import { jsx, jsxs, Fragment as Fragment$1 } from 'react/jsx-runtime';
import { useGelatoLimitOrdersLib, useGelatoLimitOrdersHistory, useGelatoLimitOrders, useGasOverhead, GELATO_PERSISTED_KEYS, gelatoReducers, GelatoProvider } from '@gelatonetwork/limit-orders-react';
export * from '@gelatonetwork/limit-orders-react';
import ReactDOM from 'react-dom';
import React$2, { createElement, PureComponent, useContext, useMemo, useRef, useDebugValue, Component, useCallback, cloneElement, useState, useEffect, forwardRef, createContext, isValidElement, Children, useImperativeHandle, memo } from 'react';
import { ChainId, CHAINS, Token as Token$2, WAVAX, Percent as Percent$1, JSBI as JSBI$1, CAVAX, currencyEquals, TokenAmount, CurrencyAmount, Pair, Trade, FACTORY_ADDRESS, Price, Router, TradeType as TradeType$1, ALL_CHAINS } from '@pangolindex/sdk';
import require$$0 from 'util';
import { SafeAppConnector } from '@gnosis.pm/safe-apps-web3-react';
import { InjectedConnector } from '@pangolindex/web3-react-injected-connector';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import { WalletLinkConnector } from '@web3-react/walletlink-connector';
import { EventEmitter as EventEmitter$1 } from 'events';
import { useSelector, useDispatch } from 'react-redux';
import { createAction, nanoid, createReducer, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import require$$1 from 'http';
import require$$2 from 'https';
import require$$0$1, { fileURLToPath } from 'url';
import require$$3 from 'stream';
import require$$4 from 'assert';
import require$$8$1 from 'zlib';
import { useWeb3React, UnsupportedChainIdError } from '@web3-react/core';
import { save, load } from 'redux-localstorage-simple';
import require$$0$2 from 'crypto';
import path$2 from 'path';
import proc from 'process';

function _setPrototypeOf$o(o, p) {
  _setPrototypeOf$o = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$o(o, p);
}

function _inheritsLoose$3(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$o(subClass, superClass);
}

var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

function _extends$M() {
  _extends$M = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$M.apply(this, arguments);
}

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop$5() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return _extends$M({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return _extends$M({}, arg2, {
    queryKey: arg1
  });
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [_extends$M({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject$4(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject$4(a) && isPlainObject$4(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (var key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject$4(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

var FocusManager = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose$3(FocusManager, _Subscribable);

  function FocusManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onFocus) {
      var _window;

      if (!isServer && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };

    return _this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  return FocusManager;
}(Subscribable);
var focusManager = new FocusManager();

var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose$3(OnlineManager, _Subscribable);

  function OnlineManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onOnline) {
      var _window;

      if (!isServer && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };

    return _this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  return OnlineManager;
}(Subscribable);
var onlineManager = new OnlineManager();

function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError$1 = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError$1;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continueRetry = function () {
    cancelRetry = false;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError$1(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      sleep(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!focusManager.isFocused() || !onlineManager.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;

    try {
      result = callback();
    } finally {
      this.transactions--;

      if (!this.transactions) {
        this.flush();
      }
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      scheduleMicrotask(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      scheduleMicrotask(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

// TYPES
// FUNCTIONS
var logger$u = console;
function getLogger() {
  return logger$u;
}
function setLogger$1(newLogger) {
  logger$u = newLogger;
}

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = _extends$M({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if (isValidTimeout(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    clearTimeout(this.gcTimeout);
    this.gcTimeout = undefined;
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = functionalUpdate(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = replaceEqualDeep(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(noop$5).catch(noop$5) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !timeUntilStale(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions,
        _abortController$abor;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = ensureQueryKeyArray(this.queryKey);
    var abortController = getAbortController(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }

        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new Retryer({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!(isCancelledError(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!isCancelledError(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          getLogger().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return _extends$M({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return _extends$M({}, state, {
          isPaused: true
        });

      case 'continue':
        return _extends$M({}, state, {
          isPaused: false
        });

      case 'fetch':
        return _extends$M({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });

      case 'success':
        return _extends$M({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if (isCancelledError(error) && error.revert && this.revertState) {
          return _extends$M({}, this.revertState);
        }

        return _extends$M({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return _extends$M({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return _extends$M({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();

// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose$3(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : hashQueryKeyByOptions(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = parseFilterArgs(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return matchQuery(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = parseFilterArgs(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return matchQuery(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    notifyManager.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(Subscribable);

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = _extends$M({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(noop$5).catch(noop$5);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      getLogger().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new Retryer({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer$1(this.state, action);
    notifyManager.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer$1(state, action) {
  switch (action.type) {
    case 'failed':
      return _extends$M({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return _extends$M({}, state, {
        isPaused: true
      });

    case 'continue':
      return _extends$M({}, state, {
        isPaused: false
      });

    case 'loading':
      return _extends$M({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return _extends$M({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return _extends$M({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return _extends$M({}, state, action.state);

    default:
      return state;
  }
}

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose$3(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new Mutation({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return matchMutation(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return matchMutation(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    notifyManager.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(noop$5);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(Subscribable);

function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = getAbortController();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if (isCancelable(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();

          if (isCancelable(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}

// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = focusManager.subscribe(function () {
      if (focusManager.isFocused() && onlineManager.isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager.subscribe(function () {
      if (focusManager.isFocused() && onlineManager.isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = parseFilterArgs(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll(_extends$M({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = parseQueryArgs(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return notifyManager.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = parseFilterArgs(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    notifyManager.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = parseFilterArgs(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = _extends$M({}, filters, {
      active: true
    });

    return notifyManager.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = parseFilterArgs(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = notifyManager.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(noop$5).catch(noop$5);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = parseFilterArgs(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = _extends$M({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return notifyManager.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = parseFilterArgs(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = notifyManager.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, _extends$M({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(noop$5);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(noop$5);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(noop$5).catch(noop$5);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
    parsedOptions.behavior = infiniteQueryBehavior();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(noop$5).catch(noop$5);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = notifyManager.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(noop$5).catch(noop$5);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return hashQueryKey(queryKey) === hashQueryKey(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return partialMatchKey(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return hashQueryKey(mutationKey) === hashQueryKey(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return partialMatchKey(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = _extends$M({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = hashQueryKeyByOptions(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return _extends$M({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

var QueryObserver = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose$3(QueryObserver, _Subscribable);

  function QueryObserver(client, options) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.client = client;
    _this.options = options;
    _this.trackedProps = [];
    _this.selectError = null;

    _this.bindMethods();

    _this.setOptions(options);

    return _this;
  }

  var _proto = QueryObserver.prototype;

  _proto.bindMethods = function bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  };

  _proto.onSubscribe = function onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  };

  _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  };

  _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  };

  _proto.destroy = function destroy() {
    this.listeners = [];
    this.clearTimers();
    this.currentQuery.removeObserver(this);
  };

  _proto.setOptions = function setOptions(options, notifyOptions) {
    var prevOptions = this.options;
    var prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryObserverOptions(options);

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    var mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  };

  _proto.getOptimisticResult = function getOptimisticResult(options) {
    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return this.createResult(query, defaultedOptions);
  };

  _proto.getCurrentResult = function getCurrentResult() {
    return this.currentResult;
  };

  _proto.trackResult = function trackResult(result, defaultedOptions) {
    var _this2 = this;

    var trackedResult = {};

    var trackProp = function trackProp(key) {
      if (!_this2.trackedProps.includes(key)) {
        _this2.trackedProps.push(key);
      }
    };

    Object.keys(result).forEach(function (key) {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          trackProp(key);
          return result[key];
        }
      });
    });

    if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) {
      trackProp('error');
    }

    return trackedResult;
  };

  _proto.getNextResult = function getNextResult(options) {
    var _this3 = this;

    return new Promise(function (resolve, reject) {
      var unsubscribe = _this3.subscribe(function (result) {
        if (!result.isFetching) {
          unsubscribe();

          if (result.isError && (options == null ? void 0 : options.throwOnError)) {
            reject(result.error);
          } else {
            resolve(result);
          }
        }
      });
    });
  };

  _proto.getCurrentQuery = function getCurrentQuery() {
    return this.currentQuery;
  };

  _proto.remove = function remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  };

  _proto.refetch = function refetch(options) {
    return this.fetch(_extends$M({}, options, {
      meta: {
        refetchPage: options == null ? void 0 : options.refetchPage
      }
    }));
  };

  _proto.fetchOptimistic = function fetchOptimistic(options) {
    var _this4 = this;

    var defaultedOptions = this.client.defaultQueryObserverOptions(options);
    var query = this.client.getQueryCache().build(this.client, defaultedOptions);
    return query.fetch().then(function () {
      return _this4.createResult(query, defaultedOptions);
    });
  };

  _proto.fetch = function fetch(fetchOptions) {
    var _this5 = this;

    return this.executeFetch(fetchOptions).then(function () {
      _this5.updateResult();

      return _this5.currentResult;
    });
  };

  _proto.executeFetch = function executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    var promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) {
      promise = promise.catch(noop$5);
    }

    return promise;
  };

  _proto.updateStaleTimeout = function updateStaleTimeout() {
    var _this6 = this;

    this.clearStaleTimeout();

    if (isServer || this.currentResult.isStale || !isValidTimeout(this.options.staleTime)) {
      return;
    }

    var time = timeUntilStale(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    var timeout = time + 1;
    this.staleTimeoutId = setTimeout(function () {
      if (!_this6.currentResult.isStale) {
        _this6.updateResult();
      }
    }, timeout);
  };

  _proto.computeRefetchInterval = function computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  };

  _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
    var _this7 = this;

    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (isServer || this.options.enabled === false || !isValidTimeout(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(function () {
      if (_this7.options.refetchIntervalInBackground || focusManager.isFocused()) {
        _this7.executeFetch();
      }
    }, this.currentRefetchInterval);
  };

  _proto.updateTimers = function updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  };

  _proto.clearTimers = function clearTimers() {
    this.clearStaleTimeout();
    this.clearRefetchInterval();
  };

  _proto.clearStaleTimeout = function clearStaleTimeout() {
    clearTimeout(this.staleTimeoutId);
    this.staleTimeoutId = undefined;
  };

  _proto.clearRefetchInterval = function clearRefetchInterval() {
    clearInterval(this.refetchIntervalId);
    this.refetchIntervalId = undefined;
  };

  _proto.createResult = function createResult(query, options) {
    var prevQuery = this.currentQuery;
    var prevOptions = this.options;
    var prevResult = this.currentResult;
    var prevResultState = this.currentResultState;
    var prevResultOptions = this.currentResultOptions;
    var queryChange = query !== prevQuery;
    var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    var state = query.state;
    var dataUpdatedAt = state.dataUpdatedAt,
        error = state.error,
        errorUpdatedAt = state.errorUpdatedAt,
        isFetching = state.isFetching,
        status = state.status;
    var isPreviousData = false;
    var isPlaceholderData = false;
    var data; // Optimistically set result in fetching state if needed

    if (options.optimisticResults) {
      var mounted = this.hasListeners();
      var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        isFetching = true;

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
        // Memoize select result
        if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
          data = this.selectResult;
        } else {
          try {
            this.selectFn = options.select;
            data = options.select(state.data);

            if (options.structuralSharing !== false) {
              data = replaceEqualDeep(prevResult == null ? void 0 : prevResult.data, data);
            }

            this.selectResult = data;
            this.selectError = null;
          } catch (selectError) {
            getLogger().error(selectError);
            this.selectError = selectError;
          }
        }
      } // Use query data
      else {
          data = state.data;
        } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
      var placeholderData; // Memoize placeholder data

      if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);

            if (options.structuralSharing !== false) {
              placeholderData = replaceEqualDeep(prevResult == null ? void 0 : prevResult.data, placeholderData);
            }

            this.selectError = null;
          } catch (selectError) {
            getLogger().error(selectError);
            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = placeholderData;
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    var result = {
      status: status,
      isLoading: status === 'loading',
      isSuccess: status === 'success',
      isError: status === 'error',
      isIdle: status === 'idle',
      data: data,
      dataUpdatedAt: dataUpdatedAt,
      error: error,
      errorUpdatedAt: errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching: isFetching,
      isRefetching: isFetching && status !== 'loading',
      isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
      isPlaceholderData: isPlaceholderData,
      isPreviousData: isPreviousData,
      isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  };

  _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
    if (!prevResult) {
      return true;
    }

    var _this$options = this.options,
        notifyOnChangeProps = _this$options.notifyOnChangeProps,
        notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;

    if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) {
      return true;
    }

    if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) {
      return true;
    }

    var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
    return Object.keys(result).some(function (key) {
      var typedKey = key;
      var changed = result[typedKey] !== prevResult[typedKey];
      var isIncluded = includedProps == null ? void 0 : includedProps.some(function (x) {
        return x === key;
      });
      var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function (x) {
        return x === key;
      });
      return changed && !isExcluded && (!includedProps || isIncluded);
    });
  };

  _proto.updateResult = function updateResult(notifyOptions) {
    var prevResult = this.currentResult;
    this.currentResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify if something has changed

    if (shallowEqualObjects(this.currentResult, prevResult)) {
      return;
    } // Determine which callbacks to trigger


    var defaultNotifyOptions = {
      cache: true
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify(_extends$M({}, defaultNotifyOptions, notifyOptions));
  };

  _proto.updateQuery = function updateQuery() {
    var query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    var prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  };

  _proto.onQueryUpdate = function onQueryUpdate(action) {
    var notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error' && !isCancelledError(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  };

  _proto.notify = function notify(notifyOptions) {
    var _this8 = this;

    notifyManager.batch(function () {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        _this8.options.onSuccess == null ? void 0 : _this8.options.onSuccess(_this8.currentResult.data);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(_this8.currentResult.data, null);
      } else if (notifyOptions.onError) {
        _this8.options.onError == null ? void 0 : _this8.options.onError(_this8.currentResult.error);
        _this8.options.onSettled == null ? void 0 : _this8.options.onSettled(undefined, _this8.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        _this8.listeners.forEach(function (listener) {
          listener(_this8.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        _this8.client.getQueryCache().notify({
          query: _this8.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  };

  return QueryObserver;
}(Subscribable);

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    var value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}

var unstable_batchedUpdates = ReactDOM.unstable_batchedUpdates;

notifyManager.setBatchNotifyFunction(unstable_batchedUpdates);

var logger$t = console;

setLogger$1(logger$t);

var defaultContext = /*#__PURE__*/React$2.createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/React$2.createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(contextSharing) {
  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

var useQueryClient = function useQueryClient() {
  var queryClient = React$2.useContext(getQueryClientContext(React$2.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      _ref$contextSharing = _ref.contextSharing,
      contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing,
      children = _ref.children;
  React$2.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext(contextSharing);
  return /*#__PURE__*/React$2.createElement(QueryClientSharingContext.Provider, {
    value: contextSharing
  }, /*#__PURE__*/React$2.createElement(Context.Provider, {
    value: client
  }, children));
};

function createValue() {
  var _isReset = false;
  return {
    clearReset: function clearReset() {
      _isReset = false;
    },
    reset: function reset() {
      _isReset = true;
    },
    isReset: function isReset() {
      return _isReset;
    }
  };
}

var QueryErrorResetBoundaryContext = /*#__PURE__*/React$2.createContext(createValue()); // HOOK

var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
  return React$2.useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT

function shouldThrowError(suspense, _useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, params);
  } // Allow useErrorBoundary to override suspense's throwing behavior


  if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors

  return !!suspense;
}

function useBaseQuery(options, Observer) {
  var mountedRef = React$2.useRef(false);

  var _React$useState = React$2.useState(0),
      forceUpdate = _React$useState[1];

  var queryClient = useQueryClient();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions.optimisticResults = true; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager.batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    } // Set cache time to 1 if the option has been set to 0
    // when using suspense to prevent infinite loop of fetches


    if (defaultedOptions.cacheTime === 0) {
      defaultedOptions.cacheTime = 1;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React$useState2 = React$2.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  React$2.useEffect(function () {
    mountedRef.current = true;
    errorResetBoundary.clearReset();
    var unsubscribe = observer.subscribe(notifyManager.batchCalls(function () {
      if (mountedRef.current) {
        forceUpdate(function (x) {
          return x + 1;
        });
      }
    })); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return function () {
      mountedRef.current = false;
      unsubscribe();
    };
  }, [errorResetBoundary, observer]);
  React$2.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var data = _ref.data;
      defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
    }).catch(function (error) {
      errorResetBoundary.clearReset();
      defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
      defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
    });
  } // Handle error boundary


  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  } // Handle result property usage tracking


  if (defaultedOptions.notifyOnChangeProps === 'tracked') {
    result = observer.trackResult(result, defaultedOptions);
  }

  return result;
}

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends$L = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits$2 = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/

// Check `document` and `window` in case of server-side rendering
var windowObject = void 0;
if (typeof window !== 'undefined') {
  windowObject = window;

  // eslint-disable-next-line no-restricted-globals
} else if (typeof self !== 'undefined') {
  // eslint-disable-next-line no-restricted-globals
  windowObject = self;
} else {
  windowObject = global;
}

var cancelFrame = null;
var requestFrame = null;

var TIMEOUT_DURATION = 20;

var clearTimeoutFn = windowObject.clearTimeout;
var setTimeoutFn = windowObject.setTimeout;

var cancelAnimationFrameFn = windowObject.cancelAnimationFrame || windowObject.mozCancelAnimationFrame || windowObject.webkitCancelAnimationFrame;

var requestAnimationFrameFn = windowObject.requestAnimationFrame || windowObject.mozRequestAnimationFrame || windowObject.webkitRequestAnimationFrame;

if (cancelAnimationFrameFn == null || requestAnimationFrameFn == null) {
  // For environments that don't support animation frame,
  // fallback to a setTimeout based approach.
  cancelFrame = clearTimeoutFn;
  requestFrame = function requestAnimationFrameViaSetTimeout(callback) {
    return setTimeoutFn(callback, TIMEOUT_DURATION);
  };
} else {
  // Counter intuitively, environments that support animation frames can be trickier.
  // Chrome's "Throttle non-visible cross-origin iframes" flag can prevent rAFs from being called.
  // In this case, we should fallback to a setTimeout() implementation.
  cancelFrame = function cancelFrame(_ref) {
    var _ref2 = slicedToArray(_ref, 2),
        animationFrameID = _ref2[0],
        timeoutID = _ref2[1];

    cancelAnimationFrameFn(animationFrameID);
    clearTimeoutFn(timeoutID);
  };
  requestFrame = function requestAnimationFrameWithSetTimeoutFallback(callback) {
    var animationFrameID = requestAnimationFrameFn(function animationFrameCallback() {
      clearTimeoutFn(timeoutID);
      callback();
    });

    var timeoutID = setTimeoutFn(function timeoutCallback() {
      cancelAnimationFrameFn(animationFrameID);
      callback();
    }, TIMEOUT_DURATION);

    return [animationFrameID, timeoutID];
  };
}

function createDetectElementResize(nonce) {
  var animationKeyframes = void 0;
  var animationName = void 0;
  var animationStartEvent = void 0;
  var animationStyle = void 0;
  var checkTriggers = void 0;
  var resetTriggers = void 0;
  var scrollListener = void 0;

  var attachEvent = typeof document !== 'undefined' && document.attachEvent;
  if (!attachEvent) {
    resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    checkTriggers = function checkTriggers(element) {
      return element.offsetWidth !== element.__resizeLast__.width || element.offsetHeight !== element.__resizeLast__.height;
    };

    scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className && typeof e.target.className.indexOf === 'function' && e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function animationFrame() {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function forEachResizeListener(fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false;
    var keyframeprefix = '';
    animationStartEvent = 'animationstart';
    var domPrefixes = 'Webkit Moz O ms'.split(' ');
    var startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' ');
    var pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationStartEvent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    animationName = 'resizeanim';
    animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = windowObject.getComputedStyle(element);
        if (elementStyle && elementStyle.position === 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        var expandTrigger = doc.createElement('div');
        expandTrigger.className = 'expand-trigger';
        expandTrigger.appendChild(doc.createElement('div'));
        var contractTrigger = doc.createElement('div');
        contractTrigger.className = 'contract-trigger';
        element.__resizeTriggers__.appendChild(expandTrigger);
        element.__resizeTriggers__.appendChild(contractTrigger);
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationStartEvent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName === animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}

var AutoSizer = function (_React$PureComponent) {
  inherits$2(AutoSizer, _React$PureComponent);

  function AutoSizer() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, AutoSizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    }, _this._onResize = function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;


      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.

        var _height = _this._parentNode.offsetHeight || 0;
        var _width = _this._parentNode.offsetWidth || 0;

        var _style = window.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;

        var newHeight = _height - paddingTop - paddingBottom;
        var newWidth = _width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: _height - paddingTop - paddingBottom,
            width: _width - paddingLeft - paddingRight
          });

          onResize({ height: _height, width: _width });
        }
      }
    }, _this._setRef = function (autoSizer) {
      _this._autoSizer = autoSizer;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;

        // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41
        this._detectElementResize = createDetectElementResize(nonce);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };
      var childParams = {};

      // Avoid rendering children before the initial measurements have been collected.
      // At best this would just be wasting cycles.
      var bailoutOnChildren = false;

      if (!disableHeight) {
        if (height === 0) {
          bailoutOnChildren = true;
        }
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        if (width === 0) {
          bailoutOnChildren = true;
        }
        outerStyle.width = 0;
        childParams.width = width;
      }

      return createElement(
        'div',
        {
          className: className,
          ref: this._setRef,
          style: _extends$L({}, outerStyle, style)
        },
        !bailoutOnChildren && children(childParams)
      );
    }
  }]);
  return AutoSizer;
}(PureComponent);

AutoSizer.defaultProps = {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
};

function _assertThisInitialized$o(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual$2(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual$2(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var now$5 = hasNativePerformanceNow ? function () {
  return performance.now();
} : function () {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now$5();

  function tick() {
    if (now$5() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }

  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}
var cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.

function getRTLOffsetType(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement('div');
    var outerStyle = outerDiv.style;
    outerStyle.width = '50px';
    outerStyle.height = '50px';
    outerStyle.overflow = 'scroll';
    outerStyle.direction = 'rtl';
    var innerDiv = document.createElement('div');
    var innerStyle = innerDiv.style;
    innerStyle.width = '100px';
    innerStyle.height = '100px';
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);

    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = 'positive-descending';
    } else {
      outerDiv.scrollLeft = 1;

      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = 'negative';
      } else {
        cachedRTLResult = 'positive-ascending';
      }
    }

    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }

  return cachedRTLResult;
}

if (process.env.NODE_ENV !== 'production') ;

var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;

var defaultItemKey$1 = function defaultItemKey(index, data) {
  return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsDirection = null;
var devWarningsTagName$1 = null;

if (process.env.NODE_ENV !== 'production') {
  if (typeof window !== 'undefined' && typeof window.WeakSet !== 'undefined') {
    devWarningsDirection = /*#__PURE__*/new WeakSet();
    devWarningsTagName$1 = /*#__PURE__*/new WeakSet();
  }
}

function createListComponent(_ref) {
  var _class;

  var getItemOffset = _ref.getItemOffset,
      getEstimatedTotalSize = _ref.getEstimatedTotalSize,
      getItemSize = _ref.getItemSize,
      getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment,
      getStartIndexForOffset = _ref.getStartIndexForOffset,
      getStopIndexForStartIndex = _ref.getStopIndexForStartIndex,
      initInstanceProps = _ref.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref.validateProps;
  return _class = /*#__PURE__*/function (_PureComponent) {
    _inheritsLoose$3(List, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function List(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, _assertThisInitialized$o(_this));
      _this._outerRef = void 0;
      _this._resetIsScrollingTimeoutId = null;
      _this.state = {
        instance: _assertThisInitialized$o(_this),
        isScrolling: false,
        scrollDirection: 'forward',
        scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: false
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoizeOne(function (overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        return _this.props.onItemsRendered({
          overscanStartIndex: overscanStartIndex,
          overscanStopIndex: overscanStopIndex,
          visibleStartIndex: visibleStartIndex,
          visibleStopIndex: visibleStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoizeOne(function (scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          scrollDirection: scrollDirection,
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (index) {
        var _this$props = _this.props,
            direction = _this$props.direction,
            itemSize = _this$props.itemSize,
            layout = _this$props.layout;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);

        var style;

        if (itemStyleCache.hasOwnProperty(index)) {
          style = itemStyleCache[index];
        } else {
          var _offset = getItemOffset(_this.props, index, _this._instanceProps);

          var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"

          var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
          var isRtl = direction === 'rtl';
          var offsetHorizontal = isHorizontal ? _offset : 0;
          itemStyleCache[index] = style = {
            position: 'absolute',
            left: isRtl ? undefined : offsetHorizontal,
            right: isRtl ? offsetHorizontal : undefined,
            top: !isHorizontal ? _offset : 0,
            height: !isHorizontal ? size : '100%',
            width: isHorizontal ? size : '100%'
          };
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoizeOne(function (_, __, ___) {
        return {};
      });

      _this._onScrollHorizontal = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollLeft) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction;
          var scrollOffset = scrollLeft;

          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
            // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
            switch (getRTLOffsetType()) {
              case 'negative':
                scrollOffset = -scrollLeft;
                break;

              case 'positive-descending':
                scrollOffset = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollLeft ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._onScrollVertical = function (event) {
        var _event$currentTarget2 = event.currentTarget,
            clientHeight = _event$currentTarget2.clientHeight,
            scrollHeight = _event$currentTarget2.scrollHeight,
            scrollTop = _event$currentTarget2.scrollTop;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1, null);
        });
      };

      return _this;
    }

    List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps$1(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = List.prototype;

    _proto.scrollTo = function scrollTo(scrollOffset) {
      scrollOffset = Math.max(0, scrollOffset);
      this.setState(function (prevState) {
        if (prevState.scrollOffset === scrollOffset) {
          return null;
        }

        return {
          scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: true
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(index, align) {
      if (align === void 0) {
        align = 'auto';
      }

      var itemCount = this.props.itemCount;
      var scrollOffset = this.state.scrollOffset;
      index = Math.max(0, Math.min(index, itemCount - 1));
      this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps));
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props2 = this.props,
          direction = _this$props2.direction,
          initialScrollOffset = _this$props2.initialScrollOffset,
          layout = _this$props2.layout;

      if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          outerRef.scrollLeft = initialScrollOffset;
        } else {
          outerRef.scrollTop = initialScrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this$props3 = this.props,
          direction = _this$props3.direction,
          layout = _this$props3.layout;
      var _this$state = this.state,
          scrollOffset = _this$state.scrollOffset,
          scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // So we need to determine which browser behavior we're dealing with, and mimic it.
            switch (getRTLOffsetType()) {
              case 'negative':
                outerRef.scrollLeft = -scrollOffset;
                break;

              case 'positive-ascending':
                outerRef.scrollLeft = scrollOffset;
                break;

              default:
                var clientWidth = outerRef.clientWidth,
                    scrollWidth = outerRef.scrollWidth;
                outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                break;
            }
          } else {
            outerRef.scrollLeft = scrollOffset;
          }
        } else {
          outerRef.scrollTop = scrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          direction = _this$props4.direction,
          height = _this$props4.height,
          innerRef = _this$props4.innerRef,
          innerElementType = _this$props4.innerElementType,
          innerTagName = _this$props4.innerTagName,
          itemCount = _this$props4.itemCount,
          itemData = _this$props4.itemData,
          _this$props4$itemKey = _this$props4.itemKey,
          itemKey = _this$props4$itemKey === void 0 ? defaultItemKey$1 : _this$props4$itemKey,
          layout = _this$props4.layout,
          outerElementType = _this$props4.outerElementType,
          outerTagName = _this$props4.outerTagName,
          style = _this$props4.style,
          useIsScrolling = _this$props4.useIsScrolling,
          width = _this$props4.width;
      var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"

      var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
      var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;

      var _this$_getRangeToRend = this._getRangeToRender(),
          startIndex = _this$_getRangeToRend[0],
          stopIndex = _this$_getRangeToRend[1];

      var items = [];

      if (itemCount > 0) {
        for (var _index = startIndex; _index <= stopIndex; _index++) {
          items.push(createElement(children, {
            data: itemData,
            key: itemKey(_index, itemData),
            index: _index,
            isScrolling: useIsScrolling ? isScrolling : undefined,
            style: this._getItemStyle(_index)
          }));
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
      return createElement(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: onScroll,
        ref: this._outerRefSetter,
        style: _extends$M({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, createElement(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: isHorizontal ? '100%' : estimatedTotalSize,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: isHorizontal ? estimatedTotalSize : '100%'
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      if (typeof this.props.onItemsRendered === 'function') {
        var itemCount = this.props.itemCount;

        if (itemCount > 0) {
          var _this$_getRangeToRend2 = this._getRangeToRender(),
              _overscanStartIndex = _this$_getRangeToRend2[0],
              _overscanStopIndex = _this$_getRangeToRend2[1],
              _visibleStartIndex = _this$_getRangeToRend2[2],
              _visibleStopIndex = _this$_getRangeToRend2[3];

          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
        }
      }

      if (typeof this.props.onScroll === 'function') {
        var _this$state2 = this.state,
            _scrollDirection = _this$state2.scrollDirection,
            _scrollOffset = _this$state2.scrollOffset,
            _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
      }
    } // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.
    ;

    _proto._getRangeToRender = function _getRangeToRender() {
      var _this$props5 = this.props,
          itemCount = _this$props5.itemCount,
          overscanCount = _this$props5.overscanCount;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollDirection = _this$state3.scrollDirection,
          scrollOffset = _this$state3.scrollOffset;

      if (itemCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
      var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
      var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return List;
  }(PureComponent), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    layout: 'vertical',
    overscanCount: 2,
    useIsScrolling: false
  }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.

var validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
  var children = _ref2.children,
      direction = _ref2.direction,
      height = _ref2.height,
      layout = _ref2.layout,
      innerTagName = _ref2.innerTagName,
      outerTagName = _ref2.outerTagName,
      width = _ref2.width;
  var instance = _ref3.instance;

  if (process.env.NODE_ENV !== 'production') {
    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName$1 && !devWarningsTagName$1.has(instance)) {
        devWarningsTagName$1.add(instance);
        console.warn('The innerTagName and outerTagName props have been deprecated. ' + 'Please use the innerElementType and outerElementType props instead.');
      }
    } // TODO Deprecate direction "horizontal"


    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';

    switch (direction) {
      case 'horizontal':
      case 'vertical':
        if (devWarningsDirection && !devWarningsDirection.has(instance)) {
          devWarningsDirection.add(instance);
          console.warn('The direction prop should be either "ltr" (default) or "rtl". ' + 'Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.');
        }

        break;

      case 'ltr':
      case 'rtl':
        // Valid values
        break;

      default:
        throw Error('An invalid "direction" prop has been specified. ' + 'Value should be either "ltr" or "rtl". ' + ("\"" + direction + "\" was specified."));
    }

    switch (layout) {
      case 'horizontal':
      case 'vertical':
        // Valid values
        break;

      default:
        throw Error('An invalid "layout" prop has been specified. ' + 'Value should be either "horizontal" or "vertical". ' + ("\"" + layout + "\" was specified."));
    }

    if (children == null) {
      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a React component. ' + ("\"" + (children === null ? 'null' : typeof children) + "\" was specified."));
    }

    if (isHorizontal && typeof width !== 'number') {
      throw Error('An invalid "width" prop has been specified. ' + 'Horizontal lists must specify a number for width. ' + ("\"" + (width === null ? 'null' : typeof width) + "\" was specified."));
    } else if (!isHorizontal && typeof height !== 'number') {
      throw Error('An invalid "height" prop has been specified. ' + 'Vertical lists must specify a number for height. ' + ("\"" + (height === null ? 'null' : typeof height) + "\" was specified."));
    }
  }
};

var FixedSizeList = /*#__PURE__*/createListComponent({
  getItemOffset: function getItemOffset(_ref, index) {
    var itemSize = _ref.itemSize;
    return index * itemSize;
  },
  getItemSize: function getItemSize(_ref2, index) {
    var itemSize = _ref2.itemSize;
    return itemSize;
  },
  getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
    var itemCount = _ref3.itemCount,
        itemSize = _ref3.itemSize;
    return itemSize * itemCount;
  },
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset) {
    var direction = _ref4.direction,
        height = _ref4.height,
        itemCount = _ref4.itemCount,
        itemSize = _ref4.itemSize,
        layout = _ref4.layout,
        width = _ref4.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var lastItemOffset = Math.max(0, itemCount * itemSize - size);
    var maxOffset = Math.min(lastItemOffset, index * itemSize);
    var minOffset = Math.max(0, index * itemSize - size + itemSize);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        {
          // "Centered" offset is usually the average of the min and max.
          // But near the edges of the list, this doesn't hold true.
          var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

          if (middleOffset < Math.ceil(size / 2)) {
            return 0; // near the beginning
          } else if (middleOffset > lastItemOffset + Math.floor(size / 2)) {
            return lastItemOffset; // near the end
          } else {
            return middleOffset;
          }
        }

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
    var itemCount = _ref5.itemCount,
        itemSize = _ref5.itemSize;
    return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
    var direction = _ref6.direction,
        height = _ref6.height,
        itemCount = _ref6.itemCount,
        itemSize = _ref6.itemSize,
        layout = _ref6.layout,
        width = _ref6.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var offset = startIndex * itemSize;
    var size = isHorizontal ? width : height;
    var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
    return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref7) {
    var itemSize = _ref7.itemSize;

    if (process.env.NODE_ENV !== 'production') {
      if (typeof itemSize !== 'number') {
        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (itemSize === null ? 'null' : typeof itemSize) + "\" was specified."));
      }
    }
  }
});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire$1 (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var reactIs$7 = {exports: {}};

var reactIs_production_min$6 = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$7=60103,c$7=60106,d$6=60107,e$7=60108,f$7=60114,g$a=60109,h$7=60110,k$8=60112,l$6=60113,m$6=60120,n$7=60115,p$6=60116,q$7=60121,r$6=60122,u$2=60117,v$7=60129,w$6=60131;
if("function"===typeof Symbol&&Symbol.for){var x$8=Symbol.for;b$7=x$8("react.element");c$7=x$8("react.portal");d$6=x$8("react.fragment");e$7=x$8("react.strict_mode");f$7=x$8("react.profiler");g$a=x$8("react.provider");h$7=x$8("react.context");k$8=x$8("react.forward_ref");l$6=x$8("react.suspense");m$6=x$8("react.suspense_list");n$7=x$8("react.memo");p$6=x$8("react.lazy");q$7=x$8("react.block");r$6=x$8("react.server.block");u$2=x$8("react.fundamental");v$7=x$8("react.debug_trace_mode");w$6=x$8("react.legacy_hidden");}
function y$7(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b$7:switch(a=a.type,a){case d$6:case f$7:case e$7:case l$6:case m$6:return a;default:switch(a=a&&a.$$typeof,a){case h$7:case k$8:case p$6:case n$7:case g$a:return a;default:return t}}case c$7:return t}}}var z$7=g$a,A$5=b$7,B$1=k$8,C$1=d$6,D$1=p$6,E$1=n$7,F$1=c$7,G$1=f$7,H$1=e$7,I$1=l$6;reactIs_production_min$6.ContextConsumer=h$7;reactIs_production_min$6.ContextProvider=z$7;reactIs_production_min$6.Element=A$5;reactIs_production_min$6.ForwardRef=B$1;reactIs_production_min$6.Fragment=C$1;reactIs_production_min$6.Lazy=D$1;reactIs_production_min$6.Memo=E$1;reactIs_production_min$6.Portal=F$1;reactIs_production_min$6.Profiler=G$1;reactIs_production_min$6.StrictMode=H$1;
reactIs_production_min$6.Suspense=I$1;reactIs_production_min$6.isAsyncMode=function(){return !1};reactIs_production_min$6.isConcurrentMode=function(){return !1};reactIs_production_min$6.isContextConsumer=function(a){return y$7(a)===h$7};reactIs_production_min$6.isContextProvider=function(a){return y$7(a)===g$a};reactIs_production_min$6.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b$7};reactIs_production_min$6.isForwardRef=function(a){return y$7(a)===k$8};reactIs_production_min$6.isFragment=function(a){return y$7(a)===d$6};reactIs_production_min$6.isLazy=function(a){return y$7(a)===p$6};reactIs_production_min$6.isMemo=function(a){return y$7(a)===n$7};
reactIs_production_min$6.isPortal=function(a){return y$7(a)===c$7};reactIs_production_min$6.isProfiler=function(a){return y$7(a)===f$7};reactIs_production_min$6.isStrictMode=function(a){return y$7(a)===e$7};reactIs_production_min$6.isSuspense=function(a){return y$7(a)===l$6};reactIs_production_min$6.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d$6||a===f$7||a===v$7||a===e$7||a===l$6||a===m$6||a===w$6||"object"===typeof a&&null!==a&&(a.$$typeof===p$6||a.$$typeof===n$7||a.$$typeof===g$a||a.$$typeof===h$7||a.$$typeof===k$8||a.$$typeof===u$2||a.$$typeof===q$7||a[0]===r$6)?!0:!1};
reactIs_production_min$6.typeOf=y$7;

var reactIs_development$6 = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  symbolFor('react.scope');
  symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$6.ContextConsumer = ContextConsumer;
reactIs_development$6.ContextProvider = ContextProvider;
reactIs_development$6.Element = Element;
reactIs_development$6.ForwardRef = ForwardRef;
reactIs_development$6.Fragment = Fragment;
reactIs_development$6.Lazy = Lazy;
reactIs_development$6.Memo = Memo;
reactIs_development$6.Portal = Portal;
reactIs_development$6.Profiler = Profiler;
reactIs_development$6.StrictMode = StrictMode;
reactIs_development$6.Suspense = Suspense;
reactIs_development$6.isAsyncMode = isAsyncMode;
reactIs_development$6.isConcurrentMode = isConcurrentMode;
reactIs_development$6.isContextConsumer = isContextConsumer;
reactIs_development$6.isContextProvider = isContextProvider;
reactIs_development$6.isElement = isElement;
reactIs_development$6.isForwardRef = isForwardRef;
reactIs_development$6.isFragment = isFragment;
reactIs_development$6.isLazy = isLazy;
reactIs_development$6.isMemo = isMemo;
reactIs_development$6.isPortal = isPortal;
reactIs_development$6.isProfiler = isProfiler;
reactIs_development$6.isStrictMode = isStrictMode;
reactIs_development$6.isSuspense = isSuspense;
reactIs_development$6.isValidElementType = isValidElementType;
reactIs_development$6.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$7.exports = reactIs_production_min$6;
} else {
  reactIs$7.exports = reactIs_development$6;
}

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize$3(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index$2 = memoize$3(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var reactIs$6 = {exports: {}};

var reactIs_production_min$5 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$6="function"===typeof Symbol&&Symbol.for,c$6=b$6?Symbol.for("react.element"):60103,d$5=b$6?Symbol.for("react.portal"):60106,e$6=b$6?Symbol.for("react.fragment"):60107,f$6=b$6?Symbol.for("react.strict_mode"):60108,g$9=b$6?Symbol.for("react.profiler"):60114,h$6=b$6?Symbol.for("react.provider"):60109,k$7=b$6?Symbol.for("react.context"):60110,l$5=b$6?Symbol.for("react.async_mode"):60111,m$5=b$6?Symbol.for("react.concurrent_mode"):60111,n$6=b$6?Symbol.for("react.forward_ref"):60112,p$5=b$6?Symbol.for("react.suspense"):60113,q$6=b$6?
Symbol.for("react.suspense_list"):60120,r$5=b$6?Symbol.for("react.memo"):60115,t$6=b$6?Symbol.for("react.lazy"):60116,v$6=b$6?Symbol.for("react.block"):60121,w$5=b$6?Symbol.for("react.fundamental"):60117,x$7=b$6?Symbol.for("react.responder"):60118,y$6=b$6?Symbol.for("react.scope"):60119;
function z$6(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$6:switch(a=a.type,a){case l$5:case m$5:case e$6:case g$9:case f$6:case p$5:return a;default:switch(a=a&&a.$$typeof,a){case k$7:case n$6:case t$6:case r$5:case h$6:return a;default:return u}}case d$5:return u}}}function A$4(a){return z$6(a)===m$5}reactIs_production_min$5.AsyncMode=l$5;reactIs_production_min$5.ConcurrentMode=m$5;reactIs_production_min$5.ContextConsumer=k$7;reactIs_production_min$5.ContextProvider=h$6;reactIs_production_min$5.Element=c$6;reactIs_production_min$5.ForwardRef=n$6;reactIs_production_min$5.Fragment=e$6;reactIs_production_min$5.Lazy=t$6;reactIs_production_min$5.Memo=r$5;reactIs_production_min$5.Portal=d$5;
reactIs_production_min$5.Profiler=g$9;reactIs_production_min$5.StrictMode=f$6;reactIs_production_min$5.Suspense=p$5;reactIs_production_min$5.isAsyncMode=function(a){return A$4(a)||z$6(a)===l$5};reactIs_production_min$5.isConcurrentMode=A$4;reactIs_production_min$5.isContextConsumer=function(a){return z$6(a)===k$7};reactIs_production_min$5.isContextProvider=function(a){return z$6(a)===h$6};reactIs_production_min$5.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$6};reactIs_production_min$5.isForwardRef=function(a){return z$6(a)===n$6};reactIs_production_min$5.isFragment=function(a){return z$6(a)===e$6};reactIs_production_min$5.isLazy=function(a){return z$6(a)===t$6};
reactIs_production_min$5.isMemo=function(a){return z$6(a)===r$5};reactIs_production_min$5.isPortal=function(a){return z$6(a)===d$5};reactIs_production_min$5.isProfiler=function(a){return z$6(a)===g$9};reactIs_production_min$5.isStrictMode=function(a){return z$6(a)===f$6};reactIs_production_min$5.isSuspense=function(a){return z$6(a)===p$5};
reactIs_production_min$5.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$6||a===m$5||a===g$9||a===f$6||a===p$5||a===q$6||"object"===typeof a&&null!==a&&(a.$$typeof===t$6||a.$$typeof===r$5||a.$$typeof===h$6||a.$$typeof===k$7||a.$$typeof===n$6||a.$$typeof===w$5||a.$$typeof===x$7||a.$$typeof===y$6||a.$$typeof===v$6)};reactIs_production_min$5.typeOf=z$6;

var reactIs_development$5 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$5.AsyncMode = AsyncMode;
reactIs_development$5.ConcurrentMode = ConcurrentMode;
reactIs_development$5.ContextConsumer = ContextConsumer;
reactIs_development$5.ContextProvider = ContextProvider;
reactIs_development$5.Element = Element;
reactIs_development$5.ForwardRef = ForwardRef;
reactIs_development$5.Fragment = Fragment;
reactIs_development$5.Lazy = Lazy;
reactIs_development$5.Memo = Memo;
reactIs_development$5.Portal = Portal;
reactIs_development$5.Profiler = Profiler;
reactIs_development$5.StrictMode = StrictMode;
reactIs_development$5.Suspense = Suspense;
reactIs_development$5.isAsyncMode = isAsyncMode;
reactIs_development$5.isConcurrentMode = isConcurrentMode;
reactIs_development$5.isContextConsumer = isContextConsumer;
reactIs_development$5.isContextProvider = isContextProvider;
reactIs_development$5.isElement = isElement;
reactIs_development$5.isForwardRef = isForwardRef;
reactIs_development$5.isFragment = isFragment;
reactIs_development$5.isLazy = isLazy;
reactIs_development$5.isMemo = isMemo;
reactIs_development$5.isPortal = isPortal;
reactIs_development$5.isProfiler = isProfiler;
reactIs_development$5.isStrictMode = isStrictMode;
reactIs_development$5.isSuspense = isSuspense;
reactIs_development$5.isValidElementType = isValidElementType;
reactIs_development$5.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$6.exports = reactIs_production_min$5;
} else {
  reactIs$6.exports = reactIs_development$5;
}

var reactIs$5 = reactIs$6.exports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$5.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$5.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs$5.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$6 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var getPrototypeOf$2 = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf$2(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols$1) {
      keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor$1(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$6(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function y$5(){return (y$5=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);}return e}).apply(this,arguments)}var v$5=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g$8=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!reactIs$7.exports.typeOf(t)},S=Object.freeze([]),w$4=Object.freeze({});function E(e){return "function"==typeof e}function b$5(e){return "production"!==process.env.NODE_ENV&&"string"==typeof e&&e||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!==process.env.NODE_ENV),O="production"!==process.env.NODE_ENV?{1:"Cannot create styled-component for component: %s.\n\n",2:"Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",3:"Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",4:"The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",5:"The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",6:"Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",7:'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',8:'ThemeProvider: Please make your "theme" prop an object.\n\n',9:"Missing document `<head>`\n\n",10:"Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",11:"_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",12:"It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",13:"%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",14:'ThemeProvider: "theme" prop is required.\n\n',15:"A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",16:"Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",17:"CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"}:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t);})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw "production"===process.env.NODE_ENV?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):new Error(R.apply(void 0,[O[e]].concat(n)).trim())}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e;}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0;}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++);},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n);}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x$6=new Map,k$6=1,V=function(e){if(T.has(e))return T.get(e);for(;x$6.has(k$6);)k$6++;var t=k$6++;return "production"!==process.env.NODE_ENV&&((0|t)<0||t>1<<30)&&D(16,""+t),T.set(e,t),x$6.set(t,e),t},z$5=function(e){return x$6.get(e)},B=function(e,t){t>=k$6&&(k$6=t+1),T.set(e,t),x$6.set(t,e);},M="style["+N+'][data-styled-version="5.3.3"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r);},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(B(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0;}else r.push(i);}}},Y=function(){return "undefined"!=typeof window&&void 0!==window.__webpack_nonce__?window.__webpack_nonce__:null},q$5=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.3");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q$5(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17);}(t),this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return !1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--;},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q$5(e);this.nodes=t.childNodes,this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return !1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--;},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--;},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X$2=function(){function e(e,t,n){void 0===e&&(e=w$4),void 0===t&&(t={}),this.options=y$5({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o));}}(this));}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y$5({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o;},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else {var n=new Set;n.add(t),this.names.set(e,n);}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n);},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear();},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e);},t.clearTag=function(){this.tag=void 0;},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z$5(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",");})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n';}}}return r}(this)},e}(),Z=/(a)(d)/gi,K$1=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K$1(t%52)+n;return (K$1(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return !1}return !0}var re$1=te("5.3.3"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic="production"===process.env.NODE_ENV&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re$1,t),this.baseStyle=n,X$2.registerId(t);}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else {var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a);}o.push(i),this.staticRulesId=i;}else {for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h,"production"!==process.env.NODE_ENV&&(u=ee(u,h+d));else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f;}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y);}o.push(m);}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w$4:e,i=s.options,a=void 0===i?w$4:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_min(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}");}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t);}}}((function(e){d.push(e);})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f));},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=React$2.createContext();ce.Consumer;var le=React$2.createContext(),de=(le.Consumer,new X$2),he=ae();function pe(){return useContext(ce)||de}function fe(){return useContext(le)||he}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"));},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t;}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return "-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return "";if(_(e))return "."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return "production"!==process.env.NODE_ENV&&reactIs$7.exports.isElement(u)&&console.warn(b$5(e)+" is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."),_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g$8(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g$8(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitlessKeys?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g$8(e)?Ne(_e(v$5(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v$5(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if("production"!==process.env.NODE_ENV){var n="The component "+e+(t?' with the id of "'+t+'"':"")+" has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",r=console.error;try{var o=!0;console.error=function(e){if(Ce.test(e))o=!1,Ie.delete(n);else {for(var t=arguments.length,s=new Array(t>1?t-1:0),i=1;i<t;i++)s[i-1]=arguments[i];r.apply(void 0,[e].concat(s));}},useRef(),o&&!Ie.has(n)&&(console.warn(n),Ie.add(n));}catch(e){Ce.test(e.message)&&Ie.delete(n);}finally{console.error=r;}}},Oe=function(e,t,n){return void 0===n&&(n=w$4),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return "string"==typeof e&&("production"===process.env.NODE_ENV||e.charAt(0)===e.charAt(0).toLowerCase())}var ke=function(e){return "function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return "__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze(e,t,n){var r=e[n];ke(t)&&ke(r)?Be(r,t):e[n]=t;}function Be(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&ze(e,i[a],a);}return e}var Me=React$2.createContext();Me.Consumer;function Le(e){var t=useContext(Me),n=useMemo((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return "production"===process.env.NODE_ENV||null!==n&&!Array.isArray(n)&&"object"==typeof n?n:D(7)}return Array.isArray(e)||"object"!=typeof e?D(8):t?y$5({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?React$2.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.3"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,v=void 0===p?function(e){return xe(e)?"styled."+e:"Styled("+b$5(e)+")"}(e):p,g=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||h,N=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new oe(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target;"production"!==process.env.NODE_ENV&&useDebugValue(h);var m=function(e,t,n){void 0===e&&(e=w$4);var r=y$5({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t];})),[r,o]}(Oe(t,useContext(Me),a)||w$4,t,o),v=m[0],g=m[1],S=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w$4,o,s):e.generateAndInjectStyles(n,o,s);return "production"!==process.env.NODE_ENV&&useDebugValue(i),"production"!==process.env.NODE_ENV&&!t&&r&&r(i),i}(i,r,v,"production"!==process.env.NODE_ENV?e.warnTooManyClasses:void 0),b=n,_=g.$as||t.$as||g.as||t.as||p,N=xe(_),A=g!==t?y$5({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,index$2,_):!N||index$2(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=y$5({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=b,createElement(_,C)}(C,e,t,P)};return O.displayName=v,(C=React$2.forwardRef(O)).attrs=N,C.componentStyle=I,C.displayName=v,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return {};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b$5(e)));return Ye(e,y$5({},o,{attrs:N,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Be({},e.defaultProps,t):t;}}),"production"!==process.env.NODE_ENV&&(Pe(v,g),C.warnTooManyClasses=function(e,t){var n={},r=!1;return function(o){if(!r&&(n[o]=!0,Object.keys(n).length>=200)){var s=t?' with the id of "'+t+'"':"";console.warn("Over 200 classes were generated for component "+e+s+".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"),r=!0,n={};}}}(v,g)),C.toString=function(){return "."+C.styledComponentId},i&&hoistNonReactStatics_cjs(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w$4),!reactIs$7.exports.isValidElementType(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y$5({},o,{},n))},s.attrs=function(n){return e(t,r,y$5({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e);}));function We(e){"production"!==process.env.NODE_ENV&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}"production"!==process.env.NODE_ENV&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"),"production"!==process.env.NODE_ENV&&"test"!==process.env.NODE_ENV&&"undefined"!=typeof window&&(window["__styled-components-init__"]=window["__styled-components-init__"]||0,1===window["__styled-components-init__"]&&console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."),window["__styled-components-init__"]+=1);var styled = qe;

var reactSwitch = {exports: {}};

var reactSwitch_min = {};

Object.defineProperty(reactSwitch_min,"__esModule",{value:!0});var t$5=React$2;function i$1(){return (i$1=Object.assign||function(t){for(var i=1;i<arguments.length;i++){var s=arguments[i];for(var n in s)Object.prototype.hasOwnProperty.call(s,n)&&(t[n]=s[n]);}return t}).apply(this,arguments)}var s$2=t$5.createElement("svg",{viewBox:"-2 -5 14 20",height:"100%",width:"100%",style:{position:"absolute",top:0}},t$5.createElement("path",{d:"M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",fill:"#fff",fillRule:"evenodd"})),n$5=t$5.createElement("svg",{height:"100%",width:"100%",viewBox:"-2 -5 17 21",style:{position:"absolute",top:0}},t$5.createElement("path",{d:"M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",fill:"#fff",fillRule:"evenodd"}));function o(t){if(7===t.length)return t;for(var i="#",s=1;s<4;s+=1)i+=t[s]+t[s];return i}function h$5(t,i,s,n,h){return function(t,i,s,n,o){var h=(t-s)/(i-s);if(0===h)return n;if(1===h)return o;for(var e="#",a=1;a<6;a+=2){var r=parseInt(n.substr(a,2),16),l=parseInt(o.substr(a,2),16),u=Math.round((1-h)*r+h*l).toString(16);1===u.length&&(u="0"+u),e+=u;}return e}(t,i,s,o(n),o(h))}var e$5=function(s){function n(t){s.call(this,t);var i=t.height,n=t.width,o=t.checked;this.t=t.handleDiameter||i-2,this.i=Math.max(n-i,n-(i+this.t)/2),this.o=Math.max(0,(i-this.t)/2),this.state={h:o?this.i:this.o},this.l=0,this.u=0,this.p=this.p.bind(this),this.v=this.v.bind(this),this.g=this.g.bind(this),this.k=this.k.bind(this),this.M=this.M.bind(this),this.m=this.m.bind(this),this.T=this.T.bind(this),this.$=this.$.bind(this),this.C=this.C.bind(this),this.D=this.D.bind(this),this.O=this.O.bind(this),this.S=this.S.bind(this);}return s&&(n.__proto__=s),(n.prototype=Object.create(s&&s.prototype)).constructor=n,n.prototype.componentDidMount=function(){this.W=!0;},n.prototype.componentDidUpdate=function(t){t.checked!==this.props.checked&&this.setState({h:this.props.checked?this.i:this.o});},n.prototype.componentWillUnmount=function(){this.W=!1;},n.prototype.I=function(t){this.H.focus(),this.setState({R:t,j:!0,B:Date.now()});},n.prototype.L=function(t){var i=this.state,s=i.R,n=i.h,o=(this.props.checked?this.i:this.o)+t-s;i.N||t===s||this.setState({N:!0});var h=Math.min(this.i,Math.max(this.o,o));h!==n&&this.setState({h:h});},n.prototype.U=function(t){var i=this.state,s=i.h,n=i.N,o=i.B,h=this.props.checked,e=(this.i+this.o)/2;this.setState({h:this.props.checked?this.i:this.o});var a=Date.now()-o;(!n||a<250||(h&&s<=e||!h&&s>=e))&&this.A(t),this.W&&this.setState({N:!1,j:!1}),this.l=Date.now();},n.prototype.p=function(t){t.preventDefault(),"number"==typeof t.button&&0!==t.button||(this.I(t.clientX),window.addEventListener("mousemove",this.v),window.addEventListener("mouseup",this.g));},n.prototype.v=function(t){t.preventDefault(),this.L(t.clientX);},n.prototype.g=function(t){this.U(t),window.removeEventListener("mousemove",this.v),window.removeEventListener("mouseup",this.g);},n.prototype.k=function(t){this.X=null,this.I(t.touches[0].clientX);},n.prototype.M=function(t){this.L(t.touches[0].clientX);},n.prototype.m=function(t){t.preventDefault(),this.U(t);},n.prototype.$=function(t){Date.now()-this.l>50&&(this.A(t),Date.now()-this.u>50&&this.W&&this.setState({j:!1}));},n.prototype.C=function(){this.u=Date.now();},n.prototype.D=function(){this.setState({j:!0});},n.prototype.O=function(){this.setState({j:!1});},n.prototype.S=function(t){this.H=t;},n.prototype.T=function(t){t.preventDefault(),this.H.focus(),this.A(t),this.W&&this.setState({j:!1});},n.prototype.A=function(t){var i=this.props;(0, i.onChange)(!i.checked,t,i.id);},n.prototype.render=function(){var s=this.props,n=s.checked,o=s.disabled,e=s.className,a=s.offColor,r=s.onColor,l=s.offHandleColor,u=s.onHandleColor,c=s.checkedIcon,d=s.uncheckedIcon,f=s.checkedHandleIcon,p=s.uncheckedHandleIcon,b=s.boxShadow,v=s.activeBoxShadow,g=s.height,y=s.width,w=s.borderRadius,k=function(t,i){var s={};for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&-1===i.indexOf(n)&&(s[n]=t[n]);return s}(s,["checked","disabled","className","offColor","onColor","offHandleColor","onHandleColor","checkedIcon","uncheckedIcon","checkedHandleIcon","uncheckedHandleIcon","boxShadow","activeBoxShadow","height","width","borderRadius","handleDiameter"]),M=this.state,m=M.h,T=M.N,x=M.j,$={position:"relative",display:"inline-block",textAlign:"left",opacity:o?.5:1,direction:"ltr",borderRadius:g/2,WebkitTransition:"opacity 0.25s",MozTransition:"opacity 0.25s",transition:"opacity 0.25s",touchAction:"none",WebkitTapHighlightColor:"rgba(0, 0, 0, 0)",WebkitUserSelect:"none",MozUserSelect:"none",msUserSelect:"none",userSelect:"none"},C={height:g,width:y,margin:Math.max(0,(this.t-g)/2),position:"relative",background:h$5(m,this.i,this.o,a,r),borderRadius:"number"==typeof w?w:g/2,cursor:o?"default":"pointer",WebkitTransition:T?null:"background 0.25s",MozTransition:T?null:"background 0.25s",transition:T?null:"background 0.25s"},D={height:g,width:Math.min(1.5*g,y-(this.t+g)/2+1),position:"relative",opacity:(m-this.o)/(this.i-this.o),pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"},O={height:g,width:Math.min(1.5*g,y-(this.t+g)/2+1),position:"absolute",opacity:1-(m-this.o)/(this.i-this.o),right:0,top:0,pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"},S={height:this.t,width:this.t,background:h$5(m,this.i,this.o,l,u),display:"inline-block",cursor:o?"default":"pointer",borderRadius:"number"==typeof w?w-1:"50%",position:"absolute",transform:"translateX("+m+"px)",top:Math.max(0,(g-this.t)/2),outline:0,boxShadow:x?v:b,border:0,WebkitTransition:T?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",MozTransition:T?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",transition:T?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s"},W={height:this.t,width:this.t,opacity:Math.max(2*(1-(m-this.o)/(this.i-this.o)-.5),0),position:"absolute",left:0,top:0,pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"},z={height:this.t,width:this.t,opacity:Math.max(2*((m-this.o)/(this.i-this.o)-.5),0),position:"absolute",left:0,top:0,pointerEvents:"none",WebkitTransition:T?null:"opacity 0.25s",MozTransition:T?null:"opacity 0.25s",transition:T?null:"opacity 0.25s"};return t$5.createElement("div",{className:e,style:$},t$5.createElement("div",{className:"react-switch-bg",style:C,onClick:o?null:this.T,onMouseDown:function(t){return t.preventDefault()}},c&&t$5.createElement("div",{style:D},c),d&&t$5.createElement("div",{style:O},d)),t$5.createElement("div",{className:"react-switch-handle",style:S,onClick:function(t){return t.preventDefault()},onMouseDown:o?null:this.p,onTouchStart:o?null:this.k,onTouchMove:o?null:this.M,onTouchEnd:o?null:this.m,onTouchCancel:o?null:this.O},p&&t$5.createElement("div",{style:W},p),f&&t$5.createElement("div",{style:z},f)),t$5.createElement("input",i$1({},{type:"checkbox",role:"switch","aria-checked":n,checked:n,disabled:o,style:{border:0,clip:"rect(0 0 0 0)",height:1,margin:-1,overflow:"hidden",padding:0,position:"absolute",width:1}},k,{ref:this.S,onFocus:this.D,onBlur:this.O,onKeyUp:this.C,onChange:this.$})))},n}(t$5.Component);e$5.defaultProps={disabled:!1,offColor:"#888",onColor:"#080",offHandleColor:"#fff",onHandleColor:"#fff",uncheckedIcon:s$2,checkedIcon:n$5,boxShadow:null,activeBoxShadow:"0 0 2px 3px #3bf",height:28,width:56},reactSwitch_min.default=e$5;

var reactSwitch_dev = {};

var propTypes$2 = {exports: {}};

var reactIs$4 = {exports: {}};

var reactIs_production_min$4 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$4="function"===typeof Symbol&&Symbol.for,c$5=b$4?Symbol.for("react.element"):60103,d$4=b$4?Symbol.for("react.portal"):60106,e$4=b$4?Symbol.for("react.fragment"):60107,f$5=b$4?Symbol.for("react.strict_mode"):60108,g$7=b$4?Symbol.for("react.profiler"):60114,h$4=b$4?Symbol.for("react.provider"):60109,k$5=b$4?Symbol.for("react.context"):60110,l$4=b$4?Symbol.for("react.async_mode"):60111,m$4=b$4?Symbol.for("react.concurrent_mode"):60111,n$4=b$4?Symbol.for("react.forward_ref"):60112,p$4=b$4?Symbol.for("react.suspense"):60113,q$4=b$4?
Symbol.for("react.suspense_list"):60120,r$4=b$4?Symbol.for("react.memo"):60115,t$4=b$4?Symbol.for("react.lazy"):60116,v$4=b$4?Symbol.for("react.block"):60121,w$3=b$4?Symbol.for("react.fundamental"):60117,x$5=b$4?Symbol.for("react.responder"):60118,y$4=b$4?Symbol.for("react.scope"):60119;
function z$4(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$5:switch(a=a.type,a){case l$4:case m$4:case e$4:case g$7:case f$5:case p$4:return a;default:switch(a=a&&a.$$typeof,a){case k$5:case n$4:case t$4:case r$4:case h$4:return a;default:return u}}case d$4:return u}}}function A$3(a){return z$4(a)===m$4}reactIs_production_min$4.AsyncMode=l$4;reactIs_production_min$4.ConcurrentMode=m$4;reactIs_production_min$4.ContextConsumer=k$5;reactIs_production_min$4.ContextProvider=h$4;reactIs_production_min$4.Element=c$5;reactIs_production_min$4.ForwardRef=n$4;reactIs_production_min$4.Fragment=e$4;reactIs_production_min$4.Lazy=t$4;reactIs_production_min$4.Memo=r$4;reactIs_production_min$4.Portal=d$4;
reactIs_production_min$4.Profiler=g$7;reactIs_production_min$4.StrictMode=f$5;reactIs_production_min$4.Suspense=p$4;reactIs_production_min$4.isAsyncMode=function(a){return A$3(a)||z$4(a)===l$4};reactIs_production_min$4.isConcurrentMode=A$3;reactIs_production_min$4.isContextConsumer=function(a){return z$4(a)===k$5};reactIs_production_min$4.isContextProvider=function(a){return z$4(a)===h$4};reactIs_production_min$4.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$5};reactIs_production_min$4.isForwardRef=function(a){return z$4(a)===n$4};reactIs_production_min$4.isFragment=function(a){return z$4(a)===e$4};reactIs_production_min$4.isLazy=function(a){return z$4(a)===t$4};
reactIs_production_min$4.isMemo=function(a){return z$4(a)===r$4};reactIs_production_min$4.isPortal=function(a){return z$4(a)===d$4};reactIs_production_min$4.isProfiler=function(a){return z$4(a)===g$7};reactIs_production_min$4.isStrictMode=function(a){return z$4(a)===f$5};reactIs_production_min$4.isSuspense=function(a){return z$4(a)===p$4};
reactIs_production_min$4.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$4||a===m$4||a===g$7||a===f$5||a===p$4||a===q$4||"object"===typeof a&&null!==a&&(a.$$typeof===t$4||a.$$typeof===r$4||a.$$typeof===h$4||a.$$typeof===k$5||a.$$typeof===n$4||a.$$typeof===w$3||a.$$typeof===x$5||a.$$typeof===y$4||a.$$typeof===v$4)};reactIs_production_min$4.typeOf=z$4;

var reactIs_development$4 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$4.AsyncMode = AsyncMode;
reactIs_development$4.ConcurrentMode = ConcurrentMode;
reactIs_development$4.ContextConsumer = ContextConsumer;
reactIs_development$4.ContextProvider = ContextProvider;
reactIs_development$4.Element = Element;
reactIs_development$4.ForwardRef = ForwardRef;
reactIs_development$4.Fragment = Fragment;
reactIs_development$4.Lazy = Lazy;
reactIs_development$4.Memo = Memo;
reactIs_development$4.Portal = Portal;
reactIs_development$4.Profiler = Profiler;
reactIs_development$4.StrictMode = StrictMode;
reactIs_development$4.Suspense = Suspense;
reactIs_development$4.isAsyncMode = isAsyncMode;
reactIs_development$4.isConcurrentMode = isConcurrentMode;
reactIs_development$4.isContextConsumer = isContextConsumer;
reactIs_development$4.isContextProvider = isContextProvider;
reactIs_development$4.isElement = isElement;
reactIs_development$4.isForwardRef = isForwardRef;
reactIs_development$4.isFragment = isFragment;
reactIs_development$4.isLazy = isLazy;
reactIs_development$4.isMemo = isMemo;
reactIs_development$4.isPortal = isPortal;
reactIs_development$4.isProfiler = isProfiler;
reactIs_development$4.isStrictMode = isStrictMode;
reactIs_development$4.isSuspense = isSuspense;
reactIs_development$4.isValidElementType = isValidElementType;
reactIs_development$4.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$4.exports = reactIs_production_min$4;
} else {
  reactIs$4.exports = reactIs_development$4;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$e = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject$1(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject$1(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$e.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$b = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1$2 = ReactPropTypesSecret$b;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$5 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$a = ReactPropTypesSecret_1$2;
  var loggedTypeFailures$2 = {};
  var has$d = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$5 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$5(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$d(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$a);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$5(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures$2)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures$2[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$5(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$5.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures$2 = {};
  }
};

var checkPropTypes_1$2 = checkPropTypes$5;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$6 = reactIs$4.exports;
var assign$5 = objectAssign;

var ReactPropTypesSecret$9 = ReactPropTypesSecret_1$2;
var checkPropTypes$4 = checkPropTypes_1$2;

var has$c = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$4 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$4 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull$2() {
  return null;
}

var factoryWithTypeCheckers$2 = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$9) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$4(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull$2);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$9);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$6.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$4(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$4('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull$2;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$c(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$9);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$4('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull$2;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$4(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull$2;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$9) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$9);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign$5({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$9);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes$4;
  ReactPropTypes.resetWarningCache = checkPropTypes$4.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$8 = ReactPropTypesSecret_1$2;

function emptyFunction$2() {}
function emptyFunctionWithReset$2() {}
emptyFunctionWithReset$2.resetWarningCache = emptyFunction$2;

var factoryWithThrowingShims$2 = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$8) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset$2,
    resetWarningCache: emptyFunction$2
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs$5 = reactIs$4.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess$2 = true;
  propTypes$2.exports = factoryWithTypeCheckers$2(ReactIs$5.isElement, throwOnDirectAccess$2);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$2.exports = factoryWithThrowingShims$2();
}

var PropTypes$2 = propTypes$2.exports;

Object.defineProperty(reactSwitch_dev, '__esModule', { value: true });

var React$1 = React$2;
var PropTypes$1 = propTypes$2.exports;

function _extends$K() {
  _extends$K = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$K.apply(this, arguments);
}

/*
The MIT License (MIT)

Copyright (c) 2015 instructure-react

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
var uncheckedIcon = React$1.createElement('svg', {
  viewBox: "-2 -5 14 20",
  height: "100%",
  width: "100%",
  style: {
    position: "absolute",
    top: 0
  }
}, React$1.createElement('path', {
  d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
  fill: "#fff",
  fillRule: "evenodd"
}));
var checkedIcon = React$1.createElement('svg', {
  height: "100%",
  width: "100%",
  viewBox: "-2 -5 17 21",
  style: {
    position: "absolute",
    top: 0
  }
}, React$1.createElement('path', {
  d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
  fill: "#fff",
  fillRule: "evenodd"
}));

function createBackgroundColor(pos, checkedPos, uncheckedPos, offColor, onColor) {
  var relativePos = (pos - uncheckedPos) / (checkedPos - uncheckedPos);

  if (relativePos === 0) {
    return offColor;
  }

  if (relativePos === 1) {
    return onColor;
  }

  var newColor = "#";

  for (var i = 1; i < 6; i += 2) {
    var offComponent = parseInt(offColor.substr(i, 2), 16);
    var onComponent = parseInt(onColor.substr(i, 2), 16);
    var weightedValue = Math.round((1 - relativePos) * offComponent + relativePos * onComponent);
    var newComponent = weightedValue.toString(16);

    if (newComponent.length === 1) {
      newComponent = "0" + newComponent;
    }

    newColor += newComponent;
  }

  return newColor;
}

function convertShorthandColor(color) {
  if (color.length === 7) {
    return color;
  }

  var sixDigitColor = "#";

  for (var i = 1; i < 4; i += 1) {
    sixDigitColor += color[i] + color[i];
  }

  return sixDigitColor;
}

function getBackgroundColor(pos, checkedPos, uncheckedPos, offColor, onColor) {
  var sixDigitOffColor = convertShorthandColor(offColor);
  var sixDigitOnColor = convertShorthandColor(onColor);
  return createBackgroundColor(pos, checkedPos, uncheckedPos, sixDigitOffColor, sixDigitOnColor);
}

// Make sure color props are strings that start with "#" since other ways to write colors are not supported.
var hexColorPropType = function (props, propName, componentName) {
  var prop = props[propName];

  if (typeof prop !== "string" || prop[0] !== "#" || prop.length !== 4 && prop.length !== 7) {
    return new Error("Invalid prop '" + propName + "' supplied to '" + componentName + "'. '" + propName + "' has to be either a 3-digit or 6-digit hex-color string. Valid examples: '#abc', '#123456'");
  }

  return null;
};

function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];

  return target;
}

var ReactSwitch$1 = /*@__PURE__*/function (Component) {
  function ReactSwitch(props) {
    Component.call(this, props);
    var height = props.height;
    var width = props.width;
    var handleDiameter = props.handleDiameter;
    var checked = props.checked;
    this.$handleDiameter = handleDiameter || height - 2;
    this.$checkedPos = Math.max(width - height, width - (height + this.$handleDiameter) / 2);
    this.$uncheckedPos = Math.max(0, (height - this.$handleDiameter) / 2);
    this.state = {
      $pos: checked ? this.$checkedPos : this.$uncheckedPos
    };
    this.$lastDragAt = 0;
    this.$lastKeyUpAt = 0;
    this.$onMouseDown = this.$onMouseDown.bind(this);
    this.$onMouseMove = this.$onMouseMove.bind(this);
    this.$onMouseUp = this.$onMouseUp.bind(this);
    this.$onTouchStart = this.$onTouchStart.bind(this);
    this.$onTouchMove = this.$onTouchMove.bind(this);
    this.$onTouchEnd = this.$onTouchEnd.bind(this);
    this.$onClick = this.$onClick.bind(this);
    this.$onInputChange = this.$onInputChange.bind(this);
    this.$onKeyUp = this.$onKeyUp.bind(this);
    this.$setHasOutline = this.$setHasOutline.bind(this);
    this.$unsetHasOutline = this.$unsetHasOutline.bind(this);
    this.$getInputRef = this.$getInputRef.bind(this);
  }

  if (Component) ReactSwitch.__proto__ = Component;
  ReactSwitch.prototype = Object.create(Component && Component.prototype);
  ReactSwitch.prototype.constructor = ReactSwitch;

  ReactSwitch.prototype.componentDidMount = function componentDidMount() {
    this.$isMounted = true;
  };

  ReactSwitch.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.checked === this.props.checked) {
      return;
    }

    var $pos = this.props.checked ? this.$checkedPos : this.$uncheckedPos;
    this.setState({
      $pos: $pos
    });
  };

  ReactSwitch.prototype.componentWillUnmount = function componentWillUnmount() {
    this.$isMounted = false;
  };

  ReactSwitch.prototype.$onDragStart = function $onDragStart(clientX) {
    this.$inputRef.focus();
    this.setState({
      $startX: clientX,
      $hasOutline: true,
      $dragStartingTime: Date.now()
    });
  };

  ReactSwitch.prototype.$onDrag = function $onDrag(clientX) {
    var ref = this.state;
    var $startX = ref.$startX;
    var $isDragging = ref.$isDragging;
    var $pos = ref.$pos;
    var ref$1 = this.props;
    var checked = ref$1.checked;
    var startPos = checked ? this.$checkedPos : this.$uncheckedPos;
    var mousePos = startPos + clientX - $startX; // We need this check to fix a windows glitch where onDrag is triggered onMouseDown in some cases

    if (!$isDragging && clientX !== $startX) {
      this.setState({
        $isDragging: true
      });
    }

    var newPos = Math.min(this.$checkedPos, Math.max(this.$uncheckedPos, mousePos)); // Prevent unnecessary rerenders

    if (newPos !== $pos) {
      this.setState({
        $pos: newPos
      });
    }
  };

  ReactSwitch.prototype.$onDragStop = function $onDragStop(event) {
    var ref = this.state;
    var $pos = ref.$pos;
    var $isDragging = ref.$isDragging;
    var $dragStartingTime = ref.$dragStartingTime;
    var ref$1 = this.props;
    var checked = ref$1.checked;
    var halfwayCheckpoint = (this.$checkedPos + this.$uncheckedPos) / 2;
    /*
      Set position state back to the previous position even if user drags the switch with intention to change the state.
      This is to prevent the switch from getting stuck in the middle if the event isn't handled in the onChange callback.
    */

    var prevPos = this.props.checked ? this.$checkedPos : this.$uncheckedPos;
    this.setState({
      $pos: prevPos
    }); // Act as if the user clicked the handle if they didn't drag it _or_ the dragged it for less than 250ms

    var timeSinceStart = Date.now() - $dragStartingTime;
    var isSimulatedClick = !$isDragging || timeSinceStart < 250; // Handle when the user has dragged the switch more than halfway from either side

    var isDraggedHalfway = checked && $pos <= halfwayCheckpoint || !checked && $pos >= halfwayCheckpoint;

    if (isSimulatedClick || isDraggedHalfway) {
      this.$onChange(event);
    }

    if (this.$isMounted) {
      this.setState({
        $isDragging: false,
        $hasOutline: false
      });
    }

    this.$lastDragAt = Date.now();
  };

  ReactSwitch.prototype.$onMouseDown = function $onMouseDown(event) {
    event.preventDefault(); // Ignore right click and scroll

    if (typeof event.button === "number" && event.button !== 0) {
      return;
    }

    this.$onDragStart(event.clientX);
    window.addEventListener("mousemove", this.$onMouseMove);
    window.addEventListener("mouseup", this.$onMouseUp);
  };

  ReactSwitch.prototype.$onMouseMove = function $onMouseMove(event) {
    event.preventDefault();
    this.$onDrag(event.clientX);
  };

  ReactSwitch.prototype.$onMouseUp = function $onMouseUp(event) {
    this.$onDragStop(event);
    window.removeEventListener("mousemove", this.$onMouseMove);
    window.removeEventListener("mouseup", this.$onMouseUp);
  };

  ReactSwitch.prototype.$onTouchStart = function $onTouchStart(event) {
    this.$checkedStateFromDragging = null;
    this.$onDragStart(event.touches[0].clientX);
  };

  ReactSwitch.prototype.$onTouchMove = function $onTouchMove(event) {
    this.$onDrag(event.touches[0].clientX);
  };

  ReactSwitch.prototype.$onTouchEnd = function $onTouchEnd(event) {
    event.preventDefault();
    this.$onDragStop(event);
  };

  ReactSwitch.prototype.$onInputChange = function $onInputChange(event) {
    // This condition is unfortunately needed in some browsers where the input's change event might get triggered
    // right after the dragstop event is triggered (occurs when dropping over a label element)
    if (Date.now() - this.$lastDragAt > 50) {
      this.$onChange(event); // Prevent clicking label, but not key activation from setting outline to true - yes, this is absurd

      if (Date.now() - this.$lastKeyUpAt > 50) {
        if (this.$isMounted) {
          this.setState({
            $hasOutline: false
          });
        }
      }
    }
  };

  ReactSwitch.prototype.$onKeyUp = function $onKeyUp() {
    this.$lastKeyUpAt = Date.now();
  };

  ReactSwitch.prototype.$setHasOutline = function $setHasOutline() {
    this.setState({
      $hasOutline: true
    });
  };

  ReactSwitch.prototype.$unsetHasOutline = function $unsetHasOutline() {
    this.setState({
      $hasOutline: false
    });
  };

  ReactSwitch.prototype.$getInputRef = function $getInputRef(el) {
    this.$inputRef = el;
  };

  ReactSwitch.prototype.$onClick = function $onClick(event) {
    event.preventDefault();
    this.$inputRef.focus();
    this.$onChange(event);

    if (this.$isMounted) {
      this.setState({
        $hasOutline: false
      });
    }
  };

  ReactSwitch.prototype.$onChange = function $onChange(event) {
    var ref = this.props;
    var checked = ref.checked;
    var onChange = ref.onChange;
    var id = ref.id;
    onChange(!checked, event, id);
  };

  ReactSwitch.prototype.render = function render() {
    var ref = this.props;
    var checked = ref.checked;
    var disabled = ref.disabled;
    var className = ref.className;
    var offColor = ref.offColor;
    var onColor = ref.onColor;
    var offHandleColor = ref.offHandleColor;
    var onHandleColor = ref.onHandleColor;
    var checkedIcon = ref.checkedIcon;
    var uncheckedIcon = ref.uncheckedIcon;
    var checkedHandleIcon = ref.checkedHandleIcon;
    var uncheckedHandleIcon = ref.uncheckedHandleIcon;
    var boxShadow = ref.boxShadow;
    var activeBoxShadow = ref.activeBoxShadow;
    var height = ref.height;
    var width = ref.width;
    var borderRadius = ref.borderRadius;
    ref.handleDiameter;
    var rest$1 = objectWithoutProperties(ref, ["checked", "disabled", "className", "offColor", "onColor", "offHandleColor", "onHandleColor", "checkedIcon", "uncheckedIcon", "checkedHandleIcon", "uncheckedHandleIcon", "boxShadow", "activeBoxShadow", "height", "width", "borderRadius", "handleDiameter"]);
    var rest = rest$1;
    var ref$1 = this.state;
    var $pos = ref$1.$pos;
    var $isDragging = ref$1.$isDragging;
    var $hasOutline = ref$1.$hasOutline;
    var rootStyle = {
      position: "relative",
      display: "inline-block",
      textAlign: "left",
      opacity: disabled ? 0.5 : 1,
      direction: "ltr",
      borderRadius: height / 2,
      WebkitTransition: "opacity 0.25s",
      MozTransition: "opacity 0.25s",
      transition: "opacity 0.25s",
      touchAction: "none",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitUserSelect: "none",
      MozUserSelect: "none",
      msUserSelect: "none",
      userSelect: "none"
    };
    var backgroundStyle = {
      height: height,
      width: width,
      margin: Math.max(0, (this.$handleDiameter - height) / 2),
      position: "relative",
      background: getBackgroundColor($pos, this.$checkedPos, this.$uncheckedPos, offColor, onColor),
      borderRadius: typeof borderRadius === "number" ? borderRadius : height / 2,
      cursor: disabled ? "default" : "pointer",
      WebkitTransition: $isDragging ? null : "background 0.25s",
      MozTransition: $isDragging ? null : "background 0.25s",
      transition: $isDragging ? null : "background 0.25s"
    };
    var checkedIconStyle = {
      height: height,
      width: Math.min(height * 1.5, width - (this.$handleDiameter + height) / 2 + 1),
      position: "relative",
      opacity: ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos),
      pointerEvents: "none",
      WebkitTransition: $isDragging ? null : "opacity 0.25s",
      MozTransition: $isDragging ? null : "opacity 0.25s",
      transition: $isDragging ? null : "opacity 0.25s"
    };
    var uncheckedIconStyle = {
      height: height,
      width: Math.min(height * 1.5, width - (this.$handleDiameter + height) / 2 + 1),
      position: "absolute",
      opacity: 1 - ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos),
      right: 0,
      top: 0,
      pointerEvents: "none",
      WebkitTransition: $isDragging ? null : "opacity 0.25s",
      MozTransition: $isDragging ? null : "opacity 0.25s",
      transition: $isDragging ? null : "opacity 0.25s"
    };
    var handleStyle = {
      height: this.$handleDiameter,
      width: this.$handleDiameter,
      background: getBackgroundColor($pos, this.$checkedPos, this.$uncheckedPos, offHandleColor, onHandleColor),
      display: "inline-block",
      cursor: disabled ? "default" : "pointer",
      borderRadius: typeof borderRadius === "number" ? borderRadius - 1 : "50%",
      position: "absolute",
      transform: "translateX(" + $pos + "px)",
      top: Math.max(0, (height - this.$handleDiameter) / 2),
      outline: 0,
      boxShadow: $hasOutline ? activeBoxShadow : boxShadow,
      border: 0,
      WebkitTransition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
      MozTransition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
      transition: $isDragging ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s"
    };
    var uncheckedHandleIconStyle = {
      height: this.$handleDiameter,
      width: this.$handleDiameter,
      opacity: Math.max((1 - ($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos) - 0.5) * 2, 0),
      position: "absolute",
      left: 0,
      top: 0,
      pointerEvents: "none",
      WebkitTransition: $isDragging ? null : "opacity 0.25s",
      MozTransition: $isDragging ? null : "opacity 0.25s",
      transition: $isDragging ? null : "opacity 0.25s"
    };
    var checkedHandleIconStyle = {
      height: this.$handleDiameter,
      width: this.$handleDiameter,
      opacity: Math.max((($pos - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos) - 0.5) * 2, 0),
      position: "absolute",
      left: 0,
      top: 0,
      pointerEvents: "none",
      WebkitTransition: $isDragging ? null : "opacity 0.25s",
      MozTransition: $isDragging ? null : "opacity 0.25s",
      transition: $isDragging ? null : "opacity 0.25s"
    };
    var inputStyle = {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: 1
    };
    return React$1.createElement('div', {
      className: className,
      style: rootStyle
    }, React$1.createElement('div', {
      className: "react-switch-bg",
      style: backgroundStyle,
      onClick: disabled ? null : this.$onClick,
      onMouseDown: function (e) {
        return e.preventDefault();
      }
    }, checkedIcon && React$1.createElement('div', {
      style: checkedIconStyle
    }, checkedIcon), uncheckedIcon && React$1.createElement('div', {
      style: uncheckedIconStyle
    }, uncheckedIcon)), React$1.createElement('div', {
      className: "react-switch-handle",
      style: handleStyle,
      onClick: function (e) {
        return e.preventDefault();
      },
      onMouseDown: disabled ? null : this.$onMouseDown,
      onTouchStart: disabled ? null : this.$onTouchStart,
      onTouchMove: disabled ? null : this.$onTouchMove,
      onTouchEnd: disabled ? null : this.$onTouchEnd,
      onTouchCancel: disabled ? null : this.$unsetHasOutline
    }, uncheckedHandleIcon && React$1.createElement('div', {
      style: uncheckedHandleIconStyle
    }, uncheckedHandleIcon), checkedHandleIcon && React$1.createElement('div', {
      style: checkedHandleIconStyle
    }, checkedHandleIcon)), React$1.createElement('input', _extends$K({}, {
      type: "checkbox",
      role: "switch",
      'aria-checked': checked,
      checked: checked,
      disabled: disabled,
      style: inputStyle
    }, rest, {
      ref: this.$getInputRef,
      onFocus: this.$setHasOutline,
      onBlur: this.$unsetHasOutline,
      onKeyUp: this.$onKeyUp,
      onChange: this.$onInputChange
    })));
  };

  return ReactSwitch;
}(React$1.Component);

ReactSwitch$1.propTypes = {
  checked: PropTypes$1.bool.isRequired,
  onChange: PropTypes$1.func.isRequired,
  disabled: PropTypes$1.bool,
  offColor: hexColorPropType,
  onColor: hexColorPropType,
  offHandleColor: hexColorPropType,
  onHandleColor: hexColorPropType,
  handleDiameter: PropTypes$1.number,
  uncheckedIcon: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.element]),
  checkedIcon: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.element]),
  boxShadow: PropTypes$1.string,
  borderRadius: PropTypes$1.number,
  activeBoxShadow: PropTypes$1.string,
  uncheckedHandleIcon: PropTypes$1.element,
  checkedHandleIcon: PropTypes$1.element,
  height: PropTypes$1.number,
  width: PropTypes$1.number,
  id: PropTypes$1.string,
  className: PropTypes$1.string
};
ReactSwitch$1.defaultProps = {
  disabled: false,
  offColor: "#888",
  onColor: "#080",
  offHandleColor: "#fff",
  onHandleColor: "#fff",
  uncheckedIcon: uncheckedIcon,
  checkedIcon: checkedIcon,
  boxShadow: null,
  activeBoxShadow: "0 0 2px 3px #3bf",
  height: 28,
  width: 56
};

reactSwitch_dev.default = ReactSwitch$1;

if (process.env.NODE_ENV === "production") {
  reactSwitch.exports = reactSwitch_min;
} else {
  reactSwitch.exports = reactSwitch_dev;
}

var ReactSwitch = reactSwitch.exports;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter$a(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function warn$2(s) {
  console.warn('[react-ga]', s);
}

function _typeof$s(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$s = function _typeof(obj) { return typeof obj; }; } else { _typeof$s = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$s(obj); }

function ownKeys$w(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$v(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$w(Object(source), true).forEach(function (key) { _defineProperty$x(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$w(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties$x(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$w(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$w(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$r(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$q(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$t(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$q(Constructor.prototype, protoProps); if (staticProps) _defineProperties$q(Constructor, staticProps); return Constructor; }

function _inherits$p(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$n(subClass, superClass); }

function _setPrototypeOf$n(o, p) { _setPrototypeOf$n = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$n(o, p); }

function _createSuper$l(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$m(); return function _createSuperInternal() { var Super = _getPrototypeOf$n(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$n(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$p(this, result); }; }

function _possibleConstructorReturn$p(self, call) { if (call && (_typeof$s(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$n(self); }

function _assertThisInitialized$n(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$m() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$n(o) { _getPrototypeOf$n = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$n(o); }

function _defineProperty$x(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink$1 = /*#__PURE__*/function (_Component) {
  _inherits$p(OutboundLink, _Component);

  var _super = _createSuper$l(OutboundLink);

  function OutboundLink() {
    var _this;

    _classCallCheck$r(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$x(_assertThisInitialized$n(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass$t(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          target = _this$props2.target,
          oldProps = _objectWithoutProperties$x(_this$props2, ["to", "target"]);

      var props = _objectSpread$v(_objectSpread$v({}, oldProps), {}, {
        target: target,
        href: href,
        onClick: this.handleClick
      });

      if (target === NEWTAB) {
        props.rel = "".concat(props.rel ? props.rel : '', " noopener noreferrer").trim();
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return /*#__PURE__*/React$2.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(Component);

_defineProperty$x(OutboundLink$1, "trackLink", function () {
  warn$2('ga tracking not enabled');
});
OutboundLink$1.propTypes = {
  eventLabel: PropTypes$2.string.isRequired,
  target: PropTypes$2.string,
  to: PropTypes$2.string,
  onClick: PropTypes$2.func,
  trackerNames: PropTypes$2.arrayOf(PropTypes$2.string)
};
OutboundLink$1.defaultProps = {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
};

// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}

var redacted = 'REDACTED (Potential Email Address)';
function redactEmail(string) {
  if (mightBeEmail(string)) {
    warn$2('This arg looks like an email address, redacting.');
    return redacted;
  }

  return string;
}

// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim$2(s) {
  return s && s.toString().replace(/^\s+|\s+$/g, '');
}

/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */
var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; // test

function toTitleCase(string) {
  return trim$2(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

function format$3() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var titleCase = arguments.length > 1 ? arguments[1] : undefined;
  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _str = s || '';

  if (titleCase) {
    _str = toTitleCase(s);
  }

  if (redactingEmail) {
    _str = redactEmail(_str);
  }

  return _str;
}

function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

var isLoaded = false;
function loadGA (options) {
  if (isLoaded) return;
  isLoaded = true;
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  }

  var onerror = options && options.onerror; // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */

  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    a.onerror = onerror;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

}

function log$1(s) {
  console.info('[react-ga]', s);
}

var gaCalls = [];
var TestModeAPI = {
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
};

function _objectWithoutProperties$w(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$v(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$v(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys$v(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$u(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$v(Object(source), true).forEach(function (key) { _defineProperty$w(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$v(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$w(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof$r(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$r = function _typeof(obj) { return typeof obj; }; } else { _typeof$r = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$r(obj); }

function _toConsumableArray$b(arr) { return _arrayWithoutHoles$b(arr) || _iterableToArray$c(arr) || _unsupportedIterableToArray$h(arr) || _nonIterableSpread$b(); }

function _nonIterableSpread$b() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$h(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$h(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$h(o, minLen); }

function _iterableToArray$c(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$b(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$h(arr); }

function _arrayLikeToArray$h(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;
var _redactEmail = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return TestModeAPI.ga.apply(TestModeAPI, arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return warn$2('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format$2(s) {
  return format$3(s, _titleCase, _redactEmail);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      warn$2('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray$b(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    warn$2('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.redactEmail === false) {
      _redactEmail = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function addTrackers(configsOrTrackingId, options) {
  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof$r(config) !== 'object') {
        warn$2('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return;
    }

    if (!options || options.standardImplementation !== true) loadGA(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
  addTrackers(configsOrTrackingId, options);
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      log$1("called ga('arguments');");
      log$1("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set$1(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    warn$2('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof$r(fieldsObject) !== 'object') {
    warn$2('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    warn$2('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    log$1("called ga('set', fieldsObject);");
    log$1("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    log$1("called ga('send', fieldObject);");
    log$1("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    log$1("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    warn$2('path is required in .pageview()');
    return;
  }

  var path = trim$2(rawPath);

  if (path === '') {
    warn$2('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread$u({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      log$1("called ga('send', 'pageview', path);");
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      log$1("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    warn$2('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = removeLeadingSlash(trim$2(rawModalName));

  if (modalName === '') {
    warn$2('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      log$1("called ga('send', 'pageview', path);");
      log$1("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || typeof value !== 'number') {
      warn$2('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format$2(category),
      timingVar: _format$2(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format$2(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {{action: string, category: string}} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties$w(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      warn$2('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format$2(category),
      eventAction: _format$2(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format$2(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        warn$2('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        warn$2('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        warn$2('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          warn$2('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format$2(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        warn$2('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        warn$2('`name` is required in .require()');
        return;
      }

      var name = trim$2(rawName);

      if (name === '') {
        warn$2('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (_typeof$r(options) !== 'object') {
          warn$2('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          warn$2('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          log$1("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          log$1("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }

    if (args.length === 1) {
      payload = args[0];
    } else {
      actionType = args[0];
      payload = args[1];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        warn$2('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        warn$2('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            log$1("called ga('".concat(command, "');"));
            log$1("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            log$1("called ga('".concat(command, "');"));
            log$1("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            log$1("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    warn$2('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      warn$2('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format$2(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var testModeAPI = TestModeAPI;
var core = {
  initialize: initialize,
  ga: ga,
  set: set$1,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: TestModeAPI
};

var Defaults = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addTrackers: addTrackers,
  initialize: initialize,
  ga: ga,
  set: set$1,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: testModeAPI,
  'default': core
});

function ownKeys$u(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$t(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$u(Object(source), true).forEach(function (key) { _defineProperty$v(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$u(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$v(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
OutboundLink$1.origTrackLink = OutboundLink$1.trackLink;
OutboundLink$1.trackLink = outboundLink;
var OutboundLink = OutboundLink$1;
var ReactGA = _objectSpread$t(_objectSpread$t({}, Defaults), {}, {
  OutboundLink: OutboundLink
});

const MEDIA_WIDTHS = {
    upToExtraSmall: 500,
    upToSmall: 720,
    upToMedium: 960,
    upToLarge: 1280,
};
const mediaWidthTemplates = Object.keys(MEDIA_WIDTHS).reduce((acc, sizeKey) => {
    acc[sizeKey] = (a, b, c) => Ae `
      @media (max-width: ${MEDIA_WIDTHS[sizeKey]}px) {
        ${Ae(a, b, c)}
      }
    `;
    return acc;
}, {});
const white = '#FFFFFF';
const black = '#000000';
const philippineYellow = '#FFC800'; //primary
const mustardYellow = '#E1AA00';
const eerieBlack = '#1C1C1C';
const ghostWhite = '#F7F8FA';
const ghostWhite1 = '#FAF9FD';
const chineseBlack = '#111111';
const darkGunmetal = '#212427';
const platinum = '#E5E5E5';
const darkSilver = '#717171';
const venetianRed = '#CC1512';
const oceanBlue = '#18C145';
const quickSilver = '#A3A3A3';
const defaultColors = {
    // base
    white,
    black,
    // text
    text1: '#000000',
    text2: '#565A69',
    text3: '#888D9B',
    text4: '#C3C5CB',
    text5: '#EDEEF2',
    text6: '#EDEEF2',
    text7: '#000000',
    text8: '#565A69',
    text9: '#000000',
    text10: '#000000',
    text11: '#18C145',
    text12: '#E84142',
    text13: '#000000',
    text14: '#000000',
    text15: '#000000',
    // backgrounds / greys
    bg1: '#FFFFFF',
    bg2: '#F7F8FA',
    bg3: '#EDEEF2',
    bg4: '#CED0D9',
    bg5: '#888D9B',
    bg6: '#FFFFFF',
    bg7: '#FFFFFF',
    bg8: '#FFFFFF',
    bg9: '#000000',
    //specialty colors
    modalBG: 'rgba(0,0,0,0.3)',
    advancedBG: 'rgba(255,255,255,0.6)',
    //primary colors
    primary1: '#FF6B00',
    primary2: '#FF6B00',
    primary3: '#FF6B00',
    primary4: '#FF6B00',
    primary5: '#FF6B00',
    primary6: '#FFFFFF',
    // color text
    primaryText1: '#ffffff',
    // secondary colors
    secondary1: '#ff007a',
    secondary2: '#F6DDE8',
    secondary3: '#FDEAF1',
    // other
    red1: '#FF6871',
    red2: '#F82D3A',
    green1: '#27AE60',
    yellow1: '#FFE270',
    yellow2: '#F3841E',
    blue1: '#2172E5',
    avaxRed: '#E84142',
    switch: {
        onColor: philippineYellow,
        offColor: '#CED0D9',
        backgroundColor: platinum,
    },
    toggleButton: {
        backgroundColor: platinum,
        selectedColor: ghostWhite,
        fontColor: chineseBlack,
    },
    button: {
        primary: {
            background: philippineYellow,
            color: black,
        },
        secondary: {
            background: chineseBlack,
            color: white,
        },
        outline: {
            borderColor: philippineYellow,
            color: black,
        },
        plain: {
            color: black,
        },
        disable: {
            background: platinum,
            color: darkSilver,
        },
        confirmed: {
            background: oceanBlue,
            color: oceanBlue,
            borderColor: oceanBlue,
        },
    },
    primary: philippineYellow,
    mustardYellow,
    eerieBlack,
    ghostWhite,
    ghostWhite1,
    chineseBlack,
    darkGunmetal,
    platinum,
    darkSilver,
    venetianRed,
    oceanBlue,
    quickSilver,
    color2: ghostWhite,
    color3: platinum,
    color4: chineseBlack,
    color5: white,
    color6: chineseBlack,
    color7: ghostWhite,
    color8: platinum,
    color9: quickSilver,
};
const defaultTheme$1 = Object.assign(Object.assign({}, defaultColors), { grids: {
        sm: 8,
        md: 12,
        lg: 24,
    }, 
    //shadows
    shadow1: '#2F80ED', 
    // media queries
    mediaWidth: mediaWidthTemplates, 
    // css snippets
    flexColumnNoWrap: Ae `
    display: flex;
    flex-flow: column nowrap;
  `, flexRowNoWrap: Ae `
    display: flex;
    flex-flow: row nowrap;
  ` });
function ThemeProvider({ children, theme }) {
    return jsx(Le, Object.assign({ theme: theme || defaultTheme$1 }, { children: children }), void 0);
}
const useTheme = () => {
    const theme = useContext(Me);
    if (!theme) {
        throw Error('useTheme is used outside of ThemeContext');
    }
    return theme;
};
const StyledLink = styled.a `
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme }) => theme.primary};
  font-weight: 500;

  :hover {
    text-decoration: underline;
  }

  :focus {
    outline: none;
    text-decoration: underline;
  }

  :active {
    text-decoration: none;
  }
`;
/**
 * Outbound link that handles firing google analytics events
 */
function ExternalLink(_a) {
    var { target = '_blank', href, rel = 'noopener noreferrer' } = _a, rest = __rest$1(_a, ["target", "href", "rel"]);
    const handleClick = useCallback((event) => {
        // don't prevent default, don't redirect if it's a new tab
        if (target === '_blank' || event.ctrlKey || event.metaKey) {
            // eslint-disable-next-line import/no-named-as-default-member
            ReactGA.outboundLink({ label: href }, () => {
                console.debug('Fired outbound link event', href);
            });
        }
        else {
            event.preventDefault();
            // send a ReactGA event and then trigger a location change
            // eslint-disable-next-line import/no-named-as-default-member
            ReactGA.outboundLink({ label: href }, () => {
                window.location.href = href;
            });
        }
    }, [href, target]);
    return jsx(StyledLink, Object.assign({ target: target, rel: rel, href: href, onClick: handleClick }, rest), void 0);
}

// here we need to do some hack, because react-switch package is still in commonjs
// https://github.com/vitejs/vite/issues/2139#issuecomment-824557740
const BaseSwitch = ReactSwitch.default ? ReactSwitch.default : ReactSwitch;
const Switch = (props) => {
    var _a, _b, _c, _d;
    const { checked, onChange, checkedIcon, disabled, height, offColor, offHandleColor, onColor, onHandleColor, uncheckedIcon, width, } = props;
    const theme = useTheme();
    return (jsx(BaseSwitch, { checked: checked, onChange: (isChecked) => onChange === null || onChange === void 0 ? void 0 : onChange(isChecked), onHandleColor: onHandleColor || ((_a = theme.switch) === null || _a === void 0 ? void 0 : _a.onColor), offHandleColor: offHandleColor || ((_b = theme.switch) === null || _b === void 0 ? void 0 : _b.offColor), onColor: onColor || ((_c = theme.switch) === null || _c === void 0 ? void 0 : _c.backgroundColor), offColor: offColor || ((_d = theme.switch) === null || _d === void 0 ? void 0 : _d.backgroundColor), uncheckedIcon: uncheckedIcon || false, checkedIcon: checkedIcon || false, disabled: disabled, height: height, width: width }, void 0));
};
Switch.defaultProps = {
    onChange: () => { },
    checked: false,
    checkedIcon: false,
    disabled: false,
    uncheckedIcon: false,
};

function _extends$J() {
  _extends$J = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$J.apply(this, arguments);
}

function _assertThisInitialized$m(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _setPrototypeOf$m(o, p) {
  _setPrototypeOf$m = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$m(o, p);
}

function _inheritsLoose$2(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$m(subClass, superClass);
}

function _getPrototypeOf$m(o) {
  _getPrototypeOf$m = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$m(o);
}

function _isNativeFunction$1(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _isNativeReflectConstruct$l() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct$1(Parent, args, Class) {
  if (_isNativeReflectConstruct$l()) {
    _construct$1 = Reflect.construct;
  } else {
    _construct$1 = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf$m(instance, Class.prototype);
      return instance;
    };
  }

  return _construct$1.apply(null, arguments);
}

function _wrapNativeSuper$1(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper$1 = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction$1(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct$1(Class, arguments, _getPrototypeOf$m(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$m(Wrapper, Class);
  };

  return _wrapNativeSuper$1(Class);
}

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
  "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */


var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose$2(PolishedError, _Error);

  function PolishedError(code) {
    var _this;

    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      _this = _Error.call(this, format$2.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }

    return _assertThisInitialized$m(_this);
  }

  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper$1(Error));

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4])
    };
  }

  throw new PolishedError(5);
}

function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }

  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);

  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;

    case green:
      hue = (blue - red) / delta + 2;
      break;

    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;

  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }

  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl$1(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new PolishedError(1);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla$1(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }

  throw new PolishedError(2);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb$2(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new PolishedError(6);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba$1(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb$2(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb$2(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new PolishedError(7);
}

var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */


function toColorString(color) {
  if (typeof color !== 'object') throw new PolishedError(8);
  if (isRgba(color)) return rgba$1(color);
  if (isRgb(color)) return rgb$2(color);
  if (isHsla(color)) return hsla$1(color);
  if (isHsl(color)) return hsl$1(color);
  throw new PolishedError(8);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare


function curry$1(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */

function darken(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends$J({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
} // prettier-ignore


var curriedDarken = /*#__PURE__*/curry$1
/* ::<number | string, string, string> */
(darken);

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */

function lighten(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends$J({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
} // prettier-ignore


var curriedLighten = /*#__PURE__*/curry$1
/* ::<number | string, string, string> */
(lighten);

/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */

function transparentize(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = _extends$J({}, parsedColor, {
    alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
  });

  return rgba$1(colorWithAlpha);
} // prettier-ignore


var curriedTransparentize = /*#__PURE__*/curry$1
/* ::<number | string, string, string> */
(transparentize);

const Primary = (props) => props.variant === 'primary' &&
    Ae `
    background-color: ${({ theme }) => { var _a, _b; return (_b = (_a = theme.button) === null || _a === void 0 ? void 0 : _a.primary) === null || _b === void 0 ? void 0 : _b.background; }};
    color: ${({ theme }) => { var _a, _b; return (_b = (_a = theme.button) === null || _a === void 0 ? void 0 : _a.primary) === null || _b === void 0 ? void 0 : _b.color; }};
  `;
const Secondary = (props) => props.variant === 'secondary' &&
    Ae `
    background-color: ${({ theme }) => { var _a, _b; return (_b = (_a = theme.button) === null || _a === void 0 ? void 0 : _a.secondary) === null || _b === void 0 ? void 0 : _b.background; }};
    color: ${({ theme }) => { var _a, _b; return (_b = (_a = theme.button) === null || _a === void 0 ? void 0 : _a.secondary) === null || _b === void 0 ? void 0 : _b.background; }};
  `;
const Outline = (props) => props.variant === 'outline' &&
    Ae `
    border: 1px solid ${({ theme }) => { var _a, _b; return (_b = (_a = theme.button) === null || _a === void 0 ? void 0 : _a.outline) === null || _b === void 0 ? void 0 : _b.borderColor; }};
    background-color: transparent;
    color: ${({ theme }) => { var _a, _b; return (_b = (_a = theme.button) === null || _a === void 0 ? void 0 : _a.outline) === null || _b === void 0 ? void 0 : _b.color; }};
  `;
const Plain = (props) => props.variant === 'plain' &&
    Ae `
    background-color: transparent;
    color: ${({ theme }) => { var _a, _b; return (_b = (_a = theme.button) === null || _a === void 0 ? void 0 : _a.plain) === null || _b === void 0 ? void 0 : _b.color; }};
    display: flex;
    justify-content: center;
    align-items: center;
  `;
const Disable = (props) => (props.isDisabled || props.loading) &&
    Ae `
    background-color: ${({ theme }) => { var _a, _b; return (_b = (_a = theme.button) === null || _a === void 0 ? void 0 : _a.disable) === null || _b === void 0 ? void 0 : _b.background; }};
    border: 1px solid transparent;
    color: ${({ theme }) => { var _a, _b; return (_b = (_a = theme.button) === null || _a === void 0 ? void 0 : _a.disable) === null || _b === void 0 ? void 0 : _b.color; }};
    cursor: auto;
    pointer-events: none;
  `;
const Confirmed = (props) => props.variant === 'confirm' &&
    Ae `
    background-color: ${({ theme }) => { var _a, _b; return curriedLighten(0.5, ((_b = (_a = theme === null || theme === void 0 ? void 0 : theme.button) === null || _a === void 0 ? void 0 : _a.confirmed) === null || _b === void 0 ? void 0 : _b.background) || (theme === null || theme === void 0 ? void 0 : theme.oceanBlue)); }};
    color: ${({ theme }) => { var _a, _b; return (_b = (_a = theme.button) === null || _a === void 0 ? void 0 : _a.confirmed) === null || _b === void 0 ? void 0 : _b.color; }};
    border: 1px solid ${({ theme }) => { var _a, _b; return (_b = (_a = theme.button) === null || _a === void 0 ? void 0 : _a.confirmed) === null || _b === void 0 ? void 0 : _b.borderColor; }};
    opacity: 50%;
    cursor: auto;
  `;
const Root$a = styled.button `
  padding: ${(props) => ((props === null || props === void 0 ? void 0 : props.padding) ? props === null || props === void 0 ? void 0 : props.padding : '0px')};
  width: ${({ width }) => (width ? width : '100%')};
  height: ${({ height }) => (height ? height : '51px')};
  font-weight: 500;
  text-align: center;
  border-radius: ${(props) => { var _a; return (_a = props === null || props === void 0 ? void 0 : props.borderRadius) !== null && _a !== void 0 ? _a : '8px'; }};
  outline: none;
  border: 1px solid transparent;
  color: white;
  text-decoration: none;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;
  position: relative;
  z-index: 1;
  text-decoration: none;
  box-sizing: border-box;

  ${Primary}
  ${Secondary}
  ${Outline}
  ${Plain}
  ${Disable}
  ${Confirmed}

  /* Customizable Colors */
  color: ${({ color, theme }) => (color && theme[color]) || color};
  background-color: ${({ backgroundColor, theme }) => (backgroundColor && theme[backgroundColor]) || backgroundColor};
  border: ${({ borderColor, theme }) => `1px solid ${(borderColor && theme[borderColor]) || borderColor}`};

  > * {
    user-select: none;
  }
`;
const IconAfter = styled.div `
  color: white;
  margin-left: 10px;
`;
const IconBefore = styled.div `
  color: white;
  margin-right: 10px;
`;

const Button = (props) => {
    const { iconBefore, children, iconAfter, loading, loadingText, as, target } = props, rest = __rest$1(props, ["iconBefore", "children", "iconAfter", "loading", "loadingText", "as", "target"]);
    return (jsx(Root$a, Object.assign({}, rest, { as: as, target: target }, { children: loading ? (loadingText || 'Loading...') : (jsxs(Fragment$1, { children: [iconBefore && jsx(IconBefore, { children: iconBefore }, void 0), children, iconAfter && jsx(IconAfter, { children: iconAfter }, void 0)] }, void 0)) }), void 0));
};
Button.defaultProps = {
    target: '_blank',
};

var merge$3 = function merge(a, b) {
  var result = objectAssign({}, a, b);

  for (var key in a) {
    var _assign;

    if (!a[key] || typeof b[key] !== 'object') continue;
    objectAssign(result, (_assign = {}, _assign[key] = objectAssign(a[key], b[key]), _assign));
  }

  return result;
}; // sort object-value responsive styles

var sort = function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
};

var defaults$b = {
  breakpoints: [40, 52, 64].map(function (n) {
    return n + 'em';
  })
};

var createMediaQuery = function createMediaQuery(n) {
  return "@media screen and (min-width: " + n + ")";
};

var getValue$2 = function getValue(n, scale) {
  return get$3(scale, n, n);
};

var get$3 = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var createParser = function createParser(config) {
  var cache = {};

  var parse = function parse(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

    for (var key in props) {
      if (!config[key]) continue;
      var sx = config[key];
      var raw = props[key];
      var scale = get$3(props.theme, sx.scale, sx.defaults);

      if (typeof raw === 'object') {
        cache.breakpoints = !isCacheDisabled && cache.breakpoints || get$3(props.theme, 'breakpoints', defaults$b.breakpoints);

        if (Array.isArray(raw)) {
          cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
          styles = merge$3(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
          continue;
        }

        if (raw !== null) {
          styles = merge$3(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
          shouldSort = true;
        }

        continue;
      }

      objectAssign(styles, sx(raw, scale, props));
    } // sort object-based responsive styles


    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parse.config = config;
  parse.propNames = Object.keys(config);
  parse.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return k !== 'config';
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser;

      parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
    });
  }

  return parse;
};

var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
  var styles = {};
  raw.slice(0, mediaQueries.length).forEach(function (value, i) {
    var media = mediaQueries[i];
    var style = sx(value, scale, _props);

    if (!media) {
      objectAssign(styles, style);
    } else {
      var _assign2;

      objectAssign(styles, (_assign2 = {}, _assign2[media] = objectAssign({}, styles[media], style), _assign2));
    }
  });
  return styles;
};

var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
  var styles = {};

  for (var key in raw) {
    var breakpoint = breakpoints[key];
    var value = raw[key];
    var style = sx(value, scale, _props);

    if (!breakpoint) {
      objectAssign(styles, style);
    } else {
      var _assign3;

      var media = createMediaQuery(breakpoint);
      objectAssign(styles, (_assign3 = {}, _assign3[media] = objectAssign({}, styles[media], style), _assign3));
    }
  }

  return styles;
};

var createStyleFunction = function createStyleFunction(_ref) {
  var properties = _ref.properties,
      property = _ref.property,
      scale = _ref.scale,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? getValue$2 : _ref$transform,
      defaultScale = _ref.defaultScale;
  properties = properties || [property];

  var sx = function sx(value, scale, _props) {
    var result = {};
    var n = transform(value, scale, _props);
    if (n === null) return;
    properties.forEach(function (prop) {
      result[prop] = n;
    });
    return result;
  };

  sx.scale = scale;
  sx.defaults = defaultScale;
  return sx;
}; // new v5 API

var system = function system(args) {
  if (args === void 0) {
    args = {};
  }

  var config = {};
  Object.keys(args).forEach(function (key) {
    var conf = args[key];

    if (conf === true) {
      // shortcut definition
      config[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof conf === 'function') {
      config[key] = conf;
      return;
    }

    config[key] = createStyleFunction(conf);
  });
  var parser = createParser(config);
  return parser;
};
var compose$1 = function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    objectAssign(config, parser.config);
  });
  var parser = createParser(config);
  return parser;
};

var isNumber$7 = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getWidth$1 = function getWidth(n, scale) {
  return get$3(scale, n, !isNumber$7(n) || n > 1 ? n : n * 100 + '%');
};

var config$8 = {
  width: {
    property: 'width',
    scale: 'sizes',
    transform: getWidth$1
  },
  height: {
    property: 'height',
    scale: 'sizes'
  },
  minWidth: {
    property: 'minWidth',
    scale: 'sizes'
  },
  minHeight: {
    property: 'minHeight',
    scale: 'sizes'
  },
  maxWidth: {
    property: 'maxWidth',
    scale: 'sizes'
  },
  maxHeight: {
    property: 'maxHeight',
    scale: 'sizes'
  },
  size: {
    properties: ['width', 'height'],
    scale: 'sizes'
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(config$8);

var config$7 = {
  color: {
    property: 'color',
    scale: 'colors'
  },
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  opacity: true
};
config$7.bg = config$7.backgroundColor;
var color$5 = system(config$7);

var defaults$a = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var config$6 = {
  fontFamily: {
    property: 'fontFamily',
    scale: 'fonts'
  },
  fontSize: {
    property: 'fontSize',
    scale: 'fontSizes',
    defaultScale: defaults$a.fontSizes
  },
  fontWeight: {
    property: 'fontWeight',
    scale: 'fontWeights'
  },
  lineHeight: {
    property: 'lineHeight',
    scale: 'lineHeights'
  },
  letterSpacing: {
    property: 'letterSpacing',
    scale: 'letterSpacings'
  },
  textAlign: true,
  fontStyle: true
};
var typography = system(config$6);

var config$5 = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system(config$5);

var defaults$9 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$4 = {
  gridGap: {
    property: 'gridGap',
    scale: 'space',
    defaultScale: defaults$9.space
  },
  gridColumnGap: {
    property: 'gridColumnGap',
    scale: 'space',
    defaultScale: defaults$9.space
  },
  gridRowGap: {
    property: 'gridRowGap',
    scale: 'space',
    defaultScale: defaults$9.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid = system(config$4);

var config$3 = {
  border: {
    property: 'border',
    scale: 'borders'
  },
  borderWidth: {
    property: 'borderWidth',
    scale: 'borderWidths'
  },
  borderStyle: {
    property: 'borderStyle',
    scale: 'borderStyles'
  },
  borderColor: {
    property: 'borderColor',
    scale: 'colors'
  },
  borderRadius: {
    property: 'borderRadius',
    scale: 'radii'
  },
  borderTop: {
    property: 'borderTop',
    scale: 'borders'
  },
  borderTopLeftRadius: {
    property: 'borderTopLeftRadius',
    scale: 'radii'
  },
  borderTopRightRadius: {
    property: 'borderTopRightRadius',
    scale: 'radii'
  },
  borderRight: {
    property: 'borderRight',
    scale: 'borders'
  },
  borderBottom: {
    property: 'borderBottom',
    scale: 'borders'
  },
  borderBottomLeftRadius: {
    property: 'borderBottomLeftRadius',
    scale: 'radii'
  },
  borderBottomRightRadius: {
    property: 'borderBottomRightRadius',
    scale: 'radii'
  },
  borderLeft: {
    property: 'borderLeft',
    scale: 'borders'
  },
  borderX: {
    properties: ['borderLeft', 'borderRight'],
    scale: 'borders'
  },
  borderY: {
    properties: ['borderTop', 'borderBottom'],
    scale: 'borders'
  }
};
config$3.borderTopWidth = {
  property: 'borderTopWidth',
  scale: 'borderWidths'
};
config$3.borderTopColor = {
  property: 'borderTopColor',
  scale: 'colors'
};
config$3.borderTopStyle = {
  property: 'borderTopStyle',
  scale: 'borderStyles'
};
config$3.borderTopLeftRadius = {
  property: 'borderTopLeftRadius',
  scale: 'radii'
};
config$3.borderTopRightRadius = {
  property: 'borderTopRightRadius',
  scale: 'radii'
};
config$3.borderBottomWidth = {
  property: 'borderBottomWidth',
  scale: 'borderWidths'
};
config$3.borderBottomColor = {
  property: 'borderBottomColor',
  scale: 'colors'
};
config$3.borderBottomStyle = {
  property: 'borderBottomStyle',
  scale: 'borderStyles'
};
config$3.borderBottomLeftRadius = {
  property: 'borderBottomLeftRadius',
  scale: 'radii'
};
config$3.borderBottomRightRadius = {
  property: 'borderBottomRightRadius',
  scale: 'radii'
};
config$3.borderLeftWidth = {
  property: 'borderLeftWidth',
  scale: 'borderWidths'
};
config$3.borderLeftColor = {
  property: 'borderLeftColor',
  scale: 'colors'
};
config$3.borderLeftStyle = {
  property: 'borderLeftStyle',
  scale: 'borderStyles'
};
config$3.borderRightWidth = {
  property: 'borderRightWidth',
  scale: 'borderWidths'
};
config$3.borderRightColor = {
  property: 'borderRightColor',
  scale: 'colors'
};
config$3.borderRightStyle = {
  property: 'borderRightStyle',
  scale: 'borderStyles'
};
var border = system(config$3);

var config$2 = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
config$2.bgImage = config$2.backgroundImage;
config$2.bgSize = config$2.backgroundSize;
config$2.bgPosition = config$2.backgroundPosition;
config$2.bgRepeat = config$2.backgroundRepeat;
var background = system(config$2);

var defaults$8 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$1 = {
  position: true,
  zIndex: {
    property: 'zIndex',
    scale: 'zIndices'
  },
  top: {
    property: 'top',
    scale: 'space',
    defaultScale: defaults$8.space
  },
  right: {
    property: 'right',
    scale: 'space',
    defaultScale: defaults$8.space
  },
  bottom: {
    property: 'bottom',
    scale: 'space',
    defaultScale: defaults$8.space
  },
  left: {
    property: 'left',
    scale: 'space',
    defaultScale: defaults$8.space
  }
};
var position$1 = system(config$1);

var defaults$7 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

var isNumber$6 = function isNumber(n) {
  return typeof n === 'number' && !isNaN(n);
};

var getMargin = function getMargin(n, scale) {
  if (!isNumber$6(n)) {
    return get$3(scale, n, n);
  }

  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get$3(scale, absolute, absolute);

  if (!isNumber$6(value)) {
    return isNegative ? '-' + value : value;
  }

  return value * (isNegative ? -1 : 1);
};

var configs = {};
configs.margin = {
  margin: {
    property: 'margin',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$7.space
  },
  marginTop: {
    property: 'marginTop',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$7.space
  },
  marginRight: {
    property: 'marginRight',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$7.space
  },
  marginBottom: {
    property: 'marginBottom',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$7.space
  },
  marginLeft: {
    property: 'marginLeft',
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$7.space
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$7.space
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'space',
    transform: getMargin,
    defaultScale: defaults$7.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: 'padding',
    scale: 'space',
    defaultScale: defaults$7.space
  },
  paddingTop: {
    property: 'paddingTop',
    scale: 'space',
    defaultScale: defaults$7.space
  },
  paddingRight: {
    property: 'paddingRight',
    scale: 'space',
    defaultScale: defaults$7.space
  },
  paddingBottom: {
    property: 'paddingBottom',
    scale: 'space',
    defaultScale: defaults$7.space
  },
  paddingLeft: {
    property: 'paddingLeft',
    scale: 'space',
    defaultScale: defaults$7.space
  },
  paddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'space',
    defaultScale: defaults$7.space
  },
  paddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'space',
    defaultScale: defaults$7.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding$1 = system(configs.padding);
var space$1 = compose$1(margin, padding$1);

system({
  boxShadow: {
    property: 'boxShadow',
    scale: 'shadows'
  },
  textShadow: {
    property: 'textShadow',
    scale: 'shadows'
  }
});

function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

// based on https://github.com/developit/dlv
var get$2 = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split('.') : [key];

  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }

  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function (n) {
  return n + 'em';
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: 'backgroundColor',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  mx: 'marginX',
  my: 'marginY',
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  px: 'paddingX',
  py: 'paddingY'
};
var multiples = {
  marginX: ['marginLeft', 'marginRight'],
  marginY: ['marginTop', 'marginBottom'],
  paddingX: ['paddingLeft', 'paddingRight'],
  paddingY: ['paddingTop', 'paddingBottom'],
  size: ['width', 'height']
};
var scales = {
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  margin: 'space',
  marginTop: 'space',
  marginRight: 'space',
  marginBottom: 'space',
  marginLeft: 'space',
  marginX: 'space',
  marginY: 'space',
  padding: 'space',
  paddingTop: 'space',
  paddingRight: 'space',
  paddingBottom: 'space',
  paddingLeft: 'space',
  paddingX: 'space',
  paddingY: 'space',
  top: 'space',
  right: 'space',
  bottom: 'space',
  left: 'space',
  gridGap: 'space',
  gridColumnGap: 'space',
  gridRowGap: 'space',
  gap: 'space',
  columnGap: 'space',
  rowGap: 'space',
  fontFamily: 'fonts',
  fontSize: 'fontSizes',
  fontWeight: 'fontWeights',
  lineHeight: 'lineHeights',
  letterSpacing: 'letterSpacings',
  border: 'borders',
  borderTop: 'borders',
  borderRight: 'borders',
  borderBottom: 'borders',
  borderLeft: 'borders',
  borderWidth: 'borderWidths',
  borderStyle: 'borderStyles',
  borderRadius: 'radii',
  borderTopRightRadius: 'radii',
  borderTopLeftRadius: 'radii',
  borderBottomRightRadius: 'radii',
  borderBottomLeftRadius: 'radii',
  borderTopWidth: 'borderWidths',
  borderTopColor: 'colors',
  borderTopStyle: 'borderStyles',
  borderBottomWidth: 'borderWidths',
  borderBottomColor: 'colors',
  borderBottomStyle: 'borderStyles',
  borderLeftWidth: 'borderWidths',
  borderLeftColor: 'colors',
  borderLeftStyle: 'borderStyles',
  borderRightWidth: 'borderWidths',
  borderRightColor: 'colors',
  borderRightStyle: 'borderStyles',
  outlineColor: 'colors',
  boxShadow: 'shadows',
  textShadow: 'shadows',
  zIndex: 'zIndices',
  width: 'sizes',
  minWidth: 'sizes',
  maxWidth: 'sizes',
  height: 'sizes',
  minHeight: 'sizes',
  maxHeight: 'sizes',
  flexBasis: 'sizes',
  size: 'sizes',
  // svg
  fill: 'colors',
  stroke: 'colors'
};

var positiveOrNegative = function positiveOrNegative(scale, value) {
  if (typeof value !== 'number' || value >= 0) {
    return get$2(scale, value, value);
  }

  var absolute = Math.abs(value);
  var n = get$2(scale, absolute, absolute);
  if (typeof n === 'string') return '-' + n;
  return n * -1;
};

var transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
  var _extends2;

  return _extends$I({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive(styles) {
  return function (theme) {
    var next = {};
    var breakpoints = get$2(theme, 'breakpoints', defaultBreakpoints);
    var mediaQueries = [null].concat(breakpoints.map(function (n) {
      return "@media screen and (min-width: " + n + ")";
    }));

    for (var key in styles) {
      var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
      if (value == null) continue;

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        var media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };
};
var css = function css(args) {
  return function (props) {
    if (props === void 0) {
      props = {};
    }

    var theme = _extends$I({}, defaultTheme, {}, props.theme || props);

    var result = {};
    var obj = typeof args === 'function' ? args(theme) : args;
    var styles = responsive(obj)(theme);

    for (var key in styles) {
      var x = styles[key];
      var val = typeof x === 'function' ? x(theme) : x;

      if (key === 'variant') {
        var variant = css(get$2(theme, val))(theme);
        result = _extends$I({}, result, {}, variant);
        continue;
      }

      if (val && typeof val === 'object') {
        result[key] = css(val)(theme);
        continue;
      }

      var prop = get$2(aliases, key, key);
      var scaleName = get$2(scales, prop);
      var scale = get$2(theme, scaleName, get$2(theme, prop, {}));
      var transform = get$2(transforms, prop, get$2);
      var value = transform(scale, val, val);

      if (multiples[prop]) {
        var dirs = multiples[prop];

        for (var i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };
};
var css$1 = css;

var variant = function variant(_ref) {
  var _config;

  var scale = _ref.scale,
      _ref$prop = _ref.prop,
      prop = _ref$prop === void 0 ? 'variant' : _ref$prop,
      _ref$variants = _ref.variants,
      variants = _ref$variants === void 0 ? {} : _ref$variants,
      key = _ref.key;
  var sx;

  if (Object.keys(variants).length) {
    sx = function sx(value, scale, props) {
      return css$1(get$3(scale, value, null))(props.theme);
    };
  } else {
    sx = function sx(value, scale) {
      return get$3(scale, value, null);
    };
  }

  sx.scale = scale || key;
  sx.defaults = variants;
  var config = (_config = {}, _config[prop] = sx, _config);
  var parser = createParser(config);
  return parser;
};
variant({
  key: 'buttons'
});
variant({
  key: 'textStyles',
  prop: 'textStyle'
});
variant({
  key: 'colorStyles',
  prop: 'colors'
});

layout.width;
    layout.height;
    layout.minWidth;
    layout.minHeight;
    layout.maxWidth;
    layout.maxHeight;
    layout.size;
    layout.verticalAlign;
    layout.display;
    layout.overflow;
    layout.overflowX;
    layout.overflowY;
color$5.opacity;
typography.fontSize;
    typography.fontFamily;
    typography.fontWeight;
    typography.lineHeight;
    typography.textAlign;
    typography.fontStyle;
    typography.letterSpacing;
flexbox.alignItems;
    flexbox.alignContent;
    flexbox.justifyItems;
    flexbox.justifyContent;
    flexbox.flexWrap;
    flexbox.flexDirection;
    flexbox.flex;
    flexbox.flexGrow;
    flexbox.flexShrink;
    flexbox.flexBasis;
    flexbox.justifySelf;
    flexbox.alignSelf;
    flexbox.order;
grid.gridGap;
    grid.gridColumnGap;
    grid.gridRowGap;
    grid.gridColumn;
    grid.gridRow;
    grid.gridAutoFlow;
    grid.gridAutoColumns;
    grid.gridAutoRows;
    grid.gridTemplateColumns;
    grid.gridTemplateRows;
    grid.gridTemplateAreas;
    grid.gridArea;
border.borderWidth;
    border.borderStyle;
    border.borderColor;
    border.borderTop;
    border.borderRight;
    border.borderBottom;
    border.borderLeft;
    border.borderRadius;
background.backgroundImage;
    background.backgroundSize;
    background.backgroundPosition;
    background.backgroundRepeat;
position$1.zIndex;
    position$1.top;
    position$1.right;
    position$1.bottom;
    position$1.left;

//TODO: set appropriate type
const Box = styled.div `
  color: ${({ color, theme }) => (color ? theme[color] : 'black')};
  background-color: ${({ bgColor, theme }) => (bgColor ? theme[bgColor] : 'transparent')};
  ${space$1}
  ${layout}
  ${flexbox}
  ${typography}
  ${border}
  ${position$1}
`;

const Text$1 = styled.div `
  ${space$1}
  ${typography}
  ${position$1}
  color: ${({ color, theme }) => color && theme[color]};
  cursor: ${(props) => props.cursor && props.cursor};
`;

const InputWrapper = styled(Box) `
  width: 100%;
  border-radius: 8px;
  padding: 10px;
  border: 1px solid transparent;
  display: flex;
  position: relative;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.bg6};
  color: ${({ theme }) => theme.text4};
`;
const StyledInput = styled.input `
  flex: 1;
  border: 1px solid transparent;
  font-size: ${(props) => ((props === null || props === void 0 ? void 0 : props.fontSize) ? `${props === null || props === void 0 ? void 0 : props.fontSize}px` : '18px')};
  background-color: ${({ theme }) => theme.bg6};
  color: ${({ theme }) => theme.text4};
  outline: none;
  width: 100%;
  padding: 0;
`;
const AddonAfter = styled(Box) `
  position: relative;
`;
const AddonBefore = styled(Box) `
  position: relative;
`;
const ErrorText = styled(Text$1) `
  margin-top: 5px;
  color: ${({ theme }) => theme.red2};
  font-size: 12px;
`;

const TextInput = (props) => {
    const { label, addonLabel, addonAfter, addonBefore, error, showErrorMessage = true, onChange, isNumeric, getRef = () => { } } = props, rest = __rest$1(props, ["label", "addonLabel", "addonAfter", "addonBefore", "error", "showErrorMessage", "onChange", "isNumeric", "getRef"]);
    const inputRegex = new RegExp(`^\\d+\\.?\\d*$`);
    return (jsxs(Box, { children: [jsxs(Box, Object.assign({ display: "flex", justifyContent: label ? 'space-between' : 'flex-end' }, { children: [label && jsx(Text$1, Object.assign({ color: "text4" }, { children: label }), void 0), addonLabel && addonLabel] }), void 0), jsxs(InputWrapper, { children: [addonBefore && jsx(AddonBefore, { children: addonBefore }, void 0), jsx(StyledInput, Object.assign({}, rest, { ref: (ref) => getRef(ref), onChange: (e) => {
                            const value = e.target.value;
                            if (isNumeric && !!value) {
                                if (inputRegex.test(value)) {
                                    onChange && onChange(value);
                                }
                            }
                            else {
                                onChange && onChange(value);
                            }
                        } }), void 0), addonAfter && jsx(AddonAfter, { children: addonAfter }, void 0)] }, void 0), showErrorMessage && !!error && jsx(ErrorText, { children: error }, void 0)] }, void 0));
};

const StepWrapper = styled('div') `
  margin-top: auto;
  display: flex;
  justify-content: space-between;
`;
const StepItem = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'none' : 'pointer')};

  @media (max-width: 768px) {
    font-size: 12px;
  }
  &:before {
    position: absolute;
    content: '';
    border-bottom: ${({ theme }) => `2px solid ${theme.bg5}`};
    width: 100%;
    top: ${({ progressDot }) => (progressDot ? '21px' : '15px')};
    left: ${({ progressDot }) => (progressDot ? '-50%' : '-38%')};
    z-index: 2;
  }
  &:after {
    position: absolute;
    content: '';
    border-bottom: 2px solid;
    border-bottom-color: ${({ completed, theme }) => (completed ? theme.primary : theme.bg5)};
    width: 100%;
    top: ${({ progressDot }) => (progressDot ? '21px' : '15px')};
    left: ${({ progressDot }) => (progressDot ? '50%' : '38%')};
    z-index: ${({ completed }) => (completed ? 3 : 2)};
  }
  &:first-child:before {
    content: none;
  }
  &:last-child::after {
    content: none;
  }
`;
const StepCounter = styled.div `
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${({ completed, active, theme }) => (completed || active ? theme.primary : theme.bg5)};
  color: ${({ completed, active, theme }) => (completed || active ? theme.text6 : theme.white)};
  margin-bottom: 6px;
`;
const StepName = styled('div') `
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.text4};
`;
const IconDot = styled.div `
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ completed, active, theme }) => (completed || active ? theme.primary : theme.bg5)};
  margin-top: 17px;
`;

const Step$1 = (props) => {
    const { active, completed, stepNumber, disabled, title, progressDot, stepIndex, onStepClick } = props;
    const renderIconNode = () => {
        let iconNode;
        if (progressDot) {
            iconNode = jsx(IconDot, { completed: completed, active: active }, void 0);
        }
        else {
            iconNode = (jsx(StepCounter, Object.assign({ completed: completed, active: active }, { children: stepNumber }), void 0));
        }
        return iconNode;
    };
    const onClick = () => {
        onStepClick && onStepClick(stepIndex || 0);
    };
    return (jsxs(StepItem, Object.assign({ completed: completed, active: active, onClick: onClick, disabled: disabled, progressDot: progressDot }, { children: [renderIconNode(), active && jsxs(StepName, { children: [" ", title] }, void 0)] }), void 0));
};

const toChildrenArray = (children, option = {}) => {
    let ret = [];
    React$2.Children.forEach(children, (child) => {
        if ((child === undefined || child === null) && !option.keepEmpty) {
            return;
        }
        if (Array.isArray(child)) {
            ret = ret.concat(toChildrenArray(child));
        }
        else if (reactIs$7.exports.isFragment(child) && child.props) {
            ret = ret.concat(toChildrenArray(child.props.children, option));
        }
        else {
            ret.push(child);
        }
    });
    return ret;
};

const Steps = (props) => {
    const { children, current = 0, progressDot = false, onChange, allowChangeOnClick = true } = props;
    const onStepClick = (next) => {
        if (onChange && current !== next && allowChangeOnClick) {
            onChange(next);
        }
    };
    return (jsx(StepWrapper, { children: toChildrenArray(children).map((child, index) => {
            const stepNumber = index;
            const childProps = Object.assign({ stepNumber: `${stepNumber + 1}`, stepIndex: stepNumber, key: stepNumber, progressDot, onStepClick: onChange && onStepClick, active: stepNumber === current, completed: stepNumber < (current || 0) }, child.props);
            return cloneElement(child, childProps);
        }) }, void 0));
};

const Root$9 = styled.div `
  flex-direction: row;
  align-items: center;
  display: flex;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : '')};
`;
const OuterSquare = styled.div `
  width: ${(props) => `${props === null || props === void 0 ? void 0 : props.size}px`};
  height: ${(props) => `${props === null || props === void 0 ? void 0 : props.size}px`};
  border: 1px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.bg4};
  border-color: ${({ theme }) => theme.bg4};
  transition: all ease-in 0.2s;
`;
const InnerSquare = styled.div `
  width: ${(props) => `${(props === null || props === void 0 ? void 0 : props.size) / 2}px`};
  height: ${(props) => `${(props === null || props === void 0 ? void 0 : props.size) / 2}px`};
  background-color: ${({ theme, selected }) => (selected ? theme.bg5 : theme.bg4)};
`;
const Label$2 = styled(Text$1) `
  margin-left: 10px;
  font-size: 14px;
  font-weight: 300;
`;

const Checkbox = (props) => {
    const { value, label, onChange, disabled, size, checked } = props;
    const [internalChekced, setInternalChecked] = useState(checked);
    useEffect(() => {
        setInternalChecked(checked);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checked]);
    return (jsxs(Root$9, Object.assign({ disabled: disabled, onClick: () => {
            onChange && onChange(!internalChekced, value);
            setInternalChecked((prev) => !prev);
        } }, { children: [jsx(OuterSquare, Object.assign({ size: size }, { children: jsx(InnerSquare, { selected: internalChekced, size: size }, void 0) }), void 0), Boolean(label) && jsx(Label$2, Object.assign({ color: "text1" }, { children: label }), void 0)] }), void 0));
};
Checkbox.defaultProps = {
    size: 15,
};

const Root$8 = styled.div `
  flex-direction: ${(props) => ((props === null || props === void 0 ? void 0 : props.type) === 'horizontal' ? 'row' : 'column')};
  display: flex;
`;

const CheckboxGroup = (props) => {
    const { value, onChange, options, type } = props, rest = __rest$1(props, ["value", "onChange", "options", "type"]);
    const [selected, setSelected] = useState([]);
    const handleOnChange = (isChecked, checkValue) => {
        var _a;
        const index = selected === null || selected === void 0 ? void 0 : selected.indexOf(checkValue);
        const newValues = [...selected];
        if (isChecked) {
            (_a = (newValues || [])) === null || _a === void 0 ? void 0 : _a.push(checkValue);
        }
        else {
            (newValues || []).splice(index, 1);
        }
        setSelected(newValues);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValues);
    };
    useEffect(() => {
        if (value) {
            setSelected(value);
        }
    }, [value]);
    return (jsx(Root$8, Object.assign({ type: type }, { children: (options || []).map((option, i) => (jsx(Box, Object.assign({ ml: type === 'horizontal' ? '5px' : '0px' }, { children: jsx(Checkbox, Object.assign({ value: option.value, label: option.label, onChange: (checked, someValue) => {
                    handleOnChange(checked, someValue);
                }, checked: (selected === null || selected === void 0 ? void 0 : selected.indexOf(option.value)) > -1 ? true : false }, rest), void 0) }), i))) }), void 0));
};

const Root$7 = styled.div `
  flex-direction: row;
  align-items: center;
  display: flex;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : '')};
`;
const OuterCircle = styled.div `
  width: ${(props) => `${props === null || props === void 0 ? void 0 : props.size}px`};
  height: ${(props) => `${props === null || props === void 0 ? void 0 : props.size}px`};
  border-radius: 50%;
  border: 1px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.bg4};
  border-color: ${({ theme }) => theme.bg4};
  transition: all ease-in 0.2s;
`;
const InnerCircle = styled.div `
  width: ${(props) => `${(props === null || props === void 0 ? void 0 : props.size) / 2}px`};
  height: ${(props) => `${(props === null || props === void 0 ? void 0 : props.size) / 2}px`};
  border-radius: 50%;
  background-color: ${({ theme, selected }) => (selected ? theme.bg5 : theme.bg4)};
`;
const Label$1 = styled(Text$1) `
  margin-left: 10px;
  font-size: 14px;
  font-weight: 300;
`;

const RadioButton = (props) => {
    const { value, label, onChange, disabled, size, checked } = props;
    return (jsxs(Root$7, Object.assign({ disabled: disabled, onClick: () => {
            onChange && onChange(value);
        } }, { children: [jsx(OuterCircle, Object.assign({ size: size }, { children: jsx(InnerCircle, { selected: checked, size: size }, void 0) }), void 0), Boolean(label) && jsx(Label$1, { children: label }, void 0)] }), void 0));
};
RadioButton.defaultProps = {
    size: 15,
};

const Root$6 = styled.div `
  flex-direction: ${(props) => ((props === null || props === void 0 ? void 0 : props.type) === 'horizontal' ? 'row' : 'column')};
  display: flex;
`;

const RadioButtonGroup = (props) => {
    const { value, onChange, options, type } = props, rest = __rest$1(props, ["value", "onChange", "options", "type"]);
    const [selected, setSelected] = useState('');
    useEffect(() => {
        setSelected(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    return (jsx(Root$6, Object.assign({ type: type }, { children: (options || []).map((option, i) => (jsx(Box, Object.assign({ ml: type === 'horizontal' ? '5px' : '0px' }, { children: jsx(RadioButton, Object.assign({ checked: selected === option.value, value: option.value, label: option.label, onChange: () => {
                    onChange && onChange(option.value);
                    setSelected(option.value);
                } }, rest), void 0) }), i))) }), void 0));
};

var toStr$9 = Object.prototype.toString;

var isArguments$6 = function isArguments(value) {
	var str = toStr$9.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr$9.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

var keysShim$1;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has$b = Object.prototype.hasOwnProperty;
	var toStr$8 = Object.prototype.toString;
	var isArgs$1 = isArguments$6; // eslint-disable-line global-require
	var isEnumerable$1 = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable$1.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable$1.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has$b.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim$1 = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr$8.call(object) === '[object Function]';
		var isArguments = isArgs$1(object);
		var isString = isObject && toStr$8.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has$b.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has$b.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has$b.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
var implementation$b = keysShim$1;

var slice$1 = Array.prototype.slice;
var isArgs = isArguments$6;

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : implementation$b;

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice$1.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

var objectKeys$1 = keysShim;

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams$1 = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var hasSymbols$6 = shams$1;

var shams = function hasToStringTagShams() {
	return hasSymbols$6() && !!Symbol.toStringTag;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = shams$1;

var hasSymbols$5 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr$7 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$a = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$7.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var implementation$9 = implementation$a;

var functionBind = Function.prototype.bind || implementation$9;

var bind$4 = functionBind;

var src$8 = bind$4.call(Function.call, Object.prototype.hasOwnProperty);

var undefined$1;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$1 = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD$2 = Object.getOwnPropertyDescriptor;
if ($gOPD$2) {
	try {
		$gOPD$2({}, '');
	} catch (e) {
		$gOPD$2 = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError$1();
};
var ThrowTypeError = $gOPD$2
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD$2(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols$4 = hasSymbols$5();

var getProto$1 = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto$1(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols$4 ? getProto$1([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$4 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$4 ? undefined$1 : getProto$1(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$4 ? undefined$1 : getProto$1(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$4 ? getProto$1(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols$4 ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError$1,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto$1(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind$3 = functionBind;
var hasOwn$4 = src$8;
var $concat$1 = bind$3.call(Function.call, Array.prototype.concat);
var $spliceApply = bind$3.call(Function.apply, Array.prototype.splice);
var $replace$1 = bind$3.call(Function.call, String.prototype.replace);
var $strSlice = bind$3.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName$1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar$1 = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath$2 = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace$1(string, rePropName$1, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$1(subString, reEscapeChar$1, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn$4(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn$4(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$1('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$1('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$1('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath$2(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat$1([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn$4(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError$1('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD$2 && (i + 1) >= parts.length) {
				var desc = $gOPD$2(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn$4(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var callBind$4 = {exports: {}};

(function (module) {

var bind = functionBind;
var GetIntrinsic = getIntrinsic;

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
}(callBind$4));

var GetIntrinsic$4 = getIntrinsic;

var callBind$3 = callBind$4.exports;

var $indexOf$1 = callBind$3(GetIntrinsic$4('String.prototype.indexOf'));

var callBound$8 = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic$4(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf$1(name, '.prototype.') > -1) {
		return callBind$3(intrinsic);
	}
	return intrinsic;
};

var hasToStringTag$7 = shams();
var callBound$7 = callBound$8;

var $toString$4 = callBound$7('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag$7 && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString$4(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString$4(value) !== '[object Array]' &&
		$toString$4(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

var isArguments$5 = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

var GetIntrinsic$3 = getIntrinsic;

var $defineProperty = GetIntrinsic$3('%Object.defineProperty%', true);

var hasPropertyDescriptors$1 = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors$1.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors$1()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

var hasPropertyDescriptors_1 = hasPropertyDescriptors$1;

var keys$8 = objectKeys$1;
var hasSymbols$3 = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr$6 = Object.prototype.toString;
var concat$5 = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction$6 = function (fn) {
	return typeof fn === 'function' && toStr$6.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = hasPropertyDescriptors_1();

var supportsDescriptors$2 = origDefineProperty && hasPropertyDescriptors;

var defineProperty$5 = function (object, name, value, predicate) {
	if (name in object && (!isFunction$6(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors$2) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties$1 = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys$8(map);
	if (hasSymbols$3) {
		props = concat$5.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty$5(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties$1.supportsDescriptors = !!supportsDescriptors$2;

var defineProperties_1 = defineProperties$1;

var numberIsNaN = function (value) {
	return value !== value;
};

var implementation$8 = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};

var implementation$7 = implementation$8;

var polyfill$4 = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation$7;
};

var getPolyfill$5 = polyfill$4;
var define$4 = defineProperties_1;

var shim$5 = function shimObjectIs() {
	var polyfill = getPolyfill$5();
	define$4(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};

var define$3 = defineProperties_1;
var callBind$2 = callBind$4.exports;

var implementation$6 = implementation$8;
var getPolyfill$4 = polyfill$4;
var shim$4 = shim$5;

var polyfill$3 = callBind$2(getPolyfill$4(), Object);

define$3(polyfill$3, {
	getPolyfill: getPolyfill$4,
	implementation: implementation$6,
	shim: shim$4
});

var objectIs = polyfill$3;

var callBound$6 = callBound$8;
var hasToStringTag$6 = shams();
var has$a;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag$6) {
	has$a = callBound$6('Object.prototype.hasOwnProperty');
	$exec = callBound$6('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString$3 = callBound$6('Object.prototype.toString');
var gOPD$5 = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

var isRegex$1 = hasToStringTag$6
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD$5(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has$a(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString$3(value) === regexClass;
	};

var implementation$5 = {exports: {}};

var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD$4 = Object.getOwnPropertyDescriptor;
if (gOPD$4) {
	try {
		gOPD$4([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD$4 = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	return functionsHaveNames() && gOPD$4 && !!gOPD$4(function () {}, 'name').configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

var functionsHaveNames_1 = functionsHaveNames;

(function (module) {

var functionsHaveConfigurableNames = functionsHaveNames_1.functionsHaveConfigurableNames();

var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};

if (functionsHaveConfigurableNames && Object.defineProperty) {
	Object.defineProperty(module.exports, 'name', { value: 'get flags' });
}
}(implementation$5));

var implementation$4 = implementation$5.exports;

var supportsDescriptors$1 = defineProperties_1.supportsDescriptors;
var $gOPD$1 = Object.getOwnPropertyDescriptor;

var polyfill$2 = function getPolyfill() {
	if (supportsDescriptors$1 && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD$1(RegExp.prototype, 'flags');
		if (
			descriptor
			&& typeof descriptor.get === 'function'
			&& typeof RegExp.prototype.dotAll === 'boolean'
			&& typeof RegExp.prototype.hasIndices === 'boolean'
		) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function () {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function () {
					calls += 'y';
				}
			});
			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation$4;
};

var supportsDescriptors = defineProperties_1.supportsDescriptors;
var getPolyfill$3 = polyfill$2;
var gOPD$3 = Object.getOwnPropertyDescriptor;
var defineProperty$4 = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex$1 = /a/;

var shim$3 = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill$3();
	var proto = getProto(regex$1);
	var descriptor = gOPD$3(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty$4(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};

var define$2 = defineProperties_1;
var callBind$1 = callBind$4.exports;

var implementation$3 = implementation$5.exports;
var getPolyfill$2 = polyfill$2;
var shim$2 = shim$3;

var flagsBound = callBind$1(getPolyfill$2());

define$2(flagsBound, {
	getPolyfill: getPolyfill$2,
	implementation: implementation$3,
	shim: shim$2
});

var regexp_prototype_flags = flagsBound;

var toString$c = {}.toString;

var isarray = Array.isArray || function (arr) {
  return toString$c.call(arr) == '[object Array]';
};

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr$5 = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag$5 = shams();

var isDateObject = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag$5 ? tryDateObject(value) : toStr$5.call(value) === dateClass;
};

var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
	try {
		strValue.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr$4 = Object.prototype.toString;
var strClass = '[object String]';
var hasToStringTag$4 = shams();

var isString$5 = function isString(value) {
	if (typeof value === 'string') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag$4 ? tryStringObject(value) : toStr$4.call(value) === strClass;
};

var numToStr = Number.prototype.toString;
var tryNumberObject = function tryNumberObject(value) {
	try {
		numToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr$3 = Object.prototype.toString;
var numClass = '[object Number]';
var hasToStringTag$3 = shams();

var isNumberObject = function isNumberObject(value) {
	if (typeof value === 'number') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag$3 ? tryNumberObject(value) : toStr$3.call(value) === numClass;
};

var callBound$5 = callBound$8;
var $boolToStr = callBound$5('Boolean.prototype.toString');
var $toString$2 = callBound$5('Object.prototype.toString');

var tryBooleanObject = function booleanBrandCheck(value) {
	try {
		$boolToStr(value);
		return true;
	} catch (e) {
		return false;
	}
};
var boolClass = '[object Boolean]';
var hasToStringTag$2 = shams();

var isBooleanObject = function isBoolean(value) {
	if (typeof value === 'boolean') {
		return true;
	}
	if (value === null || typeof value !== 'object') {
		return false;
	}
	return hasToStringTag$2 && Symbol.toStringTag in value ? tryBooleanObject(value) : $toString$2(value) === boolClass;
};

var isSymbol$a = {exports: {}};

var toStr$2 = Object.prototype.toString;
var hasSymbols$2 = hasSymbols$5();

if (hasSymbols$2) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	isSymbol$a.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr$2.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	isSymbol$a.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false ;
	};
}

var isBigint = {exports: {}};

var $BigInt = typeof BigInt !== 'undefined' && BigInt;

var hasBigints = function hasNativeBigInts() {
	return typeof $BigInt === 'function'
		&& typeof BigInt === 'function'
		&& typeof $BigInt(42) === 'bigint' // eslint-disable-line no-magic-numbers
		&& typeof BigInt(42) === 'bigint'; // eslint-disable-line no-magic-numbers
};

var hasBigInts = hasBigints();

if (hasBigInts) {
	var bigIntValueOf$1 = BigInt.prototype.valueOf;
	var tryBigInt = function tryBigIntObject(value) {
		try {
			bigIntValueOf$1.call(value);
			return true;
		} catch (e) {
		}
		return false;
	};

	isBigint.exports = function isBigInt(value) {
		if (
			value === null
			|| typeof value === 'undefined'
			|| typeof value === 'boolean'
			|| typeof value === 'string'
			|| typeof value === 'number'
			|| typeof value === 'symbol'
			|| typeof value === 'function'
		) {
			return false;
		}
		if (typeof value === 'bigint') {
			return true;
		}

		return tryBigInt(value);
	};
} else {
	isBigint.exports = function isBigInt(value) {
		return false ;
	};
}

var isString$4 = isString$5;
var isNumber$5 = isNumberObject;
var isBoolean$2 = isBooleanObject;
var isSymbol$9 = isSymbol$a.exports;
var isBigInt$1 = isBigint.exports;

// eslint-disable-next-line consistent-return
var whichBoxedPrimitive$1 = function whichBoxedPrimitive(value) {
	// eslint-disable-next-line eqeqeq
	if (value == null || (typeof value !== 'object' && typeof value !== 'function')) {
		return null;
	}
	if (isString$4(value)) {
		return 'String';
	}
	if (isNumber$5(value)) {
		return 'Number';
	}
	if (isBoolean$2(value)) {
		return 'Boolean';
	}
	if (isSymbol$9(value)) {
		return 'Symbol';
	}
	if (isBigInt$1(value)) {
		return 'BigInt';
	}
};

var $Map$2 = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set$2 = typeof Set === 'function' && Set.prototype ? Set : null;

var exported$3;

if (!$Map$2) {
	// eslint-disable-next-line no-unused-vars
	exported$3 = function isMap(x) {
		// `Map` is not present in this environment.
		return false;
	};
}

var $mapHas$5 = $Map$2 ? Map.prototype.has : null;
var $setHas$4 = $Set$2 ? Set.prototype.has : null;
if (!exported$3 && !$mapHas$5) {
	// eslint-disable-next-line no-unused-vars
	exported$3 = function isMap(x) {
		// `Map` does not have a `has` method
		return false;
	};
}

var isMap$2 = exported$3 || function isMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas$5.call(x);
		if ($setHas$4) {
			try {
				$setHas$4.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Map$2; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};

var $Map$1 = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set$1 = typeof Set === 'function' && Set.prototype ? Set : null;

var exported$2;

if (!$Set$1) {
	// eslint-disable-next-line no-unused-vars
	exported$2 = function isSet(x) {
		// `Set` is not present in this environment.
		return false;
	};
}

var $mapHas$4 = $Map$1 ? Map.prototype.has : null;
var $setHas$3 = $Set$1 ? Set.prototype.has : null;
if (!exported$2 && !$setHas$3) {
	// eslint-disable-next-line no-unused-vars
	exported$2 = function isSet(x) {
		// `Set` does not have a `has` method
		return false;
	};
}

var isSet$2 = exported$2 || function isSet(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$setHas$3.call(x);
		if ($mapHas$4) {
			try {
				$mapHas$4.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Set$1; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};

var $WeakMap$2 = typeof WeakMap === 'function' && WeakMap.prototype ? WeakMap : null;
var $WeakSet$1 = typeof WeakSet === 'function' && WeakSet.prototype ? WeakSet : null;

var exported$1;

if (!$WeakMap$2) {
	// eslint-disable-next-line no-unused-vars
	exported$1 = function isWeakMap(x) {
		// `WeakMap` is not present in this environment.
		return false;
	};
}

var $mapHas$3 = $WeakMap$2 ? $WeakMap$2.prototype.has : null;
var $setHas$2 = $WeakSet$1 ? $WeakSet$1.prototype.has : null;
if (!exported$1 && !$mapHas$3) {
	// eslint-disable-next-line no-unused-vars
	exported$1 = function isWeakMap(x) {
		// `WeakMap` does not have a `has` method
		return false;
	};
}

var isWeakmap = exported$1 || function isWeakMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas$3.call(x, $mapHas$3);
		if ($setHas$2) {
			try {
				$setHas$2.call(x, $setHas$2);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $WeakMap$2; // core-js workaround, pre-v3
	} catch (e) {}
	return false;
};

var $WeakMap$1 = typeof WeakMap === 'function' && WeakMap.prototype ? WeakMap : null;
var $WeakSet = typeof WeakSet === 'function' && WeakSet.prototype ? WeakSet : null;

var exported;

if (!$WeakMap$1) {
	// eslint-disable-next-line no-unused-vars
	exported = function isWeakSet(x) {
		// `WeakSet` is not present in this environment.
		return false;
	};
}

var $mapHas$2 = $WeakMap$1 ? $WeakMap$1.prototype.has : null;
var $setHas$1 = $WeakSet ? $WeakSet.prototype.has : null;
if (!exported && !$setHas$1) {
	// eslint-disable-next-line no-unused-vars
	isWeakset = function isWeakSet(x) {
		// `WeakSet` does not have a `has` method
		return false;
	};
}

var isWeakset = exported || function isWeakSet(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$setHas$1.call(x, $setHas$1);
		if ($mapHas$2) {
			try {
				$mapHas$2.call(x, $mapHas$2);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $WeakSet; // core-js workaround, pre-v3
	} catch (e) {}
	return false;
};

var isMap$1 = isMap$2;
var isSet$1 = isSet$2;
var isWeakMap$1 = isWeakmap;
var isWeakSet$1 = isWeakset;

var whichCollection$1 = function whichCollection(value) {
	if (value && typeof value === 'object') {
		if (isMap$1(value)) {
			return 'Map';
		}
		if (isSet$1(value)) {
			return 'Set';
		}
		if (isWeakMap$1(value)) {
			return 'WeakMap';
		}
		if (isWeakSet$1(value)) {
			return 'WeakSet';
		}
	}
	return false;
};

// this should only run in node >= 13.2, so it
// does not need any of the intense fallbacks that old node/browsers do

var $iterator = Symbol.iterator;
var node = function getIterator(iterable) {
	// alternatively, `iterable[$iterator]?.()`
	if (iterable != null && typeof iterable[$iterator] !== 'undefined') {
		return iterable[$iterator]();
	}
};

var util_inspect = require$$0.inspect;

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString$3 = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice$2 = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO$1 = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice$2.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var inspectCustom = util_inspect.custom;
var inspectSymbol = inspectCustom && isSymbol$8(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$9(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$9(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$9(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$9(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has$9(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray$n(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$9(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol$8(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray$n(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if ('cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber$4(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean$1(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString$3(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate$2(obj) && !isRegExp$1(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO$1 ? gPO$1(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice$2.call(toStr$1(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray$n(obj) { return toStr$1(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate$2(obj) { return toStr$1(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp$1(obj) { return toStr$1(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr$1(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString$3(obj) { return toStr$1(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber$4(obj) { return toStr$1(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean$1(obj) { return toStr$1(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol$8(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn$3 = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$9(obj, key) {
    return hasOwn$3.call(obj, key);
}

function toStr$1(obj) {
    return objectToString$3.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice$2.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray$n(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$9(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$9(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

var GetIntrinsic$2 = getIntrinsic;
var callBound$4 = callBound$8;
var inspect$1 = objectInspect;

var $TypeError = GetIntrinsic$2('%TypeError%');
var $WeakMap = GetIntrinsic$2('%WeakMap%', true);
var $Map = GetIntrinsic$2('%Map%', true);

var $weakMapGet = callBound$4('WeakMap.prototype.get', true);
var $weakMapSet = callBound$4('WeakMap.prototype.set', true);
var $weakMapHas = callBound$4('WeakMap.prototype.has', true);
var $mapGet$1 = callBound$4('Map.prototype.get', true);
var $mapSet = callBound$4('Map.prototype.set', true);
var $mapHas$1 = callBound$4('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

var sideChannel = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect$1(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet$1($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas$1($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};

var hasOwn$2 = Object.prototype.hasOwnProperty;
var toString$b = Object.prototype.toString;

var foreach = function forEach (obj, fn, ctx) {
    if (toString$b.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn$2.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};

var possibleNames = [
	'BigInt64Array',
	'BigUint64Array',
	'Float32Array',
	'Float64Array',
	'Int16Array',
	'Int32Array',
	'Int8Array',
	'Uint16Array',
	'Uint32Array',
	'Uint8Array',
	'Uint8ClampedArray'
];

var g$6 = typeof globalThis === 'undefined' ? commonjsGlobal : globalThis;

var availableTypedArrays$2 = function availableTypedArrays() {
	var out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g$6[possibleNames[i]] === 'function') {
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};

var GetIntrinsic$1 = getIntrinsic;

var $gOPD = GetIntrinsic$1('%Object.getOwnPropertyDescriptor%', true);
if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

var getOwnPropertyDescriptor = $gOPD;

var forEach$2 = foreach;
var availableTypedArrays$1 = availableTypedArrays$2;
var callBound$3 = callBound$8;

var $toString$1 = callBound$3('Object.prototype.toString');
var hasToStringTag$1 = shams();

var g$5 = typeof globalThis === 'undefined' ? commonjsGlobal : globalThis;
var typedArrays$1 = availableTypedArrays$1();

var $indexOf = callBound$3('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};
var $slice$1 = callBound$3('String.prototype.slice');
var toStrTags$1 = {};
var gOPD$2 = getOwnPropertyDescriptor;
var getPrototypeOf$1 = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag$1 && gOPD$2 && getPrototypeOf$1) {
	forEach$2(typedArrays$1, function (typedArray) {
		var arr = new g$5[typedArray]();
		if (Symbol.toStringTag in arr) {
			var proto = getPrototypeOf$1(arr);
			var descriptor = gOPD$2(proto, Symbol.toStringTag);
			if (!descriptor) {
				var superProto = getPrototypeOf$1(proto);
				descriptor = gOPD$2(superProto, Symbol.toStringTag);
			}
			toStrTags$1[typedArray] = descriptor.get;
		}
	});
}

var tryTypedArrays$1 = function tryAllTypedArrays(value) {
	var anyTrue = false;
	forEach$2(toStrTags$1, function (getter, typedArray) {
		if (!anyTrue) {
			try {
				anyTrue = getter.call(value) === typedArray;
			} catch (e) { /**/ }
		}
	});
	return anyTrue;
};

var isTypedArray$4 = function isTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag$1 || !(Symbol.toStringTag in value)) {
		var tag = $slice$1($toString$1(value), 8, -1);
		return $indexOf(typedArrays$1, tag) > -1;
	}
	if (!gOPD$2) { return false; }
	return tryTypedArrays$1(value);
};

var forEach$1 = foreach;
var availableTypedArrays = availableTypedArrays$2;
var callBound$2 = callBound$8;

var $toString = callBound$2('Object.prototype.toString');
var hasToStringTag = shams();

var g$4 = typeof globalThis === 'undefined' ? commonjsGlobal : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound$2('String.prototype.slice');
var toStrTags = {};
var gOPD$1 = getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD$1 && getPrototypeOf) {
	forEach$1(typedArrays, function (typedArray) {
		if (typeof g$4[typedArray] === 'function') {
			var arr = new g$4[typedArray]();
			if (Symbol.toStringTag in arr) {
				var proto = getPrototypeOf(arr);
				var descriptor = gOPD$1(proto, Symbol.toStringTag);
				if (!descriptor) {
					var superProto = getPrototypeOf(proto);
					descriptor = gOPD$1(superProto, Symbol.toStringTag);
				}
				toStrTags[typedArray] = descriptor.get;
			}
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var foundName = false;
	forEach$1(toStrTags, function (getter, typedArray) {
		if (!foundName) {
			try {
				var name = getter.call(value);
				if (name === typedArray) {
					foundName = name;
				}
			} catch (e) {}
		}
	});
	return foundName;
};

var isTypedArray$3 = isTypedArray$4;

var whichTypedArray$1 = function whichTypedArray(value) {
	if (!isTypedArray$3(value)) { return false; }
	if (!hasToStringTag || !(Symbol.toStringTag in value)) { return $slice($toString(value), 8, -1); }
	return tryTypedArrays(value);
};

// modified from https://github.com/es-shims/es6-shim
var keys$7 = objectKeys$1;
var canBeObject = function (obj) {
	return typeof obj !== 'undefined' && obj !== null;
};
var hasSymbols$1 = shams$1();
var callBound$1 = callBound$8;
var toObject = Object;
var $push = callBound$1('Array.prototype.push');
var $propIsEnumerable = callBound$1('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols$1 ? Object.getOwnPropertySymbols : null;

// eslint-disable-next-line no-unused-vars
var implementation$2 = function assign(target, source1) {
	if (!canBeObject(target)) { throw new TypeError('target must be an object'); }
	var objTarget = toObject(target);
	var s, source, i, props, syms, value, key;
	for (s = 1; s < arguments.length; ++s) {
		source = toObject(arguments[s]);
		props = keys$7(source);
		var getSymbols = hasSymbols$1 && (Object.getOwnPropertySymbols || originalGetSymbols);
		if (getSymbols) {
			syms = getSymbols(source);
			for (i = 0; i < syms.length; ++i) {
				key = syms[i];
				if ($propIsEnumerable(source, key)) {
					$push(props, key);
				}
			}
		}
		for (i = 0; i < props.length; ++i) {
			key = props[i];
			value = source[key];
			if ($propIsEnumerable(source, key)) {
				objTarget[key] = value;
			}
		}
	}
	return objTarget;
};

var implementation$1 = implementation$2;

var lacksProperEnumerationOrder = function () {
	if (!Object.assign) {
		return false;
	}
	/*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */
	var str = 'abcdefghijklmnopqrst';
	var letters = str.split('');
	var map = {};
	for (var i = 0; i < letters.length; ++i) {
		map[letters[i]] = letters[i];
	}
	var obj = Object.assign({}, map);
	var actual = '';
	for (var k in obj) {
		actual += k;
	}
	return str !== actual;
};

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	/*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
	return false;
};

var polyfill$1 = function getPolyfill() {
	if (!Object.assign) {
		return implementation$1;
	}
	if (lacksProperEnumerationOrder()) {
		return implementation$1;
	}
	if (assignHasPendingExceptions()) {
		return implementation$1;
	}
	return Object.assign;
};

var define$1 = defineProperties_1;
var getPolyfill$1 = polyfill$1;

var shim$1 = function shimAssign() {
	var polyfill = getPolyfill$1();
	define$1(
		Object,
		{ assign: polyfill },
		{ assign: function () { return Object.assign !== polyfill; } }
	);
	return polyfill;
};

var defineProperties = defineProperties_1;
var callBind = callBind$4.exports;

var implementation = implementation$2;
var getPolyfill = polyfill$1;
var shim = shim$1;

var polyfill = callBind.apply(getPolyfill());
// eslint-disable-next-line no-unused-vars
var bound = function assign(target, source1) {
	return polyfill(Object, arguments);
};

defineProperties(bound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

var object_assign = bound;

var objectKeys = objectKeys$1;
var isArguments$4 = isArguments$5;
var is = objectIs;
var isRegex = isRegex$1;
var flags = regexp_prototype_flags;
var isArray$m = isarray;
var isDate$1 = isDateObject;
var whichBoxedPrimitive = whichBoxedPrimitive$1;
var GetIntrinsic = getIntrinsic;
var callBound = callBound$8;
var whichCollection = whichCollection$1;
var getIterator = node;
var getSideChannel$1 = sideChannel;
var whichTypedArray = whichTypedArray$1;
var assign$4 = object_assign;

var $getTime = callBound('Date.prototype.getTime');
var gPO = Object.getPrototypeOf;
var $objToString = callBound('Object.prototype.toString');

var $Set = GetIntrinsic('%Set%', true);
var $mapHas = callBound('Map.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSize = callBound('Map.prototype.size', true);
var $setAdd = callBound('Set.prototype.add', true);
var $setDelete = callBound('Set.prototype.delete', true);
var $setHas = callBound('Set.prototype.has', true);
var $setSize = callBound('Set.prototype.size', true);

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
function setHasEqualElement(set, val1, opts, channel) {
  var i = getIterator(set);
  var result;
  while ((result = i.next()) && !result.done) {
    if (internalDeepEqual(val1, result.value, opts, channel)) { // eslint-disable-line no-use-before-define
      // Remove the matching element to make sure we do not check that again.
      $setDelete(set, result.value);
      return true;
    }
  }

  return false;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
function findLooseMatchingPrimitives(prim) {
  if (typeof prim === 'undefined') {
    return null;
  }
  if (typeof prim === 'object') { // Only pass in null as object!
    return void 0;
  }
  if (typeof prim === 'symbol') {
    return false;
  }
  if (typeof prim === 'string' || typeof prim === 'number') {
    // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
    return +prim === +prim; // eslint-disable-line no-implicit-coercion
  }
  return true;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
function mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }
  var curB = $mapGet(b, altValue);
  var looseOpts = assign$4({}, opts, { strict: false });
  if (
    (typeof curB === 'undefined' && !$mapHas(b, altValue))
    // eslint-disable-next-line no-use-before-define
    || !internalDeepEqual(item, curB, looseOpts, channel)
  ) {
    return false;
  }
  // eslint-disable-next-line no-use-before-define
  return !$mapHas(a, altValue) && internalDeepEqual(item, curB, looseOpts, channel);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
function setMightHaveLoosePrim(a, b, prim) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }

  return $setHas(b, altValue) && !$setHas(a, altValue);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
function mapHasEqualEntry(set, map, key1, item1, opts, channel) {
  var i = getIterator(set);
  var result;
  var key2;
  while ((result = i.next()) && !result.done) {
    key2 = result.value;
    if (
      // eslint-disable-next-line no-use-before-define
      internalDeepEqual(key1, key2, opts, channel)
      // eslint-disable-next-line no-use-before-define
      && internalDeepEqual(item1, $mapGet(map, key2), opts, channel)
    ) {
      $setDelete(set, key2);
      return true;
    }
  }

  return false;
}

function internalDeepEqual(actual, expected, options, channel) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  var actualBoxed = whichBoxedPrimitive(actual);
  var expectedBoxed = whichBoxedPrimitive(expected);
  if (actualBoxed !== expectedBoxed) {
    return false;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration

  var hasActual = channel.has(actual);
  var hasExpected = channel.has(expected);
  var sentinel;
  if (hasActual && hasExpected) {
    if (channel.get(actual) === channel.get(expected)) {
      return true;
    }
  } else {
    sentinel = {};
  }
  if (!hasActual) { channel.set(actual, sentinel); }
  if (!hasExpected) { channel.set(expected, sentinel); }

  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts, channel);
}

function isBuffer$6(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }

  return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
}

function setEquiv(a, b, opts, channel) {
  if ($setSize(a) !== $setSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  while ((resultA = iA.next()) && !resultA.done) {
    if (resultA.value && typeof resultA.value === 'object') {
      if (!set) { set = new $Set(); }
      $setAdd(set, resultA.value);
    } else if (!$setHas(b, resultA.value)) {
      if (opts.strict) { return false; }
      if (!setMightHaveLoosePrim(a, b, resultA.value)) {
        return false;
      }
      if (!set) { set = new $Set(); }
      $setAdd(set, resultA.value);
    }
  }
  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
      if (resultB.value && typeof resultB.value === 'object') {
        if (!setHasEqualElement(set, resultB.value, opts.strict, channel)) {
          return false;
        }
      } else if (
        !opts.strict
        && !$setHas(a, resultB.value)
        && !setHasEqualElement(set, resultB.value, opts.strict, channel)
      ) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}

function mapEquiv(a, b, opts, channel) {
  if ($mapSize(a) !== $mapSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  var key;
  var item1;
  var item2;
  while ((resultA = iA.next()) && !resultA.done) {
    key = resultA.value[0];
    item1 = resultA.value[1];
    if (key && typeof key === 'object') {
      if (!set) { set = new $Set(); }
      $setAdd(set, key);
    } else {
      item2 = $mapGet(b, key);
      if ((typeof item2 === 'undefined' && !$mapHas(b, key)) || !internalDeepEqual(item1, item2, opts, channel)) {
        if (opts.strict) {
          return false;
        }
        if (!mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) {
          return false;
        }
        if (!set) { set = new $Set(); }
        $setAdd(set, key);
      }
    }
  }

  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      key = resultB.value[0];
      item2 = resultB.value[1];
      if (key && typeof key === 'object') {
        if (!mapHasEqualEntry(set, a, key, item2, opts, channel)) {
          return false;
        }
      } else if (
        !opts.strict
        && (!a.has(key) || !internalDeepEqual($mapGet(a, key), item2, opts, channel))
        && !mapHasEqualEntry(set, a, key, item2, assign$4({}, opts, { strict: false }), channel)
      ) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}

function objEquiv(a, b, opts, channel) {
  /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5] */
  var i, key;

  if (typeof a !== typeof b) { return false; }
  if (a == null || b == null) { return false; }

  if ($objToString(a) !== $objToString(b)) { return false; }

  if (isArguments$4(a) !== isArguments$4(b)) { return false; }

  var aIsArray = isArray$m(a);
  var bIsArray = isArray$m(b);
  if (aIsArray !== bIsArray) { return false; }

  // TODO: replace when a cross-realm brand check is available
  var aIsError = a instanceof Error;
  var bIsError = b instanceof Error;
  if (aIsError !== bIsError) { return false; }
  if (aIsError || bIsError) {
    if (a.name !== b.name || a.message !== b.message) { return false; }
  }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if ((aIsRegex || bIsRegex) && (a.source !== b.source || flags(a) !== flags(b))) {
    return false;
  }

  var aIsDate = isDate$1(a);
  var bIsDate = isDate$1(b);
  if (aIsDate !== bIsDate) { return false; }
  if (aIsDate || bIsDate) { // && would work too, because both are true or both false here
    if ($getTime(a) !== $getTime(b)) { return false; }
  }
  if (opts.strict && gPO && gPO(a) !== gPO(b)) { return false; }

  if (whichTypedArray(a) !== whichTypedArray(b)) {
    return false;
  }

  var aIsBuffer = isBuffer$6(a);
  var bIsBuffer = isBuffer$6(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  var ka = objectKeys(a);
  var kb = objectKeys(b);
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; } // eslint-disable-line eqeqeq
  }

  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!internalDeepEqual(a[key], b[key], opts, channel)) { return false; }
  }

  var aCollection = whichCollection(a);
  var bCollection = whichCollection(b);
  if (aCollection !== bCollection) {
    return false;
  }
  if (aCollection === 'Set' || bCollection === 'Set') { // aCollection === bCollection
    return setEquiv(a, b, opts, channel);
  }
  if (aCollection === 'Map') { // aCollection === bCollection
    return mapEquiv(a, b, opts, channel);
  }

  return true;
}

var deepEqual$1 = function deepEqual(a, b, opts) {
  return internalDeepEqual(a, b, opts, getSideChannel$1());
};

const Svg = styled.svg `
  @keyframes spinners-react-dotted-shrink {
    50% {
      transform: translate(0, 0);
      opacity: 0;
    }
  }
`;
const Loading = () => {
    return (jsxs(Svg, Object.assign({ fill: "none", viewBox: "0 0 66 66", style: { color: '#e1aa00', overflow: 'visible' }, xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("circle", { cx: "33", cy: "33", fill: "currentColor", r: "3", style: {
                    transform: 'translate(22px, -20px)',
                    animation: '2s cubic-bezier(0, 0.9, 0, 0.9) 0s infinite normal none running spinners-react-dotted-shrink',
                } }, void 0), jsx("circle", { cx: "33", cy: "33", fill: "currentColor", r: "3", style: {
                    transform: 'translate(29px)',
                    animation: '2s cubic-bezier(0, 0.9, 0, 0.9) 0.1s infinite normal none running spinners-react-dotted-shrink',
                } }, void 0), jsx("circle", { cx: "33", cy: "33", fill: "currentColor", r: "3", style: {
                    transform: 'translate(22px, 20px)',
                    animation: '2s cubic-bezier(0, 0.9, 0, 0.9) 0.2s infinite normal none running spinners-react-dotted-shrink',
                } }, void 0), jsx("circle", { cx: "33", cy: "33", fill: "currentColor", r: "3", style: {
                    transform: 'translate(0px, 30px)',
                    animation: '2s cubic-bezier(0, 0.9, 0, 0.9) 0.3s infinite normal none running spinners-react-dotted-shrink',
                } }, void 0), jsx("circle", { cx: "33", cy: "33", fill: "currentColor", r: "3", style: {
                    transform: 'translate(-23px, 20px)',
                    animation: '2s cubic-bezier(0, 0.9, 0, 0.9) 0.4s infinite normal none running spinners-react-dotted-shrink',
                } }, void 0), jsx("circle", { cx: "33", cy: "33", fill: "currentColor", r: "3", style: {
                    transform: 'translate(-30px)',
                    animation: '2s cubic-bezier(0, 0.9, 0, 0.9) 0.5s infinite normal none running spinners-react-dotted-shrink',
                } }, void 0), jsx("circle", { cx: "33", cy: "33", fill: "currentColor", r: "3", style: {
                    transform: 'translate(-23px, -20px)',
                    animation: '2s cubic-bezier(0, 0.9, 0, 0.9) 0.6s infinite normal none running spinners-react-dotted-shrink',
                } }, void 0), jsx("circle", { cx: "33", cy: "33", fill: "currentColor", r: "3", style: {
                    transform: 'translate(0px, -30px)',
                    animation: '2s cubic-bezier(0, 0.9, 0, 0.9) 0.7s infinite normal none running spinners-react-dotted-shrink',
                } }, void 0)] }), void 0));
};

const rotate$1 = We `
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const StyledSVG$1 = styled.svg `
  animation: 2s ${rotate$1} linear infinite;
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  path {
    stroke: ${({ stroke, theme }) => stroke !== null && stroke !== void 0 ? stroke : theme.primary1};
  }
`;
/**
 * Takes in custom size and stroke for circle color, default to primary color as fill,
 * need ...rest for layered styles on top
 */
function LoaderIcon(_a) {
    var { size = '16px', stroke } = _a, rest = __rest$1(_a, ["size", "stroke"]);
    return (jsx(StyledSVG$1, Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", size: size, stroke: stroke }, rest, { children: jsx("path", { d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.27455 20.9097 6.80375 19.1414 5", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, void 0) }), void 0));
}

const LogoIcon = () => {
    return (jsxs("svg", Object.assign({ width: "50", height: "50", viewBox: "0 0 1053 987", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("path", { d: "M957.158 0.770165L815.237 0.657715L846.697 100.693L857.306 134.444L829.473 155.25L589.981 334.445L801.6 493.282L1052.89 305.289L957.158 0.770165Z", fill: "#FFC800" }, void 0), jsx("path", { d: "M223.323 154.888L195.53 134.013L206.18 100.317L237.639 0.646202L96.235 0.53418L0.104492 304.941L251.087 493.327L462.99 334.77L223.323 154.888Z", fill: "#E1AA00" }, void 0), jsx("path", { d: "M502.192 161.848L287.451 0.727051L251.21 115.473L502.192 303.859L502.328 303.747V161.82L502.192 161.848Z", fill: "#E1AA00" }, void 0), jsx("path", { d: "M765.574 0.890137L550.547 161.759V303.686L801.679 115.804L765.574 0.890137Z", fill: "#FFC800" }, void 0), jsx("path", { d: "M278.907 532.814L251.74 553.171L251.21 554.824L502.192 743.21L502.328 743.098V365.654L278.907 532.814Z", fill: "#E1AA00" }, void 0), jsx("path", { d: "M801.068 553.29L773.765 532.779L550.832 365.451L550.547 365.662V743.105L801.679 555.224L801.068 553.29Z", fill: "#FFC800" }, void 0), jsx("path", { d: "M502.152 803.537L474.36 782.675L297.856 650.22L251.21 797.946L502.192 986.333L502.328 986.221V803.397L502.152 803.537Z", fill: "#E1AA00" }, void 0), jsx("path", { d: "M755.169 650.314L578.203 782.714L550.547 803.407V986.231L801.679 798.349L755.169 650.314Z", fill: "#FFC800" }, void 0)] }), void 0));
};

const AvaxLogo = ({ size = '24px' }) => {
    return (jsxs("svg", Object.assign({ version: "1.0", xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 1000.000000 1000.000000", preserveAspectRatio: "xMidYMid meet" }, { children: [jsx("circle", { cx: "500", cy: "500", r: "400", fill: "white" }, void 0), jsx("g", Object.assign({ transform: "translate(0.000000,1000.000000) scale(0.100000,-0.100000)", fill: "#E84142", stroke: "none" }, { children: jsx("path", { d: "M4590 9989 c-1442 -124 -2734 -838 -3594 -1984 -572 -761 -904 -1642\n-986 -2610 -13 -155 -13 -635 0 -790 123 -1453 833 -2745 1985 -3609 761 -572\n1642 -904 2610 -986 155 -13 635 -13 790 0 1453 123 2745 833 3609 1985 572\n761 904 1642 986 2610 13 155 13 635 0 790 -123 1453 -833 2745 -1985 3609\n-761 572 -1642 904 -2610 986 -139 11 -666 11 -805 -1z m458 -1530 c39 -19 79\n-50 109 -84 64 -72 782 -1332 824 -1445 41 -113 59 -231 59 -385 0 -159 -19\n-277 -63 -394 -23 -59 -293 -536 -861 -1521 -456 -789 -853 -1472 -882 -1516\n-118 -179 -349 -347 -582 -423 -157 -51 -179 -53 -992 -49 l-755 3 -60 24\nc-86 34 -158 108 -180 185 -19 63 -16 116 10 202 21 70 2972 5247 3025 5307\n114 129 223 159 348 96z m1919 -3378 c50 -23 124 -90 163 -146 42 -62 1009\n-1762 1043 -1835 43 -89 49 -202 17 -278 -28 -65 -92 -123 -169 -154 l-56 -23\n-1110 0 -1110 0 -59 24 c-63 25 -138 87 -162 132 -42 82 -38 189 10 295 36 79\n1035 1807 1076 1862 41 54 118 115 164 130 53 17 147 13 193 -7z" }, void 0) }), void 0)] }), void 0));
};

const WgmLogo = ({ size = '24px ' }) => {
    return (jsxs("svg", Object.assign({ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", width: size, height: size, viewBox: "0 0 1920 1920", enableBackground: "new 0 0 1920 1920" }, { children: [jsx("g", { transform: "translate(0.000000,1000.000000) scale(0.100000,-0.100000)", fill: "#ffe669", stroke: "none" }, void 0), jsx("image", { id: "image0", width: "1920", height: "1920", x: "0", y: "0", href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAB4AAAAeACAYAAAAvokrGAAAABGdBTUEAALGPC/xhBQAAACBjSFJN\n    AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAA\n    CXBIWXMAAA7EAAAOxAGVKw4bAACAAElEQVR42uz9TZcdN5Ym6L4eCpESI6RwMYKZXXW7Mn0QOYke\n    1h/g/+35nTZHd3Rr2DlhrtXOzLpVq+JLHlJI/FAo/A6ckJub42MD2AA2gPddS4sU/ZgZYOf4sWN4\n    zgYubm/xCWbNK1yMbsKQvBzdAAD/bdNzL81/LdjmX3lOq/PmcA7/ZXRjFsx/V36NXo3u0EL5n5O/\n    f/yX0Q1YJP9r8tfBKvnPoxtgOH/ga5RhGMN5gdvRTTCb/zG6AQwA4B/5GlXLf4xuQEX+E18HarlW\n    3t//zudGPa8Pf/9nnl+V/C7zPP630Q2eIP918Gvz1egTMCgvN3lP+D/rNr+YFoB3xV9gPAATf8PJ\n    hV+ir04Iv+2jhb9XozuySGYHX4DoWxoi79gQd8Mh7jIMs0OIxOEQiceGOFyWmSHYhSCsk2vFfRGC\n    9UMI1g8hWDdE4DEhAiczJwDvjL/AOAAm/IZD+B0Xh7+EX/1oV/wCBOCSEHv3DbG3fwi8shB7GYZh\n    7kMUloVA3D9E4bIQhffNtfL+CMFt8hpEYO3kYDAhOJ5REPxqdMcHZhcEBoogmAA8W14OOCbhNxzC\n    79i8wQXhVzEEXzuZFX0JvfUh+vYJoTceAi/DMIxuiMThEIb7hBhcn5lhmCCcn+sG+yQI6+YDz6d6\n    WBWslxEQ/Gp0pwdlJwAGshF4PgDeFX9fDjgm4dcfru87Pqz61QvR105mQ19ib10Ivf1D9L0LcZdh\n    GMZeCMR3IQb3D2G4LrOhMCG4LNcN9kkMrg+nhW6TXAQGCMGxEIL7hAgczFwAvCP+vhxwTMKvPyXw\n    60IArs+b0zkk/tZFE36vRndm4hB91w6Rt3+IvHch8jIMw6wT4vBdiMP9QxzOCzF4n1wr7osQXJ/X\n    p/8nBtenBIEBQnAshOD22QmBlwPg3eD35aDjEn79IfyOC9G3TTTw92p0JybNbODrQvhNh9jbL0Te\n    xyH4MgzD7BOCsD8E4j4hCqczGwS7EITLcq2wDyKwTgjBuilFYIAQHArXB+6XHTBYiMB2AXg39AXG\n    wS9A/A2lFH8Jv3U5wi/RVydaFb9XozsyWQi+64fwqx8C78MQdxmGYZjcEIkfhjjcJsRgWQjC++Ra\n    YR/EYJ0Qg/XCamD9EIL7ZWUInhqAib99Q/wNJxeACb914dq+utFe3/dqdIcmyWzoS+yVhdDbJsRe\n    Ai/DMAwzJkRiwnCLEIXlmQ2GCcLpXCvvjxisE4fBROC65EIwATicUQDs8mr0CRiQFSF4SgAm/I4J\n    AdifHPwl/OrkCc9jdYi+4zID/BJ74yHy9snO6EvsZVbPP45uQMP8r9ENYJjG2R2EicHtQxyOZwYQ\n    JgLLc91gnwThurwGEVgrUgwmAodDBO6fTRHYBgDvCL/AePwl/PpD+O2bN7hgxW9liL5jQvCdO8Te\n    tiHyMoydrIyyq4bYzFgLcZhpFaJwOAThdXKtvD9CcF0IwTrJqQgmBPszGoEBQvAKSSDweADeEX9f\n    Dj4+4fdxONVz33CNX71o4O/V6E5MkhnA9xji7+MQffWyM/ACRF7GRgi7DEAsZsaHOMxohRj8ODMg\n    8DEEYVmulfZDCC7PcY1gYnBdODV0fUZD8KvRJ2BAVkNgIAjBYwGY+Ns3hN/HyYVfgPhbkzeec0cA\n    Lkst/F6N7sAEIfjOH4JvfXaGXiIv0zLEW8ZSiMhMq+yMw4Th+hCEH4cgvF6uK7cnApfn9en/CcHl\n    yUVggBDsy0gIfjW684OyAQSPA+Ad8RcYA8CE38cpgV8XAnB+zvBL9C0Lq33bZyb0Jfjeh9CrF4Iv\n    w8hCwGWY+xCQGWkIwoxGCMP3mQmEicHxXCvsgxhcFkKwTkoQGCAE+zICgl+N7vSgrAjALh8hmADc\n    Oy87H4/4+zCE374h/NZHc33fq9GdMR7L+EvsvQ+xVy87Yi+Rl5GEuFuePy38O/brhQcHWodAzEiy\n    Iw4ThfVCFL6PdRQmBIdzrbgvYnBZODV0XUoRGCAE+9Ibgl+N7vCgrIzAGAXAxN/2Ifw+DOF3TN7g\n    guhbEE30BQi/oRB85wjBty67IS+Bl8nJztC7MtTOlp1hmTDM5GQ3ICYO14UgfB/LIEwM9udaeX/E\n    4LK8BhG4JqwI1gkRuH0IwA2yGwC/7Hw84u/DcJ3f/iH8loXVvm1jGXxdCL/3IfzmhdDLMPdZEXYJ\n    tow0q4IysZgJhTDMxEIIvo9lCHYhCD/OteK+CMFl+cDzVhWuD6wTQnDbLIzAfQF4J/h9Oei4xN/H\n    yQFgwm953HTPhN/y1ALw1egOGMsM4OuyM/wSevOzG/YCBF9mftQl4DKzZAVAJhbvnd1A2IUwnJfd\n    YXgGDAYIwudcK+yDCFweVgTXJQeCCcD+cG3gtlkUgfsAMOG3XwjADyPFX8JveQi/dSH66mcG+N0V\n    fIm9ZdkJfAm9e2Z23AUIvMw+WQGIASLxrtkFh4nBZdkZha2DMCHYn+uKbQnBZeEawfWRQjAR+HFG\n    ALDLq9Gd75yFMLgtABN++4Xw+zjE37Z5czhvxN+8aEz1fDW6EwZjFX53xV6A4FuS1bGXwLtvZkRe\n    oi7D1GdGMCYO75nVcZgonB+CsL0Qgv25rtyeGJyX16f/JwTnh9XA5RmJwAAheMK0AeCd4Bcg/loK\n    1/ttnzen80X8lUVrfd+r0R0xFovouzP4uhB+41kdeQFC7+6xir0EXYaxH4tgTBDeO6vDMEAcTmVn\n    CHYhCM+Ra4V9EINlee35N0JwXrg2cHlGIzCwFwRPjsC6AEz47RvC731K4Bcg/uaE8FsWLfgFiL+A\n    TfAFiL4E33B2wF4Xou8eIe4yDDM6RGJmZHYAYYAoHMvuIEwMtptr5f0Rg9NhNXBdShAYIAQfw2mh\n    +2VSCNYDYOJvvxB+71KKvgDhtyRvcEH0zQjhVy9W0ddlN/wl9oazA/YSedeOVdw9htDLMIwvFlH4\n    HCLx2iEMMzvBsFUEdiEG62IwIVgWh8FE4LyUIjBACD6GENwvk0FwPQDvBr/AOPwl/N6HUz33C+E3\n    P7X4ezW6AwZC9LURYm88q4IvkXf9WIRewi7DMD1iFYqJw2tnVRwmBsezCwgTg+3nunJ7AnB+XoMQ\n    XBJWBNdnFAS/Gt3xzpkIgesAmPjbJ4Tf+xB++8RN90z4zUsN/F6NbryhWMTfXcAXIPrGshr4Enr3\n    iQXwJfAyDDNDrAAxQXiPrAbDBOFwdsFgwCYIE4Hvc125PTE4L4TgsnB94LoQgftkEgQuB+Ad8Rfo\n    D8DE3/vk4i/hNz+E3/yw2lcn1tB3J/B1IfzeZzXoPYbou2YIvAzDMH1iAYiJw+tmNRB2IQw/zE4Y\n    7GINhQnCOlNEE4PlIQSXJReCicAP0xuCX43u8IBMgMAE4Jy87Hw84u99cvCX8Jsfwm9eNNb3vRrd\n    icEh+I4Nsfc+q2IvoXedWMBdXwi+DMMwNkDYFyLxOlkVhQHCsMtuIEwMtpfryu0JwbK8PvydGJyX\n    HAgmAt+HANw+BODF8rLjsYi/DyMFYOJvXt4czhfxNx3Cb12IvuNC8L3LathL5F0n1pCXuMswDKMX\n    a0hMHF4nq+EwQfg+u6AwMdhOrpX2QwyOhwhcHikCE4AfhgjcNssC8G74+3LAMQnA92H1b5u8OZ0r\n    AnA4GvAL7Im/1tDXZXX8JfjeZRXwJfSuESvIS9xlGIaxFytITBxeI6vAMEH4LqtjsDUEdtkRg6+V\n    9kMEjocIXBZOB12WEesBvxrd6c4xjsD5ALwT/r4cdFzi71245m+7cMpneVj1Wx5r+Ls6+gKEX5fZ\n    4Zfgu05Goi+hl2EYZo2MwmFi8DqZHYQJwXdZHYIBexi8IwIDXB+4VxwEE4HlyUVggBDsMgKCgX0w\n    2DACywF4F/h9OfDYhN989AUIvzkh/MpTC79XozswMFbgl+C7R2bHXoDgO3tY2cswDMP0CiuFGY3M\n    DsIAURggCPfOrhgMcI3g1iEE54cQXJZRCAwQggcmDcC7wC/Ait+RIfy2DeFXFqJvWQi+/bIz+K4A\n    vQCxd8YQeBmGYZhZYgWIASLxjFkBhoF9cZgg3C+7YvB15faE4HSIwXkhBJeHFcHtYwSDwwBM+G0f\n    wi/ht3Xe4ILomwjRtyxE3z7ZFXxnx14i71wh8DIMwzC7xAoQE4fnyuwwTBBeM8Tgsbmu3J4YHA8h\n    OD9cI7gshOC2MYDAjwGY8Ns+hF/Cb8uw2lcWwm9ZLMDvyuhL8J0vxN75wnV5GYZhGOZxRuMwUXiu\n    zIzCO4IwMbhPdsTg68rtCcHxEILzQwjODxG4fQZC8EMAJv62DeH3Lrn4S/iVh/ibTi38AnvirwX4\n    dVkVgIm/c4XwO08IvgzDMAyTn5EgTAyeJ4TgubIqBFsBYIAIXBpCcDyE4LwQgcsyAoJfje505wyA\n    4DsA3gl+AeLvyBB/2+TN4TwRf+Nh5W9erMDviui7I/gSe5mWGQW9RF6GYRhmtxCHmVhmRWGC8Bqx\n    gsG7QfC1wj6IwPEQgfNDCM4Pq4HbpzMCX9z+X/j56D53y8tBxyX+3oX42y4E4HhY9ZsXC+hL8J0/\n    M2Ivodd2WMnLMPbyYnQDBuYPoxvAMIZDIGZ8mRGGd0NhgnCbEIPzQgj2hwCcHwJwWYjA7dMRgQnA\n    PUIAvgsBWD+E33CIvnkZjb4E37lD7GW0QuRlGN20Bto/b/x787zDTTuRmVkthGHmHKKw7RCE22QX\n    EL5W2Acx+GFeH/5OCJYlB4EJwPchArdPJwTeB4BfDjou8fcuxF/dEH7D4RTP8oxGX2A9+N0FfWcE\n    X4DoazEjwRcg+jJzx4e7O4Ps6gmBM5GYmTkjQRggClvLjBgM7APCxGD97ALBAKuCtUMIzgsROD8E\n    4D7pgMAE4JYh/ubBL9E3HQe/RN/HIfzKMxp+V0NfgPBrNQRfexkBvkRexmKIt8yI+BCZgMxYTW8c\n    Jgbby2wgvAMEr4jAACG4Z64rtycEPw4xWB5CcF5GIPCr0Z0ekMYITABuld3xl/CrF1b7xkP4zQvx\n    Vy9EXzsh9NpLb+gl8jIjEptemZjLrJLYVNfEY2ZECMPMDDC8AwYDa4EwEbh/riu2JQQ/DiFYHkJw\n    XnpD8KvRHe4cArBCXnY8FuFXHsJvOqz4TacUgK9GN7xzCL/1IfjaCLHXRljJy6weydq5RF6Gka2F\n    TChmemXElNIEYhshCtvICiA8GoKBvTD4umJbInA4DoMJwfHkQDBADO4Jwa9Gd7ZjCMAVednxWIRf\n    eQi/6RB+02HlbzyjwRcg+s4Q69gLEHxHZ/QavQDhl2mXM/ISdBmmbc5YTBhmWobrC+8dgrCNEITr\n    szoGXyvsgxDsDxFYHkJwXgjB+mmIwOsB8MvOxyP85oX4K8sbXBB/PalFX2Bt+CX61mdl8J0Be48h\n    /I7JKPAl8jIt8gJEXYaZNQ6LicSMdkbBMEF4TGaA4GNWRmFicH1WxuBrhX0Qgv35wPMiDqeGzgsh\n    WD8NIHgdAH7Z+XiE3/wQf2Uh/j4M0TedkfA7O/gesyL+zoS+BN9x6YW+RF5GI8eqXeIuw+ydY0Ux\n    oZjRSC8cJgaPzSwovCIGr4DALiMxeGUIBojBLfIarASWhtXAeeH6wG2iCMHzA/DLAcck/paFABzO\n    m8O5If7ehVM8yzICf4m+c8Qy/hJ7+6dnZS+hlylNbN1dYi/DMJLE1iQmEjOl6Vk1TBzuH8sgvCIC\n    uxCD67M6BAP1GEwIvsvrw98JwfHkAjBABAYIwa2iAMFzA/DLAcck/paF+OvPm9N5If4SfqUh/JaF\n    4Ns/xN6+4RTOjOUQeBmGsZAQEhOIGUk4hfQesYrCBGHbGQHBOyAwQAjWCiFYFiJwWXojMEAIFmRO\n    AH456Li74y/ANX+1Qvj1pwZ/r0Y3vkNGr/E7KwCvir5WwdeF8Ns2hF5mpnzC1w3DMBPlOW6JwUxR\n    RuAwYbh9rGIwsC4Iz4zBnBq6fa4LtyMC34cQnA4RuCxE4LYpgOD5APjloOMSf/Pwl/DrD6d6DqcU\n    f69GN7xxiL5lWRF9rYMvQPRtld7YS+RlcuKqelnByzDMLiEQM7npDcNE4TaxDMHHrIbCs2LwSAgG\n    1sfg68LtiMAP8/r0/8Tgx8mBYALwGAB2eTW6852SicBzAfDLgccmAMsAmPDrD+E3HFb9+jMSfmdF\n    X5dV8Nc6+BJ726c1/BJ6GUlC0zYTfBmGYe7im1KaQMxI0hqGCcHtYx2FV8HgWRHYhRjcJtcV2xKC\n    H4YVwelIIXh3BB4JwAAR2JN5APjlwGPvjr+E3/q8wQXh9xSu9evPKPgl+tqIVfQl9rZNzwpfoi9z\n    jg94ibsMwzB64ZrDjDS9KoUJw21jFYVXwWCAIFyaFSH4WmEfxOD7OAgmAodDCE6HCNwnQgSeA4Bf\n    Djou4VcW4m88T3h+fkot+gLrwi/QH39nRt9VwPcYa/hL9NUPp3JmRuWMvARehmEYO2EFMRMKp46e\n    P9YweCUEdiEG52VFBAYIwdr5wHORDCE4nVEQ/Gp0xztGgMAE4FB2xV+u86sb4u9dWO0bD+FXltXQ\n    1xr4uhB+68OKXmZ0XoDIyzAMs0K43jATSk8cJgzXxxoEu6wGwjNjcE8IXhWBXa4rtycE34cQHA/X\n    B5ZlBAS/Gt3pjkkgMAH4HMKvLMTfcNx6v5zymfCbCuE3nZXQl+C7bnqAL6GX8YWVvQzDMHvlXC1M\n    HGaOIQrPE4Jw+8yIwSOmhiYGh0MIvstrcEroWHIQGCAE98qr0Z3tmOkB+GWn4xB+80IAfpw3p3NC\n    AC4H4KvRDW8YrvErywrwS/BdP63gl9jLAFybl2EYhskL1xpmQmkFw0RgvRCE22U2CB61PjCwNgZf\n    F25HBL5fF9iFGPw4uQgMEIJb59XoTnbM1AD8ssMxdoVfgPirFcKvP7n4ezW6wQ1D9JVnZvgl+K4d\n    VvkyLcIKXoZhGKZXWD3M9KgQJgrrxSIKzwzCs0EwMA6DCcEPQwQmAqdSAsAAEbh1Xo3uZMdEENgu\n    AL/scAzib36Iv/ch/PpTUvV7NbrRjTICfom+/WMNfgm+dem1fi+xd78csZfQyzAMw1gJYXjv9Jo2\n    mjBcF2sYPDMEA8RgaVaF4OvC7QjBhOBUCMH5IQTrJYDA9gD4ZYdj7Ay/QBn+En4f5oi/hN+6tX6v\n    Rje+UXriL9F3XIi/c4dVvUzLsLqXYRiGmS3EYMaF1cL2QgRuE2JwOitC8HXFtoTghxBMBH4cTgmd\n    l15rA78a3dEO8SCwDQB+2fl4OwNwLv4Sfh/H4S/htw5+gTXxl/AbDtFXPwTfvLQGX2LvnnHQS+Bl\n    mLvcLPi7cMmBLYYB8BCIicN7pjUME4XlsQTCxOAx6QnBRGB/dsdgB8FE4MfJReCdARjoh8DAdhA8\n    FoBfDjjmzvgLyAGY8BvOE56bavgF1sNfwq8/K6AvwXfesMKXqc0Lz78ReplVsyLcWgshmVk5rB7e\n    L8RgWyEI62YmDCYE1+VaYR+7QzAAfOA5CEaCwQTg/q+fV6M73SEvcTsGgF8O7DQBOB7CbziEX1b8\n    nsM1ftOZEYAJvvOnFfwSe9cMkZeZMcRa5hjCMmM5zz2vT+LwmmkFwoTgshCE6zMTAgOcGro215Xb\n    E4GB3+IW/zq6EUZDBI5nBAC7vBrd+bbpD8AvB/Z2Z/yVVP4Sf/0h/N6lFH+vRjdcOSPQ12UW/J0N\n    fS2BL0D0zQ2xl8nNi8C/E32ZniHgMpZCQGZ65XnktUYUXjNEYRuxhMHAfCA8EwT3RmAXYvBdiMB3\n    YTVwOCkIJgKPy6vRJ6BN+gLwy4E93RV/OeVzed7gguv8fkwJ/l6NbnSDsOI3nNnQFyD8zhZCL1MT\n    rtPLtM6KoPvr0Q1YJH8a3QDlEIuZVuH6wnuFMDwm1iAYIAa3CiFYJ9cF2xCB78L1gcNhNXA4RGD1\n    9AHgl4N7uSP+SuEXIP6e8+ZwPnYHYMLvXXrD7wzoOyP4nmMBgIm+4RB8mdwQeZkemQ16ibhzZzY8\n    Jg4zreJwmDC8bgjC/WMFg2cD4HNmAGFODV2f64Jtdofg16f/JwTfRwLALoTg/nk1uvO6aQ/ALwf2\n    jvArCwH4Lm8852FXACb83qcX/s6AvsDc8EvwtZ1W4OtC+F0nhF5GOzOgLiGXyYl1OCYUM5ohDq+V\n    VhDsQhAOxwIIz4zBM0Aw0A+DV0RggBCcGyKwPzkA7EII7ptXozuul7YA/HJQrwi/8hB/Cb/HcJ3f\n    +xB+H2ZW+B2NvgRfWbTxl9g7d3xr9BJ7mdxYQ10CLjNTLAEysZjJjW+dYeLw3GmBwoTgdEaD8KwY\n    TAh+mBUh+Lpwu10h+LXn3wjBZQgMEIJ75tXoTuukHQC/HNCbHeEXYNVvbTjlczn8ulyN7oBSek71\n    PAv8AnPh72jwBYi+kmiCL7F37ryI/Izoy8QyEniJuQzzOKPQmEDMpPI88hohDM8bTRQmBqczGoOB\n    uUB4FgQG+k4PvQoGXyvsgxhMBHYhBOelNwS/Gt3h+qwBwIRfeQi/D/MGF9uiL1APv8Aa+Ev4fRyi\n    b34Iv/6wupfxhdM4M7npAb6EXYZpm15ITBRmpHmOWyLwItGuEiYK+2MBggFicIsQgvNzXbn9rggM\n    3EEwAfhhOC20PD0R+NXoztZnfgAm/spC+H2cJ5ufkxr8vRrdeKX0hF8XywA8E/oChF+LabGOL8F3\n    7rwAkZdJZ1Q1L8GXYcaGVcOM1RCG5w+njW4fYnB+rGNwTwR2WQGDryu23RmBAeDD5v33JReCd0Vg\n    oA8EvxrdyfrMC8C7wi9A/K3N7lW/ANf6JfzeZzb0BcbDL8H3Pi3A14XwO09YzcukMgJ4ibsMs0ZG\n    IDGBmAnFTSdNHJ4nLSDYhSB8n9EYPBMCu1jGYEJwea4LttkdgQFCsC+EYFmIwMm0AeCXHVpOAE6H\n    8PswhN+75OLv1egGK4fTPd+F8CsPwfc+rcCX2DtHQuv1En6ZnsBL2GUYJhROMc30jG9tYcLwHGmF\n    wgTh+4wCYUKwbjgtdHmuMx9PBL4LIfhhchB4VwAG2iPwq9EdrIs+AL/s0Oqd8ReQATDx9z6E37vs\n    Dr9AH/y1jL4uM+Ev0ddONPGX4Gs/Puwl9DLHtEBf4i7DMC3TAoiJwcw5ZxgmCs8RLRQmAj8OMTgd\n    ywjs0gODV0NggBXBJeH6wI8jgWACcNu8Gt3J8ugB8MuOrd4ZgIm/8rz5eB52x9+S6Z6vRjdaMb0q\n    fgm/ehk5xTPh92E00JfYO1c+4fPFfAyBl2GY3dKqgphIzADAj3wdTBUNECYGP8zIaaJnweAZIBgg\n    BpfkumCbnSH49cc/CcH3IQKH0wOAXV6N7mx+6gH45YBW7wrAxF9Z3pzOwa4ATPhlta+LdfgdvaYv\n    QPgF9Kd3JvzaD7F373DaZoZhGH96rjtMHN47z3HLCuEJojllNFF4/HrBwBwgPAMG95oiehUMvi7c\n    bkcIfn36f0LwXYjA4fREYGAqCC4H4JeDWrwj/krX/AUIwLvjbwn6ulyNbrxCuL7vXayDr8to+N0d\n    fVus50v0tZfzVM6cxnmv9EJeAi/DMDuFaw0zrXKcPpowbC9cO1g/ozF4BggG7GMwIVie64ptd4Ng\n    IvDjSNcEJgL3y6vRnU4nH4BfDmop4Ted3fEXeAjAxN+8XI3uQEV6wi9gF39ngF9O7zwuBN+1wzV7\n    mWO04ZfAyzAMkxdtJCYG75nnnuedMGwnLUB4ZwwGOE10KlYhuBcAu8wOwdcV2+6MwATgu0gRGNgT\n    gkcgMGAaguUA/HJQCwm/shB/917zd+fKX+LvHPDr0huAib56IfbayRF7ibx7hsDLMAwzb4jDjEZY\n    LWwz2ii8Mwj3xuAZAPgYaxhMBM7LdcW2uyEwwDWBz8lBYIAQ3DOvRnf8cWQA/HJAywi/shB+7/IG\n    F1vCr8uu6/32wl+L6OsyC/72hN/d0RfQgV+Cr5048CX27hUiL8MwzH5pMb00gXifOBQmCNuJBgjv\n    jMAuPTF4Jgi2hsAunBJanuvC7XZEYJcPG/f9HEJwOpwWWgDALwe0ivibDuH3LoTfPeEX6IO/hN+6\n    jJjueXf8Jfyuk0/4PGyRHmv0En4ZhmHmS491hgnDe+RHPs8molUZvDMGj5oe2joIW0VggBCck+uC\n    bXZGYIAQfAwhOJ2NITgMwC8HtIbwmw7h9y6E3z3hd3f0BezDL9G3b7SmeCb6jg2ndN4nrcCXyMtY\n    yV8Wfg/7FQeZGCNphcME4bVzXk+YVcLjojlN9K4gTAz2Z3cMXgGCAWJwbgjBdyECp7MpAvsB+GXn\n    VuwIv0Ae/hJ+70L4Jfy2imX4tYy+I8AX2BN9uZ7v/CH07hNO38xYzspIO2uIy4x2NJGYMLx2uJbw\n    +BCE60IMfpzdIRhYA4OvC7bZFYJfg+sDuxCC0+kNwa/GdvcxAL/s3IId8ZdVv/l58/Ec7Iq/O8Lv\n    7uv7WkZfgJW+PULwnTcvTv9P7F0zRF6mdwi3TCqEZCYV7eph4vCaYbXw2BCEy0MMfhyrGEwIluW6\n    cDtCMJMDwUTg9nk1rqtjAZj4Gw/h9y47428J/ALEX0kIv/kh+rYPp3SeMw58Cb3rpcWUzYTevUPE\n    ZSyHgLx3iMNMKg6GCcJ9w/WDyzICgwnB+SEEy3JduN2OEPz645+EYCKwJD0h+NWYLhJ/rYb4ew+/\n    wH74Wwq/wNz426vq12os42/v7Aa/WiH89s0L3KHvn0c3hFFJq/V5XQi/a4ewy6wQyeuYSLxu3HVK\n    C4J911Wi8NxxX3b85OP//8jns0vcPZ5mZfAOcWMKo6qCrcWNN1mF4Nb5n7iYGoGvUIbA/x0XWyIw\n    cOcKuyPwv+Iie0popl1eYggC/7x+FwzDmMnV6AZMEovVv5bxt3fl7074y4rfuXKu9CX8zh1W9zK5\n    IfIyTPz3gDi8RkLXMg0YPl97CcJz55OPzycrg/ukFoLP9567VAT/ARfdENiNnViuBP5fuDCFwG58\n    rkcl8OwIzDCMfv4bLrpPB905BGDGflj9K8vV6IZXhFM+2wvRt1000Jfg2z6+aZ0JvnOGa/UysRB1\n    GUYvOb9PxOL5krr+lQBx6BpNGJ4r58pg4OE6woRh3ZzvBTVAeHUMPo439MDg83iKNRC2WA3cC4Jn\n    RuArsApYkn/B/TTQrAKW579i32mgF8/DNYBfdjrqrtM/S9f/5fTPe677S/htE4vwS/S9yy7oS/C1\n    nReHv3MN33lD5GXOIez2y1ejGzAoX49uwCYhFK8RzfWFicPzhijcJxpTRa8Owsf0nCLaGgS7WIJg\n    F64NHM914XY7QTDA9YBduBZwPIuvA3wPwC87HnU3AJbCL0D8JfzKczW64YUh+toK0Vc/BF+7Ifau\n    EU3sJfTOGwKvPLsC7cwhLstDIJ43migMEIZnDVG4fQjCsvReK5gYLE8PDCYErx1C8F2kEEwEbpdX\n    /bt2B8AvOx2N8BsO4fdiK/QFCL8tQviVpTf6AuvDL9fytZkXp/8n+s4boi9D8I2HyLtXCMTxEIXn\n    jBYIE4LnzfPTc0cQ1g8xWBZiMCF4xlwXbEMI3jOEYH8WReCL29tO6wDvhL+EX3kIv7JcjW50RQi/\n    tsKKX/0Qf+3mBYi+s4VTOe8bAi8Rl+kT4jGBeJawQnjvOAwmAuuHCCxLbwQGCMHSEILjuS7YhhC8\n    XzgtdDiLQXB7ACb8+kP45VTP0lyNbnhFWuOvRfh1sQjAPfGX8JsOwVc3xN55oo28AKF3huwAvARc\n    ZvXsgscEYtvRhmGAODxLnuOWIKycWgwmBOvGIgADNhEYIASncl2wzY4QvDMCA4TgWBaB4HYATPj1\n    h/C7H/wC+1X9uuwIwBbhF+iDv0TfeAi+eiH2zhFW8+6XFZGXqMswZVkVi4nDtsOq4f1CFNYNQTie\n    XhhsEYItIjABOJ3rgm12Q2CAEAwQgmOZHIL1AXgn+AWIvznZFX+BfAC+Gt3gyuw47bNF+CX61ofg\n    Oz7HdXyJvrajBb6E3nkyO/gSdxlmbGZHYmLwXOEaw3uEU0frpgaEicE6IQbHQwSW5Trz8UTgPUME\n    DqcXAgPqEKwHwLvBL0D8zc2O6/0Ce1X/7ga/RN/1orGeL+G3Li9O/0/0tRsN8CX22s/syHsO0Zdh\n    bGZ2DPaFQGw/tShMDLab56fnhiBcF64bHE8PDLYIwYAdDCYEx3Od+fgdARggArsQgsOZEIJ1AHg3\n    /M2BX4D4C+yJvzut+bvTVM+7oi+wLvxqoC9A+K0J0dd+OJ3zulkJeIm7DLN2VkNiArGdaE4dTRS2\n    l+ee54QgXBYNCAbWxWBWBdsIMfhxrgu32w2CCcB3yQFggAjcOq/qNq8HYOJvOrsD8G5TPxN+9UL4\n    jacX/AJr4i/hd3y4lq+9EHrXzArIS9xlGEaa2aGYMGwj2usJA8RhS+HawfUhBvvTC4FdrGEwIdh2\n    rgu32wWCX3/8kwhMBJZkkmrgOgDeDX8BVv/mZif8JfzqxRL8Avbwl/BbH67tOy6f8PyZiSb2Enpt\n    ZUbwJfAyDNMrswExQdheWDG8Zn7kc1EcrhX8OD0hmAgcDyH4ca4Lt9sBgonAd8kFYGA/BJ6kErgc\n    gHfEX4AALM2bQ79Xx1/Cr16swS+wJ/4SfR+H6FsWVvjaSy36EnrtZRbsJfAyDDNDZsJhwrCtaKAw\n    MdhOWCFcHmLw4+w4NbQ1BHZpicGzITBACA7l9eHvO0Mwq4DTmQCBCcC5kQIw4ZfwG8rV6IYXpiX+\n    En5laYm/RN+HIfjmh+v42guxd43MAryhEH4ZhpkxM0GwL8RhG6lFYYKwjRzXECYK56cUhInBZbGE\n    wIBNCCYCP8514XaE4PWTg8AE4D55lfdwAnBOiL/h7AS/QBn+Xo1udGVaAbA1/CX8zp3adX0Jv/K8\n    8Pwb0XdMOJXz/CHyMqvkm8lfy7F8uemgD+PPzEBMHB4TThs9f557zjtBWJ7aNYNXA+HdIBiwhcFE\n    YH+uC7ZZHYEBQjAgh+DdEHgEAANZCFwGwMRff3aEX2CvdX6BfPy9Gt3gyuww7fNu6AusBb+16OtC\n    /E2HVb5jowm9LgTfvpkVegm8a2VlpJ01xOX1MiMQE4b7RxOFAcLwiLA6OD+1EAyshcGE4HEhAodz\n    nfn4HRAYIAQTgf0xjsAE4FQIv+HsBr8uOQB8NbqxFWkNv8B4/LUGvz3W9wXWwV8N+CX6yvMJz1XX\n    aGMvoXdcZkBfAu8cIdwyqRCS58gMOEwMHhei8Nz5kedbHELwfXZcIxiwAcEtEdhlVgy+znjsLgDs\n    4iB4RwQGZBBMBG6fV7KH5QMw8fc+u8IvQPyV5Gp0YwvDit/+IfzmpQZ+Cb7yfI0L/GZ0IzZNDf4S\n    esdkBuQFCL1WQshlLIZ4bCPEYSYUric8X/4I4Cued3FqQJgQnB9LGEwItp1r4eN2Q2DgDoJ3RWCA\n    EHxObwR+JXuYHIAJvw+zM/4CwJPN+r/6mr87VPu6WMJfwm9+SvCX6CvPC3Ba594pxV5C75jMAr3n\n    EH7bh6jL7BJCcZ/MAMHnEIbHpAaGicL94qaK5jTRspRg8CoIDOwJwRYQGCAE+3Kd+fjdIJgIzGmh\n    j+mJwK9kD0sDMOH3cYi/+/S/BH4B4u8xVuDXxQIA94Bfou86/W8VrufbN6zqnSszQi+Rt08IvQwT\n    DnG4T2bDYcJw/xCF7eb56fwShNMhBu8zPbQVBHZpjcGzQPB14XY7QfBvcYt/Hd2IwWE18MP0guBX\n    6YeEAZjw+zi7wy8A/A7Av21wHkrhF5gHf3eCXwvo69ISf3dHXxfirz8E3z7h2r3zxjr6EnjbhrDL\n    MH1CJG4b6zhMDO4XriU8RwjCsnB66Lu0xGALAOyyEwTPgsAAITgVIjCrgX1pDcGv0g95DMA7wS8g\n    x1+AAPwGF8uv+bsD/Lq0AmDCbzit8HcV+K1BX4Dw68sRfQm+baIJvsTePrEMvURe/RB2GWbOEIr1\n    YxmHCcN9oonCBOE2OYIwMfhxaiDYZQUQbgXBlhDYxRIGt4DgmQDY5bpwux0g+MMGfUxFisAAIVgr\n    r+I/fgjAO+FvDvwCe+Pvm0PfVwbgHaZ7dmmBv1bg1xr6Aqz6jYXo2y5f4wK/Gd2IhcMpne3HMvQC\n    xF6tEHgZZs8QiPVCGGY4ZbTd/MjzG0wtBhOCwyEEh0MEvs914XYrQ/Drj39yTWB5iMA6eRX+0T0A\n    E3/j2RWAd8Bfwm99LOCvNfjlOr/xcIrnNvmE56ZZSsGX2Ns21pH3GIKvTgi+DMOEQhTWiWUQPoY4\n    3DalKEwQbhdicDylIDw7BLdeI9gaBluA4FZTQu8EwTsgMLAnBOcCMLAXAgPtIPiV/58vbv+/+HR0\n    n7umBH+B/QD4zam/q+IvkA/AV6MbXJDV1/u1hL+E33hK4ZfoG46b5plTPOuF2GszxN49QuBljrms\n    3P5mdAcYUyEQl2UWEAaIwq3DSuHxcVNEc3rocAjB7WIJg0dDMNcFfpzrzMfvgsDAfhBMBE6n49rA\n    ewEwK3/T2Ql+gTz8vRrd2IK0hl+A+AsQfaXJxV+irz9c11c3nMrZfqzCL5G3LARe27kc3YDFczO6\n    AUwwxOGyWMZhYnD7EITH5vnpHBKFHycXg2dHYGAfCB4NwEBbBAbWh+CVAdhl52pgInA6rREYAF7t\n    BMDE33R2mO75GCn+Xo1uaEF2gF9gPP62ht8V0Bcoq/ol/t6H4KubGvA9hvirH4vQS+QtD6HXRi5H\n    N4Cpys3oBjAAiMOlsYjDROE2qYHgY4jCdTmCMDH4PiUVwStAMLD+9NAWEBggBPtyLXzcbggM7AXB\n    ROB0OiAwAdiX3eAXuMffHeAXWBd/V5/q2YXwaz+c6rkunNZZP6z0tRGLyAsQemtD7G2fy9ENYKbJ\n    zegGbBKicF2Iw2uHlcE2wumiH2bXqaFdWmIwIfguhOCHuc547A4QDNxj8E4IDORB8G4ADDRHYALw\n    MTvCL3CHvzvAb+5av8BcANwSfwm/D9MKgGeHX6JvfV6A6KsVruM7NlahFyD21oTQW5/L0Q1gmEhu\n    RjdggRCGy2MRhQHCsFZKUZggrJPnuCUEH1KKwcDcINwKgUcD8DEWMJjrA9/lumCbHSD4NfYDYBcJ\n    BBOA1UMABvaFXwD4HYB/26D/JfgLzAPArfDXAvxaQV+XltW/MwIw0Vcvn/CcFIfYayOW0Rcg/EpC\n    4JXncnQDGMZQbkY3YJIQh9OxisDHEIT1QhTuH0Lw4+xWGbwDAgNrQ/DqCAysD8G/xS3+dXQjBiYF\n    wbshMAFYIcRff3bA31L4BebBX0AfgAm/j0P4vQ/RVyec5rksnMrZTiyDL7E3HCKvLJejG8AwC+Vm\n    dAMmCHE4HqswTAzWDaeO7hdOD+3PLhi8+trAx6wKwTsgMLA2BBOBicAuBOCKpKZ9Jv6u23/Cb3mI\n    v/fhWr8PQ/ity4vD34m+8hB8x8cq9BJ54yH0pnM5ugEMs3luRjdgkhCH47GIw4RhnRCE+4Ug/DC7\n    QDCw9trAx6wIwTMhMMBqYF9++7FvhGB/iMAqWReAWfUbzpPF+7/6dM8A4bd1WO3rTwkA746/rPKt\n    C/G3f6xhL5E3L0TfcC5HN4BhGHFuRjfAcIjB8hCG1wgRuH+eH87bziBcgsAzArDLDhC8IgIDhOAV\n    8mHhvknCauC7NELg9QA4VfUL7A3AxN/HuRrd6Iy0WusXIAATfcMh/MpD8K0LwbdviL1zhsj7MJej\n    G8A8yrcLvka/2HxQxmJuRjfAWAjDshCF5w9BuH92rw7eDYKBtTF4NAK3WhcYWB+CVwZgAHgN4J8X\n    72MsKQQGCMGFWQeAJfAL7Iu/bz72+19GN6RxcgD4anRjM9ISfoHx+Ev4tReirzyc2rk8peBL7C0P\n    0XeOEHnvcjm6ARtmRby1FEJy39yMboCREIfDsQbCxOCylKIwQTg/xOC9MHhVCF4ZgYF1IXgHAHbZ\n    EYIlAAzsg8CAGgTPD8BS+HXZDYDfnPq7MgBL8fdqdEMz0hp+gbH4O3rKZ+Lv4+TC767oewyrfuUp\n    AV9ib3msYa8L0fc+hF4ir0aItvuFkKyTm9ENGBzC8MNYw2CAIFyTEhQmCKezOwAfsxMGt4JgVgO3\n    zYoQTAReN1IAdtkFghUQeG4AzsVfYC8AJv4+zNXoRmZm5arf0fALtMVfYC4AZrVvWV6A6JsKwbdP\n    CL3zZGfwvRzdAOMh4jI9Q0CO52Z0AwaFIPw4FlEYIAyXhCCsH2LwfVbH4FUrgV1GQjAR+GGuhY9b\n    FYJfe/5tJwjORWCAECzInABcAr/APvj7xtPPVfF3xapfYN21fi3AL8DKX6AMfYG94Zfgm5cc/CX6\n    ymMNe4m84eyMvQDBl6DLrJLdsfhmdAMGhygcjjUcJgrnJQeECcGyPMft9hhMCC6LBQQG1q0IXhWB\n    gX0geBcELgFgYB8EBoogeD4AJv7Gs0vV76pr/QLt8Jfwe5dW+Ev4XTNEX3m4nq9+iL1zZGfovRzd\n    AEMh+DI7ZXcUdrkZ3YDBIQ77YwmGicLhcN3gttkZg0sQGCAEA4RglxYQvDICA2tC8K4IDBCCU8lE\n    4LkAmFM+p+MAmPB7n6vRjc5IC/wl/BJ9XYi/6XA9X3kIvu1iAX6JvQ9D5N0zRF2Gqc/OWHwzugGD\n    Qhh+GAsgTAhOhyDcLjtOFb0DAru0wGBC8F20IXgmBL4u3G51CCYCp0MEfpR5ADgXf3eDX5cni/a7\n    BH5drkY3XpDV4NdlNAC3gN/Z0NclF393RF+A8BsLwbdNLGDvMbvD767Qezm6AR1D1GUYm9kNim9G\n    N2BAdodhCxB8DFE4HoKwfp4fzg0xOJwZERhYtyp4NAID+0LwdeF2KyIwcAfBOwGwC9cFDkeIwHMA\n    MPE3nd8B+LdF+12Kv1ejGy7IitM9u4zEX1b83icHfndCX+Ah/ALE33MIvm1iCXx3x95jdoDfy9EN\n    6BQCL8OsmV2A+GZ0Azpkdwg+hig8V0pQmCD8OM9P54QY7A8h+GFGQbAFAAb2nRb6umLbVSH4w6L9\n    SiUHgncBYECEwGsB8I7wC6yLvytX/baCX2A8/hJ+x4fVvrJwfV9/cuCX2BuOJegFiL0uO0DvOZej\n    G9AohF6GYYB1YfhmdAMGhDB8H0swTBQOJweECcGPs+PU0MesjMGtEBjYG4JbIDCwNgSviMC/xS3+\n    dXQjBkYKwUTgn7IGABN+18yq6/22xF9gHACvCL/AXPjLat90Ptm035JI4Zfo648V8CX03oXQu1aI\n    vQzD5GZVGAaIw7uGKGw7UgwmBIfz46bnZtUpolsiMLAnBLcCYJcVIXhFAHbZGYIlCEwA/inzAzDx\n    d93kAPDV6MYK0hp+gTH4uyr8AnPgb261L7Af/hJ9/SmZ4pn4+zij4JfQS+RdKQRehmF6Z0Ugvhnd\n    gAEhDI+FYULww3CKaL3shsG5CAzMAcGrIjAwDoKJwHe5znjsyggM7DslNBCHYALwT7EPwMTfx3my\n    Qb+l+Hs1uqHCrFj1OxJ+XVoA8AzoC5TBL7AP/nJ6Z3+IvvUh+I7JLth7OboBjULgZRhmpqyIw8A+\n    QEwUHofCBOH7lGAwQBA+Z6dpoksQGJgDgoE2GDwSgF1GQHBrBAbWguDVARggAodCBAZgHYCJvw/z\n    5mOf/2V0QxpmNfh1aQXAu8IvoI+/hN+58+Lwd8LvfUrAFyD6unBa5/FZGX4vRzdAOURehmF2yGo4\n    fDO6AQ2zMwRbmS6aIHwXYnB9nh/OxeoYTAjODyFYP7MAMCCvBl4dgl8D+OfF++gLAfguUwIw8fdh\n    3hz6vCoAE3/l2XGdX5dd4deF6/w+zIvT/xN/89GX2HsXYu/4rIy9wHrg60L43Su/Gt0A4/nL6AYw\n    3bIaBB9zM7oBjbMrDBOFbYXTRZfl+ekcEIMfZhYEdtHEYAsIDKwFwTMhMEAIfn34+24QTAS+SwCB\n    bQLwf038fCcAfnPq64r4S/iVZxT8AuPxl/Arz+rwy2rfcCT4S/C9y2jw3RV6V0feYy5HN0ApBN65\n    Q7CdOwTlebMKEN+MbkDHEIbHhCB8FwkIE4AfZqeqYECOwTsjMDAegketDeyijcGrIjCwHgS/Pv3/\n    Tgj8O0Ffd4FgDwLbAuAU/LrsAsBvPP1cCYCl8AsQf0fCLzAWfwm/sqyOvsdwfd+HIfrKw/V7+4XQ\n    O1eIvPOH0LtXCMNzZwUcvhndgI7ZEYa5hvDYSKuDCcL3+XGjc0EIlmcUBo9GYGBvCL7OeCwReJ1I\n    EBjYA4JPCGwDgKXwC+yLv7vCr8vV6EYLsxr8AmPwVxt9j5kFgAm/j/PJRn2NJWeKZ8Jvf/TdEXtd\n    Vkbfy9ENUAiR136IuEzrEI7thzhsPzuCMNAfhYnBdyEG5+WPAL7a5FysBsEtANhlVwhuMTX0DBB8\n    XbDNShC8KwJLAdhlIwgeC8A58OuyIwDvjr+AfQBebbpnYD34Bezjb840zy6rAzDRN39NX2Bv+CX4\n    9stq4Hs5ugGKIfaODSGXWS2E47FZAYVdbkY3QDm7YjBAEO4Zrhdclh2qgldcI5gQrJ8dIfi6cLtV\n    IHjX9YBzERjYAoLHADDhNx0HwMRf2/jbAn6B/db63b3il/D7MJzimegrDdfx7Rdir+0QfNuHqCvL\n    Xxd+Lf5yo8GTmhCL22clEAaIwjOH6wf3DzE4P89xu/QawbkI7GIdgwnButkNga8rtl0FgYF7CCYC\n    x7M4AvcHYOJvOm9wsRT8uqw09XMr+HUZAcCj1vlthb+E37ny4vD3XfGX6JsOwbd9VoNeXy5HN6Ai\n    hN522Ql4V0baWbMbLhOJ22R2GL4Z3YDG2QGGCcJ9QwyW5/mh36ticAkEW0dgoB0Ej0JgYAwEtwBg\n    F6sQfF243UoA7PJhwT6lQgj+KX0BOBd/d4NfAHiyaJ9z8fdqdIMjWQ1/R8GvizYAE37nyYvT/+8K\n    v4Acf3cDX2Ac+hJ718jl6AYUhMjbLzOiL/GWiWU2SCYE98usOHwzugGNQxRul90wGOB6wdIQgx9n\n    BggGdDF4JAADROCeuc58/IoADAC/xS3+dXQjBoRrA3cCYMJvOqvCL5CHv1ejGyvIKtM+j4ZfQBd/\n    Z4BfIA9/V0RfgNW+LhL03RF8XXrC7w7Y67Iq+l6ObkBBCL3tYxl4CbmMpViGYyJx2xCGbWUHEAb6\n    ovCOEOwiAWFi8F3/CcFE4FHpDcGtENgyAB9zLXzcqggMsBpYksUQuD0A5+DvjvC76nTPLlL8vRrd\n    UGFWwV9gPABr4e8s8AvI8XdV+AW4vi8rfcMh+LbJSuB7OboBCiH66sUi7hJ1mR1iDYsJxHqZFYOP\n    uRndAMXsgsEAQbhHiMHxrL5OMCDD4FkQGFgHgketC7zbmsDHXAsftzICA4TgVBZC4LYATPyNh1W/\n    88AvoI+/I9DXZaX1fmcBYAn+rgy/X+MCvxndiAHJXdd3J/gl+OpnFey9HN0ApRB7y2MRd88h9jLM\n    XayBsC9E4roQhu1kFxQmCLdJ7prBu4Lwj4v3exUIbrE28CgIHoXAgD4Ez4LAACEYAF4D+OeF++fL\n    hghsA4B3w19W/d7lanRDhVkJfoEx+NsCfgH7+Ju71u+KAPzJgn1KJRd9gT3gd8RavqvC7yrQC8yP\n    vUTeuliEXsIuw7SJRSgmDNeFMGwnq8LwiPWDdwDhXAgG9sTgVSF4tWmhV4HgkQgMEIIlWRWCd0Rg\n    QA7BCyBwOwCW4O9u8Ausjb+E33gIv3oh/NrPjlM9s9r3YUaAr8tq8LsS+B5zOboBGSH01mc09hJ2\n    GWaOWIBiwnB9ZsHhm9ENaJiVUHgEBLusDsKsCo5n1TWCcxDYxTIGt0BggBCskVkg+DrjsStC8OuP\n    f+4GwRIEJgBHQgB+mDcf+7oi/krhF5gDf1us87vbdM87wm8u+gLrwe+Lj3/uBr8A1/Y9h9M712VF\n    8L0c3QBhCL16GQG+RF6GWTujcJggrBOi8LishMEunCa6TbhWsD/PD31eCYNXg2CAFcFa2RGCrzMe\n    SwReJykEJgBHkgLgHfEXWA+Aib/xEH7rYxl9AVb7vjj8fTf4laDvLuAL9EHfFbHXZRX0vRzdgMIQ\n    fvPDil6GYSxkdMUwcTg/s0DwOTejG6CUFTHYpQcKE4MfZmcMXgmCgXwMJgT3CdcH7pvrzMevBMGv\n    D38nAt+HABwJAfg+qwJwDv4CtgF4parfEfAL6OMv4ddudkVfVvk+DMG3LrOD7+XoBhSG0JsXIi/D\n    MDOHODxXCMNjQhCuyy4gLJ0qejcQXhGDCcHxjEBgYBwEayMwYBuCrwu2WQWBX5/+fycEXrwKuA0A\n    c/rnh1kRgHPxF7ALwC3wFxgDwMTfPsnB3xXhl+j7ODugL8G3LITeMSH0ykPkZRhmx4zGYYBALA1h\n    eExWhGGCsE6IwY+zIgQDcgy2jsCALgSPQmBgDAQTgdNZEYEJwPchAJ9C/H2YFfEXYPWvJD0BeBT8\n    umgBsHX4dZEA8Erw6/LJgn0KRQq/wLr4y3V88zM79gLzgS+hV56R0EvkZRhmpozGYcKwPDPh8M3o\n    BihkJRTutYbwqiAsRWCXXTD4xwX7SQT2ZycEbgHAgF0Evi7YZhUABvZcCzgFwMDUCKwLwBL8BfYE\n    YOKvzayAv8BYANas/rUOwLtW/gL74C/hl/CbmxXQ1+VydAMSIfaWpRf8EnkZhtkhvXCYCFwW6yB8\n    M7oBypkdhHshMEAIBvZB4Oe4ZSWw0XA66PKwCjielQAYIAKHMikC6wCwFH6B/fB3JfgFiL+pcNrn\n    8ljG313hd6cpnznVcz/4XQF9gfnh93J0AzJC+JVlRIUv0ZdhmJ0zqlKYOJyOdQg+5mZ0AxQyOwS7\n    cIrounBq6IdZDYJz1gbeCYKJwHWxjMBAHgSvhsDAHQQTgR9nMgiuB2BW/T7OivALyPH3anRDBdHG\n    3xHwC4zBX8KvP6vAL9H3cYi+5VkFe4F5wfdydAMyQ+yNh8jLMAwzR0bgMGE4HcJwnxCEZSEG74HB\n    q60PTAgOZwQGE4L75DrjsatBMBE4nEkguByACb+Pszv8Avbxl/BbHk717M8K8Ev0fZxV0ZfgKwux\n    t22IvPEQeRnmPl9Wbv/N6A4wjCesHLYXwnD7rIDCBOHySECYGDxfVsFgQnBZtCHYOgIDcgheDYEB\n    QnAsxiE4H4A53bM/K+Iv4Tccwm9ZLMPvbugL7AO/EvQl+JZlBfAl9rYLoTee3tBL5GWkqUVX5nEI\n    0Yw0vXGYKBzPLDB8M7oBBSEIp7MqCBOD77LSFNGEYH8IwWWxDsHXGY8lBM+fBSBYDsCEX38Iv7ZD\n    +C3PLlM97wq/q6MvsC/8En3jmRF8L0c3QBiCbzw9wZfYy7j0xtyVX3sjqjYJxwxAFLYUgnC7EITj\n    WRGDCcF3IQTby+wQPAKBAUJwLKtBMBE4HmMQLANg4u/jvPnYT+Kv3ayAv4TfttkNf1nx+zDE3/wQ\n    f/vncnQDBCH8hkP0ZVpEA3X5erETDdwjFO8TYrCNzADBN6MbUJDZEZgVwWUhBK81NTQR2J9dqoEB\n    QnAoqyEwQAiOxRACpwGYa/0+zopVv4Acf69GNzSRFeAXIP62zm74C+xR+bsj/hJ9wyH46ofY6w+h\n    lylJDeTydcAcU4OCxON10hOHCcP+WIbhm9ENKMjMIEwMzosEgYG1IZiVwDYzOwQTgfvkOuOxq0Ew\n    ETgcIwgcBmBW/fqzO/4CtgGY+FsebfwF7ALwbvi7euUv0Vc/M6LvbNh7OboBiRB6H4fIy4RSCrl8\n    npnRKQVDovFcIQyPjWUUBuaD4RlRmBgsDyF4HQheBYFnB2CACNwr1xmPJQLPHykEG0BgPwATf/0h\n    /trGX4AAXBNNALYKv4Acf1eBX6LvGiH4Ps5M4Hs5ugGREHofh9DLuJTALp9TZtWUICKh2HYIw+NC\n    FNYLQfhxdgPhVTF4NwgmArfNCATeDYABTgdNBPZnMAI/BmDirz+rrvkLrAPA2vgLcN3fkljF313g\n    d3f0XQV8gbboOyP4AnOg7+XoBiRC8H2YntgLEAetRWMtXYDPK7NnuHbxeuH6wuNjGYZvRjdAGILw\n    wxCD18hOGLwDBI8AYIAI3CPXwsetCMAAETiWgQhcDsA74S+wLgCvgr/A/NW/M8OvVfQFCL+zh5W+\n    eiH6tsvl6AYIQvi9Dyt8GQn88rljGJ1IUJEQbDME4TGxjMDH3IxuQCIzQrBLKxAmBs+f5x/7NDsG\n    z14VPDME90ZgbQAGbCPwdcZjV0RgAnA8gxD4IQCz+jccArBdAJ698pfwq5+d0BfYF35XQV+XFvg7\n    K/oChN/aEHwfpjX6EgttJQa8fK4YxmZi2EggtpUeMEwMfhirKHwzugGCzAzBgD4Gr4TAACGYEDw2\n    hGB5dqoEvs547GoITACOhwBsPKut/5sDv4BN/CX85mf1qZ6l8AvMjb8vDn9fEX+BOAATfmWZDX9n\n    AF/AHvoSeh+G0Lt+UtW7fI4YZs2wkniOtMZhwvB9rKHwzegGZGQmFOb00LKkIHhFBAYIwVZCCJZn\n    Fwi+znjsSgj8+uOfOyFwDgADQxCYAJzKipW/rPp9HMKvPITfsVkZf3eZ7rnlNM/APPA7A/hejm7A\n    KcTe+xB61410XV4+RwzDAHJwJA6PCyuG+4UoXJZZQJgYHI6kEhhYD4Kfn/ozMwRLERggBLcIIVg/\n    15mPXwWCicDxTAPAxN85Q/h9nNXX+V0dfoE8/AXWAGDC73zZfW1fYm9+iL134Xq960YKvS58fhiG\n    kSYXHInD/dJzXWGi8F2IwvmZAYSJweHsiMErVALnALCLRQjWQmCAEFyS2SGYCDxnlgNg4u98Ifw+\n    zurwC+jiL2ATgHfC39Xgd3X03R18Afvoezm6AZHsir/E3rXDqZsZhrEQTiVtL0Th9rGGwMfcjG5A\n    IjNgMEAQ9mVHCAaAHyfvz+yVwJoA7NIbgonAbXKd8dgVIPj14e87QLAUgYcCMPH3LivBL0D8Pac3\n    /LrMXPkLzI2/M6MvAHwyefuPWR19Aa7n62IRfy9HNyCQXbHXhVM5r5kQ9vL5YBjGckIQSRAeE04d\n    3TZWUfhmdAM8mQWBj2kBwrNCsIsEhFfC4F0gmAjcJr0RGCAE+7ISBBOB7zIMgIm/9/ALrIG/hN/H\n    If6WZVb8JfzaiQR+Z0ZfF238JfrW53J0AzzZHXyBNuhLWOyfWEUvnw+GYVYLcdhOWsHwzhgM2ATh\n    m9EN8GR3DJ4dgYH9IPg5bpefGtoiAgP6ENwTgUcAMEAE9mUFBAYIwcd0RuCL29vDFNC+EH7nixR/\n    r0Y3NBFW/pZFC4AJv/2z2jTPQBx/V0BfQBd+Z0Jfi+B7zOXoBoDY26q6l7jYL9J1evmcMAyzWziV\n    tK0QhdtlNAzfjD4BicwEwoTgx4lh8EoIDBCCR0YLgneoAgZ0EdgqALtcCx+3GgID60OwIQQOA/Dq\n    8AusN90zsA7+AnoATPzNC+G3f158/HMl/F0dfnec6pngG8/O2Ntj7V4CY7tIkRfg88AwDBNLDkIS\n    h9uFU0e3DUE4HssgzHWCwyEEz5PdIZgInBfrAAzsh8AAq4GP6QDBfgAm/s4bCQBfjW6kIDNX/xJ+\n    9bIL/ALr4G9quueZ8Xc39CX4yrIb/PbAXoDQ2CKs5mUYhhkX4vC49ABhYE8UHo3BLjejGxCJVRAm\n    Bj9OamroVSD4+aEfq0MwYA+DZ0RgoD8E71QFDOyJwMAdBO+AwEAcghsj8EMA3gF+gXXxF0gD8NXo\n    Bgoy69q/I+AXqMffWeHXZUYAXg1+JWv8AvPhbyvwBeyiL2ATfi9HN+CUndC3NfgSG/vkjL8870yv\n    fDf5a+0XmwxIMONzRkoicPuwUlgvViDY5WZ0AzyxCsEAMfgYyfrAwBoYPDsESwEYsIfAACFYEiLw\n    46wGwAAR+JhGEHwPwDvh74rwC8xf/Uv4lWfVdX5z4BeYG39nh18p+gKEX8A2+LpYgt/L0Q04heCr\n    E6Jj2/gqfHnOGY3MjrgjQjhmNOIDSsJw+3A9YZ1YQuGb0Q04xDIEu7QA4VUhGJgfgx0Er47AACFY\n    M70gWBOBAdsQfC14zIoADOyFwEB3CL4D4F3wFwCeLNrXmdf+1YZfYF381YJfwBb+7gC/Lp9M3HZg\n    3WpfF038Jfrm5XJ0Az5mJ+x1aYG+hMd2kUzlzPPPWELbL0Y3oDDfjm7AIQTlvSMBScJwu7QA4d0w\n    2MUKCt+MbsDH7IbBsyGwyy5VwTOvDTwzBGsAsMuqEKyNwIBNCL4WPm5VBP6waL9CSSEwoAbBF7f/\n    N56M7m+3/A7AvxkaDNGKFH8BewDMql95NPEXsAPAq0/3DABf4wK/Gd2IyhB+ZSH6luVy0HGJvboh\n    OuqF6/UyQHvEnRVmV0oPZCYerx0pThKI9cIKYb2MBOGb0Z0/ZScMnhWCARkGzw7BfwTw1aR9mHVa\n    aE0EBvpD8KzVwIA9CL7OeOxqEPxb3OJfRzeiczoh8D4AvCL+5sAvYAt/Z4VfYO6qX8AO/LpIAJjw\n    Oz4xACb62o5F8AXGoO9u4Mv1e+2H1bz7ZFRFLpF37oyoQiYYrxFWDfdJ63WEd0PhESB8M7rTgVgH\n    YWJwGINnB2CX1SHYEgAD+ggM9IXgWdcGBmwh8HXm44nA80eCwEAVBBOAZw3x9z498RfoB8Da8AvM\n    h7+zwu8LzL/Gr0sIfndH32MsArBF9L0cfPzV8ZfYaz8p7OU5njs9gJeYy0jSGo0JxPMnhZaE4foQ\n    hsszeprom9EnwBOLGMx1gu+zOgSvPDW0NQQG5q0G7gnALoTg+6wEwZwKOpxCBN4HgFdZ+3dm+AV0\n    8bc3/ALz4q81+AXi+Dsz/LrMDsArwW8L9AUIv6lcjm4A1kVfTuM8V87wy3M8d2qhl4jLWI0GHBOH\n    580ZLInA+mmJwgThdrkZfQIO2QWCgTkxODY99OwY/Pxj+wnB/TLj2sAjEBjQhWAi8Pi8BvDPi/RF\n    msYIvAcAv8EF/mV0IyqTC7/Auvg7An5dZgPg2eAXmBN/V4Hf1Dq/s+HvLtW+gA34vRx8/FWxF2gH\n    voRI/bDKd+6U4C5Bl9k1pWBMJLadGFIShfXD9YTzQxC2CcEAMRhIrxE8MwQ/P7R9RgjefVpoIrA8\n    lhAY2BOCd0PgHAAGshF4bQB+cxjEmRmAZ6/6ddEA4FH423PdXw38nRF+gfnwdwX4TaGvy0z4qw2/\n    RF9/Lgf3f2XwPUYbfwmQ9SHyzpfSql3iLsPUpwSKicT2wmmj+0QbhFeGYJfdQdgqBgO6ILwSArvM\n    isEzQ7AEgYE1IXjV9YCP0UJgawAM7IfArz/+uQsC5wIwkIXAawLwm9Mgzy74ezW6sZHMir894del\n    BoBnhV+XWQB4J/gF9sNfq+ALEH1XR19W+toKoXeusHqXYeYLq4jnjwQsicNlaVEdTBBum5vBfd8B\n    gwnBdjIrBEsRGFgPgnsiMDDvusAWAdjlOvPxM0Pw68PfV4dgAnBmiL/2MiP+zga/gD38XRF+XV5g\n    XvgFZPhL9LWR0eB7zuWAY66KvsReOyH0zpmatXgJvwxjL8TgtcKKYf1wuui8jIDgm9GdPsUqCGtg\n    8EwQDKw9NTQA/DhZ+3MQGLAFwbMhMNAfgldHYEAOwTMDMPAQgYG1IbghAq8DwCvBLyDH36vRDU1k\n    tnV/Z4RfwBb+rgy/APDJhG0+Joa/u6EvQPiV5HLQcVeCX2KvrcTAl+fUVjh1M8MwLpxKev4QhduE\n    lcLxjKoIvhnd8VMsYjCrgh9mdgT+I4CvJuvDrNXAs00J7dILgleeCvqYa+HjiMDzpNFawGsA8Gr4\n    C8gA+Gp0IyPRgl+XHgDcG3814NfFAgCvDr9f4wK/Gd2IiqwAv6uv7bs7+hJ84yFM1ofwazO5yEvc\n    ZRgmlBwkJg6PSwwsicD1YaVwPLtXBq8MwcAaGDw7BM9WDQzMB8EaAOyy6rTQWggMzA/BswOwyy4Q\n    nIPAWwDwivDrkgLgq9ENjIT4G48m/AJz4e+M8AvMXfUbgt9Z0BfQh1+A+HvO5YBjEnzDIUbWJ4S9\n    PLdjkoO8BF6GYVqEOGw/IbgkCtdHG4VXwWBgTxBeHYFdZsHgFSH4OW6nWhfYRQrBqyEwsB4EawKw\n    i2UIvk78nAg8XyQQvDwAH/F3JfgF5sVfbfgFiL+xWIBflxQAzwi/Lz7+OeNav6k1fmfAX6Jv21wO\n    OOZK4OvCSt/xYVWvrbCal2GY2ZI7tTRxuG9YLawXThUty24gbA2DCcH+zIjBzz+2eUUItgDALjND\n    cI9q4J0g+Drys1UA2OUIwUTgZOYG4NXgF5hz6udZ4delBwCvWPXrshr+vjj8fTb8XQF+XVZd45fo\n    O39Y7TsmhF67kaIvsZdhmFkiQWFC8NgQhuvDqmBZdgLhVTF4FgAG4ggMEIJ7JwbBlhAYmHNa6Bmn\n    g3axiMDXiZ+vhsDAPQSvjMBAHIKXBeAV8VcCvy5Xoxt7yIzTPR8zG/5agl9gLfxdueLXZQYA1oBf\n    S+i749TOLqvgryb4EiplIfbaS25lL0DwZRhmnbBKeI4QheujicIrgfAIBHa5GdhvSyCsgcEzQHAK\n    gF0Iwf0yEwIDc0FwLwB20YZgawh8LXzcahD8GusDsIsPgpcF4CeLDf4Rf/vDL9Aef3eGX2Ae/J0Z\n    fgEZ/lqH39XQFxgPvy6XnY83O/oSe/vnS+HjeD77hFM4M1op+dKA5RD0mFCIw/aSg5iE4XSIwvfZ\n    qRr4HGJw3xCC7USyLrA1CJ4JgQFCsFauMx+/EgT/Frf419GN6JQCBJ4PgH8H4N8WGVDIgV+Xq9GN\n    /piZ8bfXmr8aADwj/AJz4e+s8AvMP+XzavC7I/oSfO9DoMxPCH95LtuGyMvkZDXI7R1i374hDNtK\n    CDEJwPkhCN+nNwjfjO4w1oNgYG4MnhGAXWaCYAkCA+tC8IoIDOhCMBF4fIjAwcwDwL/7+Cfx10Y0\n    AHhV+HWpBWBL+CuFX2Ae/P1kknaGEsLfHdAXGAO/sRvM3hB6Wfiz2hB8H4dYKYsPe3nu2iYH7oi8\n    68UC3P51dAOU8svRDQBxcLXk4DCf+7bxYSZRWB6uI/wwvUD4JvH/o/o58svZu1cFzwzBP07U9hkh\n    WAOBe60JDMxbDWwFgIF8BAbWgODffuwDEfhRCMC9Mzv8AsRfSVbB39Uqfl2+xgV+M7oRBYlV/O4C\n    v8DDG0utb/2WZhSIXnY6TgroWoCqZlq1j3AZD7F3bFLwR+ydJy0RdxWcXSUtkZmAOE9iMMznsV+I\n    wvnRhmCXWUA41M5W5+Wcm0H9Hrk2MtBuXMA6BANhDJ4Vgv8I4KuJ2j4bBNcicE8AdpkNgi0BMEAE\n    3hmBgUcQPAcAE39tpRaAe+Jvb/gF1pn6eVX8nbHyd9ZqXyANv5IbNUvTPANj0Pey47F6Q11LRNba\n    N/EyHGLvuLDCd65oYi7xljlHE5AJjTYirRLm89UnnEI6Pxr42QOAeyFzLwwGxoDwaAw+R2OcgRDc\n    NzNVArvMBMGzVQIDRODaXBdsswoC7wLAQBiBgZ8geA4AfrLAQGIu/l6NbnAgxN9wNOAXGI+/q8Lv\n    i49/zrTm70wVv74bDy0otQDAq6PvMbPg3a+E/7Zq/3vnS8FjeO7ahGv2zpFS4N0Jcy1MpZzKTs8H\n    UPacEBzHJHdNYYDPVaukII8o7E9rELZeLdwTgI+5GXBMCxisVRHs64u1sRhgnemhn+N2ijWBz5kF\n    gmdEYKAvBK+GwMCeEEwEfhD7APwGF/iX0Y2ozAr4O9O0z7NW/QJz4O+M8LsK+gL9bzb+VLCNBpbu\n    ir5Af/idFe1ysDf02Fn73iMp8OW5000JHhJ6xyT1XM0GiDOg7KqZ7bUCpF8vBMf+IQyPD0G4PLFz\n    lwu61gE4p++tcjOgn6tgcEk/RkAxIXhcdkJgYN1qYI01gVdA4NkBGABeA/jnBfohybQA/OYwuLIL\n    AF+NbmggGvgL9AFgVv2WZzX8nQ1+gTT+Ano3ESWwm0otmPZGX9/xvhn8mrnsdBz3XM02UNKjwtf6\n    usatwymd24dTN9tN7LmZEesAfeDlazKeEoyLZbXXHeGxb3Jej3xudMN1hP2J3Xtogehs9zdAv4H2\n    m8H9/PLQT801e3MyCoNj0YTi1DjPTAgM3EEwgKkwOAXBowHYZUYI7oHAGgDsMjsEz47Arz/+uQMC\n    TwfAb04DL7PjLyAD4KvRjfREC35dVgLgleDXJQXAs+DvjPDrolX92wJ3Q+lV7dsLh0cB8GWHY/Ss\n    aNYaeNHGWE3IXAmKj+hL7G2XGC4S1dondP5nBLYc1OVra+7kAN4qr2VCZPvEXlc8/+1yBs6VQFjr\n    s3+LqlhNEO71+b911exNp36c82WH95cc4K3F4J7VzTlIvBoCA3NBsKQS2AoCA3NB8ExVwC4WERiQ\n    QfAqAOyyMgRPBcBvPAMzswNwCn+vRjfQE234BdbB3xXhF1ij+ncn+O0JvKHUYOJXsDHFs8uq6Dtq\n    CmtLGY2Z1pD4XN07+vysGkLvuJzPvXUQI+QyLZJbhWz59+T8O0KcbBvCcP/MgMIjK2q1QfgvsPf5\n    PBVicPt8ffqzJKOnuvYB8SrTQR8zy9TQs1QBuxCBH0YTgF0sQvB14uezAzBABP4YGwD8JjBQRvzt\n    n1nxF2gLwIRfu3nx8c8Z8Vcy5bO1+FAxB3N3h9/LxvufFX1LB2LOA1KzgWbLAajQGr6znSPLyV23\n    l4Cnm+9wYQauSqZZ5uuBsZSZ0bhXNchO4dTR4zJi6uiZpkz2nR+t+4gZ0gMZbwb0ywoG11YPj0bg\n    khCC22W2SmBgHgiesRLYZTYInh2BXwf+fUUINg3AxF87mXHKZ6B95e+u+GsdfoF5q36P8Pvnj38+\n    H92oU87fIP2L0nkeDcC90feyc/9mBOAaBM3FzNkGeqTn5svEz4m+dcmFXoC4p5VvAXw/+PXLKl2G\n    eRgpDo5G4mcfB0H4e1mfkrWtCcN1SVW+5qDwqp9/gfoK4dnOTW9gvOncv9EQrLUu8a9O/bAwg9s5\n    53GoGSF4BgQG5oNgIvDDEIHnR2DAD8EbIfBYACb+2okm/vaCX4D4W5IVqn5dZgLgPyKOj70BOGcN\n    mdnxl+hrKz3BtzTWBoNC54xVvvphVW/fOFQYibwS4OXzzDB5kYDhSCB+dhgc4e93eXJhmChclxB2\n    +jDY2mdZl9bTL9eAsNVzFgoxuF00IPhXme3vjcR/Dvy7O++/6dyekswCwC47QvAqCAzoQ7A1BL4W\n    PGZ2CN4YgW0B8OrwCxB/tdJjvV9gLQBeCX4Bu/j7R8+/9YbfHNyNRQN+R1b8rgy/RN/x6TlIFDp/\n    qXOTqgxmHoZr9+rniAOjK3l9+SX43DLMyHyL8ZXC5xCH68O1hHUTq/YNgWdvzLS4ru5O1cE9Mfhm\n    QP9GYfAICA6lFRD/OfIz33m3BsMrIjBgA4JnAGCXGSHYGgADeyAwsMe6wCcEHgfAR/ydHX4BGf4C\n    6wLwavDrogHAo/F3NfgFgE8MtPePgse0hF8t5PWF8JuXyw7H2Al8j7GKv5JoDBodz2OLc7ErEBN6\n    9eIb5LcEvQRehpk7loD4mWdwiO8v+Qnh8M4wrL3G7xE+tRDTIvBKUwvBLgThh7np3KfdKoJzUwPE\n    uQh8jgUUXhGCRyPwLFNBHzPTtNCzArDLahC8IgIDP0HwWADeCX5drkY3+JRa/F1puudzZsdfwq9e\n    JNh7Tgghc+C3JfKeMzv6uqyEvzOhL8E3P75BpNbgm5sVgJjYWxfp9J6j0JfAyzB7ZyQQPxMMFPH9\n    SZbVK4a1gTc3EhCeGXhzQgzWzc2A/qywTnBrDD4mB4ZrIficETBMCNbNTFXAx8wCwdYQ+Drz8Ssh\n    8KoA/DFjAPh3AP7NwMBmbXLxF1gLgFet+gXq8ZdVv3rpPdVzCfaek1v52xN6z6mF3x3RF2gHv7uh\n    rwXkHJUYrv4VF8MHC2v70Ds5a/dyQP4+ues39oRetzYvny+GYUrTG4glKHwM398eRnpNsobCM3xm\n    +8+RczZD+1tlJxAmBOunFoN7QrAvZxzWBmBfeqHwTBBsHYGBOSGYCFyW68zHr4DAAPBhkX4E0h+A\n    ib92Qvx9nNmrfgEZ/gL2AbgH/Gpg7zkxjLQ06wHhNz+Xjfc/A/7Wou+u4JvC3pLMMFjXCohzsBfY\n    e4A9F3hdekLvf+p2JKZHLE0Brp1c3GNsxzoOu+x6Dcu9frVE4VU/c/2SKPwoO6wb3Hp66JsBfRqN\n    wbND8DF/Qh8IdmkNwjNAsHRdYGB+CCYC+2MJga8Lt5sdgn+LW/zr6Ea0S18A/t3HP2cG4BL4BWzh\n    7yzTPvfE3xXg12WF6t9WUz23AF+XI0aeq3xHVvj6UoO/o+F3NfR1WRl/d0TfFuCbm1kG7qQDllL0\n    3WmgvBR3XXpX8+703FjPykg7a4jLtjILDgN7vbe2qBBe7fNSTQjCD1OKwTMgMMB1glukBoItITDg\n    nzrawXDL89wKhK1DsBSBRwOwy0wQ3AuBgToIJgKPzW8/tn1RBO4HwMRfG5kFf4F+ADz7dM/HzI6/\n    mlW/LbH3mJ9H2msNfoE58bcn+l52Os4M4OtC+E0nNChn8RzMMoDngCo0sL3qgHct6vrSC/t+Gfj3\n    VZ+r0SHiMi7E4zaJvR/3wOFWz+uK78nfJv59pt8RS8trAGEEneXzZOvzkAox+GFuOvZpFAavhMBA\n    fA3hP6PPedZC4ecf22oVgmeYCvqYWaaF7gnAAKuBV0BgYDkI7gPAK+AvkA/AV6MbfEgt/LqsBMAr\n    Vf0Cafy1Dr9AHf72AF/3wfMm0c7V4BcYg7+rwe8s6MtpnuU5D9Kt0PcRA3oxyNIeqG458N0Cb0vT\n    Agd/mfj5iqjQK8RcZkRmQjFrSb3fawOxpeeq9Xu95rU0tq9R59Qa8ObmDKE7QfAO00MD61UGj4Dg\n    laaEdvlT4ueXhza3HpurAWHrCAykIdgSAgNzVAPPUgXsQgQel0URuD0AE3/HRwt/gTWmf14NfoE4\n    /lqGX+Aef4E8AB7xoXJH+AXWxt/LxvufAX1rwRdYAz5zchy8263vNQN9EuQiIpZFCxCJvHoh6jKr\n    xBI+zpBeOMznJT8SXK49r7MDb24ciu4Ewcd+12QGEF4Fg2esBgbmh+BjWo7f5YLwDAgMzAXB1quB\n    ZwNgFysQfJ35+JkB2GWxKaHbAvDvMD/8ukgB+Gp0Qw/RhF+A+OtiCX9nrvp1yZn2udWHRskHxpuN\n    pnoGxq71Ozv+Wkdfgm9+fIN5u50DadwAoBS/CIryaIBiCngBPielIfgyu4TwWBZpZWstEPP5yUsu\n    Cu8GvJJwmug9QLglBt906sOsEAzMhcGXgraOBmHrawIfE4Pg1RAYmB+CNQEYsIPAgByCVwBg4A6B\n    CcCJPFlsECQFwFejG3iKNv4C7QHYOvy6WADgFeAXSOPvSPA9JoS/1uB31mpfoO90z0Ab/LUMv5zW\n    WZ6Z1vO1lu8E58gNtBIZwymFRAnuHsPnQBbCLsOUhRApS8mUx6VIzOcknJzPJ7/geYyGILz2dNGt\n    IPimYx9GQTCwT1WwBIHPGTH+96PB8+nLDNXAWgAMEIF9mQ2CV0FgAPgwf1/aAPAbXOBfRndNMbvj\n    78zwC6yFv6vA79e48H4IswK+x/jwdzX43aHaF2g73bNV/K2B313Ak+BbFwn6lkCjpfV0W0aKi7m4\n    ew6xNxwCL8OMC0EynNrroBSJd3kOcq+DkvNPCJbHB6K7gPCKGLxCNbDLrFXB1iBYC4GPaTE+GBob\n    JATrZBYEBtpD8OoIDMQheCUAfv3xz3+et0+6APzmMICyCgDH8PdqdOM8If4+zgoAnIJfYB78/eTU\n    zp4f6nIzQ+VvDf7uUO172Xj/VuEXKMff1eGT4FueVtirkVnA+HtcVGNuTnaHX+JufX4xugET57vR\n    DVggu+BkLL2ub3/FXOd7xPWNKKyXHauESyHYIgC7tF4j+KZjX2atCrYCwbG1gWsh2KX12OEfAXxl\n    5HzGkkJgYCwEzzAV9DGzQTARuH9eH/4+KQLrAfCb0wDLCgA8G/4CegC8Avy6zL7u7yr4e4Rf7Q9u\n    WuDrMtN6vyUAvDr8Xjbev2X0BQi/5xB8y5LC3t1hURoJmmtk5+eDyBsPAXfuEJHjmQksNdMLhYmZ\n    sqSeD57HeHbD4JqKYGJw+8xWEWwFgIE4AgN6EOzSalxxhmrgHRC4FwADcyGwNQAG1kfg16f/nxCB\n    dQD4jWfgZXYA3hV/W8MvMBf+WodfF8sA/AkuzIOvy03iPFrCX8Lvw1w23j/Rd86c8Xf1/paG2Fsf\n    Qm/fEH0fhsi7Z4jD99kVgs8hDNsJUbgsZxxdFYFD/ZXGMgQDxOCaEILLoznu+BvYhmAJALvMDME9\n    ERiYA4ItAjCQXhd4dgh+7fm3iSC4HoBXw9/Z1vs9phaAib8PQ/ytz9eKbRuFvsD88OsyAoBb4+9l\n    w30TfecN4Tccy9M4z5LW2Mvzf5edkZegy7TIrmBMHL5LDxwmaobD6aPzshsE+/qcE8sgPPN6wTMB\n    MGALgYFxEAzoYrDVaaFnQWCgDoJXQ2CgHoKJwP3zOvDvkyBwHQC/CQzMzAjAKfh1uRrd0ECIvw9T\n    g78j4ddFCsCW8ReoA+BW4HvM6hW/x/TG31nh1zL6loIvsD6AEnxlIf7mhdDbPqsjLyGXWSErwzFx\n    uD0MEzXvQwQuD0FYnh0x+KZxu3tDcA0Cu1jC4JEQDNRjsFUAdpFCMBFYHusIbBWAgTQCA/NC8MRV\n    wOUAvCP+AjYBuAZ/e8CvSw8Anrnq95gUAFuHX6AMf3ugLzAP/NaiL7Ae/AK6+HsGX2tw2LrKt+ab\n    5iND8JWF4JsXgm+brIi8u8Pu2wWfU418Puk1VSurQfHOONwShQmc9yEIl8d3DzMzCqfuZVbB4HM/\n    NEH4pkP7Z6sIBuaB4NYIfEwuCPsA+PcA/qFbi9OxvibwMTNAcA8AdimFYKsIfJ3x2BkheFIE1gPg\n    GeEXyMNfwBYAz1D169Iaf1eBXyCOv5bg9/eHv58/+OTgby/0dQnhrxX0Bear9gX6wC/wEH81q3Ut\n    AeJslb6tEflLz79Zer6shNhblh5r9+5y3leC3tWBl4BrMysD8ko4vAsMcz3hceH6wfkZBcK970lW\n    mSZa8/7xjMg3nfowW1XwDBDcE4FdcjD4CMG/P/3MCganIHgFBAbaQ3BPAAbWqga+znz8Cgi8DQDP\n    iL+58Ausg7894delJQCvgr8zwO/vA//uPuxI4Lc3+J7jA+BV8Hfmat/UzXMNipYec0Rmw9/SpG76\n    ib7xEHvz0wN6gT3P+8zwuwL0EnP3zQpgPDMM7wLBxxCFx4UoLE8pBs9yr7EKAmv0p6Sv2scjBJfH\n    B8EjENhFisFf4TY5Njo6MQheBYGBthA8EwIDdiD4umCb2RF4eQCeEX6BMvwFbABwbdUv0B+AW+Fv\n    Lfy6WABgy/j7e8FjPiX8qqQUf63Db+nN9C7oW9Nfy/3JjQ99f4nbpfpYmhRe7oiOsbCqVz8zI+8x\n    s4HvjLg7Y5ulmRVcZ2v3zCjsshsO94BhAufDcProdBz0+e4lZp4u2tfH3FiE4Jr+tOhrbltmmh6a\n    CJyOBIN/SLTTAgaHIJgILAsRuCzXBdvMiMDAPQQbR+AyAJ4Zf4F5q39nw1/LVb8uo/F3dvj9BhdR\n    RB2NvsAcUz4DZfhrAX61cY7oO3d/SuPDXynirTi4RfCVhdCrn9mhdxbgtYKkVtqxeywArYU2SDI7\n    DhOG9bPi58CS7FohLPksGOr7KgjsUoKnViG4tD+9++tr4wwQbAmAAVtTQvsSw+AUAruMxGDL1cAa\n    AOzSCoJnWA/4HAsQfF2wzawIDAAfbLc9H4B/B+DfJh4s2Bl/gX4AbL3qFxiLv/+Y+Pko/JWgLxCH\n    XwvoC4Th18UKAFuHX4e+rdFxNPy2OH4oXxZso33+rQx4HM9FK8ybacArdA52Q8hQWoLvTud4ZuQl\n    8I45TiizPB+tMxIle8ItkbhtdsLhljA80+e+lgmd49nOT4vPfudzYOW+CCi7T/SlBE97nYdchO09\n    RbRGXJt7YnBJNbAVCP5T4udWIBjwY/CfIH+uR0Gw5bWBZ0BgoA8EawEwMCcCzwzAv/3Y9n8d3RB/\n    5AD8u49/zoy/QD4AXw1urxb8urQG4BmqfgHb+Av0BWAp+rr4pnu2gr5AGn4BG/hrabrn1JTOrfBX\n    E12P+7JYIWsBfTVTOkDQA3xzM3IgjGv5yqP9etnlvM6IvTOgoja8joLcGc71DhkBltqYOwMOzwjD\n    ROGyzIacLWO9MtjC/cDxHNQgqBbeaqcUUC3B+LkfmnjbCoJT570VDhOC++WMwTkQDPTF4BQAA0Rg\n    SVojsCYAA/Mh8MwADJhGYBkAr4K/gByAr0Y3FHPhb0v4BdbAXwn8Av3wtxZ+LaEvsD78utQAcK+1\n    eyVJ4W8pDltC09XQtyRHZPsWNgZ5cqM5MEbwTYfTOutkBvi1jo8aKNsbdq2fU6Y+vRFTA3at4/AM\n    MLwLBLeeMno0dlrICBCe7fO/OwdfoM805j0zOwa3XPN4FAT7UoPDpesCAzYgOIXAgH0Ilk4L7dIL\n    giUIDKwBwS0RGGgLwUTg8e2tiVEETgMw8XdMtPEXaAfArfEX0AFg6/AL9MHfXPh1H0a+/tg2a/AL\n    zDHdcy/4zUVeX1oi5D812q8VOK355reVPtTkDGslAz4zDbTEBsmIvekQe3UyA/YCNnFSE2hbY6/F\n    88fYTUvU1ARdqzg8AwoD68Mw1xBuH8k5Tp2jmYA393Phue8z3aeEUjulsgUMbjUt9L8bb7cUhmsQ\n    GJgDgq0hMHAPwV99bFvu2CvQHoOlCAyMg2ANBG4NwAARuCTXgsfMDsAuxiA4DsCzr/d7jAR/r0Y3\n    8hBNAJ658telFoCJv3UfPr7GhUn4BeL4uzr8amCviwY+tqrqbdlmjWhM92WlL7mJDaK0HAyyOPhy\n    RDjfgOwOEBkLsbcusyDvMZbA0no1r6VzxewT60hsCYdnAWGXlWGYKNw+oXPsPotYfn21+iwYek1Y\n    vCeRZgUI1ujHOalKYI1KYc02x1B4dQi2iMAuPx7aNjMEz1oN3AOAXVpB8GrrAbtcCx5DBFZPGICf\n    TDjQFEsMgK9GN84TLQBeAX+BcgC2vtYv0BZ+Sz5oAPcfNl4A+LPx9wIfAK8Iv5rYe0wuPJYirib+\n    WsPSUgC21o+cjIJfaXoOxoRg7peef9tlQLH1a4DQayfW4LIUaVm9yzCPYxGILaEwQBi2FE4frZfz\n    57i/Rh7b8zVl4fNf7HWwGwZbAeCaPsRSCr0527WqZD6j8MoQbBmBn39s2x9QPjYLtMXglSGYCHwf\n    SwDscp34+SoIDNxB8GAE9gMw8Xd8NAB4Z/wdCb8uKQC2CL8A8H98/JPwW5dSAP4K7bD3mBg+amHt\n    yugL5MOvxT7kxjfwYgF8c1M7QONDul8W7MdllUHFFq8FC4N9rTIT9loDzByw7bEOr7XzwzA90ho/\n    c7GXOFwWonB+dv/c5gNhjdfRbJ/5fK+DmRHYJRclrUFwSR9i0VwbOLSvVhB8zo8Vx7GAwIAfgi0j\n    MKADwaMReCQAA3sjMKADwUTgsRmMwI8BeCX8TU37fDW6gYHU4m9L+HWxvO6vBfwFwgBsHX6B+fDX\n    EvwCefj77cfHXnZs319xoT4d8zGEX9vtL4nG2r6zxDdwk1PlqxnrA4wE3/xYRl+LiGkJei2eH4ax\n    Gis4bA2FAdswvDIGu2gDnfXPakDbz+2h6uDYa2nVz3rH18IKEAzMj8FWqoIl++2FwC43AL7IOKYV\n    AHYhBOsnBsGjARiwj8AtARhYF4GBOASvhMCvAfzzmP7cA/Cbjx8K/2X02VDKjFW/QB3+9oBfgPgr\n    SW/81ZhOhNM910cCv9+eHnPZuE3n/X/b6DledX1flx2rfYH7AZqVwdcXX3+PA1yt4TeVEYONrV4D\n    qw4CulgFX4uYmQu4LcDX4nnZMc8a7ff70R1jmuBnCfJag2GrKEwQLstIFB71mf0MwefPyjNAuWZc\n    f1eBYCAPKAnBZTmD7E2j48SOkUJhSxA867TQfzj8v8WpoUMQPDMCA+0huDUAu9RC8IwIDKwDwYMQ\n    +A6AV8JfVv22T0sALoVfFwsA3BN/tT4sfI0L/KblSanMTeDcWcffGLZeNmhDbJ+zwK+LBUDdEX2P\n    GLcL+kr7GYNKC4M7mgNrXMM3P1ah18USbFqo6rV0PqymFcLuGuJzOhZw2BIMW0VhYE0Ynm0NYQuf\n    00Of56TnchcUXq0yeNb1gltV2LbA4BTC3igfL7a/UFusQPCfIj+zDMHn6bitQbBVBK4BYJeWEEwE\n    rst14udE4OJc3P6/8fSn/5sZgFPwC6yJvz3hF2iHv7XwC4zH39iav9r4qzldiGX8vUmct9EAfEZf\n    CbJeKhw3Zx8t4Lfl9NGjETUXfX3tbjEg03KAZKfpnXP6qIGUFgZ5Uq+dHs/3auBrHXsBO8ApBVxC\n    b7tYhtwe6zNLYgn9ztkdjlsi6EzTSFvG4GNWguEen+Ekn+8tfC6v/RwnOZc7YPDoNYNzX0ux56QG\n    U0dj8EoQfMyNwvEk+zi3aTQE/ynxc6sI/MePf35lGIKJwGXphcDAmhB8LXjM7BD8+uOfHRF4DQCW\n    4C9gD4BZ9XsXDfwFxgLwPyZ+rgXA2vALwCT+puAXGIu/Dn5LcPWy4Hgl28xU8dsbfc/HK0VfwMag\n    TG5Ww7ichJ6vnudkNAq/xUXTweyVXl8zQC9gAzklkMc1evXTG3etgK319AbDHZGYMEwUHpHRn+F6\n    pNfnuNC53AmCv3v0ZfL5UvN8HSG49/q3LY85GoKPuWn8+GPbCMFl+SMeIzBgA4J/nThnoyBYA4Bd\n    WkEwEbgu14LHzIzArw9/74TA8wMw8bd9LFf9uozC3xT8Ajr4qwm/Lp8YHcSzXPX73/Gzqu0vlR4T\n    Syv4Beyt81u7fSn8roS+Gn2ZYaDm3E+LSNlj0CeFN7mD2RbPY00sg68V3CT0tk1P0CXm2kpPTFwZ\n    jEfD8GgU7nEearMSCLvkfobT/jxWEmuf4c7ncIb7C5ea+6lQP3fC4NqKYA3I1cTgVusDu5RiMCAD\n    XsljYvnf8ffGZyCcFAIDNiH4x0SbWowHS5ICYGBsNbAWBBOB72IJgq8zHjsjBL8+/X8HBJ4bgKX4\n    C9gC4Fnwl1W/4UjgF6jH3xYX+hcA/mx00C+Gv6Pgt6ba95jLzH/PSUv0ddHCXwna9qoIzgXgVeB3\n    ZD96Deb4+mhtoEua0gEgLdz5HLfTnjtJrKGvJdzkWr11GTH1slXUfWe0XbF8ZngwYQQyzozGrTA0\n    53kgDPuzIga7uM9vGu/Lta+f2T7H+T779gbhEfdLO2Nwj2mhJcirBcGtERiog+BjbjL/Padto6qC\n    Z1wX+Dlu8YfEY0ZAsASBAVYDxzLLusCAHQS+znz8bAj82vNvjRH4HoBXxl/ABgDXwq9LDwAm/voz\n    O/wCdvEX8ANwb/j9i6cNNcB6Gfi7Vlrjrzb8jl7jF8iD3xnR9xg34DNTP0oGeCxM7dwzvoEgbfj5\n    ZeLnMw7aEnv9yX3ttEBGK+dCklFr6lrC3RlBt3WsgfEocJwFiltAaMk5twDDRGGdpD5j/FX5eL7X\n    zoqfe1tMFT3DfdGxfzMCcKgvsYxeGxi4B+BZIFgLgY+5Sfx/Tdt6g3AIgi0jMIAmENyjGhiYH4Jn\n    Xxt4FQS+znw8ATiZOQE4F3+B8QCshb9AWwBuCb+ADv6uXPXbEn4Bu/g7Gn7/EjkvNev8XmZvmR9r\n    a/2egdcC+LpI4XeGQYFYZkTfnPwCt6K+rTgI5uIbZNQaWEzBbypWBm6tYS8wHjktVPRaOA+SrFa9\n    S7CdL61BmesU+2OhWrjk8bOch9JY+WwB1H2+0ETg8+c1S+dIOxIADa2ru0Jc3wjB/XOG4BoYboXB\n    LRD4mJvTn1pt64nBPgi2isBAWwgG1q0IJgLrADBABO6RztNA3wHwTPgLzAfAmvgLtANg6/hL+H2c\n    1IWbVb/h/EVwTnJx9RJ90LekbZJI0TcHdUcDcO9pnluiY+ymf3X0BWQ48g+TfeiTpvVgYy36StJq\n    YNIi9J7TGzwJvfLMtObuaog7qpI6lFmAUhINPO4FkDOc99HrCtc83mq/tdISPVt/vpBicM1ntBVR\n    +FvYWEN5VGowOOc+tRU2W5waOpYc8JU+tgUEt0bgY26Qh8HStvUA4Zkg+PmhXbNWBM9aDdwSgIG2\n    CKwFwMB4BL7OfPxsAAw8RODmAPz6sAbwLJlt+ucZqn9b4y9QB8CW8XfEdM+E37JI0BfIw9VL9EPf\n    kvZJEoLfGrwdCb8S9LW2Nm5JNPtg+RvlsUGenEGxmQbBWg46/gL2BnVznhvr4NsTPa1A74i+l6QH\n    OErP86yYaw1tLWYG0PRFisY9YGWGc9j6OmoVhq19fvBlpc8UmpnpczAgf25ikD4DBOd+edgHqJbv\n    4yT9kLZ/JAbXVP6Gtl0Bgo9/aratJQavOi000B+CV0Xg1gAMtENgTQAG5kLgGQEYuEdgArAnOQB8\n    NbqxsL/2bw/8BcoBeBT+AmkA7l31K704v4Bd/O0Jv1LwdZHA6mXi/1ulZcWvJtaOgN8vUV55OxP6\n    hvo4qg+tBxt8kNKqUtXKoJj2QGQOyFke1H2GW3ODtK2xsxZsd63s7QWUsfM7E+4SdG1kBvB0iUEx\n    cdjOFNLa24/qd2nc5zprnx2OkV5Ltc+tlc+8QJvnxwfCPd6bRiw9E6qmnQmES9dy/hbjQFhrfWC3\n    n1UgOPT/tW1rhcEzVgNLEBjoC8EpBB4FwC6lEEwEvstMAAwQgSOZD4CJv/qxXP07En+BOACX4m/r\n    i/EnRm90bwLtaoG/mvB7mfnv2tGEX4ezpev7pvarndJKXklmgV9r6FsayUBET/CVpvUgmebAVyuU\n    GzWoWwKYLQb4WpzXVjjbYr/WsLc3WM5a0UvYXTPW8NNS1fAx1s5Ti+toq3Oqvd9WnyGsfEaQpMV1\n    VPO89gDhkRBfC8IjYLcku2KwpH+toFgLgl0cBGvutxcE32T+e2n7tDF4xmpgKQIDNiB4NAADZQg8\n    MwADa60FDMgheFYAdvlAAL6PBICvRjfyEA0Abom/gN21f0fjLxAG4BL87XHx/RoX+E3rk1KQm8j5\n    0gLgXPQFwrh6mdgu9XON1MKvD2UtwW/u2rznlNyMz4SmK0xRLYkbEDoOzoxGX0lKB8u0BsBGo5zm\n    wGOPqYmlOZ7X8+CgpXa2asvo15XLCLwMnVNrsAsQd5l4rOHn6IrhYyydm5lQWLMt7r3WSsWw9jkb\n    eR3VOqc1IGy54trFd89hqSpaIytME52LwbX9q0HiVhCseYweEHxT+PPStmlg8J8SP7cIwX8E8FVm\n    u3LHoldDYKtVwC0BGCACz5rXaFIJPA8ASyt/r0Y39BDi75zr/rpo4W8J/AJr4O9N4lzV4m8J+rqc\n    gfUyY9ucx9a2SxIpxGoBsOR4tcAbSw7+zoam577N1v5UQgNDkgEzK4OFsZwHkGao8NVM6jmyhKgz\n    nE9Cr36O59Qi7gIEXqZtLCGoyxmJCcO6sQTDPftdGsn5snIdjaVllfAM0AuknyffOVodg1eG4JZ9\n    kwKxBgZLp4QuOVZLCL6pfHxN22owmAgcTu6YdGw66JEIbHk94BkQ2AoAu1wLHjM7AgPq1cDrAPDV\n    6AaeUou/reEXIP6Gornub68pNyziL9Cm8rcGfYGHwHpZsH3JNiVtC6W06lYDf33Hbgm9vkjxtxec\n    ah7H9S1nUGWGQQpJf2oG0iwNGvrATmPgdYaBxtC5sPT8uFg7n6tDr0tv2PwaPxvd5WB2RV6r6H6O\n    dGrj1WIJQo/5Cn/vfkxr58Lq2sKz9LMmv4C98ySJ1rls9dlWKy3vIWa4zzomdc/l+qMBpaVr97Y+\n    Xm/g9sFwTwQuPbYlCD5uo9GuEgyeEYF/LGxTy2pgy+sB1yAw0BaCWyMwUA/BROBxUYJg+wC8G/wC\n    8+NvDfy6jAJgLfztudbCCwB/Njigpo2/tfDrUrpG8qXK0ePxAXDt+rpaVb8/G/wa06z6tVZVWwK/\n    LaI9yJHqTw+c6jGQ2GIdOmtw1+pc9BrotXQ+d1in16UHcrrzaREWV0Nei+fYclZCZGsY6vIZbrtB\n    lNVzoH0dtQR7LfoXSu511Np5kkRyLq2urWzhnqEFBo+699OEYM2kkNdKNbAkv8StytrDpRB8bIcv\n    FqaE9uVL3OJrpeNrQrBFAAb6ITAgH69OITAwDoKJwPWZDYKJwD/FLgDPttYvMEfVL9AOf1eGX6Ad\n    /tbALzAX/ubCrxb6fvXxz28K9nepd1qCOcJvLfi6lMKvr6JXq025kaDvGXOt4a60b6PxtzS+wZCa\n    aZ57pnZQURPyZq0u0T4PLjXPjbXXmUvtebLaL6A/dL7FhSmMnBV6LZ3D3TMzFluBUXcOe15LrfQ9\n    lJprqeXPJJY+I1g+T6n8UfkaUHsuLH3OCb3GYgg8273cuS+jwTQnRwiWoPCovoXwtQSGayHY1y7L\n    COwyCoN9EGwVgZ/jFn+o2D5n/HqFauBaBAYIwbMhMLAGBFcisE0AJv62Cat+H2ck/ALrVf0Cfvwd\n    Ab9fHf5uFX4B4H8qT1EphV/J1M0j4TcHcmdFX2C+wYJQ3ibQd6YBstCgjxZ05gxwWTxvFtbx/Q62\n    BgrPKTlHlvvjQuidI5bOGaOfWbDYCo72rBK22P9QShDV4meSc39GX0utniPp5xKtiuuVZrp5iwvv\n    ebH6XJdkVgyWVgT/YnDFs2RaZikKa0Kwaxsh2J+ZqoGff2xTCQTvWA2sgcBAOwieAYGB+SB4BQR+\n    DeCfy/phC4B3hF9gbvydFX4BVv1qpxZ+tdEXsAm/3+KiCazG4Dd3nd4e8HtG25wpnkP7sJjd0Ld0\n    QMfiIMrbR9XlZZm52sQC9gL157DlFJKxczTTAKfLCOS0No2zdei1cp4Ym7EMxFZQ9HiOen/+sHIO\n    chO7jrY+h6XXUivrCfd+jWl+dtOqtrb4OR8oO1ehc2K1j7lZHYND/eq1pnHO+sApFJ4Rg28Ktvny\n    1KbeGDwbBM9YDQzMC8EzIzDAauAZU4jAdgB4R/ydGX6BefF3xqpfwm881uHXTfGsDas+9M3FXpcW\n    6CsB2lz4nRF9Cb716TGoojUINAL9NM7PKtjbKlbOj2Z6Qqfv/FmATKvYa+HcuHw+ugET5+3oBpxi\n    FYctoOj53HAq6bpYxbDVUHjEZxONz74rfZlx5ergGTG4FoI19ilJDgQf40PhFhDs0gqEbwq2+dLT\n    Fg0MJgQ/TKviJqsIDHBtYCLwfClAYBsATPxtE8v4a7XqVwq/QN+q31ngF5Dhbwv0BezA77endrSs\n    +C0FX822laDs6vBL9O2X0kGWVlM6WxhclJwTK6Bp7fUE2Dk3mukFnaFzZwE0rWFvr3NCwJ07vRDZ\n    Gg5bQFHfOSEMl8cqis3yuQ2w8fnk+Lmt15TRqVg4L8A+GDwDBAN5cFvSJw0YLoXgYxwKt4RgoA0G\n    3xRs82WgHbUYXAPBVhEYKJsWGtgPgonA9bEEwdfCx80MwZkIPB6AJfgL2AJg4m9ddqv6XQ1+gfKq\n    31r4/Srys5H4+23k2Jr4+yvUg29NuzQQdjb4lbT3l4bae0zpoMwqU9r6Bly0B4ik58PS4KKVQTLA\n    3uvJ0rnRygj4Jfbep/e5sIC973Bh5vxr5+9GBgl6VhZbgmELIDpi+mgL/daMNRCz8BntGEuf1ySf\n    07TPX+j1YeF8SNJyunQLn5uP6PnXxGOtQHFrCK49JqADwcAdBreGYBctEL4p3K4VBANpDGY1sD+z\n    IzBgF4KJwPm5Fj5uEwQeC8Cz4e/u6/0CxN/d8be06tca/AL1+Ptt4rga8Ks5xXNO21oiphSANdtQ\n    sr6wNFbxtyZugOU4gGFhwEGrX1YGX3oNOMYGzHoOwlp8Dc0ymChND3Q7nzNib9vz0Ap0pe21cG5X\n    iATwWkFrKyy2AsOjcXTU1NGj+62d3VE49Hlkts9pGuftLS7MvR60zsVvFugXkIfApdHGYynItkTr\n    VBs0EfgYDRBOta0Wg28Kt/sycdyWVcG7IDAwDoJnROCWlcBAewheCYGvMx67AQKPA2Ap/gIE4Jy0\n    xF+gDoBnn/Y556JXCr8unxgYUD3nJtKmEAC3hF+XngCcQt9jSgD4V4mft8DfXmiZg7DSNrWE3VR+\n    efr/2fE3NPA04pv/rfsUSmywqRdeag2c1URr0M0S+BJ688M1e8MpPQ8tMLe0LRbOI/M4painjbE1\n    aDwahi3A6Mipoy30XyuWEFDzs27NZ5LZPqPFzlvOebD0WjgndS5bVgSP7ffDtreCYEmkaDuiEji3\n    Ta0Q+JhSEM5pWy4I3xS2KQXALi0g+E+Rx6+IwECbMfEYAo8CYMAuAs8AwMB8CDw7AANJBP756HZO\n    Ew38ZeZMr6rfVdIDfV164G8O+rrk4G8KfQG9aZ//F36mtCd5SuF3JO764tb0dTf538E2KtWsAZs7\n    KGQFiWufj7en59hlZPVF6ry1eA2e9ynpP7FXP6OQ95jdwVfSfy3U1TzXVnDXwutHK71QU/Lc+YCv\n    5FzH+pTzuj5jsa8tPVHYdw57o2ju86H5OSP0GpoRhn3XqFFgFvqcI/l8q/m5pPScjPqc9otTm7WW\n    p+n1OtA4b7HP9iWzE1n5nHtsx+e4fdCq286/p5Jxg29xP9YggeAvDtu1zHeeL+f/ArfVEPwlwgh8\n    Hn+SgvBfcSFulxtDk0Lw5cc/bzL7+Q0uRAh8HGMswWA3xnmE4F8jjsAr5h8gHx///WEbRi//Cxdd\n    poPeLf8dF1MjsCCsAJZGC4BnrgCesfoXiFcAp6p/e1b9usxa/dsTfoG2a/6WoC8gg18J+LrUwO9f\n    H9xs939NpW7Ejj/v0b7vK45xvHG3ctNdGl/7fYMbvQfYWqxXLE3J4M6oAci3uBhecf2Lgf0/Z/bf\n    Rxdib7/zkNN/DdxtcV57nycLr42Z07siVhv6NNofqigeWS08GkRTfWfFsDxWPpMANj6njZxmOPdz\n    mca5qnn+R8C4BMQtvaZzc257yXP8rBvw3x8nBb0j1jM+tq8GhL/JeKwEg2vaIgHhm4L9SiuBj6mp\n    Cj5C8E5TQR+jNVbOaaDzM0MV8GwVwMC8VcDCCmD7AHw1pHWPw+mf5wTgUvwdVfU7E/6uBr+l6Auk\n    4TcHfYEy+PW1YTT8xhBYq201sBvLeUBgVmjSqvKNpccghRs8GAW+o86DtL8tBxul56vH62DW38Nj\n    euFd7FxZAD0r2Ks5LfNsVbwWXgfMfXpgqBb2abb1jMOjUNgKhIb63xOErJyLmlj6TDL6M1qrc9Hi\n    M1kLEO6BvFrnwtf/VTC41e+BFhbHqoK/Tfx/j/jalwuxORDsEgNhQvA9BM80HTQRWB6rCEwAluc6\n    47EE4AaZrfoXsA/AxN/H6YG/WvD7AsCfjQ3EtYTfXPQF2sBvDfoCYfjNBV8XKfzGwHkE+ua8P0jb\n    1wp2Y1kFfUNtHzlNb83gxdvo612WUX0v7Xfta69mkMXilwNm/l08pjXqWV23t0ffQ4n1vwR/tc9n\n    i/Ni5Tln2qQFkFqoGmaVcDgj1hS20veaaJ6jlsCXk5rPaK0+i7dKzrkKnReN18Coz6Dn/s8Mwef2\n    966Sz0HinHWCW1f55bZPCrIlEAyEMbh2uuoUBt8U7NMaBBOB7xMaQ7eIwDUADBCBZ0PgWQEYECEw\n    AVgS4m95RuDvPyZ+bg1/rVX9En7T8QFsKfoCMvhNVRn3gN8vEv+f274RyOvLylM8W1qbNZbQoEbp\n    8+EGFqz1PzZ40/q1Jxls6XW+Rp6HXmkJnqFzZAn+LIBvLvC2On9EXqZXtLG0FQLmtpNVwo/TG4Ut\n    9b0mqXPU6zPI6M9kVs6DJMdz1Qt1V30AAIAASURBVGLZFkt9TfVf0h/rGQnBofiAOAeCR1QIS9qX\n    gtlSCHY5g3AtBANxDL4p2B8hOJ4REJwaR49BMCuBH6YlAmsAMGADga+FjyMAK4f4qxuu+fswM633\n    O1vVb2/4BXTxtxZ9gccIW4O+QBh+JWsJH9MCf78o/Nk5f8DP1NumFd8ggvVBgFB6TPU8qi8lAx0h\n    cLE0gOn6OftAjsY5mP08tMLOGaC3Zf9TeYcLMfL2Omea58La88zMHU007XEtzWnvW+X+WToPuSEM\n    y2Ppc9h3GPeZ/S0uTJyDY3zX0tLX2gqfNVeaGjrUbisYfM4L/F382G8Lf1aTHKgOAW0tBAMPMVgD\n    goEwBt8U7IsQHM+PCu3RXEZxtWrgWREYWKcS+Fr4uFkR2BwAE391Q/y9z0xVv7PBL1COv6PhVwN9\n    XRzK1qKvyxl/c9HXRQN/paBbsqavlSpfX1ao/F0FfkvO/3kAoRReeg1e5vSxxaBO6vy0Pg81v2NW\n    Brl6Qq9l/OsJvsdjSV5Ds0Gv5eeZ2SNacNrrWiptr7tu9AZKyyB6Pnc7wHDpZ4/Wnzsk15AW53D0\n    Z9HSc3GO79zkPtdWPlvmZGUItgrAoemjc9YMrn1cKjkI7OJDWg0IBu4wWAuBAT8E3xTspwSBXUox\n    +Fe4nQaBtaqBe0HwbAgMzAvBROA5kkDgfgA8E/4SfssyG/y6aE1VIYm16Z4BP/6Ogl8gH38vPf+m\n    Cb+A7vN2hN9S9HUpwd+c6l3ftpbX8JVGE35HQOuxzbXToo2KBriHBoy0BkJqBt60v1CQ2yctnLJ0\n    DlLRHABrPX3zTOjXA3t9x1gNe2d6zlunZO3lnnlbv4slMhMMS9rqu0b0aJsVCJXkM9xOhcI9P2fU\n    nheN60jJ+dM8RxbOQahPGq+tmSA1hqW/6dQPLbCdHYLP+QVuq2C3ZNsSAD7Hga0WAgM6VaXnnDH4\n    pmAfhOB4tJ63HlNCA/NBMBF4bK6Fj1sQgfsAsBR/r3qelUCIv2WZEX97Vv7OVvU7An6BOvzVRl9X\n    6VuLtMf8FRei9X5TyYHfGvA9Hke6nxng1w0ctALTFgNSoenZRg0olfahJrV91RjYCZ2rkdjZsxoz\n    9VqZoZK+1e+RpP8zIGDL11Ns31bAl9ibjibgvjdyrp4q3eTvgMcaMGwZhXu0zzoKp85d6y/azfpZ\n    4phen83O59AKimv0v6YvM4Jwi5mMzn2wWCV9BF+L6wOfI4XgI+TWAq0UhTUg+BvoVu+6ff2lcj/n\n    HCH4JnPbGgB20YZgawisUQ2sPd5OCJbF+pTQMyEwMB8Evz78/YTAbQGY8Ksb4u9desIvsCb+An4A\n    /vkg+HUpAWBN+D1P76yBv8d9tMZfLewt2acV+D2j7i8F7bM60BRql9agUslNfe6Aymj0bXEOzpHM\n    NKGd83kZWbUwov+1af26mgUAe6/dm5rOufd5q+3/LM+zNLmwawVvrSQXkVfC4llQONXe47WUU0c/\n    To91lmc4D+ekBqVb5nwtHXH+NPrf8l5sFAaXfMbQOA++/lqtbo5/ieDuZ389/bslGJZgcAhva7A2\n    BcK1EHyuAq4F4fP22hhcUrGqgcBAOQT/7XR8awAMjJkSmtXAemE1cDrXwsctgsDtAHgn/CX89sts\n    Uz6/+PinNQA+4++3uChC3FHwC+hNy+xb07cWfn3b1+KvD2hLwTdVQWwRfaXVum9xMfXavr729kaa\n    WKQDCN+j/Nxb6G+qn6m+aQ/A5Z6TVgM90ufU6gBuq9fWDBA4at1el+NrZ8T52hl7pbBL0O0XKRbP\n    jsQ1YDjiOiJZI7dXu6xeR89pgcKW+y65loz+DObS6jzWLMFi4b6s9Ly4/kk/T1jtq1UMjsW1+e/C\n    tvdG4pKqYF9K4bYFMgP+6aBrMNi3rRYGl6w7PBKBv8bj6aytIjCArhC8GwID+1YDA4TgljlBsD4A\n    zwS/APG3NBbxF9Cr/l0Zf4GHAOwqaHMxdwT+Olj9lXiLcDThN7ZdDfyeobYV+ObuvyX8xqA3diP9\n    i4zHWs25zRYgNDfvcJEcDPQNRljvq6RfuX2WZlTFt/bv0IgBXe3X1SwI2Ov3KXQc99oZeb52A98U\n    8s6Auz3bqDXl88g2zojDtVg4CgaP7R41bfToc5AbbRie/TNECbppfQ6z8BnUakLnJtbvz3E73X3m\n    uZ8zI7DLd8LH+dIKiLUg2EULhFtAMFCOwaHtajHYbT8DBB8fe4Rgawj8/NAeKwgsmXWCCHwfIrAs\n    18LHzYbAwE8QrAvAM+Evp3yui7Vpn11CANxzvV8Xi1M/++AXyMPcmeE3tL1l+C1B35w1gnOOoQG/\n    pcCbs7/ZbsqPbZ5xoCUXSnyDgsd+WxjclPSpFQj3eg3UrgumEc3nmtg7bv9vcTH8fNWch9FtlyaG\n    vJaAt7YtnzVu37uKba3Bcaw9swDxbFXCx3yFvw9v4+hzII31SuHen799SNXjc1jqnLW8lvaYQlwa\n    10/f+cj5TGCpT9K4Pq+AwEAZ5sb6roHDUggG5Bjskou5mmsRfxP5WQkGW4JgLQQG5BA8GwL3ng4a\n    8I/NS5cdIALfpzUCA2usDQysC8GvNQFYgr9Xo3v8McTf+lgE4Fr81YJfwB7+huAXkIMu4Ve2Te1U\n    zz8raFMu+Lrk4HIu/mpDr3T/M+Gv9emeY9EAE19fYwMpLQc5tQCoZCDoWeO+SftsaRBrFJBbhkAL\n    0Osyc4Wv5efYJQS9msgr2VdriN0pUnTWAubZYbj0emS5QnhEW63icMvPGy2BUzNWPoOVfgbVuJa2\n    7nPsuT63X+t3xdJn6VBWmBZaC4JzzkPu/lsi8DG5qCudRjuWbxI/z8Xg2ONrMPi4rbRNvSH4/Bir\n    EKy1HrBLbYEWq4DzQwSW51r4uMkQWAeAZ8JfwP60z0A7AJ4Rf4HytX9H4C+gtz6tRmrxdyT8AuX4\n    m9ouB38lj62BXwexUsgtBd/z8aRJ4W9vjJ15uudQW60MSIXSCnylaQHDPSDo3O6cc9Bq4Hamygbf\n    +dI8L9YwcPTUzb6wurddaqA3B4MJuXNHG49Dj7MMw7OB8LHdObDSs72jz80x2p81ztcMC3218NlL\n    ei2trYotSW2fQ30rbbfGa2b0Z+jSPs6EwdJpoVscS3LMHAQG6iAYyMPgX+C2+ngpCAbk8Jp6HCHY\n    Rn5UbotkvD40Vr/iWsDA3FXAABHYcOoBmPjbJgTgh4kBsCX8XQl+cx6XihR/e8Dv+Tg1jwHK4feM\n    sDHUrQXf0DElOeKvharbYxtmgd9YOy3D72j0lSQXhntjUG6VcywWoHtktYY0ofNkAQJH/r7PMpWz\n    tK2+WGi7LxLoranuJfDuG83prGeC4Zmnjc5B4VFtHX2OgPhzXHst7dG/kTPLuGhdS3u/Hkqe+5bX\n    f2LwHHFtbYnAoWOec25Dbwh2iYGw72clx5UgMDAegs/bSdpDBPZHE4Frx+xXRGACsJ3X+rXwcZMg\n    cB0Az4a/AAF4trV/gTnw92tc4Dc9T0oitWv9asEvIMPfXvB7PlbJz11y4TeGrz7g1UJfaRuO+R4X\n    JrD3nF90Pn7qWDlTi0m3K0lqYCJ30KFmEMUKaJ/77PrUehCrpP/aINwbwVpVbdSk5hxYWJ9ZI7G2\n    Ht/bLKDpSuB7xl4Hu7nAOyvqxvo5W59CuGptHWCNPoXyFLfe/q6Ewpaw8/PML7VZTatpmFshWu25\n    7XktagHjue3v8Vp8Fuirhet+Tf9LX8PSfrf8coSv7dJz0ROSR0CwpL/fQQ7BWgB8zhl9Y0Cc2wYp\n    BANxfM2ZProEgwnBOvkjgK+U2lI7HTQQh+DZEHj2aaCBOgS2BMCADIGXB2AJ/gIE4JJYXP93BPwC\n    Yfz9U6Q9O+OvlemeXVL4e8bWXPwtwWIf8OauBZyDv1L4bQG+0nb8MtAGCxW2DqJr23LevhXkhG7Q\n    rcORu4F37c8ZoLDaN+n6ajUDOS36nnPuj320Mjgsab/mebMwGDg6ofN5ft+zcq5WAV8f9voAdDb4\n    POf9o/dSJpYzss4MxqH+zIDCJdBi5Tp6bv8qMNwimigsPZdWrkXuWtrzi56+1L4GJVW9litoc/r/\n    DhdVy8NY6FeL56LFusQWIDjUFwevf41s0wqBz204/72mLTkIDITxNXcN4R4QrInAQB0EW0FgYJ5q\n    YCLwXQjAZbkWPGYCBG4LwFeju+eJdQAm/t6lpOoXqFtDoCQWp3y2AL9AHH9nhV+XGABLqmwdtLZG\n    31Cbfnn6/+9wYQJ7j5HCby/YleSdobbUtDsWd4NeOuhkpR8utSjc4zk+trHkubKQ54qvEysDr72T\n    +1qzMp1zSdtdrLQfuMfeI4ZeGGpfSQi7Y3OE1dmR+Cluvf2xhMIzVwgDwFf4+5Tt7h1tELZ0HZJe\n    S0Oz4LRKzmtNawpnS/cfrv3n8yB5vqz1I5Rz30a2+9yWFBQff24Bg8/tOuKrD4RbQ/CxDZI1hGPt\n    yQXgY84Am4vAQD4E+x4fOq42ALvkQrBFBB5RDRwb0w9B8EwIPHsV8ErTQAME4CQAX43umifE3/xY\n    wt8/CdrSE4Ct4++I6Z5dQvjrA9cczNWA31L0dQnhrxR+R6DvLz0/t4y+wD3sHttoGVTdwIXlNvra\n    m5vPBY85D/i2HCRoMaiVQuGez/E7bzWh/UHsFoNelgZhW2dm7C1pv8voPjgQde9znwV+PkveP6ie\n    YmbMzEj89MGXl+7y1vOzUZnhWppKLgpba3/LlDy/kmuQtc9Skn70xLrj+em5Xm/rPh7bnLoXKv3i\n    y4wYbLXNxzY6aLUKwce2+QDWoXAPCHb5B+G1xdemGgQG+kNw6LG+4xKB49GqBtYY01+hGrglAgNt\n    IXg1AAbSCEwANpRa/AXaAXBL+AXK8NcS/AJp/O057fMLAH82Ngj4H/jZg/8fVfUL+PE3hq4S1LUA\n    v8Bj/JWuqfv70/PTOv/p9P8Wp3Y+5mcn5LXWvlDeTYLTvvaWRIK/khwHRmZAwM/h/3Z5y0HAnH6O\n    HsTWfO2XVjvPnJzzZw16S/pwTO+++AD3c/hxdBbsJfLumxlx2NfOr4WPa53Zp4w+9iN36lSL/dBO\n    y6rY0Z+npH1pjXW+9o8YM9FYZ7f2nqd29gOrsHrMDBB8zue4fYTDljA4NFX0Mf+zY3t+gVtRVTDw\n    GINrIRh4iLAlEAykMTj18/NxrSAwAPyXgi+Btc5z3OIPlfvQWBPYxRIE71YNvBoCXyd+TgA2EuJv\n    XizhrzX4BebHXyvwC6RhtxZ+NdAXeAi/UvTtXe3rm9Y5lFHAejzuL+AfKLCOv75BFsv4qzHApQW/\n    qYRguDcSSfr7eaJKuCRa/WwJwr3Xzq7tk7VIz59V6M3txzm9+hTD21mre137iLxMKjPBcKxKWLJN\n    y4z+clWL/uTAsNV+5CZ23Wn52aLlZyqNa2lt30vv4XpPC+/rpyb09uiv5c/Avte55fYC4Xu4Pwge\n    M6ptLufpontVBedMEY1TuyxAcC0C+447CoJ96wJbqgR2yz7VIjCgN9ZvCYEBe9XArRC4FoABWwh8\n    LXiMcQQuA+CZ1v/dFX9nh1/AJv4CtgD4PzyVpTHg7YW/Enj9VeHPYnHH1YbfHPT1/V07vumdpcfr\n    Aaxn6D3nWeTxVhMabOkxvVmraexi6YW+knz9oMJN/0OVVl9zq4R7YVjNIHYL8NXut/WBJpfQYKll\n    6I21XZLWfUuh7YzVvbtC74dBz8mTSd4/NDILDD99VKk5HoVrrjPWIdX17fwZxnq7jxn9mTuV2iVE\n    enxOSPW71Zd2W4Hw8ZxprU05uq9ar80WFeMzQjAgf9/7LvD4Xu0K5Re4fbBucEsQPuJvLgRrIDDQ\n    FoJLEBgYA8GWEfj5oR0aCAxwSmiXGaeEXgmBrwWPIQAPjFX8ZdXvXf4x8XMNAF4Vf29w8WC932O+\n    Ev6bRkrgFwgD74zwG4JXbQA+t+Uic/+tkNXt9xfCxz/zbGshvpvh2A2y1arf0pt6S+Ar7UPpVNK9\n    +nq+eX+Li+6VD76UDPIBZYPBlnCz50BU7P3Z0jkJpeb9rWX/QlM4HzML+K4EvaPw1kpmR2TrMOwD\n    4XPeCrbTzA4g7Mvbyr7nxsr1srTPvmup5Pm30O/nnj73+RJxftz5kny+t4SSob7OOitO7LV9brO1\n    Phzv2aTv0d8Ftm/RJkluT49vgcE++M3BYG0IbjEt9AzVwKF/twLBFhH414LzwimhicCpXAseYxiB\n    8wGY+FsXa1W/Lr0BOIW/QD0Ar4q//xFZT7YX/pZM9wzow687rib8llT75vwsJ+e2fJ+JrYDuzXou\n    9p7z7LSf1ikdQAlt9+sura7vq3TwRAqhPW7StQa7YijcG7nPffrMO5g2Pq5duejnGyCxMGjZO5LX\n    lfXzYqkq6Yy1sgHd+D5GZ0bs1ULdsoWG7OW90n5mwmIHrdZQWALCx7xNbK+RVUFY2i8Ln2V6JnRe\n    Sj9HWfiM4LvWHts1Aux8r6sc7E3F0pcZSn6HrFQ2+/oSel8rPee9niuHrqXvyy0qhXP2dUTpZ4ft\n    NDE4Br4SDNaEYAD43yrWwZ0ZgndD4B4ADBCBAbsIDIyH4Gvh44wicB4AS/AXGAvAGvALEH9bphZ/\n    d133Nwa/wDj8HQW/7tga+CuF3xTs1sJvCHyPkeJrLbLWYu85zxTadEzNYElsgOadoMLMUnLPQ6zv\n    NYOQI6apzumv61vrAYScPo0G4c+D/152jqxUOLeK9H3AwkBuLFaqe0ugF7Bf4TsD9tbg7iqg2zo1\n    YGwZiS2isK8tKRR2eZvYT2lWBeGcvq38eQDwV8hK47sf6n2+UuCbSq8vhz5Dv9+J0j5p35Pm9tda\n    Ne0559d2rL2970Vj+Ry3Kq89LRQuhWDgIQYD9SAsgV7JY/5/le0A6quBgTD2ShD4fGwLCAwA/6UC\n    xjXzHLdd1wMGwg5gEYFLARggAo/IdcZjDSKwDICl8AvMj7+7rPd7TE8AluAvEAbgXtM+u3xiZFDR\n    QtUv8BB/a6Z71oDfnDbE8v8SPEYCu6X4K0HfY1IgW4qs2uAL1Ff8ltxQa+HGSugL6E1ZXXoj/Blu\n    u8NYqs9aKKzVr5YgXPp6jg02SH6vZx0AXgV7gfrf/do+lkKvi2XwtYy9ucirCbsrTwmtibMlSGwR\n    h9/BNghLMfgY7arhlUE4p3+zfiYAZNeu2s9Mj7dp24eWn19z4trR6kuqtX2a6b5rJgwubWvJa6Hm\n    vGhB8DHfoQ6EU9t+l9heqzrYCgTXrg3sMiMEf514vAUI1kJglxoTsIbANQDsQgjum+uMxxpD4DQA\n    z4C/lqt+gXb4Wwu/Lr0AeCb8/RoX+E2Pk5JIbK1fwDb+WoZfScWvJfQF9OG3Bfi65Kzzm3NT3WLd\n    3ZXRFxizVvHxJjkFNdqDxjX9zQXh1vh3bkfOQKD2a1lrGkCrg78rTOPsMgp8JShbWuVL8PUnB1pL\n    gXdlzO2ZUriVIrElGLZUJaxVHSzdtzS1SDMDCkv7afFzQe1nqHc/XSt0fwdqPwf2/twaigR8Y2nx\n    +o99zjj/ro++t5LGMgZrQHAsOecrdfyS9YFzU1olHHt8CoEBvcpg6TrAscdpTA1tAYLdcVsBMDBn\n    NfAfoTttfWsEnqUK2KUVArcAYIAIPChhAM6BX2Bu/G0Fvy4tAHg2/AXSAFw77fNq+Gul6tflG+F0\n    y63W+fX9PTdfHv7uA2Ap6JbAbwn6usSQVgq/b3HRBHuPOd8QH9smHXTodVPdE35HwdGIAYpUv6WD\n    V9KB1dZ9PKPwSAQMgXBL7C1pV0ksTH1Ycw5GZXR1L+AfNF2hytcS9koR9mnFtqMzop2W0DS3rTnV\n    wxb6aQWFa0AY8F+rNPqkcR2dAYUtgrDGZ6iRUycfz1erCt+SnD83t/y8nvPal3628L0uRoOqpemR\n    tZIzPbRWpOfx2BYftLZ8z80B4dpq4GNqK4NrIPh8vBoMbgnBVhAYyKsGtrA28EwIPBsAA/MhMKAD\n    wTMgMGACgv0ATPzVjTYAz4i/QByA/5RoS+rNfRf8DSFva/z9H4n1h120q35bwK/LEWRzQDcXf4/H\n    yUFfQFadGwLglhW+x/hu6L8WvF5G4OR5IGTEt+MlqYWP2GBWrzW7ciMd8NO8aSjpi2vn6EHs54oD\n    Edqvea3XWItB4FnhV+v9sqZ/GtDrQvANJwShx3+3uA7vLNCsHQu4es4Rh0PtG91uqyBcMl000AaG\n    ta6lFmE41bdWCKz1hTnNzwo1z7Pvs8GfjVxLz+e6J0B+jzrojaVnP94F7/HLM/o9N3b+WlcFpyJ5\n    r/zKU0nZ4z02BcISKC6FYCAfg0sh2HecUgg+w+8oCO5dCRz7dwuVwIAeBGsUicUgmAh8l5YADMyN\n    wMBU1cCPAXiGKZ+BffEX0AFgK/ibgl+gT/WvFfi9+Xg+fNM+z1b1Oxp+v4z8zKFsK/itQV9AjrZH\n    /O0Fvi6+9X1DN6qjK1FvAiBtbcrnGgBp0Zecm+9WcPZW0DfNQYLcfvQC4dTv0GcZINwbOa1NgTjy\n    XKSi/V6pNZ1z7fsLwfdx/ir8Yt1o7HWwO7odM0YCsSPaEsoT3A5rpwUQrq0ODkVjPeHRU6S2jjYI\n    j54ZpdX58H1GiLWtx3McAt/SPpYkdg5azZZT0gft19HMECztz2e4HV69HPo9cu1y+NrrPTWEwdLp\n    o3MgGCjHYCkCnx8f2v9oCC5FYAD4zx3gVTIt9Bcf+z66EhiYA4F7AjBgF4FbA7BLLQTPgsDAMAi+\n    B+BZqn6BefAXsAnAxN+HsYK/gH/NX+tVv8Bj7C3F3zP2auNvCfxKH1+LvkA+/PZGX3e84wDE+Wa2\n    N/bGbqZDP6sdBGi9FrE05370njbvPS6aDCBInp9UX0et49sChEteb+f+u0EJK+DZYjDHnScr8B1r\n    Y6vk9FGzotcXa+v49gJfXyWspDq2JbCG+tzzORldWV0aDQCUJHTNaH38FAz7QLgHEq8MwoBOxXBL\n    FLGCwzEIbdVGC58VXN9zwdcX7fNUCr6S/koi6X+sba3ulVrdE7WM5nuI1uss9vyE2ju6Wth3z5W7\n    lm9NjiCcc9xcCAbyp4jORWC3TWzfliBYCsDueL2nhPb9myUEBoAfjSAw4Ifg3ggM1EPwjFXALjMj\n    MGC+GvgOgGep+nWpBeCZ8RcoB+De8Av48dcK/ALAC4yfKgkIV/5arvo95lenP3NjFX4h2K43/PZY\n    y/d4vGPO8NsDe0sGYqTwO7oyObd/rSqWpYMhJVggHQzR6JsUhXsO7pWAsObr8t1P6OUHYSvJHbxJ\n    nSPpc6xxHka9j1jCXsBelW/vCt8j8qbAt1c17UWj8z8r5vZKC7S97ThIkIPCvSqGLYKw9vNsHYVD\n    0fo8IbmWSvqX2x4r4Bs6D+9wMRTqWoFvLNLP67VtysHg3M8zub+72uc3F7qtVdmG2l/Szl7rCh+P\n    c+5PbxB+nlFxWgLBgAyDSwD4uK02BLeYFjoHgYH21cA5CAzYgGAi8OPUIPDMAAzUIfBoAAZMI/DF\n    7f+VcRt/1bNpkdQAMPG3X2bAX2A8AOfgb+zfNZJT9evyK+jBb+jfYklN9VyKvi6+7TXQF5Cv8dsL\n    fd9G+vLs43+tBkq09nsRQWsrye3ryKmqjwMemt+aPw+M9MLt8wBO78FkHwj3Xt81Z7poC3meeI6s\n    Dd5qx8o0zufsBL4x0O2FvbF+aZ534m6faOJh7DqmcRzp9NE5/16b0SDcq2L7+Bmmpq+jcad1Uv0b\n    fa8fS2mVb6s1okeA7/G4gP+1Puo+oSauzaMrg3Pu3yy+Vxxfo28V29iqr5/hFt8jfW/VA4X/LqwK\n    LkVgQDZFdA0Eu36EMhKC/4J8AHbHG702sCUEdvf6f6jcDxH4Li0AGJgDgS0AsMu18HEdEVgGwFe9\n    miNMKQDPjr9AGQDPNOUzkH7jrsXfF4e/j7whtLTeb0nVLzAWf2eGXyCOvw5if9bw9fk2se/zgIRW\n    WzSwxjcI0HMq6pI+5A4o5A50aA8ulAyAlACxr5+t+xJrZ49BmmOfXVtKBiG04NNadXDsdzdU0bxC\n    ap/PEVW+FsDX167cSKZoljwuB3tL2qxxvgm89qOFiLnXs5zjlkwdXfM4SbstVQcf26UVjbWEz1n1\n    Wprql7XPORqf50qfy3cn8O21nEzqetYaT3PuDVJtlKble5Tk80FuH3Pa2+u9JDb1ckkfW/bFQXCo\n    /ee0BGEHqKlj1EAwEK8KrkVgzYrgEPj2hmBL1cAjEfj4ZW/LCAzMA8GzI/DsVcAu18LHdULg+QCY\n    +CuPlapfF43q3x3wF3iMvatX/Up+5vJl4ue1UHmGX030BcLwe1zPN4WzpQntNwYu7meaUzFLIr2p\n    Ph6jBH1bVg+WDNb3/sa97+a+Beocb8hL+pgzCJHb/tRgQe2ATU5/Y99s71Xp2huEpb+3NRXOlqLx\n    PPbAXmCdKl8p8OZudwZfTVytOc9E3nVTi4qaAHFuSwyFa6A3d9tdQTh27NyscB3N6UPvzzk9Ps/F\n    +v8OF+LPDBqgJsVeSXJf3xpfaNX8fBVrf6/PVyXPaav309L3mu8L9lPzWq6dejr0HtMbhN0+v4vs\n    vxaBgXhVcC0EAzoVwTHsLYHgWaqBQ9XBoyH4PONXDQRrmQIROJweELxCFTBgCoHjAHzV53xkxSoA\n    t4RfYH78BcYDsCX8/TZy/K8Cf9dOadXvPxUeL3WsWvy1Dr8uRwA+ou/53zRSAr6+n0sGKkoHM0pv\n    qlPwO3Ja2JobeCvTPZ9TN/VgODUDosc2aQ+a1FQJaz2H7otCIwexW04XrbWOb4s+StO6jb2g9/5c\n    yNrQK7ngWwq9kn2UfulN2seSEHqZY7Sup1qJDYRqVP5K9/GuUf9y0gOEXTTWEs5NLRiPBlFAF4Et\n    3pc8xa3K5wcJommCbypa9wKh66nONPqP2zXyPakGQq3fk5S8F5WeD8mxcr9UG/q5Jgaf93XGYA0A\n    PiZUFVwLwd8m9iGBYG0EBmxWA38d+Ps5X+DWzHTQQDsErgVgl94QnIvALQEYaI/AqwAwIENgAvAp\n    Vtf+3R1/U/ALjF/719J6v98m2vDV6c8WKcFfq1W/3+HiAdbm5gi/5/1owi9wD72hNX018LcUfX2P\n    CQ1W9MZe33HfZ3x7vVdqBjyOV+JWg4IlbZbmPCBQCxOpcxBqd6uBiRQIa78Wff1727B/0tSAsGRq\n    553Tes1eX0K/p7Ogby34nrc/VvS2wNXS87oL9GqtlyyJZF3bFVL6eaLVtca153z+a0E4B4Nb9k+S\n    XusHnzMChq0nBjg5IGwNfAH/fVKL59u9rkLXt1afZUpRteZ66vsd1fi8NCMGW3vvON8j1X4pRRuF\n    S2dXagnCvn04DNZGYMAuBKegtxSC/z3z8a0rgYF7/P068bjREKyBwBq2kAJggAjcEoFXmQba5Vrw\n    mMYIHAbgq/7nI5oa/AXaATDxV5YUAPeo/B2Nv/+RmGq5Z+UvIF9v91enP3NiGX7dPoB21b7H/CyA\n    vseUAHAN+IYeex60yB3E0LrZd8ftCSOl+y4ZAOg9qH8/8NrmNR7qj9YgwXtcFA2Qthzw0hpcK522\n    evQATAyEQ+9BowdFLWQE9rpYWsf3ePzU+6FGda9vPw4drYDvzNjbE3AtZGZEtnItfQf/eexRIWwB\n    g0PH7/VFQKLw40hQ2Cr4Am2nU/YdD6hf5iXnWDl907qevg9+IVo/2l+olabHNaHH+tKhtdK1prXP\n    7cNnj57P8mV2tDE4tt1sEJxCYGAMBOdWA/ecDjqFwP+l8frEkjzHbdOpoIE9EBiYczroGgAG5kTg\n    IQB8Ne58BGMRgC2t9+vSE4BnwF/gDoAtT/kM9Kv6dcnBX234lfw8Bb8utZW/reH3LS5Er99c+NVA\n    X9/j3eBFb/ANHU/r2+QtceV9ZtuB/Jt5jcG4ksGT1GCAxqCEpG+xto8axD73PdSOXmt9jQbhz+Ef\n    XHmHiy4DPjOldrmC3Fib1tkd39cuLeQN7bNlhe+q2NsDdVs87znRwMZUZsDi3Oup9vXmeHztCuFz\n    QvvbbbpoXyzMNmItXwXOx9cGZsvQusdJPeeha1yLGYw0r6c5r+Waz0bSvudc91v8Hkr6eOyLpA0j\n    Zl/K3SbUxt6VwsfjSdYIjsW3TS4GSx7/+4L9SuMw2EFwKQJLIXmGaaHdMXpAsPVKYAD4UeH4td5A\n    BJalBQTvhsDdAfhq9Nk4pRZ+XbQB2CL+Av0AeBb8/RoX+E2XM+KPW8MxBMCrVf22hF9AB39nhV/f\n    Y3PBN7TdTaI6/ZhW2HtODv5qDX7k3PjnDhKMGOhvNU2y60urAUnXvtKBmFYonPMchqaJ6zGo2hqD\n    Y79v5+fM14adQLh3pa9F7D22w7WvJfhdCAaptfqTG4vgqwG8uc/naPBNJRcbNXDSIhCPrhKOHf+2\n    4bXUPZ8WMBgYB8KhSrod4rtWv3/wZaLwuWj5GUcbfVPH8vWz9rNwqE85KbmWaq0VLGlXi3WDR/3+\n    5fQlp41a/Xmb8e85x6yB4dz3gMtDpWXpWuS1GCx57Hd4vF6wVo5VwX9XQGDA3rTQVhH4/PdziMB3\n    kSAw0A+CSwAYmA+BawEYsIfA15GfbQ3AFvHX2pTPx1jCX401f2fHXyAOwJbxt/d0zznw61ICwF8c\n    9qUNv25d39Q0z8fHlzymFH2P2+dU+pYOMtRMheZDk5rBDq0b/ZnRtyQ1Az+lgx+x9tcMFpRUNtU8\n    f8d+xI7dC4RrjpPzu1f6/M2Owr3XvgPiv4sW0Pc9LvAhUOlbkzNYxjBR89gzvP+HUoO8OVhrHXY1\n    0xOJLeHwyCrh0LF951b7nLkBaQsIOmIN4dyqupkSuk6n3vOlfa/5fNMbfENx17Pa5/sd+l9LS9cK\n    rmlP7Hdx1jWDR7331+znLXS/yFKKwtL3gM9wi89wW4zALjVTRVuAYAe33xZs79vGEgT/5fRnKq0h\n    +OvE/wN3AAxgKAL/8eOfX1W2YSUELgVgl5mmhNZAYMAWBF8H/r0rAF+NPgsfowW/wDz4WwO/Lj0A\n    uBf+AuUA7KZjslD5CzzG3zP2tsLfXPgFgH8qOE6v6Z5dSuHX7c86/LZAX4exz07/70vJIIPWulfv\n    cfHg+JK29ICOnGOMHvSfYX3f8yBCTZs1UTj23NVOVR07rkZfpJFUB0vfA1oPYllF4RHYC4Rfnxaw\n    FwC+/TiThM7U8PGEoHEU+I5+33eRQq87fzuBrfUcEVOKxVZguFWFWOkxY+dP65y9+3gcCwAaa0Pr\n    SuHZ1hDOmcEkN1ogbAF9Jdc0aX9zlnHR+uJlTsJTA9e3ofVMSaMyermAkv2/Pf1dq03aKOz29/3p\n    /0tTisFSCHZ/amPwi0NVdC4Ehx5fCsG7VwN/cTruKAjWQGCNAjQisCyaCKwFwMD2CGwPgK3iL9AO\n    gGfBXyAOwBL4dWlV/Uv8vc83uMjC35LK3xr87Qm/f8iY4lgSh7Ra8Ku1pu8xZ5R9FvjZKPANtSfU\n    pt7IofUN9VoYkN5k94ZfSXLWv9UaJMmb3uthSgexW6wZ1mtwxzcIUloNo5VU33vCMCt749FA31y0\n    PEcLX2cC36dgZe5OkYKwe9xoGLYEwpJzV3u+LGHwMaNg2AIKp67RPa6lOV9wO38BtmVq0FfS19Jr\n    ae5rUus5PPe7dC3kWAjBY9obOt759++MrjUpAdu3ge197akB4ZJpognB99GG4H/PeOzoSuAjAs9e\n    CazlECkIngGAASLwyFwH/n0bACb+lqUX/gJhAM7BX6AtAFvEXx/0tqz8zYFfoA3+hh4zc8Wvq/Z1\n    keBvDvxqgm9ovxdFN65159DXLx/6WsCNkvPjrqK9gSz3eNIb9Ra4cQSInKkwNQZNjgMAWmuXtVqb\n    awQIn9cse4pbE7+Luf3XgOFea/ZKXofWngM3pbO0/b7kTEW8G/iG+lsL5JZjrc0aa/labfP7im1r\n    MgoIfMfN7W8pDLtjW0NhSVtaQVWr9YStzBQkzfnzu+aasbn9b3EtTT2vpcvIaDyHOf1116ZW75E5\n    z7e03Tlfui1N7Xrk7yL76Z2nuA1C8DG1KFwKwhKU7oXBUtT97vR3TQzWhuASBJYAbw4C504Hfdz/\n    7hBcsyawpkPEENj6WsDntIBg7amggbUg+Drys0YIbAOALcOvSwsA3hV/gTYA/ALAnwfe5IXW+7Vc\n    9Qvk4690/zn4+11gn7n4e3y8ZtVvCfy67ST/Vgq/KZh9dvhTsuawdL+SY6b23XOKMyB9A/3+1C6t\n    /c4QXx+0BqNyBvilAy25bcv9dn8of8noi8bgRou1g3OmEX6n1I9WKWlbCIk1q280pg0cmXNbatEX\n    sFHlOwp8pe+BGjg+Ktba0zvW4Fh7CmnN/s1WHQzUVQgfMbhF3zSS2xatz4epaVhLrsmWrqW+tkk/\n    j9acY8lavrX9kOQpbouPVztLUAn2pqL5PlhT+WwxJV/0GfmFlHPOy+OkYLUGhXPQ9vMDAqeO2QOD\n    c6qBj/+vBcHH9YGB/hCcg7vSx5YgsNv/zgj8/ONx/1CwbQuH8EFwLwB2sVgN3AKAgXUQ+Drx8wYI\n    PB6AZ8BfQB+Aa/G3J/y6+ABYu/LXJeeN98XHP2fA39C/1aZkvd9fnf5MJWff58e2rvptVfH7s8C+\n    cit/e6Iv8HAKdAn8tgRft//WlXW162PuBr8a7U/dmGugQC0K13xzPvWakA5MjKwO1lo31tK39nMS\n    aq9vILZVrA5Ix9r1ofD85CCmO04oPQeqtV4LOe95M1T27g672hkJxSugcMsvVvWsDo4dy+o1tle7\n    Yl88s3otDaX0c0YJCves8o0ldryaCtXUe4Skn73uSWrO+ewY3GLGh55T2ftmKpDCaikKS/Z/BNQ/\n    Jh+ti8FnvE1h7neRf7cAwbXTQu+KwL5/+wK3Q6uASxG4hUcARGBfWgGwixYEj0Lga+HjFCH4HoCv\n    BnRYC39bwq+LJgATf/0prfp1GQXAN7h4BL9Av8rf0qrf45+plOJvL/h1+9PA33O17zk5+Nu72ve4\n    7xj8loKvFHuP0YJfLciq3X5m+O0JXi3XIGw5iF467ZsFDP5MuH+NQdSZQNjX35l/j7XOwTG54JsL\n    vedj+WJpoLq0D7GkzllrbPUd/1vhMWue790jvRZ+EUSvdmm1Pm7NNdoCBtf2QXrOQtXB2v2cLefn\n    ZZZzcJ7WuSaSPv9l0mtpzfTK74THa309bYUu577Omt5T/9dOTX1Oasp6CbC2AOEjoEqqgqVtlbb/\n    c9wWVQGffzYjBFutBraAwMCclcCAvk+sgMCzVAG7zIzA1xmPVULg+QGY+Ns+FvHXCvwC4QG0rwJ/\n    10xp5W+PKZ9b4u8I+AVk+Ptnz9TTPaZ4PvajZF+pY5TuswSAPxPspyY7oW+v9ssrrdvkSWKqudBA\n    QKup33oMYqfWjitdKzo3ljC4dRXMTElV+ALp86IFfxamdpYeS2PgWHLeelTXunawknfuPPnpvbzf\n    sULRaEPO9VRyLbUyVXQskvM2a3Vwy5TMfNIzmugbyrGvsc84tWDY8stTqWtQ7HWf+mzf8vomuZa3\n    fi3ODMEl7dc8n6UwXLJmeYtpo0P7PEOw9BhaGPz8sB5vKN8Jfq4Bwc8+7sPBbU8EBuS42wqBj/vt\n    AcFfBx4zshr4+eG4FqaEtoDAQB0Ez1QF7KIBwdYRGKiG4DsAvurezT3xF6gDYCv4C+QB8Ir4CwD/\n    kVhj9qvTn9r55tB3CdK2qvrtudbvGX4BVOOvBH6BNP6e4bc1+p7/7oPfXPSVrt8rTQp/P0s8XjOa\n    6NtqoKem/25w8cmjbynba2uo7bl5Gv1Zeqq50uO2wuBUuwHZ8+mrCuk5WNoLhIm9DyMBX8B/flpU\n    ePoGZS2s5dtisHhEde/5mN96f+9t5AMuzLQlJ6Hr6uj2uPiqhrWRuFWVcMkxLVQHa78WQueO1cHh\n    jEThHuDrO965n5Ljp35faq+lsZRe857+9Gf+dNE170Na16eWr8HUF1lz+6DdVsn780gMTu3b17YS\n    CHbpAcKlECxpn6TNkorgHhB8RmDAZjVwTtVwDgS3RmAJAANEYJdfB87BTAg8WxWwSy0CzwDAQBUC\n    zwnAPeAX0MdfoAyALcEvQPwF5sRf7arfHPgF9PD3vJ9SANaA37e4eASvJfCbg77nfzsev6TKt7bC\n    1xcf/PbE3pzjfJb4/17RPh/SfsTWW2vdxvTxHqZ2gOYpbqN9sAbCx+eldAr00dUzx+PXHpNTOd9H\n    MqWzy/kctYI4S1W+I6ZTlpwLreONrugtHXBePe9hA4vPbdAE2hEgHDp+r+rgVlNFh+I7fxIQ1uzz\n    bPE9Rxrn4X3iy1MtUvLlNum6wa2ndc7N0+C/189gE3of6nXdyn39Sb5coF0NPPK94t3pTwvt9KFw\n    DQIfow3Cx/2FIFiy3x4QnEJg95hSCH522i4XgmOPka4NDIytBiYC36VmSuiYW2gAMDAPAmsDMEAE\n    juW6YJtCBL64/X8GDZ+VAvDM+AvkA7A1/AX0ALgUf0fCb2i932Na4m8u/ALAP2UeQxt/v0vsLwXA\n    vqpflxL8nQV+nwn//evElxFy9p1qUyru5tVV+n7m+VmvvM9Y03IV9G3Rlw+4SE5L2DLn/vScCq3H\n    2oep/rj+awyGjcbgcxtyjpvz+7xScp7v1LTOvap8Y23Q7nvu2sWl6Qm+FrB31ordGTICiX3H00La\n    HlNGS/L3jjDaqzoYqKsQbtH3mVIyG0nvCt/zcc8pbYdv2mjp501ptNG3RY59Gj2VsuZrqkVfRr1H\n    SPuS84Vlzbhjuna+9fysJDF4LcHgGAJL91uLwSMh+JlnG+m00Kmfj0Rg4A6ALSAwcI+/KyKwVuHa\n    rwV9n2Fd4BYIDPSB4BoEHgHAQDcEnguAib9tk4JfYFz1rwX8BdIAPDP+9pzy2UWKv7795OKvFvwe\n    /+yFvufHvP3pZl52DlqBL3A3sHCe2vmi4+9p7XrBI66As8CvJLmDkNp9WQ2EfTk/Fxr7jJ233gMs\n    50HaUQOwo5P7vpDCz57gC/RD3591XDu35DzUHKsX9hJ4baY3Dj95gET6+wz1sXUkGAzMNVU0ED93\n    JZ/FdkVhH45aAV+tthyvJb7XxLuC45Rcn0Zhbyra9w45X0bTfm9YpSq4Zor/nveCt6fjv0X9OdOo\n    Dnb7cHia2kYbg88QfPzzHIsQLKkU1l4bOAeBAeDfBY+xgMBueZKRCAzcQbAmAmtVAbtYR+BWAAzY\n    RuBRAAx0QeAxAGwVf1vBr4tlANbGX0AXgD8ZDL8uIQD+KvH/tZltyucU/AJx/F0NfkumePbt4/PT\n    /5furxZ9P8dxHdX206Pl7NcC/vraoDGw71vft+SmN9VvLYTIqRy2/s34c7QwODa1s+QYWgNJltbU\n    O7dlxUHqkspeoG91r+/4x2j9zobOhaTfWukFvr2re2eA3tHTWbtYmLo5lh443GLq6NEgfLye9FhP\n    tycIAzIUzjn+itdb4PF15vh5o1eftat8z5G8l8ZAwPfatYq+Wucs535Ba8YR6e9iq3uZnOf0CW6H\n    zRIUS06bWt4Tnr/A6v58W7g/l5rq4M8ObZAgbquq4CPe1kJwbB++jEBgYJ9qYMl00KOrgF1+zGyD\n    5uylROB4rCLwSAAGmiMwAdiF+BtPLv4CegD8NS7wm25nw5+bj/1P4W/Lyl9phW4L/D0/rgZ+gTD+\n    ak73LIVfIIy/x2me3+JCFX6l6OvyueffpPvUAF+Xb05TTmtfQUr3l1s9V1s5LGlrj4HtkhvbL3Gb\n    HOhp+cnAB8Mlx4ud39x1AmsjHcR++uDvvmk5/X2S7r9ldbD2enoukud+JRSOvc+kfgd7YV7PqZ1b\n    A3MordF3J+zN7dvTDuejJO79MwclR8JxbxRuDcI9qoN917dzm1picK/XS2wd4VRbZr6+3vXdj72x\n    tPqM0RJ9pe+hqXV2Q+0t+VzbKufz5et7ye9W7F6o1WcQSbX+Z3j45f+ctGp3qL0l91hPM7+IULKf\n    WLTvC8/7+xJ/f/D/NSBcgsHHbd4K9pPan6Qtof1pQnBuRfDoauAc2J0NgYF4JfAXh+ONhOA/Avgq\n    4/iaAAzIEBjoB8GWABiwicCjAdjlOvPxQgTuD8DW8Lc1/AL5+Av0AWAJ/AJl+AvoAPDXH489CoBv\n    Dn0fhb9SoAXy8Ddnv8fHt6j6/SKxn1z8lU4R6YPft55tc6c07gW/raZ2PoLvw8EAPSBsXT12jruh\n    Dw1UaF4JLQ5sn+NuVkNtDSGxS4tPDpLBm9JzOwqEpciUO3DVqzq4Zqro1lMc+tpnbeBaOhvA+Xz0\n    hrzWUzsDwLeC9epb3pH0qPLtMZ3zCOhN9cXCusW9UrKebm8kvm14vJVAOPVZQKv6LXac3q8NCQz7\n    2mXt2nrXl3zolaTmS3A9p3YOJff68AEX2ZX6ra9Bx3NVcj2R/l59o1TVe07oNRSCXY0vxfZK65mH\n    XHK/4NT6vbpk+3NlMNCuOvj7yGPfCveR2l/O9i6+zyM+yJUgsHucdQi2hMDH/bZE4PPfgTkRWBuA\n    XaxUA5esBQzMDcEzVgG7XGc+XoDAewOwVfwF2gNwq6pfIA2/Lqk30dH4C4Qrf3tN+ZxT9ev7eygl\n    +Ptl5Oc1a/2OmO4ZkOHvM/hB2BdN9AXy4bcF+CLw77lXjRZXGWkVGXA3UNHjSnduQ4vpmTUiRfPY\n    4GsMiDX78AS3TTChFQj7+n7ev6Q/0kEPC5XBLk9x23yKQ422thrIdn3PrWi1WLVZ+3y9x4X493ZU\n    pe8M4NsSe4/t/SE6mwKjkQ+Rn3368T2pJQa2QuFeIDwag4/tq72GWAJhQD6NtPZ5iLep/ZeSJEl9\n    lkh9nrZQ6VuyvxRIan+RshZ8zzmucez6onmNTn1BNlS9K3mOLH7Zwpde71Ux5PK1Qfv85b7Wj48P\n    tUULhKUYPBqCQ+sSnyFXisDusVrTQgNh7NWoBs5d61fy+L+c/pTuszUC+/5/9JrAf/z4pwSBJY5R\n    CsFE4HiIwOFcZzw2gcB9AbgEf4E2AEz8jWdk1a+Lhamf/+NUsRKC3hYAnFv5e/wzlpz9pqZ9blX1\n    2xJ+XX5x2v6YZ4F/96UX/GpP7yxB3/PPJVeLlleUUAVZi6re3Bs+38CCxtpZraehq9unP5o3F752\n    n8/JcaCnNKUgnDsNeO7rympl8Lkvx34+wa3p6oVUXySpWQtu5JqsO6Dv+bPK8XdCc1pnbfAtxV5p\n    O0LIawV4f+hwX+bLp0Zu8ENALG1fyft6CxTWBOHjvo6/G+8V9h3LzhjsUnJ+fct7SDLb54VvTp93\n    WvSlVaVvTo59ST2vuZ+hNMHXHfu4z29O11Ptad1TXzrWSisM1gL8nN/32t+NUJtD71VfnKZh1ozk\n    /J3XBw6lJwaHIDi2vW8/udsCD7E2BME5AOzydyPVwJoInAPA579L9ttyTeDQv41eEzh3KmhA1zWO\n    SUFwawQuBWBgXgQuAWBgTgQ2A8Cl+AvoA7C19X6PsTD1cwv8LXmD/GTgFHI3uOhe9Qu0rfztPeVz\n    j6rfEvgF7vH3CLxnYE3hbwheS9AX8MNvK/TNwUBJ5a/2VSRU3Su9qY61R3rTmzMgoQkBmgMHHyKD\n    VCMiHcjIxer3eHgzownCqdeLZF2yWFqCcMvq4GM/nyaOZeG1VxOrv9+1ba/5HTn+jkrOj/Y14mnk\n    /8+vRS307QG+GscYDb2jILd3esGxD4Y1jh2aylrz/boVBgPx33ltHJZcp137VgJhzfO46ueA8+ef\n    0n5qV/nm7NMl5zr9xPNFzJz911zrzp/xv8m8R8z5HT3fj0iXd7Ee7fdIyeteE4slrzfXxx7T2b8T\n    /Jv0uE8jSCtJawg+7yt3+xQElyCwZjVw67WBNSH4L4n/T+1zNwh+jlv8IXMbIvDjzIjApQAMzIfA\n    wwG4Bn5dZgLgmfG3FH4B3TfHFwD+PHAA6T88VYY+7B0NwK3wt7bqVwK/of30wl+L8Hv8udYUzzlV\n    vkg89rPTn1qJHSunzZ9BdkOoNYivPTVn6Xn19bmmj6WDV5L2+9rqbnQ1K5TPIFyb1DnRmq5Ou13n\n    c1Kzv9wvYVhbE1MabeSbHXxDv5c90Dd17kIAVPMctlzL9jv8TB1hfdjaCno1Ydf64LnW4HhLJD7D\n    cItj3eJ2ChCOYTCEP5MmB4OPKUEHyRrFvTICjEYld81zX0L4lHOcnOPl7vMYzRl0AP+XMLXBV+sa\n    8vTBe1L4fjTWtpq0WN845/nUqATW+AJEaR9z2u+e69i9qFbenf4sPVZtdXAMgz8T7Lu0KjgHgX37\n    ya3qdcmB4GeBx81WDZxbCdwSgAEicE5iCGx5KmiXlhCsjcA1AAzMhcBDAZj4K08P/AXCAGwJf4Fx\n    ADwKf4/TSVnA395Vvy4SAC6FXwD4WSH81kzzHNv289N+zo/tWekbevxlUQvk+/8s47Gp1AwwSK6E\n    LaZR1r4CS89BzU2/uzGvbfsHXHjb0WJg8HgTXVIh7JtKTjIVXGlGVga7/txXNNVnBhDWnB7YSptz\n    Xuex97fWUzvL1sU7tze/fan91r4GjttfKL8vtMbeGuC1DrqtU4pj2mjbC4WB+vfsHhgs3XfpdMe5\n    bfMlBwMsgbBLzXNn4boP6IBvKu48fcCFqN9WKn2lOd8XuM8Tpb9brcDXxXfOajHk/PvZ8p5U+3dH\n    e01nQPbeVnrc0v6H2tQahW8U9t8Cgz/D7U/4+jZz22NKK4JjEJxb1YvMbZ8lfl4LwSkEBsZBcO8q\n    YN+//5eGU7Sn8vxjn3MgWHumU5cQAvcAYMAuAlsDYBcrEHwd+dkQANaAX5cZALgGfoF++Av0B2Dp\n    G+Jo+AVk0z6n/r0kpfirud5vquoXqMff1PYp/NWCX+Ah2o6AX+AOaZ8FHp8Lv6WVvqFtPoPOAIFv\n    vyXbnZNzU92iH9KE2pnbJsmNbguEBPw3xaH2a7WzNQpLpoyODTbFptZusS5haww+Pye+vmsPNlkA\n    Yc1K0R7RqrqVvp+1eJ/NPW9W0de3jSb4tsTeXOjt9VpffQ3gnGuDVptaTR993P95f6Xv3VogXIvB\n    JY/PuUZLz48GnowC1tLnr1d7e4Bv7Hjn81PyZTsL6BuaMSP2PPpeG63B13euJOej5p4m9Lup/Ty0\n    +J3RxuCW0+L7ovWlmxYo/A7lU0OH2lKLwe7vEgg+b3tOCwgurQaWbDsKgYHx1cDnfWlCsLQKGMDQ\n    SmDALgL3AmDAJgJbmwb6mMkRWB+ALeMvoA/AM+Ev4Adg4q+/8hewt+7vCPxNwS0Qxl9J1S+Qxt+f\n    Fb42YvALlOFvK/itmeK5FCjddserQOkVoRR7Y/tpXXUWy7eB94SatGin5BxpDhBIp1pskfNNs1a/\n    3uPhh9/3KJ8K1rXJAgQf2yPpi6/f0n3WpjUIl2LhyMpGDfDNvTa0fM/NOZctp3eW7iP1uB9w0Qxl\n    NfYrBVXt1/gOawC3QGPpNUPj2K0qhX0gfI70vVzjWloyTTQKHneOVnXwMTODMDAWhXuDr+SYsbVk\n    Q322gL7HNmvcf7xHW/DVOAdPcJt17s/rQrfol6+NLaKJwU9w22393dDxj9GYlr+0P+88f685N6UY\n    7FD2iLPfC/fTYnroFhDcuhrY2rrAwD3+jqwEBh6ib6gyePR00IAcgVetAnaxBMGWARiwj8DdANg6\n    /gK6ADzDlM/HWKz+tYy/wEPwHTntcwv4PT62tOrX5YvI/9dM+dxqume3b19K4FeCt5979vMOF1nw\n    W1vpe9z2/M6feyXQAl+3rx5rSvrafY52Je0o9C1NaBAhd3DGV1kqPZY0tSAcem6O1Qgl00X72mMB\n    hH2DWLG+tRjElqZmzeJdsfcc7UrfVlW+523Oz73G8+nbR+5+LYOvBF01Xt81uPtp5bFLz9GHwu3u\n    +1weDViVvBfWHqcVCN8W7Of8vq41y8aIymBA9zqaCwSl6xX3SgsUlryvjwBfl9jnTl8fLaCvxjIJ\n    7rN0rF8l2JjzmbZ0n8fkVmtLl1zRzAxVwbE2aiGx9P2v5ngaIHzGYA0IBsowOLca2G0XSy4E+7C2\n    BwSXIrAEgM/7OKZkSmhNBD7vr+WU0F9HHjfLlNAtENgKAANE4NxYgOBrz791AWBN/AXsV/+ugr/A\n    GAB+cfj7SPwFZNW/rfBXirW/ggx/c/apUfkL+Kt/Ndb71aj6tQS/x33dZFaXasGvb4rKmjUia6t8\n    Yze+WpXIudGYtnnk4NL9edDJuS81U6LVoJ4kEhCOPY+hAanUdNGSWMHg0t+rkRgMhM9ZTUVET/At\n    GeTTWr+3tC2S49ecwxDCaE3t/FeFWRw00Fd7OucUwtY8Jz/gohpqtfppMbWYfMwPKIfW1ijcAoRL\n    MPicJ7hVuZZqYnDuttoo2wKFS9tSG8n5C10f4qDUJi1nzMh5niyir29aZ187Q89bqP+a4CvtV8l9\n    0PkY2p/7pa/pUV/QdAk9j7Xt0qi8DbVJc981a7yPwmAHwUd07Q3BKQQGyiC4thq4FoF7VwIDdwA8\n    EoFnAGBAjsCrVwEDdhC4BQAD2yOwDgATf+VZCX+BsjdBC1W/Lr51f4G2Uz/nTvmsDb/Hx9fALxCu\n    /B1R9ZuC3+P+j2k51fN5f6XwW4qaF5XAejyuJsjW3sDXIm/ouLXfxM6dYlSS2HqzWjnfzPeEsZYo\n    7G6mPwvsp3RQy90YzYDBLQYGW6x3KE1qLT1pjq/xmjZq/a5rrY9e28ZQO7TeE1pU+h6vcxrPh8Za\n    vj88eN/W2U8osmnb76NxjjRh18qU0S3X3c3N42tVOi1R2DII1+6rFQZL9tPyi1U18FASzWUaRl/X\n    JW1MpfVnL+voGwLfWGJLlpw/z+emFHsl7dX6gm7re6/S9oZ+lzTeH58c7qe0UvulGF9/NVC4dhr/\n    mutcyRTRn+H2EbL2guAY0h63l4DuOd8JjiFBYOAh/NZWAgNlqC2tBpYg8HF/Wgj8deL/XUYDMCBD\n    4N4ADBCBW2Q1BL4O/LsHgesBeIZpnwE9ACb+PkzoTXAG/B2x7u83uBha9Xt8vCb+asAvUFb1ewZj\n    Kf72qPh1fSqZ5rlmXd/Uu/pnie0lj5Nsf07q+fWBWg32Stp/vhEuGfTQvmm3NsVz7Ca/xRrEmuvB\n    nsFJE9TP1cElqcVg9/vxFLfe57DHOs29qoOlvxejBtckaVXVe07pQHWLc9Sq0tdtX/t+2aLKt2R/\n    pZW9sWPVnJvcPliB3N7JxdAaIA5Pe+9P6v3fCghL1g6WnJvadYNr1wzOyXmfPb5Y1RuFNVJzPe+x\n    frBLq/V2Y31+/9OfF8VApTG9s0sJ+p7j2nCeajn3d7DFus+1a/CWfkbXvifU/nJE7nPjO76kTTXv\n    SeffD8kXCmIY13r94FRfSzG4pCq4JwRLEfi8vZVqYI3poHOqgJHx+JIpoXtXAltAYOAOgkMI3AqA\n    gbUQ2PpU0MC2CFwHwLvhL1AOwCviL5APwJ8YGSAaNe1zDtT+k/BxufgbQrjayt8RVb/H7VIVuyn8\n    1YbfZ5Cv8Vs7xbMEfQH/jU5L8HX7k6z19Bnufkdyb8qlbdaA3lC00KQl/Oa2W7rGWos13HyJHcf/\n    be14u337rB0U0RhUSYFw6vc11gZLGJxqK1D3+yB9X9AY5O6xNrkkJQPVrVA8VkmX+7x++OlLDmXb\n    +1Jb5dsDfL8Q7sel5LxI270r7mpFgpulMJw3HWkbFP5Quf05tdXB5+toybW5Jwaf9917lo3aNTe1\n    sFhyLa05Vs0SJqXtrU3sGn1uq6TaUBN8NfZx3j5VxV2yHEju55zaL6eVvs56fEY/RguCNdt9bJO0\n    fSXvCa7N52PE7qtix6kFYd/20n7VYnANBEu2bwnBtdXAQBqPR00J3QKCcyqBAeA/NwDZFAR/gVtc\n    GphSN4TALQEYiCMw0B+CV0dgQA+CrQIw8ACBywFYC39bwi+gi79AGQCvir9AHgC/gN3K35ZVv4CN\n    yl/3WM31fmsrf2vgF4AIf3vDrwP2nG1bTPHsi3u3r0FfCfge8wEX3puY2E2/dN+pfeb+PDdPBe3O\n    SUn7cm+8S9ubWzlbMiCQMxjh279v4CjnnGqC8HHbkqmij9t/U/H72nLqtlRyB7FLfz97DMJqRmsK\n    +9yB6tYV0LXo63uM5mB1DfpqgG9qBoycfeZP4ZjfR438LbBPzXWGW+QHz7/9vMGNvRRLc3E4F4VD\n    eZ/RxtA+a0FYG4NDP5PuoxcGu+QM1ub0KZZaEO6dWhSeBX1z3/fdeTnPEFOyn88qto/1o3Qt2w+4\n    iP7+5Xzeye2PdN8fcFH8+1j73tJrjeD3gb9rJNU2japhyTXhs8C/a4Kwrzq45H2t5HqZA8EOZntD\n    sKQa+LvD/5dMC11aDdxqSujW1cA5U0JrVgID8yDwj542tAZgYB0E1gRggAicynXi5x8ReCwAz4a/\n    gH0A/sfEzzXxF8gDYAvVvxL8Df1baXLx9/hnLLn4+2XgZxL8/SLybz3x97x+7wvBY1us8ft54PHP\n    MrdvWe17zkUD9A3tx920SKboPN+kakBv6eOlN8waa0SW9iWW2M3wwzUg27RNG4ZT+5NOLVsywKGJ\n    wSVTRWv0Qbp9r6qD42BG6dThs2HvOaX4m/u72KPK17dvCfpKp2YcPbWzFH2fCreX7MuXnPPQE3qP\n    uGsddFvmjMUaUNyiYlh6DYnt99OCLxRpTRetNU20pM3xz1Lt1ww+57jfXBToMV20xYTOU+r9VFIR\n    2CJa6JvaR8nroXZq59wv/Ob2IWea6JzzKWln3vU579w/gex9XuM1olUN/AS3oudB816w5PHn9wfJ\n    9cD9mRr78KV0+v13mdvWbifBYIey38OPujUQnFofOFUNXIvAqe1mqAaWVgIf/5Tss9V00KF/szAd\n    9B8BfHXqdw8ABtZAYG0ABtoiMFAPwZYB+GPGAPCM8AvYn/65J/7+PvFziwB8gwt8e2hDDHm1ANhV\n    bkmwtjf+tqz6dfEBcG3VL3BX+Sup+tWu+JXAb2g/NdM8l6LvcTuNtSelNz0fcCEe5I+1q+e3zCXH\n    Gl3tW5JQm2MDqT8kvlmfm9TNeM6xvvDsK3cqtVoQ1qoM9iV3cFK7DW3WOiyf6u7po/+fZ1C61xq+\n    Lj2qfIE89C358o2VSl+HqTnnNISrLcA3tc9QW/5WcH52Bl6N/JD5+BAipwA0B4VbgvA5D98j8rf3\n    pWVlsGSb8//3wuDz/kuqxHZB4eM1OOf56PW5I2d655LUrllb04aSKl/psc/7C/Xl24HYG8vdeuXx\n    /FDxubm2bVqRtDfnfqTlF2Hd+6ikzb88wVQuCJdUB5eCLqBfFXwG3BUhOLTNM8G+foFbL/pKILgX\n    AlsE4PO/u/Ge0ZXAP2YAMKCLwICddYGtADBgG4EJwJ7Mir+AbQAeud7vMRbX/r35eGwJ/mpX/gJ5\n    +Hv+uy9S/K2d8rm06tdFC3/P8AuEEbe06lcLfn37qqn2LRnIdsf5DO3Q1we+vr+f8zTSJq0b66co\n    R4jQ/rRiaY1fSRtz1t/KjfSmP1UVIR0Q0ARhLQx229e8LlqCcOlzXTazwV1Kf99GD0z3quw9RrpU\n    hEYk6Fs6jaKFSt8S7HXbhiJpU0117/HYJah7DpG3f3JhOJQjGJ9RVYrCtSBcgrnvD/ubDYPP247E\n    4GNyp4wOnQdpRl97XfK/WHvsQ78+96r0zU3tZ9Hz8TXX3dWYcvn8O9ga30PHyL13ifWhdXpjsLQd\n    0irjmj6+E7TZ994PyMZNXHLfS24qti1B5FwI9v27NgT3QGAgDMFSBAbKqoF7I/D577F99UDg889G\n    Twf9Y+DYNS6SGwvVwFamgXaxisCW1wH+mL4A3BJ/W8IvYBd/LVT9St7cRgHwGX97VP0CbfC353q/\n    VvE3VfVbMt1zyVTPvn1qwW9Jte95TV/J9lrgG/q30M31Z5F9SBO7qa7dd6ztJbkQVEPHUvbN3fxo\n    TPdce0N+fzMdaqNehawWCJd8Q933u/I+87g1bS7dh2xat7LK1XNq1vQ7R3uAOqePGgOJ7vz0qO49\n    piX61p6bGvQ9o+0XFdseUwu+0imVa7HXKvRqLq2Qk1o8bJFaGE5NQ/2D4HE9Qfi9Zz+law/XQPK5\n    z6XTlLq/+96zeyJOTZVw6tzE0gKFa2bUOEfrM4eknz2gsbZS130GdZH/7pdP7awFvrGEKm0/ZOwj\n    ldT9qCQ1X0LtFSsYfG6L9r2o21/o/eB9ZJvQ/7cA4ZvC7dyxtSBYisC+bZHYl2+/vseHcPeMwLHH\n    huJDYAkAA2EEDv2bb9tzvvn4pxSCWyAw0AeCLVUD/5g47g7rAlsDYBeL6wIbrwIuA+Dd8Bewufav\n    BfwF0m9su+IvkEZb7Wmfj4/Rwt9a+AWAnxW8Bo74W7rWr+Z0z8fHx9b6LYXf0sHPnGmeS9FXspaj\n    ZJAj92rzNLCf1HFK4zteKbr0rvb1tR+Iw2KrNpYOop7b7wZyQ+hSOm1jzn5KB2aO2+UOklnH4PcP\n    /l7+Gsp5P9AE4VSOAyPn/rX+ve61dm+47w9zfK7/ip9V73MU+gL319ieVb6uvym0bQG+I6F3FOb2\n    yKe4zV5/VzOlOBzD3tQ+f45b4ZebwsmFWYfCFiqDS0Hhyem8jawMPh+zxzX1Yd/D19XWkX7WqDkn\n    TyPP8zmjq30l9zYxEP5QeC2tQd+atXuP7yHn63np/UlumySRLBFzbMdMEOy7r9GEYMnPco/n3g+k\n    VeWhxx3/XRuD3x3+7LVW8FPcRiH4+8jPANn6wr7EpoVuXQ38d+VK4NC/hbY/phUCS2YPaVEJDNhH\n    4Oe4xR8SjyECh7MbAhOAsSf+Am0BmPgbzs3hmL3xF7gDYGm17q/QZ8pnIA24X0T+3WrVLwB8HRiU\n    1qr6DcHyaPg9blsCv6Xoe/xZzlRmqTbmYm/pY92xaten0mpLbbQGYDSn1AolNs2i9LVUu36tZPDi\n    fcW2rs3n6QVLB000p7bU2Ifv9SMdNC2bbyacFgPYvX9/rYEv8HC5DI2ZGnqu6RvD5h5r+X4vRHJt\n    8O2JvU8QR3GmLxJrg7B0f89O6yD6olUdfEwpyo7G4OM+nuDWBAafj9vzi1aaFYXHaH7OyDkf5+OG\n    0LQmPa+lx5zX0v0i47kLtVlrzd2cCuvS6aFbfi70LVsUa2soq0wPXXIvmtOWEoR+l9jHeV85MC0F\n    4RTSum1qrnO52/qqgj/DbbRa9xhNCP5K8HnkCHg9p4SeqRJ4FAJLpoM+XndmQ+CV1gUmAqdjfBro\n    fAAm/sqyCv4CZQD8AsCfB+MvcHfTkgJeLQAumfZ5hcrfUNVvDf5K4Bfw429L+HX7P/6sBH5r0Pez\n    w7Fi797a6Hs+NgTbxdqnURUWG1ioHTjQbI92NL91L00rIP7lA1zMb29rEJZicOoLBRrrBo+oDM4B\n    eODh+4k2+EpTOojd4/e357q9oZxh9vwat46+0gFfrUpf/xSSeevvzgS+BN72aQ3EJShcUyF83t53\n    ndDG4JqZPWoGyWvWCw7t5+np30Zh8DHv0R6Eaz7PjPh8cT4fqTYcrxOlfW1d6Ss5buzLCjnQrVXl\n    W7uO8uMpe8vuP3LaWrs+c056vX9of4lDes9W+yXd2HaxNrwTbO/yFLei989YdXBuZfC7089L379L\n    IPiMuX8P7EMLgkPInILd2mrgWgQGHqKvpAr4vL2LNgID4yD4a8HPz188sojAPaqAgTkrgVsDMEAE\n    drmO/3heALaKv62nfQbiALwz/gLjAFi76hfIX/O3tPLX5QvP32Pbfh/5We6Uz7lVv6H1fkPbacDv\n    uV8l8Fuyvi/w8KYgtA/t6Z3P2x/3L7mRDVW2aX4LvnaaSc3pnVsPmEumPm1RcSBJ/s3i47i21k4R\n    Jv2Gf862qf38gAvxDdh5H9Yqg0vXLhu91mFJPuBCZYBb8p4+orr3GN97pXt+tKbO10Tf0rUEtap8\n    U30pRV9L2DtimmZp/1tXNEuBNLWWrnZawnAuCtdUCEvWFq4F4dLr6HE7zeuoNgZrtbE2JRVypfkM\n    7SqDtRLDUK0vL46q9C25lr7H3bX0Uy+C5R0zlFrwDe3nAy7U1pCVfvG4Nv4v18Rm7Gqb8/Ne+/tb\n    8z56fK+sbUfsvT31fueb+r4Wg0P78GHwSAgG7kE3VA3sfnaOBgSn1gU+bucgWGtKaEAGwSUA7LY9\n    5xvIARjCx+YisFYl8AxVwMAdAgMIQrCFKmCACNwiiyBwHgBbwV+gPQBbxV/ALgC7dVpH4S/weN1f\n    IAy8mlM//4+MtfH+SfAYDfyVwi9wD75fCLdvUfULxNf6PT72jLQa8Bt7/LHqt2fF7xl+z/8Wakfq\n    W6Sxm8UQLuegbwvw1b65lk7x1WMtr5x2piJd36pmXT1Jzmv31ayfVTPI2gqEP+ACH+CH+dLB6BEY\n    HBoAS8X3fNZUZLWO9anZWySGvoCNSt8fcBFcfiKW0umd3fvj+X0yBY4zg29r6A31ceQaxC3jA9DW\n    UNwCAXuBsOTcHPfhPje0qgwObV+73nAPDO6xVIckPdswGoRz7wFGPT890de3rYPGFDCMAl/JtlIM\n    7vHlqR8S96Qla6q3jNZsStptvRWuX5/Tv5x11O+m+w8jreR4EgxuCcG56wQfITiGwEC79YEl1cBn\n    wMuF4BoEBu7x1yoCSwDY7a81AltZC/iYUDVwrypgYOxU0MB+00Evsh6wDIBz4ReYF38tTvl8Ti8A\n    zsXfkfAL+PEX8EOv5rTPUqyVwK9LTwA+V/72mvJZo+q39XTP7hjvcDEcfo8/k1b7ug/70irfY3Iq\n    fo8V7drfXNeAm+ON9BPU40wPTCptY00l8vmmuxaJQ32ovbnXBmEpBkunxEsdT3JOSgexJdvF1oEO\n    Jef1WLPOskZ2xF7Xjg8d0LdmP66NJecsF31D2OtiBX01obTFwPS5P1rtlQKkxvFysLNV/1ogsSYM\n    a4BwbXVwbPtPcSv6TKK53ELpdWonDNboZ25ao7D2Fz/fF+xH+lmux7U01d7j9r7fv1L0bQ2+uW3S\n    eo3/UHj+jym9P+vxe6pVBey+VKDxheVzmzRnf5BA2f1sSboYHKsKjiFxCQbnQPDxce5ct64GPh9D\n    gsBA3drA30W2iUHwSATOweJ/z2jXfxaswyzN14J/+wK30yHwagAM2ERgS1XAgDkETgNwCf4CcwIw\n    8fdhpABsAX+BOwDuib/aVb/A+MrfUvwdMeVz6+menx22eYeL5vArqez17Td2M1BS6YuM7WurwGJV\n    vbn7PN9QHysztYAm1iatKaClbT3fELeeglqKw772p9r2d8Ub8ZzBjVR1sK/dT1D2TXcLVcE5v1Nf\n    KH5YbVkZ3BN7rUDvse+SqbdHo6/LZ40qlELvL75/r0XfTwu3y2mDNJpr9bZC3li+F7ZdsvxBKjnT\n    YKaqNzRyhE5NGNacQjoHhFtVB/u29332+DRxLQfKr6XvDE4TDfjfC0dPF33OLCisNVVxbP/Hc/Ft\n    xr58/epd7evruwTJz+9FqVmBQseKReszylPEviyW/8VRDeSVRIKjvn6V/m7mYKzWFzUefomxrC2p\n    Nml84Se1bvrj9/C2GOxbh/h8zBIIlq5vfHz8Z4d1gkdMC91ybeBaBAbuALgWgYG88RQpBOdUA7dE\n    YB8KW0Bg4DEEW1gLuBcAu1iaEtoaAAOmEDgOwKX4C8wFwKXwC/TFX8AGAFvFX6Df1M+jK39brPlr\n    sfKX8Ht/Q/s0so0m+ob2cdy2dPAhZ7sPwkH92OCwxjfjfceUpPRmP9Sf0KBubtu0p35+f+rrcf+l\n    OFEDwjVrCJ+rfEuO5zs/JduFts8ZUDn2JWdg2FdppJXa6uBe4GsRe0Pt0gTf8zFK9nX8YpDGOuux\n    fRzfY1pV+tZW+WphqkZ1b0voLZnuWrsNpcmtfj1GE3C1YVgLBGfB4NjnG+0vVpVggRYGn/eVui6M\n    nkY51K6WSfW59/Iux/3lngP33l/yPJagb4slcXxLpuR+5pYu3SNJ7hfXXXxfvj0+ny0+O0rvpUqm\n    hZZ8ptTIsW01MzOEIoXhnGOXXj+P2/mg1NeGGgxOTRHtmx2q5Hg150iKwHf9qZ8WOheB3eO1ETh3\n    Oujz3yXbHtNiOmhgDAJLq4CB8dNBAw8ReKdpoI+xUg1sEYBdDECwH4Br4NdlFgAm/oaTAmAL+Htz\n    Or4D4Bjy1gLwNx+PIcHaX+Hh9Lix1OJvKfxKtz0DcC38uoRA92tPhXVL/H12evxfMiq8NeAX8E+7\n    LIFfDfT17eczz7/n3NzWfkv9PHWzNBrfLP8hAi4tktO/vH7kRzKIkGrvd4+goe4DjwYK+wYPQl8o\n    qJkqOpTWlcGS10Vommjp61x7IDkHhFvirxXwlVbaaE3r7DuGdH+hc6ZdnZQa/Myt9O0xtXMtampU\n    9x7bq4GsI9DbajRAtPR4tfvTQOHa/tdgcGjb2GeM88/c+2fN9ey28DOCSysMBmSoYwWFW4JwCsnP\n    aYm+uf2XfIEq9Bz2qvStmdo5Vh3s275Vda80PzwYwwj/7uTMwFDSJum1Ne/Lou3jXufSe0GtmYN8\n    MFz63pdbJey7zrw77S+UnEpdSVWwry2h6ZxbQvCvPuLgKAj+KoCTx8eVIrDb9ryNZFaZ0imhQwgM\n    6E4J/ZfTn6n9aawJnLMeMDAPAq8MwMD6CFwLwMBwBH4MwBr4C7QDYOLv47TAXyD+xmURf4E7AG6J\n    v4B86mftaZ/d40rx94vA/8+Avz2rfkfAr8t7XDyC35Jq3xz0Pe7nM8+/HZMaSKipUPqAi59uhkum\n    fMwZJJBWlNVEsp+cG/kelY+SQd34wEcKao59HwPCx3P54ad/S2/jy/uCbVLb5lQGu9dYybl8Ch0I\n    aF0dHHpN1Q4aWwTfnDWze6Nvq/f+43GlFTmx99ZS+K2d2lkDPGuun1rYW4rj55RcR0sriGuTC6rS\n    99va9XBz9l+zn54gXFIdrI3Bxxw/R2gut3BO6nqlicGhvqSuL1ZAWOMchPp67uMI8G21jx9w8dPr\n    fmSlb+kXcI+fx3PWDg6di5rPeD8Ir6dPkIZgzXvBkuR8rq59P82JdLaGVL9K3iuOawtrfwko1Y9c\n    DM6t1A1VBZ8h2D02tqZvLgTnTA1dCsEt1wY+t0GrGrgEgF0kEBwal2mxLrC0ElijCvhrwc/Py1VZ\n    QuBeAAwQgX2xDMDAUAR+CMBa+AvYB+AZ1vt1GYG/QPiN6/+APfxNwS/Qd+pnzcrf889LAFgTf2vX\n    +3V5Fnis9pTPUvgF5PirDb8A8O3HY6fgN6faNzV99Rl+cxGgFnxr9hPDYq0b/1br6s5aHfVDg7Zr\n    obAUhI8DQ58WDrqWVAdrVAb7fj9zqyhCsYDBofef3P1KnstRABxb9zzUfs1B6hT69pjh4bvTdVZ6\n    TO01fUejb8n5c9e77yvBN3VeNKuPV4vOlM/xfZQc43gtffYToJS0rK5/NRisPU10zmeK4/vuLwoH\n    L3PWYE59CUy7MlZSJXx8bM/1e89pcQ33Xe800Fvj+hy7FsTORWpJHEmFsIs2+pZO7eymVM753S2d\n    zvl4TBete5yH9zbzpWZZhFCOz2np/V64Yr58v8drXs9ZIc4YnJ62Xo7Bqemhj+36InG9a10RLEHg\n    u77UQbBkWuhWCAy0heBYJTAgA14pAv+78By0rgQ+/sxiJfD/HfhZCwAGiMC+EIG9uQdg4m86O+Ev\n    4Afg0dW/o6p+XaTVv1IAzsFfDfg9/lvumr8Ocksqf8/bPAs8rhZ/c6t+R8PvseIXePyaKan2laxZ\n    /Nlhf7kVs7WVXrlTjcYGop+gHHLO+205FZdra4v0mLor1v4Wx3cDDzUDBL51ulKvlRIQzl1zOLcy\n    +FjVkcrxuchZA+icWgCQDKCUDpqWDM4cn/ceg9rSwdDY1I+t2nPed8kgeumUksf32FHo69t+JPj6\n    3lc/nH5eir2uX6UV05J9l8b6gHjt4HcpEseO+ylus/fr9ucD4dRrz22vVaWcys8fXbPzHi85tuRa\n    +j6yTe6SDbVfXmqFwaG+SCtnW7Up1J7SY5VcS1t+fjmm9F7qOPvLXXvLU7sOcumavNIlHkIQXFPh\n    ez9zTptI3ldbR/N+U9L2mutlzjrusdwvFSM7Tii+2RhK7jty14s/HkPyhWbpFNGp6aGPfXyaOG4u\n    BL8DkvsEHlYD5yCw20byOJfvPY9JVQPPgsDHbV1aILC0ClgLgIH5qoFjVcCtABggAp9jHYCBIQh8\n    B8Ca+Au0AeDR+AvsMe3zMdYA2Ie/P0+0QxN/pdW/QHr6Z8l+UvgLxBE3hL/Wpnw+PtaBbUv4dfn1\n    x8dJwDT3Rj1V7fv+hK8h+NWs9j1u81cheD+FrGLtnNS0prH9hQYDjje0kht/KeieH6c9KJBzI+7H\n    Dt0PBjkDETWDCJoDHiVVwsdBnicZVTnn45RCsEvpNNG+NdJi/T//TqTWC5ZGC4MdHLYaNI6vpdU3\n    5/e3XtAb6rPvyze5/alZPzEXfkPv3TXr+tas6Vv6RR/pOr7nqehD4Ctpb8m586UEeGuvnbNMAX1O\n    7uB3bXXvMZLr4fF45yrhFAj7jue2yb2mjqoMLoVg4OF7d2gbyfW15jrqQ4jR19FR00WPuJbWTkd8\n    jNasSdIvtfmuB6kB/hbTO5+3L/nCbcmSJ63u70rvjUrui1p9ebhX+32peU/O/RJPKQjHvtyb+/7n\n    ZlTIuZ98IpxOWaMq2EGw+/lICJYg8F0fyquBpQh8fqyD4Nx1gf/eEYFj00EDeggsrQLWmAraZSYE\n    HgXALiEIJgLrZWIEvrj9/zyik7pYrv5dAX97wK9L6E3rk0nwF9AD4JGVv8BjAC6d8jm17feen/XE\n    35bTPR/bIV3r1xr81qBvbsVvTt8l61j6ji3B3lD7UvsIxe277YBRWdpNOV1TwZOCFfm+WwwefPpg\n    cFtaLVi+5mMNCKcwOPSa9J23nArfERgsmW6xJQjHjntODRC/R/q9pMf63bFKnNL+Sa8Bqff1VtW+\n    udM7a4Bv6r1dcs7c7/PfcIFPcf+5K/e6oYG9uegq3TengL5LTQVsyb5zr/XHa8sz3J6mwowndT1I\n    Xe9LQbh0veDQtloYLL22lmBwqDI49PMWSfXvi8oBLEkfWl9Lz59JNKaNboG+sZwrhO/bDc+/pXG7\n    Znrnmnu1Hz5eHx/+28P4Zvq5/5lOar/EG2rv+YtfGvvPTem9YcuK5pIv7J77knovkaKwdOme3PeE\n    d4LHu32G1gz2pbYq+C+nn2tDsOTa9/Tj55BcBAbKqoHPP2tRDfxd4LEpCLZcCfyX05+pfY2sBAb6\n    Q/BoAAbsIHApAAO2EVgTgIGuCKwLwJYrf4F5ANgC/gKP37TcG1ZvAPbh768B/KVT9W9v/D0+pmfl\n    ryb+puD3+FigD/4+OzxOsl5Qzk17Lvw+PW2jDb+hNX1jN+0XFVN7SqcRKwXf47apY8X21XrwyBr8\n    5rQ7Baku0hvzkmmLS+If0M1J/geunOrgFARrVH1LBx9Sg8jSxG7ic37HjsevneqxJtLz4F+Deczv\n    bmhQtrba+SL6ux/vq9YUz0B/+D1vJ30vj52vh+vJ3x/n+FlLY/BXG2Ul++sJvBoD+S3WM4xFgrk1\n    FbE5+yv9ktYz3D543ab2J4VN3zVfci5yK4Nzq4JzzpWkMhhIX1u0K4N97esVXztyPmOMuJb6PneU\n    foY5p3a5nHMbc7dz24ZeC4+rY9NrROcsGVR2XyOduckfjWtFzv1o6f7O5/pD5j5bpASDW09tHZ8l\n    KR3pWtIpEM5Zuid3mYDbjOuHFINrqoLP00LH9ilpiy+S696Tj5WjvaqBjz9LVQP3nBK6xZrA0i+Q\n    a04HDehUA6cAGAB+hVv8yfPvvRH4R9wOBWDABgLXADBABG4QPQBeGX+BfgBsBX8BPwB/jQv8pmMb\n    QvgLtAfgnCmfe+GvZPrmUPVv78pfKfwi8Fht+AXubshTeKpZ9Xs8lhucL4XfkmpfBP7fxU3vnDvA\n    kPP4801t6c31+Zip/bQYTHqS+e+hvsT+/ZxWN+U5ba65gS7pS+00aaWDEq2nivZVW8SO96kHSF1C\n    xyvB4NqqYI3ftftvnKf72DOjgPcc33tuTWVRaj/SfltAX9+2Oeib+8Wd2NTO7t8fzlJQVuVbsv6x\n    tO+SfWkirzVUPkYTazWOV4qhkn2VVggft/tUsK9c2HTHaVEVnDpfNRj8vmAb3/W2dqmFY3usgLC0\n    7z0T+hxVe513/epd7Ru7tzv30SV27/FwCQP51Nel6PtEuP9UW8s/86cj7VNqXw+rk+tgs6Qf0mjc\n    c7aC4dT7R+i4Je/THzzbtFoD3rUvdB2Ifbkmpyo49tjeEPw0McX1U9ziLe5htuXawD0ROLS+cwyC\n    W0wHPSsCSwEYwHAE/iOArzwI3BOAgfHrAlsBYBdtCJ4QgXUA2Dr+AvYBePR6v74c37Ac/gLoBsAx\n    /AXaAvA3H/ctAVtN/D0+LnfaZ5cvTn/PhV8AogpZF9+Uzyn87bXW77Hq120bgtTW8OuL78ZXq9o3\n    9G/nvkqnbC5ZA/IHwaB37Ob64ZpjsmOWxrd/rRv/kn1q5nizez8Ftk7bQjfSWpXCx+lSj/k5bkXn\n    vXQg4gdB23z9eO/dV7rK19dO32CcL++92+ZPEV1TCQvoDGK73/lRg9hWwVe6nqw0bn+l/ZXOyODb\n    5pgR6FsyWPoDLpLPQW2VbwsYT+1DC11LnotZU7JGbel+c/ZfCsu5g+FuoNJXHezbb8l14YOwz75+\n    W50iOpUnFecrFNeO8+cLCyDcC4Njlawa58F371jyWap0BibJ9vdLAPlzvkZJZ6YpgV/f1M7SSD/z\n    H68/P/fc/8TaVtuOnHMRnz3g8fPV8/5Re3mf2nvFVJ4I9h/7fZfci+ZMEe07prSSOITHWhAce3yo\n    jcfrkubU0LHrnTuOFII1poQ+/1wKwbWVwICsGviIviVTQQP66wED8jWB3f5Kp4TOAWDgMQL3BmAA\n    +OF0zN4ADMyNwNoADNhG4CkAWBt/teHXxfL0zxbw9/eRn316aMPI6t/e+Auk0fZXpz9j6V39m6r8\n    DeFvTuWvtOr3+Nie+HuEX0AHf6XwG9qvxjTPnyX25fv3c1tSKF36DfSngX93Sd3APoU+9tbgbu5+\n    S/rcOpLBCt/Nb+mNec232z/1Dq4//CLBB+F2JccPJ2fdx4usymBfpW9qveBQajA4NEV07u9d7gC2\n    5L2mJQhbQF/fl11avG/8IFzSwr+tTrVvTeVpLjSWgK9rs+RzgQ99a64LtVW5Glgs2efKwKsRTSQO\n    oWUrFM69loamig7FXR9KgCEXdzWniM5pby0G329bP2Wirx9SFOkVTQwunbo45zy4LwSV9K83+sbO\n    UWo5kpzjxaN37xaKb7Yp3wwGsW1yjl/6+azkC2itp1pOpdeSPtpIHEPh1O97qC1PIvd2OSCccx93\n    vqd6kmibBgZbgeDjMdxjcqqBWyPw6EpgKwgsrQI+7qtmXeAUBIcQeAQAA48R+JjRawID7RHYGgAD\n    tqeEbozA5QA8Q9XvMVYBeDT+/j7x8/80cJDnCMDSaZ+BcvzNgV8A+CfhfnvAL3APvpIpn4HHANxq\n    ymf32CPYtsRft+/j4G1v+P3M828j4DfUv5r1I1ODEKEq4Fjuq/7S5ysWybfYNSKZCvr7Cmg5R1It\n    mtPW3PNSc/zQPiT7+hsukt+ItYLB4eq9+8f6BgyeRh4f2uaYFhj8ARcPzk3NAPaHyPa169WG+pI6\n    ZyPBNzSVfYv3qg8ZkBmKhSmeY+gb2mfoPVoy4Cup8nXHbo2+peBbArS9q3g11mvUTo+1gnOnL5bs\n    Q7Ifaxh8hkjpsUPbHNtvBYNLph4N5TZzClJpLFYJS/qZM7NSTmJr5tZMtXt875dWVWmir2/bHx7c\n    J6e3kXzOvU9bIPW1Jb00UNmxtbC3dukfzamuS9uSet+uaWduW8qmy/bvIxeEnyTu7aQYnHMf8wS3\n    oori1hDsm75ZY2rod4H9HP/NVQP3mBL6+PNeU0KnxjyAh5XAEgB225zTohI4F4J7IPDIKuBjQmsC\n    u/SA4BkRuBUAA3YR2CQAz4a/QDkAr4y/QBiA/wHAJ0bwF7gD4B2rfgH9yl+gfs3f3PV+U/irWfUr\n    gd/3uIiC7jG58Hv+9x7we/xZDHJDUJsa2JcMQhwfI53W2SV3HagW38r25Qwns1T8nuNuXLXbVXsz\n    Hqv2zdkm1QatNYwft/Vu3zkDKb5p3aT91KwKPm6T+t3TwuCn0J3eUnouYv3TGOTOgWztqZx9+Q4/\n    UxuozumfJm4et8tB8hJQ/5tgSsofUDa1s2aVr1Z1bw/otYi7mmkBxUeEzN1/SZVwLgi3xOAfBO3x\n    tUM6o8jjqVR1zknOedGqCgbaYfC5X9LPRVpYHLrW+Pra44tctcf4QXi9CFUIp86LpJ2+bXOnbJbE\n    fRYuee8vvZaWTun8A+LQknN+Wn/x+Phe8X3F9Nmt2hTL8f0j5z2+th15X5K+DW4Tel97uKxS+l6t\n    tDI49r56m2jD+d9T6+0ek4Lg0LrCWusDW60GboHAvumgJVNBA7qVwEAaeWdFYCsADITXBXYZjcBA\n    Wwi2iMCAvSmhzQHwjPgLlAHwKPwFxlb/foqLrlM9n+Nb+/fnRip/c/A3tb/zz7SmfZZscxzELK38\n    PW7zLPI4DfyVrvU7qur3s8C/p9b4lazvm8YZeZXXU5RX+sa+bZ8LvoB8HajSgYHUPluv76s5QFxz\n    wy8d3Ne6MS9BYQcwJdNQ54Jwy+pg/+CwP7FBB0kfU6gbyns8fu2XnpPUdqn3mZwBZmkkA7atB85D\n    baiteI4dq6bKF+iHvkAcOEsHU3NhXfL48/TOpV8A0pzyWrJNbHsN7LUwAD1DWqwLXLourmT7FlWw\n    JRic8yWhTzOuo742fxd5bMmazCMqg4F2IFz6pTONpK7lLY6fui5IoNs3FbEkx+3c66EUfkvR936Z\n    lQvP9v60XM8391yWTOlcM6OSJvamrs2aeJp7bUqt8y5Jznu0xpeJS47vvtTrS2r9YGklbw4GS66F\n    rio4td8nnqrdc3IgOITAvv2k9hl6XGg/uRAsQeDz41wkCHw89qhKYKAMgb85/TyGvDkA7Pt7bH8t\n    Efhvnn2PRGAA+J+B468OwEAZArcGYMBWNbAZAG4BvwDxN5RRAGwRf4E0ALeu/v1V4v99qcHf0qrf\n    1LY1lb/nqt9jngUeq7Her1bVb2v4Pf5MA35D+zn3SQIebuqy3MGEEvSNge8xuVN3SvZ53k/Nzfm5\n    UjN34OF7xfdwyY3AOZpVXRoDD+eqnb8JXg8l3+7OWX+4VWWwtMr37rF1A9i5A7T3MwWk951zXj7F\n    bTVwlgz8WFi/NxRt8D3P2qBZnZTb3tpqX1+Fb2zfvuRW+7Zc0zcHfXMrfEure2uuAb2RtwTBc1I7\n    PbJ2anC4pFK4NQiPxuCcquBQe2PrDPeaIjpn21CO04RqI6mF9YJTfc97fD3i+b5UVztb0JNIX3Kq\n    fXOvpdLPFDmfcXPPS865TN0DSrcJTR//JLFdTrTuyTSuVbn3p7F70Jx7rtLXzfFYpfd/qbYdI7m+\n    xaqDtTD4PeLL6Dw+dnrNeMn00BoQbLkauBSB3c9bIPBKlcB/Sfx/aD+lCJwCYIAIfEwKgAEisGZK\n    ENgEAO+Evy3hF5DhL9AegGfC39HTP/fGXyANwF94/r/Xmr9S/AXu8DYHf1tN+SzF3xr4rZ3qWYq+\n    x/7EHutuVr9I7EuKvu6xvpvgnEGH2MC/NOf911a/hdpz/J3Rmn5TO6EKL61pe2PJHYg4nqfSQYyc\n    CuPa6uDz68wNCvjaHnstt8DgnAGJu2p7+SCN5Nwdf+dLvuEuya13kN4m+LbEXrd/jb6PRN/j40vX\n    pCuZ4jl1fXDTOwNy9G1Z5VtS3WsNe117aq7NP2/Qrru2leX4ftQCjEtRWKtKWGu66NEYfGxDyQwi\n    52lLS8+D9FwcozlNtMv5vO2Ewr6+at0vhO6dSqqE79palhbVvrHH+8/F47hrwPH3Wrrsiyb6lsCt\n    a3vJ+3zL+8FzlfinD342NpJ1159l3L/l5PweV/reGXvvj+0/9kUe6fI8qfdlB3uxvj05HFPyPpSq\n    CpZCcOxxvSC4ZG3gknWBjz87gu35uL0qgc9VwC7fJrbxRbMauASBe1cBA+Ong/7Bc3wLVcCAPQSe\n    FYCBfAQeDsCt8Bewt+5va/wF7Fb/fvrxmKMAOIa/QDsAdvjbo/LX9++5+PtF4N9a4m9J5S8Qxl+N\n    9X6fffy526Zl1W9ond/jz2oqfkvgN/Z4SbVvTqXved+hx0tusn1TfObkIjHddE4kFag52/eMRqVY\n    6dTIqfgGAVpNQ507ZbSkolg68OMGB3Kqs7XWpUr1KbWUQQkG50BhzqCGNLe4NYO/rbHXRWugugZ9\n    fdsDcvg9P65kgLYH+mqv55tb0Sp5j6wF31LoTbfXxu/l2Dx8nytFWV9KtnXHr6kQLlknt6QaNheD\n    W00RLfk8EaoU1DgP57TA4FA12aoo7PrVAn2l19HjudCqbg19JpNeS3M+S0nv2Y4z+0i+EHX+/cmp\n    2I1tUwO+sdTc26RS+oWAkpkdWif3Pi73SzbSfIrbrGvFOR8gO4+pL+Om1gs+Pz72OPdYd10KXRda\n    QvC7yD5aQ7AUgYF2U0KfgfaMuyEIrqkEBuJjDb5KYN//h7Zz+cbzmBD0tpgOuvdawC47IrAFAAaI\n    wLE0ROBxALwj/gI2AfgfAHw9sPo3hb9AGwBO4S+Qv+ZvbH8SAM7BX8m0zzVTPrvHukjX/AXa4e+z\n    088/h72qX234Pa/Z61+b6WHVkhR0nwoe4/KzyHFDkQz+x+Kew9obes0Kp+N+Ndd/ksR3/n6O22YY\n    XVtF7FvTLCc5AwG500W7x4eqfFPtOD8XOdN0aUPwDz8NusmrgmPnzB3v3MeSQeIaDI69N+ac75q0\n    XLf3GPfFHa2MQF/ptP6tpniOteFuP/f96Im+FsC3pMr4/sswuhn55amcaFf5uspjyX5jgFwDwpLt\n    czA41p8e00S3miJaus0PaLtWsIv2msHH3Ho/3+hfW3uhcOpaWvM5pOTzwPl67/tsdW5/KCH0Tb0e\n    WsLv+XyHflf+lriWfvrgPSo8NXbuOZO0Q9rPcztLttf8nOdyfg869lGryjYW3zlptWZxyX5d+0pA\n    WFoVHDoPfw8cswaDj4+Rfqkn1ffcqaGl00KfH1sLwaG1gZ/i9gHmpqqBd0Hg0L+dt3ORIrAUgIF7\n    +P1L4nE1CCwBYBdLEPzHj39+hdtHNtM6o9cCdiECh9MIgeMAPGv1r1X8BdIAPAp/gf7VvzeRvvbC\n    X0APgGunfQb8kBuawjdV+ft9BuT5IsXft6f95eBvSdXvedszsr7HRRR1XbTX+R1R8SuBX+ngRag9\n    Tw/HkVb5npO64Q0N9EuOl1vJmxpUDA0OaE7ZlpNQO++fk9z91X+YSMGwZKDj54cBXmlqQPg8CCKd\n    jjo1hVno3LTEYMka8TlrBZ8fe36f8G3bAoO1KnxLv/XfAnvPka7bXpIW6AvEv8ijvQ57q2rf4z41\n    p3eWom9L8A3Bt+SLTw/fB+tSulaxxeRcm2oGuv9WsJ8fAv+W046cCmEpCLeaJto9NvaayVk/vgSD\n    pceJVRzPgMHH3OK2CQTH+pITvaVf4p9FNND3vB9fv3+I3INJH+tytw5puC3hcyGL9Fp6rAq+a1c4\n    sc/kpV8i8+07lU8jj5d8vj+2TeseMae/56mh7/fRLrkzFaXuuSSfD0oqh33Pm/TakfOefj6e+zP3\n    Xip1z3SGYF8fcyHYbVMLwanpo0MQXFoNfKwCdmk9JfT53yVTQtdMBw2kxyBCXzgIIXDtdNASCM4B\n    YKDdWsCWEfirj8e1hMC9ANglB4JbI3ArAAZMIHAYgFviL9AOgC3jLxAG4B7w6+LeXNwbywgAllT9\n    AnH8rZ322UUDgFNTbh5/njPtcwx/Y9uFKn8BiKp/ffhbWvXrfnbO54mfH/PM8xhf9W9t1W9sumf3\n    8w+Cx8SOmboZ9/UhNBVzLfymBikA4Hv8DKlIK79S/fT18Rjp9GJ328f362tb6VqMLZKC35rkrG2U\n    k+8/QkTpPnLgrhSDU3AeG3jKqYjOheDz/s85vxalA/g5VcFPE+2NDdbmDBS/hw/Z+t10uddZC/A9\n    omePKatbo29OxU2qAjcUKSgfI0VfV+0b64vv2KVrG6ceF9vOPV6CyiXnWaOiN6fKeZfUrJ0bSgkM\n    +9okaVur6mCtyuDcquAcDM+ZIjrUD9+xUjOSzIbBLsfrfM30qpL+aAGvJL7ZanKupbFrfWw/P+Ai\n    +nks1k5f3O9F6POiLzlIKYHf0DTXsXWCff04v5ZbVvmWvNa+/ziNdS3yxqf6rsunGe/XPSK51nzA\n    w/f6knNS8t7sknpfK4Fgd9zjsUO/95LK4PNjWlQEH7cJoexoCH56guoQAgP1U0JLEPjzwGNcctcF\n    /i7yuBAEl1QCSxBYaz3g1DTQLjsh8BGAgcdO0zqzIjDQDoJbAjCQh8DdALg1/gJtAJj4W5be0z/P\n    hr/nv/tSU/1bgr858OtSU/krwV/f4yRTPqeqfs+P8VX+aq/1qzndszb8Hm82nyYeL53i2fe4GPym\n    bsB8N8Q5z9EPp4FwybSe5/aFfheeCNqfGjxoOfVzKSQA9VNulcDwDxH0ya34OUcThGPVBQ/bmW5z\n    7vrJJRj8feZzXgLBTwBRNZMvuYMXofe/0JrDrdNrHV/t/CB8/87dh2R99tov5ZzTeorn4zGkfaqd\n    3jn1Xn28Duacu5o16kvAtxX0zjL9s0ura2rJfnOmkJa2w/eY4/5j12CNyuDWGNxyiuhzP0L9TC21\n    oL1ecM1+SjLrdNE5s/rkfq5JoW9tO88Jwa8vuWhZOnNG6stjj3/3H+b+C0vp15dWha+kf6Hq2tTv\n    mnSGlZKk+pM7rX9NJO85ktkiQu/DIRyWfDZ0x815X/RdQ1LXiNS9tGSGJg0IPvc1tM/YdTIHgUOP\n    +wJ/jz5Gsxp4BAKffxaDYK1KYEAXgY/buWgBMCCrAvbtpwSCcxAYGA/Bx2mgXX6PfgAMhBG4NwAD\n    NhDYEgC7KELwYwCeEX9z4Rfoj7+AH4At4C/Qr/rXh7+/9jxOG3+/8exPc+1f7XV/Q/jrfubbJgQG\n    JWv+xuD3+LgQ/B5/do42/tZO+RyDX/fzkumeteA3dPMdWhc4Z13f42NT0zxLblKfnP6eM9DhHhuC\n    4lRFb6gd0j78LdH/WDSrn3Kq4Wpu4GsGkY9wUbqf3IHJnCmjXZukg2EuMRDtjcG5U3xLvll/X9WZ\n    N6CRamtoOsOSweeWIKyJvjOBr28/qQpf33a50+370qra1wr6+lA3Z3A+1aZQSqt7pdXMJfvJ7d+o\n    yqRzW2rX2JWmZArLc/6mdOxUv37wbH8+rrSSWLsyWHOK6FoIPvfj2FfptNclayefMxKEAV0U1sLg\n    1su4pK7LuevafsBFApLuI33//fSnP2WfP7XR19f34+9ZDmTm9Dn3+hTD3lj+9vE5e/h7XxaNL0v5\n    l4Yon/XgnJprtmtHztIBLjn3CaHzf/vTdSNvNqnzsTUxOOeLtbG1gs8/O1cF+/ZXu0ZwDIJ9lcDn\n    x9Qi8Hlt4JIpoc/A+1bwGJecauDcSmCgDIFj2PttYJtjpNNAp352zF8gnwraZRcEHgnAABH4mNYA\n    DAxF4PkBmPhbl54ArIG/QD4A51T9An3X/c2p/o1N+9yi8leKv0Cbyt+e8Bt63Bl/W8Pvcbsc+K2Z\n    4jkGv9IbV9fGkirf8Pq//seHjh1KzuB7ztqPkpQO+OdM3yaJxoB2qFqttsKptEr4NjiI7Hsdy/ar\n    icHSwV73OAmGlWBwKtoYHLom1gw85yK7ixb49sJel9ppnUP7kaIvALwNzABR+p6oDb/nal9Jn7Sm\n    eHYDyrH391z07QG+Ndjbo3J3VHVw7vX1U+RfU2vW95VuWzpttOaXjH6OW++XtWoqg2euCg7l81NF\n    VKxftTOpuPSeLvocDRTOwWApTpbsyyU16B271vnak/qscVwfVevacl4iJfda2hp9Q/uLvX5zp3TO\n    BV/JtT82DXFOv0P7r8nxvqPFEga+lM50IJ3lSHq/9mng5yUzNd1mXiNiU/9rVwX7tpdA8BPcipb7\n    yYVgt11rCJZUA9euCxyrBD7+PIS7fzj8XQrApdNBhxA4ZzpoaSWw5OfAXAg8sgp4RGZGYEAPgnsA\n    MDAMgR8CMPG3TazjLzAGgEfgL6BX+dti2meXLwL/n7vmb4vK3xj8AnXr/Z6rfo/blUz5XFP1C9zf\n    jPeAX7dt6gb8uH3pFM/HG+ka9Pwl5IP5IdAOVTqWDt5Ivrn+aWCbc3oMSJd8iz83NYPP5zZJb1Zq\n    BrLvB3Glj78QDeo+QVmVUqvK4PNrv+Z5ujtG+JipwYlcCD7uP/T706IKKfbN/xnBV6vC17e/4+tB\n    MkgrGdTMSWv0jfUrdT6OCfX7GfzVvanz0wJ9/4aLKuzVhN7zAHfpfmZN6n1acn6k+3IprRYumTZa\n    E4SPj3MwXLNmcC4Gp173FjA4NS3ph8h+Sq+loyuEAb0qYdcX7Qrf0DXLd30+I2q834+T+swRupZK\n    K4RjOX65M/b890Rf13bpUijPcJt1zYktXRM7R+f2xY/xeNvwNPHlbalJzvrvmsd63P/wsjzn5EJt\n    6l4sVhUfWk83lPeZ72mha1spBp8hOPQ+fzyHofdhTQg+I/D557791EDw+bpeWw1cMyV0aMzke+hV\n    Aj+LbBuaDjpnKmhgTgTOBWCXMwT3QOA/Hv4+GoEBPwRbXw/YZSYELgFgoBqB5wTgEvh1sbDurzX8\n    BfoD8K8Dj9EE4FL8Pf89FOm0zzmVv0C4+je2TQ0A51T+luAvUFb566v6BWT4G6sMTq3165KLvzXw\n    644XH/y+H/DWht+cm88ngr742nzO96fjn1/Dud9C922T6tfbyDrHNSlZ01FWoawf3035uS2SgdSS\n    abwkg9IhDI4Nsh1v/mKvI+k3yyUYnFrnD3CIIztPknOTWsPX1z7J41MYnFtlHRtEKB1wdu9tuWsR\n    p9ISf2Ov2Vq8Dg1ohr5w46KNvsdjak7xfNyf9hTPF5FroXSguhX6ArIq35IBaknfeiCv5hIKNdG6\n    vqYG+XOuN9J2ytbJlD8255zUTP3sHn+8ZmtOEa0NwcfjakOwr+/nPn4I7K8Wbltco1OpAeDYsjY1\n    U0aXXqNT1akl6HvcrmRpmlhy1p+P9SHUf/f4EvQNPe782g8tMxT7smXNF6FS24ba/YNnH7H34F5f\n    noq15YfA31vm554q2FCbXEqX4DnmvKZwCNNyMPj/z97fLUmOHFuj2EJm1k/3cIZNcvNQn65kMtP7\n    v4hudC0zmcw+nXOks/cmmxzOdFdVZkIXgCNWONwjPPCTWT3TTht2JRCICACZcLivWMt7xEoOWOf2\n    UPEBJeln3a42Z9lfehbfEwheAwJvLQm9lAlcAnYZBF7LBG6tB1wCgPk4sX8ZbTygt6UmsP470k8L\n    EFwCgf9Y6IdB4FsDwMD9QeD3wAReCgADvw8QGFgMBN8WAL43+AvcFgB+j+DvP5zx9waAI+AvsA0A\n    /K9CHxZoa4G9SwBgDxDeQvq5FfxtlX1eK/ms94utZf4uAX+BMqu3tn9r1m8E+H0q9LEW+LUC5CXB\n    cEQ+tJSgZxBMz2sJ2Mv2Q+NxW9ZiXNvX2mB/SbK4Zgl46Ivnv1Y6rJXVlL478SR2q/xzNEEbYQWX\n    ZM2j1+cUSCQCbcnoaD3EYbxe1SSv912ypYnmFoC0lgDm5MMegO+eQG86h/LcSzXYo4nYJXOqnT/b\n    nrV9PSD37LRpYfC2gL57sXzPhXOttffmGFGAaLFWxvV7sygQuaY/vkZryimsYQivVZ7w5tvyfuAB\n    Dswe9ubRAgQP7X1r8Y23BILbxtyWWVs7acj8/AAAgABJREFU/y2txTdv9U6wxl/XfF2Km+S+xZ59\n    Jf/ttddmfUc4liuZ7yfjTGfdT+n6RHzCK+I5gPOUS4g+B7f3p9qYEbxGWnmLxV2W1YDgluNK579k\n    LrVnzS+FfdFyPLo9x3reMVHAObrAqLSgZykr+OdCn2J9BQSOnMMj+ncHAlvz1kDwXnWB92QC3wIE\n    jgDAgA3StgLA1udaP1EQ+FsFgIH7g8DAHAj+VgBgYBsQ+L0DwMAiEPh2APB7AH+B2wHA7xH8PaIz\n    HzDA7QDgv1Ta3RoA9oDeEgBsAb1R8LeF+VuTfQa2AX+BNgB4D/B3T+BX9+exfq1avy+FcWus36fK\n    /ijwC8y/G61sX7YacMDtIjLMJclqDqo027Z1Nbl1bFTKWSzKkto6Qb0H8LvEagntKCsgWruv5Tjr\n    WGlfulYeGGydwwP6poTGEonoSP3m1mT9G8oST9rWJrCt611K2Nf6L5mVxHgKHttq+vmwhilkzXkv\n    k+ddDfD1zlNsD+B3CUNpy9q+b4F3BW+8FrbvHqDvXgzf2nm8LTgueo7fCri7lS1NmpeOB+rs66W+\n    tGQtYHDkPJcyg722OpFr1RqOKHHsVSt4DyDYuj7WeZbGflwxv4ht6UeB3JfuxT72YvaIH4/4uppv\n    se5pqy+Nylu/Igb8RnyMJ2dcegf2rk3Ul5YWUuq5eefIc21l9y59b6rFLXpeS/va2rZe+BTt3xtj\n    iXR0tHyNZfpYXa/dW2zhSUjrcaMqTKV2PFYECBY2cOn8hem7BgiOsoG/GsfcUxJaQNoIEByVg/7V\n    2G6BttKulQkMLJOD3oMJDMzB2hoI/M/A9lofERB4KQAM3BYE9vCZ7yDwbx8EXgsAA80g8G0A4K3q\n    /n4r7N/3CP7+Ax3+A7gLABwFf4H1ALAH/kaA36Wyz9a2rWSfveO8ujhLZZ+BObD7RY3hAct7g78v\n    6IqSzsD7q/Vbq/O7FPi1xq2xfYEYgCDtSskHnaDQgdCravsrupBsZ23eVvtokt07p70Daotd1jrm\n    raS39HyXzmFJ4qCWDGA28po52FZvG2UGi3mJ++i1KTF+19a+qtmS2o+R42rztc6xtQ/7fL49MCq/\n    FusAX+D9sH1rvqWF7WvVLbYWpkUSve8V9N0C8PWeRa1+aEm5giXG1+Sy82/3mAECe5zL9sBwTUI6\n    mlivK23E2rWe21pmcKmNXggWZWZJu/fACq5dG+vcrbFL4z8G2rx32/JdIMVGy/tI88qtpSzAsDhx\n    W+BXL871GMGlcyidC/uXE/rNfCkanv1fGhnNp8DvveRPW9rXroXYLeO8Vlvrx7YaE2hj0UbqqbNF\n    AGHNDAb8HEi0ZnyEVdsy75o89M+V4+WYGhC8lSx0KxC8hyQ0kEDda+Gc1zCBSyAwg86tTGBvvq1M\n    YG8bH8O2JRv4n4Fta6Sg1wDAQAKB7wUA/weAyzsEgYHbAMFrAWDg/ctBbwEAA00g8P4A8HsBf4H9\n    AeC/OdvfC/gL3B4Ajko/i5UA4KXs3y1Yv15fe8k+y/YW8HeJ7LPYx0I7YABpdZs19X63lHx+T6zf\n    GvAL+MxgLYn8ZBwr1sL2tY5vmbf04zF9vRpPpYA/AjKX2kZrXW6RqG6RBvXmdk8rBetr5roULCwd\n    W2P8WknsmkR1LIm9TiY6l57N5xUFg3WdsNYEds2W1qOKXI+W4+2Ew7I5t8oRvkeLPqOBdvlDz9b8\n    7reUeW5l+0I906PKCktA31q70hysObWyfNcwkpa03ac8wWARMPeezOGIj9gSMN5KarPEEm5hCG8J\n    CO9VM3iJHwUG9lZpDM0Kfi9AcO3aeOe/ZM57M4T3tjkLMKYgpG1eX7ndj25ZXiYyZ22RBbfAPI8Q\n    BTf1e6317qvbxq9J3E9EZJZL51ZjBHvH7nV/9fy37ncPa30+bQEcW3WCreeWNVaLaoIVp1jxXwkM\n    5jFqQG8UCC7Nu8QKvgcQvKY2sAX0fjWOs/aXrAYCtzCB5ZjSfrElIPCeNYE9sPdnp71lWzGBgeUg\n    8N4y0MDtWMA1fOa/cF828L1qAr8nABjYBwS+KwC8Nfi7FfALfNvgL3BfAJjBX+C2APBndd5La/9G\n    gF8gxv5dA/7qvv5dmHNE+rkV+AW2A38BHwDWwK/er/exrWH+Ajn4eivwN8r6/a0Bv5Hr2zWCvoCf\n    QLfm6klK1+yHSvslQfraBPR7CcpLxsmTVmZrxNbUi/piXH+PBdUqEyZziyawa6CqsB2iCQQPDLaS\n    B6+Ffix7r6zg2rEPqEuN1ebsPSv2ko3cwqIS/EC8Xh+39+yWoC8QA369ZLWWfWyVpvTabcFQamH6\n    bsXybWH4toLWe4G8v2UpaOtZJwDxGnA4Cox682hddNTaNlmciRU9h61ZwbqdZgdbfbTUCr6FPHTt\n    nEvnXuon2r4mQ3pva/X/ccnkrnnh5JqFNiXbGvj1yvpEYrq3Qj+6zxojWPqILqDasu6tJ8e99L5u\n    HfuJX19bK/hWtjaGPCFWmkcfo02zbpcoE9XA1ZIvioDBEb+xJSu4BgSzNLQHAku7UrxWk4UugbMa\n    CL5FbWCZr8UCBtrqAm8NAreygIEyc9kCgrdgAnsAMJCDtREAGFguCR0FgYFlQPB/q897gcARfOa9\n    gsDAvkDwbx0E3goABsIg8D4A8JbgL/D+AeC/VfbfAwD+xzimBnZvBQB/Ns7ZA4C3AH+BOvv3WwF/\n    rWN+LYy3pewzt/PA37XMX73PYv/WwMmtJZ/vIfe8F/Bbkw2N1snV36ka01f3sSXg+0DHR9pHmchb\n    2QO2B1+2SvhF6/p6Y6wJ7pceO6/rVz7vFjaTtI+yZyymg24D1FeT8/UvJbBLkn0RMNhqY809msDW\n    1y1iS5JWETCYn21Lvlu3BIajygVirWCvHFM/52UWlZhuOQdb5jkmX70U9C1dp28N9N0T8K35r1sA\n    uvdaRHULCc5Skrv0vGwBhVueu1v40j2YwXsAwfHzyn15hBXc4kdvwQoun5/fZ2tdznv70pqlmCG6\n    yKxenkDbXqCv9J2XkfG+13XlDA/0Hc7bP5cS21dbaZGYXgzZEsO11C0u+VL7O7zM1vqpVn/q1Qtu\n    sS39961loWvMW89Y/SDGrI4Bwg/oq9fgI41t/T5/CZxDVL1hLRAs+0o1gvcGglvYwHuBwBrILYHA\n    t5SDjoDAtbYaBGYwdykbuAQAAwmsXQsA8749AWAgDgID2wPBUXzmniDwXyrjfgeBl9mWADAQAoEH\n    APg9g7/A+679+x7BX2DO/BXbGwD+7JzvPcBfIAG1JZC3Vfr5WwR/pS0Qq/m7lPlbY/3qNhr83Zv1\n    CwyBfo31uxXwa/VRAn51+63q+0auqyQcPAAqEmh/wcGdX+08vL5bgJEzurBMarS/2tjvlfnL92vL\n    VeRLgENtLTJne9Y7rCVW9DWMSBv7tffaEthrgeCoLb2f9dX1bSvs59eLV/O3J8veg3nPhqXPqD0T\n    zmJ7Ar//wsF8pyid473YvlvW9F0j7axB39p3QH+3WtUwtkwU87lGJLDfq2lW75bPmNbnr/YhteNz\n    5ms74zfqS8+Iv2dEgew1YHCU8Vyb868AfhplpLcpNxGvD1myPRdjAeXv1ZrFV1uXaog+pzVoEX2n\n    sMCbXwPHLvXBkXcDqRe8N/AbOd+IOoj2K7X37aiPXFrHt+X7e2uwt2TCCo6yAm9tteva8oyMWO8A\n    sdGxWxnC1rP6A67V61FiBkeAYDlXz7ZiBL+gHmtGZKFL+1tqA5eYwLqP2n7PRBJ6CQgs+8VaQGDe\n    dws5aDELCP650J/et6Ye8JJawHrfmlrAYktA4P922m4JArfgM/cCgWsAMPC+QeAtAWDgmwaBtwWA\n    9wB/gXUA8F7gbw34FbsX+9cDdPcEgD8XztUCgP9ZuTZrpZ+BAaytAbyl/RbYu7Turwf88n5uXwsy\n    f4Atm6qthfnbCvwC2zF/l4K/Udav2AEdvhbGq4G/DO5axv3mjLUc+AXggsS3An45cV+TAqsl4ksS\n    ZFHQN8qO0u2XBNjRREJk3u/J5vJmpbbcbvmLTCRh68mueWzfkm3P/BnsS1ByrZZ0j7BjWhLYnjw0\n    j2X9xloSLkuTM7XEeO2aWOdk/Z7XfD9vAQp712Cp6oF3HVrHj9geoO9Zvct8DLYtnU/NP9xK4rmV\n    6buG5XtGV62heyr0VzrPLQDwvYDdvRnHe0lrRiWga+BmyzNLzqU29lElzFsA4Xsxg1vB4KW1gmsg\n    +BtS8rR2XktYwcD+zODI3L25leZ3q0VXa3yc9/6pzQNVa34xIhvuWcuCMMvvPmTf/zroa12PqC99\n    RbwkRMt5rQV9ayoflnnfW+tdoc7WLM+jZtG4bauYbU9rfR60Lsqx7KSezd4cvLHWykU/FHxDRCaa\n    JatL519jBa9lBN+SDQzYIK0cZ/W9BxuY6wI/oTdBYAAhNvBWILC02VoOGpiDwLX2DAK31AO2wNoS\n    CFwCgGV/6fhbS0GLbQUCt+Iz9wCBIwAw8H5B4K0BYLEtgOCbA8D/M4Nvltte4C+wHAC+J/NX7NYA\n    8LEy3l4AcCv4C+xb91dsawB4T/BXH7MH8zci+QzEZJ8/BNpIXxb4u7Xks25n7XsdwV8PxF1T61fv\n    k34s4BewawJHpJ4jNSRr17Mz5uStCI8Av0tZvi1Bu3VOtWB7iaxqxCLJkq0T4621BbcYvyWRq61H\n    vQZYmmuSSN4reeC18+YYAUStANdLzkWZzLUEtvzWfkUsodlyPqXzYqvVBa/Zw+yc5VnZZlskwJax\n    merXQ59bxG4F+Op5b1XbV/uFFvlG75zWsH1bkrKRuW4F+lrnzd/DEuB7Un1F7UOl35Jt40ti53Qv\n    q/nXLZ41S+sDH42kZGSeEUBYTH8HT8GEdu3aRJnBayWio7KkS5nD3F77r9PCJDjbVkBw6dw9W8Jc\n    1qbnvBQU3sKvLfGj0dIZnul3gNo9bFU2avGlJ/Sh2r58/rVrl97PtaLV3CILj62x82fXslIJrd8f\n    jjsi3xuZ4xoVl7X+zorLlgLP0QXCsb7aGLYtFpXBtvb3Qd+gj48oPonpOrotC5Kt32otXosAwbpP\n    a+5LgWDNHF4CBHsg8Avt/wlz2eg9QGCe4y1A4F+N/R4IDLTLQdfaMQhcqgfMVgOC9waBayxgIA4C\n    bykFLbYWCF6Cz1zeKQsYeJ8g8F4AMPD+QOCbAMDfwV/bbg3+/hXA3+8AAG8N/gIxALjG/BXzAN5W\n    6Wfrs1hJ+nlr8BcYWKw108zfj4V2a5i/LbLPmvX7gs4Fd9lamb8W63eYxzLwNyr3zNsAn/W7B+M3\n    wsh6UP1ZyYFooK2B35oEmNeP1a7GTrL2La11W7NUf7Y+h3uad/5LJJTL48SP19eoLwa09txakghR\n    9o+uCVZj/5wC846ygpfKWr5N97fPxl2SwG659z0lE6MWSX7W5rokebQHI6Ll3PcCe8W2era1Ar9d\n    wed416BFnvFewO8WbN9IvfkI03cr0PdhbH9rsPcWi6Dei1mJ8SXPnqWAMDCAt2e01QU+V/qrGfdl\n    +egIMzjin6Lz2GpRldcu4p+iYPCtawWXzj1iW4DC2rY4H8u29qWR9xOg7d1Azn0t27d27lbdXn2P\n    lihnRNi+te9ai2qIB2BE1UJq56P7eqscs6SkTqQ8ROR47xxaa+LeyvRcxO9srRRQimVaFu+uUZcA\n    7MU7Eb8g/el6wS1AsD4XbWuAYN6mgWAN+G5dG5hB4GenjQcEb1EXWPphMHdPJjAA/KkgJ85s4C1A\n    YK8m8BoQeCspaMAGgvW2tUDwEhYwsB8IvBSf+Q4Cx21PABh4XyDw7gDwnuAv0A4A7wn8Au8b/AVu\n    DwC31vwVWwsA3wL81X1Fa/+ukX0WKwHAEfAXSADwXwtt/qFqtu7J/NWsX2A987cG/Mr1+jq2/ZcB\n    1q4BfgG7hq/H+tV9bgH8PhaObQF1o0n4Lgua10tuAsN3JdKOJZ+3AkNq/dSA33sCwQM4kQOCrbYV\n    QMzJ3ehK+hNiSfCoTFftvE4OK3kNGKyve4s8dO3ay1xLwTuP35IQqiXt9XOrtuLcs0i9vNp81yaO\n    Wr7LewC+a58Ra591SySegfxZXzuHVuD3XrV9a3OU45fU9D1XrheDvg8oL55jWeeIj2oFfFuT0t41\n    XZLcXgpO39IigKhlnj9b4k9b51s6Rj/vo2CwJRPtAcHWOKVzWwsGvxd56OE6xZlp3xoYHLkOer5R\n    azmvPf1o9J21dTEcMI/RSue8pMat9Q7oqUdFWKN5f3E1Kev71QL6eozgrUDfyD2WkiYtbOClrN4t\n    SjDwvGvXbC9rAWE9v7M1W7ikYGHNU2T+I+cZZQZbihU1ZvCaxchbA8GvmD/PGeC2AN8t2cAaBAbm\n    csWtbOAWOWjpo6Uu8FoQ2GMCA8B/0t9r5aA/Gttr9YDFfqb2bP8qHMNgbQQABvYHgZeygIF9QOCl\n    +Myf0WffjVvYewCAgXYQeG8AGHg/IPCuAPDe4C/QBgDvDf4CMQD4vYK/wLYA8FLwF1gOAEckn9ks\n    oLeV+RsFfsUE0K2Bv9JGA8BbSD/vBf4CceZvCfx9hg3WskXq+ZYkn2us31qt31bWr2z3auFqxuwT\n    bbesJvVcAn6BcuBdAoa9FeWyfSvQtwuCuCKZecs6vScsA3pvVRP4S+H++efU/lLSJvWor5d9TDlR\n    0sZCWgsI19qVgvVaABYBTEusYM34BW4HBJeSnJHktfeM2FKWck3CKHqukXOybGnybcvnx1LQ9xHA\n    F/VuELkm9wJ+b8X2ZenmNXKU8l6kx+HPEYC0VYKyJUHdUkfesijA+14ZwlHwtRUk1v22+ORWQDjy\n    nOb5c//8t05YtoKow0KvdRLRt2AFt0h21tpFQdBjgfFj2dYy0d61iNreLOE1IFYrc7a1r+g5ec9p\n    ff+iCkZLgV/Qfm/uUbZvLfasxSdRkNubX0vb+H22VKX8ubPvalVD2rKWtTbvebV1bLr0XT5ar37N\n    eNaxNT/EbSO+swUM9tq21Au2zsezLYHgEggsx1hsYB5ryfw0ECxS0M/YHwS25shAcI0JLG2+FPZp\n    izKBgQQEr2UCWyBwrR6w2M9oqwcMbMMEtkDhpSDwGgAY2B4EXgMAi71HIPj3BgJvAQCLrQWCCyDw\n    +waA3xv4C9QB4HuBv8BtAeA14C+wDACugb/ANuzfLcBfYJ+6vwCqAHCt5q+0KdX8Bey6vaX93Jcn\n    +Sx/12Sft5B8Xsr6BUpBe53169XDZQlovY8tAvx6x0YT1C3Ar+yzxmutsdiyuj26CtubU82ikpVr\n    aj1tZR5zNXItooFzNJnH/TEDOTqP6DinCqNJz9tjH1hjRq6JFYh78tprJLrSNeqLz/9SEM77l87R\n    G8ezV6dtBGzcS965pd8tE8RLbK/FIi3yzryw5ld0zWB49BpGAVPdtsaQ2aq2L5Azbr05tvrN2jnI\n    mBHAtJXlGwVXl0o3R+fcYvdiBq8Fcpf2eStAuMYO1nOOspjXspsseeq9WcF7A8HcNuJLX5ESsdHy\n    DHsBwd412dpu7cuB/WIJ7x1oy4VlJR/kAb9eHGrN/yE4j6W1fd/UfquNZ0va1e71KdDGOq+ltvX3\n    syWuG843LqcdPXaJWc+3NeUUlsYRkecs970WEH4wwOeaP1kLBG9ZI9iTteZjfzBAyxIbuLSvVBvY\n    YwOXgN57gMBrmMCyzwNuW+Sg7yEFDWwHAq9lAYtZQPBaAFjMAoJvCQAD7xsE3hsAFosCwd8KC1hs\n    DQi8CwD8nti/twJ/gTIA/N7BX2BfADgK/gLtAHAE/AUSYFsCef8YOF7/ra0G/gI+APyj0x7YTvq5\n    Bv4CcAHgrZi/e0g+W2143+sILt+q1i8A/DKypayAn8HfCPAr41hWA36XrLaOJq89pteSBL01RpQV\n    Vuqndu6WSYK6Nv69ZZ6XWqR2bQu7pjQf3U9kdWpLPdoaIMzSZ2tqA+prtKWEFzAPKudsu3ICey0Q\n    zGN4SUov4LfPu2uuK+zNq8WWAAV7JYpb7J7Ab+f4joi1gr6ltktB0y3YvszkLbF9W+cXPYco07cF\n    8F0C9m4B8m4FFH9LtgTYbe1jCTDcylqOSkBvCQZHQVQZ87nChIlIP29dJ5jbRoHMFgas1WdffI/b\n    TiK6dK572BogeK8FXEv98xmdyaiyz8leLCz2Sn1681oP/M7HsO7HUtBX72+xqC/9EIhLhvOKzyWi\n    NmUB2ta8bQnk+KK10m9vyXW9V53g0sIfsTe0lQMqWXSRkD4m6hOWlBzQbGBvjFagmNvMyxPVfYMH\n    BGuf9XNh3xpZ6NK+q9PXEjbw0rrAvdM/A8FbgcBRKWhpWwN3a9dSbAkIrPe1yEEDCbRdAgDr7VFJ\n    aQ0CbwUAA9uAwFsBwMD7AoFvBQAD7wcE3hIABpaDwN8kAPwd/C3bEvAX2AcAbgF+xVoA4Cj4Cwyg\n    bY3hWwOA/x0YTwPAUfBX9t1L9lmDvxHmL5Czf2vMX267J/NXg8uv1P/WrN8lcs+y/cnZJ7Y38LuE\n    7WvNN5p8ryUMBBhuTeAsBW9qSWp9Xmul4bayODCzzGqBtE5C1BJF+nq0yEfzMbEkRRlE5fEiCeA8\n    UC/PL3I+tfM4o6uuKt8CCLbOpQUIln4fZkkJ/7vZUt/Qu3ZLLFrL2Dq/e9fobbVokrflOV+2dSyl\n    yHxKc1oC/J4dfxmt7SvvRm+F/iJjAnGm79ag71aAb+3YJSDve5V/FmuVqATagd3ocfrYLQHhqFR0\n    ZPEVUAZS+Z0i4kv9MhLxhVx71gC+FRAcfe/YmxlcO7+1Vqux653TnlLRJatJIVvvTZHzq/nSN2wL\n    /C65Lmtq+/J5eGO2vgvYv4vY9yJaYsg6pyhIq+WYI7+XPb/XW4PBa1R9omV9lrKFWxb3SPsa0ItA\n    Gx3DPRT8WGSOUdbwUiB4DRuY+29lAwPl2sAWSCtAMLBOEnopExgYQN29mcAREBiIAcFbgsBrAWBg\n    AG6XAsC8PwoAAzkIvCUADMxB4FsCwMD7BYFvCQADMRD4WwOAgc1B4PcJAL9H8BfwAeD3Dv7+V7VF\n    GwC8FvwF4gBwC/j7CcDPgfYlAPj/G6x9VwKAI9LPUdlnIAYAf6E+/lpp44G/WzB/9dNEQNq1zN+I\n    5LO3T473ANanwj4L/N1K7jkK/FrH3hr4XQv6Sv8fA228+ZXasUVZXUuuUWT8tbY143cNoNY6l3ng\n    6c8jwuCM1RyOyXOVmCRL6gpHkr9yDqXruCcQ/Ih68lqfg6dk0MryjdRArtmS7+5D9rd37t8eK7Gk\n    MKFtqaqC7ntpUrQ27tbAb4SldAocbz2vlspU3wP0jQK+NeZx6zEt/dxTTWOJ1cDJqB0b+zkWfV9s\n    jq1zrfmiGjO4hd2kf2t1f1/e35qML7Xx2m0lD72WEVx796gtDvsW7KH4XtXR30v6Xmc14FdbiR3s\n    1Twu+VL9juddG+ucl/pSVtiJAL9LpJu/FOYWLwlUL0sTmWPJ778F2nrG13GpbRmT7sEKjjwnt2gX\n    XZRU6rt2DSK+CWiL40pAcOT8I0Cwtb0GBG8pC72EDVwCgQEbrGVAtyQJvWVdYH28AMH3YAJvVQ9Y\n    jP3UD+jDLOAlADAA/J8qKi81ABgALo3PMAGBtwaAgRwE3goAZnvP9YABGwS+NQAM3B8E3gMAFmsF\n    gr8ZAPi9gr/AHAC+NfArJgBfCfytPUhaGb9sAgC/J+bvJ9TB3xozOMr+BXwAuKXubw34FYtIP0fq\n    /v5DgdsRAHgp8xdIQOzezN814G+r5PMS1m9rnd8lwO9SmWcraOTEfymojCTdpZ8l8tSlcwDWJ5g/\n    Osd9q3LPUYsExqVk//OKwHpNfdoImBqViR5qgNXnu7RWsDXHSIJgTQJbM37XsJ1KSb5WIHgtI7h8\n    zr8PW6oCwW2i9q1IPccSwv5+yz/p+ube3NeCvtG68nsCvmuBXuv4rf3XHvLRrfV+Y9fCkvpcPpe1\n    oPAWgHCN9bsHGPxG/5aS/lsm40v7I3P32m1ZJzjSZy3pD3ybQHCrld6h1r4vRJmikfa9864YBffm\n    v5l9fan2WV5ZmFjd5Pr5RffX6vlGgevSeUQBXy++sfzY0fyttp//WruXLDSPfSoAYEvm3coUbpFZ\n    jsQ/cZnovrCvrayCN6d+FoPX/UFEFvpF7feA4FY28BoQeA0T2OvbmtveADAQB4FbAGDrGlkmIHAN\n    AAa+TRC4RQp6DQi8pA4w21Ic5zsIfH8p6D0BYGATEPh9AcDfwd+Y/RXLwN81oK/YXuDvn4xtUQD4\n    uJL1C9ye+RsBf1uAX8AHf7+gc+v9ipXA3xLwK/vvxfwVcNcDfoF28LdW6xfwQVoGf7814FeS5VuB\n    vtacuP9bAb4Pzue9AN+l/UVXzuvEwRKpSsu8hM6cbeQfxxYFIC3w5TQ7R81OjwXh0blH6hy2gsGl\n    NlsksN/gf1ceKvO2rm+0lrDu95asYH5G/haT2TU2T0sCem/Q12u/pj7uVguPTkafut8I2/fWoG+L\n    rPMtAV99bOS7FQVv31uN4AhAHAWRT42+uoX1G5Wb/pbAYOs3WfLBe7OCb8UIHs69LWEU9bslAEDs\n    t+5L15xfdLGOWO093gJsPaWWmi+1Ysw3areFcsYSQDfSphTjleIPaRcBjR+yY8rXtxXwjYC1flxR\n    j3HWWuT9oOU5FW2zbs45IKzvw5LavsC2gPCb+nsLMPjBadMCBpfiMWtfFAgusYFf1PEtbOASCPyI\n    furb2ueBwF+R6gPrfWJbMYEtEBjYDwgugcCtUtAtTOBb1AMG6iAwUAeCf0SPz4GxfnLOfUsgeCsQ\n    WKwV1xEQ+B4AMDAHgd8rC1hsDyD4nYPAywDgrcHfKPArdm/p53uCv4ANeJZWimwB/AK3BX+BOgD8\n    Cesln4H3Cf621v29J/NXt48yf1tYv96+Evi7RPLZC4gF/L0167cG/G4BCst4paR8KTj15mgl81tX\n    OC9JPJdAhNYamHszcltXzi81SdDWkr2RlfSnQD/cXiySZI3U1dJWC8JF4jmSCI4AwdH51dpEAFQL\n    CNYSx6XkpgcEJ8CvLkv4YNyfJecSPT+xWu3e2rzfu9UknVvZRnJMi+0p82y1XepjgHKyWkDfVqWJ\n    t8p+b87sl2pyyksAVm/8VhD3FGyn28uYa8DZ9wbsbmlrWcRHpET3EqZwC0O4RS56LRi8JxBcmvsX\n    rFtUtRcjODp/3X4vMNi7Ft+6ZHTru0Lt/PYCfYe/c+DXbt8V37tK8tMsT+19n2u+tHQubLU2Uf9/\n    quyXvr5U7kvtnUkrCHnPmSjDtw5C5z7YP/8I+DrYHn619Rm1xpYAzd7zNhKHRRdhtS7mscDppYuR\n    kt+7LRAcfe5vAQTfQhJa+qqBwHzsGiYwH783ACz2JwMoZQAYWF8PmO0j+hAIrPffqyYwEGMD/5ZA\n    YMDGef6M/m4AMHB/ELgFAAa2B4HfGwAMZCDw/QHgVvAXuC8A/B7BX8B+MGwF/ALr6v6+Z/AXiAHA\n    PxnbWmWf/zMINAPtALBX93cN+Bup+cvHMBB7C+bvv9CZ4yyRfPZYv9KPPm4P4JePr9X4bQF+S4n5\n    L4Xv5NIkgU7mRwGDVknJVlaZ1e5etXw5iI+wvvYMygfwpB5Q6+vYwkSO1ibWLOQIO1j3WZOdXgMG\n    676/ZPcxzoS29tfOqxTU1Wo76YBcL0IqJZwtMLiUZGuViOZjIonct+IzoXwd3oN5i31ak85iS0Bf\n    IJbgXaLWEH0uR8+3Kzwra/Oz9nuJ3hbg9z2CvhYoXZPOLPVXs1sCvBEfWbOtlDIitgQgbvWnNbA1\n    Ii+9tr5xtGZwKxhcWxRW8rU1Oe5ISYKSD7sFK5jbLwWDSwohtfP9FvwoUC6NwOdRMjnHJfLOwxi+\n    eWxfv31+Hh9nv5FyHOntfwucXxT4jcRzH2bPshjb1zL2/9bvLXpePH8rBliqbqLPR+xSmbe2BwzP\n    y1v6Vet85FnJi5RuaTzekkXEpXbe+UQXSVnPcI+lvAYMbgWCW6Whvec9UH7mW0BwS21gDwQGyn65\n    BAQvBYHXMoGfqH8NAgP71QQG6iDwlgAwAPx1HK8GAHObveSggW2YwLcAgIHtQWCxKObzXwD+dONn\n    ONs9QeBWABjYFgTeGwAGVoHA7QDwvcFf4LYA8HsCf/+BzgV19wSA14C/wPYA8Kfx33sDwBGJZqAd\n    AI6Avww8/NXZv0b22dsvfZXA372Zv6/o8BU2aHsv8Hct8Mt9e/O8BfC7hu3bChasAXxbmMBiXxsW\n    YJTmvoapu0UfNYsEoJHrtyTwryWlS/2/YQ4qHDFPBEfPMTL/iNSyPo8kwRpLYFv7LSudEyfBy2xn\n    O3EbmTMfb1kLK7g12a3lGh/cBEzbO1hLAniNRRlIkQU+EVsK+g7XJN73FsBvJLGqrUMXAkijwO8a\n    0BeIgbprJZ5L0s4XdJsmqO8B9m4B4t7LtgCPW0HhNQusLF/z5CTWIlLREenqiET0klILUXloff51\n    6eXY/fB82RZ1gkvtrPYtYPAr5gBi1EoAQWm8LWztIjBtpbm/oWuWiq75xyVs3/mc52Na35Ma8AvE\n    AFTvXEpzql0Lb84R+eaIL63Fqda8+PzFpx2N50utfzkP3VfNWuS5I+/NeypIrWUFL1UF8q5Fazme\n    lvY1lnDtWe4BumvK/USBYH1+rYxgGUfbUjYwkAOFum853xY2cE0u+qtqK9sF5CuBvWuYwF/VcU/o\n    m5nAwBwEXsoEBnLJ3xoQHJGCFvsrriEAGBju/z0BYOC3DwK3YD6/VxB4CQAsthUQ/I5B4PsAwEuB\n    X7FbAcDvSfr5PYC/wP3Zv5/o7xoAHAF//40O/w7cVw0At4C/v6ALyT639PsFncv6FXC4BAB74G6k\n    7i/v0/Ndwvz1wF+P9QvMQdtSvd8S8AtgBv5yH3nwbEt+6+D70ejH2q/tCw5Ncs9LgF9P7rnG9o2w\n    kSNgwRLQNwp2eG2jxy9l4NXsVjLPrdbC9tVWS/jqtsN1sM1KFNUYTaVksJeUa5Vatuc6t9ZEcFQ+\n    uhaYRefcmkAQiyYForWCrXGjwOnWTKRWVlWrRSUaW2yJWsHS2r7eMRFZ/agSg72vLvEYmZsGfpew\n    lLeq7VsCPl/GRUnR+vYtoO+SBPUaoHdvgHetWsfeTKalIHELMBwp5bBGrvg8jrEGDC75pRYgWM+9\n    xApeAwQjoH5S2v+sEpbvDQiO9m9ZS4mJPWyJnyzZI0Rmtdyvt4BuOGdrnuU518o9eH17/jZyDjW/\n    9CW4CC1SRqg2Z6l5u7bMQ+na19Q+gLJqBgJzbJVhLi0ci7KC7217y0O3KgbptjVFp5a2JXZw9Pnc\n    L/RFvXFeYg8FHxVlBdeA4A8O8NYCBO8JApeurZaEZhD4GXO2q8cE1vu8Nrq9BphbmcBL5KBlv5Un\n    EBB4q3rAYi0gsL7m9wCAASwCgf9ROWapFLTYFkBwKwAMvB8Q+L2zgMV+4yBwGwD8Hfy9j5XAX2Af\n    APizc757A8BR8BdYDwBHwV8gB4BbwV8gVvc32rcwhD86+yzwlttuVfNXA7RrmL81yecDsX7FntR+\n    y7Zm/QI+8/e9Ar86UcDtSgF3JBiPyohG6iC1MHwfAu1KYPDawDqSjC5Jly4bs25rAvRobV/LojWG\n    pd0FXTgQt/p8LgTZH1SQ/2C0iQTidiJrmaRlZP8S4Lo2Xx53SyAYQDH4j9YK9iTwLaslo9+rRdm+\n    lmTnnqCv1f+a+r6WwkKpNnxu3xbwGwV9rf6l3yjoq+e9BeArbV8WfL8AmO9OUYvWK761tdTVjZ3n\n    cn/6FFhgFVXbWCJZzP1Z538K+vulYHBrreCI+kbNj3r1mN8qn+XYiC9dUgrDs7US0a22pLTDe7HS\n    oqvSQrea77YknnlM+5jlwK+3j+9LzTdZ52S/95Xn1OJLS3NuBX31u30JyP5amJM3LzGOMaL+NNJ2\n    L1uzQMpemO1/rvnELZ4TJcAyovzUwvqNSksj+FyuPSujMei8nJF9blswgksgMGADwQK8WrHgi3Ec\n    P2v53aAFCI7KQWsQWO/fkwkMJABUniMWCNzKBP7V2f/BaReVed6jHrDV9y3rAP9IfXyutG0FgdcC\n    wMDvDwT+izHuLYDgNQAw8JsGgeMA8HsAf4H9AeC/OdvvBQD/Yxz3lgDwVuAvEAeAazV/gW0B4CXM\n    XwZ0ayYM0a3Zv9LGA38BrJJ+LtX9lbEt8PcZ5WTiGtlnDf5q5u8Wks8R4BdI4K+1fSu5572AX2lb\n    Y9WWJKgB+zulzQr8SwmEVkC1ZsJEWwL0LpEstY6/d0I7zSe3XMZwWR8R04FaLXG1NBFaS6pazCFr\n    jtb8+kqiYQ2TyUpee2YlDOY1tOur29fW0IqCwTXpSZbC479b7D0mpNcsMPkVXZgR7V+T2DNvqcyz\n    tI/UUY+Bv+3J6tI5RIDfpTLPW4C+3M47F+s6lZLruv/S/F4afNMx0MY7x9K5/hZMP/dbQeJL4xgR\n    QJjnEQFVgRgLtZT4ry3U4uOW7N8aCAaWlX3w5D294/nf1veaJbWC1zJx7y3xurUtefeX8/mIforZ\n    a338asSBdt8xH1nypS1KSfbvOM749UomROdck3nujHfX0v5oCQe9/4y46lTpHcG6nksVo2o+8Wxu\n    e1++NcqKZVsa31n9WAtuShZRS4rGotHFT0AC4paqT/XOebYCwS0AcY8e0VJAYh4buAYC8/m3gL2l\n    a8ZArwaBgRyQ3JMJzGOVWMCyH4hJQQMxJrC0iTB8lwDAwH4gMFBmArcCwEA7CLw3AAysB4FbsZ97\n    gsB/ccb8DgJvaw0gcAwA/r2Dv8B9AOAI+AvMHwJ7gL/AtuxfIAHAS8BfYDkAHKn5C8zBX2A/ADhS\n    97cV/LXaLgF/P9L+WzJ/X8d+3wP4K4F9C/hbSuafje/gPYHfGugrfZcSCDogrTHCIizfCDCsGcbR\n    FdhrgV6vn28h6W2xfZcE4y3AcEvdJo8dW6uLGAWDNZuiBiZGwNNo0t3bFwWCI9dwKyDYGzOacK6B\n    1kBKDnxU937p7zEqjb2FRQHfrdi9837b5OUjwK+eV6T2PFukJMAtgN8t2L41UFj7HrY1oO9WLN+X\n    yhzEWsFea/wWv3cvllSrtQC7a0FhoAwMtwLCa+SWrf1RBtgZvt9bCgTr+Vhz9aRft5CH9o5vkRP1\n    kvFLgfnSMVtIM1vXO+Lnbg0ILwXi9DlJnK7jNg9MFXvF9mxfbru2RE70PcqbV/TdpbQASizC9rW+\n    d63vLdoXeYpDS1SnIrYkBpy/d73/WJKf1Wt+90ued8BcBSO6YHgtO1jL/pd8mvYTS/yRBwQDIgcf\n    m3+LLHQJCPaVmObtBfwrKUa9jp81CMwArnddLPNAYDj9WUDwVkxgkYSOMIG/OP2WmMAlKWhpWwN4\n    fxn/jUhB/5W++1EA+Af0s7YRINgDgfcAgIEcBN4SAAb2AYGXkP/uVQ/4L4Ux9waB1wLAwLcDAm8G\n    AG8B/ALbgL/AvgDw3yr7bw0ALwV/I8d4tiX4C8QA4Aj4C2zH/l3K/BWLAsAC1kbA3wjz9wckkDcq\n    /VwDfyOyzzI/C/gFtmX+atbvMC8btPXA35K0s7f9TTGvLOCX58TWCv5arN9I0nop8AsAF2fBQ21F\n    uDW2bn8yjmmVL+M2cVCkzLLyrtVSNq9nJ+fvW5oOPq3rIIHyUsZvNCBvZQqXAnEJbKLSnLU5y1gX\n    dHimoLlFInoJEHxS+3WbJUBwpF2E6VTqJyYPbSebWRqxNRktiYKIpHTkGm2VkL43u3c4nzbAV8+9\n    dGxEwrn0bI/Np6vsrS9E4rH2An5rierSc7Qk8dzCXmqZr7SJAqtRwHdPkPdbSm5rawV3l4DDEZYw\n    9xeZ71ZgMPflnUstIV+ac5TJHK0R7J2DtFkDBHM/S2WfPUbbUmCEj90CDNaLtFrnsCUovFTZZy7l\n    bQO+5T666nvJrwUfqc/DskisBNSB77XALzCXS7Z/j/XzORf8ekSOujZPPVegvKjrjPsAvkuZvHzd\n    +bxKfuSW/vWMeOzX+iyIPAPt67AdQ9iLlazndk09Yk3d+hN6c64RRvBSIPi0QBZ6CRvYA4GB9rrA\n    uiaw9CH7dF3gLZnA1nwYBK7VAwbapaAB4E/OffoVCdj9BWWL1gMWJnALAAxgUxAYqAPBLTLQYgIC\n    3woABpaDwEvxn3uAwH+pjPcdBN7OgiCwDwBvBf4C75/9WwN/gfsAwNEfsrYlAPDW4C9QB4CPDdf0\n    E/29N/gLJAD4R7W9BQCOgL8M7EbbaGB3CfgLxGSfPyIFmhrojay89hi+EeYvMCwQeDL6a2H+rgV/\n    t5B8Xir3vAfw612n0nx428k5Rv8dWb0O1APxmqTyxRh/Sf1LzyKBtNVmS5ZTLGG8brzIGFHpL50s\n    aqtp589vCzBY7ruVwNYsoiXSXR+cYNyei3+Nzoq1UEoYlGxLIHh47tmWkhC+fF9LMtpLFKyt3637\n    885naaJZjt3K9PWMzikCikaez9zuodCmbLcFfiNAauvioAjbd2t55xrgW2vDFgF9a/WJrbYla01C\n    b/m7abHWpHSLHHOkny0B4RrYW6sd3CIXqfvwzyNWEkCPs7RO8BJp6GGWy5jNtfOxEuxRCenaNWqd\n    yxaAcOsc9HxKx3nx2FLz6vRGgd+S/33I7ucy5SHd517AL/f7wfwd+8CvN85bYX9LbV/+jrJfeTbe\n    idlaQF9rv64nHDGZw3Po+R73p6X5p/7s816mNtH226qNEfGJkTatzzVuX1qMFOk7Uj/YauM9s2Vc\n    r78S8Fp6Tn7A1Yxb1gDBJR/54ADPQFtt4Cgb+AcD9CuxgVvrAv80bue+vJrAtX2WaSaw/P08AsE1\n    EPhLYR+bZgJ/qLT5gL4KArfIQUfberLR0ZrA/K+2KAj8OTTTZJfCuS0BgIH3BQJfNnwPjFoNBAb2\n    BYJ/LyDwKgD4O/ib2z3kn6Pg6LcIAAuA+6mhr0/qWM9K4C//WzMNALdIP/9nUGIaKLN/RRK6xPyV\n    /aW6vx7AWwKAGfgVawGA1zJ/rfFK16tF8lm2RySfD07SoIX1241AM1uL3HML8PsI4Esj4zcCmg7S\n    XPY8rb6X1rLiq1YyncBfCviuWSVdk/i8lUVWstckGy1rSWDHLbZiPcq+Olf2c5sBwIklsFuA4Mi+\n    GjOodh3vCQR7Cc9XtNkaKWkei6WitwCDtd0LhNK2hO3rgY3WOUXYvC31fW1bD/xaieIW4LdW/mAp\n    8Nsi8cyLpyLfr6WS1GI1sLeV2VtLrHvXbSvbwr8uqWPvz6c9Gd7qT2vto4Bw6blfG4NVLW7BCq6B\n    op4vriWyrWfI3ozg2vm8BdpEzrF0LqX5bAkEL7W95KJ5MeGvRlxXPz6+OGiQYC3Hg7K/JEO8VDq5\n    NseWOKkG/JbmKu9jpfPwgN+IL00gW26toK9/viUr9SHPyLZ4MDovbV8r34V71uRuWdBUOn7JOenn\n    fn0O6+Sirecxb9PxXSk+WwoE78EIXiIL7cWCFht4L0noR2IZ6+0Wq/crMGMCyz6xkhw077e2PxX6\n    7R0mcIkFbLUBtgeBoyxgIMlBL5WCbgGA9d9se4DAnzGXkRZbCgAD24PASzGgP6PHfy4+i+V2TxD4\n    PQHAwH4g8GIAeEvwF1gPAP8ewd+/Avh7YNy9wd+lwK+YBQAzgPsp2M8n41jLauCv/rtkDAC3gL/R\n    mr9Ave4vA8BR2WdgG+nnv6h9DMbuxfwFEuCqt5eYvx7I67GBNesXmMuBeaxfaw4tcs+ADcRGE9pb\n    Sj1vDfyuk3e2rtNgViAfZYxB9bGFMUsqIgW6helg1uq7BNxF+rQsCg7LfFoS2NLeS+zU5qDHaQFR\n    gVgCu1Ue2rMaEHw2rl+0nnHpHD3rK3N9qPSl2b4tCek1QDDba+G4raXeb2Fvgedxy9y9Z67lU7as\n    hRcBOSN1hVuB3xbwu3YerWxfL9kcYVJZx2mrvXO1SjpH1DS88/CuV9Ru5TNbbMkCKfvctgOGW31p\n    DRCuyUSXxqnJXFp9nwPnthQMrklxev7oHkBwa53gmi9tLd0Qmd+3Cgb7zLp2eWc+ji0CrHLbVlbw\n    WuDXm2MtvrMAS34Xtfqvgbvedk/mealyxhF90dcuAVfz51fbIi3p03reWXNZywiuvefXFv3WrpFl\n    0Xiu1W9FLaICoa9RSUlifg/qi6Eiz/LeeV7L+EuBYKtvsaWM4CWy0K21gS0QGLCBYAsElj4i18GT\n    irZA4BcMTGC9b0smMM+Tj31GXwQC18hBeyCwtK3JQbfUAxYpaCAOAjPg3goAW5/FtgaBP6vj2NYA\n    wMC29YDX4ED3AIEjADDwvpnAW4LAwPZA8CIA+Dv4m9utwd+/jv9GwF9gXwB4LfgLbAMAfzKOs8wC\n    fy2wtxUAjtTnBXKgOAIAC6vXA4Br7F/Zvof0cwn8BdqZv9yHx/zlmr57MX+lf4/567F+Zd9WtX5r\n    AK+33UsmeKzfPYFfObd1yQsb9JVx5TvICxYidX7XgL215PSaOqBbWDTRXpMnWyNhyYxaoC3pbfWZ\n    X/Pl8+akUC2JWtsv43i1grcAguffW58RXAJ79wCCH2AnCUpz9satfT/WSFTW5Kj1OXnncWtrSTR7\n    ZvmIUhJWjxORIm6Z29bA71tlv2y/FfDbTc+73JaCvtax3EctQdvC8m0FXSMJeW/eLefZel22ttYE\n    dQSs9aymPhGZ05YM4aXM4JKfOjrnWAOD17KCedu3CATr8T12cIn9vEW9YG33BIYj7xalmCh+7nG2\n    b9Sn5OBqb7bVJT7Y9gJ+zw2+ShYCls67tM8Dfh+QYrtToK9avCzPlaWM2mTzRZhsUX9qxUVrSwSV\n    QOuYX77979gCYK35r7FInCTja/D1mRYttYLBtQW0Xhue3xeUreR3rH2nEZiNAsEt9YFbQGBgHpc9\n    Fub1Ah8E5mtosYFb6wJbgO2TAQLLdrG9mMAeEFxjAi8FgaXd1iAwgKaawAICLwGAvW01ABgYwNzP\n    wTl+VsexrQWAARsE3koGugUABvAdBG60rQFgYFsQuBkAfk/g757AL/C+wV/g/gDwFuAvMAeANYj7\n    qXL8p8Kx2jQAvBT8/Yn+jrJ/f0GHHxEDfsVqwLLez8Au1wOWQMpiCK8Ffy0gthaY7sH8ba33C8AE\n    f59UGx34/2hsa5V8Znbx2xRQ2gF5hPVbA37fjAR4KcleS+R/UO3ZOBmwpO6TtMjnNBiDvlat4Yu6\n    ltpaQd+WgLxVajo6lxqYZrUrBczt1yCWkBazVt0vYaEIyF9LdEeSFpEEQlQGq3ZNLFC9BQj27ndp\n    DmuBYKt/a/+HwnevpW5ha7vSMWuSzzrZcEY3Baq3tC2AXn0ebLU6e97YUbn+uC1jsJaA33Ph/cM7\n    t6UgNgO/lt+J+IsT9VWyvUHfJQzbVsA3cj3W1Ca+3ij+OsyULGJm+a5joz9t8b+1BHrJl0bOqcQO\n    XgIGl+brlXDYEgjm7R5jGHh/0tB6/JJMdOm9I1rzeOk87wEM2+yy5RYFflt8yhpfKosCa21r81wL\n    /Fqgr/2sigO/Yl8d/1Ri+9ZAYc8iqhWlNi8F31+7BpqtLNaqsBFdqBgFUmug9BZjaIvEWK2+s2V+\n    Vo1gXZu3BAbX/FJfif9K/geIAcHedfOAYH9hrz+XSJzM2wRsXssGroHALO0cBYFb5KCBAZQtSUED\n    2zGB+XjJKZRA4KVS0MA8rt+rHjDQVhNYt9uKCbwlC/izcyywDQAMzO/7resAA99B4KX2nkHgJgB4\n    a/AXWA4Afwd/42NvAQDvBf4C6wBgva8FAN4K/AXqALDsj9ZsBurg7w9Yz/y12tTAX6772wr+7sH8\n    Lck+e+CvV+8XGEBhC/x9hC/57IHPVuKB51QCf6PAr56nd+5nGmtP4PerIzEdYZ5ZtZZOSN9Fnp9O\n    wK9l+EZrRnlzf4AVFO7vI6Lz5LltEUifZsFN19QesIPJmvRaq1wkr7RfAgRzn3XZxbpsZe/Mr3RM\n    dA41ILi1RvCDs9+TAOS+WyQtrfNqmSdbS9L5zXyWLuur1ZbU7vUsX/wR6zfC9tXttN2jxi8Dvx7b\n    ZmvgF4Z/ArYHfveq6VuTdC7NV0zPu8YIbmEu3RPc3coOxrMiChQP1yDOmI2AwhGGsNdmrUx0RCI6\n    ygr2rs1eQLA1dgkIto4V66v+Yx0QXPKjUaavdx5bsAHv6UuTIkvbuN5C2lbgd4kv9ReuDudg+clo\n    SZfSe8Fa4Ncby/oOtZblaZ1DqwqJB1pHfKUFAtbmHDlfr9xNazzpvZdEY70tpZlL55mfY32RTW2O\n    a0FhXRuY91tg8HBM3l904Q3b81grtRSDrgGCe+f5vhYILslCPwTGaQGBAbhAcIkJXBr/lkzgEgj8\n    VOi3JAe9VgpajIFgZgHXAOBIG7GPIwP4h8Bv22ILbwECRwFgsc+Ftp8Lx24FAIvx/b+1DDTwvkHg\n    PQFgYDkI/J4BYCAEAnf9/92EjtbbEgD4O/jbNvZS2j8bA8B7MX/FfkbXxPrVx5ZMAOAtwV+gDADz\n    vigAXKv7CyQA2GP9AmUAuMT89fbXwN8XdC7ICyxj/r5Sn1Hm7xP8OsCy39rGx7Dk85PaJtYq+azB\n    3xrIu7TOrwf+RmsNa2NwsyYpqs+pFtjbK2lt0BeYJ8NrwbpnXj3GyHEMOG9ZN7jFlgC/rRapB6jn\n    UUpkpznZEs/RJHYtgf2CLpC8aJdjtFY7y/fTS0QsYdzWgOAa02cNEGwBodHrE51r6TyXyEOXjvVq\n    7bWCrlG57JJtJQnPi3la+7ee93sAvxGp5xbgV95tWqWU1wC/J+c4LwG8ROZ5L6ZvBJyWf2vAsTW3\n    SDvLorKlSyxa47hkLaBtqx3QbwYKe+30eci+pb40Ml8vsbqmVnDLHM83AIJ5fCl9EAFZI4zgyOK0\n    Fmlor32MnXw7UHiNrfHftfq7UT8amVfNB9b8U3Q+3ntbFPitgY1rZJ69cyiNr8u0rGf71v1OpDRB\n    dLGX9XuOqmUkvxz7vUUXiFm2pszP3iZzexqB0VZg16rp2zK2ZgXrfqznZBQIlmNqz1pv/xZAsCXZ\n    rG2pLLQHAreygTGLT8sg8BImsHfuHtD71el/CxD4q3PMEzG2SyAuUAaBf8XcSiBwTQZa7BfEpaAF\n    1K2BwF7d4LUgcCsADMTZwHvUAmYTEPieALDYLYHgbxUE3gMABm7KAn4/APDe4C9QB4C/ZfAXWMf+\n    3Rv8jQCknwr7lgLAezN/pf0WdX9ln2b/fjH63lr6WQDgLWSfgTrzV1jQX43+l8g+e/V+PfAXSPdO\n    s4GB+filWr8Ryee9WL9rgd+o9FZpPG5jMX2BBPxa8+rMILs9qG+tqeS3r/cTYV4tsSXAwCXbv/zl\n    gQPhGCvNT6iesr/LK7kjDCG79nNdnrIl+fqANraWtPFYs5E6Ud6+CFh6LuyTWmveWF+m72/5+xJN\n    TreAwUvkofWx+hl7jxpnW1lJUr9Wpz2amN2C7Vt7LtckKK39b9gf+M2f0T5Yuzfbt/YeVQN9o3M8\n    Vvbb16Vdsnktk3cLUHdPWwsYHybfFbkWZeDUa6f7L/nSxzHZvuRcvQVjW9UKrktZ+33tBQRz/7q2\n    MIz9tesQBSta5aHtq9Xu10vn+K0Y19XN5Upjx1oW9aPcdi3wK8d/MH/PnQme6nGj9XWXAr+WP5N3\n    4RZfCszzErXrU3sXsXylJcXcOk99TeYLMst9efNZA/R6Yx2n7WXbCgRuqU+fzF9gtIbNHDnWig+t\n    52ZNJjoKBltSzdy/nlekdA/gA8E1prBYiQ3sjaPBYQFpbyEJLedgAb4eEBwFgeX4Z+QyxZ7kc6sU\n    tMUEBoA/4oovsEFcoCwHHZGCZhOfEmUCtwDAYkuZwPcAgIEYCHwpnM/WktCtIPBW5UAZCP69gcBA\n    GxC8FwAMbAMCfzMA8Hfwt33stT/4W4K/QB0A/lTp+xYA8FLwF4gDwFHwFxhA2RLz1/vltko/A8DJ\n    kfddyvzV+2S7AKvPGF6WNHjryT57ydMS+GtJMgMJzNVS3K2sXw3+1mr9LmH9egDvGuBXera2e3UX\n    SxLPNXln65ro+UYYVa0ylO1B9VwK85Ys4DUJgHptyHhQbs0jEpDrur5ns007GMzfI79O8jIw+ETH\n    W+dc2yfXq5YErtWJ8va1MIJPleubEtH5/a3NPcLsiQDB3vm2AML5M71tnPdkJTn90rY1TJxIe9/a\n    gd9zwSfKvdtK6tmS6ee+SgygWhI44pv0MXzspXLtlrCTloC+rf7ziHUgbxnQXnf8FrZ2DmsA4ghj\n    uAYKrwGDvf2D+c/OqE/U5oGga4Bg69w8f9m6oMoDgvnYkjymb3G/tEepBa/NtwoIR/xb774zxhdd\n    3RL4zcvh9Nm+YZt1nA/+bgn81hYAa8Ch5Ie8fb66UDvoO792fdXf6+vnXQ9u8xL0k9b7QAsAW1P2\n    yNvG7VZMYD9Oi43fwvxtVaziNt4zYw0Y3AoEIxhTleK3o7Hoqw/6VpnvA7ZjA3sgsN53NbbdGgTW\n    8wO2YQJ71/8Kv4ZuixQ0EAOBo/WAowAwsB4EvhcADPz2QOAlADDwfkHg7wBwu1VA4PsDwLcAf4Ey\n    APytgb/AOgBYwN896/2yrQV/gRgAvEb+OQr+SpsW5q9YqfavAMPM/m2Rfbb2AzHp59eNwF85xtr3\n    gi6TfPbA362YvzXw900d2wL+MvArnyOsX3lZ7mbb1wO/emxtWwO/up+z6qeWRInW1Y0mrZfIPnPy\n    fal85dpV2955t9rTLPGSWwQgbrFIwiDCaiolYYf7E5c4Fqsxb0tJJm+eOvFgzU3mtwQILp1PKYFt\n    yQN6tc9qNYwjMpJbMIKtOfh1f/1rvWR+pWu0pS1lylrblySVt5CejDB+vbl6ihdrgF9rzuUFOu3J\n    YmteS0Bfb5/0VwN9t2L6RhlJS1m9UYBUt3sNjPMeAOBHx69u6U+5xrB3XMSXHqvvAHWljbmVweAW\n    pjIQB4KlzVIgWBv7ti0Ywfo4y59tAQRvuaDKOqbUNgJo39OPsm1V9mGp713rb2vAKmAn8vXY/D7Y\n    Cvy2sn35OOu65b+PZDWwNe+n/h7SUm6iZFvFo2csi0eP6EMAbzS2i4LS+fmtU5BaY2f4EsaRcaOl\n    FKJxaC2m0s/H+fe47AOtWNCK9RhUrj2vvXk+B4FgzQYWILcEAutrUasNHGUCMxhaAoLX1gTWY7HM\n    tBBVZIytmMDePESlpSbnXGMC16Sk9RxqctAttYCB9nrAYv9roO8/GH3KtjUAsNjnwr6f0OMfzr57\n    y0FvBQAD96sJDPhA8C0AYOC3BQLfBQB+b+Av4APA3yL4CywHgPdg/gLLpZ8/VfqNMn+BZQAwg79A\n    GwAcBX9LzN8fVDvABn+B9rq/wAAAl2SfPfAXKAd9JfCX969l/pZq/lrgrwXOivH2g9q+BPyNSj7r\n    uTyCA/U5C1lvEyZVhFmsTScoTrTdSxB8LXwnOKlusX1rCZRSzWFQf8C2gK+VRIgwfLn/rRPSW4DH\n    nukg11qlekEZjDgGWErctqVNbQV3lD3cAriejP5agWAed+m8ImxlbztLO1vta8nfGghcm3t0nOic\n    rDrFXvKyNu+W+UVtnhhq+81Gato9NB5fOmaJlPTcyufIvsgaz5N6BuLAr/iJqHyxHn9Pxu/y2r7r\n    AGkg90G1a1OWnxwsCvj6tYT9Nq87+s57mZzvo+NPa+cb9actDOEICBspE1HzS0vA4Eit4BIruV4j\n    uOwTaou5PD/uAdSRBVc6WV/3Wet9WisQXFoEVuujFSTy34PWv/9G/ZoN5vVN7fWYWyyyqqk2lVi/\n    3litAO8aVm1koa9np8q+8ywOThYBzCML41g1Z008ioY2fBaWcdxl+ZEX4xy2ti0ZwZGFSNp645na\n    KgkdAYRrzGBLVcIDP5eygmtAsBWz1ZQctpKFfqXPw7/+GHp7TRZaA76aCfyi+uC5cR9cI5htDRM4\n    CgLzMS1MYE8KehjzenMpaGb4loDea8Nz4YK+GQD+GXUWcAkABvYHgW/BAgbaQeCtZKDF3hsIfCsA\n    GIiDwHsCwMDuIPDvGwC+NfgLJAB4DfgLLPux3xr8/RmdC/B62/XxJauBv6XtwFz6GWiTf44CwB7z\n    1wN/+TPb1nV/TzuAvx7zl/f9K8j8tUBeb3sJ/NXb5Fiv3q8+RvfFAG0NmH3DHIRuYf1+xaEYyNZY\n    ZFoWzEtelIHfOehbm0M5CdDOmvKuT22+lulkf4usVs22TxLYtjZAvxAjlAMXr45vbm1yXbX91kr1\n    cn3h+mpsZO1l1suS20uB4DordzkQXLPI2KW+osnrreShuwLLd2+p563A4pqsIrez7F5MX+6rlEwU\n    /1Cbfyvwa9Xs3RL4jUoptwK/sTrwy5LrpYVHS1jH0s9awFdbCeSNJqZb/WGrn95D3QKY+wUe5zHY\n    x1aAcIs0c1QmeikYbB3/3oHg/MzijOCIn6zVEI7MX/dXs60A4ch4UdWPqLWyeS1bWvqgdA5R4Ddy\n    DrX4rSz33MZs3RL4LY29BfBb85e1c4yCvl6f8vuOlg+KtDm719K/Ji/ocES/Obi7JPa0nrl7AcT6\n    mVwfJzaPWk10bwGTfi5HWcEeGOzN9xnXYvkCL/5tBYI9NvAD7Fq8QA4IPpjx9Xw+S0FgIGcDCxCr\n    gWDdl8cEtkBgDxiu1QSuMYFbpaC9Y4a5tIPArVLQDPr+qrZtIQctQGkNBNYAMFAGgf/g9Ke3l4Dg\n    bw0EBupA8NYAMDCAwPcAgIE5CHxLABiIgcDfAWDDIgDwLcFfYA4A3wP8BQYAeC34C7T/2PcCfwEb\n    AC6Bv8D+zN/SdsAGf4HtAWCP/dsC/rZKP0dknz8A+OeOdX8t5q9uK9stANZj/npS0DXmr3x+Ur1p\n    8+r9yrgl8FcDv7r9D8Y2PT8xL9neIh/Kge8HY5u0bwF+lyYArIRGlOlbC1prwIUYs92HerV1q41d\n    ky/bop+aReshxZIVyZ4oGD8V2kcSl/MkdGfuiySwW8BgL/FSSkhbz0xPutIa15pXKVFcm0+rtSQs\n    ZPylstXWOLV5fUE9URiViN7qmkXPq1Ui0rIoUOyNu70sps/iTS3akq8l4Nd7ptee9a01fj1wtwQI\n    83l34yKZiLRyZD489pY1fbcAfVt9YcRf1fzNe2cFRwDXmsVq7sbGFHtfYPAy0FX3twUQXFvUVGNK\n    e/M9G8dHpaGh9pdko2VblOm2BAhuBWm98hNbjLkF0Au0+dKI/9bvTFsCv0Ddl9aAVz2Ox25eUuO3\n    BvyuBX3nYKx8V+LzaS03FC2DoP2p/Pajx/PYEcD3pcGf5moOcdWrFqs9d54q/quVoVuzF/r70QAt\n    rfFr7/7HyvPV8wVW32skor257gEEbyULrVm4NTbwViAwEGMDe3WBLcD3EX32/eLtFgj803j8V2oX\n    YQIvlYL+43hv/tvY1yIFDZTloJkFrLcBcyB4CQAMlEFga99SIPhWIPDnwvF7AcBAGQTeAwAGymD3\n    nvadBbx7LeDtAeD3yP4FcgD4XuAvUJdEjlrLj/0e4C+AxezfbwH8BZYDwD8YbYBlAHAr87cG/rYy\n    fwEbMGYA2AN/AZ8d3VLz15JlBsqSz3IsmwX+WrWE78H6XQr8CuvXSiCItLR11qmv8vheAsCW2hqs\n    tpI7snq+JQGtr/Gx0n4ru6DbLFhfs+I6GpiXjj8F51Bn4ggAUpaTLM3bA4ytmmO1BLYEYBYToCRD\n    vTcQrH8D/TRuXMqwlCDw6h6ulYa2xsqfR72ZNPdsDTMp0keLLZWsbAF8l8hBR46dX5PU55raf3pc\n    C/jl8boGf6+PtcYvAb8Rtu+58oxuqVdYSmJ7x3pM33sDvm3nXa8tHLE9SyLUr0fbMyJaq1dbCyAc\n    ZQdH2E16bGsOETB4CRBsjc1MO31NLDC4tAjs2OjLSu8V3r7euYZLgGDuT1sCC+JAsB631O+SY3Uf\n    S5i+Wy7K2tuX6uO+qPeXlnF4vIjyR60O7VKpZ5l3Hs8muzXwK/s8Bm60JELpvGv1eiP+9AVdFfjE\n    eGVr1gL41mwLZrA+79rzxlu8s4V5fWof2DfMIQII12IabwEQ4MdXNYnoWq1gUYvwYratgGBPmaIF\n    BNam58Kfpb3n+yxJ6D1B4BYmsAZ1NQAs23Vbvc8y73o8occzenxBuSbw2nrAH9DvAgB/HNsJmHsP\n    ELgEAAPrQWCrjy0BYCAOAu8FAP8XgD+9ExD498YC3goABkwQeFsAOAr+AveTf74n+PsPdJv8IIHY\n    j/2zca57A8AM3n4y2n9C3aIAcCv4+xP93QL+8r4W6WcgBx69OsBb1/61AGA+pkNngrFbMH95ewn8\n    ba35WwKEX7Ogdvj7kfqzQOEI+KuBZSvo1dui4K91Pmd0s+17AL/Sdh6U58BvtLbvWuC3Ju1cA3xL\n    yep8X/uzf2lSeq9V2kusJJu4ZH5eEnT5GMvAYA0Enwr9WYlkvkdeEHZLIJhB6zwJXp9n6TqWErel\n    uoetUttsEZZvbW7R89srIb2U3bvk2KWy0LXjLfuKQ5XB6vVZSkgPfedgZ+nZX/MLWwK/lgKFN24r\n    47eFvaT7rzF9tyqNUAJio2BvpKZwyzFR29pHrl0QNZxvLGEdOWZLULjEDi4pbWwFBB9RZie3vDvM\n    /bud/K+xgrcCgvV8uM2z49+But+qSUM/B9hv1riebbGoivvaExBe44OX9FXz3x47uDb/VpbqVsCv\n    HOstvBRfenb6uhXwKya+zFMM8kBqS253Kehb+p4Is7p1QZRmf0ZtiS9ea1szebc4xqsj3BqL1p47\n    fcAfaTCvVSLaAoKtBT8lIFjXBy7NQ48flYVeCgR7ktBe7V7epk2DwECqQ2vJQQuzNyoH7Z1nDQTm\n    WrjRmsBLQOA/4joBvB6QuxYABnIQ2AJ4NRAcrQXcAgJb+7eQhF4LAn8ObN8TBLZY4BYIvBcALH2/\n    BxD4PQLAwH4g8JYAMDADgbcDgFvAX+D3BwBvCf4C9R/7Z+c89wKALdD2U+WzZb8V8FczWy3wt6Xu\n    L7ez9gG+9PNH1WYJ+xfwAWAP/OV9UennFuYvt7dklQ/Gtmi9X73tiyHJXJJ8bmX9yjYOPkurxkvA\n    rzXGg9E3j562J+C3pfawB/yWkvvlILb8XazVX/SS/layQ/dZsxYw2rM95S+jzCFfdrg9Se4lYfX1\n    qLGVImAwj6e389y9vr7Crzd7SyCY52rdiwu6IlOoBuiW9kUZwaU+vdXz+tnTytTdgtm7ph7hGknJ\n    tcdsDfim/ur9RllKLcns1iTsmhq/ut+WOS2Zz17A7yl4TInpG2X4tiayW4BkbVvIRu9lUUbR0j4u\n    DW1lrLWS0YeZL7bHLgHQ3jGxebYtDCuByvo4fvbH6ka2L1KLgAxbLJqKLqqSc9iyVnBp3q19bDlu\n    1Lb0pUt8r/UOFK3vO5x/ec7R0g/WvpLySCuweCvgt2WuHN+Vyu1EfL83Z29+pTinZcHSGdvEk8Oc\n    trW1cWRLDBmNRfn5Xxt3Tf3gyMJjvQioRe3JA4J5XrpcgAcER5nJpXmd0LuAr1UbuCYJbc0jAgID\n    NhCs79XDCPRaQDTLO69hAlsgp4C6Xj3grQFgZgEDfk3ftfWAgVwOOgICt7KB7wUC78UC/lzoZ28A\n    GJiDwHsDwMB9QOB7soCjADCwDwi8NQAMZCDwNgDwtwL+AvcBgP8xjrknABxh/wL7AMAR8Nfbpq0G\n    ANcktLcEgDX4CyyTfa6Bv62sX2t/DfwtAb9Am/TzHsxfbw4R5q9m3GrWr2xvZf2KfalIMkdZv1at\n    X066S5+lBMJa4FeO08n0EvDbwva15sD7l4K+kYR1lO27pM5k7bio3aLuIdew8tv486oxUqIWabuE\n    0crnVkrOWmBwvgjCH8cDN9cCwQ/Uj3WtrFrNJZmyEhCsA3LrXGsr1qPS0BFAcs+ahUukqfPzjLOD\n    WqwdqN1uDondU1dYiCTSI4zgUrJ1KeN3sPkxnsT/nsDvGtlpT+JZs6VL92sp6NvqP5cweqOgwlo/\n    2upDo4lsf7ze/JstUlewNq+IkkaLT2c7BPysTmi3gMH3AoJ5/tJmj7lEGMHWNWWLAL2RMgvD/rbE\n    0NblElqB4bXMZCAutRyxSC3gJePX3oXOhedwCWS1gOE3tAO/lq/nd07Lf71Rv54tAX5rC84sRZ9z\n    0IdH/H7tnkeUNVrA3triNl+5wbcLul0kmefjLLc1ClElf3sK+GUeo3ydloPBZ8RBWJt921Oclc9J\n    t7fiPas8wRI2sPxtxeR6m4CtDAQvAYG98Sw5aL1dQGDevhQE9uaxlgm8lRw0M4EBG8xtrQd8aybw\n    z/S5RQ6aj/NA4D8U+quBwFsBwNzXLQBgIAeBvwPA21sLAAxsDwLvAQCL/c8tAOBW8Be4HQD8N2Pb\n    vQDgLcFfoAwAfy6c49YA8P/HARU/BbdpKwHA/0aX1f/12mj7SX2OAMB621IAuCb77AUZWwDAEdln\n    YLn0s7X91sxfIAdVfzS27c381bLTLZLPFvhbY/1aSXevf338V+f3Wqpr7J1/bXzZVwrAa0njaFL5\n    aGxvTTQvAybmpueyhYRljTlbmr8VvB+R1+ETKwXkJYCwZpF2pcTtE+rSlh4Y7NUZs4J2D0y1AvQS\n    OzcPxv1rwXOsJQqWgMCetciW6cSCBSpGgGJrvJJFkhiRYz2Tc/D6bgFbW8HhrSSiy32uY/0+IL2n\n    tIC/e7N+X8iH1RZEeWNGn/WyMKqU2PYA4aPRp5eo9r4PtXq+NaC21X8uvU7A/F3vStcgau+ZAcxm\n    PfufGvxjBBSuJbX3BoO9+cq+C8oLmbyFUhbraWsgmMFWa457yUJb11LPydqn28WA2D7UnzeHiLUw\n    dLcCheWZvkeZhiij1jumNg9P1vU9sH5LMd4D/PIopfigtMCMY8JzY3seN1+YZM/Ra892BNwciDW+\n    ZdFYrsZajtpr4Vzm23wWrWWtvrZUIz0KELf6QwTapxgq1ucWgPDZPMKPK8W8RUClxUHPuFYX8nrj\n    11SV9Lh7gsAtctBAvSawjOcxgXnODPi2AMByrAcC34sJDCQwd0sAWM+hBgIvBYDFLCB4awAYAC6F\n    /VsCwNLf3nWA2QQE3hMA5v5vDQL/xRjvViBwKwAMfFMg8LrU9BLw91b2t/VdfJN2S/D3nzdM1vz7\n    hmP9stFYP1T2f0G3YQXu3HSd4A+Ftkvr/vI2DlT2AH9rwK/F/F1a71c+64C5VO9XWL96Xt75dWPf\n    EdYvj8ftJJjujL71C/+wwjhv+RV2ktiaSynZr8dn0NcODP3ktCTUl0poRgGGM5Ylm1uO2bJ2YQt7\n    LRpMJwZdOq5U8zdPYuXg8dm435qNa/U5v15DP72ai04CXYx9Onn9SkARg9081zyB25ksJ6kxpoPu\n    btw+TzDn87HOMyXR54ss5HfOxz+MI3qSgx3mQHBpHrxPj5vmma6ZPKvenGuR7pUc738H9TPOS07w\n    XOT8IsfpY/Vn3c+D+ncrW1K/MDoPD5CMjMl+rQTsdqgzkfaWe+4UM6bVN2m7oENpcYbV3tv2APv8\n    j0D27lKuB9gG/EaknT3/qedo7YsCvtZ7XK1S6b3A3YhF5sbPeev+vAZ8sfXcPxJI6bHEj+bztpv6\n    1PvzfnLjuR8qvkvPd/6O0GV+lN8HbIB42B5RGZG56ASqngu3l375XVz70o7G8fyYfj+R99xj8Lqc\n    jWuZSwfP/ZG844uvB2pgsL0IS/fLZj3vlypjeH40alpK2Ru79j4VHeOsnv2RY0qWs1Tt/TL3D8Yi\n    vRbGb22fvJ9Z59cZPpP7ke0RH619V/rt5X63xnBmsxYrWXEl4L/Te/M/Io9F9e97Deir49HSe3ak\n    z5cV/pF993EWp2xjfE/mz8e5tYC63iJdL26MxL2e/+RYxQeDuf95v+ILztkRtu+0Y638+S/PfsnJ\n    MDj3FQecATzRG5b1TJS8Dy88+aLG1s8gziul+tZ91hf3z5LQb9Pzg8Hcbrpeum/tkz+M5/M49q7B\n    z4G4AdV3DgS/ocMTejwBExD8Ns5T5tyjxys6AmqHPRoIlvun5zEoGuYg8Ms47jNyMo68qwzbbSvt\n    k36t7RhnJ/YR8/q+W5h8Zzx55x8wZwIvtV/QVSWht7B/o6uCxCX7BB/w1fYzus0B4Pdg/wEbZN7b\n    /hvdDAT+G25fDzhqgotuBQT//9DtBQIvZwAvBX9vwf71wN971f+tyRYvMY8BfCvpZ8CXfwaW1f8F\n    bAYwg797M4A98HcJA7jE/tX1f9la6v4Cif17L+bvzxSU7cn8tUBasR8xB16Xyj631PstsX4tyWc+\n    Z8365ZdznaA/K1CXk0Tcxg7y5yuxa6vB9TaxUpBfq/lbSgBEg2y9r5a0aEs6b/Ocrq1EX2K12rqx\n    PniOfSgZZo3v1dvyJCO9/VZ/w9zyY2qrxjVAdHLmysfo2lIRVhEwT8iWJDNP6jpzwuy5MMfSeGx7\n    1wfWCQ09r1q/e7CCub8tJJ3X1iBsHTMyp9Z+S0oKug8L+LWkJG8N/CbQ2Wcv1eYl/b5M31tpk/um\n    EgDMAJZO7nus2ijzeI3Ec00G0hq3xvKNyDm3+JlIMr3V9iqZsFYW2rKISkc6L19WUrex5pwA4znA\n    vIQZfCj4Eu7bm5v3rLcS7DloNL8O3vuAvAvkpR3sa9nCsOqnd4I4K3graWjLj+pnc7xG8HA2Jduy\n    1m+07yWm450l47XW9uVjanMbxi/v9/qTd1RLLvpc8X/WfKOMWu4rIucM2IAUDD96VuNpoDjit4E5\n    89gD/HT/+rtwRDkWtd4FvP7ZamUSPBB2bUy6xF/VANglDGBtLTFkqd+W8ztWYideUJXOtX5dar7T\n    e7YeHR9WUpoSizKC0/enL/owOU58Kz9DP6g2Op/0HiShLTZwtCYwkLNFt2QCSzuP2fuV2u0pBf00\n    soDlebxECvrXwj7d5gN6Fwj+BfE6wB4DWIxB4D0YwP8stIswgIE5APy50PYeLOC9GcBil43PK2J/\n    cca8BQi8hAUsthUI/G4A4LWs370B4BLz9x4A8B7gL3B/AFjYv3sDwBrQ3RoAjoC/QOw+Rmr//n0E\n    F71fXQv4W6r7K58/wF9Z2lL3F7AB4J+VpPCzM95hJfir2zLzdquav7IyESiDoEslnxn4leDfApZ5\n    fEsWywqorfG+4jBb8Vw6v0iQrpPg5URxfMU3nH6OhX2XwvxKdmxoa5kHdN+ivm9NEvRgBNPReUXq\n    2AJ53amlCWxr/wn1sUtJ9lKgvScQrL/HPEdmHDKYLeO2SDduBQTD6ctKpJWOiciSyXXcS0rSqu0c\n    7WNrxm/UauNGEtYRMJH78xi/GvyNJKQjtXxLwO85+C6g516blwChWq79xfA3+jd7VH3ofq1jtgJ+\n    I6CvVdqg1X9a+/UcW/xnzReVzudbsyUJeAFVa8fWEtq6jdVntC5vLqFanjfbHkCwnqc1HwsYfjL8\n    qNd3SymFvnB8qzQ0z8eTwuY56X3WczouDd22wK8mR30va/XhkVqxtT5qVlps1bqIqlYvuHQeewC/\n    upfhmMHYP2gww5J69sbbGvjV+7iesd63heJTKR715hmxqHpLyZeU8jmHnZP2lj9aAw63gMK1EkD6\n    76jv9PYNNt+u51Fa/AS0A8G1+sDD1jnAqsfVYDEwzz9JGwH3rFiS2cC8TYPA2qwFvB+I3RwBgb2a\n    wAAySWgLXF5TE9iSPH7CXCL6x/F8tpaCln4sEJiBXA0Cl0Beb7+08UDgX+jfLUHgEgAM2CBwFAC2\n    2kYBYCAHfT8X2u1RCxjwQeBbAsB/Ro//3KHfmv2lcC33BoJ/oyBwGwD8Hfxts78C+PsNAeBbs3+B\n    GAD8qdpbMu7PAnNLAPAe4O+PaK/7CywDf4FtAGAGWz0AuIX9y8d74G+J+QvMwdgnY5sF/v4yjsEg\n    Ldsa5q+Wk66xYq16vxbIqQOxcxYg56xfMStBbwXL+ji/9m8ewNeAbWu7FaBbkmcXdX6l1dNbJK09\n    xpNlR7QF/kvrJXnJ7dYkuTd2a42k0txag/MT+qI82doEdmstYtlfq5Goz8HatxYIts/NlpLitudK\n    vxIcP9BFeTv7c1gKEFty8bKPpaFL589t6gnqfYDg6PH3An1L47cxh9sYmTXJz1JSuKWmrrTxn5Nt\n    6g+Zv6IGX88+QBuZp5+YLfsmL/HcUmuYn8PXBdfJm/8S0LfFf7b4sLUgb6l+41orJZTX+Nda39qs\n    RVrWXNb4UrZaMvtS2MfAwaXSj+UzW4Fgzz9EWbhWvz36zI/ivMxflhYyLQGCS750Xv4h339rMPie\n    QLA3/hpfvhXoy21K/VqxlqW8Acj98p+5SxdLWe+SXrwbWeDbOXHJ1x2B33ODT78E7psVc+zlT60y\n    NFHje75GvcIDgi0f3woatyx0EluiQhX145avWbqQyts3mL3ISgPB1j6gDgTLtmckBQwee17GIAdr\n    LSDY6t87httHFlRpEFi26TlafUg7zwdH6gJf1bYaCLwHExhIIDBvj4LAX2GzhqUPAXif0e8KAEu7\n    PxsFXrQM9Np6wIDPBF7LAv5noe23BAADNgh8SwAYeF8sYLE9QeA1ADDwbkHgOAD8nsHfWr3f3xr4\n    C8QB4D3AXyAOAH8K9ZZsKQBcA3894Nf6zMdEwF9gznDVAHBN9llsCQDsgb8HZ+4l8DfC/JXPkbq/\n    1hw8lq8F/mrgVgOw8/7n45WYv9KfB/5ysM5A8w+IsX51HSv52/oOWJJlVuD7UBjLq33pBeTST2ml\n    dT7HOZjtnTv3W6sJFUncX9CZbC6xliSxBVZYAV6t9m6SJ9zeosC1lwA+uu39BMWloW2E/VuTSIzs\n    qyUWvGCxNkfu9+MY4HgyXppJrwOm4bscn4eXCJDPZsLzVABjz+m4SGKbv7+epPK8nqIzdnC/mmq1\n    ndd3i0USvVskt1uT0S0JwEgCWqxTfsI6x4hEpVgJbOX9q4Hfkz+3t7MP8lp+p5Sg1c/ELjo/lP2V\n    rq0bLXcRuU56POs8a+ByRPWihbUUWVjlA463j8fWWMt7gT6uJVkfAXx1fzpJHwGDl8pcWvOThCiD\n    w1sAwd45R98nemMO0k6AMHPR0rk+P+86lRbCeUxp69rw3Hj/g9OmBQxuUeNolXTeCiSu+dI147TU\n    903Xod7G69sDfr19QB7PH+nel+Shp+NP+fZsXOPH80CHlRSfeHu0TnxeBzttk34tRY5fsxq/vpXm\n    0Zn+T55TXTUuuqix16hmRONMmXmsnR0T1YDraN9L7YLIc7N2Xv7i2drY2lgxwvNfLQt9pc0xEF/x\n    8X0hDvXA4RR3zgHXZ9XfyWEDCxCsfYl1ntYzVS800ufEzyxLEtoCgZlpXAOBo3LQGgRmIDLKBG4F\n    gTVwK2DtV9VOg8NbS0EDOQgsn2sy0EAbAFxjAevrXrKPY7tbgsBbAcBAAn4/F9rsCQADcxD41gDw\n    e2QBA99B4EaLAcDfMvgL3B4A3hv8BWIA8N7gL1AGgD8t6LsEAFvg77+d8T3wF4gBwC01f4EciLTY\n    vxEAWAO8H53tQB383Ur6WbN/X9DNkpvPTltgP+bvI+bgb4T5qyWfgXmgbAXaUfBX18+U/h7gg7He\n    2NZK4Y/O/L7iMNtekrN8Vp95TMtSPdA48FuqkaTHKgXRr0pm/GgcX7IWudRhvBwUL40TAX5bE96l\n    urpRs1a2c728yBwiMs88x1KyW8th6nrEeq763Llml3cOJaZLVDqa2VC8XQduxzHoTjUJ+R63AcEl\n    ZtAX2MZgsMsIPs+3d+hQkrpsrR1cGj96fIQVrOWpvSTwvRm+tXOIWvSZVar/Lrakxi/PAVhW59eV\n    aTYeqF6yukOX/T5KfuvF8C3e87m8YKkzttnnrPvX4Gu0FqE1j7X+sybV3LJoyToPq9TAq3FfWlg+\n    WyhmtFoL00kDGcAcBOXrkX9uA4RrEs3W/mPAl3L/kWR25BwsILrGxhquZx9OqlvXRvtoD3j9amwD\n    6n4UAPpz2/tGZPFbTRZaTPvRkn/rA/5Rj7WFTPR7sG3fB8rPoJYFVLXjdT9NC8NOFcYvbNAXyNXD\n    LCnlFuAXmU+S38SwWFe7+hfHl+bxgG9LF1FZsU9NXtp7ntf8aSTea5WIPsP2/Wtr8O4FBJfOQ+xx\n    XHQbeQ9pfV7pmE6PWbsWW/lOnndpQbIHBHt+0/KZz7hOoK8GZ5eCwLKd28gYH6jfB8wloZcwgWVb\n    CQSG6tOSg74a2x6MbT/Q92ELEPir0c4Ch6NMYKtP3if5gevsu1AHgSO1gKWdgL8lEPgD+hkr2LMS\n    CKwloD1J6DUg8BoZaLH/d2Hf3gAwMAeBz8ZYewHAwHcQeIltBQIDmwDBdQD4O/jbZrcAf4E5AHy6\n    EfgLxADg/0tjn1Y/Au7+sXBcC/MXsMHeLQHgH5z9fycQq8bsXSL9rMFfYHvpZ8389drKvgjQK22e\n    1GcGauUzsJ7521H/wDxx7kk+i1ngr8W6/Uh/R4Bf3Y+VQH90GL4WgF2T9ooAvxz0a0CixLwqSWZZ\n    Ml8eu8la0RwLnGO/WStZb10be4S2Z3w02Z7Xemw3DmDsBDHc/RbgalkJTK3VGHx0gmwxK9C3JLBr\n    df9aa/Z5czmq8+DxXkZwylrVO7SLJ7VrQPAZhaTuad6ex5p9V89lWWgUxvKkob3xo9LQmpkUTYS+\n    58R0q8xfjelbS/Zqewu0OVf8gCf9WLLJd53qx3nJ6pyh7s+ntR67p3jBSWjLR1qAfAmsLAG/LYum\n    Sn66FfT1mU/x2obc12vgHcI7z1K/97At5KH18/sxCPhG+q+BriUwuMZGLUk7l5hTEWWO9Juaz0XP\n    z0qqy2fLX3nnXDvfr852AYMtn2KC1OdhZiVrZZ6JlWpBTvM1jqstCvOtzY++Z78LDAuua+DvnJW+\n    TurZW2TlST1Lm6rcM01KfgclX+q9/D6gXkO3zd93ZvsXDHWCPV8l79Qtcs7eHEoLzaz+dCxRuh68\n    /7XiT2s+s8RKLvUxfx+wfeQlMAfP9gCBo2WGvMXD8UVZsXYvxrjL5J5t/1nznRyTRmPQmlw0YIOz\n    Z8zBvKsCvq0YuQUIFhBY++WoHLSuOazHroHAESbwC+ag755MYE8K2gKBt6gHLH1YIHCLHHSNCcz7\n    /+wsoJA6wLcEgIF1ctBWm1Y56M/OPu7nViDwrQFgYACBAdwUCK4BwMB3EDho+wLAvyfw96/jv7cA\n    f4EcAP4XOvx5/HtP4BfIwV9gDtx+Uv9GbC/wF1jG/uXjWur/LgF/gbLss94PzAHgj/CZwGxbSD9H\n    ZJ+9OXSBbZr5C+SA6yMGsFhv25L5a4G/j+NstemgkesuRsFfS3rrq2K9PmYM3DxZcaHzWQL8eivS\n    9bGdE/BbiZNS4vrF2ecFwLVaTpFaT7r/Y6VdArNzB/uE5VYL0ONSYTGzkhaPlT5bQee6pKTNzNHn\n    F101bl2XctDeJmlZYhEBIAlyP+DnRQ6enFetPjCbxZA2g/STyIHl36WSRGR2Hc66OzshsBQE9van\n    4RPL22ob+Y231Dvc2rZk+NZqCZbYvtZ8WsHfi+MjiydTS2R74y8Efq3tgJ2Y9SQny74rsYCshHLJ\n    X0WvQQuT2Bq39puILGp6RRcCXq8N/tObx/B3zQfddtFuRJJy+LvtWH1MJKld6y+itlHyX1EJ6Zqs\n    cm0+7At5TtK+VJeRFwNZJRlqdRy5zxKT6wzn/cVZUBVWH3EckAXOtkiQlnxtKxhs9eeeT8DuCQhH\n    aqragEv+TPdlX8vqGaU2JfWN2ZxP6R/vGahjvH76nnfmST7kXZvj1ur86mPYl8q7rjdnUW6pgaWt\n    i6XCpSXgvzsc0If9bHS+3hxqFl349IquGsMtsT1A4OFaxBWkrGNb5heJRXtn4VJJmeHJeUZ7cah+\n    jhzRwypJoGv1yraacsSp4ps53tTx6Gu2+KGHxwYGfFloDQLr87Cfo/3mctCync2Tgy4xgSMg8CP6\n    2SICiwUM2KxdXQ/Yq+/rAcGtUtBb1wOW/Z4UNDCAwAIE12wNAKyPW8oE9vZHQeDP6l+vjz0BYCCB\n    wH8H8JMaa28AGPgOAi+xdwIClwHg7+BvzP5Kf98aAP7XON4tAOB/GufG4O0n2v6p2tv8eLEI+Mvt\n    xGrgL5ADvr8U7lUUABZZ5/+lsP8LulDd3wj4CwwAsD5GPu8l/QwAPytQ0pN+jta/i9T9rTF/W8Ff\n    +dzC/K2Bv9KPPkcBcWPg7zzQHmR10md5mf9qgL8dulmQDvjMXi9g52QKA7+WvDS38Wo76WN0wtuS\n    O+a5tUp4wuj3FGgjn9O8cqsxs96z2fWXc3sqBMCW5cE5Wz9t8wLtcg3iLgvkS8leK6EeWY2dXxuf\n    7aOZ6tHahrpusGy3grgnXIsJeys4520swUUNTasxt817f/YTFWJ6Nbd3XfWco7Ysubx/QrqV4ZvO\n    J5ZUtsYqtdPJ5hqIzPMB5qCvOT/13aol34usX6pbLX5jTc1hW6bY7tdaQMW+NLWbn6/lm/ykfZyd\n    pM+rVNe3Ra0i0p83jxagt86em48dTXxvwQxeKr98UGy20rnlcy4ntmvJ6lJ935pZwGxLveDSoiqL\n    /Wsl0L1yCkD+XemVry8luz3Q1mMkl4BgTox/pe2TPzsVZKGL987YR886bSf0rs+X/Za1yENHlDhs\n    v7zMj94OEG73wefxHfNUaePVXuY22vS7kOXnLXUMoL2uLQ0ymZZ/lX71XGqLq15UrC9zsErLWDHf\n    2fBxFvv24vSJhuvglUso+Rn2+QzGeItw635Wv3dwHzHTZSx4e35t3r95ssmR9iW/GGHoipWe0eKb\n    tNIU9639Y03y2VvsJHYiIPiserCux1n1p6+D7r8fAV3tSzSg96YW9p4Mf1urDazrDvdGey1H/aAY\n    oiUQWPr6oBin+p5GmMAPI3jrSVG/Yi4FLf1o0+NLG4sJXGMBc1uxJVLQmvmrQeAtAGBu8+eCjPr/\n    Mf5bA4GX1gEWs47TQPBSFjAQA4E/O39bx98CBP77+DeDwLcAgIHfJwgMLAeCtwSAgcUgsA8Afwd/\n    Y3Zr5q/YfyGBvwDwf9t5vH865ycA7ie1/RPqVgJ/gTYA+CdjfwkA/qVyv46B+1lj/gKJ/bsEAC7V\n    /mUglMFfwA4iaoBZSfpZtmnp5yjz1xpff35F58o+A+letjJ/9Vit4C9LPsvLrJWM1zV/SzUZH5Az\n    fE9GHx+QEhXS5iu62Tg6gOZavZZJ0F2S/zpRb0Ae/HoAr1fbia2UtNaJAnv+/qpvq59Su9pKbwYq\n    W1dzlywmr2kFhKU+62PaAXlX7KvEWMrrKtVXcFuWavf48mgeOFpbHV6rK3gytokNq6I7+ns+h1Jw\n    nkDwudQcz0uDuzq4LDGC579fA8B1vrgeI9jbPlsV7jCFa6zgMz1Hvf5LzNYtk8rtNcXqv9uanCBb\n    tDbhVozfc8X/msnsyoOvJJnpvW+c0U3AL7fma6jr3cl2wPYpniy0dT9ku/ZpPIZlHrjsn+t8mySk\n    S7V9I/XmSwzb18L3rvQOWAN89TWrJbUtgPkwe761Hb+HRX2cN58aq1f7qXOgjWelhLZXh5j79Pxx\n    pN6hf55zn2UlwFuYywwE8zZLCUNf0yg4Xb7WeeL6bQEQ7DG1xEp+1Ou7RV1jKz+6ZS3hlnFrChlL\n    zIvJ3ox2bIlF27v7S6AvTn6pH7Giv/RPaHbNcpDXnq/lS2UcCyRmX6oBMw98ZYawpzplzc9afFUq\n    mdCyiCpSPiI9e8q+VPet7TXgK0vs4y0YuZZ89L1Nx2U+4A5zu9dnvV39+V1axFWajxxnsTr1+aa/\n    8+dmaYFyycfoY9NcEkjHvpPzSW+Gv+E5PI99REFgfT1FIlqej1InWIPAAEwgWD4zCLyUCaxB4JoU\n    NGAzgVvqAQMJ0GUAmLe3SEF7IDBLQesav14tYMCvB/xc+K1JPeASwNvCBL4U2gjwGwWAgRwE/kNl\n    /BII3AoA68/W8XuDwP9P+ltA4FsBwMB3ELjV3gEIbAPA38HfmN0L/AWA/xeN+Wfcnvkr9jM6E+z9\n    hLqtYf9K258K+z0AuAb+fkGHPwTG/zHQT4n9W6r9WwJ/WfI5Av4ukX7m7RHmr2zXQVML8xfATKbZ\n    knyW7Vsyf7mNmIC//ALcGcfrz17QruW0TrBrQEXA5Mt4vayV3FbyxJMde8YcQOXE/ssIOr9Ugu1a\n    oG3ZvF6hzd6yLMJQqo3PjOTy6uT9rQYMR0FojxXLZv0mo4lw7/pEWE0cPFnM71LN4kgAXgr+5fxO\n    ajv3IUB5LRFgsZMtQJivicek4uOZaatlIs+Y3zed2G4FgfU4ejzL3JXh5xwI1mzUWjL8AfEEcbSu\n    cNy8BEvLe128bQn8jTJ9rTmWmEpVGcoTqv2IlVi/3jPbAn612oRm3HO7aHmAoZ31zmH7y5JvqC1Y\n    shLNJYZSrWawNVYJ2C2xofU5WOfO/dcsmsTOx79fTd97m+dPo0l4S8niXNkv5gGeHkgcLcXQB1hQ\n    F2ObNVZp/jJ3y78+GuyTo9omx7YCwfwM0r70rSALra8hW01K2fKjPI4F8EYZwWL7MIPnVgO9rWtj\n    2/p8SsQvWse8Ieaf3Xcd5VBcuWek5p50sjt3w4/mcxuM+2WWoqX0MYxjL3DS2zwFDH36NcUnGMfk\n    l0/mmexaAJ0jZRq8eMKao1WjtxaPRn1eZPFTaRFrjfFsWQwo3deii4JL9Xllf20B89F9r7f2DZ8P\n    8GNRPQc9TikGPiOVF/qY+SsbCI7U5z0Zx/J4FnjcKx9iyTe/UR+yzVKBkvk80/lYC4x6OlZAYKsu\n    cOl8W5nAaXH5fIyfjW2aBQz4TGAtB22xgIGYFLS0YyuBwJ58tJaCFmN2cIkJ/GthH5sAwACqIPA1\n    8Iz5d6WfH9A3AcBAAoGjALDXtgYCfy5s847dux7w39W2/+uNn/P3AIGBOhD8HQQ2bVsAeE/wdzg5\n    324J/AL3kX0W+4xu+qHvLf3cIvtsffZMg79azjkCAB8q192q/1sDf39ErO7v3yrtRBraA4BL4K+1\n    vwT+1q6Ft4I2IvscrfsblX7W4K/F/AUSePtEn8WWgL9fDDlmj/n7OG1rA389yWcGfiWAtBIDmhks\n    x+qA9ozOvaeSVNe1n7Skl5XA5gBX9lnAr5X41sF3iUmk+9DjesfKPa8F2PUg3b52eyerr5Xx0zwY\n    /LPnuMVq7loftSR27XqVWMe1BHaNUeIF+lYwbLFvxV5hs6OHc/cloKzxvYTN2ThfT+IayFdmM3v7\n    GeX6xEuAYD6nlvvgJQTEGOwr1YfyWMNW2/l1irVrtS1ZR3yOkTEjyfqofLRbg/7kn2dp/KXALwCX\n    9cu/zSjwO+ybM3hhbGO/JAtVanUC+bk2X3SRwGSxayEhHWH06vF5X6v0szVmtK6hdwyfZ4uV6iHX\n    rHTctaGfQ2X/8kR4+3GRxVm1eVrty0DBHAg9ZP4lPk5+9nGm8COus/56ZxxL1nLYnteTtP2nJaXs\n    g9CWL50zHfPjPSDYuybStgkEpuNg+NEWIFja1XxQlBncWr6hZntIRYfq1sP3f1FG8FtlVaa1uDed\n    93q5Z+nHk1vO25T8fc665bnpOO0I+1XSih2B8sIooHN9iiXZzAs09Hl65x6NFUt1iX2Fo84FfGsl\n    hICYP7VYwS0+1ZKiXhI7RsoRrImfvTmV4iSgrjyQL8It7/fYuudK39Imok4lQLDu3zpW+xNh9Z6N\n    Nt4ce/QZGxiYM38toHge3yVA1qoT/FwBaHvV38O4lQHaj84YvG1tTeAaExiYA8F90NdrJrAnBS37\n    lkhBl+oHa8BVQFwPBNYgbwQE5lrA/K9lPwd9+6XSzmIC/4yy/Qt1ABgog8DRWsCALwd9SyYw1wIW\n    +zOAT99BYAC/DxB4NQD8Hfyt273B32HcBP4C+wDAGvzVoO0n9W+LcV//Nq5hDQD+yTmOjQHgLcHf\n    HwD8wWnLwK9YDQCOAMQf4IO/QFx6ma0EAMtxEfBX9tXYvx74C/jMX94m2y2gWQPAMrYcG5V9Fjlv\n    fW8fK+f2FQeXWayDbE4MyL9c11lLQicw9jALvnnldQ3k5W1H9VlLb1rJ/pYV1tqsubAcp3dcKdFt\n    XYfIsXqeV+SBvi3FFO+7ZR6R+bUdNwc4dZ+vs3sWYwCxPJrXviaJaZt/TAsYzPMrrcZ+QTcLoryE\n    7wF+bcFeXTedMPBXsfezvuQ89ffsK/g3nhIH3mp+LSsdBYJL8qKlfbxS22J1A5RUNSQva5KMrQni\n    paDwrUHforSjcy2Wsn1rEpQxhlR8gVn2rA/IPQPzhHUJ+LWlmOfbnrLPdqkAzVCSsSNS0wL86md1\n    SepZmx5f/n0LjM8gcav/vAb9tmfS/msBYn0wnselOb1X037vgvn90ecdBVK1RUsw1Ji41tgWGPyg\n    tpV8qTVXD9T22L/WnNif6fHngG9qZyXsrYVWR8XYgTOGbLOAptk7yml+va17wBZlyJZKJHh+dAt5\n    aOvYLZjBUVsCBkfBXu8479gv1u9bvTtZ7zs1xi9QjsndfVW5Z3teVsmfM4Zkt952AvCrEWMCZfUn\n    b/FuZ/jR4VrZ/serB1xTnroY20rWqpyR5tijvDDJWhhtz9u6JlY7S7XBisNKfXu2BAiOLpgqqVds\n    Mb8aQ7g0V2871wW2asxHgGDdvxcLXpAYwexz5uP4i351rFcqTaTrA1uliAT09eoASzxp+QYLCNZ+\n    8M3Y9hGJDRyRg2YQ2BpjCRP4QbWx5KAjft6SggZsOWjZvqUUtMW4FRBXagOXAGCxkhy0BolLctAy\n    n19Qtlo9YDFmA9faetdD2z/VZwaBWwBgsc/qX7a96wL/N/2tCYLfQeD9AWBgGQh8RxbwNgDw7wn8\n    BQYA+B6yz58LY24NAEfBX/131KQ/D8QtAcAi+xwFgKPgL1AGgLnWrwW4RsFfwK/7y/vY/jJu95jB\n    rdLPgF3395n+1kCRBQBHmb/S3xP9rcFfYBvmr2xvAX+lnwfk3wGuAczHc6Dv9f9BfZb+OWn6ATbQ\n    ytdPgN1nYwwr4XAa/2OmkhXQ6nv069i+UwFwS31CHQSXmUr+quuW2k7DPu7XNlmxDdirukuyYjXT\n    /V0qx/qJgPlKZf35LTAnr7YSm5ZW02P5NWhjEpdWwqQmFV1io1pzsZPK9py4jxNt08Crx6jSiWQr\n    KcD1lr7SNuu6a4CWV4ejMI4O9mGM4wHBp5OfjKmxgKwx81putukgMktMd5SYNjLKS8HgGqP4VoBv\n    K8tWzz0C1p5PXbWtd75LGb/A8Ix5drafAJyzL0Qd+JV9ujbhM+znpQZ++Vhe7JJLu+Z+yUpiiz0Z\n    2+Szx+jJF5/YSWlPzln3W5ON9kD5EiDMfVvnZvkWeYu4mvdA+utnUPCaOr7X2Xd5fQLDPrdl/VrH\n    vRn32jrGYjDr87P8mmUt9Xn1PC7Uh4zpyUZzO56fnKvHCI74UWtsZn4x81fPS+akgW9bKrofF1SV\n    k/taPUQn5IHcj1r+vcTKXsoIlmO9dlPi/hwHg4F4uQHv+OjcW20ut93uS73jzYVntPHc222/Fp5p\n    pfiotKipuhjsnPcTAX55zJI0tJhWevKYxXy8+P6zAfR2Klbzzt8DfTt0MwDYLjc0N8+3le6BnrM+\n    13lM1hfjUTGvjjCfk5yD9Rwvg99l3/XgPLvzvpaZpVKlgfjIsbU5yPXzWNjzRUB2v6X4197nM4+1\n    b67JRpfGksVST+jVecx9hO7/EdcZEMiAqX5+DuzRXK5Zs4NPyGvGanaw9PmlMCaP6wGn4ieY9csA\n    rAUC6/N6QB9mAmPm89I7iO7DYgJb9YAfjfeYSD1gYD0IbDGBn4x7Awzxt8Tg/230VQJ5SyxgoMwE\n    ZgC2BAJ/pHZREDgCAAuY+69Cm38WjgO2BYH3ZgPre6tJgt9B4O8gsLIcAH6P4O9wMrbdC/wF7sf8\n    BQYwUP/YtwSAW2SfP1V7s+1ndEUA1wOAueZvBACOgL/SFvABYAZ/v6DLPss2/bcH/gI+AOyBvwDw\n    WaXYSuCvbLcStBHmL1Bn/z4b7eSzrvFrMYoZeN2S+cvAL1CXffbA3wfM6/FqwNUCf4d6lnk7mRt/\n    ZvBXgqY8CO1gAaL5mHnwbQW5R6SA2pNgln+t4LlUN9ECecuB9ly+urZy20sk5+eQz2net0765f9G\n    ktUcxEWB6iXWysbiwHs4z/j4XjB+MX9rKdA9BvrK2cdtAXiJFWyxcj02j3VuVsJ2Lv0oQPc8kWwF\n    4lbdJgGDrYSwBmhBCS8599oq9FYgOLumFflCDwyuJXhLyeFS8hoYweBxh06ILpGIZjtnfmed9GQk\n    6dwteAZ4Es88ZrbvFEuKL02ce8nmrvI8ZvCXyx5EgV9OPPtyzbbPsxLKHujL52T5UW2vJjtqMI+N\n    c1HnwibvHR4byrLy98reJ+9DSwBarw0nzFqBXou9da+ahN68sGJuCejt3KTwYXrGo9pGTDzRQ6O/\n    LCk4eBLRF9gJ9JIEcykBfnCEu+f+2vZnMo4kXPl32Ku5aJ9nyUpbfnR+rF0f2PKjtXqTVk3HCCsu\n    4vfMNgoEtmpI8r5WBq30FS3TsNTycjbrVT3M94pxI4O+VtvSYqjSvhN687kdUgEpLKISWwr8WqUT\n    hu+lPU7H/t3xpXrhMWD7xi57352/f0fq1bMEs3eOSxZR1RY8S5xVWzB8qez3YlKrrW+sNrFM1WNN\n    OSEv1mipnyymSxN416/kc1JcX1785F0DKzY8Or7Li728cgf6GnF7T+qaxziNfVmxL/f7NMajwPwZ\n    nfz3nKmryynoRUMlINgCnj0gWIBb7p+ZwPIZKDOBpS/dP1BnAvM7lEhCPzht5FgLBI5IQQ/3pDcB\n    YL1vCylorgcs9onudw0ErgHA3E4Dv/z5F7XNA4FbAGAA+F9w3RUA5uOXAMDAfUDg/w60uQcIfGsA\n    GPBB4N8LAAyEQOB1APAtwN/hRGy7BwB8vMOYmvm7JwBcA3+BbQDg/71SncsCgKPMXyABuv9HtQpY\n    LhVtAcAa/PW28eca81esBAB/oP0e+/elcC1aa/9qhq5uH6n7643ZIdUStpi/cpwF/koLNo/5WwNs\n    ARv81eNp5m8r+KuB33n7eQDN9X6F9asDcE6ozxPWHZh9pJPOLwS+MtDrBWd8LUt1f3kOHjtKy4GV\n    AvOhzuI8SeyZBfhy3wm4jAfIOagaTwJHgvZa3as1yXB7lf26+kz2XP2gFrCTJyXAt5Rs10GWxVji\n    8Rgg5gUAJYlmi0mUL3SoB+K8EtwKqiXQl77Sc8G7nvM+hCWsA37rPngJ8en8TjCPE5Ng3kpu6hpR\n    /Bws1c6Kgsqnzk9Kv72V+xvGjr+nFWsZB/toTaBbY2ofJcze6LltAfyK74pIPlrbmfVrgb8e81bP\n    94T5uwQDvzpB7CcYbR92Mvxv6jf3o6UFSFoC2lJSeA2UZrDGqtUI9oBdbx6yvaSYUJKovE7jxfwT\n    M5EtH17qZ61EtWUtc7g690esb7gGPI5XTsCbp4zp1WC05s9AcUmeUrOYvLnpxL7Vx7yucJ19LO92\n    nlw0kJhYvM1jFosftfy8dYwFBOu+vHtU8qM2iFBSYFkGokaAYKudbHs7l9sAbX4tCvbW2kXHLAHC\n    mS91OnzDHPS1xi/V8QXSM/PN6Md7dyqBvxMYWgF/vTI4XArIK70jfVq+XN5v+Xgd1/GC5VK9+tLi\n    ZD69zvBXljqHBgDZL2lA2QOOawvYSsCuxVa2zAfdB/Ni0pJ5i5y3WDy1RKJ5yfivxv2rn2v+XNY+\n    NboIScbje1BafOUt9J2bvwi3dB4lP8HHy3auHRwtmZD6vWafxTh27Gf+bg7gaoDXA5o1G9haLKTr\n    Alty0Gw1QLnGBNb1gOXYF6NPDwSOlnzQ8sMM1jKo+9MI/gq4bIG6Hghcegf15KA9JrAHAOt9kTlY\n    gG8JBG4FgFukoGsg8D8rx/8PZ/FHzT47f3uA8hbADM1bAACAAElEQVQgsAUAa6zo1gAw8B0Ejtod\n    WMDfLgB8D/AXuD0AbMk+7wUA/9M5t1uzfwEfAG6RfeZ/I8cAMQC4BP7Ktqi0cwkA9pi/Yh4AXGMf\n    WQCwHPMM4F8G0CvteFtE+llAZY/5q4/RAPAS5i+wXPZZs371HLnG4oPar1m/Mgc9l4u6n3Isr6pm\n    tlWNhcXHvkxzswF0nYBnpjYnjUtsqUh9RJ6j7uMVZYnKSLK3xNyV+ZSCa534KM3JBiznyYKrWtWO\n    YH/1Verla+PVDawBzWX5yPJx3jlFV5PX6ilFJKLlHupgXbO+c5nS3hzrnB1vS0hKGysQ5/4OxrgD\n    YJzfjyeVULCSAi+YJwX4b5aTjrKBuRZhSRJazErYPtA+KxFbWyAgVpS07PJ+S6xgnchlNnGLLWFC\n    Ra3ENgJiLImaJPRSqefB2haTWb4hJa1z5usZfsKa52zJPXMCmq+Px8i1n82HbJsNZnfU99w/cv96\n    cZRWlBjG7GZzKfkrbTXg2bNjoJ+SrHNtvpbZIHT7MRFrScksHaM2zmHBMfnxZX9Zkov2wGDLPLDU\n    6gfwpae1j31QM0v78uf+o3NFNJuGx7WYZHIevXHdvEQ6by/5Ua3e4bFzpVZj7meTH+W5lwBq37aR\n    htZtI8zZbG4GMLy7X1xoWWz0EH9fAMqM33MgdqipNHjnFVqEZfhRMWvcE+bAr27LMZ32a/zuYQHJ\n    8t3oCj5N1/8d+qiravBxHnD7ZpQz0mCw7LPisCWgb2ne2rxF0fP9cXstvA/aC3+suDx+fHR+9uK1\n    vvi51gcvOGDznofyfC8t6oqWUKjtOxhxV7TGvWz32dH9bAyvvj2Ma6yZo+y7vDq/2uelcXpnrjnw\n    yixcXf6Hr4sGiz0QWNqy9HNNDnoNE9iqB2zJQVsg8Av1w31qKWjAB4E1ACzbPBC4JAXtgcBe/VsP\n    BC4BwHp/ZHwN+FrMYLZoHWAAE/i7BQhcA4C3YAHrv/cCgSMAMHAfEPhyhzHvCQAD7SDwHVjAywHg\n    W4G/w0nkdi/w9x/o8B83HM+r+bsHABwBf4H9a/+KaQB4Cfir/y4dF5F+BvLavx74C8Rq+9bYvzKW\n    BRyX5J9LALCu+8uJzmcMLxs1Vm+r9LMGfwFkzFtP9lna8fEa+JVjPOavfAZy8BdI95bBX64drPuy\n    wF+WxbLaeJLOcowGgy/oMvDWqsPEwKpma80luDozeeAlsD0JacBO4NfqI17UfH2QNbdrcA56/xVl\n    4FcztmpB4hWdW3/wotpFrZZ0WLKi26p7W5Ib845LzOvyHA5TINYV9+s5PTrbLfNr8c4T25IMiiYE\n    9AprvV0C4dJKbg6gmZUr7KYefZbEOSCXhOb+PKloMSuBbYGsFhDs1SiU9phqyNI2ZfNaiLnVZEbh\n    HN8iMy2A8PQ8NkDUGohsNdwjuf1mdKrnuwTwLc05yvg9GZ+9cSJyz2Jfz4mJqyUdPXll9m/an3jA\n    r8X4tRQqLNUJPW9Rm+D+jk6fOaPVlozmMWq1eC3g1/NdJUYvUJd3rgG6UaC0VptX+8RaPVzLLmiX\n    lV5qtdrC3jxytkxua2oNlwBfT3HCOt4CiX22c3sNYulP+0dPIro3z2Hulz7gOhtXfCJvZzZWWb6z\n    N/yk7UdnflGdE7c9UXvx36fTfGzLWuoDl9Q5rGNrbax2lml/7vnRhy2L/lpzdpxzTa6Z5/vmHFMa\n    wmbu1hmbS0o/5EoZPc7nuXqGWFTumduWgF/ZLv73bPq1XFWpR58tWj0a49V8s7SxAOoTfB/M82Dz\n    /awtw1+TedYx4qXif9kO6Kv+tjZeyS7omuKoJba0r0PBL7b0m4PXffF3J4uRLm5f5biwNje9kHd+\n    XnPf6S0gqgPENkuYfVTJF0qbH2hbPy5csvybqGDMVaaumS/nRcMA8Ep/PysFKlaHsiShtW+xmMAM\n    Eup3E68msPSl20fqAQO+FDS38ZjAXo3gFilo7sdjDFtmxd6WDLSYgMC/Iq8X3FoLmNtYNYB5W7Qe\n    cAQo/IHatIDASwFgYF0tYP33vQFg4PYg8D0A4OH85+N+B4Ani6xt+26/dfvngqDl04Jxfl6R1InI\n    Pi+1X4N9/wHJ4ZXA35pF6v6WrCb97Jlm/moAV4O/ifk7N33sE+b8oVcFzGrm71vlHDz2L1tngL9s\n    uvYjA9Bv6KYXzyj4q1m/QHqKfh3TqA/I5b/kXy3x3Km+9HgSlMsxv2ay0KnPy3ivzlOw203X/zh+\n    koBd10sUs5hQehW5tE4MW/ta8D3jwPlkbBO7Yg5aSpsB1NVBALIxrsaxnKA40jhXpIAnT7h6yXc+\n    7/wcWkzm8FhtKffHD0p1YkEnQd+ca8GWrzr2gQgrqcwr8i1W7ZuCFIRBxNfbStjyvg65ZOkBKfnK\n    Uq2ScLFqS/K5S6Cor+mJtl2JVSBjvMJLFkh/XSZt9jolaLqJMSSgxiu6EQge5vMVubTdM/rJH/D1\n    eRrnch6TIVyHWphJQ4CffqsSuGtGtGZlHs9D8pqZoGfMg74SCNzRGLrNRV3/PFnBz6A520izfC/j\n    NRDTydsHdZyX9GW20MY57OK4MkdPZtm6Lt65eu1K7fVioTNs1QIPnPYSpxr8jQK/sr2j3zlLVHLC\n    mkFXr0agpTohz4YOyT/JIo032i5jpr9SX+JDgfRsY3/I1tH8L0ab5H/nx/DdfIPFtsrlMqW9DvM6\n    sMxuN3vu8tP5qvZD7SuBw2/qOut+Lk6fFvBqXau97UrfBe/cbOC0m/31Nj7bvXHS32VAmNm/lpKJ\n    +BNbqWawnq5nn/WX/IDcAwZzevJpQO6D5ougPJCM372u47y6cc6pP/levSL5MPltyftC8m35Aq/X\n    idGfFl9Zfu6cfT/7yaef6VpY/ml4PuestFzFYD7G+Qw8n/J3Bwvs5fPRdqa5nNXYbMyK0sfK8a4f\n    NXyutm48/5ofxUM8yaV9c8RKfpT71PZlwXFRqWdrfy0esJiNHOOJsR/F9H31gV+LYWvHd77cs8SO\n    WuFLrscc6B0qess7b65Wlfd/HPeISQ7gNPbbIY8vtYJGl43rX2N+huuFR9aiJOn3Ffb7CceTF7Xd\n    KoXA451xmK7DvI67vWCLn8uRhcUX43Mtxmvxqy2AtHV+R/TmOwXf79z6WTv93eB4OI85j8VFsZ4M\n    d36+vXnO/P2W/IpmV2pQML0v9rN7Kdt5fkDym2e6frIQQu5tP8bE8v6aZMQPeKAFxB2G/JKMPzxn\n    rrP3b65NPiwOuU4+54IDumkxcZeVAjqhx+O47VcMea/nsX95rnUQMHb4zecLqvLPHTr8QKDvr+rz\n    2/i+KD5PH5/fi+H68PvlsC3/djET+E21l8+Sp+Fj5XnRQ9fxHcZ5mbWdz1Pyqpxv5b4GIk1vto/a\n    C7oJgLWA4K/G3L6iy2L+j7DZwJZ9ofEs+wOAf2/Qj7Zfxu/KjyiDwP927sU97Gd0Jgj8T3Sb1QOu\n    2Wd0NwWB/4EOf3on1/+7Tfb+AeC/re9iE3tP7N/vNjeL/bul/YH+XgP+Ru0r/DrCJYvW/WVbW/cX\n    8NnA/JJlmcf+tcBfq+4vbysxf39VfQ/bMO0/qys3sHfnfXF7YA7+8n4L+GXWLq/eFtBYxpL9L+gI\n    wBp60xLRR7pPwgDmxIIEU0/IV16nAGMeiFv3dEiYH7IETmll9BGYJfD5muntkojXksiSbmcZrasa\n    S47n4P8Aixkl1k2fSwluDvh53ChjSq/w1MC5ZxKQ5kCs/4y5UptaIkCsHxM56WrYYG9KrBym62BJ\n    Tc+ZemzD942T2/k97qFBHam9zODMBTqZmZ/R0GoIlDVzyrqWkpB+zBIK3QQEXzBP5iZ4RwLxa5ao\n    f6JgWRZkfKBvnrRLwbbUFGY2ZD+Bc5zUOKHLgkydwGYQmIFhff4M1J3RAeecwcSJ7VM2vnft0xgS\n    /Fv7juo+R8FgXiSVJ3Tm4/CzlK0kGb2XWTXoPRA9Cua2gL52Le4u+15oY38lZso9j9tezsO/z0gs\n    A0/umY/z5J7l3yfathT4FV/HC0kekUBPTi5LH2l7l10LgbJkQRH7Bfaj3rvOFdazfO5jZb8GB4By\n    vV/uw5KlTj6af0vzvo6qL7Y32P5+uK9Df5JMe3POrQO/m6UkKfuglhrea0x8BS/yknknqG/us/kc\n    +6kvkHfIr+/DzJ+mdvpZyQC/nYhPvjHfPpj4PUvmmxcPnlGSyxzKJTDYYb1zPZDPlX5OUw/99M6Q\n    rkwCmrusfTeyq/IkuvQp7wuPyGWgefHU8EybL4wS352ufz+9W/M2GfNZ+dGT48usMX45d3iaQOA+\n    86PSXt8Hy1ee6duX2ss+jNc+mQcGaz9aa6f38bfZKtfQ5EdHVu5S3+uBvRag7MnUttb39fqaTqnw\n    Pu9l17wxz+dhrBSr231r/7tE7vkZHKfmylBH5LVW+Rn0hSSbB//aZapBEn/yM12UOIb3/9y/Anlc\n    LwpOXTbf3NhHWupifE0O6HHAXInigm5kD87tivz5/4j8GZrO3/ej0z2dFoX32bF6PLkuwPCLL9f3\n    7My6pVb/a+rlWn3qxbXeb6O0uN+Oned+U8fm6b0rtZdYVMdzPI6e82H6t898Ki8M14thh23pWc+L\n    gl/V9yAtwh7sQala6IVKEmvyYmHQd1DAQAGgJU8ioDD7stP47cGUB0i/SYCltof4kgG/FxwUMzjN\n    Qf470vbh3IZFQpL/YjZw7p+6cbzruL1DLhfdTX3JtfsBmIHA2qQvZgI/Yh4VzkHg3N4wgK5PGIBE\n    Hs8ClZ+MMSzA94AuWzDwgs6s8yvqi08YQGSrnbSJmjdWydaAwNpawdy97d/oJkZvq3mgbck+IWf+\n    frfv9s4subnW+r/f7bdvJfnn34Np+ecoUzha/9ezv2Bw9K3M4Kj8lLwsPgXbiXkgspZ+tur+aitJ\n    P7eAv3Kcx/y1Vso/0HHC/NVgL3/+isP0MlsCfz+qz0P7eWJaEt+yOvMBzJoaAuAHJPlkDRhL0mEI\n    bA4quEkJBEtuixPpL1NA0U0vx5zY5gTAKxJbmuWi57V0DzPgV44pyYJ59aQsmUy9IvwRPntIs430\n    fg4O7SB/3t9BBUEl69FWZ1fsTN+hKNtYztVe6T1no1kBFYMEcj00s2m4X34Ce34NOcmc7u/B2A5o\n    0NxiBqZkyUm1BXJ5qjSXXApS7IAhMLQA58sY0KXV5QlM6ihRcMJhCsbFJBkt10CSYh9wxRP4t57Y\n    VLLCnYNsixE8HD/Mjeug8crzM1JAfxrbzeSRCSCWY62AsbTi2rOO5qVZIXoOFhB5nrXjfX5/g/Vm\n    srglgdxqXmK5JJvdyt6NHuMlnkvLPUuSiC+q1q61oEDA3xLwy/P3wd/c15UWDVnAL/uZL+MClyPy\n    JK6wf9JCjzmL64pcWeSqfA0zhN7QTUlJzXqRRVMaPNPgnhgnLXU/UH3wPu0Tj0bbq9GfPm/N4tX9\n    8XPbmo8lDeq1BYZkV6QW/RasYCvh/abusX1Pevf6H1W7ueXvUlqp44D8vb2UoO9mYzBQbPtSPfd5\n    Inz4zs5/9920MGmYf5ofJ86ZJX2d+u/HhVId+b8ciEjfu9xnXsiPil+UhPdh9GMXDAuq9OKmwXdL\n    wj73jRoIPo7J3pIf5QVVJ/TFZ2BeAsIB+Ix7zO2PzvdHK2dYbFIrzgHmvturi2tLHvezvtKs4pLT\n    0/FB4LelJMMb6u/HFphTa1/qs8YILl4DWLV207PBU8l4ALLvJ8eg3iIqzfqV7c/Q97LLfqvsn1Kc\n    OH/enaY+xK8egPE3COpLFh+LvY7qV/OyDoM90rGYtbHeY+sLrnTJGM4n6FzDAfNFyKV4VF8XuX6a\n    lSz/HtAHYtL0bqH3aTUR/l74Sh7ynOCFqO12hR0va7Pry/O8/fZe7C3HHbLjAF7MDedZyrEog768\n    UED7To775PqKJd8BcIyoF1gBwNexh0fkjOBuegfos0UU/I7APvI07nuaAddJIe0ygn5JJanD46gb\n    83U657T4SqSdh/ILwznJwoiHaeS0OGruFwfJZgEJhQ0MJN/Di4/YH5WYwEmpj5m6g3H+bu6DhhyI\n    5LQ8JvCr0b9u5zGDeb7zmsNzeXbN4LWAWQZ2BVyOArjy/tgH2g5jDe2FAfql4RitChYFiH+l7zED\n    +9r+gPpzSVi/2mos4J8A9/n4WzZPBvqW9h/YtkTBd9vEUg3gVgD4VjWALQbwPWoAH288psUAZvbv\n    ljWAW+v/fkK76b5aagDvVf9XjqnV//2CLgODPQawx9htqf37l/FzCfy1JKBr4K9V+1eDtrqtHuNg\n    jKGBXq4pLH9b0s+PdLwGf/V8LMncDl0G/rbU/NXSz3zt9HVk8Jf3JfnMYdtH9XnoW8v3zeWqP9De\n    X3Cga5/knnUNXSsxzqwR2Z7a5e2tOsBHDAlzNu5LX302Bpg9IFfaWf1bAXWtdhLPnZOc6Rr5JkH4\n    fB65MbtSJxP0sZgdO7cY8zd+DXS/R3d/N5P91Oet2bilc9EM7JZztBIDBzDAquc4T26U6hvmgb9f\n    x9CqQ6THlL5FbisHrHVyIPXDMsgCPGvWrjUO989sqFJ9YEl2zxMeSRaT+wHyRO0M2D3lfeTj+JKR\n    a+sDAzCTe/nUfMlwbc/BYHgra2UsRmv71gDfuIZPmcXEdlE+CvAX7/BN8EsK5H09mOPN2Uwl1u+J\n    fCKQktVJ1nG+iGkOdB5mY2hgGWo7kN4nNGuqdq072HLKFvAYqX2o5+Md783FswHk1XMsm31e8WPe\n    Q2Km5ZzXnq9Y6XlXA8YtwPBB+ZR8/Dnb91jwpfl2bx5zP8oJ7Ac1puXzGJxhH3cg5pRmO6c59tmx\n    Gug5G75R+2YeVx9/RKrZV/I/xxV+9Aj/XUSPF1mIdQaa/CgK7VsWfrUuEtvCSnGyt/jIsufZ78AD\n    8bsiQF1j/Ub8qJ7rAzyA3mb9MrDF+xickm0W8Kv708CX9s2snqHf4TlvJoxdHc9z/51xPvpctJKF\n    XrhVYsGW4lHdvrbNnlMyzV5dE5Ny2QCv/E9kTtL+QPFMi12d+1yaB89Fx2lLFlHM+06+ga9NDRCz\n    QWpbEcNamKX9aQ9rkbHvM3iMD4olzHPPF0Slv1OMNz9mqOPbz/xaT/7uRH3ousG6tu5R1QSW2sFi\n    z7iOuba85q+uCyz7S3V8eQH3oObk1wS2VClO9N4xB2hz0wDwA8Xqr7RNPueAcu/W/n0xxslB3nSM\n    VRPYqgWs22q7RS1ga39pfCDVAv7F+aztI/pqTV9gWS1gLd/+z0p7Zgy/9zrAXg1gb9/3OsD7W0sd\n    4D1qAAPFOsDvGwB+L+Av8NsFgEv1fxm0/UTbP6HdlgLAPwXb/4gE+EZkoH+kvy0AmMFf67M2L6Fm\n    Bagfnf1/oW3WcaXavy3Szz+PocnTuP9fAfAXmAPA1pia/cs1d/k4i/kre9lqzF9gXqsXmIO/SfaZ\n    geX5/OWcdM1fXbeR92vJZ1lJeaG+Hoxrx/WAAQ7oU2DLss95m3y+kviWAH34fMja5PcrP46NpaHF\n    rJqQl9k8c1aVJUHYApgO/aX7Xlp9HWEbXQrtWEZKyzUdMWfLzldm57KL9lzqdkAc+C1dv0uhTWK/\n    +8zdV+f8tJWCfpYDjVyTEiDArCMrmcztrHkcxmDXSyiLcQJbQF89rgDCkgTRgf8LcpD3PPV3nVZd\n    Q7Xh8XneGgj+apy3lfjmfucy0nbi45wazPrgsbw+IuwaHmfO8p0D1Nq8JHNJ0riln6jVAN8oIPzQ\n    0Ae3jQC/J9TncTWeWFayWmx6/jrAr3ec+E79zvBK7yLcXy4BnSe3WRpa167nBTtH1d/J6JuvQ550\n    nbN/ofpmUBiwgdoD9Fx8FhEfK1LEugZviQmrWUst5vktD3RO18lve6BnpNWuVAdY9xM5/5LVWEue\n    1LU3vgW6l+ZZYjzl18a2A2qAtL/YyZJ3BnL57VoyXO4jl3Aoj533zRLSDN7ytRqSnqnnc9YmJa95\n    XhYQLMfK5xe1X85F2lgAsgXKWgCs5XMmf33yWb95/cc5k/ap8rboKWd4Y7w5fXgWVcUo9bEFILyV\n    FHxEOcOrjRyp8SvtvHHdkgrn/HhrnLMThzFz3PNrw/l1WT8a+AXm/pL/TQurdJxqL366quPZuHzC\n    K/k6y3exn9SKHdqs57qlXjH3UdyHvX0+1tz3W+fpWX7fYj7tov72ywO09XVc+BstxWq86FS31WpG\n    cq08cJvnq0Fkba8oAe1l1nXpGnq+myWegdznWM97Kz7jeBCYs4SBPIaT+En+Ho7vs2P1WBxTPuE6\n    gYhH5TvPY9tnGrOf+dRr1hcDh6fRRzMQ64HAQJKL1nMcrmkCfR/GFgzUfqR74IHJD+Mx+j1zLgU9\n    HxsY3hv08RoU5pIUbBoY1gDwcP3mIPBPYzsBkH803gM8ELgsGz/fJ/f5Gf0MT2CQ9x4AMFAHc4EE\n    /EYB4D+gx7/ocwsADLSDwJ8Ln7cGgUsAsLf/9wACfysAMLAPCFwAgIdXyfcI/r4ne2/g763t08rj\n    GfwtAbl/jHS2gf1Y2f9DqJdkJfavNg/8/WBsYyuBvy2mwV/rZSJa91ebJ/0sIK5mAlttSnU6pJ2W\n    fbYCeAF/H8H1r/JV1WwaRLbAXzGReBbwlyWfB8ksDnly8FeS4F8pSM6DeqmlkmonSbvTeG110htI\n    kpUdUh3gDnNmsB4vl//jOWHqNwXs0mrYJlXdeD5ablO2lYDfV9i1rjjYP83GyvvXCV5mlXI7OT9e\n    Ua3HOlKbbvxXMzg76EBa7oNd91fPpWT5nGX1afn3p1c/6/74XB+mY+YLA4bamP2spxeVEkm1/3LT\n    wXkO+NiyYJJA5lXw/PsUQEaui1xfOymXpJTl+nUYvqsvyBPYGhQGJNmV+s8XWwggm997kYSWvofA\n    roPU9e2mdgfIr0bXUpK5Sp3DM9L3sEMu/3gCMiA41fPtsmuc5p4kLmVBiZaV5Nq9lrQmXx+WxWSr\n    1QeW/mo1cIdn2HxlN7eR74eeW2187ieaoG5JQkfaRuWdI/V8W+fCNedLx9RqAH/FHIAtsZ86zJeL\n    XUbQVbN+T0AG8gLIFjYBaQEVq2Jotq/0daWxc1nM/BgZTxYbCXir68qLP2Tpyfzp6KtGvKgaitos\n    GU69nU0nqvPEbClJnc8t1YLvlF+TfnNfmfcwmE60XUfpa26nn5tQ/Vs1NTkF1rLII2KyuKvkP3P/\n    6J1rWrin58zMMxkjAYNafYLNV+KYM3U1oJPsBM1W4oUMfuL9hcYSQDK1s+eWQN507vI7E/8itQlT\n    CYTrNM9uLJVwgLCE+HrJ966fwOEETOfXjesK87ODQeXEZkylH8SPDkzFdBX5e3mq+BzxcbrEApD7\n    bDnGkmmWhTmS0J4DCrmvt0w/m/VvJ6+ZqpPg0qZsJT8akZWu9V0zz+eU1ES0WlStBEVpFiWfHPGl\n    aQz+fuV9zKWibQUNr9YvA78Sf9pKUfn8GOjVJRFylYzh3684THE8S9SC2l6RnhFJ6jkvkSD+Wy/y\n    Po69cfmFI/z40iqNcIAPnFrSz/p6Ho2+YRxjSSXrmFSeidepf199iReQSUxqKSLNF87O49H83Nty\n    Sh5w+qb8Nr978P2S2GfIi1ixyny8kjoKx4yyUIE5wMlS2Z7LbF+yOQBrfV+GEZ6n/tLCCDnfBLgl\n    APQ6fk6+WH5nqS2/q56RSo48Tf5S6kX36DIfmeadv4mkvoDh/TPdg+RXj+Pi5COG58xxAm+7CRwe\n    zu8wsYFfRl/9NH6WmsKafMGS0XLPpW6wgMSWnHJe1mCQ/X0DZpLQ7INEHnoAm5NsdZkN3imp6bz+\n    L9cr1rWERdHAYgJDtZPvS00KOpFwhnytZgKX8raeZLTklz028Ae1j2sBR2WerXs4jJnXApbPJSlo\n    oC7pDCQ5aE8W2rKfgAkEZszBAoMFr1haO/gT3k8d4PcgBf1e7G+4HQj8jm1gAL9HAPhvzvZbM4D/\n    CuDvNxwzCv5uwQD+Z+W8fkZngr+f0GYCALeAvz+pzzUGsLBTW9m/QM4K1eAvM4A96WcAVfnnkuyz\n    OGc5hxb27ws6tzYvkDOALfBXA0vPiEk/W+zfXygA9Ji/Mj63kXYl2ec3I3HtMX+B4Z5KH/JS6Mk+\n    Sz+pbmPqV9rper8W+MuSz2Xm7vDv61hbkRPWEpzroJxBZJ3gltXZg5x2Dj5LgozbYvz8aiQC2HRt\n    JWYn6+SyxYzhe1Va3Y1Cu5xpY7ORSoyiqwpMH1QQns5tLsMVtegq7u3NWmGfgssS+0qDwtcx4eLJ\n    W3Pbt9nzwbtmvXtdbPZXNwNkuX8tPa0luNK9nct1eSwo2derFeIJIE6sIE7QpJXA11n/PXoKBudS\n    XcPnOUNYxnikf89qjsL2YFlpXhnO56aT0z3mklKaSTRJdJ3yY0Fj6e1L2cA8pmWtDKIam6FlTlsx\n    j4AYy7dW93Ap41c/Yz3wNwr8nofG0ztCDQDWyTFvO7OL2Edp2cpuAleGTxr4FflnK1nNCdxX8oey\n    /W1sw+8eAuyxr9Gg6xkH5XXnfupNHcc1AaWNNq4HbAG/rVKV3j5rO9dp0/O5Igfc5LnZUiYhwlhi\n    1uiWFlXZqKmS6P2JGeRd52SSXIXTh7ZT5Vp4pRVKShpWf5q1q+f/oPzzPOHXm4CEbOvHObHvviCx\n    gdjXDgnwnC2sJaZ75TN5UZf4xCfl49j3Apj5UYAB+vwqedt5n/z9hB445WAvaCx9nOfv5nKc83YR\n    RrCegzUO9xdpt8aWMIRLgG/N3jAHfy2L1iBeKvc8fR/Oqb1W97D8uF5wdaa2VukEraqhgV+J/yzG\n    bwLs0pP+mO2TGHbua4drfcjAO71ABmPv+f3pzJjTWzClY8g35Uu1Eoe3iAoYnmuWtHKJkYqAP43E\n    pMAAJlqlbbyY9Gr0zQs+72FRn2+/6/SGBHkyrjXv+eU3ulaleE/34alflFQ7OBZ9MMbMlTV685l9\n    Vs90LQ/9gXyi+MKUa+gp7r1OPoxVph5VbHpALk38OIG+Oav4BXlMeTL8Yj+e13DdEwgMJCaw7Csx\n    gVkuOvWbjOWgP6LPfM+r2laSldbxvRyf25wJnK5rfu00MziP+e1jZJslBa1loBnkfcGcCbxEChqY\n    A8AC8l4r+4EEApfKK0mbD0abD+hnLGBgDgJ/VMe2MIGvKD/7GMj9l7H/n4Fjt2IBl/pZwgKuMYC9\n    Nt9ZwPtZKwMY2J4FXJSA/t/C3MXBfk/gL3B/9q8H7K4FgGvgb+ncPzWMswX4Wzv+F3RmDWDPvNq/\n    FvP3CzoTAJV9YksBYGb+fkQ7Azha+1fq/gLpem8p/fym0qIMADMr+Mlp47GGxc6qfwv8BQBbCrob\n    x5uDv3I+FvibM3+7rE8Gf2VVNQO8EqxzYC6BOst1SWDOK5p1MpwDo9cxSJbAWJgCvCKbazLJMRKM\n    v1F7YJ5cPtL8xThJzYly7ici8wzYyVcrqS7bve+3JYvZUgvJa+sxoPi4lrp8b4j5j1ICK62a9Rld\n    ObDL2+1rllad5/eRpbC9a1WStyyBcN5182Q/Swnvi2rLf+vgnQFiLf2s7+fVGOcpq8+US1JyAC3b\n    RYrsiLxu8EEF5I9j0Gz1IUntYcTEAtdSmCwh9pGkyDy5SkveEsgTyJNE1ykP+r37e571o7/L5Zdg\n    K6FsJWGtpLlnLdJ259nn9ne+aNKYx1hSS7BsPvjrPUdDcs9qmySuT/Dnqf2YmCxUku1n5AuheBxO\n    WDPw+zL6QA38DuoguX9LHACtnpFAX/4sfyeWa/JNb6oNj3OlY4D0rD2r+fD+q+FjS9KT0k/UfwK+\n    X74E/LXnBzWjSdqWZS/9sRjQ0985r33k912S6VzyrtCyyMu6RpG+PF+as6tK4JkNBJfrT+Zt+V/L\n    HwLAaWIED/aAXApRs6y4HMQVyadJglwfk4DmfD75Qqh0ndgX87mcadFTnhi15psS50npYmhry0v7\n    38F0LPB0stuVfKlXp7cMBLcnm2qAcAtIuwQYPpnvInGrAb+nQtsIQ1jbGVr1Yr5QpuZLp8XE5xRP\n    cmkh61irBI/Mhf0okJjtYhIjPk6/v27ymQyisqKGXjAFJDBY/Kiw5x8rfcjRgDAMD6Y/lLlJO/5X\n    +tEx0BFDHO6xcevPbJ95almJHayPlxjGk8IG7IW1+nfN8v8nFZ+9Gf3kx267iLJkkbIWPKc3x0d6\n    12oYI25e/Nijd0F1ey7+/Kw4lP0S14+1zlX8CIO0OnZ9oPiT40I5lyP5t2H/NVvUdCZwkhdQWYuZ\n    Ehe/z0Bkq2ZwYgmnY8t1gVk5IwG3ui6wBwKnvNwc9K19Hv6+qn5zs+oBi8n17Ol+WoDyD2qMFilo\n    3v4THfNP6sNqa5m+hh4ALCbA6bNqZ9UDjgDAQBkE1vtKIHALAPwzUGQCaybvEhB4LQAs22r9tILA\n    EQDYa3dLEPjP6PGfNxtNroN9fu8RBL6hDPT7A4C/g7/JSqDuGgA4Av7+CTlAyPYpOM5W4G+pDwF8\n    WwHgCPj7BwD/XUjJlQDgr4V9sv8DEvBrHcdmgdAWW5f3iQn4+6T2aQA4Av4CeTL5Fd1M2lmDv9IO\n    4+cS81e2cV8l5q98BuZSzQ+YA3BR5i/X/OX6vhHwV7OGX8YEN8DgrDCApJ9uulfSVrZJoC7Jc2ZG\n    sXT0qxr3lQJjDsx1DUNPChiYJ1HnspLzYNsLeOfBsx8w1uo8cVCs5fUOxnFW0pgZViJjxfYAm0GT\n    91k2K2DNmaYpsWFZDRDQ19j6bCUnrJXlSUKqzPC1rpN1vv798M1avWq118E2318v4S3BtDcynw8H\n    ysxiYsCYk8AWGMxgMa/gtoDgPGCfJ/9l1fdZtRF2E/cFYAYmi51VO7aTCv4eTvl91P3C6NezGstp\n    2FfvqwUErh2fru8+73lLGEbR5LdOGJdqBy6Ve+bt/G5wPi8Bf3M1DNn+qwJ/dW1BXswkIG/ONJ0v\n    hJLtp8nHpmskJSQYgOUEdj/2c4FIseZ1eNl/vql+7eRweZu1cCfO7PW/tx6j2AKkLUaSxepls+q7\n    a0lnj0FzVoB1aQHOLcxiZut5e7WQLRnr0nXjdm9GnwfHl55wLTJ2bZszWko1llm2lH3cJdC3HHMx\n    /CjP8+qcS0eJZ/GxDC6/Yu5HNRD8gOuUwOV3AelXFpDoJLdeFGaBwMwqljbDOP43VpK0J/KjNTYw\n    74sygq1+ooxgPaY3nmVb1PgtnQPbEh8dkV6WdpGSEVafch1afOkEZp7r4K+1iIqf+5r5+4RcKlpK\n    JchxvAAlLabieXZGzHfI4jeOdfnYfBGySJinxcdWPfsOHUoqT2JvOJg+rTPeBaRvwHue29YVn9nS\n    3/w+8niaNWyVIkrX0Zd8tsBj/Zzi/qWtluBn47k/FH67NUD2zThvtjxGmp83z0/6kvkM4F7n+LrO\n    eOfI93vPj4P53l9Wr7L6mC+Gtu+JJ+t9UcexMkbeZ698ce53BOiVbcPC3uSPeiQmr/aV7D/l+Cfk\n    qlRc855BZl4MdZ6OvYZAYPlcYgKDxhR7gzB4B2MAGCiDvlaN4A/wgWANAst4zAQG7PrA0heDwJY0\n    dAQEFhawbON+rNrB2jzJa48hK6AuA7xfYAPA+hhv/wdnrA/o8RE9/m3ss4DgVgCYP2uzpJw1CLw1\n    C/izsz3ChG0BgaMAsNf2liDwe2EBA78PEHgTAPhe4C9wewD4PYO/w/VAU3uxKPgLrAOAl9T9/anQ\n    n9UHg70tALC+tx74+ys6U/ZZbA0AzHVgawCwx0D2ApYa+CsvDQy8agDYq/urwV8gr+0rL/Qss63Z\n    v6WAzwKSNWgL2Exf/Vkn2DRwfKEwyZJ9BqTeoS37PNQX1OKPNvgrwbiAyrzCmpm7wHz19XCsZgWn\n    RK6wniRBrmWoMWufAOhh35yNpmsQDgzmg5uk5nFL1qGrJEfnNq/T6NdC1CwizYBlieS035pPSoAf\n    1DY9nszJmvfBfRGP+RePScT3wVtNz9dA37dSosA6zjsnfX1L+8QSaDWYlYxglmvJeqQESH4N9H3R\n    CWFk+zmJzH2w9HMuSZa2JfnKHIBmoFYD1MxASoF+LsmF7Nh0HvK3BOycCNCJAe4jXf80F319JXE8\n    ySUqEDgqM+ndNy8x3VK/l20tILyX1er5Wufd0ndN+QMos34jjF9dC5ovsD3v3I9x4vmktp8xr9mb\n    5pz64QS3lYTuUAd+RdWC/R4npOc+KV8YlSeqmX2T+0g+lucoz2h5Br6qpyo/m1uT03KMx7Lh62BL\n    UMPYN9+W7lNqU0oyl3xQ/tkGkVvYxVHT/XjgbUtdxMh1sBRKSsocef1cq885OM9+rsQG8wDjK3Iw\n    QYwXCjFzl997tFqHlVgXv6olnDVTmEFkXnCV5pe3HY7WUpfXLNEtbV+Rkqjso86jn+dzEqD5pHwx\n    1xDWflRf28wfKT9qgY6tQHC5ruGwfylIa/lSCwjeAwTm69EC/JbYvtHj7HeIMuuTj/fmzH5MgN8B\n    jCizfuf9z8eVhb6n2XG8sCe9c0sfuiwRK27IFlHDmMejuR8d/pZ8wPAE03FlvngqPfW0XxZjWeYr\n    zVOPq018esmsRc9s4tv19/s4ApQyjpi+h7W4itvp57nlU/Qz1gKkAT8ekj7yaxBbqJSrKuhz8dnN\n    80XNncGynS82lvPncd+c68vxvBcD8nuLH4/71hd8ajrn4fnvgfMnXGeLei31Kb2N2b9Dn/niJRmb\n    fdsBVxyR+8W0cLifxaPs09m/iUIVx6oCTmsQmBdDP42grwDIGui15KB5HrKdZaSHZ2W+uEz2SfvI\n    ZxmHcw4RKWgAIRBYPmuWtrYWKWjZzuPXQODSu4EFAmup52f13eB93nF6/4fCHP6CqwkAA3MQOAIW\n    agCYt7GVavkyEBwBgYEYEPzZ2f4TevyjenQcBG4BgL3230HgfeydSkHHAeDv4O9+1gr+AssA4Bbw\n    F1gOAG8N/lr9aKB3CQD8Q6HNS4B79wWdy+5l0wDvB8RqAwPLav9qMLdTbfV9teSfLQC4Bv7yZ4v5\n    K/vFSuzfNcxfma03d/nMzF/ph5m/w/04TPeJmcDD6ukDzScHf7lOEoO/z+AgPZeE1mwp7uc0G6dT\n    9ZdSe28l9pylNJfT0lLeOsE8Z4fm9Qy1BDH3PZcWngf9HrALDN/Po7G9Zlai9wor2dzNkqzDPH22\n    kzWPrWsXejULrRq/zFbie6WTFkOb3tg2N6vGUck8EKKUfNbtS9dSgkZLTksH4HKNdP1FGZcDbklO\n    SHDOCWFJYLNE5mXWR59JV3LC/Yy8LjDoGAaCL+imM06Mp/wK8HnKsSlYx7THApKHuaRt/O/c+hnS\n    xwlOK7iGM4a3/znwYhwBdmuM5C1r+kZtK9BX1/irta0xfq056KTyWW3njf785wugNCjMNeSBnC08\n    HDcHf1mSOe2blyHoRhUMOS6Xh8yfiUc1D/aF4gd5sZSWldSgqy67cKDzOmT9dmYSVQOc81YWKziN\n    5dlcrt9PMnvHarA4nxUnurrZdkte+Dr6Weu5EZnXluYDuNY7w9znW+fcG/fKYjzXZJlztpy9cMk6\n    To/H4/L94Dp+3K+1iIvZw3LvrP54wRQzisWE/StjcIJbWL75NcoTkZfRx7I/iyyo4j6BeXKT6zE+\n    0pz0MUf1+Zz14/u608lm/TIQHCmvoK3kg/VYpTl6toQZvJdF5KJbJKFL9nXmx+wxrP0cT+oFp0Bi\n    /taA5YvyZbxPx5gW+Cv2qvyLlFzQsaIum8DA72XaowHYtFiKS/YcoAHffCGyjAQaXy9qTWUUcr+a\n    3ulzn6zvvQDQ9ruf5U/9mE5MqzdJDNDqs7yYVI/DwObD9MztTFCSlTX0QqI9lTXkXUj7+rTYIL9n\n    tXISvMj44LSLXHM9Hw80LzF02XxWZfKb1rVOcaDMwV4cpcsScT9nAi2ZIWyBt7woOflFXsA7B3Rl\n    6xMBk0eKQ79izgaW/ZYPlHYpzrtWQWDtyzQTuJ9dtzkTOMoCPmEuzy32aGz3QOCfYbOANQis6wF7\n    LGC9jaWgZZ9ch5Ic9FfqU9sT+qZav72xzzpOtykBwLLfYyQzCLwUAObtYn+o9CUg8D9RthYQ+LOz\n    ne9tDQiOgMCtALB3zG9ZDvovhXP7HYLAMQD49wL+/hXA378B8BdoB4BbwV9gGQD8szomAgC3MH89\n    4Nfbr+0LOvwBZfD37zgU94t5q0c9AFjae+xgC/wF2mv/8j4Bgz0A2JN+LgHArypwE9PgL7etST9b\n    zF+rzm/0M49VYv7yeXCwWGP+CktX2EwstSXbhf37MvWTQFmRwXyZwGGplWwF5yl4lqCa6z3JWVgB\n    OTBnDEt7YF6HcM4U7XAc+9Lgq1VrqQYm8r05GmNxH9a8oI6xJLQYbLRARQs4Fekpq4bvATrwt22e\n    PN3OlzCw6yX1respUtn1ecm2OtCdglMr0d1TsirfnvfrX0Or/XB+80Cd+zqgz8BdacdJXJ9RfZ31\n    LQlk3v5AgTVLRXO4rRlLDARLMK4lnbW8pMhCSxD9pAJqS8qL6wNrBrK+dhEQ+IyhDvCwyluzQ/MV\n    1no795FLU1q2DQhcslskq7cEfMUsFpB3TEvtQt0/z/XsbVcAMLOOuD9WngASEKrfFxj8ldIGmvXb\n    GddCs37FF3Ny+uu4OEv8FvtGzSYajpF3jkO2T4O6rM7B/egktbcAzWIcW/6tVNfe85N9wX/q7d6C\n    CF1jcDjeYuvmCexIgpnLNshxPEbNmMHbBZ4ZfdD/SsLZk4LW8y6fnx4zLS4rz2FuJ+f6eL60c7Z7\n    MqNyTfUxvMiJGWV2eYa5ggQvcBI/dFH+RwOrwpB6pTbiFx/oeE40S6Kb/TW3EX/NwLLMS/rO/VPu\n    Ly3VDL0Y62z4T/G7vOBKA8DcNsIGnvopfO9rjGA+j/x+xe3egPDDyuNjvjj/rfI5Xxw/6il+5Iuu\n    +qlD9sciTS7963Gs8gjyWTN/dYkf+Q4+YSi3wMefMF94fERPIK0cn7ODr4aPZB9zxNyPMvDL/ehY\n    5qq8lyUbbMWiZzUHPRbfP21eXKXHtdpf1DarjqwGSK3YhmXEeZvlF97QTWAw4IOW6dlpW2t8WmPB\n    eqWb0jWQeLo32x2Q10EuLeaQuXvnZylV2Yoj83PjeC0qla0XO1mgflK/6DMfm+bXq+P1IvSrAiv7\n    zI/KMawElUom5Pt1eSIGc8X/cZkDAYFF7lnq/7KMtJyjBwIfRxAYmIPAHtDLKhYWuGvVA7baahBY\n    xogygT0AGEigY4kJrAHg4Z7b4CyQANyfVJuvyIFiCzTWbb0xPBDYknnujX2837LI+8gVvQsUCwjc\n    AgCLbcEEjrKAgTII/NnZru/tWhB4CQDsHfd7BYGBfYHgdwYC1wHg3xP4C9wWAF4K/gJtAPAS8Bdo\n    A4B/dtrWAOAtwV+rjbYv6IrfuS8YZJ9rAHAJgLUA3o9j3xY47NX99QDgUu1fmZcl6TzMLQGvz07/\n    luS0yEgzaGuxajXzF4ixf7WEtO47zv7N+3xDl+RM4TN/ZR/XYzojMbwZ/LWYvyXwV1i/zOw9IdU/\n    5H484Fczgoe5JGD2DYcp0NTylnxd8tXYid3LCeorcsBXznVeAwpTn3IMqK3HBNZ91AJHbmcFfHmS\n    vqd5Dp87Ol8xm+miJZt74xwSG4gTw5Zso5dktwLpkpxZqc3VaO/VK+R5y7lEVr17dpx66afPXi3j\n    0nXwV0zPTQfKF6cfCcYOYMm2PECUFdvcrw7CU2CfJ7U5+H6Yguc5k1iCbg3OSkCvgVotL2lJb+UJ\n    yWEfJ9u5jQTpGvB9UZ+hPl/GRSmnky2zrBPHVk0my0qM4JZk9JZyz0sT1+yPlkg5p3OZg61iezN+\n    Zd+5sA8Yk53n9DdgvwMNC5gsAFsrAGiwN691qAHdV6RavxZTSdpp4BdISWXt4xgQls+saJL70zyh\n    DXDSt6O9FtCcM6L4+zZnuAhwWfcHfNzR2Y7C9pRgLvsp7evsfj3Z5/w33SuA2fLnJfBbz61kpQS3\n    N4ZeQOZd21Z/mTOz+oK/l+d/Z26vbbPkl737JnNJmhNzX/pA2/LvbWLksr+2/Ohg0i75UV40JX89\n    IJeptNoJ0Jv74Xzx1HwhVA7U6gS7539hfH+5n5dxvBJj7ALgeEr3R/oXYzawt09vH9pvwQius4yj\n    pue3hV9day1+ObJIisFaPs6bu1Ub+OUsi6LlO9SZ/lnK/fAcZPEx9yuLqNKzq8ueb7KwWEs/69iQ\n    93Ecqhdaic/VdX2l7RsOk4TyfMGT9Ddn676BF3ync+KYRsDDxL4tA8RA+Xnt1Qr2VJcss3yYZvjO\n    AWI7ltOxTadi0rni0zUb01pkZTFfI/7TM6+0kV9SQUwrifA16Gf3id9tdK3cxBLvs7YW6KQXfEcX\n    H5fLO83P8WmM5/J3hxzo5cXCmjXcK9+oQWK5TsOxeTyq40xd9/c4ApAfyDeyRLT4yAFwTX5U17p/\n    g7BPr+B6w2JfkfymgK4RJjADtPz3ifqRPN4D+hk7dw8mcFQKGpgzgVkamiWja/WArVrAw3VDtp2B\n    3xLQagHEHgA8jNPPQF4A+BOu0/ZaHWBQuxoL+BcAf64sr/zXAgAYWA8CtwDAgA8Cf3b6aAWAgTII\n    vBQA9o79LYPAwP3YwO8IBC4DwHuCv3+r7P8O/pYtCgAvBX+BOAD8XsBfq522YwHcFfAXQLENgOKy\n    CS3vLP/+wwhDSgCwV/vXA4At5i9/ZvBXtgFx6WferqWfpU1N+tmSfZbt3E7X/a0xf2WbxfyVF0fp\n    U8BdDtZZupKZvzrYjoK/83q/KcGdJKGHxLiu+dvhMAU4r+PfjzRiLoHJYG0KtKUmrwZlOTl9gS0L\n    zX97kk2y3wJ0OaguJaJL0ouceIzKH1tz1MlWuzaiXV8J6I3EgMdkmc/LA4CtVZnegg4Glu1FJ/NE\n    ig74rc/97LzyNl7/cl3SWJo5VU6c8D3Tq6tL7N+TmpklN3ZAP8qgpfvGUpXz2oP5OR1UAMoAbAq8\n    0/flRCuaJZDnANwCgqWv89TXdWLyck0mLT/9QvPmwJzP6QC7ttNpDAI9JrCWKWQmsiQDBAi26/fm\n    AAFLH2or1QfmNpFE9Fd0m9YgLCWst6zhO5zj/DfisYusY2NJcvt3aAG8L8a26dl+zp9rT7CB6cvo\n    93icC7qxfdrGiWg5TsYVsLdTfkb7SF4UJW3Yp8m285j4ZjCX6wRzsjpPNvN7iO1DWUWjpmahlxJZ\n    wG8aD9l4kcVBYmfVn2cH97je9c25nywzgE/op/e8D/Qsy8/Nthjb1k/Oekn96DW0tkuf8v6fasna\n    AESyvgIm5IuwWljRVlmD2rEWOGstorLvaWLbMqOK++Mk9huSz9JJbE8umhdVSd1e8alaZUP86eu4\n    NWcD99M4co6aDcz+Mgddr8oviu/k+sDp6gwKHSmxjqyvfvTddSD4aZyHXpBTLNFQMJ3wLpk19y3r\n    B8t8SrYl8DuU24kwous+1/PLF7WYx4pJxU4YgF++t3l9+zRXXYuXlTFO1H8CZG3wV8Zg8HdQ4mLm\n    bTeVTWAJaVlolat5JJlnDfpe0OGF+h0WZh+mY7XylMxd3mUsVQ79OcW4OQh5Hd8Dc7WPwTSgWIpH\n    9UKfN8xjWs3UnUsVe5b7hPneHrqcgI5J5Xlp+Revb28xbSl+LplXdsha/JuY6vlnXQNYn6fc26va\n    xsd6Sk414/YvsPMCQ/9+39qHWgxsXaJIv68wcF8qzWAtOAbS4mHdnwCPCZzNQdrz2Pcj+UYGgg8j\n    FC3MYQFoeUGULCgWNjCzgvlfAYGfiF08XKcUNz/TPu2DOH59g9Tunfu1aD1gwAaaSyzgRwNsHr47\n    OZj7YszfAoF1G9muJZs9KWgNFteYwCWGsCe/7NUI/qDAYa4VbFlECvoX2u+169HPpJ21/eAcuwYE\n    /p+F8bzjLBD4s9PHT0bbNSDwGgDYO/47CLyPLQGBgW2B4L+h9wHge4G/t673+y3JPrNFAOA14C8Q\n    A4B/LoyxFADeC/z9H4U2kthZCwB74K/H/uVj2F7QTQxgvd2q/avBX6utVfvXYhfXAOBo3V+gDgA/\n    IrcvGcBalnougb+PAH5VwDEfw0l0Bn8ZHNayzxr8vdD1FcCXQWCWfJZre1YBd0dB83VMoEtA/YZD\n    Bvwm9lM31TZ8RAKUpeXQV5cxfEXGGcjrN0lbZihxQrKje861DOfB9Pw7bCV0rCCcwToxS77RCt7l\n    GE+iNpfe4r6soE8nz+eJzeG8+qw2U4T1u8QOwW3y/XnFYQJkvXszrw3lJz54hfUbuiz4l+8AXxed\n    HCgF57XkNss58zHWcfnK6Q5831gSWidDtOzzfAV+P9UsfJgFcGklNss+D2Nex0UneYJbM5hSoH3N\n    AmwJvjXozMwozSgGEgjMfR/pOqZVxem8X9BloDFbBgSf8m2yPV3n/PdbSmDXktsey3jY5z8DdN9r\n    bA2jt2Rr2L58fCvr99Iw7kw28WyzflmuUpLLvI9ZTFLf+jjrgyWg51KRX4hRzLV2O7WNfWUJ+GXW\n    cM4wSf5X+pDzZWnNYfHMMEcr0Xwmf36gY8T0uDDa6D51IlUnW3tjHp5pH6cB3cQ+4WPmnwEfdCzV\n    2rvQfLvsmTlXcTjBlopsSVx7x5/Ne6dZ2GkeFkOMz1tACBh91cxL6OtrEQHMtQx0YjPxCPNrzX0d\n    lN/hfrjNHJCd95FkpHO/yX40+eW8FiKXUGDAmPuQNpwk1/LOzBgWptMj8rIMuVRlmm8CcNN15L7Z\n    R7IChycJfTQci5aafoLvz3z/a79rtYDArX2vtS1VPPiyerHAfPw5O1esVOfX2/e14mPP57q/v6DD\n    xxmQcJiBv+LL2Ido8Jd912WMH5M/zhcC52WDUhkHvWiYfZJ8FrYus32Phh+VGPI6a5PHoPKZ45ZO\n    +Uit+sWLPq2FsgfYi55qi4RKz2/v2IdxLlaZITHx37zNWlB8nvkhtgSQyfHzOfoWkVbVZl/bHARn\n    k/vpKbvJdbKklufvTuk6WNeHFyOXFDSklERnXOu5fLfFwp1LPg+Wt5kvmBreZ9j/cv85aKwB4FSS\n    iBc/WXXtL7TtYQJtr7Q/gcyPFFfKviNtk2MESIyCwBzPvtF+IIG+AhBGmcA9ba8xgT0Q2PKHfQMI\n    vIcUdKQesFULWIPFHhPYk4L2AGBPCvqDsV3XC4axD0BR5pn3We1+QI//HXXbGgQusYBLwLEGgT87\n    7X4q9FEDgi0QeC0AbPVxSwAY+H2BwMDd2cA2APwd/N3PtgB/gToAvBb8BeoA8M+VMTwA+I/jvxEA\n    2AJsl0g//49Cuy+0bQ0ArKWfuQ2zfz8WjhOz2L8C1q4FgD3pZ2tckX6Wv/VYwPBy/6NqA8zr/spM\n    2TSQ7DF/5TPgrbSeg9bM/LWAX/4sgbkAvh+RwGBgSFTLcVzDd/g8BKsa/GUpaCAltyVZLiuzJSnd\n    jeDwEIDntQsF/JUgnaUmRbpSWEyywpuD7MRMOswSy9JO6j2lbXnCWK+uBqyE8jyZ3Tv3SSfQLWlE\n    a0yuBWiZJ7GoGaacpJWXds2GsQJQ/qyln7keX2/Mu2ZHzANpXu3u1Vjmz3JfX+hepBrH+lrZMtIw\n    tnUE+F6N+8jBrX1P8vaWdLMFGtu1B/N7kIDv+Zh83zng1gD+RX0H0or7dKyE0jkjOW3vsz6u43XJ\n    QeJ+TATIauvhXg2fGeDNayjaILBmKg33OgeYGQTOg/McbPUSsj36CQAW81hJFhhbYvxGGMHD9elC\n    7XjWrbYH6OuxgSJgLx9fY0eVktmAn7Sugb/AAAAnxQltKSHN/epafiwFnT6nOev6v6J+wUCvlnzW\n    CWpmKA2/jzx5faXj03kelJ9Nx3GCmxlMLJssiWn2g8wCZtlp/lfOSd6PzhO43DnP/7nxM1izXtlf\n    WL6wxlgq+T293ZOYlMVXnGgdnp3sy2LM1dY21nn4phO/cv/SfRGT+zNXFsnnF2UWXwttSixerbRh\n    MaIPjt+0ktnMtoHTRns8lq/kY/ppfuwPBv/MtQi5DELqVRYgJNBWAFoNBF8ooc7t2Y8CcwWNIzSg\n    PPihD+NczjQfAXO9kgky7tzXWe8x1yoAjFk/MTZwadEUWwsgLHdE2x6A8HIwuC1/E/HxJSUOz496\n    Cz8z+eiz7/u59JD2zye1X4O/b0hyyXwML7i6UhsN/grg+4rDpO5xpH7Fxwm4e1F+TfxcYvKyj8zl\n    oplNnO7g0IZLDR2Qx2dnenJqWeg0j7Tg1/K3PJ5l8/4sQLBcXsGWv4+rXfAiL97G8am1mEf64vgm\n    L1E0Z6z243tS5PeswVHtE0vX0fqb71FaoJcrkehYV4B1PncrP1C6lh4jWtSj+LN1XTVofC20tca0\n    FljJAuPk+6yyCle6Lgks1mxhuTISy+ZqGf3kb+U4Yeo+jqNz/NqPftSrC1wCgYfvTBpH/A6/Z/QE\n    2Aoo/AU+Y1czgYH8+29JQUsf+nOLFHSJBSz7xSJS0HY+I99mSUFzLvcr1gPAT+hdGWixGghckoPe\n    EgAGgH8Di5jAP1fabA0AAzkI/NlpswYABuYg8BYAsNXPdxB4X7sjCDwHgO9V8/c7+NtmawHgGvgL\n    7AMA/5H+/qlyTAT8rQG/QAJ/vfZbAMAWu9dj/5aO9er+yjYL/AXyoEaDwfKCUKr9azF/LfA3yv6N\n    SD/rfjxwVv4GbCawZv6+TXMVWLVz+xTwVzN/Gfx9yJLfc9lnAX+7qY8c/OWAOclPdtTbgYDfvM0V\n    h6k20hFJVmsu8dyhx7wOMCeyJchOdYNToN+p6wtoOeGcGawDL6uWrAVKcvDVGcfM+0B2BGZtE5hr\n    jS1JSC+4A3K2MCfuNBsql0fMVy6XahDBOH6+L7+2fh82gO5dP06k8PXrRziXP1vX3U+kdFOwWpK3\n    9BLhV/eInLGkA2GrD520ntcWHD7xcToI51XVfdbfHARObGJOgnfgOofMcGJAWYBjBpsfxhS8JKkl\n    aD4a8xg+D8E3M46AxEICEoAs8s+ABOgdJQBy+UsPBD6OALC7D+X6hFHGr96na++1AcDlcxr2bW9e\n    IrgF9LX626LOr7Ud8FiSCZw9n72kaQ7+Xsin6b6Y+ctJZ0n8CctJ5iPgryf5/EZ+UPYz8MuMXw38\n    Ctt38Kfp7Fm2UraeacEUA7rMxmJlDjFWy/hiLLriNjKOV8fXYi+Va/fmxs/60nfQZ+7mdev0PDsk\n    HyzGv/+SrLHHQvWS0t2CZ0DvnLN+Z/Cun/dOY51zX/mNzxcp6fnY53ekvq0ktHfm1vemBArwwiZe\n    ZNWRP3sin6jH44VPDA4LJMQqGZwAF3ZTupaXjBXM/o6B4H42BrN10gIrloRmP3rMPovfBbF0yiCw\n    5Uc9EPgM4OnUo7Ywal6XOl+sBef4rRnB2molILa2kt9eorSTLzDqzf3Sv7Wdx09znO87w3nOnkVJ\n    ygaAGfzlBVFPY/yiF1FdadsTjVsDf9N16GbMYIk5pf4s1+RlhrAsNk6LjPNYb5CDTs9XAXAl/pzH\n    qTK2XqDlLyBnfw7qJy2G681jeUwrHtXmLdqxwOA5GJi2p/eFeUzqKTdEY1I5F46bvLrxkXq4NbMW\n    InOZogGkzBnqOSBtA8VWCSFL/tkqlzAvR8T9zIF86/zt2DGpYaVFRfO4VF9vrbTB90THoJZCFLcX\n    wDcdxyBxT2zjfpxfkoQe3oDSmQkQ/DJ+ZvbvwzSTFA9LbeC5JPR1AnkZ/D3SVe2RQGZgiEEFdBTm\n    76/0N5CDwBq87cf/cTyk75XHBC4BwNJ2CQhcYgEzc5jbRaWgeRuDwJb0swf0WuPxGBoELgG5f6J7\n    +yu2B4CttgzYLgGBf660KQHAgA0C1wBgIIHAn539P1X6aAWBtwKArb6+g8D72p1A4PxV9/cE/t7a\n    tgR/a7YF+FuzGvj7XowB4whY/EO1Rbt5NX6/Nl5DD/xlYHiQdc7Nqrn7Ehg7Av6WxnkrjKFr/kbA\n    XzifvTGZtesl0k/Gfg/8FeZvuoY5wCvgL9DhBZ0J/sqqaKuWr/xvuO4dfsURDwAeCagV4PeNgvFH\n    5KxfTlQzc0rq/b6O10XCAkkosDxXYnxinE03JsyHbWfkCVQJ9HrY9ZxkOwdoMkft+lJCrry+/0wz\n    zOFMlpkcgmu9CpgDzQsF1TooA/KkKctwDUmkOQMaxt98ntbLeE/Xwkp8HehOpG22HOiF5nMZj7AY\n    2mdKDF3pCrIEZk/9WJYzjvwV7emalI2Zqvl5SwIyJQMS40GujHwX0tXQq+Kvat/DeA/P4BXVKdgX\n    EPUybeshdRuPkJXNktzuRlYSr7iW1dRyzY9j4hlTwD6w8q9jQNaNzO0rzXN4tjyOQf51nOkR1+nZ\n    JECsvt6SVLwA+BXHSf65G+cvgLAkRNPzENPn8/QEmX93LypBZd/T1J+uM5yP2bnJu7wWXZpjvZ6w\n    B8j2s3NdYpp5my8M4usU74t91EOhHY+nrRVs9lhJFwhLJLXzAGNbrWHYLt9BZv4CwzuDruUrNYC1\n    5LMkqb+OyWVJWLPcM7OO+vH7lNQy0jE9DuP3J/ffcg7i2w5jP8lbpXnJohlZnPUFSQqTn5+swsEK\n    K/LNvWK+8Equv/hoecaXwMh0zZG1tZhMgEiEJhA+Z7p0sBbedPDZMsfss1zDftY3VH/6N1wCt3Vt\n    xJpZ9e7FTuN+rsF5wRxiTr/ddB9P0znP33FS//3s+ZPeHeRzWkClWV8aoC0pZ9jnngO1kiDPF7xp\n    6cwjLVZI/3KlxjNy+ecrBvYspiQ/a4HI/3cjQDDcQ3n3SEzc4/irvI4LQo70++vRjX44vUN1uCIx\n    fw+jH+1wnZKpFxxwGZPdOeiU/OgFPfnV4Tv7AdfJZ8lvHUg1evn70k2/LauUQjfNNt3HbvKj84U4\n    cT8qfVl+dLhHth99yOY1WBQUvmAOkfE7cJSFXLMaszbiry0Wr7UIiq9TTQo6OjfLl3bjO2aH/D5a\n    YLMwfodno5QNOhAYnD8PeFwGf7mkEDAsqkpjJvD3iT6nuJGVMw5TTMllFmTblf47jb/tB6RYEhji\n    6OvkiYexZPE2A8Fy3hok1sCvxKf89sn1kIH8rZQBxzP9zc9cn8Wd+rC2l7ZdjO1WTNopX5HYoPnz\n    Xn5tPfTCHGHI8jWa+0qJZcsLd21jAHYejUrEk8bR74OJHNBnZYbknvTTfc3vm37qSKSalx9ib1NW\n    4ZB2lv+cv52JEkjuj18pTuSnPL8zSa4gL22V5nml+FTYzf34xijsXFk4LM/ZI/rpneUKYY6Kh5Ro\n    sscbDipGHuLOA4bf3Bs6nEZP/TJ9o/qxRT8uMs6vi1wH0N0/TTHrYVpgLG9dx9HHyTveGZIzu075\n    oxP66Tmgpb1lH2h/yrOluzeQS+qmxwOQjdGP2wew1gKB7XHke/1Ix3E/0vcruund5AnzPC3bC7oZ\n    mPs63qdn1U7uxzP8SJyJQHqMD8hBYMlLW7LOX9AVa/q22g8YSE+/FNpI3l5A2x9RBoF/QZcBvLX2\n    NfsjfCbwnvYn1EHgf6JzawKvsb8gB4E/o7spCPx3dPjrjUHg/0bngsB/w/4gcKv9n7EaBE6vn/cC\n    f+9lt2T/vifw9572x/VdZBYBdGttmf37A2BKYqyxfzivoRb4+wE+MGsBu8DwMszgrz7GMmsMDd4O\n    EsXler3M/NXH1sBhqDY60e191rLPb9mnnOmLQp9DoidvW2P+cpKfg235NzF/O0qep9XWUu83SVke\n    pmT3EPQP7b+OgfvDuO1tTBtLsvFM4e9xnK8kvCUZLYlxSUqmoG04RviKnNrukQO91mprDup05WFJ\n    JnNgy4CyDgh7Yxub97ohwd0RedKVVxd309/zRNt5DIx0jUgZk5PikhyVxLeE3zLmG+rmrURn00C6\n    XDt9LfSqaUkqyTlIulRLqHESQydK+F6KZLKEcS1JAmYpeUymUm9DUisxavgICY5T4jxJiPK9s+ob\n    XqZvfj99q7sx+BVAQeo6H8fP0nYI3IYV1t0YQCbgNiWv08KAYRZDMrufAnR5HvRjkH0d+xyk1zlg\n    F4bVAZdxjpjO6TAlr4XZwQzXYSV2SgbKfeZgWQA9DfjKb16+q1KTdX7/OmgmkAahJbgX08lVP0kq\n    ig75XLY0BhrlHM6IJ60tv2IlxpfaraWe5fugr5G1nY/Lzz1PRGuwWOQlB8vZwnmd4AT2ip88YQCE\n    U5sc/O2JfTv8rg/TYqjj+JnloXnRC7OfrtP+AXRi0NZi+HJyuwdLTqeZDOeXGLx8nXpqI74TyAFL\n    TvJbfoEX9liW+5QuOxbq2KNzrGW6Zp9VomHoM4FDvFiH/9YgJZvFlGXGZ8Ss9wPuL5dZTOdjzVcs\n    McXn14llTHvjWD3+FbFrz8lc/t54lrivczlhi6l0pZ45ld5N4PBx2ibf6cFPXiffwbWB5V9eMNdP\n    ae/kZ8WPdpP/Ha5bYufKdR5UL0Q6UpLLV3TZL/E8+lHxpRjfn5/HxVKXsbdHXPGK4Tc5lGJJShoX\n    ur7Sb3p+5sCNgMTynLOAYA3UAvzOnbcT47IO+TM9v5fWgioAmR+u+bYHYLGn5bmlshQaNI33bjFq\n    5Vy3tnzBle3veA7W/GS/F7fXJJ+5X2sBH8eQooxxGf2UbNMxp8SRWkFjOMvkow7TAum0aIqlnM8j\n    8DvEWvmCLNC/Eis+IIHOV8i7Ir+/D75c4s/r1EsCnTkGvdLeF+SsYH5uc2wqY8nzKfmN/HmpSyZI\n    v+XSQnPTi6vm7NX5sbYMsa53P1/gms4pxaSszHAd43l+3upfXrTsjnWeeiEYoGvw6sVivAx7uL8C\n    IvZTnmFe9kj6kfcC/XbN3+nct6R7od+p5udjm3VvJPbXi4nZUl1hmXNa3DQAi9Z1TqzXFDknRYxh\n    sUiSe5b3pY7iy/QeO2w74jDFp+cx9nyib+GV5iTx5NPo385I/v9tWqhsLZQdYlZZHHwcf6kMAh+n\n    88ME/AozWOJo8U9D3Jf8hgCMXwq+6+vo0wFRD2SGbzexgNMzvs/iSokzLZPj2VL+Mh9DA7lP438a\n    cJR2eR60d/sHfBD4eQSBBdDlv7vxGAvsfXa2PwV+/+m6xwHgj8hZwCX7AWUQGJAcfmxsDQLfw35G\n    N6sH3GoREHgv+w4C57YnCPyf47ne2E7T4Hva773u73uyP917Ajc0Yf9Gmb9fAu0+Vlu0tYvYi5Ng\n    9tLOulaE3m4xhJ/VZw3gavZvYqrmprc9Tn3m25j5CwA1qWdt+gVOg79n9TkCKHMfHLjbf6cg+wU2\n    85fB39MYtDL4y+xfaXcdE9yyTyS2hAHcIwG/XNfwcTqeZbQSk6mn0EiEmo7juCxRmZLpzFrioCsl\n    uhm8lZd+fbfyJEQKCRm008eUks+yitxj+8oZSsDaQ8sgptS7BJlH5LJawxykhpIkcvMV0/JXYnIy\n    syZfYZ3Sk6lvfa6lOo2XKamZgDqZAzOKGJiX4FnStgwWpPpfCZwQuDNnqKX7xdcllwZPdhlbl2oY\n    dlNbe19aIZ3YyDLneVstM5mC6DSP9A27IqW2hVknx1ynK5BWXrO885C8Gti+CZq+TknsDlJHKYHV\n    16yPfprXZUxUnMcRkyy0JOauY0L3MLGcOmAM6A8TY0mCf2GFvI6MphPyBPLbmOCW1dpP6PEyPl8e\n    R7aTJNVOlHji1fk4j+DeSZKMczlIjw3MSegzOjOZy4E+r/r22gyf+RtFc8Uc4C6Z1c/8vOC2WiIl\n    XfJJVtvaeJfg/CPXQtct9M5cJ5k5ucEAszyXZFEBs4gZ/OX+JJEtrCBA6twndpP4LymTIE928YV5\n    zWCWlhSfyz502C5+VfxsT/fpdfSTkrzkkgsslZ8vkOqmBOAJyHyCTlgD82e19Y4nNRmFva9Ng5u8\n    XXpjVjEfI/usY8WvcXJVy/DLve+U52UBwnyRT0rQAfl3/Qj2b+mpq5my2o7O57Q4aW4n8teyEFCO\n    SX47nUNK3KbvjjDzdP1Iy196yWm+9jlzyE9al5LZ6eh0LbR0Jr+DcZJbAAQNGgjwcBh/ATkzTcCJ\n    4Wq+jW2fRgD2OqaBr9PbmbDE++m97Tj2K2obAgSLHxV5SgGnLzjiDFlQ1Y+KG904WgKBZSGUsJRk\n    MRVLCguwzMn1YX8/PbcS6NsTCNtnzzwGgeWZcwFwOveTHx22CusrZhaYLNtl/mJa3Shtt9UA2N4K\n    bT3z/KgFbJf7KG+3Fp+dAv3o61BT1yhdr/wYf84T05ga6efXGQnolHm/jouOhBEL5LV+pQ9515ex\n    hoXbc/D3DAZWh9iTJZ+HfuX7neBFBn6vo898Qw4AP0zzSAu4xBdLHXV5bvOSYYkveIGWxDe8EEoU\n    Mlixghdf6ee7PLPzJcwpdslrmSef0Kl9+n7NwVReMDPvb4i/cnBYWJsndRRrLPDCmbRwOjHC0yLd\n    BApai5+5IEGu5aXByPl3Xl8H7w1Snp0H1VKek3z95P4Pz9Y0My0Nna6vBpe7zD/yonJhUDMjOs8H\n    2Ave9Hn2yBdMp+19di/nkt0phnygay1lEfIFfLmPlQXKVwzsaPn2Du94g3c4Zz5Ujk3e8DT2c6a5\n    Hsdtoig1qFHJN1bvY2by0CYtFtHf/X76LWL0zcIm/qqYwMcpvpQyJ1d6/+9nseFJbRPLS70NAC6D\n    wFK67XV2zPyzNSbG76aoYbwhAdM6d6lZwBab91Fds9ex7yQNPdzlR9T9q8Xe1dv57xfjji3Z/hVd\n    kQUcAXgjbVLZxR6/oMwybn1f8uw9AMRb2V4sYMtuDQLfw0og8J62BAReyQLeowpabt/B39z2ZP/e\n    ym4h/9zC7i1ZiZsjjucL7Fpgum0E1NW1f/cyXQ/4GWkVMteJ0HV/tT1jnoSaJwO64v6a9LNmEZeY\n    v7xNM3O9MbRctAaRLWlpTvoM0lYJyGRO05k+afBXVl57zN/0Ap1qKknAfZ0C/GFbCqpT+qyfjhA2\n    bwqYRaqPg+eO/k2J7MOYIEiSWj0lBF4xBP4cYIHmKqtzGQjskAfgSaqPE8Pz3xQH60AOenIynGuy\n    cULdq50nQXFKvPcTGM1JWJZj4hWjWlYLSKzRFFxLStGqCZxq1MkxHsAp43EyWe/T10cA/IvRtsv6\n    6qZEtqyclvnKNk5SCiDIiQV935i5JoneKzi45vubVkJb8t3XWb/z1ejcFzCXHGZ2EYPbw3c81Rlk\n    9k4O9EpSpp+O78HsXWGmcy2kJLcmyWHhIXXox8Rykqp8mAJ1CdZFHjMltPkcz2MALRJfF+QSz5IO\n    E9C1GwHd17H9FxxH5vB1fAZJ1U9JYotCQU8AXP73CcAfMATVPEcgZwOfzwkE5kST2FySusPZ2M7m\n    MZX4uR1h2gOY5BPXvL4vqdXbYpzUrRkzfi02lMf4tc6jxPq1arTjnJLKul9mJelzY9lUYTUxyJsn\n    r7upT2H8Dsd1kBqHrIaRQOLk74SplGoepgQ1+0ypVXgFJ6kxtWX/KYntF3QjOz8l0OVZnEDsjt4L\n    0hXV58rPWX6HYhnhBDz68sXCOM65S2kff/cP2XF5e4/tlC+nSolzVlhIDNCUYM3lH/NnO7dPT8T8\n    2ZqPKtdGns/2L8ba6gOidjxwgPiubkr+yt/iM2T+OpGcQIqOnusdGLzme8ILySzm1THr2z9Xzcbq\n    lE/J/54zfqUPDeCzeLO+JwwGyyKpixrxOKWlj5CFc93oq9LY8tY4bLlOV6if5ppKUswXT8lyRllu\n    JaDtedwq7N9+vLOPkFIJ7Ec7HJEUNHK5blnkZoPAIkXNC6EYmE2ympj50ekZce4zEFja6lIJ3MdF\n    7dP+0mMEPyP5jCiTlmUxt7RW2WvL2M89NJwTn5dlnrrGi4pkhDH14j6Tcl8q4K/lLy8jzCXxefou\n    5dfLWwh0RorVOnT4MvlHARXT8aJ2cZrmxxLR3cikO0x+mRcVJ98o0BTPKy2oAoCe9vfIFysLYCes\n    YgG6MY01X2DM/uhAZ5uOStdSjpPr39F4HD9dkXs5vRCZYyr+hvIzXp5W/C6QL95K383H8Z1cVKTY\n    VzJrVRZYcUyaYuo8JpX3yATs5+eRYst5PKqVNPSzhAFSzfKVa8tt+Xrm+mLIzliuGy+645JFHA/z\n    s0LiPT3Wdeozj/k5l3Ghvhks1344P6d53MlxDjN65f0hvQflLOH0fWB/KjV80zc5Pf97uscp03Kl\n    qyiM5wv5wg6J3StXh8uVvI2zk/dKUdO40L4HXKffzWXKPAgbOV3H09iPMEjlnfSEfmIC99RH+n4N\n    ZyYS8D0E8E3lmOQMBmniFBcKgMvP8K+jDxfQlhm6/I0qxZdvagxuNRBfbBBYxmBQd9ifAOVXYMYm\n    FptTGTCr8cvbv6p9z9N2yfH2GQhsMXtbGb+etYLAQIdfgSJ7+Atdj62lpr/bMtMs4FvbPVjAJdtb\n    CvrGIPBpd/bvd7udvWf55/dmWvq51rYE/ooDroG/W7KCxRKrdz5erfavBQpbgSYzf0Uaeqn0swfc\n    Wp8BXwpaAIFH5HJE3fRS5tf9BfKghkFhIJdde6CkwJBkSlLQLzjgeWwv9YCZGSxBuUhgXqcUZEpW\n    S3AsyekzktykJJWZUyHtRW6rp/G4xvAQpidgF5Aah2ksIJdTygPrlNgUKcpcajcFYczyShB2/mrL\n    NZvStvRJ2kriFUihwLwOV+qZ7yOvvOVks9RROhhjchCsV+byKmYO5qxj5MwkwE/1s2yL1ASV8VLg\n    ygEx1/JNEmhybzi90SMxh1myUMKUCziITfeAE9gM2ArYb60bZXC89BqjpcL08bxPJ7vlvkmyN21P\n    5yv3kEH5nP2d7rMkXQS4H4DS4QqdkIDj08hbkoT0YfyWJant63SfciCYRbfSOXBCe1hIwldcFmCk\n    JMFlvPKX8ejHMbEuCem3MRhOUp15MvhtTBUAwMcp2ZBDB5KkPCNnGsl3xipDYNUmvIzJCW2eZCUw\n    l40u7Rd7Rim4luPm5iWetwJ/S2yjS/A4Bn0Z/F3C9j0W9lvSk2IW+KsBbJFO5gR3AikS64jnwc8y\n    6VOknsVTJEbRgRZ8HMiPJbaSZv2+jAxhjNstUFjSW6B9STo/1SI+ICWvezU/qanGCXGtpiGA4BsY\n    9mLxxpw5JL/+PCmd/6WBYU/a2QODtV/iffobkiSdud9c7p+TqwycdtTHKXvmpjFFnNTzldZCoqhs\n    ZW1hZ+ovB35OdD+5P36nAP3N7zasrsHXzUrQR++J3q/BYE6v5teOfWsO1PMiqYvRniWf0zWXxVf9\n    +LtIxw+1BxnQkCUDyb/KfvkfJ7uTP++nntMVT0Aw37Pr9IuRlLj8dUV6VxjaSE3qHoPspZTDkMWb\n    jxNzKS9nAGqXEu+DMYNHnl8H9PQsnDNWnmD7pJKyRpT1q/cBVn1bWeyKrI1l/P23FmGtLdPgnZt1\n    HmnM8mddgqJktXbW+BJDW3P3fOmT0/ecgjEAqfLde6XnkOXDWSkDSDLSEidKW3nzvEIAjFTXNwGt\n    h2lhlfjT8/R2nOLNxJY9oKfjL7RQSp4uPMZ5UgvoaFFiii1l0XNaliq/Z4DjUV1fNue25uoNpVhU\n    bM4CzX0RP4f5N8O+IEFX+eI6LeWeYqj0TBVA7Tz2wHPlWvCsxDCMncDivGZ8/sxP8Wh+juybazVU\n    ubwQm1aVSvM+KP+e2KUSI/Ex/G4kx1gL1HjeEtdKP+fpuzPMktWyku/lmr1JBUrfZ83w5YVufO+H\n    70QuD80qVgxCn1Q7lnRm/5ok3nvIUt6h7XWqFfyG5C8HEDX3p6exx+FZIApTg6zzmb5lvJRjuA+H\n    yWPJs+mKwwQCp3s4xMIP4zy/TvHqdQQiB7av+FG+mvJsu1DsOSjR5cxc/V0GEhNYyzgLwKsZojpf\n    GCkxpPcxsPzqzEubsIIfx//k7/mivny+XCcYSL7mCUn2OZF65nPQTOAtwF4P5B3y4qn/Xwvz4mNq\n    IPCtgN8WFvAfcZ86wN9tsL8C70YK+j3aQhB4fwawZ/dg/363+9kfG9puxf79A+y6Ai3M3FpbDf5K\n    e13jtwT+fkDZnhu3e6ZB4lfjs8X+FQBY5KWWSj+X2Ng6ENcALc9Hz886HrDB4059llrAkjRg5q7I\n    NgM5+Ps6vjbrv+0ahkMbBoSZ+SuB8wmp1uAbkgz0dWI3paS3gMICFgtDeF6DMK3FHV7aEzN0SHRL\n    zaBu+jcl9VIQDeQBnlUL+AESUM0lE4d+5qt6Qe3k1Z3ZUBenn4s6Vm+fJ89zmEuvugbSCmNJRnJw\n    zyuoWd5ZUiNXelHgmneS5I7WLLQY0XzeHNDmAEKS1U2roK16ywlkSOeSkiqcdEnJYe6Pr2fOoZO+\n    NFMcdByvAtf3Rq/W1uxszPpKga2+x2lleAImmF0jNaCHa3GdAFtZatHT1b2OfKbEfJBxBQASrtMQ\n    jotMtAUEi6SzBOmpzqGsik+1gS+QhNvABJY6hWck1hMgybwkUy7jiPSWZicJmzfJbenfZPoul2Ql\n    2SJsYDn2bOyLMILlWe5JQZbsVNn2FevfN/QYy3rsTJ9+Nq6bjKlrMLLlUpMe8DtnAwsDKa/XOj9e\n    1z5mlu9wNnMQDUgJ39fRxwlALCvFWQ2DGbNJSjIpZOQgb/KzLBUtTys5JpVESE+6A0R2U8tgDv8/\n    SF8epme68HnSTDGdK0siyoz4Wsk7QP6M5me11EHNjWsb8v3Qz11Lvlm251LT6UmsOaL6WP05r6+Y\n    xJ5zmUSov/PktlWv3apPy5aeCd3sWG/O+t3Q+j7qdw1J1Se1hDxBnVg7qUe5JrLIzFIKkfuXUpUW\n    xJ+DuvocS+8TmtnF90On72WMQ3bPcpYZHydtBXwQuUQeh5nf3eg7pZfDyEhK75EXiEpGrvaSRrSA\n    YKn8KIunRPlD3hiEDXwafbskr9N7m8hLJz/6EaAzS89FOT8BcMTPsm8Fjc7fJ11TmK8Ps0R1veAO\n    ORuY+9BsYN6XP4v5fSc3vagITjtt1kLaY8Pxnunrw+Ms8aOyQKlWP9hj/Oo5SRtr8ZU8H0wFDTq2\n    1DfP5ULvAMLYFX/MtYaT4pQGf4d4/Qqptzt8y2UOg0zrcVLE0JLPumxCgr4OFPclBathnMO44GFo\n    K8ziAfiRbd30i+bFVqzcwX5UVDbSwtrk55IaBXORmUkv1zk92axYlK87W84u5udnN+uLgUE9lt6W\n    q1YlcG+Yxxy8tWJSra6RQMS54gOXJJK55gti03ciYt5iX/47L6mVLyBnMD7dc14wxu9Rcg06de/y\n    95W81n1+jun+2MxlAYn1NbdMgPrOaJdiwLwviY+FUZsg2hTbcjkDXsQl8SjHscOiw7RgmVUzxN8K\n    iHxGXkoIU5+HKXa+kE8WbRLxrcKYF8B3WKxxId+UZJxfR187PB/zNxx9vYdF2YexZEOqIwz0xPhN\n    10iIGVrKuc/6Ha6eBQJzPV8NKntS0Awyi2npZ/1Z8p+6HvCL+luzgl/HO/lA36hX9WtuNU8yWvZZ\n    PUsO+otznOSvf0XOOBYQmAFiTzq61SSXrgHhP2BeY/m92s8r7+V3e3/2HlnAC21fAPhv67v45u3z\n    BsnF92T/RtcE5rbaVuCvZ1vKMnPimMHf6DFsFoP3Gb7M1Cenf09CpGavY8DIQK6Aq0/URh8Do721\n    f5B+RvZZg7HaLADXqvtryT5bbGLZDiQJaO5DgtbL2DvLWKbVsmnVtgTLwtTKax0ephdgzfyVZDIH\n    1xJwv0GEog50VGIFi+SlAMIi6Sw1ks7TC/7QHyfND1NIkoBhCc4kWE8MCL1SWkIHZlh2dBXylaRs\n    HDhzAjBP1HpHY5yPLwMpczo4n5nhmIInS8qYk5684rnP2svWVDs4Bdry/TwU5muxl7g+8vB95HOX\n    714KZnPQIQcTdD0mFlzk+5EvE5CgL91PZi7xZ2GHXtVIKdjus0TAnNVr3d80VuKpcvI8B+yT3Gti\n    ePO9Y8a2rKtP9zoFzek3MYCrDOhyol7EpUVsjNsN9+U6yXVdMiBXfqOaq5Qg85R6luub0g0HXCeZ\n    wLTA4YBXDNKWB/R4RJJaTqytoVYw6Jpo+XVpn1i/yfjNUH9b+fuoTZ6htkxx7+4rMYJTwrrMdMrn\n    WGYVXZzf2lJrfatgJYlyu3SOc/C3bt71Obn7OjMh6M1VgGJd956lx+X58gQGl6XOfZJv5jIJaR56\n    KUou08yJavF/D9T2SD7xQG3EPwrwK4uYJIF9RHo2JCZVRyNzCi490Xkc+SxJTE7bAeJjuuk5Iz3I\n    s2B+f3OgMpeRTqb9jmYUHQmw1d8BZvEOfc1lnAFebMIcxzmMLAtq5jURewgjjZOq3INeqDVck3pg\n    bF03fr5qMNdi9MpRg088ZNvmZ5r28FtMCbjlNOV1dg+YJWQBFFDt89kIW0tfz4s5a6h7lxZBpe90\n    YvT29JnLY4hJIpjrA4tUtICqh/FX1eM4AiHDr0hYTY8jcCtg7mlKVvNzM7GBzzhMTCgglU5IfjQx\n    mOQ+yBlckGQv5ft4wHVS0rigm763vBj0Ef0k9azrzXu+1FaisK3GBpbnJQrHX9QxaT6+r02f/bZ6\n    HH3MGjsjZ1/WJKIjih1cC7k2R68/T3nDq3s8zF36tOcj+7jMggYm9SIuVtkQ8Dd9FxL4K72lmDb5\n    JM24xRiPahUNAYaPYx/DYg3xbim2fCBfLECxxJ5pgVVqL35X+pEFF/nC0DS3XDUnxaFJJD5db1nM\n    KhLTYimeyOMSPx6dm77Lp+wJOQeNZYuO02Q+6ZyYlcpvAvzMxbRQ5jIuBk2LzHSN2/kikV7NSeqt\n    D9ekrqjBPkmusUQx/F7C9ZglcmaFjHxhU9rG3zy+XylWT/dc5s+xqpwHf9b3TSSX/fvbZ3GoHIOs\n    /5wt3Bttkkftp3suxx3pbTGVlEjxpowpSk+yoFz6egPwOIG2Sfr5YXzLGiThZenwcJe5LMIr+il2\n    P+I6+cgj+WupS/yAK16Q3vXecJxAYPZpsl8kiOWZKMz2/A1usFxtBZNstICvz+P7gMfULYG52gQE\n    ZhYwgNlnPromBf1Kn2tS0NLWqhUM1d8SswDfT+O2Pthe2MIDCJ+sBObKPmYC/xo4rpXla7X/EduA\n    wL+gwx+Cc7kXC/hPAP5RafNP9fv6buvtnizgG0lB7wcAfwd/b2sR+ec/rRzj34ExLIsCxkv71/aj\n    s32vmrwa/PXYvxb4+wE+yGttf0E3A39LtX95O9szkL3MALZM1SOWWU36mffqGr6AXQeY+9CAckQ6\n    mpPuD7DA3DQmJw0k5JCVzhKqMED8SmGe1DXSUtAC8Epge8xCDmEtJNbvFUNtYgF6uynA5mCba/t2\n    o8hPLl8pY1+yvxNbSdi7LFnZISU8ktReCvoksOOahT0SQ0lkHdP/p0AuB10xHt8V3R1DeCngTwGp\n    AI9inKzO5YyF4ZEnpC3p4fRvnqhOUl/MGdGMp3kwqdlL+XgdchA0mZWgYJkykR0TVrJm4Nm1D7uM\n    SSZJwn76nExgyvxeMfs3P0bulT4PyyxwWEttpV7zbTKHC+3VyQwJrjlRNEhXXac9PfV3GbewZPQV\n    PXjFfqp9mNoOrKLhujzgOiUbhdl0wRFHXDKW7nUMeGWldQedqOonBiEvKJCFAK8jyCvne8q+J8PK\n    7CcMwLbADZIYPtLVTPd6mEUKYJlpxW3SNq6lzaaB3nSM/SvnJLVX79YaQ5snrVmyB9zWPAaWnr8G\n    qqNv63W5Z5v1y8fq7Sf6LH5TQGiuWejNXVa+g46/TN/u1IbBXJZtlhYM/jLbV6QqpTSC7E1JbPk7\n    +cwz0uKpfvz9DlLA3SiXnvo6QRLOiaHMyc2kFpH28fXL07oYt7GMpfx20372X4Bdn91aZFR75vaq\n    rVZZ0M8bXuwkx1jJZT1K/jxL9WBFipevBrOIde08npf2nREGsL7y+TXO2dtyfeT7wcyt+TtKDiZY\n    zOw5+3fuyy3Jbou5FjVL3WSepNbvGGlkAWnzueTsJQEdHnCdkt5SLzIxccVXyi8i+dPD9B0YfKiU\n    WACAt/ENV0Cn4d108LgDuH0YF0bJAql0N+Q3m1Q65Ls3zEvKJjDw8DYCKuk9rhsloeWdIC1okRrJ\n    osjBUEUCQfosJhA/mthOfIfTsRrsTKzJ+XZQew8IztUy0vfyBfOxLFnlM2w/7tkefjRaMzjqG9n3\n    2u8n9TnUxswXKcz7kOMkTsz9dQd78Vy+TWK5Rwx1MDlOPwL4MsaSXEpBnnBHSDmgtDg5gb+HSfWr\n    Gxe+aNYvA8Psk8UPi2KHbNPAsByTShZhOiKpVEjsmj935SwkRmW5fWaayts7+yBe7Ao1Mn+uKTZp\n    RSOA/Xf+3OTYiRdx5jEVs0vT0fPFIelKsCy/PF+1jD8v4mLWsC5NcKTRvShcLzZLRWq0Mkk6P1lg\n    K8fzIlQuTSXXTZjdknvQYLl+19G/v57eKwDtixPX1rNcCSONLfusZXU90nMkSTkPe67ZHZb/12WJ\n    0jLC9DxPPvZCbUSeWRYlyWIpIMWjAgRfJ382+EhZ3PyI65iD6sdnjxx7Hec+3JkeUlLomoG8Wg76\n    Mnn0QQL4EdexZnqPR/RTjd7DGBMLuzct/LAVpoa81LA9r/M7mPiaV/rMUtPdeDyzdC3557TIuM/+\n    1vuAXAp6qUkJPcsYOF5aC5gln5/HK/FFzfnFea/wJKMjjF6LCbyl7QkC/xv7gsAt/b9H03WAP6PD\n    pxuez9/R4c/v7PrtzQJeao0g8P0koO9hf68kArc2zf79y07j/IxuNbhbs+/gr20fMTjImoxzq71g\n    LgfpbQNykNcCf3XtX2nDNYa0WdfyqfIZsOVSrPpRQLkGU1T6WQPIZ+TA9QO1O9FnvdpaktKS7BV5\n    6K8qCS31CuXvXwkYliBZAmBJcstK46cp6EkQ4dvUhldYJyaTBNwiZicw1HAehykpxquw0+rqlABg\n    IJelqvN6PcJ6ypmiVwgjOQf88uA5BXDWd0oHYBpk1N8EZiRzYMqBOiczezBIlwdxslI3/Z3XLkzJ\n    Ng7kUkCnQcUkn5xmxNuScDB/Z+svMZLw4GsjwG6PlJTmtnKFjqqnlCRJbfWcc9nnnsbL55SzMnKm\n    VL6Kvqf+6sxI5sIOfdlgOoqf0z3jJAoH3fJXWhmdgqB+GpeZv7kEl9xRZvyyzOUZiQsoiWlhGMnK\n    /TOkrvBl/L4dxu9EPyW0BdqXhLNIWXbAuIo5naGAwB8gUtLD1TihH+UBBwaR1BwUgJrrsD6Oxwmr\n    SSwBe30G/ukgU557FhBsgbha7tGShZZvhgaCta/wgefOXVTlHbe1WX7t5Pwt9oKuOdnMtgT4Hayr\n    Ar96m8VAE6UMZvXKooQhKZ2kLMXPCqiSFlTlIO/w7tBNC6J4MVRKQCeQV/7up1/g0PZ1hJxERj/V\n    K0zAr/jeHim9fUQO+h6oT7l2lynl142LOfLEtuzTAKAwmrgdmyVxOV+K0TlHw+gPobbyPOW+c5aS\n    7oMhwrQtXwyWktQd8ie02HF8viU/lIPBVmLeOhfr183Hs3/T90OM3wcOyJPc2ofKvdJ3Yv4tmN8v\n    PVftM3u1r2YM0nZZn73RZ7oLvLiNAQlmJQkDimUpz+MbI79LscLGBf103y8QPn03vtv1kFqCx9FL\n    ChB8xQFvAB5wGd9pjyMjKpVHGOYkYK8s6Ez7BUS5YHjHFqYvg8A9naMknC+jj5N7yjLR8ox6gchJ\n    X6c2iXE7GPtNzRJm5jAAAsfm34q0MGEZEMzjynuA9hEdeligsPixs9nnbZJyXjkgoFxvsOaD+RrO\n    z3s58HtSfb9gXmvQ86/iH0W+OYF6ad+vSEpVAgID6T08qU910/8k5hU/CvqXyyWIjz1PUFAed55H\n    fzu8UzIbOClWDb/NvNTCgeZ2GMeTp4FEpKy2Ie8SvBiZn8MJgMyfp7lnRvZXR30C6dme2ND24hht\n    +bMyjTtni84XW1kxKcBxiV6Ik5inOn7Nf69JXySV0+knv3ZVbfk7mJcJ8L/b+XhpAXJ6Z7JVvfgt\n    R9iYF7r3unJrD1ZMwWw7965VNeQ5pfMJ6Zpw2Z7cvOenXH8dk16hfTUveuuz+8v3kHWZ0sK6lHPg\n    dmnBVSqOkDxsP4G5mI6RzE1aXCVy0OcxpkpM1eEqp3rBgwc+jd+08+iHr+jxNAHNh2w+T+OdP0MW\n    SwkTeHjnfh6/eS9IilSp+EU37htqB7/Qoqoow5eB4vP4nv48LSRLd4OloKOmFQcts6SgtQw0xnOU\n    +PrH8Sp8Vc+PR/R4gc7fDqzqaC1gC8TNf11le5k9teL2ewGB79H/n1BnAf+MDj/e6J3su+1vN5CC\n    vg8AfOv6v79l+zl4LdcAxN/BX9sE/L2FPSOWALLMq/3L/2rp5x+N9k/OZ83M5ReYDt1MtplXivPf\n    nmwzv4hJQlja6z4iTGDPNHNyCJpTQM4rtzFdu8N0rCSYJQhODCdZpSwrvI+TPJXU+5X1zpKEfkCS\n    e5bwMsG23ShCK8G6hH4stjR8liS3JJgGxqFslQRo4sSIFBeDvRKIHpDXUQRScpQBQQ7cNOPFS1f3\n    s896YUJ6hWU5aD5zIAdLuU9dmzABjwwH5snuJA7MidK0ClVW5z6AgWK5LjbjpiRjnSxP9PPcjrSV\n    AXULPD/Mjs4DdU5i8zeH2dsX5KB+OidelZ8zh5O4Oa/Et1ldOlGiaxjmdz5dW05MJw69TsqkXhkc\n    PqHHZUwbnygZwPWYMH0vhLkmbCMJtEW+MtU7TKu+Bdq5TgGtBNfDdU/pbkn6vEGE34dUG7OOEjiW\n    2L4XCmh1HcLXMSkvEpYX2qeTm2e6XloqUhLFFjPJk2xuSQqLzGUrW1iPV0v0np3jbmGleotWPcHS\n    eZSsBP7Wth8DbWssalkIwAue5MnD7LkkNZnG5oT0lXzV49ieQWEWYb5Ov6ihPftJeR694TgmnIc9\n    w+cB2BWpZ0lSD76Rq3SmxLYsjEoLqTpKhnXTb4VZwGw6XZ38ZXo6swQm+zN+pmr5YjH2v3KcBS5K\n    Ww9YFB8nQDbL37JP48VW/excpUV6trNMtHjVVEJBvg8YJQ+7WT8XY64yX21WGz6+o2tzUkfJfLhm\n    ZToPXiSW7mN+7fL3H36vSu04TWyB+hbIPgfAO9jvGb06RpdUkOOOdMz8TAC9oEpq6jJzLC12SwCF\n    gA0H+hYept7kO3WZfKH8WgamkSyXGsZ7G73s43i8JLO5NrAk0EXSUoBiOQeWyL2OfjT57vRt6LLv\n    e2KsXcb/OPn4CEy/kWHx1MVcFHOe+sjBFmubmOdfvURuVBZ6uIc2mKsXWMniLI8xK+339qN1324v\n    CvMWFtfYtafCvto8S7WEuT/rPUvPUatniD99QVrMxSpU4lultMIJCQAeVDHmoC8vJj4jV9x4gCxM\n    Poy/zVR2SHxnp/oT76cVNVg2Wn7tHJ9wXWCOlzFtZZCRvWu+SEdUrHiRLMdc8yXEKV7RcRT7U+u5\n    K23yfemZzuCfnKXsk3j1QE95q3yNfJYrliTuRTGD5dJFdSnJBmM6lse3FpKUTVSMOO7vMF9Eldon\n    lbB09rKYhmPCxOLO3yLSvebrfVRjaR95yMacSz6nb1lazGTdVzbxB+w/2Z8y6J7PLP2d7mdeQmG4\n    9ul+ybf0OHm0VC4hxZvpysjb72X8O6mk5ZWyBVA9jSzch7HtcfTnMs4VUnJgGP+MI064ZItHhS2u\n    mcDyPDsjvduIjxt8efKpIhsssZ++YmySg+PPNeU/9ksM0LIUNAPHc2lovx4wM4uZsctS0E9IQK6A\n    vgMwnC+y1v48UvvXY+nW2pTqAm9pX7E/CKwXU90aBP4jYuWXlvbv2XsCgT/jtixgAPgrgP+86Yjf\n    pjWwgH9fDOBb2ufGAGKJvXfw99879q/tHuDvLe7xPWyp7DMwl35m0wCvJf0M9VlLP5eYv9JeTO/j\n    Fe0SRkqwzWGl9HtCYv9K/UJJOMtLsbChuEZNXvVG6icdYIG/j2OfEmA/TiGFrMY+jElonuMQSL+O\n    yWweM3FfU8JaWEwp9Eg8jcsUlCfYipPcHKRd6TpywKyZSgk6swPq2lIGTooyOJFDwTmsyauEGURk\n    6aY8ucrBUk9z6yGS0jq13VN/zIg50zxTr/MawBf4dYHFUp3Y+Xnr2oxptbvcv/QprWjvsuvO/fOx\n    UptJy6YJq20O3KY5HtSV0i/HetV2+tsW5OKV3VZtqj67pylZnW+RJImW7+onxhHfR65nKOxehnd5\n    zXIPYfUOV/c0fjOG78ElS2hIWkaApvOYnO6msxcG0WApuSbzlCvSj/DvIBs91HMagnCp1w0kQFeY\n    /QNAKpzG4V8JZoUZNdQz7CcGqkh+JWZRSlSnpHBqB8yBFA5kLfBTtl/oW5iSCMjGFeOgVuZpJWpr\n    8pb6m7hF7UJOlvtjJnvFwe0nYro2oFeP2TIGfa0ag5otpttd6VhhA7E09NCmm/UtbCWuRzgkttMx\n    UsteEtrylDtCy0Ln4O+RfKYAvgOYnJhMw+9h+Hf4xSYmcGIqpb4kgd1D2MqHKYklXuMwjT/8y9KG\n    OWMlJUHZT/LdAu3Ti9HytJFt1qIhBNrq7by0hxdAcQIzzS6XvOTP7CM1C0sDxHI1tIxlXjc4//55\n    5rGu5Lry9c99Ww4oWFeR2Wx5BXfrLiYWad6my67x/PrH7tl8wZN9TG+2SaA++9vEK0/sMe6N30WE\n    PXTNrmjqTwCJ4T50I2AsQLGIOksfx4mJxECwJL0HZo/wxw/jM+wCka0cwOLE+u3H5HWSgJbnSj/+\n    jodSDQf0o9z74OultqbUNe+RnkcX9SsUn3UG8GVM0D9N3+bECOZasLxYi+UugRwctvwo3wEZF1Pf\n    OXgr41lmlx6wFiNdXZ+m/f0Z2/hRfxzfNLgqppPgnipIXt4gbTur/bZ1ZhvtS3luLIX8Su9l4keF\n    /ev3O9fXYYYwIDUrxY+mskJatvmKVFIoAblcjkiUsw7jNUkLlTnyHEqcJLhLg75pMXJSqeKFVuI7\n    Oaq5giMceWOWhWI5QCiLMQ5ZD1plI1ku/e/V4s6f5sNxfC90n/3Utwb6eHmpyOFzO+1D9bFX5M+D\n    /BgGfbvxyZnPl31AWoo19FmvfZyrP8j9yN8SUg7kjHwhFOcREiQsPYtyTJe158VU7CnZJ13U/CWa\n    SgvRe/UONr/P5cJTuY/Vi5W5TFQeo+f3KF2zKxh4PozPcFHJ0O+F6T0p8XlT9eV0zVJsmrQ5hnfz\n    xBc+4orL+EsXZY4TgGdc8XX0h4/jr/Z19IcfxmOuuOA6+tj0HZXlyPz/w9n+OvrttKhrONcXyAKN\n    fsrria96QIc39FNs8hN6/Cv75fWU4+tnpJI3IANpRZHqTb3DMitYS0HzYib+bNUDjrJka7V9S3WB\n    t7Zbg8C19/Sl9otx/e8BAgPvUw56DxBYy0ADtwWB36MM9G/Afj8A8C3lny1gcGv553uBvxFW7xGd\n    C/7+5PT/S+V8NMDL7S3w9w+BPgFZUdRmt2b+Rq3FuXtAbalGxXuxc+O1z6Wf56sKpU2HfBU3g8NJ\n    UguQV/NUy1DkKTFtT0kjTAG2BMVAWl0tLN88MD9MstBSs/Co2r1C5CoHcPiMxDaWQF7AJGEeJ/Av\n    hdMStAN5cvNKvXH74exzxq8Ed/l65zlTSY4p1S2Mrrzn5DEzQvOZWiueU2JTEpWS2Juv7u3pmH5K\n    UBzGJKKWgpZkdWIWY+oX475ITT9OFl+zWeR1deVaSdDLSbmUoASEddOr9poBzPxX2cMr6XV9w1Jg\n    rVdq898lcFezmPIW+VZds4mDeQm05f5zoiV9p4cgWcJmWRaR1k73UzApKW2558eRvZvYRnLEUIV7\n    +D6w0Ot1Cvhl7gIwSR3DHhgXewypJGEiHaf73tOa75TMllCcawamms4sacnfGwZThysoK7xP6jOc\n    42SbV5fPsmO45dxKsoxr5rTGSvV8Zc4ypz1sq369fnLgt5sSNMyonLObNLA8X2QFDAvNpM+UoOb5\n    JEYPJ6mFgSAz6CaeRKp5/4ojHuh44df3o88WJjAfm36lQ0KbJS3fkKSfeWFVUsDokHj36fkrMxyu\n    nxZInAPA/exzfl+SpOPcv5bqtkfNllmeL7LhuTKIm3x8mj0njnv6nCdKNUDMx+dz42d9iQHMvuyg\n    /mWwlxnW2kfOWdld1ndv9NdP7VLylt85tB/VFr1vMvfSvTzM7t2cyc3XjAEGfc94QQBfY7kfojQh\n    yd/Erk1MG677K280ya8M/x4mCEMg5OFN+XV8u+J3SJF8Ht6Nkx8dEsaH6Rctz4YrzVoYSqm+YQLo\n    chbw0OMXDOUWxOTZkvvS/Hd8ovvAQHDUPF9WUsjYyv+9jsBAOl9/UZe3yGtvK/m/l+l+LrsWtexY\n    jfXrbdOLexKb1/pu2OClBn/TAqxuVJWSsZLfSe+SyRezX+0ntu9xeuc8TyzgbgT2hgXJUp5IfKoI\n    IKc49zA+6xLwK6UhTtN4EnukUkXyxE+KF4fM0+eLVPOFx3JFj9l1mi9WHrYxkIhxHtZ1tu/GofCd\n    SsoKPZ1j8o3DmGmfPO0kZuGFOdaiKumZF+9weSGJUXQ8CtrG51uveWy9a+QMYF4UJXNKZX3stpbE\n    sxwn3yXZ34HvRzd96/h4/o7w/Sr9+mVfkmKe3++5j8yP7uk+8PsOL3QbrnfylUC638nXCitXonau\n    49vTSMzeFWYvy4VfR3BVllpcqc79YXxuXXAeWzxgKEn0Nv6uZen4ZTr7IyT7JdHneTr7w7RY+DKd\n    XU8+KJVFOSGVsXrGAOJKzHpWd3Io/zBskX9bFSd0Dd/3ahYIXAOO2b4inideCwJ/BELs3q9I4OCv\n    Dcf+gCFv/6Fw7oMU9FzJQHAAAYJ/QWIL631sghNIW8ElfqL+/6WOkTZ/RH9TEPhPqLOAh/P87YHA\n    321z6/r/RzP8FbO/FfbdWgL6eMPxbgH+/jfmALAF9LaAv/9S/aUHXJt51/on9VmDyyWwdgn4+18B\n    qOVQGFOYwx/VdgF/BQDm2r8aFP5Y2PcB/opkebFlp16rCcw1IfjYltq/T5jLQVufpW1N+tk6JyDG\n    BH4w+v8yS9/Z/b2N1z4BxV3W/gOAf0+snkFu+WXs+2F6aQR+wWG8jglwPWGoL5mgYJa8HP5+HVdP\n    S6D7Mu49jWO84TD+3U0B9iDTNRwv4LAwj3oCfs8TFHmYGFjC+k1iejkTeHixT9eCE+USREhNJmnD\n    iU9ux0lQC8y1GC9iur2d/PR/k1fVFwfIvF8HtlbCM09Ec8CaUgMsj6hr+TBIrCWiOKHtJV490wli\n    HXbOAdl8TXVKm+Ygb5Iby1O9Hd1f7l9LUwL2imvpR7Zw4J+fV0o6pASYxe6d32t9/XSNZmsc/l7k\n    TLT8Hudi4Sk5faAktQC+w989EkzUTywmgdgPtE0YSj2kxm9Px12n5HXadx2D5x4P0+eUSpJ2MscH\n    moPsTyzafgJwD9N8eggzKQHEw2epBZwkpmX1dl4v6wXA6TRPqkrC10q2lhKwpWQ4M4I9pq/NZqr3\n    ucRalkt6tRaX9qfZtF5//nj2dmbtSh/iN6/nDhZ77YmOTYBwNzGGZL5pYUE3LSoQCWjp99eROdRR\n    olh8lLB4OWGtmb8niCCsALBSfTBJPmP08XqRlLTjkggXHCefO3w+IC99wD4yMYDZd7L/zGvZ5RoY\n    eqEPMFfJsABgaV96w/Vq5vJ95+cv+0z2dT3mYFLOJpoznaBaW346aZDoOn6p/xNyn+uNULKcQ5Ku\n    Wa4Ew4n91DZnE/Eit84dhd9/dGkJXoBznM4tv49X6mctiFfzkXw19buSBtgZyGXuWe5bmZPWq/3X\n    6d/kf3MgeGDtJO0SUdo40jH96AMfcZ08svhNbpNUOoYFWqk6opRiSH6afT0zg4d7NSyIFd8q584s\n    W/Gv4i/F70qbF2h27+Cfj9ODd+5LvRqV3ndCM4L1Pjm+xUp+VOo5Rn3YWkC41Y9a7wxaraTUp7dQ\n    TXyaNz+LsXs+Q8XQSUWK1aOOSPG2Vt4YSgolKejX0c88USEQcc8AAIAASURBVJ+yWIlVNnLW7yHb\n    dp56zxWkJIeT1KpydQ2OS7l/XqAsbdjnpj6A5DNzZStd2zeVaeDrnnyjLILU/k7XCxYrxZ/6rnLp\n    Gr099TdfiAokf6dl3ueLi/PntBZ513C19JkWq4JGlNnpuNZeTruF8UIgfe17db84/s/vS1p0xfeF\n    gXtuL2We0nGY9TnE0bmV6zrn1+Y6O9b3o9a+/z97f9crO5JsCWLmjNgf52RW5cmuqimgMcK00BKk\n    wTzP/IN51b/VowQBggC9SC8C9CZggBZu99Xtqsr6ynPOjmBQD06jLzea+QeDjIjN7SsReXaQTieD\n    wXBzt2W2TAYrhzXk3Ach7WaYf/G6MuzD0LMO7Nww2jkfpNFPNq2fPEQXZQ15GdeRfgbdi3778d9X\n    uozryYGextXmGez3Qdjgji6TzePXebKPfLUDvY7bTuPnexmvf5iO8RnKJ7gDfK94bvgr0cz3h4Qv\n    ziXxlyWziI/wno+XfVl9M1gKmvsnCsTus/Get8m++P0z/IvELatbfIP+0BeMbQi2y+O0z8HHfqU5\n    XuG+a9sZfOyX8fmV7fl9iui9UHq8+kQD/UCDmmyGRK+UjE5lCsu2SNT+LXFcT3VjK5PG2P9vK/r4\n    S+G2/7DymP8nY/utSODa+7wGfpc4579ufO6lNYAfVgJ6z/V/b0H+/i+F96+U/P2b0t8/yFUTv0Tl\n    RPu9yd9c1q9G/vLfFvkrcS35i8iRv0TXk7+8/cXoE9+/0Hoozeb9SnlCPweeKH4jmemrL96DQ50z\n    fUNNYAd/EwXylhe0GI0dMnKJvgky9zAtYoIMtM8i9IvtnuKs3wOFjN5hPCe7zoNTOpb8iusuhQU3\n    Ziphdi9Kb7EDHzNk2Ak+wHFxdjGZ3yo+c/xXShZ5vhjG7cEtcIF/eUKLWVDSfYxufMzywGzRUMso\n    5PJgdHNYuA+z68KFv7yGlFNB0rShjlYc7azVrkLnyfx78a04c1dms/M2lMQMUtjxdze/p6EPGXGt\n    1fyVx2sOlLmLXSMdrHABrDfJNayG6dwO3oenNtQv5MhrlOwKz9gw/r79wjfU+PWf/DwtuNElzTLP\n    l/GeXkZp95DV67OXAn1/Ge/McVx4s6TzM/VQ1iB8Mz2xs6yfnhuiYXKeBfI+1ApkR1L8/cy31UKO\n    o6neUnUL++gJtfbHvbPs4jnT5xJyJefEtqQoc/enBltkEiPpe6Z4PE59N1r9YKK4HjHLUnKWb5xR\n    3E3k8TPNyd8zhfq/XFcQs0CQ/A05IXHgEzus+/F1nM7Dmb+xBPRhtG7BtrrpOKyRiA7rWOIwfAZu\n    xX/Hzm9pC+NxPGwP/0dIYnP+/aTBucwXpb3MQJJZMli7Fx2f6MjGjJqYNgw1fTtx5eiIiuurz0sx\n    lEIex/YUa7BiS/68sb2NyXhU4JBObXZWM8mLBG/s/A7vMQNtmPrX673mPy86l+f3QOs1dtXrQVaB\n    fJSEfih1oBHCQYMj3I9w3GWytxcKhPeJmJJi6Uo3tT8SjRlNhzF/qQO3OmcH8y/al2M4j79fGnOr\n    WDWD5wOcIRy+i45eJ4c2P4/hO59Lks/z0e3M3bBfBh0EOcptUFIjGJGyo0xiskNuK8WNstrz8+u0\n    snB5HZe63rRKyVwlag3IcwbbGpRdAlk8nx3zmvOFuB5wbKdihY25ggaSv5zFi8pT0sZ6exba87FI\n    9p6mtiGYJmQMx+vQEIAcq1Hx7xtJQKzPHgq0aFYyHIt3ihHG2hg4/9GePrkmjcNp5DqF+xxEexn8\n    pI/BvA/JYewjrF2cODYOs5G1bCUBnQPeJz7XgYbouwjErQz0DfZTy/rleRM/33y8ZjsP8FmtdWm4\n    9zI4Pf7etH0dDep+a615gaPxu++ibcP07Af1KPwOwzcQvs8QHiFLE7Ht6qaWw6RIxYG+HFDMVpdr\n    AIf51IXO4683ZNsO4/uOnuhCXOe3pzCSsO30dW7dWGLIjaoAPpP4PH17bvKZ8T08EAbnxGPwd+Li\n    EGE71+o90XU4k88qrVU3TElBY31hCa43LKFl+75QfVYu1/nljN43chMJy9tkLWC/PT6OiMfPYdb/\n    J5qTwN/G88hs3m9wfiLv4/5Kwfct6wLz8V/Jzvb1fkzbTn8lR1/J0e/pMiOBURIaM4HlPgnZFrN1\n    f0s2Cexz5MvnQMyv/BX6Zy6mhAj+meaEr7btfyG3KgmsZQHfErX3uSGJbQjgP17fxWq4VfbvLzc4\n    j0X+/px5X4MtyF9L9pnoPpm/JTnvn42/GZL8tSSha6SiXylMDmqkn2vwttFzuka/SAZj9u836qIM\n    YSt7mEiv++trUoS+eDvLUvEoiKQnk7uc7cu1A/lY36qbFt0nCqTvkeIahrwwDnLSgezlLKfztJiO\n    F96cucQL8CDh5R3avMDmTCVeeCPxy9t5ARacYJwFHxzZTGPHUlxunPxz2wBcfEnpSy1jFyOGndIH\n    gx1oqaeKnZTnybkQnJO8n+vTIoGH0dmYwYufLtRgjYlhJMe4vuwA7dmJiw6d0sxfCf6uiEKtTHak\n    Yk3nuMJtcLYEojdETrPzXbob2CmOVxMcGEhOzK9Wc2Tz989OfPkcyE8qv395x+Q97OG7khHYWPGa\n    HSAE26R4Jy+iMdN3iJ6bC0TdX6ZcoH5annPfPV2Iaxtyhsxl/P0G19YwLm0O45VzFsOBLpNM1mn6\n    zoK0JQtgPo/LIv4+DxSI3rdx/wvFxC9HxPtabeHzY01C/D4deYd0kLmk8fMMkxMx1DgcwF65WQZT\n    7HSb/xZKpDHLHb1xlo92jH5cPWr7qJ1tI+mQqufYi98fXt/BbB/soyR9+ZjvcM3yWjDjCccYbBuf\n    O0hDs23k54gzh9HBHWoS8tjXTTKtrJYRZ/4GRzarZPhMKC61wGFSwdkdO7XjoCq21x1hZnGQqkQi\n    GGs6hkAbN90v/vwYbCUJ3Fiacr4//D23pVaIhBx3KepT9hFDOpL9ZxnA3snnLVwltsHcFmyHlFmc\n    /xK3H6C/eN4hHejzz4quVSTj41wpnWRHeuQytYjnKbJO8ED4Owxu+SAL7GZ9x/c8vDRCY56VZH9v\n    8TeTfhcHsIVgKEdhTuWmvfIbusC1DtACM335ui7QB7voh8kGXsazHce8Jf4sh8neBTvqa/ce6Gmy\n    zEwGe5K3G+0sCnMewF4OFBy0YU5FY33VOICPx5EzDZPt9UErQ/Qb4N+3d47HwUYa+RrL3cuas6EE\n    A2dDYW1grTxDeA7lXMmJ8w5USgSX2lEr23YLaNdUShRTor2d9RtIX1nT143bwrozzt6V3zH2Ecgd\n    RGzr2c7J6+M1JpYoOsJ3wUFUzxRsrSeRg+3j9aGjEGzF5+S1aKChwvoSg6tYPYP/u0AbFGhm+80B\n    ykREQUGDc+hxBIyDjeO1TgiXwjE1BCWFtrjekGslWSZBrkf5GIsg1VQ25mu9+D2PrbwuPVBsx1Ad\n    I5QmsFd78WgarCZfB5PmR4qDkfCcJbNYtHl4P6U8N85v5skMbnoqwpnjAHQMRCboi79Lls6WgXKh\n    rb7usJSp4quL5z2prOBYBSv4APCbwStjXwIHTsTfaRe16SnYzWAFWdtmmOzfeRJ1Ds/U02gBOdj4\n    MH7yfrQh3pZ5bQw+2ttSfw2f6EJvxEo9nlTmskSH8XreRjv8MhLLRDSWGOqmLGcuycDjIWeyvo3b\n    X2mISMOBcCz3gcwcmOrHV1/Pl1tjPWAEKwdqtX2/wvWl6vjWSk2vAasWMEpBr13DN9efRQIzSuWg\n    l7YnShPEiB+JqkjgFJaSwD9RfU1gDX8j9+5I4F/odlLQfyFHP9/w9/kncsks4HeM22YA71X62SJ/\n    18z+taIuriF/LdnnWvxEVF3zl6isRq/W9jfFR81Rmv27R6RI2lztX3nsKXovHVnhvSXvLN/LfSfo\n    SyN4Zd8aeGHew3vEdwoy0JqDwI3b0YkXMohC/V92tJ+oo368l7xwf6bgzPaT4pApLMnfYaSKefvT\n    tAj3xxGh5HM3LeZ5ec7ZwmFhH5aPIVI7OLaD4zk4AjATGJecg9gmI3MdbJdSwUSxK5BIxr3yd401\n    kzSHb0xWxe4CLao3JhbxE/vv0vcpM5X854oXdbKebDctMGKimXvAhb10VqcygGWktay9S8Tkp/wu\n    3OyY2F0QyKBYakvGnYdtkvANUeXxHefMHvyute8H95GxLTgu5o7qOUHMJCaNztsQj+2ICPMF48zu\n    OGu7GzORQkY1PyfssD4Qx1rzohodVxgFzvvOk7RtyPLl3tx4NhQZdcT5S/4bPEznC8cFV73MFOa7\n    HWoPD3BvDnCPglRkcNUMNIwZPcPMqWw5co/G3/zemi7LrCJ8tkukKsuJ3cE8TqI0i2errF6ElgmU\n    Ol+pjGUcCOBMZ3dJRrbcxv3FNXw9OAiKVUM4uICP1UhUzqjlEgdsK4ncZBNRIhpLJHDt35AD6C0u\n    S1ayAKy344EMxkCpnuKgKcxUwnYy/AMdn2gX0SkacnZCVhN/XknKajaBor7KviN2GF4If/EuslnY\n    OxFmsASnqsxziYnQoLAQk36ybchmwgxkpvBwBhKIZq0gwTxoSJ5LEucYoOXJkHClSBzEst14RaEv\n    Td4yECjxeYK1pukYlrCM50TBXoS82mBjZVkJ/J0elPshs5rkdlS2CPswN2k+/8F5EKqLDFN/F7gX\n    mAEcCF/OSQuBWZ4ewu//OPbzbZwTP4+f9kQHOo5Pji+hcBj/5gCFkB/FgrPdGITVTdcd28kusuAc\n    GBpqeYb6jGG8e5qCssJ8jIPC4rts2yQ5zkr1DcxSl4RvKkvVjXY7XQohRgkhnK+Ji/0tJ4Rztjp1\n    nprrlffCUgdJ9TPf55LfDV63JJNDhjKWVQj72b7ycxlqB7soECwoZrgxGDjU5mVbdZh+dWiDQ5Cx\n    zObFwCj+Oy6XEJPBRB3Y4BBohQpU/GsfptGQKARkISE8zxRlIo3h59zxSMdjaLDFmuwzkoT6s2Q9\n    YTJIB89urfWwXmzoRa57XBR8fImODTbzAHePx6kQZBrb3vDNB/vbRVeQhgxIQxKXz4vzFvQB4HfJ\n    NpbnoZI4xuBp/N6Q7A8BUs68RrxWtqn8XiODWYVCBhLz/Z+rlcTfMd9jWUIjXEXsOwhzqlCCAIPJ\n    uXVQacKZm19BHiEYyc/xPCHb00BHCtoY/KlOdJjWflxeyH8Ph7HHy7hu5fY+8eIARC/PWE/U0Qv8\n    QkMQk7e3RwrZ4cdxfRlKOfi74bOF/V3gdWEICeum60eEesDxtpPShv/G0AgWx2bfD2cXc6YxjX3F\n    7wMh7MhNUtCnaZxicttFMtBIMsuavtp765fIvtdcTeCaWsC3gswMRpTWBM4pFKTIXSvbN5UFvBQ+\n    ea6uJrAnjdetCbx3Evj3VF/O5L3i38gtkoH+91QkA307AvjW5O9fyNHvb3CeW5G/f1fOU0P25rC0\n    5u9PtJw4TuE3ldt/XP0KPGT2b01Gby2+L+jbiuCSff1DTHlTtX6l1LN8X0r+EtGMoM29Z0hC2Nqv\n    bT+Px7lpgjlvj4vHQOr6T4ALal52opwRZgChNOQz7Md6SLzw4UW1j64MNZm4HhNm/h6oGyfNvGwN\n    0dMddfRGcX0mJoT9eULdRHZu8yKBYJGOzm2+J1ifiekpXnCHaHMPrr2EEtH4DMTEHo3bYtoRwVmX\n    c9ngOLKXF0GcaRjXrwsZHCjnNK+vNKek+ZPzfl6uHCh2bqMzlO9e7B6VkpqxAdcygnU5yJhsj93g\n    4T7hs3mB7yImEML3jAQxuqiRwA+LbIK+4+8X6dWwLZbAxD6CDJk9zs1dKAEaVR0fy8RPcKvI79VR\n    qJmE2UBhER9kKfn75AV4WHzzIpszljjS2btkDqNz+hyJVMYUsydveTHKYnUDvdGBjtRPWfrsruFv\n    CUnSM3X0Mj5d7Izm77qHu0IUnCrD+L09k4+iRkcxZm6iVCUvfllNgX8vISs3fJ+4UNbqArN0pLZv\n    ngm1fDFhZQbz51jez/bInbMnZ7aQ5K6D3zcjlmF20bZclpq1jbfHmcJsE8N1BQlKtIt++/fIgRwk\n    oy/kYKwJGUsy4Ikzl1gRg7OimCjuJ/sZFDPY/p6m32pwSrON5JIKfGVn6qbfZ6CsHPz24vexszIe\n    wwf4xGFM9pBlAUjpQYL3xc5oFznM3EhmXeAcDB5xsP1AaEelczPYxeBkxU8XPkkI8EI3ZzgH2mG0\n    67LOIl63Po/AzxPfnQ62YxkEJHUHOA+H0cXVfMO/MVkfjg8lGrD/YJexbqEkHi7QG+/D0glYP1j/\n    1HiFcTaSRgVjwJokfedtcabDM0j5LQYZyxDIxORFKBTCEtBoizk7aRht7DP142/d987v+ft7op7e\n    qJvqB/eTffHWNmy7wNwoUFs9eUf353Hke6O5sgYGkDJBwY53dMrGhGuw1efkNv5OPXrx++Xxkp8F\n    rEOMdl6Sln1mX3zu7Z12S89ZIu28FNYakm0XEdfp1ch8GYymb+f2r/BZZDC1tNlc5xcDjDnj9w1s\n    IQdHIfnrtwdbiE87rvU4OYJlmjGYOBDF4T3vZzvrwNZ61alQF5iPizN+3dRHCFLtpqcdg6ww+Abt\n    qBx/cT3UE4dmBYRPaxO7A3XR+3kbDr3Ug7FwHKfolxn0DlARSco4h3IKoSQN/z+UMsKQqyCUze2l\n    DDuuU8PnCqucITpfGTDY6wJ3rp++s2CT8EmLryKWdMb61/x/VOjgudUF+sJM7/Ad8jPgonE00KXh\n    GEf4XEiSNjWvuoj2+LwEUh/LH8zVweJK9eH5CjMCtpHx8xDKJYQnYJhaHce1pA/2uBCTqyEb1l/d\n    0xgwheUPfGATr01pkoM+TEFS/jfrCdrL6A/ytoXtUUfB3/g82szv5CIbxsQzK1z15IlBVpjqiUY5\n    aQ+fhYs59uGbduSmtkjUInJZvDVZvlL6OSUFLUngbry+77CPs32RBH4Z79kAn/E7EWRO+7rvR3gC\n    pcQzk8iPRgIjlmQBXwsme2+RBbyEBJb9E5VnARPdjwTWcCsS+NZS0FYW8B9p+zrAG2J9AvgR5J8f\n    nfz9U0VbojLyt5YM/htdv5DKkcW/Teyryf5l5DJ/l/RZg63JXzbcr2I7Jd7LxeSr0uY8c4PF5K98\n    T1Ra53f5/cAFsyX9fIYpuSX17I8JRD1PID/B309iH070Mcr6PH4HKHFJFBNsRLIWk3dy/5O85OSB\n    iH6lA71SWIiz1CQ7kZ9hQe4zgAP5exnJ3+P/7j/QU3ekkCfoqB9GGa6hox94sTR003UNw2FaKE0R\n    2ENYWE/LtnHb0/T5utFZNrYZ5hHY3Xgf4zp2ji6DGwms/NMRsp+sBXlYsIVjtP4CaacfP4xOFH2C\n    MC3aHco2x4ttrBeLBHDn5nKUfG7pqCYi6v/zn6n/9bt6/vS9Inr+40/U/fh5/I7ibDEG19ikISYW\n    +H7zv/zETccN4W/MeCJCibr4e5PXyksyzRnPi6RU9HwKWvZYuN55LatBHIPfsd8fvl9cpDsX54kH\n    V73f5x1LF+h/oMEF0nYY2x3GRTpLUx/cZZKLJDc6v3/5hc7/5U/ETwlnIrFD2xGNi/RwPzsKjtzL\n    9Lu+jN/9MErx+UX8iUINpVjal2sVs3xv+LzsKD7Ae7zjnIlygGPoDNkyx3AuCY0glvsOyrFSdpho\n    TkxiO4mc5LOj2KmbkofcKkRSyxLKST1zm2OijXQGp86H5G+v3DirL3SQ83tH8vuKxyk+3zOfa9zP\n    NpODj8J4jKNMyPTl7c+jM/AM+1mmku0sUUdP//F/Rd3xOGb9OuoGrHE/uowHyFAy7OWBwhzgOO4/\n    KnaSHd00SIexdBfOXY5HwkCNNEk4DPrIGj55TADHbZRxEt7LZ8W5OREYI9C6chwmigOvoqxfF8gs\n    Pg5dfkyg8vN++cdXOv3//ja73vk9COiJ6OkPv6HuN5/hPKEdn0+WpLgM8TyHv0FddjL+tHOkvzuc\n    y8rspECR4H2JCWDtnmvfncxMwgwz7RuWRDB+jxeiya5Jm0rjPpnNNGWquWHKMvJ2NkhDH2ggcugm\n    H22rC5LST3//K33/lz+PNu9Az6Nk9JnYJnPZhJDnxCKbcfBAsGvfqaMXuozOW/+dnsa7zttQRSNk\n    5s7JwdiW4h0V22C87Y8hgIad6/NsYJqum/EyOsI1G6zZUcs2puoVl6LOVsb3ykIJ4Vtz3pLsXFZ9\n    0q6hF0537djzWQ/S0ZQ35uo+3pbIzF//d9wPB+ayjQwWNy4dw32EVQATuSgT7fdhaaIzBCg//8f/\n    luhpzPkbmGr1a9LD6D9gsvc0BNKX16CBBh2vc3DTehLVqHj9SRSvWcJveHw/hDI3DE0aGINocBuJ\n    41KwQgmdum1Q2zI60qtaol3kQNwjrF20MjfTqsYFijUex3HGFK7m8us3Ov3nX2jI/PY0XMjR8b/5\n    7WRPn2Z3Z56pO92rAW0ZB9fFfbNCTEcU2eD4GoJdjudP83m7pZYiR2ZUH5OfJnyq9HfL10YUz23k\n    OI52ciBvozEAeSCch6F9HH+1LgQBT5S58//24/k6x5bOr0Uv47ZJNcpd6PL3v9Pwn/51mr973xOv\n    KYlex+AqpuCDdyko3vl1/iXK4O3h2+H5FtcK5hW4DGbjYOQj0azeL/rxBvgbM3+lcqCUgg4h3uFv\n    Xpd60nuAdWq4Jk1KOgcvoR3LU0uJZ6sW8ADbX8iTy9juTN2MBPZy2uHcTAJrdYCpYttaSGUBrwGv\n    6jmoMtApbJEFvAQ/kZeOliRwDUpJ4BLIzF6Lo/qd0f6jkcBbY2kWcAHWdW9p5O9eM38tWD+WpYWz\n    /0ouS+7Wkr8SSzJ4f7ri2PeINcnfHKmL2y0yWIvy0rZ1mevOST9LnKZJ01x+OSf3XCL9/BXeS0JJ\n    v574/OwE95nAbpKA4f38H//N7fFeu+lYP5nlOr8su8WLWL+NM3r9Vl+XjMAJTZNzGuv4nidCOERS\n    c+bvmTr68X/8P9DxGK6ICBzHQ7zw4UWT3I7HOLGt5GkOi/Fcq8fGULCvK1jcEUlneB5f/2//V+r/\n    P/8lcuCmgIvdp//hf09P/+1/qPusyvcVCOB55lDq2yv9ZvPPSD1q73OqNRLGsn/ze6b5fs3Jg0EB\n    OQfB6f/7/6Tzf/m/jIt7ri86jNHSHBDCQSPDKHuJ2dhucj5zZrEfh30EOMtSsrTWM1wxk7xHijN6\n    vfPYRyJ/h/4PROOCMBx7hoXcVK/p7CISWCN7NanSsK8sU8lfZ9kzkXKGa33PHfbbQpNmTqFPjteo\n    TpH6jAHSIdqTd1rzfZLEO5POLxRLVfL5X0R7llgO144ZTN2YdRRI1X567gMRy9lNoeZfUKXg8giY\n    seRGp9WJgmrGgRy9/k//M3XPcehgcGN54PjFDmNpL3G/hDy+5JhabDHGrgUcq/WALXucleOm5Wwn\n    Ijr/y3+i4f/0/8heTyf+fvnv/yMd/7v/tXkOPE9qbpQPTHs/39M1iD97bCetc+A8a0hsi/vQbXT/\n    X/5fdPqX//NUZ3CYgqKC4PpAQUL+EOVUE3H5Ba57eKR+yqxkgvdtHIlYxhGzfn22ku8JydOX6aod\n    OLyDHf1ONGs72cazJ4GJYhKY70/YHtsttg0YyIWZVESSwCSD7I2fW6tu8drQZJftLNs5ajxY58xI\n    XGJHrX6mYLfzvGYwr0f5u0JlLba1vJ58I6cGe7FdZXvbj+tOzhbmtTTX8vUEMQYgI0nsn/W3ca16\n    olAagdud4W9HHb38j/8zuZd/F31mjS4jInoedPvplGPtYOBxv2KbU1gy+q45ZpeOsWutSZeM6ed/\n    /U/0/T//39WyAebnGv/tydGn//5/S8//3f+m+rzafZZbLsZvMHXMYyJ9V0Pgcb4Xud601pncp2VP\n    nbC8b//2/6Z//Kf/I3FtZbalTPiepkCqkKyAGeyHsc2RuGyDr7P74xRijHXsw/j9Ol7Bt3ENwPYK\n    c7Z5vXkgR9/GNhyQip/u09hOWxtqmbsn8TdnEFtkskUC49+ncb0tr+FEenZyDlY9YIb/huJ+sZ7v\n    27hO10hguQ2Ps4jhshEija1J4BzWJntTWcBE69QDrskCJrJJYMRfyWco14C5qxQR/JFJ4HecBbyt\n    BPSeyV8t+7dG9rmk7V8L7t+15C8il9Fb2w5xLVF8z+zfpeSvdpwkZCXJ+2psJ6VNahtnBqfkQLQs\n    X5lRjO+R/JVgqUfGEulnmf2Lf1vEMpHP/mXyV2b7BmKCQK457COKF/jfyU2TWSmrRRSyf1+Iox39\n    YvoIi22sn8T/8UKdo62DHBZHS3un9hs7sz//kegQC5A78S+jJKp9Kd7HYutx4Z5eaKDDFJlLlHZi\n    oAS0+/wjdT/8u+w5atFd38W7Q4lTf8n+VDu5rfv0WxroQFxllGWxXkZZS45sfxrrIb6NLrzj+H4Y\n    j2FJzW4kblGmmcbF89tEDMaLb4bMTkIHcmo84fEXncw9bOP3LM9OFI9PuUwlq24hEpMlTumXiraP\n    SPxqTmCZUW3Vr9fOx0hJPvM97o2nWd7LHmwbZ/WG/4fzadfBAV7s1Mb/QkaxtKM0/c0O6if4G8nf\n    gR3fn/5A3ctci8YZf1v3reH+uHz+8yiznx6X+Tmd2n3+gQ4/rrlSargGJbYyta9//Yn6sVbhMOX8\n    dqOiRhAix0qCTG8x2NEdAlaCmkY3Zv0O5MbgWB9chcSsJCwPY/YVrw+QWtHq+CLxOR9X4/EZs4FT\n    Y9NxvFs8H0CnNK6HuI9UjWCdmN0OtZm+NeT0kqzf3PGaRHQcHBCI39x1aWoZcU1gXWWD+4gVqYKi\n    RgieioXPuSZvqI/JEs9cHiGUF5rybD/9gbrXMg9Xjf2snX8323w93Ke/0gFWgV2BA32AZ6v7/MMm\n    61J/LR8HW646igL8X//zaO288tR36uhptJqOgs+M1TRotK9H6qdEiCcaRgU5Pxpj7XK2P9L+YaYt\n    rxU5YIqzgDFM8wko35DZ7YF+QY0Ejter8blqgor5PDID+Q3ea2Qz+zSZCJb1fK3awDkSWB5nAQle\n    3IafBX3E7LNGIlgSw9xGEro5kpf3byEDXSPvfKs+1yCBa1GS9ZsjgdHK/0n83Ujg+5DAG2UBr2du\n    ZfbvRyJ/f0frk78lWOrSWEP++ZHw60af5zPFJK5G6H4bI9RSxzE08hexVu0GJG01QveF5vV98W+t\n    9i/W/+XJTyksuWdL+llCSj9rUtDoHOd+Hfx9JjfWGPSQDoeYDHaRoySW4wrVbtEBzjJcfprsz3Og\n    4OBmYvg0ZvhytPWROEshyFwedvb7/MgI0qVe6vs8Vs2xXpwXGgQqG/YCdsMNY71Rdsz1ozvmLN7z\n    uHEGsT/O+uCAEqKQQXmeAlDC/kCoOViIu1kfRH6MPyqEYkpymNGPwStSLlHLnunhRaIPZ+yL+9NJ\n    xQO8tG3Waw2UnKdPfDa8p/idBWeIm2yY/D61eyT3xXV02ak8/wza9ejPQ/wdxDV+OdPXK2M8U3g+\n    +LnnZxWv7wCualTQoOnaQyYCS0eyfDqNZDBRqH04TPsadoHBjURfsJOpV2jbsC+4aIw4THZzLJEy\n    KRCE8YSzGtE1zmVNeNwJtVWDIsFxIs2CbcXxTI7tDGlbicJYKu2mTjDG47Mcv/nYnK38Tt0kk8/r\n    Gif+S6UB4DluYUf53pWcK3d+Xpfl7pFmS1NzFG3bm7A02j2V6hpEYW3N29nOcWkXPh/LgfL5cN0Z\n    Pxs4P3IRMRx+N0gG+yf1PP5m3PQbCWWL+jaG7gocFsqvS8Grh1cLC98HfEAJ+yZ8AkLQCouDRsI4\n    09H3aXQJNvUCPi1cB/agBvRKYW3jawDT2Eb3CfJ29OnJNpwccoS/rVJxlNgnk0+W+CyfKYY8t1Vm\n    z0q6YUWIN+P39rbi71CWH0Tf9KfxJfGNHH1Wtll+cvx3C2xdArI0iQ3bbZlUZ+Feoa4ar/XLjWzF\n    gRz95YZ26db8JpEngWvw7/NN1nGP3Jv8PdB9yd8tUJL9ew/cI/s3ha3IX6LYaKWMGsIif9GAfic3\n    GVit7m/Ztc0ju76To7/Db/qkTCx+K94juUuUrv1rkbRnctM+njyx41ebPFmTMm0C54zJV4z8MxA7\n    Y5zIpgpOAJS5RAcBZkahk54dI0HCMiy+v4+LJf8+TKg5awmjr8/jQvtpup6GPYDlT7vov5S7uhNU\n    SsNewDV8A/kbHG6XMSNDSvChPDxL/Z0gqITGsZZrqHJtJovMw2thh6R0ApcQiGdiQi92qmPmilWT\n    Nuc0LtGlQSI492uR4/ktMn6XnDPkuQbCNyU3qUG7H5fMfeJnQF4nOqDl57IQJPwCsXEan3msX34g\n    mkolMFGLQRBPU39dRPJycBX+VpicwezgoKzRsBcMQzc6JsNLC6KS+y9DCwPYG7ppTOF5dZhfc2AI\n    z6uRFDtDO3ZysyS9z+LxQSvcisc6Lv+CJHHIvLRhZXbKbWjLJHA7nq/EjkpbcY7sSiCES/DodhTv\n    x7ng+rT7U3Jv5dwGA+s4MEHabu050eztgeLrkkFWbEP72fPnxkBiitajWLv+jQ5TsLEXP++iX08/\n    BiZyANVlGk+bHd0XgkoKwdqTki8OcMeAgob3DK7BzL9zLqXiYFTg+bdfIwTJebavMrgEA1cwGNQK\n    wOH2vAbFpA0cm3l7SrXCUlx4IpvElWXoUuQxHv+s9GX5R3G7RQLj+5fEe38/g7/1DXzJiG9UD+mD\n    lv1+Mo77bGyX7dGfbh1zLbbkA5aihjORXMnSZL0cCbwVv3RPEvjWpV8lz/lH0svgrolaEjiD6yWg\n    H4H8vRVu9SCXYK0oDx5w1oxAISL67fVd3Bxf4fu1nIefEseXGELNWJeQv/I4Gf31neJIsVeah3fI\n    7yRF9kqcKp79H6ZrTJO9/P5EcaYuQRvZXusr7tcDnRqY+ctS0bJ/iV5MQnsK2QBEIcqRI6oPQMig\n    M9pPXLkuMBM5fvLs6xj6hfmB3LQcHxr5txsMQzdGTQdoklsok0QUYm8b9gOuY3oY3W/DKF7jiIlh\n    GusD93SehG06Gkb5ycso0MdjTjdKZLFAFm/z9Qq9HOFAXm7qTCzxzJKFXt6SZaR8rfNhkjM8Ttcb\n    P6s5h7cFTVKS74pWAzhkvnqciWb1iUi0QSnGlKNA4h6jLTp5+8j+6fdOykDjPutzaLV+a65POm3Y\n    ScP9MAnSEwchxFlxRCEYgSXR2I5yxh2S05fJMe23faeOnsmNvwtWSHDjL+Mwhspw7c7DeE1xBnDD\n    fhA0VgLSI4JHm03tDAOPG34U6Uc5ZyZ8WQoaq48OY27wYZS45P/34/jCeXFEoTZrRwM9k69r2NFl\n    lLt0YwkXXyfxbTzP69hLkIMO/UG18ekjaKUQLMhxW9YGpvEs2A5tqRN2FPehWpK/rmGU6QztS3Gr\n    3xnaJZwT4Ha5pj5TulwCHn8wtlPhdqLY9mrzfRl0hwHIoe9gG6Vd9efoIrKXr/1CIXCZ16O8uuS/\n    fX9Ysohnkx38tjBQomEvGKbvm8YXj1M2Qq1qInrgOvcNNfDz6CfqxyDKUFyDA1lotJTnSSzawbGs\n    fuHt6RMNY/DlZVx3dnScqtX6tWQPtrUf18PSLp7gCsO6Ndje13EU82UbQh1fxJPox4JOKg9RP7gF\n    +32etbalqDUpaF57v1C6yi6rP/xNbLuMfwe/bywlTWONXyK9vq8GKRldepyUdWa5509E9FXZ7kng\n    gX6l4Hf/tJLE7a9j3xK/gXu2FP8gRz/esZZxDX6mvBx0Dpq08xbHrIUmBx3j3xPRv9i7r5vYfSTy\n    V0Np9u/aP4Z7pfgvwRrZv1b939pon69G+6/kon0/wt+YzbuE/EVoks+vBe2+Zz7nK9GM/JXIEfJS\n    Clqr/avhmWIiFsnfUhkVK7M3J/2MUdZatpS2jRfaXC84dnSHfbIWIhLCF4qz3EL9QcwaYOd0yF46\n    j0QvO7FRko4zm/oxSnu489jWsA7Ct52W3OJ93JaoawvtvWHgyHs31gJ2oVYphYykt8n9FuLyPVDW\n    NmRqsKPwNEZso0QiP30oJYy15xAW6ZfLpOHrd6JvHDOPxjlz0GQzJfhcb6Njs+QcWmbRmq8UXsk7\n    Tb6Pr1SdwNL7ZZG/QaJ03v5ARDQ46mGcQXULhAxHwf45M4mPceJf/2yGDCXMrgvvuynLvSOa6vnK\n    34Y/Nx9BU7YvETuigmxlywDeH4bJXsYlE/A1TM8B29X2HOwJ3rXJ40EIqDzDmOEzGuMMxzB+BGUN\n    zvxFCfoBgjtZ8vkI4xdRPB724/zfIhCxHf6Nlc2JiHoei4f6bODUeWsQygyEEjUp3NOOEtFk83N2\n    /0hlc4kUtKxfrdyGBH9P0j7ytjeaK7bEmcEhU47trYueNZzXoTQ6jVtixZgwd6TJXqIdRVWaZkf3\n    h2FwpJcbsl+4dm0ZwHuC/245w/cyzcHD/JrLJBxgbOEsYJ6nsxKPhxuJ3E740YI9eZvGmqBEweMq\n    +/YsdQorWUT+bWXz5pJSsB/Nv4i1f1npEPt6VvrWfKgpn6sG6cN9FX29KtsQqDypvdf65XbXQEpI\n    W5nAKf98LbbMBN5K0XTtJLx7QnJjt0yevDUvqPGe7yQTeDkBfG/y9w83PdvtpJ9viS2lmbfufy3y\n    F/GZYvIX8Sl7dB2srN+UsdUI45LsYa4lgUjVCZbHEum1f58pntiUyTUHSPkVd0VfCJSRwToiJTmV\n    6HwIhEggUByFGr1vxLXHwgQXnQFYz+ltnGRzBDY7nPz2bsza8+7wewe2NKwHNzpRelg4aQtsdF43\n    x/VeEWS1iGh0wvjvmp3Xh/E5QWcdjxdSWUDK6jJ62IdkMC++TxRqlAfHINYtDAoHPP7VELdStpAh\n    HajSiUrwmdFZwMdi3cKck/gaR+9WOJK3198L5t1Yn1GX59ZlQ2U2kFbrNwVLntQ6/xsF8hdlM/k7\n    eh4/zUVcq5RTlX9jRnDQxnBTcJR/jrrpeWXxV5YoHMYxt42h+8FAgfBLyVZioYUgX9mwF3AGGxO8\n    Qf6WAy6ZzEWJ6GB7g3RuGDsuhHP2OWmHeCYMrgpj3oU8EfwG/c4VGq57Fnk8RxJYk4W2at9KO5oC\n    r5kezY7y59CuS84LrFrHvJ6zbKlcBy4NYJPXdoF51ZtCsqO95aA+zgzm4AYkGLi8AlFQmOJjsdZv\n    KE8UtnFphYFC4ATXeB2mvGDe1rAXOHKTrwHXnqkXllRo9nQfcEMgddl++nrAPEqEwKoTBSnoeJ0W\n    bKEvK+RGf6Mfhy50oKNhi3CslVm46GfEwGSZ+FGjk+bEcVIKmkgvQ6cBj5V9SbI3VwtYgySEsS4w\n    QvP/aj7ilJ94LRJ4iaxzR+UkcC0RrHEEv6nq4T5YkzdJJQtuXWb0nhxZI4EDErWAlxHAW3+wEvz5\n    jpOQrR/sLX+YrCm/ZJC5Rst+KbQB+9eEkcht/4F0fCZb9nkN/A1+aznStpToTfWD9X1T5C8jVXui\n    pLbFs7Jfi7RDwvcr3JMakhcjBGWUIE7G8F/NkcHR7uyU78mN9zTOXuOeL9RF50HC5JlCJrAns+cZ\n    S0zmcN0VJn3Ysd2Nk8+24N4PLkM3EvzslkSXYXhhJeADodx4w14wDP47ZacaZ/8yacUOPL+fo6cP\n    gqj1z4TPcMLAE0efKDg8UZmBnYgWMUsUVA20mudE5c5rKevL5yqtx5dzNmP9wlSf+Fm0/67NBkpd\n    v3Sy82+bs35T11zimC+FRvxi1i9n/obgJs1B46JnA2Uq+Zr5u2YbyMdidjASE97ehTrAvFjriJ/Z\n    4JDnZ/5MXUTa9JCldJyORsLYTfRww14Qgqc0FQ35mkjhpqSxK4TcoW76rQ/w+x8o1A3ncYKd10x0\n    SclcopAFzHYzjG3BPsvAJTfO1aS94/0vFGxRUEmYqyvIYB+ZDSxRE9STQs7enMexlu/108Z2lChl\n    R+cBYBb68bpz68oDlc895HxIyi/n7rScDx0oJprxmSQKJRb4GJz/cUYet/9EvIpA9aq5HeW62UG1\n    Jfw+fFsORA0qNbIcR8P7RliF+KelFy9W0MAXhy8TdeM6pmEPYOI3ZPd66/o2WjdUykDiF4NJ+umo\n    eK2JQTgvFIhctjdv49z9SDT54YjmAbLcxsrQRfLWjetgLQs4Bez7K3VZElfiKdEf7z9RqN2bqwWs\n    QZLAuYxhiVpiGPdZ2cJrQJLAEj8U9GH5/rfKBP4HuU0T3LZOzluKe0k7L8Gtk0TfIQlcTwBrH2jv\n    2b9rYg+ZwzlsRf7+Sq6a/GX8QGlDsiX5W2M4c+TwN4prNBAR/V38jpn8TaG0/u+vFWPEM3lpFKz9\n    i5O0VJQcQhK6mnyLtVjX5GFk7Sd2LBwTx/Nxoc5vN01geTGNE9o4o4mjH2Np1H6UgMY6hezEfiI3\n    yT83ya39YBDR06Wvvi20dwfOXKLRsYZOuaAK4J8ZrqnKRC87pvGYZ1hM8789/IsOQ0cxucvoKchY\n    oSMzzpDB9tdnA0sHr+wzOGPdZD80OX/s85EgnSUlKCGzkWxlsAP6ony3CEtS1DoXy2rKzyWzlY7k\n    pow4tum6RGmckX6KZCm90wd/A0zgsFObKEhHB2nobpSa82oJHTk60WEifdyC9U3D48INwREZh1bE\n    L3RY+mynxxsjGpZjGEKAB8vUMomFJRX60Y7ySMAkV0dBLpclJ2XGACpsEGENTD0zmO3oJ6Ip44nE\n    MaFtXK6gN/pEpMZuzMCS1yyzgVP1bEtsKQdfaSodjwL5OeQc4gzXrqlrSGJb3htLgrv0vvbi3vE5\n    2Y7GtZzna90T2DWe4/HcgAleDjXl54Kz2gLl638HHITM9K+/X6xS4ytrt4DkfcERTetMGudw+OqU\n    /1iVisbyNA17gJv8EyHjPwRQ8tjBAcpcigUDOVFdgJNAUK6ex8jTOBq9ECpN2WQvJnaw/y7OtE0r\n    BCJhrJWOk9slzhTIWmyPf5/IRVLQJUASmCgmca0EHESKBP47dTNf8zfKI5VslCOBv9E6c+tSEjjl\n    5y8lge+RBbxE3vlRSeAa3JPv+jO5RgIDFBK4bvr+KORvy/69Du8hckUjfzXwoG+Ru1/JZSOIflzp\n    mjVj+J3cJB9tGdby/vW6Djmkos1SUtAp8tfLPwc4ZbKk4aTsT0k/a/34yV3c5omIvsH1YhuL6D2K\n    v+WE0y/+aSRlWMo5HBcye8PkFOsWMmFzmjIVaMxQcGNtFe+cvIzOIJ6CX9oSa0dwYzaSX26V4EKB\n    1mvYEzibhkcIzl1y4zgTCEPvoCE6Uh8dcyGO2r4Q0UAhu6knr0QwjGOMH7u8828YSTW+Bn+Wnvx4\n    9mkUHCfC7KVh/DeMo/ye/01lIcXO0fDcY/8lGTfcyxmuSV6L/jtJ/9ZiB/110KLTc+01ac7UdZa6\n    YK3vpFeCSZh8fxuPcxSyh/h8bAO9kki4Jrx+lEsNRHDIRuL93XSeWMaS64xxH1yL8EJcI5tl0YM8\n    +pG8He0nEjjUAg1BNG78hTTsAyxdGX7dOYs6jMc17Av+9800pP+Vs/3EzCQ3jRED9WMIFo3z7vNI\n    bVxGu9qPlvM4Wd9g/y5gt9COHmignnj8iZ9KPx76v1+I6Dtp47inYyQJ/EyXye7y2N0T0cHNn/ie\n    8vbhAG01oNJRfJ/TvzB04D9N9+Y61GU3z3/bqRrM4XPqnwtJ4TPppHxZxq99HSklFm+P/XW+UTeu\n    1VHpBd+5kdQNxyIpw+QOB02dpwy/QOZ0FMoSsTIVz0w55Kpv69Gdgb9b/xso+c3Gs+VmT3eBAYNA\n    hrG8iq/0PMD2UD7B24OX0fbxuHGgy6S40NNlDFAZ6DKGDbAd5HXB82QzaZrHH2kY1SaIaPz7PP5t\n    w01t/dh4ISJei+XXl74HN16H/5xHGia/JpO8T+IazmM7/vt5mmW6yV6yT/JNOWcggH3bN+gD/yYK\n    STWMF7gjPKdAvCl9Ew3V/mZu/238O0UkfyNHr4W+rRQ8CWzPONiPf0n08XX0Z0j8OvbN+A0R/f3q\n    Kw58x48rfH6r/99u1DeR55t+2rD/R8AfiOjf7nwNfySif92w/38jR38o+B7/PRH9S3hbPrF7BNnn\n    95z5uxZ+vvL4pQRtSQTLVuTvP6/oN0f+LqlbQFQe+fSJPElbQv5q25Hg1SQ/5LZXmkeSWe1TEiIY\n    pSZrYjgRxVbq/OY6wrIWRylYHvIM/TCQ/D0r14b1nBhaBDj/y1Hg/rMexP2Ske8hM4sjJOPaY+G/\n    Mzi0hzHykibHNTun2oJ7Lwj16EKOkvafE/tRQrxhPwhylUHimeu2nekAWZJB+hbHBh73sCawX6iG\n    MSOu1xRLUOJxHKXNwGwTdExq2UM1mcAods4R4DyOE8WZNpwZ9aaMgbXZx1shSCLyd7T+NVmf9UJ2\n    ppd0nON9l/06tX89+0leF5EumYmyzwyWbj7Ae8wUxueWj3+iYEuZRObfDTus+5HmCUEVQRKayWei\n    VgN4T+AawBd4aeoZuL9JQO8PnMF2pFDBMnz/DsYczmBiRYEwbmI9Q5aw5DEKA1dOFITkeWzD+TnW\n    AUYcKR4Lz/C+JymdrGeJSnUMWThEArdLGyH73sKWPmp2sJWFK7OwY/I3yCfL2vbh85afM7yfK1PJ\n    +3SEc6GMKh9D4xYst3GBZ13aUQ5EZsJ4oKC+wetQKQvNVLIPnmjj554wDA5mVodpDUrKK+w7EAfY\n    XYbmn9gDhtG35UlYDqDsJhUB1gngcYVHhxPFEs8o+4ylq6Rtw1rAcp3Agab891H8LcdSDTg2B59l\n    3dglfYdMApes8Z4prXIok1ksFcQ30Yf005bUAbb6I6pTpJTn+GTs1/zhS7KDv5Fb7JNn3CMTuIT7\n    WJIFTET0Lxv7g3NJh9cmPfLxv3yQeYSVFPsIHCpRlAlc9mBZF37L7N97kr/XPLg1mulbZ//+bWH/\n    9yZ/U9m/OWnnFNYkf7VtGvmbAhrmXM2FV9HequdQSvgyTsTRv+Xgic2beI/ZuV8Lxhpt8oXnsBwK\n    kvzldlI++ijO8yYyeHlS+krz7DLeh0RFqGcYFvdcnwyzf2XtFJ5go7QOC++cppqfDXuAG0J9upQU\n    dLzwHp+J5rjeFUJWN0dLdxPRNdBhqh1+oSBkGuqI41hBhBmWROywDgtxzubAseSZAvlKFGowEdHM\n    0RzOadfIq60LbGXOoCyjNfblZKP1ux1LXy51ei8hfHvj3I5KZDhdlbO/Jz1rqh8cvQ0dvQ1zqVFJ\n    KhwVhz2eH7OhtNrOQdo5OKT5OeTvA1UxQvmD8HcsCx3bS5an64nLJ9Ak+UpgYzGvvgXQ7AyDt6FW\n    4JQWYLWkzFHDYyMESrqpXAbbu2Ess8J2dJgIXLQ/LrJxMbHHhFgQkJfEHRLEPcW1Wrk9jouh/q8+\n    nh8pSD7KsVWO2W9Dp6o59BTbgVwpACkPbUHW3K2xo2sRwvq505mIlpyz9Slzdr281q/vT/uOj4m+\n    kBgholERKs7q5WORHOY2J5gzov3k30UH5+Q62bEtpilohgMsLnQIhE5bi+wKWmkizZbi+tTnhjbv\n    xF7gFX98MGU3jYFsQ1GRKq4BHOqFh7GI7QnO9zFYVJYkIvJ+W5TYP1NcF51Ir6WL6n45KWhug0ks\n    MgklBUkCcz9S6VD6Pq1r4v0n8nLYS8q9abLRr2J/zucsfcuWr1kmLrGi5Scqw1KJ6KU1gXN8wL9R\n    FyWU/YbWI4K3VFZdyt0QlSUN3kJ59p74CMmjpVLQRBMJnF8cPwprvXc08reO/CVaTvwS3Sbzl6hc\n    6rm2TrDW/o1cNeGLtSZ4UsJ/l4DrRxLFpO25YGKG261av4yj0afMTkb5LkavnEdmAmOUIh6HDhiM\n    WnwhH/noa3HKzKxumhjzZBMn0Ly9HzP1eEHej4v4vmWt7AaX0ZHixZC6MUPczV5x9pJv31zXO8MQ\n    FtsstNdTqNcWL5DjgBKsW4jKApz1KGsVEoV6cBygggtylO3F4/g67FqHivN3cJFTOkVespwmv96m\n    iPO6TKVSZ/KBdKd3yimMmVmlhO+x8FVyvRI5At36zFpdZSQaYgezfd+Z5OC+2QmNtb6knTyI6+W/\n    kSzB7CV2InE2PBMwcZ1sNzmp0Tk1UCCDLmMWYE/d7HM1vG8wfRHI/fQrDg5o2AuGIXy3fvzxTusQ\n    EBWygIPDOmQ+sqJAIOr475gkxrEKsyyJeOyaZ3nK+ofYR4mqBjrTWTHjhZRatYOeeaxBU41AlPSh\n    2bIycjWglBCW2dG6DS+7ZonUnILnIzwncfBdy/vF303U92DbUg2O9EAvbP8i+uKgYs2Ochu2m/j8\n    8Xd1hrHzDHaUAyWCNHSwu02Ram8I5B0/G7n/wjOaDrxoeD/AgGQOOj5QCKO7TD6pbgwiiefjrODD\n    a9QTjJsn6uiZ5utLLM1A5ANdcJv0yyHZyiQxEQcNh3YE/Yf98/WPBqkmaK0bTontfK7SWsDYX0cu\n    qu37UnBszs9bk3iEx+SAfd6TBM4hR6xLVdFbkcBLs4CJriOBHwUtC3hbVJLAy0V6Wvbveiglf0si\n    OTTslfz9munTaoOG5Ss5dXlTarQ+T+3nKHVA5jJ9rfbaJCA3edDkoeUEIkX+Yu3fl4LPdyYX1f1F\n    4tYljsFoPaJ5xB3WAHbw91HZLid/x/EeBlePlZHVTfuxtuELBWcPRjwGqVY/MR6Eo5oloFkQeCCW\n    5OKeAjHUsBd002Q0kG5zDFPrtrzeM7qRnOLaSF5+i8ZxgcbaQuF5OY7hIb72YEdH6qex7zK663y/\n    7CDsqBvrHXZjtRyuHcwjDYP//kYdvSqVddjpw/YG6/bKaiMvRHQenFqjEKE5UzXpYkRPcT3FeJ/+\n    a9HaItA5IGsooj2W/djO3DqUZiJfomsJ90obQw40Zv0qfddkPh+UY1/gb83JzcedYDs7iw7ENTaD\n    lLl0XnvnEmcbexvJGb4sPYik7nnK82OntZv2Bgf2kvj6hkcFh8QwZUGkV4jj75znYk0GfG8ItQsv\n    5HONQkaunzsfxpFqIDfZUUc99dMxl1Heth+DTYZxLPK1Co+jrezHsesANBg+c6H0i0c/jkDhb86d\n    i4NSUySmtHWeRGQ7FfrmoKsDDXRwQ2QTeuVcfeacGnJ2tBd2tKaP7+M8KHd86flL25bUSw7Z1C7b\n    logmQh4/w1EcnTo/H3eaMn/nx3EAAxMmnK3rn61A6tF43RikwIGGce3fuOYvBmT1ow3t6TDKwTbs\n    BQNxIF05uC17RBr2Au+J4jXpkS7j+iesUXm+jiTtiTr6RJdpTOlHG8rtDqM95dq+HsPYLrwnCgpD\n    IRFjGNcKwXbIdSdn5XL//nj/9+usjm+o28vvc8B6vmew6Vj/18ILOfrneD1PRFRSYZV9pFot4JeC\n    Pt7gGhnfx3vxjUItX6ztq+E7OXrJnA3vjQT7w3/NXC/713O1gz8X9GXhByL6p7Kd6wH/U7lnt8BP\n    RPTXhcf+jZbVBP6ZiP6SaVNaD/hPdL0s9K3wZ3L078bP9Ai1gIm2rwdcgfTE7hGzf/98w8mHJH/X\n    0kJHNPK3vubvWpm/Vq2AWvJXw5I6CxJI/rLBZuduaXYv45liwlfWmbBIX6v2r4x0e4O/kazVyF8J\n    S/qZM3WPRvtv1EURgSwNcyYqykQ+iL7DQtdNf8vF7wtxVifHT7pJgpoz8kI2H0VR1m/jdNnfl8NU\n    l8xTPJjR1xZYe4EbZStDtTpdAtpNT0Jo2xba+wJnKqL0O2aFP1GovDVQnB2pZW2ETJAQXIIygnE2\n    sZSqDJH9vC8+do44ozRkB2C9JjeE9/2wTqaSJjnM51uaaYvHc4YVfp6j2Kbtqz0fnvdgvOT9kPcg\n    +j7G+xu9xJghM34Z8rvDMgYlkDUKuQ+O/ieKVxdYX5P/PY8ylPxco7QcO6RRFJ/fD1P/TPj462ZZ\n    dc6cbxnA+wIHFAQHdjd95/gK9YGRMm7YC4aRsuLxGbP/sagLZwGjLC7OsQ/jc4RjD48/rMxDFMYR\n    S8VA2s2ggmBDEnzSrslsKMwGnvc1twMaZH1guW9ppi1et5UprP0nbS5mO9fa8JRN1koV4H0oVdc4\n    EM3UTnDOg7V7pW3MEdU9XAP2we/ZpmJGOv/7fTyC4Hm+jPNJDpzi7D1UmuF5J89HuXQC/xaG0Y76\n    IMU2hu4Fw+AiRaqSDOCgUHVo6mS7gRvXkkF57jSuJueqGHEiA0rwSxv7BP3HUv3BZ9ZTkLnHfWfS\n    7U4csIs+RQ8c72VJOKkQiP5FzBROKT2hdDOXs5Pt35T2/HmfjX2I06y/fFYykT4nYB/v9/HfN3IR\n    6VubHSyRW1uVZu9qvnbpl7+2JnAp1pKD3rIe8Na4hRT0R8kCvhcqsoBtAvgRyd+94T3LPq+FNQux\n    56AZkhKyV5O6KCF/a2WdLXwjon9QlyV9X4y/38gmeN8KJj0SGvnLEy2ZqWsBJ12a9POT0hb/TtX3\n    /Q6Lmvnn8fuxTvB3MZklimv+ouwl7kMnSZy1Gya+6LRmmpgdVSwDfQHnUyACG/aAPiJ58/+xE6bV\n    sNwfUHrSO7BDNoYjGh133UQSh7ptTPzGi+3DdExMlPlMIR4ng6QuLsax9i/jSN4eSMLVO2UdvRBn\n    koTPo0HWKZyc0sOcYNYylXIoqUNYWrPwmtrAtdeKta40pBzSU41HcPJLZz3bq/DSP1tN9rGjoHiB\n    TnSL+JA1f31bzv4NhMzb6LSOM4Djzx5qYqOUKmYQOyCBuOIrOyx9r0NzVu4GnviNyymkXlPb9gzs\n    CmzZONP/SJzlK4NCvB3kkgcYRCKlLJEg47OEGuMh6BPHIawTjOsrSdjx2IlBU71or8Eau4/TK7bj\n    kS2IgoL0OvEl5KdVy35t1NjpWvtfgtiOKfsE8dsPvh7z29CZ/QW73I3zp7jmJV/nG6xH+XuJn4n5\n    ey49dBLfOxFFc0WiULOa1578NwfGBIIvkD7+94Nrl4Y9wa9AujHY9JB9cdu5V6XhvcIHAsS6KjiH\n    7ikoDvB8nYOjglJPTA6fwEZiSQRcS+LfRDTZboJ94bhOLQfHdvT7zO/Gf819hkj2an5GmaRi1e/l\n    v7X2SAJjeTwJyz+a8sfiZyqVisZ+JQmMwOzgHL6PPtPaJKfS2sHfyK1GAueSxXLJZkuxJQm8lNcp\n    TSLcMwn8KLWAH0QKuhENFrZ+QGt+ZEuyf7cmf9fI/tXI33+SS5LCS7N/pQH5C3Uq+Su3ldY5YKxN\n    /hLls31fKZ4MOHJFGcIInlCcxARJgic0JzHx0dpbkymcyGhEr9YX1vqV9T3CBM8DM9JkJLkkPPiK\n    tL9lnUwCp4Kv+9vB3y5yKnFGnidV/OTZk75BBpOJX85goOl9G5f3Aib9gtBa+sVOzeZy2R9YWg8X\n    zVgLuJucb35Mw4wN76D24wNLcaEcGy/K0fmM543ry8VZm0Rz0hchs4Hmzuu5U1ZmMJXCytCpzU6y\n    6v9xdqCj7Uhf6z7Kz5e6B1FNQCWzC2tqyWzeFGQ7lHirJeDxWh3Nr41rB3+nQ5Q9J4lizmR/ovh5\n    xHqcA7gfD+SmdyGoyhGqK7BdbdgPQq5KUNXQ/gsqGkEWvGFfYOc0jxc+2OUwkm0+4PIpsh/BwR1K\n    s9A0hrCNDTUN/V5/LhcpJHCfXXQ9ca1M3lZHQLKSwTwbOAWZaTsLzBHZwTV2tIacXgvct6NQm9L6\n    3Llrl6+Uwoh5PUoAiZVl7MipcyXrXltzqQAHZR/i6+Znkr/vs7CjPNcJdbDjTHgMCnTTuTxZzYGo\n    HQU1rIa9gEe9eO6XemGAense9gFW0nAwJhBh8HkoWebbhzJl7PsiGN9QsYADTU5TOwnMBo7VhyzF\n    P24vy7lpbc8UhypYPsXUNqwNLH2O2nGWymGqLjCrL8qEHQuy7B8f90JlfmQ8XvNR12QGX0ME57C0\n    bnApuLykxjXcqh4w0fshgbdQv70VbqkaXIMHSLLVp9APcGEqbvVFauTvkgf4TytcyxLydym2zvzF\n    aBtr4OWp5a8rftca+VuC2iL3SP5a39ur8v47vJfGVBptrb8XiuVHSvBC88zgVO1flDE5kUtOaoi0\n    2r80+1u25/1E+shkTcKC9LOb+j+T7RA/jp+Ixra4cOdsJaIQYY0L5iM4svnfy+h0Oo9OJ0/o+uyD\n    kEHg6EBdtADnTD+u5cSR2I9prhqWwEuy+SU017PplDob6NhhgqRlLu0LwxCygLzE5IUI6i8RoePu\n    MmUIX2gg/9RciOXiuS3XWurg32fiyjaO+jEX0h8Tai5xXV27Bo6vdfRM8aL2OFb/wTqFXKPQ9x3X\n    LvRngG1IYibqFkrwZ5PQSda4bpSeSR9qOWn2qBaoQMH3OAUr62qWIa2Qvng+vdbjvO9aGswHLsUO\n    bEf57OEg60wT8SIdLeiIR3nVAbLLL4KkcdDG/80lKTwdzDY9lotu4+e+EL5//mbTNYD51Z6DPWEY\n    4trfnrQaJhsYxrowZ8c6h8NokUIAVRhfiIaRSMNQkmBH5ZPnyy4QHRPW6zieK9hcb0d53VICP2eQ\n    9XR5bI7tKKsWIVK2lbO1NHTT57avbE07ytfv+4uVHjziX3wNCW3ZXO3ecBb1vK0bM9PibT18F/La\n    jhRf58t0vE1CX2CUOxEHeMXEsO/bz71Ok11EidbwnksMYTBE2N9NQcjcBoOrcmv9hveFMOLxM1B2\n    TDi2YS/gFaUftYbpdz9Q7Pc6jGOIDzS+RL4wrjPe0TDaY29H2Z769acHK0wNNER1bv0+33doba9P\n    ZV3hYbSnR9FmoFAb+GmsDRzsy7xGMIm/Cdrg31/J10C28Dxe/xsRPY33NVdv9oWC//cHGiK/sAWs\n    /evITTV1vxW0Jzhfqu7va6I/2U+upi/jExF9zbT5C3X0M9zjpfWArVrADOYi/i62/Z0CZ/HDhrWC\n    l9YEXloPuBSlNYGX4hdy9OUONZg/Cv6NHP0hfX/nRFgjf7c/z6PW/b0Vtoy6yeFr4b1ZSv5asCQ2\n    UsdpxC9Gir1SfbYvRo2dCo+TNSyep77Kav+S0kb+/URzol7W59AyhDFCTwMv2J1CHnsndze14+hC\n    vWaUi5zTuA+z9Px9Dc5rls15mq4hlnxmhyZHXLcM4H3By6+5KRiAa9XJV3A3dlNN1+a43hvcJAnO\n    mUgsqYzSld6By+MDZmsEcov/DdmxbpSUj53fclzCa8FatDwelWSR8nj6Rt00fmI/pU7ZfkjXHJZZ\n    M6W10d9gfE25q9im9Cu8chHiS8H3QNYptjKwSu49RtzL+4/OkVTf+N0cyM8rLhTLg/fiuQ2ZacG2\n    dtCXl2oNAVNxthZm7MW/FcxoQWK59HlpeCcYwm96KHjF2W0Ne4F3YQbCypOrQQKe/+5pXk/8MtFa\n    nBVJ8KzMs0UxQMWPKSTs7jz7Cf8lmmduMizCtNqOklZaIVaGwFrwktjsi85iY007mreljkpsu4TM\n    +M3NO/rC4EupoMGSzm/js6krkchPFGfA6Rna8bwOt3G7Dl6yLifaRZR6DmvNkEnPQRW8Fu0neeiG\n    fcBFa8/5b2r+wvbNO7EPcIB5B99zT6EMEa4L+Tnx5G3wb7HqQE/xPB1rjRMFuytloYm8XWL7iUEz\n    iNLMX27N0LJy5fvPpPseLTyJNtJeWck4L5VjKN+XGv+uNtuVUtG5/kozg1+V476NrxKU+NhLk7WW\n    QCaZSQ4C328lFc24ZdnNWyYVIrQkyltJQd8jC/hPBee8M9+67MdV8sH2hDXT1x+V/K0ZgJbIP6cG\n    UDnwrpX9K8ner4pxuqbAvEX+lpLHNdIZWPPhDSZOpcficfLvFFJ1LLSFemrClaupYQH7RCJXSj9z\n    uxClnSaF38T4J0nfC0xWGbggx8V1J9rEJE2o04nEMDum+nGRHRyWH2t83TOGoZsc0qEudTd7hX2x\n    87phX2Bn9XH8fjnwI4whbqx12U3bCcYOHGsOFGQrUdaQ3x+IRDam/xcDf9A5rclCYl3ZC8WkrwXp\n    XHXRsx8j5WjN1S1Eyc1QF9EHOKXq6WrXWyp/vPRY67rNuo1C8rkE0t6l7nvqmvk6sa4k3sOjaPdt\n    ek7jPnDewJl0WGvziSh6xrndJWoX7pt0Vg/koracv4CBVG0E3Q+G0XYOYC9T/2FZjYb9IJRQCXbS\n    k2gHqCcY5ue9GGPmc/a5cgAHpvQU29FejFME20/UTTUQ+Tpw7YDjfk952yQzczEASI7ptXLMOVlo\n    TTJ5Sztaery8HrT7eH9d4rq1eYW8N/LeamUWNOJdQpLBkrhgUl5+vnC8zPwlwhIJMuCPnwuWgZZ2\n    NA6gCaUS+D/+TWFAchs/9wVP/AUbysHHqReuXVswwD7gA6lC+aGgrhJqApMYV+PxINjRA7TDwGMc\n    k7AG8Fs0l4+BNdHVNSPNlRUCKRsjqALqCSmyLbfRStPJv/n6tCQXiwT+Ef5OXYvlny3x+eI9s3zF\n    a5HA1nFLJZw1Ml7z45cmctXivZHArR5wwxV4/FiuP9B+sn9v8WNagntKP9+S/JWoIX+tyCaN/NVk\n    nnPHSXTk6BvF0hsoB11ijN8M56+GkzL5eU60Y2D7E7lI+plonuXLwMxdeY1H0f83Y5xCqbCSiZ2s\n    p/V9nLAyyUEUEx5B2jQ4xHsgV0JWUhfV/e2Ixn9dRBif4dggLjefbLcF934QvuGwiJ7Tv7FjL7gf\n    G/YEdqBw0AcHgBDRuPjuQGbLg4nXOBPSdm4+kyUnqEsEH8djcJGOteWIvB3RnJ1Ye1BmpFoZqmqG\n    8eCIhro6tPjZLuM4nZOQzjmyS2qhldZPrHGc4/k19KRn/MYOmZrM3xgoGYoOFAyE4mO5phc+U1x3\n    kIHZt7LtGRw/vD0EPnRRn0gWc5hMkHXFYzDTM7avzVm5L4T5kn8iNGd1qA/cgun2iJC3hPNn3ocS\n    tnGwFAeJDBSCrS6wnZ+cM4w5RHNyld8jAcf24AS2W2a28jEWLPWNcnI32AIZxJWq2Vtjc7eyo4cr\n    zoe2v8beyuvleYiEnsU7fyY4i/doHPMmvgepNOXIzYLHpYIGt5VBe9h2oG5ah9J4NFF4nsO8MxCA\n    bFv5d+DGfoMUbMNegMHGcuVp/cdtW2mifaGDMYPXchwEEuxImItfwNd1oRA4xTjB/F6qF8gxk1WN\n    5nXQiX5VSOBUWTfuX8vc5W3fqIt8iXKctmr48j7Z3wmuC9vJfqTP9Fnpl2sBIyyStmQ0flX6YRI4\n    J+dcA41I1HzbtYRwjgS2ttVizVKT98I9SOCl5U2tZMpbkMCtFvAMMbHyqPLPt4D1AK6V/XusePhu\n    maJ/S+mBW2EL8leDNHQ/UxkxmwPXXLDq/1rnQCmVFLDPFyLS8mQs8lebvBD5mhjcRttvRdTJfbKW\n    YloKTJdR40nlcbxXT8qxKEmD0XEH8t9rLyatTJJcKHZWYFYSO5XOxDWBg2MeI7BZRokrg4RIXG7T\n    Mpf2g3mE9YUOsxc6rydSoy20d4VhCA7C+HcfMpT60bGNGUwcXR3EK+OFN0rTx47mIFWJmcC4HzNJ\n    kLQLsv+21HDKMR1HjM+Pq81Ywj5TDuMcEfxI0LJ9j+JlyUjWksUoU3lQj4ud50j4vo0Z6y8Uzwsk\n    seFIJ6m9Q6SbapvjNcnP4zOX4hIKwUmF2UvBWc0ZKgMFtYVSOfOG9wOmMeLMpPlLksHNYb0vIIFL\n    078OSKwuCiDhtjKIxBFLRHMvYSxDRzcGuXyiuSKCDKyS4693dPusJx5TSYyd3J8cs1KlFZbYUcxE\n    RQf4teoT90KutnFJsJbdtzPIf5eZgzjz2H6cV/GcjsG2k5UzrIAvVOcIc7kOCOGYJOanO7aTcRYf\n    /x6YCOYyNViepFXq2xdwHaopUlmvpqqyHwzRb95FSQn4XpZhYXvkxnm6TIiQ9cf5GBwvZak1ouC/\n    5O1vEExFRFMZNTw2+Nkk7KBYVi5M+SGxHf+tJZmwv9Mqp/dstLf8qKXl+dCHa/l8rbKDb+STi6z9\n    jFKFyp+pTPWyRh6aSCeBS4jhWsjM3jWzgGvVUn+ix+Rk9pIJfGsS+MHVkutdJLf+QLf4wh4pBf3R\n    yd/aAa0m+3cNiQVpEDTjuAb5u1TiIgc2yG8Jo67hhcpknU8wKbPkRJ6hLb7H2r9EYXr1Vbh1idK1\n    f1PtZHver32P57HdJ9EeSeEeJnA8eXRif4hCdFPG3fPYDh0MB0ISPEx8eXEcpG9CZjETOOhMCo5s\n    P/nux7/53C1raU+oz0JqeeD7BJO+3rnmRw0fUDJMz0hcpbejYRoNeBE+jLLPnC/sez1RRx1dpmO9\n    vG7sqHajI8+HmAwz6UEvT01E07XxscH9dyTMjGIZxGFciKOMvu0yDLNOfyyP1+x05jH34IZFjlt/\n    /pJvY12y+GD8rWGpgz3l8Je2rQT8vXHmGtawPJGbkRvW5yUKzwUfe6Fuykg/wz4OdHqioH5ARJGj\n    6UKokkFT3Wy+lgth/c+QJRUCbhydm4rCrqBZ0kFtF//d5lM7w8A1Son4CRhoGP+eB4t4axdbQiKa\n    7CiPHhz41MFTxWdhaWe2m/1oSw/jKMW2mYHrgkD0xnYxELseb+OVlsKyo3zOyY5m+mQbINEPjg4u\n    dz3r29Fwbwrs6II++TjLBmMAcfrcbnacpqAhzyKlwy/jM3gBe8v/cjmQp7GfC/SDChlxUEL8LypT\n    kbCVSN6E55iDkDlQugXR7A9O8dqk2xPxmNaehf2ApZ97+PtC/Tg/Zx+WT2oYpsQFOW7045ydpfiH\n    0U4OxGtEN45d3m4+g73ipAtp+7w/jIDk1W3RE3n7fEzYOTfuP2XaP8FZfLsAvIaQuRvwlTp6omHq\n    941CCb0nCn7TEzl6ooGeSa8X/EJE3wlJ4PycgO+5hleK7Ya/Njde30CvRWdI45WIvsL77+NnvBaf\n    xbV/TTwH1+Cf5OiHDxjmxHzTXwra/p0c/WaFe/Q7sjOIfyFHXzb+Hg7kJv/bo+CPRPSvtz/tY0tA\n    /+XO5O9a2b9/r4ikuQY1UgCPFmWyhb7+VnUCNKxB3LMrooT8lYRvjvxlOehnSuNZ/K21l5FxWlst\n    wo4oloy2oup4u6O0pIslCdOLa+NM4KPYj4t8rvUr5d2kRM2RdImxA7F0Ky+kO1iUB8c2L8L7MZKW\n    ieGQCdi1GNsdgSPrS1+hhmWrtbQ3DBRL76ETJtQe9GPDAHMzWU8pSOfGUdkXimv9BufgXFicndgs\n    6cvQQg8sSWkGRmPr8od21q+27QVeRyJySnZSLkupz7ysz7YUsp+aGoPyPmoZRGXZz2XZ1mhz3siB\n    bFt8nPXZ5s9ICG56hmPQKf0k3kuHNT7jfI2cdyLrW/N2mn4rXJqhm+xq36zoLiEVM1KvkOHUnoQ9\n    gS0oZvkgeXWcWnXRfiaNB8KaqBT9jdlLPO7hmNPDWEUUSi50NB8XZa1eKderlU04QeaxDHdgm21n\n    ptKsvWY3UnZGImdj8VxrYUbUUt6Oa9etvdzgnw+eX+hqGLYdtcpg8DpRzo0uxvfPcDSX636D5xbv\n    BxIuvI2f+56QcHYzO4rXgoFWQeI5SKE7Qrvc1iF7QxgRMWAu/cK2DXtBrCqFwSEHGBd4DRnP0cO4\n    9UYHsI/xfJ3rtBOF8elIsRy+VOHDsQ/r/aI6oPTlMZ6IkvaMj7fknnl7rmawPJb9n7L8nUbwPht/\n    29+SM9UgU8cgcsqUmO1bo2KJx/2c2Ie4NnlKfra1/PypZDWrXQlqk+aIbs/P3DLxkCjNrd0iIfMW\n    3CLjnlnA/5Y+d50xv+UH+Qs5+v3G57gF+VuKR8/8JVo2kJVgC/L3G7mqTF8+JofPNBfoZfmL7+SK\n    ZTNQfqPkuBT5m0NpLWCc7FjSJQg5CbJkS1LyzwiO9Dsnr9WZEevY/1Ecw2Dp5zPNayfpUefzGlRY\n    oxBlcmTkdahHKKOrMfo2lrhs1Zb2hbnkqf7qCCUMgzOmYV+QjmseP9hBHZxwwbl3JHZax45uJHyJ\n    QqQ1qiaErN6AJ6LZeDYnMONFuCVJeCg8JkVesrM7rr3u6G3o6G2w56hLavPeCn2GtD4aL7M/sgn0\n    3rAb8n7I+oicwY3t5fEkjtHubfxcBhlKxAX2d0q/kjghaIM1fzkDgW1lCKwKTiz5G2vYCYZAWJQ6\n    rQdqM6q9gb9TfhZYspmlK09A+odgEZoUdnCsYjtKNJ/34xjFAVYIbf2Qz1jVA6wsO6qtPVJ2NCU9\n    nFOPsOxRzpbdE0vmADyvkEFrGumu3fMcAW/NpyRBnJpP8TMtyVua3ndTwBUGMEhbjYGAA6wxOoql\n    1NGOBtIXZdMb9oR4jhTWnblXCBpo2AN4ntRPv/k4iBJ9VR35Ui7o3+Lx5jwpBjjCAE0ftIRj3Tz5\n    goHByKwaFJeVmSsuINBvGPyDLllO7tv4eWQtYATahJQMNF4HJrlobSwS2PKh5pKDrGOQWLfkoBmS\n    BC4lgvE4lIL+RGVqm7XS0ETb2aQtuAiifZDAP1N5MmMJbs2xSdySBH5QlBPAtyZ/t8ZHJX+XYskA\n    VjKYLhlwv5JLRv10VB88UEr+SpTUPpBIGVbNwC8lfEvqSfC+J7Kj0eTxnJ2b65sozuKVEzC8n7L2\n    r+xDIp7suSizmES/7CDHOtxywY6y2LjAD5HVseMmdsqgc2YeeR3knoPE84VCvU+MqPSOrRZluxdc\n    hlCbEMn/IMfmX/248LpMbZvbZY8YpkVunH2BYwsTvliLUJJl7JBGlQFZ5xedh+gM1IhAPI4zZPrE\n    OIT9aM5Wi8xM1ai1SLuU83qpMzqXRVTiWE45m1MOaLw3Oee8tc8ijlNZv3hd6JTBGpOarCV/Rie+\n    7wtZZIPvD+tvzuv/eoRszbhmNH8mznZiKcxO/Cb4t4JOKh5jG/W3P3TROJF/deSafOkOwXV+kbiI\n    A6vm8yqpoIF2MczNO5XYJQoy+RiEZQXloDQvKy+xytBRad+TEyTj3DZZyhuxQlE6mChnZ2pqCmsB\n    Q4fM9hKCtiTDVz0uMxdI1fTFjLZ8+3CvtXuizbFi+OfyBfrktv2sJWYeu+l5wufEn9dN5AzO+wIR\n    0U2kL8o/hyCZeV3t+HfVsBeEAONuKkPly1a5SS1I/oer2GZP94FQRCGMJxgwh8Eh50mhLGQJ47oz\n    lD/zkFnA1vhKFHx0Mggq7A9KfEfSVQPZ/4e+RiaBcZx2sN/CE9nEZa4WMP+ttTtlzplrh+uZJT7h\n    EpQmMNUcV5qIVVsfOOchy/EEFjRO4jfVvcyxVQIdUZ366yPB4tq2zgJmfuhWJPCD1gJ+PKKBv5Ct\n    s38trEX+/qmw3Vrkb+kAcIu6v6VYSv6m8APV1fglWi5JgeRvjeG02mpG+ieqp4Iw6itl+EuIYQbW\n    /7Wi2ohictjCmRw9ZyZDmgQLTto0wldm/36Cv78LqVNL+quHY1D+WdZHJKIpQrunMCG+wN9xtGRw\n    ZDPtw1lNvMg+j9KGl8c0Fg0LgERvLPXNrkQmezGD7REtc8P1iEmxMK67yDGHzjl2+PljunFMmR+P\n    Ers9HMsLcR7H2HkdZARdZryZO0DTzlsXLeylhD4ROrlDUAQeaxGRuWzZNTOTUpKTqYyo0vNbzvYS\n    Z3nOWS+PQTIidW6+z156O3b8pr7zOVESv4+zkvxzfoLnEWWe3fQsdISOau4DM385az7IYIZshiZX\n    uE8EsiL/4ozQNpvaHzjog7Ma4/c0/Y22NIwbODaEcS6Wnadom8ywlIFATuzP4TA6s1+M/VJ2uDbI\n    KKfakSJia8jgUltYI99cg5TNzc0ZdCls/3obnw8ruO1IZfeJZbvleS2wDZTZu0ShDnX4Hv0asyf/\n    zL4Qks9d9MweKUi0esR2lAOTObsTFYlaOYWdYfArTAfPQBy0gAFU8Rp2aJLgu8EwuCgDGCWg2Q/F\n    Wb/WuhGDoXgfz760ACZJBmuS+gT7mMT9DnN5OZZrqoGWxDPCkTMlnnm/BiSZrcSTE1wTy0DLTF8t\n    sUbrx3q/hAT+iWg250j1sWT2/ImCb5x961uRwD9UX10ZtsoErsWjZQFvgXuRwIwPTAKXOUhudeG3\n    In+tB2uLzN9Uyvytyd8lWIv8lRE0W5G/W7l72ICxgSpdEsls3xLy99v4b+ng/1bQJ1E86XhJ9Jci\n    f78qY4as/asBJ1tW3V8tak6r94vyz1q9X35xn1JuBmsAI3xtEnvhj1H/7Jhx5CZSZj5JRtlnfxeC\n    VCWBYyo8tzz5btgHpHyWVsFOvlDitGFf8Haji+TUUCKeFQTQke3h4K94Ic6QUpHcljNMnkkn5RAO\n    xrgUJMEYakXp4PqGQe7ZmURuqo9S5/Sh4GUh59DOHX/MvFLIfUZNOo23yyh7fB40pzs/P/zdcbZv\n    siakcA5KIJEra06jU+gSPbeYweQdTuG6u6lsA5J5B4rtKonfS7Oge0QcJJV7cfvmsN4XmPRl4pe/\n    awwKYQJMs6OXqZ9AAgeFHprGISTfcDzB+uYXY5yOFV5soAwxBgFqdXCJ5tmlwRbpBKh1zjnpqSNn\n    y6xzoJ1dGih1jQ3XP6d+DglWzzoSByt1RQFXTrQpub4QCDxHPJfDZy0mVwLRG57TJyKYUwYFDZR2\n    JooVMzBQdZh+J67Z0h3CTf/ncGP9dRmD0uW6tWEvCOtQLK3BAVSsIoDKFxfxFOA8/zwpaMTBBJYy\n    BNc8T635zhQHEmu+PgQmj6AUtIVU2Tn0y1nHIrTSedjGUlmU27lGPfeBQL+uTPbJEcJv5Oh1PO4b\n    BV9z6ril0tC3CBty5LIk8NIawVuQwO8hC/iRSOAtgTzjnkngRB3gMLX7450v+FZfwC3J3xTu8SOr\n    xSORvyXYKhoI8Z3c5uTvG7kkQSuPfUn0qWXpau2tmhQISf4+jy8tmo2ITKkWBE7g5GQK3yP5K0lh\n    7FNO1NDBgcQt92k5vHuY+OHC3kcldpNzgD8TZtidgUQ+TNcaR2TPib62uNojhukJCosrzV2NtQvb\n    k7B/yBps7GiLs5BiZy8H0eC+eFEeFBguo+OSweOclPDFffy3dGqjFFwKsj9e3HuyV88cTmUqWY4D\n    PNZCicNZza412tSQvtpnK3FG52o0orO4lAyfnPAUBy6hJKl1DaxQwXW8sA2SIB3Fz5BFDId/3fSc\n    ol3ETDs+N38G7nUQ5wgUjn86ZeZwG0X3g4HigKrSV8Oe4VQ7ShRojAGIM1QNwPFmbm91O8x9a0oY\n    2B7HXN8+XG9ubsfrEh6jsZ+cPZQ2AYnlXPBRSZ8p2ekUTDWLCrtcQyDn1THKJJ/5GA5ak3WWcwF1\n    DCT38XxSmQOfLyLblp6poxP5gEGUYMVyCCHzF8maEGDIz3gYI+N1aByE2sbRvQAprdJAqpYBvD/g\n    b5xLpuB4ptUJZ72yC4WSCdw+BGDFgcdSmYoo2AtZE10GuHJSRgh8ccoaJUBLIJFS0FZJOcuOPSWO\n    Q7AfVCOBtb+fKQ/NV3siZ5YKLM0KfqVAGJeQwNrxJeiovr5vLUoygdcggdeQgSZqJLAFjYO7lRT0\n    LfFAmcDp2L57kL/3+ELuXYz6GmyV/WsNUv8gF70YvxUvC0vJ39wA/t8U9FFiiFC+QsKRK675W2og\n    mRTm9iVG2IoAk/t5slEy0WDkZEqeYV8KWPuXwbIsVgYw/5uSVkllCctaH9ZinsgmfQ8UZwFb9Q7l\n    Qh0X+H5y3M2IGxq3+2sL9ZpC1lQ3Oaca9oGQ81i23MaaSw8zTWhYB4ODgAAijC+W9ZOIYsL1Mo0t\n    gUjjjCV8vnrytQpxYf0MfcgFtFYblig4jvVxkqZjNGctn0c6na1asynncYrkRFK0OMNWcRxr2b0l\n    GUbJ82R+vaUZTUik52Q9+d6najMj8LvPBZ3wdyprVFoO8PB+HqggJaGlwzpkIMnrCZJ1QY0DyyyE\n    jMChjaC7A5K6lzHLc1BeYV8jgPcI72QOWbs4d+L9c2LLY1DGIh/UiQ7uENxyhrILYd2BwSw0+1sG\n    zMTZmxrmWVKyP6LYpmi1ZqUNqQk+wvOX2r6aesEI7TwWqVuSKSztv0V2lwRMaQFceJ0YDGfNSWQt\n    ZwlWyDhSbEe1756fG342Y7WtLlp/xtm6c6WpA+wLBE8Xkcd8JNeGbaUU9oeBiMqoX2uN2rAH8Byb\n    yyLgnB2VNbDskGaXsKwRvyeKxypNnSpeT8RPFdY+92p+cbueuqhUG5GuIijrAuN2PEbuxzbyb76+\n    lHw0Q/O9lpDAOf+qRQITlZcAfIE2Nf5nxhqZwCX+9G+UJ5FLkr+WksAIJIF/SzbvYfEkuP/RYZHA\n    f9/w2u+ZCXyrJFSihyGB7YldI3+vh/VDWSu64h7kr4YU4btW1EwKJYN/Kfl7zfG1kORvCXLk7z+V\n    LF0JSeyW3L83ypO/qaVBivz9NnOwxAgTtHjihnil+UQQYZEO7HTWnd/zye4JFt3oKJLvZYYB3x/M\n    WPIOgCAfrZ234X1DSj/HLqQcOdywP3jSKtQn5KUzklkxKeZAIksSxSg/z5m//J7/vZCbxlgGS3rJ\n    7F+JuSM17UDlKPIXymfHyPE45VhNQTq4cy6qnuaSzhw9XSJ5WSvrLCEzclNyz5IwxT5qHPWYUeaM\n    PrE9fg+9ci6LZEZ7yM8nPpNddHwX9ef/jTPp8N+4rYuymE7jbwodUdcQ+A2PBwy1C7Kr8xdKsjYJ\n    0/3Bf8dxbV/eHgeFhHmUHG9IHVN4z3x85LHkKx2iMQ0lonGbdTyeI2frsLQCZgPnkAom0oLAcH+p\n    NLSGpbbzBV5SMjoHR6UEt46ewhxcKxOUur8vhMF3dv+UeRZwGypqaPZWrjV5Hz7Pb3SY+sHrwxIj\n    eC4OReaAQl6Tyqz3hn2Ag1BloFTqxW0b/bsvHIkg2BLn1G4aB5D45WcHlahkeSJcW8r1y5HmyRS4\n    D22cNh7jmMh1gfuRwLTqAqMUtEUGP5FdSxiV/jRYfk2ZEfxmtOH9z+Icmp+VVRdp6rMuYSgFlnf+\n    vsFvPDVupJKuEJYPnondkiSwJahJWrO4kFuSwFuWBEX8aaN+Gwm8PgwZaH1qdw92em/k79Z4FPI3\n    hVtIPyN5+avR/7Xk73cqz/wtxXfyEVw1dRK4NpGFfy5YquH9szJ+38iu7cuwJkeOHD0njrXIX1nn\n    A6Wf5Tm5PogWRag5MVKTEZSgxIhIBjtjYklL34Zriz2RdACFBXqI2A5S0LxUj+WC20JrHwiL6BTZ\n    i/umhXeBA6zh/cARTa5pXFyzY5bgd8/ZGUeaS1UigRzkueZOZ805KTNFJVT5RTG2puo5af3J85XW\n    75v3E34vteSedBCj41dzIl/7WgK+JnS21WQiXyjO4tKkKq37gvc5JQstzyHPL2XHGSlHeZCqDOob\n    fDw6nqT7EYnip+m9g+CKNn7uCcPAz0CZ9HNT0tgn/HMQB5NwMBWPEzh/1uxo2BfsKJPKGtlmZT+d\n    IEMYUTpuWyUDUtAyU0vHOg6MQDuz1F7Ja17jlbLJ9Yjn2Nq8JnevtExr6z4cjOPlvdLayExhK9PO\n    v3czctj/S7PPeVYUpbh+Nh7Lvw0MUuaAqjZ+7gtxffLy13RcW5fuBBg4FZ4LVAJAraoDxTb3DKOD\n    FnzcR89NUO6Qmb/5ABp51WEb+wSldHSJSqDm00zVAyYi05dpkcCMr9RN/aYkoiUJrLWR+Cd12Uzf\n    0pKCRJ4w3oIEXqMm8BqZwEuwhRQ0URmv8tOCfreWgt4yC/heuAcJjPjj9V0koZDA3ezEtyR/+Ubv\n    kfzFHwj+iNbI/l364/6ywee0Il4eJfN3KVh2Ikf+ctRUDZj8taBJeOQMOJO/JRm/jNz9477OpBPD\n    Vr8MS8aZiNSsW4zYk9ssOWk5ebQczVg7kf+V8jOaw+YyZt9pEdn83iI5ePks5TAdhUhKnmxzlG1z\n    XO8RMhAhl+3bMoD3Csy6YCDphrJ8MdzkoNOIVI6GRqcl0Zy88z3Nx/JekHcIrJvH7zXnrRwPc1gi\n    Cc3IOYXZuc2vJZm61yK+b+GF143370Jljm4rMyh13y25UOmg1jLXjok+gwNHSrzFffm28XMUXxte\n    S1xzUzoOjhRnJc0lo2Vtw4Y9ILaWceCUpqbBf7XnYH/oaT534uxvouDM5rGDxwskglExICaTQwbT\n    k9geQwbGBOJSywaW8sDxZwmQYzOPhbm6tjlJaAuSbJ1/xphEvYeyAiuEoE2vJQ6sfvGYHj5nCXDO\n    IwPM4mtwpi3luVevnnduk+N60qQ+u/j+bKwtQ7mZsEWrEXymlgO8J7AEdFiHVJC/zZbuCrym5NrO\n    KP3MiMeIueIAg8u58Fw+XpOkbQcmcchMYN5mkcGyZrDmR9Sg+Rm5j9Rz/gzjqgatDvC8j/p9lq/1\n    mfKS0USx5HMOS0ngnD+c+9Rkna9JssLkry15AUaK36jJAk5tvxa3ygTeAvdKzrw1F3lnKeh4CG+Z\n    v+vgrxvexy1/1GsNUPcgf9fM/uVjSshfbleKmnyEnKGW+3OTDowEy02O8DpPFefhRaUVgZd7b03K\n    UjItOce+dc9lRrVFBKPsMy74pbOFaybFEdmxY4ZluWJpuvAeJSwbdoAhZCTxAlrLViJlf8P+EH+3\n    ciEdRiqOreaap1i3kIgXzCHDA8esecZHyu4EYllCZpCyA/MCx8jj+pHoQ6BDuySbhj9frt6edb0p\n    ecvj+GK5ybWc2fO6hunMpdqsplLJZ0nI52oL43tpRy1yGL+/4JS3s3tJOU6WTmBZVc7kDdcQiBr8\n    7QwU6gEzpHRrc1vvD5q9tF5x24a9wNFcGUALKpHtw/gQ1wvmfvh9nLFEM0JVG+u8+oGLiEkc71Lj\n    Pds6RK6+rAzCSqG2pn2Z3YoJ4TVJYZRYZnutXVNtdrDMMM6tG/MBU/ySz143PWs8Z8plAuO6UHu+\n    whzPrsMp51fy83H/rCDjpmM7UKTx7zvSyy80vH/I9UfJfzL0qmEfiMtkhHlTeBfAZRRkgAkSxKwC\n    pCVIcCBJSuKZx0oriSM11mtrmBK/IhnHYDvpd+TjrHW1RgKjHzVH2GLyzIvRB0Keq9R3/JJp851c\n    cYIT+sGtYz6JdluUViS6PwlcixzH8mVhv1vyRVtnATNP98uNLc7v6X5S0DfOAu42P6GFv5C7Ofl7\n    6wfpkfAls39JFIoW6WINijn551/JmSTuD/Aimg/uaxR3l8iRurXk7yuVkb9skHNyGTnyV04U0NBr\n    kx6sLWFNVFIZv7lJFU5o5ARLTs7m5LCNVGSg7EObIL6NGb7cXi7UGTz5nUdphwkvH48L9IGCdA47\n    JPtpEh0TKOzObgvufQEzkdjxIl+xdGWLtd4jeCw4kCd2w5gwJ9B6cCLisSh7q0visxR9+gnqKIz3\n    kggkCmTvM8Wk75siGVkjrahJF9Y6tLGvfnRect1HS4b6XplLEpjtK/9LXZ/MYK7J9Jo/W3rGmbxG\n    /3ecbWeRvUzeWgSJRxzIgHa/E21kljxmHTCpF8bNThA+wdHdsC/UEbotkGqPGMivj7gGtN8W5tZE\n    OH7EagDDbHwJz4hWBxiJNQ1+7AzjGiIO7nQTScwBUrnSCpotTAVOaVnDRGW16jXShwNfr5GIXgsp\n    G9eP3zvOA2rJ7pSkdmn5BK3tiTp6G+0Tkxue2NbLZgTiJIxzGITAQGlnza9wIRdl8cp1Jj/3GITl\n    4PeDQRNtJbIvMG2XWo9q61NJEDa8fzB5e6HYDvJYwGMEEr+ovIey0HwsjoEyE1gqU/XKOItlYKxx\n    0lL6S5HAPTk6U7pWcImPkvEk/k1lBOf+tpJqePtLpl8NORIYSdpviXbfjXtttS3xiW8hMS35gx/E\n    3z8kjkvxDylYfEdtFvCW2JIE3jLZkahlAm8BIIHDQHvr7N97ZP4StezfWtQMWEsjYpYMvIy1yd9v\n    hQaMqNyI1RjFUknpVORWemKQn6TgthPF5LDEE8WLS5wMWTU25PFaO3RYWJnAeoRzjJTkc6jHa8tB\n    ywktZ6NJB3Woe0JqvTFeaOFkGyUuccLdFlj7gUb86vUKdTK4YT8IjpSwxTvaKCKDg/PZQ9YZj+Vx\n    Q5ZGT7HjN5yB4PgwvuGYyI5qjNrGMTGVVXqhOuLWgjynREmtXXae5kjfuI/rX6nrktuPlCej5xnF\n    4V5fCj4ftk31Z8k+s+PmZBC+Wl3Mi/I8BbBzScpAu6mmIWbjYeYR283gjAqkjoP9SLS0sXN/YCd0\n    Sf1fzP4d7n3hDasiVgGI5+Jh3h3GZSLMVgo2UaoFcB1gIl1F46KMZ3rZmPn6gMFyv1p9d03qOWUD\n    LKRqA9cEQ2lkdNq2rW9Lrc8mpUXta7IzmqW6SS1y9yeVrS3Plwrokt8hzum0OtWcLYyKHWhbZQYo\n    21W2o7J8woVK3f8N7wEDUZUNDa9WTmFPGKCWM/qniFBhI8741VR8Qj3gAFSykwHGUn2B15U56WWi\n    WOJZ9inbaHV5tVrAcp+1/SmzzV+9ff3sQ/2V5ok0lmz0G6yjciQwEr6lNX9fx7Zv5FYjgUuxBQks\n    +QBJ+m6RGbxWJvBWWcBE75sEvhcON/5czMHeIil3JIG76MS3wh9uerbb4VHJ3y+Z/Wtk/25F/tYM\n    4Dky+PP4SmELo/Ra0G9uf8q4a5FeOmlbT/6eEsfIyc+T+Ltk8mVlDpeQx0QxiSu30TjRPIv2mhMc\n    7ysSGprsG/99UvpiKUuO+MbPijJzsdPa//9ItRkuDY8OXDCnSN1G+n4M+LEllq5FOdseRjLNgYcO\n    Pn5WgsRWTKSR6IfbHihkIVm1DTFTNSUhjKTmMbEfsVQSWspCy2NKMp1ugRxJbSGWvpR2UlfC0Oow\n    W3UmNQf1XIbNItXnNQZpdqwPQngi26GOmbxaxhzXEMMMvAGe//A7CO998APnMAU5u0fI+G5YG/WE\n    Ejo6G94/OJCKf/OxDeGahsF2IuElgzZxHJKkG9tK+zpsO4pjpVajXa5JcFy2JINTtYJTNudMsf1g\n    28IlgWoJ0CW2bQuw/dJsfpD87ornBfgc2XZUJ5Sx/9zcRxLmlkIHK1NZZHCcXR76R8R2NswtZSAi\n    ZgmzvT3CvjaG7gfyuywLpGrk797gg49juWZUDsDxDNUC0E+nBxuH8YjXJLhu5e0yGEZbn+A2tF8a\n    8HqxjZZkIjN/cTv2Z50L/ZuSGOXtmu/0TC7pU2VI323uvQb0E6eygWtI4C2So3LI+eyJYt9/jgdI\n    cQgpPiKlYlrDf1yTBfxl8ZHL8fMdzon4HX089d4bkcC3l0i7F/n7C7lNs3/fK/m7BnKDX07+2UKO\n    /OWB/iu5IvJXw1Y1CBg1chhW5m/KeL8pEwqcHPC+Z7E/V8cXj5XQtluZvDITWMvqtY5n2WZtny2p\n    Pc8Mnss2z50+XqrLRZNOrG0ij4sJiDkJHSIjQ5Yvbpf3uy2u9gnMO0nVL5RZSy3mfn8YxHjixxc3\n    y14KgSL4HOhkGUrnWkSq5sjUJHNZ9lFDqv4hIidlrPVrbctl/KYcwFLOcikpWwrZNzqTtWuR95U/\n    s+bI1iLvrXtZQqizbdOCmvD9PEOcZu35mZXSo/hM4+eTNTcdzZ9/7brOpGco8D3n34Ijag7LnQIt\n    ZgnxG7dv2BNi2ckuqqM7J7mCHR0oVtbADOKeKCLCpJ3gEgvzbGOazpOqmWoFlGq4UH4OmLMJcky2\n    7MIR2su5grRdsq+tyWBpt+e1SePPoc0FtHlEX3DfrOtBuMLvKU2yB6ll2Rd+h/icyv7lfFCTdcUs\n    eCtznSjU1E4FfDW8d9SJe6Pdbc/DfsDzZQ5C7igQmIMYMzCwU87/+W9+Nk5jaTVNIYjXiHGJtfip\n    kspEkgwO168/wSniVguk1fqxElY0P6d1HSnbkLMdFumr+XR5+z/FfZQkcMqXzCTwVvgk/mVIH7zm\n    ky9J3rJI4Nqs36WKpJIH+e2iXrbDGlnAFhm81yzgW/OVN07G7W56wnuSv1ui9OG/dSTFlxufrxZr\n    SD+XSECXkr/y/Sd4EdXV+70VUnLPvK9UDoSIZlIu2JdGHGv1MySeEsfIbVS0zWXbyYh6uY23S3ma\n    Czn6LO5ZTyEaew59ocyZTL5u5mFaoIdr4XpV8/6a43o/GAidaME1rbmymOBoruv9IkRBh+xGdNRh\n    1oWERq4RBdUBPAbJQNwWEGS7rNqDltNyLp2ok4OyPVHauVoiWSy3lTqgj4nXUuC5ZZ8pqc0lNYkt\n    +eaSY3qo5Vgiq5mud5k+n5QZfyZ2Ws+fJyR8JRkjCRDex9u5LjU6qS7E4y01NYWGhl0jJryYvJIS\n    tygjT6JtbEdtglRm8T5TLEGcI3OtcVNmm2rzPU1iOScRzMfhudewN1p/aPPWCrJaaqtLlDC0+1Gi\n    QILHy3uMkNLeKXuLJAfPC2O51W4KSphn3em1Ns/UQdBxuCZ/XLCLrLIh5dC59MiFwjqk9N40vA+E\n    ILl5oJT1avV/94mOYuKWKJ47Y9buBcYDtJlx+ZZ5yRgtKIr9bEeD1NWCeDSFKaLYv4e+wFdK+xVT\n    JLFsm9un1Q9mPBMrKs6v5UTO9LnysYgXOE7bT0QzErgGNb5ionJfN/vO0Z+OKCGBiepIYMRaUtC5\n    ZLa15KBT+HLFse9VCvqeWcD34i1vkAV8n1iuP9/hi7xXMelrsfQH+2WFc1tSBRjZco/s35q6v0vJ\n    X6KY+L2G/JXHcpRVqfG0jHJJtFaNQf+aIH81lGT8WpMiK2NYI764lscTzcnco3EOq96vtoCXNaWw\n    Dytjd/65u6m+IcuzzomQQNTgS0bnN+pvP2gS0A0IJLsYnLmIdX+HaCyYB5mkMnq07bxg55quPA7F\n    wTlyvAr9MXI1da12KadwrsbhkcqcubfORloD0rl9prlkp3UN8h5obd+ETbekuiXQ6aMpaBDFzyU7\n    gaSzqFf6S5Es+B6dSv7fOGCCne2YVdxTF/12GvaDZXULm03dKy5EahAlzr1jCdPQNgRPhfEkRdLi\n    cT3RZEd5/EFSOJW9Oyd9JeZy0IiSQB7ZVuKsvLYon3ALqWiL9E0FjTG0ALmScheMEjtKNLd9Xkba\n    vg7v1LeztnO21AGpENvRMO+Ls/titStpZ9v4uT9ohF+J/WzZv/vCvKZ7GDdQScNSDGJ7KNcC3EYb\n    T3GdoB2HkGVqcDuWPmKwjxD9g+w/tP2NMazawaWJK9r2ebbuclg+XTyH5Rsu8Qe/Ul0SUy0JTET0\n    7wraL1XnrEkOs3BNctot8OXG5ytNXtw6E/gjkMCYlLsxCXw7c/7Rs3+XYMtoDcY1evTXkL9LB+ca\n    rX8LJeRviYGSKDGEJeQvt+EaTXIfSnnIrFwka/nYZ7InBHz8KbG/BFYt3zWRck7ksoBTx8vFu4/M\n    7rJR89L5fYbox0CuxNcgZWB9iyAFK8mhhvcNpPHYGaMtsFHCtIUA7BPD4CInHFFMfElHCz4bvM3L\n    xXeJmVu86MZIbaL5mHQhXZJY28dguc2U0xOljxG90jaXcawRoRpqMp0sWUj5OlE3vaT8pSWFmarV\n    mKtbmJPrlH1a7bW6kin7ydlIQZ5tfm3y3AF43tjBcx6FzCnRX9yTm+TgWO1D1r+WzkuiMHbOa5k1\n    7AtM/uezlkKWU8PegMTEPLt3Pi4EO8qBKZ1pR7FeIY8nPMfnLMsQdCRh29J5QKgdZIqwgnZiCU1X\n    QC7P22rnlvYpF2TEr5R9RDtaantLiOMl2c1WHyXnQxnqVBtup9lcTelE2+f3u6kOtXZefC4lNHnW\n    sA1/D3zuYLuxt2ZH9wUeO+fKVOmCClyqqj0P+wAGenjE8+t+tJ4YmDzPAtbHHrlekLaJ11Yk3peU\n    vtKDmmz/H4/BTAKHhJH42BJiV+Kp4G+JkBEccIIxXgP6e4liv7BVO9iSfH7J7Ge80txvbLVfQgLn\n    pKCtbSU1gRkpjuCeWcAW71LDx3xZeP234JUa1sOGJPBtCOB7kb9bo4b8LY2gWANfbn4n5lia+ZvC\n    NRE9NUDDdK3sMxrMGvI3tQ8JYoaUGCklfzVpkhP5CZBWY+JEbib3jJMWzMaVtX85Gg/xRPqkp6c4\n    Co+Plc4QlHNBGTI8TieC59GMbnYfuijDSELWOIkX2KGNRQRrsnPoPG94/0CS91LwiojhoU3U9gRH\n    ekYGAwMEkOxi6T57cWw5fd20YD/QPIKbF/U5R7UmuyyBMpYpRyqPz2/gCLYgHdQ1WUo1zmQpM4mu\n    MUneWi/rfiwZy+d95z8DSoT2hPH7Fvi50PoKjm6UpgxBKrpUN35njJB5btWOi7ML5DOKNa7xUyG1\n    x5m/F3BpH8d/2xi6V/gnQM9WasTv3sHBHsEmddE+HKekHZVBJfwvB6vIfTKjKa4/bI+FmFnJWcK4\n    RvBj+hxBDjo/hvNYL8lghJSRXss2pfalXmhfa2SelxDEst9ccFXtOeQ91fens5Dl/fPHxfMsH3QQ\n    iAppS/l5twIacJ8MosKAGRmUikFVDfvCUiWNZln3A7Y1mo4A4jKO1Thu9EDgYjvehnYO21mKBhiE\n    E9YzeL5Qbge3EcVjvK6gMT9O+iLPxhr7TPNAHkvlUNuuJddoSTe1JLB2rNyfI4GxXw2vtH5dYJSD\n    llia9SuxRqJYCo8gBU10WxK4ZQHfDrI070Yk8L4FPbZ8ULYmf+8p/VyC1AD3KOSvFim0loEpQSl5\n    XIPTin2m6lJsgdI6v3K/lG/hCZ517FH8mwJn+mLf8Xu/+PaO8Pk1MAZlwiydDbLOEx4XL7Qa9gKs\n    QdcVvGTkdcO+YI0LAW56VrC9hhQhjEE6cX23sBjvE+OZS+xjWLXVpcOQ+5JO1flYmyaDtXPXYGtJ\n    yhrHuibDqd27VIb1Rfk8pVlMsi88N38vIRsotJ9ndMfEA/ah1QI7gJNl/vzqJEZc33Ne2xB/LwM5\n    9dwN+0Ag92yb6kS7hn3BIibiuqfxuJAi/hzpc3eiMPfn7RLaeJ+yhzKoCG1gqpYvUVrBSJZAsOQ3\n    res/k22TcsduSRBeY7M1hY0SyHtpfQdaaQSZdUbGfqL4uZPzsYt4Ljpi0qKbgqOfEp8J6/4iQiBq\n    3FaSeyFodd8+wo+LeeBp6oXHNf/EfoD+p5ALHuC/f1anC+OHFghFxjaiQEr2FNaimt04Es3K1vB2\n    hDbO5vyBRHpmbulasqTdteqHOd8rkrGl5f3W9udafu0a2WjGpwXHLMES/iB3TAkJ/FuqR60q65cr\n    780W2JoEvhfumcy6AQm8ZsUXHfKG3ar+772iBO6JL5Xtl8o/3yq6hfGV3M2WIWsZpFuQv1pk1jP5\n    iUGJpDO20epeYBsfsUZReyJPsp+VPmRdXinDMncu4LX4d2dy0/fB7XHi5yhkKyPpy9HTWH9QzzLu\n    ZiOg5TRgydNQr1MHT2x70qMqg/xS+NRtQbVv1EpmNYmtfUJKPIfsnzjy2I1OlguQwWdl0c19urG6\n    oR9b/BafzXShAw3TuCVhy1iGa2SExXw8WoXatUwixvt7GOncuD/lWI7lqAfYXi4FzZ+tZH8//bvs\n    N4fnqZlN1xKUrDZRc51lAVBzR4wV0e/fB0gHOBMJEpxZJ2sTXtRnnqb9Pc1LJnCU/mUkZrgf//w3\n    7B0cBFDihm529GMg2NKQ3YtPxwCzbGkH52oFIduJ5/lvdBhXEwOdqKNuHKX6aPYez+Q9SRfeHyiM\n    bRdoi9lP3I+X0def79jhbSOuEz9M/Vm23rJHzwtH1b64nSTL4/tyDbT7owWc5a5V1r88KPcEs9ws\n    2efemMNJO8qBV5dZH+EznEHC3L/H+xgTyQ7+lrad16JMMLuikbVhD9ADUK9v2/C+oNnEA2k2NJb/\n    1gI8aZydob3tiEa5536cq8d28TvM8bkeveYZO0CbEDAzjOqAvM/RcdzG7/kTEAUlwWF8nzqfG/vS\n    /J5PUw/Bn3mkgZ7GXk5T29AnqjE+KefiHk/jeePj5jiRoxca1H0Sb+QW23IN38dzr4HPRPTraldm\n    o9vA2/pPcvTDB7KYPxPRXwrb/pUc/bTRvfmFHH25wX3/Mzn6d3f6fv9Ejn4nzv1HIvrX9U6xT3P+\n    SHV/l2T/LsGXyvbX1P5NYe3s36/kFmv1lwAzgmtqC5QQvDnpjO/klTs9RQAAgABJREFUpn5ejeNR\n    9hnr/VqyItY+3C9RQv7K9qn7VVo/gzLHSxIZoUVla9LPWmablJLRMqKs7DSUBuWFtpR+1pxKw7Qv\n    zmDA41ve5z6BZH/Jq2Hf4CASlNQqqVmqjSsofMlSf9axsq4hkSRcYwl6jXDEzCUrM8dv78aX/ZmO\n    ZNcKtj6DJgu9BCiJWUOqWtLP14ZSSoltKZOdJozznwMlonO1HK2srgsEVVmlClASk2VVJbyt7ITE\n    czjHXCYzPpYh69HJjNCGfaHWRjZ7unfoCgCy7IaE3+5hZTGdqYuyfxHn0YIHOziHFkSDQFucynBd\n    UgJAAypGoF2R8pxLIe3f0uxgtMlLg7I0ueeSgCueh3AAgIW3cW5j3WtNbhuhqULJ/Yy8EsxcuhwV\n    Mqzs9S7Td1uP7BdSPaNkTSrbNuwJIbEB6/9KHxUDxytZrgj7lG3R1nQ097tpyhXa2lCTgdb6kpAl\n    6XjbOdHO8o3ytWlI1RK2fLCp/lLHnYRfGLfjsS8UlxCUvulXCj5ozbfN+17g+DWTnGp879fg1nLQ\n    S5PlHjkLuIbTWjMT+Hfi/UeQgtawYiZwc5PU4hHJ31siJWmwhfTzrfCZyuWhc87q76OBfKEg0/Gq\n    tCFjH9G8dnBO7uP5yv2Mk7k9/swaOWtNlLTav9Z9ZHkrGcFn1Yd6guNIHENin3SwyzaSDJF/oyM+\n    TFTnC+v5Ql1biHOmwrxmYgkZ0vA+gASFJCxkOxkY0LA/hEzduOYzUZzteBHPjVZfvJucjDr5m8s6\n    kdmdeIzlMNWOsfrV24XafxIpcjp1LTV1BGuRq/Vr4UxpWU2t31xtZGmfNPuT+hz4r+VQRkLCknXT\n    vmN26FiO5ktkOwM4K1g6kGTmL27nT+2U7RfY0ySA94cldQvbM7AvaL99tKMymOoC7YjmdhSDo86i\n    JAy20YJnMMhFs184ZueCq2S/srZwzR1KXQduY5uD58HXmfK2LIelNrQElu3PEb66LZ337ZR7ie9P\n    EORmzTtScymrHqYVNNAZx3HQApdYOIp9+C9DI3f43K3m676xxI629em+wHbUZ6x20ZrUat8pW3kb\n    jqPaOuNA+vjGyRp4HNolgm0Iza+YqwWM7T8RzcrL0bhNzhq5vm+qFjBuk75QKynnRLbPVaLUh2ud\n    E0lgC6UkMI19pUjg0sDub+Qm3/snyvvhb1nGsRQp7mOJDDTRY5PAj4JbkMC3Ui2+A7YlgO8h//wo\n    dX9viS+V7bfI/t2q7u812b8lhuQTbUf+MlK1EXJ1E3IGW+Kl8Pivym/fT0ZcMpoMa0tK8pcnSQhr\n    UZyKkuMJoUXkxtF7+kSSYS3sNUfBQTk+FanIx2vZdQ62B+hObWth3vD+odMVpcc07A253zZmJxHN\n    SSxWCuDxxQqikc/PhfJ1ENOkr0uSvuwsdaRLCs+dA2W/iVw2Tc4hLbOALKcrvl7gdSx8lZ5Xc/xb\n    tQbxnpZkQ5WS4Bea16HUkCOYL3Bt8r5ahC+SL53Sl8zgxbYa4Sv7Cfe0G4XRGxoa9oRhcLPAOg0o\n    uawHgwSlgtQ4J22sRsJhPfaULU3VvZcKDOHadNQGPPG1acdYih4pOyavrdRWon3VSOfc+TWk5gEY\n    LFWeWRzPeaxr4/JCOeI5X8JBn8vxZ7bmXoPyfdF0n3xwINpSpxxnBUbwvlYHeJ9YqqbRVqb7Qi7Y\n    V/d5xvPv86jog8ddjPEMkQqe0e2ay7a1FAPRbyhVAK3jNGgkMPpF5TbeLgnZ53GbRg6fqVu9dm8t\n    UuTuS2E7ovKElo4cfaayMoxLSeAfaJssYKJtOJAtSeC/XXG998oC1vARy72ulAW8r4md9SD8rrKf\n    NXBN9m/ND/NLZd/vhfxFpAbsz6TLR2xB/ubI2lTU1BKUkr/2RMGK5LMln1NRZk9kR6F9U8YSOaHS\n    CGIZVRf+nsu88H7Nga45NKx6vkTB8a0trDX5No3YwON5Anymjp7Ij6xHyk+C8a45KpOCbXg/wAoO\n    rvClHduwP9iOa6cSYPx3P8pTxsfMndJWxDXus5ySrESQysiV2asIdPii7L6EHGsvlHfSys+FrzN5\n    u1kq+6hd8y3AEe4y47fkGvqCe8Tt2Akctmlt8tlZ/Kzwv1r9L8tJTqTLMqOkNG5jW4pkcJz5GxMv\n    /K4jp56nYT8otaH4avOpfQJVAg6J/Th+YDakJGqlJK6mZKFt56AsbUzUCDzLjlq2tI/a6WN/KaEr\n    j+GXzAheKr9ciyWqHdLen4lUkjhn01DpIqVagvcGg8K0NtZ5ZcYxyjPLdhhQHLbPg43l/ZBgO8r1\n    O2U5Is2WMpoN3S+kKkbNmpQzRhveP+YlyGLgmjMeXeK5Oa9Fw7pVszv62k8LQNUUonKKfXychNZX\n    qPnr8WRsZ5wLtmm+TezbUkdM+VutfW/iV8lkrEUmh2Pmf9cC/dk1JHCpH/zbSAKXZg5L5KSkty4p\n    +Qj4cu8LuAO2JoFl8uq9ZaCJViGBt3N33Tr795GiAH6m8kLZ1+BLZfu/vzPyNxetYw32JYTuJ6qr\n    O7CE/I2vKQ1plDGL+KSYQ63e74vY92acqySy7GRMpjS5km8j6Ulk1+31sioBKO3M0EhbCZklpUV7\n    k9Knd1z7+k1Hoy1vY8e5dZdYGi18lm62IOceeMHEzqie2CEl721etqzh/QElvrtMO/l3c1zvD5KQ\n    QAJLLmePxOME1jTs6EA9DeTHM16kD+CaORDLSrlx3AmjDY89Wt3C4CAMuCgunzmZPFBPqdrCwzTm\n    8hiI7fqxDQPbErT3ATe6+4nPx/8+K+3kZw4R4fG/S2DZrVTWdA5aSQIraEk7Z64OJbZPzQkuo2NB\n    1vDC/d5uhvccBHVR2nE23oXC+IjXzMEMw1jbkPsjYulCJIZD39LB3bA/8Pcf3qfbNuwTqdqmA/nx\n    hefaPDbhmIMy8ThuYW3guUJBeNoOpNvRy2hv8dieHJ2oozMRHccz8PG8328bonEU+wznHWaOYc2W\n    8znwX26bsqN4zT05eo5G8PT5rrGfCG1dJz8HA2VCU59Js6Uu0w6vR2sTk/ah75hInV+TJfustXsi\n    /8yewUZikLCmosHPOe8/jXZ0oFhlQxK+4XvFDD7XyOAdQtrRkvaOhmZTd4SS4DisJ47/92NgN9rY\n    y9TW1yPvxVk82DYy+sTYwvbxjTo60GVaCw8U269A2g5Tn7zePMN5tJniGfrJ2cQn0qWacft5/E0d\n    aaAnOCP/chAncvQ0bkvV9/1Mg+nHfSbdx+sTeXzfeNY3uA9vcH5+/5z4/Oy/5lrBmj/7+4rhIZ+J\n    6Fflvs2vy9GraOOPtfGVHP2OBvrHKlca45/k6IeVQ2T+QY5+84BhN7VZwD+t8Bl+R0R/Mvb9Qo6+\n    POB9emDcZmp3T/J3rezf0jT2a8nf0uzfL5X9rkH+LtWyX4IfaTvy141RRmvBIn+ZNP5G6agruQ9r\n    B2t4KdymQTp6tag1bMOTExnB9pQ4XvZ/Ljgnkr+aFOYc+YhAK1NYRh1yRHaJfHQspxWc1ynJN16w\n    y6ymRvruH1oUdekxDR8DmKmEtcEHUZdJPhMXMabgdoTlLLdISEvCsieWA5xLI1qyzxKpurMWtHqG\n    8jW/1vglrxWzknMylyUveT2HzHVruBS00SDlNK3vVso+W23YjWyrV9jXj9+XFfiiPZ9WXUOUO0dn\n    laM4O9h6xhsaGvYHfWxx0ejkncaOehhJ2L460ZeVDXWJxhx9nLHHnPRYmaqRp8lBa20I9nN2aglK\n    7JFsx9DsyFp2lG0glpOQRKu069Znsq499VlzwVVWlu/B2Hahji5GRnVK2tl6pkrmeXJfeN75txA/\n    7wfl+Ib9o2adqeWBNuwB8XfKwVEcqBnPzePSZ0Tx+FF6Dm2clWumWPEvPzLJ8fWsPN2lSoHhqp1a\n    5k7CKmeH25/hvZa8g8djH7lkHe7L8v/K7TJhCPfnfNRv5CIiWEMuEaoWW2UC/0qOflz1SgO2SIqr\n    5W++FLa7Rgaa6Dql2y2wZSLoI9YCvjILePsp30fL/H1EbJH5S7Rd9u8P5AfoLcASE2uhJPMXDWsu\n    k7iUyNWQkgDRgHUqZHTbM6XJX0vyBKFNrJ5Il0Phtt+pM2v/apATOK22B5EtUZmKtifSpZ95j4Ql\n    c0nKNs7oY9dUTAI17BkDfP/8atg/OvE3v3y0czdrl8rAwGxKq39sK+Ut57AJvwt1dBJXIWWYLSeA\n    5bhOOZXjc8/r5mp1gTUZzfh1e6Qc0lptxNy9wnuAdRS19v7v8LKzs32GkCaFSRTIYA1YG9qye6ng\n    qE553yl/49HD9C8/F91kO5EIbnZ036iRrWzYHzDbP5AT8XzKIm/5eB7vnqh8vLhQvqyCLgcdB9fE\n    +9yosuDtbEouWpKfmh3F+vXYJkX2WnXtNWnoW8lDS3D2svws+hxg/nklSS2/NytgSyI118F1pkYG\n    DwoZfJmeCWv+pa9drWcWSZl0cIIHrkOOFAcitnG0oWGf4Lk0/85x7PQKUy5aOyJwLNKCorTxzKsM\n    zMc+Oa5h5q4khGVySK4UgoRGFKdqAWu+ypKkF7sdK1TFYP+r5h/N+XRPRp+lyJHAr5n9W4H99Evr\n    /ab8/F/JbcYxEDUSeK94RBL4CmzrJrk3+XvL2r9r/Ai2yv7dAqkB7p/kzP2/GV9W9A3LPi/J/s2B\n    6/6uhZJoJzaYLJ1xLU5jJBbimdKTBCvi7Gnarh9/MhalSP5qExZZ15e3UcE2In0Sx7UkEanovTMc\n    x5M+JyaPkljAvrR6XtrfMgNB3z4HOiGCvGuo19SwH8hvtDmrPyZ4FAqy4GEMCHJcPvO3y/SCSI1N\n    VmYk1gBOZeWikxXHTy1wBjN2ENKZatX9yzmouU0ONUTq2tCc5bVOCvlZDqQ756228rvVbZl/nRJP\n    mkbqWlndWkCCvDYtQ4lrcWpksAaZCSz7a3a0oeFjIIxr8ZgglQJC+6AYMBhjjlYTNRWYyWSbNdYS\n    odpEGU6TS94mBC2iUaIkyCh1rATat1sQwjm7fe3nwXNY9y13fp4bzRVWAjT1FcuW9gW2lIy+LcJ3\n    MJ8lpnvtti1AdY9Y+p06Gob2POwJPA7I4Ckcf3CflJ+X6wIHfcht1vm1cjU8XuMYjOtAq+SAVQtY\n    QltLhXJA88xf3GbVC5bKiCkSGOGTd2zkSF5rf43yZAo1vus1s4CvTdbKHd8lrvVHCnyFRIrj0LCW\n    eupWyXzX4pYkcI7Xu3U94C3xp4JzXZEFvB0BvDOmPIlbkr+1WGvAKB3AcsRvClsWZ68lf7+TKzJk\n    axG7RCES6x/G71IjaZ8pnTUsyd+c5DMCJUu0iYeUSLH6t2BJPmuIF9/6YvqgbNOOyUuC6dm9/vPN\n    vxusUcjv+RhrEo3brHM17APBlZciJQIp44ha9P1OwRlLuIgOY4CdaWkHnYQ2vM/K9pVZu9jXiUIW\n    EmZvPlOeUC2tSVu6z5Lzd+SSGUqlmcXaNSx98W+21hFuXTP3yzY3RfhqfVqfj7PLNMK35B5ZThqt\n    HUMSvp6cpSjjTjqvS1QwUEFDQxs794u5LbVfLcBqv+CxAm0pUbCvLBs5iPGlZNwi8mPIkWiqwWrZ\n    4FLJ+VSZg9T4a2UGz1F2HUcKtsWScl4SKNXDr+0ae1pip+V5retm28lZ19qcopZULpnrWPePSV38\n    HKcoUKzsHFYNYfmsp0jki+gPZVYd9NdUqfaLJba0YT9w8H+ieEyohWUPreCUnuw1haaAIdUUcF/Y\n    lk4ysZNFQnYxJ6+Urrk0fyeTzXIf+lC1zGIrCYf7yZHArPzxXNAvUZB1LkWJn5vb5HznNSTxJ1qe\n    BZwCJ5mV8A4Wd5EigrdSSK3Bl8J2a/BPj0QCb41H4zcXksDvd2r3KNm/j5z+futokWsGPB6Et8r+\n    rUGJcfpOLmkQX42/c/1r9YBzBj/XT4r8ZUiSNyVDYvWjZQJjhjBG0WnkrxaFPV+g25+hV/ruxYQu\n    Rf5KMkOTq5ETXWuRjQ4j6ZDWsg8wE7BhP9BIiiYB3RATv2XtU05nTTpZg0bYotRXGM9s6fuaTBe8\n    Ps2Bi3VvZVtJrJY6p4+UdyZfg9w1LM2IktlEVtZ2SqpyLvusX2eeDAn7ZeaazDKWn5sz6S4F58U6\n    voyQhRBn7GlOavl3w35Ray+bbd0nkKBiGcuc8xoVAjjAThuftBrA1jiWymrK2594jMXjrPNyZnAg\n    bXU5aEsaWX4mrLO7JrZW2sDPlHLUa/OFVG1lrGVsnU+DJDbm+/T+pLTzGYLvAtJ2WtpSq+QCPtfW\n    uHhJ2NiGfWGpLW32dL9gNYD8OBGAa1KttIFU1SCy1BLmbXDfkbyvUwukyvkQSenbshs5yecnZRsl\n    jkHy9kTO9OWWyjejH9Yib1N+YS1DeG1Z59KkqNIkK6LtSGDGNSQwURn38ehZwFuTwH+9oe24RWnY\n    vzyYLVxAAteI0ZXjL+To93e8EfeODqjFFtm/aw4SJQNXagCsyfz9usG94OzfUgOSyxS+RuIidywa\n    41Rm7wvZsiqWQX+iPLRJiiR/td418jcFGZn3fZxKStkXCzwpxHohoa98DcIePseB5lFyh6jdPFJR\n    i4zOxcmGiTUe4189oQRsw17gCre17/zjQMtYkrgo2/1x4UnpKH5uOvLjWCeeJu9oHISjmI8ZIqdz\n    pzyJgdgbpvOwA5r3H+C4C7zvlb5w20GcT8/IGUiTz+Tr1Waxeae2Tm5aKHVm10SPy+vsyaYUSrOs\n    Y1s3z2qbt0mfByUpSdlX9hl95u9AUjZubuswGKGnDmoShv34m5G1QDEj8JqMhob9oDmt94tLYsxk\n    B7asVxhKMPjjjxTb0cs4XnF7DODsyFGv2Ei0nRewl379Ebfjq+P+08B+PSwbmQPabHnteDy2ydsy\n    dnTrmGfBls90S4K4LuIaz9N23WYxgYBr5ENizsPHaP3gc4LHHcRxnEGuZbPxtTKx3ynbiEJQnva0\n    c1vcwwEO8zUq28jw+5C2lCgEKad+Xw3vFzIgvbR9ywTeH4aq37gzx1ZsQzS3bQcKvskD+TGohzVt\n    2ObRi/Uov/d+v2Cz5Ht/BV4iutTefKeOXsbRPHfEE9FMrhnL6WnbNTzD/XiiwSSBnxLX9CZ8Arj9\n    hQb6rhzzQqRu1++LG4+Zn+OViL5mjn3J3M1PlF+nfSNHr2M/+HcpPhPRr8a+r+To09jfD0T0z0xf\n    vyGiv1edfRv8nRz9ZgOv4d/I0W+v7PdnIvrLDe7B74joTzc4j4XfE9F/JUc/b+y9/RM5+t0251g/\n    A/gWrHiK3d+C/LUiF9bI/t1K+nktXBu1kiN/t0YN+fuJ0jUBEFaEkze8OiT5WxIlpZG5L2STvKUR\n    ZpYUdCoSzZFbtBzEesHy3Dmil88rYdWE5PpUWnS4lvGb2s/btGwBi1jWrjfU+CV1O+P96jE0NDTk\n    oDlaYnewrg6A0OoWatlC3M4ar3XCUN+HWcEWrqnRhzKNqbqDsl8uf5CqSytfNddXk8mUqmk8z0Sa\n    lyzIZTNp153LCMbPXVpPUO5LZRVxG8yaOhBFjmx0aGtBU1jHE9+X1LWWQPKXqBF/e0SNA7o5q/eL\n    0prhiMGwkUTz7EfZTpun89jISJVEQEne3LXmpPiDMkNZxm8J8BhZ4qBEGrqmTEHOnlpKISX23JLB\n    TJ3bwX8ln6O0bAUCpZ81m5yTQtUCu+x5TwwtIIqz4LVnUZNWb2ho2B94vcm/dA6wlJBbrLHjII64\n    QL/xfu0YHdo4+EL5MVdbj6X8l7IvVCwszfzV+7UtvuVvlTWHSzOEESlf9Itoh6gpa7hGBnFJacZv\n    8N2tnQmMSWfXlKG8ZRYw0ePWAya6nTJuiu+7RRbwo6EyC3hdyoHJ33tl/94y8/de5O+XgjZbDwxy\n    oFtD+plo/ezfbxUGo6Y+sIWUwZV4VY6VhlQzrKmJgLZPq/+AE4uTcsxTwXEatPoZcgKF0OVayNwm\n    z89ZwAdlm+WM5z5T9QwtokBzhKcmoHKRz5NrbdRti+39I+WQ5n2Y0dawP1gkmDbmpGqcHpTjLhQk\n    hK1jz5HzdO6U5n2p+nFEFBGMCOnk1IAOXk2eMUXWWoSnrD1oIXVd8z6XI3U8Xic7nkuzaaUj3teI\n    dFMN51w9SUnUyn05J7YWcIB1iy3JSpnZpAVVybrUJNpIEsaR7bBq4+e+oZVRaGUVPhZwvkQ0Hx9w\n    zBkStkgbh1j15wxn0Mdor2TwRDZpieOmhpQdtfbLsR7tAFG9DDPKQpfY0WttZOnxOXttkdXzfXbf\n    2hyECo612pTaUvnsxUFTuhz1/BqcOZ+0g63m1yIz40uOa3jfwAzw3KvZ033CWuPx961992jLLLuE\n    73tjvo/gRBC5rmBoY+kL6UkcWttz5tyybJwGK4GlhBTWS+r5ecNztN3Gc3RsvL3GL1zqay4hgV8S\n    x9dgDf/7WsiRwNcmta1JAm+BLZMSt5CBvrfi7y2SXv+0zTnWI4AfTQ97LdxSt/zRsHX27y3I3zWR\n    q93LxjBnOF/FcRo0ApYznrS22gQgNTFhGRM8zzPZ5K9EbSawnDQxZN1euR3PmMr6ta7JKW0teS9Z\n    k0lOcntj0ptyZluZT7mang37QqmABzthmiT0x4HmqONFN/+r1SZkWCoF2JZJUqIwJkqSN5eFwtsv\n    4prihfq8JrCVbVyaqYT1n1LHrFF78BZ1C+V9TLW1iNrgZC773CVO9E49h0cs3ezfPxn9dqR/7/iZ\n    L6IvhkXiDDP7GsBEUCrDr6GhYT/QZANlgJ1F/HZwvDaXH4SN00jgVJDSxSCE+bovFI+xmh3VkVfg\n    6CEYKFdHPkeMpkjOtbBGoFXK9mFw0guVZSprNpeBwVqyBjMfqwXUIeS6T87B4vOHzKccGaytM7Hm\n    dUlwKT//jfBraPgY0MaVoEzlZtt0lAecaHbFGr97Sq8ZUUEwpcCRSgiROI/7kBiWGbmyb7nvicp9\n    pEgO+yCufLk+S8FRQ6omMOJaElhDTbnE0kxg/HctSP5haSbwNclwS/Be6wGvjUYCL8J+XCRN+tlj\n    rQFh6yiVa8nf1DHfyNFn+DuHEsPDhixn0EqlM4iCwS2JnvoN2eSv1mcKT8axGkpIVYlU1i+SuNxO\n    ksMaQWy9x2uS+/A6NSIjlQXMx5yoM6MS5/fBXjhrUpetvtLHQXOoNMTQa7bNW8UOa02K0pLLxTGH\n    z5ZapLMTMZU9uiQzCDOL2IFaQkhKW4COaW28r0FMcnaEEpC1L74WzRld6zxPyUtqNQS1eyCJhdpZ\n    vnTMyKwwLXupV547T8D4XF1J2GCGkhZsMET90SyLjp3U+1nBNJSghpxoRMZ+EX+vLrEvtLAUVlJk\n    HSk9Ddms4DC+MRHML3RSayVpcrYCx3TremUGa4okrbFPuZID19hP/C8l8VyKPtEXzitK1EJQqaMX\n    Ni8XeGUpR+H3OVdysbJw/VzlQmSSytZ7GbSHwGw/Mo5raGi2dL8ImeBx4DFRyAK259t28A3+S+T9\n    aTgGWTYplQ2sqfBdqMuWD5L7NbVCyycp8URpUhj7xH9zZfa4DZ/DyvrNHStRKiHN2cGlGb0sF50j\n    mL+TqyKDc/hMed9+La9Q0740C9gihG+ZBfxl4XFbcVRbJVXegwRGteNHSYKtkIFex32CH/we8s/3\n    Zv9r8Z7r/q4p/0y0PvlLRBP5uxZKDNcLzcnfb4n2NeTvC5VPABiczUvkJx+1xxPFFEUum1i2syLY\n    zjAhe8r0q+3jSZu2ECfSHRopmlWSGtaENFWHMCV5iftTo60zjm143xgGv6wq+07Dc/LYFqJhKSz1\n    AC170SWOI7IznIKzMM5kspydTPAxeujHckpLJ7B0YnLGccpJms9OctOrluytzRa26vWWvNKfoex6\n    UtfHhDd+T71xXErC0coothQx+H1KqYLlKnOZzSg5rl2bFQBxyfwuLLTxs6Fh37Cc1Ag/XuTJNZed\n    o9njWhzc6ZLkm2YXEJrjOxeoqpPAwUYguXqirkopw7Jb1vZr7GiuznDu3DkEFRT/ek70kyLWe8WW\n    aUSzNW+ysoLDnIdm+zCj/AKfQSOOrZIS+PtI2VEZrNXWo/uEVExYq23D+8acYO3UABOrNAERzeyp\n    FvDZT/3PA5Y0aEG/VjAs25Cj0U8KT+OL+7N8lE+F2yQ0ErjEP4ttkByWPmStrxM5ei38Bed80t9o\n    7tsuTXy6lgTGZK3PRNRtSAJfUw+4BGuRwO+xFvCeSOBbYuUs4Oundvdmvbf6wrfK/r2G/P2y0WdF\n    1JC/S/Hj+O8W5G/OINQCDZZlvDgKCvGN8oYU91sRVC8F/cj+SqO9uO0z6XUlGKlItxTRK8lgJH9z\n    k7Aj6TU3EAfS6wKn+kxJgGkLegm5TfscKKNlRUziIltmMzyuOW/YDu1b/2iQDmt2yuE2q75pru6b\n    Jq/bi3HGGt9KMoWkw7NT9kmSMiXT+Ez1Dt0UYkcyk8gd9eNdXupETl0/OpRTWU1WVo3m/J47Y/gV\n    Z5KV1PzVgJH48tpy2eDy+z0Jt7LmDC+rT5iXk9OCsFKZTA3vHzLnM/dq2CdyNb95FOoyx2jjEPZh\n    BdnwsdyujBz2SNWMxXNLlKxNtEzj1GcgoizZKlU38D+UV17TfssAsH76RvNBZUuR+gxxoBhN/2rl\n    MOQ9m3+m+f21vhdrJXgUx9o1ru3nUgZPyN9KSdByQ0PDfjAfQ3T7mCp5NlcYcNE4pQWKWiWCiPI+\n    Ozze2qbJOJeUAiCar1lzPklsg8hlC7MPNue7tfoo9RFbNkXKRKeygHlfKQm8ZuavhlzC15aZwBpq\n    kuQ+cj3gW+CXG1//O5OCXnd6d+vs372z/XvEj1ccuyTzNyfvXCIR/Up1Rmwp+VtqxPEYqjwWJxAo\n    L/KcaH8ml4x2yxHEUgZFtpWSzyX1QFKRgh42MWzJSltZxURxJkEq41dz5GiEjZapgPKWDR8Ftru6\n    PQf7xJKsRnY0a31Jx6Ml+8vEZMk1pWQqU3KGpFyPdh3yvL2yLwdNPlJCcxav4Theh0COKauSvqw6\n    V5YzOnX9VgZU2oEdbOBZlEeQny1FrgxUEmCV/p4ubdxsaPjQ0IhfmxDj7Ma8IosVqILnooQtzdXQ\n    1exoqva7fQ3hnLIvPk8Z6sMnciT0GtAUOvSrj/8rdfDH92r+uXK2MVe7WQuoszLdUrYUr4/7wFIM\n    KSUNZ/wecnayyT9/DHAgaurVsG90s7/l2OShzdsvFKvkXSiNEEA6H2fLfXy2ndJK5VjA/i1JaIsE\n    lsjJQTvKS0YTxck3ucxgy2+bkmTW9rH/+EXZZkHu1xKhGN/JTftyvvS16/sSLSeBr+ErEPcmgb9c\n    cey1JPDes4DvoXq8Egl8HQF8j+xfZvS3/JK3ejBb9m/AraNyNJSSv7X7a8lfK9rKMuK1OaIlUWsM\n    nHBocs5WH1akHrZ/UvblFuqa5LO8F6n7Ifex89yuLRxPLFOZR1oEY+yUyS+iWx3Dj4NhfPEzxE+u\n    d1r61wDt27J7/5CLZUvCkrdr5NxlDNB5MvrUJOzxWNxuSUFrwGzXkgxX32fsFLckEbVzlWT9YK2+\n    NTOE5DVf208JuVlSc3kJ8RtnUsWfTaKH5w6zhK0yCFqt3/k1x9diy5jT2MKZkuh+zAyZv7msv4aG\n    ho8HKQWtgYljawzVbNUFjpUlEJiMQ7JXU3iY19UlKg0M0moCa6oR2mdI29yygKQUasjsGsi6w7nv\n    1QqakpA2N9eev9fTGAjFdjGV7cs2F78Tef0p5QwtW66jEAyH2/Ugq3wwMveZKv3Q8H7hR5Vl32nz\n    VewXqScCZedxm1bfHO1dagzFcdIqY8D9MVK+QK4FbO3j42Wfsj/Nx4nJK6nSdDkfqyx7d6JQni8m\n    fvXrKZGYZrxQ3e+8JgEphRwJXCIXnfLNa0lda5d9JFqfc7g3CfyI2AsJjLgVL7oCCbyeOb8HC74F\n    3jP5e40W/Nrkr1YknaNp1iaTieqyf7+RqyJ/U9LPpX0wSo2sFdlVerw2qYj3x+fyEws3Ox6Rm9yk\n    9+evW2YCa/vTjn2XeR9DOuKlE5snp1pUdao2IkreIFLRtCXO+4b3jZqo6uZy2Sfk71x7DsJSW6/x\n    xjgkoqDlwtqqvRrOqB+bG/dKiV9ZZ30JQTuXhlz+KymtOVhaS7j0PqQga/160ptmDuNcHzWObKse\n    oZRuQ6eOt4cBqfqZWja4paCh9ZEbJ63fD/7bsD+0rKWPjQ6C54gsiWfenx9DUtm+vq98kI3mDNdI\n    YH9FehBNyn5IQrXU3qB8cS/6SBGoJfYVr+Ha2r01dYBzwNIPS+sF4zXkrp3vgVTF0DKEU6UZrHrV\n    1pxRa3NU2ljPiFP6bSPnR0F5tn/DfpHzO+V8UwfjGPk3+tNwjSnH+SPp2b9WZq+0FTiGSuIXgXLQ\n    R2Nf3Kf+WylVQERI/+qTsv9EOp6NPizUJBfJtjVZvrKdBvalX0sCL2m3lNBdKwv43vhyxbHvUQr6\n    liTwO+U/3yfl0KSfb4e1ydotyF/GmtIRa5O/38kVk7eyHgOjlvy194c2NfUqnigfgYZttNq/1jmt\n    CZpVs2PuILAj+nrSM41xES4njfhekyyV7+cLcfs7CAttp25v2CdSC6mQFewxFPXY8J6gOdsQ+Hyk\n    nHwX0p22kizG/rhmXU9p56FNCKY+zRwyg6QkC0cSnWtmDaWAxPJRvHL/ldSomn/O8nFeOsRrndkH\n    4yURMpk6lfSXbTVnjHz+MKCKnT4lzqbUsyXlXbE/DJhotrSh4SOAx4M5QWvLQOP8O29HtQAXS3JX\n    ZjVJ0ler5XuibqyfPketLLR17FJStaY928K81Yxt7DVE7RJoGdfpAKv5vSuRftaeLSsQT9rGVOBf\n    ebCwm/Up55WldrJZ0/3CFbwa9gmvPmYFiMy383gxKGOLBNsd9JE9GcfkSvSUkMIHZTv+jbWAicp8\n    mWT0+WS0KemHr0H6WKV/tYTgxTalhDDjN5SWima8kaPv44uxBglcAsunf6ss4FvyH3uXgrawVdIl\n    kecKb1UHGEngd5IFvJwAxg94K/b7F3JN+tnANdm/P23yqe+LXO3fEqxJ/paCJaFLEGr3lvf/RMvI\n    3xpgzWA9kk4HE7Uph7qsn6RFDx6VY1IExMkcB+PayDiR9a85SqRWQ+86mvN6X6jNSGoZTPtFLlsn\n    5fiTmUp6rSU9k0n2qzkcU+dmV1BJXV8+3ju88xL30mGeq59YgqN4lbZfC7HD/Xp3WuoeaQ7h+X0L\n    WdMo7c2kqVaP0Mpekp8Tz5l79ojmJK/2PLGDSfbXiX+ZytFkLdsIuj+U1EtnOHqvIc4NJRiUMQtr\n    Fcqxoqa+OAeF5km++fibI00t2Utbwjm2GxYZLIOutDrutUDFjdiGrDe61tjeWruuf575PSqRLCVi\n    4rdsDoTn0Gy/FTDFfWnKU5otDc+TXkKE/81luDcVqgYbbTb1EYA2zYadBBHqkttrXUd6/d+3SdeD\n    on2pWsCWDdD8fRaxbO0jmmfw4t9c03cpCWzVBH4qONY6x3NhWyLvB34jV0wCE9X5sonSvvISP3oK\n    a/j4S3BLEngpF3MN/9OwHt5ZPeDrp3vvNPV5hhLy9+d7X+QGSA047zX7N2UYSg3YNeSv1k8pqVub\n    5Ztqf6a4vgROJJ6hDUJGoaWkTbT9KfJXvi+RfNb28fuUi9daoGu1urh9J9piX5pzGyfLpRKr0tHA\n    jupWZ+ljYRAvRnsKPgak2F5KGl6LxCaSi3UnnNB6tqR0HKfkJtnZe1ayQq1jDiPpW+psRpL0WqnG\n    lGP6qLxYaWMN4veQeGlIyWeXyD7L2o9SOpoS5z1Tl/xONcd0yefBa0OZUq0NtrX2S+k4zD7gf1ug\n    TEPDx0ZMfHbjvzLwNGSnSmjKGYzeaBNn+qZldlNZwdY6hcfoE83XKlrfDuxIjsjraW5jlpVzKK+X\n    WwK0y0fjpX+e66Sj8fPkjpeBaQewuzlwtjfP1VJ1ghmBULHJYm5nyZjP161EvdLSCl5uaPBo8609\n    A9cTCO0778V2LfgIIcc6S/peC0TVgOfQ1AHxX0kC59Z70tZIAjZXk5d9oNY+hEYwn8nNiNy4PrD9\n    G3wbj8Xawjksrf1b6gvX2tUSyTmsqf55C2zJheTw5YpjWxbwY0KSwH8sO+w619ctyd8ts3+3fPiu\n    wZfCdrnoj38o+3+itOTAPza8Jykt/h+u6PcbuWxUUEnUEBerl7g2YikHn/1bJstB5CcFbwvOY5G/\n    MpqtlvzN7cN+U4t5Ij8yndV9YX8P27UJ5ptBER/EuRAX0hfzOJl0RvuOPJlnO0/mC3RH8US6ZS7t\n    C1rO35Boax3TsE9o37M2BliOPe1ZuoyjSupY2b6jgQ4Uj18hw3hY1K+GOPJ7SJKc/dQOPxefe0jW\n    Ejw8uIi6bmP4VfbrZ8fwIdEn349UncdSJz4+FzKIIHb+hOeaMzYvxjPNzxjLrDoKktHzc+MIGQN/\n    M82G7hQD1/el8f+Z5kWtGvYKP2Z01NElqm86kB9feD1xpGF8puaqGrHNm9sVaRP9ODdMWVA0nZXI\n    mvkdoJ2v0Rv3d5n+5vaDOE7CjZ9IR6/MSK01T3enX5DP+sojV1ZCzhmosN9U1hn2nVKpsK4Dg6pq\n    5lAhECruV8sEH2A/2mJ/fAgc1OyyAzuvyZ837APpUUlv27A/8Lxbew6suTSrUcnxQUuk6Ij9gfEZ\n    WL3wMvbI6Kcg4mF6L/c/j+/RR9iD/TxGfQ2zNSH7F32AM9FR+fTncW6g4UyOXmmgM7GqYt2xuI9V\n    GZ/U+xO/fyvo/838Nq/DG9z3NfC98Do/E9Gvxr5PRPSVkACuu74fyFJS8/hKjj6Nv4Jh5Xv6D3L0\n    o+jzt+Prb+P7v0Jbxo/GdfydHP2m8Bq/ENEvq36a6/FXcvTTDlZsvyei/3rviyjD8qndR8r8vQe+\n    XHn8P8hNL8ZP8ModuwW+kjPJ3x9oOfn7jVyW/P1M+RoBqaikV/j3teI42ccr1UVcObIlOrR+LAkQ\n    GQ0mo9O+GmNBjtDlaDlNCoWPybljrfq/uL+nIJfSi30pB0BqIS9r/xLF5HCJHBhDSkKn6pA5sjP+\n    Gvn38dC+84+BYUh/yz1107iQks/SpQHHc0CgikaiadlHMoMoBczsLMk45WvWbECJ8/Y0ZkFJR2cu\n    46rkM6yF2gykQ6YfeZ0hAyg4nEuv/yJk1fpkWzuD7DLZ3rk95eux6kvHSGcBY6vzuEcGSHEL7Ths\n    22jghob9Q8tY0sewoBrQUzeTE7cyoHC8lRmzpBxPU9t4PJeZnZo0tV7nMOwrzTZl+48KIpaSQ7/Q\n    juJnXJp9m/sMS9toZST8fKIsw1n7HCX3np8VJ+63hYv4bnS5cl3u25ISl+0Gw+aiLb0o1rQpbXwU\n    uIKXx/t3zzcwhsH+XWOQiAZpKy1biGOtrNdr2Qpn2BFeL+ZKxMljpL+QSPdnaioTNSXsUoktJVnD\n    iJp6wDWyzy/iM+SSjd7IFSc+aXWC0W+eOibnQ0/57tnvvzQLOMc9fL2D7ePkPI2z0bgdxqNKQf9c\n    2G4rPm7L0rEa3okU9DIC+A93+HC3/gLfC7QfvBwYNNLXyv7divzdyhlXSv7mwAZIM0QpI1ZD/hLl\n    yV80yKl7pk0IrImANrlAaOQvTkBS5C/vt+pULCF/rXMQpaOypWS0LQ0TTww1ckHKbhGRSp7k6vym\n    iOAWWd2AcYtSDrrho0APAcCxQzqX8W+Oxpbb+b1WUxAdjTXOW16EP8PxGjQna86BKp3lKOUlnQdL\n    6xkuJX41R/dSh3eJvCZmhZXUddauVXPqWgoXKXuWsnFWAJXsW2YFHIQtDf26yPmkPb8SNXVhGxoa\n    9gGt3mlqHNDGMwy4kna0U8bKQRnv5qo+NqEqSTuL8MNjMPiGiOhEHV2oq7I9SAbL6ynNoC3Fmrby\n    GputEd3W9aSuTQtgS90X3vdMZZnEfJbTWJYBiWv87i3iOiW9GrfhrD0y2wxtVdqQQQsG2De0cF0M\n    AhkSY2EuGSNH/Fr9WKp9VlkEObZrPszzwudYG0HRV7qUBNb8sKXSz9L3m5N/rklCqiGBieY+8RwJ\n    bB0nUUIC/3KF/boHCVzDt/x05fESXzb5RNdjKxL41jLQ9+BJK/E+JntbfXE1D1ppBIPEkoiMLwv6\n    TmX8Svw23/Xq2FL2uYTgTSFF/pYclwMb21qja6GG/M2htE5ECXBilJOXRqQIW37J6Dw58bPqBYd9\n    9mI/FUmdckBbNZM0R1Nn/Nuwb8jsNZZU8uKEgfrjfW1x/THADrlUYAg6pHN9aWONdAhadc0vmf5R\n    Jpjfl19T+fPMGb+ctXoN2Yu1hfllOaLt2r3h2FSNX4v0tF7++uxav1q/WOvRJZ6LPmGrJPlbkqms\n    BUJhn/i3lqWktcVtnIl3MX4LfFwYNWOEABo3I5pzz3VDQ8P7R0mJAzm2pEkwlyVo5+fM1/YlKlMW\n    4nYMHoO1Pi1iVasLj6UCNLtl2aScLSOl35xNLbWlNXa8BHgeNwZJnSpWY1KJo/R7DHMt28bxd6C1\n    tYKR5bxPPr98xxEusY/7tuoJN+wDS1eZbXW6XwyUDjR1xnbt79yaoYQEliRuKllEy96Vmb+9ce4n\n    2J+6LlmrF/+2fJs5SD9pzh9bQ1qn+nox/k5hDRI41/aRSeCtktgsElfjaVIZwYxHzQK+N+6RRHpr\n    ErgyC7j+h3LrD7RV7d+9Sj9fg3tk/15D/pYM9KXksGV4SqOXUig9NkXivk0LvjQxzEb/mZZJjVh1\n    fXMTnKX7kfy1ZF9kVB2SvZoz3+rL2p6roUiJ/ZYzhPcRxaQvk306Ggn4EaBTGQ0fAZxlYWXsEgXn\n    rYV0lkfKWZyvT4fgTF+OqE45XJeStUz4XkYiMAXNQW05pZ/h2muvaQspS3l/tGykZWR37Bgv/XxU\n    eL4enlPMHEfIDDX57LJcpe+jozN1U1vpwI4dSfM2jtJBCyhh3ezofsHfsVNepeRMw/sFBs5JxPbM\n    qcFRRPb4gG3Oo632Y1hZIIxEL2Z8faYfJEtrx/Ta2SVmZc1f+UCnpbiGwH2GF9+32iCrOdw0D6m9\n    rnmpBv3zcpDUU+JeXpTnpEu0xWcGYZHN0payrU7nPzd8dDRlqn0iFXjO29D3JlvF40n9KIKByFpw\n    ak92+SCLFE4lgWhy0NYxEtKHiZLDJSSw5UedZwaH9ydypk8W21jgfTXJRynIfr5VHp+Sgi7F54X7\n    9o4lJPCXG15fTRLlHrKA/zye616ZwH/MN6lbJt+D/H0ELM3+rcWXira5H7hV5/fW0s9bgY3vIw34\n    32huEFOG943ctD8VhVVK/jJKpaDldK4muizV9psxrpwVMpcRZwHPI/XOlI8C1PrMRRpqEee5hbxV\n    WzMlrUmUHm2bw7KhYf/QMpGwFpsT+yS6xHvLoY0ZJeg01DJ4ONOSSZQS0lf2m5OUHEYS8KyMeqlx\n    sFROUhu7a7J3l2BJ/7msp5J7r312/q/E+a3VH8zdUyYn0jbLQSCD7lxK2cac23mAflPOq4Z9Ah2X\n    1qthn7CIXykdz7gk+mFItQKN1PVEcFBgyNVeleNzKnBLq5moAcfz1HVItY+4D92OakFKWr9b2tHa\n    c6TvVdl8QVvP8fwkZ4dQPWpO4Nvgc1plMfCZQ/tsBWClbKmmJCPfYfCgdnxDQ8O+kAsVwn08RqUU\n    qzRbZNW65z6lXDOOhdbYa6n/aeDM4PP0r00C28fq13EmZ/o6idI+0qXy04hSeeiOHL1Q2hddWnpQ\n    4o1cNQlsoVaB08Jn2iYL+Cu5qntTg5os4FJsRQLfKsN4DyTwPVCRBVz+I0Hy9883uIFbfkmPmP37\n    paKt/AE+MnnryJnyz9dk/xKtR/6uZXiQ0C25L6XSG0Rp8jeFcjI4nwnMbUrJX61djsDFWr9HOMaS\n    7USURvfhol2rNYKyXQiZWaDVhRoUZzpOjAfSSZu2yG5o+JiwZmFx1L3t4LMW3jwOSbJVa5uqd47Q\n    Mlhzzk4tO6e0/mDaIe5Wc0RfIyupXXcOmJ2cyvhKSW5KyM9felxn9FUGGcEfu5WknGQuA106uXNZ\n    es1uNjQ0EIXsb3xPFI8RudqtuB8JZa0NlzhwwqaV1ES0bFWJnLXsv8TupWxBr9jR54I+18C1NYLl\n    PcjVmSyxiTKjt9SO8rHy81j3UbP1qTXnmTpTpjX+bB4ltvQijse2zbJ+DLjCV8P+IWuEow0dEvN0\n    iRBMrBO/2na5XwLHVJR81vyMlm+Qj+P3nJSSQj7pxB//pO6xM4NzBLG1/9n4O4XTAhLY8k9Lf/ma\n    JPBa+ExxhvZ7QC2P81NV6zS+3Ogz3iqZ0gKrCbd6wERUSgA/6MXfBNc8sFtESrwnffcfN+q3tO7v\n    NQTxd3JFxPDr+Ppm9KHhJfM+h1ydCJaC5smBnIBcQ/7KflD6pLYuRmpilcrQ1SIAZb0Q7RzyuGdj\n    O1Gc/ZYiXHJR6Udju3+vb2/YNwbl1fCxIJ1xXUE7bRzS+tGyUiSsOnNa5pJGKpY6h1GSN+c0SI2D\n    nClTIuvsnbD2i8iP7aex/t9plPlc60XTOewav7l7xtmzqc9aWsNXc0qnjinJcMPvBK85JW2JxImd\n    ySTPEfblViuYRdewT2Dmdx6uERkfGLFttJ3XVv3xVPYSQ1NOeCI9i0azoyVPpywRkFIowmOs683V\n    kdeu1/dZVoLhmhfbY7RVKVueI9hlzV8NJdncJfMX7Ro0wh7/DuvMeB6mBXNRpr/U5+mUvlLg4IYW\n    YLVDDMu/0/Y07BdSEaOkRIIVTJyXn9eCUYKdOyr7aNyujXmWWoW13ZGjN2M01+oJS0gfqVUfmPGU\n    2Mf7a+sIY8m/VBvtbwvoi06RxRoJTBT84TlY/vW1krEYS0nge2QBrwFJItfwRV/uffEKtkzW3DMJ\n    zFnAGRnoxxQebdm/16E2MmTLDOKvGwzoW8s+lxohNHTSWJb2gQbXMtCaEc9NFnKRYdxPLvrN2s8T\n    JGtikyOUrXq8RHEGbq7ORypi2pKT0TOC9Umr5ijR3uuyWZYkXcj6bfXq9g8ZPZuTq2wSlh8XMsMj\n    RZZhG/yX6xZKaDWWZP1zTS4TZYVzYPnE0vb655oTlUhM12Y8zR3MZdk816Anq66iTsJyjcAc6Wvd\n    n7DPBjrCSzOD8XvUMq3lczjPkEtfoww40OQqLxRn/Dqxr6Gh4eMhpZ6jjUGxzLIOJHQv4jwk+sLz\n    OBiTUyoXNXZUEoG1ZQ8oM8YjGZxai9mv7RDsdVmwlfX5UhnSknituS4k0UvmErn7zNdLlA864H1y\n    nqcFI2gBgmhLNRvdVh77hxX0kkMLVt4XeD5tjTVa1m8qyBJ9YVqbkuMQWIuejP0IzPDFOsK4n4z+\n    jtCnNU6zL/OJ5iRxnPSSzu7N7bN8wdx/zr9r1Qi2+kX/Nfqka5OTGK+F+6Sf/FNB36Wk7ufK9jXY\n    KrltC2xBAl+TiHjvLOCGCXnq4aPW/b0WW+ivf/Ts35qB/Bu5bPtPVGZwalEqA10SbfWmGO/SSLE3\n    Skd95TJ9c+Qv4xt1yToZqes9kk7OIvl7LviscpFv1RXRJoWM1MTWiQnqRRynycWR0p8ztuN7R0TD\n    FVG6DY+JlLsp7Gvf+0eDlMklmj8rF5pHVktnXi7yep6lOc/4xfHXqk/n28lj9LZLpSkPFKKiU/aj\n    hFzFdvgZ8VzXvrTzEaXJapmBnAL3Y6lRXKbPVp51XCLjxgjPgpvIasuGcebTAO8lMPuNr9XKyktl\n    wQ/kEja7oaHNpfYGi7jgwDm512WOQ8e2zGyV7bRrsBzdmLmbI/+s86SUhlLZuNhXabkFtEe5+r/+\n    /OvbUUvxqcS259p1FOYTVo3mUmIZ24dtcwUQDUwGWzYZM9fkmtQKqsISH6n60ykVjmBvG/aOME6W\n    jUm8HmmKGvtEqqSKo7lN0tcN82PDuGSXH8AnSrMtWrKHVr8+h/P4stQC5bXY/bhZv7z9G3XTejWX\n    RWytbXMk8IkcvVEdCVyCUr81Y+1sXcajk8Cc1PabTT59wy2xNd8oy+XeIws4gfrcsy3r/z4a+bs0\n    UuGW5O8j1v/lgfG/rpjbyAN4SfZvyWDPRkYaMXxfGsWEQCN6bb2FWoPM4ImBlpX7RGlSuGbSwPWA\n    +ZhToj+LII4X60HmRbYpkWVhyDqVuH2e8VYXpcgL9yUR90T5moUtG7ih4WNAy/TOSUGjs3ogL8Ff\n    Ivln1WGSx6TUECjTJxPBtWOYdP6mSNUSGWN2uq9Z17cW1mfgbacVRnorI3dp3V90TLOMNlEcNBWI\n    29LvOf18XzK/gfIslaaa0NDwUSBJqkuhHZVtkGBLSUHjeXIZmj0F9YSLYX+QmHWG/S6tB6xlHF9b\n    vxflODWscY4lQJueqvWrtU9d/9L7xlLJWj3f0jmUNU+Q2ety3WnZUiR5UzV+U9fV0NDwsXAZRxSZ\n    zDBM+/WxJzWWpMoVdLN28Xsse8BIE7/2dRyVY4/i3xSw3J1WCo99n7WkKx+TygpOkcQlfUtofuWX\n    8cX7Upm/b+Smdkt91DmsSQK/d/w2sa9U7fXRsoAfCXuWgiZKykCnlxit9m9DLZj8/ecGETdrST9v\n    kfVLtIz8vRUsUpgy2636wVznCvfnFuPpiZbLtrFkn1ORgD3F2VF4LZZMaknWmuWgYYdA/N5DTpRl\n    ZkKpnFjDPtEIjI8BS3oP9+OYQBQ7hHs4OicTiPK9WmYI9l0y9vRijOJzpMYu6ajWxk6+tmfluJLr\n    kMfImonpLKNlL4nS7KYlhHRpxPuSur++rrKLru9EnSkljveav7sSsiLloGHHtXR6a/1osnTYT0oa\n    tmEfuIyvgWIycIB9DfsF/sZdpo2Elu2UD5DKZ/zG8tH6WoXt03nMtOU2zxTq26cgCdASwnJpIFSJ\n    HU2rYFxvV1Pn6zNzjj4xP8Dvx7rvsWS4y9pCtl9yfpS773isHTSGClHpTLVSmexc0EGznx8D7Xv+\n    2NBLKOTRkV1+IdQ2J3VMZFjqQESxn7SnOFALcYza6XbcKiUXtl3ju4zPK/2iEtY+zQfL26zx/tn4\n    OwckcRE18s/XkMCp5CpOwlqLBN4iC5j5jUfMAraSArcggf+28J4+Gr+2JQm8ZdLslajLQrhH9u/v\n    bno/PK55OEt/EF8q+qz54aYiQn5b3MsyPMJgWDPIpyQsSgrZa3ghohqRHGm02TCfCvt4przhP2f6\n    W0L+WnV9KbMvhVAXWJeKIYrlsSTkxFLKcfXKxNLqT8uq0pCaBKeeAz8p1sfftiDbDxylpZ8ZQ7SA\n    aPKl+0VMXsnvWXPK8RYkfi1ZXI3MtQJVeIwsIX7RYVpyLDogLSe1dDj2mb6sz1D+K4vPteaLKC1B\n    qe0rcaLn7nEJ8Luy6lNe4HOgPGUJaZCr+yshyylYUpSSYMYrsSSi8SwNe4Z/VgPhH943C7p/SFlK\n    nGtbWbyOQikFOcZokFmXluqPXCekSFm0Ab7vbrZN2gKsO1taZqHWZpTIMKc+z1avElzgN2+VSkh9\n    dj4XH5MKaCoNduN7apG61neolQNh6OWF7Oct/A7cTEFGtkuvOdtYukdg8FTO59BkwfcPnDWl7GNq\n    fZmb//cwJln7D8njwtXiGuVS2R9RWDuW+ms1ZUL2dabqAWv+0Jwy4pPoi680hxoSmChP3uZI4JfC\n    fjSU+NjXzgT+uqIt+3UDEvgRFV23wkcige8NIwv4MQRH93LjtyB/t8YWA86vC/r8Sk4dnL+So89E\n    0+sWWEL+vpEryuwtzf4tMeTcppQsxslGLgrN2m+RvCnyV0Krh8Xkr3Q8y/q/PUy4cNIVsnzdzKEi\n    j9Myia3JlRbVLfczakbTQZkIP8Zo3LAVLEdLI/w/FvDbHoz9MuM37YQOi3Ksu9qpPcdqA7rzmKI2\n    4VrCsXHtpPCynKMpklOSwJZktZZNJe2IlrWzprJCjVQk2yGu8Ztz5Gvnkg7bVM3fkntm3Z/cZ+0L\n    7iFKmUolDOuInOT5EvCRzZ7uDzyC8XMcZHT9C38zjQbeLyw3shyjkCjOE13z8TF/BamaiGG/zKS1\n    2snAKY2ws22hXhNYfr5S2yMDh1L1gVN9rCUVrdl0LYgsF9Ar+5P3p/Rz4FxFu/exzXTFQXfz5y8V\n    /BaCjVO2dOn8p42f+4UcD1Njo2/b8FEgx4tg46z1XVgbLikbYClwOGM7UTowCf2Dlq8R+9ESVJyx\n    3YJs+426YnlpDRoJnPKvnsgn+pSSwDXkbU7R8qWwn1KsXV/492TzB8w9LCGHtyCBt8QjZQETlZHA\n    f93BLOSetYAZCglsL1vkBT5wGvOqeLSohNQP9pGiRXgAXEr+5rA2+bumgcmRv5zVW0r+1khES/L3\n    R6MdTxxO5KokSIhC7WCezHzLuFY5Q7gmE1ibpGnbNVgR6welHdYz1I63zpeSSY3vhp4NnJKqI5rX\n    XWn4GGjk78dEitBlR0tvjAZM0GItYH6P/+K54vPYzxw7LjEjpuSzyHNgrWLtcxMtcw47+M86d811\n    5lBbV1EjfWtQ6zS3PpNFjHPNSTy+1qFf4sC2MtQlcnZPq8+Jzijsp42kDQ0fCzxuyN8+qgPks9vK\n    bJ0kT3MjDhK5qVqIDLYdOOZxsFBntNfOZ8lPI66pF3xLMnipfb/APKH2nLnrRFu65Dq5j9KgKjxH\n    WamFtD3V5mrNdjYQpcfLtlbdH679RnEe7mb2KFaOOiujklQPwqCWcI3xGJ4qb1My1p8pTQKfje1x\n    H+lEGQaSwBqhm0e5GiSjpn1N0tIW9X6XKm0uxWdaNwsYsSUJvEYd4C2xNQl8K+wlGdWCIIH1aeIt\n    yd9b3vBcJME1D+I1PwALaxbZ3lL++RryNwXO/r0lXqnOKJUaxRryl/s8VRr/Z9KN/wn606BNYkoy\n    fJHkPVf0xQgTRlu+Bc+d7iMt52xFxWlEsFbnkv+VUZCWDJ02ssZyhQ0fBfNFdZCs054Gbj8M7Tn5\n    CJBELlHeWezIlt69UJkMtMSB5tmmVsQ3EsV8bErGGM/BjtlUNnOn9Jm7J2tl+y4hYZfUWEwhJxdd\n    cxxKY8r+OjhOZjPJe6K9z31mKc3aKX3L/dKVpJHAfN2c/dnQ0PCxwOMCjwmc7YvvZaCVnNfLmr0a\n    Qhsa+80TuXic3U5XzdCydMNYPQ/0SY3BVg36LWxVTUmCtTKDa+rzynOnpJ6RQK79PNb9CNeRzzqW\n    cOJZlWSwphTSUVmQQjhHw0eBvhpF1Qwn3s+Pa9gHBsX+EOXV73IBAVbACqok8Pm0UkDa+qcM9nVJ\n    4hfxfbyKJ7LHzZKkllSbHAmcIpQtP+oLlWf9EgW/MvuZa0jgnD+6liQuqQW8Zu1eonQy2TVZwGvB\n    Suxbi8PZIgv4PeEeZWWJHiMLWCA/9dwL+ZvDrcjfL3f4bNbAsWYG8dJBMDXgrkn+fiM3GRIr+/cL\n    rR+RdKLyzN9ncVwNnqmu9nAqgu2cmPxo7U9kT2asvnDS1C+csPF2jrLPtZOTyDDRjDGvizhHqD05\n    hyRjNDQauKGhQUOJ3DyTZam6sWUO6LmTM0XOlmTwatlOpVLD8fXdZoTkcz+Pr0PBC91la6k25Ihk\n    S+LZIneJ6rN7+Twp26dJi8eZShrcRM6UOI64V5lJniNsmk3dN7Bu4ZptG94/cGyRxBaOIb6df2ep\n    bGjjTI5k1GxBSSamZf9sh7c/l9a+VOrYf/Z1A5cCQR2uL/fSbO4t0CdsqUSKZLbmPzI72OpzTrDw\n    udL3OVV3UwbMOeUYK9iQ55WOyojphv2iZK7WsE/IwE2JVI3glHcrpVDBwacIGVijgdX+SgKzcr7G\n    7wWjnuUHPZP3hXIbophMLpWTTikoWn7hWn/xErDUc2o/UT0J/CWxbysSOIU9SEHfQx22ZQHn8Qgk\n    MGQBzwe7B2ClJ9yKqX+kh4+xJPu3RgpgrQHimgFvKymGFNaQfv5Ojr5DBJWFV9INZo2BzBldBk4A\n    3sZ/LQK2VL6EoUWvIbRJVWnfPUik5CLZU+5dntzJ2sAISV5o+3F7rhaYNum8iOMxG0EDSle2BXdD\n    w8eEVadNZnGk5Cq5j5JxRI5rKYlKzVktr5HRJ86B50rViaKov7rsIrwm+dI+0xJ5577gPsnPupYE\n    ppadi5+Xnek0s0vza8PAqNT3oJMHertUIBZeq4PPg05wzOpDCkfaVUZpDbuGfaDGKd0c2A0xgpyj\n    tAf8rOBYtFQ1o2SMt4K36ghIN433VqZViT3Ofb6UDUv1WUMwa2ofVkkJy6bnYAVY1dSs7FU7avel\n    1VLWoElKlz5HmhKMJo3OChpxUMzcfvJvIUVCN+wHQ+Z1aXOsXYO/0YHSwb80tXPZfWk1qLKxLacm\n    ReR9fQ7GdPvay1Q7rqn5e07YuifjmCWwCOgU2D8sfck5X7Tc/0LlSVLsJy/Bl4I2a5LAWyiLrkkC\n    P1IWcA22IoH3UAeYcctyun8yzjWSwOkp9J7q/loP0LXk7xbSz2viPUo/E62f/UuUJn+/FPbFfZSQ\n    v0TXGVw8NhfhhdnDZ/ISHyV1JpAM1iYVT6Kd3K71JWFl+8paG6lIP9ymTaKseh4MWVOEYZ0TCRHN\n    GW5F+us1PTuYNOvRlJid0LBPpLK+HbWs8L0jFQRCpDuly6Qp88TvhcK4J+UQZd3B+DhX7Kjm9lr9\n    WTL6SDm8c6glVKXz2NswFzmqtRfXO5Q1BmW9wWvIXsuJb90bvs/oCHdU5uDOZfdqBH/J96HJh1uf\n    ga8YgxZSWUfslM7JEUrSr42nDQ37xYXmJH9waAdCK11uINg+Hsu1fuVxuYBSeZ1W1m7cxkMLfLJV\n    MkKdYH7VlkNYYq/w5RK2UdYMzr0Oo4N7KdFb+llyiiTWPjw+FZym9ZHLCOc2nbIda2rmPk96LjjP\n    Vk9l+TXsG1PJoYJXwz6RmuOXKffoY08IXNXXuBpxe8jsJ6JZ0ogVaIR+QG08Zr/jAdqn/KY53yND\n    +lMxo7fGz5oC+oRLJKAtEjgHzWedI4HxmGtJYDz+GhK4hlO4R3KaxD2yeO+NWyVj5pJLH0mdeEPY\n    08Styd/cDb6XTvd7Qcng8MjSz7dCicHYqhB9LflroYb8JUpLLyNybWrIXwsW+Ssj7iQRey7oL9Wv\n    hd6YaErZLC07yiUmyFqfVjtrIi1rmjW8f7TvsoFR4kTJOTtRVSBP+oYxTJK+so0mLyzfp0jfnBwy\n    OjV7eGnO4lpoxGvKGV1yjrXqCZdeb+2xfC/P1E0vS9ZS+y7k5wzfR+74+J5YGd7yHIO4n/NMrrKg\n    AQvyKnLBEw3vEzVBUi2gar8osaP5MSQOFDnSPIOSx6xhfJpKSTY8VmJO4sZ1EXPjljYun8AOnKmb\n    AnlqFSeuUasoQa1dzdnxtRQ25LlwjpIjotl+pbKdLYlvaUutzGf8vESUDU6ggnZa1rsVoNywL7Rv\n    tCH3u3bCPhLNx6uUYoa1ttT60c7O0Hx2WpIHIpcwcjbahv22T1HvL30vS3yoNSQwt1mDBK71S/Ox\n    W/jNrT7XUO5EfCX38FnAFjRep0b9dWtcmxRpkcB7zQK+l+ryH60p7Z4yf4k+bvavhkeQfibKR9jg\n    /jUGasuAvFK9IZMG89sV14UGvKSOQwn5ehZ9lkwM8BgtG5j3n5XJ0DHRl2xL5OtspNqk6v4GuGSU\n    dq4uCBK9B2OfdIYzcnUIuc3SiMr3N6o0lCD1nbco64+DkPEfOx55nwYcYx383+qfUSNnKfvMOVRT\n    TtdUXV+ZxVriEO5oHed0yfG3IA61zCftGktlKK/93CUSlVrtX3nPerWNJE3m9hX7SdU3ZFi1Phsa\n    Gj4WZMZv+RFlc/iYdIuJ4F7p56KMeblArZw08BJi01KD0GyLlY27JZYQ3TWQn7PkO9DIYKvfLnG+\n    ms9lnediPEOlkrzyuauTH23WdO9o33CDhnhcyyc9lJZKYKSCjnOlZ7CvtUrGSaCfUm6TfWj+UAnL\n    14l+1iWZv9oxmq+3Vi66BFoW8XeKfeFLE54srE0Cb4U1k+K2loLeCu+BG7t3FvAD8Kzx0P0o9X9v\n    kf27d/L3FtLP/3zwe8BIkb/XGpVvVG7oZD1fPK6kD82QS4MvCeU1yF+tHVF+soN/HxPbLOSIYJTe\n    tPYzLPkXhKxfmJOn8W3mE9VcRLVEq/27b9RmIrkFxzS8D+D3OozjVwlKavtq9Wc1yS3Zzjqmh2Mo\n    +luXssxJOmPQTUm2jFUPeIlz+lpZyFtBSmni/SPj3qc+S86JbdnF3ng+tHt5iWy+z0DTbKKVIWCh\n    yxyPwOAZlpNuaGjYL0ozHRE85rhMGy3TSWt3hmBWq/47QtrSvnJsrsmgDX3EpLVWvuBe2KLUAyM1\n    Xyixf71yv1LXd1C2XQxb2ot22v2wzolZwSX30I3Pr1VqRDsCj222dJ9oahoNCFSos75rtLO5gBoe\n    p1K1fFHFQarvIWR9eNweI28bcyMaqhPmSGANVrtcFnAJCfw8vtYmgVO+6FLJ6O/k6I2cmRBVmmi1\n    pcXZIuvXwlpZwPeWgv5yh3N+hCxgoruTwPMh/AFY6VWxtwfmGtx7ICnFmtm/15K/qQzhWvIXsQX5\n    uwY0klduw3oWZ2j3lOiHtz1RWZYv7k+1w4X6kfTJJk4otMkZTxhP43ioLcitupapRThOqP2CXbu2\n    hoaGjwbNYc3jA8riljm2y7KNZF3DnJwlSyHy37IesOVE5UAajUhMOTS18/N/uQwZCyXO49Q51ui/\n    FFr95eBATt+7nFPX+j5ynyPlvObzlwRg4TVidH6ouWn30VH+WW3YP/DpHwpeDfuEo7i+r4VA3Loi\n    8mtOhgbiN2dXGVoAlbR7pVL92L4vsE8pO8oBRFjLXl7DtVhqC5GILlEcKe1T25ay9dr9k/ddZlbn\n    AuHYPiIRrAUNa2UTwjXYTy3aX8w8vyTa88tR3pY2RaJ9Y8m3256JfaHk+xxgbJG4GH1o45mcx8uk\n    C63WL45vFjmM/kLLRuRkoXE/zwOsmsApMvdstNHO7UafaA4pdUht371IYD42RQKXEMEWCbxmFnCN\n    CmktODnu1lLQNfj7xuP4VlLQa+JRSs1umXz7J/t7iKd/j0D+7jn790thu2t/mNrAsDb5e6vs32/k\n    knV8P42vWpSSvymsIXFRSwQzMAqMYU0STuToNE40UpOAs5iMWJOf0L5cukSbfB2VfRKpRf+8zzRR\n    jPu1GlradomU4yQl4xb2623YqXX/EbhhbdRKOzcp6P0iV5ON85OCTLQNi2CTbWRGJhO5VlZmqj5T\n    iXyyRWRiH/F+hk101qBU5tnK2Kp5rQGrbjGRbhsxGzjVX+6z+/7LjpfficyO8nCR41vuvyjnibMO\n    5HMzB9b2bWPkxwWWTLBeDfvEMKR//6Xz6AHGLUSJVDCPXdKOzsfJ+FiGZkNwTC7J9LXGeCa9c8fL\n    c6xl05bYUXTyL8m4XQppSzUbhdeVun+pa52fc/63PCbO8g1zOQ2SCM7X92zrzQaP9gx8XLiiuXQ+\n    UBj359YOmjLVSekZ+ylJAjkSFahD5bN/OUGF/ZNPVFKSLlY5PMHfCH5/VLZZYJ9sSYnA8CmX/arX\n    JIFTuIYEvoYP+EZx7d9rSN5bYokU9CMk/G2hlLu3pM478q77jqXf4kF5j9LPaw4EW0a0EMUDcpe5\n    7hzxaxmKEuNoGaglGb8lhrPGuD8rnyF3fEmUWYr81Y7XJi45ktkif3ni5knl9LH6ZCxMrC6ZyaIk\n    grUIRJeY9MrJsiRS0Ekt24XzNHxUOOXV8HHRkR+3MLPJgn9e8k/MWXFOatmil+lfOWbFEl6p+q9L\n    ICUS5XhYSwJLp/DWpG3N9UgpTiZKJfFbglpnc0l/8ntP9YlOb0vq+SlxnAXeg5l6JSQekx37Xsk0\n    NDTkIOdS8+CmGF3mfXzsfJxDEhhxTmTZLgmgSl3fWnZNI4JTNutWdlRez5p2fU7ohozfdT6j/v1L\n    CWeiONO4F8fItnp2c4D2nOQCD9mOttXI/qF9y6Xfens69gvpw8L1aG5+XTL/zslBa369HPF6GQnb\n    3FhtyzKnz4OkrtbG8nWmrjsnBa21zZHA2vaXil8rJwmlzrEE1yZJLSWycyTwLbB2FvAjELq3xkfJ\n    Ar4TCRyG7b88wMP1HrJ/G26DHPmbk4a2MnyXZAvXoMbguQUGl2tALEVpxi4iRx5bkyOGJ3bLItmt\n    CD5J/lpOkpwMjGzXJ/YRxbKVuRqGuLC3SGAGL7pbpkpDw8cC/ubLnYxxpHZqwS2JuVL5SoTmAO0o\n    Hi9La/HGxLOeNVNb05eIicayOvexBLJb3ZEtndGy/qD8fFqd37UymjBLrab28fw7iJ3OUqJTy1SS\n    kE6fnCNbOsdrbWRJEEXD+wR+r67g1bBflBAYkvDVbGeJBC6ORTmZZR7vHIzrTrF5kvwrtX9a4NAa\n    detl5i2SwfI6t7Sj8jNSwoZK8Nr4sDAgyLLR+L2X9CuvtVeOw/Wkllls3Rfsx9ef7sxjtFrBQT3D\n    BttcR7yWbfgIaDazQfNpafulvZNtZD9Psza2TL+HS/r6NHuTK92Wk3227BiSwJTYn7NPmBxTmvWL\n    bXN+WM2P/CPVQ0swsvBGbjHJW1oTWMO1UtDIL7yXLGAinQS+Rgq6VG32yxXneA9ZwI9AAm8JQwb6\n    PnHzvygXs/YX8F6zf6+Rf76F9POWWGsgTpG/a9YQkFhC/q6BUgIZJxIlpC7+Wwutzu+T0t9BHJMD\n    O1dyE7uAvASavA7cz7CcRpbcFkpbyr74qpzSR3Ne7x9NrvLjwlHtrCstv8VgR3XKWX2J/rYdhogD\n    zUm7mtq7uWynUuB1BJLVI6g6xPRPqeP4lkjJPUv0dF0mkvz8tYQwZvriMZzlqyljhLrF+mfXnN4p\n    8hhJm5JvEe1oG1cbGvYLtqUpKWiGtG25gKjUsb6dXstVHhPXPbezgy3IMftaeyYVj7TPnyKB7425\n    TQ82X94bKS1d8zlKlDZq7CheP6qUEJUF52EbmXmO35e1Fp2vPkvQ1qQfDS146mOjZG2KQTFybLBK\n    pPUUr+GsWr5aH7JNSZJHT77evWXvejEmp4Cl8bjt0egrl917JlfsUy1RbURoZQF5eynw+JxyJe5P\n    +b6vzQK2krZyvvxcklguyazhMfBRkjbvkITb3evEEW5F/t7zQfqycf8/KdveK/l7bfbvUuQMCu/X\n    IpfQyOUim3Lkr0XoPhttn6e/aao9kUO6tq9O/pbUENZwpDn5KyddksS1JmXzWpKpe1n2/OdIYJy4\n    WhnBGBmpXUFJJpMkjRveP5z42yXatcX3x0WcrRQ/CdYzMZCbZYCklAoswlHKJmtjfN5pHTKCUucq\n    vwe6MwGzqawIcj2b9X7g++ooT/hKyc3U/agBnltKTGr3EI/UPo98n6sljdDsZjhGu3a9/TC2t4Kn\n    mix0Q8PHwCDGBazvW0L8WmVdQsBKjJQdxfeaigYJe0zKcYzeaFdj3/TrjIlT6zipJvFI6BM2Bq/d\n    FdjSmpI88vvg+7lE2vuJaBZclb5OO9iY/+6V0gxW/yV4nJlUw1rA50MLnywNuGt4/9C+a2uOLveR\n    0U6OSSUBNal1Wynxy0knJYE/NdnB2vbSOr5Pxv6cDxaJ5xTQ51tDAqPss4Y3KlPXsvBKZVm+JUlZ\n    S5U7S0nglgW8LVoW8P2hZAHf30Wy95teg6U/xJ8WHbUc/9xwwLiW3F0q/XwN+YvI7c9FQ9WQv7j9\n    RHmDzpC1fUuygWsygc9iYlVK7uIx3M6K1Isj+3LXFpO4GnDyKWUuZTtEigRm6Syn9CFH3mUR2g3v\n    CamstJYN/HHBmRvpMWHenpGSpbSg1T+0nM0WNDUGWWO9BlgLOCcZLT/nWlKYa2JJjV/rs2FN5mtn\n    7dr94owirFF4yBzPxyE681zpOppa32nENcoaPgZqRpcWUPWxMJCjviCvQwaa1GQGy7/leCxVDkoy\n    hA9kj4MlSgkWZOkFojzhnL5n20g+X4tS+y9tadheTqjPzxHmP1IWu6Y/LYgqZRet8kOIFBEsPwMG\n    KNeQ4Q3vFzl5b40IbvOt/aCk/IFsnwrelH3KtU8vxl2p0JBDzoeHxC+31/pGAjdH/EoFQzwm5ReV\n    /VokMO4n8qua2sxf7/cNvuNa0jblM875k0sI3lcq868vUedcQ9GTOYf3TgJvzQN9ufeHVrA3EvjG\n    ybjd3bN/18YW0s9E10UwfLnB55YRIFtk/65VzFyCB97PlC/QvkX2b6kRqa1ZUCN9YRntlAF+hjZL\n    jD9OSkonHWeYPKX2M47G30T6ohvblCyiLSkWCXRenBJTXzznk9IH/zvP9NWz0XJ4NNKioaHhNkDi\n    VxsFhulfXkDHLVMSz5YUILbH4J9SZzPWfOU2uczWHLTauVY0uXYPlwClJK8dgy8U10Uk0us+9vBa\n    A7Lu8JLP4Z0msdM65cDulWeEP0/OgY1/X5S28fH294IZv1YdxYaGho8DHgukis4AY41UD5DEb84h\n    nrJJ/L5X2mrQxltH6Yzc3LVtQc5KmyWzgjGLeI0gLLSlS+9DaeAbnmfJvdNKY0gyOhdIpV23LK+Q\n    UnTR4CgOQqgNLG0k38dByXfdAu32CzmGlEnI26XNUn0zUPXAzrL1YPWGHPGLQTgltX5zsBQKS8rU\n    yWNqy+gtKbtXkvjznNln7Zd+bFn3dy0SmDJtlmYB1+A9kcAalpLAt8gCvgY/J/btjQTeEiILOEwt\n    f3+Hi7ll3d+fK/pZE18K272X7N+1geTvVrjWcHwnV2zkGBr5axHCOfK3lJx9Vo5NIVevItX+XHAc\n    kqKpiRNPtrDPg9Im5RBwxsRPInZcpFBD3tZH5jc0NHw8WNKU5cfZ8myW81Or63vIHCOPxwX7GbKJ\n    ljh8Y2nN2KH8TPkFOh7TZ9qUXo8uhFf2YocGRrxrRO+amcqW1Hb4bufSkVbWL++X2dv8nZQQIyk5\n    VDw+5zian8vBMekraY7KhoaPASR4c7/4AcantIIPqW0sMu+gnCNHPmoy0Vqddnl+vV+n2vLaercp\n    aHaDbdtJnC8Ql8ttaemcKF1Kocz+8717Fn3i971krRb66egM361FBsugKiTzS88/ZOwpqk7hZ9Qy\n    QJtyQkPDx0PKn4XByLb6lJ0gQRSvkUoU+XIkMQIzc3NjrNbmTHMfo/QnlpDAT6LPUuRnMXNg0s+z\n    2Ja6vpRSZE0C0ZLavmtk7G6BrfiHLdVS107yK+Ggvmz2aR4LzE3+cofndeukXCCBb09F8A29Jfn7\n    6Fib/N2y9u+aWcDXRNvkjl0rWmhJdnCNYXwxtpdm5mqZvyXkr0TNBASlT3Kkqzap0rJ2z2RP9HSZ\n    UVu+pTQbKkcEa1LNWpuStinJLgd9NDQ0NBCFMYUX3KX1C7mtzPZ1YgwtdVYjObikvq5Wg09eY43j\n    V77HLCV+YVYV/7c2AStJ31xGUGlm7TXXJO2tI0eDuLs5xzJfL8uCM1LZTHgcvi+BlYUwGH3lSN6Q\n    l94I4YaGPQLtYml7Isz8RRJMd1xjUI1ESg3IOjeRnklrHSPHWx7L4xrBIYP1GlgBtpads+zd2lnI\n    spYv/xcUQ+avJTYIbaJF/C75XGGeNScgSmxwqr1VbmGItsVtB+U7S2GNkhMNjwl+KkuzgOP/N+wF\n    Wgkip7SRdaNT5c8ktIQOC7xOzSn6af1KSL/hsaAdwlItTPlLMfP3ROV4voIEzm27Fjmfdq065rUo\n    8e/XJpdtKQW9lXqqhiYF3VCI+0zt9pxijfhy7wuowD/JzV5EfuDC1xYRLbXRN49G/r4UtPlHxW/t\n    hTyhW0r+auCosJLJgJzMlMqcHGleI8PqU4N0ZGh/SwnpvmByiH2XSNRgtGGN3NacjJgTwdqiXUZQ\n    NjQ0fExIKdySWsApMkzL9nVURnpKJ+PJzDUuwZyotYjgUpwUIjPnmNbay1cpUqRvbd8oP4kSlPKe\n    XQPte6916GI2lHRI58jg1Hm1eoUlsnL8RFpOy5a91NDwcWD91i0lDG3cwX+tttp6IjVO4diIBGBt\n    AJJFHi/JGEpdtyzBkFJcStk6LeCp1ubX2NKSQKtrg74wgAz7rF27YQ3iGklSmZlXSgTnIJVYGj4u\n    WqDcx0QquDglMa+1S83fS2uRM1LZvzLJ46D2pBO/sj8r6AlxpFj9UEtAeTL6TPkpZb+ynxRq6/xq\n    5yjxWzNKkppeC/tcKwuY/fyp/paSuWuSwL9RXkSk8i21sJL99ioFnUKTgi7HmAW8D/rhPbP/95Z+\n    tgYfHKj4/ZrkL9f6XZP8/UbuJnUCGC/jKxf9tEZGsERpbeAc5hOO8mtNEbUSqdrAVp+p9sdMe9yX\n    m5Adpj7ntQnndycsxi2yOJexx221Rdf7HckaGhpqIeuZpn7/OGbYMlzhPUpfpiAjuS/UZSO6JfSA\n    mzwdl8qEwWvAsVw6qK8hdUs+VyrTdwk6yjvPS2sgW/dN66NT2pTeK/m95rKTGFoWr6z12xntUwjn\n    nP8ehqIeGhoa9oiO0oEuqZqo3gbPx16sW546Nh5PY/tXY0tLxu4ltqjL9LGmHV2DDC65V9o1y3mC\n    JLQvxd/h/DNJm5VT90jdFy0z2D5vfDxfL157aVYePuMym6/hY2EYX5w9rr0a9omc9cBAl3ienltf\n    4tiTzw4uyayVShc12b+yfalPEJGrzXusaIvH1Nb81VQfrTYWlpDApUlM9yCBU6ghc5GP+LbSNZbw\n    K9xuS8nohnr8jm4nA41leLeWgSYi+hO52077fiHXpJ8BW0RbrCH/vLVcwdLomrUG5BLcu1ZBaSTY\n    mueIa/y64uvAOkdS4llCm2wdC9sR+YnZS6YN9osTuVNyAlMuOxMW8JRtK6/dJjvaEny/kI4ep7xS\n    7Rv2AEtq0mpnvUfgHh5BSiTwD7N+Ymdw7vhL9Hfs5C1Vf0jJgnGf55GMRtnHLRzJqetbSza6BJ3y\n    siCdwjlZb2wrneVEZffUqo+J9y13/Hn8VIGMmNe1tuSftfsh75MWJNHQ0LBPpNQA4r/SygKMC6wF\n    eKxK1TW0AkFLIUlL3iazTlPkYOnYz5+1xL6sCUstY0vI+YIbv88zBLgxNLKgxJahqslcFrvsnpzG\n    +X7t/cBghRQRLM+HSAUSNvu5X1jfLAfHyFfDx0HKjrhMmzAWYmsdrCrUk0uSmbIe8FyWOezDf6X/\n    j2bHzZNSanyRRHHyT2kZnyeKfa1HZb+EJIlLSOBSrJkJzPdjKxL4U+G2a7BFPeB/kivmVWpJ4Htk\n    AX9Z0O/fbmBH3jMfeAf46d7vr+ylYY4vG/a9ZvZvCdbM/kXyd+2Bdq3+SjJ22cDdIvtX1vf9tXLZ\n    7he+5VIjNeQvoob81WoIa/U2tEka0Tza+0y+jrB1XZJgxcW5Jpta6kjnf3MZUIH8SU+L22KroWH/\n    YMILf+2ac65EwpfHnxKp53kEdXByl0BzVtfICJZII3OGzT3rz51Gx+yJ9BrDudfakDWNZQZXDQGA\n    4Kh6dsbUOLCxDyldLuUlh8SzbcmYO6N9Q0MN2lOzPzgK44YVLofkBY4x3H5eaiEEdWpjTbp0y/Lx\n    SQY4LakHPw9OndfLtXCNja21i9Ku3gPBNs3lmCVKiWopRyrJ/BJwcJQbbSk/iyVENH+mEuUQLbhK\n    W3c2eegGifYk7BeptSYG9abGCv47V8aFz5fK6MX1x4m6pGrgGf7GvjQS2PIpUqadhaPi18zhKdPW\n    IoFrfLJsZxHPxt9r4tb1gImIusx9r00e27IeMOKWtYFr0KSgA26ZBXxj3M699p6zf2sjF74UtHkv\n    P7CtBqhasjY3gFv714wOkmSuZeheEsedyFWRwpL8rZULWZpJzMfVZgIzUmRwaRZwqr08Fp3XudpV\n    uT55YqpFV2tt8V+tLTqh2mK6oeHjolSaMrUY15zUuXEFF+X8t5YJo0HLFi4ZR/F4KaMs96fqAy+Z\n    peaIWa12oMw6vua1FebnmGcPLbkGfDbYOb6kD3n/iMqzmAfxObRahyXX1CxsQ8P+YQVQ5YIoU87q\n    1LFog89jyJUca3vKO77DtdbXkaVZH9odseWd18Y1NrLEzob7uk6glXW/raxkmbVcApnFXXJ+eTzf\n    G1mHOnU8lh4qCSTW1qVtffox0ALNG4jSdXslataY1n7ux1KJQjWFIPlcrs53VPo6ij41eClmmp2n\n    tCRd6arjXOHD1UjitUngHGp81Uuwdf9rYC0SeMssYAtrJQtq+LJh3xp+vvH57o0byEDfjgDec0Fl\n    xJd7X8CV0Aao96BLv3X2b6mhqpHTyEEaaksGpAauYgJRlwlsT5pyRDBm7qYX2roEm/a3dh7tHDm5\n    UswGLmlbUv+XIRf4TQS6oWG/kKNHqVStJeeXcvSl6sGlFuk9HI/HusSi3QJmNOEYjHKMWzmpLYfy\n    Vhm6+r3U6xAuJVbxuCfS7XJJxlfJ+YiwHuLyjDR8RrVa1aH3dCZSyk5axM/jz1obalEjSdnkK/eP\n    XH1KrUQCBlDJjEntaZFqBtdkRsqx+RrCDRUhJNA2XBOYZNmwJVnKGnLXxPZ6y0ArKeGMGdSybmSu\n    RrAFVO5glK4R+ZmT86TU8Wx3U8oc8hpQqeNCXbECSMPHQbOn+wPW+LXWqCnUlQ3K95dSTpAyz1pb\n    3d+o+w7l+K6RwBZchR1k4rY2IeeJykoq5c4tUUMCp/zML6T7vGVy1BvVJT4twdIkMQtbSEETzTmW\n    95wF/KWyz1vIQBO93yzgG6sxdzc54RY37lGzf0vwCNm/JaTumtLPRCGS5oeVP0vNwL5EnuIa8heN\n    p2ZIS/vmY2Vmbg1qyF+J1PmsiDmtXse839Iou3RUnpwAcpu3xDL5MC7wSxwJA9QCs+v4ois7n+2H\n    xyAaEdzQsF+ULKrtscNlHX+daC9hjXeaJObSxSc6O6W0JTuQlzpTEbWO6VQGspTMrHlp11VyHTln\n    tub0TWUxSUjyYrnTfJ6xpgUY2NcfnMsHouy8oPQZ1dCclPuHVatQq1vYnof9YigYJ7rCYxApBaOS\n    MTQm7EJW7hIgCWiN/6mxv4RwXkKuWoG1tS9pe7Xryl3HmuQ0Bz3J+YoMHF46d1kyr8J7UEMkW8+L\n    JZtOFAcmtrFz/3AFr4aPAQwAsXBU2tsINjBPEOfrARPNyV9Gbh2GGcFLZZ+PiXaaj/SY2W8B25YS\n    xydxPCbwLEkW0s+h91Oa+LQGCWypem5F2K6J95BMV4sv976AG2GHSazbUw1bSD8/Kr4UtNmS/P3H\n    lX0/aiRKCkz+fiM3I4Klobg1+ZuDZUytCdCT2U8echKxdDKiSZJoyNX7le3kwt2qDWxN/hg4CXwr\n    HN9qMqas+iU69MynhoaGjwltEezE35h5USLRJR3DOSdv6rrYIbuGsxr7DbJfy+copQ5qdNbmCNut\n    JJtryOLUZyw9ToNG0FpZ2aXg77EjdjJ0syyj3PHWNWqQDiYtK8nK3GvYL5rT+mNDI/jlPFuThy4b\n    63WyLXesGwmz85g9qUkAl0IjHWuzRxFaGYaS4KOldmwprAAt65WTBb02W7inWP1E9nVN37JusNZP\n    rn9ZZqFEIlr+jWjr1IaGjwP8vdcEe+TGiRrlPK3PVP/ST5gjfkvWOaXEr/y7pJ8lyTqa/HOOBPZy\n    zzqeqZwE1mSj74lXyvvukQdYE5ystmYt4FIp6Ecgi0v5qi/3vtAbYWdZwB9jurdUO7wm+/fLvT/k\n    ylg7+5exdvYvEdH3guu8R2H6FHlcY2BPiai4U2FfOHlYmgksa/zWHFPaXjqmXyjtbLAmbq5yAkhU\n    XmMwlQWstcX+u0SbFnG9P0ini/X9tsyljw2Uyi0dB3g8KYmsTu07FPajISz052Pi0lqypZDZuiXg\n    ayLjmpeiI0pmaJUch8SDdNYH+WhPgtZKWeM9kjUKa74fKSWek6KUnxP7cfC8U6YfaSMvUx/2ORoa\n    Gj4eSmsBM0IAiYtscA3hKmXzz3BE6fiK0sOMlBxmCl42mW1FXH5As5dL7NdhwTElQBv9VHk9mFW8\n    NmQm9vz5wLqVdf26aS7iiuwhIgQJ1q1N5e9DBk80W9rQsF+UliAi8uNB6Zr0UjF+1ZQAwvI5mgJD\n    D+3wX8SL0qcF2b+vE5yv4avV6a31lxLFPttSf22OBC7ZlsIzXZ/Fu/R49OFrWcBbkcBbQJLAj5x8\n    t3bS4nuVgWbcggS+Ebad4m2V/Xsr+edSfCls9wjSz0R5Yncr8ndtfCNnkr9oINYmf79TeT2D2loL\n    pe2f4JjSthq0yUoOXPuiJrKNJ1pWxJ7WXso6H40+z8Z2oliyJZc9jJ8Q21wyk8TSRbd35LdldUND\n    Q4B0NktozjjpgNQW51qNQ9zHzupagpYdlQclGwado9fUutUyRUuizlPO7S3J6BpYUs7y+rV26Mi/\n    tn7kHNxvjFKZaiSs7XPYyMmcIvKBMvf/nhsaGm6HnB21gLVPU8AxCbM2HeXrAmMgT7ydSMtZX6OO\n    u6bywDY/l837KME0wZ7oa6zSADDt8yzNEMb2Ghl8GedGS21QKrBvKLDDIZAg/swWCSFVZhoR/DFQ\n    E3DegpE/DuTvv8ZnVaJWEPfukRu/MRDKUkzAGr4SOPZJ5YgSErgkiUSOr0uDkNYggZ8S+0q3p+Se\n    Nf+3JNdLErNqkfPlb3HO94Br1V/XwJcbnGNpMudaYD5zaxL4RlnA203t3jtLfqsohVr8ZGxfawDY\n    kvzdIvtXw9bkbwneyFXJQtdkBD8n+qjpB8nfWpkSbu/IVd3j2iziXL1fInvSeVD+zsnS4DE5p45+\n    TP4+smRmbaR3w/tGyiXUpCs/HkocMH6cqDtu7tCO/64db+LsJt2hrLVP9cXQyMyUQ7cm4whJ31sS\n    v7XnkqRvzqGtSVhf8xl9BpxT++wr+uV2R2JnBR9Xd11oF/lIS+ZZZuzFxHBDQ8NHwCVjETyhFr+v\n    JTXQ7nREVdmpiH6c6WkBWkvXApdKO4r7t5Z1XgtIBNeoTlhtrXIQpYpRmm2UihhyzrRkbkDGXK7k\n    +bVI3ZJjSs/R8D5Rs95sa9OPhZqM3xCsUvaEoOpQl2hDFAeXapgHVM3HY8YR2qTKB8hkk1TdX+1Y\n    TI4p9ativd5UqT6N2LV8vqWE8XOmHw2lvu0tCVmrFvB3cqtmAW/FW5RIQT9KIt7aUtCPyq89Em5A\n    Am9DPTwS+bt1xMCXwnaPkv1rYWsJgjU19InS2b/3xlLyt1aOQ+tDQvapRZctqVFBNCdRc4QuTqBy\n    0XFWZpo2oUNoC3hsJ0e8XC3hE3XF8qh8Hq0m4iNknjU8DlDyuTlZPh5S3/nSYIDgBNbqIdaoNfC/\n    uEiPMzvztWyDw/2iLNIvBU6AJY7pIJ3cZYloKa98zauGhJU1ims+1yGxP/VZa+6fzBQ/ZPqRxEiM\n    eYZ4KcL50lKs1nW1cXV/aE7rhhpg4EhNrXLZRyyXaY+DGlAuX0ruLw3G0mCN0zW2RhLCJeUl1rSj\n    JbY07O+qSevcvcCg3/Q1lJ/Lw2cF12SUxZDX4qpKFklbWnP2ZkcbiNpzsFdgln/pN4wla0rWlpdp\n    vMpbPFQyyCkYlASoWmOu7M/yX9b4R5k8rlVIrD2PRKn/d2k/Gkp9Cmv76T8Zf79HlNYD3iPeKwl8\n    qyzgG6DlnmkofTC/3PtCR7yH7N81kYrueXSDYBlkJIxrayRofWoyIKkJBk9cSiYhWhZvaY0Loli6\n    +Uh5IllbLFuTwSX1fvtpwjmHlhFc3nccxZgCLs9LnAsN7we1tX0bKfwxgdmO8Zb8M2PJ8NbKUMmI\n    61qyEsdUrlnL21PjIEpTLr/eWPZSZsfeMhPYOjcSqtegRMJT+7yytEHqnmB2t/Z81WSsSTUNmZFn\n    YUhc2xZ1HhsaGh4bqdqFTPKuncVYM87JMgjaGKrBGo+1LCcrmGZpNm/KBqRs2dbInZuzqVPSoDnw\n    sTkC35Pcoa5y7t7Jc/D97CkfVJVCbEudaeu1z0EU/x44QKJ5Aj8uZDCy9mr4OLC+70tizMvZtJJg\n    ldI+ifIBNFrJuNxxPbnRB+pfNUE6S85HFGoKHzNtEFbG7jPVEb7oZ65JWLL6uLY28JpYOwv4PcDi\n    gX6q7MfC2lnAe8DWJPAftr389ad9eEO2qP/7HvHo2b+MvZG/JZFH10pEv5ErNoIlxnkt8leiltgt\n    aWMRtaVkcK9M+I6JtloNX64pLPtK1fs9GH+nJms4gXUFi20GO6RqRtq24Gpo2DfwFy7Hh1KnS6gH\n    54rItBRkLUOidWQhrfF3DdlJrO1bs1h/BDWGEmf63KaV3Q/N1khi/JzJkJY4UCwpxgTsUgc2P7s1\n    tnFQ7lULlmpoaCCKiaxhmv/X1S+U5G1plqXsB4NTWC66BmfqojGaiU6JkpIIPcW2w7KV9wqWWgPB\n    vi3L8kak5ic1EtGp/hGlBK4FLn0gn/2Ghi3QSmvsDyVB6T54pXzdsCTYtUQdQyZu4N/WmjIl94zH\n    oBJF6jg8PpdZrEHztdaQwDyf0Hy9tSQw+5wtEviZ0gTxmiRwiT9ecgCfKtpeg7VVTBmcBbynTOAv\n    he2WZAFvrer7aNiQBN533N+SB+WRs3+1SI41s3+3wlYDJ0Ijf3PG5JXWladIGb+UAV0afZUy9KkJ\n    Qg5PtFyOpCYTmCieuJVkE5fW7SDSJ4oISXbgMZeCY0pHz/fkSGlYFxxhX/MEtIj8/ULWYpPjTk1d\n    N+yvVl43RnnktYacDFdHZY5q7XOm5CzXGlcPK7xyKPn8UkbTb+OMo+WZTZi1WyNryVlR8ro7pZ2W\n    HZAjZyW5Yt0b7Tchfy8XWmabGxoa3h9wToUyzyWy//O+lhOHuF6QDm9t3NRsAJZLsK5Zll+osdEy\n    e5UodnTnnNyltnsNO7pWHeKUokgt2Vo6f1lC4kobuFTVQs4rOchqCRmcyoZu2AeWBgm0jOCPiGAb\n    c+MCj2elc3FtzETlIUTKTqUSRywcMsfmgAkvKRLY8qU6clWBYdzPEp/uGij1U9+CBJZ++1uRwI+O\n    tfggC+8lmfGW2DIL+M/b3u91p3k70MTePaws3/ee/Yu4ReYv0TqRTymjeiJXZeylBAhPGGrIXEn+\n    Wn9bExd0KNTUBOb3NdnDLNWCWOJEkO3PYlxMObK7Rd97uTR0Q0PD3lAvT+ml4VHWuZwwJgoEItaC\n    w/EnJXWP2UOpLCHZX+1YnMpMchTLJubGzqWk89rg7K+lDm6si6jdl9LjqeAakMQovU5ZL5iM56Ec\n    gYypcTTGbZtdbWjYK/zYwKj/rQcSw9Gw0DrE9evnDuySzyCDczTIIJ7S7FPLXtRmr0pytjaTeW3U\n    krFoz1JKGzX3RbOjSHqkgq0uSj/8uWR/19oxWf+6BpdoltmwJzQCtyEFDEexnpVhNq6F9SiPY7k1\n    hCyJUBJ4oqkGyr97omQWLx7D/kYMvCmxBceKtkTBT6n5YpfY1DOQx2vW+V1DClp7X4u1SeBr8cP4\n    79ZZwGtAI4HXkoGuwZfCdltmAf91o+9Lqhu/Uyno9Vxj8gbcW/65Zf+W4z1ID6xZ93cN8teCZvhS\n    0hoWajNwsa8npZ8lGb0YoXYy+k8dnTqnnDjhBIxrYpRMIFOOkyXHaLWdSrKBU+2s+0PkJ8xtOdbQ\n    8DFQR2r5UaKf3MzLZAJRIjCVdWlFXpdIQ3aJ43PXhuhJz3jS2tcSlfhaO+MI+3smbyOZ+C09vmQ2\n    vlSeU5OdRCc6OrAl6VyT0Sv7x+NTn2mgeTABylqWEvmXZlcbGnYPtKN2zcIAJMJctCXdh+wLiV9N\n    Qcg69jLbFrJvSzOFa1FjJ2ps4RPF9m1NO4rXIhUoSu+HdT3aXGJpYJXsNyVXylLeTExoxyNkUJUk\n    lusRZ7jXlFxoaGj4OBhg/lwKWcqlhMSVa4uc3LOEVcaN+8+BCVzLR1lSuzeXrCL9sOxDXbIy4VrB\n    1vWuSQL/pqI/lJBeqwYwE7tLSGALHykLuGGf2IAEfn9CLyWM/kfTCL8GW5O/HDHzw5X9WFhS93dJ\n    2xSWGMBcXQWJWtkPdkITLSN/Jcm7tO7RkfITHpzA1dbGKLk2i9SwtnWZdhKWk7pkEo1SXa7wmIaG\n    hv0C5SyXjAtycS0dlNp42CX6IdKzZCzn77xuHr70zOGcDFhK8nkrGclalJ675nqXfB6uH1lqs/n5\n    SNnJmlq78nvDmr/cZ6nkuXSAE73HVUtDQ8Otgc5sDIBKwZbHd4uDnGQ/Uiq61m6xLa6t487nyu2v\n    uZ5Hsbmp69AyzUqkoS+RzdJtoEbeav33ZKulcD/as6kFBlxXn9nNgqsaGhoalsFlxy0JmfGrrVM0\n    khjLxGE/vWiXgpa52wv7QEqb8Gnrxl28XuzvGiUNzP4t7WeJbHRtLeEtUEsCv2cp6JYFXIdH4/ne\n    oQLyOlPAd/jBZ/io2b9Ejy///MgD9xLD90J15O/SbOCldXy182tSKSXASc9B2ZY7zinH546xssc0\n    yDrBliSXbJ+Cd3jXj63ssFomK93w6ECiX754HxIizUHzsZCrtZrDoDgYU31YpO9FWXzLa6y5NqvW\n    oDaWajKTfOyaJC9e0+WKF/6KS2sqpnDNZ+RsI7mttt5h7twXqq8DxwSKSzxbuePnfdmfAf9t2A9S\n    NtSyqQ37gxP/yr1LMmgxy5fHuECyLlPeSI1xJcFTuT4vZBPBVl9b2VH+5V1jTy8r2VH5OZ3SH5dn\n    sO5z+LteJpr71zLFU0QwtrPedxX9pMD3u7bcQsP7B9rHUlvKxzXsB7XBxfgc1CgW+WNs30bpWGbZ\n    LEvuOXdtOYT+UBi77lfAZfWW1hpGoE93zaxfibWkoJfimuSsLaWgibaTgWZsSQI/MvZAAm8BrAO8\n    chbw/lwkW0o/L8EWP8J7Sj//Si56MX4QL6J1Bso1pZ/RqKQMzBLjt1UElIYSQ74k4iuFM7nqiU+M\n    +gmaRh4T6RnBqXofJQ5tzk6TwAU8f/5SBzg7qdER2RbaDQ0NFpY48uJx2SXHOivbUyc2PUpIwTWA\n    /cduqcdCKQmeJo7r741my2Ln+/z82rXUfM6UBHcInkrfA+4L+8X916xCZFbe/lY0DQ0NOTCJteT3\n    j2oEcfBI3F/J3L0XfUosDeyZ15LVs6ZS658UIZw7d439WkvCehuEeUUuI5hxLRHN55iTHl1Eepdm\n    Bcs2S8gJTUKd51zD1FdDQ0NDbG94vEipZaT2a+hJt3Oa1DOWaltS4qB0PJ/7GZcpKSJpuwYJTNBn\n    LQlcIyFtJSrlfN01vvASX/sSMtjiBq5JJvtBea/xHkQ2T7IEaybo3SML+N7Yqg6whlskw65IAl8/\n    RX+k7N9HI3/XwFY/2KXkrwZN3hnJ3y3knz9Xti8hf18pNkg5+YmUocPaCBLPyvtSQ16S1YvkL9dq\n    WtIPAus+pWpRpNADiXyuPI5ROoHijDGrZmRt3RDNgW1NdK1JaZPdamhoYFxfp9RFBFtJtq90UFv1\n    gEv6JNGX778+UyZ2UKedANq5ryVXS1Hj1M5dB2Y54T3rxSt3PbeS39Sc+lZtwprvYm5L68ouYMst\n    v/uGhobHQyozLTUaoJyvVBMoCew5izFOjnlWPfRcv9fsRxuaOl+vvnR7lLqW0nF6azJ46RwA5biX\n    ZkTLe1VzT6xjlhAo2OdQETinBTXIbc2qNjQ0pFR3JErLtZSMdXLtSuT9gDW1fonq16bn8fi3hdaL\n    faSWDzZ3rOZjxX5KE4FKfbX3kny2/OylCVv3gJXcZnEdtSTwnrKAv1S0bVnAOv68zff4vuiIWzL5\n    j4p7/aCvjWJZE9eQv/fGUmkNojlp+6a0yU00nqie/L2WpiAi4eT2f9dGw8mM4NRi/Uh2htLB+Jso\n    PyGVUlyltQz9fQzHtUzghoaPhWGYR1FH+wucrlKHoWQG1yX6u4geS2scak7LUoel5hS+kMsuaEsd\n    1GsSgbfMZpI1klN1krXr4YwhvN4y9YvrHNh8HkmI1Ng4dF5r/S+RdW6E8L6BZRO0V8O+URpQ6cRf\n    NTWBLWhlEpYGUPWJcV5Crj9K6hKnAnRS51sj83XJ/ahB6l6l5gsyaE3OPUrs/iXzvS2zpU7tm9vW\n    ENQ18s6pa23jaQNR81nsGfzNYnYv+rdy0EoFMQ6ZY0pl8K1z5Y4tJYv5uCMcc648Hs9JFHytRyrz\n    o5b4ZktI4FPV1QY8Z94jcglQKbxm3jOuIYEtnmCtLOCtpaC3wrVJhVtzUO+dBH5HWcDXTcdb9u+2\n    kD/Ue0o/W9gy+3eL2r+p7N8apAxcjfwyGljsM0fknkifLKTOvUYmMFGYICGWTpAOVJbVK8njPnH8\n    IdMHI1df2Mty6dAc0r1Ri4sSfWjOo7bQ2g9CNH4QtdWc1byPpQfbM/BxkFIM4H+vrQ88dyjmCUVE\n    b/RTuhi3iUiZRRWyknJO6kfJ9l0LmpM6dY9zRMFTxedgGUp5bn9dNvh75bbadzwk7KgFHhNrnFAN\n    +4YmW9rQkIMksHjMukYuGvvCMao0i1SO6yXrJz4XZxQtlZK+93h6q6zg3OcP84x4nxVctfS7LZ0j\n    SUUNafsGJeggd5/x79qgrIZ9I7UetdanDfuEl32fJzN0yWPKVfMYJQo/qXE2pwZ4nNrN2+eQKi1X\n    0pfcr/VX4m+VbXIZxNq+E7ksCVya8ftCtylxWOKDX4sE3hItC/g+SHGAe0ge3SAL+P1kAKe+wEdi\n    /xF7+eHVDFxbR8XcKvu3lhBOgeWgXzJtGCWGWSN6aycJONGwJia5CUtJZFtq4rQkuk7rkyeNx4L2\n    2rEWaqUsieqck3GE9j7Gi4aGhuWIHdb1svHsXB3E2CUX1qVOcEkEXkP6YqaolTVzayc13y8sc3Co\n    fK2JXFZWT1a2kUteT03tYu3v3LWmZE+1GmIaHFmOozgYoqGhoUHiQnHgFM+prXFlqaKAtJ1MsOVs\n    Vy05mBuzebzXgodSShlb2Nham8lBShiodMux3fq+zlCblz+X9jk1FQztHER2jUvrPsoMOu04Dhat\n    Bf4+nLGvoaFh/2AbeQE7WX4cwXFOTYqQ0AJYDnDcwWiXyxKW61qpOJgC1gY+0nXruaVZvksScRh2\n    FnC+T/Y15wjeJSTwWqTxIyl4Em2bBbxmvV+E5KIevRbwoydnPgJWyAJ+/66UpeTvoz9gW2X/Slwz\n    4OSye7eo/XsNSrN/c++XGLY1yV8JNvQ1mcdICF9D/iK0yU9q8jV3XNTdV83BUSJ56e/VfOxbWqdL\n    y+SNnVB5LL8LDQ0N7xUDzRfTRPVjADqgrf18DisyW15DjZO4hAy1HJlL6gavcT2y7ZYouZ5lTnnv\n    wOmMfi7jS3NW13xu7HPIXOcSIrh0JeKgH8vG1mYbNzQ0vG+gHSWy7WdqdA11xZ2ZbV7jMempm8bK\n    1NhuEYw6oRjb6piknCt75FBybbe0jzVt174mSyq6ZF5TK82sZyjrfTMsW5qzxxowIMKaEzY0NOwb\n    g/BblUAqR5UQvpofLCcTXaJ2gGOvJI/rUEYW98b6FX2ltaXtGNiHlvWbV4VctoYuJYGvOQeR96O/\n    iveleDQSGFFDAt8rC/ij4JbJoL9L7NtKHXnlLOA27fto2HJAWUv62cKnK469VybwKZP5W4KU4Q8G\n    eRn5K8GTkNqItKPSRx3QeVNPBBOla/siUtJr6TpL5fJb2CJMgmvuQkNDwx4hncsdhTFvyYzMymzC\n    xXnOSbiE+LWydubjp3dMb1FTsIbg5ZcbnbrPtCzgqvQ8NaQvO5prz6P1F/4u+y5r6khydtQS4LPi\n    n3mP2mCp/z97b7vluI2za1N2VSeZTDI1a/Y+/wN819rPJHny1V2W3h8ulikaJEESJEHpvnq5y5Yl\n    ivowQAEE4GKjmCiHDUffAgDm43nSxyNlvCWd6SDc7uK0UVN+IZTtgtKZ3OwMtlSCu8zFyvIcp6Rf\n    wz20TussGK5eLt1PaXrvGDcnw4a/L2rfnPuFGw1us3u47dH6eok6XNLsdehW3A7QTul1xf1wPqjx\n    OaWrKJ3s/nW3tVx369/hRO662y3O+jnPmFcTtjXG9Izdx7vj+H01eY7fd6IZHB+6AACAAElEQVQN\n    ipTT1z0LxqQdtKn2Yk7gWju2RTK7JocWaaB9/4bvBNYW/GaMbBRwj+y2pUGaISfwEdJAGyPqBC6d\n    qxL3cP8nox0OoQvXO/r3LWPdmh9Ir+hfDtwZK7MWRPfxZyh9FW7/qzfkcBU2ZYz+YkyyloPFHYxw\n    8R23OduG+vCowxF25YYGWO4WVJ3hl0h71ogeW4/iRgxU74PDe+quR5q1PQ+nStplvXzsx42Cu6dp\n    BUfn4ejgr38MaQqeuburrMwo/f2vn7Jkj30wv2W0c28j3JOr8601PKb2cZf9uXd+GXTdWfpY3feP\n    aFKZPuS0Y/dOGUCotiXqVXLYRxjt+0q17zoOLsx27edH++V1ft12F7OvkZg7kQwAMAduJgBjFjKd\n    bYhtt204+05uSuLN0egrod19PVXjpLzL27Re3deWpZ9jnvtnn0/S7fsTjiSg9HKoL7lO7hL88kH3\n    CHHeubfPkI/jiJ8nq7e494Y/DnOfKf3a11zs80edMxkcFdwN52AN6FSObNo+pKS7zWYesopq4/ap\n    j+PPojfn/fvHe65MNuZuV3w3i7k6upqj60JtlfD+cZQv3n5fnGPKaevFbOaLudurvyUsC3Y9Dn5b\n    X4zM0/z3xpi/Pv5y2/vbLOY7IVvCX2Yx31e29aMx5neR3gBQxv81xvx/5ZsjAhiU8WPhdyMoif6V\n    mqUUizBKzdbiRieVRjGFBi+pWWmcNt2HZr8tzqDJndXnt0exEuvlprh0/1r8qCVqm/32z1BRTwCA\n    c1IiA6gUzbFUu3bdzZNRbvRQKtrH/xySpatnQl/Npcr5dg0sy4kEcqOu3s3lKXK1dUpLYx4z0v3X\n    PRraPL2oY7X1ESWJpf30I5I5dQ6pbUNG7lhklK1bbdvi4huo/UhAcAwWkzc5ChOpjk3Jb5zKhEHJ\n    odR+rIzjRHGG9LQvh9eN0tVyetStde/r0VvwtUT0WD+sDnfr86bODWe8kDsOcGteLuY55XYqlTZ3\n    3/b4bkSbIYfsfjIUTa4zF/ITgPNRm/GCai82oYqTpcjilo7z7X0hfH31YtI2xRdme6VOYD91dE17\n    ufbaHLu0VC3fkdRkD+XCDYJLBdW1qgNMcbYo4KMgFAWs30wiHf3bg1mif6UETYvUz395feshwFun\n    pqAUaY5ypepCWEXuDwBKHLivH9vFnLdcXsxjpl0pNmI29ZB+DWxLtcGVeDEj0cWEB6ylBpuaNJgA\n    AP1wf9mu88x3iL0YXprInM8W3+FHyV6q/uDj6ORkVyq9sSVkmA4bifu4hW4R/RB6ucftG0tSxuzi\n    6KZtMe9b2qhOGW84tb/c6ODcCGG3nUdU0/M+QkCTAnAucsbROamdqVIK3DroqbZ3k5W2i7ltZZKL\n    M3GKOnY3i4M/cSqmE1o7gW1dY2r84pfxSTmnqWOonQS2z3zx7AgOTQqmrkVsH3SbvHvPnQwVqmvN\n    AboUgHOQqtfrQ8kkN8udyzWxXWy/vrzO1T9fzWXnPObgO2OtPVPa6VuSeZFqh3Ls5rb9zSzR4KSc\n    VNAx+/b33l8O2moBzxQIZ8zYbLIaOEoaaGMeTuD/W96EfgcwRY3zt3RGQQ9qZmOMQnvq5xyFwVn3\n    Yha2woopypSS9cmJ8i11/sbaKWnz5gyWaowFX83l06Hsw5mlV1ojOFaXkTObMcdADcfvGYg5nx6p\n    DMG5oVL3cY3VvoGaW8s39tnn5j3oUw/1OViDqH+Mbv9v3rJYBOs34ghy03lKw41YypklH6v1mLyG\n    22JuW/xeCUXyUvcip6bl5kTNhQjd49bQbqPaUTrhnOSkNS1NgQrmJ5a+NqULVuK9q1dDNVg5cnH9\n    fIUnZa1m+ZTPMahjcHWp215qYg83o8YIQtcrpOvd/sbGENQ5qHEK23Z853Rqm9Rx2j6H3tdcl5KM\n    GwCAI/IoiRDKeueyRsZXsWfVHJnlPl/ezPKZlSJESH5bO+HXwqdAO7HIDWopKTNHUVK6z9/WmEfk\n    bqiUYA659mmK7w3Pufu3ySvXo9kJLOUPaRkFLFkL+DdmP9+aHU2YkJ9Q0gksXe62M7odwDN667k/\n    CA6jo3+59X8traJ/S8lRFD3rxUkoV2MeA4ZvjMEFh9DApiaKl6rjmwO1fqkz2U1taak1fORG41lC\n    dccAAOdgI4x6VC3DlHx4J4ydKccHx6HsOwdjcjD2fSid9JXZBsdgkEo9NoLcVJV5bTwvSzmQP9vL\n    iDDL0X+cdNVuW1znnK2JaNdfDH+SFQDguPgTQahJMo+JAHyjsxtJnJJ/vtzzZSBVhoGLK6sp2Rpy\n    4JboUY7zU6sjuGaM4C+PZdu4ZrQb6yMnDXmuLg3p05w8Laj7ex5yJ1MBkPtcaSkZr9dOLPapidr1\n    2ymxQVKl8KQif30oW3xpqUCKnChgbsBUb8eulJ/BR3tQHMWMwYccNGcKlqAyCljeNCblEdeW+vmt\n    cfsz/QCtcmmR+nkEXOdvjtILIeH4NYZ3vkucv/6A5DWwXgpq0JTrZE85f3MGdLF0m/778PbhgWhK\n    kuIBClguxAsAt0a4/566R24fS7mGHOp+u+7auxOraRd7uI9BRSb5+3/0g19jUJvj1/Y9pz5hSfvU\n    Obh96qj7y73e7nkqrZ25Be6L3PTQ7va2XTfq7hYxQruRCaX3IgDguKQmUD2yCOyN0mtExvlQejSm\n    c1KO5Nh+3OeWvUx/vCidU1Krl6uXXJ3Tm9i4Oeccc89P7jmh+pvq4xpYP2d8sH7q0iWZxjU2vqxJ\n    FQ3040Z42s+pl+ViMGH9KPCnRKXtXpzMBSlZcnX+Xp3tS/SmtTVKBZCUOo+NSdtMXxnr5LZpTL3D\n    VypQ6atZWLbz7w2/JKLmKGApbJDeT6MPLoFk0GMvZgwubQBMz5KU/hB6O397FBmPzYL5x8erJRIK\n    4i/n/Xcmr15vS1zFLuVQpih1/qbgPNSmBmnuAI87c527PCQV351vfAN4bDvL5kUy5dZaAQAcE35t\n    ckMar2PtcaNJYsbvVBuhdJiU8bPEME31V5uzb4QxPFQfkYoO5kY0xUlHs8XuvdD+NrN8TmgoM/js\n    9w3DNQDHhopWzBk/W/nlyh4Kf9IJR5fW6KZQxozQfiRTAsf6EUJCn0vCjQguPa7QfRA7X/GouFAJ\n    Bnq/KTbn+HPLJfiOQQDAOYlNWuKUI+JG/aba4kyotbgyuNQJ7JaMc9urzWZoeTW0Q1nCvurag1+N\n    TNRvCxvzX4HlEkFWef0o81NQ/o2cVNC52VWlobLLzhSEmEOPVNAjqYgC1ulu0Bb9y0F6FkSL9M8/\n    mTbOX1/wUcLvH4bn+JVIy5Dj/A2lp/jL7B2+MecvV2lxFWmuwi1JI+JCDTz8AUpoH7mDK+4AjYPv\n    /C2JpjLmMUC9ZrYTSpfFrdWJGnUAnJfUbHrfmcUxbObWlOO0dyG2Myae2pkySlMRSrm0cPxeI6/U\n    unYevSYDeOx82bqS1PHFngZyahNzJjZdnG2piHO/ljUHnVcAANACK0P8iLYQnOhev86vvy9qfTcz\n    UCwbRaiNkDPxs/bh9qxLdXLXhSkdSh1naUaMFKXnKpRlI9Z/f7lPqNZyyIEfG2tx7k23PV8nx85K\n    KoIenBPYKo4PpyZ4LODBzUKQ4uq1lcqylypf8LDjlWUptJ/9FM+ldkUJcpzCnJKALi0cuyFbuG8/\n    /2qWoBNYW8rokN/C+jpapnzuEaznUuoE5vi/3roeST9CWY//q19fyjqAJdI/a/TKvzVse9ZZF5TQ\n    my33Pdf5G0N6xlKOUn43S7bz1x9QcAYYHOevfc8d/FAz4NbMNtw0MVezH8BR7aa4eefzwmgjVjPJ\n    jxwI9QIPVgCch5TTl4piDKX187cxJmWs5suaC7FtyNAZSh+t1Vhdkv7xmtie46CXNnDH8B2/IUcC\n    ZZi2n3NTaT/XjX7mYsKOFh9uSlYKndNbAQBSxCQCJS9yahjalMvP7e7bz9WpVt6GsmZQbd62fe32\n    Xno15ZQNTexy9WPOBCu/DQ2kJrM9nlsf58xl8dYv1an393tCaZ2pNmoj5gEAxyVVQzwsW9LPeqHJ\n    LP6E4VyZ7zpr/YnHucRsiCFC/aWWhyJ/XSh7bK4TOMcmzLU352S/DNnEfYdtzAncgh8Cy7lBZ7Hg\n    Nev78FNBz1waMxekgh7H/ys7Dgz/JDhz6meOgOOmew4J4h+Y2xvDnxUUm2XkK7tQmzHnr/9dafpo\n    yWhgdyBRmm4klrrEb5Nn7F6eBm4lD/7uILB0e9eZwZ1h7fKcRjUPOIIBOCfuDOjUeqHPD+PxHv/h\n    PEfOrGYxC5FpgU7V9dimBWuGfkk5Y63hwTVWp17fzOXz5deUd7NIhF5Lok81o/EcZ3vMSe8b5kPX\n    motbk/Ddayk3TbnbpvsXAAAsJXKBW783NhErRSpS1NclpTJdEtsHOwbwnbeuAZ96WX2Zo2fdZ7lY\n    n7gTrVpNRHPbvRHf+xOrlo8I6dx9UPtz00cbr9VYRDzq+wIAjDFm25ZkJjpbtoyK+s2dAOW2UzoR\n    1s/WZ+12vs2P2/5Xr+xMSb/eP3XA8mQDfTE8Z/Kr115tOuic7XtGAvuE7OLaooBLkAqI+90sXesA\n    awtK/FXgPMayB0s4gSWCXyXITANdZtqhQptbR/9qTv88A60FSK2wk0j9LIE/I2mkgokpZir6lzvz\n    i3LYcrZNDWRqZ2xfzWNAxlmXwg7klsy+cAwGudKSGlSHogrAMfENM0tkvXzzEJgZ+3Cd65zl1Bov\n    iU7y97FEHqqlavlyCcn7xfnHqZVIOTxTcAzI/r5j+7Tn13/lHju3b6Xn1gT6zCWUztI3Xsf2kbM/\n    GLQBOC+5v/946lz7dzE3Y4ods3Y/fh30UDrhGmoyUFxMWifV6NGcc+bq0pQeddd3xwIjseOi0Pmx\n    DvXS50DuZIRL4rMFE6oAAJZYimdL7vPlldi2JM2ymyGjRs7vn1uXbN3rZ4OiHL+xzxy4TlxO1K9b\n    C/ibWYqcvr6ztiT7pUR5xha0jAKW4CipoN+6HsW5KIgCPpcromQmwVvie0T/xuFG//YkJ/rXXe5+\n    F1J+35m9si0ldwbYK3NZaD/fMvv3EmjHGHdWHh93QOWmdalxMFgnhTFlBvaQE9hNj5nCr6myFR8N\n    OBqoA31O3GueeoDOuTNqHYHW6UsZq0uN3yW48vhieMZpt28SBmCOMb2UlN7wndrU9xJ9S51Hy+bd\n    E6EUpnbbGFSNX855ykkV/XgPuXpcFsbrzrmecgEF5x7wdRxnXBbLMEFnyYiXSKjNuOC2HdKDi/ev\n    lBKHtbRejelCf7zwauhayy2hxk5+VLCE4/+uT93nzefz4H5OnVVj4BAG4EzEIn03U/b8l5OJ4ZrR\n    Tu6+KRazFDlmLVQJPJectq39VSL61+K281WkxWdKIn1HBlXFsolqCUID/TlSFHAGMo/GR639exQu\n    jc9ty+jfnPTPHHJmFVlFlVsPWLousDH7aGDO7K0c56//PsWL937xBkJ3B25Zmun9oClsXMnB7V/u\n    to+H67IUMwvRHvX9YtK1VsCc+E7elNMXTuHjwonYsLXcUneA/2BeyiPal1/HSRJKln4xxlw/DNS9\n    6wiPqlscMtrfo4kuZjWXoMH+HkmexjpuuSP/m9kbfqgahKl6jjnHv//82AfFEvgMhx8Ax8bqPftb\n    d2WB+/tfiM/7dvbtleDXUvedbb7hmzOp1a0VzOsDLfcWR3cYQ2fsGBUxO0Kv3x2w9vVMK4dw/Fgf\n    /fEnv+XAieS9eOvGe2WS7YH5cScih17guHAzj/kTQSncZ1j3fanT1p8sI6Mz6tu4medyc1RWRi4l\n    AT+cfVlbcWnUL4fvDM/m7QdRcegZBcxlVBSwtB/nfwfJ9bchez1HFuH/Z5acNNA6TCUp56/WCzdL\n    9G8LZo3+5aKptkCuo7Z0EFKCOwBynbfvmQYPH38g+B5Ynscjqri2Boklli7HXRMPUQAAitQoLFXT\n    lwtlnH4YmfcTFFoaZ2nZu4/e89ODjXLKjsbWG3Z5XH83mmxPy5E9XYvw2YyUo2OpCHNuekukzgfg\n    PITkgisHXgyVwviZmhIJ+/e0TKRS3+cSS9scPr6F3P9Z9ahlfy73Y46eDmFjqPvjQjr+a1JFpyYI\n    bp77/9x3BwDAmHD5MmP48mgjnltysA5WqsZvThvGPOyH/nJT2La1b1KZEEujiqUif3vuozTb5eyp\n    oEfRMxV0qzTQWmkRBfxf3eei3kw0Ydgzm7dB+5WcmdFCYEgVNzdGb/SvJZYS2sXOgPqS0QYHtz2q\n    di8HyiFs23g1z7PYuLwQ7/3BT87gKpRG5cXs0znXGDFqB5Tu/qlUk5REjQ2m4RgG4HxwZ1zbvzVy\n    IpQC0NYjr60XzNm/xU2DeHfsXsy3j8hWqUjSUrQYyG0NwVumEeZxnfPrHJfw7jin3ehg24+b87mU\n    WMYMqu3xVw8A0JrcWuSWGj1KTaByKU2TmXPMz6kwl+za7DH90hsNOteOO759jEXMbnxCT/htdQ7s\n    2IjS8zkR4S6cex6OYMAFZayOC7f0AYUrq2rtWjche58vT2tSPvv9srw4L7sOFz/l86uznOI18TnV\n    fi2S2S2lgqxy25HwK3CC21pEAf/UoM0WSDuBS8q3giT5w1nXoz1T6mfpG2iWWQ4tBIYr2GqcwdKz\n    baQUSsphG/r+C/FZOh10bhqPnGjgVE2L2PrGPAZAV8a6ufgP5KH2cvazfAzmSh+sjaGdJ6FaKhzg\n    EAbguHB+3e5DeM3DuH25kUE2jdeNiCyVhDJUW2O1MXfn4buSDDQajNC2H7V60nf8XrfFmG3ZpX6u\n    dciGItv8v1Tt4PJ98w1TiAgG4Jxs5jEZxZ04tZp0+koXd13K8bsR8s99L1Xr1o0IvRpjjCPPqf3n\n    Yg3ao/WfBh1sz+lqlt34xE6qqslwUXI+to+IYNsHd4JVTa3onAl/thwJOBZ2bMa9h+y6m1nMtuGO\n    ADS1pYhsGyXZg1xunk5ORaqmnrtCE6ZKdUBsfymbbW6Gx2+eE7g0aje0vf3s27pDKZ9LAqKko4Bn\n    rgXcMwq4FW+D9pvKJnyEWsD/j38MOgxwGnlr1G7P9M+ta/+2REP0L0VNNG8ufvSv7/wtcQa/ep9L\n    CQ1g3AFRzmy71ADs6vwNpW8pNZ4/BpB1KWts6lTK+ZvTEpzAx4Fb+5eqt4T74DxYg3UJ/lZUZJIb\n    UdLC0OrLZVvPdiFk6mhDr7a+NOvHzlB3N2C7+7FR17fcdpnH9NmNhCPYv1+pup5uW+5f8rAbHA/Q\n    QY5DYjF4wj0qqQw6nPTxl8h3oe8lUjrHsLUFl6f9eBkdGjhhDq0LK/rjT1Sz4xpXb7bKXuLrUSoi\n    OXXPpsAzxznJySyE++LYcK7vJbFtzj3iB0zYZRL16N0gEVcmt5qw40b/WkJRtznZFt0sjbm0qvdr\n    qXUiW3ra03OQcgL/s0HfJIP6Utlma/xVswRJtmC0E5hJ+ePxJAfYhJY39qjC3L340yzmT7OQAvYf\n    zmsUpQopNCtKQsFRyrwmEjhVpyK35rAxzwOgWPsS6cdcI4lEe266mZqak66DxQ6I3XSVMEgCACw1\n    kb6uM8RPs+y22UrmWKPnLWGMjkVD1WRfKGX9mEx1M2b36t2HFsbuq0kbo11Di5um+UqsJ2X4o6La\n    fX1Ykp7NnThTGzUPAJiTtVDLUTVX9+0+ZIqErKacLs+TWu8sJl5DuIXTsZVeSuHr4m8fOrp3P0KR\n    tZzzctv25S0k8SPYbZT7SuhSiedM6FAAgI+VKxLPlncZSQdf5OLbAEscv75sj9kUa1JJc2yqfgCU\n    hBNYIgr4a6CNL4ZfLrEFJdk/fzBpn4P1V+Tgrv9Ho2M/YxRwrzTQ0lmJFdcBzhPf9kCknL9a0z+/\n    Rb6bZVZDq+jfmnatYAw5fy0l0b8xBdCyiHwozQXFd4afEjpH4ZfUeOC0H3IE5zpbQ4MliRofL2af\n    uqsWWwsqNw2NT+wBeg4JAgCQpKaWLxUl6aZ2thHEfno/94FdQj4+0ko/2rNO4JQjmGqnJ36tvZav\n    3tQ40v3Ulz2TKNt74MXsU1yW7h1OYADOgcRvfZ+lZ9n9tbSR54+yCL4uzcVN79+bEp2Yu80InZp7\n    Lu3Yx41mK6nPTOFncNnvY0+oFFHJMdWMVwEAc2MzqNiyCpZSeexPULGZFWpl+76EAe0Ezm2Pem/M\n    3paZcgL70b65dtofjCHrA4fg7KMkMphrt445gWNwt2lhx3d9Db4T2PVT1JS6bMFZawHPxMgg2f/h\n    nXfEo/m8je7AQYkJ0FrnrxSlM5VCytFVtqW1gFMKO3dQ8W6Wp3OcGsiUOJiptkMDMonoXZvOsrY9\n    KsWWHVSmBpShvbqGKmrmJKQwAIAiJSeo1OH+eiUP2K6s29cT3qe5z227l6E6xyl7NfeH12vFK7dv\n    UkgYmK3j115Xe76Wz+vcajLhszEplCqacgrDOA0AcAnJBD9bhjuBys1O4E+cktRVlB6VnjgkObGq\n    RLfHXovznOa/vpiHDo71p+dEq9JzSTlLqEjz2nHDJbKe+zvwU+HjeRMAwCVVbiFHnvhj/lIZbm18\n    N8c2d2Pa6WJtfvs4Gt+G2Kq0XYqW9vDSKOCUTVprWucSJJzAPzbqm1SQ38iss2+Z688WBWydwEqj\n    gPmiWzr6txe9bhgJpH6IrWaH5AjAUEqFFgXWS9I/SNBa0eXO1krNAKNSP+emFrEDmlyncGgA9c2R\n    QbWDJbufFyMTXeziRgVwpGZsvxvRN9QtBABQWCnBSUfppwnMcZL5zlk3rVaOwTUnEjiHHFnOcdKW\n    OnBzeBiRF+NG1mqIGrb9yFm3lSE51g/3m5YOaaCf3LqFmCRwXiiZspiH7JXKikHxnK532WXsiPW5\n    tS4IRY7S+uiht1wHdis4urpEb7c4p2tG1hN3/3660pLIXHdbzvZ+OaKcbQEwBhPujgxVSkjmeu9t\n    XVtA95Rw+7BnWj1Qk5aZivqtaa+UV/Nsk+XWCuaun7Irh2zCnCCm0kAnCVt6qR/gH4H3UmiLHu5N\n    Kgr4bXQHDwojCnjc8K9X+ucc3hLfzxLOri0/PDf6d8bav77Cs8o1Ff1LKfoaOIOAlPOXO+CRigim\n    Bl0S9XyN2c8IlOVhGHHrJ9ayEg/o4Bj4CVUX4hVbHxybJfDe4hqqQw/lpffL+vT5kZZyNJQu2Buo\n    n43SMf3hG48lDaCXwOtxTnnbUUb4qxmTBtPFnbG/VEgo7vn2s2akziEA4Ny4Ub5u1ONjwuWlqxNj\n    MY9a6/f9j5vks0b06Orp0ZDectsJ6ToJLub+bMpx9PqOVHfCVWhyldQzZi1rQI/e2NvuSWWgcicE\n    +r+D8WcD9ISaCBB7UduB+aGup4SeuhnXpiV719yMXJ11Sg+E0jyn9ufbT62dtFbXvJh8J3AtKdu0\n    a+emHMqjooBbBIOdIRX0yCjgo6M4Cpg3bJ81+jeHt8H7P1L0bwmlzt9R0b8UJfUVWkANBlIDBI4z\n    2h/IlNS1cNt6SXwvgTtoq6mzZYh2Qp9L2/PTdgEAjomf0tZ9T9XyTbXlbstZz6YjlEjHZVlNOiLm\n    ltg+ZLA1ZokahFdvndHEIntDzmd33au56+RFyPHbKtLYrR/sp7isSaNKRa9T9/ZzdDAA4EzEpqNQ\n    Dq8tU9/F5IrVN7V1fGNIyW07ecd1rsaOOZZiWMMEMfN5DOE7YD9mSE0oK6M244nrCPYd8vzt7+RE\n    A8e2xSRUAM6BxKQoKzvudsTnMme1uM5kKcevn0baxXVa50YCuzZRrn00FRBE9aHG6cuxVXOdwP77\n    kVHApcwaBawt2K+Ut4x1Z8rqqxy+iB7l/P13xbZnvFG0CQRX8Pnpn0dG/LpIRP+6CjDVXqr2whcj\n    O6OLSv0cIzcyeSmYUR2rhZQzwIvt121nIR78qfe5+LNkJQa9SLUEwHHxDW2UcTqnnZT8ctfz67xK\n    ZS9wjd/pOn7GeT0bYG29wFg71117efJSc+pD6/il+heKtooZsXumFN1MOJospx3OOpT+ttHs0J4A\n    HBc/ObFlLdSj3HX9TA32r0tLWRuT5ZQOiMlhtyZtqUFdWw1eahxB4dYkvhLb+2OUWP9qxiEh7ISC\n    xzHwHLwbc73QtkiZD8B5kHT8hvRhKbYdayv1yxOFqAkc8XVhbltURsMYuXbWksAeLl8ylh+pxq9L\n    a39EKydw6yjgfwm0zcme+yZ2RmSQzFLcOwr4//BWS4tUhWHL4rwx1mmZ/ll7+L0VXK2Kmc8Y/Rua\n    5WSV41ezsBXlF5N2CteQM9CoqRH8mFHHW8+Y59rA18T6JVgpdzX7AaUxdQNWv6/uAFirgwEAMJZQ\n    Gr4cePKFjjGWNPJxHb/+NqF0kj6hdm+FBlfNcjlm5AidG2vEtufoZusSbs8O0h7Y6/i4x54dEn6/\n    au5HGKwBABJQWQdW40/YepQe2IQmUOX20WJlvY1ADTk2LbFJRRqyZoTIPccxZ2zoOKn011ynrqt/\n    pXWt/zzpfr5G1i85b5ZQhDAAABhjM1jtx/gSti83MnclniFqoFL/X83d7vgS2SbE++dfN3NfXl9z\n    yu61rkmcY4N27dwUraKAv2e0IeEX8H0SmtNAawv668EZgzsbEBfVM6d+5t4gb6M7Kkir9M+9SNUK\n    1hIxPBN2cFIyU4zj/PUHJbfEvkIDqlDdDRc7IIylbonhOoLt9n6NLk79pRB+ajm3DhkAAFhKHFe+\n    A20LPHBfIt9JkUpV6BqnqYkyoe1S/S2p39eiTqEkJVFYIQO/m5L03VyCUd43w6s1yCV1fveGkX3s\n    nuR1KY2mBwDMRYvf90MWLU96NOQMa6FfKPls2383F/NuLk/17GvR7gTOPUbuWCEn28bVmJ3T3f/O\n    TwcuBeWUDdUQdtcJHV/pvgEAx6H0OdRCTZoyJmcysAlue81sy0LJ/FApnlDQCXc/N+c9l1fDs3f6\n    vHv2Sgm+JD7HaOUElsB3Asd8B3+a5dP3gCjgsbr+beje26KwFrBWk9gxoULpUfs3vR9KKP/F7Bdn\n    xlAuqehfqr5CqObCl8Cy3PQgIV5NmfP3JfE5hLsvf1CUGiTZARm1T9/5mws1yHMHU4vZO29roeqM\n    oa7SOfFTq7np1qi0a0jFBkL48sQuu3ws6RGxsX5EGFEpqK3xk0rrTzk6WxqdZ3D6tqwXGTJg+9FN\n    pZHUJSk63z+22BxjBrJmAABG8ZxGevlMZ78YY26ZkqlU71B61JfNfhrqFjXdW+glKXro9NjYxXX8\n    Us5ed1Jcr1rJmxOV7p4nADhQz6Ox51NwLqwsWUzY4Vt6j7jRvm4WBeq5JYeYvTA3kjYeBVzffgzJ\n    UoA+Oc5eTs1gipFOYJ9UEJm2yF4QZ+YoYCVO4PAwUUkHi5gl+nf0bAstzCR4U85fihzl+c/M9WNQ\n    s8UknMGp5cbk18PwB3gvke+MMebbh+yqTQ8dal/ywd1PdYkHKgBACdbRa8zD8Pd43wZ/ljYd5fI8\n    vUXakMyV9VIRUa2Q7puNSFq38PkJOd/9DBgpvZd7brdEm1SkumbHPQDgKCy7SUwcmbNmOES46ZX9\n    yTh+CueUHl3NXfbftjbOYI3k6AiJZ0QXN9L3wX78Q13He1/aQU+kwrMmkAV31LFxdeJi2pU6oCag\n    xlLpc3WRzfyQ4wSWiDJOEUs1HcO12UpGAX8zi5gT+Ch1gf80S5MoYLd8Zit/x89C7Yz2S701bv/f\n    A49NWTbltFhX1mFAIPXD96kVVKnt/8Fcx4cb/cthZB1hny+Zy3PxBxIlSM6e43ANvHfb5hitfWLb\n    +JFJtamhQ3ux0tedYQkAAMY86g/eTYt7R1qvSSSbE7V579P+Yd1/GG3hvCupxXcGVlNu9PfP0+I5\n    Q/yoptwaz+7fPNx9Syc8A0fBypmFeGECAfBx3XNu9oFaPcqVcXbijC9XjYmnG87l1sARrBmuXrox\n    xxC5+NfN1sZ0++Tqw/eOkmlfQ1M+fSgA4Fj4mevaPGc+O3wlpCIn42BNumf7l2PTfHH+5thMv338\n    fTdL1EYrGRn8z6z+5Qc6SUcBc7N6hvwEHAcvyk2O5Y25HqKAq6DFroKOFXO26N9Wzt8/vP79WNiO\n    xRfGPYSwdPpnqejfnNlSpc7fWAppd/DwLd3UJ+5A5ofM/kg6glMPsjdigMnFf5i3kQHtUnktn/20\n    Ncfmlb4AgFqsUdGmXxvhzLhPernXkH01+9TOvtGzldN1tOPXPuxzXqv3atXP1D5KoBwPdvxAOSz2\n    /XnunzT330G4vwAAYHHlg50QQGUakMKXeZRMdCOM3Qk11AQqqT5J6Ylk9PHHK0dfSsNNXd0rLbMx\n    +whwd/x0M5fstOJy7GsDb+UNAQAOgJuyvpZnXficMt++z23L9tWYcCaF2LNXipSjNkdv1ZTQ49hk\n    S0sEfjFldX5npcQJ3CMj6WxRwP8qbAc8oyiodswg9BfmzZ8bqq15NkCPH9Dvio+fokQISkb/5iA1\n    iylWC/gLsawl30zZTDLf+Zszw42K2s3ZfjFx5+4j7Ut40McZyFnJuG/j4ZCRnCFJ1YAFAJyNpYtj\n    lcKNUnGN1e7fnqNFjjHCTYdNbU+9OEgZqR/7vL/81GTxbZ8dCT14Nc/XfG8cWrKdwhK4+vYxKWJv\n    zAYAgJ7j55VcRutStz6sMWV11KX6zJ2489CF95eUAzVXx+bp8/SkuZ6OYGMejuD99U7r0la4zhg7\n    ScK+B8enVEbCNnFMuCUQatqW2oeVXTeTtuW59sLS2rylz4K5QTKWlnV/Lda2bO3RMVtzTknCkMM4\n    x36uKSunJH4Q3R+NjrNVUGBv3pjrafb7pRgcbPssjt0OKfJUi/I2ugNCzBL9W0Lr1M/GyCianBlS\n    HEUaWyd39laK3imh3TQqtcRSQxvjOoJl7hk3VY2fJkcCPFgBcHyoX7l1ahnT1who9+c691w592JG\n    GKfDhlm3rp4r83Oii3oZfn1jf6gf+wiqh3G+p4Gaiur2oaK+KWP8asbqssX7C46JlZmxFzguVha5\n    EYwjrrs7McWv5etnE0odT68JXw+ZvXcGcxys7oSgXno0tp9YdLFbqzc2pug95rJjK4vrpBjRH2rs\n    6f6OMLkKAMDFzW7QKuNGKGL56vy173Nz6tXYKf2Uz9xI3VTKZwpu21ybceuAI0lysnuW+A2oWsCj\n    gs9GIV0L+LeG529mJ3Ar/o8x5n/i5+U4Q7uZboDRRbZHk5vaOSV4qZlWkumfpVNJ+3AUb85AIjc9\n    iDvQSQ16XiLvcw0YuQOtVE0P9707QPQHihL1fP3IqN4P7QCAOYnV8r0Elkvt161n7teI8/vQA1cW\n    U+nDXIPoNbD8uc28c7ePxIrXu70GXv46JecwdFwt0j67x16yzepE4vppLm2fH/1vz/73sjj/AwCO\n    hv2993b6+s5S9xnA1SGlKadLdUe8z/J6JVSzOKUbn1l2+rdFCmy3H7FzYZF4PuTi9suNXHYnVLVg\n    ZejIUeVHAAD9qdGjfrYLK8tqJzX5z4ecFM8Skb65tsna2sKtidmEcyJ8OYSColrb0Y0JR11bH4Lr\n    S9BQ57dVFHALjpQGOje7cEsGRgHvh3eaav9qukC1Mxda/HB6Rf9KQDlwubNpKMFt+cGUp9mQQLo+\n    wh8Zj1ulNSBq4A6sagdg7wXbpiKCberNe5RV+XW7BD5Lp4UGx8B3SyyR9WLfg2MQkg2tHL82mtSY\n    fZ1xa2wdXXHcjURKrZcD3wDt9mMJtsFpK7VOSQ1gMsXytpjbx6vkHHEifkug0pv6TuGWNQfd44EO\n    BuD42F+5pCzLSets932JtlfuYM3RXy63bTHrx6umLyndl6MXQ/o01xGdq9u5x+5m3+jNfvy37PRn\n    y4nGiPQFALhwJcwakB2yujjsiPX1Y0wfhByt78z1QoQCYkxieU7QTYxXQ2dvfA2sG4KTCronnOyc\n    IYdyyieQE8kr7SRulU3VL//ZqhZwb94y1p0pCFRJduWwqFbSQRY5F/5tcF9b/aBa1f+VFlg5ArU0\n    5QJnppGWOgN+LQYOIUVeWzviXWBQwhkQufgz7d4D+86diRcaDNakhvZnZ1Pf5xihF8Y6AIDjkpIp\n    HLbPv66RcJ+K0n9Aj+2vRypK1zBdGoWU65ilXhKRtbYtN4qpJBKKc94pg75/DNLRwrkGeso50qLW\n    oV+nGlk4ADgXfvpaCYewOyZ33y+ZaZ1dWmRwCMn9sv2kpx9SOs3XdxLHFNpXrq6vPp9bW32Sun82\n    4n5za/e6NYRrnyOhO89HzoRjTE4GxpinzBabM4U4JM9KsyHFSvpwHb8uIbuiW0u4JHiFs4212UqU\n    3eOSEyT0zSyikcAjo4CNoZ3Arj9BUzpnRAGDQcG3D9GsKfr3SMz0g9EkiFLCOjTLR1rBhNqTiP51\n    nb+u8s1VxNLRwNQgJXdgVBotTA3Sah5O/cHhzTOY5DqCuX2xa23eA3rIuAQAOBeSv/7VezD33/dm\n    l1LRiVi9OVFJOQbWVNRqnrP1YeytMVq7+8o51480n/G4/5K0mOkoJ/45l3ZaXJwjjbUbihJevDZK\n    jgkAcB6s7EylujXmOaIpla2jhBInraRMT+uUfQRqTrvGyDiCl8Jo4NB+c6OpjTFPYxQq40ZPYhHn\n    LTJ5AADOCZX6fT8R6g5HTlDPpSFuhB72cUskSE1ULq31W7pNC8dvqPRfburnb2Y5RBSwMbKRwDXb\n    +LSKAvbRGAVckk33LWPdnGBQTpbhXxraFnoE2f6f+Ne0WG7ZMc4JzUn/fMbo31bpn30kBFULIVub\n    9llL9K8l5vz9mtiWmlkmhev8LY0IrjUIfKt4HHW35KSHiQ08ax6KW6TbBMeidy07MA6pVLW2Dqt1\n    jFHth7ZzkYz4DUWi5kaQxmRmjTyNzSrnUBNhFDpP3GOvSd3MjRJu5UwN35/PtTyp1HLQn6AU6FXg\n    4t8NvrN3cf72kDtbQA7XZnVIOT5jukYqK0aNniyZoEsdX+6x+3zbLjvHPXVtpKi93+y9HIoM5tQU\n    dqP8IDkBOC8SYyeOfAyluLcZDyQzTKR0SqqMjyXHCfxeqcu4vJp0QJBrUw7ZnrU4gTnkBH3l+CPs\n    uj1qBUsE37XKAgv6MCAI9zJqx9NQW/+3BxI//B7RvyWCNEdg90ovIQFHwX41+Y7d2mhgan9S9Sr8\n    AVNqQOenhy7FTQsdShHNqbFU+6DvGpZoow84MhwnL4zV5yBHluyzByw7p1huJIhf863Mmfh8LCGD\n    KMdwfTF3vXUNfCdhhJdy/I4iVYPR/55bk3I1i3k3l8/JBI/l7fH7aPXiy+en5/4ac48QhpwEAFD4\n    Y3lKN62fcubOiEmarozdPuTwrcK5GHO6jtRftfuu1d0usclVryZv8hzHSV+iRy+77XmO/8V7bx3B\n    /pbQm8CSM+kY9815WM0+Crhl+m/u86EEVo/URvzm6jJ3f74NVCJwJ9fm+24WlhO4FoksmbXBWmeP\n    ApbCDV7UntV2plrAg5l7Xr32C+3+UEYX085lVPQvl5RiaJm6WaINS0jhfjPpwYHvRObM/srFHbC4\n    A5ncgUtubWB/f+5nKYew/97CcQbXQD1M2YcxPGgBcG6o6A0/GilXSlBRlaV9C8nFZ+Pno56fSyrK\n    VRJNjl977iSM2SGnL3VeQ/0PRwG3qVmZgr4v9yUT9lHlAABAExpTuzJy8f724hFJ+tznkOz1ZX5r\n    PVpXU5jukxZHsN8vn5gupR294TFRyfmTuH7+5ED3uRbPmQAAY6gJlou4dFi9cXwMyRTPNTbDF1Nm\n    t7SEbKRanMApNEcBf5/4bEzYR6Cp/q80fjBgr2yxOWgKqszJNtyCHmmg/yd8vp8fHXp0KMboC+Ki\n    6UYNceSw/1DtX0qwfx947yLpuK2Bo1h9x3BKYb8Sn3MHBf4gKTTgcfuSO7ByI3BjA6qU8zdnv6F1\n    3YFmyCkibQTx0XFHAgB6sz19plPv1coIP+o3xc08nIDGPAyGXKPhSswZD0UntYpM0uT4fZyTtnDO\n    ra09zM10EdJ9N6E+pyLvHpEIz7XEYMQGALhYeWFlljtximPWbj0lPid9sNWjlBMyJ+ODVL+lqE0P\n    3coR7PaP19+8LC7PJTHSuCm8JZ5DXX1rfyuuHvV16sZuGQAwG1YG+BOiLLXyZvXaiQVX+JObfHJS\n    N6fWjX3/Yoz5ruKYe6V6pt6HyHEyS0YBSxCy239v0lk/tZV7dPGD7HpkYa1hZBDj28DjblkH2KdF\n    NuZIHeDLtOmfc6N/30Z3eCIkon//LLyvUrNzSp2/GuEqWm0K2SIVEVxbJ0oKTj+o6DyJSKRRkQig\n    Pwvx8r8Hx2dzjNTuXxP4XNq+MWlHm1+rNzcLAmUkTe3zauQN17VG0hYRv62dv7z0pXdJ40eClxyr\n    G0FUcmy5qcpDR2ON19ZBDIcwAOfFj3iMTerktFOrm2qiP/00wKnRQE19+NzjaeEMLuHWQLdyxiTu\n    eXbrU3KPwx9r+ctD+5QklE3Gvt+I51wAwLFo+evmPku6zyE5Kfh9bp9/ecEiVL1h6nNKrr9//n0O\n    jGkZBfya2YZEpLFmQrb/Fk7gUv9GD3oEBR4pDbSmoNPO9E0BnfKkH+lC9Ej/LPVDd4WZ5tz0NYJc\n    S/SvVdo1Tt1QdLBt2x8YcFKX+IODnHQnj4HW/nOIUArm3BQrnIf/GgO1fx79h+EVD8mAQUkNnZZ1\n    d8B4/ChfyZGY+9Add/o+b8fpt/veNzpbg2gK6ahfjY7flsTSf3L64l/HK7Es1F7qfek5MyZfl/q/\n    oVg0E5gfPxV+DF/GgqPxPHWq5HrXOt5stgx3UkxOXcOQLPc/c/VKj3rGLRzBWvqS0x/KaeCf/xId\n    TWXY8LNfSOu3UNaZ3qUgQHtKryjuBBCDUz7mYvjPL7x9ti0JF8J1MHNtn7X4NtJU9K9vK84NOmqR\n    BrokSCtmv08FgKXqAJci4QTW7G9pyQzZdXsxMOuynhrA2py/uEHL6Tk7xhX40oJeYzRxruM4d8BQ\n    Q80Ms9JaG+6AjZNmhtveK7GMgrsvjkMGAHBcekT5h2r9rt53W4bRlDJolhpsa7blHLO7LD5b3KaR\n    vL9ulS+7v3dzSdYD3DtOHy8OrVJmW/xrzdkfpQNDNS6p7VocAzge25aXir6FkwSMZ9vqHL7BdpmT\n    UFbjZwDiTYThZMiQlF12f3wnNj0pLHZM7+byqfNqdSili8P9pevwjohODu2TmlTFvb4beXx0O9J6\n    FBITUECXnpe88j80rtySyvonYeszJmxzTPUzFekbIzeCN9bXmF23NNjIbldjM+4VeJWy/c+UClqC\n    VlHAbjCj9ijgHDT5H1tkZb7Sbe6Hoy090T3zaI+mxw+jxQ9c82wUjgDnFHevqe1gTJ1Cq3W+xmZz\n    cdoOreMPPGr66T60Uw/wKeduqSPYDgBv3oCwdmDopoNLpYajDI4S6aHBvFAPTvY+cV8A1EIZRO1f\n    jpE6FbVSY5yWmO29Pr0eDleO09VfT7rGL+0AXQLG6jynb8n5k6gXWPO93weq5mBLIFUBACW4unMx\n    +UbnmGO3Vu+UZjXi6g/KGUzpM06t+BJcx2tqv/552Y8J8idY1Z67WBucZT4bcwyHZwhQCvU8iudT\n    YHFrhrvk3BdX5jIusYm2KXJtjLmZCaV5NXybrLXlHinds7XZx2zvru2/ReDWPwLLNaeC1k7rIMvc\n    MrExJ/BB/Zc65srnet9zL2wuNTfmkWZFlDAq+neJ7Ncqjlrnbw3SqTRyFf1r4LNkypKQ89e+zxnw\n    laZlsbRKw+nWKolJTzuDGw9PAICWWBnjyqScGq2x6N5U9oPc9mvwjcC3yPepdqT7I4Xb5mL26bTX\n    bZwu8R0Ysc/Uto8JWo81H44UAAAYj5VF24cDcTOLI7OWpJyrfW7h95OvC1y9cTX3Z+VW9el7lD+g\n    9kelUOY4jXPgO9D5+8pNF23Mc5kDV7/ieRMA0Apulj0qcIKi1LZXS03defev/z4X3y5r2yoJwvFt\n    4JJOYGn7da6TlmO7TwWJIQpYnrP7u2bi/z4v0uEABnx+Nm1qCmuO/qVwFUhMsJc6fzWmfw6xZN4P\n    r4XflVDrYC6pERza582knSJU3a0YOSm9OO0BAEAOJY7YGmM1d3+56Yp7Go+11Ry07fr9u22LuW3L\n    k/PX7YONcLrxdiNK6J5y6wpTRmnXgMRNvQoAAK3wJ2w+Z/NZPh1uxjxknK9LJKN9udwdng8H9lPE\n    6IcOuW2PybhulG2LcznLs05OX7klLHKPn5MePISrP+EIBgBI4o/PKdlCpXbmyq/SNPs58tXaDsv1\n    cdzh26L272viM8W7WZpF/7aoB5zDdyadgdP6AlL2e062UC5njwKucQJrK7U6Kgp4UB3gPg7g2InT\n    lHvbGET/1hAThP/IaCcHzqyekZG/xrRTnLXK/mYW82JkUpykB0ALcz0at481swZrUkOHSM3g9gfO\n    eEgHAHDZnPd+VNJi8lP1ljykP/bPczRfmdtbo/TNcXC2NB7X1NBtbdQOORRifVgNHQU1yvh+N1wv\n    n1FmdlkO0I8AgNbkZuhxnXI2Q8PFyKQILu2/+56qu57SA61rytfozN59oyZbxer71tQHTh23JTdC\n    2J1wZe9vO0YAAAAuHN3IKY1Wwr58URjKntgqC0cLJ68xe8fui9kH9OQG5LwafemfJesAx2z5I4O2\n    tDqBWwQLgva0qAP8/8ziRwEjAng2tP6gpQVgbIYOV9D/bRZR52+vgvY5cOv6UviO3x8K+8AdcOwe\n    tiuMAhbKsZ6VGq1RqlA3DevFoBYhACAf35BnzD6FbgzfcChRd7BUHsbq4+a0UYtmx2/pSJyq+9yq\n    NmOs/6H+uN9xJivEgEMYAMDhkcrZ6s+8bAPutzEnXEzetTmutHxvXSNYot859IqijvU31H/OOZPQ\n    wf6kupzrxR0zAgDOiZ0kwhlj19q1YjXcqc8ltkIqYCRXj/jpnlPbt3IQl9DKCSxpTy912HJTPc+U\n    xdOYexZWrY7kFEcKfjxRLeD2A8OZon9rmPUH8KdZzD9Hd6KQlCLgOGwpJSGp5FpFH7+bpcr56yOd\n    +tnFdzTfKgZ2fpsSs8RrBpox7CA5NUsSEU8AAGMeEb5+tgD34dh3pPnyJbemXAmxdMPSUam1xtNS\n    HaHZ8cvtv38srq6hUzPn9Z17XkOO4NQ5oHTjc2rWvL4DAI5NTH/G8HVpifRP1UTP6b/te68MD1od\n    wVLPeSX7Dk2ysmm3Q7QqyeCP72zvlsh6LqGU0ZsBAJwRju3JjtsXU69/boZ29pa067ZVUjIu1l6u\n    TbDU8fpq8m2woQyQLWy5tcFP3O2/N2nH7WIW89uASU2pLKZanbcXpf2yaEsDbcyxfJMuXhTwuJmB\n    Gk9w6Y0Yc/5KRuzOGv3bKv1zDI6CyJkh1EsBSlMyIMkZOKUGSJy2bmYx78aY94rjvA/8eDP1KPyB\n    57u5NDMoYz72+chx7oecM+AYbJ9/8yd+vJj+zl6KHlGmte1yjcZX77V8/LsS34VeuZSkRZY6x1Q7\n    jxqS4X2kHLW5Mit276bOD8chDI7LQ0c+v6A/z0fJNff1aI3+jMnnVLtu7V7/mCRkfknGjZLzkaMv\n    YzqWsw+J81G6LbfdnmmXL5HlbkaqGJCb58C/zgvj5W4LjkPsei7Ee+lnTCkZ6eqFEh3xbu52yFRw\n    ikS5PLetkvY4Nl2NqaApQgFSHNt8LACMEwUsWQdYilmD8YxpHwT5NvoAP+gVBdwiDbTlwwnc1mR4\n    sHDp4fzcoE2NAicm2GsVQ6qd2aN//fWo9zFeEp+lcQdcOZHB10A7EhKtRZ1gilaDaqALPDQDizW+\n    cO8Jd72a2r05xAyk9ruLaWfwXL06fCFikVavZm/Y91+tKdn3k07b8g33pcRSXtpI3zWyrRRL4D31\n    OQTkLQDHRmqySQ+DtpWbfg3hfZ3DPjJrNfc6tz4hg/nF6NSjsYgpbmYKzhiDS0h3psZSPbF7S+23\n    ZGIiAGBuqCx1LWS8lT/vFa3bLa2ztzR7X0k2wpRNNDcohmNj9e23I527pXbt3CColK1fY0lGrWgN\n    HrQgCrgf/+9xrtsN4WdL/dwi+lcSrT9gjWkPrGKQcsDOrmiowUJujWBqkJIa6JTM1L4xnK+cdmMp\n    l3Pbch/iuWm9Uvu9FGwDADgXvaN6KYfu6jmhW9Xku220cdqeh1SUS45RuiZ6V6IPscgn9zy0PN8h\n    rIPfzapxM/0mRvn4qVg5e0c0EwDHJTealXrfq4+PCFy7bNk5gnvyaTAndG1JVosWzuCaPnAiYV3W\n    yJijFt8R7TuG/WWtCJVf8EuJAADOQ0/N48u90rF5ji6P6Y9RmRosKafv+6eTPD+IxyIdBazRDl4T\n    7FVCjzTQPwn2twUxX9SspVBzOUhwK4Z/Z+ba4SaWTP/8A2MdCYWguXg8N/o3tr0xxnxLrDfC+UvB\n    mZkXGsBdA+9LsWkue9SGBACcA1eSaDFW+zUUe9arjdWX5RicS/vZKxIrpItu22LMtkQN4K2vQ9BQ\n    7um9/f3SH6qPiFwC4Fz4qUxr6/dKEKq97uuWXrKc2senfok4QHtMPCpJT+0fY+nxu9/ZbBst8DOV\n    uE6QXo7gkgnJAAAQglumxX+WTEHZ7dznwZBeotqn1i2J+uW0S+0jZUcNfffNPGy0NU7gVkhFAY+2\n    xXP8Bb35o0GfWmSPlaZFFPCvlW3GglVndgJ/1AJuM+w7S/RvT2b4AUswUiB/Z54VjqZZT5LO39LB\n    T+uU0C7UQK3EKEHVBqEM7LkP4KGIKDxMAwAo/EjGhVhuzN6w3TIN181cqlJxSfTDrQXoE4sEkup1\n    zxScsT7EoAzZrhGb+i6HWDptyvHrvqfTR/chFt0EADgm/kSpi+k/8cOtmf6YGGq/o1JB52e3iHEN\n    tBPKLnSJtDNa/8XOjySpccbi6bLeI6N3c+mWaSP0e/HHpHieBQDkICm7pCYirU6ZOQm4tlB3Pa79\n    9mYW87eA5J2hFnBNps6vZunuM5g1CrhXFtmzRAEfgPmGdiUe/bfIdzXO39SNLvWDa/HDlRAwKUEn\n    Gf3LRdJhq8n5Kwk1o4wzmLHr3MySNZtNCk56aA5UlF1tm1vAGF7TFgDgXLQ0+vmyqZfj1ze63vfq\n    ur/363LbrOUmbBDIpSb6KWbEphwDJX0rPSZ/+1G1DgEAx6b3bz1VIiFH1uXKxdBEH0rml+jH2mhc\n    CaSM9Nw6wCa43vP4pFc5htUsu7FZamJB7nnJAboUABDCTryq1RtUkIdU1r6aGsGlvJj7ZCL3M4cW\n    ztpXY8w3RZKcsqtLlWsMEcse+peic2NpEQU8AxqDMQ8cBSxvAJz5hJyJswqYEC0VkIQj+Vtl9K9L\n    7WDIHcxcTZ+o4NvHQO4RubaYm+HX5KVw08VJRpPd/+qYVQ8AOAfWSOhORslNv2XJlYcX4jNlrK6N\n    sJEywo50/BrTRzf418BNrU1dnxYOADcNXIuJTbZesT0+AMC5aSFnNscJJ9l+SN76spr6riWjn12k\n    JmeVjBX8dM2hSVUSE624+Fk4JKOEMeEYAJCDHc9LyJ+H3KzL9Ge52wX7TEB9SXzm91lfmmdpUjb2\n    1k5gSXpEAUvTM4ssooCnoK/JRGP651J63uDSP9weRcZLon9jM3E49X9z+WqWoHPWXT6TYsrBHWhI\n    PGy/mLwBUM4+W868tgNEt96IVJv39wAAEMY3wsUk4xp838bJFoJjmJYaYUo4fjVEOI3CXgc/bfTF\n    OS89ngZ8h7A7USpHT667+fUAAPCAIxtWcln/OuI2I4bdty+fY+n5j46EvpaO3O057uHg3qs19+0Z\n    x0UAgDG4MlIi6te3J5aWjiuxhfpBMSVtUU80Us5gLVHA1pYeC4o6aubNXK4NzoPmrLSWWBTwW7O9\n    npKHCP6PQGuzRf+2DDfX/EOTiP6VnuHSOw0DV8mUOn8lnca1tX/9tnxyTKnvgUHVS+B9CKkILHem\n    uMSs6OdUpXxC+90GGJWARui0t/vvcI+cCV8mcGQOFeGbQ418pKJKW0bClEY7rd7L13uuM7jUMRxq\n    YyZDqnX8+saYHqkujaFLJ4TuaZtu7qzOEABAHlR0kcVGMIWyE0jLcUrGUqURtOgPTj+k9F+qnXez\n    mPfPCUOPVw4tHOkpZzClW3PPCxdKl3K2hz49JzlZWWC7OB9+9qjQPVBTyuBS2ZYxdxug3e5bRJq1\n    cAK7QS85wS9HjfLloNEJXOJ/GFHiciaOFAV80DTQ/YZ+o6J/3xq0eaQbuwXaBaOvXL4LfK8h8nfU\n    rK2SAYofASyVGprTjv/AmxpIpmr/UumhL4z2uIyINAAAzIfUBBKucdaNPDLOe/cBuoeDsGZ0ShmS\n    OYbjmFNX0lnsc9va6wHONfMdErUG7FyoaCYtDhGgh4XxAsDFdfj2JOYQ1EJI/7SYHJWjS319LTHR\n    qtc18MdLvh7lPh+XHielSzn3Pp5Jz0GOnnTXxd1xXHw5kSN7OPYx7vNDSj5LpsCvJSXHXVtq6L3l\n    NbF9Da8CbUnZozm29dkjgbWmgW4ZvSuFZHDmrx2Od1InsNwweLYToLHYtM//mqVr3vZRaCnCzk37\n    nOMY1pB2w1Iy4CitTRFzBI9K/VxTL5hKDy2ZMhpRwgCcB+p3vjfY3en5gPv68fIN1rlI9JmS+zNG\n    2IbOx21bdq/Qscbg6jOJiF7fgO1Hfss7hvf6EHoRAMDBnVwZlqHLZ0YBKfxnA8mJM7Y9bjsx3RDS\n    o75O8vXSrLo31G+JkhIluPu1Y64R58U/Bo0TEwAAbWkxtpZM5WyMnQj0rI8oYnJZqkRdbu3fW8Cm\n    emS+M/WOXo4TWMpRrDEKuEUaaClmcCSDKHMN+Xp48iXQ/MNoLVBGRv/+XXFsrVNCl2CdxxIPiCUz\n    vyQGLVJRwKn+xWg5W3AuCQoAGMlGGNzcVGwtoh79Gud2325mg5Zyms89zsD2c92WzxfXGK3JSJ3b\n    l5yIqJvh3SNXI29wiEW0lerDR2rneF/dY4ZzGABgTF1GncWU69tUyl/p54Obox9T54OTJrk0ulcL\n    MScA5eB2xxTG2DFR+ZhB6ly8mOesK9S90+vcQ6cCALhQ5Vk4mfNSbVpugs/FNamgXwrbodoK0TIK\n    2Ji+Ubyx9b4zD7v77NG+M9EzqPBI2XJHZTFuSB/3xZFOXM8bGtG/fXCVT0wRcRXel4+/Eor2S3UL\n    YbiOZcoRnGtUfjEPYzTX2SAb/fvo9yLsJFgN6hICAOKkon5bsBIP5S0N1I/98vvn97Em5aQWWvWF\n    chL7y6wjtYXzN0boPovdY1LnCemiATgfOXUsU3DKwlClYYzpPxHUOi4tMb3QAk36trbusDGP6zny\n    uCh9SZVg6Nk/yd8XAEAnpb9xaqKKhC5cC+2Mkrww3nPQFPErEUxUYteeJeWzxijgFqmkpYIUWwY7\n    hrL0vjXbYx21WZD/07/LMo8tWtM/vwWWt0z/rPmH9fuBo3+55CgZjVHBJUjNHqOcvzmDG9/526OO\n    ZAyJh3131mNu3WAAwPloqYUX513KQN1CNrnZFh41d9NytkYOazFEj+A5hSNPp3Giw0q5JN5bnUnV\n    GAYAAA4tHFNWFr2Yh/PrYvY6u4e8isnn/TPXcyXPs+rD2ue5eOaNxRnbPNclbo2fUtyYx1VveT+e\n    804CAJQgIX9DfyW5Mr97MQ99m671u6fG8UvtS2MUsA/XFh4KuqrJ4imFhqA0IMss2YM7A9MLGIc2\n    QRuLBI6lsaCoVbDvZmka/SuR8tMOcN5N/mDHH2TFvm9Nqwf40IxuAACQ4lmmpOu6ScshTgSStJxd\n    Nz1RSCOhavyuZtnpZPf6cJ3ysuyjrVzjNXQiAGAUoYhL1+nWOwqSktVuH26e/M6pD3x0xMcZu/Nu\n    kuMcCWJ60b0nF+8e6OEUBgCch5bBDClnb0+dFgpO4dpKb2Z5soU+bKR6nlMl7MrWvk3Zv0ucwLVw\n    HMc/iO3tmdbBb9LBe2fILtuCI2UzNlaktww9ljphZ/PgS/9AJQUIlZJgdPSv5Myhmshf7dHAxsjX\n    e+Q4f0Pr1KRWKSGUQit3tmHJYPhcEgwAIEWqtpJff0mam/fZNUi/m0uxo5eKbEn2hagJfEZCjt+c\n    aGuOk75XpLD9jCsLAGjNc+xsnFZO4H3WjLxJU5TBnNILZ2MtHCOkxiIh3bmaxbybi3n/aGEbMMGK\n    ewwA1LCN7gBoSkxqScmW3hkUKKy9kePs5Qa4SDp8W0cBtyTXCawh/bOLtuA0zaSy1daUTT1bGmif\n    /7a9D+vFOdI/P2iZD/1o5AjYljN3LCkF9NUsLCX1xRhzUXQfSA0Yctop2ac72GnlROcaRTjO4NpB\n    a6vaKQCAueGkm8yVFTWyxRo6b85n+/fmtNzjQf7sjl+rN0ocvzGo7WtTsJX0yb1PF4MsGmBPTk1K\n    1K8EFj+Nc81dUSNrQzJVQnb7bSC7Qtl4odZ5To2JqMjhHDjX0W97cf4ugTbOfn8APlaXQqceC19O\n    uMtk6vm67/OfKVpNZnInSnGCT3wnsP+5RwCLFFJRwF/MPPV9W4MoYDAZGP5pRHP0L8Xo6N/WUMqL\n    UqA/Ce7zdfRBF+I6f0tmw10D70fRwmCzZ3H+BwCclVAKv5hs4MghnvHwuc1YNBJSL+ugdSpn917Y\n    iPfU+tR3Nc6IkPNXyqEDADgOsckiJTLIyi5KxsTk7+o4THrpzv6p/QFFauxUkmmDq0NjDjqq9EJu\n    JDw4FnaiVOwFjolb7kAaf2JSjV6S7F+u45diZGpnbVHAXGdyKogq9N33zPal6wcjCpjPDMGPZ8si\n    zOCYDuC3Afuc4QegBWnByhX8IUUSq/0bIlTjt7b2ryS9on+pQZQ7QMoZ+FFpWa5em6N4zOa+7D7b\n    Wl0S6Ll7AADSSKW5lTLycpy9LfZbwtmjf100GPo5fejxhMGJmAcAHAeO5BslC0JG757yWoN+0ILW\n    cUMsnXR4m3a4UcI6zxgAoDW1Dv9QRgoN1DqSa2yq2hy3JfiBSdbeLRn8NDOzRQHPzNug/abK2tZk\n    RW5Zjpeg7hGpV/pneO7LQfRvHZRDmFpGKcAvZlwkr7bBRqnz9ur8pZzDo/Ef2jFbFvjkzrDHjPxj\n    08P569cH9rd1l3Fk1sgHeq3GhJZQ0T5aDSu2P+9efO4iODEqB6Q+BeC4+Gkqx/Rh+ZQxmjNjIDX0\n    ndumd/wSun+2ykkEEs+iZ7tPAAD5bIHJK7UyV0pmL5F2OPbEm1nM7UOOa7CtSvShtA0/4jcU9MQt\n    myhJKhgst5xkbbDanwLH/8/qFsJIZptFEOR0XJp6nFOe8qMgeeMfPS97rkBNCWzptA8pYgpNKvq3\n    xQCj1BFd2xd/AGcdwZRD+Mpox12nJH1Lr3SZAAAgCV+uPBsMa4zUI+XZGWVpyPGrEff+uiTWeV7e\n    Fp1nDJSymLzJUZhIBUpZvfcpPRpLi68BOIIf56GGmsnHJfsOZWjZIvrWR/N9CQCYm5BcG6lbrt5f\n    /z3Fu/c5ZqsMkbJJlgbCUPbbkY5oKu0z19nbMg30GZAK6juCw/ZtdAc68N9210n/8D83+vdtdIcV\n    0SL6V2JGywhaKZDQLCdKQX4x/HoJNWiYoUYRGlC9m/wHa7eGh33fS5rl1GGiZka6D+T6JTAAYDQx\n    I95DtizBmdgl1DoeawzMLZ2eGmWurUtFOX+14k7K4p5Te13dupitjhH16wAAXChnm+vYjckSV9fN\n    MGHH77umrEo9zkHtuGbUvv227N/UPQo9CADIgcoSpT3IgXL4ckrIXT++fzdpRh37qGySHLv1N7OY\n    nww/Y+aRmS0r6tGDDl1myCbcMQ20RlNYOW+jO1BJ6x+idJ7+1oIuN13DKL4z6ejfHo7fEKOif3n7\n    SM+048yacyVZyJgxMgUY9R4P5QCAFDGj3uY4fzVRaySV2P8lsDy0bs2Lg3XyUstnoVUa6odTGAAA\n    2nGXNYZ0mklGiGp2BKf67i7j6icJPXoJtGmYy3MYNbmtdt+h/sTaXw2eNwEAaVJyrbccSTlubZ+p\n    qN/afZVG7MaQtKtqiwI2ZrzDV1sa6DMxIqr4bfRBE/Qqj1uJbgfwDN56qRvedf4eITS/B73TP/tQ\n    ii4nDXQLp7DW6N8QvvPX1tqw5D4oSwwCKWw/pCSmP4jGwzkAwOXmSRvX4bsJyyNLrWGyZ9Svfei/\n    Jta5mPskqFdn/VZO12vkFVo315E8ktbRYu79/ZxFw+z+bsR2AIBzQdW1dxk1saSlnpHG1ZNUv3P0\n    mhTuPl4NT0+GMmmEGJnlxO6/NVQkH/QlAIBCMkjB6gfpWsCu7TRHB4UcvDezFJWUK0UyFXQNlL04\n    FPFLLftmlk+b9zezmO+E++cyaxroFllTpbO7Igo4j97lbRulgS4fuqY83L1P0FuHffyr8zHVoDH9\n    86iZNC0Vx3fm4QiWcP5KO3BLBwwtZr6FoAZeJfU3XHxH8KL4gTeWLhoAcEzWp895EUnSUqJG7kga\n    g6lRKdeZGjJet+5zTlvWGe2nDaXaowzMPZ0K1kA+2kFNpbmEERsAQLGZRU22HSs7r6bv2J7SSe6k\n    KT9a2e8v99lR2hGc0vHUspJxgT1W//hL+1yK9D0Rai2UvtWNhgcAnIsZxtOuPe/iLSvBDTSZ3d7W\n    KugnJ0DJt30fLQo4F+nsqNLZW4/G2+gOCNMpDbTemIOzRv/OwlHSP7eMIrZK0Fek3NlVs1PrRP72\n    IZ9K26EGiiNn5GseYAMA+qDxgbv0IVjCMRgyVMfa5sjxGSKw/AgkjiE75zxJ9EvzOYzVKQMAnAtN\n    OjVEqzT6IT3AcZC6/fLb1AZXr4fWCenM2vFCzfYj04VrmSgBAOhLj997jQ7Zy9TnSbI5WDn3TYlW\n    0xIFbAyvzq/lq1mCDt6vjaOAR1EbvNYiClgaKT+UdAbb3xqcuxn8ix3QIQhreRvdgQmonUGiTYCN\n    Tv9sTDz6N2cGlJRD2J8JVprSpGf0b2n/bpHvL8T67nI3jeUxJCDQzL5W6+Oz+6LWhzEGUGiRWdx+\n    UIbW5eOfv/zK2J6zP81OS2PapJ4MpZPOPxeLmnssRGgShcbJFQAAWWK/71l++xeTN1nF12u5dXO5\n    zFK7uETHxxzkLotZghOuOPvQoj9r+jHL7wgA0JaeskCmlq/9S6d8nkG/9cK1G3OClSyjo3xrmS0K\n    2Eciy+uRyo2+je5AYxqkgdYyTN3TyjvfYiaBNBI/yBbpn12OEv2rDetEbjHDazZCAzR/AJdyVscG\n    eu5As6fDQL8UAgCMosfD6Vo5weCS+OzLVNdY7aeblIJreB318N/bMBy7Bu4yN9JX5xMBAADko92J\n    5Tp1V2+iqn3PiVRt+fyiWSe00Kl+WujQpKrUGEi78xVOEADAaCiHb0if+fa+kIxdE0EitUgFyUil\n    by5px5YiaoGGKGANQWKz0SoKuFf51LeMdbVHAXdIA615aM/jbdB+z5T+GdG/z8RmRtXUAqYUMkdJ\n    S0X/Sg1IekQRU7P5agwhF++vBQ/KAACwh3ImxgzTrSKLchy/I2S5hogg2jh9Px9X86hJrBGqNjYA\n    4NzkyCttssPXm6/mUSOYqrk+WjaP0mFcnd2qf9T+qTFOymlfuu8eaPttAACOB1VewM/EVzKB1w8G\n    4QaJaM90GKPUvhuyL+fYrFPURgb3tO/3DDar9aOgDjAQZvRjxTPavfIzMpPg6CmQaxVNiaL7ZhZS\n    2YYUsLZo4NKBRw6lA7PFG/iVPEBTRhdt1wAAcCw0G+Gsg9BNMexHlvrru7R0vMZmgLv7pIwGLV+h\n    /r1vF/Nt4427W81g9+v7plKIjnpKyPlN6P31AABakusI3gZOBKIyMrif7bNGS53J1SurWcz7djHv\n    jr6iJsf20KMh/U2d416OYGPiKaL98RIybAAAzoor/6TkoJ3AWmPzc+lh3/SRCrrhkmPPrHEMIwp4\n    zjTQWmsBt0C7v9GPAhZOAz33cPRt0H5bRf/O8IMZzWiBboysYnMVbCoauGXKDmP6D0SMkRtwhWYB\n    ljqT/bQ0pQZxRA8DAGrpIUVc4+nFexlTNlqUnGXtO1avxph1W3Yvn28fDtfbtny+enAxxhinX74h\n    PXy+Hi9p3eE7flP1ljkOixZwHb/QrAAAy+L9TWGdwS2IRYSmshRdnVcLR7BNj+m+Urxvl4eOta9O\n    WL1tdTl1PvxxADUJTerclRAaWxnTxwrH2YfmSYgAgPnwZZyUHL6ZZXgEL3f/rZzK3Ha5WSWtLdp3\n    +pY4gWeqD9zaSeuCKOD2vI3uwDzM7QDuSa8c5rVI1//1BdaPhe38xehXT0FcSo3zN6RYQ4pXG9wB\n    R83ArIXDoGZ2IJW2xhjM5gYAzEUoMtV39HFqMXHgyPLVhA3QVCTQ3bwfNopbA3DM2dvSCfxZ53h7\n    6Byu3lmDx1znCEhFJXOPyz9G972rF0vhHp/uURIAQANcObd+OIJLHGCpCTK1zwiu4bxW/vsRtSFd\n    k2rnk21p/gxE6WpXt4cmfq0f4wQTOW5yf+auh6N9qnA+xOoEU6mkAQBgFLlSzn8ucJf573OJye7S\n    547RTuRW+A7eL5nbS9miS+3loUCv7wXbAmG0lSb9reE1PHEUsK4hpvYLIUmvH9iRZoxICvLatmoV\n    pL99KvqWUyvYMiKNyWhSA0B/oPeoExInJSEvgb8AGEM/QC3ECwAKCXlyMffoDqpGb6j9mgkua8RA\n    GnJspqKQbF3EWFup5a2prR1PRjZFnMHuxKbQOe95LmJOYgqbihURvwCAVuSMsWKyKObc7eW4Czsu\n    eY5OCX1ATSga8dxz2/LqA6fWtVk3uOeoNGKWOl+hkhqfmU4+9tXjPCMS+Nj48nBhvNx1wbkJyUcp\n    GxiV/Uiro3Z0FHCMHCewtT9rD0JqRcvgMz9orjYK2KdFGmgpRmW1fRuy1+mY113xlrm+1AyCo/1Q\n    YkgLqhitBHDJjKEQubOoOHwzy5PzN+UMfk18bkGP6N/e3BIP+9xZhZQTePGWAQCApXXqSdfIGMpi\n    0Ov4QtFHLi0M073wneUr0zBdeoyxz6lz0uP8xBwjj8/8fkCHghrmGZGClthxOUeeLM7EFH+b3vLo\n    MdEnreN66sDV7KNva7I/SJwfyXZCk6xa7TvF/d597Mu9J3PvR+76cAQDAHzsOL5UOoT0xM2RtdTn\n    0naPjGuX5aZ6tuTanUtBLWBZZg3q05xFd7bgU6EoYD2mldkuwAzMKigoNAnwlvUNcpVwD2ew9oji\n    +hmH+ek6c/s1apY8AEAPXKNaSFYsmeu3kjluqsSQg9FPq9nC6WvbGeX4dY0OoXSUo3h3rj7HCe+S\n    yoyRi43A8iO5qclS9q+eMwkAOBKhVLyUs3eEIywmr0fpu2BfPSfwCEN8y3Pitxsb19z7ES9tUYt7\n    f7q6M7euMJ5HAQApWsiJ0ORkTXqNC9dm28OOmmv/pZzAUtHAtXby3jb/VBAap4wll57BdVz8IESp\n    LLVnjQL+RfC4/1PfBMWcQ8C3zvuzMxekbmT/h4Xo376UKJYW0b+pgcM3s2Qp4R6RwDE0RP9KDCA3\n    s5h3c2k2GJ1T6gIAenAJLAulEw9t10J+PT+wP5aPeHjX4Pi9KXP8pupZxlJnPwzYcteTm6bTmOe0\n    g7H7GwAAOFBOs9jyEFLOYNdRGJO1odrtOanze7A6dXmNGesIHtE+9xr2OEYqCww38p1C030GAOgD\n    lfpbYgxu5ZeVKzM6fUtp4QTODQLKLT8oQQv7eS6agshAPi3rABszXxCqQBSwDpPKbCce9AWCm56N\n    FVP0r4bnEM5NN62N1kaG0IO91Oxuqj6ZDqkMAOhJKIV8T3nwSL+1X9Y7jbBGKKP2TZHj15hyY23o\n    +lLvV8O/B7jrUZFL1H0PhzAAIIZvuObIlhypyZd9zw5e6Uje1GSf3twUOII1jU+4WTdynydzrnnq\n    +RJ6FABgjLwsCEX4Sk4wdQNPSvovEbgiFfzCdcaWOH1dG3IqsKiHU5gDZfuXLOvo0zMYrSbI7kjZ\n    XWfl35331yAK+BxDv9YzBzRSIyCko39jqRN6R/+2TN+cg1WwoZlRroLm1GpIOYPPQOuIpY2oC8VF\n    x10HANDG1dDyoWR0RtepM8FlrizbiPepts8C5fjV5vxtCXcCgNWPHAN1zdnLjdwDABwTN1sAlTnA\n    RTI17pZ4FjjzxClfN46KCNYCde3d+4e6lzhlGEqd/1R03xJZBwBwLFpNHNocmWaMKbKXHRkpe6xE\n    gE9PNNQCBnFaZ6PtXQf4rfP+JmM+B/Db6A4IozH9syZqon+lZgppUlwchf4aeE995rbTAw0DxCWz\n    D9bYrWkWPgBAP1T0vwRrcHk4Eql0JCgls7Uah6l0zxodvxfT5xzGHB1UtJvL1qA/S+A9ODabM+4K\n    vcDxyal5mkMq5WVo4tSoZxiN+pPSlZodwaP6ZcdfF2OC47PU9lJQY1JI0uNRqh+hV8+Lf+Xd8bwd\n    /+emdZaKnNVgO5TCt/HW2nPd9nLsx1qcx5JBWxx/Qu+gtFJ6RAHPXgc4F+3ZiP0o4Mo00GWPTani\n    xjmh0dpPuPSMBakfFMXvys/laLRE/9ro3lwHKycSOFZj4jXR3sxoGgDePuSq7dN802yAFJtjAIsZ\n    pmG4Ph9ScmF7crQ9ZmBzInlLI401yVxptDt+3fOvRb9Q95q9B0szZwAAwCjsZCpXtmkdo7nlIjTp\n    55Aj+KjUnHtfl7tjuVi0sLuuBFrGFKAdOc+bWmUeGIe1c9XW8tUga3rrylQt4JfI59kif4/EX8Ln\n    VTrbqgSanbUl2XzfRndaLxpEb1uk0j+3+FG0+qG1Sv/8Y0F7mtI/H4ncWV0vic+p9UPkzuALPfhr\n    MFbkRv/G8AfFflocAACowc7Admdf58oZqTTTR0F7nV/f8XuEETx0IgCgNQ9n7jPb59/ntM2zTVzR\n    7Ah20RwNLEHpeeeek827T+1f6FMAgCTuRE772f1bgxb9pA2uDdbybpZsu3AI62RO1QrORSqbpqas\n    nAD0RDAKeC7z0dvoDoBp0KporFKWSq/sK/xcZ/CrYF9GITGA7CkJa2dMAgCOy5pYZo26N3MpfhDX\n    FPWrxQisuc6vPffWuK9l5L5l3hOhCKe1kXEJAHAsuHJh9f6GHGbu3/32+RkWNI3pNTqCtUcDS/dF\n    MhqYsy/718+6sV8PAACeWYmxd0x+SekUieCLVvotVydwg2IoB+9rZJ2wQ3i8Xg8hlXXzyGmga6KA\n    e6SBlqZ3HeBctGclFmSsGelEJ7obraJ/pfmBsU5N/V8fjYqoJbm1go15DDBaRf/mzmjrSYvBI0e6\n    htK3AgCAJZXWmUtprdhW8lGLI1Nr1K/GVM9u3ziU1OmMOYE5978GZwcAoB0pObBlGrM5cLbOnRTT\n    Gt8RrAHfEawpGriFnh2ZHtUfO86QzhwA0JejyIJSPSJVj7iE3BTPxoSzQEqnf0Y66fNxtDTQgESb\n    Sek8aP6BgTa0VKTvZvkcRFCDgffE9ryZZm0oHXhJGQxGGx6OMvAGAORDGeRayARN6Z61jDwph7gG\n    56/r+L0aPecr976UPpNU9oy7Uds8LQcAHJ/NmK6OrVkljNV1WqKBKUY/i1m06NvavsR+B886FI5h\n    AM5IjwxSKbTIfooWNtEXw7e7vu/et3P2umjLDOkHX7VOAx0KUiupA1xSPpPLT8aY36Gvo7wN2u8v\n    ja6LUBpoTcPcOG8F29TOFNAeqq4d6YLpXLTXB/jSaT92cPDN8AcK/oAkNCjJHXhojv5twTySFQAw\n    ipwH71KjXKksGun87WGg1iijfcevFqNITlTbiPPaaxIFAEAHq5mj5qm2PlqdotUR3CszSOrYW/Vj\n    xDkvvf+03bsAANAKqSjgWDul0b6pIB4wLz2zrwI5/j26A3XkD29bebRBHb+b5VDpnyWZJW1zK6gZ\n    Y6EBSmhA0sqBOzLtijE6nQAAACBBqXQdVU9ptFF6ZPSve9xaHL9+v2JoSukNADg2GhxTOTJPk7PV\n    nVw0UueOzrbBOW5NTmDoVwCABlwJJqU/pOSbpucnywvjvcXaRX3b7TfnvUm0Icm3iuvb0v4+Kthr\n    VHBbT1pmqdUeXHmS8rQYToZoeYPOmP45N4XBEaN/a5SgJFT0LWcAkJM6JGewkqLFYEyqTamBq0Q7\n    GgxaAABd9DYWjqr3O9rxO8oYbQ3wNkWnBuOFJmcFAABwwBg6D98RPIKRutceNycaeMR+pfsCvQ4A\n    OCot5Vuu7dOW5UvZT18D24acwD3pla2Sy9mDucAd1AF+piANtPywlhsSfRIPezdqon+PjBaFYZ3H\n    tXUVeg8AXNwawxI1gyWif/FACwA4IiNkWyvnb2qfPY/Vr6k72vGriZw+ja5NrO3cAQB0MNIRTNWV\n    p5hd/kvj6+HeumWEExgAAEYjoS+ldO4yWCfG7JLcybk59X2lCDmSj07LoK9YtlLpILeaLKzw/6R5\n    G90BYf5T38QcQ9q3gm0wQ2Aco6J/vx994Alqnb9S7VIDHN+pGyM0sKEGRxqimUJoM74AAEANi9E1\n    qtMW9evro3Wg81cTOYb/0ameEeUHAOAw2hHMrXevUR+M4LYtO53c+/kxdS1GT3ry0dQXAADQQo3u\n    yA1OsfvyHb8pB+y7E+Xrr6vFeWvtyzUZMLVkzxxJbhbVXP5ocI7PnAZaCsVlczF8pJgt/XOLH76L\n    pODqXf9XCg0KTGpAEGsnZx+SaaIBODqLCddkXRLfA9CKESmfRxi9XYPA6hmaz4pG5wPFZhY4fgEA\n    2Vj5pl3OzSKLezDSCWwMooHB8cl53sSzKehJTXZAicyCMVx9VGr3dPvY2tGrxZFsGVW31+VvZedE\n    gn82avfn0QcWQEuQJzfrsULyhrGKPdk7tNwYvaj94dekHtCC9uhfbbUUXOwAwR2UUPUnqM8+7iCo\n    taLXZiyBUQAAMIJSSTjCqTZCbrt1DrXpDc1oiPbF9QI+C+MFAMVIecKNCAYfk7Q+zoVbq7jb/gdc\n    hxp9l6OnMZkKAADKCDmBU7wTNlZJWmWZlLBftyzHOMr+Pyrb6YxQwY+ao4BnLFObWQdY1rQzsSf8\n    E8035AxICUQNM3SsA1NDHeGQ47WFwqcGJrdPJzGP0gFSLyQe7mGoAQBIk2ucm2XiyWaW5rOzfVzD\n    MeQ1H24dy1bgWgEAWjJKxoyeVMNFiwx2J22NcALP5Cyd4b4CABwLV+5o0RsteHH+cu2a7+ZuPw0F\n    1cSQel7WFgU8E5JZS1ungb5Mlga6lrMFe/pU1gE+3nBR8w3R4ofU4gffilnTPx+JnIGAHxn8t1On\n    IjUwefH+uoZ4iYf43o6EFMeTpAAAzcwkc3obUX3H75GNEtKMjvgFAIBejJI5sziCtTAyGvioJQgw\n    LgIAWDTJuBrZJGEfvAbe5wa0/N1ZyyMKuC+IAq6jZ9Dl26BjVJo9mS+YlB6AKKEbUcpxqzWXeoyc\n    GSujBGFLwS+hsFqlf26l6EPEnL9cx/LirDcqMljioVfTQBkAMD8zyhTOCLL3cZ1lNjqXM54DOFYA\n    ADnMqH/Pxsho4JmA/gMA9GT25y6rT9zo3pATmPrsoy16F1HA5wBRwIDJsYaJmm+Es0f/nplvlddJ\n    +wDAH+hwHLvuOpKRwQAAAMJIPJxfjc7Ro+0Ton4f50ErLRwuGu9JAIA8i/dXCs3RnprleU/sedAY\n    Ra2xTylwXwEAjgTXARtz8hqzD1qJ7Yeyr3L7IB0MozkK2JhHeUVpZogCbp0GekZmL706svxtRRpo\n    uWHq7PV/Z78BW3Dm6F8pBXWU6F8O/kDIH/xQgyHK+ZtyBONhFQBwFHKMzbUjNinnrzZmNLqekVbO\n    FYwIAADSaHUEg/1YRqP+lxgnSUxkwx0MYtgxWexl1wNgdtxI35rgk7s9c2/rbFWaTnsQUA4t00Dn\n    8LeSfoBz0CuL8n/5++ENmWdI/6w5+hfkoUUwa1BU8yn+54GQ+/49sTXlCG41W2wkcGIDAHoiYcDh\n    PCj3lG3aDL+zRB73Pm/SxsOL9xeAENum//cIdNNbpsfksyb9oqkvxvTVB5xjH1GvuAY4+QAAR8GV\n    0VdDp3bmcOvk6JVEY5BQD0ZFAWtCaxroVqmk4f8rAuYTY+LRv1pznyP983kFfQvF3qoerx0ofc2U\n    NaHI4NUsQx+oWz8g41cNwDmYydimzdGqES3GcOuEpvozm0HaB/cgAICD9CSREfo6JK81TTTS1Bdj\n    9DmBe/cJAABGoUnWSZSXezfhgBZj2tlOW1EbDCSR1fKrWQ4X2HPkNNA/d9jH7Fl4J0wDrUlUHxet\n    TuQYM6R/bolE9O8XU1f/Vypqt9dstdRA6FbQp2vk78Vb1puZDekAgOOzKTPOHhHXAD7aUa7pWkv2\n    BU8qAIAaJGWIFjk7uh/uOR3dlzPQ6xxrroMNAJAj9CuX+v3XtJNru6QcvlZmcie/hqJ8c4NYXCRs\n    uSVtSAcL1dize8INDtOSbRTUM0MUsLI00Om5K5wOj67/O8OFBzy4Avl7Y8zfjfqgeWbSjGk9qFrA\n    Lx9/3ajeWyK692aWp7vDn+W/mvQg7/qxXi6jo48BAPOzEXIsxcUYsw3qb85jb08j8GoWcwmclYvh\n    y/hSme4aFuw+U7RyZN4d/XqQug8wsgcASCKlS+8ybpRW3vfjLvvl+8LRo3udZidCtT8vWiYF5UQB\n    lz57AgDALPSyk13NXetdvGXU3xTu8+RNiW4/Ml8PeI7/Mov5vuKY/jSL+UHonFwmPL//Msb8MroT\n    52HMEPpXRWadXmHnkiH0kumf/6xs64jRv+CZ1lHEtv3adGKpQZ/UcZRKTsySBwDkUCJresuZ1mkg\n    /YlP94f1+KzuS+Aldbz+fkr3fTXp44jBnWE/0+QlLcZ9AMAxaaELRsKJ2izRQRfD02d+NLDUeeHq\n    0v0xPO+/pU7Rcg/E0N9DAAAIEyoN5y/zuZnlMwOhDTYx5iG3/c/udhwk0kBz2iixX7YIGpJIA312\n    ZksDbYzuOsAamCwNdHxIPEP0b0uOfKPGmFEwSSKR/rkWKt1HiSLnpA3pNXihCD04u9HBt7wmd5TO\n    BgQAgBmRMEb2jPr19+Ubol3ZvXz8M4FtOGm+ahzCvmHbLUPA3b8xeQZ36jvL9hlxFT/eGfQenL4A\n    gN6Mf9pLY0vepOS8MXudQMn+2glJsXX9dkvGBjn6OdXX5eM5khpTUNvV6KARk+4AAKAlEqmgS9uw\n    jkZfxxhT9kxzM89O3xynaq9yeq2RKi9YS8tsm9w00Jwgth+6nA1gTF1Q5gzZgHulgWYwv8ml5oLP\n    WHT6dz03zzC4gr0EzemfZ6RmwOQ+4N4cwzu3TX+geDV16WFqwQM7AOBIcGRayokZWnY190lPoWif\n    3seZivrlEut7yijvL/P74RvOezp/od8AADMygyXE1wExPXpNbBtrQ4JW0cA5UMf7auiJ1NwxSepc\n    jTjOXOcKtDQAQCuU3a6UUGTviAmxHLulRDDOTGgItpImJytq62A7SX+RZBZb0B5GHeAZHntAT3IE\n    Um36aB8N6aSPqJBitEo7Uos7QKOcv6GBXQy/XrA7o/BqIA0BAHrIkUfbACNrzCGa+myXhSJwWhmm\n    pY/TcvNerQkZ8933r4Z2GFwC20idoxwWwT4AAEANpbKoRv/GnIyUvrFOTA26MqbzJKKBWxHTgdSz\n    YM74ZoTDG05gAMCM+JG9PiW6jbJZnjl6t0UaaKCfn0Z3IEDL7Lqjo4A5WZGVRAGHRevZ0z9LgpkT\n    SKFQS6v0zzOzek5g9+8tsG4OMEwDAHqjTWr7TkRbX49Ko5iKmKmZeb2SD/VlDldrpE3pBf/7NfCq\n    PQ4pQs6AXIM25zqVGrp7OCwk0tYBAM5LqYwKyURfvsaiebkTdTQ9o3B0I1fnluiWkDOacz1ipMY0\n    /nWy13Y1S7MJVwAAIE1L+XQh/obSOqeeP1wZH6rjW5LimUNNe0dxQkuiIQ30kZkxa+yM2Xk1kFkH\n    WP9w9C3yXcv0zxrr/874Q5YG6Z/7MuuAZY1ECMcM9pfA39R3AADQG0lnoh9RRNXM89eNtVNCKBND\n    yCBsl9dE37oGZ/9VC6fNUSkyLVzHhL02q1nM9mHcdrcbDZy+AABJynXZQ6a7Oi010aZkfyV17Kll\n    lB5qoRND7Za2b/V+rI13cyGX1z7DpcZB7j3gj6deTLx+cel5leo/AADUEMq6lyvz/PXtM18oCCSE\n    a8/U8MxCwcnKiChgWaSzj+ZkR/2xYlugk0mCY2lRg+jfc+ALmtb56GNICOC/ITg/4QwQtNabKBmY\n    hYwaV3Mf9NkZ2Xfn75J9p1yNMe/GPtTvB7ZbYlsYpgEAKVpLiYt5OEitHDNmX0v21dzl2eqsV8Ka\n    ue318wxsThvuQ/22W3bneV1/+ShyI4tTy28B/Zazz1z8yU/uPbGYxzW+RLbpAfQrAOemtwwITRB9\n    lpnLx/u+OsnVmTdCN+7LGmzEtvv1Q9/3Pi4f1wkQ66fl3Vye+pz/NFhHaCKd+yxpl5eeXRt9DAAA\n    rbGyZvE+++9zuTnbfzMXczHrh2zbdjoOzMtXXMdp+NkY8z+jO3EQfjGL+dfY+x5DxNYglH0etNb/\n    xcytOtwHfH+moFSEs28Q0nknAQCOQMrg7RqjOe+lsZNtqBSQbt/d+u6P7Z4jglaGAzS1XDvc6OAt\n    cM5i2zy3m5e6mtMmxxE855UBAJyVkL7Mee/rvRQc2ezrR19Gb8Q+c/ToDOSMAahoMXc9O0n45p3D\n    53byyz7E+mrMfjJ2aFJB7tgt536DJRAAwGUxDxkUc/6WEHr+s/JZkhFRwByb49lsvhrSQEtHAWtC\n    Y/bYVJbdGt/Z6DrAxkwRJFsmqjUcGNI/j0UyTQFX8M6U/vlLw76m4ET/cgYYI9I/Sw/IYgNG2iBA\n    nYc4qdTQS+Q7AADgszy9ixkGS+vcWVazmG8Z0axcR6RvnL4xDNXAJA36KX33cMzz0m2uZslONxa6\n    /16cZZRTGLUSAQC98Y3Y1Fg95KDLhfM8Yt8/6ugu7O1S+wB3qHPkO37Dzt8lOuaJEdOl3LIasfd4\n    zgQAtOAepymbWcBN5RwrkWPRXJKud0bFkjTQLqnn+p5oDb5y+aFh20gDrZNfG18HTrblhjyL8sEd\n    OhwancnG9E3/3FJwSqFJAbmKeeaZYBoGa9zBKhURbJdJp5fzDd7jzxIAYATUb/8SWC8UCRLbjstK\n    LnuWf6HomRwjaLov55OIrY+Z46T3379/3FES+i91n6feL04b57s7AABcONkxjNnrVGNo/dkie4Er\n    W+3nkAyW1KupPp2NkprDqcwb1HePZ8v4Pkuiiil8nek7bXLueQDAsQlF8LaYUEKl7M+RwS0idkeU\n    wpMK0slFuk1JJ3LLKGAgB7La6uY//FX7D/Vae9QByEVS8WiaVRWCMwjImV0mNSjrGf2b20br1DO2\n    riIA4PiEZN3CXFaCb2C87L57TnsYM0ZT25XKSNuPm5d+8QyUGKFb9YN6TzlTtoZ9Xoj3nKcUOIcB\n    OA+p3/m9Rrmtv2t2f/33EqwBOUkt2xI6dRTa+tMLd8xRel+kxkGrd93fiT2tAv2gyCnNcL6rD8B5\n    Cf3uJeQPNQlmE7Cn9a7ZrpnaKOCj8LfQeZBMA60tildbFllj2qaB1oCGbMkR8sW88gNSxew3bw+k\n    BK6UApgdDAgetHYoU87h2nQ1mH0NwHFxIxn95bFlJVGY6+ff520XQzt5TWQbaS5mTA0mDcxqbE/V\n    XLQOjrse8/Wl3P5jBuuLgUEbgKOTcmC1HEvb6ChXL4ccvrMxq26qwX1W6zUmocZb7rmnHB2hMkUc\n    cu5FqXqeAIA5KdEAMQevZp1ypudQqShgW+ZQKuipZRZOqfKRSAM9P2+jO+AxMOvyfnh3hvTPqP8L\n    XL43copHOvp3VAqQEU5kdwA2UxRY6CH+eT0AwJmhovxTBrach+bNMw6mUjRTE1o0P6SfjR5GCYlr\n    HptA4EYLh+67rdGxwXgNADAm7vxyJ0ptJq5z/Qje57bKZWkv/Xs15zJ4l9BLd6SigVfifnOXPa8P\n    AABt2QJj/V6Mfk6VsFFy7Kyc9NRHCvqRctTWIBkFDMbxG65jCphIzoiW+r85glaDYuAyc91eKcY7\n    ceX3XyItN2JwPGNUAACgL5v39/n7Z0N0TLbE5FdPmeTWlgLP9DLQSxpRUtfU14OhyHNqGwAAkIBK\n    X5+apMIxcEvqtJ6OYBCm5xgldb1jkw1ijuFwGnI+0MIAnA//+XKLTDzJQUK3aX1+nE2nzlCyEOhC\n    Y5CkZhRnTc4To1oO5Mye/Z9GdwCQSCnSmnZGzATjzFCbFSkjTMwJvA2YPQkA0AvlLLN/a+vsjkZD\n    P0bPHo8xS9Rvyz7fzMWJynsAHQkAyIVy6t4YmqhERkrKwtHRwJr1ZC96jldKJ+9xWAOOYe41xp0A\n    wDGJTS7ZIt/l0EKOSuinEan/Q/sPMSoTZA6SaaBLg72OWAZSOg20VDZZyfKm2usA/9rhvhqUfVmD\n    OQ6MpGX0by9KUzhrjioepfRHRO5Kp39ucQw9JCWcwQCcBypag5p1Ta0L8tGQ4jrUh15R0aOPP9W3\n    0MQo7iSqVumkAQD64URA5nw/ml7yOqR7RuvM0fvXRKvxwXNUX/g7AMBxmLluPbwXD0algT5qtstY\n    dtKedYDBMdASPOvxEKEa6/++CbfXs/6v1KwF6fq/PQuLxwTlEWfrGHNchXg2YHQAAEgTirwY8dDd\n    W8aNNiSPJGbI7uX4lUq91qK/pfc/MmkAcD6kf+ct5IaUrOzlBI31VYP+POO+KVo7gqFDAQAt0SZT\n    SwgFmuRmReQErMyQaVEynbTm4CwADgJ/KCnhwe4RSq0J5ErXi6SC0VBHITUDjDOAyJ1FFmrzCIM7\n    l5ravwAAkIuE/NBk0D2zATfm+J0l6leb4xcAAGZgJkdwrK9a9WjPffeKOtsS11qiH9C9AIBetJCd\n    IzIWHgUbrKTBfi1FaTZQilFBaq2jgKWDCsG0IImC5YzO2lJBUxtF/JfguZYU+KMZlcbjSEgYCUYb\n    OgAA50TKKKdlZHcx4+Tp6PSRo6N+bR9qgeMXAHA2pGWUFp3M7SvVX806tde+tVxHLf0A5wIjNyDB\n    EexsPY9BaxTwGbNe/qPjvmr9LT816lfPOsBnYEAW5suoHR8aremf/+h4nXsKSC1oVYQ9Bw5HGNQB\n    AMCMaDEKWgPySGPtSFpH77QGTl+gEVsnPecFQA1nvoeugeWa9WsPZtDhAADQihK92EJuXuubEKdF\n    GugZQBpoAGhG1AH+b/z3yBPHSgsYA1DE0dI/j0DjbDSNA8FczmxsAgCUo0VyWDkM5++cSBtpoNMA\n    ADPTQqaXpobWol/OGg2MSGAAAABH4Uh2bMmsoJLZSnPws7P2DN7jYCN2f27QJoVktLExxrxlrn/Q\n    8rX9ho6jT2DsBpIMP7c/CG0h7b4AaZ1nPsQogRpCSwrp0QpYYgbaUWaxAQAAyOP68RptmB3J6P3X\n    9OVq5J8IRp4PPVcCACDJKKdXC3lWMnF1Zj1zlP2vZvkc84wGTmAAAMin1m7Zs3SfxsAbY9plv9Qc\n    BXzGLKfgUOgdNr6N7oBCWuVyl6aXYCxx3n7XqC9a0z8DPeiVtgCAo9PSUDraCKrBCM3pw+jzFOrT\n    EXTTYuD0BeBMjJBbrZzAGnUDFw36d+R+Z752AIDzcoQMPUeQv0cJoBkdzATSSJcXlUJb4KQ0qWzK\n    ncvxHsHsU4fWG07rDxQ8OIqiyx14tJqFVvMQLzEAlDAiHGEwDQDoQ63M4Y7gWhpIR48i/WPrbQzg\n    On5b92u0Ed72QUM/AADnYZTEkZZ1Gg3ZXN01WvaP3n/La8c9rtK04hY8vwIAzkqpDKdsqFqjdUMc\n    xZ4tDdJAx5FMAw26ckl6nFH/l4/WH4KW9M+A5giKt3T2mkaDh+Z+AQCAFs7s/NUS9Vtq+K41Fo9m\n    /lETAEASKxN6yjVpp2NpXeDWzk+uHuvphNUWOd0ymwYmVgEARhCTPCWTRnwZeVTZ1tMJ3DMVNcWX\n    Ru2WZO2ksoO2SCedynb650Hva2P0Bk9yectcf3QZ2wb0eUw64ImLMvsPo4Ze6Z//VpT+WZqe6aRz\n    Bw2zzWrj0jr697wSAWxm2d0b9rP7iq0PgA/37mj1YB1yHvZ6kPcN3r0Nwdzj1Bj1O7vjd+a+AwD6\n    MesoqlRGt3YE5ziBezuCR+2bAjoKAAD6UfOsJaEvJFI4j3biSgUj1bRTUtoRxGldPlQy+PHM/rPO\n    6Bymvo3uQAFao3+lqZnRMiqVQggpRVPjWJZQuKMHDaNrV+iUYgAA8Eytc1+D83ckox2/Gpy/Gozc\n    vTnX0QIApJhVdpTq2tZO4BmigXtORqNoNU7ijh9Hj9MAACCE1ihgTRklgH56Bb0ZozcNtFZ+U3i+\n    FGVVPvcQcaaZBq1ncGimReqGWjBLSZbRtaNczi0VAQBAJ77zd9S+Y7R2SmsxlLj9adWnxZTrY2RR\n    AOB41PyuW6bnPZNcNmaeaOCRzJ4OGjoUAJACciLMUbMm9qQkyKokSyjIYyYfmgQ9shmnyvIK0t7V\n    cYb0z5qjf3vOGEH6Zz20SCNNDWRqoo8x0w4AAHhwR2ujjZ496F3jUUPU76bUydCCGscvAODY1Mqd\n    MzmCWxrnNUcDAwAA0It0FHCNXpfIZDhbGmjKTlyz/6Pa2UdlL/1x9IFnoNkPBkji4lJRqPI0aJ8R\n    MZNAOTqjUzeP3r8E0g/60u3BiA0A6IU243MLtMrUVkbnVWlN8Bb3msS11XiuAADy9CqnkIs2Pbw1\n    1iEancCz17rnoO0+AwAAMIYj2HSNmS/DZiz4raZspiQzZZHt5Ud7G32gjfgPb7X5hsdSOb21O2o1\n    okWQSaCh/i9FbuTuERT+6BrCAAAAaLSMElezqIz8vZi2zl9taOwTAODclDo4zxQN3LI/ejOU6LgG\n    WsZRAACgBY1yseZ5rpdNtkWWR8lj+KZA7/rZQjWWk8wFdYDHcqCsxm1Fb8mJeht0JjRTOnMD6Z/b\n    IKHYjuC4RfpnAAAYTyujKjVCHGPU7u/85dCyT9omRrWu9QsAAKOYvV4rl5tZmumWHCdw3/Oi4xpo\n    dHYAAAAXyDAQo1Ua6KOml54dN5gSaaD18d/w2BeivBbc8G3RPGMHCmk82owrLlzpipSVAABtaHL+\n    9oQb9dtq9NzSQN/ynJSCpxAAgAZayXWN0cAtncA6ZXr/809d81bnJvYcqfN6AACOhDYdl4u2564S\n    cgNzWkYSa6BX0NgMaaCBDpSU18WwUJKzppXWHv17VEdtSNHPpNBnH3DBeQsAaElslNZK/lAZGs7g\n    /OWgPer3aubIsIF6vwAAjcxgGZGQ8RqigftybCdwaH8AAAD4vFRsO7td05jxWSpnqwPckzOkgdZc\n    B7h1Guhf+hx7eBha66HWnP75DI5aaQFxpBksoxXLtwM4bmuoGVgBAADoa+iD8/eOdsOtlONXY8Sa\n    Cxy/AAAKSdmgPS209ok+OqOBF6Mxq0iP/UFrAgBaovm54Wj912ozPmrQ1ey45UR/b3SfIyvuNOgb\n    ms9Ejxu9tP4vaAsUXD0zDbQAAAD0YdTINKSTdBqy9/2TcAZod/waA+cvAICHZlkhJWtnyPgQ0p3a\n    dc3MaL73AQDARbsOm4nR0bvacLOHtiwr2SsbqjbOEFR5QDSbtMDZcQV1rzz+YB7OMoseAHA+QtLt\n    6Ia9EaPSmDFe+yhZqn/ajfFHv+8BAOdDyhE8g56i+jhq0pH28yUBdCYA4ExI6pKzZCv8Elj+reJc\n    fine8sHobJ2SHCmL6gj+Vbjdb4zz/lbQbus00B1oMwTWnP65FUeeARETXNwZL38d6PzUKLbQzKzc\n    Nmed4WUHVLPXyJAYZOLhHACgjVGG0VGRTLNG/do+StBLF5X0V7tjGgCgm7OMtWfWWaOcwKMmAI+c\n    eHyOXwMAYCYkdJdEG3jmANrRXAdYKjvukf1qtWV2BaBFpYKOqadl+udWudnBsWYUnZ3SB2h3cIfo\n    XwDADPQ0Yvd+ANZmoJ/BiK69jz66rjAA4GysZsnWNbPJ2Rn6rMkJbIyuiWcAADASro7UrmckOEsU\n    8NHplQZaOygrCj6YS3xzQrlTHHlGgUXzzJASkP75GBzF2Rp7cMedCgAoRYP8OIvzN5R6UvOoGI5f\n    AACop0TvzCR7teuKWEroEWibhIZjAwDMysgJLhL7bpmlsIdTOTdL5BehdlwWgXM4W9BWLCvqkdNA\n    z+5beyvYpmUa6F/an0/5xwOkf5ZDw0yNUQJL6wyd7yq2nSltc8sBisTACrOnAQBnoJfxbhtQi2+U\n    HA85frUbzGcjt8/Q6wAAzcwmh7X398xO4FH1j8F5wWQAAAAA4Bz8l9b52h8NAJBDYiZRi9lINTWF\n    AQAAzM3okdiI/Wty/vbcd+7+r0bu+mg1NsMoCQAYgVaZKNm/0slNs+nKWfe7maXLGAx6FgAgSUxu\n    lchRCTl4lGyDR6AmaKoluUFmf0F3ZtGyTOpRGFxud7TZcU5wY9/5R30TUzGDo/Z1dAcSSKVVkRjg\n    zWYQAQCch37GunNEvcRSPvcYCZccs5Qho9c5LzmXMEoDAEazKa4PLCW7S/RJD90R0xtnmig2chwC\n    ayAA4CggDXQ+IRv3t4M8o81YTvLHyHel5T5tdtnfJzwfLXkr2KZlGujGPA/5ajzSZ0z/DOT5wXk/\n    o8CeHY0DExc4YQEAoJ7eRj9txtxeM8VHR1JpRGu/AADnZc10BPfUIUeXmXACwxELANDB0fUNmAOb\n    eVNrNHEOqAPcn9+U9mswGGpqw87IKK3/WzojhEJKUGlInTC6kPxRZlABAAA4Bj0f8LUZceH8lQER\n    vwCAIwID+INeDuiQXtY2fmi1r9H3HO54AIAUo+SZ1PNdyyhgiX1rz/pozBzZMyU5W3ZUoI//pFeZ\n    xwFc48H/V8N+aZ3x0JqzCbizKbAWSAyk1k61kgAA4IhY+dnTEXcG4y2179HG3JaUpHs+8vkA/VgY\n    LwCk4OrKXuUERgIn8PH2BwAA2qiVg9rlqPZsixKMDr6K8UN9E0UcOQrYZcZyqW8F20yaBnrso8rb\n    6MMH6hglkM/C+5yCSjVHN/gAAI7BCFmlqd7vkY+5J3D8AgDORI4Mm+2ZIDdaarRuHTWm6E2r+4gz\n    oQEaGwAAwJE4WlnJ2jrA4Bz89/k+kRteTuoBz2bGGQ2WHzPW1TBDRUJQS9YMOEMa56PPSIMhGgCg\n    mSPJqLMYamv2fzVt0lGPPg8AAABkaeUAnckJPGr/R3ICAwDAkbmY8XpKAxKBP6Pt35ojiSlmyZL6\n    u/B5PWtW3FL+PW7XGFrW0OpGx8wMWWZTHBQcBT5DLYgabkj/DAAARfSWnZoNtK3q/2owNrRwEJSk\n    NkWtXwDAEcmNBm6he+EEHlPjfvQxAwCABNKSDPY5eY6StVEyGEuSnKyjfwleCw1BdoDmbXQH+jBO\n    XL+NPnSFSM/EaEWrmS1a0z9rVVy5HGUgoQmuBIUxHAAwAl9G9ZBFvpG0R23E2Zy/LSJ/WxinS9I9\n    w0gOADgyuXKuhQ48shOY2w84gQEAAMzI0bMuGjM+ehgcg39VbPtb43twwizI+2HtwFBkoAjJmSmS\n    M2ZAW44eQQwAAGdmxESUHtMMRzp/SxyerZzQklwNav0CAECMXJk3ixM4R0eNTks9wgncg42YSNd6\n    HwAAMBJXztXK9ou5Zw88OwgAAr1AGmideHWAZYaTE3q+Achi5AymWRW39My2WqO5O5BEqhoAgBZa\n    GeEkH6S1MvK4SvY9g/MXAAA0cgQtNsvzh4YJQGd3AvvHdYT7HwAwF5goMo6UA/sswTutyjm2yj4q\n    lS31x0b968HPoztQyNvoDrRnzGPI2+jDFgAzHGRpJYCPUP+XQ2oAMPsMuNn7DwAAPdFgZG7t7MyJ\n    /J0h3TIAAAAwKy2igTU5gY86gQvjGQCARrTZ/3KDW7T1fxQS5RS/H30QgoyuA/zTxyQi65IAAIAA\n    SURBVN9Zyo8CUTSYCNPU5O6uyRneE/sD/KmynVpGCyRwDLTVtdD+cKu7dwAAkIcWQ2mrtM+j0dAH\n    Fy0RAjp6AQAAY9CgG+AEBgAAMBrI6zsjs0keJRgLZS37coZgy1bld/8T/3oOBzCoRyqFgFRKgx5I\n    zBT6zsgrri8Z62pJ/zyyHzezYAAHAAAM/FFdb8fcxeh54G4R9TvauC7dBzwFAABmZfH+zsoMtYFH\n    90HLuEJbXyTRMpELAHBejqgPa0hFEWsLumnF35OlgdZOq6DDMzhufWYoh+vUAYbpp4RWN/bo6F9p\n    Rs+UaaUocmldPzil+LU4kY8EJCcAQBsjnb+rWVTJRY0pn2vPjzYjhgZj8fgeAAB6E5I9mnRQLhqN\n    3tp0libHa+97zb/nZ77XAQB6aC1LRj8rSOuNszhcATgrb6M70JZ6kZ/r8X4bfchAHWedeXNUtA+0\n    cvvX2ugOAzYA52L0w7A0cP7GuRh9hnRj6s7TSGe0pnsNADCOkC4dJZ1qdbvGrBUSuktSX1yNHkfw\n    xeibmAUAAGAPavGO5ShpoHNIZU3VUnbzDHWAa8rJHhD9ZpQzXDCpH94fle1oEUSaOKPC0gQGbAAA\n    EGfkSE6b81dbFJU247kx9QZ0bQbvo02oAADwif3+R+imWvmosW69Jh2vrU9HdAJDpwIAfCAXytCS\n    iTGnHznlCnsy2i4/wlciVcaT4mjZZwELLcPnPmjOSY4foCyjFUSI14x1ZxwwgAdHMwgAAOpo8fBM\n    jeJ6yR44f9sivX+JSOQRQJMCAGakVOdfjT59pnEykxZ9NtoJDB0JAAD96J2FImWLPUta6u8rtw+V\n    h0Q2Ulla+Nz+NfqgDsBHHWAtQ+d50OxEDtFy5kgI7gwZCNw6tCl8LWm5AABAE71mTvfaz2jnqIu0\n    Y1MqbWZNnzTNtN/Moqo/AACQw0hrR43slO53rSyX6A+cwPX00snQ+wAACXJlo7RcfzHIKjiabzj/\n    YCC5WYXfMtvPLYs7EC3DZpozpH8GbaidIdSCnOhfKWaO3m0xUMuVeHj4BQBoZHTaZy1oi5KS6JMm\n    vaPpWgMAQA2jpJk2OQoncDu0XWsAAAA60RbI4+LarTXZk7Vm+SxBQ/nNn8w56gCDT+qGzLme7rfO\n    R4dQcVCDhILRpDABAAAcE01Ow15oMvpK9ElbpO0IQzZ3j5rOEwBgPFYmcOTWqNrAmpyDo53A0mjq\n    U89IYM3nAQAAjkqO87ZH9DGnP7BLh+FmJf3rYHWAwenAMHE0v5tFRf1fyRkoEoLx74o2jjAziKOg\n    e8waQ7qUduDMAgBmQpMBW+PotaZPWs7rqL5ovJ4AgDnBBBEetU5gbXJbU3966VFNYwcAANDMzPJy\n    hPP2y+iDJtCY5RM8M2PZ1CPxn8Dy/5pF01AZnI0z1f8doUB7O28l6//OPEADAIBe9DR0a6nxrqUf\n    LjWj6da6OsdQD90LADgTIyRezmSq1paaWv2jzZKkqT8j9Sk0OQBgBJpkMNDFEYK0wLy0rgM8CXpF\n    tMb6vzPOZDhjygCJmUFnU1Caa1BoQ6PzAQBwfEaO2LSMFlvK31JjrXbnL/fYNad8BgCAXLRHAuc4\n    gVvq4Fo9VKKXW+obLc9pPfuByVsAgKMzs5zrEZjzWt8EmIg/hO4prXWAfd8byruK0M+k9zb6UJWi\n    If0zmI8eCr52oDIyffTMA0QAANBEb+dvyGiv0flb0ydNzt8RcPun3YkDANANR8aNkjJanlduZqnS\n    SXAC04ycPKfjzgIAzIKWyb4tkXz26q1nRthWbRbLb5X7lsyG2SpQa0QdYMkynAAwOK6Yn2GGgMaZ\n    FrVwBWKr9M+aIndrFWUNvetEaI8g1mIIAACAWno6xHobp2dx/l4r+lRraOfAGd2PivqF4xcAoJne\n    1hGuLO7Rr6M5gak+bWbprF+gywAAesD4GoxCwlZ/xjrAZ8zq2oKWWYZ/nUOuHtcB7CORvvnn0QcR\n    QSoFAJBnRP1fUIeWGfkAADCKzSxdR4kj5G6p83d2Ruk4zl63QY5pAMDx0Wz41uIErkGbE1gPZzhG\n    AABoy8z6YmR2RHDnb1wDoJxf2t6jOh8jNNb/nZEzzhSRmBE0MnIX1DPzwBAAADSwwvlLAudvWzQ7\n    ZwAAx0GrrBmVmUGSWZzAvfc5+3UFAAAOks9KOr0V40hleUQd4D5IpoHWQIs6wBIBmKN5G92BCv5D\n    L4ZIHYmW+r/c3PP/SHwvJQi1zMz5bnQHAqQUu0T65yPNUJOUcpCYAIBR9DJYr2bp6uicxfCr2fmr\n    vd5vCq3OGAAAGIFWWc0FTuBnroOOEQAAQD0t7KPay+gZ87A9nyFIqlWZSiDDDGVelVPuzsjJcf02\n    +jAVcsT6v+CBVZAzzMKaYeDRk9qHcxiyAQCS9JQoZ4iIyd1nTb3fHmjuWwroSwDASGaXQRcjrwOk\n    jNwlunOGMUENPZ3As9/bAIDjISH/MJEGnLEOMJDh5NmG9cWzSVyQFjMDjhDCfnSgCPRwpAhiAAAA\n    8sxg6NXuXNXevxgw4AAAtDC7s0yzLoATeCz6rH0AAMBHs37LRcJGOnsa6KNEEvdOA02V9+RmcuWg\n    JTstaAqGhKA/qVTSI9GukJD+Oa/vRxowAgDOyeyGaYoZDLya9Qc3skqLUdt92tDSJzAXm1nYsjBn\n    XQBizHQXaddZOcwwRgAAAEAT8zJA1o5DwlY8O1rKTYI0CMKsg6gDDAfwKCRnWFAzP34saKeGoxVC\n    HwkU8zgwIAWSwAANajjqCG0Gw+4RDOla9NlR72MAwDHxZacGGcaV50fQXbnHLIkWvYljAgBoZYR9\n    Q4MebsUM5fi+fPytCZb6TrhPyP4pj2SZ0p8b9RF1gKs4sih9gJkD81A6I0eTApjJgTvDgAMAAM5I\n    L6NdT+PgDAZdzQb0WUftiMgEAMzEapad7phJ9l4U9xdO4PH7AwCA2RmVsbBHCmcJtKeBBmAkOWVn\n    30Z3VhZdjwda6/8CUMKX+ia6M3MKaY0z9gEAQDManL8tZfVRnL+aDfpH6C8AAKSYTaZp7S+3hIHl\n    DE7gHmi9HwAA5wOTQuuYKeBoNnLKVcayoLYoe9k7yys4HBgKjkAytB60QTpFhQRHn8ml1fAOAAA9\n    6TUy2w4+aeZIzt+ZcPsLAw8A4AhYfTLb5BbNfdXiBB5xjvx9HtHhDAAAkmh9TpPgbFkZv0LnifEn\n    zuXh+KXdNW0/5H1rvgcwmqPU/51dEWEmGAAAgBI0G4lLOLvzV4MxWUMfAABAitEyrXT/R9Hvo8+/\n    NP64AxOmAACAzyid4GY7PJPjVmN2S01lII/AT6M7wARZf/n8Z//xKI8Ed2a5ESR/WNSMD82pAVqk\n    QtAYrTsDRxqw+ANArcZ8AACI0WNUdjQjau3xSeoLyXNbci/4dSt74Uf9Hv0eAwCck82rC9zbklIq\n    46X7KSXjZ6gJfDRwBgEAYKy9EHWA66gN3PobmvD0SJSfnZDH48C/R3cFADCUkfV/z+KwPdaUGwDA\n    ETizXDqa83cEZ75/AADnQ0P5BA1OYCnO7ASmrsmRjg/oAncW6I1WvXMESm23I7NGInBLP9rKlf6v\n    sv5Mjh6RrN0D//PoDoAks6dwjqF5BteRIokp9EhJAAA4FiPlq+S+Rzt/RzBLPwEA4IiMdgJL6r2z\n    TASmGKVLj2s1AQD0YMRklSPriqPbVH2OYrvvXQ5Tc7ZXoJ7jm2+0zRjQNqOCSyh1s6TAG5mKQYsC\n    6jWTS+MAozR62GfEwLB2AIy6TwCcmzNKADh/Zfo1Iu3zkQ0wAABQwsX0l41HcgIfZUwwE2c97jNz\n    xucNoJdaHaKhDjAYC6KK6bKgR2eW8q/KwLDvaJxtRkgLga+xwP0MjBqAzTpwBACAs3KU0edo4/fo\n    er8AAAD2jKgLXNJHqX5KTkKCE7gPmHh8TnDdAZezyMORE1p7OJE1Z5HUzD/qmwATwM1C/Da6o5X8\n    5/H2OKL9jDMAzjjTAwAAADgKvbW4NdK2Gv2daULN6PSXI6J+Z3pq2Lbz3IsAAF3M4AQ+Yh9q4Vy3\n    IxwnAAAYUz8pgCMPpfXhkbMQaczSCNoCnw7oiA5Tjvb6v0AGzKTRy8g0JpKDuCMPCAEAx6XHrPzW\n    zl8uo/cvAQzAD7YBKagBAEADmiLqNMhhDX2Y+Tjt+Kj3eTzHVQMAaGR2vQGnbTlSZRhLsoJKlp8M\n    lcWc0f/xk5m3bOmR+KXNNTiCGW4efjeL+Wl0Jzy0zDgZWf9XO9KpOzBIeZAacGImOACgBaOkxuhR\n    3+j9SwCZ/0DjudDkkAEAHB+NcnAks5+P0eOU0fsHxwZjJADu1AbAzKzr3gf2HeUW65ml7OfPjds/\n    YxbgSjDEBOX8NVjpSdX/lZp5dEasM3nkIAIAAIB+JDM01Dx0l458JesczsBsTwgwagJwHrT93iUm\n    lB6J2XXl6Otl99/6Pvev09xXDQAAAABH438xOpGi7fD2rdNRwPPflhlTF5SCGUljGJmCGgAAjsym\n    JPWzFDX6osb5eyZmu1e0OYMAAMDnYs5VqqZUb9bon7PpagBKwJgJ9Ga254peUM+0yNbIA0Fce7Rk\n    dgU6+c/9D0TxrOAHfjy+DbqmiN6l6SEd8QAGwLnw5cqRZEDM8Cpl9Ibzty1Xk75Wmu5Zqi96egcA\n    6IEmmWRMWmfACZym5hlMalLxma4TOBe6JCYA8z5rzWBHlS4n6KLJCTu6DvDROEsd4N9OcpwfjHcA\n    tzzhZwsVnyUXvI+E4NWkfCSRVtgtBgCzRu/OOtAEAAAuq1m6SDrtzt8Wx3U0Uk8EZ0uBDQDQyQxS\n    CE7gB0d1AvfQh4vpM8FhQypoAAAoBlG75RzVjg/6MHM24H/33+V4B/AMSBSvPssMil58P7oDDlTk\n    LlJJAwAAGE2PUV4P5y9oyxGeBjDKBgDMxBHk7hkY7QS+dNoPOBe4o4BLrYyZVUZp6PeswTRgz1+B\n    63imcpo+ZwvInID5Hz1m9vgDMDNSM900DLxa9nvOowMASOLLAW0pK0uZQX5fTNlod+Sx9dz37E8C\n    s/cfAFDO7L//nv0frdNK9q/l+mpwAgMAAHhmhmfRXHpkgRxVftCYsnTNIA3KhI7lV+Hz/4v89cRw\n    EgAN9FDAlOLHjDMAADgeGhzMGkaYpY7f0YZyLWjqi4/engEAgE5Gy/SZncCj+zEiFTQAAPRitH4q\n    ZaQ9VUMN4pGOZAlmrQM8a/lPMJTRQ1lQApVOupUACKUs+GtSQTkTLer1SgMHMgAA6KKXAS/2oC49\n    ujyLrtFk/NDUlxn6BQAYy2oWtZYNTXJrdF96OYF7jht6ndPR1w4AcD64UgfyCfTGrx+sqUzkEdBU\n    xrRlOunfGG2/jT4BAvwHDmAwmpIZN60Ee0kqitlnPAEAAAC5zPCQj7TPx+iLi85eAQC0odHCMTq7\n    hN+XMyDtBI7dV0gFDWZiM8tJpAAAfbjWN7FDqtwe0M+RUzf/3GEfKAvL5j6M/PfobhSCCw2MeZ75\n    czY0pP6YjbMYPgAA56O1dEvJT2kD5cwpI1seYymlNZFHM2OfAQAgh7PUBC6h9Nz0PM7ZzikAAJwd\n    iakQtZONRmW6QjATAKei3WPGG2MdTqh1KZIh4rVtaQqdB/rooXipGWQ1Aw2pGWlnSesJAACt2RSn\n    v6w5plxmOwc9a+5Jz07vxaYocg4AMA8zSo2eOmy2mq+z6fcWzHXFgHZwP4HezPosMjsS5QW/CPan\n    JPtmK1rXAf5HfRMk/ySWwfcEImAYfWaOnGoAtEfCeasttQkkIgAAzAuMCmFmOzezRioDAPRgHZyz\n    yZKr6Sezz+AE7nmMvVJBY1IUqGW23z5oD+QKmJ2RdYD/wu8HCPOL7D012+NQf3rkLM+BmtHxz4J2\n    NNB6pk0OmmYgGSMzQwvoBA9bAABJjvqwnisra43lvc/jZhbogwD26QTnBwAgAWRJnN7np1bfluj7\n    o90DsOIBAI7GUZ9pS9EWLBMCqaQBmAIMHUGYVqkKAAAAACDH0UZzZ3D+akCjoeVo9zIAQAebSKU/\n    eVYlKe7hBAbgfGiVi+DYaBvrn7ks3ezO26+N+g9fiD5ipVn/Nbpzc6BN9PLBBT4nI1M6+ISUZU70\n    7nsHhas1mljbQGteaQgAOCtrp7q/PY3TufuC83eO404BHQwA6MGq1OGhQSafwQl8JC5Gz5gCAHBs\n    ME6PczPLkIjdHvZkoJdZs8GCIZSJ8V+VC5n/Vd4/IEftjJ9WM4aOzlkHGlxDBQbIAIDW9DIWh/bT\n    Qs5pMIDXMIsxevbzDAAAtWgcq59RNvd2Amue0AbAKHCngjMzy/NbLdoCgzSVYdRUnlITv1eel1l8\n    c79N0s9KND76gBxmnfGhScBqUjy5jHDEaqpFAQkGAADt6On8zeVqdEX/ajYe2L5pSTXqYu8lbf0C\n    ABwbrZGTM8hCbfpOgxM4NC7qcT0RCQxqwL0DgF60OW1BGamU0n8KyuFapy04LBpMeIALfsgAAAAA\n    2Dqkfu5thJ7B6B1CmzF8lr4ZM/d1BwDMj0YJZOWiZvkt2TcJPaDZCQwHGwAA7NGm37SVp+uJRB3g\n    2WsJAzCCfzPW+UXutwUH8FlJzTBB0fNjoCla12U1i6pBHyQhAADwaCG7RzgBj+54vJi9btN2vNC7\n    AAANaHfO+bJcE9qcwJppfXyIAga14O4BKbj3yNHleYj3QXWAe/JldAcYfD+6A2DHz4JtxVJK/2v0\n    gepH6+OEHmbJWQ7mY8ZZUkcf0MTgPlRDqgIAZif04A7n7zM552TU7HJthpjFLDBUAwBUsSiTSaNS\n    9ufKZsnnniNkHhk9wVmbvgdzgDEZAGAEEuUYv55cfs1aFhR0Z5yroqbIcsyzD4etTiQiimeYyTPD\n    jKhaRtQdPgJ4IAcA1AIDTT2SsjhnFD1KB0D3AAAAF73ysqfVJtf5PPPk155OYOhjoB3coQDMB+yz\n    MvyN82iMMean0R0ArZh5uA5mnenxl5BglZjpUzrjaMboXQAAAPMzauTWYr8zG0O1On81pwvVFmEH\n    AAAUmmSoqz809avH8c7MyGuFyYIAAJCP1jrAR8/CeJYI3p5lNn8/yTkFWZzhMQKAYzLrTC+tAysA\n    ANDOKOkJ5+8ezc5fAAAAx6V3JLDGfo08Tu3MfB3AWDBxAJwZyfT9JQ7b0bZdBDiN509cAxDgF5l7\n    42L+PfpIADghPRSs9EwxyfZqBlhHekgHAAAOI+UejIl7tJ4Prf0yBnobADAnWh0icAKPPU4uofPR\n    +r7SedeCWcD9A4ypl1MY+wMAWoCyr8XMPExvz8+jO+AgGcKfmlnSMzXBSM6SaoJi9Ayz2cAAFgBw\n    dLQauiVnZNeSO2qG7tB7XwEAAAetMgxOYJACYxAAAOjLGbIdfhFur7QsYwukylWCMfxrdAd0c6wh\n    OmYCgBw0KRoAAAAgROvRmlYjoaZRKqcvN+e91nMKAAAgD61OYK1o0t2aJpG5YIwANAJZB2anVrae\n    wYHbipFppM8c3GWMMf8c3YEIs/jpfpuknxVoGp7zgEd/PJgVQyM9E+qIYEAFAAC6mNUIeatvgg2c\n    v/n4RsT5njgAAODB2R0jrl67mbQO7i3zY/3Rqn8wVgBawZ0JQB3S5fhSSGR4PFId4O9HdwAAfWgd\n    DoMUmmd4xDiC8/hIijGX0Q5cPCgDAM7EjDJvFWrHHaFShvfVLF2cwKGR8vrx8g3hsWvWw4Ew4z0D\n    AADaOIOVJKQvuMtv5qELKd3f6xzeAn32de6a+DwCDX0AwOXsk13AeenttD1K345Ki9KYZym3eVZ+\n    1a0/z/BoU84soepgLiQcyL1r+GLAUQ4eogAAZ8I1Ztr3q1miRs7n79KGXLsdFYmU2l/e8dAv3nGk\n    +yNp/B1tSF6JqF9oQADAzGiTYVw5X6sPSnQWV1dK9cfqf47zN9fqNVqfSoJnUVAC7howC1pT/QM+\n    KM94509Byfu7Iin+8+gOKObfzPV+qb+ecAD35KfRHWCgdUaKn8Lhb0XCTJrX0R1ozFGdyZCmAABw\n    p8Toa42tF++zS8gJ7DqCfQe0pDOY03+qbznbcNajPucco6RR3gIDMwDgLIyWd+7kKom2cicv9XKO\n    +jrc/nX1fc5Y4eJ9ju2XWqdUd2pwJo++ZwEAYBZGZz08I2ev4QvyQLBmEcdxWeAG4CE5o4SLRqcy\n    Zhj1R/rh9zjSCwAAxuM7YI1JGwypaF/73hpK350Wcx2i1PpbxCCdapuKUG1xHjkGdUnnL3dbzjYA\n    AADStJCjtZNzaiYHcfVWrwlVJTp0NQuZ9rlGb9oxzGriY55UOwDMBCYMgJG0ymDRC+tAzg186Z3l\n    sYYvozsAQIB/je6AXuBCCYEQdQDACOYZ9gEAZiFVBy/Gmtgm7gQORdHURcVeI9vmjmxLR8IXE49W\n    roVjtM6JAnusy9t3DXi6AACAfEocjBz9mqfzF1Y6TXfSWI3Mz90+ti4vDWjeJDRj6OwioW00AV0M\n    AKglNBkA8uWYSJQrnJ2/Jj0H/xzdAaAdiO3W/DGp8Dg60ikmjjwDys5cG50KRXomYA/pp9koAAA4\n    HjFnrf8d10jsRvPmRJSWyD9qpnRIVvvL3f2VOIFzX7nHGTNMc44xx/nrO49d52+ov1LRHniyAAAc\n    lRz5tpfB1LKQPg21EXcC2/dXI/PMk+MEtvuo0aUpUpOuuGMFY3hRWe4+bl4mE+o9te1qwumoqbao\n    CGaXzfAncgFQy2YWWDLA6ThquToAwOnJfxz4FcOA7mgq3g3q0JDWQ0MfjgYM3gCAFuTKltJJJzWp\n    DGN99L+7Rr7PacdfHjIG10YmpeBGK5c4f7n797ePOcZzorhTBmbq+wXGaQDAwQlNzInJvdwIXLet\n    pUI/5xwLRUp/1e6f20eqn5xJX5fIstj448poh/rO3457vZ6ztNRnSgEAAHAuZrfz1pZp/HuS49dY\n    IrM1KNmqgrncFsjlfeen0R0AoBBeai4AAAA5xIyMWyQKyX4XM2BaOOvE+hPCN+6GjL0xA2+qPz2c\n    we65cV/c4+Z857YnZQDmpLX0o5X8dJi2z5bRteNG7x8AMB+5eiu0fViO7pdRkbqcvlCTfvz1r4zt\n    3OVcR3Cs/IIkXJ29BMo+5IwjUs5f/xi544hL4n1OFpbQdyG2z23teQKgHNw/4IyMzn4IAIgDp3I2\n    czmAwdxI5dKvndlTO7NoNDPO7MIACgAA6qFTCdq/YTlbKoFrDZ3UZ9+IHDIqc426m2NM50wy4jhn\n    Ofj1D7kO5lLHL+X85Zzr2Pc5x+mymXRUMfUdIoNBKYvhy7GcdcFctJjckRudG+vTjVhvcRx43Lrx\n    JWUMuE7glP7hOINryiHE2s3V4znnjlr+SrQbP1/hiU8tJjlvifvNmLrzvnl/AfDBhDoQY3SWJRet\n    gSba+vVa3wRozJ8Hlbs/j+4AOIYDGJ5/Gc6YigCcg5qHY6TZAgDUsgWX56dz9KNBtohBkqLmQTRm\n    7HQN25yo3mviM+dYRhmmSvVCSZprKqUkdT5znb+5huvcaCXLllhfEhgqAQAptoyIytg61ESYGhkU\n    0w9px2TYCZzrCK5hxDMT55zHMmr4f0PbpD6HvuNEGHPLYYS+d6/9ljEpK3Xu4BgGAMxKjT7S5rQF\n    44CPBGjil7px9jEcwNL8bI7pVD7qTBLQjpfRHQAAgAOwbfWTUKgWakdxvtHxSiyPGUWfH5CPP87o\n    YeDOrRlc4/yNtRWLsFrN8hkJVlqrMJTaEpHCAIBSNoaTK+XYcrfx1113VXnv5BiLuZNvch2H9nNI\n    5h7ZoN1z8o8byW0JOXCvzPVanhPO7yHYRsXYFQAAwJxwM05+Ed7v1xPYEXrzO84peAAHMABAP5y0\n    ZgAAMCOUsXYx+QbNlGPQNQxTRsiL4RsxNTAi2nN0RoiS/edEMXEdw5QBnNv3R/TdM1tiHUQjAQAs\n    OTpgffrsy5pwql1uumZfLpY4emN6ONUOdXymcPsaRutJrbjX8iWw/BpYnmovh+3jPq1xDINzgXsD\n    gHmYsVygJLXlImuRKnsJ9PHWsO1/9zkEOIBBWzSmTBg1s+jsylijA0ETkMYAnIsa41uONrkw3oM0\n    vYzaIV3ZYv9cR0PIQeEuXyJtlRKqdQhjJADAsk/FvGcl1slpz5jcSTK8GrE5WRlmRGsqaG3HF763\n    FsY6z8uoXuXq5g16FgAAjDHG3CAHu/Pd6A58cHZH7k+jO1DJv0Z3QCdHe9w4HgjZ3zN6Rg/Fa8e2\n    zu5EPgt46AbguHBHXtR6qTTQMUPhkaJyjnQsLj2dvzFiUWxUFDlnW07qavdYXWdv6uihMwE4J89Z\n    AvgTq7gyibO9xowZo1NBH1VP96R0Al/KEZy7DAAARsj0o+gRlNUDPq0C5WZ33OZyxNKtDYEDGJyL\n    70d34IRg5hwAAMRJSUlOeucYR3KQHdUAocX5W0JOqsqSe92Y56ik0D2NNNEAHJ+VkAc1Vo0cGcZ5\n    DydwfP9H2V9LOOM26v5LbXWcMwQAAHFghwSz8udB792fR3egA7/qvXZwAAMAaI4yU+1IxgAAwLFI\n    RfSagu9nItcIfVTnb+ia6tJfZcZoiXVzenWkyQ4AgDokU+bmyykdsmi0E1jL8cY46rmwpDLKIBIY\n    gPPR6zfe81lGUpYfxRbam2/QHofjD6Frimjd4cxjRuyVw/sMMxIAmAnM3AMAHI0Sx692ch/wZzhe\n    OH8t5X3pER0MADgPnEketZOrpKSvFpkV0ic9+nfUiVszQkUJS03GAgAAoAOJsoEzO3Kly0a2StcM\n    QAm/lN/f8w/zMIuARyqFAFeonb0YOhhPz1naIwwIiF4C4Lho+3XPNAqEQXcU8uc9xzmzEN9fDHQl\n    AOBOiR7r5fRaK1NTS/cldS7OTO55ONqYBPcBAKAUyI/z8irc3teD6VYN/I5zCu5AVAOQw8iZUBIz\n    uUaBFCoAAABmAtG/xoyesoBahgCAENTvPzUxZITlQ5MTeBR6dJpOzn5/AABAiNH644jZCKWdtgCA\n    KcgbbiouZixKi6jin0Yf1AHAbCCQS8sBIx7WAQDaiclAyLAwI40Now0dlpnuDx1nDADQg5KJIRpk\n    hAaZerZU0AAAAOagVZa/IzpwAQCgAA2PIiDE7KH6GnPlw4k8FzAWAACAPD1T6c9GL71DjcCh8+Kk\n    ovtw9gA4NlzLBVLEh4ETWCex89/qfoYlEABwNPCMC4Bufh7dAaX8u/0uMOwDoAec1NFfRneyAVpn\n    3GFgCAA4OjC06kX36Hvu+2bu3gMAOOiWofpBPWCdjDr/mDABAAAA6OJP6GYWLTL4HhQM810wEwHk\n    gvoJAAAAZmLGkV8vZzbq/mroAwAAxJlbUuno/Sgn8JH0OQAAAABACRozpoJDM6MZEABwVmaJ3IXR\n    AQBwdCDn8oHzFwAA+qBDrobQ3DcAAAAgj5hnoVYfj9LnL0P2ekdrJsVZQOlHAJ4Y4wD+DT/GriB1\n    AAAAAABmnPan24h/FHCOAQDzwZFcetPbau3XnGMFCowfeOAsAQCODJypczG78/avyft/FP41ugP6\n    aDO8f+vUe+25vv9Q3r+ZmF0JjGbkoGdU1C4e+gEAZ6SHsRspHI/DMvE5PoqTAgBwVuaVv7Mw43hl\n    lG7DmAsAAJ6BAxkgXbMM2n14s/BL2XmE6QQAoJPRAy08BAMAjgRGfGAm9EbtAQC0MbO0mHkSDtiD\n    Z0cAAAAz8MpY5xtTp3HaGsH3ozsATsuvOseDMAcCPrOnMkAUMdAG7kgAgCRHiv4F7ZnV8TBnrwEA\n    rUlZNqC/wCyE7lTcwwAAEGdUBkIAjsRPozsApIEDGLThDCkStM50AgAAoJNtkMttxtFebyPn2Yyq\n    Wo8Xkb8AgLMx62ScUo6s33vsC3oSAHBE4Lg9BtzIYdCP35Vdk59Hd+CczGESRPHmtvw4ugMAzmQG\n    c0grAAA4LlqdhjiufGY0spzvKgEAzsLZ9NCRncCzAwczAICiRjbMKoNnfF4Cx+HPSX83oIx/t20e\n    LhWLnYGAotQAAAAAAHuOFkHTG00jbk19scSMShr7CwDQTUxuaHRwaTMy95C7s+j63HMxy3EBAMBZ\n    uE0ol2fssyZQAhKAHfzhrNIixodFW4g+ACWUGjMw2AEAAD4ajY2zOO16nLtZzsUoNDpjAADzM5tk\n    ga5oi8axEgAAjAa6px8vozsAADgrEPU9GFk8W0vKgL8q+vG3kmOYdQbR+6T9BgAAoAMYTcvRNtLW\n    1p8Vkb8AgEFonHyiSe4hCviBxijgWc4dAAD0RpMuBfnMansHY0AmXxYQiwCAcwGpBwAYwZmGpSPl\n    7Jq17pmuCvQfAOCczCb7NPVXU1+MydPxAAAAAGjP6+gOdOCHjHW5AXA/jj4ocCa0DekBeOb70R0A\n    w4GkAgCAZ3rUTdXgJKX6EOpXqr83s3y+pNjM8vly8a/ByHOp4Tpy+6OrpwCAI3B2uXLLWDelLyh9\n    V98/nm7O0f3Sek9jFDAAAIC2lJa1084ZnLZAhj8wnjkCyEB/djDjpIwvxpivozvRgBeTZyAAAACQ\n    5kxD5pCB9G4I3ZzPeaxmMRdn+9Cyq3k4xhfvO5fNLCKRRJxra43Al8h3lhY6WJsRWmPaVQAA0ASl\n    32q2tzr4Glknd/9SenQ1i3lJ6OvU9pxl8TZ0czF4RgcAAADAMfjZGPPr6E6ci3kdwMjxDXJADQEA\n    AABn4WLGGDOv5h7FY43GKePy5hijfQdxaJs7G7HMPO2LMhovFQZ1Lvfjjl+DkOOXY8jOMWxrdP7q\n    6hEA4EzE5M9qli46ggtHL5a2t9e9htTVrv5YA+tIsTnnPubw9fsd63PqXFzM9ql7l92xLsHJbBqz\n    Uq3QqwAAkGQ1i7kq0vEAANARjUNYoBFuDntj8nLjg3jqjXc8zgEAAOhAymG8fv7dG0npdZfge//z\n    zVnH/z7cl9A6PJ3ZMgI11X/qGNfg8iXb+avN4ZsDnkpADm7qdUSVgxxid4u2eylHB3B1iNW91PJQ\n    +xfD19G9zwnn3ITOCfU51Gao/Y1YR3tEMYfxVxoAAOZGsuQQAABUAFOLMffQcwAAAACAI8IxRKYM\n    xykj6DXSXolBtRU9jPsSdQI5hvzYNqtZzPtHT/zrnzoH2hwgAFhiDl9/Oe5jMANr5J6lJl5Rn/3v\n    OOuX6N7WliPub1aqH6mxSWis4o53NsY4yZ3kdv+bf8wAAADOx0wBQd8577Vk4PxbST9q+PMAx+CC\n    bL7DgAO4FSiSDUAZM8+Sq3mI1zCjHgAwB+l6ePzvtgzDMGXQrI2+k5J9JSPaa8E2LfohQchwHbve\n    tIFantT9Ae0HABhBTF63GJdz2qScwCXZIIAcoUlvJc7fUHs5kd0AAADStHjOA+BM/DS6Ayfk38z1\n    fskfG8IBDAAIM9OMs9ZoqgkGAAAUjwq5y+4vRcwAuWY6dXuPJi+Rz7kG/av34pC7vhbSBurw+rFl\n    AAAA9oQnUj2cuqF1a+vb1nLJ+K5Eh8a2S409Lt5fbr9HQzmCn9epcwQjmhgAMDuzPVuV8DK6A0AV\n    P47uAGjCr/rGZBA9s3G2GRh/m8V8P7oTHt/VNwEymH0QuJgNrmMAgBh3A1++VFmd7W4mPAJcC9sv\n    wTdmXj/65nKvO/hMaLn97rGPPGp0Tqyvqe2k+8Ld/2oW8vtUtBIMzQCAI8ErleDrl2d9eZep92VW\n    X6/O9KzQuu57S0zP5XA1+VrdHmdPHUqdF7cvVB9X4j11HKE+Uuc95xy1qvW7meXj7lmi6wAAwEz0\n    fM4EAADwieZ5kqCWo+WKH4mWGga5zJxOuQUpo4Rv5C41CAAAgCTWwLg9Lc+L9G1hLMyJFKIihwxj\n    Wcz4m5rKePncfmk66vWjkN1XiFjEFNeInjqntce8OdHBsTqGFne9G54zAACTwNGPoewaq+GlA+5B\n    jtTlRO1SuqyHZOfoUBNZJ7ScOt7l6fnPRD9zv/Ph3gtrwum7EMvcv8/tAQBAOaWZ8GBL00Esq+Pr\n    6M5FmNUGD/Twr9Ed0AVvyKowdBkAIMzM+QAwuAQAnAFOakDNxmZ3fdvPHCdwytAb6ot7TrhG5Zzj\n    4Tp83eO7Zn5HtT3avUpNLuBGK43uOwDgnGxPn5fkOu5klvXzb7zOqxT+8xlnkk/I8ZnSOznOYEk9\n    SrUdO5exPsQcv5zxRu7EtZaO8Zx00K6T19fHW2TSFgDgnNRMCm79rAnbHtDKD6M7AEA5ML+4/O/J\n    HN3INd+Hbye7rzSSM4jEgBMAMJqch3KJh/AL4/2VWH4JrOev+zzafI62CdUV5PZ7JNx+SDl+Q/tM\n    GbJblVSg7kHrMFlheAYADMCXOdvnclpnPqd2pqN6pTJppLJDxNalvs91hEpnn9AMR7dS5RBqMmxc\n    A+u1Om85k7CQOhoAUMoM0cCxfSFDIuDyV+W9Urv9Gfh5dAfOxUxD9zk5W81eIMc7FMYn164DRj6l\n    A2AAADAmHKURW7cEqdFeyKBJfc6Nqml1TL0jolvDcZZzDNm903lyIuRglAYAtKJWF5TKp9BEqth6\n    1Gd/4hS3XEKv0gct4F4ziX7UjGleDP8692Azy9OEBTrSfYl+BgCcgxmcujMDuy4AQAFwAAMAxiE9\n    aNyn+Wwf9ZsjQTFABgDEDHGl0UWlKZhj77mO3hKn7hEdstrIcf7GtuUcm79Obo3DmFEaxmjgwr0b\n    cNecEym5EZN7LTNucD5znMBnRUIXSzic/evLGVv1npDlAj0LAHDRZrNK9Ue6v9qOfza+G90Bj+9H\n    dwAcirfRHahDo9mqLwg5T5OTugA58fN4Hd0BZeSkZKmNCqa2D6WolHdUAwDOxvb0V9aQTC3jGBU5\n    62sbLZ41+rfkmFMOfO515kQ3pc53qWMl9FuBLj0Pub/k8/3ygSQpWcWZPNVqIpU2vaYlClg7uc7f\n    nDGYtjEaAGBelt37soCK2kCMHJmWmgiFiVIAAGCMwXARnIGvB3lw7M2MqUokHbX7QWwYf49LYvAb\n    OquYbQigkY/NxkiBG0Py/hj1MHwUQ65F22+25vxKRi1JnpdWadEBAPNhJ334E6p8JGVDjTwrmWAD\n    yukZBSzd31Dfl8T6rWsKAwCORZ5Ttx7JrHywl83FN+gR0JH/xf2WAo8bAOSgLaXFTJRE7Eo6KVLS\n    bjNL90ElaggDADhskahOSrYtie/95TMZ+rh6YYSzeaSDu9W+pZy8Uk8cnJqFM93PAIBypH/rOZGW\n    IzNmaJtMhSjgNseUe78tiTYAACBEabQvRa+sehxqswZqICdLIjgmf+IeAPVgSAgA0MmVTAfDH8Ct\n    zG2o72+M9nP64g6o4fQFAIRIGe9KjdMaOJoBV9v5HQlnkkHJ9znA6QsAyCElMVKONX8dzfpXGs0T\n    rCQmD88yXgndo/Y99CIAoAX7icb81M/XwHbGPNvfJKKBOTY9cHz+nkAX/ji6Awz+mOA8gihHfzwB\n    s4Oi7eXMlMK5ZmZeyQzE0lQ0se1qahG628JBDMD5SEXxcrcpYRZDpzGI/tVOyhjtr5PaDgAAfKxT\n    q1Wa54WxHDwDq1I+LRy0Id3LBdcRAGDMwz5VapuqTf0ccxannrlSjt8ruQw2OAB6gXTNQ8AQD4AU\n    qF3AZ8TAiRrA0YPI/EEox6nrR/c+Io/5oJ4JAMCScpZBI8Xp4YjVNnrW7HzmOFa43wMAQAhu+tvc\n    yF6taJb7o49ZsoTQrJw1Oh0A0I6crHZ7uRMPoqiV2dbOdyOWSZDT1oyO5C+jOwAA6AGGgACAvsQG\n    gNdKx22M1ExAdxDrD0K50b21ErUmihgAoBsqKqPU+Cxl9p3JgCxl0K09ZurajK79O9toXqLOJgDg\n    fHBlgER65xmo1T016TGpfUvI6J76VMNzl9Txcs49JlkBAGJczFZoecsPtJAsucbVZdLtzcRM2SG1\n    88PoDoBp+LXwd/fvNt3B0M+CEHR9zJCrH8giPWObGuStie8BAKAnsZGYJgdtyxFjiRG25tysZiFf\n    pW3krO9yM8c0MlCU3D8L431N+wCA+UnJBj1aVJ6L4etCar3VLKQOytVrJfq4VA+H1vGXXxnraBpj\n    jeJsvxkAAM1q8n/7dKk17rZLVv1gCmobatmXSNu5wSml3CBZAQBjeRndgSLgrE3zZ+Ic9Swy/heu\n    11TcBzrtr1lsP1ezPQ2SqPVr+noz9wFqaxdwqv3NLPiFANwDJ+QMDiv/4T62njGbuZm70dbf7hrd\n    7o7EhJ6UMfhubK9r75b4ntMPd71rZp9mx49g2iLfAwCOiyuPKdnsR/keccrnGv1uIesm0rUUn/Vt\n    rn511++lk3IcuO66NU5vLrON8Y76GwEAyFMiK1Zzl4ulE19dPWTteDVcP547Y7xntgfufGfO9Wwa\n    4y+zmO8nvzd+Msb81rD9n40xv44+yHMw29B0Dv6A+Qkw0FJr4eVDIT3+7pfXwBkI5RrtpaN2Swah\n    q/cXAACOTGi0WCMD/Wgf+/kW+D63vVGkIpli31PLU8d1M/qjmFo8bSCVJQDnY/Nk3WjJN1r22v3n\n    TCaK6ZlYRHBOlG5rmcztx5VY92bo8Uddf+qPR4LwWG30LwUAoI0Si1qp47cW24bVT1xna6lT9ug1\n    f2fiK/QX6Mhvx77fYDIBQCMaazTUDG5S2968v3a23ebVCPH/SnE3BNRsz2fz/gIAwExsT07bx3uK\n    lOExlZJRi+GybQrsfMev/W4bfL44UdMAADAjOrTPHl/mbgwdG3IEc9o/GjljjNRkrvvffRvU9Uhd\n    IwAA6EUvJ66Eba1FsMW1MB10zboAAKAAmGWAHEcvhv7d6A4IExv8xGpU2MjgEoewv80t8h2nHnBL\n    x3CvgS6GjgAADYQMxJfEuhJOYJDHahazfbzcZaHzTK373KaJfh/qhybsMerqFQBgZlLWklI5SOnN\n    lCMxtM/NLOamzK6jqzf5xK5FyPnrX5fZzwEA4Nz0dvxKB3m4XD9tmOHvOP0aFfGrMUAI6OSn0R0A\n    WkkPS3+FoAETg5QR7bBRunYQlDMLbousKzGoahUpzD++fJBO+rxASgEfacdaLOKFqtsX/j79vtUx\n    jGRmI+7GuPbQPwCAmZghopJTZ5bjBM5N7wzaUjM+shPmJNNPAwDASGqidWtsdqNk50t9E5n7Gxsu\n    AsczAIdhZpNWPT+P7gAAA2g5iHgxqcjiNJzI31wkHMJrRRuI8gUASCA5attIR+CSNEhrJ+ccXRjr\n    Xwq/a8VqlmI9yXH+UvfFLfA9AACAWPaL5+83hkN3Np17iXxXs31pm1pYA+Ms6nvr7Kd0c6rWMwAA\n    1FBSoqzGvqVl4ikngMW1bb4n1wY+36C3ANCC/BD6bfQhAVH+gsCekpEztahZcdoGS9aY3avub802\n    AACQy0bUNbdG5/fE2G8GA2PKAVpiUC55SfZZA1vCQXymqG8AACiBE+XbaiLN1cjI4avJ11mt9Shn\n    /ZZ6tvS85vQpXo/4Qer+mclJDgAYRy97Vk0gRYhb5t9ce2RNVsJRaaIBAOfil7yxKYaHALTk7Ckz\n    bqbPAKjW2AHHLADgaFgD4ZaIQIkhEWmawzWw7BJYznUEjxjtXr1Xar1Q/11qon9rCRmcN4YjuKWO\n    RUQyAKA3lDNXSwTvhbnMmLQO5eiwkv7kbJvS4bE+Xkx4XKGZLXF/+aCcAwAgh9blyqzMlnD4hhy6\n    Uu3VtPHyWVd42302Zu9wjq0X41vlsQIAgAMcwAAcAem0zu+F3+WswyU1mw8AAM4GZRCkHL6j8Y2s\n    l8Rnu03IgB1zBOc4g7lOYe4o+Wr4Dl9On0P9e2X0sefIfgs4PC6R9QAAQJJa+RJzsG3eOq5s6xHR\n    y8GXt6Eo4FodejX5ui73OLg6ulSHUg5hat3Q59B5lWRj3lcbeb9C1wIA8tCWvae3rS9nf9aBy0kd\n    TWEzJb577fG23Yq+A8Z8P7oDgOR/lcmeEwAHMABH4DXyXcmAIDQ7zV+eO4stRqmDd7RjGA/bAABp\n    /FpMsdpxox/cn0eS+/5wnMA5Dt+UUbjdcdXv82LSBuvwMacNz6NG9Rvh/KUmJIQcLYhaAgD0ZmNF\n    VI538qZ0KLXs1YT1Qcy5Ku3UjfW5FdzxBHcZ5/yH1u1x/GvB5D/oXAAAoInZEv1Sd1JBLxpSRn8Z\n    3QEAQGvgAAYgxtmK1r98OnTLKBkEIZIXnJlzSRiQYntyjD2ijkqMfCVcGO9zI3tLIm7AHXtert4y\n    zvmLrVNyvmsmG2yE09e/pzfnOwAAkCSWJcOVRbGJV8akZSdXTl4yvit1XsacvdC5e6hxS85YJ7Zu\n    re7NgZMNBpOXAQBnI9e+Sdk1b41lJyJ5z82PozsAjg6G/gAclZwBBGfWWW1aaAtSOAMAwJ5YKr8e\n    hjruaNA3dj4bNcNpgLlRRRiZxuE6enMc7CPPOZVG2ncIAwBACl9XljrApLNqcJ1/pU7fENrq3M6u\n    29000P61kJ5sJQknWwwcwgAAQEPZLHMigd93bdXLWtfG+1rRTmu+G90BAIDP6CHpsflpdAfAoWgx\n    I8x3/ErW7vVp2XYPIC0BAFL0NrblRvX662gyZvag1TGWRrbWGPKp68c1XLv77ZVqfGOkOYdjGACQ\n    Q88JVcbE5WVK/mrQt0eZpDsim0SJfnWX9xodji4fAgAAvZAoGVdqy5wpqvdVaV+/KtRXPwzY558K\n    zsPvCvoAijmDGS8Nik+DWSkdULyYTcQhy0mNchQjAgAAtEDaIF3TmgbDM8Vqng25IeNlb6Pmapbd\n    y+fmvLQZXHOilkLfjTgiRCsBAFxCjr5WsoIzqWqJZMSITcqRpHTy0GqWne6ivg/pvBgSx8nV/avR\n    pXO5E+5y3kvSe5IEAACMpsQhXJoV8fpZam9jre+ve1+/rXzWHFEM6oHz9vSUVvoEALTkruzjAvrd\n    0L/gu3N3v+03w1fovgM3tJ8UpdsBAMAR2T7Mwfe/W3I9DilD4L128PO62hy995SKW/SzPTvu50eN\n    5O2pvf154E+Wos5HzIjsG9hvkW0pY3zKQE1vI8/FPCJr/ftjde5Y6t6hnBvSk7/2vx//fCy7dQAA\n    52L7kA4auJqH/Lt470fWN/f1ql1279tGrv9g/z03O0SO7o31O+f7NbKdTd+8MtuO7VPi2DhjtBDQ\n    dQAAIEvPwJVrICAn5RT+9vGXCgSaKdoYANAdDWY/0JtZiot/P7oDDfkyugOVtE7nDMcxAADkwYnQ\n    5BgYa0eGrkE19D603cX7/GzYXT4jk6jlscigkmglTr9j+yrpT+i4H+9N9HtpQg5s1/k74mkCUUoA\n    gB7EJk+FJsFYWdk/I8XDgG11ie+sjekdjs7KOSZqXY6+KNWhNxMfO6T6phFtE/YAAADEncU5ttIr\n    w2lLrYNo3T78NclYAQAGGEYCwEFbEfvYjC8qNUhqNljJ7LPnfZRtB8BZwXAScKDuE176yb6sweV7\n    J3DM6Mox0pY6cjn0GBXnGd8fy0JppLUZsUffj3AMAwBK4UyY8t8vxPJeUPpg8yZJcR2ioTZn4p24\n    CrljCP976j1VliK0PxNZN4dSfeqfEehIAIAkI3WGBn0lZfscFb2rte4vOBc/j+7AOej/qPKbAiEN\n    gEa+Fm73asIpnqnZYjWDlNKaFwAAANKkRki90ziv5LJHL7cn5677Phz9WxoV1BtNRo3tw7Dvfp/q\n    38YwYtfg750TVV5ynTXeGwAAfeQ4t1rJq9w+ceTwljlxyl9/pAzVqO9D+49NWNs7f+NjHM45kKDU\n    ETz6/AMAwBngBtmk7Kj2e6R9nhNEEYMS/i3fJIZ/4Lh8VSBoXYV8VOUMxy8AALRlCbxvDSedc44R\n    VLI/0mgbEdf0h3IW++9jTgc36riW3BTk1HYAACBFbpRvbpslUDVpfSejL9ef24DUNKbNeYiNeTjR\n    wrx9yAM9CwAAfch9ZkqVvOOkhg63Hd8WUb8AnBJt5i4wKz+M7sBkSDqD/ba+ZbQvNSttJCMNHjVp\n    tGCoAeCcpEZevaI0UtG9lpCck3T8YjTaDs51CjkWWqWKlEwNDU0KAOAQkjvtMmgs0WW+fOVm0JA4\n    fg2M7o/0/kPjJ+71k34urEkTDQAAQI4SW6pm+2su3/C0Bk7Mr3rufwz3AJAmd0ZVzvq5juMjDRwA\n    AODYLMS7OqxBcXPSM/vfxd5bjloz7uK8Srg27FcvQtFMWwMHBPeYQ3vDxCkAAIfe5RJShOTpEXTr\n    1dTpwlwdzNmXZl3Bde7HvuNaA7hlGqjv9Z5BAADQC9f+WmOnLUkFfdRslAAANqnEAwCAWkL1eSle\n    zVY1Q+rFbOY9sH1OPyyzO5CvhpfmEgAARtFCCq1mMYvzoHf/vJjVbOZiFmPNh5u3nmZceR0zALvf\n    cdNxUe2tZhF18LZyFrdmZUSAW6wzo0Uqy8ddCwAANFZO3HXeg4tpI5c2RzKthJRaPX0bW1cTVl/l\n    pLSM67jFXCqPl6NDc/Vsq/uCw2qWT4fr5ky8Wj76tHn38P57PL8CAMDR4NpeX4ntRnh2vg7YJwCg\n    GEQAA6CVkllcuQ5el9mdvQDMBEw350Sqlu8aXP4cWURFHrWIOio1SKaisy6Zy12u3qsn3H3HjkOT\n    0zgWtWSN1ZaHI1j+PsOTCwDAp1fkYkqHptI+j8LqEl9+5ujQWnLPQ64OzR0/aGZljtuOEEEOAAAz\n    cauQu5L21lDZv2+B9wCA06N9+AtG8hceKpozSinD2QsAAPOyd+rqxR9lXhPfh5bZ5TEDr6RDOMdQ\n    7e+XYyxPGaxDbXDOV+3IvsRZEXMOb7v15FiYywAAx6JH/d4YLSdSlcDVAdfI9rn60zC3SXH13nMd\n    zqk+5ziEqWWcscoox75//+mNIwcAAODjZ2tM2WVzHbpI9QwACIAU0NL8ruRhEBwXN5Xzu/O+JMWz\n    bQOSAAAA9BOKABk58riaeJpIP8Wivz6VatI1tq6B9lZTZny2xlM3HeXtaZ3ydmNcGN+FHL8zRjEZ\n    s09zad9rcZwAAOYhN4NGSjfG0vy3TNG8ZqZDphyWa2LZJbCee7yUnuPqFPf8UPqfOq83c4+cih17\n    qVPVP3bucVHjD8r5G2s/NQaqwdWfqXVya0uPHjsCAACguUf3tm/z1dHH1nEciixO8cVswZTQr3BK\n    A6ABuH0ACPFV0WOR69y9K+Qluf5CbAsAAGAeKBO0rSO4NTRQU/ipmkNO3Yezj97Wrn8xz0bXkBE1\n    nFbzcfwXYt2UoXkNLM+Bu7ZEiuySZSnDuEQfc3CNzm49wxmc2QCA+fEzaDwmpWwfMulRs3cxWzNn\n    cKz+bMrpG3ICu8vdSVKUvrZOQ0pPUhOlQuvQxxBuM0RK++x1+/64cmrVu+fB/+yvnboOsUhhjTrN\n    dwzDJA8AOBOaSuv05MVsn9HDuc7Y+7YLnLgAzI/GoSkA4/jSWLG9ELOsjNkr4ldn9pU0qAMBAABz\n    QdXylcZPYUwtj23jbrcGt+X3P+Twfa49uzivZ0P0/vu+k7o4+/a/uzrLH+vkRzeF0lyGPnOeBqSf\n    GLj3c8hRDwAAFM9OrmXnFL3/HZPGmZqo5H+X8zkml33ZGdJFHB2Vq0P97UpLC4S2Xz9f/GPK7Ufq\n    /Oc4f0c6hqkx5MN5r2eyOwAAnJmeJfq+1jcBgAj/i3FIT+AAnomfRncAFFFThwE1HAAA4LhsJhTZ\n    OtYwd4m8jxkyr2ZvdI4dQ+r4wobffCM2d58SpPqROi67/PbxCq3LhbpmlMP/EfGlD9Q6BACEoEsj\n    PFjN0mUilc/F+xtbp/SzD61X9tk1VrOQyX85zlqJyVSc7bnjA85y7tggVsv+sfwOFT1sSTl/R0Sg\n    7ctqwNgKAHhGc3kWjc8mvWX5++ffZRfU09NxjChgAKZGoygFoB2SEb6lbSEKFwAAgKX3A7e7t5hh\n    siZiJeQEpoysmoyRo/pC1aLcHKeFu16qj1uGEZvrbJC8N7hQx+87cTQbqwAA/dk+/+qfSOVOunFT\n    GqdkakruUQ7Q2GSzs5OaYOWmus49ZyVRwaMihFPLAAAA6Ka1nRmRwwBMzXkdwD+P7gA4NKWzo0qU\n    6rfA+5LZYO+VD3w3PDACkCT1KzmvZj4XrQxsF8ZyKcMjN8K3JoIV3OE4fjfGOQ/VPeZGeveSTyHn\n    LwAAjCY2kcrlJfKd5Xmij/0blue5TmCKs9ZCjBGaoBZz/pZMZAvdM5z7Cs8IAAAALC+B5ZQzOFR2\n    cIask39XPgd+P/oAABgPhpAAxOA6ciVmQ+U4jRFFDMAxgYsD5JA7iosbEePRopug8RPskR6Nx4zY\n    Ltvuu2W33BJzYIQM1z3uhpgDBM5iAI6N9ghfLqksDbGMGZBzcSTvjZjzN7TcrT3tr0/dI7mT9Fo7\n    hXF/AQB6gefItuTYjl1ncKnNGamiAVAJHMBH5E8o0ObUOHxdpfpiNrZihdMXAADOS2rExo1I8qGi\n    Rp+NzuZpeU9gGJAnlSo6J93lKAP1vr+4RwA4E7kOKo6MSMkpbk3ei9O/e7rn5z74ztwt08koASxB\n    bQldb64j300NzgHXEwAAgBS1kcFfRh8AAMAFw0TQlr8OZpArjQgunQUFpy8AAAAfiTSBKxGdYpdz\n    lh2Bq6lLgymRQnP0SDwWwWT7xqkr7B9L6LgWxjoAABBCKjJRYlJVjg7lrjsbtXqwVg/PRmrCFacm\n    L1JCgxJwrwBwLEKlAGPEAplibcTs2V8Q8QvADLxEv/31AA8lAIzim/P7+WqOndr1xZTVHAYAABCH\n    40hbjDGb2adrXsz24cTbPpcZ7wHN/X4mOFFa3IgZYx7G55Z6WqPhLcf5cDPGGMcp7NcN5hw3pz71\n    sUdLAACN+HJqC7ynUvouH2u4+nT19O2FWOa2oU0Pl+rQnPZb9MtvV7eDfT+xiup7St9ejNXN+3uV\n    vtPC5wkAAMBxQBARAIAAwz8A/q5YJzbbqTTqtya99LvqB10AAABcSiI8UumctdV0uyY+x479EvjO\n    jbS6EOvZOorShmGqTWr/nPOQOvYexPbtRiptXtTSatL1OReTdvMiUhgA0JpcLWD1yxbQq1odjiEZ\n    ejVpHUvpsJY61G33WX/T5zimZ6nl2iOOY2O51dDjO+p43ffU1YJuBQAA0BNECwMwjJf6JgBQyl/G\n    mO/NZr4qfBj/Zox57bhdihfzmEF8FPBQCwCYhVC0hhvdEcON7t2SsR8ySEQtUdE8V+KYqTp41vDp\n    9uG5zuJz/y5EG6HP3GPw26XOFbXd9fP7cLslyzhwI3i5bVmoSQaxfYUimNzv7fmhrk6fux0AoJ2Q\n    gysWwRvClymrp2Ntho1rht6N6fNVUJKFjpPS2e4xGPOsQy9eFPMzS1akcKrfz/3Y9yfUl9T3LlfG\n    stwI6J6EooXdM7CZZ+cvFdVOAZ0KAADH4ZsJe31SKZ9rApPcdix/G9QFBmAgcAADoIGYY7eV0xcA\n    AMBYXCOja5SjnKApejl+S9mnxzSff+9Gyn3fXWOsex5ijuD791vwO3ed1scZwnc+L8w2ciKbNBuu\n    LVvAIR5zBLvovtMBAK0o+e2nJpFQztfVcfKOzp1xIT6vkc+PbXhlH2xU88VsTzp2hA4N7Ze7Tl7E\n    70KeT06b7ncjde7qHMPy9F2839yU0QAAAOanxqH7NfHZkpsFExHBAHQDMXIA+PhKqDSVM9BNbqSX\n    tvpcYE705SMAvShJaUuZnf2UuyOIpad2Da2PKCJq+8Wsu+ihhYzIzZHVWtNvprg5x/p8DOHU0pbt\n    wwBMn+fw555Q9y2VTnV/5HGQJhqAc7Ewl8WWU8RKJvTSKzn7sfJuc3RsKELXBPRq6XFp0LO144LV\n    OS+r8/kS2caY+/gmlj5ag46l7uHYeHH81QQAAKAN18Ebs4db27lEtDAAoCkwlwCQO+sopABTs6Ji\n    KTZM4bqI4Z8HPGADAEJsT39DBsu+xBy9KSfwI73x8hnpuwacvKOPszf+MYaud6q+n63B60cWW2dA\n    6Fz624zguXbwUjy5oaReNgBgbkJSgiMDYrKmlw5KRZX6n33npF3mHkOozdQxXTseN6c/Pfe9Pk1K\n    oj8/O359PRrO3DFCR60Z9/bm9f74ozCAawwWBDcAhxxbdUtmigj+YXQHAMgDZhIAKP7OWLdUSWlR\n    siBM6cA4ZzsMvs8NtPA5CKf6tX+fjdG9o48sYQMy5cT1TYZLYFv9Tt7efbpWbr8ZOqqLdzz8eom9\n    0BDZDgCYFzrLAL2O/74lrnyla80+HLoL6bR7yHfXCexHekJ2ypKjQ42ne/3yHlrw+5LSu7ijAADg\n    mMAWDcDp0DQkBWAukOZCD6n0zEjfDAAYyRZc3t8YHYaOIvKjSf2Io5pUkqANseuxeE771LWeEdyN\n    ABwb7m981EQqH242jXvt4XBfWx5H7yjgWQlFCG+Ek56bOWVWXQsAOB+ldrWc7WC7mxM3U+bf5jlQ\n    aqboXgAOCIab4HxA8RyP2kiq0kFmTvQuBrIAgFFO3pjRcSUcv6EUwboc1mWs9U1U7n+p1lmlbI6x\n    eg1EAW8B5++VWJdar0WfU9/Nei8CAGToLQsumcvtd+HJNc8RvUcn5GxuoaN7O7ap67fsorTD2Tp6\n    W+egRwEAvWmdAe8Ku1sVfnRwKPAJdvXz8NPoDgAJ4AAGx+TvyocYV5l99/HZTQv9WqHsvgw+N2ch\n    NfArnYWYY7hHemcAgM8oI5ufrHkjInrXiIOwd/9bGWxz6uKdDfeeiDkqLBKO4Nxz/1w/GQBwFjT+\n    3jlRnjnpms+uj2Y+fs746DHGujuF/YhhKnW0lklX4FjgSoNWSAY+IIiiPbnpoKUyYXIcyFwnM5zR\n    ACSJDyF/xo8IgCx8Zfgt8RnwkJrF1yr1jLsu0tsALpiCdS5GOE79SF7X2buYuQ2tYXgG2PWzZvH9\n    ZdMf57xs1Jb7SuFPIrp1PDMl13t7mjpw52G0fnZy9JRtfvQSjNcAHJdtQLRkzBF3z6rg6gTj6Ja9\n    s1ejvr2ZvQ6y+il1Xvc6r0x/Wh1qXxwd6p5bitz7YXRGEPe4YqmjH+flcezuWcDzBACghNJsdq2y\n    4FHrpoIvRkT73hTq85GUOoT/ZqzzXeS7vyraBeCEvIzuAAAq+GI28xWKvDtXs4kOoK5mqzKwXMzW\n    xBiwFA6YAQDHpEROpQx8j6jNzZjPv49lm7Ns+0hG2NNouGZ8556fq3k8aFvDwCXZ5uK1lzZAtDLO\n    ++fYN7aH0m1rgzJQ38//vv+hs9hqhIWRGwDnoMfkjrtTl35v9Y0/JcbqWPe9Ru5ye9+3xzndPnXT\n    xftrTNpRWvvsFe+zu26sHbpPV++ze0zanPLUBIfH+OdxZz0mPAEAgAy+vYorX/xACK4t7eLoHQqk\n    cZ4bPyL3XhM4vc1I5+13uOfAsZnB5ATOyPeMdTSkg5BKfwHaURtlWxrdu+y2AwCAduxT95rP95qI\n    GVr9yB8/ovb68fLX20cShXEjjV4MFa1VTzjCaY+NCLP1eCmjtV2u7Rr6rGYfdRuKNg+5abUfHwAA\n    GPNwRIac0JociZfIspAOXR29FGozpdsk+u1HBnN0u6/P7cuOG6jjtsvcdjRdQ6qP1LXx70t9RwC0\n    g3sGpEhF/l4Y2+Xso2Yb7rIYR3Y8vxf84qUyWCJFMwDDgekFHB8qbQQ1I8nna2Ib0BZq8HUtGNRR\n    aWNCg8MbuW4c/vzIvH6D44GHbJCCe4/YtJMrYfQbnQLXj94NfbcSBt6VcIr67V0Nbagd5TDN2e/V\n    0AZ0KpVmaD++kf7ZcO2e43H4KSu3p+OiU1lCTgKKzfCj3XLWBcBmYViddM7G7NPbG9PXQUhFq4bW\n    c/tITcaxuLqHcoja7xbmcY6cpBTbt+v4tefI3YZygsecw8akU5C6lIzBSs5jqsSHBToVABCjNLXz\n    khEkkRNQcWHaAHPkMqc9wIMTAKUlBTPs9wDsgAMYnA+uQnolFAZnW0QF08QGWj2coTkzAktqMpYY\n    2rXUngL9gfYFFDmpdEfUFQw5XmPr+Q/oy8c/d13KmDtDBGwuOekr/fNAOX7NkxHf3hP6oO4d34Dd\n    O300mAM3aj5nfXAe8q42rTt9Z5qWiNDnkgeUs/IhS+39H4vW1axfW0UXh87BupuMtESdv34pBKrt\n    1vdNSra5juDnMQMAAOwJSRRrJ8t9plgES6rVRPTCyduHUts3nLMAdAdDQaCLkXn3oYR0Upre5Zax\n    LQAAjCRV466HM4P7sL56hmbbZz91MRW5GzrmXhxh1Eud30fKTPp4N7OYm7mIp70ugYo8s1D3OSKZ\n    AAAcKPkQyjrgykZbwZdymvXGdSrGnXeLoRzBM+q40ZPYLP65o1JIU87fzdFpGqLHqft32zm5AdiD\n    ewJQ9A9ukI3ypRgdkALysPb5v0Z3BIBjMONjAgDPjFQKiPjNIzbwKv3u/v0dyhFcCqJ6AQDSuIaW\n    UORIDwP0hbWcNkCvjvHZjTbitJ9CizF4ZvyUoFTqy3C93rHnZTO2HuU+FSknUhgAAIwxn05dn9GW\n    j9hkr5BzMZXWuQXSRveZCB27e33czBwPHvo1FF1utx31rOhmkKH06FHHRACAttTINK6tjlvWjVtG\n    DvSDspf7mTWpYKzvDABAkNGPQQDwqI3OpbZHxK88UoOrFjPwagamJdtuweV4uAYA7BkhF9bPv8su\n    asWtLXxnIaJNn99TnzUSi0Btv+/+UNHCMeev617VEAnn9iOWMhqaFYBzknJqGcPXTZIyz68pbJft\n    o4/pOrx+xGlvaibP1jBSP9fgOiZcHetOlns4h5+PuSf+72Qh+rCZOcZzAICx9LavWVJZ/m7e3xhw\n    DsvCKZkobYeHXR8AFhjagWNjI4M5s4coZcWZrQSe4QykOE7eFjP47ECwJroXkcEAACl6mP5SBkbf\n    0Eyln5QwUnKjijjysrY/vY2uGg3bz9d173S1kUp+6svQ00MLPUfVusZEKgAAhQbJ4Mun1dyzGexl\n    WXhSTk9COmm0fiw5H1SfV+Ja9MQfV4XqTKfKgLQglioaOhaA89DLdVZjg/PxnydDDt/aoJISuyMc\n    yuXAzq6X30Z3AEjwMroDAGTxt0EqiBl4MTnpXO6JHkexmvJUZyUOYTiCATgvy9On7cPQ1uZh8e6s\n    24j0zXZ/9++tXHJTE15Mvygg20+6j66RdHvazmK/y0mv2MrQyjWea3II+9eeSlXuRg65aUntVel5\n    PPS103M+AQBtcGWOpaUeDfVhNXaizLZ7f3Pej9KpOVD69WqMuZEptKmoq75wauuGHL/0WKM/7iQ7\n    fyJWzPnasr9w+p6bvhIUzIa11pUGQUiVFbD7dx2+uW1fP/R06Dv7912ozwAAoAREAIN2fB8ZRn4n\n    NMQsTfeA2UV9mWEmXE10r6XkKPWfGQCAdmzdVGOeo0qoCBMNjrLnKKnnz6Fli1meHvj9+rbu6/n4\n    2+H3+eq83H7mRDtxztXjvSxu5O/i9XXZHYemhMyj9w8A6EEvp5U/Vvcddq1qlNc4/Nz6wdx9rWYx\n    7x9H4+otf52eUPqc6sfV+Dop3u/ntMfLrq1ex0b1yU8dHYocBgCAFtTYpyRsarfA3xpalJgzZu80\n    5vJ+Ihn+lbEOyjUC0AU4gMF5gGIZD2eA5H53Y/5tgUS6Z8nawQAA4LOvM7c3YG6DHL97Z2Q69XSs\n    3rBdJzRa9Z2rsfN0JV6SXE16H/6xxVJ/Lh//Nu985jp/WxmKY/32QVpJAIA0UvIkNe7mTKRq6QT2\n    Wc0+onX/3T69tO1bqDqy71il4Og2Cfz2OamxU/2hnKXvXo6LlFM7V4dKTMJys26Eyi+4xwbNCgCQ\n    oMQOJeHwlWijhOtn9qj9kb8ztnmB1e4JbpAVZz1k/QRAHDiAwTGhIoxLlcjZooV9J60/uGk56Cl1\n    7PrbrYm/En1E2mcAwGhcA7hr4PVT+EoSkmdbwPFrjauUMdc33IbWs8cUMwi3MkqnyNkvFcnEP8a9\n    8dc9r/fPjzYsW4YzXgJ/37E0lwAAUIL0RBI36tJPfe86frdPZ1t/OUYd80MXUw5MKn1zXIdynMEu\n    o3Ruat+h4wgtp9ryJ9f5n42h9av08x5VisG+p/oioWMxUQsA0IoWtrmWuDbJGTIaHpGQLf6vxHah\n    QC+pTKQAtOZ/5Js8rwP419EdAN3IceCezdnr4g9quBXCfYdwzuCoRyQvBVU/BIBenFfzghrD2r32\n    0nO0R6+oI5/VPEfO+AbRkBHWEMsujGVHJmWU5yx3o4Z6O399Qveo7d/zWgAA0A9KrlrZdPv4tkeU\n    ZWhc8NCvjwwKfqSxeyyhDBNc/eHvezSSzuWScYdfSsOdKLC/ZrTzl1vXt5795D9bjxoAACSpyYo3\n    I6W2UVBGqR0eGT0BYHMm0xqYnZBwt8tTs4AATavZbLF24XAFAIAw7szoUBSSHw1SC2UwdFP3hgzC\n    vuGZ4/Q9qnNXMo1kiDxnebzWcMhJvAlGM9lWqYjgxzp0BB4AAJQQkyO03Ns79Hrop5iD0M/2wJH5\n    PfWqBgcxr5/8/oecxP7nvWOavm6htNKp85Z7/UITABdzT+Vq751HmRAAAJgDbim4HqXi3uubOCWS\n    Tl1E7oJZ+VnPvYt5LKANfxhj/jG6Ewn+NueuLfBiNvMu+AD/7hluX8zzwOvdIN4HAAB8rFx0ozeu\n    xjrEtg/H2WMdSdZPUyG9zDp/L2b7/Ov3wxqeV2+Z8T6XOhSp9MZuX577bsjv/PUkHZzpY+in/fy0\n    0O6yR7+fo7Xt+8W0nbXv3zub2dc6fDiLAQCgjO1Dlm2ejrPZNK6EbpWUe64e9Wv2Xj727eqxu7Z/\n    9DOkUzdvWQtZHdKvz8cnt//FxPW2q0Ovie9tv2r0LmciW2rMYx37V2N2z9xbQP9K4NcM3oj9IkIY\n    AKAVaZ12M3cZLOkQdkvmvRtrVwUc/jbGfEmsU2Ojjzmd/6psG4DJOWL8BZid78wmEs1bOkvozGmg\n    WyEx4ArN6kM6ZwDAUWlhotunCd7v6W4wf0Rjcgygsc85xFIW22iau0F3b0yPRdpQrx7U7lfSOOtH\n    hfmfF8/5S11D+vzKoiGtOdDPwniBc+PKKz8DgV/T1X/vkiuHV3LZXqZeneXUviV1au3xvJvLEP1p\n    zw9n3/736+6VjsAt1bWx60TpXJeFGOu0SNv8PNGKah8SEwBwLqytsMRhuyXsy89po/NL5AFwJv6J\n    30ZPEAEMAMjn+hE9bKOIr4Fo4vuMuDxu3rY3g8dTAMAx2MwjasRGIT3Lt+eI3FxWs4+QcSOgNkb7\n    lPHy5nwuqwMV3u8WNdRuT8vuqbE3cv2r2ZITgR7rhvHb4NYjLDWSx4y/lEP88b4cXtR22PC+7D4b\n    I53A2XcK22uyOXtCpDAA54bSaXaZXzNXSl6EnL2UkfeRQePRB0ruhr532+D0w93m3t5ju23nHM8/\n    E1SblG6M6eDa2r42O0qsf5zlKYerRHQ1HRVsCfeVKtdgM3PUaFn3lxI6/voRKJgVXHtwRm7m8Ywh\n    WXvexdpDSxzBLyf4Vf6dudySKhHZmj+77AUAMRABDHQSiwCmFEFKyCOqtww7SOkx8EDaFHBkMIkB\n    uGwBt6+ldnTmt2+dzfb95rx39ylRV5iK5L14n3MI1eqL9e/qvEq5CrVzJ57iMRXBTK3rRkK7SEQ0\n    UffCsnMcuDV7n1NKbk99rmcl7lmksQTgXKR+8XsH52P9UkkRkjGbU0JgJWSjMekoUSmorBj775ds\n    B+jFpPVsjGvkVdtWqs/P50dm3FFL7Pr75Q/se//pu4XO20yfmtcAADADHJtkrd0SkcF5+Jk9JbKF\n    pvYBwAz8K+++xXDviPxwYOElPZvnTI5hjhPXH4yU5gjgDIqQshkAcCb8tLaUE7YWygkXcqBS73MJ\n    OfZ8J/Aa+exCGXdjRmiOkfpqjHn11q0xbIe4RF6pbTjHzUnBuTHPc+5xhT7HHPvuiKOFMd2/v+3+\n    4BIG4PhsZp9vQHICVXif9EQqP1NCC0fv6ul2OmsGvX6sHzl6qqX+DO0n5TBO9Sf0Xajd1HiFmuAW\n    mozlrpPqv8W/p1dif7YfLaw9KL8AALAcyVNQ4rCFjfJ4wMkLTs6RxDoAbWYDfR19UB3IifB9j7TB\n    GSgh0hcAcEY28xwpWctKOnnDhugSw3Qs/fD986PeXshQGiJkmI05RHMNva3J2S/HgJ76LrQsx/mb\n    ujYhY3a8ruH+/cq432sig2OGcgDAMZHVnzxCNdIl9Kttl3N83Pq1IR3C1T25+kwSrhwvPY7Y+ML/\n    7DtfQ87f0mOI9SFeCzo8uS+XhfEeAACOQkn93/fC72IJ1UO1gs/ImQKyABgMHMBgHLEZOJidk0ds\n    0FDyXQsn7eyz6C6F92SbOdoAgDPjRh7dPsZyoQiokpEeldpyC0SixKCMmJxlxqTTPYaiblJ9c1Mr\n    10bJptpaTTw6iHMeLonvOMvc/oauY815CN1vz4nI9/tCCmcAQAluBC4XK4e36HeLoervutTo19Cz\n    UMwJ7GeC4OrQ2glTqzHmnTgfth8SOpRqi6PD/X6m9Cw1ngjp1lTEcKzOMCdamDrPof3HJhaE0kYD\n    AADgIWWfjNlOr0Lpns+WLrqk/u/fpjxjaKye7/cnO/fgsJQmeAVAH1/MZr5GHnwwu6iOdxOWGO8m\n    PFs4tt1RyXEWw0EMAEjhRg9vERPfPWrl8Z4jXfbO3o34fvmUadR7d59+H+znkME6tl2oD+4ye3ao\n    9f0z+GBhrF9OLA0nRa7BtiQ62OIbsanINt9oXTpVNOUkkdoPAABwuKeN3oLfGfNwLC8fus3SQj5Z\n    /RDTr6H9P+T1fhmlR+0ySo/Gzsm+n9tTm9SxyJ2beLtcPZvTL+oav3zsa4us44+7/P1a/VaT8cK2\n    TfXD1d02Gwb0KQAgxf2JUn5dl9IAit5wIoPfTVkd+xev3RezJYNtciOCX8xmvrU+SUpokfETgJOA\n    4SGYjy9mizpztSuFXimlR88SO0Kq51aO3FkGwwCAsWyBaJJcw/TGXDcUERpLfRn6zImqofYVW4eO\n    sk1HDklFKnFI7cvWbwzXceREQMXPLef8U4bqUHRw6D7kEItm8lM3I3oJACBNSM7Gaq+670vlUkye\n    bgkn3dXwdOizI3Z/jNRxU/2kdBJVg763Hk19v0Z0aG0/c8c5qTTSfh+NCY+5JNgC1xoAAHx6BCQc\n    xf4Vixp+Zy4zpjzt85nTRdfQ0keACGEwCXAAg7bEhOGfGe0AGaQHDLM4eXMGnK3WdcHjNwCAgjYA\n    LsS7cMpnbrthxxttADZmP/OZMn7668fSRoccueXnKZ/aGoZSo2ieczuc5jJm1M1xBof65u9nTexz\n    89bnnMdHBN7z/qAzAQAlbE+fl6DuLIn4pdIRu45UV66vZiHTELvvc2U17dzeR9DG9Ap9zvIn+dTq\n    UUldyl3Pd77WRAvHxkrP3z87f2lnbR6h+3pl6GoAALC0CmrIiZ4dHcjCQcoOGrPPUnHXr6MPvAMt\n    Mnei/CQAcAADxZQlGomjPTo4F2rAUOPk5c5aiw14RtT6TQ0+UwNOSafvPmUbUkEDANLkRGrkjNy2\n    JwMnHc0ZM3tynYWhlI1uTUWO0ZVjhL0kvss1KF8KX7nt58BNH71lnr9UfUGOE4RyeuT2ndoHVTO4\n    JvoYAAAoatM7h3Q2Jftynbq5E7o4cjF30lSJzuqlR1P6P/dchB3k8clOoZTOJTo11c/VLIabQjq0\n    v0fRjP0kCDx9AnAuSm1OOTaw1D6OEg0cItd+2oujRw+X1v8F4/l1dAfOARzA0vwIoZNF6WwbCPcw\n    1Kwwahad9CBEw6DGJWeQWvI9AABIsjEMxynSqYPjkaLu+xpHoO/YzXVSuoQm8IQMwVT94ZDhOBZV\n    y4HaLtfIHfs+tt0WMFpz1i9xUsSi5vyIt9h+QoSi27nnAwBwbtxMAi4100b8J4FSmVbi9I05dikd\n    WzJBJiVTObqsprZtSAfH9htblyIn6ix2Tn3HcGw76rvYNefUVM69vgtjeSzFOSZcAQBCSAY5pAM5\n    8m1yPSOIa4JfuPZT6aCfWYkFc7WIGi7hj9EdACDMS/c9/mQ28xsGlKAxfxljvh/dicl5N88Sglp2\n    M+0lycVsIik/7wPMcDtXs7EHYqm2SkEkMADn4h6NUfa7X42fPtfWNrQy896ub2hcnfeL9zllzN2c\n    do2zPwk4BtxbYpvV61/MsLo/1vxjyNVLqbqPqfNQ0i/XiHs/d3kR1v49wblH9n15jjjicDG0UYWK\n    XrLHWLIfAMD8SPz2fd3hLruZy2cM5kPH3vF1qov/3RrYr9Wh9v3N3PWeq28fcj1lTA87SUOTlvb9\n    iePXtl0ZfYqf8/D5oPq0MvRozOnLqaVM9yl9DFSab+o4Y/dMar/uPux9X+OEt7i/IehSAIBlSeRl\n    rLVdXQ3fiao5QOPd5E04Cp8Pvj3S54xOYQAAG8ylB3WkCp63LIiuZZaPFmpmhn0b3fkCqAEgd1nO\n    9zn9yBkAL4XbAQDmxnXIhdLfcg1vqahOl3Cq3TChdM1UKufUPkOfQ8bY0Hf24ToW8bqvnbvvd+xY\n    c1/cc2gjiS6B71PHHPqOUzPSZQtcT/e71ZRdz9B7zn1Sarx2o5fcfSJyCYDzwMmgwK1zHlvG7UMs\n    GtVN5RvS31ZncPvCdWhaZ6L7CmWDsDort6autA7lbON/Rxngw1lAFtb54zp//T6l4GZeod5T+jtH\n    94XWhP4E4PhI2J5ou1vZ9iU2vBkoSQVtv79W2HbBnhalJQGYkLSI/hk/FjX8NroDAzhrQfaUcs9V\n    /rXpmbWldw5RMuvu8vm3rA5wzkAXjl4AzolvUCudfkel2fWJOXq5KQfdur218Jy+y5PTsNTwHNq3\n    RBYJCbjG7Pt7s/sbP4e8dJ7U/jZvf7FzZtcJTVjIrV8pwT4iWMd1BgC0hZPiloLrLKNS9/r6ldK3\n    a6Qt463DcfT6zzbcyUCxY/KXhXTS1YzRnakxQO5ELKrN+/l6HjNI12y2UKUSQjWGa+tSS5TZgC4F\n    4Lhwft09agVzv+cu65n6OURLuylV6k/abqyVv+qbIPnObObPyPc2oK02tfMPB7kOYGoQAWyMMf/E\n    j3EoMSdvK0F/dGKKPhXt29PZGxsAXpmDutGDxBInCSQOACDHtEZFmfgRpSHHb2ik5xrBN6ftksgn\n    joHUOpUfMtM3hC6EkTy/P9rgTEyijNkh3ULXuVxYDoGcUX/I+cudfMBtX9LIjKcaAI5PSbaM0Nqx\n    WqscnRpy9q7O+9i+QnDl+XOt9nSWhZTzdHadSx0Pb2zhZsEocwZz9X1suV9ygUPoiuXo2fLfFQDg\n    iEhNBI7RI8p3Bqdwjv31mzmOU1cKZAYFgAVMJSCMVPrmWDt/ZrRDcQZhH1Lw3yLfvxoekoORntQ4\n    gmODQG79ESkwdAPgXKQjk+zfh1PUX5bbpm0nZzmFO2K8Gjoq6dHuI72kH1m8ecbxjTDM9uJCvHK3\n    iyF5LPbcxdI422Ucxy/3WEMOjC3pTKFTnYfeI9oIACBJzPlVIm8ombkFZGJKVlLtcZ2+qVTDG6FX\n    W5KrP6ntelqkYs5gG5EbTs+9779LbEyU6kdqooCv10szcAAAQC4t7VXpzEWyASEcejmMc0rw9SrX\n    J+1Y/tqp3zHOmlEUAAIME0E7atMkWCC008ScwTNwzYwELm2LS++o3h4zLAEAeqGcvLG6tc9RP6F2\n    l+T7WNs50S++gdKPOAr1q4RYlE2tUfnCeJW2KUkqommfbvK51rB7Ljm1Mqn7hxOhnVPT0D0ujgMl\n    BFzJAJyPmKOX+i7mOAvXfKWWxWVVzn729XnpVNF2nyU1Z7m01J8tncUlpYBcQhOsqDIMz+mkw+eO\n    W486lcbZX5bj/MUkKwBAL1rYtrjZASXtitLkBNfkBuKU2oHd7b70PyUAAIL/adMsHMAAzEoqMth/\n    n6J1tG/tgEtyZh+XksHrWrHtnO57AIAksXrBOSn6KMMxN4r44rTxbMz0awWXpbjkEhqpXg0diUzV\n    +ZNw4nL76r5c52qoRnGsP7W1ot39Uv2QrG3o7o9afv/uuV1OvU6375uBIRsA8CCWxpmCMxEl1B4n\n    4pezT+vgNeaetvlCtGNltc1OVBPZG9Mxodrw9vur6aM/3f5Q+4vVKabGArHjqzmGlPOdGn9Qui+1\n    D4u0vpOKiAcAHJPe9i9LTia+XBsgxw452jlsTH6kb47T1133VcGxSpHKCPqX99dFItBMKmuqC+oF\n    g0bAAQzykYrs5ZKqA3yGNNAhcutFUO97UzsA4w7O7CBSYgZiTWpoqG8AAIfNq96XY6QuNeilon3d\n    dM0uq5DjNxT9RNfmW7KcwTa9tP+KncfSY3CNzO6+fIO1b9SORW1JG63tObHYPt4MpScX0mHx+Dbd\n    J8o5kmNkDkfg2bYAACBOSFZRy0OOZCsfbx9rcvUdZ0INNVGLyuaQQ24t9tXRr5TD1RA6tIUz2C8J\n    4L782sYxp++jLV6JhNxz5rf3fC7d7x9ppblRwTmRvKFJVlRbS6Sd2DIAwLF56KG+3Ly/3PVDlDpw\n    e9QhjtEyCGfW7JBaaOHcBQ/+ifPbGziAz8jvzPUkZ56khOcR0zz7M6tcBRx6/xpYzqVkm1F1fjmD\n    NMkBWe4gk6LGmYw0zwAAynDHjVSi4DphOWmd/ShRt58rsZxDPGX0I8LYN+5a460hjLfGyKa67A0V\n    xZTSD0vEaF0atRvrn/u+NJVlrN0UHGezbW/eOwEAUAqlPzkTqJZIWyFSZRj89mMyMjbpRzK61+rV\n    nDZDEbb+OdDsJAyPEZ4nkVnHsp9u254/E/nM60e4nnCpHs2hNHuM7TcA4Jhs3t8SSuxaEra4XKTS\n    QV8jdl0wN3+O7gA4ND/rkhXyQ87/jj6kDH4d3YGD8L3ZqgTnkYVuaHCQW19hlkGGddjmDKhGzbqT\n    iBCuSXcDhzAAwFJjnOMa6nyDo90q5ES+OVvUGAN9p7J1Wj6iZO1xP0fp+n2ajZpRdijyaSUM2aGU\n    zrmE7gU36ouTPjp2zdy6xP6yLdJmD4M50M/GeIHjsn2kgb+/5xNy/NaMxTkZNCw1WTNCmTLcdh7L\n    nksg5DqCj4Z/rq1udUtduMti9X0puHWHn6OFn3UqpxyEv85Dp6av8XnvAgBACaPsZLXUOpufHb59\n    cbM1vgeWa8nuqJlUJlEuvTOgAtAImFBa8tvoDoCpOKLirplZ1xvfIdw7UhhGSwCOjVTEYipyOOTo\n    tftO1QbONRQ/p2FcggZrN8Ko9QiUY5StTWHZcxQdquW7OkbrULSRRH+tkZxaLlVTk9NHPLmcGyqt\n    eyjNOzgedx0Wjv7lXv0t+l1YJj3rjIcT2S8DUENMN/lpmOnUw/1+B7UyuXVd4RT+BKeYQ9ZfdiW+\n    5+4v9N5PF517Jbn33sJ4DwA4JzURvi24Zf6l0F4HWMoWfESbcguOmIEUgAQwowA9xISw1Oydo8GZ\n    BRaaNdYDf7Ycb+ClC8koXwwzAAA+3JFYThrKWE3D0lSOcSP4Po2zjVIdQawuoD1mqr6g/efX6aVe\n    dt0c5xNd21huZnwscvqRUtt8vMt3wFP3zfp0TG5E9/Px8/bziI7ipjUHAByfbavXKSmdx53MEiqT\n    UKJTfQfyg+cJP+4+pbJl0Doo3lZIh3L0Z40eTen3tnphfw0W73rUpI0OXTtuenFqX/555DyDwhEM\n    wLmwciHnWaRFZK8fgCGRqY9DSfbCWXgx26ftV7Lk4FmQrP8r1ZZkic5SflTQB1AMzCegLW66hNmK\n    qH8Z1N+UUm7hxO1dB7h2kOUPCkODxpa1RnrWLwEAzM+zw7RNu8bsjZFuekCOcTpcc5VyYoYNojmk\n    HvDpSNZ4PWDK4MxBIsJwX8N43881uL4cnGtk+3E1aUNy7Fz5+6Si5zg1fak2758fDuEUMFgDcC4W\n    8+zYqo2+DcmoR9mEZ1KTf6j3/ufVPJyij2VyNe8552V/bHsdxo1u5b5S+Po75Phdd/18/i7Wb65z\n    wU/f7F8j31F/8drOjegNRQmHJgJyyi7UZHoBAByL3lbONfF3BKX2SN9pfD2IE/mMzuDaUpSz+Tfg\n    vD09cAADoIEzKtwYrRy5ofY4g0+3VnFO3eIF1xYAkAEntXMourLUqBcySvuGTftdTT3DEH5NWD/N\n    pXVkxpzBMdOqWztXMuXks5N5yTLaU/X83FqEkmyJ8+PfR7U1jH040UWptKcAgHMScsxuAcdfaXsx\n    uBOpfFzZ6teZ5UyEKdmXnwWCKhOQe+ymkR51+0jVMn4m7Jh+6N/l6T7ZO1ProcZB/vgpda1jpNJF\n    155/6FUAAIijxcFbm9Uxtc0XY8zXj/dHsE3HMohqTf/8++gOgKMzpwP4n0p/sGemdvYLZ/bNEdJA\n    u8o0R7GWKHmpqF472PH7G5r1dqmYDdc7ErkVcPoCAFxCJrbSiNzNuEbG/DZTPDt+5Y2Ea8TJGTJW\n    +8bU2QgdL5VC054jv86vXe62WXPN9xFLy0d0UzxSLSdi2E0X/ehnXn9TTmEYsQEAxvBkgRtJGpJl\n    j4wNS7GcCdVgl548RfU7VB/YTb9MHc+clqH98ft6NjWpihpXSJ0Hv6bw6jwhpvRomW593pY7/sST\n    KwBAmpygiRAjsu65+3wpbqUPre2nR3AG9+KPwHINqZsBMPMP80EuED5tKEkX/cXIp3OWaO/Fc9xy\n    Bj3v0fbCtEzRLEGLSN/LhykCAHA+XENyjhSIRU5yjNMhQ+NCtPioB1WazjncW98ASzk3Q/0+Ank1\n    tmhDvrs8ZMSXxDeMl6b5TkXp3Y9nv9/c9uAIBuBc5NT09TXTRmjAVLrdVLtUvXWKHP0ak4WUc9PX\n    E6FJUxKpkWch5fiNOX9Xs4g4AMLXfIl8SrMR269EW+HyHvsxJJ5QAQA+pc9jJduF7IOhDH4tS8DN\n    FpySsgWj/i8PN7jtj4p2AI9fR3fA4aeJfhf/yu/r0UxrQBrpvPaz5cmXYGMes6+Euc5c6UjfHkgO\n    pkKDwFJSTt/SVNASMyABAMchFX2TMgLmGJDdmsD+fnLbivXZmHt01bMTOO4IliR1LHtH6qM+b07a\n    Znf7NbL96rykcKOj3WX0edinjAxFjcfYgibk5cmgTEU2pc/lswE6t17icz8BAGcmnGlhryMeUZTl\n    aZ2NMU/tGmIfHMKyOd6G6wiWIqa/fD1aUqu4VA+3ygBCTVDz00ivZvmMIC9N62zZHB3tXrvS9M5+\n    iuiloi0AwHnJsXUthXaxnD7UYu2OEg7h61OgTP/00FzH7beM71Jtvg60Y7bKAlpb/7d2ewAGgOGg\n    BWml88iZCcNdF0KUj2TkcM/ZXzUDr5K6vZbaQWSOUzgHRAIDcD5SxuBa02YomskYN9qlLnVwqi7w\n    1TxHPuU7BePnLGQo9uvwcgzKfu3B1EvSgd3GcflstL5457TGuOwv92selhxTqgZxqL9UDWUAwHnx\n    J6LUOgwpOeTqvlInW6h/j+jN5cmpvHp7kagBK5EKOkd/5ujRZz0ervm7Et/5NX/znh337SwR52+t\n    M9hE2vF1aupuprLChPQitCUAwJKyS7nfp9bVHPhQEoiSu01Px7CEXfiL854bvOQz0kk8gjMGtoHp\n    gQMYyIH00vnkRP1Kp4umyB2khOoD++QMmnxHL2fbkkFmrVMXTl8AgCR+NFGdpKAjkdy6hvkthusZ\n    rkxjbohQf3wnsJ/u0k+NTNU6fDZKt2X1jNuheoSu4Z1Ki523zzCu0do9N+55L62r7EbPuXWEjde+\n    f4wl7T+O5/k4/OUAgGOyRJZtJizLSiaGhDIrUI5bbvuhtUI69DmjBp9nxzKtJ23/fWfwsw4ri/Qt\n    I65HqZIIsWMJ6ciSY3GvVWz8sx8zldWP9iPLF8N3BFu2wPb+2S7rKQDgiLSK5qXabWVzS9GjFJ0t\n    H9DKEcy1sfawIx8F37ELRy84EDxzzM+46YEgMwrRv4llpbOc3O2+FLXQH66jt4Ych2/tcfDWvXMp\n    nO0IRy8AIEXM0Map7esb7S7Bb0v7tDwZuTlRmRS8tI70OpQT1f+O64DOWZfDxdT1garva0zc4B67\n    J3LSWNP1IWXMv6F7Ueq8L4z34PhgrHVe/N86FT2Z4+BbiTb97AYlXAKf/YjWkihS37Hp6+iQg5Jy\n    nlLlBahjydV3Oecp1uYlsG5qbEDTzpH9fA6fUzNzodrZvDZz2/IlJsJBADgfqWjekISJOWMvH1Nv\n    ahgZOcyxQdbaKVvaUkudvLHtYvbuLxnHoi06WEvmUdQXBp3BkA/owhXGrfL9j8BVel8ztmsxWytn\n    4PFw/JbBGSSVzrrjziAsmVWYM/iUND7CkAnAcYk5qTjRQxdmW6l9W/x0wCGD5SXYQhr/uJ4Nrgu5\n    LGS4lTA4t4xe4qaajn1HO2XNRwLKJXmvcKKpqfX962z3t5pnp0KsvWcoA3a+MyWUBhycEzfGbxEw\n    OoJ5kJy8Y8zzZKuLMZ+yz5hyOROKvKQmO0laZGy6YsoRznHcjrYOSaTsjo8f6DGHu3853UI7f6n0\n    zFydGsqyYY8xhb/v1aB0AgBnISfNsyQl9rgrcxnHlpdjb2wZEWxpXYKvV8Qv166d4yzWBBy07WhR\n    gvUoZV3/p13TpW4doI3fjTE/ju5EhD+MMf8Y3YnGfDGb+VrwAPXNGPM6uvMeL2Yz74ljeTdhCXIz\n    5inlJLU992xdzWZugg+n90Hhklxmj4WKCMipI8UFj98AHJuY45ZjcLRy5+5A28z64RK0y3JYzWJe\n    Ptow5i5nrdxfzBaUcynZ9zA0bztHpm3TGFuDePtYz42I2mP7sBq+UXp1TKxUn90+tZDjbrvPqZ/z\n    eTgp0sdNRXmldHFsn267/vc3x6HAOY9ufWCb4pxKgc2pb1gygQLMy/JRkWxxPu+/t2zZEXbgGGyf\n    UoWz7p01IEtcnUpJ7TW4/P5c5Mr/uzNx+3Qq5xR3WHfvF8egvdehMUK61f0udD4Xhg4NtV0Lb8LS\n    c59DbYQcwv56vr7bPD2XM07zcZ2/Vi+7evQ9c2KUnUh187J52GwwueONxdA6GQAAcrgkqshezRbV\n    G9eP7VvIIRucwrVVxr6L2ULtcaS421zjSKePRjroen4w25NzOOQsnjH7KTgsGN6BOD+YLUtooQ5w\n    Pa3qAHNmmtXORuNsXzOrjhutSw0sayN9AQCgBTmRJlTUSO52oVq+/ntOW+42bqpJuyf7PeVAzB2B\n    rs7L9sOv87dffyFfVD84aS25663Ovrl9zIFzPm27qdq/3P3Zbfzo5JqniBLnb26fwTFw74uN8QLH\n    J0//PW978d6XTiJZvbaMeZY/eWmon9e9mkct4FDGBssls+2YDnL1116PPu8zJy00R5dy9Lffx8e2\n    ZU5pKp20X6bBBD77feIQ1qN1mtCvG1yiDzGpCgDQgxpbHDdqOAbHLplyBIdoXf+XS6n9+NVsTxG+\n    R4j41ZL+GYABwETy6+gODOJ3gTaOmBJBo7LqMUsrx/FbOgiivosNiHIHS6kB5JW5Xi4lRgZ9dxkA\n    QBv7aOEyx2+sRQnnnYXj4M0xTOc6Rl0jsFR9wtJ21oBR3neUx4zxsZq/HOO2dRj4faCM2KW4W8ZS\n    iKegU2HSxmuYpM/L3gm8BF/37wGgM0f4ztpSbPJxt13X8ZarM57T+j7r6JBc949538f4vvzlfs1g\n    epITr2QFd9IUB6pOcUnWE2qsEdsn1YeYc3V7uo5xfD3aq6I9dCmggO4EIylN7xzalvOdpba2L6fN\n    1mmfJahxFvv8PfpggBi/je7ApPys7zcPB3AL/qHgQudG4mpy5mqaleMrs1IHcU7dX2l6zDordQq3\n    OKYaB2+rdKAAuOA+A3zyjInG7J1xVPp6DrQU3RtPKSdwKqWkC8fpS9VK9PfHiTa6Gtp43uK36O6L\n    U2vxkRb7+Tjdmr83E56pnjJiU4bs1TM0+9c2J4pqDRit65PxLsQ7GK/Pik0DHbr+se/AcdgiOoFa\n    z01tW+L4dVMFL4Tjl4OVpYsnyfyJMzkTp2JYXWEdpUtA35bo0JKyAtzzY+HqUGM4Y4ElY7zBg9qf\n    7/x9/p7vYPMjkZfAd1wdvXyujxT5AIA8Sp6V2jxfbR9/H1wKHb+h72IRwbHvcuydsX69VDqyU3xL\n    fOaiMWhKmpB/pHXGU2RUleWX0R3QBRzAoB+anMxSWAexdfB+8T6H8L/vXYshNQNNwmmbk+q5dPBG\n    zwCsp2bQCuceACAXtzacWxvVmDyDtU3PWBKJRK2fMkan2qYiWX0j6XM0TTiCNmT4zIkuek5raape\n    fpsxOJFQ9juOmbbEiO1f31BK8JL01LEJC3uDdhrKYcNPrQkAOBohuRGK6t3XoA/jygt/oklNxoTn\n    lMH7/tp91OjVHDnN0TtlerROh9qyCVw96vf3cS7i37tnnSqZ4B9bDr5ejU26yrO+0XrUT13ObTOV\n    rhwAAB7PNuXbtqZVMEiqbWPqytkZ87DDvmQ6gl8r9wvOAyJ22/Hf0R2o46W+CQA++MMY8w9zn7Xy\n    J+aXRvlmjPmS+D5Hyb+Yzbx/nHP3vSTv5llivBvZaIur2cwt0OL1M/ajHzdT7lC2wzbrjAEAAGNs\n    hO4d1/F7NXeZY99zIjVsW+tHjNPlc7sty7DnRodcPkyDbpv37x77XL1lLqtzVO7ny2f/bETL9ilf\n    /cfcWIRLbP9ULccl8SBfkwbZPXe17acihal2fSO2MWGdleMYdpf5tZ1LahYbY8y7Ezt3+3jv/hZy\n    cI3XNqpqIb4HAJyDi3kYZWt+/Zu5y9B3Qo/mTKa67PTfQzfb5a4eoz5z9nHfbvOci48IqVCbvt6g\n    jOX7iVlbtH+1OpTDs14P9+eSWEZFG7tjMXd97gSr0LOe3xe/Pq+N7uVce3e8R9VMhtYDAPRG0s5V\n    61itTQN9t0PW8c5c9s3AE3MGvkc0b5KzlmQdBOb9ufzzJD/QkrQCEF57ZqhpQA10etSeSA2catOX\n    cGf11Q7gXNbA35q2AADnxK/RZ0dit0wH3aOdskdvP7LSN3iGRohUGuiQIzhkiE3VDC6tCUz1I+YM\n    rE1nGXO2pvocW+c5XXb6HBrDu2bUZ6odyvGxfl7vpTiCyE3L+ujHEnQwrIHtY8swYgXg+Lj6p94J\n    ua8/Tk0mivXBf+/qvxxZSUX3pvSlu4xydKbqHqf0Vep7CT0a2j4UjZt6lgr12c84Eju3nEjrNbAu\n    xfP1L4vkNpF2StzA7rnf388AALAn1xa2Mr5bTX3UbghOu6W2SUlbY4gXpj23xMbrZ6D8mvhs8dM/\n    p0omvirQJn9lrp+bufSImU7BIYEDGNShXTh+V1nDl7O+BqVG90sG7ky23LTR8Vl66XW43Ly/kg5Y\n    3oztjVx3y2gDADA3m/c+N0LRTTVsvPeb4aWMpBzGsTS9qfbcfjyncd63mXJWUkbekPE2ZSjlprB0\n    uRa+ckilVvbTX4Zq/uY61WO1fmPRTNT+KMfwmoyxpvv7uN70PW2/oSK/3H7evCMvSd8JANAP9aum\n    fuuhdPPu5BMLpbs4jri91AnXfg1P3Nr3IeZszJlMRXGXk49zEEu1nFMb2KeXHo31K+yofV7un4Mc\n    3eq2uzF0qom04e7DnYxH3btrpB1q+Ua0FQOZNAA4D1YTxJAMfrB/ezhOY1j7Yo7TOWaTlLCLGtMn\n    UKeGVInDM1ASSMfd5vfRBwfOABzAoA1ai5d/X7BNalYTl9Qsq1L8dmtmhfWuRWzMY0Al4ezNwR+E\n    SjhiH7Pt+cdi14VDGIDj4tczfdRvS+M6wShzXMzgaOvzWYfbo5240fNhbKSjZ3zHom/EfTgfw5HK\n    mwk7eFPHF6vvtxLr5NQ2rKVkv9yoHU5Uk+0D1Sd/rxSb4UUiPacRfWz/HDHMYV/T0O/BRrz3JyLY\n    1NIwWwNwTDbnNx76nfsTpigHHddRF5NdvvOQky46Nlkq1l5oWWm2jFQ//X321KGh/T6PKej1fTjn\n    yHcG78se7PfhcvXazYkeNibsXH7o+vixUGzOdjY1dGyyl52UuJh8RzYA4FiEU+vzbVstHL2j7GOU\n    fbLUZsl1Co/K4phLqS271JYOAHjwr7LfERzAALSixyyp3oOB1Ay3khl1lssgR7CPGzF8MRt7EEvX\n    0KL/uuARG4BzwHX27rdZkuu4+A4x16F28bZdItuungExlIbS/0wZp6m2QvulooFShudc47S0IZu7\n    fz+yKrWNHx3FiYZORcO5/aXW8SPMuak3L4y2ONhUrnbSg63t6zul3XqHeJI5N5wIFnAcqNTMVgY8\n    ZMVD2/m1XY3zeQt856/3/7P3pu2RI0eSsAHIZJJ1V6vv6tYtjc5pqdXS/v9Pu+/M7s7sjOaekebS\n    rVZXd50kE8D7AekIc0cEEEAiySQYVg+LTCAQOBKJiHRzM+cEKutK4E/K8vfDx++zhc6AwXHWd7wx\n    SUF9SlvfeBTjsjE3ITx1HI+ZG1iExla+lhXcmOTr2/bne+9s3/XAdbXHbu8bwdCYWu9SJAralmsN\n    uzHW576Sp3E1IeGWYcwsyrrb9YkYDmXtLCgjfwNxjhM2DjmmTu9YJfAWw6SwiHPE2ZFjv8dACh+r\n    E+Y+mMuxdKiE5tj9HIPA7s4RHEPCXkjTu4R4zFUHOPZht7mmB4wvKymGzL1uW4yxyt8hte8U6xKL\n    61L37oPhiepYQ60GoQBlbtYfeqKckJBw9ZBgGweqGXb5WPWFDuCFLXNj+mkCj7U6Xj7OkMoppMzx\n    nU9fnWFfIJXbdxUyMbWB49vuC96X3a9P8RVbH3LISjtECgwFsbOBfWhV1DAxYF9Le5+dcx9qD4Fh\n    r5VVAubmd8IyYU1sM2giOCXWLR/WQD73LPcRqrVp31d7npfb56TtT+8jA6uQLQkdk0wl++Xnt032\n    qXvG1dhnoK8f3xh7lWMo7zu2nR1nfUS2LA8lmsUeg7wnofFsyDY6G3kd7b3XZznNJC/gd4GxxDLv\n    I1lAJyQsHzFJc26sdG2HVLhDMSxeHyJqq4H1PmJ3HxxzrHKuWr8xsHHsqa6QU9S9N0URzAQs8xmp\n    /m/CnPjssN3f3BDJvRvyoLhJmPrwui0PvXP6ey4b6DGYMuDH1gEeIntjyOC+iZjNnjvUJCs0aZRp\n    bMjuecyE1YchcpePYrivhISEJcIXYLOB4Xqn2PDBVwe4NGFFxtAML1T7zhK/NpgZqiHbF0iW4w8H\n    RrvqrMwcR18Aempwel8F05RtfaqbEn22a/G1CWX5UD3JGEVT12I1U/epD6ycCt2ZPhXUEAkeY62a\n    sHwI0ev+1usAPR9L86nbgsw7Pgo40YVJYWsHzeRYBT0W1giThD5YtWYo6cu+HrIrDrlx+J+L8bV8\n    h2oD953zvs/kKeNwzFzAkr/+mr9x13Oo7m9oXsTW1baf0DgY2m+fa0vWMzZbxTqXWfC90765akJC\n    QgLHsGJjZyHidmj7YyRk49F/7NdRci8GfccVI3Q69yybQyF8XaKw68C+Kt+k0E0YQPx0+8GCb6Yv\n    rvsAFo65lMOHQgyZO3Xwui5bjH2yw+ojfr/mzAJke+fhtv7t+5CNmCQnJCTcToRIWKvMtG1L5F7V\n    Y2hWV0cEqf3qTX/b2Pp23C9bQftIX8Bfly8U5O3b39hgcj7xZ+w+xiIUyO5Ss9lg0FquZwiu7nO3\n    JnE/WdGtqdlX75DpuT5ie8ji2ZeokJCQcDtgCdkhW2ZeLs+nFbrPEVkfUteG6o+7fYTr+MaUePDt\n    PzYByDc27JMcNbb9VY2jU8jiGNtsGZOsm8lQaYfQax5TQ44qdjtOovL1y/O9mu5jX5sx1y6pfRMS\n    Ehg6mW6aEEIwRWhxDHN6qw625erGqIdjrZ5j2locgxV0HzjWfuxq31fXfQAJCYfFGFf7hCl4BuD+\n    dR+EB2eo8QIZ7l7T/l8BOLvui7AnzgFsBtpc4PAZtKu2Sl4Yl9TiEuOUwWOPv9gdT777XUQcn4Ul\n    drfof1rlnn3ELrPrq55tQn3KVCZugpx12qb6dcvH+E9BwlLBAUZRY4SeAVnbRmwLM9SoW5VnkUQi\n    xQAAgABJREFURk8f7Gybq916QAKCtfq7ALBVOhC9Pz4S6c+Havect0QxnyO/tscT+nJfteNH/zX0\n    7dceV6j/QyNkRRwKsvpU30M1Hbk/q7B111sfU6g2pTyfuAavrCtoO1HPWRvVWEi/BdiRI1Pvp6/G\n    Z8z1TqPo8sHjqO/9zky7dE8sF1yPN/ZpUXvuCmuvK2OUPI98qsvc0wePbX33nh1TQ+O/75x8z/Bs\n    l1jFfTgicJ9k4P5xeGgc3WdbOVf+7baNq8nbh1BSmZub9ROpdry229njDSnAeRy1r8sdQR26Uj5F\n    cYaM7sV+tw6o7dw9m4jg24s0Xt5myNjlfBJq+ONTQwIKXs8xMl6PgfUlmriffCeY2/Y5FsfMlAjp\n    exlxnIcgiKeWPjyfuN2xIuSEeuwCuOtGcvO9NhxDbk3CTcJteZhNzU6aqw7w1IF67HZjLEgku83u\n    Y87aGVc9sQsd91TLZ4ZvcpyeuAkJtxtj66G6iuOa6BMiLvdu07UjtMqn0Ha8Ddti9lk7y2uuRVuh\n    n+DtU4haFIA3DCpBTp+aaKgO777Wz75z9x3DGFvNUL8h9PXHdSNDSrEhO9O+OoMI9Kn/DinkNFi9\n    5ILX44ngMURQws1CIiUSGLZ0QghOgaln7T67+36VZ9da3/bjU/uGSiTIeBRTC9jnoBE6177rsW+5\n    gtozfvaNUaExOMa9Y+w4niM8r8iQRdf8lX0OXRPf++N7bduHHU36jys0//Ldx9zGV1oh1vnK9peQ\n    kLAsZBGef2PGjUOofPNAjG6obvAxYx+l7xjMSfpOsaw+x3RXyWNXCSfMhzmdeBOpHIWbQUd8ft0H\n    kDCIm1wH+Ngzka7K1sNOQlaG2D1kFtyUCZslbkvoSSHQV1Pxaq5pN1O/7qwb82U8YTmoJq5LuPkY\n    Updwm1jytdlGbzukIPIFluueAK1PwWItDJkEjiFt8uAyfyBX/tlrFWtzeRXq37EEN69z5x6/fYjI\n    rQKB5yEyOBwY97+vfWS/7Nv3dx/GvkvpmZnASK4qtwP2cx9T/9T3Ny/lZClJ1BpLrI5pP0T69tWa\n    7duHj7CWsWVqAtRUO+kpiBnLQ8cTmivI2thxlOGrH1z13FG2jEeohnAVGJtzTx++8gl+0jt8Lfvu\n    zUT4JiTcDvjmzHbexM4/8roKtLXLfOs5EWefOJw/oacbEyxQt7HNKXHGQ5KzU3AZ+PtY7J+nxtN9\n    ZO+Qw+YUHFsd4ZvMnSTcaNwMAjhhGvYtIj53P8eCmKwi3yB2DLVxYwf5fSYDcyh5Y7GNXO6bxNms\n    P0bunXiOV/pOgVjf9GU6Dk2cExISlomYIKPA1hLsAwcUbXCXk3d8Nefs3yFFSw0/6RtT+9W/f0ce\n    +s+vCVaPrQE8BvsqgcfXIgwt9weynZWjDlrXPUH8MXV/szYI7d827+mHkxS4PxsUl3vTBuPj7Sa7\n    Qfah7a6CoEi4eth5UmZ+9PI0p1oiQjb2gCXLwmPaEIbqqYcUwyGiLUTyumB6Fp1EE3u8br/dhCI3\n    1hzPODpXRCo8X/Cfr69cAi8P7aNv3sNzJl9fMepjO45myLDtId9DRHCiexMYKVkuIYQ+pwCOac19\n    D8XG52KX9WEOItjFWKc5IPpitJcRf18n7DFPdby8LcreKY6pL677oBNuCxIBfAg8uIJ93DnQAzQm\n    G6XvoXYTsll8WUW+AWkqUTzHYL2O2HfIQuRyZBvBXKRxzERozASM28ZOEouedYcgfXkynJnf3dpc\n    YUgtlPp2zI8SEm4lag81EQocx4ToWD3SZw3t699nEcivue8+Uq1P8RoOfgvpqfe5P7Ko4K0mXfWP\n    z+ayq9AdZ285FrYvUSCFyIJQ3d8QnALJpywbtie1x1hBE8H6HXH38hjFnNQl5u2s1TOfR8Jyke3q\n    sto5VrfdEPGRcJPhGz/dOg1+fvifGRmFcsMqTGu5W0PbOIecM3x92Wcmu2/UPeNoDJrPh7/kwNxJ\n    MaFxtG/snGMcDTmETIHPanpMyYSh68quKEPOLz5FsMXKbM9q9aF7JAu86hs/k/V+QsICcSUxpmk7\n    iY3R9cUaY/o4ZE3h1URi+CoQE+s9FkXxTcDcvMdY0V0ijY8bD47zs5QI4IT5cAjy9/V1n9QtwBTC\n    eurkIMZOJWYydlXEruAQgWXO/k9ISLgd4GAv/+bAcF/IrQ6G8dD2w39nnkAf1x8OKaNq+C0GY2rB\n    Mnkogeg+RdWUwLTUBQ5VfbWkbmYC00OYUr+Qz6uA36YstK99Z+Myntgg9pB9uLtWDfosxzO1r6y3\n    D1unEaYPfu2UxLbuMEyfug8+Vvs7YXlw73s/jvLrdsKVonn2dWHJrtCzaShxxj3vwqSx7Gco4SW2\n    XICvNu7QscYh/plZROyvb+yMHUdDRDF6tpX5gB139yG+fePokDrct19fXfu4RL2wpXkW3CbUX/e1\n    jKt6TE1ISFg2au+rqqe1XXddZaz6Yn3FxHXAfPFJhrhvXQcRzHHaUMw2pk1CQsJx4uH0z2wigG8a\n    ns3Y19KsnW8ahlS4MX9fFYo9s9lCEyvub446wPsc45RjqAJ/WwypFerI9gm3COkmWBxC5C2rlJp2\n    DfTzRas1hywtWVnEgcgSeUcpHOorxuIw9NraSw5b9oaD5RIEDgWOM/Ov7/rHBl/HwCqbhknIrtrY\n    XruQEqn/GoaJXGtZWmMc6RxSivvOtT+ora9CHeirpMSB0L4K6sf3OmE5EFpC3y/d152/0zi6SEgS\n    E3/mc+jkphDJKs9GX1A7pK7k3/KMt3aZPhI4pAwGbJJVd//y2ia8hMboIfA46r+icdp5dqGYcxzl\n    68bnG8LQuG8Vyb59cU3L0LnqYxjvlNGvEPb3a11afMlyfXOZOnA9QvO4ajcvDO0/YRlgd7E0NN5e\n    hGJPgtjY1lCbOYlg6cuXWBtL/G4jtjuEIlgQowwOOTduTR9z42TP7X2OmBcR7aY6cB4zrFNq4lsS\n    xuCzw+8iEcCCL2bu71AWzceCKd7214XYwWWq5fPUoveC68q6mmIDshrcQiNmIrVF3OTtKjPo+Lhz\n    1NHq4grdibUvcGknxR3C5+Z8vBL6EBk30UHH5s3Pkg/4ouCzv/UFqkUR6Vvnluk+ud++wJ2vvRDK\n    IYIP3m1CgUcdPI758t+1YOxeJ27bH8Q+fvTbSPoD1n0qard9GF3VbdZxoBiyzB7qObZ2cJ9y2Hes\n    lnwJ2f8yETRUTzPh9iCNo0tE1j4tmRzjZ4PYxPueQ9VuHT9bxtQUDymFhQT2KaWqgWeltc8fSmSy\n    /cPTpxDQlsRkVW3Ms/2mgYlfH+zcJ1ZJ3U2I65KpMXbPvNV214+PzA3VmfYfmx9lRMKb/YxwMkXC\n    stA3HsaMlFm6KxYBvg+s5t/Go3SJM7/7HsfISkwjfqe4+E1VA8tZ9m2/7d16nnnl1PhviCS+qbBx\n    9E3kdtdNFO/jfDpl2+skkucUICZcO1KI5LZjbu/4Y6oB3GcfHTO4yIDEA8zUovcWPOjvm3Xlw1AG\n    2RCugmz1kcMx+51ybFMz+iranieK+cDk0be+8qwH/BPqZMK1DGQTviu3o3K6BRaFGpoELuhvG+jz\n    WSoDTvkrRKlVwPnVsd1+WW2rg5pdhJUz429un+rUEps2IDtlljp0bBwUH/onx9P3rzY/+xyb7ziH\n    roNV9sTWf2alsazr03/pRAU/qdunFOekhlDyQ+gcCurDqoiDSLHKxcDGrX1aRft21wDqRAAvCvbt\n    7Lrn+BwJ/GRg4dmugrabDyVG2cQnIZErZCjN2tKz/8zTPydAhc7Ft/+herl9zhT7RIGGxtG+Wrox\n    Y2kfpsw/xs4zpl4bX91f258vYU9j2CIbcARviaz9W+YMvprXsm02sJeh9Qk3E1m133iYpbDxMkC3\n    QUWLxsaebFxrLPFbRS4bgzFEcqxIZco6wVWKV2KcJdcpuDQLjonvSOjH59d9AMeHmz2S3zvAQ+wQ\n    fV4V5iJzb+NDbV8VbwwOrfSNJXf7jmPMMW57lvWRu8c2YeqDnUjajEibBZh3Xjtkgb58Z5oI4IVg\n    oAhob02dPb+oJxwX6joz5JuGJWSdSqeLFaQmUxNsHqrzaoO/NsAqxN/WE+xmAtIqpUJBWGuRiM6+\n    /Na+Vk3VBxcw7x5DQfvJIoLJfRhTy9d3HdwxhqnVscFsfj+6AeYsSKqG4IL47jX3p/sPH5N9X60a\n    jo+lon1y7V9HEHRV86zgA8JjqJA4KXi9HNS1dj6IHh0P6eeXcDQYesbbkgf8TGEyjYlfTtry7SuG\n    qGT4lJb22MP1bTWsypXHmrGRnX4VsFMKjx2nfOTw2GsW6sc3Jseev8/5gscf/7wh7rqGLJoz+JXG\n    Q/WhbYKAvCt2vW8+59tHHvE5cf14FibcbAxMrIfKVSUCeCGImED5hAohdfBQzKqPlPUpjeeGxBRX\n    CMcuD+02eGw1dg99PDFx9Zti/zzG9XQfh9TbaBU9twNvQhQOM5I/ve7TSojGPg+bq7CB3ozcxzEO\n    HGMxpt7vpfndh+tS9e5zPFMD73ws9rcPPnVv83cXvokuT2CzQBbkUF++up8JNxv5HoGTOhHAi4TY\n    U/reXR+RKyFYJsYADAY6p6hnM1ji1h1XrBpJXneDxZmXWA5B1FB9z0NrCR0KUuc9P3Oh22+4RqIl\n    hkOWz75r6/rov+Y+ulmued919QWcXY/6lRz3Cv3JAF0ry7DdJavv9PXwkyBafW0+QylwvUhwmQ37\n    022cxtElIcvC9X0rhJM+5PlRtm21MjdDd/y1hF1s3XT+3pLTMVnb4Dr4zJRtuw4Jvmfg2Fru/oQx\n    PYb6nBx849rcUaQxY/XQOOq7rtaOexi+qz5c99dec96WxzgeG/trFev603x0nKSn95Spsk2WOLb3\n    vFafj09wSLgBqJjUG496ny+1CUcDO8fmb6RDcal+sjccHytNm+uOdfkI3744Yd+6MTbMfbHPvpiv\n    bBcT7x3Tjvc7ZpshxNT/9WHjaTtHbP/13j1o3EaxXMJicD2pXPcXQNIdGndv8DW6KQ/FqQPKIdTC\n    YzKx5hyg5zieIQyRwldd49dHDIesmgUhy2cJpoesb6qB1z4k9e9ysNeX5XQbLAq+zHkbXIsNtnHQ\n    N6S4rCICzW4bpywR4jXHcICa9+MPiE6zO+a+WdUTQ3hfx6x2zD5DQW1rfTlU73eslTTX/Y1RSoUt\n    RsXuVF6FsTX3YG3699lMVtCB55BtqW+5L+kgYRnIJo6H9XVHGRPmxe4j3Tc+SbMajS2ue5YEu0MN\n    R9xy0kqIFLbUWPeZrp99Q8peX+KNjMNWjTr0VAvd8tYO2lcbeMo4el2iwKFj5fU+YpuvQwyG6v72\n    Obz4+tqacTWkDA7N5Uozy9LETdfGPHRcNVwd4gzd+zWNosvBvonFiQBeCGqt6LUKX5jlIfhiZ4V5\n    XXnaomcZ4xBxwZg+Q4Rujno2U5mxcdb1iOO0GIobcynCQyiDr1KcdVOFYHOX5ExI6EHy8ki4HfAN\n    CGPqAB8Ctg7w3MRuTH9TBvpt5LKpk6SrIoJD+3ET0hoF9CSWCZZSbTMesh/vBDupVhaB/RTA1330\n    CYcGB399lshVT+A69MyR4J373W1v69OtEK7p6rMStEHTWJLWBsFrT0CVyUqfJXRMcNoFe+H9ibmO\n    +yC0L981sMcyVI/Qr3LOBvvl/VsSoOlhmPCXbfke69unJX3LnntExlb+LAzZOFtj7U4gfkoR9oSj\n    RN3zOqM7zSqB62QBvSxkmbKx5SSSIYVjGXjaD1nkhkhCp47Sz9AhjV18PeDxCWFAN3EqdAxjx+u+\n    cW0OdJ0yQj/D1yZUToJrENv3dGy5CDsm8/s45ODB7bh0Qnxil1Zis5I4g1O4+8njDEz62mMC9QOk\n    YXRJ2Od7ZY10LywGnhhTSAXc2XT3u4/gDf09dtl1o0+gEhsLHaMOFkyJzU5R/B7iOMbiKkowHhsO\n    KZS7c+D37ND974ObXMb1ijEu9PUgXdgbh6kWzzdBxXtMCl7G+gCfk9iBnScaq56Jy6EGdTtZynuO\n    4RD79S3TX/7H1ymZsk0IoXqIbtmur0QALwJ1lk1XdCcL6EWCCTf7m4PYNnDtU0Raa0kfwcr2mFDt\n    41S+fbbNMZaYcWRlFkl8xgWgfXURp1pEx/yEzjlm33IdY8/HXjc/gR56L7qweja2Aw0dnyVahGiw\n    SnI5Zp8Ftj7erFXr+e5/OSe+3vba+z5PSbq0HPCUqLHzZePvBrzMKlsSFoKseUebcituDKrpddi4\n    voFP1WvbsXKU+5FEUNnO55YRcsXg9TaZSp7k8QSkT5mceZYPE70hgtsqZ/WP/3rNPY6GxtCYOr/W\n    8jk0v7BuJb5rGUvM8jhaKwPw7nviO1/fWD9OodyFjMe+8ZL/LiDkjq6xnGygF4TA98pgCQWDbJ+6\n    XAlHhPnmRTXF2mw8TOZjsk7y8aRdaZZX1Kus97WL/R1LvoaI3lXPNleRWxgTv91XPHSIePDUOPuY\n    uP5YDmBsSck+HIIjuY31fxOm4+F+90tSAF8Fnl33AQwg5qEz5sF03eTx1AHkKrKQDjHQDg3+66he\n    hvucI9vtqtS9glD9Xzup7AYzwjVBZN2U6xqLFLRcBrLcb3M6uB3qpABeGOpaFEkAE262tikHgzt9\n    mIBkyNJyBU2UCUrSN/UFNLmmqwTaeb8hdY0PPkKRawkGr5c3cBofBD50zd8h9O1f160dPhdLevvO\n    Ra6pVSFlI4LYoVrFdp+++65UgW9HjMj+M+jamLxNaP92XanOxZ2nRZtkkeLWy0HtfvXp9DpK0KQA\n    XhTEVcUmiNg64DbZsvvj6qP2PUMYBXTCCzBM1DkXD/0steNoaL5n6wHberK+mUJXDRyn2g2NS74x\n    bFwd3ekYO477kr985zm0P5h+YuYOoW9tltyX/sKJWt37pIZfnc7nxD/2PNhhg23Peb3+TCXid4mQ\n    8TB8rw7EHlLYeBHIrkFkwI56gJ9APZQy+JDTwOtU/YZwOWLdCa4GY+r/6uNL8dA5cZNLjCbMhjSS\n    M7647gMYiblk+Ev3ne8bdK7bBpoxJqvrcmDb0LKrJmC7xzQPbHafvJZMxNi6w4DLKuxOMv3X6hAW\n    aJ0vXUn9uQjUq6wTVLHwKS1zAPU23QOLQt6t48eB1lAgmS3+ZBuuVRiDAlaZEq6rqslVbRHsmzGW\n    VZwVdIzdpE/BbElMbs/9xhK8XVUT9v7xnX8MYm04fdcmhsy1wXCf9XPf9vzbqqHsMW/b+5jRr8WT\n    YHRXgafTZqRN7fnhY+qeUwpgLwYUsHSJNJ5mcCRxjTSOLg4TP9I+Bw1rSd+1YHaQ52YMAcrK4Rz6\n    e09oO9/4b8cqti+2++vDkGXymDE0R63U0ZwoNtdYOmYcjSGn2fLZp/6OuTa+ZXbbuPmYVn/7bK9B\n    65sttBI9N21Dzh7Stjb91XAEbwV05qX2XFMm1XJQDYyHg+90keLGS0C2yzjKds/zdrlx72vW7z+H\n    8j2jctToE5T37TePjG/OEfOcy9FQ4pUcm/URxX3x3ENbMl+F5XPCfLjJ/E2ya75W3JyB/PPrPoCE\n    G4+5soguZjymmo7JZmEdwkp6Cg5Z5yJ+v3Vn2djJYTPZrDvLfARcCFXg71j0ZYirdskCehGo1+PH\n    2Pa+ukgS4CUh89wKjvxyNVWtGtgXuG7UII4YBr0ukdOzKRsgF7WNtLW99G1be4KzITKRa6YD3QCp\n    P2AaVjV1A73d4PHYT1zY4nL8Tx9svb+Y2oz+69Vv9d3XJ79X1vpZ70cHl/W2mTcgjsAybaCq/+7u\n    2Xeve2oSdrb126rX+xRhTzgqCKGbqVkzkxnd+VWGGlmZxtElocqy4KgBOJeBHOjY2HZqhKM7bvgd\n    GTi5Jev0x9b1oP58RCQ87fgYrYNDDCkbO0743Bx8GJMoJP1e1Tjqu3aheUD/efrsssP7t/eJLaNh\n    ldlD5xFSkZcIz6Want296OzPnaLYuow0fTqTa04AHHLzbcfTRPotBvU5P8Xi0d4LJ+leWAKq3QOt\n    +Q66WxZo2zw34uoDDyGGTPY59lW73wXZQAuuS9hibaMtwVugni0u6nMcZLJ2jGAodt1VxKDPRy5/\n    ffAjOjx8LqnJ/jnhinHzB/KUQTAPfA+f67ZyPiTGDjpD6Bso7Tp+PYZM3qfOwyGzumSCI5MgW3t4\n    SvZgyLrZh77Jn29d+HgO/yyxNevsuqs8loTDo9jN2qd8Yaov0z2wJNS5rjQnTwIhSUP12ULKSQGr\n    WxwJ7K8DKNsWnn5C4ECltYLmJX3Bap+6h49/iPANHauvLmEf3eML8B66dmFsEF2OxacsDu1LCNlQ\n    0oB7nzRC9S65D7YuHYJVl/sTB2TfjqZlddJQ//JZ4WPmc+HPVdt/Ui4tBnXVHUdtLWBLDmcA6vM0\n    ji4JQkbpZCn9rHKknFsXApNk3Tq8mbctuyL4iF5BKMLSRwz3lYCwx2JJR7vMN27YcTLO2jhrx4QQ\n    UTvHONpXgsB/HV2N3xjL574x2+eYMTSnCJVhYPC45Ds2Ww86lgDnch6+hAY+d0sO83FxEqF8ZsRz\n    pU0Wu/mhwgRBT2Jx6HuqGlNXaU61BGRVHfV++3CIxwHH5WJjhtbxj+OF1+12CIQdD2NjuVPjtvvW\n    BI7BWEHV3E6adv/ngeWCOev/jsVc5O4SSeKb5rw7Fg8mvGefXc2hpVnd0nCT7QDmhAwCc2ULXVUN\n    gjkGbt+kIbZe7VC22hZdoteHfS1SpvQrX2t4Elh6+5iGsToSa6XTRU3/G+uvJFpZBiYogAX1xfIm\n    e7cZRS7BYn8lt5CqMQRf4DoUPBSFkibQYlQqXcvoPvWnDciG2ofUUTZQ7TvnIVtoVjLH2kIfGrHH\n    YoPZQ/11nCOgVdw+pXCoL0GJvDNG9hEZVgkV2lfZQ4RbYtcGtm39RLlWTZvu+bX7SQrgxcDW8mW6\n    S/+4wGYNoE5OGsvCyj6NumUVSiKwavjpVN+Yyc8SW0PYWkcL2JaZrextjXLf87Hy9GPhs4Pm9tYh\n    wY7zvnHYEpwhHMMYqomBrkOGP8HJXyYA8CegDRHCvIyvaR85nFGinWwTqjldwb5P4bIbot/ka2AT\n    wHwzTD5v2cLnLiP7UJ+FxAAvBlXP98rQbKmm9flJmlMtAVXtE0eYNp7tsglE7dwYcv8LlYi7Kszt\n    hsjYV8xzFeQwMJ9TpsTer6oUYyyWLJBLuBVIk7qE40df5s6xFoef67j2Haz3mSxcmj4c8duPKZMf\n    3zZDyt6QSnifSWl/MKTu3abyLJdlPGmu6XVmSODWyjBZQC8CxdofXIxCClwvC3kWpSQR+oKVlBm0\n    ksNH9taBfivq3Rd0tmrREOkbIoFt7UKf+rSvjp7etz9Y26ew8iuHwgpaF2B1NplT7Cf1NvpH9lNg\n    eJbdF8zuO7YhAp2X8fuSmddVpdszClK4OQI2jGx3zn33mMDam8v9XZp3yKc+B7V3CQFa1VSv0veb\n    RaF2cyU7n+Ifp93ctU+JVMtCkXdKJTTIaB7tt4ku6SlRIQ8SrrasAt9XaNf59VM17YtdLwD9LLSk\n    sj0G+zrkrBBSztrXofGtr9yD3Y+MZ33j6Fh0x7juOBoq++C7Dn2WzzHXxe6Ll9m2PhW2D0V7LnWH\n    0O+73o7EbiBjo69OsO8IQkliofY8hqrEguSksRhk590Z3NAIqRIM9khqTjgeZFV8fMEmRsmW+6hs\n    545ujHUCjEUonmntn6f2I+iL9Q7FcfvW237H2DpPJXFj49/HRupeBZL989Xj8+s+gONEGsgTbgau\n    0r5h7kFpzprB+0wSxvRl+ztcRlv8MdusPiBuotFHCNtJaBmxTahv+VsmyD5lbyzyJAFeBKq1Jt+C\n    7Xa/1Yh8me6BJaHOdI3fjALBgLbfE1gVUdOmuUtYKVJDBxML1bP925eswuomF2Dn+3FFPXXvZb+y\n    1Addr88XNO63l1TX1BO45UDtvsTuHHUKfdfFp5oOtesmB/iVvbXnmln0kQ4AsA2Q/LItE8FDyvBm\n    mb4nC9OH/gS4+7BG+Dj588GfJ0tkFMmqcFGQKZFNmuu0o3UZalTJAnpRyIqik8Tidwzo1kRt+4Cu\n    oRqqac/rATeuZqiD8/pyRyzL81GOQfoIJdDm0Mk4Pnt/aecbB31jsm9MCFstd/czBYeq9+vbNjRG\n    Dp2v9Nenig5ZZPuU1xUyVNXwuVRwJGtoHOV9ateLrJ3z+ZIB7LyS5wmSmOXfQh8PJxrK0WbJSWMx\n    qEYmFquEghzIi3QvLAF15Z9H6bujVsub5GC/s92QQIKVuVcFHzm7xWGtosfETWPjqmt047WHKOs3\n    NVY9d63goRj8sQq/jgF3DnRtnl33iUUglYQdhUQAW3yB23sTHbIO8Oke1zTGxnkKabsv0Tt1EJqT\n    EA5hHzLYKn7n3I/ATnx8+yoDbULHFTshHQJvFzthDU2a812gKPSVS9QsHTvLEdmZCceLvK0BPL4O\n    cJkC14tClvtVSX4FibOw5CCe3abeBaMFvmB3nyqGA4nytw1Qh9QmXHe4eVzZWnb9No32mO2yUD3A\n    ECkasnzk7UNE6RTL6L72Q3V/Q3ULLYlt92fNTPuUYdzGdyS+moc1rHWqfo/076btavc370/65OMG\n    nHWqC2T7VUpWZTXmfWmPOymAl4XKVXSNqxu9Q3LSWBaMAs1WMgyNkwW0NbAPlpjjZ/NQLXR+ZlUR\n    z2Ru22dJ7FMf9/Vrie6QOrirrM06JGjfPmLJ5SH0jb01+onivrHfnlfMcfYde8j22Tcfybzj4bBr\n    Rzdxr8HKs42M1z6XD6A7hgp4fG+uTa7G/c5sMyVSLQr16/7Rs29ttklzqqWgrirlPMdxKJvgZMsh\n    yG9fmwrDsY6+9b643diybTFq4AJ1G4ccUvkC3VjgUGwwFK+8KgtmX2z2cuTrEK6LgB3iAnzHNVcZ\n    yISbQQLfFjzc/zOYBvNDYt9MjLsR28fs47baC1z1IGWzoGL3bwnh0KDMA3rM4D4WvslQqM9D1vjl\n    OsP7QNdfahBD6Jae7ez2NjgSmtByHWDuq/Ks520kOzPhZiPbBSuHgoc+1IkAXhTqIldBScA9o2yA\n    TlDAEWChWoayjdQ+5OAgB3KdOkoHKGOC1aE6r3118mpkJkDgq0UY7kfbQerlsTVy+86pD3nEz9i+\n    tYVluEaf79xCdpFDgWxHgHTVu772so3P4jtsMa7vMa4z6KvT63ufmeTQ9qJOeSy1DjNq485H389N\n    rbqxYaOEo8buZhozKtYAqvMaqaLGcpDluRoTQ2pgm5TC6kvAPbu0WlcTYH3qzObvrLXlldc+2//S\n    04eM56EEF54rsLW1PGNDytTQOBpWu4YTpoDpY13szz59hxA+t7Dlc2gc7bN97itrIfdlKCnPkior\n    6PuE76sqsC+fK4f054hisY3ukvYF9RWqB5yt0zi6GNRA/boaaOIz19+tO00x48WgTaizKVRhNBb2\n    DWqzXPri1zEiDNumcQmahn2dCm18cKjcXR9WndfjJ6ExMd1DKIHnxjEodq/SRXQMbis/c9Px9LoP\n    YH+kwTxB45Aq4BhMeUgPDS6HyAC6KbULZHKwr3X02DrAFiWGSV3f5G2fer5jkLfn5+CbFFui1lni\n    uMqdfduHiWK3PgOSAnghyE6nB0+q8wp1mSaHi8HJiqix5rfYLTuyE7s1XZUQoyW54ALJ8rfPHhjQ\n    sz2fuaRVC9W745NgJQeEC0//clwh5QnDV9PPHqM931AfQwrcUOBZwv31jD8ZsmCAO2x5PXweVee9\n    yjrvX+h6SJDYe10rN5YPkcNV4H7kEY+3kfG+RG62dcSLXt6tyckEdr1TK8n+u8drzjERwMtCpedX\n    QLf+bx3aLo2ji0ERqEEphJhVRYbSppyiUyeaOHTVpM7Zwq1bYZjI7CNsm2OgZ6Jn6j923MjQJft8\n    BKA9P/9+u/vjnznHT0fCZ8FxG9DjOwLHF3q/Q7DzEN/75bumjf1zf3KcTaCzY7rMsRxh3J1TdeeA\n    9j3XTh7chpMetPV0n7p897nYpHF0Kai3Neptf7J6H4qzFDNeDMpwjEnuhabgkCtt5msD+OOBffcT\n    iyFyNPHBhlzuj7ntA3mKlb1tmn31Eckxscw+DIl3rkohfKw4hP3zsZC/fVzKiwn9TdnmmPDFdR/A\n    7cYyBvPbatl81RiTqXKVpPGSMba2QgyZG6PwHdPfWNjJ06HqgpQDv2Mnm33LYuxupN0YZIkAXgSK\n    0y7JFkLnHa+B+jzdB0tBtg5/bfQFUyUQ2GffvOtZqZ98FsJOjSuKKa2G8gU2+1ShHZUIMtRVN2DO\n    28r52MCnr7/Q9bFwgdFwPUBrD7lP/d7Y4+urd9gNaIdVWCHL5yHw+2fvOf9xyrr+ALYclSZEwmpl\n    TdJ2VWg+8pbrZvqsLbnf7v5pv4kAXha2XfLXBy8R/Oqqq88lHAyrAlnmyF6r+I0hOcUS2jcmsMKJ\n    nQ24dmuNrGPLy9tKn/bZFHLb4LE8dMyCov3ukfW2812LDH3kqD95aah+7xTb51hw2YaQzbMdR/1j\n    aTbpGH0lJ/TVdNc5M+/1kFPKqt1H88OK35r2wGNt0W4T/l4RM1/sQ2Y+R4kAXg7ql9PHwRpAdjfd\n    C4tB2dwLPkWvIG9/D5O5dpm2yu+SyNznEKEaQ9qOgXUaDPXRRwRPVRsXvVd8foScI23sN9aJ0hKw\n    Q86XU50xx+CmCLKOATHOsgm3AjeLAP78ug/ghuCmZ4WEcIgsnrkHjrGEreBi4PUhYMndy551U+Gb\n    uMkXX5lA2UlYX92NEHwTuCEy19o6N1mIsrzuTGzZ/rlQ6t941LtthrYrk2JlGTgp1DAbVCkFMGTX\n    lXBzkK+K1qI5ZPkcCs2xuimjYCbbQ6Jd5uBqH/oVnH3Wf7xfu50cbcgm0gZOQ8oZe9ySEd4XpPbZ\n    QnOfYwnefQLYU7fts3ruO0fXpr9fdz113eRcN+4lchm+e6NU9K3/PpB7T9pUbaBc25qKol369NW+\n    ZntL/u3gjiEDgJN9DNwSjg31pXvSjaoBDKB8lcbRxSDLkJ/pyuM+ElieKVZx6YhE7QYB04cd22y9\n    9QrAdpc8w2piWzJBfofvWX8SC2hbTcY69I13MeOob9y+jnE0dvuq87qf9A2NozweVj39CnyOInxQ\n    vpIJvtfiqMLHIS4wvmN0Z6KdMNgC3betc4XxzzNlibQrIepr3TYHkG/SOLoUVAOJUPYZZe+ZPCmA\n    F4O6dN8e+2ZWLjmU1+ntrEtEX8m1sSILxhyl4SwkDrlPrHEIV23TfBX7szHq88Dfc2FK/d9jwr6i\n    uGQVnTAz0mCe0MV120D3ITQInKDuHXTmGpCmZjNd9rz2qXB5P6uIv48NUzPnDjHBiyWH+/YdQ9oO\n    hRhdnRTsfnezItsJeZ0ClotANu1Lc6s8ScqlxSBf550Qm644qJeLJSDgs2/0EW4+1SXaZXUnoOm2\n    8tXE47YceO5V/lQ2WB1nB60D9ZoIHmMLHToH37bdYLcOjPfXLWza9SmjQscVQoiEtbaYMefqs6vc\n    vT3telajVUbRJtjugsN87HZ/jpgNqXHDdTR1koBfuS59y2tOWMjQc2+fpcD1orC1wcphtAHKl2k+\n    tSicrQHzLBDYZUyW9akfbR9CDFekvAT10LWQ7m7PCFkwD42jvuOM7geg0cOfNIWJ45Vs7xtHh8bP\n    2LE09J0rZnwf2k7mGUyo9qmzef5jE+h4uxX0HMjtq5/klSvhS5qT5ZW6H/X97yy09bGzitruw+7b\n    fgYqZKgTAbwYyPfJLpUnf2c9TwMAd5ICeDHYdudEXUKY141zuwtZR1tyuDK/6/YYatXORkIOESsE\n    /MIUsajuax8D3zHL9ivUKhYccmoMtVkCDlGucSquwjZ6blL3zhFzAhbJuffaMT4w/SC9aQnXgH0f\n    xlMHlqlZRVeh4B0LntiMsYEe6o9h7U3kdb6bRM05aZujr1gFbzVxXR9qz2uxZ83LRPwtBdkeWdNJ\n    ubQgFAUyip+w/bIN0DGsjW7WWZ4pEo6Dqo3NJdrtOXC5NaQvAFzSnNAGLEtPkJQVwiFFSsgOmgOa\n    7ojjbY5trTxGDKnbhz7byyFlVCjAjYHtfUuHaihbsp2D233ntq10UDtUnzJESm9bgsQdO7fjMGIF\n    n75O3munUfKp0q2CK+v8372/5B5KyqVlob6svHOmZt7UPDV8s7kaQJ0I4EUhu7NqE0bKjk9Fn0sA\n    j1nN/+XuGVQZxaRvrOV1YgNt66oq9aTn7y3846h16PDV3/WdC9CfwMUIjSeh5X1jaB+Gxs/YZKkp\n    42is3TMTpjwGVb3nqQnSssqC6+UcVujOq3zOH3ZOZMdF2Wdu9qbnQS4pQdoVtLzeqY0rde4uQUI+\n    B1yGIUvj6GJQvgiPgzGRkFQDeDmoTA1gH7lr75Zuwoqf5PVhSkSrT7zhK+0mZC3QJXLH7sv31Jsr\n    KjdVvLOv6CfkUDk1Xj3V8fKmY4wgLil3rwaJUB6NNJhfFZ4dsO+blPVx7Dh2G4kYTCF351IT+0hh\n    36TpUNl7DnGTRFH2TgkPhshjnkj7bKJjzjxZQC8HU22zMtR71WxKOD7km5VSDvkCzC4LX9cdhGkr\n    6ypkyo7XBgwvd7aDEtDj4J6/Lm63fp2vTSgAa8uX++ygfSrlTj/QBGW4bTdI7e8viw6Uj0VsYFxf\n    035L6z5Vku+cxHqt164SXcI0dE1k+Uq1z5WSLUzWd+s1huoISz8rtbZ7Ldw+uwpnH0Wcn6bA9ZJQ\n    b7sOKs7M17+sJVHSOLooZKfrTsIUE3r17ulSKXvdzEvo2Wc329Yz+mzyQ1bLrACVY2USr08lXFXw\n    EoX6eNzyWFLV97zWM4p+VTD3NXbci4EvsamP7I05bmv37K9b6bf8tscUAyHOeV+rTh+ZSqTyJVCF\n    7KH5vNzfei7nm8MJrEqet+nMF06S6nMp6Ps+GZN0mRTAC8JOZFABKnmuL/LUfL8Ix8umptnZuzLW\n    ElrQF0/k2N92xHZjXQznUuPO6ew41TFyqijoUPHzIQfPvv2KeOx1z7pDw0cYJ2I4YSoeznPvJALY\n    hy+u+wAIV1Ww29YNPlYb6L4H9qHJW9v/OS2fYjE9dZCVgXzIRtrCN9m5LhvpsaHZ0NcOsWZx6mJ9\n    PjxpnPLVhbeXv8O2ZLJ+WFlsbW861jtJAbwY5HemjbM5knJpacjvNE8+Vipayz7fTwMd0LMEmxhM\n    23p0IRVL3umTlcRalSTBy9KoksJ1WrPOcdhjCQWcfEpgSwRPsX8MvieYPhOO2TbvjEn+Y3QERtju\n    ma9x97zDtaVBS4WgzxEO81sVUu5p77Nqbu7LfBdUao5pBR1wLndXRJaVcBarrMarzJnamp7u/vBb\n    X8pnLWEh2NYQhxQmeH3qcsAFNTMgJVItDLYGcLvcjJH2/mgI1tyMWvr5Ve2eTzZByo6tPrWwrTcM\n    sx95tR0Yo0J2+7wvOe4+l4jQcraFDhM/VzeOzrF9qD92xbBWyaEztOSpJaEzZO2khOdMQDgBj9vK\n    yFTu+uUEvtLsm+3Lee7A9xr3z0p27teO33z+ocSIGhmylEi1GOybCJVqAC8Il8290C0u5Khg/u7S\n    jWjFxQ6H4maCKXfmVFJ43/0cejYZIpPniteOJYanxqrnUgj3OXjGxN6viui9SrzYv4tbgc+v+wBG\n    4rOr21UazJeKGEL3WLHPw/o66gDHYuwgOne93/WEbfpqVkxZtj/qwb5DpO/cE0yBtdGUjErevqJj\n    5234rFjJUm9TwHIpyO7qAMqYsFr1It0HS0J2/8RLVu3WdiwkO9ujCRDquoYNmgCnqxkL6sdnrSwK\n    oqwT7IR6zajaoKO/fl0bBK26xxECBzmtFXZm9jniSqNPpdx3HOPqF8ajjjimvqC9TxnV7T/02r07\n    8t4FFdweYsR3LNzerxLvEhm5p61NOrAkdrULoHM7H83t1Eu7++fOyaj3J+G4UV/0z8XqnuX18zSO\n    Lgn52crzDPDbQMsrTfy5MYbHX1efMKckGK2O1LXq3d9M/Opx1D3zOBHGlxQlx9QqhyunJmXY53K3\n    zqJWrvaNV/3jWJggDo3HU8bRKeraMTNpeX/slj6Vb/faWneW/iQDWe5XGXfHXl9SXGb+du9GN/nP\n    3lt2fOX70tU7djbQ0jN/itQYfG8z4t1JOGZUXzSRE79ni/+1K7MA5HdTMsBSUF5KOpSGL+bXV2JD\n    MBQriy23po5x99vWDfbN9qT/PuJ3X1K4MPuwV2SFelIs1BfflX0MOTpOJWcF8i3pEvEx56mW0Utw\n    2ByL6xTOHcJ5NjnOLgbLIYCP2f/7kPbPNxVLzMiZA4dQ5PIkZaguxhykbW0mSVMnXWzVXHrW7dP3\n    WIsZRglnI+avyxXux1oWdq/drk0igBeD/EG89twGjcov0n2wJOT3N6amXdeOT8ABuQIu2CxKX59l\n    oSyTer2yPYf3KviJvcoTFFTH3tmXUxMx+u72kB107Vlu4YLu7tk7rL711yM8NOz+aoSpcD7/2H5D\n    ltqArZBrtq+6VqY+q+kmyKz3K2oiG8D2afGYYPFfc00Ei7pc+pd73iYs2HuT63na5IH8dErKW8Kx\n    orqs0UmUox/f67ZGXXLSWBSyuyfq885jDo8p7BqQ97QRyDNO+nOKSk3qOfeOrksC9yV0SZdE1PCN\n    o5Z8reCfH9jz4eOOHeu6biN6P6yEvs5xNKa+r8/uOTSf4PZdRxV7lem4Kv974FS6utQGj3W8jy6d\n    1j2/Go1DRkljMNuU8/XheWFB5yDH5kud4vln5rnfirspkWopqD7vj/D0faKLFZCdJgvopSC7DMcW\n    bG3fPsvnfPfk9LnlMfjOCcXIujWHh530+uKE14Wp8ck+ItjiMAKb47N/3gf1ER7ToRBDzF6Vo2wM\n    jslp95ZiOQTw3DhmQtmHq8rKOAYb6KuGb2CLyYCKzZLiQd/3VWuK4vgQkwNf/YwtwqT1PmQ272sM\n    MQtMr0PSt+0QYcx/uz7qQFsJ+DSTZplAq+NIBPBiIFnTU8Jl1Rdb1DdrKEroQX7vpEP4SpDOBVq1\n    va2ubNkli3VNQab/stZ+l59r0p4DiDbw11WPdl9ZFVQnyNoGSbuB7Jhgbh0IVrICS67fWCVRX/C6\n    ivyZ0jefG1s9Dyl/Q8fpI367wW6/KleOI6Qq9hEOjYWztnuWY3HvJ6/vqomtCi6DVueV6rNgCW1n\n    g2ktN23yQHEnEcCLQQ3gvGrnSY7krYM/TAJXz0qgSgPpUpDf39ATIVO2uZxY1XW+yFo1G+Cer2LT\n    a21y/eSdft44wrH7/AtZQdemX9ciPI7mnT7c/MDvKNLtP8ZhYtgaur8vOeQxP/4+4t1Dhuye9ZXr\n    r3cq17k7/un5SqicRdXTf7eGM9eg7k8ACDnC8H3IyVz2aee7Djy/1K4plEiVnDSWgW2F6rn+tI0a\n    ER+ukKWQ8WKQXW5V4hyTuLrMTwP97HN3DseubBwsR61IOF8fMSTv2GiYrWjcl7Ywh1W0jY2uMF8M\n    1vctxsZWh0jbfdwkYwjhc8/fErfuI4ZjSOO5nDstkghtPzy47gMgHCtf9+BIj2uHmzea3zQ/79uM\n    VzP3t2lDPtM+VK/RX0tgDPa1gY4dhMcM1lPrAPvgm7ys2slUvXvdv82YCRDbnQwdo7VGmYMq9dX4\n    yFF7AhQ+Irh/PaAnyRW1bAJUNb3eWe1sk2JlKcjvj/uKwUGs6lWV7oUFwdnphYOT8pqJMkvaavIW\n    naAdaHsJXLOqSX7n1G8fiRoKdoYCnf4v3NlA0DisbrX2jXJ9fAHkMSTwIX4G74GB6xCye9bkbH8Q\n    210Heq8qrVizR8V/l8gUscF9bum+lGMRRTYr8koVXHbnItty8Fr2y3WQfe+/3OdMxrCirv19sgI2\n    iQBeCuqyRr118yQhefstZd03hep1hfo8jaNLgYyjOqlEOynwmGZtfwVCHPN3GU7OgdmGiWNeUlFC\n    Eh8Dh8llO586NzRuWBcE7qMPPktoO74O9eOzQ0ZPv1c9jobO22f3zIkAtee96D9PY/JcdRMFpD9A\n    3yt2X4Ceu8lvHktZReyzcbYJgfp+yzpjJtfzbV51t/Ol+OUAkGXIzhIBvARUz5qIydSQdP4w2T8v\n    CdVlqbxUmvm1HxIfy9rfjuC1v3kb7Yjh1MIacXekjaKMifuxQnhf98DQ8QDDMc/Y2PU+xzZGwTsm\n    vnwId8p9cShy+KoxVM/XlvBM9X8Pj/tHeL/PjJtHACdcL66qlvCh6gDHYKqVxVyD0T6k76WnH+7v\n    kHWA94FM0HyTszLQNvTah1jL51A2Yldd7DIlZfIbgq2zMmSrUyPVAF4SVndzIBsOpnlRA1WqX7gY\n    5HdPIDbMLkyoFb+svrHEL6t9cmqrg48ueG1rDOa0T0HpCTJatZOtQ+i7k302ivYhZwO7vhqIvkB1\n    CLoe4zh76OB7FPnTBxuIdTbQ41RVtpajz6ozrPyl46m6yQF9RDS/L1oZ5pB52lbq/WCbZlF8Z507\n    iY/M1rZmkpi3k89EbY5Drk3xxumIdzzh6PG6GQOF/LWWvAxdnoNI4GeHMs1LuGqs7qxR57l6HgA6\n    AaVWYxfUGCsJUdbpwhK9pXlayfhZwhF23McWjqST16HnbK32pJ+X9hlfVwPPd3RVwL7SCj4Mrcto\n    /OqzirbbHaL+r+3fjvtDx5arbf2lCXzkc91ppa8zJ0b5YPcVmgfYOtOr3bFyQha7cOgyIjyj1MSy\n    LJPt+a62nyFFGJ+tka2T7e8SUD4b/z2S51dFIoAXhfq8uR/kuyhrZnN60gtYuMCw8SxfiTO/Q153\n    ncTSYi2dx9QV5raxM0G2lx6CFcjE7iuWsF1NOH6GT7TEqT2xcedU/zch4frwcL7PUY7PrvtsjhRL\n    8CdPWSJdTCWWpw5esYM7Z4bNlW/Lk4Qp2VuyzdBko88Geswx+taNmYBZhLLo7KSxQBwRXEWsr8zf\n    TVCin+yV3xkRyfk2BSsXg5MCq800RUOGGlWqA7wY5HdOWmWIVSZpOLUGoAObNTJsjb6TiTJpZ20x\n    ZRtpV3pCr906sOFAJf/N9WE7qpLOw8+nCh0OVPuIT581tLVNnDPwHAN+XznwGlO7kK+JVfzyZeRw\n    71iFmK2HGbIp1dsIndao5SQUyNeS72kmHioKQtdw71VJ97gEuAt1FFpBbI/b9d3cf0wl5482SFgO\n    qgvnk2KJ35CdrCWBt0/TOLoYrAoUd5t0ViG73BjYdQgAuipeVkhWu2eQcxlwfbJVr4AJUetaIeBx\n    0NYb7tpD62X8TA2No75asT5LaJ0QMa42MO/LjmnTiprE7y9m3PaN+6F5wdC+/D4sZhm9B3qMQ+cY\n    dIkPty+tCu6OmfIe5eo4bEIVu6zoRD3eh89Bwx1bl9S3V2D1IKl/l4Ly8+kxhQxA9iARwEtBXdWo\n    y2YUaxPkAm1ZtduQxXUbrwq1d3Mxfy1h+e1mZHG1b6Vk2lwIfSL2UeCK/XNMH0OfyKG46gp1b4x5\n    aj3fJUDu7FDMf26H0uvEoUuAPrvuE0w4BJIC+CbAFu5OH8ar9+8/H7lcMNUqug9DA/4+Vh1DEwZf\n    HeBYyMRNagfH7mNM3wybRciTTh+xLBOGMrJ/mH5tb/y7ayNdByfQQGPPk7Ac5PTleegToxMNknJp\n    ScjvnCBfWcs+p5DUQTgdkObAnSZnXbCb2xbUL9sHAjqYWACo1Fww26l+3DG2x28Ck1yLlRUwNtju\n    C63GWkLb4Hso4Ms/Q3UGuQ5xPcMP7z0UXLefa/vTZ385RnXV2a7qBqX5OqzQTTDwW0O699gpfTVZ\n    EkLIDpOXcV1nq97jIHeNvBMwz8w+1kkBvCjUrxqKhcnfeuBTKRASuPwsjaNLQvF4Q8SV//lYozsC\n    dRW2GZGtWau45ISSwmzD7giynxySGOPaNM9WeI+Bx1Gr1LXjFc8JKk8/sS4ZjD5b6PjIkBv3wmNj\n    /3H5xlLfGOgb031jP/dtr1NojO3WSfYcd4XQGpVMV3Xuk67Km5Xj/JvVuHxMBbrkse/68ueggCOJ\n    /UR5d7+dRIXHaRxdCipDAI+NEuWJAF4MsrK5F/jpYWNc/KqvVjugiV1W8A4X3djPmW8MOKLWdRrU\n    /a96th87i/TFY2P7iKn/O3Z9TLsxMWRfDDxGJewTVfmWhco27uO4OcQfnCa18kFxVTV7P7/uEz1u\n    LIsAPtZC0FeFoSyQq7JvvgoM1fIdMzhMVfdOtcIQXEVNhX1qPEypAzwE3yTMYf/aHH1q3hpdq+YY\n    YjdHTcqkGjaLMbSdha3/kUPsoW2wEqguU7ByScgfj/ukKLXJF+leWAqyVYHsjVOwhsbWdxNi0qdi\n    4ZqG1i4QcM9jn6LDp1CySlyrQkF7lFpBNNSXPa66ig8s+9qEahf2KZR9NsxuHzosH/pR711kO99x\n    DJ2fXZ/3bG/rR4ehkwn0e+tr3T3GGq6AAavM7Tlm3mvtjrHc6QjkvZS+CjgFn3s/Nf1sA/vu+LpG\n    lq3a+o0zJCwIF6Uif7OBOWLHUQVA9afbrIdYHvLHpyrpQz9/cnoiyG/3bOo+WbqKy6bPvO3bqnPl\n    uSVjLpOA3H5rnln8nPWNDUwS8nkBbhwdUt/W6I5MlsDWhHO3P28yUc9+Q2NjiOgdM5aWI8jl2HMM\n    zUd87ew4ymOpfn/t7y5h61N/8zGXyNvkAZmTldSbTb7isVp6lT4q2GrW/G41v60i2I3HGYq37iJh\n    GdhOTICqdz+rZAG9GNRbXQ+aFb7yeyjOJcjbO8SPKriNdUcYF/ebShTLp+AqStsxYuv/+rBCHRXL\n    HaMGnuLtMHUGHRtjP9Z0IyaEr1s5nJxdE2bC9RHAt6DA8o3D3A+WoSyavvWvcHUqX59ZYGx2kkWI\n    eN6X7A0NvEMWIHOgQL3X5AXwq2rl68TUSVcfUcwTwQL9NYUFFboTyNLTZ2ji2VWe9NtI8wSbg5U1\n    ALxOpN+SkD+aUn27QflpuheWhPyde20AWgJvxe61DQ47m1xdl1CCezXyTnCvpGU+wqxSwVNrx4y2\n    JQc5rc1zey5Aa51p6+pxoBwAKk8kwBKF3K8vgNunjg2pgu3+xthfxpC8PtQ958TH4VMkcT1Dexy+\n    I/EFsltCtepvs4IORtt98jpbh5DtK3nbDDoxTLfjcHRutusS1pZAYBKHj1mTNxmyN+6MfMcSjhnV\n    yypI/tbmh6ES9j5LBPCSULxxasooOFKRn3dcwdTV/dXEHGh7+Vsg5KMbczOVLMUlDEJEavOMl/66\n    42gGV7LBl1zFZKKMoz6isgtbc905LXQt07vjUSjhJy4ByZ3bmKQphm+8HiKX+/roUzjXPUdW04Wy\n    amIufRB2/7AJaBl0ZV031nE9YUs+u39uWdW5qjoxkGdEmaetva48VudvJAJ4EahqVJ+OG/+4/m++\n    yZDfSbWgl4K6dDEFO5/qS66zMa0KaOuUZ3Cuen0l0jjuldM27NDHy+2+Y0u2DSGm/Jx/v/H76hPR\n    WIydnQ7FlMf0t298N+H4cMxOsXOWWL3tws+p+HRpCuBjwoPd70N7sw9hadkiV239fJXoG4QPYSUt\n    k5M+5e++xPVcVs/5iElpPjAR9WHIskYTwQ6i4JXJLJPIbIyW0/KQ+kod60UKVi4JTgE8lkraKZfq\n    5T73bhvWb93pkJWC5ou0tvHLKWjn6qfmnQCiBAO5dmBNQT8OVorSxO2z2Q+3aayhnWqTUUEHS21Q\n    nOGIO3eOFjZo3we2bw4Hcu2VscFfF0odG9C2+2IbUvk31lIzh5/IDp1XqF9FRrQDjVOUsSLStdf9\n    yzpNVDAhIuoiR1Rnpj+5D1mhx8cifcu5FuoYtDqeyZouVeMh/89WKO6mGsBLwuXL5s6N/cbq+yRX\n    z0pgO2xKmHAzULx1Dz43BCa9RA1snxHchp9R1e7ZlkGUwu45pn05AGdJr8HjC49RFfxaTOvCgc52\n    DD0GdInFcJ3czLPMqlkZoX75Z44x1B5P1h6PdjyJIY55fI9N9rKJanadHUd9bTiJjffv249VilvK\n    xWf1bI/AOsLwa63i7dYm1vvmOaKbx2XIgCxD8Tg5aSwB1atqV0Yh7huobVM8XgPFtM92wvGhvhQL\n    aPfkceNM3a7jmrvi4aMd60J/Qy0PlWgLxTX7Ug04Vsel3EroxFNn89wPSzTHiEX2Acc9ryvK17ff\n    fe2frwJD+x1yCF0SrptjSrixuJkE8OfXfQBHjPQw6MdVDAxjyNqpxO7QxGEscXsZ+HsqbLYcZ9OV\n    2M/mOQQ/2dvsz9YD5klkCW33PNSnEL1TJocyGXbWz2JP7WpXZqhRXaQawEtC8Wi6fVb5skJ9ngLX\n    S8Fqp04UUlJ8AzJkSm1kA6rWGhro2u9myDpBQ18NXYGtRbyCJu04ENlkeGv1Um7+bvYHr4qoQtYG\n    U32B6r6AbR+J6gtM+8jUmE9QuKJovwXl0Exazm1LwX197iH4FdIx16imffnqP/a9DimNrSq8Nvcb\n    /y3kiz4e27MLOAsRzOSN07JzQoNbn8HZSLc26O8l1dLi8Hy7u7fCdep4GS9v7Q0roPw8uWksBcXD\n    U9Rr8c7QRBagnzfsEGATUyxBaslhJnpt4hFb8soW/Czl49HP+1z1M/R85+d3jQxVNaxotehTuHZL\n    43Rr5vaRqT7Ceco4GnMOlriOuQZ9qt8hEr30jNm6ZIG7htYdpWmj6wN377MGLlHPXfsSeevUkcES\n    ufoYst2+LF3M9ybPE9mBpjLXNANQPDhBfjrduSjheFB9pguWja7/+6Vk/7wkNARwV/k7NI40Y6Au\n    XSZzsoaQbdDnpOdbH0Loe1Hf9nI8YyNoThDTRdnTPgYF6mDMMzZWOxSXteu537mI5ph4ta80oiVs\n    T1B7lyFi2b64ShFZTNnNIZHekkp3JuyHh/PeCzeTAE64OdjXL7/vYT0nmRs7+NhlMYPdVPQN6HMg\n    hoSdGi7bN8xWBCaQxcB6IZf3ocuGJqdMFgsZ7LPRqak9t2m+qPv7bGnzZAG9KOT3V8hpuB365Nn6\n    O9s/pfthKcgfnSFb5XABWW1v64g7G7DjYHY3dMioSEfDxJ1VGDEh6QMrg0H7DtcOzFqFKK+Xmnb1\n    jgTufz6HA9UhW+ihAHVfwDmf4cdi6LhYPRuyrg6dTd6zr3ZZtQvimrGQCfJsNyLV1KejUxpIAJrf\n    GX5fRSXONR19tpKOeOkmKrhahQ0xwvWe+b1jJR8fTaWuXYbVu4kAXhrqL0pF/vZXnXNt3N+7oODT\n    NI4uBdmqwPotVwfYJZ/oOrPW7rYhyVw7pzBlO90uqSnjmk4qysm9QI+3vG1YBawTtVxNRj2OCsSZ\n    A9AlFXzjTDi60zUCtuOjtYe2+wntb+6xNJYoDtlX9xPDWbDH1q606i9DYZ1Q2AbcKcHrlmi2740u\n    AdLAZxHOJK3YmPO4ad1Y3L3ojq827zs7o3AJErnWKZFqObj8YxNNmhpBKt5IiQBLgtQApiVtkq+3\n    PUw5jZ6+QyIKdsEre9ozxpC4oXimjQ0OYS7XQh/2EeaM6d9udwgHyblxlZ5NfbzEUOnK68Q+jq53\n    j/i8Ehp8drW7Wx4BPKcf+DF7i4/xdz8WG+hjebD6iN2YwWcqsTtXFhMP6jyRiJlUxE485iaZGWMz\n    8oqIieFctSt8tU1CimLbbngbpxpu1Sie7Wpef1HqwlMJNxr5KgPuT8uizlBjm+oXLgbZeoXijY0J\n    aHaDc4Am0NgStwkyW+PCpg1b9ArhVsHVbAW0RTQTaBw4Z0Wv258sc335CVCtImKUcEHm0PZyPrHq\n    Jj4uJhD76/2Nrwk8tN9Qf3wsTPz6jiukMA5ZPncC1FVX9awVTXkwoM3XxaeotiFzJlBY8bvavX/+\n    oL22gWYlvGALlyCh6RvXLx8TK5nyt+/t/X4mHBe2z9zsccyMzyqBy88SAbwkFO/eVRRYRU+LLvnb\n    fR7xM0aXT+i6arAVsR0zbWIMt8nNfkNErYyVfM/Ks1q7a7jnpSUV+9SsIZWu7wnN409sotMc4Lq6\n    vrHDns/YfbNFdGi9nH9ZZW3de18bS9Bb8reCTlaSBDgAgfvQXzrB7r/cjY2cUMX3LH8CeJ7HBYls\n    IlUNPZZnAIq3EwG8FJQj6/8CLlE9w84COmExqC/lfqjViMN/ScxKixe4Lm7/TMxHJg/VFw7Fz0IO\n    fu5Y+jGlRjDvI+RoCMwjkrmEi71e9Qz1Yv8uWsxtCT2lPxaGLblkZEI/klPwIJZHAM+JL677AG4B\n    +kjhfdXDwHTy9apqG1wE/p4bIfKY6wCP/YqwHVgmk6R9SVqp88G1fcciZOVs++NjzdVkt79PmRCz\n    4ioz29f0A3SzKHlynMHVaUlYBorHQouMQw6g/lMigJeE4skDiOLR1ZBzNHBtgnXoLLcBaFvPL6x2\n    FbAyiam2mr7u23aAWCK6fdj+VxDlKCvZNTGLKr6mbYXhYDAC2/nUQL6guCVwx/7Eqpp874lPOTsE\n    q8Tu3F+BfZWe8LcEq/NA2wqiJub3MVPqX+4zB3DZ3rdolbtyneWsnUKq6dOpoLo6YiE8Cmhqp3Nf\n    nBQovpQC14tCWaN60czU7ExMkubsT23atF2lRKpFoUn2cGOjHj+7Dgt2HAWa8YzrzgI+IlknSDXP\n    9a6FtCh3BZYoZoKxMsfE28jz1gdJnsqaxl7Cd8xYot0buutC43SIjN3nB2i+i8aO1Z37AeE5QR3Y\n    ziZnMVae/UkCF8y+3FzKXU1uK++ZlNmw85oK+e5ebBKg2K3FKbN14pq+g5hctuR+d4Yh8092nWE3\n    muKd+9H3UMJxo/zjHuNelgjgxeF8237Lk5iUz8nOt8yuR9uLW2YdJELxN0ZByzgu1xc/9BHCTV+6\n    /m9fnd8p5ehsZG6FGtuRfYU+kYcojxez3z74hEE+VfHUGPYhrJ59WBohfJUlP8eIDm867i/sPglg\n    GgH84HZcnBuLpdUBPrQN9L5k7znmG8DsAHqTwlVT1MNDk50xFGhoMtjsp0GuJn7dZfJalvFklpc3\n    hDTMdtrmxtc34L7ONxPkriJYprxVIoAXheKt6UY82z/cpCdBwhDWX34EVifZeqlsQ8k2jYAmxjiw\n    LYQcB7EtGSzrm/pyohh2tebcF2an5GwChW6fHEAV60BWKIH6sOSxnJM09tlNhkjSmBp/fSRyn3Xl\n    VUKrvPvtLe35hM6hfd+r9tKqPiwZXqNLjgtKiEVqt6YvXy+5R5hsZlK2ec9YTe6SHbjfsr1fc0VG\n    aEovb4/Z6oIlkJ0hw/rtM2QnIeok4SaiflUiq7q1f5nstcl1jgLUKD+9BOplfT+6zcjfvAvk3Rr3\n    QrBZq3lL5vJzhMdLS6JqVWrzo9WhdrzSjhtdgjHzPoPFI6ak5SWRgdo6uD04+OjbPrLTgs+t60Jy\n    fZ+XmLF72OpZ3pHuOet90XWo/N/veB7lm/PwPeYUwXq8E5W3S1fQSWRckoH7KQBl/+zG5dzch1ZF\n    nKl98ZyQ5yHcR353hdXjsyt7nxMOh/qiQkWlD4Y+zZlpk90tkN9Jc6oloTq/DN4HPptneS751uvv\n    fC5W1jxPHRHLpdNkGcwyDCyLjRf2CUUcOTz/uCbjt/Q9FBOd05kx5ApZB5aPxZQYt6/Wrw9Xaf98\n    UzHGyfW2kLXH7NJ7A3C40NfTAx/5TZR3H8OHcqig+LHYRffhUFk8MQNcLFlsqZ45COI16r0G89WE\n    CZUPW7Ntsct+C7Xrm4xZU1yrGi68xzzcLxCaQIbXCUI0nW9/4cmwJpDhneC6Y/HVEMblITXhCVeN\n    1VtNFrUL3MSj/vQS9TZZgi8FqzfvId80ekagSwiiXeqslyWMxzbQ1toyo9+s7hVy2AYWazTWhNYa\n    Wr7wl9C1FXk70DYWmrTkZd0gLtcdBJpnfkjVO1wht7t/BPrqs8rcp25hDGItLkPrfechNSG1Sk3v\n    Uwh7fk9818GS/LxMt3dqNCFUKnWf6nvHZ9Gqa1w3ZC+HrNFu4dTpkjChbS8znHw5qZaWhvK5nl0K\n    +WvHT1a0+JbVAPB0i/p1GkeXguLeBtkbpyoBRZ4ZhXrmaHUjJ6vws6qiZxYTZULm2kQkeaY66+ju\n    87My+2NSODPtYPr2jXNsy9+0c9v7XC+GlLJ2nImpuevDvmOoT0k8tL9+hOcKdnxUSt3Kbe8jerXN\n    M+jvTL0nJWztZzevCtURLiCJVTrRgNW9XM5D2zi7u0knK7j1kpTHxLCs5+Stk689AopE+i0B5R8u\n    2ht1zCe6tX9+5+S6TyFhbrxuYkui8OVEOoGdJVWQ5JR+G+chsLNemPi16uBptXvH1v+NOZ857J8t\n    fPbPHK+99CxbOqbEzPcVhPkcSXnZKxxPKcubikTaXj8+bX4lC+ibgn0LeB8zsbuvDfTYh35IsXtM\n    WUhja/yOxTbwd9+y0PGsRmw7dDx9pG6/wnfapDSm7kgWICR8fXOWo1W29aHpn5XBQH2eVJ9LwuqN\n    9ciQWoMKQLWtcfmnpAhfCrKTAusn90xQmNWN2tbZF8zT1pOAJdlyItOk97IljzVxLP3aGoby2oYC\n    u8HqnPbPaiZWH6Ozr6rqBrRd3Sn3r6+WbAhzkbVT0d2vDrLGQhPf3ffAWWr7VE3GervnWCto+1Ku\n    WSjL5X3idvL+6nvEKc1ZjSTWqZzEoNV2+ndG+7TKZVYKFwCQZVg/eXCYNzPh2rD9bKsUvrpUhnsS\n    2te+9lUNXCY3jcUgy4DTrz9E1ypXP+34uVvTuKITTLTCV55PnLTChJsku7AzQUnbsVJUkmL4GVl1\n    nnnAFpknKdYRxb6a7XYcteBEsfG1evVz+qrHUD6HccfgJ33ln5C3Fa3T/TJB262JbN+jiu4owFk4\n    24Q7IFNtORmAE7cquMQ868Dh9r2zaoYm7dlJw5032vfRnp9sV9L9X3zl0dW8sQkHx+Xv9kskX72d\n    COCloXp90c6L7LNUYlAuNtYta+aemzu3OuhYFwsiKrhYWkgwISXeKoSVwTbuN6Wu71AEZYo62MZD\n    x8ZT9zmHsTNZ237IcfJQM2UWUl2V/bMghlN4eaVHNA1Lc3pNuHIkAnipOJaHw03OlolV+8ZOr8cQ\n    uTzl3mcQ3tJ+uZ+x2XAFau82YyY2BVzm35j2MeSwwDdh9KlyZb1Y03A94NAklW2hc5oUw/TPbQA3\n    ac5IwS0Ta20HDdUeF0kBvCRk91bIz8ZWaGuQAyh/n+6HJaH46iMK2nXJQW01qNfboB+TcFKDV8Dq\n    lnJnF+iC0k3fvN8MTvUEzzGxBTAHGkOBWVZVVdBBTwley2tb624YOlgfg0MEs31kb591Zeyx2CCy\n    60srk0r0K79EVcTvwYraaKWTI+Lte8tEcG7uC3k3cujgs1XAufu9q0iSvq39syQv5GiUfdy+VfI9\n    3iB7nOr/Lg3Vn9zM1RK9gLZ/Dql/mQQuf7dv0ZeEY8Lqw4cAdDII299WuzFPxjSxOHX0q67eqsda\n    R+ayuteSx5ykws9RJg276mK0r63SdOVZz7B158vdOGpLNcSOo6ExyAX87VjWJYbnwpTxmUnusfWP\n    +f2oKpNYBT3/se+TjKOs5O6WvWDrblniEqm61xyd7eWs2A6clcO1uXelLIJL9gN4NHf3tEs5bFXB\n    JwXW7yYnjaVg+5vme2NM1MXeKTWA9Vup/u/SUL12FtBM7rKnhH2K+uoDu+2ckILbDZVDk35sLC3U\n    lgUbfnfAuNhiyGFw1bPNdmDdHNbSvm33EQCtUGOo8FhMfNmStEMOl7J+bvvnMWTxTaj3OyTMG3Js\n    TfDj0A7BT6/hnB7Ofy9cLwF8qELLxygxP4T98zFYSu+Dq8qymTvDKETDhAbBsVlWQzTP0IQgZkAf\n    M6X32ZNYhGygEbGNnfQUEfsD4lS/volkDU0EN33191OZ7bk2cKj/0P59mZLSztV/qlElBfCikGVN\n    HWDGmCdTIoCXhfV795FnWrnklEW5sYjMVMBu22p4AQ7gdcnkrCX/WE0JaKJNesnRtUaWQLZVcsp6\n    HSjtBsZDwW5r+eiDq7+uLbB9KtqQUnYIY6yd+9qNsa7sC27bAHsfamQoK6cM8l3PhjS1de7d2GOV\n    RrKMCdjQWCnrQwkJrO4WAsYGyFmVxJbOtq9qF/x2hLL+3Jx86xGyYorHQsIxo/yjfx7UNQrU63yv\n    awDb3yQCeEkovnSG7O4arMCU56eoPbfI1fNCnlv87OFxhRNXdG1zGZ9lLMyJ6NX750QpgbV1rsBJ\n    UVZx7CDjn00GknVN0tewdXOMGngM+cpj3hS3jf0dOsLnUtM44VP9WmyrTClvpQ/elz0+HmvlDuD3\n    hbcX8jan9bKc7zG5X8SRw6nJu2RxTv1yUkK3/IK+N1yZBm1jngEo3ruL7KSPCkm4KajLurGAltcx\n    29DfWQ4UX0oE8NJQv2zuCU6kY+QUxXJKYUcM22W+Z6qNfflEE2Xgbwz0Z/uZ6gAYIyqJaQP4yOP9\n    iNuY9WMihId2lZwTsbWD58Qxi9WOzcE1+WwtAs108rPrPoyEK8GxPUTGYF9vfx/2JYaHMqvmxByk\n    7wp19MA/3J/Odgt9XQxNzHhStepZN9QPrxubeeeboNrlfUQyZzz2TTKbL9m1Cd7YK+km484COhF+\n    S8PqbV0HeAyq316gPt45asJIZPfPsHrztCVmhUQDHJHH5JkEGG2NYFDwjxUq1raX7QV1PVc/aWtr\n    t7LKU/7eQqsxZXvP2batajqGtq1R3thagPy8tJbRgauLWCLYqpt8SicONIfb9mMoOG+Vvfb4rOq3\n    kj/gxtAq+D7q61fRe7pt32PAkRBOiWTvJ6u+zdS+dcC8VecCbf1hu57VyU3/udqG34Hc7FeC13We\n    Y/3VR1Hvd8INQlWj3FlAc0CtbxhkstcX3Cz/cAlsUx3gxaAosP7qAzDJJeMkJ4wA4dqo1n2An3s5\n    9ScQy1xO0mq2zdtnMLtoWLvnmojGClKawR0PO2WAtvSpjNXYU6lf7Za+MUqrZv0Il1/oImb8HBpP\n    Y+BLNPO1sYSyjHm+sghW9dsldqHWy9Vhq28uc8GuLTbpDrRNrnrTY7xLenNHIctK8tlw5RfYucWR\n    ugDMnNH9LXbRYl1eI8PJNx5HvQ8Jx4/y+Rb1q/FjnTgk5A9XyE5TLeiloXrZWEBbFTDamZYurcFC\n    BakDLImlLkbmSN4SPH7qcmhi98y/Ydbb35Y87ovLWdh4YsjJ0MYRrdK47Nme+7Hw1QweI5bh+r9z\n    WUmfwAmNYsnmuXA+cvmciLF/vgkY6/C6bwnRY8QxCj1vGJIF9JJxLDbQ/NANZdnsWwd4XxybJuAC\n    +5O+vu1jieIQ9rWB7sumi+knNOHbmjZDZLCdZNbwk8EWoa9SdgLNfepJtKurApo868BBs035OhHA\n    S8PqLWfu7g8q+VEB2H5eon4Vm4+acOzIMmD9vTdJqcv1C9l6MusEERuyOFd2uKyazCgoyIFep2HS\n    ql4OFJYUxJb92Xasd5JgNQfafUHWUCC5TQCq0AnYazJYK3gkGBpHBOuA86HhU8OG0CHDzTo5V7nW\n    tk8bxOZlbF3q61dCe5f0nouqKAOT77Z+r1P/yt85tFrOBsclQC73LivL5R7m7TNaxtauooXj67B6\n    +xSrx3cO/r4mXC2qVxWqV5bOGv5ek3nb7+ZaFzUun85ZlS3hurH+6kOXDGKetQVc8gknonCtYHbL\n    kKQUrfolq3naHrvlPoqEE6X4mGT/PI75XDcY1kXDQpSruxfeMSKkLpbt+8ZG33g2JYlxLHwkcmiv\n    PPexiVJC/gYdO6rwNbI20aC++P2xNt+8vRuDtTOGJFUV0POAGrlKuGICV9qIAt0laLlt2SK6Nr+b\n    48zbY2L3jmKzwuqDRwd/XxOuBttfx0e27OeqBrB6N9X/XRzqGvXLCxWpEoJV2zfL2q7Sl9tyuTNb\n    Bs2CyeKhtISQ61AZ+G0J3FDaQmjmt8Kwy+EUSJ9TiNS+beb2B7yMPMaQ/bN90lxV9PKqawgfO266\n    M+x141DOxMeCT92fN5sAPrTPN7DMLIMhX/k5lMKHtnfe198/dlp8VcSwDOZMRPqm3iHVMQ/cdmKw\n    RdzAHmrD20+xefb9ZoJ1n1Bc36RMMhHh+T0GXHdE/tb1TlzWpM12tHA17Nwx8hevVv0LAK+OLS0h\n    YV/kXzpBPnHYzVCj/H26J5aE9VffQH629pBcaNUZtQniscpIbAGFPG705VrlwaojthfMiXyTgLeD\n    HIvenoOhrPx0dQt1sFTUpSFC0kf4Si8MqwhutnXrMvNvCGNVR0MYHxjXNs++Or98bDKmqOtUuQC5\n    VU8DOghdqr4kSK6Pc0Vt+f0Nv3+6T3dmrtYm15wWZa9uyykF7jeTv2wN7ep6Ni2ljvHJn73RZFQk\n    LAqXnzazWV99OVmet3eW+9uGI+12qQ7wsrB+5x6ye2szRsmzwpG58vyQ4DDTu46Y08rK5tnLCTF5\n    S5zJ2CU2vpa8w64/fl7Kc1mcD+T5eGlStbgPefbbZ3LXElqPo7Itl1LwjS/agrnfIppxCDJ4zNjM\n    Y74md7t95eEdtr1195mZprpNTe+hq4nJhTu6hLDdlyOCw+pfrSTO1PqsffK5hATphUlxl/Tg7n9X\n    MqT5t/76AxR3E+m3FDABHPMJrU279ftjKnQm3AhUJbILf9QtVDqD50/yt21ry5mFlkmMrM9VjzFE\n    vFqFbhnRdqjdvkIV26bvHKYIecZiSh9TCeZ9nTFDhO4xEL3XYRN9k51bffjiug8gQXBYAvjpNZ7Z\n    EonbOTDHw2RsYfKrfGiOHTzmHlRi++PB9RD1GObIDptCzPaRyBZDZGy/7bO/r/AksO4st5NNrS7r\n    qnOtDamFb7Kb0TLuh+0J2YaHCWW8OITxecJ1orhfoHjY3L1OLRmHHMD2VylwvSTkd06w/sbDNgBX\n    qWBetzawC/JxSJmJMRcs1DV+NXHn1Lts69y1jBZYNZF71rGtdJcYlH1YBZNV6rRkcqXJRp+KSQex\n    Q3XYxwWlQwqn2J8YaFvM8HpbD9G3n6qS60/3kqdPR+K7Nt33VdfClGOwtqR8f/B5CDnC96D0zUol\n    Ph6t5crUUla/s42qtWtt76PNCusvP4p+rxNuDqrfcwBbz5dy89qqfu160Kvyt8ldZVHYrHHyncet\n    ErZJPnGJKFwL1j1L2VBefmsXgko9c7KW9HXEm73r9FjV7ccRsT4FaWaOyBKSGR2b3Ra0TWgc5X3L\n    WN1XC3isNfO+P/uQzlbt2zeW8jm6994ty7zt9OtSjYduntN13NAJfJw40Gxv60+zG4cmcN3YrNXB\n    7p7NaWxmxbsrp+CutSOdMwBZkWH9nbei3uuE40e9rbH9ddw4lwUWrt5NBPDSUL0+76h9a3TLmMmz\n    dMhxpTuWaWWwvLaxN1+pNUaJ/YQbbDE91raZ+2BMVQFbxKptBUP1e0PxXh8ZOzXePHXGfAzE7Wv0\n    O4kyR/EysPxYcNXOrklRvFjcbAXwsWPuQtk+H/ehD+ex2EDH4LptoKfg0HWAxwzWlxO350nN5UB/\n    YyGTK55IjZnMFaiVetjWDYnpi9W7vgkck7MlmsmwrwaX3qZp6ya5ep3UQ+EQpA1cOrVvN1CZoUb5\n    IpF9S8TqQ/2lurFYisPFry6A6uY80xOGcfLtN5EVVrmq68/Z8KQliNnWku0spS9LBgNOCaoDqo5u\n    q+CIOa3vdBbBDK7Vq0lFrThuXvuwU1NVFJRs+xuyruwqnawy+KqtK619pQ2UdNtqBZNV/Nqgvc/y\n    WcCWzFYNZdXb8q4KYbvy9MWJAlaxzclYjsSwluPaEtXenwDUPcZBbV5m6xwCwOar95HfS4HKJaL8\n    1TnYF8fOoULIPO2c+0qN7W/TOLo0bL75JWTrojPG8UjC4wArKn1OF5KskpvlYqELaDtpJujk+VbT\n    fplErKDHZC6dUMOOtjpRULsjOLB6tEKGbeUnQH2lFPqIXl0reHzN3n2gCU6t9HXEa7e+b6gvOZPW\n    grmKmQ841wnuSx+DdrDg5AMLVnZzQoFO6ZN5VmbGXK0A5vuYx0RtVZ6ruR8ri/kzsHrzDKu37x38\n    PU24GpRPL1E/dxGS2NFOVMDFoxXyB6vIrRJuDC5eo4YrSWbvC64NzDbQFW3DTnfyU3r6WVGszqII\n    Lg/X95UjKwf68/U9JGiJsX/21fPtwyHq93K/PtQDn3T2d5D49dRY71hy9zywzXng9TFJYI6Vg7hK\n    3AQ+6SqcgWPw4Piv1fUTwEv3207oxyGtosfSZzHF6admM0n21NgaC4c0Y+o7FrvuUDbNvolVH8aQ\n    x3YCqSeFdWc5t7cEcxV4LX8LEcwqXps9KRNrX/0Uq/6tAVTPk0pliSjeP528bfmnLaqXqQ7wkrB+\n    6x6yt5r6pVVLnGaKTPNZ/LmQsraw5OAf14LzaS7lb6vQ5fqtsox/r6gtWxdqta8Lnle0DGZfHNgF\n    9WO3iFMEh5XB3N4Sw/sjjuzl8/PVSWbiN1TrUdS/K8C7HyZAXJ+6jnTtueasVmMig5VpNonAkRzN\n    e12Zds523BG31e6Oc2S2WEPnpn+rgNcEMgBUeYH1996c4f1LODbUlxXK3zdzIF2bzhcY1D+9/QKo\n    vtiiep7G0SWheHyGkw/u7l5lKMCpS+6ZZUlbt55dMJzjAdPH8hzi5CirFNUErt6eHQ3Yvl+PwTb5\n    BW07Jm19sIRvqC48K4I5YSqG3PXZRccZzMbBZ+scsrS2xzvknsFHWVZ6/hOaD3TnRnZ81clbGR2P\n    jGlyt9hkgky9F5naltW/PBbX1Lck4+l7Olf7kWOySVR2brj54VvIptanSTg6lP/t6JOY6ArbP9cA\n    Nl9OSXVLRPnqApwMBzhHOolRueU1fY9yMash1zI7R8tpWag2sN/+2d9fey673zHxSRGTDMUcfbPC\n    cN3gcfFLX1/XZfHchxhC2BcvP5Qg6pAOnrEq37nVwENurGeoO21uAgGbcGOQJnu3EUvzlI+FDBaH\n    yCo6H3jtwxwKW872spOAIUXwemD9VISy3ba922gUNAEd2lba+9TGgFYA+7YLhwH9NjXWKtq3T9+k\n    uTCTbntsbnnzd/nyEnU1NNVOuGlYvX1CQ68lyMKoAKAGtr9NyvBFIc+w+cFbcLUJJTiXq4CkBAIr\n    5BSoyVt1CNeSEyJZK0RcbcF610dFwUerMhFIXxm9xu6ItFUv2wN3SWMHTRozCrdTzxYOPivHPoto\n    +6Muv9pDV+Vkf+D9GfmWq2PVpG8fwQ0if319ck1CQJO/fDX5fQrZivK9wWFk14vux7Vg3ZpVn+t+\n    5D5kYr6AS2IQm0ohiAs4kiVDhvXbSbW0VJSfXqDask1hF9Y1pW95bdpc/Pcx6QsS5sDJ995siVsm\n    yhqwzbC2cbaJJ7K9I+VcslUNreZlclfGDku0SX+WIAZ0MpU8GbWTAtplzfkIaZu1z3uL9nlfhZON\n    ZJ9MBMu2QwlMfsSPob7xlBON6PA9P93zCZ2XPTLXrz/5zZ6PTWDTBKy9pnrstu8Hz7EKOPWvHZ9l\n    DCwNSeubn/HYzft297R2jOGEQtm+Robs7hrrLz8e/Y4nHC8u/yvue2Jo9lp8MD1ROeF4Ub8+V/Mg\n    eVIAWuVr6/RyWY2mhbyuWwI39D0rZAfNbda7WBxbP/cRqyHbaP69D2KJ4C3cGC7H2xdHZftnjtEO\n    KXf7+puyzsJ3zGPiwUNylauMWm3McV+levc6baN9jrB3ZzieuWygU2nWMD7rWffwMNft5hPAxyL3\n    PmYcQ9YI1w2e+oCMDdfMWXMgpq/YrKe+vsYMtOuByUUsuO02YnkIQxl1UyY2MRM4H+HbZx9j2/TB\n    bl/ScraM9pHLdh1b7biv3jrj1lsPuK5QXSQV8NKQ3y1QPO5SODGjcYYa5X8nAnhpWH/4CMWjjSJT\n    dQ1Up5DM1d8CHUgFWAnaDbTKNjkFDqV2oqzn+rFsTemIYCYXTY1aOCtE6ccGR63NfrfmaxeWcg0p\n    ZVkB5Q869yPv+dkHNohv1b4+BZc93pApHyuRKgDb3bbc3ga8WSNn9yUELwflu2pfCYBrS2dr3WnV\n    v7xvIa65NqFYhkvdQgAtMVzviOAqy3D650m1tFRsf9OMczZYKYhR+jbb6O3a/v89mbotDev3H2D9\n    xokidmW8ZFcBwCVSyXPIqY14rLNUr3UjcM83WcYJVzwW8+jJ5RC2yLDdPdP4WQyIaxA/17tjmJ4H\n    OLTPfYqy+5Sy1oraV0phCvLInz6Exu6Q84VV+wbTsyr3TvrrCWedft1cqLtvccLghKiK7h1OBLCJ\n    ebI/Sc7jxLzctGeluiRIOVNn6/SSd95bnZTgzmvz3S8BG19KeMJNRH1ejapzzyUWMgD5KkPx9iH9\n    5xKuC/XLZl7FsSZ5zSStJXu7ibPOuU4IXo6Tcd/WQc/20/e6u7wOxvDs8liFsI1h5uiPacZibmUu\n    Y18B0Rp1dF3fQ9b/PUQ0azPxuh/SkTRhPhyKSF66I/Gn+mUKnAzhixn6OAYC1uKYVMBTH7pTH/IC\n    38ATQzJPtbmYi8rbd+D3TUpCE53+feltVoiro9GHGMJ5bHZfKCuwDPxu1Lquxq/UHRY4tW7/+XAW\n    JAcgeZlVpXA2JgDgdVKpLBEnE+21cgDbX50D26QMXxKK0zU2H7+DItMqJU2kucCfVm2yxS5UsNsX\n    bBSlMCsyQ8FBB0f0AV0Vk7QRaMWLJmz1ev8stEajdu0LEvsUwSEy1acQZpXSXIgNdvvqEftIa7XO\n    85EPvV/2nHxW3YwtcrcfcJqSu8+0opdpXKht3bvj1LzuOHLqT1uWM1nsFFBuuVXWrd8+w+orj2Z7\n    7xKOCDWw/fW5CkwD2qKSYS0NYdr5ku3KX52jfp1soBeFVYH1D99GnTlbXCF3WTPpnik5PYvzdmwo\n    6Tkl9e7Zytda0Uvb5nnntrU1fXkZKz8bMg90xA1ycOJLFhwLeb7A4LrAfeMLgy2JYbafOyHKngOr\n    gn0K35hx1L0rXfA46qvQywRubpZnaMZJn2rXjqtuBgb1XrO1t5znyvRj53D6PtKOMNZlJUfWmQvV\n    iiR2SWDyGSjun2Dz3bdnfCcTrhvb350r94wQMs/fNYDV22vkp8Xg9gk3D9XL1yrulNPcyY1BQEP7\n    dglhacftLfGb0/KQ894cKDozRI0S/rq9dv9Dla7tLLFR/e5fJm9f1a1t3+cIGYsp8eVzXL3986Fx\n    nUpeAMn+OeHQSATwEhAjz7cPj7OBh0ksQXyVD8mryNePGWx8bULk7pyD4iowuO8z6E+ZJMRO3rYD\n    23OW3banX6nb0a2dwev92X9DdT544mrb8mvfJFYyIGt1Ps2Eue7Z1mZOWrvops1u/ctEAC8Rqy+f\n    tX+zojJmRL78osL20zkM5BOOCetvvInivbvQgVxt3ceksFNKSktWqnBg0KkvxSI6p3VM0jXksFXR\n    WB0UG/02gUy25rUE7LbzBGQVll/5Kn2VVX+N3pAZcygwbDHXDHgoGG5VTCFS2heUz4G27q8N6Fti\n    3UccS9C5G6RulpdmfffqsoqJSQxntSqECb+3/B7kcESKHFkFF6Duqpe6NRL5rquzHJuP3kG2SkHK\n    JaLqUTBZe2dJpJOfThKdZ7saQLmtcfmb5KaxNJx880tYvXtHqS4tEcu20Ox00SaXUJvcPAPZTUOe\n    S/o55UozyLhZ0brcPEfle8wWeZv0ohNeqDQCQRweuu4cXaLYjh/uOoTHI14fUxN4Lgz11af0DSp+\n    zbaWZOdyDLLM7kPem1Wnv9xLTDfb6bkTz7v0mO3KcpRmXle2/etxW0pzMN3M6nZO0GLPDV0XGNj8\n    6G3k91K91yXh8pfj6v/adsVXzyK3SrhxoJgSk7hWmMDI4czk3bJu7V5W/trlPhvoJv4WvkND6Xl5\n    xF2dT+i3D75YIsctx5LaMfbPvHwswWxjz30Ro7Fx4JhZsy/2PUYRPBT5vEpieIgvSTgOXIUj8NPr\n    Psn5kAjgq8QcPupz+LlfF67yITo0OIQGlzmrnoQGydBgO5e1cwhDg3ysTYqv3dT6FTwRC2Xh8f5i\n    JlljJmIySVzvJrghohewAqyagiQ6O9IHIYp9Njq55+q1tjwvk03hErF6e438jiNQxn56kn3l8pCv\n    Cpz+5D0UawnxaatJG9zL4Cyc805g01lHWxUwWxWycqQEU4pS8clZOUtgEm0LzvSWQLKuJ8sksCOl\n    ZVtnqei9HvS3BFJjgs02ANxVxHRVUvv+WPRZTueBdqHjsdvVZhv2j7BBbPs+aaWQI/uZqOA6lG5/\n    OXJ132iFnA6Yu8QCJmDYvtJaWzoiRe69bFcj0X0WWD21evsU66T+XSy2v3uN6kKXxbCjJBO/DLuM\n    1b8WF79M4+jSkJ0U2HzyLrAuWqKMSVqpsSpjplYBs42vezaxCljGXk50keeW33nBkXYCbicksCaY\n    tRoVtN6OCfJTmj6ZdAQ0CWzHlqDrRKBNaFybeywdGruHvDu43wxZew18sCUt7HHYcgo6sSrDlohV\n    TmXipD1W3/L9xalWdbsfl1glCXxW6Qtoslnmbe7+1Al+nIwFZCjevoOTb7+FhOWg3lbY/md84nhn\n    fMyA9Yep/u9SsX3magBzwhzHuWxdYP6tbaKb5St67bOBztC1h5ZZGjvtFbt2BbWPres7FPcLEbix\n    24fQjVuG+xlD4u6rDp5PIjDtusQQtEne4scUh9a56vQO4cFVXoiEQ+I4COCl+24fK67SBvoQ3vr7\n    WkCHYAcl30A2PftonmMeO7jbGr9z1aZYDUyqGFOtm33LfUStbV94J526rf3tqyEc2tbCTpSBrs2O\n    UwdrS2g72RZKvXyeApRLRLbKsZ5gAy33x/m/n6OOsPhKuFko3n+Ek288BKuLtBmvVgED1mbSqoDZ\n    bpJNAF2QUVJZmJCr4AKSrEaxRKKzzXQIEayACzTV7TquHavbt0sr1++QFSZoP32qICZRx9YIrga2\n    HbLO5H4svGSyUm91jSvFlpIulWrP185ZUboEgAK+wLtT6PL1EyKE7wOh9nUN4JzeK7Zc5XtWB6q7\n    yQ762NvzWRU4/fG7Sf27YGz//VVnhqftKuvOumywjZ55ZQC2//ka9WUqp7A0rN9/iPXXH6rkEV+9\n    XlcqIVP/OAEFcAQcj6eS4MLPJyaYWQUstr5M4DGJJ+3kiVaZPjlBJocLOlfU3qqcsTu+vqQp3zru\n    a4ignTqGxvThI3tjlb5ybqq2sYcAt+Nx7e25a/lsVbTi3rMyW/vqNdtEO0cZwzvuyd+iAm7KI4TV\n    v04B7pY79w1SoxcZzj5+F9nJkAFqwk1C+ccLlM+Hoy2hz09xv0DxKNWDXiqqL14Z4pfWmb+lLrCT\n    KHRjVw5O5ctksQ/27uyLsbF6mNeFYnt93wpCJC/HLG3939q8Htret69Y4nefuOwc9s83AUPq46uo\n    /7svnzHEvVix3DHYPx/DMSTMiuMggPdFSPY9V6HoQxWcvmoc0wfYWkdfV/H1YzKAm6tGMKAJ4qmT\n    gb7t+tTAfe2HanZwn3Fq3374Jos+oljWWVgimIlcO8l1xHSt1sskO28nlK6dJX5tTeAqEcCLxclX\n    XZY120APIUON8k9blE+TDfTSkOUZTn/8PvK765YwY0KXLSYlyJdDbAglCNisYavKbBcEXMEFOn3E\n    sVWQ2MBzowL2E7YV7ZMNKQW8X0uSMgnMnwE5XvvBYHI8dhZrg8d9244NbPepmcYokD0H0pKovn07\n    e0iN9rqBw8vaetQSDtKWSWYham2gXJR1VmGu7UfdcbN9pVNANW1swoIQKK5/Ta6cfHAv1f5dMOrL\n    Gpf/1czMQybumj5xYckamhzqVmul/QCoX1XY/mHOmXfCMSDLM5z9+F3g3kn7ZLN1UZkItj+crMJJ\n    Ks0zM2vHLGej3zzhmucWk6faRj9HFnj2Afx81olWus66HQdkaOSxXa8nkjEwwey6Tch3le64NdUF\n    I3Y85fIGsWRvd1v/k2MFS/rSPYOsHQ8lQYr3rB1JXFJA88PXWqvCrapca7r5vc6J9M/bJIMVzdX4\n    3mWyWM/S9P0qjjG2JMP6yX2sv/w48som3BRsf9FNnhoCtz/52imyZYSGEyzqCtVOASzvefPscnEt\n    G7vyPXtt7MtH+FaQ8TAMbs9xOS7fxs6IvpigT8whcT6fPXNfasQUa+gh7FvveF8yd4W6jQdLXzEz\n    3tB+fTHzqTPokJBqTvvnfVXGY5xL5yiJOacw7yY7xl41bqEQNY3yh8axy+UPqQK+ClK3L9vnBPXB\n    CN7znmX71ia4ML8ZoTrAsVih7my39bTxr68Hs+Bkve0jhjDuqxlc0L5jMvFCKmHbp0UJrk3CtbB0\n    vRRuL21WbaZi0z9PpvkH6Cp+mRDm6s7V59eVGpFwaBTvbpBvtI0bMDwqy/rtL9K9sURkj+7i9Ptv\n    woX1tPUfB6WtYgRwakwOJgpqsL20VoowYcxBa1ZCyX64bqKoS1hHYm2EuabgivoBXIhVB4YdJHjq\n    +1xwwD7WItriEBbQfTWI88DfvnZyrW3f+p7Q26xMO7stX1N5t+Q9s0kB/J4K4cFqblHBlchbW1W2\n    hHb7dMfsbKazluTVCQisSzAE8dkKJx+/hyxP312Wiu2fLlA9c9XhXMJcA54j+WZ4ukZwt43cZe3+\n    kg30IpE/voOzH34JeaaJL1YBc+pJTs8fS5xJWybiAPeMFcVvbfq3YzQnw0jRGJsM5UtqtXXVJZkr\n    RLz6CNBW9dwTkR96qh66lMLUsdvWYfZcFFgaWRLWKnRdSHi+0Z17aNV2Y4HqyH1XNsPNwbgkh30v\n    mazlY5TlTu3rEhM0yd1VCvM8zt0PjhwuTgucfvw+UCQXjUVhW+HiP+OjXr7yCKsvp/q/S0V1cQHU\n    NbnOaStojlEJuBWv77bTls81iS247VBsDqYt9z0GQ2Tu2Jq6Me23I9uHwKTtlL5C0oCTkf3YWPZ6\n    wvsQ6guYt+TinJiDyE3o4osD9v35/l0sGp92F6UgylXh0Orbq/J/3xfHVEw9lBkUY/nsa+MjbM/R\n    HTRjCGLeRsjUy8D6KdhXOxiakIw1k/IpcsfAbdtP9rIyt7ttg4qWyd+VacuTX8mc5AxKvQztPmVS\n    LLnbPuIX4En5rt3Tl0B9PJ+ZhPmQnxVYf9CdkscaUl784jXqbbKvXCJOvvcOVm+dkVK3a/XHKmD3\n    dJGgY0ZBQ0f8inqTg4MhIpHtLiVALm3ExpDVnpZcLJFT8FIn01h1rLPk9KucAGBb9WuCrEX01Nmt\n    TxE29qcPTind/azz+1lW/nPMTR8+lCYMXKlgtNsX24vzvVDSey8tuHahq83brBNbSm1DmRnCQ8hs\n    TRBzP5m6F/S2GTKcfvcNrN+5P/GdTbgJ6EtsCtXztU+FWrXXQU47m7r4xatkA71QrL/zNvL37qnx\n    jMdP95zKO89wnRyVt88koFEBu2dm18qe6652lb4uKcuNiezaARqnNYmcqW2645wdY20CkLW+1mO4\n    Q6yN86HHyhDkvPv72L13VQZfApkrh+BmRLbERPcadI1TV53j0PbevB2//0IIV+a33E+cZCfL9Tmz\n    LlwTvHzf8r0o/Z782RtYvXfs8oSEsdh+eoHys2G6KGj/fCfH6p2xNFHCTUH16jW6sTI3W8rbpxvT\n    vi4+BTDBq9XDAvkWWrSvu8pim3YSIoT7SrfFKmvl0xCycu5TFY/d1xD2Kb/HceCler/NURN4igV0\n    klIk3EIcngB+et2nmDAZsergubJljuUhfBVZSWMmAXNNx4e+FvAkx1qG7NNvqA1PsorIydnWs21f\n    ex9i6gf7ljNpa2uU1Ki9GZF9tVBstiUTxG2bZ+eoq0MY0yQcA9bfuNP+PUYFnKHG9rMS2z8m+8ol\n    Ij87wdn/+AD56Qqibq3gKF1WGlkrQOz+AgW1RcOkawo61ZOoO3WwWVtRsiUiv2ZFaOa5hzlQLeSu\n    DaxqtWi4XaUesuHgsbav7iqEpyqOgu9XoL9x9RHdurpyZ1ibc2Dyt7tPp2Zy9s5M07t3So6PiV5t\n    K95VGgkB4axOc3V8lTpSty9R+rJFJgfBObnBkSP63i3eu4v1n7830zuWcIyoLytc/uJ1OwPyfVI0\n    udtF5nlt++PZWPW8xPZ3x1QMJmEu5KdrnP70fRR31jQm6BIH+tkmz7G8HXOdAthZ5DOhWyELErZM\n    OttnrU26kX3KT9k+H12/gHNe6JZx2J1ze0xo95PBENA0jvYRvUNj177jaOb5XhQap22N5n7y2HdN\n    9PlYS2e/dbazjZa5E1+DEnr+xXMcrfx1+7BlEArqW94vl2jl7ses7dfN7ez4yXWB+f7gBMLV23dw\n    8qMnE9+xhGPG5T+/HIyA8BhoP0Hrr58hWydh0GLxQqK6WogAaGIX4GeztoQG3DdLTqfzqYNZEMG2\n    zKwWLnZkcaHiarKsiym1dWPgi7L5ytFt4eKioXijJmj97ocxsdWhNkNEsFUSA12h0hgy+Txy2T6Y\n    av/8Gv3k7xRieB/B2pRtpzqyHlIAeFPEhUvFw5n4NQ/cQP/ZNZ/kvv7bt0n+Pbev+yFtoH3Y56Hq\n    GxymFn0P9XdMGLKBHkIMkTtEmk61Ilmh9rbf9m7jh92mz0aGrah95zZkesV1fn01f+W1P3jh1CaA\n    JXn1hJnVwDqj0tnxZHWF6lWyKFwq1k+cDXQsWEF5+S/p3lgqVh88xua7X1LEGsBqIwCtwsOFSFkp\n    IurMBs4GkwPTYt8sql4JLks4sjTErwQwWQ3MgWhW4ObwEYwNrPVlDn9Am/t027pzGlIzcR8cOPbZ\n    nU2FtvmPqxfsgvJ+RbMLGNv9NMskMK2vRQN5D/laSn+s6s3M+2btvy2JwUFlppX5fG0SAu9b1L+i\n    THKtdZ1r7O4pOa7izhqnP3sfxdl6pncs4RhR/v4c5RfNbM+5oiBqxlsDyHYPu5D1cwjn/3Is6acJ\n    c2P9/gOsv/8m8gxwiS/sfdD8dmSvPOdy9QysWmItp2egrk/OxF1tXkviDCdh2Xq3lkysoEcHViqz\n    PbWgm2ilkXFvnWQqnTQVGkttqYY5x1E5LOlvSCns5iFdd5AKNmGsC1fHWTty2PkK20QzGZyDnyvu\n    uthENmsb7rZq9m2Pw6rQbbKfI/F0qQSbwCflO9r5xskKZz99H8WdpPJcGuqLChf/1kS0+jTx6Fl3\n    8vVk/7xklM9f0rPVxbW65c0kUuXiX/KbiwE1y9zf1kHPwsbscjQl6WKsnosR68oR23au0YjtVpHt\n    +uCLh7JSuD9eGr/ffWsJh5wsfTFquyzGVTMGx5CmeRu/KRzawTbhWpAyvZaEsZka123HPEY5vA/J\n    O9eg0TdgyeAYqgMcsmy+HHgt8NlA+9b3tQH8kwlfSHXKZCGmRu9YLeuY9rGTsHLgt1Xt8mup89vE\n    GbWtjUAsc/rrnGiiWClSbMvnt3HKcTuQnRZYP3HBGCanYkbny1++Rn2R7CuXiCwDTj56guLtO21A\n    1gUWtcIob5dpItWqkbg9k4GVCVg2y7SddNlqT9D2U7WhSR2YLBXJqklgVtRUyLClQPWK2jOK9qna\n    WCPXnuC2O4/9rCurPX9i9+1em3WVVmDrzHodmC7puCXI262/q8lfJo95nVWbMbXA9aFZ/c33UmNZ\n    mbfr5X6pSOnLdtTuejMFogPgQI48y7D+/ptYv/8w7oOTcGPx+p/1XMcZETbIPH9Lm+xOjvz9TafP\n    ynzWfFbR5b+/Rv06Oa0sFZsfvoPVe/fa0UrINnkeAaAnnnXKcM9jrtfatHE20pJAxcSuEL7SVpN/\n    AKhvwI2bMubyWOhTtrtnvtQG7ipRBTKOcGJWXYXHK5t85MO+Y+W+9tChMbcCUFfaKcWeS+k5O1YH\n    8zVke2fpX6cQaIcVWcMkrpuj6bIXUiajpnXaRtophbX7C99PrrxCZvpipfnmO29g9eEbg9c14ebh\n    8jfnwKvwd0H+lPgiE/m9Itk/Lxz15y9VXIrFCYKQK4Ms53JmEv+yYgn+4VhYofqcFtNt7KVdrLFv\n    1sZiEB9szDKHP4YZK2SRuGkofuqL48bELYfivxa+ePPJwHrf/qYipkThxrvs6jmJmOhqTJtUN7gf\n    92a6PnP1w4gVoD6dfc/XikQAx2DOwtW3TU4/lroaq2eTASNWyesjcWsMZyf5SORDm6/yIDo0LeeJ\n    QexkYRV5LQA32fFtY5et4J8c2RocoUlXga5y2Gf7MmQDHSJ4mza6ndQJ9llQ1zSBtZY5/DdnR9ps\n    SneermYw2+nYLEypBVwDqF8kAnjJWH/zzuRtyxcVtr89hrzIhEOgOFvj9KdPWitoW+uNA8uNEler\n    mFi9JG0rCjA6YtdZQXPQ0QUZJdtZB1yFcGRFigSmmdRlwtlXd9iqga3yVK9rOu9aNoaVwd0qoYdF\n    1vMvhBpZewI8jljbSt+snS1BmUQF3BmzWkrUWyWcMk2OnFVlEr4RIkNURRywZvtwp8J2AWxWsNs2\n    Ge3T7depoWpkKN6/h7MfvnMl71vC9aF6VaL8D6dg0s8ZmyjRxck37+L0h/11LUOkUv26wuWv0ji6\n    VOSbNU5/9gT5nRW6YxtbC7ukJ35iM6mXwY2jOilLP0c5WSbv3Hd2bPONDfrZKb1aJaklQH0ksFXt\n    2r0EPxcTxrH50T+W+xTIdn7By3kMEgUXO2tYZwt9HLp/0HxK/AqE6JV5kRC8lec97xLLmkhmcplJ\n    Xb4nbA1qdtNwtuIZ1m/fwcmPnzSZhQmLQl0D5//8EiH610f+2iSok2+cAasUE14ytp+/pCdVV6jA\n    8Sf5keUSt3KkryODge6zVkQSQBNjkxiZlEYr4Y/h2fgdx+RiUvR8JG5IRbvq6WeI9I0hbjmeegx1\n    e/d1lLS4avvnq+jv0ETuVTmuzu0UCwAP9u/iILhNDsAzIg32V4klyeitenhp2S+bidtdYP5BMUQ0\n    x04opk48Lgf6iFXcbke0b+pr+FEiTB5zm7Hg7MQVZS668+y2z82kVCbFLsteZ1RyViXbRDPxm9Fy\n    17pG9SwRwEtGyAZ6SAUs98vFP6f7Y8lYffAYm2+/odSWXHOVFSAcKmbbQFEoZXBkIVc1lCAldtu6\n    /txr6ZVVLYCzIaxVQNIqiHRwlQPZzspYE5i8Zx8JzCotn71zGHGW0WPQtXWOg34XfDW0dCCbg/5S\n    d7KgtnlwP92azUwk8N9WQSTLS3r3crj7LDd98Hq2I3fn2aQNcB1gDljzMed319j87AmwSdbPS8fF\n    v71E9UrCjA1iP0nZSYbNd+5h9eQM+cNVZ1umXIL7TzbQi8b6vQc4+f6byDIm2XTCkytZ0DyHxJ0g\n    b0lcJuJcrXKdaNUdkwG0z0Mh5TRZjLZ9aUZi+T6kXSP0J8M5MGB33N1yCr5kK6CxSeZxORZsFT1n\n    JKlr6eyHzya6HYc8EwCu5Sxzk3BylU5ys+QvO6644+laP/O8SsY7uRus80WJHCu1P12L2tp0W1cX\n    PQ/TRHB+usLZz54k6+eFon5VYvtf56OjcO39nmVYJfvnxaP+7Ln8BUDX8mWBAttES3xKYlxcv9fF\n    spywYSgGx99xChI9WKGG9N1X7g3wxxVDxzCnA6Ebl8fHvmOENEO4DGw7pu9YB8oYRe8Y+IRYQ2Tt\n    UFz9OtTDh8B1O7MmLA+f+hcfFwG8bx3gm4DbpgCegilVLYce/lNI2Sk1CsYgNFDPkSnW18e+k48+\n    IndMjWBGOXHdEHzqYu7TTj77ICaktu/mb64L3FhFs3KY92VDFi4z0vXBWZrl5ykwuWRkpwVWH7iU\n    Ew7ahUhgXr79z3NUL5N95VKR5RlOfvwExZt3lPqXbYIlkB1SMQEusOiCiei04Nzvsg3FagtnDkyy\n    UlQdM9jCUFtB+0jg7j3erV8rqkD52Rr7Sq7NF1IHW7UQE+gcNB37L9ayEvCHtisA26prkWmD63YP\n    /F5xW2v9zIS3K2ngSA22bObrqNVH2s47M9vndCxa0cvkiba7dEF0sbAk5XCRY/PDt7B+91jzjhNm\n    w2UzOQX0AACAAElEQVSFi3/QufHZiDnp+sNTFF/aIFvlOPnO3WC70DfeGmgC6C+mzmATbgLOfvgu\n    Vh/cAztocO1xtr7PiKyTdU3ylBsXOSnGV/9X1LjizuH6y9vno02uAe0D4PqzXStoVvmW4CqyrjdL\n    Alvic4tM1cod65XB123sP5+q12dbHVL5st12u03lxnVOlLJzlcpzXew4LolTnHQm4xTPhwBOXHbJ\n    Vo4kcHeakMfyt9xHBdxx8/jJDhtd8jdvj8fOXzhRb/3dN5P184Kx/eVL5Of+tMc+9a9sUTwosHor\n    JQcsGmWJ6ukrEhsIoduAn7FM7HJcyqEb19LxMF/cy0/mdpXAuh8mhvssnwvvMn/8zzfLC8UKffHO\n    PvtnH7g9x2ankMeyfWzZP2Cc/TMjJD7qK3EY44x51fbPob6ncA23DUsSLiY4PEI9nQB+MOKmeHpF\n    J3SsMvAUvgpjSh3guW0iwvsbRt9gF0sg9w3efYP1ekc0CoaywPoQ0tfE1hNeRU6SBJaI7es/pPYd\n    gkwWeYIpv+tAn2xNU8G/T57Q1moirS2dATfRljYZ/ISwtNVq4d01+lNKG1k6Nn+2hw30eY3Lf0tJ\n    AktGfmeD0//xBNnpSqmAa+Sq1moDrRSxRJ4ogJmEEyvoHGLxyyQz2tAyk5IS1Aa43qENruogKweq\n    JaRtiVNWKjGZKOuUdWOghmFIHTyGqJ0LMQbUch5cH5nhC3aziomvb7dmpA6qa3Jf9wVgd82dxleS\n    CbgGoZDATIwIKewSBiSozao4fZ/yfci1EDNkWH1wD6c/SNbPtwHb355j+8dmxjda/ZsDpz+4374+\n    +fpdZOv+rX0zyXpb4zy5aSwbmzVOP3mC/O46SPyyclLGWG4rikwZF23ZhMw8S7X+nMnNjPpxz25+\n    7jqS2l+nvTREoywXhMZYWSc/28CnLWbsOiT6xvBQ9MrW8JXvjzxu2bPhvrjcgSWJ7Xud03vFV4zn\n    GSXdK/LajdOuL1bxuuQ+vi/zdhmTvc5Jo5vMAGQo3rmLk4+eXMO7l3AVqLc1zv/JURljP6cZgNPv\n    nCErkjX4klG+fo2q7CYJSIyK6/Y6Ra+LWdlEHEv82nhWaV67GsF++GJtU8UmY90J+2D7CsVWxzgd\n    9mHf+rtzYR8BVEwJxTkhsddDq4BD3w6W5oAquA2R59sgPA3guBTAh8AhCkYfAw7h7+7DGL/60EPw\n    qkIq+zz8p2RiWXI2NrPqULWDxyiHRWnsqxe89bQNoS+jzrdtXwZfaP92X30TrNLTBxPIkoHosgX9\n    FtJV4HVF/ZToTnptO2el4yx2LPnM22gT6Gb77R9foK782b0Jy8DqyQbFfVc1x6qAh3D+T6+AbbpH\n    lozVB2/g5NtvoCZCjf8XEo2DgNZkWNcU7AYhSzj7Swkcc9BU/i5pr2w9WLVbgvp0hC/PODmIW6m/\n    HcnrU7W214O2tT8WufnhAOkchHDW8+ODCmZXjSHyaqB/Ie5LEwCXa1XBpQ7Je801nN011ASDUyIJ\n    scEqMnfvsApcVOeskGNFuih6WW3l+s7MsXUVZKt7a5z99Amydd9VSVgC6rLGq799MepTqFSQ725Q\n    vOvsK/NHJ1i9fzqqH7lPz//lFeo0ji4a63cf4OSHb6POnB2zGw+dNX0DrvPbPMO4njm7HGhL3rzd\n    Fsiwhht3nBW/Vutaja+19G/UoBmN/w7SlusSWwI5NBq1Y2I1nCg1dpwbCx/Jyz8WnbG/8ltSM0G7\n    6umroPa6/ELYZcOOqTL2cXKWzKmEQLbuGSvocgnWKcMlzPnKXeQQpTCTwhky4LQZR4uzVEJhqSj/\n    dIHt7y4GvyeGEquyVYbVN6YnICfcDFTPnrVkrxMmOIK3Rr2LlbEAgdu78mdCErd9Q5dCk2XijCfw\n    iTnydr9QywB/HWAEllmRRyyGYpLbiesKI9Dpwz72z2PWMS4wzQ2Syd1DxbLtvg5NIM8NsXF+ObB+\n    DhySpJ2z7y8OdIzHKvy8AVg+AXxsSHL6fuxD4u5bQ2AIdvvYDCnffvu2XaGeZWC1E4Gxkwzbfku/\n    QyRsgXpwPffF7eYwsbU2Ln3HYPfnn2xqK2dL8Np6wNYap2tdVque3fZ6og3QF7VtiepVMitZMrJV\n    jpNvhWswhWt77j5Pf7jE9tNDT8cTrhNZnuH0x09QvHUHjox1ltCs3M1NIJAJT2cBne8CpxJ8dAFt\n    JolZ6WkJXFB7XXNQB3AtMSt/y7FaK2iXXd5f21Ya20BxiAi2qMHBcUunx//EgJVmfUFthgSfHXng\n    ljvyvXuuGb0fQvBaFTUTuxI4Ltp+9XsuquECQLHr0WcTzfckk75dtZNWOrkayHnzLPzROyjeuo+E\n    5aN8eonyv5pZct8MtespACAHTv/8AZDr+//k+/e6bXv73s0JP91i+9s0ji4dpz94p7WClmdQZQg0\n    Hlt5bLCkcVtndbeOnTUkCWa7G2sdKdyQuTl0SYayfSb7XBJ0ElTX8tIl1ri68DrRKqy+chv4E6WG\n    MW3cnEYj2xIJuZws+slfH1zylHa3kL7kW5muoSz3AhPC+e69cwSyI3rRvvdMMrv3NW/vlQxuTsU2\n    4XoelrXqc60G1q9Pvvsmig+S9fNSUdfA5d/HyzR8n4DV+xsUD1OCwNJRfv6cIk2ubm8NWxYHENtn\n    Dafg1e54LgZm6/ZalbAlflmMwfE4a0Yu9s99sUXbv8QYhajuiz3yfvZFbBGRvnarEeQxE/Er1K0Q\n    aWj72Pq/Qxhr/yw4NKkrfEA1Iu69FCXvVQkEE240EgGccPswd23fQ5C1Q2Dlbp/18+XA9j6MsTAJ\n    K3/j23NdkBiVr+unm7ln9xt7Lj77mRx15wkpy3jiKopgHQzQljoaXVV05mnD2ZrVs+dR55Fwc3Hy\n    zTPkRVeV1IcmQNXg/B9eok7zvkUjv7PB2SeNFbSu7WoVSN2goFMlMeGqayGu4RS7EsBcQ9sJ5xTU\n    5IAkB8IlDClWw3KfWtUvo+yZj9pgrw1oW4MEX63DPoXw3AhZVtoz5HqFfNxss+0LwgsR0YWQCqz8\n    ErKBLaIlWN3RgyiVGicACMFR0TFxTeoMmSI5hCix96itUe1I4mb5+isPsflusn6+FahqnP/8BcYY\n    nLikDSB/e4OTL3cTp9ZPTlHcK7zbAv1U08U/vkAaSJeNbL3C2c8aK2gmzayVM4D2uSRErdRc5Xqs\n    8uxz9Vib3648A4+z7slcg1Wn7nkuT8ywnbPfwYLva7775VhZxWrH0j7njOsqpRAav0PJU7n5OzRf\n    4DaWJA8dh3uPXNu6PR6nBOdjtO+XzLcqap+1yQHOiFUn6unxVd7HmvbL+5CSC6t372Lz0RNkydl3\n    sahflTj/xevBSG4dXJ5h84O7130aCVeBp8/U0xvQxKwQwboMmSZ7MyWI6LrZSSzPqoSto56tBcxO\n    e92awF24OGL8PG0MuesjibcYtn8OrbtEnABHnBl9/U4laPv21Yepce0xNYYFUxw4rxpzOJmOcVQ9\n    BiTBosPT6z6A+XF8BPC+ftw3QQ5+G3zVDwWfQngu338mhqdmJ40d/MaocmPajp0k9Fk/h/Y9dhI0\n    paZFiED2TeIswRqa6FkyuOhsowlbW8NE1vNkthu3dASxEMKZ6sO1q2m5Uwq7esJNoHPX7ll6aiwd\n    xRsnKN4+8a7j5IIQLn9xjvrVHDmsCceM9ZffwPrbX1Kkrwv8AYCvdm7XClqW5RSkLqmPri2wUxDr\n    eoROyyPWwBWtYZWqq2bHW7rXJXS9WF5nydshVZOs8we8u8rVfX7sv1CQHXwulQsUu+Xdc2Ui1xG8\n    uoYv0FV6sR0ok7+2HrDYTbJls60nWLWvdH1ntz9RNznbb6n/KzU0mUSR7a1N+erhCTY/fQKsuuRd\n    wvJQfrHF5b8Ou5sw6dsSTzlw+qMHQOF5AqwKrL9332yHqOSP7S9fo3qextGlY/X2A5z+8C1kGbtb\n    OEKXk6eY4JMxMPc8v4QMFNJYElysJTATzWwZ7NwS7DMfu3q/aOut89hhyVhWIuu+XA3apl3XbUPG\n    JTvW+n60pf/+P5W5nuHx28CTAOZWdcdZua56zuPauz7sMbnd6cQ3tFeDSXM9Trv7hdW73J7dPjhB\n    ShKnZG7kEg3kXmO1OpCdrXH2sw+S9fPCcfmLl6jPJXLgR1/S0+pBjtWTzXWfRsIVoPxTE0NyZckc\n    oYvd3zaexfbQ1t2O2/AdyG55Io6wy7vOeLpNGVhmBSI25uibtfXZR/fZP5cYdjKcUqN4XyfGPsyl\n    6t0Hc9f/Hdp+yPnz0FiKangID677AHBzSro+mOk4Hx7ofB81/R4fAXwbcFM820M+9S971k+pAzzl\n    ARr70D/0YOQjfEOZU2OsMnwD90nPuiHINivUgzV2Y44pxubEZs9ZxFqlNOhayIRb+id8tkYIW9i4\n    dnZdd58hda+2ieYMSN8Eu24n39ZyR2dbNr/Lz5ICePHIgM33dC0mG9jzBcDkPqnOK2x/cVUV1xOu\n    DXmGs50VtKvF6oKZbOfLgUFLfDJhLEFqDlByQLEk5SeTgGx/aOvSde9drbBq+tWq0WZbHSy397xP\n    CSQWkFNntIMB5kC7GBvnrvrYb8lp7Se5fqOQV7YmJG/La7rEsrMkLdQ2Lpi8bdXaWpHMpHPWtnek\n    Pr/3rEByKiY5WiZX2Cp1d66rHJsfvYvicVKk3AbUNXDxdy9QXfgcUExb06JCFlT/ClbfuAtsctVH\n    t1/PvrbAxb+lkhu3AZsfvIvVh/cpvcU6JHQtdis49wRtk6yr7dpnOSfg5MjaJNe63Y8bI+V+d8Sq\n    JvjQ7sU3H0S7TxlHxVrajglWyWutoMc4Z4wdF+12GLGNOt7dl6oV9RU6Zqt29o2b0o6T5+S1vrba\n    otkm22kbb5dCYMc9N4ayWpwtodFu7RTEeZu4JaSzI6Ab6+fV+49GXs2EG4Vthct/ar7vccIlo4/8\n    rZHh5M/uIFulOPDiUdco//Cc1LwSf2rgI3DrdmSydX27Zc74dR+hWkHH52zMqy/uNgSO5w1ZRa88\n    28YQzLJs1enPOTLOgRDpexm5zdSawrKdzyXTFzufovaNxdxOnQkJFvsKTm8CPg2vSgN/LL7Yc/tD\n    ZE/M4fM+ZzHyq8BQWGafbKAp5PA+g9RcA9xckw5frnCoDrBv/yszeQqpeG1NjsJM/vqIY95GJnmh\n    CaetAcL78MHW8vVlKbJVjWzD6mHOqIRq6yo4Zp71nGnJxK/sZ/unpAC+DVh9+RTFmX9c5nuRW7BW\n    7vwfX6HejvDTTLiRyHZW0DhZQex2m/qtuqZhExDtKoWF9CspSKn7cH4IbGfIWpeagpCAszJ29Yhd\n    hURbG9iqbmRdDh2U7ZKmVunECp3GUnlM8Nn1ozGF6LXH1BuA3u0wZKfJQV2fapfBqt2K3q8mGMN1\n    Kt31q9U1lfc/a+8JJiwK00bXg3bKcKuWE6LEKuXYrpKtytdffYjNt98a+c4l3FTUz7Y4/yc9o7ck\n    i69ueAb0q393WD1aY7UjiG2yBO/Hh4t/foX6Io2jS0e2XuH0Z0+Auydt4kpGzy9+BkOpat2zkp01\n    5PnLrhCuzIIuv1DuRhV2VHDUsxCBbrkfuZfMzFQL7PbnEn5sj3Ycku8+XueKSEJY9j30MxXW7rlv\n    zF3trsoWLjlKzlXmQt1Pu5sfdYleTfRbVwtpn5n3nOdInGTHduJo3TNkTHWW0Ozs4kpsuOSEHED+\n    3j2cfPQEyft52bj8/QUufr+d/BnKVhnW37wzceuEm4Tq8gLli0Z2IgQwIHEnFjJo0YJV/cqPtZCW\n    v7UIQsfJLHlsBRluzNHqXI4HjilPx32PwThhigbHQH2ELMdqfecSG8ud4hw5xtJ5jrKGgqE491xx\n    8CnuoLx+ihBtyerfmxBxvgmOv0eMqyOAn173qSZMxrH51s9h+cyDzhjSeOpgNVfBezup6MvAis1K\n    8ylmx9Rk6JuM+CZTMZO4vklY7KSu8Ew2BULcyqSVv/xb+5nKsy23ragdk8Y1QtmT3dopoAkyWz/L\n    9vUfn6GuljvZSGiQnxZYf0OrmjQhFkYN4PIPl7j8zVxPm4RjxurLX8Lm229QUNGv9rV1WrWlr1vP\n    ZCMTtI4idm01oZKrdhwMle2YBK7o+LpJQi6w7iOIQ7V0Zb21Tt4n8ByqP9j3o0lVX58N+Vt6SF85\n    e22F6T7zK7qG/i27NqBsUVmr37qmoL1eHJBmwpfrPJc7SoPvCKcQd2SwtfTke7FVFj86xeaTD5P1\n    821BDZz/4wtU53pOE/pcWxTvnvSqfwWn37+HLNdKXw5tdmyld9h+usXlf123uVzCVWD11gNsfvgW\n    UGjbZk6m4rFMrO31OveMrGmdc8twpJ3UaBfYBC3s9rTabcv0cI7GqYGJWvecDScH2WUyxndHDUdy\n    llXWO99ki+Tx46RGFeh/aPzeVuE++b2oAgSvU9TS/bBb47ON5v1zHV5r4+xPtGpGS1YUcx1fbm9L\n    enA/bkz3JCucneD0Zx+iOE3Wz0tGXdY4/9uuKxiPbX3RghzA+skJikfpPrkNqL54BrSxJyc0kLuk\n    Ro0CNYrdk5AVwUz2OpJXljXtuKZvQX9z/CtH7Z3f8XrZHtAEsQg+fOj7xuBz+UOwn3FxzDqyPcdf\n    fbHSvpJ6Y5TFIftnLiom8eIxBO8Yla9tG4pEzRWhej1y+VSM8dW7aaK6hFuL41QAL12WvfTC2lNs\n    oBn7ErxzPfxjB6++AbKPMJZBeCiba426bbuPDTRjTJbbZeDvsRMmXtZnExPuP1a9q8GqYWdR469n\n    Unr6Eitnm93os6W2ttCVZx/8Nc1mW3J2ZUWT7e2zC1Tnidi7Ddh85wz5Kpy9PxSUu/jr56i3yx5j\n    EgDkGTYff4D1mw0RwqSaVSaxjWUBoETRCWLX5rcLkDodsbMfdDUPseuflTCsIgW0OaaodZiALMEB\n    cbTnI0pWueebrPBcka0dQrdCVPB5iBCOsSDr2lO7+oChn1K9I/rHXgP3Wm8n4DqCHHRmhaOjLthW\n    2lmCitKIiQldY5AtLLWNaXPOHAjn+pdSD1rfZ/y7RgasC2w+eR/F42FCL2EZqF6UOP/7VxCKpquA\n    96U07JADdwbUv4LVO6co3jpRz6kQ7Gf5/G9foL5M4+htwOkP3sX6g/vgO0+rYt1zT5PETNrl7XjG\n    yTZMs9bqaWyJw2YNj40uQcolBcmz2Vdigd0erF0xp235bKP5p1UNV331eruuNDERpX4Xpv6SD/yz\n    rbQFtt5WCO5ugkkGdj5xkOvUzC/0PMSVx3B9y5ymAqt19RxIz6scce/GbT3PYvcM67li52bcL5AB\n    WYbN997ESbJ+XjzKzy6x/fdziEuYL8FJIHeQSujMgdMfplIbtwXVZ58rwheev9x3F/G66KYTSAwN\n    cOphXes3XGotFCfjOsHo2Ubg4oh10GUwVKN3TOm6unffDmMFMBZzpmDMYckcK3I6n7jtXG2WiLHk\n    sU+lO4czbKjv24qn130Ah8F+BPBchY7nhpWFH2Ph6Nv44Tq26pSHHGRCVJ0doEPHMLaGQwwsaTwm\n    G21u2ImZjxCWyZ2dRI2pDbL19NG3fQXsCBJWCWvSN0QQOzWwa+uMVO2kUtf+LcyEW8IsPEmvPns6\n    99uQcIQo3txg9f5GLfMpOXyoAFz86gLlH+Y08Uk4VuR3T3H2yRPkJ41uhYleF5R2FeSc+tMFNi35\n    ywoV0HquSWtVnNZkWCwMWRnKAVUJcDtVlG4D6BqFIWWTVd+u3MZBjLWx7EOI8O3bIEc4a93WY3Sq\n    bQ1l+diek677yCqjgtaxrSUTCZYQdkSA294GoFnFxK/lvnBHK8FwRxZLP6ffeIjTbyXr51uDusb5\n    P75A/arfYlmHH93nvXj3BKuvRAav8wybH95Xi3yfTt+y7W8uUf4+Jd3dBmTrFU5/+gT5vRM1Ltok\n    GJcQ5QybuRYs12qt2jC6rpvOY7QkM8lzOVet3BgpW/vGhxJMFEKR0I4Edu4Sof7U9UC/sgrojnm+\n    kjmx6CN9vTB1f60Smfu1x8tJae589dyjNO8dE7eyzDmoaBcN6dHWCOa+2RZaJ9vpRD2576QmMOBI\n    Zev4Urx/D5uPnkx8BxJuDOoa53/3oi0j0gf+9HDz7K0T5O+fXveZJFwRyj88BeBX9vKy5q+6XcK2\n    zHVL/jriF/DV7dUxLx+amFd3+z53vxCpW0ZsazFEzFrraaBb4s72NWTpzH9zZM+W0Asd36Vn26F4\n    7ZR4ri9ydB7Zzm7ji29vPO1iMSZmv0E9WDIyBiHeYqr9c1IIHweWLjQN4ZE77+NUAN8GLIUADj3M\n    xj4cx7bfoFZK3z7V8DHU6QWGBzpL0IYG2CHiduWZzA0hZqIgbbae9gWts8u3kf1bhC1fYvryT9ZC\n    k1K2hPa1s6/5uvIXq6pd6ybXBU2cpZ/M/C2TbFtbRbIss0QA3x5kwPqje8jyeBWwqyHd/Hfx8+dA\n    sgy/FVh95U2cfPsNSA1YUWtaApftKoW01TXk3G+tLmngrKOdbaFYXHIwtNptI0FSUUaVbajWBaOd\n    vbQDB4PZhrGkYGcIusZenO3zkFq4T80bIny96t6qe66MGjoQXMJPVVklFx+nJn9dfUhJTHLW2o4g\n    ZrK4JEPKGplSMTlCQd7jrA1Mc1v5ZxVRLvHA9bl6fIrNxx+MuNsTbjrKL7Y4/7mEVeISMNo7KAc2\n    Hz0ctb/VV85QPFjB7iszf5X0WZF153/zAnWZxtHbgPVb97H56B1kRU7PdvdM04bJOokmQ5fEky05\n    eapG3rFezugZXMLVeeX+NZmbq20k6YnHyor270O3hrsfedOZfzzz9BkzTk6xiPaN41lPe3e9m3HU\n    jqWshuQEKJkTOYLXXc+axs5mWd7OfeSIOGnNEdNO7dvYo3ZVwXy/8ZjKZDCrgrl8ApAhu3OCs59+\n    iHyTLH2XjurZFpf/Nkxt+Bxl8t2Ksz+/i7zYL/kx4YagrrH97eeKyIX6H2Alr4CfTqHkHrs94AQT\n    bl+uXy6TForFMZFbeZYJfKKOPqtoARPJPse/IazQTyCPqVMcExe9nLDO2j9fQIuPfNvtK/6JjTUf\n    2v45FkOcg3AbU4VrdrtjK6U5Bg+u+wASDoGrJYCfXvfp7oFjVBGHMCe5PHe2yhwq4JisnkNW77Kk\n    8KGUxDxI+2ygY7bzrYsd6GWSs0Lt7XOL/iy5hvj1w9qsFDRR5Oy7vsmUnci5Y4iDb+Iny9YRGYy6\n    JkrX/lkIX7F1zj0T6Qy6RnBNy2qzfvv7p5FnlnDTsX5vg9XbOphjiSa+j6xa4/KXr1E93dcoPuFG\n    IM9w+vEHKN68QwFNHbSuTcDaX1+OrXmdWliUT2iDjr6gbhOILAAKVrqasLYObbNnUdSwNaJT0rC6\n    xwW20a5nJZMPZeULLPdYR++BoeA4t+u8fe31YZV0rYgoufYc4JffVj3NZK0EsiVYzepjto8WYkIr\n    vHMwceHuJSYPQMsy1V9zblY1nLvjPVlh89P3UTxM1s+3BXVZN6TqK6leatab1/rzlGH1zgnWH467\n    X7KTApvvjjFGc3u8+I8LlJ+lcfS2YPPdd7D+8EFbP92WNmDyNTPPtgqOZnGJUM4u2ipvOSmLFajO\n    pSFT47m29XcuGkAzbrpkIL81NI+9LjDvFMO+8bAlnT3R/9gxbyyslbNV94otdWgsDamaeS7h6vg6\n    8lfU2A35at8LVxaBFb3O+8QRuTYJzSVNuXuEjcCt0lzuq+1u9Hb3T67mCu19k2U4+cFbWL33aMZ3\n    IeEoUQPnf/8COB8Xc+KPb/14jdVX05zrtqDeXmL7x6ZeNMeoRFzAdXKd+tfvdCcjlxCntsSZJWrZ\n    HrqifruqXX0sOrbhI3eH7/8xiuAxbUNgUjg2xupL17kqF8a44/PHug/hiyMx+33j6VNi/1PVvBZL\n    Ufc+w/GVKrUc3OcT+zk0jtUZ2YPjVQAvUZ59iCyKufzex+LQds5zPZCHcAjydsjmeY46DWNxiIwv\n    xpiawqH2fTbQoba8DU9YfUrkUD920tkQ0Fx7UpPVsk+f8pfbAV3i1722at/mp6QexAJati9/9znq\n    pOq8FcgLYPPDu8iyaaG1sgTOf36Tcw4TxsBaQTPRK8FCsR501pK5CibaGnNsayg1XzXRqMlb2Qer\n    lzL6zYRzuXv6WYKzQlj56gMH0vW/HQI2eT5SOPQz3CICdBxaJ6ttKf3Q67h+oFJ2QCt8JVxTQVeH\n    FJWZrvfr9lUT+cBBbw5ss5LcqYFtskGu7jmrQl9/6zHWX/tSzNVLWAjKTy9w8Y/+FE5fHWCe7WQF\n    cPrjB8gmKJfW37qD4k6u+nb79ZNG2W7l5d++SG4atwTZusDpzz5A/uCECDx2NHDJMLV57jWlY3Rq\n    DBN+ouzkGrVOTeqUpzqpJ2ufz7a2uyyTZ7WQwLr/Buy0Ye90Z/vfHUtHXbuIn66St9uq1/7ZuGjY\n    UZ8TyOw5IrCOCXhWKdfIOu8n22hXaimfoy5xwWrkqj3HfDd+N3vWSnK0CXo57YMT5jLqd/X+fWx+\n    +P6o9yrhZqJ6WeL8H18NWq2HkiMqAJsf3EW2Ot7Yb8K8qD5/1gQEKK7E9YBrNCXIit1dJelLVrhQ\n    UJxK4HO0g/nNiuAurJOg65dJ6BjLZteHdfHr9mFFIwKfnTM7GI6pKcwCmtA2l4E2IXAcN+T6aPuy\n    TpIXI/YHTCd7fbH1Q7lxbvbotw9z2z8nJBwR0iQg4WrxEsdXCxjYP/sotm5CaDCdWo9X2lhlL/99\n    GbG9Dz47lZhj6iNfeV0ZaN+Pae+PTPjEjlkyEgVWvVvCksxskaPrn/iyIbmvitZri2kx4XGTaqf+\n    FVK6dvv87BWq81ST7rZg/ZVT5I9Fw9egTwXs2jR4/a+vUT1L6qXbgtXX3sLqW294VJeuLqEENVmF\n    xO1EZcL15wCtbOG6hWJpyMaYTKpKSJODqUJcsnVxew7QKiaeoeZwAWIOZfs+A6J+HrKMPjRyAHXl\n    FLLamhu74+cQrwvCN4SCvQ7d61LCEfoFmHzQ1paiBJbtV7u1zsqya2ndvNeOVJbANVtX8judqb25\n    99dZkzfHULx5hs3HHyDL03eQ24Lqssb5/3mO2jPh49qnvvB1hp0rxgfTlEvF/TVOv+XbVtup8xIZ\n    R8//9Rzl07Epjgk3FcWX7uHso3eAQiswQc9wecpalbB9hguJl9PzVwg8XWfYPSd5nCvBpCzM89nV\n    iXUW0m58YFWrgJWrevyHl3BVLiLV/mPpkNVzHPwEtbYg9SV42XHTzWOswhrUV6be4+YaspUzL6/N\n    HcIJeI7M1wQxaB9cOkG21/eeqSN956RJWDhJ1s9LR10D5//8AtWrfvq371OV3ytw+o2k/r1NKD97\n    CpcOqt3l2KVORAwZdOzKqoQBiQPqWJWvjrD0EVvnFwgRxQ18Qg62fy4H2vZt6/vNYEfDvr5DM8Wh\n    2Kklg4diuGMiO0P2z3PgUE6YPsSofOeo/3tbMXeJ0urICPMxAtOn132wM+KRPu/lBl+OVR4uuIP6\n    RtUB7tOSTbE98G0zJasm1u4hdnA6j9x2qL8LzIOLgdeAX1EcM8hvA+1jJypDKNqJTP96+zsPTL4Y\n    0qZG7VUDY7eWt7U1Q5j07ap59X58djhszyyvWVHssiybDEs+ZvnNk/GM+mS7Hfldo0b1+dPIq59w\n    05Gtc5x8/27nC7228mOluml3XuH8r1Mt4NuEzY8/wOpLp2D1b7Z70kEFKLUqmFUwVRs0ZgWLUxet\n    di0lgFlR0NLZGGuLSkDsGR0ByaQPB6LZ9tJaWrIVtCMl+wPJZdXVB89tAa3PR6t7+bh9cOSwC6HI\n    30zQy7lmEDu1zKi+tIKJLS+ZnmC7Zq7rLPUP3fvhkgEsEeyOsnnvZZ28v5W5z+Q4KuTIT1c4++kT\n    FPc2M139hJuA7a/OcfHv3Rks16kGjOpX/jjJcPaT+5PUv4LV9+6j2FgFpQ6Ye+uJbmuc/7/nqRbw\n    LcLJn72D9VceqHFN62c1Ucdkn9g982tXH10s+Zk0dAk/nEglamBOsmE1sByHIxt1QpUcuRsHHKnc\n    JTq747Ve38COpXOPo7Iv71haDSd0Cembm/7kush6GadW7Tac+JG1yVGg3+wH4tTVcs21G4q8p9KP\n    Uw27dDlJiuuS8fI+uysgZTWcnXSOPMtw+oO3sHr30YxXP+FYUb/Y4uLnL7z3/5AbTb27x0++dxfZ\n    aYGE24Pyj58pgpfjTZrAxa6FJohlq4pasDpYYGNqdrlAYmESKyupXQhj6uoC+9s/x6b7raBjevvi\n    OuyfY8sCXiXBOwZT1L9LUPD6+KPrcoRN2A+fXc9u95+23yC/66PDTSKArwN9D+lQds+hrCD2Rezg\n    eTnwOnbdEMZONEIK5Vg7k61necykKTQRC1m4hNry7yH4SN8c3Yksk7/dv/WE2bXvTpozdVysreLa\n    LLtJ+B+vaahIuBZsvnGG7H74C7sEE0OBu/N/fJVqGN4iFPdPcfKTJ8jXBYWbfUbGoifRdedAf4vS\n    hYOeEizlgHJtflhRpC2IHbkrAXGuwVdB22JKsFerlTVk/VDguqpMHTQ63jn+2ZrIoP1acDhZFNfN\n    Menjq8DGo+4c2apSFEXuvePz1scm74e8b7IfPodGUebMpeV9kSVs5WxrUzL5644p71zj0z97jPVX\n    k/XzbUL1qsL5/30+2K429xWwU/9++RTF+/spl1aP1lh/7azdDwKfWR/O//kc5adpHL0t8FlB89ip\n    71H92il7m9/yZOYxYkXjYglXisHe/zlt7xTA8pztEr5MEDtHom4CFatdOemoO0/ox9zjaGgsteN3\n    4F3DCs5y1He+Oa1ntxImbiWRiV1LZB7kxlBtY81kuxDM3KfUFgYyWp+TgtsRwS6pyr3zrCRurZ+f\n    JOvn24K6Bi7+8QXK51XE56CLDDXyuwU2375z3aeScJWoa2x//RSAi01JaTFt6KzJXmkjJDGXOBPo\n    +FZX8WtLpoH6OEXt6UdvL7bTU+rzdu2oG4xV7sYuG+r/0tNmiqdMKA4bayU9ZP8cE6cWkRQLj/YV\n    PA0JuWLj51Pq/4awj1NpaNubWCP4EKVLE64Gn/avvnoF8NMRbeesA3zvBn7w9sGc5PIhHlrHbAM9\n    BVaFK6+HDHuHBs4xRG0ok4ttovv6920bQ5o6pW/cscZMfMSu2X8M4ePMB47BZ9fM27GCd737ms77\n    l8mo1CexZLGd/DL5y5PpzEyand6rNpNtt00NoPz1n6KuccIykJ8V2Hx0tzNSDwWtm9rRQLWt8fpv\n    knrpNmH9tTex/uYbYMWvDU471acmXapOSFPXOHRqJhcsLSBW0A7i+iCBV1a++CyPrf2qI5obiDoq\n    R9dRImYWOyVotg8qZKgqf41hDgzbcxZiXc5rBetIoX9bdRm/L7ZCIZPrcrVX0Grjmt55awHOqvIc\n    rErqJhA0x6HJ3wo58rfvYvPjJ1f8biRcK6oaF//0CtvfdWd+MioxYWN1d9kmx9lH92c5lM0P7iE/\n    ydU+mBTyIdsd4MVfv0C9TePobcHq8V2c/uhdZIWuu2qtoAFdq1VsnLk9gFbV2ZB7QJOi5UhA7QPk\n    XBMk8YqJXkkc4tIA4tJgxwEgTAL7HDRqM0awhbEe164OQ+N3pc7VQWYzMj9pyv9Ye2g3f6nV9XDE\n    v2wj77p2H3HrWBmO3XuXt4Q/WTdDW0+7UdRtz/uo4dS/OTLkd0+w+dmHQLJ+vhWon23x+ufTomby\n    eV5//y7y+6tJfSTcTJQXF9j+4Tmc8MCpfjkmpelgHddiQjYzywH3vLVErX5ma0KY23IcrY/s5Zja\n    FoDPPygUW3T1eMMo4CeNQxgSugy5KnJc8TLQRwgxqYi+Pq4zhdFH4s5J2DLmsn8e88S9ieSuD0mY\n    eGugQ2dJW3Z4HCKb4rpk/8dI4vZhzgL05571U7OgpO/QoO/rd4i4BcYP9kPt7STF97fF2Cw33wRQ\n    Jm1j+nITvbHZdm4i2gS4Xb1gn/q36mzbtZS2tVYku5In4q5dN3uRJ8gXv/kcKFM9utuE02+doXhD\n    qJoussDnX+6ry39+he2nc5nSJxw7sjzH5icfYv34tLXdRRty1IFla2PJmtMcTFy62ndruOBxSeqn\n    kvqXwKeroij3o6uLyIHqEhygdjWCL8kPgZW+/EVeSMY+FXAOHIwF9pG8MrMWRZIF11Tm8+PDdGoi\n    a2vpCNascyxaucTqM1YsaZ8JZ/2sSWp3b8DcF2xxKveSthh3/bXnd7rC6c+eIDtL1s+3CdvPtnj9\n    V2H1L993Aiah1t+4g+Ltee6Z4s0Nii+fdvYhzyZtbq5x8ctzlH9I4+htwubP3sbqKw/Bjg2cGMP1\n    0HP1rOSa7zmY1HMW+27sEr+fDK42Oyf72CQfISu3kPrtXPvW1bblhCl2kGBohw2xifanVbXjbgXY\n    Me9QqCp3Hr6jsi4kck5i7yyQcY7LI/DpbMHFMKDasIuGlErwO59kRCbres6cEBVS9rJrh3ZokbPK\n    gSzH5s/fxvqdhwe75gnHg7oGLv7hOapXlbr/Q9/7OtsDyB6ssPnu3es+lYQrRvXpn5DVIh+o4UYj\n    F4uy5cesNbSIIIRABlw8rIS1gnZly2Rb+7XLp85lIQbbQgNN7M4nRPGVfhty+4uJnFlnQnE6DPXZ\n    J5LpI3LXEe0v4eKuQ/FZER1Ju5OIc+3rk0VNEqM+j2g7BkOOnUMCqilYgv3zIfEMTYnSY8bne2w7\n    p7DU4oY5Ii+3BvAhcAgVccq26EeMDfTcWUQ+ovgqQ5YhG2g9IM/TfyjbbK46wIyYzLbQdj6E6vMO\n    bWe399UgEesZVvxK9iSrfTPoeia+/qUHXp7RhFoUw86Ax2Vl8qQ8Q4365Tmq58NWignLQXZa4OSj\n    e8hMjM0qCEOoKuDir58n9dItwur+KU4/eR/1ukkccOpbZ1bI1C+TeTooreu8cnAb0LVk2ToR6Nq5\n    aitNth/WFs+N4wHbOXaDsAzW1Yh1om3DVtBj0A1xh8leRmg/tdnOp1qS4688n28m3KU/UUe7QDGr\n    h9z1kGvJCm55b9e7rXJknWNku9AMmvwtAGxRKLq5pPuE75GT734JJx88GvcGJNxsXFa4+N/PUb9u\n    xh5LsGq1bwPnBpAhP8tx+tG9+Y4nAzY/vId8ZckwXYPbN1LWFfD6r16ivkzj6K3BqrGCLh5s2mct\n    eytUNIpWrQK3W+9VErHseCoW+2IFzQ4RLkGLSVqft4MjCa0VcblTG/MYxapVtwztfhzRGi674Efm\n    /fEtjYWMoyHiV669rZ/MyVMZusQw96fLVHRttXlctWmYDdnr5gB6jsLX1z3VQuMjJ1tpK2x9X6w+\n    uI+T7yfr59uC6ostXv99vKbN3tsAcPrDuyjupNq/tw3l7z9VjnO5eqrIMgdbnoyVu2wR7UqcaUJY\n    3Oo4psZ9loHfoRieOAEOxQBjrKIL05a39cHuc2X62Qb6t+BYqa/sXWxMNCT6ibV/jkFseuOc9YD3\n    sX/ep+SjCNh8HMPcat4XB+gz4fB4et0HcFjMQwDfMNZ7Mr44QJ9LIYCP4eEmg8E+WUVzksl9A9dc\n    9RP6agb7JglDiJlE+CYidvIjk6OhjLyVmlRqK+cScRbUQtTaiR2j2GUxbs12eoLanajav0H912by\n    CzQT7XK31tX3Zd0AT54dNcLEr7SxOi1pU/5xwNk/YXE4+cYZijdXRMU0GLKClhH+8hevsf3tIfIp\n    E44V66+/iZNvPiYVMBO4UMFGJje1kiknkjFTQWvph9Wmou4VOLWTs5C0wWixwbQBZ26bUf82wMo1\n    DAEdANZkauYlh2dH1SXRuUavVR5a8tcXhGcVL18Ra+EN2k7IgBJ5u0x04JY05mMSgp/V4+4+0a85\n    sN21gxZCOcfq3Xs4+egJOlksCctFDVz8+zkufnEeWq0gzxUmrE6+fQfFo3ltTtfvbJC/v2ktYYWA\n    6x5fd+nFf1xg+5s0jt4mrB7fxeZH7yBfFZ1arVqxCTCJx21kvSTwdJXC+c5ZIwcnUVX0zLWJUJqM\n    bqyN9Xgry3M1RnD9WksC83hU0jnVvp9q2rN8TKTAjuH8Y5OTpF8mf7vEt0Bpatu5hT8tpRnDNKmM\n    DolfmrExpzaOKM4647pLrHOzMnZVcfOuxvr59GcfIlsnK99bgarG5d89R/W6+VTG5C9Km9b6+XGq\n    /Xtbsf3vJlZUQJcSs5bPsjSj1+xOp+v9atUvlzzLoUujWaK1QNdemsFEsi+OJ7G4vqefi9dZJW9f\n    28jrOVO7UJx1Lm+/KWTwVFL3ImLbOQnjECR235cqsxT1r483msMJ9hB81G0rvzoWV+W8/Kj7PlyP\n    AvjpiLb7yLX3kYlfBY5FZh9D3s5J8ErmTV+fbC991Q/tUHhnaBBbY38b6DEYM8j316Xo72dL7YeI\n    ZF894Eb560fdM8nz9RvTduj4eBIKdL9UcXaiT9XLWYscMGHyNocldO357hS9nuvv+tT1WWQ/21QH\n    +NYhW+c4/fG94JDtswMTm3EAqGrg4q+eob646mqoCdeGvMDpjz9A9vhMKXtdQLn5XVLQWVsIOz2p\n    tijOWxJRArFcf5DJP7EW7toZawUeK4Rt0FasLjnAa+vocoBbCOk88GPtK/uCzF2bR6D2LtfB/kIt\n    caHk0EjLdp9ct7FbjxFgQgFtv45+YLUvq65ZPV3tQtGsNmMLZ7ESZaJX64AdiZHv1gshwQR0jQz5\n    nTVO/8cTFGepXuFtQvXFFq//wu9W0p+41JDA2d0cJz84gG1lBpx+dA9Z0bywn7AhWuv8r160AfmE\n    24GTP3sbq686K2j37OREqdyMs47gZQvoHJrABbQDBnbLXZ1Yp1x1Vv3O/cE6QrikIDcOym8eA7gk\n    gM+JAkBbmsGOZaIlbEhg7fIxNF5WAz/tuFzpZCj7I31ZZxBL/nLCGsz5W1tn945wmQw3lrGCW1/z\n    vCV4bfJcZo6T7wutlNbuGpyolyMDihwnH72D1duHKCSWcIzYPr3E+T820bAp9s/IgJOP7iM7Terf\n    W4ftJcrffA6OI7HFs7uHXKyqojiTxA9YkADYpNV6V89eQ9dhd256JbR7YVdx3A8bB2SRSMgR0Eeq\n    WvXvEPHaJ0ThbTnOOof981hY++cLhO2ZY/r3xcJjYtV2u83Efm4KmMu4aaUx+3AsM41EIh8EyQI6\n    YT9c98OuL9tnqpr3NabZQMcOaDH6gdDgzCTzXDbQQP9kJUaFKxibwRbbvksgd4lcgSWF7SRP1oey\n    DEH9nu72UwQml5ztyIpg+9v+yGTa1kthAlmORbaRZZe//qzxI0y4VVh/5QzFOyeweiVt0Rr+rJ7/\n    9wUuf/lqnAQj4UajeHiGs5+8D6wdJdkERAtF2HHg0loRAg1hKGqU3AQ3G2tErQjlurW+IKrUxGOt\n    sLSV/bTnsPst9fuYnLXWj6C23aC63wo67/nxrS86lK+D77Hs6uzq4LPdvyPhM0X+6lm6PqfavH+a\n    bNf1BWXfQvZW7fWzCmyfYlmC53lLErs6kRxAz3YJArvtsxyb77+J1fuP5rytE44c9bbGq//3EuUX\n    4+Yp/Dw4+f5dFA8OkzSw/uAU+Xsbb2KG1GLl17z+8tdbXP5rGkdvE7JVgbNPnqB4uGnnW2yX79S4\n    evx0z0NQEg2Tgs3ztACUNb+rH+zGAimLUO/GSIEjnW2VeP2XgMcYJhrZGpnHP0vohnr2WT3HjKe+\n    Nn3WzzyH4PXN9zQ3Jso5lugmTAF2rmHLLWStc4Ytr8DnwMSyTdxyqQLNFq6OsyaRpZ2ztHbvJ9tX\n    rz94gM333pt+EyfcLGwrnP/Vc5Tn4wea1i78zTU23zy77jNJuAaUTz9HtS1h6/9yTKktLQaoNs51\n    rkFOlK4vZpbTdpVpx/WC2dnP2j/7xBxDNs3tuUZcj21PW9e/v/7vkP1zCLbcnl3Oopq+GCwLZUJW\n    0EO4QH+5PxYvxdb0DRHMsbHwvhj9UJy8z/FzH2vo245jESYeAqn+r0IigMdijkwEm1VxKBvoq7aX\n    nkMlPFXtaweSqxgA6sA+QirgQ2U8XSI8YM9RFwLw1cOoBydB1gY61F/IBjrmOASszLWQ5SESN4SC\n    JqZle3xh+xpAE7XWGrraTZJlea36adZzuEWW61osNco/vUD1Kr4mUMIykK0ynP3kHrIVYMNvtQoV\n    hfH6fz9D/Wwuo6GEm4CTb7yJ9dcfw33dF9tCF5AU1a5TJXFbp5JB+zfav5tgbLcGLQd8pc8Cuq4e\n    q5dYNaqVPY4E5j4luOtI6nCNP/7JBj8lGtEUVgUVVA8R0L56jFp95ALHhWqn637Xnm01gavVUs21\n    ce8B4MhgW/tZrpIQvkxwaMtoV/fSWqNWyLF67x5Of5iC1rcN21+d4/U/9KdgZj3Li4cFNt87gPqX\n    cPojUQF3UdMn0TeqvvqrV6g+T+PobUL++C7OdlbQ1pq/grbqZWLRPhOtU4SMd2ugpRyZWGQFqUsg\n    ElcMl/TjnB5yWPJWxkp59tsxkJOrADeW2giRT80bP0COvN6e/bE1th3nmwSybpkHmzBVBz7TOb2X\n    AudW4ghhTqhi8rii953HQqv+ljbu/dVENCvGJZkqu7fB5qcfJOvnW4Ttb85x/q/N93wpVxCCr+5v\n    XgCbH99Dtk5x3tuI8vd/RN0SuY6grSmmBDgimONWNu4kyzKzPDP9AC6OxzEyjulJPM2hSxTzNqHy\n    cjaOx6Xg7Da+vnzxwlBM18JX+m470DYWU0r37Yt9YtNzxrX37WuOqKjwGHOK246hRGYMllKSdA48\n    ve4DODy6E4Or8qNOcLgpH7pje4gJyTvloc/ZRXMOYD4i9jyibV8dhX0mEIzLiLaXA/34JichMnjl\n    mYRtPcv7SF3eLsYGeizJK9vWge18NtCW5OUJtkyS3XZukryinH+eWHN4gyfbNvzB223/kOoA30as\n    PzzF6isb+ILnoYA6373bL0q8/vlzoDyuZ3nCAZEXOP3Jh1g/Ou2QdFyDjq0s2cayMgQgB7XF9pDV\n    S5ZAtkoZ1s0yoclUsFUgVXBWjtYmGfT3FqwMyjp75DOvq0BtQ89P16bSPJ13fdmgtHob4IhrfZxo\n    r4ENutcIk782kN19bxzBLO9fuXs/nU0mq7RFq6QVbKJe69Zy7taidLUPm3qFm599AGyS9fNtQvW8\n    xMv/70VTd8Cuo3s2mK6UNYHr/OywtpWrJ6conmxkl/oAgq8alM8rvPqbl2kcvWVYf7uxgubkKav4\n    zaCtme0YahXEWUv46QSemnrlJB4ZH1x/2hYacIk9jGbc6I6xBW3Lylk7Pvmw2m3nG0th+vKVVAjV\n    FnbX1VdKQattuW+eD/AcwL0fvhrBmbp+PL6uaD/sZiLkb2vPTO97yEnDJgawTbS8Q9UuocpZczfW\n    z6cfvY3VW8diyJhwcLwu8er/PI9KrgiRw8X7G5x8Jal/byvK//oDAF3/11/7lwUYrnzZFoBTBzct\n    ql07FjI4QleXPAuVUBtS89p++4QkwXPf/Xbl68LYzrAs5tj62oyxf76MXG7VuWPJ5POJ62Jwgnrv\n    Phhj3T4P5Vy6T7/Xza+k+r+3DvNlho2VPz+97lM/Eswlt5+jAPgQXgSWH+qhd9320kzIxg5WV1HX\n    YEyt4cvIZUO2ImMmOKEsOjsJi9FPlD3bD9m++CZ9tZqwuskm1zSRvrmdrTXCxLFMrgtAEb8VrYea\n    RvNEWdcBzs1k3G3HJDFQ/vfvI65ewhJx9vE9ZGddJaMjiPhe6+Li715i+8ep1coTbiKKh2fY/OR9\n    ZOuCApaAU6e4ICTXeO3WvNPKJAmYNuolFwy1FtCOjGRiN28Ds0wKsbUmk8A26CvkpS9Q7ewf2dAs\n    A5Oou4Y9JHG/laXen/vtd4bQ9QcBrdoqdlfUHqPUYFzRUXNQmQPFJV032Wdmzr2kd78gsqA2x+BT\n    q/F7ntN6Wz+4RA4UBU5/+BbW76Wg9a1CWeP8715i+2mpPruMIXq1eOcEm28dPnCd5cDpj+8hW4UM\n    c/Vn1drIXvzja2x/d1UajYSjwKrA6ScfYPVw09a8z9vna94mx7gavlx2IYeu2evGOHk21+12aLex\n    NtNl57nMFsL68+YIU64Lj7ad/EgpBXHQEPjGLaj1+reg2M0Y7Jg5NM5KR9qC3aM69oylMg+QsdLO\n    N9gg2xks+xLRmnUFNFEsv52KWruVWLU3j5eSWAe1F6fu9pXgkDnX+oMHOPnu+we5nROOEDVw8W+v\n    UP7G/x1NW/Pqz16b5LDJcPrxfTW2JdweVJeXuPzvz+Cr/wu4FCOJMWly2MHaQdtYmY2fWWe8Fb0q\n    ULdl62y7UP1eRl+8b2j7OK+Wrv3zGEj7WGfEWIRmmGwfHWPZ3Hc+ffbPY2PasSrqPsTaP++LqY6j\n    jKsmbq9KMHis39w/v+4DmBHXLLi9GdYgh/TtPhbcFBXwTYJvkJiboJ2axSTbrSMnHUN0zSqiH54w\n    xMI3WZkS8uqb9PjI5b7Jns2667N/dvvtqpHtpNGXrSi/C/WlS/8tP6VnXReOMK5pMs5ZmGIPzaEa\n    O0G//K9PgTKm8knC0lC8ucH623cCd1eGId1Uua1x/n+eob5IdaRvE06++SbWX38ECfXWFJ6u2mVs\n    9dwNWgr55wKsWRuktsHQHC6obO2dJShc7oLmjrx0QeuagqA2iMvBXF89QN1GowaTnBnKatg83dZw\n    5/bVwMeoq0pymqBQrWKn0tIKaxv0z9AEvK3tJSt1eX9cddDaYrM9uFMHO1tTX4Bb2vD1zJBh/cF9\n    bH7w7vibNOFGY/u7C1z8jfPkscpEUSFquHX5SdYkOK2u5rvp+r0NVh86FbC2i4X62z4h6hJ4/X9e\n    oD5P4+htQvH4Dk4+fhf5qlAELT+VmRC0z1tOnhHLYS69wPSg1AaWH6sCdq4O4j7BFv9Wbe8Ix869\n    DJcg5KyNNUIkcLu+4rbdnyEwuRuyauZxXvrViSZ+strNEXxjvUuEskS6nq/o5ZLYZsdEdsqAOR8h\n    dnP1XjglsJtbNfdEfq9x0cjWh3VDSDge1M+3ePV/n7evY0dCrtp68vUzrN/bXPepJFwTys8+Q3Wx\n    ha3/2zgKuecxE8FMDktMq0E3Vlbu2lXQMUxf/V8RXchv2Z5tqH3oq//rqyU8BOsOWPT0L/A5D/pU\n    v7a+bx/ZytvZGsFzlOybq+xfDGJrBcfgKsRTQzgEmXvdyt6Ew+MY6/9GeITeDAJ4LswlRz9EHeCb\n    gjEPs77smkOoe8faQMxhcdE3aJ171k8d5MKqWrdcBuOpmoSVZ/sh5e828HcIIRvoUB3gPDDJ8oEn\n    dqFJYbxFtOtLlL1sdSN92MDGGlrxy5Y4bLHDx8B1gKWlTK65HguHRcrPXqJ88RwJtxOnP7yH/EER\n    CNR1Ye/2y/84x/bfX6E+vnlLwqGws4IuHp3uFvgDlNbOUPQpHNRm4o+1M2wjWe7sDKUXVjCVZu6Z\n    g8llc9i0HZPBDEXIggMRWnkcUvBKH7E/amfQxLTvR1RJpbpmelvAKa7EqpnPzaqi5HfZrnHvS0bn\n    7GwmnarJp+qFeS+ZOhYqnyuN53SMXDu4uHeCzSdPUr3CW4bqVYVXf/kCJU3UeHjpV/4298/6G2dY\n    f3iKK0MGnP7oLrJNrj7XVkUZShC5+O9LXPzr6zSO3jJsvvkW1l99CHieoRI+Z+JXnspVO4Zl9JTW\n    pKEu+tI8s1dwNsYVteXkKn/dW+cIwYlDOmGnAROpbIMMcGmDrDO28bYyHo4ZS9v9eCauttxD39jt\n    23aFbp17uS66lELeJlLJtpJU1dhcN3t2c5e8HdMbwt3admsHDVb1ZoBSe/PYKUfWWj//6B2s3ryp\n    0aKE0ShrvP75c9TPy8GkiaD1890cmx/d89cuSLgV2P7mD6o8mTzprLOcj7CV9bVpLzEpVv4ySez6\n    dy53lqS1cTlrF23Xh7bzYSjmF9uPjTOuTD++0nYhrDzbrM06X5+AP44bEwc+QVcwNNbv7TxymY1n\n    h+LmV2n3PKQOPkb75z7EuMTu6wD7bPczlyPtTcfT6z6AmfHI/776p9OpDvDV41AK4Nh+981SeblH\n    P/vYQM9lBbFP9lHM4BY7oI4/7mHE1IwIkat91fuGJjANNKE7JSTM9ssWdjlP8GLrANtteVIqv63C\n    t1L9s52Oe+2rAyxErq8OsJ1E80TcN5Gvf/+HCVczYQko7hc4/bF8ye9aQWcY/v7/6i+fofoiWVje\n    JuQP72Dz8XvIVoUKUvqsgsUumJVLEsysKIDJgeKcgqmrlszkmrMcPNYKG7E81ooaXbuvgQuYcqVD\n    tom2sLUImZjNmwZe4lZdO7tuFz1ZedqzBbUE2u1oxNabso10qy0p0b5HzgrUrZX9rDz9i4Jaro0o\n    rpmskDuA1WkZvTdOj4b2vWctsSMqMqAosP7oHazfvn8Fd3PC0aCqcfEPr3D565DninttDWrbmqj3\n    C5x+fO/K85JX72xw8o3TToKHe674z0Pw6v+8RPV0rLFfwo3GqsDpJ09QPDptn7FZOyZKckw4wcaR\n    gDmYBBaVqrv7nJ0/O2tYclYIRVejVo+bPHYDaNsArsxABij3GL7/OWmIx1HXP323q/rHUYvQWGrr\n    ETM4wYs/r7KdczHRZSTcmenPOltISxmDfHdtK3oP2ALalpjg+Q/MviQRi8ng/mITGVYfPsD6O+/N\n    fecmHDG2f7zA+c+HqYSQ9XMGYPODuygerQf7SFgo6hrb/5ASYdPr/6Ldhp2PtDpYRBFcE1g752mE\n    xBm+Umwcb5M4XyMe6cb5tPueFZd04TuGISVwDKwS2P7NcdLYyMuQojdGhWuJ49h9++Li5yPbj42t\n    j7V/Hiv8isF1l59cAlL93/3w8PDXb95v2qkO8H5INtAN5vDlFwwNDmNIWJ+iF5jPusJmaV0OrO9r\n    y/ARtZeB9X3LtrROtr+Ef3JU9Gzvg29d3CStDrYNbWuzCrkeMPcp63ifQ3WAZZv+OsC1WeaIXphl\n    /CP7kNDNxX8mAvg2Y/PtM6zeWUcnevMnpwJQfVHi4v89A7bJwvI24eSbb2H9tUdgJZINRHIQ1ama\n    nH1hA60G5mC1KHw5qCyksqypkKlgqq3HV9GxSX8+NawEZbneIcx6Cx1Ybn5vq6xDFPM14eW+tjZY\n    HVINSq3drvLXBbSdhWeurkdzHW0A2/Ul19iRD1pBrUlzR/BLULps319HBGdwCuKa2mVAp07w+isP\n    cPbdd67gLk44Jlz+YYvXf+3CJlY1K6+7n4hdEkGeYfOju8gfXINqPAM2P76L4p6uhC6wx21fVy8q\n    vP6/L1BfpoDHbULx+A42H7+7s+fV7gmWDOSnsUuo0kk68mzmmuwyBliFcfPs9ROYbpzWDhjY9cfj\n    LKtrBe5ofJ9X67bhH//s+NhX+VfaAv5xlI+r+zpr5xiW6K1hx2Am4S0hDJqxcNqVK5HBat3m3HN1\n    DPp97yp/JXkro/FZxlkZc9vkzQcbnP7sy8n6+Rahvqjw6n8/A7ZCynUhtbV95C8ArN9YYfO9u9d9\n    KgnXiPLiAuVvPwc8cSdO8w2TwS5+lbdtQf25v30lz+Q5bOv/shOeqINh+pDXffbP6lzN65AtMwLt\n    JObWF+8MHQevjxPD+AU1K0W4x8MX851St3hM/HpKrDvGiD7U7zHYQvdhSPB2U+2fk+fI4XEEQtvb\n    ZQE9J+bMbrhpsvtjfqjtowiOGWxiBjObkTWXDXSI5GWbkX1soIdqUPgmQSE7lCkZc9YG2n+u3e0A\n    badcetoDesLJf1dm+1C/oTrA8rq/DrBWDst+M7Ve/xTeybcz2bn8z09Rl0l5cluRrXKcfnwP2QoI\n    6X2HyOGLf3iFi/+e06An4ehRFDj95ANkD0+VsqgJTDrrygrOupKJ4YoCoVwP2JHBLvDM6mG2gQa0\n    iskFqrVaWMDBWVd3MUyydpXJkYjIheBah75+nYYH7Xlbi085G22R21VaS38cdHbWkfrauDqCrq9q\n    dz2ZJBflmVw/W6NSiF1d95dVv/J+uQB4jgyrhxuc/jTVK7xtqF5VOP/LF6jOY5QI/Ll3KN49weY7\n    Z9d2DsWDNU5+eKdNmKjN54HBn1tZd/Ev57j8z/O+knYJC8Tmm2/i5OsP2+dyY9Oct89erq3Oz1q2\n    grY20vLUL802nKzDpRZqesY30GUYmBwG9ZGr36Ct+W+d+MPHGxr7BNXIsbQPMqbaUhUWPLaW4OSk\n    nJbrBCtdu1dfiap1QtHK3Rq6bjPXdHbkb955jtj7gInilgguCmw+ehfFl+5NuykTbhzqGrj85SuU\n    /9l8F2OFO8zfoY9MngPrH91HdprmX7cZ5e//iKqsIBXqXaX6uiV3RZjAznO8jEniysTGuvV/dYxK\n    7k9b/5fvSq7/O8bmmY8jxtpZSs75hBuMru1ziICOm+ANxV/74qyXEduHwI6QEgs+lP3z2H6H+psD\n    +8T/9+E19lUMx+77ECLBJDzUeDqy/THW/41EOCx2BOz0LPj8ug+gB0vLshj7EOT2+zx8+aEfYwdx\n    6Kwi7p8HuphBb+jYZNBdo27/jrGBDmFICTwP+utW8ASNYev12smcRWm2FTJ2G+iX+7Gkc64mts01\n    lsmsrw4wT3qH6gBz3RXOsOTJuK0BLO15Yl6+ukD59OmB3rOEm4DigzOsv8Y1Xf0Irakr4OIvvkD1\n    PCUS3Cbkj+7i9OP3UKxcbUKh+SRgreq6wlYit4FTZx0t20rAmEnPEprc1CRxA6mtZwmYrtWjVgfz\n    bNanNPQRT+31gLPVq6pwYFqWs320s7nUlsxZe45uG/mbbZ8r1barcBaltISNJWDP1pxu76xzYsNR\n    RwjroLRW94pVpbWddnaamrBoaw6vCpz86F2s3kjqk1uFssbFP73CxX91w0F+4tQtbe1y1xnOfnIX\n    2ep6E5JPv3uG4s2VeubEumugBl7/xQtUz2LDmAmLQFFg85MPsH602RGxYVUo6FnLqlBtPZ6bu8/V\n    6ZWnMdtJO3LXtXVbypjbJYF1EpaoXHM1xgLy3cX9DTgi1ip7O2UV0E/w8ljaV9u3NufGxwfalq+F\n    SzbT8wYuceGStFyfTBprklknusnVrXbzHanPnMG933o81fMgvi8subz6ykNs/iy5aNwmVJ9v8fov\n    XSjeF+FwJB2onfskFO9vcPL160uiSjgObH/1WwCuim/zDJc7xzrNuSVCFrO6V37b+sG56cfW/xUL\n    55j6v1ZJHGofk9Zgt1n1rIuJeIT8aEJKY188NbS+u6/up57jkrx+qqXzUNsYO+lQ25A75rlnGeCP\n    1Q/FyPe1e2bOYU6n0ZuOuUlgFkh+MWNf++B+er8trl8B/PS6D+CIIIW4D4mrUBvPrRDeN7tmzhoB\n    sZlL+2RHMcYQtHZgD00eYiYLof1uPcu4XZ9tChOvvslX34QspOrldWNCb1zXV8CvK9OnrQcsbZjY\n    tXWAC1S76+gI3rzNi7Q2PBY6q9JfBxi4/M/fjDjrhKUhL4DTn9xX9pUWdrkd9ctPt3j9ty9Qb9ME\n    6TZh8623cPK1h2isCbXSR9QqgA44i7VkTQFNCXA6y0pNCmO3XJO6O9Xobl0FF0SuaButqHEBrxKZ\n    UUnYgKqfgBoDIYL5R9A3c6579iSBc61kAsTSU8LP1p6SayXLcmen7RS/HMjXSuJmvRDJTCj3kxTc\n    ipVOTdBb9rX66kNsvv3WtBsx4cZi+7sLvP6/Lzt3/HD9X3efr79xivWTGG+dwyLbFDj9+G4baXSJ\n    J3G6j+3TEq/+38s0jt4yFA/PsPn4PeRrRx5qpayuB+z8IQAmC92z3nlI1PQcrml0q+lZLHD1a9ll\n    IqPxGqo9JyFxkpX8sMW0D7Xat02gdfCNo7HKX33E3dd8nR3R7eoa2wQylzimba9teQpWSxedvTrF\n    Ll9Na/1s6/6KUlvex6p9x5pxtACQP9jg9GcfJheNW4R6W+P8b54NJg/Z5EFVYuE0x+kn95Gvx85y\n    ExaFcovtL34Pdoqr6Ld4UXCJMiaFrZjBQYsxJPZl42XOMa8arP9bqPY17JBg3fOswEPahGoFj8U2\n    sF3fsiGL6qE2K9TRwpsYB8gx2wENGRsbq75q++cY1HtsyziEq+kxO6X6cNOcaBP2xvwE8A2WQ996\n    jHlgLf2BKaTxXDV/+7axmVSHU+JqTKkDPGbCE5qEWQI3lvhFYDurFM57j7H/+Ku2lc1IDNcBZktn\n    WcYW05ItaSfU1e4cOLPSZlFKtqWYynHd4Aw1tr/4Leox0ZSExaF4vMbpR3eBnCucdcGqDv5dA7j8\n    +Qtsf5usoG8VigKbTz7E6uGmDUK6QGXeBjArFWzOUKFQpKtTzuQUknZBZAmGSq0+f3DZKnSt2tdR\n    mbL9JRGgtt6oo7G1worrE/vQp0biNqEnrhyHq0nsahRLoN327ztyDlRb0pjrHjrS1yqltJ00B6at\n    Pam9VmwnjbZd3pL/HLQGMhSPTnH6yQfAKgWtbxOq5yVe/n/O+jnoMgGnNJR20ra4n2Pz47vjszMO\n    hNVXT7H6UIetavMMqXvO9eIfXmP7qzSO3jasv/kmVl97rIhZIf/Y4cH5MehnNVdnZ4KHCV/rypBD\n    E8RSl92NPd3xo/mOwntyFtC+REFJTOIau7IP6dsHVg6HMDTW2nGPE5NshWKuheybXzDpy0R4hgxb\n    IV/peIQQlr5lPGa1ry7r4Ah7N+dw6mBL4uvyGXnznXhV4ORH76F4nFw0bhO2vznHxT/0yxzsfNN+\n    7k6+fQfr964/iSrhelE+/RzV56/gZlwSfwLYolnSZ3N6UnH77qytW/9341nGkFiYr/5vKA4npdZk\n    O0ZTom6c4GNr+gZ8DoC6vJsIWWJindLe7su3/5i47hDJ2wdxgrzAOCXvEEIuljFx8H1mwmPj7EP2\n    z1Vkf0OCM1EOC1+xr0DtOuETHC7NmfYm4uHVcEDXrwC+yZhDmj7nh+1u4Hiu0uPdPgznsll4NbB+\n    rPf/oQev0AA81OfFwLHxBMG3j5gsMNtmar0J3m5szd+hyZXPpjlmX+XAa4GdnNo6wBzKrtVyzjiU\n    5a4l4LIjrQ00K4GZ3GW1ryOCm9dircM2PawGLn//DNvnz0e8awlLxOY7d1C8v0cu5bbGq798hvpZ\n    soK+Tcgf3cX6x++hXq2IUIQKLmc7EhjISeWrQwcuKKoDoQWcraKvlqHUOeRgs9PVNNuUrW+CC1QX\n    aIIBTHZWZj6rFbPanpKVOVadzKRo3zK7vQSQXXDcoaZjwO5cSuQU4M47AXF3zqzeddvb+qTa/tm1\n    47UVmEBw7yXU9dOksLwnru6v26ZY59j85D0Uj+9cy/2bcD2otzVe//wVyt8240Vo3OGkjg5ZlAGb\n    H91B8WiFY0FWZDj9+C6ys1x9xlgNHNwWAErg1V+8RPVFsoK+TciKHGefPEHx+BTaTp9rsnMyjXhg\n    dNW/dqxB+8zVz3BJKOJxgccnLgAgpGi1G0sFbjzK2zYl3L3v1jvI30KacpkAn9PH0DjqG09lfGE7\n    aTleWyZBrjPac8zQTRjTyVJyZTiRSuvjWEHtCGWuQ1zAEbjuemkSWJLjZA7ExRXcHKn5e/XVh9j8\n    2dvXfSsnXCHq51u8/otniuHlz6cQdn3jTvFohbMfpXrRCcDlf/yqVfpy6poQr44E04SvFRZk7XJH\n    AkvMLDPbsP2zxLNENBGq/+tz1pPfPjto3tZC9t3nODiWLAacUIWJYtt/qHbw4Ptk9utzaIwhg9eo\n    R9UbHhPr7Ysm+VTD5yO2n4IhJ88hjmAM5qzp+2JE2+tAqgHs8HRk+6mC1yMpsXtzCOBj8e/e1888\n    BJHf36QPY9+DK/ahFvugHUPwsnpTtpvTBhoYHtzYWqOP9I0hmfsGbdmHDPKX0MTwWFsQtiSJtZ+2\n    VtMxlikr6ImPtZa2fTBhy/1Y8ERS2pwgXAc4tK2cmVb+ujrAPtscngSvaTLNKuGmva6mKX3ZiXtN\n    7aWVtYGuAFT/9Wsk3HKcFDj75D6yM1abxKMGUP/2Aud/+xz1NinKbxNOvvV2awWtg7OOEJQgqKiM\n    nPoF0NXJu+okVuVIAJxtpDlozBQk1y1sgqhdS0omha3yV+CrYehD5vkp6Meus58SZzupQwU2qM6E\n    sSiD5bgq6CA8twN0MFm/D44E54C21G5mJbAousqW1kXbnyh+WcXdVQe796342mOcfPPNK7tXE44A\n    NbD91QUu/rYJufhGm+bedH9b9X6NDKt31zj5zvHVLFy/s8bJd0/5dNXnuX90rVH+scTrv34JXKZx\n    9DYhf3jWJMPsrKBLQ9xaK+jaPLetUwOrXHWtd3cHVrvxQI+dziJaxhZJmJKxQZKPOElKK33d+MLt\n    BfyZsHd5hXHjqB6t6Xqa/vW47camEi5ljJPJQMuYIJZEMH4ecbkKGW/XkLIH2s1E3htJjHIW2l17\n    Zy6XIISw1A12SQFA8fAUp598iCy5aNwelDVe/90LlL/XdIpNtuiWU6C57SrD2U/vI7+b7ptbj7LE\n    5S9+BxYSOLVvDa7xW4Pr+GqXOhYrCKEbqv9rxROWwGXy1JZbs9syQqRuH5HbV/83ZnsffLHMGGVw\n    X7x0isPjPsrgvuPgJ0+fatjGu2MUxpuefuaOx++D6yZgl4a5avb68Pl1n9yycBgCeCwr/vS6L0NC\n    NIayWcagj/wdqxyeM/tH0DdI2cFtbC2CvgG1ryZDaMA/wTwYk9EWM/lwhG+3jrCvrW+db9K2MtvF\n    TOwKai/9+uoAC+qoyacjdtlGh/tne+fatHd1fSoz2dYTdzup50n69he/QV2lScxtx/q9DU7bgHoc\n    CWyDd+d/+wIX//4adbqdbg2yVYHTTz5A9uC0reuatUFOR/iKApRr4DmCUFSkHBTNWrJSW0Jz/Vmn\n    JBIClIPNsoyD12yNCTjiVf6uqD+rSKrQDfjOAds/70fIbFZqgf7mALxQu1yL0NU91iphsQ0VAkAC\n    0Vqd5H7LdXOkM9ec1MSEpCjl9LfYgrck8OMznH7yBFl+cxJJE/ZH9UWJV//rBepIswjfUJJvMpz9\n    9C6y1XHeO6d/fgerx92guv382nOTs7n4+9e4+MU5kOZltwon33gTxdcem6QbTuZxy5y1syMQRSfK\n    NXuZFHYJProesJC0ohZmi2YeHwBtAc2KWiaQQX9bpa8d43Tphv1R03Fx/1xOQn7s2C/H7LaRFDVt\n    Y12hsX5mApyvt7ueNpnK9SljpXs/+Ao69xSeN4mDhozrBQCsCmx+9G6yfr5luPzNOc7/Ji6iJipM\n    +zlbffUU668dXxJVwtVj+/wZyj88AwsI2P7ZxbOcoICtm8VhzpK8Em8S4YOt/2vrAzeWyroMGqCF\n    FXZ9TKqcVfTa2F17HSL6knPzCU6Gth+yemay1hf/ZMxNFF8MvGaMVeiOdcQ8tP0zi8KGBGKx/MBY\n    5e+c9s9DI8FViAOT/fPy8Cj82TjOL983CYfMdrgOzJENcyhP/KuwgZ6r5u8xwip1gXiVLyM02eHl\n    Q3WA+/pcjdh2qA4wZ+tZhW+oVrBMcDn851MfF7urylmPFbX3T2x1jV+n+uVj8ttAs2UPk82Xv/oc\n    1eubXIkiYS5sPrqH1VurSeG4GgAq4Px/fYHyT1ON4RNuIvJHd7H50btAUSjryrwlgV3QWqhH1u5w\n    kFTXPETbjoOwui5v3pK+K1rPyqYKLlDOlrKZ6Y9r/LLdsq3JyzX9fHaUY37k2DnADPM3Xw1t/ewU\n    Wt3awM5GkgkBPmfZTwZtb12b/sXKkokEJui1ylfbY8t+C7jRJz8pcPaz91E8TMHH24Tqosarv3qJ\n    8k9b+KjdLPC3bXPyrQ1WT463ZmF+VuD0x3eQFWGFYi9q4OVfvMT201RS4TYhy3OcfvIE+ePT9vkr\n    YyLXXpfndNkZSx2J6BJ6cjO+OreGmp7qjtx0y3WpBD1OCmy9eTuOAvr+t2OcHFNpxp0pP0KQunHH\n    kdDurB14HOXxXrbMPOcmxynXLN+Njey6weOeUO1c7sJnVw04hw6hgH0OGjwfqpDj5GsPcfLtZP18\n    m1A/3+L1//oC2OoxNESE8bxXUNwrcPrJfWTFfMkXCTcX5X/+WrnIceyI7Z/rdnnTtqJl7EondyO7\n    10l7iX3J+m6NahcXkziatLOCi5K2CdX/DZ4z/c3biJjExgWH+l0F2w0TuH19r+nvS9o2NDvsi77I\n    uhinx7HCpBjSdqhM4Rz7sHgduSyEsdxACLb+702HkMp3DnQ+h3LMPQSejmw/1f75iNBPAB+JT/Xi\n    YbMubpINdAzmqgO870M8NGDsk6nUhzXms4Fm2EHdZnmtULeTg6k0zqpne99EJ2bCFprshAhfS7jy\n    JC6mDnDX0tnfViadfjsaN0GWY8jRtXUGtCq3QvP+y7Ju/12it88GmrM23fImZFLVFS5/9ZvB65+w\n    fORnu6DACWskx6F+VuL1/36G+nWqY3ibsPmzt7H6ysOWFBTVis/GkpUvbBXtSGJRv7ht2f6Qa9IC\n    rn5wW1sWoEBrA1fDkOv8acPnXLXVBLWz09SQvqb8oLNf0PlkHbJXVLwr2k6UTKVqn9PRa4tsIW6t\n    orqm4DOrn21Nxq7NqJDSmoxg22gb7F5/6zHWX0/Wz7cKVY3Lfz/HxT+8ho8SDc0AbcvijQKnHx+/\n    2m39jVOsP3DeOvY8fOfLaho8r3Dxly9QvUpW0LcJxcMznH7yHvJ1gXr3XJWxTJ7Lrq66PJd1iQC2\n    EW6SgxxBahW3NY0XvDyDI3M5eUj2IKRt1zXDJRMxqesjea09835jqZ6xct9M6srYftk6UjB97vbf\n    df2AuhYyu+FEMxlNpUSCkODOwlmI+bwzjrLDhhDKMueRY8voSIEMq4cbnH7yIZCsn28N6m2NVz9/\n    gfIPLrriLMy7yHbf+tWyLMPmz+9i9XiNhIS6qnDxi9/COsWxYCCnmFGzxgkKxG3OxsDEtc7aP5dq\n    rbaLBrTLHt/VOfrjhD5lMYAdmYtOPzqe5sAOgX1RjHBMEopAFhTmmGxfl/CTsUz6hnAJf7w1RqTD\n    DpAx9swAeu2fxxK8Y4jmfeyf5yJy58AckpshIvlQxOxtw7GUkD0yHI8C+Ol1H8AR4RAE8FCfc1o7\n    C+auAzwGvjrAUzCnjcXQ67WZeIUQGrhjFLyXUcvj7UpiloUmUSEiN4bc9fULNenU6O6rVlYy1qaG\n    f9uaJiXcxFZ+Sxtdp1cyICuacnfXywRb6rNYux7fT6VeA9t//TVQp0BjArD+6hlOv9nUMIwhgfmu\n    kbvu4hev8fqfX6Eu08TptiBbFdj89EOsHmxgK/Q562Bd486pU3WNWK2k0WpUIURzNJnRbAEt0EFu\n    rQZyCmFnNQ3PegAU1NX9WkKUayKO+REFl+2Xg8xc91CfZ7feL4DOGTGBbq1ERcVsVc9CIocIeFZZ\n    sd0zH4MjG/Id8b4Lhn/pDJuffHDdt2vCFWP76Rav/2L4m0LfiJOvM5z97N6NqFmYrTKc/vQu8rtC\n    ro0/3/P/uMTF379CvU3j6G3Cyde/hPXXHwP0fNbP4rxNUGLbfXlGs0JUxjMZFXTSFXbLWIlqVaw6\n    IUlaucq5ts6vGzuZmOX6wLZfHktDY6UPtuZ9yI1DwPu1Y7srIcHq5Uydh7Th8Vb6k/bY9WEJexkj\n    HWnP74tzE5G/xfqZZyIy3mYAsCpw8vF7yB4dfzJMwny4/NU5Loz1c9/o4PvkrN47wea76b5JaFA+\n    f4by108hT2RH5DqSNmtfAxxLEjVwRct1/MlB+q3oNeCI23z3rYGFFUBX9etTDVuhR+ccI65DTOzQ\n    JzQZ61QYI3iJJUWHYqh99tEctx1j/xyLc/P7AvEEs0UsqTxFXTxnCcirtHVOSLhGHI4APiZ59NyF\n    ow8la7+qbI9jyiq5buPaOQelsXYb85+LH6HJxOVA29hz9fXD2XMyabJ9rzzbhNBXB9hm6g1lGTJ8\n    bXOaQPN6nszy5NYqgiuzDJ2+nEpYJusVvfYRvtmO9GUbaG6//Y8/oX7xPPq8E5aNzcf3sfqSfEI4\n    0BWHHDUu/vczbH99nuoB3yKs3misoPOiCVjWFNCs2uAx21q6oGfWBnCdGolr99UUBJXAqlPZaLWq\n    kKUSeC2Rt6qkHFwfEUQCO70swLnuXftn0PKudeQwmOi1CmS2m7bks4DrLnINQunPBexdAFyuJQfF\n    ZX/uWrl8f0vO1yoIzaSDs7VkJbYL/hPhfLLC2U/fR3H3eO17E+ZH9bLC+V++QP1MaVw7kBlL6JN0\n    8q0N1l+9OffO6q01Tr9/FjyhzPOXXX/+f19i+98X8YNvwo1Hluc4++R9FI85Ec89g+v2udqsZdUv\n    j2WiJLVjo9CTUlGWyzYAroQCbyPPfh5TuD49J05VPfez/OayBZzgFBpHQ6Qwj2WM3NN/Re1tklSp\n    Wms1MM9luOI9u2AIfSHHJOfC85xavQdCB0P1DSKz2XFD5kZyH6y//ggn30rWz7cJ9RdbnP/FF4An\n    sdaXvu2zfs7vFDj92X1kJ8cj4Em4Xmx/+V8qHiSxIlHriv2zfINgopj9l3T8yZHIXP+XCcC++r2N\n    +IFLnjV/cf3fmrbvi9vZ+r9AvLLX2j8X0HE4G5+MtZ+eUqNXbzt++zEx28uIbRmxYqc5SyLG9OVT\n    DI8RdfkcSH3LhriIuZxMjxVz1P+9qSVRn45sf0h+8+EMfX8a1+z2TSCO9QY9puLbQ8rdY81qickC\n    2sd+Yl/YbCrfuhDs4B3K7pKssCGit69vX59zYyjjbtWZOI7vgzMRgf6JnY9AbrZtjkJeS1tps1aT\n    5a4N9AraBpon19Zah617fDbQTiusJ+piA33+H7+e/X1KuJnI7q9w9j/uIz8dbwTdBvDPK7z6n1+g\n    +jzVA75NECtooWE5gMzKXiZeue5vToFOUcg6JY1Tn+ogKyt+cgqxAr7AtZDKVpVkg2XartLVVWRw\n    MFuOte+Hg+bWuo/JZ7t/wBG18rcLZjsVsASonV2lWHKyBaVcT23PrWsyo0MesOLXqs+4H1EvOZvu\n    pu3mO29g/bUvXfctmnCFqLc1Lv7+FS7/47K9z4e+OfpmWsUbBU5/chfZDStZuPnhGYp31/S0s+km\n    /hOSa1BtgVf/8wWqP6V6wLcJ2YMznP60sYJmcpcTqUr1LHZWz3X7CpB7rBlvRGOVERnqxo2qHQfa\n    o2jHDR5rnQmxIzkBPc7x+KOVvl0Slsc/qdc7ZSzVR+5IY58aGGDyWO+Lx0E3b9DlINy1b9q7shZu\n    LNX0sGtXt2ppPZ7KciF7feNtASB/dIqzjz9AVty+GNxtRb2t8PpvnqP6o//7lB0zfaNKlmfYfO8O\n    1u/dnCSqhAOj3OLyX34DKxjw2T8L4cr2zzWtc4SuLjXW1P2tlIiBY1OWKBaXPE3U1R0lsFvDMbc6\n    ioTleJyt/yu/x6qGt3DCEksU921jj5fXx8RiQ8tjYq9T7J/7+h1yqrTwxWhDfexTCpHvpeuM4x9b\n    /d+7E4/n0KVGb1L936vEEZXWvVmTz9vk433b6gDHKoHHZOHwgDGUMcSDjx28zj3LzzFPJlRfH0P1\n    IgQ86J8gHrb/y4H1Q8dkrVT84a5uNt4Ww4Qv28PEkLqx1Ut5kiiTY2v7LGsd6YuODXRhiF2Xidks\n    YRtowIUK7CQ8g56su2vmluv17ufyn38NlKlua0KD1ZfPcPKdO0DmrKBDsXebxdsGrz+9bOoBv0r3\n    1W1Btipw+tMPkT3YdCgPlyeeQ+oB57ROa4RcLT1HbHJtXlcnb0Vb+hQ7TN6y0klqGOo6tZk3oGyV\n    v53z3v32WVDaAHQfh8VtOChdmDZc75chgffVrhenApPXLvCvFdZM/jahdVdHWb9/WduvtQx1hL4m\n    9jOs3r6Dkx8/uYI7MOFYUNfA9tcXOP+r/hl61rM8A1BsdtbP947f+rlzDic57vz0DvJTfqL4iN/M\n    +406A1A+LfEq1QO+dVh99U2sv9lYQUsyjbhncDIUP5vZZliev0zcclkFgVufqfHWEpwy1ur68dJH\n    3qnzC+gSDbZMQwhTx1KbSAV0o1RCMss8QK6FWD9zHWImkWXrvPPZZZU0wAlqTDDz2Mn98LJyN+a6\n    RLUcTie8O6L1CpuP30P++M6V3YcJ14u6Bi7+/TUu/u6FiiyIqt2OCiH9/er9E5x9lKyfExzKp5+h\n    /MMzxNo/s9gAu//Z/tlXg1eI4RUqio85ctnW+pW4HN/Xsl2fqIOJYAHbLltXPW7rlLyeazTymvpi\n    lzGkdF98NDaeGkMGr1H3CncuMJ9wZ0oZxKtMT5nT/nlODAnlxhDJhywLekyOsAlXinwWuXEIY2XS\n    T6/5aowBZzccQlU89QM/NRskYTx8g5yd3KxRK7VuLGk8ts6CVQRfIq4+cHgSEa8gjplo+CZPnG3n\n    W2fRZwPt9qGJZEvkNtl6+hwl89EH//Iu+ewIYW0hXXqOpabjBLo20K5t1waaszKtDXT526fYPlta\n    6kjCZGTA6Y/voXhn7RaM7wLn//Ia5//0EvVlGltuC1Zv3MXmo3d3ChVHCIqaiKvVsupI6h1qo0pd\n    t5BrBGsllK4rXKlgq7PD1EQxwMoeJo+1/WLXolLqetqA3BBswFoU8+6aOBUUwHUOteIr9/Qs67cU\n    yO7uWau6+DxFOVa0x2ctKP1qbOyur6v7ywaXGbLNCpufPkF+Z0yKWcJNR/V0i1f/8wXqrf6cuMCe\n    NkG2P/LX6lunN8r62WL1ZIPVt06Hr1fPE+Tylxc4/7tXqNI4emuQFxlOf/IE2Rtn0ORjN+mGE5gq\n    81qezV1qlMcCR3Tyc71UI6VW1GoVrFb/yrYltGWzqFh5vJtjLLXLbIkFnnPImOYcMNyWcra6bq/b\n    lvt2ZHreXg9Zz6perq/M1s4Vus4ZLjmu2UYIf+lr9fVH2HzzzYPfewnHg/LpJc7/1xd+n2fEfW7y\n    uznOfnofOLl5SVQJh8PFv2r7Z1bnsv0zE8ESc5JlbP/MKl8RRGQ7AYNzuXPrAeeKt4YuhwZYpW6D\n    Ct2SamMwZP8cqids7Z45Xjvkz+Kr/8vbcJx07PnY7fuW8fHH9tUXw12jnuRKORa2v6kCqn3tn/tw\n    XSUpfWTxVRKzx+RAyzhWx96FYFgBfERy5cXjuj+E/BC6Shtofujua69wbNlAITXxlMGVB/EY0jXU\n    Zmjb2Ey1bc/ftp5GrPndkJ0K4Cdlh/q3ZO1QG0CTsXYyy6+1DbS2jREieAtHCLMSmMlca9Pjs4GW\n    DM2uDXSzzeUv/yvySifcBmSnBc5+9gD/P3tv3ic3cX0PH229zOIVMGYJkABfliQQsE3y/p9fMGbJ\n    CmGHAGEJmAy2p3epnj/UV3XrqkpLb9PTXYfPMN1SSd3TnlGV7rnnnOCA2wk2A/9rGL39ANNvRj4P\n    eI/Q/b9HkDx5AVRozkQRFKUirC6EKlYgNdU0WikDUbjlObXl7DNT7USFa02C6n1AdYYhVzlxcpaP\n    qfrS70EfzzN7dYHatHtOYRao88emxpoIav5u9OzAP7/A+m651adUawfF56qzDk31mS5SaxVTflTn\n    xauIn7x8dr+MHhuHGmcYvTtA+rNcMUmdnv13kbZHD8Xov35w7qyfJfqv9RFdi1sdwz8pBWDy3gCT\n    L8fwE+n+IDzuof/6dQSdqJgT+Ryp5rSrnvlMYpFHInB7Yt3Iw+2Z9fWfj6PXAPT8YxKsZY8Y7bKh\n    t/Hc3sD4GRafS1G8H03akpLXbLaiORUGGc0bwuhn5/O7fif083A3DdNdgztmBMbnp4n1lM2relY1\n    1cH0+XNFtkKA8FIPvdefACJP4u0L8nn0PtT9tLLyYvubKPaFATq/PUT86PltovJYPdR0ghmzf85A\n    il/tLhcVYQGZ4TbHgwS4/TP5EnH75xCmPTSRyxzS/pkEKFLwAHE+U0WM0lgbmcrH2uyfzTFlx0BZ\n    L3Tl/zapW1aRvTaCOIZaSClcJ8RpZ//cbKysX8vXcNk/t61vt7F/Xgf2Lf/Xy4Q0TlqOX2f+74Zx\n    viyg9wG862Odf6Sb6i7hhO6qLqJnYQNdN77J9ibn5hOszPKVmGAxtCGSab9t8bFIlxtQXlTReeLS\n    4qxsFy2Pq1IKy+/296xKY3VGit6eie0JTOubkC1EeWcl5l2PIRRiZgOtOy8zkEW0toHOQAt6ej29\n    UKcclnyctIGefPIdMPOZrR4ayeNd9F46AEJ70Y3gMqcMoaBmCoM/38Psrv/d2heESYTezScQHnWM\n    wqbNSjgr6EtORJrqpoxt1wSjaW1MR/O8Wiq4cmUPqZQ4IZvBJEFlhmHxc4nzEMhKuskX/1vh5+Pg\n    5C+gLZ1NhTRP7DKtKIN5aYQXzHkxWttHc9LX/OJnkzmEPP9XJzjn37kiO370EN1XHzv3BJ5HC6QK\n    049HmH4yLs0Z9rtG+y9HeBCg/8YBwoPzT3iEBxEObh4g6C9+36xSYHT7FNMffR7wPiF+5io6z10y\n    CF4iCOm6zN0h8nsG7V7BFavyWm5vrioraHOExvVezxWmXTQnLmPj9evnOaDdXJpCN1Nx9TG/V1Ps\n    NbT1M0TzGb13U8Ws1wD0s+vPkY+h3Hub2peOTxlRr51E9Nojg45doLxnes0widB7/Tqii/2z/nX0\n    2BQyhclnQ6Sf2KUJNstziQABksc66P/eWz97mEj/+yOm98cFycsjwvSdBaBpWKkSNpXDZuxYmagl\n    dS8nbjkZTGpeLXRAcR57tJqGQrPsX6BK2Wv5jFp8njFMEYqNGJ45jy2/d3ke2zmmjscucPtnOq+s\n    Be+T/XNdXf8sVL2rtH+uwjbl/3K1rs//XQzrdGS2YD8J4H2VlW9718cqLtRdqEIFvIqg+LpzrCIH\n    mNB2spXdV7QI4KRtAjeBS3Dta7PQUbCTtFXH68VRc4UwwUbq0sKNnrfNAeZKX6CcNcL3ZZbzS7tn\n    aQNdfg39PokYzsBJOb4w1+NlnkvGFvTp3QeY/HS35afpsevovnKE+Il8aR6gHZNDo7N7KUZv3UM2\n    8HnA+4LooSP0XrkGFUVFYTMrSqCm/SERvKYdsaZ2tRW0adVMlsVUzCVil2wmSU1DheuYnRXQLTPS\n    +pGK2DyjWImCL6egFwE316RzpjALy/lcEUJbUpYLfvo90ydrKp7pe1FMLhRG+nhtN6lJXmmFzdXY\n    Wm1t7s/4mfsJerceR9RP4LE/mP4wxfAdvSIvr+rq55AgAjov95H8andUS/GTXSQv9oCg+SwqVcB4\n    kGF0+xTZAz+P7gvCKEDvD48jnFtB84YoTVrqa7LMliVVq7T9NwnjfM7Mr9TawpnbHmuYUQ6ZGMOb\n    jTS5ac6xpqNFmQRu/Rmx73xu101Oej5XxWMNPk9m83UCfaZBQdyadtKmU4f+TLka23Q30Z89uWno\n    95H/O6RzQ1R+DObWz53feOvnfcL0xykGd/LKm5xDm80fAcKjEP1bxwji/azXetihMoXxR1/lj4Wo\n    IGNtPYD2iSDClwsRYIzltam8ZkXCBa4c1Wrg4t0Y4hWqwVHlitfCZKN5Vc2Q1xXrCGSguo5oU6u2\n    cSbk77WK0OWvU3XXVOe06MpK5mOaBPLU2T9zUD3bVoueYHX1bm//fHaQPNBZO8+uG8dbxPdtmaPy\n    +hcU+5IDvCrIP8ZtJ21XhbYX301YMjSZpJqUtmQOMIEmWZfNhs3SwzWZJw0WBU0WF01tSmznsS2m\n    eDdd0wVY1aKsTcmME7c8Z8T2PkK20OQgojdki19bt2MoFsf06dA5yAY6RlaygdaKXt1RabOB1roz\n    snxWhl0P7Z9+8AVUtj2TnsfZI+iE6P/xGOElrU/Iv5uQN2fyt2j21RjjD06hZv73a1/QfeEauk8c\n    GYQhL1BzlQu3gEZRvAU7Ln/MVUr0nYrYdM60KJ1qaLWNPk9WkNIoxkv1j/xOr8mzjalM0uSLH6Ot\n    lnkeYQ4yX6PXNnOLzeI211BLa02eoSzzIrltM//8qfhPKmIq6wfgZHiZ+C00x0GI7ktXET9+6ax/\n    BT02iOx+iuFbp8hGvO1MQ/6Ou5D8qoPuKwdn/eOsHAev9hE/FheNKm2F8QrA7D9TjP7u84D3CeFx\n    D72bjyHo8DVYeR5w2f7TeNNBouyUkQry0bT35/SnaW3MSUtO6MpGKw5Tzbu6uZTOzedtSUDL95ay\n    n107hLgbqej8EYKCNKems5TN6Xp+Lttzh9BuGmZOs7aBVggRXs6tn4PIk3j7AvVghtFb9xAMF2/0\n    CSOg8/sjRNd2p4nKYzVQpw8w+fS/kMpfLkKQFs8KFABjWjxzq2cl9nF7aBlJRs53NJ7EDkTUccKX\n    PGDoNXhtTf6FVPnF1EW4SbLY5fpHP0M8r83V2URXoakv2qqUuRyTmueLvtdFUGf/bBNU1Tlvrtv+\n    uQ67Zv/Mscmc4bbYV6HmBpEvRjcsO95JrOOXdVHyd1FbAIl15AC3uZjaxq6jS4dPOotkF8hJa5Wq\n    4LaT9aJWIE1ep+3ipe14vuCSnXZSYSxJXRcWufWSNtAcfHsEbQNNX3U20DJHRdtAgy3QdV6LXLzz\n    LBee08Jtfyaf/hfq9MECP7nHLiO+2kH/xjGCXruSNf0V0A3V5D2fB7xPCDoRurceR3CYCPKXsgX1\n    Y2lHKVWnASuMUhlbF00BXXg2C+O8cG1m8uXH8Ow+2i5VTYBpXylzg9uUZqW1tKmt0mMyVpDmCl8F\n    nq1o/lxEfhPBFEOruwA5A5g5hWZ2pFaXEanOVU9cT0Ykccb+zeLHjtB75fq6f708tgjZRGH01wHS\n    72eVxGYd8RleidF/4xBhsnu+4UE3RO/WIcLDkF3XGh7Lvk/+McT0y0VM9jzOK+KnriB57jIoP1a7\n    LZi2zjk44RiyOSQwrtO8mY/mN5pDZD4ukb4pQmNuouMBsm/WZ9aWy2RdbY7nj1c5l/I5nO/n4J9D\n    JM7Fm61kI1UAbqkNzOafhySk9Xytc3/L9tuSrKfXnK+NvPXz/mGWYfTPU0z/M0Hh/CCQZ167ESBA\n    8kwP3Ze89bNHGePP/g2VpgbJy2tCRLLq/+dXQS4sCNl3af8MaKUvCRcALWjgtS+gXP/i5wCqhRfa\n    /rkssnCfx7SMbmv/XM4Bls+rBSucNLbtd9c/zZi/JrCNc51/2azg8YLHAXZB1DL18FHFtib2z3Xo\n    Q2GA5rzCqqybOWw8yqaI2XWof9dl//zLOj+Ihjhv+b+Xqt9vs2X6lsmWdx7HG3od20VmEVJ3VaCL\n    8CousjxxZRUdRC61bn7+anRg2qOssuTj6vayLQ6mLcYSZqi3KqFFD51fZvPaO+ns+b4yB7gq45ej\n    rsuvGnrx2cYGOmEkNCeDXTbQ/BxSJcztngPxnRbvVOLXJHR50R8gg0pTTD77d4Of22PfkDx7gO4L\n    BwjCdlbQeUEwR5oCwzfvIzvxecD7gvihC+i/8jBUFIG0qkQaSsUvzwOmfZTMa5KQZh4wL7ISuCaJ\n    F1sl2QvowrW0uiTVVMjeB1dBAWbhumpVLFVH/BxaX6sLyFSUVtAK37zwJy03KQMyLMZpNXRZZcUJ\n    b65M4rmF9NlmCDFDVBS8ubVowN5bNqflgQA47KB383GEXW/9vDfIFKZfjDF5X5ddXIVr5dgHBAgP\n    Qxz88QDh5Ri7iuTRBP3f9xDMf8Q2auCCEMiA4VsDpHd9HvC+IIwC9F57HPGVHniDFL82k2UxD1DQ\n    zT2mCwdd96UqOAKKa78ZraDnOU5uSpvojM2lXCnMXSYCmDEEq5xLwd4Xt34mZbH+vOyNVDTn05qC\n    IiV4q5n+XHg0RGB8kjbnDZrnU7aWUez9yqzhzrOXkHjr572BUsD0qxHGfzttcYdlIkCA6GqM/q0L\n    O9lE5bEcsvEE0w++AV+NUY0oFM/NWpgWIHD/hrxOpYUI0v4ZxTFg59DbeX3TRtTSNh6d1kTAAWhF\n    L2Cv/TVZPckxrte1nUvWKG2Ia/ZNG4znY3jdko91OT02IWdd53LVtvnzOlXxojiL9sdlRWjLYh0k\n    clPsi6NsU5yc9Rs4W2zGjmYbWfNVKXY3EXZ9Hv9oqzpqqi6qq8oBrkJdru+45fimqJpEXdkLCaqt\n    mKdirD6ffXsTVS4/Jx8/Rf1Cpw62RVROMtejaqEX14zhdjCurkCZ80HIjHOYi1u+ME3YfpsNNC0E\n    teUNz2hJjc5MvainV6PzNFnsK0w+/AbZZF3LNo/ziiAA+q8fIX6qlz+3qipsEH8TJzOM3r0PNa7q\n    YffYJXRefAzJE8cwKU+dWssJSbJl5jmHAFf2moVXTkySkonbGJepFfO8fDzP2uW/ncp456YSOBA/\n    T+j4Mn9mqYIKjNdKxWvQ+6TPhNtHZuwT1IrCoLCizKA/W9Oe01RX84xCTXxrMlm//9A4LisK7IAK\n    QvR/9xCS67ueDuTBMftxhtFbp4Bqb2ucI0CQAN3f9ZE8tfuWlZ2X+0ie0SttmiHb2EKr+ymGd06R\n    Df08ui+Ijrro33oM6ORXf50jq+cViGs1nxtMchTgalTt9AA2JwTG/EhNRly5znPjQ+g5nMB/n7VC\n    GMWr83GrnEulepLbQOdzLJ8fUXw2XNmst5vzKc2/YD+7zdIa7B3Sdv7vRZ+ZJPQN6+fQWz/vC2Y/\n    TzF48z6yzB6hUI8AQS9A7+Yxwou720TlsThm33+P2S+Dol40gxYccAtn2xe3YOZRZLAcK8UK0v6Z\n    5wiTyIHqjba8X9MFT9o/m38puSrYhGssiU4imPU3l8CEIO2frZ+1eC6PsTkXrgs2MpljAjSuFy8L\n    Ka6ps3+uwyqdM3cJq+Z/1sEnebvmetQJac/AidkvSj2qcZbdKuuAixxeZvJZZNJr83pVk3Yd6Tqt\n    eC7J3bbnJvBFj0v52yZXgxZY8n1UdeJVLcJs3YPKMUY+J/tl1/7I2K8VwXwxTot0WmzH8z16uc3f\n    i16YS+tn+UWLcVIZ887O2f8GyL7/vtG/n8eeoROh/6djRFepuFBfriblIlFLCsDkkxHGnwyAdLfm\n    CA87gk6E/s3HEBx2mBpHq2C4rpRUS2YxtZwHTAVpnZmnycqQjcmEethUDgWIgUL1RNaRir0O5ttS\n    cMXS6pQVciU9ZQSrmSeoVUhcGQzkNpQ8p5AKydLaks5J5w3E58kzIPl+Itx5sZqrrOjfJXnyCN2X\n    vfXzPiE7TTG6c4rstKz3aIYACID42S56v9sPq9MgCdB/4xDJw1FBqPHPrM5Cm0i06ZcTTD8YQs38\n    PLovSJ66guT5y8X1Xyp69QyhG3mICEYxR+g5gJOPEcwMW4XAmBvpd5WTwmDb5avzZiI63xSh0eC0\n    ykqSJH9NItps9KKfK57v5XMsd7bIinlRq3wBGM1ifE6leVLnLkdsTtbEO9lil6MqAoRJhO7NxxAe\n    9zb7y+VxZlDDFOM795DdS0HtHS7QTGuOCBAEQPfFAyRP78c86tEOKssw/deXAPLZQseGyRqRWX8i\n    pa8tNozCfKj+xLN5uf0zJ4U5wUt1L9pG423OeRD7tP1zPeR5qO7H2ySa2D7b7J9dpG7tv0dNPZJq\n    q7KeOhWPXU6LbUjbac3zNuB17WXtn8dYXkjFa/fDhsdUCcra2j83RbYhzmTZqM91OM2uShC5jYTy\n    NgpZl4Retm9TDvBJxb7jLXqfEqv6pT2E2pgN9CbQhkSWF+NN5QA3QZUNtEQz6+HF8hbkpL6oztNF\n    BtuwaJZwnb00YBK7bUhjmQNcHm+qdPV5y4jYWNmlyF9PnjcR74HnovDz2BbTegGtF9+889JmB807\n    MG220ZosBkb/+nfu1+vhIRBdTNC/dYzgIIStUO3SI8mxwzsPMP3eK833BfHDF9D7/cPIgqggFrli\n    VZO0YaFu5YojbvNMqhtuWywJTF60ptWqqWYipW9g7KdtZoZhDl6kDYQSVjX8Ko/VltcpwiK3l4rU\n    0h6Tvw8qUEv1FH2qWTGThEbhOWSfOc+TlCpgboOpyQQz97cYe9RF7+bjCDq2WdJjF5FNFcb/HGL2\n    TftyETduTa7HOLh1AMT7Y1kZHkfo/fEQwSG/xpmfT9WnQSTw8L0hZl+Pobb39tZjlQgD9F97HJ2H\n    +8WcmUGHFMjGHq705bMhjY3mo3TUgJkrrBuoNNnM51XZYGU2IqF4DzS3xqB51Zxjlp9LzeYlej2T\n    0DXze+X8T81XgJ77iSTmKl8+76q5opc3n5nWzvrz5xEKOg9Yr2+IFO48ewnJ0976eV+gZgqjfw0w\n    WSLXPQAQP9FF/7UjBPszjXq0QHbvF0y+/Bm8VkQ5wLrNU0eCASbpKzODc+e5VBDD+Wwia2nc/pmE\n    Dgk4yWu3f5bEMB3vAq/tcTIajuObRsVVjeewiU7akMLun82+vcnK2+bkOEE7+2c5tklNe9XVnabi\n    pzrCeBXRjmeNTeb/nkcnWY+1onnfZp18+TzC20AvnwO8jm6XAZZXHtPk4JpEVmXr3BaL2EADzW09\n    bIsB28Rfdx6OmWNM1XuSCyAbsVu2Y3G/rkQbWpMvaPmi0vaelVj40WvxrkhJLIcwCWG+yOMWOxnb\n    FopFM2l5yQaaZ/qaVjswFvC2xX84fz794i7SX35p8Ul57BOSp/vovpwX7JuqIbnNJQBgnGF4+x7U\n    PZ9juC/ovnQdnSeOoAvSWgETGkVdaQFtqnIVKzpDFHrNIq1Q1oAXrrVNtB5nZuzyDEOyheYrX02m\n    6lzCui9zLFcZm0S1jXTWmYuaPCclE99OP5vMiaS/vrQoV9NrcQtu89+DF/alOqp4zTBC75VHkDyy\n    S+2HHlVQCph+Ocbkr3lPvW5UaAKmuLsQovvHQ4QH+9c4ED/RKfKAbSSwC/yzVjOF4e0BshM/j+4L\n    wsMueq9fR9iJi2uwmW/LLZvLhCld63nrkJ5T83No9wit4s3E8TT/cLUvWRjzeRvQc65+zH4eBI75\n    sdlcGonnpt2zOY/z+Z3WGNQ8xo2b9c+tYynoc+F5vvQzUm4yb1TTriM6ikHul01Z8ZUeuq8/gTDy\n    LN4+QClg9t0I43cf6G0V4/nfDXekCS5EOPjj8dwe3sNDQClMPvwcSmUWItcUAdB+KSggJy+aLbjn\n    C1cR03/kbsfd6rjQgcanMEk5l/0zgBKp63Ltq9vGj+VkMd9O71mSurL+aBOc2Oyf4djPRT+JY3yT\n    bVXiIaq/diz76uyf26COpG0qcFrV660K68j0bYNdc1T1ONfYnAX0DsqnN4JFid9l7QF2DU26hWyT\n    EG2rI4yrjrVhjOaTXh15Kyf9idhepcp1LRi4bYktN0OCL7Jci6YqRa9rm4tIlorbOtjGhI6fXVpG\n    mzkoOTiJm6BsA807Kcmmh+/jNtB6MW52TQbsZ9PvwVzcK2ObufhXKsPkX5/Dy0o8XOi9eoTur915\n    wDYE0CVuBSD97xTDvz6Amvgcw31A0InQu/U4gsMOysSkzSJRG0pqw8syMakzg8FUs2WFEH0FgKG0\n    DVhBV6tjzTxcTkBrota0mWwDXojm1pRc98dzjnXRW+9Pi+K/mV/Mx3Kym4rznFgPxGdLnxw31Czn\n    Lprbuk8do/viI2f3i+WxcWQ/5bm/WctLN/9rCROg/1ofybWk3Ul2CN3f9hH/JjfBW4QEDgCkJylG\n    7w6gRn4e3RfET11B9/+4FXRYavohstKcw/Rdgmk9rJWoZAXNSeUEel4h8pQrfzUkecy/548zlOMN\n    lplHyVKak8Daolo3RekmMD3DcWUyfV56rWCqds38Y6541gpe/fNq8lfv068vG64UwjxixVs/7xWy\n    X6YYvnkf2Uwt+BcQAJ0AvT8cInqos9AZPHYf6WCAyYffgru/Zaz+w4ngrLhHz6/yWgtsWkLrlYqZ\n    5Zshd6yToSC81sXrbzLz12X/zGtnVDe0CzJMSAc+gi0l23a+pjXGOhKVH1MXnTdteM46JJY6rETT\n    uD86n01otEyGr0SVoKkpXHX7unp+D6rW/hk4OzfRTUPySKts8SYh5Xmzfz7ZyKvk2GT+793mQ30G\n    8DZD/pGelcAYwVQAAIAASURBVIR/010rTWygm2AdFhEuy4xuxViCi8h1TcRtbKBtaHIbsUxGBFCv\n    Am6rZ6Bjyue1K3P5cbbvVTbQKXvMxxKqbKD5opbUwWYHotmNSItlWlTzDkiuEqbFOf9OOb/6EY0v\n    E7+ZsahXmHz4HbJBG02/xz4hiEP0bx4jeqh5HrBt1Pj9AaZfDIHMNxvsA+JHtBU0t5mkIqi2VgwM\n    gjaHtirmhCQRxVyRQyVWInr5ipUXhhU06VlWGJmkMilmYTlfVhTFq79kXiDmr8PfYwSTjAY0GczJ\n    Yv4eyp9L/iwrCtB6H1cLq+IsukjO7UKJRJf5vzQuOu6ie/NxhIlXnuwLsmGG4dunUPfNVU7dFZwr\n    8RAAyXNddF7c87zCOED/5gGSa5qua0oFGHnAn4wx/XgIpH4e3QuEATp/uI7oap/FANhdMygywTSH\n    5o1RZiOQdnvQ+bcyXkF6v3BSFzDnK3K7oBlCNjPJfPo2c6mEnsPMZjA+r/P2Jk7i8vdPY7nilxPJ\n    mL9XHWHBE4hD9rhMCoOtcfj2znOXkfzaWz/vC9Q4w+i9+0jv6mpHk+xfsNEBgO5veuj+3+FZ/zge\n    W4zJZ/9GOpyCq3Rllq/tK5uP03UigFZ68VygwPfFcx+EiI3j9TCqr3H7Z6m4ddk/88g0oEzANrF/\n    Btrl9FYdF8N+Lq5ydb0W1SmbvZcyMVyHKoK5vTVzszVlx0EO16HqmCoBlU0ItQmHzrbkL+dBXMe2\n    qbQuY/+8qMDv/grOcZ6wzZGxWwBz4V3HQnsbaDc2YQO9LixrA70uVBHPA9QTw66g+Dp76E2iqQq4\n    bsEwcTy3EbSuc9Xl9TbpjKs6v80GmhO7+WssBzpeLsgkcetaXJINNF/QEqpsoLmCN2GvQceViWPF\n    uis10Rszgpf2kdo3g17QS9sfafVTKI4nU0w/+/eSn6rHLiO4EKP/xoVSHnATHRIfP3zrPmZ3l20p\n    8Tgv6L50HcnjRyA1qlb1AjzTkJOTUqXErSZz+0VT6UMG+NoqGgiNgqwGt7eU5Kwt05BIYE4u089R\n    ZVnJ90fiXBqkDKIit/nZAGZhOix+3qAo2JOVpxIFaNOmk5fwA+MnsFmGymI1EABxhM5r1xBf9cXH\n    fYGaKUw/GGL270lBPgItyV8A8fUYvZsHZ/3jbAWi4wi9N/I8YKBpK1UZg3eGmH7v59F9QXTYRe+N\n    xxF2YsByfebkLid8ub0/v/Lz47gZslbp6vlFO05oUpjsl3lTFSdsA5TnX5r/6Hg5T7rmUT6Gu3kQ\n    bPM3n99dBLL+mein5+fhyl2z4SqA2VAl5089Jj87rXEoRzm+2kfv9SfO+lfKY1NIFcafDDD5KK8m\n    LXLNDwDE1xL0blxA4C3DPRxQkzGm//w3Coe3ouaTzetB5CrHXbqk0rdMGMt6FtWouFCB2z+TLTQX\n    OnD7Z20Lbda9OIEslcN1kGNlNm+Ecn2P3mv+s5hkbiyOq4JrTNMc4bptfKXHSWdXvZULexLH+HWs\n    HjviM7Xta3oOoJ0yeBVirk3YP1dxFtti/+wDntpjRx2Mt1cBfHLWb2BBrFq+fp7/WJexV9gma4Ym\n    NtAuS+dVWWrUWYC4coBpsSBzgJssFqq2V72XJtnATbv3+LjYsQAJHYtBiTYLTnmM7rTUIFUukC9Q\n    eCZKCFMBzDss+XbdlamPsy3OA/FdE8MAvyGgvnt+QzD659fIJqs0d/HYNSS/6qH720MEUTMraJs+\n    PzvNMLpzH2rQ5i/M47wiIKvDgwQ8N1CbWWoCUmubZK6gSRhrpY5WAFPxlyuL1PxcvHAdoUyWcnCF\n    EM9YlJbNXOFr+6JCOM8W5Lm/dC5uD60pcK7t0nmD3P5SZjIG7DPkxemM7eNEgSR66f9ECGRz4p3+\n    vTpPX0D/ea9Y2hsoYPb1GKP3Bq3uVqS1cXghRG9Pc39diB/XecBAOxUwQY0Vhm+eIrvn59F9QfKr\n    y+i+cHk+H5hW/TIywcxz19d+GkN/jXxMCHNOpfmF5qUUpnNHBD57aDtmgBO0AbiThrZxLjtlVM+j\n    +ly8cUtn3Jebq+g7/by8kYo3U5WdOkzLZ62C1usWbokdgs/Y9n8b2hd2IvRuPIbw0OYH5rGLmH4/\n    wfDOg2JObGb8rxEgQHgYovfGBYRHfh71cGP2zbfIfhlCqnt5Dm9QtO5oaQHVkbiPXFA8o7qRJoFD\n    KExB0TiYb8sMIQOvcZGYgqt8q1oJpf2zLf+3w94L/y7rh7E4zvnZzb+X7Z5hPa8NMt6O10ebEMlV\n    522CVZG60lmyyqp5gvoIQsDugOk65zIYoRkZ3MT+eV+wCefY82b/vEls0v65JbaXAPawo80f86Yk\n    /tkaX4cu1qvo3mnTRTReYF/VbR9NsglUoc4dW84pSeQmky9Qv4iYNjzWZTnSZJHCF0F8oVSnHpaL\n    M24DzQlduThz2UHHpf3mgjN0HMfH0gK3ygaaE9HSBprOIW2gaSzmi2y5oM67K3XHpraCzmCqe+l8\n    vPPTvBkotv0ywOybb2v//Tz2G71XDpE8Y+YBt00jnH41xuiDAdRs9xZyHmUkj15A9+WHoIL8apmr\n    eLlBoyaGZdFa5gFzhVNenNUFWiJRucII0NbIVOSlQnVojDdtlmPwDECudGqm4JBW1FxnpQsS0joz\n    L09T1jHPctTnMQv+MtuXq724NShXO9lyf1Xx6gAVvaknP77UQffGE0Dsi4/7gux/MwxuD6DmC6om\n    6t8S+ZsAvVf3O/fXhe5v+4if0XcDTfOA87HzPOAfZxj9dQA18XnA+4AgALp/eAzRIwelaz/l/crM\n    dh6ToNgxWUGcApzwLOfE60at4n2AxxNowpPnBuuRdK8VGGQyUJ4jXYjYGfk8nBlzKZ0vYPO/+Z7S\n    +XymFc0w1gvmz8GbqcrNZmYDm/kZlBupmPXz85fQefrKWf8qeWwI2b0ZhrfvAWN9jabfBut48TxA\n    AMQBOq8cIXncNw14VCCdYfL+l9YcX9MlLr8yZWw73XmFbDwRuhDnM+tJKF6DalrkjEd1ppRtozOB\n    jW1r/wy0E2rYCNsmRLBrG9UpXbVMvq9O4evK/21C5Mbz+iAc53A5PrpxdvWYtk6bNH5R1W8TrqCJ\n    wGwTimGOpvbPy+A8Cwo96tEi/xewLdHXaQN9ljLqXyr27ZMNtItArrv4LNs1s46um2VUwi4b6KZW\n    Fk2xyvNNa563WRRMHdvqFiu0v2pxwvfLBZ5tASaPlzbQVV15Vdkgdcd1YM8W4dnFnNDli1nbojdi\n    XZFyG/VeagVvfmQ838PzWXTXY3nxThQC9W4GzEZaftHrKQDTf34JzLytoIcbQRyif+sCoqvN8oB5\n    oYNyDAFg9N4DzL4ZQXkOeC/Q/92jSB47AlfWcGVMJuhJsk0EdGG7bF9JVtAhK2fLL100NhW4OueP\n    iFau+s2gi8L6TNqimRRF0rJSK430O+BK3RC5kkraT3OlE70mvV99fqlOgvGYv2oIyh80c38D8PzD\n    0Pg8C5USJ4STEP3XriG6vOf5rXuEbJRh8M4A6iQtyEagnvzlY4IAiJ/tovNC76x/nO1EHODgjQNE\n    D+umikVI4MkHY0w+GwOZn0j3AeFBBwc3ryPoxmyODIr5UxK51EhEI835NzQasQj2+UU3TPF5iZ9T\n    zmE669ckjyPxik3mUtPGOn8eA0zLZs7jRPIqmApkOpe2kTYbqnKHkLC0TqFzZOwTkM1W3HrbbBeb\n    O5dc7aP32hNA6C189wFqmmH0twdI/zttPI8CnATOj+g+20PvZR+94VGN2U93Mf7mfyDyVjb+8/oR\n    rTSCggY2x2r1r1b+8roWZQBzm2cSQ6RsHBc8mEIVu/0zh0spHMJNCBO4UIS+c6GFy/6ZC0usn7Hl\n    sYvs5WNV7V+9WwTTpCLncm7k25sKfAhNBU5SgGQ7zpYZ7Nq2CgwXOGYTZO6y+b9N0UbYt2717y4q\n    dvcIXgF8HrEJST+w3hzgVV2QN9Wls4wNtERTVa/tuKZ2IU0WDS40yfBFzRhpl8Jh6xZ0vYbr57XZ\n    x7TJEuEIHa/Bx5L9jS3Ll8Yl7DGN5wtmvpjmi2hadBORS4t5bTFtkrr5DWc+OmDbI8Pix7xJmPzn\n    BJP//tjgE/LYZ4QXY/RuHiPo60IXFS0al7ZSheGb95Gd+IaDvUA3Qf9WbgXNc30VK6DKYjZXHnHb\n    Zm5DKS0nZeFaU6BmhqFUFEnyVZLAvCCcFgXgMmgbL0DzHnvT0pIgPwFthK0JabMgTQXsoHiPIRQr\n    5tuUwDTDUJHbRqZL5Vj8zEUkz3rr571BqjD9cIjpZ+PGK1CbOi+5HqN/68DnFVYgPI7Qf+MQ4WE5\n    g7UKhhW0Uhi8NcDsx6aBKR7nHfGTl9F56Sr7fcnntkxc/2k2IccNcpeQpKU+JizmZlLY8uxbGR3A\n    zZf5WbWTRA4iWjNGrEpytmou5Y1Zel7X5G/VOoAIZz7/08+k5z+U3k8Gvi7RDWj018dtn7mymj4/\n    mfsbUhSGt37eD2QKky9GGL/fToKg/27mNuyPJOjdvIAg9vOoRwXSFOO/fwaA7sZN9S+PF8sFAeYY\n    hfx6OoOuMQE5ycuPJeJXOtbRPg0dJ2fP8lXWmhqvoblIU15zKzvtVQtF5PEEl+pXEsl1tVV+TF1l\n    oyxqUc5xdC7+mbjEPh3AeR4Xqt6rtH/m9euJZZwNi8x6LgLapv5tqwRet/2z6/zryP/dFNezDDZh\n    //xLi/M0wcm6PoyWWKf986X6c3sCeNW4h+3qijhrG+hV5ABX2UDXnb+qW6huYqnLL7BNik0nQ24D\n    Lc9TlclQNZm7FlUdx36+aKhb/NTZnRCiikVMU/KazsOVvFWLNFv3n/yO0mLSPF5+knysiyDmuSnS\n    4oYTvgS++M4EITwtXjH/L2T5vrP5Z6DJX04KZ8VNgT7WzAoO5wv9yd8/g0p9MdGjGp2n++i+dACE\n    ZdJXPte/j+a+9GSG0TsPoMbewnIfED96EZ2XH0YQ6EJpuQCtlUs6y7as6s0tmsPiOF2O5sVfU72T\n    ioItL2JrklgXtaVymH/nZK784nm+IcxiNO2LoRVO0raTW2jS6/D3pAvYubLLViDXhfHQsKGkL02C\n    h+Jz1P8m0eUeejceByJv/bwXUMDs2wmG7wzZb2A1bORveCFE1+f+NkLyZAedl/tFHnDTMj+5aQQA\n    MMwwvH0K9cDnAe8DggDovnId4SOH4Hm0fB4FzOYq3hDFM+LlvEENTpq+DNgcVm5G4iQ0kaw0t0TI\n    5znupMEJXKD9XMq/S/LXNp/D+Lk4Saxzg7nLB7lf8O/8c5LnzNhnbcv9pbk1ef4ykqe89fO+YPbj\n    FKPb94pbe/5bVAXeSBschji4dexzfz1qMfvf/zD97L8Aa/IPWc0nYpbPunaVFcSu6SzH60Ka+KW6\n    ERcmmOSymSdMwgZu6Sxra9wmGihHpEl3QDpvB6rSBnrRClZZXGI/F/852ryWy/55mYpbE8GOdHqc\n    VpxjUfERwVWrdmHUcNyqsGnb5kVgE9atw/75PJDHu45lHJM3AE8AE7aJtLVBerev44/bdhFapwp4\n    Vai66EuSd9FcAWDxSYwWFHXHuwjnqkm7zga6Kabse11eb1MymBCJRZB9QSS78dyv3wRxzXjbYlO+\n    Z9tjmWmi371+/0oskHlHJCdp+T4zb9hcrHMymS/qMzaelvwhW/hLFfDsi58w+/Gnhp+gx94iAHqv\n    HiF+sjt/aio5yqaCJmjc5NMhpp8MgHS751aP1eDgd9cQXz8CL47yAjbP5dVKJtOSsWxbTL9hVLDV\n    RVmuhNLjdPGXE1imzSRZUQdMCWVaVMaOL1585koiTiibdp12JRMV0Wk8fTbp3NaT3rcmhCF+Xln0\n    58V//bkTCU3K4AwhgiRC78Z1RBe99fO+IPtlhuGbp8CUmsg0bFdnSf4CQJAAfZ/72wq93y+eBwzk\n    /w7Tb2cY/WMINfXz6D4g6ifo37qOsBvDbOoxHTUyo8FHz7E0D3AnDq2U1X/TNNfQnEyzK481AMoE\n    L5/bOGGrIx50A1bdXCptpwGTxM3nSDMaQRNu5aaqwHien53WDRkjxqXqWWf96s+U5w3b1jNAgPjh\n    PvqvPe6tn/cE2WmK0Z37yE6zVtdxAuX+dn97iPhJH6HgUQ2VZRj/7VNkKr9bIc0ur/noOo+5j2f6\n    0nHk55UKkQAAo/7E84FJuUvPgbwGxu2fpaUzF02EMBXEUpRRBUkEc2EHF4Y0tX8GTEFJFVxjeA20\n    SaQd38brtXUxevoTNX+WNjXeKvvnVZCyXWApq+dNEMOSH1hGlHbW2JSgryk2of71aIaW+b+AiwBe\n    Zw5wG5xs6HW2EfIPfZWE76LnWkeO7yqw6gt6k64mF1lbpxpuC3m+NjbQgF4s2BYPTQ1apxXbbe+F\n    20C7UFbolo+X26QKWNpAh5bFng1NbKAjscAj4tdlA01IrO/JtHrmi2hb12WGvCyRsvMT4WtaAHHL\n    Z632zYr90hpIYfb3TwGvAvaoQdAJ0f/jBYSX8lYKfevIxsDdQka/uYM7DzD9ftG2FI9zhW6C3q3H\n    gH5SkJMwCsPh/EvaTWqLRa1u4nmHJqkqc3FDmBmGmXhdoKwsCtg57NbNgEu5xMHfCyd/5b5APObF\n    e1MNrElmrubiSl/K+qVyeApOsmuLSq7gItV1BCD5zSXEz1w9698Wjw1BjTMM3xtgdreZitRKDgdA\n    8mwXic/9bYUgmecBP9QuD9i8wikM/z7C7Ksx1HbegnmsGMkTl5G8dLWwfybiMUVUzKU8AoGTk7xZ\n    iAhMIno10RkUs4aMIKBGIdf8JYlhvgbkx7jmT9s8KrfLuZRTt3pO47nFAZsf7WQ1/Rx8faFXsfp4\n    fn6KeNAOHdqSO+jEOLhx3Vs/7wtmGUbvn2L6zWJVHvotTH7dQ/d3R2f903icA2T/+x+mn3wPUv/m\n    dahy7FeZ9NVjuMBAqn8D9jguzgXoK2h+1x9CFYQvd8Yrq3+1uEEKJahe5iJgc4WwOVYSu7q2aB7n\n    gitSjo6X57UdK1W8vB7ahEhugiZkMLd/XqWqV59f5/ZO2HlXTdLWXT2r7J/r8n/XTe66zr9YO1CO\n    Tah/jxc6SzX2hbS9sLs/5/lUAB8v+A+yah9xF1bVFVH+uU1sSgXcFJsgiBexeKjK7V2HDXRTNM1Y\n    aAPXwqDDtrnygV3dabaxVeCLIqn8leewKYNll59cgDUld1020K7Fp/15uaORL25tNtBczcszUugc\n    VFrgdtC0+ObHxozg5Yt4TeqaXZ70OGIqYHlDMPr8J6R3f2707+ix34ivJHkecM80OeN/PTbdg0Eg\n    jDOMbt+DuuebDvYByfWL6L10FSoge2JNeFIB2lTRAGXLRp3Fx7MFdZ5uWWHL1TxaGaTtowEUNpHc\n    RloWrJvoeELjNfU2U+1LObz69bky2pZPqMv35ZxfaSPNy+Tcatq08wwNchgIEF3to3fjcYQ+v3U/\n    kCpMPxlj8tEYhrXwHHIlxPdxksbn/i6O8DjCwRsHCA/k9ase9O8VZAqD2wNkd/08ug8orKCvHbJZ\n    TzdScecJnmKr/SRM++YANscKTRLzXHuwYwPL/MXnNRcJ3CTvmt4tv87wpi+tVObOGUT5miRugPJ6\n    QDZTEUmuPz0izWEczwl1nvvLLaOBAJ0XriD+lbd+3gcoBUy/GmH8l9wTT86j8mrOV7ekzwSA6OEk\n    t35O/DzqUQ2VZZj+45OS+ldbN3MVsK712FTA9F9etzLd5rgAIZ6TzLyuRfv0a2t3O5N8NGtloRhf\n    Jcyg1+AW0U2JXf4aTcbbtnGlsAtV+1yq36rVGs//rUNV7bVK1MPryssSxbb4vKr6eFXdfVFU1evb\n    cgNVZPEqraQ5L9LGUXWdFs7bpiTeRdQJZc84/xc4rwTwurCrHQ3L/rE3vWi5xrkutE0usk07eqrO\n    Vdc1tMhEVXWMjcyV2/hkPG5wDpPMNfc1XUTUYR2ZwPTe5OKpiXWKtIFuq+p12UDTc2kDbVMBh9BW\n    M5LgNaGzUmisSfzK1yhnrnCCWCp4FcyFPe/w5Nv4TYG2CQKKHnuVYfj3z4DUZ8p51KPzmz66Lx4g\n    CMrFuioQ2QAAs/9OMfrbA6ipzwPeB3RfuY7kep5hKHN+dRafVv1q0lJbH/OxXJmjta1mFqJW65TV\n    t9xGk4rDRIySvSOVnaWtpqki0oVmbl9J74+I7cwowOv3wLXHWpls2jeb6q2yVaX8HMrW2YLwZT9/\n    0InRu3kd0bFXLO0Lpt9PMXr71Lgeu2AjfwP43N9VIP5VF8lLfQTzj7B8fXCDyIb0XobR26fIhn4e\n    3QdE/QT9m9cRdBPwGAUzi9ZskOJzh3LMH6ExVquCtWuHPjtl1HNlrhlpoOc97sKhKVo9N/Ev3gym\n    R4XgbiA0VttXl1XI9nmfVg5m/nFonMO0jua22oHxWZhf9J6jRw7Q/cNj3vp5T5D+b4rRm/eBrDyL\n    ulp5FCj3d/43dTDP/T2O4eFRh+zkBJOPc/VvMK/jRPM6joLOAeYiAK3a1QrhGXQNSooIQvEdQEEo\n    pzCtmzPkdUjphCcFDqWfA2UlbxP7Z4LN/pm+2wQfLvtnV02zSoRiGysdCCWqHBPrwElh7vZIAh7p\n    pVbnrSb322rNq3StbBNzeBb2z4tiW91Pm+AY6yGT1yV0lNiUcPM8YwH7Z6CKAN4WG+jzinWRyauS\n    8m97QPgqrRwWyQHmk9MqVMBNcxeaTNBVk/4E7RYJ0xbbbLkXrkWNyz6FI6pYSNXpHKpsoHm3oVzI\n    Neku1Ch3BcrSmySDbSrgiJ1Ln4PbNuvvKXiHJ0r785/JtIHmxK9UAZuW0fm42ac/IP2fVwF71CMI\n    gP5rR4ifoDxgx7ia69ro/SGmX4ysBRSP3ULYTXBw8zrCvs4wtOUBK1Fc5aSmJoa1pTMRuGRfCTaO\n    isScXuWFa67OBXQhmx7L3+wyyWuDfi1b3m/IxqVz62tO2qr5tghm7iInh7JiJuHkM88u1MSxLFRT\n    7i8R3N0XLiN+yiuW9gXZvRTDN0+RjvQ1twldwf9mfO7v6tB7tY/kaW3k1+TfQqrMxl9OMflgCDXz\n    8+g+IH7iEjovXYFWq+o8d1eOrSR6+ZzKIxj4fENzUCbOQ3OonrvNuVPOV6b2UUPOpeXmB3Oe5lu5\n    +4e2q+YtZby5S6t2ZRNUxt4jn1Mhfl5J/vL4BYUAUSfCwY3riA468Nh9qFGK0dv3MbunqwayvRDO\n    5/Pf0AjovHyI+Fc+QsGjHirLMHz/M2SpJnxljScAaXrNepHtiwsJQvaYyFnazqPKqK7FyWISNoTI\n    ClEKnYc73kn7Z17rc9s/222fq+yf+fESdVFyTeybqX5JY+tI3KbCGF7zrBLb2F7PpeSVY9tEBUr7\n    Z9v+Nlh1FCKwGkXxOiyim9o/2wRybRxXmwr5tp3b2RQWdQpeBc4JP7p/CuDzZAPd5A9+UzbQdPGq\n    64Sp2r+qLppV20AvilVPcm0m2aaTu8vu2bXdZQld9bq2bVHFeZq8d5cNdFVmR5UKWDkWlTby1nVe\n    lw00vUJmvE6+SDatc7RKmBbNXBlM4/R5dLdmBlPtK28GbDcFOgs4M1TAUBnGf/8UyquAPZqgE6H/\n    x2OEF6mVoUz31llBQykMbt/H7O6q/Ao8thnxY5fQfekqEOgCagipktUFWV2UNi2cdRE6ZLm3EmU1\n    Dydmue10ygrZkhQ2i8R1kAVrfW4if8myUhtplvMJuf2mtLtOYVo8m4ot/dnI3F++rSiWe8XSXkFN\n    Moz+OkD64ww262cOTtlwcgWBz/1dJcIkQP+NQ4QL5AEXVtBQGL03xOzbic8D3gOQFXT06GExd1Cc\n    Ao9YCNkcw4lQQDtKyCYpJeYdiiEwFcOmdwU1LQE6t5fPeyZ1W4+MXX1s5C8/N28KM91FTOtoqmqZ\n    7iAhlDhPID4L3jim2DrFdDDx1s/7BDVTGH00xOTzvNrjuuSaq05zOwAkz/TQf/XwrH8cj3OC7H//\n    w/TD7wo1Lql5bWSwqfrV7nGk/o2KehAgXeO44EB/oRjPHesAN8krM3u5AILG6Jqd+VekRRvNBBqu\n    DGHzNdzbYtjtnzkp6xKg1NU/p5ZtrnrnVHyXj5ugyta5yv6Z9rlq2DL/t4lLJceoZpxtm6zRS6FW\n    FdG6Sstm17nWnS/MsSpeZx3Zv8BqBY676rxbhS2wfwbOggDe4UDljWGRP+pNeb63tYFeJZaZBGwE\n    cd3E1dYGWk6iLhvopmphF1yLAupXlopb1wKkqQ100644mQFiX2SZi7AmZkmzBfcR2tpASwsc+V3+\n    HHIbz18Ji+2mCric55KP44t6bQOdlbpB61TAk49/QPrTTw0+HQ8PIHqog96NYwRdTqw1Q/Hbe5pi\n    dOc+soFvPNgHdF+5jvjR3AqaSmGk1CGFTmZQo2BFWcAsPevxZOEsLRpNFa5+TW7THIvzRsXZuWpK\n    20BLu01ucMkzEbUqGQWpS8+5aomTv1SQ15bUZpYvV0txa0vFPpVAvEeu8CqUYN04V2R7xdJ+IFOY\n    fDbG5AOd++tCVeNO7HN/V47wYoSDWwcIDkw72yZzKZHAaqYwfPMU2S8+D3gfEPUT9G9dR9DPraB5\n    RIKNoDQzdEMjZoDPJzI7mEhgHhug3QDKNtB8vuMWyvo90jzqnktD8d65clchLOZr016aO2mYWcdm\n    xIN20EDxiYXQMz6fQaVLSX5ExH6+DCHiRw7R+cNjCPwlcfehgNl3I4zeedDibsdsxwaA8OEE/VsX\n    EMT7J7jxaA+Vphj/4xMEsxlc6l9J9mYwo8OkKMCm/g3FV35XrljNyIwvU9DuemX3Pn0Om0se4CZt\n    bdUAXSu0O/3RcS61cJ39c5OsX3lMXe2yanxbktcm0FnW/nnVkEFCi7hbNsUiAi7JB3AB2ibJ3E2i\n    CXG87/m/J2f9BlaMBe2fgToCeJttoM9S3n1WuN9y+6Ln2ySakrbLqoczqLWogF2wpezRBMknyjaT\n    NF8UyEWEfL7s5O/qTrPZQINt54ugJuWpKhtoCakCjh2LP24DbdtPi8o2NtCcvOWgxS7PUFFsLFf0\n    8gU2kC/YiexN2Xi+IJeZLa7FvbQA4qQv3RzQ+yAV8OgvHwMzr8j0aIbOswfoPN8v6mOZKIs0KZJM\n    vppg9MHAW1juAcJugt7NxxD2Y5Gtq0lfrlvVClitcFWQhW2tZpIFbVOFxEliDVPlVHgi1Fg8l7Ud\n    +vXKdpZk9Zyyn4Ofj94/EcMhyuosykjUuYRmwdrMVDTtQOXo5KWriJ+8fNa/Dh4bwuzHGQZvDaCY\n    RLQtXxFeCNHzub9rQfJUF52WecDScnT2c4bRuwOosc8D3gdEj11C56WrBmVZzoiXUQGmc4R23QjA\n    SVs+bxDRS/s1QavdNMpOFyj2Y36cXQvp0kmiOA/P8g3Zc34eToDzn5cfk6C8apA/B31emWU9Uo5q\n    CBF1I/RveevnfUF2b4rhm/eBib7G2n4bS8eBOWkchDi4dYTwos/99WiG9KefMPnwe0P9S1cqIoMj\n    g+w11b/c3jkq3N9yRzpT/QujtqR/y7X6l9eg9F4lRCZlRS/VuHgdzmb/TK/hEmA0+rws2+rsn13v\n    XR7rInGb2EcDzUU0trH0GfLZhn/uVepf2+suKyzi4JbRrtdZBE3iGTeNKu5h2+yfdw0+/3et8B1p\n    EtsmRz+rP/wqG+g6rMrqeSC+cyxr+cAnmmUmnarJrslEm9SMcZ0jgapcXMiFAhHCvJssqVh8VKHp\n    WL5Ikouq6nOUiduZ4zwSVTbQcryNMHZ1I/LH0vbGPEbvj+alA3O8PpdWEutcYJ7FwhfzYbGQV8Wi\n    ni/mlWHkxgnjrPSdVMDTL37C9LsfGv1bengEIdB7/RjJY/ktibbXQ/HcVhDhKrQACpP3HmD2zchb\n    WO4BuBU0FVRz8jMEV+7IYnXZmlEXeaUqmKuCipw+aKUS5e/SsVTA5mriDDYS2QSN5YQrL1ij2M8L\n    9DxjWOYXm19cPcUtKXV52lRWlT+bkH22+ScSPXqI7ivXvWJpT5A9SDG6fQoMs+K62+Sfnjcy+Nzf\n    9WMlecAfTzD5eASkfiLddQQB0Hvl0bkVNCMlofOAeSou7edWxzrL3pxjlHUuMsebDhf6tdL5PMMb\n    qiRxWtXcQHM0WUnzeZCfm++X5C9XCNNjasJSKBPk3DuDxyhwNw2Z+xsA6Lx0FdETvpFqH6DGGUbv\n    PUB6l+sQy5C/2Yptpdzf5Ff9s/5xPM4LZlNM/voxoKg1Vc2JYF3/4c5wLvVvaKiDtbucmfOrFcFc\n    nMAFDICuU0nnO173kiQxP47OjOL9V8MlzOD1QJv61yYiqbN/ludGy30uS+gq8UsMZRXYtEGdwKfJ\n    eTkhzPN/m9g/dyvOW2f/XHeMDU2I1lWoeldt/7wIF7JOQd++EMmrEogu4lhcJ4xdpf3zEupfYBUE\n    8FmqgBfFproK9pVMrrKBtl0QV+nfX4U6orepQthmAy0nujHsk2Rdd5Rr0l2kq8q2SGjSu8wXUm06\n    2Kq20YJELqb4Qsm10JK9s22M7yLHYoy2pcZYOLoQy6rnTIyVC2BO+vLFM7eQ1p+2uQinRXmMDFOY\n    KmDqCs3EIt/M+pU3CVlxk0ALfHo8eu8TZJN1m8V47ArC/jwP+II2CpQksAs0JkuB4Zv3kZ149fmu\n    gzIMw2uHJVJXE575FU6rXgGuSOJEJ0BXSE2apgiRsiI0VyVpgphIYm1DTb/BMXQRGsWrBKUvni9I\n    0JbS+Tni+euYWYZmAZ2K5FwJze2rzQI1FcF18VrbQ/PcQ54FPEc/zhVLfU/k7QOyqcLo70NMvp01\n    IhQJhord5/5uBJQHHF1plwecj2N5wG8PMP3ez6P7gLCboPfGY0CfZh0zB5hmDtomm4Oo+Uk2WAUw\n    G6u4ElgrcE3lLjlX8PlPRyyw9wz3fAr2GjwWgmIZouIcJhkdsHNrghfzRi49ShUzrpnvK5XTtO4w\n    7atN95H42iE6r3jr571AqjD9dIjRh+0843Itpv799Lm/Hm0x++4HTD7/qajz8IR2Hu3VRP1LdZ+w\n    qBy51b+A6UAHoORYlx/DdcLcjQ5W++fIOFcZkkTmx0ghSHMNfdn+2ab+tYlJmohWXPVH2yqMk71V\n    cI2rq79S5a7qNepERnVooxheRv3LwWv1m3TuXAeaCufOE+6d9RvwWAXqCeB1hhUvi320gV412nab\n    bPpi1rTzpsm4IRafTMYL7pOosoFucp6qyXyZMtB0gW2zmrF8TFVXXFSxsHItwqQNtMwI0Spa8zVc\n    i0sOtzW02wY6NcboRTNtk4SwXlTr7kwaq+bkr00FTGOo85MvwqnTk98sSPUvdZMSaTz79gSzr/8D\n    D4+miB7povfaEYKOLu2VrfpMSPXS7CTF6J0H3sJyDxB2ExzcvI6gGxc2lFyxqy2N89JsioiRvlIp\n    TCQvL2Nzy8uwKARLO2heLJY20CFQEME8f7f4GRzPuaU0V1dpmKoq/jwyxuvCNC9E27IO9etoJbPM\n    /VVBmCuWHrt01v/8HptApjD9cozxP0YFjdhc/auL1j73d3MIL0b5Z91vnwcM5P+26Rh5HvC9ZoEm\n    HucbyWMXcyvowCQrM9FQBct8ZM4ngZXw5HnAcl6SJHBqEKiBMR/KuVKCk7c078J4nwRN7gZsPzV+\n    UXwCPab3r/OK5c/AXTZ4A5q5DiESOkOIoBujd/Mx30i1J5h+P8HgzoNW86gkf+OHYp/769EK2WSC\n    4XufgK5wuuE/Y4SuFgLweK8m6t8MFOOW748ZecuPlwKF3FVI165sTnlcCEEENI3RNbxq+2cOGznb\n    1PHPBSKQXRm/5th2GcFNhTC8LuiKveOOjSTYkY6N1T+nKo1dFTGbvyfV6Hwu4ti1fZ32z8vk/7rG\n    r8rplMPGxywr3NuGqE8XqkSS3v65PS61+13xi5PzgPMo23ddHJexaVjHBZfQdvJZRY5CW8hJ10W6\n    2vSc0gaaFgguG2j+WL5ODNV4weNS9S5iA82PtT0mtLGBJtRlkfDntACWlji29xGJrsqI/Wx8kU2L\n    ca4CJoueqfE6ZgYMX+xTGUibVpVVwLRA5yrg4bufIhsN4eHRFJ3nD9B9rldURqTNsw1yzPjTEaaf\n    DLyF5R4gefwSOi9dKVRLumAcFqQwqYq0Vif/LlXDXA1L6iCtieLksC5qkxKJisfculkhwJRlGxJh\n    PJu/t2z+WO6nonQqCslgr2XL+NXkt/75TItrXhDX9pT0H9lQ83EhFavn/yXXD9F75VGvWNoTzO7O\n    MHprAGTKuM42QaGo87m/G0fydBfdF3sI5rfi+rrhRqmZ6scUo78OkE38PLoP6L3yKMK5FbRW/Jok\n    rmLzE7eAVqVxek7SpDDAZxxN6srmJU2Ycsvm1DJXZuKrvJ+TznqeNpuezHmRE8baj4bP/TquIYMk\n    sM3mMa2IDo11CRCg+9IVxE9cOut/do8NILs/w/D2fWQj7aXlAr9Kc/I36Ifo3Tz2ub8erTD95lvM\n    vj0x1L+ygZ/qPhFMi2ip/qXvvN7D7Z7LRK0pXKC6EY2jMfq6T5nB2lZatnLz+hbQLDfXFFKU639N\n    7Z/rnP84uHjEFRNnI2t5OxDVSGVNs6mwpi143baN+rdT8XxSMY7D5mxJ4xcRWC1r/2xzELVtq+Me\n    bMdUcQ67qOzdBZylMHST9s8rwP4SwFXdBauybj4vMvlt6BDZlA00h430lZNRG6LXZgPd9Pimky8A\n    g7ytWnC4OsZ4V5kL/DxNbaCbHtPWBjoni+E8hmBTAdNzbgEjX6NZF6G5EJQ5KJwMpm5Lxf6dwLbR\n    4lqqgOk1aJxp0UNHahUwX+yHbJxO0kqLbTYVcHHOu/cx+fRL+FBWj6YIogDdGxcQPapN5alw3aRb\n    njC48wDT770F+a4jt4J+DPG1Q6YyCkuFW05iavLWtHC0ZRjywjKRrrwYTMXuCDDOyakurkrSWcT6\n    i++T2YghG89/pogpmPj7AzQRznMa+XsP2c+mLbLNrGMq/vPPDQcd9G89hrDrFUv7gGyQYXznFOl9\n    04ehqfoX8Lm/Z4YA6L3WR/yUmQesGvzrcSvoyQdjTL4YA5lfw+06wm6C/q3rwEGnRAJzhS93xuAW\n    x9zqWRKpPO6AO2eQVTOfFfmVQls289fUhG79XKrPxN8DxTWYM7lu/OLksiSp5c9Gc7R2ITHzk2Wm\n    cgAgftRbP+8L1DTD6G+nmP13apC7tn967vPC73mCEOi8dIDkKZ/769EcajjA6J1PjMZ8qv1wla/p\n    +Gaa6HPXNyKK6crPyVrb93h+Pqn+JXABAnezk+B1sUgcL0FjbIQuQTsINv4kjWNd9s9ViOGuT3Ii\n    eNpgPEcVUUv7bMKcieU5GpyrCmPHY1kzVi0+t6avtw6s0im0CdYpRtt2bFu0qcfCaEYA17HWdaz3\n    Mjip2e9toNthFWriJhe/qu6YVU0qkjQeoJ5IXkbnuMgkZuuWop+/Y5nsbVhGbTypec5R1a02dYxr\n    ksdrdhXaUWUDLcfEpcWi+7yc3JWLSBdhLI+jMdxWWqqA+THlbdKm2rTMoc+UVMBE7HYKla+CqTYu\n    L/LlDUFmbKfzZoWqWFsD5Tcb4/c+R3b/vLSseGwDwoMI/TeOER3pdURb9VI2VnnH/b02yd4e5xFR\n    P0Hv5mMIuzFcCl+uJOIKoKAo1OpjzGK3NnjMRBE4hVYNp6wozF+X5oYQdH02Vbf0DvS+cgYhf72M\n    vV9tR2lmInJ1MCd3M/azcwVUxgrT/FjDPjMI0Xn5KuLrF876n9tjA1BThcn7Q4y/mhVX3qZNOD73\n    dzsQJCEO3jhAyPKA2/BNAXLed/jWALMf/Ty6D0geu4jOy1ehmUnTspnPp7xhqeyCoRuQOIFrOmeY\n    0QlElpKKV7ppUJNVNP8KLP/xuRTQDh66sQpzglfbNfN5XM3nWf5z6SxhvqagDGGt8KV3NCveadkG\n    WyFA0M+Jdm/9vAfIFKZfjDB5f9BoHuXkL2/WiZ/qof+Ho3YXcI/9hsow+ugLqLv3wRv2eaM+j/Wi\n    OwTAtHjmwgIifLn6N4UWKNBYl/qXq4dN8tgUQXDBA1cCy7Eu+2fegFslxGhr/yzHS/tnmypZOgu2\n    IY0lXC6JNtJYjps4tjd93ab2z4vWlceO8yxiC02Cq03ZP7c9blWE8TbgPDnJevvnjWB/FcDnFdug\n    1t00+EV42c6bqomG9rW1seDjOw0nXxfGNcfabKCbLhRcds9JxWKkCk1toDlokUWq3GrbaHORFsPM\n    A6kqddkWh02yRKpsoOn90PGc5C2TtHQEJ3rLub3mQlmrgHXuL1nwcAWxtnkm9TAt7jPjPHnZhM4d\n    sZsJ6jQtuk1Pxxj941Mg9VlyHs2RXO+i88oRglhXPDIEja8iARTS/04x/tsDqKnPA951xE9cQvLS\n    1YLgJeUSz+Ezs4F5li9ZOpoqHanVlQStBtdtmEopKoZnc5I4c3wpBOI8WtHElU2SjKb3SEV2bnut\n    bbBRvB+tfDKVzLyIzYvXNCJ+4gj93187639mj01AAbOvxhj9ZVj8Rja97hpFa5/7e+YIL8fo3ThA\n    2CIPWEYqqNMMozunyE79Gm4f0P/9NUTXDyHjAOQXny/oMRGzPIpBZwTr0r7MBCY7aP562vFCQ4lj\n    XHMpn3e5swXYmECcm2cM89xi7vShPxPejBU4x+v5WK9JOi9dRfzYpbP+Z/bYAGZ3p3kjaotbEEn+\n    Rldj9P94jCDxdVWP5shOTjB+74uiJkPELtVzbFbPGbuyarPyevUvd4vj6t8pGwNUiyEwH5uJ/TIm\n    jfZRbjCH7ZzSbrmt/XNZGGKiyhK6iuy1CVdctc+qmmRVrJ4NHcd2qte29U2rIny5yrhq3CaiD3mN\n    fhFL6UXQ1oF0U/bP20jarkomtA4l8T7ZP99d/hT7vVDxXQZnBxuRuykb6LaTSpNJb1GLi3WrgJex\n    gaaFj41k5s9dRG7bTOAqFbBrYSVVwTZVL7ejiRyLx6bQCly7xY2ZYWIugs39+r3R+BRaBRxWfOcd\n    nJz05WUVhXI2jKaPTWUwbZ+8/w2yn35q9Xl4eHRfOkTnWa0e493xNpiF6/zx+P0hpl+MvIXljiO3\n    gr6O8OFDo7hM9o1k5agtLctFXm4HnRWEMC966+w/Oi8vVMucXp4FSCB1Ev/i3eoyr5cK6tI+k78X\n    rkbWRfjye1DGzxEYPycnuXVm4/xzOeri4OZjCDo+e24fkP08w+D2AFkqnRWqof+egMjn/m4Nur/u\n    ovNiz7gtryOB8zGa3pp+M8Pon0OoqZ9Hdx1BJ0bv1mMID5KCzszYvMetlGdFo5WeV3gD1PyMRuOU\n    JkaBCKSi1cpfnmvPrZql9XOI+rmUk7F8O/9ZQvY4XzPo4AXtwhEaP0/IPgMeKcGJb4goigBA9Ogh\n    eq886q2f9wBqkGJ45z7SU926Wq3+VcUdd7GtH6L3+jGiS14t7tEcajbD+G+fAONJqSlfqn/VvKGf\n    q4F1Bq8WApiRYXq/GT1mV/9qIQPVkFC8RsTG0VhAK35J/Us1LVfNjtfk7EIL83jb3UyVwAPFcfbo\n    tzqSduY458wxfmrZBjQjeW3H83NIyHrttOK5q/bbtFbdtjbqEkLVvV6VKKvOsbOHskqX8wicZ2ir\n    5t20+ncfxX0eq8Ol9hzR2RDAF1ZM9K2D9V9Vd8KqzrPKTpBNdZVUdcksczGuUgFv0ga6KSlrG2eb\n    FG05wK7Jk2dF2BYBE8d569Bk0VI1zqVIrlLutlEdu5TDTS1iYjY+FecFqhenNvKap/KG4jHYY7KQ\n    lipgnhXMF++0mOaLdq4CDucq4Gi+UOcL+wymVXTMbhoi9l2TyPPFfppi+N5HyMY+k9WjOYI4QO/m\n    BSM/so4E5vsCqNzC8vZ9zH5qegXyOK+I+gkObj2KoBuzMrGZA0zFWSoNp0WablkppFW/ZuafEsVf\n    bi2dWYvgQVFm5vvNL03gcnVuOrfUNK0kdY6hLfeQvz/K+ZUqX558rIz3FEJnGQZQYYTeKw8hunZ0\n    1v+8HhtANsoweGeA9F6zojXtN4rWCdDzub/bg3kecPKkOY9WkcCS+FcAxn8dYfbVuLkc3OPcIrl+\n    Ad2Xr0IFeq6UmfFg841uutLjVdGopOcvTojyiAPeqERq4Kxodiorj4mQlvMo5ufXBK1U/+r5kOZt\n    msP1eTV5zIlhnhhM75k3SmVsHaA/Gzbf9jvov3EdYddfF3ceswyjDwaYfTUx5tE6ZGDz6Dz3t/Nr\n    n/vr0Q7T737A6F/fgTvA8QZ9WdvhhC2pfwND8cuJ4axSSEDqXx5TJmte9Dxh+7m4wUYSljOE7X9R\n    VfbPnLTlJK5L/csha4xx6Xm1/bPcV7XNBVmfVKxO6yJWE6iiVssFOnXiINdrNoHLzrkp2oxve+6z\n    VP/uc8bvWcMLMzeG5gTwWeYArxPr/mU7L6ma57X7ZFnVcNPsgWWsL2w5wJuw0rCBLzK4lYjLBpov\n    Vtp0qkm4FlR1HXYQC0HZDdhWLVyV7WESwm7rG/m5yGPNBbBW+SYwc4RpLB+voAwVcIjMoQrW5LDN\n    +jlgBC+/aeDq4cgyZvrlXcy++gZQfgHk0RzhUYTezWOEh3pNUUVGcIKYSn/ZaYbhnftQA29hueuI\n    n7iEzv9dYcVkXUDm9pIptKJHF7XDonBsEsFlFS7PJaQiOFc4SdWR+Tur7SqlcpjnI3I7Sm7dbJ5b\n    q48icC+HfCvPbTTVyJSzqPOQI3Y+KsR3fnWEzouPnPU/q8cGoGYKkw+HmH4+KX5TmqhEDTt0n/u7\n    lQiSEP0/HiK8ZOYB1ymBDSvoDBjcHiD92ecB7wN6v7+G+Pohs0wGdGNUYJCwIZuPjLxbQdzSvMbn\n    YptbRcbmP5pXqeGJwK2eeZMXn7fBzi1fL4I55wJ6tqefRxnn1mplapyieTVlnwX/nIr1QOCtn/cF\n    SgGTf48xfu9BqXnKde+igLlduUb0ZNfn/nq0hhoNMbrzYVGrCedEbsgyfnlsV4wUkiA283zz8bNi\n    r5orcsu1H030kmqYZ/+W1b9cJQyUBQ5h8VplZzyb/XOVnXMKu/q3uipgnqfODhqot3+eQdf5bAQy\n    YGb68jHramOvsn+eAs78XykokvXnJiRzVc163HJ7U1TV59vU/s9jlu95FP2dJc7S/vmcYr8toD3W\n    i7oumrZdNqu6iHehnN1FTQhh26Q2QvUk2CRXQU7CLhWw7XWqiFjX5H7Q4vOvs4Hmz6eOMU3yNppY\n    M0srF1dmsFT16vdkfy3ZZQjYOxP5+egYnv9ry0ThZC1X/oawq4C5pQ5fvCuYKuCMEbnUMRqgbPOc\n    zW9dZ/PxmjDOWJ5Mvm3y9ifITjeVcuGxK4if7KH7u0MjD7hKCWxTL82+nmD0wQBq5hdzO40wQO/V\n    64geOSi0SDwPOAM3bzTtm8t20KTKDYs90g6a5/ISCSyLv7SdHx0BRgG6bJGp95jkb1kJpfOLzZ9D\n    qqJ0eVErgrU2WeclF6973MmtQBNv47vrUAqYfjvB8J1hq6I1t30GgOQxn/u7rYiuxOjdPEDQK+eM\n    2yB/BwIoZPdyhXg2ahFq6XEuEXRi9G9dR3iQoNwUZZK6fJ7U23PoqAJOwuYzHrlm8HPKeS5jc6Ak\n    buUcaptLlXHush20EvOgninNqAXuBCItsbnSmD4T7qQRXz9E/5VrZ/1P6rEBpP+b5/6mQBP1L4+t\n    IURXYvT/dMHn/nq0g1KYfvol0v/es0Z1ydguOMbIzGAd86UJ3pB9cVWurlXpulcT9S/PCXblAGsy\n    1PyL0g57MF7HhabOfq5jZa2vSjBSleFrq1k2Fb9MG+zjNVqXMKfO/pmjqWrYdl7AXmPu1p1ojlWJ\n    m5o4dVZxAutS8frK6PJwOePuqvp33fm/C9g/A7tEAO8D+7/PHSHyQr+sDfSqYJvsbNtsk6fLBtpF\n    JLfp2pKLg0nN86pjXfv44ya2znwRJpW/VYspSfRKS5cq1C0u04rjOnBllJiLSWUskMEW33q8JozL\n    2b984c0JX70wz8QCXiEu+jPLls/65sDMCg7YvgzlDOBgTgbPfhlg8q9PgdQrMT3aofPbIyS/7i3U\n    DE/ZWqP3TjH7ZuRF6DuO8LCD3o3rQJdu0007Z7KC5mpZad1MkNvKdtChUQzmVsu8MM4tJum1aL+a\n    l55pLJ0vFXbRgfG6+n3JXEZuF81tnzOmv5IKLdO2OkQUB+i99giiq4dn/c/psQFkv8wwfPMUatq8\n    aC3J3+hCiP6ffO7vNqPzm1ydHbBb9DpHDSUezz6fYPLh0DdT7QHiuRV0EJjEJidVedORzsHNx6di\n    XuXfbc1SMrM+YOdJWSOXnje1s0XG7mhSRt4GbA7kRG/G5lzdqlqOelDsNfjPQHESej1Brhv65wKA\n    4CDJG6m89fPOQ41SjN55gOxefo9b10hlI3+DXojejWPEl/3vi0c7pPfuYfzeF0V9Jiia8rWdc8S2\n    caIX7CrIG/9J/UthNDo52FT/8voSqX919q8mkGGM06A6HCd9M7GP5wYbP7fls3AJMfh3l1oYMNW+\n    toi5Ovtn1/uxwVan5NtiKOsYm/2zq+a5iJWz7Zi26lteX5a15jpSt86u2XZ81TGL2j+vou6/KuK4\n    zXnOiwPrtjranjX/d04dkHeHAF4Gu9p1sA3Y1m6Zuu4i2wS0atvmZc7HJ3fKAZaLABfJa+s2k4/j\n    BguVVeyXi62ZZZ9NRcy327bZVL1kPcNtoOVi0rZAtW3jBK1UAfNjpAqYL76lCpiTwLSA5orfuFjq\n    mznC3M45mFO7RHnQjYUqzEy1ajhgx5gdpxmGf/0a6d278PBogzAJ0L91jPBhsyhSZVNaKq6kCsM3\n    7yM78XnAu47kyUvo/N9lkBJJkqUZ2x5A2yfrAm8IbULJtUU2m+dybjDYPp7Tq20stc1lHgtAql9e\n    fNbaY26Arn+WfHtqkNCadNaWzpLg1dnAGbRqKQSZWwLJ0xfRff6hs/5n9NgA1DjD6N0Bsp/zFUKT\n    orUkf8ME6P6hj+hhX7TeZgQBcPB6H/GTifHv51IBl46fr+aG7wwx/Xbi84D3AL3fX0P8eJ4BTy1E\n    RALTYx1NEM7JVT1HRWw7EcSa0M3PajpmQFxdTGeMDHIu1/MaVwpzJwwA7LXkvG3OuXK+p2YsrvDl\n    6wX6DGy5vyoI0Xn5IcTXL571P6PHmqFShdFHQ0w/G81/h3UjVWPyNwQ6Lx4g8bm/Hi2h0hkmf/8Y\n    6ekYtrgunv0bFGSuW/2rLZi1TXNsyQUOC5q2rP6VogMiXKlF0LaPalZpcVa3yhYwa3B2YQWc9s98\n    v4RL1bsO+2eOKgEMh6v+6RLpdBzn4fXZNpWRtmSuS/3rygseW7a5ztMGdfbP59HWmVDnvrnPYj+P\n    jaEdAbxqGfOqseougKMVnW9buyYk2nShrKtLZpEOHtsxdSrgKhvotqBJr84Gusk56ra3IY35IqHO\n    BrqJIrjOBporeV0LFL7wqrNbqVpUyeOrjrEtGmlxObOcF6herEbiZwbMzj6T0C3bU7tUwLQI55kt\n    umMzE+fMCWHe2cn3EdHL9/N9Qek5J5AVMJth+O5HUJNll3Ee+4bwOEb/1hHCg/L6wnYV4n8lVLhO\n    T/IOfTX2FpY7DbKCfqgPrYA1rSapCEwFZNMOWhPBXC3MFU1kpMyVwFoJpVfBvNhcziw0raJ5sZoX\n    k7VXg1YxYb7fzAU2C9mcLCYy3KZYDuevmiFAeKmL7o3HgNgrOXceqcLk4xEmH08aFa3zfSY9EwRA\n    8nwXnf/zRevzgKCT5wEHl8y/b1cesFQBAwCmyBXjv/g84F1H0InRu3kd0WEyX9HrZqF0ToaSw0VQ\n    PDabn0ghy+faoJjLUDzjzhek4M3va0xyl5O/vLlJ56iW51KzGUvHNyg2p1MzlWLzPpHYZiRDKObb\n    cuyDQoj4+hF6v/fWzzuPeYTC6J0HxTxaFVNDkM1W8ZNdHLx2iMAnKHi0xOzb7zF+/1soSx2GajAJ\n    UkPtS8Swbq3Rz7V7m5nfqwUH5jbTLa5a/UuZvFLQ0ET9K/+iuAue3CYhhRqSLLZFxHEr5/x7+X25\n    EIvXk+/FNt61Tbok2mqh/HiX/TPHxPGYv47tfBwux0lX9OAmIEleet7E/rkNmpLFdbxGW0HbWQvg\n    zouyGPBCzEWxoP0zsGoF8DmVQXs40CYj9jzCNck0yQGuQ1NraJutcxUZK9GmK6yJIrjpueS4OmsU\n    QlXHXbWS2FTbxmgPbiHDy2FyEWra3bjfj2uR67KMToFiQW1TAfN8FdOCh1tDmypgKpHkj/NRdHNA\n    9kAB6walx7Pi5kHfXJhZwBmmX97F9N9fw3vxerRF8qs+Or89RMD+gHihxfUbReU5BWDy6QiTT4ZA\n    6n//dhnhYQf9m9cRdqOi2JxB599y1ay0teR5wBk0oUoqphiacI3YUUQEp+zcpNSNoYve/D81Px8V\n    1aPit1UmBwO8tEjH0jNurcntrfn71GqtcmpihgBBEqH7h2uILnsybx8w/X6K0dt5GYMXratQKlo/\n    FqN/88C4JntsN6IrMbqvHyDs2JSWdshmquznDMP3Br6Zag+QPHqM3u8emltBm9bIEPMJkbuAnoeC\n    0nieP60JYnLJkDnD/NxE5tqze/V8m4/VpDK3fA7Y/rD4rs+D+Wu45lj+U9A6Qub+RgcJDm5dR9BZ\n    5K7S4zwh+2WG0e17wCS/StaRv7bt4aU89xcdP5F6tIMaDjC6/RGU0sQt/7Ll/HL1ry3qSwoIyupf\n    TQzzWlQqjrOpf6NSnavsdgfY1bK81ucSVEgHPq1g1kgd5+Tvp6quWPo3cNQB69Ckxln1XMFdx6Da\n    LK+5u9wZXe+Bj1nG/rkNFpWH1Nk/L6L+3VTs46qzhc8TSbsKUeSqhJWENsLPk1V/IA2w7vzfJeAt\n    oAnnpfvgEGplF4xtsQZYV1h7HUgF7Jpsqiap8QL7muYAt309jjY20BNxjOwGsy1ebB1tdYsg27aq\n    hZdrEVl1rNm9Z7eBBuyLSVcGCV+k1qXhRkb3pKnwDcX7osW1zAmm90eLct6NSYt32h+KRT5fzNtu\n    DrQVtEkI0zERMkSMQCayePzWJ0jvnxcPA49tQu+VQ8S/6rECoklK2KzV5PPBnQeYft+mJcbjPKLz\n    q0vo/t9lcKWOJF/pNygV5LAuWFPhmNs3h8XZyMoZ4AVtU9FrFo41ZCEcxuOyKpi+B+w9UJGcv2de\n    CA/Z+fhrcUV0Nj8mfuYius9dOet/No8NILuXYvjmKbKxqfh1uSnk382rajjP/Q36vmh93tB7tovk\n    ha6hNtMKSTd4M9X4owkmn4x9M9UeoPPyNcRPHEHPfyZBy3NytVm0bozSLhhmc5LpSGE6Z5hzo+nO\n    YWtWkU4Y3K1DZg9nKJO7vNGKfkb+HgODTA6M+daIWwhCdF6+ivj6hbP+Z/NYM9Q4w+ivD5D+NIN0\n    0bA5adjuT8JugO6NY0Q+99ejJVSWYfTB50h/ugfFGu2pUZ/it2Rsl3R1U8U+vj23fS5n/xLxm8Os\n    ERXvzKr+5YIFOlZ+L9fFTMJYrjar1L/8eVMnPxtsEW9tLJqXsX9uK5zhcJG8y1Q/qhwkx6gmljlc\n    9s+ArpM3dbEkrEJo1QRnYRV9VpzGOrHOKvA28m8XdvDfUGD3COCzDoO2YdUdD2eNNrYGfaiV2SBs\n    g+d/m04pObapDXQCVTnWlr3QBC51cafleeSCqe1iSNpAc4I2rli4ydyOqLSQdaNq8Vi12My7FuGw\n    geakq3mszPXl1jkhMoPoLVvz5B2WXOHLCVs6Xmf25l2ftHiXVs+BuMmQdkOZ2AZ2E5LeH2Hyt0+g\n    Um8h6NEOQRyi/8djhFdj42/HRgLLx1S4xjjD8PZ9qHv+92+nEQbozq2gOQFKheYQmkilIrGpKKJS\n    traN5BaPVChOC5LYTeKWrZ71Y10U55bP3M5Sq5cAyvwFwArPUjk1/wAMwldnNIbGsSGA+HIX/RvX\n    gciTebsONckw/MsA6Y+pUbQmyGup2cyQw+f+nnOEQO/1A0RPmHnANhJYNgfw8cO3B5h+3yY9zuM8\n    IuhEOLx5HfFhUqhnyQlDz2dhaW6ZHw0+13ACWWcK53ObmbfL50ez0alqPuXbePNVCBQEbsbmWnOu\n    pnnWVC3z9QGfl3mOMX3Fjx966+d9QKYw/XSI8YfDYh51Ryc4cn8DIHnhAJ1nveuKR3ukP/+MyV+/\n    BG+y585r1IhPv4ERU+3SlVU29/PYMLNOlDGClquJtRrYrF2Z60pToGB+57U0qnFFpePNsfwYl/o3\n    snyvUgvzWqGsDsQw63qyrgjYa4sSkXgt+Zhvs9VFbQ6JLvtnlxCHY4JyXXUZ++cm41ZtCV2n/l2F\n    /XNTAparhvkx28A1LIv72B6R3y7jLJ2Pl7B/Bs6SAG7Drp9s6D3ZuhB2jbytw1nkALcBvzDz11/U\n    /mFVNtA8B7jJuEXO7SJ8q2ygm9pC2+xGbJm/VeddhQ207bHtXLlldP0xNlVvivJis0o1THCRyDrb\n    RCEUx/GcX/6dVMCmlY5JBsvsX64CBtuXFdv1cZoc1mRzwHpDI0b88hsNuiHh9kPj9/+D6bc/wMOj\n    LaJLCXo3j4EeEVw56khgrl5K/zvF6G8PoKbewnKXER520LvxKMJOJAjWsMgk5GpaqQKix5T9Z5pY\n    mnmGORFr5glL9RMRxplRiEbxOlSspnMErPgs0ldL750XyLlqiWcncttNUjCrJEb39WuIL/bO+p/L\n    Y93IFCafjTH517hUtLarf8slbZ/7uxsIeyEO/nSA8GKIpiSwfj5f3Y1UriS/31RL43FeEV47Rve3\n    D0GFUTHH6MgBc97T6uB8ftNKYbBHPAc4PzYEd7DQEQv8SkWvnbKvjM19umnKjHQgO2qyiJYNUzzv\n    l68HtGo4/zuh9UNUPGZRC4cJ+je99fM+YPLDFIM7D4qJs2kcDX8cPdFF77Ujn/vr0RpqMsH43Y+h\n    JlNG+Ob1GCJ9M1ZzMe2gdbO+dHCTpC7Vd1KgsILmBDEphPWdtKn+1YRyvs+m/qV6lCR3pUAD7NgU\n    eR2ziRDDdjVOK8aLT9pZX6x6j3xbnWqYk7pNlcVVdViqwbqEOE3snzkWtWXO30N9fbrJmEXeA9Xc\n    V60MXhWZuyohW1205raSttvIhW2j4HOdWKH9M7AIAbxqP+t1YBt/KVYpn1+lDfRZYtVkru38deda\n    lw10G9iyIZax/aiygXblStCkVPW63Aa6yvbZledrs1qpWqzJjj/XGLtldDMClxabroWcXLyWVcD5\n    thl7jQx2FbDZQanPR8dUq4A5WWxa9OhOUJn9ovdxNXDIbjy0HVBOCIfsZoRuOJTKML7zEbLBKnrz\n    PPYNnaf76Lx4gCA0SQoXCWzbP3p/iOkXIyDbvrndY3VInrqM7nOXDKKWq3u46laxQrEmUlEUu7nK\n    lxeYM3DFkpkPLHMSTVtmvk8rk/kxXOGk1VK6AM9VTAAvrqP4eWKgUFehuGLnr5H85iKS33jr533A\n    7Icphm8NrEVr/ty1LQAQPZb43N8dQXQ1Qff1AwQiD5iTwK55tGim+jHF+K8DZBM/j+46ur99BJ0n\n    Dtk8p+dFajIK2GMaA8CYu/gcREQxV+3yeIIQ2iKaz4s8uxdizuRNVNKi2iSUdV4xfS83UIUF+Uvv\n    P2SPC+I6CNH93UOIH/XWz7sOdX+G8e17UKOsaKSyjkN5Hi0U6RdjHPzpGGHPT6Qe7TH96j+YfP7f\n    eV3FrM1Qm0yEzNjGG/GjeSM/b+LXggA1rzUpTAFWwzHrRUQUT2G6z/FVQ4a8Lkg+Ry71LyeEec3N\n    Zgttq7ulxRHm+aUroFT/uuLf+GOq6VXVAgmSxK2Ln6uqa3KS1xaVx/ctiqpjJVEshUOSuKXxVYRu\n    1b4xFhc8uerti1YYff7v+cU22j/vCVavAD5LOfQqsK5fxm3snnCBX5TqulWaYJUXzU1aM7gmqWU7\n    oFahApbPq7rEmqqAFzm2bpxLRcxJXb7gc5HHfCzArVmaZ4MQQsdrQywyqxau/Cfh37kKOHEsmjlB\n    mxiErSaNeScmVwGbt6naDprOMWU3Fvzmgshd6ibVNxdmxgy3haayj0KG9L/3MP34c6jMqzA9WiIA\n    Dl47RPxknoIuSWBX9la+f36lUMDw9n3MfvIWljuNMEDn9esIr/ZgKoO02oiUvBCFYp63qwvVZoYh\n    t4LkaqTUKF3bv2RuoqlmMm2l+fvieYZUjDatrMtKJUkMBwgQXe2jf+M6gnD3ols8TGT3UwzeHEAN\n    lbNobZoBljXn4YVcNepzf3cH3ed6pTxggJPAAWxlT6OZ6oMxJl+MfTPVjiPoROjevI7oMEHhIMEI\n    Xdm4RCQszT6k8KV9fB7jbhV6btRzKXfTQM2XnEtTYy4NHQ1f5WgFnfWL4rVNHxAdERE/fojuy976\n    edehphlG/zjFbG59X2X9TCg5KHQDdF8/RnS1bViWhweQ3b+P4Z2PwZvxqe4SITWIXt7IH8yjuAK2\n    z9bgz9W/umakieGc8M1/96UgYRn1LwkdADdx6hJQSHLVpv611d9kra6Jm6DtfVUpd8t20vXrpKox\n    vNbpsn+mx7IWO3E8JixaDRk33NZteD6ZLeyCizAmIdYqsKz986pef1WK4UVwH6vhblaNVfJgbYWe\n    Jy3G7kH+L7CLGcAe24l1XQxXdeGuyyVwoWmuL0e3wXnqcoBhGU+wLQrqFhLyHIlj0VJna1K3WGqy\n    mCLYFpVxzSJuZhlrs3VOYZLI/HzSCoYWrW1UwPTdpQKmY9L5Z+1SAVMnZ4o8Y2QKc3HPs18oC1iW\n    hkPWNUpjA5gqYGk5ZGYD50Tx6N0vkN1dsQmFx36gE+Hgj8eILuVlxvoyTA4qLwJAdppheOc+1MBb\n    WO4yosMuDm9cAzqkyzXVtFQsNtVCoWFXSY9N1REAVhCm52S3rNj5QpQL1aEYo4xzwnhNyvrlzwPj\n    GF3opp+F2z7TcdmcFA47EXo3riE6bnpL7nFekU0URn8fIv0hX1G4itY8Q7NUtPa5v7uJeR5w/ET5\n    35Wr1qx24LQSzoDhWwPM7s7gsduIHzlC57cPIQjN+VGSwOYcFBaEMXe94GphV3YwYM6lUvVbNZdy\n    1w5bzIPZCIbieVR6P2bTFhHLRByHhwl6t64j6PjGmJ1GpjD9YoTxP3LZQN5IpVHnOqQQ6Nzf53yE\n    gscCmE0x/MtHUL8MgMJ9jTfac1Vvhow5tdG2kDXk80Z9rv7VjnJUxwE4WUzqX6pJKZh1KRqTgNe8\n    7OpfPkaqf+VfVRMRBX8+azDe+VGj2sa5LB4x63gzLG7/LGuhTeucVIvlZJ2rDithI5NdNWNZh540\n    GLONaKv0XUQwtgv5v6tGtqbfjV1X/67SMVlW3pfM/wXOEwF80nL8NtpAr7L74QCrsYFe1G+eCN1l\n    CdhFbKDbXqDrJg2ynVg2e6BpDnDVsXwSbmoDbZv0my5A2tpAT9l3+RpS1WuzRuGoyuOIWyzkpA20\n    HMfRPEvEHJ9WnsOmudDkLj9Gdl/yjGBOFsssYJ7nEs6fh8Vz3SUawFT+qvlnw7tH6exZcSOQP4rm\n    xK/UzdF5sskMwzsfQo1X1avnsU+IriTo3ThG0NXKRoJNCcz30V/N7OsJRh8MoGbbN797rA7x01fQ\n    ee7S3DpZqnryx6ad8ry4C531Z2YD6mI1EatcTcxfgxel5RdX5mpiNz8uZcpdZVxJTbKaxsQA+zso\n    F8jJmhoIkTx3CZ2nL5/1P4vHupEpTL4YY/zPfI6VRWuCy0of8Lm/u46wF6L/pwMEIg8YqHPTYEry\n    0wzjO6fIBt7RZdfR/e0jiJ84Ku4UzCiDcrQCOWjQ6p9bMlPzFW9UAnQTCnfpcM2hVXNpNH+s5vOz\n    bOQKoNeOROoSwSvnXf4zUvQDggDd3z6E5NrxWf+zeKwZs7tTDG/fh8poHq2+Z5DkLwAkT3Ty3N/z\n    Uyr12BYohdl/vsf4/W+LWgs11ktClzfk89oM1X9kIz/VcuKS+tf8zgUDpt2zqf7lcWSyjgXUZ/+6\n    lL2k/oVljBLfeT0vrRjvEoHkucfmttjyvlyWzxxt7J/l9ipVLu1LUF+/kKKdNmrfOuvmJq/fgVuE\n    1EScJN/DqtS/ber/qyRzm3AdbfgQb/98/nHOHY/PdlWzrTJr2ZVwHuyb13kxOS820Daid13dPMvY\n    QLdR9vKx8jVdmQ51SKBaZQy3tRlpkv8LmMRtm0WZXABK4t62AJSLTFrIRqUFont8/tzdkUgq4Egs\n    kmnxrKH30/kTts2VBUyLecp5SefUQspuCGTuS1AQx1nppoJuRvhNB7eB5ipgIo4nX/2M8adfAd4K\n    2mMBdH7TR/eFPhBw8kvDTQLr9pLxe6eYfjOC2v5p2WNRhAF6rz+K7tUuuC0lJ3qlxaS2iDStI3WK\n    um6XATsXFY/5eJlbKFVM5jGSiA5KxWdSVKEod2vLajq/LGTTzxM+3Efv9UeBsJlq3uP8YnZ3luf+\n    OorW1NpFsP1G+Nzf3Ud0NUHvDwcIEksDwPw7/Z5IEpieT76aYfL+EGrqJ9JdRtCJcsXrUaeYh/i8\n    yOcgPmeRSjcz5kRA5vTqOcsdoeCaS5VzLoXIHDYJXop6MB09yu+TR0KECJA8cYTubx85638SjzVD\n    DVKM7txHdprfp9ZZP9vI3+hi5HN/PRZG9uABTm9/hAApeBSXrtVw82XdwJ/BJIVpf7mRX+cJB+yO\n    J4RCpzDi14IBbvHMhQY8jiwnUbWKmOpeXP3rIoml+pc75dmEFLbnaLDfJhyZwW0H7TpGwiY2aVrL\n    dO132T8DmuDl9s9Na7iAWZd1OUbattlqv8ryujavKV5zHlm2NaltVwmtlhVhLWL/vEnUcSmLCvI4\n    Vm3/fB74rzqcnPUbWDFWoP4FzpoA9lge6yJ+25x31cHohKYX6WVfnyadRXWNVSRtm21yEnYRta5J\n    tsoGeopq6+eJ5RxNbKDle45rnru2RVDWxVkTWxY6p80yuq2lTNV4ThiXbaDLi2AigulzVKVj84W5\n    SwXM81zkl+6Q5LbOXPnLs33ppkIZNyD8BoPIYcoF5uP42AAZJnc+RfrzOe998jgTBCHQf+0I8RMd\n    9ldgFqpthRpd1AZUqjB+8z7SE58HvMuIDrvovX4NKomMXFwqNnN6ldtAal2cqU7iFpLcjlkWj01F\n    k5mvWc4C1vtI9WS+jiZ/c4UTFbdzC2j6KbiamRfpw26M3s1HER566+ddRzbIVZk41c1VTYvWxTaf\n    +7s36D7fQ/J81/qLoB01KqygAYz+MsTsq7HdD9VjZxA/fIjO7x+CCqNi7uMzqiZ6Q6MRKWSzWIig\n    9B+f9/gcyeczOZe6XC944wJ/XT7Pmk1V5YYtag4L2GNSAweHCfre+nnnoWYKow8GmH6VVzVcLhqB\n    +J6Pnf9udQL0XjtC6HN/PRaASmcY//0TpD+fAqx2IsndyKjT6P1k2UxqYZ4LzKO9tKpXzYUAWhAg\n    1b96VcmVxTBiyCK2jS8KbOpfl/Me2Jg69W9k+V6l/uWQr90Vx1QtamS9kAtRXOrfqWU8YBfINN0G\n    2Mm6OjLYlSXcFttk+zys2e/iA1zbV2n/3DbC8izzf88LlrF/XqfD7zYKU9cUvLgYAbxKX+t9wj2s\n    3gb6LLGqi9wmfPoXtYFelhx2YdXl3LY20K5Fg8sGeup4XIW6RZIcIx9Xd9rZF5C2c+kjllMBE1ap\n    ApYLba4CLr8Xk/AlFXB+HL8J0DZA+sYCc+2bmSdDeTTR/BYhY8eYXat005IhHU0wfvcjqHEbLbuH\n    R46gN88DvlguxFX9xXM13OwkxfidB1Bjr0TfZURPX0HvNxegSV+eGaiLzZSnq60hw1LZ2SR6NflK\n    aiEikan4zFtudPZgmXAmtZRWMJnvJbVsk0RvAECrlvR76Lx0CcmvLp31P4PHmqGmCpP3h5h8la9c\n    XJaV/De6tD0B+j73d28QRED/5gGix9r9exuERwoMbg+Q/ezzgHcdvZceQufJ3Ao6BoqmJNO1ArCr\n    eEMWcYBiG/kMhWJOJCtn21xK86ltLuVErov8Ddn/+VfKCF+t/J2/fhii+9uHED1ydNb/DB5rhFLA\n    9JsRxu/l1akm1s/FsfTbHQCd5/tInjs46x/H4zxCKcy+/QGTf3xj1FEkgatzfvXjjNVcaC9t52Rx\n    CrJv1o3/ROpK4QCPDiOFbyjOD6DYJ+PKqBYlSWI6hl6Db7dZRVepeWPLPnuNzW01zc/HURcV51IF\n    N1H6NrV/dhG2XP3rgs3+Wap/OYjUHYvntK0pYSyre/K88txosL0KTdS/67B/XpW18zbYP3tbaY8W\n    OHsFcBu2/WSD7+s8hVOflz/6TdhALzt21bBNwnx7HaS1Rxsb6DoVsFx02BYhVYuFqfjOH7dR/tZh\n    VjO+jWU0wba4jGvOxwnj3NTH/t5llyRfjEsVMO+sDOeLaDIG4hkvelx5kc8to+k7J4y5Clgne5HV\n    swLETQm3h+ZqYn4TM/78R8w+/wpQnoDzaI/ooXm2VpfUv/X2tlwFDACTT0eYfDIEUt+QtqsIowDd\n    G9cRX+kWVy5un8yzB7mCVmYUkqqprDzSReyUXR1duYW0Ly1eWxfHOTWnxHsg8pkrq3gBXlPAQfGz\n    hY8coPPKowi88/NOQylg9tUYo7/kbYhUtK7L/iXoorXP/d03BP0IB386QHih6l6+WgWc3csweHeA\n    bOTXcruMMInQf+NRRMcJSB2bMkKWSFQiZDNBwgbQGcAamqzNoBulMva1zFzKM3313K6bqfRcSuSv\n    mTFMJLO3ft4PZCdTjN+8D8XuCZosn3T2NRA/1kH/xhFCLxT3WADq9BTj2x9CKTJb1nUVmfnLm+tJ\n    6cvJ3nKtRtd7eD4wCQG4Wjhk2+2CghxU49OiBe5oV63+ddXvqlz25HsBTOVtiHY1QX6szflP1vNk\n    PbCJyyCva9Y5EZZ/zjKo1npg+XeQj6teoy2aOkouQuAuav+8KnEV5xeqav7bav+8ja+zSsHiLlhJ\n    bwNWZP8MrIsA3hZz0HXKxPcBnFiuu6isityV56m6WA8qjmuLRXIJqrqfmkxqtuPHlu2L2kADzRcL\n    TbrSmmZbuJ5PHWOq8jniBgs7TvTaFmdNtQ18XNusEm4DzRfH8rjMOJe5iM+75m2fsSSc9WKfbiL4\n    ecj6J2Q3DRHSQhFM47itEFlAk+UQZf5qW+pyRvDpnU+R/u+k4afr4WEiee4AnefdecA2yG7+4Z0H\n    mH7fJtHc47whPO6h+/o1REmupJXq3pAVk2H5zglYbX8JcCI4YNts9pS8IB0W+iOpWqomf6XyKWDb\n    srk/A5036kXo3XoUUd+rOXcd2d0ZBrcHUGyx0Ib8VfC5v/uM6OEE/df6CFvYCtHVjGbT6WcTTD8c\n    Qs38PfMuI7p6iO4rDyEIiVSVdsxhQaZGgJUE1nm9Wg2sIC2fuarYbNHicy6sc6k5h8rXlvuUmGMh\n    nodH3vp5H6BGKUZvP8DsRNNYTdW/ND66EKH/p2OEPkLBYwGodIbR+59h+tMD2OKzXESw2XyvG++p\n    oR+wx3cRyVun/iW1b1wQz/lzbvkcF5bS1epf6WwnQe+hA7udM8FW9+P1Mmn/HDvOA+Q1Wlt2r8wJ\n    tj3mqKpB2rYta/9ch0nNsVSrddWDmxC5bcYs6vnnqodTbb2J/fO6RV+uY9YVcblqSCHghbN+QxXY\n    pMDypMXYPbJ/BrZBAeyxHPbZBrrt+ZvaQLtQRequygx3mQmb3kMT1W7VONfvVNNFTFW3XJ0y2JWz\n    YVMBSxLZtsCUY5vaQKua8bS4VRULYMCuAg7ZuXjmL38trgKW2cC8C9T13aYCJiI3ZoSvmi/66WYk\n    QoYYqdGNat6oaAJYDcYYvvuxt4L2WAhhBPRfP0LyWGderNFJ1i7IwrUaZxjdvo/snrew3GXEz1xB\n    5zcXEcIsSpPdI1k6S/tnGxHLi8h8G2XyartnGF881VdbTpcLzgHC+X/6PXIFk3x9XdDOr9IIAnRe\n    uoLkiYtn/bF7rBnZMMPgnQGye3q2t10BXc0xCkDoc3/3Hp0X+0ie7RbNVBJO5TjD6L0hZt9OfB7w\n    jqP74kOInjoGNS5xojdC/ntBqlzaRypcamCiWY7aTAGTxJXNVnz+JHKZmqm44lfbNqPYFsEkf3X+\n    MJ9XyfZZW0iTUrn3ykOIHz4864/dY41QqcL4oyEmn+VVmioXjeKY4vv8t60ToP/aIeKHfe6vxwJQ\n    CrP/fI/R374Cd1CT5C1vpOdjNKlLx+bbUnBFcFn9GzKimGo8/LmCVvZq2+ccXIzA7ZxpXzP1r3KS\n    uK5tdYKKKrtoua2KGK4Sl0DssxHIqNgmn/PP1SWQSaAKYQ0X2vBabF07exv7Zw5p/7xK++Zlj29i\n    /1yFpiTtutS//PXrOJHz4tjqsfPYDgJ432yg1yGF38RFZRUq4EW6aZqGvK9CBTxCu8moyWQ3rhjb\n    5Pi6zIYqG2gbmthAuxYnsXhMixFV85pNu+jilgs12zmbqoDbLkLrxtMnQe/VZZHDVcAm+atzgTkR\n    HbJ9/HnMFvma5M3As4BTcIWxpn0DdozMpqEvaQXNx9INzfTTHzD5/CuozNsHerRH2I/Q/+MxguOo\n    FQnMMfvvFOO/PYCa+t/BXUUYBejcuI7gcpepxXlub/5d/25oEphyeIM5KRuyMgq3hdZZhHnJOm+H\n    yb/In4HadiKmZ+JlGakE5kVxaS/N3180/ykyhIivH6L/6iPe+nnHoWYKkw+GmH2Rr7qaFK0lQp/7\n    6zFH78YBoutxMY82gWEFPQaGtwdQv/hmql1GEEc4uPUoguMOUBC7KAhbmgu1NTPAm5bMPF5OxnL3\n    Dd06pdg8yr+IFo7Y+amBi+ZSmR8sFcjUECZdP2hk9HAfyYsPn/VH7rFmTL+dYPTOA2NbG+tnzHN/\n    4+d9o4DHYpjdv4/Rmx8Cacqa5rMSyRsW9ROtCJ7NyVnusBbO83hDuGs1plDBFABoW2jApgaOYIoG\n    9LgcXLCwiPoXKKt/paCCf08rxtscAwnlbN9q+2Q+tq72yGucttdeBq56elP75zr1r4SNWLbVbZsa\n    ybQlehcleduStm3EZMQZrFuAdh7tnwn3NvLOm2Ndzr7bqP6VWKH9M7AtBLDH2eKw4pdqlcRyXWfM\n    Kmwb1tXh03byajo52iZb26Ts6uhybaPFwRTVpKord6JJObFKEexasLmP0Qs/ueCqtrGuJlxtXX1N\n    VcBRxXig2uKGL46rVMD0M2TsMbffkdv5c5OQlaplIok1IcxvREKW7Yv5Z0c2z5Lw5RnA2ihaE8SD\n    259i9uNPDX5jPDzKiB/poP+HQwSdoAUJbF4lx+8PMf1iBGTbv4jzWAzRcRf9168hSCKQeogKeDJb\n    FzAVR6EoXpMKCUbxmttamupfCV0Ep7PzPF+9nyuQeUYiz/7N1VDzYvhBjO6tR4GuJ/R2GUrlRevx\n    e6bvTFP1Jg1Onu8i8bm/HgDCgwj9Px4iPA6tJHCVCphmzfRuiuFfBlBj30y1ywivHKD36sNAqOdN\n    TfLmcxqRwAHLBTZJYN3kFLJj+X6CaTKtocT8S/O1bJziLhtE+Mrmr4i9kkKAsBOjd/NRhIl3Rthl\n    ZPdmGL11D2pC97/11s9050wRCsn1BP3Xfe6vx2JQkwkmf/0Ys59PIRvpiQzO2HPuykatptKtjf6L\n    mGNbOq/G0PeQWUrT95jVmkhQYMaNyXiyMglM6l8Ol/pXjpGPbUKKKiK1Sv0rLZ2raoMK9hqkC9y5\n    sAo24UpVLdS2z0XySnFOG+toWXNeVMm7iJ9f1TFV9s8jUJRdNVzcgK3ev0oyt62obVWOqG2xDgHg\n    LmT2nqzx3P+r2X9xBZ/fGu2fgW0igNfFvu9qDrDN3/2srAXaXvTqLqptlLxtcwHOgw20DatOuaxS\n    AQPuBUrThU7VYqppLrEEX8RVKY5ll1+VcrhK1Vs1Pq08h14czxyvQSpgbgetuzfNfBZp68wX9zG4\n    rQ+dgxs865IJtyDi43VJRVs92zpW5U1McSMzGmP45r+QDdbdR+exq+i+cIDucz0ApjWb669cFq6V\n    Asa372P206JpOx7nAclvLqP7mwtMaattIMmqMpjn6aaG+SSMMQXhChQWk7r4bdo0l7OFywVrxb7b\n    jKNThIhhqqxKWcNBgO5LV5BcPz7rj9ljzchOZhi9eYpsvshoUrQm0LUv9rm/HgLJtQT9V3sIEvqd\n    MmEngc3fu/FHE0w/Gftmqh1H74UriJ86Ks17AZtbyaqZFLkRa6nix3ASmTc4leY4sY3mUmqEojmU\n    GqZ4xIIqXlc3TdF8ziMc6Pyd/7uE5FeXzvpj9lgj1CTD6C8PkP6YT6R0xaqzfubkb3CcuxCFB34i\n    9VgAKsPkq/9g/P63hepXMXVvUFRo6LtpAU01lQgpAtaYz2su5NgWC/IYQEHcxpAuboAmmbUaWLHj\n    TAK3Xv1L9SwuYJD2z6tS/zZx8osaHGOLjANMcYyLIK6Ks+PgpHAz++cc0mGxDlN2LtdxTeyfAXsN\n    tcqlskl920U6L2vx3BTrqEAuS+puQv3rbaU9FsD2EMBtcHLWb2AFWGV3xVnnAHOcRWD6KlXANFHZ\n    JizXJLaMDfTYcbycbBMoY5uclKtsoCUlUkWRNMmo4Isa12LHhirL5yn0IkzarvBxi+R8VC0kI8di\n    VXY4ulTAUcVrcDK3iQoY0N2aUbFVq35poZ8a7013kXILH9MW2uwQVWy7zv5Ni3FaJUwG0vpGJTQI\n    Yk0Ip9+dYPTPz6BSbx/o0R5BFKB34xjJo6byscoQVRauZ6cZBnceQA2ambV7nD8EYYjOjesIL3dR\n    KH2YbaUuRodze0iTJA5Y4TljV2Kyho5Bel5+laYxOv2Q5wzTV1ZciUlVpa/OXEEl3zddiZMnDtF7\n    xdtV7jrUOMPo3QHSn02NRRP1LxWtwwsh+j7318OChOUBN7kTks1UUMDw7QGmP/i13E4jjtC/dX1u\n    Bc2JV5MEJkeLDFzZq4lebsGsW6LCYhZWji/KH5axDHwO5T4e9N5i6LuXgL0uJ3/Dhw/Qee1RH6Ow\n    y8gUxp+PMP6XdNGoUgUK8rcToP+HQ8TXmhqfeniYSO/+D6M/fwSAu6uZ5K6at6rwSK2AkcT0H5G8\n    il0JbU5vnESmLXmzv64x8XNy8UAErQQGuGOcW/3L4VL/2rKFq9S8cc3nKl+nSX3PViecOcbycTYy\n    tEq8Uhd5R3DVWl3kLa+5Nnk/y9g/29D0KshVu4uofwl1giugvcirLTYpW6kiag8b/k6dd6wrWlXi\n    pMXYPbR/Bs4rAXwW2AU5/CqwLNm8DhvoNmhy/rpJq6kKuIm1BWCfdBe17+DvwUXaSrgWI03/rac1\n    223dc1WLqyobZ5uyV9pN2xaKTRaTfLEas/O5xlXZRkN8b6IC5l2dlPdLpDEnbblaWO8zVcBmhq/e\n    lxZksVYLc1VwCn5DwbtTzY5WGsG3jf/6JabffJ/LMT08WiI8iNC7dYzwiEz9clSpgKUV9OzrCUYf\n    DKBm/ndwVxEdd9F77REESV4kpkJwyorVpFriNs9E2WqDSV28psKxVhFrY2cqLuvX4laWWgmsi9Vg\n    70dbQut8Q078zhVNRwm6N68j6NSVRTzONVKFyccjTD7RJZmm6t+C/J3n/sY+99fDgiAK0L91gPi6\n    /VpSpQKm38JspHKF+n3fTLXLiK700f/DQwhjmpdy8pbIXlOFq+c0UupmbO7j1s/6/zonmP8XinPz\n    OdsMU8jHpUbEAyec9esUVtHdGP1b1xAd+OvjLmPywxTj2/eLi1ad+pdotGJsAHSf7aH7wsFZ/yge\n    5xTZaITB2x8hOx0DKEdoRUgN1zTeRG/aQZsxW+VoL/NL2zVnxfcQ5BqX14WmICJXq39N4YImjuVd\n    tk39ayqHTZAyWLYjlglWXSfjtTpe92oCbv9sU//WiUIAu/qX1xKbWkLz+meV+lc+lsKaScV5OWz1\n    2ir75zGaq4zHLbdXvYcqrEIRTEKvRUVnqxCrbYP9M2GbhIDrwq46+tqwZvtnYNsI4DYs/MlZv9kt\n    xDI2AMvmAJ/lxY+Tuqu4qDfpSloEVSpgCdtkOhFjl8l8mKLaBlqqgPljmSusLIsmF6qI32nNOEJT\n    u5em+gVadIaOxanLwkbCpQKmjkubCpi/vqk21ipgnv0bIytykrVamBbRWUHgZpCK4fw9xPMbhoCR\n    wFzlG0J3qwIKyXzpzxW/TivoNMXwzx9idt8bkngshuTxLnqvHCKc1655HrDtr85W7Bm/d4rJ12Pf\n    h7DDSJ69jPiZC+CFXyoo87xfKhaHgGEJTfuptK0EEWwWsjnMc3M1Mdj2lBWpuU0loLVRVOIOwwDd\n    319Fcu3wrD9WjzVj9u0Eo7f1irWqaM2JOiJ/4XN/PRogPIjQm+cBA9WWqLS/5Kjxwwzjvw+hpn4i\n    3WX0/u8KoqcuFO1RWr+bP+fZ9WS9rIlg3cxELVN8LtV6YfOLXsdG/PI5OICpOubbQ+iYB24rnbx4\n    GcmTF8/6Y/VYI7IHKca37yEbSheNKvVvYPz+JdcT9G4eI4i8TNyjPVSaYvLRl5h9+VNB3IaFjXP+\n    mJO80vqZk76AbrbndtEpdMM/1W2k6pd/14IC029Bqn95zYu7xlFNSULWqKSQwmXnLGFT/3LSt44w\n    hhjbVP0r64FTuK2hbdvksVVjXaCa6iJEnXRFbGP/bEOV1XPdtlWpf+v2A+3cPOvEXcs4gy6K82r/\n    vGrB4zYLKM+D+ndN2C4CeBuxKbn6sthk90fday1Lwtou5G0v3lXjm56rTZdSp+Gk2OR4F9pO+tIG\n    uulCxSR9czS1EOGvUbeIsr8fvYibimNtHXs2OxqX5bNc8NkIXZsK2NWVyDskAbcKuMoOx7Rszo/h\n    1tFSBUzELl/k06Jdd3iaKmAic+Vx2upZd6sSZZKx47XK1yR/9U2LzqnJTk4xee9jZONVp1Z77Au6\n    Lx2i8+te8ZyrOm3gKuAAClma5wGnJz4PeFcRhCEObjyK8GIX0bysl1+vtVJIZv6ShaRW4moFLreb\n    5KSu/ormrTc631cTvwDXLZG1ZQSuCuZqpRBaiRIgefIInZceOuuP1GPNUPdmGLw5QCYWbLaitcw/\n    p8eJz/31aIjkWoL+Kz0EcTkP2K4Cpn0a43+OMPnS5wHvNOII/ZvXEF3oQGb0kr7XbGIiYjYs7KJl\n    DALNk+l83szEfEpzJz9WE8F8ftW20hk7hlpPAZ08DARIrh2g9+oj3vp5lzHLMPr7Kabf6zt9ctGo\n    Uv9yRMehz/31WBxKYfbDfzG+8xnA6ie8JqLrMLpJPmLfVam+wsnhcq4vd4Gjfaq4kuqaTArtThcj\n    KyydZeSYJFklKdxG/QuU1b+uupmNzK0ab3u9qlpmG/Uv0Fzpa9s/dTy2Pa8CVwNPGh7rEhTZzi1h\n    s7Belwl+VR19U9nALlSRxn2olQrbvCxmczg56zdwPrB9BPA62Phtko3fY4/X0RWxKxeZtiTyKq2j\n    u1DO7qS2E9YyNtC2SbqOVpPZwHXWH1zpazu36/iqBYptUdSUfG66aKpSAdN+lwq46eJz1nK8a2yV\n    CthFEsvsX63m1dbQupOTyFyd/cJvDngWjAK3HSpbRWM+PmVkLyd9eQaw/KLzjf/1LaZffgOVVSXJ\n    eHjYEcQBereOET+i+4R5cVpeSWyF69lJivE7D6DG/ndwVxFe7KH/+sNQSQSdqwuWwavTCKloTTm/\n    mUHOhoXpMyeBA+hMYEkQU+YwKaUypmIylU36ffG8Xyp2h8dd9G49ijDxhchdhhpnGL43QHq3rKWw\n    q3/LiC6E6PncX48W6LzYR/Kb/O6Ck8DcDpVDNiOoDBi+NcDsrs8D3mVEl/vo/eEhBHHE5ijtqEHz\n    l0kCo5j7zHkTxjzJM3pjUGMtn0tDaD2xvqOgJqrAmH/BRpJGeU799RJ0b15D1PfWzzuLTGH8xRiT\n    f5QrPnXWz4XyPAb6r/rcX4/FkZ2eYvL//oVsNhON8bo+Qs9t9RdZg9GN/3psCkn8ZiKiC+BEMRcA\n    2JS9VDMyRQcmsWsjeBdV/7rUvHRXXzdeRrtJmHFv1WSvS/3rOq4qvk6eW386bvtn6ago7Z/r0Eb9\n    KwnhJq/TgSoJiWQteVWgGnqd02YTERfnCTaZ5Stfe1mieNX5vxc2/Fl4rBbS/nkN+b/ANhLAbXCy\n    4dfbNhn7qv/I21yEbCpgfhGsInBPsRqrZhfo3MuogGlychG+TewrbKjKWGhi6Zw0GOMa36ZDzbZo\n    kY+bLH4kePee2/JZLwBdKmA7mls0u1TALlUvWo53qYBt4ItvynCh8/LFcSrGZsU7UgZJLHNi+E0G\n    Ebn6RqJMBkuFsOxYDee5Nty6KJin35BV9OjPHyO9u4EUA4+dRHgco3PrAsJDc42iyTMTfAs9nnw6\n    xuSTIZBu17ztsTokz11G8swxUx5pxZIuMnMFeV7EpqI2FZtVMdZUJaXsnKREp/+olJMWBLJWDpvF\n    c52tyN9HGIfovXoV0UM+g26nkSlMPhlj8mG5xc6m/s0KWoPZpSZAz+f+erRFnOcBJ49S6p+9YYpg\n    26fuZxjdGSAb+GaqXUbn+StInjouyF8A4EQwV/ny+ZbcL8ymKm0ZzR1cUpbny+db3lJKjVWZmC/p\n    //r9AFxt3H3pMuInfOlzlzG7O8XorfvIsnJuuQ2S/AWAzrM9JC/6uA2PBTGbYvyPTzH56UFx1VLF\n    d10XMb/n+3VEF6mBM8yA0rGAbuLXXnDazjmEtofmtSLuGkf1H9M1TmuTAZs7nV39G7HjjY/C8RGt\n    QlBhU/JSDdBV4+P1uSYta7YaaF1MXRMxi6u26nLP5MRw1fuhcU1JWdu4ZdS/rrq3qw69rPq3Kam7\n    7/bPq3wtznPdW+I8q0ZTIedJi3Pusf0zsAwBfLHmg/vfEu9qn/5Rto1UdmEblMVVF/E23T9Nxi5i\n    TeGaBEcNxzZVAdsm9abbqhYviXNxkkMuTpqodSWJ2+T90PgqCxe+uFOOhalNBVylHK4iaVelAuYk\n    dQoYmStyMc4zgkOxoJc3A/yGg7bz8g2pevmxeqxpYRTMraDz95UxstckfDkJTGPJKjobjTG+/S+o\n    07NMB/c4z+g+2UXnd4eF3am0sOR/9bJwTbbQwzsPMP3e25HvKoIwRP/GNSQXE1a4pixBnWbILaF5\n    EVkTtLoAnZbsn03rSipi8+PN7GBO3ZkWl1q9FKDz1DG6L1w564/QY82Y/jDD6O2BkUleZ1kJ+Nxf\n    j9UgPIrQu3VYNFMp6Dv/DPUqYACYfTXF5P0h1Ox83K96LIA4Qu/mNcQXOsUcqWML9DyZk7o8o5c7\n    bgTGHJmKuZNHK6Rzi+cMpkqYWz3zRi6az3V8Qr5PIUByrY/+qw976+cdhhqmGL39AOl93YjC1/ul\n    8SiTv/GjCbo3L/jcX4/FoBQm33yH0d++BtVG0nntY8baWKT1c8BqNDLHl5PEmdjOm/V5zFdY1F1Q\n    nJsqOTwPmLvOASjVjExiV5VqWrIm5RI6NFX/Nh1fp/7lx9Spfzk4gTtzjGvqWsjrjlXqX/lYViPq\n    6qpV9dM60dCkwTHAYtnBiyiDqa6+qIAKsKt/22JZAVqd+rcNIbus+ncbuJkqcI7rvESq7gnOtwIY\n    OJ9e3+vuqjjLC8JZ0j2bsoBoQg7zybFJvq8LtmNVzaRfZQFiW1zwRYJtcZJAtVYB13XWVXXZAXpx\n    ZiOQY7FolJ+Oe599Mbl+FXCOdP76fJEtlb7lLGCzI5P+y+b/DhG0NTTPdTEJ3ryblHrqudqXk8d0\n    08GVxdoeWs2PT4sbEGkRHcxveuj8k29OMPrnZ8DMZ7F6LIbubw/RedrMAyZU0yc5srHC6PZ9qHve\n    wnJXEV7soffaw4hiXShW83K1zDPkZK0eS8VuTc7m9pPlr3D+PYZpc2kWxLVFJS9S07gUIcILHXRv\n    XgNib+e7y8jupxi9eYpsxNdJOWxXLyLkQjbO5/56LIv48Q66v8/zgAGh8BVjrSpgAKO/DDH9elIt\n    ufM414gu99B/7SEg1gQs9yMIi+9apasbnPRjmi+5Crh4DbaPk8YKukFLzpk6X5jsqDUxHPUi9N54\n    BEE3bvATepxHqJnC6F9DTP+dVygk4WveF9jJ3/AwRO/WMcIjP5F6LIbZL/cw+PNHgKJm+axooOeO\n    aBl4rcZ0SNMkbz4+KahaXvPR9Ri+T6Fcu+GWz9INjqt/6RW5sIB/d2X/cpKY164WUf+2HW+r47nU\n    vVIp7HrtMjmtIeuS0jq6aZQdB9VUOSnY1P5Zvl6d/bPcJsfbfuZOxTZ+3jbq3zqCdxn7Z4kBVl/7\n    X3X+r8f2YRmh6TIC1y3C+SeAm2KZHGDetbDtit1lyd9lbaA51mnzXIdV2EDTZNnGBroJ2evKahij\n    eXdW021Au6wJ13EuFTDBRdLSY2nlzI+rIoOjigWZTdnrGgvr2PIxVSpgG5qpgMsWz+X3rBff+rwm\n    oUvHZ8URtCjXNwUx6wyl7ZxUppsU2jdlBDD/zq2hA9GZyq2K6OaGf/EbovFfvsLsq++gsu2+bnps\n    J8IkQO+NY0QPlfOAAfMvWFrC0fPpf2cY/e0B1NRbWO4qOs9dQvLUMQCwArJZnFbgaiL9pS2dTWtK\n    ZfmicVT4zljhWmcNc9WTzvsl8jdKAvReewjR5d6CP63HeUA2URj9dYj0h2bNJ5wYpsc+99djVej9\n    VucBA/ruvypSwVihpsDo9imy//lmql1G8vxldJ46QgaydtbzGFfycmcL/tw29wbsi8+lYHMjJ35p\n    S8jm4vwKyJu2AgQBcuvnx731865CKWDy9Rijd09BzhmAXf2rfa/M9qowBrqvHCJ53Of+eiyGbDzB\n    +N2PoH4ZFM3uStRHUDTaawe1yGiUB6L5mHwWNespWiXMf5OzghDmjf3ayjmvG+XnzsUaGXS1JkFW\n    1JWkIrecE6xRtofO0Vb9214trCHrfbIuaKsHVjkH1glPmh5TJWmw7auqwXJlcF0sH9BcedtU/bvI\n    FbHJe1iH/fMiVs5nYf8sse0qXcKq7Z83zZedbPTV3KhzSK7ChvJ/gW0mgNuw8ydn/Wa3BJvwnF8V\n    Fs0BrrOBXlVmAFDdpdTWIrqp5YVtMl5GQdzEBpovOtqSxW0XQk0XW9OGx9QtBG020DbIxSMnY2n7\n    DO7FrU0FzMcTbItql4KY57LQc57zwrs7+YKa5/hyGyHKjaH9ESvncPI3YjcvdKMSzm9iyNqI3gFX\n    AWurolwprKCgVIrhmx8h/eUEHh6LILwYo3/rCEFfr1e0SikofuuqMHp/hOkXI8A3Iuwmoty+MrjQ\n    NTJ9qVgM0BVOWzfT9wBabSTtnvmXJHWJBA5hKoG1Wgrgps9kqZk8fYzO85fP+hPzWCcyhekXY0w+\n    GIk2rzKciiWf++uxSlAe8DWdB+wigV3eGtlJhsG7A6ixb6baVQRRiO7Na4gvdpAx6lZHK+h5NGD7\n    FJs/y1nB7vmUH0vzMhG9NN9SpINuwspfN75+gN6rD5/1R+axRmS/TDG+fd9pP29zBQrE9s6zPXRf\n    9rm/HgsiyzD98huMP/4BXJXLG+e5i1oAU+3LndGocZ5aR2kM1Wds1s+Atn5O2XOeE0w1HiKK+QxN\n    z8NirCRidY2J16GkRTShjfq3SlRh3+d28ZPqX5tQhLsHSrFJlfiDC1XqaobS+dBmG51AFSQsF9Dw\n    GmtdOFVVbVaqdOvsmZepI7exbHaNbWr/3ISwXYW4bFHVcJ39cxssY//sIpV9K5xHQ4QltrkN1pkD\n    vM1YRVcD765Y5nyuP/bzbgO9CkuHVaiA6yarqv2LZCTYYJu4J44xLnVxlQ101blpEbOIDXQVccu7\n    +dzvRy/upo5jbSrguvwQk5gtLyBT6znL+1CxzfWzcMKVn5+TuGYnpCZsQ7GdxiZswZ/ObwroJkEe\n    GxrPtfUzPdfErplDQzc7/IusivhNEN3MZOyY6b0hxu98hGy0TPKHxz4jeaqPzkumDapJAptd/1Id\n    oBQwvP0As5+8HfmuIrrcw8FrVxHFVEgmIjg3rCRSlmcBAzrzN2BFbtsXaZpMK0xN8fKCNb2OeTYg\n    vNRF78Y1BNH2Nl96LI/ZjzMM3xpA1fBkXOdhJEf73F+PNSA8itAVecB1zVSygWH66QSTj0dA6pup\n    dhUxzaWJjkjgzUy5Rb1WCHMiOIKOXtBzpoY5I+pzcJtpZRC/nBTW5G/Yj9G9dc1bP+8w1DjD6O0H\n    mJ3kd9k29a9Jk5URX5vn/sY+99djMczu/ozBnz9BWBgja8KX1zwyVlPJoFtFeY1ECdI4EORwwAhi\n    3rhvi+3iznHc+pnbN0v1L7d8BsqKXD7Glv07Q1msUKX+lUIIm/q3iUCjKvpt3erfKZrUK+trqxJJ\n    y/fbRv0rz+0ihceWbU1faxlSuQpthFxVYxdR/3r75/VgmfzfJg6+Jy3Ot4z98w5hu4tQXgV8NnB1\n    payaVK67yLq6fOpUwE3RZmwbxa9rUuT0V1sbaBuh23QxYMuCqFr4uBYlLhvoqfhug+yus+1v8t5s\n    qFpELqsC5vuiikUuHy8XyxK0ADaJZjhVwHwRz5+T7Q9ZQ/NuTt5rn0JbAoUwlbucrM3Vv/mtgyZ+\n    s0IRLG9UpGU0z7lB8TW3gv70R4w//jeQevtAj8XQf/UQ8a9M29wmJR0qGqWnGQZ3HkAN2hq9e5wX\n    dJ6/hM5TRwWdxgvVvPSsdSI5WRwVxWudTGhaP+uviBWqudKJq36zOemsFcgBgiTKrZ8veRvCXUZ2\n    mmJ05xQ4NdnfUlMKyjnmNCb2ub8ea0LyRAfdl3UeMGBrpqrG8M4Qs2/r9Cse5xnxc5eRPH1cKG7T\n    gqSludB0viBHDZpTiRZW87kwms+vfD7ljVSS+NWxDNoimhqrEITovHwZyfWjs/6YPNYElSpMPhli\n    /Gle6bDZ0ufPzQZQPqPGhyG6PvfXYwmo4QDDNz+EGo2h1bymxTMRuWFRV9HbZqA8XmVYP8t6illr\n    MT2HuGgAyGttVEOiGlAiakARu4OB5Rz2OhQ958c2U/FWiSNidn5Yxkvxhqt2ZotWs5G+VerfGey1\n    ykXVv7btUizDhTQEVx3VBpf61/XchkXtn6VsY1n752xJ8u0soyU5toEkXiUnc97tnz1aY7sJ4G3G\n    qlXAu4q6i/U6LuarDIRfNsdgERWwbVK25WO4VMCu51WYNHzeVgWsKt5DnQp4Oj8Dnd+lArajuQq4\n    qrMwtRxXtdCVpK55XpM4llY8dLxUAduIXcoSVmLRz4le/vnxGw2u9qVMGknswuhMzYzt1OnK/69t\n    jIhONhXBATKM3v4M029/yOWYHh4tEXRC9P94hPCyqfhwkcC237LZ1xOMPhg47eQ8zjmiCN2bjyC8\n    0AGY8pcsJtN5WYRv1991uYUXpbnFs87/1cQut8YMWMGa6TkBBOj8+hid5y6e9SfksUaoqcLon0NM\n    v5kZ1x+79bO+cvFrmM/99Vg3ur/vI37GvNOwWanq5wIThcGbA6T3fDPVriKIQvRuPILgYhdamavn\n    S67+5epcoi/oyyR3NemrGDks/TbM5quAzbX5+PixA3R//9BZf0Qea8T0uwmGdx5UjpHXKSNCIQaS\n    3x+i84RvuPNYDGo2w+j9zzH7z8/C9UwrfanOId3QyLJZNtDr+o4ep703FKbgFtC6nkNq4HK8F4pt\n    pP7l5C5t43UmGu9S/0pimCCFEE2zf3kNLhSriZnjMd8WFzUv+37b67jQVAlsU//a4CJupf1zG8h6\n    p0uUM3ZsqyOMaZurPr2ohfSy9s9VWFWWbx9qpRzBoliH/fO+4qTF2GXVv3XOxqvM/10zPAHcFMvI\n    15tgld0Sq7g4LHNxWhU2cZFu8hrL2EATOpYJsM3ky89BcKmAXcdX2UA37T5zqYCbnKeNCliiytrF\n    ls1rO97V2edS6QIo52wAeAAAgABJREFUdU22UQHTorupCphnActcFr7QT8VYWsx3C0IW4DcElDWj\n    7aS1NTTPpKFjzSwbTeZyYpdbPgfzmxxVHMctolN9/GSG0Z8/RPrLPrS+eKwD0aUEvZtHCHrm2qWO\n    BOaapvF7p5h8PfZ9CDuK6HIPvT9cmVv+6YIy/ZaYRWqzqG3aTpa/+D5+Xq0aJlWwLpIHCBBf7aJ/\n    82EEoV9z7yqUAmZfjTH+a/WKsLJo7XN/PTaAIAlw8MYBoofNJoOmJqkKQHo3xfC9AdTE5wHvKqJL\n    XRy8fgVBwknafMZLGTmbwVQE8zzz5nOpnpd5lEJWqIbnauHDGP2bDyPs+gaZXUV2b4bRm/ehxvki\n    3aX+5QjE4/jXPXR87q/HglCZwuTr7zB+79+G01nGah8RUsP2Wc1rHjISi2cC5/WS1FAAk1001Wt4\n    nm++jebYfJvO/s23UT1IO7mZkWO2WhMAq/q3XEuThG4ZLlFETt7ax8laWhP1b1WGL8Gm/uWRcbYa\n    ZFP1L69vStdC2pegvrDQNgsYaGf/LGGri9raYmSNuUr9uw77514LctbbP+c4WPG/g1f/bg8urfdz\n    XL4YtQzb3QSrtIFu4iO+aayTCjkPXSKnqFYBL2oDPRDHL5MDTFiFDXTTsbZtTVTALixiA93k3HRO\n    2SVnW1y5YFMB23J8F1UBN1lQxmLR6yKcm2QBt1EBy0U3X6jLTkkzx9e0gpZZLToLWJPY+Q0It4LW\n    23h3qsyqkXZFdANDHa62Gxx+TMRuiGY/n2L87sfIxqtKyPbYN3R+3UfywgECsXxpWrzOUmB8+z7S\n    E58HvKvoPH8JyVNHUKwoTUokyiiUSiVtZelKAZaKJyJ8tW1lNv8eMdVT0InQff0hBMdeibLLyH6a\n    YXB7gEDwYY2L1j7312ODCI8jHLxxUOQBE9o4akw/HGPy2RjItu/e2mM1SJ67hOTpY3AFLpGzOhVY\n    W0PrvN6ystdU+er51gytyc+d3ztpBw6FAAgCdF6+jPi6J/Z2FWqSYfTXB5j9NEPTq0opZ/qRBL1b\n    FxAmPvfXYzGkP/8Poz9/iCylWCzd2J4xolcJIpeo4FlBCfOaiFlLobNRxq92adOEL2/6J4KYu711\n    5+0yRPya4gL5HeB1nqbqX57lK+tVQFP1b7Wl9CLqX14TrSJuZZ2Po07dW1XXrFf/quJ5UvM6rudt\n    7J/bKHfbCpDqQGSxq04+Qrsa+jaiiWNpE0J2XQK7Cwse5wnbvcT61Qh1cunzjG35o+F/9KvuBlkU\n    q+qi2QarhrOwgV4UdTbQVSrgKsI3gVaP8kWNDXJh5OqUA8qLNrkY4wuwOhUwocp2enEVsB7XVgVc\n    dX5XFrDMbHGpgPWin7pPuX20qQImZTDAu0p1RnBgKHdNYjd/nBo3QPo/3emKggROwe2h+U3S+OPv\n    Mf30KyD19oEe7REEwMHrh4ieLBNqVeUergKenaQYvfMAauzVSzuJOELv5sOIjpOioCyzCiPk11tS\n    6WZFKVubP9sygKkITlsyRg6HopAdAIievYDOM4vemnmcB2TDDMN3TpHda55wJa9Vkc/99dgw4ie7\n    eR6w+J1rSpsEChi+NcD0hybmix7nEmGI/o2HEF3qzDfobF5S/1IMAhG2ep6MjHlUzqchOIWsAxR0\n    1jA1b+Xn7jx+gN7vrpz1J+KxLmQK489HGH2gtWd16t/SteowQu/WMaJjP5F6LAY1GGB8519I7w2Z\n    kldbPnNHNbJ+psZ4wLSDBrj7mjIeUw0nZs3z0qXNZh2dsloQoG2eudVziDLBC5jqX5tjnX5tfX4C\n    /4tqk/0r98nXsQk+OOrUvy6CV6p/CS71r22/HGeDa1/i3F5do5Rjmzo92ojmpqRwlWhpGbVvG9LX\n    Ve+XIq069a8LdfbP50H9u05h33lU/560GLus/XMd1i2IXSWuQOXL6g37Tq8VJ2f9BhYA/dGdRxvo\n    JoRzXdfMOi66qyKOh/Pvi9hAuyZNmw30oirgNouDRVTA9u12tF0g1S24mqiA+Tg7Qaz32fbbFoU2\n    FXDVIte2je/rOBbVNhWwJIVjSILKbgXN95GFdAqdyVtlBR2KDlZtBa2zfUkPTMeS1bO0OuJ5wiZ5\n    nIE6aBUUhrc/xeS7H30esMdCCDohDv54jPBS+RZTFoSUsU8VYyafjjH9ZAiV+t/BXUR0uYf+q5cR\n    hFFRpAYrLqv5lZKKzKQM5uNkBjA90ilglGkYQpte6u/hw330Xn8ICL0SZVehZgqTD4aYflle5TQt\n    WocXQvR97q/HGaD7+z7ipzul7bYrlrI8V0OF4ZunyB74hr5dRXSpi+5rVxEkUdHYRDMiPdNplgGk\n    YXQovswsYRRnAmuw4nOxQojwIEHv1kMIOv4auauY/jjF+Pb94kIToHptXppHY6D32wN0n/RuKx6L\n    Qc1mGH3wOcb//pnVMHTdhJ5zUljXSVDUQ0JRAyE3tPxKaRK+dHZeswGrxVADP7d+pnYa+o/Hgc1/\n    kuK7Tf0LaEJX5gZLLK/+rQbP8eXbquqTLvWvfE1ODrtqh7Zjq9S/CvY4u8TyWEFV2j3XCW846gQ+\n    Eh0o65hlr46u111GLNXEibOJAndRrOvckotZlfr3PrZH8FeHZSJUt8m5d8cEratRAG+TDfSmsS0q\n    YBfOgw00sJgNdNtzuyaYAeonn2VVwED7LqomGQ1AeQHRdpFQdS753JZzkVgWSVOYC7SqhVzVosu1\n    zXYsf1xF9koVMI2tUgHL87RVAbv+DfiiW9s4E8odj9IGmvZz8pgv8HWHqt6uLN/5TQglcIUGmVu2\n    glbMCpoygPMbnrREEHN7I4UMajLF8M1/YXbvvFyhPLYN0ZUEvdePgG5YtoCrOZb+egZ3HmD2bVMj\n    fY/zhs4Ll5A8dcBsmzWRm4MUTFqdxAvZ/AtF6cYkfTnxq0vjIYJujN6Nq4iPfJ7rrkIpYPr1BKP3\n    hs1Vk+J5mAB9n/vrcUYIkgD9Nw4RPlQm1pr8TgcA0h9mGP1tCDXd7vthj8WRPHsRnacPjZgEO4Gr\n    50kgcM6lmjTO51/dpKX/X2wLQ/R+exHRNW/9vKvIHqQY3r6PdGhrfC/DtuaPf91D93f+d8RjQagM\n    k6+/w4jl/vLM3wAZZqIWEhSN7boRnls/84itjNVBIsM5zUbe6poN1Wb49sSwiYbT+pmDBAV8rKuW\n    VRYqaDRR/8ptLsK4LvvXFG80V/+22Va3v424Rds/21Gn/p02GNtU4GNDB2XRENUn+fZRxT6JOoEU\n    YdhwXB3qBF62ev4uqH+rsKz98zrjSNeFk7N+AwznTP2LHzdhAQ3sHGu+Fiz7x7cuG2jZrXIWdE1T\n    W4hNoIrsrZoExw32SZJwjGbK4GVUwFXkKlAmemksLW5cBLENvGPO1j1ng1QBR+w92GAnc5dXAXM7\n    Z46mKmD9TsyFbOR4HVqc68wXGF2c9J3GKss2unngNxH6eG4FndMelEPDM2sii+1RUHSxasUwtzbi\n    1s/85invmqW8mgzpTw8wec/nAXssjs6zfXRe6Fsr1VqBIrfra0A2Vhjdvg91z1tY7iTiCL2bDyE+\n    jsGVRbw4rVfBASN0w9JXxghfTvWa5yMTywDdF46RPHV81p+AxxqRncwwvH0KNbOrIzls16MgADo+\n    99fjjBFdjHBw6wDhQXnGlL+3rt/z8T9HmHw59qYuO4owCtCbW0EHbE7UJG7A6FsdqwDHlxINVCG0\n    A4e2lc7n1OTxPjre+nl3Mcsw/scpZt9OWTud+0JiW9eHD/vcX4/lkN79GaM/fwSVpoU6V1sw5xWZ\n    QNREMtYgn8wDtSS5a9o725rwdY6v3Ef1nbxGA0HschLXFAroGhCKsfx7U/UvkNccV6H+bZP9W7Vf\n    KoVtj81apLLWJnkdsqoCsKj6ty5mr0nredPqmO1ctji8s1D/VsXyAdW1fNp31urfVeX/LoP74vu2\n    YdsFkduMM3BiXh0BvE3s98lZv4ElsK9/QKdYvQp40PJ41yREXUt1k5gNLjVu044p22S9yPvgcHWJ\n    0WLlrFTAsWPRZDt+6jh2XSpgmaOyiAo4Zufj5+F5vlwFbC7izcU95f3S+AycpNbfeUcov6HQZK6+\n    2bBZQWv7Z9OSiB6nczJ3Bm2NxDNwIqSlDlquDB59+D0mPg/YY0EEIdB/7RDxYx33GOs2dgP50wyj\n    v51CTX0e8C4ivtpD55XLCEIqTHMzygBc+SsVS1Su5upeKmxrlZNWBFMRPHykh96rVxH4WuTOIhtl\n    GL0zQHay+HXD5/56bAuSp7rovNQ3pT5tkOV5wNlPvplqVxFe6qL7+hWESTifH4MiyxdsLuVzJY9O\n    oFmyrArWDVaYz83USBUdxd76eYehFDD+YozR3/OKTVV1w9XUiYMIBzePfO6vx8LIBgMMbn+EbJ77\n    y9W9gaiNcEvo0DGO1z7oOF5j4Q33RChL8pcgG/rVvK5DNadU1Ho4SczjxCgrWI6VtSyp/uVYRP3r\n    qpVVZf/KaDcb0RtVXC1iqNr9rm11whhCnfo3hnLWSevO19b+uW48YRG5xaISjVXk/64CqyaPm6qF\n    12X/vGqcR/Wvx9LYjAJ4V7CMj/lZYF3dIvJ8rq6Xs7ZUsE0oVTbQy6DJRLfOibetDbRUATeFuZix\n    v3aT89WpgG020IRFVMB1C8ZNqIDL9s12wlgvylGogLl1jzmGK4bN962Vw/qGImCv4bKCloRwMr/V\n    ANumu2LVnOjVhDK/GdL5OLQtf6zfT4bh7c8w/eEnnwfssRDCXoTeH48RXNB5wKqxIWuO0ftDTL8Y\n    AZn/HdxFdF68hPhXByXlLlih2cz6NYlenUVItpf0X8jGI3/ci9G7eRXBQbzYm/XYfqQK0w+HGH86\n    qb3SuIrWlPsLn/vrsSXovtpH8rS9mcpJvjCo+xlGb58iG/pmql1F8psLSH59VMx+gJ5LaR6lOwNu\n    9cy/TII4ZHNpaM6lYYDu7y4ifsQ7JOwq0rtTjN66D2ZRZVX/Oq89UYDey33ET/XO+kfxOK+YTjH+\n    52eYff3z3OGMWt0zoxlesdoGmT6bDmdk7ZwVjfLB3F2NrorcMY1bOmu3N970b6p/Q5TtkM2aVlkw\n    wMcSkcxXnBEjj22iiFWof6uyheXPwAUdNgGJTf0rBR1S/SvP0caFkJ/LdVwTktclrHG9j7bOjk22\n    VTlKVtk/V6FOzET7XfbPbZ08F7F/rjquD3XmXMUi4LzLovbP5xknLccvGyVb5WS8TQLYOsztnwFP\n    AK8Gq1LtbmsXxiq6Vpp04FRdhAeOc2zKBpomr6aTXRVsk+q4Yp9tm1rxYqFKfZtAGYsX14KpiQq4\n    ihx2qYBdXYJtVMCuc2xaBUz/ljYVMOZn4KAFe2bZJxf7NmsgfnMRG1m8tC8zFMVKdKGa9s7a+oiT\n    uvlNT1rcHEn1sILZTWvmAmfAZIrBnz9E9uABPDwWQfxIB73XD4Eu6TXr54Wg+JvN/ze6/QCzn9q0\n    w3icFwRxiP6tqwiOE4PQ5em9RXYvK0SjVKgmTbBpFk3lnSAIkLx4AcmTPoduZ6GA2bcTDN8ZFg4a\n    Lt2Sq2gd+Nxfjy1ESHnAV91NCfbfad1gOPn3BJMPhlCz81MU8WiOMArQvXEV4aWOIHN1CyhKhK4M\n    TijPpQBvzMq/4icO0H350ln/yB5rghqmGL99H9n9rJhBm5K/9FvSebqL3qt+veWxIFSG8VffYfze\n    VwBM2+egmNd03YKa4BVrfM9QbqDPjDpHXmuZITfO1w5uuoZjU//S49ymWRl1KJv6l9dy8n05SP1L\n    5C+vFUlCl7bnNTUTm1L/Elal/q27q5e1R/7e4obnkerfKZpl8trQVv1rs3+21Y0XsX/m9eImhPAq\n    sQn751VBCuHWLbxbBY6gtpZ38lg7NAG8Cv/pKhb8fy3OY0Nb9v7Esf14yy8ky/wxrisHuAk2/XqL\n    gCaRqg6hdRDKfNK0dVnVwTZpN5mIqxYNCVTl4qQqmyJhXXB0jiZZFkB5YdVWBdzElgVotnCU51q1\n    Cti1L0+jdKuAKc+FVMBh8X4z4/VN4tYkg/l23uFp3mCoEmlMub7c6kixGyH+ReeJ5jc2ZBWtO2Bz\n    YphbG3Eb6HCuLI6QIvvxHkbvfYxs3PQ3ycPDROe5A3Sf70HNfXd1MbIZ0tMMgzsPoAbejnwXEV3t\n    off7i0Co1UlUwFYoW1XyQrQS+Ybc7lLnIAaIHu2h9+plb/28w1C/zDB4cwA1ZQ0kxSPd7uYkf33u\n    r8cWg/KA0W9yETObH+jR6L0hpl9PvKnLjiK6kKB34zJUErE5VBK6gTGPmgQwSnOtzgyez8vHCbpv\n    XEWQeIeEXYSaKYz+NcTky3b3fLSmVwDCh2L03zhGEHsxi8diSO/+jOH/+whKpQWRS9FW3MmM6hX6\n    OSeCtUtaBlLZanI4graM5tbPAaOOyRaaO8WFUIK8VY5Gf3ObCVW8OiETx0j1L68xbVL9a9sPrFb9\n    y8fUZf9OHc957dIFm6IXS5wPcAt65Llt1t0dKKejZFO1sATVsKscMLtQTvUvoY0DZ9VYW/2+D1V5\n    TFv176Jq4VXZP/v83+3CeVL/AiD1L+AVwLuPTdlAu9D2YlnV6bOICniVuQJD5JOZa7Kj7U2JXQmX\n    CniMZpOxwuIq4Dpy1UUWu/Qr/HyuRZQLdSpgzBfCctG0qAoYlrGrUAHbOixT2Dou9fn5d26iRype\n    ubDL2D7Z2Sltf/Tx2gpaW0frfF9JLOtMX03+8lwbnXmTFc8jpvYNRRawzNIhi+rRB99h+sXXPg/Y\n    YyGEEdB//Qjx9YQRdtV20IYKGED69QTjDwZevbSj6Lx4AcnjfXBlL7d5zgxC1/zKwJW/Zn5hgABR\n    P0L/5hWEPV+w3lWocYbhXwZI71bnnFbpgn3ur8e2I3m6i96LPWuJoFrzPif0Zgqj26fITnwe8K4i\n    +fUxes8cAIy4BZsbA9YkpSzzamb5KojjMEDvlYuIH/K2vrsIpYDp12OM380rRFXqX+O4+W8VAAT9\n    EP1bRwgv+qgNj8WQnea5v+p0NL+KKZjxVVr5OwN3SNPxVtmcROTRV/wcPLfXRhTzeo12euOksCZ/\n    uUo4YoSxWa/JQcQtxYdxVbBpNW2qf2n/OtW/HFKksWz2r4SsN1bVOavUv8pxHHdIpDqpVP+67J9d\n    4I6Oi6hum6p/beNc9etF3seitXDgfKl/JdZN0q5KcLft6l+XYPNkw+9jWQHrtuCK+XmungBepwp4\n    m7HK7odt7KTYVHj5qr341xEsv8ikVmfhUQfb5K0anGOR16UFU9WihZOvXAXsIoqVY1FlI3EhXsf2\n    3prAtYCMoAxS2GUJLd/7qrKA89fl25VBJNNin3dOcsWwVAFL658UZqcoV/7acmbybVlxfn2bo8ne\n    dF6ysVk6c2I3nN8Skb0z73LV3a7mDZJi5xr8+VOfB+yxMIJ+hIM3jhEdh2j6GySLTuP3TjH5eux/\n    BXcQQRKhf/MygoMEgJnnq1C2fS5bVwZFEduwgQ4CdF86Rvz4wVn/iB7rQqow+WSM8YfjymHUFkDg\n    lxHK/Q187q/HlqP3Wh/xUx228jSJGhdZUzRTnaQYvjuAGvs84F1EEAXo3ryC6Eqn0PQqNj8qMb/a\n    5lIzA1g7cSS/6qP74j4m2+0Hsl+mGN++36rR0mjkDAN0XjpA8pR30fBYDNl0ivE/P8Xs65+LWgfm\n    7mQ8rorqFSGra+h9+orHraC5ixrlCdO2kB0nrZ/pPAHbpusqJsmr61Iw6jocvOZDK045G0v1L6Bd\n    6tal/rXnF2vwelhb9S/ZP9sUxDRGbrORwlXCFVcdMnGcr8ptUdZAXWNthHBTcVBb2HKBXagSRNWp\n    f3tQK1P/2lBHHq+Kb6gjZNfJn/hVUj2Wzf/dUey2AvjEsX3bbaCXwSZtoGWXy6ZsoNt2BA0sxy5q\n    A91UBVyFRWygbWiaFyxfkyMRC6OmKmDzsR1VZK1tn21BVpcFXKUC5lgkC9imcVhVFrCLnuKEcQQF\n    qQKmc5sktCR39etTKUZBIWF5vxlQ3GRwe2jaFoHnBeddpDLjJrAQwSl0VyzvlE3FOCVusoqv8cTn\n    AXsshfjRDnp/OETAWpirVcA0JkeW5nnA2YnPA95FxNd66P3uGAhChPOicwRtTCmL1GaxWivLIzY6\n    fKyHziuXzvpH81gjpt9PMXw7X002McflGnEFn/vrcb4QJCEO3jhAeCVfxfLf56aYfjLG9OMRkO7u\n    Pfc+I7qQoPvaJaATGfMjt3U2f3PM5ipyaonm40MEiC4k6N+64m19dxRqnGHy3gPMTky/qqrrioK2\n    DVcIkDzVRf8PPvfXYzGoLMPs3//B+C9fI6+BpAXJSzUQqmPIJnfughYxW2juhsZd0Yg45jbQuk2e\n    6jNm24ytpgNo8jaa173Mxn8NTdya9aem6l+JTWT/rlr9a7NVrop9a6r+5dttNVH5mi4hTVV1oY36\n    V9Z2m9o/tyF52yiFm+5fNapq+i605RJWLVBrCu7kuiqeZVOixV/W+LlsAlXC1XXaP19aw7l/NJ+u\n    Z4F93jyxtw2rluWvyo5g0S6WTXjsryO7dxk0mfxsk2pbG+ix5XmTCR014xZVAcvHnMitUgFz1KmA\n    aVvdQpATs3Uq4KrXB+zdjsuqgAEY5KtUAadASQVs6/IETCvocP7vQu+R30SEhamR2WlKNyG8E5Ws\n    mbUFEuaZvvoGR4kxZKHEt/GbJ0766o7Y/F0Wtks/3sPob58im/g8YI/F0HnhAJ3fmPaBTTKBCxL4\n    ZIbxOw+8emlH0fvtBcSPdZEhJ4GzeX5hAJvFs/5imt/C9jI8iNG/dRlh16s6dxXZvRTDN0+hRtqk\n    rxV87q/HOUR0OcbhzQOEjfKATdARgztDTL/3zVS7iu6vD5H85hDaQSP/HgrSFxYyOGRzaYgAWRSh\n    +8oFRFe7S70njy1FqjD9ZIjRR3n1wXQUsMMkf4H4aoT+H48QJL5BwGMxzH78GcP/9zEypZvSOeGr\n    CjJY1y20e5lZx4iYapg/pvpGKuolPBM4h2n9TNt4BBe3ktZW0DIaTJO8cgwhg0mgSvUvWT9vc/Yv\n    39dW/Wvb1kT9W7VP2z9ruOqhtvfRRP1LaEIIN7V/tqEtabtM9m+V+tdl/9xGAbxK6+jzaEN93rHL\n    Qs2zwJXy57n5BdQyNtDbLuPeRutm3i1y1uHhTS+idTnAbc61CJpMMk3slyVck3fTSbdphkPdGHqe\n    iO9AvcVynQpYUnZNF1JVtixSBUzPV60Cto1dtQqYFtU8Z8XWvcnfRxMVMLcGkmNkfjC3GqL9nFzW\n    JLPZiRrPyWOeARwyMpdunijhKxCdr8GcUgYbSzdWNJ6OmfzjW0w//w9U5gk4j/YIogC9W8eIrzVT\n    29nUB+NPx5h+MoTy6qXdQydC78ZlhP2wKFDT1asgdsUXzy0scg/DEN3fHiF51GcV7irUJMP4rwOk\n    Py6WZ6oQoPNY7HN/Pc4lkme66L7YA8J2JHCxgp5kGL55iuxe2up4j/OBIArQv3ER4ZXEmBvpTiC0\n    zKV8PuXzb+epPjovHJ/1j+SxJky/n2B4p+zu1OTKogCE/QD9m0eILnkXDY/FkJ2eYvjmh8gGY6NZ\n    HaJZnVzOqLbBid0ZuNMZRVxp5zMebQXjPLr+Qo30KdzWzwmyolbERQGk/tUm1Tbwug4MQYFL/WtL\n    0z4L9a8kcTlp3GQV7lL/No2bW0b9y8e4JAxVddHMVouwjLOJgmzj2qp/myiD62rWTZww26KqLr+I\n    AGxd9s+SZ/H2z6vFyVm/gTl2QOi6vx10i3YXnAc5+1leFDZlA21D1SRgs4Fe9FzDmmPb2EAvqwJ2\n    Te6uBUOTbTbilWNRFTCwuixg1zaJKhUwYJLCLkvoWCxil1EB26AX3fUqYIjn/D3wmwHZGUo3GNwC\n    SN+kcCtocxzPswmMVzBzgiNG4Goi11QCy7xf/di8mcLcTHr85sfIfvR5wB6LITqK0H/jCNGhuc6x\n    aQ0CY7/G4M4DTL/1SvRdRPJYD90XjxAEeQE61wADPOdXFe0sOh+YvocA4id66P5uH2/D9gSZwvSz\n    MSYf5CWPNhQY2VVGF0L0/nToc389zicCngfcjgSm0emPM4z+MoCa+Ia+XUR0lKD/+kVEHRmXEIgW\n    U3M+5XNudByje/OSt37eUah7M4xu30c2pvvpHO4scVMXHIRA96UDJE97Fw2PxZBNpxj//VNk352A\n    IqqAbO5ClruR8bgqalyn5+Rwxmso0hYaRT0lm0dtma5rsbCS5iQtEcK8YZ8Uwlw8QNtDlElem/qX\n    nODs6l+TFLYJFYCzU//a4FL/tjkH31+X7zt17KtT/8Ix3vZa8rhOzXMb1qH+XSRjeIT6OvlZo60g\n    7azsnwmrtH8GVuc0uw7h47aof5cRrC6DDdg/A+skgKvY8bP6UM8TzosNdNPztr14Zhu4ANR1DdWR\n    wHUqYNuEushkynEWKuAq+qONCrhqYcVRZ8/CyWLeWdhEBczPYSOGOar2rzoLmFtB0/n5+8jYNmkD\n    BLadK3lp0W+eT9+4cMKXlL1c/atgZv/ym5mIkbuq6JzV6l5tDZ0ZxG6IlCmF8320DeLGKB1NMPzz\n    h8genPXSy+O8Inm8i87vDhCK1mZeWKoqRKmxwujNB1D3FlP/eWw3uq9cQPRoD5gXqk0iWCNkX6RY\n    Co9i9G9dBDqe2NtVzH6cYvjWAJnSFpRNoQCEPvfXYwdQ5AFfjlqRwAqaBJ7+a4TJZ2Mg247ijsdq\n    Ef/6EJ3fHIDUvLZ5lBBAE78KIRCF6PzhApIr/jq5i1CTDKO/nWL23/I6uunVpPNUF70/HLbrwvLw\n    mKPI/f3bN1CsCd2u9jVJYLD6B1iTewit8AUjfCU5HLJz6lqOSSbzRnyq8XD1L9V8SP0LmOpfIm2l\n    yhfQMWB29W8Om/oX7NxNt606+5fX0OruwiOo2pqhjTyWY+Vry+0ukle+tm3c1DEWaC7Scal/mwiE\n    qs7bJhe4zv65ClX2zwRO0LaxfubHtj2uLc5S8HYesA2CyXU4B++A+hfYBwXwScW+daiAt90G+qxf\n    bxXWzYte1NuogJedONqqgEeOfbZjmnSGrUoFbEMCVVIBu8bZxrgWVRKuDr+m75OfRy5G+fk3rQK2\n    7YvZPpcKWFpBpyhbQfPOUWkFTaRvxsZmxQitHOY3LlpNbN7IkCW0zPMlcjdj5zBvosznAbK5BVIK\n    fiNFN2ez7+9h8o9PkU19hpzHYuj+9hCdX5dbZ0oKA2OfxuzuDKO/nUJNvXpp1xD2IvRvXgB6MagY\n    ze0ruWKJtgUIEIYBer8/QvSwzyrcVagHKca3T5ENF8v9VUGArs/99dgRRJdjHNw8QNCrSuwsg/5u\n    MgUM3xpg9qNfy+0iwhDovX4R8dVOofzl82ggFMG0DwiQPNVD74XDs/4RPNaBTGH8+Qij93WVwzaX\n    KuOxeX2JLkfo+dxfj0WhVJH7q5SZ7UtOZTyyimf+0hdZP3MnM8XqJdxtTZ+LqjRZaZypHs6T0KlG\n    o6AFAVxNS/UYfXyZ0OVEMD0nApl9IFur/nWRuIQm6l9XvVCeRz5uKlIBuPpXH8trnhPHeNt5pRCn\n    qfp3XDNmUcFQFZrYPy+j/l3Ezrkt2kpKmo5fR8wmnVPyKt53bL3YJaFqav+bWu9iakdY8jPBskTy\n    Nl4cVn3RbUomr6sLqIlKeVkVcNNJnRObTbq3+LmrLEtokVKnApY20G1MU3lHXFV3HAffbzse2G4V\n    sG2RzW2AzO9mZyeN5cSvVBjzmwxuH0TlGJ5FozN4zU5VfpPCu2GjuWJX7zOtnTPITN+MnSNX+vJu\n    W1fHbTDfO/rbfzD7t88D9lgMYRKgc+sCOg/rHmdZvq67Io/eH2H8uVcv7SLix3vovHCAICBio/xF\n    uYXBvGkgerKHzstHZ/3WPdYENVUY/X2Iybf5zN9WdES5vz2f++uxQ0h+3UX3hS6CMP8db/p3QePU\n    MMubKh74POBdRHgco/f6MYJOToPQvMlzgfm8mlvkx+jevAhEntzbRcx+nGJ8+0GR5MNX0NJ1RzZl\n    AkDY87m/Hsshe5Dn/qaDCcDIXZnRG7HaBNG2Eat78BqHzfpZN8Truk+A3GktZiQwKYd5LYbn+gJm\n    7i818NvrRVpUQGPi+Vm49bOtXkXH7YL6V74O3+ZS/1YdL4Uqtqi7/Hn52Anaq39t45uqf5fFCHb1\n    76L2z8uijfp3EcK4rf3zolhV/u+qieVVOaxW8VSLqn+3xf55k7h7Ni9rLrg3+Sa2hV3f5l+2VdpA\n    H0CtpTsFaH9xWufFt24ykCrgZbuN6myg68An21VMnBxSBVxn7yFtoKu64lykceIYR+ezLYDqVMCx\n    OAd/j3XH8/NskwrYBqkCJvCbAG4FHSMzrKBlTjB9EdFLY+J5730mzs8Vv7ZO1ZSdixPDYXE+0z6a\n    5wyH86ND4wYqfxwVFtJE/mbFbRGRwMP/9zFmP/5c++/s4WFDfByhd+sIwUG+5pFqA4WyAbQxRgHj\n    tx5g9pNXL+0i+n84QvRIIigNs1BdWD8fx+i9cdFnFe4qMoXpl2OM/6H72NtZPwcIfe6vxw4iCID+\n    6wdInsxX+tziuQp83OTbGUb/GEJNt/fe22NxxM8cIPlNv2iWsjdV5QjjAN3Xjr31844iO00xvPMA\n    6bD8t17lI0DbgxDovHCA5NfeRcNjMWSTCcb/+Azpd78ArCmdFLyc1NXkb4YIaUH+8sZ0ne9bbloP\n    Gckrs361j4xZk+FeCTwrmAhiqi9pNzZu/WzWoDgJC3DFsCkwmLFjO2z/eVD/crjqlG2yf9eh/nWN\n    r0JT4Y4NCqqR/XMbi2cbqEZd5XBZRy42sX+2oekxdfbPqxKiSUXuuvgVG7ZR4LdLqOIn1y1sXUf+\n    rwPrL2Ct+sNah5/3ItiEDfR5VgGv23Z63d7+9Bp1BHHVZEeTZBNi19ZpNXbsc3WALUNGN+kIqrI0\n    sXXIVS16XAurRVTA8pjzrALW/67mIp0v4jkJTO/BXPjr18zEMfr1stIYrhim1+KdqvGc7KVs4JTd\n    hPCbIH7TxK2hyUKJWyzpPGCtIubEL+UIp4MJhm9+iOzU5wF7LIb4Vz30f9t3KvJs5ai8cD1vnjjN\n    MLhzCjXw6qVdQ9iL0L9xAWEvLFRLPPe3KFvHAfp/OEJ81ResdxWzuzOM3jqFmk+EbdS/CoHP/fXY\n    aQSdEP0/HiK8FFkbp5pg8vchpl+OC1Wgx+4gCIH+68eIriYOPw0Uc2z8dA+d5w/O+i17rAFqqjB6\n    f4DpN/kdeSAqFIUrQPEVFNtpXPJkF/3XDxH43F+PBaCyDNPPzdxfrtqlOkM6r0tkrCZhNsCbjmaS\n    OOaW0LyZnV6TN81zq+i89pIVNSAiern1MzXnm45tZgszjYgK4tm0frbFj8m72GVEDKtS/xr/dg6i\n    2VWncxHBi6h/5eM26l/bOP6+ZI1SjpUkLa/1cuK2jsRtGk7E1b+299EGywqi2mKb1b+rxL5kDdcJ\n    Mk/O+g2uAWek/gXOOgPYq4A3i3VeRJp2vxB90/TiWkdM2s5jmxTWSRgvMukta+HRdHKvUwF3KhYu\n    bVTA5mP7uCoVcNVnWKUChuVcVeexqYAJZ6kC5tsi2BfqMtsF0At8nhkDoCBxlfF+lTiHJoZ11rBp\n    BS2tpBXbx8fQcbyrlqygo4JELnfd6nFp8SqKjeE3VOl3v2D8d58H7LE4uq8covt0+9xWKnPPvp5g\n    /MEAarYfa4Z9QvxkbgWtAjP/l3/FT/XQ/T9fsN5VqEGK0dsDpPfzGZQXo6uQjwsQBED3+S46PvfX\n    Y4cRXYnRv9EuD5irgFUGjN46RXq3ibGjx3lDbgV9BCT53QbEl0KI8GKC/s1jBJFn93YNSgHTr8YY\n    /yWvvLjaRHSIUGBsA4DoUoT+n44QdLzTiscCUArpj3cxfvNjKGQIkc6bEHISl8dYRTCVwXldIsOs\n    qEbIWohpAc1VvlQPsdVKwmIswJW82pFN323Ieo95DrsFNH9O1s98rCZTy+pf2r+I+ldGlHG0Uf9C\n    vA5HVfYvf7yI+leiqsK0bPavDW0seW2CINsYF0FcRRw3UQZXqX+7NT9HE/Wvrabftn6/boHYJgnZ\n    fbJ/3gacpfp3HfjJvSvciNz4PH5oTXAef8lXcTFZ1td+VRq+VVzk64joJirgZSZEwCRjRxX75PYq\n    1fAiFh9NjjmPKuD686xGBcwXrW1VwPSc7ycVsH2/faFOsN000A0JdZV2kBpEMLeCVuw90A1PWHzP\n    5jdUZgdsaO2AVcjmJDB10vIuW2m/lMK0VaLuWbKFHv/tG58H7LEwgjhE741jxA+584Al5JVj9N4A\n    06+9emnnEAD9PxwiejgBt32mr/BijP6tIyD2BetdhJopjN8fYfpvvWppTv7m8Lm/HvuCzrPzPODA\n    7p5hA/97Su9nGLw9QDb0a7ldRPJMH53n+rBaQMchuq8d+lzXHUX68xSj2/cLFw2gPJdy1a9E2AvQ\n    u3GE6LL//fBYDNmDUwz//CFmoym4ateW3Ut1CzkmmltBh+wY7nJGGcG89sGzfnnjPG+o543zea1K\n    11zoeG79XI750vWZFFr9K8UB/BgpKojEc4mqbTPHuFVl/3JSeBPZvzb7aClYkVin+tf13AbbmG7D\n    cW1Q52SpoDBsdKbmaFvjr6vnNyU/6TxNuYp12j9Lsnnb7Z+3Kft3WxyDzxKX3Z9BubNu03LkTaiA\n    TxqMWfUv36psoJft1pAXi0361K8Kq7JiGIjvq0Qd0bvqfN/8NTVocl9kwUDPE/EdqO6Ek2OrVMD8\n    fC6rlarXcqmAm+R+yIXlurKAgeVtdAikApaLd1unZ8jeD1cBg90A0HvMivPrsTnxa3aoZuI8OstX\n    E8/ypkZ2xXJymN/0ZMVYTf5qQlix18s7cqlzN0AGpTIM/t8nPg/YY2GEF+O8uNQv5wFXgVQMWQqM\n    bj9AduKV6DuHXoT+jSOE3cAsWccBeq8d+IL1rkIB068nGP1FlzCa0vw024UXQnR97q/HnqDIA36C\n    8oCDRn8zfEz65RiTD4beUWMHEYRA78YhkofK18PuM110nvMuCbsINUwxvvMAs3vkomH393KRv0GQ\n    5/52nvW/Hx4LIp1h+NdPMfv+nlGH4A3m1HCe1xcy55duaC/vg6iBSItps3Fe11gCUUvh1s8kSOB1\n    Fqn+BezEq96uatW/tv1V6l+bOperlJuqf11Eb5UddFX2L9+/qPq3SR0ygbKqfzkWUf+OW2xzZfg2\n    UQW7ttvOuQhZ3ETsVFd7b2PpvIj983nDqvmaVfFS+4h1CFkl37rB/F+ACOANv+hO4bypgA+g1kYC\n    y/PW2SSsithtagPtQt3YuklriMUIXle2g8QiVh58v8sOpOk2SbYuogJOLAs4/p2/jjzPOrOAI8vC\n    cVEVMB9D42y5vHxclQo4mh9RpQK2vT9OHPPXkCpgAPMbFv4zSBUwtyyiGxXTOilmXbRk+ZzNb3Ki\n    uYKXZ/1GSA1baJ35m+/jCuIAyrgBAzJkgzFGb36I7HQTSeAeu4jO0z10XjLzgKuK1/LKMTtJMXr7\n    AdTYq5d2Dcmvuoif74MrlnzBereR/TzD8PYpVJr/pTe1fgZ87q/H/iLohOj/6QDxJd1M1cRRg48Z\n    vzfE9NuJd9TYQYSHEXqvHyFMQtBcGl2M0b956K2fdxBqpjD61xDjL/OqwCIJ4ckTHZ/767EwVKYw\n    /c8PmPzzP6yJXFnJW6pVSOexjH2RbTS3gea20AqmW1kqSF/+H3uX4HbP0vqZkLHxNiKW1L8Ab8rX\n    sAkIFlX/Elz1r6bqX76vjfrXVZfjP7Ot/tdG/cu3NVX/2hS/rvPb1L/0fRH1r621pk2eb9O6NY1z\n    kbxNyN8mNfltsH/eJvWvPPey6t97K3pfqyaStyWGdROC1C2CPVtjHSrgKvZ8Wz70bfkllFj1H9s2\n    qIDb2EBXjV10cuDHNSGim9hA102OTSbbqkm/bmLviAVYm9epywKuwrIqYLnPhWVUwPI8toWnJGfb\n    qoDLNj2oXHi2VQbbVMD0umHp376sApbbODnNs2nAzkk38PxGhds8U0cp3fRw0jgs3XCZHbU865f2\n    Z4A1JziVr/vdL5j88zPA5wF7LIIA6L16iM6vunKzE3nhmjXtfDbB9JNhQRp57AgCoP/aAaKrCRRC\n    hJdj9G4e+YL1jiIbZRi8O0B2UjbYq4PP/fXYd0RXE/ReP0DQCYoVY5srZTZTGLw5gDrxecC7iPiZ\n    HuLnelAIc+vnG4cILsbLn9hjq6AUMP12gvG7ZsWmbi7l14r4UoTen4597q/HwshOTjD6/z6EVuzm\n    Kl+KkdKVB7MeQa5k3JGM6hicEIaocWRA4aBGDe9mo31mWEgr6/ccATKr+tfm/MZFByb5q6xq3lmx\n    b/XqX5tqdxH1rw3rzv7lj121U1uN06b+TWp+DolVqH8lumiPZdW/I2Bp+2dZYx+0GAusTlC2Tdhk\n    1vAqcN4EkWeJTbstW+AXWavAun/pl+3akF0jm1QB12GdF+1N20msSgW8DrvopirgxDFuWRWwfMzP\n    5Vp0nYUKuKojkY+1laoisZiW2xdVAdPi3Taek8K0EJfZLzzfl+f8pvN/E32jo284+A0LJ34VGyuP\n    0Xk6+U0X3RTJbllS9dqygMuduCaJTK+jkGH0l68x++o7GEFTHh4NEXRC9P94hPiSaVFYV7zmJPDw\n    zgPMvm1i9ORxnhAeROjfPEB4FKL/+gHCi97WdxehZgqTD0eYfaZXPc2tn/ORic/99dhzdJ7tofN/\n    Og+4jgSW+9XPMwzfHUCN/Fpu1xAEQP/GAZKrMZJnuug+3zvrt+SxBmS/zDB88wGy+c1xE/UvvwaE\n    3QDd148QX/UuGh6LIRuOMLrzMdJfhpamc9OamTeay+gq7kxGSt5o7m5ms37mNRE6hijnHGYWMCdb\n    s+KxFBDYrJ/ttSSCjYiVwgFZRyKENecGqt3v+DFc4dtG/asqjrPBZt28rPrXtU/bP+tzV9U3J9iM\n    +leKgFz20HXEsQtN1L91CuAeVK1Ya93q3yZxmk34iKak7OGSnMI2CPU2gW0RXlYJUddh/yyxDifm\n    n6p3awJYvvguZgFvGtvkt35WweGb6GAZoB2RbJsk6o4foJokHqLaBqONCtgGbucsUaUCbjPpN1UB\n    2xZNdSpgSZG4Fl5VtivA+lXAtixgWPbzfXyh3HTRPGNHAHzxDWsnJllB2xTCnPTl55TnlqQtoC2G\n    eKcnJ3y14tc8L5HINiul/IbGzMKhx/nNlCaRdTcuvbe0OIbbMeXHkw005QGnOP1/HyO96/OAPRZD\n    eClB7+YRwp5ZrnYVr+VfdzoGhm8+gLrn1Uu7huSZLnqv9tF5zhesdxIKmP5nguE7w9arVCJ/owsh\n    um/43F+PPUcIHNzoG3nATUhgjuknY0w+HgHeUWPnEB5G6N3s4+DmwVm/FY81QI0zjN99gPRncx1c\n    9ZccsDFBACQv9H3ur8fiSGeYfPQlJl/8BMVcw1JWh5Ckr3QaUzAtom220UQm84Z33QhvNsjH89cD\n    tItaWNQ+UDTP01he75FN/lSrSYsRylD/RuIYl/rX+tGJ7ybc6l++vc6umdfu2mT/NlH/1rkeutS/\n    5k9pH9NU/Vv1fFXq3zq0Vf8uQjxLrEKwtKz696ywTpI2FT/nshxOEwJ8GaxbCHmy5vPvITarAF4V\n    i35hiy4AhHX/8m+bDXRVd8s6VMDrUArLSWYVE0sT+2WJRSZdjqaTvuwOc3WG1amAXWibBdzEeqWN\n    CrguCwRYTAUsF6FNiOM6FbBcTPPvVXCpgOWiX9pRZ5Zz8JsMeweqto6mGxZ+cyNJYK4a5jk4ZOtM\n    Cl6u+uU20TJvRyqEua00ve7sdIzR7Y+gBj4P2GMxJL/pI3nhoFStripec3XD7O4Mw78OoKZevbRr\n    6P3OFyR3FdkvMwxuDwD2d9sk+7cgfxOg94c+kmteseThEfQi9P90gOgi5QHXk8CGChjA8O0hpt/7\n    WI9dRPJM1ztp7CJShcknI4w+5i4a1bOovCYkT3Rw8NohAm9K6LEAKPd3eOeLon4gFbkQpG42bziX\n    jebUkB4iLR7zfQEUIqQGgRvNn+Uzl2JH6ZpIzEhn/l27p2lrZ279bDbwA7YaEh1r+WSc1s9lpbHN\n    +lljZj27HidFE1Uq3jbZvy7Uxcg1Uf82jaKT6t/8cfU1rqlopk39l66wq1T/NhEJ1al/q+yfN5H9\n    uwp+YJsspPdF/bst2LQAVQps16H+bYDtWm1tgwp4W+ToEqsK7yas0wZ6m+CafBZRAVedj9BEBVyF\n    qm4vlwpYHrMJFTBQ7nJzHVeVBWxbGC2qAubHr1IFXHWcrXuxWvFbXmRL62fArgLmnZwSqThekrpE\n    4PKbCm5HlP8sWUn9S92qRN7yTldO+OqbJrrh0lm+PDdHdtTKrlzbc2kdnbKbqxApJl+fYPT+F1Az\n    r8L0aI8gAA5eP0TyRKe8zzJeFfv039v4gyHGn4+BbDvXDx4eHhpqnGH47gBgiqU68jffn18RggDo\n    +NxfDw8D0dUE3dcOEM0X/XUkcMkKepJh+OYA2b0m7ZAeHh5njen3E4zeflA8D4r7WzvktSC+OM/9\n    7fnmAI/FkJ6cYPj/fQSkM2bhnCGY06lE5prqXqJadawUt4K2fUXzc+s6jHY/o/Omxb78O9G+U9ga\n    6s2x/LtN/Svtmbn6lx8Tov196HlT//JxtsdyWxP1rzzHOrJ/XWNt9d11qn+lctf2OnXq3qbq3zaK\n    3kWlHFXHtSV3Tx3buaNpFX+yavvnZdW/qxQQ2s61jdm/2ygU3TQuV38GJgF8Riz0zmAb/wg45EVk\n    UwSwywaaX2SXVQGvY9JoO5a6oOpUwLZJcxtVwDbEjkUQHeOyenZZRK9aBVyXCQLYF6NAOxUwP5d8\n    XKcCti20eTemCzSGXkdmB0eMhDXPZXZ9hsXPRxZJ5liXBXQ8J3YlQcyfR+wmaobcClreINFY3l2b\n    zcdwK+iy+re8jc4w+stXmH39PZQn4DwWQNAJ0fvjMcKL8ULHKwWM33qA2U9eveThsdVIFSYfjzD5\n    eNJ41SXJYZ/76+FhR/e5HjrP53nAQDMlMEf24xTjvw6QTfxazsNjm6HuzTC8/QDpqNnfaukakITo\n    vuZzfz0WRzYcYfQ2z/0t5/iS4jdjNQOt6C27kZFaOGJN6BmrdYQoZwfbM4HN6C3alrLt3L6Zj6Mx\n    OiMYon6jwetAvP7DxQo29a9NaCCFCS5Frk39i5pj+Nhl1b+yFtk2+9dWS7SJUmzq36o6ZFXcHdU+\n    qyL9XBiL73XqX3mcRNUxTdFE1LQINu3nt23q301EZ64Ky/Be2yC4PGvh6RnyrtUK4E3nALfBeWH3\n    1915sSyWIYFXaQO9CrS9iNsmmXXnCzRVAY8q9rm2r0oFXPdaHFUqYLOTzj6+ii5ZJgu4qQoYWGxB\n    yhfWaLhgti3GVcvFuXxNvp8fR4/pfLYcGXlu6ofN2Fh+kzIFwK2gdcZO/lzbKplkL39uWinpGyga\n    Y95UmTk9KXRGMO2nmzaVphj++SNkP5/1dO5xXhE/lKD3+iHQNddFAZoVr9PTDKM7p1ADr17y8NhW\n    TL+fYnhnCE7pVql/aR/P/e39yef+enjYEERA7+YBksdilvPpNoUtqYABjD4YY/qFd9Tw8NhWqGmG\n    4V8HmP2Xu2i41b9yDZ27aPTQed67aHgsiHnu7/Tzn4B5RYKTvTxSqsptTM1rCVSXIJqYk7sBa2wP\n    GEFsi8Gy2TvbrJ85sVtNIMM4vx6t4IoTm4ltsDxvJkowt7lqWC60Uf+6BBcu9e8qs3+B5upfV6wd\n    f7/yfBzyGBchbCOIO1Cl7TYB0LKiIqpBV9k/A6i1f64jc3ndvm7sNuX/rgvr4E5W7SC77VglP7iq\n    6NpN46f6IWUC+KxVwNtQvl+mK2HbVcAc22YDXUXgnjYY40KbSaPu/IOa8w2hcxGqsKwK2Da2jQVI\n    lQqYnifiO1C9kKKxE/aYjpHncT2mxZjN1nldWcB1KmD+Huq6E23dk20W13XbuArYlh1M1s+umwYi\n    hBXbb97o6PwZTkbT+cgKmrYR4cvPQY8lwUu3VQFTBUN03fLsHH6TRjd0+rya/CV18P/P3pu+uW1c\n    2cMHXHqV4yyTyYwnmSSTdTL5zWSznfz/b6zFspTNji1ZtuNFkW0tbambJEgA9X4gL+vWRVWhsHHp\n    ruOn3SRQKLCpbtZy7jknfz7D7NZ7KCa+KWlEhBsHPznGwU+OoJIy5WsjgeW29vyTOdJ3JlCL/Zw0\n    RkRcZhTPc0yvT4C5mfvrQon8XeX+jr4dFUsRES4kx0Mc/eEUg6/pPQaFJFgFnCiF9OYFsi9jrEdE\n    xM6hUEg/SJG+My39TYeQvwAwfOUAJ6/G3N+IZqDc3xnL/dVF5jrjV6qA+b4Eb1veC1nuRdA1g3UR\n    ut734A5pPHOYCuUV+25rS9+pIJ9/5TAL9vk+jyz8l9bPtn0ofh312VT9ax+VwwUQ/FOiKnJNwibu\n    6EL9S+c4ulT/EkLFOKnlse3aJkreGex7wHX7aAvbXnpd9e9xBcm8T/bPffAxfQgHCfvEd0WUsN8z\n    rzos/9m2X2wH6KuKYxMq4BAb6LZoYhsxaXhdFdoOjmmDPlwqYJ91SEifLtDkpq0KeO65dhNZwIBd\n    BWzLP5H3t01o6ZqmKmBJGrtUwEpM6vligB+nx9JmWhPFnCQ2j9kWLwnsla6U+8srY5fKYbOCllfU\n    8r6XdtH5muClBRsng7Vlk4K2dNLE8fwfT5G+8yGQx43DiPpIBsDJ704xfsVO8ISQwLM7Eyw+TqEi\n    BxwRsTuYF5j9aYL8y6w0ors2rTn5G3N/IyLCMfr2GEe/OV7nAQNa7WsjjaQKOL9QSG9doLiIjhoR\n    EbuE7PEC6c1zKKXHTpfG3zpn/toIx3+4Fl00IhpD5/7mIve3HBnFi9K5TbQkg4era4arvvh+B+9j\n    sNpv4HsUSzc06gvOPRK+r0Ijm9y7Ieh9G7OQ35fz6xstt6n+lfeVj7et/q0SqLhi76ruL9vSd5fw\n    RkIStXXUv00tnkPUv4dQrdW/ddBG/dslz9An9s3+uQ2uqv0zd1besuDWTgDzF9W1DfS+yqnroM+q\n    iF2zgd4X1Bk8qtpWqYABv9UznfMRvD6S1jdhaGoF0rUKWMKnAl7ArgKW2JQK2HZ/1+TUl43SVAUs\n    M15s7UbinGxjWj9rklq2GxuLG9M6moyLaLEyYAspxc4rcPsjGM9H68WSWmfyEHHLM3rI7jlj5+kc\n    UbwJCozYoo6qd03L6ALpnX9g8dnnMQ84ohGS4yGOf38Nw6/ZN6eqFINFDsxuvEBxFvOAIyJ2AoXC\n    /EGK9J3U2Kh2/S2XyF/E3N+IiLo4+OmxNQ8YcBVTcSjMP80w+9s0OmpEROwIiosck1sXyC+KyrbW\n    8XU8wNFvTjH69sG2f5SIPQXP/QVT+UoSOGf7CDaXMelAVgCl3N8B22Pg5eb8mKkKBvgeicz0lQ5t\n    Lpc2vm8jz9MeUR/qX5eS1y6SgPcawj6of13CFJf619Xet+qvo/4NFersq/oXKNs/NxVxhfTfps0m\n    1L994LKof89qtN2XeNgdwG4qgOuw8n39Y+9CdcK+IPRDr6vKFt8Hdhcq4LaB8FQVVVWhZoMcjJuo\n    gH39cYK3iRWJCz5V776pgDlUxcTWvM5NHMtKxzpZwPTc1l6J9nxRwBcafBFCiwt6PITO+x3Cbkmk\n    389i9e+hDJLYloPDF1+0aBqu1Lu0wNJW0Jr0HawsorWaOIeZDayrb6UlNFAAeY7p//cesmfRoCSi\n    GUb/eoDDX58C4zDTSpl9lj0vkL55DpVWb5JFRET0i+zzBSY3J0hU9axMkr8AMIi5vxERtVGVB1w1\n    uiZQSP80QxYdNSIitg61UJi9PUH2iblit6l/bX/bKkli7m9EO+QZ0vf+gcUHjyGtnyn313QLM4vI\n    ifQdwMz65aQu7UWQkxm5mI1WexM2O2cz99c8xtvqa7BuL2O3uPWz8aPDXvRvEsp28tem/qX2VTbP\n    8tohtGiA769JcYQt55egLNdtU/1bJVKRx6rUv75rQrJ+AXPv1fYzH3iO2fZtZ57rZJsq9a8PIerf\n    LkVZXWGbSmEXsfy1lv126RzbJ6F8FbBD6l/ARwDvwIvba+yLCrhvu4EQdTH/0A3JAfbBd/2mB5wQ\n    FbAPacC5g8BJQQgZ7ZqU+FTALnKWZwHza2Q/u64C5vfg+cAuFTC1V6tJskvJm3mO2aynbRWbPuKZ\n    K3n5gsKciOs8YL4IsWUB8zwb/pxXnboyb+TiarCqtOV2znxhpr94tS0t5JZfOcyMYLNKt0D+1RSz\n    2/dQTLuqVYy4ajj4WTkPWFVuWWukD+aY35tB5XEuFRGxLRQvlrm/amrOKuRfMlnTSvI35v5GRDQH\n    zwN2kcD8b1FaQaMAJjcmKJ7EWI+IiG1BKWDxcYr0rrm1H0r+AsD4lTFOXj3FINZRRTQA5f6mtz4A\n    OX7pXQdN+hZQGK0KxzPoGClO7ubrrF5lFJNzBzIiiQeWAnceocWtn7UzGndNs1k/m3snY0bS2qyf\n    eVG+zV0uB+1nafhc5nyEsNx74upfSeZWqXir3PX4vpoPXap/ZT9dqX/5vSTSGsdcBG0Tta4Pbfqb\n    Nr5yCblX33UUY1shV13smvp3l9GXwLKOIDREaHrJHYvDFMBd20B3jdB/9LMtvb59qJrYNxvorj/c\n    66qAQ2yggWri1UZP0aBMKt2uKawqFXDoMQmbindsmXDtogq4bqWihM8eh0+Q60y65SSdn9Ove9k/\n    b++u/jQXE7zN2CBu9WviixybFTTPA5bVrJxQHglLJl5pO0CBDDCqZrN1f/l68cbzgIdssUf9qDUJ\n    vFzCZR98ifS9f8Q84IhGSIYJjl+9htG/j6CtYJWTBLZthM3ePEf2cI6IiIjNQy0UZn+ZIvs8gz3p\n    V7QXz5MEGMfc34iIVhh9e4zDXx0jGcNKAvuhUDwvMLk9QTGLjhoREdtA8WyB9MYLXU3sAP/75hh8\n    bRhzfyNaIXv21Tr3l7t+cQJXwXQLW+4X5Oyx2X7AXMh4XvCwpBzW+xdqnQ9MpHCxLo5X6/0qPboR\n    KWwSuKqkCJbubDLnV1o/A2XrZ5+bnC/H15bHa7z3lmvqqH/5MeW5jtCn+leqc7tS/9ru2TT7l6ML\n    9W/o+wf4BUpNnC0l5N55U/I35LX4hGN8n9/VLtT+uQt0KcjbB97pqmITAttvVN/DTwBvUwUcws73\n    jV20gSY5f9M/7rZ2Ai60tYEOtV4IadfFAAX0bzsRogJumgXMjx1YJl2h9ztwTGaAy5UFbHvcpQq4\n    ymLHNRmXFZ42K+gRdFXpQFxHVtB0PWDmA+co5/5yQpfUwwPRj84NVuv9AMUWQ0T6LhdJZTUwLch0\n    HrBJDA/WSyyyey7nAXMSmPKAOQkMFEhvfRDzgCMaY3AyxPHrL2H40sDY0ApVAhepwvT6OdTzWIQQ\n    EbFRFArzj1LM/zYrUU029a+yHBu/MsJxzP2NiGiNw58fYfzjQyCxqHwFyn+fCtmHc8zfnUFlcS4X\n    EbFJFLNlpEn23GR/XSUcpfnxOMHRr2Lub0RzFNMZZreXub+c5B0I57Acmgjmub88w1fvGxSrkt6l\n    YlgTwXovQrqY5bC5ncGwfqb9EmrDi+OBMllL6l9OwnKBgI0MBsp20CPPOUKVsMCl/rXtZbkizmyP\n    beIKn/qXH9uH7F8fmmT/Vl1zGNgnQQqJbPvGVWKjkD3kEPvnOurfTdk/t0Fb9e8+CPA457SL+b+7\n    nv27SSHt47Bmu5kB3ARRBdwefX0I1e23T+sG32AiB6E2KmCyxwgheX0q4L5QVwU8hjszmJOptslR\n    GxUwt2zpUgXsm3DWUQHbJrjyPLeCdqmAfVY9cJxzHbOdc2XE8NzgsVikSCtoong5WcvtngsAOTNA\n    KoB1dk6+IoRpAUb/JSClcM5UvHohxxdVVKHL831secCGSnmVB5yfxTzgiGYY/9sBjn51gmRkbmxV\n    kcD0V5Q/yTD90wRqEdVLERGbQvYkw/TmBKowSSZrNqF4niDm/kZEdIlkmOD4tROM/n1UOhe62pne\n    ni4dNXZ/OR0RcSmgMoX5u1OkHyxX53X/9FSS4ODHRzj4eXTRiGiIVe5v9sGX0EbLpMTVewM8A5j2\n    GnTWr2kBTUQvteGF6IPV/oO0fFZsT2JgkNBm7u8IBduHUUYBPd83of0UWZDP7Z6l9TPfs6HzXAhA\n    9wDM/aMQ9W8dscLIc02I+tdFJgNuxa+NgLTt6/WR/QtLO9trWXjatsn+laIeuR+7CfVvF9iE+pf2\n    7tsKy/qOyOwLu8w37aKwcpPYEfUvUIcA3nUb6F3EVaMcNq0C9hG0TVXAcjDqovrIV1UVmgU885wD\n    dlsFXJUFzEnihaV/G1wq4CrLGOXo20bayvay2lH+3GY+Sn1bnbYqYL5Y4IsEUgHLxQS9RkkCh1hB\n    SxUwzwPmi6URI3Jz1pbbQtOibJnZQ0u1YmXBZNba8kpfIoFlHjC3e0ooD/jOfahZzAOOaIaDn5/g\n    8EflmltJAktFBD1L35li/kEKRCV6RETvUJMc01sTqBdFsNEsIQGQxNzfiIjOMTgZ4uj3p0heGpQK\n    MWxFGPxcAgUsFCbXJyi+io4aERG9QwGLh3PMbp+XToWofxUSjP99hOPXriEZhrnmRERwVOX+cvJ3\n    uFr/y9xfxayfuQW0dhsz3cn4vsZo5UBWAGtXM/pO+l4qe8+hSk5qfO+Fq4Hpu97vKkdzUcmwTwiQ\n    w1T+yvMcIbFi/JhU/1bFoXGi10Ya28QVVepf13PX/p1EV+pf214mf+7aq0xRJoLrZv92jSbqX6B6\n    vzpE/SuxLfVvXaGZS8jWlfrX1n9fjq11sS1C+SywXV3176YdhneUP60mgPtgq/sKVu5DAt5ltULX\n    f0Rd9rcPFgS7iJAs4LYq4L4mBbuSBRxyPaFKBcwRMolExTWAffKasfZVW1HcCpr6qTMJl5N/l9J3\n    5OkHrB+5qKBFBK8q5UQtX5jQYoauLVfFarKWKm/NhVDBcojJvkmTwLwyl6pyuRU0f01EACfra8p5\n    wPQ4vf8l5vc/jnnAEY2QjBIcvvYSRt+xqZcCNrYUkN48R/Z4Ud02IiKiMdRCIX17huzjxaqgSKNK\n    /ZtgpViKub8REb1g/J0xjn51jGQEyL/IKhIYAIqnOaZ3JlBpdNSIiOgTxVcZZtfPoVbTVt9OBGkv\n    OYYvDXD8+5cwOIkuGhHNkBu5v3pfITH2BUwiOBEkL+0RZOvrdBH5YEX4SptoXsAOKCxEcTy3d+Z0\n    NH8eav1s/mUptkdij/Xix2UGcJ/qX/4afdfwfl2W0W3Uv1XiD5sQRPYh1b9z9th2LT9nwybVvxJV\n    6t+Z+NmboAv5xBGUQbxuK/u3Sbt9wS6rf686NqH+/Wb4PepZQG+axe6LpT/b8M+xa5BVJV2GnLuq\n    YUL77fLD2DVIVBG2fFDqwo76EKr14Kk8fYSqgKveF991VSpg38QoRAXMH7uygOWkblMqYFtV49Dx\n    89pUwHDcw3ZNiAoYKFs6K8v1UgVM15kLDq3Cpv7JCpovRGjhQ891NajZBsDa+pnbKdGCKIG2gtbK\n    YU3W8kUbz/pd3tPM+klQIMOyYrcoXV+AVwsPkGNy4wNkD78AVJwgRdTH8NoQx69dw+C0PG+ybX7p\n    c0vkFwVmty6gJjkiIiJ6gAKyj1PM7k7pqa9pmfxFEnN/IyJ6xuF/H+HgR8s80ColMAepDufvzTG/\n    nwJ5nMtFRPQBlRaY3blA/nS5ajXHSul0U577JmPg4FenGH0n5v5GNAPP/U3Yen6I3NgHIEKY20Fz\n    gnhJpi73EgroEKrRyi2M5wlzZ7OcnaN9ixEKo60ufDeVvrJYnu+bcOtn2qOhfRlemA+YhfpyH2cI\n    0/q5vM+D9XHu+sb3oaidPOZT/8JyTVP1b4hwwxffVlXSz2PkCLY9SX2ufG2V+teFOsKaUKFP3exf\n    CZ/61ydW6kP92wRVe/JdRUiG2D+3Vf/2jecd9CEJ5TbOtnUElWeB7XY9+3eHEUYAb4K17gq7/suw\n    yyrgTaLqw7XqQzzEBroJbANYCGHcRgVM5/rIAuaTBVtfu6IC9mUHy2t88E0m5USSjkkSuC8VsOyH\n    T9Dp+txyDS0K+L1dVtD8+cByL25HpNvYraB5n3zyzxc59DoWq1ZkgcTtlWgxxfOATfvoYkWf0TX5\n    ekEHkd+j84btecAF609em2QZpn98D/lXXUyLIq4ixt89xOH/I/VSGVVq4MUnc8zenkIt9nPcjojY\n    ZeRPM0xuTKByt0UlYCeZFBIMvjbAccz9jYjoFckwwdFrpxj/2xAKiZUEtv+N6r/r6ZsTLB5FR42I\n    iM5RKMzvz5C+17x0/eDHRzj67+iiEdEQq9zf9IPHUEyJK3N/aV8gWVO7+pgyCsJNxzH+RY5jPPd3\n    xNzKuEKYyGQqaOd7HSbpqzAAWMG9WTRPeyya/C0X9ss9Htm+9JY5jtkIYX4f2b9NvavhJnTpGrlf\n    xvfIfKphl2hjYWlTV/3rel6V/Uvkb5XIZVezf/tQ/04b9CHVvyHtm2JfVL3RefXyY0ftn4G6CuAd\n    /2Fq4WxD9+kjB7hv+qIvFfA24Bpw6gwuTUlmOUhuQwXsqixrogIee56HTJDqZgHb2rZRAbsmly64\n    VMAhljk2FbCcVA8rJuUctkk8PwfHcVv/tkUGr0LlFkO0lBoaC5jltVz5K62gl/fXiyGuHuYLN/0a\n    NIHLVcPLhV2+qvIt5wEP2WP5tcwEylf3XT7Pnk0wu/0+VBpSxhARUcbhL09x8MN6dbj8L3p+9wKL\n    j9MoRI+I6BDFtMDkzQmK50XJ+hlARWlGssz9/c0xhjH3NyKidwyuDXH0+imGp273DBvWM9CZwvT6\n    BMWL6KgREdElFp8vMH1Tb6O7pqou55vxv8Xc34jm4Lm/g5VKVyuATbtnWudnbF+B9gD4/kA5ZkoT\n    xbTfQAXqZP2snc+IQDb3PLjlM1k2y5xfiOdE/vK9FmoD6H0b2jtxWT/7Cv95TFiVuxzgd6bj6t+R\n    4xqXcMLmmOcSTtjI2zrqX1sp2Ej8zIBfzWtT/9pQR/3L90W3rf61IVT9S+ebkL82TFDfAvoYfpVx\n    6F49tQslim2cSJc8xwuURXFN8n8vi8DwLLDdrgs+OXbM/hloQgDvA7r+pegyB3hXcQK1M9Uodb37\n    fR/6TSwpbANT2zB6PoC6zgPd5CyU+9ZoowI+YFWLsp1t8tVFFrDNClrCpuKV522PF57rbVY2PtJY\n    TmYzcY5fT8Sx1BjZbHN8yuGQxUCVFbTME+ZbaWQFTQRuvu6RJuVaTcyrXuXiiC+4FGszEosuXp3L\n    q225JXSxPs9tpLUKWC/witVr0NW/dHx2/3Ms3v8k5gFHNMJgnODo9Zcw/Pao0fVFDkxvnKM4i+ql\n    iIguoDKF9J0Zsg/tWzO0DW1TFiar/x389BAHP42KpYiITWH0ygEO/9eeBwy4iad1keGXGaZ/mqKY\n    X/41ekTEJlC8yJHeeAE10ys4G1xFG8PTAY5fvxZzfyMaIzuTub/5ar1PxX2mCpg7gnFil+8VDNaF\n    5Jr85apiTQaXncz4ngfFW2lnMxmtJW2czb0ZSf7SY16Yb1pHm6hS/8rzVcIBl/rXpvCtE4HmUv+G\n    wLZPxx+79vRc6l+J0OzfUPXvXDznCFX/coSqfwmh6t8mjpIhe9Ih9s/7pP4NsX9ui775lj6Egn0I\n    GjeNZxu8144LZsMJYM5e7/gPFYyzDd1H/tF0UVXB/7ib9FdVXbIJFXAXH7IhH/abUAG7bKC7UAHz\n    QXvbKmCfKjh0ojS2TO5CVMAE3ySvjgo41FZ6KPqUk9ys4jobiSyrOuU1PisfeczVnmB7fZywpX5t\n    KuDx6ji3oKYaXL5g4eSwXEhRfs4AZqUttVEsd4efl+Qx/055wFwNzG2givWCb6kgXi4ctbX09MYD\n    LD79HKqIG4cR9TF8aYjjV69heFJfuQQAxfMcszcvoNIi+PqIiIgylAKyh3Okd5azLZv6F7BvZMfc\n    34iI7eLgl8frPOAqnT5BQZPAi7dnWHyYAnEuFxHRCmpRIP3TBRaP/MWxLvI3GQHH/3eM0St9aNUi\n    rgKK6Qyzt5a5v0T6yj0AUgNzwpc/5oXiyWrtX7A9Bl4sPgCtwcruZDnbp9BEsR576BxX/Q7YOdob\n    4bm/hBzL/S4zX1eTxEB5n8hW4M+vk/1XqX99LnZ0Xqp/5TU2dzzCyPjZ6ql/zZ+vWv1ri3eTfdTN\n    /rXBdr3ci2yS/VvlSWf7RG0bERii/uVoqv6Ve+NNs4K7UP/uIjZBOO8LzgLb9a3+fXlP/02+DG+6\n    PQVw32/uPknDI9qjaxWw7boQwrivLOC2qFIB83NNs4BDVcCEbamAbdkibVTAtkpHum5omTyb503Y\n    Kiir8oOlpbOrvVQBk8KXXzdcTZAloUz1sUQW26yg+TnKx1nmBOuqWF5VS4strhwu1o/1go4WgVTB\n    Kyt8ZTu+COTH6ZUlKKDmC8zeeA/52WWoaYvYBg6+f4jDXx7XIo34p8f8QYr5vRmQx7lKRERTqLMM\n    k+sTqIzGMUsbyzEif2Pub0TE9pCMVnnA31n+/dU1jVUKSG9eYPE4OrpERDRGoTD/IEX6jt7mD5mZ\n    8r/Xgx8dYfw/p9v+SSL2FXmG+Xv/wPz9x1CiWFw7eVXn/vJCcFlMrvcNzNxftSpU57bOZlQVOZeV\n    CV9enD+C3gPJRTub9TP/LqO++H6Ni/y1WT/T8TqxYT7CGICXKJaPbcSy3AtzwXZeRr1lnra7pP6t\n    UgPbYNtj3Kb6t8q9sqn613WNaw89hOCto/5toxRua//8wvG4DbgQsAv1b9f2z1fBSZeDC2U3Yf/c\n    APUI4KgC3i10LfHvugpFfkjW/aALrehp80HuGmxsg1OICtgGWk61IXj7VgH7qs/6yALehAo4E+1G\n    lglo6GR0aLkmJNdEnufvuUsFTPCpgKVtT4gVNFBeeAzFvSRRzO2dOdHLFbz0RcpgsOc8R1gv0LQy\n    OFu1p+e0KJOKXzJywmpZx4libbuks4I0CVysrzXJZoXsbIr0rXsopn2UXERcBRz+3ykO/vOg8fWz\n    N8+xeBiSKBQRESGh0gLTOxMUT5ejUoLwOaxCgmSc4PA3JzH3NyJiixhcG+Lw9VMMVnnAISQwVwHn\n    FwrTWxOoScwDjohoguzJAunNc6iapjQ04o6+M17m/o5i7m9EfVDu7+zWB2z9T6m62gq6YOv5Au7c\n    36GRHVwmgcltTLqQcZJ4sCKF9R4F2F4FHQd41i/9+dA+DX2va/0s93hc8O0T2QhksP7LJK3L5tl9\n    jdwP43thynFdXfWvDba9vdLvFDtuI3z1uXK/NtRV//rUvVXZv/xcE/Vv1fl9U//60KX6dxfUuE3y\n    f/vGJqQyZ4HtosCzjJr5v8A+ZAA/28A9zrbwc+1CWLftQ6aPyhQfXB+2TUhd3yDQdIDoarDig+cu\n    qIB9CMkClscIXaqAbYQwEKYCriJ2Q1XA/DGfSEt1cEgmCiwTe1IBl4+5Vb0+2+fQhQL/WaSCl9q6\n    rKDpNfGFDn2nPjhxOzJ+lnIlLlXe8lwevhizWUErseiThLC0hx6AKocLtiAssHj/MebvfRTzgCMa\n    IRkNcPz7axh9M1w9yD8pilRhev0c6nn8/YuIqIVcYXFvhvk9PcMIVywlQAKMf3qIw58ebfsniYi4\n    8hj/xwEO/2eZB1yHBCbknyyQvj2DWsTNoYiIOlCTHJNbF8gvNPtb569omft7isG16KIR0Qw89zdZ\n    OX5JC+jC2Acws3+lKxjl/pL3l22vgBesJ0z9Kx3LuIWzLmgn6HZ830JbNpf/ksj6ORd91LV+tql/\n    q5S86/ebPbY5xFURsC6XPF+G8KjimO2xS/1rg2//bw5zf/Kyq39tRHRddKH+7QpV9wnlDOpyAZIH\n    aav+leiacO4j+/eqoa1D8bbUvzXsn4G2BHBbFfBVsoHuq3pi11XAEn2RylUf/l0NUlUWz5OKNqHV\n    VjZI4rUuScwrzqSiuM69gc2ogPk5G4nsUwET6qqAqyao8j0LUQFnlr7KKmCToLVNcvk1PLMXCFcB\n    +6ygZWWqzQqaL4q43TNfBNGrNdW7ejG0vBdf1GkiOjf617m+pA625QEvq37zVe4v1QfzBSPZR2t1\n    MbUpUGB260NkD79YeglGRNTE4OvjZR7wcTPlQ/4kw+xPE6hFzAOOiAhF9nCOyS1dWheq/qX8wvEr\n    I5y8Ws/CPSIioj8c/u8xxj9cOmqEksB8gz29O0X2cVqPvYqIuMJQC4X07Snyj+sVUhEo93f8HzH3\n    N6IZyrm/suC7XPQNKIxWsVC8+FtbQvOcX3O/YLkPYBaiczcyBbNAnchf7nrGi+a5FTTfA5Hn5N4L\n    HbftARF8hKdLDOCyfraJEHw20/Ial7sdJ31HMPfAqtS/+i7he5JN1L+2x8vnZr90XraTe5CSUAaa\n    q399Dox9ZP/qvt398P3lpupfwCRcJ+K7RBv75zpw8QWbUP9WieyaqH9JANgVH9S1QDEEZxu/4+VB\n    A/UvsA8K4E3hbAv37OqPrM0ffd8q4JBqGZ8KuMsPfldfVTbQk4A+QsAHUR95G0IS+yYAqafNrqiA\n    +eQqRAUsHzdVAYdMOENUwEQsj2BOfl2TdWmPM4SyHrOpdG3LcZ/616cCzhzXDWEqec3Xoxc65VwZ\n    1yII675oYcWJ3uW/j664pe/cbknmAQ+g7ZyHKxKXLxBpYZjAtH3mfdB/vC3yHLM/3kN2FmvnIpph\n    /MMjHPziGEnglEr+Rc/emWH+QQoUcec6IqIKxfN8mfs7X/69JEFlbMuWAGLub0TEDiIZJzh6/RSD\n    by//LkNJYCr+KHJgcmOC4ml01IiIqIQCFh+nSO82D9Ia/zDm/ka0wCr3NzNyf/V3bufM1/y0P8DX\n    /tRGEr68LRWaQ+wruOyiOfnrsn7mNs70nfZLOLGbQ++FKdaHtH6WZDF3iZNWzgM28/Wpf337VNz6\n    mV/D99DkXpiLeOXWz/K4y/rZ1pa+b0r9y6+rCmUaQ5UUw/A8r6v+5UKdtPJKEyHZvyHioS7Uv1WC\n    qVD47nMM1Zv6t2/sgt10CDZh/7wr6FL9u0nUVP8CTQhgKWe+LFnAVbhKAdb78qEkUUUYb9KqokoF\n    HELy2gbpUBVw0yxgH7pUAcs2fKJXRwXMz7sgJ6s2FTCHzQp6VPM9a6oClq/bN5mXKmCgvBDh7Yew\n    Ly7kddxyCCjnFEsraLnoseUE03dusaTb8IwdvtBaKnb1Qkz3b1vcFTAXaQNO8rJFJSeG13nAzy4w\n    v3MfxazudDsiAkACHP3qFAffC88DNj49lMLs5gWyLxfB10dEXEnMl7m/+RNehhSClflzzP2NiNhZ\n    DF8aLu1kT5d/r+FK4CWK5wUmtycoZtFRIyLCh/zZArMb5yjYIrLO7s/oX0c4fj3m/kY0A8/91Qpf\n    yv011/i0bidN7sBiAV3+Li2hl8e52xjtQCRrsrlYEbJEDANlghhrYrhc3K7AC9353krZ+pkK62G1\n    cJZkr8/6maPOMZ/1c52IMy5ocKl/nb8HrH9XPBvE467Vv+bxavWvRFfZvxw+9W/bnaptqX9d2JT6\n    tw66tn/uM1bzqqh/d8nZdxfQUP0L7IICuG8b6Do428I9u1QBb+MPtwnqfAh2rQJ2IcTaObStD5tS\n    AfuwKRVw1aTJRRDXUQG7LJurJo68D9tjF2wqYMBdXWnLRrFVWkp7ZgnfMWnn47KCxmqhYbsXfZcZ\n    wPIxX9RwS2fFjktymFspaTJYL7ak1ZP8PhSWzsPV9zFyI2eHZ/zIql/+XL8+s5p4fu8LpO99HPOA\n    IxohORjg6PfXMPp6M1VhcZFjdusCapI3uj4i4tKjUJg/SDF/l884qsfthD2Iub8REbuNg+/pPGCg\n    mgRWMC3gFx/MMX93BuT7sSaOiNg0ilmB2e0L5M+bzTcHpwMcv3YNw5eii0ZEM+Qi9zcBV/7quCZO\n    BOcou31pkndp7ZyxfQZZJE6F5qP12h/r77IQns5lMPeHfNbPNrc0l/UzFebbrJd9f5U+MldBtVL/\n    Suc5257WyPJ6gbL61xWLxsnbhbjeJdAIVf/K6+qof2WuL28Pdl2f6l9+XR/Zv3XUvy7yt80eeF0h\n    VtfZv9u0f+bILfdrYv+8D/AJKM+2/eIYulb/bir/t4H6F+iKAN5lFfAuVQvsqoze9qHDP5y2aQNd\n    F1WEcahRYFvskgrYdvwAqjQ5qKMCpr59k58FwirpNqUC5uCTzJF4zfK10PXUThK48vjQM4G1Ta7N\n    86i8hk/q6XFd0tg24VewWw3ZrKApN1haQdMiip8brCpqde0uVcsuLaCHLAeYW0HTQg2srZkrTMSx\n    WQE8XKX4DIxFIhHDeqFpKoSXX7NbD2IecERjDL85xtHvTjE8bKaIWHy6QPr2FGoRf/8iIiSyzxeY\n    3pysOd+Q3N8EWgtyEHN/IyL2AjwPGKhPAk9vT5E9nMc84IgIiVxh/u4U8wfmLkHon0oyAg5/eYzx\n    92Lub0QzUO5vwXJ/zSJuU9FLa/ah2AMwc3+1XfSAncd6P8AsMNeuY2YB+oB9t+X+AgqHTA1ss37m\n    4EX0odbPvv0YwFT/+qyfAfu+T5X61wbXPtjQc6wKtv03/riu+tdFzsrHoepfib7Vv3S+afZvSJtQ\n    9a8PXdo/N1X/7pql87awz+rfiK1h+wpgYH9UwLtuA32ZEyx3QQXMX8uuqIBDEJoFnDqu9VmN+FTA\n    QFiWhv24f/JGkBNWG4FbpQKWFYghcNndEFyVjzYoxwJA9uW6BiireV0q4BAraL6AkQQzfS9W/w5h\n    VtC6H15ty1+n7kcvwigjmBPBZAU1WBHEyWpRJ/OASfWrl4blxST9p/iiM8sw++M95M/7NGuJuMwY\n    //gY458fIQnggJXlSHp3gsXHady4johgKF7kmF6foJiG/2EQ+Qssc3+PYu5vRMRegPKAh/+i/14V\n    ahRWLdQyJ/yr6OgSEbGGAhYP50hvX8jDwRj/8AiH/y/m/kY0xCr3d/H+49XKW0c0JWsL5ny9eudO\n    XXIdr9f8wHh1zRDaCYy7iNlcxrj1MxHF3K3MdA3D+jnf23BZP/PCedpTsbmtye8kBvAV8dvO2Uc6\n    u7qY9oL4/lWV+pdDkr5c/cuvC1X/cjGFT/0ryV/f/p1b/VvuK0T9qxCm/nVF8Nn/deqpf13oWv3r\n    Qkj2L1DP/rkp+lT/dr0DyPtrayW9T+hS/dtW0PnMc24fs3+/CdVU/QvsCgF81bGrVRd9fkjZPlxd\n    KmD60A4lgasGhaYq4CaDWN8q4CYTBWCzKmBlmZS5npsq4PJ5UgHze9TJ8pXn6bsrd8SnApYk6Qj1\n    MlN8KmBJAstrZJ8SvkUC5Q1nsC8+gPLiRBLGlOfrsoJevh+U7UvvkrlIopwdbseUQOcB09KOrhmv\n    6mK5pZOZy6MrfhVMayhZXSzzgnm/2bMLpG/dR5HGPOCI+kgS4Og3pxh/t1nGaJFjmcv2LG5cR0QA\n    QDFXmP55iuxz/TeRVMxWOPmbjBMcxdzfiIi9wvClIU5eP0FywolftxJYfh5kT3JM706g0pgHHBEB\n    AOqrDLPr5ygauswMv73M/R2MY+5vRH3w3F9N4GoXLiKBc5i5v6QAXj7ORd6vXtvzdf1yj0LvD+Qw\n    rZ91/q9atyUnM9pFGKzvYVo/y8J32isx3dHc7m1DlAv1iTh1q3l5wTzW93W1r7J+tql/+X6ay/rZ\n    5SAnMao4ZnssxRuZp6+F53mVgMTmGFil/rX1z/dBfYSvS/1rI22bZv92of6l822yf7tQ/wL+PfdN\n    q3+74kNOoaxivab2z33zR7vqXBvR2PqZ0IwAtvlat2W/fez7sxr92FC3auDMc27XVcBNPwxsHz78\n    Q2rf9HBNBwc5GLkGoBAVcAhhfAjViQq4ygbapwKuUvGGqIBtkyGCz5qZ2sqJl80K2jU5c6mAOfjE\n    1TUBtR2rOs9fBRCmAs4sfZVVwCZ8iwKbChgw82xs7Q/Wr8vfr1x8uKygebWruVChx4VRKav7WS66\n    pD0TEcQyD5gv8paEr2kxLauDZaUw5f9i/bj8fP7e55jf/wTIYx5rRH0MjoY4/P1LGL1s/iXbtsxs\n    KuD8eYHZ7fO4cR0RUSgsPkyxeFvPcuqQvzH3NyJifzH6z0Mc/MK0bffZQUtb+PS9Oeb3U6DY7bV7\n    RETfUGmB2d0LZE+arWtGJ0nM/Y1oBZ77Wxjrc03kyqJsMnxO2DOZ+0uk8YDlBnPit4AuSlfsXDnS\n    ivYWsHqmHcukGpjvjRAxLFdsvLieCFcekyXd24gcdu3bmNFbphLXZj1dev/ZPRW7llBHxDCEWgsf\n    +HWu/S6p+LU9tpVohlg/m32oSvUvRF8h6l8Jn/Vzl+rfKvK3S/WvD02cL5uqf6v28PdJ/dsndtn+\n    +apk/24D32z/mqMC2IWzDd+vqz++rm2gu6x6kdimCrgpQdyVCphXV/WtAnZNSFwVaU1UwFUkckgW\n    MGFUMRm0qYBdr9llBU39jNk514TUpSKWKuAlueyvuiRI+xzetpy9ayK39GWbtPusoH22QIBpBc3z\n    a2xW0LSgcVlB8wVL4iCBqdKWk73cCpqqgaV105BVBFOVsF48aiVwwhaWZC1lHpN5wQXSmw+w+OeX\n    MQ84ohHG/zLG4W/MPGCFJTlVpZ1QANIHc8zvzYA8/v5FXF1kjzOkNy+gAmshDPIXMfc3ImLfcfSr\n    Y4x/cBDUdjnGLsfMZHVg+uYE2edVpagREZcYhcL8/gyz99LSatk2w5Rz1MEQOPifYxz8Z8z9jWiG\n    YjpDusr9lXbOes2ujPX5ANLqWbt4cScwmfu7LBjPjT0F7ipGfY7Wls/Fer9CWj+bub9YPeMEM9b7\n    JdL6WRK50l0NrEeg2vrZdszmSOezcebWz2DXjhzXZOKchE017LN+dl3vUv/asHD0Ic9za2eX+tcm\n    QpHnQ6yfXWir/u0KoepfH0Kyf13763X2z3dJ/dsWnOvYJ/XvLqFP++e22Ib9cwfYLQJ4X1j4XVcB\n    N0WVCnjf4BskuhqI9kEF7L/3Em1VwIB/UuRT8FJb5ZnAVfXhmvzZwCezfFJax0raZoVjI6H5xNpF\n    HrvJ2PLrltfYMlfqLB54upqtPS1q+OJFWkEDptpYWkHzRRTZRlO9r7RxHouFXGI8p5wY0/J5gAIZ\n    sLaIti8sdSVxxp5zW2i1IobXBlDzBabX30P+4hwREU0w/skxxj85QlAgsAWzNy+weFiVpB4RcTlR\n    XOSY3bpAfmGOT66ZhCR/Y+5vRMT+YzBOcGzJAw4dVdVMLfPDX0RHl4iricXnC8zevIBSpko+dDdr\n    /INDHP4q5v5GNITI/dXOWwWknTNfuyuUY5wkSZus1u60xqd9ATN2qlx8nqwfF6WoKm79bOb+mt+5\n    GxoAiwOaXcVLz6l9huqCfV5ML62f+T4NB9934ns3/B5SkCCv91k/g93XpRqWcIktgDJR3FT9S485\n    mqp/bdgV9S+d44IgibrqX5v9c2j2L0cIWWzDptS/NvSp/u06VjOqf9tjX3hHjg7Uv0DXBHAXLLjr\n    H6Mte9+2ekBil0ngrv+YN50F7EJdFXBThJK6oa9jgv5VwED1BEG2p+ObUAHbCFnfJMunAqZqvLYq\n    YEnsyj5Cs6Jl9SQ/BrgrIm390D0VyvZAvC/5mmkBAJQthaqsoHlFam45LhcxvD+eESytoHWFrEkC\n    UwYwLcB4HvDy/svFnlyscZvnMVP8mnbQerFYiO/SWorspLXJk8KA5QwrKBSPzzG78z6KNJJwEfUx\n    GALHvzvF+JURSFNBfz0+JTBZ3Bapwuz6OdTzmAcccbWgFgrTv82w+MT83ZcWr/q4Sf4m4wSHMfc3\n    IuJSYPDyEMevmXnARALLcZSrgAnZ5xmmf55CzXd37R4R0QeKFzmmN85RzMJ+95djqcbw2yOcvH4N\n    yWi3RCMR+wHK/Z3e+hA8YVfm/pK6dyAcvbQFNF/jm+5fQ2vUk5n7q1bPNSm83Ddwkb9k/ezK/aW2\n    h+u8YWV1S+PWz/IcwVfcD0t7gs36ucrhzb6arO9cx18nP+5T//I9txGUU4ARqv7lfQDwWD/b1b8K\n    1erfuXgOz3OJvtW/ocKfLtS/Vdgl9W9Iu5MOfua2aKr+jdhtfL3n362W+b/ArimAdw1nG77fLthA\n    +1TAm/LF7/JD2TcIhBJ8QDsVcAi6UgF3hW2pgOXkzKYC5pDW0XwiWKUChrjW10eoChiWyXBIloqt\n    Dnt5vkwCu65xTdxt19oqS112z3QdKXgh2gzWk9eiZJlE38fscYGyFfQA2gqaXh9l+vAFmWnnZNpF\n    FavFIFUH8ypfbgtlVhNrgljmAdP1i7//E4sHn8Y84IhGSI6HOP79NQy/Zp9v+VRMCkD2JMfsTxNg\n    EfOAI64GlAKyj1PM/2TWovvIXzqfQCGJub8REZcO4+8v84D51oUK1gEDi7dnWHwY84AjrhCyArO/\n    TJA/yhw0kYatmGJ4MsDJq6dIXh5t+yeJ2FNQ7m+SZ4ZDF4QTF63Ps/UKXqqDzdxfsngesGJubutM\n    pCzfB6DnY7YnwHN/uUuZmfuL1TOTDB6w+0h3NNpJ4ORvmdil5373Nv4apPrX1q/P+lmqf20WzvS4\n    Sv0rj7lUuoSReC85ulD/2h4vn9tfg4St1F/uJYaqf137pV2rf2V7jq7Uv3XRVP3bNXZJ/dulo+ou\n    2z/vmkDSJSC9wupfYFcJ4L5UwF2jyS/5V9t+0Q2xKypgQkh1T50PfomuVcCuPrtWAfsGe589yQFU\n    6fg+qIDpcdVrrqMCltWFtsfyGJ9Q27JSXJWRmeiLq4C1VY8JPoH3Tf75YsKdO2MniGW/RBBnFYud\n    celn1/flBDPP4sH6PdGLvGX/+ru2dVLrPGBuBc3zgLkSmPobwlQBc8JY5gHzdrQknN54H/MvnsQ8\n    4IhGGP3rAY5+dYJkbKqAfeBk1+ydGeYfxI3riKuB4kmGyY2JrjiC/nsI+QsYx9zfiIhLiaNfHWP0\n    fZ0HzPN+JXklC0ZUAcxuXiB7Eh01Iq4ACoX5hykWf9M7DUnACLp2qRkmOPyfI4y/HwupIprBlftL\n    blt83Z6gHN9Eqb+kDzaLtTWJS/8RKczJXiW+D1duYzz3l8dNkQObSf7q67n1s02h63JNk9bPsr1r\n    P4cri2U7KTBwx30ppwq4jlhhSRjrd4SOufa1XOpfvlfnU/9K8te1Pwe4BSJc/Sv76lP9C1SrfwmX\n    Ifu36bUcdYRZbVBHaNYn/9EUm7B/bsJX9UH+du3g2yX2NP8X2FUC+Cqjq6qOokU/fVkS1PkQdX04\n    tyF1baij7N3lLOCQSjH/vctILf31rQKWhCx/HqICpmsIC0/fPhWwcvThul5WVS778VdjEnwTcpcV\n    NEHaQ0sCmbcLWWRQW5cVtMwDlq+BZ+XQPWnRRAQ3VwbzKlm9mCuMyl3TLrowrhmIPGC6XttAL0ne\n    ZRtt70x5QdlqMSirkGnBSRXKSOeYvfEe1HnMA45ohoOfH+PwJ4e184DV6n/TmxdYfBk3riMuN4pp\n    gcmbExTPl+yvL6/QSvp8bRhzfyMiLikG4wQnr59g8E3733cVCZxfKExvTaAm0dEl4nJj8STD9OYF\n    isJfOGWPI0lw8IODmPsb0Rws91fBzP3lxduAPYKJSNchy/0lBS7P/eUuYPw67jSWg+cCY239XM4T\n    1vsPOtu37GpG1s9AuSAeq5+I76MAdltoec54+yzn6LFtz8ln40zqX/1c78fYruHqXzsxbBc4SLhE\n    FNL6mchZX1++yDZO8vrUv67XBnSr/rU9l6+Z2jRV/85EH67zPlSpf+uABFF9qX+PoYI4gCYxkdtQ\n    /15F++ezDd/vMqp/O7B/BvoggLtiw6MKeLfwHLunAg6FbzBokye8aypgmgA0UQGnCFcBy8lKXRWw\n    j8AdQzntWWwqYNtjm62MBLe1samDfZPWKitoUrNKcIscF3lsy27hVtAh1/CJvG3hEKICzj3tpRU0\n    VwEv/y3KVtCcBKaFFc8DpgpcmbWTiIpfas8toIfrR6a1FL/Olgc8ZIvNIVtwcqKY3zf/4gXSuzEP\n    OKIZkmGCo1evYfRvOg+4DoqLArNbF3HjOuLSQmUK83emyD6ar+2cAbtqyfYXlIwTHP3mOOb+RkRc\n    Ygy/McLJqydIju3jqI0E5p8n2ccLpG/PoLL92wSKiAiBmuSY3bpA8cItB3DlZwMJht8cxtzfiMaQ\n    ub/mqt102aLc3xww3Lhobc6J4oL1w3N/yfpZk736bjnbN9AF5cu2er+GXqHe4zCVt2Vhg9nGLIzP\n    4Ld+lgX2vnguQoj18/LeKF2TW+9hR7X1s/2+sr1L8WsSt+U9uibWz23Vv/L6uupf256qRIrmIh0b\n    QvqqUv9W4QiqloJXoqvs3yboQjC2i+rfNgI/jq7VvxF7heYTu74DjvtAExn52bZfdAt07RHfheVA\n    Fx+m9KHelQ30pgao0Gt3KQsYCJtkHFRMjsaeiRdQJoGbqIDbWEHT6+JQAf1J2CbYIVbQvj64FbRU\n    /Pqu4dcSuJ2Rrf2gdM+ylZG0gqb+TBJYGQphvqjiC6ey+ldX4Wr7aDMPeFl9WxjXcWUvfZfWUNzm\n    iVcI0zVae2wSyTybaPb2Mg9YFTGPNaI+BidDHL92isG15W9jFaTtbfbpHOnbU6jF/s2/IiJ8UApY\n    fDJHesdfh+76q1FJgvFPD3Hw0+Nt/ygRERE9Y/zDQxz+9xHUoF4xFY2p6d0p5p/MwzzlIyL2CCpT\n    SN+eIvvYXCmH2T8nGB4nOHkt5v5GNEd+9hUm/989a+4vRSsljMjNoJW82v5Zf9e5v6bDl9wT0Ord\n    wrB15o5jOUx7aO44pslcvbdB+wemLbRd2UvXcPK3yvrZtx9js342BQDmvaWqeKn0Le9h+dS/5XbS\n    Ma96T8tF3o6gDKHFwnG9hIsklpDCEBvB7LueMEc99a9sV0f9K7FJ9S/tKbdR/x5BWdW/E0fbJmgj\n    1pKQDqN9CtAKXB3171XL/t2k/XPH6l9g1y2g90UF3ASbqK5oQ9i6Ppz6/KCUfdfx6K9C08HDNljZ\n    BrhjqOCBzacC5gOyDz4VcIr+s4BdVtAhKmDAn/0LuO1fxpAksAq6fgE3MritaWx20iEqYHrneBsg\n    LGOFFg9mT3ZCl9pJTSCf0IdaQVdVnEoraLno4QsbWPrkyl9AV9pyhXCxei8o61cu3nhbakPWTjIP\n    eIB8fVzn+ZoZQ0Nwq2jTCnqwyhIq5wE/QB7zgCMaYvzKIY7+7xjJCEEkMIF+29K7Eyw+TuPGdcSl\n    QnGWYXrjAkXm3qhOxHde/jN+ZYzjV09i7m9ExFVAAhz9ZpkHXGccXV6qUOTA9MYExbMYqxBxiaCA\n    xScp0rsTeloLyQA4+MURxj+Iub8RzcBzf7kzl8z9VTBzf4crW2dejF2sr6XZHl/T60Juri/mts45\n    2xdYQiuFuesYxW3R85HYb+DkL98LkS5oBcr7W9KJLdT62XbMZv3sixqTwgEdUWZXDFepf/n+19DS\n    lw2uSDV6btt/a6L+pb61+helfqldlfp3IZ7D8/wA1Z+yLovnPrEJ9S8nf9ugK/UvvZbLqv7tWthn\n    wy6pf7vO/91H6+eesNsE8L6g66qHLv/Au/6w6OIDcdMq4BB0Nfh0kQUMbFcFHFK5FnJd1ypgfQ7W\n    ftuqgCWxS6/T9hpc/QJ6UryAPUPFVTGZWfriPwOpgCGukVbQfFFgs4JG4DFJNsv2vHLWZgXN7Zxt\n    VtA8L5gTxZLgHax/Jn0uWS3iBpbjROjKamKeB6wEMUxth5AKYLU+TwvMPF1gev09FOddJ5JHXBUc\n    /uIEhz9aJq/X3bwucmB24zxuXEdcGhSzArPbExRnRaVKifs+LJ8nGHxtgKM/nMTc34iIK4RkPFjm\n    AX9juB5H5eeDD+osx+T2BMUsOrpEXA4Uz1aFVLn5NxCq/h1//wBHvz5tklISEWHk/mJVRM1zf/Wa\n    vFit73PDhcuV+8vX4nx9z9frShSDU3F4zmaLkiCWKmDuUsbdy7A6P4ZW98q9i2UBu1/9W8f6mRfX\n    c5J3uH79+nzpn8HSt21vKESUMITCiB0fQZXIZpf6V+6h2dS/8nqJOupfm/Wz7CtE/QvRTxv1bwr7\n    fmQb9a8rto/OV6FK/dtEqdtW/evaz++S1N2k+vcFunFO5ei6v03ibIP32qZQdE8cktsRwJv4IaMK\n    uB36+PC5bCrgKhK5jgo4FFUD4baygJf3DsuzaKIC9lXdSfgIWU768jZzcb3tWhvk5JNfa6te9E1e\n    aeLMCd4R/FWaBJvFj23y7rKC5q+ZFgryGp8KuMoKWqqApRU0J4FpESStoGmxNYK5kOLEL38s84Cp\n    opcrhGkxOBBVwYVYEBIRPESx+k/nAWcWQphqijmRPECO7NFzTP/8AMXc91sVEWFHMkpw9No1DP+1\n    2mKPb9zRo/x5gentc6g0blxH7Dlyhfm7M8zfr85Wl7OVBMBwvFICxtzfiIgrh+E3Rjh69QTJUVIq\n    pvIRwTSuLh7MMX93BuR7sWkTEeFEMSswe+scxVle+1rFc3/HURwSUR+hub+cwPXl/ipLe5n7O1hp\n    hKWtM99LGLA9g8Fq/2W5cjIVvnSMK4GlTbOOpipbP9NeiUsh3NT6mWCzfrbZOHPrZ/sngX0viqt/\n    bcQw3/fyxZnZFL0AnMIL+biJ+rcsOLG/Htm2Sv0LmPufkhAOUfKGWj93ibbqX6BasORS/zYRVHUh\n    5qpLFPu4jLZCtRcd9CGxCXFgU15q1+yfLxN6sH8G+lIAb9IXexM4C2jT9Jd/EyTwJiwD6qJLFXBX\n    qDto2dqHWEG77iOrsNqogENye33XtlUB2whf+ZpCVMAcISpg+Vi+ZhuBy+1u5PGR5zXIczbrnMXq\n    VUhw6xwbeQzHdaQCdllBy2tcZDMtcGxVorwClRYQNoUv2DFeJcsXOpyA5vfgmcI8f4dbQSerCmCd\n    /QtjMUcLPG3/BHCilyqDc9a3rvUt5wEPWXYwX3y68oDnf32I7MPPYh5wRCMMrg1x8topBqdhecAE\n    +utLH8wxvxc3riP2GArIHs4xu72cFdmKHeix7bc85v5GREQc/tchDn5+uNrSKI+lSnwR6PNmdnuC\n    7GF1AUpExM4iV5i/O0X6vi8cyQ6FBIOjBEe/O8XwGzH3N6IZQnN/wYhcm1MXz/0ly2iyjy7Wa/sy\n    2Ttiub/8+ACaIKYicU7C6n2NdtbPcr+pK+tn1z5KiPWzclwjUWX9zNsMPZ8unDzl74di+2kyl5ff\n    W5K/LgUxYO4XLoDW6l9OKPN+XM8lXOpfGw4txzap/iW0yf7lCCGLm1zbZ/bvttA0/3ef1b+bhEsg\n    Gu2fDexHld9lVgFvAk0/NHwfUrukAq4zQHSpAuboykIa0IPzLqqAbTkWVWSzbxI1h39S1YUK2DXh\n    c1lB0z04ySwnsvK12EAq4IU4RgixgrYRp1VW0L5FQl0r6BxuK+iBeE1yUcRJXm23tLyCFky2POAB\n    O8+toHnFr7SEJhWwtoIujAWoKw+YE8XcToqIY16VbOYBLxe10zfuL/OAIyIaYPy9Qxz+8hgY+q2g\n    bfZ9CYDZmxdx4zpib6G+yjC5PoFig6Q5Uvg2shOMYu5vREREAhz/9gTj74W5AJQ0VAtgcn2C4nl9\n    5WRExC4gezjH9LY999dn/6yQAAPg4OdHOPyvmPsb0Qwy95evrcuZvXqNLnN/E1aIPWBrftnHgLWV\n    eb+23F9eZM4fc8eyESNypfUzAMOxjKt1Q6yfYekL8Kt/ZYG+JHqrCGNerK/vUc+JTkOVXoPcu3IR\n    rK6otZHnNVB/8hUQxp7HTdW/tnuGuhy64FL/thHpuO5L+70h6l9fm5DsXwA7qf7tAl2of4FuCdtd\n    zv4NEUCe9f7qdwN9OSN3rP4FuiCA98Treo2uA6W7wL6pgLsifzcVsB6qFG4ygLRRAdvaNFEBu0jg\n    EMWuC64KsyYqYNlvFWQFnkt121YFbIOtEpFnlsg+bFbQvIrSpsytyl6BuE5Oxl0LC4K0h+Z5MU2t\n    oKm9ywqaZ+jw+wzY6+dW0HQvsoIm0ldaQXOb5+X3ch4wfZf5vQm0kthVZczJ4ERUJNvygOm6fPXq\n    s1nMA45oh8P/d4KDHxwACM8Dpr/KIlWYXL+IG9cReweVFpjenSB/wkeEUCxzf49j7m9ERASA5GCA\n    49+fYvj1AUICTLmvDADkT3JM70xQpLu3RxAR4YN6nmFy/QJY1PvdpfnmwffGOP5tzP2NaAhL7m+y\n    8gaTLlpUWO3P/dXHab3N1+w6D5iUpYVwBivYbFJbPyera8rF42ZBO/9u27/geyhEFPP9HJv18wHK\n    dtK2HF+X9TNB7in51L9YtyzvYbmsn233sgkxqnJ0fUIJSRS3sX6m67T6136PrtS/LvJ1k+pf3+uo\n    QoiwKAR8/3qX1L+unbjQ7N9N8RJ10bf6dxM81CawKWHopmQ/3+zv93E/FMA+bOof+yygTZce6Lto\n    20ygD9IuiGDXh21o3/Rh34UKGPAPRn2ogLvIAq5CGxWw7xqwa12TFurXNZmiiVuVFbS0gQlRAftI\n    YFtfripFgnwNPtj6smWrhKiAbddVqYDhuReHbdERagXNYbOC5u0GpdfDs37NzGBtpbQ8R1bQPA94\n    ZFHw0nnTekp/FeJ5sqo8Hq4sqXgesK4zphzhfG1dBdaG8oBnf415wBHNMBgnOHn9GkbfXv5Fu0hg\n    qeKgZ9mTDLM/XUDNoxV5xJ4gV0jvp0jfo5G+zjwnwWAMHP7mJOb+RkRErDH8ps4DrsNm0dg6fzfF\n    /IMUKHZ3/R0RwaHmBaZ3JsifLFd4ddS/ADD8+hDHf7iG5GD/9wMjNg+Z+6vtm013LU76FpZzrtxf\n    sn7m19FveYFy7q9ijzn5S05j3JFM5v7yYvPVTwdSDFOhu7R+lm5nQNn62fZdvIvG9dSOu7fJQn6C\n    VARLwppfYxMfuCLIlopofZysn137VHyPy7ZXRmKKheN6iVDC2ZYDbNuJGUF51b9ztFP/2sjfvtS/\n    PuvnOtm/NvvnNurfJgjtp0uJRZ8OplVoYv+8y3xQn+hSsLkJ++c9Uv8CXRHAUQXcHn1XXzxHsw+R\n    pl71XcNnAx0yMNQZPLqwc26TBSzRtwo49RwPVQHLSU1bFbCEbfJHNs2cBHbZSdssnl3wWdqEqoD5\n    Y7IW0mSvO7vFVn3JJ+VyoSHJWJd9NC0gbNfIqlQO3c4kgW2vRUEvovhih+5PC68hXIstTiDrhRev\n    2NUWT3qpB9ZG5gHLSmNNL6vScyKJyeoZjESmPCJu/8wVwumfP0P+UcwDjmiGwcsjHL56DcPj5aZ1\n    nUzgBED6zgzpg7hxHbEfWDxaYPbmBFDVG9QmEiABxj89xOFPo11lRESEifGPjjD++ZEzD9gGxR7M\n    bl4g+zwW80XsAQqF9EGK9N2Q5EcTlPt78uoJht+IhVQRzZCffYXp/3cPyHXhNFf7QpC8SamoWhdn\n    F2xNTrm/vKCb8n0T1mbkiIRa7m7rPQZOBBNxS4Xlbayf+f6GvIYXw9exfpbtpFtcLtrQsSHbpym3\n    cyuGbSIDDb2/5RIs8D7k40XF+TbqXykOcVk/L+C3fq7K+g1R/4aiC/VvU1QJiqr2rG3t+D72pKKt\n    RFfqX2rbliTuQv37QnzfRUguqA3/1KXwsS02JQi9JNifij8fe79L/+ht/hjkH+E+VH3sggq4CbrM\n    Aq4aAKsg+5zCHKjbqoBT+ElkQhsVsK+/KhUw0EwFrM9p8IlelQrYRuCGTFJd531W0PracuUlt9mB\n    6MNmBc0J2CHKhK5sx4/bKkiEWpP8AACAAElEQVRDraBtuTQ2K2jZHyeBed9UfctpWL1Yo8VZYbWC\n    rsoD5qpgnjVkywMuK4PLecA8/5c/X5PQqsDk+vvIv3yKiIgmOPz+IQ5+cbTOM7WRwC4VMG1cL77M\n    EBGxyyhe5Jhev4Ca0XgQBvpriLm/ERERLiQJcPLbY5YHHFpMtfo8mipMr09QnMdYhYjdRvb5ArOb\n    F+tBNFT9S7m/458fYfSj423/GBF7imI6w/z2feRfTQGxZpaZvYA99xcw1cFyjQ+2vue5v0Toytzf\n    Ecv9pT2FRBwjJTAnZkOsn/neSoHlHpOLnNWOaeVzrvbyGF/NSWc2n/WzVCY3tX4GNDHriyzje198\n    n80kbuHcI7PZNRN4DBtgV+4u+/erf32wZQGHqn9t1s/yZ6drdkX962sXYue8b+rfk45e7zZwDap3\n    ++ddRF2h5rZ5wD1T/wJdEsDbVgHX/cffRRXwJtAVqbyN6paqD/GqwWTTKZ27ogIO6cOF0MkN3StU\n    8UvHfFV5Ej5bZk76cszF9a6JoCSB5cT62DGpDU0tHFru3dQKWubGhFhBK8u9fDZFsJyj6lJfe54H\n    bKtSdWXgcDUxfXE1sG7DiV4YZK8tF1jBzAOWKt8BVIns5TbSMjuYW0ubJHCBbDLH5MY9FBddeAhE\n    XEUc/eoUB/95sH6uaugji2mB2a0LqEncuI7YTai5wvRPU+Rf6jKm4Gtj7m9EREQAKA948HXa46gX\n    brr4PEP65ylUzUzViIhNoTjPMb1xDjWllU0YeO7vyW9PkcTc34gmWOX+zh98yWyazdxfctLK2VpZ\n    5v7SOlzm/iqULaMLViw+Wq/VASJ+TRcy0/qZ7wto62eC6UZG+xiysB2A4XImVb9m7nCZkB1a2vHr\n    qf9NWD9z8D0jc++r3Ifco6qyfqbHvv01iP7MV2Cqf/njbah/Q7J365C8+6b+5dgF9S8hdH+/z+xf\n    3reNr9gFR9VtqH/Ptv1D7yl6zP8F+lQAbyog+bKhTxVw0yoS24dW1xU1XWUB14FPBVw3C7hrFTBQ\n    VgE3IXABBFWd+bKAXcfbqoDpenMS51cBc4SogOV1LhWwDVShuEBzK2heXTlcn6eqTLcVNIfNClou\n    HPqwglainV7E2IhZ22vh/Wv7ZyJ4ZR4w38LgfUgraJ4HrBdheqGXrGyhcnGNaSUliVxuNVVW/9ry\n    gLUttFYW5w/PkP7tAbCIFoIR9ZEcDHD0+jUMv6kJLqkEdlHCCYDFp3PM3o4b1xE7iEJh8WGK+dtN\n    ZjIJME5i7m9EREQQht8c4ei3J0gOaPwMYbrUumX6txkWH8VYhYjdg1oozP48weKRm0qxzRNpLhlz\n    fyPaQOb+Lglak8CVhdO88Frm/nKi15b7Ky2gbbm/UjEsrZ+JaObxU9x9jO9XyCJ/F8FaZf0syVze\n    d5X1s+0vu0vrZ74/xfvjjnS+fS8bfCpeV19NrJ/pOpv6V74G32vmffJ9wzpCljoCGdex0L3Ubat/\n    ge6yf0NRtbdf9XpCuIouyF+OrgRyfbvA9h092hRdq3/7zv/dQ/Uv0DUBfNlVwGeB7XbJE92GrlXA\n    m1QDtyWeN60CBqorq3yDbqj9cxcqYB8J3KUKuK4VNIckWflzrgLmbaqsoG192Saqvsmt7TEC+yLw\n    ibctR5hePU3kzUVGuBU09QnUt4Kme0gS2FcJy/uXCytJ9BYwiWhpBW1b8PH/eLWvVgcrUF4QX2gq\n    tuDUub/6sUkIa8KYrtUksrnQnd39DPOP/wmomAccUR/Db4xw/LtTDI6Wm3UJ/JnA8pNkdneCxcdp\n    HXFlRETvWHyZYXpzYvqWB2GZ+3sQc38jIiJq4PDHRzj4+SHjfsNJYFUAk5sTZE9irELE7kApYP5R\n    ivRv0/VvsxxJfeTv4DDB0W9j7m9Ec1Tl/nKSl758ub+0O8AzgpffAZn7SwXeShznub+a0DWLzGl/\n    QReRm5FU1BaAUaQurZ99ubyafMW6nybWzy71b9/WzyPRxkYcE1zqX77PY4s2c0GWzbvIW5kD7Pok\n    G0HVchkE7HuV9POEqH9Dyd9QtFX/zmDfR56yx9vI/g2JYQzdr2+r/u0C+6j+jWiGSyJw7bf6r+s3\n    qW8Wf1ewi1nAm/jwaluFs20VMMeE9RMK3ufUcr5KBewji9tmT1AfEiEWyAdiEsVhUwFLSBWwe1Lo\n    zv/1oUoFzNvwe/OfZ+Hoz0XkuvJW6lpBS2UuHPezqYCbWEEP4F/08J9JLqzKil8zX4e/pzwPWOcD\n    6zxgXrUrc39lXtByIcjzgGFkAA+hk4jNRWl54Smzjfj39cJT5Zj88T7yx3VLkiIilhj/1xEOfn7k\n    nKK5soATACoHpjcuUDyLG9cRu4GlXeUFiotlUUy4sXmCBArjV0Y4efU45v5GRESEY7DKA/4uXw2E\n    e94WLwrM3pygmMZivojdQPFkgfTmufSw9WJdQJgAhz8/xMGPY+5vRDMUsxTzO+XcXxhrY9Pmmat4\n    edG0LfdXqnkH7Dqe+6uNz9XK8QvQa3/uKGbGUpnEbdn6mTuUKXaOF7zLwneX9bNL/VvX+lnfv9r6\n    mRf3V1k/83M262d+3Gf9DLjFD32pf/U5++sJsX6eO9oCZetnCZf617bPahOF1bF+bqP+lU6SgH1/\n    eZPZv5vCvmf/As2dW/tGX0LHmP27xOP+X3r3BPBlVwGH4iqogPmH66Yqa+R9JUIGqL5UwF0QxjbY\n    BnAffCrgFM1VwC8FTnZCyGbbZIsmdTbyVk7e3Cpgs42LEHZZQdtUwNwK2pUj7Mo74dfTY5s61jZp\n    l7BN1OlxlRU0P+ZS9UL0ZbOC5u25SS1vx6/nVs3mMRh2TLI9fy1UdZuXXhtf7GGdCWSSwHrRyEnd\n    ckawPQ+4YO1psUrXDFe1tjIPGCiQX6SY3XgPahLzgCPqI0mA49+e4uB7+hOtjhV0/jzH7PY5VBo3\n    riO2C7VQmP51hvyhHrlCZp8Jlr/jydeGOPrDacz9jYiIqI+jIY7/cILhy8uZYrL6vw80tiYA5v9Y\n    YPHOFCrb7TV9xOVHMS0wu3WB/IWe11Wpf/m88eC7Yxz95hRJdH6OaII8w/z+x5jf/5Ipb2mFbs/9\n    lSpgvjZX6wJqvR4fQKqA9Xpd5v7Sf3ofwbSHtlk/A1irgbn1syRcee4v2LVyn0M6lnHyl+9ntLF+\n    hrgWcFs/cyc5uiZU/cuv4yrnKutn+b4R5H4sv7eNsCXI+0kRiM36WaLqNXPyl+BzL2yj/m0rvvGh\n    rkukxBFU7djCvtS/HF2rf13oOvs376C/q4o+yN+rIhxtgDgLBPojga8CNmn/HIImg8auqIAnqFYB\n    A2ilAm6DOnkXrnv7VMAADBLYBZcK2GYFzUHPRxWTWpcVNCzHXBNfV7+AudCwZbDw9j4raLou1Ara\n    tu1e1wqaFlguEjjEClpX92LdVlpB6/uYRDGRubyNrg7WCzu+SBxxdS5MK2hOAusFpW4/XGUDD9e5\n    v6pkaTVYLXiLVR4wtZl/eobZ3z6MecARjZAcDHD0+2sYft2dB+xD+mCO+b0ZkMf5TcR2oBSw+CjF\n    /C98NlP9+7j+LY+5vxERES0x/NbYyANOKkZS+Qk1vTNF9kkKFYfSiC1BZQrzd6ZI/xFiZLq6hv2W\n    j14eLHN/j2IhVUQDKIXs4ReY3vgAWBdCF5BuWVW5v8mK5OUEbw6z+DoDWFG2LNo2nbmkenhZLE5K\n    3sLYE5C5v3yvxNy7MPc/TIeyMBe0Kutn1zFf/Fao9bNLSODaT5LWz7Y+QqyfbUIIalvH+pn3z4Ub\n    XCiyfG6/d4j6N+T5gfhO2CX1rw+2PclpwHUSoRbRIfDth9dVGPvaS6HYNrmKug6qfbi+yj7b5P/u\n    usCxT3Bn4z1W/+JbUP0QwPumAt5F7IsNdNcq4NBqnLYq4L7QhjC2gQbry6AClpOp0EkYQVYBuiae\n    LhWw7NM26XSBq4Dl/WxVjDYVMH8sqz1HsE/0XRNnTtjyitQ6VtDyXnUWKzYr6MLSXlfZwqIyNtXA\n    mlQuL9Lq5AGXM4D4otEkgcnumX/xRaorD5hfKyub+UJ3ducTzD/+J1Sx/c/viP3D6JvLjevhod7I\n    45t6ifE5AHZ8idmbF8gehm8YRkR0ieLxKve3hhCdx3XG3N+IiIgucPiTIxwaecBV0CrgIgMmNyZQ\n    ZzFWIWLzUApYfJIivWOWuPvUv3yeuMz9PcXwW7GQKqIZ8rPnmP3xHpBlhio3EWpf6aA1YE5ZMvd3\n    AJ37q1bfM4CpeE2HLkn+jtYTy3Lur809jBemmwSt3l+Qyl0qPufHXAXudayfbapdVWrv3oNxWT+b\n    r6e8fyRFB7brVMUeVMj+l01o0YX1s039K19DHfUv9WPbr3QpgkOFMNtU/84s7ST521b9a0OV+jcE\n    m1L/doGo/vXjLLDdvgkxt81zdoD+FcD7kgPcxy/fLlZJcD/5rkhl/qG3C4rgLgePrlTAoZAqYA4+\n    2IeogH0kcFN0MfnxHauyguaQJKtpBa1VwLwN9TmyTLRdfdsmsHyC66uA5KhrBW2DTQUMoFTFKlXA\n    sh1XIdusoMt2y+HW0fWsoPVCzJUHzJW9cjFnywMeomwFzZ/nrLJYifZVecC2SudCVDdb84CfnSEi\n    ogkOfnyMsdi4dumX5KdGnipMrl+geJ4jImKTUJMc0zcvULzg7K9//pGwVqNXxjh+9STm/kZERLTH\n    Kg949IomwUK54ARAflZgensSYxUiNo7iLMP0xgXyzBwjg7DK/R3/JOb+RjRDMUuRvnUPi2cTyNxf\n    HX/EH5trbsr95UXTS+jC6YGxhs/B19sU4cTdvXju7wDmfoLNGYz7KPH9CE340lmp8rXva8j9kabW\n    zwSbHbONyK2yfuZ7R3Wsn/lzX2Yw3+9yOeDJvbHMcb3tuRum9bOrlGUEVUv9C8f5OtbPvD3HNtW/\n    odbQVeiC0CWEqH9D9++7EHp1Yf9chcum/u0DTfi3yyD03Ba+tXy/+yOAt82O9/XLcbbBn2FfVMDb\n    Qhcq4Iua7UPQlwqYo+ng3pcKmF8Tcn+aLPLJWMj1UgXsqvQbw53/60OVCpgjxAra19/QMmG2Td5t\n    VtDUlleO2qyg+TW2RYXrZ6N+urSClvm+XAGsX7cqVdzarKDNa+Uicrk4LIBVFbLuj+cBD4T1MxG9\n    w9UjvniVmUR0TOYB0388D1hdpEhvvofioon5TsRVRzIAjn5zioPvmkteIoFdWcCE/EmG2d0LqHnc\n    uI7YDFSmkL49w+If4ds7fGM75v5GRER0jqPV58rL+nOljhX0/P05FjFWIWKDUGmB2VsXyM9y7++q\n    S/17GHN/I9rAkvvL3bB4Zi9XAiuYWb5UbM0J4oIVW5tOW+XC7bK7F2Bz/iKXMJ4NLF3FbORveX/C\n    LEaXqyeb6xn1V8dNzefORt9t1s/0mrn1M71afr2Ey/o5RP0boq6VIojMcZz64+DRaLasX6yf219P\n    1WqD92lT/0rrZ4m2Api6ZLKP/K2r/pWoq/6tEkNRny7UJYurXouPKD4JfJ/bom/17/P2XUR0CBK0\n    9slvkv3zN/r/He53RrhtErgu9k2CvkvoUgXcRVXOBbrLE7isKuAqwtU1CXFNgg4CJ0Gyvc36OVQF\n    DMCjAjbbSELYpQK22TjblbvNrKBtfVVZQfM2gF0FTAsebgWdi+tDFht1raDlQsNlBW3LyiF7Z04U\n    2/KA1WpBYC54ynnARPbKPGBq48oDHq+ye2kxyonc4XrxmrPFrGkPzfOANZ2sH8//8RTp3z+EyqKF\n    YER9DI6GOPr9NYxeNudsVZnAdHbx9xnSBykQrcgj+oYCsk9SzO5Oyycc4L/FyTjBUcz9jYiI6AGj\n    b49x+OsTYKwpM9coykk1ajN9cxJjFSI2g1xhfm+G+X3/at1F/o5eHuAo5v5GNIUj91eJ4mhX7i8/\n    P1ifoyJqfd1A5P5KsleSwUPI4m2d+0u20ERR6/7sub+60L2+9bMsYPcVzPP7UXvZjh+rIox50T/7\n    B1vf36X+tRHDtnNVRK9N9MCd8VyKYFe/8niI9bOtD5/61waf9XMIYVu1v1nnGkDv2bZxa6T9X75f\n    3HX27zbVv/uCXRDMda3+reNse9bTzxQq8OzLMXif8S39ngw2EjbctQ10KC6DCliiCxVwWxvobXyo\n    9WktHWoF3Qb8+rYqYNvgXgd8YhFiJeLqI7QSznX/UHvoecVz24QyxAq6qg863rUVND/GVby2dq5z\n    LitoQhMraGW5JsQKWla8EvEaYgVdXny584DpOS3slu+LOw/YrFYu5wHzXOBstQgt1q9FW0HT4jVZ\n    L2Z1RTOvWLaRw2Ye8MfIPnkU84AjGmH0L2Mc/PrUyAMGqklgYClYmt28wOLLWIAQ0S+KZxkmNyYo\n    jIEn8DMv5v5GRET0jMOfHuHgp4dQiR473aOoMgi2PAUm1ycxViGid2QP55i9udyh4L+frtHUyP0d\n    Jzj8dcz9jWiOkNxfQLtgSRUvj1BaXmvm/haWdbvePdAF3uTm5cr95QQrXW3uXSzb872KIdy5v7x9\n    HetnfryJ9XO5b7v6l/cj7yP7DLF+zlhfLtEBJ29dNtC2fSoXXFbQksR1qX/l/WR/Nutnm/rXdR+J\n    usIX17EQ62dXH3XVvy7sovq3jvVzF+rftkIzzkn0YSV9VdS/+ya83ISwdQPqX2ATGcBXXQXcNge4\n    L6/2Pj5c+IfgprKAfR/2XaqAgXrWzpMa17ruFUIUd6ECbmoFfWhpZ0NbFbDtvK8acGRMHlHqlz92\n    WdF0YQW9cPQnJ9gqcHI+QrUi2GYFLV9711bQdNyWB1zHCtpmn8QtmHi17gJ6qUiZPzYS2JUHrG2g\n    NLlL96AFLM8MtuUBa2K4YAte0/aKk8PIc0z/eA/5011L4IjYFxz89BgHPzlEInarE1TnGappgdmt\n    C6hJ3LiO6AfFrMDk9gT5WbH6nTTJExv4723M/Y2IiOgbyRA4fvUEB6+MzOO+azgJ/CTH9O4ERbpf\n    +xsR+4PieY7J9Qvk4ndM/sYl67VVwg/i4KeHGP805v5GNEMxS5Hevu/M/R16cn918fXSr6sw1vx6\n    DZ6wNbrM/R2t3bU0sWvGQOnicb6voFb7AwNo1zBpHc0L3wFJ4JpuZS7rZ46urJ+5IECSv/wam/Wz\n    zga2j0l878fc59H3D7V+9okaXI996l+X9TNdZ9vvk+SvJI4lZHwcEK7+de1fKks/LnHMprAJ9W9d\n    hKh/2/bjQ598xClUZ3xK1zGf24wNPdvanfvBJoSsfQtyv2X+PmwuFGRbKuC+cLbFe+9qFnCXpPIm\n    wtk5NmE90UQFfFQxiHehAm4KJSY6KTtuu5+cJPFrOGQeB1Bt5SKtlk0raLcK2GcFbevLNZkNmRD7\n    rKBtal5fBgxvI8lXWbEqz/dlBS1R1wpa/gyuPGBa1BEJjNUxsnvmFtD0PvBFJC0uc6NfvcDlecAD\n    Rhnr7F9tBc3zgDnxS7bR3AoLKJC/mGF2+x6KaVPtfcRVxmAIHP3uFKN/Nzeu6a/PbWW5bJN9Osfs\n    7SnUYvtziIjLBZUpzN+dYf5gHkT8AsL6Oeb+RkREbAjJ8erz5mvm542tmEqPr8s5YQKF+d9TzD+I\n    sQoR3UPNC8zuXiB/EubYIl1gDl4Z4fjVUwziUBrRBJT7+/4XpdxftVov18/9ZcXQq+9D5MhQnfsr\n    n9tyf7n1c93cX2nN7LN+LtC99TPtd+j7i38O0F6Pa59Kk8ch1s82ZzmfE515J7vgQZJzPgK5KquX\n    342Tvy4vA599NF3ru7ckjkNVvTYcWo5F9a8fXe2/byP714U2Tql9qX83JT05C2zXRHD5bEM/gw37\n    JmitwJIA7pt17vpN2xVf77Ntv4CW2DcVsKu/rlTANAjtUhawC11nAXehAq4L6s+mAqZ7hqiACS4r\n    6DHK+b+uPuS1vG9OAstl+bFjUlxlie3LS+Hgk3M5wddVn+UKVrVaNIRYQfNr5LEQK2ibCthmBU2K\n    3TpW0K48YG4GRSrgAcw8YH5O5gFTdhDPAx4yEljaOcs84IEjD5jUwbQETdjjxYePMX/vIyCPdrwR\n    9ZEcD3H0+jUMX5J5wNVQAGZ3J1h8nAa78kZEVEIt7SrT25MV+WucKoGTLAoAxgkOY+5vRETEBrHM\n    Az4GxtUxChJKxViFiB5QKKQPUiz+vlyV+1XpZfJ39LUBjv7wUiykimiGitzfRBC6PPdX5gLz3F/u\n    kEVZv7RGl+tzTtombF3uIn/5XgOpf809EHvubxPrZ0n+dmH9bHNl81k/55b7yD591s8j0b6J9bNL\n    4OCKTeP9Gb9ubG+Lq39d1s9VZHKo9bNNaOISpPji7qSwJSQGrwousrmK/K1S/zYRHrVFV+pfQl2y\n    2MYbdCUwc6l/d4H83QWh4GXBZROwrrA5BTCwnTexSbXArnmS26o2uvrjbvNh41IBb1q9u0/oSwUc\n    QgJLbFsFLK8B/Lkcc9hJYFd1n8sKWuZ/+FTAvkpFOTF2KYJtE2Ng96ygB7AvJMD68VW6moQt1n3y\n    ilm+UJMksCR/JTlN33kesMsKmshXviDl2USSDOZ5wFzV68oD5speInfNSuaCLZTN5wkKTG99hOzT\n    z2MecEQjjP/tAIe/OsFwFH7NepswB6Y3LlA8ixvXEd1AfZVhcn2CfBGWVcjPqySJub8RERFbweHP\n    jjD+8TIPmH9eVcUqJFBQU7UcS89jrEJEN8i+XGB28wJ5g6XBcAwc/Po0FlJFNEaT3F9p/azLohWo\n    xJq7a3EHrSEjk/m+ACeBXbm/em/BtH4ewq7ulfsTNutnai/3Lbj1NEcX1s+A2/FNWj/za/j5ptbP\n    vL861s+2vTba4+Lkc6j1M1Amb31Rb/LeVRm+HLZ9SHotIfuiqaMfW+Rjl+pfH0LdILtQ//JjTdW/\n    tBdeJ/vXh11S/+4iulD/hkSanm37B12ha6HoptS/feX/fqvc7+YI4EsmnV7jLKBN2xzgvtFnpcgu\n    qICB5tkBtn5CVcCugbPOawlVAYcM/j4VsOs8wTc5kcd8JLDrWltbmwrYhbGYgHLYrKA5JIkcagWd\n    wZzcjqBqVUoC5kTZvG+ZjO3DClpe34cVtG2BVMBcbPHXAce/BbXXi8Tl8xR6oThYvUdUWUyLtgJY\n    VxBTtaskiikPmGcH8yxfBSCDaWFlywPWWUbLhS0nno084DfuIT+LecARzXD438cY/+iwFuFGVtDF\n    8xyz2+dQaYGIiDZQaYHpnQmKp3kt22f65FzaVcbc34gWiIVUEQ2RDBMcv3aC0b+PYDOur4pVyB9m\n    mP5lFmMVIlqjOM8xuXEBNfXPy6g4wShYSIDxjw9x8LOY+xvRDDz31yyO9uf+KpRzf8HW8mYxti60\n    duX+ciLYlvs7EG04YTtGubBb5v76rJ/1eQ1XFjAvTtc/p9lP19bPZrtq62cOm82zshyzweVsJ6/z\n    lRX79vKkKMN0/9PoQv1ru6cNLvWv61ga0K4KTdW/tnbbVP/WdbwMQRfq367QZfYv4Sqpf3dNaOnC\n    poSrfTsxWzDojW12oas3s28b6F375dxVFbCrvy5UwF0piesMGlU20IQ2g1to9RRvX6UCBppZQR9A\n    OZW5EnVIYBdC7mWbpNFEz6UCdkGqgOUk09WWwzdp3YQVtCu7pQsraLn44IukJlbQOeykscsK2tU/\n    r7515QFLK2h+Xi4ObZk/rjxgsneme7jUwq48YG4HzW2jwRbJCgrZ2RSz2/dRzEL++iIiTCTDBEev\n    XcPoO6NaJDAhfTDH/N4MjaQmEREAkCss7s2Qvke5vxo2IsU8n2D4tQGOfh9zfyPaYfFogeJFVGFG\n    NMPgZIij359i8BIl/Jpwk8DLmd38r1PMP0qh4lAa0RBqoTD76wT5wwWWikk7jOgEhtG/j3D02rWY\n    +xvRDCL3V1s15+ti6aa5v9JFq2AF0fmqVZPcX74XQQQfdwlz5f5y5TBQ3juwuZbZrJ/J9QzYjPWz\n    vI9N2Sutn3kxv836me85NbF+lupfoL76lxO1BJv6V5K/Vepf295gW/Wvy/rZd22V+pf34zvvgo0c\n    tu0Tb1L9S33UOV63H8JlUP/uOmm7C+rfZ4Htovo3CJu1gL6sOAtos+sq4KZo43XfFH1nAROaqoar\n    VMBt+ibQ4F5XBWxDqAq4qo9QK2h+nt/fpwKusoLmbaTKlj/nOSIc1OfI81pkX7ZJblsraD4h15bP\n    9ayg+cKgbBVkwmYF7cqU4f24rKD5oqgrK2j6zklg/v1w/X7qf39ayI1WWUOcNLYtLmUeMC1euRJ4\n    uQC25QEX6wUyt3r25QHT1+LBl0jf+zjmAUc0wuDaEMevn2JwbYDQFEPebvrmBNnDeeCVEREmFo8W\n    mNyeNpp5DMbA0W+OMfrXaFcZ0RzFVxmmfzzH7E8XKOaXc50V0T/G3xnj+FdHGIzLuaouLItaFFAA\n    05sT5E/iPC6iPpQC5h+lSP8SNpaWyN+XBjj+/TUMTiL7G9EAHeT+8nU1z/3lUUgD1lYXRtfL/eW5\n    wdL6mfYYuEsYQe5HuHJ/bdbPsi/a5/C5o7mspttYP9uK+13Wz/yczfqZ4rOA8l4SHbM9bmr97LoO\n    MIlaLvgYQ2GMMOtnm/qX37tK/WtzMnSRul1ZP8t7yfvRfmyo+teFI6gg8pf2rl37012repuIs0Lh\n    4gm6Eqe5hHNNOZE+1b+b8Bk8q9F21wSWLlyW7N9v2d/vJQH8DaiNyI+JRd8XFXAdnG3pvl1VjXRd\n    fcJVwG2qZlwf1rvgw9+VFXQTFbALTVTAQDdW0IeOtr57uY7xyVmIFbSsFrRVHfJJ5RzlSSH1MbL0\n    4SKUXVbQrutsfQDlqk2NMhlbZQUNlG2CAL8VdMjiRC5oyvfRx3hlLEEupiQJnLP+BitCVt6vXF2r\n    F2x6QWPmCA3A7ZeXVtBVecBaB2LaQMuM34FlcavYNa48YDCyeHbrAyw++xJRPhLRBKP/OMTh/x1j\n    MHKrQ2xQWNr3Tq5foHge1XMR9VA8zzG9fgE1s2nmNMrKX537e/DTaFcZ0RxqXmB69wL54wXSt6dY\n    fDiLdtARjXHw38c4+PEBktUHVshvElnxqhcFpm9eoJjGWIWIesifLjC9ebH2mQ0t5gOWub+HvzrB\n    6DsH2/4xIvYUrtxfUuiG5P7yuCOKTOKF0DL3l6+/R2vi2HTpWoJbQGvnL0n+cutnXlQurZ9tal6e\n    +2u8L45jA1RbP/P2XVk/632fautnm9LYRur69srMn81t/UzkrwsLz3ObK5/ez9PowvrZJihxCU9s\n    +5S2tqEOijZUqX9DYBMBTRv0I/eXq8jettm/oYjq3+1jnwSMXfGCl4X89eBqKIBDZeMSXVcptP0j\n    6rOKo2sb6G2hCxUwrzSyte8qT5ijSe5CXyrgplBQrSdNshIQ4nkdK2gX+Sr1Ri5baN+kVSKD+351\n    raD5goX31dQKOkO1FTQh1AoaqLaC9mX/2o65VMOyf27XRFW7ZAXNSeCldRLZQ5s5QkTuUmawzANW\n    K3I3g5kHzM2s+cJWLn61/XM5D5gvZAsoIMswfeMesrPL8ikcsWkc/uIEox+aJTihn+j5kwzTuxOo\n    edy4jgiDmhdI/zRB/mW+2uizQx4nfcc45v5GtITKFebvTzF/dwZAAUohvfkCiy8WrfuOuJpYxiqc\n    YvhvlAccqgRezbU/WmDxzhQq258Ns4jtopgWmN26gHrhH0sJ/Ddrnfv737GQKqIZfLm/RNaG5P4m\n    Ym0rc3+HjEDW6+ly7i//LnN/aV9BrR7byF9f7q/L+hmA1XXMZf0MuIvlL6v1M4e0fubHZR8SVdbP\n    XKhhew0h1s82+PYb6+x/dqX+DbV+3pT6lxBi/ezDhPXTFXZN/evCNhxROfogknfB+nmbuKT2zwAn\n    gGMWcHucBbTpo5Ji2ypg34feZVUB0+DWlQo4BPugApa/36n47gP1F5rb4TIuDbOC1ipg2WdTK2g+\n    AecTZIlNWUEDtgrVzVlB0/cqK2j6Lq2jByv7Zt5O5gHzxR5VBS9Wr00uKPmiciDOyTxgblPFF7F8\n    ESwrpXkeMK9u5vnAw/Vj0/4qf3aB+Z2YBxzRDMkowdHr1zD8l/A84ISdn/99ivRBGtVzEdUoFOYP\n    UqTvpKsNa/vvjIv8Hb48wNEfYu5vRAsoYPHPFJOb54BieYIXOaY3X0C9iFa8Ec0wOBni6PVTDE6T\n    WrEK9Ck4uzPF4uE8GrpEVEJlCvN3plh8FBbDYZC/0Lm/ybCOZjgiYoWK3N/RSu3ryv3l6+EB7Lm/\n    uihar4NzmJbP0vpZ5v6SIxit22m9vnT0cuf+SgzWr6s699dn/exS+vLv9JjIXdceCYCNWz+79o7o\n    mO2xay+sjvWzrV+CzfrZ154Qqv7l533wqX/l7kwb9a/sx4YqQU/X6t9Q6+cmgiXZfwipewzlbWcT\n    fPVJ/hK6lGpcg9prAd5ZzfZ92j9H9W84Pt+2AviqksC7iq4/hLb1obYJFXATtLHUcLWzDfaHUEEk\n    sESVOpXDRQKngcfoWjl5qpqs8Umi7bycDLomjmOYFYY+K2gOnxW0PO96b10TbKBcxblgPfA2QLUV\n    dFnlay4q2lhB09a9zwqaFld1raB5HjAt1mw/ny0PeAyuGlbrPGCygpZ5wDYraGqfQ+f68mpnWtzy\n    PGBaBJu5wGYeMD0frejpwWpxTV/ze1+s8oCjHW9EfQxfWuYBD0+SYBJ4fV4Bs5sXyL6MxEmEH4sv\n    M0xvTqAUgjVytL03GANHvz7G6Nsx9zeiOYqvMsyuPwdm5LChv/KHKWZ/vYBaREeDiGY4+PcxDv/3\n    GMmISv+qkaxmkEWGpTX+WRxLI9xQClg8nGN2Z7kzUKX+leTvIOb+RrRBB7m/vMDZlftL52TuL1+H\n    8/X4cB3/ZMY8KSgcsrW63EOw5f5ya2af9bNElfUzP0b9A2FqYWn9PLRcI9W/XVs/u8jjutbPNgLZ\n    1Z/shxO1cv9tzK6XZHKV+tfmIugSkIyhgtS/rr1RX5xdqPrX1neIstfWRu4H11X/Av1ZP1927Kr6\n    t41z7D5ZP+8zvtnj+/wtd98mAdzniyBsSk7dFfYlrLor9KEC7gK7qAImhKqAXdfWVQGHIMQK2jaB\n    4JORkEmIDQcIt4IGzInSAey2MLxdebJoryYkuFXAbstpX0ZIlRV0SAWlcrw+jiGUtS/b5D3UCprf\n    v28raN4Pbz+E3Qqa2pXzgO1W0LxKVtpF5et2ssK3MKqHybbKzP8tjMUp5QHzHCOu8uW2ztwiy5cH\n    DOsie5UH/M+YBxzRDOP/PMT4l8fAMCxHziCKyYpwEgsQIuwoznNMb1xATVXlhjWHQoIkQcz9jWgN\n    leaY/ukFsscLKMd/87+eYx7zgCNa4PCXxxj/aJmrGkICL7POl62KpwVmdyZQaSxCiLBDnWWYXj+H\n    yuqUXq/I3xFw+H8x9zeiObrM/R1C5/6CrZU1oVvO/U1W62yt7C2MvQRb7i+3fgbCc3/1d02+8v0D\n    Tg5LNbBsH2r9bFPh1rF+Hlja2tDU+lnuGflsmwnS4c4mgAixfgZQ2/qZXzt29OGLcJPngXCxCp3z\n    XcuPhaqCbXulodbPVXu8dQVFoerfEFRFJ4aqf33YpPr3Besnqn81zmq2b8OnPas4H9W/4fh8+W37\n    GcBXUQXcpqrCVc3RlQ308w77ov66sl6oQwJ3oQLm6CoL2DWYUl9NVcC2yUATK2gXeWuDzwr60NFW\n    wjeJIvBJG/XjI2FDVMBVk01JLNexgqZJsC0jxfYabFbQ3ILaZwXNFxAhVtDSSqipFbSsgvVZQUtr\n    Z2pfsHZyERZiBa1fRzkPmFtB00LRngesjMUnkcIy62jAFrG6opnbQ5tKX2kFLfOAk5XVdAG9aV1A\n    IckyTK7fQ/78HBERTXD0fyc4+MFyY5AIuiAVMIDFp3PM3p5CLXZnPhWxG1ALhdmfp8gfLkeBMF0c\n    Vm0Rc38jWkPlCum9CeZ/v1gXbw1W4/OAjcdFoTC78RWyL8KsVSMiJJJRguPXTjH+znBl8RxGAlOb\n    9N4c83szII9jaYQJlRZI71ygeKpXUqHqXwAY/egQhzH3N6IhQnJ/OSlcJ/dXn+e5v2axdFXuL63n\n    R2t76eW55ZperXN/bS5g2qZZRkyFWT9L8hcoWz/7ity5etdn/SzJX5f1cybOVzm/0X019L4U3yvy\n    wSVWGItrfQSyb4/OJbbg6l9U9Bdq/RwqHPFZP0vU2SeV4HuuTe2jbfu9NjfIturfOtbPfah/62b/\n    7huuEvnbJ/oifzchWN2E8NaBMgG8xRfTGn2RwE2qFs62/F5EtEedwaetCrgObO1dVtBNwCclTVXA\n    CuEqYJcVtEudK5/bJnPymFQB637gvU8VeUttOJmbea4PtYLmx2yTeX68KguGk6kZ66OpFXRmucam\n    9OX2Sy4raNviS8GdBywXZz4raKpklnnAI2YFbVt8khHWiG0oh+QB83PJ6q7cQstudaXA84ALKBSP\n    z5HeuY8ijXnAEfWRjAY4ef0aht9a/sVVkcBy43F2d4Ls47SaNY64OigU5h+lmP9tOSMIsX7Wn/4J\n    BjH3N6ItFJA9miF98yvwKAau/KVoBkChuMgwu3mG4jxa8UY0w+DaEIcsDziMBNYz38mtKRaPFoiI\n    WCNXmN+bYXZvOb+vctLgv28JgNF3Rjh+7RqSUcz9jWgAT+7vkpzN1+vWJdmqnzfN/R2sC55RWgcn\n    6zZ6DU2ELc/9XRd3wb7uB/R+Bd+HKACMGflbZf3sOuaKuQKaWT/Le5D1s11s0L31s4u8ddlAy30u\n    KXyA6A+WfkawO/wtYO7ZtbV+JrS1fk4d/dhEXHWtn9uofyVk+1Dr5yr1bxN0IZbaJfUvh4uwbeKA\n    2qXQrsu+CNH+uX8Q3/rlBu/5uX5oEsCbfBEcV0FyLbHLf1xNVcCuD0H60OzCrrlLFXBd7JIKeGJp\n    15cK2NdHExVwCK0VYgXNJ5kunceYTTzdVtDL+0hVcJUK2LetIyewLivohaM/OZm3Ece2yfwmrKBl\n    HjBBWhbZ+glZdJE9tLSCpkWcfB+5YrlOHjAnfAdiMWouUnUeMM/ylXnAar2QLozr+eJ5gBw5azta\n    PSvlAb/7CPP7n8Q84IhGSF4e4eTVUwyPl5uEIUrg9bkcmN64QPEsEicRS2RPVrm/RZianJO/Scz9\n    jegA+fMFpm+coUj1JrQuuFJr4jdhpPDiYYrZX18AWbTijWiG8X8crPOAOQkcVFA1V5hdn6B4Hudx\n    EUssHi0wfTOs7FuSv4PTAY5fP8XgWiykimgAS+5vYqxn6+f+FmzcrZv7q9fd5tqdk8Vjdo3M/eVf\n    9AlrcxXj+w9NrJ95AXuV9bNtn6WO9TPvx3Rkg5f87cr62SdG4NbP/P4+62d5XAou+L7bGH7rZ1sf\n    dG2d5xIu9a/rWBel+fWM/zXkPu8hlFUAVBebyv4N3Xuvs0e/CfK3y7723fp5lxCtnxvDbgG9DRVw\n    31bQzzb+E20efVSB7CK6ygPusuoJ6FYFHGoFzWGzgu5CBdwULhVw6KTqoOakblwxSXRVKo7ht4Ku\n    mhzTcakCDrGCln37rKClvc+mraBh6XMo+qljBQ3YraCBsjqZV+7KRRu1l1903JcHzBedCWsjF6n0\n    nFtZufKA6WuwIner8oBlttI6D/hmzAOOaI7RD45w+Iuj9R+3jwSW5/LnOdLb51CzSJxcdahJjumt\n    CdSL5e+CSwMnSRGFBIi5vxEdQKU5Zne+QvZ4DpOCc39Rm/lfnmP+j2nMA45ojKNfHuPgR2asAlD+\n    zCNwFXD2ZYbZnyZQ8ziWXnUUz3NMb5yvs6F96t8S+TsCDv/3GKP/OERERBPYcn9pXdok95evbwvW\n    l7R+duX+0vPB+jXAaO/K/aV2dH+b9TPPFgZMMjfE+tnss7yfYStq79v62QX7ubLooGoPqon1s8TC\n    8ZzUv7pP/TjU+tlG5JaFIm4lrk3969rrVJZ+XKrhuupfG/nbVP0r0ZX6t4/s39A+fOTvSWB/XRG2\n    VbxCE/XvpvBVw+uqBIpnDfpsk//rwi5Fv9bFJtS/3xLvz+fm6TIBTC+mTxJ4E77a+4CmKuCmf9R1\n    0LUKmD6Mu1AB18E+qYCbWEGHEMVNVcB8ktJUBSyPU1tX9VuVFbTvnn1ZQbuur3ouraD5BNc10baB\n    k8C8B3mfNlbQtMjwWUFLFbArD5i+D0uvu7kVtG5bONv7rKBdecCcmKXXZ1uk8oUuX9wW4npOFFMt\n    tFxA2/KAqQ++IMd8scwDfhHzgCMaIAEOf3WK8X+WP5l9JDBh9mCO+bvTmGF4haEWCunbU2Qf0/Zb\n    +ffERYIMoDCKub8RLaFyhfT+Oebvnq+UvuWCK/l4wIqrVKEwe+Mpsi+aBppEXHmMEhy9dorBt4dB\n    n4HyfPpOivmDNBYhXGGoeYHpnybIv6h2VrH9Lo1+dIjDX55s+8eI2FMUsxTpnW5zf7kltFwf07Ec\n    5MBVzv2Vhdau3F8678v9BVAqLufkLxWQ28hfnz+Dz7UsxPpZXmMjf6X1s27TzPoZnmNS/Wt7LIUJ\n    nECW1s8u+2j583dl/exy++Pg+4jS0S9UlGKDrfQmhPwNvV8V+duVwEfuG3eh/u1aUBWKTXEKXSl2\n    o/q3PvoWcF5B9S/gUgBvC32rgDeNs22/gJZoSgK7+uoSm1IBh5LE1E8bFbB8PU1UwIB9khBCAksc\n    ICwnA6hnBe2Ca2LGJ46cjE1RngzWtYIG4LSC5n26qiT59Tal8AJumxybFbRNBcwfV03wm1pBDxBm\n    Bc1fd5UVdN08nVAraE4C8+t8ecBUxRuSB2zL6x2JxSy3n/QthkPygLnVli0PeHbnfRRpyLInIsJE\n    cjDA8evXMPxGeeM65JN9enuC7GH83buSUMDi4xTTuzN6aqh/XcQvsFIsvTzAccz9jWgDBSweTTG7\n    9Wy1mWtm/nL1ES/AMtsUUOcLTK8/Q3Ee81gjmmFwbbi03z01YxU4+GciVwFDAdObEyy+jLEKVxKF\n    wvxBivk72qzTpf6V5K8CMPzXmPsb0QKU+3uvee4vja11c39t62me+0uF2ETYKnAXL1PhK5W/gL3Q\n    3Jb7S9dLHwY6xveWfNbPsnCetwdgsXYuv1Z+zmb9LNuGWj/b+mhi/eza0+ra+plIWVc4TIj1Mz9W\n    5Roo4bJ+dql/Xe2rEKr+9cFF/nL751D1L0cXYiQXmpDCXah/u0JU/+4u9tn6ecvZvwQ7AbwJFXDf\n    sP1y9F1F0AS7rAJuil37UNyECpgjlATuQwVMk4EmlWK2SUhacT4EctLkUwGH5GvISV3VpM9nBc0n\n    smQFPV8/d5O+u2AFjXV/3VpBS6Uwb+uqJpWWSDIPuMoKmvJ6pRW0XPyV84Dt/dvsobi9lMwDpmuq\n    8oCJBKY84ELYOA9g2jvLrGFzUb08l6+eD0Ue8HB1fPH3f2Lx4NOYBxzRCMNvjHD86ikGR+WNa9un\n    mLGNsFCYXL+IGYZXEMXTDNMbk/WHbrL+rPUXDyQAME5w+OuTmPsb0Qr58zlmbzxFkZbHYk4A868y\n    AbyykHw0Q/rnM6hFtOKNaIaD7x3g8H+OQSGLVfa9RsHMVCG9dYHiIo6lVw2LLzPMbl6sfzFc46dN\n    +RtzfyNaoaPc3wFyb+4vH4Pb5P6SS5c+DnDStSr3l75LclZGQ9H3wtPetr8g++eQ1s/cutlu/Vze\n    Lwm1fub3Mklnc9+K7x85f0Uce11dWD8D0m1P7tfp9m2snw9Wz0Otn11IxXdCU/WvJH/la+jS+jkE\n    vF0IQdul+rfJfrsPm8j+BbAqZGmPPtS/NpFen/zQWY99R2wUu6UABnZXit2Hf3kf6CMHuKs+X4jv\n    bdGVCrgKtkGrKyvoKjQZ1F3YhhV01YSryv6Y+vBZQc9RbQUNhFtBu65xTU6rnndpBZ2V2pUn53Kh\n    wVFlBb1sYyLUCprDlwfMraAlaSytmeg7b5+L/kPzgOWCkttB5WIxWjcPmGcc2fKAKTdJ5iEpRhhz\n    9TCv0lZQmN14H4svnsQ84IhGGP/XEQ5/frTeVXRtXNuO508yTO/GDMOrhGJaYHb7AsVznVUYgmT1\n    v3HM/Y1oCZXmSO88Q/44BXfU4Cok/1eZHJ799TkWH51HK96Ixjj632OMfhiew8p/0xafZkj/NoVa\n    xN+/q4LiIl8S/1Nz/mSzES+dGwGH/3OM8Xdj7m9EM2wq9zdhberk/g7EupjskIkUlrm/0vq5Te6v\n    Sb4uQe1DXMr4PYDyXkd5r6V8Db9/HetnTgw3sX622Ta7hAhV1s8SSvRjc82T1s/yfBPrZw4Z4yb3\n    Il1qXtexpurfqr5DECro6Vr924b8bbIfXniukUKuvq2f90H92zXfs4vqX5twc1dcfptgR9S/gI8A\n    vgwqYBs2rQI+C2izyyrgptUqtg/HTdo3yA9v372LHl5XGxVwCCkacq+u8iKAevkWgJ0EtqmAXdem\n    nv6AshV0FaSFdBMr6KVlsJuw3ZQVNGBO7n0LApcVNN2ZjslKWlseMGDP9nVZQYNdE3IMKC/KQvOA\n    eX9VecCc7B0zcpdXJ9MCtSoPmB5X5QEvF9PcClpXUFMeMC2++eI8p2fpArM33kPxousayoirgCQB\n    jn57ivF39ScnbTJKRWeCMuE3//s0ZhheEahMYf7OFOkHPPe3+t99bVf5yhgnMfc3ogWWub8vMH/3\n    BYDCuild9cULqMiNA0phcv0psscxDziiGZJxgpPXT5H8y2j12eguqALKn53pn2bIPk5jLd8VgFoo\n    pG9PsPhU0xf0O2O0c1w//uEhDv835v5GNMOmcn/HbG3Lo5JoPc1jl3J2Hx7FVCf3F3Dn/krrZ9pT\n    cFk/D8Ux+l7X+lnuB/H9EL5vwXN/21g/8/uMLH1w9W9T62dyrquyfnaRyPJ98Vk/+1TKIdbPXP3L\n    9wddwpE61s82NFH/us7XUf/ytuT4GGr9XKX+7dP6eVM7V1dJ/WvDLlo/NxVQ9s3X+QSnX+/h/dgk\n    n/qt6nttTwHse3N3NQt4F1XAtj/2qALuHruuAuZW0DwTQk4smqqA+SQoRAXsQhsraDnpk5O8KhVw\n    iBX0sl+3FbTssw8raB8JzFXA0v6HW0Gbx6utoMsLlDKhyxdcsrrURhxXWUHTz2DeAyVCF3DnAY9X\n    BK2LlK6bB6zY+YFYrBIxq69fXmOrfK7KAx6uDa/C84CzL14g/dP7KOYxxzCiPpKDAY5+fw2jl/Vf\n    ZXAmsAJmNy9ihuElh1JA9nCO6Z1prevo9yh5eRhzfyNaQSkgezTB7NYTo5hKZhFylw3puCHHU6OP\n    iwWmN56guIjjaEQzDF4a4uT1EyQnA4Ss+AzPngKY3JigeBLH0ssMpYDs4xSzu/6xVBbfGbm/r1/D\n    YBxzfyMaoGbuL48mqp/7S2tjM/eXIpCqcn+1cleP9zK6ia/Lba5f3MqZ5/5i1ZLa0XWU+2uzfnbt\n    J/isn7G+E12vry0X8Putn/k9bfeqsn7OgJ21ftZiDN1ekslS/Ssxtzxva/3sAnkv2EQtocIYn3q4\n    SpjTRrjjQxXZu2nr58us/u2Dk9kGzrb9Ai4JdkD9C4QSwFEF3A5nAW3aVF/0rQTuWgXcNQkcirYq\n    4NAKJhoU26iAp572bXAItVUr6DZGVgdiAll1zxDLGDlZ1Spgsw8+ea1jBc3hm0RLyxzbY34sg3/y\n    D1RbQQN6sSGtoIkElq9f5gGrikWCzwralgdMJK0rD5iuq2MFzRePtjxgbUdl5gFrW2qzUprn+ubQ\n    Vc5A/TzgBGF5wPSVvv0Q2YefQRXRjjeiPkb/MsbRb08xONS6JBcJLD95immB9NYF1CRmGF5WqLMM\n    0+sXUKsP8xD17/r3Z5zg+NfHMfc3ohXyr+aYvvEYKs3XYyjP9uVj7YCUvezxYD0GF8Y1PBM4+2yC\n    9C/PoLI4jkY0w/g/D3H0iyNguPwErFYBsyLL5yuL/Wn8/busKJ4uMLtxbkgP5UhqG1kVVrm/r51i\n    +FIspIpogAa5vzZ3q9DcX2kP7cv9Xb1AI/dXwZ37C2BdpM3VvDbyl1/DrZ8Bf+4vby+L1QFTGcyP\n    2ayfZW5vlfVzDtP6mfqrY/08Esdc998F62fAbf0MS9829S+Hzx3Qhrrq36bWz7RH6ro+xINGvn9d\n    qX9tJUl9qn/7uMaGXVX/9oFNZ/82Rdfq366EnVdc/QtUEcCbZKk3jaYk8C6qgG3YZRXwpqygbQRz\n    1/fuauCSg+8RFOppcNwqYIlNWkFz+CZTdVTAruc2wreOCphQNUmtsoLmfbsmzzYVsItYdllBy4l+\n    HStoZVxbriblpK3NCprfv8oK2rZ44qSutHb25QFLK2heHSzb86pirezV70BVHjAVhcg84HI+cLEm\n    iGX2EVcf2fKAC0tbWx6wYt+nb9xH9vnTmAcc0Qjjnxzj8OeHQOLegHRh8ekcs7djhuFlhEoLzO5M\n    kD0tVnb3Kpz8jbm/ER1ApRnSO4+RP56Bu24A9S2geXtOCNPYm/7lDNk/XkRb+4jGOPjVCQ5+oAte\n    qrSaCftcTT9cYPHOFCqLv3+XDcW0QPrmBbLnmv2VBXfyX33tojFc5f5+L+b+RjTD5nJ/FSgCqU3u\n    L0Ux8cJsX+4vhy33Vzt4mdbPvmxf1zmpHqb2sqCd76nUsX6WJLKtsL7K+lkW/Xdl/Szv77N+lpDO\n    eSHWz7K/utbP8tpQ9W+d2L261s8HltfQxPq5DaSAqEpQtGn1r6/NJqMjge5dSok36dv+uQ35GyJA\n    POv59UdsHOEW0H2w1/toA90nrooKmKOLD9muqn62qQIOQWh72c42yWiiAgZQ2wq6avLFJ1GuSZis\n    yHNZQacIs4J2VSUCditoeR/fa7X1J62g6bEkgUMqMgFzcm+zAwq1guY/gySDgTAraIjzrgxhqeKV\n    BLFvYcbBraDNCmEzDzgX7V15wAOE5QHT4ti2qJV5wIlYJPNFM+UB69xfdx4wVz0lzKYrmy0wu/Eu\n    ivOYBxxRH8kAOPrNKUavLJfhS5WnffPa9ik3vztB9nFa4RkdsVfIFeb3Zpjdmwfl/XIoxNzfiPZQ\n    mcL8/ldI33tukL4DmOqlhI23vv/M6AVdRLW2rCwKXNx4jOxpzAOOaIbBOMHR69cw+Bc9Yw8x7F2O\n    twrTO1NkD+dxLL1EUJnC4p0p0g/dHlQu8hcAxj+Iub8RzbGp3N/huqgqLPeXu3FR5BKt5Sn3lx5z\n    8leP5fZcXlfuL50HTLUtWT8TXEpe/tymFgbscVrbtn6WAgWCS7Tgs372Ebw2YQS/l3TP4/eg613W\n    z7brAL/7H7+G2sn9xyo1ry371+ZkGIo2ghm5b9tG/cvRhfrXRf7K4yE7VD4i2Ub+ujiDrtW/LuK5\n    rv1zH5BivF1U/gK7m/3rQx/qX46+hbWB6l8ghACOKuAymvxSn23g55EfArusAt6mtULbiiI5qFVV\n    QjW1gm6qAib4soA3oQL2WUGHTqRs7UKsoDmqlMGSYJVW0JQFbLuO4COVJeS9eDWk8vTJQSSwKi0y\n    ysRv31bQ1Fbel6PKCpq+80WWywp6IF5fnTxgbd1cJoG5xRTPA9Z2UeU8YG4FPVovhgtrHjBKVdL5\n    ihReGmHx/igziYhfCKI4e/Qcsz9/EPOAIxohORri5PenGH1tOQf0bV7LT6EiB2Y3zlE8jRmGlwX5\n    wzmmb05WZNkSvhGaZxUOXh7E3N+IVlAKyP55gdnNx0gspG8507cw1L0yKoErnDgJTITyOtPw+Ryz\n    N79EMYnjaEQzDF8e4vi1EwxOEu84CpTzXosMmF6/QPFVHEsvBRSweDjH7M7E18QAH29H3x4uCwpi\n    7m9EE9TI/aVVbNPcXyKUQ3N/uTLXlvtLa+06ub/03Zb7K9tV5f5K62cZTQXxOIN/L2Mb1s/yWoLL\n    Ua7K+tmn/uUIsX7mYoyurJ/nnvPyeV33QcC9Txmi/q2yfm6r/m1i/Wx7XtWeow5RHCpP2CUZA5HL\n    XZPJfat/26CN8NCHPsjfTdg/94Ftxeh+7j8drgDu64fom22vwiZJ4BD09ce4i6AP2T5VwHX7DlEB\n    A+0rm0JRd/AGTCtoH+qqgG2ToibaCd/kqisr6KpckLpW0JwE5q+1iRV0hnIWS1V1piSpOUxCthsr\n    aFrkNLWCzuC3gnZV8obkAfPnbfOAKY9XLjR9ecAJ7HnAmjBeErYyDzhhC24z0xCGMklXVPvzgOd/\n    /SzmAUc0xuhfD3D469PSZqNLDcyRPS8we+scahZ/9/YdxfMck+sXKFIEkb9gbZJxgqNfn8Tc34hW\n    yL9KMb3+OYp5biV9dQSCHjv1NrMusFJsY1qTvmXLaD4uLz46R/pOzAOOaI7x9w9x+ItjJEN/MRUg\n    SWCF7GmB6VsTqDT+/u07iq8yzK6foxC23q7xlI+3w5MEh69ew+jlWEgV0QCW3F/AnfsrSd+ucn/t\n    kUlY2U+bub+H67UuuXXpvxRb7q8t4smV++tqL13FqtzHXNbPMveXXyP78Vk/c/K3rfXzcLUn1YX1\n    Mz/exvrZPIdS37b+VOm6fqyfXUSuzXw/xPrZ1t72OqoEOCHq3yaoUv+2sX5ust/t22+vI9TqgrDl\n    XIGLsK2r/t1lEV4dnG38jtvBvqt/ayKMAO77Rbve9KtoA901uvyw6NoGmvfXld9+KHyDS5OKpL5U\n    wEB50K5jHV2lAm5KAvMJWlsraDmhCsnjqFIBb8oKeux5rU2toF1wWUHzyT8dX7YPt4J2WSAB9ayg\n    q1S9A/gXSgPxHnSZB8ztpsxFnT6P1aKU5wFrK2d3HjDfkHblAZub0GbOkradNoljVx4w3XH6xn3k\n    Xz5FREQTjH92jPFP7HnAVSTw4sEc83enQH5151f7DjUvML0zweJJEWz9zHN/D2Lub0RLLHN/v0T+\n    ROf+go1xktSVxVWu7F9AKp34cZNgnr31BNknL5ZS5IiIBjj41QnGPzgAUE0CQ5yf35tjfj+NY+ke\n    Q6VLIj9/mge15+RvMgQOfnGMg+/H3N+IZsi/Kuf+ElHbZe4vf16V+2uLUuIOXDz3N0d17i+PdpLW\n    z2akk3hvVt+H4thQ9M8L0gGTHObt7H4NdhUv3ddm/Wwr0pf9h1o/23J/gebWzy5PirrWzzb1r8/6\n    ORQ262dCqPUzP8b3Kqusol2oEsSECGZC9j/7Uv92hV1S9dZF1+rfvtF39m8T7LL6d9PYpPq3hv0z\n    UFcBfFmxKRXw2QZ+ll31gndhFz9suwy370MFHIJQFXAbK+g2kNVxVVV1PhWwLWskRZkcdicyLdHE\n    CnqO3bCCpgUA74G3AfwWQXyBZbN3DrWChqV/vrCx5fNINW+ZaNbXEopSf3wxoxei/Dr+WmUeMFlY\n    kRU0X4iG5AFztTAnhPliWa2vMe0sKe+XV1jXyQOe3LiH4mKfp9wR28JgCBy/eorxvy9ryuuQwAWA\n    6e3JMsMwYv9QKMwfpJi/m9ayfqY2o1fGOI65vxFtkBdI759h/t5XpczBBKZ1s1QF84IpCFtoOzHM\n    i6fEeFvkmFz/AnnMA45oCMoDHn7LHEurYhWS1W/h7M0LLB5FK/K9RK6Q3k+R3Qv7/JBj7fgHhzj6\n    dcz9jWiGYpZidvv9jeT+0hg7YtbPcl3Lc39pjdxH7q/P/SvU+jk095cgrZ+HMAvoq6yfXbm/LuI2\n    1PrZlh3ssn6WpO0mrJ/HCLN+DlX/8vMEm9CjC+vnkH1K/smvLP00tX5uqv49qnhfgX7Uv6E7UU3U\n    v30Jxbj1c1fq3z6wDfVvXexj7i9w5dS/QB0CmF58X2x2329+VfXApkjgEHRdldH1h0aT/nwq4K6s\n    oOuSyT4VcBMr6K5UwDbIwTuUFJY5wrbJx7ZUwG2toG3XVVUCVqmAq6yg+XPeR99W0AtLHxy2RUDo\n    AgIwFzWuPGC6Pndc57KC5n3SY18ecKgVtPwuF4O+3CBbHjApgxeonwfMLaApD5gWyjwPmJRI3JrL\n    lgesWL+2PGBevZ0/PEP6lwcxDziiEQYnQxy/fg2jl8w8YIKPBFYLhen1C+TPw1QvEbuD7PMFpjcn\n    gFKVSjXA3LSOub8RbaEUsHh4junNLyE3nSlGQap6adyjMZEXRi3HUbMf023Dtrmt+ym+SjG7/QUw\n    jeNoRDMMXx7i+NUTDI7LsQr8uzyXQCGfAen1CxQv4li6b8gezZG+eYEqE28er0HzrNG3lrm/ySgK\n    MiIaYJX7u7j/ee+5v0VHub8jQx3cfe4vLy6X5C/gzv0F/DbOgJ38NfdMzGuGon9b7u+mrZ/lsV2x\n    frZFu9WxfqY2VUgdzw/RjPztCiHWz6HqX442ttFV6ELk1Aa7KCLrAzbeZd8Ef7uATef/bgpS/ft5\n    9SVxwnkZYftQ2IXKkV2ooOkbtsGw7gDpGtxDrEFc/fgmAJtQAftI4EPRBo7nNkgVsLy+aytoV+Wh\n    7NM1yZUkMD/us4K2VWkS+rCChmUBolaLGUkCE/SCp9oKml9ThlmZS+0kCWxTEOs+y1bQPBfIngfM\n    c4aWi9Q+8oBJ3eTLAx6IPGBq68oDnv35M+QfxTzgiGYY/dsBDv/vBMPVDkOdEaF4kmF6dwI1j797\n    +4LiRY7J9QmKqUn+uv7dDbvKmPsb0QGK5zNMrz8C5pmxQa3HR1UaM2mslTELfEw3XTf4yGoWT9Hz\n    go2viw+eI/3705gHHNEY4x8c4uC/j5AMpNLXDTq3+DLH9E9TYBF///YFxYsc0xsXKGbufzP5b0+/\n    F8PjBEevxdzfiIbYYO4vHa+b+0tq4NDc35x9539RZg6wWdROKmKwa1y5v7n4Lt5Q43VQO0kw22yp\n    5X6FLfdXqpq5ehhwWz+b6l6zPQkQmlo/c2zb+rnKS0qSvzbCmKOJ9XMT9KX+JdQlf+taP4eof0PQ\n    p/q3L/St/m0andk3QoWGZzX67Ev927f9c18CVBLM7qD6F6hLAG8rC3hT2LYEfR/Qx4dZlypgG3x9\n    dqECroM2KuAm7bkVNE0itqEC9oFP0qoUvjYVsG8S2L0VtKkCdllBy8myq3Iyg7+qUk6ybY+pH7Lg\n    cVlBu2yKZJVpedEhFzZlQtm3GJIWz9TOZQXN+7Et3PiikN9XLgw5CSzto/ki01Q3l/OAk/UxTura\n    84B5VhLlAeskQ23LVZUHTFXWuvLanwcMVWBy/f2YBxzRGAf/fYzxjw6DrIA5CgD536dIH6RAsf1C\n    s4gKLApM/zJF/vkiKPfX+H2Iub8RHUClGWZvfYHiyQwQZC7YGCezBvmmNFcxkQW0YsekHbQSfQFa\n    BUwtAIXpW18i+/R5zAOOaIYEOPrNCQ6+v9xeD/0tovnk4u0Z5h/EsXQvsCgw+9MExRdZZVM5r0oG\n    wMEvjmLub0RjbCr3lxcqN839JZvnkNxfwO0O5sv95QXfvtzfptbPBLl3USf313xtYdbP8hy/1uda\n    x38++Zj2tUh8IIUJba2fge6tn+V5gk39G2L9LAnfttbPNlfDUPLXp/5tgyrhUJtc4G2rf9uCk7+7\n    jMus/t0277Zt3rEL1Mz+JeyeAlj+Y2xart3kl7EPG+i22FUVcAjakMBNPsjbVhzJqqdNWkF3hUOo\n    2iQwwTbZscGlAna1c/28LitolzrXds+mVtBjmBNk2UcTK2jqy0Xw2qygbfen61xW0BxtrKCJBHZZ\n    QdsIXZNkxrp/nxU0fef3GYt2vCqYk8B0DSmDXP2H5AGTonnAvnPiV9pDk3KYL6Rp0d00Dzhhi3iZ\n    B0z9ZZP5Kg+4rkFQRASQjFZqlO+MapPAUEB68wKLL6s3QiO2iEJh/kGK7G/LcjCf+pfsKnlZTcz9\n    jWiNvMDs/jOk750JQpZIWb1Jrb9zFZM9F9jWFx8/zU1v0y7a2PTOckzfeIT8LOYBRzRDMh4s84C/\n    ufyg5J+h3AbYuGb1XSmF6c0JFo/jWLrTWI2li7enldbPBD7GHnz/AEe/PvVLwyMiHAjJ/VVGsRS1\n    qZf7O2Zr0qa5v3z9vNy3KOf+Vlk/05cr99fm9mXL/cWqBe9fFqcvj+lrfLm/ACpzf3PYrZ9lIb7L\n    +lnex+X2BpRjxWxwiwncal17e7cT3lL9a7+urvUz9eezfpZ91IFPJVxHFdxUQewje9uof3170SF9\n    7ZL618YLdEncdq3+vQa1s+rfPrCLPNguYEfVv0ATAvhL9JcD3Df6lpFfFTxHczI5JAu4DzQllftQ\n    AYfAN/DyQb1LFXDdirM2EyQ+4fJlAYdik1bQrnsD/kmoS1UMx2S8iRU04F8chFhB28hcW/WrLQ+Y\n    38dnBc1JYPouSVrX4syWB8wXf3yRyBeUrkWltIIeQy9qeR4wWUFLwtdU/erFMKmGR2zBTYtpngdc\n    3pgu5wHL7EPKA1Ziwzx/eIb0bw+ARcwxjKiPwbUhjl47xeB0UIsELgBgWmB26wJqEjMMdxWLxxmm\n    NycIcYqXfgrDmPsb0RKU+zu/+Qg2xS+PTlAo21DK7/J6+aWs9zDH28Jyff5Viulbn6OYxXE0ohkG\n    3xjh6HenRh4w/+30QV0USONYutNYPM4wu3kRXCXHm42+ucr9He+eCCNiD+DJ/V2SrrlRcExjXN3c\n    3yFyZNCOVG1yf/lam9b7vK2CXqe71/cK0mVM5gP7cn95e+PtXH0fsHO+3F9+TYj1s20fxJf767N+\n    pv2dEOvnKkECJ4pDrZ/lPpbN+lk+91k/28jeMvwCjjFUY/Vvm/3HrtS/EtSek78hkO1c+8gTR3sf\n    JJncRP3bVDG8aWfQLtAV+RvVv/2hb/XvJsjfhupfYBcVwMD2Jdl9qoDPAvsL9Wf3YVdVwCEVNZtW\n    AfsQMmhVqYCPAwdmoHpQntRsL9v58oCbWkGHqoBdkP00UQF3YQU9FpPnqvzeKitoH6nMQVbQoZY7\n    tsfUD7eCttk426ygfXnAVVbQtkUWXxxJQhfiGmnZBMu1VXnActFYlQfMn0tlL78PbddRm4Ido59j\n    yBa/ZL1lywNeWkBpKy7TWosW8FwjjLX6yZUHvHxtIg/47meYf/xPQMUcuYj6GH/3EAe/PMZgpI9V\n    bVqT3i77dI7Z21OoxfbnGREmiot8SSpcLD8XpPDI92mRjBMcxtzfiJbIn88wuf5PFHNTecQVvJz4\n    LZO8xXr8lKrehG1k6+OFlRxOjDGX21nqtov7XyF99ylUHsfRiGY4+C+dByxhG1N50VX2ySKOpTsK\n    NdFjadWnQ6mQ6jjB0aunGH5jhIiI2rDk/hZsnKP1YNvc32K9J9A+93fM1st6Db0EJ41Dc39t1s+w\n    POb9AOa+Bt+PMF8HjON2YtSu4l0es0dc0euQ6mEOV+G+HCmk2xwh1PqZPybyt0vr5xHCrZ/lPlyZ\n    EDb3BEOsn6teexXqilt8+cFVwppQ4U1dX7e2bpH8flV74KHqX1+7uk6cXe3z95H92xXP0hdf03X+\n    bxP1byjP1pdwc9s8Y5/4PKxZMwJ4E6z2tv9xtl2ZAHRDAveFNipgX59dfqhLNM0CDh3cJNrmI/gG\n    /LqDe+jkIXSy0oYEDrWCrvp5m1hBV1USysmob5LdtRW0jQR29eOyhYboz/Wzc7WwC7RQqbKC5nCR\n    zvK+clHkygPmJLBNC+Fa7MkFI+X+UL4vXzjyxSevTqZjMg+YsotkHjBtJtNimFdIkyWXzgGijWZz\n    c5oW4jwPmKqyZW6TOw84x+SP95E/3oVRLGIfcfj/TjD64WGJJKwigQcA0rtTLD5Oa/hHR/QNtVBI\n    354g+2QBhbL1s/efKub+RnSAZe7vIxRPppCqXxoLeWahJH+50oh/5eLx2srZcp1pKy3vW1YOp7e/\n    wOLTFzEOOKIZVnnA4++NnU6/PlVwHEt3D2qhMHt7ivyT+fpTw9lWPF/n/v7waNs/RsSeIvvqRSn3\n    d7AeA811ZZvc32FpfN5e7q9ZJK7JX5v1M+C2fg7J/eXqXZ/1syR/u7B+5rDFdNmuJbSxfnaRvz7/\n    k1Dnu7bWz0B96+fQmLmu1L+2+4YIYXxt2lg/+xCi/q26X5O97V2yfu5T/du39fNlUf9eduQbmLS3\n    UP8CbRTAj3v/0fYPXauAu0CfKuA2H3J9q4CBbkngECvoKqK4iQo4lLhtYgXtIns3kXwWYgXdJE+j\n    ygpaoi8raF+mcJWqeCQIZNc961pBczS1ggbKdkk2K2jfgisT/dBjXx4w5fhKK2jezqby5SRukzxg\n    rvRtkwdss7DkOb4yT4kW79q6S2+EK7a4p8W+mfNUQF2kmN64h2IS84Aj6mMwTnD0+jWMvj0MIoGp\n    TQFA5QqzG+consYMw12AUsDi4xTp3ZnxaS5JB9dqIOb+RrRGXmB2/ykWIveXq30Ty2Z0sqZ2y+Qs\n    FVpRsdWAFWjJTGBJAueWdmaMw8p5Y5FjduMhiucxDziiGZLxAEe/v4bB14eointV8nEOTG9M4li6\n    K1iNpfO7k/rkL2Lub0Q7FLMU6e37Ru4vd4kasFGsTe4vrS13JfdXruPpfJ3c37ITmRlBBcs1Q881\n    sFwjrZ/l/klV7i+/74i14dfarJ9DhQP8/Ij9u1AfEH1ySPWvy/rZRyZ3bf0MoLX1s6s/3/5jV9bP\n    rig+n0tjCFyikz6sn5sKpELQt/VzH+rfrhDVv93jyep73wLTPeFHd9MCmtDHP1IdOXmfv6Rnge36\n    UgHvqkXBJkLT+6z+6cMK2tWmrcWHiwQ+hKptBa08k6AmaGMFLTEuTf6q37e2VtD8HD9f9ZyrgEcV\n    E9mR5zVWWUGPEGYFnVnalTNvyiSwed5OuPqu4ffnr7uuFfSu5AFT5TPPA6ZFNumEeR4wVWYTCezK\n    Ax6sF/NcE7Xsb/HpM8z+9iFUFjcPI+pj+NIQh69ew/AksZLAtg1OOpY/LzB76xxqFu1Tt43iSYbp\n    jUkjR/iY+xvRGkph8fAF0nXur1bxSrXvgMUd8AxDrg6W9s/ctnmw6nlgaS8JZH4tvwdXJicokD1N\n    kb71CCqN42hEMwy/OVoW0RzVY/4UAPU8x/T2RRxLdwDF02xZ3JbruU7o3Gj4jZj7G9ECjtxfKgAO\n    yf1N1mtWd+5vwqyhu8r9pfV0l7m/VeQvB7d+5kcBM/eXH5f7TUP2l20rZHdZP/P9jjbWz5z89aGu\n    9TNHqPWza//Kp0CuIn/lMbkHaLN+Hle8F/x6iUNxH9s9Q9FkLzbE+rlr9W8I+pAMNFX/2tB1xGOX\n    2HX17y67ym4K23YX7got1b9AWwJ4Eyz316HWrP0+oEk1RBXa/tH2aRnQhxU0/4DvQwXsQ1sV8DZR\n    VwVMcJHAdVF3EtSlFTSHTQUsJ4oHYjJps4J2kbmEqkmvrHj05aXw+zS1graBk8D8XSTI6lIbeJ6u\n    JJJDraBlNjAng3kVrmvxxK+R1br7mgdMG+BVecDJakFtywPW15k2X/SV3vkE2SePoIrd/uyK2E0c\n    fP8Q418el//AV1CeY+mDOebvToE8/u5tC8W0wPTNC6jnee1rY+5vRBfIv5rh4vpDYJ6txy0eayAL\n    pSQBK+2gzTG3/DUQbXQf+n58E3tgsZ3mSuIEBdL3nmF27ykQ84AjGmL0oyOMf27PA67C4oPlWKqy\n    OJZuC2pWYHb7HPlz92eAyx1lcJTg+NWTmPsb0Qwd5f7KCAW+ZqQiKFrX2nJ/7TnA1bm/3OYZaJ/7\n    K/8CXVFQ5NgVmvtrxl1hfY2L/CVI62dqmwEGee1S//J9jq6sn6vsnn25vz7XO962qfWzhI0QnqPa\n    +jlE/WvLB/Zl9lbBpv61na9S/9rA1b+hpK5s10b9K8nfLtS/TaMQ+7Z+vorq31CcbfnnJ/SV/9sn\n    NsGLdkD+Am0I4G+sXsCeSJ0N7Mov1dmW77/tDxnXh2xUAWvUVQE3sYJ2oa4KmNBEBeybuIVM1KQK\n    OMQKuooElqhrBW2rlHRdZ8sDlu1dj6usoOnx0HK9a+HhutaWaRNqBU1WzrbXR6hrBc1hWxRuKg+Y\n    NpQBfx4wLc7NfCVTrUTELi3Q+WO+ca7baqI4EZvcUDmmf7yH4tkzREQ0wdH/nWD8g2W9tE2/5PvU\n    nNyeIHtYbfQV0T1UprB4Z4rso3ntmV4Sc38jusBsgdlb/4R6MmUbzuZ4yJW3clNaqpMUGzMVympg\n    XQzF25rZv0T68s1wSTxzQpj6mN56hPmjmAcc0QxJAhz/dpkHXAf06za5PcXi4TzEwCiiY6hMYf7u\n    FOkHy7mMVP/aVL9rDICDnx9h9F9xLI1ohvyr59bcXyKCwcasJrm/9EVr2qEY/9rm/gL1c3/HqxW9\n    aRetrwvJ/fVFPtlyf6XLWTkmCtbc3yHKe3GZ+Bl91s8En/Xz8ly49bNLhUv7RD7hgus5d6br0/rZ\n    Jepwtdmm9TO/Rwj56zpvs36uq8Ztax3N0ZS4lfCRxC7BVZ/7831h19W/oTir0Xbf7J8vi/q3I+yH\n    Fc1lVgGfbfvFdoB9VQG7+u1DBVxFArdB20F/m1bQcrIlJ2dVkzrero4VdAglIds0sYKWVs6hk20+\n    Sfepj/m9ba+RFhpyYaMJ5rA8YNNCqVwBq1aLIBsJDNSzgvbl99BCMCQPmNrr55rEHa8WtF3lAQNh\n    ecAulZGsrvblAds2yX15wPmLGWY376GYdLk8iLgqSEYDHL1+DcNvLv86Etg+k7E6p58DABYKk+sX\n    KJ5H+9RNQikg+yTF7E59Q68EwOiVUcz9jWgFlReY33uM+b0zNraZdsyc+JVFTAlkqIEkc5WVAJab\n    34r9x4uopJpYK47LbhoKCoP5AtM3PkPxIuYBRzRDcrDMAx5+fVArBlYBSBYK0+sXUF/FsXSjUMDi\n    4RyT2+ZYWprrCNAaZPy9MY5+e4ok5v5GNEAxSzG7/T4WzybgYxMVOnWR+0txQ3x8teX+kvsVd9ro\n    I/d3jGK9VudF4XJ977J+HkJZFMRLVEVV2fYEpAU1v2ZY6rNMGvM9K1/EluyD2thyfyWqrJ85+euy\n    fq7K/a1ysauyfgYQZP3M1b99WT/Tvfj3TVg/h1zT1PrZJQBqov6V2GT2rw1dWz93qf7tkv/Ydvbv\n    rmBXhJp1QILYb/T42qvUv5+Hd9UNAXyZVcC7opvaZRtoQpMPrm2qgHcJbVTAoZMAeb+Qdtuwgubk\n    7aFoU3UP3s5nBR2qApb3aWIFLXNbQqygAXsecBMraJkHzF8ZwZYHTNfKNuZjuSAqE7o2C2klvstr\n    BuyaMszKXmpns4KGeM4XlUQCt80DlovfqjzgpdLY3Aznyt+qPOCB2BbXeU06DxisDZBj/o+nmL39\n    UcwDjmiE0ctDnLx6iuHxMg/YRgID0rBtifxJhundCdQ82qduCsVZhsmNCVRWTzCWABi8PMDRH67F\n    3N+I5lAKi8+eY3rrUYmY5USvVOiaSlxO6uZOotf+ZSqCEzYmgh2TJG/BxnTra3o8xfTOI6h5HEcj\n    mmH4zRGOfneC5DCpRQIDQPE0x/TOBCqNY+mmUHyVYXb9HFjQOgHr766xleZHw68PcfyHa0gO9kNs\n    EbFjELm/nPzlY6cr91c/9+f+0tqSiqy2mfvLyV+gfu5vLr4DfH+krP7lx+3Wzva9keUxe3SVtH6W\n    sDmwyXP8nq59p1DrZ0n+utS6rtch7+GLR/MJHuT+mksNvAnr5zrRc0BZ/Zs6zre1fm6Kquvr5AR3\n    JVhqkv3bl/pX2j93BeI9ovp3d7FPAtINot2ktE+W24Z9+kfcFxVwV9UmbT78NuG336UKOKTyydam\n    CytoF6Y129vauSYuTayg5aSsrmaCV+SFVufZ1MM+K2jXsbFn4iufuya/C9FPGytoHwkcYgUtMfRM\n    3vl5GyFdZQVdJw+Yn5evy7aoUpbzcuE3AKyLSlseMJHA3F6qSR4w0C4POFkvLMuEsC0PmFdwS9to\n    vjnAF/sJCqR3/xHzgCMaY/zDIxz+4ggYYE0Cu4hgifnfZ0gfpED83esdKi0we+sC6iyvP7uLub8R\n    HaA4m2J2/VOoRb4e72jM4wolPmYOBBFbVvtKhZOd/JXHB6wPm+MGVxzzzXOpMF4Xf/39KeYPngBF\n    JOEimmH842OMf3YEJAgmgclhI72XIr0fx9JNQKUFJncmyJ/KFFM79OcUMDhMcPy7Ewy/EcfSiAYI\n    yP1VbBy15f4mYn3I14Ou3N/EWBP7c3+X6+hy7u8CbXJ/jTehUe5vqPUzXQOgZP08ZH1I8jcX/cl+\n    OGks1b8u62cY15ftqNtaP8v7LyquC7V+dr0mG7l8mayfbf01sX6W6Ev96wNvs4vWz7us/t0HhAgI\n    zzbwOkIFlX2of/u2f96F7N8a6l+gSwvoy6wC3gTOAtpcVhWwC11XAnVFAh9DdWZ/UXew9Q3mdSvI\n    JoHXhk5qqiZJIVbQdSZpba2gUywnpFWVgDaSd+F5brtXHSvokDxg13Wu1yRVwLZFRRsraFr81MkD\n    5gsz2Q899uUB2+5Dx0PzgOk1t8kDHrPN5SZ5wIPVeW55yYndnNk+8yxgW86Tzj7k9mCr6/JlHnD+\n    bFP1hBGXCglw+KtTjL53sN6MXh52f34q9mB28wKLL6NyrlfkCot7M8zv189djrm/EV2gmC0wvfNP\n    FE9npc1onl0oiVubIpjGy7LSSSt5bV9qvWFuKo4lSWzLAHaRy9w2c3r9n8ge7WNSWcQuIEmAk98e\n    Y/TdsTGWBkEBszcvkH2+qHNVRF0UCun9FIv3wsqXaR6UrP43/vkRxj+OY2lEMxQBub9k2+zK/dXZ\n    vtqHih+n3F/KBpYuHU1zf+lck9xfvrZumvsLS/82ZbDL+pn2KExS17xG5v7qfQx9zEf++qyffbm/\n    QJgTnBQM+EaLTVg/yz5s1s+A3ea5jvWzyw2vS+tnl/rXB5/6l9CU/HXt34ZYP3PY9qO7jCv0YR9n\n    012rf/uwf+6D/O1T/ds1L7dp4eimhbGEmuQv0AUBvKkfltj7rv8xQ37ZQqsW2uJsQ/fpC/Qh2NWH\n    2AnUxgaFTd2naoBtYwXtau+DtIJ2kb1Nsi6aTqp8VtBN7rFvVtA2yL7rLAAIrjzgKitoGwnM25t9\n    ua2gzfNlEhiWa6rsnJrmAXMr6KqKYb547SIPGFhaRuesH56/xFVSg/UjvhFtzwOmDW9auJv2l0ty\n    OH8xw+z2PRTTmGMYUR/JwQDHv7+G4dcpD3h1HNVqYDUtMLt1ATXJK+8T0QAKyB7OMXlzggT1rJ+B\n    mPsb0R4qL7C49xiLe88gyV8+TkmrZrUaD8ntgo+FObSDhlbluhXAXO1L8Ql8I5y/loFlo5y7b5SJ\n    6lV/aYbZ9ZgHHNECR0Mc/+EUg5cHxljqA7VTM4XJjQsUL+JY2hcWny8we1OXervGUz73oXF39N0D\n    HP0m5v5GNENV7q8en/R3rgKmdaKrgInWpJpA1uMgrU/3NffXtefA+6Bjcs1v23sIzf2V+yC2gnp6\n    bCvAl58w3H6aY2FcUU3+1rV+9u1LjaGckWVdWD/z7F9+jK4JUf9y9GX9bBO2VFk/287TsTb2z22t\n    o0P3kzmqBFAXcBPHJzXf/67Vv669/qbq377jKqNcozk2Rf7ugvq3AWIuSZ/oo0pi14O8m34YVn34\n    dkXQ1h1M2qiAXef7qKg66mAiQejKCto3WQpFlRW0K/tDtunCCto3MW5qBe0i1ruwgrbdj+7qOyYt\n    iGyQub688lVaQdsslmyLtKo8YNvrpoWiLQ+Y9ykXk3SPbeYBa+WxXrxzMrhgV7jygJP11jUnhAsM\n    1oTy0jwrAVlx5lh88Bjz9z4C8qjGjKiP4TfHOPrdKQaHSWnj2kYC8yPZp3PM3p5CLXZ7HrOPUM8z\n    TK5fQKW+ci29IchdEmLub0RrKIXss68wu/VPRs7a3Su4rbNij83fT37OjEaQls78P2kHLZW9tJlt\n    I4z12Mxto8skMKCQfTFB+ud/xjzgiMYYfmuMo98u84DtI6f9kzwBkD/KMPvzBFhEK/KuUbzIMbtx\n    DjULf2+J/B2+vMr9PYpjaUQDrHJ/55bc34QVCvO1pCv3l1S9Vbm/A1ChlS423mTuLy/KBprl/pou\n    XWahOFC2fraRsHovoVwIr68rR1RJBzNp/QzYc39tcVt0T+rTZf3sEgzY9oXqWD/LvqT1s0SX1s+0\n    b9eX9bPtcahQxZb7S2hi/SyPNVX/uo6FqH+rrJ8vm/r3Bex7+k3I3z7Uul1jV6yfgTAhZV+uvH3b\n    PxP2SP0LdEUA0w+9KRvoq64C7poE7uODrEmftg/hy6gCtqELFXDoxEBiEtiuab5FHRK4yaRtU1bQ\n    El1YQUv4rKDheey7TlpB03smK1YJrgWKywraln0jrZv5/WUesLRJktf58oBpoenK9SlgVv/S4nMg\n    Xj+RwHyx2SYPmBbHekGsF9FaERyWBzyArvgm1ZK2ljaznMp5wFq1xPOfprc+Qvbp5zEPOKIRxj8+\n    xsHPlxmGIeol/ls2uztB9nEKFX/1OoNKC8zuTpA/yS3/Fpy80kfWiLm/ER2gOJticv0zFAu9SS2J\n    VW5Ryb9oTNPkrHlekr/c7jkptTWtLMuk7vJ+FNcg7yMzgtX6fmZfCgrzvz3B/IOnMQ84ojEOfnKM\n    g58dGoMo/aYvYX5+88/u+dszzD+IecBdQi0KzP48weKRXvH41L/L78s2g8MER789xfBbcSyNaIBV\n    7u/Ekvs7YGNQItaEchzjRVcy95fGSJ77qwliWQilbaIBf+4vt24mhOf+8r+wZrm/AJwuXk1yf+m8\n    7T4Daxt9z9Dc35Hog5O/cs/Fl/tr2wO7atbPbnK2jFDyl+9VphXnQ/pwIdSi2Wb93JT85ahD/u6j\n    +pf29uve34WurZ+3hbMG1/Rl/xytn93wqX8bkr/AvimAOYu/DRI4Igx9WEEDl18FHFptVWUFPXW0\n    rwKfqDVRAddp44OPBL7KVtCZpW/XawvJA6aFhrSCHsFuX1SVB8zb6vP2PGDCJvKA5fZN33nAClrZ\n    68oD1vZa9jxg2nRWbNG+1O+G5wHTRgCpgnlVN/Ic0zfuIT+LBjMR9ZEkwNFvTjH+7gEAkwSusoNW\n    OTC7cY7iaVTOdYJVVuHs3VRYP5c/3/gnxgAAYu5vRAcoZgtM33qI4ukUZaVuOduX2zLL/5J12zJ5\n    rNg5/jUwCqM40VxWFnMS2LapDvG6NJFcGK8rQYFcKUxvPMT88/Nt/xNE7CmSAXD82xOMv2uShvQb\n    7LwOgCqA6c0JFo/jWNoJCoXFhykWb+tVtG0mI22f6cHBz48w/kkcSyOaIX9+jtkf7yERub8FCmSr\n    cUfm/haWsUuvGYvV3JwUwwUjdMNyf7Vy15/7S8eb5P4Cu5H7y9uGWj/LtraCdnpcZf1c3pOxY1+s\n    n+uQv22tn2UbOtaV9bN83IX1M6D3a+taMe+i9TNQXzXs2tfflPVzU3RN/nYtxNt1t1iOfSZ/NyV8\n    7QHdEcCbVgH3gT5I4CbVEmcBbZr+ce/6dr/LimHbKmBf5VBTEtiHJoMz0NwKmu7Hr3NNXOpYQdss\n    nPn5utiEFXRdEniXrKBdCwMbpNUQXUVwWUG7SGAb4erKA7YttqoIXd5n+WfsJg+YrKDb5AHT4ngk\n    qqrr5gHbNs01VayVUDIPmNtB8zxgTg4DBbKzKdK3Yh5wRDMkR0Mc/f4ahi/brQ4lEazWx4HF8wKz\n    2+coalgsRtiRUVYh+7h3vatEmdHn4PiVEU5ePcEgulVGNMQy9/dLzO8/A7dI5mMRkbTmsUKQs3KM\n    kmphrfxNRD+yvYJJ6kplsEkw61xF2zgpSV9OEA9QQE0XSG98huI8jqMRzZCs8oCHLy/3ZAZi3KRn\n    +jd1dR2A4qLA7NYF1CTmAbdF9iTD7NYF8sLtasLnNFRwpQCMKfd3v3QVETsClaZI79y35v6aufRm\n    7q9tvOJjnIxFoLYhub9SDVwn95dft8u5v0B576KN9bNEHetn+u5T/7r2m0Jc4jZt/RyKLq2fbdfV\n    tX52kb91UeWaCFwu62ffXndX6tu6qFL/1rV/vizWz5vEsy3eexP2z3uo/gW6VgBv2v960xLvy4yu\n    P9QumwrYhdCB8qLBtftqBe1D11bQHF1ZQUtU5ZfskhW0qx+XCrhM3oYvWOQ5lxU0zwPm97cturA+\n    Yq/i3UQeMC1O6+QB06K3WL1HtsUyt9SSi+vRypKLiGCbipfUwuU84IKdlzZgOg94IPKAB8gxfz/m\n    AUc0x+hfxjj8rZkHLDdOXWrg9IM50ndnQL5bi5V9wjKr8AJqRp9Vyy1AV6Jkwj7XBi8PllmFMfc3\n    oilWub/TW48gbZ8hiFlpycyfF6LNcmw12/DraGyjsZGribnjhVQZ83FUZgG7NsolcazHWH1d9ugc\n    6V8eAYs4jkY0w/BbYxz95gTJSghMkSAAID01OM0DANknC6RvT6EWcSxtCjXJMbt1geyFvXxKFrRx\n    t42Y+xvRCnmOxfufYP7uI8PSWeb+QhC/9XJ/c2M9SWNsVe4vFSoP2NgZkvvLyd8ucn8HsLuCtc39\n    lddI8tdu/ax2wvrZZ8HsI2Qvs/UzPW9j/ey6R131rw38miqRhgtV1s99oA/r502pf3NHf02yf4HN\n    qX/7FOyd9dh3Heyz+nfPsX+lipLN3+Q/9iarGM4C2nStAu6LBK4L14dy3vHrc6GuCjjECtoFOWDW\n    qbyqIoG3ZQXtUwHXgc+6xWUF7ZpQ8XvXtYLm51332aQVtK1v12trYgWtLZ/DrKBtZG6GcgWuzQpa\n    XueyTyJsIg9YE7V18oBNBbAvDziBnQSWCuGELb7J7sueB2x+yQ11Vx4wHZ/e+gjZwy8QQ1kjmuDg\n    J8c4+InOAwbsJHDC/rrpfHr7AouHc7vPYoQXalFg9iedVUjqsOV7Ldquvq9tuscJjn59gmHM/Y1o\n    geJsiun1T6EWmeFCAXAVrknEDgz6yp7zSwQrH2elmpeTwfTFCd1yNrBJ9vLs4WQ95tqUyct+ZR98\n    4z1BgfQvj5F+9BQq5rFGNMT4p8c4+OnhMmMBZqwC/w6UXR7Su1NkH6dxGtcAKlOYvT3F/OPlqpDe\n    dyqakgVVnPyNub8RraAUFv/80sj95es7qfJ15f6a8QVm8ZJeCwKk/nXl/ur1o+l2lbPrQ3J/bTm+\n    Ibm/EnS9zZKZH+8z93fI+jfbhJG/tkJ7l/Wz3PcIcXhz7fNQX6HWz5L83TfrZ36sK+vnpuRvl9bP\n    R+K6qr3cUPWvDbY96Kb729vGC3RPJm8KTcnfPtW/feX/7iseY/PC1w7RPQG8jTejSxJ4V2ygQ3FZ\n    raBdOIXaORVwKDZpBU24bFbQsp8QUllOAHfJCjqUBDbJW3uFZ92FAmAuOlxW0HzxUicPWL6GpnnA\n    8ppN5AGTtVRoHjAtiBfs/NIySucBLxe/mtylvN9s9fp5VmIOM5+QFvXJemNAOfOAB8iNjWm9AUAb\n    1jm4fTTyHJM/3kN+1nVdY8RVQDIAjn53ivEryw1QubVjtBVni4XC5PoF1POonKuFQmH+QYr0bXME\n    leSv9d9ilfs7jrm/ES1QzBaYvfUZ8lXur7aJ1LbJ0p6Zk79Scauf63GQFzPJnF5+T6lIgqVvHo0g\n    768ziSEKpuykMR9z10pgVWD6xmfIH28qsCbisiEZAMevnmL8ymhdhuAqptL2rksUOTC9cYHiaRxL\n    60ApIPskxezucvWr3+8y8UvnFXsy/tlxzP2NaIz8+Tkurt+Dmi+MwmDK/eXjEXd3GqzXcbzNchRb\n    FjVrJTDv15b7q4uV9bpUulVReyJDiRQmQriL3F9ZeF0391f3Kd5j2AnjLnJ/fQRySO6vtH7mWDge\n    +5zgqvaJfPtUHDZFrqu/JtbPnPztyvpZtqtr/ey6f11Ukb9AO+tnG+paPwNhAqSQfetdVP9S/65d\n    rSbq32tQO5/9G4Kzjd9xM9i0+rdvvrNH+2egLwXwppSalx1nPfdvI4H7UAE36dP14UwfvtvaYmmr\n    Ag6xgpbP99UK2ne+SytoOaELsYK2YRtW0K5+qvp32fyEWAUtLP2GVKjSedf20hAxD5hbYvGcpBFb\n    VPNNa54HXEDnAVM7Vx4wvRquQuKqqOGKBNabCXY1FW24588mSG/fRzGrq9OPiACS4yGOfv8Shl8L\n    m1NyK+L8SYbp3QnUPOYBhyL7coHpzclKta+VlhxyFKGN64PvjnH86mnM/Y1oDMr9Te8/s2YQcjKX\n    bJdNotVU0mqCl5PFuUEYJ+z8YDXeDcTXaE3QmiQ0zyBOLBvgegTmBVWmGtk2Dsu4hWKywOz6pygu\n    4jga0QzJ8dJOePjyslQQcOfRAgAnaPLnBWa3L1DM4lgaiuIsw+zGORRbTLhiKwBzXB1/9wBHv425\n    vxHNoNIUszv3oR6fw5VDrzPttbvTkJG/gGkDncBc8/HxKiT3l+f/0jrVlfu7JHO7y/21WT/Xyf21\n    WT9vIvfXpdoNyf2lAvCq3N8Q6+eRuEfVdXK/ihPu/PzY018T62cX+dvG+pngs36ugtyL7NL6maOu\n    MIdft0nr51DRUtPM4L4R1b/doQ8hY5eCSxv5+/U9/fffEC7PrDWqgK8OuiwwcA0QPoK5DyvovmCz\n    gg5FWyto2WaXrKBdKmBJAre1gnaRtrwvqQL2TdLpObcYcuUJ+ypGbVbQCkrYMlcvZFzVrl3mAXPy\n    edN5wEQC+/KAtWoXohJaGXnAA7bBLNVNvB+ZBzxkGwG0BcBzDZXYzC7Y46o84AHLA07f/wLpex/H\n    POCIRhj96xiHvzrFYFzerlaO56SGn707Q/ogBaJ9aiWKi2VWobpwb4G5yN/hy0McxdzfiDZQCtln\n    Z5je+ie4QlaPOzqPXpO1poo2YY/NAgY+PsJ4LsfJqq+q9lJRLBXLnNCm/oarAi05hvPrFw/Pkf7l\n    n1CLHBERTTD89nhp0T/Wn+VJ0JUK8w/mmL87hcriWFoFlRZI3zrH4mxJmNN8JOSdo9zfwdHl2UeL\n    2CAsub98XabHMDP3V8b86Mggs4CJ1nxmkbDO/ZXjI187mu4aZu4vjX91c3+XSmFN/gLVub+S/N1m\n    7m8Ou/Wz3AOpm/tbRf4Cbne3KutniD456uT+jtFt7q9tD7Ct9bN0BbRd49t77ML6OeQ8kbhdqn9D\n    2jdR/4bAt+ddV/3bFcj6eR/Vv327s541uGbXrZ+3kfv7zS2+Jx2of4E+CeBtvDm7Hv7c5I/orOfX\n    tCkVcBP4PqS7tILeNEJUwBJNVcC+9iH3qyKP99kKGoDXCtpGAte1gpbH2uYB8zaufJdQK+gQErir\n    PGBCSB6wTXFblQdsu4aTxRCP5eLUlQfM7aFtlcpl+8llC04Cm9m+xfpcARjkLl+My+88D5hyfwdi\n    YV+VB1xAldrTT0MZh9NbH8Q84IjGOPj5McY/ObTuVktikm9sJ0phdvMCi88X1Te5wlBZgfTtCRaf\n    SqM3N4j8TQ4HOP7NScwqjGiF4qsJJqvcX4ixTSuWYJwjgtdmPWlaP5etl/kmNm1Q6zHU/kVjsCZn\n    TSUyf12F5TlXKMuirYT9vFJhpVavd/rnL7H4+GksaIlojIOfHuPwp4dQidajukhguSKZ3Z5g8XBe\n    PThcZeQK83szzO7PDUcS2xxFYnCY4PA3Mfc3oiFWub/TGw9WY1NRWpfx4t0ucn95PAN/xAuZhqvi\n    Yxo/bbm/PAaJwNXDZs6vuX6WVsq2nGBYngPbz/21uZJ1kftbZZ9cN/eX7hGa+0ttCaHudCErtSon\n    vSqlb6j1M9Cd9bOrzxC4SodoH7QN+VuV/VuXLO4CTayf+0aV9fOuoGvyd1eFgM8cx/sQWm4K34TC\n    l9t+Ee3Rb+ViXyTwJmTdrl/OZzX72RTa/PFvggTui1TukwTetAqYD6S2QbWNFfTU0d6HCcIUxFUV\n    bxKuiVpdK2hXn4QqK2i6Rk5C+XNfpaILNitoG2x5wAi4rqs8YFffRAJD3ANwW0G78oDrWEGb5+0L\n    PLpmyNq6KoLJKsplOW1bdPrygCH6qcoD1gvb5WIyY885CcwJYl0R7M4DpuU6KZKWrzVfb1rzTW+e\n    BzyESQ5n6610tkGeLTD54z1kX+1reU3ENpEMExy9eg2jfzM3Rl25tMbWyDTH9MY5ivOonLNBKWDx\n    YYrZXT1ShpK/Kklw+LOY+xvRDsVsgdmbn6F4Oi25TfDNaJlbqPPraTM4X49kkvDV5GuBwnLe3lYq\n    n9xfNrVxwo5ropqT0Xnp58qh2Phrbq4PVI7pG58if3K+7X+yiD3FYAgcvXqKw1dG699YIEwJnC+A\n    2fVzFF9FNxcXFo/mmL55Ydg983mJc2xd5f4exLE0oiHy5+eYXn9vnfurx9IcGcyYAlq3Ue6vJnbL\n    ub+68NcsrhqKYyNGDvPc3yV4jq+Z+7uAJo1tub98Hc6LrWVhNS+o5spdrPsPz/0N2UewWUA3zf3V\n    beyfENJFjWCzfrapk6X1sw1yr2ck3ssQy2jb9dL62WclHaL+5Qi1fq4iXVPHMZ/1cxX561L/yvNt\n    rZ+bwkf+hpDJVW2aZv92bf3c1rL5RUA/TdS/QLeE8jZyf4Go/r0M6Ej9C1wmC2jCrv8y7KIKeBPo\n    SwUMtCeBu84JCBkUt2EV3dQKmtB08iNVwIS2VtB8onjo6C/ECprgqkxsagXtygMeefqqk9ciSWBp\n    Be0jnm2v0a3kDc+04ef4wsxnBW2r0rURuiELvvK/Rzd5wJxMlq+FrrPlAfNFsy0PmFdO02vlecD6\n    mMx9IoJXt7HlAdN10mraVAJrW2gFheLZBdI791GkMccwoj4GJ0Mcv3aK4TVzfik3rjkFQ+fyRwvM\n    /noBlcUMQ4n8cYbJzQlUUVYq2bAmf5Hg6LsjHP/2JGYVRjSGygtk975A+v4z0NgyWI9WWv0qrZPN\n    XF3TqlISwNSnWo1t3MWCW1pqQrn8xQudiEQuHP0DppJK2jvz1yrVyrogqzB+tjURfT7H9OanKCZx\n    HI1ohuR4adk/+hqZE6+OW9py0jKBwuJpgdmdC6g0jqUS6nmG6Y3z9Xujx0pzXLW9z+NXxjH3N6Ix\n    KPe3eHwObfusv9tifPg6Trpi8ELggWUs4kVKQPPc3xQ8x7ec+wvYbZn5+tuW+wu0y/2lYy7rZ7k3\n    MxSvt4vcX5eS1xVlRXsdTa2f+Xnax3GV+lRZP7v2mXwk9L5ZP/sgyV/5uK31cxfq3zbtbferEhuF\n    7E83sX4G3Pv1Xe7D77r614ZdVP+2JX9dgsmu1L8+vq8voeg2rZ87Rv8z2G2ogLsigfdNBdwGm1AB\n    N4WLBO7yQ77J4OMb5LapAg4910QFXDXJccFlBS0fb8MK2pUHTHCRxXXzgIHqybVcAITYSwPLyT9d\n    a7tvmHWQXsi4KlTbW0FLEth8rfI623neJ9AuD7icU1QmmiUJXCcPmKqfQ/KAy1aS9ue8YjxfL5nL\n    ecByI5sqyHO2gc1tNvn3+XufY37/EyCPasyI+hi9coiD/zsBRuYWatXGNQCkf5li/mEaXcgZ1CTH\n    7M0LFC/y9Wa1D/x9Hr08WOb+HsXc34iGWOf+PgRX0ZqZuWZebrIejzSZW4gNalPBVDArVlORCzZ2\n    KnEsYV8DMe4plMdmrhAesPFxiJyRx6aC2Xy95tjMx2Ww15GgwOKT50j/+ijmAUc0xojlAQOc5HUj\n    wZIEnr43x+x+CuRxMCWoRYHZnybIvzBXEyHv0PDlIY7+8FLM/Y1oBpb7ayso4mMpX7fZCpHI0pnG\n    w5xF+dhyf33ryXLf5dxfvmZ35f4C5XXxNnJ/zT0HrK/hyt2+cn991s++3F+JKutnSf661LquPmXb\n    Mdwihb6tn+XzptbPtuNNhCZdWT8T+rJ+Do394+hCtXvRUT+ELsjfPtW/XXIh+6T+bYPLyJNtm/zt\n    UP0L9EkAc3/sbb9pfaDNL3dfKuA+qkB2/YOvKxVwU7SxgnadryKBffBNMvq2gq6aBEm4qvY2bQVN\n    8E1Kqya0LvisoPmEfcwm9b6KTXk9n7DbSOAmVtAyD5i/EoJtEdUkD9hmBS0XUTxrh9/Ptkjk95JE\n    risfqM88YH1Pex4wX3jb8oBlThNtLGeAoQBWYsHPN6z5xnW+uq4Q56mfYtVTggLpzQdY/PNLRCYu\n    ogkOf3GCgx8dBrU1fsMKYHbzAvnTmAcMACpTmL09xfwfaZD9J7VRWGYVHv825v5GtMMy9/cTFIt8\n    vens2sAmApUToqGWzAM2VtEIm6w3o4vVmKyVwWo1rvL8X/qPj6f8uY3ApZ+IE7lSrZwYbel5sT4n\n    70dj7OzPn2Me84AjWmD8s2UeMH24+0hgfi6BQvrmObJHIauVK4BCYf5BivQdczUr/zITlN/bwTjB\n    wa9PMfp2HEsjGqAi95evx3iRr1zL8TFLErya1KX1oTv3VyuLde6vHNfHrG+e+yvdqyjuyCym3s3c\n    X9OVzLyPtH4Oyf2F5X6ufRPq0yUOGImfEXArgm2P61o/E1xZvJuyfqZ2QD3yV1o/S3fAJtbPtr3I\n    Nu6HbZwXq3J/gfrqX44+rJ+3kf3L9/9dwrCm5K+vz67QRv3bF/qyft5n9S9hE/m/3xI/Q8fkL7Dv\n    FtDbVAEDl6/CYRc/hAghKuA+rKDb9NmXFXSTqi+OthOSLq2g61baAX4SuI4VtIuAtlUqpujeClrC\n    ZQUt4bOWzizXux67rKB5W57nSz8hISQP2GYZLdW7IXnAkgSG5RpOAldlCMv3PDQPWFY9A5o05pZY\n    tDjmecB6oY61SbO00BqxTeSC3U9vinNbaMBU9/I2mtCl/mQeMCeBbXnAar7A9Pp7yJ/HHMOI+khG\n    CY5fu4bRv47M4472/K+seJEjvXUONb3ayjmlgMUnKWZ3J4ZNJQCmjrRcByBJgIOfHWH8k5hVGNEc\n    xWyB6Sr3l4hPKl5KjPFLjzfSwUISvXKDmxOrMsNXqoK1aqhMMHNlMCyvj78GeS9KSeQqYCqY4kSv\n    qXo2+9ZjPMtpzHPM3vgE2dNtBL9EXAZQHvDo3zX56Fs5cRK4mClMbyzdI646si8XSG+eGzWNQSvQ\n    BBj/9Cjm/kY0RmjuL5GyCtW5v7rgqGBtAD0msVz69TinSWBX7u9yHNQ90Lmq3F+NcgG1SQibSts2\n    ub9yD8BGGMtcYl/ur81NzHYdITQey0ce+3J/fRbMC/Y6q66zWT+PoLy5v6772vqkf7+21s+hqOP6\n    Z0PVPmRX1s9AP9bPE3Rv/RyCptbPgH0/vUvr567jHIHdF8GF4GzD99smN9YX+XsJhaz9EsCbUAH3\n    zfT3hV0P1ubo6kPreYd9ceSsz22QwFfJChrwE8h1raA5mlpB23JDmkwKd8UKmk/OXX36cltcNj62\n    +8ByHdBdHrDM9dV9m9W70pzUdh1fQG0qD5grh/nr4ItSfty2OB5DVj2b1dNcNUz34+RwAdPacqkW\n    NvOA+Wb7ENICzJ4HPEQ5L4rnURVQKB6fY3r3fRRpVJBE1Mfg2hBHr13D6KTaChowCc75R3Okf59C\n    ZfszV+oaxdMM0xsXQG5uVLuIX24PffDdmFUY0Q4qL7C49wUW7z81iFRNpuqNZ3rM84BJCczVSgm4\n    9bJdIUyKX2lZyYniKlUx3wjnr1cqe8vjqP1xYbxmM6dRX19YyenifI7pm58in8RxNKIZkuMhTn5/\n    itHXzA/0qoKqBMDiiwyzP11ALa5uHnBxkWNy6wL5hX4PbKOoK/f3+NVTDGKKQkQDqDTF7O4y95dI\n    Xb7eovGEyN86ub/SfQMoFynx3F86Zsv9lZnAKbQblo38Bern/trIX1/ur+2vlOf+8mO23F9ZeB6a\n    +8v+9azXSetnfr8Ra8OvpWua5P66rJ85XOSti/zlr0HeG6hn/SzJX0KV9XNI7q/c/7K1q6P+de0v\n    9mX9HII61s9N0JUgqUvr5y7Qt/q3K7i4j7bCuz6cX9vwUz7ydxPq38uADah/8W2oy70ztIlfkjaV\n    DnX/yM4C2rT9MHB9GO1CFcwufIjXRRsraNlPHRSe9m2toAE/0VvXCpq3D52ASTLWNhmUE8AQK2hO\n    AhNCrKCrSGAb8WojgaUVdAgJbCNdm8SSh0kAAIAASURBVFhBu/KAyQq6aR6wqSLmfZgLQZ8VtFxs\n    8vtJQrfLPGBe4SzzgPk9VOn1lSukeVKvXIDXzQPmFeTmxruZBzyw9C3zoQpL/hTflFj8/Z9YPPg0\n    5gFHNML4e4cY//IYSY3NU/orSt+6wOLhPFCmc7lQzArM3jpHcZYbP34C39i7xDKr8FrMKoxojlXu\n    7+TWw1KhkKlgshPDnBQu5+gWzNlCE8N8c5ruKb8PLPd0qXFdKmAdp2Ans/UYnbN+9GtdnjNVwZz4\n    thHi2UdnmP/9EVQWx9GIZhh95wCHvzLzgH1DI51PAKTvzDD/IL2SVuRqoZC+PUH+qV7Bhb4LlPub\n    HEf2N6IBKPf3749ETE953cWLi6pyf8Ee23J/Q9aRsuDKlvu7VAPr9awkjekooK2hXetlub52kb+m\n    WhjGtbJ4nGCzX7Y5gFXl/hL4HoVNvRua+0ttusj9pcd1cn9tx3nurw1NrJ8lQqyfm5C/hDbWz7Bc\n    y+/TtfVzW9dGibrqX7l/3NT62bevvA31L++zL/Vvn/bPu+y62gRt+LAusAn17ybsnzeEzW4O7asK\n    uKpqYdu/9PuEvj5Md1kFHALb4Fs1aFdNKqrO75IVdFqzD36NjQQ+FG0IoSQw4LaClvcKgc0K2gVO\n    AjfpX+YB2+4ZmgdM17XNA7aRwCidt5PA8j62PGCO0Dxgm8VTwa7lfUgbKerDtwjm1dR0vGz7bCeB\n    bXnA5iJeW0PTop8UUxkU20Aw++Eb8krYQvM8YK4ITlBgeuN9LL54jJgHHNEEh/93ivEPlp/K9BtU\n    lWerAOQZMLv+AsVXGa4SVKYwf3eK+YM5e7/Kls+F5V2Mub8RXSA/m2B6/WOoxXL7UmbbciI0ERvR\n    ZqGSMp7TGMYzghNjDLKNd3r8Gqw3ypX1P9kfH0/5fWnTm7KF5XlpRa3Ha5l3XFgem2Qz9Td76xEW\n    nzy7kiRcRDc4+Pkxxj8+tA6g/De1dLwAZjcvkD2u0nJdLigFLD5exijw98MG/pYqxNzfiJYQub8J\n    U/zac3/L6zFzTNVtM9GPXgf61o3l8VC2IfKXipf5+pV/heb+kpLXjG9YgrT4LvJ3G7m/gCq5nrms\n    m0Nyf2mfoir31+fO5ntclfvrigzbpPWzjfx1kc9VkC5/dffibNbPqeX8Nq2fq9S/dZTBIeRvCNoE\n    mLTdkw9B1+rfXRC9VSFE8HdWs89dd6d1CTv75gG3hZ7Uv8AmCOBNseX7+o/fxx9bVAH3g6YkcIgK\n    2IWqwXqbVtBA2CTId54mW64JXR0raH6tq5owFDYraHmsiRW0L78XQGlyTlWjrj6r+gt97MoDloTu\n    0HF9aB5wmSw2SVgbCcyJV1secGa5JiQPWJLAY3afMsysXjom84BlZhLPLuRW0Lyim2cy8XvwPGA6\n    NxKbAbTZzPugTQGt1MpFe63cylBWElP6lNYuFUA6x+yN91CcxzzgiPpIRgMcv34Nw28tzdFcJLCN\n    FM6e5pjeuYBKr4h9pQIWD+dIb1+sPw1sql/b6BZzfyO6QDGdI33zUxRPp6sNXxvJWSZVEzGOJWxM\n    MlW5pvrJlgdsV/XC6Gdg+fIpgxNHGyKebcSuJLZtrhrcHlqqhZNVoVUCBZXnmF7/BPmzmAcc0QzJ\n    MMHRa9dw8O9+UpLGjYT9tuYXBWa3LqAmV0eFXjxbYHbjHCj8immae6zbxNzfiJbgub+KrcmKVaGu\n    VO7y4l3utgFocpgXXenxB2zs1ePOiI271H60pl3Lub+S/MVq3SrXp2Y+L8Q6mK+jZfyRBo3n5r6J\n    8q7bN5H7m4l7tM39dZHEvgJ9Fwnrsn52XVfX+tm2f+Trk/79qqyf5bEurZ8JTdS/8tpQVO1LtrFv\n    rhLmtBX+2NB2NuoTQLn2zbtU/+Yt+5IgfqILwVpf1s+7hmcV57uyf7ZhU/zfJvhMbv/cI/kLAIOS\n    1/Rlw6a8wqt++bvC2Ybu0+eHE32odl0V88LxuAlcg1OflUybtoIG0MoKumqiUtcKmk/CQkngqirA\n    Lqyg5UQ2RTsSWKKqArNuHjDBZgXtuq5JHrBNncsfbyoPmC/+6uQB0z35gtVtBY01jerKAx6I90Dm\n    JUkSmOcB88c8D3i0MmimBXoOs0JbbqT7NtQTRuvKjXyeB6yg1b+8r/yLF5jFPOCIhhi8PMLha9cw\n    Ol5utfo2YumLkL43w/z+7Eoo54qvMkyvnyNb2FW/BGWhy2Pub0RrZDnm9z7H/MHT1ZjAN5HL44zN\n    WpIXISk2vulNav2ccoJpHKQcRG6xDJhjtS5Ocv+n/27MAilSEOvN+PIGN70+qZKyEcJYvUf8PcmN\n    tvw9UVBfzTC9/SmKaRxHI5phcDLE0e9PMXzJnQfMxw1OBM8/WSB9ZwK1uAJj6axA+uY5suf1t4gP\n    Yu5vRAuoNMX07vvr3N/Esa7iub9Lda4megtGENucoWzrPkAZ60S+fhyhMPJ7eYHyYH1PTYracn85\n    4cojlXi0EnfJKt9PrzK59XNIfBPQb+6vbqOv81k/8/vVyf0FwhzZXLm/IdbPtn0ibv0cmvtb5UQn\n    ZzE+62fehlCH/AXaWT93of6dIVz4Ulf9O7Uck/1tw/rZ12bb5K8P+xgbGYpdyv7dFP+1DfTlXLwD\n    2Mwu0VVRATf9I9hFFbALXZO2Tfpzfai3tWGWaEIC+15D04F2l62ggf6toKtQlQds67eOFTTHuGKi\n    GbKlF2IFbcsDrnr9sq20gq6bB8xBJGwGezZvaB6w7dou8oBdVcK+BaW8J13jIoFlvm9IHjBfNBes\n    PfXPq6RtVtAyd4kW86QO1hvrZRWvzAamzEN+H9O+sjoPOH17mQesiiuixozoFIffP8TBL9x5wPKv\n    lBPBszfPsfj8cttXqrTA5K0L5E+z9Qa+TRVN6i7+2TX++iDm/ka0g1LIPnuGKcv9dZG9PN9WqpXk\n    NYnY5JbjDydLAU1WSRJWiXa2r4HlGlR80U8yBHfBgLFxv1RZ6feAk8fLv8WyRTa3tabxtIBC9sEz\n    pO9+DsQ84IiGoDzghAmBecGQSQbT1/L3cHpnisXH6aVO9KAYhdkH5VWZy3mE3o7R1wYx9zeiOfIc\n    2fufYPH3f4rIBHfurxxjC2jHitDcX9f6kCt3+djIc3/pPJGztiJmwEa4alJYrotDyV/e7zZyf3Oj\n    jzDyNyT3t3x+iYVxRRj5K19DlfUzB++jy9xf2deB53wb62e+x9dkjxBwk7/0uCvrZ1L/NrF+7rJ9\n    U6tnCdqT7qq/rrHL6l8XdlH9u6/k77Z5vy6xQfUvQATwJlXAfbPp2/5l2PYfQ5fYhAq4KVwkcJcq\n    4KawkcA0eG7LCnriOI4ax+X9uArYNylqSgK3sYLmcFUHhkwk61pB8/OEJlbQsi+Xipfg64+TsTYS\n    2LWIkAuKEZR1wcUXPU3zgMvn/SSwreq3bh4wnZc/A13jygPmi+Uc1ZnDoXnAnATmG+PVecAmSUuK\n    3oRtY/M84GFpc3p5jizG1HqjXl+rbSwLzG68j/yLJ7jUu4cR/SABDn91ioP/1HnAcjOWb4+xy1DM\n    FGY3XqB4cUlJk1whvTfD/N6spIC2gZ8fHCY4/O1pzP2NaIXi7AIXb3wClWmVEjc5JgWtVPpy6+OB\n    GKdsebhEthLJygnjBGbhEy9g4m04WZyI+3DVLb+GXoG8frD6CWkD3EUwS9J6wKyezYIpN8lM4/Ts\n    9kNknz2L42hEYxz+9zEORR4wEb223yoaV1SuML1xjuLZJS2oUssYhcntC+PnZqdtlwAAhuMEhzH3\n    N6IpVrm/kxsP1usqvYYy11wU0aNQzvwdrsdRTfTmoh9ZbORbH7pyfwfimFz3UhtOvsriaH6OCFYe\n    Z1Re9+5W7q+NNLYVtMv78ePS+pn6lfsfrtxfOPqyEb5V5K8kkl2ucX3k/nL1L6GN9bPL5a+O+rdK\n    +RsKl/CiCfkrEaL+9aHqfFP1rw/bUP+Goon6dxMCty54lb4EfnWxab5LOvpuku/blJB1g9icUmCT\n    b14fvxR1/Mub/FHskwq4K/RhBX0C1Snxuw0r6BB0VY11xCYutuM+dJUHzCEnZ02toF2TxSqF7y5b\n    QdNiwtXnwtOfLxvYRx5LK2i+mHDlARNstkv8XLmC1iRhbSSweb6/POAhu5YgSWBZ+WvmEOp7hOYB\n    0+JbZzoV69dUlQeciI1nuakOttmwPG7akPE8YL3pYF5LG/FZusD0+rsozmOOYUR9JAfLPODRN5Z/\n    ZTYSmCDJ4OxRhtlfL6Cyy6dAzx7Nkb55Xkn8yk/aJAHGPzvC+McxqzCiOYrpHJPbn0KdTQ1Vklbk\n    kmKJaFtTXSttKU3LZT0+6cgBTf4SISsVSuX7l5XB/i+srx9Y+pXKYTo7XBdRlX8++/Xmz6cVWpo+\n    l7EMKstx8cYnyM/iOBrRDJQHPP63Ub3rABTPc6RvnqOYXb6xdBmj8ALJwvy0cL0X/Mn4p0cY/+xk\n    2z9CxJ4if3GOySr3lztjkK8EL8al3F8aJRJjBchzfwsM12s3ZYybsgi4KveXj182hTBZP/PCZK7y\n    Ncnfcu4vtfHFMe1a7m+5jduy2RZ3BZStn6vIXwDe/Rx+vk3uL39ex/q5Cq6M366tnwltrJ+rEGr9\n    3CW2bf0cAp/6d1vkb4jIqy3526f6ty3q8Dpnge364J846vBnuwQSrF6y7F+CJoA3oQLeFoPeVQ5w\n    37/EoX+EZ72+ChO2apWuq2Sa9rkpf/+urKBDVcCu822soH1VaS4SOBT8OtcEqq4KuAlCrKAlQqyg\n    beBW0K6JcBV8VtB84j8Wi4QQEthm4SzP8fp2l/2zjwSumwdsq6ItV+qa1b595AHbLKzonnwhK62g\n    ZT+0yOUqYp6HRH1yKyxeeW0jgbkyePm+UaaTfkxfZs6TVl9JW065gV2I7+U84Hz1syw3HzgxTG2z\n    R8+R/uV9qHnMMYyoj8E3Rjh+9RTJUZnu5Io+k8pZPkr/OsX8w/RS5QEXzzNMb5wjT+30kgsKCQ6+\n    O8ZxzP2NaINV7m/2/lPL2GEvLhqwzW0aTai9zMyVRC7PPhywMW4gxi7+OZBDW9hSj+VMYiJy9WeG\n    /hzRBG2x/jmwfo3rjF7xurlamCt/y4S3qbCiPvnPTyosUk2rs+kyD3h2SZWYEb1jcDLE0WvXMDxd\n    hnwAYQVVCkD6wRzpu1Oo7PKMpSotMH3rHPlTuzkkt8nm7wsQc38j2qFI55jduV/K/TXHHJ31Kwt4\n    beszTvyarhzKUALz9aAsbOJFyDL310f+8nN8XQvjuV4z83WxtFm2WT+HOnRV5f6ail2zIJyjKvfX\n    Rv6G5P7Ke9rIX6Be/FaT3F+fancT1s828reO9bPLpY/vydXZ3wP86t8DqM6sn4F+rJ+ryN++UZc8\n    3pQ46gW6i33cFPm7Sevns577f7bBn8WGTap/+8YmXZgZLu+O0bZ/Ofr+4zgLbLcvKuAuwVXAfQ9G\n    dfvv2wrahxASuOqYROjkJHRyNUNzFTCHbZLY1ArapQIee14nP0+oYwUtMfZM5H2LAVceMFCe6LsW\n    JBIuEthU0JYrY30kMF3bJg+4qnqY5/2UYRLP1K5OHjC/p42ktuUBU//0+gZiE3p5XG+Q881xnvck\n    aSNuD0Yb9HzzoLy5XxgKpwQFcrYpTnbQXFGc/uUzLD76LOYBRzTC6L+OcfTfR0DiVgGb9q5LqEJh\n    dvMFsieXgzRR8wKzuxdYfJFVt12/L8vHo5j7G9EWq9zf2a3PUC4/0NmFg9XIxccgm10yjUtDoXiV\n    zhRDY2S1k66D0utRxn9odB7reyhxn8GKkC5YX4mF7OVqX9vPp8fs8tgqx+js/adI3/scyC+ptX1E\n    7xi/coCj/z1GMlpq9AlVKzMFIL19jsXDeXXjfUCuML8/XcUomFniNuKXxlEg5v5GtESeY/HhMvcX\n    xpixXC8NxLqMq3R520SMPUpcB8u441L1ynFQWj8PVq1pTUrkLK1JOfkLmMXO8rhNldsk9xfsHtSH\n    tJcG7Lm/LvLXRkibfYSRvyG5v7JIn+CK13Ipgpvk/rr6HbPrAT+Z3Mb6WaKu9XPoMY6m1s+hBLLt\n    PSDwfU1Voz8On/o3hEzuW/1rQxPitWvrZ9draCMM22XlLxDO55zV6HMf1b+b5Pc2LVztQ/3rwMC4\n    2aZUwH3nAPeJXVEBA5sjgfuuWmljBe36sO+qMojQZPDq+jXYUEcFHNKmTyvoOhOktlbQVf2GHJN9\n    jQMmun1aQfP711kE+OyffY9dVtC8LZHA/CckSEskukYusKiNSQLr96tOHrBcHEoLqJBqY9s1dfOA\n    ecW1svTH1b70XRPBBVP2cr1T2caS23Tllk1vnQdMKi294UCb3zybkL6oWp1vOvA8YDo2/eP9ZR5w\n    RERNJAlw/JtTjL/rz9qT+X0JgOJFgdmb51DTPSdNCoX5BzPM/j5b/Wyq9MX/ounnVwCSwwGOYu5v\n    REvkZxe4eOPjde6vVvCa+bk2MlePB5RlqMcdORZJJXAiNqv5pjaNzvy8Vs9qAllZ/nORwibZjPXr\n    pPPF+pidsLaR3fmqlZmzWI5rGIhNfm6nraCQvvkpFg/PEPOAI5ri4JcnOPjR0ihT0hP0ZRtfigUw\n    u/4CxVfVBUi7jsWjOaa3zo1jkvS1IYm5vxFtoBSyzx9j9sb7a5WvXifpOB2+puJfOibAJIWpPY1/\n    pRgBaOUvLwSmMYcXUCUrTTG1p/GLxlm+HlUw1b6ASbLKTOCQ3F+Z4cvVyT5XLtsMP4NdBczPE1y5\n    v7BcJ+9hu58v91c5XkNIfm9V7q9EH7m/yvlvvoQkfwk+62f5PNT62dauK+tnur6N9bPtmqbqX98+\n    a1/Wzz6Cdxetn3n/245gDIHkMzap/u0bzwLbdcmXbWOXcdPWz33h2/Z7lFUDl8kKuq8qgX31M7+s\n    cJHAecf/Tpu0gvadq6roqrKCrjrXxApaXtOFFXSdCj2OEKsYOXGssoKmPlyTW58VdBUJbKva7DoP\n    WJ4bobpKtSoPmN/blgfsysqR4ERunTzgzDhfXgzy87yvqrwhmQcM6IWoiwQ2X5teIJNNlhI/my8P\n    WOcgYk0Ck70zt/CSqiJ5XG5iazJ3uYkwWG+o5+sNBkkGU+02r0InZZNCgWwW84AjWuBgiOPfv4Th\n    y8PVBvXyN5jgy8Od/2OO6d/3275y8fkCkxvngFJBG9X6jUlw+PPDmPsb0QrFdI7p7U9QnE1hG1O4\n    AkkXIZnEsJ3gNTOCzUx6vklt5hna7Jalstckjy0/E6SNfJnE5cUV/P788WBVPEWWlnxTno+FctNe\n    653UOpKBxltNjAsF1yLH9Po/UHwVsoUYEVFGMkpw/No1HKzygOXY6RpdEijkTzPM7pxDpfvr5qKe\n    Z5jdeAGVmj8pFZCZpHiijyXAYcz9jWiB4vwckzfehUoXooCWk7ymHbQmfYvVWJivzuvcXz7OyAKs\n    BLogypb7y9eoRP7y4ief9bMv95evQYFq8tel7vWtw23Xdp37W6X+Berl/tLrb5r7O2bnbUX3PjLY\n    t//TZe6vRIj1s2zXVe5vFVzq3zrkb8h5ev1NyF/fXmuf1s8huzVt3Cb7RpfqXyJqo/o3YtOQfOsG\n    1b/AZbaA7hshJHBolUQbnAW261oF3HUOcBsVsA+7WinUlgS29RWK0JwK3r4KE4QpfA+hapPAfVlB\n    S6SO6233r2MFXQWbFTQH3UvmAfsqQN392ytLXYuSkDxgukZWyI5Qzwqavz5fHnCVhZRcSEri2GYn\n    ZVt88i2jIbgtloSbBKY+OQkcmgfMF+L6NS7PyTxgM0NKK395FqGsBl9uCugNa16ZrtXDy02J4Vrr\n    tNzI4FmN2aPnmP31AYr55bDkjdgsRv8yxtFvT5EcJuKvzr5pzdvM3zrH/JN0L4Vz6kWG9MZzqKne\n    mrP9GCULbAAH3x3h+Dcx9zeiBbIc6b3Pkb//FGWS1SQrCzHOSFKVxgRTEczHCZMshTEuFSW7Z5tt\n    pc0O2vcl23Mim4+XCSR5W+6Lv+4hGysHoj8q1rIVYlHhFBVhyQ37/MkU6Z1PYh5wRGMMrg1x/Nrp\n    Kg9Yw2Z/TKDfztl7MyzenwLF/g2mal4g/fM5Fl9kwasvajf+91HM/Y1oDMr9zb/8/9n7szY5juxK\n    FF3uEZlIgCBrklQ9qFpSt7qPpFbflnRUJekPnR9w3+/39R/T06niVFWsgUUW5wEgWSwSJJIgkBmT\n    u90Hjx22bLuZu/kYkYAtfIGM8MHcwyPCzG2vvdd6fCBuWe7Z5/tbwp8w5PP9lbZkpOVK4ILGFT32\n    yVwyO6RK1ZWjYnx/mfz1+f7qeSqDpaUtXHJazgyo2zZxO3qurpOqZf+uvr++/fr4/so+TToKHFvR\n    cRZ/sr0/XtN0h8DJ/SFCtq/vb5P0c1/fXx+EqG2KqfWVfma0kbsx0s99SdqxpZ81QnHhtrjyk4Z9\n    j1n9Kxi7sAsYn/wdm8eYgvydGlMVSk5V2KnxYJajHBVV9EizznNUAT8DF7c3umZlXEZuN7Yf8FQk\n    cB80SUGPSQKPVQUMxBG3ocF6SBVw0zahKuCxSeAu6/uQwCEy1/e8aZlvm6mkoEPVt6Gq41AVryDs\n    L9yNBG76THnS0+YH3CYF3UYCA/VK4j5+wNyejzh2j2m3C/kBy3qpFCqcFl0S2CWKrfSknczaSXk9\n    II3DRJ8D9Szh5ZPe1FVLHHRwg9XsE+z6AfOZWk8rK3G2+s2n2CU/4ISeOP/vt3H+3ys/4AxNPY7r\n    5VfugPXL36L85maRJmZb4vr1J9h8Xg8X6feu5a8X311UXoUXKWKd0BPGoPj0a6xf/YQqi2y1r68S\n    GIexxga0fdWsdkypJxTph65q4rbkXw5dtWvbXgQeGe2/gPX5zQ8jmQTK6yQtPOeW0Xs33uX2jDM6\n    RlX5W9TGXqhtZfnq7a+wfvuPMEUaRxP6Yfmfb+H2/678gPXYoaHHmqtXH2Pzx5s1lqI02H5wjes3\n    rI1COJ2qWip9yeKFHHf+9W7y/U3oh73v7+ZN6/ub0RxJz7+MGmP08+wwaoTnbU2JUXpeKB6/eixn\n    gngBdx7K5C9X8vK8FfBZHuGwrRyx7vtbJ3/1PNq3zCe/3Eb++nx/C8zv++tTcYux4Iolf2Oln888\n    5+E/bjfyV8faNPnbp/o3FIvrK/2s44cxBSSxRSbX6C79HEP+dpF+BtyY8BDy91TxLZrJ3yHVv1Nj\n    iPzzqZG/DyO2uekquQ8AfG/i9zAHzwoE5Z+Bpgrgp4UElmyBKfTDT6UKGJjnxz+Xhv3YnXKBcUng\n    PmjKnOo7KI8hBd2FBO6KPr4aoW18nrxtaKvI7XIz2uYH7JOCHssP+AzjSEH7SGBNIp+iH3BxaK3d\n    D5gzin1+wJxdrCei+soCduLL+4T8gPUxfK/58ynUMuu7ZI+xhPUDDlVBceZ2CfYDLp0At1sVzP6E\n    BWzwwAYfDHSmeT1oIY/cFLh+6V3svvwaCQldkeXAnX9+Dmf/aemVrvSFcyWIW1zusL5J8pWlwebD\n    FdavXzdWZsl7Z+QXGS7++Tksk+9vwgAUD13f38zp9+sEpxC69Spa9tB1iVJb/WQfVs7SjtR8fGlR\n    j28L1Ilao7YDte2r4GV5aR45fW3IWGwC78NdzqRuvfrXng+TA+LRaH2T5bH6+SfY/fESN1LWIOEk\n    cPY/n8PZf7uoLTeB54dlqxLrlx+h/Pbm+AFvvwzbKPAvq0aAn2W4+IfnsPjhrbgDJSQwyPeXE2O1\n    7y/gVvzKvIznW4BxxgLt+2sre6v9dxA55rrvr7utELrGmU/KOCtjHGBHVD1fZfLXR8wyKdzk+8uE\n    sk+Ri9vwqXz19f3l98X7+Wypuvr+Grp+ersY31+odiW+Eup928jfJulnnjF0lX7u6vsr6EP+rjG+\n    9DM/j/X9nVL6eeztx8QpV/+G0If8FZx69W8MLnvsM5X885Tk71zVv1NjLvK3Bc36cVOe5NTs+lw4\n    pUyHy4htnsUq4LnQh2Qey2ehTztT3JRMJQXN6CIF3eYH7COV20jg0I1ojB9wG5qkoHkyoaWg+/gB\n    79DND5ifN/kB+ySkh/gBS2Ut0O4HzG3wZM83ofKRwD6CljOJgWY/YFfm2c2Q9vkW+eSzZHsrOe1m\n    VMuk3mb7ulVXPMnnoICtSOKM8rqcJZO7uiKMSV8O/huU2F1tcP3y2yifJB/DhO7Ibld+wPkLthqn\n    8u8zXqKUX63fXmH77hVQnM79WAi7B1usXv7Wkdps8/81yJDlwPnfXuA8+f4mDEB5vcHql/ewu1xB\n    Vyj5yNxQta9xxh93/wW0P7D4HNp9SriELOi19gKWaiOXNLaBbH5oktiqc1giVwfaSzp+5nlvrhKH\n    TabK1XqRh+agvo9gzpxrUB4SrAADbHdYvfgxzLdpHE3oh2yZ4c5P7iL/4Zm38te7j5Adn2+x+s0T\n    mO3pJ1SVjwusyEbB9568SVYZcP7XFzj/mzSWJvQD+/4asK9vqeZJru+vjB0yz5JEIO37K/M0TeiK\n    x/2SxlgmgZf0vJpD2rkmzytdkXh3HsrSzy75a8nUNt9fbl/Pibv4/gJ18lfiAzG+v7LMN7cf4vvL\n    sY6+vr9L2p/J3xBxzPDFeXzSz6FtQu37qn8ZMb6/ZzCdrdC4/bGln3U7Q3x/b9H3cIjv75jSz2NV\n    /45J/o6JturfPrgLc/Lk79h8zVA8PNJxpyjgDGGO6l8fZvb/BU7BA/imVwHH4Fg/mhBuAgnct80Q\n    CTxmFfBzPQfDJinoMaqAb494QzGWFHTMjVTs+qF+wBqhrMQYhKSg2/yAh0hBa7AUtEaIhNdeMz4S\n    OEYKWh9T+wHLtiE/4NDEiSd6OhPZJVP91ba+/Xidzw9Yy0uHJqV8/noSrUngAnXZK5bVcoliV85r\n    AZ4Ic7C6em2PZ2UtJcubs71t2N1WUGUUiOcgfxWELg8BbF0B5gtm7PbBDg5cFJ9dYvW794HtDZMR\n    TDgJLP/sHBf/+ByyszZKtIKt7jG4evUxtp/HpNkcD+WTAqtXv4V5UtSC0r5gNQfvz350Xvn+xkb0\n    ExI09r6/6/cewkdIApa8LWkdk5pcxWolJUsUsPKrrCmhCU8mUOW7ziSslmWW37cr/+yee+ZZDrW9\n    tMp+w0zqlkCwHXi2d98fV3Xpc7deyj5CgIP7sn775RVWv7yPcp3G0YR+yO8ucOcnzyF/rkpT0Kj/\n    biw2b1xh++HqtP2AdyVWv3uC4rON8yttQvV7BJb/8Qy3f3IX2SINpgndUa43uFa+v9XYWTjJtTx3\n    EjsATsbltN7c2c6131kcyF8heUto/1+eC9q5ujsvlbFZfH/1OMhz1HrlL8+v/eSvrC9RzdEBTSD7\n    59ltvr++5OkmEpd9fzX5C8RJP4Pa9/n+hmIYGjExFB2XAYb7/vra8+0XOldpq8n3lxEif09B+lkw\n    lvRzX3XEKaSfGX0Lip4M2DeEsap/2+L2xy78SrA4pYLIPpiDjzyR6l+ACeAQ+zxHFfBN9wOe4ks/\n    VXn+s4xvMV620tjSFjEkcNO+TYiRgm5a1/dmJ6YSuM8N2VApaH2T2VcKeko/YI3Qzby0FfKg0ftL\n    G11I4BAhrCcUmgTmdyjwZdKGSGCWgpY2NQkMz358TJ6o+SacDF9mspalkvXiB+xrxxK+fu+jrn7A\n    TMTyRF0m/kzqFnAlMHXAWgIP2k9Kgg4lxP+XZctYJtSVM8v22essgbb+1SfY3PsDYE6/giTh9HD+\n    f1k/YADe4DX3LuIZbNYlrk9ZvnJXYvXGE2zvrw/nH6K5ueczEN/fu8B58ipM6AljsNv7/nJ/rmWd\n    2QyAVSByIob5nyZD9djD1gYu4QzAsx9X/cqoJ4RsTltbYtcNqDOhlatjWksJ2159nETtXDJYOU7W\n    4cgoMF9/D1wFXR9v9b66Evv6ra+wey/5ASf0x9mf38L531d+wEJ+NhGlh0SL0uD65UfYfXWaCQjG\n    ANuPVtj85vHhvGORP7/AnX+9i/xOGksTemDv+7vd+/7K/Ccn8teOrJz0Y8lfoHTW+bzlfTYKeqzk\n    ZF9piyt+3QSleN9fJlpD5K9v7ittsu9vrNJWyPfXL9tsl7X5/mpbqrF8f4FwrGZu31+9PhQvim0T\n    qJO/gibp5yHkr47r6XhdW9wvZBk3pvTzLRhco4qN9pV+jom5dkEMcTvE2/eY1b/Sfqj6ty/5O2f1\n    b1/rzCm9f/vwSw97vo+hkMLN7/Y45y4QHnLK6t+5yd8/bT7e8SuA5yKBb2IVcJ8f6WXkdn2rgEOd\n    2U2QgpaBbK5Bq+kc+iBmEO8rBX3VsC5mmYa0d432G6ouUtAhWZdjSEHLa99NsLQZuoFuI4F9E4e2\n    jM6uUtC+SYGPBG7arymrNEQCx/oB+0hgAZOpbX7AWk5a78cTVL9fb50EZj9gQ+uh2nQnya6slg2M\n    N/sBS1tLZ4Jvas/zg/SztF29roLe1f4cEPD5AXMlE1cpsVcVV3JxsDsXWTNT4Opn76D8KvkBJ3RH\n    tshw+8d3cfYfqrz7phodHfgtvthi9ZvHJydfaQywubfC5leP7TL6q3s4pwpYfH+/l3x/E/qjePgE\n    Vy9+DLMryONdgtEu+cvjA5OXNvnHkqKynNUjdKBa5J4tKQy4AW+XgOXKXSZptTxz04O3l3Zy1KuF\n    M1rOY7QOyounoa4OXqjrk9N4qoP3nDzFxDJfByaBn7z8Cbaff4PkB5zQF7f+13M4/yvX5zbklQv6\n    Wz4psXr1EcxV0XqMubH7aovrlx/BlPZ8rZpAHZJElp1lOE++vwl9sff9ffLi+wB4XqQ96t2xUMZa\n    TvyR+ZK2I2DfX6n29fn+CvnLihm+uSFbAtkkKnc+zCQsk78G7t2ptVOoE60yk3TnvaZG/qoLemjD\n    JxHNsQI9Hw+Rv9r310fm6lgDPx/L91fvN4Xvrz6m9v3VxwqdZwzOYYLkr6/YIUTYrgPLdGytC8bw\n    /W1bL+v6kr99C2kEpyb93IQxC6TGln4G5vP9nZr87YOb5P17LL7uGUEcAXxCJcujYIov1VSl76dY\n    CXwTSOAQZDCZw7cghFOVgm5CXynoC5goErgJIRJYPx8qBR26MUXLcp8sjiaBu0pN+6Sg4XnNfsA+\n    QjZEAvsknJty/WOki6Qd3se3X6wfMGMMP2DfpBLUVuxElfeViXXuWS/Z0lqmWpPMIT9gCVi7fr7+\n    ADv7AS8ouJzD9YlaUsCeg9UZBSN0QEP7AUuFsFsFbIMWQIHiyRpPXnoH5VXyMUzojvzOArd/8jzy\n    u/57VEvi2NdA9e3b/O4JNicmX7n7eourl75F2YGXzgAgB2797e3k+5swCOL7W5DvL//lpB4OPmfO\n    +FE627u+hi7RuXAIZE5ScgPLdaLYTaiyVbI4JDfxtju4/r/82lW2kPGTg+FWPcDnpaiJ4ZLOw624\n    slSAJp8X+zpmGYe56pcrqfXnIdfabHZYvfwxysdDw4cJzyryswwX//I8Fn/WnkCkR8zNvQ3Wbz4B\n    dqeTUGWuC6x+/gi7b91zygD45Kxlnfj+XvxtGksT+sH1/S0Oc6VczYc40cfQc/soaMyw46r2/V3S\n    +KfnczwXXMIdR1kWmlN8rUw0oOebLsnqkqfymrcF3Hkvz4Nlmy6J1RqcBG7UcWW9PteQ76/Mu90q\n    YotY398m6eemBHxfHKSP768vDjSV769P+tkXD2PpZ43ziGW+KuGu1b8afYjkmEKUGFVDH5qknwEb\n    Kw2hL/nbhiGVwccspAJOR/p5bPK3Cy5neo8PZzpOCKn6dxLEVwAnKeibg8vI7YZkmcxBAg9pq2lw\n    OLYXcBvGkILuSgJPKQUt+zcRvV1vrPr4AcdIQYdkaNqWNUlB+84zVgq6jx9wU+ZnqP1T9gP2kaZA\n    vB+wJoE5czjWD5i3LdQx5Dx8JLCWgnYlrKvtqmqruucvvxc9iefKJdmen0sAQILeNlfd9QMuUZee\n    FJJ3cRCUNrXAxkIFrEuI/LQcs8Duk4dY/+6D5Aec0AvL/3QL5//7DrJleBvjPN8TNQZYvfwNtici\n    X2muC6xefQQ82kH38pZ88uPsR+e4k3x/E4ZgV2D9zufYvPf1IVDN1bEsUWyrU13ylqtudQUrv9b7\n    5HCJY5acdAPWtuo3hx3LWMKZiV6uZtIP3/ZQ7XLFbUZjrybDZd8MrlynbmexJwGkCnpB15kroHnM\n    XKg2LZnOQf4SxRePsXrtPrA5jf4s4eZh8fwCd35yF/lzeVBRw1cVDBisXnuM7b3VSRShm53B+vdP\n    sP1IElkM2uSf5X0s/+My+f4m9Ea53mC19/21tjdVH72DJXK5/y/2cyHu5117Hf88TOZpPG/LaTxx\n    53fucz2GurZCAp4rumQtK1zxvLVAPUEZqM9/uQ3Z16fABdTJX12x6yOleX93mTuH95HZp+L7G0v+\n    htTXpA1pe27fXx3v6iv93ETUnpL0M2Djn6cg/RxL+A5RjTxm9W+b9PMQlBO0OSZOTfo5Bje5+ncO\n    8vdEcXwJaMEcF5+zCI5RBdw3i2JKKehTx5DOeg4p6L6DXVMVcBtiCeKuWWFlxxuUrlLQbegiBd0X\n    PjKW4SOBu0pB+zIij+kH3DaJ0CSwPB/LD9gnywz4M2zjpaDrJDA8+wHwVtzyJNNHAneZtErLPhJY\n    As8+P2A+xtJDAnNGtfUbthN3Wytk/YAlYzzfBx+kDQ4eSPBZB/V9FWESRreyoAU4u10HLpgIMCix\n    eu0+Nvf+AHNC1ZgJNwcXf/cczv/alWuM+SbtnpRY//wblEeWr3QD1i4kcJ3BTwIvvrvA7X97Pvn+\n    JvSH8v2VRB3j9PUsX+nKQHM1KvvtutWycLazYwsO3oM4bOk+5H8t0ewSsJbINXA9CXmdJXsriF+w\n    rg52Se3qdaZeu+dox3S+Dlwl7b423jaMc52Z7NXku1tdDRis3/wS6w++RCcJgYQEwtmPbuH87/0J\n    VaymoVEWBtcvPULx8LgJCMYA209WWP3S2ijwr0HPDvh15fv7fPL9TeiHve/v5s0/gBOa2PdXyNoF\n    zY1kvYxEegxY7Ilkd95klZm0nY+QvzLPY1sgng9qgld+J65tkd/3185j7fy5jfwtYefgbhv+ebRO\n    ppbnOlm7ni5Zl372HVP3BmP5/vI+jJDvL0OTv/ocmuI0fP2kjVh1tzYZakYf318Ag8hfXyFGrGLe\n    syj9rOO6Q6SfQxhiVTgUMeRv3+rfU5d+Tqgwt/Tz1PxjWwHtHyc45p+2vyeXAG47ialLmL8HM2sV\n    cNIXP/0q4Knwrfo7BGOTwED/wbuN9D2mFDQwvhR01ypghu9GU6iGviSwRowfsEYbYQvPa99koa8f\n    MD8fww+4PmGrE79d/YArX9sKXfyAQcczgf0EsX7AglLtw3u3kcA+H2Jf1W9B+3KFkgT2uRKY/YCF\n    HHblwepVvKBgv4H4AbuZ6LpiuFSBa5ZEM+IH/LBv+lPCs4xsmeHixy9gGZCv1IFe0OvNxxts3nwM\n    FMchTXTA2p6FG7zxhZuyixy3/vkuFsn3N2EA2PdXyN0cJSUEWRI4P0haulKTtlrWX+nL1bRugpKt\n    znOlld1qYCZ+jdovhx3T2L+XK31DFcC8rbvOlXzWChrs9Zs77xe191yvwoJDCOukKk64YqLdd13l\n    M5J11y/dq/yAExJ64tb/eg7n//UWwnQv4CoDVP/vHhVY/+IRzPXxEqqKb7a4fvkbFLv6bMx3HyDI\n    zzPc+sfk+5vQE+T7y2Svz/dXKyu544ydT3Hlr7ZesGOOS/IaGIeIZUKYVS/cdfY1zyeBsO+vTrDS\n    5C9DyN/QXNb2IcbZB3Arhn3kr/oQADT7/vL8eUf7+Tx95/L9bUrob6rObbPy4tdjSj9rxPj+nrW0\n    0dZ+0+um6t828jcWTddgaulnoLnwpi1e25f8bdu/DaG4+dDq35h4/BDp51NRKB2Kyx773JTqX83L\n    fXfC6/yMqw6fTgUw4yaTwFOUwgM3rwp4zM5xyipgYDovg77tyqB8DD/gmGvdN6NNbqLGlIJmdJWC\n    9u3H2Yt9fER8UtBtfsBnDZMEed1VCtp3LUPXts0PeAmDs0A7Y/sBN03SZBufH7DZTwKbSGBfJjK3\n    q2WapeU6/CSwm11dn+C6k/KqHSavXennekBaHiKXqaWgXXJXMszdSiItIebzq8Leo4oDgbpKKTuE\n    LnT1r+sHnKOAebLG6pW3YZIfcEIP5HcXuL2XrwSaJZNlvRA469e+xfb+ceQrd5dbrF7+BmZn6w6b\n    cFifA+fJ9zdhIMrrDVa/+Bjl5TV85CMHrF3ykauPdJDbkruoteeSuAv4yeKKJHU9do3TNnv4VuDt\n    fb8jX59gAIc0Lp019jmfA29v6S8mr91xVJPjXAks10F7/TIB4CPXWXFDZESBEma1xeqVj1B+m/yA\n    E/ohP8tw+8fPY/knWuA0PD4JVbx5/xrrt5/A7OYfTM26wOoXj1A+3JEvdxhS0WxQ+f7e+ps7s59z\n    wtMB9v3NDpRnuSdqXd/ffF+Lqz1/F3sZaDuPsglZPjUlVm8CjSVN5C97A8vcmOeNOpkYsPNOd25c\n    J2t5Ts2KHqxS1VyFC2eZlpdmAjakvCXrofZr8v31V/VWiPX95djFUN9feT7U91fQJP08l+9v3+rf\n    sX1/9T6x0s8hyH5DpZ+b0DW23Zew1Zii+ndM8ncK6ee5CNshKZpDCvKmwsOGdVPxXXPiGa3+BXwE\n    8BQn0wXH0OFOlcD90dTZnXq2DQ8yQ0ngKaqAx8JYUtAXHZcztBT00JsyXxVwF8T4AfN2QHwV8FR+\n    wPp1mxS0bz9GmxS0ljWaww/YSiLXz5ureX0kcMgPeOesD5PAjK5ZzG0ksJwTP+zVs9toKeic1uf7\n    953vPysfCcwBAk36+khgG0xjklfasJno+aG+uQpGu36Fbsa7rhkGCmw+/hqrNz8EdsnHMKE7lj+6\n    wPn/eg4ZKTgKwaMDTRmtLwrg6uVH2F3O+70zqwLrXz5C8XC3PyfjJISEkAFY/uhW8v1NGIZdgc07\n    f8Dm/a8BFYzmPt6OB5Z8lD6cCUorWVk6cpRM/uqKWJZKRu14dR9dIX51tS8nOGXqYYlV9zk/dAWx\n    Pp/qF8oymOWhPe0NrN8fwOSyTbjSpO7Cc52y/fXWktw5XBKYK4F3nz/G+rf3YTZNDoQJCWFkLyxx\n    51/uInuuHv8xntfss7v+5bfY/WHVns00JgqD9btX2Lx7fThsfWi0ySWM5fcXuPjx88n3N6EXyvUG\n    61+7vr+iolGiDJK3rqqDK+fcpKIRM2/TqhU8Fsn+W7jzRcCdL8pcONvPNwF3fmznqb7qYD/5y+tj\n    1LM0QuRvyPeXyV9OjOYjy359fX+byF+NtphIk/Tzqfn+CnyFDIwh0s+3PO309f3Vxx8q/czk71Dp\n    566ksGCq6t8nDfvHxKN9sfIxfH9j0Lf69y7MqPLPx5R+vuyxz1TVv2NjTi7uAZ5O399I8hef9akA\n    nloGGpj2Q5mynFxw06qAh2adzCVK1pcEbho0xqz+9Q2CMe2fohR0aP0F3Rj5lre1eQHTSgJ3lYIG\n    0EsKuokEDomFdSWBBT7pHEYMCew7dtvNfxcp6CYSeCw/YFfeqTnzNiQFrfflbOcQCdzmB7zz7NPV\n    x0iTwNoP2E7GjSKB3eeZhwSGt203iMDEbgnXD9js3yP7AVuy2NZ66Sov8XC0QQyq7KVtxBtYPK9Y\n    Hk3y19evfYzd/c+TH3BCL9z6++ew/Ktb8IV/S7iBamfdwx02v/wGZj2TfGVhsHr7Cbbv2lEyR/1u\n    2/UvrN7T4rsL3Em+vwlDYAw2e9/fkMykluz3VbPq10aNN7JsQdtKlRJXBDNJmtF6c9iH/XuN8zv2\n    jXNCqIrfsBxfnme0jCt27bm4fYVRx+dgPJPITUF5e4xSvbZE+MK5jtYP0r227BPpI41LrF7/AtsP\n    v0h+wAm9sfwvF7j193echCqB/lbxuFVuDK5f+gblo/kSqnZ/WGH1an0mrSv79fiaXWS4+Ofk+5vQ\n    E3vf3/XvXN9f9mfPUGIHc6jwlWQr28vLc3c81QlFehyVeRvb+Mg8bRlQddLJVTwHdauGLfl7eKuw\n    82cmf4VEBtz5rI/89VX06ipeTf7ytjIX9yVa+31/3Tl6H/K3zfeXyV+NkO+vL0bCMZQmv+Bj+P4C\n    9ZiUJmL7Sj+vA69D9m0xCEk/6/VtccSQIh7v15e8jdFo6Sr93KbsCAzz/Y3BVORvTPXvEOnnMZGk\n    nytMLf08NU6B/D1ywa2fAD52FTAwjQRAE+b68j0cuP+zLAU9pL25pKD7ksAaPMAfQwo65sanjxAd\n    +wED4Zu0Nilo3q/JRyTWD1jv2yQFHcpO9PkBh6Sgfee9QTti/YC1FHQfP2AAtUpgfRzffk1+wPXj\n    10ngGD9gva+PBEbkfloqykcChya1vJ6Rw5XDCk3EmeTlY3AlMOeRy/al2ldXUAkJbCXAWOLZ7wfM\n    Wey2AszW8uoqMhv0sMEQIYFx+Et+wEWBqxffQfnwEgkJXZGfZbj9kxeQk3yljwKx6RL29ebdFdbv\n    XgHF9PeVuz+ssP5FeNRnklqeZzDILzJc/Pj55PubMAjlw8dYvfgRzE6ScVyiV2SIdZWvbKPVHTS5\n    WSUFWb9gVn/gaiRfxauuhPWRroaW2SC3JXxcOefANQAc8lnazNSx9LIS1b2CXIOF5/3rSmC+jkL6\n    LknykwlpV1nDJkrx/u611vYMBpkpsXrpY+y+SH7ACf1x63/dxdlfXqil9bFJo/hqh9Vrj2DW0ycg\n    lN9ucfXSNyjpWHp8P2zLL/IMt/72Ns7+a7JRSOiBve/v1YvvwUDb49S9fpmMtWNGeVBwsL72thqY\n    22jy/WUyWMYbmbdx4hLPK2WZb/64OLSvZZvrc1JOPJa/vjTKrsnSgN/31yV5/SSutl3SydSAm9gt\n    CJG/vmPy+fP+giZ1tCbCdQvUiOyhvr8b1X4f6WeGjl2FyN+Y6t+2Zb7nfRX9uhDJMXHBMaSfQ8un\n    kH7uQu72qf6dwypximPcBOln4ObJP4+JEP82VcHmXDazTQWzx+RZP6v+hCuAT4EEngqhL9WYJHBT\n    dsRcP6o5MXUoguUbxu7QpxrYuhzDN/h2kW7uSwI3YQopaEEMeRxzkza2FHTT867LmvyAN4H9YqSg\n    m/yAQ5I9MdXE0p5+vlOvh/oB7xr2Y0/eGD9gHQrSE9GQH7DejzOP9X7cdltmM2cSW5IWh23k2OEJ\n    tz2+TIpt/nj1d0kBbJ8fsJYSk+c53MxxCSLIa+sXbAMe2f5dsJynDVPYgIgERYR4tnKWrvxo+ega\n    q5+/g/K6a2pGQgKw+M4St39yF9ntfF8za6uBfT0a1wqvXn1UyVdOiOJRFbA2m/rZ2ApIdxmAve/v\n    neT7mzAI5fUGV7+4t/f9LR15f+nPC9Xf66qkTO3H3ra+Klwmd6UiiiuCeRxi2UptWSDSy/bhkqq5\n    5xxiH1xxnB2C8DicN7edq2O5VcxGXafycN51otw9vpaEzp0x0iXh9bkyCVyiRHG9xerlj1A+Tn7A\n    Cf2Qn2W4/S/PY/mnVUKVHrFyoJZsId/o9VvX2Lz3BJhQzcVsSqxee4Tdg7Dwqnv07DDen/3oHLf/\n    6W6yUUjoBfb9tfoQldKR3/pGP4rDeGjH1sIZhyUJS8bhwjNmCTnMc7ym+R6TuUuaNwJ2Pqnnqr65\n    KOgvW5cIodzm++ur4tXtaPIXqM/PQ+TvAjbpm4/HydyMevVwPfFcJ8mHpJ9DCfH6fevq3yl8fzeo\n    S0E3tdMm/czkr46nhSp/u0o/+zCn9PMKx5V+7qu+KOjrAzzE9zcUv74J0s9jIkk/Vxiz+ndu8hc4\n    jerfKRAj//yZfdpdAhqYRwYamLYKeA4SeCpMUQU8RvbJqeejx0hBT1UFHNN2Ewk8VLojhLabjTYS\n    eGop6L5+wEOkoPVz3kbQVQpaV/eu4SeB+/gBA67/7wbj+gHLep7IxPoBaxI45Acsy7v6AfOET9qT\n    iWyTH7CcLe/Hk02dtdzF2yjkBwzPseG065LQEogWElgm+SWq736bHzBnlFt/Q+tjtVTEbT0QzbKd\n    rh9wBuuBpSvG8n1wg4Mc9hMvsfnwATZvfwQUyccwoTvO/+I2bv2dla+Uu1iDcLQ3g4FZl7h+6RLl\n    t9PIV5brEqtf2oB1PT2lOle3bqo65+WPLnDnn56b+UomPFUg318ONIsiQwZLyLrVv25VEpO3djxx\n    iWAT2J7tCZjYteODS8ja8/RZEMBpT343ZYeHwFZP1auD5bVUb8lzXb2sE6sA6x+st/MRxUzq2vV+\n    Et4411Q+N7f6bPOHx1i9/gnMNo2jCf2Qf2eJOz+5i+yOjKLuGNrEn16/+gi7L/qk3UagNFh/cIX1\n    768O996+c/GN+fn3F7j9by8kG4WEXhDf3/LLb535DaskGWdMs6Mqb88JUJkaV1w1DbeCeEmvhXDm\n    JF4Zh5p8f5n8zQ9t8TyQ5748R64TuHZNXfrZR/7qvQC3cpjnyCHfX0GI/OWqX3c/P3EM+BXI2PeX\n    5/4h8td3TXzPu5K/sb6/ev0ZDM7gl4Juqyhu8v31ST8zfORr07FiYmxtCEk/j+37C8STvxpt6Xha\n    AdG3XmNs6eeuBPKU5K+u/o3xII4Fk7Vj+v9OgSmqf4eSvw9neN/H4Nu+P8G17ooTKbBtJoBP4SRP\n    4cPqiymrgKfI7JhKgmCsLJwxqoB9JPCYg46gLwnchGNIQcesn1IKuqsfcF8SGJ59tDdwjBR0TCUy\n    S0GHbsA1mmSbXenncEZoFynosfyANZpI4Kqdfn7AehIp2cFNfsD8PEQCC7pOdEMkcO69Ti5xzeci\n    E3iZ3OpM77J2DA4gSxDcBg0kqMBBZoOyFmDQAWn2Ay5U0FrkQHcwKuNdttO+hiVWr36A7SencIeR\n    cBNx8Q93sfwvlVO7ED0hyUrAUjS7B3v5ys248pWmMNi89wSbt668XsSl87wKWsvdd558fxOGwhhs\n    P/0Kq1fvI0ex75HdQLT2/5W+OTv0/YV3m5LGHB85atRfTfQKsSuKGGxNANikCOu560othx55wyNm\n    /4zGxRI8G7YBdi1XzcQxau/brRbma8ifgw2lu+Q5kwnZvtqMz9MqbkhlWIHNbz7H5uMvAZP8gBP6\n    YflfbuP8fz6HXA0/7m/CRQYDsyorP+DH4ydU7b5YY/3yNzDGf7fN52FhkF1kuJ1sFBL6gnx/ZXzM\n    oeWerdcv99eSFCtjZkEKD3rcKWms0KSwJFdJ/2/HtPJA8ppae/75oE7G0uQvE6lMqGrf3zbyNyYx\n    WiNE/rLv7+FjgUv+Gs9+IfJXSz/D077su6U2x/T93SEs9dzF9/cMblyGe7km6ecYv95Y39+uxK1u\n    P/S8KW4WIn+7ph91kX6OAccwrwPLBW3krw99q327tNcU/56z8jd0HkO9f6cmf0+x+vcmkL9NmLL6\n    92lFx+pfoG8F8NOCY1cBH/tHNgVOvQo4hDswo1YBDzkPjTluApoQyobrcvMTwlhS0CHEksBtN5Kx\n    ss++bZqkoEN+wL4bdl3NG5qAnEGTwi7p2MUPmMFkrCaBh/gB2/V1YraLH3ATCYzAfnriqr2DfH7A\n    fK5NUle+SbReryfhko2tSWCe8LNkFwfWJXggomWy/ZbO1wYHOAOdg9lupnqO4lB9xP5XOVx/yIXj\n    NuVKjkogRYLX4gd8/eLbKL+5qSNGwjGRnee4/a8v4Oz79tftrxCqE8Or319h8/648pXFH1e4evXR\n    4Zj10BKd+/5vCSC/yHD7JylgnTAM5cPHuH7xI2BnvXmZgHQl/e16WyXsevPaCifpu+tt+shfIT+l\n    ktZHxmawlbg+IpkrfzlhSlf18rIyYj1QrwTW1bZZ7ZfrrwaW97eAS5QXdG04CC+JWJmzvi4NXfcT\n    dmVGZUw+nJcpcf2zj7H78tRrHBJOGbf/4Tks/8r1Ay7ViFr/ZQC7zzdY//pbmO14CQjltzs8eekb\n    lNe2Tevj7YLPMM+BW397B2d/dedo1zHhBsMYbMn3Nz8QsJK2pNWM3OQdd9y1Uv9WuN+Otb45VE59\n    /2JPH9uxys7j9NhlE6uqZTJPded1fvKXk4+htskDf7XEcow1km9bmWv75tC+Ct4xyN+F9z24cZUQ\n    YdzF97fNE3hO319fpW+T9LNGV99fX/Xv1L6/pyD93LQ8hvzVx9Rx2qHVv318f6cEx9lDaq+nIv0c\n    anOM6NWpef+28VJjyT8fQ/r5+zD4crLWXYSUkqcoe4khfz24GQTwlFXAU5PAbT+WISRw1yyPy4ht\n    ppKCPvUqYGD8wfAYUtAxVcA+tN3wxJDAMcv1MWOrgPtKQXdBjB/w2FLQvKxNClov6+sH3CYx7Wsv\n    lPU61A9Yb8uTMZ8fcCwJvDssqWcW+/bj98Cy0no/7TEcOkY9i7ltMu3PfJbXvgk9IES8SwhrryjO\n    GLcTaPdh/adwCFBIUHu59wCWMIYNRksIm4MgYT9gnTVfXl7h+tW3YFbJDzihOxbfPcPFj59HdlHd\n    x/KvptH6zwCrV77B9ssNxkD57RbXL10CKy3uXO9XeYssz6qA9X9NAeuE/iivN1j94iOUl9eOMgOT\n    h0z4cmIP9/O6IimHK12sk5DqihMuict/M3BlMJzlIr1cr9L1kbu20tY3jlnilOWY/e3wg3183SA7\n    vMcoA8vluHJNAXPwRNYEPI/VmlS3fr+up3DpacdcrXH98kcon6RxNKEfsmWO2z954eAHDLhqNc62\n    avnqjSfYfng1SkKV2ZZYv/4IxefhsVnGdvnlyPksfnSRfH8TesMo319RXGC1Bp2QY1B6knTEF97a\n    5PCYWzhjBJy2uaKXSVrfXE4nAvN8UI/VVkXKwk2C9ict53CJYkGButpV0zxYnvt8f+kTOOy/C+zn\n    75PqMQPfcx0bAMK+v3q7Lr6/nBx/bN/fruSvrv4dg/wFgFue84ytJB7D9zdmPTBc+rlrha9gKt/f\n    sfZnjF39O2XB1amnRZ6a9PMQPqoLjkH+Puv4rL6onQA+tkjjHGz9Ta4EvklS0GNhjE49RAKPXQU8\n    5mA51A94qBR0aJuhfsAmYru5pKBDFbnVMdxtBF1JYEGMFHQMCazR5ge8QXgSwvtL+yEpaHnvY/oB\n    83vySTXz/r7nS7gErrQf8gP2kcByvBB57PMyast8lmMwgawrg2W99gMWuNXHdpJ/ywkkA0uq6nUD\n    B67HIAcc2HdK/IAleFDSaw70CyHM/oQSAGE/4IweOniyfe8B1u/cS37ACb2w/Ks7uPW3d2q3slVg\n    OIzyusTm55corwoMgdmUuP71t9h90S6Dab2KK5z96FYKWCcMw67A5p3PsHn/a1hKpCRiVVJ+XNl+\n    7TuryeCcKpWsUoSVt9QVv/J6gfJQL8XrXVLY9bOXscpWylbQnr8sNynH8P0r4apq1Kt+9THc4xu6\n    HlzJy+OpHMNHjvuJYX+FLytxWCLa9ZF0q3+5Urs8SH3vPv0Gq9c/AXZpHE3oh8V3lrj4yfPI79jB\n    NKau15TA6uVL7L4amFBVGmw/vML69cfdz/27S9xJvr8JPVGuN7j+1XswX34L0DzGjjJ1uWd+7nvt\n    Vt7qxJ+67y+POVri2Uf+MkGco5n8ZXAyMJO7WqFK5rDcB2jp5ybyl48bIn+1XHSI/F2ACfH6fFs/\n    F7TFEjhRnKWfm5LUm2IcWhnt2L6/sRZjbb6/MbLLIYu0UCyurT0gTP5qtMUHYwpIupC3vm1D+w/1\n    /W1CTEFQqK22gidfDHyseDbH2ceWfpbCsFOXfo7lWS4nfh+ngqnJ31Owkz1W9e9n/sVxFcC+k/7B\n    CVzMMZEyD1wMJYGnFvaUzn1sqQeWgp4SfaqAgbgbg6abgiGVwE03MSESOBYxN18xRDFjqB8w1L6h\n    rMcmrD3thKSgN572Y0IqbX7AG4zvB8zHWiKOBNbo6gfc5M3D2b3cJmADxm0ksG8yGyKBu3gf8XsQ\n    uS6eZLsyWHZirqWg9X4lbccBgsqr0CWBrWRY3Y/KJXbrMs62Qowz1G2wmr0KZdsd6rJoIgVdwMqk\n    GRS4fuV97D77AjBpDE7ohiwD7vzTXZz/6BYyQP0C6zCwv6HN/TVWbzyG2fWUrywNNh88wfaNx077\n    tXOUzVHdcWcwWHx/idspYJ0wAKa0vr+2j676Yg4mcwUuy/jrcUDG4NyzXsaExb66iYldXxUwB6vL\n    wz2D9dGtn0O4Opfbl39Nft+A9Srmf6FqXbqih4dUBNvzqZPAmed9swfw4lAhVn8fTLBzMpZLnNvq\n    M6OOYwn34nC89a//gO29B6NK2yc8Wzj/L7dxa+8HrH8ZPsjy4kmJ1c+/GZRQtftqg9XLlzCl+JzW\n    wWO8IL/Ik41CQn/sfX83b3wGo8ZHl9B1yV6bhlQe/rd0sXGSdkrVt/O8yPfablfW9rGexDi8PqP5\n    ICdL+ap0eX7JY5soTR0ui2pLz0E1cQy4SVe+ROmQ768gRP5yQlcf6WfBAgZW46Aee/CRv9vAc10R\n    7LPFOjXfX70s1vdXI9YSbWzpZx3Pi4nlNUk/M64RVwSjY5VNMc8+vr8afat3m+LAfcjfOXFK0s++\n    dk/VuGzq6t+x5J8TTgI3QwIamIe9PyYJHPPjC2GKKuAxoDvJuTrnWLQNMlNXAQ8hgftWAet2uqKr\n    REpsFbDcRI2Ryae3GXqTqdFFClqjzQ/YRwL3kYK2+7pyQdoPuOk9NNW06exTTQL7slJj/IA1iQr4\n    J4hNUtC+SaZMfH0ksCBU0ev7bH0TYRf+CbiPONbH0bLQ+lx05RQfaws7cZdtOfiugw5V0EAy0ksi\n    kVnuzAapxdNKgho6ULFAsQ+SVGchrw1c+TSHoNjtcPWzt7G7PHXBnoSTxPkCF//6HeTfsaEdlwyu\n    KBhfoe36V4+wuXfdK/dg98UaVy9/c9hXftuNlccAFhc57vw4BawThmH38DFWL30I7GwCDhOKNlBd\n    9+31KTJIsDqjKl7p/7U8Mm8LtS5Xx5Jl0k5Oy7gyl4PNgB2/NGGcd3j4SF17T4DD1dG+w/qcAa4g\n    5vHRjsOZuh483ma0DVdR27brldkGeqy0yVM5XK9nA4PMFLh68SPsvk7jaEJ/XPzDXZz91UVtHAuN\n    a/Kb3X68wurNfglV5mqH9c8vUTzRNgr79ftnepjOxPc32Sgk9IHy/bVjaNXbsxID98daucGXWFuq\n    fpzHCJGCln3zw3I4/TorUOwAh/zl5F87H3WVLHzkL5OmslxXz+pq4BD5qy7mYZ/Cu9Y0VgzzOWjy\n    13j2iyV/m3x/NfmrEev7q/cV6Wd4tpnD91dvL23N5fsLNMfPpK0m6OrfEPnb1/eX9zXo5/vbJP3c\n    V1GxTalR0BQDfhKx/7EQU/07FKd+B/ysSj8DfmXdp60A01cge0Lev4J4AvjYUtA3GbFZE3P8CC87\n    bPssSEH7MFcVMDCMZI65AfDh1KWgY27Y2tazFDRQv3HtKgUdU/kbugnu4gfsI4GH+gGfIewH3OQ7\n    g0B7LAUd2rcpU9bnB8xSTU0kcB8/YB8JDFgSlvfzVfTKOTX5AcdkQy8C2+pJtuu5VJfc8kmBuZN6\n    VxpMtlmCg/duVrmtanIz0peearAFEQta6tmG1N0gSEHb2+CGJSmKh4+xee2d5Aec0AvL75/h9j8/\n    j8WtKlDMwers8HuTykAcXqMwuH7pG+wu2yWcGebxDlcvXQLXrlOos40nZJ7nwPnf3sHyr1LAOqE/\n    yus1tr/4CMXD60NCjpahLKgvdmUt3f6cCcZQtaz02ZJMZElLS2RaIlQ8Divkaj0HqbUEM1fuls6x\n    1PuPePi254C68ZyXrwrZPX84QXp+z9LLhEhgubI5LOHLn0mJ8HWXz0bLcpdqvfl2hdUrH6K8SuNo\n    Qj9kyxwXP/kO8h/YBCWdUCXLAHfcW7/2CNuOCVVmV2L15mNsPl47YzOP1aGK/+WPLnDxT88nG4WE\n    XigPvr8baLlnbZOw2Hv4suKR/M1hfX+FONZy/pxExfMtVm7S44pNqIKznczveE5p4M7r2Pe37uVr\n    55o6Odkny8zrY1SvBNK+zJ91QjWTv5owHZP8ddsOE999fX/5+bF9f/X5SVtdpZ+HkL9rjOv7GyrK\n    GOL7e6v2fe+GGN/frtLPY2JM6eexcZOkn8eu/u3Cq1yO/F58iOWdpqr+nYP8Pbb88zHJ38/Cq7pV\n    AOs3MbcM9DE+xLF8gKcmgbtkf1x2aHdsKeixq4CHSkGHBps5SeAmDJGCbsIQEnhKKegYErjthm0s\n    ElhDS9j4MhhjSWCNM3WjrREigRl9/IC1FHSbL02TH7A+hyavHB8JLM95ksjtyXa+SZ/vOU+Q2etH\n    yzLzcWUrfd5CvDaRwE3ZzYI2Elgm0Cx5pUngM2jilwlb1w9YV4a58tjuvrIdewizH7AOUnNGfIFK\n    9rmk5favlUnTQW+pZgIMNu/8Eet37sEUw3xZE55NnP31czj7H3eQZZ5KocA+BgAebbH5xSXMKu57\n    Z3Yl1r99hPLzNbqOwsu/vMDtFLBOGACzK7D9/afYfvCV03e7/upGJdtIYFn3va4Xod6HLQBcwtPW\n    QTGpyoFzST7SEsg+stYnC62rhrPAwyVL/Q8mavPaPvX3AtSJYN7XVvuzzYF7HdxAvmuJIMt0hdny\n    oKDBkqNGfY4u0c9JViUMdvcusf5d8gNO6I/Fd5a485MXkN8Ox4h8Y58pDNYvX6J4GOcHbAywvXeN\n    1WvfRo2lPGzm3z3DnX/7TrJRSOiFcrPB6jfvofzyEVgLgsfPHMV+DlTsE62K/TrbT+uHJnt57DWH\n    OZVNrtVJt/Y5ywHb7dp8f4X8lTm+Jn95fsnzTv7rqxKWfUMSziHyl4loNz7iJ3F9x/ARuHp5OBnc\n    PmdStimZXMc1mmIZrILWRv728f2V2E+s769Psln3xucwQfJ3Q9v0gcTZmmJeXXx/+9q4xagFSpyy\n    T/VvaJm010f6eczqXx+GkL9j+f/GnEdfPKvkb9/q32OTv3PjyxmOcYPscYdLQM/xZuf40ARTZiPc\n    1B/RTSGB+2IOErhp8OwrBQ30vxEYiiYp6C43SgxpL0YOeoiPb2w7faSgY9EkBW2XNxO+eh+g3Q9Y\n    b1MdZZgfME9yYv2ANVnty9zVMkpNEzoEtlvCZh7zebT5AYckrppI4NDkmNfDOW598i0TZlkv+2zp\n    OCVcElhX8+ZOGziss8FmOIFn/TD74AQHpheHwAdXHbkBBx0IKWF9f+uSo9VySy5Uz65feR+7z5Mf\n    cEJ3ZDlw+/9+Aef/6dwug1uxxFW5XMG0fe8Km/cewxQt37vSYPPRNdavxwWsGYvvL3HxLylgndAf\n    le/vA1z/4hMU+2CykH+ud6E59LH2wURuSeMF+xzWE3yEKAZcgtklQ/3kruwbqvgFOFhuK3fZn9fA\n    n8AhazUZzOlPOLRnqxi5bV2lzGNiRuecO9dJk8U60M+Eb1kjquXaaeloGWNNrT2p8LXX3fUfthVn\n    Mq6vf/0Ztve+hEl+wAk9cfYXt3H+d88hy7tlK+2+2UUnVBUPK99fFNUviY9kkNUkoAV5slFIGABT\n    lth+8Ck2r38GTgKSvpZVNCrli3oCTuVtb+dVLAOtfX9z2kfIX9/8S29n4M7t9mfvjB9MCDP5K+NW\n    ATuH1/NO9v3V806titU0v+XteFs3Gdn5BA77h3x/OV7gk3FeeNpdBrYTcxiOV4TI3/qZ+uMWMeQv\n    o6/vr5C/vnOIlX5mxJC/ep/Y6l/fdlpFr0/MzEf+9pV+5uWxlnY+6ech3r6nKP08V+Vv03GGVP9O\n    Tf4+qxiTt9IFlan6tx8GSj8LuhPAz6IU9FhVwEDcjyk2K0NjqirgKTAFCTxFh902YI15nCb4SGAZ\n    5E9NChqobo76SkHzvk03cV39gLvIOQvapKC7+AF3lYL2HS+mCrjJD1i29/kBx5LA+nhtJHAoW7VJ\n    ykgmUtv92VTr+vkBCwmspadiSWCdtewjgd12u2VI60xsnpTzeiGBARxIYD5PDqq7wQErH7aj7SVw\n    4UqLVUGIYh+kYAmznEIdTOiy/DNXgFUSaAWYZFhQJr0Qv47U5W6H6xffQvHoFPQXEm4astuVH/Dy\n    BZdk5QCy9hMUOuX61UfYfdGcWrT7qgpYl6UNUJuGY8hxsts5Ln78AhbfTQHrhP4oLr/F9U8/hCmK\n    gyd75ul/dYKOlqzkKmAmHRdUjaQJYSYdpef2basrbIG6xy9Xyvqqe3N1XJ+nb0gWVhOu7Amc0TLZ\n    Tiq2+L3Lu3GJazjH9qloyPZ6PY9xXCXm+jYLie76CZdq/1L9zcAk8p4sLvZ+wA/TOJrQExlw8Y/P\n    Y/kX/pmbpoV5HFy/f431249hduG5llkVWP/iEsU3O2iCt2ksxd5G4ey/JRuFhB4wBrsvH2D10jtg\n    uWdXrpk9fO28pVT9sh4jdd/sKkxUz5cosQWTvTZtyRz6exzma5KQC9gk4HryFQ5/feSvL0HZR/72\n    VbjKqYdg8jdkqSR/Q+QvK2D1kX4WaN9fiVP4FMYE2vdXrxPouIaPRB7D91dmDDG+v23Sz5r8ZQz1\n    /ZU2Wfq5K/kbqv7V6/tKP/NygzjyV6NN3bCt+ncq8rdt/yFVt3NU//Ylf4F5PH9Ptfp3StzUokUf\n    jlH9e2zy97Pm1f0qgI8hBS0f3hxs/hxZCaeAyw7bjl0FPAWGDALHrgLui5hMr6lI4BhCt48UtL6B\n    irmZa1qvQ/pj+gHfUtsI+pLAWgo6xg9YH6vZD9gEq47PECZum9oHUPMEbvID3gba0X7AQkozCQx0\n    9wNm6Wj2E2oigfWxNHmsSWCeKMd4JJ2rbX0kMMtVMwlsq3j93k7y95aSDLPBe57414kC8Y4s1HJb\n    jWSD0Yt9WAT750IIm0Pww3pqsbSayKpV2xRgr8riwWOsX3sH5bpvfX3Cs4zFn93C+T89j/y8ThGF\n    KooMMph1ieuXLlF+6093MVc7rH5+ifJbG7DW5K+vVirLgYu/u4Pz5PubMADl9Rqbn38EPLqGS8jW\n    yV+3FleqlkqH8GW1hlDlb12+2SWDNcnLJG41Htjgdg7j/HMrld1q3CbPX59qReihK5Jzas8G0i2y\n    wHnacZCPj8MxbBJV6Dz4/fo9JuWz8yVaaS9neWdMvhv6zDKUwLcrrH/+IcrrNI4m9EN2luP2v76A\n    5Q+Wh7GtSVVDYJBh9YtH2P3h2lsAaHYG67cfY/P+NULkb6ju+OxHF7iTbBQSeqJ8/ATrF3+PYrVB\n    RspG/uSakhKDXDl+1wu4rpBhYJOKbN9unCRbnl9xla+MgTJXY99fTfpysi+PnSzzzPPIEPkL2Pno\n    OdzEZF8yNJO/ukq4TRELQCP5y/N0q+AVR/76qoWZ/NXqYUN9fw1MLXbR5PurMafvryZ/x/L95RhZ\n    m3JeCL5ijT7tmIjtY7YRzCH9PAZOXfr5W2Df59UxhPydovBr7DZPkfx9ONNxBMeo/hU8LdLPI1X+\n    CoZLQM/55ueE/nLelCrgrrjssO1QEljj1CQWjk0CTyUFHbO+L2KkoK89y2LAN2khsneoj+/QdtYI\n    ZzeuA/uFSGCBjwRmxJLAGiwF7fMDlnZjs1+1H41kK/vOoUlGKeQHDIh8U50E9vkBN5HAPHn0kcCA\n    S9yy/FWTrDPDN2F2USeBtTeToIkELtS5sFSYnjzr4MAStuLIBhZkcm0lJrlqTPbZws1wdwPblvQ1\n    1JYObmcosNsHU7QcNJMRm7c+x+bd5Aec0A+3/sdzOPvvtw9RZKaCOZCtJSeLP26w+vUjmK2ioHYl\n    1m8+xvbjVS1gnam/ev35X17g1j++EI5oJyS0wOwKbH7/KTYffH1I0GH/dLfqyJKFTELm1DeD+nAO\n    XOuqpvwgeWz76hxudRNX1Go56IyOKFS1VYfwVQvritsKuoI4FrqCt1TtaUJZ3ocN3FtSW0Y10D4Z\n    /WUbBLfKuKRtXKJASAEeT/kzymufoZWC1pXfmoAoYLD58CG2b30Cs0vjaEI/LL57hts/dv2AfSSw\n    Ht7KjcHqpYcoHqmZhAF2f7jG9S8eOWNl2/CYAVh8b4k7//ZCslFI6IVys8H1r9/D9vNHh34S+3lJ\n    NfcpagSwrQK2z2UbUVzwJVJJ3y3C/jI+SIIPz7M4qYiXLw9tAJzUW72yy7XvL69rIn8BnnfaBPeu\n    c1lGiPzlY/nkm0PkLx8vlvzlbSR+IORvyDe4j+9vDPkbqv6Vdnxqa1P4/urPcSzfXx/h63veNQ0t\n    VKjR1xpuDN/fPgUtjJsm/TwH+TsUc0g/z1HABvQjf/v4/85N/j6LOLZa8mftm/QngI/x5ub0Aj4F\n    9PmR9ukMLo/4HscmgcuJBpkCp0sCx0hBN60fKgXdNeOtjx9wCH2koIF+N6NAt5vc2JtpIYFDlbkV\n    2tuK8QOutquTwAJNAnfxA7Zn6k5w9HL93EcC60kdT+KAusdPaFLnEsr1SSQTrFD7aQ8kPm/OMg5J\n    ZmlCls+hLrnlv94+Eli3yyQw+wG7VU52X5addP2D5Tx8cpvlwbdKSz5bByzbtpAUVvyMpaGLw1+u\n    DtZ+wKtX3kt+wAm9kC0y3P7n7+DsP5w7XqLebdXr9RtPsP3gChD/TGOwvXeN1WuPavtlgTZk2fIH\n    le9vdjZesmXCswXx/V394j7YZ7BQfe6C1rnkbuEEu7lP1xWrWgpaLAP4GFyxpIlI3tatKHbHFa6+\n    dcldd72PIB7y8LWrSWItFw31fvl98naZujZcPaavp/0MQUSCe/2kSsxKZReH9jV5z59nodZd//wT\n    bD95kPyAE3rj7C/v4Nbf3UGWN89EdFLV7qsd1r/6Bljbu+Ti0RbXL10i25TOfuE297/Hixy3//kF\n    LL53fuzLkXATsff93f7uU7j9tVVNcGWey9oYKfOTElbdSM9/StUXLymJVipRc2qPq4F18i3P2+w6\n    HLbhed8CNgW3ifxl8LzPZ0nEv3ZuFwhbGgF+8jdE4obI4oXnHJrm+SF/YLaBavL97UP+6n27kL9n\n    zrzb+v4y+es7N30MX6Wvz/cXmMb3FxhO/s4p/TzE97cJx5Z+DqGv9POY5G8ThlT/jh3vn6IobezC\n    OUYfvicWU8o/z1X9+32YZ1L6ORLDglLHlIKeA1N+Saf8cU3ZKUzRmZ0SCdw0GI3pBzyFHDTQ/0Zh\n    DD/gJkztB9wETQL3rQKOJYEZMVLQvG+sH7CvClgva5aCdklg34QghgTm1zypCpHATT7DjBAJbCdw\n    /gmfr/J54Tn+wnMeMX7A7nn7/YC1b5ImgVk6iyWo9SSY2zC1866TwO55ur6EuhKYA9VSgSTPC7i+\n    VLrKqFDLFyrgL4FxJn0loGLrl8raclDQBSiRbbaVH/C3yccwoTvyOwtc/Mt3kN+11ULy69DSlRkt\n    Mwa4fuUSu6+qnrD8eoPrly9RFrbSSVcO6+cZgPz2PmCdfH8TBqDy/f1gr4Zg1RbYM9YnY8lVwEb1\n    40xkut63ddLUENHJFbPSz4OWyciSoV6VauWP/cSuloVmwnVxqMAynR+yr0tau57GPqKYK5VN7f3U\n    iVgATkC+pKtv65/dcdKVwy7VdfQTy0z21pOnXNsFwMAUBVYvfoDiMo2jCT2RAbf+8QWc/+WFszjk\n    1cvj6fqtK6zfe1IlVK0LXL/2DXZf7YJjqV4GIPn+JgyDMSj2vr9sOeOOidbrl6t8JSF1d3guY4Tt\n    d3VCjq3ypX7YSdDCXgranacVcMdWJn9ZFprneYA7dywCy+V5TstkG55/hqyM9DY+8pflqduSr3m/\n    BZ0PnxvP531Vw6GE8KXTUjv5uw0817ELHRPx+f762uF9BE0J/7G+vyHy91i+v32km9ukn2PJ31A8\n    6Zbne9UVMSqGXQthYqt1Ywt7fO0NkX4eA9L+FNW/N4H87YLLmY7zMGKbsfmpMRV0u+BpIX8nwvCq\n    hGOQwA8mP8I8uKlS0H3RJKNwE0hgGUynJoGHSEG3IZYg7koClxE3RX3lU2L8gNtu7HwksI9YjZWC\n    9t2oDvEDBhDlB8wYgwT2HZ+fh0hgbk9DJkUx0kUhP2DdvksshzN9ZZ8mP2DJBjaefWNJYIswCQzV\n    po9o1j7EIRLYbbNOArM8tCaB830wwWad8zorXymSZRyIMKikn20gvnAkQCWDnaXSQAF3WcfymDZA\n    4gZZfPLSxYPHWL32LkzyA07ogbP/eAu3/vdd5Mt6jVGoajcDUDwpsfr5JYqvN7j+xTfYfVP4A9Oe\n    ZRmAfAHc+rs7OEu+vwkDUF6vKx/Xg+9v3W+QCcG6dKWb7MPEJ1f0chBavNyZ9NQkqVWPAGRM0YSq\n    rfytwJ6DLMXM52THIg6om8O2fR+g8+OAOh83U+fF5wtqQ1dfyX4y+uWB66XJXHdMdsl4JoHdOjP3\n    8+XP3BIHBYT8P3x+31xX36NVGkcT+iE7y3HxL9/B4vvVXTmPe6EK3gwADHD16iPsPl9j894TbN+6\n    at5+D77bXibf34QBKB8/wfXe97c89J12zqKrd3NP3yqKRTnceYpNTiqJuK0n6vC46SN/jfor8zSr\n    WsGJW9U6TjbW5K/81dZCsi3gzjsXtK2ei3Ylf4H6vLmJ/C3o2ELY8jy+Tfq5fkxpyd0mZI0VU8Gr\n    9+3i+6uJZF+spavvbwz5C7T7/gKIIn9DFme+WFbTfowQ+dsVMXG7IdLPfZcL2o4ZIoOPZe03RoFS\n    DPk7pPp3TDTxD0Pkn29q9e+UmKv692nCBNW/wJgewHPiezN+gfjLeqwshqcJc2npA9Nk9Hyr/h4L\n    mgTmG4gxpKD7IIYEjlnOiJWCBrr7+DJiSeC2G92hfsAamgTWJGQsCazB/r9NfsAhxPgBt0lE6+Uh\n    P2Cd5RsigWP9gHlSaTz7NpHAIV8jHwmcq3P0VexaKeiqVV8mtvYDlmOC9hH/Jzf47Mpa8vF8QXbr\n    eugGG7hCuARUlnxdipSDK9khNC4kgZt5z9n2ukJN/m5//wds378PJD/ghB649XfPY/nXd8ijl/+G\n    aF1g8/Eaq1cvsf7APyIYtS9XQC3+4gK3/iH5/ib0h9kVWL/1CTYffA2fPLAkzchzvw+h6wvL2ywo\n    +A21nXH25xpW1x/XJXo1qVwfZzSxyct9/ryaxO2Lpja1DzD/q8tSu1vlsOMnk8lyHcrD1lbK1q1E\n    ttXRMsLyOCjXkhOpdBUxJ1Vp4p6Jh/UHX2P71idA8gNO6AnxA15cZBAS2Cgq2PgGvVWJq5cvcf1q\n    yLEvPA7n3zvDxb98J/n+JvRCudlg9Zt3D76/Mu/IUEkvswqR9KPSp4pdTd3iwCawct/rKiMV3sQo\n    kYWWcZyTcO18CwepaJdY1cm9VkqYyV+eJwqhqhOa2FJISFiff6/PIgnUvo/8rStToZH8ZWlr3zw9\n    xvc3RP767J0EmrSNiVMYdPf95TiIj6Tt6vvbFJth6JhSjPRzTFtT+f7KPl2qf1doVwe8xnDp567y\n    zk3rYqSfu5C7fap/QxiT/G3CKUk/HxuXMx0npqBwSnXaOTGV5zTjBlf/AmMRwMeoAp7jw50DU1UB\n    T+kFPFVWy9iE7RBz+KYq4DFJ4DGloMcmgftIQYfWX9CNmG95W5uxUtBd/IDbMhdDmNIPWFcB87K+\n    bQH+TNZK+nk6P2AmgYf4AfNznphye77JYhMJzFnJMSSwwFely75Jurq3iQRm2Ujex+fFpElgPk55\n    2K9OArtVwW7muK7sshJjNuis5Snz/TViGTQdkC6pXRvWduWffZKlHFCxx6vo5euX38PmiwdIfsAJ\n    XZEtM1z8+DtY/tk5dJDZ/iqqADRLOGcANh+unNC0JX018Uvk7w+WuP0v30F2fjMTLBOOD/H9Xf/8\n    PthLXbzVmdBlaX0taym+sayqwFXCTNqCtpHAc1162BK1rgQyy0hXS2xlLA77un7cRm1jwf71TQ94\n    HjH7+Y7nBuvlHVpCl9+HUdvbqmx3XNZS1sY5B5c0Z2KCiQomlfO9nzNLbNvP3n4v5POXT1+Ijuuf\n    f4Ltp1+lcTShN87+6g5u/e0dFT7SBK47ngJA8ccNypXbG9jt9B1q1Ua+9/1d/iD5/ib0wN73d/P6\n    p4fx0uz7USZzQwmovm1KcCXuXqnoMC5wNbH1+t06/b+VhHYlnZkkdud+btWtS/4WEC/5Cj7fX50A\n    LOsl+VjbFslR9BxYz1UXtXPzK10xCWuXhcnfUNVwiPzlbZbwz+l1PECTtk0xiTF9f3Vsp4/vL4Cj\n    ST+Hihn0866+v/r4Y/n+diF/NWIKT5rIyCnJ3yHSz4A/fj02+TsFTzM2TzBV9W8sLnvsM1X179Tk\n    71zVv3OoBM9F/vap/v0sbrPxAlRPsxT01F/aqX50U5LAQ3BTqoBjMpSmIoFj2vUN8l2qeKcggWMI\n    3T5S0FP6AfeRgm4igW95tgPqBKo+vrz2kcDc3gZxfsAMnxS0oM0POJYE5te+rNouJDAjNOljElh7\n    AOlJo+95Ewmsaw34uE2T3Vyde2iZjwTmdnwkMpPA+phCAsvnp2UoC4Cyzt0gg3XEssFxDq5z5rpI\n    oEmWfLF/ztVOCwqcuJKkBQVahLSwJLDIQgPixWV9LMv1BquX3kL5+DESErpicXeB2//yAhbP5fCR\n    wO5rJnn1g7evVy3lt/OqQir5/iYMwI58f7Wss+2L3cQbDl6XMNjB7w8s+0giTwbxN3Tb9LXvq+a1\n    uhH8y/ArTFRw7RcYoYpf7etrK2hN9DoGe/Tq48sZsoqGlo/OwCO4643sktE+xQv3+rmkvJuw5fP5\n    1Z+rrlBj0WgtF212O1y/9D6Kb9I4mtAPWQZc/NMLOPuRO9uz1cA+U4T6ONpyFGQ5cCv5/ib0Bfn+\n    GlhpfK7qlaTTHfW1kt7D/a1O4ilVn8t9vaGxUnp3K+1stZR4nsXzL/b95fkb9+8+8tdXvesjf4Fw\n    ojFoX03eaqIXgWMCdfJXe+XqZGgf+QugcR6v5/yHj13N5QG/76/zVaH9Y3x/Q1LPfXx/LRlr2xjD\n    9xfwSz+PRf7KtmP5/q477O9rh9EWBwyhq1ph10rUoSqLglMlf9uOIehb/XsXZlBh16nhssc+fcnf\n    h0d6j3Mr5z7A9CrBc/CbM2DaCoWpL9L3YGb3Az6WDHTfH++pksAhTCHbPHabXAU8FqYggcfyh+h6\n    0zKFFDSjjQTuKgU91A/Y19Z54Ka5KwksOAu0JxjLDzhGFihEAjf5AXMWbMzkaetpR5PAO6dd/4TQ\n    d6wF6pO9BU1A2Rcpxg/YtOzny652J9J+Epi31fJdIeI533+mMvH3kcDaD5i3Yw9GN1u9el7ABiAs\n    aSuEsJs9L1VJboWxJRQkIJOj9Aa5rafwvprpj4+w+vW7MBtfakRCQjOWf34bt/6X9QPW4eiYUYgp\n    JXc5qoD13z2Hs79MAeuE/iiv19j8/IOD76/4C9arceukIqssiCyllr3UwesS9bGCiWLXcsEllNkH\n    18AGtK2aBEtIAzzmNFX15giTtyXUbzWnx+Es20nktmphK3FtK5oNnX9G74q9gVlKuzycVv362s/C\n    veYG7uck4yFLfhu4Vd9c5a19m+WvJGYVD69x/YsPUa7SOJrQE+cL3P6372DxvSUAt3q3eu0fJzU0\n    gcxbn/3oAhf/9ELy/U3oBfb9tSmubgIqj5FibcPVvlqNge0TpL3FfqwtqH9nBQaf0hJg5106+ZbJ\n    3yVKL/m72M/zZB4ZImJ95K+eX2ryF0Ar+Vt42jGB/X3Sz3r7pnk1I5TwvaS9OD7A+zC0769eJ/vp\n    bXYN7YTOVZ6HfH99r0PtxPr+As0qckA4RsVYB577yN/Qfhox5O9Q6WfBlNLPXdUQdRx1qO9vXzJ5\n    SvJ3aunnsTFl9e+U/r9T4Gmp/j0G+XvDpJ8F00vUPY0k8BS4abrrQzu3uaqAh2YLzSUFDfQngX2I\n    JYH7+gG33fy0kcBDpKB9+zO6SkED/eSgfaQxv465wfa1x/uGbuKr5eHsUl7WxQ/Y91pXATchJAXN\n    7TZJKm09z3X73OZOXQef51CbHzCfS1Mms943RAL7/IBDElugFoBmEpjfo/YTliCB9nHiwL5UCZ/t\n    AxZaKlrLfOr1UvkrhIP4S0pFWg5bfWY9tFz5tByu9CgHWZhYYI8tG/IvsfrdZ9h89ClMOdQVMuFZ\n    xPnfP4+zv759CE7H1iMJ9Pb8Cz77ywtc/OPzyfc3oTfY97dURJ7uI6sAdlGTrFw4+/k8ga1kMBOI\n    LGWsq52qwKpLDNtqW0uQyvF53GA6SHpzmXn6KnAzuJLUvkcGA+T7B6/bL8sa9vVXJbvI1flk6voZ\n    dY5Ml2tCd6deg65brq43J1X5qqhB15aVNrQcuB1D/YRw8e4DbN/9FCiSH3BCPyy/V/kB5xfhOJL2\n    CNZEMW8H2J4i/94SF//2neT7m9AL5WaD1W8r39/8MFuS/lErE5WHfljGU91f676Vvds5CVaqfTPq\n    y31qSpxAxORvQXOtJvLXJktV69t8e7uQvzyvlG185K+cC+/DbcWSv5wcLvD59uq5f307qyyiyd+Q\n    9HNIBlqTvxxDuAm+vyz9HOv7ez5gGS/vE0frSv42rR9T+rmJ/O3rCQyM4/vrQ1v179iFS03H8Z3L\n    EPJ3iuKwEJ426eeHLeun4p/mLph8WqxhBX3knztgXAL4WCz41Iy/RqoCHgehTvbUqoCPnbHUNmiH\n    Bv3YDLGb6AcsGEsKGvBX7/aRgoZqU8NE3lQ3+QGvqTXfPqG2gOP7AcvyJl8d3Y60wXAnk/XJY6wf\n    MC/ncwn5AYdIYG7FTo7dSbgmeH1Z000T+xwuwdxGAutqKz4PHXyu9rHBCk0Cy366comdg3MVPBEK\n    wXoD28olDkyLRLQrw+ZWIUvQZfWzd7BLfsAJPZCfZbj94+9g+R8qof7YSqXWdn9wVvn+niXf34R+\n    MKXB7tMvsf75/UNfbwk/nSDDKgthD3Xuo5mYdQPKnKRj+2NOHOJ9WOiSiWB3vesBzG3IOCNqEixa\n    zGOPfuz2jxI4TF31NgfsK4J5n/q2lnQt6Tzk3LTcNe/HVLkdw+x2cm2N2l9f32qZ2B6447E8X3g+\n    TzdxipOq3O+H9ryU9QUMrl+5h+0fkh9wQn+c/dfKDzgbMOzpMTi7tff9/V6yUUjoAfH9/e2ngOoX\n    2aNXJ1S5Mvo2WZU9gKUvtkmwbpWvreq1YwgncLEyBu/Dz3OUONuTv1wRzISrtQkKk78htSidbKwt\n    jTRBHCJ/Q3NfOVaI/NXzbb081vc3RP76yGOBJm2nIn+5rTF8f0O2YDfd97cv+WsC6zX5Gwvftn3J\n    Xx9iYrFz+P76MHb1b4j8HQKJ348p/zwlodxWIHfZo82pfH+nwjGkn6fGTaj+jfT/BeaoAAbm0cue\n    m/mf4ss9ZRXwFCTwGBIHN8UP2Ie5qoBjzyWEsaSgu6Ip+y6mkret7bZ9Tcu1HIsE5n3186n9gKU1\n    QZMf8BlNSqb2A/aRwL7nvrZCVcFAsx8wXwffZLKJBA5lQDeRwKB19evhSloKmkhgPkaIBLbkbRwJ\n    zP7AEtxwj1HPTN8ClAXvbiftiG+Wrk6rKpOsx5YQxexxyBVsC8rIl31L1H26HD/g1Rrrl36P8vGx\n    eraEm4z87gK3f/ICFs8t4BK/VhTaBB4aBhny2wvcSb6/CQOxu/wWV3vfX13BKZQjE30gos+tVKoT\n    xbmzXen027oyNve8ll8Aj2d8FrlaL7LN7Ptrq3uNcwQeg3zno88lz9Xr2lhL63PT2F4GS/1CnZeQ\n    ukwua49gruRirQrZ33/t+Pj187EJVP7PT3+2bfuyHQN/j8x2h6sXP0D5TRpHE/qh8gN+Hmc/ugAQ\n    TqSy42fYD9ggQ55luPib2zhPvr8JfaB8f33jpYwzO+oLOSlVnhdw1Yw4Wajq+61FjbWqcZNbZb7E\n    Vb4yDmzpuaE2mXRlkpbHnhjy15LPzeRvqHK47vlrvOSvj3htIn+1R7G0Im3EkL9uMrj7PkPz/VC1\n    Lz/XFlW+56FKX1+7AILkb/Xaf25jkb8+K7ExfH/7oC3O1qcdHzgu2Ff6eQj527f6tw1TSD+PhZg4\n    +LELqWLxtEk/P2xZPwXvlHx/bwTGJ4BDbPgcF2/KDIDves7/WSCB2zBVZzcmWTtG1lDT4DU2Cdx0\n    jK4YUwq6TxVwDAnctqztmG0+IV3RlQRet6w7FT9g3jfWD9hHAsv2vvfgk22W7bUfsCxf0jk1XRtB\n    DAmsPYK6kMCLwIQSqEsxy7ImH6RwtrRLAu9QJ5rlvEIksLzWE332BtZBBiaBbzlZ7zaozVnquhLX\n    BvktccvSlUwC59Q+VwiztyHLq9m6qKpqSQLX1XObjb/5/BHWv30v+QEn9MLZf76FW//7LrJldxlo\n    gMLXOXDr7+7g/C9vH/stJdxglNdrrH/x/t7315XN91UnMTksfSYHr7nPlcQblwS067ma16jXVV9u\n    +32fpDBv4xKldbJTS0K7stD+MdKp7u05Za1VCBPkuCz3rCWf6+Sx+z51MpWW9+RrxFXVnGhVp5/3\n    CU+Hcyprny0TFC5Z4RIe8K4rUX71BOvXPkh+wAm9kZ0vcPFv30H+3cqJs07tNuyrHss/v5V8fxN6\n    Q3x/y9Uadk5RkgKCm2TK46euDma1IwN37FtQewX9ZfKXxw3XU94lgo3aDnATdrVNT8h/l+ebPs9f\n    PQdtk412YWrtyn7uMerS00PIX36u5/T2DNrJ3/q7qRO7mvzVctKMEBmsiWTt++uSv/42uP1Y8le2\n    CZG/EhMaw/c39LyL9LNv26G+v7x8iO9vX8/f0DZtMdQuCO3fV/p5rOrfLufSFXMqgs5B/l72aPcm\n    Vf/6eLHvTnj+c5C/NwUdqn+BuSqA58LUfsBzkcBNaMvmGBuXEdvcFD9gYHwp6LEHOyA8KA+Vgu6b\n    5z+UBG7axlfJ20UKWvZtuins6gcMdPcE9klBh553hZDAIT/gCi6hG/ID5n1j/IB9JLDeP+QN7PPx\n    1X7ATdtuW9ppIoGXCE0Y3fPQz5tIYF8bTSRwvaLXJXD53GSCzm26AXE/CcyvNfncRAJLVXBB5ybv\n    mYlc65PIQp1uezb7vQoqW0k0Vz6Ng9QcgOHgtPhxGdpPZ+fL9uvffoLtR58kP+CEXrj1P+/i/K8v\n    wNVJ7Avse/B2BhnO/yL5/iYMg9kVWL31Cbbvfw1d9aulnUWaEmpdDpbdr1eKcr+p10k/rwlIDmK7\n    6wEOWJ/t9Rnq0sqgIDgOQXAfORwifxl5z+lqntt9m0ng+vm4xLQ7Hur3eYZStQNoQphJAZ98dKjC\n    V0t98+fskwGvt8VjJx+3xOrtL7F591OYIo2jCf2w/N4Z7vz4eSxu+ZUzfOOofiy+u8Ttf3sB2UXy\n    /U3oDvH9LT7/BqB+L9+bDVQJqNYP2CZL+SX0F4cEVBkT3D5Z/ub01y6z+2gClxNqecy9tR9ZQuSv\n    kK9N5O8C7eQvK1Dp/Xkbu8wlppvmuZrEFbSRv7KNxlKdqzxfHlqKI3+1729oHS/jcwpJP/vA5C3H\n    XDT52+b7G+v5q6+j3tdH/gr6LBsq/Syf2RS+v8Aw39+22OMQ398m9C3QAaaJQXdBjPRz3+pfjteP\n    Kf/sw9Pm+xuDKQsOBVOSv8A85G+ogPWU5J87kr/A3ATwHFXAU38Zpv4yAzevChg4fRKYB4+bIAU9\n    5FymQFvmWtPNTwyh20cKugsJ3IQmEth4blJDiCWBu1YBy7IQCbym11vP+ia0+QEDqHkCc4VxE3Gr\n    1zf5AcvfkPyz7zi6Tb6mLN2sr7VvArdQx5Vl/JBlIT/gtsxoTdj6g97uxFhvo7O0lyhrvlByTE0C\n    S7ssDcYEsUzMxYfK0r026M2+lDkMlvugN2/rqzpygyZamq1OTrjVa0wOF4cgt8HeD/jLr5GQ0BXZ\n    cu8H/MNzABlyhIPTHMiutsuw/MEZbv/rC8n3N6E3TGmw/fRLrH9+j0jfAgXqJK1QrJqolX6RK5ck\n    wL2AJZKl/QVVNwkZuHCO4y7TFcFczaslkjXJ6SM46xW0dXDSUg6DZV6Xex7yCMFHZIcI8ky9DyGC\n    fVXDXOHbdK2l0le8mX2fnRAYOa3LKZmKvxelGm/tdu4YvHrlY+z++DWSH3BCX5z9tzs4/5s7yLIM\n    GY2nvjFVllcjZ4bsVo6Lf34eix+cH/ttJNxElCW2H36CzW8/dZJFdQKp7Tvr6hpcEcx/F9Rfyr5S\n    7cvzHUsyu8myuv/3kb9CuGrf3xD5K3NKfr7Yz8dAr3k94M4DgTp5LNu0VfP6lK6afH/5rzznebgv\n    udo3t+dqYj4HTdQyNPmrq3x1IvsQ318f+SvbavIXqn3fMYCY6t8wCRsif7tKP4uVWZ+iBi39HNp3\n    qO8v0C2O2MXHt4/vLzBO9e9U0s9jVP9OSf4ybgL5O4Ua6k2q/AXmL4ic2/p1Tvxph/fWg/wFpiKA\n    j82KPw1+wFOia6dyOdN56U54bKJ2SinouUjgmLZ9A3FMFXBshXCfG5EppKB924ZuImP9gH04BT9g\n    WeaT/uH2mAQeyw/Y7lfPKpV9uvoBdyGBfe1IG7yNJnt9JHCMFDRPPpnI9ZG6el+oc9Dby6RYE7M+\n    orpOArtZ2NImk8A6UMDHz+k9LSgQr0lgPi4HK0o6ByaGNekroQ+dxc5+i/KsCsAUFOR2g95WItpX\n    BVVgt9pg9fLvUT5JPoYJ3ZHfXeD2v7yAxXP5PjDdVP9brTfIkN3OcfGT55Pvb8IgFA8f4fqn7wOF\n    9Ty3kpEmQAQbh/ArVd9oA9rsb+sGnHUlcKnWuftqD3cmQH2kqCVMpYLWSmBa8DrdjpZ9doWL+z3g\n    VAHXjxkihzkgL+MdV9H6roEB6FrZ6yv/FgdiQV/furcvj5dMAoe8KX3fFwNrqWA/a6kYNjDbHVYv\n    vYfy2zSOJvSD+AEv/7ya6bSNp4exNAPO/+ZO8v1N6Afx/X3R+v5Kta9OIC0DVbxaXYgTZHhOouc5\n    rILEybAgNQi3Fevzy169TLrK/E/++shf3/xRyF/f/A/oR/4W6vh8XtxWE/kr802eQ/P8O9b3N0T+\n    akK5yff3GORv/TWCbXaXfq6Tv1qtbSj52+bX21T9G+P7GxNTi9lGKnhPxfc3lvyNicmOLf08NqYo\n    PJL4/9jk7xSS0lNJPw/Fw4Z1Yxcazi39PBfPd+revz3JX+Bpk4BmTPnl8H2p5ySBHw5vojMuI7YZ\n    IwNmLhJ4bCloYNxBsCk7a0o/4CcR++vngqF+wH2loAE38y9E5va50fQRsX38gH03v31IYMAvxxw6\n    9lh+wL7jbdQ+TSQwvw6RuiESOFQVDIR9gqSNndou1g84RAJzO11JYEBLa8FLAhfO+4ongeGZsPNk\n    Xqp2636DVnbMZq+7QfHlIaABascld1kqjQMmOeoVvxJkYUK4pOXa15IDOBlsdXKGEtvPLrH+7Xso\n    NyEH6oSEMM7+8y1c/O/ngGWl49xEAQOV7+/5393B+V8k39+E/nB9fzVxZ4PN3AeGVBPqz+vVSUw2\n    ConJcpMuqesuzw90rB0XOKGHCc1SbbdUYwk/QrX28i/Lm+rxezxyajvwCFUNL+GS1fI+5b3bdku4\n    5DgOQX+3ArpOohcAkecuKd8kGc3PM9hx1Ed2CEGh99998Rjr1z6EWSc/4IR+yC8WuPNvzyP/rpVx\n    bhpLgcr39/Y/3UX29IajEiZE5fv7JorVBkBxmCNwYgwnk9pxq3TmHDyv4L68VH0oz3vE7obnVVIF\n    7M6XSpVgZOdjWm55cTi7OvmqyV8Zv0Pkb2j+2IX85W1Cdkkh8rduzwSnnVjyl+fxTLY2+QYDdcLX\n    9zxE8jZJRrtXwfUO1uSvT5XNV+nblfyVdkPkry+mFOP7ywhV7J6a7++U5G8bbprvLzB+9W8IQ6Wf\n    5yB/5/D97YOh1b9z8kRzk7+ngCkLXWOrfweQv8AxCOBTZ9NjcdNJ4FOVgvbhFEngEMasAh5CArf5\n    ATdhShK4bZsx/IBD6OsHDLRXEDN8UtD8eqgfsD4fTQLrSceYfsD6eGdqwhQigX3tMxEbIocFTdc/\n    NGlc7idmsqwPCayP34cE5lYA/6S+XglsvCTwztO29hnm9nwSYNoPWEtyiq+jT86ZK4q0lBmTvkJI\n    bw/BcgNxKvZl3WtZNvHqsuSxDWgDrldwhhLXv7mP3cfJDzihH279z7u49dcXaKZ/q8fZX9zC7X+8\n    m3x/E3rD7Aqs37qPzQdfH6qVuEKIq3wLuOQd+wOXHhIxU8Hss31f6qsONapNTRizdz3/1ZWvWjpZ\n    euGzw7l6yF3VRq0iN29e3/fR1q4+Rz7vs/074/fpl4yWayw+yDZxSl9jvv66SluTu65yhkv4Z7Bk\n    h/5M7b51v0v2xlz//o/Yvv9Z8gNO6I3FD85x+5+fR3aLRaD9j/y7y4owTr6/CT0gvr/bzx/Vkl6E\n    CBYvX1EOYt9fIYZZKcOXrJqrMdPn+6sloGVMcCuDee5k52vYb8tjq8zV2shfnz+vba9O/u6ATuQv\n    zw/1/LYP+Rvat4n8lW1lTq/3D/n+2iPW4wrcViipXO/jW+6qptWfh3x/Q+cagiZ/dWK/Lzm/j8ev\n    jl/1JX/n9v3tgxjJ6Kl8f4H+xTjHJn/5OFNKP0+Nucjfy47tJvK3GU+z9POMeLpTLqf+kkxJAseU\n    5z+tJLCvUz41OegYKegxMAUJDMTLPbeha3Zb082UrOvjByz7T+EH7CNd+/gB8+uhfsB6e99kINYP\n    +MwzCQr5AftIYU0ChxCSghaEqpD1et+60ORRZwsLmjKHm6p5RcqqiQTmY+jPaSgJLMdeePY/gyVe\n    +Xx9smHsLyVZ7AWEioUKLtRlz/TD7I9dUCAk28uicZZ8yHeLs/V1AFwHvuUIHKjJTYH1i2+jeHDT\n    DBkSTgLLDBc/fgGLHzZLOi9+sMRF8v1NGABTGmw+/RKrn9879JO279PVvqZG2HEFp+4jdV95hsJD\n    TnLw2EpOuxYAXNGqK04t6YtDO27QmmWfvXLMcKuiXH/ecf1+wz7AoXW2ktn3aGoH9P5814yJBl0F\n    xp+HVAK7Vdh1ct8SuC4RwcS+S2r4pablu2dgcPXyRyi++ArJDzihL87/222c/c0dmKzqPTQMMuBW\n    jtv/fDf5/ib0w973d/3bT2BnLq76gY/EZWlo7ht1pW+1f3HYT5JZl7SNTw666pPhtMPrz/bjnpti\n    4yZc6cpgTuTV5O8Z6qpSMnf0kb88l3TbayZ/tZqVbc8eV5O2LPsMdey4+Xdd1UvvHyJ/myp4fXLO\n    faSfdYxlE1gf6/vbVP3L28vrOXx/GXP7/obibD7f3z7Vv6Fl0t6Uvr9DpJ9PBVOQv3NV/55q5e8c\n    GEv++Wmv/D1GwWoX79+ByOc82FOJm04Cd8Flh22nIIGnwKlLQQPjy0GPKQXtez1ECjq0fRt87Q2R\n    gg5hqB+wvB7DDxjAKH7Asm2MH/AG9UmQbrtJCrrJD1i2bfIDbiKBdZsxJLDeR+CTuuJ2fZnPut02\n    36SuJHC1rUv+1uXBbCWwHNdHAkvgmTPR4ZxrKBjhBq01Ibz0BDw4OGOD3/UgtK7qdaujXLk2UDvi\n    Zbi92mD10u9hkh9wQg/kdxe4+MnzwHML+MRhcWeB2z+5m3x/EwahePgI65++BxQFyfVWgWmuQtIe\n    r7ryk8larnDi4PQOOKzzVfnK67otgH1Vob69LAfq1b8ZpFq2nSytk8MYzfc3xg/Yd/wQSVwlLZX7\n    alvUSG6+HvqayVr3mVstpj8XqTZz1TL4c6jOZwfrF83fE51coNdz9e+B9F9vcfXieygeD61vSXhm\n    kWe480/PYfnnFblbG0sz4PxvbuP8vyUbhYQe2Pv+rl98G1W/ZtWFjOrjDOrjqY/wXVAbsp+t0q3m\n    NpxgJcvsfImJXZaJBng+VcCm/8i6Qs3HQr6/dh5ZJ395PsjzX1nvI395fSz5q6uHuQ05jm+OrOfR\n    +nnbHD1E/mp08f0dQv5yWz7f3y1sbGQs398QVDJKqQAAgABJREFU+Xuqvr+hbWPt2HwxPE3+DpF+\n    DmFq6eeYCMWpSj/LMaYssDt18ndKTF39OyX5OwdS9W+FgfLPwJQVwFPqY98E3BQSeKoq4DEwlx/w\n    FCgwXyVwE+aQgvah7w1UqAq4rxR06AayqxT0WJ4nvC7kB+zbr68f8BgksPYDFhJYSw6xnPQQEpiX\n    +0hgXzvShm5TIJM1nV3cNJFceI67oL8LtYzbbCOBdTb3ovH4uurXBg9ClcBu0LlOAsuxJZCg5aB9\n    MtEcoODlOtDBQRIJsuSoMuhz2MoyJnpZAhUUmC6J3GApN654k7ZyFNh8donV794DtskPOKE7zv/8\n    Fi7+/jbypStWmS+AW//zNs7+MgWsE/qjvF5jtff9ZfKNA9Ei+6ylKrVnuq7slBFG+kTpwzPVT0vF\n    qK0qrcv8M12jk358lbDcVqa288kkO2TvHocqp7mK6/O6RQIazpUfS7puPqJYXyNDnwVfVzfRya0E\n    ZjUM/hy5Ehjqs9PfE5fQsElTnEzFRIiMw+UXj7H61UcoN2kcTeiHbO8HvPzOoib+fPbn57jzT88B\n    efJRSOgO8f3drbYArKyztokpa88tSbxwxl6rSOS2YxWSdFLrsjb21udTmvx151UAPPsMJX/l74L2\n    DZG/mthlOenQNgA85G7z3Jjn1765rm/OzrLPPHdumudrgtWo50vP+QwlfwEEyd/qtf/c+Hix5K8g\n    RP42FQQ0QZO//Fcv7xIDG1v6uS/5qyExQl9c8aphXRNiq3XbyN9Tl35uI3+HVv/O4fs7FKda/TsX\n    +RvC01T924Sp+M05C3J/CJNPetDQRZqzrHqObIGpv/SnVgkci5viBzxFFTBQDZRjksBNx2nCECno\n    qfyAp5KC7kICN2FuKeimbUPwVQH7SGAA0SQwEO8H7COBuY0mEphfh0jdEAkcqgoGEJyUyn6aBO7i\n    B7xUnz9Pypv8gNsm03rCn9M5axLYEr/NJLBL0trjcsDbHssGICRgYffhwIRIdlqZaVnOAQ+pSirh\n    BqGrwHg9IONKt1kS2Hpf2iom3taSy4Xjf3j9q/tY3/8MMMnHMKE7bv9/nsPZX10chCszAGd/eYHb\n    //DcsU8t4QZDfH+3H3zl+PrqqqVS9YU2uF298iXB5PuqVF0daquf6mSiJSrdPj2jvp2rhjUxylW8\n    TGpyYJwJYq4AEhTgMany553zn/gBu+dR++Sc9yLvx0qBiv9uBX6/fM3k8/Vd5/wwxuFApLuVau5n\n    riuB5fMva9u5ahm8vSQZcDIWfwe3b/wBuw8/A8o0jib0w/IHZ7j4v59DfssSvcvvLHD7355Hlnx/\n    E3qg3Gywef1dbD5/tE+gKg/zAEmq0gmiPFfQ4yn3ewX1qxlKbFGv/OXxmZNemQjOYec8WhWp8vVF\n    bftY8tfQdkCd/DWw5K+ogPjIX1ab0uSvTlpuIn/19npfnlfH+v6GyF9fsrWgK/nbVCkM1S5Dk786\n    Cd8lf423DT6/EPnrW9bm++ur/gWaq3/HJH/H8v01nvU+8jcWXaSf29YB9dhmmyqiIDbe2kf6eS7y\n    twlDfX/nIH/nln6+7LDtkIK8Y3NAc5C/35/hGDcBI1T/Ak+7B/Czhjk6gMuO298UP+CppKDHJIGP\n    IQUds163F4um7L2uN2y+bdtIYNPSXhMJ3EUKug8JbAI38T4paJ/8EBpeN+Fs316MH7CPBNZ+wKFJ\n    lW85E7E+Ejg0udNthSaVst9yP9n2TUqnIoHb5LQARJHAsr8r61UngQFLAmtJr0I959cc1OBzZc/I\n    LUCkr2xrSQSubrJ+iq5PYU4BGJZ91pVw/JwloplE1lJumSlw/dO3UXz1NRISOmOZ4+Jfnkf2Z2cw\n    yJD94AwX/3IX2TLdLyf0g/j+Xv/83iG4bAPOWgLaBqh9fq2u/7mu3q17B4cqSX0qDrlnmZY15qpW\n    A5esZG9DrpgtDi0qAtY55lE/odr74n9cF6b9gPm68vtiSWw5BjzXK/RZaNJej3X8PYFnORMW+rvk\n    W+arJL5+8UMUf/wayQ84oS/O//ttnP/NbZis8v299c93sfxBslFI6A6z9/29+s0nNcsDHHo7N/nJ\n    +puX+4IQVyGB+1RtM8MSz9KuJLeyJY6b4FRPlnWTaatt2IqHyV/ATUbykb8CPe/T5K/sB9Tnhr75\n    Zpti1Rzk747WaTnoJt/fpvhAE/nb5B/sgyZ/mezV5O8Z/InuOqHehzbf3xjyt036WceTbiEcp2pD\n    rO9vl3bsebnkr6Cv9HOT728bpiJ/29BUyDMn+TtVUV05crtTkL9dcTnTcWK4nzGrf48l//zlkY7L\n    eEqqfwEmgJ9mL+BjVQGP+SOZsnS/a9bJ5WRnEo9Tk4Nu8wM+NgncJh3SlwQeww+4aV1fKWhBGwnc\n    xw/Y548ylh8wMA4JrNvqIgUN1CtrfX7Ast9WtTPUD9i3bVtbetsmEthX/duFBNbnMwYJ7JvU597v\n    enNmto8ErldiuW2xv2++n3RvauftblOdnyWBQ7LQ1bZ1oqKkv+YQaHGJXQ7s5E6gx62Ck2WS3Z+h\n    BJ5c4+rlt1BeJR/DhO5YPF/5/S5/sKx8f7+zPPYpJdxglA+/wfqn7wLFLui/ykkyTBLrPrPuj27J\n    Qau84MpTlqoPdsm+6lV2aMeqP2iSU4jJBZorgrlmNDyWuftKNe7cjzxvrlIG4ATn9Xv0VfwuYGrX\n    TftDSk0uX//MSxjUSXypBF/sPzH2iJZ9Fodx0a0Cr/th1sdWOcPdaourl95DmfyAE/oiz3DxT89h\n    +Z/PcfE3Fzj/H8lGIaEHjMFu7/tbT4xyFYUkWVSPmdoHuJ5Yqucatu/NnXbcpFeel0mSrDtvcgnZ\n    zWE9DtvY8cU4z+3ezeQvk8ex5C8jRP5yG13IXwC9yN8FzIH8jZmfA82xgKa4QR/pZ4GOufjIX6j2\n    +RhN0s0xvr96+6Hk7zkMfDEnbi8WvmPHVP+uWtazdPPY5G9oH8aU5G9T9W9b/DaEOcnfIdW/Y5O/\n    U6FLQdvlsU92RjyN1b9zKhV34V+HVv/+0B7LrWiYggR+lryA5/gRnAouO2w7RRXwFJhqEPpW/R2K\n    Mf2Ab8MM9q4YSgK3SUUP8QMGmqWk+/gBA2FP3hCatjWBm/fQfkP8gAVj+AG70kXhtvuQwKEJmc7s\n    3XqeQ7UvbWoStynDmLfT+4eI3CEkMOAGmTUJ7E7W3Ym2QTMJzMStyJHpAAMTuDKZFxKYs9TlnGT7\n    5V5+mQMqkv3OJIbNyrfHyFFSNj0HZAqH2LVEcZgYsW1UrsFAie39r7H63fvALvkYJnTH+Y9u4fa/\n    3sX5X94a3ljCMwtzvcLq1cr3l/uu3CHg6tW63N+xLKXIS1oZS/EurELYLLfPRK+PTGTy0ZLKlsxk\n    UlNLE7sVwxWY+OUqq9DjQKS2FNez/HLfR8sBaoS272HfU/396grqxZ50ZU9gwEpyut7L7uegSXsm\n    HkpIolZ5aJM/Xy0j7rZhCWPt/cvfMSZGtn98hNVvkx9wQn9kFwvc/re7uPinZKOQ0A/lkydYv/gm\n    itUGJVyLGD0vgOrD4IyRdp5hUB6qfN2kVDcRp0BdrUESYGVskTkNW+tYNSU7j5N5lZ5T4bAtDs9d\n    D3kLH/nL88F6WxVy+O2CgPHJ39C+4Xm1JX95uxjyt0+8YIjvbz3hXquwIdhmF/KXEfL99ZG2bbEp\n    H/nbJB3dVfq5D/kbWi/LupK/Gm3k7xW6qQyO5fnL2/Qhf0Nx5bHJ36b49VDf37Fx7Orfyx779JV/\n    fhixzdNQ/XsKmILPnJP8VajPuucigedk14HjaYfPXQUc0xn40KfzuRzxvfXBXANHLNqkoIHpSeAp\n    /YBjtwG6kcBtN3Q+EjgGPhJ4LD9goJ4x2VcKWpbFZnD64PMn9pHAW8T7AZ+hLuGsSWAXbpUx7zMW\n    CazbCvkHSxu6TZ9Elc9jyFeRPAUJzNcOmIYE5grf6r25JDBXMrkBB5upznKdQtZKu5oEluz3fD/J\n    Fik0XdUkHoQLqtzV0pT1yrfSCeDo/bVM6urXH2PzyR9gymcnOSthPJz9l0T+JgzAbof1W/ex/ugr\n    Il6t5L281tVKXAlqZXzdZb6KJvY9lIC0W73rksosE6yrTFk1wpXMxIHElHGE5Y/tObNMcoXc066u\n    /O1M3kbC3y4dlyqBfcdmIle/1wxusH8H1/vXqHaZaLYO0PYvf06+z0+T+b7qcCZ9S7ifsb+S3H73\n    3GQrg/Xrf8D2o89hkh9wQk+c/clZ8v1N6AWz3WD9+nvYfP4IgKv8s1P9mXgA6zFS+sgFCmQH5Q2e\n    h5QOqcsKRZzIquczkpiTO+tdxSStrOQmwrrzQr0fzw2B7uSvngf6yN+mOekU5O+S1ts9bLzBV0Xs\n    k2Vu8vHl9nwxBn7ehfwF4FTn6mvX5PvbRv7qZVL920b+dvH9PVXy10dk+8jfWOhth5K/baSzj7wd\n    Sv4eG2PFq0O4CzOL7+8YGFrINgXmJn99mKv6d07557n5ybnwQ/d9HdfT7Gm8yL4fw00hgW8iboof\n    8Kkj1g84tM3Qm5cYErjpdVvbQHMlsGlpL3TzOjYJ7Nu+ixS0fi9nLZOTtgmI9gMWaA+bjWd77Qfc\n    RALz67YJmm4rlOUL+ElgvZ9ur2nC6WYfN5PAAGoksN7XN2nWcpNTkMA6+7ykY+mghfa6coPXOHgC\n    MwlsK3o50FEeli/2VWocvGbygivgODDNwRyWaZPs/irj3z5HUeD6Z2+hfPgsjYoJCQnHhikNNve+\n    wNXP70FLVWbUtwn5awPXlYpBjmIfrHa91FmkV/pVkQ9e0Hbaz5YrVC0NDXC1KuBWwgpFyESy1IqK\n    bKVb4QovuaorfsUX2HvdZvzng/b7DVUDa8lrGWMlIF/QtrbKzLYn1yuDOXxuAA4jIH9e7HBpq7vL\n    WgKA3cZWxvFr65tZHsZK8aJmT02uTM9QwpgC6xffx/bLy2P/rBISEp4hmLLE7uNPsPrNfUf5QuYB\n    VQKojKu2ypdtYXbOfKI+75Ak0sLpR+3YJ8msen4jc5zlflTMaX1bMi2Tv3r+taT5kZ7/TUn++tro\n    S/7qfQU+kjdE/jYlZDdV+7aRvzv45/fSrvP9g0v+cgzFF/9o8v1t8vwFwr6/vvUh8rdJ+jlWta6P\n    76+P/I1FU9xMx+36Sj+HMJXvbxfP31D89NjVv3yc0Lnc1Jj3VLjssU/f6t+5obmsOcjfU8FTVv0L\n    hAjgp1UKeq4q4Jv6o5iyCvimyEBPhZtQBTyUxB0qBd22zVA/YGkjRObG+Pj6ttFkbF8/4NCyoSQw\n    twPUSeC2SUnID7iaoIRJYF1hvIQJTrqayNYQCRwj9cTtCBae/ZgEbpOcWqhj6eMICay9mfS+TZPn\n    GKkuOHvVSWDZz0cC+7LLS9SJYnkfTALrdqrjWCLCVhi7mfKSOc/VTNqPy0qr2ec+0tdW0OnKJbuN\n    kCrlo2usX3kT5jr5GCYkJMyD8utLXL/4LjLl+8syk74+i+WguQIpP5DBdUUELem7aKgMXqjqJT0G\n    SF/tq1yVsaWpkpYJURkfsn2gXB4yjizzcOXwHI9aJW9u37s+Z37fPnLYV7XMcqB8NCZ2Ldzt2EbB\n    le22RL8lMLQ6hltdrj0wJQVAS0Xz2MpVahlK7K7XWL/0LsonaRxNSEiYB9sHX+HqZ+8ApqhV+brJ\n    L5wmU1cPqvpxmxyqx2NpR/pWPX/hxNT80F9az996co9L/orss882wTenCpG/gq7kL+/XRP765sey\n    Hy/Xlkqh4wu07y+3FSJ/Q9LRbVLPbeQvGtpi6DiDT545lvzVxxji+zsW+Ruq/uX2YhDabojv7y24\n    yn9T+P5eBfbxbTMFmkjiU/H9nVL6+aZU/06JJP18WvAVpj4N5O8P68cLVwA/rVLQx8JNqQK+KZko\n    jJtUBXzKfsCCIVLQbSRyTJXvVcP6oX7AQJgE7usHDHTzBG7aLnRDvkY3P2BZBzT7AfuIWiDOD9iu\n    r5PA3I7OWg1JLcVO1kJtNVVx68mnj4iNJYG1n7BPzkom+75JMJO6w0ng+vs3nv3GJIFZQtoSutW6\n    Mw8J7MpMVn+3tWC3Dd5IxVKmni/2Ym0SpOHgtX1uaRPAEirrj7/C6o0PYApfTnpCQkLCeDBX17h+\n    5T2U366cYHNORJwQdIZeu9K/vEyTdCzn6wa0Nem7QFHz75WA+ILIxFBijuzL8pY8fjDZ6yM7faQu\n    gIPv7imB/YhDZHHmuQayve/66H1815hJ+wyuEkbmrCudz52/S7KdK1vqfqey/XdOS4Hz902Twfzd\n    2/3hEuvffghskx9wQkLCtCgeP8HqxTdRXK0PcwO+5+d+iucMCxpfpd+UKl+2X9DJLwtn3LNEr8xR\n    bOIUDuRvSFWJXy9gx0+tvMRkbO7ZBnDJX3leJ38tfOSvthQKkb+FakO3q+e1ukpXluk5s2/+3TR/\n    bkrCZugYAl8PPUr18f0V+AhaTf5Ctc/HiPX9DZG/sixE2IbiQE3xoTGkn9eBtsbw/RV0UfxjDCV/\n    fRir+neo9PPU8syMvmR0CHOTv3MVkF123P6mkL8+zFXoOKd961x85JErfwXNEtBTkMA+zHHR59QP\n    B6b/cZwSCXwZud2UVcA3gQSWQXSOgbvvMYZKQYfai0UfErhr24Kx/YCZjB3bDzi0rQ98A99EAjP6\n    ksA+P2BpK+Q13IcEjvH54bb0uep29CSUJ7FcyduVBNZEriujXN83RAJzpVVXErigvzEkMAc1cvrL\n    AX/dlgROmASu5C9twGSpAsoSVJHjlrCBFfHh4iC3KwltAzp6O182fwHXzzBDidVrH2L3yefJDzgh\n    IWE67HZYv3kPm3tf1wLM2mvVJQNdKV+3ItMoYrA8kIKl03dyf+6vVOVANMvwV4k+xSEwzYSnQFQc\n    NNmrpZ157NAkKZOsvCz2oceUpkf3tg9vtLZMexcXgXOy77mkYLvrkyyBf5H4LtXnIVXevvfjkrSm\n    9h2QamBN8PpI56qNorYNV9G5ihsGq998hs29PwLm1Oj7hISEpwVmu8H16++i+MOlkzBVzQHchJgF\n    6uRvRlXCYrPAz1lliCWdt6rf5Arg/DAiVMmuMu+x7VTP7dwnTP4C3cjfBc0l/eSvOy8cSv76pJ91\n    9TIraO0C+8bMuxeIm3cDLmnbZA2lYwZdyF/dVhP5W62Ht01pqwv5KwiRv11txJqU4kL7d/H9baoi\n    7uP7K9C+v32qf9vI3Sl8f2PQRv4eW/qZC5XGln6+iVW6MdzF5bFPkjA2+Xvs6t85+LsQD3kK6sVD\n    8UP/e5vfAzh0MZ9GEnhqTJnhMRUJfNMw9mDFg+mpS0F38bDw7R9C201V15u2vlLQgP8GNVbCWUPf\n    CJ+CH3CIBObXXfyAfVJJISlpTQIzhpDAPvmnkORTFxJYEJuJHNq/Dwms9+Xtu5LAsr1vPw4O8Pkx\n    Cawz2uW8bFUwZ67XSWBNNFiyWI5VHrLpS7hEM1eOASzz7AZlqrYq2ngHS5SIn5ccR4LkJQxQFFi/\n    9CaKy0skJCQkjA1TGmzv/xHXr92H9GWWnnPJWa7E1FLPC7gyvDm9Zr/1EgiQeiX1v67voYTRJUjt\n    npetdtUksUtC2u180s6a8GXiUreXn9BDn5ePTAYsGazfP2/jI4Z5vLX0qf4MbM2tEMNcRRyShc6I\n    gJAxj0kP/T1zvzd+oljOiSuQjSlx9bP3sHtweeyfW0JCwlMI8f3d7H1/ORlF3+/nlEQjz3nUlaRR\n    6VW1XUIB9mg3sHMVlxjmPlzmIEz+Gmed9fNlGwA/CRsmiH2yzzKv60v+ts03u5K/ADqTv7KtVvrS\n    822NLuQvxwH6kL+83ledK9BxFH2+bRZbmvwNtd9E/naVfr7l2X5M39++dmrVudXb60P+NpHLfe3o\n    OLYZinPGxk37kr8h3ATyV3CTqn+nIn+nrP6dGnNV/x4bT4P0cwPaCeA5/YDnIIHnLCfXP5JjZFHM\n    2VlcRmxz06qAhyA0SE7hB9wXQ/2AY6Sgb/e8oWvaRt/c9ZGCFugbzjGloE/BD9g3OejrB8ykLhDv\n    B+xru4kE5te+6t82Epi3903MfJNSzmaO9SJyJ7X+ybFMvptI4LaMbB+Zy+en2+AgQV8SuDycS5XB\n    7Ksc5gph7ZXFQQM3oAwnGO0GsKuAzYICMm7Apu7vJdJuuQoKSRXAgny/tg+vsfrFWyiv++oIJCQk\n    JPhRfH2JJz97D6YoiEyzhCwHsnV1JlfiaiJO+sCc9nEJQEsGV+tAyTdcacxksPTD9epWeb2EW0Vc\n    HYNJ5TrJyz7vTK4eSMy8vlz/E2lq30N78zY9mtrxHdchhPM6qc2kcH74bOz7z+h9ymfC2yzV++Zr\n    pIl32w5Xv9ltMzo+y3uXdH6a+HU9Ma28s++7xt8d9xoVKJ+ssXr5XZir5AeckJAwLrYPvsL1z95G\n    ZopDf+ZXz6ju7VnauaDX0s/XLRdcoreehFU6fX22f81tieIRKz1I34xD+3aMjSF/gWbZZ07utehG\n    /jYpTjWRvz7iWB8/bp7szteNZ3+fBZSe88eSv3r7UJzB1xbgxkh88Y2hvr98DiHf377krw/nnveo\n    24tB6LhjSD9z9W9f398Q+vr+xsREY5UTh5C/U8aMue0pyN+5q3/nIH/74CZLP8+J78Mcrfr3aSF/\n    fxg+ZlwF8Jwk8NT4EvOSwFPjlKSggeOTwFNgCj/gsUngvlXAci4+3IaZVAp6iB8wgF5S0EwCN+3f\n    VwoamN4POLRfm9TPOcxgP2CgTqrGksC+tnn/tmVtWby+SaXvfJsmmZoEZomq0D6xRO7YJDAHAXxt\n    SBZ6qBJYByRCctA6UM0Z7Vy1xISvDqprEljIiZyCzvwaajln/gsJnKMuo2qXudV1+cH/q8D2/S+w\n    fvvD5AeckJAwGsqra6xeeRfltyuqROJqXFup5Erbu30YJ764+7vrMpRY7ttk8k8C0NzfioyzJnp1\n    havfH972+1YOul4VZZ9bFHDHoWVeJ2n9lbjTw3dcfW7L3L53W9XltuG7DlLdm6nxUpPiIiPN19N4\n    rgXLR7vEr9+/meltli+VcbdU29tqdZtUpSvPAddfePvJJVavf5T8gBMSEkZD+eQJrsn3F5CETivZ\n    LCOhrex17/s58UrbySz2bTH5a+cs1t6Ak1OrZKhyP4eqJ+/IuOmr5HUloKvt4NkeiCN/h1T++sjf\n    EIGryd8u++o5dhv569unifwNJWuH1MM0YmMOIs/MI9zYvr9N5O8ZTGNlbpvvry8eNKbvb2h9H+nn\n    m+77G4MnA/YF5isYKia4B5c4+lzVv3ORv5cd2+1L/sZgCvJXFy7OVf37LJO/M2F+CWiG7yLPJQU9\n    Fwk8x49lyoyPqTqrZ4kEDqGv1EcIQ0jgEGJJ4NC+Ta/bEOMH3PQ6pm2B74bVtLR3LD/g0M137DGG\n    ksAhP2C7vk4Ch9rmiZxsw222TeZ8WcFdSGDBInhOlgRukqZy25uWBNbt1d+DGwzoQgLb44aW2Qok\n    XbXEQRFfQJsrpwrah6XZKorWJX652kpXL1VBbVsF4JIe1i9MKouFXF69+n7yA05ISBgHux3Wb36M\n    zb2HVO1rnOfch+lqTXPoq+oEHZO+muwT8pA9WjX5Kz04PxaHbXEgPnX/res/c7VOINv5CFTeJw9M\n    N3PUyVjM8KgTwIHzy+Fs73uPNQ9hdQwe6XyEbwaXIPDJehvUCV9LbLiVbVreWX+f5DvD366MvoP8\n    3c32Y6j9ztlxePWrT7G9l8bRhISE4TDbDVa/fQfFHy5h1QkqwparfN1kTxnTbL0tKwNxUozrt273\n    FzJYJ8Ly/ENa53HSzs3c5TpJNpb85XkZ0I38ZZwS+cvz2BD5q99DLPnbpvYVK/3sOycfQesjf31t\n    diV/BSHydyzf3zHJ364xKEEb+cuFGWP6/saSv/qYsXHMvnFSQV/fX2Ac+eeYgqSb4vv7NJK/Dwe+\n    p5uGY/r+HhsTSz8L4gngOdnr5Ac8PoZ0HlP5AU9BAk8pA9237aZBUzKtTtUPGBiWsdZ28xQrIBfa\n    rq8UtIBvNqfwA56SBO4jBS2vfSSwoAsJzNvwBOxM7ddEMPchgUPS0XrbptqUJn8iPdFd7B8hP2BA\n    T2KnI4FZ1jmGBN6hWQ46hgQuwdfEBrOZBGbJaJZH01W/LjHsSrQtSWpNVzTxvlIFYKVRi0NAmwPZ\n    Wmb1EAAXP+BvLpGQkJDQF+L7u3rtfo1Ek55SgtEsZemr/LXBbbeCk31/bWIMDscBLDm5qPW5mmws\n    sYMlIkWqOKf+F3C9bLmvrxOTlgzVkAD3Uu1Tf5wCwue3pGus4Upiuw++bq43sHu9WcbZykmXzvXW\n    HsAih60VNnQSQAa3ak5/j8rDceuJCpKQJfYK7j4ljCnw5Gfvo3h4eewPLyEh4QZDfH+3v7lPfVlZ\n    SzrhcdJW6LLYMo/BJXyJV9Lb8XxCxsttre8v9/NIN3mISV89H2K/9xD5y8uayF+Zt+0880uec+o2\n    5iB/geYKW/b2teNonfxtmlczeH6vCV8dNxib/GWEyF9pr4n8lWVbpz3dfjv528X39xzGG2/t6vvb\n    RP7GVP/64mA+8rev9HOoaKNvnHGsyl9gmPTzXORv07kM9f0F5qn+fRrJ3xg8bdLPUyPEMx67+ncm\n    8hfoWgH8tPkBTyFz0IapfIBP7cd/GbndTSOB+2JOEjiEISRwW3Zb0/ohJDDf4IW2u27YJ4SQFPTY\n    fsAAokngJoxNAgP+SYcgRtTvbD+R1e2EJ03hSdFQErgpQ3jraUfQRAJrQreNBN4hTALzRHgMEhie\n    9urnbbDYP/ORx7wccOVBAdSeMwmsK341CWyDDy4JLFvlFPjO90FmWS+Z/IUKVIv0M0tVynPsSRZX\n    YrV6Lst19fDu4RVWv3wb5WrILzMhIeFZRvH1Ja5+9i5QFODqSSZ6ZZmVorevdeKK2+exd6/1bPWR\n    fhzQlleuH6FbrcoVo5qIFTloLXWpydqDtLOnYtWpFG6ZapYn8GhEbs/TTxCXNZ9E7LfVstsF/NXC\n    QtYa1Kuv+fORlvyfe1l7XcL1EubvliaM63LP5UG6nLfh1+WTFdavvIPySR9TloSEhITK9/fJz95G\n    aVwp57LW7zARbO/5Xe9y6ddYJtolepfUh3EyKveHMjfJYZWLdMUvz3s4CRa0bAj5C/rL+4XIX8bU\n    5K+vclfPpxcwwX3ayF8mWOV5KEYATzt9yF+gnuzOy848x5flvngIPNv5yF9fBe5Y5G+bLVmMZVlT\n    kUJf398h5K9G6O6D2+qiEtiF7I2Jj/Ylj+ckf0OcyCn6/t4k8ncoHrasn4r/OYb88xzSz3OSv8fE\n    D5s/r3xOtjmIY5LAc2Qa6B/NVCRwG9o6kSZM5QcM3AwSeIx2YwbRsfyAx64EjpGC7iKB0uVmqI0E\n    voAZ1Q+46SbVhy4kcBOabrBl+VgksK8doE7SNk2MeJnsF+sHvEWdIG4igfm1j/htk4nqQwJrQpcn\n    tLEksM8DqY0Etu3VJ80xXk/u8SoS2MAESWDAlZjWHlaaEOZsdy0bateV4ODFksLZIvjMEmzL/Wsm\n    fXO45IYlVgrnuet5aJcJYeyTrpTg0ObdP2LzzkdA8gNOSEjoiPLqGutX30H57TURZWWNKCspSJ07\n    vZUvaM3EXV3aOVNBbVvFa/tKqfwV1QWj+miuHOW+nP/pKiau9M1om5BnL5O/fchXn0fvWI/Q+Tae\n    o0MCh8+3+TqZ4LUWooDX87jpVvS6xG/mPLdy0FpO2/fdWVBigkuuuH7CWlVDvtEZSmw+/hqbNz+C\n    2aVxNCEhoRvE99dcrQ89Toa66gB7/trqYH3/zyob7hjK8wubkFP1s8bpP10VDZ7PcN+rSV9OfuV5\n    EvZL9HMei0Lkr9j4LPb7yTYCn71PH+nmEPnL2/Ac2yf97CN/eRt+PYT85ffjSxAH4uMIOsbBBK8v\n    fnHmaUMqhptU03g7fSyf9HNX8neNeM9fbjdG+nkM8ldf5xD5G4sLtX/bvl2kn33xyb7Sz23kb1Ph\n    zdTkL2NK319g3OrfuSWlh2Lq6t85kMjffjhB719Bdw/gqd7MsUjgufyA5yCBp64CPuVObGoS+BHG\n    l69gzFmNPoRk7ksCt91QtWX8xZDATa9j2tYkMN+gmpb22vyAgeomeogUtG5P79PUXqitNj/gree9\n    hyY1mgSu1vn9gOW1njAtPW2EXrdl+XbxCuJ2QiQwk7mxJDBPin2eR0ICa7J3p7bzeQwfkwS2AWt4\n    iQLOti8BR0JN9i3gZt1LENtWAnPFW0je0lb+MqEsgeoctgrPBpGqgHd1/AJXr7yH3Wd/BMzpjm8J\n    CQknht0Omzc+wubjryHB5UwFrM2+j9HkLVf7Sn/FygW6zzPQBLFL7Gl/Q91PSh+9ha3YXTrHr8Ae\n    tdI3Lw/Hs5DANlcUN5GmghAh6/snge8pHr7jRZHFLWQ2XxMGX8f8MEa515OriaWiWMbNkMxzqf76\n    vhOshsFt7GAOyVRuEkJZ+y7x91rGTX0+V7+6j9395AeckJAQD7PdYEO+v9m+f9G+42KlwFW9Lslb\n    7JWFXOJYSz1r398cpTPmiToRJ7e66kZuMqvM4bTSg4/wLeg5SzQzKasrfw3MIPLXN3fUxCzoPehK\n    Yp7/+shbOUaI/OW5d4j81dBz+S7k7w7h+IHeVm/n8+b1+f7qfbuQv7G+v10RKgTwoavvr+zT99x0\n    3Cvk+QtM4/vbhqnI3zYcm/yVYzTFn09N+jkU1z/V6t+hvMnDge+rL+YuVJyD/A3hVCp/Zy7IzY9x\n    0CCO9SEciwS+iThVP+AQppCDnqoKeC4/4LZjNFUBx2AqEpjh29ZE3hQ2tdNUSTzUDxgYhwT2Ifbm\n    v6sfMNCfBGY/YCaBm/yAQ9m6uk1BFxI4NHH0taNJXL7SwDgksEuq+qWx2rK4u5DA0sYYJLAJrq8v\n    M+qvSKvZjPmCtrHBGc7q50CQraKzZG8J60uoCReuaGJhzQMZs9ti9eKbKB4NnUIkJCQ8CzClwe7+\n    57j+1T1o+VxbvVuXzpX+yRKzhdNfuT7BlhjW/R/Ucq5B0sSgBLd1JaoQkD7/WhkbXFljTTDWq2F1\n    FWwsqcv7HuMBxJHFOZqrn5lA54QnaV+up+96cxtMErjewO7nyxLROvkpQ7m/T3NJYZscZb+tOoHA\n    jp11+4QcnMRgDlcpKwpc/+xdFF+ncTQhIaEd4vt7/Zv7h3EwP4jkWyKYkzmlH1o49/kFeZZrWwQZ\n    g4takqn045yM6so4y1wkTP76iF7fMiaFZRxoIn/7Vv7q7RaeZQxORtbb8fy5K/kL+OfiPvKX2/PN\n    4buQv2hoC571Ap/vr4/89Z1fH/L3DCZI/vaRftZoI3/bMKbvL68Pkb9T+v42xQKnJH/7+v7OWfk7\n    dnsCiZM/y+TvTcXc0s9zkb9zqAozTrj6F+hTAXwMzPGhHYMEPkYV8DGySS4jt5tCChqYRi5iKhJ4\n    bB/gKUjg2Buf0P5Ny2L9gEPoSwJfBG5K9Y3rED9gvoGOJZNDJO6YfsDnngmMz9c3ZpLDfzUJzPs1\n    kcBNUtB9Jn1DSGDdhrwC/BJXTSRwU1s+/8CxSWBuI0QCi/ejtBvyBHblzlzC1yUY3ECL/JUKJ7tO\n    KovcAI4EXCRAs9g/hAR2A+G2sik/hFJswGgHW2GnKwS2Xz/B6hdvw6yTH3BCQkIzyq8f4snP3kVW\n    FIc+RTx9pYpSy0lq+XmmF21Qu/QSca6Xq6uAoBUUCuoPWd6Z+2NOhfEpOtgHE5r796628RG8+4Y8\n    7YUfx/T/jT3Hgt5XiCDWVcBy/cr9rr73zNdRk8iWfOCUJ3es5e+RJp+lVU48KCHJB3VPX6GEWXKV\n    qWLtxclVw8W3K6x+8S7K6zSOJiQkNGP74CusfvYWYApKKrEJm9r/1/Eepz5JJ0NxopSdB1TLClom\n    /d+SklB1n1onhG2frSt7Aaj5lyWCeZyxCJO/htqQbQRN5C+P1Ua1L3NSLf3ctC+AXuRvW1tdyd82\n    Fa8hvr8+8pcRIn8rYrg5LiLLfL6//HoI+dtF+pnba8NQ8rdpfR/y1/fefejr+xuLITHQNsxF/spx\n    mgjaodW/U6pmCk453XAO1dSxlV+P4ft7rMpf4Omt/v1h++fWjwCektU+5odxjC/hsfyAn1bMMRhM\n    KQctxOuYRHBfEjiEoSTwELRJQQPhm8Im+EhgXzXwUD9gHyHrQ9s2U5DA+tgxExuNjWff8KTKJYEZ\n    fUhg32QPajsfCczQZLIvG1peyXqd7Rz2BG5uSwIKU1YCt5HAVp4ZdE7uMTlY4COB5S8HxUXmWpO+\n    brDaSl+6xIb1B3Y9CNnf0pV7K/ehHglOl/uKAQ766ED29p0/YPPuxzCFpuITEhISKpRX11i9+g6K\n    b1c1j14mc40TsC7AigZWktcNdrtkcFELgkvf5avYdKt8y5okvzy24ACz25fbilIcljNhLI9Q9e6h\n    L8/jiF1NVh6vAtgE36uXKM7r5w11XbhC2n2v9Suux8YC1jZBezu7npR2nf7+adJEHvy9cttw1TPs\n    MUqU1Ib2rGbSGCix/fABNm9/DBTJDzghIcGP8skTrF58A5urzaHXzWhc1AlTrOSz8/SLkhRa9XEl\n    kcl2vmBJXFfmmfvgZWCdVUhyq3x5mR5TeQzW44SMDSHZZ1nHf4FxyV9dqaz35eVNyc6yvm2uq6uQ\n    dRtN5C/P6XU8YAj5C8BL/upYho4paD/fEIw6d5/vb1/yd0rfX72Pb31f319N/saiq6rfFL6/XWKf\n    fap/58RU0s93YUaPkfuKrsaI959y9e/DlvVPA/k7l/2lr5D0VMjfsRFB/gJMAJ+KDDTg/1DmKt2e\n    48uof1Rjk8BTVwH3yWq5jNxuDCnoqf2ABeWANmOqgMeuBm47nkbbTUpfEnhMP+AQuL0hGYDXqN/k\n    thHMsSTwVH7A65b2eH9Gkx8wEF8FzBMnnpD5/IB5cmUC11n8f7qSwHoCyNsb1CeHAl9Wsz4neYX9\n    ek1YdyWBOZDu82CaiwTmajA+J12FFCKB+djl4ZzcIEpFQFiZUF0FbAMwNsjNhDETIlVgSLL3LWnC\n    QW2fv6EONMnz1SvvYPd58gNOSEjwYLfD9s0Psfn44cEPlb17cxWoNtSPSR8DClLbwLOV1mV1A+67\n    dJA7o/7TEniSDGMrhSXwzcfTDyaOefnu0LIQv2bv0ViXk2bfXyY826SXBbFEcd9HuG0XMUQxv89Q\n    FXEGKx8qj516L9pvkq+ZfC6L2rgnn4H9fuX0Hck8750r5+QcOJGAPaZ9JDAnNGSH729xGF/t+Vfr\n    r1/9CNv7XyQ/4ISEhBrY91eUCTJY3QG+J8+dfqbck7c2SYoTOnluIP2SkLqijiHy90vqN7k/LuCO\n    i5IY65K4zeQvE78uaQzoCmJN/vIcjv9Ku0PIXzhtDyd/mVCNIX9DlkmAOw9n8lev03P8oeQvE7S+\n    +MSZpw1teSXwxUPayF/dhkZTPKeP9HMM+StxpL6ev9IOw0f+CsaUfo7FVORv0/7AaUg/f9tyrET+\n    Hh9DeZquOEYx4lzk77OESPIXuCkS0HPjwRGOOfePb+7OpQuedRL4DszoJHDfm4ehfsDANCRw23ZX\n    6E4CX0VuB/T3AwbGJ4E1QpJAMcdo8wOOnfT4SODqdT8SGPDLPumJGT/fIiwbxSRwSE5qKAms22ua\n    IMtEHZiXBObtzWEy7ZcEjSGBueLXONuZw0RblkugZUmBEAnSCAnMlU4scWmr6YTcKPbejHXfQpf4\n    NQAKqlqSgNC+Qm+zxdWLb6J4NId4UUJCwk2BKQ229z/H6rV7NcKXq3fF/1cnnAhhVpdwtr0Ze7P6\n    KkO1lHNO7ehqUEsmm738ZbXfEiXOIXLTbptcsSoJOnXf27rMcK6e85gTS+TGEsV9EVP920Yc+9pC\n    oB0hd4U0z+g6+uSh5XovUClhLA9jnevTXNL2TPDyZ2Or42QMhPN9sGSxWzFnv5f8fXS/Yzx2cgU7\n    K3OgKLB66W0Ul6cs0JeQkDA3xPd39Zt7h57Ml1iSkVKBjKmsdMHjLlcQu+RvWdtHxsDtYd5hDssk\n    MVX+Luh13e4GCJG/ckRODgLq5K8kWMk6wdTkb6HOSe/Lbc5F/nJ7PIcPxQBC5K+v3RjyV+Dz/eVj\n    dCF/fRXCXX1/fcumJH95n7F8fwWa/D0F399YxJK/p+77K8eZqgr5aZR9vpz5eDH8zJjVvz7+aerq\n    3zl5tmNU/564/y9wygTwMUuzvwcz+ZfT9+MakwSO6RxOmQS+SZjKD1gwBwk8pR8w0E8OOtYPeGoS\n    WKqAtR9wE5qqgAH35noImXwL3Ujgrn7Aa9SrgPtMfrQfsCaBuf2mzM5Qha+8bssG1hNIlm/uQgK7\n    UlZ+EnjnaU/vI5+V7D8XCSyPwrO9kMA+iU8bSvGTwEwGMwnMZAYTxQalCq5Uf7dg8ld7FNqKOSY6\n    fJW/4nXoBsOrtTpYdHj+4FusfpX8gBMSEizKrx/i6mfvwBQukSvB6RzFwWfcVljaHlP6pgVsNZMl\n    cUsnuUUHxXl5CVsVylWmTOixVDMTvEzmamKWCV8+36ptS0qGSFQtjewjdtugPXWn/hcj9t9EFovU\n    dYjAttfMJc01sa6JZv4s7Gfg+gPL563HZV+1N/tH5zVixf2OsTIGt1k9Cujv40IlXElC1e7yGptf\n    vAuzSuNoQkJCBfb9ZSUCuVe3Shm6L2Ky2PY5i0NCp9XbkHFV+i6ZT8j+Bf1ltQbZvoDthzkhVs+9\n    crUP98UCnQwl2+88bXH7c5G/TXNJoC7TDITmxf75cV/yl48jz5sSvhGxjqHJX5247vP97Ur+TuH7\n    20T+jlGxO4Xv7y2Y3uSvxlDyVyO2+jcGTwbsG8IU5O9U1b9DCqJCmKJwC5i++rev/++zQv5+b+Jj\n    PIvoUP0LnDIB7MNcMtDAPF/Om0wCTykDDdysKuBHE7TLVcBjYsybCaAbCezbN2ZZCLEkcB/4SGCN\n    NgmaNhI4pg2gOTO06WZ9LBIY8JPAGr5JEP/VJDDvp9vn69K1KrgLCVwFMMMkMLfDk109sZZjtpHA\n    PuKY31MXElj270MC23MJk8A5rF+ktMnEbx8SmKUqpQqqgCV+LTlcOn/lf5FAFelVlny2wWs3sM1k\n    SwkbYudgNZPDBiU2v/8Mm3c/BpIfcELCM4/yyTWuX30H5d73V6RyuaqI+xSu7HUl523fxHLRuppT\n    k3IZ3EomWSb9NCfVAKD+1iVipRJYSzTr8dZXgdvk51tUG3jRhdQdq9o3Fnn0mZmmRhzPX59vsByL\n    H7rySktMS+UvL3fr3eB87uV+3Obvmv5Oynhvxz47bvrkU1ki2mejYDzfUx5fV+8/wPadj2F2aRxN\n    SHjWIb6/u6s1Eb2cMGWc+3Duc9yaWtsfcl+HQxUv93fS31opaJ96ha7izZ1j2EpXnz+wzNN8Kkna\n    H17mV5p4lXWul+5xyV897nFSNFf+8jyXCd8u5O8C8ZW/+pi6Ld+563ucEPlbva63qeMZglAspEn6\n    eU7yN7b6l485tu/vNfqDY3Ex8cEuvr8+DPH9bTq/PtW/U5G/oXMZKv08NqYif7vgssc+ifw9bTyt\n    3r8d0Z8AnqO8+dgf0hwl6okEnh+nMKgw5pSCBvrdVDTdvMSStjfFDzh0TF8lcFttQ5sfMIDJ/IBl\n    v6EkcMgPOIa83gT21cva2o8lgWMnh7Ek8M7Trm/Sy5PbJhJYT8qHkMA72r+NBAbgJYG1rBmTwBLI\n    iCWBC9qP92dPYCaBmfQoaHtLINsMfglWy/OlWqcl4KwvWEHb2Hq4krYXn7ES1k/YoPID3n75BZIf\n    cELCswuz22H9+8r3VxQLRPpWk2ZMunG1LxNpJfVxPuUCSVPh/k58XRconX7RTZpxiUKWEF7ApsHU\n    ZYdLJ+BdQlfO2OUaB5WIPEzytpG6XeSYx350kZpuJIdzuhYKrvS1fc/6HDL6jGRbIYEX9J1YRn7+\n    OUpnP0ve2nQorlbn76Edc7U0tPXq5Cp3X5KD2Y+rT175CLvP0jiakPAsw2w3WP3uHZR/eOjcr4vc\n    c44CC+d+3SWCM7j3+JIMKuOr7CvS+zj0QaUzZ7DJpaICwRLPXPXLqaPt5K/sGyZ/q9dt5C+jK/kr\n    5zMG+avPxUf+ylyUSdwQ+auhyV8+dlvlb1uSd1fyF57Xvm18ZK9GqP0m8lcjRP76MAb5K76/Y1UR\n    C0JkcR/p59sN+/S1jNPxxyG+v33J3xBuGvk7h+8v8PR7/z4LmLP6d87CUUFXfvSzEY7ZsfoX0ATw\n    GCcxNZ62KuCEaREaLMYmgYdWAc9NAvvQ1n7TTUys9MdN9wOWTEa5sb0FM4ofsIloJ5YE5vVNE4C2\n    SUEfEjjWD3iLZj9g2YYnUvpYvC40SVyq9sLyUN1IYN85zU0CS1uF2pfb5H19lcBLcHAYFODwk8AL\n    hElgPmddCaz3ydV6DrhoIoCz9rW/l1QOC8HB1Ur2UdA22nuTq/BsG4CB2WyxevFNFI+n7nkTEhJO\n    EaY02N3/HJvX7h2kc7kfYqlKHzmmH0wO64cm4cyhPajt6hWgTNIWsEFw1/+3akf2yWgfUHt1X1sL\n    Xc3rVlHVEUPs+jx2YzCGZ7Cu1o0hi9veJ/+rE8J1yWjtBxyShc6c/eqEvlHt2TZ0dZ2vateVYl2g\n    XgksRzMwHhJYyGW3WtjAINvtsH7xbey+mcMdLiEh4dRgyhLbjz/B+leu769oJ2ivX7uNfa5VfRZ7\n    uWgmhK2ks1UacuciLvnLcwhOUOX+lZWMuC2Z72jy153XWPKXk2Nle7pCo5C/khg8Bvmr56yhyl+e\n    RzeRv9xeH/JXHyNE/urtjVrXROyK9DPHEnibturfLuQvo410XVP7er85yN8+vr/yfAzf31jyt4vv\n    b0zhSiz52xT/bCN/54wuTOH7OwX5eyq47LFPqv5tRjHDMW4SjkT+Ar4K4C4ncwNMjgcjVQE3Y8oq\n    4JuWpTOFFDTgDtpT+wEfiwT2IbayuI8fcAxCJLCASeAmxPgBA3GVwHof9zj+9cYzEWiahOjtzhom\n    EkIC86RnTBJYJoDSfqjyV79uIoH1+fepBA5VJ/OxupDAoUl0DAnMgWY+F70vt9lEAnM7TAJbDyyX\n    KHYlRG1WPGfIn6E8tFXQdhwsMfsgMlcIS4Bmuf8r3l35vpKJgz2VJKobELJ1ei7x68qpWjlMwMpC\n    lzAo/vgIm1+9hXITI6CVkJDwNIF9f1n6mQmvEq7cJFcr+WTpc+qX6oSyJLRYqlX3lfzcJYxtX7qk\n    gLYmc7nK1Ovju9+udFqtV/MK0ejz/dXkrkYzeRv3CEkutxG5TRXATSRyU9vW/9h9v1piuqD1vuvO\n    VdjGs55JCd/3g5Uy5PvI/sNCLst2TKjIaxlH3aQs15NTV+mJcgaPvayusXv4BOtfvotyncbRhIRn\n    DbsHD3D9s9/DGLefcPuRcv9P+qoCugoYnj7GSTahJBTj9HulQ/ZKf1bN8bhv5SPWE1ltn+v3A/aR\n    rUL++ip/Qcdn9CV/gfnIXyBcdTuE/N2qbXldDPkbOie9bmryVxAif7tIP9c/L7vNLfQHk79N21TH\n    iYtz8XMf+dsVTXG7KX1/xyB/+2KK6t8m4q1v9e9UapqnUP172aPtRP6eFnwFo1MrC98gXtQvAZ1I\n    YIu5qoATCezHlCTwqfkBNw3CPHgfuxK4CX1J4NBNnizvIgXdtK201+VmsckPWG50TeTNcRPBK9LM\n    TdusW9aFbuR95xcjBS3LzjwTJ4FMrPqQwNXrsMQST9o0uSvPfaQub7dDuPJXt82TdC1b1eTn2zSZ\n    lklzEwncJKMVSwJDfRd5ch1DAnMbuh0bwDYHEli/VzdA4Z6Xe+42U58D3FK9JiLMgCWLq2tYqCCM\n    S/QCrqchky0S1NYVTz6ZOXku3sCrNz7F9oPkB5yQ8CzBXF1h9erbKL+93vdKVi3AX9lbyVhWwVgm\n    2ly5+oL2ySnsrCuDpZcTGWkm+zJUSTFc/cmkrqFlOfVyvqpdmQVqj1/d22mCVkjPGIK3G3lbIdu/\n    zykegi4kchNBfKjIzj3XSI2R2i/Y9znoamKWhZbqbd5GXleVwpYEZhIjc9ox4O8kq2MsaBzMVdVv\n    djgbl3DhJIaqPSvlKp6cm3f+iM2792HSOJqQ8MygfPIEq5feQHG1xmKvolHCkr7Y37tXSShFLUlT\n    yz+78tHSl5WHyl22WJCErLYkIKOes+yzj/zVcxxN/i4ASnRFI/lrYLCkJXOTvzppOZb89Z9LPdbQ\n    RP7uaHmT4lcf8pe388UogDr5y/vGkr++JHiofYaQvz7fX9nGF8Ph9W3pVm1FAV19f9kiLeT726X6\n    tyn+14X8lW1vw4xK/rYVlRy7+ncO8ncu6ecxMCWf0Jf8jcGY5O8xkap/LT7DUat/gSYP4FMhgY/t\n    AwzMUwU8B6bsRE6ZBG7KGpo7g6kNsSTwGGjKMmu6MWm7qenrCTyUBGa03TACw/yAGTHkbtt2bTf0\n    jBgpaN/6vn7AvmP7SGD+C8SRwNYPGMEJlyaB9USridANrWtazpN1n/yUzw8YaM+onpoEFjnoInAu\n    bSSwfQ9hEliWup7BluD1kcAi4ZzTdgAoG59JX7vcSk9ysEaCPvYvB4Ik8KxJYKlEAmz1HQ5HcOXm\n    bICq2g8ocf1i8gNOSHhWYHY7rN78EJuPvwZL5jIRrBNIbOCZ10sAu8DyUDlckWxcZ6SrOCVBhiuQ\n    mPy1Ur9Wyln6Uib6mAzmbbhP5r4a4PGjmbQVstNH8vpI3S4ErUEzSTz0YTqci6CJIHbI4dw0bmvJ\n    Cecb53weSyJxtccvS0LbZa5stI8kdiuB/Z7V+rVbZceJCwVVBddtF8r9O+TkLAOD61fex+7zNI4m\n    JDwLEN/f3WeXjtWKqGhYXSFzsGrh/qcihAtnPOXEGHdsrss/sy8wJ5NKoumS+k09Lorn75kzBgM8\n    XuZwyd+KJLXkr102Dfkrfr9APPnL809tW+Qjf7V0dehc9DnouS6DvYOb5uq6HT2/Z+iE7ZA6GFCP\n    RZzRPl3JX9/5NKmmdSV/Q/GZMaSfZfsh5G+sal0f6WcgLpbXBCZ/feiqDMj7NRHFfcnfsap/pf0x\n    q4kFU5G/TRij+jcWlx23H0L+PmxZPzZv86xU/x4DcxfEDiB/gSYC+JQxt6nz01IFDLR3Jm2dUROm\n    zIC5SXLQMihOQQLLYD61FHTbMZpubp5g2E1V0/KmG7/YG8cx/IB92Y1j+AELVoirBO5CAvfxA+bj\n    NPkBA82TM3j28ZHAgjYSWGfEhjKa5XVb9nCIBA55EPUhgeUvT9p1G5oE5v3jK4HrJHCMHLQEItpI\n    YM5sjyGB5Vx0ZZN7LHe5BHEWFKiW4A6TwEIWiwQlVwzkqtpOfMPyQzCpoO2tn1hxCFjbwLdZr7F6\n    8Q2YJ8kPOCHhaYYpDYr7f8D6tY9hpSktWSsJIiX1HUDd7zeHWyHM8vRQfZXtK9mbt+qvOCHG9pfl\n    IWlG5HsX+wpNLe8M1Cty2XdWSz27ZCRq+xtqowvJ20bKik/9AvVq2ykefLwhZDE8+/B18lUBu1Xe\n    7vUEtcGkb+FZljn7WnIjp++qbC/j2gIuaVLS/kwMc4JDrpbL72FB5Iy8e/HxzGi9kDlms8X1i2+j\n    eJTG0YSEpxmmLLG7dx+bX30MoJ5EIn2D9EI2kakaT21qCc8NOHHFZwvj2se4SaN2uU2m5wSeElvY\n    /tk3X9Hkr8zDJPF2LvKXyWygG/nLClcx5K+e4zaRvzzP1uTvVrXZRP62kcL6dSge4Kv8ZfK3eu2e\n    X5PamX4/vvOK9f1lhMhfwB/DmcP3Nwbs+8tEcV/fX0bI97dLIUfXYwLx1b+x2/kwJ/nbRNL2rf4F\n    5iV/x8BU0s83ifz1YS7yd+7q37l5wi7k75ErfwXNBPCpVAGfAuaqAp7jx3hKJPBlh22HkMDHqAKe\n    Ao9wOiRwE+a4ifKhDwkcgzYSeEw/YKnKjfUEbruBH+IHrJc1kcA+ueYN6nAnX5oE9k+mdPv8Xnyv\n    Q8QtEE8CA+OSwFqaOYYE1hPsviRwrBx0DAkswY6uJLD8vUVBGvY61ASFDT6bAwnClU5VAMX693IA\n    yFbRsaSzKy23OJA3LLTptsESdds/PsL1r99GufF9qxMSEp4GlF8/xJMX30apfH9z6h9EIh5OALuk\n    v7ZP4epIS7zZALdOWtGVtLpSt6T+VCpFhWDd7Zf7CF3s17HMsk4U0sSjr6I3h0GWx1ftxpK6jAWm\n    hW4/liyOJojJD1hXAfuIePkcuCrYlYe2Yx5XwulqX25XEgP4O2D3qycgZKgnJDARLIkPQiQzEcy+\n    wHDOz+4vBM7uwWOsXkt+wAkJTzN2Dx5g9dPK91d6QVfK2e1bOOHEPvze41LZu0ThJHXKyCv3+vmh\n    h7KVwayuIR7Ado5ST7TR5C8rGclfrYgUQ/4yupK/WiEK9DxE/vK2beQvH+PY5G+oLd958OsQ+QvP\n    ax/52xS74HP0td/V91dDtuP3xvv4fH9jidwpfH/byN9YaOlnjT4qfk3tTeX721Qgc9PJ3ynj5VN5\n    /95E8ncKjF1QmFDhhvKf41YAz3kR5mb3j4lj/GgTCTwMU1YBnwoJ3CZxEusHrDGmH3DT9qfuBywI\n    bdcWPjsPTB5CJHBXP2Df8WNI4HoGriVZfX7AmgTmv/pah2Sf9GQyhgSWye7YJPCtQ2BgXhKYz6UL\n    Cazb5KBHFxKYA9F+Epiz9w2FfiRAY9vgTH8mhqX6SAheDjK5ktEuGcNewuL9a6sQrET0+vVPsPv4\n    Hkzpc75MSEi4yah8f99C8WhFfYztC4ynz+GkEVdi161gkoC2cQLZrkIBB6u5j+NKTib7pArU5+3q\n    esy6QW7ADXT7CF8ANYLXwAC5n+SNIXabUKjHlOh7rCaC2CeRbQ6fX70Smq83t8VEhE0AKInYBfR4\n    KkkA8tzQa10JrNU1zGHMdGWfeVx0ZVbZhkESEKoaZb90tN1Wlq3f+gM2794Dkh9wQsJTB/H93V2t\n    1f21Vc6A89zW+8qYyz7iriS0TTzRFgl2qR3vOGHKJovaMU/7/ur27DzHOMSq7ruxX8bkry8JV17L\n    PKu752932WfeP5b81e2PQf7KNl3J39B8vYn85b+AP65whjD5G5J+DpG/gq7kryZj28jfNpuwpnWa\n    /B3L91cwhu9vaJ+u5O9U0s9tOAXyF0Aif/c4RfI3Bkn6uT9C/OAUlrJdec8Tqf4FYgjgric7BQkc\n    +tDmJIHnkoEGTqMKGHj2SOCpMBUJLDhlEjgGvqy7Mf2Afdvrm8MhfsDXsDe+Y5DAU/gB6+djkMAy\n    QfL5AfclgavnzSSwbrup8rdPRnEXEli36yNjQe3IdkvEVQLrz0vanYsElnPkNiXYzyRwiTAJrLPp\n    JbjShwSW4BCTJY5UMzjg7RK7LDenA9JCsvDzOiFsABS4/tlb2H3xJZKPYULCU4TdFqs3P8T6468d\n    8pd9xbmCiR8sXalldLkvqfrPurylK1tfXyZ932L/Ot+Tx7q6U+R9Namr+2Pej0lFIRJDss1neZjk\n    DVXtDiV0Qz66XR4sr9wHTe9B3neIHNbXkK+vXu8SrUxA2M8n39+L+PydbbKA+12qV/uytYIdT7mS\n    XX9/daWvTn4wsDLnC7JUYKsFruq7fuV97L5M42hCwlOF7RarN97B9rOHAPUT4vtb/ZWxsziMhrZv\n    0tLQrrc4J0/Z5BM7FsoYWSdzy1pC1JJ6Np6X1O1u6uQvJ+xI363JX38SbD/yt6/ss+xVHbeZ/JW5\n    3i06ju9c4GkjhvwF2slf93zC5K/eXpO/vG2I/JXtxiB/OR4yJfnrQ4z085jkr287H/nbx/fXJ/3c\n    N97Xhfwdo/q3D/k7Frj9KXx/GWPLP9808nco2riVOaSf58Sc8s9zkr/HwEjkL+5P5QH8tJLAc2uY\n    M6aoAp66k5mSBB6C0KAyVRXwVOBB/lRJ4Ngq4LFJYB+he6X26UsCh7bTJPAYfsBCyo7hB6yfr9Vf\n    Pp5vf9/koqRJD2PreR5DAptDe/VJG7c3BgncNJmMJYF3nnZ9fktQ7cSSwE0T77lIYNleZDAlUMIB\n    aitn6RIPhTqeLGMJU6g22fPSZukz2WHJYldWVft9VYGhOoHjSrNKcIqrgaXagKsQDpUM12usX/od\n    zJPHSEhIuPkwpcHukz9g/dpHNZLXrWYsFZHlEmIiPa8rJ7kv0dWRsp2Qg8vDchzWGbiqB9KD5XQ8\n    G9S2fTHLUXOfratO3XbrVb0cAPcRvbEkbx8it2slsQ++KudY4rgNofe+ALDI656SXC1sGj4P32eT\n    70kMK9VdgsdRuZeQz9H63RtsqS2uhqu+dyW9rhMnbrKD/U1omfMcJXaHNsrad10q+MQP+MmLb6N8\n    nMbRhISnAqbE9v4n2Lz20YHczfYJlHYM44QSc+gPqjlGcdgGnv4mh7Vtgeqr2MOcE1+kXSZ/ea4g\n    /fAZSicpVRO9gEv+yjac/Boif3lutgQc8nhq2ec+5K9L5PqTmjX5q9GX/F162vWRv75K4CaC1kf+\n    Vp97N/JXPwft44t3dSV/GXOSv7EQ39+xyF/BbZho8jfG97dLhe9Y0s8hNMVnxyBrNfk7le8vkMhf\n    4OmQfn4aq39P2fcXGF79Oxb5u0ccATxGyfKUeFbkoG+aFHQfXEZuN6QKGLg5JHCsFDRwup7AQ0jg\n    EGJu7rpU9Xa5WWwigQX6Bjm0DdDsByx/DcwgP2DfRKJp8tFFXjpEAvsIVh8JrF+HSOA2v+G2jOI2\n    EtgEzv+USWDBVCSwCwmmcDDdBig4AJGrbdz3YYMnCxW81gRyTsdgcpeJYnmeUxA6q7VpPTzFG5Er\n    8Fg62rpsWuLFkkHVXtvPL7F+/W2Y5AeckHDjUXz9ENc/exumsFW87Anu+oIbsNytpWpZ8rc8kF22\n    Ahi1fsmqDdjgNEvd62rdLVwJYF4H6teYzJWxxRLLUulbqvMNSzfnAJYkaRyWe24nc2Og2x3jXx9p\n    6tj35HvIv2VuajNt3m7p/e7YsWlJyQRb2Eq1EnWCWFcDY//587jKEqmSsCBkcZVMYMkWPhZXEnPi\n    A1e3l7Akjktz27G3pPdZ/PERVq+9A7NJfsAJCTcdxVdf4eqnb8IYqwAgyVJGJVr6xlbXaMGOUaIo\n    UDh9m+2/eH8eYznJhUlb7kdlbsF9Kdvb8DyH+3tOxPGRv1o9SeZ3rJ50auTvEuG55yLQhk9ZK5b8\n    lW1B67qSv744gJZ+jiF/ZT3DR/4uA/twnCvW49f3Wj6zLuRvE2I8f2U7IN73VxAif2MRQ+Z2bbsp\n    ntfX97cNoUKYqclfjanI37swifzF9OTv01b9+/2Z3k8TD/i0SD+PhfvVn/gK4FOWggbmI4Hn+jLP\n    lZ0R09kMIYH7dJaXkdvdJBJ4SJuxUtBzwXdDM5YfsL4Za7uR6+oHDDR7Ag+9cdU3wybyZjqW3O3r\n    B3zL05Y+v6ZK4pAUtMBHArdJNgl8FBqTwLxdEwkcquIF2sli33PGmCSwnkQPIYG5ynYqEngH1DLC\n    m0jgEm5Aw9AxZPuSlgsJLETuGQVjLKlhAzA+v00JFEmQqPRsawmZwiGKOQC1oOoCrnziKjsJgK9+\n    cw+7e8kPOCHhJqO8usL1q29hu/f9NdSfSD8gMpVVf8sOhJb8lT5lQZLxuq+qL5M23WC23dYl+Vy1\n    A9uvlnD7Xk36ccA6gyUHfdLIPplo5H6p4lgydCiR29ZuzGOq44Yqh53rlfuULdxrzp8FV5dxcoBU\n    /erqM1bfWDjfXdczmn2BZRsZe6Wi3K1Mt37BTM0sYD2u+bvMvxseK7PDL4gJ5L0f8JufYf3+/eQH\n    nJBwg1E+eYInL7+B4skKTO7yfTTfV3Mf49tO+p4zUuGRvk8neco9f+b0oG5/y/2SO7+w8w1WJwL9\n    5TFW2ynwnKqN/D1HfZ41NfnLxz818lfPvX3kr4aPQI4hf6vX9tqEyF6NkJqYtA+Eyd+uMRUf+QvU\n    4zcaTfGfc5hWMrmv7+91w7ax0s9S+av36UP+XmE68reP9PMc5C8fo0ml9NTI3xCOYdP4NOOY1b/f\n    h8GXMxznWSB/R5R+FnSTgE4kMPAlnj4S+FnGXIPNlCQwD/pzVAGH0EYCx1bZdiGBge7+IE37x5LA\n    Tcecwg8YaM/ibJps+PZtI4Fj/YAFvhtkHwkcIwUt2/JreF5rElhfa37tm3y2ZRvrcxcyVEhg3yS7\n    jQT2ZWOPJQcNoJEElm1jSWDZp454Etj6+9YrsJgELg4t26CMVPYK1eJW3VXX30pbusEhrt61lU91\n    CWhDsnJS5StEcQFL/1TnUlhPRFPg6me/R/HVHLe4CQkJo2O7xeqND7D7+MFestJW7FaqAa5HYaEq\n    l7ifkQpHlwhkyedCKQ6w37mPKPY/twSiJRu1H6xWYFju2+B+P0TmyvIt9glDVPkr/yRwrR9thGpz\n    Ja31rm2ruh3jEXO8mH+x14H9IkMkOpPA8pmKXzD2+zAZzN8FJoFlnZZzlu+Sv5IOh++mUevs+G1J\n    mIzGWq52Z+JHj8GL/RXInd9LidVL72Kb/IATEm4kyu0W6zfexu7+VwfJZxkTF2Ap52Yi2C7n+3Gb\n    nMJ90pb6lhylo3Ah21l1Azcp5QwiSW+IsAX1k3DW6yRb6aPduZRxyF9BE/kLTF/5y4nLseQvb9eF\n    /DUwB/JX2g8lfvusmfi5b51vft9E/sLz2nc+IennJvJX0JX85VhMDPnri8UAcdLPpdp3TN/fEPnb\n    xfeXY3tjxvF8eBrJ36nbBKYjf33x8DHi8an6txlzkr9z4NTJ3zEwsvSzYBoPYMbTSAIDxyOBjyED\n    DTy9VcCAf9AZuwoYGE4Cz42x/YCfoD8JHMIQP+DQ69hzHNMPuAsJ3HQz2sUPmF+PRQJXEkv1DN2l\n    Z3LF8JHAMuHy+QEPIYH1JK4LCWz2E1ueLPuqe32TY34+BQkM+L2leL20K4GLHbUm+2t5Mj5HF3US\n    mAMTTPy6VcH2oQMohra1AXbt1+VW17EXom3DSjrzc5E+9VUimUN7XMFnpewkEF7sq/xKGBRXa6yS\n    H3BCws2DKbG+/xlWv/oI9UpdN/DMgWYdmNYBbU0C2ypIIfSs36qhPqmAW6kqkrxVwNmSgbZiE+Ag\n    tSYVpeIzU0FrX8WuXVMnkjWaZJFrla9qfVMlbohUnuMRImzb3l+IyPXKTOeovf/CWe23P5DPTT5L\n    Tf7LuGpomUsCV9+f6r1y25YkcQllq45hK9ItmesmNViZZ1bd4HVmv39+EDc32NEywADrDa5f/D3K\n    NI4mJNws7H1/1699dPg9c0KUJFHZRCnjqGQwEWzAFi4FbBqJm9xZUt8lUviSwLJw2rJzCJ4zFLB9\n    PCe76jGVCV/fc567nKGskb8CH/mbq/M+XE4cV/aZrZG6kr+83Q5h6WQf+astmfQ+fchfLf0sc/tY\n    318E2rdtjkP+hkjcMXx/29qKgfb9HUr+Amgkf6f2/R2L/A1hLvKXjzOF9HMif58uzE3+Pm2lEX34\n    zBOUfhYs/s//44hstuNbAM93POhzAK6QjfpGngC4G1h3B8D1yMdjXO3f0+2JjyO4ALCi49yZoP11\n    xPu4PeAYMe1rrPbn1oZbADYDP4e151jnI7TrO87zPdu9hfANnwGQ79vcoF0yJhbnALaBcw0dZ9vw\n    3raovr+7iPe/3R8fqEjA0D6yrqknW3r219tv1bLYc7wd2Ha3b2+5f71GdnjuQ7Fvw7fNgtYX++fL\n    YDtCJtp9Qm3x64yWSWBUfltLz/5yHD73AvYzK6m9qnozOzwvqS1ud4vssEz+ZrRMcsMX+0dJbXL7\n    Ob0GtYP9ut2+zRw4hBty9fqM2s/Vc/6s5LMw6vj8/jPPczmPnNqU62kg6Vm2TT4GAm0X+/ay/fEX\n    tE9Oz+W85ZrmqrXQ/oWzLQ7L5ZzL/Xso9vuW+/b4eixoe+zbzw6fqdl/F+27lPez2C+RdjL1mWe0\n    hNdJ+4a+r9yCOexh/7dLqtdyDvZzqdrNARTfrpEtCiz/7E+QLfgbnZCQcKoovvoKV//+OrDeHCqQ\n    bPUvKwFY8ouD2OawXRU6XoBVBkRWUghjJse4upK9eHFQPshgK2jkfwPgDKVD+hWwxCD2W0qvxlNV\n    CVpn9NonRczbA8Air+uX+PbIqRct1bb6cVPQdu4LgMYaHpvD7zXPgMJUn5Y7xlTIaPzjR0ljoqH9\n    dDsylhvVMo/hbtuGxl9z2D+DHcPlHqCEHaez/bbyvjM6Z/lWu+Ome3+52J+5vd/KgCcbwOyw/A8/\n    SONoQsINwe6rB7j691/BbDaoeiRXDUDSULIDZWpTmnLSRBAiOEdJ66txeEFjLmAtWViNwCagyFju\n    JroY2HFSSFMmciXNpeqzbBqU9J4ysnOCrRDGZ4dRz+31hViVpU3k7Q7S/48j+1zSPtrCpwRayd9Q\n    Gz7yd0Ft6gRpII78BezcSidhN5G/ch0EY5G/ofZtm26CvIxYXclf/oy7+v6GTBNW6pqF2oqt/l1E\n    kr/6uqFhW4616X22nu2bUMXhwtvwui7FJfK9CSFU8BKSEx+7SleOM4X0800jf4G4uPdlz7anrv4F\n    4viOLtAFg2O378Oc5O+c1b/HIn8nkH4W9KsAPiVGO4SpK4Hlyz1XJTDjWakCBubN1LkJlcBzS0ED\n    3SuB26Sg+1YCj+0H3LT9GH7AgFsJ3HaT3cUP2MBE+wbHLD+n6S5jrf7GHGcNfyWwz7snphJY/Hra\n    KoG1XLPxHI+3dWWyulUC64muz+dXby8wLW0uwRNut82x5KB1W1wJ3OYpHKoEFlm1nToPl2ywARe3\n    Csm+jzOSemOZSl2ZxWQMDm3aSl6u5rMSnFWgaHHYTmTqCke6jqv4tH8hewGLyOvqVx9hd+8eYJIf\n    cELCqaO8usLVy79H+WTlBKtLWKnmHLb+SMvZiuytSAkzObw4VB65SgW2QtMGrG1FJQ77SX9ofVtt\n    MJs9YX3yv0IIO+8Vrk8snH0tdPVpnhvo3izkqcvVtFNhkZnejynQVEWsrQ6czyLXctj1a8zrS9r3\n    cC3AXs7+anCWPpVEAy0HnavvEI+18t3minSpSpd18h2uV/PZ30dJKhvZnhyS31Q1FheHc9u+/gm2\n    H90HyjSOJiScOsyTx7h65Xcole8ve/La3sit9rW/e1cxoHT6npLu9y3h60vP4SpiS9T6+mJb+cs0\n    LysaaVUiJn9lO5mftZG/gjbyV8bvKWWfeX7WRv7yvFLP+XwS0UPJX3ktMtICTcBp8pe3DZG/oigW\n    Q/5u1TF1HMFH/rZV13IcRcdSDEyUT69eHorJaPIXDdsBcb6/MZ6/QDff39A+V57t2445Bfnbtn1X\n    6eexyV85zlTk7xSYkvwdQw30mJha/nmO6t+nlfztgxvAk/aXgD51P+A5MGd5+9RS0HNoz0+JKTv/\n    OQfDGMSSwGOi681LGwkMHIcE1miTgh7qBwy4JHDbjXmsFLS8DpHAbYStL1MuRAL7lrVJQftIYJ8U\n    tC+70ufdswGCJHCofU0C+2ScQiRwqE0fqRtDAut17jWdhgSOkYPWJLAmb5v211ey+qwsISsBFsnx\n    t5KXdqJv93WJYR0E18/dzH4rBV0c2qrLvrGEKwenJGAllQNC/hQU2JbgtSZ+DwT0wQ/4ARISEk4Y\n    2y02b7yH3f2vwRLvEogW718OSi/otfz6reaB26dwn2NJPCtT75Oy5P6NpfJd71W9zA2Aa1LXJwkt\n    ZKVvf6ksLoCDXPEURO8xSNy5j+kjhjURYa+h+zmIxDd/Vr7PCXATAeTz5n9CWkib8j3zjY+czIBD\n    mzxW1pOxFnAtEpjksWfAY6bddnGgifh5gaufvY3iiwdIfsAJCacL8f0t7j2g3zz/xotDf6Hl4mXs\n    477CVdiwiSaSfsXJJ1z9q6t8OZGFx1ze5uwwngrsGMnzEk5i5bnLWOTvjtoCxiF/Q7LPfclfTeaO\n    Qf7ydeLtfEnb+rzafHl95K+P7NWv5XhQ7et9msjfJguuUGzFt21bJWMT+Ruy+dLbVccZh/wdy/e3\n    T/wulvyNxRTk79iQ40zh+ytx6bGrf6e0P5xa+nlI9W8MpuBfjlUo+DSSv135y7HI3wmrf4GhHsCn\n    TgLP4Qf8JZ4eP+CYTujhgPanrgKeyg8YGH/wksF1ikFRbgrmvhnRaPMDBqbxBD41P2DAJYHH9AOO\n    IYF9E4B1YHkTCdzVDziWBPbJ5YSWyaROLwu1LyRwyCtI3hsQ9iJq8wQWTE8C+4nb0LnEkLi6rWK/\n    zLTs709ksCQw+2vlnrbcql2X/GB5tjrxWx7IECaM2eOXCRYbRCqx2we9hfTRganMCWJZLzJN/O72\n    gW+ReBWPs/LqGlevJD/ghISThSmxuf8prn/5kZf8lSA0E7vZIVRtnO2kf7GVv9Zz3EecSeWvDkhn\n    FKguav2d7fd9fq+2urOSrjyj5UIWStDYeNYJmBC2von9iN4upGoXT94x/zX5Ace+l67gY+S5ccjb\n    NuI+5PN8tv/c9TjKhC9XA+vvDhMqNpEBtMwmMNi/lshxSRadMOWSvCypLolWmdq+hIFZbfDkpTfT\n    OJqQcKowJXaf3Mf1ax/Cquy4Us4yi2AlADt2Voo7oiJQ7v+ekV9wTmOxoXt5JoZdlR533MwoJcZH\n    /tr+Pkz+Sp/L5KtL/trxmSFzpQVMI/nL+/vI36b9Dx8FPfeRv3KcEPkLhOe0Bq70c4j81e9bt6nn\n    3UuY0cnfunpYmPz1zV/bfH/7kr/rwPFC5O85jJfgbfP9lTjQ2L6/wDjkLzCu729XxMQQY8jfPpjC\n    9/c5mNF9f6cif0MYq/o3BpczHovRxpnMQf7OVf17bM/fYxeFniLuh1d19wDW6OoJPLYXMNDsBzyH\n    R+8VgD+Z6VgrdYxrjOsJHOMHvEJ/P+A+XsByXjEYw7PX5wcMjO8JvEaV6den3SY/YPEZ3iKbzQ84\n    dIw2P+BzxHnt8vZnLfucoe7/yvD5AYvszxm9HtMPuGrDtjmmH/CtfXs7z/Zd/YBl2XXg/LT3sM8P\n    WJ+f/t5of91YP2Ch4s4hIUj3GNyebj/bhwPE93dHbQsyx5Ouej8+j2Gg7vFraB+fJ/BStcsefe53\n    1fXbZY9l9umN8QRmz94mT2BuK1fnYTz7s8eg/3dmPZXlL5+ZtMW/r6pNey0z2l/OZnH4HKrJuFCw\n    Ge1fOQ0asC8h6H3ZJe77sF7A7L1s9q25bct+OZ2PrC2/uQaWJRZ/9qfJxzAh4cRQfPUA1//+W5jN\n    FlxtxFWMDhlF5LD4CtqRiPfhCiYbfM6dZbZqWEKeTLBlHoJPgr+8LqNtRe5ZnvM037eNePXKX65f\n    OvRzkXnBi8wgz1B7HK61btcThMgCj6mRoduxS/r0DKoxwvfe5WFi3sXeVF5TCOItXH0u2stX7pMy\n    57Xcb4kvr/jVZ4e27dgmY5aMczyGZ/Q/DqOojL/mcN9jUAXIZcsFPc+JcpExk49g6ChyfpX3MLX/\n    eA1kOyx/+CdpHE1IODEUX32Jx//+K5Sb7UEtgxOkysM4J2OclXm3Nbo2eYoTrrBPvtTtZbQ9qxaY\n    fY/ESgtLFNgCTq9tiWEZJ+1fmxxTvdaErysZ7SodaUgrQoZq8laugC/pl/cL7R+q/PV7/pr9fDdc\n    +Zt72pN2pM028nen9j0++Vupt8kyHkE26rUsa6ssvuhJ/p7D1BLL1vAXF7RJP/tifitY4p+v4xDf\n    XyF/l2gnf4Hhvr99yN8ppJ85/hfCMaWfbyr5Gyp0alMqjEFs4VeMZZ4PU3r/JvK3O0KFnVORv8eq\n    /gXCvGYXNPyeh1UAnxJCH/4cVcDAfJXAvh/zTZKDnlpK4ab5AAypBG4a5B9hmkrg5zre/IwpBQ3E\n    Vw63SS2Hbi59N6Jj+QED1c302H7AXM27CqwH4v2A27btWgkM1DNwfZW6MX7A2G93B6ZR0sk3gZTl\n    QL0KmbcJVQLr75RvnZaD9klsDasErrapy22NWQls2/NVAnO74UpgcwgKGAqelIFzYblqwC8HXcBW\n    FG8B3DpQwCxNaf2/pDKJfcMkcFTst5VqYpanq7YT+sL1L2Sp1xKu7KUEtlavfYjdJ8kPOCHhlFBe\n    XeH65TdRPrkG+38buH6lWp4S+986nGVu1SJX/HL1IysNsD85VzlJAFr+LtQyQ9tyf5ihXt3JlKsr\n    Ce3KOfuqXSt/2vp1a6qAjfXB1V64+ria+J77Yc/BD/1emqqJQ9cs0HDtuPpaMkXsKmjUP2dLcLgy\n    4dyOLF86Y6FbTVc625eH72S5/14vDnV7trrdVgdb4saaP0hbBcQH2Cp01GXUM5RY/fY+th9/ApP8\n    gBMSTgbmyWNcv/I6yifXzviXERGc7Sv/c+onqv6hOPQY2l7BUqO2X5D7ftuHlM44Z0fSqk87Q4kl\n    ClK+qPd/APfVth/nhCvpT6Ud9gtmVQ4GVxA3kb/7q2ivJ4aTv7ryl2Wl+1T+8nwzRvZ5KvJ3i7on\n    r4/8hXp9B8aRghY0+f6G2vcdowv521TN27asaTngxnvaYl68fUz86RZMq+cvMNz3t6vss+xzSr6/\n    cyBW9rmv7y8wL/k7Z/VvXyTyNw6p8rfCDfD9ZYxDAHd501PIQAuO/SWY60dwCiRwW+fWhD6d6uXI\n    768Nc0lBA882CdxVCrrLPjE3xD5cqb9yrDH8gAVj+wHzsj6Zbj7fGN/5rdXf0Hq9TEtBA/UsyyEk\n    sG+y10YC+96fbB8igTVx3EYCA5iEBJaJ9BASWAcbZCKv22sjgX3B/QUFSSR4oklgAyaBXWloNwvf\n    EEHMAXeRc3N9N82hPfcvkzC5JwAtASkbLHIrA5kUYjk7SyTvA1mmwPVP30h+wAkJp4LtFpvfvYvi\n    /ldOZRH/tt0AtksQuzK5lvK1lbouiaXJLEvUWXI4d4LXJZaH5XUyVxPCgCVNXXlgOMkzoL616X5D\n    yN8m4rIPyRtD7LYRxHMgdM19RHFoX00Ox5LCrHTha9uOv/Z68ZisyQ7e115fO67x90i+n+76usw5\n    V+7xWMtkL4+bTArb30FBSwx2MIfEC9CYepCNNiWuX/w9tg+O5WaWkJDAKLdbrN98C9t7Xzlj4YLG\n    Tnmew94fL0gKOlOEb0H9joyIPF7yvXsO9z7fTWyRsZznMVwVXEIn0Mg6mcto8lcko+2xZF8XLCnt\n    I2/h2X/hLIsnfzXh6iN/9TzTR/42zRd95K/MGfX8NkT+AuhM/vK6baB9H/nL8/8pyF8t/SzoEgfh\n    az2m7++5p72xfH+bMNT39wrheFlTrO0Uyd+pq381+XtT/HmnJn+nLPiakvydAscif4sZ526+gs5j\n    836CUyR/7zevHq8C+FTevO/LMFcVMDDfj+FZJIFjMdagcBMylGIwpyfw3CRwG5qCnm03mfy3y/l1\n    8QMeiwTWWah6+7YqYN/ko8kPuOlcQufnI4F9E8ZYEhiII4F95x4igZk09hG/Pg/jEAnsy+w+JRKY\n    z0v7Fuvz8JHAC7iVwDqILwEYOb+qkshPAkuwgwPZrveWG0CxARfXS1FX1clrCV4zKVzu18nzbF/p\n    ZAPRNmidHQjegkijcn/8KrglVcUZSpSPr3H1yusor8Z2E0pISOgEU2J7/xNcv/ahk/BROr97Nygt\n    D12ZJEkhto+y3uA6WaRepWm90TkQLcsLMKlrSTXuz5aq3dzT32my0tc3CxbUTizZq9FE8rYRu6Gq\n    2rn/xZLQIZLYV0HcVjEM7EnhhR33FoFz0P6U9epfAx+J7a8Kd71+3XHSOOdequPId3sHOMkNXPXn\n    EsXV2MjLpBLQ/pYK53e0o99RcbXG6uU3UD5J42hCwlFhShSf3MPqtQ/2Y2PhJEGC+oCMxtAc9SSr\n    fL+/7Z9KFGq8tfYJbuKJbMHjnmwr61jZQCqDAdCY6yd/DfWLmkTeX4RaHx1D/rJ6k0BX1QJx5K88\n    t/cC85C/0ibPa5vIXz1/1uRvkwpX0/xcECJ/9XrZpo389aHN97dpmUGdNA6Rv318f1eIU19jdCF/\n    p/T9bdq3rdAiNg7X9Y6hzx3Gt5iP/BXcJOnnKdElzn/Zse2plUrHrv59FshfH6Ymf6csWG3DD6c/\n    9tMjAc04dkbAsX8UY+KUSODLDts+DzNZdtBNqwJmjEUCN93c9DlG3/BOzM1g0zYxJLDePrYSeCwS\n    uAljkcBrhCc2JnJy0zYZ8ZHAPkJVSOAQ6SuvZX0bCazPvwsJDKA2cfWds699eX4TSeBQJbCWolzs\n    1+jseTht2/NlEliC0JrY5X8sGe1KSZaH43Kgxsqj1uWf5WiLfbWdVB8wCVzJTBfYwZXGlPUig8mk\n    sJypBLkkkLW79wDrt94GdjEOSQkJCVOg+OorXP30TZRGV+0XhwrHitRyq3y56j/37MdJIy655Vb+\n    ch+j+7HC6edcok7qq8TzVyskLKkyiauhpNJJ+sJFw+NAfi7aCdEQ0dtEnLYRu7pKtg/4/fT+jqBO\n    eIeI4tD7DFcQ+7d12l20f16W+HAlnOVfdvjc7dgI+v7I9lvwWG7P0Y6TlmhhgndL321Zpglftyq4\n    oHG++n2JvydX9ZVgkoeriatfwO7Tr7H63dsot2kcTUg4FoqvHuDJT3+HsqwSpuSeWp6zJQqTw/k+\n    wUO2476Dx1omf+3YZu/jOXnTTaay9/hc3aufa+l8AA75KyoaPEbnTlpPHPnrjhN18pcrf31KTLHk\n    75yVv9KmCezrI399dktM/oaSs2NeN5G/muyNJX991cVN5G+T9HMoZtJH+nkM8jdGFa4L+RsL37ZD\n    yN+2WFlMJW9onyb4Clia4pxTkL9T+P4Kbpr08ymTv22cyNTk71yYW99uzkLOrhi7AHYM8vd++yaL\n    //P/OLbsw/AtgOcjtnsOwBWy0Y7rgzZPvgPgeuJjMr5GhjsTH+MCwEq9p+v9ex0T65brdntA27ci\n    2mes9u87FpuBn3noWOcjtK2x3l+PPu3eQrMczfMAtvt2N2iXm4nBObWp4TvGWcP20t4ZgF3k+99G\n    7rNF9ZsIbbNsWCcTgjP6K8/bzvOspe2dsw2QNZxfgexAAGos9uuBasK4pGV6H72+qS13mf/8CmRO\n    +7K/HMd3fuf75eV+Wbm/DiW1X9JxF9Q+n8MC1fdpcdhfwo7VOm5Pty9tyXF2+3b4+GeH59k+MCBy\n    jVntnPNA+wKD7LC/hDuX1NZyv9y3L+gYfL0LalO+Y247tg3eVp5n++PzeeW0f+lpT66DnGGpzk0+\n    F34vVZv2WBWZ4Z5DdtivWlaFrO31X+yXL9R7qZZm+4CJvWqL/fln+23l/OX9Zftt5fjL/dTStm3b\n    W+xD4oAEQ2TfqiV+b/a7sMfnl1j82V3k3/kOkM13/5GQkACUV09w9dNfYfvgsROUlurD/LDMEk5M\n    QtnKf0uwZrCVv9KOTQKx2xT7vwsKUO8ouLw49HJCd1myTpZJL1jun0sAzMDUgq4SvLZh9mrL5b73\n    sv1dhVyWL+Csz/b75irclvE+6hGSMA5NYytFCNQefaa9Yaq1HQvPOfAYGPt+pC3ftdH7yHXN9bY5\n    YIx73ReqHRn/5P3K+JOp7Qvap4QdS+V9yeco33o7ntrPU+6J7DnyfRAfNXPuCeReKNsvM87djB33\n    Afe9ZbWrbt9b8fkjLP70DpbfTeNoQsLcMFeP8eSnv0Tx5aPD2Cjkr03sEFJYpJ6r2VhJvZBbHWxV\n    eGzik02aknHTVgLb5E9ZXs1R3BSoxWF8tsk2oq4hY2hG/Z/2+5XxWUhDbpfhI3+ZuM0D5K8mVvn5\n    00r+8vk1kb9bWOlt3abcY3Qhf/kzkfUFnk3yt6n69xZsIkIM+dtX+rltv2XDuinJ367Sz8cgf4Fm\n    afE+Md27LaTyEJwHlq87tVJHIn9d6N/rXNW/MTLxY0LzWnMUej4Xud3Y6qp3hzcR87t+OiuAgeNX\n    AX9vph/HHD/2KauAgekrgYdgbhnoR5jOj4FvTI5VCXwsP+A235C2ffWNa4wncMxNMlcCt92gA938\n    fds8gdsmH3pZrMxRl0pgmayFKoEBtxK4SR5aVwK3VRobdWyfJ/GSAu1tlcCh9uW5b+I/dSWwtK8D\n    D22VwAvvefF1sAGPnPYDmiuBTe18rH+l7LeAK2dq9p8NS01zBZMITGpvsJwCSlIZJ6Er9gXmbP+M\n    thGCp4A5BL3kf+tVZomi8lARbD2Bd0WB65++juJh8jFMSJgT5XaLzRvvYHvva7C/rwShtewze3vb\n    YLStdlx42pDfvlRfcp8ifY72Iuc+Cp59RBmB/dG5WlgqidkDVra3VUrV4wyuvCVLBpcAZVe5FZzS\n    f2t/W67Ybare1dWruv3Ydnzn0PfhQ/g86udcf09xbfnOQ1cLM4Feol4lrC0SuIJbyI1SnX8Ba5PA\n    3ztXatx+t3aAM4KyrKqt2LXfQZsQ4cql+zy2uSqe10sF8WJPFFnp9BJW36OEMQWuf/omiq/SOJqQ\n    MCfK7RarN9/C9t6DwxgpEtDs753tf7M6yYrHXk6wkvttsU4x1E/kcCt97RjJXuO2D5SEKlE5ENln\n    tlrYqfFPtpP+UJbznEf6yxD5y1XBTNzyfG8o+ctqTKdG/mqEyF95HZpn818f+av3iSV/fbGDuclf\n    37ahZU3LAZf8jUEX31+gmfwVtMW1RCXPJ/3ctl/b+YXQJ7bXhzAGjkf+TiX9PAWmqv5N5K+LZ0X6\n    WVf/HpvfY5xi9W8kxieAT8ULGKh/SeYuIZ+rRF7/6KeYIicSuI4pB9A+iJGCfppJ4DYMkZ4J7R9D\n    ArdtIzfdK7Rnacp2Gr4JCi/nffpm4IWyWDeeNpsyWAUyWetCAms/YKj1S3QjgTWZOycJrNsakwQ2\n    1GYfEpify3nZQL4lgbkNOU9p20cCs2SzBG+E8JUAtgR4ZLkrmeoewwZxqs+uInZcksVQWHupAk8+\n    ElhkKesSdcVh32wfNpLgtQS5xBNYqOIcBbaPrnD16m9RXse6JiUkJAyC+P7+8gMw2SQ9DCdyMDHF\n    Mu7sw2uF331kre1HMtW3bGm7ENmrpZtZ6leC0xy4lr6dvQpZdpID2sY5T0sU6kC4D20EbRPJG9ov\n    nqz1n/eQh4/k7kIcN5HEXYlhjYOP78Il6PW58/dCSAL2s2QvYmlnCUvkynvK4HoA8/fQEr7ucvnu\n    lofr5yY+2N+SmzAlvqD8G5GqQSaNc/UbZWIpQ4HyyTWuXvkdyqvkB5yQMAtMid0nH2P1y/f3SRr2\n    ntgmThXqPtmSv5xSwh7hJdz7be7fpB9xpZ1tsiUO+1XbbQFKhrFzCiFvuY+WBFMAXvKXydY28peX\n    a/JXnvPYECJ/tX2OJn8FTM7KXHJs8peXS5tN5K+e+zaRvwCC8+tY8pfn/5r81eD5fwz5q5PSfehK\n    /oYstID2ik0dO9Hkb1v179jkb4zvr8S6xvT9nSIWGEv+6ljl00L+Cm6S9HMif10ci/x9VnBM/9+Z\n    sPg//z8s8QTjSiqdigw0UC+lnlMG+jaAfKbjzSEFfYFmueYVTlcOuq+0smAdONZUUtDP92y3TQr6\n    Flzp5mPJQTdJQcdKO+vjx2w/RAqa5Z9Bx2vaT/a93bLNDvb3lTVsJzK7sVLQvHyoFDRfJ14nUsz6\n    vEKy1HqZSPz6pJUBVw5aJKRF+hnUhqwzsNK+C1ovbZ0FXsvzseWgRVZYwHLQLGc8phy0nGNGbYpM\n    cawcNOg5v2ejPn9DbUjYWD7rBS0Hrc/gyk7q67M4PLcSkYauI8tPs4wm1LJSnVtdltLKUsuVNs5n\n    mB3es0hj8vvlT4XPoQq0y7YG5eUVcDvD2Z/+CZDztyshIWFsFF99icf//itgszlIT1o1AFuRlFPV\n    r5WaZG9vt/LIkrw2XC29mpW0tAQjt1H1i6VDsEnwcQHjhMG5Cpe3t5Wgtv+p5H7t9tJXZRBZeysl\n    Le1lAMzCV+dqH0xTy/4i0w/P9oKQTLTp8Ai1MebDCnY3P6r3FJJ3lnHNT6WLxLRRx0PTMfdS0PI5\n    2c/N3glIG5nTnpZsFmJBvw9DbWS1djLY95sfjm3HRb6vyFUbbLcA1Z6cY07Hzpwtzb7d7PDdde+C\n    DMpvrpGdlVj82Z8gW6RxNCFhSuy+/gKrf/8FsN44Us9WzrmiUF0VAPucFTNyIoYLWHUMOz7bJBOf\n    OkY1DxSCmMdPmwQK4LBO1A+EsLXS++bQN3IPbpNR/eSvTc6qJ9ACLvmLfTtMpAJ+8pfbkP3gtOUn\n    f0X+Wtofo/K3xDTkb1NyNe9XqvabyN8lDBZwk8MFfchf/usjV3kZjzzr/TH0aHR++E7VcU6fvV6u\n    jwV0J3/d6x+G+P7GkL++a6ixRJ2w3WIY+dtGOnet5OXza3o/p0L+AuGYbl/y927gezYUU/r+xsap\n    Lyds24djkL9APWGjizXmEDzAMJ6nK45V/Rsj/3yq1b8R/r+ATMtmLDl+5nCsKmDgOObgbZ3h2Ljs\n    sO1NqwTu225MJTDjGJXAdyLfW2z231hS0E03oyEp6Lb9YtoGqgH9FsIZo0C7FHTTJEHvE8pmRcty\n    XyWwTM7aJia+8/NVAmvoZboSmCd757CVwL7Joa7a3arjiOSwPr6vEjjUps6m5u3nqASWdkKVwCzF\n    rCuBdeDDF8TgamADN4t9R23o7HbZV2fKG2pPKsi4GiyHW/VbJRC4lbtcrcQkCi/LiexhUWeRi+aK\n    wBxcOWilLUWukpdL7VW2r2CSaod8XzVRosT61Xew+ewTwIQcMxMSEobCXD3G1SuvA0+uD79Hc/g9\n    W/I3CwSqbfWS7QtAv/eqX7Hy0bnTj9h+qFT9kK661EQv94PWy9d9ne8DilyFypWqUj9pK5fdKlbp\n    ecpFe6Us/2uTNea+OtTuULnmsdHlfJqulW97X9WvluBurG5euJ+XnC//k/W6apqrjPl7w+t0NTm3\n    Id/rHZ2ze76VP6fd3/5G5HfCFb/ub4llY6WqnvcvsCBSqVLdKA5/gRKb197H7pN7aRxNSJgQ5uox\n    Vi//GuXja6/Pr4/85edsmcKkbjV/LBwFnpz6Du6DXHUet5KXyV+eO3DVMNvG6LFW2nLJXzveafKX\n    VZJ8cyYmf7WNDhBH/h6uPT33yT7z8lOv/I0lf7eqfU3+8vMlzL74or4+hvzlZTHkLwLLhPzVVcNN\n    lb9dfX/7kL8x1b9dyd+Y6l8dW2vz/R1qozaE/O3q+xvCFOQvY+wqXYkrT9Wuxhjkb2zs/rJH20Oq\n    f+fmOwTHrP6dy970mHgGqn+BqTyAY1nxOS7ysWWgn7YfS0w2y5BOsU9nfDnj+5+LBJbBeQ4/4Lna\n    7UIC883Z3CRw2759SGDZJ5YEHssP+FRI4DY/HT0JW3qO2yYHzZOwriSwnqy1kcAy+V42tBlDAu9w\n    HBKY22Qy1ydDBsSRwBw40UEPLQm98OzXRgJLkIZJYJdEsUEfJjBEApOl5sTXVwhcDkZxwFrIIJF6\n    NvS8pIC1+JjBIZgKJzBWFlusfvYbFN98jYSEhPEhfoW7ew9gpWelurcEJ2pk9Hs1B7LJ71m62Pc2\n    uo9YqOC2z7uQ+x8m8WSdrnjS0s0SZLbyhLbvlT6S5aB9BKrjE6xKUnx+s1ydomWeF+hH8gpCXrnm\n    iP/aPIm7ksNaFpsJgRAp7Pvc2N9Xf2b8PZJrr4mNhdoHdM48rso4me8r1GVZSdvwtrv9d5+THPh3\n    YX8/LvGL/bjISRQsH+tWD9rfr8hG5yhgygKrn/4OxcPkB5yQMAXMdoP1m29ife8Byv39riRgiM+v\n    /Fb5HldEnjl5crHffrfvUZb7u+V8v07fj/PfHNZOwU2uAmzyjTvWMrnKNjKcnKPnLfLclwDrI38N\n    tcVt2L4Xh/kd4Cd/3T4/PNfTlb9AnRQeSv7yPFSTvzrZeQzyV8+vY8hfIVrHIH/lXGPJ33Vg2U0l\n    fyXGFOP5C0xD/rahqRCCMTb560OInJ06jjqV728ifysMlX5uwxTVv8e8652roPGYOBb5e4RC3MX/\n    +f/uxS3vAqNKQcfIQAPzSEFrGeg7mFcK+mtko8sx+3CBeaSgY2Sah8hBd5WCluPFSCAMlYKu3v88\n    ctBr9JeDPpYUtFyHWDnoGCloIF4OWvZp27apvRhJZ2lDINvHyEi3nVtVQZnhAnW5ZT7HAtmB/GNo\n    +ealWreGKwe9DOyHluUZrMSyrPfJQcv6InAsnxz0FllNClr2k30WdDyWg97SeRlUMoK8LCQHLe/J\n    PZ77WvaR1CmRAA+1mavnWg56tz/iktaNKQfNktUsH142tMkSmQs6PstBa0loLdYo25rD5+A+38HK\n    R+YQucsMC9Wee2zsl1kpyYy2N7AS2Ln6Psn7ld+LofMEtcdXQ8TYbfA9cz7PjLZmielsH3gXKUuW\n    pjarLYrNFc7+0w+RLbkHSUhIGARTYnvvY2x++gZgKjJqSQkZtgqYCWGpYCwO0pFmT1xZ8smGeC0p\n    BacyuOp7LIFW7l/bns/s+7iqpezQi9m6YhzalVdWjrKS0bUhMQ5iSx8jQWUrVe/KEh8qiHOXUORt\n    RAKTHxpN8sxyHD42y08jsF/Xu2b9/vSja3sx5+STjM4b9jWes8g9DwNXGrr6HIAsB0pjx7XQsWWM\n    A7URsh6S/fg1n2tOtbh2HPRfD2vHYO8x2L7Btp8dvgdCeMg4aq+VgRaElvGX3+9BQnpTAFePsfxP\n    P0R2do6EhISRYErs7n+I1f/7OmA4aarY/07rMs+SKClJVELo5vvEjwJmTyKXhzRKGR9lW+0hbslP\n    WyXMiSgLGput+oDoCFRjWXZ4WNKWadHy8MxKL5f0nP1+c7iVvoaeSys6URawpCy3wYm2uXNGYQKX\n    ZZ/HIn9Z9nmHKkbB56PbjSF/l/v32UT+Ol+3QJtAmPyVa9dG/gL15Ck5xtjk7/l+3rdGXQ5a7x9a\n    zklnK88+bmJeHbHk7wrtcs5AN99fns3GkL9t0s9t53cbZhLyN1b6eUzydw7f30T+1jGl9DMwvixz\n    iPydQ/75AeYvaJxb/rkL+Tum/POY5G+k/DOgp/fHkoKemnGfSzM8hO/BHDVzYuyMkSmyWsbAZeR2\n    Q6WggXnloB/1bDdGCvoYlcCMNqmVvpXAU0pB+xB7bleRbZcwUTfzIYSyRmUdVwK3+YCEbpKMmvwI\n    hlQCcxu6ohZwJy2+DGA+fnUMWwls1IRPt6ffk+817zNGJbBsL1nXY1YC7zzt2GO0t8nBDz6OwM1u\n    d9vjzHhugwMefB4L2pYl3aRySsu4cSWw9f+qnp8RPSAy0fnhr3ECULoSwQ0mVUGunJ4bWK9QqYZg\n    eUvxCpWqCZGNzvaVwhkK7N75DNt334Ip9DchISGhL7Zff4nrn/4WpixQgOXXzeH3J79hoYQz+u2z\n    rDtX/7Icra3olN+67Ws4iO1KU8pWtp/S6SziVcjVvICr0uBWG7lVo1wJqmWDJXCewwCLcHWvG0B2\n    92+r5OVq2hg5Z5/kdJdHu4R0v4ev2rbpWoQqiEPb+66H7zM4SDUv1OfnuYZ23KpXc8v3YkHrZdyU\n    KmAZI0u4nx88z32uySzTyhWBVnGjcH5jnEamK4OttHpJv11bTciWCpsPv8D2rbeAXUwoOyEhIQa7\n    r7/A9f/7axSltTExpGbD5C9gyd98v42WfeYxtlB9hiWKXeUNHhOXajmPo3bEln7T9nesKMRzBp43\n    YL+vHfvcflTPXYznuewXVknyz3/03Mo3D/PNC5vI36a5XZPss5C/vDyW/OXtWSFrSvLXV3nrI39D\n    vr963zEqf337Ny0LHQvwk79t1b8xinBC/paB82F0IX+7KuqN4fvbh/xtwzHI365I5O84uInSzz58\n    d6bv4rHJ36nxDFX+Cur53WOdTFd2fO6L/7RKQc/VGcRgSCfZt3O+jNzuppHAfdvtQgKP5QUsCN0k\n    9fUDBuYlgdv2ndIPGGgngfv6Acu6Fe3bJAW9RrMUNAL7xpDAGtrrJ5YE3nja0SQwny8fR7fP76nJ\n    E1j2XULIxu4ksCzf0rHHIoFlXy3NFUMCa48rXzCD22R5UN7POoa5/r/n++dyHkz0as9CaV/LQWtC\n    QAJDrhy0DWobp01bEWiD5K6nmW27PEjN2UC0Wz0oASrrkliFwnIigcvD/gVWL/0eu88/AczpjNcJ\n    CTcV5ZPHuH75NygfXx8kKJm4NRSkzui3y37eNgnE/sar5BAbyJbXOPQr1Wsd4Layz8bZVp5L5ZIs\n    WaJ0iDbA9oFuAoyVWuZ/Ia9Y6YNLAFg0E74hsjKG6K19Hmgmd+f2+41FDIEckmT2EcOaHPZtq1H7\n    jBZWvjskGc0UrFHnKNuKdLfc+2hZZ36d0XVgP8+cKvTkNyGewBWBK9dIqvQKapMr5ktV9Sd+wJY8\n    kqQNGT9ZDlp+z9e/eBfbT5MfcELCGCivHuPqlV+hfHx1+A2WcCt9mfzlxIzdof9wf6NN0s7STnHo\n    o9xxlBM3+Z5exkTbowAyVmprGCaCbTWv3Y7l+neo5iZaClqTv9L36nlPSPJZ7xdD/sq5dSF/Q7ZG\n    bbLPQ8hfToLW81lBG/mr9+ExKob8lba6kr8++WZBE/mrcQ4eU+toqzQcSv66x/LHirqSv7HbjCn9\n    PDX528X3d+x4aBueg4mq/u2KqcjfEMYgf7vgcubjHYv89RXyzcX3zF3AmMjffuhQ/Yv/CGMloBlj\n    yUHHykALppSDvutZNrcU9J/MdLw5pKAvML0UdFcZaD5mjCTCGHLNc8pBi2xz13abCDe5MRXZ5jGl\n    oIF4Keizhm1ZClq2jZWDvoN2OefQNn2koOXcYqSg29oHpH6ias8nB90kBQ34pZb1OisdbKWYu0hB\n    A1YKV7Zh+V0+LssQh86PJXtDctAlXDlo+f6yLJJQcywHbeV77Tn6pKD5PZXUHrcvz7XMc1c5aHns\n    9u2PKQdtaF+Wg3blqOtt8nqRmWTJSn7ObYKWi7SkgZWZ5GPzcTK6ntKelX+0Us07+l6Azos/OwMJ\n    tGRguebq86uWm/0x7Gco78PKvxk6v4W6DrLOqM82o31dOdBqafVeDIwxKB98jbMf/RmyizkMIhIS\n    nk6Y7Qar13+Hze8/oYA0V+3boLMQXdbvVxI13O0kSUR8DYUEZtlKu48luNxKTUug5dRDLQ7L3cC1\n    kHwZ7e8ShJYAzui59Hels5U9lgGwXNTTfbWUM+DKN8sxmmSa+VwYsbLOsT5vc4EtD0Joem88Bujt\n    M9qGKeUFmuWjc+DwobKdgvs518cf2VePj9Zywe7D2/Pnrv/yOL7cUz1shSDfY17Gx18cfjFaijpT\n    9w/2Gmh5a7sHUBig+OJrnP35nyK//dyQjz4h4ZmG2W6weeM32L5575AsZav4mfStXuf79EpL4Lqy\n    0Gy7IEkhi73VgoE57J/vx1cZY23ClKFtzWFszCGJJ3C2k+ROTvjM4K/ulUQeTkq1KkkVLJnMqkZw\n    xneeL4xN/nKbp0z+AlbyGehH/i7p/uVMXYM28neDaozoS/5yfEzGmqZlLD0tss++9ySQhALfcn2s\n    vuRvbKFAF/K3jYhdoh/5GyKXY8hfwE/Ah9pjtJHGHMdrI3/HNJ2QY0mbY0o/T0n++gqSxiJ/p5Z+\n    HlL9G1NpD4yrlHpM6efvw00wnhoh8ncqJd8+5O8Y8s/HJH8B4Hm/w9N4J9fnIj3NlcBfovoxPWs4\n    JbkExlgSE3NVAssg3rXdmCpgxpiZb01SKV2Oo2/eulQCxyDUXlsmZNMNb9O+XTIkrxF/g98GXzKA\n    Tw46RrKI4asE5ipc3W6b5FKfSmBDx+M2uBKYz7epYle/J3m9pePWJ8LVVn3loGWSOrYctOyrK4G1\n    TJpu08oss3SkP8DhihnbrHiWUuNqKF19tqPlXBnsVmO5FVrctq4OlmPbql+7blmrZXMrhyVotaAg\n    llQrZCixg632XeyDWCU9Z2lLqVpa0BXI9lWIu68eYfXLM5xUAACAAElEQVTar2HWffOlExKecZgS\n    u08/xvq1d/e/K+5puEqRq5fYF5hl27mikbeRCscSJVzyFzDYwnoUWmldSz6z1OSSKouFUHYrf6Xv\n    KqGrUbn6U0hkfrdAvXpUEqAAf+Wpru4NVaaGKnqbKnh1Jazv36mhPjLU/7W957aKYV+1cFuV8GJh\n    P8eQZDRXwp3B9czkB8tCS/tSgZ7R99omSMAZW2X8tN8Zq5gh1cD2bFw5aPEC5XE0O/xWbNVgDq4K\n    Lvejqf398jhdfvME17/4DcpVGkcTEnrBlNh9+iHWv3gb1rvXWiCwvLPoEXBlvvQBoqIjtgtLuic2\n    1CfJ/bH0OfoePYc7xrJ1AktBc78m84AzuOOkJHOxspCdS7nkr0BbLrhzjKq9sBKS20aI/JV5Hn0I\n    zrioyV/p75dwZau7kL9iDTRm5S9vx+tlrhxD/oasmDT5q+Gb9/clf5ukm2U7JqDPA9ccLW362gX8\n    8Zs2ey7eryk2BMSRv4KmkfQCxhvbGkr+xqDLe2B08f1ti0tO4f07he/v3OTvWJia/B2CWC5jTPI3\n    hDmqf+fmq+au/H1a0JX8/Y/VdfZXAAvGqATuWgUMTFMJfLdh3ZyVwM/NdKxTqgIG+lUB3+rQvkZs\n    FfAtjFOpGzrWmFXAQP9K4FsI30xym1KFO2YVMLdbvz72WE1VwED/SuCqmqW53TN66Da7VgJzG22V\n    wLcj3sMS1W/5Nr3uUgmsK3d9VcC83zKwH1qWb6jylCuBpTJXVxgX6F4JrD9HrgS2yzIKlrqVwFwF\n    XKpjtFUC82u773iVwPJ6R+fPVbOyrqkSeKeqbNsqgW0b9n/ArUDWlcBStcTVr0a16asGdiuUqveY\n    q/PL1GvZ31bc2uvOVVX8l+uXFrQsd66/Xc7VxHwtstr7kAonrnnLDsug2pIKOwn+y/evuh77gNCD\n    b7F8YYH8+3+GLA8n5CUkJNSx+/qP/3/2/u1HkmRJ88Q+d4/IrKqpPp19Ljx7Znp2zhIgAYJPfOMb\n    n/gvkyDA4RLL3VmCxJAYgk0Q2+BuDme3Zzjnln0uVZkZ4e58sBBXUTFRVdGbXdxVgKoIN1MVVTX3\n    MPWUn30i+PO//L8CX77eIJRTIOEWzObpJAn4uvSyBHXpYQ6qxUu+3EMiBxGYlmolnlj3+PY7r+tL\n    QI1eH707+fUtuOjCiQc4lS5hZPr/+e34BPJoj3Dt6R53OuHtXuaQXEzdq6l6Q6pXrjyWlvtPeZd0\n    f9n/cr+hx9alKYi1a0d7iFTXHkSbScH21uYIXK5uHN7HKX3n86O9lj4DB7aKp9tnze137v10Lemc\n    m7OfWYN/y5ZtyBfP/EHzpuwfNM9pDPoMX0F/AfyzTfsnVy5f/vBnHL4/4vnnPweO8hvhsGHDYvb6\n    +/+Av/zL/zPw5StcunXg6Q0E077p/vUwQVzaL3k5BdpL3R3WZd443uAw/edSyFMbqvnL1cAa/KW9\n    1Ye/l9tdg8Nf3pbDXzLa72gvjaV8vsKHuO77ffjhWfJDba5wymFSv16Fz6e3NjTfJ+D2mquOc5S/\n    F7SFv6G0z7ykEbcU/H3G1WtDcbWv7DzYsVgaae4/B/6GHlZvDX8B98DX50Cfc8KfFf5+hu37WKru\n    Lwe4HNq2gL+p/jnw99vE54LbVuAvEI7RltT9pVip5SGCHOtZ9xewxZ4/VfgvVf+uBX/XTP38LSbh\n    4hKWgr9WMVeO3YP6txD+AikADNQD4D9hGxD4L9gGBP4nmP6o1oLArZNN9k4FvQQE3lMqaBqrNQTW\n    UkG3TAcdg8DWVNDkh5sFAAN2CExzkH5T4ywBgTnQ0yCwTK/MzZIKmp4OPqAMAp/ENe4BgWU6QyAP\n    Ar+DD4GfwYOY24bA/FwIAtN5KwTm0JYHbWWKag6BCXWEILCEy/wcXwuH25idm3/GruyacIhLgeAL\n    OKj213UQ/TnspXuDDGzzd90FoykQPYfANG+AwMjh1tbN9+p93o644vIPv8XxVx9w+qsPwGG5khTD\n    hu3Zrj/8CT/8V/8XXH/zCVQR0AFbpzwkxS6lc75gUjG+vt01OOh1qS8dGD7BgWWn6nQgmDIpECh2\n    werrDdQ+sTYEf10Q2AWFueLyAD8lM8+CQA/EPMEB3xPm8PfwdsNztdnda5fG37fQHUgLdFr+GWsF\n    uyGTqapL/wuldm4Ji0PrmH9/0H3Rdxz+PtE1BCYIfBAQmPubP7TkyiBc4e+JV/GTykG8sH2Yf054\n    qQcqp6CVh/AfyvJBMY1xZXOkfdLNi+brg97rrZ1Lgc3V2Of/4fd4+k9+gtNP/nrso8OGGe3645/w\n    +b/6Vzj/x0+Q9b4J3vJ0z9O+5uDvgcFfnvLZ1QL2Ff1Htp9Sf55d4YDrW3YAfz+l/dFPxUzH4WUs\n    IMB7ZL2PAfhLQDVU75f2ae6T+pFp8Fc+3OX+beODVa4EDmV9emJ9c+Avh8g8L0Nr+Au4PaoV/H3C\n    1UvtnAt/Id5X7qMV/P2CeexBtpEmU0qH4K8l9bP7vPgm4a819XMv+KvN8Vtcb/GynvA3p+5vLL10\n    b/gbU+rmxmF7qX97w1+r+teahlla79TPPZS/P4rXS8FfUv8ukVcnBX97pH9+cPgLWABwCxVwKQRu\n    rQLeAgT+AetC4B7VBq0QuLQWcA0EXlIFvAYEblUPmPzRfAnCLgGBl6gHDEz/5PsBh2D9jhgEttTr\n    LYXAJfWAyadU9tbWAwbmEFgDwLHPXk8IDLSFwARmcyEwAdo9QOBp/f44T2z8OQSefjsyv0cxSgwC\n    01olBKbjEgJzFe5ZzJsCz0+iL/+cTJ/V6w3wXnG4rZ9D4lc2T3/8w1uwaR7I5tDbBRJ81S/EXOmz\n    RG1cUGquWJ4uygXn3/0OT//pr3B8P+oBDxuWsuvLV3z9f/4bfP5//X9vgeHjW6LI4y1lrAtYH3F+\n    U8w6KMwD0Lye7wnXWzCboDBXKFFaaTpHOIpek7KXq5QON58O4pL60tX9pbvRZKT+oAdHCPxyqMzh\n    KPUhWHw6+fc67jMFXi3pmWMQmRsHsFaYy1XFrZS+8/nnQeNj4poQvE3VEHbXZd5Ozpfvg7f/rvwR\n    A38dNMdX+BksAPddg0Awz7DBZ+T29flDWdTuyvxw4w97ufn7r+lhKv7wFv+d9ly3f3LlnIPCbk99\n    Q0DXKy6//R2e/vZ/hOM3ox7wsGEpu75+xZe/+zf4+nf/3Q24Uor2Cba69M70l015JKg0Ai93wNO9\n    c/h7Zb/TQ1WX252Cp6WnvdkvzUKpop2il6evdyCY7hJcdUsPab2Kc4ADn7LeL+/7ju3jvB/g9kD+\n    u0z5zPtJwOnS9sfh7/Rvcr7/+OPy/ZLDX+6Xxm5d85d88p8t4O8UN3Pnyazwl+YK4aMV/KVrrdl3\n    8NW7CPiugb8x9S+P7Xw1fJf7hn02YueBOWC1wD+p/pUAOWZ/ARKUQvdLfWNmrfu7JvzdUupnLXa6\n    NPz9VOi/Bv5a1L+90j5zALwU/AWWU//uBf4C9eUxW9f9zf0bFxw2DYCB+0oF/egQuHUaaD5GCtKW\n    AmCgHAIvnQo6BIFbA2Aa668yfVtSQQPrQ+AeqaDx1u5d5Pyz+H0JCPyCvHTWS0NgTe17Dhwn0yAw\n    T8WcC4F12DZXIEvrBYE5oI1B4Cc2D81vDQSmnykIDPjQF/BBqyUlNH8/Ceg70OnmwQGq9EnnJQSm\n    NJAn+Ot3/ab0zS5o7QLQFCC+ejN0AW0JZX1YTYFnt1quX5oeWoC3Vh6Ydikp/SsmA+Pkk3/184NC\n    B1x/+IrD+Qc8/epXOJys/9wdNuwB7XrB13/33+Lz/+nfANfLTV1EqiGqEUopJn0V0pUFnqc7EU/p\n    PAWmXXuq50upK+n10w31UhCX/LjatxSmPLHA9RFO4UsglyuZeACZ7lG8PfWnh164Qpj3AYDj0VcQ\n    h/7pGUvjTHYSvhHxG4K8Mhges+MC/1mMp+/X1uVrvObXgit6U2A4BYRv+8oRuDIVMDDtmxyeEsTl\n    31/ou4d8+IqPSns74MPZC/vpjrksFufbXuselDqy7wCH21wJBl+98gy0f/OMHNMarrN50T7samsf\n    bg9IXH58weHlL3j6p7/C4Wnso8OGBe16wes//H/w5b/4v+FypT3Th7WU3pln1gB8sMuzaLi91PWh\n    vZa+tZ9ud5FwqmdXh9ylhSbPsn467Y0A7VN0X3BqYPIo6/b68NcHtRfmj+8XoXq/QLjeL4R/uvu+\n    Cp8h+HuC3HmdSfgrVcovbE4t4K9s1wL+UhpsOr8l+DtdV/+nti7uNwV/P8O9563h73vxmXtF2p4Q\n    BrEx+PsD4umVZX/NR6z/X2CvD5wLf62pn1vB3z/BfZ72CH8BHQC3SDFthb9Amfq3Bv5axuwFf3n6\n    5yXh709xXSz1c4xHbQn+1qp/W8PfSvUvYAXAQD0E3koqaCANgZeAsgSBl6o9vAUIXJoGmqwUAlsA\n    MPnvVQ+4hwoYuF8I3Kse8DPsKmAoPi0Q+Fn4sUBkaypoYPo7jil0UxCYt5cQmJ9LQWAgDwIDPpA9\n    g9RPcyAtobYMZgJzCKypgOWYJ/aa1wS2QmAJb1+ZLzkHrtQF2kNgfh1CEJiOSBAM2CAwn8tBmaOW\n    ApLPSdYF5kpgAq5aCmj+2aHgML13B+aPGx1/ent1YUf5OjnIIJDCn693NYbnnzcOsSlt9AFOheQr\n    l3gdYHeOHoagfgRHzr/5Rzx9eJ7qAR9GPeBhwzR7/f1/wJd/+V/j8lb31wWLXZrJw+2ORqHfy03F\n    ywPPFMQ+sHbuOKWc5IHm6+1O8QKnVCL4CzilL1f1EuwFXED6ltaXvfZrELogMk8nSfcMCkzz++ot\n    8Hiyq3vn0DIMe8lCkDemwD1G+mn/0b7P91dr31a+Tuy6h1TFR2jX4TDr41/jMih88/X2BrnrOt8P\n    6XuOnBf5oDm8Yv7+cSU2/w7g/nrc2skn/53Ohb6z8Qen3P7p9lSuNua/Hdinl6uB6VN9xBXn3/0J\n    p5+cpn30OPbRYcM0O3/6D/jh//Bf4vzjFzhg61JA85IKYOdkmQVqe7qdP9/2PwLKF/ba4VUOeh0g\n    JgXwEQ4Wu4evpjZPbw9nAQ4fc3Xv9Q3C0d45h6h+nWCu+j3cfM2BcajeL/W1wt8c5W8I/krl7xVz\n    dTMHvj3hL96uzQSb/TlB+NHg7ws7nwN/aVw5htxxT8iHv/Q+PmNSgVvhb+w4wV85NzkX7RxZTt3f\n    FJwF4qmfJbzlsbHSur/SR8hq4C9QX/f3n7x9FlsYH0MC5RhAzY25vkM/+Kulf26h/s2Bv58K/NfC\n    35T6dwn4C9g5Rq0tCX+Xrvu7FvwF4syxxCrVv0AOAAbupx7wtJbwG7JUPeAfAPx8obGA+4HAuSA4\n    58bZAgIvqQIunbOlHjCwbQgsv5z1gMCl9YA5BLYqiXPqAXMIrNUDjkFgCW2fIud6QGBKBa21y0kF\n    DZRDYJpDLgTW4O0rO6cpgXtA4FCdXf6e+sFl37cVAku1bikEliBYvjc8BTVdQ1mDmI9LQWqegpTP\n    gVKUvb6Fq45Ke/5+0OeNt5mCOL5Kyg+2c2WASyPNoYGsNTz97jTDrl7Z22f93/8Gp3/6U5z+yYdR\n    x3DYMGHXH/6IH//Vv8Lrf/xH8HST8ILTpNidjj69JYTmd6PDDcy6wPPx7c7igKyrV8jhL1f9HuCU\n    wrxmoUtL7ULdBKoO7Jg771S+/PcjXJicfndJnuf/nQEcxQYYS+espXG2wN5QXd8U4D0BSP0T3K+d\n    6KwU/oZ8WVI1W2Cx+wTlg2E+TjYQPgLnq/+ecb88wwVlXpFw1j2Q5UDsGe7BJn6egAhB3ucbtHVj\n    yc/R9PCZrzOm60BHTuw1zRPM7/ltTz3i6s2DxpCpUK8AXv/hd3j+1Qcc/+rD2EeHDRN2/fGP+PJf\n    /5d4+fe/98AvlUagB6Dco0tu1zuyvZarf132jcvbvf580xNTCmdSFEv466oKE8T0yyZc4KDqE8uo\n    Abg98cReU1tehoGM0ilr8JfGBubwl0yr98vHCMFf8n9V/FJdXfr3gAX+yjTUa8HfFzj4G6pJrPkN\n    wV+6Vhb4KyGfBn+f2fV312+yL+IYf02pnyXUbQl/ZZ9zwp8F/pK6uLbubyptc2ndX+4j3rcc/lrr\n    /sbgbyuLwd/W6t+9wV8gL6acq/69F/i7lPp3ybq/wPLq35LCMFur+ws0Uf8CuQD4nuoBA48JgXk9\n    4B/RBwT3hsBAHgC2poEm65UKeksqYOoXOr4HCCxVwNTeAoFTqaBb1AMugcDWesBPmAJ7BHg1CEyv\n    a1JBT9eqHAJ/ZbCR2k3XR4fAufWAgXUgMA/EptJBk98n1p6OST9WCKzV+JM1eOcpJfMhsJayOQaB\n    SVmUqgtMx/k14kpgaiPHIvhAKSK5MtgFo12dYPLHVU1u/MmPq43ogvPuurrgNa2R3tvr7TgPtbu6\n    hTzYPn3mrt55l0KadE1X4HzG9Q+/xek//Wc4vhv1gIcNI7u+fMXnv/vXeP27f/sWiL7iFb5a109F\n    Of9JyiGe2vL49jtXKRHM5TWACdySgmm6110Y4HUKJkrFSP8/waU59P24er5kBIXPb/59Zaaf9pn+\n    e4WDv36tQD9tr1T3zqGlD3DDal4d9MYALwWoc2FtL7OC4xAsJmgb8qWBYQmFQ0CY+/f3dN9erwe1\n    rjPtw9TPV/C67w60972yPesA//vT0RvbPeCk7XEEafm1O7C+BINp7ZQt4wS3Nj/ryPU2V2pPf1UH\n    7/9CkXe54Py73+Hpn/8nOL4f++iwYWTX16/48v/+1/jy//hvb1kzzre/IXoNUNYM3Haryw3qEgCm\n    rBlPb+CXHsR6evNJf5s8M4fbI90+S215pg2nE3YPUL277bZva2Hwl4PW083vvAbv0es5h7+v8OFj\n    qt4voMNfXreXQPNB8Uvwl/zmwt9X9IG/T+xayXYvys8W8Pcr+sDfkPr3zI71hL/AHEqWpH52nxnf\n    OPz9EeHaxNxidX9bwN8l6v7mwl8wvwP+2n1rtnTq50+ZvmvhLxAHzvcIf3+D5eBvTP27pdTPW6v7\n    mwt/gSBzzQPAQD0ABsogcA8V8LSeMAReCsouCYG5Ctitc3kIXAuAc1XAORB4pILeFgTOSQUN2CBw\n    SgVMbchKUkGXQODcesASAnMQ3Koe8LR+93kOqX01CHzCchCYBzQ1CPzK/BD4TUHgkzjGx41BYL92\n    oA+BuapG82OBwPQ7AVE/tXKZEpjmF4LAHMJKda6rPeggME+ZHILA/Ke8Fi5tsg+gaT6U6tnBEWdX\n    8TmYXwE/ZSUPMgN+iujDLdhz8D4nR+aNAjukkJIqqouYo7uG89qe179M/4w//eqfjXrAw4YBwPWC\n    1//+7/Hjf/F/x+Hq1Emu5iBwfAtCn1jYmGAuBZ9dWsvLLQBNqieXQtIFpCd/Li0lQVmX4tLVBab0\n    kQe4QK+DVa4/neF/87z274Edp/sFBZND/5ScIPPkiENAAmiHW7uwulcDvbJNCvQeoIPh0LeZc2Dc\n    Nf/TkgbH1hOCw1o/CYXf3jITFNb6H4/A8cpb8Hnx/ofZvOlBANqraN5XNpafDWR6dw9iDAnKCeoS\n    8nCfmevtu9wFhzcFMX9oyqU6pxqf9N3iigOrE3lg/+efPFeP+ADg8sMX4PwXPP/qV8BTq2SOw4bt\n    2K4XnP/9f4O//B//Na7XM3imCwK6017i6t77WTVob7zc2rhvt7J2sNuDeaYNujtM8NIphF2WDv81\n    +Xx3G4fD1Tj85SCMUkEfRXvas063ubg9wFLv192HHCC+gmcHcuUdyCevd5sDf3nqaK3er1TiamCW\n    39Nj8FfW5SV7gVP9hsaAGGNN5W8q9TN9VviYGvz9Av3B8hCsBWv/Bb6KvGXdXw5/pzFtwCFU9zcE\n    bqnebwn8Bfx4Wqu6v89K35iR+ndp+Av4ccq9w1+gHgBvHf6m1L89UjKvBX8B4M+LjbQ8/AXWU/+u\n    nfr5V+Frfbj+uwIU9/9rALD+aUGf33QEpL8MHP/dQhAYmNJNLmWfxFg/6zTOP0bW9DcN/P8x85p9\n    yGj7pwbvx18Hjv+503v9kwLf1i8j8uGPEiV/yEIPltAYsYc/Qjd2ywMVP+IQ3Ri+U9pz+2wY4zvx\n    0+LjO6NvADi+teNfSPjDEV+U89z4QwPvI+e+Yee1Bw3eI/w3c1COf8UBLwqEp7bvRVs5R/lgAD1c\n    weG5/AfCKw63Y++Yn3e3cRwo5jWcX9gx7l+ui/un9vJBgif2+2vAL/+dg1o5Bu//JMaQDwLwKyx9\n    v4r2r+z3+XsTWr8Pb09sDIjf3VwdyOXnD28Q9fL23hCI5+3ddXFBZR6OPrzN4fz2O52f5jb9/voW\n    fj+xPpe3EDSt9cBeU/upvu8UqiL8fXk7esQB57fjl7fXFN6+vIWMjjf/9Jows/v5/f/6f4mnX/2P\n    vevLwTTZ9aoFxH2zpDsls6QiHVZv9L61suOh7h+LEjZZvB0CrS6Z7eX4AHDg6/n8J/zlf/uf4/VP\n    P4ICze7xDcpRcHlT61KYlFIzu3rAPBX0AVxf5Aes6efxLVBJaZ5d2uYrCyRfb+3eva186uPO8XSV\n    dG2OtyC1Wz0dIzjMlUWxq3UGcDo5vyHj5y6J8ykf52TLtF2M7VpUcl1yLJ7ZIj2veZtj4rw8dz5r\n    qt35w3iuz+F2jEDvBS5VNH8Ijfb4yxsmomMOPPh75fHt2GS0J9IDXa7dhfXj+x+dk/vs+e3Y8e2/\n    M463PvT6CfSohcPq3/+v/hc4/Yv/qXct5L03dIVj++Axs70c66ocK7VL473kULmXDIsb7YPWexLv\n    I+32nVB5z66y75c/48//u/89zp/+cgO/pOKdICVV23Ww9sRAsJ9hw0FfUvwSSJ4yWFzxDmf2MNUE\n    jymF8xHnWyrn49u5I6jsAm4poZ/fxpApnsnn89trUtk6AObD3zOAV3ae9lnenv59EUv5zPvS76l6\n    v2RavV/ya4G/fB6vws+L8G0Bs/x3CX9flXYv8OHdS8SPfE1ANgR/v2IOf6V/GnO+hnL4yy0Ef7W2\n    ZH+FqwrDQqmfW8FfWe8XmMQ875G+d4dSP8fgL1lJ3V+r+tcKf0NtLKmfY4q+val/14K//1jpOwf+\n    AssD4BT87aH+XRP+nhccCwgD4F7wt0T9ew+pn4GNAmBgHxB4SQAM3B8E/sfEemohcC4ABgYE1iz0\n    JUJ+GeGgdgkAzMfZIgTOAcD0uzanGgj8BQfvLv4NOw7xu6U2dQ0Ejh3vDYG5ur4HBKZ2e4DANLNz\n    cJ52CAzh10/w6PsllSyQhsDcOMilNhIC874SAp+8PngDr7hB4BOAzyzg7IDtFM463cZPQ2ACxzw4\n    ffHauhD55e08tbuKc0fWnoPgIw64fPMe3/7Pfv0WrH5TNV39RNykLTwAwNW9H1d2nqvKzlf//dFU\n    VDGcPKvfHAk854AUK3C+VzBtAUVAHND5f935//C4BvrzIDWHzBfR7uq9vs584kDQ1KlZXd3c6byv\n    hn8DvIcrLv/xd/j8D39gAWqCsi4dJddxUhD7xNrQudNbaJkC0hR0JljMIbBTSPn1Cc9vgeeXW59p\n    tRRodvDWHeOpnf3As3tfaeY6ZJ2/pzdfmjQFceAb+iydDW245UCMmNF10uyU5Um3mG/r3196DWnj\n    Y50S5zW/obmez/6e65s/pvNxCKz/cMuOQvCW9kgCyHTuRxzxDNKi8YwfBwaMjzcwrEHgIw63vXLy\n    PbXh0Fc+IBV6gIrv48AReH7C+//5fzYt60o5PfzvMLjS/ovb+QO/LuIhK18JzTWABNPfrpvYH/n7\n    eFU92Ezug7G/0hZ7y57Nshfm7pehe572EJbeNrRvuhT708SuszYuw4RDtRP8dcVEwPrfMlUcrrj8\n    9vf48u9+60Fd2jEJ6l5Y1gxKAe1SLTugS7CXq3SpNMP0MNQc/h7eMmrQHk77L/l4xuVNFYzb45Ju\n    z+V7BH+4agKiX95+nuD2Eb6ncPh7Zf3oqlvgbyzlM/cLMQ6gw1/qK+Evh7vSz+l2TZ3fPcBfPjc6\n    Xwt/3+GKr/BtSfhbW/e3Fv5y363hLzCB1gF/820p+JvyV2pbgb+fCvzvEf4CPgAe8Let5QLgFvAX\n    aAuAS+Av0AEAA+tB4J4AGHhsCLyGChgYELi10ZeIHN85X0ruDQLT+a1B4O8CxzXrCYHluaUgMB3r\n    CYHfCR9WCDxHZ3UQmPephcAAB7ZhCMznwCGwHCumBiZQHIPAwDw9eBgCT56pzYHN/wAfKIcg8OXt\n    2En00yAwVwaH4bBTDfPXDhyTOvj0Fkw/vgXBTzefPHh9xAEvON2UwRcc31J1H71AOAXGz3AqZZck\n    05+zTLzqAtFujfSaB7m1lOO0Is3o6CXYwlkOrLUGwzWfLRR7WzQPvGb20QLaR9HuoAa65v35sevN\n    lwS5lASSJ2WnFOyXG9TkgWt4rym4fbkpbHna5Kn2IGaBaTrP6xdKkEu+jrfgtK/0JfURbn5dQNop\n    n1yaQQqGP+FyU/py4HtmV40HrGNB4yO7XrydbAvM4TCHv7nANwf2loLeK5YNMPSyGlAc+/sNKXVj\n    bVQgfHblLbQ+UxP/exbfFyQ8pn3c7eEu08bl7bvHEcCXt32QfJ0wPSA17YHHW//n2b5Je93p9l2C\n    9r5XHPEOTofP984r/Ieq+J53usHb41sWDkofzWEycH6b35ntuXxf9L8PAO47yfHWDnDfp+S3wQs7\n    HtrbrmpfeH6n6z037jNn/7sU9NmTadfKknUiFwCnfNKnNDWyqwfvH6PXHOjSnkkpjnkGimlM96gT\n    PZQkH2Q6gUoVXOD2XwK+FzaSnyWDwK6s5Uu+r2+qYAK6rgawA71uv70wmHt9qyl+uaWE5n6f2Z7K\n    6/Ty/ZSnhX735pvDVK4M1lS/1Jf/+0fuubnwV77zIfj7NOu7DvylY3uCvwBmAHiv8Dfkr4fyF5iD\n    2Bi4pba5qZ8lqE3BX61PaE6h/iH7DtcBfzN9S6sFv8D+4S9wX+rfAX/n1gr+Au0AcAf4C2wBAAN5\n    ELg3AAbWh8B/wAE/X2isLaiAgQGBW9u9QuBUHfBeEPi7SB+gTSpozU9JKmgyCYFbpYImH60hsHZ8\n    CQhMfR4dAvNzr7BDYPebDoEBuxpYg8BT/+NtlBgEpr6xdNDTeo43lZEGgf3XUgnsB545KJbnrm+V\n    RgkaH0Qwm1JF420UOu6C4z4IdhpjCmjDm4cfwMZtbXSMrtMBrnYzBb95bWoKMPMRqOa09jlySi/f\n    rrPX8m+mzEqUwPepHU6bfA+0wPRBXFGpSpKeCFRyT5oCWNa+Pd4Cx1MbF9Tm4BY3XdIJl1vdvgML\n    IvN6gTwYTUFuntZSpnWWyl4/GO7g8OXWDiyoDfAANVf5ulC5VLNSXUVX+87dwxxAppYUYJ4UmA4k\n    S6MA9PHk3hNuNcA3F/bWQt7QXFqpi904ofXW3R0OBf2tUPgUOSf9vJwPah/qR/uye+DApW2+YP59\n    xj8uITGHoISLXP4L3PYclwL6xI67B5Om32lPpmNc6fsKV0ph/kAVoO3JuKmOp1GvkPszcGTz4N8D\n    JAzmqmZ+heiuOQFweoiK9vPJZN1kfu1wa6OD4lb75Z6t5M5SkgFDG0/zcwi05Q89uRrwkz2xOySd\n    5w/90J7BywNM/Wkf9B+c4vuV21+v3j457YCupu8c/FI93gt7dcUzzrd9lD8ARamfKdXzGfBSP5PK\n    9x0ueAFXFLtx+QNUR7i9lh+f9sTLDdSG4C+d89MmX2+vz7cjfp1gDf5yS6V8lu+8G3+u+uX+Nfgb\n    S/ksffExyKcEpVuCvzzlM5CGv18D/oF28FfCZj6HlvAXmAOzFqmfNfgL0PfluK0Jf2M+7hX+St+t\n    4W/KZ4kN+Bu3e4K/wDYAcE/4C+QB4HuCv8BOADCwLQi8NgAGHi8VNDAgcGvbIwT+S2KuKQgcU/EO\n    CLx9CPxe9OFQVhsrVQ8YqIPAPyh9ayGw9JULgeU4VggM+DV2eX8OdmVK6BwILAE1D5elIDCpl56U\n    vi8saOtqGvuvT2IufuD6eBvb1Yp20PYEqlsYhsAugO3UulrdwhNIb3gAV/nyYDUplOapLcGOucA5\n    gWCXVvPAZupg8JVBYlo7B8I8iC3TYMbqOYfqHYYC1SmFUQy4WNRJ95oKWrPp+oe/yLv3wGYyqC2D\n    1fI4h3Aa5J1UvtfZOR7oJojrFMoX9toFpF8BPDPVrlMzyTq9XLl09QLUXFVMf4l+KufLTX3kVE1g\n    x3haSxnAhnfOpZ0Gm58DwDIVtJ7meK4ukiBAvv+38ycO5eefEwvwzYGssTTNofalY23FrPV4NctR\n    DdcAYQ506Q06Ku24H/7Aj4S67pVT/fKUzjKNNO1E9J2IQ2Be+xfgwJnvqYStpp1t+v4xPRzFofL5\n    bZfn0NdP/QwcxN57ftv73X7rPyh1FOvw58uviw98vfILmO+n2vU8ztr6reapndOfndRDV9rn5N7N\n    CoBj96PcjAh8H9XHnz9ANR0N76dHXNi5+YNTHPr6ilxAK3/Awa8EsvOHpNw++YTLrA/BYJeXxlcH\n    0/56FXM7evPhD2TBA8sc4p69ftN3BB/++nCVHo56vV1LvTZwLvyNqX5pPG4cqObU++W+Q8B6y8pf\n    K/zFW9ta+Et+cuEvXafWyl+gfd3fGvgLlNf93TL85T40S8FfYF/q3wF/w1YDgLcCf4HHUv/2hr+A\n    HQC3hL9AGwBcA3+BHQFgwA6B11ABLw2A11QBA+0hsAUAA3UQuAQAA/cLgfmXihYQWPuSQsB2KRUw\n    jbVFCNwqFbTmq7QeMLAMBP4amZt2jmCvdlxC1BflM7YUBP4a6FsDgckPh7xLQGBK16xBYPJIlqoL\n    LCEwQdg5iLXXBaZgz/xzQdeaArkHMwSmMbWawH+5pa6cQDAFtV/e0k++vIWQL7f3YvLO01eebm04\n    oPXTRr++BaSf4aucKKU0gWFeS/gAgrkUoD7c1nt9mzcFtzmmJl/u2jjYS2Fyp6YGfO2nU/2e2e8S\n    GvCgdAhuSPgwD1If1N9jFmpFSuYWtoXUmBZIVqJwknAxNK4W+NbSP8uANq/ry1M+X4Eb2J16cVhM\n    QVoHhP200FKZ63RNPFU0VyxR2mmw8aa5nG/pFXnKZwLD57eVUNB6Svvs6h9SoJvSPh/F63nqRweQ\n    pVpapnrmtQxJ8cSDlTwYzQ5679XFe5fCFnqf5d9yjqo39dmy9l/TSlTAJXA4BIXleyn9x3x5fc+H\n    28NUMqUzGdX35WUTfH++8TIClN6Z5nm6tZjO85TQz3D7LwfCz2996KGrE9uDzjjd9mr3EBY9JCXr\n    BQM8qwYHzrQz0tycEpnvsaQ2dg9WAe7hJvou4SDywds95f7Kjx3Y++gevgJ7nX6fNWW21VL76hb2\n    OqDdQyEETvVrYTO+r8o9VvoI1gEOQDj+AJTv/3p7fYW/1x5meya19x+Q4irgE1P0Ht5A6el2ZA5+\n    aQ/kaZ/9kgz+A1QHD/w6YHuZneNqX5f2mR6wmoCc21815a+7hs4nrUeCcw3+crWwfBdT8NeS8pmO\n    SfjLf8+Fv6dZe/d6KeXvC/MbGkOOs3X4S+3k/DUA+wU6mA3BWjqXSvtMvlP+1oK/QH7dX+5nwF/d\n    79ZTP/eEv4AdAH8q9N8b/gLtAfCa8Pe3AP5mZQB8z/AXWB8A/yo9fjkABtaDwEsAYMCHwEsDYGA5\n    CPwpsLYBgefWAgAD24bAuV9W7gkCy3OanwGBdZWxpup9j/DfTChtYggCv2M+Q3OMQWBAh7HyuAUC\n    89e1EBjwwSr3PaU/zIfA8rWEwICrsSvfFbIUBOZ+6XcXZM6vC0zv6QlzwMwVzJe3zwKltDyzPvQ7\n    BaD9ALcLBp/e3jcKNBNcdvV9SRnsAC7V9eXqJp7+mSuKeeCaq5+mQPGRpYmUCmCe7vkwa0M+OCCm\n    3+k6+ekqpRKYfqfrT8phWSPYXXUOWHngH7DDWz9orlupqvccvJPk2xaC4r1Ukk8sgWRs3BP88KEW\n    tCZVL/1+Ef14KmNeqZAQzRl+AJxSQEulkA+LOfh1qtwLZApppz7iaiWCtU9C4asHs6d1v8P5lvaZ\n    p3cmRREHwDIgDXEN+PUMqb8AF2imYCWHvrcahif/WMz4eDGTflqkiI75yFESL2mnyLkWal7Nz8nY\n    3gKEAeD8dnEPgXFe2L5J/l2a5vk+wKG12yvd3koQmD8cFUoJzfcq/6EpsH1zyrrBwaxT57rdiO9z\n    57cHt85ir6TfuQ9+nGoPu7lMe9Gk8nX7I+BDXl7DV5ZT4HudVq+XjvAHrTQ7gDKTtLct7HVAu/1u\n    +k5TFnQ7JO51Et5afIWA7zXgl84fvF78wSe3O9LDVTz1s5+1YtqfXEEFX4VLey7tn7RHUjaMK6jG\n    vavpS3vnPEsGh7g+/OV1gS+sv6YGptcnti54q3Yg9/gGAen19G+UqQYwvU7BX/eQTFz1C4SUv/O9\n    3Y3tp3wm31uAvxLaavD3Bb5Z4C9mr30/370d6wF/gTBY/ZNox+efA3+RON4b/krfOXV/twR/ObTt\n    BX+BtMKxJfwF3OfsXuAvsKz691Oh/yXgLzAAcK1xALwE/AVsALgH/AXqAXBn+AtsEQADAwJzWyoV\n    9BIQ2AqAgXIIXAqAgWUh8F9HzvWCwL1SQQN9IDD3q1nqb6O2HnDIz3eJfr0g8HfKsZDVQmAJed9H\n    znEfMairWS4EBuqUwIANAvO5WSAwBKjV1haCwNJfLwhMviUE9sHt5JEsBIH5PFrXBf7KjmvppHnt\n    Xw6B34txKKDs5u1UtLKWMA8AcwhMSJZDYFLu+hB4Ckw/AfiK0y0Q7uoUulqGfjrM49u1POIZBy94\n    Tcqkqxc2dvURSalLANipkA5eIJqn8aRgt4PIPPjtK5WozRTYliqn+WcldTQFeHlAvca2qnxaK/1t\n    SsmkBb81lSgHiTw9NFd/chUTHXP1B13wloNcl5rZnXdwd5rxFb6iiKdzxtsYU5ppF4x2Sl6/LwW5\n    qabvGRc8s/MuVbMf5KWQNwWVfeWSC1y7ayYVwe56zVNE6zUg5e83aBohhjElt/sMpP+BqKqOA+3O\n    yt+cDJrfg9E6U8A2ZNp+F2oXg82htPxisrO5cp/cx4XtEQ7Y6uP4+5H7yWsGh+oCS5jLyypQnd+r\n    aOP2UHj77jTmXBl8hl8vmOryOjDr79uy3q98eIr22eNtTfD6SBW4liVDXudQSQVph8T5pWyre2ZN\n    rV/A7YUpP9r52N2Vz5++wfFkzlL9O/12ne2vBD/pMyfTOXMg7LJf+FCV1/iV4JdKJMhyCLy8gnsQ\n    a+qn1e7lqaZpX+UPbM1TR8PzRX2fPfjr76MnuOtDWTIImHIlLilzHfydA1ra0ziE61nvdzpmg7+x\n    GsUclMoU0HI+EqiuCX9J/WuFv9rxEvgbSv0cgr9ybQj41dp/TvT5YvBnVf7mwF/AXve3JfwN+WgB\n    gLcIfzWfW4e/3Le0PcBfYKh/c21t+AsM9W/KOqd+JqsDwMBIBb2ErQmB11IBA9uFwHtTAQOPCYFb\n    pIIO+VkTApfWAwZ8CNxSBcz99IbAvB5waJ4DAofHrIHA/DWfRwwCy/lZUkLTexVSA/M5T2pev0aw\n    HJunh7ZAYB9eU5gspFyaA2RKbzm9p8dbCmkeBKeah9M6XBpoUgA7Ne/R66Opf49waT25ymmqJOzX\n    Q55/LvVahjJYrQeg5+ombrnpK3XIbDM5/5a25Le+0n86WJWe87XpfaSqd5obDzY6VS+vdQvlOAe+\n    PK0zh5U8uE1BXwpaTgD5ovSVKiR4gW2u3OXpnOdKJXf8CBmYnsYhpe97FsDmqmCAUjdfZteKp3bm\n    wNyN5b/7sVq+Gn1Mvfcp4JsDe4PzUszyefTTFC9vueOn7mny7bHA3lQbv06vfl69/57dfVmrHSz7\n    yWOUbYOvg6uE+Z2Rw1xSA7/gCK4Qnv7vqnW7R6DcA1I8nfQRU3YO2sOmlNLH2/chDoqfbvum8xcC\n    vrRncqUwh7e03/JyCu7hKl4Kwd9XL/C/OdBMqEVI8cvLLuSa6WGAgO1hX4vP31fV5s9p3tN99nXT\n    7ml+W/88fxhK+pjXDfbBIh13ZQ0Idl5ux/2+ch91aaFlWYV5DV8CuRfIh6AOt5FcqmbaL6mQCWXg\n    OL0d5w9UzYGxLJvgw98LXJ1fDn/d/dlX/k4ZM/z22nvhw2JntSmfyTcwh78a+H2FDm5jql/uuzX8\n    1VI+0+sc+Cv90WsOf3n/R4G/sXly4wC4VvkLzNW/3wT67Qn+Sj/SYqmfl1L9krWs+7s3+AvYAPCn\n    Cv/3An+BZQDwo8BfYD317w5SP5PVA2DgsVJBAwMC19qWIfAHY7tHh8ChLy9LQ+Al6gGH/LSGwLFE\n    pq0gMIe9rSEw97EHCBwa914gMPebqgsMzFNCvzLQy/2TGjgFgUtSQtO5MxtV8+1q4uJN1Xr0xopB\n    YJkOmsbWILBMS0mBaxlgdgqledpn+TupfckPKZYoMI3bT9+3a+va8dC0VC75dQwd5OVBba5mmgeh\n    /cCyH/DWLRbkDlmqjmZemullTNZFTrfX5lv2D4WYKuoQDFQdVB9zxZHf5jh7fZn54MFWp3ji6S99\n    aDvBWK6snQNXqdjlQW4Jig9w9f6e4eoZEqTlx/00zpe3oLN/zNUqnPs5vgVoCQZL8E0ppOm6qOmb\n    lWCzBoN539v7dYLXPmQtgK8V9sbmccI6ULeHuf0pbCE4nAOFLSrhmEKYP7hzeZvsUenvz/cw608A\n    9yT60bycQtfVquVQ+Fkc4yCY9lme+vnI/L6+lVqg1xMIntcG5nsjB7syDTSlc6bf6bsUVwn7D2a5\n    dcn6wH7mDT/ls1aP/oKjYY9wd+AQ0LXe27mV7omhz1bOXrdUXe+czBryGs7roOeNmVqjlhFjMgf8\n    +DHaGy+sj6t56xdJcOPzfY0/fORnvtBSNsvzDvRSGujzLfXzy9tRlw76/DY/emjqcoPDXOHLx9OU\n    vfTAFIe/3B+HvxzKvt6uBj10xdMn+++ke3jVh79yH4zBX/6e1dT71eCvUwlP/aXqF/Dh75Pwx/2v\n    BX8tyl8L/JXfXR4Z/mr+S+v+Dvg74K/mW9qS8BfYdurne4K/QFoZ39p+poy3FfXvA6d+Jjtc/xW+\n    xT+vXPC9p4L+pXJsaQh8T6mggVEPmJsGgXsAYLKfZPgv+RJzLxC4tB4w9c0FwEB7CBxLBU3ntwyB\n    qe170a83BA5B261BYCjn5fEQBCb/ORC4ti4wB8fWlNDngG+CmNwfV/hSewpac9Uwh7K+ukqqed0x\n    B4SPb+kqfVBLgWlS/V6YAhjsOE8rzYPkpP7lgJcDYl6H0KmCXVsZpA4BYale0tS/zp8z3ocfd0Ag\n    bnNfYctVDkv/S5qcqRVYhwP6vebpq3dD53ylkn/MKX3mqlXX5jILkvo1b301sIS+V0wBXF47mALU\n    vFYwAeEDO+aUUrJOsAPIvB6wDII7tbD/2k8pLWEtT/3s1nKCC3zytu68H3wOBSBv78epHPpKGK2d\n    55YDe3tD3pa+S1M3W/1qc62FwhYgHPveeDmnH8iR2TBeMK8FzPdJeZynf5YqYp4OWu6ptJ9qamDe\n    R5ZbkA9WOVBLimM3n/Nblg0ag7JmODAsH/xyeylP5yyh8PSwk4S7bk89Ktdqeu0sticeIudaWchr\n    znipEgO9raS0ggVOa8rdkJE3fh8NlUTg42v7qFQB+zBy/qDUBf7eSupZvgdO+52W3cLtq6/g2Tr8\n    bBk8jfOBpYzGbRTfJ2XCeLophf19HHBqYVoj70upnE/g8NJX1sp27vvGdQZc+XXU4G/LlM/kO5Xy\n    mfwtBX/lHHPgr6bqzYG/qbrF/Hpw2zr8BdrX/V0S/mprtwLgUvgLxAFvj7q/A/6G/XMb8NdZa/gL\n    rJv6ecBf3x5c/Qu0AsDA46WCBgYErrUBgZ0tCYFzlcB7gMCl9YCBOgj8HRDtWwKBPyvQVp6vrQcM\n    9EsHzf1a/HFbAgJrYa8eEBgIw1nuj5sVAkvf/HcOWeU4JRBYXrOausASztKxVEpoKGNxfxoEJvDL\n    ITDNxQKBCebK9jxozZXB1JfXEKawNgWUXZpM5+/1prJyIJiC2tIXVzVpMNgPcruAOimTKPjN7crW\n    zmEwVzPx42C+5cMI3GLAIVXvNwY0WlmvEXyIvoyFAtp8/JiCTCpKw4pgp1ii9NBaPeDJrwO9HPjS\n    ucnH5QbNOPQlWPv6dlxLHy3BL68dzBXHlNJSpnTm4JYHuXmNXq78PbP5H9naeGpIriQ6qteFK7cm\n    ozmEPitXClqf5sdDllL4nsT40kKfp1rYK/turUawBllroHHoelmgcFMgfI6PexR9qJ2fNQMe1JR7\n    JgfGr95DSbjtb1/eHnqSsJUDXi37Bvk8sN9PmDLc8HIJ3BdvzzNo8Nq9NOr57dGpE9wDdnyOLv1z\n    vMavpgQOKXp9yEpjxlW+sT215KGpEpNzqK3Dq6+3r8Xg7lW00cySHlo+cHVAfO+8Qo457WO0t/By\n    ClxDyzNh8H2SHpZy+5/z6aoC++UPqEwCqYlpzyPVLz08RfulVBfTz9PbXnyCD4X5mHTv/wr+8JSr\n    g8uVv7S3SiDLM5K83tbtg06AA2Ob6ldCZnetIcZrU++3Nfx9EnMOwV8JfrVx5Nr3Bn/f4Xpr/84w\n    LiJtZfsl4W9O3d/e8Bewq3/Xhr9AWwA84G/cBvzV7ZHq/v4sMFZvADzgb5ZNABjAgMAJ+2Xg+CNB\n    4NYAGBgQmNvSSuBjhu+9Q+AYAAb6QODSVNDUZ0sQWALbHAhs9UnH3gfaaqCXIDCfUwoCaypgoD0E\n    fn4btwcEpnP7hcDTkRAEBlyg+2sACsu+3P/57fPClb9+iukDHCp1gV1ZuzhUF5jX+T2/vXYg2CmV\n    OMB9vv3ugG8IBHPIK+sXUppp+p3a0fsnaxPyGoSAD4DntQwBiUY5rJX1gGXQWQaHeZDbqpStVfIu\n    FQhf2uLB/5jF4bBTI837XJQ+1H767PhBbgo6T59N54MC2LyOISVbpb4cGPO6guRd1vrlgW9KI+2D\n    36m9rEMslb10nM5RemeeAtpP9zz1k1CYK4mkooivxVdv+SbVSBS0ppsXP8f7PrM5aJYLfGtA79nz\n    sy3A28L4HlQCh3OgsBUIn29/SZNpafXP57lPrbbwkfXhyl68HZF+ycfR86crgfkxvoe9evuvDoKd\n    gth/EIrDYQ0EywemLl5f/+EogsF0nXjGFf7dwM+A4f4ldb2N4a6RVu/Xv6bTHSRVVkD2kedittSD\n    SEtabYrp0DVJKZrleemHq3svzIeWflqmhL6K+/tJaP64yvdJwNwT/CTRdEdwmTDcOVL8kj8OfqU6\n    mEojOODLVb+47cnTnC6zFNB8v+Xwl1I6c/jrRr/eIDDe2nH4yyEx9Zmnh56M+3iH+V5Nr2VqaXqd\n    W++Xv9Y+Rb6quQz+SnAn4S9X7NbA370rf1vD389AsDZvr5q/QB78BRyEDcHfH5VzW4a/mi9uS8Pf\n    mN9WAHiP8BfoC4Br4C9gA8D3Bn+BZdW/W4e/QHsA3AL+AuUAuAD+Aq0BMNAeAlsBMPAYEHgpAAxs\n    CwLXAGCgDAJ/yGj7yBA4BYCBx4XA1DcXAlP7EASm8zX1gMkIzv6RhZFyIbAGVGMQ+D3CfzM5EFiC\n    3dYQWAO0S0Jg3l4CVj6W/AmUQWAakfeXdWGl/1dlPEtdYKnSDaWEPotzVghMr7nyNwyBaW3pusC8\n    PU9JKdW951v4fF63kAe3NRDMU0PzsQFX55B+5yopqk9IamMCvK/wlVBz+OorloA57KWZXr3rFbcS\n    AMzH1iw1aq90mTUWC95P569VQfoSAEx2UANj8/MUHKa/OZ4K+srmwJVIFJSmADgHvnSeB5yp/qGE\n    s5p6l6eTptq7FGT2g9fzfn6tRID+kmQqZy3lMwXU+TWnADQFH6Ua+AIXdD5611NLQemOn3ANUsZ4\n    7d3+wNcpt8v/8RtUMfcuHBy4prWZB2ivyQXD2vUvBcKhvjhP33neRfqQf5nemY7xh7NofEoXzdud\n    4EofTJ9/vj86CEv73yvb0yS4pb1Mponm9X85CKbMHXzP5CphStssYbBT4fo7PNVBlumgj5i/3zz1\n    swM6h9leqr1zqX2rBgCn/Lr3JGbbepjDojyOtWgFgOMj64pgXuuXp4qmh6emntNe8cra0n7Js2Hw\n    0gtXtr/wDBk8KwZX42rgl9JKc6Uv7dt+pgyuFr6ydM/8IajpNd/7aG/kffk+zuEv3RM5/HXZQ+Lw\n    V+6BIfgbSi1Nvrm1rPcrxyZLQdMa+Et9W8DfUJul4S8d0+AvnV8T/oZ8WpW/QFnq5wF/B/zVfGu2\n    B/XvXuEvMAfAjwZ/gb4A+JHhL7AhAAy0hcA5ABjoC4F/GTm3FAT+BYDfrwiBewBgIA2BawEwMCBw\n    yKwQuEYFDCwDgX/EAd9H+pRC4Jp6wADwB0OIRlMBA8tB4NapoLmfkN+cVNDUPgWBaW5bUwKDHbdA\n    YOrL2+dCYDmWHEcbt3ddYDknLY2zVAPznn4/55/342mgHUiew10HrR2ghdKPgs9nFsR+wuGm/uWK\n    p0nhS9DVD3wfWLA7BYL9NJtzVTBuPuC9puA0h8QADxJzFDeH+7zGITceoNdSP4f+Zi+sv0WdG0qZ\n    KecROlejAD4X9m2hdKzxMK/LG7anRDteL1ced/DyABncdiFvqYL1lcCuNqEL/NJ5CXYPng9fnUvB\n    aJ6KmauJCMielQD4HOz6x/jv5OcIF9zm5/gaKQB5xfUNjF29dnytIfDLFcUnRvxaAl/N5umZ/eMl\n    n/Frqk9v0FtiCXqbC4k1xXDoWsesFAjzfuezHOugtifgyfvTnnjGAc9sh3DfqTgM9fvwMgt8P9Wg\n    L68NTGc5wOV4lpS/T2xM2iN5mmiuaOYZP+YweGolgTB5v858adeR9tGrcs7trZbP0auhDYfOJdbq\n    X5Yle2ftvpl6cCp1zqYidm2OEV98/yVgexDzmz5zlE3lelOb8rEkAOYq4QO0rBj+XsYh7hXuoSqq\n    e/902y118PvE9tYzrrc9lO/LgF82gfrwB6dOXj9X916r90t+CNbNUz67eUo4Sz401S/14w/YhFI+\n    c9Uv90+2dL1fOmaBvzLlszbPUvj7BP97HD+2Bfj7VbSTqmANvoaOAxPEkgA3Bn+1MUPnuD+yn7C/\n    6CXgrzxfW/M35MMKgGvg758j/XvB35DvR4a/VvBL9qlgjN4AuBf8BXwAvCT8/Smu+M1io62j/s2B\n    v0BbANwK/gKLq38BDoCBbULgXAAMrAOBl1QBrwmBewFgYJsQ+EOm/xYQ+K8Dx3tC4J8Y/ed+yZGQ\n    tiUEDqmAayEw+bAc47561QMGloXAgL1+79Yg8LtAf95+rxCYzksIzH2VQmA+DqCrgXulhKb+moKX\n    zA9+50FgAF5AmUPgr/CVwlJty+f0ckszOXk5vX3uTuz1K2S9YAeWD6wPT+kcAsE0V6o3TO+PTGF5\n    8dr6qaJ5+kx+/bmKV9YvnNY6tfcVv5Np7SWcsKpwc2oaXpT2/HVqzB7qqfBYsTWTQkefc7gOpG4l\n    tQrlXLQ+J9H7IvzxVJcU2KZ2vGah8+nqFHJ/Lm20CwpTMPsVDrRyUPuE6y0wNr2+eMFsqYqivzI6\n    w8c6YQ6EpYqJPNO8r8r5ZwGEp79DPYX0nHv67wOdfz6loa8F+Fo5Kw+S83SWMYtBnLNhYJdqM3++\n    NaaNZ4FYpwitTfWna0rfOXKUwrKtvJ9Z1cEv59DYur8L/P2QPtf8GIfAfN85en1kKmfft4TA/jF6\n    dcCF3bFJBXyBUwT7WS78B6nouy/PrKGNxYHw2fPryi7wfYPfy7WyCDJlNBCDiWklcMj0/SS3PalR\n    y+dRapbauppJda30eTT6y8nCoaV0dqaD6cNtP+D9eWYJh8Rk5o3p/1fwB6v4/hLKlAHgrb6vfNDJ\n    pWoGrniHy+0BKwK/L+AgmgPmi7dXXjDtf69ibJnymZdN4Hsv/dTq8PJ18vTJ/MEkTfXLr632/rjf\n    /HFzUj5Px/Lgb0j1y/1rMDgGf3W1rg3+XpW5cj/PAd9W+KuNETomr1sI/nLVL29bC3/lca7S5a9j\n    faypn8nne1xVv0B/+AvYAPDfJO6MperfAX+d7RX+AnkA+FOB/1r4C8QB8L3CXwCLAeA11L+58Bdo\n    B4Bbwl+gDABXwF+gJwAG7hMCb0UFDDweBN6DChjYJwS2AmBg/xDYAoDJh+XYFiBwi3rAwLwmcAsI\n    zH2EfC4JgV+EzxAEfifa1qaDpmMcBLeEwLIucAoCS7/8NRkpeQmu9kwJzf3JWrwA1QqEp/bhY/N1\n    8lTPB+aTADFX+AL0/ut1gXn7FwaRKeXkkY3pILEMiB9uKTEPb+9hCAT78Nb5x9trV5fRQW1eP/Fy\n    m9s0zleWXjNc29FPccmvMB07snZAHPpqweOcgHGJkldTLcfabtWsSl6y3PTRsbZPmNclnObkjshg\n    O4FiPyWyDFY74PskgtSuBu/0mgLeLrBNWnWnHqZxj5B1C93ovP3TW7CbQ97jLeDtj6cDYbc+DpR5\n    QJqnrCTzayG6Y/I904Dt6cQh7yGq8m0BfC1tTYo9NrhMhxkzv1xBf8sZT2a8eFuc0Wz3Gq60Tdkp\n    0l9r4x6Euk6ZL84poOzPhatjT+oYDn6e2e9c5csfRqKMGHx/5rWB+YNV0/81EOz2O38/c69fPdh8\n    vB2TMJinuqY9mKt9+d73wlJP0zWd1uKDXZnumf4SZIaOkMo3F7CW7plbNes+eM1oS5azZ6agtDa2\n    9M/LI9Cc+Wt/DB/s0vkntq/xB5ymHv5+5T+k5Kdq5imgea3gEPh18/EVwFz1K7Nt0Jye2fz8bBmu\n    ji/tp+9YG780wxz+0rmQ6lfuxZrq14HetOoXmMNfa71fqWKWe02q3q82Lyv8fYEObGN+eZ9a+Kut\n    5RlzlS8wV//2gL/amrlvaRzU0utYnxz4G4PKQNu6vzXwN1f9a4G/KfAb8kW2JfgL1APgNeAvsA/1\n    b2/4CyyT+vlR4S/QBwCXwF+gDQBuDX+BfABcCX+B3gAYaAOBSwAw0AcC/zJxfkDgOtuiChhYHgL/\n    deJ8DxDcAgJbUkEDAwKn7N4hsDym9SEbENj14+drIbAcywKBuQ8HXecQePJXlhLaHZmrgek9es/G\n    g/I7h8QSApP/GASWKSi5qviFBZV56mjuj1S7LjB+9ILWPEgtA9gEbaGMQ6CXB7oBeMFumfqZvz+u\n    r+sTSvUpUzFLJRPEOZ4yHNBBsVW9VKouugcAXGI8gOynMdQtHTC/ztrwWr7yuKauoXaTkvcAHhiW\n    ilie9lhCX14D0U9D6WoScn+8BjBXR1Ha5WcWEJ+UOVwNBWgBeBc0hzc+AWOaO1+DvDZX5Zh8v6YA\n    NW5kjdq94IAUpLVA33Da6fn7b3KGPMgbshYp1GutNP37DA4bCK7McKFZLRDm5vaJSZl+Ps/78fXz\n    PeIgjvP7+knxwWHxxVvnYba3yLTQ9P3F7XPHWd9pbP1BK9pH+b4q1cc8y8YrfLWyBN18D+fAlvfh\n    e5/MSEHe5PEUrI3tT/wMf896KHLXtNoavynje6Y1i4as337CVTw0pffVAC/A9zv/ASm+RzjgS6/d\n    A1e0r/n749T2APfIkty/6Dz1tYJf+u8F0z7Ka/lSFg6ag4S/HEDTMbd/uv30DAdqZV1gfg1Dql8O\n    f+WDVzx9NK/hS8e45aZ8jtX7pXO58FeOEav3K+eaC3/pdSv4q41hhb/UVqZT5v546ucBf8PKX/LX\n    G/5qsHbA37QRoO0BgAf8HfB3CVta/VsKf4F6ANwD/gJ5ALgB/AUkAAa2CYFLATAwIHBrGxDYbj0h\n    cC8AbPVd+qWnV03gUD1gAFUQ2AqApb/WEJi3T0FgayroWggsgek9Q2DevgcE1tpoa86BwFB+Aj6k\n    leuxQmCa35n5t9QF5mOUqoHP7NgJ88C9P54PJR3clQDXpYTGrb+vMiI1MAfTPMDM00j7NYddGkpe\n    4xfwFb2USvPE5uTSQ09z5UFpHuSeXyvc0j7LlOPTfOeBY3oYQSqTpPL3yK6nVEhxS6XCjAXAS4PZ\n    1G+PgfF42uj8vlJ1RCb/6TBPZTnZ6+21nqrvDBfw0xVVfvpjsqc3AOvuAy4l5dTLh76UNppSQp9B\n    dQzdanhNYA5wqY1W51cqfumakVqYB5LPYiy6JrKNBARcBc2D+hrwvM3nxMcMGz8fAqgakA2NbbET\n    rsDZDnqj6aGNPpa2GEzNgcRPb86sfeS4oX5Pgf5areHYWOez/wCU5k8+BCQfIOL9edYNQAe9t7EV\n    OKsBYp61Y56uefptqvXrA2vKruH2PxoPs/Eok4cP3A9v9xuZ6NmvcQzMH6S6KteNTKp//awJ8vvf\n    3K6R/dayz4XVrPswDl5j68nxpV+P8EMtsbIJ8sEeCYCdkpfMf9DKVw27vYPX8tUUq9r+RqB2+ntz\n    e+gZ/sNScfDr9mUHgR345ce1LBqAv3fSHF/ZPngC38NdWw3+8trA/HPAf6fz79hrWTdYU+lyq6n3\n    a1H9AuXwl/+UMPaV+d4S/CU17x7gr0z7zI+F+qwBfwGX+jkFf4G+dX9DsLYUAMfgb8jHgL+6b80G\n    /J3s3uAvsJ26v2RbAsD3oP5tBH+BpQAwsB4EvudU0MC69YCBAYFj1iIVNLBsOugBgRH0kTrG/cUA\n    MPVPgdpcFTC1aVEPmIwCbT0gcMhvLwj8gsPtdU8IzF+TpSAwtT/MgoBpCAzMFbY1EDi0PhpHKkrJ\n    H8S5kpTQcs0U/OXpp6fX7pgMPMvxOSR2c3BqIFnfmI85QVQ/CC0hsPtccYUvT0V9uKWKDoFgntaS\n    p4fm53htYFkTWI7rj+WuEQ92yxrLWkpoblq9Xdk+pfYN1xMus9pU0xZ/ITVWbtrJXLMpNcPzno6H\n    /c6Vu/CgruaLK1+lbxcw9ttyxZK/Lj9AzH2/sDE0P9yHr3TSFMY+iKagt59W0g8QU6BZUwE/s/Zu\n    /rpaWF5rDYjO6gJHa8xSkzjwjStq7Z+rV29ieUrdXMC7pgo4V/2bU7vXy0yR0zExJ/lgVWjMU9zJ\n    rY12D+EwV8sUAWWPod81NTCd43vy/AGmwy0FNAfBUHwdxLGD2CP5Q1JPcA94UYrn42wMd+051J0e\n    ejp67acxput/jeyDsfdR31vmSmxu4Swctr+f3DTRpTYH2uH55ex1/lra+Qr51ObN97JQKn8JdrnK\n    F0p/uQ8QbKV+dJw//ETKWlLfcjUyz5Yx9XcQmDJflIBfDmpl5g0OWqXi+PgG+o5s/9TgL99HJUgF\n    NPjqw1+3hzv4y+sJc8tJ+TwdS8PfWJpqQK/vWwN/Q6pfPlZszfRwAdkW4C/gQ9W9wF/tPPkgn6G5\n    kOXW/c2Fv0AaAKfgL/dxb/AX8AFwb/ib8lViW4K/nwr8LwF/gT4A+Hfi9dLq3wF/dbsH+At0BsDA\n    NlXAwIDAIbtHCJwCwMCAwMD+IXBLAMz9cuOwVoLg1qmguc+1IDAwgd3WEDgGYLm9j5wD2kNgmRaY\n    jq0FgYF5bd3YsRoIzOcRg8DULhcCy7GAMgg8+atLCS1VvGfRNqQGJt90XkJg7n9e6/Fwq2v4/q0d\n    +dHSWcpahFJtTHWAwdpwJRQPZD/DqZ1dwFumdZ6n2bzczkvIe2St5kHmeZpMug7zPlLJG4OuqVSm\n    1oB0epz53EJjZHGYhhYKgluVTFpwO7f2o1Tjhs6dI32pHiEd44FnChKH6gk7qOoCYlylxJUsXJlL\n    dQcJDnMfrq0eUJ5SVoYUSrqiVyqcQsCct/HX54NkHhicQV8y8cFMqXxbAV9fMa0MHhinpYqXrs8S\n    9X/J6H7/NePvJ2VJJe9Jf5n+G04D4RJ1MK8HLB8KIvuKwwzcXnAQ4Pig+pAPI/mw1fdF++ELexCK\n    P+zEs47MH5Caj8f3Y65E5iUTpjk74EvZTPg+yO+xFzFnCcaPoBIOYVjL/Up7TfQNmcw+IN/DeF/d\n    1iyVoNVwlRbb8/3ztqBZqF2qVrrcG+R+Tnsc98dLE2jjS3Uv9eMPNmn7LtgeyiGwXtLAVwZP4/ng\n    l8AuV+OexXkACvzlIPd623dlLXnuk6+VIKhV9cuvGT+nwd8Wql+e8nmuMKZ1+2aBv1pdXpn6WVP+\n    Lgl/Q3OXY9TC36/sGPfTC/6+V47F+ljgL5/DgL9p03yuAX9TfmsA8IC/casFwGvBX2Dd1M/3Dn+B\n    9QDwncFfIASAgW1C4K0BYOAxIfAnZZy9QuASAAwsD4H/OnJuTQhc8yVoQOB+EJhUwLX1gMlyIHBK\n    BQzoEFgeHxA4vuYWEFj6zoHAPO0zH+f8NkbrlNCaGhjw1UuaGngeGD94PmStYakGBvx6wO/FXLRg\n    NimRJCzWQDD5p0C3VPNqNXxJyRtSAXOowIPX/Hep4OK1DLkProQiC0HHCw64wldOQfk9ZaHAdczH\n    K/L3QR6UDQeRrYC63mKB6rOxj0wvGr6WUqEUGltXCcvAtQxm84AzV9+6hzdcn3cC+vIg9xEUaLzM\n    5nNm/mUa5xf4a3pmszuz9hzuUqBcqp01iHqFr97yIYEPvE+43gKZ8n28qXqV1M8h6JtKrZxS01qA\n    bw7sjX1u+QNAe7XUGlL3iCgUPunta4BwjjpYqwcsX7+AZ8Fw41+UPXiupp0DWPkw1wtkSYMJyk7g\n    5+g9DDWp8GnPxG3P9PdPf4+a0kTza+Y/6MTVwXzsAxwUnu+d7jrIOsCvmKfWTqWFlsdCJoGLBfjG\n    HnhqoQi27u2x9MlkJQ+VxLJWWOcRs4vyO4eqR9FGy5DB0z87Na/cRy8z2CwzXvjXyD00JZW/Z2//\n    AngmDMBX7krlrQZ++TnayznUpevBAfEr6wNcZwBV1v+d1/adw1iI331Vsjv3yuYigbM0Df6Wqn5L\n    6/1qc+PwV8LYHOVvaKxS+KuBbDn/JeEv+ZTWEv7Kflb4S75bwt9U+63B39hxbgP+1lsIAA/462wJ\n    +AssC4DPC44FLF/3Fxjwt7GFATAwILDVQhB4SQAMAH/AAT9faKwlILAFAAMDAvcAwMB9QeAYAAbK\n    IfCPkWuzBAQGwiB4bxCY5vHNW/8/RcZ5bzzeEwJTn61BYMAHwbkQWPpKQWD6nfspTQnNfYXX7cbg\n    6l8gDIJDEJj75yBXUwPz8Z4CgJf6u3n4qaZ1EMyvE7X3VcK49fOVu5O/I/Pi/PCANAXOSbE0Bcz9\n    94fD44sYh/yQ8XqH/DMjz0Ppo5lWL5gsV4XUEzTr0Ds0j3Zf2FO++BzmNX/1NYbSPUtFrxxfUwn7\n    tQ2vXnueunIKjk5t/ID19Bv/OU/lzNtzxe0V02fXVztR62e4gLQLrrtVPIOnpnTjh8d2a+Y1GrVU\n    njzFZeg9OMPB314qXxX4MjudbbA3tA5+Xx/mmwXKnXGIUroWQDiqDg5AYLkOmWVDQl9trzgoewzP\n    nMHb+A8jHeGUyfQ9zu1RlCaazh3ZdZLz4WNzv4Bep5iAMM/KEVI2ywekQure1J46ze0QfQ+m2fD7\n    UXzPDY1fay1SU7fYN3MfugrV283ZX7XXfB+lMULQmB87zPaYCSbTa6rhC7gA7xPrc2HjHd/SQPsP\n    Ql3Zg1A8O4a2V+eBXzoO+CreE6h+q39Oh7B+m1fWgit4Abf/SdUv7W2vmECbljaa+oVUv3RdpeqX\n    2mjw16r6pfeRf05K4K8GYpeCv5r/0Pw1aMvtHuAvHzs0Pp9DCv5a6/4+KvzVfLSGv8AEgAf8DZsV\n    AH+qGKMGAFvgL7BM6mdgOQA84G/Ytpj6eQPwF0gBYKA9BF4rFXRPAAxsBwKfFhpvSypgYPsQeI+p\n    oIEBgTXbAgSWbWMQ+JMRiWwNAof60PFHhMDaOCHFbqousITAsZTQIQgMzNXAcwWtrsZtpQamMWWA\n    NgWBNUWxVPPyPgSB3RoPbyDYpcbUUlFO58MgmPpJ2MvVSPIYje9qyzmozOdPaty5QsndE/w0l5iN\n    Za1hKJXGFrO0O7NWVr+1we7a2sT2cfoFu6kPH+MY8JVSXYVSIEuwyJVPHAiTvbB2EvhOQPoy8yNT\n    Q/K6vjxw6ae5nMDvZxzU9JJSsTsPws/r+Mr3QaqOedpnf95zO7OfR1xntWFTKt9q4IvrbRI5sLcl\n    6A2Nu1Qt4FDd31bp4WOq4SQUPsXrEqeBcIE6+Oxn1QiZtrdKiBraB/h5vg9yEEzKW76Og2j/jCu+\n    sAwYtBfSXuk/lKV9Z5XZOtz+JUshHEWfV9E+/Z74cDv0fpK5Gur8urnrV7I3tXgoqrXVZMyw1zv2\n    7WQY1TIvv40/l1CZB18V7Ks6eY1ftz6/zSt8uMz3K7kP8RIIfGxN7Ytbn2l2MfBLe67cR33V7xwK\n    8/T+PK0zTx+tKXZf4ZdPCO2tX5hf7T2xqn5pDF316/yecPWgrFX1S8dK6/1CjMN9aSmfl1D+8jG2\n    Dn+BCWJ9gQ5+ge3CXwD4gEsQ5P4oXnMAbIG/QBrU/oAw/NX6t0j7rPkZyt+4f24D/vp2b/D3twD+\n    ZiMAuBf8BcoA8BbhLzAAcLXtBQIPFXC9DQjs24DAdsuBwFYALP1or6VfCwAGEIXAMRUwEIbALesB\n    fwOXrrkFBP4GulkgcGz80Lgc+srXjwiB5fg1dYE5vJUpoWVAuiQlNBBWA38VMBaYq4F/fFP+SL80\n    Pw6ZXZ3h6edXcd4FmI+iJrIfAM8BwYBLBU2+LsKvf8wdf31TAVPg2Fd9S9Wwfw1pjie4v+1Qukst\n    sM+D1TlQQoMMWrrpmLUOVteA3/ZzyYPDOXUOSQ2uK7m4gtUPTPMAMz8G+MFsMp7qGW+/T2OQAuri\n    jTtPqTyHvq5esDsfqtfLlcC83TP8wDX9fmSvnzFP46mBY/qdB3E1+KulqARwg7810NcEfGke57AP\n    brWwVw6zFNjtYWfDvctq2nVV7x0nRSUMtVnYx81s6uDXs5tjqG6wVMOSj1CZgYuy91N/DnbpCKl7\n    /bF8fzKdtIS9SJyX9ex5qugpjfT8HJWB0BS+r2JflPs/9Tuz32Op+c+wQH5/rHX3zbK/7RZlE0rn\n    4met8C30UFNsvBC01+u9T8fes3Natgkt/TOd4+PIOr5ubgR1+UNgfqaM57e003K/9KGxXipBU/1y\n    qDuvw+vWcWXnr5inaib4e2LgTz6URedrVL9yfrF6v67NBE05RG4Ff631frnvXvB3j8rfWD1gOk6Q\n    1wKAa+Dve1xVoEyWA3+/wTWo/I3BXyAOgNeGv1D8bhH+AvUAuAf45f6ltYK/gA0Af6rwf0/wF3gs\n    9W9P8AusB3+Bu1X/AhYADNwPBO4NgIFtQOClVMDAgMBkHwxtWgFgYB0I3BMAA8tD4BoVMPcTei39\n    3hsEJkD7RbSXsHQrEJiOaxAYmIDuniGw5m+NusD0O/djTQkt/XBf/LVUA9NPquGrBay/ijloamCt\n    HjAfS553ge/DDQRraaFTIJj7ngLgx2Baaa1WMPU7M78X5X3SUmLy30nRywPZWmDZV3mHA8oaROZB\n    8BiY0Hz1Vua2Uv/lBtitgfCQukjrHwuEU3sewNJ8yFTQWhstGO0Cxa7PPN3l1JvPl0NfP62kn9ry\n    iusM4krwS69dncbr2/vr/PP58D7y+mlQWAahCfBcI0HBmSr0FAajsVq+OlRwJmG0bNgqPXkvyJuG\n    4bXzDqdELvHlX4M8C4F27x5y8n6o4/KmxTD4PN93J+XhvI98eOmrALkX+LBXA9VSNXwUfmnPpowV\n    z5AAev6Q1KQulpkzoO7LmL32r89cISzbhL838TXSz1Cdep6ZQcJkaTllC3LKJ+TurS3uISX1fnNM\n    u5en1sTVuE7pHl+3y/7gTO4DFzEGIPdzqeLFbH+Sr5/hVLvkwy+NwOfnagVzte8xsI9yxa8sd+AU\n    v3hT/PpQGJiD2ZjqVz7cJOGvlo3jDB8it1D90jFLyueQ6heoT/lMr0PwN5byOTZeS/hLYzyLcVrC\n    X3q9F/jLgW8K/gJ5dX97wF9qvyX4C4Tr/vaCvxbfA/6m7VOB7yVq/gID/rYyCYB7w18gHwC3gr/A\n    AMCbBcDAPiDw0gAYWDcVNLBfCLyXesDA/UFgDmp7QuBWqaClvx8T12YpCAzMQXBOPWAgDYEJzvaE\n    wORzbxBYm5MGTVNgWEJgDdxaITBdKd5G+pJzKKkLDMxBcCwlNB1roQbmkJkgsaYG/spURxoEpr5a\n    qmbyQf5ku1wQfPBe+/5p7hIGX7xQrfZ5cyqqeS3GcCBft3mg+4rDrH0qeKyppULnrconBNotlb6Z\n    xuJqsVKrVUJZ+mt1eUNtCGYecRW1nXlQeRqXB7Zl/UOujpIwGZjwjVT98uAy78+h72S+Ohjwa/Fe\n    vfN+gJtahNS8UlFLAfApkHm4zVO7pilYQGOfTnkANabyPWnv7dnvy61E3eugSNk/SHtD3V5WCotD\n    ClqLyfdHg8HSbykQnvW7fW7iD/WQ75N6zlfyAnpd4IvYXzSFLwfBPDXz1N7f92gfvcDBYvngkExh\n    LYGw/F6h9afXV7Gv+5DYvyZcCcwvcyoduHUvrN33avv3UPOWjGmFvRogDNX2zU8L7e+HJ2Xfcu3c\n    /qb55DV3SWXMUy7TWNq+eAbwntUG5nsgv59L8OuPN8+yQT9fMcFkStPMATBfzwlXXJXzmuoXmMNf\n    uc86Za//UBe8c5j55e9pSvWLm3+76hfIh78y5TMfi/cI+ZamgWU5h1bwl3yRlcDfr+IY+ZGqX7IQ\n    5F0S/mrnB/zVX8csJ/XzgL9h/9L2An+BofwttS2kfl4C/gJ5AHjAX7PZADDQFgK3BMBAHgReAgAD\n    60PgJVNBA/elBB4QOGwDAuu2NQj8baCPFQJb6gEvAYH5OFofspJ00LJfKwhM/VpDYJpvCQR2x8IQ\n    mNpbIXBs/FRKaF4zmI5JNbCEwORLjiMD2Fydq6mBZRvuV6an5Mek4laCbakaLgfB7n06qcemn18E\n    GJY1CQ+z437gXgssh4LVwHweOZA2BUCkKqzEtpAKk2yqHakFdPXxLDV44+tIt9UC1DE7qPOnz+41\n    0D8FMH0oS32kypfGktCXgtVPDBxP128eCI+BX3fN5wpkHvyWY1M/Lb1zqOavnDsAnNgfRKxGHFc/\n    STt56xDX+lwHfEthby/IW+vz3OnvPBcO10BhaZdTWHkcg8FfI9fituedfZ+x2sAH5ZxWJ5iO873l\n    RQGwdE6CYO6L75t0nL6D+TXufRjMlcHcD1cU8+NHTNrGkMk9l4zGPwZ6p5S5lv0w9yGs1F4X+jzG\n    9rHWCt5cVbFl32vR/4w8/36Ne/3hKw5X/QfJ9IeP9NIG8Mah/dK98ve8q7Inalkz+L4XAr+k+pV1\n    e0Nw2WXKuHoKX2AOfiH88XOvbC5yX1hC9Uu+1kz5zMeLrf/J+wxMtiXlrwZ/ab65kDf0PWop+Et+\n    QrWFuVlTP3+DK77BVQW5W0j7LH0M+OtbT/jbu+YvMOBvyAb8vX/4C7QFwLnwF9gQAAYGBM61AYEH\n    BI7ZgMC6bQEClwJg+btmKQjM+4dgbYkKmPqtBYFTABhYPh207LcXCCzbaWuPp22OQ94edYH5WKGU\n    0K5fvRqYwKtUAwNzVS8fSwa7eRrog+gXWtNFjB8CwVrNQgmHMRvb+Zuuiwt2v4h1ypqE5P8ZfkA4\n    Vu9RMxn4lu0ugXmk/Mq2OSksQ3Nbw6zBeA4b88fwYWnMKP2y1Z/0mwqOE/A+qz79AC5Pr3l8C0by\n    dJfz9MakkLl4czorQUMKXPMgNg9yk19Z85f3PYn5yjH4ugFfcXSarfWg9/dUnFd2zwlfZ1XlK691\n    AZEpgb3Xin+YptaxplkgqtUOxv7VUPik3++sawmeC9QDlv5lCQM5tqa4leNeZj7iIPgF8weo+JXn\n    dXpJBcxhMNhxnn7ZB8Xw5kK/SwU0h6Gh9y8FdC37YWovPBp85fS3AM81VL98biXjHwz7plz7vK79\n    vE2otEGoDb/3ydICPN2zlg1DzuP5bZ/lZRT0kgS+ujek9tUUxRL84jaO1gdiPk4FTHOX8FcDyfxa\n    cRXxK3yAlqP6pfYW1S/erlEIIpOFlLlPCH9/SMFfRHyl4K9F9Zua773B3xBwvQf4S+25hQAwbxcD\n    tj3hL2Cv+9sT/lr8l8YyB/yN217hL6AD4KXgL/AYdX/JrAC4NfwF2gHgEvgLbAwAA+0gcGsADNgh\n    8FoAGLjvesDAgMDAgMBAu3rAwHIQGPBBcE8I/IsMXzUQGKhLB701CEzn9wSBLcA0FwK/Y75ja7dC\n    4NyU0FYIDKRTQvdUA9MaOYglk4D1LHxzEExqYnqdUtR+ZercEAiW/fxg9BwGE7g9s/MU5JvaHm99\n    JcTmiqZX+CosOs7f57BSVVd7+dfTZlYoHALJNWmic+YV951vOgCoM+ovUw1a/VJ65lBwm/vTIa0z\n    H4I64zV83bVwdQY1paxU+n6FrjTiyiUaW1NMaXWB+ZzJNEDM15sKXktz6S4xo0QWABwEvuxkLkyV\n    ayDzH/bJV99uGfC2MA1gWk3bo31QUeb7JH5JAWFu0bHO4XnzvjKbhga1XX3e+Tnux39wzv/+IfdH\n    vLXn35FsMNj55n7kPn6E9nCZWy9lQ9Cu8SuO0b3kIub2anjPNX98P6+xVvuSdS6le14KTFvgrbV9\n    7py0fTG2J2ggm+CvTD8tlbB0TKsFfH0DwC/w1cPUh9dXlSUX+INaUnVrBb80B7D+co+UD01hNoY/\n    vqwh/HTrkaf6pb5yb6OavltO+cyP8dfSV0r1q4054O+Av9x+k5jjgL9hG/A3bkvU/R3wt409KvwF\n    2gDgUvgLbBAAA20gcA8ADAwIrNnaELgHAAZsELgGAAMDAsfsHiCwBmqXgMA5qaCBdSFwqh4wMIfA\n    dIysFQQGXEBuT+mge0BgPmcObCWETY3xxNotlRKa+wqpgXl6thw1MAWgX9nvUs0rAWZImeQHsw/e\n    ay1IHaoPzMfmIFpXBfs+Zb1ESnF5hA5ieTD+woLpFJil1NHcjpAwOaxYkspfDSxQcDxmOWo3WYcx\n    1+/FMJ8lLJQSNBZ0nqf6nP+jIFXTNzZeTMmk+039o8QPRr7iMAvShdRSMlgt0zTzVJwU1KQgopY+\n    mo8lU10CYfAL1lZTyLpAsO5HzkemfrZAVV1Nzc6LBiGfr8AMVIXGO+Hq/f3EAK5lDaG0008NfORa\n    bqrm1NxT/TU7ZbTlRu9faOwZVD35fS3zCPk8n/32MRhMe9mTci5UWkHO6yu7V8/LGPiqYDmfF/Fg\n    VggGk89X+I8+yWvmMm5Mvuh+JtuHLX7ttcwZfH6a5byflr0jNp4FSi9hoZID1gdMuLrVYpaSDKfA\n    fI5iP5Pz4MfdwwRa/eHLrN91dh1C4NlPGS3nFlL71oFfmqEP9U7CP7+vnpjf+XW5CkjLlbjtVb98\n    PkulfKZjpfV++XhPmH8PAsrgr5zjI8BfbfwvkXNLw98fI+25tYC/OXV/a+Dvn5Xz5G/NtM/AY8Jf\n    K/gl+1QwxoC/5bYF+AssA4AH/O3+XpcBYGBAYKv9MnB8QOA2tlUI/CGz/YDAuu0ZAresB0ymAdsB\n    gcPnpZVCYJpzDQSW/nMhMB1PpYS21gXOgcD8Z4uU0PRaqoFlm1I1MF2XV++8P38egJYQmNpx31pa\n    af89DSuCzywwTephPoeQKlimm+bKYPL7zhvDV/2GoLI+v8neIQ4lZApMeS6m0q2p9RuDFi3hbu68\n    ypVMy4zDg7SxNM9amxOgBnlD7fX6hfM6hmccvFqF/nzD6hkZeJfpLWm9UvHEj0/r0gPAcg2aqjen\n    BiG/Fu9OaQArTas1TA1jwFeen+4z4bkBYZ/UNxfExtTMOQ9/tFIR56ZXjs0zR6Hr7x9Xk6+T0ka+\n    n9x30OdJv0fnXpev54PaVn4XkIpgCwh2pu9Hcs+TMDi0r8Vh8HREAuELDrfvV88gFeVB3bdkdg3t\n    2kK51v79MQ/4lqQIL1UHL7GvtUwhfYzcb2rWHntASoLl1EM7ZPS3/FU5pmfXmD8kJVXGPDvG1MP3\n    x0HsM4N0J/jpnvnDTbJ2rzY/vkdexU++T2rgl2fa4NfwCgnYXf/3gb1oTdUvHQvBX031y8fjc4nV\n    55VzyIW/mr8l4O8X0WcJ+BsrU1EDfznE3QP8lW1a1v3tBX+BtgB4Sfib6l9jPQHwHuAvsB4AfjT4\n    C6yn/r0H+AtsNvUzWTkABgYEttoWVMDAfULgJQAwMCBwzPYKgWOpoAEHgXMBMPe3BATW+lsg8Hes\n    bQsIzFM085/3AIEBpwYuhcDkzwqB6XhPCCzHeAq0sUBgzX+uGph8l6iB+TH++otoHwLBWl1eoB4E\n    Az6wlSDY+Z5DX4LDvLavpq4NKaXO3lhuTjKFNZkfWE/XFZSAOtQm5mOuUgpbS1VxbY3PpS2lliwJ\n    dKfSX1JqaLJYUI0Hkn0l7dRTm6OWAnM+xlUNGEL4lb5kAByYAnnz2oZzcC3BLw/mpmoDa9fjFPhg\n    pqDvWTTWPgN6Kk3NbP+olMH6ELgMma8ms/2N5aaZ7mE5c9VS4Vv8cxhhHVNTymptojD4pjz3LQcG\n    kxI4NmeZ1YPvWXLNIVWxHMMCg09KX+0hJ/76oOw7U5YO37T9y39PwtdDy6bxmtjvSh5msnw+9mK5\n    9wKLWjdkF2NbXe2qWUxhLTNb6GNqpQt4O5myWe53ZM9sdWfMlb7+POZqXyv45Xujlu5ZV/zO4W9I\n    9QvE97glVb9AWcpnC/jVfPNjMf/yGNAG/pLPWvj7VRyT/u8Z/gLAZcBfgPneMvwFymKWjwR/gXwA\n    vGf4C8wB8JLw96e4JlOyt7atw19gu3V/a5S/wE4AMDAgsNW2AIF/AeD3K0LgtVTALQAwkA+BPxSM\n    0QICrwGAY/5rATAZAdslITAwgeA1IbDWPwWBc1TAvH0KBFshMOB//kshcAwAA/0g8Hv2WkJg7TrU\n    QGAgrKIF7CmhcyEwb1uqBo6tQ1sDWSs1MPXl42mBcF0x5YLVB+hq4Nh4Gkj2r0kcBEsFMrV/Dz+I\n    LQPmqcA2+TvBB8I8aK7NSfoIpeiMBaiPSAewremcS5RqPMBeonxaI010TmpKra97/+rH0QJnITVU\n    TE2sB+CuypF5ak8KHruAt66GikFfwA+Yu/Tmc9AbqtsooS8/F4O+vL1W8zeZ2ln6U8iDBfqekYYp\n    oTrAsbahddSYA4XLW4+xNaVsyp6M7VJAOKYOPp/C91RTauGzr4wOzVfuiSfjOQlz5RjygSa+z8n+\n    k0mw7LeT878Gd42DckTfZ3KzXhwM73lqX2pRA9gyTg8r2f+0Grkhs2RW0Pzb5hYHvtr48r6s7ak8\n    JbQ8z2vYy/FCDybxMfnvX259L7NzqRq/fH/k9X5T4Jf7OIr2LcHvdFyDv/PsHVcx39KUz/xa5Kh+\n    Y/6lSfjL1dxkreDvs3LdrfCXoOe9wF8gP+0zvw4xI/gLoBkA/kYZNwZtB/ydbE/wFxjqX24D/rax\n    tVI/3wP8BTaf+hkA8LEFAAa2C4GtABjoD4G3kgp6aQi8lVTQe4HAe1YBx/y3gMC900HHADBwPxAY\n    CCuBU/2+4JDcMVJKYAlKayEwwdq9QeB3wm9LCMzbauu3pJ0mNXAIAtPvVphtUQPL8TQ1sOuXpwam\n    /iEIHFMD9wTBAEwwmHzJoPy8lrJ/7kXpQ21T6Z75eysBsjzO1xc6r70f3HL7S+NzK0mXKceMw+52\n    X9RjNXyt6zjDVut1Wld6/po6N2SvCsSVc+M1B3k7rmbi8+Pz0JRQKZWUnAtXLvG2vP9V6X+OnAut\n    9XbuND8m1zrrQ+fYwZbANxf21oDRErja8u8qZTn3Fj0dev61IEvBXrtKOH5eBcIn/5w2v9ADOFR7\n    2lLPWO6FEgRrwJfG1o6DKXRlimcJg+UapHJYX6cOb7XvUPLaWUBuKqNGaB4ho/u9dY94Cfit2Stj\n    c5uvP/4AkdVkmQGrWeoIh+6hqRTTsQeintk+dY3ew+N7S+iBKZqHnj3C37e+wH/I6gw/M0YK/Moa\n    v4APfoEwiLWCX80HN5numY7Fwe/kX9bkbZ3y+Un456aNp/nXwC+/3iHVL5AHf7V1kd9e8PcdXEro\n    vcBfTfkrj2uWSv1MkLY1/NXabBX+cp8D/ob9azbgr7Ne8BfwAfDS8BfAogB4wN8624P69+P043D9\n    7/AN/n0lFGoBgIEBgZewX7z9HBC4zEpSQQN5ILinChjoA4H5l6MBgX3bCwTmbfcIgf8c0UHUQGA6\n    thQEBhBV0aYgMPdZUxcYsEPgJVNC0zGLGpgf0/o7ywPBZ9V/HARL5Zas5euvd+o3r6U4V/PGVFxa\n    DWGI9nxeMYWvVA5LP/zcC5sfIu1Tx+RaS80a4LZADX2OeVYa/I7VJdUD0AcvTaTFv2V+NA9XU/AS\n    hGPfvJ2LQVCtXq8bxw9qT22uAuK4vn4w2/elBchDtYGlkkmDyqHrdxs8sF7ZVlP62lI71wPfFrA3\n    BUeXhLq9LAbtSuGwVnM+ZC2AcCsYzBdrqZPsj3tQ22iQmB/n586sL5VIALvX8f1bXuMT86Opc7X3\n    mR6UigHUFxy9+aX2nLlaOW6UXSN0n9ffg3K4m6sGtuzPeg1sm9U8fJFS9Mbq/Gp+AAe0zojD4dje\n    q9WbD82F9rXQPurU7XI+Phw7Y/4wU7ykQQvwO/U6ijmEyiro8NaW7lnrL2v98jXE4O9Sql8gDn8t\n    9X6BNPzV1MX8GKmJ9wZ/Y+AXyIe//DxX/fKfreAv/f6D6GvpB9wH/G0JfoHl4W+qf6kN+DtZCv4C\n    Q/3bwn4WWVtPAJwDf4H2APgB4S9AABjA3ULgHAAM9IXAv4ycWwoCPzIABgYEJtsaBC5JBQ0sD4FL\n    ADDZ7w0hEvIfAsEDAoftEFEB03nN7hECy/W+4pBdF5iOtUoJra2NLJTGea5utauBNX/u+DztNPef\n    Wx/YH0MHwRrI1d4rGTjn6alpLhpM1molunPud7IXuFTMND75ttgB6VTOqRSj0jQgLv2E+litpdrJ\n    cq2sNQ1r4BuAZBAsZ7zUnI8imKv1PcMPJMpguISxUoFExwn4Tn3IdDWuXNsJvjqZ12+9iuMQvmUQ\n    OaW+ZQ2Da1R9vZ3YA/CNgc4SyGsZv1V9YNvfapnFa6TnmRUKW1JGW9JF3/akk388dE1uaz27fTSn\n    Bq2/5+r7uZu3X2/ZfR/Qxzxh+u7Fywxc2DghIMzXqdWklw82hWohcx+pfekc+czk2LwkRL7Zs0y0\n    2++s1iJ7QMiHBlxjfi1zeYH9Xkjjy3IGct+UmRSusz0Nov11Bpf5Psr7Sn/O2oFfuoYW1W/bdM/O\n    v2vXTvVL16SF6pcfk/OQdYRT9X6t45TCXw38AmH4SzC1B/zlUDlkn5V+cmzt/IC/zkcJ/MWb/63D\n    XyAfAO8d/gJ5APhTgf8Bf8vtUdS/A/5OtmDqZzIHgIEBgcnWgMBDBdzGloDApQAYsEPg3qmggXXS\n    QbeuBwzsBwL/GPHLLQaBLQBY69sDAqfqAQMDAkuLQWD6HdBBaQwM0/FUSujSusBAnRq4JCU0vW5V\n    G9g/pvvnV477rgXB8r3gaictbaam9qK2UikloSnNU0vVrNX0lb+TnxcRxJ7DjDSkzUl7mkr/3Ko+\n    YavAu5xTLRizjZ/3j4TY2E5ZHVamSj8UGJNpl8+qf232c4WtHJvgslNtuXW/C4zF5yTnI1W8X29/\n    J9dgsFlTRoXsDAfCcDJC37eTS0DfUuAbgpc5oNeaXnWrFoN8FgvV1c19H2LzIbPVEDaqg0/6Obn2\n    r2d/r7dcmzN7yOhJOUc/32O6X4T2Q00ZHFqTA8AQrzVAHv4ORSb3Vglhuc+vbCwo/bj5iuSQCtW+\n    Dx6N7a2fx4th72z5IEir+0Us9XRq7ana53p/Dmjn++Wz2F/OEV8hOKs9MHUUx2kv09pqsJS35bD3\n    VZwP1fgtBb803m0fZWZN9zx/r8Lq5lz4qwHTlimf+TF5TWS7JeGvVfULrAN/LQ89Dvg7N+p7b/AX\n    cAB4wN+4WeHvp4oxagHwgL/L2SOqf1vBX2A3dX+5+QAYqIPArQAw0BYC7wEAAwMCtzALAAb2oQTe\n    az1gYP8Q+LcRbdsWITDQRgn8XaBtqG8NBKZzGmjltmcIrM2/VAmsHdsTBE6NQZZSAwNtQPCrGE9+\n    Lrg6qAYEUx+pcAJc4Pik9J+nqZ77ku+xXANvq6W7DKme+LlYCmltDtxi9YJD44UsBTdKAXFLRXAN\n    pC5NkxsCjprJ4JevHHJgVFoq0HYJ+JyvSU+d6Nf19dtZlLcy8A34QWItAK6tySmEKXjsnwPm9/Nb\n    oFyp96sC5nP4HPWPrbkH8K2BvUtCXkv9YmlPBX2slpOpgKz2QZZ2QNgAg0/hc3wu5/N8v5pSLV9n\n    fSh9M33mtGsmM3/IvUiuje/JKcUzMN8L+etQVhAyDfRa0h/H6gj7mQZ8+5r4vORm2dCs9jPZIsV7\n    aQYMy9jm7A0G/xflvDX9vdyPZButtrEsT8Db8D3uGhhHrv0V85q/oX1UA8itwS+dl9/HS9M9P83G\n    Kwe/dKwk5TP1rYG/oXHJcur9hsZ+DoBUK/x9ZgrcR1f+Ag6Ea7Yk/AV0ALwF+AsAP88unJO2JeAv\n    sF7d3wF/53ZvAHjA37DdI/wFFk/9TNYWAAMDAqfsl4nzS0PgNQEwsG8IfA9K4N4QuGc9YMBB4B4q\n    YACrKYG571IInAOAgTgE7qUEpnMxCKwFwCwQONSXn5emQWDuJxcC0zmrGpjmZVEC0/EfmIKYjqUg\n    cOwahFJCSyDbMyU0jSOhrQwyy/rAMi00lD5yHTzwpAXNS0CwnAt/Lev6cv8X0QZiXM3/SRkLon8o\n    oA7WImRSJRWrEazVINb8hfpb2mlWWrvX4qeFhdecp0aaz9fe31IPUqsXnJtWUwLQUI1EX+WbB3yp\n    Tw70lUHhFKgNrV0Fnqc4QH8991P5tqjhG1praN21kNemfF7HQurUEh/TGuNWqxLWHtSRVqMOPuMA\n    nPTrwT/z57MNhl9i42AOuGPZMGhtsv/FcP3l9eC15kM16uW+HPJt2fdiNYet1mLfS9Z7vs23z99q\n    Wcrq9H05ZHoNZXtbDd5a+sdqBSMwTuiBJZl6mY6dEc6SEUobHdtHe4JfPif+Hbw23XMM/JLPUvib\n    o/ql9qX1fjWFLrda+Nui3i/BX+14L/gLAN/j0gX+csDbG/4CDsbmwF/eL3QeiMNfwFb3txf87Zn6\n    eQn42wv8kn/Nloa/QDkAvjf4CywLgLcCf4F+ADgX/gLtAHBL+AtsX/37UT88B8DAdlTAQDsInAuA\n    gceAwABwemAIDNSB4L3UAwbWSwfdsx4w0A8CA2ElcG094AGB+0Pg92/9lobAL0r/mpTQKQhM51J1\n    gTWF8d7UwHRMBoZDauCpb74auBYEa0pk6fd06zEH2DKIzYPzh+jf2tyX1iem/JV+YgqolD/t7mlJ\n    IxmfW2q+7awVEA6nna4DwPNx0nVx5dp4vVxNicTVuSnTgnZ8TqEA+JSOWV8/PyaD2DIwrKV+Dl3j\n    FPQNKVu9YPLJzUsFwNE3tF7l2wv41sLe18J+ezHtgRxLH245dc2tQHgJdbBWK/iEKw443NTtqXFS\n    mSe+Yp6aOab+pfMlqaLp2mrzvIj9NKZWjlns4agLDt49GAjfq7XRa81apqFdLe5eZpufBerG2oYe\n    kEpnUIhnw0j5S9Ws16+I3o5DWjL58FQIMgPLgV85L2u6Z+rTCvzyOa9d7xcog7+l9X4BHf5qKZ/J\n    d0/4a0n9nIK/fG50fovwV/bl/bRzZGvCX/K/Rt3fXL8lqZ+XVv0CA/5qdo/w97zCv5n2ov4F2gDg\n    R4O/QCYABu4PAm8JAAPbSQUNAH/AAT9faKxPgbU9Yk3gDxltW0FgYHk1cAgC7yEVdK96wMB2ITAw\n    geDvYE8F/QUHr5ZwqA0Z33V4XeAtQ+BQOmjAgVUOdCUIblEXOKYE1o69KOMtkRKat+mhBub+LCC4\n    NC10TxAsfclrxOsh+rAhdHyylCJMS3Ut+4fgs2ZavWF5Xs4t1kba0dBnifTPljSfbj79LDdlZaif\n    DOjz9WnK3LNyLGYapLTU8JVridXz1dYUUpfGoGkK+gLz9MOnUwAsn23XhwcxtbSXoXn0SJWaguKa\n    tVbxPil+SlI+p8eRY7T73psLhq1K4VognILB03VwZoGaAHA+6VBUqoFDmSn4HFvD4NB5S5YKPnbu\n    9eSm1RjmSmN3TF9fao41JRVqrdd+2OL+Fq6fnO4bm0vsHnpBam+8znzFHrSJPURziuyjIfiqAWS+\n    X2oq4NDcNAWxBfzKdM+A/N49329z0j2HwK9cD1kO/E2BX+rbE/7W1vsl4LtH+Evt9wx/6fWAv+3s\n    T+z33nV/h/I3bnuu+QusC3+B5QHwo8FfYDupn1eGv0AMAAPlEPheADDwOBB4bRUwsC4EBh5HCQzc\n    HwQG+qaD3ioEjvXdMgSWu85eIDCfw3txbCsQmKeEfhb9tTXHUkLHxspJCU2/p9TA2nq4hUCwDDDz\n    dqG00HzuJSBYqm1zU0Nz/8AcBnOfZNx3qB6w9BsKnscC7+FU0Vr79L1EC3pzy4Ef1rG09VjGy7V4\n    zUnf5vUES/db+z8eNIjrf870uc3XeY0ej0Gpc+B3bhpQjKV2lue1OcYC5RboK32f4Wr9etczAH2t\n    QXxN+RdSA+q+7LCiRN1bq+iNBeG3btoekWs5YNgCheuBsH4stJ+QBcHwSVfIUm1gOh4qYyDnYq1J\n    z1/npoqm30Pvyynx2h8jfN0ssFirXyzvDfl7RdnnNbVH5ex3pab50e4/uWmprVkP/PXbxtKyb4RK\n    PKTWorWTtX9D14fmEQLMWimEU+D+rKVY5nPNBb98jJp0z1qd31fM4WCt6neJlM+Ari7eIvz9Ivzw\n    uVF7asdfQ/hYq+Yvnxudr4W/P0baheBvCvxqfS3wF5gD4AF/5zbgb9g+FY4x4G+dDfgbt3tS/y4F\n    f4EKAAwMCAysA4GXBsDAshAYWC4dNDAgsGYaBF6jJnAPCAy0BcG/jTzv3hsCS99bgMCh/luHwKH+\n    rSEwgBm8fc+Ol0Bgep1Kofyi9EvVBSYftWrgkF/5e2s1sFYfmMbgIFiqnWIgWPrn43CzKYKnGcl+\n    2hjSbyqF9Au7N2lB+Bh4kO1TtX5jCqgc1TBvz++suWDWAj4uybnWWUwJlQPNvHqagTlaA950TWSg\n    TwPAk6X9SpiaAyh5YO+CQ1TFoSmVQuokLb1zSGWsBdih+NHqKgIO/Kagb2xtMSCdspwavTSWDLJb\n    rBT2hoLttdYu9Wz777Y1cLgkjTS9n7kPtJTf78L9gvM/+XvU+eydCtZYzoHB0pfmR6sNLM/HoO0T\n    /L85iypaS6uvrc1yrUP36hexnpSF9hF+/Ur2KX2sNha717WuRczvm1bYO1lccWx5+EiOH9uH5b1V\n    AmeCvvycpuLVQHVM7cvntQb49Y/p4LeX6pe30zJU9Ej53LreL/8O2Av+ctC6FfirzSEEfz8H/KQA\n    8Nbhr+wbA8A94S8A/LxxXqR7SPtM/jUb8Hdu95j2GQB+C+BvNgKAe8JfYADgjcBfwAKAgTIIPACw\n    3QYE9m3NmsB7SAcN9K0L3BsCa2O0qgcM9IHA5HMtJXBpKmiyzzio/QYEdvaIEFirCxy6FhYIDCxT\n    G5jGSaWF5sdCIFgLSLcGwYAdBocC46dAO37sInBkrGbhK+IKZG0OT4nzcoxYG22OKQVarG+OtQTA\n    rUwGhXPmmBMU1wK8KRVsqJ19DnxtPgCeAuU+/NbmEavn2xL6ykD26bQO9A2px7T5c+NreV8IZZ+C\n    vg/VoDcFm5ZUCacAbA00pv0pdi31PnGfXxL3Yjnvutrq8Pxkq4MZDJYf4BIYHJp/KFU0+dJSUMv1\n    8PvQgd2PUmuXJQ60h2Q0s0D8nM9f7n6RuqZrWwnozb3PynvzOdJOmrzna21safJtD0Np87vi6qVz\n    Do2rQV/eTvaX7bmaeA3wS+2vyvcBeb9cQ/XL21jhr0X1Czwu/KW2e4O/3wSOPTL8ba3+LYW/QB4A\n    XgP+tgK/wIC/Fhvw19mAv3bbOvwFGgFgIB8CtwbAwIDAS9iS9YDJBgSe7ENG270rgeUYLVXAQD8l\n    cK900OSzlxIY0CGwBQADcQis+RkQeF0ITCZBrKUuMPnJTQnNjy2pBtbWnUoL7R9zr7lPza8cN6wi\n    8mGzhKvzoLH7TIbSZfI5npRj8lrywHcICJhrPUbgsPSvjam9zlmjZrVpnHsoAmssFiTWFdfOtMBe\n    TjA71h6Ig1Qyraatdo4fleujucn0lXLsWC3h3NTOci6sQ7Se7xahbwqung1tYmNN9wEbAJ7X2vX9\n    bu3vT1t/7MGX1DVw9335nh6ifV5F29R9LvfhnBZAuDRVdOwhoFhphND8Y1kqvgb2EVlGwR2n90n3\n    qY31ivgeaoWsqQevLO3597qj2idvf1nbSpX/qftuKgV+LL2yfJ1Wzubdc+W+J+cq76FatozUuOE5\n    6+mrZYroGPiVgBZIg1+ah7XOL7XJTffMx6bjJarfq5h/LvglH6GxyZ6FX22s0Hgc/uaAX8CHvwRN\n    HwH+8tdbgb/ABHG/Scxnq/CX/LaCv6Upn8kG/NXtU+EY9wZ/lwS/ZEunfgZ0AHzP8BdYHwBvDP7i\n    b3HtB4CBbaqAgTII3BsAk2kg+BGVwHtOBQ3cBwQG+tYElv73AIF7KoHvDQIfDX5DEJiO9YbAmo9W\n    EBjArC7wi1hLbwis1QWm45aU0KFrkaMGPqiB0zgIbqEGDqWFlu1yQbBWI1i7fnSUjxGCm1pAWgtE\n    yyC/DJyH0kXLAO9FfB7IV40SKAZufZVyWJ0WWodmOeqqLVgusLbV9LxW9eeWAxE1dVYs0G2v3xhT\n    7KI/9EUcssauTQ/ouzTwzVHfniLzns4jen5Ppt/TYmu133+eMtrXAuG9w+DYGuKposNrhrI3Wucb\n    ez8uBQ9NWa127+uxFy1ppfue5b7J+/N7cyxzRsyfzLQiTYO+GhRLQV9t/9Hu53xP4A9SafuQNiaU\n    PVVTH4fAL28Tq/NLY62R7hkIq361sWtSPs+v71z1+xXAdwb4W1vvl58LwV9Z75e3rYW/vN29wF9A\n    Vxla+pfA3x/E+Z51f+8R/hKYHWmf41YLf4F16/4+IvxdS/kLlAHgrcJf4MEAMPDYEHgpAAxsAwL/\n    AsDvHxgC1wJgYF8Q+K8j5wYE1n2uAYE1v98p/WNWA4F/lmg/IPD8WCkE5n24cRBMvkKqWcBPCc19\n    WiFw6HrkQOCYb/5aKpZT65IWAsGaMlaqgV3/+TFt/BAI1msjHmbntOAxBZ8ppSVZqJZgaJz5UR8E\n    h/3Y7/VW9TC3Mw4mhW8smK/9bu2/RYsH8+OWWxc2ZSG4O7c0PKW/DQrI8ZqWocC5nK9lLnuDviUq\n    X4vSjHxZgG8N7O0Jg5ZM/0yWC9+sVgqFc4Bw6n5dow5eEgaHrk8pDI7ZJdIntTd9xSGqTpartcyj\n    pO59zvpy+m8N9IYsZ99LlQaI9T0JAGmx/BrqYTBKv4d9xva68H1bpneWbVLgV85Tfg9uAX7lPK+o\n    T/csj5FfDfbKNv46bUpczUduymeCuM9Ir6tFymcOTDX4GwKse4G/nyO+esDfmtTPA/5ONuCv3XLg\n    L1AGgAf8rbctKH+XAL9kuQB4wN86+xg597fTfPIAMLB+KuhWABjYLgTeAgAGBgReCwJ/yGz/KBC4\n    BAADfSEwMIeu37/9vEcITCrgWPteEBjQQSs/LvvFbAkIzI9r4JbavxNtubWsCyz75qSE1ur6WlNC\n    Aw7OSnCrgeAaNTAfi7+WwfCWIBjQa+rKNjwozKFsTInFz2l1Di2pMyVADgXBXe3DufVQj6X8ptKl\n    2qx+72oJlOe1A8uM1/eLmUyvTBaCbakaweHaueH+8nxMyXsOXGhWUewAAIAASURBVBPreq+3dofo\n    WCXQd2sq39bANwXkS60E7JamgLVYSYaAVqDYen/j41rabU0d3BoGUy/n/wpr+uV5OYK4cjj0wFVq\n    njFAnVPjN+Qn/jCK5frFTf69lzzkFbOSur6+2frH7jehfaT0fnPM2C+1NtfAfMiv3HNC+68l+4ZF\n    7SvnJCGvHN//XuysJfjVfIfe45aq39DYsXE0s6R8Bnz4S6pf6XMN+BtT/crj/PwW4C8dr4W/AHAR\n    bUKAdgvwFwgDYOpbA38BHQBvDf4C2wHAA/5OtiX4CywPgLcAf4HlAPBa8Bd4vNTPZB8Dx//WzWd/\n    ABgYEHhJWxoCL1UPGBgQWNrWATBvn2uPAIEBB2eXgMCxtq0hMOCCUfcKgYFlUkK/oAwC0zGtLq5V\n    DQzoaaGtauDUWHIczbe1PjD5yAXBgB8YC9XH5UFmqyoYik8kjmvB5FBgmsZ6J17rZoMSWoAwVB90\n    8mrfayxq4hbgpmVK6RRUOyEvGB1T/fC5z2uvlqcG1mrw8vq81vWGUjdr64id01S+ZxyitYL9Huun\n    dm6p8i0BvrWwtwQwx6yXMtc6VzIrpC21XKXwk7GdtW67RR3cO1W0njUjNacrENh/Y9cnlno6Vz2r\n    PZAlaxDz+eWCfHnPjtWTzvkMukwgcSt9OCnsry4YFvu7taRjlu3pHh2q8a19T6l5wAlszK/iNV8D\n    ALzDJbn2HOgrx6Jzsfq+/PtabI+01PglP9o1DNX51dI954JfeUwDv9rrK65BoG2Fv6GxLCmfpeo3\n    Noda+KuBX+nLCn9jimBt7UvA39Bnd6/wF3Cg9YfA+QF/J9s6/AX2A4BbwF9gPQA84K+zR4C/wGMC\n    4I+B43/rzyUfAAPrQ+CWABgYEDhla9cDBvpA4C0DYGCkgk61z7XWEDgGgAEHgYF8EPxjwnfMZw4E\n    1sDsHiAwoEPYLUFg8q0dJ58SvC5VF7g0JTT5WksNDKVfaVpoGXTuAYKlaX0p4CtBMIDmMFibX6zu\n    cKiOoTVYXgJOrQAk1bZ18No6P7ufsPkpIP30ySlf6bqwDibMUyqmgXJqjFLgy/3mK4tJOWS/FiHg\n    mlIOx6wU+i6l8m0BfC3qupClINUWU0Cn5tQmS4FvOWpOC1hsqQ5uCYPnD6XEr5umUnafY7ui2LKH\n    lADh2JihecjP18G71tZ7eayNP9cz0p+XVntnLxW/de/MuR/aLd4ntMfp6luZDSSdpcMCfcPjzfcT\n    Aq3a8dQ1WhL8hq5HKLVzSPWbm+6Zt7GCX6oXXKL6pWMl8DcEOnPhr4TIA/7a4C+d2zr8lb9bzQJ/\n    gTYAeMDfPBvq37Stnfp5K/AX2Gbd3wF/29jHwPFVADDQFgK3BsDAgMApWxsCP6IKGBgQONU+1wYE\n    nlsNBA711/x8weHWJ2ZbgMDSTwwCU/9Q3xQEBux1ga0QGMirC0y+c1NCS7/kW44ZUwPH5kmvQ4rh\n    mrTQdGxpEExjSjUsB8GyrTVFdFsYDGhBdS14nlOPNwwxy4PSa9b8bakOTgVbY0DJWtfQjaWlwfTb\n    WwLkljrFljTMGniO9dOCwU/QITJdt2tiPbHU1GT8s1ZTz3cJlW8N8C0BvU+N/KxlJTA3tD7rPddi\n    SwPhljCY/kYsdd0188tB+NfwfPuu468/dJ1CDyUtAYSlf3mv9eeY5zs2r9i+0XLvmua43t9zaP9L\n    q5zt+6Zlj41BXHlfT2WCsMzRmuKZ2kpAe4YGXMN7pVaHVx5vBX55W2kxOPqkvAcnAX9DwLhG9Uvn\n    tGsXg78c/CLgU5tDCNhy2zr8pZ/3AH+pbQn81cbSbA34y30uAX8BB4AH/E1bDvz9VDFOLQDeEvwF\n    lgXAP8UVv1lstMkeGf4CbQFwLvwFNq3+BUoBMHCfEBjIA8FLQOBfBo4vDYHXTgXdCwADy0DgUgAM\n    DAgca1tiBG17pIIGfOj6vWhbA4G11zF/NRDYAoDJvsWAwNQ/1DcEgVN1ga0QWPqi1yk1MG9LvnNS\n    Qi+lBqbf7wkEh65pDASnfFhBgSVVtN7uYGqfCoTH6i5a5xuyHPXSmuCYLEf1KAOp8/Sx+vWIAYWW\n    sBewAV9tzTw4rsGRqxe89a9drM7iCVfVX+i60BosxgPGXNEozQJ9U8qytYDvSQ1Kl/fdu1nvna/G\n    vqH+McsBwraU+um9In6/vyb9cIvB4NBDKam1ynlyWKxB6zPrJ++jljTbFiAs55+aewgKh66N5n+u\n    PLXvcT3Trlsst0Zwzj0uN2tFCewl00oShOaRe++M3eM14KXtuZril46H5rMV8AvY0z3za1Jb6zc0\n    Hj+nwWftfWmp+s1J+QzUw99Qvd/QObn+d8rvreAvP7YG/LWA35CvXvBXwt6tK3+BevgL5AHgXvCX\n    /Gv2aPAX2BYAvnf4C6yX+nnA38kGABZ2bxAY6A+CBwSebEBgm90TBO6hAgYGBNasFgJrNYU1X3uD\n    wNxXDwjM/VohMNBPDRxLCf1OOdZSDRyCzPL3VFpobTw5VmgOtSA45V8zDfBqqaHl+NJCMFjWKjyz\n    8/T5ylWEnRCHA9pcS8BwqF9r9VJPS6ub+/1DQYef8/Esaqez9/shCl7JhwQyvE1OnV8wPzUgNWSx\n    gL+mKJLz5NfDAvVbqHxLgW9L2NvysxtSX7U06z25xFKpjK1QuBcQttWhTd9X56UK5qmc52vX/ZY+\n    hBNTMVsVzFa/5OdrYi+b1yhOq6RTa5D7do6djH0se+meHuaw7G+ADThbH5Di+9KZHUOiv1/31/Xn\n    +zZ/iEn2CYEuDTTXgl9+T9Yeatob+KV2a6p+6VgK/krVL1BW7xdIw98cde8XhMGvvAZLwd/3uKr9\n    cuDvj6Ld1uEvMAfALeEvMAfAe4a/vZW/fAxpjwZ/LeAXuE/175bgL9AfAN8b/AXuUv0LrAGAge1D\n    4K0BYGAbqaB/8fZzKQi8VC1gsgGB57YGBAamL2l7gsAxAAy0SwUdOpaCwBYATG05rLVC4G9Z++8i\n    7cjfI0Hg0DkrBAbqUkJzn346xXYpoVO+Y8c1tWxI6ctfS+WxpfaxtB4gWB7X5hIL8MsgPQWkQ5+7\n    UCA8FljnfUKKoZzgOm9rU5zZ1cK569mjWQP1FtMCynQ8VkM4lc54mif35wPPCw7JgHoqMF+aMrkW\n    +mp1MrXAtmWeMXAZg6d0Pa0q31rgm4K9LUGv5dps1V6V+12uxcFouC23nPHd59iWLlp+Dq3jxq6N\n    XLPcH/2/NWflWRni+4MlDXLJg0Y033e4qgA4lIran7l9zSkI/YgWe5jGqiq21o7ndhX7K5AHfUMZ\n    PVIPB8VSPEsLgd8StS8/x9W+fBzZrxf4peMW8ItIu6VUv0A45TOHv6F5StBbAn8lbKX+IUgLtIG/\n    so2l3i+wnvLXCn+pZu+jw19gX3V/Hw3+AuUAeO/wF3g89e+Av+1sL+rfj5FzdwuAgceAwEMF7GxA\n    YJu1gsBAGAQPCDz3RRaDwEAeCH5UCPyFjW2BwNrrUgis9aXXGmzmbVpCYOpTC4HpeAqu8vEJAmtz\n    iqWE1vzW1gbW2uWC4Fha6NA8LCAYop01PbQ8p43Nr3js2tN4KRh8UvqEzFITU7bRxs8JcOcohrX1\n    peatWWkgvRbcngQ0sF8j30eOWQPiFtDIx/7CQNI8NSxUX6Upky3q2dT6U4CbzyNWE3E6b1PAhK7h\n    K+KK6tD1C5kF+MZAZMm13TPkLbUaOByCwq1Vwql7G33uUurgGETl10KzA+Y172NrozkvrQ6W8zlF\n    z7l73RPiwFf6s97zc9dfsne2slj66lB7P6NE7nj+fSZHzRvyETPtPq75q6l5HsroEMvGEfJ5Zfvc\n    yQDIgPw0z3SuN/jlc6HjGuANHZc+Q7V+c8Bv6Fo+M6UtP1aS8lmme6b+rer9yjW0gr/83J7hb0z1\n    Wwt/v8E1CnS5fZtom4K/oWMxG/C33Ab8nWzNlM9ka8NfAIsC4AF/21kp/AWWBcAfI+f+NjyPcgAM\n    DAgsbUDgPrYkBLYAYGBAYG5rp4OuAcCAD25rQfCAwK79khD4Cw7euVYQOJR++SsOzSCwnF8rCEw+\n    atXAsZTQ2rXmx2prA2v+tUDzXkBwaoyQlcJgAIsBYX2e+hjyOuWYBTjX1vZdS1l1xqEqSM0tBR7l\n    GCmYbaldqAFgv9ZmGfClFZUYD56noK9F9WpJCRrzCUwBRmua6JT/0BjamJPPQxXsfUV7yJuTOrul\n    WWq9ltpr5v1NU97SdfliuO+m/JFZ7m10H39Vjqf883MpRe0SMHiy9FxjQFircRwDvtbrxNf3NWN9\n    OQ9UxeZxQvn+0sJqHp5KlShA4dpC+2bIdyvgK8eogb70io8Tm2cqzTMfk6v59XlczeA3dP0sdXDl\n    ulPgl9qF5rGU6peOxeBvC9UvUA5/vwgf0rYAf6+J19JXD/hLfSw24K9uLcAvWQoA94a/vcEvcF/w\n    F7hf5S+wvPp3LfgL5AHgAX/b2EdDm24AGBgQmNtaqaCB5SHwaeHxtgiBgfVA8IeMtnuGwIADvP8Q\n    GWPLEBgI1wQe6aC3D4FDfXtCYA6ftZTQoYDmllJCl6qBZXurGpiO1dYHpjG1MUIgWHs/rCA4NE7I\n    5te6HwyWc0bm+XmtSJuVBLhT84qBhxyzriEW3A6plXIhRw7kdfPXg8EyTSsPmOXUjA2pk3vUyA1Z\n    ico3tZ7YXFJ1iTkIn17b4McEW+Mpp0NzT6lKXbs4lK+xtcBuD7PVz7X50ew14Tv0flrUwaUZEdxn\n    NL0HpBS1lr0lNe8WqaKt5QKevPZ6iuyc/ZKv7YuyF70qbUs+b7l7Z8lelPOAVAnkjd3bWgDrdB15\n    f/7W+1gN8AXWg76Avb6vNhf+UJBUG/cGv9rxXume6bgF/j6z9jLls2WutfCXPgsa/JVzbQV/Qymf\n    6VgP+PsZYbj7aPCX+sRep2zA3zIb8NfZgL+TnRcc82eRse5d/bsl+As8EAAG6iAwsO2awHtRAQMD\n    Are0AYHDtmY66F6poIF2EPgvgetA4PV75VxLJXDKlxUCc3hLsDYHAvO2KRDcEgLz8y0gMBBWA/8R\n    BxwrIDD5Ds2PxtXUwC8K2ATyU0K/gw91UymhgeVrAwN1aaGB9iCYr8sFanUQ7OavHw+tJ08V7I9f\n    AoOBZYAw+S4FKiXq4VYqvyXVwaUKqRzwFgpKn8QxUgnH5len8G2jCNsq9I35CfUHdECkzS0ECK1q\n    3RwoYl1HK3Whlno3t1+L+bSoz6v5tPbX9gZLDWH52ahZR+q+nVqPJT2zNpde6mBLiuzYtUkB4a/K\n    fqvfY9NraKFYXzq7RYva9iVZCkr/1uV9O+fhJ0ublMqX2sT894S+fN6xNM90PAR+pc+nxHeSHnV+\n    Y+meU2NKvyWqX8Ce8jkX/HLf3HLq/VJ7sj3B3xTcLYG/KfALPCb81fwM+OvsXuBvLfgFBvwFgN8C\n    +JuFx3zU1M+PCn+BNAD+2/hc7g8AA48LgZcGwH/AAT9fdMRtQuBaAAwMCGyxpSEwUA6Ce0LgHxO+\n    rb4sSgECt6VK4BwIfDT43SoE/iZyPXtBYNfPlhJaQlx5fEtqYH5cD3q3A8EhKM1NA8FaimoKzIbS\n    f/ZSBUsYLIPssb/13kA41E5bT25A3DpuCki0sDRI6JNuM0ddmVIghdqFbEq9GJ5TLfCVAXL+WVwj\n    tbOlnm8p9C0FCuSP3odQTUUJAUs+i08ssF1jFij96v1+yOqr9eN9LaAzpci12HOBn/CDQb7x8gOv\n    sAFK1y98nrdLWQsYTH5i886BwUD4PiHPhdaUmm/s+lj2E0ud4Bx/fD6WWuI5ZlFMt4C809rD97eW\n    a0rVt7fsF5b5WxS+vJ11/fy7RAr6auupUftOpiuye4Pfmjq/vF0v1S+wTMpnIKT8nat+ya8GYa3w\n    N1YLmOYfOjfgr/+7BQCn4C/gw9ratM8aTP5zxM+Av862Bn8/FY5xD/D3d8qxe1f+Auupf3PhL9AW\n    AA/4G7dFADBw3xA4FwADfSHwI6uAySQIHhDYZvcOgWsBMFkLNfC9QmArAAa2A4G/Ef1aQ2DyGYPA\n    1F87Ls/lQmBNDVxSF5irgTUILNs+i2N87BQcjoFXa1roWBt+zFIfOHacj6vNRa4tVK9Xno8F41vB\n    YDl+TVAemAfQe0Ph0FgtAXELq1EB6mtNp2AOrcUKerW2oTFrAKVlHkA4QK750eoNh+Yfmldu4F1b\n    bwuVLzC/F6Tm5fqlr9kL/GBkiTI8x7Q57TUNdGnK5pjlqD2t7S2ZI0rhZAsYDJQ/iGRNFc3vCVal\n    aw0QDl2v3PmnfMWuyfxerwPg3M9TjrX6224FeSUstc4/Z/yUuhcoB76ADhf5vpd6GKlG7Rue21U9\n    FwK/sc9FT/CrzSU2bkvwC9hTPj+/qXW1tiUpn0OqXwlhcwDvgL/OvsG1O/y1lHVJwd/Y8Zgvsj8n\n    fNRA25bwF4iD3X+6EvwF2gHgAX9t9qjwF9gPAB7wt419NLT52/R82gFgYEBgbo8CgIEBgckGBHbW\n    GwL3rAdMRgB3q+mgW0DgHxGv00s2ILCzFATOrf0bO6fVBc6BwEB+SmjArgYuSQltVeC2TAvNx10S\n    BAPx9NB0vlQVLM9rdkiMbwnKA3VAWPoKWW3tytg8cny1DJBba7jmr28OeTUQEusTmkssMM2D3O9u\n    41C/cFvNUsA3FLTm8+Rr5ultY9B3C6mdp/X1gb4vhjZyzNzPY47/2PXYuuU+2FEChnPrC78G9vrQ\n    PFqqg+3Xow8M9s9fvWvH7wehOcfeH0sq6dA9jo5/Tcydzz80x1hbeW/X4Evt/hXKXtLyb7hUVTvN\n    pe24JbV9rbCXt02t+ZrYs1J7Uy70ndrEoW8ozTPPBtEL/NI1SYFf3r9FumcaV7Peql8gF/6Wq355\n    v1z4S+mge8Pf97je2gz4ex/wtwX4BQb85fapYpy91/wd8Fe3AX9t9oDwF2gNgIFtQeB7VgED20kF\n    DawDge8xHXQpAAYGBJbnW9heITA/1xoCAxOo3RMEpjZrQ2A6XwuBgTlwzYXA5KNUDSxTQrtzNjVw\n    q7TQQD4IlsHnUhDMx+avqQ8/bkkP7fzNj3PfobXFgvO05lQNxlSAPxWcB/RAekswnNO3xFr6za25\n    aIWvlv7n2ec8bzw+poS92tqWAL6x9UwB4IPnywItekLf1PVdA/haAo3cnhLXfQmrST2dgqU9LFbb\n    3dLXeg+y7FG83R5TRcux+N94CnTHYGvqPWkBhAEbFE7N1Y13jbZPzS+n77xPO+tRDiHmtybrgbbu\n    nsCXfJzYHmZdV+xeba3tS7PTrksJ+A1BUDoXU9nuId0zEFf9yrFbpnzWIGttymc6H4K7A/7GjfwO\n    +OtsafjbC/wCA/5KswDgAX/b217gL7BdALwn+AtU1/3l1h4AAwMCc3skCPwLAL9feNwBgX37kNG2\n    FQT+68i5AYF9H9JiEBiwgeABgSfLgcD8eE8ITO2086UQmI+9ZEpoQA+YtqoNLP2XpIXWfGrzptdr\n    gmC6Kpr1hMF+sD3+N5YDhIF6KFwDXq3KtFq4m9M/Df/IZ56l/JYCOgl7+bFc2Et2TMBTUvGF5h2D\n    viHoaUnpqSlv/c9yG+hbovJtCXxz1b0pCF9rLWoIL2E9oHENFLaU6yCfPdTBlvOtUkVbShRYUnNb\n    Mkrwe4/cy+TDLiVAGKiDwiXXKLRWy7xT97yW+1+Lvi0zaeSCXt7HMt8U5OEgszX0ndqVqX3l3OU+\n    tSfwGzu3F9Xvy1vbpeEvVwT3hL8EcT+Ldin4G2tDtgT85b4t8PcHpMFtK/j7l8Dxe0r73BP+AqPu\n    L7cBfx8L/gLrAuABf+O2OgAG7hMCbxEAAwMCbw0Cj1TQznoC4NQYe6gHDEzw9ftI33uGwNIft3uC\n    wNRWno9BYNknBIGBejVwKiV0KzUwsExaaM2n1rYUBGvntPH5a22cHFXw1G5+To6RA4MPwocFSFhA\n    hEUlTBYOqi///YVb6Jp9aTgv+b6G0kVrVhP41tI48+OnRJ+QUbDcWnOYr5tep+BprL5sTWpny7xj\n    aVBLoG8PlW8O8O0Fe0sgb25K6ZZWkra5FSC2pieW1gMIL50q2rI/WFJFW+s0a/PW7sGxdcm594DC\n    1msTstyHoV6B6EM4pcYf7mntu9RCwNZSf95/ICD9EFaqjQSooXv3a6Sv1iYH+k6Wr/YNzQtYF/zy\n    8a3gt5XqtwT+xpTDLeBvKOWzdo7Oh45/eRtDA0fUJwV/LapfapcDf7ei/O0Jf2PtHgX+AmEA/P0C\n    3yHvBf4Cy6R+XhL+AssD4DXgL6AD4N7gFxjqX7Kdw1+gJwAG6iDwFgEwsC8IvAYABpaHwJ8CY+0Z\n    Ag8VsM1+gunL4N4hMBBPo26Bt6nzOSA5BYLvCQLTuV4Q+DNwW0MtBA6d09TAS6WE1tr6Y5RBYDlO\n    q7TQWtslQDA/FlMFt4TB2lq1NnRM+rEACWv6TqtSmIwC65Yg/FYsVX92+fk400DvNNd5HwqGp+BG\n    St0rr4U1RbIPR+bnbUHtNtA3NO+U1aZ2zlH5WlM6twS+Vsi7JthtbVZAWwuHc6GwNWV0C3VwCgan\n    1lRzP0/tNaHMGc4OiYdc4ntl6hpbVMJ0b9W+A4Xuy63AcEvb2l43zSlufK6WFM4568u5B0tY2wP6\n    0vnYPsT98XbXwD5hre+rzbUW/PK2NemeLeD3GVcVvpaofrmvFimfAb3eLwAz/C2t9/sZCMLfVimf\n    qd3S8FfC2keBv8AEgGM+SsHt0vD3J+hX85fGCNmjpX62wF+gDwAe8Hcd+AsM9S9wF/AX6A2AgfuD\n    wFsFwMCAwNJGKmi7tQDBa0Hg1BgDArvzrSCwPJcDgb9lfWI+ue89QGBAB8Gf347HILB2PHbOmhKa\n    +tWmhKbj1M+qBqb2vdNC83M9QDCQB6ilxVTBtSmiJ79Q+5fCYC3QbgXCof6xttxkgDsVUC9J6bxE\n    EL2kXiJPO2qdoxzHCnrpvEX5lLOuFDSNAd9YGw58Y9DJErAvhb45sIPXJ22d2tmq8m0FfFOwtwby\n    bikldCm4tdwXa6DwWkDYkio6ZTGoWvtwT6wu8ZfE3FP7jqXmsQUI59gFh2T2hRAYzhnvzNqW7lM9\n    rWxO6XuQ3OtKQC9ge7AIiCtlr5E9TvOhnQ9B39B6JPTl7UrVvkAavG4B/Grneqp+Y+CX/FhVvzSz\n    0pTPQBn8XTrlM7W7d/hL563gNtUuJ320tAF/bbY1+AuM1M/cBvztbwP+bhP+AhsFwMA2IPAjqICB\n    AYGl7VkFDOwPAgPrpIPmX/60cfYCgWvTQd8zBP4W6fSrLSAw0D4lNFcBa1C3JwSmc61TQtPrWjWw\n    rDNMxoPTcoy1QbCcQykI5sfkePPgch0MlmNp69baxFJw9oLC2vrIclJvhiwWRK+xEHzV1pGal+Zj\n    anP12p0TPqhNDui1BH2l9QK+ofO8XQ2AzFEo56akTl0L6/VdCvi2Br09wXEP6wFyYz5LoXAuELam\n    i7bUzNXaheaSmyq6pj77K+zq4Nh5shKFsMVy9kyyQ3Dv903uC7Y12Yzfu6SfFntobO8sMQ3k5aqV\n    raCXLKWQlf5yVb5yDbXQV16nlmpf7Tgfryf4ledknxrwS8dj4Je3r1X9rlnvl46vAX9jYDcH/r5/\n    g7mPCn/Jj2YD/tpswF/fHh3+/hRX/GbREScL1f3daupn4L4A8B3BX2ApAAyUQ+AtqoCB7ULgLdUD\n    BuKKxh42ILCzD5ntl6gJDPRXA/cEwGQEce8VAksfITDbAwLHxjvgsFsITMZrA69RFxhAlRpYg8CA\n    XQ08mU0NLI/HQLAlXTTQFwTH5iHNmiL6rMwpFcQO1fPLVQfzdhZV2VPCV8isgCK0FiuoqAmAW8ym\n    WgvPt0U6zVxFbyrQG5qb1ueMQzHw5T5bAN/Ymt4HAsup+fFrFhuvNi219DeHAofZ8dbA1wpnXyr7\n    781aAN3WUDgEhN2DHPlKXmu65ZDPEhjMfcW+59nWYMscUQuEtb/lXKhdum+SYrhmD4vtRaVZKEos\n    Nhb3b71n91D0csvZN6ldLfCd2tv2SQTOnXCNQt/QPMnuDfzy8bTrJ8Hv9LOt6leOQ/OltrUpn7Vz\n    dL5E9auNHbK14W8sNXtr+Kv51I4P+JtvGuB9xJq/wOPCX2B9ADzgr922CH+BMgB8Z/AXWBIAA2UQ\n    eKsAGBgQ2GpLQuAlATCwHAQGykDwh8z2AwLbrScErkkFDdw/BAbiAcISCMx/LgGB+U8JdXvWBQba\n    p4Sm1xY1sOuTBr5ksbTQQDkIDoHHrYBgPuY5MHaO6qlGHfwU+N0a4M4NbnP/qYC/VTkWCzLXKIpz\n    oWvpWDmBarnWHFWvVamqg0mZZvNQBXypXQooxtaV8l8CfK3zz0kX2kJxHVtTaF+2wNolQW9tfWKL\n    laY0js97fn0tQDd2b9SUS9YHcazXIXVvroXBco1WGGw5b1mrdZ+M+ZP3saebXw7TbPO07lchMCxT\n    QocAbGnWDWC5Pc0ylgUwW/aQkgesSvdN3j5V9z328JBF5essDH3lNZBlCVLrWwL8UhrqWJaN0Fix\n    dM8hCBhT/X5Vju9F9QvEUz7T+VCfC65RWLR3+KtBWtpnrQC4FP4CtpTNe4a/LcEvsA78XUL1Cwz4\n    m2MD/vr2CPAXGOrfkFXAX+DRADAwIPAaEHjtVNA9ATCwXE1gYBk1cEsIDKyTEjo0Ri8IDOSD4Jp6\n    wEC9EhhAsrZuDQTmP2O2FQhM7VrWBa6BwPJY6twjqIFr6wPL4xRc6wmCU/PkFqsVTMHcePA4fC5H\n    HSzHluvQ6gOH/MSsBgzH1madxxK1gNNzb2ukOLIG/nPSElvSHUt/HJxYwV4LlW8u9LWkdrb6t8OG\n    PJVa7nxyUkyX9Msx6fObyNqXqAscuw9/NtwLa63mnimtFpDytrUw2Laeg4Bief2XAMKuNur8WGgO\n    FiV0rH1uCuyalNnStrAXTmuyzNUHrS0yZ+SWPUjdM2N13y1pnXm72ANUsX2KvgtoYLqn2pePaQG/\n    gK76DdXz7VHnl84A66p+yY9V9UvHuOXW++XHPr/9DP0btyX8/SzatoK/F9jr/QJ94a88tzb8BeL1\n    S0vgbS/VLzDgL7dPBWO0AL+ADf4CywLgR6j7uzf42xL8AkP9G7JK+AssDYCB9SFwawAMDAhssbVT\n    QQ8I/FgQ+B/ZmHuGwH8F4IcKNXBrCJxbE5j/jFkMAofGbQWBtXZLQeA/4oBv0BcC8+Mcwr4Xr3lA\n    fHk1MLAFENwiNTQ/X6oKlnPSYEENDJZ+pnH083I+2nq0c7XB7dK0mDnj1c4RaBN8zllDLkzV5vlk\n    6G+tbZsCoZZrZIXgNcBXa2OBvi+J85r/EIBvqfLNAb6W9yh1HSzGr9Vz5BxgC2L68yz/rpi7Hvm9\n    KbaW0jq+r4b7K7ecerytgHBqD0mNJddp2VtbwmDreue118Ow16okjrVNfZb5/blkT3qK9F16v4pZ\n    6UMrpWsoqW0vxwv1DQFfy56Zo/K1Ql9t3rnQV1tPS/CbSkUt51MLfuWYZL1Uv9pxfk5e1xT4BdC8\n    3q9M+fwZ+r9tQ+NrFoK/IdUv0Ab+0nntPQ4B2py0zwR9twx/Y+D3O1w9WKtZLsAd8LfM9gJ/reAX\n    GPC3ta0Jf4F8ANwa/gKPB4A/Gto0gL8AcLj+5/gGv15saesDYGBAYGBA4B52bxAYaAeCl04HTV/U\n    NAjcGgAD24XAFgD8Twzt9gyB+fkcCMx/9oLA9I9trgbuUReYn9uCGpif98eyp4XWjteCYKCsRnBI\n    FWUBwdp5aU/Q1VlWGFySAjMFhHlbbW2h8VpA1/lc2yqneij+UqYFmVsA6bPaxh0/4Rp4H9O+Q+1b\n    AV8K5JXWTC5V+b4kzsv5xSwFBJ4i51JrbQF8S2AvXR8ZjGwBRvdgsXX+GLjnp+zVeH8lswLhnHvd\n    a8JXC3Xwa+L69ALCdJ9rlRkiVUM4Nh+tD//+GUrrrIHqXJPK5lI/tVaS0SBktbXQQ+Plwt5Qn7q0\n    zuXQl+b4argupWpfmp8GfnPUvrL9EnV+CfwCuupX2hqqXwv4ledz4C8dS9X71eYg7XOkf0j1C7SD\n    vz9CzywSg7+AXfn7ARezb3luwN984wCYwCwXd7S2LcLfT4VjLAl/e4JfYH34CywPgH8WGW+L6t8B\n    f9vYx8T5RvAXWAMAAwMCc3skCLw0ACbjIHhA4AGBgX1CYCAMgpeGwMDy6aBD/ntBYGrbCgID69UF\n    1uawpBoYsKeFflaO0zntuAZr1wLBQD9VsKzBWwqDaZYxswBh2W7e3hYg19aXGqPGYmlOc1R2QL6y\n    spdZgWpOUN0SlLa2zZlf7XXrqfLtkdo5NI/UXGJrzl1/aj4h0FsKeXnAfmtGaypVHGvX5kfjPV5a\n    jkrYep/MffhIM2uq6NSce8Ngyzpa1I+Xc2nxPuW2XzKFc8n6ch8oys2WYLGaNPm8bUxJq43RGviS\n    jxj05eOF1pja96xqX9lm6+AX0FW/lnTPQFrda4G//kNEPvzNUf3y87kpn+l4Cv6Wqn6pP4e/st0e\n    4G9v5e+3uEbhrcXPo8BfoA8Avif4C9xHzV9gwF9pA/6W29YB8EdDm+YAGMDDqYCBbUDgNQEw8BgQ\n    +JMyZk8QbIHALQAwMCBwyvYCga0AGChTA98TBI4pgQFbSuhcCEw/ayAwsI26wPy4hMDyWCkI5j5y\n    00JT+xAILkkLLdciz6dAcGpc7XWuKjg2J2lP4mcIBsfmzcfMUTHFFGMhIGwZI2Utg+q5fpYIrqfA\n    YwsrUYyWtG0JfHPTfeaqfGNtyF9qDjmw4iXhx9I2B+Ja22qwtxT0PjFl1T3aM/IAsaYYLoHCOWNq\n    bS0PM+XOaTJbqmgLDM6ZZ+6eYlFDtwSuOfuSVSks+1jvj9Zr38tCe0KrlNSxOrm1RkA2Ve8e0B+Y\n    aw18NZ8alNbWXpPimXy2qO8r25eAXzqXU+c3pvpdAvzy9aRUv0B9yudQH0r3HANFrer9fg60q4W/\n    dK43/M3xLY+n4O/FeP8L+UmBXwAD/iZswN+5Dfg72YC/cRvwt519TJxvCH+BPQFgYEDgGtuKChgY\n    EJhsTRUwMCAwMCBwqG+s7YDAPqTV2sXMWheYj/E+8JqbVQ2sQeUtqIHlPGK1gaej+wbBvE0pDH5S\n    fo/BYEuA2wprrSpheQ202sutrdTvmb1nFgulT7ZYy1SVIb9yHZZge6gWnz4XGsc+91rga027qZk1\n    tfPWoG/OwwF83jGIxwPn/B5sBX9bgbx++td1sgyR5YDhGBROvW9ktTVnU6UJYm1DZlUH16aK1sa1\n    roXPI+UzFwin7oW5+1/oHk5zC92nWpRWKLFUJh65jhIA3Cu7RgxQakAx9DBcC+BLfpaAvryNRUlr\n    Bb+0R/QAvzHA+zVwvDbds9b+a8JPb9Wvdo7Op1I+h+r90vkW9X73Dn/5z5TvXPhbq/xN9e0BgO8N\n    /vJxpA34G7Yl6/0C68Dfn+KK3yw85pp1fwf89W1L6t/G8BdYCwADAwJLeyQI/AsAvx8QGMC+IHAr\n    AAyEv8j1BMB8bBqnBwAGHg8CAzqUDUFg+btmW4XA9PuSdYGpD1mPlNCAA7At1cDcz72A4FSgn5/j\n    v5fAYGvKzhQMDimMLIHiGig89ffbWGr3rlGHN3atlpinNRhurRUbrwst15E/9lPkGM2lhcI3VUc3\n    V/0lr1GP1M5W9W6uyje1du3+YAXfIbOoqC1Gc8tVJbc0C1B89fbENr5L4XSoDIE2N2sa4i2pg/l+\n    YLl3PQV8pNr1AMI598KY5aT6pmvUqo596xILVjjbSvnben4cqmr1kqUP60NVJcBXjhGqddwjxbO8\n    BrJdDPpy36+RcyFfJYpfoKzO79rpnumYVfXLz4dSN0v4K9u3qPcLxOHv50i7ENi11gXuDX+5Twv8\n    1Y7F4C+dG/B3bhIA8/jdkurfAX/DNuBvH1tT/Tvg79y2AoA7wF+AA2BgHypgYEDgUtsKAAYGBOY2\n    ILBvvSGwVAIvAYEBOwgeENhZTU1gYBkIDMzhagslsPSrqYHfJ/pZITA/t5QamI5pgDNUH3iy9UHw\n    EztvBcHytUVJ3AMGxwK+rYGwNh7v9yUjLWhszkuadn1iqSBzrEfw3KrOrZlPzpxaAN+Yn9w6i65W\n    dV0K0V4q36WBbwtlbyloTq29hbW6X9SqjXPTSPNxLUD4Gf73plog3AIGx0oiTOevyb3FArktyugW\n    QDi3XWzOFsspRWCZU8vsFdZ9sadZ7heWVMuav9yHs2qArxxTyzaxFPSVbXPBb0jtq/lqCX7pDLAs\n    +JXjLa361fzxti3q/QID/saODfhbZgP+ltuAv+1sDfgLrKf+HfB3bltK/3x3ABi4fwicC4CBAYGX\n    sAGB5/Yho+29QODeqaCBx4TAwBzKLg2BP+Nw6weEQXALCExtSiEwYKsLzH9vmRJa82eFwMCyamB/\n    vHIQXBLw1mDwkzjXSxWcOz9uc99xVbDsaw1u59b5rVEkx65DrrUDQvV+SwPmNZCX5m5VluXOldq5\n    gPDcLGmdLSrf2JysKixtbG1NZxyy1Lul0Lcn8K2BvTWpuO/FSsFiyFL12jWzAuGadNG5qaLp7yNm\n    lvtjTX36UJtQO21Nr6JtDyBsvRYpK6lTX6r+bbHXpXyWWO79TwOwOXtwzp4SGk9r4yz9IFSL9M7T\n    SPnQl87xOaTAb24GjFbgF9Dr/NJYz0qf3rV+geXgb6t6v+RLm2sM/lpSPqfaxeDvDwjbgL9zG/D3\n    fuAvUA+AB/yd7NHgL7A+AN4a/AW2A4A7wV9gzwAYuE8IvBYABgYE7gWBLQAYGBBYs9YgeA0lMJCf\n    EroVAAb6QuCYjxwIrL3mtgQEBsLQticEBvLqAgN2NXAJBObnWqiBtfNaiud7AMF0vgQEA+X1glPz\n    JNPSYtIxq2IoJ2isXZ+Ucf9WaFFjreqG5gWC86wW8Lq10vg5CuJDkbo3Fuie1xBsD3ypreV9sQbl\n    cyBFK5VvDO7lAo9r4T8mLYrsFn63YO3uB/V+S1TCISDcKl10qeJ3aSBshcHUdq6wtKWgzoHCuffd\n    tuUF8s2677T4m+l1L4jdW9eGvXIO2hg9oW9rta/sszT4pXTPGvidfvZP9yzXllL9AnH4mwK/1Cal\n    +t16vd9YO368B/yV/lL+Q+MN+Ftmjw5/gXXVvxb4C/QDwI8Of4HHVf8O+LuK+heQABgYEBgYEHhp\n    GxDY2ZoQ+ENm+z1C4NAXyz/j0BUAAw7q9lABA2Ug+N4gsBxjCxA45pNbTl1gYA53LSmhqa12XJ5f\n    Ug3M++akhaZ+z4FzQDsQLNtZ0kOHfMt+WptSZbDmT7aJKaByFU81qt0cdVfJ+TXrCK9p9pq2vml9\n    NHBB170U+ALzdLVaUFeCmVbANzVfPpa13rLFpwyOa9eRrod2vZYAvq1gbwnQ6VHzN2V59WwnKwVe\n    tVA4FwjHHhqKpYv+xvu7zrvHpkoMpNpoPmNry00XrYFeCYZy6iHLOYT+pmP30VxrDYf3ZLU15Vvu\n    IdJnC+CrrdP6MFEp9OV9UmpfPs7WwC/QJ91z6Jwcj69vadVvqO27xGd5z/A3Bn6BPvA3dGwr8Bdo\n    B4CXgL/ABIA5lO0FgL9PrKEVAF4K/i6V9pmsBwD+XeD40gB4wF+bbR0AD/hrtjkABgYEfuR6wMDj\n    QOBPgfEGBLbb3iEwH3dJCAy0VwID+RA4BwDH2m8NAvNxJAQGdBBsgcBa39Z1gbW+3OQ5rgbulRIa\n    qFcDk4/StNBaezlmCAS/QxgQp0CwXJ/WrpUqONSmJQyW7VJ+S1JglkBhOXaOgqvEWvnRLARSrZYK\n    7pcoeS1zjM/Jtf98+2xQ4PugtiPLUcPy9T0hDIb9du1UvrG2FuAbmoum2qLr9q3xmqUsF/g+GdZs\n    7R+zNcBua7OC4lyo+1TRt0QhHFrHj8a9LzZX7b4Vuu/lZp5ImdwztDTFZxyiqehD67Lsq/JemAPR\n    rdcsp6/tmtmtFbzOHae1r5w9I+TTet1ie0oqhb5F5cvblUBf3s+q9g1dw9z6vpr/3uCXxuuZ7pl8\n    1ah+5Xkr/JXtlqj3y8+XwF8L+AW2AX/XUP7mgF+gPfztCX6BbcDfNZW/QBkAvgf4C2xD/fuI8Be4\n    P/XvPcFfYCUADAwIfO8qYGBAYGCbKmBgQGDNBgTWLQcC16qAY+0HBPZ/XzIlNOArgC1q4JKU0IAD\n    qe/Fa8CeFtqaMro1CAbKFcFyfVq7WlVwCgQDafVPaaronIB4CRTm/WrhsPVabNXOwfd/sie0CYSX\n    +sgBg7Le5wlX9d5sAb6WOb/CBep0AKv7jV2fWpWvBfrKNi1UvlZI4B7mKAe+sXndA+CtsRQcbgGF\n    U++tZR5a35Q62JoC2gKEUzA41ka/NuFznzPSRWtzja1Luw65dY9LVORLPvzUEsQuZRJ01qSVzgG9\n    vA+fi7SU2vfF0NbSRrsWobnEwK8GfWWf1Hxi4De13+WCXzoXAr90nvfLBb9yzBj45f5bqX6pTSrl\n    c8x61/ul8ymfJfA3BX6BZeEvEAbAvZW/9wR/QzG5FrZV+PupcJwW8BcYqZ+BAX+tNuBvW/toaLMa\n    AAYGBH4ECAyEQfCAwH3MAoJbAGBgQOCYxb5wHjt/BnungwbyQHAuBA71sULg75Tza0BgYA5zW0Bg\n    eq2pgVtAYC0lNB+nNCU0UAaCXyJB4l4g2FIfeCkQrM1NO/ek+NDGsIBgwA6DQ3PmbXJUwZqVQmHe\n    vzSVdGge0r5kts+by9xCAa4UAM6ZV02gPjfdr6Uur8V6pXV+gf85lkHgb5AGoDHVGLfcAH0MtFnX\n    J4PylvbT/A9FqU1jaxuWtpL00tJI2aqp7S3jW9uHHhx6CbSLra8GBvO2Zxxm48u/b8s1Lik5kLsv\n    lGasaFEr2jqWGyO9xlMQPvXZQ3P2z1i/3Dq9obEt/WJzT81HU/suBX1Dfnqrfalta/D7bFhz63TP\n    8/vS9lW/sm/KNPgrwa/WrhT+asf4Z8EKf380tIm9Xlr5G/I14G+9Dfir2xbhL7A8AD6v9KDbnuAv\n    0BYAD/ibts7wF9gaAAa2BYHXBsDAY0Lg0wpjDgg8tw+Z7fcGgbUvfzTuTxqOE7KWSuBQ/61BYCAO\n    grcCgfmxHhA45ZcspQTW/PZMCS3PxdTAgAvO1qSF5v1LQPBz4BzZIXJ9CQbHgrK16aF5G9mXv66F\n    wdp1i61Z2lPCHwx9ahRMOerh0HVOKUZrrJVvqaYN+baOkUo1GbIc2HtKBKVzLBf4powHtUNw+BtD\n    QD8ntTNZC5VvTlrnJ8PnxWpW2FsKlV+9fWR98x+AqV+TdawSK1WSHjLarqEOfinwYxlf89MK8NLc\n    c/qUpL22g/y4L21/ybFee6jVb04K51LAG7s+OXXeY31i9/VWwFf2t0Jf8h0DuzlqX2pfA37Jfw/F\n    L51vme4ZWFb1+xlxOBSai2ZW1a/W9lHgL6BDW36sFP7ee9rn73HFH99+j8XhWowTsgF/0zbgb3v7\n    WWTMR4C/QFsAvDf4C6ye+pksDoCBAYEfBQJvLR30gMDO9pQOGmgHgteCwDT21iBwiQoY6A+BtX4t\n    lcChY0AeBKbxlobAgB94zVUDW+oCy5TQEu5uXQ1MPiz1gemYFnzWQDBXA8tz3FqDYCAfBltUwaHz\n    0loB4dC1KVEJx/q2rCko51sS8G9tVrWtrKdru548yBv3Ly1X1WtR7IbWnDNOyFKwMKZUss5rCn63\n    Se2cq/ItAb4051LrBXu3AHZbWgm4tfz9rgGEt6QOzmmTys6htbVazn6Zap8LhWN9Yj5ejddi6ned\n    7S+WOdaokluYhJG5D9GkLEfRy82i7iVrAXzJd0/oK/vUqH2pfez9esZ1Blj5OT6GRfUbAr+hPjXp\n    ngEHVDXwy89r5+T5lOpXe02/U1YozUpVv63Bb6jdEvD3G2WMlvC3pH6v1i9H9UsWA8AWmPunzPY1\n    RvA3FntrNU7IBvyNWy/wSyYB8NLgFxjK3xzbqvr3HuEvsCEADKwDgYE6ELxVCFwCgIEBgZcyCYF7\n    AmBgHxAYWE8N/AgQGLCnhL4XCAzkKYFDx8i+RR4EBnSoVQqBtb5bTAlNv0vLgcC8jQaB6fwaaaFp\n    nDVBsFxraI7yvFUVrB1roQ6WfkLB81iqZms66pjVqKZiY7dIx7o104Kvz+IcvS5R6ebAXqA98NXq\n    MOpqQj2gHZtbSskcSyXdUuWbk9Z5KeBbU4e41t9WrZX6tJc/biVA2KoOjtWYD6mDQ23P6t9y3rVK\n    AWH5cExJzXrL9bC0t6S9jvXTFNKxFNn3YrXAt0TJyy0H9MoxtTatga/mJ/Rau19rgD21/tR9nwBe\n    aH0xIL5l8Ev+eqd75m3WSPm8BfhrAb/AgL8xSwHdJeEvAFxwvQv4mwt+gQF/gW3A398C+JsNqX+X\n    gL/A+urfR4e/wGbUvwBwuP493uO/N/yD6NdLTYnZVpTAjwKAgW1B4D/ggJ8vOuJkW4TAa6eDBh4T\n    Av/zhmOkbEBg3z4HYWdYDdwbAgN91MAtILD0qR1bWg3MX5PVpIXm/nqD4HeRczRWKmieqwrGm9eY\n    rxT8baUOlr7kPEtqOqbGyLGaYDtZTkrUlpYLVuNt04quHnOyjlULfGOWA3xDc7FA3xyYK/tq9wCr\n    yrcF8F0K9t4D5C213MwQuT5y/GjmsgLUpYvWPte5KmLeV36eLEC4xbWOrTFm1iwSOVA4tG6rld7/\n    W+yfPcxyb2y5f7rrUeYzBZctMFXr3xv6ThbPlpGr9p081oFfPkYO+KU2FvAb81eb7hnok/JZtttT\n    yudQO3nsRzgw2wL+fhOYWwz+psYd8Lfc7gX+AkP5W2Ja6uelAfCAv3l2jwB4q/AXGADYswGBna0N\n    gddQAQ8I7GxvEHhPNYG3oAIG7Cmhe0BgwEFdCwDm7bnlQmDAAdklITCNFwoCSpjbGwKn/JKVpITm\n    7ZdQAwN900Jz/71BMBD+jFhBsFyz7B9uY4fBFqVwyKxAmPv0a2aG/aYsN+1mrYXqIbZOEd2iDqs0\n    LSgsazp+SVwv7iOcxtu3HrCX5pJbjzgPjsd9AWEYlVpzrso3Na8n0XZN4Ls06M1JFZ0zfs69o4dy\n    8jVx/66Zf+l8NXVwqv5qbaro2LpialarQtiyVute1FohrK051pe/F6m5vMc1WdO3B8jtuVeW3utt\n    864Hx5aSCTlp/6lfCfDVjqeg75PYc1uoffleWAt+tRq/qTW3qPMrx46le+bH1lL99kz5DOjvV896\n    v7nwl9ruHf7m1vsl2xv8/R7XKLRpAYC3CH8/VYwz4G9b2xr8BUbq5xIb8LeJTQAYwN1C4C0CYGBA\n    4BwbENjZI0NgIPwl8V4gsAS7PSAwYFMDPwIE/o75stQFbgmBpRK3pRo4lBKaj0PQcgtqYKCuPjDv\n    XwqCXZtyEGxNNZwDg1PqLSsMjh2XRkFja6D3YAhulwSicwPNNbCYxlpa+WQJ/Ppr7Gu9YC+ttSXw\n    LVEolap8c2v5wtjOUmc4tpZewLcF6C2twbwF0+4lLSBxDRS2AOHU5yE2jrV+ew4QzoHBcn4la4nN\n    LfcenwuE+RjW69PTcvfPtfa+mj0t74GQunnGfFmzOljVvam15UJfPucW0JfaxMBv6/q+cpze4Jd8\n    plS/GmytUf1+ibTbQspnapfyuyX4qx17RPj7p4y2rWyJur9LwV/ADoA/VYwx4G97W6Pu74C/k7UC\n    wAP+NjMHgIH7hMBbrQUMbBsCbykVNLBOPWBgmxAY2FdN4AGB82wJCLyEElj27wGBQ+dKlMAhCAyE\n    QXAOBNba94TA0qd2vEYNrPneMwjmfVMgOJQeugUIlnOWIFhbk2z7Glh7bJyU5aiEQ4HznpC1lSrp\n    NTLvXpYbmM4FaK/e74csH08F8yOzBsVLgS9gg5cWOOanWz7c2ueofK3XyVKzOGa8FqgVYqeuQSmU\n    7QWPt27p7A3lvjSfL4l+odrfuZab2hnGdlId7KCUTeX8EvAXah9rR9ZbISzHsd4ftLTOvR+GWmOP\n    a3Wf6JltI5RFwjJmjrrXej04cLXvZ5Ol9gor9JXzkFZb31d7sGmL4BfYVq1fbT4h+yz6Ae1Uv1q7\n    UD+Cvzkpn6lf7Hzq2A/iZ8w4tP02sI4Bf3W7J/g7lL/5NuCvbgP+ltneAPBHQ5sV4C8gATCwXQi8\n    BRUw0B4CA2UgeE0l8BoA+BcAfj8gsGe1ELgGAAPbhMBAPaRNQeAWY1jMkg46BYBjfQEbCH4UCAwA\n    xwgEBnyoa4HAsk+oPQfBPVJCh84vqQYG2qWFDrXJAcGWvqXpoaUatwUM1kBwal0H49otvjSzQuFY\n    oN16fda0khqaZeOU/0OgVRB8HgjVj0nLqd+7FPCV7UvUsHotYfoc5Af2S6BvTUpmCQQtUPs54csy\n    7iNbrHY6t5eED/k5zlXTciu5x/I+uergedrzMkW1JV20VVWdWkMuEKY+WlutXrLlPlpiNfB2qT2t\n    d+aKGtOyO5xmn9+05ah75XjWdjG4Gio1EMteYd2P5L5xL+BXXoNW6Z5lmy2rfoH9w19rymdgXfhb\n    Cn6BNPwFwlB3afhLUHYt+LuW6heog79AGwBsgb9AXwC8Ffj7U1zxm8VHXbfubwn8bQ1+gbbwFygH\n    wAP+zmwOgIH7g8AtATDwWBB4S6mgf/H2cw0Q/EkZsxcItgJgYCiBNesFgGnMAYHjbTXLhcDABIBb\n    QOBUP2klEBjYdkpo6TN0PAaCY6A3dV5TA1ObHiBYO/8ioKwcs7ZOsEUVLNcXshgMTtXejdUCzld3\n    lUHh0NxSqaF71Lzsaa9vALw3DOsRPA8FhW2gJ2+91lSfrYGvZa4lKt+YilqeWwv45vSxrLt0LVb7\n    LpIutJfR/T31HajGSu65mpUA1F5A2P75L1MHW9cTAqtrAmGrb3eN8q9DifVX+B7wim0+GGLNemBJ\n    9cyP5ZZvyLk2/J5rqf2rzTXUdy3oC5SDX0uK6FzwK+e2pupXa/cZaRhUAn/lWkJjcyuBv7E+9LkZ\n    8NdZDfy1Kn+XUv0CcfgL1APgLcJfYH3179rw93eB448EfwEdAA/4W257Uv9+NLRZEf4CIQAMbBMC\n    b0UFDAwIvAYABgYE1mxA4LkNCOzbXyFu9wKBtfMlEPg7hOu9AtuGwLxfyJZSA8s2VhAsA6BbAcF8\n    bkuogrVrEfNhVQfLvj2BMJlUC9fUCbbMYQ1gbA2yL6mGygGcMR/2a1CngLIE62uBb948869dS+i7\n    BPDNvyZ5tkUolGs9lJJWpbB1PqVAuFYdbLHWtYPlenqni06Nn7IWKcKX3NO2uJeRWe6vlntOCOC+\n    it9zQa91fK1t6l4cg76tlL7cR25tXzrPfYXg7VLgV85BXo9W4Fe2iZ23qH4/I/xvvxzwC5SnfAbK\n    6v2m4K8V/AJt4a913Fbwl/pvQfk74G++LQV/lwS/wP3D35++jTfgb9r2AH+B/ah/PxrarAx/gRgA\n    Bu4LArcGwEAfCAzkg+ABgZexT4HxHh0Cfyjo0xIE90oHbYXAteNYbEDgueWogXtAYMBBXSsElm1D\n    7TUQbIXAQH81sOzfKi00fw30A8ES3pbWCdbOy7YxVTD93gIGy/O56mDZv2cwPDRWDRRuPb8SWwM6\n    t4J3OSmcAVI/21I5k32TEZhunda5Ry3f1Bpic6yt/5vyb+nfCszeA+CtsZb3llIoXJpiWbNcpWzZ\n    WG3VwXKeuUA4NEbqOyPfs3Lrq1P/mj2u5iGCFtYzKwDQ9t4SU/jWpOnPnWNoLM1Pqco3Zx3ad4hc\n    tS8wgdMSta82Hh9ra+BXnpdtUqpfWttaql8+B60t2fvEPDT4G+uTm/IZb+1zwG/o3F7hL9BG/fsI\n    8BdYr+YvsC78BbYLgIfyd8DfWhvwt7nFATCwPQi8JQAMDCXwmhB4KypgYEDgDwV97gkCL6EEBhzk\n    7QWBgTgIbgGBwXzsQQn8uSAldC8IbPFNZoHAQFwNTHMogcCa7y2BYGAO+EvqBPP5LQmDtesS82MB\n    wqEUm5ZrE5pHjqVUWXuoFxy6DiXz7gHrckFvaPzPOHgBdQkxtGB7KPir+W9Rx3dNla8cuzStc67a\n    7XV2X829FmXzHKZbCzgcgqCx912z2D0oB4qmxuqtDraMEdvLcoCwbKvBWrrXnW/f0fLel9A16fHw\n    U+k+tLe/fSvU7JXdItQnlbEiBXzJx5agrxy3JM2zNl5P8As4ICt9vRPntXNkJeA31Nai+g3NS7Mt\n    pXz+EcAl8+8npPwd8NdZSvm7BPgFloG/3yfW0gr+5oJfYN20z1sAv8CAv8C+6v7uBf4C+wDAHw1t\n    NgJ/AQsABgYETtkWIPCj1QMGtgWBewFgYEBgq/WAwJYvsksqgYEBgaX1VgID6brAQL4auAQC07El\n    UkLz4zVqYM2/FQTH6gMD/UAw0C89tHW8VjD4GXoQOgWELUCgBm6UAItcSGC5PkvYC+bXrWdAvRTy\n    ktWooci+xTV4b69NE63ZnlS+ucC3VOFb6qP355MsFcRPrSlvLLul7t+1lnt9W6Rufk3spTVjtgbC\n    VnUwjZ2rDi5tG3uAJWWle5k02rdbweHQ+uUesPb+Ob8O9nu9xV+J71Q/y0M/eh1tvb3mL+fzGHoY\n    KKa+1UyDvoCDrjlpnrUx1wa/vI12TmtTA3+3pPoF8uFvSilcCn/XUv5+GxmjFfxNgV9gn/AX6AOA\n    twx/gX2kfh7wt6/tCf4C7QFwL/gLDADcwQYAbmUDAg8IPCDwuhA49cWyJwQGtlUXeEDg8PktQ+BQ\n    +y2ogYEJXL439q+pDwy0A8HkqwcIjvkuhcGxNM21QDgEg4Fw/eCeoDZmOaqlJdI7tzQeYC9RB59u\n    fessJ2Ad6wfUwZGcOr58nLxA/X5UviXAtwbYPs/WcTDD2VzrnTK2pfWCXvL61gLn3P0h9wGZdWEw\n    UAqEXxLt6ucVvu9Z96TWe2cpIOYP0Cz1AEhrs95je2RDyM3U8JTYw2MPYeVCX0s94VRdX2oTGp/D\n    WWuaZ8BBydh+0xr8yvF6gt8WtX61eYWsl+pXth/wN+7rkeDvH9nrR4O/nwrHWjrt84C/fe1nkfX2\n    BsBbgL/AUP+mbEPwF7ACYGBAYIu1hsBbTAX9y8i5AYG3AYFbAGBgnxAYWE8JDNwfBAbiIPjYAAID\n    EwBeEgIDEwgugcDUN2Q96wIDKK4NvFU1sLYmshfhaykQbKkTTOOTOuaHiO8SGBwKBJfAYNneGnTW\n    UnPmBKh7gGHp26JafmTrkfYyBXtrUxpr9vrm9wmxoDm3/sA31qeXyrcW+LYEuy1rG+/RSgCo1Wqg\n    cC0QLoHBpdejNl30a6AN4L7fPSW95s8rdR1qoHBo/LG/zU2Dqi3vQS0fkoplnoiNk7ueVDaMJwZd\n    a6Av90Xfgy0PM/H5bRX8yvOyzbvIvAi4xsBva9Uv+dTm3BL+9q73S32146l+3HLh77eJMbYOf/+U\n    ON/apOoXGPDXavcOf4HlAfCjwl9gpH4O2VIA+KOhzcbgL5ADgIFtQeBSAEzWAwQ/ugoYGBAY6AuB\n    ARsIHhA4bI8CgVMAWOsTsnuGwJZ+2prXqgsMzMGq9T2gvqVqYDrOfSyZFpra9QTBfLyQOjOkCqa2\n    LWFwKuhboiCNweD0mHEwnTt+Sf/YtVhyDrV1+FJ2NgKMFiCuVdrL1Dys4+Sqm1OBeu39zlVtpfr0\n    UPluAfiWQpBW1mINvdM6+/P1rcW9rXT+JfVfWwDhljD4JdEm/77d/jqk5hF7aCZ3/qXX4BV6bfYS\n    C12LFnto77q8LccP+ciBvdq4LVI7h8YtTfFM9hU+yLI+0GQBv1oa6Vg7bQ4a+OXHc8GvbHdPql9g\n    v/V+Q+fXgr+pNd8L/AXWV/62Ar9kuQD4U+E4A/72sfNKgG3A38eGv0AaAG8Q/gK5ABhIQ+BfLzj7\n    AYF1WxsCA+uA4NNGADAwIDDZh8z2W4bAOV9wf1I4RolJ0PtXkXOatYDAP+KQBLxAewjMf5JZYO49\n    pIQG+quB/xjxyUFwaVpobQ4WNTC1e0kEt5cGwTQPDoNTAfJUYJ+PbYHBoWsRsmfxM+VbO/5U0M8y\n    pxa+WvRd20rhpWahILElhXMv2As4ha+t7SFYEzHHtNqWvVS+ucA3pw+3WljaG/b2Si3dw1pD49Zg\n    uGR+PdXBsTX1zAbBjR6csvztvN7a9rkWlnW2BMOpee1VnV8DeVs+pBWbR2z/su6brVI7SyPgGy+t\n    kFZPpxTWsb3TAn4te4OmWKYx9gB+U1ar+k2pjrltKeUz9ZXHLP24PRL8/ZOhTQ+T8BcIx8fuDf5+\n    qhhnSfjbE/wCA/4CA/4CA/5+TJzfKPwFegBgYFkIDNSB4AGB62xrauA/4ICfLz7qUALH7ENG25YA\n    GFgfApeOk2tLQOAfEn7WgMCArga2wlxqVwOBeX/NeqeEBnyga4XA1C8Ggekp9ZZpobV2pWmhqV0L\n    EBxrx0FwaIxUXUVr6sxYUJ9gsDUwnBPsf068jvkPvW4NhlNzto6zBgzuVVNxfs1T6p560AvYVT/6\n    nMuuSUnQvkTlW9q2BPquCXx7wN7S+aRSkfay1N4QslZw2LpH9JrTGumitXtQSa15i+X2ST3QVHM9\n    ctabuk+Hyza032e2sF+WPEDTYtz5tYj3yX1Iyjrn3EwQV8OccqBvbK69wW9ob1gb/FK7VumeQ/PT\n    7HOgX2iuvVM+A+vC3x/Ez5hZ6v0CNvj7F4OfFvAXiAPgtdI+A+3VvwP+xm2rAHjA38mWgL/A+gD4\n    0eEv8GAAGNiWCpjs3iHwFusBA9tUAm8FAm8BAAMDAgPhL6EDAuvtY7Y1JTCgq4GXgsBfcMBPje34\n    zxYQGJirgb8a/ZO1UgMD69UHpna1IJj8WuoEx1Iv94bBvP8h4/NaA4Qt/V5xMAWLSxVXOeYU1sup\n    z5YwGWyNqdBzfYWsBvZOc8zvExo3tRYLWGqh8rXWO4yta03gWwNKcuawFtjtYVZYXAuHW0Hh3kA4\n    ts/FauDKvx3rA1X881t6jUqA8DR2fp+Sca0gPHW/2vMex9cRstYZMLhZyg9YoG9ojj2Ar8yIsQb0\n    1eat7RWlaZ7lGDngV2tXC34BB9pDbVPpnqlNruqXj5mj+gXyUz6nwC9dh5x6v8AEcddQ/fKfIWsB\n    fy3gFxjwVxtHs0eHv1tI+wzM4e8a4BcY8DfH9qD+rQG/wIC/Ofb3vQAwMCDwUAFPtlZN4AGBfdsb\n    BAaWUwP3hsDAeimh14LAQBrybhECAxMIzoXA3731SaWEBiawu7WU0NS3hRoYmKBky7TQ2trINBDM\n    j4cCr1tQBYfaaO0tMDhHHZyae2zOpeuxzi0n2J7j17LWLaidLBYL4BIgoFTJlnXHfC4Be1Nris2p\n    pGYj9clRUEtoZUnDKWFN7nVZG/iWpuV8NLM+XFRiLYBwKxicUqXGHrzRfHPj96qaurg9gTD3XwuF\n    c8b/8TbmNQrZS9a0JizOyahQ6kdfc53f3OwJ1vM567CofIHloC9vs2fwG2rD2/Frv5bql/q2Vv1S\n    Wwv4/RETlF0D/uaofgFbymdg2/B3rXq/wHrwtzX4BZaDv0AbADzgr28D/trt3uHv0uCX7GPi/FYB\n    8N9PP8oAMLBNFTAwILBmayuB14LAa9QEBgYEjtmHzPZbhcAlX3z3AIGtABjYJgQG5iC4FALn9CWz\n    1AUG8iAwtedmVQPTsZYgWI4VOp5SA0sfPUFwLCDaAgRLCKuZVRVkUQen0kTz9q2BsDW4nAu6S4LQ\n    uaDYso41g+GtVU0cAFvWVxpEL0072hP4lqY31vrxa5ar8v0W9lrFzygHvkvA3gF68826v+RYayCc\n    +rzwGvQpsBuaFweXOfPO3SNrr1ENEJ7WWd5XM6nojd3rS6xkvS0tJxtDyqxQ1zKH0PncucVSPufu\n    m1fRfivQl7cLgd/aB4leEAa/NG4K/AL96/zS8R6q39Jav0A/+LtGyudc8AsM+FtqWr1fYL/wNwf8\n    AgP+chvwd3/wF9h+6ud7hL/AtgHwv8D1/gAwcN8QeKsAGBgQmNvSNYEHBLbbgMDtlMBAGARvCQID\n    26oLDNRD4FCfVhCY+wpZi7TQcpytKoK5j3eB4wAWh8HamkP9S5RVIShcEzjOSVttvR65JgP1pcrg\n    FnVT4/Ms+0dETjDcAi2WhL1ynNJ01iWK5pz6yK8BiFaj8s1J351SAlrH1GzA3n7WGgrze1fud6XS\n    MUP7gjUFcUnt4FC/nkA4NVfLNcq5v1qs9MGnJR5uCl2rnDTJpSA3Z9yUXSuCdy+B32uBb8zHs3G/\n    tD4YZdlP/ZTsfvtatS8f8zkAS7nv3nV+AVu655TVpnvm81kr5TPB20eDv3Q+5MsKfoF9w1+gLQAe\n    8DdsA/76thb8BcIA+JHgL9AWAO8R/gK7V//2BcDAgMDAdlTAwLpK4LUA8C8A/H5AYM/2CIGBtiA4\n    9gU1B9CWQuDccUptCSUwsAwE5j8ttnZdYOr7baId/wm0TQkNbCsttJxPqG2o3RKKYKCuVnALGKy1\n    r0kVHRujJCgs6x/XwGANUre0Hmmny9TKbf9BEAuS146VUpulrARIrgV8tX41tZEBrr46RM+XXiOX\n    CtN+vWLBybVgb++HJ3JtTTVkbM95eVPeWuYtFbo9UkY/4xr5bNss575/L0CYj1Vzj06rhttaz/2u\n    NhVzqdXWtY/5s5QG0CwGnaU/K/DV+ubukyGI3UvtS1cDQBT89lT88nYp1W+PdM/kV1vjWimfS8Ev\n    MIe/FvAr2w34e1/wd6v1foF9wV+gHwD+nXJsLfj7U1zxm1VG3if8Bbat/r1X+AtsEwAz+AvUpIAG\n    BgS22hZUwGQDAi9rW4XAQBsQfI9KYOC+IDDggG9PCAzoILgVBOa+rCB4TQgMLKcGzkkJzedlMasa\n    ONYmBwTL9iUgmLdZAgSH2so6wWS9YTDvEwLSIStR5/IUobH1Wa0mPWgPkwH1nkoqS0C8RTA8pkyS\n    kCL1vvZW94bWnKN0SvWzXFNZg7DUrGm5S1OP5n4+rHAx13oA3rx61O3/TmvvOS3qtvaoj5uTKj69\n    xvSDT6mx9gSEU/PlQDAEgC0Pi1mtx0NPuab9nbZU9oas9OGh0nHkQzlW43XorXO1pHUOrbE39A2d\n    C7UNWx74DQHVJcAvHe+d7lnOSWsvrQf8/dHgV7OSer+y3YC/y8BfDmV7pn7+PrGWlgB4wN8yG/DX\n    mQaAHw3+Au0A8F7hL7BPACzgLzAAcNwGBC43DQKvCYCBAYE1e2QInPqyaoWzqS+qW4PAgIO7S0Ng\n    IA56LRCY/OVCYP57DszlILgEApeqgVulhAaWTQsda1OaFjrUtgYE+23Ta+qhCgbqYXCsrewTAtIp\n    y4XCMWDdEtq2ADy589GC5q+z12Xz6qlyau07Z517Bb68by70rb3eMRWZVl81Z+1LWSjYXwvQl7CQ\n    wtWyD/SynL0i9tlZCjCSpcovpPyXpucP9S15wChnzS3vtb32zpJ1xdZo2Rdj1uI+teT+mftATulD\n    Us8FoDg2R+tesSz0BWLgl8bZGvhNWQvVb2oetapfS59S+Fuq+uVtOfB9VPi7pOoXwKrK39Q4ubYk\n    /L0X8Eu2lbTPP30bd0vq3wF/y60G/gJD/ZtrCvwFagEwMCBwjg0IPCAwWU8ADAwIbLUlIHBsjLUh\n    cOt6wGS9lcDkbykITO17p4Smtj3VwIAPSXPUwNR3LTVwqG1oLAm8X5Lt2oBgYLswWK6zNACcA4Wt\n    aq41U7BarwfNMRZIXaLWIlkvyFsSkH/Foag2bU59SMta9wJ8+Rit0jD3Ar7W+e0B7rawnJq5vaBx\n    q/slzS+3DjBQdq+7ByDMv3vm1/xuZ2vtn5b9r/T+vZTlpP7P2ctalEBI3Ud71LyPpZkG8qAvbx+3\n    NPgF4jA1BEdrwG+oz9LgNzTmUqpfYH8pn/nPkKXAL2+j+coBv0Ae/F0r5TNQBn8BOwAe8DdsW4a/\n    wDoAeMDffNsy/AX2q/79aGizNfgLTAD4X8znVQ+AgfuGwC0BMLCdmsBLAGBgQGCypVXAwIDAVtsK\n    BM4Zq8a2AIGBdZXA9HpJCAz4sDWlBq6BwLE+95AWOtQ2BYJjamDezpIeGqhLES3n0KImYklwWwvG\n    lwJMS03h3CB1bnrQNa003am01vUJc8eympzTjwIA/xiAE62Br9a3pI7v3qBvLWCv9Tus3HqkfG5x\n    X+T71BJAuBYGW/rWAmFec/vpBjYOs2O1D/702tdyATq33PvuVqx0P8hZ27VwT9bUxC2Bb2y9luui\n    7VE9oC+wH/BrqfOr+bJYb9Uv79Nb9Qv48LdE9Qv0TfkMxAEwP9cC/gJpADzg77rwFygHwAP+9rEt\n    wl9gGQC8FfjbEvwC+1X/fjS02Sr8BToCYGDbEHhLKmBgQGCyR6sJ/Ckw5hZAcAsATFYKgj9ktt9i\n    TeC9KoHlMc22DIGl35i1SAldA4FLU0ID/dXAa6aFfo8wnI756QGCfb9tVcGyfWgOtergUB8bgGwH\n    hckOjUFuDaR+NOuRXrN34L8X8OV99wZ8tXXXzjPlbwml3hYgUu/7Qm4d2qX9hawGCK+hDrb0Te2Z\n    tZ/HWAmEFv4ewVo+mFQzbqmiNzQf696T+5BUjno51Jbm1Af6Aim1Lx9zKfCrveZG4NdS5ze1Ns33\n    Fmv90s/aer9bhL/WlM/kU9qjwV+gTernGPxtCX6B/Sl/ATsAHvB3Gdsb/N266pdsj+rfj4Y2W4S/\n    QFD9C7QEwMD9QuDWABgYEJhsQOBtAGBgQGBgXQgMTCD4kdJBk4Vg71YhMLVvURcY2LcamPpbIDCw\n    LAgOjdcLBAPlMDg2hxbq4Fi/UJ+XRHC9VWDbohyO2ZIpl2vX2sNaArRa0Fui7iWLXaM1gG/uOG4d\n    fiC9xloC36Vhb2tY3dtaZy9YcswlgPDS6mA+Ti8g/KK0fTH2z11Py73Tur4WtoUHNFJWcx/hkLcl\n    eNZ8hfagXIVvas05++UzrtnQF7Dtb++Ybyv4zanvK/2mUjR/gQ380vEtgF/qI+0eUj7ztiX1fq0p\n    n4EBf6UtBX/5WDn+S2wp+NsK/AID/mp2Xmncn0XGfST4C2xL/bvl1M9bhr/AQgAYGBDYaj0AMLBd\n    CPzLyLkBgQcE5vYhs/3WIHBtupwlITDgg18L+CuBwMAcBFshcOqc9HevKaH5T4tK1wqCW6mBqf+9\n    g+B3GWtcAgYDywDhlww/NYHxWBuL33uDwb2C7y0UvaWwNzdYT+9p7zq+JXOT4yyR1rkF8G0FXrde\n    57O1ldxPW/nPGeMegTAfI/c65HwWa65dyf7TWjGcM9+Q3QP0pfOWteSsNxfWyn2ox76Z+4BUT+gL\n    2MAvHzcX/H4xtNHac2AbA7/WNS6d7hnIB7+pPi1Uv9Q/B/zyvqXwt3XKZ/LLrQT8AtuHv39MtGmR\n    +nkof9NmAcAD/va3teEvsB0AvCX4C2xX/btV+AtE1b9ADwAMbBcCj1TQuq2tAgbWg8CnlcZ9BAi8\n    15rAZKEvt0tBYOtYLWxAYPe6BORSett7UAMDPkQtUQNLfyH7YwQyf8Vh5isHBIfax9JD83OpOsHv\n    Ev6kWWEwH/tQADx5oHeC1fH20iyBbWuwvzQFtWU+luvxrBxb2vT0j2WWu44SVZHVT46/0jqSz7cA\n    /sF77R8bwNfiqxbGlqQefTTrVa+8FjovnS56aXUwzV+7D8h7RyqrRen8Sh/CyvVZ4qum/u2W9tAl\n    6vrG/Of05Z/BVjXv+fe5F2MfbcwnXLtBX96+d33fWDvZfqvgNzbuXlI+U/+lVL/Atuv9Amn4C/hK\n    66XAL1APf2vTPrcGv8CAvzU24O+Av9xG6ufJPibObx3+AisAYOA+IfBIBV1nv0ycHxB4QGBuHwr6\n    bEkNPCCwbikIDCybEvq7wOtcmLtVCEx9pKXUwIAPc0vUwJpPbpReLQSCJfi1gODYOmJtQvNuDYJ5\n    n5TR2K84FAWpJQye5hnvo1lMoVQS7Nd8puayRr3gtaxmrS3rFZb4tgah52suC0jnPFiRM8fQ/JZI\n    67w28C2FC8N0aw2G9wCE10gXXXJfCM1tieu4Zm3gPSh8yZZ8eKXmusSgb+49n39+vwb85OwTvK1l\n    ry2FvoAOdGvUvppPS41f3i6mtM0Bv6H1xexzoO8WVL9AfcrnpVW//GfKBvx1Zkn5DPRV/q6t+gXq\n    4C+wbN3fAX/7288S424VAD8C/AWWB8AfDW22DH+BlQEwsE0IvDUVMLANCLyUChgYSmBpEgQPCOzb\n    h8z29wSBgfXqAv+AA75PtC+FwOSfbG0IDOw7JTSwjBq4V1roNUGw1i40dy1YzH32gsEcBANlaUCp\n    jxzva6JfyFLKoFIwrI0hzaKMzrk2WzMZ2OXXIRZItq6pVJGb6yfmqxT4fsfqNcprkzOHVL8tqnx7\n    AN8Wqrpe9oIyVbfuK+/e2dtaQuF7A8Ilf6+y3zP875glGThK5mC9B7cCw/Harvq1yR1jaau9B/H0\n    xtJagO9YHd/Se33se9lLpF9qjdSnB/TlfWrUvtIntxLwa02xvCT4lf21sUvAr+y3ZdUv9ZWwd2n4\n    2yvlM5CGv38W/reU8hmoj1ltOeUzsA3l76j5O7cBf+8T/gL7Uv9+NLTZOvwFkumfgd4AGLg/CNwD\n    AAOPBYG3qgT+Aw74+SojDwicsg+Z7e8RAlvGamUEgteGwIAOfHMhcMw/tz2mhOY/W6qBge2CYOlv\n    CRAsz68Bg+WYuUAY0OFpKygc8p9aR65p681VgvI5tAqG90pJKQP5rSBWS9Ab85kL8ejzR4GyXOB7\n    LfwHWkgln2tbBb5rKntbwtxlbbl/j8QyONT4yfXZqg5xzGr/1mz7jD/nNYAwkLe/tLy3Wx8cqhm7\n    x97ZIj1xLei1zMGyz1hgr7aOF5Ttu/OHx+I+cv7+tqj25e2tsHVr4Jf6SGut+gUc/C1R/QID/sYs\n    B/5uTfULDPgbs3uDv8AcAD8a/AX2mfp5T/AX2A8A/mhosxf4C2wAAAP3BYF7AWBgQGCytQAwMJTA\n    IWsBggcELvNNtiYEBhAFwTUQmI+xRQgM5NfBBeogsBzz20TbNWoDl1wXa33gUkWwNsfYemLtW9UK\n    BvorgwFd7WuxUHppCxSW48bmV7KmHHukFNGAH+iNXVf+vlnWWZt+uATyhYCv9T0tBb4yrXMKSh2i\n    n/W4bQH49oa9+4W8peu1peavsRZQuAYI16qDQ2pM/rdWmy76nbFfKyAcm2fu3puyXvf5rVmrDAZW\n    s96nvmb0K4W9tI6tAd9p/vnQl/rtFfym5h8yCX5Dc5R9pD2C6hewwV8OaGvgr3ZswF9nA/6G7d7h\n    71rgFxjwd8DfsA34W2YG9S+wFAAGBgS22hYgMLB+TeABgScbENi3D5nt9wKBLQAYeAwIDNhTQpdA\n    4JB/bt8FjpWqgUsh8BbVwNo3hq2A4NQ8tb5yTql23CQQSqmCgTIYzPuFLKQOBvKC0rFgujWYKccP\n    XZuc9VnWLK0FnFkymF4K+XpDqB6wF1gP+Mp5tDANJtWk2t428N3HP4TXtT73jZ5AOEcdrP0dt7Ja\n    IAyUKYSBPlCY++9lpfvA0rC4Vz1foH4/svoNrSHn+1EsTXVs3drYS0BfwAZ+r8FrY4O+sbayz1ZS\n    PQPLwd+aWr9bgb+9VL9AGfyt3b+2DH+B/jV/twx/P1WO1wL+WsEvMNI+L2V7hL/AvgDwgL/LmxH+\n    AksCYOC+IDBw3+mggQGB17BPyrj3BoGBOhD8IbP9gMD19hccuqeDBspSQlshsPS5FzWwhMBAGgTn\n    qIGpj7RcEFyaFpr7DNmSIDjWJzRPLdj8YgDMS8FgspyU0XKMHCg8rUkfO+arxdpjZqsjGZ4bX8MS\n    asoak4FZaw3NsLKtLey1zgnYBvAteT/4Z0QDLVz9uEXg+2iK3t7WQzHcWyEMpD/HMWuZLhroC4Qn\n    //7ca4Bwas7PuBbVMO9RQqG10eckdE/Kua+U3Htr7/d8fnINOaBXW6tlbqm6vz1SO4f6SSCqree5\n    Evxaoa9su6biF7hv1S/ggG/JdzAtzfSSqt/Q8QF/nQ34G7YBf/vZT3HFb1YZebIQAB7wt40N+Lu8\n    ZcBfYGkADAwIbLGtAGBgXQi8JgAGHgsCA/uqC/yhoE9LEJz6UhyCsy1SQQP3DYGB/JTQpRA4NgaZ\n    BoE/46AeT/n5cUE1sIS6W00LzX1YQbDWNlavWJtnal2pPl8D0FcLDr5ErhcZ79cSCFuBZigoXOo7\n    1u+HxPpqA9ypOZUGwF+863WNzrMW4KZsa2CuFewFtgF85fw1q03rHPJlhWxtge92Pk+9P9u97i+l\n    c2kJ5Eo+O9Y+vdNFW21NIAy0gcI9rffnO5Xym8+h9G+ZX/fW2Ros8wqBodRcYn4t9YpT9/TnwnlJ\n    C6l8uXEgGoLY2nxi4HWAX99KwG+qX0vVb+l3sXuHvynwC2wf/gJ1ooR7hb9Lp3wGBvxd0taEvyXg\n    F9gP/N0L+CX7aGizBwCcCX+BAYCdDQgctkeFwL8A8PsHgsD3rgQGBgSusSXTQfNxrOmgY8elrQWB\n    geXUwDIlNNBPDQzMoWuuGpj7yAGguSBYHrf4jPUJgWAAURgcm0MNDE6Nm7IYFLYGu0vTPVM/KzQr\n    DXT3CtrXK7Pa/EPDEgyuCX5xpXAt7M1NhSn75qzZsq6UlaZ1bqHwja3f9UkrQtdQ9lrGKwnE15jl\n    X7/rwGJ9TO3zIK9r67T4LdJFt5yPZksC4WmM+fx/gP9wUM26Ug9IyTXXWIvPd497Scn9PGcez5E+\n    NZA35SsH9sbGK7k+FugLuPtwTLn8nAFdc6Ev7xOCrNq5pVI9y7FS4Jf349Za9dsC/AJ18Le03q+E\n    vVuGv8C2lb8W8AvsA/7ee71fYMDfJW0ofycb8Pe+4C9wJwAYGBC4BwAGBgTOtbUg8KfAmAMC+/ah\n    oM9SEDgGZvcKgQGnBAbWhcDA+nWBgTLFa2s1MDBAcAgEv4+0LVEFx/r1gMG8bwkMlmOXBHy11NGt\n    02FKy63hWGK907H2MGvgNxWkLkk9+h0LIL8KADy1T6+/VFEi17QV4Bvzkwt9pZ9ekPZLxPd7lEOh\n    kM+lwW4PC92ja65V6LqUfKewmuUBgZj1BMKt7sctgDBgh8LPuHrQ9gnX2xx8MGyzl+g525yWVCa3\n    zERQs6fnXN9Spa3F+N6USuVsnUMN8LX0t0BfeT4H+qbayz5aWw20fkYetKlR/MqxU/Pl/bhtVfUL\n    TAB3TdWv9jpk1nq/0mdP5e+f2RhLgV+gLfwF4jGoAX/jtnX4C6wDgAf8vV/17z3CX2D7ALgQ/gJr\n    AGBgQGCrbUkFDDwmBP7F28+hBNZtjxC4dU1goAwEt6gHTLaGGpgHtkIg+N4gMNCuLjAwBRiXgMDU\n    nv8shcCxvnsFwaHzMb+pPrI9D9y2gMG510X6qFX+HBLrKTVtXkuBg54WWkML9at+3m45tWRz3uuW\n    dRhbpQHtmda5VuXbCvheVvpH67sZPDi8/Ww9js1ajvvu9lNf49LWChK/FABKbqVAeCl1MNAOCEtf\n    Fgt9Bi3lFzRL3b96ZcXoXfO+xkrS7Ld8uEa+xzUPOdHcSu9dVpUvmbZXxKAvH0Ozlmrf2Hn6nZeF\n    SV2T0geR9pLuGSjf+/eU8hkog79LqH5pnKXhrxX8AuXwd8mUz8BI+1xrW4O/AFYDwAP+Ont0+Avc\n    h/q3Av4CAwDrNiBw2NaEwMC6IHhAYN32CIGB9iB4QGDdloDAQLu6wGtAYKAsJTSQVxuY2vdUAwNh\n    6LokCJbtU7C3lypYtpcB2hAMtn4zawGEXyvrUMYC7C3gcCiovYTitoe9BKFJfgrLvHF9axXUf4e8\n    wKFl/UsBX8t12DLw/dLIj2ax9JvD0pZ66KiltQDCW1YHl8wnZBYgbP2b4g9TtbhnvVa+B7kK2hZ7\n    0ZYsdk+uXVMIjNa+7xZFcshyVL5kFujL1yfHkVYDfWPtY+A359rUgF85Zgn4Bdqnewb2nfIZaFfv\n    t7fqF4jD3z+z35eEv7mqX2DAX80eBf6umfYZGPC3xFoD4C3BX2Cof2usoO4vt3UAMLBtCFwDgMm2\n    DoK3nAoaGBBY2hoQGLCD4AGBJ1sbAgMTCF4LAgM6CG4BgYEJBC8BgbXX0vaaEpra85/AciCYjpWA\n    YPLVAgRb0jj3hMGhwOs7xVeOqqcWCJcqkyxraQmHe9bmTMGIWnBaA0ri16T9XOdznKuT3gHqMau1\n    VGpuOa3zloHvVmFvTsA/ZmspdTXTHoxqbQMI261G1fsucDynprDVtGvSY88A+u1xLXynrPT+mIKg\n    sXZWK6kBzK0E+PJ18Pv610Tb1imeeT+L7z2BX96P29bTPQPrqn611yFbQ/ULDPg74K/NrAD40eDv\n    SPucb/eu/AW2rf4Ftg2AK+EvMABw2LYGgbekBB4QeEBgaVsAwMCAwGRLQ2AASTVwSwgM9FEDaz5L\n    QPBnHIKAOGZ7VQOn+vYCwdyPxXJAsLVNyL+cZ6htDGS+U/zkgs9SINwSUloC7FYgntN3SeudBnsJ\n    uCutNpWlZhosLrWS1J+5vtau49sD+K4Fe1vB3CVtKXDcGwq3BsJLpouO9c31YzW6n7dOX94DDJPl\n    XN/W95TW1ynXUutJwc7W64vtTTl7Sm5KZ21dFujL+6QUudr8YmZR+/J27wwAOnat9gh+qc8eVL/A\n    +imf/xJpuwT8/bN4vXX4C5TFme4Z/gLLq38H/F3GfhZZ84C/9Xbv8BfYLgBuAH+BNQEwYIPAv15t\n    dvUQeOsqYKAMAi8FgIFtQuDTisHmT4Gxt5ASuhUEBh5PCVz6ZGbM7jklNJBWAwM++N0LBN6zGjjW\n    N1Yf2DqmZrXpoXNAcKpdqE+sbyw9NLd3AR81QNh63VoG33umhCbrGWSvXePagXLNeoBesjkQdcdC\n    n5lQUJ5fu1qF2ZbTOres4bs07G0NeVvOt/W/dnvC4XsHwrG/31og/HQDSOl5z8/5c/D/tvvZ2nuW\n    tNQ+veY+Ru9Jz3TPOetslXWiVN0bW+8X2KCvHJ/3j80zZFboy9tuCfySvx7gV/a1qH4BB3+3Bn6B\n    NPwtVf0CPuz9S6LtgL+6bR3+5oJfYF/K397gF9gW/AWA84pjr638BcoA8IC/fe2jsd1W4S8AfG0z\n    t+0DYGBAYG49IDCQD4IfHQID2wPBW4DAwH7VwK0hMJAHggcEzrdeEBjIB8Eh2LsVNTCwLRAcCnCv\n    DYK1uWntU+1CfWJ9LTD4XaR/rF/McqBwbt3dWNC8pWq25Bq0riGcAg9Lr49bT8jr5lVmMjjeQ33X\n    SpElfT0i8C2FvFtJK51jpf9C7gGHtQenWlktEO6VLrrEV8hC6ZpT48esJxQmK4HDvWv40vXrtYeu\n    uUZt3ynZ22JrkffQlsA35TcGfUP3aOs936KYleO8wxWfkQdlNJVuru0N/NLvNfD320DN3pT9AAeP\n    5fGYaaC3p/K3BfgFbPCXxloC/paCX6AstjTgr822qvxdE/z+FsDfPDj8BfIB8B7gL3D/APgB4C+w\n    NgAGhgq4xIYS2NmaAPgPOODnq42+PAS2AmBgvxAYWFcN3DoVNLA+BAbWrQsMLAeBgW2pgYFl0kJT\n    P2m5aaH58a2D4Ny2Wp9Y3xQMfmfwEeprMQsUrg3+UvC8NzCtvRYtrcdaX3BYBPC68cotFhSPqe/A\n    zlkC/1rgmz6va6d13hPwzYG9ewS8NZb7r+fW0LYXEH7BoToy0AoIa3+r1rIAWvYBdz4+r5q9bQko\n    zO2AQxcYuoVsFb1BtrbW1vtbLeyNXYdc4KvNpxX0tfTR2hIAtnznr1X7Am3BL9Cnzi+w7XTPQF/4\n    mwN+ye/S8Hfrql8gH/6OlM82s4Jf4LHSPg/4O9mAv7oN+FtujVI/k60PgIEBgUvs0SDwVlXAa0Lg\n    LaeDBkZKaG6PCIGBZesCp8AssG5KaOD+1cCyj6VvLxDMfZbUCc6Fu61gcOxakNUA4VB/i4WgcCsQ\n    bB23le0FCKcCdy8KAGi1tt6wt8aH1VwdxYP3WjNXm9vZlur4tlA+pfxa1jMsbrV7QIsxW/numS46\n    9LmTf6u1a7HuUc8NfJT4zvMzv9en7i8WFfG9At9WaZxj9sRgZs64udfBAny1/hboW7oHlKaEzhmv\n    VZrn0LVYAvxSn6XAL9BH9UvnYtYq5bP2WvM74O/ctgx/H0H1CzwW/AW2mfYZ2Hbq5wF/+9tHQ5sH\n    gr/AVgAwMCBwiQ0I7GxNCAyslw56jVTQwP7UwB8K+iwJgQEfzvaEwHKsXnZPEBhYPyX0Wmpg/hPo\n    C4JjAey9gOAWfbS5x9pZgHBsLvWwsL06mKw2aG6Fxz1h8DOuwUDtEurn1Npqg99AG9ib8mP1qQXP\n    a2pacn/Wz0krlW8vhW9u0L63ta4dnGM9a/lyWxoK91IIW4Gw9e+m5G8z5q+2hnCuvyXA8BJK2NA9\n    sHd9YuvaagF1i30OmO9RLxlryF2/dg+2qHzJUuC0J/QN9bH2ban2Dc372gn8yv57U/1uIeXzkqpf\n    QIe/a6V8Bgb85fapYrwBf5exrcJfYDkAfK/wF9gvAP5oaPNg8BfYEgAmS4HgX680ry0CYGBAYG5r\n    QuBfAPj9gMBB2wIEBtavC2yFwD3qAQOPoQQG0grdlhA4Nd7e1cDURwLdXiCYr5GsNQiWPmPG24XU\n    ytb+pf20NcTmz4PjseB6aj41UJT6asHtLddb3Jq1BMQ8cFwDLVKQdgvAN8dawJUeYHbvsDdP4bWe\n    WcFSL1CcU2qg1Tg9lce51uLhm1ogDGwLCveqJ78Fle/S1qp+r0sbvhzs5fbV6Gdt6Mv78T4D/Ibt\n    HlW/oWMh2zr8XQr8AnXwF8gTEWwZ/n6qHG+NlM/AgL9L2oC/zgb8ndvHxPkHhL/AFgEwsE0IXAuA\n    gQGBW9gvE+cHBHY2ILBuHzLbr5UOuhcEBpYFwUtDYBorRw28NwjcQw0M5KeFBmxA9ktgnjWKYOvY\n    IWuhCq6pAdkCBgM2dQ4Fxy3B5B5QONSnNN3mI4JgstB7WBvY1653S9Br8WfxXRp8/1LgI/a3kEob\n    GTL5t9xD4ZtTh7HnWGtC3R72NXpuWaDaYrwUEC75fFv2o9TnT+4XJVGKFkAYaAuFQ/5q0tzH/sYe\n    EfaSxfam0PVu/ZBRDewl+5oxdghq1qT3z70HyH0xF/rmXBvNHh38ptYYsy2ofrXXmu97hb8cxvaA\n    v4AfOxrw12ZD+avbT3HFb1YZ2dnaqZ9zwS/ZXgBwLfwFtqv+3Tr8BR4MAAPbhMDAUAKnbG0l8Nqp\n    oAcEjtuAwJM9GgQGbCB4TQgsf49ZCQQGdBBMEHcNNTCwfn1gS/+YIjhnfM1KVFF/xOE2pgaqLVYK\n    g2PzfMHBDHlzAUIrMFwCkC01grdQz7eX+fVo2xoFl7Xr94wrXnBopqCyrC80v1z70sgPNy1IXfsv\n    qFSw1vJ3uhTw1cbpAXmXAFdLKSt7qHdLx0nVvu4RDWix/t5AGOgHhS2+6T7b2nruG1uyWIkF7Vrk\n    +G3RJvf++w5XU58YHF5C5cvtWgB9edvaPWor4Jf65YBfev3oql/ttea7Z73fP4vXe6n3S3Yv8BfY\n    X9rn3uAX0OEvsA4AHvD3/uEvsE/178fE+S2DX6A7/AW2DICB+4TAewLAwD4hMDCUwNwGBJ7bh4I+\n    rSEwYAPBPSEwMIHgNSEw4IPgvUBgoL0aOHY+5u/HDiB46frAFh89QTBQpwrW5pdjrYGwVfVbkxbU\n    Os+XCLBuYaHg9hbq6/pt+9uzeqxdjcVaBVvqGmwJ+JYqaaS9w/X2WewBN+Vav6IOvL0LQoVy27Ma\n    sce6a98fOaceAJF/ZluB7Bb1ZFsAYc0Pt1xgWnJfrK1Pv9Z+Em67Xp3iVtcitIYeoBfIU77S2vUa\n    9/lK3dK+ZHJ/XDLFM6CD27XBr6X/HlS/dC5mS6d8BrAY/N1TvV8ya6zo+8SaBvx1tnX4O5S/ug34\n    28YG/F3HHh4AA/cHgXsBYGBAYGkDAjsbEHhuHwr6bBEC1wJg4L5TQlvrAgPLpYQG2quB10gLTX34\n    T2B9EJwzh5DVwuAaRVUNDJb9teBxKPD8PuErxyzzfknMs9aWVj3V1n0stVzQUArj3uGa9XnoBXuB\n    spTOKWsJfOU834vXKeN/P7H19QCr38+Acvo93zPgrTErxJNgovV3rdQ8+P019zOoqd1bKXtbPKSz\n    BBAG8veT3Pul39e32N/XWvsOUJe+usR6QG9+f+0FeoEwINX8ae83n9sawBfQ98gBfpcHv8BQ/Zba\n    gL/lfnJtr/B3SymfgQF/pYXg71br/ZLtCf4C5QB4pHwutwXgL7AHAAwMCJxjW0kFDQwIvCYEBrYP\n    ggcEdvaoEBi4j5TQwDZqAwPrpIWmPvwnkAdhS9JDLwGCgXwY/FWZV803rRbq4FhwWwabe9eg1Pyn\n    gu8tAPHegHBpcF0GyUvARa7JgHUopXSJ9VD3An2Bb62/HrWeW6RwXgr0tqypa70W7cfIWW/b65Cq\n    DVt7fVvDYGB7QFjzRUb3oNL55l6z2ns60AYU7w34lqRxrr2HW+4tfIzUPdV91rYDfa0+W0FfIA1+\n    3+MahLuh/tSvZPw1wS9w/6pf8t0T/mopn4Fl4G8L8Au0gb+twS8w4G8r2xr8BbAaAF5b9QtsC/4C\n    21P/Dvhbbn/Pfu8OgP83eI//ydorNti9QWCgDwjekgoYeGwI/Iu3nwMCh22vEBhYti4wAPwPifEG\n    BE7bFtXArVNCU59aNTCQnxaa+vCfQH8Q/I3o1xsEh8aQFmrTKlW0nFNOPwsQrlUf1xiN3UoZLP3s\n    tSZiSwVUKcToDQG3DnyBttBXBtL5+9Ea+GpjaPaoit7eZv1b6w2Ev85e3y8QJl+h+YaspjZv6T21\n    ZSaMve5x03WgNbS7Zz83hJFAGVSlsUN/3zXpnVsBX2Db0FfOY6vgF+iT7rlU9QsAl4bgN3ZcszVT\n    PgNx+MvH2RP8BdLigD2ofoFtwF/ABoAfDfwCA/4CA/6mbKvwFxgAWNj9AGBgQGCyAYHnNpTAvt0j\n    BAb2rwbeEgQG+oPgvwj/IRDcEgLzcVIguAQCx/zuUQ0M+CDYAoGpD/8JbAME584jZDkB79j52pqI\n    rYAwMA8+a0HsVkrmEosFx0vntUSd4NC16F3DsSZ4/g42CFgboKcgMX9vB/Bt47fGate4/dxSdVZ6\n    fVpflwGEy32RPeNa/b5YwW1tLfAepRK4PWMZdbxmJdck9XdYu5eUXovQvOQan2d7gX28lsD3C1IP\n    DKXKTLSF67XgNwaElwC/gIO/a6d7BspVv0uDX/LdEvwC24G/HMYuofwd8NduW1L+/i5wfG0A/Mjw\n    F9gWAO4Bf2tq/g74W2cLwl+AADCAAYEr7REgcCkABpaDwEAYBK8JgU8rjg2sA4HXAMDA/iEwEAe5\n    /4g4mG0BgYHl1MBrQWAaa2k1cOxcTzUw91NiBFZLQLCEufcEgoF2MBjYFhAGbFA4Z5yaaxObV6lt\n    BVSVrKcFKA0FbN8r51LBpJKxKKDL33se5M35TDwS8G0NJoZty1rUj8+xPQJhIG+/DN1XtHuQnHOp\n    /TngU/4dttqH1tpHWlire5N1PS1Ad2zO/G/ouQKuauO0mHtqv9wK9OVjEUh9JPALLJ/uOQZ4S+Cv\n    FfwCQ/VrMQu4/Wd3nvIZWF75Czwm/D2v/B1h7Zq/wIC/KVsDAH80ttsTAF4A/gL3CICBAYHJtgSB\n    lwTAwIDAmm0ZAgPbUQID+SB4aQi8hBIY2AYEBhwIfgQIDNxvWmj5ewsQHPPzjej7tcBHrlkD3dYU\n    0j3AasqnZW45aqwekJXPsacqaiuAuMZyA7S5QEC7RjHYW2tfccDXgnnGbCngO82/jV+LDeB7P7Zk\n    Sv7YZ7YlDG7hjxsB4Rb3Gm1esfcg528td8+6h30I6Hc/4ntBDwWzdd45+1Jsnj2Ab0rlaxlrSejL\n    xysFvzkA9t7AL/cTOq9ZC9UvkA9/e6p+Q7V+gQF/W9ie4e9Q/sZtwN8Bf1M24G+dLQx/AeBw/Tu8\n    w799+4fIgMB1VgOAyVqD4AGB57YmBP4DDvj5aqMPCJxjHzLb94DAQBjmLgWBgQkEbwUCA+ulhAYm\n    ANwqJXTqXA8Q3CMtNLC+Ijjk5xvR1xJsXhIG5wS/a9XBsTHfG9vVrNXSt9V6etlagfgQMCgNxPZW\n    fbUOwvPg9dcA5Mn5HGwd+D6Cwndrc90bZFsLCPdUB5f405S9dKzVntlyvSkreaAp9llYU+G71N94\n    zX5TMsfS/UObZw/YS35zfGltW+6T3FLgl8bmIPVzho+9gl9gvXTPQNuUzxbwS77vHf62AL/AfcDf\n    T5XjraH6BR4P/v4WwN8M+AugDAAP+NvPPma0HQBYtfsFwMCAwGSPCoG3WhN4KIHjtmcIDCyrBl4q\n    HTSwDAQGfBD8gzLeUANPVgOBgXVBcEgRDPSDwTlq4NL5pIyCtNrYJUHllsHtFBRuBXVbw4KSdbWy\n    nsDIEmyNgYJeQX8NZuaMZb1mLdM5S2sRyOaB8bWA79YAas+51UCRlveALUPiewXCLS03q4b1c6zd\n    i3vVl08B4tT9eO19q8ZKa+S2HCfXb0w12/pBqZJ9c/4A03rQl48fUv32Br9WPz+y3y+NwC/QJ90z\n    nQ/ZWqpfoG3KZ2DA39K+JTbgbxvbGvwFhvKX7F7hby34BQb8bWV/j0XhL0AAGAD+LQ67AMDAgMAl\n    thUIvBUVMLAuBP4FgN+vOP4aEBhYpy7wgMDtbKSE9m3vauBWaaGB/YBgOpYLgnPnlLIQXK0Jni+l\n    dsoZZ0kokTIKnPcIzIdqO/awUM3KVhYCmD2gMtUabh0I53O1AtnY9dxKHd8tQd9a5dzWbelMBq1t\n    qXtvTf1gW0pa31qn/D9430Pa2pJg2Pm/LpIVo9eeZ62dW2M9772hNNA9s2LUXoOtQF8gH/zmqm5b\n    gt8tpHsGhuqXLAR/5ViPBH+t/XNszymfge3D3zXBLzDgL9m9wl9gn8pf4P4A8ArwF+AAGNgPBN46\n    AAbqIfCoCdzOtpgKGtgeBF4CAAMDAtfYgMCT9UwHzcfaS0poYALBa6uBgXVBsNY/5Ocbpf2WYHCL\n    AG6rGsKaXzIZ4I4Ft3sBkpJr1Roi0Lq/ite2vr3UuofEed16pgyVwXECwNxKPiclwDfHvmfQfSng\n    uxXYW5vi9B6tND3+mrY0EKbPQo/vivz+WnIv55/p98rxHg9TcQvNObVvrLVX+G39uba+35bsP72u\n    S+zeF8uG0asOcQu/78QcW+8zNdBX9m+l9tV85YJfoE+d317pnul8yO5V9QusC3+/Z/6XAMDf4xqN\n    8Yy0z75Z4W9v8Eu2JQD8U1zxm1VGdvazyNq3Xvd3wN++9jGj7YC/UfMBMIDdpIMeELjMHhECb1UF\n    DKwLgddSAQP7TAn9oaDPvUNgoC8I/oviWwPBPSAwHysFgktSQqf87jktNOCD4Jz6wNrvQDsQLH19\n    E+izRoposvdopwqW1jqwLecWC8bzb5trQ5El6wavtV4Z2OXvzRJ1IUNKqFr7XvhsASBaKHy/zh6G\n    2B/wtczhUSBvqVnvLWvfA1sA4RIFb+uU0XIMus/1UPP2Vu/y+QPz++cW9pHetoX7C6059yGpter3\n    poz76lFewQp9+VwkQP1s8FUCXT9H+u8V/ALrq36BfPj7CKpfoB34BbYFfx9F+Tvg7zq2BfhbAn6B\n    x4G/wADAtbZCzV9pcwAM3B8E/vVK89tiKmhgQGBpjwyBge2ngwYGBJYWg8BAGMreMwQGhhqYrEYN\n    DNwXCNZ8aP6+ifRZSxlMdugEgzX/tZaaXyoN89pQxLKGWmuxxlRQXgse83W1TiPds2ZvKhAeUvPl\n    +GxRx9cyb3m914S+A/Yua5a/tTXvf3Jsy+e3xFoB4Zy/+55lBVpBYe2e/G72sMsyn6ElSxmsZSl1\n    b+rhpa3CXm1+W4G+wDLg93Oi/xrgF7iPdM+AD3xT8LeX6hfYDvztofoFwgCXxrtn+NsS/ALbh79r\n    pn3eOvwFlgHAA/6mbcDfeltR+UumA2Dg/tJB/3ql+W1RBQwMCCxtQODtq4H3DIGB9iB4CxAYWC8l\n    NLC8GtgKgflPq21NDQxsCwRrr5dQBct+a8PgLzh4fvvVga1PH11SQ3NrqVWXVgpbrHfgPLbmXqre\n    0PpagYi/6gB8l6jh2+rzV/LAwLD+lnp/W97jct/j3LFLP6upv8UW353lWnrf11NguOffW8m+ew/A\n    tyRVfe66a9fQC/bKuX1GG2AprTX0jfmsVftqPvYMfgHg0jjdc+qcZltQ/QIO/v5ZHF8L/i6p+gXS\n    MaCWtmfl75bq/QLbUv0C24e/Q/nbzvaa+hmwA+ABf00WBsDAfUHgX684vwGB07YFCAysC4IHBE7b\n    gMC+bQ0Cx8ZsYVuAwMD21MBAHAS3gMDkq9a2AII1H5q/bxJ91obBNKclgDD3v1QtScs4SwPa1rWD\n    AR2orq2EXkqZKoPhrcZ9Nwv8tvdpsbUUvrHvGgP2btu+Jt67te4NSwFhafJvqJXfpaFwaNylTau5\n    3uN7+xJlBsis97SS+3Hpfb/nffadAlTXBr7avNZQ+2o+csHvpdG1JPD7I+K1elNWCn6B+6r1C9hV\n    v8A+4S9Qrvwd8Ne3AX/jNuDvZAP+2mzL6t+tg19gM/AXSAFg4H4g8K9XnNtWU0EDAwJLG0rgkQ46\n    xz4U9FkqJfTSEBhYRg2cgsBAXxCcC4H5T6ttOS00+aq1XBCsAVvtWA9VcAoEA/nB416poj8rvpcI\n    bOeC4RKV0hZsLUVwj/XXBqlzr0Uv2Kv5lterNPCfe93XAr4l6rccW/pznwsecqzXwzgxy7nme7k3\n    5o5b+t039bfc8rNZC4Vr76e97vNr2JYeNOml9O1Z+iA0H/4db+3UznJuZLngt4faN8f3VsFvj3TP\n    qXOa/QU28Eu+11b9An3h79Lgl4/515n9Sq0E/AID/oZswN+5Dfjr24C/un1MnN8D/AWAr9uZZxoA\n    AwMCt7CtQuAeABgYELjGtgiBgf4gOAcCA+1A8CNAYECHsj0gMDCB4KUhMKCD4J4QGOinBk75vjcQ\n    XKoGDh1vqQrOAcHAdmBwzJYEOjTW+8R5q20FBrdYS6lZrkFvFVJs7UvCXnk9asbaErQI2R7TOfcE\n    ur1tDWCcsth9Zsv3R+saYmZ5uGMpKLzU31oOHF4S+G7xXlNyDULrWHoPjc2FbG3oG5tfDvhtAX1j\n    fnJUv3sCv3Q+ZGumewb6qH6BCf6uDX6BfvAX0EEury+8Zfj7qXLMljV/B/xN23nl8Qf8nduo+zu3\n    j4nzA/4WmQ0AA8C7DdZB02zLEBjYZjroR4XAQBgErw2BTyuPvwcIPJTAusl/IKwJgUNjtrC1IbAc\n    KwWCl1YDA/3SQgPtQfDxzYcVBAP9VMEWP98k2pKVBKJbAgeam8XnWupWDogHDM6ztQPwfHxa75fA\n    8VZrbKHu1fxarAVcaakqXvv9J7Oqse7B+P1+K3C4NRBe43Nec5/orRKW97P3geNr2iPsNzHL/czy\n    fWqtdVnGpXtry3tqC5UvNz63VH3fnmrfHP8EaVNKWou1Ar9An3TPqXOaWVW/3G/PlM9bgb89wC+Q\n    D397gF9gwN+W9rvA8bXh79rq3y3AX6AMAO8J/gJ1AHhN8Ev2MXJuwN9iswNgYEDgVlYDgfeUChoY\n    ELjGBgRO25YgMLAdEPwoEBiwp4TeAgQG7ksNDLQHwd+9+alVBGvnSoP1Vhj8xbD+tYBwKbRYOqht\n    GS+kKN4yDLas7Sva1k1seT20AHAtJNKuR0rdWzPunmr4cuMpP9cGMDwQf8+Qt9S2BIfXBpLStgSE\n    Q/5r/760NbZ8H1rdj6iWfSoCtPb9Jvd65Cp2l1pf7jit77MlGRgsc36PZbW8mQAAgABJREFU68z3\n    GmrfnDF6gF+gXpm9JfDLf1rGvfeUz8CAv5p9ajDmgL/L2laVv0uCX2Bb8BfYnvp3bfj7MXF+L/B3\n    Q3V/ueUB4L2kgiaLgeBfrzy3AYHjtiQABrabEnrtdNDAqAucax8K+vSGwPIfC48AgYH/f3v/kiRJ\n    kh5YuicQ3XhkJRLeCUoqojtpH3RPMMUGfBNYELZzaxHXF3BrWpO4A41xNYocVUACCaKE34GGwNTU\n    VERYRPjxM/M5k/Rw1weLqJlaun7+s7zH2ZLXBX58rojXBgYh+LmSGJwCwdAfBudYf8nnygGeKc9z\n    9kPj1iCTcn5KQO+Rlg+gHqeJz9YL+G59OH/2a+3q+4TQm7cjOzHsdXY77a33n9pYffa9OgcKL99T\n    pXbhST3elGNp/Q9QSv2sywWvqecnKvQ+lnMXhVLgu/SMna3QN/V5lmv8lpj4ffzvM125zi+sA+9R\n    +IXj1/qFuvi79lw9Xu8X1iG3Nv72PvUL6fjbastnEH/F39c5/fu+286fi7+XOwbA0BcCR54EjgjA\n    IAKv5TSwCHykTyfuUxuB4SPKjo7AMPc0MJSF4GewzQXBrx57rT18LYnBrx5n71q8j539cLvk+s9W\n    CjtzToVFqwYQr33QUxoaUiZ7U9axdY5mBt8cCb11S/2HQqVa+15qNbl85v35CjTWvpbwkeOuhdPR\n    J3yh7o4PLR43xz+2KQ2+8HrCNdc/FDqD36nwmwt9oR78Ln++Vaup3+XxZ5n6BfH3uW8Xn1P8rVvr\n    LZ9B/F1L/H3fbefPxd8sHQdgEIFzFfF6wCACr+UkcGwEzgnAS1cg+NOJ+4yMwBAHgkeYBt56/JTn\n    7Q2ClzXnguC125TC1MfrBqZWE4Rrbl2a80P1M48VHYKvHFuED/RzYW+JZgff5fgjfJ2cLfX96eyk\n    bMvWtrev+dzP9QTCuZ9z7f2i9W4OV9bQw/f+mffpXMdV4/xcgdMr72tHjm3tZ0Up9E19vN7hF65t\n    9wxzTf2uPd9o+Pvrp+MRf9MSf7cTf98XCYDF3/fdEm7TAwAHx1+4AsBAFwi8B8AgAr+qBAL3cD1g\n    EIHXanVN4KUWEDzKJDAc2xJ6BgQGp4FhG4L/5OJr1AsEv7rd1Q+9t7b8PPsh/5UPnY8cT87tSq90\n    9HhHxuCIrX2YnOuavTkSfNs8r+WrFQoLwuvP22paeORKT/pGeA88iqdX/xHL0WPe+nmxrKUF+qbc\n    bkFfSEPUlJ7h9/H3zhQNfh//N+V5S8EvzLHlM4i/uYp0vV8Qf9f6643jrwnAZ+AXyuBvRPgF8TdH\n    P/3yv0MCMIjAOROB94uCwK23gv7dL/8bDYJF4O0+Hbz9LAj86nlz9c8bj/s8DVwKgZ+faw9kS0wD\n    pzzv3rRvZAh+9fhrncVguPah9x/4YROCocz2l3ulHtPa+qP1eD4iYnDuD6BrgUMq9EI/2LscU45z\n    GAV8xd55OrOjRI7nfFWunw1/yvfD348t/wHPkX/o0vq9+kw11pxj0jf6+933A+trBb5b9/9X2qFv\n    ym1zT/vC2PAL6VO/j48/+rV+IR7+loBfEH9L9AqAxV/x9znx92O3hNv0hL8wAQDDOAgM7SBYBN6v\n    JgJHnQJeijYNXAuAYR4EBreEzlGkLaGh3bbQKc9dchoYykHwsvbl8bYw+Mh1F/9Q4APvV5j66oPW\n    FiCcenyPa4s69RQRgKMeN5z74PjPDvx+ic6A75mez6ngm6do6476XnZk7TXfw46A8NnXuicQrnF8\n    j0X7/jlTy62ec/e4rr3jyrE9fc5r3j8/1p/x/dIar6Lv3u1LTvsuj//q98885tr6rsDv3p+tFXHq\n    N2W7Z+h76hc+ft7y6xfHExF/v2V4TvG3buLvW+LvftHxF+IDcEf4C7kAGOIjcCoAQ78IDGUgOBIC\n    Qz0Ijo7AP056TWBIR2DIB8EjITC8/UVjD4FLAjA4DbzV2W2htx4/wrbQSy2ngo9A8Nbtr2Dwnz89\n    7taHwWc/2C6NwlvrigoqqevqDRP2jjXnB8ZHu3ouj64jJxJEuZbsHzIfV8muTqLVquU/tClZy2sJ\n    P5d794gj5z/H8bd8D7z6/h2t1HMZ9Vi31vXq2HL+7Cjx83t5zAVbW6Pv1n0e0RfGhl9wu+fHxN/r\n    tZj6hXz4GxF+4SP+toRfEH8fE3/3a4W/twO37Ql/YXAABhG4RE4CpyUC3xOB04o0DfzpxH1aIDDU\n    g+CZEPjx+SJPA8MYELw85hoGH4Xgrfud/aB7uV8qBsO1D7ZzAsbjMde8pnHOzq4jAq4srX04/AwI\n    r461Bb7tnbuo4HvmA+0z7zE9TPemrK3lluC5S/l+j/Ketraus+9ZOb/uW4JwyjmI8n74/H6d8h7f\n    uivnrvV73VVgbY29z+tJeewr8Lt2n7PbRbeC339Z+f0rj/lqjS3h9/nXe88dBX9rwC/Uw99frxzP\n    3mcxV3PL5/xFm/oF+GOAvy9EwN+z8Avib41uB24bHX+hu+lfuArAMO5W0CACPycCf0wEFoHP9Onk\n    /UpuCd0agaHtltDwBrOlt4R+fC7oF4Ifp23PVhKCn9e9t0V0RAyuNe2U40PkV8ecC0lrfcgdDYNz\n    fCi+96FwJEBIKTcU5Abf3Gto3dGptxnrcScEyI+xW9UCYYh9zl+19T0W/Wfo2feAWuBb8mdo7Wv2\n    pq5r67kioe/afZ/Rd+kq/q5N+z7/2dnHjQK/EG/qF+ba8hna4+8Z+AXxdy/x93V/vbOG6AA8E/5C\n    GwC+Hbx9dADuEH8hBwBDXwh8BIChDQJH3QoaYiGw1wR+KyICQx0IPoLAEGdL6E8n7ycCX6/XaWAo\n    A8Gpz10LguENaUtA8PK4uSF4675HP+R+NRUM9a+JePVD45TjjnDdypzH/qd8D3kd3KPlBoMzHzg/\n    fkCeC4oigO+yjtwIUuqaokLv+dbeC65+f+X82lnWEgGEc65j+V4/c65LnYtS8FnrZ86Vv4McOfZa\n    QJzy3tYaelPXufWcZ+E319bOe/dfQ18YG36h3XbPj88RZeoXxN8cib9lEn9fF2HyF+bAX3D6N0Kd\n    4i/kAmAYF4E/N1qjCJyWCPxWawSGdtPArSaB4RoEfzp5v9ERGO4QXBKBYR2CnxEYYkJwi+sDQxsI\n    vvq4W2tfw+ArELz3GKkfLj/f7ioIQ7uJolwfqNf6oDsngKauOTK0HTkfZz8wP/tB+dbXVgTwXdbQ\n    epvTrZ6BoLcpyh5aXv/n679H7N/4oQsQPvtec/br+8g5ifr9fuRnaM6fSZFQN6WjX1u5ji/HJRCe\n    f7alHkuJKd+1x1gwtjT8/svGn1153J7hd3meWaZ+Qfzd69uF58wJvxAPf/9h5ffFX/F3rajTv+Jv\n    nhYA7gx/IScAwxsCRwdgEIGvVAKAoQ8EhtgQPDMCQzoER0JgiHdd4EgI/Py8uZt1GnjreaJD8NXH\n    3lr7KwzO9UH9FQxeu82rx2yJwqlrqAkLZ3p1Pv7w4b/Tz3P0473S2Z9/NTHgz6g/3VvzGPd6deyR\n    tp1ujc0RXqcj7/EtagXCy/dvrWM8058T42uoREfeJ2q+x7Y63pyvc+7ts8+8z5cE31ePtYe+cA1+\n    t6Z995439bEjwS849btXLfiFdPz1er/r9YC/reEXxN/HxN/0ogOw+Fu8vAAMYyLw54ZrnOl6wCAC\n    5+h3wP8IuCW0CLzdpxP3aYHA8AayNRAYykPwP+88bs1rAz8+Xw/bQkM5CF67X66p4F/t/PkzBuf+\n    IP4sCL/68721Rbu27eN6RsHRK18f0c/BEQR4/lorCSNbH6CnPm+Ocx8JfKNjr6UXGYVzg3DK1+jW\n    z7EaP6uWjnyfj/Te/twI4Pt8Dkq8h1+ZSN5bz9prsPa61twRY3m8FPSF8/D7/Lj/kni7o49/FX7h\n    NfKOBL8QZ+q3JvyC+Jsj8Tet1vgbBX4hHv5CGQDudfIXxsJfuANwp/jL3/A9PwDDHYF7AGAQgc9W\n    CoBBBM6RCCwCl240BIaY08DQDwTDa1QtBcFQF4OX5yv14fvRLTCv4sDVqbtSW0lH/8A8td5AOAcS\n    /hnfPxz38iHw1e+bHNh7pJRtZwVfq92ZfwBUoxQQzv11ufcz7OrPqFfvZ1u/f7Qe3+dF3/VKQu9j\n    R9C3xSUQ/ozvm9f0fS4H/P5L4u3OPHZU+H3+9d5z14BfcOq3ReJv/iLi72/5zn9vugLxdy/x9323\n    xNuJv3UqBsAgAudOBE6rNgLDOgSLwCLw2T6duE9LCK6FwOA08F5Xt4Vee66cEAznsDYVgs8+/tq6\n    19ZREoPh2IRwThTIsR3rlQ/enQ7+WK7zkAtgcn9w/Hx+9j5IbwWvf/ofmP14Lup1dNqrp1rAUgQ4\n    vVoEEF6+Hx6/F1pt6310Srj0e9nZorznjwi+cP5nSI7rC5997pR/7NPymvf//h/XON9/ntLom7qO\n    rfv0Dr/Lc5WGX4gz9Qtt8Hcm+IV2+FsDfiHmNX/F3/eJv2m1xF9IA+Be8Bfg3zpa63N/c197OQCG\n    vhAY9iH4c+P1icBpOQn8VmsE/rby3NEQGPJC8IwIDE4Dl2wUCH7+79wQDHmmglMgeHn8P7y4bnCJ\n    UieES4FA7g/0U+BsRAyGMiCcGwFrffC/te5/44cm2Lt8yF/iuY+A8QjTvSMAUk9QnOv9Pwd0Pba8\n    l9f8BxOPz7v2vdziusa5KvFzYITv16Wj6Jv7az7Xz4/n1+RfV369d7/cLQD7Z4XhN3WL57Xbn3mO\n    53WeWfcz9NaGX5hz6hfi4O9oWz6D+Nsi8fdjZwB4NvyF2NO/PcEvDIG/UBqAAf60o780gwh8Nq8J\n    vN7sCAx9TAJDPASG/iB4FgSG+tPAj8+ZArH/aeXXR4sKwSn3q4HBj4+7fMDbEoT//Ol/U+5ztZLT\n    XgsYjIrBsP66rH0gnQNRWnzQv4cTzx+YrwFw7q+3kuB7pNbPf6aRwOhMPeHwY60mdJ+fvwQIP34f\n    vQLglGOv/TMm19fR0Z8Zo33/Pm/tnBt1Hyv5fn0UfWu9jv/y4rlqXNu3Bvo+rzUH+q79Xkr/vPPf\n    W8/fYuq3FfxCu+v9tsDfM/AL8fA32pbPIP6uFQl/Z5n8hfGnf3sC4EHwF2oAMPSFwNEBGK4hcCkA\n    BhFYBN6uJQJD3xD86cR9ZkLg5XlLNco08POvj1YDguE41KbcPscW0Ue2h16qNR38+HxLe1tF14SL\n    3Njww4nHq/WBfo4JzRzn60/53gzKU85BiQ/PU85bFOxdW0OOr58Sr3tLKLpyTlr+Y5ES77Glvj5a\n    g/CyhiMgnPN7OCIKP/YHfmi6/XDtc3D26/x7xq+JFj8j/ozvu9fyrfle/DzlC8ew9SiiHkHfM+tZ\n    u30k+IX42z3D3Pi7t+VzJPz9luF5W8EvtMVfr/l7bw2AZ8ffUvAL4m+kBsJfqAXAIALnTgROKwoC\n    twbgpR9F4OTbisDnG+26wND/NDCUg+CjCLz0q5VfL5WAYLiOwanbQz8/ds3p4Mf2UBjOgWruzgLE\n    8/1qbzFaq8fjPPvBdIkP71thb2olJ8COVAp7c/bnlMWFaMe7VUno+gM/hDoXUUF4qeV7eisYPvv1\n    8bzeCP/QJXfP7+lnjjHKeVkD6+X1r/0Pb16BLxxH1iOIegZ9z6ypBPxCvq2eYaztnqHOls+Rpn5L\n    Nhv+1oJfEH+3En9fJ/6ud9v5857w9//iO/+t9SIu1BSAQQTO3UwIfBaAQQR+rjUCw0cIFoHT+nTi\n    Pq0QGOp+rUWcBgYhOKU9CIaYGHwEgl89disQXnqFvs8Taz1stfz4gXdvGHzkQ+hnAM4BNKmvbypG\n    tP5QPcd0by74ig6+EbcAj1SvWwCXOvacIHz2+/NxDa3f21PPR+732K1e/VxIOdeRsH+tLfRt/XNn\n    r9Qtm3NOLx/p1bbOEBN9j65r67a/P7jm50rB76v/3lpDi+2eYb6p38fnrV2rbZ/F3zb9McjPtN7x\n    F8oAsPi73m3nz8Xfev3N63NdF4BhLASG9hA80zWBR0BgiAHBEREYxr8uMFyH4E8n7+c0cL5Sp4Gh\n    3rbQy/OeQeBX/32kXBAMb6haG4LhHAYfReCtx20JwsuH1I8IsQcSEXF474Ps1mjQ+vhzFeED90cQ\n    qL2eV+c5MvjmxN4oxxS5XO+NkVF4672m5vdjyWsJX1lP6SK8B5dua/eGiMe/9974+D68/Lr2++na\n    hO9jZ66nmwKpEdD3ca3RJn5f/ffeGlpM/W4972jwC2lbPpfqLPyC+LtXRPiF+PgLdQFY/E0vOv5C\n    XwDc89bPEAiAf+YH/u/WZyOxFAAGEXgtEXg9EfieCHyuTyfvNwsCwx2CSyIwxJ0GPgKwvUIwHMPd\n    M9f8/YuD98+JwdAOhF9h8Kv/TnmMSEWaHmtxzEe3Qn7+gL31OYt07d5X/RnfD/3/itJruZrQm78c\n    74tRUDjie/xSFBR+fs89gsOv1h71vS9nLf9hz15H3xP/7MPP0PromwK+S7knfp8f7yj6Hl3T3rRv\n    6rq3WuD1CvrCefhdnjsa/EId/K0Jv9An/n67+Lw54RfE3yNFwN+/3lmD+Ju/q/ALbfH3lng78bde\n    f7O+/jYADIjAGbsKwCACl+g/7/y5CHyvFwSGWFtCfzp5v1II/I+wi7y1v94iTgNDeQg+uiU0lIPg\n    KwgMaRAM6cB7BoLh2HRwbgh+7A/8UA2Enz/g/0MCVl99jpqNBMKpuJvjOsKPlTpvEbH31QfoVz7I\n    zwV5V7FX6G3b1ffAnCB85Wvp1XFEwWooj8JXrzV+9tq9I/3savl+f+Z9cO/7JffPjJSOgO9STvjN\n    gb5H1pVym6tbPUMe+P3ng7+/toYa+BsNfqH+1O/jc9dO/C2X+Lue+Lue+Pu6W+LtesLfn4D/s6P1\n    vmoNgP9rCwAGEbhEInB6IvDHWkOwCHy+TyfuUwKBUwAYxkRgSJ8GhnrbQl+5NvDW7x3pX05g9Kty\n    QvBZBF4qicFH11ZjSngNKI58uJ8DAkpicbRrB1/FBHj9YforAC6xZemR8xcRe+/H8H49I0DpCMcw\n    Q5Gna68cQyQQhnMonOO9+bnUa/fmeK9u/bMN6qBvjve6o/8gYu32pd53z2DvUin0vQK+qWtLRd+U\n    te81G/yC+Nty6hfO4e+3DM8r/rbpt3znvzddwT3xdz23fX7dLfF2veDvT7/876j4CwEAGETgnM2G\n    wHAegiNtBw3tIfh3wP8IiMAQE4LdEnq7PQxu8Q8OokFw7W2hYS4Ihn1MvQrBSykgXBqCH3v8kD03\n    DG/BRI4P91sBweNxvfqQ/flD8xIIkFotKC15Lcvo2AtxsPTsVGbK+qOB3Mztvc5XUDjK63xkV4lW\n    PaJw7vf5Ed6793oFzM/ncTkPrd5jc14TvRb6XsHex3LAb84p39S1pa776vV9l4Tf+eAX9vE39R+7\n    n2mUqV9Ix99a8Avi71ZRrvcL8fAX4k7/9oC/0AcA//Tw61EB+L/e/6cNAEN/CJwKwEufG61zpusB\n    L4nAeRKB+0ZgiDUNDHNuCQ0xt4V+fN4rELz1+ynlhuDnX6/VCoOfH7vk9tB75Z4WzjEZnKuSz/lv\n    /FBkIi8agqaei70eP/jeO8ZWk45RwffKh/sR1r905vsxJ8qMts61ekfhSFPCz98/f/70e8t7X+o5\n    H/X9/Uz/XuhctPpeLI2+ubB36Sj6wntALQW+e2s7ir7Pvz7TTPALr/G3JfxCO/zd24I39bONM40y\n    9Qvi75Gib/vcC/6Wgl+Ii7/QDoBvB27bG/5C3wC8g78QBYBBBM5Z1ElgEfjeFgSLwCLw1T6duM9M\n    CAwxILjVttDLc1+5PvDa7x0pFwRDXgzOha1LW9PBNaeC18o1LRwJg3O3dwwjbNd6puXD7n/jhyLY\n    keu8RsXetbWlFGX9OesFgKN39vsmwrko/XOkxPfN8v43688B2D+vkf7RxNlKoG9u6H3uLPy+ul9O\n    9N1aWwv0BeF3acapX0iDuFLTv6Pgby9bPkN7/P3tL8/fevp3DX9rwy/ExF8oA8BO/sZpFPzd2fb5\n    sXYADOMj8OeG63QSOL1Ik8CtARhE4KVWENwKgSE/BC9/Wdr7S9NfUR5jn/vNw6+jQHCP08B7f7ZX\n    TgiGY1tEwzqqlsBWeI2sf3LiuUqt77ErOBxpsqt0z8c1EgQ8fri99iH1H/jhw5+Vfq23znFU8B1l\n    ujfXMY1U5Pe2nkF4bf1/2PxHXOV7/Lp/9f73vM6RfiYspfxs6L0cP0se4bTWeToKv88T2rmxd29t\n    rdAXysLv3p89r2FW+IW4U78la7XlM7TD39ZTvxADf1vDL8Sa/IVzAOzkb91uB24r/tYtYfJ3qS0A\n    gwhcqqhTwCACgwic2isIFoHT+nTyfjNNA0dEYBCCc3R0KnjpGVZLQ+szrP7q4HPWgOBXpeLwyJPB\n    a/UGwjU/yM/9ukeGh5GmeyOf5+hFe6/rHYRrra/k13zPPyNg7PeDM5O+LZD3uSPo++d8fweoJcF3\n    bX1n0PfVf5/tKvzuwW5U+IV0/K0JvxAPf0e83i/kxd+IU78Qd8tn8fdjESd/xd/X3RJvJ/7W7cD0\n    L0QAYBgbgT83XKMIfCwR+H2RERjcEjq1TyfvV2IaGOIhMNTbEhriQzCkIWyPEPzqv7eqjcHwhqmP\n    60x93lYY/NwaDs+Iwc/HV/uD/p4+uN/7Osg12VvqNRgBfCN/fYxWpPe9aCh89Hvi7M+WyF/vLX9u\n    wBwTvnvH93gOSm/XfKYURH2+zQKoNdD3+fnPou/a7x3tEXtLwW/KbWrCLxyf+q0Bv9Bu6vcfeQ/P\n    W7fLDcBn4RfE39TE3+3E3+3E39fdEm8n/tbtIP5CFACGPhEY0iD4c+M1zrgdNJyDYBH4Y5EhWARO\n    69PJ+7VC4BZbQsMdgms97xoEryEw1L1GMFyH4JQ/X+tfDoL0Xr9K/L21HnG1JgSvrXNvDVEweO2Y\n    Xn0w/+fEQpFS5Zj+egUkkT6YLlENKD3yWvQOvqN/vfRYlPe/WiBc+nsh+mTt1dZ+jh6tp38olKvv\n    L47x+bhrIemR9hD11Z+3nPa9gr4pf7ZXDvSFvuEXxN+lVPwt0ShTvyD+Hk38/Zj4e6zo+NsD/C49\n    AnDP+AuHtn5eigPASwsE9wLAIAJfrRQEOwmcrwgIPPMkMFyH4E8n79fqusDgNPBjkSE4BXlzTAWn\n    rGWvX538s8cWXK2FrK+2id5a197vRWsPhrd+H/r9kH/50P2HlWOb4UP4M9ttLtXEsj9794F2emKv\n    XS0CCh99j12+7muvPeXrfKbr06ce579S90P6nG29x259PTz+WUTofS712rmvsLT2tG9r9IV6074p\n    txN+32oFv+CWz7kSf4/V8jrTj4m/65WCX5gDf6EfAF7wt3f4hVPTvxARgKE/BO5hO2gQgY8kAn+s\n    BcY91xMCQ7xp4E8X7ltqGhi2/8LV6utOCP74/DkmglNv86rn57+CwXvYm4LBtSF46dU1d/dQuAcI\n    Xjs2KP8B/ZnHz4Vqe8/dK3A/dwV7j5Tja6VnMO1l7RHR5S+uP0SVegbLiN+fo1+eIOU9Nsc5bflz\n    9OhjR3z/edUWqq4hac1jOzrtuwe7uaZ9X/13ajng9/m5Z77OL7SF35Sp39Qdys7UCn9zwy/ExN9/\n    WPl98fct8Xe9kvgL1wG4Jf7CWNO/4i8QFYBhTAT+3HqRiMBHqo3AIASn1nI7aHBL6FylIjC0nQaG\n    thD8+xe/PzMEP6+hJASn3KbFtYKX9sBiWXvLNZY4vlE+mE8px5bRtdr6wD3KNCy8P6dXAKLEB+1H\n    EDIi9vYCK2eLiMRH3w9bf93urT3K13WvMDzjls57x9rL+9Izoi7/nQKjtbd3fvXfz6WC7ln4rY2+\n    e7eNBr9ra6gNvxB76rfU9O8Z/P2W4Xmd+m1fBPz965019IK/UAaAI+Nva/iFsfAX7gA8Ov5CxwAM\n    dwTuBYBhDgQuCcBQBoHPAvCS08AfE4FF4FwdQeCW1wam4nOfgeDa20IvbeHrEeDNNRW8t6a1jlwP\n    OCIIH/nw/Vcba4oMw2Lw+vHWRuFeoHdt7SkA/IcP73XtW1trbZSMcC6iFuW1iPC++HwuXn39Rljn\n    0bbeb2sfz4zXg0893qjvU1to+u8HX7vSx5i69fRjRzD3DPy+Qt7Z4Rec+n0uBX8hDvyC+HukqPj7\n    /wD/R4B1iL/bib/73Xb+XPyt30X8hegADPCnnf3FcA+BP7de4C/NNgncEwL/54TbRIBgEfheKgRH\n    RGDoD4JbITDEheCW1wdeigjBe+ta6wgG792+xXV5zwLEv/LD4WNplRi8f9xXUbhn5E05hr32Plgv\n    /bVWGnFS3ieiAkqPtT7ftd4bt75ur+B4D+/te++5V49B7N0/7kjvWVtQ+nvSr5Vb8xjX1rR3LEfK\n    hb4pf/aqI+i7dftXzyv83ot+rd8l8Xc78fdYv+U7/731IhB/UyoFwL1v+bx02/nznvAX4N86W++r\n    9vAXBgFgEIFLFRWBo20FvRQJgSMAMMRFYHAa+EifTt7PaeA6nYFgqL81NOSD4DO333v+oxh8FIL3\n    7rMFqCVw9cqH7a/Wc3TyuWaC8P6xP+PEHhz0grypx7NVqQ/UU7/+oiJOpK2Cez/2iMd95P2x1Nfo\n    6Cj82FEgnnkr5+ciXs/37CRsJPjdW8uRaw/vdfR+OdEXxofftXXMAr/QFn9bwi+Iv60Tf18n/qbX\n    C/5CXwD8f/Gd/9Z6ERfLhL/QCwD/DfD/6+wveTNsBw39ITBcg2C3g/6YCHxvVgSGvBD8j0//7TTw\n    W68geA+BoQ0Ewzq4noHdo/fZw94jGHwGgrfumwKluTH1ylTwlWMtfVxHj7U3MDjT8kH5yMcaEXuv\n    tHzIXvr7I+Kx28dqYPGf8z3Urg65jn30972Rj+/V8b6qxbbHrzoCmhHQN3UNz7c7C75n7r8Hu6Wn\n    fbfuEwV+IW3qV/h9KyL8Qv9Tv1APf/9h5ffF37e28Lc2/MJc+AtjAPAt4TY94S/0P/2bgr8wGADD\n    eFPAS58br/MqAIMIXLoeEPh3wP8IsJbWW0L3jsDQ5zRwq3+E8JuHXwvBr9cBeSH46P1SoDcVg69A\n    8KvHOfrhe64P62tg8N6xRzjenj5IPwKeRz4wfnUOok0q9o69Zz/4P9Pj90yEY7d8PX9f1vq6ioDE\n    o6Hwq+/N1Pe5o+ci2rFvVXLK9+j3y1X0PPOcuY717PMvt89x7KmPkwq6R+D3DPqu3W/reUvjbw/w\n    C+Lv2b5leH6nftsn/r7uLP6Wgl8Qf7e6Jd5O/K1bZvyFngAYROBSicDHqg3AEB+Bf/fL/0ZFYKgH\n    wS0RGMbdEhqcBn7uGYJf4WsLCP79xnl4ha1RIDj1trkgeOlPLnzdXP1wviUG75XzPC/rrTUdnHur\n    zpqYt3YeSsPw1XMWBTxrgu9juT60XyoJR5G3su3puHP/LEopAghDHyi89p5U8+s/5/t2iXO2NeWb\n    +70093vkq66s+crPsCvP+++Vz/MRzE297Vn0fXXfvedsAb+wj7+t4Bfa4O+v+f7hc4LHvNbvsSLi\n    b/SpX0D8fVFE/AW3fl7rlni73vD3J+D/7GzNj2Xc9vmxvgD4Z37g/269iIOlIjC0heBZERj6geDo\n    CAyxJ4EhJgKD08BbHUFgaD8N3AKh9yD41yv3GwWCj9z/6HWAt25f4sP35cP1K4995gP63NcLjtjz\n    OX0+5pzHEQUjc5ZrWjgHfkQ6vy3AtwZklOzoObvyvVnzuSIkCl/rLHJGwN4a5f6HQI/fn8/nsJf3\n    uZroe/Xnze8zPc7WY7/q6NbNKbe/gr6vHqMl/P6vjT+LBr8w99QviL81En/TEn/3izz5C20B+JZ4\n    O/G3fnsAfAJ/oTcABhG4ZCLw8UTgj4nA90TgdltCzzgNDH1CMLxH1qsInPo4RyF4634lITjnc6R+\n    SD8DBkOb7ahHa2taOBd8iL2xajXh3FPR3i9mRmHIC8OzQG+ujrxfRHuvy3Vcz6X+TMuFvTkfM/V5\n    joJv6v1yoO/j46SsU/h9q/XU7z8+rWHtNjAe/ILX+42CvxHgF8bA316nfqFv/L0dvH1PACz+btYn\n    AC/1AsFHABhE4LVE4HsicHqtERjcEjp3PV0buBVCn4VgKIvBexAMb8CaC4L3HussBK/dvwYG536u\n    f91AvBKP20N757bnY2vZ3teU2BsnoTd/Ud43ZgdhSPv5Fun9qJf23jcivceVOL6tXn095XyfXTu3\n    NdD3LPim3D8X+i6PlbpW4fd90ad+YVz8nWXqF8Tf1MTf/aJu+Qx9TP0u9Ya/MDYAX8Bf6BGAoU8E\n    BieBc+V1gbcRGOJAcCuAe+4VBEdFYHAaeC+ngdPaguBf79y3NQTDHVdzQjCsY/BVCH5+nJoQ/Fzt\n    a+fmXHvkts7rCMe3Vq4Pj6Ofo1nBV+htW5TvC1H4Yzm+N6If49UE3+1aXsu4JPxeBd+lV4+TE3wf\n    HzM6/MI2/s4Kv6lTv3/18L+5E3/r9Ap/I8AvpP0DhBr99c46auOvWz4fz2v+lmkG/IVJARjGR+DP\n    jdcpAh+vNgJDH9PAIvC9ERD404X7lkRgiDsNDLEg+Mg0MMSAYIA/KXDuSmPw8lgtMfixXOt4fJwz\n    52qED8RHmhAuBYBHPvj/Q6Ep9NrHnOt8lErs7afW7yEtQLjkcV/durnk+Wj9Wh9pdPBNOcbnnmEx\n    1zk4+zglwDkX+EI99AX49wPrLgW/e+gLwu9aKdf6jQi/EBN/o275DOJvSqPgL5QDYPF3u1vi7XrF\n    XxgbgC/iL/QMwCACl04EPp4I/DoR+C0huN00MLTfFhr6hGAoh8FHIBjKYDB8BOGcEAz3D5BzP2aO\n    D46vfrC9d/+9Y+7pw++z56DVMdYAv9If+P9h49ylAHEr9GwNIWLveLV+r4yOwq2uz1vjvLR87bfe\n    S1q/z5U+xlT4vHIecpzD3O/3f8H37K/t47ksBb5wDH0hJvy2Ql9of51faH+tX/B6v+LvvR7wt5ct\n    n5d6xF+4DsDib/5Ggl8ojr/QOwCDCFy6WRH4LACDCLyW1wV+SwSe89rA0H4aGMaB4P9EflB9fnwK\n    PMfzh8W5Hr/EB8RHP9g+80H44/G3Bo5cldwuujbsRfyAfw2FH6GnJla1Pkdi77y1fM+sDcKP32cp\n    7wFRqn2eSv6Maf1el6NXx3d0wvXIeSh1znK975eaYH5+/JLo+xd8P/z4wu/HWk/99rzdMzj1eybx\n    dz/xN63I07/ib/5mwl8QgN8lApdNBD6eCPw6EfitERAY4lwXGNwW+kz/zA8v4bU3CIayGAxlJo9f\n    fTCc4zhqocCvTv7ZWpEx/Eq/4u3D2mhrG+ED/aU/53vxa2W3Pl9ir+3VMwqnfH8d+T7voVaT1Ws9\n    /qxq/X73al1XO7ud8e8P/n7Ec7B27CWO4egk7tljiQC/KegLH+F3WU8U+IU2+Htk4hec+k0tMv7+\n    w8rvR8Df3/Kd/956Eb8k/qYl/q53O3DbXgBY/D3dD9+/87/z3wb4S5QIXDYR+Fy1IVgETi8CAsMx\n    CM6NwOA08F/RDmEjITBwGoKhDAafhWAYB4NzHE+rD8p/tfLrM5V+PWtXY8voSB/cXyk3eKac28fX\n    p+V5FHstV5FQeO97qsX3fPRyIfEM1/B97Oq1a3+/8uvanfmeSDn2nMf0z4nPebar1w6OCL/g1G8E\n    /G099QviL4i/z4m/aYm/290SbtML/MJ4+AtVtn5eugMwIAI3LAWBP7deJNcRuCQAgwi81AsCgxC8\n    NAICQ9xp4MjXBgYheK8rELxUChCXx/1PFx/nsSMf9B45rkgAcOW2o2Fw6nFHm8bKXQTsXK4h+he8\n    fb/8y8btU65B3NPx21zl/pmw9r2yfJ8sX+P/Qt7vnQjHHq3HXSe2GvFnyhZCHj3eXtD3CLzmOqZH\n    fC0Fv1fRF/LDbyr6Lrnd8+tS4He5HTj1e6Qj+Cv83vvtL2sQf18n/h6vF/yFfgBY/L3cWAC8tECw\n    CJy/yJPApQAYxtoOGmJBsAh8bxQEhngQnHqtoH/ih2J/wUzpN7RHYFiH4FQEXsqNwTkgGMoA4qvH\n    vIrCZyd+9o4vygffuSaato6nNTLANiBeWWuU1/FoUaAz9XVZ6+j5f3x9o5wDs8eev6bPfI9c+dqO\n    8H796jz00plzn/IaR3hd9taZ4z01CoZvHcsVaL16fK/gtQT8rj2m8Juvlvi7gG6v1/r9lnEN4q/4\n    +9xf75wP8fct8Xe7W+LtxN92VcZfeARgEIFbNwsC97gV9NJZCBaB1xOB32p9XWAYcxoYjk0EOw18\n    LxcEQ14MzgXBkB+Dtx7vCgjnwtLn9UX6oDvHMUY6ntylfAgf5fijAedV7G1ZBHypUe3XaJbzCtfO\n    7fKe0up7OtLrFOX9FdJej57f93Ic/15RwPfV8eSE1TPHuYetOdeX8littno+ir5LC/4+rmV2+IV0\n    /F1u69Rvem75fK5IWz6Dk7+pib/b3RJv1wv+whsAi7+Xeg/AMB4CjwbAIAKnFHEaWAReLwoCw2sI\n    FoHP9enCfVtvCx1hGnhZR+v++WENj/g6EgQv5QThlMc6isK5IPjVGiN9uF1jOrj3UmGk1DmIhrwQ\n    Azyunpccr1cUNIvweuRqpHN65Gv0FQBHeF+N8noslTwnqa/XSN9vV87DVlHRt8QkbeqxpuJqrjWm\n    Pk6rid+z6Asf4TcC+sJ7cO1h6rdk4m97/I0Av+Dk715n8bck/EJs/IV+AFj8bVcj/IVXAAzjILBT\n    wOWKvBX0kgh8TwQ+ntPA93JA8KcL9y05DZz6F8yWEPybh19HgGB4PRV8BoIhHwaXgOClHCB89DFS\n    11cSg5/r5frBW0VAi9LlnBKOCLyPRcCOiOfo6td5KqxFOP+ROgKSV8/diF93OYqGwo8dOT+zT/ce\n    OQ8pRb2Obyv0PQqrOdZ55DFawO8V9IU7/Eab9l3qYbvnx9tHm/qFPPg7G/xCfPyNAL8g/qZWEn5B\n    /I3cT4i/mXoNwDAWAvcEwNDPJPDsCAxCcIlabr/7nNPA7aeBSyHwUupfNiNAcBQEhtdTwWchGPJg\n    cEkIXroKwmfvv7XW3BB8ds21AEAQPl5kGNkrCnRERLcarX2fRJqki9DW+5JfO23r+f0P4rwHli7n\n    90mN96fU9ZaA3pRjPQqpudZ89r614fcq+oLwu9ZR+C2dU7/tp34hDv7+P8D/EWQto+Bvz1O/MAb+\n    3hJvJ/62qzH+whYAgwjcspkQGLwucK22EDgKAEMcBO5xEhjyQ3BrBIby08ApELwAbAsIjjgNDPkh\n    GOpj8JVr854F3RyTxa/WHQWDt8qJAmLw+1I/kE49b7mvkb3/fDGaDezE3DaVfr+OWJT32toonIpi\n    qd+LUc7j1SJO+eZYU230vYK9V9d99Vhrwm8O9AX496c1RIRfEH9bT/2C+LsUBX//GGQd4PV+UxN/\n    97sl3q43/IVxAPhvdo4hBADDGAjcIwBDOgLDGBDcKwKfBWAQgbeKsiV0BASG9tPAERAY4mwLzYHb\n    56wHCIY7wF6FYLiOwTWmgp87gma5ge1x/T1gcGqpH3bnOOYoH6zXRsgj5+7Kax8FeZdmwl6ht49m\n    guEo77ePXcXh3Nibqyjnuhb61n5vL42+j8ecC3zPrD3HcfaIvv+J7x8eS/h9KxL8gvgLMbZ8BvH3\n    VeJvWtGv9wvib8nE3+z98P3/y//O3+7cSgRulwicr6gIDPUhuJftoEXgjx2B4BG3hIby20Kn9Iiv\n    QvBbzxD8ly9+72xXMLgFBC+lYllJDF4qBQu1J0VTOnusUT4kj9BZFI6GvEtib+xqvT49fo/PhMIQ\n    9zX6iw//HRN7I3f2+zziOax9Hd+c8Juy9tzHVwt+c6EvvIbf5fejFGG758d1tEz4vSf+vuX1frcT\n    f8/VC/yC+NuyQPgLCwADInDgROB8icDv62Ea+He//K8Q/NYoCAxC8NWiXx946S83/uxsZ0C4JQQ/\n    tgWmJTG19LWEI0JwzuNbiooTEWtxrmaCXogJIzDO6xD1+10UrlfK1/KviPu9WLOI2zrn7iqM7h1b\n    7gnf1LWXmmKuAb+50XftMYXfe9HgF9pf6xfa46/w+z7xdzvx91yt8RfGnvyFMQB4D38hMABD/wj8\n    8y/rHxmBP7deKHMjMLgldImiTAJDnwgMsSH404X7RkBgaLstNPQHwWt/frajGHwUgqEcBi+9wtNW\n    GLzWUXCICsK54SQqEJ3t7AfvR85rjnM2CjAeKRKKzHj+14r0HiAMn+vI1/Or78MUAB7ttSnxHhDp\n    Pe6xIzh65hhqom+N7arPHNMR+M0JvvAedoXf9UaCX4g99Qvi75V6wd8W8Avi79nE37L99Mv/ir9F\n    egNgEIGjJwLnK+okcAsAhj4QGODHQGuJAMEREBjaQ3A0BF6qjcEREXjp1dbQW39+tVQQjgjBj73f\n    VjcWBq+19gH3LBgMsTDosVYfrB89x6/O34zYGAFCZjzvuYvwfjAaPKaU432kxfdg5NdK8M273pLo\n    +3gMtcD37DGlwm9J9F17/EjwC+3w9x+f/lv8vRcBfiEG/kaBX/B6v3uJv+cSf8s2E/6CAFwtEbhO\n    IvC5RODtnAZ+nwj8lhB8LyoE700Eb93uSikYHB2CoU8M3juWiB909wbCUT8832vtPP8531fhJgKk\n    laj1ayjytqn113PE999cnXkfaf19eLbSr2Pu94do5/lxPTWgdMRJ37PHtQe/ucEXXoOu8Lue8Lue\n    +PuW+Ps6t31OT/zd75Z4O/G3bUGnf+EZgEEE7iEROF8i8Fv/eefPReD1XkGwW0Kf79PF+0eA4Ff4\n    WhOCf/Pw614heO22V9sD4SjXCd5qDYBzwnCt47qy5lqAUWrL6GgfhNdqDxTOnO/WmHakVq+70NtP\n    rb6ee0PhM1/Ta99/Pb2H5OzxNe9xwvfq40fdDvnMemuC79nj2kLfEuAL65jbE/xCXfz9xxe/J/6+\n    1fpav0s18dctn48l/qYn/u53S7yd+Nu2wPgLrwB4aQ+CR0Jg6A+CReB8icDv6wWCReCPRUBgiAHB\n    ERAYhOCtjkDw2u1ztPacPUDwUgqiXoHWVtteR6k0iowID6Ww8exr0eIctwR+sXe8ZkThnMB7Nd+n\n    zxXxHzr1gL4pa2wBvmeP7VcHEPZqe4gr/K53Bn7/auV+uYsAvxADfyNM/YL4u5b4m574u98t8Xa9\n    4e9PD78eAX9hH4Ab4i9sATBsI/AIALzU6zTwTAhcEoChLAJDfxDcCwKD1wV+1REIjo7A0P+1gUEI\n    3uooBG/dL0fPz93D9tCPnQHUI/eZHYOf623L6FxFBsYrr8nZc+9Ur7WoVxS+8nUbERR7eM+GPid8\n    cxRxK+Sza+oJfeEj/Nae8t177mjwC222e44MvxADfyNs+VwbfiH+ls894a/w+76S+AtjAPAt8Xbi\n    b/uC4y8IwG+JwGWLPgW85DTwWz0hcKRp4B4RGGJvCQ3xp4FT/xIcBYKjIfDSM+qmQPCr++VsWUNv\n    EAx5AfXVY4nBHys1LVcbGEaFxRyvT6v/vzHqa2L5awGSy/dWjq/THlDxaKO8h/fy2rRG35zP3xJ9\n    145vr1/xvRj2wjG4/V8X7luz2vC79vfWFPjdun/OIsAvOPX7WCT89Xq/20XF39LwC+Jv5Eba8vmx\n    LQAOgL+wB8AgAveQCJy3qNPAIvB2IvDHIiAwCMHPreGrEPzWWQheu3/uzuw80NtU8Jn+pNLz9ILB\n    UHb71DOgICKu9+q1OoMdOaDH18ly1+rrcu09sBdIrF209/WeXqcaULo8R65r+rY+nrXOHF9JjDmD\n    tk78vm7r76lb+FsTfiEG/kaY+gXx97mepn6hL/wtPfULTv6mdku4jfgbow7wF1IAGETgHkpB4M+t\n    F0keBAa3hK7dFgSLwK+LgsAwHgR/unDfWttC9wDBkbeFhvNbQ6c+Vo4WiPz1gfuMNBV89ThzrUUQ\n    tqv9nnQA9jU0e53fL/03I/imPs7o6HvkGP+pwprPYm1v8At18Hfv76Vr+Dsj/IL4+5z4+7poWz5D\n    3MlfEH9TuyXcRvyNUQdbPy+lATCIwD3UCwJDH9PAUbeDhngIDHEgOBICQxwIFoHfFwWC9+C1Bgb3\n    CMFwHoO3HvNsrwAyBYVnwODSx/h8DD1h8PKhaWkg6emc1KgmcDy+tqU+JPf1nbcaX1Otvl/sXkkQ\n    XF7bnt5Dns9HaTAVfd9jb8l1X0Hate2mhd854Bec+r1adPiFWPg70tTvUs/4Owr8wtj4C2MBcEf4\n    C7kAGMZC4J8fjkUELpcIfK0WCAxOA5/tFQRHR2AY+9rAUBeCYf0v0ULwfiUgeO+xj7b3IeoaCreG\n    4JS156jGcfb0QfZWovD1Wk6y5fhgvCWGzfD10aJW0JPje6Hl18QsMFz666On6d61anwPzYC+a8f5\n    Twn3y7X2XDjrxO/HUtB2D35THydHI0/9HoVfEH9f5fV+t4uMv079pndLvF2vACz+Ni0dgGFOBO4N\n    gKGfawKDCAz9bQcNIvDZIiAwOA38XG0Ehtd/oU5B15oQHBGBl65eI/jo45/pyIfljzAsBvd/bCWq\n    ASC9npveoTdns0DZzEVCvNbvGT1/vYu9r2v1nloDfVse36vjTMHeXOsuAbLP8BsRfZdqXec3FWxf\n    4W9v8Avj4W9t+IX4+Btp6hfG2/IZxF/xt2zib5iOATCIwL3UEwJDfAgWgT/WCwID/BhoPW4J/b4o\n    08C1EBjyQPDz45SoRwiG/Bi89VypicH7CcLHqgUfUc5PBMxo/cF9jXoGtZ6K8PVcqgjvGZG+jmu9\n    b/T8NdXivbUW+LY6vrVjPYK+V9ZeEmOF34+dhd9Xf5fsAX+/ZVzHrFs+w2v8jQK/0Bf+gpO/z4m/\n    ad0O3Fb8bV+n+AtnABhE4B5KBeClz60XjAgsApdNBP5YFASG+SD4+S/cQvC1akLw1nPudfSD8Vdb\n    Rs8CpS2OMwJcXKkmepQ6VxEQo/WH9WYjFuX9tdT7ZM33jQjvk1cafcq31TGuHV9p9K0BsL1s87xU\n    A36PQK3w+7FS8Avx8Tf61C/E2vIZxsNfr/cb4+vrduC2veEv3AFY/A3TOQCG+RC4NwCGYwj8ufVi\n    f0kEPp8IvJ9bQr8uCgTPhsCQ9hfwI/BaEoOF4HPPv9aZD8N/vfPnNdG05of5s6B3qaJNC0fCC7HX\n    rG2R3mePvFfWeO+I9F55pZbvs6Nt7ZxyPEfB98gx1EbXXuEXyuDvUaSNBL8wPv56vd/rRZv6BfH3\n    aNHxF2IA8O3AbXvFXxgHgDvHX7gCwLCPwDAGBPc6BbzU03bQOQAYRODaicDncxr4Y0LwvSsQvPaY\n    V/vNw6+F4GvrWTr74fceBr+qFKTOgMG1j7N0JVH4GS0inDeh16yvIr5vlP7HNILv9UaY8j1zDCXQ\n    tyW0Cr/vO4O0y5q2/j7Yw9QvjIm/wu/HxN+0xN9rib/lE39Ddg2Al2aYBhaB69UDAkNZCL6CwNAG\n    gv/zzp9HgmAReL0oEBwFgaHdttCPLX9BP4OuQvD7WkLw1tqufNh9BoNfdRVXW3xg3/o6yRGQIkdH\n    YCMnUuQ+f0Kv2dhFfs9o9T7astbvuTXBN9cx51rzWfR9PoZIsCr8vnUWZ4Xf10WBXxB/XxUNf/fg\n    F8Tf58TftG4Hbtsj/sJYWz8Pgr9QC4BhHATuFYBBBM5d5ElgEIH3iobAEAeCjyIwlIHgnAgMQvDe\n    Y5+pFwiGj+AaBYJfrS8CBq91BFxnuG5w62MevVfnszU4mFnM1t5/fc/IW+vzGRV9a6xrRPQF4fex\n    K/C79/e8XrZ7hjHxNwr8gvi71WhTv9A3/sI41/29Hbit+Nu+gfAXcgEwzIXA4CRwjaJfDxjKIzCM\n    tyU0CMFbRUFgcBr4VREQeOkfuYauOTFYCC67RjgOi6UhOKVHkHU6uE2lPpAufW6XD6rXADjCuTUz\n    W+r1vTalmcG3xXO/6ij8vnrNIoKq8HvvCsymwO/V5ziS8Pux2vAL4u/ZRsPf0vAL4m9qt8Tb9Qq/\n    IP4GLx8AwxxbQYMIXLMeEBhiTwOLwPuJwOtFmQYGIXitqxCc+jwp9QzBEBODt9a7tIdhETD4yHoh\n    /4feET5ETz3256J8AJ3SkfNcChXEYbMxK/GecfT9YtT346XW2LuU+zynPF6UY1/aQt+9tUZG1N7Q\n    d2nB31zwexVk/4r3IF3qeY50BX+/ZVxHFPiFWPgr/K4XEX5B/BV/+8hr/nZRXgCGeRAY+t4SWgTO\n    nwj8ui0IFoHXE4HXywXBny7evxYCQxrQ/hM/ZPlLfm4MFoLrrHmt5w+3o2HwqzWWKAoAtzj2li0f\n    Ukc7/6Ofd7PeioZvCxiO/l4R7bwv1YL2iMe/wO+ZtUWG1B7hN/fEb66/p40EvyD+5kz8Pd6I+Atl\n    Abg0/IL420uz4S8IwP/RTAAMInCtROB7InD5eoBgEXjOaWCoC8Gpz7dVTxPB0B8GH4HgVy3H9vtA\n    r82MW0VHOAdnyvHBebRz/1wvr4VZ1CIC22M5oLGn94lIr0fUa/nW6lcPa/lfFx4nMqKuHVfkNUNe\n    +M35j3OF3+3E348Jv9tt4W8r+IXYk7/ib3q3xNv1jL+jwO/SoNO/UAKAYU4Ehj63hO4JgaEPCBaB\n    XycCn89p4NflRGAYE4Ih3wcBVzBYCG6z5iPtHV8LJG75oXokmKx9HqJ8QB7pNVirJ/gxK1GU94ut\n    omzbPOt7ObR9DWqfh18lPt+o6Lt2bNHXDPngN/eOTCnwm+t5U7oKv+DUb86c+j3XiJO/vePvKPAL\n    4m+PDYy//C3fywDw/cHXGw2AQQSumQh8DYEh5nWBoyEwwI/B1tQzBDsNXKYjEAztMVgIbrfu1HIc\n    Xwksbg1t0TDy6PmIBAG5ivaa7NX6a9gstd7eL6IAb856f49v/ZrkPh+pqLvXyOi7dnw9rDsH/Jb4\n    O1Y0+AWnfreKgr+R4Bfgj8HWAzHxN/KWzyD+Hu2WcJse8fenh18LwP3UDIBhPAT++eF4RkXgz60X\n    +VAPCAxlIVgErpMIvJ7TwOtFmwaGj+DaEoOF4LZrT63FMabicWtMa4GPjx9otz7+HuoNiNfytbaz\n    RUPBs7XGxB5q/fOh9WuU+rWeC3KPNDr6rh1jD2u/Cr+l/i4l/O5XCn7hOP5GgV8Qf1OKuO2z+Hu9\n    3vAX+gNg8bfP/vZ+bOUA+P4k24nAcUqdAoY4EJwDgWHuaeCICAzxILgXBIY+IHiWaWCIB8Fr2NoK\n    g3uDYOgXg0tvEV27kltSv/rwfO/D5ajYKB6uF/U1K51fE7EbBW2P1hoQoxb16yHa69UCdre6gr7Q\n    B572ir5wHn5zguva35miXecXYuGv8Lue+LtdxKlfiI2/PcAviL81En/77G/fjq0sAN+fbDsROFYz\n    bgcNcyMwtIHg3hA42nWBwWngtWaeBoZrEAx1Ptx4Tghuv/YjRT/OFtcrfi4yLgqAaUV+DSOX+vUV\n    CZBSX+uoGBe9SK919KJ+jUV4DaMh73MzoO/acfay9jPwW+vvRU797ud2z+tFwl+v95te5Ov9QlkA\n    Hg1/bwduK/7GaRL8hRoAfH/S7UTgWInA+SsNwDAmAkMsCBaBtzuDwCAEl+jsttDP1cbgUSAY4iPp\n    3vpT6+E4BeH9ROFrRX99axQBiGrka31vlte7VFGhdynK6yv6xmjtOHtZ/1H4rfn3H+F3v0hTvyD+\n    bhUNf/fgF8TftcTf9G4Hbtsb/sIbAIu//fS3H4+tDgDfn3y7URG4RwAGEbhUTgK/zmnga0VCYBh7\n    GhjmhGDI/8HD1tp6hGDoeyp4bf1H6+F4I4Aw9AFJwnC5enj9l6JgUE/5+hrEh16I8/pHx164Dr7Q\n    D5quHW9P60+F3xa7Hwm/aUXC3xbwC31c7/e3v6xF/E1L/L1eb/jbI/zCvPgLAvDFBew3EgSLwHUT\n    ge+JwHWKhsAQC4IjITDMPQ0MeSF4qQYIjwTB0AeO7h3DkXo43igYvNQLGgnDbcv9dRIFgGbK13Cs\n    eoBeiPd1IvrGq/dpX9iH35r/qHVvfWvNfJ1fiAW/EGvqNxL8QrypXxhzy2coj79e8/dYt8Tbib+x\n    mhB/oTYA3xeynwgcJxG4TCLwelsQHBGBIRYER0JgEIL3GgGCocyHFI9r7RWCof+p4LVjOFovxywI\n    n08UNrNZEnzP1QP4wnzou3bMvR3DGvyW/nvKmfWtNTv8Qiz8dep3O/E3PfE3T+JvnUa97u+k+Ast\n    APi+oP1GQeDerwcMInCpROD1nAa+3isIFoHvRUNgiAnBZ6FVDF5PDO7vmAXh6wnD9YqGPTm+Xq88\n    Ro7zEemc9vj933O9IO9jkb5eoR/wBdG31+Oohb5nwPfVGtfqDX7Bqd9SvcLfaPAL8MeAa9rC31bw\n    C+Iv5AFg8bdeI07/jo6/EBCA74vabxQEhjsE9wrAIAKXrCQEi8D16gWBQQheigbBEREYriNrqQ9g\n    RoNg6AtGt47jSL0dczQQhv5RSCA+XjTkWav3r03wXI9ej8i7FPFrsyfwhTnRd+24ezyOBVYX+G1x\n    Ld+U9e3VG/5+y7we4feeU7/nizr1C7Hxtwb8gvjbW6Phbwr8wtD4Cy0B+L64/UTgOPWGwJAHgntH\n    YOgXgntDYIAfg63p28Z6erk2MAjBJasFwUu5PuR4te4/Cfb9t9coELx1LEfr8dgjojCMAUIz43BE\n    3IExvq5K5OsVs56B97GIX1+9YS/kAV/oE0tHmPYF+PcX6y35d4szjQq/IP6W6B82/kz83S8q/l6F\n    X+gff0eCX5gHf0eBX5hj6hd28RdaA/B9kfuJwHESgcslAr9OBM6T08Db5UZgEIJTK/GhzbLG35x7\n    qOqNBMFbx3OmHs9BVBCGcTBoJBiOBjujfI1EK9rrDGO91kJv+XoEX5gbfbeOv4fjedzS+RFVo4Hv\n    qzVu1Rv8fiuwJuH3Xi9Tv9Dfls/QL/665fM98bdu4m+fJeAvRADg+2L3E4HjJAKXqzQCwzUIdkvo\n    9NwSer8ZEBiE4KNd/VDkFQQ/Fh2FxeD1ej0HkUEYxkKgpWhAHAl1Rny9R8ivke1GAd7nIr3ur+oR\n    fXOBL/SBpEfOQeTj+Z8rv58TfnOD76s1btUb/IL4W7Je8LfHqV8Qf9cSf493S7yd+BurPQCeCH8h\n    CgDfF73dSAAMdwQGuoXgVASGOBDcy3WBReD1ROA8CcHbRZwGhvkgeOnshyXP699aZ1QUHg2Dt47p\n    aD2fg+ggDDEBKHclkDgK5szw+s3U6F9Xo+LuY1Few616xN6l2ad8t85DxGP6nwm3yQG/pcD31Rq3\n    qg2/4NRvSq3gF8TfK0Wd+gXxNwf8Qp/4C/0CsPjbZwfwFyIB8H3x24nAsRKByyUCr9cbAkNMCI6G\n    wHAcgksiMMSE4NoIDHEgeOnMhyh7U8FrRYLhETF467iO1vt56AGFYV5YfMbiKJgz6+thb0X+WpwB\n    dp+L8nrs1TP2glO+j0VH3xTsfews/JbG3rU1btUj/EJf1/mFvvBX+L3WqPhbGn5B/D3T7cBte8Tf\n    n37539HwF7YBeAT8hc4B+H4A640GwPCGwNAnBM+MwFAWgqMjMMSFYBE4rW8b63Ea+K3cEPwpw2MI\n    we9L/YDlLAQ/1xKGt8C0dwR1u+i3egHhx0bCyDOIU2rb6ZHOq9WrNEQewd3RvoZ7Qd7HBN/3RQLS\n    o22di5bHdRR6HzuDvjXB99U693K7Z+H3OfH3WuLv+cTf490Sb9cj/IL423sH8RciAvD9QNYTgeMl\n    ApctOgRHRWCIB8ERERjiTQOfQWAQgmt05MOWFhD82NYHL7kg+LnaMDzqVPDWsZ1thHPSIwpDXPxp\n    iTjPWBz1HNm4PX/9t5rWjfy13yP0Qv/YC4LvqyJc1/cK8r7qGX7/io///70F9G6tcy/h91607Z7B\n    qd+UIuLvqPAL4u9j4m+dfnr4tfjbZyfwF6IC8P2A1hOB4zUzApcGYCiPwKNOAkM8BIaYEDzKNDB4\n    feBaRZ4IXmv5UGZt7SXXWhqHxeD0RjgnS72iMJSHn2h4k+t4S00aW//lQNxRv296O+7URsDeJdH3\n    Y63QNzf0PraGqQsAR0r4PZ5Tv2/9w8afRcTfPwZck/h7vtLwC+Jvb42Ov7AOwJPjL0QG4PuBvW5E\n    AIb+ERjSIfhz64X+kgj81lUEhnYQvIfAEA+CIyIwOA2cWkQIboHA0CcER1trbhweGYO3ju9so5yX\n    pZ5ReCkFfaKCTeSJxq2E5Xr1eG3c3r/foq7/SCNhLwi+a9VA35LAu9YRTG1dZPiF6/j7rdC6nPp9\n    y6nf60XF36vwC+LvY+JvvUbe9hnGn/69gL/QKwAvjQjBInCbeoFgEXg9EThf0RAYYkJwCQQGIbh1\n    C8b+z0BrvQLEo2Pw1jGebaRzszQCCkeqV+TtqZwg3SO49tYIwBqp0bAX8oMvjIO+kBd+WwDvWv+v\n    h/VHWterUuG3BfqCU79H8lq/aUXE3z34BfF3K/H3XLfE24m/MRN/d4sNwPeD3G5kBO4VgEEELl10\n    CHZL6GMJwemdgeAZp4FBCM7RI7w+rjfaB1gpQLyFpCOBZ24MhrHOz2OtUfifCj72ry/eX+A1y1cO\n    HI78fnG1EbEXBN+9ts7P3nFG+/+h8PH/iy6YGnGtzwm/5xJ+3yf8Xi/q1C/Ex98a8At58DcS/EIa\n    /vYKvzA2/v7NzjGJv/9R/wAMInDUROCyicDricD5GgWBQQiu3QwQ/Fz0D7mW45gFg/eO9WyjnaNX\n    ncXhkkhztD3UEXnN2reHwz29p+w1KvQuCb777aFv9P8fCdv/6PDXHU37Pq93q57hF/Ljb2n4BfG3\n    ZOLv8aJf7xf6mfyNhL+3xNuNgL8wHgDv4S/0D8CZ8Bd6AOD7Ae8nAsdMBC6bCLzdFgRHRGCAH4Ou\n    axQInhWBIT4EQ3wMfv7Q68h6o34Q9gx9f7ny61EShI/1+GF1b9eIdQrYLEZXJoAjAXBqy5bjI/9s\n    AME3tf+18muI+Y8Czlx2ZFT4hT6v8bv0rcDanPp93z9s/Jn4m574ez4nf891S7zdCPg7GvyC+Hui\n    PgD4fuD7icAxE4HLVhqBoW8Idho4X9821tQKgp0GPp4QfL0rELxWhA/MtjA4td4+8J4FhEt8UL/U\n    CoZbb9v6nGBsMxXpmr+tkLjUtaUj/gwBwffs8UdE3zPI+9wzokb4/7FH17xWq4lfcLvno0XEX+E3\n    vcjwC9fw16nf9/WIv9AvAIu/fZcZf6EnAL6fgLRGg2ARuE0i8PtE4PpFnAaOiMAQcxoYhOBXjbQ1\n    NKRvD3212h+s/T7ANtEtPgQvAcJXjqUk3JbuCgxHw90SCcYWpUiYW6KrQFwKemsU7WdPbfCt+TN0\n    67lqo28O4F2rt2nf5zXv1fN2z98KrMvtnj/W29TvHwOuCWLjb/SpXxB/z3Y7cFvxN17i7+n6AuD7\n    iUhLBI5VKgBDLASGfiC4BgLDNQiOvCU0xIRgp4HTizoNDHEhuBUCw9gQ3GrdpT6Ii4DBLTp7HdxX\n    zQCaqf0lec/trAnItjQ64NboV3zv+h/c5C7nVHWEiddStUDfkri7Vo/Tvq/WvZYTv69z6vd9vcEv\n    9Im/PU/9whj4mwt+Qfxt0U+Mh78p8Av94y+UAeCvPQLw/WSkNSIC9wrAS71CsAj8PqeB6xYVgWGc\n    awODENyqkbaGXqo1FXylsx/e7cHdyCCccvxX6xWKc7/uAnH5BOQ4Cbjly41xvWJx6e2yR8Ze2H/d\n    zx5/C9RNyWnfcgm/x4s49RsVft3y+VzRt3wG8fdstwO3FX/jNcPkLxTDX+gVgEEE7jkRuHxuCb3d\n    HgJDPAj+3S//GxGCIyIwxIXgEggMQnDUesDglNY++Mtx3eDeK4mVLUA48msoDM9TTqAWWOcpKkC2\n    AmPBN2+vXsdX5yAq6KY0+rQv9A+/4HbPNesJf3/7y5rE32NdnfqF8gDc05bPEAd/bwdvL/7GS/w9\n    39e3X/YLwJCGwKMBMPS/HTSIwCLwPRH4eE4DHysqAkPcaWAQgksUYYvo0pW6fm5vtd46OjLglk4g\n    Nhu72cBx6Swg5wbgWc7/X7J+zmtfx7hWPU77Pq97L+H3dVHhF2JO/UJc/O0RfqFv/B1hy2fwer+9\n    wy+Iv72XG4C/vv/PvgEYRGARuH49ITCUh2ARuH4i8PGiQnDkaWAQgks1ylTwVlsYnBsoo2/F+YyS\n    JaZ6Z0bfo4nEZjGbBRdzVOLn3issjvqalPqZNzP6gvBbosjwC273vFZPU78g/p5N/L0n/sZZ99HE\n    3zEqjL8wAgAv7UHwyAgMc0Dw59YLfagnBO5hEhhiQ3BEBAb4Mei6ICYEn0VgEIJ7gWDoC1RnmAqG\n    uhjcQ7UmpWc8t7kTi82uFRUQe6rWP3IaFTm32jq3I5+PGaZ9QfjdKir8glO/R/tj0HVF3vIZxN+l\n    EfEX0gFY/I3bHgCLv+t9/fhb4wAwbCPwiAAMInDLekJgiD8JDLERGGJCcI/TwNAnBPe6LTQIwT00\n    w1TwkiD8sZrbZ896jkskENvsCbz5qrmbxci4udWs4Av9ou/z2lMSftdzu+f1nPrNl/h7PfH3fLeE\n    24wAvzAn/o4Cv1ANfwF++P6d/43/OtCHFyJwv82MwOA08FJLBIZ+p4F7hGC3hV5PCN5u5O2hQQx+\n    bFasrH095VnPc+0EY4ueoFun2pcuGB03txJ97/WGvs/r36sl+oLwC+PBL8TEX+H3fMLvW+Jvv808\n    +TsS/kKVrZ+X7gAMiMCdJwK3radpYBF4v14RGOJuCx11GhiE4CsJwWWbZYvox5wO3k4YnjsB2VIS\n    cWMl9tZt73yPfn56vq7v2jFsJfxuVwN+4Rz+Cr/HE3/PJ/6+NSL+3hJvJ/7GTvy91tf1P3oDYBCB\n    e08EbpsI/DEhuE1OAx9PBL5WTxAM/UHqjBAMYnBqtVEYPP+jJSy3Sagdp9rIuzQ6ZqY285TvUu/w\n    29M2z5APfqFv/B1t6jcq/ILX+j3bVfiFcfB3RPiFdPyFvgFY/B2nyvgLzwAMInDvLQjcMwCDCCwC\n    vyUCn6tHBAYheKtSEAxzTgRDn5AqBq8nSr7VAoXB18DOVxuhxVc7k9Abo9mnfJd6R99Xx7CX8Ltf\n    ZPiFtvjr1G/eRsffGvAL4u+VbgduK/7GTfy91tf9m3wEYBCBR+hnfpgGgSEWBHtd4I9dRWBoC8Ei\n    cJlGmwYGIXipNwiGPiF1VgwGrx18plYovORrYma91Ap6YR68PJLg+9aM6AvCb0rC73Y9Tv2Kv+dy\n    6vd94q/4G7m/2TmuUQC4BPwufd2/yWsAhnEQ+G8TbjMiBI8wCXwEgEEEvlppCB4dgUEIPtOI08Ag\n    BC+1hmCYYyp46RGEez6OMwnC52qNwuBrY2Ztaom8SzPB5ZFSXpuZzt0I6PvqOPZqjb4g/C6NCL8Q\n    F397hl8Qf1PqaeoXYuHv7eDtxd+4zYK/UA6Av6bdbB2AQQTuvREQGPqdBAa3hH6VW0K3KTICgxB8\n    pR6uEQztMXhWCO79WM4mCF9PHDaz3ouAvDAXVp7JCd+PjYK+r45lL+E3rRrwC+Nd5xfiwi/0jb+9\n    b/kM4u+resXfnuEXxsbfPfgF8Telr+k33QZgEIFHyO2g2yYCf0wEblevENwagWFeCIaxJoJBDJ4x\n    QThfEWD4MV87szmLgruPzQiVZ3LC93Uzoy8Iv0eKPPXbGn6hz+2eAf4YeH2j46/X+/1YJPgF8XeU\n    UvAXxgDgxts+P7YPwDAGAqcAMIjA0esVgntCYPC6wKn1DME/Bl6b08Dn6wGBQQhulRj8liCct2go\n    /Jyvp1lfRcTdx2bEySsJvuuNhL6vjicl4Te9yPAL7fHXqd/8Rd/yGfrA396u9wuxAPh24Lbib9zE\n    3+t9PXe3NAAGEXiEZkPgz60X+lRv1wUWgdPy2sDlchr4fELwsY5CMPSPp2LwW6l4KSKeKzoOg6+t\n    We2iAy/MC5I5Eny3E31joC8Iv8+NOPULsfHXqd/zueXz+2af/O0dfuGOvyPCL4i/Ofp6/q7pAAwi\n    8AiJwG0TgV/X+5bQ0O80cK8IDH1DcA0Ehn4gGPrF4BHgVAx+nyBctx6A+DFfd7PX9YC6j80MkLkT\n    fPcbDX1fHdNeI6IvCL+t6xV+e576bQ2/IP4+J/7GWveZRsZfmOu6vyUA+Ou1u88HwCAC//zLcfUO\n    wSKwW0I/1xqCe0Vg6BeCIyAwCME56xWCYQw4FYNf55bRbeoNh1/l14b1Wm+g+6rZ0bFUe18bnvd7\n    I6Lvq+PaS/g9nvCbVq/X+hV/z9cL/EJf1/sF8bdVI2/5vCT+Xu/rtbsfA2CYC4FHBWB4Q2DoG4J7\n    RWDwusBr9T4NLAKXTQi+VkkIhjG3h4Y5p4JBDN4qBSaFv7KNgMMp+XVkVxoBcfcSG8vmdO+xRN97\n    UdAXhN9X9XydX3Dqt1Tib556m/oF8bdV4u898Xe7r9cf4jgAwzgIDPsQLALHTwQWgZ+LjsAgBF9p\n    1G2hQQh+Vc8QDOOgqRi8nygcq1mAeCu/3vpvBsDdS1ysV+rXm6/J+0Tft4Tfcwm/afUMv0BY/N2D\n    X+gff0ea+oVxt3wG8XekxN/rfc3zMOcAGETgUZptO2iIB8G9bQndCwJDfAgWga8lBF9PCD7XGQiG\n    cdD0Ny9+b5Rjy5nXEu4nsfh6M30di7J5EhHbJvae7xWMzoy+IPyeTfhNq1f4Bad+cyT+vm9U/L0d\n    uK34G789/B0FfpcCXvf3MQF4SQQWgVvnNPDHZkBgEIKvJALnqadrBEP/GDwaljodnJ4o3HdCsdl2\n    YmHMxN7rjTrlu3Z8qUWB39zoC2PAL4i/Lftj4PXNMPULY+GvWz7fE3/jJ/5e72vehzsPwCACj5QI\n    HCMR+HW9bwkNfU8DA/wYfH3RIRjiXx8Y+poIhv4hGMbE0kcQHvH4cufW0eMlFNtoCYN9JfjmaXT0\n    fXWMKUVBXxB+txoZfiE2/jr1e71e8Le3qV8Qf1sm/oq/qX3N+3DXABjGQ2DYhmARuI96hmAR+HVO\n    A7dPBL6eE8H3PmV+vEgQDE4FL7lV9LmcEp434dhKJ/iNl9ibr5G3dt47zr0ioS/0tc0zCL9Hc+q3\n    XNHxtxf4BfH3arcDt+0dfkH8BfE3pa9llnodgGE+BIZxIVgEjlFvCAxuCZ1a7wgcfUtoEIJzJgRf\n    Twy+95uV3x/xWEt0BAaF4bkTkcdNwDOxN29rECr63ouGvtAf/ILX+T1Sz/Db+9QviL+p1YJfEH9B\n    /O2lLfwdDX6hm8nfpTwADCLwaI0CwUcQGGJBcC4EBqeBXxUdgiMjMAjBueoBgksjMIx/nWBwi+jn\n    nA6+3lHoE4YtZ0LzW2Kb5SwVeZf8+jvWLFO+a8eaUjT47W2b5yXhN73e4RfoGn9bwy+Iv6/Khb+R\n    4BfE39GabeoXupr8XcoHwCACj9YoCAzpEPy59UKf6hGBwWng1EaYBobYEDw6AoMTwXtFg2AQg18l\n    COdJFDYz6yuness3w7V81441tWjoC8LvXlfgF8TfHDn1m6er+OuWz+uJv237iXHhF/bxF8YD4M4m\n    f5fyAjCMh8B7AAzjI/BMAAzxEBj6hOBepoFbIzA4DVyj0SG4JgKDEJwzt4h+3TMIz3DMJXMLaTOz\n    th2Z7BV7rzUT+K4dc0oR0Rf6hN+a1/gFp35bFx1+wanf3PWGv9HgF8Tf0RJ/8/W1/NLzAzCIwKM1\n    CgJDv5PAIAJvNQMCQ3wI/jH4+kAIzl2PEAwxMdip4PWcDi7TmS18xWEzs/WObt8MYm+OZtrWee+4\n    U4oIvyXQF4Tfx4TfPP0x+Bqd+s1fDfwdeeoXxN/REn/z9bXO8ssAMIjAoyUCx0gEXm+ELaGhfwju\n    YRoYhODceZ3gvInB2zkdXD5x2MzsdSJvjGac8n113KlFRF/oc9oXhN+z9Yy/I0z9Qnv8der3Y+Lv\n    W+Jv/FLwF8YC4M7xF+CH7/8f/je+FHyGkSBYBPaawFHKBcEi8OtaQ3DvCAxOA+dMCH7fp0KPGxGD\n    z0IwzIWiTgjX6wwMgzhsZv11BnpB7C3VrOD76tiPFBF+e532XaqJv8JvjKJP/YJbPueuN/yNCL+Q\n    jr+jwC+IvyD+pvS17mHcARgQgRNKAWAQgXvJ6wK/JQR/rDUCg9cGrpUQnL8aEAxOBac2E4b+ZuX3\n    ZzoHtTuLwiAMm1n7hN6Yzbqt89bxpxYRfaFv+HXi91y9w+8IU7+jwC+Mhb9O/b4l/vbTbFs/l8Jf\n    GBSAQQQeqZ8fjq13CBaB3xKBP9YDAoMQnKseIPgKAsOYEPyp4GOLwWPkhHC7ruAwCMRmdr2zwAsi\n    b81mnvBdOwdHioq+IPwe6Qr8Qhz8/YedP4+Ovz3AL8yDvyPB79LIk7+3A7cVf/tJ/M3X1/qH8wbA\n    IAKnNvtW0DDWJDD0DcE9IjDUgeBREBicBq7Vt501CsHn6xmDo0IwiMFHc0I4VgKxmV3pCu6CwNuy\n    2Sd8t85DaqJvuYTfc/UOv9AH/vZwrV8Qf1/l5O9b4m8/ib/5+trmkN4DMLgV9JH2IFgE7isR+N5o\n    CAzjQLDTwPUSgsvU89bQEBuC4RoGw5wI6nRw7K4CMYjEZr12FXdB4I2U4PvWqOgLwu/RhN84jQK/\n    MAb+jga/MDb+3g7cdgT4BfH3MfE3ra/tDusjAC99KfSMIvBYzYzAMC4Ei8CvE4Hz9WMHa4Q+toUG\n    IXirT4Ued2QMnh1AReE+yoHDSyKxWd1y4O6SyBuvNeCcFXxB9D3bt0rHIPyer/fr/MI4+DsC/IL4\n    u1U0+AXxd+T28Hck+IVy+Pu19YFtATCIwKm5JfRYECwCvzXadYFBCI5UL9PAIASXrPepYBgbg0H8\n    dNvoPssJxI+JxWbr5YTdJYE3dmLv666AL8RHX+h/2heE3ysJv/XqAX97gl9wy+dc3Q7cVvztp9mm\n    fpdKAPDX1gd1TwDOmdPAInCkepsGFoGPNwICQz8Q3Mu20CAEb/Wp4GNHh2AQg3PllPBYlcLiJdHY\n    eqwE5i6Juv0m+K4n+l7rW6VjqI2+MBb8Qv/4K/zmTfx9nfj71gj4OwP8gvibu6+tD+zeNgCDCHw0\n    EVgEjpTTwOvlQGAQgnM2AgRHQmAQgvf6VPCxxeC5ckp4nkpj8asEZDtaSbzdStgdqy3QFHzvib7X\n    +1bpOITf6/UOvzAO/o4CvzDels+jwy+Iv6M225bPS4PjL6QAMIjARxOBx0FgOAbBn1sv9kUi8HZO\n    A8eqFwQGIbh0o0AwzIHBIHY+JggbtMHiVwnI/dUKcF8l6s6T0737XQVf6AN9YYxpXxB+cyT81mum\n    qV8Qf7cSf2Mk/t4Tf4/1tfWBvS8NgEEEPtrsCAx3CBaBY5QTgWE8CB4FgWEcCP6xgzUuCcFlqwnB\n    4FQwiMGlEoUttShwnKseAToSwF5NwLVXib3pib55+lb5WITf6/3Dzp+Lv3nrYeoX+tryuUf4hZj4\n    eztw2xHgF8TfJfH3WF9bH9jH0gEYROCjicAicKRE4P1GgeBRELinaWAQgmvkVHD9xOCyicJWo9FA\n    eYZEW8uZ2Hs80Tdf3yoeSwv0hbngtxf0hXHgF2Lgr1O/640++Xs7cNuR8Hd0+AXxN3dfWx/Y644B\n    MIjARxOBReBo9bglNDgNfCYhuH7fdtYpBOfJqeB2CcLlE4VtlEaAZyHWekvsPddM4LvktO/1ZoJf\n    6Ad/e4FfcOq3RDXhF8Tfx0bCXxgfgPfwF8YE4MnwF84AMJRDYBgPgvcAGOZBYPC6wFESgbfLgcAQ\n    A4JHQWAQgksmBKf1qfDjz4jBIGym9JuNP/P8mZnN1xZYir1pib75+1b5eITffI0y9fvHTtbay9Qv\n    iL9rCb/vGwF/f3r4tfgr/h7pa+sD2+4cAIMIfLTZJ4F/fjg+EThGIvB+TgPHqycEhr62hYZ+IRjE\n    4Ag5HVy33+z8uefSzGyM9qBS8E1rRvCF8ugLc2zzDMJv5Jz6zV9P8Avib85uB247AvyC+PvcaPhb\n    Cn4hPP7CFQAGEfhITgLfm3kSGITgXPWGwBADgkdBYBCCS3cVgsGp4JzNisEgYh5NFDYz6zsne/OV\n    A3xB9F3rW+Vj6nXaF4Tfko0EvxADf3u71i/0ib+9wy+Mh7+jwy+Iv7n72vrg0roGwCACHykFgWF8\n    CBaB49UjAoNbQp9tJAj+sZN1LgnBdRODY5QLg0HAvJLbSJuZxclr9eYvF/iC6LvWt8rH1HLaF5z4\n    jV4v+NsL/EJ/+Nsj/IL4Gynx933ib3pfWx9cetcBGETgIzkJfE8EjpcIvN9IW0LDPgT3gsC9TQOD\n    EFy72hAMYvBWgnCcnBg2MyuXWzeXbXbwhTHRF/re5hn6g1/oC397gV/oZ7tncMvnrcTf94m//SX+\n    5u1r64M7Vh4ABhH4SE4Cv/UzPwyDwOB1gZ8bEYKdBo5bbxD8bWetQnD+RoVg6BeDwe2iI7YHw+D5\n    NjODNIQUevM187bOSzXQF4TfMwm/ZRsJfiEO/jr1u15O+IX+8XcU+IV58DcFfkH8PdLX1gd3vHwA\n    DCLw0ZwGvjfzNPDn1otdqVcIdhr4XCMhMAjBNeodgkEMjpwTwrFzatjMZkzobZPge0/0LZfw20d/\n    7Gi9s+GvU7/7RYRfmBt/R4dfmHPqF8TfF+UFYBCBj+Y08D0ROF69IjA4DXy20SDY6wOXLwcEg1PB\n    JROD3ydOlk0cNrOec8vmtuXc0hlE3yN9a3B8vU/7Qkz4hbGu8yv8lqm3qV8Qf3N3O3DbUfB3lqlf\n    mBd/oRwAf219YOfLD8BQDoFHBGBwEnhJBI6XCJzWSBCcgsDQDwT3Ng0M804Ew5xTweBk8JEE4X5L\n    2VYafE3MrFypwCj01knwfd2o1/WF9tO+4MRvL/W03TPMh7+jwi+Iv8+Jv/0l/pbpa+uDO9kXvvcF\n    wDAuAsM+BIvAfSYEv29UBAa3hY6cEFynUSAYnAzuJUG4/1JhGHx9zGy7I6Ao8tZP8H3d6JO+0B5+\n    R574HQ1+wanfUjn1u90M8Avp+DsK/IL4+9io8Avi76u+3M9JGQC+P0G5ROCxE4Fj1isCQ3/TwFEQ\n    GMaD4N62hQYhuHWjTwXDOBgM+UEYRMfWCcRmtiTw9pXgu94M6AvCb8lGhN+epn57gl9w6nevGfD3\n    duC24m+fib9l+tr64E725e2clAPgtycrkwg8dj8/HOMoEHwEgUEIzl1vCAxCcKl6nAaGPq8RDHkw\n    eGYIhroYDILwXiJjzIRis34TdvsvN/bCWOALddEX5p32hXG3eV4aDX97gl/oC3+d+t1P/H3fKPj7\n    08OvxV/x92xfWx/cyb68Pyf9AjDMjcAwPgSLwCJwiWpBsAgcvx4huMdp4CWngvP0qfLzjYTBUAaE\n    QVDspSNI/Jivr9mxzmKguNtHJbAXxgNfcNK3ZiNP+y4Jv23rCX6hP/wVfvN3O3h78bfPxN8yfW19\n    cCf78vGclAfg+xOXSwQe9/iXZt8SGmJCcE4EBqeB94oCwSkIDEJw6YTgGBAMYnDvlQJhEA17Tig2\n    e90V+BN3+03wTW+WKV+Igb4g/EJ/8At9XecX+sLf3uAX+r3WL4i/EfuJOeAXxN9SfW19cBdqBsD3\n    Jy/bqBAsAt+bHYE/t17sSiJwWrkQGPqC4J4QGLw+cO2E4Lx9qvx8I2LwklPCdrSzYPyYXx9Wsxyg\n    J+iOWSnshTHBF+ZCXxB+ayb8tm9G+AXxN7UR8Hc0+IU58HcPfkH8PdvX1gd3oS+vz0s9AL4vomwi\n    8NjNjsAgBJeoRwiOgsAgBEepZwgGMTh3nxo8pyB8LtHPcuDxY35NjV1unBNx507sPVdt8AXR97HR\n    r+8LY8Kv2z2XrcepX+gXf6PCL4i/4u9bIwJwSfiFIfEXagPwfTFlE4HH72d+GAqBwWngV42KwJAH\n    gntDYOgLgnvcFhr2IRhiY/BoEAxi8KiJwhap3Ih8pJm/Xkvi2V7CrR1N7L1WC/QFt3hemmHaF4Tf\n    CKXAL4i/V+sVfiEu/t4O3HYk+AW3fH6V+Hu8r60P8EJfts9NfQC+L6psIvD4icBxywnBNREYnAa+\n    2ojTwKNCcGQEhnwQDGLwY58aPa8gfL2Zkc3a1BKVR0ywtZqV/scJgm+5vrU+cOLAby70BeG3Rb3B\n    Lzj1W6Oa8AtO/b5K/O23mbd9Fn/X+7J/btoA8H1x5RsRglMQGOaA4Nm3hP7cerEbOQ2c1ogIDEJw\n    pITgt4Tg931q9LwzYPBSaRQGYdjMbOZqTKHPgL1Lom+MhN+3hN869Qa/IP6mJP5+bCT8nWnLZ3Dy\n    t2RfWx/ghRLwF1oC8NtCyzUiAIOTwI/NjsAQF4J7RmAQgq824rbQ0Of1gaF/CAYxuGSfGj73TCAM\n    dVAYhGEzs5Gqtd34TNgL7cAXRN/nZkJfGBN+Af7Y4bp7w1/hdz+3fH6d+NtvTv6W62vrA7xQIv5C\n    BAC+L7hcMyMwzAHBIrAIXKoeERj6g+DeEBiE4JaNCsEQA4NBEK6dKGxmZktib7lagi/EQF8Qflsm\n    /MZpVvgF8fdI4m+8xN+Pib/H+9r64C52AH8hCgDfF16uUREYnAZe+vnhGIXgePUMwTURGJwG7qle\n    t4WGfQiGuTA4GgSDGLw0IwhDPRQGYdjMrEW1oBfmxN6l2ad8lyKhL+SD3x7QF8aF31G3e4Yx8bcm\n    /EJd/J0FfsEtn0H8fWxU/IVyAPy19YFlqFsAvi++XCLwuMe/JALf+9x6wSv1jMDQ5zRwJAQGIThi\n    QvDHxOD1PrVeAPOCMNRF4SVx2MzsfDWRd2lm7AWnfB8bFX2hD/jdQ18QfmvX29Qv9Im/Tv2W6Xbw\n    9uJvv80OvyD+bnUQfyEaAN8Polwi8LjH/9iIW0LDMQj+3HqxG/UMwU4D52nUbaGF4PblhGCIh8FR\n    IHjpU+sFMDcIL7WAYRCHzcygDfKC0Lsk+L5vZPSFPuAXnPiNlvBbL6d+y3Q7cNuR4Bfc8vlV4u+5\n    vrY+sAydwF+ICMD3gynTyAC8tAfBInDficCvG3kaGITg3uoZgmGM6wSDU8G1+9R6AYjBzwnDZmb5\n    agW9IPY+1hp8QfRNabZp36VR4Re8zm+thN+0xN/Xib99J/6Kv1udxF+ICsD3gyrXyBCcMgkMc0Hw\n    aAgM6RD8ufVCd8oJwbURGNwWOldCcMyE4NeJwWl9ar2AXxKFP9YKhpcEYjOLWEvgBZF3LcH3daOj\n    L/QDvyNv9Qzjwi+Iv7nqGX8jwy+k4+9o8At3/J0FfkH8BfF3qwv4C5EB+H5w5RKBReDecxr4dSNP\n    A+dCYIgHwaNeHxjgxw7XvDTK1tBLo08FL0UD4U+tF/CQIPy61ij8mEBsZiVqDbyPib2vi4C9S99a\n    L+CpiOC7JPyuJ/zWb+apX/Bav0eKjL+3g7cfDYBnwt8U+IWx8bcU/IL4+0uxAfh+kOUSgedCYHBL\n    6KiJwMcaFYJHRmBwIjhSM0wFL0XDYBCEeysSDoNAbGbribx9FQl8QfQ90qzoC2Nv8wxjX+cXxsVf\n    p36PNQr+jgi/IP4+J/6e62vrg7tYBvhdmhuAQQQGEbj3jiAwCMEl6xWCIyEwjA/BPU8Eg1PBe4nB\n    x/vUegEPCcLHiobDSyKx2VhFgt3nhN70IoHvt9YL2Cgq/Iq+2wm/bZodfmHsqV+YB39vB28v/vad\n    +FsWf6FvAM6Iv9ADAN8PunyjQrAI/L6fH45zJAgWgdcTgdMTguvV+zQwCMEpicHn+tR6AU+JwueK\n    isPPicVm7YoMu0sC77kiYS8IvmfLjb4g/EarV/iFPrd7Bqd+U5sFfkH8FX9fJ/6e72vrA7zYlAB8\n    P/DyjYrAkAbBsyAwOA289Ln1gjcSgo816jQwpEFwjwgMQnDUZpoKhtgYDPFAGEThq/WCw8+JxWbb\n    9QC6rxJ5rxUNe5e+tV7ARpHRF+ae9gXhN3rCb92E33LdDt5+VPgF8fe5UfG3NPyC+PuifgD4fgLK\n    NyoCOwn8MRH43ufWC95IBD6eEBxv3SkJwTGbbSp4KTIIf2q9gI1E4Xz1CsTPCcY2Qr2i7mMCb94E\n    33PNhr4g/EZM+K1fr/AL4m/JbgdvPyr+zgK/IP6Kv/sVwF/oDYCXvhR+/FERGITg50bdEhqOQfDn\n    1ovdSQg+lttC9wvB4DWCoyYGx+1T6wWsJAiXbRQkXks8tlyNALhbibtli4q9IPjmSPS9J/zGzuv8\n    jj/1C3nxNzL8wjH8HRV+Qfx9blT4XXLb5+0K4S/0CsAgAl9JBP6Y08AicOlE4LyNDsEjTASDGHwk\n    MThPn1ovYCdRuH6jQ/HZBOZYjY60ZxJ26xcZeyE++ILo21MzoC/0Db/g1C+Mj78zTf2C+Ls0C/7O\n    PvW7JP5uVxB/oWcABhH4SiLwx0Tge59bL3ij3hEYhODcjbwtNAjBPTQrBkMfIAzxURiE4QgJxfFL\n    RWsxNX7ibtuiQy/0gb3QB/iC6PuY8NtHvcIv9Lvlc+9TvxAbf28Hbz8q/s4CvyD+LpXE36+tDy5D\n    hfEXegdgKIvAIwPwUgoEi8Bj5DTweqNPA4PXBgYhOEJC8PF6wWAQhHMmCMdPMDa7J+bGT/DN28zo\n    C8Jv9GaAX4iJv079ppcbfkH8jZz4+7rR4RfE370q4C+MAMAgAudoD4JF4DFyGng9p4GPJQS3aRQI\n    BjH4TGJwmT61XsCBhOExEo8tWiLuGPUAvUvfWi/gQL2A75LTvm+loC8IvxESfu+NDr8w19QvzL3l\n    M4i/a4m/1/ra+uAyVAl/AX74/p0f+TrIh0lfCj3uDAjsltAf+5kfRGDmQmBwGvhoQnCbhOB+EoP7\n    wuClT60XcDBheL5EZFsSb+erJ+iFvrB3qSf0ddL3Y7NM+4Lw27Ke4Rec+i3d7eDtxd/+c8vnt8Tf\n    7SriLywADIjACY0OwSLwx5wGfutz6wVvJASfSwi+JwTHKAWCQQx+VU8YDH2CMPSHwiAMW3qCcr0E\n    W0utN+iFPrEX+gJfEH3XEn77qWf4hX6v8wtO/dboduC2wu84OflbFn5hDPyFhgAMInBKIvA9EXiM\n    RkJgcFvoM4nA93pGYBgLgmH8qWAQgx8ThOsnDJuZxalH6F361noBJ+sNfKEc+kLf8DsT+kL/8At9\n    469Tv8cSfrcTf8dJ/HXqN6XK8Lv0HoBBBE5pdASGNAieCYFBCH7sc+sFbyQCn0sIvicEx0oIvlaP\n    GAyCcMuEYTOzcvUMvUvfWi/gZD2CL4i+W80GvwB/7Px4hN+3vNbv8SLj7+3g7UeGX5gLf932+Z74\n    u18j/IVXAAwicGqjQ7AI/DER+K3PrRe8kVtCn2t0BAYhuNdmgGAQg9fqFYSXPrVeQKbEYTOz/UZA\n    XugXepd6BV8QffeaDX6d+G2fU7/Hmu1av+CWz+LvdiPjr1s+p9UQf2ENgEEETk0EnheBYTwIHgmB\n    wWngswnBbwnB8RKDr9czBkP/ILz0qfUCMiYOm9lMjYK80D/0LvUMviD67jUb+oLwGyHh93gzTf2C\n    k7+zwi+45TOIv6k1xl/YAmAQgVMTge/NCsGjITAcg+DPrRe70wjTwCAEl0oI7jsxOE+CcJw+tV5A\n    gcRhM+uxkZB36VvrBWRM8N1O9O034bd9bvd8PKd+9xN/x0n8LY+/MAYAB8Bf2ANgGAOBv1R4DhH4\n    ngg8TiMhMAjBVxKC3+odggF+HOAYnkuBYBCDUxOEY/Wp9QIqJBKbWc1GxN3nvrVeQOZ6B18QfVNL\n    gV8YD3+F3/YJv+eabeoX3PJ5wV/h93Xi7/W+tj7IDAXBX0gBYBCBUxOB74nA4zTaltDgttBnmwGB\n    IQ2CR0DgmSeCYQwIBieDjyQK951AbGZHmgF4H/vWegEFEnzTEn37bwT4BfH3Mbd7Ptdo8Avi70iJ\n    v/fE37QC4S+kAjCIwKmNjsAgBL9qZASG8SB4hGngFggMc0DwTNPAo0IwzLM99JKTwccaDYSXPrVe\n    QKMEYrO5mg14l761XkChRsDeJdH3WLNu8wzCb5R6n/qF+vjrds/7jQi/IP5uNTr8gvibWjD8hSMA\n    DCJwaiLwWzMhMIwNwSLwfk4Dn6t3CIb+MXh2CIaxMBgE4TONisJLn1ovIEhisVnMZkXd5761XkCF\n    BN9jjQS+MPe0Lwi/URJ+zyX+7jcy/gq/rxN/8/S19UFmKCD+wlEAhjEQGMpD8AwIDGkQLAKPlRC8\n    XQsEhv4hOCoCw1wQDGIwiMFnE4T77FPrBXSQaGx2LDE3rW+tF1ChkbAX6oAviL6jNQr6Qv/wC/1v\n    9wxj4K/w20ezTv2Ck79L4m9aQfEXzgAwiMCpicBvicBjJQLvN8s0MAjBz42AwCAEw3gQDGLw1WZB\n    YRCGzyYW26iJuuf61noBFRsNe5dE33Oloi+MC78Afxzk2ITf9wm/1xJ/+2hW/HXy963S+Pu19QFm\n    KjD+wlkABhE4tRkQ2O2g1xsZgkdDYHAa+GpC8PuE4D6aGYPBraJzNBMKL31qvYBBE4+tdCJumb61\n    XkCDRsXeJdH3fLNP+4ITv9ESfs8329QviL8wL/yC+PuY+JtWcPyFKwAMIvCRhOB7MyMwCMEgBNes\n    922hQQiO1OgQDGKw08H5mhGFH/vUegH2LmG5v4TaWH1rvYDGjY69IPheTfS9J/zGS/w9l1O/+40I\n    vyD+piT+Xu9r6wPM2PAADOMgMDgNnCOngV8nAr/vc+sFJ+S20NeaZRoYhOBRS8HgUSEY6mHwkig8\n    V59aL8CaFRmjRde5+9Z6AUESe/M3KvqC8Lsk/MZL+D3XjPAL4i+8wS/Mh7/C71vC77E6wF/IAcAg\n    Ah9JBH5LBB6vIxD8ufViExoFgcFp4BrNBsEAPw50LGvNPhW8JAiXSRR+3afWCzCz4frWegEBmwF7\n    oT74gugL46MvzAm/EBt/c8IvtMHfUbZ7hvHwd0T4BfE3JfH3el9bH2DmOsFfyAXAIAIfSQR+36wQ\n    PCoCgxCcktPA5xOC4+VU8PvE4PzNAsIgCqf2qfUCzCxE31ovoJNmwd4lp3zzloq+MAf8/nGgYxR+\n    X+fU77VGg18YH39ng18Qfx8Tf9PrCH4B+C85ARjGQmAoC8EzIDA4DbyWCPyxz60XnJDXBr6WEPw6\n    IbjPxOC3nA6ukzB8rk+tF2Bmp/rWegGdNhv0Lgm++RN93zfStC+41fNaM8EvzIm/t4O3HxV+YV78\n    TYVfEH9z9LX1AWasQ/yF3AAMIvDRZoBgEXi90SFYBE5LCD5fdASGOSEY5tgeGtIhGMTgks2KwiAM\n    5+xT6wWYTdC31gsYpFmhF9ps6Qyi73MzoC8Iv5HzOr/nmxF+Qfx97Cfmg19w6vc58Te9TvEXSgAw\n    jIXAXyo8hwj8lgg8XkcRGITgmrVCYBCC1xoNgp0Kft0MGAyCcOvE4fJ9ar0As4Z9a72ACZoZepcE\n    3/J5Xd/3jYa+MM5Wz+DU79Vy4++I8Avj4u+sU78g/j4n/qbXMf5CKQAGEfhoMyAwpEHwjAgMdwge\n    FYFhzGlgcFvoHAnBrxOC+04Mfl0rEAZR+DFhOEafWi/Apu9b6wXYfyT0viX4ls9J39cJv7ETfq/l\n    1G9ao8IvzDv1C2n4K/zm62vrg8xY5/gLJQF4aRQI/lLhOUTgt2ZGYHAaeOlz6wUnNso0MIyxLTTE\n    h+BUBAYheITE4PUE4VgJw333qfUCrErfWi/ATifyfqwV9sJc4Aui71bCb+xGgV9og7+zwi+Iv0sz\n    T/2C+PuY+HusAfAXagAwiMBHEoHfNyME//xwzELwvc+tF5xQCQQGt4W+mhAcOzF4u9kwGAThyInD\n    9qn1AjroW+sFWPNE3u0E37qJvtv9ccBjFn7Xmw1+YV78vR28/ajwC+Kv+PuW+HusQfAXagEwiMBH\n    EoHfJwKP2xEI/tx6sYk5DXy93AgM8SEY5t0aeunHQY9rKzF4v5YgDKJwauKwmc2UyJtWS+yFOcEX\n    RN+9Rpz2hXT4jY6+S6Pgr/Bbv9uB284AvzAn/nq93/eJv+n1Br9LIQAYROCjzQDBIvB2o28JDU4D\n    p9YKgWEcCO4BgWFuCP7dL//rVPB2s2IwtAdhEIXPJBCbWW+JvMdqjb0wL/jCMfSF+eD3t78cr/Ab\n    v1HgF8Tf2t0O3n4G/J0RfkH8fawG/IL427r/sv3HdQEYxkFgcBo4Z0LweiLw6z63XnRCI0Gw20LX\n    bfatoWHO7aGXnAxOLwIIgyicI5HYzGol7l4rAvbC3OALom9Ko077wlhbPYPwm6NZ4RfE38dmxt9U\n    +AXxN1dfWx9k5noE4P+yfxMB+GpfKj3PDBCcisAgBI/aiNPAIATnasatoYXguSEYnA4+kyg8ZgKx\n    maUk7uZN7I2T4Jue8HtP+K2b8Fu/28Hbjwy/cMffGeEXnPp9Tvw9Xm/4mwC/S/UBGETgM80AwCAC\n    7yUCv+5z60UnVAKBQQjOUXQEBiF4SQx2MvhMUUB4SRgul0hsNnbibrmiQO+S4PuW1/RNa2T0BeF3\n    rxnhF+bF39uJ+4yMvzNP/YL4+5z4e7yB8RdaATCMh8BQHoJnQWBwS+i9fuaHoREYnAY+0ozXB4Y5\n    IRjmvkbwY2Kwk8FXiobCIAzXTiw2i5GoW7do0Ati73NO+qY3OvqC1/hNqRX+Cr9tuh28/cjwC3NP\n    /YL4+1xp/P3a+gALNDj+QksABhH4bLNAsAi83QzTwHAMgj+3Xmxio00DQzsInnFb6CWngu/NDsEg\n    BucoIgiDKBwt0dhsOzE3XoJvH4m+xxodfkeb9oWx4BfG2u4ZxN8ec+pX+H1O/D3eBPgLrQEYxkRg\n    cBo4VyLwdiLw6z63XnBio0HwSNPAIAT31u9++d/ZMRgE4VyJwpYj0dh6Tcztq4jQC2LvWoLvuYTf\n    t4TfNjn126bbwduPDL8g/oq/73PL53NNgr8QAYCXRoTgL4UffxYEhjQInhWBYQ4IHvXawOC20DkT\n    gtMaGYLBqeDHxOC8RUVhEIZHTkS2o4m34xYVekHs3Uv0Pdfo6AvCb2rCb97E3/6aHX4hDX9ngV8Q\n    f8/UG/zCJfyFSAAM4yHwlwrPIQJ/bFYI/vnhuIXgtz63XnBio00DgxDcKiH4fWLwW0cxGAThlCKj\n    8JI4bKmJzeUSZS21yMi7JPbudxR8QfRdmgF9QfhNrSX8wnj4K/z22ez469Tvx8Tf402IvxANgEEE\n    PpMI/LFZERicBl7rc+tFJzbaNDAIwa0Sgj/24yTHmZIYXLYeUBiEYTOzlvUAvSD2Hkn0vZbw+zHh\n    t13Cb5tuJ+4zMv7ODr8g/r5K/D3epPgLEQEYROCzzQLBqQgM80LwDAgM40Kw08D5E4LTmwGDnQr+\n    mCBcp15gGMRhM7Mc9YK8IPSeSfC9nuj7upnhF9zuOXej4u/I8Avibyr8wjz4WwN+QfyNUCb8hagA\n    vDQSBH+p9DyzIDA4DZzSz/wgAr/oc+tFJyYE529mCAangl8lBn/sDAaDIHy2nlB4SRw2M3urJ+Rd\n    EnvPdQZ8QfR97re/nA/h9329oC8Iv7kTfo83A/7OCr8g/r5K/D1ej/ALWfEXogMwiMBnmwWCReD9\n    nAZ+3efWC06sFALDvBBcAoFBCO693/3yv2LwxwTh+vWIwo8JxGY2Uj0C72Ni7/kE33zNhL4g/B5N\n    +M3fqPg7A/yC+JvSLPAL4u+ZxN//KD4Aw1gIDF4XOHduCb3fzw/HLQS/73PrBR/I6wPnz4ng9GaB\n    YHAqeC+3i25X7zC8JBCbWaR6B94loTdPbuuct1m2eF4Sfo/ldX7zNyr8gvg7Q+Lvx8Tf44m/7+oD\n    gEEEPpsQ/LFZERicBl7rc+sFH8htocskBB9LDLbHBOEYjYLDSyKxmeVoFNxdEnnzJ/jmT/Tdrif4\n    hfz42xp9Qfht3e3g7YXf8RN+Pyb8nq9HAC6Ev9ATAIMIfDYR+GMi8PgIDELw0ZwGLpMQPE5i8H5n\n    t4sGUbhUo8Hwc0Kx2ZyNBrvPCb1lOrulM4i+e82GvjA2/DrxW6bZ8fd24j7i7/iJvx8Tf88n/n5I\n    AI7QlwrPMRMCgxCc0iwQfBSBoR8IHnEaGITgKLk99HpeLzg9QThuo8Pwq8Ris9iNjrqvEnrLJviW\n    bbbr+i4Jv8cTfssk/Pab8HtP/P1YDfz92vogCyX+vqwvAF4Sgs8lAr9OBB4fgcFp4DMJwWUaGYJB\n    DLbtBOE+mhGHnxOLzfI0I+o+J/LWS/Atn+ibVk/oC8JvqWaHX3C751eJv8LvWuLv+cTf1foEYBCB\n    rzQTBKciMAjBIAS/6nPrBR9oRAhujcAgBC8Jwfu5RfTxBOE+E4i3E49ttETc7QTedgm+9Zpxi2cQ\n    fs/WGn7B6/y27nbiPrPgr/Cb1kz4K/xeS/zd7Ifv/29+5O9aH/HJRODzicCvE4FF4Fd9br3ggwnB\n    ZRKC7x2FYJgXg0EQPpog3H/icL6EZLuacJsvkbd9V7AXBN+jzTrpuyT8nkv4LdfI+DsL/IL4m5r4\n    m7evrQ+yUD3CL1TFX1gAGBCBg/Wl0vMIwR+bGYFhHgge+drAMCYCL42Kwb1BMDgVnJoYfL4rILwk\n    DMdLJG6ToBw/wbZN4m68rmIvCL5nEn3HRl8Qfkvm1K9Tv2uJv+LvWuLv+cTf5N4AGETgaH2p9Dwi\n    8MdE4DkQGMaeBi6FwNAegkdFYBCCR08Mvt5VFBaE+0koNrOribt95HRvu2ZHXxB+ryT8OvW7dDt4\n    e+F3nrze78dqwC+Iv9FqgL/wDMDQLwLDmBD8pdLzzITAIASn9PPDsY8OwU4Dn08IFoIfc3voY3nN\n    4DwJwvMmEJvNnbjbb4Jv+2a9pu9jwu/5hF/hd+l24j6j4+9PD7+eGX+d+n2d+Hu+XuEXmuEvvALg\n    pV4hWAQ+nwj8upkRGJwG3utz60UfSAgumxD8PqeCjycI50sUtseEYrO+EnbHKcdWziD45shJ33sz\n    oC+MDb/gdX4jdDtxn9HhF5z6XXLq93Xi7/l6xd+G8Lu0DsAgAkfqS6XnmQ2BQQhOTQje7nPrRR9I\n    CC6bEPw+p4LPJQbnLce1hEEYni3h2OxaQu5cib3xEn3vHUVfEH6fiwC/TvzG6HbiPjPBL4i/4u/r\n    xN/zib+X2gZg6BeBYTwI/lLxuWaDYBE4rZkQGMa+PjAIwTUqgcFC8HyJwWUShS13grGNnqBrj+UA\n    X7E3f6LvW8LvtSKgL7SHXyiHvz3BL3id37Wc+r0n/L6uFvyC+ButbgAYROBofan0PLMhMAjBqf3M\n    DyLwSp9bL/hgIyMwjA3BIAbPmBhcNlHYWiciW6nEWzubk73x83q+b4m+eRJ/7zn1+9bt4O3F33ny\n    Wr/rOfV7LfE3S2kADP0i8IgADCJwqVIBGETgmaaBR98SGsaG4NERGPqFYBCDryQG1ykXCoMwbLES\n    m9snylqkckEviL01En3fmgl9QfitkfD71u3EfWbAX+H3nvi7nvh7LfE3W+kADCJwxL5Ueh4h+HUi\n    8DwIDELw1YTge0Lw64Tg6wnC9cqJwiAMm5lZvXJCL4i9tRJ8Pyb85kv4vSf8vnU7cZ8Z4BfE3yW3\n    fH6d8Hs98TdrxwAYROCIfan0PCLwekKwELzV59YLPpEQXCe3hv7YGQgGMfi53/3yv4Jw3ZwWNjOz\n    SIm9/ea1fNcTfvMl/N4Tft+6nbiP8Dtf4u/rxN/rib/ZOw7AIAJH7UuF55gNgcFp4CMJwdt9br3g\n    g5VEYGgPwRAHg4Xg1zkVnCcxuG2isJmZ1Ujs7T/Rd73Z0BfKwW8U9IX28Avi72O3g7cXfufLLZ/X\n    q4G/X1sfZOHE3yKdA2DoF4FhbAj+UuE5RODthOA7BIvA631uveiDjQ7BURAY3B56KzE4X24V3b7c\n    W0iDOGxmNkO5kReE3taJvuuJvnkTft8n/L51O3Ef8Xe+nPpdz8nfawm/RTsPwCDPpV+pAAAgZUlE\n    QVQCR+1LpecRgtcTgZ0GTulz60UfbORtoUEI7iW3iM6fIBynEjAM4rCZWU+VQF4QeqMk+G53Bn1B\n    +N1K+H2f8Pu+24n7zIC/wu9bTv1uJ/5eS/wt3jUABhE4al8qPY8IvJ4ILAKn9Ln1ok8kBNdLCN7O\n    qeD8uV10zErBMIjDZmatEnrn6bd8F3x3mnHaF4TfmpWEX+gPf28n7jMD/IL4+5hTv+vVgl8QfyPW\n    Cf5CDgCGvhEYxoXgL5WeZ0YEBiH4SELwfp9bL/pEQnC9hODtnAoul9PBsSsJwyAOm5ldqRTwLgm9\n    cRN805p12heE35o58fu+24n7zAK/cMdf4Vf43cup32v1DL/QFf5CLgAGEThqXyo+lxC8ngg8HwLD\n    cQj+3HrBJxsdgiEOBpeEYBCDbTung/uqNA6DQGxmJvIauK3zkWZGX5gDfiOgLwi/r7odvP1s8Avi\n    L4i/e4m/1xJ/q5cPgEEEjtqXis81IwKnTgKDEAxCcEqfWy/4RCURGGJAcBQEXnIqeD8xuGy/e/i1\n    KNxXNXAYBGIz67vSuPuY0NtXgu+xRN/x0XcpAv661fPHbifuMwv+Cr9vea3f7dzy+Xrib/3+ju95\n    Afj+oH03KgKDW0KXzi2hj/UzP4jAO31uvegTCcH1E4LTEoPr5JbRfVcLhpcEYjNrWU3gBZG359zS\n    +Xizoy8Iv7UTfj92O3GfWeAXxN/HxN/txN/rib/1+7v7Oc8PwG9P0G8icJ5mhGCngY/lNHBan1sv\n    +kRuC10/ITg9MbhObhk9XrWBeEkoNrOj1cZdEHhHygnfc51FXxB+UxN+X+d2z++7nbiP8Dtvbvm8\n    nvCbp57xt0f4hf/AXygJwPcn6reRERicBi6ZCHy82SB4FgSGOSAYYmGw1wlO7ywEgxh8JkF4/FoB\n    8XOCsdl4tQDd5wTecRN8zyf63iuJvhALfqOgLwi/r7qduM8s+PvTw6/FX6d+9/Jav3kSf+v3d+/P\n    eVkAvj9hv4nAeZoRgUEIPtpsCAxCcK6E4NeVhmAQg5fE4PO5ZfR8RUFiEIrNWhcBdR8TeOdJ8L2W\n    6HuvNPqC8LuW8Pux24n7zAK/4NTvY8LvfuJvnsTf+v3dx3NeHoDvT9xvoyMwCMGl89rAxxKC0/rc\n    etEnE4Lb5FTwscTgdjklbEuRoPg54djsY9Ew9zFhd+7E3nx5Xd97s8EvxMFfr/P7sduJ+8wIvyD+\n    gts9p1QDf7+2PsgKib/1+7vX57wOAN8X0HejQ/CXSs8jAm8nAt+bEYFhHgguicBLUTBYCO4/Mbht\n    grCtFRmIUxKRLVKR8XYvcdeeE3zz5aTv+2ba5hnioC8Iv2vdDt5+JvgFp36fE3+3c+o3Tz3DLwyH\n    v1ATgO8L6TsROE+zIjAIwUebEYJnQWAoD8FREBjmg2AQg58Tg/P0u4dfi8KWWu9YnJqoPH49Q+2R\n    RF1L7bcPXyuCb55E348Jv+0Sfl93O3GfmfBX+H2f8Luf+Jsn8bdNf7d93usC8H1B/TcyBH+p+Fyz\n    QrAIfLyf+WEqBAYhOGdC8HpC8PnE4Dg5JWwlmwWPrzQjPM8CsVcSca1ETveWSfT9mNs8t034fd3t\n    xH1mgl+446/w+5b4u10t+IWx8bd3+IVh8RdaAPB9Yf0nAudJBN5PCL434zQwCME5E4K3E4PPJwbH\n    SxS2lonGNlpirrVI7C3bFfSFMeG3BvqC8LuV8Pu628n7zYS/Tv2+LxV+Qfyt0dfWB1sw8bdNCfC7\n    1AaA3xbaf0JwnoTg/YTgNwSGuSD4DAKDELyWELydEHwtMThuorD1lpBsORJvrYfE3jo56fu6Gad9\n    QfjtpduJ+8wIvyD+Lom/29WEXxgXf4XftnUDwPfF9p8InCcReD8R+J4QnN7n1ou+kBDcthoQDGLw\n    VoJw2byesNnHROdyCbFm97xub72c8t1O+G2f8Lve7cR9hN+5E373c+o3T+Jv2w7gL0QA4Pui+08E\n    zpMInJYQfM9todP73HrRFyoNwSAG7+VU8PXE4D4Shc3MzPIl9tZP9N1O9I1RafiFfvH3duI+M8Ev\n    uN3zc0fgF8TfGn1tfbAFE3/bdhB/IQoA3xfffyMjMNSD4FkRGJwGPtvP/DAdAoMQnLtICAzzQjCI\n    wXuJwfVz+2gzM7Pt3Ma5XaLvdrNe2xfmg99e0Re8zm9qPyH8PubUb1q18Pdr6wMtnPjbthP4C5EA\n    +O1A+k4EzpcQvJ8I/L4ZIXi26wODEBwlMThPYnC/OS1sZmYz5lRv+66CL4yPvjDvtC8Ivz11O3m/\n    GeEXxN/HUvFX+K3T19YHW7je8bdn+IXT+AsRAfh+QH03OgKD08A1chr4XG4LfazPrRd+ISE4RkJw\n    3gThvhOFzcxspMTeODnlm9bM074wH/zCfPgr/JpTv2k59Zsv8bddF+B3KSYA3w+u70TgvAnBaQnB\n    92ZFYHBb6FJFwuCoEAxicO6uYjAIwpFyG2kzM4ua2zfHyynf9GqhLwi/KdVAXxB+Z0j8fZ/wm5ZT\n    v3kTf9uVAX8hMgDfD7L/RofgLxWfSwROSwR+Swg+1ufWi77QjBAMcTG4FgSDGHwkMThmwrCZmdVK\n    6I2d6Hssp31jfSgv/O53O3Ef4ddA/E1N/M1X7/AL4u8vxQbg+8H2nwicNyE4LSH4rVkheMZtoaEO\n    BgvB6TkVnL8cGAyCcOTcStrMzK7k1s19lAN8QfQtlfCblvC73+3k/WbDX+H3Y0fgF+bF35rwC+Jv\n    D4m//1F8AL4f9BgJwXmbFYKPIDAIwY8Jwcf63HrhFxOCY+VUcLkE4Xn63dN/i8NmZnMn9PaV4Hsu\n    0fee8Ntft5P3mw1+Qfx9lVO/aTn1m68R4BfE36f6AOD7wY+RCJy3WREYnAY+26wIDHNCsFtDx0wM\n    LpvbRc+ZOGxmNl6/ffoQSOTtL7d1Ppfo+5bw21+3k/cTfg2c+j2S+Jsv8bd9BfAXegLgtxPRf6Mj\n    MHht4FqJwOcTgo/3ufXCLzQrBENsDK4JwSAGX0kQ7j+3lTYzi5vX5h0np3zPVxN9ITb8RkNfEH5T\n    up28n/BrS079puWWz3kTf9tXCH+hRwAGEbiXvlR8rpkRGITgs82MwHAOgj+3XvTFhOC4icHly4XB\n    IAiPljhsZlY2J3nHLRf4guhbo8joC8Jvz91O3GdG+AXx91XCb3pO/eZtBPwVfjfrE4BhDASG8SH4\n    S+XnE4LTE4LfmhmCZ5wGXpoVg4Xgj82IwUuisO3l1tJmZml5Pd7xy4m9MCf4Qn30BeH3aKJvereT\n    95sRf4Xf14m/aTn1m7cR4BfE34T6BWAQgXvqS+XnmxmCReDzCcHH+9x64RmaFYJBDH7VzBgMgrCd\n    ywliM5shgXe+nO7Nl+j7sWjou1QDf4XfuRJ+Xyf8pufUb97E3/ZVwl+AH75/50/4L51/UDMCBM+A\n    wOC20DUTgs8nBB/vc+uFZ0gIjp0YXL+cGAyC8Mw5RWxmkXN7Zltywjd/bvH8sYjwW2viF/rH39vJ\n    +wm/tnQEfmFu/BV+8yf+xqg6AAMicIBE4DLNDMEi8LV+5ocpERiE4BpFhGAQg9eaHYNBELay/W7l\n    98ViMzvTb1c+VBF37THBt0xO+34sIvqCWz0f6XbyfjPCL4i/azn1m5bbPZdpBPztHX6hKv7CIwCD\n    CBylGSD4S+XnE4HTE4LfN/M0MAjBNRKCz9cCgkEMXsoNwiAKW1pOFJvNnRO7dqbc2AuC71IL8IX4\n    6AvCr/A7X8LveuJvWuJv/kaAX+gffyvD79J7AIb+ERiE4F76Uvn5ZkZgcBr4akKwEFyjiBjcAwSD\n    GBwlp4QtYq+mi0VjszgJulYip3vLJvpuJ/zGPP4j3U7eb3b4BfH3OeE3PfE3f+JvjBrhL7wCYBCB\n    IzU6AoMQXDsh+HyzIzAIwbWKCMEgBu8lBr+vxIQwiMJWvt9t/JlwbLae2y5bq0pM94Lo+5zou19E\n    +PX6vse6nbzfrPALTv2uJfwey+v95k34jVND/IU1AAYROFqjQ/CXys8nAqcnAn9MCBaCayUEX08M\n    jpMgbDPl1LH12CvAFW8tYoJvvUTf/SKiLwi/R7tduO+s+Cv8rif+pufUb/7E3zg1xl/YAuCl3iF4\n    FAQeHYCXvlR+PiE4PSH4Y0KwEFyrqBAMYnBKYvB6pVAYhGEbq9/t/Lm4PE+/3fkQQbC10RJ76yf6\n    7hcVfUH4Pdrt5P1mRV8QfrcSfo8l/uZP/I1TAPyFFAAGEThSM0Dwl8rPNzsCgxB8NSF4bgiGehgs\n    BOepFQQvCcLbicJm9dsD5rP1CtN7yHolgdZsPbG3Ta3Ad0n4zZPX9z3W7eT9hF/h91XC77GE3/yN\n    Ar/QP/4Ggd+lNAAGEThSMyAwCMG1E4GvJQKfR2AQgs8kBudJDI5fSRAGUdjMzKxFpbAXBN+URN/0\n    RN97s8MviL8g/r5K/E1P+C2T+BunYPgLRwAYROBIicBlmh2BQQi+mhDsNDAIwY/1hMHQFoTF4PSc\n    EjYzM+snsTdGLdG3J/BdEn7vjQK/4NTvmYTf9Y7AL4i/4m+ZxN84BcRfOArA0D8CwzgQPAsCgxBc\n    uyMIDELwq4RgIRiE4Md6g2BwOri3nBQ2MzNrW0noXRJ803PK93iR0ReE37PdTt5P+BV+13Lq91g1\n    8fdr64Ot2Cj42zv8Qlj8hTMAvNQ7BI+CwDAPBH+p/HyzIzA4DZwjIditoUEIfk4MPp4YfK7SKAzC\n    sJmZzZfQG7fW6AvCb4mE3+PdLtxX+BV+1xJ+j+XUb5lGgV8Qfys0LwDDWAgMc0DwlwbPKQQLwTkS\n    goXgJTH4LSH4XGLwtWqgMAjDZmbWfzWgd0nwPZ/oey7R961R0BeE3yuJv+sJv8eqDb8g/vaY+Ful\n    8wAMYyAwjAXBMyAwOA3cIreFvt7PD+dECD7X59aLz1hNCAYxuEQRMBgE4avVAuElYdjMzKJVE3pB\n    7L1aBPAF0bdUNeEXxsHf24X7zgy/Pz38Wvj9mNf5PZ5Tv2USfuPVAf7CVQBeGgGCR0JgmAOCvzR4\n    TiHYaeAcOQ18Twi+JwR/rEcMBkF4tIRhMzMbLaG3zwTfa4m+HxsFfUH4vZITv9s59Xs88bdM4m+8\n    OsFfyAXAMAYCw1gQPAMCg9PALXIaOE9C8D0h+J4Q/LFeIRjE4JGrDcMgDpuZ2bGE3v4Tfa8n/H5M\n    +L0n/N4Tfl/n1O/xhN9yib+x6gh+l/IBMIjAEROByyUEOw2cKyH4nhD8ltcJ/pgYnCdBuEwtUBiE\n    YTOzmauNvEtib5migC+IvjXy+r7nu1247+zwC3f8FX7Xc+r3WF7rt1zCb7w6xF/IDcAgAkdsFgQG\n    p4FbJQTnSQi+JwS/5VTw68TgfAnCZWsFw0sCsZlZv7UC3iWht2yRwBdE3xo57Xut24X7Cr/C715O\n    /R7Pqd9yib/x6hR/oQQAwzgIDEJwr32p/HxCsNtC5+rnh/MiBAvBS7UhGMTgWgnC8yYOm5mZyDtP\n    gm/eekFfEH6vdrtwX+HX7Z73En7PJf6WaST4BfE3SGUAeGkUCBaB++xL5ecTge8JwXkSgt8Sgt8S\n    grfrHYNBELb2MLwkEJuZXa818C4JvfUTfPMn+m4n/L4l/Aq/ewm/5xJ+yyX+xqtz+F0qC8AgAkdt\n    Fgj+0uA5heB7bgudJ7eFfksIfp/bQ28nBpdJEG5XFBh+TCQ2s9mLArxLQm+7ooEviL4tctr3ercL\n    9xV+hd+UvM7v8bzWb7mE35gNgr9QA4BBBI6cEFwuIfieEJwnIfh9ZzH4c+uFF8ip4P3E4LKJwu2L\n    iMMgEJtZ30XD3SWRN0YRwRdE3xY57Zun24X7Cr/Cb0pO/Z7Lqd9yib8xGwh/oRYAL40AwSJwv31p\n    8Jwi8D0ROF9C8FtXJoJhPAxuAcEgBrcqKgiLwTGLCsSPicVmVqOoqPuYwBszwbdsom9ao8Hv7eL9\n    hd97PyH87uXU7/Gc+i3XaPALY+DvYPC7VBeAYQwEhvEgeBYEBiG4VV4bOF9eH/h9QvDHnApOaxQM\n    hrggDKJw9HrA4ceEYjNbqwfcXRJ5YxcVe2Ec8IX+0Bec9s3V7eL9hd97Tv3u59Tv8YTfso2GvyPA\n    LwyLv9ACgEEEjpoIXDYR+J4QnC+ngd8nBH/MqeD0xOB6CcJ91RsQPyYWm/VdT6D7nMDbV5HBF0Tf\n    1jntm6/bxfsLv2/oC8LvVsLvucTfsom/MRsYf6EVAMM4CAxCcM99afCcQvA9IThfTgR/7AoGf269\n    +EI5FZzeSBgM8UEYROHe6xmJtxKQza7VM+BuJe72XXTshbHAF/pEX3DaN2e3C/cVfe8Jv2kJv+cS\n    fss2GvyC+NtR7QAYRODIzYTAUB+CReC3vD5wvpwI/pgQ/DGngo81GgZDHyAMovCIjQrFzwnHNlqj\n    Qu5zwu549YC9S6JvjJz2zdvtwn2F37fc6jktr/N7rtr4+7X1AVduNPwdBX5hCvyF1gAMYyEwCMG9\n    96Xy8wnBbwnB+RKCP+b20K8Tg481IgZDPyAMovAszQLFqQnKdrRZwPZI4u4c9QK+o2Hvkuh7POH3\n    Y8LvW8JvWk79nsup37KNBr8g/nZaewBeGgmCReC++9LgOYXge24LnTch+GNC8OtaQTCIwREThK2n\n    xOJ6CdFpia91EnStF+yFccEXRN8zib6vE37fEn7TEn7P1QJ+QfztuZHgF6bCX4gEwCACR28mCP7S\n    6HmF4HtCcN6E4I8Jwes5FXwuQThOorDtJRqbxUrMtb16wt4l0TdmbvGcv9vF+wu/b3md37SE3/M5\n    9Vu20eAXxsLfyeB3KRYAgwgcvZkQGJwGbtlRBAYheC8h+HVeJ/h1TgWfb2QMhv5AeEkYtqsJx2bb\n    CbmWI7E3Xj2DLzjtW6rbxfsLv2858ZvWUfgF8XdJ+C2f+Bu7SfEXIgLw0igQPCICw1wQ/KXBc4rA\n    bzkNnD8h+GNOBK/XEoJBDO6hXkEYRGFrl5hsURJtrVU9Qu/S6OALou/VhN/1hN+3nPhNz6nf84m/\n    5RN/Yzcx/kJkAIZxEBjGhOCZEBiE4NYJwfkTgl8nBq8nBl9vBhAGUdisdQLzOAm0NkJib/x6B18Q\n    fUt3u3Bf0fd9TvymJ/yeT/gtn/Abu8nhdyk2AIMIHL3ZEBiE4NYJwXkTgdcTgrcTg683CwZD3yC8\n    JAybmZlt1zP0Ls0CviD65kj03U74/Zj4m5bwez7ht07ib+zE3/8oPgAvCcGxmw2CvzR4ThH4fUJw\n    3n5+OD9i8MfE4PWE4DzNhMFLI6AwCMNmZjZfI0Dv0kzgC2OgLwi/pbtdvL/w+zHhNy3h91rib/lG\n    hF8QfwdOAG6VCDxGXxo8pxD8PiE4b0LwelcRGMaGYBCDczYjCMM4KAzCsJmZ9Z/Q23+jgC+IvjW6\n    Xby/8Ps+r/GbnvB7LeG3TiPi70jwC+Lvi/oB4CUhOH6zQfCXRs8rBL8lApfJ7aHXcyJ4PzE4b4Lw\n    WInDZmYWpZGQ9zHBd4xE3/LdMjyG8Ps+4fdY4u/5WsAvzIe/I8IviL+T1B8AgwjcS0Jw+UTg9wnB\n    +XMieDshOK3WGAxjgfCsGLw0KgqDMGxmZuUaFXphXuxdGgl9W4MvzIG+4LRviYTfYwm/13Lqt04j\n    4q/wO1V9AjCMh8AwJgTPhsAgBEdICM6fELyd20OnFQGCYSwMBkEYxkbhJXHYzMz2Ghl5l2bHXhgL\n    fCEG+sIc8HvL8BjC78eE32MdhV8Qfx8Tfusk/PaR+LtbvwC8JATHTwSulxD8lghcJreF3s+p4LTE\n    4HIJwm/NAMMgDpuZzdQMyAtC72OjgS+IvrW7Xby/6Lvegr/Cb1pO/Z7P7Z7rNRr+jgi/IP4m1j8A\n    gwjcS0JwnUTg9x2FYBCDU3IieD8hOD0xuGyC8PtmQeHHBGIzs76aBXmXxN73jQi+IPq26Hbx/sLv\n    65z4PZ7wey2nfus0GvwujQbAwu+hxgBgEIF7aUYEBiE4QkJwuZwK3k4IPpYYXD5B+GMzovCSOGxm\n    Vr/ZgPcxsfdjo4IviL4tumV4DOH3dU77Hk/4vZbwW68R8Xc0+AXx90TjAPDSaBA8IgLDnBD8pdHz\n    CsHvc2vocgnB+4nB6UWBYBgbg0EQ3mpmGH5MJDYzS29m3H1M6F1vZPCFOOgLwu+RRN/1nPg9nvB7\n    Lbd7rteI8Avj4a/we7rxABhE4F6aEYHBaeAoCcHlEoL3uwrBIAa3anQMBkE4JWH4YyKxmc2SwPs+\n    oXe/0cEXRN9W3TI8hvC7nvB7vKPwC+Lvc0791kv87SPx91JjAvCSENxHM0Lwl0bPKwS/z22hyyYE\n    7ycEn0sQrpsgnJ4wvJ9QbGYRE3X3E3rTE3zrNhP4Lt0yPIbwu55bPR9P+L2eU7/1En77Sfy93NgA\n    DCJwTwnB9RKC3ycEl00ITsvtoY8XCYJhDgxeEoWPJw6fSzA2szMJuucSeY83A/YuRUJfEH7PJPpu\n    J/weT/i9nvBbr1HhF8bDX+E3W+MDMIyHwDAuBIvAdROC3ycEl00ITsup4HNFw2AQhC09cfh6QrHZ\n    HAm71xN5ryX4tk30PZfwu53wezzh93qt4BfE35EaDX6XBOBszQHAMCYCw5gQPCMCg9PAkfL6wGX7\n    +eF8icHbORV8LjG4fYJwnoThOonHZnUTcesk9OZpJvAF0TdStwyPIfxuJ/ye6yj+Cr8fc+q3buJv\n    Pwm/2ZsHgEEE7i0huG5C8MeE4LI5EZyeU8HXigbCs2HwkiicN3E4TgKyzZiIGyehN1+zYe9SNPSd\n    FXxB9K2V8Hsu4fd6wm/dhN++En+LNBcALwnBfSUE10sEfp0QXDYhOL0cEAxicLRmBWEQhUsmEPeZ\n    mGylEmz7TNwt16zYC/HAF+ZGXxB+ayX8nkv4zZP4Wy/ht6+E36LNCcAgAvfWrAgMQnCkhOCyCcHp\n    CcF5iojBIAhbnQRi20qIzpfwanuJvHUSfOMl+uZJ+N1P+D2X1/nNk/BbN/G3r8Tf4s0LwEsjQvCo\n    CAzzQvCXRs8rBH/sKAKDEHw0rxF8LLeHzpMYHDdRuE0CsZnZ9cTd+s0MvY+JvnG7ZXgM0Xe/nx5+\n    LfweS/jNk/Bbt1HhF8Rfu5QADCJwj80IwV8aPrcQ/DEhuHxC8PHE4HwJwvEThtsnEpvZrAm7MRJ7\n    34oKviD6gtO+NRN+zyf85qkV/MKc+Dsy/MKY+Cv81uvvBeD3CcF9NSMCgxAcLSG4Tm4PfSy3iM5X\n    VAheEoTfJwrHTSw2s14Sd2Mm9r4vMviC6Auib+2E3/MJv3kSfus3Mv4Kv3a1v7//jwD83IgIDELw\n    iH1p9Lwi8OuE4DoJwcdzKjhvgnB/icL9JBKbWcmE3X4Sez8m+PbTLcNjiL7peX3f8wm/+XK757qN\n    DL8g/tr1/v7tlwLwq0Tg/poVgUEIjpYQXCch+HhOBecvOgaDILyVMDxGorHZnIm5YyT0rif49tUt\n    0+MIv+kJv+cTfvMl/NZvZPwdEX5B/K3d37//TwF4rVERGITgEfvS8LmF4NcJwXXyOsHnEoPLJAj3\n    nyg8T8KxWZzE3DkSe/cTffvqlulxRN/03Ob5WsJvvtzuuX4jwy+Iv5anv//4WwLwXqNC8MgIDEJw\n    i4Tg1x2FYBH4XELwuXJBMIjBz/WAwSAIH0kctscEZLN74q09JvKmFx17l0Tf990yPpbwm57we72j\n    +Cv8vk74rZ/w22fCb93+fv2PBOCURkVgEIJH7UvD5xaCXycE18vtoc8lBpdNEB43YdhyJixbqYRa\n    y5nQezzBt+9umR5H9D2W2zxfT/jNl9s9129k/B0VfkH8rd3fb/+xAHwkIbjPROA2CcGvE4LrJQSf\n    zy2iyycIj58wbNETm9snylr0hN7z9QK+IPqudcv0OKLv8YTf6wm/+XLqt34jwy+Mi7/Cb/3+fv8m\n    AvDRROA+mxWBwWngqHmN4Hq5PfT5nAquUy8YvCQKX08cNjOzKIm81+sJe0Hw3eqW8bGE32O5zfP1\n    vMZv3oTfNom/fSb+1i8Bf0EAPt+oEDwyAoMQ3CoheD0huF5C8LXE4HoJwnMnDpuZWe5E3rwJvmN1\n    y/hYou/xhN88ib/5En7bJPz2mfBbv0T4XRKArzQqAoMQPHJfGj2vCLyeCFw/MfhaYnDdegNhEIVL\n    JQ6bmdlaIm+ZesPeJdF3u1vGxxJ9jyf65kv4zZvX+W2T+Ntn4m/9DuIvCMB5GhWCReCx+9LwucXg\n    1wnB9ROCr5UTgkEMTqlHDAZBuFYCsZnZuAm8dRJ8x+2W+fGE3+MJv/kSfvMm/LZJ+O0z4bdNJ/AX\n    BOB8jYrAIASP3JeGzy0CrycE108Ivp4Y3KZeQXhJGK6bQGxmFjeBt269Qu+S4JveLeNjib7nEn7z\n    dAZ9Qfjdyu2e2yT89pv4W7+T8LskAOdMBO47IbhNQvB2YnDdhOA8icHt6h2EQRRumUBsZlYmcbdt\n    vWMvCL5HumV+PNH3fMJvnpz2zZ/w26bR4RfEX8ufABwwIbjfZkZgEIIjJwTXTwzOkxjcthFAGETh\n    aAnFZmZvibuxGgF7QfA92i3z44m+5xN983YUf4Xf7YTfdo2Ov8Kvlegi/oIAXK6RERiE4JH70vj5\n    heDtjkKwCJynBYOF4GuJwe0bBYSXhOHYCcVm1nPCbvxGwV4QfM90y/x4ou/5fnr6b+H3ek795k/8\n    bZPw23fib7sy4C8IwOUbGYJHR2AQglsmBK93ZhoYxOAcORWcLzE4TqKwRUgsNrMaibp9NhL0gth7\n    pVvmxxN9r+W0b/6E37y1RF+YG35B/O054bddmeB3SQCu0cgIDOND8MwIDEJw9Nwauk1CcN7E4FiN\n    BsJLwvA4icVm9pioO1ajYS8Ivle7ZX480fd6wm/eRN/8Cb9tGx1+Qfy1MmXGXxCA6zYyBI+OwCAE\n    f2n8/ELwdkJwm4Tg/InB8RoVhEEUni3h2Cx2Qu5cjQi9S4Lv9W6ZH0/0zZPwmzfhN3/Cb9uE374T\n    fttWAH9BAK6fCNx/QnC7ROD9hOB2icH5y43BIAjnamQUBmHY1hORzV4n3tpaI0MviL25uhV4TNE3\n    T6Jv/oTfMnmN33bNAL8wLv4Kv20rBL9L/3+p31xxXlEVpgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAy\n    Mi0wMi0yNlQxODoxNzo0OSswMzowMDbsQsUAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjItMDItMjZU\n    MTg6MTc6NDkrMDM6MDBHsfp5AAAAAElFTkSuQmCC" }, void 0)] }), void 0));
};

const CflrLogo = ({ size = '24px ' }) => {
    return (jsxs("svg", Object.assign({ version: "1.1", id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", width: size, height: size, viewBox: "0 0 1920 1920", enableBackground: "new 0 0 1920 1920" }, { children: [jsx("g", { transform: "translate(0.000000,1000.000000) scale(0.100000,-0.100000)", fill: "#ffe669", stroke: "none" }, void 0), jsx("image", { id: "image0", width: "1920", height: "1920", x: "0", y: "0", href: "data:image/png;base64,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" }, void 0)] }), void 0));
};

var bn = {exports: {}};

(function (module) {
(function (module, exports) {

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = require('buffer').Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) ; else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(module, commonjsGlobal);
}(bn));

var BN$3 = bn.exports;

const version$q = "logger/5.6.0";

let _permanentCensorErrors$1 = false;
let _censorErrors$1 = false;
const LogLevels$1 = { debug: 1, "default": 2, info: 2, warning: 3, error: 4, off: 5 };
let _logLevel$1 = LogLevels$1["default"];
let _globalLogger$1 = null;
function _checkNormalize$1() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        ["NFD", "NFC", "NFKD", "NFKC"].forEach((form) => {
            try {
                if ("test".normalize(form) !== "test") {
                    throw new Error("bad normalize");
                }
                ;
            }
            catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) {
            throw new Error("missing " + missing.join(", "));
        }
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) {
            throw new Error("broken implementation");
        }
    }
    catch (error) {
        return error.message;
    }
    return null;
}
const _normalizeError$1 = _checkNormalize$1();
var LogLevel$1;
(function (LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})(LogLevel$1 || (LogLevel$1 = {}));
var ErrorCode$1;
(function (ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})(ErrorCode$1 || (ErrorCode$1 = {}));
const HEX$1 = "0123456789abcdef";
class Logger$1 {
    constructor(version) {
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if (LogLevels$1[level] == null) {
            this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        }
        if (_logLevel$1 > LogLevels$1[level]) {
            return;
        }
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log(Logger$1.levels.DEBUG, args);
    }
    info(...args) {
        this._log(Logger$1.levels.INFO, args);
    }
    warn(...args) {
        this._log(Logger$1.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if (_censorErrors$1) {
            return this.makeError("censored error", code, {});
        }
        if (!code) {
            code = Logger$1.errors.UNKNOWN_ERROR;
        }
        if (!params) {
            params = {};
        }
        const messageDetails = [];
        Object.keys(params).forEach((key) => {
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for (let i = 0; i < value.length; i++) {
                        hex += HEX$1[value[i] >> 4];
                        hex += HEX$1[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                }
                else {
                    messageDetails.push(key + "=" + JSON.stringify(value));
                }
            }
            catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch (code) {
            case ErrorCode$1.NUMERIC_FAULT: {
                url = "NUMERIC_FAULT";
                const fault = message;
                switch (fault) {
                    case "overflow":
                    case "underflow":
                    case "division-by-zero":
                        url += "-" + fault;
                        break;
                    case "negative-power":
                    case "negative-width":
                        url += "-unsupported";
                        break;
                    case "unbound-bitwise-result":
                        url += "-unbound-result";
                        break;
                }
                break;
            }
            case ErrorCode$1.CALL_EXCEPTION:
            case ErrorCode$1.INSUFFICIENT_FUNDS:
            case ErrorCode$1.MISSING_NEW:
            case ErrorCode$1.NONCE_EXPIRED:
            case ErrorCode$1.REPLACEMENT_UNDERPRICED:
            case ErrorCode$1.TRANSACTION_REPLACED:
            case ErrorCode$1.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) {
            message += " [ See: https:/\/links.ethers.org/v5-errors-" + url + " ]";
        }
        if (messageDetails.length) {
            message += " (" + messageDetails.join(", ") + ")";
        }
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function (key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, Logger$1.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) {
            return;
        }
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) {
            return;
        }
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (_normalizeError$1) {
            this.throwError("platform missing String.prototype.normalize", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "String.prototype.normalize", form: _normalizeError$1
            });
        }
    }
    checkSafeUint53(value, message) {
        if (typeof (value) !== "number") {
            return;
        }
        if (message == null) {
            message = "value not safe";
        }
        if (value < 0 || value >= 0x1fffffffffffff) {
            this.throwError(message, Logger$1.errors.NUMERIC_FAULT, {
                operation: "checkSafeInteger",
                fault: "out-of-safe-range",
                value: value
            });
        }
        if (value % 1) {
            this.throwError(message, Logger$1.errors.NUMERIC_FAULT, {
                operation: "checkSafeInteger",
                fault: "non-integer",
                value: value
            });
        }
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) {
            message = ": " + message;
        }
        else {
            message = "";
        }
        if (count < expectedCount) {
            this.throwError("missing argument" + message, Logger$1.errors.MISSING_ARGUMENT, {
                count: count,
                expectedCount: expectedCount
            });
        }
        if (count > expectedCount) {
            this.throwError("too many arguments" + message, Logger$1.errors.UNEXPECTED_ARGUMENT, {
                count: count,
                expectedCount: expectedCount
            });
        }
    }
    checkNew(target, kind) {
        if (target === Object || target == null) {
            this.throwError("missing new", Logger$1.errors.MISSING_NEW, { name: kind.name });
        }
    }
    checkAbstract(target, kind) {
        if (target === kind) {
            this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger$1.errors.UNSUPPORTED_OPERATION, { name: target.name, operation: "new" });
        }
        else if (target === Object || target == null) {
            this.throwError("missing new", Logger$1.errors.MISSING_NEW, { name: kind.name });
        }
    }
    static globalLogger() {
        if (!_globalLogger$1) {
            _globalLogger$1 = new Logger$1(version$q);
        }
        return _globalLogger$1;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) {
            this.globalLogger().throwError("cannot permanently disable censorship", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        if (_permanentCensorErrors$1) {
            if (!censorship) {
                return;
            }
            this.globalLogger().throwError("error censorship permanent", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        _censorErrors$1 = !!censorship;
        _permanentCensorErrors$1 = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = LogLevels$1[logLevel.toLowerCase()];
        if (level == null) {
            Logger$1.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        _logLevel$1 = level;
    }
    static from(version) {
        return new Logger$1(version);
    }
}
Logger$1.errors = ErrorCode$1;
Logger$1.levels = LogLevel$1;

const version$p = "bytes/5.6.1";

const logger$s = new Logger$1(version$p);
///////////////////////////////
function isHexable$1(value) {
    return !!(value.toHexString);
}
function addSlice$1(array) {
    if (array.slice) {
        return array;
    }
    array.slice = function () {
        const args = Array.prototype.slice.call(arguments);
        return addSlice$1(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function isBytesLike(value) {
    return ((isHexString$1(value) && !(value.length % 2)) || isBytes$1(value));
}
function isInteger$1(value) {
    return (typeof (value) === "number" && value == value && (value % 1) === 0);
}
function isBytes$1(value) {
    if (value == null) {
        return false;
    }
    if (value.constructor === Uint8Array) {
        return true;
    }
    if (typeof (value) === "string") {
        return false;
    }
    if (!isInteger$1(value.length) || value.length < 0) {
        return false;
    }
    for (let i = 0; i < value.length; i++) {
        const v = value[i];
        if (!isInteger$1(v) || v < 0 || v >= 256) {
            return false;
        }
    }
    return true;
}
function arrayify$1(value, options) {
    if (!options) {
        options = {};
    }
    if (typeof (value) === "number") {
        logger$s.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while (value) {
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) {
            result.push(0);
        }
        return addSlice$1(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof (value) === "string" && value.substring(0, 2) !== "0x") {
        value = "0x" + value;
    }
    if (isHexable$1(value)) {
        value = value.toHexString();
    }
    if (isHexString$1(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") {
                hex = "0" + hex;
            }
            else if (options.hexPad === "right") {
                hex += "0";
            }
            else {
                logger$s.throwArgumentError("hex data is odd-length", "value", value);
            }
        }
        const result = [];
        for (let i = 0; i < hex.length; i += 2) {
            result.push(parseInt(hex.substring(i, i + 2), 16));
        }
        return addSlice$1(new Uint8Array(result));
    }
    if (isBytes$1(value)) {
        return addSlice$1(new Uint8Array(value));
    }
    return logger$s.throwArgumentError("invalid arrayify value", "value", value);
}
function concat$4(items) {
    const objects = items.map(item => arrayify$1(item));
    const length = objects.reduce((accum, item) => (accum + item.length), 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object) => {
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return addSlice$1(result);
}
function stripZeros(value) {
    let result = arrayify$1(value);
    if (result.length === 0) {
        return result;
    }
    // Find the first non-zero entry
    let start = 0;
    while (start < result.length && result[start] === 0) {
        start++;
    }
    // If we started with zeros, strip them
    if (start) {
        result = result.slice(start);
    }
    return result;
}
function zeroPad(value, length) {
    value = arrayify$1(value);
    if (value.length > length) {
        logger$s.throwArgumentError("value out of range", "value", arguments[0]);
    }
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return addSlice$1(result);
}
function isHexString$1(value, length) {
    if (typeof (value) !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) {
        return false;
    }
    if (length && value.length !== 2 + 2 * length) {
        return false;
    }
    return true;
}
const HexCharacters = "0123456789abcdef";
function hexlify(value, options) {
    if (!options) {
        options = {};
    }
    if (typeof (value) === "number") {
        logger$s.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while (value) {
            hex = HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) {
                hex = "0" + hex;
            }
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof (value) === "bigint") {
        value = value.toString(16);
        if (value.length % 2) {
            return ("0x0" + value);
        }
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof (value) === "string" && value.substring(0, 2) !== "0x") {
        value = "0x" + value;
    }
    if (isHexable$1(value)) {
        return value.toHexString();
    }
    if (isHexString$1(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") {
                value = "0x0" + value.substring(2);
            }
            else if (options.hexPad === "right") {
                value += "0";
            }
            else {
                logger$s.throwArgumentError("hex data is odd-length", "value", value);
            }
        }
        return value.toLowerCase();
    }
    if (isBytes$1(value)) {
        let result = "0x";
        for (let i = 0; i < value.length; i++) {
            let v = value[i];
            result += HexCharacters[(v & 0xf0) >> 4] + HexCharacters[v & 0x0f];
        }
        return result;
    }
    return logger$s.throwArgumentError("invalid hexlify value", "value", value);
}
/*
function unoddify(value: BytesLike | Hexable | number): BytesLike | Hexable | number {
    if (typeof(value) === "string" && value.length % 2 && value.substring(0, 2) === "0x") {
        return "0x0" + value.substring(2);
    }
    return value;
}
*/
function hexDataLength(data) {
    if (typeof (data) !== "string") {
        data = hexlify(data);
    }
    else if (!isHexString$1(data) || (data.length % 2)) {
        return null;
    }
    return (data.length - 2) / 2;
}
function hexDataSlice(data, offset, endOffset) {
    if (typeof (data) !== "string") {
        data = hexlify(data);
    }
    else if (!isHexString$1(data) || (data.length % 2)) {
        logger$s.throwArgumentError("invalid hexData", "value", data);
    }
    offset = 2 + 2 * offset;
    if (endOffset != null) {
        return "0x" + data.substring(offset, 2 + 2 * endOffset);
    }
    return "0x" + data.substring(offset);
}
function hexConcat(items) {
    let result = "0x";
    items.forEach((item) => {
        result += hexlify(item).substring(2);
    });
    return result;
}
function hexValue(value) {
    const trimmed = hexStripZeros(hexlify(value, { hexPad: "left" }));
    if (trimmed === "0x") {
        return "0x0";
    }
    return trimmed;
}
function hexStripZeros(value) {
    if (typeof (value) !== "string") {
        value = hexlify(value);
    }
    if (!isHexString$1(value)) {
        logger$s.throwArgumentError("invalid hex string", "value", value);
    }
    value = value.substring(2);
    let offset = 0;
    while (offset < value.length && value[offset] === "0") {
        offset++;
    }
    return "0x" + value.substring(offset);
}
function hexZeroPad(value, length) {
    if (typeof (value) !== "string") {
        value = hexlify(value);
    }
    else if (!isHexString$1(value)) {
        logger$s.throwArgumentError("invalid hex string", "value", value);
    }
    if (value.length > 2 * length + 2) {
        logger$s.throwArgumentError("value out of range", "value", arguments[1]);
    }
    while (value.length < 2 * length + 2) {
        value = "0x0" + value.substring(2);
    }
    return value;
}
function splitSignature(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if (isBytesLike(signature)) {
        let bytes = arrayify$1(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = hexlify(bytes.slice(0, 32));
            result.s = hexlify(bytes.slice(32, 64));
        }
        else if (bytes.length === 65) {
            result.r = hexlify(bytes.slice(0, 32));
            result.s = hexlify(bytes.slice(32, 64));
            result.v = bytes[64];
        }
        else {
            logger$s.throwArgumentError("invalid signature string", "signature", signature);
        }
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) {
                result.v += 27;
            }
            else {
                logger$s.throwArgumentError("signature invalid v byte", "signature", signature);
            }
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - (result.v % 2);
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) {
            bytes[32] |= 0x80;
        }
        result._vs = hexlify(bytes.slice(32, 64));
    }
    else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = zeroPad(arrayify$1(result._vs), 32);
            result._vs = hexlify(vs);
            // Set or check the recid
            const recoveryParam = ((vs[0] >= 128) ? 1 : 0);
            if (result.recoveryParam == null) {
                result.recoveryParam = recoveryParam;
            }
            else if (result.recoveryParam !== recoveryParam) {
                logger$s.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            }
            // Set or check the s
            vs[0] &= 0x7f;
            const s = hexlify(vs);
            if (result.s == null) {
                result.s = s;
            }
            else if (result.s !== s) {
                logger$s.throwArgumentError("signature v mismatch _vs", "signature", signature);
            }
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) {
                logger$s.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            }
            else if (result.v === 0 || result.v === 1) {
                result.recoveryParam = result.v;
            }
            else {
                result.recoveryParam = 1 - (result.v % 2);
            }
        }
        else {
            if (result.v == null) {
                result.v = 27 + result.recoveryParam;
            }
            else {
                const recId = (result.v === 0 || result.v === 1) ? result.v : (1 - (result.v % 2));
                if (result.recoveryParam !== recId) {
                    logger$s.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
                }
            }
        }
        if (result.r == null || !isHexString$1(result.r)) {
            logger$s.throwArgumentError("signature missing or invalid r", "signature", signature);
        }
        else {
            result.r = hexZeroPad(result.r, 32);
        }
        if (result.s == null || !isHexString$1(result.s)) {
            logger$s.throwArgumentError("signature missing or invalid s", "signature", signature);
        }
        else {
            result.s = hexZeroPad(result.s, 32);
        }
        const vs = arrayify$1(result.s);
        if (vs[0] >= 128) {
            logger$s.throwArgumentError("signature s out of range", "signature", signature);
        }
        if (result.recoveryParam) {
            vs[0] |= 0x80;
        }
        const _vs = hexlify(vs);
        if (result._vs) {
            if (!isHexString$1(result._vs)) {
                logger$s.throwArgumentError("signature invalid _vs", "signature", signature);
            }
            result._vs = hexZeroPad(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) {
            result._vs = _vs;
        }
        else if (result._vs !== _vs) {
            logger$s.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
        }
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}

const version$o = "bignumber/5.6.1";

var BN$2 = BN$3.BN;
const logger$r = new Logger$1(version$o);
const _constructorGuard$4 = {};
const MAX_SAFE$1 = 0x1fffffffffffff;
function isBigNumberish(value) {
    return (value != null) && (BigNumber$1.isBigNumber(value) ||
        (typeof (value) === "number" && (value % 1) === 0) ||
        (typeof (value) === "string" && !!value.match(/^-?[0-9]+$/)) ||
        isHexString$1(value) ||
        (typeof (value) === "bigint") ||
        isBytes$1(value));
}
// Only warn about passing 10 into radix once
let _warnedToStringRadix$1 = false;
class BigNumber$1 {
    constructor(constructorGuard, hex) {
        if (constructorGuard !== _constructorGuard$4) {
            logger$r.throwError("cannot call constructor directly; use BigNumber.from", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "new (BigNumber)"
            });
        }
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return toBigNumber$1(toBN$1(this).fromTwos(value));
    }
    toTwos(value) {
        return toBigNumber$1(toBN$1(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") {
            return BigNumber$1.from(this._hex.substring(1));
        }
        return this;
    }
    add(other) {
        return toBigNumber$1(toBN$1(this).add(toBN$1(other)));
    }
    sub(other) {
        return toBigNumber$1(toBN$1(this).sub(toBN$1(other)));
    }
    div(other) {
        const o = BigNumber$1.from(other);
        if (o.isZero()) {
            throwFault$2("division-by-zero", "div");
        }
        return toBigNumber$1(toBN$1(this).div(toBN$1(other)));
    }
    mul(other) {
        return toBigNumber$1(toBN$1(this).mul(toBN$1(other)));
    }
    mod(other) {
        const value = toBN$1(other);
        if (value.isNeg()) {
            throwFault$2("division-by-zero", "mod");
        }
        return toBigNumber$1(toBN$1(this).umod(value));
    }
    pow(other) {
        const value = toBN$1(other);
        if (value.isNeg()) {
            throwFault$2("negative-power", "pow");
        }
        return toBigNumber$1(toBN$1(this).pow(value));
    }
    and(other) {
        const value = toBN$1(other);
        if (this.isNegative() || value.isNeg()) {
            throwFault$2("unbound-bitwise-result", "and");
        }
        return toBigNumber$1(toBN$1(this).and(value));
    }
    or(other) {
        const value = toBN$1(other);
        if (this.isNegative() || value.isNeg()) {
            throwFault$2("unbound-bitwise-result", "or");
        }
        return toBigNumber$1(toBN$1(this).or(value));
    }
    xor(other) {
        const value = toBN$1(other);
        if (this.isNegative() || value.isNeg()) {
            throwFault$2("unbound-bitwise-result", "xor");
        }
        return toBigNumber$1(toBN$1(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) {
            throwFault$2("negative-width", "mask");
        }
        return toBigNumber$1(toBN$1(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) {
            throwFault$2("negative-width", "shl");
        }
        return toBigNumber$1(toBN$1(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) {
            throwFault$2("negative-width", "shr");
        }
        return toBigNumber$1(toBN$1(this).shrn(value));
    }
    eq(other) {
        return toBN$1(this).eq(toBN$1(other));
    }
    lt(other) {
        return toBN$1(this).lt(toBN$1(other));
    }
    lte(other) {
        return toBN$1(this).lte(toBN$1(other));
    }
    gt(other) {
        return toBN$1(this).gt(toBN$1(other));
    }
    gte(other) {
        return toBN$1(this).gte(toBN$1(other));
    }
    isNegative() {
        return (this._hex[0] === "-");
    }
    isZero() {
        return toBN$1(this).isZero();
    }
    toNumber() {
        try {
            return toBN$1(this).toNumber();
        }
        catch (error) {
            throwFault$2("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        }
        catch (e) { }
        return logger$r.throwError("this platform does not support BigInt", Logger$1.errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!_warnedToStringRadix$1) {
                    _warnedToStringRadix$1 = true;
                    logger$r.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            }
            else if (arguments[0] === 16) {
                logger$r.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", Logger$1.errors.UNEXPECTED_ARGUMENT, {});
            }
            else {
                logger$r.throwError("BigNumber.toString does not accept parameters", Logger$1.errors.UNEXPECTED_ARGUMENT, {});
            }
        }
        return toBN$1(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return { type: "BigNumber", hex: this.toHexString() };
    }
    static from(value) {
        if (value instanceof BigNumber$1) {
            return value;
        }
        if (typeof (value) === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) {
                return new BigNumber$1(_constructorGuard$4, toHex$3(value));
            }
            if (value.match(/^-?[0-9]+$/)) {
                return new BigNumber$1(_constructorGuard$4, toHex$3(new BN$2(value)));
            }
            return logger$r.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof (value) === "number") {
            if (value % 1) {
                throwFault$2("underflow", "BigNumber.from", value);
            }
            if (value >= MAX_SAFE$1 || value <= -MAX_SAFE$1) {
                throwFault$2("overflow", "BigNumber.from", value);
            }
            return BigNumber$1.from(String(value));
        }
        const anyValue = value;
        if (typeof (anyValue) === "bigint") {
            return BigNumber$1.from(anyValue.toString());
        }
        if (isBytes$1(anyValue)) {
            return BigNumber$1.from(hexlify(anyValue));
        }
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof (hex) === "string") {
                    return BigNumber$1.from(hex);
                }
            }
            else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") {
                    hex = anyValue.hex;
                }
                if (typeof (hex) === "string") {
                    if (isHexString$1(hex) || (hex[0] === "-" && isHexString$1(hex.substring(1)))) {
                        return BigNumber$1.from(hex);
                    }
                }
            }
        }
        return logger$r.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function toHex$3(value) {
    // For BN, call on the hex string
    if (typeof (value) !== "string") {
        return toHex$3(value.toString(16));
    }
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") {
            logger$r.throwArgumentError("invalid hex", "value", value);
        }
        // Call toHex on the positive component
        value = toHex$3(value);
        // Do not allow "-0x00"
        if (value === "0x00") {
            return value;
        }
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") {
        value = "0x" + value;
    }
    // Normalize zero
    if (value === "0x") {
        return "0x00";
    }
    // Make the string even length
    if (value.length % 2) {
        value = "0x0" + value.substring(2);
    }
    // Trim to smallest even-length string
    while (value.length > 4 && value.substring(0, 4) === "0x00") {
        value = "0x" + value.substring(4);
    }
    return value;
}
function toBigNumber$1(value) {
    return BigNumber$1.from(toHex$3(value));
}
function toBN$1(value) {
    const hex = BigNumber$1.from(value).toHexString();
    if (hex[0] === "-") {
        return (new BN$2("-" + hex.substring(3), 16));
    }
    return new BN$2(hex.substring(2), 16);
}
function throwFault$2(fault, operation, value) {
    const params = { fault: fault, operation: operation };
    if (value != null) {
        params.value = value;
    }
    return logger$r.throwError(fault, Logger$1.errors.NUMERIC_FAULT, params);
}
// value should have no prefix
function _base36To16$1(value) {
    return (new BN$2(value, 36)).toString(16);
}

const logger$q = new Logger$1(version$o);
const _constructorGuard$3 = {};
const Zero$2 = BigNumber$1.from(0);
const NegativeOne$2 = BigNumber$1.from(-1);
function throwFault$1(message, fault, operation, value) {
    const params = { fault: fault, operation: operation };
    if (value !== undefined) {
        params.value = value;
    }
    return logger$q.throwError(message, Logger$1.errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let zeros = "0";
while (zeros.length < 256) {
    zeros += zeros;
}
// Returns a string "1" followed by decimal "0"s
function getMultiplier(decimals) {
    if (typeof (decimals) !== "number") {
        try {
            decimals = BigNumber$1.from(decimals).toNumber();
        }
        catch (e) { }
    }
    if (typeof (decimals) === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) {
        return ("1" + zeros.substring(0, decimals));
    }
    return logger$q.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function formatFixed(value, decimals) {
    if (decimals == null) {
        decimals = 0;
    }
    const multiplier = getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = BigNumber$1.from(value);
    const negative = value.lt(Zero$2);
    if (negative) {
        value = value.mul(NegativeOne$2);
    }
    let fraction = value.mod(multiplier).toString();
    while (fraction.length < multiplier.length - 1) {
        fraction = "0" + fraction;
    }
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) {
        value = whole;
    }
    else {
        value = whole + "." + fraction;
    }
    if (negative) {
        value = "-" + value;
    }
    return value;
}
function parseFixed(value, decimals) {
    if (decimals == null) {
        decimals = 0;
    }
    const multiplier = getMultiplier(decimals);
    if (typeof (value) !== "string" || !value.match(/^-?[0-9.]+$/)) {
        logger$q.throwArgumentError("invalid decimal value", "value", value);
    }
    // Is it negative?
    const negative = (value.substring(0, 1) === "-");
    if (negative) {
        value = value.substring(1);
    }
    if (value === ".") {
        logger$q.throwArgumentError("missing value", "value", value);
    }
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) {
        logger$q.throwArgumentError("too many decimal points", "value", value);
    }
    let whole = comps[0], fraction = comps[1];
    if (!whole) {
        whole = "0";
    }
    if (!fraction) {
        fraction = "0";
    }
    // Trim trailing zeros
    while (fraction[fraction.length - 1] === "0") {
        fraction = fraction.substring(0, fraction.length - 1);
    }
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) {
        throwFault$1("fractional component exceeds decimals", "underflow", "parseFixed");
    }
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") {
        fraction = "0";
    }
    // Fully pad the string with zeros to get to wei
    while (fraction.length < multiplier.length - 1) {
        fraction += "0";
    }
    const wholeValue = BigNumber$1.from(whole);
    const fractionValue = BigNumber$1.from(fraction);
    let wei = (wholeValue.mul(multiplier)).add(fractionValue);
    if (negative) {
        wei = wei.mul(NegativeOne$2);
    }
    return wei;
}
class FixedFormat {
    constructor(constructorGuard, signed, width, decimals) {
        if (constructorGuard !== _constructorGuard$3) {
            logger$q.throwError("cannot use FixedFormat constructor; use FixedFormat.from", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "new FixedFormat"
            });
        }
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = getMultiplier(decimals);
        Object.freeze(this);
    }
    static from(value) {
        if (value instanceof FixedFormat) {
            return value;
        }
        if (typeof (value) === "number") {
            value = `fixed128x${value}`;
        }
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof (value) === "string") {
            if (value === "fixed") ;
            else if (value === "ufixed") {
                signed = false;
            }
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) {
                    logger$q.throwArgumentError("invalid fixed format", "format", value);
                }
                signed = (match[1] !== "u");
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        }
        else if (value) {
            const check = (key, type, defaultValue) => {
                if (value[key] == null) {
                    return defaultValue;
                }
                if (typeof (value[key]) !== type) {
                    logger$q.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                }
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) {
            logger$q.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        }
        if (decimals > 80) {
            logger$q.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        }
        return new FixedFormat(_constructorGuard$3, signed, width, decimals);
    }
}
class FixedNumber {
    constructor(constructorGuard, hex, value, format) {
        if (constructorGuard !== _constructorGuard$3) {
            logger$q.throwError("cannot use FixedNumber constructor; use FixedNumber.from", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "new FixedFormat"
            });
        }
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    _checkFormat(other) {
        if (this.format.name !== other.format.name) {
            logger$q.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
        }
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = parseFixed(this._value, this.format.decimals);
        const b = parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = parseFixed(this._value, this.format.decimals);
        const b = parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = parseFixed(this._value, this.format.decimals);
        const b = parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = parseFixed(this._value, this.format.decimals);
        const b = parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) {
            comps.push("0");
        }
        let result = FixedNumber.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) {
            result = result.subUnsafe(ONE$1.toFormat(result.format));
        }
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) {
            comps.push("0");
        }
        let result = FixedNumber.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) {
            result = result.addUnsafe(ONE$1.toFormat(result.format));
        }
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) {
            decimals = 0;
        }
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) {
            comps.push("0");
        }
        if (decimals < 0 || decimals > 80 || (decimals % 1)) {
            logger$q.throwArgumentError("invalid decimal count", "decimals", decimals);
        }
        if (comps[1].length <= decimals) {
            return this;
        }
        const factor = FixedNumber.from("1" + zeros.substring(0, decimals), this.format);
        const bump = BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return (this._value === "0.0" || this._value === "0");
    }
    isNegative() {
        return (this._value[0] === "-");
    }
    toString() { return this._value; }
    toHexString(width) {
        if (width == null) {
            return this._hex;
        }
        if (width % 8) {
            logger$q.throwArgumentError("invalid byte width", "width", width);
        }
        const hex = BigNumber$1.from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return hexZeroPad(hex, width / 8);
    }
    toUnsafeFloat() { return parseFloat(this.toString()); }
    toFormat(format) {
        return FixedNumber.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !isBigNumberish(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) {
            decimals = 0;
        }
        if (format == null) {
            format = "fixed";
        }
        return FixedNumber.fromString(formatFixed(value, decimals), FixedFormat.from(format));
    }
    static fromString(value, format) {
        if (format == null) {
            format = "fixed";
        }
        const fixedFormat = FixedFormat.from(format);
        const numeric = parseFixed(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt(Zero$2)) {
            throwFault$1("unsigned value cannot be negative", "overflow", "value", value);
        }
        let hex = null;
        if (fixedFormat.signed) {
            hex = numeric.toTwos(fixedFormat.width).toHexString();
        }
        else {
            hex = numeric.toHexString();
            hex = hexZeroPad(hex, fixedFormat.width / 8);
        }
        const decimal = formatFixed(numeric, fixedFormat.decimals);
        return new FixedNumber(_constructorGuard$3, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) {
            format = "fixed";
        }
        const fixedFormat = FixedFormat.from(format);
        if (arrayify$1(value).length > fixedFormat.width / 8) {
            throw new Error("overflow");
        }
        let numeric = BigNumber$1.from(value);
        if (fixedFormat.signed) {
            numeric = numeric.fromTwos(fixedFormat.width);
        }
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = formatFixed(numeric, fixedFormat.decimals);
        return new FixedNumber(_constructorGuard$3, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof (value) === "string") {
            return FixedNumber.fromString(value, format);
        }
        if (isBytes$1(value)) {
            return FixedNumber.fromBytes(value, format);
        }
        try {
            return FixedNumber.fromValue(value, 0, format);
        }
        catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== Logger$1.errors.INVALID_ARGUMENT) {
                throw error;
            }
        }
        return logger$q.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
}
const ONE$1 = FixedNumber.from(1);
const BUMP = FixedNumber.from("0.5");

const version$n = "properties/5.6.0";

var __awaiter$9 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const logger$p = new Logger$1(version$n);
function defineReadOnly(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false,
    });
}
// Crawl up the constructor chain to find a static method
function getStatic(ctor, key) {
    for (let i = 0; i < 32; i++) {
        if (ctor[key]) {
            return ctor[key];
        }
        if (!ctor.prototype || typeof (ctor.prototype) !== "object") {
            break;
        }
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function resolveProperties(object) {
    return __awaiter$9(this, void 0, void 0, function* () {
        const promises = Object.keys(object).map((key) => {
            const value = object[key];
            return Promise.resolve(value).then((v) => ({ key: key, value: v }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result) => {
            accum[(result.key)] = result.value;
            return accum;
        }, {});
    });
}
function checkProperties(object, properties) {
    if (!object || typeof (object) !== "object") {
        logger$p.throwArgumentError("invalid object", "object", object);
    }
    Object.keys(object).forEach((key) => {
        if (!properties[key]) {
            logger$p.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
        }
    });
}
function shallowCopy(object) {
    const result = {};
    for (const key in object) {
        result[key] = object[key];
    }
    return result;
}
const opaque = { bigint: true, boolean: true, "function": true, number: true, string: true };
function _isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || opaque[typeof (object)]) {
        return true;
    }
    if (Array.isArray(object) || typeof (object) === "object") {
        if (!Object.isFrozen(object)) {
            return false;
        }
        const keys = Object.keys(object);
        for (let i = 0; i < keys.length; i++) {
            let value = null;
            try {
                value = object[keys[i]];
            }
            catch (error) {
                // If accessing a value triggers an error, it is a getter
                // designed to do so (e.g. Result) and is therefore "frozen"
                continue;
            }
            if (!_isFrozen(value)) {
                return false;
            }
        }
        return true;
    }
    return logger$p.throwArgumentError(`Cannot deepCopy ${typeof (object)}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function _deepCopy(object) {
    if (_isFrozen(object)) {
        return object;
    }
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) {
        return Object.freeze(object.map((item) => deepCopy(item)));
    }
    if (typeof (object) === "object") {
        const result = {};
        for (const key in object) {
            const value = object[key];
            if (value === undefined) {
                continue;
            }
            defineReadOnly(result, key, deepCopy(value));
        }
        return result;
    }
    return logger$p.throwArgumentError(`Cannot deepCopy ${typeof (object)}`, "object", object);
}
function deepCopy(object) {
    return _deepCopy(object);
}
class Description {
    constructor(info) {
        for (const key in info) {
            this[key] = deepCopy(info[key]);
        }
    }
}

const version$m = "abstract-provider/5.6.0";

var __awaiter$8 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const logger$o = new Logger$1(version$m);
//export type CallTransactionable = {
//    call(transaction: TransactionRequest): Promise<TransactionResponse>;
//};
class ForkEvent extends Description {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
///////////////////////////////
// Exported Abstracts
class Provider {
    constructor() {
        logger$o.checkAbstract(new.target, Provider);
        defineReadOnly(this, "_isProvider", true);
    }
    getFeeData() {
        return __awaiter$8(this, void 0, void 0, function* () {
            const { block, gasPrice } = yield resolveProperties({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error) => {
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                maxPriorityFeePerGas = BigNumber$1.from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return { maxFeePerGas, maxPriorityFeePerGas, gasPrice };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
}

const version$l = "networks/5.6.3";

const logger$n = new Logger$1(version$l);
function isRenetworkable(value) {
    return (value && typeof (value.renetwork) === "function");
}
function ethDefaultProvider(network) {
    const func = function (providers, options) {
        if (options == null) {
            options = {};
        }
        const providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") {
            try {
                providerList.push(new providers.InfuraProvider(network, options.infura));
            }
            catch (error) { }
        }
        if (providers.EtherscanProvider && options.etherscan !== "-") {
            try {
                providerList.push(new providers.EtherscanProvider(network, options.etherscan));
            }
            catch (error) { }
        }
        if (providers.AlchemyProvider && options.alchemy !== "-") {
            try {
                providerList.push(new providers.AlchemyProvider(network, options.alchemy));
            }
            catch (error) { }
        }
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = ["goerli", "ropsten", "rinkeby"];
            try {
                const provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) {
                    providerList.push(provider);
                }
            }
            catch (error) { }
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") {
            try {
                providerList.push(new providers.CloudflareProvider(network));
            }
            catch (error) { }
        }
        if (providers.AnkrProvider && options.ankr !== "-") {
            try {
                providerList.push(new providers.AnkrProvider(network, options.ankr));
            }
            catch (error) { }
        }
        if (providerList.length === 0) {
            return null;
        }
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) {
                quorum = options.quorum;
            }
            else if (network === "homestead") {
                quorum = 2;
            }
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function (network) {
        return ethDefaultProvider(network);
    };
    return func;
}
function etcDefaultProvider(url, network) {
    const func = function (providers, options) {
        if (providers.JsonRpcProvider) {
            return new providers.JsonRpcProvider(url, network);
        }
        return null;
    };
    func.renetwork = function (network) {
        return etcDefaultProvider(url, network);
    };
    return func;
}
const homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: ethDefaultProvider("homestead")
};
const ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: ethDefaultProvider("ropsten")
};
const classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const networks = {
    unspecified: { chainId: 0, name: "unspecified" },
    homestead: homestead,
    mainnet: homestead,
    morden: { chainId: 2, name: "morden" },
    ropsten: ropsten,
    testnet: ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: ethDefaultProvider("goerli")
    },
    kintsugi: { chainId: 1337702, name: "kintsugi" },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: etcDefaultProvider("https:/\/www.ethercluster.com/etc", "classic")
    },
    classicMorden: { chainId: 62, name: "classicMorden" },
    classicMordor: classicMordor,
    classicTestnet: classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: etcDefaultProvider("https:/\/www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: { chainId: 100, name: "xdai" },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: ethDefaultProvider("matic")
    },
    maticmum: { chainId: 80001, name: "maticmum" },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: ethDefaultProvider("optimism")
    },
    "optimism-kovan": { chainId: 69, name: "optimism-kovan" },
    "optimism-goerli": { chainId: 420, name: "optimism-goerli" },
    arbitrum: { chainId: 42161, name: "arbitrum" },
    "arbitrum-rinkeby": { chainId: 421611, name: "arbitrum-rinkeby" },
    bnb: { chainId: 56, name: "bnb" },
    bnbt: { chainId: 97, name: "bnbt" },
};
/**
 *  getNetwork
 *
 *  Converts a named common networks or chain ID (network ID) to a Network
 *  and verifies a network is a valid Network..
 */
function getNetwork(network) {
    // No network (null)
    if (network == null) {
        return null;
    }
    if (typeof (network) === "number") {
        for (const name in networks) {
            const standard = networks[name];
            if (standard.chainId === network) {
                return {
                    name: standard.name,
                    chainId: standard.chainId,
                    ensAddress: (standard.ensAddress || null),
                    _defaultProvider: (standard._defaultProvider || null)
                };
            }
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof (network) === "string") {
        const standard = networks[network];
        if (standard == null) {
            return null;
        }
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: (standard._defaultProvider || null)
        };
    }
    const standard = networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof (network.chainId) !== "number") {
            logger$n.throwArgumentError("invalid network chainId", "network", network);
        }
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) {
        logger$n.throwArgumentError("network chainId mismatch", "network", network);
    }
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if (isRenetworkable(standard._defaultProvider)) {
            defaultProvider = standard._defaultProvider.renetwork(network);
        }
        else {
            defaultProvider = standard._defaultProvider;
        }
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: (network.ensAddress || standard.ensAddress || null),
        _defaultProvider: defaultProvider
    };
}

/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */
class BaseX {
    constructor(alphabet) {
        defineReadOnly(this, "alphabet", alphabet);
        defineReadOnly(this, "base", alphabet.length);
        defineReadOnly(this, "_alphabetMap", {});
        defineReadOnly(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for (let i = 0; i < alphabet.length; i++) {
            this._alphabetMap[alphabet.charAt(i)] = i;
        }
    }
    encode(value) {
        let source = arrayify$1(value);
        if (source.length === 0) {
            return "";
        }
        let digits = [0];
        for (let i = 0; i < source.length; ++i) {
            let carry = source[i];
            for (let j = 0; j < digits.length; ++j) {
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = (carry / this.base) | 0;
            }
            while (carry > 0) {
                digits.push(carry % this.base);
                carry = (carry / this.base) | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for (let k = 0; source[k] === 0 && k < source.length - 1; ++k) {
            string += this._leader;
        }
        // convert digits to a string
        for (let q = digits.length - 1; q >= 0; --q) {
            string += this.alphabet[digits[q]];
        }
        return string;
    }
    decode(value) {
        if (typeof (value) !== "string") {
            throw new TypeError("Expected String");
        }
        let bytes = [];
        if (value.length === 0) {
            return new Uint8Array(bytes);
        }
        bytes.push(0);
        for (let i = 0; i < value.length; i++) {
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) {
                throw new Error("Non-base" + this.base + " character");
            }
            let carry = byte;
            for (let j = 0; j < bytes.length; ++j) {
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while (carry > 0) {
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for (let k = 0; value[k] === this._leader && k < value.length - 1; ++k) {
            bytes.push(0);
        }
        return arrayify$1(new Uint8Array(bytes.reverse()));
    }
}
new BaseX("abcdefghijklmnopqrstuvwxyz234567");
const Base58 = new BaseX("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
//console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
//console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))

const AddressZero = "0x0000000000000000000000000000000000000000";

const NegativeOne$1 = ( /*#__PURE__*/BigNumber$1.from(-1));
const Zero$1 = ( /*#__PURE__*/BigNumber$1.from(0));
const One$1 = ( /*#__PURE__*/BigNumber$1.from(1));
const MaxUint256$1 = ( /*#__PURE__*/BigNumber$1.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"));

const HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000";

var sha3$1 = {exports: {}};

/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */

(function (module) {
/*jslint bitwise: true */
(function () {

  var INPUT_ERROR = 'input is invalid type';
  var FINALIZE_ERROR = 'finalize already called';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_SHA3_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = commonjsGlobal;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && 'object' === 'object' && module.exports;
  var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var SHAKE_PADDING = [31, 7936, 2031616, 520093696];
  var CSHAKE_PADDING = [4, 1024, 262144, 67108864];
  var KECCAK_PADDING = [1, 256, 65536, 16777216];
  var PADDING = [6, 1536, 393216, 100663296];
  var SHIFT = [0, 8, 16, 24];
  var RC = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649,
    0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0,
    2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771,
    2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648,
    2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];
  var BITS = [224, 256, 384, 512];
  var SHAKE_BITS = [128, 256];
  var OUTPUT_TYPES = ['hex', 'buffer', 'arrayBuffer', 'array', 'digest'];
  var CSHAKE_BYTEPAD = {
    '128': 168,
    '256': 136
  };

  if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
  }

  if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
  }

  var createOutputMethod = function (bits, padding, outputType) {
    return function (message) {
      return new Keccak(bits, padding, bits).update(message)[outputType]();
    };
  };

  var createShakeOutputMethod = function (bits, padding, outputType) {
    return function (message, outputBits) {
      return new Keccak(bits, padding, outputBits).update(message)[outputType]();
    };
  };

  var createCshakeOutputMethod = function (bits, padding, outputType) {
    return function (message, outputBits, n, s) {
      return methods['cshake' + bits].update(message, outputBits, n, s)[outputType]();
    };
  };

  var createKmacOutputMethod = function (bits, padding, outputType) {
    return function (key, message, outputBits, s) {
      return methods['kmac' + bits].update(key, message, outputBits, s)[outputType]();
    };
  };

  var createOutputMethods = function (method, createMethod, bits, padding) {
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createMethod(bits, padding, type);
    }
    return method;
  };

  var createMethod = function (bits, padding) {
    var method = createOutputMethod(bits, padding, 'hex');
    method.create = function () {
      return new Keccak(bits, padding, bits);
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    return createOutputMethods(method, createOutputMethod, bits, padding);
  };

  var createShakeMethod = function (bits, padding) {
    var method = createShakeOutputMethod(bits, padding, 'hex');
    method.create = function (outputBits) {
      return new Keccak(bits, padding, outputBits);
    };
    method.update = function (message, outputBits) {
      return method.create(outputBits).update(message);
    };
    return createOutputMethods(method, createShakeOutputMethod, bits, padding);
  };

  var createCshakeMethod = function (bits, padding) {
    var w = CSHAKE_BYTEPAD[bits];
    var method = createCshakeOutputMethod(bits, padding, 'hex');
    method.create = function (outputBits, n, s) {
      if (!n && !s) {
        return methods['shake' + bits].create(outputBits);
      } else {
        return new Keccak(bits, padding, outputBits).bytepad([n, s], w);
      }
    };
    method.update = function (message, outputBits, n, s) {
      return method.create(outputBits, n, s).update(message);
    };
    return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
  };

  var createKmacMethod = function (bits, padding) {
    var w = CSHAKE_BYTEPAD[bits];
    var method = createKmacOutputMethod(bits, padding, 'hex');
    method.create = function (key, outputBits, s) {
      return new Kmac(bits, padding, outputBits).bytepad(['KMAC', s], w).bytepad([key], w);
    };
    method.update = function (key, message, outputBits, s) {
      return method.create(key, outputBits, s).update(message);
    };
    return createOutputMethods(method, createKmacOutputMethod, bits, padding);
  };

  var algorithms = [
    { name: 'keccak', padding: KECCAK_PADDING, bits: BITS, createMethod: createMethod },
    { name: 'sha3', padding: PADDING, bits: BITS, createMethod: createMethod },
    { name: 'shake', padding: SHAKE_PADDING, bits: SHAKE_BITS, createMethod: createShakeMethod },
    { name: 'cshake', padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createCshakeMethod },
    { name: 'kmac', padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createKmacMethod }
  ];

  var methods = {}, methodNames = [];

  for (var i = 0; i < algorithms.length; ++i) {
    var algorithm = algorithms[i];
    var bits = algorithm.bits;
    for (var j = 0; j < bits.length; ++j) {
      var methodName = algorithm.name + '_' + bits[j];
      methodNames.push(methodName);
      methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
      if (algorithm.name !== 'sha3') {
        var newMethodName = algorithm.name + bits[j];
        methodNames.push(newMethodName);
        methods[newMethodName] = methods[methodName];
      }
    }
  }

  function Keccak(bits, padding, outputBits) {
    this.blocks = [];
    this.s = [];
    this.padding = padding;
    this.outputBits = outputBits;
    this.reset = true;
    this.finalized = false;
    this.block = 0;
    this.start = 0;
    this.blockCount = (1600 - (bits << 1)) >> 5;
    this.byteCount = this.blockCount << 2;
    this.outputBlocks = outputBits >> 5;
    this.extraBytes = (outputBits & 31) >> 3;

    for (var i = 0; i < 50; ++i) {
      this.s[i] = 0;
    }
  }

  Keccak.prototype.update = function (message) {
    if (this.finalized) {
      throw new Error(FINALIZE_ERROR);
    }
    var notString, type = typeof message;
    if (type !== 'string') {
      if (type === 'object') {
        if (message === null) {
          throw new Error(INPUT_ERROR);
        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        } else if (!Array.isArray(message)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
            throw new Error(INPUT_ERROR);
          }
        }
      } else {
        throw new Error(INPUT_ERROR);
      }
      notString = true;
    }
    var blocks = this.blocks, byteCount = this.byteCount, length = message.length,
      blockCount = this.blockCount, index = 0, s = this.s, i, code;

    while (index < length) {
      if (this.reset) {
        this.reset = false;
        blocks[0] = this.block;
        for (i = 1; i < blockCount + 1; ++i) {
          blocks[i] = 0;
        }
      }
      if (notString) {
        for (i = this.start; index < length && i < byteCount; ++index) {
          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
        }
      } else {
        for (i = this.start; index < length && i < byteCount; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
            blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          }
        }
      }
      this.lastByteIndex = i;
      if (i >= byteCount) {
        this.start = i - byteCount;
        this.block = blocks[blockCount];
        for (i = 0; i < blockCount; ++i) {
          s[i] ^= blocks[i];
        }
        f(s);
        this.reset = true;
      } else {
        this.start = i;
      }
    }
    return this;
  };

  Keccak.prototype.encode = function (x, right) {
    var o = x & 255, n = 1;
    var bytes = [o];
    x = x >> 8;
    o = x & 255;
    while (o > 0) {
      bytes.unshift(o);
      x = x >> 8;
      o = x & 255;
      ++n;
    }
    if (right) {
      bytes.push(n);
    } else {
      bytes.unshift(n);
    }
    this.update(bytes);
    return bytes.length;
  };

  Keccak.prototype.encodeString = function (str) {
    var notString, type = typeof str;
    if (type !== 'string') {
      if (type === 'object') {
        if (str === null) {
          throw new Error(INPUT_ERROR);
        } else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) {
          str = new Uint8Array(str);
        } else if (!Array.isArray(str)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) {
            throw new Error(INPUT_ERROR);
          }
        }
      } else {
        throw new Error(INPUT_ERROR);
      }
      notString = true;
    }
    var bytes = 0, length = str.length;
    if (notString) {
      bytes = length;
    } else {
      for (var i = 0; i < str.length; ++i) {
        var code = str.charCodeAt(i);
        if (code < 0x80) {
          bytes += 1;
        } else if (code < 0x800) {
          bytes += 2;
        } else if (code < 0xd800 || code >= 0xe000) {
          bytes += 3;
        } else {
          code = 0x10000 + (((code & 0x3ff) << 10) | (str.charCodeAt(++i) & 0x3ff));
          bytes += 4;
        }
      }
    }
    bytes += this.encode(bytes * 8);
    this.update(str);
    return bytes;
  };

  Keccak.prototype.bytepad = function (strs, w) {
    var bytes = this.encode(w);
    for (var i = 0; i < strs.length; ++i) {
      bytes += this.encodeString(strs[i]);
    }
    var paddingBytes = w - bytes % w;
    var zeros = [];
    zeros.length = paddingBytes;
    this.update(zeros);
    return this;
  };

  Keccak.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
    blocks[i >> 2] |= this.padding[i & 3];
    if (this.lastByteIndex === this.byteCount) {
      blocks[0] = blocks[blockCount];
      for (i = 1; i < blockCount + 1; ++i) {
        blocks[i] = 0;
      }
    }
    blocks[blockCount - 1] |= 0x80000000;
    for (i = 0; i < blockCount; ++i) {
      s[i] ^= blocks[i];
    }
    f(s);
  };

  Keccak.prototype.toString = Keccak.prototype.hex = function () {
    this.finalize();

    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
      extraBytes = this.extraBytes, i = 0, j = 0;
    var hex = '', block;
    while (j < outputBlocks) {
      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
        block = s[i];
        hex += HEX_CHARS[(block >> 4) & 0x0F] + HEX_CHARS[block & 0x0F] +
          HEX_CHARS[(block >> 12) & 0x0F] + HEX_CHARS[(block >> 8) & 0x0F] +
          HEX_CHARS[(block >> 20) & 0x0F] + HEX_CHARS[(block >> 16) & 0x0F] +
          HEX_CHARS[(block >> 28) & 0x0F] + HEX_CHARS[(block >> 24) & 0x0F];
      }
      if (j % blockCount === 0) {
        f(s);
        i = 0;
      }
    }
    if (extraBytes) {
      block = s[i];
      hex += HEX_CHARS[(block >> 4) & 0x0F] + HEX_CHARS[block & 0x0F];
      if (extraBytes > 1) {
        hex += HEX_CHARS[(block >> 12) & 0x0F] + HEX_CHARS[(block >> 8) & 0x0F];
      }
      if (extraBytes > 2) {
        hex += HEX_CHARS[(block >> 20) & 0x0F] + HEX_CHARS[(block >> 16) & 0x0F];
      }
    }
    return hex;
  };

  Keccak.prototype.arrayBuffer = function () {
    this.finalize();

    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
      extraBytes = this.extraBytes, i = 0, j = 0;
    var bytes = this.outputBits >> 3;
    var buffer;
    if (extraBytes) {
      buffer = new ArrayBuffer((outputBlocks + 1) << 2);
    } else {
      buffer = new ArrayBuffer(bytes);
    }
    var array = new Uint32Array(buffer);
    while (j < outputBlocks) {
      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
        array[j] = s[i];
      }
      if (j % blockCount === 0) {
        f(s);
      }
    }
    if (extraBytes) {
      array[i] = s[i];
      buffer = buffer.slice(0, bytes);
    }
    return buffer;
  };

  Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;

  Keccak.prototype.digest = Keccak.prototype.array = function () {
    this.finalize();

    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
      extraBytes = this.extraBytes, i = 0, j = 0;
    var array = [], offset, block;
    while (j < outputBlocks) {
      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
        offset = j << 2;
        block = s[i];
        array[offset] = block & 0xFF;
        array[offset + 1] = (block >> 8) & 0xFF;
        array[offset + 2] = (block >> 16) & 0xFF;
        array[offset + 3] = (block >> 24) & 0xFF;
      }
      if (j % blockCount === 0) {
        f(s);
      }
    }
    if (extraBytes) {
      offset = j << 2;
      block = s[i];
      array[offset] = block & 0xFF;
      if (extraBytes > 1) {
        array[offset + 1] = (block >> 8) & 0xFF;
      }
      if (extraBytes > 2) {
        array[offset + 2] = (block >> 16) & 0xFF;
      }
    }
    return array;
  };

  function Kmac(bits, padding, outputBits) {
    Keccak.call(this, bits, padding, outputBits);
  }

  Kmac.prototype = new Keccak();

  Kmac.prototype.finalize = function () {
    this.encode(this.outputBits, true);
    return Keccak.prototype.finalize.call(this);
  };

  var f = function (s) {
    var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9,
      b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17,
      b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33,
      b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
    for (n = 0; n < 48; n += 2) {
      c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
      c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
      c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
      c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
      c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
      c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
      c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
      c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
      c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
      c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];

      h = c8 ^ ((c2 << 1) | (c3 >>> 31));
      l = c9 ^ ((c3 << 1) | (c2 >>> 31));
      s[0] ^= h;
      s[1] ^= l;
      s[10] ^= h;
      s[11] ^= l;
      s[20] ^= h;
      s[21] ^= l;
      s[30] ^= h;
      s[31] ^= l;
      s[40] ^= h;
      s[41] ^= l;
      h = c0 ^ ((c4 << 1) | (c5 >>> 31));
      l = c1 ^ ((c5 << 1) | (c4 >>> 31));
      s[2] ^= h;
      s[3] ^= l;
      s[12] ^= h;
      s[13] ^= l;
      s[22] ^= h;
      s[23] ^= l;
      s[32] ^= h;
      s[33] ^= l;
      s[42] ^= h;
      s[43] ^= l;
      h = c2 ^ ((c6 << 1) | (c7 >>> 31));
      l = c3 ^ ((c7 << 1) | (c6 >>> 31));
      s[4] ^= h;
      s[5] ^= l;
      s[14] ^= h;
      s[15] ^= l;
      s[24] ^= h;
      s[25] ^= l;
      s[34] ^= h;
      s[35] ^= l;
      s[44] ^= h;
      s[45] ^= l;
      h = c4 ^ ((c8 << 1) | (c9 >>> 31));
      l = c5 ^ ((c9 << 1) | (c8 >>> 31));
      s[6] ^= h;
      s[7] ^= l;
      s[16] ^= h;
      s[17] ^= l;
      s[26] ^= h;
      s[27] ^= l;
      s[36] ^= h;
      s[37] ^= l;
      s[46] ^= h;
      s[47] ^= l;
      h = c6 ^ ((c0 << 1) | (c1 >>> 31));
      l = c7 ^ ((c1 << 1) | (c0 >>> 31));
      s[8] ^= h;
      s[9] ^= l;
      s[18] ^= h;
      s[19] ^= l;
      s[28] ^= h;
      s[29] ^= l;
      s[38] ^= h;
      s[39] ^= l;
      s[48] ^= h;
      s[49] ^= l;

      b0 = s[0];
      b1 = s[1];
      b32 = (s[11] << 4) | (s[10] >>> 28);
      b33 = (s[10] << 4) | (s[11] >>> 28);
      b14 = (s[20] << 3) | (s[21] >>> 29);
      b15 = (s[21] << 3) | (s[20] >>> 29);
      b46 = (s[31] << 9) | (s[30] >>> 23);
      b47 = (s[30] << 9) | (s[31] >>> 23);
      b28 = (s[40] << 18) | (s[41] >>> 14);
      b29 = (s[41] << 18) | (s[40] >>> 14);
      b20 = (s[2] << 1) | (s[3] >>> 31);
      b21 = (s[3] << 1) | (s[2] >>> 31);
      b2 = (s[13] << 12) | (s[12] >>> 20);
      b3 = (s[12] << 12) | (s[13] >>> 20);
      b34 = (s[22] << 10) | (s[23] >>> 22);
      b35 = (s[23] << 10) | (s[22] >>> 22);
      b16 = (s[33] << 13) | (s[32] >>> 19);
      b17 = (s[32] << 13) | (s[33] >>> 19);
      b48 = (s[42] << 2) | (s[43] >>> 30);
      b49 = (s[43] << 2) | (s[42] >>> 30);
      b40 = (s[5] << 30) | (s[4] >>> 2);
      b41 = (s[4] << 30) | (s[5] >>> 2);
      b22 = (s[14] << 6) | (s[15] >>> 26);
      b23 = (s[15] << 6) | (s[14] >>> 26);
      b4 = (s[25] << 11) | (s[24] >>> 21);
      b5 = (s[24] << 11) | (s[25] >>> 21);
      b36 = (s[34] << 15) | (s[35] >>> 17);
      b37 = (s[35] << 15) | (s[34] >>> 17);
      b18 = (s[45] << 29) | (s[44] >>> 3);
      b19 = (s[44] << 29) | (s[45] >>> 3);
      b10 = (s[6] << 28) | (s[7] >>> 4);
      b11 = (s[7] << 28) | (s[6] >>> 4);
      b42 = (s[17] << 23) | (s[16] >>> 9);
      b43 = (s[16] << 23) | (s[17] >>> 9);
      b24 = (s[26] << 25) | (s[27] >>> 7);
      b25 = (s[27] << 25) | (s[26] >>> 7);
      b6 = (s[36] << 21) | (s[37] >>> 11);
      b7 = (s[37] << 21) | (s[36] >>> 11);
      b38 = (s[47] << 24) | (s[46] >>> 8);
      b39 = (s[46] << 24) | (s[47] >>> 8);
      b30 = (s[8] << 27) | (s[9] >>> 5);
      b31 = (s[9] << 27) | (s[8] >>> 5);
      b12 = (s[18] << 20) | (s[19] >>> 12);
      b13 = (s[19] << 20) | (s[18] >>> 12);
      b44 = (s[29] << 7) | (s[28] >>> 25);
      b45 = (s[28] << 7) | (s[29] >>> 25);
      b26 = (s[38] << 8) | (s[39] >>> 24);
      b27 = (s[39] << 8) | (s[38] >>> 24);
      b8 = (s[48] << 14) | (s[49] >>> 18);
      b9 = (s[49] << 14) | (s[48] >>> 18);

      s[0] = b0 ^ (~b2 & b4);
      s[1] = b1 ^ (~b3 & b5);
      s[10] = b10 ^ (~b12 & b14);
      s[11] = b11 ^ (~b13 & b15);
      s[20] = b20 ^ (~b22 & b24);
      s[21] = b21 ^ (~b23 & b25);
      s[30] = b30 ^ (~b32 & b34);
      s[31] = b31 ^ (~b33 & b35);
      s[40] = b40 ^ (~b42 & b44);
      s[41] = b41 ^ (~b43 & b45);
      s[2] = b2 ^ (~b4 & b6);
      s[3] = b3 ^ (~b5 & b7);
      s[12] = b12 ^ (~b14 & b16);
      s[13] = b13 ^ (~b15 & b17);
      s[22] = b22 ^ (~b24 & b26);
      s[23] = b23 ^ (~b25 & b27);
      s[32] = b32 ^ (~b34 & b36);
      s[33] = b33 ^ (~b35 & b37);
      s[42] = b42 ^ (~b44 & b46);
      s[43] = b43 ^ (~b45 & b47);
      s[4] = b4 ^ (~b6 & b8);
      s[5] = b5 ^ (~b7 & b9);
      s[14] = b14 ^ (~b16 & b18);
      s[15] = b15 ^ (~b17 & b19);
      s[24] = b24 ^ (~b26 & b28);
      s[25] = b25 ^ (~b27 & b29);
      s[34] = b34 ^ (~b36 & b38);
      s[35] = b35 ^ (~b37 & b39);
      s[44] = b44 ^ (~b46 & b48);
      s[45] = b45 ^ (~b47 & b49);
      s[6] = b6 ^ (~b8 & b0);
      s[7] = b7 ^ (~b9 & b1);
      s[16] = b16 ^ (~b18 & b10);
      s[17] = b17 ^ (~b19 & b11);
      s[26] = b26 ^ (~b28 & b20);
      s[27] = b27 ^ (~b29 & b21);
      s[36] = b36 ^ (~b38 & b30);
      s[37] = b37 ^ (~b39 & b31);
      s[46] = b46 ^ (~b48 & b40);
      s[47] = b47 ^ (~b49 & b41);
      s[8] = b8 ^ (~b0 & b2);
      s[9] = b9 ^ (~b1 & b3);
      s[18] = b18 ^ (~b10 & b12);
      s[19] = b19 ^ (~b11 & b13);
      s[28] = b28 ^ (~b20 & b22);
      s[29] = b29 ^ (~b21 & b23);
      s[38] = b38 ^ (~b30 & b32);
      s[39] = b39 ^ (~b31 & b33);
      s[48] = b48 ^ (~b40 & b42);
      s[49] = b49 ^ (~b41 & b43);

      s[0] ^= RC[n];
      s[1] ^= RC[n + 1];
    }
  };

  if (COMMON_JS) {
    module.exports = methods;
  } else {
    for (i = 0; i < methodNames.length; ++i) {
      root[methodNames[i]] = methods[methodNames[i]];
    }
  }
})();
}(sha3$1));

var sha3 = sha3$1.exports;

function keccak256$1(data) {
    return '0x' + sha3.keccak_256(arrayify$1(data));
}

const version$k = "strings/5.6.0";

const logger$m = new Logger$1(version$k);
///////////////////////////////
var UnicodeNormalizationForm;
(function (UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})(UnicodeNormalizationForm || (UnicodeNormalizationForm = {}));
var Utf8ErrorReason;
(function (Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})(Utf8ErrorReason || (Utf8ErrorReason = {}));
function errorFunc(reason, offset, bytes, output, badCodepoint) {
    return logger$m.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === Utf8ErrorReason.BAD_PREFIX || reason === Utf8ErrorReason.UNEXPECTED_CONTINUE) {
        let i = 0;
        for (let o = offset + 1; o < bytes.length; o++) {
            if (bytes[o] >> 6 !== 0x02) {
                break;
            }
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === Utf8ErrorReason.OVERRUN) {
        return bytes.length - offset - 1;
    }
    // Nothing to skip
    return 0;
}
function replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === Utf8ErrorReason.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return ignoreFunc(reason, offset, bytes);
}
// Common error handing strategies
const Utf8ErrorFuncs = Object.freeze({
    error: errorFunc,
    ignore: ignoreFunc,
    replace: replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function getUtf8CodePoints(bytes, onError) {
    if (onError == null) {
        onError = Utf8ErrorFuncs.error;
    }
    bytes = arrayify$1(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while (i < bytes.length) {
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
            // 1110 xxxx 10xx xxxx 10xx xxxx
        }
        else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
            // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        }
        else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        }
        else {
            if ((c & 0xc0) === 0x80) {
                i += onError(Utf8ErrorReason.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            }
            else {
                i += onError(Utf8ErrorReason.BAD_PREFIX, i - 1, bytes, result);
            }
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError(Utf8ErrorReason.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & ((1 << (8 - extraLength - 1)) - 1);
        for (let j = 0; j < extraLength; j++) {
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError(Utf8ErrorReason.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = (res << 6) | (nextChar & 0x3f);
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) {
            continue;
        }
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError(Utf8ErrorReason.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError(Utf8ErrorReason.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError(Utf8ErrorReason.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
// http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
function toUtf8Bytes(str, form = UnicodeNormalizationForm.current) {
    if (form != UnicodeNormalizationForm.current) {
        logger$m.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        if (c < 0x80) {
            result.push(c);
        }
        else if (c < 0x800) {
            result.push((c >> 6) | 0xc0);
            result.push((c & 0x3f) | 0x80);
        }
        else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) {
                throw new Error("invalid utf-8 string");
            }
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push((pair >> 18) | 0xf0);
            result.push(((pair >> 12) & 0x3f) | 0x80);
            result.push(((pair >> 6) & 0x3f) | 0x80);
            result.push((pair & 0x3f) | 0x80);
        }
        else {
            result.push((c >> 12) | 0xe0);
            result.push(((c >> 6) & 0x3f) | 0x80);
            result.push((c & 0x3f) | 0x80);
        }
    }
    return arrayify$1(result);
}
function _toUtf8String(codePoints) {
    return codePoints.map((codePoint) => {
        if (codePoint <= 0xffff) {
            return String.fromCharCode(codePoint);
        }
        codePoint -= 0x10000;
        return String.fromCharCode((((codePoint >> 10) & 0x3ff) + 0xd800), ((codePoint & 0x3ff) + 0xdc00));
    }).join("");
}
function toUtf8String(bytes, onError) {
    return _toUtf8String(getUtf8CodePoints(bytes, onError));
}
function toUtf8CodePoints(str, form = UnicodeNormalizationForm.current) {
    return getUtf8CodePoints(toUtf8Bytes(str, form));
}

function parseBytes32String(bytes) {
    const data = arrayify$1(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) {
        throw new Error("invalid bytes32 - not 32 bytes long");
    }
    if (data[31] !== 0) {
        throw new Error("invalid bytes32 string - no null terminator");
    }
    // Find the null termination
    let length = 31;
    while (data[length - 1] === 0) {
        length--;
    }
    // Determine the string value
    return toUtf8String(data.slice(0, length));
}

function bytes2(data) {
    if ((data.length % 4) !== 0) {
        throw new Error("bad data");
    }
    let result = [];
    for (let i = 0; i < data.length; i += 4) {
        result.push(parseInt(data.substring(i, i + 4), 16));
    }
    return result;
}
function createTable(data, func) {
    if (!func) {
        func = function (value) { return [parseInt(value, 16)]; };
    }
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair) => {
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v) => {
        let comps = v.split("-");
        if (comps.length === 1) {
            comps[1] = "0";
        }
        else if (comps[1] === "") {
            comps[1] = "1";
        }
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return { l: lo, h: hi };
    });
}
function matchMap(value, ranges) {
    let lo = 0;
    for (let i = 0; i < ranges.length; i++) {
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && ((value - lo) % (range.d || 1)) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) {
                continue;
            }
            return range;
        }
    }
    return null;
}
const Table_A_1_ranges = createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v) => parseInt(v, 16));
const Table_B_2_ranges = [
    { h: 25, s: 32, l: 65 },
    { h: 30, s: 32, e: [23], l: 127 },
    { h: 54, s: 1, e: [48], l: 64, d: 2 },
    { h: 14, s: 1, l: 57, d: 2 },
    { h: 44, s: 1, l: 17, d: 2 },
    { h: 10, s: 1, e: [2, 6, 8], l: 61, d: 2 },
    { h: 16, s: 1, l: 68, d: 2 },
    { h: 84, s: 1, e: [18, 24, 66], l: 19, d: 2 },
    { h: 26, s: 32, e: [17], l: 435 },
    { h: 22, s: 1, l: 71, d: 2 },
    { h: 15, s: 80, l: 40 },
    { h: 31, s: 32, l: 16 },
    { h: 32, s: 1, l: 80, d: 2 },
    { h: 52, s: 1, l: 42, d: 2 },
    { h: 12, s: 1, l: 55, d: 2 },
    { h: 40, s: 1, e: [38], l: 15, d: 2 },
    { h: 14, s: 1, l: 48, d: 2 },
    { h: 37, s: 48, l: 49 },
    { h: 148, s: 1, l: 6351, d: 2 },
    { h: 88, s: 1, l: 160, d: 2 },
    { h: 15, s: 16, l: 704 },
    { h: 25, s: 26, l: 854 },
    { h: 25, s: 32, l: 55915 },
    { h: 37, s: 40, l: 1247 },
    { h: 25, s: -119711, l: 53248 },
    { h: 25, s: -119763, l: 52 },
    { h: 25, s: -119815, l: 52 },
    { h: 25, s: -119867, e: [1, 4, 5, 7, 8, 11, 12, 17], l: 52 },
    { h: 25, s: -119919, l: 52 },
    { h: 24, s: -119971, e: [2, 7, 8, 17], l: 52 },
    { h: 24, s: -120023, e: [2, 7, 13, 15, 16, 17], l: 52 },
    { h: 25, s: -120075, l: 52 },
    { h: 25, s: -120127, l: 52 },
    { h: 25, s: -120179, l: 52 },
    { h: 25, s: -120231, l: 52 },
    { h: 25, s: -120283, l: 52 },
    { h: 25, s: -120335, l: 52 },
    { h: 24, s: -119543, e: [17], l: 56 },
    { h: 24, s: -119601, e: [17], l: 58 },
    { h: 24, s: -119659, e: [17], l: 58 },
    { h: 24, s: -119717, e: [17], l: 58 },
    { h: 24, s: -119775, e: [17], l: 58 }
];
const Table_B_2_lut_abs = createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const Table_B_2_lut_rel = createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const Table_B_2_complex = createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", bytes2);
const Table_C_ranges = createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function flatten(values) {
    return values.reduce((accum, value) => {
        value.forEach((value) => { accum.push(value); });
        return accum;
    }, []);
}
function _nameprepTableA1(codepoint) {
    return !!matchMap(codepoint, Table_A_1_ranges);
}
function _nameprepTableB2(codepoint) {
    let range = matchMap(codepoint, Table_B_2_ranges);
    if (range) {
        return [codepoint + range.s];
    }
    let codes = Table_B_2_lut_abs[codepoint];
    if (codes) {
        return codes;
    }
    let shift = Table_B_2_lut_rel[codepoint];
    if (shift) {
        return [codepoint + shift[0]];
    }
    let complex = Table_B_2_complex[codepoint];
    if (complex) {
        return complex;
    }
    return null;
}
function _nameprepTableC(codepoint) {
    return !!matchMap(codepoint, Table_C_ranges);
}
function nameprep(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) {
        return value.toLowerCase();
    }
    // Get the code points (keeping the current normalization)
    let codes = toUtf8CodePoints(value);
    codes = flatten(codes.map((code) => {
        // Substitute Table B.1 (Maps to Nothing)
        if (Table_B_1_flags.indexOf(code) >= 0) {
            return [];
        }
        if (code >= 0xfe00 && code <= 0xfe0f) {
            return [];
        }
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = _nameprepTableB2(code);
        if (codesTableB2) {
            return codesTableB2;
        }
        // No Substitution
        return [code];
    }));
    // Normalize using form KC
    codes = toUtf8CodePoints(_toUtf8String(codes), UnicodeNormalizationForm.NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code) => {
        if (_nameprepTableC(code)) {
            throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
        }
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code) => {
        if (_nameprepTableA1(code)) {
            throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
        }
    });
    // IDNA extras
    let name = _toUtf8String(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") {
        throw new Error("invalid hyphen");
    }
    // IDNA: 4.2.4
    if (name.length > 63) {
        throw new Error("too long");
    }
    return name;
}

function id$1(text) {
    return keccak256$1(toUtf8Bytes(text));
}

const version$j = "hash/5.6.0";

const logger$l = new Logger$1(version$j);
const Zeros = new Uint8Array(32);
Zeros.fill(0);
const Partition = new RegExp("^((.*)\\.)?([^.]+)$");
function namehash(name) {
    /* istanbul ignore if */
    if (typeof (name) !== "string") {
        logger$l.throwArgumentError("invalid ENS name; not a string", "name", name);
    }
    let current = name;
    let result = Zeros;
    while (current.length) {
        const partition = current.match(Partition);
        if (partition == null || partition[2] === "") {
            logger$l.throwArgumentError("invalid ENS address; missing component", "name", name);
        }
        const label = toUtf8Bytes(nameprep(partition[3]));
        result = keccak256$1(concat$4([result, keccak256$1(label)]));
        current = partition[2] || "";
    }
    return hexlify(result);
}
function dnsEncode(name) {
    return hexlify(concat$4(name.split(".").map((comp) => {
        // We jam in an _ prefix to fill in with the length later
        // Note: Nameprep throws if the component is over 63 bytes
        const bytes = toUtf8Bytes("_" + nameprep(comp));
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}

const version$i = "rlp/5.6.0";

const logger$k = new Logger$1(version$i);
function arrayifyInteger(value) {
    const result = [];
    while (value) {
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function unarrayifyInteger(data, offset, length) {
    let result = 0;
    for (let i = 0; i < length; i++) {
        result = (result * 256) + data[offset + i];
    }
    return result;
}
function _encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function (child) {
            payload = payload.concat(_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!isBytesLike(object)) {
        logger$k.throwArgumentError("RLP object must be BytesLike", "object", object);
    }
    const data = Array.prototype.slice.call(arrayify$1(object));
    if (data.length === 1 && data[0] <= 0x7f) {
        return data;
    }
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function encode$f(object) {
    return hexlify(_encode(object));
}
function _decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while (childOffset < offset + 1 + length) {
        const decoded = _decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) {
            logger$k.throwError("child data too short", Logger$1.errors.BUFFER_OVERRUN, {});
        }
    }
    return { consumed: (1 + length), result: result };
}
// returns { consumed: number, result: Object }
function _decode(data, offset) {
    if (data.length === 0) {
        logger$k.throwError("data too short", Logger$1.errors.BUFFER_OVERRUN, {});
    }
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) {
            logger$k.throwError("data short segment too short", Logger$1.errors.BUFFER_OVERRUN, {});
        }
        const length = unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) {
            logger$k.throwError("data long segment too short", Logger$1.errors.BUFFER_OVERRUN, {});
        }
        return _decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    }
    else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) {
            logger$k.throwError("data array too short", Logger$1.errors.BUFFER_OVERRUN, {});
        }
        return _decodeChildren(data, offset, offset + 1, length);
    }
    else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) {
            logger$k.throwError("data array too short", Logger$1.errors.BUFFER_OVERRUN, {});
        }
        const length = unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) {
            logger$k.throwError("data array too short", Logger$1.errors.BUFFER_OVERRUN, {});
        }
        const result = hexlify(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return { consumed: (1 + lengthLength + length), result: result };
    }
    else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) {
            logger$k.throwError("data too short", Logger$1.errors.BUFFER_OVERRUN, {});
        }
        const result = hexlify(data.slice(offset + 1, offset + 1 + length));
        return { consumed: (1 + length), result: result };
    }
    return { consumed: 1, result: hexlify(data[offset]) };
}
function decode$e(data) {
    const bytes = arrayify$1(data);
    const decoded = _decode(bytes, 0);
    if (decoded.consumed !== bytes.length) {
        logger$k.throwArgumentError("invalid rlp data", "data", data);
    }
    return decoded.result;
}

const version$h = "address/5.6.0";

const logger$j = new Logger$1(version$h);
function getChecksumAddress$1(address) {
    if (!isHexString$1(address, 20)) {
        logger$j.throwArgumentError("invalid address", "address", address);
    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for (let i = 0; i < 40; i++) {
        expanded[i] = chars[i].charCodeAt(0);
    }
    const hashed = arrayify$1(keccak256$1(expanded));
    for (let i = 0; i < 40; i += 2) {
        if ((hashed[i >> 1] >> 4) >= 8) {
            chars[i] = chars[i].toUpperCase();
        }
        if ((hashed[i >> 1] & 0x0f) >= 8) {
            chars[i + 1] = chars[i + 1].toUpperCase();
        }
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const MAX_SAFE_INTEGER$4 = 0x1fffffffffffff;
function log10$1(x) {
    if (Math.log10) {
        return Math.log10(x);
    }
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const ibanLookup$1 = {};
for (let i = 0; i < 10; i++) {
    ibanLookup$1[String(i)] = String(i);
}
for (let i = 0; i < 26; i++) {
    ibanLookup$1[String.fromCharCode(65 + i)] = String(10 + i);
}
// How many decimal digits can we process? (for 64-bit float, this is 15)
const safeDigits$1 = Math.floor(log10$1(MAX_SAFE_INTEGER$4));
function ibanChecksum$1(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c) => { return ibanLookup$1[c]; }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while (expanded.length >= safeDigits$1) {
        let block = expanded.substring(0, safeDigits$1);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - (parseInt(expanded, 10) % 97));
    while (checksum.length < 2) {
        checksum = "0" + checksum;
    }
    return checksum;
}
function getAddress$1(address) {
    let result = null;
    if (typeof (address) !== "string") {
        logger$j.throwArgumentError("invalid address", "address", address);
    }
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") {
            address = "0x" + address;
        }
        result = getChecksumAddress$1(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) {
            logger$j.throwArgumentError("bad address checksum", "address", address);
        }
        // Maybe ICAP? (we only support direct mode)
    }
    else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== ibanChecksum$1(address)) {
            logger$j.throwArgumentError("bad icap checksum", "address", address);
        }
        result = _base36To16$1(address.substring(4));
        while (result.length < 40) {
            result = "0" + result;
        }
        result = getChecksumAddress$1("0x" + result);
    }
    else {
        logger$j.throwArgumentError("invalid address", "address", address);
    }
    return result;
}
// http://ethereum.stackexchange.com/questions/760/how-is-the-address-of-an-ethereum-contract-computed
function getContractAddress(transaction) {
    let from = null;
    try {
        from = getAddress$1(transaction.from);
    }
    catch (error) {
        logger$j.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = stripZeros(arrayify$1(BigNumber$1.from(transaction.nonce).toHexString()));
    return getAddress$1(hexDataSlice(keccak256$1(encode$f([from, nonce])), 12));
}

var __awaiter$7 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const logger$i = new Logger$1(version$j);
const padding = new Uint8Array(32);
padding.fill(0);
const NegativeOne = BigNumber$1.from(-1);
const Zero = BigNumber$1.from(0);
const One = BigNumber$1.from(1);
const MaxUint256 = BigNumber$1.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function hexPadRight(value) {
    const bytes = arrayify$1(value);
    const padOffset = bytes.length % 32;
    if (padOffset) {
        return hexConcat([bytes, padding.slice(padOffset)]);
    }
    return hexlify(bytes);
}
const hexTrue = hexZeroPad(One.toHexString(), 32);
const hexFalse = hexZeroPad(Zero.toHexString(), 32);
const domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const domainFieldNames = [
    "name", "version", "chainId", "verifyingContract", "salt"
];
function checkString(key) {
    return function (value) {
        if (typeof (value) !== "string") {
            logger$i.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        }
        return value;
    };
}
const domainChecks = {
    name: checkString("name"),
    version: checkString("version"),
    chainId: function (value) {
        try {
            return BigNumber$1.from(value).toString();
        }
        catch (error) { }
        return logger$i.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function (value) {
        try {
            return getAddress$1(value).toLowerCase();
        }
        catch (error) { }
        return logger$i.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function (value) {
        try {
            const bytes = arrayify$1(value);
            if (bytes.length !== 32) {
                throw new Error("bad length");
            }
            return hexlify(bytes);
        }
        catch (error) { }
        return logger$i.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = (match[1] === "");
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || (match[2] && match[2] !== String(width))) {
                logger$i.throwArgumentError("invalid numeric width", "type", type);
            }
            const boundsUpper = MaxUint256.mask(signed ? (width - 1) : width);
            const boundsLower = signed ? boundsUpper.add(One).mul(NegativeOne) : Zero;
            return function (value) {
                const v = BigNumber$1.from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) {
                    logger$i.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                }
                return hexZeroPad(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) {
                logger$i.throwArgumentError("invalid bytes width", "type", type);
            }
            return function (value) {
                const bytes = arrayify$1(value);
                if (bytes.length !== width) {
                    logger$i.throwArgumentError(`invalid length for ${type}`, "value", value);
                }
                return hexPadRight(value);
            };
        }
    }
    switch (type) {
        case "address": return function (value) {
            return hexZeroPad(getAddress$1(value), 32);
        };
        case "bool": return function (value) {
            return ((!value) ? hexFalse : hexTrue);
        };
        case "bytes": return function (value) {
            return keccak256$1(value);
        };
        case "string": return function (value) {
            return id$1(value);
        };
    }
    return null;
}
function encodeType(name, fields) {
    return `${name}(${fields.map(({ name, type }) => (type + " " + name)).join(",")})`;
}
class TypedDataEncoder {
    constructor(types) {
        defineReadOnly(this, "types", Object.freeze(deepCopy(types)));
        defineReadOnly(this, "_encoderCache", {});
        defineReadOnly(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type) => {
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for (const name in types) {
            const uniqueNames = {};
            types[name].forEach((field) => {
                // Check each field has a unique name
                if (uniqueNames[field.name]) {
                    logger$i.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                }
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) {
                    logger$i.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                }
                // Is this a base encoding type?
                const encoder = getBaseEncoder(baseType);
                if (encoder) {
                    return;
                }
                if (!parents[baseType]) {
                    logger$i.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                }
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n) => (parents[n].length === 0));
        if (primaryTypes.length === 0) {
            logger$i.throwArgumentError("missing primary type", "types", types);
        }
        else if (primaryTypes.length > 1) {
            logger$i.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t) => (JSON.stringify(t))).join(", ")}`, "types", types);
        }
        defineReadOnly(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) {
                logger$i.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            }
            found[type] = true;
            Object.keys(links[type]).forEach((child) => {
                if (!parents[child]) {
                    return;
                }
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype) => {
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for (const name in subtypes) {
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = encodeType(name, types[name]) + st.map((t) => encodeType(t, types[t])).join("");
        }
    }
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) {
            encoder = this._encoderCache[type] = this._getEncoder(type);
        }
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = getBaseEncoder(type);
            if (encoder) {
                return encoder;
            }
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value) => {
                if (length >= 0 && value.length !== length) {
                    logger$i.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                }
                let result = value.map(subEncoder);
                if (this._types[subtype]) {
                    result = result.map(keccak256$1);
                }
                return keccak256$1(hexConcat(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = id$1(this._types[type]);
            return (value) => {
                const values = fields.map(({ name, type }) => {
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) {
                        return keccak256$1(result);
                    }
                    return result;
                });
                values.unshift(encodedType);
                return hexConcat(values);
            };
        }
        return logger$i.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) {
            logger$i.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        }
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return keccak256$1(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = getBaseEncoder(type);
            if (encoder) {
                return callback(type, value);
            }
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) {
                logger$i.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            }
            return value.map((v) => this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            return fields.reduce((accum, { name, type }) => {
                accum[name] = this._visit(type, value[name], callback);
                return accum;
            }, {});
        }
        return logger$i.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new TypedDataEncoder(types);
    }
    static getPrimaryType(types) {
        return TypedDataEncoder.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return TypedDataEncoder.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for (const name in domain) {
            const type = domainFieldTypes[name];
            if (!type) {
                logger$i.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            }
            domainFields.push({ name, type });
        }
        domainFields.sort((a, b) => {
            return domainFieldNames.indexOf(a.name) - domainFieldNames.indexOf(b.name);
        });
        return TypedDataEncoder.hashStruct("EIP712Domain", { EIP712Domain: domainFields }, domain);
    }
    static encode(domain, types, value) {
        return hexConcat([
            "0x1901",
            TypedDataEncoder.hashDomain(domain),
            TypedDataEncoder.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return keccak256$1(TypedDataEncoder.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return __awaiter$7(this, void 0, void 0, function* () {
            // Make a copy to isolate it from the object passed in
            domain = shallowCopy(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !isHexString$1(domain.verifyingContract, 20)) {
                ensCache[domain.verifyingContract] = "0x";
            }
            // We are going to use the encoder to visit all the base values
            const encoder = TypedDataEncoder.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value) => {
                if (type === "address" && !isHexString$1(value, 20)) {
                    ensCache[value] = "0x";
                }
                return value;
            });
            // Lookup each name
            for (const name in ensCache) {
                ensCache[name] = yield resolveName(name);
            }
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) {
                domain.verifyingContract = ensCache[domain.verifyingContract];
            }
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value) => {
                if (type === "address" && ensCache[value]) {
                    return ensCache[value];
                }
                return value;
            });
            return { domain, value };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        TypedDataEncoder.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        domainFieldNames.forEach((name) => {
            const value = domain[name];
            if (value == null) {
                return;
            }
            domainValues[name] = domainChecks[name](value);
            domainTypes.push({ name, type: domainFieldTypes[name] });
        });
        const encoder = TypedDataEncoder.from(types);
        const typesWithDomain = shallowCopy(types);
        if (typesWithDomain.EIP712Domain) {
            logger$i.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        }
        else {
            typesWithDomain.EIP712Domain = domainTypes;
        }
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value) => {
                // bytes
                if (type.match(/^bytes(\d*)/)) {
                    return hexlify(arrayify$1(value));
                }
                // uint or int
                if (type.match(/^u?int/)) {
                    return BigNumber$1.from(value).toString();
                }
                switch (type) {
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof (value) !== "string") {
                            logger$i.throwArgumentError(`invalid string`, "value", value);
                        }
                        return value;
                }
                return logger$i.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
}

var hash$1 = {};

var utils$s = {};

var minimalisticAssert$1 = assert$b;

function assert$b(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert$b.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};

var inherits$1 = {exports: {}};

var inherits_browser$1 = {exports: {}};

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  inherits_browser$1.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    }
  };
} else {
  // old school shim for old browsers
  inherits_browser$1.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function () {};
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    }
  };
}

try {
  var util$9 = require('util');
  /* istanbul ignore next */
  if (typeof util$9.inherits !== 'function') throw '';
  inherits$1.exports = util$9.inherits;
} catch (e) {
  /* istanbul ignore next */
  inherits$1.exports = inherits_browser$1.exports;
}

var assert$a = minimalisticAssert$1;
var inherits = inherits$1.exports;

utils$s.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray$1(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
utils$s.toArray = toArray$1;

function toHex$2(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils$s.toHex = toHex$2;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
utils$s.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
utils$s.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils$s.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
utils$s.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert$a(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
utils$s.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
utils$s.split32 = split32;

function rotr32$1(w, b) {
  return (w >>> b) | (w << (32 - b));
}
utils$s.rotr32 = rotr32$1;

function rotl32$2(w, b) {
  return (w << b) | (w >>> (32 - b));
}
utils$s.rotl32 = rotl32$2;

function sum32$3(a, b) {
  return (a + b) >>> 0;
}
utils$s.sum32 = sum32$3;

function sum32_3$1(a, b, c) {
  return (a + b + c) >>> 0;
}
utils$s.sum32_3 = sum32_3$1;

function sum32_4$2(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
utils$s.sum32_4 = sum32_4$2;

function sum32_5$2(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
utils$s.sum32_5 = sum32_5$2;

function sum64$1(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
utils$s.sum64 = sum64$1;

function sum64_hi$1(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
utils$s.sum64_hi = sum64_hi$1;

function sum64_lo$1(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
utils$s.sum64_lo = sum64_lo$1;

function sum64_4_hi$1(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
utils$s.sum64_4_hi = sum64_4_hi$1;

function sum64_4_lo$1(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
utils$s.sum64_4_lo = sum64_4_lo$1;

function sum64_5_hi$1(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
utils$s.sum64_5_hi = sum64_5_hi$1;

function sum64_5_lo$1(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
utils$s.sum64_5_lo = sum64_5_lo$1;

function rotr64_hi$1(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
utils$s.rotr64_hi = rotr64_hi$1;

function rotr64_lo$1(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
utils$s.rotr64_lo = rotr64_lo$1;

function shr64_hi$1(ah, al, num) {
  return ah >>> num;
}
utils$s.shr64_hi = shr64_hi$1;

function shr64_lo$1(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
utils$s.shr64_lo = shr64_lo$1;

var common$5 = {};

var utils$r = utils$s;
var assert$9 = minimalisticAssert$1;

function BlockHash$4() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
common$5.BlockHash = BlockHash$4;

BlockHash$4.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils$r.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils$r.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash$4.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert$9(this.pending === null);

  return this._digest(enc);
};

BlockHash$4.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};

var sha = {};

var common$4 = {};

var utils$q = utils$s;
var rotr32 = utils$q.rotr32;

function ft_1$1(s, x, y, z) {
  if (s === 0)
    return ch32$1(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32$1(x, y, z);
}
common$4.ft_1 = ft_1$1;

function ch32$1(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
common$4.ch32 = ch32$1;

function maj32$1(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
common$4.maj32 = maj32$1;

function p32(x, y, z) {
  return x ^ y ^ z;
}
common$4.p32 = p32;

function s0_256$1(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
common$4.s0_256 = s0_256$1;

function s1_256$1(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
common$4.s1_256 = s1_256$1;

function g0_256$1(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
common$4.g0_256 = g0_256$1;

function g1_256$1(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
common$4.g1_256 = g1_256$1;

var utils$p = utils$s;
var common$3 = common$5;
var shaCommon$1 = common$4;

var rotl32$1 = utils$p.rotl32;
var sum32$2 = utils$p.sum32;
var sum32_5$1 = utils$p.sum32_5;
var ft_1 = shaCommon$1.ft_1;
var BlockHash$3 = common$3.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash$3.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils$p.inherits(SHA1, BlockHash$3);
var _1 = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32$1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5$1(rotl32$1(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32$1(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32$2(this.h[0], a);
  this.h[1] = sum32$2(this.h[1], b);
  this.h[2] = sum32$2(this.h[2], c);
  this.h[3] = sum32$2(this.h[3], d);
  this.h[4] = sum32$2(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils$p.toHex32(this.h, 'big');
  else
    return utils$p.split32(this.h, 'big');
};

var utils$o = utils$s;
var common$2 = common$5;
var shaCommon = common$4;
var assert$8 = minimalisticAssert$1;

var sum32$1 = utils$o.sum32;
var sum32_4$1 = utils$o.sum32_4;
var sum32_5 = utils$o.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash$2 = common$2.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256$1() {
  if (!(this instanceof SHA256$1))
    return new SHA256$1();

  BlockHash$2.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils$o.inherits(SHA256$1, BlockHash$2);
var _256 = SHA256$1;

SHA256$1.blockSize = 512;
SHA256$1.outSize = 256;
SHA256$1.hmacStrength = 192;
SHA256$1.padLength = 64;

SHA256$1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4$1(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert$8(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32$1(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32$1(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32$1(T1, T2);
  }

  this.h[0] = sum32$1(this.h[0], a);
  this.h[1] = sum32$1(this.h[1], b);
  this.h[2] = sum32$1(this.h[2], c);
  this.h[3] = sum32$1(this.h[3], d);
  this.h[4] = sum32$1(this.h[4], e);
  this.h[5] = sum32$1(this.h[5], f);
  this.h[6] = sum32$1(this.h[6], g);
  this.h[7] = sum32$1(this.h[7], h);
};

SHA256$1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils$o.toHex32(this.h, 'big');
  else
    return utils$o.split32(this.h, 'big');
};

var utils$n = utils$s;
var SHA256 = _256;

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils$n.inherits(SHA224, SHA256);
var _224 = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils$n.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils$n.split32(this.h.slice(0, 7), 'big');
};

var utils$m = utils$s;
var common$1 = common$5;
var assert$7 = minimalisticAssert$1;

var rotr64_hi = utils$m.rotr64_hi;
var rotr64_lo = utils$m.rotr64_lo;
var shr64_hi = utils$m.shr64_hi;
var shr64_lo = utils$m.shr64_lo;
var sum64 = utils$m.sum64;
var sum64_hi = utils$m.sum64_hi;
var sum64_lo = utils$m.sum64_lo;
var sum64_4_hi = utils$m.sum64_4_hi;
var sum64_4_lo = utils$m.sum64_4_lo;
var sum64_5_hi = utils$m.sum64_5_hi;
var sum64_5_lo = utils$m.sum64_5_lo;

var BlockHash$1 = common$1.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512$1() {
  if (!(this instanceof SHA512$1))
    return new SHA512$1();

  BlockHash$1.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils$m.inherits(SHA512$1, BlockHash$1);
var _512 = SHA512$1;

SHA512$1.blockSize = 1024;
SHA512$1.outSize = 512;
SHA512$1.hmacStrength = 192;
SHA512$1.padLength = 128;

SHA512$1.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512$1.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert$7(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512$1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils$m.toHex32(this.h, 'big');
  else
    return utils$m.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

var utils$l = utils$s;

var SHA512 = _512;

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils$l.inherits(SHA384, SHA512);
var _384 = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils$l.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils$l.split32(this.h.slice(0, 12), 'big');
};

sha.sha1 = _1;
sha.sha224 = _224;
sha.sha256 = _256;
sha.sha384 = _384;
sha.sha512 = _512;

var ripemd = {};

var utils$k = utils$s;
var common = common$5;

var rotl32 = utils$k.rotl32;
var sum32 = utils$k.sum32;
var sum32_3 = utils$k.sum32_3;
var sum32_4 = utils$k.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils$k.inherits(RIPEMD160, BlockHash);
ripemd.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f$4(j, B, C, D), msg[r$3[j] + start], K(j)),
        s$1[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f$4(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils$k.toHex32(this.h, 'little');
  else
    return utils$k.split32(this.h, 'little');
};

function f$4(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r$3 = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s$1 = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];

var utils$j = utils$s;
var assert$6 = minimalisticAssert$1;

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils$j.toArray(key, enc));
}
var hmac = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert$6(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};

(function (exports) {
var hash = exports;

hash.utils = utils$s;
hash.common = common$5;
hash.sha = sha;
hash.ripemd = ripemd;
hash.hmac = hmac;

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;
}(hash$1));

var hash = hash$1;

var SupportedAlgorithm;
(function (SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})(SupportedAlgorithm || (SupportedAlgorithm = {}));

const version$g = "sha2/5.6.0";

new Logger$1(version$g);
function sha256$1(data) {
    return "0x" + (hash.sha256().update(arrayify$1(data)).digest("hex"));
}

function decode$d(textData) {
    textData = atob(textData);
    const data = [];
    for (let i = 0; i < textData.length; i++) {
        data.push(textData.charCodeAt(i));
    }
    return arrayify$1(data);
}
function encode$e(data) {
    data = arrayify$1(data);
    let textData = "";
    for (let i = 0; i < data.length; i++) {
        textData += String.fromCharCode(data[i]);
    }
    return btoa(textData);
}

const version$f = "web/5.6.0";

var __awaiter$6 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function getUrl(href, options) {
    return __awaiter$6(this, void 0, void 0, function* () {
        if (options == null) {
            options = {};
        }
        const request = {
            method: (options.method || "GET"),
            headers: (options.headers || {}),
            body: (options.body || undefined),
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) {
            response.headers.forEach((value, key) => {
                headers[key.toLowerCase()] = value;
            });
        }
        else {
            ((response.headers).keys)().forEach((key) => {
                headers[key.toLowerCase()] = response.headers.get(key);
            });
        }
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: arrayify$1(new Uint8Array(body)),
        };
    });
}

var __awaiter$5 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const logger$h = new Logger$1(version$f);
function staller(duration) {
    return new Promise((resolve) => {
        setTimeout(resolve, duration);
    });
}
function bodyify(value, type) {
    if (value == null) {
        return null;
    }
    if (typeof (value) === "string") {
        return value;
    }
    if (isBytesLike(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) {
            try {
                return toUtf8String(value);
            }
            catch (error) { }
        }
        return hexlify(value);
    }
    return value;
}
// This API is still a work in progress; the future changes will likely be:
// - ConnectionInfo => FetchDataRequest<T = any>
// - FetchDataRequest.body? = string | Uint8Array | { contentType: string, data: string | Uint8Array }
//   - If string => text/plain, Uint8Array => application/octet-stream (if content-type unspecified)
// - FetchDataRequest.processFunc = (body: Uint8Array, response: FetchDataResponse) => T
// For this reason, it should be considered internal until the API is finalized
function _fetchData(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = (typeof (connection) === "object" && connection.throttleLimit != null) ? connection.throttleLimit : 12;
    logger$h.assertArgument((attemptLimit > 0 && (attemptLimit % 1) === 0), "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = ((typeof (connection) === "object") ? connection.throttleCallback : null);
    const throttleSlotInterval = ((typeof (connection) === "object" && typeof (connection.throttleSlotInterval) === "number") ? connection.throttleSlotInterval : 100);
    logger$h.assertArgument((throttleSlotInterval > 0 && (throttleSlotInterval % 1) === 0), "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = ((typeof (connection) === "object") ? !!(connection.errorPassThrough) : false);
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET",
    };
    let allow304 = false;
    let timeout = 2 * 60 * 1000;
    if (typeof (connection) === "string") {
        url = connection;
    }
    else if (typeof (connection) === "object") {
        if (connection == null || connection.url == null) {
            logger$h.throwArgumentError("missing URL", "connection.url", connection);
        }
        url = connection.url;
        if (typeof (connection.timeout) === "number" && connection.timeout > 0) {
            timeout = connection.timeout;
        }
        if (connection.headers) {
            for (const key in connection.headers) {
                headers[key.toLowerCase()] = { key: key, value: String(connection.headers[key]) };
                if (["if-none-match", "if-modified-since"].indexOf(key.toLowerCase()) >= 0) {
                    allow304 = true;
                }
            }
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) {
                logger$h.throwError("basic authentication requires a secure https url", Logger$1.errors.INVALID_ARGUMENT, { argument: "url", url: url, user: connection.user, password: "[REDACTED]" });
            }
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + encode$e(toUtf8Bytes(authorization))
            };
        }
        if (connection.skipFetchSetup != null) {
            options.skipFetchSetup = !!connection.skipFetchSetup;
        }
    }
    const reData = new RegExp("^data:([a-z0-9-]+/[a-z0-9-]+);base64,(.*)$", "i");
    const dataMatch = ((url) ? url.match(reData) : null);
    if (dataMatch) {
        try {
            const response = {
                statusCode: 200,
                statusMessage: "OK",
                headers: { "content-type": dataMatch[1] },
                body: decode$d(dataMatch[2])
            };
            let result = response.body;
            if (processFunc) {
                result = processFunc(response.body, response);
            }
            return Promise.resolve(result);
        }
        catch (error) {
            logger$h.throwError("processing response error", Logger$1.errors.SERVER_ERROR, {
                body: bodyify(dataMatch[1], dataMatch[2]),
                error: error,
                requestBody: null,
                requestMethod: "GET",
                url: url
            });
        }
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) {
            headers["content-type"] = { key: "Content-Type", value: "application/octet-stream" };
        }
        if (headers["content-length"] == null) {
            headers["content-length"] = { key: "Content-Length", value: String(body.length) };
        }
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key) => {
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = (function () {
        let timer = null;
        const promise = new Promise(function (resolve, reject) {
            if (timeout) {
                timer = setTimeout(() => {
                    if (timer == null) {
                        return;
                    }
                    timer = null;
                    reject(logger$h.makeError("timeout", Logger$1.errors.TIMEOUT, {
                        requestBody: bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        timeout: timeout,
                        url: url
                    }));
                }, timeout);
            }
        });
        const cancel = function () {
            if (timer == null) {
                return;
            }
            clearTimeout(timer);
            timer = null;
        };
        return { promise, cancel };
    })();
    const runningFetch = (function () {
        return __awaiter$5(this, void 0, void 0, function* () {
            for (let attempt = 0; attempt < attemptLimit; attempt++) {
                let response = null;
                try {
                    response = yield getUrl(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        }
                        else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) {
                                tryAgain = yield throttleCallback(attempt, url);
                            }
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof (retryAfter) === "string" && retryAfter.match(/^[1-9][0-9]*$/)) {
                                    stall = parseInt(retryAfter) * 1000;
                                }
                                else {
                                    stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                }
                                //console.log("Stalling 429");
                                yield staller(stall);
                                continue;
                            }
                        }
                    }
                }
                catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        logger$h.throwError("missing response", Logger$1.errors.SERVER_ERROR, {
                            requestBody: bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) {
                    body = null;
                }
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    logger$h.throwError("bad response", Logger$1.errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: bodyify(body, ((response.headers) ? response.headers["content-type"] : null)),
                        requestBody: bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) {
                    try {
                        const result = yield processFunc(body, response);
                        runningTimeout.cancel();
                        return result;
                    }
                    catch (error) {
                        // Allow the processFunc to trigger a throttle
                        if (error.throttleRetry && attempt < attemptLimit) {
                            let tryAgain = true;
                            if (throttleCallback) {
                                tryAgain = yield throttleCallback(attempt, url);
                            }
                            if (tryAgain) {
                                const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling callback");
                                yield staller(timeout);
                                continue;
                            }
                        }
                        runningTimeout.cancel();
                        logger$h.throwError("processing response error", Logger$1.errors.SERVER_ERROR, {
                            body: bodyify(body, ((response.headers) ? response.headers["content-type"] : null)),
                            error: error,
                            requestBody: bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            url: url
                        });
                    }
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return logger$h.throwError("failed response", Logger$1.errors.SERVER_ERROR, {
                requestBody: bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    })();
    return Promise.race([runningTimeout.promise, runningFetch]);
}
function fetchJson(connection, json, processFunc) {
    let processJsonFunc = (value, response) => {
        let result = null;
        if (value != null) {
            try {
                result = JSON.parse(toUtf8String(value));
            }
            catch (error) {
                logger$h.throwError("invalid JSON", Logger$1.errors.SERVER_ERROR, {
                    body: value,
                    error: error
                });
            }
        }
        if (processFunc) {
            result = processFunc(result, response);
        }
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = toUtf8Bytes(json);
        // Create a connection with the content-type set for JSON
        const updated = (typeof (connection) === "string") ? ({ url: connection }) : shallowCopy(connection);
        if (updated.headers) {
            const hasContentType = (Object.keys(updated.headers).filter((k) => (k.toLowerCase() === "content-type")).length) !== 0;
            if (!hasContentType) {
                updated.headers = shallowCopy(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        }
        else {
            updated.headers = { "content-type": "application/json" };
        }
        connection = updated;
    }
    return _fetchData(connection, body, processJsonFunc);
}
function poll(func, options) {
    if (!options) {
        options = {};
    }
    options = shallowCopy(options);
    if (options.floor == null) {
        options.floor = 0;
    }
    if (options.ceiling == null) {
        options.ceiling = 10000;
    }
    if (options.interval == null) {
        options.interval = 250;
    }
    return new Promise(function (resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = () => {
            if (done) {
                return false;
            }
            done = true;
            if (timer) {
                clearTimeout(timer);
            }
            return true;
        };
        if (options.timeout) {
            timer = setTimeout(() => {
                if (cancel()) {
                    reject(new Error("timeout"));
                }
            }, options.timeout);
        }
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function (result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) {
                        resolve(result);
                    }
                }
                else if (options.oncePoll) {
                    options.oncePoll.once("poll", check);
                }
                else if (options.onceBlock) {
                    options.onceBlock.once("block", check);
                    // Otherwise, exponential back-off (up to 10s) our next request
                }
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) {
                            reject(new Error("retry limit reached"));
                        }
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) {
                        timeout = options.floor;
                    }
                    if (timeout > options.ceiling) {
                        timeout = options.ceiling;
                    }
                    setTimeout(check, timeout);
                }
                return null;
            }, function (error) {
                if (cancel()) {
                    reject(error);
                }
            });
        }
        check();
    });
}

var ALPHABET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l';

// pre-compute lookup table
var ALPHABET_MAP = {};
for (var z$3 = 0; z$3 < ALPHABET.length; z$3++) {
  var x$4 = ALPHABET.charAt(z$3);

  if (ALPHABET_MAP[x$4] !== undefined) throw new TypeError(x$4 + ' is ambiguous')
  ALPHABET_MAP[x$4] = z$3;
}

function polymodStep (pre) {
  var b = pre >> 25;
  return ((pre & 0x1FFFFFF) << 5) ^
    (-((b >> 0) & 1) & 0x3b6a57b2) ^
    (-((b >> 1) & 1) & 0x26508e6d) ^
    (-((b >> 2) & 1) & 0x1ea119fa) ^
    (-((b >> 3) & 1) & 0x3d4233dd) ^
    (-((b >> 4) & 1) & 0x2a1462b3)
}

function prefixChk (prefix) {
  var chk = 1;
  for (var i = 0; i < prefix.length; ++i) {
    var c = prefix.charCodeAt(i);
    if (c < 33 || c > 126) return 'Invalid prefix (' + prefix + ')'

    chk = polymodStep(chk) ^ (c >> 5);
  }
  chk = polymodStep(chk);

  for (i = 0; i < prefix.length; ++i) {
    var v = prefix.charCodeAt(i);
    chk = polymodStep(chk) ^ (v & 0x1f);
  }
  return chk
}

function encode$d (prefix, words, LIMIT) {
  LIMIT = LIMIT || 90;
  if ((prefix.length + 7 + words.length) > LIMIT) throw new TypeError('Exceeds length limit')

  prefix = prefix.toLowerCase();

  // determine chk mod
  var chk = prefixChk(prefix);
  if (typeof chk === 'string') throw new Error(chk)

  var result = prefix + '1';
  for (var i = 0; i < words.length; ++i) {
    var x = words[i];
    if ((x >> 5) !== 0) throw new Error('Non 5-bit word')

    chk = polymodStep(chk) ^ x;
    result += ALPHABET.charAt(x);
  }

  for (i = 0; i < 6; ++i) {
    chk = polymodStep(chk);
  }
  chk ^= 1;

  for (i = 0; i < 6; ++i) {
    var v = (chk >> ((5 - i) * 5)) & 0x1f;
    result += ALPHABET.charAt(v);
  }

  return result
}

function __decode (str, LIMIT) {
  LIMIT = LIMIT || 90;
  if (str.length < 8) return str + ' too short'
  if (str.length > LIMIT) return 'Exceeds length limit'

  // don't allow mixed case
  var lowered = str.toLowerCase();
  var uppered = str.toUpperCase();
  if (str !== lowered && str !== uppered) return 'Mixed-case string ' + str
  str = lowered;

  var split = str.lastIndexOf('1');
  if (split === -1) return 'No separator character for ' + str
  if (split === 0) return 'Missing prefix for ' + str

  var prefix = str.slice(0, split);
  var wordChars = str.slice(split + 1);
  if (wordChars.length < 6) return 'Data too short'

  var chk = prefixChk(prefix);
  if (typeof chk === 'string') return chk

  var words = [];
  for (var i = 0; i < wordChars.length; ++i) {
    var c = wordChars.charAt(i);
    var v = ALPHABET_MAP[c];
    if (v === undefined) return 'Unknown character ' + c
    chk = polymodStep(chk) ^ v;

    // not in the checksum?
    if (i + 6 >= wordChars.length) continue
    words.push(v);
  }

  if (chk !== 1) return 'Invalid checksum for ' + str
  return { prefix: prefix, words: words }
}

function decodeUnsafe () {
  var res = __decode.apply(null, arguments);
  if (typeof res === 'object') return res
}

function decode$c (str) {
  var res = __decode.apply(null, arguments);
  if (typeof res === 'object') return res

  throw new Error(res)
}

function convert$2 (data, inBits, outBits, pad) {
  var value = 0;
  var bits = 0;
  var maxV = (1 << outBits) - 1;

  var result = [];
  for (var i = 0; i < data.length; ++i) {
    value = (value << inBits) | data[i];
    bits += inBits;

    while (bits >= outBits) {
      bits -= outBits;
      result.push((value >> bits) & maxV);
    }
  }

  if (pad) {
    if (bits > 0) {
      result.push((value << (outBits - bits)) & maxV);
    }
  } else {
    if (bits >= inBits) return 'Excess padding'
    if ((value << (outBits - bits)) & maxV) return 'Non-zero padding'
  }

  return result
}

function toWordsUnsafe (bytes) {
  var res = convert$2(bytes, 8, 5, true);
  if (Array.isArray(res)) return res
}

function toWords (bytes) {
  var res = convert$2(bytes, 8, 5, true);
  if (Array.isArray(res)) return res

  throw new Error(res)
}

function fromWordsUnsafe (words) {
  var res = convert$2(words, 5, 8, false);
  if (Array.isArray(res)) return res
}

function fromWords (words) {
  var res = convert$2(words, 5, 8, false);
  if (Array.isArray(res)) return res

  throw new Error(res)
}

var bech32 = {
  decodeUnsafe: decodeUnsafe,
  decode: decode$c,
  encode: encode$d,
  toWordsUnsafe: toWordsUnsafe,
  toWords: toWords,
  fromWordsUnsafe: fromWordsUnsafe,
  fromWords: fromWords
};

const version$e = "providers/5.6.4";

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var minimalisticAssert = assert$3;

function assert$3(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert$3.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};

var utils_1 = createCommonjsModule(function (module, exports) {

var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};
});

var utils_1$1 = createCommonjsModule(function (module, exports) {

var utils = exports;




utils.assert = minimalisticAssert;
utils.toArray = utils_1.toArray;
utils.zero2 = utils_1.zero2;
utils.toHex = utils_1.toHex;
utils.encode = utils_1.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  naf.fill(0);

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (var i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    [],
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  var m8;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
      this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN$3(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;
});



var getNAF = utils_1$1.getNAF;
var getJSF = utils_1$1.getJSF;
var assert$1$1 = utils_1$1.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN$3(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN$3.red(conf.prime) : BN$3.mont(this.p);

  // Useful for many curves
  this.zero = new BN$3(0).toRed(this.red);
  this.one = new BN$3(1).toRed(this.red);
  this.two = new BN$3(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN$3(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
var base$e = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert$1$1(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  var j;
  var nafW;
  for (j = 0; j < naf.length; j += doubles.step) {
    nafW = 0;
    for (var l = j + doubles.step - 1; l >= j; l--)
      nafW = (nafW << 1) + naf[l];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (j = 0; j < repr.length; j++) {
      nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var l = 0; i >= 0 && naf[i] === 0; i--)
      l++;
    if (i >= 0)
      l++;
    acc = acc.dblp(l);

    if (i < 0)
      break;
    var z = naf[i];
    assert$1$1(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
  points,
  coeffs,
  len,
  jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  var i;
  var j;
  var p;
  for (i = 0; i < len; i++) {
    p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b], /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3,  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (j = 0; j < len; j++) {
      var z = tmp[j];
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils_1$1.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert$1$1(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert$1$1(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
      bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils_1$1.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null,
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles,
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res,
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};

var inherits_browser = createCommonjsModule(function (module) {
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function () {};
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    }
  };
}
});






var assert$2$1 = utils_1$1.assert;

function ShortCurve(conf) {
  base$e.call(this, 'short', conf);

  this.a = new BN$3(conf.a, 16).toRed(this.red);
  this.b = new BN$3(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits_browser(ShortCurve, base$e);
var short_1 = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN$3(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN$3(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert$2$1(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN$3(vec.a, 16),
        b: new BN$3(vec.b, 16),
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis,
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN$3.mont(num);
  var tinv = new BN$3(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN$3(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN$3(1);
  var y1 = new BN$3(0);
  var x2 = new BN$3(0);
  var y2 = new BN$3(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 },
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN$3(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
      var npoints = this._endoWnafT1;
      var ncoeffs = this._endoWnafT2;
      for (var i = 0; i < points.length; i++) {
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();

        if (split.k1.negative) {
          split.k1.ineg();
          p = p.neg(true);
        }
        if (split.k2.negative) {
          split.k2.ineg();
          beta = beta.neg(true);
        }

        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
      }
      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

      // Clean-up references to points and coefficients
      for (var j = 0; j < i * 2; j++) {
        npoints[j] = null;
        ncoeffs[j] = null;
      }
      return res;
    };

function Point(curve, x, y, isRed) {
  base$e.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN$3(x, 16);
    this.y = new BN$3(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits_browser(Point, base$e.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul),
      },
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1),
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1),
    },
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point)),
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point)),
    },
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN$3(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate),
      },
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  base$e.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN$3(0);
  } else {
    this.x = new BN$3(x, 16);
    this.y = new BN$3(y, 16);
    this.z = new BN$3(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits_browser(JPoint, base$e.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  var i;
  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN$3(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

var curve_1 = createCommonjsModule(function (module, exports) {

var curve = exports;

curve.base = base$e;
curve.short = short_1;
curve.mont = /*RicMoo:ethers:require(./mont)*/(null);
curve.edwards = /*RicMoo:ethers:require(./edwards)*/(null);
});

var curves_1 = createCommonjsModule(function (module, exports) {

var curves = exports;





var assert = utils_1$1.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve_1.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve_1.edwards(options);
  else
    this.curve = new curve_1.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve,
      });
      return curve;
    },
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
  ],
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
  ],
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
  ],
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
  ],
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
  ],
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9',
  ],
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658',
  ],
});

var pre;
try {
  pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/(null).crash();
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3',
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15',
    },
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre,
  ],
});
});





function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils_1.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils_1.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils_1.toArray(options.pers, options.persEnc || 'hex');
  minimalisticAssert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
var hmacDrbg = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils_1.toArray(entropy, entropyEnc);
  add = utils_1.toArray(add, addEnc);

  minimalisticAssert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils_1.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils_1.encode(res, enc);
};



var assert$3$1 = utils_1$1.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
var key = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc,
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc,
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN$3(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert$3$1(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert$3$1(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  if(!pub.validate()) {
    assert$3$1(pub.validate(), 'public point not validated');
  }
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};




var assert$4 = utils_1$1.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert$4(options.r && options.s, 'Signature without r or s');
  this.r = new BN$3(options.r, 16);
  this.s = new BN$3(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
var signature = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils_1$1.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new BN$3(r);
  this.s = new BN$3(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils_1$1.encode(res, enc);
};





var rand = /*RicMoo:ethers:require(brorand)*/(function() { throw new Error('unsupported'); });
var assert$5 = utils_1$1.assert;




function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert$5(Object.prototype.hasOwnProperty.call(curves_1, options),
      'Unknown curve ' + options);

    options = curves_1[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves_1.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
var ec = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new key(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return key.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return key.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new hmacDrbg({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray(),
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN$3(2));
  for (;;) {
    var priv = new BN$3(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  }
};

EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN$3(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new hmacDrbg({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN$3(1));

  for (var iter = 0; ; iter++) {
    var k = options.k ?
      options.k(iter) :
      new BN$3(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature$1, key, enc) {
  msg = this._truncateToN(new BN$3(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature$1 = new signature(signature$1, 'hex');

  // Perform primitive values validation
  var r = signature$1.r;
  var s = signature$1.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);
  var p;

  if (!this.curve._maxwellTrick) {
    p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
  assert$5((3 & j) === j, 'The recovery param is more than two bits');
  signature$1 = new signature(signature$1, enc);

  var n = this.n;
  var e = new BN$3(msg);
  var r = signature$1.r;
  var s = signature$1.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature$1.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
  signature$1 = new signature(signature$1, enc);
  if (signature$1.recoveryParam !== null)
    return signature$1.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature$1, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};

var elliptic_1 = createCommonjsModule(function (module, exports) {

var elliptic = exports;

elliptic.version = /*RicMoo:ethers*/{ version: "6.5.4" }.version;
elliptic.utils = utils_1$1;
elliptic.rand = /*RicMoo:ethers:require(brorand)*/(function() { throw new Error('unsupported'); });
elliptic.curve = curve_1;
elliptic.curves = curves_1;

// Protocols
elliptic.ec = ec;
elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/(null);
});

var EC$1 = elliptic_1.ec;

const version$d = "signing-key/5.6.1";

const logger$g = new Logger$1(version$d);
let _curve = null;
function getCurve() {
    if (!_curve) {
        _curve = new EC$1("secp256k1");
    }
    return _curve;
}
class SigningKey {
    constructor(privateKey) {
        defineReadOnly(this, "curve", "secp256k1");
        defineReadOnly(this, "privateKey", hexlify(privateKey));
        if (hexDataLength(this.privateKey) !== 32) {
            logger$g.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        }
        const keyPair = getCurve().keyFromPrivate(arrayify$1(this.privateKey));
        defineReadOnly(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        defineReadOnly(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        defineReadOnly(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = getCurve().keyFromPublic(arrayify$1(this.publicKey));
        const p1 = getCurve().keyFromPublic(arrayify$1(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = getCurve().keyFromPrivate(arrayify$1(this.privateKey));
        const digestBytes = arrayify$1(digest);
        if (digestBytes.length !== 32) {
            logger$g.throwArgumentError("bad digest length", "digest", digest);
        }
        const signature = keyPair.sign(digestBytes, { canonical: true });
        return splitSignature({
            recoveryParam: signature.recoveryParam,
            r: hexZeroPad("0x" + signature.r.toString(16), 32),
            s: hexZeroPad("0x" + signature.s.toString(16), 32),
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = getCurve().keyFromPrivate(arrayify$1(this.privateKey));
        const otherKeyPair = getCurve().keyFromPublic(arrayify$1(computePublicKey(otherKey)));
        return hexZeroPad("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function recoverPublicKey(digest, signature) {
    const sig = splitSignature(signature);
    const rs = { r: arrayify$1(sig.r), s: arrayify$1(sig.s) };
    return "0x" + getCurve().recoverPubKey(arrayify$1(digest), rs, sig.recoveryParam).encode("hex", false);
}
function computePublicKey(key, compressed) {
    const bytes = arrayify$1(key);
    if (bytes.length === 32) {
        const signingKey = new SigningKey(bytes);
        if (compressed) {
            return "0x" + getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        }
        return signingKey.publicKey;
    }
    else if (bytes.length === 33) {
        if (compressed) {
            return hexlify(bytes);
        }
        return "0x" + getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    }
    else if (bytes.length === 65) {
        if (!compressed) {
            return hexlify(bytes);
        }
        return "0x" + getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return logger$g.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}

const version$c = "transactions/5.6.1";

const logger$f = new Logger$1(version$c);
var TransactionTypes;
(function (TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})(TransactionTypes || (TransactionTypes = {}));
///////////////////////////////
function handleAddress(value) {
    if (value === "0x") {
        return null;
    }
    return getAddress$1(value);
}
function handleNumber(value) {
    if (value === "0x") {
        return Zero$1;
    }
    return BigNumber$1.from(value);
}
function computeAddress(key) {
    const publicKey = computePublicKey(key);
    return getAddress$1(hexDataSlice(keccak256$1(hexDataSlice(publicKey, 1)), 12));
}
function recoverAddress(digest, signature) {
    return computeAddress(recoverPublicKey(arrayify$1(digest), signature));
}
function formatNumber(value, name) {
    const result = stripZeros(BigNumber$1.from(value).toHexString());
    if (result.length > 32) {
        logger$f.throwArgumentError("invalid length for " + name, ("transaction:" + name), value);
    }
    return result;
}
function accessSetify(addr, storageKeys) {
    return {
        address: getAddress$1(addr),
        storageKeys: (storageKeys || []).map((storageKey, index) => {
            if (hexDataLength(storageKey) !== 32) {
                logger$f.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            }
            return storageKey.toLowerCase();
        })
    };
}
function accessListify(value) {
    if (Array.isArray(value)) {
        return value.map((set, index) => {
            if (Array.isArray(set)) {
                if (set.length > 2) {
                    logger$f.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
                }
                return accessSetify(set[0], set[1]);
            }
            return accessSetify(set.address, set.storageKeys);
        });
    }
    const result = Object.keys(value).map((addr) => {
        const storageKeys = value[addr].reduce((accum, storageKey) => {
            accum[storageKey] = true;
            return accum;
        }, {});
        return accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b) => (a.address.localeCompare(b.address)));
    return result;
}
function formatAccessList(value) {
    return accessListify(value).map((set) => [set.address, set.storageKeys]);
}
function _serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = BigNumber$1.from(transaction.gasPrice);
        const maxFeePerGas = BigNumber$1.from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) {
            logger$f.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
                gasPrice, maxFeePerGas
            });
        }
    }
    const fields = [
        formatNumber(transaction.chainId || 0, "chainId"),
        formatNumber(transaction.nonce || 0, "nonce"),
        formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        formatNumber(transaction.gasLimit || 0, "gasLimit"),
        ((transaction.to != null) ? getAddress$1(transaction.to) : "0x"),
        formatNumber(transaction.value || 0, "value"),
        (transaction.data || "0x"),
        (formatAccessList(transaction.accessList || []))
    ];
    if (signature) {
        const sig = splitSignature(signature);
        fields.push(formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push(stripZeros(sig.r));
        fields.push(stripZeros(sig.s));
    }
    return hexConcat(["0x02", encode$f(fields)]);
}
function _serializeEip2930(transaction, signature) {
    const fields = [
        formatNumber(transaction.chainId || 0, "chainId"),
        formatNumber(transaction.nonce || 0, "nonce"),
        formatNumber(transaction.gasPrice || 0, "gasPrice"),
        formatNumber(transaction.gasLimit || 0, "gasLimit"),
        ((transaction.to != null) ? getAddress$1(transaction.to) : "0x"),
        formatNumber(transaction.value || 0, "value"),
        (transaction.data || "0x"),
        (formatAccessList(transaction.accessList || []))
    ];
    if (signature) {
        const sig = splitSignature(signature);
        fields.push(formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push(stripZeros(sig.r));
        fields.push(stripZeros(sig.s));
    }
    return hexConcat(["0x01", encode$f(fields)]);
}
function _parseEipSignature(tx, fields, serialize) {
    try {
        const recid = handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) {
            throw new Error("bad recid");
        }
        tx.v = recid;
    }
    catch (error) {
        logger$f.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = hexZeroPad(fields[1], 32);
    tx.s = hexZeroPad(fields[2], 32);
    try {
        const digest = keccak256$1(serialize(tx));
        tx.from = recoverAddress(digest, { r: tx.r, s: tx.s, recoveryParam: tx.v });
    }
    catch (error) { }
}
function _parseEip1559(payload) {
    const transaction = decode$e(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) {
        logger$f.throwArgumentError("invalid component count for transaction type: 2", "payload", hexlify(payload));
    }
    const maxPriorityFeePerGas = handleNumber(transaction[2]);
    const maxFeePerGas = handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: handleNumber(transaction[0]).toNumber(),
        nonce: handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: handleNumber(transaction[4]),
        to: handleAddress(transaction[5]),
        value: handleNumber(transaction[6]),
        data: transaction[7],
        accessList: accessListify(transaction[8]),
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) {
        return tx;
    }
    tx.hash = keccak256$1(payload);
    _parseEipSignature(tx, transaction.slice(9), _serializeEip1559);
    return tx;
}
function _parseEip2930(payload) {
    const transaction = decode$e(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) {
        logger$f.throwArgumentError("invalid component count for transaction type: 1", "payload", hexlify(payload));
    }
    const tx = {
        type: 1,
        chainId: handleNumber(transaction[0]).toNumber(),
        nonce: handleNumber(transaction[1]).toNumber(),
        gasPrice: handleNumber(transaction[2]),
        gasLimit: handleNumber(transaction[3]),
        to: handleAddress(transaction[4]),
        value: handleNumber(transaction[5]),
        data: transaction[6],
        accessList: accessListify(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) {
        return tx;
    }
    tx.hash = keccak256$1(payload);
    _parseEipSignature(tx, transaction.slice(8), _serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function _parse(rawTransaction) {
    const transaction = decode$e(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) {
        logger$f.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    }
    const tx = {
        nonce: handleNumber(transaction[0]).toNumber(),
        gasPrice: handleNumber(transaction[1]),
        gasLimit: handleNumber(transaction[2]),
        to: handleAddress(transaction[3]),
        value: handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) {
        return tx;
    }
    try {
        tx.v = BigNumber$1.from(transaction[6]).toNumber();
    }
    catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = hexZeroPad(transaction[7], 32);
    tx.s = hexZeroPad(transaction[8], 32);
    if (BigNumber$1.from(tx.r).isZero() && BigNumber$1.from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    }
    else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) {
            tx.chainId = 0;
        }
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push(hexlify(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = keccak256$1(encode$f(raw));
        try {
            tx.from = recoverAddress(digest, { r: hexlify(tx.r), s: hexlify(tx.s), recoveryParam: recoveryParam });
        }
        catch (error) { }
        tx.hash = keccak256$1(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function parse$8(rawTransaction) {
    const payload = arrayify$1(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) {
        return _parse(payload);
    }
    // Typed Transaction (EIP-2718)
    switch (payload[0]) {
        case 1:
            return _parseEip2930(payload);
        case 2:
            return _parseEip1559(payload);
    }
    return logger$f.throwError(`unsupported transaction type: ${payload[0]}`, Logger$1.errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}

const logger$e = new Logger$1(version$e);
class Formatter {
    constructor() {
        logger$e.checkNew(new.target, Formatter);
        this.formats = this.getDefaultFormats();
    }
    getDefaultFormats() {
        const formats = ({});
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v) => { return this.data(v, true); };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: Formatter.allowNull(this.accessList.bind(this), null),
            blockHash: Formatter.allowNull(hash, null),
            blockNumber: Formatter.allowNull(number, null),
            transactionIndex: Formatter.allowNull(number, null),
            confirmations: Formatter.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: Formatter.allowNull(bigNumber),
            maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
            maxFeePerGas: Formatter.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: Formatter.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: Formatter.allowNull(this.uint256),
            s: Formatter.allowNull(this.uint256),
            v: Formatter.allowNull(number),
            creates: Formatter.allowNull(address, null),
            raw: Formatter.allowNull(data),
        };
        formats.transactionRequest = {
            from: Formatter.allowNull(address),
            nonce: Formatter.allowNull(number),
            gasLimit: Formatter.allowNull(bigNumber),
            gasPrice: Formatter.allowNull(bigNumber),
            maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
            maxFeePerGas: Formatter.allowNull(bigNumber),
            to: Formatter.allowNull(address),
            value: Formatter.allowNull(bigNumber),
            data: Formatter.allowNull(strictData),
            type: Formatter.allowNull(number),
            accessList: Formatter.allowNull(this.accessList.bind(this), null),
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: Formatter.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash,
        };
        formats.receipt = {
            to: Formatter.allowNull(this.address, null),
            from: Formatter.allowNull(this.address, null),
            contractAddress: Formatter.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: Formatter.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: Formatter.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: Formatter.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: Formatter.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: Formatter.allowNull(bigNumber),
            status: Formatter.allowNull(number),
            type: type
        };
        formats.block = {
            hash: Formatter.allowNull(hash),
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: Formatter.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: Formatter.allowNull(address),
            extraData: data,
            transactions: Formatter.allowNull(Formatter.arrayOf(hash)),
            baseFeePerGas: Formatter.allowNull(bigNumber)
        };
        formats.blockWithTransactions = shallowCopy(formats.block);
        formats.blockWithTransactions.transactions = Formatter.allowNull(Formatter.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: Formatter.allowNull(blockTag, undefined),
            toBlock: Formatter.allowNull(blockTag, undefined),
            blockHash: Formatter.allowNull(hash, undefined),
            address: Formatter.allowNull(address, undefined),
            topics: Formatter.allowNull(this.topics.bind(this), undefined),
        };
        formats.filterLog = {
            blockNumber: Formatter.allowNull(number),
            blockHash: Formatter.allowNull(hash),
            transactionIndex: number,
            removed: Formatter.allowNull(this.boolean.bind(this)),
            address: address,
            data: Formatter.allowFalsish(data, "0x"),
            topics: Formatter.arrayOf(hash),
            transactionHash: hash,
            logIndex: number,
        };
        return formats;
    }
    accessList(accessList) {
        return accessListify(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") {
            return 0;
        }
        return BigNumber$1.from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) {
            return 0;
        }
        return BigNumber$1.from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return BigNumber$1.from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof (value) === "boolean") {
            return value;
        }
        if (typeof (value) === "string") {
            value = value.toLowerCase();
            if (value === "true") {
                return true;
            }
            if (value === "false") {
                return false;
            }
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof (value) === "string") {
            if (!strict && value.substring(0, 2) !== "0x") {
                value = "0x" + value;
            }
            if (isHexString$1(value)) {
                return value.toLowerCase();
            }
        }
        return logger$e.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if ((result.length % 2) !== 0) {
            throw new Error("invalid data; odd-length - " + value);
        }
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return getAddress$1(value);
    }
    callAddress(value) {
        if (!isHexString$1(value, 32)) {
            return null;
        }
        const address = getAddress$1(hexDataSlice(value, 12));
        return (address === AddressZero) ? null : address;
    }
    contractAddress(value) {
        return getContractAddress(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) {
            return "latest";
        }
        if (blockTag === "earliest") {
            return "0x0";
        }
        if (blockTag === "latest" || blockTag === "pending") {
            return blockTag;
        }
        if (typeof (blockTag) === "number" || isHexString$1(blockTag)) {
            return hexValue(blockTag);
        }
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if (hexDataLength(result) !== 32) {
            return logger$e.throwArgumentError("invalid hash", "value", value);
        }
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) {
            return null;
        }
        const v = BigNumber$1.from(value);
        try {
            return v.toNumber();
        }
        catch (error) { }
        return null;
    }
    uint256(value) {
        if (!isHexString$1(value)) {
            throw new Error("invalid uint256");
        }
        return hexZeroPad(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) {
            value.miner = value.author;
        }
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = (value._difficulty != null) ? value._difficulty : value.difficulty;
        const result = Formatter.check(format, value);
        result._difficulty = ((difficulty == null) ? null : BigNumber$1.from(difficulty));
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return Formatter.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) {
            transaction.gasLimit = transaction.gas;
        }
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && BigNumber$1.from(transaction.to).isZero()) {
            transaction.to = "0x0000000000000000000000000000000000000000";
        }
        // Rename input to data
        if (transaction.input != null && transaction.data == null) {
            transaction.data = transaction.input;
        }
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) {
            transaction.creates = this.contractAddress(transaction);
        }
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) {
            transaction.accessList = [];
        }
        const result = Formatter.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if (isHexString$1(chainId)) {
                chainId = BigNumber$1.from(chainId).toNumber();
            }
            result.chainId = chainId;
        }
        else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) {
                chainId = transaction.chainId;
            }
            if (isHexString$1(chainId)) {
                chainId = BigNumber$1.from(chainId).toNumber();
            }
            if (typeof (chainId) !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) {
                    chainId = 0;
                }
                chainId = parseInt(chainId);
            }
            if (typeof (chainId) !== "number") {
                chainId = 0;
            }
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") {
            result.blockHash = null;
        }
        return result;
    }
    transaction(value) {
        return parse$8(value);
    }
    receiptLog(value) {
        return Formatter.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = Formatter.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = BigNumber$1.from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && (result.status !== value)) {
                        logger$e.throwArgumentError("alt-root-status/status mismatch", "value", { root: result.root, status: result.status });
                    }
                    result.status = value;
                    delete result.root;
                }
                else {
                    logger$e.throwArgumentError("invalid alt-root-status", "value.root", result.root);
                }
            }
            else if (result.root.length !== 66) {
                // Must be a valid bytes32
                logger$e.throwArgumentError("invalid root hash", "value.root", result.root);
            }
        }
        if (result.status != null) {
            result.byzantium = true;
        }
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) {
            return value.map((v) => this.topics(v));
        }
        else if (value != null) {
            return this.hash(value, true);
        }
        return null;
    }
    filter(value) {
        return Formatter.check(this.formats.filter, value);
    }
    filterLog(value) {
        return Formatter.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for (const key in format) {
            try {
                const value = format[key](object[key]);
                if (value !== undefined) {
                    result[key] = value;
                }
            }
            catch (error) {
                error.checkKey = key;
                error.checkValue = object[key];
                throw error;
            }
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return (function (value) {
            if (value == null) {
                return nullValue;
            }
            return format(value);
        });
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return (function (value) {
            if (!value) {
                return replaceValue;
            }
            return format(value);
        });
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return (function (array) {
            if (!Array.isArray(array)) {
                throw new Error("not an array");
            }
            const result = [];
            array.forEach(function (value) {
                result.push(format(value));
            });
            return result;
        });
    }
}

var __awaiter$4 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const logger$d = new Logger$1(version$e);
const MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function checkTopic(topic) {
    if (topic == null) {
        return "null";
    }
    if (hexDataLength(topic) !== 32) {
        logger$d.throwArgumentError("invalid topic", "topic", topic);
    }
    return topic.toLowerCase();
}
function serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while (topics.length > 0 && topics[topics.length - 1] == null) {
        topics.pop();
    }
    return topics.map((topic) => {
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic) => {
                unique[checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        }
        else {
            return checkTopic(topic);
        }
    }).join("&");
}
function deserializeTopics(data) {
    if (data === "") {
        return [];
    }
    return data.split(/&/g).map((topic) => {
        if (topic === "") {
            return [];
        }
        const comps = topic.split("|").map((topic) => {
            return ((topic === "null") ? null : topic);
        });
        return ((comps.length === 1) ? comps[0] : comps);
    });
}
function getEventTag$1(eventName) {
    if (typeof (eventName) === "string") {
        eventName = eventName.toLowerCase();
        if (hexDataLength(eventName) === 32) {
            return "tx:" + eventName;
        }
        if (eventName.indexOf(":") === -1) {
            return eventName;
        }
    }
    else if (Array.isArray(eventName)) {
        return "filter:*:" + serializeTopics(eventName);
    }
    else if (ForkEvent.isForkEvent(eventName)) {
        logger$d.warn("not implemented");
        throw new Error("not implemented");
    }
    else if (eventName && typeof (eventName) === "object") {
        return "filter:" + (eventName.address || "*") + ":" + serializeTopics(eventName.topics || []);
    }
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function getTime() {
    return (new Date()).getTime();
}
function stall(duration) {
    return new Promise((resolve) => {
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */
const PollableEvents = ["block", "network", "pending", "poll"];
class Event {
    constructor(tag, listener, once) {
        defineReadOnly(this, "tag", tag);
        defineReadOnly(this, "listener", listener);
        defineReadOnly(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    get event() {
        switch (this.type) {
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") {
            return null;
        }
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") {
            return null;
        }
        const address = comps[1];
        const topics = deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) {
            filter.topics = topics;
        }
        if (address && address !== "*") {
            filter.address = address;
        }
        return filter;
    }
    pollable() {
        return (this.tag.indexOf(":") >= 0 || PollableEvents.indexOf(this.tag) >= 0);
    }
}
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const coinInfos = {
    "0": { symbol: "btc", p2pkh: 0x00, p2sh: 0x05, prefix: "bc" },
    "2": { symbol: "ltc", p2pkh: 0x30, p2sh: 0x32, prefix: "ltc" },
    "3": { symbol: "doge", p2pkh: 0x1e, p2sh: 0x16 },
    "60": { symbol: "eth", ilk: "eth" },
    "61": { symbol: "etc", ilk: "eth" },
    "700": { symbol: "xdai", ilk: "eth" },
};
function bytes32ify(value) {
    return hexZeroPad(BigNumber$1.from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function base58Encode(data) {
    return Base58.encode(concat$4([data, hexDataSlice(sha256$1(sha256$1(data)), 0, 4)]));
}
const matcherIpfs = new RegExp("^(ipfs):/\/(.*)$", "i");
const matchers = [
    new RegExp("^(https):/\/(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i"),
];
function _parseString(result, start) {
    try {
        return toUtf8String(_parseBytes(result, start));
    }
    catch (error) { }
    return null;
}
function _parseBytes(result, start) {
    if (result === "0x") {
        return null;
    }
    const offset = BigNumber$1.from(hexDataSlice(result, start, start + 32)).toNumber();
    const length = BigNumber$1.from(hexDataSlice(result, offset, offset + 32)).toNumber();
    return hexDataSlice(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) {
        link = link.substring(12);
    }
    else if (link.match(/^ipfs:\/\//i)) {
        link = link.substring(7);
    }
    else {
        logger$d.throwArgumentError("unsupported IPFS format", "link", link);
    }
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
function numPad(value) {
    const result = arrayify$1(value);
    if (result.length > 32) {
        throw new Error("internal; should not happen");
    }
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function bytesPad(value) {
    if ((value.length % 32) === 0) {
        return value;
    }
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for (let i = 0; i < datas.length; i++) {
        result.push(null);
        byteCount += 32;
    }
    for (let i = 0; i < datas.length; i++) {
        const data = arrayify$1(datas[i]);
        // Update the bytes offset
        result[i] = numPad(byteCount);
        // The length and padded value of data
        result.push(numPad(data.length));
        result.push(bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return hexConcat(result);
}
class Resolver {
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress) {
        defineReadOnly(this, "provider", provider);
        defineReadOnly(this, "name", name);
        defineReadOnly(this, "address", provider.formatter.address(address));
        defineReadOnly(this, "_resolvedAddress", resolvedAddress);
    }
    supportsWildcard() {
        if (!this._supportsEip2544) {
            // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
            this._supportsEip2544 = this.provider.call({
                to: this.address,
                data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
            }).then((result) => {
                return BigNumber$1.from(result).eq(1);
            }).catch((error) => {
                if (error.code === Logger$1.errors.CALL_EXCEPTION) {
                    return false;
                }
                // Rethrow the error: link is down, etc. Let future attempts retry.
                this._supportsEip2544 = null;
                throw error;
            });
        }
        return this._supportsEip2544;
    }
    _fetch(selector, parameters) {
        return __awaiter$4(this, void 0, void 0, function* () {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                ccipReadEnabled: true,
                data: hexConcat([selector, namehash(this.name), (parameters || "0x")])
            };
            // Wildcard support; use EIP-2544 to resolve the request
            let parseBytes = false;
            if (yield this.supportsWildcard()) {
                parseBytes = true;
                // selector("resolve(bytes,bytes)")
                tx.data = hexConcat(["0x9061b923", encodeBytes([dnsEncode(this.name), tx.data])]);
            }
            try {
                let result = yield this.provider.call(tx);
                if ((arrayify$1(result).length % 32) === 4) {
                    logger$d.throwError("resolver threw error", Logger$1.errors.CALL_EXCEPTION, {
                        transaction: tx, data: result
                    });
                }
                if (parseBytes) {
                    result = _parseBytes(result, 0);
                }
                return result;
            }
            catch (error) {
                if (error.code === Logger$1.errors.CALL_EXCEPTION) {
                    return null;
                }
                throw error;
            }
        });
    }
    _fetchBytes(selector, parameters) {
        return __awaiter$4(this, void 0, void 0, function* () {
            const result = yield this._fetch(selector, parameters);
            if (result != null) {
                return _parseBytes(result, 0);
            }
            return null;
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = coinInfos[String(coinType)];
        if (coinInfo == null) {
            logger$d.throwError(`unsupported coin type: ${coinType}`, Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`
            });
        }
        if (coinInfo.ilk === "eth") {
            return this.provider.formatter.address(hexBytes);
        }
        const bytes = arrayify$1(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) {
                    return base58Encode(concat$4([[coinInfo.p2pkh], ("0x" + p2pkh[2])]));
                }
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) {
                    return base58Encode(concat$4([[coinInfo.p2sh], ("0x" + p2sh[2])]));
                }
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) {
                    version = -1;
                }
            }
            else {
                version = -1;
            }
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = bech32.toWords(bytes.slice(2));
                words.unshift(version);
                return bech32.encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return __awaiter$4(this, void 0, void 0, function* () {
            if (coinType == null) {
                coinType = 60;
            }
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) {
                try {
                    // keccak256("addr(bytes32)")
                    const result = yield this._fetch("0x3b3b57de");
                    // No address
                    if (result === "0x" || result === HashZero) {
                        return null;
                    }
                    return this.provider.formatter.callAddress(result);
                }
                catch (error) {
                    if (error.code === Logger$1.errors.CALL_EXCEPTION) {
                        return null;
                    }
                    throw error;
                }
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") {
                return null;
            }
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) {
                logger$d.throwError(`invalid or unsupported coin data`, Logger$1.errors.UNSUPPORTED_OPERATION, {
                    operation: `getAddress(${coinType})`,
                    coinType: coinType,
                    data: hexBytes
                });
            }
            return address;
        });
    }
    getAvatar() {
        return __awaiter$4(this, void 0, void 0, function* () {
            const linkage = [{ type: "name", content: this.name }];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) {
                    return null;
                }
                for (let i = 0; i < matchers.length; i++) {
                    const match = avatar.match(matchers[i]);
                    if (match == null) {
                        continue;
                    }
                    const scheme = match[1].toLowerCase();
                    switch (scheme) {
                        case "https":
                            linkage.push({ type: "url", content: avatar });
                            return { linkage, url: avatar };
                        case "data":
                            linkage.push({ type: "data", content: avatar });
                            return { linkage, url: avatar };
                        case "ipfs":
                            linkage.push({ type: "ipfs", content: avatar });
                            return { linkage, url: getIpfsLink(avatar) };
                        case "erc721":
                        case "erc1155": {
                            // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                            const selector = (scheme === "erc721") ? "0xc87b56dd" : "0x0e89341c";
                            linkage.push({ type: scheme, content: avatar });
                            // The owner of this name
                            const owner = (this._resolvedAddress || (yield this.getAddress()));
                            const comps = (match[2] || "").split("/");
                            if (comps.length !== 2) {
                                return null;
                            }
                            const addr = yield this.provider.formatter.address(comps[0]);
                            const tokenId = hexZeroPad(BigNumber$1.from(comps[1]).toHexString(), 32);
                            // Check that this account owns the token
                            if (scheme === "erc721") {
                                // ownerOf(uint256 tokenId)
                                const tokenOwner = this.provider.formatter.callAddress(yield this.provider.call({
                                    to: addr, data: hexConcat(["0x6352211e", tokenId])
                                }));
                                if (owner !== tokenOwner) {
                                    return null;
                                }
                                linkage.push({ type: "owner", content: tokenOwner });
                            }
                            else if (scheme === "erc1155") {
                                // balanceOf(address owner, uint256 tokenId)
                                const balance = BigNumber$1.from(yield this.provider.call({
                                    to: addr, data: hexConcat(["0x00fdd58e", hexZeroPad(owner, 32), tokenId])
                                }));
                                if (balance.isZero()) {
                                    return null;
                                }
                                linkage.push({ type: "balance", content: balance.toString() });
                            }
                            // Call the token contract for the metadata URL
                            const tx = {
                                to: this.provider.formatter.address(comps[0]),
                                data: hexConcat([selector, tokenId])
                            };
                            let metadataUrl = _parseString(yield this.provider.call(tx), 0);
                            if (metadataUrl == null) {
                                return null;
                            }
                            linkage.push({ type: "metadata-url-base", content: metadataUrl });
                            // ERC-1155 allows a generic {id} in the URL
                            if (scheme === "erc1155") {
                                metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                linkage.push({ type: "metadata-url-expanded", content: metadataUrl });
                            }
                            // Transform IPFS metadata links
                            if (metadataUrl.match(/^ipfs:/i)) {
                                metadataUrl = getIpfsLink(metadataUrl);
                            }
                            linkage.push({ type: "metadata-url", content: metadataUrl });
                            // Get the token metadata
                            const metadata = yield fetchJson(metadataUrl);
                            if (!metadata) {
                                return null;
                            }
                            linkage.push({ type: "metadata", content: JSON.stringify(metadata) });
                            // Pull the image URL out
                            let imageUrl = metadata.image;
                            if (typeof (imageUrl) !== "string") {
                                return null;
                            }
                            if (imageUrl.match(/^(https:\/\/|data:)/i)) {
                                // Allow
                            }
                            else {
                                // Transform IPFS link to gateway
                                const ipfs = imageUrl.match(matcherIpfs);
                                if (ipfs == null) {
                                    return null;
                                }
                                linkage.push({ type: "url-ipfs", content: imageUrl });
                                imageUrl = getIpfsLink(imageUrl);
                            }
                            linkage.push({ type: "url", content: imageUrl });
                            return { linkage, url: imageUrl };
                        }
                    }
                }
            }
            catch (error) { }
            return null;
        });
    }
    getContentHash() {
        return __awaiter$4(this, void 0, void 0, function* () {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") {
                return null;
            }
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) {
                    return "ipfs:/\/" + Base58.encode("0x" + ipfs[1]);
                }
            }
            // IPNS (CID: 1, Type: libp2p-key)
            const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipns) {
                const length = parseInt(ipns[3], 16);
                if (ipns[4].length === length * 2) {
                    return "ipns:/\/" + Base58.encode("0x" + ipns[1]);
                }
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === (32 * 2)) {
                    return "bzz:/\/" + swarm[1];
                }
            }
            return logger$d.throwError(`invalid or unsupported content hash data`, Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return __awaiter$4(this, void 0, void 0, function* () {
            // The key encoded as parameter to fetchBytes
            let keyBytes = toUtf8Bytes(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = concat$4([bytes32ify(64), bytes32ify(keyBytes.length), keyBytes]);
            // Pad to word-size (32 bytes)
            if ((keyBytes.length % 32) !== 0) {
                keyBytes = concat$4([keyBytes, hexZeroPad("0x", 32 - (key.length % 32))]);
            }
            const hexBytes = yield this._fetchBytes("0x59d1d43c", hexlify(keyBytes));
            if (hexBytes == null || hexBytes === "0x") {
                return null;
            }
            return toUtf8String(hexBytes);
        });
    }
}
let defaultFormatter$1 = null;
let nextPollId = 1;
class BaseProvider extends Provider {
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */
    constructor(network) {
        logger$d.checkNew(new.target, Provider);
        super();
        // Events being listened to
        this._events = [];
        this._emitted = { block: -2 };
        this.disableCcipRead = false;
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        defineReadOnly(this, "anyNetwork", (network === "any"));
        if (this.anyNetwork) {
            network = this.detectNetwork();
        }
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error) => { });
            // Trigger initial network setting (async)
            this._ready().catch((error) => { });
        }
        else {
            const knownNetwork = getStatic(new.target, "getNetwork")(network);
            if (knownNetwork) {
                defineReadOnly(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            }
            else {
                logger$d.throwArgumentError("invalid network", "network", network);
            }
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._maxFilterBlockRange = 10;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
    _ready() {
        return __awaiter$4(this, void 0, void 0, function* () {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) {
                    try {
                        network = yield this._networkPromise;
                    }
                    catch (error) { }
                }
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) {
                    network = yield this.detectNetwork();
                }
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) {
                    logger$d.throwError("no network detected", Logger$1.errors.UNKNOWN_ERROR, {});
                }
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) {
                        this._network = network;
                    }
                    else {
                        defineReadOnly(this, "_network", network);
                    }
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return poll(() => {
            return this._ready().then((network) => {
                return network;
            }, (error) => {
                // If the network isn't running yet, we will wait
                if (error.code === Logger$1.errors.NETWORK_ERROR && error.event === "noNetwork") {
                    return undefined;
                }
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if (defaultFormatter$1 == null) {
            defaultFormatter$1 = new Formatter();
        }
        return defaultFormatter$1;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return getNetwork((network == null) ? "homestead" : network);
    }
    ccipReadFetch(tx, calldata, urls) {
        return __awaiter$4(this, void 0, void 0, function* () {
            if (this.disableCcipRead || urls.length === 0) {
                return null;
            }
            const sender = tx.to.toLowerCase();
            const data = calldata.toLowerCase();
            const errorMessages = [];
            for (let i = 0; i < urls.length; i++) {
                const url = urls[i];
                // URL expansion
                const href = url.replace("{sender}", sender).replace("{data}", data);
                // If no {data} is present, use POST; otherwise GET
                const json = (url.indexOf("{data}") >= 0) ? null : JSON.stringify({ data, sender });
                const result = yield fetchJson({ url: href, errorPassThrough: true }, json, (value, response) => {
                    value.status = response.statusCode;
                    return value;
                });
                if (result.data) {
                    return result.data;
                }
                const errorMessage = (result.message || "unknown error");
                // 4xx indicates the result is not present; stop
                if (result.status >= 400 && result.status < 500) {
                    return logger$d.throwError(`response not found during CCIP fetch: ${errorMessage}`, Logger$1.errors.SERVER_ERROR, { url, errorMessage });
                }
                // 5xx indicates server issue; try the next url
                errorMessages.push(errorMessage);
            }
            return logger$d.throwError(`error encountered during CCIP fetch: ${errorMessages.map((m) => JSON.stringify(m)).join(", ")}`, Logger$1.errors.SERVER_ERROR, {
                urls, errorMessages
            });
        });
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) {
                // While there are pending internal block requests...
                while (this._internalBlockNumber) {
                    // ..."remember" which fetch we started with
                    const internalBlockNumber = this._internalBlockNumber;
                    try {
                        // Check the result is not too stale
                        const result = yield internalBlockNumber;
                        if ((getTime() - result.respTime) <= maxAge) {
                            return result.blockNumber;
                        }
                        // Too old; fetch a new value
                        break;
                    }
                    catch (error) {
                        // The fetch rejected; if we are the first to get the
                        // rejection, drop through so we replace it with a new
                        // fetch; all others blocked will then get that fetch
                        // which won't match the one they "remembered" and loop
                        if (this._internalBlockNumber === internalBlockNumber) {
                            break;
                        }
                    }
                }
            }
            const reqTime = getTime();
            const checkInternalBlockNumber = resolveProperties({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network) => (null), (error) => (error))
            }).then(({ blockNumber, networkError }) => {
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) {
                        this._internalBlockNumber = null;
                    }
                    throw networkError;
                }
                const respTime = getTime();
                blockNumber = BigNumber$1.from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) {
                    blockNumber = this._maxInternalBlockNumber;
                }
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return { blockNumber, reqTime, respTime };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error) => {
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) {
                    this._internalBlockNumber = null;
                }
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return __awaiter$4(this, void 0, void 0, function* () {
            const pollId = nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            }
            catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) {
                this._emitted.block = blockNumber - 1;
            }
            if (Math.abs((this._emitted.block) - blockNumber) > 1000) {
                logger$d.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", logger$d.makeError("network block skew detected", Logger$1.errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            }
            else {
                // Notify all listener for each block that has passed
                for (let i = this._emitted.block + 1; i <= blockNumber; i++) {
                    this.emit("block", i);
                }
            }
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key) => {
                    // The block event does not expire
                    if (key === "block") {
                        return;
                    }
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") {
                        return;
                    }
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) {
                        delete this._emitted[key];
                    }
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) {
                this._lastBlockNumber = blockNumber - 1;
            }
            // Find all transaction hashes we are waiting on
            this._events.forEach((event) => {
                switch (event.type) {
                    case "tx": {
                        const hash = event.hash;
                        let runner = this.getTransactionReceipt(hash).then((receipt) => {
                            if (!receipt || receipt.blockNumber == null) {
                                return null;
                            }
                            this._emitted["t:" + hash] = receipt.blockNumber;
                            this.emit(hash, receipt);
                            return null;
                        }).catch((error) => { this.emit("error", error); });
                        runners.push(runner);
                        break;
                    }
                    case "filter": {
                        // We only allow a single getLogs to be in-flight at a time
                        if (!event._inflight) {
                            event._inflight = true;
                            // Filter from the last known event; due to load-balancing
                            // and some nodes returning updated block numbers before
                            // indexing events, a logs result with 0 entries cannot be
                            // trusted and we must retry a range which includes it again
                            const filter = event.filter;
                            filter.fromBlock = event._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            // Prevent fitler ranges from growing too wild
                            if (filter.toBlock - this._maxFilterBlockRange > filter.fromBlock) {
                                filter.fromBlock = filter.toBlock - this._maxFilterBlockRange;
                            }
                            const runner = this.getLogs(filter).then((logs) => {
                                // Allow the next getLogs
                                event._inflight = false;
                                if (logs.length === 0) {
                                    return;
                                }
                                logs.forEach((log) => {
                                    // Only when we get an event for a given block number
                                    // can we trust the events are indexed
                                    if (log.blockNumber > event._lastBlockNumber) {
                                        event._lastBlockNumber = log.blockNumber;
                                    }
                                    // Make sure we stall requests to fetch blocks and txs
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error) => {
                                this.emit("error", error);
                                // Allow another getLogs (the range was not updated)
                                event._inflight = false;
                            });
                            runners.push(runner);
                        }
                        break;
                    }
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(() => {
                this.emit("didPoll", pollId);
            }).catch((error) => { this.emit("error", error); });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) {
            this.poll();
        }
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return __awaiter$4(this, void 0, void 0, function* () {
            return logger$d.throwError("provider does not support network detection", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return __awaiter$4(this, void 0, void 0, function* () {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield stall(0);
                    return this._network;
                }
                const error = logger$d.makeError("underlying network changed", Logger$1.errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber) => {
            this._setFastBlockNumber(blockNumber);
        }, (error) => { });
        return (this._fastBlockNumber != null) ? this._fastBlockNumber : -1;
    }
    get polling() {
        return (this._poller != null);
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(() => { this.poll(); }, this.pollingInterval);
            if (!this._bootstrapPoll) {
                this._bootstrapPoll = setTimeout(() => {
                    this.poll();
                    // We block additional polls until the polling interval
                    // is done, to prevent overwhelming the poll function
                    this._bootstrapPoll = setTimeout(() => {
                        // If polling was disabled, something may require a poke
                        // since starting the bootstrap poll and it was disabled
                        if (!this._poller) {
                            this.poll();
                        }
                        // Clear out the bootstrap so we can do another
                        this._bootstrapPoll = null;
                    }, this.pollingInterval);
                }, 0);
            }
        }
        else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof (value) !== "number" || value <= 0 || parseInt(String(value)) != value) {
            throw new Error("invalid polling interval");
        }
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(() => { this.poll(); }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = getTime();
        // Stale block number, request a newer value
        if ((now - this._fastQueryDate) > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber) => {
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
                    this._fastBlockNumber = blockNumber;
                }
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) {
            return;
        }
        // Update the time we updated the blocknumber
        this._fastQueryDate = getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return __awaiter$4(this, void 0, void 0, function* () {
            return this._waitForTransaction(transactionHash, (confirmations == null) ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return __awaiter$4(this, void 0, void 0, function* () {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) {
                return receipt;
            }
            // Poll until the receipt is good...
            return new Promise((resolve, reject) => {
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function () {
                    if (done) {
                        return true;
                    }
                    done = true;
                    cancelFuncs.forEach((func) => { func(); });
                    return false;
                };
                const minedHandler = (receipt) => {
                    if (receipt.confirmations < confirmations) {
                        return;
                    }
                    if (alreadyDone()) {
                        return;
                    }
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(() => { this.removeListener(transactionHash, minedHandler); });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber) => __awaiter$4(this, void 0, void 0, function* () {
                        if (done) {
                            return;
                        }
                        // Wait 1 second; this is only used in the case of a fault, so
                        // we will trade off a little bit of latency for more consistent
                        // results and fewer JSON-RPC calls
                        yield stall(1000);
                        this.getTransactionCount(replaceable.from).then((nonce) => __awaiter$4(this, void 0, void 0, function* () {
                            if (done) {
                                return;
                            }
                            if (nonce <= replaceable.nonce) {
                                lastBlockNumber = blockNumber;
                            }
                            else {
                                // First check if the transaction was mined
                                {
                                    const mined = yield this.getTransaction(transactionHash);
                                    if (mined && mined.blockNumber != null) {
                                        return;
                                    }
                                }
                                // First time scanning. We start a little earlier for some
                                // wiggle room here to handle the eventually consistent nature
                                // of blockchain (e.g. the getTransactionCount was for a
                                // different block)
                                if (scannedBlock == null) {
                                    scannedBlock = lastBlockNumber - 3;
                                    if (scannedBlock < replaceable.startBlock) {
                                        scannedBlock = replaceable.startBlock;
                                    }
                                }
                                while (scannedBlock <= blockNumber) {
                                    if (done) {
                                        return;
                                    }
                                    const block = yield this.getBlockWithTransactions(scannedBlock);
                                    for (let ti = 0; ti < block.transactions.length; ti++) {
                                        const tx = block.transactions[ti];
                                        // Successfully mined!
                                        if (tx.hash === transactionHash) {
                                            return;
                                        }
                                        // Matches our transaction from and nonce; its a replacement
                                        if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                            if (done) {
                                                return;
                                            }
                                            // Get the receipt of the replacement
                                            const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                            // Already resolved or rejected (prolly a timeout)
                                            if (alreadyDone()) {
                                                return;
                                            }
                                            // The reason we were replaced
                                            let reason = "replaced";
                                            if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) {
                                                reason = "repriced";
                                            }
                                            else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) {
                                                reason = "cancelled";
                                            }
                                            // Explain why we were replaced
                                            reject(logger$d.makeError("transaction was replaced", Logger$1.errors.TRANSACTION_REPLACED, {
                                                cancelled: (reason === "replaced" || reason === "cancelled"),
                                                reason,
                                                replacement: this._wrapTransaction(tx),
                                                hash: transactionHash,
                                                receipt
                                            }));
                                            return;
                                        }
                                    }
                                    scannedBlock++;
                                }
                            }
                            if (done) {
                                return;
                            }
                            this.once("block", replaceHandler);
                        }), (error) => {
                            if (done) {
                                return;
                            }
                            this.once("block", replaceHandler);
                        });
                    });
                    if (done) {
                        return;
                    }
                    this.once("block", replaceHandler);
                    cancelFuncs.push(() => {
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof (timeout) === "number" && timeout > 0) {
                    const timer = setTimeout(() => {
                        if (alreadyDone()) {
                            return;
                        }
                        reject(logger$d.makeError("timeout exceeded", Logger$1.errors.TIMEOUT, { timeout: timeout }));
                    }, timeout);
                    if (timer.unref) {
                        timer.unref();
                    }
                    cancelFuncs.push(() => { clearTimeout(timer); });
                }
            });
        });
    }
    getBlockNumber() {
        return __awaiter$4(this, void 0, void 0, function* () {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return BigNumber$1.from(result);
            }
            catch (error) {
                return logger$d.throwError("bad result from backend", Logger$1.errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result, error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield resolveProperties({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return BigNumber$1.from(result);
            }
            catch (error) {
                return logger$d.throwError("bad result from backend", Logger$1.errors.SERVER_ERROR, {
                    method: "getBalance",
                    params, result, error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield resolveProperties({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return BigNumber$1.from(result).toNumber();
            }
            catch (error) {
                return logger$d.throwError("bad result from backend", Logger$1.errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params, result, error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield resolveProperties({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return hexlify(result);
            }
            catch (error) {
                return logger$d.throwError("bad result from backend", Logger$1.errors.SERVER_ERROR, {
                    method: "getCode",
                    params, result, error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield resolveProperties({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p) => hexValue(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return hexlify(result);
            }
            catch (error) {
                return logger$d.throwError("bad result from backend", Logger$1.errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params, result, error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && hexDataLength(hash) !== 32) {
            throw new Error("invalid response - sendTransaction");
        }
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) {
            logger$d.throwError("Transaction hash mismatch from Provider.sendTransaction.", Logger$1.errors.UNKNOWN_ERROR, { expectedHash: tx.hash, returnedHash: hash });
        }
        result.wait = (confirms, timeout) => __awaiter$4(this, void 0, void 0, function* () {
            if (confirms == null) {
                confirms = 1;
            }
            if (timeout == null) {
                timeout = 0;
            }
            // Get the details to detect replacement
            let replacement = undefined;
            if (confirms !== 0 && startBlock != null) {
                replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock
                };
            }
            const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
            if (receipt == null && confirms === 0) {
                return null;
            }
            // No longer pending, allow the polling loop to garbage collect this
            this._emitted["t:" + tx.hash] = receipt.blockNumber;
            if (receipt.status === 0) {
                logger$d.throwError("transaction failed", Logger$1.errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
            }
            return receipt;
        });
        return result;
    }
    sendTransaction(signedTransaction) {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then(t => hexlify(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) {
                tx.confirmations = 0;
            }
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", { signedTransaction: hexTx });
                return this._wrapTransaction(tx, hash, blockNumber);
            }
            catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return __awaiter$4(this, void 0, void 0, function* () {
            const values = yield transaction;
            const tx = {};
            ["from", "to"].forEach((key) => {
                if (values[key] == null) {
                    return;
                }
                tx[key] = Promise.resolve(values[key]).then((v) => (v ? this._getAddress(v) : null));
            });
            ["gasLimit", "gasPrice", "maxFeePerGas", "maxPriorityFeePerGas", "value"].forEach((key) => {
                if (values[key] == null) {
                    return;
                }
                tx[key] = Promise.resolve(values[key]).then((v) => (v ? BigNumber$1.from(v) : null));
            });
            ["type"].forEach((key) => {
                if (values[key] == null) {
                    return;
                }
                tx[key] = Promise.resolve(values[key]).then((v) => ((v != null) ? v : null));
            });
            if (values.accessList) {
                tx.accessList = this.formatter.accessList(values.accessList);
            }
            ["data"].forEach((key) => {
                if (values[key] == null) {
                    return;
                }
                tx[key] = Promise.resolve(values[key]).then((v) => (v ? hexlify(v) : null));
            });
            return this.formatter.transactionRequest(yield resolveProperties(tx));
        });
    }
    _getFilter(filter) {
        return __awaiter$4(this, void 0, void 0, function* () {
            filter = yield filter;
            const result = {};
            if (filter.address != null) {
                result.address = this._getAddress(filter.address);
            }
            ["blockHash", "topics"].forEach((key) => {
                if (filter[key] == null) {
                    return;
                }
                result[key] = filter[key];
            });
            ["fromBlock", "toBlock"].forEach((key) => {
                if (filter[key] == null) {
                    return;
                }
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter(yield resolveProperties(result));
        });
    }
    _call(transaction, blockTag, attempt) {
        return __awaiter$4(this, void 0, void 0, function* () {
            if (attempt >= MAX_CCIP_REDIRECTS) {
                logger$d.throwError("CCIP read exceeded maximum redirections", Logger$1.errors.SERVER_ERROR, {
                    redirects: attempt, transaction
                });
            }
            const txSender = transaction.to;
            const result = yield this.perform("call", { transaction, blockTag });
            // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)
            if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (hexDataLength(result) % 32 === 4)) {
                try {
                    const data = hexDataSlice(result, 4);
                    // Check the sender of the OffchainLookup matches the transaction
                    const sender = hexDataSlice(data, 0, 32);
                    if (!BigNumber$1.from(sender).eq(txSender)) {
                        logger$d.throwError("CCIP Read sender did not match", Logger$1.errors.CALL_EXCEPTION, {
                            name: "OffchainLookup",
                            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                            transaction, data: result
                        });
                    }
                    // Read the URLs from the response
                    const urls = [];
                    const urlsOffset = BigNumber$1.from(hexDataSlice(data, 32, 64)).toNumber();
                    const urlsLength = BigNumber$1.from(hexDataSlice(data, urlsOffset, urlsOffset + 32)).toNumber();
                    const urlsData = hexDataSlice(data, urlsOffset + 32);
                    for (let u = 0; u < urlsLength; u++) {
                        const url = _parseString(urlsData, u * 32);
                        if (url == null) {
                            logger$d.throwError("CCIP Read contained corrupt URL string", Logger$1.errors.CALL_EXCEPTION, {
                                name: "OffchainLookup",
                                signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                                transaction, data: result
                            });
                        }
                        urls.push(url);
                    }
                    // Get the CCIP calldata to forward
                    const calldata = _parseBytes(data, 64);
                    // Get the callbackSelector (bytes4)
                    if (!BigNumber$1.from(hexDataSlice(data, 100, 128)).isZero()) {
                        logger$d.throwError("CCIP Read callback selector included junk", Logger$1.errors.CALL_EXCEPTION, {
                            name: "OffchainLookup",
                            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                            transaction, data: result
                        });
                    }
                    const callbackSelector = hexDataSlice(data, 96, 100);
                    // Get the extra data to send back to the contract as context
                    const extraData = _parseBytes(data, 128);
                    const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);
                    if (ccipResult == null) {
                        logger$d.throwError("CCIP Read disabled or provided no URLs", Logger$1.errors.CALL_EXCEPTION, {
                            name: "OffchainLookup",
                            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                            transaction, data: result
                        });
                    }
                    const tx = {
                        to: txSender,
                        data: hexConcat([callbackSelector, encodeBytes([ccipResult, extraData])])
                    };
                    return this._call(tx, blockTag, attempt + 1);
                }
                catch (error) {
                    if (error.code === Logger$1.errors.SERVER_ERROR) {
                        throw error;
                    }
                }
            }
            try {
                return hexlify(result);
            }
            catch (error) {
                return logger$d.throwError("bad result from backend", Logger$1.errors.SERVER_ERROR, {
                    method: "call",
                    params: { transaction, blockTag }, result, error
                });
            }
        });
    }
    call(transaction, blockTag) {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const resolved = yield resolveProperties({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag),
                ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
            });
            return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
        });
    }
    estimateGas(transaction) {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield resolveProperties({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return BigNumber$1.from(result);
            }
            catch (error) {
                return logger$d.throwError("bad result from backend", Logger$1.errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params, result, error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return __awaiter$4(this, void 0, void 0, function* () {
            addressOrName = yield addressOrName;
            if (typeof (addressOrName) !== "string") {
                logger$d.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            }
            const address = yield this.resolveName(addressOrName);
            if (address == null) {
                logger$d.throwError("ENS name not configured", Logger$1.errors.UNSUPPORTED_OPERATION, {
                    operation: `resolveName(${JSON.stringify(addressOrName)})`
                });
            }
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if (isHexString$1(blockHashOrBlockTag, 32)) {
                params.blockHash = blockHashOrBlockTag;
            }
            else {
                try {
                    params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                    if (isHexString$1(params.blockTag)) {
                        blockNumber = parseInt(params.blockTag.substring(2), 16);
                    }
                }
                catch (error) {
                    logger$d.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
                }
            }
            return poll(() => __awaiter$4(this, void 0, void 0, function* () {
                const block = yield this.perform("getBlock", params);
                // Block was not found
                if (block == null) {
                    // For blockhashes, if we didn't say it existed, that blockhash may
                    // not exist. If we did see it though, perhaps from a log, we know
                    // it exists, and this node is just not caught up yet.
                    if (params.blockHash != null) {
                        if (this._emitted["b:" + params.blockHash] == null) {
                            return null;
                        }
                    }
                    // For block tags, if we are asking for a future block, we return null
                    if (params.blockTag != null) {
                        if (blockNumber > this._emitted.block) {
                            return null;
                        }
                    }
                    // Retry on the next block
                    return undefined;
                }
                // Add transactions
                if (includeTransactions) {
                    let blockNumber = null;
                    for (let i = 0; i < block.transactions.length; i++) {
                        const tx = block.transactions[i];
                        if (tx.blockNumber == null) {
                            tx.confirmations = 0;
                        }
                        else if (tx.confirmations == null) {
                            if (blockNumber == null) {
                                blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                            }
                            // Add the confirmations using the fast block number (pessimistic)
                            let confirmations = (blockNumber - tx.blockNumber) + 1;
                            if (confirmations <= 0) {
                                confirmations = 1;
                            }
                            tx.confirmations = confirmations;
                        }
                    }
                    const blockWithTxs = this.formatter.blockWithTransactions(block);
                    blockWithTxs.transactions = blockWithTxs.transactions.map((tx) => this._wrapTransaction(tx));
                    return blockWithTxs;
                }
                return this.formatter.block(block);
            }), { oncePoll: this });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return (this._getBlock(blockHashOrBlockTag, false));
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return (this._getBlock(blockHashOrBlockTag, true));
    }
    getTransaction(transactionHash) {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = { transactionHash: this.formatter.hash(transactionHash, true) };
            return poll(() => __awaiter$4(this, void 0, void 0, function* () {
                const result = yield this.perform("getTransaction", params);
                if (result == null) {
                    if (this._emitted["t:" + transactionHash] == null) {
                        return null;
                    }
                    return undefined;
                }
                const tx = this.formatter.transactionResponse(result);
                if (tx.blockNumber == null) {
                    tx.confirmations = 0;
                }
                else if (tx.confirmations == null) {
                    const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                    // Add the confirmations using the fast block number (pessimistic)
                    let confirmations = (blockNumber - tx.blockNumber) + 1;
                    if (confirmations <= 0) {
                        confirmations = 1;
                    }
                    tx.confirmations = confirmations;
                }
                return this._wrapTransaction(tx);
            }), { oncePoll: this });
        });
    }
    getTransactionReceipt(transactionHash) {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = { transactionHash: this.formatter.hash(transactionHash, true) };
            return poll(() => __awaiter$4(this, void 0, void 0, function* () {
                const result = yield this.perform("getTransactionReceipt", params);
                if (result == null) {
                    if (this._emitted["t:" + transactionHash] == null) {
                        return null;
                    }
                    return undefined;
                }
                // "geth-etc" returns receipts before they are ready
                if (result.blockHash == null) {
                    return undefined;
                }
                const receipt = this.formatter.receipt(result);
                if (receipt.blockNumber == null) {
                    receipt.confirmations = 0;
                }
                else if (receipt.confirmations == null) {
                    const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                    // Add the confirmations using the fast block number (pessimistic)
                    let confirmations = (blockNumber - receipt.blockNumber) + 1;
                    if (confirmations <= 0) {
                        confirmations = 1;
                    }
                    receipt.confirmations = confirmations;
                }
                return receipt;
            }), { oncePoll: this });
        });
    }
    getLogs(filter) {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield resolveProperties({ filter: this._getFilter(filter) });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log) => {
                if (log.removed == null) {
                    log.removed = false;
                }
            });
            return Formatter.arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return __awaiter$4(this, void 0, void 0, function* () {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return __awaiter$4(this, void 0, void 0, function* () {
            blockTag = yield blockTag;
            if (typeof (blockTag) === "number" && blockTag < 0) {
                if (blockTag % 1) {
                    logger$d.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                }
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) {
                    blockNumber = 0;
                }
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return __awaiter$4(this, void 0, void 0, function* () {
            let currentName = name;
            while (true) {
                if (currentName === "" || currentName === ".") {
                    return null;
                }
                // Optimization since the eth node cannot change and does
                // not have a wildcar resolver
                if (name !== "eth" && currentName === "eth") {
                    return null;
                }
                // Check the current node for a resolver
                const addr = yield this._getResolver(currentName, "getResolver");
                // Found a resolver!
                if (addr != null) {
                    const resolver = new Resolver(this, addr, name);
                    // Legacy resolver found, using EIP-2544 so it isn't safe to use
                    if (currentName !== name && !(yield resolver.supportsWildcard())) {
                        return null;
                    }
                    return resolver;
                }
                // Get the parent node
                currentName = currentName.split(".").slice(1).join(".");
            }
        });
    }
    _getResolver(name, operation) {
        return __awaiter$4(this, void 0, void 0, function* () {
            if (operation == null) {
                operation = "ENS";
            }
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) {
                logger$d.throwError("network does not support ENS", Logger$1.errors.UNSUPPORTED_OPERATION, { operation, network: network.name });
            }
            try {
                // keccak256("resolver(bytes32)")
                const addrData = yield this.call({
                    to: network.ensAddress,
                    data: ("0x0178b8bf" + namehash(name).substring(2))
                });
                return this.formatter.callAddress(addrData);
            }
            catch (error) {
                // ENS registry cannot throw errors on resolver(bytes32)
            }
            return null;
        });
    }
    resolveName(name) {
        return __awaiter$4(this, void 0, void 0, function* () {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            }
            catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if (isHexString$1(name)) {
                    throw error;
                }
            }
            if (typeof (name) !== "string") {
                logger$d.throwArgumentError("invalid ENS name", "name", name);
            }
            // Get the addr from the resovler
            const resolver = yield this.getResolver(name);
            if (!resolver) {
                return null;
            }
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return __awaiter$4(this, void 0, void 0, function* () {
            address = yield address;
            address = this.formatter.address(address);
            const node = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddr = yield this._getResolver(node, "lookupAddress");
            if (resolverAddr == null) {
                return null;
            }
            // keccak("name(bytes32)")
            const name = _parseString(yield this.call({
                to: resolverAddr,
                data: ("0x691f3431" + namehash(node).substring(2))
            }), 0);
            const addr = yield this.resolveName(name);
            if (addr != address) {
                return null;
            }
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return __awaiter$4(this, void 0, void 0, function* () {
            let resolver = null;
            if (isHexString$1(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const node = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(node, "getAvatar");
                if (!resolverAddress) {
                    return null;
                }
                // Try resolving the avatar against the addr.reverse resolver
                resolver = new Resolver(this, resolverAddress, node);
                try {
                    const avatar = yield resolver.getAvatar();
                    if (avatar) {
                        return avatar.url;
                    }
                }
                catch (error) {
                    if (error.code !== Logger$1.errors.CALL_EXCEPTION) {
                        throw error;
                    }
                }
                // Try getting the name and performing forward lookup; allowing wildcards
                try {
                    // keccak("name(bytes32)")
                    const name = _parseString(yield this.call({
                        to: resolverAddress,
                        data: ("0x691f3431" + namehash(node).substring(2))
                    }), 0);
                    resolver = yield this.getResolver(name);
                }
                catch (error) {
                    if (error.code !== Logger$1.errors.CALL_EXCEPTION) {
                        throw error;
                    }
                    return null;
                }
            }
            else {
                // ENS name; forward lookup with wildcard
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) {
                    return null;
                }
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) {
                return null;
            }
            return avatar.url;
        });
    }
    perform(method, params) {
        return logger$d.throwError(method + " not implemented", Logger$1.errors.NOT_IMPLEMENTED, { operation: method });
    }
    _startEvent(event) {
        this.polling = (this._events.filter((e) => e.pollable()).length > 0);
    }
    _stopEvent(event) {
        this.polling = (this._events.filter((e) => e.pollable()).length > 0);
    }
    _addEventListener(eventName, listener, once) {
        const event = new Event(getEventTag$1(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = getEventTag$1(eventName);
        this._events = this._events.filter((event) => {
            if (event.tag !== eventTag) {
                return true;
            }
            setTimeout(() => {
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event) => { this._stopEvent(event); });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) {
            return this._events.length;
        }
        let eventTag = getEventTag$1(eventName);
        return this._events.filter((event) => {
            return (event.tag === eventTag);
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) {
            return this._events.map((event) => event.listener);
        }
        let eventTag = getEventTag$1(eventName);
        return this._events
            .filter((event) => (event.tag === eventTag))
            .map((event) => event.listener);
    }
    off(eventName, listener) {
        if (listener == null) {
            return this.removeAllListeners(eventName);
        }
        const stopped = [];
        let found = false;
        let eventTag = getEventTag$1(eventName);
        this._events = this._events.filter((event) => {
            if (event.tag !== eventTag || event.listener != listener) {
                return true;
            }
            if (found) {
                return true;
            }
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event) => { this._stopEvent(event); });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        }
        else {
            const eventTag = getEventTag$1(eventName);
            this._events = this._events.filter((event) => {
                if (event.tag !== eventTag) {
                    return true;
                }
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event) => { this._stopEvent(event); });
        return this;
    }
}

const version$b = "abstract-signer/5.6.1";

var __awaiter$3 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const logger$c = new Logger$1(version$b);
const allowedTransactionKeys$1 = [
    "accessList", "ccipReadEnabled", "chainId", "customData", "data", "from", "gasLimit", "gasPrice", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "to", "type", "value"
];
const forwardErrors = [
    Logger$1.errors.INSUFFICIENT_FUNDS,
    Logger$1.errors.NONCE_EXPIRED,
    Logger$1.errors.REPLACEMENT_UNDERPRICED,
];
class Signer {
    ///////////////////
    // Sub-classes MUST call super
    constructor() {
        logger$c.checkAbstract(new.target, Signer);
        defineReadOnly(this, "_isSigner", true);
    }
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return __awaiter$3(this, void 0, void 0, function* () {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return __awaiter$3(this, void 0, void 0, function* () {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return __awaiter$3(this, void 0, void 0, function* () {
            this._checkProvider("estimateGas");
            const tx = yield resolveProperties(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return __awaiter$3(this, void 0, void 0, function* () {
            this._checkProvider("call");
            const tx = yield resolveProperties(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return __awaiter$3(this, void 0, void 0, function* () {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return __awaiter$3(this, void 0, void 0, function* () {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return __awaiter$3(this, void 0, void 0, function* () {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return __awaiter$3(this, void 0, void 0, function* () {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return __awaiter$3(this, void 0, void 0, function* () {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for (const key in transaction) {
            if (allowedTransactionKeys$1.indexOf(key) === -1) {
                logger$c.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
            }
        }
        const tx = shallowCopy(transaction);
        if (tx.from == null) {
            tx.from = this.getAddress();
        }
        else {
            // Make sure any provided address matches this signer
            tx.from = Promise.all([
                Promise.resolve(tx.from),
                this.getAddress()
            ]).then((result) => {
                if (result[0].toLowerCase() !== result[1].toLowerCase()) {
                    logger$c.throwArgumentError("from address mismatch", "transaction", transaction);
                }
                return result[0];
            });
        }
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return __awaiter$3(this, void 0, void 0, function* () {
            const tx = yield resolveProperties(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to) => __awaiter$3(this, void 0, void 0, function* () {
                    if (to == null) {
                        return null;
                    }
                    const address = yield this.resolveName(to);
                    if (address == null) {
                        logger$c.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                    }
                    return address;
                }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error) => { });
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = (tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null);
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) {
                logger$c.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            }
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) {
                logger$c.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            }
            if ((tx.type === 2 || tx.type == null) && (tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null)) {
                // Fully-formed EIP-1559 transaction (skip getFeeData)
                tx.type = 2;
            }
            else if (tx.type === 0 || tx.type === 1) {
                // Explicit Legacy or EIP-2930 transaction
                // Populate missing gasPrice
                if (tx.gasPrice == null) {
                    tx.gasPrice = this.getGasPrice();
                }
            }
            else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        }
                        else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) {
                                tx.maxFeePerGas = feeData.maxFeePerGas;
                            }
                            if (tx.maxPriorityFeePerGas == null) {
                                tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                            }
                        }
                    }
                    else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) {
                            logger$c.throwError("network does not support EIP-1559", Logger$1.errors.UNSUPPORTED_OPERATION, {
                                operation: "populateTransaction"
                            });
                        }
                        // Populate missing fee data
                        if (tx.gasPrice == null) {
                            tx.gasPrice = feeData.gasPrice;
                        }
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    }
                    else {
                        // getFeeData has failed us.
                        logger$c.throwError("failed to get consistent fee data", Logger$1.errors.UNSUPPORTED_OPERATION, {
                            operation: "signer.getFeeData"
                        });
                    }
                }
                else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) {
                        tx.maxFeePerGas = feeData.maxFeePerGas;
                    }
                    if (tx.maxPriorityFeePerGas == null) {
                        tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                    }
                }
            }
            if (tx.nonce == null) {
                tx.nonce = this.getTransactionCount("pending");
            }
            if (tx.gasLimit == null) {
                tx.gasLimit = this.estimateGas(tx).catch((error) => {
                    if (forwardErrors.indexOf(error.code) >= 0) {
                        throw error;
                    }
                    return logger$c.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", Logger$1.errors.UNPREDICTABLE_GAS_LIMIT, {
                        error: error,
                        tx: tx
                    });
                });
            }
            if (tx.chainId == null) {
                tx.chainId = this.getChainId();
            }
            else {
                tx.chainId = Promise.all([
                    Promise.resolve(tx.chainId),
                    this.getChainId()
                ]).then((results) => {
                    if (results[1] !== 0 && results[0] !== results[1]) {
                        logger$c.throwArgumentError("chainId address mismatch", "transaction", transaction);
                    }
                    return results[0];
                });
            }
            return yield resolveProperties(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) {
            logger$c.throwError("missing provider", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: (operation || "_checkProvider")
            });
        }
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
}
class VoidSigner extends Signer {
    constructor(address, provider) {
        super();
        defineReadOnly(this, "address", address);
        defineReadOnly(this, "provider", provider || null);
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(() => {
            logger$c.throwError(message, Logger$1.errors.UNSUPPORTED_OPERATION, { operation: operation });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new VoidSigner(this.address, provider);
    }
}

var __awaiter$2 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const logger$b = new Logger$1(version$e);
const errorGas = ["call", "estimateGas"];
function spelunk(value) {
    if (value == null) {
        return null;
    }
    // These *are* the droids we're looking for.
    if (typeof (value.message) === "string" && value.message.match("reverted") && isHexString$1(value.data)) {
        return { message: value.message, data: value.data };
    }
    // Spelunk further...
    if (typeof (value) === "object") {
        for (const key in value) {
            const result = spelunk(value[key]);
            if (result) {
                return result;
            }
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof (value) === "string") {
        try {
            return spelunk(JSON.parse(value));
        }
        catch (error) { }
    }
    return null;
}
function checkError(method, error, params) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        const result = spelunk(error);
        if (result) {
            return result.data;
        }
        logger$b.throwError("missing revert data in call exception; Transaction reverted without a reason string", Logger$1.errors.CALL_EXCEPTION, {
            error, data: "0x"
        });
    }
    // @TODO: Should we spelunk for message too?
    let message = error.message;
    if (error.code === Logger$1.errors.SERVER_ERROR && error.error && typeof (error.error.message) === "string") {
        message = error.error.message;
    }
    else if (typeof (error.body) === "string") {
        message = error.body;
    }
    else if (typeof (error.responseText) === "string") {
        message = error.responseText;
    }
    message = (message || "").toLowerCase();
    const transaction = params.transaction || params.signedTransaction;
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit/)) {
        logger$b.throwError("insufficient funds for intrinsic transaction cost", Logger$1.errors.INSUFFICIENT_FUNDS, {
            error, method, transaction
        });
    }
    // "nonce too low"
    if (message.match(/nonce (is )?too low/)) {
        logger$b.throwError("nonce has already been used", Logger$1.errors.NONCE_EXPIRED, {
            error, method, transaction
        });
    }
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced/)) {
        logger$b.throwError("replacement fee too low", Logger$1.errors.REPLACEMENT_UNDERPRICED, {
            error, method, transaction
        });
    }
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/)) {
        logger$b.throwError("legacy pre-eip-155 transactions not supported", Logger$1.errors.UNSUPPORTED_OPERATION, {
            error, method, transaction
        });
    }
    if (errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted/)) {
        logger$b.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", Logger$1.errors.UNPREDICTABLE_GAS_LIMIT, {
            error, method, transaction
        });
    }
    throw error;
}
function timer(timeout) {
    return new Promise(function (resolve) {
        setTimeout(resolve, timeout);
    });
}
function getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function getLowerCase(value) {
    if (value) {
        return value.toLowerCase();
    }
    return value;
}
const _constructorGuard$2 = {};
class JsonRpcSigner extends Signer {
    constructor(constructorGuard, provider, addressOrIndex) {
        logger$b.checkNew(new.target, JsonRpcSigner);
        super();
        if (constructorGuard !== _constructorGuard$2) {
            throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        }
        defineReadOnly(this, "provider", provider);
        if (addressOrIndex == null) {
            addressOrIndex = 0;
        }
        if (typeof (addressOrIndex) === "string") {
            defineReadOnly(this, "_address", this.provider.formatter.address(addressOrIndex));
            defineReadOnly(this, "_index", null);
        }
        else if (typeof (addressOrIndex) === "number") {
            defineReadOnly(this, "_index", addressOrIndex);
            defineReadOnly(this, "_address", null);
        }
        else {
            logger$b.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
        }
    }
    connect(provider) {
        return logger$b.throwError("cannot alter JSON-RPC Signer connection", Logger$1.errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new UncheckedJsonRpcSigner(_constructorGuard$2, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) {
            return Promise.resolve(this._address);
        }
        return this.provider.send("eth_accounts", []).then((accounts) => {
            if (accounts.length <= this._index) {
                logger$b.throwError("unknown account #" + this._index, Logger$1.errors.UNSUPPORTED_OPERATION, {
                    operation: "getAddress"
                });
            }
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = shallowCopy(transaction);
        const fromAddress = this.getAddress().then((address) => {
            if (address) {
                address = address.toLowerCase();
            }
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = shallowCopy(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) {
            transaction.to = Promise.resolve(transaction.to).then((to) => __awaiter$2(this, void 0, void 0, function* () {
                if (to == null) {
                    return null;
                }
                const address = yield this.provider.resolveName(to);
                if (address == null) {
                    logger$b.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                }
                return address;
            }));
        }
        return resolveProperties({
            tx: resolveProperties(transaction),
            sender: fromAddress
        }).then(({ tx, sender }) => {
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) {
                    logger$b.throwArgumentError("from address mismatch", "transaction", transaction);
                }
            }
            else {
                tx.from = sender;
            }
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, { from: true });
            return this.provider.send("eth_sendTransaction", [hexTx]).then((hash) => {
                return hash;
            }, (error) => {
                return checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return logger$b.throwError("signing transactions is unsupported", Logger$1.errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return __awaiter$2(this, void 0, void 0, function* () {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield poll(() => __awaiter$2(this, void 0, void 0, function* () {
                    const tx = yield this.provider.getTransaction(hash);
                    if (tx === null) {
                        return undefined;
                    }
                    return this.provider._wrapTransaction(tx, hash, blockNumber);
                }), { oncePoll: this.provider });
            }
            catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return __awaiter$2(this, void 0, void 0, function* () {
            const data = ((typeof (message) === "string") ? toUtf8Bytes(message) : message);
            const address = yield this.getAddress();
            return yield this.provider.send("personal_sign", [hexlify(data), address.toLowerCase()]);
        });
    }
    _legacySignMessage(message) {
        return __awaiter$2(this, void 0, void 0, function* () {
            const data = ((typeof (message) === "string") ? toUtf8Bytes(message) : message);
            const address = yield this.getAddress();
            // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
            return yield this.provider.send("eth_sign", [address.toLowerCase(), hexlify(data)]);
        });
    }
    _signTypedData(domain, types, value) {
        return __awaiter$2(this, void 0, void 0, function* () {
            // Populate any ENS names (in-place)
            const populated = yield TypedDataEncoder.resolveNames(domain, types, value, (name) => {
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            return yield this.provider.send("eth_signTypedData_v4", [
                address.toLowerCase(),
                JSON.stringify(TypedDataEncoder.getPayload(populated.domain, types, populated.value))
            ]);
        });
    }
    unlock(password) {
        return __awaiter$2(this, void 0, void 0, function* () {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [address.toLowerCase(), password, null]);
        });
    }
}
class UncheckedJsonRpcSigner extends JsonRpcSigner {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash) => {
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations) => { return this.provider.waitForTransaction(hash, confirmations); }
            };
        });
    }
}
const allowedTransactionKeys = {
    chainId: true, data: true, gasLimit: true, gasPrice: true, nonce: true, to: true, value: true,
    type: true, accessList: true,
    maxFeePerGas: true, maxPriorityFeePerGas: true
};
class JsonRpcProvider extends BaseProvider {
    constructor(url, network) {
        logger$b.checkNew(new.target, JsonRpcProvider);
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) {
            networkOrReady = new Promise((resolve, reject) => {
                setTimeout(() => {
                    this.detectNetwork().then((network) => {
                        resolve(network);
                    }, (error) => {
                        reject(error);
                    });
                }, 0);
            });
        }
        super(networkOrReady);
        // Default URL
        if (!url) {
            url = getStatic(this.constructor, "defaultUrl")();
        }
        if (typeof (url) === "string") {
            defineReadOnly(this, "connection", Object.freeze({
                url: url
            }));
        }
        else {
            defineReadOnly(this, "connection", Object.freeze(shallowCopy(url)));
        }
        this._nextId = 42;
    }
    get _cache() {
        if (this._eventLoopCache == null) {
            this._eventLoopCache = {};
        }
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http:/\/localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(() => {
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return __awaiter$2(this, void 0, void 0, function* () {
            yield timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            }
            catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                }
                catch (error) { }
            }
            if (chainId != null) {
                const getNetwork = getStatic(this.constructor, "getNetwork");
                try {
                    return getNetwork(BigNumber$1.from(chainId).toNumber());
                }
                catch (error) {
                    return logger$b.throwError("could not detect network", Logger$1.errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return logger$b.throwError("could not detect network", Logger$1.errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new JsonRpcSigner(_constructorGuard$2, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts) => {
            return accounts.map((a) => this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: (this._nextId++),
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: deepCopy(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = (["eth_chainId", "eth_blockNumber"].indexOf(method) >= 0);
        if (cache && this._cache[method]) {
            return this._cache[method];
        }
        const result = fetchJson(this.connection, JSON.stringify(request), getResult).then((result) => {
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error) => {
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(() => {
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch (method) {
            case "getBlockNumber":
                return ["eth_blockNumber", []];
            case "getGasPrice":
                return ["eth_gasPrice", []];
            case "getBalance":
                return ["eth_getBalance", [getLowerCase(params.address), params.blockTag]];
            case "getTransactionCount":
                return ["eth_getTransactionCount", [getLowerCase(params.address), params.blockTag]];
            case "getCode":
                return ["eth_getCode", [getLowerCase(params.address), params.blockTag]];
            case "getStorageAt":
                return ["eth_getStorageAt", [getLowerCase(params.address), params.position, params.blockTag]];
            case "sendTransaction":
                return ["eth_sendRawTransaction", [params.signedTransaction]];
            case "getBlock":
                if (params.blockTag) {
                    return ["eth_getBlockByNumber", [params.blockTag, !!params.includeTransactions]];
                }
                else if (params.blockHash) {
                    return ["eth_getBlockByHash", [params.blockHash, !!params.includeTransactions]];
                }
                return null;
            case "getTransaction":
                return ["eth_getTransactionByHash", [params.transactionHash]];
            case "getTransactionReceipt":
                return ["eth_getTransactionReceipt", [params.transactionHash]];
            case "call": {
                const hexlifyTransaction = getStatic(this.constructor, "hexlifyTransaction");
                return ["eth_call", [hexlifyTransaction(params.transaction, { from: true }), params.blockTag]];
            }
            case "estimateGas": {
                const hexlifyTransaction = getStatic(this.constructor, "hexlifyTransaction");
                return ["eth_estimateGas", [hexlifyTransaction(params.transaction, { from: true })]];
            }
            case "getLogs":
                if (params.filter && params.filter.address != null) {
                    params.filter.address = getLowerCase(params.filter.address);
                }
                return ["eth_getLogs", [params.filter]];
        }
        return null;
    }
    perform(method, params) {
        return __awaiter$2(this, void 0, void 0, function* () {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && BigNumber$1.from(tx.type).isZero()) {
                    // If there are no EIP-1559 properties, it might be non-EIP-a559
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = shallowCopy(params);
                            params.transaction = shallowCopy(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) {
                logger$b.throwError(method + " not implemented", Logger$1.errors.NOT_IMPLEMENTED, { operation: method });
            }
            try {
                return yield this.send(args[0], args[1]);
            }
            catch (error) {
                return checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") {
            this._startPending();
        }
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) {
            return;
        }
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function (filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [filterId]).then(function (hashes) {
                    if (self._pendingFilter != pendingFilter) {
                        return null;
                    }
                    let seq = Promise.resolve();
                    hashes.forEach(function (hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function () {
                            return self.getTransaction(hash).then(function (tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function () {
                        return timer(1000);
                    });
                }).then(function () {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [filterId]);
                        return;
                    }
                    setTimeout(function () { poll(); }, 0);
                    return null;
                }).catch((error) => { });
            }
            poll();
            return filterId;
        }).catch((error) => { });
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) {
            this._pendingFilter = null;
        }
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = shallowCopy(allowedTransactionKeys);
        if (allowExtra) {
            for (const key in allowExtra) {
                if (allowExtra[key]) {
                    allowed[key] = true;
                }
            }
        }
        checkProperties(transaction, allowed);
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        ["chainId", "gasLimit", "gasPrice", "type", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "value"].forEach(function (key) {
            if (transaction[key] == null) {
                return;
            }
            const value = hexValue(transaction[key]);
            if (key === "gasLimit") {
                key = "gas";
            }
            result[key] = value;
        });
        ["from", "to", "data"].forEach(function (key) {
            if (transaction[key] == null) {
                return;
            }
            result[key] = hexlify(transaction[key]);
        });
        if (transaction.accessList) {
            result["accessList"] = accessListify(transaction.accessList);
        }
        return result;
    }
}

let WS = null;
try {
    WS = WebSocket;
    if (WS == null) {
        throw new Error("inject please");
    }
}
catch (error) {
    const logger = new Logger$1(version$e);
    WS = function () {
        logger.throwError("WebSockets not supported in this environment", Logger$1.errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}

(undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
new Logger$1(version$e);

(undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
new Logger$1(version$e);

new Logger$1(version$e);

new Logger$1(version$e);

(undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
new Logger$1(version$e);

(undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
new Logger$1(version$e);

(undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
new Logger$1(version$e);
[
    Logger$1.errors.CALL_EXCEPTION,
    Logger$1.errors.INSUFFICIENT_FUNDS,
    Logger$1.errors.NONCE_EXPIRED,
    Logger$1.errors.REPLACEMENT_UNDERPRICED,
    Logger$1.errors.UNPREDICTABLE_GAS_LIMIT
];

new Logger$1(version$e);

/* istanbul ignore file */
new Logger$1(version$e);

new Logger$1(version$e);

const logger$a = new Logger$1(version$e);
let _nextId = 1;
function buildWeb3LegacyFetcher(provider, sendFunc) {
    const fetcher = "Web3LegacyFetcher";
    return function (method, params) {
        const request = {
            method: method,
            params: params,
            id: (_nextId++),
            jsonrpc: "2.0"
        };
        return new Promise((resolve, reject) => {
            this.emit("debug", {
                action: "request",
                fetcher,
                request: deepCopy(request),
                provider: this
            });
            sendFunc(request, (error, response) => {
                if (error) {
                    this.emit("debug", {
                        action: "response",
                        fetcher,
                        error,
                        request,
                        provider: this
                    });
                    return reject(error);
                }
                this.emit("debug", {
                    action: "response",
                    fetcher,
                    request,
                    response,
                    provider: this
                });
                if (response.error) {
                    const error = new Error(response.error.message);
                    error.code = response.error.code;
                    error.data = response.error.data;
                    return reject(error);
                }
                resolve(response.result);
            });
        });
    };
}
function buildEip1193Fetcher(provider) {
    return function (method, params) {
        if (params == null) {
            params = [];
        }
        const request = { method, params };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: deepCopy(request),
            provider: this
        });
        return provider.request(request).then((response) => {
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request,
                response,
                provider: this
            });
            return response;
        }, (error) => {
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request,
                error,
                provider: this
            });
            throw error;
        });
    };
}
class Web3Provider extends JsonRpcProvider {
    constructor(provider, network) {
        logger$a.checkNew(new.target, Web3Provider);
        if (provider == null) {
            logger$a.throwArgumentError("missing provider", "provider", provider);
        }
        let path = null;
        let jsonRpcFetchFunc = null;
        let subprovider = null;
        if (typeof (provider) === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        }
        else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) {
                path = "metamask";
            }
            subprovider = provider;
            if (provider.request) {
                if (path === "") {
                    path = "eip-1193:";
                }
                jsonRpcFetchFunc = buildEip1193Fetcher(provider);
            }
            else if (provider.sendAsync) {
                jsonRpcFetchFunc = buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            }
            else if (provider.send) {
                jsonRpcFetchFunc = buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            }
            else {
                logger$a.throwArgumentError("unsupported provider", "provider", provider);
            }
            if (!path) {
                path = "unknown:";
            }
        }
        super(path, network);
        defineReadOnly(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
        defineReadOnly(this, "provider", subprovider);
    }
    send(method, params) {
        return this.jsonRpcFetchFunc(method, params);
    }
}

new Logger$1(version$e);

var ConnectorEvent;

(function (ConnectorEvent) {
  ConnectorEvent["Update"] = "Web3ReactUpdate";
  ConnectorEvent["Error"] = "Web3ReactError";
  ConnectorEvent["Deactivate"] = "Web3ReactDeactivate";
})(ConnectorEvent || (ConnectorEvent = {}));

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var AbstractConnector =
/*#__PURE__*/
function (_EventEmitter) {
  _inheritsLoose$1(AbstractConnector, _EventEmitter);

  function AbstractConnector(_temp) {
    var _this;

    var _ref = _temp === void 0 ? {} : _temp,
        supportedChainIds = _ref.supportedChainIds;

    _this = _EventEmitter.call(this) || this;
    _this.supportedChainIds = supportedChainIds;
    return _this;
  }

  var _proto = AbstractConnector.prototype;

  _proto.emitUpdate = function emitUpdate(update) {
    if (process.env.NODE_ENV !== "production") {
      console.log("Emitting '" + ConnectorEvent.Update + "' with payload", update);
    }

    this.emit(ConnectorEvent.Update, update);
  };

  _proto.emitError = function emitError(error) {
    if (process.env.NODE_ENV !== "production") {
      console.log("Emitting '" + ConnectorEvent.Error + "' with payload", error);
    }

    this.emit(ConnectorEvent.Error, error);
  };

  _proto.emitDeactivate = function emitDeactivate() {
    if (process.env.NODE_ENV !== "production") {
      console.log("Emitting '" + ConnectorEvent.Deactivate + "'");
    }

    this.emit(ConnectorEvent.Deactivate);
  };

  return AbstractConnector;
}(EventEmitter$1);

var isProduction$3 = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction$3) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

function parseSendReturn(sendReturn) {
    return sendReturn.hasOwnProperty('result') ? sendReturn.result : sendReturn;
}
class NoEthereumProviderError extends Error {
    constructor() {
        super();
        this.name = this.constructor.name;
        this.message = 'No Ethereum provider was found on window.xfi.ethereum.';
    }
}
class UserRejectedRequestError extends Error {
    constructor() {
        super();
        this.name = this.constructor.name;
        this.message = 'The user rejected the request.';
    }
}
class DefiConnector extends AbstractConnector {
    constructor(kwargs) {
        super(kwargs);
        this.handleNetworkChanged = this.handleNetworkChanged.bind(this);
        this.handleChainChanged = this.handleChainChanged.bind(this);
        this.handleAccountsChanged = this.handleAccountsChanged.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }
    handleChainChanged(chainId) {
        var _a;
        console.log("Handling 'chainChanged' event with payload", chainId);
        this.emitUpdate({ chainId, provider: (_a = window === null || window === void 0 ? void 0 : window.xfi) === null || _a === void 0 ? void 0 : _a.ethereum });
    }
    handleAccountsChanged(accounts) {
        console.log("Handling 'accountsChanged' event with payload", accounts);
        if (accounts.length === 0) {
            this.emitDeactivate();
        }
        else {
            this.emitUpdate({ account: accounts[0] });
        }
    }
    handleClose(code, reason) {
        console.log("Handling 'close' event with payload", code, reason);
        this.emitDeactivate();
    }
    handleNetworkChanged(networkId) {
        var _a;
        console.log("Handling 'networkChanged' event with payload", networkId);
        this.emitUpdate({ chainId: networkId, provider: (_a = window === null || window === void 0 ? void 0 : window.xfi) === null || _a === void 0 ? void 0 : _a.ethereum });
    }
    activate() {
        var _a, _b, _c;
        return __awaiter$a(this, void 0, void 0, function* () {
            if (!((_a = window === null || window === void 0 ? void 0 : window.xfi) === null || _a === void 0 ? void 0 : _a.ethereum)) {
                throw new NoEthereumProviderError();
            }
            if ((_b = window === null || window === void 0 ? void 0 : window.xfi) === null || _b === void 0 ? void 0 : _b.ethereum.on) {
                window.xfi.ethereum.on('chainChanged', this.handleChainChanged);
                window.xfi.ethereum.on('accountsChanged', this.handleAccountsChanged);
                window.xfi.ethereum.on('close', this.handleClose);
                window.xfi.ethereum.on('networkChanged', this.handleNetworkChanged);
            }
            if ((_c = window === null || window === void 0 ? void 0 : window.xfi) === null || _c === void 0 ? void 0 : _c.ethereum.isXDEFI) {
                window.xfi.ethereum.autoRefreshOnNetworkChange = false;
            }
            // try to activate + get account via eth_requestAccounts
            let account;
            try {
                account = yield window.xfi.ethereum.send('eth_requestAccounts').then((sendReturn) => parseSendReturn(sendReturn)[0]);
            }
            catch (error) {
                if (error.code === 4001) {
                    throw new UserRejectedRequestError();
                }
                warning(false, 'eth_requestAccounts was unsuccessful, falling back to enable');
            }
            // if unsuccessful, try enable
            if (!account) {
                // if enable is successful but doesn't return accounts, fall back to getAccount (not happy i have to do this...)
                account = yield window.xfi.ethereum
                    .enable()
                    .then((sendReturn) => sendReturn && parseSendReturn(sendReturn)[0]);
            }
            return Object.assign({ provider: window.xfi.ethereum }, (account ? { account } : {}));
        });
    }
    getProvider() {
        var _a;
        return __awaiter$a(this, void 0, void 0, function* () {
            return (_a = window === null || window === void 0 ? void 0 : window.xfi) === null || _a === void 0 ? void 0 : _a.ethereum;
        });
    }
    getChainId() {
        var _a, _b;
        return __awaiter$a(this, void 0, void 0, function* () {
            if (!((_a = window === null || window === void 0 ? void 0 : window.xfi) === null || _a === void 0 ? void 0 : _a.ethereum)) {
                throw new NoEthereumProviderError();
            }
            let chainId;
            try {
                chainId = yield window.xfi.ethereum.send('eth_chainId').then(parseSendReturn);
            }
            catch (_c) {
                warning(false, 'eth_chainId was unsuccessful, falling back to net_version');
            }
            if (!chainId) {
                try {
                    chainId = yield window.xfi.ethereum.send('net_version').then(parseSendReturn);
                }
                catch (_d) {
                    warning(false, 'net_version was unsuccessful, falling back to net version v2');
                }
            }
            if (!chainId) {
                try {
                    chainId = parseSendReturn(window.xfi.ethereum.send({ method: 'net_version' }));
                }
                catch (_e) {
                    warning(false, 'net_version v2 was unsuccessful, falling back to manual matches and static properties');
                }
            }
            if (!chainId) {
                if ((_b = window === null || window === void 0 ? void 0 : window.xfi) === null || _b === void 0 ? void 0 : _b.ethereum.isDapper) {
                    chainId = parseSendReturn(window.xfi.ethereum.cachedResults.net_version);
                }
                else {
                    chainId =
                        window.xfi.ethereum.chainId ||
                            window.xfi.ethereum.netVersion ||
                            window.xfi.ethereum.networkVersion ||
                            window.xfi.ethereum._chainId;
                }
            }
            return chainId;
        });
    }
    getAccount() {
        var _a;
        return __awaiter$a(this, void 0, void 0, function* () {
            if (!((_a = window === null || window === void 0 ? void 0 : window.xfi) === null || _a === void 0 ? void 0 : _a.ethereum)) {
                throw new NoEthereumProviderError();
            }
            let account;
            try {
                account = yield window.xfi.ethereum.send('eth_accounts').then((sendReturn) => parseSendReturn(sendReturn)[0]);
            }
            catch (_b) {
                warning(false, 'eth_accounts was unsuccessful, falling back to enable');
            }
            if (!account) {
                try {
                    account = yield window.xfi.ethereum.enable().then((sendReturn) => parseSendReturn(sendReturn)[0]);
                }
                catch (_c) {
                    warning(false, 'enable was unsuccessful, falling back to eth_accounts v2');
                }
            }
            if (!account) {
                account = parseSendReturn(window.xfi.ethereum.send({ method: 'eth_accounts' }))[0];
            }
            return account;
        });
    }
    deactivate() {
        var _a, _b;
        if (((_a = window === null || window === void 0 ? void 0 : window.xfi) === null || _a === void 0 ? void 0 : _a.ethereum) && ((_b = window === null || window === void 0 ? void 0 : window.xfi) === null || _b === void 0 ? void 0 : _b.ethereum.removeListener)) {
            window.xfi.ethereum.removeListener('chainChanged', this.handleChainChanged);
            window.xfi.ethereum.removeListener('accountsChanged', this.handleAccountsChanged);
            window.xfi.ethereum.removeListener('close', this.handleClose);
            window.xfi.ethereum.removeListener('networkChanged', this.handleNetworkChanged);
        }
    }
    isAuthorized() {
        var _a;
        return __awaiter$a(this, void 0, void 0, function* () {
            if (!((_a = window === null || window === void 0 ? void 0 : window.xfi) === null || _a === void 0 ? void 0 : _a.ethereum)) {
                return false;
            }
            try {
                return yield window.xfi.ethereum.send('eth_accounts').then((sendReturn) => {
                    if (parseSendReturn(sendReturn).length > 0) {
                        return true;
                    }
                    else {
                        return false;
                    }
                });
            }
            catch (_b) {
                return false;
            }
        });
    }
}

var isProduction$2 = process.env.NODE_ENV === 'production';
var prefix$3 = 'Invariant failed';
function invariant$3(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction$2) {
        throw new Error(prefix$3);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix$3 + ": " + provided : prefix$3;
    throw new Error(value);
}

class RequestError extends Error {
    constructor(message, code, data) {
        super(message);
        this.code = code;
        this.data = data;
    }
}
class MiniRpcProvider {
    constructor(chainId, url, batchWaitTimeMs) {
        this.isMetaMask = false;
        this.isXDEFI = false;
        this.nextId = 1;
        this.batchTimeoutId = null;
        this.batch = [];
        this.clearBatch = () => __awaiter$a(this, void 0, void 0, function* () {
            var _a, _b, _c;
            console.debug('Clearing batch', this.batch);
            const batch = this.batch;
            this.batch = [];
            this.batchTimeoutId = null;
            let response;
            try {
                response = yield fetch(this.url, {
                    method: 'POST',
                    headers: { 'content-type': 'application/json', accept: 'application/json' },
                    body: JSON.stringify(batch.map((item) => item.request)),
                });
            }
            catch (error) {
                batch.forEach(({ reject }) => reject(new Error('Failed to send batch call')));
                return;
            }
            if (!response.ok) {
                batch.forEach(({ reject }) => reject(new RequestError(`${response.status}: ${response.statusText}`, -32000)));
                return;
            }
            let json;
            try {
                json = yield response.json();
            }
            catch (error) {
                batch.forEach(({ reject }) => reject(new Error('Failed to parse JSON response')));
                return;
            }
            const byKey = batch.reduce((memo, current) => {
                memo[current.request.id] = current;
                return memo;
            }, {});
            for (const result of json) {
                const { resolve, reject, request: { method }, } = byKey[result.id];
                // eslint-disable-next-line  @typescript-eslint/ban-ts-comment
                // @ts-ignore
                if (resolve && reject) {
                    if ('error' in result) {
                        reject(new RequestError((_a = result === null || result === void 0 ? void 0 : result.error) === null || _a === void 0 ? void 0 : _a.message, (_b = result === null || result === void 0 ? void 0 : result.error) === null || _b === void 0 ? void 0 : _b.code, (_c = result === null || result === void 0 ? void 0 : result.error) === null || _c === void 0 ? void 0 : _c.data));
                    }
                    else if ('result' in result) {
                        resolve(result.result);
                    }
                    else {
                        reject(new RequestError(`Received unexpected JSON-RPC response to ${method} request.`, -32000, result));
                    }
                }
            }
        });
        this.sendAsync = (request, callback) => {
            this.request(request.method, request.params)
                .then((result) => callback(null, { jsonrpc: '2.0', id: request.id, result }))
                .catch((error) => callback(error, null));
        };
        this.request = (method, params) => __awaiter$a(this, void 0, void 0, function* () {
            var _d;
            if (typeof method !== 'string') {
                return this.request(method.method, method.params);
            }
            if (method === 'eth_chainId') {
                return `0x${this.chainId.toString(16)}`;
            }
            const promise = new Promise((resolve, reject) => {
                this.batch.push({
                    request: {
                        jsonrpc: '2.0',
                        id: this.nextId++,
                        method,
                        params,
                    },
                    resolve,
                    reject,
                });
            });
            this.batchTimeoutId = (_d = this.batchTimeoutId) !== null && _d !== void 0 ? _d : setTimeout(this.clearBatch, this.batchWaitTimeMs);
            return promise;
        });
        this.chainId = chainId;
        this.url = url;
        const parsed = new URL(url);
        this.host = parsed.host;
        this.path = parsed.pathname;
        // how long to wait to batch calls
        this.batchWaitTimeMs = batchWaitTimeMs !== null && batchWaitTimeMs !== void 0 ? batchWaitTimeMs : 50;
    }
}
class NetworkConnector extends AbstractConnector {
    constructor({ urls, defaultChainId }) {
        invariant$3(defaultChainId || Object.keys(urls).length === 1, 'defaultChainId is a required argument with >1 url');
        super({ supportedChainIds: Object.keys(urls).map((k) => Number(k)) });
        this.currentChainId = defaultChainId || Number(Object.keys(urls)[0]);
        this.providers = Object.keys(urls).reduce((accumulator, chainId) => {
            accumulator[Number(chainId)] = new MiniRpcProvider(Number(chainId), urls[Number(chainId)]);
            return accumulator;
        }, {});
    }
    get provider() {
        return this.providers[this.currentChainId];
    }
    activate() {
        return __awaiter$a(this, void 0, void 0, function* () {
            return { provider: this.providers[this.currentChainId], chainId: this.currentChainId, account: null };
        });
    }
    getProvider() {
        return __awaiter$a(this, void 0, void 0, function* () {
            return this.providers[this.currentChainId];
        });
    }
    getChainId() {
        return __awaiter$a(this, void 0, void 0, function* () {
            return this.currentChainId;
        });
    }
    getAccount() {
        return __awaiter$a(this, void 0, void 0, function* () {
            return null;
        });
    }
    deactivate() {
        return;
    }
}

var _a$2;
const NETWORK_URL = 'https://api.avax.network/ext/bc/C/rpc';
const NETWORK_CHAIN_ID = parseInt((_a$2 = process.env.REACT_APP_CHAIN_ID) !== null && _a$2 !== void 0 ? _a$2 : '43114');
const network = new NetworkConnector({
    urls: { [NETWORK_CHAIN_ID]: NETWORK_URL },
    defaultChainId: NETWORK_CHAIN_ID,
});
let networkLibrary;
function getNetworkLibrary() {
    networkLibrary = networkLibrary !== null && networkLibrary !== void 0 ? networkLibrary : new Web3Provider(network.provider);
    return networkLibrary;
}
const injected = new InjectedConnector({
    supportedChainIds: [43113, 43114, 11111, 16],
});
const gnosisSafe = new SafeAppConnector({
    supportedChainIds: [43113, 43114, 11111, 16],
});
const walletlink = new WalletLinkConnector({
    url: NETWORK_URL,
    supportedChainIds: [43113, 43114, 11111, 16],
    appName: 'Pangolin',
    appLogoUrl: 'https://raw.githubusercontent.com/pangolindex/interface/master/public/images/384x384_App_Icon.png',
});
const walletconnect = new WalletConnectConnector({
    rpc: {
        43114: NETWORK_URL,
    },
    qrcode: true,
    bridge: 'https://bridge.walletconnect.org',
});
const xDefi = new DefiConnector({
    supportedChainIds: [1, 43114, 11111, 16],
});

/* eslint-disable max-lines */
const ROUTER_ADDRESS = {
    [ChainId.FUJI]: CHAINS[ChainId.FUJI].contracts.router,
    [ChainId.AVALANCHE]: CHAINS[ChainId.AVALANCHE].contracts.router,
    [ChainId.WAGMI]: CHAINS[ChainId.WAGMI].contracts.router,
    [ChainId.COSTON]: CHAINS[ChainId.COSTON].contracts.router,
};
const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
const NATIVE = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 */
const CUSTOM_BASES = {
    [ChainId.AVALANCHE]: {},
};
const NetworkContextName = 'NETWORK';
// default allowed slippage, in bips
const INITIAL_ALLOWED_SLIPPAGE = 50;
// 10 minutes, denominated in seconds
const DEFAULT_DEADLINE_FROM_NOW = '600';
const PNG$1 = {
    [ChainId.FUJI]: new Token$2(ChainId.FUJI, CHAINS[ChainId.FUJI].contracts.png, 18, CHAINS[ChainId.FUJI].png_symbol, 'Pangolin'),
    [ChainId.AVALANCHE]: new Token$2(ChainId.AVALANCHE, CHAINS[ChainId.AVALANCHE].contracts.png, 18, CHAINS[ChainId.AVALANCHE].png_symbol, 'Pangolin'),
    [ChainId.WAGMI]: new Token$2(ChainId.WAGMI, CHAINS[ChainId.WAGMI].contracts.png, 18, CHAINS[ChainId.WAGMI].png_symbol, 'Wagmi Pangolin'),
    [ChainId.COSTON]: new Token$2(ChainId.COSTON, CHAINS[ChainId.COSTON].contracts.png, 18, CHAINS[ChainId.COSTON].png_symbol, 'Coston Pangolin'),
};
const USDT = {
    [ChainId.FUJI]: new Token$2(ChainId.FUJI, ZERO_ADDRESS, 6, 'USDT', 'Tether USD'),
    [ChainId.AVALANCHE]: new Token$2(ChainId.AVALANCHE, '0xde3A24028580884448a5397872046a019649b084', 6, 'USDT', 'Tether USD'),
    [ChainId.WAGMI]: new Token$2(ChainId.WAGMI, ZERO_ADDRESS, 6, 'USDT', 'Tether USD'),
    [ChainId.COSTON]: new Token$2(ChainId.COSTON, ZERO_ADDRESS, 6, '', ''),
};
const USDTe = {
    [ChainId.FUJI]: new Token$2(ChainId.FUJI, ZERO_ADDRESS, 6, 'USDT.e', 'Tether USD'),
    [ChainId.AVALANCHE]: new Token$2(ChainId.AVALANCHE, '0xc7198437980c041c805A1EDcbA50c1Ce5db95118', 6, 'USDT.e', 'Tether USD'),
    [ChainId.WAGMI]: new Token$2(ChainId.WAGMI, ZERO_ADDRESS, 6, 'USDT.e', 'Tether USD'),
    [ChainId.COSTON]: new Token$2(ChainId.COSTON, ZERO_ADDRESS, 6, '', ''),
};
const UST = {
    [ChainId.FUJI]: new Token$2(ChainId.FUJI, ZERO_ADDRESS, 6, 'UST', 'Wormhole UST'),
    [ChainId.AVALANCHE]: new Token$2(ChainId.AVALANCHE, '0xb599c3590F42f8F995ECfa0f85D2980B76862fc1', 6, 'UST', 'Wormhole UST'),
    [ChainId.WAGMI]: new Token$2(ChainId.WAGMI, ZERO_ADDRESS, 6, 'UST', 'Wormhole UST'),
    [ChainId.COSTON]: new Token$2(ChainId.COSTON, ZERO_ADDRESS, 6, '', ''),
};
const axlUST = {
    [ChainId.FUJI]: new Token$2(ChainId.FUJI, ZERO_ADDRESS, 6, 'axlUST', 'Axelar Wrapped UST'),
    [ChainId.AVALANCHE]: new Token$2(ChainId.AVALANCHE, '0x260Bbf5698121EB85e7a74f2E45E16Ce762EbE11', 6, 'axlUST', 'Axelar Wrapped UST'),
    [ChainId.WAGMI]: new Token$2(ChainId.WAGMI, ZERO_ADDRESS, 18, 'axlUST', 'Axelar Wrapped UST'),
    [ChainId.COSTON]: new Token$2(ChainId.COSTON, ZERO_ADDRESS, 18, '', ''),
};
const USDC = {
    [ChainId.FUJI]: new Token$2(ChainId.FUJI, ZERO_ADDRESS, 6, 'USDC', 'USD Coin'),
    [ChainId.AVALANCHE]: new Token$2(ChainId.AVALANCHE, '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E', 6, 'USDC', 'USD Coin'),
    [ChainId.WAGMI]: new Token$2(ChainId.WAGMI, ZERO_ADDRESS, 6, 'USDC', 'USD Coin'),
    [ChainId.COSTON]: new Token$2(ChainId.COSTON, ZERO_ADDRESS, 6, '', ''),
};
const USDCe = {
    [ChainId.FUJI]: new Token$2(ChainId.FUJI, ZERO_ADDRESS, 6, 'USDC.e', 'USD Coin'),
    [ChainId.AVALANCHE]: new Token$2(ChainId.AVALANCHE, '0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664', 6, 'USDC.e', 'USD Coin'),
    [ChainId.WAGMI]: new Token$2(ChainId.WAGMI, ZERO_ADDRESS, 6, 'USDC.e', 'USD Coin'),
    [ChainId.COSTON]: new Token$2(ChainId.COSTON, ZERO_ADDRESS, 6, '', ''),
};
// these tokens can be directly linked to (via url params) in the swap page without prompting a warning
const TRUSTED_TOKEN_ADDRESSES = {
    [ChainId.FUJI]: [],
    [ChainId.AVALANCHE]: [WAVAX[ChainId.AVALANCHE].address, PNG$1[ChainId.AVALANCHE].address],
    [ChainId.WAGMI]: [WAVAX[ChainId.WAGMI].address, PNG$1[ChainId.WAGMI].address],
    [ChainId.COSTON]: [WAVAX[ChainId.COSTON].address, PNG$1[ChainId.COSTON].address],
};
const SWAP_DEFAULT_CURRENCY = {
    [ChainId.AVALANCHE]: {
        inputCurrency: 'AVAX',
        outputCurrency: USDC[ChainId.AVALANCHE].address,
    },
    [ChainId.FUJI]: {
        inputCurrency: '',
        outputCurrency: '',
    },
    [ChainId.WAGMI]: {
        inputCurrency: '',
        outputCurrency: '',
    },
    [ChainId.COSTON]: {
        inputCurrency: '',
        outputCurrency: '',
    },
};
const DAIe = {
    [ChainId.FUJI]: new Token$2(ChainId.FUJI, ZERO_ADDRESS, 18, 'DAI.e', 'Dai Stablecoin'),
    [ChainId.AVALANCHE]: new Token$2(ChainId.AVALANCHE, '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70', 18, 'DAI.e', 'Dai Stablecoin'),
    [ChainId.WAGMI]: new Token$2(ChainId.WAGMI, ZERO_ADDRESS, 18, 'DAI.e', 'Dai Stablecoin'),
    [ChainId.COSTON]: new Token$2(ChainId.COSTON, ZERO_ADDRESS, 18, '', ''),
};
// used to construct intermediary pairs for trading
const BASES_TO_CHECK_TRADES_AGAINST = {
    [ChainId.FUJI]: [WAVAX[ChainId.FUJI], PNG$1[ChainId.FUJI]],
    [ChainId.AVALANCHE]: [
        WAVAX[ChainId.AVALANCHE],
        PNG$1[ChainId.AVALANCHE],
        USDTe[ChainId.AVALANCHE],
        DAIe[ChainId.AVALANCHE],
        USDCe[ChainId.AVALANCHE],
        UST[ChainId.AVALANCHE],
        axlUST[ChainId.AVALANCHE],
        USDC[ChainId.AVALANCHE],
    ],
    [ChainId.WAGMI]: [WAVAX[ChainId.WAGMI], PNG$1[ChainId.WAGMI]],
    [ChainId.COSTON]: [WAVAX[ChainId.COSTON], PNG$1[ChainId.COSTON]],
};
// one basis point
const ONE_BIPS = new Percent$1(JSBI$1.BigInt(1), JSBI$1.BigInt(10000));
const BIPS_BASE = JSBI$1.BigInt(10000);
// used for warning states
const ALLOWED_PRICE_IMPACT_LOW = new Percent$1(JSBI$1.BigInt(100), BIPS_BASE); // 1%
const ALLOWED_PRICE_IMPACT_MEDIUM = new Percent$1(JSBI$1.BigInt(300), BIPS_BASE); // 3%
const ALLOWED_PRICE_IMPACT_HIGH = new Percent$1(JSBI$1.BigInt(500), BIPS_BASE); // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN = new Percent$1(JSBI$1.BigInt(1000), BIPS_BASE); // 10%
// for non expert mode disable swaps above this
const BLOCKED_PRICE_IMPACT_NON_EXPERT = new Percent$1(JSBI$1.BigInt(1500), BIPS_BASE); // 15%
// used to ensure the user doesn't send so much ETH so they end up with <.01
const MIN_ETH = JSBI$1.exponentiate(JSBI$1.BigInt(10), JSBI$1.BigInt(16)); // .01 ETH
const PANGOLIN_TOKENS_REPO_RAW_BASE_URL = `https://raw.githubusercontent.com/pangolindex/tokens`;
const ANALYTICS_PAGE = 'https://info.pangolin.exchange';
const TIMEFRAME = [
    {
        description: 'DAY',
        label: '1D',
        interval: 3600,
        momentIdentifier: 'day',
        days: '1',
    },
    {
        description: 'WEEK',
        label: '1W',
        interval: 86400,
        momentIdentifier: 'week',
        days: '7',
    },
    {
        description: 'MONTH',
        label: '1M',
        interval: 604800,
        momentIdentifier: 'month',
        days: '30',
    },
    {
        description: 'YEAR',
        label: '1Y',
        interval: 2629746,
        momentIdentifier: 'year',
        days: '365',
    },
    {
        description: 'ALL',
        label: 'ALL',
        interval: 2629746,
        momentIdentifier: '',
        days: 'max',
    },
];
const SUBGRAPH_BASE_URL = `https://api.thegraph.com/subgraphs/name/pangolindex`;
const LANDING_PAGE = 'https://pangolin.exchange';
const EVM_SUPPORTED_WALLETS = {
    INJECTED: {
        connector: injected,
        name: 'Injected',
        iconName: 'arrow-right.svg',
        description: 'Injected web3 provider.',
        href: null,
        color: '#010101',
        primary: true,
    },
    METAMASK: {
        connector: injected,
        name: 'MetaMask',
        iconName: 'metamask.png',
        description: 'Easy-to-use browser extension.',
        href: null,
        color: '#E8831D',
    },
    GNOSISSAFE: {
        connector: gnosisSafe,
        name: 'Gnosis Safe',
        iconName: 'gnosis_safe.png',
        description: 'Gnosis Safe Multisig Wallet.',
        href: null,
        color: '#010101',
    },
    WALLET_LINK: {
        connector: walletlink,
        name: 'Coinbase Wallet',
        iconName: 'coinbaseWalletIcon.svg',
        description: 'Use Coinbase Wallet app on mobile device',
        href: null,
        color: '#315CF5',
    },
    WALLET_CONNECT: {
        connector: walletconnect,
        name: 'Wallet Connect',
        iconName: 'walletConnectIcon.svg',
        description: 'Use Wallet Connect',
        href: null,
        color: '#315CF5',
    },
    XDEFI: {
        connector: xDefi,
        name: 'XDEFI Wallet',
        iconName: 'xDefi.png',
        description: window.xfi && window.xfi.ethereum ? 'Easy-to-use browser extension.' : 'Please Install',
        href: null,
        color: '#315CF5',
    },
    RABBY: {
        connector: injected,
        name: 'Rabby Wallet',
        iconName: 'rabby.svg',
        description: 'Easy-to-use browser extension.',
        href: null,
        color: '#7a7cff',
    },
};
const AVALANCHE_CHAIN_PARAMS = {
    chainId: '0xa86a',
    chainName: 'Avalanche Mainnet C-Chain',
    nativeCurrency: {
        name: 'Avalanche',
        symbol: 'AVAX',
        decimals: 18,
    },
    rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
    blockExplorerUrls: ['https://snowtrace.io//'],
};
const IS_IN_IFRAME = window.parent !== window;
const DIRECTUS_URL_NEWS = `https://p7gm7mqi.directus.app/items/news?`;
const COINGEKO_BASE_URL = `https://api.coingecko.com/api/v3/`;
const OPEN_API_DEBANK = 'https://openapi.debank.com/v1/user';
/* eslint-enable max-lines */

const getTokenLogoURL = (address, size = 24) => `${PANGOLIN_TOKENS_REPO_RAW_BASE_URL}/main/assets/${address}/logo_${size}.png`;

function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

function _objectWithoutProperties$v(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$u(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$u(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var AlertTriangle = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$v(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$H({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  }), /*#__PURE__*/React$2.createElement("line", {
    x1: "12",
    y1: "9",
    x2: "12",
    y2: "13"
  }), /*#__PURE__*/React$2.createElement("line", {
    x1: "12",
    y1: "17",
    x2: "12.01",
    y2: "17"
  }));
});
AlertTriangle.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
AlertTriangle.displayName = 'AlertTriangle';
var AlertTriangle$1 = AlertTriangle;

function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

function _objectWithoutProperties$u(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$t(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$t(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ArrowDown = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$u(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$G({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }), /*#__PURE__*/React$2.createElement("polyline", {
    points: "19 12 12 19 5 12"
  }));
});
ArrowDown.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
ArrowDown.displayName = 'ArrowDown';
var ArrowDown$1 = ArrowDown;

function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

function _objectWithoutProperties$t(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$s(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$s(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ArrowLeft = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$t(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$F({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("line", {
    x1: "19",
    y1: "12",
    x2: "5",
    y2: "12"
  }), /*#__PURE__*/React$2.createElement("polyline", {
    points: "12 19 5 12 12 5"
  }));
});
ArrowLeft.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
ArrowLeft.displayName = 'ArrowLeft';
var ArrowLeft$1 = ArrowLeft;

function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

function _objectWithoutProperties$s(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$r(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$r(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ArrowRight = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$s(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$E({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }), /*#__PURE__*/React$2.createElement("polyline", {
    points: "12 5 19 12 12 19"
  }));
});
ArrowRight.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
ArrowRight.displayName = 'ArrowRight';
var ArrowRight$1 = ArrowRight;

function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

function _objectWithoutProperties$r(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$q(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$q(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ArrowUpCircle = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$r(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$D({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React$2.createElement("polyline", {
    points: "16 12 12 8 8 12"
  }), /*#__PURE__*/React$2.createElement("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "8"
  }));
});
ArrowUpCircle.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
ArrowUpCircle.displayName = 'ArrowUpCircle';
var ArrowUpCircle$1 = ArrowUpCircle;

function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

function _objectWithoutProperties$q(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$p(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$p(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ChevronDown = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$q(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$C({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("polyline", {
    points: "6 9 12 15 18 9"
  }));
});
ChevronDown.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
ChevronDown.displayName = 'ChevronDown';
var ChevronDown$1 = ChevronDown;

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

function _objectWithoutProperties$p(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$o(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$o(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ChevronRight = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$p(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$B({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("polyline", {
    points: "9 18 15 12 9 6"
  }));
});
ChevronRight.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
ChevronRight.displayName = 'ChevronRight';
var ChevronRight$1 = ChevronRight;

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

function _objectWithoutProperties$o(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$n(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$n(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ChevronUp = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$o(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$A({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("polyline", {
    points: "18 15 12 9 6 15"
  }));
});
ChevronUp.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
ChevronUp.displayName = 'ChevronUp';
var ChevronUp$1 = ChevronUp;

function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

function _objectWithoutProperties$n(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$m(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$m(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Divide = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$n(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$z({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("circle", {
    cx: "12",
    cy: "6",
    r: "2"
  }), /*#__PURE__*/React$2.createElement("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }), /*#__PURE__*/React$2.createElement("circle", {
    cx: "12",
    cy: "18",
    r: "2"
  }));
});
Divide.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
Divide.displayName = 'Divide';
var Divide$1 = Divide;

function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

function _objectWithoutProperties$m(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$l(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$l(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var EyeOff = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$m(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$y({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("path", {
    d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
  }), /*#__PURE__*/React$2.createElement("line", {
    x1: "1",
    y1: "1",
    x2: "23",
    y2: "23"
  }));
});
EyeOff.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
EyeOff.displayName = 'EyeOff';
var EyeOff$1 = EyeOff;

function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

function _objectWithoutProperties$l(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$k(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$k(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Eye = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$l(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$x({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("path", {
    d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
  }), /*#__PURE__*/React$2.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }));
});
Eye.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
Eye.displayName = 'Eye';
var Eye$1 = Eye;

function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

function _objectWithoutProperties$k(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$j(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$j(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var HelpCircle = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$k(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$w({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React$2.createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
  }), /*#__PURE__*/React$2.createElement("line", {
    x1: "12",
    y1: "17",
    x2: "12.01",
    y2: "17"
  }));
});
HelpCircle.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
HelpCircle.displayName = 'HelpCircle';
var HelpCircle$1 = HelpCircle;

function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

function _objectWithoutProperties$j(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$i(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$i(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Info$1 = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$j(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$v({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React$2.createElement("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "12"
  }), /*#__PURE__*/React$2.createElement("line", {
    x1: "12",
    y1: "8",
    x2: "12.01",
    y2: "8"
  }));
});
Info$1.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
Info$1.displayName = 'Info';
var Info$2 = Info$1;

function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

function _objectWithoutProperties$i(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$h(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$h(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Link$2 = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$i(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$u({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("path", {
    d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
  }), /*#__PURE__*/React$2.createElement("path", {
    d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
  }));
});
Link$2.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
Link$2.displayName = 'Link';
var Link$3 = Link$2;

function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

function _objectWithoutProperties$h(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$g(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$g(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Lock = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$h(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$t({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("rect", {
    x: "3",
    y: "11",
    width: "18",
    height: "11",
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/React$2.createElement("path", {
    d: "M7 11V7a5 5 0 0 1 10 0v4"
  }));
});
Lock.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
Lock.displayName = 'Lock';
var Lock$1 = Lock;

function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

function _objectWithoutProperties$g(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$f(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$f(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Plus = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$g(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$s({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }), /*#__PURE__*/React$2.createElement("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }));
});
Plus.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
Plus.displayName = 'Plus';
var Plus$1 = Plus;

function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

function _objectWithoutProperties$f(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$e(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$e(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var RefreshCcw = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$f(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$r({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("polyline", {
    points: "1 4 1 10 7 10"
  }), /*#__PURE__*/React$2.createElement("polyline", {
    points: "23 20 23 14 17 14"
  }), /*#__PURE__*/React$2.createElement("path", {
    d: "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
  }));
});
RefreshCcw.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
RefreshCcw.displayName = 'RefreshCcw';
var RefreshCcw$1 = RefreshCcw;

function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

function _objectWithoutProperties$e(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$d(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$d(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var X = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      rest = _objectWithoutProperties$e(_ref, ["color", "size"]);

  return /*#__PURE__*/React$2.createElement("svg", _extends$q({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, rest), /*#__PURE__*/React$2.createElement("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), /*#__PURE__*/React$2.createElement("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }));
});
X.propTypes = {
  color: PropTypes$2.string,
  size: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.number])
};
X.displayName = 'X';
var X$1 = X;

const BAD_SRCS = {};
const Logo$1 = (_a) => {
    var { srcs, alt } = _a, rest = __rest$1(_a, ["srcs", "alt"]);
    const [, refresh] = useState(0);
    const src = srcs.find((srcVal) => !BAD_SRCS[srcVal]);
    if (src) {
        return (jsx("img", Object.assign({}, rest, { alt: alt, src: src, onError: () => {
                BAD_SRCS[src] = true;
                refresh((i) => i + 1);
            } }), void 0));
    }
    return jsx(HelpCircle$1, Object.assign({}, rest), void 0);
};

const StyledLogo = styled(Logo$1) `
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: ${({ size }) => size};
  /* box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075); */
`;

function CurrencyLogo({ currency, size = 24, style, imageSize = size, }) {
    var _a;
    const srcs = useMemo(() => {
        var _a;
        if (currency === CAVAX[ChainId.AVALANCHE] ||
            currency === CAVAX[ChainId.WAGMI] ||
            currency === CAVAX[ChainId.COSTON])
            return [];
        if (currency instanceof Token$2 || !!currency.address) {
            const primarySrc = getTokenLogoURL((_a = currency) === null || _a === void 0 ? void 0 : _a.address, imageSize);
            return [primarySrc];
        }
        return [];
    }, [currency]);
    if (deepEqual$1(currency, CAVAX[ChainId.AVALANCHE])) {
        return jsx(AvaxLogo, { size: `${size}px` }, void 0);
    }
    else if (deepEqual$1(currency, CAVAX[ChainId.WAGMI])) {
        return jsx(WgmLogo, { size: `${size}px` }, void 0);
    }
    else if (deepEqual$1(currency, CAVAX[ChainId.COSTON])) {
        return jsx(CflrLogo, { size: `${size}px` }, void 0);
    }
    return jsx(StyledLogo, { size: `${size}px`, srcs: srcs, alt: `${(_a = currency === null || currency === void 0 ? void 0 : currency.symbol) !== null && _a !== void 0 ? _a : 'token'} logo`, style: style }, void 0);
}

const Wrapper$3 = styled.div `
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: ${({ sizeraw, margin }) => margin && (sizeraw / 3 + 8).toString() + 'px'};
`;
const HigherLogo = styled(CurrencyLogo) `
  z-index: 2;
`;
const CoveredLogo = styled(CurrencyLogo) `
  position: absolute;
  left: ${({ sizeraw }) => '-' + (sizeraw / 2).toString() + 'px'} !important;
`;

const DoubleCurrencyLogo = ({ currency0, currency1, size = 24, margin = false }) => {
    return (jsxs(Wrapper$3, Object.assign({ sizeraw: size, margin: margin }, { children: [currency0 && jsx(HigherLogo, { currency: currency0, size: size }, void 0), currency1 && (jsx(Box, Object.assign({ ml: '-5px', display: 'flex' }, { children: jsx(CoveredLogo, { currency: currency1, size: size, sizeraw: size }, void 0) }), void 0))] }), void 0));
};

const CurrencySelect = styled.button `
  align-items: center;
  height: 2.2rem;
  font-size: 20px;
  font-weight: 500;
  background-color: ${({ selected, theme }) => (selected ? theme.color2 : theme.primary)};
  color: ${({ selected, theme }) => (selected ? theme.text1 : theme.white)};
  border-radius: 12px;
  box-shadow: ${({ selected }) => (selected ? 'none' : '0px 6px 10px rgba(0, 0, 0, 0.075)')};
  outline: none;
  cursor: pointer;
  user-select: none;
  border: none;
  padding: 0 0.5rem;

  /* :focus,
  :hover {
    background-color: ${({ selected, theme }) => (selected ? theme.bg2 : curriedDarken(0.05, theme.primary))};
  } */
`;
const Aligner = styled.span `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const StyledTokenName = styled.span `
  ${({ active }) => (active ? '  margin: 0 0.25rem 0 0.75rem;' : '  margin: 0 0.25rem 0 0.25rem;')}
  font-size:  ${({ active }) => (active ? '20px' : '16px')};
  color: ${({ active, theme }) => (!active ? theme.black : undefined)};
`;

const CurrencyInput = (props) => {
    const { pair, currency, onTokenClick } = props, rest = __rest$1(props, ["pair", "currency", "onTokenClick"]);
    const renderCurrency = () => {
        if (pair) {
            return jsx(DoubleCurrencyLogo, { currency0: pair.token0, currency1: pair.token1, size: 24, margin: true }, void 0);
        }
        else if (currency) {
            return jsx(CurrencyLogo, { currency: currency, size: 24, imageSize: 48 }, void 0);
        }
        else {
            return null;
        }
    };
    const renderStyletoken = () => {
        if (pair) {
            return (jsxs(StyledTokenName, Object.assign({ className: "pair-name-container" }, { children: [pair === null || pair === void 0 ? void 0 : pair.token0.symbol, ":", pair === null || pair === void 0 ? void 0 : pair.token1.symbol] }), void 0));
        }
        else
            return (jsx(StyledTokenName, Object.assign({ className: "token-symbol-container", active: Boolean(currency && currency.symbol) }, { children: (currency && currency.symbol && currency.symbol.length > 20
                    ? currency.symbol.slice(0, 4) +
                        '...' +
                        currency.symbol.slice(currency.symbol.length - 5, currency.symbol.length)
                    : currency === null || currency === void 0 ? void 0 : currency.symbol) || 'Select Token' }), void 0));
    };
    const addonAfter = () => {
        return (jsx(CurrencySelect, Object.assign({ selected: !!currency, className: "open-currency-select-button", onClick: () => {
                onTokenClick && onTokenClick();
            } }, { children: jsxs(Aligner, { children: [renderCurrency(), renderStyletoken(), jsx(ChevronDown$1, { color: !Boolean(currency && currency.symbol) ? 'black' : undefined }, void 0)] }, void 0) }), void 0));
    };
    return (jsx(Box, { children: jsx(TextInput, Object.assign({}, rest, { addonAfter: addonAfter() }), void 0) }, void 0));
};

const Root$5 = styled.div `
  flex-direction: row;
  display: inline-flex;
  background: ${({ theme }) => { var _a; return (_a = theme.toggleButton) === null || _a === void 0 ? void 0 : _a.backgroundColor; }};
  border-radius: 4px;
  align-items: center;
  padding: 2px;
  width: 100%;
`;
const TextButton = styled.div `
  margin-right: 4px;
  background: ${({ theme, selected }) => { var _a, _b; return selected ? (_a = theme.toggleButton) === null || _a === void 0 ? void 0 : _a.selectedColor : (_b = theme.toggleButton) === null || _b === void 0 ? void 0 : _b.backgroundColor; }};
  color: ${({ theme }) => { var _a; return (_a = theme.toggleButton) === null || _a === void 0 ? void 0 : _a.fontColor; }};
  border-radius: 4px;
  padding: 3px 5px;
  cursor: pointer;
  text-align: center;
  width: 100%;

  &:last-child {
    margin-right: 0px;
  }
`;

const ToggleButtons = (props) => {
    const { value, onChange, options } = props;
    return (jsx(Root$5, { children: (options || []).map((option, i) => (jsx(TextButton, Object.assign({ selected: option === value, onClick: () => {
                onChange && onChange(option);
            } }, { children: option }), i))) }, void 0));
};

const PendingWrapper = styled(Box) `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
`;
const Loader = (props) => {
    const { size, label } = props;
    return (jsx(PendingWrapper, { children: jsxs(Box, Object.assign({ mb: '15px', display: "flex", alignItems: "center", flexDirection: "column" }, { children: [jsxs(Box, Object.assign({ width: size, height: size, position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }, { children: [jsx(Loading, {}, void 0), jsx(Box, Object.assign({ position: "absolute" }, { children: jsx(LogoIcon, {}, void 0) }), void 0)] }), void 0), label && (jsx(Text$1, Object.assign({ fontWeight: 500, fontSize: 20, color: "text1", textAlign: "center", mt: 10 }, { children: label }), void 0))] }), void 0) }, void 0));
};

const initialWeb3State = {
    library: undefined,
    chainId: undefined,
    account: undefined,
};
const Web3Context = createContext({});
const usePangolinWeb3 = () => {
    const context = useContext(Web3Context);
    if (context === undefined) {
        throw new Error('usePangolinWeb3 must be used within a component wrapped with PangolinWeb3Provider');
    }
    return context;
};
const PangolinWeb3Provider = ({ children, library, chainId, account, }) => {
    const [state, setState] = useState(initialWeb3State);
    useEffect(() => {
        setState({
            library,
            chainId: chainId || ChainId.AVALANCHE,
            account,
        });
    }, [library, chainId, account]);
    return (jsx(Web3Context.Provider, Object.assign({ value: Object.assign({}, state) }, { children: children }), void 0));
};
const useChainId = () => {
    const { chainId } = usePangolinWeb3();
    return chainId || ChainId.AVALANCHE;
};

const version$a = "abi/5.6.2";

const logger$9 = new Logger$1(version$a);
const _constructorGuard$1 = {};
let ModifiersBytes = { calldata: true, memory: true, storage: true };
let ModifiersNest = { calldata: true, memory: true };
function checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if (ModifiersBytes[name]) {
            return true;
        }
    }
    else if (type === "address") {
        if (name === "payable") {
            return true;
        }
    }
    else if (type.indexOf("[") >= 0 || type === "tuple") {
        if (ModifiersNest[name]) {
            return true;
        }
    }
    if (ModifiersBytes[name] || name === "payable") {
        logger$9.throwArgumentError("invalid modifier", "name", name);
    }
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        logger$9.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = { type: "", name: "", parent: parent, state: { allowType: true } };
        if (allowIndexed) {
            node.indexed = false;
        }
        return node;
    }
    let parent = { type: "", name: "", state: { allowType: true } };
    let node = parent;
    for (let i = 0; i < param.length; i++) {
        let c = param[i];
        switch (c) {
            case "(":
                if (node.state.allowType && node.type === "") {
                    node.type = "tuple";
                }
                else if (!node.state.allowParams) {
                    throwError(i);
                }
                node.state.allowType = false;
                node.type = verifyType(node.type);
                node.components = [newNode(node)];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) {
                        throwError(i);
                    }
                    node.indexed = true;
                    node.name = "";
                }
                if (checkModifier(node.type, node.name)) {
                    node.name = "";
                }
                node.type = verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) {
                    throwError(i);
                }
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) {
                        throwError(i);
                    }
                    node.indexed = true;
                    node.name = "";
                }
                if (checkModifier(node.type, node.name)) {
                    node.name = "";
                }
                node.type = verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) {
                                throwError(i);
                            }
                            if (node.indexed) {
                                throwError(i);
                            }
                            node.indexed = true;
                            node.name = "";
                        }
                        else if (checkModifier(node.type, node.name)) {
                            node.name = "";
                        }
                        else {
                            node.state.allowName = false;
                        }
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) {
                    throwError(i);
                }
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) {
                    throwError(i);
                }
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                }
                else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                }
                else if (node.state.readArray) {
                    node.type += c;
                }
                else {
                    throwError(i);
                }
        }
    }
    if (node.parent) {
        logger$9.throwArgumentError("unexpected eof", "param", param);
    }
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) {
            throwError(originalParam.length - 7);
        }
        if (node.indexed) {
            throwError(originalParam.length - 7);
        }
        node.indexed = true;
        node.name = "";
    }
    else if (checkModifier(node.type, node.name)) {
        node.name = "";
    }
    parent.type = verifyType(parent.type);
    return parent;
}
function populate(object, params) {
    for (let key in params) {
        defineReadOnly(object, key, params[key]);
    }
}
const FormatTypes = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class ParamType {
    constructor(constructorGuard, params) {
        if (constructorGuard !== _constructorGuard$1) {
            logger$9.throwError("use fromString", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "new ParamType()"
            });
        }
        populate(this, params);
        let match = this.type.match(paramTypeArray);
        if (match) {
            populate(this, {
                arrayLength: parseInt(match[2] || "-1"),
                arrayChildren: ParamType.fromObject({
                    type: match[1],
                    components: this.components
                }),
                baseType: "array"
            });
        }
        else {
            populate(this, {
                arrayLength: null,
                arrayChildren: null,
                baseType: ((this.components != null) ? "tuple" : this.type)
            });
        }
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            logger$9.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            let result = {
                type: ((this.baseType === "tuple") ? "tuple" : this.type),
                name: (this.name || undefined)
            };
            if (typeof (this.indexed) === "boolean") {
                result.indexed = this.indexed;
            }
            if (this.components) {
                result.components = this.components.map((comp) => JSON.parse(comp.format(format)));
            }
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        }
        else {
            if (this.baseType === "tuple") {
                if (format !== FormatTypes.sighash) {
                    result += this.type;
                }
                result += "(" + this.components.map((comp) => comp.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ")";
            }
            else {
                result += this.type;
            }
        }
        if (format !== FormatTypes.sighash) {
            if (this.indexed === true) {
                result += " indexed";
            }
            if (format === FormatTypes.full && this.name) {
                result += " " + this.name;
            }
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof (value) === "string") {
            return ParamType.fromString(value, allowIndexed);
        }
        return ParamType.fromObject(value);
    }
    static fromObject(value) {
        if (ParamType.isParamType(value)) {
            return value;
        }
        return new ParamType(_constructorGuard$1, {
            name: (value.name || null),
            type: verifyType(value.type),
            indexed: ((value.indexed == null) ? null : !!value.indexed),
            components: (value.components ? value.components.map(ParamType.fromObject) : null)
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return ParamType.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify(parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function parseParams(value, allowIndex) {
    return splitNesting(value).map((param) => ParamType.fromString(param, allowIndex));
}
class Fragment {
    constructor(constructorGuard, params) {
        if (constructorGuard !== _constructorGuard$1) {
            logger$9.throwError("use a static from method", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "new Fragment()"
            });
        }
        populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if (Fragment.isFragment(value)) {
            return value;
        }
        if (typeof (value) === "string") {
            return Fragment.fromString(value);
        }
        return Fragment.fromObject(value);
    }
    static fromObject(value) {
        if (Fragment.isFragment(value)) {
            return value;
        }
        switch (value.type) {
            case "function":
                return FunctionFragment.fromObject(value);
            case "event":
                return EventFragment.fromObject(value);
            case "constructor":
                return ConstructorFragment.fromObject(value);
            case "error":
                return ErrorFragment.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return logger$9.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") {
            return EventFragment.fromString(value.substring(5).trim());
        }
        else if (value.split(" ")[0] === "function") {
            return FunctionFragment.fromString(value.substring(8).trim());
        }
        else if (value.split("(")[0].trim() === "constructor") {
            return ConstructorFragment.fromString(value.trim());
        }
        else if (value.split(" ")[0] === "error") {
            return ErrorFragment.fromString(value.substring(5).trim());
        }
        return logger$9.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class EventFragment extends Fragment {
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            logger$9.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            return JSON.stringify({
                type: "event",
                anonymous: this.anonymous,
                name: this.name,
                inputs: this.inputs.map((input) => JSON.parse(input.format(format)))
            });
        }
        let result = "";
        if (format !== FormatTypes.sighash) {
            result += "event ";
        }
        result += this.name + "(" + this.inputs.map((input) => input.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ") ";
        if (format !== FormatTypes.sighash) {
            if (this.anonymous) {
                result += "anonymous ";
            }
        }
        return result.trim();
    }
    static from(value) {
        if (typeof (value) === "string") {
            return EventFragment.fromString(value);
        }
        return EventFragment.fromObject(value);
    }
    static fromObject(value) {
        if (EventFragment.isEventFragment(value)) {
            return value;
        }
        if (value.type !== "event") {
            logger$9.throwArgumentError("invalid event object", "value", value);
        }
        const params = {
            name: verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: (value.inputs ? value.inputs.map(ParamType.fromObject) : []),
            type: "event"
        };
        return new EventFragment(_constructorGuard$1, params);
    }
    static fromString(value) {
        let match = value.match(regexParen);
        if (!match) {
            logger$9.throwArgumentError("invalid event string", "value", value);
        }
        let anonymous = false;
        match[3].split(" ").forEach((modifier) => {
            switch (modifier.trim()) {
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    logger$9.warn("unknown modifier: " + modifier);
            }
        });
        return EventFragment.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return (value && value._isFragment && value.type === "event");
    }
}
function parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) {
            logger$9.throwArgumentError("invalid human-readable ABI signature", "value", value);
        }
        if (!comps[1].match(/^[0-9]+$/)) {
            logger$9.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        }
        params.gas = BigNumber$1.from(comps[1]);
        return comps[0];
    }
    return value;
}
function parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier) => {
        switch (modifier.trim()) {
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = (result.stateMutability === "view" || result.stateMutability === "pure");
        if (value.constant != null) {
            if ((!!value.constant) !== result.constant) {
                logger$9.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
            }
        }
        // Set (and check things are consistent) the payable property
        result.payable = (result.stateMutability === "payable");
        if (value.payable != null) {
            if ((!!value.payable) !== result.payable) {
                logger$9.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
            }
        }
    }
    else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") {
            logger$9.throwArgumentError("unable to determine stateMutability", "value", value);
        }
        result.constant = !!value.constant;
        if (result.constant) {
            result.stateMutability = "view";
        }
        else {
            result.stateMutability = (result.payable ? "payable" : "nonpayable");
        }
        if (result.payable && result.constant) {
            logger$9.throwArgumentError("cannot have constant payable function", "value", value);
        }
    }
    else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = (result.constant ? "view" : "payable");
    }
    else if (value.type !== "constructor") {
        logger$9.throwArgumentError("unable to determine stateMutability", "value", value);
    }
    return result;
}
class ConstructorFragment extends Fragment {
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            logger$9.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            return JSON.stringify({
                type: "constructor",
                stateMutability: ((this.stateMutability !== "nonpayable") ? this.stateMutability : undefined),
                payable: this.payable,
                gas: (this.gas ? this.gas.toNumber() : undefined),
                inputs: this.inputs.map((input) => JSON.parse(input.format(format)))
            });
        }
        if (format === FormatTypes.sighash) {
            logger$9.throwError("cannot format a constructor for sighash", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "format(sighash)"
            });
        }
        let result = "constructor(" + this.inputs.map((input) => input.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") {
            result += this.stateMutability + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof (value) === "string") {
            return ConstructorFragment.fromString(value);
        }
        return ConstructorFragment.fromObject(value);
    }
    static fromObject(value) {
        if (ConstructorFragment.isConstructorFragment(value)) {
            return value;
        }
        if (value.type !== "constructor") {
            logger$9.throwArgumentError("invalid constructor object", "value", value);
        }
        let state = verifyState(value);
        if (state.constant) {
            logger$9.throwArgumentError("constructor cannot be constant", "value", value);
        }
        const params = {
            name: null,
            type: value.type,
            inputs: (value.inputs ? value.inputs.map(ParamType.fromObject) : []),
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: (value.gas ? BigNumber$1.from(value.gas) : null)
        };
        return new ConstructorFragment(_constructorGuard$1, params);
    }
    static fromString(value) {
        let params = { type: "constructor" };
        value = parseGas(value, params);
        let parens = value.match(regexParen);
        if (!parens || parens[1].trim() !== "constructor") {
            logger$9.throwArgumentError("invalid constructor string", "value", value);
        }
        params.inputs = parseParams(parens[2].trim(), false);
        parseModifiers(parens[3].trim(), params);
        return ConstructorFragment.fromObject(params);
    }
    static isConstructorFragment(value) {
        return (value && value._isFragment && value.type === "constructor");
    }
}
class FunctionFragment extends ConstructorFragment {
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            logger$9.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            return JSON.stringify({
                type: "function",
                name: this.name,
                constant: this.constant,
                stateMutability: ((this.stateMutability !== "nonpayable") ? this.stateMutability : undefined),
                payable: this.payable,
                gas: (this.gas ? this.gas.toNumber() : undefined),
                inputs: this.inputs.map((input) => JSON.parse(input.format(format))),
                outputs: this.outputs.map((output) => JSON.parse(output.format(format))),
            });
        }
        let result = "";
        if (format !== FormatTypes.sighash) {
            result += "function ";
        }
        result += this.name + "(" + this.inputs.map((input) => input.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ") ";
        if (format !== FormatTypes.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") {
                    result += (this.stateMutability + " ");
                }
            }
            else if (this.constant) {
                result += "view ";
            }
            if (this.outputs && this.outputs.length) {
                result += "returns (" + this.outputs.map((output) => output.format(format)).join(", ") + ") ";
            }
            if (this.gas != null) {
                result += "@" + this.gas.toString() + " ";
            }
        }
        return result.trim();
    }
    static from(value) {
        if (typeof (value) === "string") {
            return FunctionFragment.fromString(value);
        }
        return FunctionFragment.fromObject(value);
    }
    static fromObject(value) {
        if (FunctionFragment.isFunctionFragment(value)) {
            return value;
        }
        if (value.type !== "function") {
            logger$9.throwArgumentError("invalid function object", "value", value);
        }
        let state = verifyState(value);
        const params = {
            type: value.type,
            name: verifyIdentifier(value.name),
            constant: state.constant,
            inputs: (value.inputs ? value.inputs.map(ParamType.fromObject) : []),
            outputs: (value.outputs ? value.outputs.map(ParamType.fromObject) : []),
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: (value.gas ? BigNumber$1.from(value.gas) : null)
        };
        return new FunctionFragment(_constructorGuard$1, params);
    }
    static fromString(value) {
        let params = { type: "function" };
        value = parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) {
            logger$9.throwArgumentError("invalid function string", "value", value);
        }
        let parens = comps[0].match(regexParen);
        if (!parens) {
            logger$9.throwArgumentError("invalid function signature", "value", value);
        }
        params.name = parens[1].trim();
        if (params.name) {
            verifyIdentifier(params.name);
        }
        params.inputs = parseParams(parens[2], false);
        parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match(regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") {
                logger$9.throwArgumentError("unexpected tokens", "value", value);
            }
            params.outputs = parseParams(returns[2], false);
        }
        else {
            params.outputs = [];
        }
        return FunctionFragment.fromObject(params);
    }
    static isFunctionFragment(value) {
        return (value && value._isFragment && value.type === "function");
    }
}
//export class StructFragment extends Fragment {
//}
function checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") {
        logger$9.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    }
    return fragment;
}
class ErrorFragment extends Fragment {
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            logger$9.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            return JSON.stringify({
                type: "error",
                name: this.name,
                inputs: this.inputs.map((input) => JSON.parse(input.format(format))),
            });
        }
        let result = "";
        if (format !== FormatTypes.sighash) {
            result += "error ";
        }
        result += this.name + "(" + this.inputs.map((input) => input.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof (value) === "string") {
            return ErrorFragment.fromString(value);
        }
        return ErrorFragment.fromObject(value);
    }
    static fromObject(value) {
        if (ErrorFragment.isErrorFragment(value)) {
            return value;
        }
        if (value.type !== "error") {
            logger$9.throwArgumentError("invalid error object", "value", value);
        }
        const params = {
            type: value.type,
            name: verifyIdentifier(value.name),
            inputs: (value.inputs ? value.inputs.map(ParamType.fromObject) : [])
        };
        return checkForbidden(new ErrorFragment(_constructorGuard$1, params));
    }
    static fromString(value) {
        let params = { type: "error" };
        let parens = value.match(regexParen);
        if (!parens) {
            logger$9.throwArgumentError("invalid error signature", "value", value);
        }
        params.name = parens[1].trim();
        if (params.name) {
            verifyIdentifier(params.name);
        }
        params.inputs = parseParams(parens[2], false);
        return checkForbidden(ErrorFragment.fromObject(params));
    }
    static isErrorFragment(value) {
        return (value && value._isFragment && value.type === "error");
    }
}
function verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) {
        type = "uint256" + type.substring(4);
    }
    else if (type.match(/^int($|[^1-9])/)) {
        type = "int256" + type.substring(3);
    }
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function verifyIdentifier(value) {
    if (!value || !value.match(regexIdentifier)) {
        logger$9.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    }
    return value;
}
const regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for (let offset = 0; offset < value.length; offset++) {
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        }
        else {
            accum += c;
            if (c === "(") {
                depth++;
            }
            else if (c === ")") {
                depth--;
                if (depth === -1) {
                    logger$9.throwArgumentError("unbalanced parenthesis", "value", value);
                }
            }
        }
    }
    if (accum) {
        result.push(accum);
    }
    return result;
}

const logger$8 = new Logger$1(version$a);
function checkResultErrors(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function (path, object) {
        if (!Array.isArray(object)) {
            return;
        }
        for (let key in object) {
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            }
            catch (error) {
                errors.push({ path: childPath, error: error });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class Coder {
    constructor(name, type, localName, dynamic) {
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        logger$8.throwArgumentError(message, this.localName, value);
    }
}
class Writer {
    constructor(wordSize) {
        defineReadOnly(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return hexConcat(this._data);
    }
    get length() { return this._dataLength; }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData(concat$4(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = arrayify$1(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) {
            bytes = concat$4([bytes, this._padding.slice(paddingOffset)]);
        }
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = arrayify$1(BigNumber$1.from(value));
        if (bytes.length > this.wordSize) {
            logger$8.throwError("value out-of-bounds", Logger$1.errors.BUFFER_OVERRUN, {
                length: this.wordSize,
                offset: bytes.length
            });
        }
        if (bytes.length % this.wordSize) {
            bytes = concat$4([this._padding.slice(bytes.length % this.wordSize), bytes]);
        }
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value) => {
            this._data[offset] = this._getValue(value);
        };
    }
}
class Reader {
    constructor(data, wordSize, coerceFunc, allowLoose) {
        defineReadOnly(this, "_data", arrayify$1(data));
        defineReadOnly(this, "wordSize", wordSize || 32);
        defineReadOnly(this, "_coerceFunc", coerceFunc);
        defineReadOnly(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() { return hexlify(this._data); }
    get consumed() { return this._offset; }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) {
            value = value.toNumber();
        }
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) {
            return this._coerceFunc(name, value);
        }
        return Reader.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) {
                alignedLength = length;
            }
            else {
                logger$8.throwError("data out-of-bounds", Logger$1.errors.BUFFER_OVERRUN, {
                    length: this._data.length,
                    offset: this._offset + alignedLength
                });
            }
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new Reader(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return BigNumber$1.from(this.readBytes(this.wordSize));
    }
}

class AddressCoder extends Coder {
    constructor(localName) {
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = getAddress$1(value);
        }
        catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return getAddress$1(hexZeroPad(reader.readValue().toHexString(), 20));
    }
}

// Clones the functionality of an existing Coder, but without a localName
class AnonymousCoder extends Coder {
    constructor(coder) {
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}

const logger$7 = new Logger$1(version$a);
function pack(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) {
        arrayValues = values;
    }
    else if (values && typeof (values) === "object") {
        let unique = {};
        arrayValues = coders.map((coder) => {
            const name = coder.localName;
            if (!name) {
                logger$7.throwError("cannot encode object for signature with missing names", Logger$1.errors.INVALID_ARGUMENT, {
                    argument: "values",
                    coder: coder,
                    value: values
                });
            }
            if (unique[name]) {
                logger$7.throwError("cannot encode object for signature with duplicate names", Logger$1.errors.INVALID_ARGUMENT, {
                    argument: "values",
                    coder: coder,
                    value: values
                });
            }
            unique[name] = true;
            return values[name];
        });
    }
    else {
        logger$7.throwArgumentError("invalid tuple value", "tuple", values);
    }
    if (coders.length !== arrayValues.length) {
        logger$7.throwArgumentError("types/value length mismatch", "tuple", values);
    }
    let staticWriter = new Writer(writer.wordSize);
    let dynamicWriter = new Writer(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index) => {
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset) => {
                updateFunc(baseOffset + dynamicOffset);
            });
        }
        else {
            coder.encode(staticWriter, value);
        }
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func) => { func(staticWriter.length); });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function unpack(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder) => {
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            }
            catch (error) {
                // Cannot recover from this
                if (error.code === Logger$1.errors.BUFFER_OVERRUN) {
                    throw error;
                }
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        }
        else {
            try {
                value = coder.decode(reader);
            }
            catch (error) {
                // Cannot recover from this
                if (error.code === Logger$1.errors.BUFFER_OVERRUN) {
                    throw error;
                }
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        }
        if (value != undefined) {
            values.push(value);
        }
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder) => {
        const name = coder.localName;
        if (name) {
            if (!accum[name]) {
                accum[name] = 0;
            }
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index) => {
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) {
            return;
        }
        if (name === "length") {
            name = "_length";
        }
        if (values[name] != null) {
            return;
        }
        const value = values[index];
        if (value instanceof Error) {
            Object.defineProperty(values, name, {
                enumerable: true,
                get: () => { throw value; }
            });
        }
        else {
            values[name] = value;
        }
    });
    for (let i = 0; i < values.length; i++) {
        const value = values[i];
        if (value instanceof Error) {
            Object.defineProperty(values, i, {
                enumerable: true,
                get: () => { throw value; }
            });
        }
    }
    return Object.freeze(values);
}
class ArrayCoder extends Coder {
    constructor(coder, length, localName) {
        const type = (coder.type + "[" + (length >= 0 ? length : "") + "]");
        const dynamic = (length === -1 || coder.dynamic);
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for (let i = 0; i < this.length; i++) {
            result.push(defaultChild);
        }
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) {
            this._throwError("expected array value", value);
        }
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        logger$7.checkArgumentCount(value.length, count, "coder array" + (this.localName ? (" " + this.localName) : ""));
        let coders = [];
        for (let i = 0; i < value.length; i++) {
            coders.push(this.coder);
        }
        return pack(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) {
                logger$7.throwError("insufficient data length", Logger$1.errors.BUFFER_OVERRUN, {
                    length: reader._data.length,
                    count: count
                });
            }
        }
        let coders = [];
        for (let i = 0; i < count; i++) {
            coders.push(new AnonymousCoder(this.coder));
        }
        return reader.coerce(this.name, unpack(reader, coders));
    }
}

class BooleanCoder extends Coder {
    constructor(localName) {
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}

class DynamicBytesCoder extends Coder {
    constructor(type, localName) {
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = arrayify$1(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class BytesCoder extends DynamicBytesCoder {
    constructor(localName) {
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, hexlify(super.decode(reader)));
    }
}

// @TODO: Merge this with bytes
class FixedBytesCoder extends Coder {
    constructor(size, localName) {
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return ("0x0000000000000000000000000000000000000000000000000000000000000000").substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = arrayify$1(value);
        if (data.length !== this.size) {
            this._throwError("incorrect data length", value);
        }
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, hexlify(reader.readBytes(this.size)));
    }
}

class NullCoder extends Coder {
    constructor(localName) {
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) {
            this._throwError("not null", value);
        }
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}

class NumberCoder extends Coder {
    constructor(size, signed, localName) {
        const name = ((signed ? "int" : "uint") + (size * 8));
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = BigNumber$1.from(value);
        // Check bounds are safe for encoding
        let maxUintValue = MaxUint256$1.mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add(One$1).mul(NegativeOne$1))) {
                this._throwError("value out-of-bounds", value);
            }
        }
        else if (v.lt(Zero$1) || v.gt(maxUintValue.mask(this.size * 8))) {
            this._throwError("value out-of-bounds", value);
        }
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) {
            v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        }
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) {
            value = value.fromTwos(this.size * 8);
        }
        return reader.coerce(this.name, value);
    }
}

class StringCoder extends DynamicBytesCoder {
    constructor(localName) {
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, toUtf8Bytes(value));
    }
    decode(reader) {
        return toUtf8String(super.decode(reader));
    }
}

class TupleCoder extends Coder {
    constructor(coders, localName) {
        let dynamic = false;
        const types = [];
        coders.forEach((coder) => {
            if (coder.dynamic) {
                dynamic = true;
            }
            types.push(coder.type);
        });
        const type = ("tuple(" + types.join(",") + ")");
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder) => {
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder) => {
            const name = coder.localName;
            if (name) {
                if (!accum[name]) {
                    accum[name] = 0;
                }
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index) => {
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) {
                return;
            }
            if (name === "length") {
                name = "_length";
            }
            if (values[name] != null) {
                return;
            }
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return pack(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, unpack(reader, this.coders));
    }
}

const logger$6 = new Logger$1(version$a);
const paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class AbiCoder {
    constructor(coerceFunc) {
        defineReadOnly(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch (param.baseType) {
            case "address":
                return new AddressCoder(param.name);
            case "bool":
                return new BooleanCoder(param.name);
            case "string":
                return new StringCoder(param.name);
            case "bytes":
                return new BytesCoder(param.name);
            case "array":
                return new ArrayCoder(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new TupleCoder((param.components || []).map((component) => {
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new NullCoder(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match(paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || (size % 8) !== 0) {
                logger$6.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            }
            return new NumberCoder(size / 8, (match[1] === "int"), param.name);
        }
        // bytes[0-9]+
        match = param.type.match(paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) {
                logger$6.throwArgumentError("invalid bytes length", "param", param);
            }
            return new FixedBytesCoder(size, param.name);
        }
        return logger$6.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() { return 32; }
    _getReader(data, allowLoose) {
        return new Reader(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new Writer(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type) => this._getCoder(ParamType.from(type)));
        const coder = new TupleCoder(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) {
            logger$6.throwError("types/values length mismatch", Logger$1.errors.INVALID_ARGUMENT, {
                count: { types: types.length, values: values.length },
                value: { types: types, values: values }
            });
        }
        const coders = types.map((type) => this._getCoder(ParamType.from(type)));
        const coder = (new TupleCoder(coders, "_"));
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type) => this._getCoder(ParamType.from(type)));
        const coder = new TupleCoder(coders, "_");
        return coder.decode(this._getReader(arrayify$1(data), loose));
    }
}
const defaultAbiCoder = new AbiCoder();

const logger$5 = new Logger$1(version$a);
class LogDescription extends Description {
}
class TransactionDescription extends Description {
}
class ErrorDescription extends Description {
}
class Indexed extends Description {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const BuiltinErrors = {
    "0x08c379a0": { signature: "Error(string)", name: "Error", inputs: ["string"], reason: true },
    "0x4e487b71": { signature: "Panic(uint256)", name: "Panic", inputs: ["uint256"] }
};
function wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
/*
function checkNames(fragment: Fragment, type: "input" | "output", params: Array<ParamType>): void {
    params.reduce((accum, param) => {
        if (param.name) {
            if (accum[param.name]) {
                logger.throwArgumentError(`duplicate ${ type } parameter ${ JSON.stringify(param.name) } in ${ fragment.format("full") }`, "fragment", fragment);
            }
            accum[param.name] = true;
        }
        return accum;
    }, <{ [ name: string ]: boolean }>{ });
}
*/
class Interface {
    constructor(fragments) {
        let abi = [];
        if (typeof (fragments) === "string") {
            abi = JSON.parse(fragments);
        }
        else {
            abi = fragments;
        }
        defineReadOnly(this, "fragments", abi.map((fragment) => {
            return Fragment.from(fragment);
        }).filter((fragment) => (fragment != null)));
        defineReadOnly(this, "_abiCoder", getStatic(new.target, "getAbiCoder")());
        defineReadOnly(this, "functions", {});
        defineReadOnly(this, "errors", {});
        defineReadOnly(this, "events", {});
        defineReadOnly(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment) => {
            let bucket = null;
            switch (fragment.type) {
                case "constructor":
                    if (this.deploy) {
                        logger$5.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    defineReadOnly(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                logger$5.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) {
            defineReadOnly(this, "deploy", ConstructorFragment.from({
                payable: false,
                type: "constructor"
            }));
        }
        defineReadOnly(this, "_isInterface", true);
    }
    format(format) {
        if (!format) {
            format = FormatTypes.full;
        }
        if (format === FormatTypes.sighash) {
            logger$5.throwArgumentError("interface does not support formatting sighash", "format", format);
        }
        const abi = this.fragments.map((fragment) => fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === FormatTypes.json) {
            return JSON.stringify(abi.map((j) => JSON.parse(j)));
        }
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return defaultAbiCoder;
    }
    static getAddress(address) {
        return getAddress$1(address);
    }
    static getSighash(fragment) {
        return hexDataSlice(id$1(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return id$1(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if (isHexString$1(nameOrSignatureOrSighash)) {
            for (const name in this.functions) {
                if (nameOrSignatureOrSighash === this.getSighash(name)) {
                    return this.functions[name];
                }
            }
            logger$5.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f) => (f.split("(" /* fix:) */)[0] === name));
            if (matching.length === 0) {
                logger$5.throwArgumentError("no matching function", "name", name);
            }
            else if (matching.length > 1) {
                logger$5.throwArgumentError("multiple matching functions", "name", name);
            }
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[FunctionFragment.fromString(nameOrSignatureOrSighash).format()];
        if (!result) {
            logger$5.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        }
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if (isHexString$1(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for (const name in this.events) {
                if (topichash === this.getEventTopic(name)) {
                    return this.events[name];
                }
            }
            logger$5.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f) => (f.split("(" /* fix:) */)[0] === name));
            if (matching.length === 0) {
                logger$5.throwArgumentError("no matching event", "name", name);
            }
            else if (matching.length > 1) {
                logger$5.throwArgumentError("multiple matching events", "name", name);
            }
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[EventFragment.fromString(nameOrSignatureOrTopic).format()];
        if (!result) {
            logger$5.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        }
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if (isHexString$1(nameOrSignatureOrSighash)) {
            const getSighash = getStatic(this.constructor, "getSighash");
            for (const name in this.errors) {
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) {
                    return this.errors[name];
                }
            }
            logger$5.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f) => (f.split("(" /* fix:) */)[0] === name));
            if (matching.length === 0) {
                logger$5.throwArgumentError("no matching error", "name", name);
            }
            else if (matching.length > 1) {
                logger$5.throwArgumentError("multiple matching errors", "name", name);
            }
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[FunctionFragment.fromString(nameOrSignatureOrSighash).format()];
        if (!result) {
            logger$5.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        }
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof (fragment) === "string") {
            try {
                fragment = this.getFunction(fragment);
            }
            catch (error) {
                try {
                    fragment = this.getError(fragment);
                }
                catch (_) {
                    throw error;
                }
            }
        }
        return getStatic(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof (eventFragment) === "string") {
            eventFragment = this.getEvent(eventFragment);
        }
        return getStatic(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof (fragment) === "string") {
            fragment = this.getError(fragment);
        }
        const bytes = arrayify$1(data);
        if (hexlify(bytes.slice(0, 4)) !== this.getSighash(fragment)) {
            logger$5.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", hexlify(bytes));
        }
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof (fragment) === "string") {
            fragment = this.getError(fragment);
        }
        return hexlify(concat$4([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof (functionFragment) === "string") {
            functionFragment = this.getFunction(functionFragment);
        }
        const bytes = arrayify$1(data);
        if (hexlify(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) {
            logger$5.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", hexlify(bytes));
        }
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof (functionFragment) === "string") {
            functionFragment = this.getFunction(functionFragment);
        }
        return hexlify(concat$4([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof (functionFragment) === "string") {
            functionFragment = this.getFunction(functionFragment);
        }
        let bytes = arrayify$1(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch (bytes.length % this._abiCoder._getWordSize()) {
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                }
                catch (error) { }
                break;
            case 4: {
                const selector = hexlify(bytes.slice(0, 4));
                const builtin = BuiltinErrors[selector];
                if (builtin) {
                    errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                    errorName = builtin.name;
                    errorSignature = builtin.signature;
                    if (builtin.reason) {
                        reason = errorArgs[0];
                    }
                    if (errorName === "Error") {
                        message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                    }
                    else if (errorName === "Panic") {
                        message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    }
                }
                else {
                    try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    }
                    catch (error) { }
                }
                break;
            }
        }
        return logger$5.throwError("call revert exception" + message, Logger$1.errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: hexlify(data), errorArgs, errorName, errorSignature, reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof (functionFragment) === "string") {
            functionFragment = this.getFunction(functionFragment);
        }
        return hexlify(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof (eventFragment) === "string") {
            eventFragment = this.getEvent(eventFragment);
        }
        if (values.length > eventFragment.inputs.length) {
            logger$5.throwError("too many arguments for " + eventFragment.format(), Logger$1.errors.UNEXPECTED_ARGUMENT, {
                argument: "values",
                value: values
            });
        }
        let topics = [];
        if (!eventFragment.anonymous) {
            topics.push(this.getEventTopic(eventFragment));
        }
        const encodeTopic = (param, value) => {
            if (param.type === "string") {
                return id$1(value);
            }
            else if (param.type === "bytes") {
                return keccak256$1(hexlify(value));
            }
            // Check addresses are valid
            if (param.type === "address") {
                this._abiCoder.encode(["address"], [value]);
            }
            return hexZeroPad(hexlify(value), 32);
        };
        values.forEach((value, index) => {
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) {
                    logger$5.throwArgumentError("cannot filter non-indexed parameters; must be null", ("contract." + param.name), value);
                }
                return;
            }
            if (value == null) {
                topics.push(null);
            }
            else if (param.baseType === "array" || param.baseType === "tuple") {
                logger$5.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
            }
            else if (Array.isArray(value)) {
                topics.push(value.map((value) => encodeTopic(param, value)));
            }
            else {
                topics.push(encodeTopic(param, value));
            }
        });
        // Trim off trailing nulls
        while (topics.length && topics[topics.length - 1] === null) {
            topics.pop();
        }
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof (eventFragment) === "string") {
            eventFragment = this.getEvent(eventFragment);
        }
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) {
            topics.push(this.getEventTopic(eventFragment));
        }
        if (values.length !== eventFragment.inputs.length) {
            logger$5.throwArgumentError("event arguments/values mismatch", "values", values);
        }
        eventFragment.inputs.forEach((param, index) => {
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") {
                    topics.push(id$1(value));
                }
                else if (param.type === "bytes") {
                    topics.push(keccak256$1(value));
                }
                else if (param.baseType === "tuple" || param.baseType === "array") {
                    // @TODO
                    throw new Error("not implemented");
                }
                else {
                    topics.push(this._abiCoder.encode([param.type], [value]));
                }
            }
            else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof (eventFragment) === "string") {
            eventFragment = this.getEvent(eventFragment);
        }
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!isHexString$1(topics[0], 32) || topics[0].toLowerCase() !== topicHash) {
                logger$5.throwError("fragment/topic mismatch", Logger$1.errors.INVALID_ARGUMENT, { argument: "topics[0]", expected: topicHash, value: topics[0] });
            }
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index) => {
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push(ParamType.fromObject({ type: "bytes32", name: param.name }));
                    dynamic.push(true);
                }
                else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            }
            else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = (topics != null) ? this._abiCoder.decode(indexed, concat$4(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index) => {
            if (param.indexed) {
                if (resultIndexed == null) {
                    result[index] = new Indexed({ _isIndexed: true, hash: null });
                }
                else if (dynamic[index]) {
                    result[index] = new Indexed({ _isIndexed: true, hash: resultIndexed[indexedIndex++] });
                }
                else {
                    try {
                        result[index] = resultIndexed[indexedIndex++];
                    }
                    catch (error) {
                        result[index] = error;
                    }
                }
            }
            else {
                try {
                    result[index] = resultNonIndexed[nonIndexedIndex++];
                }
                catch (error) {
                    result[index] = error;
                }
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) {
                    Object.defineProperty(result, param.name, {
                        enumerable: true,
                        get: () => { throw wrapAccessError(`property ${JSON.stringify(param.name)}`, value); }
                    });
                }
                else {
                    result[param.name] = value;
                }
            }
        });
        // Make all error indexed values throw on access
        for (let i = 0; i < result.length; i++) {
            const value = result[i];
            if (value instanceof Error) {
                Object.defineProperty(result, i, {
                    enumerable: true,
                    get: () => { throw wrapAccessError(`index ${i}`, value); }
                });
            }
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) {
            return null;
        }
        return new TransactionDescription({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: BigNumber$1.from(tx.value || "0"),
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) {
            return null;
        }
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new LogDescription({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = hexlify(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) {
            return null;
        }
        return new ErrorDescription({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */
    static isInterface(value) {
        return !!(value && value._isInterface);
    }
}

var ERC20_ABI = [
	{
		constant: true,
		inputs: [
		],
		name: "name",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_spender",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_from",
				type: "address"
			},
			{
				name: "_to",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				name: "",
				type: "uint8"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "_owner",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				name: "balance",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_to",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "_owner",
				type: "address"
			},
			{
				name: "_spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		payable: true,
		stateMutability: "payable",
		type: "fallback"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	}
];

var ERC20_BYTES32_ABI = [
	{
		constant: true,
		inputs: [
		],
		name: "name",
		outputs: [
			{
				name: "",
				type: "bytes32"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				name: "",
				type: "bytes32"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	}
];

const ERC20_INTERFACE = new Interface(ERC20_ABI);

var WETH_ABI = [
	{
		constant: true,
		inputs: [
		],
		name: "name",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "guy",
				type: "address"
			},
			{
				name: "wad",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "src",
				type: "address"
			},
			{
				name: "dst",
				type: "address"
			},
			{
				name: "wad",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "wad",
				type: "uint256"
			}
		],
		name: "withdraw",
		outputs: [
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				name: "",
				type: "uint8"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "dst",
				type: "address"
			},
			{
				name: "wad",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: false,
		inputs: [
		],
		name: "deposit",
		outputs: [
		],
		payable: true,
		stateMutability: "payable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "",
				type: "address"
			},
			{
				name: "",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		payable: true,
		stateMutability: "payable",
		type: "fallback"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "src",
				type: "address"
			},
			{
				indexed: true,
				name: "guy",
				type: "address"
			},
			{
				indexed: false,
				name: "wad",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "src",
				type: "address"
			},
			{
				indexed: true,
				name: "dst",
				type: "address"
			},
			{
				indexed: false,
				name: "wad",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "dst",
				type: "address"
			},
			{
				indexed: false,
				name: "wad",
				type: "uint256"
			}
		],
		name: "Deposit",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "src",
				type: "address"
			},
			{
				indexed: false,
				name: "wad",
				type: "uint256"
			}
		],
		name: "Withdrawal",
		type: "event"
	}
];

var MULTICALL_ABI = [
	{
		constant: true,
		inputs: [
		],
		name: "getCurrentBlockTimestamp",
		outputs: [
			{
				name: "timestamp",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				components: [
					{
						name: "target",
						type: "address"
					},
					{
						name: "callData",
						type: "bytes"
					}
				],
				name: "calls",
				type: "tuple[]"
			}
		],
		name: "aggregate",
		outputs: [
			{
				name: "blockNumber",
				type: "uint256"
			},
			{
				name: "returnData",
				type: "bytes[]"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "getLastBlockHash",
		outputs: [
			{
				name: "blockHash",
				type: "bytes32"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "addr",
				type: "address"
			}
		],
		name: "getEthBalance",
		outputs: [
			{
				name: "balance",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "getCurrentBlockDifficulty",
		outputs: [
			{
				name: "difficulty",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "getCurrentBlockGasLimit",
		outputs: [
			{
				name: "gaslimit",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "getCurrentBlockCoinbase",
		outputs: [
			{
				name: "coinbase",
				type: "address"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "blockNumber",
				type: "uint256"
			}
		],
		name: "getBlockHash",
		outputs: [
			{
				name: "blockHash",
				type: "bytes32"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	}
];

const MULTICALL_NETWORKS = {
    [ChainId.FUJI]: '0xb465Fd2d9C71d5D6e6c069aaC9b4E21c69aAA78f',
    [ChainId.AVALANCHE]: '0x0FB54156B496b5a040b51A71817aED9e2927912E',
    [ChainId.WAGMI]: '0x5138349f3027F1e2c2f10eDAD83d38096C0D8Abe',
    [ChainId.COSTON]: '',
};

const version$9 = "contracts/5.6.0";

var __awaiter$1 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const logger$4 = new Logger$1(version$9);
function resolveName(resolver, nameOrPromise) {
    return __awaiter$1(this, void 0, void 0, function* () {
        const name = yield nameOrPromise;
        if (typeof (name) !== "string") {
            logger$4.throwArgumentError("invalid address or ENS name", "name", name);
        }
        // If it is already an address, just use it (after adding checksum)
        try {
            return getAddress$1(name);
        }
        catch (error) { }
        if (!resolver) {
            logger$4.throwError("a provider or signer is needed to resolve ENS names", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "resolveName"
            });
        }
        const address = yield resolver.resolveName(name);
        if (address == null) {
            logger$4.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        }
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function resolveAddresses(resolver, value, paramType) {
    return __awaiter$1(this, void 0, void 0, function* () {
        if (Array.isArray(paramType)) {
            return yield Promise.all(paramType.map((paramType, index) => {
                return resolveAddresses(resolver, ((Array.isArray(value)) ? value[index] : value[paramType.name]), paramType);
            }));
        }
        if (paramType.type === "address") {
            return yield resolveName(resolver, value);
        }
        if (paramType.type === "tuple") {
            return yield resolveAddresses(resolver, value, paramType.components);
        }
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) {
                return Promise.reject(logger$4.makeError("invalid value for array", Logger$1.errors.INVALID_ARGUMENT, {
                    argument: "value",
                    value
                }));
            }
            return yield Promise.all(value.map((v) => resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function populateTransaction(contract, fragment, args) {
    return __awaiter$1(this, void 0, void 0, function* () {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof (args[args.length - 1]) === "object") {
            overrides = shallowCopy(args.pop());
        }
        // Make sure the parameter count matches
        logger$4.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) {
                // Contracts with a Signer are from the Signer's frame-of-reference;
                // but we allow overriding "from" if it matches the signer
                overrides.from = resolveProperties({
                    override: resolveName(contract.signer, overrides.from),
                    signer: contract.signer.getAddress()
                }).then((check) => __awaiter$1(this, void 0, void 0, function* () {
                    if (getAddress$1(check.signer) !== check.override) {
                        logger$4.throwError("Contract with a Signer cannot override from", Logger$1.errors.UNSUPPORTED_OPERATION, {
                            operation: "overrides.from"
                        });
                    }
                    return check.override;
                }));
            }
            else {
                overrides.from = contract.signer.getAddress();
            }
        }
        else if (overrides.from) {
            overrides.from = resolveName(contract.provider, overrides.from);
            //} else {
            // Contracts without a signer can override "from", and if
            // unspecified the zero address is used
            //overrides.from = AddressZero;
        }
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield resolveProperties({
            args: resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: (resolveProperties(overrides) || {})
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) {
            tx.nonce = BigNumber$1.from(ro.nonce).toNumber();
        }
        if (ro.gasLimit != null) {
            tx.gasLimit = BigNumber$1.from(ro.gasLimit);
        }
        if (ro.gasPrice != null) {
            tx.gasPrice = BigNumber$1.from(ro.gasPrice);
        }
        if (ro.maxFeePerGas != null) {
            tx.maxFeePerGas = BigNumber$1.from(ro.maxFeePerGas);
        }
        if (ro.maxPriorityFeePerGas != null) {
            tx.maxPriorityFeePerGas = BigNumber$1.from(ro.maxPriorityFeePerGas);
        }
        if (ro.from != null) {
            tx.from = ro.from;
        }
        if (ro.type != null) {
            tx.type = ro.type;
        }
        if (ro.accessList != null) {
            tx.accessList = accessListify(ro.accessList);
        }
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = arrayify$1(data);
            for (let i = 0; i < bytes.length; i++) {
                intrinsic += 4;
                if (bytes[i]) {
                    intrinsic += 64;
                }
            }
            tx.gasLimit = BigNumber$1.from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = BigNumber$1.from(ro.value);
            if (!roValue.isZero() && !fragment.payable) {
                logger$4.throwError("non-payable method cannot override value", Logger$1.errors.UNSUPPORTED_OPERATION, {
                    operation: "overrides.value",
                    value: overrides.value
                });
            }
            tx.value = roValue;
        }
        if (ro.customData) {
            tx.customData = shallowCopy(ro.customData);
        }
        if (ro.ccipReadEnabled) {
            tx.ccipReadEnabled = !!ro.ccipReadEnabled;
        }
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        delete overrides.ccipReadEnabled;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key) => (overrides[key] != null));
        if (leftovers.length) {
            logger$4.throwError(`cannot override ${leftovers.map((l) => JSON.stringify(l)).join(",")}`, Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "overrides",
                overrides: leftovers
            });
        }
        return tx;
    });
}
function buildPopulate(contract, fragment) {
    return function (...args) {
        return populateTransaction(contract, fragment, args);
    };
}
function buildEstimate(contract, fragment) {
    const signerOrProvider = (contract.signer || contract.provider);
    return function (...args) {
        return __awaiter$1(this, void 0, void 0, function* () {
            if (!signerOrProvider) {
                logger$4.throwError("estimate require a provider or signer", Logger$1.errors.UNSUPPORTED_OPERATION, {
                    operation: "estimateGas"
                });
            }
            const tx = yield populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations) => {
        return wait(confirmations).then((receipt) => {
            receipt.events = receipt.logs.map((log) => {
                let event = deepCopy(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                }
                catch (e) { }
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics) => {
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = () => { return contract.provider; };
                event.getBlock = () => {
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = () => {
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = () => {
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = (contract.signer || contract.provider);
    return function (...args) {
        return __awaiter$1(this, void 0, void 0, function* () {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof (args[args.length - 1]) === "object") {
                const overrides = shallowCopy(args.pop());
                if (overrides.blockTag != null) {
                    blockTag = yield overrides.blockTag;
                }
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) {
                yield contract._deployed(blockTag);
            }
            // Call a node and get the result
            const tx = yield populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) {
                    value = value[0];
                }
                return value;
            }
            catch (error) {
                if (error.code === Logger$1.errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function buildSend(contract, fragment) {
    return function (...args) {
        return __awaiter$1(this, void 0, void 0, function* () {
            if (!contract.signer) {
                logger$4.throwError("sending a transaction requires a signer", Logger$1.errors.UNSUPPORTED_OPERATION, {
                    operation: "sendTransaction"
                });
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) {
                yield contract._deployed();
            }
            const txRequest = yield populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            addContractWait(contract, tx);
            return tx;
        });
    };
}
function buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) {
        return buildCall(contract, fragment, collapseSimple);
    }
    return buildSend(contract, fragment);
}
function getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) {
        return "*";
    }
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic) => {
        if (Array.isArray(topic)) {
            return topic.join("|");
        }
        return topic;
    }).join(":") : "");
}
class RunningEvent {
    constructor(tag, filter) {
        defineReadOnly(this, "tag", tag);
        defineReadOnly(this, "filter", filter);
        this._listeners = [];
    }
    addListener(listener, once) {
        this._listeners.push({ listener: listener, once: once });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item) => {
            if (done || item.listener !== listener) {
                return true;
            }
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i) => i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item) => {
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(() => {
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !(item.once);
        });
        return listenerCount;
    }
    prepareEvent(event) {
    }
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [event];
    }
}
class ErrorRunningEvent extends RunningEvent {
    constructor() {
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class FragmentRunningEvent extends RunningEvent {
    constructor(address, contractInterface, fragment, topics) {
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) {
                logger$4.throwArgumentError("topic mismatch", "topics", topics);
            }
            filter.topics = topics.slice();
        }
        else {
            filter.topics = [topic];
        }
        super(getEventTag(filter), filter);
        defineReadOnly(this, "address", address);
        defineReadOnly(this, "interface", contractInterface);
        defineReadOnly(this, "fragment", fragment);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics) => {
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        }
        catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = checkResultErrors(event.args);
        if (errors.length) {
            throw errors[0].error;
        }
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class WildcardRunningEvent extends RunningEvent {
    constructor(address, contractInterface) {
        super("*", { address: address });
        defineReadOnly(this, "address", address);
        defineReadOnly(this, "interface", contractInterface);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics) => {
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        }
        catch (error) {
            // No matching event
        }
    }
}
class BaseContract {
    constructor(addressOrName, contractInterface, signerOrProvider) {
        logger$4.checkNew(new.target, Contract);
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        defineReadOnly(this, "interface", getStatic(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            defineReadOnly(this, "provider", null);
            defineReadOnly(this, "signer", null);
        }
        else if (Signer.isSigner(signerOrProvider)) {
            defineReadOnly(this, "provider", signerOrProvider.provider || null);
            defineReadOnly(this, "signer", signerOrProvider);
        }
        else if (Provider.isProvider(signerOrProvider)) {
            defineReadOnly(this, "provider", signerOrProvider);
            defineReadOnly(this, "signer", null);
        }
        else {
            logger$4.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        }
        defineReadOnly(this, "callStatic", {});
        defineReadOnly(this, "estimateGas", {});
        defineReadOnly(this, "functions", {});
        defineReadOnly(this, "populateTransaction", {});
        defineReadOnly(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature) => {
                const event = this.interface.events[eventSignature];
                defineReadOnly(this.filters, eventSignature, (...args) => {
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) {
                    uniqueFilters[event.name] = [];
                }
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name) => {
                const filters = uniqueFilters[name];
                if (filters.length === 1) {
                    defineReadOnly(this.filters, name, this.filters[filters[0]]);
                }
                else {
                    logger$4.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
                }
            });
        }
        defineReadOnly(this, "_runningEvents", {});
        defineReadOnly(this, "_wrappedEmits", {});
        if (addressOrName == null) {
            logger$4.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        }
        defineReadOnly(this, "address", addressOrName);
        if (this.provider) {
            defineReadOnly(this, "resolvedAddress", resolveName(this.provider, addressOrName));
        }
        else {
            try {
                defineReadOnly(this, "resolvedAddress", Promise.resolve(getAddress$1(addressOrName)));
            }
            catch (error) {
                // Without a provider, we cannot use ENS names
                logger$4.throwError("provider is required to use ENS name as contract address", Logger$1.errors.UNSUPPORTED_OPERATION, {
                    operation: "new Contract"
                });
            }
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch((e) => { });
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature) => {
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                logger$4.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) {
                    uniqueNames[`%${name}`] = [];
                }
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) {
                defineReadOnly(this, signature, buildDefault(this, fragment, true));
            }
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) {
                defineReadOnly(this.functions, signature, buildDefault(this, fragment, false));
            }
            if (this.callStatic[signature] == null) {
                defineReadOnly(this.callStatic, signature, buildCall(this, fragment, true));
            }
            if (this.populateTransaction[signature] == null) {
                defineReadOnly(this.populateTransaction, signature, buildPopulate(this, fragment));
            }
            if (this.estimateGas[signature] == null) {
                defineReadOnly(this.estimateGas, signature, buildEstimate(this, fragment));
            }
        });
        Object.keys(uniqueNames).forEach((name) => {
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) {
                return;
            }
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) {
                    defineReadOnly(this, name, this[signature]);
                }
            }
            catch (e) { }
            if (this.functions[name] == null) {
                defineReadOnly(this.functions, name, this.functions[signature]);
            }
            if (this.callStatic[name] == null) {
                defineReadOnly(this.callStatic, name, this.callStatic[signature]);
            }
            if (this.populateTransaction[name] == null) {
                defineReadOnly(this.populateTransaction, name, this.populateTransaction[signature]);
            }
            if (this.estimateGas[name] == null) {
                defineReadOnly(this.estimateGas, name, this.estimateGas[signature]);
            }
        });
    }
    static getContractAddress(transaction) {
        return getContractAddress(transaction);
    }
    static getInterface(contractInterface) {
        if (Interface.isInterface(contractInterface)) {
            return contractInterface;
        }
        return new Interface(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) {
                this._deployedPromise = this.deployTransaction.wait().then(() => {
                    return this;
                });
            }
            else {
                // @TODO: Once we allow a timeout to be passed in, we will wait
                // up to that many blocks for getCode
                // Otherwise, poll for our code to be deployed
                this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code) => {
                    if (code === "0x") {
                        logger$4.throwError("contract not deployed", Logger$1.errors.UNSUPPORTED_OPERATION, {
                            contractAddress: this.address,
                            operation: "getDeployed"
                        });
                    }
                    return this;
                });
            }
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) {
            logger$4.throwError("sending a transactions require a signer", Logger$1.errors.UNSUPPORTED_OPERATION, { operation: "sendTransaction(fallback)" });
        }
        const tx = shallowCopy(overrides || {});
        ["from", "to"].forEach(function (key) {
            if (tx[key] == null) {
                return;
            }
            logger$4.throwError("cannot override " + key, Logger$1.errors.UNSUPPORTED_OPERATION, { operation: key });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(() => {
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof (signerOrProvider) === "string") {
            signerOrProvider = new VoidSigner(signerOrProvider, this.provider);
        }
        const contract = new (this.constructor)(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) {
            defineReadOnly(contract, "deployTransaction", this.deployTransaction);
        }
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new (this.constructor)(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return Indexed.isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) {
            return this._runningEvents[runningEvent.tag];
        }
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof (eventName) === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") {
                return this._normalizeRunningEvent(new ErrorRunningEvent());
            }
            // Listen for any event that is registered
            if (eventName === "event") {
                return this._normalizeRunningEvent(new RunningEvent("event", null));
            }
            // Listen for any event
            if (eventName === "*") {
                return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
            }
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof (topic) !== "string") {
                    throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                }
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            }
            catch (error) { }
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new RunningEvent(getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = deepCopy(log);
        event.removeListener = () => {
            if (!listener) {
                return;
            }
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = () => { return this.provider.getBlock(log.blockHash); };
        event.getTransaction = () => { return this.provider.getTransaction(log.transactionHash); };
        event.getTransactionReceipt = () => { return this.provider.getTransactionReceipt(log.transactionHash); };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) {
            logger$4.throwError("events require a provider or a signer with a provider", Logger$1.errors.UNSUPPORTED_OPERATION, { operation: "once" });
        }
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log) => {
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) {
                    try {
                        const args = runningEvent.getEmit(event);
                        this.emit(runningEvent.filter, ...args);
                    }
                    catch (error) {
                        event.decodeError = error.error;
                    }
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) {
                    this.emit("event", event);
                }
                // Emit "error" if there was an error
                if (event.decodeError != null) {
                    this.emit("error", event.decodeError, event);
                }
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) {
                this.provider.on(runningEvent.filter, wrappedEmit);
            }
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = shallowCopy(runningEvent.filter);
        if (typeof (fromBlockOrBlockhash) === "string" && isHexString$1(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) {
                logger$4.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            }
            filter.blockHash = fromBlockOrBlockhash;
        }
        else {
            filter.fromBlock = ((fromBlockOrBlockhash != null) ? fromBlockOrBlockhash : 0);
            filter.toBlock = ((toBlock != null) ? toBlock : "latest");
        }
        return this.provider.getLogs(filter).then((logs) => {
            return logs.map((log) => this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) {
            return false;
        }
        const runningEvent = this._getRunningEvent(eventName);
        const result = (runningEvent.run(args) > 0);
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) {
            return 0;
        }
        if (eventName == null) {
            return Object.keys(this._runningEvents).reduce((accum, key) => {
                return accum + this._runningEvents[key].listenerCount();
            }, 0);
        }
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) {
            return [];
        }
        if (eventName == null) {
            const result = [];
            for (let tag in this._runningEvents) {
                this._runningEvents[tag].listeners().forEach((listener) => {
                    result.push(listener);
                });
            }
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) {
            return this;
        }
        if (eventName == null) {
            for (const tag in this._runningEvents) {
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) {
            return this;
        }
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
}
class Contract extends BaseContract {
}

var _format$1 = "hh-sol-artifact-1";
var contractName$1 = "IPangolinRouter";
var sourceName$1 = "contracts/pangolin-periphery/interfaces/IPangolinRouter.sol";
var abi$1 = [
	{
		inputs: [
		],
		name: "WAVAX",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "tokenA",
				type: "address"
			},
			{
				internalType: "address",
				name: "tokenB",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amountADesired",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountBDesired",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountBMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "addLiquidity",
		outputs: [
			{
				internalType: "uint256",
				name: "amountA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountB",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amountTokenDesired",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAVAXMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "addLiquidityAVAX",
		outputs: [
			{
				internalType: "uint256",
				name: "amountToken",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAVAX",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "factory",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveOut",
				type: "uint256"
			}
		],
		name: "getAmountIn",
		outputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveOut",
				type: "uint256"
			}
		],
		name: "getAmountOut",
		outputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			}
		],
		name: "getAmountsIn",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			}
		],
		name: "getAmountsOut",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveB",
				type: "uint256"
			}
		],
		name: "quote",
		outputs: [
			{
				internalType: "uint256",
				name: "amountB",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "tokenA",
				type: "address"
			},
			{
				internalType: "address",
				name: "tokenB",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountBMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "removeLiquidity",
		outputs: [
			{
				internalType: "uint256",
				name: "amountA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountB",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAVAXMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "removeLiquidityAVAX",
		outputs: [
			{
				internalType: "uint256",
				name: "amountToken",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAVAX",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAVAXMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "removeLiquidityAVAXSupportingFeeOnTransferTokens",
		outputs: [
			{
				internalType: "uint256",
				name: "amountAVAX",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAVAXMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "approveMax",
				type: "bool"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "removeLiquidityAVAXWithPermit",
		outputs: [
			{
				internalType: "uint256",
				name: "amountToken",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAVAX",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAVAXMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "approveMax",
				type: "bool"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "removeLiquidityAVAXWithPermitSupportingFeeOnTransferTokens",
		outputs: [
			{
				internalType: "uint256",
				name: "amountAVAX",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "tokenA",
				type: "address"
			},
			{
				internalType: "address",
				name: "tokenB",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountBMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "approveMax",
				type: "bool"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "removeLiquidityWithPermit",
		outputs: [
			{
				internalType: "uint256",
				name: "amountA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountB",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapAVAXForExactTokens",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactAVAXForTokens",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactAVAXForTokensSupportingFeeOnTransferTokens",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactTokensForAVAX",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactTokensForAVAXSupportingFeeOnTransferTokens",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactTokensForTokens",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountInMax",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapTokensForExactAVAX",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountInMax",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapTokensForExactTokens",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];
var bytecode$1 = "0x";
var deployedBytecode$1 = "0x";
var linkReferences$1 = {
};
var deployedLinkReferences$1 = {
};
var IPangolinRouter = {
	_format: _format$1,
	contractName: contractName$1,
	sourceName: sourceName$1,
	abi: abi$1,
	bytecode: bytecode$1,
	deployedBytecode: deployedBytecode$1,
	linkReferences: linkReferences$1,
	deployedLinkReferences: deployedLinkReferences$1
};

// returns the checksummed address if the address is valid, otherwise returns false
function isAddress(value) {
    try {
        return getAddress$1(value);
    }
    catch (_a) {
        return false;
    }
}
const ETHERSCAN_PREFIXES = {
    43113: CHAINS[ChainId.FUJI].blockExplorerUrls[0],
    43114: CHAINS[ChainId.AVALANCHE].blockExplorerUrls[0],
    11111: CHAINS[ChainId.WAGMI].blockExplorerUrls[0],
    16: CHAINS[ChainId.COSTON].blockExplorerUrls[0],
};
function getEtherscanLink(chainId, data, type) {
    const prefix = `${ETHERSCAN_PREFIXES[chainId] || ETHERSCAN_PREFIXES[43114]}`;
    switch (type) {
        case 'transaction': {
            return `${prefix}/tx/${data}`;
        }
        case 'token': {
            return `${prefix}/token/${data}`;
        }
        case 'block': {
            return `${prefix}/block/${data}`;
        }
        case 'address':
        default: {
            return `${prefix}/address/${data}`;
        }
    }
}
// shorten the checksummed version of the input address to have 0x + 4 characters at start and end
function shortenAddress(address, chars = 4) {
    const parsed = isAddress(address);
    if (!parsed) {
        throw Error(`Invalid 'address' parameter '${address}'.`);
    }
    return `${parsed.substring(0, chars + 2)}...${parsed.substring(42 - chars)}`;
}
// add 10%
function calculateGasMargin(value) {
    return value.mul(BigNumber$1.from(10000).add(BigNumber$1.from(1000))).div(BigNumber$1.from(10000));
}
// converts a basis points value to a sdk percent
function basisPointsToPercent(num) {
    return new Percent$1(JSBI$1.BigInt(num), JSBI$1.BigInt(10000));
}
// account is not optional
function getSigner(library, account) {
    return library.getSigner(account).connectUnchecked();
}
// account is optional
function getProviderOrSigner(library, account) {
    return account ? getSigner(library, account) : library;
}
// account is optional
function getContract(address, ABI, library, account) {
    if (!isAddress(address) || address === AddressZero) {
        throw Error(`Invalid 'address' parameter '${address}'.`);
    }
    return new Contract(address, ABI, getProviderOrSigner(library, account));
}
// account is optional
function getRouterContract(chainId, library, account) {
    return getContract(chainId ? ROUTER_ADDRESS[chainId] : ROUTER_ADDRESS[ChainId.AVALANCHE], IPangolinRouter.abi, library, account);
}
function isTokenOnList(defaultTokens, chainId, currency) {
    var _a;
    if (chainId && currency === CAVAX[chainId])
        return true;
    return Boolean(currency instanceof Token$2 && ((_a = defaultTokens[currency.chainId]) === null || _a === void 0 ? void 0 : _a[currency.address]));
}
/**
 * Returns true if the trade requires a confirmation of details before we can submit it
 * @param tradeA trade A
 * @param tradeB trade B
 */
function tradeMeaningfullyDiffers(tradeA, tradeB) {
    return (tradeA.tradeType !== tradeB.tradeType ||
        !currencyEquals(tradeA.inputAmount.currency, tradeB.inputAmount.currency) ||
        !tradeA.inputAmount.equalTo(tradeB.inputAmount) ||
        !currencyEquals(tradeA.outputAmount.currency, tradeB.outputAmount.currency) ||
        !tradeA.outputAmount.equalTo(tradeB.outputAmount));
}

// returns null on errors
function useContract(address, ABI, withSignerIfPossible = true) {
    const { library, account } = usePangolinWeb3();
    return useMemo(() => {
        if (!address || address === ZERO_ADDRESS || !ABI || !library)
            return null;
        try {
            return getContract(address, ABI, library, withSignerIfPossible && account ? account : undefined);
        }
        catch (error) {
            console.error('Failed to get contract', error);
            return null;
        }
    }, [address, ABI, library, withSignerIfPossible, account]);
}
function useTokenContract(tokenAddress, withSignerIfPossible) {
    return useContract(tokenAddress, ERC20_ABI, withSignerIfPossible);
}
function useBytes32TokenContract(tokenAddress, withSignerIfPossible) {
    return useContract(tokenAddress, ERC20_BYTES32_ABI, withSignerIfPossible);
}
function useWETHContract(withSignerIfPossible) {
    var _a;
    const { chainId } = usePangolinWeb3();
    return useContract(chainId ? (_a = WAVAX[chainId]) === null || _a === void 0 ? void 0 : _a.address : undefined, WETH_ABI, withSignerIfPossible);
}
function useMulticallContract() {
    const { chainId } = usePangolinWeb3();
    return useContract(chainId && MULTICALL_NETWORKS[chainId], MULTICALL_ABI, false);
}

var ApplicationModal;
(function (ApplicationModal) {
    ApplicationModal[ApplicationModal["WALLET"] = 0] = "WALLET";
})(ApplicationModal || (ApplicationModal = {}));
const updateBlockNumber = createAction('papplication/updateBlockNumber');
const setOpenModal = createAction('papplication/setOpenModal');
const addPopup = createAction('papplication/addPopup');
const removePopup = createAction('papplication/removePopup');

function useBlockNumber() {
    const { chainId } = usePangolinWeb3();
    return useSelector((state) => state.papplication.blockNumber[chainId !== null && chainId !== void 0 ? chainId : -1]);
}
function useModalOpen(modal) {
    const openModal = useSelector((state) => state.papplication.openModal);
    return openModal === modal;
}
function useToggleModal(modal) {
    const open = useModalOpen(modal);
    const dispatch = useDispatch();
    return useCallback(() => dispatch(setOpenModal(open ? null : modal)), [dispatch, modal, open]);
}
function useWalletModalToggle() {
    return useToggleModal(ApplicationModal.WALLET);
}
// returns a function that allows adding a popup
function useAddPopup() {
    const dispatch = useDispatch();
    return useCallback((content, key) => {
        dispatch(addPopup({ content, key }));
    }, [dispatch]);
}

const ADDRESS_REGEX$1 = /^0x[a-fA-F0-9]{40}$/;
const LOWER_HEX_REGEX = /^0x[a-f0-9]*$/;
function toCallKey(call) {
    if (!ADDRESS_REGEX$1.test(call.address)) {
        throw new Error(`Invalid address: ${call.address}`);
    }
    if (!LOWER_HEX_REGEX.test(call.callData)) {
        throw new Error(`Invalid hex: ${call.callData}`);
    }
    return `${call.address}-${call.callData}`;
}
function parseCallKey(callKey) {
    const pcs = callKey.split('-');
    if (pcs.length !== 2) {
        throw new Error(`Invalid call key: ${callKey}`);
    }
    return {
        address: pcs[0],
        callData: pcs[1],
    };
}
const addMulticallListeners = createAction('pmulticall/addMulticallListeners');
const removeMulticallListeners = createAction('pmulticall/removeMulticallListeners');
const fetchingMulticallResults = createAction('pmulticall/fetchingMulticallResults');
const errorFetchingMulticallResults = createAction('pmulticall/errorFetchingMulticallResults');
const updateMulticallResults = createAction('pmulticall/updateMulticallResults');

function isMethodArg(x) {
    return ['string', 'number'].indexOf(typeof x) !== -1;
}
function isValidMethodArgs(x) {
    return (x === undefined ||
        (Array.isArray(x) && x.every((xi) => isMethodArg(xi) || (Array.isArray(xi) && xi.every(isMethodArg)))));
}
const INVALID_RESULT = { valid: false, blockNumber: undefined, data: undefined };
// use this options object
const NEVER_RELOAD = {
    blocksPerFetch: Infinity,
};
// the lowest level call for subscribing to contract data
function useCallsData(calls, options) {
    const { chainId } = usePangolinWeb3();
    const callResults = useSelector((state) => state.pmulticall.callResults);
    const dispatch = useDispatch();
    const serializedCallKeys = useMemo(() => {
        var _a, _b, _c;
        return JSON.stringify((_c = (_b = (_a = calls === null || calls === void 0 ? void 0 : calls.filter((c) => Boolean(c))) === null || _a === void 0 ? void 0 : _a.map(toCallKey)) === null || _b === void 0 ? void 0 : _b.sort()) !== null && _c !== void 0 ? _c : []);
    }, [calls]);
    // update listeners when there is an actual change that persists for at least 100ms
    useEffect(() => {
        const callKeys = JSON.parse(serializedCallKeys);
        if (!chainId || callKeys.length === 0)
            return undefined;
        const calls = callKeys.map((key) => parseCallKey(key));
        dispatch(addMulticallListeners({
            chainId,
            calls,
            options,
        }));
        return () => {
            dispatch(removeMulticallListeners({
                chainId,
                calls,
                options,
            }));
        };
    }, [chainId, dispatch, options, serializedCallKeys]);
    return useMemo(() => calls.map((call) => {
        var _a;
        if (!chainId || !call)
            return INVALID_RESULT;
        const result = (_a = callResults[chainId]) === null || _a === void 0 ? void 0 : _a[toCallKey(call)];
        let data;
        if ((result === null || result === void 0 ? void 0 : result.data) && (result === null || result === void 0 ? void 0 : result.data) !== '0x') {
            data = result.data;
        }
        return { valid: true, data, blockNumber: result === null || result === void 0 ? void 0 : result.blockNumber };
    }), [callResults, calls, chainId]);
}
const INVALID_CALL_STATE = { valid: false, result: undefined, loading: false, syncing: false, error: false };
const LOADING_CALL_STATE = { valid: true, result: undefined, loading: true, syncing: true, error: false };
function toCallState(callResult, contractInterface, fragment, latestBlockNumber) {
    if (!callResult)
        return INVALID_CALL_STATE;
    const { valid, data, blockNumber } = callResult;
    if (!valid)
        return INVALID_CALL_STATE;
    if (valid && !blockNumber)
        return LOADING_CALL_STATE;
    if (!contractInterface || !fragment || !latestBlockNumber)
        return LOADING_CALL_STATE;
    const success = data && data.length > 2;
    const syncing = (blockNumber !== null && blockNumber !== void 0 ? blockNumber : 0) < latestBlockNumber;
    let result = undefined;
    if (success && data) {
        try {
            result = contractInterface.decodeFunctionResult(fragment, data);
        }
        catch (error) {
            console.debug('Result data parsing failed', fragment, data);
            return {
                valid: true,
                loading: false,
                error: true,
                syncing,
                result,
            };
        }
    }
    return {
        valid: true,
        loading: false,
        syncing,
        result: result,
        error: !success,
    };
}
function useSingleContractMultipleData(contract, methodName, callInputs, options) {
    const fragment = useMemo(() => { var _a; return (_a = contract === null || contract === void 0 ? void 0 : contract.interface) === null || _a === void 0 ? void 0 : _a.getFunction(methodName); }, [contract, methodName]);
    const calls = useMemo(() => contract && fragment && callInputs && callInputs.length > 0
        ? callInputs.map((inputs) => {
            return {
                address: contract.address,
                callData: contract.interface.encodeFunctionData(fragment, inputs),
            };
        })
        : [], [callInputs, contract, fragment]);
    const results = useCallsData(calls, options);
    const latestBlockNumber = useBlockNumber();
    return useMemo(() => {
        return results.map((result) => toCallState(result, contract === null || contract === void 0 ? void 0 : contract.interface, fragment, latestBlockNumber));
    }, [fragment, contract, results, latestBlockNumber]);
}
function useMultipleContractSingleData(addresses, contractInterface, methodName, callInputs, options) {
    const fragment = useMemo(() => contractInterface.getFunction(methodName), [contractInterface, methodName]);
    const callData = useMemo(() => fragment && isValidMethodArgs(callInputs)
        ? contractInterface.encodeFunctionData(fragment, callInputs)
        : undefined, [callInputs, contractInterface, fragment]);
    const calls = useMemo(() => fragment && addresses && addresses.length > 0 && callData
        ? addresses.map((address) => {
            return address && callData
                ? {
                    address,
                    callData,
                }
                : undefined;
        })
        : [], [addresses, callData, fragment]);
    const results = useCallsData(calls, options);
    const latestBlockNumber = useBlockNumber();
    return useMemo(() => {
        return results.map((result) => toCallState(result, contractInterface, fragment, latestBlockNumber));
    }, [fragment, results, contractInterface, latestBlockNumber]);
}
function useSingleCallResult(contract, methodName, inputs, options) {
    const fragment = useMemo(() => { var _a; return (_a = contract === null || contract === void 0 ? void 0 : contract.interface) === null || _a === void 0 ? void 0 : _a.getFunction(methodName); }, [contract, methodName]);
    const calls = useMemo(() => {
        return contract && fragment && isValidMethodArgs(inputs)
            ? [
                {
                    address: contract.address,
                    callData: contract.interface.encodeFunctionData(fragment, inputs),
                },
            ]
            : [];
    }, [contract, fragment, inputs]);
    const result = useCallsData(calls, options)[0];
    const latestBlockNumber = useBlockNumber();
    return useMemo(() => {
        return toCallState(result, contract === null || contract === void 0 ? void 0 : contract.interface, fragment, latestBlockNumber);
    }, [result, contract, fragment, latestBlockNumber]);
}

function useTokenAllowance(token, owner, spender) {
    const contract = useTokenContract(token === null || token === void 0 ? void 0 : token.address, false);
    const inputs = useMemo(() => [owner, spender], [owner, spender]);
    const allowance = useSingleCallResult(contract, 'allowance', inputs).result;
    return useMemo(() => (token && allowance ? new TokenAmount(token, allowance.toString()) : undefined), [token, allowance]);
}

var Field;
(function (Field) {
    Field["INPUT"] = "INPUT";
    Field["OUTPUT"] = "OUTPUT";
})(Field || (Field = {}));
var LimitField;
(function (LimitField) {
    LimitField["INPUT"] = "input";
    LimitField["OUTPUT"] = "output";
    LimitField["PRICE"] = "price";
})(LimitField || (LimitField = {}));
var LimitNewField;
(function (LimitNewField) {
    LimitNewField["INPUT"] = "INPUT";
    LimitNewField["OUTPUT"] = "OUTPUT";
    LimitNewField["PRICE"] = "PRICE";
})(LimitNewField || (LimitNewField = {}));
const selectCurrency = createAction('pswap/selectCurrency');
const switchCurrencies = createAction('pswap/switchCurrencies');
const typeInput = createAction('pswap/typeInput');
const replaceSwapState = createAction('pswap/replaceSwapState');
const setRecipient = createAction('pswap/setRecipient');

const addTransaction = createAction('ptransactions/addTransaction');
const clearAllTransactions = createAction('ptransactions/clearAllTransactions');
const finalizeTransaction = createAction('ptransactions/finalizeTransaction');
const checkedTransaction = createAction('ptransactions/checkedTransaction');

// helper that can take a ethers library transaction response and add it to the list of transactions
function useTransactionAdder() {
    const { chainId, account } = usePangolinWeb3();
    const dispatch = useDispatch();
    return useCallback((response, { summary, approval, claim, } = {}) => {
        if (!account)
            return;
        if (!chainId)
            return;
        const { hash } = response;
        if (!hash) {
            throw Error('No transaction hash found.');
        }
        dispatch(addTransaction({ hash, from: account, chainId, approval, summary, claim }));
    }, [dispatch, chainId, account]);
}
// returns all the transactions for the current chain
function useAllTransactions() {
    var _a;
    const { chainId } = usePangolinWeb3();
    const state = useSelector((state) => state.ptransactions);
    return chainId ? (_a = state[chainId]) !== null && _a !== void 0 ? _a : {} : {};
}
/**
 * Returns whether a transaction happened in the last day (86400 seconds * 1000 milliseconds / second)
 * @param tx to check for recency
 */
function isTransactionRecent(tx) {
    return new Date().getTime() - tx.addedTime < 86400000;
}
// returns whether a token has a pending approval transaction
function useHasPendingApproval(tokenAddress, spender) {
    const allTransactions = useAllTransactions();
    return useMemo(() => typeof tokenAddress === 'string' &&
        typeof spender === 'string' &&
        Object.keys(allTransactions).some((hash) => {
            const tx = allTransactions[hash];
            if (!tx)
                return false;
            if (tx.receipt) {
                return false;
            }
            else {
                const approval = tx.approval;
                if (!approval)
                    return false;
                return approval.spender === spender && approval.tokenAddress === tokenAddress && isTransactionRecent(tx);
            }
        }), [allTransactions, spender, tokenAddress]);
}

const BASE_FEE = new Percent$1(JSBI$1.BigInt(30), JSBI$1.BigInt(10000));
const ONE_HUNDRED_PERCENT = new Percent$1(JSBI$1.BigInt(10000), JSBI$1.BigInt(10000));
const INPUT_FRACTION_AFTER_FEE = ONE_HUNDRED_PERCENT.subtract(BASE_FEE);
// computes price breakdown for the trade
function computeTradePriceBreakdown(trade) {
    // for each hop in our trade, take away the x*y=k price impact from 0.3% fees
    // e.g. for 3 tokens/2 hops: 1 - ((1 - .03) * (1-.03))
    const realizedLPFee = !trade
        ? undefined
        : ONE_HUNDRED_PERCENT.subtract(trade.route.pairs.reduce((currentFee) => currentFee.multiply(INPUT_FRACTION_AFTER_FEE), ONE_HUNDRED_PERCENT));
    // remove lp fees from price impact
    const priceImpactWithoutFeeFraction = trade && realizedLPFee ? trade.priceImpact.subtract(realizedLPFee) : undefined;
    // the x*y=k impact
    const priceImpactWithoutFeePercent = priceImpactWithoutFeeFraction
        ? new Percent$1(priceImpactWithoutFeeFraction === null || priceImpactWithoutFeeFraction === void 0 ? void 0 : priceImpactWithoutFeeFraction.numerator, priceImpactWithoutFeeFraction === null || priceImpactWithoutFeeFraction === void 0 ? void 0 : priceImpactWithoutFeeFraction.denominator)
        : undefined;
    // the amount of the input that accrues to LPs
    const realizedLPFeeAmount = realizedLPFee &&
        trade &&
        (trade.inputAmount instanceof TokenAmount
            ? new TokenAmount(trade.inputAmount.token, realizedLPFee.multiply(trade.inputAmount.raw).quotient)
            : CurrencyAmount.ether(realizedLPFee.multiply(trade.inputAmount.raw).quotient));
    return { priceImpactWithoutFee: priceImpactWithoutFeePercent, realizedLPFee: realizedLPFeeAmount };
}
// computes the minimum amount out and maximum amount in for a trade given a user specified allowed slippage in bips
function computeSlippageAdjustedAmounts(trade, allowedSlippage) {
    const pct = basisPointsToPercent(allowedSlippage);
    return {
        [Field.INPUT]: trade === null || trade === void 0 ? void 0 : trade.maximumAmountIn(pct),
        [Field.OUTPUT]: trade === null || trade === void 0 ? void 0 : trade.minimumAmountOut(pct),
    };
}
function warningSeverity(priceImpact) {
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(BLOCKED_PRICE_IMPACT_NON_EXPERT)))
        return 4;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(ALLOWED_PRICE_IMPACT_HIGH)))
        return 3;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(ALLOWED_PRICE_IMPACT_MEDIUM)))
        return 2;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(ALLOWED_PRICE_IMPACT_LOW)))
        return 1;
    return 0;
}

var ApprovalState;
(function (ApprovalState) {
    ApprovalState[ApprovalState["UNKNOWN"] = 0] = "UNKNOWN";
    ApprovalState[ApprovalState["NOT_APPROVED"] = 1] = "NOT_APPROVED";
    ApprovalState[ApprovalState["PENDING"] = 2] = "PENDING";
    ApprovalState[ApprovalState["APPROVED"] = 3] = "APPROVED";
})(ApprovalState || (ApprovalState = {}));
// returns a variable indicating the state of the approval and a function which approves if necessary or early returns
function useApproveCallback(chainId, amountToApprove, spender) {
    const { account } = usePangolinWeb3();
    const token = amountToApprove instanceof TokenAmount ? amountToApprove.token : undefined;
    const currentAllowance = useTokenAllowance(token, account !== null && account !== void 0 ? account : undefined, spender);
    const pendingApproval = useHasPendingApproval(token === null || token === void 0 ? void 0 : token.address, spender);
    // check the current approval status
    const approvalState = useMemo(() => {
        if (!amountToApprove || !spender)
            return ApprovalState.UNKNOWN;
        if (amountToApprove.currency === CAVAX[chainId])
            return ApprovalState.APPROVED;
        // we might not have enough data to know whether or not we need to approve
        if (!currentAllowance)
            return ApprovalState.UNKNOWN;
        // amountToApprove will be defined if currentAllowance is
        return currentAllowance.lessThan(amountToApprove)
            ? pendingApproval
                ? ApprovalState.PENDING
                : ApprovalState.NOT_APPROVED
            : ApprovalState.APPROVED;
    }, [amountToApprove, currentAllowance, pendingApproval, spender]);
    const tokenContract = useTokenContract(token === null || token === void 0 ? void 0 : token.address);
    const addTransaction = useTransactionAdder();
    const approve = useCallback(() => __awaiter$a(this, void 0, void 0, function* () {
        if (approvalState !== ApprovalState.NOT_APPROVED) {
            console.error('approve was called unnecessarily');
            return;
        }
        if (!token) {
            console.error('no token');
            return;
        }
        if (!tokenContract) {
            console.error('tokenContract is null');
            return;
        }
        if (!amountToApprove) {
            console.error('missing amount to approve');
            return;
        }
        if (!spender) {
            console.error('no spender');
            return;
        }
        let useExact = false;
        const estimatedGas = yield tokenContract.estimateGas.approve(spender, MaxUint256$1).catch(() => {
            // general fallback for tokens who restrict approval amounts
            useExact = true;
            return tokenContract.estimateGas.approve(spender, amountToApprove.raw.toString());
        });
        return tokenContract
            .approve(spender, useExact ? amountToApprove.raw.toString() : MaxUint256$1, {
            gasLimit: calculateGasMargin(estimatedGas),
        })
            .then((response) => {
            addTransaction(response, {
                summary: 'Approve ' + amountToApprove.currency.symbol,
                approval: { tokenAddress: token.address, spender: spender },
            });
        })
            .catch((error) => {
            console.debug('Failed to approve token', error);
            throw error;
        });
    }), [approvalState, token, tokenContract, amountToApprove, spender, addTransaction]);
    return [approvalState, approve];
}
// wraps useApproveCallback in the context of a swap
function useApproveCallbackFromTrade(chainId, trade, allowedSlippage = 0) {
    const amountToApprove = useMemo(() => (trade ? computeSlippageAdjustedAmounts(trade, allowedSlippage)[Field.INPUT] : undefined), [trade, allowedSlippage]);
    return useApproveCallback(chainId, amountToApprove, chainId ? ROUTER_ADDRESS[chainId] : ROUTER_ADDRESS[ChainId.AVALANCHE]);
}
// wraps useApproveCallback in the context of a swap
function useApproveCallbackFromInputCurrencyAmount(currencyAmountIn) {
    var _a;
    const chainId = useChainId();
    const gelatoLibrary = useGelatoLimitOrdersLib();
    const newCurrencyAmountIn = currencyAmountIn
        ? new TokenAmount(currencyAmountIn === null || currencyAmountIn === void 0 ? void 0 : currencyAmountIn.currency, currencyAmountIn === null || currencyAmountIn === void 0 ? void 0 : currencyAmountIn.numerator)
        : undefined;
    return useApproveCallback(chainId, newCurrencyAmountIn, (_a = gelatoLibrary === null || gelatoLibrary === void 0 ? void 0 : gelatoLibrary.erc20OrderRouter.address) !== null && _a !== void 0 ? _a : undefined);
}

// the Pangolin Default token list lives here
const PANGOLIN_LIST = 'https://raw.githubusercontent.com/pangolindex/tokenlists/main/pangolin.tokenlist.json';
const DEFAULT_TOKEN_LISTS_SELECTED = [PANGOLIN_LIST];
const DEFAULT_TOKEN_LISTS = [PANGOLIN_LIST];
// Token addresses (excluding PNG and WAVAX) ported from:
// https://raw.githubusercontent.com/pangolindex/tokenlists/main/aeb.tokenlist.json
const AEB_TOKENS = [
    '0xf20d962a6c8f70c731bd838a3a388D7d48fA6e15',
    '0xE54EB2C3009Fa411BF24fB017F9725b973CE36F0',
    '0x8cE2Dee54bB9921a2AE0A63dBb2DF8eD88B91dD9',
    '0x6b329326E0F6b95B93b52229b213334278D6f277',
    '0xaEb044650278731Ef3DC244692AB9F64C78FfaEA',
    '0xB3fe5374F67D7a22886A0eE082b2E2f9d2651651',
    '0xbA7dEebBFC5fA1100Fb055a87773e1E99Cd3507a',
    '0x46C54b16aF7747067f412c78eBaDaE203a26aDa0',
    '0xE1463E8991c8A62e64b77b5Fb6B22F190344C2A9',
    '0x39cf1BD5f15fb22eC3D9Ff86b0727aFc203427cc',
    '0x68e44C4619db40ae1a0725e77C02587bC8fBD1c9',
    '0xde3A24028580884448a5397872046a019649b084',
    '0x390ba0fb0Bd3Aa2a5484001606329701148074e6',
    '0xC84d7bfF2555955b44BDF6A307180810412D751B',
    '0xf39f9671906d8630812f9d9863bBEf5D523c84Ab',
    '0x408D4cD0ADb7ceBd1F1A1C33A0Ba2098E1295bAB',
    '0x99519AcB025a0e0d44c3875A4BbF03af65933627',
];

/**
 * Token instances created from token info.
 */
class WrappedTokenInfo extends Token$2 {
    constructor(tokenInfo, tags) {
        super(tokenInfo.chainId, tokenInfo.address, tokenInfo.decimals, tokenInfo.symbol, tokenInfo.name);
        this.tokenInfo = tokenInfo;
        this.tags = tags;
    }
    get logoURI() {
        return this.tokenInfo.logoURI;
    }
}
/**
 * An empty result, useful as a default.
 */
const EMPTY_LIST = {
    [ChainId.FUJI]: {},
    [ChainId.AVALANCHE]: {},
    [ChainId.WAGMI]: {},
    [ChainId.COSTON]: {},
};
const listCache = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
function listToTokenMap(list) {
    const result = listCache === null || listCache === void 0 ? void 0 : listCache.get(list);
    if (result)
        return result;
    const map = list.tokens.reduce((tokenMap, tokenInfo) => {
        var _a, _b, _c, _d;
        const tags = (_c = (_b = (_a = tokenInfo.tags) === null || _a === void 0 ? void 0 : _a.map((tagId) => {
            var _a;
            if (!((_a = list.tags) === null || _a === void 0 ? void 0 : _a[tagId]))
                return undefined;
            return Object.assign(Object.assign({}, list.tags[tagId]), { id: tagId });
        })) === null || _b === void 0 ? void 0 : _b.filter((x) => Boolean(x))) !== null && _c !== void 0 ? _c : [];
        const token = new WrappedTokenInfo(tokenInfo, tags);
        if (((_d = tokenMap === null || tokenMap === void 0 ? void 0 : tokenMap[token.chainId]) === null || _d === void 0 ? void 0 : _d[token.address]) !== undefined)
            throw Error('Duplicate tokens.');
        return Object.assign(Object.assign({}, tokenMap), { [token.chainId]: Object.assign(Object.assign({}, tokenMap[token.chainId]), { [token.address]: token }) });
    }, Object.assign({}, EMPTY_LIST));
    listCache === null || listCache === void 0 ? void 0 : listCache.set(list, map);
    return map;
}
function useTokenList(urls) {
    const lists = useSelector((state) => state.plists.byUrl);
    const tokenList = {};
    return useMemo(() => {
        [].concat(urls || []).forEach((url) => {
            var _a;
            const current = (_a = lists[url]) === null || _a === void 0 ? void 0 : _a.current;
            if (url && current) {
                try {
                    const data = listToTokenMap(current);
                    for (const [chainId, tokens] of Object.entries(data)) {
                        tokenList[chainId] = tokenList[chainId] || {};
                        tokenList[chainId] = Object.assign(Object.assign({}, tokenList[chainId]), tokens);
                    }
                }
                catch (error) {
                    console.error('Could not show token list due to error', error);
                }
            }
        });
        return tokenList;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lists, urls]);
}
function useSelectedListUrl() {
    return useSelector((state) => { var _a; return [].concat(((_a = state === null || state === void 0 ? void 0 : state.plists) === null || _a === void 0 ? void 0 : _a.selectedListUrl) || []); });
}
function useSelectedTokenList() {
    return useTokenList(useSelectedListUrl());
}
function useSelectedListInfo() {
    var _a, _b, _c, _d, _e;
    const selectedListUrl = useSelectedListUrl();
    const firstSelectedUrl = (_a = (selectedListUrl || [])) === null || _a === void 0 ? void 0 : _a[0];
    const listsByUrl = useSelector((state) => state.plists.byUrl);
    const list = firstSelectedUrl ? listsByUrl[firstSelectedUrl] : undefined;
    return {
        current: (_b = list === null || list === void 0 ? void 0 : list.current) !== null && _b !== void 0 ? _b : null,
        pending: (_c = list === null || list === void 0 ? void 0 : list.pendingUpdate) !== null && _c !== void 0 ? _c : null,
        loading: (list === null || list === void 0 ? void 0 : list.loadingRequestId) !== null,
        multipleSelected: ((_d = (selectedListUrl || [])) === null || _d === void 0 ? void 0 : _d.length) > 1,
        selectedCount: (_e = (selectedListUrl || [])) === null || _e === void 0 ? void 0 : _e.length,
    };
}
function useIsSelectedAEBToken() {
    const selectedOutputToken = useSelector((state) => state.pswap.OUTPUT);
    return AEB_TOKENS.some((tokenAddress) => tokenAddress === (selectedOutputToken === null || selectedOutputToken === void 0 ? void 0 : selectedOutputToken.currencyId));
}

const version$8 = "units/5.6.0";

const logger$3 = new Logger$1(version$8);
const names$3 = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether",
];
function formatUnits(value, unitName) {
    if (typeof (unitName) === "string") {
        const index = names$3.indexOf(unitName);
        if (index !== -1) {
            unitName = 3 * index;
        }
    }
    return formatFixed(value, (unitName != null) ? unitName : 18);
}
function parseUnits(value, unitName) {
    if (typeof (value) !== "string") {
        logger$3.throwArgumentError("value must be a string", "value", value);
    }
    if (typeof (unitName) === "string") {
        const index = names$3.indexOf(unitName);
        if (index !== -1) {
            unitName = 3 * index;
        }
    }
    return parseFixed(value, (unitName != null) ? unitName : 18);
}

const updateUserSlippageTolerance = createAction('puser/updateUserSlippageTolerance');
const updateUserExpertMode = createAction('puser/updateUserExpertMode');
const updateUserDeadline = createAction('puser/updateUserDeadline');
const addSerializedToken = createAction('puser/addSerializedToken');
const removeSerializedToken = createAction('puser/removeSerializedToken');

function deserializeToken(serializedToken) {
    return new Token$2(serializedToken.chainId, serializedToken.address, serializedToken.decimals, serializedToken.symbol, serializedToken.name);
}
function useUserSlippageTolerance() {
    const dispatch = useDispatch();
    const userSlippageTolerance = useSelector((state) => {
        return state.puser.userSlippageTolerance;
    });
    const setUserSlippageTolerance = useCallback((userSlippageTolerance) => {
        dispatch(updateUserSlippageTolerance({ userSlippageTolerance: userSlippageTolerance }));
    }, [dispatch]);
    return [userSlippageTolerance, setUserSlippageTolerance];
}
function useUserAddedTokens() {
    const { chainId } = usePangolinWeb3();
    const serializedTokensMap = useSelector(({ puser: { tokens } }) => tokens);
    return useMemo(() => {
        var _a;
        if (!chainId)
            return [];
        return Object.values((_a = serializedTokensMap[chainId]) !== null && _a !== void 0 ? _a : {}).map(deserializeToken);
    }, [serializedTokensMap, chainId]);
}
function useIsExpertMode() {
    return useSelector((state) => state.puser.userExpertMode);
}
function useExpertModeManager() {
    const dispatch = useDispatch();
    const expertMode = useIsExpertMode();
    const setExpertMode = useCallback((value) => {
        dispatch(updateUserExpertMode({ userExpertMode: value }));
    }, [dispatch]);
    return [expertMode, setExpertMode];
}
function useUserDeadline() {
    const dispatch = useDispatch();
    const userDeadline = useSelector((state) => state.puser.userDeadline);
    const setUserDeadline = useCallback((userDeadline) => {
        dispatch(updateUserDeadline({ userDeadline: userDeadline }));
    }, [dispatch]);
    return [userDeadline, setUserDeadline];
}

function useAllTokens() {
    const chainId = useChainId();
    const userAddedTokens = useUserAddedTokens();
    const allTokens = useSelectedTokenList();
    return useMemo(() => {
        if (!chainId)
            return {};
        return (userAddedTokens
            // reduce into all ALL_TOKENS filtered by the current chain
            .reduce((tokenMap, token) => {
            tokenMap[token.address] = token;
            return tokenMap;
        }, Object.assign({}, allTokens[chainId])));
    }, [chainId, userAddedTokens, allTokens]);
}
// parse a name or symbol from a token response
const BYTES32_REGEX = /^0x[a-fA-F0-9]{64}$/;
function parseStringOrBytes32(str, bytes32, defaultValue) {
    return str && str.length > 0
        ? str
        : bytes32 && BYTES32_REGEX.test(bytes32)
            ? parseBytes32String(bytes32)
            : defaultValue;
}
// undefined if invalid or does not exist
// null if loading
// otherwise returns the token
function useToken(tokenAddress) {
    const chainId = useChainId();
    const tokens = useAllTokens();
    const address = isAddress(tokenAddress);
    const tokenContract = useTokenContract(address ? address : undefined, false);
    const tokenContractBytes32 = useBytes32TokenContract(address ? address : undefined, false);
    const token = address ? tokens[address] : undefined;
    const tokenName = useSingleCallResult(token ? undefined : tokenContract, 'name', undefined, NEVER_RELOAD);
    const tokenNameBytes32 = useSingleCallResult(token ? undefined : tokenContractBytes32, 'name', undefined, NEVER_RELOAD);
    const symbol = useSingleCallResult(token ? undefined : tokenContract, 'symbol', undefined, NEVER_RELOAD);
    const symbolBytes32 = useSingleCallResult(token ? undefined : tokenContractBytes32, 'symbol', undefined, NEVER_RELOAD);
    const decimals = useSingleCallResult(token ? undefined : tokenContract, 'decimals', undefined, NEVER_RELOAD);
    return useMemo(() => {
        var _a, _b, _c, _d;
        if (token)
            return token;
        if (!chainId || !address)
            return undefined;
        if (decimals.loading || symbol.loading || tokenName.loading)
            return null;
        if (decimals.result) {
            return new Token$2(chainId, address, decimals.result[0], parseStringOrBytes32((_a = symbol.result) === null || _a === void 0 ? void 0 : _a[0], (_b = symbolBytes32.result) === null || _b === void 0 ? void 0 : _b[0], 'UNKNOWN'), parseStringOrBytes32((_c = tokenName.result) === null || _c === void 0 ? void 0 : _c[0], (_d = tokenNameBytes32.result) === null || _d === void 0 ? void 0 : _d[0], 'Unknown Token'));
        }
        return undefined;
    }, [
        address,
        chainId,
        decimals.loading,
        decimals.result,
        symbol.loading,
        symbol.result,
        symbolBytes32.result,
        token,
        tokenName.loading,
        tokenName.result,
        tokenNameBytes32.result,
    ]);
}
function useCurrency(currencyId) {
    const chainId = useChainId();
    const isAVAX = (currencyId === null || currencyId === void 0 ? void 0 : currencyId.toUpperCase()) === 'AVAX';
    const token = useToken(isAVAX ? undefined : currencyId);
    return isAVAX ? chainId && CAVAX[chainId] : token;
}
function useCoinGeckoTokenPrice(coin) {
    const [result, setResult] = useState({});
    useEffect(() => {
        const getCoinPriceData = () => __awaiter$a(this, void 0, void 0, function* () {
            var _a;
            try {
                const chain = coin.chainId === 43113 ? CHAINS[ChainId.AVALANCHE] : CHAINS[coin.chainId];
                const url = `${COINGEKO_BASE_URL}simple/token_price/${chain.coingecko_id}?contract_addresses=${coin.address.toLowerCase()}&vs_currencies=usd`;
                const response = yield fetch(url);
                const data = yield response.json();
                setResult({
                    tokenUsdPrice: (_a = data === null || data === void 0 ? void 0 : data[coin.address.toLowerCase()]) === null || _a === void 0 ? void 0 : _a.usd,
                });
            }
            catch (error) {
                console.error('coingecko api error', error);
            }
        });
        getCoinPriceData();
    }, [coin]);
    return result;
}
function useCoinGeckoTokenPriceChart(coin, days = '7') {
    const [result, setResult] = useState([]);
    useEffect(() => {
        const getCoinData = () => __awaiter$a(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                const chain = coin.chainId === 43113 ? CHAINS[ChainId.AVALANCHE] : CHAINS[coin.chainId];
                const url = `${COINGEKO_BASE_URL}coins/${chain.coingecko_id}/contract/${coin.address.toLowerCase()}/market_chart/?vs_currency=usd&days=${days}`;
                const response = yield fetch(url);
                const data = yield response.json();
                const formattedHistory = [];
                const priceData = (data === null || data === void 0 ? void 0 : data.prices) || [];
                // for each hour, construct the open and close price
                for (let i = 0; i < priceData.length - 1; i++) {
                    formattedHistory.push({
                        timestamp: (((_a = priceData[i]) === null || _a === void 0 ? void 0 : _a[0]) / 1000).toFixed(0),
                        priceUSD: parseFloat((_b = priceData[i]) === null || _b === void 0 ? void 0 : _b[1]),
                    });
                }
                setResult(formattedHistory);
            }
            catch (error) {
                console.error('coingecko api error', error);
            }
        });
        getCoinData();
    }, [coin, days]);
    return result;
}

var lodash_flatmap = {exports: {}};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

(function (module, exports) {
/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity]
 *  The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee));
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = flatMap;
}(lodash_flatmap, lodash_flatmap.exports));

var flatMap$1 = lodash_flatmap.exports;

var _format = "hh-sol-artifact-1";
var contractName = "IPangolinPair";
var sourceName = "contracts/pangolin-core/interfaces/IPangolinPair.sol";
var abi = [
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "Burn",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		name: "Mint",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0In",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1In",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0Out",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1Out",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "Swap",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint112",
				name: "reserve0",
				type: "uint112"
			},
			{
				indexed: false,
				internalType: "uint112",
				name: "reserve1",
				type: "uint112"
			}
		],
		name: "Sync",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
		],
		name: "DOMAIN_SEPARATOR",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "MINIMUM_LIQUIDITY",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
		],
		name: "PERMIT_TYPEHASH",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "burn",
		outputs: [
			{
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
		],
		name: "factory",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getReserves",
		outputs: [
			{
				internalType: "uint112",
				name: "reserve0",
				type: "uint112"
			},
			{
				internalType: "uint112",
				name: "reserve1",
				type: "uint112"
			},
			{
				internalType: "uint32",
				name: "blockTimestampLast",
				type: "uint32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "kLast",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "mint",
		outputs: [
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "nonces",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "permit",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "price0CumulativeLast",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "price1CumulativeLast",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "skim",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amount0Out",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1Out",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "swap",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
		],
		name: "sync",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "token0",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "token1",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];
var bytecode = "0x";
var deployedBytecode = "0x";
var linkReferences = {
};
var deployedLinkReferences = {
};
var IPangolinPair = {
	_format: _format,
	contractName: contractName,
	sourceName: sourceName,
	abi: abi,
	bytecode: bytecode,
	deployedBytecode: deployedBytecode,
	linkReferences: linkReferences,
	deployedLinkReferences: deployedLinkReferences
};

function wrappedCurrency(currency, chainId) {
    return chainId && currency === CAVAX[chainId] ? WAVAX[chainId] : currency instanceof Token$2 ? currency : undefined;
}
function convertToPangolinToken(token) {
    return new Token$2(token.chainId, token.address, token.decimals, token === null || token === void 0 ? void 0 : token.symbol, token === null || token === void 0 ? void 0 : token.name);
}
function wrappedGelatoCurrency(currency, chainId) {
    return chainId && !(currency === null || currency === void 0 ? void 0 : currency.isToken)
        ? WAVAX[chainId]
        : currency.isToken
            ? convertToPangolinToken(currency)
            : undefined;
}
function unwrappedToken(token, chainId) {
    var _a;
    if ((_a = token === null || token === void 0 ? void 0 : token.equals) === null || _a === void 0 ? void 0 : _a.call(token, WAVAX[token.chainId]))
        return CAVAX[chainId];
    return token;
}

const PAIR_INTERFACE = new Interface(IPangolinPair.abi);
var PairState;
(function (PairState) {
    PairState[PairState["LOADING"] = 0] = "LOADING";
    PairState[PairState["NOT_EXISTS"] = 1] = "NOT_EXISTS";
    PairState[PairState["EXISTS"] = 2] = "EXISTS";
    PairState[PairState["INVALID"] = 3] = "INVALID";
})(PairState || (PairState = {}));
function usePairs(currencies) {
    const { chainId } = usePangolinWeb3();
    const tokens = useMemo(() => currencies.map(([currencyA, currencyB]) => [
        wrappedCurrency(currencyA, chainId),
        wrappedCurrency(currencyB, chainId),
    ]), [chainId, currencies]);
    const pairAddresses = useMemo(() => tokens.map(([tokenA, tokenB]) => {
        return tokenA && tokenB && !tokenA.equals(tokenB)
            ? Pair.getAddress(tokenA, tokenB, chainId ? chainId : ChainId.AVALANCHE)
            : undefined;
    }), [tokens, chainId]);
    const results = useMultipleContractSingleData(pairAddresses, PAIR_INTERFACE, 'getReserves');
    return useMemo(() => {
        return results.map((result, i) => {
            const { result: reserves, loading } = result;
            const tokenA = tokens[i][0];
            const tokenB = tokens[i][1];
            if (loading)
                return [PairState.LOADING, null];
            if (!tokenA || !tokenB || tokenA.equals(tokenB))
                return [PairState.INVALID, null];
            if (!reserves)
                return [PairState.NOT_EXISTS, null];
            const { reserve0, reserve1 } = reserves;
            const [token0, token1] = tokenA.sortsBefore(tokenB) ? [tokenA, tokenB] : [tokenB, tokenA];
            return [
                PairState.EXISTS,
                new Pair(new TokenAmount(token0, reserve0.toString()), new TokenAmount(token1, reserve1.toString()), chainId ? chainId : ChainId.AVALANCHE),
            ];
        });
    }, [results, tokens, chainId]);
}
function usePair(tokenA, tokenB) {
    return usePairs([[tokenA, tokenB]])[0];
}

function useAllCommonPairs(currencyA, currencyB) {
    const { chainId } = usePangolinWeb3();
    const bases = chainId ? BASES_TO_CHECK_TRADES_AGAINST[chainId] : []; // eslint-disable-line react-hooks/exhaustive-deps
    const [tokenA, tokenB] = chainId
        ? [wrappedCurrency(currencyA, chainId), wrappedCurrency(currencyB, chainId)]
        : [undefined, undefined];
    const basePairs = useMemo(() => flatMap$1(bases, (base) => bases.map((otherBase) => [base, otherBase])).filter(([t0, t1]) => t0.address !== t1.address), [bases]);
    const allPairCombinations = useMemo(() => tokenA && tokenB
        ? [
            // the direct pair
            [tokenA, tokenB],
            // token A against all bases
            ...bases.map((base) => [tokenA, base]),
            // token B against all bases
            ...bases.map((base) => [tokenB, base]),
            // each base against all bases
            ...basePairs,
        ]
            .filter((tokens) => Boolean(tokens[0] && tokens[1]))
            .filter(([t0, t1]) => t0.address !== t1.address)
            .filter(([tokenA, tokenB]) => {
            if (!chainId)
                return true;
            const customBases = CUSTOM_BASES[chainId];
            if (!customBases)
                return true;
            const customBasesA = customBases[tokenA.address];
            const customBasesB = customBases[tokenB.address];
            if (!customBasesA && !customBasesB)
                return true;
            if (customBasesA && !customBasesA.find((base) => tokenB.equals(base)))
                return false;
            if (customBasesB && !customBasesB.find((base) => tokenA.equals(base)))
                return false;
            return true;
        })
        : [], [tokenA, tokenB, bases, basePairs, chainId]);
    const allPairs = usePairs(allPairCombinations);
    // only pass along valid pairs, non-duplicated pairs
    return useMemo(() => Object.values(allPairs
        // filter out invalid pairs
        .filter((result) => Boolean(result[0] === PairState.EXISTS && result[1]))
        // filter out duplicated pairs
        .reduce((memo, [, curr]) => {
        var _a;
        memo[curr.liquidityToken.address] = (_a = memo[curr.liquidityToken.address]) !== null && _a !== void 0 ? _a : curr;
        return memo;
    }, {})), [allPairs]);
}
/**
 * Returns the best trade for the exact amount of tokens in to the given token out
 */
function useTradeExactIn(currencyAmountIn, currencyOut) {
    const allowedPairs = useAllCommonPairs(currencyAmountIn === null || currencyAmountIn === void 0 ? void 0 : currencyAmountIn.currency, currencyOut);
    return useMemo(() => {
        var _a;
        if (currencyAmountIn && currencyOut && allowedPairs.length > 0) {
            return ((_a = Trade.bestTradeExactIn(allowedPairs, currencyAmountIn, currencyOut, { maxHops: 3, maxNumResults: 1 })[0]) !== null && _a !== void 0 ? _a : null);
        }
        return null;
    }, [allowedPairs, currencyAmountIn, currencyOut]);
}
/**
 * Returns the best trade for the token in to the exact amount of token out
 */
function useTradeExactOut(currencyIn, currencyAmountOut) {
    const allowedPairs = useAllCommonPairs(currencyIn, currencyAmountOut === null || currencyAmountOut === void 0 ? void 0 : currencyAmountOut.currency);
    return useMemo(() => {
        var _a;
        if (currencyIn && currencyAmountOut && allowedPairs.length > 0) {
            return ((_a = Trade.bestTradeExactOut(allowedPairs, currencyIn, currencyAmountOut, { maxHops: 3, maxNumResults: 1 })[0]) !== null && _a !== void 0 ? _a : null);
        }
        return null;
    }, [allowedPairs, currencyIn, currencyAmountOut]);
}

var replace$1 = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

var formats$5 = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace$1.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

var formats$4 = formats$5;

var has$8 = Object.prototype.hasOwnProperty;
var isArray$l = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray$l(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge$2 = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray$l(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has$8.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray$l(target) && !isArray$l(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray$l(target) && isArray$l(source)) {
        source.forEach(function (item, i) {
            if (has$8.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has$8.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign$3 = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode$b = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode$c = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats$4.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer$5 = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray$l(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

var utils$i = {
    arrayToObject: arrayToObject,
    assign: assign$3,
    combine: combine,
    compact: compact,
    decode: decode$b,
    encode: encode$c,
    isBuffer: isBuffer$5,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge$2
};

var getSideChannel = sideChannel;
var utils$h = utils$i;
var formats$3 = formats$5;
var has$7 = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray$k = Array.isArray;
var split$1 = String.prototype.split;
var push$1 = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push$1.apply(arr, isArray$k(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats$3['default'];
var defaults$6 = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils$h.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats$3.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify$6 = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray$k(obj)) {
        obj = utils$h.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults$6.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils$h.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$6.encoder, charset, 'key', format);
            if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
                var valuesArray = split$1.call(String(obj), ',');
                var valuesJoined = '';
                for (var i = 0; i < valuesArray.length; ++i) {
                    valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults$6.encoder, charset, 'value', format));
                }
                return [formatter(keyValue) + '=' + valuesJoined];
            }
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$6.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray$k(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray$k(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray$k(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
            : prefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults$6;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults$6.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats$3['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has$7.call(formats$3.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats$3.formatters[format];

    var filter = defaults$6.filter;
    if (typeof opts.filter === 'function' || isArray$k(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults$6.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults$6.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$6.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults$6.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults$6.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults$6.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults$6.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults$6.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults$6.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$6.strictNullHandling
    };
};

var stringify_1$1 = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray$k(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify$6(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

var utils$g = utils$i;

var has$6 = Object.prototype.hasOwnProperty;
var isArray$j = Array.isArray;

var defaults$5 = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils$g.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults$5.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults$5.decoder, charset, 'key');
            val = utils$g.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults$5.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray$j(val) ? [val] : val;
        }

        if (has$6.call(obj, key)) {
            obj[key] = utils$g.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has$6.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has$6.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults$5;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults$5.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults$5.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults$5.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults$5.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults$5.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$5.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults$5.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults$5.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils$g.isRegExp(opts.delimiter) ? opts.delimiter : defaults$5.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults$5.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults$5.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults$5.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults$5.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$5.strictNullHandling
    };
};

var parse$7 = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils$g.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils$g.compact(obj);
};

var stringify$5 = stringify_1$1;
var parse$6 = parse$7;
var formats$2 = formats$5;

var lib$3 = {
    formats: formats$2,
    parse: parse$6,
    stringify: stringify$5
};

function useParsedQueryString() {
    const { href } = window.location || {};
    const search = href === null || href === void 0 ? void 0 : href.substring((href === null || href === void 0 ? void 0 : href.indexOf('?')) + 1);
    return useMemo(() => (search && search.length > 1 ? lib$3.parse(search, { parseArrays: false, ignoreQueryPrefix: true }) : {}), [search]);
}

// import useParsedQueryString from './useParsedQueryString'
var Version;
(function (Version) {
    Version["v1"] = "v1";
    Version["v2"] = "v2";
})(Version || (Version = {}));
const DEFAULT_VERSION = Version.v2;
function useToggledVersion() {
    //TODO
    // const { use } = useParsedQueryString()
    // if (!use || typeof use !== 'string') return Version.v2
    // if (use.toLowerCase() === 'v1') return Version.v1
    return DEFAULT_VERSION;
}

/**
 * Returns a map of the given addresses to their eventually consistent ETH balances.
 */
function useETHBalances(chainId, uncheckedAddresses) {
    const multicallContract = useMulticallContract();
    const addresses = useMemo(() => uncheckedAddresses
        ? uncheckedAddresses
            .map(isAddress)
            .filter((a) => a !== false)
            .sort()
        : [], [uncheckedAddresses]);
    const results = useSingleContractMultipleData(multicallContract, 'getEthBalance', addresses.map((address) => [address]));
    return useMemo(() => addresses.reduce((memo, address, i) => {
        var _a, _b;
        const value = (_b = (_a = results === null || results === void 0 ? void 0 : results[i]) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b[0];
        if (value)
            memo[address] = CurrencyAmount.ether(JSBI$1.BigInt(value.toString()), chainId);
        return memo;
    }, {}), [chainId, addresses, results]);
}
/**
 * Returns a map of token addresses to their eventually consistent token balances for a single account.
 */
function useTokenBalancesWithLoadingIndicator(address, tokens) {
    const validatedTokens = useMemo(() => { var _a; return (_a = tokens === null || tokens === void 0 ? void 0 : tokens.filter((t) => isAddress(t === null || t === void 0 ? void 0 : t.address) !== false)) !== null && _a !== void 0 ? _a : []; }, [tokens]);
    const validatedTokenAddresses = useMemo(() => validatedTokens.map((vt) => vt.address), [validatedTokens]);
    const balances = useMultipleContractSingleData(validatedTokenAddresses, ERC20_INTERFACE, 'balanceOf', [address]);
    const anyLoading = useMemo(() => balances.some((callState) => callState.loading), [balances]);
    return [
        useMemo(() => address && validatedTokens.length > 0
            ? validatedTokens.reduce((memo, token, i) => {
                var _a, _b;
                const value = (_b = (_a = balances === null || balances === void 0 ? void 0 : balances[i]) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b[0];
                const amount = value ? JSBI$1.BigInt(value.toString()) : undefined;
                if (amount) {
                    memo[token.address] = new TokenAmount(token, amount);
                }
                return memo;
            }, {})
            : {}, [address, validatedTokens, balances]),
        anyLoading,
    ];
}
function useTokenBalances(address, tokens) {
    return useTokenBalancesWithLoadingIndicator(address, tokens)[0];
}
function useCurrencyBalances(chainId, account, currencies) {
    const tokens = useMemo(() => { var _a; return (_a = currencies === null || currencies === void 0 ? void 0 : currencies.filter((currency) => currency instanceof Token$2)) !== null && _a !== void 0 ? _a : []; }, [currencies]);
    const tokenBalances = useTokenBalances(account, tokens);
    const containsETH = useMemo(() => { var _a; return (_a = currencies === null || currencies === void 0 ? void 0 : currencies.some((currency) => chainId && currency === CAVAX[chainId])) !== null && _a !== void 0 ? _a : false; }, [chainId, currencies]);
    const ethBalance = useETHBalances(chainId, containsETH ? [account] : []);
    return useMemo(() => {
        var _a;
        return (_a = currencies === null || currencies === void 0 ? void 0 : currencies.map((currency) => {
            if (!account || !currency)
                return undefined;
            if (currency instanceof Token$2)
                return tokenBalances[currency.address];
            if (currency === CAVAX[chainId])
                return ethBalance[account];
            return undefined;
        })) !== null && _a !== void 0 ? _a : [];
    }, [chainId, account, currencies, ethBalance, tokenBalances]);
}
function useCurrencyBalance(chainId, account, currency) {
    return useCurrencyBalances(chainId, account, [currency])[0];
}
// mimics useAllBalances
function useAllTokenBalances() {
    const { account } = usePangolinWeb3();
    const allTokens = useAllTokens();
    const allTokensArray = useMemo(() => Object.values(allTokens !== null && allTokens !== void 0 ? allTokens : {}), [allTokens]);
    const balances = useTokenBalances(account !== null && account !== void 0 ? account : undefined, allTokensArray);
    return balances !== null && balances !== void 0 ? balances : {};
}

/* eslint-disable max-lines */
function useSwapState() {
    return useSelector((state) => state.pswap);
}
function useSwapActionHandlers(chainId) {
    const dispatch = useDispatch();
    const onCurrencySelection = useCallback((field, currency) => {
        dispatch(selectCurrency({
            field,
            currencyId: currency instanceof Token$2 ? currency.address : currency === CAVAX[chainId] ? 'AVAX' : '',
        }));
    }, [dispatch]);
    const onSwitchTokens = useCallback(() => {
        dispatch(switchCurrencies());
    }, [dispatch]);
    const onUserInput = useCallback((field, typedValue) => {
        dispatch(typeInput({ field, typedValue }));
    }, [dispatch]);
    const onChangeRecipient = useCallback((recipient) => {
        dispatch(setRecipient({ recipient }));
    }, [dispatch]);
    return {
        onSwitchTokens,
        onCurrencySelection,
        onUserInput,
        onChangeRecipient,
    };
}
// try to parse a user entered amount for a given token
function tryParseAmount(value, currency) {
    if (!value || !currency) {
        return undefined;
    }
    try {
        const typedValueParsed = parseUnits(value, currency.decimals).toString();
        if (typedValueParsed !== '0') {
            return currency instanceof Token$2
                ? new TokenAmount(currency, JSBI$1.BigInt(typedValueParsed))
                : CurrencyAmount.ether(JSBI$1.BigInt(typedValueParsed));
        }
    }
    catch (error) {
        // should fail if the user specifies too many decimal places of precision (or maybe exceed max uint?)
        console.debug(`Failed to parse input amount: "${value}"`, error);
    }
    // necessary for all paths to return a value
    return undefined;
}
const BAD_RECIPIENT_ADDRESSES = [
    FACTORY_ADDRESS[ChainId.AVALANCHE],
    ROUTER_ADDRESS[ChainId.AVALANCHE], // v2 router 02
];
/**
 * Returns true if any of the pairs or tokens in a trade have the given checksummed address
 * @param trade to check for the given address
 * @param checksummedAddress address to check in the pairs and tokens
 */
function involvesAddress(trade, checksummedAddress) {
    return (trade.route.path.some((token) => token.address === checksummedAddress) ||
        trade.route.pairs.some((pair) => pair.liquidityToken.address === checksummedAddress));
}
// from the current swap inputs, compute the best trade and return it.
function useDerivedSwapInfo() {
    var _a, _b;
    const { account } = usePangolinWeb3();
    const chainId = useChainId();
    const toggledVersion = useToggledVersion();
    const { independentField, typedValue, [Field.INPUT]: { currencyId: inputCurrencyId }, [Field.OUTPUT]: { currencyId: outputCurrencyId }, recipient, } = useSwapState();
    const inputCurrency = useCurrency(inputCurrencyId);
    const outputCurrency = useCurrency(outputCurrencyId);
    const recipientAddress = isAddress(recipient);
    const to = (_a = (recipientAddress ? recipientAddress : account)) !== null && _a !== void 0 ? _a : null;
    const relevantTokenBalances = useCurrencyBalances(chainId, account !== null && account !== void 0 ? account : undefined, [
        inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined,
        outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined,
    ]);
    const isExactIn = independentField === Field.INPUT;
    const parsedAmount = tryParseAmount(typedValue, (_b = (isExactIn ? inputCurrency : outputCurrency)) !== null && _b !== void 0 ? _b : undefined);
    const bestTradeExactIn = useTradeExactIn(isExactIn ? parsedAmount : undefined, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined);
    const bestTradeExactOut = useTradeExactOut(inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined, !isExactIn ? parsedAmount : undefined);
    const v2Trade = isExactIn ? bestTradeExactIn : bestTradeExactOut;
    const currencyBalances = {
        [Field.INPUT]: relevantTokenBalances[0],
        [Field.OUTPUT]: relevantTokenBalances[1],
    };
    const currencies = {
        [Field.INPUT]: inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined,
        [Field.OUTPUT]: outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined,
    };
    // get link to trade on v1, if a better rate exists
    const v1Trade = undefined;
    let inputError;
    if (!account) {
        inputError = 'Connect Wallet';
    }
    if (!parsedAmount) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : 'Enter an amount';
    }
    if (!currencies[Field.INPUT] || !currencies[Field.OUTPUT]) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : 'Select a token';
    }
    const formattedTo = isAddress(to);
    if (!to || !formattedTo) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : 'Enter a recipient';
    }
    else {
        if (BAD_RECIPIENT_ADDRESSES.indexOf(formattedTo) !== -1 ||
            (bestTradeExactIn && involvesAddress(bestTradeExactIn, formattedTo)) ||
            (bestTradeExactOut && involvesAddress(bestTradeExactOut, formattedTo))) {
            inputError = inputError !== null && inputError !== void 0 ? inputError : 'Invalid recipient';
        }
    }
    const [allowedSlippage] = useUserSlippageTolerance();
    const slippageAdjustedAmounts = v2Trade && allowedSlippage && computeSlippageAdjustedAmounts(v2Trade, allowedSlippage);
    // compare input balance to max input based on version
    const [balanceIn, amountIn] = [
        currencyBalances[Field.INPUT],
        toggledVersion === Version.v1
            ? null
            : slippageAdjustedAmounts
                ? slippageAdjustedAmounts[Field.INPUT]
                : null,
    ];
    if (balanceIn && amountIn && balanceIn.lessThan(amountIn)) {
        inputError = 'Insufficient' + amountIn.currency.symbol + ' balance';
    }
    return {
        currencies,
        currencyBalances,
        parsedAmount,
        v2Trade: v2Trade !== null && v2Trade !== void 0 ? v2Trade : undefined,
        inputError,
        v1Trade,
    };
}
function parseCurrencyFromURLParameter(urlParam) {
    if (typeof urlParam === 'string') {
        const valid = isAddress(urlParam);
        if (valid)
            return valid;
        if (urlParam.toUpperCase() === 'AVAX')
            return 'AVAX';
        if (valid === false)
            return 'AVAX';
    }
    //return 'AVAX' ?? '';
    return '';
}
function parseTokenAmountURLParameter(urlParam) {
    return typeof urlParam === 'string' && !isNaN(parseFloat(urlParam)) ? urlParam : '';
}
function parseIndependentFieldURLParameter(urlParam) {
    return typeof urlParam === 'string' && urlParam.toLowerCase() === 'output' ? Field.OUTPUT : Field.INPUT;
}
const ENS_NAME_REGEX$1 = /^[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)?$/;
const ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;
function validatedRecipient(recipient) {
    if (typeof recipient !== 'string')
        return null;
    const address = isAddress(recipient);
    if (address)
        return address;
    if (ENS_NAME_REGEX$1.test(recipient))
        return recipient;
    if (ADDRESS_REGEX.test(recipient))
        return recipient;
    return null;
}
function queryParametersToSwapState(parsedQs) {
    let inputCurrency = parseCurrencyFromURLParameter(parsedQs.inputCurrency);
    let outputCurrency = parseCurrencyFromURLParameter(parsedQs.outputCurrency);
    if (inputCurrency === outputCurrency) {
        if (typeof parsedQs.outputCurrency === 'string') {
            inputCurrency = '';
        }
        else {
            outputCurrency = '';
        }
    }
    const recipient = validatedRecipient(parsedQs.recipient);
    return {
        [Field.INPUT]: {
            currencyId: inputCurrency,
        },
        [Field.OUTPUT]: {
            currencyId: outputCurrency,
        },
        typedValue: parseTokenAmountURLParameter(parsedQs.exactAmount),
        independentField: parseIndependentFieldURLParameter(parsedQs.exactField),
        recipient,
    };
}
// updates the swap state to use the defaults for a given network
function useDefaultsFromURLSearch() {
    const { chainId } = usePangolinWeb3();
    const dispatch = useDispatch();
    const parsedQs = useParsedQueryString();
    const [result, setResult] = useState();
    const { [Field.INPUT]: { currencyId: inputCurrencyId }, [Field.OUTPUT]: { currencyId: outputCurrencyId }, } = useSwapState();
    useEffect(() => {
        var _a, _b;
        if (!chainId)
            return;
        const parsed = queryParametersToSwapState(parsedQs);
        dispatch(replaceSwapState({
            typedValue: parsed.typedValue,
            field: parsed.independentField,
            inputCurrencyId: parsed[Field.INPUT].currencyId
                ? parsed[Field.INPUT].currencyId
                : inputCurrencyId
                    ? inputCurrencyId
                    : (_a = SWAP_DEFAULT_CURRENCY[chainId]) === null || _a === void 0 ? void 0 : _a.inputCurrency,
            outputCurrencyId: parsed[Field.OUTPUT].currencyId
                ? parsed[Field.OUTPUT].currencyId
                : outputCurrencyId
                    ? outputCurrencyId
                    : (_b = SWAP_DEFAULT_CURRENCY[chainId]) === null || _b === void 0 ? void 0 : _b.outputCurrency,
            recipient: parsed.recipient,
        }));
        setResult({ inputCurrencyId: parsed[Field.INPUT].currencyId, outputCurrencyId: parsed[Field.OUTPUT].currencyId });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, chainId]);
    return result;
}
function useGelatoLimitOrderDetail(order) {
    const { chainId } = usePangolinWeb3();
    const gelatoLibrary = useGelatoLimitOrdersLib();
    const inputCurrency = order.inputToken === NATIVE && chainId ? 'AVAX' : order.inputToken;
    const outputCurrency = order.outputToken === NATIVE && chainId ? 'AVAX' : order.outputToken;
    const currency0 = useCurrency(inputCurrency);
    const currency1 = useCurrency(outputCurrency);
    const inputToken = currency0 ? wrappedCurrency(currency0, chainId) : undefined;
    const outputToken = currency1 ? wrappedCurrency(currency1, chainId) : undefined;
    const inputAmount = useMemo(() => (inputToken && order.inputAmount ? new TokenAmount(inputToken, order.inputAmount) : undefined), [inputToken, order.inputAmount]);
    const rawMinReturn = useMemo(() => order.adjustedMinReturn
        ? order.adjustedMinReturn
        : gelatoLibrary && chainId && order.minReturn
            ? gelatoLibrary.getAdjustedMinReturn(order.minReturn)
            : undefined, [chainId, gelatoLibrary, order.adjustedMinReturn, order.minReturn]);
    const outputAmount = useMemo(() => (outputToken && rawMinReturn ? new TokenAmount(outputToken, rawMinReturn) : undefined), [outputToken, rawMinReturn]);
    const executionPrice = useMemo(() => outputAmount && outputAmount.greaterThan('0') && inputAmount && currency0 && currency1
        ? new Price(currency0, currency1, inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.raw, outputAmount === null || outputAmount === void 0 ? void 0 : outputAmount.raw)
        : undefined, [currency0, currency1, inputAmount, outputAmount]);
    return useMemo(() => ({
        currency0,
        currency1,
        inputAmount,
        outputAmount,
        executionPrice,
    }), [currency0, currency1, inputAmount, outputAmount, executionPrice]);
}
function useGelatoLimitOrderList() {
    const { open, executed, cancelled } = useGelatoLimitOrdersHistory();
    const openPending = useMemo(() => (open.pending || []).map((item) => {
        const container = Object.assign({}, item);
        container['pending'] = true;
        return container;
    }), [open.pending]);
    const cancelledPending = useMemo(() => (cancelled.pending || []).map((item) => {
        const container = Object.assign({}, item);
        container['pending'] = true;
        return container;
    }), [cancelled.pending]);
    const allOrders = useMemo(() => [...cancelledPending, ...openPending, ...open.confirmed, ...cancelled.confirmed, ...executed], [openPending, cancelledPending, open.confirmed, cancelled.confirmed, executed]);
    const allOpenOrders = useMemo(() => [...cancelledPending, ...openPending, ...open.confirmed], [openPending, cancelledPending, open.confirmed]);
    const allCancelledOrders = useMemo(() => cancelled.confirmed, [cancelled.confirmed]);
    return useMemo(() => ({
        allOrders,
        allOpenOrders,
        allCancelledOrders,
        executed,
    }), [allOrders, allOpenOrders, allCancelledOrders, executed]);
}
/* eslint-enable max-lines */

/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */
function maxAmountSpend(chainId, currencyAmount) {
    if (!currencyAmount)
        return undefined;
    if (chainId && currencyAmount.currency === CAVAX[chainId]) {
        if (JSBI$1.greaterThan(currencyAmount.raw, MIN_ETH)) {
            return CurrencyAmount.ether(JSBI$1.subtract(currencyAmount.raw, MIN_ETH), chainId);
        }
        else {
            return CurrencyAmount.ether(JSBI$1.BigInt(0), chainId);
        }
    }
    return currencyAmount;
}
function galetoMaxAmountSpend(chainId, currencyAmount) {
    if (!currencyAmount)
        return undefined;
    if (chainId && currencyAmount.currency === CAVAX[chainId]) {
        if (JSBI$1.greaterThan(currencyAmount.numerator, MIN_ETH)) {
            return CurrencyAmount.ether(JSBI$1.subtract(currencyAmount.numerator, MIN_ETH), chainId);
        }
        else {
            return CurrencyAmount.ether(JSBI$1.BigInt(0), chainId);
        }
    }
    return currencyAmount;
}

class JSBI extends Array{constructor(i,_){if(super(i),this.sign=_,i>JSBI.__kMaxLength)throw new RangeError("Maximum BigInt size exceeded")}static BigInt(i){var _=Math.floor,t=Number.isFinite;if("number"==typeof i){if(0===i)return JSBI.__zero();if(JSBI.__isOneDigitInt(i))return 0>i?JSBI.__oneDigit(-i,!0):JSBI.__oneDigit(i,!1);if(!t(i)||_(i)!==i)throw new RangeError("The number "+i+" cannot be converted to BigInt because it is not an integer");return JSBI.__fromDouble(i)}if("string"==typeof i){const _=JSBI.__fromString(i);if(null===_)throw new SyntaxError("Cannot convert "+i+" to a BigInt");return _}if("boolean"==typeof i)return !0===i?JSBI.__oneDigit(1,!1):JSBI.__zero();if("object"==typeof i){if(i.constructor===JSBI)return i;const _=JSBI.__toPrimitive(i);return JSBI.BigInt(_)}throw new TypeError("Cannot convert "+i+" to a BigInt")}toDebugString(){const i=["BigInt["];for(const _ of this)i.push((_?(_>>>0).toString(16):_)+", ");return i.push("]"),i.join("")}toString(i=10){if(2>i||36<i)throw new RangeError("toString() radix argument must be between 2 and 36");return 0===this.length?"0":0==(i&i-1)?JSBI.__toStringBasePowerOfTwo(this,i):JSBI.__toStringGeneric(this,i,!1)}static toNumber(i){const _=i.length;if(0===_)return 0;if(1===_){const _=i.__unsignedDigit(0);return i.sign?-_:_}const t=i.__digit(_-1),e=JSBI.__clz30(t),n=30*_-e;if(1024<n)return i.sign?-Infinity:1/0;let g=n-1,o=t,s=_-1;const l=e+3;let r=32===l?0:o<<l;r>>>=12;const a=l-12;let u=12<=l?0:o<<20+l,d=20+l;for(0<a&&0<s&&(s--,o=i.__digit(s),r|=o>>>30-a,u=o<<a+2,d=a+2);0<d&&0<s;)s--,o=i.__digit(s),u|=30<=d?o<<d-30:o>>>30-d,d-=30;const h=JSBI.__decideRounding(i,d,s,o);if((1===h||0===h&&1==(1&u))&&(u=u+1>>>0,0===u&&(r++,0!=r>>>20&&(r=0,g++,1023<g))))return i.sign?-Infinity:1/0;const m=i.sign?-2147483648:0;return g=g+1023<<20,JSBI.__kBitConversionInts[1]=m|g|r,JSBI.__kBitConversionInts[0]=u,JSBI.__kBitConversionDouble[0]}static unaryMinus(i){if(0===i.length)return i;const _=i.__copy();return _.sign=!i.sign,_}static bitwiseNot(i){return i.sign?JSBI.__absoluteSubOne(i).__trim():JSBI.__absoluteAddOne(i,!0)}static exponentiate(i,_){if(_.sign)throw new RangeError("Exponent must be positive");if(0===_.length)return JSBI.__oneDigit(1,!1);if(0===i.length)return i;if(1===i.length&&1===i.__digit(0))return i.sign&&0==(1&_.__digit(0))?JSBI.unaryMinus(i):i;if(1<_.length)throw new RangeError("BigInt too big");let t=_.__unsignedDigit(0);if(1===t)return i;if(t>=JSBI.__kMaxLengthBits)throw new RangeError("BigInt too big");if(1===i.length&&2===i.__digit(0)){const _=1+(0|t/30),e=i.sign&&0!=(1&t),n=new JSBI(_,e);n.__initializeDigits();const g=1<<t%30;return n.__setDigit(_-1,g),n}let e=null,n=i;for(0!=(1&t)&&(e=i),t>>=1;0!==t;t>>=1)n=JSBI.multiply(n,n),0!=(1&t)&&(null===e?e=n:e=JSBI.multiply(e,n));return e}static multiply(_,t){if(0===_.length)return _;if(0===t.length)return t;let i=_.length+t.length;30<=_.__clzmsd()+t.__clzmsd()&&i--;const e=new JSBI(i,_.sign!==t.sign);e.__initializeDigits();for(let n=0;n<_.length;n++)JSBI.__multiplyAccumulate(t,_.__digit(n),e,n);return e.__trim()}static divide(i,_){if(0===_.length)throw new RangeError("Division by zero");if(0>JSBI.__absoluteCompare(i,_))return JSBI.__zero();const t=i.sign!==_.sign,e=_.__unsignedDigit(0);let n;if(1===_.length&&32767>=e){if(1===e)return t===i.sign?i:JSBI.unaryMinus(i);n=JSBI.__absoluteDivSmall(i,e,null);}else n=JSBI.__absoluteDivLarge(i,_,!0,!1);return n.sign=t,n.__trim()}static remainder(i,_){if(0===_.length)throw new RangeError("Division by zero");if(0>JSBI.__absoluteCompare(i,_))return i;const t=_.__unsignedDigit(0);if(1===_.length&&32767>=t){if(1===t)return JSBI.__zero();const _=JSBI.__absoluteModSmall(i,t);return 0===_?JSBI.__zero():JSBI.__oneDigit(_,i.sign)}const e=JSBI.__absoluteDivLarge(i,_,!1,!0);return e.sign=i.sign,e.__trim()}static add(i,_){const t=i.sign;return t===_.sign?JSBI.__absoluteAdd(i,_,t):0<=JSBI.__absoluteCompare(i,_)?JSBI.__absoluteSub(i,_,t):JSBI.__absoluteSub(_,i,!t)}static subtract(i,_){const t=i.sign;return t===_.sign?0<=JSBI.__absoluteCompare(i,_)?JSBI.__absoluteSub(i,_,t):JSBI.__absoluteSub(_,i,!t):JSBI.__absoluteAdd(i,_,t)}static leftShift(i,_){return 0===_.length||0===i.length?i:_.sign?JSBI.__rightShiftByAbsolute(i,_):JSBI.__leftShiftByAbsolute(i,_)}static signedRightShift(i,_){return 0===_.length||0===i.length?i:_.sign?JSBI.__leftShiftByAbsolute(i,_):JSBI.__rightShiftByAbsolute(i,_)}static unsignedRightShift(){throw new TypeError("BigInts have no unsigned right shift; use >> instead")}static lessThan(i,_){return 0>JSBI.__compareToBigInt(i,_)}static lessThanOrEqual(i,_){return 0>=JSBI.__compareToBigInt(i,_)}static greaterThan(i,_){return 0<JSBI.__compareToBigInt(i,_)}static greaterThanOrEqual(i,_){return 0<=JSBI.__compareToBigInt(i,_)}static equal(_,t){if(_.sign!==t.sign)return !1;if(_.length!==t.length)return !1;for(let e=0;e<_.length;e++)if(_.__digit(e)!==t.__digit(e))return !1;return !0}static notEqual(i,_){return !JSBI.equal(i,_)}static bitwiseAnd(i,_){var t=Math.max;if(!i.sign&&!_.sign)return JSBI.__absoluteAnd(i,_).__trim();if(i.sign&&_.sign){const e=t(i.length,_.length)+1;let n=JSBI.__absoluteSubOne(i,e);const g=JSBI.__absoluteSubOne(_);return n=JSBI.__absoluteOr(n,g,n),JSBI.__absoluteAddOne(n,!0,n).__trim()}return i.sign&&([i,_]=[_,i]),JSBI.__absoluteAndNot(i,JSBI.__absoluteSubOne(_)).__trim()}static bitwiseXor(i,_){var t=Math.max;if(!i.sign&&!_.sign)return JSBI.__absoluteXor(i,_).__trim();if(i.sign&&_.sign){const e=t(i.length,_.length),n=JSBI.__absoluteSubOne(i,e),g=JSBI.__absoluteSubOne(_);return JSBI.__absoluteXor(n,g,n).__trim()}const e=t(i.length,_.length)+1;i.sign&&([i,_]=[_,i]);let n=JSBI.__absoluteSubOne(_,e);return n=JSBI.__absoluteXor(n,i,n),JSBI.__absoluteAddOne(n,!0,n).__trim()}static bitwiseOr(i,_){var t=Math.max;const e=t(i.length,_.length);if(!i.sign&&!_.sign)return JSBI.__absoluteOr(i,_).__trim();if(i.sign&&_.sign){let t=JSBI.__absoluteSubOne(i,e);const n=JSBI.__absoluteSubOne(_);return t=JSBI.__absoluteAnd(t,n,t),JSBI.__absoluteAddOne(t,!0,t).__trim()}i.sign&&([i,_]=[_,i]);let n=JSBI.__absoluteSubOne(_,e);return n=JSBI.__absoluteAndNot(n,i,n),JSBI.__absoluteAddOne(n,!0,n).__trim()}static asIntN(_,t){var i=Math.floor;if(0===t.length)return t;if(_=i(_),0>_)throw new RangeError("Invalid value: not (convertible to) a safe integer");if(0===_)return JSBI.__zero();if(_>=JSBI.__kMaxLengthBits)return t;const e=0|(_+29)/30;if(t.length<e)return t;const g=t.__unsignedDigit(e-1),o=1<<(_-1)%30;if(t.length===e&&g<o)return t;if(!((g&o)===o))return JSBI.__truncateToNBits(_,t);if(!t.sign)return JSBI.__truncateAndSubFromPowerOfTwo(_,t,!0);if(0==(g&o-1)){for(let n=e-2;0<=n;n--)if(0!==t.__digit(n))return JSBI.__truncateAndSubFromPowerOfTwo(_,t,!1);return t.length===e&&g===o?t:JSBI.__truncateToNBits(_,t)}return JSBI.__truncateAndSubFromPowerOfTwo(_,t,!1)}static asUintN(i,_){var t=Math.floor;if(0===_.length)return _;if(i=t(i),0>i)throw new RangeError("Invalid value: not (convertible to) a safe integer");if(0===i)return JSBI.__zero();if(_.sign){if(i>JSBI.__kMaxLengthBits)throw new RangeError("BigInt too big");return JSBI.__truncateAndSubFromPowerOfTwo(i,_,!1)}if(i>=JSBI.__kMaxLengthBits)return _;const e=0|(i+29)/30;if(_.length<e)return _;const g=i%30;if(_.length==e){if(0===g)return _;const i=_.__digit(e-1);if(0==i>>>g)return _}return JSBI.__truncateToNBits(i,_)}static ADD(i,_){if(i=JSBI.__toPrimitive(i),_=JSBI.__toPrimitive(_),"string"==typeof i)return "string"!=typeof _&&(_=_.toString()),i+_;if("string"==typeof _)return i.toString()+_;if(i=JSBI.__toNumeric(i),_=JSBI.__toNumeric(_),JSBI.__isBigInt(i)&&JSBI.__isBigInt(_))return JSBI.add(i,_);if("number"==typeof i&&"number"==typeof _)return i+_;throw new TypeError("Cannot mix BigInt and other types, use explicit conversions")}static LT(i,_){return JSBI.__compare(i,_,0)}static LE(i,_){return JSBI.__compare(i,_,1)}static GT(i,_){return JSBI.__compare(i,_,2)}static GE(i,_){return JSBI.__compare(i,_,3)}static EQ(i,_){for(;;){if(JSBI.__isBigInt(i))return JSBI.__isBigInt(_)?JSBI.equal(i,_):JSBI.EQ(_,i);if("number"==typeof i){if(JSBI.__isBigInt(_))return JSBI.__equalToNumber(_,i);if("object"!=typeof _)return i==_;_=JSBI.__toPrimitive(_);}else if("string"==typeof i){if(JSBI.__isBigInt(_))return i=JSBI.__fromString(i),null!==i&&JSBI.equal(i,_);if("object"!=typeof _)return i==_;_=JSBI.__toPrimitive(_);}else if("boolean"==typeof i){if(JSBI.__isBigInt(_))return JSBI.__equalToNumber(_,+i);if("object"!=typeof _)return i==_;_=JSBI.__toPrimitive(_);}else if("symbol"==typeof i){if(JSBI.__isBigInt(_))return !1;if("object"!=typeof _)return i==_;_=JSBI.__toPrimitive(_);}else if("object"==typeof i){if("object"==typeof _&&_.constructor!==JSBI)return i==_;i=JSBI.__toPrimitive(i);}else return i==_}}static NE(i,_){return !JSBI.EQ(i,_)}static __zero(){return new JSBI(0,!1)}static __oneDigit(i,_){const t=new JSBI(1,_);return t.__setDigit(0,i),t}__copy(){const _=new JSBI(this.length,this.sign);for(let t=0;t<this.length;t++)_[t]=this[t];return _}__trim(){let i=this.length,_=this[i-1];for(;0===_;)i--,_=this[i-1],this.pop();return 0===i&&(this.sign=!1),this}__initializeDigits(){for(let _=0;_<this.length;_++)this[_]=0;}static __decideRounding(i,_,t,e){if(0<_)return -1;let n;if(0>_)n=-_-1;else {if(0===t)return -1;t--,e=i.__digit(t),n=29;}let g=1<<n;if(0==(e&g))return -1;if(g-=1,0!=(e&g))return 1;for(;0<t;)if(t--,0!==i.__digit(t))return 1;return 0}static __fromDouble(i){JSBI.__kBitConversionDouble[0]=i;const _=2047&JSBI.__kBitConversionInts[1]>>>20,t=_-1023,e=(0|t/30)+1,n=new JSBI(e,0>i);let g=1048575&JSBI.__kBitConversionInts[1]|1048576,o=JSBI.__kBitConversionInts[0];const s=20,l=t%30;let r,a=0;if(l<20){const i=s-l;a=i+32,r=g>>>i,g=g<<32-i|o>>>i,o<<=32-i;}else if(l===20)a=32,r=g,g=o,o=0;else {const i=l-s;a=32-i,r=g<<i|o>>>32-i,g=o<<i,o=0;}n.__setDigit(e-1,r);for(let _=e-2;0<=_;_--)0<a?(a-=30,r=g>>>2,g=g<<30|o>>>2,o<<=30):r=0,n.__setDigit(_,r);return n.__trim()}static __isWhitespace(i){return !!(13>=i&&9<=i)||(159>=i?32==i:131071>=i?160==i||5760==i:196607>=i?(i&=131071,10>=i||40==i||41==i||47==i||95==i||4096==i):65279==i)}static __fromString(i,_=0){let t=0;const e=i.length;let n=0;if(n===e)return JSBI.__zero();let g=i.charCodeAt(n);for(;JSBI.__isWhitespace(g);){if(++n===e)return JSBI.__zero();g=i.charCodeAt(n);}if(43===g){if(++n===e)return null;g=i.charCodeAt(n),t=1;}else if(45===g){if(++n===e)return null;g=i.charCodeAt(n),t=-1;}if(0===_){if(_=10,48===g){if(++n===e)return JSBI.__zero();if(g=i.charCodeAt(n),88===g||120===g){if(_=16,++n===e)return null;g=i.charCodeAt(n);}else if(79===g||111===g){if(_=8,++n===e)return null;g=i.charCodeAt(n);}else if(66===g||98===g){if(_=2,++n===e)return null;g=i.charCodeAt(n);}}}else if(16===_&&48===g){if(++n===e)return JSBI.__zero();if(g=i.charCodeAt(n),88===g||120===g){if(++n===e)return null;g=i.charCodeAt(n);}}if(0!=t&&10!==_)return null;for(;48===g;){if(++n===e)return JSBI.__zero();g=i.charCodeAt(n);}const o=e-n;let s=JSBI.__kMaxBitsPerChar[_],l=JSBI.__kBitsPerCharTableMultiplier-1;if(o>1073741824/s)return null;const r=s*o+l>>>JSBI.__kBitsPerCharTableShift,a=new JSBI(0|(r+29)/30,!1),u=10>_?_:10,h=10<_?_-10:0;if(0==(_&_-1)){s>>=JSBI.__kBitsPerCharTableShift;const _=[],t=[];let o=!1;do{let l=0,r=0;for(;;){let _;if(g-48>>>0<u)_=g-48;else if((32|g)-97>>>0<h)_=(32|g)-87;else {o=!0;break}if(r+=s,l=l<<s|_,++n===e){o=!0;break}if(g=i.charCodeAt(n),30<r+s)break}_.push(l),t.push(r);}while(!o);JSBI.__fillFromParts(a,_,t);}else {a.__initializeDigits();let t=!1,o=0;do{let r=0,b=1;for(;;){let s;if(g-48>>>0<u)s=g-48;else if((32|g)-97>>>0<h)s=(32|g)-87;else {t=!0;break}const l=b*_;if(1073741823<l)break;if(b=l,r=r*_+s,o++,++n===e){t=!0;break}g=i.charCodeAt(n);}l=30*JSBI.__kBitsPerCharTableMultiplier-1;const D=0|(s*o+l>>>JSBI.__kBitsPerCharTableShift)/30;a.__inplaceMultiplyAdd(b,r,D);}while(!t)}if(n!==e){if(!JSBI.__isWhitespace(g))return null;for(n++;n<e;n++)if(g=i.charCodeAt(n),!JSBI.__isWhitespace(g))return null}return a.sign=-1==t,a.__trim()}static __fillFromParts(_,t,e){let n=0,g=0,o=0;for(let s=t.length-1;0<=s;s--){const i=t[s],l=e[s];g|=i<<o,o+=l,30===o?(_.__setDigit(n++,g),o=0,g=0):30<o&&(_.__setDigit(n++,1073741823&g),o-=30,g=i>>>l-o);}if(0!==g){if(n>=_.length)throw new Error("implementation bug");_.__setDigit(n++,g);}for(;n<_.length;n++)_.__setDigit(n,0);}static __toStringBasePowerOfTwo(_,i){const t=_.length;let e=i-1;e=(85&e>>>1)+(85&e),e=(51&e>>>2)+(51&e),e=(15&e>>>4)+(15&e);const n=e,g=i-1,o=_.__digit(t-1),s=JSBI.__clz30(o);let l=0|(30*t-s+n-1)/n;if(_.sign&&l++,268435456<l)throw new Error("string too long");const r=Array(l);let a=l-1,u=0,d=0;for(let e=0;e<t-1;e++){const i=_.__digit(e),t=(u|i<<d)&g;r[a--]=JSBI.__kConversionChars[t];const o=n-d;for(u=i>>>o,d=30-o;d>=n;)r[a--]=JSBI.__kConversionChars[u&g],u>>>=n,d-=n;}const h=(u|o<<d)&g;for(r[a--]=JSBI.__kConversionChars[h],u=o>>>n-d;0!==u;)r[a--]=JSBI.__kConversionChars[u&g],u>>>=n;if(_.sign&&(r[a--]="-"),-1!=a)throw new Error("implementation bug");return r.join("")}static __toStringGeneric(_,i,t){const e=_.length;if(0===e)return "";if(1===e){let e=_.__unsignedDigit(0).toString(i);return !1===t&&_.sign&&(e="-"+e),e}const n=30*e-JSBI.__clz30(_.__digit(e-1)),g=JSBI.__kMaxBitsPerChar[i],o=g-1;let s=n*JSBI.__kBitsPerCharTableMultiplier;s+=o-1,s=0|s/o;const l=s+1>>1,r=JSBI.exponentiate(JSBI.__oneDigit(i,!1),JSBI.__oneDigit(l,!1));let a,u;const d=r.__unsignedDigit(0);if(1===r.length&&32767>=d){a=new JSBI(_.length,!1),a.__initializeDigits();let t=0;for(let e=2*_.length-1;0<=e;e--){const i=t<<15|_.__halfDigit(e);a.__setHalfDigit(e,0|i/d),t=0|i%d;}u=t.toString(i);}else {const t=JSBI.__absoluteDivLarge(_,r,!0,!0);a=t.quotient;const e=t.remainder.__trim();u=JSBI.__toStringGeneric(e,i,!0);}a.__trim();let h=JSBI.__toStringGeneric(a,i,!0);for(;u.length<l;)u="0"+u;return !1===t&&_.sign&&(h="-"+h),h+u}static __unequalSign(i){return i?-1:1}static __absoluteGreater(i){return i?-1:1}static __absoluteLess(i){return i?1:-1}static __compareToBigInt(i,_){const t=i.sign;if(t!==_.sign)return JSBI.__unequalSign(t);const e=JSBI.__absoluteCompare(i,_);return 0<e?JSBI.__absoluteGreater(t):0>e?JSBI.__absoluteLess(t):0}static __compareToNumber(i,_){if(JSBI.__isOneDigitInt(_)){const t=i.sign,e=0>_;if(t!==e)return JSBI.__unequalSign(t);if(0===i.length){if(e)throw new Error("implementation bug");return 0===_?0:-1}if(1<i.length)return JSBI.__absoluteGreater(t);const n=Math.abs(_),g=i.__unsignedDigit(0);return g>n?JSBI.__absoluteGreater(t):g<n?JSBI.__absoluteLess(t):0}return JSBI.__compareToDouble(i,_)}static __compareToDouble(i,_){if(_!==_)return _;if(_===1/0)return -1;if(_===-Infinity)return 1;const t=i.sign;if(t!==0>_)return JSBI.__unequalSign(t);if(0===_)throw new Error("implementation bug: should be handled elsewhere");if(0===i.length)return -1;JSBI.__kBitConversionDouble[0]=_;const e=2047&JSBI.__kBitConversionInts[1]>>>20;if(2047==e)throw new Error("implementation bug: handled elsewhere");const n=e-1023;if(0>n)return JSBI.__absoluteGreater(t);const g=i.length;let o=i.__digit(g-1);const s=JSBI.__clz30(o),l=30*g-s,r=n+1;if(l<r)return JSBI.__absoluteLess(t);if(l>r)return JSBI.__absoluteGreater(t);let a=1048576|1048575&JSBI.__kBitConversionInts[1],u=JSBI.__kBitConversionInts[0];const d=20,h=29-s;if(h!==(0|(l-1)%30))throw new Error("implementation bug");let m,b=0;if(20>h){const i=d-h;b=i+32,m=a>>>i,a=a<<32-i|u>>>i,u<<=32-i;}else if(20===h)b=32,m=a,a=u,u=0;else {const i=h-d;b=32-i,m=a<<i|u>>>32-i,a=u<<i,u=0;}if(o>>>=0,m>>>=0,o>m)return JSBI.__absoluteGreater(t);if(o<m)return JSBI.__absoluteLess(t);for(let e=g-2;0<=e;e--){0<b?(b-=30,m=a>>>2,a=a<<30|u>>>2,u<<=30):m=0;const _=i.__unsignedDigit(e);if(_>m)return JSBI.__absoluteGreater(t);if(_<m)return JSBI.__absoluteLess(t)}if(0!==a||0!==u){if(0===b)throw new Error("implementation bug");return JSBI.__absoluteLess(t)}return 0}static __equalToNumber(i,_){var t=Math.abs;return JSBI.__isOneDigitInt(_)?0===_?0===i.length:1===i.length&&i.sign===0>_&&i.__unsignedDigit(0)===t(_):0===JSBI.__compareToDouble(i,_)}static __comparisonResultToBool(i,_){return 0===_?0>i:1===_?0>=i:2===_?0<i:3===_?0<=i:void 0}static __compare(i,_,t){if(i=JSBI.__toPrimitive(i),_=JSBI.__toPrimitive(_),"string"==typeof i&&"string"==typeof _)switch(t){case 0:return i<_;case 1:return i<=_;case 2:return i>_;case 3:return i>=_;}if(JSBI.__isBigInt(i)&&"string"==typeof _)return _=JSBI.__fromString(_),null!==_&&JSBI.__comparisonResultToBool(JSBI.__compareToBigInt(i,_),t);if("string"==typeof i&&JSBI.__isBigInt(_))return i=JSBI.__fromString(i),null!==i&&JSBI.__comparisonResultToBool(JSBI.__compareToBigInt(i,_),t);if(i=JSBI.__toNumeric(i),_=JSBI.__toNumeric(_),JSBI.__isBigInt(i)){if(JSBI.__isBigInt(_))return JSBI.__comparisonResultToBool(JSBI.__compareToBigInt(i,_),t);if("number"!=typeof _)throw new Error("implementation bug");return JSBI.__comparisonResultToBool(JSBI.__compareToNumber(i,_),t)}if("number"!=typeof i)throw new Error("implementation bug");if(JSBI.__isBigInt(_))return JSBI.__comparisonResultToBool(JSBI.__compareToNumber(_,i),2^t);if("number"!=typeof _)throw new Error("implementation bug");return 0===t?i<_:1===t?i<=_:2===t?i>_:3===t?i>=_:void 0}__clzmsd(){return JSBI.__clz30(this.__digit(this.length-1))}static __absoluteAdd(_,t,e){if(_.length<t.length)return JSBI.__absoluteAdd(t,_,e);if(0===_.length)return _;if(0===t.length)return _.sign===e?_:JSBI.unaryMinus(_);let n=_.length;(0===_.__clzmsd()||t.length===_.length&&0===t.__clzmsd())&&n++;const g=new JSBI(n,e);let o=0,s=0;for(;s<t.length;s++){const i=_.__digit(s)+t.__digit(s)+o;o=i>>>30,g.__setDigit(s,1073741823&i);}for(;s<_.length;s++){const i=_.__digit(s)+o;o=i>>>30,g.__setDigit(s,1073741823&i);}return s<g.length&&g.__setDigit(s,o),g.__trim()}static __absoluteSub(_,t,e){if(0===_.length)return _;if(0===t.length)return _.sign===e?_:JSBI.unaryMinus(_);const n=new JSBI(_.length,e);let g=0,o=0;for(;o<t.length;o++){const i=_.__digit(o)-t.__digit(o)-g;g=1&i>>>30,n.__setDigit(o,1073741823&i);}for(;o<_.length;o++){const i=_.__digit(o)-g;g=1&i>>>30,n.__setDigit(o,1073741823&i);}return n.__trim()}static __absoluteAddOne(_,i,t=null){const e=_.length;null===t?t=new JSBI(e,i):t.sign=i;let n=1;for(let g=0;g<e;g++){const i=_.__digit(g)+n;n=i>>>30,t.__setDigit(g,1073741823&i);}return 0!=n&&t.__setDigitGrow(e,1),t}static __absoluteSubOne(_,t){const e=_.length;t=t||e;const n=new JSBI(t,!1);let g=1;for(let o=0;o<e;o++){const i=_.__digit(o)-g;g=1&i>>>30,n.__setDigit(o,1073741823&i);}if(0!=g)throw new Error("implementation bug");for(let g=e;g<t;g++)n.__setDigit(g,0);return n}static __absoluteAnd(_,t,e=null){let n=_.length,g=t.length,o=g;if(n<g){o=n;const i=_,e=n;_=t,n=g,t=i,g=e;}let s=o;null===e?e=new JSBI(s,!1):s=e.length;let l=0;for(;l<o;l++)e.__setDigit(l,_.__digit(l)&t.__digit(l));for(;l<s;l++)e.__setDigit(l,0);return e}static __absoluteAndNot(_,t,e=null){const n=_.length,g=t.length;let o=g;n<g&&(o=n);let s=n;null===e?e=new JSBI(s,!1):s=e.length;let l=0;for(;l<o;l++)e.__setDigit(l,_.__digit(l)&~t.__digit(l));for(;l<n;l++)e.__setDigit(l,_.__digit(l));for(;l<s;l++)e.__setDigit(l,0);return e}static __absoluteOr(_,t,e=null){let n=_.length,g=t.length,o=g;if(n<g){o=n;const i=_,e=n;_=t,n=g,t=i,g=e;}let s=n;null===e?e=new JSBI(s,!1):s=e.length;let l=0;for(;l<o;l++)e.__setDigit(l,_.__digit(l)|t.__digit(l));for(;l<n;l++)e.__setDigit(l,_.__digit(l));for(;l<s;l++)e.__setDigit(l,0);return e}static __absoluteXor(_,t,e=null){let n=_.length,g=t.length,o=g;if(n<g){o=n;const i=_,e=n;_=t,n=g,t=i,g=e;}let s=n;null===e?e=new JSBI(s,!1):s=e.length;let l=0;for(;l<o;l++)e.__setDigit(l,_.__digit(l)^t.__digit(l));for(;l<n;l++)e.__setDigit(l,_.__digit(l));for(;l<s;l++)e.__setDigit(l,0);return e}static __absoluteCompare(_,t){const e=_.length-t.length;if(0!=e)return e;let n=_.length-1;for(;0<=n&&_.__digit(n)===t.__digit(n);)n--;return 0>n?0:_.__unsignedDigit(n)>t.__unsignedDigit(n)?1:-1}static __multiplyAccumulate(_,t,e,n){if(0===t)return;const g=32767&t,o=t>>>15;let s=0,l=0;for(let r,a=0;a<_.length;a++,n++){r=e.__digit(n);const i=_.__digit(a),t=32767&i,u=i>>>15,d=JSBI.__imul(t,g),h=JSBI.__imul(t,o),m=JSBI.__imul(u,g),b=JSBI.__imul(u,o);r+=l+d+s,s=r>>>30,r&=1073741823,r+=((32767&h)<<15)+((32767&m)<<15),s+=r>>>30,l=b+(h>>>15)+(m>>>15),e.__setDigit(n,1073741823&r);}for(;0!=s||0!==l;n++){let i=e.__digit(n);i+=s+l,l=0,s=i>>>30,e.__setDigit(n,1073741823&i);}}static __internalMultiplyAdd(_,t,e,g,o){let s=e,l=0;for(let n=0;n<g;n++){const i=_.__digit(n),e=JSBI.__imul(32767&i,t),g=JSBI.__imul(i>>>15,t),a=e+((32767&g)<<15)+l+s;s=a>>>30,l=g>>>15,o.__setDigit(n,1073741823&a);}if(o.length>g)for(o.__setDigit(g++,s+l);g<o.length;)o.__setDigit(g++,0);else if(0!==s+l)throw new Error("implementation bug")}__inplaceMultiplyAdd(i,_,t){t>this.length&&(t=this.length);const e=32767&i,n=i>>>15;let g=0,o=_;for(let s=0;s<t;s++){const i=this.__digit(s),_=32767&i,t=i>>>15,l=JSBI.__imul(_,e),r=JSBI.__imul(_,n),a=JSBI.__imul(t,e),u=JSBI.__imul(t,n);let d=o+l+g;g=d>>>30,d&=1073741823,d+=((32767&r)<<15)+((32767&a)<<15),g+=d>>>30,o=u+(r>>>15)+(a>>>15),this.__setDigit(s,1073741823&d);}if(0!=g||0!==o)throw new Error("implementation bug")}static __absoluteDivSmall(_,t,e=null){null===e&&(e=new JSBI(_.length,!1));let n=0;for(let g,o=2*_.length-1;0<=o;o-=2){g=(n<<15|_.__halfDigit(o))>>>0;const i=0|g/t;n=0|g%t,g=(n<<15|_.__halfDigit(o-1))>>>0;const s=0|g/t;n=0|g%t,e.__setDigit(o>>>1,i<<15|s);}return e}static __absoluteModSmall(_,t){let e=0;for(let n=2*_.length-1;0<=n;n--){const i=(e<<15|_.__halfDigit(n))>>>0;e=0|i%t;}return e}static __absoluteDivLarge(i,_,t,e){const g=_.__halfDigitLength(),n=_.length,o=i.__halfDigitLength()-g;let s=null;t&&(s=new JSBI(o+2>>>1,!1),s.__initializeDigits());const l=new JSBI(g+2>>>1,!1);l.__initializeDigits();const r=JSBI.__clz15(_.__halfDigit(g-1));0<r&&(_=JSBI.__specialLeftShift(_,r,0));const a=JSBI.__specialLeftShift(i,r,1),u=_.__halfDigit(g-1);let d=0;for(let r,h=o;0<=h;h--){r=32767;const i=a.__halfDigit(h+g);if(i!==u){const t=(i<<15|a.__halfDigit(h+g-1))>>>0;r=0|t/u;let e=0|t%u;const n=_.__halfDigit(g-2),o=a.__halfDigit(h+g-2);for(;JSBI.__imul(r,n)>>>0>(e<<16|o)>>>0&&(r--,e+=u,!(32767<e)););}JSBI.__internalMultiplyAdd(_,r,0,n,l);let e=a.__inplaceSub(l,h,g+1);0!==e&&(e=a.__inplaceAdd(_,h,g),a.__setHalfDigit(h+g,32767&a.__halfDigit(h+g)+e),r--),t&&(1&h?d=r<<15:s.__setDigit(h>>>1,d|r));}if(e)return a.__inplaceRightShift(r),t?{quotient:s,remainder:a}:a;if(t)return s;throw new Error("unreachable")}static __clz15(i){return JSBI.__clz30(i)-15}__inplaceAdd(_,t,e){let n=0;for(let g=0;g<e;g++){const i=this.__halfDigit(t+g)+_.__halfDigit(g)+n;n=i>>>15,this.__setHalfDigit(t+g,32767&i);}return n}__inplaceSub(_,t,e){let n=0;if(1&t){t>>=1;let g=this.__digit(t),o=32767&g,s=0;for(;s<e-1>>>1;s++){const i=_.__digit(s),e=(g>>>15)-(32767&i)-n;n=1&e>>>15,this.__setDigit(t+s,(32767&e)<<15|32767&o),g=this.__digit(t+s+1),o=(32767&g)-(i>>>15)-n,n=1&o>>>15;}const i=_.__digit(s),l=(g>>>15)-(32767&i)-n;n=1&l>>>15,this.__setDigit(t+s,(32767&l)<<15|32767&o);if(t+s+1>=this.length)throw new RangeError("out of bounds");0==(1&e)&&(g=this.__digit(t+s+1),o=(32767&g)-(i>>>15)-n,n=1&o>>>15,this.__setDigit(t+_.length,1073709056&g|32767&o));}else {t>>=1;let g=0;for(;g<_.length-1;g++){const i=this.__digit(t+g),e=_.__digit(g),o=(32767&i)-(32767&e)-n;n=1&o>>>15;const s=(i>>>15)-(e>>>15)-n;n=1&s>>>15,this.__setDigit(t+g,(32767&s)<<15|32767&o);}const i=this.__digit(t+g),o=_.__digit(g),s=(32767&i)-(32767&o)-n;n=1&s>>>15;let l=0;0==(1&e)&&(l=(i>>>15)-(o>>>15)-n,n=1&l>>>15),this.__setDigit(t+g,(32767&l)<<15|32767&s);}return n}__inplaceRightShift(_){if(0===_)return;let t=this.__digit(0)>>>_;const e=this.length-1;for(let n=0;n<e;n++){const i=this.__digit(n+1);this.__setDigit(n,1073741823&i<<30-_|t),t=i>>>_;}this.__setDigit(e,t);}static __specialLeftShift(_,t,e){const g=_.length,n=new JSBI(g+e,!1);if(0===t){for(let t=0;t<g;t++)n.__setDigit(t,_.__digit(t));return 0<e&&n.__setDigit(g,0),n}let o=0;for(let s=0;s<g;s++){const i=_.__digit(s);n.__setDigit(s,1073741823&i<<t|o),o=i>>>30-t;}return 0<e&&n.__setDigit(g,o),n}static __leftShiftByAbsolute(_,i){const t=JSBI.__toShiftAmount(i);if(0>t)throw new RangeError("BigInt too big");const e=0|t/30,n=t%30,g=_.length,o=0!==n&&0!=_.__digit(g-1)>>>30-n,s=g+e+(o?1:0),l=new JSBI(s,_.sign);if(0===n){let t=0;for(;t<e;t++)l.__setDigit(t,0);for(;t<s;t++)l.__setDigit(t,_.__digit(t-e));}else {let t=0;for(let _=0;_<e;_++)l.__setDigit(_,0);for(let o=0;o<g;o++){const i=_.__digit(o);l.__setDigit(o+e,1073741823&i<<n|t),t=i>>>30-n;}if(o)l.__setDigit(g+e,t);else if(0!==t)throw new Error("implementation bug")}return l.__trim()}static __rightShiftByAbsolute(_,i){const t=_.length,e=_.sign,n=JSBI.__toShiftAmount(i);if(0>n)return JSBI.__rightShiftByMaximum(e);const g=0|n/30,o=n%30;let s=t-g;if(0>=s)return JSBI.__rightShiftByMaximum(e);let l=!1;if(e){if(0!=(_.__digit(g)&(1<<o)-1))l=!0;else for(let t=0;t<g;t++)if(0!==_.__digit(t)){l=!0;break}}if(l&&0===o){const i=_.__digit(t-1);0==~i&&s++;}let r=new JSBI(s,e);if(0===o){r.__setDigit(s-1,0);for(let e=g;e<t;e++)r.__setDigit(e-g,_.__digit(e));}else {let e=_.__digit(g)>>>o;const n=t-g-1;for(let t=0;t<n;t++){const i=_.__digit(t+g+1);r.__setDigit(t,1073741823&i<<30-o|e),e=i>>>o;}r.__setDigit(n,e);}return l&&(r=JSBI.__absoluteAddOne(r,!0,r)),r.__trim()}static __rightShiftByMaximum(i){return i?JSBI.__oneDigit(1,!0):JSBI.__zero()}static __toShiftAmount(i){if(1<i.length)return -1;const _=i.__unsignedDigit(0);return _>JSBI.__kMaxLengthBits?-1:_}static __toPrimitive(i,_="default"){if("object"!=typeof i)return i;if(i.constructor===JSBI)return i;if("undefined"!=typeof Symbol&&"symbol"==typeof Symbol.toPrimitive){const t=i[Symbol.toPrimitive];if(t){const i=t(_);if("object"!=typeof i)return i;throw new TypeError("Cannot convert object to primitive value")}}const t=i.valueOf;if(t){const _=t.call(i);if("object"!=typeof _)return _}const e=i.toString;if(e){const _=e.call(i);if("object"!=typeof _)return _}throw new TypeError("Cannot convert object to primitive value")}static __toNumeric(i){return JSBI.__isBigInt(i)?i:+i}static __isBigInt(i){return "object"==typeof i&&null!==i&&i.constructor===JSBI}static __truncateToNBits(i,_){const t=0|(i+29)/30,e=new JSBI(t,_.sign),n=t-1;for(let t=0;t<n;t++)e.__setDigit(t,_.__digit(t));let g=_.__digit(n);if(0!=i%30){const _=32-i%30;g=g<<_>>>_;}return e.__setDigit(n,g),e.__trim()}static __truncateAndSubFromPowerOfTwo(_,t,e){var n=Math.min;const g=0|(_+29)/30,o=new JSBI(g,e);let s=0;const l=g-1;let a=0;for(const i=n(l,t.length);s<i;s++){const i=0-t.__digit(s)-a;a=1&i>>>30,o.__setDigit(s,1073741823&i);}for(;s<l;s++)o.__setDigit(s,0|1073741823&-a);let u=l<t.length?t.__digit(l):0;const d=_%30;let h;if(0==d)h=0-u-a,h&=1073741823;else {const i=32-d;u=u<<i>>>i;const _=1<<32-i;h=_-u-a,h&=_-1;}return o.__setDigit(l,h),o.__trim()}__digit(_){return this[_]}__unsignedDigit(_){return this[_]>>>0}__setDigit(_,i){this[_]=0|i;}__setDigitGrow(_,i){this[_]=0|i;}__halfDigitLength(){const i=this.length;return 32767>=this.__unsignedDigit(i-1)?2*i-1:2*i}__halfDigit(_){return 32767&this[_>>>1]>>>15*(1&_)}__setHalfDigit(_,i){const t=_>>>1,e=this.__digit(t),n=1&_?32767&e|i<<15:1073709056&e|32767&i;this.__setDigit(t,n);}static __digitPow(i,_){let t=1;for(;0<_;)1&_&&(t*=i),_>>>=1,i*=i;return t}static __isOneDigitInt(i){return (1073741823&i)===i}}JSBI.__kMaxLength=33554432,JSBI.__kMaxLengthBits=JSBI.__kMaxLength<<5,JSBI.__kMaxBitsPerChar=[0,0,32,51,64,75,83,90,96,102,107,111,115,119,122,126,128,131,134,136,139,141,143,145,147,149,151,153,154,156,158,159,160,162,163,165,166],JSBI.__kBitsPerCharTableShift=5,JSBI.__kBitsPerCharTableMultiplier=1<<JSBI.__kBitsPerCharTableShift,JSBI.__kConversionChars=["0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z"],JSBI.__kBitConversionBuffer=new ArrayBuffer(8),JSBI.__kBitConversionDouble=new Float64Array(JSBI.__kBitConversionBuffer),JSBI.__kBitConversionInts=new Int32Array(JSBI.__kBitConversionBuffer),JSBI.__clz30=Math.clz32?function(i){return Math.clz32(i)-2}:function(i){return 0===i?30:0|29-(0|Math.log(i>>>0)/Math.LN2)},JSBI.__imul=Math.imul||function(i,_){return 0|i*_};

var isProduction$1 = process.env.NODE_ENV === 'production';
var prefix$2 = 'Invariant failed';
function invariant$2(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction$1) {
        throw new Error(prefix$2);
    }
    throw new Error(prefix$2 + ": " + (message || ''));
}

/*
 *  decimal.js-light v2.5.1
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js-light
 *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Expat Licence
 */


// ------------------------------------  EDITABLE DEFAULTS  ------------------------------------- //


// The limit on the value of `precision`, and on the value of the first argument to
// `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
var MAX_DIGITS = 1e9,                        // 0 to 1e9


  // The initial configuration properties of the Decimal constructor.
  defaults$4 = {

    // These values must be integers within the stated ranges (inclusive).
    // Most of these values can be changed during run-time using `Decimal.config`.

    // The maximum number of significant digits of the result of a calculation or base conversion.
    // E.g. `Decimal.config({ precision: 20 });`
    precision: 20,                         // 1 to MAX_DIGITS

    // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
    // `toFixed`, `toPrecision` and `toSignificantDigits`.
    //
    // ROUND_UP         0 Away from zero.
    // ROUND_DOWN       1 Towards zero.
    // ROUND_CEIL       2 Towards +Infinity.
    // ROUND_FLOOR      3 Towards -Infinity.
    // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    //
    // E.g.
    // `Decimal.rounding = 4;`
    // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
    rounding: 4,                           // 0 to 8

    // The exponent value at and beneath which `toString` returns exponential notation.
    // JavaScript numbers: -7
    toExpNeg: -7,                          // 0 to -MAX_E

    // The exponent value at and above which `toString` returns exponential notation.
    // JavaScript numbers: 21
    toExpPos:  21,                         // 0 to MAX_E

    // The natural logarithm of 10.
    // 115 digits
    LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
  },


// ------------------------------------ END OF EDITABLE DEFAULTS -------------------------------- //


  Decimal$1,
  external = true,

  decimalError = '[DecimalError] ',
  invalidArgument = decimalError + 'Invalid argument: ',
  exponentOutOfRange = decimalError + 'Exponent out of range: ',

  mathfloor = Math.floor,
  mathpow = Math.pow,

  isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,

  ONE,
  BASE = 1e7,
  LOG_BASE = 7,
  MAX_SAFE_INTEGER$3 = 9007199254740991,
  MAX_E = mathfloor(MAX_SAFE_INTEGER$3 / LOG_BASE),    // 1286742750677284

  // Decimal.prototype object
  P$1 = {};


// Decimal prototype methods


/*
 *  absoluteValue                       abs
 *  comparedTo                          cmp
 *  decimalPlaces                       dp
 *  dividedBy                           div
 *  dividedToIntegerBy                  idiv
 *  equals                              eq
 *  exponent
 *  greaterThan                         gt
 *  greaterThanOrEqualTo                gte
 *  isInteger                           isint
 *  isNegative                          isneg
 *  isPositive                          ispos
 *  isZero
 *  lessThan                            lt
 *  lessThanOrEqualTo                   lte
 *  logarithm                           log
 *  minus                               sub
 *  modulo                              mod
 *  naturalExponential                  exp
 *  naturalLogarithm                    ln
 *  negated                             neg
 *  plus                                add
 *  precision                           sd
 *  squareRoot                          sqrt
 *  times                               mul
 *  toDecimalPlaces                     todp
 *  toExponential
 *  toFixed
 *  toInteger                           toint
 *  toNumber
 *  toPower                             pow
 *  toPrecision
 *  toSignificantDigits                 tosd
 *  toString
 *  valueOf                             val
 */


/*
 * Return a new Decimal whose value is the absolute value of this Decimal.
 *
 */
P$1.absoluteValue = P$1.abs = function () {
  var x = new this.constructor(this);
  if (x.s) x.s = 1;
  return x;
};


/*
 * Return
 *   1    if the value of this Decimal is greater than the value of `y`,
 *  -1    if the value of this Decimal is less than the value of `y`,
 *   0    if they have the same value
 *
 */
P$1.comparedTo = P$1.cmp = function (y) {
  var i, j, xdL, ydL,
    x = this;

  y = new x.constructor(y);

  // Signs differ?
  if (x.s !== y.s) return x.s || -y.s;

  // Compare exponents.
  if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;

  xdL = x.d.length;
  ydL = y.d.length;

  // Compare digit by digit.
  for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
    if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
  }

  // Compare lengths.
  return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
};


/*
 * Return the number of decimal places of the value of this Decimal.
 *
 */
P$1.decimalPlaces = P$1.dp = function () {
  var x = this,
    w = x.d.length - 1,
    dp = (w - x.e) * LOG_BASE;

  // Subtract the number of trailing zeros of the last word.
  w = x.d[w];
  if (w) for (; w % 10 == 0; w /= 10) dp--;

  return dp < 0 ? 0 : dp;
};


/*
 * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
 * `precision` significant digits.
 *
 */
P$1.dividedBy = P$1.div = function (y) {
  return divide(this, new this.constructor(y));
};


/*
 * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
 * by the value of `y`, truncated to `precision` significant digits.
 *
 */
P$1.dividedToIntegerBy = P$1.idiv = function (y) {
  var x = this,
    Ctor = x.constructor;
  return round$1(divide(x, new Ctor(y), 0, 1), Ctor.precision);
};


/*
 * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
 *
 */
P$1.equals = P$1.eq = function (y) {
  return !this.cmp(y);
};


/*
 * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
 *
 */
P$1.exponent = function () {
  return getBase10Exponent(this);
};


/*
 * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
 * false.
 *
 */
P$1.greaterThan = P$1.gt = function (y) {
  return this.cmp(y) > 0;
};


/*
 * Return true if the value of this Decimal is greater than or equal to the value of `y`,
 * otherwise return false.
 *
 */
P$1.greaterThanOrEqualTo = P$1.gte = function (y) {
  return this.cmp(y) >= 0;
};


/*
 * Return true if the value of this Decimal is an integer, otherwise return false.
 *
 */
P$1.isInteger = P$1.isint = function () {
  return this.e > this.d.length - 2;
};


/*
 * Return true if the value of this Decimal is negative, otherwise return false.
 *
 */
P$1.isNegative = P$1.isneg = function () {
  return this.s < 0;
};


/*
 * Return true if the value of this Decimal is positive, otherwise return false.
 *
 */
P$1.isPositive = P$1.ispos = function () {
  return this.s > 0;
};


/*
 * Return true if the value of this Decimal is 0, otherwise return false.
 *
 */
P$1.isZero = function () {
  return this.s === 0;
};


/*
 * Return true if the value of this Decimal is less than `y`, otherwise return false.
 *
 */
P$1.lessThan = P$1.lt = function (y) {
  return this.cmp(y) < 0;
};


/*
 * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
 *
 */
P$1.lessThanOrEqualTo = P$1.lte = function (y) {
  return this.cmp(y) < 1;
};


/*
 * Return the logarithm of the value of this Decimal to the specified base, truncated to
 * `precision` significant digits.
 *
 * If no base is specified, return log[10](x).
 *
 * log[base](x) = ln(x) / ln(base)
 *
 * The maximum error of the result is 1 ulp (unit in the last place).
 *
 * [base] {number|string|Decimal} The base of the logarithm.
 *
 */
P$1.logarithm = P$1.log = function (base) {
  var r,
    x = this,
    Ctor = x.constructor,
    pr = Ctor.precision,
    wpr = pr + 5;

  // Default base is 10.
  if (base === void 0) {
    base = new Ctor(10);
  } else {
    base = new Ctor(base);

    // log[-b](x) = NaN
    // log[0](x)  = NaN
    // log[1](x)  = NaN
    if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
  }

  // log[b](-x) = NaN
  // log[b](0) = -Infinity
  if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

  // log[b](1) = 0
  if (x.eq(ONE)) return new Ctor(0);

  external = false;
  r = divide(ln(x, wpr), ln(base, wpr), wpr);
  external = true;

  return round$1(r, pr);
};


/*
 * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
 * `precision` significant digits.
 *
 */
P$1.minus = P$1.sub = function (y) {
  var x = this;
  y = new x.constructor(y);
  return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
};


/*
 * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
 * `precision` significant digits.
 *
 */
P$1.modulo = P$1.mod = function (y) {
  var q,
    x = this,
    Ctor = x.constructor,
    pr = Ctor.precision;

  y = new Ctor(y);

  // x % 0 = NaN
  if (!y.s) throw Error(decimalError + 'NaN');

  // Return x if x is 0.
  if (!x.s) return round$1(new Ctor(x), pr);

  // Prevent rounding of intermediate calculations.
  external = false;
  q = divide(x, y, 0, 1).times(y);
  external = true;

  return x.minus(q);
};


/*
 * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
 * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
 * significant digits.
 *
 */
P$1.naturalExponential = P$1.exp = function () {
  return exp$1(this);
};


/*
 * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
 * truncated to `precision` significant digits.
 *
 */
P$1.naturalLogarithm = P$1.ln = function () {
  return ln(this);
};


/*
 * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
 * -1.
 *
 */
P$1.negated = P$1.neg = function () {
  var x = new this.constructor(this);
  x.s = -x.s || 0;
  return x;
};


/*
 * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
 * `precision` significant digits.
 *
 */
P$1.plus = P$1.add = function (y) {
  var x = this;
  y = new x.constructor(y);
  return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
};


/*
 * Return the number of significant digits of the value of this Decimal.
 *
 * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
 *
 */
P$1.precision = P$1.sd = function (z) {
  var e, sd, w,
    x = this;

  if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);

  e = getBase10Exponent(x) + 1;
  w = x.d.length - 1;
  sd = w * LOG_BASE + 1;
  w = x.d[w];

  // If non-zero...
  if (w) {

    // Subtract the number of trailing zeros of the last word.
    for (; w % 10 == 0; w /= 10) sd--;

    // Add the number of digits of the first word.
    for (w = x.d[0]; w >= 10; w /= 10) sd++;
  }

  return z && e > sd ? e : sd;
};


/*
 * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
 * significant digits.
 *
 */
P$1.squareRoot = P$1.sqrt = function () {
  var e, n, pr, r, s, t, wpr,
    x = this,
    Ctor = x.constructor;

  // Negative or zero?
  if (x.s < 1) {
    if (!x.s) return new Ctor(0);

    // sqrt(-x) = NaN
    throw Error(decimalError + 'NaN');
  }

  e = getBase10Exponent(x);
  external = false;

  // Initial estimate.
  s = Math.sqrt(+x);

  // Math.sqrt underflow/overflow?
  // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
  if (s == 0 || s == 1 / 0) {
    n = digitsToString(x.d);
    if ((n.length + e) % 2 == 0) n += '0';
    s = Math.sqrt(n);
    e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);

    if (s == 1 / 0) {
      n = '5e' + e;
    } else {
      n = s.toExponential();
      n = n.slice(0, n.indexOf('e') + 1) + e;
    }

    r = new Ctor(n);
  } else {
    r = new Ctor(s.toString());
  }

  pr = Ctor.precision;
  s = wpr = pr + 3;

  // Newton-Raphson iteration.
  for (;;) {
    t = r;
    r = t.plus(divide(x, t, wpr + 2)).times(0.5);

    if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
      n = n.slice(wpr - 3, wpr + 1);

      // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
      // 4999, i.e. approaching a rounding boundary, continue the iteration.
      if (s == wpr && n == '4999') {

        // On the first iteration only, check to see if rounding up gives the exact result as the
        // nines may infinitely repeat.
        round$1(t, pr + 1, 0);

        if (t.times(t).eq(x)) {
          r = t;
          break;
        }
      } else if (n != '9999') {
        break;
      }

      wpr += 4;
    }
  }

  external = true;

  return round$1(r, pr);
};


/*
 * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
 * `precision` significant digits.
 *
 */
P$1.times = P$1.mul = function (y) {
  var carry, e, i, k, r, rL, t, xdL, ydL,
    x = this,
    Ctor = x.constructor,
    xd = x.d,
    yd = (y = new Ctor(y)).d;

  // Return 0 if either is 0.
  if (!x.s || !y.s) return new Ctor(0);

  y.s *= x.s;
  e = x.e + y.e;
  xdL = xd.length;
  ydL = yd.length;

  // Ensure xd points to the longer array.
  if (xdL < ydL) {
    r = xd;
    xd = yd;
    yd = r;
    rL = xdL;
    xdL = ydL;
    ydL = rL;
  }

  // Initialise the result array with zeros.
  r = [];
  rL = xdL + ydL;
  for (i = rL; i--;) r.push(0);

  // Multiply!
  for (i = ydL; --i >= 0;) {
    carry = 0;
    for (k = xdL + i; k > i;) {
      t = r[k] + yd[i] * xd[k - i - 1] + carry;
      r[k--] = t % BASE | 0;
      carry = t / BASE | 0;
    }

    r[k] = (r[k] + carry) % BASE | 0;
  }

  // Remove trailing zeros.
  for (; !r[--rL];) r.pop();

  if (carry) ++e;
  else r.shift();

  y.d = r;
  y.e = e;

  return external ? round$1(y, Ctor.precision) : y;
};


/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
 * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
 *
 * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P$1.toDecimalPlaces = P$1.todp = function (dp, rm) {
  var x = this,
    Ctor = x.constructor;

  x = new Ctor(x);
  if (dp === void 0) return x;

  checkInt32(dp, 0, MAX_DIGITS);

  if (rm === void 0) rm = Ctor.rounding;
  else checkInt32(rm, 0, 8);

  return round$1(x, dp + getBase10Exponent(x) + 1, rm);
};


/*
 * Return a string representing the value of this Decimal in exponential notation rounded to
 * `dp` fixed decimal places using rounding mode `rounding`.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P$1.toExponential = function (dp, rm) {
  var str,
    x = this,
    Ctor = x.constructor;

  if (dp === void 0) {
    str = toString$a(x, true);
  } else {
    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    x = round$1(new Ctor(x), dp + 1, rm);
    str = toString$a(x, true, dp + 1);
  }

  return str;
};


/*
 * Return a string representing the value of this Decimal in normal (fixed-point) notation to
 * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
 * omitted.
 *
 * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
 * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
 * (-0).toFixed(3) is '0.000'.
 * (-0.5).toFixed(0) is '-0'.
 *
 */
P$1.toFixed = function (dp, rm) {
  var str, y,
    x = this,
    Ctor = x.constructor;

  if (dp === void 0) return toString$a(x);

  checkInt32(dp, 0, MAX_DIGITS);

  if (rm === void 0) rm = Ctor.rounding;
  else checkInt32(rm, 0, 8);

  y = round$1(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
  str = toString$a(y.abs(), false, dp + getBase10Exponent(y) + 1);

  // To determine whether to add the minus sign look at the value before it was rounded,
  // i.e. look at `x` rather than `y`.
  return x.isneg() && !x.isZero() ? '-' + str : str;
};


/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
 * rounding mode `rounding`.
 *
 */
P$1.toInteger = P$1.toint = function () {
  var x = this,
    Ctor = x.constructor;
  return round$1(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
};


/*
 * Return the value of this Decimal converted to a number primitive.
 *
 */
P$1.toNumber = function () {
  return +this;
};


/*
 * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
 * truncated to `precision` significant digits.
 *
 * For non-integer or very large exponents pow(x, y) is calculated using
 *
 *   x^y = exp(y*ln(x))
 *
 * The maximum error is 1 ulp (unit in last place).
 *
 * y {number|string|Decimal} The power to which to raise this Decimal.
 *
 */
P$1.toPower = P$1.pow = function (y) {
  var e, k, pr, r, sign, yIsInt,
    x = this,
    Ctor = x.constructor,
    guard = 12,
    yn = +(y = new Ctor(y));

  // pow(x, 0) = 1
  if (!y.s) return new Ctor(ONE);

  x = new Ctor(x);

  // pow(0, y > 0) = 0
  // pow(0, y < 0) = Infinity
  if (!x.s) {
    if (y.s < 1) throw Error(decimalError + 'Infinity');
    return x;
  }

  // pow(1, y) = 1
  if (x.eq(ONE)) return x;

  pr = Ctor.precision;

  // pow(x, 1) = x
  if (y.eq(ONE)) return round$1(x, pr);

  e = y.e;
  k = y.d.length - 1;
  yIsInt = e >= k;
  sign = x.s;

  if (!yIsInt) {

    // pow(x < 0, y non-integer) = NaN
    if (sign < 0) throw Error(decimalError + 'NaN');

  // If y is a small integer use the 'exponentiation by squaring' algorithm.
  } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER$3) {
    r = new Ctor(ONE);

    // Max k of 9007199254740991 takes 53 loop iterations.
    // Maximum digits array length; leaves [28, 34] guard digits.
    e = Math.ceil(pr / LOG_BASE + 4);

    external = false;

    for (;;) {
      if (k % 2) {
        r = r.times(x);
        truncate(r.d, e);
      }

      k = mathfloor(k / 2);
      if (k === 0) break;

      x = x.times(x);
      truncate(x.d, e);
    }

    external = true;

    return y.s < 0 ? new Ctor(ONE).div(r) : round$1(r, pr);
  }

  // Result is negative if x is negative and the last digit of integer y is odd.
  sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;

  x.s = 1;
  external = false;
  r = y.times(ln(x, pr + guard));
  external = true;
  r = exp$1(r);
  r.s = sign;

  return r;
};


/*
 * Return a string representing the value of this Decimal rounded to `sd` significant digits
 * using rounding mode `rounding`.
 *
 * Return exponential notation if `sd` is less than the number of digits necessary to represent
 * the integer part of the value in normal notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P$1.toPrecision = function (sd, rm) {
  var e, str,
    x = this,
    Ctor = x.constructor;

  if (sd === void 0) {
    e = getBase10Exponent(x);
    str = toString$a(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
  } else {
    checkInt32(sd, 1, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    x = round$1(new Ctor(x), sd, rm);
    e = getBase10Exponent(x);
    str = toString$a(x, sd <= e || e <= Ctor.toExpNeg, sd);
  }

  return str;
};


/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
 * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
 * omitted.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */
P$1.toSignificantDigits = P$1.tosd = function (sd, rm) {
  var x = this,
    Ctor = x.constructor;

  if (sd === void 0) {
    sd = Ctor.precision;
    rm = Ctor.rounding;
  } else {
    checkInt32(sd, 1, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);
  }

  return round$1(new Ctor(x), sd, rm);
};


/*
 * Return a string representing the value of this Decimal.
 *
 * Return exponential notation if this Decimal has a positive exponent equal to or greater than
 * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
 *
 */
P$1.toString = P$1.valueOf = P$1.val = P$1.toJSON = P$1[Symbol.for('nodejs.util.inspect.custom')] = function () {
  var x = this,
    e = getBase10Exponent(x),
    Ctor = x.constructor;

  return toString$a(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
};


// Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.


/*
 *  add                 P.minus, P.plus
 *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
 *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
 *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
 *  exp                 P.exp, P.pow
 *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
 *                      P.toString, divide, round, toString, exp, ln
 *  getLn10             P.log, ln
 *  getZeroString       digitsToString, toString
 *  ln                  P.log, P.ln, P.pow, exp
 *  parseDecimal        Decimal
 *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
 *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
 *                      divide, getLn10, exp, ln
 *  subtract            P.minus, P.plus
 *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
 *  truncate            P.pow
 *
 *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
 *                      getLn10, exp, ln, parseDecimal, Decimal, config
 */


function add(x, y) {
  var carry, d, e, i, k, len, xd, yd,
    Ctor = x.constructor,
    pr = Ctor.precision;

  // If either is zero...
  if (!x.s || !y.s) {

    // Return x if y is zero.
    // Return y if y is non-zero.
    if (!y.s) y = new Ctor(x);
    return external ? round$1(y, pr) : y;
  }

  xd = x.d;
  yd = y.d;

  // x and y are finite, non-zero numbers with the same sign.

  k = x.e;
  e = y.e;
  xd = xd.slice();
  i = k - e;

  // If base 1e7 exponents differ...
  if (i) {
    if (i < 0) {
      d = xd;
      i = -i;
      len = yd.length;
    } else {
      d = yd;
      e = k;
      len = xd.length;
    }

    // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
    k = Math.ceil(pr / LOG_BASE);
    len = k > len ? k + 1 : len + 1;

    if (i > len) {
      i = len;
      d.length = 1;
    }

    // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
    d.reverse();
    for (; i--;) d.push(0);
    d.reverse();
  }

  len = xd.length;
  i = yd.length;

  // If yd is longer than xd, swap xd and yd so xd points to the longer array.
  if (len - i < 0) {
    i = len;
    d = yd;
    yd = xd;
    xd = d;
  }

  // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
  for (carry = 0; i;) {
    carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
    xd[i] %= BASE;
  }

  if (carry) {
    xd.unshift(carry);
    ++e;
  }

  // Remove trailing zeros.
  // No need to check for zero, as +x + +y != 0 && -x + -y != 0
  for (len = xd.length; xd[--len] == 0;) xd.pop();

  y.d = xd;
  y.e = e;

  return external ? round$1(y, pr) : y;
}


function checkInt32(i, min, max) {
  if (i !== ~~i || i < min || i > max) {
    throw Error(invalidArgument + i);
  }
}


function digitsToString(d) {
  var i, k, ws,
    indexOfLastWord = d.length - 1,
    str = '',
    w = d[0];

  if (indexOfLastWord > 0) {
    str += w;
    for (i = 1; i < indexOfLastWord; i++) {
      ws = d[i] + '';
      k = LOG_BASE - ws.length;
      if (k) str += getZeroString(k);
      str += ws;
    }

    w = d[i];
    ws = w + '';
    k = LOG_BASE - ws.length;
    if (k) str += getZeroString(k);
  } else if (w === 0) {
    return '0';
  }

  // Remove trailing zeros of last w.
  for (; w % 10 === 0;) w /= 10;

  return str + w;
}


var divide = (function () {

  // Assumes non-zero x and k, and hence non-zero result.
  function multiplyInteger(x, k) {
    var temp,
      carry = 0,
      i = x.length;

    for (x = x.slice(); i--;) {
      temp = x[i] * k + carry;
      x[i] = temp % BASE | 0;
      carry = temp / BASE | 0;
    }

    if (carry) x.unshift(carry);

    return x;
  }

  function compare(a, b, aL, bL) {
    var i, r;

    if (aL != bL) {
      r = aL > bL ? 1 : -1;
    } else {
      for (i = r = 0; i < aL; i++) {
        if (a[i] != b[i]) {
          r = a[i] > b[i] ? 1 : -1;
          break;
        }
      }
    }

    return r;
  }

  function subtract(a, b, aL) {
    var i = 0;

    // Subtract b from a.
    for (; aL--;) {
      a[aL] -= i;
      i = a[aL] < b[aL] ? 1 : 0;
      a[aL] = i * BASE + a[aL] - b[aL];
    }

    // Remove leading zeros.
    for (; !a[0] && a.length > 1;) a.shift();
  }

  return function (x, y, pr, dp) {
    var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz,
      Ctor = x.constructor,
      sign = x.s == y.s ? 1 : -1,
      xd = x.d,
      yd = y.d;

    // Either 0?
    if (!x.s) return new Ctor(x);
    if (!y.s) throw Error(decimalError + 'Division by zero');

    e = x.e - y.e;
    yL = yd.length;
    xL = xd.length;
    q = new Ctor(sign);
    qd = q.d = [];

    // Result exponent may be one less than e.
    for (i = 0; yd[i] == (xd[i] || 0); ) ++i;
    if (yd[i] > (xd[i] || 0)) --e;

    if (pr == null) {
      sd = pr = Ctor.precision;
    } else if (dp) {
      sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
    } else {
      sd = pr;
    }

    if (sd < 0) return new Ctor(0);

    // Convert precision in number of base 10 digits to base 1e7 digits.
    sd = sd / LOG_BASE + 2 | 0;
    i = 0;

    // divisor < 1e7
    if (yL == 1) {
      k = 0;
      yd = yd[0];
      sd++;

      // k is the carry.
      for (; (i < xL || k) && sd--; i++) {
        t = k * BASE + (xd[i] || 0);
        qd[i] = t / yd | 0;
        k = t % yd | 0;
      }

    // divisor >= 1e7
    } else {

      // Normalise xd and yd so highest order digit of yd is >= BASE/2
      k = BASE / (yd[0] + 1) | 0;

      if (k > 1) {
        yd = multiplyInteger(yd, k);
        xd = multiplyInteger(xd, k);
        yL = yd.length;
        xL = xd.length;
      }

      xi = yL;
      rem = xd.slice(0, yL);
      remL = rem.length;

      // Add zeros to make remainder as long as divisor.
      for (; remL < yL;) rem[remL++] = 0;

      yz = yd.slice();
      yz.unshift(0);
      yd0 = yd[0];

      if (yd[1] >= BASE / 2) ++yd0;

      do {
        k = 0;

        // Compare divisor and remainder.
        cmp = compare(yd, rem, yL, remL);

        // If divisor < remainder.
        if (cmp < 0) {

          // Calculate trial digit, k.
          rem0 = rem[0];
          if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);

          // k will be how many times the divisor goes into the current remainder.
          k = rem0 / yd0 | 0;

          //  Algorithm:
          //  1. product = divisor * trial digit (k)
          //  2. if product > remainder: product -= divisor, k--
          //  3. remainder -= product
          //  4. if product was < remainder at 2:
          //    5. compare new remainder and divisor
          //    6. If remainder > divisor: remainder -= divisor, k++

          if (k > 1) {
            if (k >= BASE) k = BASE - 1;

            // product = divisor * trial digit.
            prod = multiplyInteger(yd, k);
            prodL = prod.length;
            remL = rem.length;

            // Compare product and remainder.
            cmp = compare(prod, rem, prodL, remL);

            // product > remainder.
            if (cmp == 1) {
              k--;

              // Subtract divisor from product.
              subtract(prod, yL < prodL ? yz : yd, prodL);
            }
          } else {

            // cmp is -1.
            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
            if (k == 0) cmp = k = 1;
            prod = yd.slice();
          }

          prodL = prod.length;
          if (prodL < remL) prod.unshift(0);

          // Subtract product from remainder.
          subtract(rem, prod, remL);

          // If product was < previous remainder.
          if (cmp == -1) {
            remL = rem.length;

            // Compare divisor and new remainder.
            cmp = compare(yd, rem, yL, remL);

            // If divisor < new remainder, subtract divisor from remainder.
            if (cmp < 1) {
              k++;

              // Subtract divisor from remainder.
              subtract(rem, yL < remL ? yz : yd, remL);
            }
          }

          remL = rem.length;
        } else if (cmp === 0) {
          k++;
          rem = [0];
        }    // if cmp === 1, k will be 0

        // Add the next digit, k, to the result array.
        qd[i++] = k;

        // Update the remainder.
        if (cmp && rem[0]) {
          rem[remL++] = xd[xi] || 0;
        } else {
          rem = [xd[xi]];
          remL = 1;
        }

      } while ((xi++ < xL || rem[0] !== void 0) && sd--);
    }

    // Leading zero?
    if (!qd[0]) qd.shift();

    q.e = e;

    return round$1(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
  };
})();


/*
 * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
 * significant digits.
 *
 * Taylor/Maclaurin series.
 *
 * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
 *
 * Argument reduction:
 *   Repeat x = x / 32, k += 5, until |x| < 0.1
 *   exp(x) = exp(x / 2^k)^(2^k)
 *
 * Previously, the argument was initially reduced by
 * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
 * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
 * found to be slower than just dividing repeatedly by 32 as above.
 *
 * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
 *
 *  exp(x) is non-terminating for any finite, non-zero x.
 *
 */
function exp$1(x, sd) {
  var denominator, guard, pow, sum, t, wpr,
    i = 0,
    k = 0,
    Ctor = x.constructor,
    pr = Ctor.precision;

  if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));

  // exp(0) = 1
  if (!x.s) return new Ctor(ONE);

  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }

  t = new Ctor(0.03125);

  while (x.abs().gte(0.1)) {
    x = x.times(t);    // x = x / 2^5
    k += 5;
  }

  // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
  guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
  wpr += guard;
  denominator = pow = sum = new Ctor(ONE);
  Ctor.precision = wpr;

  for (;;) {
    pow = round$1(pow.times(x), wpr);
    denominator = denominator.times(++i);
    t = sum.plus(divide(pow, denominator, wpr));

    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
      while (k--) sum = round$1(sum.times(sum), wpr);
      Ctor.precision = pr;
      return sd == null ? (external = true, round$1(sum, pr)) : sum;
    }

    sum = t;
  }
}


// Calculate the base 10 exponent from the base 1e7 exponent.
function getBase10Exponent(x) {
  var e = x.e * LOG_BASE,
    w = x.d[0];

  // Add the number of digits of the first word of the digits array.
  for (; w >= 10; w /= 10) e++;
  return e;
}


function getLn10(Ctor, sd, pr) {

  if (sd > Ctor.LN10.sd()) {


    // Reset global state in case the exception is caught.
    external = true;
    if (pr) Ctor.precision = pr;
    throw Error(decimalError + 'LN10 precision limit exceeded');
  }

  return round$1(new Ctor(Ctor.LN10), sd);
}


function getZeroString(k) {
  var zs = '';
  for (; k--;) zs += '0';
  return zs;
}


/*
 * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
 * digits.
 *
 *  ln(n) is non-terminating (n != 1)
 *
 */
function ln(y, sd) {
  var c, c0, denominator, e, numerator, sum, t, wpr, x2,
    n = 1,
    guard = 10,
    x = y,
    xd = x.d,
    Ctor = x.constructor,
    pr = Ctor.precision;

  // ln(-x) = NaN
  // ln(0) = -Infinity
  if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

  // ln(1) = 0
  if (x.eq(ONE)) return new Ctor(0);

  if (sd == null) {
    external = false;
    wpr = pr;
  } else {
    wpr = sd;
  }

  if (x.eq(10)) {
    if (sd == null) external = true;
    return getLn10(Ctor, wpr);
  }

  wpr += guard;
  Ctor.precision = wpr;
  c = digitsToString(xd);
  c0 = c.charAt(0);
  e = getBase10Exponent(x);

  if (Math.abs(e) < 1.5e15) {

    // Argument reduction.
    // The series converges faster the closer the argument is to 1, so using
    // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
    // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
    // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
    // later be divided by this number, then separate out the power of 10 using
    // ln(a*10^b) = ln(a) + b*ln(10).

    // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
    //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
    // max n is 6 (gives 0.7 - 1.3)
    while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
      x = x.times(y);
      c = digitsToString(x.d);
      c0 = c.charAt(0);
      n++;
    }

    e = getBase10Exponent(x);

    if (c0 > 1) {
      x = new Ctor('0.' + c);
      e++;
    } else {
      x = new Ctor(c0 + '.' + c.slice(1));
    }
  } else {

    // The argument reduction method above may result in overflow if the argument y is a massive
    // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
    // function using ln(x*10^e) = ln(x) + e*ln(10).
    t = getLn10(Ctor, wpr + 2, pr).times(e + '');
    x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);

    Ctor.precision = pr;
    return sd == null ? (external = true, round$1(x, pr)) : x;
  }

  // x is reduced to a value near 1.

  // Taylor series.
  // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
  // where x = (y - 1)/(y + 1)    (|x| < 1)
  sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
  x2 = round$1(x.times(x), wpr);
  denominator = 3;

  for (;;) {
    numerator = round$1(numerator.times(x2), wpr);
    t = sum.plus(divide(numerator, new Ctor(denominator), wpr));

    if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
      sum = sum.times(2);

      // Reverse the argument reduction.
      if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
      sum = divide(sum, new Ctor(n), wpr);

      Ctor.precision = pr;
      return sd == null ? (external = true, round$1(sum, pr)) : sum;
    }

    sum = t;
    denominator += 2;
  }
}


/*
 * Parse the value of a new Decimal `x` from string `str`.
 */
function parseDecimal(x, str) {
  var e, i, len;

  // Decimal point?
  if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

  // Exponential form?
  if ((i = str.search(/e/i)) > 0) {

    // Determine exponent.
    if (e < 0) e = i;
    e += +str.slice(i + 1);
    str = str.substring(0, i);
  } else if (e < 0) {

    // Integer.
    e = str.length;
  }

  // Determine leading zeros.
  for (i = 0; str.charCodeAt(i) === 48;) ++i;

  // Determine trailing zeros.
  for (len = str.length; str.charCodeAt(len - 1) === 48;) --len;
  str = str.slice(i, len);

  if (str) {
    len -= i;
    e = e - i - 1;
    x.e = mathfloor(e / LOG_BASE);
    x.d = [];

    // Transform base

    // e is the base 10 exponent.
    // i is where to slice str to get the first word of the digits array.
    i = (e + 1) % LOG_BASE;
    if (e < 0) i += LOG_BASE;

    if (i < len) {
      if (i) x.d.push(+str.slice(0, i));
      for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
      str = str.slice(i);
      i = LOG_BASE - str.length;
    } else {
      i -= len;
    }

    for (; i--;) str += '0';
    x.d.push(+str);

    if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
  } else {

    // Zero.
    x.s = 0;
    x.e = 0;
    x.d = [0];
  }

  return x;
}


/*
 * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
 */
 function round$1(x, sd, rm) {
  var i, j, k, n, rd, doRound, w, xdi,
    xd = x.d;

  // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
  // w: the word of xd which contains the rounding digit, a base 1e7 number.
  // xdi: the index of w within xd.
  // n: the number of digits of w.
  // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
  // they had leading zeros)
  // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).

  // Get the length of the first word of the digits array xd.
  for (n = 1, k = xd[0]; k >= 10; k /= 10) n++;
  i = sd - n;

  // Is the rounding digit in the first word of xd?
  if (i < 0) {
    i += LOG_BASE;
    j = sd;
    w = xd[xdi = 0];
  } else {
    xdi = Math.ceil((i + 1) / LOG_BASE);
    k = xd.length;
    if (xdi >= k) return x;
    w = k = xd[xdi];

    // Get the number of digits of w.
    for (n = 1; k >= 10; k /= 10) n++;

    // Get the index of rd within w.
    i %= LOG_BASE;

    // Get the index of rd within w, adjusted for leading zeros.
    // The number of leading zeros of w is given by LOG_BASE - n.
    j = i - LOG_BASE + n;
  }

  if (rm !== void 0) {
    k = mathpow(10, n - j - 1);

    // Get the rounding digit at index j of w.
    rd = w / k % 10 | 0;

    // Are there any non-zero digits after the rounding digit?
    doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;

    // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
    // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
    // 714.

    doRound = rm < 4
      ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
      : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 &&

        // Check whether the digit to the left of the rounding digit is odd.
        ((i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
          rm == (x.s < 0 ? 8 : 7));
  }

  if (sd < 1 || !xd[0]) {
    if (doRound) {
      k = getBase10Exponent(x);
      xd.length = 1;

      // Convert sd to decimal places.
      sd = sd - k - 1;

      // 1, 0.1, 0.01, 0.001, 0.0001 etc.
      xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
      x.e = mathfloor(-sd / LOG_BASE) || 0;
    } else {
      xd.length = 1;

      // Zero.
      xd[0] = x.e = x.s = 0;
    }

    return x;
  }

  // Remove excess digits.
  if (i == 0) {
    xd.length = xdi;
    k = 1;
    xdi--;
  } else {
    xd.length = xdi + 1;
    k = mathpow(10, LOG_BASE - i);

    // E.g. 56700 becomes 56000 if 7 is the rounding digit.
    // j > 0 means i > number of leading zeros of w.
    xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
  }

  if (doRound) {
    for (;;) {

      // Is the digit to be rounded up in the first word of xd?
      if (xdi == 0) {
        if ((xd[0] += k) == BASE) {
          xd[0] = 1;
          ++x.e;
        }

        break;
      } else {
        xd[xdi] += k;
        if (xd[xdi] != BASE) break;
        xd[xdi--] = 0;
        k = 1;
      }
    }
  }

  // Remove trailing zeros.
  for (i = xd.length; xd[--i] === 0;) xd.pop();

  if (external && (x.e > MAX_E || x.e < -MAX_E)) {
    throw Error(exponentOutOfRange + getBase10Exponent(x));
  }

  return x;
}


function subtract(x, y) {
  var d, e, i, j, k, len, xd, xe, xLTy, yd,
    Ctor = x.constructor,
    pr = Ctor.precision;

  // Return y negated if x is zero.
  // Return x if y is zero and x is non-zero.
  if (!x.s || !y.s) {
    if (y.s) y.s = -y.s;
    else y = new Ctor(x);
    return external ? round$1(y, pr) : y;
  }

  xd = x.d;
  yd = y.d;

  // x and y are non-zero numbers with the same sign.

  e = y.e;
  xe = x.e;
  xd = xd.slice();
  k = xe - e;

  // If exponents differ...
  if (k) {
    xLTy = k < 0;

    if (xLTy) {
      d = xd;
      k = -k;
      len = yd.length;
    } else {
      d = yd;
      e = xe;
      len = xd.length;
    }

    // Numbers with massively different exponents would result in a very high number of zeros
    // needing to be prepended, but this can be avoided while still ensuring correct rounding by
    // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
    i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;

    if (k > i) {
      k = i;
      d.length = 1;
    }

    // Prepend zeros to equalise exponents.
    d.reverse();
    for (i = k; i--;) d.push(0);
    d.reverse();

  // Base 1e7 exponents equal.
  } else {

    // Check digits to determine which is the bigger number.

    i = xd.length;
    len = yd.length;
    xLTy = i < len;
    if (xLTy) len = i;

    for (i = 0; i < len; i++) {
      if (xd[i] != yd[i]) {
        xLTy = xd[i] < yd[i];
        break;
      }
    }

    k = 0;
  }

  if (xLTy) {
    d = xd;
    xd = yd;
    yd = d;
    y.s = -y.s;
  }

  len = xd.length;

  // Append zeros to xd if shorter.
  // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
  for (i = yd.length - len; i > 0; --i) xd[len++] = 0;

  // Subtract yd from xd.
  for (i = yd.length; i > k;) {
    if (xd[--i] < yd[i]) {
      for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
      --xd[j];
      xd[i] += BASE;
    }

    xd[i] -= yd[i];
  }

  // Remove trailing zeros.
  for (; xd[--len] === 0;) xd.pop();

  // Remove leading zeros and adjust exponent accordingly.
  for (; xd[0] === 0; xd.shift()) --e;

  // Zero?
  if (!xd[0]) return new Ctor(0);

  y.d = xd;
  y.e = e;

  //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
  return external ? round$1(y, pr) : y;
}


function toString$a(x, isExp, sd) {
  var k,
    e = getBase10Exponent(x),
    str = digitsToString(x.d),
    len = str.length;

  if (isExp) {
    if (sd && (k = sd - len) > 0) {
      str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
    } else if (len > 1) {
      str = str.charAt(0) + '.' + str.slice(1);
    }

    str = str + (e < 0 ? 'e' : 'e+') + e;
  } else if (e < 0) {
    str = '0.' + getZeroString(-e - 1) + str;
    if (sd && (k = sd - len) > 0) str += getZeroString(k);
  } else if (e >= len) {
    str += getZeroString(e + 1 - len);
    if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
  } else {
    if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
    if (sd && (k = sd - len) > 0) {
      if (e + 1 === len) str += '.';
      str += getZeroString(k);
    }
  }

  return x.s < 0 ? '-' + str : str;
}


// Does not strip trailing zeros.
function truncate(arr, len) {
  if (arr.length > len) {
    arr.length = len;
    return true;
  }
}


// Decimal methods


/*
 *  clone
 *  config/set
 */


/*
 * Create and return a Decimal constructor with the same configuration properties as this Decimal
 * constructor.
 *
 */
function clone(obj) {
  var i, p, ps;

  /*
   * The Decimal constructor and exported function.
   * Return a new Decimal instance.
   *
   * value {number|string|Decimal} A numeric value.
   *
   */
  function Decimal(value) {
    var x = this;

    // Decimal called without new.
    if (!(x instanceof Decimal)) return new Decimal(value);

    // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
    // which points to Object.
    x.constructor = Decimal;

    // Duplicate.
    if (value instanceof Decimal) {
      x.s = value.s;
      x.e = value.e;
      x.d = (value = value.d) ? value.slice() : value;
      return;
    }

    if (typeof value === 'number') {

      // Reject Infinity/NaN.
      if (value * 0 !== 0) {
        throw Error(invalidArgument + value);
      }

      if (value > 0) {
        x.s = 1;
      } else if (value < 0) {
        value = -value;
        x.s = -1;
      } else {
        x.s = 0;
        x.e = 0;
        x.d = [0];
        return;
      }

      // Fast path for small integers.
      if (value === ~~value && value < 1e7) {
        x.e = 0;
        x.d = [value];
        return;
      }

      return parseDecimal(x, value.toString());
    } else if (typeof value !== 'string') {
      throw Error(invalidArgument + value);
    }

    // Minus sign?
    if (value.charCodeAt(0) === 45) {
      value = value.slice(1);
      x.s = -1;
    } else {
      x.s = 1;
    }

    if (isDecimal.test(value)) parseDecimal(x, value);
    else throw Error(invalidArgument + value);
  }

  Decimal.prototype = P$1;

  Decimal.ROUND_UP = 0;
  Decimal.ROUND_DOWN = 1;
  Decimal.ROUND_CEIL = 2;
  Decimal.ROUND_FLOOR = 3;
  Decimal.ROUND_HALF_UP = 4;
  Decimal.ROUND_HALF_DOWN = 5;
  Decimal.ROUND_HALF_EVEN = 6;
  Decimal.ROUND_HALF_CEIL = 7;
  Decimal.ROUND_HALF_FLOOR = 8;

  Decimal.clone = clone;
  Decimal.config = Decimal.set = config;

  if (obj === void 0) obj = {};
  if (obj) {
    ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'LN10'];
    for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
  }

  Decimal.config(obj);

  return Decimal;
}


/*
 * Configure global settings for a Decimal constructor.
 *
 * `obj` is an object with one or more of the following properties,
 *
 *   precision  {number}
 *   rounding   {number}
 *   toExpNeg   {number}
 *   toExpPos   {number}
 *
 * E.g. Decimal.config({ precision: 20, rounding: 4 })
 *
 */
function config(obj) {
  if (!obj || typeof obj !== 'object') {
    throw Error(decimalError + 'Object expected');
  }
  var i, p, v,
    ps = [
      'precision', 1, MAX_DIGITS,
      'rounding', 0, 8,
      'toExpNeg', -1 / 0, 0,
      'toExpPos', 0, 1 / 0
    ];

  for (i = 0; i < ps.length; i += 3) {
    if ((v = obj[p = ps[i]]) !== void 0) {
      if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
      else throw Error(invalidArgument + p + ': ' + v);
    }
  }

  if ((v = obj[p = 'LN10']) !== void 0) {
      if (v == Math.LN10) this[p] = new this(v);
      else throw Error(invalidArgument + p + ': ' + v);
  }

  return this;
}


// Create and configure initial Decimal constructor.
var Decimal$1 = clone(defaults$4);

// Internal constant.
ONE = new Decimal$1(1);

var Decimal$2 = Decimal$1;

/*
 *  big.js v5.2.2
 *  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
 *  Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
 *  https://github.com/MikeMcl/big.js/LICENCE
 */


/************************************** EDITABLE DEFAULTS *****************************************/


  // The default values below must be integers within the stated ranges.

  /*
   * The maximum number of decimal places (DP) of the results of operations involving division:
   * div and sqrt, and pow with negative exponents.
   */
var DP = 20,          // 0 to MAX_DP

  /*
   * The rounding mode (RM) used when rounding to the above decimal places.
   *
   *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
   *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
   *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
   *  3  Away from zero.                                  (ROUND_UP)
   */
  RM = 1,             // 0, 1, 2 or 3

  // The maximum value of DP and Big.DP.
  MAX_DP = 1E6,       // 0 to 1000000

  // The maximum magnitude of the exponent argument to the pow method.
  MAX_POWER = 1E6,    // 1 to 1000000

  /*
   * The negative exponent (NE) at and beneath which toString returns exponential notation.
   * (JavaScript numbers: -7)
   * -1000000 is the minimum recommended exponent value of a Big.
   */
  NE = -7,            // 0 to -1000000

  /*
   * The positive exponent (PE) at and above which toString returns exponential notation.
   * (JavaScript numbers: 21)
   * 1000000 is the maximum recommended exponent value of a Big.
   * (This limit is not enforced or checked.)
   */
  PE = 21,            // 0 to 1000000


/**************************************************************************************************/


  // Error messages.
  NAME = '[big.js] ',
  INVALID = NAME + 'Invalid ',
  INVALID_DP = INVALID + 'decimal places',
  INVALID_RM = INVALID + 'rounding mode',
  DIV_BY_ZERO = NAME + 'Division by zero',

  // The shared prototype object.
  P = {},
  UNDEFINED = void 0,
  NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;


/*
 * Create and return a Big constructor.
 *
 */
function _Big_() {

  /*
   * The Big constructor and exported function.
   * Create and return a new instance of a Big number object.
   *
   * n {number|string|Big} A numeric value.
   */
  function Big(n) {
    var x = this;

    // Enable constructor usage without new.
    if (!(x instanceof Big)) return n === UNDEFINED ? _Big_() : new Big(n);

    // Duplicate.
    if (n instanceof Big) {
      x.s = n.s;
      x.e = n.e;
      x.c = n.c.slice();
    } else {
      parse$5(x, n);
    }

    /*
     * Retain a reference to this Big constructor, and shadow Big.prototype.constructor which
     * points to Object.
     */
    x.constructor = Big;
  }

  Big.prototype = P;
  Big.DP = DP;
  Big.RM = RM;
  Big.NE = NE;
  Big.PE = PE;
  Big.version = '5.2.2';

  return Big;
}


/*
 * Parse the number or string value passed to a Big constructor.
 *
 * x {Big} A Big number instance.
 * n {number|string} A numeric value.
 */
function parse$5(x, n) {
  var e, i, nl;

  // Minus zero?
  if (n === 0 && 1 / n < 0) n = '-0';
  else if (!NUMERIC.test(n += '')) throw Error(INVALID + 'number');

  // Determine sign.
  x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;

  // Decimal point?
  if ((e = n.indexOf('.')) > -1) n = n.replace('.', '');

  // Exponential form?
  if ((i = n.search(/e/i)) > 0) {

    // Determine exponent.
    if (e < 0) e = i;
    e += +n.slice(i + 1);
    n = n.substring(0, i);
  } else if (e < 0) {

    // Integer.
    e = n.length;
  }

  nl = n.length;

  // Determine leading zeros.
  for (i = 0; i < nl && n.charAt(i) == '0';) ++i;

  if (i == nl) {

    // Zero.
    x.c = [x.e = 0];
  } else {

    // Determine trailing zeros.
    for (; nl > 0 && n.charAt(--nl) == '0';);
    x.e = e - i - 1;
    x.c = [];

    // Convert string to array of digits without leading/trailing zeros.
    for (e = 0; i <= nl;) x.c[e++] = +n.charAt(i++);
  }

  return x;
}


/*
 * Round Big x to a maximum of dp decimal places using rounding mode rm.
 * Called by stringify, P.div, P.round and P.sqrt.
 *
 * x {Big} The Big to round.
 * dp {number} Integer, 0 to MAX_DP inclusive.
 * rm {number} 0, 1, 2 or 3 (DOWN, HALF_UP, HALF_EVEN, UP)
 * [more] {boolean} Whether the result of division was truncated.
 */
function round(x, dp, rm, more) {
  var xc = x.c,
    i = x.e + dp + 1;

  if (i < xc.length) {
    if (rm === 1) {

      // xc[i] is the digit after the digit that may be rounded up.
      more = xc[i] >= 5;
    } else if (rm === 2) {
      more = xc[i] > 5 || xc[i] == 5 &&
        (more || i < 0 || xc[i + 1] !== UNDEFINED || xc[i - 1] & 1);
    } else if (rm === 3) {
      more = more || !!xc[0];
    } else {
      more = false;
      if (rm !== 0) throw Error(INVALID_RM);
    }

    if (i < 1) {
      xc.length = 1;

      if (more) {

        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
        x.e = -dp;
        xc[0] = 1;
      } else {

        // Zero.
        xc[0] = x.e = 0;
      }
    } else {

      // Remove any digits after the required decimal places.
      xc.length = i--;

      // Round up?
      if (more) {

        // Rounding up may mean the previous digit has to be rounded up.
        for (; ++xc[i] > 9;) {
          xc[i] = 0;
          if (!i--) {
            ++x.e;
            xc.unshift(1);
          }
        }
      }

      // Remove trailing zeros.
      for (i = xc.length; !xc[--i];) xc.pop();
    }
  } else if (rm < 0 || rm > 3 || rm !== ~~rm) {
    throw Error(INVALID_RM);
  }

  return x;
}


/*
 * Return a string representing the value of Big x in normal or exponential notation.
 * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
 *
 * x {Big}
 * id? {number} Caller id.
 *         1 toExponential
 *         2 toFixed
 *         3 toPrecision
 *         4 valueOf
 * n? {number|undefined} Caller's argument.
 * k? {number|undefined}
 */
function stringify$4(x, id, n, k) {
  var e, s,
    Big = x.constructor,
    z = !x.c[0];

  if (n !== UNDEFINED) {
    if (n !== ~~n || n < (id == 3) || n > MAX_DP) {
      throw Error(id == 3 ? INVALID + 'precision' : INVALID_DP);
    }

    x = new Big(x);

    // The index of the digit that may be rounded up.
    n = k - x.e;

    // Round?
    if (x.c.length > ++k) round(x, n, Big.RM);

    // toFixed: recalculate k as x.e may have changed if value rounded up.
    if (id == 2) k = x.e + n + 1;

    // Append zeros?
    for (; x.c.length < k;) x.c.push(0);
  }

  e = x.e;
  s = x.c.join('');
  n = s.length;

  // Exponential notation?
  if (id != 2 && (id == 1 || id == 3 && k <= e || e <= Big.NE || e >= Big.PE)) {
    s = s.charAt(0) + (n > 1 ? '.' + s.slice(1) : '') + (e < 0 ? 'e' : 'e+') + e;

  // Normal notation.
  } else if (e < 0) {
    for (; ++e;) s = '0' + s;
    s = '0.' + s;
  } else if (e > 0) {
    if (++e > n) for (e -= n; e--;) s += '0';
    else if (e < n) s = s.slice(0, e) + '.' + s.slice(e);
  } else if (n > 1) {
    s = s.charAt(0) + '.' + s.slice(1);
  }

  return x.s < 0 && (!z || id == 4) ? '-' + s : s;
}


// Prototype/instance methods


/*
 * Return a new Big whose value is the absolute value of this Big.
 */
P.abs = function () {
  var x = new this.constructor(this);
  x.s = 1;
  return x;
};


/*
 * Return 1 if the value of this Big is greater than the value of Big y,
 *       -1 if the value of this Big is less than the value of Big y, or
 *        0 if they have the same value.
*/
P.cmp = function (y) {
  var isneg,
    x = this,
    xc = x.c,
    yc = (y = new x.constructor(y)).c,
    i = x.s,
    j = y.s,
    k = x.e,
    l = y.e;

  // Either zero?
  if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;

  // Signs differ?
  if (i != j) return i;

  isneg = i < 0;

  // Compare exponents.
  if (k != l) return k > l ^ isneg ? 1 : -1;

  j = (k = xc.length) < (l = yc.length) ? k : l;

  // Compare digit by digit.
  for (i = -1; ++i < j;) {
    if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
  }

  // Compare lengths.
  return k == l ? 0 : k > l ^ isneg ? 1 : -1;
};


/*
 * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
 * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
 */
P.div = function (y) {
  var x = this,
    Big = x.constructor,
    a = x.c,                  // dividend
    b = (y = new Big(y)).c,   // divisor
    k = x.s == y.s ? 1 : -1,
    dp = Big.DP;

  if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);

  // Divisor is zero?
  if (!b[0]) throw Error(DIV_BY_ZERO);

  // Dividend is 0? Return +-0.
  if (!a[0]) return new Big(k * 0);

  var bl, bt, n, cmp, ri,
    bz = b.slice(),
    ai = bl = b.length,
    al = a.length,
    r = a.slice(0, bl),   // remainder
    rl = r.length,
    q = y,                // quotient
    qc = q.c = [],
    qi = 0,
    d = dp + (q.e = x.e - y.e) + 1;    // number of digits of the result

  q.s = k;
  k = d < 0 ? 0 : d;

  // Create version of divisor with leading zero.
  bz.unshift(0);

  // Add zeros to make remainder as long as divisor.
  for (; rl++ < bl;) r.push(0);

  do {

    // n is how many times the divisor goes into current remainder.
    for (n = 0; n < 10; n++) {

      // Compare divisor and remainder.
      if (bl != (rl = r.length)) {
        cmp = bl > rl ? 1 : -1;
      } else {
        for (ri = -1, cmp = 0; ++ri < bl;) {
          if (b[ri] != r[ri]) {
            cmp = b[ri] > r[ri] ? 1 : -1;
            break;
          }
        }
      }

      // If divisor < remainder, subtract divisor from remainder.
      if (cmp < 0) {

        // Remainder can't be more than 1 digit longer than divisor.
        // Equalise lengths using divisor with extra leading zero?
        for (bt = rl == bl ? b : bz; rl;) {
          if (r[--rl] < bt[rl]) {
            ri = rl;
            for (; ri && !r[--ri];) r[ri] = 9;
            --r[ri];
            r[rl] += 10;
          }
          r[rl] -= bt[rl];
        }

        for (; !r[0];) r.shift();
      } else {
        break;
      }
    }

    // Add the digit n to the result array.
    qc[qi++] = cmp ? n : ++n;

    // Update the remainder.
    if (r[0] && cmp) r[rl] = a[ai] || 0;
    else r = [a[ai]];

  } while ((ai++ < al || r[0] !== UNDEFINED) && k--);

  // Leading zero? Do not remove if result is simply zero (qi == 1).
  if (!qc[0] && qi != 1) {

    // There can't be more than one zero.
    qc.shift();
    q.e--;
  }

  // Round?
  if (qi > d) round(q, dp, Big.RM, r[0] !== UNDEFINED);

  return q;
};


/*
 * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
 */
P.eq = function (y) {
  return !this.cmp(y);
};


/*
 * Return true if the value of this Big is greater than the value of Big y, otherwise return
 * false.
 */
P.gt = function (y) {
  return this.cmp(y) > 0;
};


/*
 * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
 * return false.
 */
P.gte = function (y) {
  return this.cmp(y) > -1;
};


/*
 * Return true if the value of this Big is less than the value of Big y, otherwise return false.
 */
P.lt = function (y) {
  return this.cmp(y) < 0;
};


/*
 * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
 * return false.
 */
P.lte = function (y) {
  return this.cmp(y) < 1;
};


/*
 * Return a new Big whose value is the value of this Big minus the value of Big y.
 */
P.minus = P.sub = function (y) {
  var i, j, t, xlty,
    x = this,
    Big = x.constructor,
    a = x.s,
    b = (y = new Big(y)).s;

  // Signs differ?
  if (a != b) {
    y.s = -b;
    return x.plus(y);
  }

  var xc = x.c.slice(),
    xe = x.e,
    yc = y.c,
    ye = y.e;

  // Either zero?
  if (!xc[0] || !yc[0]) {

    // y is non-zero? x is non-zero? Or both are zero.
    return yc[0] ? (y.s = -b, y) : new Big(xc[0] ? x : 0);
  }

  // Determine which is the bigger number. Prepend zeros to equalise exponents.
  if (a = xe - ye) {

    if (xlty = a < 0) {
      a = -a;
      t = xc;
    } else {
      ye = xe;
      t = yc;
    }

    t.reverse();
    for (b = a; b--;) t.push(0);
    t.reverse();
  } else {

    // Exponents equal. Check digit by digit.
    j = ((xlty = xc.length < yc.length) ? xc : yc).length;

    for (a = b = 0; b < j; b++) {
      if (xc[b] != yc[b]) {
        xlty = xc[b] < yc[b];
        break;
      }
    }
  }

  // x < y? Point xc to the array of the bigger number.
  if (xlty) {
    t = xc;
    xc = yc;
    yc = t;
    y.s = -y.s;
  }

  /*
   * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
   * needs to start at yc.length.
   */
  if ((b = (j = yc.length) - (i = xc.length)) > 0) for (; b--;) xc[i++] = 0;

  // Subtract yc from xc.
  for (b = i; j > a;) {
    if (xc[--j] < yc[j]) {
      for (i = j; i && !xc[--i];) xc[i] = 9;
      --xc[i];
      xc[j] += 10;
    }

    xc[j] -= yc[j];
  }

  // Remove trailing zeros.
  for (; xc[--b] === 0;) xc.pop();

  // Remove leading zeros and adjust exponent accordingly.
  for (; xc[0] === 0;) {
    xc.shift();
    --ye;
  }

  if (!xc[0]) {

    // n - n = +0
    y.s = 1;

    // Result must be zero.
    xc = [ye = 0];
  }

  y.c = xc;
  y.e = ye;

  return y;
};


/*
 * Return a new Big whose value is the value of this Big modulo the value of Big y.
 */
P.mod = function (y) {
  var ygtx,
    x = this,
    Big = x.constructor,
    a = x.s,
    b = (y = new Big(y)).s;

  if (!y.c[0]) throw Error(DIV_BY_ZERO);

  x.s = y.s = 1;
  ygtx = y.cmp(x) == 1;
  x.s = a;
  y.s = b;

  if (ygtx) return new Big(x);

  a = Big.DP;
  b = Big.RM;
  Big.DP = Big.RM = 0;
  x = x.div(y);
  Big.DP = a;
  Big.RM = b;

  return this.minus(x.times(y));
};


/*
 * Return a new Big whose value is the value of this Big plus the value of Big y.
 */
P.plus = P.add = function (y) {
  var t,
    x = this,
    Big = x.constructor,
    a = x.s,
    b = (y = new Big(y)).s;

  // Signs differ?
  if (a != b) {
    y.s = -b;
    return x.minus(y);
  }

  var xe = x.e,
    xc = x.c,
    ye = y.e,
    yc = y.c;

  // Either zero? y is non-zero? x is non-zero? Or both are zero.
  if (!xc[0] || !yc[0]) return yc[0] ? y : new Big(xc[0] ? x : a * 0);

  xc = xc.slice();

  // Prepend zeros to equalise exponents.
  // Note: reverse faster than unshifts.
  if (a = xe - ye) {
    if (a > 0) {
      ye = xe;
      t = yc;
    } else {
      a = -a;
      t = xc;
    }

    t.reverse();
    for (; a--;) t.push(0);
    t.reverse();
  }

  // Point xc to the longer array.
  if (xc.length - yc.length < 0) {
    t = yc;
    yc = xc;
    xc = t;
  }

  a = yc.length;

  // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
  for (b = 0; a; xc[a] %= 10) b = (xc[--a] = xc[a] + yc[a] + b) / 10 | 0;

  // No need to check for zero, as +x + +y != 0 && -x + -y != 0

  if (b) {
    xc.unshift(b);
    ++ye;
  }

  // Remove trailing zeros.
  for (a = xc.length; xc[--a] === 0;) xc.pop();

  y.c = xc;
  y.e = ye;

  return y;
};


/*
 * Return a Big whose value is the value of this Big raised to the power n.
 * If n is negative, round to a maximum of Big.DP decimal places using rounding
 * mode Big.RM.
 *
 * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
 */
P.pow = function (n) {
  var x = this,
    one = new x.constructor(1),
    y = one,
    isneg = n < 0;

  if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) throw Error(INVALID + 'exponent');
  if (isneg) n = -n;

  for (;;) {
    if (n & 1) y = y.times(x);
    n >>= 1;
    if (!n) break;
    x = x.times(x);
  }

  return isneg ? one.div(y) : y;
};


/*
 * Return a new Big whose value is the value of this Big rounded using rounding mode rm
 * to a maximum of dp decimal places, or, if dp is negative, to an integer which is a
 * multiple of 10**-dp.
 * If dp is not specified, round to 0 decimal places.
 * If rm is not specified, use Big.RM.
 *
 * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
 * rm? 0, 1, 2 or 3 (ROUND_DOWN, ROUND_HALF_UP, ROUND_HALF_EVEN, ROUND_UP)
 */
P.round = function (dp, rm) {
  var Big = this.constructor;
  if (dp === UNDEFINED) dp = 0;
  else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) throw Error(INVALID_DP);
  return round(new Big(this), dp, rm === UNDEFINED ? Big.RM : rm);
};


/*
 * Return a new Big whose value is the square root of the value of this Big, rounded, if
 * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
 */
P.sqrt = function () {
  var r, c, t,
    x = this,
    Big = x.constructor,
    s = x.s,
    e = x.e,
    half = new Big(0.5);

  // Zero?
  if (!x.c[0]) return new Big(x);

  // Negative?
  if (s < 0) throw Error(NAME + 'No square root');

  // Estimate.
  s = Math.sqrt(x + '');

  // Math.sqrt underflow/overflow?
  // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
  if (s === 0 || s === 1 / 0) {
    c = x.c.join('');
    if (!(c.length + e & 1)) c += '0';
    s = Math.sqrt(c);
    e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
    r = new Big((s == 1 / 0 ? '1e' : (s = s.toExponential()).slice(0, s.indexOf('e') + 1)) + e);
  } else {
    r = new Big(s);
  }

  e = r.e + (Big.DP += 4);

  // Newton-Raphson iteration.
  do {
    t = r;
    r = half.times(t.plus(x.div(t)));
  } while (t.c.slice(0, e).join('') !== r.c.slice(0, e).join(''));

  return round(r, Big.DP -= 4, Big.RM);
};


/*
 * Return a new Big whose value is the value of this Big times the value of Big y.
 */
P.times = P.mul = function (y) {
  var c,
    x = this,
    Big = x.constructor,
    xc = x.c,
    yc = (y = new Big(y)).c,
    a = xc.length,
    b = yc.length,
    i = x.e,
    j = y.e;

  // Determine sign of result.
  y.s = x.s == y.s ? 1 : -1;

  // Return signed 0 if either 0.
  if (!xc[0] || !yc[0]) return new Big(y.s * 0);

  // Initialise exponent of result as x.e + y.e.
  y.e = i + j;

  // If array xc has fewer digits than yc, swap xc and yc, and lengths.
  if (a < b) {
    c = xc;
    xc = yc;
    yc = c;
    j = a;
    a = b;
    b = j;
  }

  // Initialise coefficient array of result with zeros.
  for (c = new Array(j = a + b); j--;) c[j] = 0;

  // Multiply.

  // i is initially xc.length.
  for (i = b; i--;) {
    b = 0;

    // a is yc.length.
    for (j = a + i; j > i;) {

      // Current sum of products at this digit position, plus carry.
      b = c[j] + yc[i] * xc[j - i - 1] + b;
      c[j--] = b % 10;

      // carry
      b = b / 10 | 0;
    }

    c[j] = (c[j] + b) % 10;
  }

  // Increment result exponent if there is a final carry, otherwise remove leading zero.
  if (b) ++y.e;
  else c.shift();

  // Remove trailing zeros.
  for (i = c.length; !c[--i];) c.pop();
  y.c = c;

  return y;
};


/*
 * Return a string representing the value of this Big in exponential notation to dp fixed decimal
 * places and rounded using Big.RM.
 *
 * dp? {number} Integer, 0 to MAX_DP inclusive.
 */
P.toExponential = function (dp) {
  return stringify$4(this, 1, dp, dp);
};


/*
 * Return a string representing the value of this Big in normal notation to dp fixed decimal
 * places and rounded using Big.RM.
 *
 * dp? {number} Integer, 0 to MAX_DP inclusive.
 *
 * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
 * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
 */
P.toFixed = function (dp) {
  return stringify$4(this, 2, dp, this.e + dp);
};


/*
 * Return a string representing the value of this Big rounded to sd significant digits using
 * Big.RM. Use exponential notation if sd is less than the number of digits necessary to represent
 * the integer part of the value in normal notation.
 *
 * sd {number} Integer, 1 to MAX_DP inclusive.
 */
P.toPrecision = function (sd) {
  return stringify$4(this, 3, sd, sd - 1);
};


/*
 * Return a string representing the value of this Big.
 * Return exponential notation if this Big has a positive exponent equal to or greater than
 * Big.PE, or a negative exponent equal to or less than Big.NE.
 * Omit the sign for negative zero.
 */
P.toString = function () {
  return stringify$4(this);
};


/*
 * Return a string representing the value of this Big.
 * Return exponential notation if this Big has a positive exponent equal to or greater than
 * Big.PE, or a negative exponent equal to or less than Big.NE.
 * Include the sign for negative zero.
 */
P.valueOf = P.toJSON = function () {
  return stringify$4(this, 4);
};


// Export


var Big$1 = _Big_();

var toFormat$1 = {exports: {}};

/*
 *  toFormat v2.0.0
 *  Adds a toFormat instance method to big.js or decimal.js
 *  Copyright (c) 2017 Michael Mclaughlin
 *  MIT Licence
 */

(function (module) {
/*
 * Adds a `toFormat` method to `Ctor.prototype` and a `format` object to `Ctor`, where `Ctor` is
 * a big number constructor such as `Decimal` (decimal.js) or `Big` (big.js).
 */
function toFormat(Ctor) {

  /*
   *  Returns a string representing the value of this big number in fixed-point notation to `dp`
   *  decimal places using rounding mode `rm`, and formatted according to the properties of the
   * `fmt`, `this.format` and `this.constructor.format` objects, in that order of precedence.
   *
   *  Example:
   *
   *  x = new Decimal('123456789.987654321')
   *
   *  // Add a format object to the constructor...
   *  Decimal.format = {
   *    decimalSeparator: '.',
   *    groupSeparator: ',',
   *    groupSize: 3,
   *    secondaryGroupSize: 0,
   *    fractionGroupSeparator: '',     // '\xA0' non-breaking space
   *    fractionGroupSize : 0
   *  }
   *
   *  x.toFormat();                // 123,456,789.987654321
   *  x.toFormat(2, 1);            // 123,456,789.98
   *
   *  // And/or add a format object to the big number itself...
   *  x.format = {
   *    decimalSeparator: ',',
   *    groupSeparator: '',
   *  }
   *
   *  x.toFormat();                // 123456789,987654321
   *
   *  format = {
   *    decimalSeparator: '.',
   *    groupSeparator: ' ',
   *    groupSize: 3,
   *    fractionGroupSeparator: ' ',     // '\xA0' non-breaking space
   *    fractionGroupSize : 5
   *  }

   *  // And/or pass a format object to the method call.
   *  x.toFormat(format);          // 123 456 789.98765 4321
   *  x.toFormat(4, format);       // 123 456 789.9877
   *  x.toFormat(2, 1, format);    // 123 456 789.98
   *
   *  [dp] {number} Decimal places. Integer.
   *  [rm] {number} Rounding mode. Integer, 0 to 8. (Ignored if using big.js.)
   *  [fmt] {Object} A format object.
   *
   */
  Ctor.prototype.toFormat = function toFormat(dp, rm, fmt) {

    if (!this.e && this.e !== 0) return this.toString();   // Infinity/NaN

    var arr, g1, g2, i,
      u,                             // undefined
      nd,                            // number of integer digits
      intd,                          // integer digits
      intp,                          // integer part
      fracp,                         // fraction part
      dsep,                          // decimalSeparator
      gsep,                          // groupSeparator
      gsize,                         // groupSize
      sgsize,                        // secondaryGroupSize
      fgsep,                         // fractionGroupSeparator
      fgsize,                        // fractionGroupSize
      tfmt = this.format || {},
      cfmt = this.constructor.format || {};

    if (dp != u) {
      if (typeof dp == 'object') {
        fmt = dp;
        dp = u;
      } else if (rm != u) {
        if (typeof rm == 'object') {
          fmt = rm;
          rm = u;
        } else if (typeof fmt != 'object') {
          fmt = {};
        }
      } else {
        fmt = {};
      }
    } else {
      fmt = {};
    }

    arr = this.toFixed(dp, rm).split('.');
    intp = arr[0];
    fracp = arr[1];
    intd = this.s < 0 ? intp.slice(1) : intp;
    nd = intd.length;

    dsep = fmt.decimalSeparator;
    if (dsep == u) {
      dsep = tfmt.decimalSeparator;
      if (dsep == u) {
        dsep = cfmt.decimalSeparator;
        if (dsep == u) dsep = '.';
      }
    }

    gsep = fmt.groupSeparator;
    if (gsep == u) {
      gsep = tfmt.groupSeparator;
      if (gsep == u) gsep = cfmt.groupSeparator;
    }

    if (gsep) {
      gsize = fmt.groupSize;
      if (gsize == u) {
        gsize = tfmt.groupSize;
        if (gsize == u) {
          gsize = cfmt.groupSize;
          if (gsize == u) gsize = 0;
        }
      }

      sgsize = fmt.secondaryGroupSize;
      if (sgsize == u) {
        sgsize = tfmt.secondaryGroupSize;
        if (sgsize == u) {
          sgsize = cfmt.secondaryGroupSize;
          if (sgsize == u) sgsize = 0;
        }
      }

      if (sgsize) {
        g1 = +sgsize;
        g2 = +gsize;
        nd -= g2;
      } else {
        g1 = +gsize;
        g2 = +sgsize;
      }

      if (g1 > 0 && nd > 0) {
        i = nd % g1 || g1;
        intp = intd.substr(0, i);
        for (; i < nd; i += g1) intp += gsep + intd.substr(i, g1);
        if (g2 > 0) intp += gsep + intd.slice(i);
        if (this.s < 0) intp = '-' + intp;
      }
    }

    if (fracp) {
      fgsep = fmt.fractionGroupSeparator;
      if (fgsep == u) {
        fgsep = tfmt.fractionGroupSeparator;
        if (fgsep == u) fgsep = cfmt.fractionGroupSeparator;
      }

      if (fgsep) {
        fgsize = fmt.fractionGroupSize;
        if (fgsize == u) {
          fgsize = tfmt.fractionGroupSize;
          if (fgsize == u) {
            fgsize = cfmt.fractionGroupSize;
            if (fgsize == u) fgsize = 0;
          }
        }

        fgsize = +fgsize;

        if (fgsize) {
          fracp = fracp.replace(new RegExp('\\d{' + fgsize + '}\\B', 'g'), '$&' + fgsep);
        }
      }

      return intp + dsep + fracp;
    } else {

      return intp;
    }
  };

  Ctor.format = {
    decimalSeparator: '.',
    groupSeparator: ',',
    groupSize: 3,
    secondaryGroupSize: 0,
    fractionGroupSeparator: '',
    fractionGroupSize: 0
  };

  return Ctor;
}

if (module.exports) module.exports = toFormat;
}(toFormat$1));

var toFormat = toFormat$1.exports;

const version$7 = "logger/5.5.0";

let _permanentCensorErrors = false;
let _censorErrors = false;
const LogLevels = { debug: 1, "default": 2, info: 2, warning: 3, error: 4, off: 5 };
let _logLevel = LogLevels["default"];
let _globalLogger = null;
function _checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        ["NFD", "NFC", "NFKD", "NFKC"].forEach((form) => {
            try {
                if ("test".normalize(form) !== "test") {
                    throw new Error("bad normalize");
                }
                ;
            }
            catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) {
            throw new Error("missing " + missing.join(", "));
        }
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) {
            throw new Error("broken implementation");
        }
    }
    catch (error) {
        return error.message;
    }
    return null;
}
const _normalizeError = _checkNormalize();
var LogLevel;
(function (LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})(LogLevel || (LogLevel = {}));
var ErrorCode;
(function (ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})(ErrorCode || (ErrorCode = {}));
const HEX = "0123456789abcdef";
class Logger {
    constructor(version) {
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if (LogLevels[level] == null) {
            this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        }
        if (_logLevel > LogLevels[level]) {
            return;
        }
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log(Logger.levels.DEBUG, args);
    }
    info(...args) {
        this._log(Logger.levels.INFO, args);
    }
    warn(...args) {
        this._log(Logger.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if (_censorErrors) {
            return this.makeError("censored error", code, {});
        }
        if (!code) {
            code = Logger.errors.UNKNOWN_ERROR;
        }
        if (!params) {
            params = {};
        }
        const messageDetails = [];
        Object.keys(params).forEach((key) => {
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for (let i = 0; i < value.length; i++) {
                        hex += HEX[value[i] >> 4];
                        hex += HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                }
                else {
                    messageDetails.push(key + "=" + JSON.stringify(value));
                }
            }
            catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        if (messageDetails.length) {
            message += " (" + messageDetails.join(", ") + ")";
        }
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function (key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, Logger.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) {
            return;
        }
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) {
            return;
        }
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (_normalizeError) {
            this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "String.prototype.normalize", form: _normalizeError
            });
        }
    }
    checkSafeUint53(value, message) {
        if (typeof (value) !== "number") {
            return;
        }
        if (message == null) {
            message = "value not safe";
        }
        if (value < 0 || value >= 0x1fffffffffffff) {
            this.throwError(message, Logger.errors.NUMERIC_FAULT, {
                operation: "checkSafeInteger",
                fault: "out-of-safe-range",
                value: value
            });
        }
        if (value % 1) {
            this.throwError(message, Logger.errors.NUMERIC_FAULT, {
                operation: "checkSafeInteger",
                fault: "non-integer",
                value: value
            });
        }
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) {
            message = ": " + message;
        }
        else {
            message = "";
        }
        if (count < expectedCount) {
            this.throwError("missing argument" + message, Logger.errors.MISSING_ARGUMENT, {
                count: count,
                expectedCount: expectedCount
            });
        }
        if (count > expectedCount) {
            this.throwError("too many arguments" + message, Logger.errors.UNEXPECTED_ARGUMENT, {
                count: count,
                expectedCount: expectedCount
            });
        }
    }
    checkNew(target, kind) {
        if (target === Object || target == null) {
            this.throwError("missing new", Logger.errors.MISSING_NEW, { name: kind.name });
        }
    }
    checkAbstract(target, kind) {
        if (target === kind) {
            this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, { name: target.name, operation: "new" });
        }
        else if (target === Object || target == null) {
            this.throwError("missing new", Logger.errors.MISSING_NEW, { name: kind.name });
        }
    }
    static globalLogger() {
        if (!_globalLogger) {
            _globalLogger = new Logger(version$7);
        }
        return _globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) {
            this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        if (_permanentCensorErrors) {
            if (!censorship) {
                return;
            }
            this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        _censorErrors = !!censorship;
        _permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            Logger.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        _logLevel = level;
    }
    static from(version) {
        return new Logger(version);
    }
}
Logger.errors = ErrorCode;
Logger.levels = LogLevel;

const version$6 = "bytes/5.5.0";

const logger$2 = new Logger(version$6);
///////////////////////////////
function isHexable(value) {
    return !!(value.toHexString);
}
function addSlice(array) {
    if (array.slice) {
        return array;
    }
    array.slice = function () {
        const args = Array.prototype.slice.call(arguments);
        return addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function isInteger(value) {
    return (typeof (value) === "number" && value == value && (value % 1) === 0);
}
function isBytes(value) {
    if (value == null) {
        return false;
    }
    if (value.constructor === Uint8Array) {
        return true;
    }
    if (typeof (value) === "string") {
        return false;
    }
    if (!isInteger(value.length) || value.length < 0) {
        return false;
    }
    for (let i = 0; i < value.length; i++) {
        const v = value[i];
        if (!isInteger(v) || v < 0 || v >= 256) {
            return false;
        }
    }
    return true;
}
function arrayify(value, options) {
    if (!options) {
        options = {};
    }
    if (typeof (value) === "number") {
        logger$2.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while (value) {
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) {
            result.push(0);
        }
        return addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof (value) === "string" && value.substring(0, 2) !== "0x") {
        value = "0x" + value;
    }
    if (isHexable(value)) {
        value = value.toHexString();
    }
    if (isHexString(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") {
                hex = "0x0" + hex.substring(2);
            }
            else if (options.hexPad === "right") {
                hex += "0";
            }
            else {
                logger$2.throwArgumentError("hex data is odd-length", "value", value);
            }
        }
        const result = [];
        for (let i = 0; i < hex.length; i += 2) {
            result.push(parseInt(hex.substring(i, i + 2), 16));
        }
        return addSlice(new Uint8Array(result));
    }
    if (isBytes(value)) {
        return addSlice(new Uint8Array(value));
    }
    return logger$2.throwArgumentError("invalid arrayify value", "value", value);
}
function isHexString(value, length) {
    if (typeof (value) !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) {
        return false;
    }
    if (length && value.length !== 2 + 2 * length) {
        return false;
    }
    return true;
}

const version$5 = "bignumber/5.5.0";

var BN$1 = BN$3.BN;
new Logger(version$5);
// value should have no prefix
function _base36To16(value) {
    return (new BN$1(value, 36)).toString(16);
}

function keccak256(data) {
    return '0x' + sha3.keccak_256(arrayify(data));
}

const version$4 = "address/5.5.0";

const logger$1 = new Logger(version$4);
function getChecksumAddress(address) {
    if (!isHexString(address, 20)) {
        logger$1.throwArgumentError("invalid address", "address", address);
    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for (let i = 0; i < 40; i++) {
        expanded[i] = chars[i].charCodeAt(0);
    }
    const hashed = arrayify(keccak256(expanded));
    for (let i = 0; i < 40; i += 2) {
        if ((hashed[i >> 1] >> 4) >= 8) {
            chars[i] = chars[i].toUpperCase();
        }
        if ((hashed[i >> 1] & 0x0f) >= 8) {
            chars[i + 1] = chars[i + 1].toUpperCase();
        }
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const MAX_SAFE_INTEGER$2 = 0x1fffffffffffff;
function log10(x) {
    if (Math.log10) {
        return Math.log10(x);
    }
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const ibanLookup = {};
for (let i = 0; i < 10; i++) {
    ibanLookup[String(i)] = String(i);
}
for (let i = 0; i < 26; i++) {
    ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
}
// How many decimal digits can we process? (for 64-bit float, this is 15)
const safeDigits = Math.floor(log10(MAX_SAFE_INTEGER$2));
function ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c) => { return ibanLookup[c]; }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while (expanded.length >= safeDigits) {
        let block = expanded.substring(0, safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - (parseInt(expanded, 10) % 97));
    while (checksum.length < 2) {
        checksum = "0" + checksum;
    }
    return checksum;
}
function getAddress(address) {
    let result = null;
    if (typeof (address) !== "string") {
        logger$1.throwArgumentError("invalid address", "address", address);
    }
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") {
            address = "0x" + address;
        }
        result = getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) {
            logger$1.throwArgumentError("bad address checksum", "address", address);
        }
        // Maybe ICAP? (we only support direct mode)
    }
    else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== ibanChecksum(address)) {
            logger$1.throwArgumentError("bad icap checksum", "address", address);
        }
        result = _base36To16(address.substring(4));
        while (result.length < 40) {
            result = "0" + result;
        }
        result = getChecksumAddress("0x" + result);
    }
    else {
        logger$1.throwArgumentError("invalid address", "address", address);
    }
    return result;
}

var TradeType;

(function (TradeType) {
  TradeType[TradeType["EXACT_INPUT"] = 0] = "EXACT_INPUT";
  TradeType[TradeType["EXACT_OUTPUT"] = 1] = "EXACT_OUTPUT";
})(TradeType || (TradeType = {}));

var Rounding;

(function (Rounding) {
  Rounding[Rounding["ROUND_DOWN"] = 0] = "ROUND_DOWN";
  Rounding[Rounding["ROUND_HALF_UP"] = 1] = "ROUND_HALF_UP";
  Rounding[Rounding["ROUND_UP"] = 2] = "ROUND_UP";
})(Rounding || (Rounding = {}));

function _defineProperties$p(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$s(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$p(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$p(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var _toSignificantRoundin, _toFixedRounding;
var Decimal = /*#__PURE__*/toFormat(Decimal$2);
var Big = /*#__PURE__*/toFormat(Big$1);
var toSignificantRounding = (_toSignificantRoundin = {}, _toSignificantRoundin[Rounding.ROUND_DOWN] = Decimal.ROUND_DOWN, _toSignificantRoundin[Rounding.ROUND_HALF_UP] = Decimal.ROUND_HALF_UP, _toSignificantRoundin[Rounding.ROUND_UP] = Decimal.ROUND_UP, _toSignificantRoundin);
var toFixedRounding = (_toFixedRounding = {}, _toFixedRounding[Rounding.ROUND_DOWN] = 0, _toFixedRounding[Rounding.ROUND_HALF_UP] = 1, _toFixedRounding[Rounding.ROUND_UP] = 3, _toFixedRounding);
var Fraction = /*#__PURE__*/function () {
  function Fraction(numerator, denominator) {
    if (denominator === void 0) {
      denominator = JSBI.BigInt(1);
    }

    this.numerator = JSBI.BigInt(numerator);
    this.denominator = JSBI.BigInt(denominator);
  }

  Fraction.tryParseFraction = function tryParseFraction(fractionish) {
    if (fractionish instanceof JSBI || typeof fractionish === 'number' || typeof fractionish === 'string') return new Fraction(fractionish);
    if ('numerator' in fractionish && 'denominator' in fractionish) return fractionish;
    throw new Error('Could not parse fraction');
  } // performs floor division
  ;

  var _proto = Fraction.prototype;

  _proto.invert = function invert() {
    return new Fraction(this.denominator, this.numerator);
  };

  _proto.add = function add(other) {
    var otherParsed = Fraction.tryParseFraction(other);

    if (JSBI.equal(this.denominator, otherParsed.denominator)) {
      return new Fraction(JSBI.add(this.numerator, otherParsed.numerator), this.denominator);
    }

    return new Fraction(JSBI.add(JSBI.multiply(this.numerator, otherParsed.denominator), JSBI.multiply(otherParsed.numerator, this.denominator)), JSBI.multiply(this.denominator, otherParsed.denominator));
  };

  _proto.subtract = function subtract(other) {
    var otherParsed = Fraction.tryParseFraction(other);

    if (JSBI.equal(this.denominator, otherParsed.denominator)) {
      return new Fraction(JSBI.subtract(this.numerator, otherParsed.numerator), this.denominator);
    }

    return new Fraction(JSBI.subtract(JSBI.multiply(this.numerator, otherParsed.denominator), JSBI.multiply(otherParsed.numerator, this.denominator)), JSBI.multiply(this.denominator, otherParsed.denominator));
  };

  _proto.lessThan = function lessThan(other) {
    var otherParsed = Fraction.tryParseFraction(other);
    return JSBI.lessThan(JSBI.multiply(this.numerator, otherParsed.denominator), JSBI.multiply(otherParsed.numerator, this.denominator));
  };

  _proto.equalTo = function equalTo(other) {
    var otherParsed = Fraction.tryParseFraction(other);
    return JSBI.equal(JSBI.multiply(this.numerator, otherParsed.denominator), JSBI.multiply(otherParsed.numerator, this.denominator));
  };

  _proto.greaterThan = function greaterThan(other) {
    var otherParsed = Fraction.tryParseFraction(other);
    return JSBI.greaterThan(JSBI.multiply(this.numerator, otherParsed.denominator), JSBI.multiply(otherParsed.numerator, this.denominator));
  };

  _proto.multiply = function multiply(other) {
    var otherParsed = Fraction.tryParseFraction(other);
    return new Fraction(JSBI.multiply(this.numerator, otherParsed.numerator), JSBI.multiply(this.denominator, otherParsed.denominator));
  };

  _proto.divide = function divide(other) {
    var otherParsed = Fraction.tryParseFraction(other);
    return new Fraction(JSBI.multiply(this.numerator, otherParsed.denominator), JSBI.multiply(this.denominator, otherParsed.numerator));
  };

  _proto.toSignificant = function toSignificant(significantDigits, format, rounding) {
    if (format === void 0) {
      format = {
        groupSeparator: ''
      };
    }

    if (rounding === void 0) {
      rounding = Rounding.ROUND_HALF_UP;
    }

    !Number.isInteger(significantDigits) ? process.env.NODE_ENV !== "production" ? invariant$2(false, significantDigits + " is not an integer.") : invariant$2(false) : void 0;
    !(significantDigits > 0) ? process.env.NODE_ENV !== "production" ? invariant$2(false, significantDigits + " is not positive.") : invariant$2(false) : void 0;
    Decimal.set({
      precision: significantDigits + 1,
      rounding: toSignificantRounding[rounding]
    });
    var quotient = new Decimal(this.numerator.toString()).div(this.denominator.toString()).toSignificantDigits(significantDigits);
    return quotient.toFormat(quotient.decimalPlaces(), format);
  };

  _proto.toFixed = function toFixed(decimalPlaces, format, rounding) {
    if (format === void 0) {
      format = {
        groupSeparator: ''
      };
    }

    if (rounding === void 0) {
      rounding = Rounding.ROUND_HALF_UP;
    }

    !Number.isInteger(decimalPlaces) ? process.env.NODE_ENV !== "production" ? invariant$2(false, decimalPlaces + " is not an integer.") : invariant$2(false) : void 0;
    !(decimalPlaces >= 0) ? process.env.NODE_ENV !== "production" ? invariant$2(false, decimalPlaces + " is negative.") : invariant$2(false) : void 0;
    Big.DP = decimalPlaces;
    Big.RM = toFixedRounding[rounding];
    return new Big(this.numerator.toString()).div(this.denominator.toString()).toFormat(decimalPlaces, format);
  }
  /**
   * Helper method for converting any super class back to a fraction
   */
  ;

  _createClass$s(Fraction, [{
    key: "quotient",
    get: function get() {
      return JSBI.divide(this.numerator, this.denominator);
    } // remainder after floor division

  }, {
    key: "remainder",
    get: function get() {
      return new Fraction(JSBI.remainder(this.numerator, this.denominator), this.denominator);
    }
  }, {
    key: "asFraction",
    get: function get() {
      return new Fraction(this.numerator, this.denominator);
    }
  }]);

  return Fraction;
}();

var ONE_HUNDRED = /*#__PURE__*/new Fraction( /*#__PURE__*/JSBI.BigInt(100));
/**
 * Converts a fraction to a percent
 * @param fraction the fraction to convert
 */

function toPercent(fraction) {
  return new Percent(fraction.numerator, fraction.denominator);
}

var Percent = /*#__PURE__*/function (_Fraction) {
  _inheritsLoose(Percent, _Fraction);

  function Percent() {
    var _this;

    _this = _Fraction.apply(this, arguments) || this;
    /**
     * This boolean prevents a fraction from being interpreted as a Percent
     */

    _this.isPercent = true;
    return _this;
  }

  var _proto = Percent.prototype;

  _proto.add = function add(other) {
    return toPercent(_Fraction.prototype.add.call(this, other));
  };

  _proto.subtract = function subtract(other) {
    return toPercent(_Fraction.prototype.subtract.call(this, other));
  };

  _proto.multiply = function multiply(other) {
    return toPercent(_Fraction.prototype.multiply.call(this, other));
  };

  _proto.divide = function divide(other) {
    return toPercent(_Fraction.prototype.divide.call(this, other));
  };

  _proto.toSignificant = function toSignificant(significantDigits, format, rounding) {
    if (significantDigits === void 0) {
      significantDigits = 5;
    }

    return _Fraction.prototype.multiply.call(this, ONE_HUNDRED).toSignificant(significantDigits, format, rounding);
  };

  _proto.toFixed = function toFixed(decimalPlaces, format, rounding) {
    if (decimalPlaces === void 0) {
      decimalPlaces = 2;
    }

    return _Fraction.prototype.multiply.call(this, ONE_HUNDRED).toFixed(decimalPlaces, format, rounding);
  };

  return Percent;
}(Fraction);

/**
 * A currency is any fungible financial instrument, including Ether, all ERC20 tokens, and other chain-native currencies
 */

var BaseCurrency =
/**
 * Constructs an instance of the base class `BaseCurrency`.
 * @param chainId the chain ID on which this currency resides
 * @param decimals decimals of the currency
 * @param symbol symbol of the currency
 * @param name of the currency
 */
function BaseCurrency(chainId, decimals, symbol, name) {
  !Number.isSafeInteger(chainId) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'CHAIN_ID') : invariant$2(false) : void 0;
  !(decimals >= 0 && decimals < 255 && Number.isInteger(decimals)) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'DECIMALS') : invariant$2(false) : void 0;
  this.chainId = chainId;
  this.decimals = decimals;
  this.symbol = symbol;
  this.name = name;
};

/**
 * Validates an address and returns the parsed (checksummed) version of that address
 * @param address the unchecksummed hex address
 */

function validateAndParseAddress(address) {
  try {
    return getAddress(address);
  } catch (error) {
    throw new Error(address + " is not a valid address.");
  }
}

/**
 * Represents an ERC20 token with a unique address and some metadata.
 */

var Token$1 = /*#__PURE__*/function (_BaseCurrency) {
  _inheritsLoose(Token, _BaseCurrency);

  function Token(chainId, address, decimals, symbol, name) {
    var _this;

    _this = _BaseCurrency.call(this, chainId, decimals, symbol, name) || this;
    _this.isNative = false;
    _this.isToken = true;
    _this.address = validateAndParseAddress(address);
    return _this;
  }
  /**
   * Returns true if the two tokens are equivalent, i.e. have the same chainId and address.
   * @param other other token to compare
   */


  var _proto = Token.prototype;

  _proto.equals = function equals(other) {
    return other.isToken && this.chainId === other.chainId && this.address === other.address;
  }
  /**
   * Returns true if the address of this token sorts before the address of the other token
   * @param other other token to compare
   * @throws if the tokens have the same address
   * @throws if the tokens are on different chains
   */
  ;

  _proto.sortsBefore = function sortsBefore(other) {
    !(this.chainId === other.chainId) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'CHAIN_IDS') : invariant$2(false) : void 0;
    !(this.address !== other.address) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'ADDRESSES') : invariant$2(false) : void 0;
    return this.address.toLowerCase() < other.address.toLowerCase();
  }
  /**
   * Return this token, which does not need to be wrapped
   */
  ;

  _createClass$s(Token, [{
    key: "wrapped",
    get: function get() {
      return this;
    }
  }]);

  return Token;
}(BaseCurrency);

var _WETH;
/**
 * Known WETH9 implementation addresses, used in our implementation of Ether#wrapped
 */

(_WETH = {}, _WETH[1] = /*#__PURE__*/new Token$1(1, '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', 18, 'WETH', 'Wrapped Ether'), _WETH[3] = /*#__PURE__*/new Token$1(3, '0xc778417E063141139Fce010982780140Aa0cD5Ab', 18, 'WETH', 'Wrapped Ether'), _WETH[4] = /*#__PURE__*/new Token$1(4, '0xc778417E063141139Fce010982780140Aa0cD5Ab', 18, 'WETH', 'Wrapped Ether'), _WETH[5] = /*#__PURE__*/new Token$1(5, '0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6', 18, 'WETH', 'Wrapped Ether'), _WETH[42] = /*#__PURE__*/new Token$1(42, '0xd0A1E359811322d97991E03f863a0C30C2cF029C', 18, 'WETH', 'Wrapped Ether'), _WETH[10] = /*#__PURE__*/new Token$1(10, '0x4200000000000000000000000000000000000006', 18, 'WETH', 'Wrapped Ether'), _WETH[69] = /*#__PURE__*/new Token$1(69, '0x4200000000000000000000000000000000000006', 18, 'WETH', 'Wrapped Ether'), _WETH[42161] = /*#__PURE__*/new Token$1(42161, '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', 18, 'WETH', 'Wrapped Ether'), _WETH[421611] = /*#__PURE__*/new Token$1(421611, '0xB47e6A5f8b33b3F17603C83a0535A9dcD7E32681', 18, 'WETH', 'Wrapped Ether'), _WETH);

function computeFiatValuePriceImpact(fiatValueInput, fiatValueOutput) {
    if (!fiatValueOutput || !fiatValueInput)
        return undefined;
    //if (!fiatValueInput.currency.equals(fiatValueOutput.currency)) return undefined
    if (JSBI.equal(fiatValueInput.quotient, JSBI.BigInt(0)))
        return undefined;
    const pct = new Percent('1').subtract(fiatValueOutput.divide(fiatValueInput));
    return new Percent(pct.numerator, pct.denominator);
}

// TODO: Actually calculate price
/**
 * Returns the price in USDC of the input currency
 * @param currency currency to compute the USDC price of
 */
function useUSDCPrice(currency) {
    const chainId = useChainId();
    const wrapped = wrappedCurrency(currency, chainId);
    const USDC = USDCe[chainId];
    const tokenPairs = useMemo(() => [
        [
            chainId && wrapped && currencyEquals(WAVAX[chainId], wrapped) ? undefined : currency,
            chainId ? WAVAX[chainId] : undefined,
        ],
        [(wrapped === null || wrapped === void 0 ? void 0 : wrapped.equals(USDC)) ? undefined : wrapped, chainId === ChainId.AVALANCHE ? USDC : undefined],
        [chainId ? WAVAX[chainId] : undefined, chainId === ChainId.AVALANCHE ? USDC : undefined],
    ], [chainId, currency, wrapped, USDC]);
    const [[avaxPairState, avaxPair], [usdcPairState, usdcPair], [usdcAvaxPairState, usdcAvaxPair]] = usePairs(tokenPairs);
    return useMemo(() => {
        if (!currency || !wrapped || !chainId) {
            return undefined;
        }
        // handle wavax/avax
        if (wrapped.equals(WAVAX[chainId])) {
            if (usdcPair) {
                const price = usdcPair.priceOf(WAVAX[chainId]);
                return new Price(currency, USDC, price.denominator, price.numerator);
            }
            else {
                return undefined;
            }
        }
        // handle usdc
        if (wrapped.equals(USDC)) {
            return new Price(USDC, USDC, '1', '1');
        }
        const avaxPairAVAXAmount = avaxPair === null || avaxPair === void 0 ? void 0 : avaxPair.reserveOf(WAVAX[chainId]);
        const avaxPairAVAXUSDCValue = avaxPairAVAXAmount && usdcAvaxPair
            ? usdcAvaxPair.priceOf(WAVAX[chainId]).quote(avaxPairAVAXAmount, chainId).raw
            : JSBI$1.BigInt(0);
        // all other tokens
        // first try the usdc pair
        if (usdcPairState === PairState.EXISTS && usdcPair && usdcPair.reserveOf(USDC).greaterThan(avaxPairAVAXUSDCValue)) {
            const price = usdcPair.priceOf(wrapped);
            return new Price(currency, USDC, price.denominator, price.numerator);
        }
        if (avaxPairState === PairState.EXISTS && avaxPair && usdcAvaxPairState === PairState.EXISTS && usdcAvaxPair) {
            if (usdcAvaxPair.reserveOf(USDC).greaterThan('0') && avaxPair.reserveOf(WAVAX[chainId]).greaterThan('0')) {
                const avaxUsdcPrice = usdcAvaxPair.priceOf(USDC);
                const currencyAvaxPrice = avaxPair.priceOf(WAVAX[chainId]);
                const usdcPrice = avaxUsdcPrice.multiply(currencyAvaxPrice).invert();
                return new Price(currency, USDC, usdcPrice.denominator, usdcPrice.numerator);
            }
        }
        return undefined;
    }, [
        chainId,
        currency,
        avaxPair,
        avaxPairState,
        usdcAvaxPair,
        usdcAvaxPairState,
        usdcPair,
        usdcPairState,
        wrapped,
        USDC,
    ]);
}

const ContentBox$1 = styled(Box) `
  background-color: ${({ theme }) => theme.bg6};
  padding: 15px;
  border-radius: 8px;
  margin-top: 10px;
`;
const DataBox$1 = styled(Box) `
  align-items: center;
  justify-content: space-between;
  display: flex;
  margin: 5px 0px 5px 0px;
`;
const ValueText$1 = styled(Text$1) `
  color: ${({ theme, severity }) => severity === 3 || severity === 4
    ? theme.red1
    : severity === 2
        ? theme.yellow2
        : severity === 1
            ? theme.text1
            : severity === 0
                ? theme.green1
                : theme.text4};
`;

const LimitOrderDetailInfo = ({ trade }) => {
    var _a, _b, _c, _d;
    const { chainId } = usePangolinWeb3();
    const { derivedOrderInfo: { parsedAmounts, rawAmounts }, } = useGelatoLimitOrders();
    const { gasPrice, realExecutionPriceAsString } = useGasOverhead(parsedAmounts.input, parsedAmounts.output);
    const priceText = `${(_b = '1 ' + ((_a = parsedAmounts === null || parsedAmounts === void 0 ? void 0 : parsedAmounts.input) === null || _a === void 0 ? void 0 : _a.currency.symbol) + ' = ' + realExecutionPriceAsString) !== null && _b !== void 0 ? _b : '-'} ${(_c = parsedAmounts === null || parsedAmounts === void 0 ? void 0 : parsedAmounts.output) === null || _c === void 0 ? void 0 : _c.currency.symbol}`;
    const formattedGasPrice = gasPrice ? `${parseFloat(formatUnits(gasPrice, 'gwei')).toFixed(0)} GWEI` : '-';
    const library = useGelatoLimitOrdersLib();
    const outputAmount = parsedAmounts.output;
    const rawOutputAmount = (_d = rawAmounts.output) !== null && _d !== void 0 ? _d : '0';
    const { minReturn, slippagePercentage, gelatoFeePercentage } = useMemo(() => {
        var _a;
        if (!outputAmount || !library || !chainId)
            return {
                minReturn: undefined,
                slippagePercentage: undefined,
                gelatoFeePercentage: undefined,
            };
        const { minReturn } = library.getFeeAndSlippageAdjustedMinReturn(rawOutputAmount);
        const slippagePercentage = library.slippageBPS / 100;
        const gelatoFeePercentage = library.gelatoFeeBPS / 100;
        //const minReturnParsed = CurrencyAmount.fromRawAmount(trade?.outputAmount?.currency, minReturn)
        const minReturnParsed = new TokenAmount((_a = trade === null || trade === void 0 ? void 0 : trade.outputAmount) === null || _a === void 0 ? void 0 : _a.currency, minReturn);
        return {
            minReturn: minReturnParsed,
            slippagePercentage,
            gelatoFeePercentage,
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [outputAmount, chainId, library, rawOutputAmount]);
    const renderRow = (label, value) => {
        return (jsxs(DataBox$1, { children: [jsx(Text$1, Object.assign({ color: "text4", fontSize: 14 }, { children: label }), void 0), jsx(ValueText$1, Object.assign({ fontSize: 14 }, { children: value }), void 0)] }, label));
    };
    return (jsxs(ContentBox$1, { children: [renderRow('Gas Price', `${formattedGasPrice}`), renderRow('Real Execution Price', `${realExecutionPriceAsString ? `${priceText}` : '-'}`), renderRow('Gelato Fee', `${gelatoFeePercentage ? `${gelatoFeePercentage}` : '-'}%`), slippagePercentage !== INITIAL_ALLOWED_SLIPPAGE &&
                renderRow('Slippage Tolerance', `${slippagePercentage ? `${slippagePercentage}` : '-'}%`), renderRow(minReturn ? 'Minimum Received' : 'Maximum Sold', minReturn ? `${minReturn.toSignificant(4)} ${outputAmount ? outputAmount.currency.symbol : '-'}` : '-')] }, void 0));
};

function FiatValue({ fiatValue, priceImpact, }) {
    const theme = useContext(Me);
    const priceImpactColor = useMemo(() => {
        if (!priceImpact)
            return undefined;
        if (priceImpact.lessThan('0'))
            return theme.green1;
        const severity = warningSeverity(priceImpact);
        if (severity < 1)
            return theme.text4;
        if (severity < 3)
            return theme.yellow1;
        return theme.red1;
    }, [priceImpact, theme.green1, theme.red1, theme.text4, theme.yellow1]);
    return (jsxs(Text$1, Object.assign({ fontSize: 14, color: fiatValue ? 'text2' : 'text4', ml: 10 }, { children: [fiatValue ? '~' : '', "$", fiatValue ? fiatValue === null || fiatValue === void 0 ? void 0 : fiatValue.toSignificant(6, { groupSeparator: ',' }) : '-', priceImpact ? (jsxs("span", Object.assign({ style: { color: priceImpactColor } }, { children: [" (", priceImpact.multiply(JSBI$1.BigInt(-1)).toSignificant(3), "%)"] }), void 0)) : null] }), void 0));
}

const Root$4 = styled(Box) `
  display: grid;
  grid-template-rows: auto max-content;
  height: 100%;
`;
const Header$1 = styled(Box) `
  padding: 0px 10px;
`;
const TokenRow$1 = styled(Box) `
  display: grid;
  grid-template-columns: max-content auto max-content;
  align-items: center;
`;
styled(Box) `
  padding: 10px;
  background-color: ${({ theme }) => theme.bg6};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  margin-top: 15px;
`;
styled(Text$1) `
  width: 100%;
  font-style: italic;
  font-size: 12px;
  text-align: left;
`;
const Footer$1 = styled(Box) `
  padding: 0px 10px;
`;
const ErrorWrapper$1 = styled(Box) `
  display: grid;
  grid-template-rows: minmax(300px, auto) max-content;
  height: 100%;
  padding: 10px;
`;
const ErrorBox$1 = styled(Box) `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const SubmittedWrapper$1 = styled(Box) `
  display: grid;
  grid-template-rows: minmax(300px, auto) max-content;
  height: 100%;
  padding: 10px;
`;
const Link$1 = styled(Text$1) `
  text-decoration: none;
  color: ${({ theme }) => theme.blue1};
`;

const ConfirmLimitOrderDrawer = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { isOpen, onClose, trade, onAcceptChanges, recipient, onConfirm, attemptingTxn, swapErrorMessage, txHash } = props;
    const [showInverted, setShowInverted] = useState(false);
    const chainId = useChainId();
    const theme = useContext(Me);
    const { derivedOrderInfo: { price, parsedAmounts }, } = useGelatoLimitOrders();
    let formattedPrice;
    try {
        formattedPrice = showInverted ? price === null || price === void 0 ? void 0 : price.toSignificant(4) : (_a = price === null || price === void 0 ? void 0 : price.invert()) === null || _a === void 0 ? void 0 : _a.toSignificant(4);
    }
    catch (error) {
        formattedPrice = '0';
    }
    const label = showInverted ? `${(_b = price === null || price === void 0 ? void 0 : price.quoteCurrency) === null || _b === void 0 ? void 0 : _b.symbol}` : `${(_c = price === null || price === void 0 ? void 0 : price.baseCurrency) === null || _c === void 0 ? void 0 : _c.symbol} `;
    const labelInverted = showInverted ? `${(_d = price === null || price === void 0 ? void 0 : price.baseCurrency) === null || _d === void 0 ? void 0 : _d.symbol} ` : `${(_e = price === null || price === void 0 ? void 0 : price.quoteCurrency) === null || _e === void 0 ? void 0 : _e.symbol}`;
    const text = `${(_f = '1 ' + labelInverted + ' = ' + formattedPrice) !== null && _f !== void 0 ? _f : '-'} ${label}`;
    const flipPrice = useCallback(() => setShowInverted(!showInverted), [setShowInverted, showInverted]);
    const showAcceptChanges = false;
    const inputAmount = parsedAmounts.input;
    const outputAmount = parsedAmounts.output;
    const inputCurrency1 = inputAmount === null || inputAmount === void 0 ? void 0 : inputAmount.currency;
    const outputCurrency1 = outputAmount === null || outputAmount === void 0 ? void 0 : outputAmount.currency;
    const inputTokenInfo = inputCurrency1 === null || inputCurrency1 === void 0 ? void 0 : inputCurrency1.tokenInfo;
    const outputTokenInfo = outputCurrency1 === null || outputCurrency1 === void 0 ? void 0 : outputCurrency1.tokenInfo;
    const getInputCurrency = () => {
        if (inputCurrency1 && (inputCurrency1 === null || inputCurrency1 === void 0 ? void 0 : inputCurrency1.symbol) === CAVAX[chainId].symbol) {
            return CAVAX[chainId];
        }
        else if (inputTokenInfo && inputTokenInfo.symbol === CAVAX[chainId].symbol) {
            return CAVAX[chainId];
        }
        else if (inputTokenInfo) {
            return new Token$2(inputTokenInfo === null || inputTokenInfo === void 0 ? void 0 : inputTokenInfo.chainId, inputTokenInfo === null || inputTokenInfo === void 0 ? void 0 : inputTokenInfo.address, inputTokenInfo === null || inputTokenInfo === void 0 ? void 0 : inputTokenInfo.decimals, inputTokenInfo === null || inputTokenInfo === void 0 ? void 0 : inputTokenInfo.symbol, inputTokenInfo === null || inputTokenInfo === void 0 ? void 0 : inputTokenInfo.name);
        }
        else if (inputCurrency1) {
            return new Token$2(inputCurrency1 === null || inputCurrency1 === void 0 ? void 0 : inputCurrency1.chainId, inputCurrency1 === null || inputCurrency1 === void 0 ? void 0 : inputCurrency1.address, inputCurrency1 === null || inputCurrency1 === void 0 ? void 0 : inputCurrency1.decimals, inputCurrency1 === null || inputCurrency1 === void 0 ? void 0 : inputCurrency1.symbol, inputCurrency1 === null || inputCurrency1 === void 0 ? void 0 : inputCurrency1.name);
        }
        else {
            return undefined;
        }
    };
    const getOutputCurrency = () => {
        if (outputCurrency1 && (outputCurrency1 === null || outputCurrency1 === void 0 ? void 0 : outputCurrency1.symbol) === CAVAX[chainId].symbol) {
            return CAVAX[chainId];
        }
        else if (outputTokenInfo && (outputTokenInfo === null || outputTokenInfo === void 0 ? void 0 : outputTokenInfo.symbol) === CAVAX[chainId].symbol) {
            return CAVAX[chainId];
        }
        else if (outputTokenInfo) {
            return new Token$2(outputTokenInfo === null || outputTokenInfo === void 0 ? void 0 : outputTokenInfo.chainId, outputTokenInfo === null || outputTokenInfo === void 0 ? void 0 : outputTokenInfo.address, outputTokenInfo === null || outputTokenInfo === void 0 ? void 0 : outputTokenInfo.decimals, outputTokenInfo === null || outputTokenInfo === void 0 ? void 0 : outputTokenInfo.symbol, outputTokenInfo === null || outputTokenInfo === void 0 ? void 0 : outputTokenInfo.name);
        }
        else if (outputCurrency1) {
            return new Token$2(outputCurrency1 === null || outputCurrency1 === void 0 ? void 0 : outputCurrency1.chainId, outputCurrency1 === null || outputCurrency1 === void 0 ? void 0 : outputCurrency1.address, outputCurrency1 === null || outputCurrency1 === void 0 ? void 0 : outputCurrency1.decimals, outputCurrency1 === null || outputCurrency1 === void 0 ? void 0 : outputCurrency1.symbol, outputCurrency1 === null || outputCurrency1 === void 0 ? void 0 : outputCurrency1.name);
        }
        else {
            return undefined;
        }
    };
    const inputCurrency = getInputCurrency();
    const outputCurrency = getOutputCurrency();
    const fiatValueInput = useUSDCPrice(inputCurrency);
    const fiatValueOutput = useUSDCPrice(outputCurrency);
    if (!inputAmount || !outputAmount)
        return null;
    // text to show while loading
    const pendingText = `Submitting order to swap ${(_g = trade === null || trade === void 0 ? void 0 : trade.inputAmount) === null || _g === void 0 ? void 0 : _g.toSignificant(6)} ${inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol} for ${(_h = trade === null || trade === void 0 ? void 0 : trade.outputAmount) === null || _h === void 0 ? void 0 : _h.toSignificant(6)} ${outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol}`;
    const ConfirmContent = (jsxs(Root$4, { children: [jsxs(Header$1, { children: [jsxs(TokenRow$1, { children: [jsx(CurrencyLogo, { currency: inputCurrency, size: 24, imageSize: 48 }, void 0), jsx(Text$1, Object.assign({ fontSize: 24, fontWeight: 500, color: 'text1', style: { marginLeft: '12px' } }, { children: inputAmount.toSignificant(6) }), void 0), jsx(Text$1, Object.assign({ fontSize: 24, fontWeight: 500, color: "text1", style: { marginLeft: '10px' } }, { children: inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol }), void 0)] }, void 0), jsx(ArrowDown$1, { size: "16", color: theme.text2, style: { marginLeft: '4px', minWidth: '16px' } }, void 0), jsxs(TokenRow$1, { children: [jsx(CurrencyLogo, { currency: outputCurrency, size: 24, imageSize: 48 }, void 0), jsxs(Box, Object.assign({ display: "flex", alignItems: "center" }, { children: [jsx(Text$1, Object.assign({ fontSize: 24, fontWeight: 500, style: { marginLeft: '12px' }, color: 'text1' }, { children: outputAmount.toSignificant(6) }), void 0), jsx(FiatValue, { fiatValue: fiatValueOutput, priceImpact: computeFiatValuePriceImpact(fiatValueInput, fiatValueOutput) }, void 0)] }), void 0), jsx(Text$1, Object.assign({ fontSize: 24, fontWeight: 500, color: "text1", style: { marginLeft: '10px' } }, { children: outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol }), void 0)] }, void 0), showAcceptChanges , jsxs(Box, Object.assign({ mt: '30px', display: "flex", alignItems: "center", justifyContent: "space-between", onClick: flipPrice, style: { cursor: 'pointer' } }, { children: [jsx(Text$1, Object.assign({ color: 'text1', fontSize: 16 }, { children: "Limit Price" }), void 0), jsx(Text$1, Object.assign({ color: 'text1', fontSize: 16 }, { children: text }), void 0)] }), void 0), jsx(Box, Object.assign({ mt: '15px' }, { children: jsxs(Text$1, Object.assign({ color: 'text1', fontSize: 16 }, { children: ["Output will be sent to", ' ', jsx("b", Object.assign({ title: recipient || '' }, { children: isAddress(recipient || '') ? shortenAddress(recipient || '') : recipient || '' }), void 0)] }), void 0) }), void 0)] }, void 0), jsxs(Footer$1, { children: [jsx(LimitOrderDetailInfo, { trade: trade }, void 0), jsx(Box, Object.assign({ my: '10px' }, { children: jsx(Button, Object.assign({ variant: "primary", onClick: onConfirm, isDisabled: showAcceptChanges }, { children: "Confirm Order" }), void 0) }), void 0)] }, void 0)] }, void 0));
    const PendingContent = jsx(Loader, { size: 100, label: pendingText }, void 0);
    const ErroContent = (jsxs(ErrorWrapper$1, { children: [jsxs(ErrorBox$1, { children: [jsx(AlertTriangle$1, { color: theme.red1, style: { strokeWidth: 1.5 }, size: 64 }, void 0), jsx(Text$1, Object.assign({ fontWeight: 500, fontSize: 16, color: 'red1', style: { textAlign: 'center', width: '85%' } }, { children: swapErrorMessage }), void 0)] }, void 0), jsx(Button, Object.assign({ variant: "primary", onClick: onClose }, { children: "Dismiss" }), void 0)] }, void 0));
    const SubmittedContent = (jsxs(SubmittedWrapper$1, { children: [jsxs(Box, Object.assign({ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", paddingY: '20px' }, { children: [jsx(Box, Object.assign({ flex: "1", display: "flex", alignItems: "center" }, { children: jsx(ArrowUpCircle$1, { strokeWidth: 0.5, size: 90, color: theme.primary }, void 0) }), void 0), jsx(Text$1, Object.assign({ fontWeight: 500, fontSize: 20, color: "text1" }, { children: "Transaction Submitted" }), void 0), chainId && txHash && (jsx(Link$1, Object.assign({ as: "a", fontWeight: 500, fontSize: 14, color: 'primary', href: getEtherscanLink(chainId, txHash, 'transaction'), target: "_blank" }, { children: "View on the Snowtrace Explorer" }), void 0))] }), void 0), jsx(Button, Object.assign({ variant: "primary", onClick: onClose }, { children: "Close" }), void 0)] }, void 0));
    const getSwapError = () => {
        if (swapErrorMessage) {
            return ErroContent;
        }
        else if (txHash) {
            return SubmittedContent;
        }
        else if (attemptingTxn) {
            return PendingContent;
        }
        else {
            return ConfirmContent;
        }
    };
    return (jsx(Drawer, Object.assign({ title: swapErrorMessage || txHash || attemptingTxn ? '' : 'Confirm Order', isOpen: isOpen, onClose: onClose }, { children: getSwapError() }), void 0));
};

const SwapWrapper$2 = styled(Box) `
  width: 100%;
  /* min-width: 400px; */
  background-color: ${({ theme }) => theme.color2};
  position: relative;
  overflow: hidden;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;
styled(Box) `
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${({ theme }) => theme.venetianRed};
  padding: 7px;
  font-size: 12px;
  color: ${({ theme }) => theme.white};
`;

const TradeOption = ({ swapType, setSwapType, isLimitOrderVisible }) => {
    return (jsx(SwapWrapper$2, { children: jsx(Box, Object.assign({ p: 10 }, { children: jsxs(Box, Object.assign({ display: "flex", alignItems: "center", justifyContent: "space-between" }, { children: [jsx(Text$1, Object.assign({ color: "text1", fontSize: 24, fontWeight: 500 }, { children: "Trade" }), void 0), isLimitOrderVisible && (jsx(Box, Object.assign({ width: "130px" }, { children: jsx(ToggleButtons, { options: ['MARKET', 'LIMIT'], value: swapType, onChange: (value) => {
                                setSwapType(value);
                            } }, void 0) }), void 0))] }), void 0) }), void 0) }, void 0));
};

const WarningWrapper = styled.div `
  border-radius: 20px;
  border: 1px solid #f82d3a;
  background: rgba(248, 45, 58, 0.05);
  padding: 1rem;
  color: #f82d3a;
  position: relative;
  @media screen and (max-width: 800px) {
    width: 80% !important;
    margin-left: 5%;
  }
`;
const StyledWarningIcon$1 = styled(AlertTriangle$1) `
  min-height: 20px;
  min-width: 20px;
  stroke: red;
`;
const ConvertLink = styled.a `
  color: #ed147a;
  text-decoration: none;
`;
const AutoColumn$1 = styled.div `
  display: grid;
  grid-auto-rows: auto;
  grid-row-gap: '4px';
`;

function DeprecatedWarning() {
    return (jsx(WarningWrapper, { children: jsxs(AutoColumn$1, { children: [jsxs(Box, Object.assign({ display: "flex", alignItems: "center", width: "fit-content" }, { children: [jsx(StyledWarningIcon$1, {}, void 0), jsx(Text$1, Object.assign({ fontWeight: 600, ml: '10px', color: "text1" }, { children: "Old AEB tokens Alert" }), void 0)] }), void 0), jsxs(Text$1, Object.assign({ fontWeight: 500, mt: '10px', color: "text1" }, { children: ["Please note these tokens were used by the old AEB bridge and have been deprecated. If you still hold old AEB tokens, please convert them here", ' ', jsx(ConvertLink, Object.assign({ href: 'https://bridge.avax.network/convert', target: "_blank" }, { children: "https://bridge.avax.network/convert" }), void 0)] }), void 0)] }, void 0) }, void 0));
}

const Root$3 = styled(Box) `
  width: 100%;
  /* min-width: 360px; */
  position: relative;
  overflow: hidden;
`;
const SwapWrapper$1 = styled(Box) `
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  width: 100%;
  /* min-width: 360px; */
  background-color: ${({ theme }) => theme.bg2};
  position: relative;
  overflow: hidden;
`;
const CurrencyInputTextBox$1 = styled(CurrencyInput) `
  background-color: ${({ theme }) => theme.bg6};
  align-items: center;
  border-radius: 4px;
`;
const InputText = styled(TextInput) `
  background-color: ${({ theme }) => theme.bg6};
  align-items: center;
  border-radius: 4px;
`;
const ArrowWrapper$2 = styled.div `
  background-color: ${({ theme }) => theme.bg6};
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;
const PValue$2 = styled(Box) `
  margin-left: 10px;
  margin-right: 10px;
  align-items: center;
  display: flex;
  width: 100%;
  font-size: 16px;
  color: ${({ theme, isActive }) => (isActive ? theme.text1 : theme.text4)};
  border-bottom: ${({ theme, isActive }) => (isActive ? `1px solid ${theme.text1}` : 0)};
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.text1};
  }
`;

var Rate;
(function (Rate) {
    Rate["DIV"] = "DIV";
    Rate["MUL"] = "MUL";
})(Rate || (Rate = {}));
const LimitOrder = ({ swapType, setSwapType, isLimitOrderVisible }) => {
    var _a;
    const [isTokenDrawerOpen, setIsTokenDrawerOpen] = useState(false);
    const [selectedPercentage, setSelectedPercentage] = useState(0);
    const [tokenDrawerType, setTokenDrawerType] = useState(LimitNewField.INPUT);
    const [activeTab, setActiveTab] = useState('SELL');
    const { account } = usePangolinWeb3();
    const chainId = useChainId();
    const theme = useContext(Me);
    const percentageValue = [25, 50, 75, 100];
    const { handlers: { handleInput: onUserInput, handleRateType, handleCurrencySelection: onCurrencySelection, handleSwitchTokens: onSwitchTokens, handleLimitOrderSubmission, }, derivedOrderInfo: { parsedAmounts, currencies, currencyBalances, trade, formattedAmounts, inputError: swapInputError, rawAmounts, price, }, orderState: { independentField, rateType }, } = useGelatoLimitOrders();
    const { onCurrencySelection: onSwapCurrencySelection } = useSwapActionHandlers(chainId);
    // get custom setting values for user
    const [allowedSlippage] = useUserSlippageTolerance();
    const recipient = account !== null && account !== void 0 ? account : null;
    const isValid = !swapInputError;
    const gelatoInputCurrency = currencies[LimitField.INPUT];
    const gelatoOutputCurrency = currencies[LimitField.OUTPUT];
    const inputTokenInfo = gelatoInputCurrency === null || gelatoInputCurrency === void 0 ? void 0 : gelatoInputCurrency.tokenInfo;
    const outputTokenInfo = gelatoOutputCurrency === null || gelatoOutputCurrency === void 0 ? void 0 : gelatoOutputCurrency.tokenInfo;
    const getInputCurrency = () => {
        if (gelatoInputCurrency && (gelatoInputCurrency === null || gelatoInputCurrency === void 0 ? void 0 : gelatoInputCurrency.symbol) === CAVAX[chainId].symbol) {
            return CAVAX[chainId];
        }
        else if (inputTokenInfo && (inputTokenInfo === null || inputTokenInfo === void 0 ? void 0 : inputTokenInfo.symbol) === CAVAX[chainId].symbol) {
            return CAVAX[chainId];
        }
        else if (inputTokenInfo) {
            return new Token$2(inputTokenInfo === null || inputTokenInfo === void 0 ? void 0 : inputTokenInfo.chainId, inputTokenInfo === null || inputTokenInfo === void 0 ? void 0 : inputTokenInfo.address, inputTokenInfo === null || inputTokenInfo === void 0 ? void 0 : inputTokenInfo.decimals, inputTokenInfo === null || inputTokenInfo === void 0 ? void 0 : inputTokenInfo.symbol, inputTokenInfo === null || inputTokenInfo === void 0 ? void 0 : inputTokenInfo.name);
        }
        else if (gelatoInputCurrency && (gelatoInputCurrency === null || gelatoInputCurrency === void 0 ? void 0 : gelatoInputCurrency.isToken)) {
            return new Token$2(gelatoInputCurrency === null || gelatoInputCurrency === void 0 ? void 0 : gelatoInputCurrency.chainId, gelatoInputCurrency === null || gelatoInputCurrency === void 0 ? void 0 : gelatoInputCurrency.address, gelatoInputCurrency === null || gelatoInputCurrency === void 0 ? void 0 : gelatoInputCurrency.decimals, gelatoInputCurrency === null || gelatoInputCurrency === void 0 ? void 0 : gelatoInputCurrency.symbol, gelatoInputCurrency === null || gelatoInputCurrency === void 0 ? void 0 : gelatoInputCurrency.name);
        }
        else {
            return undefined;
        }
    };
    const getOutputCurrency = () => {
        if (gelatoOutputCurrency && (gelatoOutputCurrency === null || gelatoOutputCurrency === void 0 ? void 0 : gelatoOutputCurrency.symbol) === CAVAX[chainId].symbol) {
            return CAVAX[chainId];
        }
        else if (outputTokenInfo && (outputTokenInfo === null || outputTokenInfo === void 0 ? void 0 : outputTokenInfo.symbol) === CAVAX[chainId].symbol) {
            return CAVAX[chainId];
        }
        else if (outputTokenInfo) {
            return new Token$2(outputTokenInfo === null || outputTokenInfo === void 0 ? void 0 : outputTokenInfo.chainId, outputTokenInfo === null || outputTokenInfo === void 0 ? void 0 : outputTokenInfo.address, outputTokenInfo === null || outputTokenInfo === void 0 ? void 0 : outputTokenInfo.decimals, outputTokenInfo === null || outputTokenInfo === void 0 ? void 0 : outputTokenInfo.symbol, outputTokenInfo === null || outputTokenInfo === void 0 ? void 0 : outputTokenInfo.name);
        }
        else if (gelatoOutputCurrency && (gelatoOutputCurrency === null || gelatoOutputCurrency === void 0 ? void 0 : gelatoOutputCurrency.isToken)) {
            return new Token$2(gelatoOutputCurrency === null || gelatoOutputCurrency === void 0 ? void 0 : gelatoOutputCurrency.chainId, gelatoOutputCurrency === null || gelatoOutputCurrency === void 0 ? void 0 : gelatoOutputCurrency.address, gelatoOutputCurrency === null || gelatoOutputCurrency === void 0 ? void 0 : gelatoOutputCurrency.decimals, gelatoOutputCurrency === null || gelatoOutputCurrency === void 0 ? void 0 : gelatoOutputCurrency.symbol, gelatoOutputCurrency === null || gelatoOutputCurrency === void 0 ? void 0 : gelatoOutputCurrency.name);
        }
        else {
            return undefined;
        }
    };
    const handleActiveTab = (tab) => {
        if (activeTab === tab)
            return;
        handleRateType(rateType, price);
        setActiveTab(tab);
    };
    // toggle wallet when disconnected
    const toggleWalletModal = useWalletModalToggle();
    const handleTypeInput = useCallback((value) => {
        onUserInput(LimitNewField.INPUT, value);
    }, [onUserInput]);
    const handleTypeOutput = useCallback((value) => {
        onUserInput(LimitNewField.OUTPUT, value);
    }, [onUserInput]);
    // price
    const handleTypeDesiredRate = useCallback((value) => {
        onUserInput(LimitNewField.PRICE, value);
    }, [onUserInput]);
    // modal and loading
    const [{ showConfirm, tradeToConfirm, swapErrorMessage, attemptingTxn, txHash }, setSwapState] = useState({
        showConfirm: false,
        tradeToConfirm: undefined,
        attemptingTxn: false,
        swapErrorMessage: undefined,
        txHash: undefined,
    });
    const tradePrice = trade === null || trade === void 0 ? void 0 : trade.executionPrice;
    // check whether the user has approved the router on the input token
    const [approval, approveCallback] = useApproveCallbackFromInputCurrencyAmount(parsedAmounts.input);
    // check if user has gone through approval process, used to show two step buttons, reset on token change
    const [approvalSubmitted, setApprovalSubmitted] = useState(false);
    // mark when a user has submitted an approval, reset onTokenSelection for input field
    useEffect(() => {
        if (approval === ApprovalState.PENDING) {
            setApprovalSubmitted(true);
        }
    }, [approval, approvalSubmitted]);
    const maxAmountInput = galetoMaxAmountSpend(chainId, currencyBalances[LimitField.INPUT]);
    // for limit swap
    const handleSwap = useCallback(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!handleLimitOrderSubmission) {
            return;
        }
        setSwapState({
            attemptingTxn: true,
            tradeToConfirm,
            showConfirm,
            swapErrorMessage: undefined,
            txHash: undefined,
        });
        try {
            if (!((_a = currencies.input) === null || _a === void 0 ? void 0 : _a.wrapped.address)) {
                throw new Error('Invalid input currency');
            }
            if (!((_b = currencies.output) === null || _b === void 0 ? void 0 : _b.wrapped.address)) {
                throw new Error('Invalid output currency');
            }
            if (!rawAmounts.input) {
                throw new Error('Invalid input amount');
            }
            if (!rawAmounts.output) {
                throw new Error('Invalid output amount');
            }
            if (!account) {
                throw new Error('No account');
            }
            handleLimitOrderSubmission({
                inputToken: ((_c = currencies.input) === null || _c === void 0 ? void 0 : _c.isNative) ? NATIVE : (_d = currencies.input) === null || _d === void 0 ? void 0 : _d.wrapped.address,
                outputToken: ((_e = currencies.output) === null || _e === void 0 ? void 0 : _e.isNative) ? NATIVE : (_f = currencies.output) === null || _f === void 0 ? void 0 : _f.wrapped.address,
                inputAmount: rawAmounts.input,
                outputAmount: rawAmounts.output,
                owner: account,
            })
                .then(({ hash }) => {
                setSwapState({
                    attemptingTxn: false,
                    tradeToConfirm,
                    showConfirm,
                    swapErrorMessage: undefined,
                    txHash: hash,
                });
            })
                .catch((error) => {
                setSwapState({
                    attemptingTxn: false,
                    tradeToConfirm,
                    showConfirm,
                    swapErrorMessage: error.message,
                    txHash: undefined,
                });
                // we only care if the error is something _other_ than the user rejected the tx
                if ((error === null || error === void 0 ? void 0 : error.code) !== 4001) {
                    console.error(error);
                }
            });
        }
        catch (error) {
            setSwapState({
                attemptingTxn: false,
                tradeToConfirm,
                showConfirm,
                swapErrorMessage: error.message,
                txHash: undefined,
            });
            // we only care if the error is something _other_ than the user rejected the tx
            if (((_g = error) === null || _g === void 0 ? void 0 : _g.code) !== 4001) {
                console.error(error);
            }
        }
    }, [
        handleLimitOrderSubmission,
        tradeToConfirm,
        showConfirm,
        currencies.input,
        currencies.output,
        rawAmounts.input,
        rawAmounts.output,
        account,
    ]);
    const handleSelectTokenDrawerClose = useCallback(() => {
        setIsTokenDrawerOpen(false);
    }, [setIsTokenDrawerOpen]);
    // show approve flow when: no error on inputs, not approved or pending, or approved in current session
    // never show if price impact is above threshold in non expert mode
    const showApproveFlow = !swapInputError &&
        (approval === ApprovalState.NOT_APPROVED ||
            approval === ApprovalState.PENDING ||
            (approvalSubmitted && approval === ApprovalState.APPROVED));
    const handleConfirmDismiss = useCallback(() => {
        setSwapState({ showConfirm: false, tradeToConfirm, attemptingTxn, swapErrorMessage, txHash });
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onUserInput(LimitNewField.INPUT, '');
        }
    }, [attemptingTxn, onUserInput, swapErrorMessage, tradeToConfirm, txHash]);
    const handleAcceptChanges = useCallback(() => {
        setSwapState({ tradeToConfirm: trade, swapErrorMessage, txHash, attemptingTxn, showConfirm });
    }, [attemptingTxn, showConfirm, swapErrorMessage, trade, txHash]);
    const onCurrencySelect = useCallback((currency) => {
        if (tokenDrawerType === LimitNewField.INPUT) {
            setApprovalSubmitted(false); // reset 2 step UI for approvals
        }
        // here need to add isToken because in Galato hook require this variable to select currency
        const newCurrency = Object.assign({}, currency);
        if ((currency === null || currency === void 0 ? void 0 : currency.symbol) === CAVAX[chainId].symbol) {
            newCurrency.isNative = true;
        }
        else {
            newCurrency.isToken = true;
        }
        onCurrencySelection(tokenDrawerType, newCurrency);
        // this is to update tokens on chart on token selection
        onSwapCurrencySelection(tokenDrawerType, currency);
    }, [tokenDrawerType, onCurrencySelection, onSwapCurrencySelection]);
    const handleApprove = useCallback(() => __awaiter$a(void 0, void 0, void 0, function* () {
        yield approveCallback();
    }), [approveCallback]);
    const isAEBToken = useIsSelectedAEBToken();
    const handlePlaceOrder = () => {
        setSwapState({
            tradeToConfirm: trade,
            attemptingTxn: false,
            swapErrorMessage: undefined,
            showConfirm: true,
            txHash: undefined,
        });
    };
    const renderButton = () => {
        var _a;
        if (!account) {
            return (jsx(Button, Object.assign({ isDisabled: !account, variant: "primary", onClick: toggleWalletModal }, { children: "Connect Wallet" }), void 0));
        }
        if (showApproveFlow) {
            return (jsxs(Box, Object.assign({ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }, { children: [jsx(Box, Object.assign({ mr: "10px", width: "100%" }, { children: jsx(Button, Object.assign({ variant: approval === ApprovalState.APPROVED ? 'confirm' : 'primary', onClick: handleApprove, isDisabled: approval !== ApprovalState.NOT_APPROVED || approvalSubmitted, loading: approval === ApprovalState.PENDING, loadingText: "Approving" }, { children: approvalSubmitted && approval === ApprovalState.APPROVED
                                ? 'Approved'
                                : 'Approve' + ((_a = currencies[LimitField.INPUT]) === null || _a === void 0 ? void 0 : _a.symbol) }), void 0) }), void 0), jsx(Button, Object.assign({ variant: "primary", onClick: () => handlePlaceOrder(), id: "swap-button", isDisabled: !isValid || approval !== ApprovalState.APPROVED }, { children: "Place Order" }), void 0)] }), void 0));
        }
        return (jsx(Button, Object.assign({ variant: "primary", onClick: () => handlePlaceOrder(), id: "swap-button", isDisabled: !isValid || !!swapInputError, backgroundColor: isValid ? 'primary' : undefined }, { children: swapInputError ? swapInputError : 'Place Order' }), void 0));
    };
    const renderPercentage = () => {
        return (jsx(Box, Object.assign({ display: "flex", pb: "5px" }, { children: percentageValue.map((value, index) => (jsxs(PValue$2, Object.assign({ isActive: selectedPercentage === value, onClick: () => {
                    var _a;
                    setSelectedPercentage(value);
                    if (maxAmountInput) {
                        const multipyAmount = JSBI$1.multiply(maxAmountInput === null || maxAmountInput === void 0 ? void 0 : maxAmountInput.numerator, JSBI$1.BigInt(value)); //Currency from uniswap sdk-core not contain raw function
                        const divideAmount = JSBI$1.divide(multipyAmount, JSBI$1.BigInt(100));
                        const token = wrappedGelatoCurrency((_a = maxAmountInput === null || maxAmountInput === void 0 ? void 0 : maxAmountInput.currency) !== null && _a !== void 0 ? _a : undefined, chainId);
                        const newFinalAmount = new TokenAmount(token, divideAmount);
                        onUserInput(LimitNewField.INPUT, newFinalAmount.toExact());
                    }
                } }, { children: [value, "%"] }), index))) }), void 0));
    };
    const determineColor = () => {
        if (currencies.input && currencies.output) {
            return theme.text1;
        }
        else
            return theme.text4;
    };
    const inputCurrency = getInputCurrency();
    const outputCurrency = getOutputCurrency();
    return (jsxs(Root$3, { children: [jsx(TradeOption, { swapType: swapType, setSwapType: setSwapType, isLimitOrderVisible: isLimitOrderVisible }, void 0), jsxs(SwapWrapper$1, { children: [jsx(Box, Object.assign({ width: "100%", display: "flex", "justify-content": "center" }, { children: jsx(Box, Object.assign({ textAlign: "center", width: "120px" }, { children: jsx(ToggleButtons, { options: ['SELL', 'BUY'], value: activeTab, onChange: (value) => {
                                    handleActiveTab(value);
                                } }, void 0) }), void 0) }), void 0), jsxs(Box, Object.assign({ p: 10 }, { children: [isAEBToken && jsx(DeprecatedWarning, {}, void 0), jsx(CurrencyInputTextBox$1, { label: independentField === LimitNewField.OUTPUT && trade ? 'From (estimated)' : 'From', value: formattedAmounts[LimitField.INPUT], onChange: (value) => {
                                    setSelectedPercentage(0);
                                    handleTypeInput(value);
                                }, onTokenClick: () => {
                                    setTokenDrawerType(LimitNewField.INPUT);
                                    setIsTokenDrawerOpen(true);
                                }, currency: inputCurrency, fontSize: 24, isNumeric: true, placeholder: "0.00", id: "swap-currency-input", addonLabel: renderPercentage() }, void 0), jsx(Box, Object.assign({ width: "100%", textAlign: "center", alignItems: "center", display: "flex", justifyContent: 'center', mt: 10 }, { children: jsx(ArrowWrapper$2, { children: rateType === Rate.MUL ? (jsx(X$1, { size: "16", color: determineColor() }, void 0)) : (jsx(Divide$1, { size: "16", color: determineColor() }, void 0)) }, void 0) }), void 0), jsx(Box, { children: jsx(InputText, { value: formattedAmounts[LimitField.PRICE], onChange: (value) => handleTypeDesiredRate(value), fontSize: 24, isNumeric: true, placeholder: "0.00", label: "Price" }, void 0) }, void 0), jsx(Box, Object.assign({ width: "100%", textAlign: "center", alignItems: "center", display: "flex", justifyContent: 'center', mt: 10 }, { children: jsx(ArrowWrapper$2, Object.assign({ onClick: () => {
                                        setApprovalSubmitted(false); // reset 2 step UI for approvals
                                        onSwitchTokens();
                                    } }, { children: jsx(RefreshCcw$1, { size: "16", color: theme.text4 }, void 0) }), void 0) }), void 0), jsx(CurrencyInputTextBox$1, { label: independentField === LimitNewField.INPUT && trade ? 'To (estimated)' : 'To', value: formattedAmounts[LimitField.OUTPUT], onChange: (value) => {
                                    setSelectedPercentage(0);
                                    handleTypeOutput(value);
                                }, onTokenClick: () => {
                                    setTokenDrawerType(LimitNewField.OUTPUT);
                                    setIsTokenDrawerOpen(true);
                                }, currency: outputCurrency, fontSize: 24, isNumeric: true, placeholder: "0.00", id: "swap-currency-output", addonLabel: tradePrice && (jsxs(Text$1, Object.assign({ color: "text4", fontSize: 16 }, { children: ["Price: ", tradePrice === null || tradePrice === void 0 ? void 0 : tradePrice.toSignificant(6), " ", (_a = tradePrice === null || tradePrice === void 0 ? void 0 : tradePrice.quoteCurrency) === null || _a === void 0 ? void 0 : _a.symbol] }), void 0)) }, void 0), trade && jsx(LimitOrderDetailInfo, { trade: trade }, void 0), jsx(Box, Object.assign({ width: "100%", mt: 10 }, { children: renderButton() }), void 0)] }), void 0)] }, void 0), jsx(SelectTokenDrawer$1, { isOpen: isTokenDrawerOpen, onClose: handleSelectTokenDrawerClose, onCurrencySelect: onCurrencySelect, selectedCurrency: tokenDrawerType === LimitNewField.INPUT ? inputCurrency : outputCurrency, otherSelectedCurrency: tokenDrawerType === LimitNewField.INPUT ? outputCurrency : inputCurrency }, void 0), trade && (jsx(ConfirmLimitOrderDrawer, { isOpen: showConfirm, trade: trade, originalTrade: tradeToConfirm, onAcceptChanges: handleAcceptChanges, attemptingTxn: attemptingTxn, txHash: txHash, recipient: recipient, allowedSlippage: allowedSlippage, onConfirm: handleSwap, swapErrorMessage: swapErrorMessage, onClose: handleConfirmDismiss }, void 0))] }, void 0));
};

/**
 * Given a name or address, does a lookup to resolve to an address and name
 * @param nameOrAddress ENS name or address
 */
function useENS(nameOrAddress) {
    const validated = isAddress(nameOrAddress);
    return {
        loading: false,
        address: validated ? validated : null,
        name: null,
    };
}

/**
 * Returns true if the string value is zero in hex
 * @param hexNumberString
 */
function isZero(hexNumberString) {
    return /^0x0*$/.test(hexNumberString);
}

const version$3 = "bignumber/5.6.0";

var BN = BN$3.BN;
const logger = new Logger$1(version$3);
const _constructorGuard = {};
const MAX_SAFE = 0x1fffffffffffff;
// Only warn about passing 10 into radix once
let _warnedToStringRadix = false;
class BigNumber {
    constructor(constructorGuard, hex) {
        logger.checkNew(new.target, BigNumber);
        if (constructorGuard !== _constructorGuard) {
            logger.throwError("cannot call constructor directly; use BigNumber.from", Logger$1.errors.UNSUPPORTED_OPERATION, {
                operation: "new (BigNumber)"
            });
        }
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return toBigNumber(toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return toBigNumber(toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") {
            return BigNumber.from(this._hex.substring(1));
        }
        return this;
    }
    add(other) {
        return toBigNumber(toBN(this).add(toBN(other)));
    }
    sub(other) {
        return toBigNumber(toBN(this).sub(toBN(other)));
    }
    div(other) {
        const o = BigNumber.from(other);
        if (o.isZero()) {
            throwFault("division-by-zero", "div");
        }
        return toBigNumber(toBN(this).div(toBN(other)));
    }
    mul(other) {
        return toBigNumber(toBN(this).mul(toBN(other)));
    }
    mod(other) {
        const value = toBN(other);
        if (value.isNeg()) {
            throwFault("division-by-zero", "mod");
        }
        return toBigNumber(toBN(this).umod(value));
    }
    pow(other) {
        const value = toBN(other);
        if (value.isNeg()) {
            throwFault("negative-power", "pow");
        }
        return toBigNumber(toBN(this).pow(value));
    }
    and(other) {
        const value = toBN(other);
        if (this.isNegative() || value.isNeg()) {
            throwFault("unbound-bitwise-result", "and");
        }
        return toBigNumber(toBN(this).and(value));
    }
    or(other) {
        const value = toBN(other);
        if (this.isNegative() || value.isNeg()) {
            throwFault("unbound-bitwise-result", "or");
        }
        return toBigNumber(toBN(this).or(value));
    }
    xor(other) {
        const value = toBN(other);
        if (this.isNegative() || value.isNeg()) {
            throwFault("unbound-bitwise-result", "xor");
        }
        return toBigNumber(toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) {
            throwFault("negative-width", "mask");
        }
        return toBigNumber(toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) {
            throwFault("negative-width", "shl");
        }
        return toBigNumber(toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) {
            throwFault("negative-width", "shr");
        }
        return toBigNumber(toBN(this).shrn(value));
    }
    eq(other) {
        return toBN(this).eq(toBN(other));
    }
    lt(other) {
        return toBN(this).lt(toBN(other));
    }
    lte(other) {
        return toBN(this).lte(toBN(other));
    }
    gt(other) {
        return toBN(this).gt(toBN(other));
    }
    gte(other) {
        return toBN(this).gte(toBN(other));
    }
    isNegative() {
        return (this._hex[0] === "-");
    }
    isZero() {
        return toBN(this).isZero();
    }
    toNumber() {
        try {
            return toBN(this).toNumber();
        }
        catch (error) {
            throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        }
        catch (e) { }
        return logger.throwError("this platform does not support BigInt", Logger$1.errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!_warnedToStringRadix) {
                    _warnedToStringRadix = true;
                    logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            }
            else if (arguments[0] === 16) {
                logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", Logger$1.errors.UNEXPECTED_ARGUMENT, {});
            }
            else {
                logger.throwError("BigNumber.toString does not accept parameters", Logger$1.errors.UNEXPECTED_ARGUMENT, {});
            }
        }
        return toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return { type: "BigNumber", hex: this.toHexString() };
    }
    static from(value) {
        if (value instanceof BigNumber) {
            return value;
        }
        if (typeof (value) === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) {
                return new BigNumber(_constructorGuard, toHex$1(value));
            }
            if (value.match(/^-?[0-9]+$/)) {
                return new BigNumber(_constructorGuard, toHex$1(new BN(value)));
            }
            return logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof (value) === "number") {
            if (value % 1) {
                throwFault("underflow", "BigNumber.from", value);
            }
            if (value >= MAX_SAFE || value <= -MAX_SAFE) {
                throwFault("overflow", "BigNumber.from", value);
            }
            return BigNumber.from(String(value));
        }
        const anyValue = value;
        if (typeof (anyValue) === "bigint") {
            return BigNumber.from(anyValue.toString());
        }
        if (isBytes$1(anyValue)) {
            return BigNumber.from(hexlify(anyValue));
        }
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof (hex) === "string") {
                    return BigNumber.from(hex);
                }
            }
            else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") {
                    hex = anyValue.hex;
                }
                if (typeof (hex) === "string") {
                    if (isHexString$1(hex) || (hex[0] === "-" && isHexString$1(hex.substring(1)))) {
                        return BigNumber.from(hex);
                    }
                }
            }
        }
        return logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function toHex$1(value) {
    // For BN, call on the hex string
    if (typeof (value) !== "string") {
        return toHex$1(value.toString(16));
    }
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") {
            logger.throwArgumentError("invalid hex", "value", value);
        }
        // Call toHex on the positive component
        value = toHex$1(value);
        // Do not allow "-0x00"
        if (value === "0x00") {
            return value;
        }
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") {
        value = "0x" + value;
    }
    // Normalize zero
    if (value === "0x") {
        return "0x00";
    }
    // Make the string even length
    if (value.length % 2) {
        value = "0x0" + value.substring(2);
    }
    // Trim to smallest even-length string
    while (value.length > 4 && value.substring(0, 4) === "0x00") {
        value = "0x" + value.substring(4);
    }
    return value;
}
function toBigNumber(value) {
    return BigNumber.from(toHex$1(value));
}
function toBN(value) {
    const hex = BigNumber.from(value).toHexString();
    if (hex[0] === "-") {
        return (new BN("-" + hex.substring(3), 16));
    }
    return new BN(hex.substring(2), 16);
}
function throwFault(fault, operation, value) {
    const params = { fault: fault, operation: operation };
    if (value != null) {
        params.value = value;
    }
    return logger.throwError(fault, Logger$1.errors.NUMERIC_FAULT, params);
}

const version$2 = "ethers/5.6.4";

new Logger$1(version$2);

// combines the current timestamp with the user setting to give the deadline that should be used for any submitted transaction
function useTransactionDeadline() {
    const ttl = useSelector((state) => state.puser.userDeadline);
    const currentTimestampSeconds = BigNumber.from(Math.ceil(Date.now() / 1000));
    return ttl ? currentTimestampSeconds.add(ttl) : undefined;
}

var SwapCallbackState;
(function (SwapCallbackState) {
    SwapCallbackState[SwapCallbackState["INVALID"] = 0] = "INVALID";
    SwapCallbackState[SwapCallbackState["LOADING"] = 1] = "LOADING";
    SwapCallbackState[SwapCallbackState["VALID"] = 2] = "VALID";
})(SwapCallbackState || (SwapCallbackState = {}));
/**
 * Returns the swap calls that can be used to make the trade
 * @param trade trade to execute
 * @param allowedSlippage user allowed slippage
 * @param recipientAddressOrName
 */
function useSwapCallArguments(trade, // trade to execute, required
allowedSlippage = INITIAL_ALLOWED_SLIPPAGE, // in bips
recipientAddressOrName) {
    const { account, chainId, library } = usePangolinWeb3();
    const { address: recipientAddress } = useENS(recipientAddressOrName);
    const recipient = recipientAddressOrName === null ? account : recipientAddress;
    let deadline = useTransactionDeadline();
    const currentTime = BigNumber$1.from(new Date().getTime());
    if (deadline && deadline < currentTime.add(10)) {
        deadline = currentTime.add(10);
    }
    return useMemo(() => {
        const tradeVersion = Version.v2;
        if (!trade || !recipient || !library || !account || !tradeVersion || !chainId || !deadline)
            return [];
        const contract = getRouterContract(chainId, library, account);
        if (!contract) {
            return [];
        }
        const swapMethods = [];
        swapMethods.push(Router.swapCallParameters(trade, {
            feeOnTransfer: false,
            allowedSlippage: new Percent$1(JSBI$1.BigInt(allowedSlippage), BIPS_BASE),
            recipient,
            deadline: deadline.toNumber(),
        }));
        if (trade.tradeType === TradeType$1.EXACT_INPUT) {
            swapMethods.push(Router.swapCallParameters(trade, {
                feeOnTransfer: true,
                allowedSlippage: new Percent$1(JSBI$1.BigInt(allowedSlippage), BIPS_BASE),
                recipient,
                deadline: deadline.toNumber(),
            }));
        }
        return swapMethods.map((parameters) => ({ parameters, contract }));
    }, [account, allowedSlippage, chainId, deadline, library, recipient, trade]);
}
// returns a function that will execute a swap, if the parameters are all valid
// and the user has approved the slippage adjusted input amount for the trade
function useSwapCallback(trade, // trade to execute, required
allowedSlippage = INITIAL_ALLOWED_SLIPPAGE, // in bips
recipientAddressOrName) {
    const { account, chainId, library } = usePangolinWeb3();
    const swapCalls = useSwapCallArguments(trade, allowedSlippage, recipientAddressOrName);
    const addTransaction = useTransactionAdder();
    const { address: recipientAddress } = useENS(recipientAddressOrName);
    const recipient = recipientAddressOrName === null ? account : recipientAddress;
    return useMemo(() => {
        if (!trade || !library || !account || !chainId) {
            return { state: SwapCallbackState.INVALID, callback: null, error: 'Missing dependencies' };
        }
        if (!recipient) {
            if (recipientAddressOrName !== null) {
                return { state: SwapCallbackState.INVALID, callback: null, error: 'Invalid recipient' };
            }
            else {
                return { state: SwapCallbackState.LOADING, callback: null, error: null };
            }
        }
        const tradeVersion = Version.v2;
        return {
            state: SwapCallbackState.VALID,
            callback: function onSwap() {
                return __awaiter$a(this, void 0, void 0, function* () {
                    const estimatedCalls = yield Promise.all(swapCalls.map((call) => {
                        const { parameters: { methodName, args, value }, contract, } = call;
                        const options = !value || isZero(value) ? {} : { value };
                        return contract.estimateGas[methodName](...args, options)
                            .then((gasEstimate) => {
                            return {
                                call,
                                gasEstimate,
                            };
                        })
                            .catch((gasError) => {
                            console.debug('Gas estimate failed, trying eth_call to extract error', call);
                            return contract.callStatic[methodName](...args, options)
                                .then((result) => {
                                console.debug('Unexpected successful call after failed estimate gas', call, gasError, result);
                                return { call, error: new Error('Unexpected issue with estimating the gas. Please try again.') };
                            })
                                .catch((callError) => {
                                console.debug('Call threw error', call, callError);
                                let errorMessage;
                                switch (callError.reason) {
                                    case 'PangolinRouter: INSUFFICIENT_OUTPUT_AMOUNT':
                                    case 'PangolinRouter: EXCESSIVE_INPUT_AMOUNT':
                                        errorMessage =
                                            'This transaction will not succeed either due to price movement or fee on transfer. Try increasing your slippage tolerance.';
                                        break;
                                    default:
                                        errorMessage = `The transaction cannot succeed due to error: ${callError.reason}. This is probably an issue with one of the tokens you are swapping.`;
                                }
                                return { call, error: new Error(errorMessage) };
                            });
                        });
                    }));
                    // a successful estimation is a bignumber gas estimate and the next call is also a bignumber gas estimate
                    const successfulEstimation = estimatedCalls.find((el, ix, list) => 'gasEstimate' in el && (ix === list.length - 1 || 'gasEstimate' in list[ix + 1]));
                    if (!successfulEstimation) {
                        const errorCalls = estimatedCalls.filter((call) => 'error' in call);
                        if (errorCalls.length > 0)
                            throw errorCalls[errorCalls.length - 1].error;
                        throw new Error('Unexpected error. Please contact support: none of the calls threw an error');
                    }
                    const { call: { contract, parameters: { methodName, args, value }, }, gasEstimate, } = successfulEstimation;
                    return contract[methodName](...args, Object.assign({ gasLimit: calculateGasMargin(gasEstimate) }, (value && !isZero(value) ? { value, from: account } : { from: account })))
                        .then((response) => {
                        const inputSymbol = trade.inputAmount.currency.symbol;
                        const outputSymbol = trade.outputAmount.currency.symbol;
                        const inputAmount = trade.inputAmount.toSignificant(3);
                        const outputAmount = trade.outputAmount.toSignificant(3);
                        const base = `Swap ${inputAmount} ${inputSymbol} for ${outputAmount} ${outputSymbol}`;
                        const withRecipient = recipient === account
                            ? base
                            : `${base} to ${recipientAddressOrName && isAddress(recipientAddressOrName)
                                ? shortenAddress(recipientAddressOrName)
                                : recipientAddressOrName}`;
                        const withVersion = tradeVersion === Version.v2
                            ? withRecipient
                            : `${withRecipient} on ${tradeVersion.toUpperCase()}`;
                        addTransaction(response, {
                            summary: withVersion,
                        });
                        return response.hash;
                    })
                        .catch((error) => {
                        // if the user rejected the tx, pass this along
                        if ((error === null || error === void 0 ? void 0 : error.code) === 4001) {
                            throw new Error('Transaction rejected.');
                        }
                        else {
                            // otherwise, the error was unexpected and we need to convey that
                            console.error(`Swap failed`, error, methodName, args, value);
                            throw new Error(`Swap failed: ${error.message}`);
                        }
                    });
                });
            },
            error: null,
        };
    }, [trade, library, account, chainId, recipient, recipientAddressOrName, swapCalls, addTransaction]);
}

var WrapType;
(function (WrapType) {
    WrapType[WrapType["NOT_APPLICABLE"] = 0] = "NOT_APPLICABLE";
    WrapType[WrapType["WRAP"] = 1] = "WRAP";
    WrapType[WrapType["UNWRAP"] = 2] = "UNWRAP";
})(WrapType || (WrapType = {}));
const NOT_APPLICABLE = { wrapType: WrapType.NOT_APPLICABLE };
/**
 * Given the selected input and output currency, return a wrap callback
 * @param inputCurrency the selected input currency
 * @param outputCurrency the selected output currency
 * @param typedValue the user input value
 */
function useWrapCallback(inputCurrency, outputCurrency, typedValue) {
    const { account } = usePangolinWeb3();
    const chainId = useChainId();
    const wethContract = useWETHContract();
    const balance = useCurrencyBalance(chainId, account !== null && account !== void 0 ? account : undefined, inputCurrency);
    // we can always parse the amount typed as the input currency, since wrapping is 1:1
    const inputAmount = useMemo(() => tryParseAmount(typedValue, inputCurrency), [inputCurrency, typedValue]);
    const addTransaction = useTransactionAdder();
    return useMemo(() => {
        if (!wethContract || !chainId || !inputCurrency || !outputCurrency)
            return NOT_APPLICABLE;
        const sufficientBalance = inputAmount && balance && !balance.lessThan(inputAmount);
        if (inputCurrency === CAVAX[chainId] && currencyEquals(WAVAX[chainId], outputCurrency)) {
            return {
                wrapType: WrapType.WRAP,
                execute: sufficientBalance && inputAmount
                    ? () => __awaiter$a(this, void 0, void 0, function* () {
                        try {
                            const txReceipt = yield wethContract.deposit({ value: `0x${inputAmount.raw.toString(16)}` });
                            addTransaction(txReceipt, { summary: `Wrap ${inputAmount.toSignificant(6)} AVAX to WAVAX` });
                        }
                        catch (error) {
                            console.error('Could not deposit', error);
                        }
                    })
                    : undefined,
                inputError: sufficientBalance ? undefined : 'Insufficient AVAX balance',
            };
        }
        else if (currencyEquals(WAVAX[chainId], inputCurrency) && outputCurrency === CAVAX[chainId]) {
            return {
                wrapType: WrapType.UNWRAP,
                execute: sufficientBalance && inputAmount
                    ? () => __awaiter$a(this, void 0, void 0, function* () {
                        try {
                            const txReceipt = yield wethContract.withdraw(`0x${inputAmount.raw.toString(16)}`);
                            addTransaction(txReceipt, { summary: `Unwrap ${inputAmount.toSignificant(6)} WAVAX to AVAX` });
                        }
                        catch (error) {
                            console.error('Could not withdraw', error);
                        }
                    })
                    : undefined,
                inputError: sufficientBalance ? undefined : 'Insufficient WAVAX balance',
            };
        }
        else {
            return NOT_APPLICABLE;
        }
    }, [wethContract, chainId, inputCurrency, outputCurrency, inputAmount, balance, addTransaction]);
}

const ContentBox = styled(Box) `
  background-color: ${({ theme }) => theme.bg6};
  padding: 15px;
  border-radius: 8px;
  margin-top: 10px;
`;
const DataBox = styled(Box) `
  align-items: center;
  justify-content: space-between;
  display: flex;
  margin: 5px 0px 5px 0px;
`;
const ValueText = styled(Text$1) `
  color: ${({ theme, severity }) => severity === 3 || severity === 4
    ? theme.red1
    : severity === 2
        ? theme.yellow2
        : severity === 1
            ? theme.text1
            : severity === 0
                ? theme.green1
                : theme.text4};
`;

const SwapDetailInfo = ({ trade }) => {
    var _a, _b, _c, _d;
    const [allowedSlippage] = useUserSlippageTolerance();
    const { priceImpactWithoutFee, realizedLPFee } = computeTradePriceBreakdown(trade);
    const isExactIn = trade.tradeType === TradeType$1.EXACT_INPUT;
    const slippageAdjustedAmounts = computeSlippageAdjustedAmounts(trade, allowedSlippage);
    const amount = isExactIn
        ? (_b = `${(_a = slippageAdjustedAmounts[Field.OUTPUT]) === null || _a === void 0 ? void 0 : _a.toSignificant(4)} ${trade.outputAmount.currency.symbol}`) !== null && _b !== void 0 ? _b : '-'
        : (_d = `${(_c = slippageAdjustedAmounts[Field.INPUT]) === null || _c === void 0 ? void 0 : _c.toSignificant(4)} ${trade.inputAmount.currency.symbol}`) !== null && _d !== void 0 ? _d : '-';
    const priceImpact = priceImpactWithoutFee
        ? priceImpactWithoutFee.lessThan(ONE_BIPS)
            ? '<0.01%'
            : `${priceImpactWithoutFee.toFixed(2)}%`
        : '-';
    const lpFee = realizedLPFee ? `${realizedLPFee.toSignificant(4)} ${trade.inputAmount.currency.symbol}` : '-';
    const renderRow = (label, value, showSeverity) => {
        return (jsxs(DataBox, { children: [jsx(Text$1, Object.assign({ color: "text4", fontSize: 14 }, { children: label }), void 0), jsx(ValueText, Object.assign({ fontSize: 14, severity: showSeverity ? warningSeverity(priceImpactWithoutFee) : -1 }, { children: value }), void 0)] }, label));
    };
    return (jsxs(ContentBox, { children: [allowedSlippage !== INITIAL_ALLOWED_SLIPPAGE && renderRow('Slippage tolerance', `${allowedSlippage / 100}%`), renderRow(isExactIn ? 'Minimum Received' : 'Maximum Sold', amount), renderRow('Price Impact', priceImpact, true), renderRow('Liquidity Provider Fee', lpFee)] }, void 0));
};

const Root$2 = styled(Box) `
  display: grid;
  grid-template-rows: auto max-content;
  height: 100%;
`;
const Header = styled(Box) `
  padding: 0px 10px;
`;
const TokenRow = styled(Box) `
  display: grid;
  grid-template-columns: max-content auto max-content;
  align-items: center;
`;
const PriceUpdateBlock = styled(Box) `
  padding: 10px;
  background-color: ${({ theme }) => theme.bg6};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  margin-top: 15px;
`;
const OutputText = styled(Text$1) `
  width: 100%;
  font-style: italic;
  font-size: 12px;
  text-align: left;
`;
const Footer = styled(Box) `
  padding: 0px 10px;
`;
const ErrorWrapper = styled(Box) `
  display: grid;
  grid-template-rows: minmax(300px, auto) max-content;
  height: 100%;
  padding: 10px;
`;
const ErrorBox = styled(Box) `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const SubmittedWrapper = styled(Box) `
  display: grid;
  grid-template-rows: minmax(300px, auto) max-content;
  height: 100%;
  padding: 10px;
`;
const Link = styled(Text$1) `
  text-decoration: none;
  color: ${({ theme }) => theme.blue1};
`;

const ConfirmSwapDrawer = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { isOpen, onClose, trade, originalTrade, allowedSlippage, onAcceptChanges, onConfirm, attemptingTxn, swapErrorMessage, txHash, recipient, } = props;
    const { chainId } = usePangolinWeb3();
    const theme = useContext(Me);
    const slippageAdjustedAmounts = useMemo(() => computeSlippageAdjustedAmounts(trade, allowedSlippage), [trade, allowedSlippage]);
    const { priceImpactWithoutFee } = useMemo(() => computeTradePriceBreakdown(trade), [trade]);
    const priceImpactSeverity = warningSeverity(priceImpactWithoutFee);
    const showAcceptChanges = useMemo(() => Boolean(trade && originalTrade && tradeMeaningfullyDiffers(trade, originalTrade)), [originalTrade, trade]);
    // text to show while loading
    const pendingText = `Swapping ${(_a = trade === null || trade === void 0 ? void 0 : trade.inputAmount) === null || _a === void 0 ? void 0 : _a.toSignificant(6)} ${(_c = (_b = trade === null || trade === void 0 ? void 0 : trade.inputAmount) === null || _b === void 0 ? void 0 : _b.currency) === null || _c === void 0 ? void 0 : _c.symbol} for ${(_d = trade === null || trade === void 0 ? void 0 : trade.outputAmount) === null || _d === void 0 ? void 0 : _d.toSignificant(6)} ${(_f = (_e = trade === null || trade === void 0 ? void 0 : trade.outputAmount) === null || _e === void 0 ? void 0 : _e.currency) === null || _f === void 0 ? void 0 : _f.symbol}`;
    const ConfirmContent = (jsxs(Root$2, { children: [jsxs(Header, { children: [jsxs(TokenRow, { children: [jsx(CurrencyLogo, { currency: trade.inputAmount.currency, size: 24, imageSize: 48 }, void 0), jsx(Text$1, Object.assign({ fontSize: 24, fontWeight: 500, color: showAcceptChanges && trade.tradeType === TradeType$1.EXACT_OUTPUT ? 'primary' : 'text1', style: { marginLeft: '12px' } }, { children: trade.inputAmount.toSignificant(6) }), void 0), jsx(Text$1, Object.assign({ fontSize: 24, fontWeight: 500, color: "text1", style: { marginLeft: '10px' } }, { children: trade.inputAmount.currency.symbol }), void 0)] }, void 0), jsx(ArrowDown$1, { size: "16", color: theme.text2, style: { marginLeft: '4px', minWidth: '16px' } }, void 0), jsxs(TokenRow, { children: [jsx(CurrencyLogo, { currency: trade.outputAmount.currency, size: 24, imageSize: 48 }, void 0), jsx(Text$1, Object.assign({ fontSize: 24, fontWeight: 500, style: { marginLeft: '12px' }, color: priceImpactSeverity > 2
                                    ? 'red1'
                                    : showAcceptChanges && trade.tradeType === TradeType$1.EXACT_INPUT
                                        ? 'primary'
                                        : 'text1' }, { children: trade.outputAmount.toSignificant(6) }), void 0), jsx(Text$1, Object.assign({ fontSize: 24, fontWeight: 500, color: "text1", style: { marginLeft: '10px' } }, { children: trade.outputAmount.currency.symbol }), void 0)] }, void 0), showAcceptChanges && (jsxs(PriceUpdateBlock, { children: [jsx(Text$1, Object.assign({ color: 'text1', fontSize: 14 }, { children: "Price Updated" }), void 0), jsx(Button, Object.assign({ onClick: onAcceptChanges, variant: "primary", width: 150, padding: "5px 10px" }, { children: "Accept" }), void 0)] }, void 0)), jsx(Box, Object.assign({ mt: '15px' }, { children: trade.tradeType === TradeType$1.EXACT_INPUT ? (jsxs(OutputText, Object.assign({ color: "text2" }, { children: ["Output is estimated. You will receive at least", jsxs("b", { children: [(_g = slippageAdjustedAmounts[Field.OUTPUT]) === null || _g === void 0 ? void 0 : _g.toSignificant(6), " ", trade.outputAmount.currency.symbol] }, void 0), "or the transaction will revert."] }), void 0)) : (jsxs(OutputText, Object.assign({ color: "text2" }, { children: ["Input is estimated. You will sell at most", jsxs("b", { children: [(_h = slippageAdjustedAmounts[Field.INPUT]) === null || _h === void 0 ? void 0 : _h.toSignificant(6), " ", trade.inputAmount.currency.symbol] }, void 0), "or the transaction will revert."] }), void 0)) }), void 0), recipient && jsxs(OutputText, Object.assign({ color: "text1" }, { children: ["Sending to: ", recipient] }), void 0)] }, void 0), jsxs(Footer, { children: [jsx(SwapDetailInfo, { trade: trade }, void 0), jsx(Box, Object.assign({ my: '10px' }, { children: jsx(Button, Object.assign({ variant: "primary", onClick: onConfirm, isDisabled: showAcceptChanges }, { children: priceImpactSeverity > 2 ? 'Swap Anyway' : 'Confirm Swap' }), void 0) }), void 0)] }, void 0)] }, void 0));
    const PendingContent = jsx(Loader, { size: 100, label: pendingText }, void 0);
    const ErroContent = (jsxs(ErrorWrapper, { children: [jsxs(ErrorBox, { children: [jsx(AlertTriangle$1, { color: theme.red1, style: { strokeWidth: 1.5 }, size: 64 }, void 0), jsx(Text$1, Object.assign({ fontWeight: 500, fontSize: 16, color: 'red1', style: { textAlign: 'center', width: '85%' } }, { children: swapErrorMessage }), void 0)] }, void 0), jsx(Button, Object.assign({ variant: "primary", onClick: onClose }, { children: "Dismiss" }), void 0)] }, void 0));
    const SubmittedContent = (jsxs(SubmittedWrapper, { children: [jsxs(Box, Object.assign({ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", paddingY: '20px' }, { children: [jsx(Box, Object.assign({ flex: "1", display: "flex", alignItems: "center" }, { children: jsx(ArrowUpCircle$1, { strokeWidth: 0.5, size: 90, color: theme.primary }, void 0) }), void 0), jsx(Text$1, Object.assign({ fontWeight: 500, fontSize: 20, color: "text1" }, { children: "Transaction Submitted" }), void 0), chainId && txHash && (jsx(Link, Object.assign({ as: "a", fontWeight: 500, fontSize: 14, color: 'primary', href: getEtherscanLink(chainId, txHash, 'transaction') }, { children: "View on the Snowtrace Explorer" }), void 0))] }), void 0), jsx(Button, Object.assign({ variant: "primary", onClick: onClose }, { children: "Close" }), void 0)] }, void 0));
    return (jsx(Drawer, Object.assign({ title: swapErrorMessage || txHash || attemptingTxn ? '' : 'Confirm Swap', isOpen: isOpen, onClose: onClose }, { children: swapErrorMessage ? ErroContent : txHash ? SubmittedContent : attemptingTxn ? PendingContent : ConfirmContent }), void 0));
};

const PValue$1 = styled(Box) `
  margin-left: 3px;
  margin-right: 3px;
  align-items: center;
  display: flex;
  width: 100%;
  font-size: 12px;
  padding: 5px;
  color: ${({ theme }) => theme.text1};
  background-color: ${({ theme, isActive }) => (isActive ? theme.primary : theme.color5)};
  border: ${({ theme, isActive }) => (isActive ? 0 : `1px solid ${theme.text1}`)};
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  justify-content: center;
`;

const NumberOptions = (props) => {
    const { options = [25, 50, 75, 100], isPercentage = false, onChange, currentValue, isDisabled, variant } = props;
    return (jsxs(Box, { children: [variant === 'step' && (jsxs(Steps, Object.assign({ onChange: (value) => {
                    onChange && onChange(value);
                }, current: currentValue, progressDot: true }, { children: [jsx(Step$1, { disabled: isDisabled }, void 0), jsx(Step$1, { disabled: isDisabled }, void 0), jsx(Step$1, { disabled: isDisabled }, void 0), jsx(Step$1, { disabled: isDisabled }, void 0), jsx(Step$1, { disabled: isDisabled }, void 0)] }), void 0)), variant === 'box' && (jsx(Box, Object.assign({ display: "flex", pb: "5px" }, { children: options.map((value, index) => (jsx(PValue$1, Object.assign({ isActive: currentValue === value, onClick: () => {
                        onChange && onChange(value);
                    } }, { children: isPercentage ? `${value}%` : value }), index))) }), void 0))] }, void 0));
};

var propTypes$1 = {exports: {}};

var reactIs$3 = {exports: {}};

var reactIs_production_min$3 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$3="function"===typeof Symbol&&Symbol.for,c$4=b$3?Symbol.for("react.element"):60103,d$3=b$3?Symbol.for("react.portal"):60106,e$3=b$3?Symbol.for("react.fragment"):60107,f$3=b$3?Symbol.for("react.strict_mode"):60108,g$3=b$3?Symbol.for("react.profiler"):60114,h$3=b$3?Symbol.for("react.provider"):60109,k$4=b$3?Symbol.for("react.context"):60110,l$3=b$3?Symbol.for("react.async_mode"):60111,m$3=b$3?Symbol.for("react.concurrent_mode"):60111,n$3=b$3?Symbol.for("react.forward_ref"):60112,p$3=b$3?Symbol.for("react.suspense"):60113,q$3=b$3?
Symbol.for("react.suspense_list"):60120,r$2=b$3?Symbol.for("react.memo"):60115,t$3=b$3?Symbol.for("react.lazy"):60116,v$3=b$3?Symbol.for("react.block"):60121,w$2=b$3?Symbol.for("react.fundamental"):60117,x$3=b$3?Symbol.for("react.responder"):60118,y$3=b$3?Symbol.for("react.scope"):60119;
function z$2(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$4:switch(a=a.type,a){case l$3:case m$3:case e$3:case g$3:case f$3:case p$3:return a;default:switch(a=a&&a.$$typeof,a){case k$4:case n$3:case t$3:case r$2:case h$3:return a;default:return u}}case d$3:return u}}}function A$2(a){return z$2(a)===m$3}reactIs_production_min$3.AsyncMode=l$3;reactIs_production_min$3.ConcurrentMode=m$3;reactIs_production_min$3.ContextConsumer=k$4;reactIs_production_min$3.ContextProvider=h$3;reactIs_production_min$3.Element=c$4;reactIs_production_min$3.ForwardRef=n$3;reactIs_production_min$3.Fragment=e$3;reactIs_production_min$3.Lazy=t$3;reactIs_production_min$3.Memo=r$2;reactIs_production_min$3.Portal=d$3;
reactIs_production_min$3.Profiler=g$3;reactIs_production_min$3.StrictMode=f$3;reactIs_production_min$3.Suspense=p$3;reactIs_production_min$3.isAsyncMode=function(a){return A$2(a)||z$2(a)===l$3};reactIs_production_min$3.isConcurrentMode=A$2;reactIs_production_min$3.isContextConsumer=function(a){return z$2(a)===k$4};reactIs_production_min$3.isContextProvider=function(a){return z$2(a)===h$3};reactIs_production_min$3.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$4};reactIs_production_min$3.isForwardRef=function(a){return z$2(a)===n$3};reactIs_production_min$3.isFragment=function(a){return z$2(a)===e$3};reactIs_production_min$3.isLazy=function(a){return z$2(a)===t$3};
reactIs_production_min$3.isMemo=function(a){return z$2(a)===r$2};reactIs_production_min$3.isPortal=function(a){return z$2(a)===d$3};reactIs_production_min$3.isProfiler=function(a){return z$2(a)===g$3};reactIs_production_min$3.isStrictMode=function(a){return z$2(a)===f$3};reactIs_production_min$3.isSuspense=function(a){return z$2(a)===p$3};
reactIs_production_min$3.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$3||a===m$3||a===g$3||a===f$3||a===p$3||a===q$3||"object"===typeof a&&null!==a&&(a.$$typeof===t$3||a.$$typeof===r$2||a.$$typeof===h$3||a.$$typeof===k$4||a.$$typeof===n$3||a.$$typeof===w$2||a.$$typeof===x$3||a.$$typeof===y$3||a.$$typeof===v$3)};reactIs_production_min$3.typeOf=z$2;

var reactIs_development$3 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$3.AsyncMode = AsyncMode;
reactIs_development$3.ConcurrentMode = ConcurrentMode;
reactIs_development$3.ContextConsumer = ContextConsumer;
reactIs_development$3.ContextProvider = ContextProvider;
reactIs_development$3.Element = Element;
reactIs_development$3.ForwardRef = ForwardRef;
reactIs_development$3.Fragment = Fragment;
reactIs_development$3.Lazy = Lazy;
reactIs_development$3.Memo = Memo;
reactIs_development$3.Portal = Portal;
reactIs_development$3.Profiler = Profiler;
reactIs_development$3.StrictMode = StrictMode;
reactIs_development$3.Suspense = Suspense;
reactIs_development$3.isAsyncMode = isAsyncMode;
reactIs_development$3.isConcurrentMode = isConcurrentMode;
reactIs_development$3.isContextConsumer = isContextConsumer;
reactIs_development$3.isContextProvider = isContextProvider;
reactIs_development$3.isElement = isElement;
reactIs_development$3.isForwardRef = isForwardRef;
reactIs_development$3.isFragment = isFragment;
reactIs_development$3.isLazy = isLazy;
reactIs_development$3.isMemo = isMemo;
reactIs_development$3.isPortal = isPortal;
reactIs_development$3.isProfiler = isProfiler;
reactIs_development$3.isStrictMode = isStrictMode;
reactIs_development$3.isSuspense = isSuspense;
reactIs_development$3.isValidElementType = isValidElementType;
reactIs_development$3.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$3.exports = reactIs_production_min$3;
} else {
  reactIs$3.exports = reactIs_development$3;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$7 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1$1 = ReactPropTypesSecret$7;

var has$5 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$3 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$6 = ReactPropTypesSecret_1$1;
  var loggedTypeFailures$1 = {};
  var has$4 = has$5;

  printWarning$3 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$3(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$4(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$6);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$3(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures$1)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures$1[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$3(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$3.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures$1 = {};
  }
};

var checkPropTypes_1$1 = checkPropTypes$3;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$4 = reactIs$3.exports;
var assign$2 = objectAssign;

var ReactPropTypesSecret$5 = ReactPropTypesSecret_1$1;
var has$3 = has$5;
var checkPropTypes$2 = checkPropTypes_1$1;

var printWarning$2 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$2 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull$1() {
  return null;
}

var factoryWithTypeCheckers$1 = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$5) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$2(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull$1);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$5);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$4.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$2(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$2('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull$1;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$3(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$5);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$2('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull$1;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$2(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull$1;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$5);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$3(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$5);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign$2({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$3(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$5);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes$2;
  ReactPropTypes.resetWarningCache = checkPropTypes$2.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$4 = ReactPropTypesSecret_1$1;

function emptyFunction$1() {}
function emptyFunctionWithReset$1() {}
emptyFunctionWithReset$1.resetWarningCache = emptyFunction$1;

var factoryWithThrowingShims$1 = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$4) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset$1,
    resetWarningCache: emptyFunction$1
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs$3 = reactIs$3.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess$1 = true;
  propTypes$1.exports = factoryWithTypeCheckers$1(ReactIs$3.isElement, throwOnDirectAccess$1);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$1.exports = factoryWithThrowingShims$1();
}

var PropTypes = propTypes$1.exports;

var canUseDOM$1 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var _createClass$r = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$q(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$o(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$o(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal$3 = function (_React$Component) {
  _inherits$o(Portal, _React$Component);

  function Portal() {
    _classCallCheck$q(this, Portal);

    return _possibleConstructorReturn$o(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass$r(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!canUseDOM$1) {
        return null;
      }
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }
      return ReactDOM.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);

  return Portal;
}(React$2.Component);

Portal$3.propTypes = {
  children: PropTypes.node.isRequired,
  node: PropTypes.any
};

var _createClass$q = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$p(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$n(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$n(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal$2 = function (_React$Component) {
  _inherits$n(Portal, _React$Component);

  function Portal() {
    _classCallCheck$p(this, Portal);

    return _possibleConstructorReturn$n(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass$q(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPortal();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(props) {
      this.renderPortal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      ReactDOM.unmountComponentAtNode(this.defaultNode || this.props.node);
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
      this.portal = null;
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      var children = this.props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof this.props.children.type === 'function') {
        children = React$2.cloneElement(this.props.children);
      }

      this.portal = ReactDOM.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(React$2.Component);


Portal$2.propTypes = {
  children: PropTypes.node.isRequired,
  node: PropTypes.any
};

var Portal = void 0;

if (ReactDOM.createPortal) {
  Portal = Portal$3;
} else {
  Portal = Portal$2;
}

var Portal$1 = Portal;

var _createClass$p = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$o(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$m(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$m(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYCODES = {
  ESCAPE: 27
};

var PortalWithState = function (_React$Component) {
  _inherits$m(PortalWithState, _React$Component);

  function PortalWithState(props) {
    _classCallCheck$o(this, PortalWithState);

    var _this = _possibleConstructorReturn$m(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));

    _this.portalNode = null;
    _this.state = { active: !!props.defaultOpen };
    _this.openPortal = _this.openPortal.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    return _this;
  }

  _createClass$p(PortalWithState, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.addEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'openPortal',
    value: function openPortal(e) {
      if (this.state.active) {
        return;
      }
      if (e && e.nativeEvent) {
        e.nativeEvent.stopImmediatePropagation();
      }
      this.setState({ active: true }, this.props.onOpen);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      if (!this.state.active) {
        return;
      }
      this.setState({ active: false }, this.props.onClose);
    }
  }, {
    key: 'wrapWithPortal',
    value: function wrapWithPortal(children) {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }
      return React$2.createElement(
        Portal$1,
        {
          node: this.props.node,
          key: 'react-portal',
          ref: function ref(portalNode) {
            return _this2.portalNode = portalNode;
          }
        },
        children
      );
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }
      var root = this.portalNode && (this.portalNode.props.node || this.portalNode.defaultNode);
      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        openPortal: this.openPortal,
        closePortal: this.closePortal,
        portal: this.wrapWithPortal,
        isOpen: this.state.active
      });
    }
  }]);

  return PortalWithState;
}(React$2.Component);

PortalWithState.propTypes = {
  children: PropTypes.func.isRequired,
  defaultOpen: PropTypes.bool,
  node: PropTypes.any,
  closeOnEsc: PropTypes.bool,
  closeOnOutsideClick: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};

PortalWithState.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};

function useOnClickOutside(node, handler) {
    const handlerRef = useRef(handler);
    useEffect(() => {
        handlerRef.current = handler;
    }, [handler]);
    useEffect(() => {
        const handleClickOutside = (e) => {
            var _a, _b;
            if ((_b = (_a = node.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) !== null && _b !== void 0 ? _b : false) {
                return;
            }
            if (handlerRef.current)
                handlerRef.current();
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [node]);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StyledDialogOverlay = styled.div `
  z-index: 999;
  background-color: transparent;
  overflow: hidden;
  display: ${({ isOpen }) => (!isOpen ? 'none' : 'flex')};
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background-color: ${({ theme, background }) => (background ? background : theme.modalBG)};
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Container = styled.div `
  background: ${({ theme }) => theme.bg8};
  border-radius: 10px;
  ${({ theme }) => theme.mediaWidth.upToSmall `
    border-radius: 0px;
    width: 100%;
    height: 100%;
  `};
`;
function Modal({ isOpen, onDismiss, children, overlayBG }) {
    const node = useRef();
    const handleClose = useCallback(() => {
        onDismiss();
    }, [onDismiss]);
    useOnClickOutside(node, isOpen ? handleClose : undefined);
    return (jsx(Portal$1, { children: jsx(StyledDialogOverlay, Object.assign({ isOpen: isOpen, background: overlayBG }, { children: isOpen && jsx(Container, Object.assign({ ref: node }, { children: children }), void 0) }), void 0) }, void 0));
}

const SettingsText = styled(Text$1) `
  font-size: 16px;
  color: ${({ theme }) => theme.text1};

  &: hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
const Frame$2 = styled(Box) `
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: 100%;
  padding: 10px;
`;
const InputOptions = styled(Box) `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;
const WarningButton = styled(Button) `
  background-color: ${({ theme }) => theme.red1};
  color: white;
`;
const Close = styled(Button) `
  position: absolute;
  top: 15px;
  right: 15px;
  color: ${({ theme }) => theme.text1};
  width: 30px;
  height: 30px;
`;
const ModalFrame = styled(Box) `
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: justify;
  position: relative;

  width: 25vw;

  ${({ theme }) => theme.mediaWidth.upToSmall `
    width: 100% !important;
  `};

  ${({ theme }) => theme.mediaWidth.upToMedium `
    width: 50vw;
  `};
`;

const WarningModal = ({ isOpen, close, setExpertMode }) => {
    const confirmAction = () => {
        const text = prompt('Please type the word "confirm" to enable expert mode.');
        if (text === 'confirm') {
            setExpertMode(true);
            close();
        }
    };
    return (jsx(Modal, Object.assign({ isOpen: isOpen, onDismiss: close }, { children: jsxs(ModalFrame, { children: [jsx(Close, Object.assign({ variant: "plain", onClick: close }, { children: jsx(X$1, { size: 28 }, void 0) }), void 0), jsx(Text$1, Object.assign({ fontSize: 28, fontWeight: 800, color: "text1" }, { children: "Are you sure?" }), void 0), jsxs(Box, Object.assign({ marginTop: 20 }, { children: [jsx(Text$1, Object.assign({ color: "text1" }, { children: "Expert mode turns off the confirm transaction prompt and allows high slippage trades that often result in bad rates and lost funds." }), void 0), jsx(Text$1, Object.assign({ color: "text1", fontWeight: 800, fontSize: 20, marginTop: 20, marginBottom: 40 }, { children: "ONLY USE THIS MODE IF YOU KNOW WHAT YOU ARE DOING." }), void 0), jsx(WarningButton, Object.assign({ variant: "primary", onClick: confirmAction }, { children: "Turn on expert mode" }), void 0)] }), void 0)] }, void 0) }), void 0));
};

const SwapSettingsDrawer = ({ isOpen, close }) => {
    const theme = useContext(Me);
    const [userExpertMode, setUserExpertMode] = useExpertModeManager();
    const [userslippage, setUserSlippageTolerance] = useUserSlippageTolerance();
    const [userDeadline, setUserDeadline] = useUserDeadline();
    const [deadline, setDeadline] = useState(userDeadline);
    const [expertMode, setExpertMode] = useState(userExpertMode);
    const [slippageTolerance, setSlippageTolerance] = useState((userslippage / 100).toString());
    const [isValidValues, setValidValues] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const save = useCallback(() => {
        if (deadline.length == 0) {
            setUserDeadline(DEFAULT_DEADLINE_FROM_NOW);
        }
        else {
            setUserDeadline(deadline);
        }
        setUserExpertMode(expertMode);
        if (slippageTolerance.length == 0) {
            setUserSlippageTolerance(0);
        }
        else {
            let slippageToleranceNumber = parseFloat(slippageTolerance);
            if (!expertMode && slippageToleranceNumber > 50) {
                setUserSlippageTolerance(5000);
            }
            else {
                if (slippageToleranceNumber > 100) {
                    slippageToleranceNumber = 100;
                }
                setUserSlippageTolerance(Math.ceil(slippageToleranceNumber * 100));
            }
        }
        close();
    }, [deadline, expertMode, slippageTolerance]);
    useEffect(() => {
        const slippageToleranceNumber = parseFloat(slippageTolerance);
        if (slippageTolerance.length == 0) {
            setValidValues(false);
        }
        else if (!expertMode && slippageToleranceNumber > 50) {
            setValidValues(false);
        }
        else if (slippageToleranceNumber > 100 || slippageToleranceNumber <= 0) {
            setValidValues(false);
        }
        else {
            setValidValues(true);
        }
    }, [expertMode, slippageTolerance]);
    return (jsxs(Drawer, Object.assign({ title: "Settings", isOpen: isOpen, onClose: close }, { children: [jsx(WarningModal, { isOpen: modalOpen, close: () => setModalOpen(false), setExpertMode: setExpertMode }, void 0), jsxs(Frame$2, { children: [jsxs(Box, Object.assign({ height: "90px" }, { children: [jsx(Text$1, Object.assign({ color: "text1" }, { children: "Slippage" }), void 0), jsxs(InputOptions, { children: [jsx(TextInput, { value: slippageTolerance, addonAfter: jsx(Box, Object.assign({ bgColor: "bg2", paddingX: "10px", paddingY: "4px", borderRadius: 4 }, { children: jsx(Text$1, Object.assign({ color: "text4" }, { children: "Percent" }), void 0) }), void 0), isNumeric: true, placeholder: "1", onChange: (value) => {
                                            setSlippageTolerance(value);
                                        } }, void 0), jsx(NumberOptions, { options: [0.1, 0.5, 1], isPercentage: true, currentValue: parseFloat(slippageTolerance), variant: "box", onChange: (number) => setSlippageTolerance(number.toString()), isDisabled: false }, void 0)] }, void 0), Number(slippageTolerance) <= 0.1 && (jsx(Text$1, Object.assign({ color: "text1", fontSize: 12, marginBottom: 10 }, { children: "Your transaction may fail" }), void 0)), Number(slippageTolerance) > 50 && !expertMode ? (jsx(Text$1, Object.assign({ color: "text12", fontSize: "10px", marginBottom: 10 }, { children: "Very high slippage, activate expert mode to be able to use more than 50%" }), void 0)) : (Number(slippageTolerance) > 5 && (jsx(Text$1, Object.assign({ color: "yellow2", fontSize: 12, marginBottom: 10 }, { children: "Your transaction may be frontrun" }), void 0)))] }), void 0), jsxs(Box, Object.assign({ height: "90px" }, { children: [jsx(Text$1, Object.assign({ color: "text1" }, { children: "Time Limit" }), void 0), jsxs(InputOptions, { children: [jsx(TextInput, { value: deadline, addonAfter: jsx(Box, Object.assign({ bgColor: "bg2", paddingX: "8px", paddingY: "4px", borderRadius: 4 }, { children: jsx(Text$1, Object.assign({ color: "text4" }, { children: "Seconds" }), void 0) }), void 0), isNumeric: true, placeholder: "10", onChange: (number) => setDeadline(number.toString()) }, void 0), jsx(NumberOptions, { options: [60, 300, 600], currentValue: parseInt(deadline), variant: "box", onChange: (number) => setDeadline(number.toString()), isDisabled: false }, void 0)] }, void 0), Number(deadline) <= 1 && (jsxs(Text$1, Object.assign({ color: "text1", fontSize: 12, marginBottom: 10 }, { children: [' ', "Your transaction may fail"] }), void 0))] }), void 0), jsxs(Box, Object.assign({ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", style: { gap: '15px' } }, { children: [jsx(Text$1, Object.assign({ color: "text1" }, { children: "Toogle Expert Mode" }), void 0), jsx(Box, Object.assign({ width: "120px" }, { children: jsx(ToggleButtons, { options: ['ON', 'OFF'], value: expertMode ? 'ON' : 'OFF', onChange: (value) => {
                                        if (value === 'ON' && !expertMode) {
                                            setModalOpen(true);
                                        }
                                        else if (value === 'OFF' && expertMode) {
                                            setExpertMode(false);
                                        }
                                    } }, void 0) }), void 0)] }), void 0), jsxs(Box, Object.assign({ display: "flex", flexDirection: "column", alignContent: "center", style: { gap: '10px' } }, { children: [jsx(Button, Object.assign({ variant: "primary", onClick: save, isDisabled: !isValidValues }, { children: "Save & Close" }), void 0), jsx(Button, Object.assign({ variant: "plain", backgroundColor: theme.bg6, onClick: close, color: "text1" }, { children: "Close" }), void 0)] }), void 0)] }, void 0)] }), void 0));
};

const SwapRouteWrapper = styled(Box) `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  margin: 0px auto;
  background-color: ${({ theme }) => theme.bg2};
  padding: 10px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  justify-content: center;
`;

const SwapRoute = ({ trade }) => {
    const theme = useContext(Me);
    return (jsx(SwapRouteWrapper, { children: trade.route.path.map((token, i, path) => {
            const isLastItem = i === path.length - 1;
            return (jsxs(Box, Object.assign({ display: "flex", alignItems: "center" }, { children: [jsxs(Box, Object.assign({ display: "flex", alignItems: "center", my: '5px' }, { children: [jsx(CurrencyLogo, { currency: token, size: 24 }, void 0), jsx(Box, Object.assign({ ml: '10px' }, { children: jsx(Text$1, Object.assign({ fontSize: 14, color: 'text1' }, { children: token.symbol }), void 0) }), void 0)] }), void 0), isLastItem ? null : jsx(ChevronRight$1, { color: theme.text2 }, void 0)] }), i));
        }) }, void 0));
};

const Wrapper$2 = styled.div `
  background: ${({ theme }) => curriedTransparentize(0.6, theme.bg3)};
  padding: 0.75rem;
  border-radius: 20px;
`;
const WarningContainer = styled.div `
  max-width: 420px;
  width: 100%;
  padding: 1rem;
  background: rgba(242, 150, 2, 0.05);
  border: 1px solid #f3841e;
  border-radius: 20px;
  overflow: auto;
`;
const StyledWarningIcon = styled(AlertTriangle$1) `
  stroke: ${({ theme }) => theme.red2};
`;
const AutoColumn = styled.div `
  display: grid;
  grid-auto-rows: auto;
  grid-row-gap: ${({ gap }) => (gap === 'sm' && '8px') || (gap === 'md' && '12px') || (gap === 'lg' && '24px') || gap};
  justify-items: ${({ justify }) => justify && justify};
`;

function TokenWarningCard({ token }) {
    var _a, _b, _c, _d;
    const { chainId } = usePangolinWeb3();
    const tokenSymbol = (_b = (_a = token === null || token === void 0 ? void 0 : token.symbol) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
    const tokenName = (_d = (_c = token === null || token === void 0 ? void 0 : token.name) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : '';
    const allTokens = useAllTokens();
    const duplicateNameOrSymbol = useMemo(() => {
        if (!token || !chainId)
            return false;
        return Object.keys(allTokens).some((tokenAddress) => {
            var _a, _b;
            const userToken = allTokens[tokenAddress];
            if (userToken.equals(token)) {
                return false;
            }
            return ((_a = userToken.symbol) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === tokenSymbol || ((_b = userToken.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === tokenName;
        });
    }, [token, chainId, allTokens, tokenSymbol, tokenName]);
    if (!token)
        return null;
    return (jsx(Wrapper$2, Object.assign({ error: duplicateNameOrSymbol }, { children: jsxs(Box, Object.assign({ display: "flex", alignItems: "center", width: "100%", flexWrap: "wrap", margin: "-6px" }, { children: [jsxs(AutoColumn, Object.assign({ gap: "24px" }, { children: [jsx(CurrencyLogo, { currency: token, size: 24, imageSize: 48 }, void 0), jsx("div", { children: " " }, void 0)] }), void 0), jsxs(AutoColumn, Object.assign({ gap: "10px", justify: "flex-start" }, { children: [jsxs(Text$1, Object.assign({ fontWeight: 500, fontSize: 20, color: 'text2' }, { children: [token && token.name && token.symbol && token.name !== token.symbol
                                    ? `${token.name} (${token.symbol})`
                                    : token.name || token.symbol, ' '] }), void 0), chainId && (jsx(ExternalLink, Object.assign({ style: { fontWeight: 400 }, href: getEtherscanLink(chainId, token.address, 'token') }, { children: jsxs(Text$1, Object.assign({ fontWeight: 500, color: 'primary', fontSize: 16 }, { children: [shortenAddress(token.address), " (View on the Snowtrace Explorer)"] }), void 0) }), void 0))] }), void 0)] }), void 0) }), void 0));
}
function TokenWarningModal({ isOpen, tokens, onConfirm, }) {
    const [understandChecked, setUnderstandChecked] = useState(false);
    const toggleUnderstand = useCallback(() => setUnderstandChecked((uc) => !uc), []);
    const handleDismiss = useCallback(() => null, []);
    return (jsx(Modal, Object.assign({ isOpen: isOpen, onDismiss: handleDismiss }, { children: jsx(WarningContainer, Object.assign({ className: "token-warning-container" }, { children: jsxs(AutoColumn, Object.assign({ gap: "lg" }, { children: [jsxs(Box, Object.assign({ display: "flex", alignItems: "center", width: "100%", flexWrap: "wrap", margin: "-6px" }, { children: [jsx(StyledWarningIcon, {}, void 0), jsx(Text$1, Object.assign({ fontWeight: 500, fontSize: 20, color: 'red2' }, { children: "Token imported" }), void 0)] }), void 0), jsxs(Text$1, Object.assign({ color: 'red2', fontSize: 16 }, { children: ["Anyone can create an ERC-20 token on Avalanche with ", jsx("em", { children: "any" }, void 0), " name, including creating fake versions of existing tokens and tokens that claim to represent projects that do not have a token."] }), void 0), jsx(Text$1, Object.assign({ color: 'red2', fontSize: 16 }, { children: "This interface can load arbitrary tokens by token addresses. Please take extra caution and do your research when interacting with arbitrary ERC-20 tokens." }), void 0), jsxs(Text$1, Object.assign({ color: 'red2', fontSize: 16 }, { children: ["If you purchase an arbitrary token, ", jsx("strong", { children: "you may be unable to sell it back." }, void 0)] }), void 0), tokens.map((token) => {
                        return jsx(TokenWarningCard, { token: token }, token.address);
                    }), jsxs(Box, Object.assign({ display: "flex", alignItems: "center", width: "100%", justifyContent: "space-between" }, { children: [jsx("div", { children: jsxs("label", Object.assign({ style: { cursor: 'pointer', userSelect: 'none' } }, { children: [jsx("input", { type: "checkbox", className: "understand-checkbox", checked: understandChecked, onChange: toggleUnderstand }, void 0), ' ', "I understand"] }), void 0) }, void 0), jsx(Button, Object.assign({ isDisabled: !understandChecked, variant: "primary", width: '140px', padding: "0.5rem 1rem", onClick: () => {
                                    onConfirm();
                                } }, { children: "Continue" }), void 0)] }), void 0)] }), void 0) }), void 0) }), void 0));
}

/**
 * Given the price impact, get user confirmation.
 *
 * @param priceImpactWithoutFee price impact of the trade without the fee.
 */
function confirmPriceImpactWithoutFee(priceImpactWithoutFee) {
    if (!priceImpactWithoutFee.lessThan(PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN)) {
        return (window.prompt(`This swap has a price impact of at least ${PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN.toFixed(0)}%. Please type the word "confirm" to continue with this swap`) === 'confirm');
    }
    else if (!priceImpactWithoutFee.lessThan(ALLOWED_PRICE_IMPACT_HIGH)) {
        return window.confirm(`This swap has a price impact of at least ${ALLOWED_PRICE_IMPACT_HIGH.toFixed(0)} %. Please confirm that you would like to continue with this swap.`);
    }
    return true;
}

const Root$1 = styled(Box) `
  width: 100%;
  /* min-width: 360px; */
  position: relative;
  overflow: hidden;
`;
const SwapWrapper = styled(Box) `
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  width: 100%;
  /* min-width: 360px; */
  background-color: ${({ theme }) => theme.bg2};
  position: relative;
  overflow: hidden;
`;
const CurrencyInputTextBox = styled(CurrencyInput) `
  background-color: ${({ theme }) => theme.bg6};
  align-items: center;
  border-radius: 4px;
`;
const ArrowWrapper$1 = styled.div `
  background-color: ${({ theme }) => theme.bg6};
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;
const PValue = styled(Box) `
  margin-left: 10px;
  margin-right: 10px;
  align-items: center;
  display: flex;
  width: 100%;
  font-size: 16px;
  color: ${({ theme, isActive }) => (isActive ? theme.text1 : theme.text4)};
  border-bottom: ${({ theme, isActive }) => (isActive ? `1px solid ${theme.text1}` : 0)};
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.text1};
  }
`;
const LinkStyledButton = styled.button `
  border: none;
  text-decoration: none;
  background: none;

  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  color: ${({ theme, disabled }) => (disabled ? theme.text2 : theme.text1)};
  font-weight: 500;

  :hover {
    text-decoration: ${({ disabled }) => (disabled ? null : 'underline')};
  }

  :focus {
    outline: none;
    text-decoration: ${({ disabled }) => (disabled ? null : 'underline')};
  }

  :active {
    text-decoration: none;
  }
`;

const MarketOrder = ({ swapType, setSwapType, isLimitOrderVisible, showSettings }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    // const [isRetryDrawerOpen, setIsRetryDrawerOpen] = useState(false);
    const [isTokenDrawerOpen, setIsTokenDrawerOpen] = useState(false);
    const [openSettings, setOpenSettings] = useState(false);
    const [selectedPercentage, setSelectedPercentage] = useState(0);
    const [tokenDrawerType, setTokenDrawerType] = useState(Field.INPUT);
    const percentageValue = [25, 50, 75, 100];
    const loadedUrlParams = useDefaultsFromURLSearch();
    // token warning stuff
    const [loadedInputCurrency, loadedOutputCurrency] = [
        useCurrency(loadedUrlParams === null || loadedUrlParams === void 0 ? void 0 : loadedUrlParams.inputCurrencyId),
        useCurrency(loadedUrlParams === null || loadedUrlParams === void 0 ? void 0 : loadedUrlParams.outputCurrencyId),
    ];
    const [dismissTokenWarning, setDismissTokenWarning] = useState(false);
    const urlLoadedTokens = useMemo(() => { var _a, _b; return (_b = (_a = [loadedInputCurrency, loadedOutputCurrency]) === null || _a === void 0 ? void 0 : _a.filter((c) => c instanceof Token$2)) !== null && _b !== void 0 ? _b : []; }, [loadedInputCurrency, loadedOutputCurrency]);
    const handleConfirmTokenWarning = useCallback(() => {
        setDismissTokenWarning(true);
    }, []);
    const { account } = usePangolinWeb3();
    const chainId = useChainId();
    const theme = useContext(Me);
    // toggle wallet when disconnected
    const toggleWalletModal = useWalletModalToggle();
    // for expert mode
    // const toggleSettings = useToggleSettingsMenu()
    const [isExpertMode] = useExpertModeManager();
    // get custom setting values for user
    const [allowedSlippage] = useUserSlippageTolerance();
    // swap state
    const { independentField, typedValue, recipient } = useSwapState();
    const { v1Trade, v2Trade, currencyBalances, parsedAmount, currencies, inputError: swapInputError, } = useDerivedSwapInfo();
    const { wrapType, execute: onWrap, inputError: wrapInputError, } = useWrapCallback(currencies[Field.INPUT], currencies[Field.OUTPUT], typedValue);
    const showWrap = wrapType !== WrapType.NOT_APPLICABLE;
    const { address: recipientAddress } = useENS(recipient);
    const toggledVersion = useToggledVersion();
    const tradesByVersion = {
        [Version.v1]: v1Trade,
        [Version.v2]: v2Trade,
    };
    const trade = showWrap ? undefined : tradesByVersion[toggledVersion];
    // const defaultTrade = showWrap ? undefined : tradesByVersion[DEFAULT_VERSION]
    // const betterTradeLinkVersion: Version | undefined = undefined
    const parsedAmounts = showWrap
        ? {
            [Field.INPUT]: parsedAmount,
            [Field.OUTPUT]: parsedAmount,
        }
        : {
            [Field.INPUT]: independentField === Field.INPUT ? parsedAmount : trade === null || trade === void 0 ? void 0 : trade.inputAmount,
            [Field.OUTPUT]: independentField === Field.OUTPUT ? parsedAmount : trade === null || trade === void 0 ? void 0 : trade.outputAmount,
        };
    const { onSwitchTokens, onCurrencySelection, onUserInput, onChangeRecipient } = useSwapActionHandlers(chainId);
    const isValid = !swapInputError;
    const dependentField = independentField === Field.INPUT ? Field.OUTPUT : Field.INPUT;
    const inputCurrency = currencies[Field.INPUT];
    const outputCurrency = currencies[Field.OUTPUT];
    const handleTypeInput = useCallback((value) => {
        onUserInput(Field.INPUT, value);
    }, [onUserInput]);
    const handleTypeOutput = useCallback((value) => {
        onUserInput(Field.OUTPUT, value);
    }, [onUserInput]);
    // modal and loading
    const [{ showConfirm, tradeToConfirm, swapErrorMessage, attemptingTxn, txHash }, setSwapState] = useState({
        showConfirm: false,
        tradeToConfirm: undefined,
        attemptingTxn: false,
        swapErrorMessage: undefined,
        txHash: undefined,
    });
    const formattedAmounts = {
        [independentField]: typedValue,
        [dependentField]: showWrap
            ? (_b = (_a = parsedAmounts[independentField]) === null || _a === void 0 ? void 0 : _a.toExact()) !== null && _b !== void 0 ? _b : ''
            : (_d = (_c = parsedAmounts[dependentField]) === null || _c === void 0 ? void 0 : _c.toSignificant(6)) !== null && _d !== void 0 ? _d : '',
    };
    const route = trade === null || trade === void 0 ? void 0 : trade.route;
    const tradePrice = trade === null || trade === void 0 ? void 0 : trade.executionPrice;
    const userHasSpecifiedInputOutput = Boolean(currencies[Field.INPUT] && currencies[Field.OUTPUT] && ((_e = parsedAmounts[independentField]) === null || _e === void 0 ? void 0 : _e.greaterThan(JSBI$1.BigInt(0))));
    const noRoute = !route;
    // check whether the user has approved the router on the input token
    const [approval, approveCallback] = useApproveCallbackFromTrade(chainId, trade, allowedSlippage);
    // check if user has gone through approval process, used to show two step buttons, reset on token change
    const [approvalSubmitted, setApprovalSubmitted] = useState(false);
    // mark when a user has submitted an approval, reset onTokenSelection for input field
    useEffect(() => {
        if (approval === ApprovalState.PENDING) {
            setApprovalSubmitted(true);
        }
    }, [approval, approvalSubmitted]);
    const maxAmountInput = maxAmountSpend(chainId, currencyBalances[Field.INPUT]);
    // the callback to execute the swap
    const { callback: swapCallback, error: swapCallbackError } = useSwapCallback(trade, allowedSlippage, recipient);
    const { priceImpactWithoutFee } = computeTradePriceBreakdown(trade);
    const handleSwap = useCallback(() => {
        if (priceImpactWithoutFee && !confirmPriceImpactWithoutFee(priceImpactWithoutFee)) {
            return;
        }
        if (!swapCallback) {
            return;
        }
        setSwapState({ attemptingTxn: true, tradeToConfirm, showConfirm, swapErrorMessage: undefined, txHash: undefined });
        swapCallback()
            .then((hash) => {
            var _a, _b, _c, _d;
            setSwapState({ attemptingTxn: false, tradeToConfirm, showConfirm, swapErrorMessage: undefined, txHash: hash });
            // eslint-disable-next-line import/no-named-as-default-member
            ReactGA.event({
                category: 'Swap',
                action: recipient === null
                    ? 'Swap w/o Send'
                    : (recipientAddress !== null && recipientAddress !== void 0 ? recipientAddress : recipient) === account
                        ? 'Swap w/o Send + recipient'
                        : 'Swap w/ Send',
                label: [(_b = (_a = trade === null || trade === void 0 ? void 0 : trade.inputAmount) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0 ? void 0 : _b.symbol, (_d = (_c = trade === null || trade === void 0 ? void 0 : trade.outputAmount) === null || _c === void 0 ? void 0 : _c.currency) === null || _d === void 0 ? void 0 : _d.symbol, Version.v2].join('/'),
            });
        })
            .catch((error) => {
            setSwapState({
                attemptingTxn: false,
                tradeToConfirm,
                showConfirm,
                swapErrorMessage: error.message,
                txHash: undefined,
            });
            // we only care if the error is something _other_ than the user rejected the tx
            if ((error === null || error === void 0 ? void 0 : error.code) !== 4001) {
                console.error(error);
            }
        });
    }, [tradeToConfirm, account, priceImpactWithoutFee, recipient, recipientAddress, showConfirm, swapCallback, trade]);
    const handleSelectTokenDrawerClose = useCallback(() => {
        setIsTokenDrawerOpen(false);
    }, [setIsTokenDrawerOpen]);
    // errors
    // const [showInverted, setShowInverted] = useState<boolean>(false)
    // warnings on slippage
    const priceImpactSeverity = warningSeverity(priceImpactWithoutFee);
    // show approve flow when: no error on inputs, not approved or pending, or approved in current session
    // never show if price impact is above threshold in non expert mode
    const showApproveFlow = !swapInputError &&
        (approval === ApprovalState.NOT_APPROVED ||
            approval === ApprovalState.PENDING ||
            (approvalSubmitted && approval === ApprovalState.APPROVED)) &&
        !(priceImpactSeverity > 3 && !isExpertMode);
    const handleConfirmDismiss = useCallback(() => {
        setSwapState({ showConfirm: false, tradeToConfirm, attemptingTxn, swapErrorMessage, txHash });
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onUserInput(Field.INPUT, '');
        }
    }, [attemptingTxn, onUserInput, swapErrorMessage, tradeToConfirm, txHash]);
    const handleAcceptChanges = useCallback(() => {
        setSwapState({ tradeToConfirm: trade, swapErrorMessage, txHash, attemptingTxn, showConfirm });
    }, [attemptingTxn, showConfirm, swapErrorMessage, trade, txHash]);
    // const handleMaxInput = useCallback(() => {
    //   maxAmountInput && onUserInput(Field.INPUT, maxAmountInput.toExact())
    // }, [maxAmountInput, onUserInput])
    const onCurrencySelect = useCallback((currency) => {
        if (tokenDrawerType === Field.INPUT) {
            setApprovalSubmitted(false); // reset 2 step UI for approvals
        }
        onCurrencySelection(tokenDrawerType, currency);
    }, [tokenDrawerType, onCurrencySelection]);
    const isAEBToken = useIsSelectedAEBToken();
    const selectedTokens = useSelectedTokenList();
    const whitelistedTokens = useTokenList(DEFAULT_TOKEN_LISTS_SELECTED);
    const isTrustedToken = useCallback((token) => {
        if (!chainId || !selectedTokens)
            return true; // Assume trusted at first to avoid flashing a warning
        return (TRUSTED_TOKEN_ADDRESSES[chainId].includes(token.address) || // trust token from manually whitelisted token
            isTokenOnList(selectedTokens, chainId, token) || // trust all tokens from selected token list by user
            isTokenOnList(whitelistedTokens, chainId, token) // trust all defi + AB tokens
        );
    }, [chainId, selectedTokens, whitelistedTokens]);
    const closeSwapSettings = useCallback(() => {
        setOpenSettings(false);
    }, [setOpenSettings]);
    const showRoute = Boolean(trade && ((_g = (_f = trade === null || trade === void 0 ? void 0 : trade.route) === null || _f === void 0 ? void 0 : _f.path) === null || _g === void 0 ? void 0 : _g.length) > 2);
    if (openSettings && showSettings) {
        return (jsx(Box, Object.assign({ minHeight: 450 }, { children: jsx(SwapSettingsDrawer, { isOpen: openSettings, close: closeSwapSettings }, void 0) }), void 0));
    }
    const renderButton = () => {
        var _a;
        if (!account) {
            return (jsx(Button, Object.assign({ isDisabled: !account, variant: "primary", onClick: toggleWalletModal }, { children: "Connect Wallet" }), void 0));
        }
        if (showWrap) {
            return (jsx(Button, Object.assign({ variant: "primary", isDisabled: Boolean(wrapInputError), onClick: onWrap }, { children: wrapInputError !== null && wrapInputError !== void 0 ? wrapInputError : (wrapType === WrapType.WRAP ? 'Wrap' : wrapType === WrapType.UNWRAP ? 'unwrap' : null) }), void 0));
        }
        if (noRoute && userHasSpecifiedInputOutput) {
            return (jsx(Button, Object.assign({ variant: "primary", isDisabled: true }, { children: "Insufficient liquidity for this trade." }), void 0));
        }
        if (showApproveFlow) {
            return (jsxs(Box, Object.assign({ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }, { children: [jsx(Box, Object.assign({ mr: "10px", width: "100%" }, { children: jsx(Button, Object.assign({ variant: approval === ApprovalState.APPROVED ? 'confirm' : 'primary', onClick: approveCallback, isDisabled: approval !== ApprovalState.NOT_APPROVED || approvalSubmitted, loading: approval === ApprovalState.PENDING, loadingText: "Approving" }, { children: approvalSubmitted && approval === ApprovalState.APPROVED
                                ? 'Approved'
                                : 'Approve' + ((_a = currencies[Field.INPUT]) === null || _a === void 0 ? void 0 : _a.symbol) }), void 0) }), void 0), jsx(Button, Object.assign({ variant: "primary", onClick: () => {
                            setSwapState({
                                tradeToConfirm: trade,
                                attemptingTxn: false,
                                swapErrorMessage: undefined,
                                showConfirm: true,
                                txHash: undefined,
                            });
                        }, id: "swap-button", isDisabled: !isValid || approval !== ApprovalState.APPROVED || (priceImpactSeverity > 3 && !isExpertMode) }, { children: priceImpactSeverity > 3 && !isExpertMode
                            ? 'Price Impact High'
                            : 'Swap' + `${priceImpactSeverity > 2 ? 'Anyway' : ''}` }), void 0)] }), void 0));
        }
        return (jsx(Button, Object.assign({ variant: "primary", onClick: () => {
                setSwapState({
                    tradeToConfirm: trade,
                    attemptingTxn: false,
                    swapErrorMessage: undefined,
                    showConfirm: true,
                    txHash: undefined,
                });
            }, id: "swap-button", isDisabled: !isValid || (priceImpactSeverity > 3 && !isExpertMode) || !!swapCallbackError || !!swapInputError, backgroundColor: isValid && priceImpactSeverity > 2 ? 'primary' : undefined, color: isValid && priceImpactSeverity <= 2 ? 'black' : undefined }, { children: swapInputError
                ? swapInputError
                : priceImpactSeverity > 3 && !isExpertMode
                    ? 'Price Impact High'
                    : 'Swap' + `${priceImpactSeverity > 2 ? 'Anyway' : ''}` }), void 0));
    };
    const renderPercentage = () => {
        return (jsx(Box, Object.assign({ display: "flex", pb: "5px" }, { children: percentageValue.map((value, index) => (jsxs(PValue, Object.assign({ isActive: selectedPercentage === value, onClick: () => {
                    var _a;
                    setSelectedPercentage(value);
                    if (maxAmountInput) {
                        const multipyAmount = JSBI$1.multiply(maxAmountInput === null || maxAmountInput === void 0 ? void 0 : maxAmountInput.raw, JSBI$1.BigInt(value));
                        const divideAmount = JSBI$1.divide(multipyAmount, JSBI$1.BigInt(100));
                        const token = wrappedCurrency((_a = maxAmountInput === null || maxAmountInput === void 0 ? void 0 : maxAmountInput.currency) !== null && _a !== void 0 ? _a : undefined, chainId);
                        const newFinalAmount = new TokenAmount(token, divideAmount);
                        onUserInput(Field.INPUT, newFinalAmount.toExact());
                    }
                } }, { children: [value, "%"] }), index))) }), void 0));
    };
    return (jsxs(Root$1, { children: [jsx(TradeOption, { swapType: swapType, setSwapType: setSwapType, isLimitOrderVisible: isLimitOrderVisible }, void 0), jsx(TokenWarningModal, { isOpen: urlLoadedTokens.length > 0 && !dismissTokenWarning && !urlLoadedTokens.every(isTrustedToken), tokens: urlLoadedTokens, onConfirm: handleConfirmTokenWarning }, void 0), jsx(SwapWrapper, { children: jsxs(Box, Object.assign({ p: 10 }, { children: [isAEBToken && jsx(DeprecatedWarning, {}, void 0), jsx(CurrencyInputTextBox, { label: independentField === Field.OUTPUT && !showWrap && trade ? 'From (estimated)' : 'From', value: formattedAmounts[Field.INPUT], onChange: (value) => {
                                setSelectedPercentage(0);
                                handleTypeInput(value);
                            }, onTokenClick: () => {
                                setTokenDrawerType(Field.INPUT);
                                setIsTokenDrawerOpen(true);
                            }, currency: inputCurrency, fontSize: 24, isNumeric: true, placeholder: "0.00", id: "swap-currency-input", addonLabel: renderPercentage() }, void 0), jsx(Box, Object.assign({ width: "100%", textAlign: "center", alignItems: "center", display: "flex", justifyContent: 'center', mt: 10 }, { children: jsx(ArrowWrapper$1, Object.assign({ onClick: () => {
                                    setApprovalSubmitted(false); // reset 2 step UI for approvals
                                    onSwitchTokens();
                                } }, { children: jsx(RefreshCcw$1, { size: "16", color: theme.text4 }, void 0) }), void 0) }), void 0), jsx(CurrencyInputTextBox, { label: independentField === Field.INPUT && !showWrap && trade ? 'To (estimated)' : 'To', value: formattedAmounts[Field.OUTPUT], onChange: (value) => {
                                setSelectedPercentage(0);
                                handleTypeOutput(value);
                            }, onTokenClick: () => {
                                setTokenDrawerType(Field.OUTPUT);
                                setIsTokenDrawerOpen(true);
                            }, currency: outputCurrency, fontSize: 24, isNumeric: true, placeholder: "0.00", id: "swap-currency-output", addonLabel: tradePrice && (jsxs(Text$1, Object.assign({ color: "text4", fontSize: 16 }, { children: ["Price: ", tradePrice === null || tradePrice === void 0 ? void 0 : tradePrice.toSignificant(6), " ", (_h = tradePrice === null || tradePrice === void 0 ? void 0 : tradePrice.quoteCurrency) === null || _h === void 0 ? void 0 : _h.symbol] }), void 0)) }, void 0), recipient === null && !showWrap && isExpertMode ? (jsx(Box, Object.assign({ display: "flex", flexDirection: "column", marginTop: 10 }, { children: jsx(LinkStyledButton, Object.assign({ id: "add-recipient-button", onClick: () => onChangeRecipient(''), style: { alignSelf: 'end' } }, { children: "+ Add Recipient" }), void 0) }), void 0)) : null, recipient !== null && !showWrap ? (jsxs(Box, Object.assign({ display: "flex", flexDirection: "column", marginTop: 10, marginBottom: 10 }, { children: [jsx(LinkStyledButton, Object.assign({ id: "add-recipient-button", onClick: () => onChangeRecipient(null), style: { alignSelf: 'end' } }, { children: "- Remove Recipient" }), void 0), jsx(TextInput, { label: "Recipient", placeholder: "Wallet Address", value: recipient, onChange: (value) => {
                                        const withoutSpaces = value.replace(/\s+/g, '');
                                        onChangeRecipient(withoutSpaces);
                                    }, addonLabel: recipient && !isAddress(recipient) && jsx(Text$1, Object.assign({ color: "text1" }, { children: "Invalid Address" }), void 0) }, void 0)] }), void 0)) : null, trade && jsx(SwapDetailInfo, { trade: trade }, void 0), jsx(Box, Object.assign({ width: "100%", mt: 10 }, { children: renderButton() }), void 0), showSettings && (jsx(Box, Object.assign({ width: "100%", mt: 10, display: "flex", justifyContent: "center" }, { children: jsx(SettingsText, Object.assign({ onClick: () => setOpenSettings(true) }, { children: "Settings" }), void 0) }), void 0))] }), void 0) }, void 0), trade && showRoute && jsx(SwapRoute, { trade: trade }, void 0), isTokenDrawerOpen && (jsx(SelectTokenDrawer$1, { isOpen: isTokenDrawerOpen, onClose: handleSelectTokenDrawerClose, onCurrencySelect: onCurrencySelect, selectedCurrency: tokenDrawerType === Field.INPUT ? inputCurrency : outputCurrency, otherSelectedCurrency: tokenDrawerType === Field.INPUT ? outputCurrency : inputCurrency }, void 0)), trade && showConfirm && (jsx(ConfirmSwapDrawer, { isOpen: showConfirm, trade: trade, originalTrade: tradeToConfirm, onAcceptChanges: handleAcceptChanges, attemptingTxn: attemptingTxn, txHash: txHash, recipient: recipient, allowedSlippage: allowedSlippage, onConfirm: handleSwap, swapErrorMessage: swapErrorMessage, onClose: handleConfirmDismiss }, void 0))] }, void 0));
};

const Root = styled(Box) `
  width: 100%;
  min-width: 320px;
  position: relative;
  overflow: hidden;

  * {
    box-sizing: border-box;
  }
`;

const SwapWidget = ({ isLimitOrderVisible = false, showSettings = true }) => {
    const [swapType, setSwapType] = useState('MARKET');
    return (jsx(Root, { children: swapType === 'LIMIT' ? (jsx(LimitOrder, { swapType: swapType, setSwapType: (type) => {
                setSwapType(type);
            }, isLimitOrderVisible: isLimitOrderVisible }, void 0)) : (jsx(MarketOrder, { swapType: swapType, setSwapType: (type) => {
                setSwapType(type);
            }, isLimitOrderVisible: isLimitOrderVisible, showSettings: showSettings }, void 0)) }, void 0));
};

const Wrapper$1 = styled(Box) `
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
`;

const ShowMore = (props) => {
    const { onToggle, showMore } = props;
    const theme = useContext(Me);
    return (jsxs(Wrapper$1, Object.assign({ onClick: () => onToggle() }, { children: [jsx(Text$1, Object.assign({ color: "text2", fontSize: 16, fontWeight: 500, marginLeft: '6px', textAlign: "center" }, { children: showMore ? 'See Less' : 'See More' }), void 0), showMore ? (jsx(ChevronUp$1, { size: "16", color: theme.text2, style: { marginLeft: '4px' } }, void 0)) : (jsx(ChevronDown$1, { size: "16", color: theme.text2, style: { marginLeft: '4px' } }, void 0))] }), void 0));
};

var lib$2 = {};

var Scrollbars$1 = {};

var raf$2 = {exports: {}};

var performanceNow = {exports: {}};

// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    performanceNow.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    performanceNow.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    performanceNow.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    performanceNow.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(commonjsGlobal);

var now$4 = performanceNow.exports
  , root$d = typeof window === 'undefined' ? commonjsGlobal : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root$d['request' + suffix]
  , caf = root$d['cancel' + suffix] || root$d['cancelRequest' + suffix];

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root$d[vendors[i] + 'Request' + suffix];
  caf = root$d[vendors[i] + 'Cancel' + suffix]
      || root$d[vendors[i] + 'CancelRequest' + suffix];
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last$1 = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60;

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now$4()
        , next = Math.max(0, frameDuration - (_now - last$1));
      last$1 = next + _now;
      setTimeout(function() {
        var cp = queue.slice(0);
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0;
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last$1);
            } catch(e) {
              setTimeout(function() { throw e }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    });
    return id
  };

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true;
      }
    }
  };
}

raf$2.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root$d, fn)
};
var cancel = raf$2.exports.cancel = function() {
  caf.apply(root$d, arguments);
};
raf$2.exports.polyfill = function(object) {
  if (!object) {
    object = root$d;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};

var raf$1 = raf$2.exports;

var domCss = {exports: {}};

var div = null;
var prefixes$1 = [ 'Webkit', 'Moz', 'O', 'ms' ];

var prefixStyle = function prefixStyle (prop) {
  // re-use a dummy div
  if (!div) {
    div = document.createElement('div');
  }

  var style = div.style;

  // prop exists without prefix
  if (prop in style) {
    return prop
  }

  // borderRadius -> BorderRadius
  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1);

  // find the vendor-prefixed prop
  for (var i = prefixes$1.length; i >= 0; i--) {
    var name = prefixes$1[i] + titleCase;
    // e.g. WebkitBorderRadius or webkitBorderRadius
    if (name in style) {
      return name
    }
  }

  return false
};

/**
 * Export.
 */

var toNoCase_1 = toNoCase;

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/;
var hasSeparator = /(_|-|\.|:)/;
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g;

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g;

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}

var clean$1 = toNoCase_1;

/**
 * Export.
 */

var toSpaceCase_1 = toSpaceCase;

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean$1(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}

var space = toSpaceCase_1;

/**
 * Export.
 */

var toCamelCase_1 = toCamelCase$1;

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase$1(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}

/* The following list is defined in React's core */

var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

var addPxToStyle$1 = function(name, value) {
  if(typeof value === 'number' && !IS_UNITLESS[ name ]) {
    return value + 'px';
  } else {
    return value;
  }
};

var prefix$1 = prefixStyle;
var toCamelCase = toCamelCase_1;
var cache$1 = { 'float': 'cssFloat' };
var addPxToStyle = addPxToStyle$1;

function style (element, property, value) {
  var camel = cache$1[property];
  if (typeof camel === 'undefined') {
    camel = detect(property);
  }

  // may be false if CSS prop is unsupported
  if (camel) {
    if (value === undefined) {
      return element.style[camel]
    }

    element.style[camel] = addPxToStyle(camel, value);
  }
}

function each$3 (element, properties) {
  for (var k in properties) {
    if (properties.hasOwnProperty(k)) {
      style(element, k, properties[k]);
    }
  }
}

function detect (cssProp) {
  var camel = toCamelCase(cssProp);
  var result = prefix$1(camel);
  cache$1[camel] = cache$1[cssProp] = cache$1[result] = result;
  return result
}

function set () {
  if (arguments.length === 2) {
    if (typeof arguments[1] === 'string') {
      arguments[0].style.cssText = arguments[1];
    } else {
      each$3(arguments[0], arguments[1]);
    }
  } else {
    style(arguments[0], arguments[1], arguments[2]);
  }
}

domCss.exports = set;
domCss.exports.set = set;

domCss.exports.get = function (element, properties) {
  if (Array.isArray(properties)) {
    return properties.reduce(function (obj, prop) {
      obj[prop] = style(element, prop || '');
      return obj
    }, {})
  } else {
    return style(element, properties || '')
  }
};

var propTypes = {exports: {}};

var reactIs$2 = {exports: {}};

var reactIs_production_min$2 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$2="function"===typeof Symbol&&Symbol.for,c$3=b$2?Symbol.for("react.element"):60103,d$2=b$2?Symbol.for("react.portal"):60106,e$2=b$2?Symbol.for("react.fragment"):60107,f$2=b$2?Symbol.for("react.strict_mode"):60108,g$2=b$2?Symbol.for("react.profiler"):60114,h$2=b$2?Symbol.for("react.provider"):60109,k$3=b$2?Symbol.for("react.context"):60110,l$2=b$2?Symbol.for("react.async_mode"):60111,m$2=b$2?Symbol.for("react.concurrent_mode"):60111,n$2=b$2?Symbol.for("react.forward_ref"):60112,p$2=b$2?Symbol.for("react.suspense"):60113,q$2=b$2?
Symbol.for("react.suspense_list"):60120,r$1=b$2?Symbol.for("react.memo"):60115,t$2=b$2?Symbol.for("react.lazy"):60116,v$2=b$2?Symbol.for("react.block"):60121,w$1=b$2?Symbol.for("react.fundamental"):60117,x$2=b$2?Symbol.for("react.responder"):60118,y$2=b$2?Symbol.for("react.scope"):60119;
function z$1(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$3:switch(a=a.type,a){case l$2:case m$2:case e$2:case g$2:case f$2:case p$2:return a;default:switch(a=a&&a.$$typeof,a){case k$3:case n$2:case t$2:case r$1:case h$2:return a;default:return u}}case d$2:return u}}}function A$1(a){return z$1(a)===m$2}reactIs_production_min$2.AsyncMode=l$2;reactIs_production_min$2.ConcurrentMode=m$2;reactIs_production_min$2.ContextConsumer=k$3;reactIs_production_min$2.ContextProvider=h$2;reactIs_production_min$2.Element=c$3;reactIs_production_min$2.ForwardRef=n$2;reactIs_production_min$2.Fragment=e$2;reactIs_production_min$2.Lazy=t$2;reactIs_production_min$2.Memo=r$1;reactIs_production_min$2.Portal=d$2;
reactIs_production_min$2.Profiler=g$2;reactIs_production_min$2.StrictMode=f$2;reactIs_production_min$2.Suspense=p$2;reactIs_production_min$2.isAsyncMode=function(a){return A$1(a)||z$1(a)===l$2};reactIs_production_min$2.isConcurrentMode=A$1;reactIs_production_min$2.isContextConsumer=function(a){return z$1(a)===k$3};reactIs_production_min$2.isContextProvider=function(a){return z$1(a)===h$2};reactIs_production_min$2.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$3};reactIs_production_min$2.isForwardRef=function(a){return z$1(a)===n$2};reactIs_production_min$2.isFragment=function(a){return z$1(a)===e$2};reactIs_production_min$2.isLazy=function(a){return z$1(a)===t$2};
reactIs_production_min$2.isMemo=function(a){return z$1(a)===r$1};reactIs_production_min$2.isPortal=function(a){return z$1(a)===d$2};reactIs_production_min$2.isProfiler=function(a){return z$1(a)===g$2};reactIs_production_min$2.isStrictMode=function(a){return z$1(a)===f$2};reactIs_production_min$2.isSuspense=function(a){return z$1(a)===p$2};
reactIs_production_min$2.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$2||a===m$2||a===g$2||a===f$2||a===p$2||a===q$2||"object"===typeof a&&null!==a&&(a.$$typeof===t$2||a.$$typeof===r$1||a.$$typeof===h$2||a.$$typeof===k$3||a.$$typeof===n$2||a.$$typeof===w$1||a.$$typeof===x$2||a.$$typeof===y$2||a.$$typeof===v$2)};reactIs_production_min$2.typeOf=z$1;

var reactIs_development$2 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$2.AsyncMode = AsyncMode;
reactIs_development$2.ConcurrentMode = ConcurrentMode;
reactIs_development$2.ContextConsumer = ContextConsumer;
reactIs_development$2.ContextProvider = ContextProvider;
reactIs_development$2.Element = Element;
reactIs_development$2.ForwardRef = ForwardRef;
reactIs_development$2.Fragment = Fragment;
reactIs_development$2.Lazy = Lazy;
reactIs_development$2.Memo = Memo;
reactIs_development$2.Portal = Portal;
reactIs_development$2.Profiler = Profiler;
reactIs_development$2.StrictMode = StrictMode;
reactIs_development$2.Suspense = Suspense;
reactIs_development$2.isAsyncMode = isAsyncMode;
reactIs_development$2.isConcurrentMode = isConcurrentMode;
reactIs_development$2.isContextConsumer = isContextConsumer;
reactIs_development$2.isContextProvider = isContextProvider;
reactIs_development$2.isElement = isElement;
reactIs_development$2.isForwardRef = isForwardRef;
reactIs_development$2.isFragment = isFragment;
reactIs_development$2.isLazy = isLazy;
reactIs_development$2.isMemo = isMemo;
reactIs_development$2.isPortal = isPortal;
reactIs_development$2.isProfiler = isProfiler;
reactIs_development$2.isStrictMode = isStrictMode;
reactIs_development$2.isSuspense = isSuspense;
reactIs_development$2.isValidElementType = isValidElementType;
reactIs_development$2.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = reactIs_production_min$2;
} else {
  reactIs$2.exports = reactIs_development$2;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$2 = reactIs$2.exports;
var assign$1 = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$2.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign$1({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs$1 = reactIs$2.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs$1.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var isString$2 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}
}(isString$2));

var getScrollbarWidth = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getScrollbarWidth;

var _domCss = domCss.exports;

var _domCss2 = _interopRequireDefault(_domCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var scrollbarWidth = false;

function getScrollbarWidth() {
    if (scrollbarWidth !== false) return scrollbarWidth;
    /* istanbul ignore else */
    if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, _domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else {
        scrollbarWidth = 0;
    }
    return scrollbarWidth || 0;
}
}(getScrollbarWidth));

var returnFalse = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = returnFalse;
function returnFalse() {
    return false;
}
}(returnFalse));

var getInnerWidth = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
    var clientWidth = el.clientWidth;

    var _getComputedStyle = getComputedStyle(el),
        paddingLeft = _getComputedStyle.paddingLeft,
        paddingRight = _getComputedStyle.paddingRight;

    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}
}(getInnerWidth));

var getInnerHeight = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getInnerHeight;
function getInnerHeight(el) {
    var clientHeight = el.clientHeight;

    var _getComputedStyle = getComputedStyle(el),
        paddingTop = _getComputedStyle.paddingTop,
        paddingBottom = _getComputedStyle.paddingBottom;

    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}
}(getInnerHeight));

var styles = {};

Object.defineProperty(styles, "__esModule", {
    value: true
});
styles.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};

// Overrides containerStyleDefault properties
styles.containerStyleAutoHeight = {
    height: 'auto'
};

styles.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};

// Overrides viewStyleDefault properties
styles.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};

styles.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};

styles.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};

styles.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};

styles.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};

styles.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};

styles.disableSelectStyle = {
    userSelect: 'none'
};

styles.disableSelectStyleReset = {
    userSelect: ''
};

var defaultRenderElements = {};

Object.defineProperty(defaultRenderElements, "__esModule", {
    value: true
});

var _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

defaultRenderElements.renderViewDefault = renderViewDefault;
defaultRenderElements.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
defaultRenderElements.renderTrackVerticalDefault = renderTrackVerticalDefault;
defaultRenderElements.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
defaultRenderElements.renderThumbVerticalDefault = renderThumbVerticalDefault;

var _react$5 = React$2;

var _react2 = _interopRequireDefault$6(_react$5);

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties$d(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint-disable react/prop-types */

function renderViewDefault(props) {
    return _react2["default"].createElement('div', props);
}

function renderTrackHorizontalDefault(_ref) {
    var style = _ref.style,
        props = _objectWithoutProperties$d(_ref, ['style']);

    var finalStyle = _extends$p({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends$p({ style: finalStyle }, props));
}

function renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style,
        props = _objectWithoutProperties$d(_ref2, ['style']);

    var finalStyle = _extends$p({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return _react2["default"].createElement('div', _extends$p({ style: finalStyle }, props));
}

function renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style,
        props = _objectWithoutProperties$d(_ref3, ['style']);

    var finalStyle = _extends$p({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends$p({ style: finalStyle }, props));
}

function renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style,
        props = _objectWithoutProperties$d(_ref4, ['style']);

    var finalStyle = _extends$p({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return _react2["default"].createElement('div', _extends$p({ style: finalStyle }, props));
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _raf2 = raf$2.exports;

var _raf3 = _interopRequireDefault(_raf2);

var _domCss = domCss.exports;

var _domCss2 = _interopRequireDefault(_domCss);

var _react = React$2;

var _propTypes = propTypes.exports;

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isString = isString$2;

var _isString2 = _interopRequireDefault(_isString);

var _getScrollbarWidth = getScrollbarWidth;

var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);

var _returnFalse = returnFalse;

var _returnFalse2 = _interopRequireDefault(_returnFalse);

var _getInnerWidth = getInnerWidth;

var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);

var _getInnerHeight = getInnerHeight;

var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);

var _styles = styles;

var _defaultRenderElements = defaultRenderElements;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Scrollbars = function (_Component) {
    _inherits(Scrollbars, _Component);

    function Scrollbars(props) {
        var _ref;

        _classCallCheck(this, Scrollbars);

        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            rest[_key - 1] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this, props].concat(rest)));

        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);

        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);

        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);

        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }

    _createClass(Scrollbars, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.addListeners();
            this.update();
            this.componentDidMountUniversal();
        }
    }, {
        key: 'componentDidMountUniversal',
        value: function componentDidMountUniversal() {
            // eslint-disable-line react/sort-comp
            var universal = this.props.universal;

            if (!universal) return;
            this.setState({ didMountUniversal: true });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.update();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeListeners();
            (0, _raf2.cancel)(this.requestFrame);
            clearTimeout(this.hideTracksTimeout);
            clearInterval(this.detectScrollingInterval);
        }
    }, {
        key: 'getScrollLeft',
        value: function getScrollLeft() {
            if (!this.view) return 0;
            return this.view.scrollLeft;
        }
    }, {
        key: 'getScrollTop',
        value: function getScrollTop() {
            if (!this.view) return 0;
            return this.view.scrollTop;
        }
    }, {
        key: 'getScrollWidth',
        value: function getScrollWidth() {
            if (!this.view) return 0;
            return this.view.scrollWidth;
        }
    }, {
        key: 'getScrollHeight',
        value: function getScrollHeight() {
            if (!this.view) return 0;
            return this.view.scrollHeight;
        }
    }, {
        key: 'getClientWidth',
        value: function getClientWidth() {
            if (!this.view) return 0;
            return this.view.clientWidth;
        }
    }, {
        key: 'getClientHeight',
        value: function getClientHeight() {
            if (!this.view) return 0;
            return this.view.clientHeight;
        }
    }, {
        key: 'getValues',
        value: function getValues() {
            var _ref2 = this.view || {},
                _ref2$scrollLeft = _ref2.scrollLeft,
                scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
                _ref2$scrollTop = _ref2.scrollTop,
                scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop,
                _ref2$scrollWidth = _ref2.scrollWidth,
                scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth,
                _ref2$scrollHeight = _ref2.scrollHeight,
                scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight,
                _ref2$clientWidth = _ref2.clientWidth,
                clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth,
                _ref2$clientHeight = _ref2.clientHeight,
                clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;

            return {
                left: scrollLeft / (scrollWidth - clientWidth) || 0,
                top: scrollTop / (scrollHeight - clientHeight) || 0,
                scrollLeft: scrollLeft,
                scrollTop: scrollTop,
                scrollWidth: scrollWidth,
                scrollHeight: scrollHeight,
                clientWidth: clientWidth,
                clientHeight: clientHeight
            };
        }
    }, {
        key: 'getThumbHorizontalWidth',
        value: function getThumbHorizontalWidth() {
            var _props = this.props,
                thumbSize = _props.thumbSize,
                thumbMinSize = _props.thumbMinSize;
            var _view = this.view,
                scrollWidth = _view.scrollWidth,
                clientWidth = _view.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
            if (trackWidth === width) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(width, thumbMinSize);
        }
    }, {
        key: 'getThumbVerticalHeight',
        value: function getThumbVerticalHeight() {
            var _props2 = this.props,
                thumbSize = _props2.thumbSize,
                thumbMinSize = _props2.thumbMinSize;
            var _view2 = this.view,
                scrollHeight = _view2.scrollHeight,
                clientHeight = _view2.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
            if (trackHeight === height) return 0;
            if (thumbSize) return thumbSize;
            return Math.max(height, thumbMinSize);
        }
    }, {
        key: 'getScrollLeftForOffset',
        value: function getScrollLeftForOffset(offset) {
            var _view3 = this.view,
                scrollWidth = _view3.scrollWidth,
                clientWidth = _view3.clientWidth;

            var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
            var thumbWidth = this.getThumbHorizontalWidth();
            return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
        }
    }, {
        key: 'getScrollTopForOffset',
        value: function getScrollTopForOffset(offset) {
            var _view4 = this.view,
                scrollHeight = _view4.scrollHeight,
                clientHeight = _view4.clientHeight;

            var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
            var thumbHeight = this.getThumbVerticalHeight();
            return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
        }
    }, {
        key: 'scrollLeft',
        value: function scrollLeft() {
            var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollLeft = left;
        }
    }, {
        key: 'scrollTop',
        value: function scrollTop() {
            var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (!this.view) return;
            this.view.scrollTop = top;
        }
    }, {
        key: 'scrollToLeft',
        value: function scrollToLeft() {
            if (!this.view) return;
            this.view.scrollLeft = 0;
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            if (!this.view) return;
            this.view.scrollTop = 0;
        }
    }, {
        key: 'scrollToRight',
        value: function scrollToRight() {
            if (!this.view) return;
            this.view.scrollLeft = this.view.scrollWidth;
        }
    }, {
        key: 'scrollToBottom',
        value: function scrollToBottom() {
            if (!this.view) return;
            this.view.scrollTop = this.view.scrollHeight;
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.addEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.addEventListener('resize', this.handleWindowResize);
        }
    }, {
        key: 'removeListeners',
        value: function removeListeners() {
            /* istanbul ignore if */
            if (typeof document === 'undefined' || !this.view) return;
            var view = this.view,
                trackHorizontal = this.trackHorizontal,
                trackVertical = this.trackVertical,
                thumbHorizontal = this.thumbHorizontal,
                thumbVertical = this.thumbVertical;

            view.removeEventListener('scroll', this.handleScroll);
            if (!(0, _getScrollbarWidth2["default"])()) return;
            trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
            trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
            trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
            trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
            thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
            thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
            window.removeEventListener('resize', this.handleWindowResize);
            // Possibly setup by `handleDragStart`
            this.teardownDragging();
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(event) {
            var _this2 = this;

            var _props3 = this.props,
                onScroll = _props3.onScroll,
                onScrollFrame = _props3.onScrollFrame;

            if (onScroll) onScroll(event);
            this.update(function (values) {
                var scrollLeft = values.scrollLeft,
                    scrollTop = values.scrollTop;

                _this2.viewScrollLeft = scrollLeft;
                _this2.viewScrollTop = scrollTop;
                if (onScrollFrame) onScrollFrame(values);
            });
            this.detectScrolling();
        }
    }, {
        key: 'handleScrollStart',
        value: function handleScrollStart() {
            var onScrollStart = this.props.onScrollStart;

            if (onScrollStart) onScrollStart();
            this.handleScrollStartAutoHide();
        }
    }, {
        key: 'handleScrollStartAutoHide',
        value: function handleScrollStartAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleScrollStop',
        value: function handleScrollStop() {
            var onScrollStop = this.props.onScrollStop;

            if (onScrollStop) onScrollStop();
            this.handleScrollStopAutoHide();
        }
    }, {
        key: 'handleScrollStopAutoHide',
        value: function handleScrollStopAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleWindowResize',
        value: function handleWindowResize() {
            this.update();
        }
    }, {
        key: 'handleHorizontalTrackMouseDown',
        value: function handleHorizontalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientX = event.clientX;

            var _target$getBoundingCl = target.getBoundingClientRect(),
                targetLeft = _target$getBoundingCl.left;

            var thumbWidth = this.getThumbHorizontalWidth();
            var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
            this.view.scrollLeft = this.getScrollLeftForOffset(offset);
        }
    }, {
        key: 'handleVerticalTrackMouseDown',
        value: function handleVerticalTrackMouseDown(event) {
            event.preventDefault();
            var target = event.target,
                clientY = event.clientY;

            var _target$getBoundingCl2 = target.getBoundingClientRect(),
                targetTop = _target$getBoundingCl2.top;

            var thumbHeight = this.getThumbVerticalHeight();
            var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
            this.view.scrollTop = this.getScrollTopForOffset(offset);
        }
    }, {
        key: 'handleHorizontalThumbMouseDown',
        value: function handleHorizontalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientX = event.clientX;
            var offsetWidth = target.offsetWidth;

            var _target$getBoundingCl3 = target.getBoundingClientRect(),
                left = _target$getBoundingCl3.left;

            this.prevPageX = offsetWidth - (clientX - left);
        }
    }, {
        key: 'handleVerticalThumbMouseDown',
        value: function handleVerticalThumbMouseDown(event) {
            event.preventDefault();
            this.handleDragStart(event);
            var target = event.target,
                clientY = event.clientY;
            var offsetHeight = target.offsetHeight;

            var _target$getBoundingCl4 = target.getBoundingClientRect(),
                top = _target$getBoundingCl4.top;

            this.prevPageY = offsetHeight - (clientY - top);
        }
    }, {
        key: 'setupDragging',
        value: function setupDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
            document.addEventListener('mousemove', this.handleDrag);
            document.addEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = _returnFalse2["default"];
        }
    }, {
        key: 'teardownDragging',
        value: function teardownDragging() {
            (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
            document.removeEventListener('mousemove', this.handleDrag);
            document.removeEventListener('mouseup', this.handleDragEnd);
            document.onselectstart = undefined;
        }
    }, {
        key: 'handleDragStart',
        value: function handleDragStart(event) {
            this.dragging = true;
            event.stopImmediatePropagation();
            this.setupDragging();
        }
    }, {
        key: 'handleDrag',
        value: function handleDrag(event) {
            if (this.prevPageX) {
                var clientX = event.clientX;

                var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(),
                    trackLeft = _trackHorizontal$getB.left;

                var thumbWidth = this.getThumbHorizontalWidth();
                var clickPosition = thumbWidth - this.prevPageX;
                var offset = -trackLeft + clientX - clickPosition;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
            if (this.prevPageY) {
                var clientY = event.clientY;

                var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(),
                    trackTop = _trackVertical$getBou.top;

                var thumbHeight = this.getThumbVerticalHeight();
                var _clickPosition = thumbHeight - this.prevPageY;
                var _offset = -trackTop + clientY - _clickPosition;
                this.view.scrollTop = this.getScrollTopForOffset(_offset);
            }
            return false;
        }
    }, {
        key: 'handleDragEnd',
        value: function handleDragEnd() {
            this.dragging = false;
            this.prevPageX = this.prevPageY = 0;
            this.teardownDragging();
            this.handleDragEndAutoHide();
        }
    }, {
        key: 'handleDragEndAutoHide',
        value: function handleDragEndAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'handleTrackMouseEnter',
        value: function handleTrackMouseEnter() {
            this.trackMouseOver = true;
            this.handleTrackMouseEnterAutoHide();
        }
    }, {
        key: 'handleTrackMouseEnterAutoHide',
        value: function handleTrackMouseEnterAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.showTracks();
        }
    }, {
        key: 'handleTrackMouseLeave',
        value: function handleTrackMouseLeave() {
            this.trackMouseOver = false;
            this.handleTrackMouseLeaveAutoHide();
        }
    }, {
        key: 'handleTrackMouseLeaveAutoHide',
        value: function handleTrackMouseLeaveAutoHide() {
            var autoHide = this.props.autoHide;

            if (!autoHide) return;
            this.hideTracks();
        }
    }, {
        key: 'showTracks',
        value: function showTracks() {
            clearTimeout(this.hideTracksTimeout);
            (0, _domCss2["default"])(this.trackHorizontal, { opacity: 1 });
            (0, _domCss2["default"])(this.trackVertical, { opacity: 1 });
        }
    }, {
        key: 'hideTracks',
        value: function hideTracks() {
            var _this3 = this;

            if (this.dragging) return;
            if (this.scrolling) return;
            if (this.trackMouseOver) return;
            var autoHideTimeout = this.props.autoHideTimeout;

            clearTimeout(this.hideTracksTimeout);
            this.hideTracksTimeout = setTimeout(function () {
                (0, _domCss2["default"])(_this3.trackHorizontal, { opacity: 0 });
                (0, _domCss2["default"])(_this3.trackVertical, { opacity: 0 });
            }, autoHideTimeout);
        }
    }, {
        key: 'detectScrolling',
        value: function detectScrolling() {
            var _this4 = this;

            if (this.scrolling) return;
            this.scrolling = true;
            this.handleScrollStart();
            this.detectScrollingInterval = setInterval(function () {
                if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                    clearInterval(_this4.detectScrollingInterval);
                    _this4.scrolling = false;
                    _this4.handleScrollStop();
                }
                _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                _this4.lastViewScrollTop = _this4.viewScrollTop;
            }, 100);
        }
    }, {
        key: 'raf',
        value: function raf(callback) {
            var _this5 = this;

            if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
            this.requestFrame = (0, _raf3["default"])(function () {
                _this5.requestFrame = undefined;
                callback();
            });
        }
    }, {
        key: 'update',
        value: function update(callback) {
            var _this6 = this;

            this.raf(function () {
                return _this6._update(callback);
            });
        }
    }, {
        key: '_update',
        value: function _update(callback) {
            var _props4 = this.props,
                onUpdate = _props4.onUpdate,
                hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;

            var values = this.getValues();
            if ((0, _getScrollbarWidth2["default"])()) {
                var scrollLeft = values.scrollLeft,
                    clientWidth = values.clientWidth,
                    scrollWidth = values.scrollWidth;

                var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                var thumbHorizontalStyle = {
                    width: thumbHorizontalWidth,
                    transform: 'translateX(' + thumbHorizontalX + 'px)'
                };
                var scrollTop = values.scrollTop,
                    clientHeight = values.clientHeight,
                    scrollHeight = values.scrollHeight;

                var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                var thumbVerticalHeight = this.getThumbVerticalHeight();
                var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                var thumbVerticalStyle = {
                    height: thumbVerticalHeight,
                    transform: 'translateY(' + thumbVerticalY + 'px)'
                };
                if (hideTracksWhenNotNeeded) {
                    var trackHorizontalStyle = {
                        visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                    };
                    var trackVerticalStyle = {
                        visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                    };
                    (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                    (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
                }
                (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
            }
            if (onUpdate) onUpdate(values);
            if (typeof callback !== 'function') return;
            callback(values);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
            /* eslint-disable no-unused-vars */

            var _props5 = this.props;
                _props5.onScroll;
                _props5.onScrollFrame;
                _props5.onScrollStart;
                _props5.onScrollStop;
                _props5.onUpdate;
                var renderView = _props5.renderView,
                renderTrackHorizontal = _props5.renderTrackHorizontal,
                renderTrackVertical = _props5.renderTrackVertical,
                renderThumbHorizontal = _props5.renderThumbHorizontal,
                renderThumbVertical = _props5.renderThumbVertical,
                tagName = _props5.tagName;
                _props5.hideTracksWhenNotNeeded;
                var autoHide = _props5.autoHide;
                _props5.autoHideTimeout;
                var autoHideDuration = _props5.autoHideDuration;
                _props5.thumbSize;
                _props5.thumbMinSize;
                var universal = _props5.universal,
                autoHeight = _props5.autoHeight,
                autoHeightMin = _props5.autoHeightMin,
                autoHeightMax = _props5.autoHeightMax,
                style = _props5.style,
                children = _props5.children,
                props = _objectWithoutProperties(_props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
            /* eslint-enable no-unused-vars */

            var didMountUniversal = this.state.didMountUniversal;


            var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }), style);

            var viewStyle = _extends({}, _styles.viewStyleDefault, {
                // Hide scrollbars by setting a negative margin
                marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                marginBottom: scrollbarWidth ? -scrollbarWidth : 0
            }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
                // Add scrollbarWidth to autoHeight in order to compensate negative margins
                minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
            }), autoHeight && universal && !didMountUniversal && {
                minHeight: autoHeightMin,
                maxHeight: autoHeightMax
            }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);

            var trackAutoHeightStyle = {
                transition: 'opacity ' + autoHideDuration + 'ms',
                opacity: 0
            };

            var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                display: 'none'
            });

            return (0, _react.createElement)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(_ref3) {
                    _this7.container = _ref3;
                } }), [(0, _react.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(_ref4) {
                    _this7.view = _ref4;
                } }, children), (0, _react.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(_ref5) {
                    _this7.trackHorizontal = _ref5;
                } }, (0, _react.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(_ref6) {
                    _this7.thumbHorizontal = _ref6;
                } })), (0, _react.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(_ref7) {
                    _this7.trackVertical = _ref7;
                } }, (0, _react.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(_ref8) {
                    _this7.thumbVertical = _ref8;
                } }))]);
        }
    }]);

    return Scrollbars;
}(_react.Component);

exports["default"] = Scrollbars;


Scrollbars.propTypes = {
    onScroll: _propTypes2["default"].func,
    onScrollFrame: _propTypes2["default"].func,
    onScrollStart: _propTypes2["default"].func,
    onScrollStop: _propTypes2["default"].func,
    onUpdate: _propTypes2["default"].func,
    renderView: _propTypes2["default"].func,
    renderTrackHorizontal: _propTypes2["default"].func,
    renderTrackVertical: _propTypes2["default"].func,
    renderThumbHorizontal: _propTypes2["default"].func,
    renderThumbVertical: _propTypes2["default"].func,
    tagName: _propTypes2["default"].string,
    thumbSize: _propTypes2["default"].number,
    thumbMinSize: _propTypes2["default"].number,
    hideTracksWhenNotNeeded: _propTypes2["default"].bool,
    autoHide: _propTypes2["default"].bool,
    autoHideTimeout: _propTypes2["default"].number,
    autoHideDuration: _propTypes2["default"].number,
    autoHeight: _propTypes2["default"].bool,
    autoHeightMin: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    autoHeightMax: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
    universal: _propTypes2["default"].bool,
    style: _propTypes2["default"].object,
    children: _propTypes2["default"].node
};

Scrollbars.defaultProps = {
    renderView: _defaultRenderElements.renderViewDefault,
    renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
    renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
    renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
    renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};
}(Scrollbars$1));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scrollbars = undefined;

var _Scrollbars = Scrollbars$1;

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Scrollbars2["default"];
exports.Scrollbars = _Scrollbars2["default"];
}(lib$2));

var Scrollbars = /*@__PURE__*/getDefaultExportFromCjs(lib$2);

const PNG = {
    [ChainId.FUJI]: new Token$2(ChainId.FUJI, CHAINS[ChainId.FUJI].contracts.png, 18, CHAINS[ChainId.FUJI].png_symbol, 'Pangolin'),
    [ChainId.AVALANCHE]: new Token$2(ChainId.AVALANCHE, CHAINS[ChainId.AVALANCHE].contracts.png, 18, CHAINS[ChainId.AVALANCHE].png_symbol, 'Pangolin'),
    [ChainId.WAGMI]: new Token$2(ChainId.WAGMI, CHAINS[ChainId.WAGMI].contracts.png, 18, CHAINS[ChainId.WAGMI].png_symbol, 'Wagmi Pangolin'),
    [ChainId.COSTON]: new Token$2(ChainId.COSTON, CHAINS[ChainId.COSTON].contracts.png, 18, CHAINS[ChainId.COSTON].png_symbol, 'Wagmi Pangolin'),
};

function useToggle(initialState = false) {
    const [state, setState] = useState(initialState);
    const toggle = useCallback(() => setState((state) => !state), []);
    return [state, toggle];
}

function useSelectedCurrencyLists() {
    var _a;
    const { chainId = ChainId.AVALANCHE } = usePangolinWeb3();
    const allTokens = useAllTokens();
    const coins = Object.values(allTokens || {});
    let addresses = useSelector((state) => { var _a; return [].concat(((_a = state === null || state === void 0 ? void 0 : state.pwatchlists) === null || _a === void 0 ? void 0 : _a.currencies) || []); });
    addresses = [(_a = PNG[chainId]) === null || _a === void 0 ? void 0 : _a.address, ...addresses];
    let allSelectedToken = [];
    addresses.forEach((address) => {
        const filterTokens = coins.filter((coin) => address.toLowerCase() === coin.address.toLowerCase());
        allSelectedToken = [...allSelectedToken, ...filterTokens];
    });
    return allSelectedToken;
}
function useIsSelectedCurrency(address) {
    var _a;
    const { chainId = ChainId.AVALANCHE } = usePangolinWeb3();
    let addresses = useSelector((state) => { var _a; return [].concat(((_a = state === null || state === void 0 ? void 0 : state.pwatchlists) === null || _a === void 0 ? void 0 : _a.currencies) || []); });
    addresses = [(_a = PNG[chainId]) === null || _a === void 0 ? void 0 : _a.address, ...addresses];
    return (addresses || []).includes(address);
}

const Hidden = styled(Box) `
  ${({ theme, upToExtraSmall }) => upToExtraSmall &&
    theme.mediaWidth.upToExtraSmall `
      display: none;
    `};

  ${({ theme, upToSmall }) => upToSmall &&
    theme.mediaWidth.upToSmall `
      display: none;
    `};

  ${({ theme, upToMedium }) => upToMedium &&
    theme.mediaWidth.upToMedium `
      display: none;
    `};

  ${({ theme, upToLarge }) => upToLarge &&
    theme.mediaWidth.upToLarge `
      display: none;
    `};
`;
const CloseIcon$1 = styled(X$1) `
  cursor: pointer;
`;

var classnames = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var classNames = classnames.exports;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$a(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$a;

function _typeof$q(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$q = function _typeof(obj) { return typeof obj; }; } else { _typeof$q = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$q(obj); }
var SVGContainerPropKeys = ['viewBox', 'children'];
var SVGElementPropKeys = ['aria-activedescendant', 'aria-atomic', 'aria-autocomplete', 'aria-busy', 'aria-checked', 'aria-colcount', 'aria-colindex', 'aria-colspan', 'aria-controls', 'aria-current', 'aria-describedby', 'aria-details', 'aria-disabled', 'aria-errormessage', 'aria-expanded', 'aria-flowto', 'aria-haspopup', 'aria-hidden', 'aria-invalid', 'aria-keyshortcuts', 'aria-label', 'aria-labelledby', 'aria-level', 'aria-live', 'aria-modal', 'aria-multiline', 'aria-multiselectable', 'aria-orientation', 'aria-owns', 'aria-placeholder', 'aria-posinset', 'aria-pressed', 'aria-readonly', 'aria-relevant', 'aria-required', 'aria-roledescription', 'aria-rowcount', 'aria-rowindex', 'aria-rowspan', 'aria-selected', 'aria-setsize', 'aria-sort', 'aria-valuemax', 'aria-valuemin', 'aria-valuenow', 'aria-valuetext', 'className', 'color', 'height', 'id', 'lang', 'max', 'media', 'method', 'min', 'name', 'style', 'target', 'type', 'width', 'role', 'tabIndex', 'accentHeight', 'accumulate', 'additive', 'alignmentBaseline', 'allowReorder', 'alphabetic', 'amplitude', 'arabicForm', 'ascent', 'attributeName', 'attributeType', 'autoReverse', 'azimuth', 'baseFrequency', 'baselineShift', 'baseProfile', 'bbox', 'begin', 'bias', 'by', 'calcMode', 'capHeight', 'clip', 'clipPath', 'clipPathUnits', 'clipRule', 'colorInterpolation', 'colorInterpolationFilters', 'colorProfile', 'colorRendering', 'contentScriptType', 'contentStyleType', 'cursor', 'cx', 'cy', 'd', 'decelerate', 'descent', 'diffuseConstant', 'direction', 'display', 'divisor', 'dominantBaseline', 'dur', 'dx', 'dy', 'edgeMode', 'elevation', 'enableBackground', 'end', 'exponent', 'externalResourcesRequired', 'fill', 'fillOpacity', 'fillRule', 'filter', 'filterRes', 'filterUnits', 'floodColor', 'floodOpacity', 'focusable', 'fontFamily', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle', 'fontVariant', 'fontWeight', 'format', 'from', 'fx', 'fy', 'g1', 'g2', 'glyphName', 'glyphOrientationHorizontal', 'glyphOrientationVertical', 'glyphRef', 'gradientTransform', 'gradientUnits', 'hanging', 'horizAdvX', 'horizOriginX', 'href', 'ideographic', 'imageRendering', 'in2', 'in', 'intercept', 'k1', 'k2', 'k3', 'k4', 'k', 'kernelMatrix', 'kernelUnitLength', 'kerning', 'keyPoints', 'keySplines', 'keyTimes', 'lengthAdjust', 'letterSpacing', 'lightingColor', 'limitingConeAngle', 'local', 'markerEnd', 'markerHeight', 'markerMid', 'markerStart', 'markerUnits', 'markerWidth', 'mask', 'maskContentUnits', 'maskUnits', 'mathematical', 'mode', 'numOctaves', 'offset', 'opacity', 'operator', 'order', 'orient', 'orientation', 'origin', 'overflow', 'overlinePosition', 'overlineThickness', 'paintOrder', 'panose1', 'pathLength', 'patternContentUnits', 'patternTransform', 'patternUnits', 'pointerEvents', 'points', 'pointsAtX', 'pointsAtY', 'pointsAtZ', 'preserveAlpha', 'preserveAspectRatio', 'primitiveUnits', 'r', 'radius', 'refX', 'refY', 'renderingIntent', 'repeatCount', 'repeatDur', 'requiredExtensions', 'requiredFeatures', 'restart', 'result', 'rotate', 'rx', 'ry', 'seed', 'shapeRendering', 'slope', 'spacing', 'specularConstant', 'specularExponent', 'speed', 'spreadMethod', 'startOffset', 'stdDeviation', 'stemh', 'stemv', 'stitchTiles', 'stopColor', 'stopOpacity', 'strikethroughPosition', 'strikethroughThickness', 'string', 'stroke', 'strokeDasharray', 'strokeDashoffset', 'strokeLinecap', 'strokeLinejoin', 'strokeMiterlimit', 'strokeOpacity', 'strokeWidth', 'surfaceScale', 'systemLanguage', 'tableValues', 'targetX', 'targetY', 'textAnchor', 'textDecoration', 'textLength', 'textRendering', 'to', 'transform', 'u1', 'u2', 'underlinePosition', 'underlineThickness', 'unicode', 'unicodeBidi', 'unicodeRange', 'unitsPerEm', 'vAlphabetic', 'values', 'vectorEffect', 'version', 'vertAdvY', 'vertOriginX', 'vertOriginY', 'vHanging', 'vIdeographic', 'viewTarget', 'visibility', 'vMathematical', 'widths', 'wordSpacing', 'writingMode', 'x1', 'x2', 'x', 'xChannelSelector', 'xHeight', 'xlinkActuate', 'xlinkArcrole', 'xlinkHref', 'xlinkRole', 'xlinkShow', 'xlinkTitle', 'xlinkType', 'xmlBase', 'xmlLang', 'xmlns', 'xmlnsXlink', 'xmlSpace', 'y1', 'y2', 'y', 'yChannelSelector', 'z', 'zoomAndPan', 'ref', 'key', 'angle'];
var EventKeys = ['dangerouslySetInnerHTML', 'onCopy', 'onCopyCapture', 'onCut', 'onCutCapture', 'onPaste', 'onPasteCapture', 'onCompositionEnd', 'onCompositionEndCapture', 'onCompositionStart', 'onCompositionStartCapture', 'onCompositionUpdate', 'onCompositionUpdateCapture', 'onFocus', 'onFocusCapture', 'onBlur', 'onBlurCapture', 'onChange', 'onChangeCapture', 'onBeforeInput', 'onBeforeInputCapture', 'onInput', 'onInputCapture', 'onReset', 'onResetCapture', 'onSubmit', 'onSubmitCapture', 'onInvalid', 'onInvalidCapture', 'onLoad', 'onLoadCapture', 'onError', 'onErrorCapture', 'onKeyDown', 'onKeyDownCapture', 'onKeyPress', 'onKeyPressCapture', 'onKeyUp', 'onKeyUpCapture', 'onAbort', 'onAbortCapture', 'onCanPlay', 'onCanPlayCapture', 'onCanPlayThrough', 'onCanPlayThroughCapture', 'onDurationChange', 'onDurationChangeCapture', 'onEmptied', 'onEmptiedCapture', 'onEncrypted', 'onEncryptedCapture', 'onEnded', 'onEndedCapture', 'onLoadedData', 'onLoadedDataCapture', 'onLoadedMetadata', 'onLoadedMetadataCapture', 'onLoadStart', 'onLoadStartCapture', 'onPause', 'onPauseCapture', 'onPlay', 'onPlayCapture', 'onPlaying', 'onPlayingCapture', 'onProgress', 'onProgressCapture', 'onRateChange', 'onRateChangeCapture', 'onSeeked', 'onSeekedCapture', 'onSeeking', 'onSeekingCapture', 'onStalled', 'onStalledCapture', 'onSuspend', 'onSuspendCapture', 'onTimeUpdate', 'onTimeUpdateCapture', 'onVolumeChange', 'onVolumeChangeCapture', 'onWaiting', 'onWaitingCapture', 'onAuxClick', 'onAuxClickCapture', 'onClick', 'onClickCapture', 'onContextMenu', 'onContextMenuCapture', 'onDoubleClick', 'onDoubleClickCapture', 'onDrag', 'onDragCapture', 'onDragEnd', 'onDragEndCapture', 'onDragEnter', 'onDragEnterCapture', 'onDragExit', 'onDragExitCapture', 'onDragLeave', 'onDragLeaveCapture', 'onDragOver', 'onDragOverCapture', 'onDragStart', 'onDragStartCapture', 'onDrop', 'onDropCapture', 'onMouseDown', 'onMouseDownCapture', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseMoveCapture', 'onMouseOut', 'onMouseOutCapture', 'onMouseOver', 'onMouseOverCapture', 'onMouseUp', 'onMouseUpCapture', 'onSelect', 'onSelectCapture', 'onTouchCancel', 'onTouchCancelCapture', 'onTouchEnd', 'onTouchEndCapture', 'onTouchMove', 'onTouchMoveCapture', 'onTouchStart', 'onTouchStartCapture', 'onPointerDown', 'onPointerDownCapture', 'onPointerMove', 'onPointerMoveCapture', 'onPointerUp', 'onPointerUpCapture', 'onPointerCancel', 'onPointerCancelCapture', 'onPointerEnter', 'onPointerEnterCapture', 'onPointerLeave', 'onPointerLeaveCapture', 'onPointerOver', 'onPointerOverCapture', 'onPointerOut', 'onPointerOutCapture', 'onGotPointerCapture', 'onGotPointerCaptureCapture', 'onLostPointerCapture', 'onLostPointerCaptureCapture', 'onScroll', 'onScrollCapture', 'onWheel', 'onWheelCapture', 'onAnimationStart', 'onAnimationStartCapture', 'onAnimationEnd', 'onAnimationEndCapture', 'onAnimationIteration', 'onAnimationIterationCapture', 'onTransitionEnd', 'onTransitionEndCapture']; // Animation Types => TODO: Should be moved when react-smooth is typescriptified.

var filterProps = function filterProps(props, includeEvents, isSvg) {
  if (!props || typeof props === 'function' || typeof props === 'boolean') {
    return null;
  }

  var inputProps = props;

  if ( /*#__PURE__*/isValidElement(props)) {
    inputProps = props.props;
  }

  if (!isObject_1(inputProps)) {
    return null;
  }

  var out = {};
  Object.keys(inputProps).forEach(function (key) {
    // viewBox only exist in <svg />
    if (SVGElementPropKeys.includes(key) || isSvg && SVGContainerPropKeys.includes(key) || includeEvents && EventKeys.includes(key)) {
      out[key] = inputProps[key];
    }
  });
  return out;
};
var adaptEventHandlers = function adaptEventHandlers(props, newHandler) {
  if (!props || typeof props === 'function' || typeof props === 'boolean') {
    return null;
  }

  var inputProps = props;

  if ( /*#__PURE__*/isValidElement(props)) {
    inputProps = props.props;
  }

  if (!isObject_1(inputProps)) {
    return null;
  }

  var out = {};
  Object.keys(inputProps).forEach(function (key) {
    if (EventKeys.includes(key)) {
      out[key] = newHandler || function (e) {
        return inputProps[key](inputProps, e);
      };
    }
  });
  return out;
};

var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
  return function (e) {
    originalHandler(data, index, e);
    return null;
  };
};

var adaptEventsOfChild = function adaptEventsOfChild(props, data, index) {
  if (!isObject_1(props) || _typeof$q(props) !== 'object') {
    return null;
  }

  var out = null;
  Object.keys(props).forEach(function (key) {
    var item = props[key];

    if (EventKeys.includes(key) && typeof item === 'function') {
      if (!out) out = {};
      out[key] = getEventHandlerOfChild(item, data, index);
    }
  });
  return out;
};

function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

function _objectWithoutProperties$c(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$c(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$c(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function Surface(props) {
  var children = props.children,
      width = props.width,
      height = props.height,
      viewBox = props.viewBox,
      className = props.className,
      style = props.style,
      others = _objectWithoutProperties$c(props, ["children", "width", "height", "viewBox", "className", "style"]);

  var svgView = viewBox || {
    width: width,
    height: height,
    x: 0,
    y: 0
  };
  var layerClass = classNames('recharts-surface', className);
  return /*#__PURE__*/React$2.createElement("svg", _extends$o({}, filterProps(others, true, true), {
    className: layerClass,
    width: width,
    height: height,
    style: style,
    viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
    version: "1.1"
  }), children);
}

function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

function _objectWithoutProperties$b(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$b(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$b(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function Layer(props) {
  var children = props.children,
      className = props.className,
      others = _objectWithoutProperties$b(props, ["children", "className"]);

  var layerClass = classNames('recharts-layer', className);
  return /*#__PURE__*/React$2.createElement("g", _extends$n({
    className: layerClass
  }, filterProps(others, true)), children);
}

/** Detect free variable `global` from Node.js. */

var freeGlobal$2 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$2;

var freeGlobal$1 = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$c = freeGlobal$1 || freeSelf$1 || Function('return this')();

var _root = root$c;

var root$b = _root;

/** Built-in value references. */
var Symbol$6 = root$b.Symbol;

var _Symbol = Symbol$6;

var Symbol$5 = _Symbol;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$c.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$c.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$5 ? Symbol$5.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$d.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$b = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$b.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$2(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$2;

var Symbol$4 = _Symbol,
    getRawTag = _getRawTag,
    objectToString$1 = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$4 ? Symbol$4.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$8(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString$1(value);
}

var _baseGetTag = baseGetTag$8;

var baseGetTag$7 = _baseGetTag,
    isObject$9 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$5(value) {
  if (!isObject$9(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$7(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$5;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$3(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$3;

var eq$2 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$2(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var root$a = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$a['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$4 = isFunction_1,
    isMasked = _isMasked,
    isObject$8 = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$a = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$a.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$c).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$8(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$4(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative,
    root$9 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$6(root$9, 'Map');

var _Map = Map$4;

var getNative$5 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$5(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$9.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$b.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$8.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$a.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$3 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$3 || ListCache$2),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;

var _MapCache = MapCache$3;

var ListCache$1 = _ListCache,
    Map$2 = _Map,
    MapCache$2 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || (pairs.length < LARGE_ARRAY_SIZE$1 - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$2(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$2.prototype.clear = stackClear;
Stack$2.prototype['delete'] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;

var _Stack = Stack$2;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache$1 = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$2(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache$1;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;

var _SetCache = SetCache$2;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$2;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$2(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$2;

var SetCache$1 = _SetCache,
    arraySome$1 = _arraySome,
    cacheHas$1 = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache$1 : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome$1(other, function(othValue, othIndex) {
            if (!cacheHas$1(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

var root$8 = _root;

/** Built-in value references. */
var Uint8Array$2 = root$8.Uint8Array;

var _Uint8Array = Uint8Array$2;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$3(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$3;

var Symbol$3 = _Symbol,
    Uint8Array$1 = _Uint8Array,
    eq$1 = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray$2 = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$2 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$1:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;

    case boolTag$2:
    case dateTag$1:
    case numberTag$2:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$1(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$1:
    case stringTag$2:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$2:
      var convert = mapToArray;

    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray$2);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$2:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$2(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$2;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$i = Array.isArray;

var isArray_1 = isArray$i;

var arrayPush$1 = _arrayPush,
    isArray$h = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$h(object) ? result : arrayPush$1(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$1;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$1() {
  return [];
}

var stubArray_1 = stubArray$1;

var arrayFilter = _arrayFilter,
    stubArray = stubArray_1;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$7.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols$1;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$a(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$a;

var baseGetTag$6 = _baseGetTag,
    isObjectLike$9 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$9(value) && baseGetTag$6(value) == argsTag$2;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$8 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$3 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$8(value) && hasOwnProperty$9.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments$3;

var isBuffer$4 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

(function (module, exports) {
var root = _root,
    stubFalse = stubFalse_1;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
}(isBuffer$4, isBuffer$4.exports));

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$3;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength$3;

var baseGetTag$5 = _baseGetTag,
    isLength$2 = isLength_1,
    isObjectLike$7 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    weakMapTag$1 = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag$1] =
typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag$1] = typedArrayTags[numberTag$1] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] =
typedArrayTags[setTag$1] = typedArrayTags[stringTag$1] =
typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$7(value) &&
    isLength$2(value.length) && !!typedArrayTags[baseGetTag$5(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$2(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$2;

var _nodeUtil = {exports: {}};

(function (module, exports) {
var freeGlobal = _freeGlobal;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
}(_nodeUtil, _nodeUtil.exports));

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary$1 = _baseUnary,
    nodeUtil = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$2 = nodeIsTypedArray ? baseUnary$1(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$2;

var baseTimes = _baseTimes,
    isArguments$2 = isArguments_1,
    isArray$g = isArray_1,
    isBuffer$3 = isBuffer$4.exports,
    isIndex$2 = _isIndex,
    isTypedArray$1 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$g(value),
      isArg = !isArr && isArguments$2(value),
      isBuff = !isArr && !isArg && isBuffer$3(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$8.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$2(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$1;

/** Used for built-in method references. */

var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$1(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

  return value === proto;
}

var _isPrototype = isPrototype$1;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$1(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$1;

var overArg = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$1;

var isFunction$3 = isFunction_1,
    isLength$1 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$5(value) {
  return value != null && isLength$1(value.length) && !isFunction$3(value);
}

var isArrayLike_1 = isArrayLike$5;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike$4 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$6(object) {
  return isArrayLike$4(object) ? arrayLikeKeys(object) : baseKeys(object);
}

var keys_1 = keys$6;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys$5 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys$5, getSymbols);
}

var _getAllKeys = getAllKeys$1;

var getAllKeys = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$2.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$6.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var getNative$4 = _getNative,
    root$7 = _root;

/* Built-in method references that are verified to be native. */
var DataView$2 = getNative$4(root$7, 'DataView');

var _DataView = DataView$2;

var getNative$3 = _getNative,
    root$6 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$3(root$6, 'Promise');

var _Promise = Promise$2;

var getNative$2 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var Set$3 = getNative$2(root$5, 'Set');

var _Set = Set$3;

var getNative$1 = _getNative,
    root$4 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = getNative$1(root$4, 'WeakMap');

var _WeakMap = WeakMap$2;

var DataView$1 = _DataView,
    Map$1 = _Map,
    Promise$1 = _Promise,
    Set$2 = _Set,
    WeakMap$1 = _WeakMap,
    baseGetTag$4 = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$2),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$1 = baseGetTag$4;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$1 && getTag$1(new DataView$1(new ArrayBuffer(1))) != dataViewTag) ||
    (Map$1 && getTag$1(new Map$1) != mapTag) ||
    (Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag) ||
    (Set$2 && getTag$1(new Set$2) != setTag) ||
    (WeakMap$1 && getTag$1(new WeakMap$1) != weakMapTag)) {
  getTag$1 = function(value) {
    var result = baseGetTag$4(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

var _getTag = getTag$1;

var Stack$1 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag = _getTag,
    isArray$f = isArray_1,
    isBuffer$2 = isBuffer$4.exports,
    isTypedArray = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$f(object),
      othIsArr = isArray$f(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$2(object)) {
    if (!isBuffer$2(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$5.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$5.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$1);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$6 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$6(value) && !isObjectLike$6(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}

var _baseIsEqual = baseIsEqual$3;

var Stack = _Stack,
    baseIsEqual$2 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$7 = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$7(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys$4 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$4(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

var baseGetTag$3 = _baseGetTag,
    isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$7(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$5(value) && baseGetTag$3(value) == symbolTag$1);
}

var isSymbol_1 = isSymbol$7;

var isArray$e = isArray_1,
    isSymbol$6 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$e(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$6(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$3;

var MapCache = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT$3 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$2(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$2.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$2.Cache = MapCache;

var memoize_1 = memoize$2;

var memoize$1 = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize$1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$3(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$3;

var Symbol$2 = _Symbol,
    arrayMap$2 = _arrayMap,
    isArray$d = isArray_1,
    isSymbol$5 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$d(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$2(value, baseToString$1) + '';
  }
  if (isSymbol$5(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$3) ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$9(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$9;

var isArray$c = isArray_1,
    isKey$2 = _isKey,
    stringToPath = _stringToPath,
    toString$8 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$2(value, object) {
  if (isArray$c(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString$8(value));
}

var _castPath = castPath$2;

var isSymbol$4 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$4(value) {
  if (typeof value == 'string' || isSymbol$4(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _toKey = toKey$4;

var castPath$1 = _castPath,
    toKey$3 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$3(object, path) {
  path = castPath$1(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$3(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$3;

var baseGet$2 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$2(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var castPath = _castPath,
    isArguments$1 = isArguments_1,
    isArray$b = isArray_1,
    isIndex$1 = _isIndex,
    isLength = isLength_1,
    toKey$2 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$2(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex$1(key, length) &&
    (isArray$b(object) || isArguments$1(object));
}

var _hasPath = hasPath$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$1;

var baseIsEqual$1 = _baseIsEqual,
    get = get_1,
    hasIn = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$1 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$i(value) {
  return value;
}

var identity_1 = identity$i;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet$1 = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet$1(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity$h = identity_1,
    isArray$a = isArray_1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$8(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$h;
  }
  if (typeof value == 'object') {
    return isArray$a(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$8;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex$2(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex$2;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */

function baseIsNaN$1(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN$1;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf$1;

var baseFindIndex$1 = _baseFindIndex,
    baseIsNaN = _baseIsNaN,
    strictIndexOf = _strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$1(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex$1(array, baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf$1;

var baseIndexOf = _baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes$1(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes = arrayIncludes$1;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */

function arrayIncludesWith$1(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

var _arrayIncludesWith = arrayIncludesWith$1;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */

function noop$4() {
  // No operation performed.
}

var noop_1 = noop$4;

var Set$1 = _Set,
    noop$3 = noop_1,
    setToArray$1 = _setToArray;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet$1 = !(Set$1 && (1 / setToArray$1(new Set$1([,-0]))[1]) == INFINITY$1) ? noop$3 : function(values) {
  return new Set$1(values);
};

var _createSet = createSet$1;

var SetCache = _SetCache,
    arrayIncludes = _arrayIncludes,
    arrayIncludesWith = _arrayIncludesWith,
    cacheHas = _cacheHas,
    createSet = _createSet,
    setToArray = _setToArray;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq$1(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

var _baseUniq = baseUniq$1;

var baseIteratee$7 = _baseIteratee,
    baseUniq = _baseUniq;

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee$7(iteratee)) : [];
}

var uniqBy_1 = uniqBy;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$1(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$1;

var baseSlice = _baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$1(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

var _castSlice = castSlice$1;

/** Used to compose unicode character classes. */

var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ$1 = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1  + rsComboRange$1 + rsVarRange$1 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode$2;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

function asciiToArray$1(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray$1;

/** Used to compose unicode character classes. */

var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray$1;

var asciiToArray = _asciiToArray,
    hasUnicode$1 = _hasUnicode,
    unicodeToArray = _unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$1(string) {
  return hasUnicode$1(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

var _stringToArray = stringToArray$1;

var castSlice = _castSlice,
    hasUnicode = _hasUnicode,
    stringToArray = _stringToArray,
    toString$7 = toString_1;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$7(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst$1;

var createCaseFirst = _createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst;

const pi$1 = Math.PI,
    tau$1 = 2 * pi$1,
    epsilon = 1e-6,
    tauEpsilon = tau$1 - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path$1() {
  return new Path;
}

Path.prototype = path$1.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau$1 + tau$1;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$1)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

function constant$3(x) {
  return function constant() {
    return x;
  };
}

var pi = Math.PI;
var tau = 2 * pi;

function array(x) {
  return typeof x === "object" && "length" in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
}

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

function curveLinear(context) {
  return new Linear(context);
}

function x$1(p) {
  return p[0];
}

function y$1(p) {
  return p[1];
}

function shapeLine(x, y) {
  var defined = constant$3(true),
      context = null,
      curve = curveLinear,
      output = null;

  x = typeof x === "function" ? x : (x === undefined) ? x$1 : constant$3(x);
  y = typeof y === "function" ? y : (y === undefined) ? y$1 : constant$3(y);

  function line(data) {
    var i,
        n = (data = array(data)).length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = path$1());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : constant$3(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : constant$3(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$3(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
}

function shapeArea(x0, y0, y1) {
  var x1 = null,
      defined = constant$3(true),
      context = null,
      curve = curveLinear,
      output = null;

  x0 = typeof x0 === "function" ? x0 : (x0 === undefined) ? x$1 : constant$3(+x0);
  y0 = typeof y0 === "function" ? y0 : (y0 === undefined) ? constant$3(0) : constant$3(+y0);
  y1 = typeof y1 === "function" ? y1 : (y1 === undefined) ? y$1 : constant$3(+y1);

  function area(data) {
    var i,
        j,
        k,
        n = (data = array(data)).length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = path$1());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return shapeLine().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$3(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$3(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$3(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$3(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$3(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$3(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$3(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
}

var symbolCircle = {
  draw: function(context, size) {
    var r = Math.sqrt(size / pi);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau);
  }
};

var symbolCross = {
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
};

var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

var symbolDiamond = {
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
};

var ka = 0.89081309152928522810,
    kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
    kx = Math.sin(tau / 10) * kr,
    ky = -Math.cos(tau / 10) * kr;

var symbolStar = {
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = tau * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
};

var symbolSquare = {
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
};

var sqrt3 = Math.sqrt(3);

var symbolTriangle = {
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
};

var c$2 = -0.5,
    s = Math.sqrt(3) / 2,
    k$2 = 1 / Math.sqrt(12),
    a = (k$2 / 2 + 1) * 3;

var symbolWye = {
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k$2,
        x1 = x0,
        y1 = r * k$2 + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c$2 * x0 - s * y0, s * x0 + c$2 * y0);
    context.lineTo(c$2 * x1 - s * y1, s * x1 + c$2 * y1);
    context.lineTo(c$2 * x2 - s * y2, s * x2 + c$2 * y2);
    context.lineTo(c$2 * x0 + s * y0, c$2 * y0 - s * x0);
    context.lineTo(c$2 * x1 + s * y1, c$2 * y1 - s * x1);
    context.lineTo(c$2 * x2 + s * y2, c$2 * y2 - s * x2);
    context.closePath();
  }
};

function shapeSymbol(type, size) {
  var context = null;
  type = typeof type === "function" ? type : constant$3(type || symbolCircle);
  size = typeof size === "function" ? size : constant$3(size === undefined ? 64 : +size);

  function symbol() {
    var buffer;
    if (!context) context = buffer = path$1();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : constant$3(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : constant$3(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
}

function noop$2() {}

function point$4(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point$4(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point$4(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function curveBasis(context) {
  return new Basis(context);
}

function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: point$4(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function curveBasisClosed(context) {
  return new BasisClosed(context);
}

function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: point$4(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function curveBasisOpen(context) {
  return new BasisOpen(context);
}

function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

function curveLinearClosed(context) {
  return new LinearClosed(context);
}

function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point$3(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

function curveNatural(context) {
  return new Natural(context);
}

function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

function curveStep(context) {
  return new Step(context, 0.5);
}

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}

function stackOffsetNone(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}

function stackOrderNone(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}

function stackValue(d, key) {
  return d[key];
}

function stackSeries(key) {
  const series = [];
  series.key = key;
  return series;
}

function shapeStack() {
  var keys = constant$3([]),
      order = stackOrderNone,
      offset = stackOffsetNone,
      value = stackValue;

  function stack(data) {
    var sz = Array.from(keys.apply(this, arguments), stackSeries),
        i, n = sz.length, j = -1,
        oz;

    for (const d of data) {
      for (i = 0, ++j; i < n; ++i) {
        (sz[i][j] = [0, +value(d, sz[i].key, j, data)]).data = d;
      }
    }

    for (i = 0, oz = array(order(sz)); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$3(Array.from(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant$3(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? stackOrderNone : typeof _ === "function" ? _ : constant$3(Array.from(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? stackOffsetNone : _, stack) : offset;
  };

  return stack;
}

function stackOffsetExpand(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  stackOffsetNone(series, order);
}

function stackOffsetSilhouette(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  stackOffsetNone(series, order);
}

function stackOffsetWiggle(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  stackOffsetNone(series, order);
}

function _typeof$p(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$p = function _typeof(obj) { return typeof obj; }; } else { _typeof$p = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$p(obj); }

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

function _classCallCheck$n(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$o(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$o(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$o(Constructor.prototype, protoProps); if (staticProps) _defineProperties$o(Constructor, staticProps); return Constructor; }

function _inherits$l(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$l(subClass, superClass); }

function _setPrototypeOf$l(o, p) { _setPrototypeOf$l = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$l(o, p); }

function _createSuper$k(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$k(); return function _createSuperInternal() { var Super = _getPrototypeOf$l(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$l(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$l(this, result); }; }

function _possibleConstructorReturn$l(self, call) { if (call && (_typeof$p(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$l(self); }

function _assertThisInitialized$l(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$k() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$l(o) { _getPrototypeOf$l = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$l(o); }
var symbolFactories = {
  symbolCircle: symbolCircle,
  symbolCross: symbolCross,
  symbolDiamond: symbolDiamond,
  symbolSquare: symbolSquare,
  symbolStar: symbolStar,
  symbolTriangle: symbolTriangle,
  symbolWye: symbolWye
};
var RADIAN$1 = Math.PI / 180;

var getSymbolFactory = function getSymbolFactory(type) {
  var name = "symbol".concat(upperFirst_1(type));
  return symbolFactories[name] || symbolCircle;
};

var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
  if (sizeType === 'area') {
    return size;
  }

  switch (type) {
    case 'cross':
      return 5 * size * size / 9;

    case 'diamond':
      return 0.5 * size * size / Math.sqrt(3);

    case 'square':
      return size * size;

    case 'star':
      {
        var angle = 18 * RADIAN$1;
        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
      }

    case 'triangle':
      return Math.sqrt(3) * size * size / 4;

    case 'wye':
      return (21 - 10 * Math.sqrt(3)) * size * size / 8;

    default:
      return Math.PI * size * size / 4;
  }
};

var Symbols = /*#__PURE__*/function (_PureComponent) {
  _inherits$l(Symbols, _PureComponent);

  var _super = _createSuper$k(Symbols);

  function Symbols() {
    _classCallCheck$n(this, Symbols);

    return _super.apply(this, arguments);
  }

  _createClass$o(Symbols, [{
    key: "getPath",
    value:
    /**
     * Calculate the path of curve
     * @return {String} path
     */
    function getPath() {
      var _this$props = this.props,
          size = _this$props.size,
          sizeType = _this$props.sizeType,
          type = _this$props.type;
      var symbolFactory = getSymbolFactory(type);
      var symbol = shapeSymbol().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
      return symbol();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          cx = _this$props2.cx,
          cy = _this$props2.cy,
          size = _this$props2.size;

      if (cx === +cx && cy === +cy && size === +size) {
        return /*#__PURE__*/React$2.createElement("path", _extends$m({}, filterProps(this.props, true), {
          className: classNames('recharts-symbols', className),
          transform: "translate(".concat(cx, ", ").concat(cy, ")"),
          d: this.getPath()
        }));
      }

      return null;
    }
  }]);

  return Symbols;
}(PureComponent);
Symbols.defaultProps = {
  type: 'circle',
  size: 64,
  sizeType: 'area'
};

Symbols.registerSymbol = function (key, factory) {
  symbolFactories["symbol".concat(upperFirst_1(key))] = factory;
};

function _typeof$o(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$o = function _typeof(obj) { return typeof obj; }; } else { _typeof$o = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$o(obj); }

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

function ownKeys$t(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$s(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$t(Object(source), true).forEach(function (key) { _defineProperty$u(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$t(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$u(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$m(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$n(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$n(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$n(Constructor.prototype, protoProps); if (staticProps) _defineProperties$n(Constructor, staticProps); return Constructor; }

function _inherits$k(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$k(subClass, superClass); }

function _setPrototypeOf$k(o, p) { _setPrototypeOf$k = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$k(o, p); }

function _createSuper$j(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$j(); return function _createSuperInternal() { var Super = _getPrototypeOf$k(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$k(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$k(this, result); }; }

function _possibleConstructorReturn$k(self, call) { if (call && (_typeof$o(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$k(self); }

function _assertThisInitialized$k(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$j() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$k(o) { _getPrototypeOf$k = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$k(o); }
var SIZE = 32;
var DefaultLegendContent = /*#__PURE__*/function (_PureComponent) {
  _inherits$k(DefaultLegendContent, _PureComponent);

  var _super = _createSuper$j(DefaultLegendContent);

  function DefaultLegendContent() {
    _classCallCheck$m(this, DefaultLegendContent);

    return _super.apply(this, arguments);
  }

  _createClass$n(DefaultLegendContent, [{
    key: "renderIcon",
    value:
    /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */
    function renderIcon(data) {
      var inactiveColor = this.props.inactiveColor;
      var halfSize = SIZE / 2;
      var sixthSize = SIZE / 6;
      var thirdSize = SIZE / 3;
      var color = data.inactive ? inactiveColor : data.color;

      if (data.type === 'plainline') {
        return /*#__PURE__*/React$2.createElement("line", {
          strokeWidth: 4,
          fill: "none",
          stroke: color,
          strokeDasharray: data.payload.strokeDasharray,
          x1: 0,
          y1: halfSize,
          x2: SIZE,
          y2: halfSize,
          className: "recharts-legend-icon"
        });
      }

      if (data.type === 'line') {
        return /*#__PURE__*/React$2.createElement("path", {
          strokeWidth: 4,
          fill: "none",
          stroke: color,
          d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
          className: "recharts-legend-icon"
        });
      }

      if (data.type === 'rect') {
        return /*#__PURE__*/React$2.createElement("path", {
          stroke: "none",
          fill: color,
          d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
          className: "recharts-legend-icon"
        });
      }

      if ( /*#__PURE__*/React$2.isValidElement(data.legendIcon)) {
        var iconProps = _objectSpread$s({}, data);

        delete iconProps.legendIcon;
        return /*#__PURE__*/React$2.cloneElement(data.legendIcon, iconProps);
      }

      return /*#__PURE__*/React$2.createElement(Symbols, {
        fill: color,
        cx: halfSize,
        cy: halfSize,
        size: SIZE,
        sizeType: "diameter",
        type: data.type
      });
    }
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */

  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this = this;

      var _this$props = this.props,
          payload = _this$props.payload,
          iconSize = _this$props.iconSize,
          layout = _this$props.layout,
          formatter = _this$props.formatter,
          inactiveColor = _this$props.inactiveColor;
      var viewBox = {
        x: 0,
        y: 0,
        width: SIZE,
        height: SIZE
      };
      var itemStyle = {
        display: layout === 'horizontal' ? 'inline-block' : 'block',
        marginRight: 10
      };
      var svgStyle = {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: 4
      };
      return payload.map(function (entry, i) {
        var _classNames;

        var finalFormatter = entry.formatter || formatter;
        var className = classNames((_classNames = {
          'recharts-legend-item': true
        }, _defineProperty$u(_classNames, "legend-item-".concat(i), true), _defineProperty$u(_classNames, "inactive", entry.inactive), _classNames));

        if (entry.type === 'none') {
          return null;
        }

        var color = entry.inactive ? inactiveColor : entry.color;
        return /*#__PURE__*/React$2.createElement("li", _extends$l({
          className: className,
          style: itemStyle,
          key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key

        }, adaptEventsOfChild(_this.props, entry, i)), /*#__PURE__*/React$2.createElement(Surface, {
          width: iconSize,
          height: iconSize,
          viewBox: viewBox,
          style: svgStyle
        }, _this.renderIcon(entry)), /*#__PURE__*/React$2.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: color
          }
        }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          payload = _this$props2.payload,
          layout = _this$props2.layout,
          align = _this$props2.align;

      if (!payload || !payload.length) {
        return null;
      }

      var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout === 'horizontal' ? align : 'left'
      };
      return /*#__PURE__*/React$2.createElement("ul", {
        className: "recharts-default-legend",
        style: finalStyle
      }, this.renderItems());
    }
  }]);

  return DefaultLegendContent;
}(PureComponent);
DefaultLegendContent.displayName = 'Legend';
DefaultLegendContent.defaultProps = {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'middle',
  inactiveColor: '#ccc'
};

var baseGetTag$2 = _baseGetTag,
    isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber$3(value) {
  return typeof value == 'number' ||
    (isObjectLike$4(value) && baseGetTag$2(value) == numberTag);
}

var isNumber_1 = isNumber$3;

var isNumber$2 = isNumber_1;

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN$1(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber$2(value) && value != +value;
}

var _isNaN = isNaN$1;

var baseGetTag$1 = _baseGetTag,
    isArray$9 = isArray_1,
    isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString$1(value) {
  return typeof value == 'string' ||
    (!isArray$9(value) && isObjectLike$3(value) && baseGetTag$1(value) == stringTag);
}

var isString_1 = isString$1;

var mathSign = function mathSign(value) {
  if (value === 0) {
    return 0;
  }

  if (value > 0) {
    return 1;
  }

  return -1;
};
var isPercent = function isPercent(value) {
  return isString_1(value) && value.indexOf('%') === value.length - 1;
};
var isNumber$1 = function isNumber(value) {
  return isNumber_1(value) && !_isNaN(value);
};
var isNumOrStr = function isNumOrStr(value) {
  return isNumber$1(value) || isString_1(value);
};
var idCounter$1 = 0;
var uniqueId = function uniqueId(prefix) {
  var id = ++idCounter$1;
  return "".concat(prefix || '').concat(id);
};
/**
 * Get percent value of a total value
 * @param {Number|String} percent A percent
 * @param {Number} totalValue     Total value
 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
 * @param {Boolean} validate      If set to be true, the result will be validated
 * @return {Number} value
 */

var getPercentValue = function getPercentValue(percent, totalValue) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!isNumber$1(percent) && !isString_1(percent)) {
    return defaultValue;
  }

  var value;

  if (isPercent(percent)) {
    var index = percent.indexOf('%');
    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
  } else {
    value = +percent;
  }

  if (_isNaN(value)) {
    value = defaultValue;
  }

  if (validate && value > totalValue) {
    value = totalValue;
  }

  return value;
};
var getAnyElementOfObject = function getAnyElementOfObject(obj) {
  if (!obj) {
    return null;
  }

  var keys = Object.keys(obj);

  if (keys && keys.length) {
    return obj[keys[0]];
  }

  return null;
};
var hasDuplicate = function hasDuplicate(ary) {
  if (!isArray_1(ary)) {
    return false;
  }

  var len = ary.length;
  var cache = {};

  for (var i = 0; i < len; i++) {
    if (!cache[ary[i]]) {
      cache[ary[i]] = true;
    } else {
      return true;
    }
  }

  return false;
};
var interpolateNumber$2 = function interpolateNumber(numberA, numberB) {
  if (isNumber$1(numberA) && isNumber$1(numberB)) {
    return function (t) {
      return numberA + t * (numberB - numberA);
    };
  }

  return function () {
    return numberB;
  };
};
function findEntryInArray(ary, specifiedKey, specifiedValue) {
  if (!ary || !ary.length) {
    return null;
  }

  return ary.find(function (entry) {
    return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : get_1(entry, specifiedKey)) === specifiedValue;
  });
}

function _typeof$n(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$n = function _typeof(obj) { return typeof obj; }; } else { _typeof$n = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$n(obj); }

function ownKeys$s(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$r(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$s(Object(source), true).forEach(function (key) { _defineProperty$t(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$s(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$t(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$l(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$m(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$m(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$m(Constructor.prototype, protoProps); if (staticProps) _defineProperties$m(Constructor, staticProps); return Constructor; }

function _inherits$j(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$j(subClass, superClass); }

function _setPrototypeOf$j(o, p) { _setPrototypeOf$j = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$j(o, p); }

function _createSuper$i(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$i(); return function _createSuperInternal() { var Super = _getPrototypeOf$j(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$j(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$j(this, result); }; }

function _possibleConstructorReturn$j(self, call) { if (call && (_typeof$n(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$j(self); }

function _assertThisInitialized$j(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$i() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$j(o) { _getPrototypeOf$j = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$j(o); }

function _objectWithoutProperties$a(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$a(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$a(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function defaultUniqBy$1(entry) {
  return entry.value;
}

function getUniqPayload$1(option, payload) {
  if (option === true) {
    return uniqBy_1(payload, defaultUniqBy$1);
  }

  if (isFunction_1(option)) {
    return uniqBy_1(payload, option);
  }

  return payload;
}

function renderContent$1(content, props) {
  if ( /*#__PURE__*/React$2.isValidElement(content)) {
    return /*#__PURE__*/React$2.cloneElement(content, props);
  }

  if (isFunction_1(content)) {
    return /*#__PURE__*/React$2.createElement(content, props);
  }

  props.ref;
      var otherProps = _objectWithoutProperties$a(props, ["ref"]);

  return /*#__PURE__*/React$2.createElement(DefaultLegendContent, otherProps);
}

var EPS$2 = 1;
var Legend = /*#__PURE__*/function (_PureComponent) {
  _inherits$j(Legend, _PureComponent);

  var _super = _createSuper$i(Legend);

  function Legend() {
    var _this;

    _classCallCheck$l(this, Legend);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.wrapperNode = void 0;
    _this.state = {
      boxWidth: -1,
      boxHeight: -1
    };
    return _this;
  }

  _createClass$m(Legend, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function getBBox() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        return this.wrapperNode.getBoundingClientRect();
      }

      return null;
    }
  }, {
    key: "getBBoxSnapshot",
    value: function getBBoxSnapshot() {
      var _this$state = this.state,
          boxWidth = _this$state.boxWidth,
          boxHeight = _this$state.boxHeight;

      if (boxWidth >= 0 && boxHeight >= 0) {
        return {
          width: boxWidth,
          height: boxHeight
        };
      }

      return null;
    }
  }, {
    key: "getDefaultPosition",
    value: function getDefaultPosition(style) {
      var _this$props = this.props,
          layout = _this$props.layout,
          align = _this$props.align,
          verticalAlign = _this$props.verticalAlign,
          margin = _this$props.margin,
          chartWidth = _this$props.chartWidth,
          chartHeight = _this$props.chartHeight;
      var hPos, vPos;

      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
        if (align === 'center' && layout === 'vertical') {
          var _box = this.getBBoxSnapshot() || {
            width: 0
          };

          hPos = {
            left: ((chartWidth || 0) - _box.width) / 2
          };
        } else {
          hPos = align === 'right' ? {
            right: margin && margin.right || 0
          } : {
            left: margin && margin.left || 0
          };
        }
      }

      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
        if (verticalAlign === 'middle') {
          var _box2 = this.getBBoxSnapshot() || {
            height: 0
          };

          vPos = {
            top: ((chartHeight || 0) - _box2.height) / 2
          };
        } else {
          vPos = verticalAlign === 'bottom' ? {
            bottom: margin && margin.bottom || 0
          } : {
            top: margin && margin.top || 0
          };
        }
      }

      return _objectSpread$r(_objectSpread$r({}, hPos), vPos);
    }
  }, {
    key: "updateBBox",
    value: function updateBBox() {
      var _this$state2 = this.state,
          boxWidth = _this$state2.boxWidth,
          boxHeight = _this$state2.boxHeight;
      var onBBoxUpdate = this.props.onBBoxUpdate;

      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var _box3 = this.wrapperNode.getBoundingClientRect();

        if (Math.abs(_box3.width - boxWidth) > EPS$2 || Math.abs(_box3.height - boxHeight) > EPS$2) {
          this.setState({
            boxWidth: _box3.width,
            boxHeight: _box3.height
          }, function () {
            if (onBBoxUpdate) {
              onBBoxUpdate(_box3);
            }
          });
        }
      } else if (boxWidth !== -1 || boxHeight !== -1) {
        this.setState({
          boxWidth: -1,
          boxHeight: -1
        }, function () {
          if (onBBoxUpdate) {
            onBBoxUpdate(null);
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          content = _this$props2.content,
          width = _this$props2.width,
          height = _this$props2.height,
          wrapperStyle = _this$props2.wrapperStyle,
          payloadUniqBy = _this$props2.payloadUniqBy,
          payload = _this$props2.payload;

      var outerStyle = _objectSpread$r(_objectSpread$r({
        position: 'absolute',
        width: width || 'auto',
        height: height || 'auto'
      }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);

      return /*#__PURE__*/React$2.createElement("div", {
        className: "recharts-legend-wrapper",
        style: outerStyle,
        ref: function ref(node) {
          _this2.wrapperNode = node;
        }
      }, renderContent$1(content, _objectSpread$r(_objectSpread$r({}, this.props), {}, {
        payload: getUniqPayload$1(payloadUniqBy, payload)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function getWithHeight(item, chartWidth) {
      var layout = item.props.layout;

      if (layout === 'vertical' && isNumber$1(item.props.height)) {
        return {
          height: item.props.height
        };
      }

      if (layout === 'horizontal') {
        return {
          width: item.props.width || chartWidth
        };
      }

      return null;
    }
  }]);

  return Legend;
}(PureComponent);
Legend.displayName = 'Legend';
Legend.defaultProps = {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom'
};

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */

function isNil(value) {
  return value == null;
}

var isNil_1 = isNil;

var HAS_WEAKSET_SUPPORT = typeof WeakSet === 'function';
var keys$3 = Object.keys;
/**
 * are the values passed strictly equal or both NaN
 *
 * @param a the value to compare against
 * @param b the value to test
 * @returns are the values equal by the SameValueZero principle
 */
function sameValueZeroEqual(a, b) {
    return a === b || (a !== a && b !== b);
}
/**
 * is the value a plain object
 *
 * @param value the value to test
 * @returns is the value a plain object
 */
function isPlainObject$3(value) {
    return value.constructor === Object || value.constructor == null;
}
/**
 * is the value promise-like (meaning it is thenable)
 *
 * @param value the value to test
 * @returns is the value promise-like
 */
function isPromiseLike(value) {
    return !!value && typeof value.then === 'function';
}
/**
 * is the value passed a react element
 *
 * @param value the value to test
 * @returns is the value a react element
 */
function isReactElement(value) {
    return !!(value && value.$$typeof);
}
/**
 * in cases where WeakSet is not supported, creates a new custom
 * object that mimics the necessary API aspects for cache purposes
 *
 * @returns the new cache object
 */
function getNewCacheFallback() {
    var values = [];
    return {
        add: function (value) {
            values.push(value);
        },
        has: function (value) {
            return values.indexOf(value) !== -1;
        },
    };
}
/**
 * get a new cache object to prevent circular references
 *
 * @returns the new cache object
 */
var getNewCache = (function (canUseWeakMap) {
    if (canUseWeakMap) {
        return function _getNewCache() {
            return new WeakSet();
        };
    }
    return getNewCacheFallback;
})(HAS_WEAKSET_SUPPORT);
/**
 * create a custom isEqual handler specific to circular objects
 *
 * @param [isEqual] the isEqual comparator to use instead of isDeepEqual
 * @returns the method to create the `isEqual` function
 */
function createCircularEqualCreator(isEqual) {
    return function createCircularEqual(comparator) {
        var _comparator = isEqual || comparator;
        return function circularEqual(a, b, cache) {
            if (cache === void 0) { cache = getNewCache(); }
            var isCacheableA = !!a && typeof a === 'object';
            var isCacheableB = !!b && typeof b === 'object';
            if (isCacheableA || isCacheableB) {
                var hasA = isCacheableA && cache.has(a);
                var hasB = isCacheableB && cache.has(b);
                if (hasA || hasB) {
                    return hasA && hasB;
                }
                if (isCacheableA) {
                    cache.add(a);
                }
                if (isCacheableB) {
                    cache.add(b);
                }
            }
            return _comparator(a, b, cache);
        };
    };
}
/**
 * are the arrays equal in value
 *
 * @param a the array to test
 * @param b the array to test against
 * @param isEqual the comparator to determine equality
 * @param meta the meta object to pass through
 * @returns are the arrays equal
 */
function areArraysEqual(a, b, isEqual, meta) {
    var index = a.length;
    if (b.length !== index) {
        return false;
    }
    while (index-- > 0) {
        if (!isEqual(a[index], b[index], meta)) {
            return false;
        }
    }
    return true;
}
/**
 * are the maps equal in value
 *
 * @param a the map to test
 * @param b the map to test against
 * @param isEqual the comparator to determine equality
 * @param meta the meta map to pass through
 * @returns are the maps equal
 */
function areMapsEqual(a, b, isEqual, meta) {
    var isValueEqual = a.size === b.size;
    if (isValueEqual && a.size) {
        var matchedIndices_1 = {};
        a.forEach(function (aValue, aKey) {
            if (isValueEqual) {
                var hasMatch_1 = false;
                var matchIndex_1 = 0;
                b.forEach(function (bValue, bKey) {
                    if (!hasMatch_1 && !matchedIndices_1[matchIndex_1]) {
                        hasMatch_1 =
                            isEqual(aKey, bKey, meta) && isEqual(aValue, bValue, meta);
                        if (hasMatch_1) {
                            matchedIndices_1[matchIndex_1] = true;
                        }
                    }
                    matchIndex_1++;
                });
                isValueEqual = hasMatch_1;
            }
        });
    }
    return isValueEqual;
}
var OWNER = '_owner';
var hasOwnProperty$4 = Function.prototype.bind.call(Function.prototype.call, Object.prototype.hasOwnProperty);
/**
 * are the objects equal in value
 *
 * @param a the object to test
 * @param b the object to test against
 * @param isEqual the comparator to determine equality
 * @param meta the meta object to pass through
 * @returns are the objects equal
 */
function areObjectsEqual(a, b, isEqual, meta) {
    var keysA = keys$3(a);
    var index = keysA.length;
    if (keys$3(b).length !== index) {
        return false;
    }
    if (index) {
        var key = void 0;
        while (index-- > 0) {
            key = keysA[index];
            if (key === OWNER) {
                var reactElementA = isReactElement(a);
                var reactElementB = isReactElement(b);
                if ((reactElementA || reactElementB) &&
                    reactElementA !== reactElementB) {
                    return false;
                }
            }
            if (!hasOwnProperty$4(b, key) || !isEqual(a[key], b[key], meta)) {
                return false;
            }
        }
    }
    return true;
}
/**
 * are the regExps equal in value
 *
 * @param a the regExp to test
 * @param b the regExp to test agains
 * @returns are the regExps equal
 */
function areRegExpsEqual(a, b) {
    return (a.source === b.source &&
        a.global === b.global &&
        a.ignoreCase === b.ignoreCase &&
        a.multiline === b.multiline &&
        a.unicode === b.unicode &&
        a.sticky === b.sticky &&
        a.lastIndex === b.lastIndex);
}
/**
 * are the sets equal in value
 *
 * @param a the set to test
 * @param b the set to test against
 * @param isEqual the comparator to determine equality
 * @param meta the meta set to pass through
 * @returns are the sets equal
 */
function areSetsEqual(a, b, isEqual, meta) {
    var isValueEqual = a.size === b.size;
    if (isValueEqual && a.size) {
        var matchedIndices_2 = {};
        a.forEach(function (aValue) {
            if (isValueEqual) {
                var hasMatch_2 = false;
                var matchIndex_2 = 0;
                b.forEach(function (bValue) {
                    if (!hasMatch_2 && !matchedIndices_2[matchIndex_2]) {
                        hasMatch_2 = isEqual(aValue, bValue, meta);
                        if (hasMatch_2) {
                            matchedIndices_2[matchIndex_2] = true;
                        }
                    }
                    matchIndex_2++;
                });
                isValueEqual = hasMatch_2;
            }
        });
    }
    return isValueEqual;
}

var HAS_MAP_SUPPORT = typeof Map === 'function';
var HAS_SET_SUPPORT = typeof Set === 'function';
function createComparator(createIsEqual) {
    var isEqual = 
    /* eslint-disable no-use-before-define */
    typeof createIsEqual === 'function'
        ? createIsEqual(comparator)
        : comparator;
    /* eslint-enable */
    /**
     * compare the value of the two objects and return true if they are equivalent in values
     *
     * @param a the value to test against
     * @param b the value to test
     * @param [meta] an optional meta object that is passed through to all equality test calls
     * @returns are a and b equivalent in value
     */
    function comparator(a, b, meta) {
        if (a === b) {
            return true;
        }
        if (a && b && typeof a === 'object' && typeof b === 'object') {
            if (isPlainObject$3(a) && isPlainObject$3(b)) {
                return areObjectsEqual(a, b, isEqual, meta);
            }
            var aShape = Array.isArray(a);
            var bShape = Array.isArray(b);
            if (aShape || bShape) {
                return aShape === bShape && areArraysEqual(a, b, isEqual, meta);
            }
            aShape = a instanceof Date;
            bShape = b instanceof Date;
            if (aShape || bShape) {
                return (aShape === bShape && sameValueZeroEqual(a.getTime(), b.getTime()));
            }
            aShape = a instanceof RegExp;
            bShape = b instanceof RegExp;
            if (aShape || bShape) {
                return aShape === bShape && areRegExpsEqual(a, b);
            }
            if (isPromiseLike(a) || isPromiseLike(b)) {
                return a === b;
            }
            if (HAS_MAP_SUPPORT) {
                aShape = a instanceof Map;
                bShape = b instanceof Map;
                if (aShape || bShape) {
                    return aShape === bShape && areMapsEqual(a, b, isEqual, meta);
                }
            }
            if (HAS_SET_SUPPORT) {
                aShape = a instanceof Set;
                bShape = b instanceof Set;
                if (aShape || bShape) {
                    return aShape === bShape && areSetsEqual(a, b, isEqual, meta);
                }
            }
            return areObjectsEqual(a, b, isEqual, meta);
        }
        return a !== a && b !== b;
    }
    return comparator;
}

var deepEqual = createComparator();
createComparator(function () { return sameValueZeroEqual; });
createComparator(createCircularEqualCreator());
createComparator(createCircularEqualCreator(sameValueZeroEqual));

function setRafTimeout(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var currTime = -1;

  var shouldUpdate = function shouldUpdate(now) {
    if (currTime < 0) {
      currTime = now;
    }

    if (now - currTime > timeout) {
      callback(now);
      currTime = -1;
    } else {
      raf$1(shouldUpdate);
    }
  };

  raf$1(shouldUpdate);
}

function _typeof$m(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$m = function _typeof(obj) { return typeof obj; }; } else { _typeof$m = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$m(obj); }

function _toArray(arr) { return _arrayWithHoles$9(arr) || _iterableToArray$b(arr) || _unsupportedIterableToArray$g(arr) || _nonIterableRest$9(); }

function _nonIterableRest$9() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$g(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$g(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$g(o, minLen); }

function _arrayLikeToArray$g(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray$b(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithHoles$9(arr) { if (Array.isArray(arr)) return arr; }
function createAnimateManager() {
  var currStyle = {};

  var handleChange = function handleChange() {
    return null;
  };

  var shouldStop = false;

  var setStyle = function setStyle(_style) {
    if (shouldStop) {
      return;
    }

    if (Array.isArray(_style)) {
      if (!_style.length) {
        return;
      }

      var styles = _style;

      var _styles = _toArray(styles),
          curr = _styles[0],
          restStyles = _styles.slice(1);

      if (typeof curr === 'number') {
        setRafTimeout(setStyle.bind(null, restStyles), curr);
        return;
      }

      setStyle(curr);
      setRafTimeout(setStyle.bind(null, restStyles));
      return;
    }

    if (_typeof$m(_style) === 'object') {
      currStyle = _style;
      handleChange(currStyle);
    }

    if (typeof _style === 'function') {
      _style();
    }
  };

  return {
    stop: function stop() {
      shouldStop = true;
    },
    start: function start(style) {
      shouldStop = false;
      setStyle(style);
    },
    subscribe: function subscribe(_handleChange) {
      handleChange = _handleChange;
      return function () {
        handleChange = function handleChange() {
          return null;
        };
      };
    }
  };
}

function ownKeys$r(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$q(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$r(Object(source), true).forEach(function (key) { _defineProperty$s(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$r(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$s(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint no-console: 0 */
var PREFIX_LIST$1 = ['Webkit', 'Moz', 'O', 'ms'];
var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
  return [Object.keys(preObj), Object.keys(nextObj)].reduce(function (a, b) {
    return a.filter(function (c) {
      return b.includes(c);
    });
  });
};
var identity$g = function identity(param) {
  return param;
};
/*
 * @description: convert camel case to dash case
 * string => string
 */

var getDashCase = function getDashCase(name) {
  return name.replace(/([A-Z])/g, function (v) {
    return "-".concat(v.toLowerCase());
  });
};
/*
 * @description: add compatible style prefix
 * (string, string) => object
 */

var generatePrefixStyle$1 = function generatePrefixStyle(name, value) {
  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
    return _defineProperty$s({}, name, value);
  }

  var isTransition = name === 'transition';
  var camelName = name.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  });
  var styleVal = value;
  return PREFIX_LIST$1.reduce(function (result, property, i) {
    if (isTransition) {
      styleVal = value.replace(/(transform|transform-origin)/gim, "".concat(IN_LINE_PREFIX_LIST[i], "$1"));
    }

    return _objectSpread$q(_objectSpread$q({}, result), {}, _defineProperty$s({}, property + camelName, styleVal));
  }, {});
};
/*
 * @description: map object on every element in this object.
 * (function, object) => object
 */

var mapObject = function mapObject(fn, obj) {
  return Object.keys(obj).reduce(function (res, key) {
    return _objectSpread$q(_objectSpread$q({}, res), {}, _defineProperty$s({}, key, fn(key, obj[key])));
  }, {});
};
/*
 * @description: add compatible prefix to style
 * object => object
 */

var translateStyle = function translateStyle(style) {
  return Object.keys(style).reduce(function (res, key) {
    return _objectSpread$q(_objectSpread$q({}, res), generatePrefixStyle$1(key, res[key]));
  }, style);
};
var getTransitionVal = function getTransitionVal(props, duration, easing) {
  return props.map(function (prop) {
    return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
  }).join(',');
};
var isDev$1 = process.env.NODE_ENV !== 'production';
var warn$1 = function warn(condition, format, a, b, c, d, e, f) {
  if (isDev$1 && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }

    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        console.warn(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
      }
    }
  }
};

function _slicedToArray$8(arr, i) { return _arrayWithHoles$8(arr) || _iterableToArrayLimit$8(arr, i) || _unsupportedIterableToArray$f(arr, i) || _nonIterableRest$8(); }

function _nonIterableRest$8() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit$8(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$8(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray$a(arr) { return _arrayWithoutHoles$a(arr) || _iterableToArray$a(arr) || _unsupportedIterableToArray$f(arr) || _nonIterableSpread$a(); }

function _nonIterableSpread$a() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$f(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$f(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$f(o, minLen); }

function _iterableToArray$a(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$a(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$f(arr); }

function _arrayLikeToArray$f(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var ACCURACY = 1e-4;

var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
};

var multyTime = function multyTime(params, t) {
  return params.map(function (param, i) {
    return param * Math.pow(t, i);
  }).reduce(function (pre, curr) {
    return pre + curr;
  });
};

var cubicBezier = function cubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);
    return multyTime(params, t);
  };
};

var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);
    var newParams = [].concat(_toConsumableArray$a(params.map(function (param, i) {
      return param * i;
    }).slice(1)), [0]);
    return multyTime(newParams, t);
  };
}; // calculate cubic-bezier using Newton's method


var configBezier = function configBezier() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var x1 = args[0],
      y1 = args[1],
      x2 = args[2],
      y2 = args[3];

  if (args.length === 1) {
    switch (args[0]) {
      case 'linear':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;
        break;

      case 'ease':
        x1 = 0.25;
        y1 = 0.1;
        x2 = 0.25;
        y2 = 1.0;
        break;

      case 'ease-in':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;
        break;

      case 'ease-out':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;
        break;

      case 'ease-in-out':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;
        break;

      default:
        {
          var easing = args[0].split('(');

          if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
            var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function (x) {
              return parseFloat(x);
            });

            var _easing$1$split$0$spl2 = _slicedToArray$8(_easing$1$split$0$spl, 4);

            x1 = _easing$1$split$0$spl2[0];
            y1 = _easing$1$split$0$spl2[1];
            x2 = _easing$1$split$0$spl2[2];
            y2 = _easing$1$split$0$spl2[3];
          } else {
            warn$1(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', instead received %s', args);
          }
        }
    }
  }

  warn$1([x1, x2, y1, y2].every(function (num) {
    return typeof num === 'number' && num >= 0 && num <= 1;
  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
  var curveX = cubicBezier(x1, x2);
  var curveY = cubicBezier(y1, y2);
  var derCurveX = derivativeCubicBezier(x1, x2);

  var rangeValue = function rangeValue(value) {
    if (value > 1) {
      return 1;
    } else if (value < 0) {
      return 0;
    }

    return value;
  };

  var bezier = function bezier(_t) {
    var t = _t > 1 ? 1 : _t;
    var x = t;

    for (var i = 0; i < 8; ++i) {
      var evalT = curveX(x) - t;
      var derVal = derCurveX(x);

      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
        return curveY(x);
      }

      x = rangeValue(x - evalT / derVal);
    }

    return curveY(x);
  };

  bezier.isStepper = false;
  return bezier;
};
var configSpring = function configSpring() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$stiff = config.stiff,
      stiff = _config$stiff === void 0 ? 100 : _config$stiff,
      _config$damping = config.damping,
      damping = _config$damping === void 0 ? 8 : _config$damping,
      _config$dt = config.dt,
      dt = _config$dt === void 0 ? 17 : _config$dt;

  var stepper = function stepper(currX, destX, currV) {
    var FSpring = -(currX - destX) * stiff;
    var FDamping = currV * damping;
    var newV = currV + (FSpring - FDamping) * dt / 1000;
    var newX = currV * dt / 1000 + currX;

    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
      return [destX, 0];
    }

    return [newX, newV];
  };

  stepper.isStepper = true;
  stepper.dt = dt;
  return stepper;
};
var configEasing = function configEasing() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var easing = args[0];

  if (typeof easing === 'string') {
    switch (easing) {
      case 'ease':
      case 'ease-in-out':
      case 'ease-out':
      case 'ease-in':
      case 'linear':
        return configBezier(easing);

      case 'spring':
        return configSpring();

      default:
        if (easing.split('(')[0] === 'cubic-bezier') {
          return configBezier(easing);
        }

        warn$1(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', \'linear\' and \'spring\', instead  received %s', args);
    }
  }

  if (typeof easing === 'function') {
    return easing;
  }

  warn$1(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
  return null;
};

function _toConsumableArray$9(arr) { return _arrayWithoutHoles$9(arr) || _iterableToArray$9(arr) || _unsupportedIterableToArray$e(arr) || _nonIterableSpread$9(); }

function _nonIterableSpread$9() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$9(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$9(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$e(arr); }

function ownKeys$q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$p(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$q(Object(source), true).forEach(function (key) { _defineProperty$r(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$r(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$7(arr, i) { return _arrayWithHoles$7(arr) || _iterableToArrayLimit$7(arr, i) || _unsupportedIterableToArray$e(arr, i) || _nonIterableRest$7(); }

function _nonIterableRest$7() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$e(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$e(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$e(o, minLen); }

function _arrayLikeToArray$e(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$7(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$7(arr) { if (Array.isArray(arr)) return arr; }

var alpha = function alpha(begin, end, k) {
  return begin + (end - begin) * k;
};

var needContinue = function needContinue(_ref) {
  var from = _ref.from,
      to = _ref.to;
  return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */


var calStepperVals = function calStepperVals(easing, preVals, steps) {
  var nextStepVals = mapObject(function (key, val) {
    if (needContinue(val)) {
      var _easing = easing(val.from, val.to, val.velocity),
          _easing2 = _slicedToArray$7(_easing, 2),
          newX = _easing2[0],
          newV = _easing2[1];

      return _objectSpread$p(_objectSpread$p({}, val), {}, {
        from: newX,
        velocity: newV
      });
    }

    return val;
  }, preVals);

  if (steps < 1) {
    return mapObject(function (key, val) {
      if (needContinue(val)) {
        return _objectSpread$p(_objectSpread$p({}, val), {}, {
          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
          from: alpha(val.from, nextStepVals[key].from, steps)
        });
      }

      return val;
    }, preVals);
  }

  return calStepperVals(easing, nextStepVals, steps - 1);
}; // configure update function


var configUpdate = (function (from, to, easing, duration, render) {
  var interKeys = getIntersectionKeys(from, to);
  var timingStyle = interKeys.reduce(function (res, key) {
    return _objectSpread$p(_objectSpread$p({}, res), {}, _defineProperty$r({}, key, [from[key], to[key]]));
  }, {});
  var stepperStyle = interKeys.reduce(function (res, key) {
    return _objectSpread$p(_objectSpread$p({}, res), {}, _defineProperty$r({}, key, {
      from: from[key],
      velocity: 0,
      to: to[key]
    }));
  }, {});
  var cafId = -1;
  var preTime;
  var beginTime;

  var update = function update() {
    return null;
  };

  var getCurrStyle = function getCurrStyle() {
    return mapObject(function (key, val) {
      return val.from;
    }, stepperStyle);
  };

  var shouldStopAnimation = function shouldStopAnimation() {
    return !Object.values(stepperStyle).filter(needContinue).length;
  }; // stepper timing function like spring


  var stepperUpdate = function stepperUpdate(now) {
    if (!preTime) {
      preTime = now;
    }

    var deltaTime = now - preTime;
    var steps = deltaTime / easing.dt;
    stepperStyle = calStepperVals(easing, stepperStyle, steps); // get union set and add compatible prefix

    render(_objectSpread$p(_objectSpread$p(_objectSpread$p({}, from), to), getCurrStyle()));
    preTime = now;

    if (!shouldStopAnimation()) {
      cafId = raf$1(update);
    }
  }; // t => val timing function like cubic-bezier


  var timingUpdate = function timingUpdate(now) {
    if (!beginTime) {
      beginTime = now;
    }

    var t = (now - beginTime) / duration;
    var currStyle = mapObject(function (key, val) {
      return alpha.apply(void 0, _toConsumableArray$9(val).concat([easing(t)]));
    }, timingStyle); // get union set and add compatible prefix

    render(_objectSpread$p(_objectSpread$p(_objectSpread$p({}, from), to), currStyle));

    if (t < 1) {
      cafId = raf$1(update);
    } else {
      var finalStyle = mapObject(function (key, val) {
        return alpha.apply(void 0, _toConsumableArray$9(val).concat([easing(1)]));
      }, timingStyle);
      render(_objectSpread$p(_objectSpread$p(_objectSpread$p({}, from), to), finalStyle));
    }
  };

  update = easing.isStepper ? stepperUpdate : timingUpdate; // return start animation method

  return function () {
    raf$1(update); // return stop animation method

    return function () {
      cancel(cafId);
    };
  };
});

function _typeof$l(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$l = function _typeof(obj) { return typeof obj; }; } else { _typeof$l = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$l(obj); }

function _objectWithoutProperties$9(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$9(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$9(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray$8(arr) { return _arrayWithoutHoles$8(arr) || _iterableToArray$8(arr) || _unsupportedIterableToArray$d(arr) || _nonIterableSpread$8(); }

function _nonIterableSpread$8() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$d(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$d(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$d(o, minLen); }

function _iterableToArray$8(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$8(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$d(arr); }

function _arrayLikeToArray$d(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$p(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$o(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$p(Object(source), true).forEach(function (key) { _defineProperty$q(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$p(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$q(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$k(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$l(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$l(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$l(Constructor.prototype, protoProps); if (staticProps) _defineProperties$l(Constructor, staticProps); return Constructor; }

function _inherits$i(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$i(subClass, superClass); }

function _setPrototypeOf$i(o, p) { _setPrototypeOf$i = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$i(o, p); }

function _createSuper$h(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$h(); return function _createSuperInternal() { var Super = _getPrototypeOf$i(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$i(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$i(this, result); }; }

function _possibleConstructorReturn$i(self, call) { if (call && (_typeof$l(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$i(self); }

function _assertThisInitialized$i(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$h() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$i(o) { _getPrototypeOf$i = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$i(o); }

var Animate = /*#__PURE__*/function (_PureComponent) {
  _inherits$i(Animate, _PureComponent);

  var _super = _createSuper$h(Animate);

  function Animate(props, context) {
    var _this;

    _classCallCheck$k(this, Animate);

    _this = _super.call(this, props, context);
    var _this$props = _this.props,
        isActive = _this$props.isActive,
        attributeName = _this$props.attributeName,
        from = _this$props.from,
        to = _this$props.to,
        steps = _this$props.steps,
        children = _this$props.children;
    _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized$i(_this));
    _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized$i(_this));

    if (!isActive) {
      _this.state = {
        style: {}
      }; // if children is a function and animation is not active, set style to 'to'

      if (typeof children === 'function') {
        _this.state = {
          style: to
        };
      }

      return _possibleConstructorReturn$i(_this);
    }

    if (steps && steps.length) {
      _this.state = {
        style: steps[0].style
      };
    } else if (from) {
      if (typeof children === 'function') {
        _this.state = {
          style: from
        };
        return _possibleConstructorReturn$i(_this);
      }

      _this.state = {
        style: attributeName ? _defineProperty$q({}, attributeName, from) : from
      };
    } else {
      _this.state = {
        style: {}
      };
    }

    return _this;
  }

  _createClass$l(Animate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          isActive = _this$props2.isActive,
          canBegin = _this$props2.canBegin;
      this.mounted = true;

      if (!isActive || !canBegin) {
        return;
      }

      this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          isActive = _this$props3.isActive,
          canBegin = _this$props3.canBegin,
          attributeName = _this$props3.attributeName,
          shouldReAnimate = _this$props3.shouldReAnimate;

      if (!canBegin) {
        return;
      }

      if (!isActive) {
        var newState = {
          style: attributeName ? _defineProperty$q({}, attributeName, this.props.to) : this.props.to
        };

        if (this.state && this.state.style) {
          if (attributeName && this.state.style[attributeName] !== this.props.to || !attributeName && this.state.style !== this.props.to) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(newState);
          }
        }

        return;
      }

      if (deepEqual(prevProps.to, this.props.to) && prevProps.canBegin && prevProps.isActive) {
        return;
      }

      var isTriggered = !prevProps.canBegin || !prevProps.isActive;

      if (this.manager) {
        this.manager.stop();
      }

      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }

      var from = isTriggered || shouldReAnimate ? this.props.from : prevProps.to;

      if (this.state && this.state.style) {
        var _newState = {
          style: attributeName ? _defineProperty$q({}, attributeName, from) : from
        };

        if (attributeName && this.state.style[attributeName] !== from || !attributeName && this.state.style !== from) {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState(_newState);
        }
      }

      this.runAnimation(_objectSpread$o(_objectSpread$o({}, this.props), {}, {
        from: from,
        begin: 0
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.unSubscribe) {
        this.unSubscribe();
      }

      if (this.manager) {
        this.manager.stop();
        this.manager = null;
      }

      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }
    }
  }, {
    key: "runJSAnimation",
    value: function runJSAnimation(props) {
      var _this2 = this;

      var from = props.from,
          to = props.to,
          duration = props.duration,
          easing = props.easing,
          begin = props.begin,
          onAnimationEnd = props.onAnimationEnd,
          onAnimationStart = props.onAnimationStart;
      var startAnimation = configUpdate(from, to, configEasing(easing), duration, this.changeStyle);

      var finalStartAnimation = function finalStartAnimation() {
        _this2.stopJSAnimation = startAnimation();
      };

      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
    }
  }, {
    key: "runStepAnimation",
    value: function runStepAnimation(props) {
      var _this3 = this;

      var steps = props.steps,
          begin = props.begin,
          onAnimationStart = props.onAnimationStart;
      var _steps$ = steps[0],
          initialStyle = _steps$.style,
          _steps$$duration = _steps$.duration,
          initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;

      var addStyle = function addStyle(sequence, nextItem, index) {
        if (index === 0) {
          return sequence;
        }

        var duration = nextItem.duration,
            _nextItem$easing = nextItem.easing,
            easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing,
            style = nextItem.style,
            nextProperties = nextItem.properties,
            onAnimationEnd = nextItem.onAnimationEnd;
        var preItem = index > 0 ? steps[index - 1] : nextItem;
        var properties = nextProperties || Object.keys(style);

        if (typeof easing === 'function' || easing === 'spring') {
          return [].concat(_toConsumableArray$8(sequence), [_this3.runJSAnimation.bind(_this3, {
            from: preItem.style,
            to: style,
            duration: duration,
            easing: easing
          }), duration]);
        }

        var transition = getTransitionVal(properties, duration, easing);

        var newStyle = _objectSpread$o(_objectSpread$o(_objectSpread$o({}, preItem.style), style), {}, {
          transition: transition
        });

        return [].concat(_toConsumableArray$8(sequence), [newStyle, duration, onAnimationEnd]).filter(identity$g);
      };

      return this.manager.start([onAnimationStart].concat(_toConsumableArray$8(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function runAnimation(props) {
      if (!this.manager) {
        this.manager = createAnimateManager();
      }

      var begin = props.begin,
          duration = props.duration,
          attributeName = props.attributeName,
          propsTo = props.to,
          easing = props.easing,
          onAnimationStart = props.onAnimationStart,
          onAnimationEnd = props.onAnimationEnd,
          steps = props.steps,
          children = props.children;
      var manager = this.manager;
      this.unSubscribe = manager.subscribe(this.handleStyleChange);

      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
        this.runJSAnimation(props);
        return;
      }

      if (steps.length > 1) {
        this.runStepAnimation(props);
        return;
      }

      var to = attributeName ? _defineProperty$q({}, attributeName, propsTo) : propsTo;
      var transition = getTransitionVal(Object.keys(to), duration, easing);
      manager.start([onAnimationStart, begin, _objectSpread$o(_objectSpread$o({}, to), {}, {
        transition: transition
      }), duration, onAnimationEnd]);
    }
  }, {
    key: "handleStyleChange",
    value: function handleStyleChange(style) {
      this.changeStyle(style);
    }
  }, {
    key: "changeStyle",
    value: function changeStyle(style) {
      if (this.mounted) {
        this.setState({
          style: style
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children;
          _this$props4.begin;
          _this$props4.duration;
          _this$props4.attributeName;
          _this$props4.easing;
          var isActive = _this$props4.isActive;
          _this$props4.steps;
          _this$props4.from;
          _this$props4.to;
          _this$props4.canBegin;
          _this$props4.onAnimationEnd;
          _this$props4.shouldReAnimate;
          _this$props4.onAnimationReStart;
          var others = _objectWithoutProperties$9(_this$props4, ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"]);

      var count = Children.count(children);
      var stateStyle = translateStyle(this.state.style);

      if (typeof children === 'function') {
        return children(stateStyle);
      }

      if (!isActive || count === 0) {
        return children;
      }

      var cloneContainer = function cloneContainer(container) {
        var _container$props = container.props,
            _container$props$styl = _container$props.style,
            style = _container$props$styl === void 0 ? {} : _container$props$styl,
            className = _container$props.className;
        var res = /*#__PURE__*/cloneElement(container, _objectSpread$o(_objectSpread$o({}, others), {}, {
          style: _objectSpread$o(_objectSpread$o({}, style), stateStyle),
          className: className
        }));
        return res;
      };

      if (count === 1) {
        return cloneContainer(Children.only(children));
      }

      return /*#__PURE__*/React$2.createElement("div", null, Children.map(children, function (child) {
        return cloneContainer(child);
      }));
    }
  }]);

  return Animate;
}(PureComponent);

Animate.displayName = 'Animate';
Animate.propTypes = {
  from: PropTypes$2.oneOfType([PropTypes$2.object, PropTypes$2.string]),
  to: PropTypes$2.oneOfType([PropTypes$2.object, PropTypes$2.string]),
  attributeName: PropTypes$2.string,
  // animation duration
  duration: PropTypes$2.number,
  begin: PropTypes$2.number,
  easing: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.func]),
  steps: PropTypes$2.arrayOf(PropTypes$2.shape({
    duration: PropTypes$2.number.isRequired,
    style: PropTypes$2.object.isRequired,
    easing: PropTypes$2.oneOfType([PropTypes$2.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), PropTypes$2.func]),
    // transition css properties(dash case), optional
    properties: PropTypes$2.arrayOf('string'),
    onAnimationEnd: PropTypes$2.func
  })),
  children: PropTypes$2.oneOfType([PropTypes$2.node, PropTypes$2.func]),
  isActive: PropTypes$2.bool,
  canBegin: PropTypes$2.bool,
  onAnimationEnd: PropTypes$2.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: PropTypes$2.bool,
  onAnimationStart: PropTypes$2.func,
  onAnimationReStart: PropTypes$2.func
};
Animate.defaultProps = {
  begin: 0,
  duration: 1000,
  from: '',
  to: '',
  attributeName: '',
  easing: 'ease',
  isActive: true,
  canBegin: true,
  steps: [],
  onAnimationEnd: function onAnimationEnd() {},
  onAnimationStart: function onAnimationStart() {}
};

if (Number.isFinite === undefined) {
  Number.isFinite = function (value) {
    return typeof value === 'number' && isFinite(value);
  };
}

({
  appearOptions: PropTypes$2.object,
  enterOptions: PropTypes$2.object,
  leaveOptions: PropTypes$2.object,
  children: PropTypes$2.element
});

({
  appear: PropTypes$2.object,
  enter: PropTypes$2.object,
  leave: PropTypes$2.object,
  children: PropTypes$2.oneOfType([PropTypes$2.array, PropTypes$2.element]),
  component: PropTypes$2.any
});

var Symbol$1 = _Symbol,
    isArguments = isArguments_1,
    isArray$8 = isArray_1;

/** Built-in value references. */
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$8(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable$1;

var arrayPush = _arrayPush,
    isFlattenable = _isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$2(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$2(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten$2;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$1 = createBaseFor();

var _baseFor = baseFor$1;

var baseFor = _baseFor,
    keys$2 = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$2(object, iteratee) {
  return object && baseFor(object, iteratee, keys$2);
}

var _baseForOwn = baseForOwn$2;

var isArrayLike$3 = isArrayLike_1;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$3(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach$1;

var baseForOwn$1 = _baseForOwn,
    createBaseEach = _createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$3 = createBaseEach(baseForOwn$1);

var _baseEach = baseEach$3;

var baseEach$2 = _baseEach,
    isArrayLike$2 = isArrayLike_1;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap$2(collection, iteratee) {
  var index = -1,
      result = isArrayLike$2(collection) ? Array(collection.length) : [];

  baseEach$2(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap$2;

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */

function baseSortBy$1(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

var _baseSortBy = baseSortBy$1;

var isSymbol$3 = isSymbol_1;

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol$3(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol$3(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

var _compareAscending = compareAscending$1;

var compareAscending = _compareAscending;

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple$1(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

var _compareMultiple = compareMultiple$1;

var arrayMap$1 = _arrayMap,
    baseGet = _baseGet,
    baseIteratee$6 = _baseIteratee,
    baseMap$1 = _baseMap,
    baseSortBy = _baseSortBy,
    baseUnary = _baseUnary,
    compareMultiple = _compareMultiple,
    identity$f = identity_1,
    isArray$7 = isArray_1;

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap$1(iteratees, function(iteratee) {
      if (isArray$7(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity$f];
  }

  var index = -1;
  iteratees = arrayMap$1(iteratees, baseUnary(baseIteratee$6));

  var result = baseMap$1(collection, function(value, key, collection) {
    var criteria = arrayMap$1(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

var _baseOrderBy = baseOrderBy$1;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply$1;

var apply = _apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$4 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$1(func, start, transform) {
  start = nativeMax$4(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$4(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

var _overRest = overRest$1;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant$2(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant$2;

var getNative = _getNative;

var defineProperty$3 = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$p = defineProperty$3;

var constant$1 = constant_1,
    defineProperty$2 = _defineProperty$p,
    identity$e = identity_1;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$1 = !defineProperty$2 ? identity$e : function(func, string) {
  return defineProperty$2(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant$1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString$1;

/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut$1;

var baseSetToString = _baseSetToString,
    shortOut = _shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$1 = shortOut(baseSetToString);

var _setToString = setToString$1;

var identity$d = identity_1,
    overRest = _overRest,
    setToString = _setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest$1(func, start) {
  return setToString(overRest(func, start, identity$d), func + '');
}

var _baseRest = baseRest$1;

var eq = eq_1,
    isArrayLike$1 = isArrayLike_1,
    isIndex = _isIndex,
    isObject$6 = isObject_1;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall$4(value, index, object) {
  if (!isObject$6(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike$1(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall$4;

var baseFlatten$1 = _baseFlatten,
    baseOrderBy = _baseOrderBy,
    baseRest = _baseRest,
    isIterateeCall$3 = _isIterateeCall;

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall$3(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall$3(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten$1(iteratees, 1), []);
});

var sortBy_1 = sortBy;

function _typeof$k(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$k = function _typeof(obj) { return typeof obj; }; } else { _typeof$k = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$k(obj); }

function _slicedToArray$6(arr, i) { return _arrayWithHoles$6(arr) || _iterableToArrayLimit$6(arr, i) || _unsupportedIterableToArray$c(arr, i) || _nonIterableRest$6(); }

function _nonIterableRest$6() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$c(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$c(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$c(o, minLen); }

function _arrayLikeToArray$c(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$6(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$6(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys$o(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$o(Object(source), true).forEach(function (key) { _defineProperty$o(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$o(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$o(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$j(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$k(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$k(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$k(Constructor.prototype, protoProps); if (staticProps) _defineProperties$k(Constructor, staticProps); return Constructor; }

function _inherits$h(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$h(subClass, superClass); }

function _setPrototypeOf$h(o, p) { _setPrototypeOf$h = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$h(o, p); }

function _createSuper$g(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$g(); return function _createSuperInternal() { var Super = _getPrototypeOf$h(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$h(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$h(this, result); }; }

function _possibleConstructorReturn$h(self, call) { if (call && (_typeof$k(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$h(self); }

function _assertThisInitialized$h(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$g() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$h(o) { _getPrototypeOf$h = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$h(o); }

function defaultFormatter(value) {
  return isArray_1(value) && isNumOrStr(value[0]) && isNumOrStr(value[1]) ? value.join(' ~ ') : value;
}

var DefaultTooltipContent = /*#__PURE__*/function (_PureComponent) {
  _inherits$h(DefaultTooltipContent, _PureComponent);

  var _super = _createSuper$g(DefaultTooltipContent);

  function DefaultTooltipContent() {
    _classCallCheck$j(this, DefaultTooltipContent);

    return _super.apply(this, arguments);
  }

  _createClass$k(DefaultTooltipContent, [{
    key: "renderContent",
    value: function renderContent() {
      var _this$props = this.props,
          payload = _this$props.payload,
          separator = _this$props.separator,
          formatter = _this$props.formatter,
          itemStyle = _this$props.itemStyle,
          itemSorter = _this$props.itemSorter;

      if (payload && payload.length) {
        var listStyle = {
          padding: 0,
          margin: 0
        };
        var items = (itemSorter ? sortBy_1(payload, itemSorter) : payload).map(function (entry, i) {
          if (entry.type === 'none') {
            return null;
          }

          var finalItemStyle = _objectSpread$n({
            display: 'block',
            paddingTop: 4,
            paddingBottom: 4,
            color: entry.color || '#000'
          }, itemStyle);

          var finalFormatter = entry.formatter || formatter || defaultFormatter;
          var name = entry.name,
              value = entry.value;

          if (finalFormatter) {
            var formatted = finalFormatter(value, name, entry, i, payload);

            if (Array.isArray(formatted)) {
              var _formatted = _slicedToArray$6(formatted, 2);

              value = _formatted[0];
              name = _formatted[1];
            } else {
              value = formatted;
            }
          }

          return (
            /*#__PURE__*/
            // eslint-disable-next-line react/no-array-index-key
            React$2.createElement("li", {
              className: "recharts-tooltip-item",
              key: "tooltip-item-".concat(i),
              style: finalItemStyle
            }, isNumOrStr(name) ? /*#__PURE__*/React$2.createElement("span", {
              className: "recharts-tooltip-item-name"
            }, name) : null, isNumOrStr(name) ? /*#__PURE__*/React$2.createElement("span", {
              className: "recharts-tooltip-item-separator"
            }, separator) : null, /*#__PURE__*/React$2.createElement("span", {
              className: "recharts-tooltip-item-value"
            }, value), /*#__PURE__*/React$2.createElement("span", {
              className: "recharts-tooltip-item-unit"
            }, entry.unit || ''))
          );
        });
        return /*#__PURE__*/React$2.createElement("ul", {
          className: "recharts-tooltip-item-list",
          style: listStyle
        }, items);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          wrapperClassName = _this$props2.wrapperClassName,
          contentStyle = _this$props2.contentStyle,
          labelClassName = _this$props2.labelClassName,
          labelStyle = _this$props2.labelStyle,
          label = _this$props2.label,
          labelFormatter = _this$props2.labelFormatter,
          payload = _this$props2.payload;

      var finalStyle = _objectSpread$n({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
      }, contentStyle);

      var finalLabelStyle = _objectSpread$n({
        margin: 0
      }, labelStyle);

      var hasLabel = !isNil_1(label);
      var finalLabel = hasLabel ? label : '';
      var wrapperCN = classNames('recharts-default-tooltip', wrapperClassName);
      var labelCN = classNames('recharts-tooltip-label', labelClassName);

      if (hasLabel && labelFormatter && payload !== undefined && payload !== null) {
        finalLabel = labelFormatter(label, payload);
      }

      return /*#__PURE__*/React$2.createElement("div", {
        className: wrapperCN,
        style: finalStyle
      }, /*#__PURE__*/React$2.createElement("p", {
        className: labelCN,
        style: finalLabelStyle
      }, /*#__PURE__*/React$2.isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), this.renderContent());
    }
  }]);

  return DefaultTooltipContent;
}(PureComponent);
DefaultTooltipContent.displayName = 'DefaultTooltipContent';
DefaultTooltipContent.defaultProps = {
  separator: ' : ',
  contentStyle: {},
  itemStyle: {},
  labelStyle: {}
};

var parseIsSsrByDefault = function parseIsSsrByDefault() {
  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};

var Global = {
  isSsr: parseIsSsrByDefault(),
  get: function get(key) {
    return Global[key];
  },
  set: function set(key, value) {
    if (typeof key === 'string') {
      Global[key] = value;
    } else {
      var keys = Object.keys(key);

      if (keys && keys.length) {
        keys.forEach(function (k) {
          Global[k] = key[k];
        });
      }
    }
  }
};

function _typeof$j(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$j = function _typeof(obj) { return typeof obj; }; } else { _typeof$j = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$j(obj); }

function ownKeys$n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$n(Object(source), true).forEach(function (key) { _defineProperty$n(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$n(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$i(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$j(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$j(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$j(Constructor.prototype, protoProps); if (staticProps) _defineProperties$j(Constructor, staticProps); return Constructor; }

function _inherits$g(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$g(subClass, superClass); }

function _setPrototypeOf$g(o, p) { _setPrototypeOf$g = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$g(o, p); }

function _createSuper$f(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$f(); return function _createSuperInternal() { var Super = _getPrototypeOf$g(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$g(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$g(this, result); }; }

function _possibleConstructorReturn$g(self, call) { if (call && (_typeof$j(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$g(self); }

function _assertThisInitialized$g(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$f() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$g(o) { _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$g(o); }
var CLS_PREFIX = 'recharts-tooltip-wrapper';
var EPS$1 = 1;

function defaultUniqBy(entry) {
  return entry.dataKey;
}

function getUniqPayload(option, payload) {
  if (option === true) {
    return uniqBy_1(payload, defaultUniqBy);
  }

  if (isFunction_1(option)) {
    return uniqBy_1(payload, option);
  }

  return payload;
}

function renderContent(content, props) {
  if ( /*#__PURE__*/React$2.isValidElement(content)) {
    return /*#__PURE__*/React$2.cloneElement(content, props);
  }

  if (isFunction_1(content)) {
    return /*#__PURE__*/React$2.createElement(content, props);
  }

  return /*#__PURE__*/React$2.createElement(DefaultTooltipContent, props);
}

var Tooltip = /*#__PURE__*/function (_PureComponent) {
  _inherits$g(Tooltip, _PureComponent);

  var _super = _createSuper$f(Tooltip);

  function Tooltip() {
    var _this;

    _classCallCheck$i(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      boxWidth: -1,
      boxHeight: -1
    };
    _this.wrapperNode = void 0;

    _this.getTranslate = function (_ref) {
      var key = _ref.key,
          tooltipDimension = _ref.tooltipDimension,
          viewBoxDimension = _ref.viewBoxDimension;
      var _this$props = _this.props,
          allowEscapeViewBox = _this$props.allowEscapeViewBox,
          coordinate = _this$props.coordinate,
          offset = _this$props.offset,
          position = _this$props.position,
          viewBox = _this$props.viewBox;

      if (position && isNumber$1(position[key])) {
        return position[key];
      }

      var restricted = coordinate[key] - tooltipDimension - offset;
      var unrestricted = coordinate[key] + offset;

      if (allowEscapeViewBox[key]) {
        return unrestricted;
      }

      var tooltipBoundary = coordinate[key] + tooltipDimension + offset;
      var viewBoxBoundary = viewBox[key] + viewBoxDimension;

      if (tooltipBoundary > viewBoxBoundary) {
        return Math.max(restricted, viewBox[key]);
      }

      return Math.max(unrestricted, viewBox[key]);
    };

    return _this;
  }

  _createClass$j(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: "updateBBox",
    value: function updateBBox() {
      var _this$state = this.state,
          boxWidth = _this$state.boxWidth,
          boxHeight = _this$state.boxHeight;

      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();

        if (Math.abs(box.width - boxWidth) > EPS$1 || Math.abs(box.height - boxHeight) > EPS$1) {
          this.setState({
            boxWidth: box.width,
            boxHeight: box.height
          });
        }
      } else if (boxWidth !== -1 || boxHeight !== -1) {
        this.setState({
          boxWidth: -1,
          boxHeight: -1
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props2 = this.props,
          payload = _this$props2.payload,
          isAnimationActive = _this$props2.isAnimationActive,
          animationDuration = _this$props2.animationDuration,
          animationEasing = _this$props2.animationEasing,
          filterNull = _this$props2.filterNull,
          payloadUniqBy = _this$props2.payloadUniqBy;
      var finalPayload = getUniqPayload(payloadUniqBy, filterNull && payload && payload.length ? payload.filter(function (entry) {
        return !isNil_1(entry.value);
      }) : payload);
      var hasPayload = finalPayload && finalPayload.length;
      var _this$props3 = this.props,
          content = _this$props3.content,
          viewBox = _this$props3.viewBox,
          coordinate = _this$props3.coordinate,
          position = _this$props3.position,
          active = _this$props3.active,
          wrapperStyle = _this$props3.wrapperStyle;

      var outerStyle = _objectSpread$m({
        pointerEvents: 'none',
        visibility: active && hasPayload ? 'visible' : 'hidden',
        position: 'absolute',
        top: 0,
        left: 0
      }, wrapperStyle);

      var translateX, translateY;

      if (position && isNumber$1(position.x) && isNumber$1(position.y)) {
        translateX = position.x;
        translateY = position.y;
      } else {
        var _this$state2 = this.state,
            boxWidth = _this$state2.boxWidth,
            boxHeight = _this$state2.boxHeight;

        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
          translateX = this.getTranslate({
            key: 'x',
            tooltipDimension: boxWidth,
            viewBoxDimension: viewBox.width
          });
          translateY = this.getTranslate({
            key: 'y',
            tooltipDimension: boxHeight,
            viewBoxDimension: viewBox.height
          });
        } else {
          outerStyle.visibility = 'hidden';
        }
      }

      outerStyle = _objectSpread$m(_objectSpread$m({}, translateStyle({
        transform: this.props.useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
      })), outerStyle);

      if (isAnimationActive && active) {
        outerStyle = _objectSpread$m(_objectSpread$m({}, translateStyle({
          transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
        })), outerStyle);
      }

      var cls = classNames(CLS_PREFIX, (_classNames = {}, _defineProperty$n(_classNames, "".concat(CLS_PREFIX, "-right"), isNumber$1(translateX) && coordinate && isNumber$1(coordinate.x) && translateX >= coordinate.x), _defineProperty$n(_classNames, "".concat(CLS_PREFIX, "-left"), isNumber$1(translateX) && coordinate && isNumber$1(coordinate.x) && translateX < coordinate.x), _defineProperty$n(_classNames, "".concat(CLS_PREFIX, "-bottom"), isNumber$1(translateY) && coordinate && isNumber$1(coordinate.y) && translateY >= coordinate.y), _defineProperty$n(_classNames, "".concat(CLS_PREFIX, "-top"), isNumber$1(translateY) && coordinate && isNumber$1(coordinate.y) && translateY < coordinate.y), _classNames));
      return /*#__PURE__*/React$2.createElement("div", {
        className: cls,
        style: outerStyle,
        ref: function ref(node) {
          _this2.wrapperNode = node;
        }
      }, renderContent(content, _objectSpread$m(_objectSpread$m({}, this.props), {}, {
        payload: finalPayload
      })));
    }
  }]);

  return Tooltip;
}(PureComponent);
Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = {
  active: false,
  allowEscapeViewBox: {
    x: false,
    y: false
  },
  offset: 10,
  viewBox: {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0
  },
  coordinate: {
    x: 0,
    y: 0
  },
  cursorStyle: {},
  separator: ' : ',
  wrapperStyle: {},
  contentStyle: {},
  itemStyle: {},
  labelStyle: {},
  cursor: true,
  trigger: 'hover',
  isAnimationActive: !Global.isSsr,
  animationEasing: 'ease',
  animationDuration: 400,
  filterNull: true,
  useTranslate3d: false
};

var root$3 = _root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$3 = function() {
  return root$3.Date.now();
};

var now_1 = now$3;

/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;

var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim$1;

var baseTrim = _baseTrim,
    isObject$5 = isObject_1,
    isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$3(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$2(value)) {
    return NAN$1;
  }
  if (isObject$5(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$5(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$1 : +value);
}

var toNumber_1 = toNumber$3;

var isObject$4 = isObject_1,
    now$2 = now_1,
    toNumber$2 = toNumber_1;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$3 = Math.max,
    nativeMin$1 = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$2(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  wait = toNumber$2(wait) || 0;
  if (isObject$4(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$3(toNumber$2(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin$1(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$2();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$2());
  }

  function debounced() {
    var time = now$2(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce$2;

var withPolyfill = {};

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle$1 (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle$1(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser$1 || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser$1 || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser$1) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index$1 = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

var ResizeObserver_es = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': index$1
});

var require$$8 = /*@__PURE__*/getAugmentedNamespace(ResizeObserver_es);

(function (exports) {
Object.defineProperty(exports,'__esModule',{value:true});var $inject_window_ResizeObserver=require$$8,React=React$2,reactDom=ReactDOM;function _interopDefaultLegacy(e){return e&&typeof e==='object'&&'default'in e?e:{'default':e}}function _interopNamespace(e){if(e&&e.__esModule)return e;var n=Object.create(null);if(e){Object.keys(e).forEach(function(k){if(k!=='default'){var d=Object.getOwnPropertyDescriptor(e,k);Object.defineProperty(n,k,d.get?d:{enumerable:true,get:function(){return e[k]}});}});}n["default"]=e;return Object.freeze(n)}var $inject_window_ResizeObserver__default=/*#__PURE__*/_interopDefaultLegacy($inject_window_ResizeObserver);var React__namespace=/*#__PURE__*/_interopNamespace(React);/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$3(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$3;/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;

var _freeGlobal = freeGlobal$1;var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = freeGlobal || freeSelf || Function('return this')();

var _root = root$2;var root$1 = _root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root$1.Date.now();
};

var now_1 = now$1;/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim$1;var root = _root;

/** Built-in value references. */
var Symbol$2 = root.Symbol;

var _Symbol = Symbol$2;var Symbol$1 = _Symbol;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;/** Used for built-in method references. */

var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;var Symbol = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$1(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$1;/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$1(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$1;var baseGetTag = _baseGetTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol$1;var baseTrim = _baseTrim,
    isObject$2 = isObject_1,
    isSymbol = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$2(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber$1;var isObject$1 = isObject_1,
    now = now_1,
    toNumber = toNumber_1;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce$1;var debounce = debounce_1,
    isObject = isObject_1;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var throttle_1 = throttle;var patchResizeHandler = function (resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch (refreshMode) {
        case 'debounce':
            return debounce_1(resizeCallback, refreshRate, refreshOptions);
        case 'throttle':
            return throttle_1(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var isFunction = function (fn) { return typeof fn === 'function'; };
var isSSR = function () { return typeof window === 'undefined'; };
var isDOMElement = function (element) { return element instanceof Element || element instanceof HTMLDocument; };
var createNotifier = function (onResize, setSize, handleWidth, handleHeight) {
    return function (_a) {
        var width = _a.width, height = _a.height;
        setSize(function (prev) {
            if (prev.width === width && prev.height === height) {
                // skip if dimensions haven't changed
                return prev;
            }
            if ((prev.width === width && !handleHeight) || (prev.height === height && !handleWidth)) {
                // process `handleHeight/handleWidth` props
                return prev;
            }
            if (onResize && isFunction(onResize)) {
                onResize(width, height);
            }
            return { width: width, height: height };
        });
    };
};var ResizeDetector = /** @class */ (function (_super) {
    __extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function () {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function () {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if (isSSR()) {
                return;
            }
            if (targetRef && targetRef.current) {
                _this.targetRef.current = targetRef.current;
            }
            var element = _this.getElement();
            if (!element) {
                // can't find element to observe
                return;
            }
            if (_this.observableElement && _this.observableElement === element) {
                // element is already observed
                return;
            }
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function () {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if (isSSR())
                return null;
            // in case we pass a querySelector
            if (querySelector)
                return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && isDOMElement(targetDomEl))
                return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && isDOMElement(_this.targetRef.current))
                return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = reactDom.findDOMNode(_this);
            if (!currentElement)
                return null;
            var renderType = _this.getRenderType();
            switch (renderType) {
                case 'renderProp':
                    return currentElement;
                case 'childFunction':
                    return currentElement;
                case 'child':
                    return currentElement;
                case 'childArray':
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function (entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight)
                return;
            var notifyResize = createNotifier(onResize, _this.setState.bind(_this), handleWidth, handleHeight);
            entries.forEach(function (entry) {
                var _a = (entry && entry.contentRect) || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !isSSR();
                if (shouldSetSize) {
                    notifyResize({ width: width, height: height });
                }
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function () {
            var _a = _this.props, render = _a.render, children = _a.children;
            if (isFunction(render)) {
                // DEPRECATED. Use `Child Function Pattern` instead
                return 'renderProp';
            }
            if (isFunction(children)) {
                return 'childFunction';
            }
            if (React.isValidElement(children)) {
                return 'child';
            }
            if (Array.isArray(children)) {
                // DEPRECATED. Wrap children with a single parent
                return 'childArray';
            }
            // DEPRECATED. Use `Child Function Pattern` instead
            return 'parent';
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = React.createRef();
        _this.observableElement = null;
        if (isSSR()) {
            return _this;
        }
        _this.resizeHandler = patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new $inject_window_ResizeObserver__default["default"](_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function () {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function () {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentWillUnmount = function () {
        if (isSSR()) {
            return;
        }
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function () {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? 'div' : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = { width: width, height: height, targetRef: this.targetRef };
        var renderType = this.getRenderType();
        var typedChildren;
        switch (renderType) {
            case 'renderProp':
                return render && render(childProps);
            case 'childFunction':
                typedChildren = children;
                return typedChildren(childProps);
            case 'child':
                // @TODO bug prone logic
                typedChildren = children;
                if (typedChildren.type && typeof typedChildren.type === 'string') {
                    // child is a native DOM elements such as div, span etc
                    childProps.targetRef; var nativeProps = __rest(childProps, ["targetRef"]);
                    return React.cloneElement(typedChildren, nativeProps);
                }
                // class or functional component otherwise
                return React.cloneElement(typedChildren, childProps);
            case 'childArray':
                typedChildren = children;
                return typedChildren.map(function (el) { return !!el && React.cloneElement(el, childProps); });
            default:
                return React__namespace.createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}(React.PureComponent));function withResizeDetector(ComponentInner, options) {
    if (options === void 0) { options = {}; }
    var ResizeDetectorHOC = /** @class */ (function (_super) {
        __extends(ResizeDetectorHOC, _super);
        function ResizeDetectorHOC() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ref = React.createRef();
            return _this;
        }
        ResizeDetectorHOC.prototype.render = function () {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = __rest(_a, ["forwardedRef"]);
            var targetRef = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : this.ref;
            return (React__namespace.createElement(ResizeDetector, __assign({}, options, { targetRef: targetRef }),
                React__namespace.createElement(ComponentInner, __assign({ targetRef: targetRef }, rest))));
        };
        return ResizeDetectorHOC;
    }(React.Component));
    function forwardRefWrapper(props, ref) {
        return React__namespace.createElement(ResizeDetectorHOC, __assign({}, props, { forwardedRef: ref }));
    }
    var name = ComponentInner.displayName || ComponentInner.name;
    forwardRefWrapper.displayName = "withResizeDetector(".concat(name, ")");
    return React.forwardRef(forwardRefWrapper);
}var useEnhancedEffect = isSSR() ? React.useEffect : React.useLayoutEffect;
function useResizeDetector(props) {
    if (props === void 0) { props = {}; }
    var _a = props.skipOnMount, skipOnMount = _a === void 0 ? false : _a, refreshMode = props.refreshMode, _b = props.refreshRate, refreshRate = _b === void 0 ? 1000 : _b, refreshOptions = props.refreshOptions, _c = props.handleWidth, handleWidth = _c === void 0 ? true : _c, _d = props.handleHeight, handleHeight = _d === void 0 ? true : _d, targetRef = props.targetRef, observerOptions = props.observerOptions, onResize = props.onResize;
    var skipResize = React.useRef(skipOnMount);
    var localRef = React.useRef(null);
    var ref = (targetRef !== null && targetRef !== void 0 ? targetRef : localRef);
    var resizeHandler = React.useRef();
    var _e = React.useState({
        width: undefined,
        height: undefined
    }), size = _e[0], setSize = _e[1];
    useEnhancedEffect(function () {
        if (isSSR()) {
            return;
        }
        var notifyResize = createNotifier(onResize, setSize, handleWidth, handleHeight);
        var resizeCallback = function (entries) {
            if (!handleWidth && !handleHeight)
                return;
            entries.forEach(function (entry) {
                var _a = (entry && entry.contentRect) || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !skipResize.current && !isSSR();
                if (shouldSetSize) {
                    notifyResize({ width: width, height: height });
                }
                skipResize.current = false;
            });
        };
        resizeHandler.current = patchResizeHandler(resizeCallback, refreshMode, refreshRate, refreshOptions);
        var resizeObserver = new $inject_window_ResizeObserver__default["default"](resizeHandler.current);
        if (ref.current) {
            // Something wrong with typings here...
            resizeObserver.observe(ref.current, observerOptions);
        }
        return function () {
            resizeObserver.disconnect();
            var patchedResizeHandler = resizeHandler.current;
            if (patchedResizeHandler && patchedResizeHandler.cancel) {
                patchedResizeHandler.cancel();
            }
        };
    }, [refreshMode, refreshRate, refreshOptions, handleWidth, handleHeight, onResize, observerOptions, ref.current]);
    return __assign({ ref: ref }, size);
}exports["default"]=ResizeDetector;exports.useResizeDetector=useResizeDetector;exports.withResizeDetector=withResizeDetector;
}(withPolyfill));

var ReactResizeDetector = /*@__PURE__*/getDefaultExportFromCjs(withPolyfill);

/* eslint no-console: 0 */
var isDev = process.env.NODE_ENV !== 'production';
var warn = function warn(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  if (isDev && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }

    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var argIndex = 0;
        console.warn(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
      }
    }
  }
};

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

function _slicedToArray$5(arr, i) { return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _unsupportedIterableToArray$b(arr, i) || _nonIterableRest$5(); }

function _nonIterableRest$5() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$b(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$b(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$b(o, minLen); }

function _arrayLikeToArray$b(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$5(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$5(arr) { if (Array.isArray(arr)) return arr; }
var ResponsiveContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var aspect = _ref.aspect,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100%' : _ref$height,
      minWidth = _ref.minWidth,
      minHeight = _ref.minHeight,
      maxHeight = _ref.maxHeight,
      children = _ref.children,
      _ref$debounce = _ref.debounce,
      debounce = _ref$debounce === void 0 ? 0 : _ref$debounce,
      id = _ref.id,
      className = _ref.className;

  var _useState = useState({
    containerWidth: -1,
    containerHeight: -1
  }),
      _useState2 = _slicedToArray$5(_useState, 2),
      sizes = _useState2[0],
      setSizes = _useState2[1];

  var containerRef = useRef(null);
  useImperativeHandle(ref, function () {
    return containerRef;
  }, [containerRef]);

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$5(_useState3, 2),
      mounted = _useState4[0],
      setMounted = _useState4[1];

  var getContainerSize = function getContainerSize() {
    if (!containerRef.current) {
      return null;
    }

    return {
      containerWidth: containerRef.current.clientWidth,
      containerHeight: containerRef.current.clientHeight
    };
  };

  var updateDimensionsImmediate = function updateDimensionsImmediate() {
    if (!mounted) {
      return;
    }

    var newSize = getContainerSize();

    if (newSize) {
      var oldWidth = sizes.containerWidth,
          oldHeight = sizes.containerHeight;
      var containerWidth = newSize.containerWidth,
          containerHeight = newSize.containerHeight;

      if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
        setSizes({
          containerWidth: containerWidth,
          containerHeight: containerHeight
        });
      }
    }
  };

  var handleResize = debounce > 0 ? debounce_1(updateDimensionsImmediate, debounce) : updateDimensionsImmediate;

  var renderChart = function renderChart() {
    var containerWidth = sizes.containerWidth,
        containerHeight = sizes.containerHeight;

    if (containerWidth < 0 || containerHeight < 0) {
      return null;
    }

    warn(isPercent(width) || isPercent(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
    warn(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
    var calculatedWidth = isPercent(width) ? containerWidth : width;
    var calculatedHeight = isPercent(height) ? containerHeight : height;

    if (aspect && aspect > 0) {
      // Preserve the desired aspect ratio
      if (calculatedWidth) {
        // Will default to using width for aspect ratio
        calculatedHeight = calculatedWidth / aspect;
      } else if (calculatedHeight) {
        // But we should also take height into consideration
        calculatedWidth = calculatedHeight * aspect;
      } // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight


      if (maxHeight && calculatedHeight > maxHeight) {
        calculatedHeight = maxHeight;
      }
    }

    warn(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
    return /*#__PURE__*/cloneElement(children, {
      width: calculatedWidth,
      height: calculatedHeight
    });
  };

  useEffect(function () {
    if (mounted) {
      var size = getContainerSize();

      if (size) {
        setSizes(size);
      }
    }
  }, [mounted]);
  useEffect(function () {
    setMounted(true);
  }, []);
  var style = {
    width: width,
    height: height,
    minWidth: minWidth,
    minHeight: minHeight,
    maxHeight: maxHeight
  };
  return /*#__PURE__*/React$2.createElement(ReactResizeDetector, {
    handleWidth: true,
    handleHeight: true,
    onResize: handleResize,
    targetRef: containerRef
  }, /*#__PURE__*/React$2.createElement("div", _extends$k({}, id != null ? {
    id: "".concat(id)
  } : {}, {
    className: classNames('recharts-responsive-container', className),
    style: style,
    ref: containerRef
  }), renderChart()));
});

var dist = {exports: {}};

var openParentheses = "(".charCodeAt(0);
var closeParentheses = ")".charCodeAt(0);
var singleQuote = "'".charCodeAt(0);
var doubleQuote = '"'.charCodeAt(0);
var backslash = "\\".charCodeAt(0);
var slash = "/".charCodeAt(0);
var comma = ",".charCodeAt(0);
var colon = ":".charCodeAt(0);
var star = "*".charCodeAt(0);

var parse$4 = function(input) {
  var tokens = [];
  var value = input;

  var next, quote, prev, token, escape, escapePos, whitespacePos;
  var pos = 0;
  var code = value.charCodeAt(pos);
  var max = value.length;
  var stack = [{ nodes: tokens }];
  var balanced = 0;
  var parent;

  var name = "";
  var before = "";
  var after = "";

  while (pos < max) {
    // Whitespaces
    if (code <= 32) {
      next = pos;
      do {
        next += 1;
        code = value.charCodeAt(next);
      } while (code <= 32);
      token = value.slice(pos, next);

      prev = tokens[tokens.length - 1];
      if (code === closeParentheses && balanced) {
        after = token;
      } else if (prev && prev.type === "div") {
        prev.after = token;
      } else if (
        code === comma ||
        code === colon ||
        (code === slash && value.charCodeAt(next + 1) !== star)
      ) {
        before = token;
      } else {
        tokens.push({
          type: "space",
          sourceIndex: pos,
          value: token
        });
      }

      pos = next;

      // Quotes
    } else if (code === singleQuote || code === doubleQuote) {
      next = pos;
      quote = code === singleQuote ? "'" : '"';
      token = {
        type: "string",
        sourceIndex: pos,
        quote: quote
      };
      do {
        escape = false;
        next = value.indexOf(quote, next + 1);
        if (~next) {
          escapePos = next;
          while (value.charCodeAt(escapePos - 1) === backslash) {
            escapePos -= 1;
            escape = !escape;
          }
        } else {
          value += quote;
          next = value.length - 1;
          token.unclosed = true;
        }
      } while (escape);
      token.value = value.slice(pos + 1, next);

      tokens.push(token);
      pos = next + 1;
      code = value.charCodeAt(pos);

      // Comments
    } else if (code === slash && value.charCodeAt(pos + 1) === star) {
      token = {
        type: "comment",
        sourceIndex: pos
      };

      next = value.indexOf("*/", pos);
      if (next === -1) {
        token.unclosed = true;
        next = value.length;
      }

      token.value = value.slice(pos + 2, next);
      tokens.push(token);

      pos = next + 2;
      code = value.charCodeAt(pos);

      // Dividers
    } else if (code === slash || code === comma || code === colon) {
      token = value[pos];

      tokens.push({
        type: "div",
        sourceIndex: pos - before.length,
        value: token,
        before: before,
        after: ""
      });
      before = "";

      pos += 1;
      code = value.charCodeAt(pos);

      // Open parentheses
    } else if (openParentheses === code) {
      // Whitespaces after open parentheses
      next = pos;
      do {
        next += 1;
        code = value.charCodeAt(next);
      } while (code <= 32);
      token = {
        type: "function",
        sourceIndex: pos - name.length,
        value: name,
        before: value.slice(pos + 1, next)
      };
      pos = next;

      if (name === "url" && code !== singleQuote && code !== doubleQuote) {
        next -= 1;
        do {
          escape = false;
          next = value.indexOf(")", next + 1);
          if (~next) {
            escapePos = next;
            while (value.charCodeAt(escapePos - 1) === backslash) {
              escapePos -= 1;
              escape = !escape;
            }
          } else {
            value += ")";
            next = value.length - 1;
            token.unclosed = true;
          }
        } while (escape);
        // Whitespaces before closed
        whitespacePos = next;
        do {
          whitespacePos -= 1;
          code = value.charCodeAt(whitespacePos);
        } while (code <= 32);
        if (pos !== whitespacePos + 1) {
          token.nodes = [
            {
              type: "word",
              sourceIndex: pos,
              value: value.slice(pos, whitespacePos + 1)
            }
          ];
        } else {
          token.nodes = [];
        }
        if (token.unclosed && whitespacePos + 1 !== next) {
          token.after = "";
          token.nodes.push({
            type: "space",
            sourceIndex: whitespacePos + 1,
            value: value.slice(whitespacePos + 1, next)
          });
        } else {
          token.after = value.slice(whitespacePos + 1, next);
        }
        pos = next + 1;
        code = value.charCodeAt(pos);
        tokens.push(token);
      } else {
        balanced += 1;
        token.after = "";
        tokens.push(token);
        stack.push(token);
        tokens = token.nodes = [];
        parent = token;
      }
      name = "";

      // Close parentheses
    } else if (closeParentheses === code && balanced) {
      pos += 1;
      code = value.charCodeAt(pos);

      parent.after = after;
      after = "";
      balanced -= 1;
      stack.pop();
      parent = stack[balanced];
      tokens = parent.nodes;

      // Words
    } else {
      next = pos;
      do {
        if (code === backslash) {
          next += 1;
        }
        next += 1;
        code = value.charCodeAt(next);
      } while (
        next < max &&
        !(
          code <= 32 ||
          code === singleQuote ||
          code === doubleQuote ||
          code === comma ||
          code === colon ||
          code === slash ||
          code === openParentheses ||
          (code === closeParentheses && balanced)
        )
      );
      token = value.slice(pos, next);

      if (openParentheses === code) {
        name = token;
      } else {
        tokens.push({
          type: "word",
          sourceIndex: pos,
          value: token
        });
      }

      pos = next;
    }
  }

  for (pos = stack.length - 1; pos; pos -= 1) {
    stack[pos].unclosed = true;
  }

  return stack[0].nodes;
};

var walk$1 = function walk(nodes, cb, bubble) {
  var i, max, node, result;

  for (i = 0, max = nodes.length; i < max; i += 1) {
    node = nodes[i];
    if (!bubble) {
      result = cb(node, i, nodes);
    }

    if (
      result !== false &&
      node.type === "function" &&
      Array.isArray(node.nodes)
    ) {
      walk(node.nodes, cb, bubble);
    }

    if (bubble) {
      cb(node, i, nodes);
    }
  }
};

function stringifyNode(node, custom) {
  var type = node.type;
  var value = node.value;
  var buf;
  var customResult;

  if (custom && (customResult = custom(node)) !== undefined) {
    return customResult;
  } else if (type === "word" || type === "space") {
    return value;
  } else if (type === "string") {
    buf = node.quote || "";
    return buf + value + (node.unclosed ? "" : buf);
  } else if (type === "comment") {
    return "/*" + value + (node.unclosed ? "" : "*/");
  } else if (type === "div") {
    return (node.before || "") + value + (node.after || "");
  } else if (Array.isArray(node.nodes)) {
    buf = stringify$3(node.nodes);
    if (type !== "function") {
      return buf;
    }
    return (
      value +
      "(" +
      (node.before || "") +
      buf +
      (node.after || "") +
      (node.unclosed ? "" : ")")
    );
  }
  return value;
}

function stringify$3(nodes, custom) {
  var result, i;

  if (Array.isArray(nodes)) {
    result = "";
    for (i = nodes.length - 1; ~i; i -= 1) {
      result = stringifyNode(nodes[i], custom) + result;
    }
    return result;
  }
  return stringifyNode(nodes, custom);
}

var stringify_1 = stringify$3;

var minus = "-".charCodeAt(0);
var plus = "+".charCodeAt(0);
var dot = ".".charCodeAt(0);
var exp = "e".charCodeAt(0);
var EXP = "E".charCodeAt(0);

var unit$1 = function(value) {
  var pos = 0;
  var length = value.length;
  var dotted = false;
  var sciPos = -1;
  var containsNumber = false;
  var code;

  while (pos < length) {
    code = value.charCodeAt(pos);

    if (code >= 48 && code <= 57) {
      containsNumber = true;
    } else if (code === exp || code === EXP) {
      if (sciPos > -1) {
        break;
      }
      sciPos = pos;
    } else if (code === dot) {
      if (dotted) {
        break;
      }
      dotted = true;
    } else if (code === plus || code === minus) {
      if (pos !== 0) {
        break;
      }
    } else {
      break;
    }

    pos += 1;
  }

  if (sciPos + 1 === pos) pos--;

  return containsNumber
    ? {
        number: value.slice(0, pos),
        unit: value.slice(pos)
      }
    : false;
};

var parse$3 = parse$4;
var walk = walk$1;
var stringify$2 = stringify_1;

function ValueParser(value) {
  if (this instanceof ValueParser) {
    this.nodes = parse$3(value);
    return this;
  }
  return new ValueParser(value);
}

ValueParser.prototype.toString = function() {
  return Array.isArray(this.nodes) ? stringify$2(this.nodes) : "";
};

ValueParser.prototype.walk = function(cb, bubble) {
  walk(this.nodes, cb, bubble);
  return this;
};

ValueParser.unit = unit$1;

ValueParser.walk = walk;

ValueParser.stringify = stringify$2;

var lib$1 = ValueParser;

var parser = {};

(function (exports) {
/* parser generated by jison 0.6.1-215 */

/*
 * Returns a Parser object of the following structure:
 *
 *  Parser: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a derivative/copy of this one,
 *               not a direct reference!
 *  }
 *
 *  Parser.prototype: {
 *    yy: {},
 *    EOF: 1,
 *    TERROR: 2,
 *
 *    trace: function(errorMessage, ...),
 *
 *    JisonParserError: function(msg, hash),
 *
 *    quoteName: function(name),
 *               Helper function which can be overridden by user code later on: put suitable
 *               quotes around literal IDs in a description string.
 *
 *    originalQuoteName: function(name),
 *               The basic quoteName handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
 *               at the end of the `parse()`.
 *
 *    describeSymbol: function(symbol),
 *               Return a more-or-less human-readable description of the given symbol, when
 *               available, or the symbol itself, serving as its own 'description' for lack
 *               of something better to serve up.
 *
 *               Return NULL when the symbol is unknown to the parser.
 *
 *    symbols_: {associative list: name ==> number},
 *    terminals_: {associative list: number ==> name},
 *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
 *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
 *    productions_: [...],
 *
 *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
 *                             to store/reference the rule value `$$` and location info `@$`.
 *
 *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
 *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
 *                 data from one reduce action through to the next within a single parse run, then you
 *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
 *
 *                 `this.yy` is a direct reference to the `yy` shared state object.
 *
 *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
 *                 object at `parse()` start and are therefore available to the action code via the
 *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
 *                 the %parse-param` list.
 *
 *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
 *                             to match this rule. This is *not* the look-ahead token, but the last token
 *                             that's actually part of this rule.
 *
 *                 Formulated another way, `yytext` is the value of the token immediately preceeding
 *                 the current look-ahead token.
 *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
 *
 *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
 *
 *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
 *
 *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
 *
 *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
 *                               of an empty object when no suitable location info can be provided.
 *
 *               - `yystate` : the current parser state number, used internally for dispatching and
 *                               executing the action code chunk matching the rule currently being reduced.
 *
 *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *                 Also note that you can access this and other stack index values using the new double-hash
 *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
 *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
 *                 This is made available to write very advanced grammar action rules, e.g. when you want
 *                 to investigate the parse state stack in your action code, which would, for example,
 *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
 *                 to the work described here:
 *
 *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
 *                   In Journées Francophones des Languages Applicatifs.
 *
 *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
 *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
 *
 *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
 *                             constructs.
 *
 *               - `yylstack`: reference to the parser token location stack. Also accessed via
 *                             the `@1` etc. constructs.
 *
 *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
 *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
 *                             action code did not provide a suitable location info object when such a
 *                             slot was filled!
 *
 *               - `yystack` : reference to the parser token id stack. Also accessed via the
 *                             `#1` etc. constructs.
 *
 *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
 *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
 *                 want access this array for your own purposes, such as error analysis as mentioned above!
 *
 *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
 *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
 *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
 *                 *reduced*.
 *
 *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
 *                             *states* such as the one in `yystate`, which are used to represent
 *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
 *                             what can I say? If you access this one, you're clearly doing wicked things
 *
 *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
 *                             grammar definition file.
 *
 *    table: [...],
 *               State transition table
 *               ----------------------
 *
 *               index levels are:
 *               - `state`  --> hash table
 *               - `symbol` --> action (number or array)
 *
 *                 If the `action` is an array, these are the elements' meaning:
 *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
 *                 - index [1]: GOTO `state`
 *
 *                 If the `action` is a number, it is the GOTO `state`
 *
 *    defaultActions: {...},
 *
 *    parseError: function(str, hash, ExceptionClass),
 *    yyError: function(str, ...),
 *    yyRecovering: function(),
 *    yyErrOk: function(),
 *    yyClearIn: function(),
 *
 *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this parser kernel in many places; example usage:
 *
 *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
 *                                     parser.collect_expected_token_set(state), true);
 *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
 *
 *    originalParseError: function(str, hash, ExceptionClass),
 *               The basic `parseError` handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
 *               at the end of the `parse()`.
 *
 *    options: { ... parser %options ... },
 *
 *    parse: function(input[, args...]),
 *               Parse the given `input` and return the parsed value (or `true` when none was provided by
 *               the root action, in which case the parser is acting as a *matcher*).
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the jison run-time;
 *               when such a collision is detected an exception is thrown to prevent the generated run-time
 *               from silently accepting this confusing and potentially hazardous situation!
 *
 *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
 *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
 *               object and any collision with those will be reported by the lexer via a thrown exception.
 *
 *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
 *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
 *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
 *               the internal parser gets properly garbage collected under these particular circumstances.
 *
 *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
 *
 *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
 *               this function will attempt to obtain a suitable location marker by inspecting the location stack
 *               backwards.
 *
 *               For more info see the documentation comment further below, immediately above this function's
 *               implementation.
 *
 *    lexer: {
 *        yy: {...},           A reference to the so-called "shared state" `yy` once
 *                             received via a call to the `.setInput(input, yy)` lexer API.
 *        EOF: 1,
 *        ERROR: 2,
 *        JisonLexerError: function(msg, hash),
 *        parseError: function(str, hash, ExceptionClass),
 *        setInput: function(input, [yy]),
 *        input: function(),
 *        unput: function(str),
 *        more: function(),
 *        reject: function(),
 *        less: function(n),
 *        pastInput: function(n),
 *        upcomingInput: function(n),
 *        showPosition: function(),
 *        test_match: function(regex_match_array, rule_index, ...),
 *        next: function(...),
 *        lex: function(...),
 *        begin: function(condition),
 *        pushState: function(condition),
 *        popState: function(),
 *        topState: function(),
 *        _currentRules: function(),
 *        stateStackSize: function(),
 *        cleanupAfterLex: function()
 *
 *        options: { ... lexer %options ... },
 *
 *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
 *        rules: [...],
 *        conditions: {associative list: name ==> set},
 *    }
 *  }
 *
 *
 *  token location info (@$, _$, etc.): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer and
 * parser errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *  }
 *
 * parser (grammar) errors will also provide these additional members:
 *
 *  {
 *    expected:    (array describing the set of expected tokens;
 *                  may be UNDEFINED when we cannot easily produce such a set)
 *    state:       (integer (or array when the table includes grammar collisions);
 *                  represents the current internal state of the parser kernel.
 *                  can, for example, be used to pass to the `collect_expected_token_set()`
 *                  API to obtain the expected token set)
 *    action:      (integer; represents the current internal action which will be executed)
 *    new_state:   (integer; represents the next/planned internal state, once the current
 *                  action has executed)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *    parser:      (reference to the current parser instance)
 *  }
 *
 * while `this` will reference the current parser instance.
 *
 * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    lexer:       (reference to the current lexer instance which reported the error)
 *  }
 *
 * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
 * from either the parser or lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    exception:   (reference to the exception thrown)
 *  }
 *
 * Please do note that in the latter situation, the `expected` field will be omitted as
 * this type of failure is assumed not to be due to *parse errors* but rather due to user
 * action code in either parser or lexer failing unexpectedly.
 *
 * ---
 *
 * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
 * These options are available:
 *
 * ### options which are global for all parser instances
 *
 *  Parser.pre_parse: function(yy)
 *                 optional: you can specify a pre_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`.
 *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: you can specify a post_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`. When it does not return any value,
 *                 the parser will return the original `retval`.
 *
 * ### options which can be set up per parser instance
 *
 *  yy: {
 *      pre_parse:  function(yy)
 *                 optional: is invoked before the parse cycle starts (and before the first
 *                 invocation of `lex()`) but immediately after the invocation of
 *                 `parser.pre_parse()`).
 *      post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: is invoked when the parse terminates due to success ('accept')
 *                 or failure (even when exceptions are thrown).
 *                 `retval` contains the return value to be produced by `Parser.parse()`;
 *                 this function can override the return value by returning another.
 *                 When it does not return any value, the parser will return the original
 *                 `retval`.
 *                 This function is invoked immediately before `parser.post_parse()`.
 *
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *      quoteName: function(name),
 *                 optional: overrides the default `quoteName` function.
 *  }
 *
 *  parser.lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */

        
    
            var parser = (function () {


// See also:
// http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
// but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
// with userland code which might access the derived class in a 'classic' way.
function JisonParserError(msg, hash) {
    Object.defineProperty(this, 'name', {
        enumerable: false,
        writable: false,
        value: 'JisonParserError'
    });

    if (msg == null) msg = '???';

    Object.defineProperty(this, 'message', {
        enumerable: false,
        writable: true,
        value: msg
    });

    this.hash = hash;

    var stacktrace;
    if (hash && hash.exception instanceof Error) {
        var ex2 = hash.exception;
        this.message = ex2.message || msg;
        stacktrace = ex2.stack;
    }
    if (!stacktrace) {
        if (Error.hasOwnProperty('captureStackTrace')) {        // V8/Chrome engine
            Error.captureStackTrace(this, this.constructor);
        } else {
            stacktrace = (new Error(msg)).stack;
        }
    }
    if (stacktrace) {
        Object.defineProperty(this, 'stack', {
            enumerable: false,
            writable: false,
            value: stacktrace
        });
    }
}

if (typeof Object.setPrototypeOf === 'function') {
    Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
} else {
    JisonParserError.prototype = Object.create(Error.prototype);
}
JisonParserError.prototype.constructor = JisonParserError;
JisonParserError.prototype.name = 'JisonParserError';




        // helper: reconstruct the productions[] table
        function bp(s) {
            var rv = [];
            var p = s.pop;
            var r = s.rule;
            for (var i = 0, l = p.length; i < l; i++) {
                rv.push([
                    p[i],
                    r[i]
                ]);
            }
            return rv;
        }
    


        // helper: reconstruct the defaultActions[] table
        function bda(s) {
            var rv = {};
            var d = s.idx;
            var g = s.goto;
            for (var i = 0, l = d.length; i < l; i++) {
                var j = d[i];
                rv[j] = g[i];
            }
            return rv;
        }
    


        // helper: reconstruct the 'goto' table
        function bt(s) {
            var rv = [];
            var d = s.len;
            var y = s.symbol;
            var t = s.type;
            var a = s.state;
            var m = s.mode;
            var g = s.goto;
            for (var i = 0, l = d.length; i < l; i++) {
                var n = d[i];
                var q = {};
                for (var j = 0; j < n; j++) {
                    var z = y.shift();
                    switch (t.shift()) {
                    case 2:
                        q[z] = [
                            m.shift(),
                            g.shift()
                        ];
                        break;

                    case 0:
                        q[z] = a.shift();
                        break;

                    default:
                        // type === 1: accept
                        q[z] = [
                            3
                        ];
                    }
                }
                rv.push(q);
            }
            return rv;
        }
    


        // helper: runlength encoding with increment step: code, length: step (default step = 0)
        // `this` references an array
        function s(c, l, a) {
            a = a || 0;
            for (var i = 0; i < l; i++) {
                this.push(c);
                c += a;
            }
        }

        // helper: duplicate sequence from *relative* offset and length.
        // `this` references an array
        function c(i, l) {
            i = this.length - i;
            for (l += i; i < l; i++) {
                this.push(this[i]);
            }
        }

        // helper: unpack an array using helpers and data, all passed in an array argument 'a'.
        function u(a) {
            var rv = [];
            for (var i = 0, l = a.length; i < l; i++) {
                var e = a[i];
                // Is this entry a helper function?
                if (typeof e === 'function') {
                    i++;
                    e.apply(rv, a[i]);
                } else {
                    rv.push(e);
                }
            }
            return rv;
        }
    

var parser = {
    // Code Generator Information Report
    // ---------------------------------
    //
    // Options:
    //
    //   default action mode: ............. ["classic","merge"]
    //   test-compile action mode: ........ "parser:*,lexer:*"
    //   try..catch: ...................... true
    //   default resolve on conflict: ..... true
    //   on-demand look-ahead: ............ false
    //   error recovery token skip maximum: 3
    //   yyerror in parse actions is: ..... NOT recoverable,
    //   yyerror in lexer actions and other non-fatal lexer are:
    //   .................................. NOT recoverable,
    //   debug grammar/output: ............ false
    //   has partial LR conflict upgrade:   true
    //   rudimentary token-stack support:   false
    //   parser table compression mode: ... 2
    //   export debug tables: ............. false
    //   export *all* tables: ............. false
    //   module type: ..................... commonjs
    //   parser engine type: .............. lalr
    //   output main() in the module: ..... true
    //   has user-specified main(): ....... false
    //   has user-specified require()/import modules for main():
    //   .................................. false
    //   number of expected conflicts: .... 0
    //
    //
    // Parser Analysis flags:
    //
    //   no significant actions (parser is a language matcher only):
    //   .................................. false
    //   uses yyleng: ..................... false
    //   uses yylineno: ................... false
    //   uses yytext: ..................... false
    //   uses yylloc: ..................... false
    //   uses ParseError API: ............. false
    //   uses YYERROR: .................... false
    //   uses YYRECOVERING: ............... false
    //   uses YYERROK: .................... false
    //   uses YYCLEARIN: .................. false
    //   tracks rule values: .............. true
    //   assigns rule values: ............. true
    //   uses location tracking: .......... false
    //   assigns location: ................ false
    //   uses yystack: .................... false
    //   uses yysstack: ................... false
    //   uses yysp: ....................... true
    //   uses yyrulelength: ............... false
    //   uses yyMergeLocationInfo API: .... false
    //   has error recovery: .............. false
    //   has error reporting: ............. false
    //
    // --------- END OF REPORT -----------

trace: function no_op_trace() { },
JisonParserError: JisonParserError,
yy: {},
options: {
  type: "lalr",
  hasPartialLrUpgradeOnConflict: true,
  errorRecoveryTokenDiscardCount: 3
},
symbols_: {
  "$accept": 0,
  "$end": 1,
  "ADD": 3,
  "ANGLE": 16,
  "CHS": 22,
  "COMMA": 14,
  "CSS_CPROP": 13,
  "CSS_VAR": 12,
  "DIV": 6,
  "EMS": 20,
  "EOF": 1,
  "EXS": 21,
  "FREQ": 18,
  "LENGTH": 15,
  "LPAREN": 7,
  "MUL": 5,
  "NESTED_CALC": 9,
  "NUMBER": 11,
  "PERCENTAGE": 28,
  "PREFIX": 10,
  "REMS": 23,
  "RES": 19,
  "RPAREN": 8,
  "SUB": 4,
  "TIME": 17,
  "VHS": 24,
  "VMAXS": 27,
  "VMINS": 26,
  "VWS": 25,
  "css_value": 33,
  "css_variable": 32,
  "error": 2,
  "expression": 29,
  "math_expression": 30,
  "value": 31
},
terminals_: {
  1: "EOF",
  2: "error",
  3: "ADD",
  4: "SUB",
  5: "MUL",
  6: "DIV",
  7: "LPAREN",
  8: "RPAREN",
  9: "NESTED_CALC",
  10: "PREFIX",
  11: "NUMBER",
  12: "CSS_VAR",
  13: "CSS_CPROP",
  14: "COMMA",
  15: "LENGTH",
  16: "ANGLE",
  17: "TIME",
  18: "FREQ",
  19: "RES",
  20: "EMS",
  21: "EXS",
  22: "CHS",
  23: "REMS",
  24: "VHS",
  25: "VWS",
  26: "VMINS",
  27: "VMAXS",
  28: "PERCENTAGE"
},
TERROR: 2,
    EOF: 1,

    // internals: defined here so the object *structure* doesn't get modified by parse() et al,
    // thus helping JIT compilers like Chrome V8.
    originalQuoteName: null,
    originalParseError: null,
    cleanupAfterParse: null,
    constructParseErrorInfo: null,
    yyMergeLocationInfo: null,

    __reentrant_call_depth: 0,      // INTERNAL USE ONLY
    __error_infos: [],              // INTERNAL USE ONLY: the set of parseErrorInfo objects created since the last cleanup
    __error_recovery_infos: [],     // INTERNAL USE ONLY: the set of parseErrorInfo objects created since the last cleanup

    // APIs which will be set up depending on user action code analysis:
    //yyRecovering: 0,
    //yyErrOk: 0,
    //yyClearIn: 0,

    // Helper APIs
    // -----------

    // Helper function which can be overridden by user code later on: put suitable quotes around
    // literal IDs in a description string.
    quoteName: function parser_quoteName(id_str) {
        return '"' + id_str + '"';
    },

    // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
    //
    // Return NULL when the symbol is unknown to the parser.
    getSymbolName: function parser_getSymbolName(symbol) {
        if (this.terminals_[symbol]) {
            return this.terminals_[symbol];
        }

        // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
        //
        // An example of this may be where a rule's action code contains a call like this:
        //
        //      parser.getSymbolName(#$)
        //
        // to obtain a human-readable name of the current grammar rule.
        var s = this.symbols_;
        for (var key in s) {
            if (s[key] === symbol) {
                return key;
            }
        }
        return null;
    },

    // Return a more-or-less human-readable description of the given symbol, when available,
    // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
    //
    // Return NULL when the symbol is unknown to the parser.
    describeSymbol: function parser_describeSymbol(symbol) {
        if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) {
            return this.terminal_descriptions_[symbol];
        }
        else if (symbol === this.EOF) {
            return 'end of input';
        }
        var id = this.getSymbolName(symbol);
        if (id) {
            return this.quoteName(id);
        }
        return null;
    },

    // Produce a (more or less) human-readable list of expected tokens at the point of failure.
    //
    // The produced list may contain token or token set descriptions instead of the tokens
    // themselves to help turning this output into something that easier to read by humans
    // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
    // expected terminals and nonterminals is produced.
    //
    // The returned list (array) will not contain any duplicate entries.
    collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
        var TERROR = this.TERROR;
        var tokenset = [];
        var check = {};
        // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
        // If so, use that one instead of the less palatable token set.
        if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) {
            return [
                this.state_descriptions_[state]
            ];
        }
        for (var p in this.table[state]) {
            p = +p;
            if (p !== TERROR) {
                var d = do_not_describe ? p : this.describeSymbol(p);
                if (d && !check[d]) {
                    tokenset.push(d);
                    check[d] = true;        // Mark this token description as already mentioned to prevent outputting duplicate entries.
                }
            }
        }
        return tokenset;
    },
productions_: bp({
  pop: u([
  29,
  s,
  [30, 10],
  31,
  31,
  32,
  32,
  s,
  [33, 15]
]),
  rule: u([
  2,
  s,
  [3, 5],
  4,
  7,
  s,
  [1, 4],
  2,
  4,
  6,
  s,
  [1, 14],
  2
])
}),
performAction: function parser__PerformAction(yystate /* action[1] */, yysp, yyvstack) {

          /* this == yyval */

          // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
          var yy = this.yy;
          yy.parser;
          yy.lexer;

          

          switch (yystate) {
case 0:
    /*! Production::    $accept : expression $end */

    // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
    this.$ = yyvstack[yysp - 1];
    // END of default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-)
    break;

case 1:
    /*! Production::    expression : math_expression EOF */

    // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
    this.$ = yyvstack[yysp - 1];
    // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)
    
    
    return yyvstack[yysp - 1];

case 2:
    /*! Production::    math_expression : math_expression ADD math_expression */
case 3:
    /*! Production::    math_expression : math_expression SUB math_expression */
case 4:
    /*! Production::    math_expression : math_expression MUL math_expression */
case 5:
    /*! Production::    math_expression : math_expression DIV math_expression */

    this.$ = { type: 'MathExpression', operator: yyvstack[yysp - 1], left: yyvstack[yysp - 2], right: yyvstack[yysp] };
    break;

case 6:
    /*! Production::    math_expression : LPAREN math_expression RPAREN */

    this.$ = yyvstack[yysp - 1];
    break;

case 7:
    /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */

    this.$ = { type: 'Calc', value: yyvstack[yysp - 1] };
    break;

case 8:
    /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */

    this.$ = { type: 'Calc', value: yyvstack[yysp - 1], prefix: yyvstack[yysp - 5] };
    break;

case 9:
    /*! Production::    math_expression : css_variable */
case 10:
    /*! Production::    math_expression : css_value */
case 11:
    /*! Production::    math_expression : value */

    this.$ = yyvstack[yysp];
    break;

case 12:
    /*! Production::    value : NUMBER */

    this.$ = { type: 'Value', value: parseFloat(yyvstack[yysp]) };
    break;

case 13:
    /*! Production::    value : SUB NUMBER */

    this.$ = { type: 'Value', value: parseFloat(yyvstack[yysp]) * -1 };
    break;

case 14:
    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP RPAREN */

    this.$ = { type: 'CssVariable', value: yyvstack[yysp - 1] };
    break;

case 15:
    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP COMMA math_expression RPAREN */

    this.$ = { type: 'CssVariable', value: yyvstack[yysp - 3], fallback: yyvstack[yysp - 1] };
    break;

case 16:
    /*! Production::    css_value : LENGTH */

    this.$ = { type: 'LengthValue', value: parseFloat(yyvstack[yysp]), unit: /[a-z]+/.exec(yyvstack[yysp])[0] };
    break;

case 17:
    /*! Production::    css_value : ANGLE */

    this.$ = { type: 'AngleValue', value: parseFloat(yyvstack[yysp]), unit: /[a-z]+/.exec(yyvstack[yysp])[0] };
    break;

case 18:
    /*! Production::    css_value : TIME */

    this.$ = { type: 'TimeValue', value: parseFloat(yyvstack[yysp]), unit: /[a-z]+/.exec(yyvstack[yysp])[0] };
    break;

case 19:
    /*! Production::    css_value : FREQ */

    this.$ = { type: 'FrequencyValue', value: parseFloat(yyvstack[yysp]), unit: /[a-z]+/.exec(yyvstack[yysp])[0] };
    break;

case 20:
    /*! Production::    css_value : RES */

    this.$ = { type: 'ResolutionValue', value: parseFloat(yyvstack[yysp]), unit: /[a-z]+/.exec(yyvstack[yysp])[0] };
    break;

case 21:
    /*! Production::    css_value : EMS */

    this.$ = { type: 'EmValue', value: parseFloat(yyvstack[yysp]), unit: 'em' };
    break;

case 22:
    /*! Production::    css_value : EXS */

    this.$ = { type: 'ExValue', value: parseFloat(yyvstack[yysp]), unit: 'ex' };
    break;

case 23:
    /*! Production::    css_value : CHS */

    this.$ = { type: 'ChValue', value: parseFloat(yyvstack[yysp]), unit: 'ch' };
    break;

case 24:
    /*! Production::    css_value : REMS */

    this.$ = { type: 'RemValue', value: parseFloat(yyvstack[yysp]), unit: 'rem' };
    break;

case 25:
    /*! Production::    css_value : VHS */

    this.$ = { type: 'VhValue', value: parseFloat(yyvstack[yysp]), unit: 'vh' };
    break;

case 26:
    /*! Production::    css_value : VWS */

    this.$ = { type: 'VwValue', value: parseFloat(yyvstack[yysp]), unit: 'vw' };
    break;

case 27:
    /*! Production::    css_value : VMINS */

    this.$ = { type: 'VminValue', value: parseFloat(yyvstack[yysp]), unit: 'vmin' };
    break;

case 28:
    /*! Production::    css_value : VMAXS */

    this.$ = { type: 'VmaxValue', value: parseFloat(yyvstack[yysp]), unit: 'vmax' };
    break;

case 29:
    /*! Production::    css_value : PERCENTAGE */

    this.$ = { type: 'PercentageValue', value: parseFloat(yyvstack[yysp]), unit: '%' };
    break;

case 30:
    /*! Production::    css_value : SUB css_value */

    var prev = yyvstack[yysp]; prev.value *= -1; this.$ = prev;
    break;

}
},
table: bt({
  len: u([
  24,
  1,
  5,
  23,
  1,
  18,
  s,
  [0, 3],
  1,
  s,
  [0, 16],
  s,
  [23, 4],
  c,
  [28, 3],
  0,
  0,
  16,
  1,
  6,
  6,
  s,
  [0, 3],
  5,
  1,
  2,
  c,
  [37, 3],
  c,
  [20, 3],
  5,
  0,
  0
]),
  symbol: u([
  4,
  7,
  9,
  11,
  12,
  s,
  [15, 19, 1],
  1,
  1,
  s,
  [3, 4, 1],
  c,
  [30, 19],
  c,
  [29, 4],
  7,
  4,
  10,
  11,
  c,
  [22, 14],
  c,
  [19, 3],
  c,
  [43, 22],
  c,
  [23, 69],
  c,
  [139, 4],
  8,
  c,
  [51, 24],
  4,
  c,
  [138, 15],
  13,
  c,
  [186, 5],
  8,
  c,
  [6, 6],
  c,
  [5, 5],
  9,
  8,
  14,
  c,
  [159, 47],
  c,
  [60, 10]
]),
  type: u([
  s,
  [2, 19],
  s,
  [0, 5],
  1,
  s,
  [2, 24],
  s,
  [0, 4],
  c,
  [22, 19],
  c,
  [43, 42],
  c,
  [23, 70],
  c,
  [28, 25],
  c,
  [45, 25],
  c,
  [113, 54]
]),
  state: u([
  1,
  2,
  8,
  6,
  7,
  30,
  c,
  [4, 3],
  33,
  37,
  c,
  [5, 3],
  38,
  c,
  [4, 3],
  39,
  c,
  [4, 3],
  40,
  c,
  [4, 3],
  42,
  c,
  [21, 4],
  50,
  c,
  [5, 3],
  51,
  c,
  [4, 3]
]),
  mode: u([
  s,
  [1, 179],
  s,
  [2, 3],
  c,
  [5, 5],
  c,
  [6, 4],
  s,
  [1, 57]
]),
  goto: u([
  5,
  3,
  4,
  24,
  s,
  [9, 15, 1],
  s,
  [25, 5, 1],
  c,
  [24, 19],
  31,
  35,
  32,
  34,
  c,
  [18, 14],
  36,
  c,
  [38, 19],
  c,
  [19, 57],
  c,
  [118, 4],
  41,
  c,
  [24, 19],
  43,
  35,
  c,
  [16, 14],
  44,
  s,
  [2, 3],
  28,
  29,
  2,
  s,
  [3, 3],
  28,
  29,
  3,
  c,
  [53, 4],
  s,
  [45, 5, 1],
  c,
  [100, 42],
  52,
  c,
  [5, 4],
  53
])
}),
defaultActions: bda({
  idx: u([
  6,
  7,
  8,
  s,
  [10, 16, 1],
  33,
  34,
  39,
  40,
  41,
  45,
  47,
  52,
  53
]),
  goto: u([
  9,
  10,
  11,
  s,
  [16, 14, 1],
  12,
  1,
  30,
  13,
  s,
  [4, 4, 1],
  14,
  15,
  8
])
}),
parseError: function parseError(str, hash, ExceptionClass) {
    if (hash.recoverable) {
        if (typeof this.trace === 'function') {
            this.trace(str);
        }
        hash.destroy();             // destroy... well, *almost*!
    } else {
        if (typeof this.trace === 'function') {
            this.trace(str);
        }
        if (!ExceptionClass) {
            ExceptionClass = this.JisonParserError;
        }
        throw new ExceptionClass(str, hash);
    }
},
parse: function parse(input) {
    var self = this;
    var stack = new Array(128);         // token stack: stores token which leads to state at the same index (column storage)
    var sstack = new Array(128);        // state stack: stores states (column storage)

    var vstack = new Array(128);        // semantic value stack

    var table = this.table;
    var sp = 0;                         // 'stack pointer': index into the stacks


    


    var symbol = 0;



    this.TERROR;
    var EOF = this.EOF;
    (this.options.errorRecoveryTokenDiscardCount | 0) || 3;
    var NO_ACTION = [0, 54 /* === table.length :: ensures that anyone using this new state will fail dramatically! */];

    var lexer;
    if (this.__lexer__) {
        lexer = this.__lexer__;
    } else {
        lexer = this.__lexer__ = Object.create(this.lexer);
    }

    var sharedState_yy = {
        parseError: undefined,
        quoteName: undefined,
        lexer: undefined,
        parser: undefined,
        pre_parse: undefined,
        post_parse: undefined,
        pre_lex: undefined,
        post_lex: undefined      // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!
    };
    if (typeof assert !== 'function') ; else {
        assert;
    }

    this.yyGetSharedState = function yyGetSharedState() {
        return sharedState_yy;
    };








    function shallow_copy_noclobber(dst, src) {
        for (var k in src) {
            if (typeof dst[k] === 'undefined' && Object.prototype.hasOwnProperty.call(src, k)) {
                dst[k] = src[k];
            }
        }
    }

    // copy state
    shallow_copy_noclobber(sharedState_yy, this.yy);

    sharedState_yy.lexer = lexer;
    sharedState_yy.parser = this;






    // Does the shared state override the default `parseError` that already comes with this instance?
    if (typeof sharedState_yy.parseError === 'function') {
        this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
            if (!ExceptionClass) {
                ExceptionClass = this.JisonParserError;
            }
            return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
        };
    } else {
        this.parseError = this.originalParseError;
    }

    // Does the shared state override the default `quoteName` that already comes with this instance?
    if (typeof sharedState_yy.quoteName === 'function') {
        this.quoteName = function quoteNameAlt(id_str) {
            return sharedState_yy.quoteName.call(this, id_str);
        };
    } else {
        this.quoteName = this.originalQuoteName;
    }

    // set up the cleanup function; make it an API so that external code can re-use this one in case of
    // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
    // case this parse() API method doesn't come with a `finally { ... }` block any more!
    //
    // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
    //       or else your `sharedState`, etc. references will be *wrong*!
    this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
        var rv;

        if (invoke_post_methods) {
            var hash;

            if (sharedState_yy.post_parse || this.post_parse) {
                // create an error hash info instance: we re-use this API in a **non-error situation**
                // as this one delivers all parser internals ready for access by userland code.
                hash = this.constructParseErrorInfo(null /* no error! */, null /* no exception! */, null, false);
            }

            if (sharedState_yy.post_parse) {
                rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
                if (typeof rv !== 'undefined') resultValue = rv;
            }
            if (this.post_parse) {
                rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
                if (typeof rv !== 'undefined') resultValue = rv;
            }

            // cleanup:
            if (hash && hash.destroy) {
                hash.destroy();
            }
        }

        if (this.__reentrant_call_depth > 1) return resultValue;        // do not (yet) kill the sharedState when this is a reentrant run.

        // clean up the lingering lexer structures as well:
        if (lexer.cleanupAfterLex) {
            lexer.cleanupAfterLex(do_not_nuke_errorinfos);
        }

        // prevent lingering circular references from causing memory leaks:
        if (sharedState_yy) {
            sharedState_yy.lexer = undefined;
            sharedState_yy.parser = undefined;
            if (lexer.yy === sharedState_yy) {
                lexer.yy = undefined;
            }
        }
        sharedState_yy = undefined;
        this.parseError = this.originalParseError;
        this.quoteName = this.originalQuoteName;

        // nuke the vstack[] array at least as that one will still reference obsoleted user values.
        // To be safe, we nuke the other internal stack columns as well...
        stack.length = 0;               // fastest way to nuke an array without overly bothering the GC
        sstack.length = 0;

        vstack.length = 0;
        sp = 0;

        // nuke the error hash info instances created during this run.
        // Userland code must COPY any data/references
        // in the error hash instance(s) it is more permanently interested in.
        if (!do_not_nuke_errorinfos) {
            for (var i = this.__error_infos.length - 1; i >= 0; i--) {
                var el = this.__error_infos[i];
                if (el && typeof el.destroy === 'function') {
                    el.destroy();
                }
            }
            this.__error_infos.length = 0;


        }

        return resultValue;
    };






































































































































    // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
    //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!
    this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
        var pei = {
            errStr: msg,
            exception: ex,
            text: lexer.match,
            value: lexer.yytext,
            token: this.describeSymbol(symbol) || symbol,
            token_id: symbol,
            line: lexer.yylineno,

            expected: expected,
            recoverable: recoverable,
            state: state,
            action: action,
            new_state: newState,
            symbol_stack: stack,
            state_stack: sstack,
            value_stack: vstack,

            stack_pointer: sp,
            yy: sharedState_yy,
            lexer: lexer,
            parser: this,

            // and make sure the error info doesn't stay due to potential
            // ref cycle via userland code manipulations.
            // These would otherwise all be memory leak opportunities!
            //
            // Note that only array and object references are nuked as those
            // constitute the set of elements which can produce a cyclic ref.
            // The rest of the members is kept intact as they are harmless.
            destroy: function destructParseErrorInfo() {
                // remove cyclic references added to error info:
                // info.yy = null;
                // info.lexer = null;
                // info.value = null;
                // info.value_stack = null;
                // ...
                var rec = !!this.recoverable;
                for (var key in this) {
                    if (this.hasOwnProperty(key) && typeof key === 'object') {
                        this[key] = undefined;
                    }
                }
                this.recoverable = rec;
            }
        };
        // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
        this.__error_infos.push(pei);
        return pei;
    };


    function stdLex() {
        var token = lexer.lex();
        // if token isn't its numeric value, convert
        if (typeof token !== 'number') {
            token = self.symbols_[token] || token;
        }

        return token || EOF;
    }

    function fastLex() {
        var token = lexer.fastLex();
        // if token isn't its numeric value, convert
        if (typeof token !== 'number') {
            token = self.symbols_[token] || token;
        }

        return token || EOF;
    }

    var lex = stdLex;


    var state, action, r, t;
    var yyval = {
        $: true,
        _$: undefined,
        yy: sharedState_yy
    };
    var p;
    var yyrulelen;
    var this_production;
    var newState;
    var retval = false;


    try {
        this.__reentrant_call_depth++;

        lexer.setInput(input, sharedState_yy);

        // NOTE: we *assume* no lexer pre/post handlers are set up *after* 
        // this initial `setInput()` call: hence we can now check and decide
        // whether we'll go with the standard, slower, lex() API or the
        // `fast_lex()` one:
        if (typeof lexer.canIUse === 'function') {
            var lexerInfo = lexer.canIUse();
            if (lexerInfo.fastLex && typeof fastLex === 'function') {
                lex = fastLex;
            }
        } 



        vstack[sp] = null;
        sstack[sp] = 0;
        stack[sp] = 0;
        ++sp;





        if (this.pre_parse) {
            this.pre_parse.call(this, sharedState_yy);
        }
        if (sharedState_yy.pre_parse) {
            sharedState_yy.pre_parse.call(this, sharedState_yy);
        }

        newState = sstack[sp - 1];
        for (;;) {
            // retrieve state number from top of stack
            state = newState;               // sstack[sp - 1];

            // use default actions if available
            if (this.defaultActions[state]) {
                action = 2;
                newState = this.defaultActions[state];
            } else {
                // The single `==` condition below covers both these `===` comparisons in a single
                // operation:
                //
                //     if (symbol === null || typeof symbol === 'undefined') ...
                if (!symbol) {
                    symbol = lex();
                }
                // read action for current state and first input
                t = (table[state] && table[state][symbol]) || NO_ACTION;
                newState = t[1];
                action = t[0];











                // handle parse error
                if (!action) {
                    var errStr;
                    var errSymbolDescr = (this.describeSymbol(symbol) || symbol);
                    var expected = this.collect_expected_token_set(state);

                    // Report error
                    if (typeof lexer.yylineno === 'number') {
                        errStr = 'Parse error on line ' + (lexer.yylineno + 1) + ': ';
                    } else {
                        errStr = 'Parse error: ';
                    }
                    if (typeof lexer.showPosition === 'function') {
                        errStr += '\n' + lexer.showPosition(79 - 10, 10) + '\n';
                    }
                    if (expected.length) {
                        errStr += 'Expecting ' + expected.join(', ') + ', got unexpected ' + errSymbolDescr;
                    } else {
                        errStr += 'Unexpected ' + errSymbolDescr;
                    }
                    // we cannot recover from the error!
                    p = this.constructParseErrorInfo(errStr, null, expected, false);
                    r = this.parseError(p.errStr, p, this.JisonParserError);
                    if (typeof r !== 'undefined') {
                        retval = r;
                    }
                    break;
                }


            }










            switch (action) {
            // catch misc. parse failures:
            default:
                // this shouldn't happen, unless resolve defaults are off
                if (action instanceof Array) {
                    p = this.constructParseErrorInfo('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol, null, null, false);
                    r = this.parseError(p.errStr, p, this.JisonParserError);
                    if (typeof r !== 'undefined') {
                        retval = r;
                    }
                    break;
                }
                // Another case of better safe than sorry: in case state transitions come out of another error recovery process
                // or a buggy LUT (LookUp Table):
                p = this.constructParseErrorInfo('Parsing halted. No viable error recovery approach available due to internal system failure.', null, null, false);
                r = this.parseError(p.errStr, p, this.JisonParserError);
                if (typeof r !== 'undefined') {
                    retval = r;
                }
                break;

            // shift:
            case 1:
                stack[sp] = symbol;
                vstack[sp] = lexer.yytext;

                sstack[sp] = newState; // push state

                ++sp;
                symbol = 0;




                // Pick up the lexer details for the current symbol as that one is not 'look-ahead' any more:




                continue;

            // reduce:
            case 2:



                this_production = this.productions_[newState - 1];  // `this.productions_[]` is zero-based indexed while states start from 1 upwards...
                yyrulelen = this_production[1];










                r = this.performAction.call(yyval, newState, sp - 1, vstack);

                if (typeof r !== 'undefined') {
                    retval = r;
                    break;
                }

                // pop off stack
                sp -= yyrulelen;

                // don't overwrite the `symbol` variable: use a local var to speed things up:
                var ntsymbol = this_production[0];    // push nonterminal (reduce)
                stack[sp] = ntsymbol;
                vstack[sp] = yyval.$;

                // goto new state = table[STATE][NONTERMINAL]
                newState = table[sstack[sp - 1]][ntsymbol];
                sstack[sp] = newState;
                ++sp;









                continue;

            // accept:
            case 3:
                if (sp !== -2) {
                    retval = true;
                    // Return the `$accept` rule's `$$` result, if available.
                    //
                    // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                    // default, action):
                    //
                    //     $accept: <startSymbol> $end
                    //                  %{ $$ = $1; @$ = @1; %}
                    //
                    // which, combined with the parse kernel's `$accept` state behaviour coded below,
                    // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                    // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                    //
                    // In code:
                    //
                    //                  %{
                    //                      @$ = @1;            // if location tracking support is included
                    //                      if (typeof $1 !== 'undefined')
                    //                          return $1;
                    //                      else
                    //                          return true;           // the default parse result if the rule actions don't produce anything
                    //                  %}
                    sp--;
                    if (typeof vstack[sp] !== 'undefined') {
                        retval = vstack[sp];
                    }
                }
                break;
            }

            // break out of loop: we accept or fail with error
            break;
        }
    } catch (ex) {
        // report exceptions through the parseError callback too, but keep the exception intact
        // if it is a known parser or lexer error which has been thrown by parseError() already:
        if (ex instanceof this.JisonParserError) {
            throw ex;
        }
        else if (lexer && typeof lexer.JisonLexerError === 'function' && ex instanceof lexer.JisonLexerError) {
            throw ex;
        }

        p = this.constructParseErrorInfo('Parsing aborted due to exception.', ex, null, false);
        retval = false;
        r = this.parseError(p.errStr, p, this.JisonParserError);
        if (typeof r !== 'undefined') {
            retval = r;
        }
    } finally {
        retval = this.cleanupAfterParse(retval, true, true);
        this.__reentrant_call_depth--;
    }   // /finally

    return retval;
}
};
parser.originalParseError = parser.parseError;
parser.originalQuoteName = parser.quoteName;
/* lexer generated by jison-lex 0.6.1-215 */

/*
 * Returns a Lexer object of the following structure:
 *
 *  Lexer: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a direct reference!
 *
 *               This "shared context" object was passed to the lexer by way of 
 *               the `lexer.setInput(str, yy)` API before you may use it.
 *
 *               This "shared context" object is passed to the lexer action code in `performAction()`
 *               so userland code in the lexer actions may communicate with the outside world 
 *               and/or other lexer rules' actions in more or less complex ways.
 *
 *  }
 *
 *  Lexer.prototype: {
 *    EOF: 1,
 *    ERROR: 2,
 *
 *    yy:        The overall "shared context" object reference.
 *
 *    JisonLexerError: function(msg, hash),
 *
 *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `lexer` instance. 
 *                               `yy_` is an alias for `this` lexer instance reference used internally.
 *
 *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
 *                             by way of the `lexer.setInput(str, yy)` API before.
 *
 *                             Note:
 *                             The extra arguments you specified in the `%parse-param` statement in your
 *                             **parser** grammar definition file are passed to the lexer via this object
 *                             reference as member variables.
 *
 *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
 *
 *               - `YY_START`: the current lexer "start condition" state.
 *
 *    parseError: function(str, hash, ExceptionClass),
 *
 *    constructLexErrorInfo: function(error_message, is_recoverable),
 *               Helper function.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this lexer kernel in many places; example usage:
 *
 *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
 *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
 *
 *    options: { ... lexer %options ... },
 *
 *    lex: function(),
 *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the **parser** or the jison run-time; 
 *               when such a collision is detected an exception is thrown to prevent the generated run-time 
 *               from silently accepting this confusing and potentially hazardous situation! 
 *
 *    cleanupAfterLex: function(do_not_nuke_errorinfos),
 *               Helper function.
 *
 *               This helper API is invoked when the **parse process** has completed: it is the responsibility
 *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired. 
 *
 *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
 *
 *    setInput: function(input, [yy]),
 *
 *
 *    input: function(),
 *
 *
 *    unput: function(str),
 *
 *
 *    more: function(),
 *
 *
 *    reject: function(),
 *
 *
 *    less: function(n),
 *
 *
 *    pastInput: function(n),
 *
 *
 *    upcomingInput: function(n),
 *
 *
 *    showPosition: function(),
 *
 *
 *    test_match: function(regex_match_array, rule_index),
 *
 *
 *    next: function(),
 *
 *
 *    begin: function(condition),
 *
 *
 *    pushState: function(condition),
 *
 *
 *    popState: function(),
 *
 *
 *    topState: function(),
 *
 *
 *    _currentRules: function(),
 *
 *
 *    stateStackSize: function(),
 *
 *
 *    performAction: function(yy, yy_, yyrulenumber, YY_START),
 *
 *
 *    rules: [...],
 *
 *
 *    conditions: {associative list: name ==> set},
 *  }
 *
 *
 *  token location info (`yylloc`): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *  }
 *
 * while `this` will reference the current lexer instance.
 *
 * When `parseError` is invoked by the lexer, the default implementation will
 * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
 * it will try to invoke `yy.parseError()` instead. When that callback is also not
 * provided, a `JisonLexerError` exception will be thrown containing the error
 * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
 *
 * Note that the lexer's `JisonLexerError` error class is passed via the
 * `ExceptionClass` argument, which is invoked to construct the exception
 * instance to be thrown, so technically `parseError` will throw the object
 * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
 *
 * ---
 *
 * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
 * These options are available:
 *
 * (Options are permanent.)
 *  
 *  yy: {
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *  }
 *
 *  lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 * WARNING: the next set of options are not meant to be changed. They echo the abilities of
 * the lexer as per when it was compiled!
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */


var lexer = function() {
  /**
   * See also:
   * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
   * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
   * with userland code which might access the derived class in a 'classic' way.
   *
   * @public
   * @constructor
   * @nocollapse
   */
  function JisonLexerError(msg, hash) {
    Object.defineProperty(this, 'name', {
      enumerable: false,
      writable: false,
      value: 'JisonLexerError'
    });

    if (msg == null)
      msg = '???';

    Object.defineProperty(this, 'message', {
      enumerable: false,
      writable: true,
      value: msg
    });

    this.hash = hash;
    var stacktrace;

    if (hash && hash.exception instanceof Error) {
      var ex2 = hash.exception;
      this.message = ex2.message || msg;
      stacktrace = ex2.stack;
    }

    if (!stacktrace) {
      if (Error.hasOwnProperty('captureStackTrace')) {
        // V8
        Error.captureStackTrace(this, this.constructor);
      } else {
        stacktrace = new Error(msg).stack;
      }
    }

    if (stacktrace) {
      Object.defineProperty(this, 'stack', {
        enumerable: false,
        writable: false,
        value: stacktrace
      });
    }
  }

  if (typeof Object.setPrototypeOf === 'function') {
    Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
  } else {
    JisonLexerError.prototype = Object.create(Error.prototype);
  }

  JisonLexerError.prototype.constructor = JisonLexerError;
  JisonLexerError.prototype.name = 'JisonLexerError';

  var lexer = {
    
// Code Generator Information Report
// ---------------------------------
//
// Options:
//
//   backtracking: .................... false
//   location.ranges: ................. false
//   location line+column tracking: ... true
//
//
// Forwarded Parser Analysis flags:
//
//   uses yyleng: ..................... false
//   uses yylineno: ................... false
//   uses yytext: ..................... false
//   uses yylloc: ..................... false
//   uses lexer values: ............... true / true
//   location tracking: ............... false
//   location assignment: ............. false
//
//
// Lexer Analysis flags:
//
//   uses yyleng: ..................... ???
//   uses yylineno: ................... ???
//   uses yytext: ..................... ???
//   uses yylloc: ..................... ???
//   uses ParseError API: ............. ???
//   uses yyerror: .................... ???
//   uses location tracking & editing:  ???
//   uses more() API: ................. ???
//   uses unput() API: ................ ???
//   uses reject() API: ............... ???
//   uses less() API: ................. ???
//   uses display APIs pastInput(), upcomingInput(), showPosition():
//        ............................. ???
//   uses describeYYLLOC() API: ....... ???
//
// --------- END OF REPORT -----------

EOF: 1,
    ERROR: 2,

    // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator

    // options: {},                             /// <-- injected by the code generator

    // yy: ...,                                 /// <-- injected by setInput()

    __currentRuleSet__: null,                   /// INTERNAL USE ONLY: internal rule set cache for the current lexer state  

    __error_infos: [],                          /// INTERNAL USE ONLY: the set of lexErrorInfo objects created since the last cleanup  
    __decompressed: false,                      /// INTERNAL USE ONLY: mark whether the lexer instance has been 'unfolded' completely and is now ready for use  
    done: false,                                /// INTERNAL USE ONLY  
    _backtrack: false,                          /// INTERNAL USE ONLY  
    _input: '',                                 /// INTERNAL USE ONLY  
    _more: false,                               /// INTERNAL USE ONLY  
    _signaled_error_token: false,               /// INTERNAL USE ONLY  
    conditionStack: [],                         /// INTERNAL USE ONLY; managed via `pushState()`, `popState()`, `topState()` and `stateStackSize()`  
    match: '',                                  /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks input which has been matched so far for the lexer token under construction. `match` is identical to `yytext` except that this one still contains the matched input string after `lexer.performAction()` has been invoked, where userland code MAY have changed/replaced the `yytext` value entirely!  
    matched: '',                                /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks entire input which has been matched so far  
    matches: false,                             /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks RE match result for last (successful) match attempt  
    yytext: '',                                 /// ADVANCED USE ONLY: tracks input which has been matched so far for the lexer token under construction; this value is transferred to the parser as the 'token value' when the parser consumes the lexer token produced through a call to the `lex()` API.  
    offset: 0,                                  /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks the 'cursor position' in the input string, i.e. the number of characters matched so far  
    yyleng: 0,                                  /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: length of matched input for the token under construction (`yytext`)  
    yylineno: 0,                                /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: 'line number' at which the token under construction is located  
    yylloc: null,                               /// READ-ONLY EXTERNAL ACCESS - ADVANCED USE ONLY: tracks location info (lines + columns) for the token under construction  

    /**
     * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
     * 
     * @public
     * @this {RegExpLexer}
     */
    constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
      msg = '' + msg;

      // heuristic to determine if the error message already contains a (partial) source code dump
      // as produced by either `showPosition()` or `prettyPrintRange()`:
      if (show_input_position == undefined) {
        show_input_position = !(msg.indexOf('\n') > 0 && msg.indexOf('^') > 0);
      }

      if (this.yylloc && show_input_position) {
        if (typeof this.prettyPrintRange === 'function') {
          this.prettyPrintRange(this.yylloc);

          if (!/\n\s*$/.test(msg)) {
            msg += '\n';
          }

          msg += '\n  Erroneous area:\n' + this.prettyPrintRange(this.yylloc);
        } else if (typeof this.showPosition === 'function') {
          var pos_str = this.showPosition();

          if (pos_str) {
            if (msg.length && msg[msg.length - 1] !== '\n' && pos_str[0] !== '\n') {
              msg += '\n' + pos_str;
            } else {
              msg += pos_str;
            }
          }
        }
      }

      /** @constructor */
      var pei = {
        errStr: msg,
        recoverable: !!recoverable,
        text: this.match,           // This one MAY be empty; userland code should use the `upcomingInput` API to obtain more text which follows the 'lexer cursor position'...  
        token: null,
        line: this.yylineno,
        loc: this.yylloc,
        yy: this.yy,
        lexer: this,

        /**
         * and make sure the error info doesn't stay due to potential
         * ref cycle via userland code manipulations.
         * These would otherwise all be memory leak opportunities!
         * 
         * Note that only array and object references are nuked as those
         * constitute the set of elements which can produce a cyclic ref.
         * The rest of the members is kept intact as they are harmless.
         * 
         * @public
         * @this {LexErrorInfo}
         */
        destroy: function destructLexErrorInfo() {
          // remove cyclic references added to error info:
          // info.yy = null;
          // info.lexer = null;
          // ...
          var rec = !!this.recoverable;

          for (var key in this) {
            if (this.hasOwnProperty(key) && typeof key === 'object') {
              this[key] = undefined;
            }
          }

          this.recoverable = rec;
        }
      };

      // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
      this.__error_infos.push(pei);

      return pei;
    },

    /**
     * handler which is invoked when a lexer error occurs.
     * 
     * @public
     * @this {RegExpLexer}
     */
    parseError: function lexer_parseError(str, hash, ExceptionClass) {
      if (!ExceptionClass) {
        ExceptionClass = this.JisonLexerError;
      }

      if (this.yy) {
        if (this.yy.parser && typeof this.yy.parser.parseError === 'function') {
          return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
        } else if (typeof this.yy.parseError === 'function') {
          return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
        }
      }

      throw new ExceptionClass(str, hash);
    },

    /**
     * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
     * 
     * @public
     * @this {RegExpLexer}
     */
    yyerror: function yyError(str /*, ...args */) {
      var lineno_msg = '';

      if (this.yylloc) {
        lineno_msg = ' on line ' + (this.yylineno + 1);
      }

      var p = this.constructLexErrorInfo(
        'Lexical error' + lineno_msg + ': ' + str,
        this.options.lexerErrorsAreRecoverable
      );

      // Add any extra args to the hash under the name `extra_error_attributes`:
      var args = Array.prototype.slice.call(arguments, 1);

      if (args.length) {
        p.extra_error_attributes = args;
      }

      return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
    },

    /**
     * final cleanup function for when we have completed lexing the input;
     * make it an API so that external code can use this one once userland
     * code has decided it's time to destroy any lingering lexer error
     * hash object instances and the like: this function helps to clean
     * up these constructs, which *may* carry cyclic references which would
     * otherwise prevent the instances from being properly and timely
     * garbage-collected, i.e. this function helps prevent memory leaks!
     * 
     * @public
     * @this {RegExpLexer}
     */
    cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
      // prevent lingering circular references from causing memory leaks:
      this.setInput('', {});

      // nuke the error hash info instances created during this run.
      // Userland code must COPY any data/references
      // in the error hash instance(s) it is more permanently interested in.
      if (!do_not_nuke_errorinfos) {
        for (var i = this.__error_infos.length - 1; i >= 0; i--) {
          var el = this.__error_infos[i];

          if (el && typeof el.destroy === 'function') {
            el.destroy();
          }
        }

        this.__error_infos.length = 0;
      }

      return this;
    },

    /**
     * clear the lexer token context; intended for internal use only
     * 
     * @public
     * @this {RegExpLexer}
     */
    clear: function lexer_clear() {
      this.yytext = '';
      this.yyleng = 0;
      this.match = '';

      // - DO NOT reset `this.matched`
      this.matches = false;

      this._more = false;
      this._backtrack = false;
      var col = (this.yylloc ? this.yylloc.last_column : 0);

      this.yylloc = {
        first_line: this.yylineno + 1,
        first_column: col,
        last_line: this.yylineno + 1,
        last_column: col,
        range: [this.offset, this.offset]
      };
    },

    /**
     * resets the lexer, sets new input
     * 
     * @public
     * @this {RegExpLexer}
     */
    setInput: function lexer_setInput(input, yy) {
      this.yy = yy || this.yy || {};

      // also check if we've fully initialized the lexer instance,
      // including expansion work to be done to go from a loaded
      // lexer to a usable lexer:
      if (!this.__decompressed) {
        // step 1: decompress the regex list:
        var rules = this.rules;

        for (var i = 0, len = rules.length; i < len; i++) {
          var rule_re = rules[i];

          // compression: is the RE an xref to another RE slot in the rules[] table?
          if (typeof rule_re === 'number') {
            rules[i] = rules[rule_re];
          }
        }

        // step 2: unfold the conditions[] set to make these ready for use:
        var conditions = this.conditions;

        for (var k in conditions) {
          var spec = conditions[k];
          var rule_ids = spec.rules;
          var len = rule_ids.length;
          var rule_regexes = new Array(len + 1);             // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple! 
          var rule_new_ids = new Array(len + 1);

          for (var i = 0; i < len; i++) {
            var idx = rule_ids[i];
            var rule_re = rules[idx];
            rule_regexes[i + 1] = rule_re;
            rule_new_ids[i + 1] = idx;
          }

          spec.rules = rule_new_ids;
          spec.__rule_regexes = rule_regexes;
          spec.__rule_count = len;
        }

        this.__decompressed = true;
      }

      this._input = input || '';
      this.clear();
      this._signaled_error_token = false;
      this.done = false;
      this.yylineno = 0;
      this.matched = '';
      this.conditionStack = ['INITIAL'];
      this.__currentRuleSet__ = null;

      this.yylloc = {
        first_line: 1,
        first_column: 0,
        last_line: 1,
        last_column: 0,
        range: [0, 0]
      };

      this.offset = 0;
      return this;
    },

    /**
     * edit the remaining input via user-specified callback.
     * This can be used to forward-adjust the input-to-parse, 
     * e.g. inserting macro expansions and alike in the
     * input which has yet to be lexed.
     * The behaviour of this API contrasts the `unput()` et al
     * APIs as those act on the *consumed* input, while this
     * one allows one to manipulate the future, without impacting
     * the current `yyloc` cursor location or any history. 
     * 
     * Use this API to help implement C-preprocessor-like
     * `#include` statements, etc.
     * 
     * The provided callback must be synchronous and is
     * expected to return the edited input (string).
     *
     * The `cpsArg` argument value is passed to the callback
     * as-is.
     *
     * `callback` interface: 
     * `function callback(input, cpsArg)`
     * 
     * - `input` will carry the remaining-input-to-lex string
     *   from the lexer.
     * - `cpsArg` is `cpsArg` passed into this API.
     * 
     * The `this` reference for the callback will be set to
     * reference this lexer instance so that userland code
     * in the callback can easily and quickly access any lexer
     * API. 
     *
     * When the callback returns a non-string-type falsey value,
     * we assume the callback did not edit the input and we
     * will using the input as-is.
     *
     * When the callback returns a non-string-type value, it
     * is converted to a string for lexing via the `"" + retval`
     * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html 
     * -- that way any returned object's `toValue()` and `toString()`
     * methods will be invoked in a proper/desirable order.)
     * 
     * @public
     * @this {RegExpLexer}
     */
    editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
      var rv = callback.call(this, this._input, cpsArg);

      if (typeof rv !== 'string') {
        if (rv) {
          this._input = '' + rv;
        } 
        // else: keep `this._input` as is.  
      } else {
        this._input = rv;
      }

      return this;
    },

    /**
     * consumes and returns one char from the input
     * 
     * @public
     * @this {RegExpLexer}
     */
    input: function lexer_input() {
      if (!this._input) {
        //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
        return null;
      }

      var ch = this._input[0];
      this.yytext += ch;
      this.yyleng++;
      this.offset++;
      this.match += ch;
      this.matched += ch;

      // Count the linenumber up when we hit the LF (or a stand-alone CR).
      // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
      // and we advance immediately past the LF as well, returning both together as if
      // it was all a single 'character' only.
      var slice_len = 1;

      var lines = false;

      if (ch === '\n') {
        lines = true;
      } else if (ch === '\r') {
        lines = true;
        var ch2 = this._input[1];

        if (ch2 === '\n') {
          slice_len++;
          ch += ch2;
          this.yytext += ch2;
          this.yyleng++;
          this.offset++;
          this.match += ch2;
          this.matched += ch2;
          this.yylloc.range[1]++;
        }
      }

      if (lines) {
        this.yylineno++;
        this.yylloc.last_line++;
        this.yylloc.last_column = 0;
      } else {
        this.yylloc.last_column++;
      }

      this.yylloc.range[1]++;
      this._input = this._input.slice(slice_len);
      return ch;
    },

    /**
     * unshifts one char (or an entire string) into the input
     * 
     * @public
     * @this {RegExpLexer}
     */
    unput: function lexer_unput(ch) {
      var len = ch.length;
      var lines = ch.split(/(?:\r\n?|\n)/g);
      this._input = ch + this._input;
      this.yytext = this.yytext.substr(0, this.yytext.length - len);
      this.yyleng = this.yytext.length;
      this.offset -= len;
      this.match = this.match.substr(0, this.match.length - len);
      this.matched = this.matched.substr(0, this.matched.length - len);

      if (lines.length > 1) {
        this.yylineno -= lines.length - 1;
        this.yylloc.last_line = this.yylineno + 1;

        // Get last entirely matched line into the `pre_lines[]` array's
        // last index slot; we don't mind when other previously 
        // matched lines end up in the array too. 
        var pre = this.match;

        var pre_lines = pre.split(/(?:\r\n?|\n)/g);

        if (pre_lines.length === 1) {
          pre = this.matched;
          pre_lines = pre.split(/(?:\r\n?|\n)/g);
        }

        this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
      } else {
        this.yylloc.last_column -= len;
      }

      this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
      this.done = false;
      return this;
    },

    /**
     * cache matched text and append it on next action
     * 
     * @public
     * @this {RegExpLexer}
     */
    more: function lexer_more() {
      this._more = true;
      return this;
    },

    /**
     * signal the lexer that this rule fails to match the input, so the
     * next matching rule (regex) should be tested instead.
     * 
     * @public
     * @this {RegExpLexer}
     */
    reject: function lexer_reject() {
      if (this.options.backtrack_lexer) {
        this._backtrack = true;
      } else {
        // when the `parseError()` call returns, we MUST ensure that the error is registered.
        // We accomplish this by signaling an 'error' token to be produced for the current
        // `.lex()` run.
        var lineno_msg = '';

        if (this.yylloc) {
          lineno_msg = ' on line ' + (this.yylineno + 1);
        }

        var p = this.constructLexErrorInfo(
          'Lexical error' + lineno_msg + ': You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).',
          false
        );

        this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
      }

      return this;
    },

    /**
     * retain first n characters of the match
     * 
     * @public
     * @this {RegExpLexer}
     */
    less: function lexer_less(n) {
      return this.unput(this.match.slice(n));
    },

    /**
     * return (part of the) already matched input, i.e. for error
     * messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of
     * input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     * 
     * @public
     * @this {RegExpLexer}
     */
    pastInput: function lexer_pastInput(maxSize, maxLines) {
      var past = this.matched.substring(0, this.matched.length - this.match.length);

      if (maxSize < 0)
        maxSize = past.length;
      else if (!maxSize)
        maxSize = 20;

      if (maxLines < 0)
        maxLines = past.length;          // can't ever have more input lines than this! 
      else if (!maxLines)
        maxLines = 1;

      // `substr` anticipation: treat \r\n as a single character and take a little
      // more than necessary so that we can still properly check against maxSize
      // after we've transformed and limited the newLines in here:
      past = past.substr(-maxSize * 2 - 2);

      // now that we have a significantly reduced string to process, transform the newlines
      // and chop them, then limit them:
      var a = past.replace(/\r\n|\r/g, '\n').split('\n');

      a = a.slice(-maxLines);
      past = a.join('\n');

      // When, after limiting to maxLines, we still have too much to return,
      // do add an ellipsis prefix...
      if (past.length > maxSize) {
        past = '...' + past.substr(-maxSize);
      }

      return past;
    },

    /**
     * return (part of the) upcoming input, i.e. for error messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     *
     * > ### NOTE ###
     * >
     * > *"upcoming input"* is defined as the whole of the both
     * > the *currently lexed* input, together with any remaining input
     * > following that. *"currently lexed"* input is the input 
     * > already recognized by the lexer but not yet returned with
     * > the lexer token. This happens when you are invoking this API
     * > from inside any lexer rule action code block. 
     * >
     * 
     * @public
     * @this {RegExpLexer}
     */
    upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
      var next = this.match;

      if (maxSize < 0)
        maxSize = next.length + this._input.length;
      else if (!maxSize)
        maxSize = 20;

      if (maxLines < 0)
        maxLines = maxSize;          // can't ever have more input lines than this! 
      else if (!maxLines)
        maxLines = 1;

      // `substring` anticipation: treat \r\n as a single character and take a little
      // more than necessary so that we can still properly check against maxSize
      // after we've transformed and limited the newLines in here:
      if (next.length < maxSize * 2 + 2) {
        next += this._input.substring(0, maxSize * 2 + 2);   // substring is faster on Chrome/V8 
      }

      // now that we have a significantly reduced string to process, transform the newlines
      // and chop them, then limit them:
      var a = next.replace(/\r\n|\r/g, '\n').split('\n');

      a = a.slice(0, maxLines);
      next = a.join('\n');

      // When, after limiting to maxLines, we still have too much to return,
      // do add an ellipsis postfix...
      if (next.length > maxSize) {
        next = next.substring(0, maxSize) + '...';
      }

      return next;
    },

    /**
     * return a string which displays the character position where the
     * lexing error occurred, i.e. for error messages
     * 
     * @public
     * @this {RegExpLexer}
     */
    showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
      var pre = this.pastInput(maxPrefix).replace(/\s/g, ' ');
      var c = new Array(pre.length + 1).join('-');
      return pre + this.upcomingInput(maxPostfix).replace(/\s/g, ' ') + '\n' + c + '^';
    },

    /**
     * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
     * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
     * it MAY be NULL) and you MUST have a valid location info object anyway:
     * then we take the given context of the `preceding` and `following` locations, IFF those are available,
     * and reconstruct the `actual` location info from those.
     * If this fails, the heuristic is to take the `current` location, IFF available.
     * If this fails as well, we assume the sought location is at/around the current lexer position
     * and then produce that one as a response. DO NOTE that these heuristic/derived location info
     * values MAY be inaccurate!
     *
     * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
     * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
     * 
     * @public
     * @this {RegExpLexer}
     */
    deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
      var loc = {
        first_line: 1,
        first_column: 0,
        last_line: 1,
        last_column: 0,
        range: [0, 0]
      };

      if (actual) {
        loc.first_line = actual.first_line | 0;
        loc.last_line = actual.last_line | 0;
        loc.first_column = actual.first_column | 0;
        loc.last_column = actual.last_column | 0;

        if (actual.range) {
          loc.range[0] = actual.range[0] | 0;
          loc.range[1] = actual.range[1] | 0;
        }
      }

      if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
        // plan B: heuristic using preceding and following:
        if (loc.first_line <= 0 && preceding) {
          loc.first_line = preceding.last_line | 0;
          loc.first_column = preceding.last_column | 0;

          if (preceding.range) {
            loc.range[0] = actual.range[1] | 0;
          }
        }

        if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
          loc.last_line = following.first_line | 0;
          loc.last_column = following.first_column | 0;

          if (following.range) {
            loc.range[1] = actual.range[0] | 0;
          }
        }

        // plan C?: see if the 'current' location is useful/sane too:
        if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
          loc.first_line = current.first_line | 0;
          loc.first_column = current.first_column | 0;

          if (current.range) {
            loc.range[0] = current.range[0] | 0;
          }
        }

        if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
          loc.last_line = current.last_line | 0;
          loc.last_column = current.last_column | 0;

          if (current.range) {
            loc.range[1] = current.range[1] | 0;
          }
        }
      }

      // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
      // or plan D heuristics to produce a 'sensible' last_line value:
      if (loc.last_line <= 0) {
        if (loc.first_line <= 0) {
          loc.first_line = this.yylloc.first_line;
          loc.last_line = this.yylloc.last_line;
          loc.first_column = this.yylloc.first_column;
          loc.last_column = this.yylloc.last_column;
          loc.range[0] = this.yylloc.range[0];
          loc.range[1] = this.yylloc.range[1];
        } else {
          loc.last_line = this.yylloc.last_line;
          loc.last_column = this.yylloc.last_column;
          loc.range[1] = this.yylloc.range[1];
        }
      }

      if (loc.first_line <= 0) {
        loc.first_line = loc.last_line;
        loc.first_column = 0;  // loc.last_column; 
        loc.range[1] = loc.range[0];
      }

      if (loc.first_column < 0) {
        loc.first_column = 0;
      }

      if (loc.last_column < 0) {
        loc.last_column = (loc.first_column > 0 ? loc.first_column : 80);
      }

      return loc;
    },

    /**
     * return a string which displays the lines & columns of input which are referenced 
     * by the given location info range, plus a few lines of context.
     * 
     * This function pretty-prints the indicated section of the input, with line numbers 
     * and everything!
     * 
     * This function is very useful to provide highly readable error reports, while
     * the location range may be specified in various flexible ways:
     * 
     * - `loc` is the location info object which references the area which should be
     *   displayed and 'marked up': these lines & columns of text are marked up by `^`
     *   characters below each character in the entire input range.
     * 
     * - `context_loc` is the *optional* location info object which instructs this
     *   pretty-printer how much *leading* context should be displayed alongside
     *   the area referenced by `loc`. This can help provide context for the displayed
     *   error, etc.
     * 
     *   When this location info is not provided, a default context of 3 lines is
     *   used.
     * 
     * - `context_loc2` is another *optional* location info object, which serves
     *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
     *   context lines to display in the pretty-print output.
     * 
     *   When this location info is not provided, a default context of 1 line only is
     *   used.
     * 
     * Special Notes:
     * 
     * - when the `loc`-indicated range is very large (about 5 lines or more), then
     *   only the first and last few lines of this block are printed while a
     *   `...continued...` message will be printed between them.
     * 
     *   This serves the purpose of not printing a huge amount of text when the `loc`
     *   range happens to be huge: this way a manageable & readable output results
     *   for arbitrary large ranges.
     * 
     * - this function can display lines of input which whave not yet been lexed.
     *   `prettyPrintRange()` can access the entire input!
     * 
     * @public
     * @this {RegExpLexer}
     */
    prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
      loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
      const CONTEXT = 3;
      const CONTEXT_TAIL = 1;
      const MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
      var input = this.matched + this._input;
      var lines = input.split('\n');
      var l0 = Math.max(1, (context_loc ? context_loc.first_line : loc.first_line - CONTEXT));
      var l1 = Math.max(1, (context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL));
      var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
      var ws_prefix = new Array(lineno_display_width).join(' ');
      var nonempty_line_indexes = [];

      var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
        var lno = index + l0;
        var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
        var rv = lno_pfx + ': ' + line;
        var errpfx = new Array(lineno_display_width + 1).join('^');
        var offset = 2 + 1;
        var len = 0;

        if (lno === loc.first_line) {
          offset += loc.first_column;

          len = Math.max(
            2,
            ((lno === loc.last_line ? loc.last_column : line.length)) - loc.first_column + 1
          );
        } else if (lno === loc.last_line) {
          len = Math.max(2, loc.last_column + 1);
        } else if (lno > loc.first_line && lno < loc.last_line) {
          len = Math.max(2, line.length + 1);
        }

        if (len) {
          var lead = new Array(offset).join('.');
          var mark = new Array(len).join('^');
          rv += '\n' + errpfx + lead + mark;

          if (line.trim().length > 0) {
            nonempty_line_indexes.push(index);
          }
        }

        rv = rv.replace(/\t/g, ' ');
        return rv;
      });

      // now make sure we don't print an overly large amount of error area: limit it 
      // to the top and bottom line count:
      if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
        var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
        var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
        var intermediate_line = new Array(lineno_display_width + 1).join(' ') + '  (...continued...)';
        intermediate_line += '\n' + new Array(lineno_display_width + 1).join('-') + '  (---------------)';
        rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
      }

      return rv.join('\n');
    },

    /**
     * helper function, used to produce a human readable description as a string, given
     * the input `yylloc` location object.
     * 
     * Set `display_range_too` to TRUE to include the string character index position(s)
     * in the description if the `yylloc.range` is available.
     * 
     * @public
     * @this {RegExpLexer}
     */
    describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
      var l1 = yylloc.first_line;
      var l2 = yylloc.last_line;
      var c1 = yylloc.first_column;
      var c2 = yylloc.last_column;
      var dl = l2 - l1;
      var dc = c2 - c1;
      var rv;

      if (dl === 0) {
        rv = 'line ' + l1 + ', ';

        if (dc <= 1) {
          rv += 'column ' + c1;
        } else {
          rv += 'columns ' + c1 + ' .. ' + c2;
        }
      } else {
        rv = 'lines ' + l1 + '(column ' + c1 + ') .. ' + l2 + '(column ' + c2 + ')';
      }

      if (yylloc.range && display_range_too) {
        var r1 = yylloc.range[0];
        var r2 = yylloc.range[1] - 1;

        if (r2 <= r1) {
          rv += ' {String Offset: ' + r1 + '}';
        } else {
          rv += ' {String Offset range: ' + r1 + ' .. ' + r2 + '}';
        }
      }

      return rv;
    },

    /**
     * test the lexed token: return FALSE when not a match, otherwise return token.
     * 
     * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
     * contains the actually matched text string.
     * 
     * Also move the input cursor forward and update the match collectors:
     * 
     * - `yytext`
     * - `yyleng`
     * - `match`
     * - `matches`
     * - `yylloc`
     * - `offset`
     * 
     * @public
     * @this {RegExpLexer}
     */
    test_match: function lexer_test_match(match, indexed_rule) {
      var token, lines, backup, match_str, match_str_len;

      if (this.options.backtrack_lexer) {
        // save context
        backup = {
          yylineno: this.yylineno,

          yylloc: {
            first_line: this.yylloc.first_line,
            last_line: this.yylloc.last_line,
            first_column: this.yylloc.first_column,
            last_column: this.yylloc.last_column,
            range: this.yylloc.range.slice(0)
          },

          yytext: this.yytext,
          match: this.match,
          matches: this.matches,
          matched: this.matched,
          yyleng: this.yyleng,
          offset: this.offset,
          _more: this._more,
          _input: this._input,

          //_signaled_error_token: this._signaled_error_token,
          yy: this.yy,

          conditionStack: this.conditionStack.slice(0),
          done: this.done
        };
      }

      match_str = match[0];
      match_str_len = match_str.length;

      // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {
      lines = match_str.split(/(?:\r\n?|\n)/g);

      if (lines.length > 1) {
        this.yylineno += lines.length - 1;
        this.yylloc.last_line = this.yylineno + 1;
        this.yylloc.last_column = lines[lines.length - 1].length;
      } else {
        this.yylloc.last_column += match_str_len;
      }

      // }
      this.yytext += match_str;

      this.match += match_str;
      this.matched += match_str;
      this.matches = match;
      this.yyleng = this.yytext.length;
      this.yylloc.range[1] += match_str_len;

      // previous lex rules MAY have invoked the `more()` API rather than producing a token:
      // those rules will already have moved this `offset` forward matching their match lengths,
      // hence we must only add our own match length now:
      this.offset += match_str_len;

      this._more = false;
      this._backtrack = false;
      this._input = this._input.slice(match_str_len);

      // calling this method:
      //
      //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}
      token = this.performAction.call(
        this,
        this.yy,
        indexed_rule,
        this.conditionStack[this.conditionStack.length - 1] /* = YY_START */
      );

      // otherwise, when the action codes are all simple return token statements:
      //token = this.simpleCaseActionClusters[indexed_rule];

      if (this.done && this._input) {
        this.done = false;
      }

      if (token) {
        return token;
      } else if (this._backtrack) {
        // recover context
        for (var k in backup) {
          this[k] = backup[k];
        }

        this.__currentRuleSet__ = null;
        return false;  // rule action called reject() implying the next rule should be tested instead. 
      } else if (this._signaled_error_token) {
        // produce one 'error' token as `.parseError()` in `reject()`
        // did not guarantee a failure signal by throwing an exception!
        token = this._signaled_error_token;

        this._signaled_error_token = false;
        return token;
      }

      return false;
    },

    /**
     * return next match in input
     * 
     * @public
     * @this {RegExpLexer}
     */
    next: function lexer_next() {
      if (this.done) {
        this.clear();
        return this.EOF;
      }

      if (!this._input) {
        this.done = true;
      }

      var token, match, tempMatch, index;

      if (!this._more) {
        this.clear();
      }

      var spec = this.__currentRuleSet__;

      if (!spec) {
        // Update the ruleset cache as we apparently encountered a state change or just started lexing.
        // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
        // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
        // speed up those activities a tiny bit.
        spec = this.__currentRuleSet__ = this._currentRules();

        // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
        // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19
        if (!spec || !spec.rules) {
          var lineno_msg = '';

          if (this.options.trackPosition) {
            lineno_msg = ' on line ' + (this.yylineno + 1);
          }

          var p = this.constructLexErrorInfo(
            'Internal lexer engine error' + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!',
            false
          );

          // produce one 'error' token until this situation has been resolved, most probably by parse termination!
          return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
        }
      }

      var rule_ids = spec.rules;
      var regexes = spec.__rule_regexes;
      var len = spec.__rule_count;

      // Note: the arrays are 1-based, while `len` itself is a valid index,
      // hence the non-standard less-or-equal check in the next loop condition!
      for (var i = 1; i <= len; i++) {
        tempMatch = this._input.match(regexes[i]);

        if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
          match = tempMatch;
          index = i;

          if (this.options.backtrack_lexer) {
            token = this.test_match(tempMatch, rule_ids[i]);

            if (token !== false) {
              return token;
            } else if (this._backtrack) {
              match = undefined;
              continue;  // rule action called reject() implying a rule MISmatch. 
            } else {
              // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
              return false;
            }
          } else if (!this.options.flex) {
            break;
          }
        }
      }

      if (match) {
        token = this.test_match(match, rule_ids[index]);

        if (token !== false) {
          return token;
        }

        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
        return false;
      }

      if (!this._input) {
        this.done = true;
        this.clear();
        return this.EOF;
      } else {
        var lineno_msg = '';

        if (this.options.trackPosition) {
          lineno_msg = ' on line ' + (this.yylineno + 1);
        }

        var p = this.constructLexErrorInfo(
          'Lexical error' + lineno_msg + ': Unrecognized text.',
          this.options.lexerErrorsAreRecoverable
        );

        var pendingInput = this._input;
        var activeCondition = this.topState();
        var conditionStackDepth = this.conditionStack.length;
        token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;

        if (token === this.ERROR) {
          // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
          // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
          // has not consumed/modified any pending input or changed state in the error handler:
          if (!this.matches && // and make sure the input has been modified/consumed ...
          pendingInput === this._input && // ...or the lexer state has been modified significantly enough
          // to merit a non-consuming error handling action right now.
          activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) {
            this.input();
          }
        }

        return token;
      }
    },

    /**
     * return next match that has a token
     * 
     * @public
     * @this {RegExpLexer}
     */
    lex: function lexer_lex() {
      var r;

      // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:
      if (typeof this.pre_lex === 'function') {
        r = this.pre_lex.call(this, 0);
      }

      if (typeof this.options.pre_lex === 'function') {
        // (also account for a userdef function which does not return any value: keep the token as is)
        r = this.options.pre_lex.call(this, r) || r;
      }

      if (this.yy && typeof this.yy.pre_lex === 'function') {
        // (also account for a userdef function which does not return any value: keep the token as is)
        r = this.yy.pre_lex.call(this, r) || r;
      }

      while (!r) {
        r = this.next();
      }

      if (this.yy && typeof this.yy.post_lex === 'function') {
        // (also account for a userdef function which does not return any value: keep the token as is)
        r = this.yy.post_lex.call(this, r) || r;
      }

      if (typeof this.options.post_lex === 'function') {
        // (also account for a userdef function which does not return any value: keep the token as is)
        r = this.options.post_lex.call(this, r) || r;
      }

      if (typeof this.post_lex === 'function') {
        // (also account for a userdef function which does not return any value: keep the token as is)
        r = this.post_lex.call(this, r) || r;
      }

      return r;
    },

    /**
     * return next match that has a token. Identical to the `lex()` API but does not invoke any of the 
     * `pre_lex()` nor any of the `post_lex()` callbacks.
     * 
     * @public
     * @this {RegExpLexer}
     */
    fastLex: function lexer_fastLex() {
      var r;

      while (!r) {
        r = this.next();
      }

      return r;
    },

    /**
     * return info about the lexer state that can help a parser or other lexer API user to use the
     * most efficient means available. This API is provided to aid run-time performance for larger
     * systems which employ this lexer.
     * 
     * @public
     * @this {RegExpLexer}
     */
    canIUse: function lexer_canIUse() {
      var rv = {
        fastLex: !(typeof this.pre_lex === 'function' || typeof this.options.pre_lex === 'function' || this.yy && typeof this.yy.pre_lex === 'function' || this.yy && typeof this.yy.post_lex === 'function' || typeof this.options.post_lex === 'function' || typeof this.post_lex === 'function') && typeof this.fastLex === 'function'
      };

      return rv;
    },

    /**
     * backwards compatible alias for `pushState()`;
     * the latter is symmetrical with `popState()` and we advise to use
     * those APIs in any modern lexer code, rather than `begin()`.
     * 
     * @public
     * @this {RegExpLexer}
     */
    begin: function lexer_begin(condition) {
      return this.pushState(condition);
    },

    /**
     * activates a new lexer condition state (pushes the new lexer
     * condition state onto the condition stack)
     * 
     * @public
     * @this {RegExpLexer}
     */
    pushState: function lexer_pushState(condition) {
      this.conditionStack.push(condition);
      this.__currentRuleSet__ = null;
      return this;
    },

    /**
     * pop the previously active lexer condition state off the condition
     * stack
     * 
     * @public
     * @this {RegExpLexer}
     */
    popState: function lexer_popState() {
      var n = this.conditionStack.length - 1;

      if (n > 0) {
        this.__currentRuleSet__ = null;
        return this.conditionStack.pop();
      } else {
        return this.conditionStack[0];
      }
    },

    /**
     * return the currently active lexer condition state; when an index
     * argument is provided it produces the N-th previous condition state,
     * if available
     * 
     * @public
     * @this {RegExpLexer}
     */
    topState: function lexer_topState(n) {
      n = this.conditionStack.length - 1 - Math.abs(n || 0);

      if (n >= 0) {
        return this.conditionStack[n];
      } else {
        return 'INITIAL';
      }
    },

    /**
     * (internal) determine the lexer rule set which is active for the
     * currently active lexer condition state
     * 
     * @public
     * @this {RegExpLexer}
     */
    _currentRules: function lexer__currentRules() {
      if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
        return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
      } else {
        return this.conditions['INITIAL'];
      }
    },

    /**
     * return the number of states currently on the stack
     * 
     * @public
     * @this {RegExpLexer}
     */
    stateStackSize: function lexer_stateStackSize() {
      return this.conditionStack.length;
    },

    options: {
      trackPosition: true
    },

    JisonLexerError: JisonLexerError,

    performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {

      switch (yyrulenumber) {
      case 1:
        /*! Conditions:: INITIAL */
        /*! Rule::       \s+ */
        /* skip whitespace */
        break;

      default:
        return this.simpleCaseActionClusters[yyrulenumber];
      }
    },

    simpleCaseActionClusters: {
      /*! Conditions:: INITIAL */
      /*! Rule::       (--[0-9a-z-A-Z-]*) */
      0: 13,

      /*! Conditions:: INITIAL */
      /*! Rule::       \* */
      2: 5,

      /*! Conditions:: INITIAL */
      /*! Rule::       \/ */
      3: 6,

      /*! Conditions:: INITIAL */
      /*! Rule::       \+ */
      4: 3,

      /*! Conditions:: INITIAL */
      /*! Rule::       - */
      5: 4,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */
      6: 15,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */
      7: 15,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */
      8: 15,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */
      9: 15,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */
      10: 15,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */
      11: 15,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */
      12: 16,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */
      13: 16,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */
      14: 16,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */
      15: 16,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */
      16: 17,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */
      17: 17,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */
      18: 18,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */
      19: 18,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */
      20: 19,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */
      21: 19,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */
      22: 19,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */
      23: 20,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */
      24: 21,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */
      25: 22,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */
      26: 23,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */
      27: 25,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */
      28: 24,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */
      29: 26,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */
      30: 27,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */
      31: 28,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */
      32: 11,

      /*! Conditions:: INITIAL */
      /*! Rule::       (calc) */
      33: 9,

      /*! Conditions:: INITIAL */
      /*! Rule::       (var) */
      34: 12,

      /*! Conditions:: INITIAL */
      /*! Rule::       ([a-z]+) */
      35: 10,

      /*! Conditions:: INITIAL */
      /*! Rule::       \( */
      36: 7,

      /*! Conditions:: INITIAL */
      /*! Rule::       \) */
      37: 8,

      /*! Conditions:: INITIAL */
      /*! Rule::       , */
      38: 14,

      /*! Conditions:: INITIAL */
      /*! Rule::       $ */
      39: 1
    },

    rules: [
      /*  0: */  /^(?:(--[\d\-A-Za-z]*))/,
      /*  1: */  /^(?:\s+)/,
      /*  2: */  /^(?:\*)/,
      /*  3: */  /^(?:\/)/,
      /*  4: */  /^(?:\+)/,
      /*  5: */  /^(?:-)/,
      /*  6: */  /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
      /*  7: */  /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
      /*  8: */  /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
      /*  9: */  /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
      /* 10: */  /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
      /* 11: */  /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
      /* 12: */  /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
      /* 13: */  /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
      /* 14: */  /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
      /* 15: */  /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
      /* 16: */  /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
      /* 17: */  /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
      /* 18: */  /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
      /* 19: */  /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
      /* 20: */  /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
      /* 21: */  /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
      /* 22: */  /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
      /* 23: */  /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
      /* 24: */  /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
      /* 25: */  /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
      /* 26: */  /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
      /* 27: */  /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
      /* 28: */  /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
      /* 29: */  /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
      /* 30: */  /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
      /* 31: */  /^(?:(\d+(\.\d*)?|\.\d+)%)/,
      /* 32: */  /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
      /* 33: */  /^(?:(calc))/,
      /* 34: */  /^(?:(var))/,
      /* 35: */  /^(?:([a-z]+))/,
      /* 36: */  /^(?:\()/,
      /* 37: */  /^(?:\))/,
      /* 38: */  /^(?:,)/,
      /* 39: */  /^(?:$)/
    ],

    conditions: {
      'INITIAL': {
        rules: [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
          32,
          33,
          34,
          35,
          36,
          37,
          38,
          39
        ],

        inclusive: true
      }
    }
  };

  return lexer;
}();
parser.lexer = lexer;



function Parser() {
  this.yy = {};
}
Parser.prototype = parser;
parser.Parser = Parser;

return new Parser();
})();

        


if (typeof commonjsRequire$1 !== 'undefined' && 'object' !== 'undefined') {
  exports.parser = parser;
  exports.Parser = parser.Parser;
  exports.parse = function () {
    return parser.parse.apply(parser, arguments);
  };
  
}
}(parser));

var reducer = {};

var convert$1 = {exports: {}};

var conversions = {
    // length
    'px': {
        'px': 1,
        'cm': 96.0/2.54,
        'mm': 96.0/25.4,
        'in': 96,
        'pt': 96.0/72.0,
        'pc': 16
    },
    'cm': {
        'px': 2.54/96.0,
        'cm': 1,
        'mm': 0.1,
        'in': 2.54,
        'pt': 2.54/72.0,
        'pc': 2.54/6.0
    },
    'mm': {
        'px': 25.4/96.0,
        'cm': 10,
        'mm': 1,
        'in': 25.4,
        'pt': 25.4/72.0,
        'pc': 25.4/6.0
    },
    'in': {
        'px': 1.0/96.0,
        'cm': 1.0/2.54,
        'mm': 1.0/25.4,
        'in': 1,
        'pt': 1.0/72.0,
        'pc': 1.0/6.0
    },
    'pt': {
        'px': 0.75,
        'cm': 72.0/2.54,
        'mm': 72.0/25.4,
        'in': 72,
        'pt': 1,
        'pc': 12
    },
    'pc': {
        'px': 6.0/96.0,
        'cm': 6.0/2.54,
        'mm': 6.0/25.4,
        'in': 6,
        'pt': 6.0/72.0,
        'pc': 1
    },
    // angle
    'deg': {
        'deg': 1,
        'grad': 0.9,
        'rad': 180/Math.PI,
        'turn': 360
    },
    'grad': {
        'deg': 400/360,
        'grad': 1,
        'rad': 200/Math.PI,
        'turn': 400
    },
    'rad': {
        'deg': Math.PI/180,
        'grad': Math.PI/200,
        'rad': 1,
        'turn': Math.PI*2
    },
    'turn': {
        'deg': 1/360,
        'grad': 1/400,
        'rad': 0.5/Math.PI,
        'turn': 1
    },
    // time
    's': {
        's': 1,
        'ms': 1/1000
    },
    'ms': {
        's': 1000,
        'ms': 1
    },
    // frequency
    'Hz': {
        'Hz': 1,
        'kHz': 1000
    },
    'kHz': {
        'Hz': 1/1000,
        'kHz': 1
    },
    // resolution
    'dpi': {
        'dpi': 1,
        'dpcm': 1.0/2.54,
        'dppx': 1/96
    },
    'dpcm': {
        'dpi': 2.54,
        'dpcm': 1,
        'dppx': 2.54/96.0
    },
    'dppx': {
        'dpi': 96,
        'dpcm': 96.0/2.54,
        'dppx': 1
    }
};

var cssUnitConverter = function (value, sourceUnit, targetUnit, precision) {
    if (!conversions.hasOwnProperty(targetUnit))
        throw new Error("Cannot convert to " + targetUnit);

    if (!conversions[targetUnit].hasOwnProperty(sourceUnit))
        throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
    
    var converted = conversions[targetUnit][sourceUnit] * value;
    
    if (precision !== false) {
        precision = Math.pow(10, parseInt(precision) || 5);
        return Math.round(converted * precision) / precision;
    }
    
    return converted;
};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cssUnitConverter = cssUnitConverter;

var _cssUnitConverter2 = _interopRequireDefault(_cssUnitConverter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function convertNodes(left, right, precision) {
  switch (left.type) {
    case 'LengthValue':
    case 'AngleValue':
    case 'TimeValue':
    case 'FrequencyValue':
    case 'ResolutionValue':
      return convertAbsoluteLength(left, right, precision);
    default:
      return { left: left, right: right };
  }
}

function convertAbsoluteLength(left, right, precision) {
  if (right.type === left.type) {
    right = {
      type: left.type,
      value: (0, _cssUnitConverter2.default)(right.value, right.unit, left.unit, precision),
      unit: left.unit
    };
  }
  return { left: left, right: right };
}

exports.default = convertNodes;
module.exports = exports['default'];
}(convert$1, convert$1.exports));

Object.defineProperty(reducer, "__esModule", {
  value: true
});
reducer.flip = flip;

var _convert = convert$1.exports;

var _convert2 = _interopRequireDefault$5(_convert);

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reduce(node, precision) {
  if (node.type === "MathExpression") return reduceMathExpression(node, precision);
  if (node.type === "Calc") return reduce(node.value, precision);

  return node;
}

function isEqual$1(left, right) {
  return left.type === right.type && left.value === right.value;
}

function isValueType(type) {
  switch (type) {
    case 'LengthValue':
    case 'AngleValue':
    case 'TimeValue':
    case 'FrequencyValue':
    case 'ResolutionValue':
    case 'EmValue':
    case 'ExValue':
    case 'ChValue':
    case 'RemValue':
    case 'VhValue':
    case 'VwValue':
    case 'VminValue':
    case 'VmaxValue':
    case 'PercentageValue':
    case 'Value':
      return true;
  }
  return false;
}

function convertMathExpression(node, precision) {
  var nodes = (0, _convert2.default)(node.left, node.right, precision);
  var left = reduce(nodes.left, precision);
  var right = reduce(nodes.right, precision);

  if (left.type === "MathExpression" && right.type === "MathExpression") {

    if (left.operator === '/' && right.operator === '*' || left.operator === '-' && right.operator === '+' || left.operator === '*' && right.operator === '/' || left.operator === '+' && right.operator === '-') {

      if (isEqual$1(left.right, right.right)) nodes = (0, _convert2.default)(left.left, right.left, precision);else if (isEqual$1(left.right, right.left)) nodes = (0, _convert2.default)(left.left, right.right, precision);

      left = reduce(nodes.left, precision);
      right = reduce(nodes.right, precision);
    }
  }

  node.left = left;
  node.right = right;
  return node;
}

function flip(operator) {
  return operator === '+' ? '-' : '+';
}

function flipValue(node) {
  if (isValueType(node.type)) node.value = -node.value;else if (node.type == 'MathExpression') {
    node.left = flipValue(node.left);
    node.right = flipValue(node.right);
  }
  return node;
}

function reduceAddSubExpression(node, precision) {
  var _node = node,
      left = _node.left,
      right = _node.right,
      op = _node.operator;


  if (left.type === 'CssVariable' || right.type === 'CssVariable') return node;

  // something + 0 => something
  // something - 0 => something
  if (right.value === 0) return left;

  // 0 + something => something
  if (left.value === 0 && op === "+") return right;

  // 0 - something => -something
  if (left.value === 0 && op === "-") return flipValue(right);

  // value + value
  // value - value
  if (left.type === right.type && isValueType(left.type)) {
    node = Object.assign({}, left);
    if (op === "+") node.value = left.value + right.value;else node.value = left.value - right.value;
  }

  // value <op> (expr)
  if (isValueType(left.type) && (right.operator === '+' || right.operator === '-') && right.type === 'MathExpression') {
    // value + (value + something) => (value + value) + something
    // value + (value - something) => (value + value) - something
    // value - (value + something) => (value - value) - something
    // value - (value - something) => (value - value) + something
    if (left.type === right.left.type) {
      node = Object.assign({}, node);
      node.left = reduce({
        type: 'MathExpression',
        operator: op,
        left: left,
        right: right.left
      }, precision);
      node.right = right.right;
      node.operator = op === '-' ? flip(right.operator) : right.operator;
      return reduce(node, precision);
    }
    // value + (something + value) => (value + value) + something
    // value + (something - value) => (value - value) + something
    // value - (something + value) => (value - value) - something
    // value - (something - value) => (value + value) - something
    else if (left.type === right.right.type) {
        node = Object.assign({}, node);
        node.left = reduce({
          type: 'MathExpression',
          operator: op === '-' ? flip(right.operator) : right.operator,
          left: left,
          right: right.right
        }, precision);
        node.right = right.left;
        return reduce(node, precision);
      }
  }

  // (expr) <op> value
  if (left.type === 'MathExpression' && (left.operator === '+' || left.operator === '-') && isValueType(right.type)) {
    // (value + something) + value => (value + value) + something
    // (value - something) + value => (value + value) - something
    // (value + something) - value => (value - value) + something
    // (value - something) - value => (value - value) - something
    if (right.type === left.left.type) {
      node = Object.assign({}, left);
      node.left = reduce({
        type: 'MathExpression',
        operator: op,
        left: left.left,
        right: right
      }, precision);
      return reduce(node, precision);
    }
    // (something + value) + value => something + (value + value)
    // (something - value1) + value2 => something - (value2 - value1)
    // (something + value) - value => something + (value - value)
    // (something - value) - value => something - (value + value)
    else if (right.type === left.right.type) {
        node = Object.assign({}, left);
        if (left.operator === '-') {
          node.right = reduce({
            type: 'MathExpression',
            operator: op === '-' ? '+' : '-',
            left: right,
            right: left.right
          }, precision);
          node.operator = op === '-' ? '-' : '+';
        } else {
          node.right = reduce({
            type: 'MathExpression',
            operator: op,
            left: left.right,
            right: right
          }, precision);
        }
        if (node.right.value < 0) {
          node.right.value *= -1;
          node.operator = node.operator === '-' ? '+' : '-';
        }
        return reduce(node, precision);
      }
  }
  return node;
}

function reduceDivisionExpression(node, precision) {
  if (!isValueType(node.right.type)) return node;

  if (node.right.type !== 'Value') throw new Error("Cannot divide by \"" + node.right.unit + "\", number expected");

  if (node.right.value === 0) throw new Error('Cannot divide by zero');

  // (expr) / value
  if (node.left.type === 'MathExpression') {
    if (isValueType(node.left.left.type) && isValueType(node.left.right.type)) {
      node.left.left.value /= node.right.value;
      node.left.right.value /= node.right.value;
      return reduce(node.left, precision);
    }
    return node;
  }
  // something / value
  else if (isValueType(node.left.type)) {
      node.left.value /= node.right.value;
      return node.left;
    }
  return node;
}

function reduceMultiplicationExpression(node) {
  // (expr) * value
  if (node.left.type === 'MathExpression' && node.right.type === 'Value') {
    if (isValueType(node.left.left.type) && isValueType(node.left.right.type)) {
      node.left.left.value *= node.right.value;
      node.left.right.value *= node.right.value;
      return node.left;
    }
  }
  // something * value
  else if (isValueType(node.left.type) && node.right.type === 'Value') {
      node.left.value *= node.right.value;
      return node.left;
    }
    // value * (expr)
    else if (node.left.type === 'Value' && node.right.type === 'MathExpression') {
        if (isValueType(node.right.left.type) && isValueType(node.right.right.type)) {
          node.right.left.value *= node.left.value;
          node.right.right.value *= node.left.value;
          return node.right;
        }
      }
      // value * something
      else if (node.left.type === 'Value' && isValueType(node.right.type)) {
          node.right.value *= node.left.value;
          return node.right;
        }
  return node;
}

function reduceMathExpression(node, precision) {
  node = convertMathExpression(node, precision);

  switch (node.operator) {
    case "+":
    case "-":
      return reduceAddSubExpression(node, precision);
    case "/":
      return reduceDivisionExpression(node, precision);
    case "*":
      return reduceMultiplicationExpression(node);
  }
  return node;
}

reducer.default = reduce;

var stringifier = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (calc, node, precision) {
  var str = stringify(node, precision);

  if (node.type === "MathExpression") {
    // if calc expression couldn't be resolved to a single value, re-wrap it as
    // a calc()
    str = calc + "(" + str + ")";
  }
  return str;
};

var _reducer = reducer;

var order = {
  "*": 0,
  "/": 0,
  "+": 1,
  "-": 1
};

function round(value, prec) {
  if (prec !== false) {
    var precision = Math.pow(10, prec);
    return Math.round(value * precision) / precision;
  }
  return value;
}

function stringify(node, prec) {
  switch (node.type) {
    case "MathExpression":
      {
        var left = node.left,
            right = node.right,
            op = node.operator;

        var str = "";

        if (left.type === 'MathExpression' && order[op] < order[left.operator]) str += "(" + stringify(left, prec) + ")";else str += stringify(left, prec);

        str += " " + node.operator + " ";

        if (right.type === 'MathExpression' && order[op] < order[right.operator]) {
          str += "(" + stringify(right, prec) + ")";
        } else if (right.type === 'MathExpression' && op === "-" && ["+", "-"].includes(right.operator)) {
          // fix #52 : a-(b+c) = a-b-c
          right.operator = (0, _reducer.flip)(right.operator);
          str += stringify(right, prec);
        } else {
          str += stringify(right, prec);
        }

        return str;
      }
    case "Value":
      return round(node.value, prec);
    case 'CssVariable':
      if (node.fallback) {
        return "var(" + node.value + ", " + stringify(node.fallback, prec) + ")";
      }
      return "var(" + node.value + ")";
    case 'Calc':
      if (node.prefix) {
        return "-" + node.prefix + "-calc(" + stringify(node.value, prec) + ")";
      }
      return "calc(" + stringify(node.value, prec) + ")";
    default:
      return round(node.value, prec) + node.unit;
  }
}

module.exports = exports["default"];
}(stringifier, stringifier.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _postcssValueParser = lib$1;

var _postcssValueParser2 = _interopRequireDefault(_postcssValueParser);

var _parser = parser;

var _reducer = reducer;

var _reducer2 = _interopRequireDefault(_reducer);

var _stringifier = stringifier.exports;

var _stringifier2 = _interopRequireDefault(_stringifier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line
var MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;

exports.default = function (value) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  return (0, _postcssValueParser2.default)(value).walk(function (node) {
    // skip anything which isn't a calc() function
    if (node.type !== 'function' || !MATCH_CALC.test(node.value)) return;

    // stringify calc expression and produce an AST
    var contents = _postcssValueParser2.default.stringify(node.nodes);

    // skip constant() and env()
    if (contents.indexOf('constant') >= 0 || contents.indexOf('env') >= 0) return;

    var ast = _parser.parser.parse(contents);

    // reduce AST to its simplest form, that is, either to a single value
    // or a simplified calc expression
    var reducedAst = (0, _reducer2.default)(ast, precision);

    // stringify AST and write it back
    node.type = 'word';
    node.value = (0, _stringifier2.default)(node.value, reducedAst, precision);
  }, true).toString();
};

module.exports = exports['default'];
}(dist, dist.exports));

var reduceCSSCalc = /*@__PURE__*/getDefaultExportFromCjs(dist.exports);

function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$m(Object(source), true).forEach(function (key) { _defineProperty$m(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$m(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray$7(arr) { return _arrayWithoutHoles$7(arr) || _iterableToArray$7(arr) || _unsupportedIterableToArray$a(arr) || _nonIterableSpread$7(); }

function _nonIterableSpread$7() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$a(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$a(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$a(o, minLen); }

function _iterableToArray$7(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$7(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$a(arr); }

function _arrayLikeToArray$a(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var stringCache = {
  widthCache: {},
  cacheCount: 0
};
var MAX_CACHE_NUM = 2000;
var SPAN_STYLE = {
  position: 'absolute',
  top: '-20000px',
  left: 0,
  padding: 0,
  margin: 0,
  border: 'none',
  whiteSpace: 'pre'
};
var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';

function autoCompleteStyle(name, value) {
  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
    return "".concat(value, "px");
  }

  return value;
}

function camelToMiddleLine(text) {
  var strs = text.split('');
  var formatStrs = strs.reduce(function (result, entry) {
    if (entry === entry.toUpperCase()) {
      return [].concat(_toConsumableArray$7(result), ['-', entry.toLowerCase()]);
    }

    return [].concat(_toConsumableArray$7(result), [entry]);
  }, []);
  return formatStrs.join('');
}

var getStyleString = function getStyleString(style) {
  return Object.keys(style).reduce(function (result, s) {
    return "".concat(result).concat(camelToMiddleLine(s), ":").concat(autoCompleteStyle(s, style[s]), ";");
  }, '');
};
var getStringSize = function getStringSize(text) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (text === undefined || text === null || Global.isSsr) {
    return {
      width: 0,
      height: 0
    };
  }

  var str = "".concat(text);
  var styleString = getStyleString(style);
  var cacheKey = "".concat(str, "-").concat(styleString);

  if (stringCache.widthCache[cacheKey]) {
    return stringCache.widthCache[cacheKey];
  }

  try {
    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);

    if (!measurementSpan) {
      measurementSpan = document.createElement('span');
      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
      measurementSpan.setAttribute('aria-hidden', 'true');
      document.body.appendChild(measurementSpan);
    } // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
    // https://en.wikipedia.org/wiki/Content_Security_Policy


    var measurementSpanStyle = _objectSpread$l(_objectSpread$l({}, SPAN_STYLE), style);

    Object.keys(measurementSpanStyle).map(function (styleKey) {
      measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
      return styleKey;
    });
    measurementSpan.textContent = str;
    var rect = measurementSpan.getBoundingClientRect();
    var result = {
      width: rect.width,
      height: rect.height
    };
    stringCache.widthCache[cacheKey] = result;

    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
      stringCache.cacheCount = 0;
      stringCache.widthCache = {};
    }

    return result;
  } catch (e) {
    return {
      width: 0,
      height: 0
    };
  }
};
var getOffset = function getOffset(el) {
  var html = el.ownerDocument.documentElement;
  var box = {
    top: 0,
    left: 0
  }; // If we don't have gBCR, just use 0,0 rather than error
  // BlackBerry 5, iOS 3 (original iPhone)

  if (typeof el.getBoundingClientRect !== 'undefined') {
    box = el.getBoundingClientRect();
  }

  return {
    top: box.top + window.pageYOffset - html.clientTop,
    left: box.left + window.pageXOffset - html.clientLeft
  };
};
/**
 * Calculate coordinate of cursor in chart
 * @param  {Object} event  Event object
 * @param  {Object} offset The offset of main part in the svg element
 * @return {Object}        {chartX, chartY}
 */

var calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
  return {
    chartX: Math.round(event.pageX - offset.left),
    chartY: Math.round(event.pageY - offset.top)
  };
};

function _typeof$i(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$i = function _typeof(obj) { return typeof obj; }; } else { _typeof$i = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$i(obj); }

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

function _objectWithoutProperties$8(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$8(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$8(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$h(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$i(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$i(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$i(Constructor.prototype, protoProps); if (staticProps) _defineProperties$i(Constructor, staticProps); return Constructor; }

function _inherits$f(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$f(subClass, superClass); }

function _setPrototypeOf$f(o, p) { _setPrototypeOf$f = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$f(o, p); }

function _createSuper$e(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$e(); return function _createSuperInternal() { var Super = _getPrototypeOf$f(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$f(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$f(this, result); }; }

function _possibleConstructorReturn$f(self, call) { if (call && (_typeof$i(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$f(self); }

function _assertThisInitialized$f(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$e() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$f(o) { _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$f(o); }

function _slicedToArray$4(arr, i) { return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$9(arr, i) || _nonIterableRest$4(); }

function _nonIterableRest$4() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$9(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$9(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen); }

function _arrayLikeToArray$9(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$4(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$4(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$l(Object(source), true).forEach(function (key) { _defineProperty$l(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$l(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;

var calculateWordWidths = function calculateWordWidths(props) {
  try {
    var words = [];

    if (!isNil_1(props.children)) {
      if (props.breakAll) {
        words = props.children.toString().split('');
      } else {
        words = props.children.toString().split(BREAKING_SPACES);
      }
    }

    var wordsWithComputedWidth = words.map(function (word) {
      return {
        word: word,
        width: getStringSize(word, props.style).width
      };
    });
    var spaceWidth = props.breakAll ? 0 : getStringSize("\xA0", props.style).width;
    return {
      wordsWithComputedWidth: wordsWithComputedWidth,
      spaceWidth: spaceWidth
    };
  } catch (e) {
    return null;
  }
};

var calculateWordsByLines = function calculateWordsByLines(props, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
  var shouldLimitLines = isNumber$1(props.maxLines);
  var text = props.children;

  var calculate = function calculate() {
    var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return words.reduce(function (result, _ref) {
      var word = _ref.word,
          width = _ref.width;
      var currentLine = result[result.length - 1];

      if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
        // Word can be added to an existing line
        currentLine.words.push(word);
        currentLine.width += width + spaceWidth;
      } else {
        // Add first word to line or word is too long to scaleToFit on existing line
        var newLine = {
          words: [word],
          width: width
        };
        result.push(newLine);
      }

      return result;
    }, []);
  };

  var originalResult = calculate(initialWordsWithComputedWith);

  var findLongestLine = function findLongestLine(words) {
    return words.reduce(function (a, b) {
      return a.width > b.width ? a : b;
    });
  };

  if (!shouldLimitLines) {
    return originalResult;
  }

  var suffix = '…';

  var checkOverflow = function checkOverflow(index) {
    var tempText = text.slice(0, index);
    var words = calculateWordWidths(_objectSpread$k(_objectSpread$k({}, props), {}, {
      children: tempText + suffix
    })).wordsWithComputedWidth;
    var result = calculate(words);
    var doesOverflow = result.length > props.maxLines || findLongestLine(result).width > lineWidth;
    return [doesOverflow, result];
  };

  var start = 0;
  var end = text.length - 1;
  var iterations = 0;
  var trimmedResult;

  while (start <= end && iterations <= text.length - 1) {
    var middle = Math.floor((start + end) / 2);
    var prev = middle - 1;

    var _checkOverflow = checkOverflow(prev),
        _checkOverflow2 = _slicedToArray$4(_checkOverflow, 2),
        doesPrevOverflow = _checkOverflow2[0],
        result = _checkOverflow2[1];

    var _checkOverflow3 = checkOverflow(middle),
        _checkOverflow4 = _slicedToArray$4(_checkOverflow3, 1),
        doesMiddleOverflow = _checkOverflow4[0];

    if (!doesPrevOverflow && !doesMiddleOverflow) {
      start = middle + 1;
    }

    if (doesPrevOverflow && doesMiddleOverflow) {
      end = middle - 1;
    }

    if (!doesPrevOverflow && doesMiddleOverflow) {
      trimmedResult = result;
      break;
    }

    iterations++;
  } // Fallback to originalResult (result without trimming) if we cannot find the
  // where to trim.  This should not happen :tm:


  return trimmedResult || originalResult;
};

var getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
  var words = !isNil_1(children) ? children.toString().split(BREAKING_SPACES) : [];
  return [{
    words: words
  }];
};

var getWordsByLines = function getWordsByLines(props, needCalculate) {
  // Only perform calculations if using features that require them (multiline, scaleToFit)
  if ((props.width || props.scaleToFit) && !Global.isSsr) {
    var wordsWithComputedWidth, spaceWidth;

    if (needCalculate) {
      var wordWidths = calculateWordWidths(props);

      if (wordWidths) {
        var wcw = wordWidths.wordsWithComputedWidth,
            sw = wordWidths.spaceWidth;
        wordsWithComputedWidth = wcw;
        spaceWidth = sw;
      } else {
        return getWordsWithoutCalculate(props.children);
      }

      return calculateWordsByLines(props, wordsWithComputedWidth, spaceWidth, props.width, props.scaleToFit);
    }
  }

  return getWordsWithoutCalculate(props.children);
};

var Text = /*#__PURE__*/function (_Component) {
  _inherits$f(Text, _Component);

  var _super = _createSuper$e(Text);

  function Text() {
    var _this;

    _classCallCheck$h(this, Text);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {};
    return _this;
  }

  _createClass$i(Text, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dx = _this$props.dx,
          dy = _this$props.dy,
          textAnchor = _this$props.textAnchor,
          verticalAnchor = _this$props.verticalAnchor,
          scaleToFit = _this$props.scaleToFit,
          angle = _this$props.angle,
          lineHeight = _this$props.lineHeight,
          capHeight = _this$props.capHeight,
          className = _this$props.className,
          breakAll = _this$props.breakAll,
          textProps = _objectWithoutProperties$8(_this$props, ["dx", "dy", "textAnchor", "verticalAnchor", "scaleToFit", "angle", "lineHeight", "capHeight", "className", "breakAll"]);

      var wordsByLines = this.state.wordsByLines;

      if (!isNumOrStr(textProps.x) || !isNumOrStr(textProps.y)) {
        return null;
      }

      var x = textProps.x + (isNumber$1(dx) ? dx : 0);
      var y = textProps.y + (isNumber$1(dy) ? dy : 0);
      var startDy;

      switch (verticalAnchor) {
        case 'start':
          startDy = reduceCSSCalc("calc(".concat(capHeight, ")"));
          break;

        case 'middle':
          startDy = reduceCSSCalc("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
          break;

        default:
          startDy = reduceCSSCalc("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
          break;
      }

      var transforms = [];

      if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = this.props.width;
        transforms.push("scale(".concat((isNumber$1(width) ? width / lineWidth : 1) / lineWidth, ")"));
      }

      if (angle) {
        transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
      }

      if (transforms.length) {
        textProps.transform = transforms.join(' ');
      }

      return /*#__PURE__*/React$2.createElement("text", _extends$j({}, filterProps(textProps, true), {
        x: x,
        y: y,
        className: classNames('recharts-text', className),
        textAnchor: textAnchor
      }), wordsByLines.map(function (line, index) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          React$2.createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: index
          }, line.words.join(breakAll ? '' : ' '))
        );
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.width !== prevState.prevWidth || nextProps.scaleToFit !== prevState.prevScaleToFit || nextProps.children !== prevState.prevChildren || nextProps.style !== prevState.prevStyle || nextProps.breakAll !== prevState.prevBreakAll) {
        var needCalculate = nextProps.children !== prevState.prevChildren || nextProps.style !== prevState.prevStyle || nextProps.breakAll !== prevState.prevBreakAll;
        return {
          prevWidth: nextProps.width,
          prevScaleToFit: nextProps.scaleToFit,
          prevChildren: nextProps.children,
          prevStyle: nextProps.style,
          wordsByLines: getWordsByLines(nextProps, needCalculate)
        };
      }

      return null;
    }
  }]);

  return Text;
}(Component);
Text.defaultProps = {
  x: 0,
  y: 0,
  lineHeight: '1em',
  capHeight: '0.71em',
  // Magic number from d3
  scaleToFit: false,
  textAnchor: 'start',
  verticalAnchor: 'end' // Maintain compat with existing charts / default SVG behavior

};

var reactIs$1 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1="function"===typeof Symbol&&Symbol.for,c$1=b$1?Symbol.for("react.element"):60103,d$1=b$1?Symbol.for("react.portal"):60106,e$1=b$1?Symbol.for("react.fragment"):60107,f$1=b$1?Symbol.for("react.strict_mode"):60108,g$1=b$1?Symbol.for("react.profiler"):60114,h$1=b$1?Symbol.for("react.provider"):60109,k$1=b$1?Symbol.for("react.context"):60110,l$1=b$1?Symbol.for("react.async_mode"):60111,m$1=b$1?Symbol.for("react.concurrent_mode"):60111,n$1=b$1?Symbol.for("react.forward_ref"):60112,p$1=b$1?Symbol.for("react.suspense"):60113,q$1=b$1?
Symbol.for("react.suspense_list"):60120,r=b$1?Symbol.for("react.memo"):60115,t$1=b$1?Symbol.for("react.lazy"):60116,v$1=b$1?Symbol.for("react.block"):60121,w=b$1?Symbol.for("react.fundamental"):60117,x=b$1?Symbol.for("react.responder"):60118,y=b$1?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$1:switch(a=a.type,a){case l$1:case m$1:case e$1:case g$1:case f$1:case p$1:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$1:case t$1:case r:case h$1:return a;default:return u}}case d$1:return u}}}function A(a){return z(a)===m$1}reactIs_production_min$1.AsyncMode=l$1;reactIs_production_min$1.ConcurrentMode=m$1;reactIs_production_min$1.ContextConsumer=k$1;reactIs_production_min$1.ContextProvider=h$1;reactIs_production_min$1.Element=c$1;reactIs_production_min$1.ForwardRef=n$1;reactIs_production_min$1.Fragment=e$1;reactIs_production_min$1.Lazy=t$1;reactIs_production_min$1.Memo=r;reactIs_production_min$1.Portal=d$1;
reactIs_production_min$1.Profiler=g$1;reactIs_production_min$1.StrictMode=f$1;reactIs_production_min$1.Suspense=p$1;reactIs_production_min$1.isAsyncMode=function(a){return A(a)||z(a)===l$1};reactIs_production_min$1.isConcurrentMode=A;reactIs_production_min$1.isContextConsumer=function(a){return z(a)===k$1};reactIs_production_min$1.isContextProvider=function(a){return z(a)===h$1};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$1};reactIs_production_min$1.isForwardRef=function(a){return z(a)===n$1};reactIs_production_min$1.isFragment=function(a){return z(a)===e$1};reactIs_production_min$1.isLazy=function(a){return z(a)===t$1};
reactIs_production_min$1.isMemo=function(a){return z(a)===r};reactIs_production_min$1.isPortal=function(a){return z(a)===d$1};reactIs_production_min$1.isProfiler=function(a){return z(a)===g$1};reactIs_production_min$1.isStrictMode=function(a){return z(a)===f$1};reactIs_production_min$1.isSuspense=function(a){return z(a)===p$1};
reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m$1||a===g$1||a===f$1||a===p$1||a===q$1||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===n$1||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v$1)};reactIs_production_min$1.typeOf=z;

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$1.AsyncMode = AsyncMode;
reactIs_development$1.ConcurrentMode = ConcurrentMode;
reactIs_development$1.ContextConsumer = ContextConsumer;
reactIs_development$1.ContextProvider = ContextProvider;
reactIs_development$1.Element = Element;
reactIs_development$1.ForwardRef = ForwardRef;
reactIs_development$1.Fragment = Fragment;
reactIs_development$1.Lazy = Lazy;
reactIs_development$1.Memo = Memo;
reactIs_development$1.Portal = Portal;
reactIs_development$1.Profiler = Profiler;
reactIs_development$1.StrictMode = StrictMode;
reactIs_development$1.Suspense = Suspense;
reactIs_development$1.isAsyncMode = isAsyncMode;
reactIs_development$1.isConcurrentMode = isConcurrentMode;
reactIs_development$1.isContextConsumer = isContextConsumer;
reactIs_development$1.isContextProvider = isContextProvider;
reactIs_development$1.isElement = isElement;
reactIs_development$1.isForwardRef = isForwardRef;
reactIs_development$1.isFragment = isFragment;
reactIs_development$1.isLazy = isLazy;
reactIs_development$1.isMemo = isMemo;
reactIs_development$1.isPortal = isPortal;
reactIs_development$1.isProfiler = isProfiler;
reactIs_development$1.isStrictMode = isStrictMode;
reactIs_development$1.isSuspense = isSuspense;
reactIs_development$1.isValidElementType = isValidElementType;
reactIs_development$1.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min$1;
} else {
  reactIs$1.exports = reactIs_development$1;
}

function shallowEqual(a, b) {
  /* eslint-disable no-restricted-syntax */
  for (var key in a) {
    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
      return false;
    }
  }

  for (var _key in b) {
    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
      return false;
    }
  }

  return true;
}

function _objectWithoutProperties$7(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$7(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$7(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var REACT_BROWSER_EVENT_MAP = {
  click: 'onClick',
  mousedown: 'onMouseDown',
  mouseup: 'onMouseUp',
  mouseover: 'onMouseOver',
  mousemove: 'onMouseMove',
  mouseout: 'onMouseOut',
  mouseenter: 'onMouseEnter',
  mouseleave: 'onMouseLeave',
  touchcancel: 'onTouchCancel',
  touchend: 'onTouchEnd',
  touchmove: 'onTouchMove',
  touchstart: 'onTouchStart'
};
/**
 * Get the display name of a component
 * @param  {Object} Comp Specified Component
 * @return {String}      Display name of Component
 */

var getDisplayName = function getDisplayName(Comp) {
  if (typeof Comp === 'string') {
    return Comp;
  }

  if (!Comp) {
    return '';
  }

  return Comp.displayName || Comp.name || 'Component';
}; // `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)

var lastChildren = null;
var lastResult = null;
var toArray = function toArray(children) {
  if (children === lastChildren && isArray_1(lastResult)) {
    return lastResult;
  }

  var result = [];
  Children.forEach(children, function (child) {
    if (isNil_1(child)) return;

    if (reactIs$1.exports.isFragment(child)) {
      result = result.concat(toArray(child.props.children));
    } else {
      result.push(child);
    }
  });
  lastResult = result;
  lastChildren = children;
  return result;
};
/*
 * Find and return all matched children by type. `type` can be a React element class or
 * string
 */

var findAllByType = function findAllByType(children, type) {
  var result = [];
  var types = [];

  if (isArray_1(type)) {
    types = type.map(function (t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }

  toArray(children).forEach(function (child) {
    var childType = get_1(child, 'type.displayName') || get_1(child, 'type.name');

    if (types.indexOf(childType) !== -1) {
      result.push(child);
    }
  });
  return result;
};
/*
 * Return the first matched child by type, return null otherwise.
 * `type` can be a React element class or string.
 */

var findChildByType = function findChildByType(children, type) {
  var result = findAllByType(children, type);
  return result && result[0];
};
/**
 * validate the width and height props of a chart element
 * @param  {Object} el A chart element
 * @return {Boolean}   true If the props width and height are number, and greater than 0
 */

var validateWidthHeight = function validateWidthHeight(el) {
  if (!el || !el.props) {
    return false;
  }

  var _el$props = el.props,
      width = _el$props.width,
      height = _el$props.height;

  if (!isNumber$1(width) || width <= 0 || !isNumber$1(height) || height <= 0) {
    return false;
  }

  return true;
};
var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];

var isSvgElement = function isSvgElement(child) {
  return child && child.type && isString_1(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
};
/**
 * Wether props of children changed
 * @param  {Object} nextChildren The latest children
 * @param  {Object} prevChildren The prev children
 * @return {Boolean}             equal or not
 */

var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
  if (nextChildren === prevChildren) {
    return true;
  }

  var count = Children.count(nextChildren);

  if (count !== Children.count(prevChildren)) {
    return false;
  }

  if (count === 0) {
    return true;
  }

  if (count === 1) {
    // eslint-disable-next-line no-use-before-define,@typescript-eslint/no-use-before-define
    return isSingleChildEqual(isArray_1(nextChildren) ? nextChildren[0] : nextChildren, isArray_1(prevChildren) ? prevChildren[0] : prevChildren);
  }

  for (var i = 0; i < count; i++) {
    var nextChild = nextChildren[i];
    var prevChild = prevChildren[i];

    if (isArray_1(nextChild) || isArray_1(prevChild)) {
      if (!isChildrenEqual(nextChild, prevChild)) {
        return false;
      } // eslint-disable-next-line no-use-before-define,@typescript-eslint/no-use-before-define

    } else if (!isSingleChildEqual(nextChild, prevChild)) {
      return false;
    }
  }

  return true;
};
var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
  if (isNil_1(nextChild) && isNil_1(prevChild)) {
    return true;
  }

  if (!isNil_1(nextChild) && !isNil_1(prevChild)) {
    var _ref = nextChild.props || {},
        nextChildren = _ref.children,
        nextProps = _objectWithoutProperties$7(_ref, ["children"]);

    var _ref2 = prevChild.props || {},
        prevChildren = _ref2.children,
        prevProps = _objectWithoutProperties$7(_ref2, ["children"]);

    if (nextChildren && prevChildren) {
      // eslint-disable-next-line no-use-before-define
      return shallowEqual(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
    }

    if (!nextChildren && !prevChildren) {
      return shallowEqual(nextProps, prevProps);
    }

    return false;
  }

  return false;
};
var renderByOrder = function renderByOrder(children, renderMap) {
  var elements = [];
  var record = {};
  toArray(children).forEach(function (child, index) {
    if (isSvgElement(child)) {
      elements.push(child);
    } else if (child) {
      var displayName = getDisplayName(child.type);

      var _ref3 = renderMap[displayName] || {},
          handler = _ref3.handler,
          once = _ref3.once;

      if (handler && (!once || !record[displayName])) {
        var results = handler(child, displayName, index);
        elements.push(results);
        record[displayName] = true;
      }
    }
  });
  return elements;
};
var getReactEventByType = function getReactEventByType(e) {
  var type = e && e.type;

  if (type && REACT_BROWSER_EVENT_MAP[type]) {
    return REACT_BROWSER_EVENT_MAP[type];
  }

  return null;
};
var parseChildIndex = function parseChildIndex(child, children) {
  return toArray(children).indexOf(child);
};

var baseIsEqual = _baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

var isEqual_1 = isEqual;

var isSymbol$1 = isSymbol_1;

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum$2(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol$1(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

var _baseExtremum = baseExtremum$2;

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */

function baseGt$1(value, other) {
  return value > other;
}

var _baseGt = baseGt$1;

var baseExtremum$1 = _baseExtremum,
    baseGt = _baseGt,
    identity$c = identity_1;

/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max$1(array) {
  return (array && array.length)
    ? baseExtremum$1(array, identity$c, baseGt)
    : undefined;
}

var max_1 = max$1;

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */

function baseLt$1(value, other) {
  return value < other;
}

var _baseLt = baseLt$1;

var baseExtremum = _baseExtremum,
    baseLt = _baseLt,
    identity$b = identity_1;

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min$1(array) {
  return (array && array.length)
    ? baseExtremum(array, identity$b, baseLt)
    : undefined;
}

var min_1 = min$1;

var arrayMap = _arrayMap,
    baseIteratee$5 = _baseIteratee,
    baseMap = _baseMap,
    isArray$6 = isArray_1;

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map$3(collection, iteratee) {
  var func = isArray$6(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee$5(iteratee));
}

var map_1 = map$3;

var baseFlatten = _baseFlatten,
    map$2 = map_1;

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map$2(collection, iteratee), 1);
}

var flatMap_1 = flatMap;

function _toConsumableArray$6(arr) { return _arrayWithoutHoles$6(arr) || _iterableToArray$6(arr) || _unsupportedIterableToArray$8(arr) || _nonIterableSpread$6(); }

function _nonIterableSpread$6() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$8(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$8(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen); }

function _iterableToArray$6(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$6(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$8(arr); }

function _arrayLikeToArray$8(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var identity$a = function identity(i) {
  return i;
};

var PLACE_HOLDER = {
  '@@functional/placeholder': true
};

var isPlaceHolder = function isPlaceHolder(val) {
  return val === PLACE_HOLDER;
};

var curry0 = function curry0(fn) {
  return function _curried() {
    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
      return _curried;
    }

    return fn.apply(void 0, arguments);
  };
};

var curryN = function curryN(n, fn) {
  if (n === 1) {
    return fn;
  }

  return curry0(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var argsLength = args.filter(function (arg) {
      return arg !== PLACE_HOLDER;
    }).length;

    if (argsLength >= n) {
      return fn.apply(void 0, args);
    }

    return curryN(n - argsLength, curry0(function () {
      for (var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        restArgs[_key2] = arguments[_key2];
      }

      var newArgs = args.map(function (arg) {
        return isPlaceHolder(arg) ? restArgs.shift() : arg;
      });
      return fn.apply(void 0, _toConsumableArray$6(newArgs).concat(restArgs));
    }));
  });
};

var curry = function curry(fn) {
  return curryN(fn.length, fn);
};
var range$1 = function range(begin, end) {
  var arr = [];

  for (var i = begin; i < end; ++i) {
    arr[i - begin] = i;
  }

  return arr;
};
var map$1 = curry(function (fn, arr) {
  if (Array.isArray(arr)) {
    return arr.map(fn);
  }

  return Object.keys(arr).map(function (key) {
    return arr[key];
  }).map(fn);
});
var compose = function compose() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  if (!args.length) {
    return identity$a;
  }

  var fns = args.reverse(); // first function can receive multiply arguments

  var firstFn = fns[0];
  var tailsFn = fns.slice(1);
  return function () {
    return tailsFn.reduce(function (res, fn) {
      return fn(res);
    }, firstFn.apply(void 0, arguments));
  };
};
var reverse = function reverse(arr) {
  if (Array.isArray(arr)) {
    return arr.reverse();
  } // can be string


  return arr.split('').reverse.join('');
};
var memoize = function memoize(fn) {
  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    if (lastArgs && args.every(function (val, i) {
      return val === lastArgs[i];
    })) {
      return lastResult;
    }

    lastArgs = args;
    lastResult = fn.apply(void 0, args);
    return lastResult;
  };
};

/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */
/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */

function getDigitCount(value) {
  var result;

  if (value === 0) {
    result = 1;
  } else {
    result = Math.floor(new Decimal$2(value).abs().log(10).toNumber()) + 1;
  }

  return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */


function rangeStep(start, end, step) {
  var num = new Decimal$2(start);
  var i = 0;
  var result = []; // magic number to prevent infinite loop

  while (num.lt(end) && i < 100000) {
    result.push(num.toNumber());
    num = num.add(step);
    i++;
  }

  return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */


var interpolateNumber$1 = curry(function (a, b, t) {
  var newA = +a;
  var newB = +b;
  return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */

var uninterpolateNumber = curry(function (a, b, x) {
  var diff = b - +a;
  diff = diff || Infinity;
  return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */

var uninterpolateTruncation = curry(function (a, b, x) {
  var diff = b - +a;
  diff = diff || Infinity;
  return Math.max(0, Math.min(1, (x - a) / diff));
});
var Arithmetic = {
  rangeStep: rangeStep,
  getDigitCount: getDigitCount,
  interpolateNumber: interpolateNumber$1,
  uninterpolateNumber: uninterpolateNumber,
  uninterpolateTruncation: uninterpolateTruncation
};

function _toConsumableArray$5(arr) { return _arrayWithoutHoles$5(arr) || _iterableToArray$5(arr) || _unsupportedIterableToArray$7(arr) || _nonIterableSpread$5(); }

function _nonIterableSpread$5() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$5(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$5(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$7(arr); }

function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$7(arr, i) || _nonIterableRest$3(); }

function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$7(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }

function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$3(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */

function getValidInterval(_ref) {
  var _ref2 = _slicedToArray$3(_ref, 2),
      min = _ref2[0],
      max = _ref2[1];

  var validMin = min,
      validMax = max; // exchange

  if (min > max) {
    validMin = max;
    validMax = min;
  }

  return [validMin, validMax];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */


function getFormatStep(roughStep, allowDecimals, correctionFactor) {
  if (roughStep.lte(0)) {
    return new Decimal$2(0);
  }

  var digitCount = Arithmetic.getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
  // order of magnitudes than the rough step

  var digitCountValue = new Decimal$2(10).pow(digitCount);
  var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong

  var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
  var amendStepRatio = new Decimal$2(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
  var formatStep = amendStepRatio.mul(digitCountValue);
  return allowDecimals ? formatStep : new Decimal$2(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */


function getTickOfSingleValue(value, tickCount, allowDecimals) {
  var step = 1; // calculate the middle value of ticks

  var middle = new Decimal$2(value);

  if (!middle.isint() && allowDecimals) {
    var absVal = Math.abs(value);

    if (absVal < 1) {
      // The step should be a float number when the difference is smaller than 1
      step = new Decimal$2(10).pow(Arithmetic.getDigitCount(value) - 1);
      middle = new Decimal$2(Math.floor(middle.div(step).toNumber())).mul(step);
    } else if (absVal > 1) {
      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
      middle = new Decimal$2(Math.floor(value));
    }
  } else if (value === 0) {
    middle = new Decimal$2(Math.floor((tickCount - 1) / 2));
  } else if (!allowDecimals) {
    middle = new Decimal$2(Math.floor(value));
  }

  var middleIndex = Math.floor((tickCount - 1) / 2);
  var fn = compose(map$1(function (n) {
    return middle.add(new Decimal$2(n - middleIndex).mul(step)).toNumber();
  }), range$1);
  return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */


function calculateStep(min, max, tickCount, allowDecimals) {
  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  // dirty hack (for recharts' test)
  if (!Number.isFinite((max - min) / (tickCount - 1))) {
    return {
      step: new Decimal$2(0),
      tickMin: new Decimal$2(0),
      tickMax: new Decimal$2(0)
    };
  } // The step which is easy to understand between two ticks


  var step = getFormatStep(new Decimal$2(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks

  var middle; // When 0 is inside the interval, 0 should be a tick

  if (min <= 0 && max >= 0) {
    middle = new Decimal$2(0);
  } else {
    // calculate the middle value
    middle = new Decimal$2(min).add(max).div(2); // minus modulo value

    middle = middle.sub(new Decimal$2(middle).mod(step));
  }

  var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
  var upCount = Math.ceil(new Decimal$2(max).sub(middle).div(step).toNumber());
  var scaleCount = belowCount + upCount + 1;

  if (scaleCount > tickCount) {
    // When more ticks need to cover the interval, step should be bigger.
    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
  }

  if (scaleCount < tickCount) {
    // When less ticks can cover the interval, we should add some additional ticks
    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
  }

  return {
    step: step,
    tickMin: middle.sub(new Decimal$2(belowCount).mul(step)),
    tickMax: middle.add(new Decimal$2(upCount).mul(step))
  };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */


function getNiceTickValuesFn(_ref3) {
  var _ref4 = _slicedToArray$3(_ref3, 2),
      min = _ref4[0],
      max = _ref4[1];

  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // More than two ticks should be return
  var count = Math.max(tickCount, 2);

  var _getValidInterval = getValidInterval([min, max]),
      _getValidInterval2 = _slicedToArray$3(_getValidInterval, 2),
      cormin = _getValidInterval2[0],
      cormax = _getValidInterval2[1];

  if (cormin === -Infinity || cormax === Infinity) {
    var _values = cormax === Infinity ? [cormin].concat(_toConsumableArray$5(range$1(0, tickCount - 1).map(function () {
      return Infinity;
    }))) : [].concat(_toConsumableArray$5(range$1(0, tickCount - 1).map(function () {
      return -Infinity;
    })), [cormax]);

    return min > max ? reverse(_values) : _values;
  }

  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  } // Get the step between two ticks


  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
      step = _calculateStep.step,
      tickMin = _calculateStep.tickMin,
      tickMax = _calculateStep.tickMax;

  var values = Arithmetic.rangeStep(tickMin, tickMax.add(new Decimal$2(0.1).mul(step)), step);
  return min > max ? reverse(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */


function getTickValuesFixedDomainFn(_ref7, tickCount) {
  var _ref8 = _slicedToArray$3(_ref7, 2),
      min = _ref8[0],
      max = _ref8[1];

  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // More than two ticks should be return
  var _getValidInterval5 = getValidInterval([min, max]),
      _getValidInterval6 = _slicedToArray$3(_getValidInterval5, 2),
      cormin = _getValidInterval6[0],
      cormax = _getValidInterval6[1];

  if (cormin === -Infinity || cormax === Infinity) {
    return [min, max];
  }

  if (cormin === cormax) {
    return [cormin];
  }

  var count = Math.max(tickCount, 2);
  var step = getFormatStep(new Decimal$2(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
  var values = [].concat(_toConsumableArray$5(Arithmetic.rangeStep(new Decimal$2(cormin), new Decimal$2(cormax).sub(new Decimal$2(0.99).mul(step)), step)), [cormax]);
  return min > max ? reverse(values) : values;
}

var getNiceTickValues = memoize(getNiceTickValuesFn);
var getTickValuesFixedDomain = memoize(getTickValuesFixedDomainFn);

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function bisector(f) {
  let delta = f;
  let compare = f;

  if (f.length === 1) {
    delta = (d, x) => f(d) - x;
    compare = ascendingComparator(f);
  }

  function left(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) < 0) lo = mid + 1;
      else hi = mid;
    }
    return lo;
  }

  function right(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) > 0) hi = mid;
      else lo = mid + 1;
    }
    return lo;
  }

  function center(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }

  return {left, center, right};
}

function ascendingComparator(f) {
  return (d, x) => ascending(f(d), x);
}

function number$3(x) {
  return x === null ? NaN : +x;
}

function* numbers(values, valueof) {
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}

const ascendingBisect = bisector(ascending);
const bisectRight = ascendingBisect.right;
bisector(number$3).center;
var bisect = bisectRight;

var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

function ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    let r0 = Math.round(start / step), r1 = Math.round(stop / step);
    if (r0 * step < start) ++r0;
    if (r1 * step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) * step;
  } else {
    step = -step;
    let r0 = Math.round(start * step), r1 = Math.round(stop * step);
    if (r0 / step < start) ++r0;
    if (r1 / step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
}

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

function max(values, valueof) {
  let max;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null
          && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  }
  return max;
}

function min(values, valueof) {
  let min;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null
          && (min > value || (min === undefined && value >= value))) {
        min = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (min > value || (min === undefined && value >= value))) {
        min = value;
      }
    }
  }
  return min;
}

// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function quickselect(array, k, left = 0, right = array.length - 1, compare = ascending) {
  while (right > left) {
    if (right - left > 600) {
      const n = right - left + 1;
      const m = k - left + 1;
      const z = Math.log(n);
      const s = 0.5 * Math.exp(2 * z / 3);
      const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
      const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
      quickselect(array, k, newLeft, newRight, compare);
    }

    const t = array[k];
    let i = left;
    let j = right;

    swap(array, left, k);
    if (compare(array[right], t) > 0) swap(array, left, right);

    while (i < j) {
      swap(array, i, j), ++i, --j;
      while (compare(array[i], t) < 0) ++i;
      while (compare(array[j], t) > 0) --j;
    }

    if (compare(array[left], t) === 0) swap(array, left, j);
    else ++j, swap(array, j, right);

    if (j <= k) left = j + 1;
    if (k <= j) right = j - 1;
  }
  return array;
}

function swap(array, i, j) {
  const t = array[i];
  array[i] = array[j];
  array[j] = t;
}

function quantile$1(values, p, valueof) {
  values = Float64Array.from(numbers(values, valueof));
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return min(values);
  if (p >= 1) return max(values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = max(quickselect(values, i0).subarray(0, i0 + 1)),
      value1 = min(values.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i - i0);
}

function quantileSorted(values, p, valueof = number$3) {
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
}

function sequence(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0: break;
    case 1: {
      if (typeof domain === "function") this.interpolator(domain);
      else this.range(domain);
      break;
    }
    default: {
      this.domain(domain);
      if (typeof interpolator === "function") this.interpolator(interpolator);
      else this.range(interpolator);
      break;
    }
  }
  return this;
}

const implicit = Symbol("implicit");

function ordinal() {
  var index = new Map(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = new Map();
    for (const value of _) {
      const key = value + "";
      if (index.has(key)) continue;
      index.set(key, domain.push(value));
    }
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return scale;
}

function band() {
  var scale = ordinal().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      r0 = 0,
      r1 = 1,
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = r1 < r0,
        start = reverse ? r1 : r0,
        stop = reverse ? r0 : r1;
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = sequence(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };

  scale.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band(domain(), [r0, r1])
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return initRange.apply(rescale(), arguments);
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point$2() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}

function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend$2(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color$4, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color$4(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color$4(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb$1(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb$1, extend$2(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color$4(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend$2(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var constant = x => () => x;

function linear$1(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant(isNaN(a) ? b : a);
}

var rgb = (function rgbGamma(y) {
  var color = gamma(y);

  function rgb(start, end) {
    var r = color((start = rgb$1(start)).r, (end = rgb$1(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1);

function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolate(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date$2(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function interpolateNumber(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

function object(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolate(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one$2(b) {
  return function(t) {
    return b(t) + "";
  };
}

function string$3(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: interpolateNumber(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one$2(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

function interpolate(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant(b)
      : (t === "number" ? interpolateNumber
      : t === "string" ? ((c = color$4(b)) ? (b = c, rgb) : string$3)
      : b instanceof color$4 ? rgb
      : b instanceof Date ? date$2
      : isNumberArray(b) ? numberArray
      : Array.isArray(b) ? genericArray
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : interpolateNumber)(a, b);
}

function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

function piecewise(interpolate$1, values) {
  if (values === undefined) values = interpolate$1, interpolate$1 = interpolate;
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate$1(v, v = values[++i]);
  return function(t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}

function constants$2(x) {
  return function() {
    return x;
  };
}

function number$2(x) {
  return +x;
}

var unit = [0, 1];

function identity$9(x) {
  return x;
}

function normalize$2(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constants$2(isNaN(b) ? NaN : 0.5);
}

function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize$2(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize$2(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize$2(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = bisect(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy$2(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function transformer$2() {
  var domain = unit,
      range = unit,
      interpolate$1 = interpolate,
      transform,
      untransform,
      unknown,
      clamp = identity$9,
      piecewise,
      output,
      input;

  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity$9) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate$1)))(transform(clamp(x)));
  }

  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number$2), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = Array.from(_), interpolate$1 = interpolateRound, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : identity$9, rescale()) : clamp !== identity$9;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate$1 = _, rescale()) : interpolate$1;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous() {
  return transformer$2()(identity$9, identity$9);
}

function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;

function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": (x, p) => (x * 100).toFixed(p),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p) => formatRounded(x * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
};

function identity$8(x) {
  return x;
}

var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

function formatLocale$1(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity$8 : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity$8 : formatNumerals(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "−" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale$1;
var format$1;
var formatPrefix;

defaultLocale$1({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale$1(definition) {
  locale$1 = formatLocale$1(definition);
  format$1 = locale$1.format;
  formatPrefix = locale$1.formatPrefix;
  return locale$1;
}

function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}

function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}

function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format$1(specifier);
}

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = continuous();

  scale.copy = function() {
    return copy$2(scale, linear());
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

function identity$7(domain) {
  var unknown;

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = Array.from(_, number$2), scale) : domain.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return identity$7(domain).unknown(unknown);
  };

  domain = arguments.length ? Array.from(domain, number$2) : [0, 1];

  return linearish(scale);
}

function nice(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

function transformLog(x) {
  return Math.log(x);
}

function transformExp(x) {
  return Math.exp(x);
}

function transformLogn(x) {
  return -Math.log(-x);
}

function transformExpn(x) {
  return -Math.exp(-x);
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function loggish(transform) {
  var scale = transform(transformLog, transformExp),
      domain = scale.domain,
      base = 10,
      logs,
      pows;

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.floor(i), j = Math.ceil(j);
      if (u > 0) for (; i <= j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i <= j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
      if (z.length * 2 < n) z = ticks(u, v, n);
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = format$1(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(nice(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  return scale;
}

function log() {
  var scale = loggish(transformer$2()).domain([1, 10]);

  scale.copy = function() {
    return copy$2(scale, log()).base(scale.base());
  };

  initRange.apply(scale, arguments);

  return scale;
}

function transformSymlog(c) {
  return function(x) {
    return Math.sign(x) * Math.log1p(Math.abs(x / c));
  };
}

function transformSymexp(c) {
  return function(x) {
    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
  };
}

function symlogish(transform) {
  var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));

  scale.constant = function(_) {
    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
  };

  return linearish(scale);
}

function symlog() {
  var scale = symlogish(transformer$2());

  scale.copy = function() {
    return copy$2(scale, symlog()).constant(scale.constant());
  };

  return initRange.apply(scale, arguments);
}

function transformPow(exponent) {
  return function(x) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
  };
}

function transformSqrt(x) {
  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}

function transformSquare(x) {
  return x < 0 ? -x * x : x * x;
}

function powish(transform) {
  var scale = transform(identity$9, identity$9),
      exponent = 1;

  function rescale() {
    return exponent === 1 ? transform(identity$9, identity$9)
        : exponent === 0.5 ? transform(transformSqrt, transformSquare)
        : transform(transformPow(exponent), transformPow(1 / exponent));
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, rescale()) : exponent;
  };

  return linearish(scale);
}

function pow() {
  var scale = powish(transformer$2());

  scale.copy = function() {
    return copy$2(scale, pow()).exponent(scale.exponent());
  };

  initRange.apply(scale, arguments);

  return scale;
}

function sqrt() {
  return pow.apply(null, arguments).exponent(0.5);
}

function square(x) {
  return Math.sign(x) * x * x;
}

function unsquare(x) {
  return Math.sign(x) * Math.sqrt(Math.abs(x));
}

function radial() {
  var squared = continuous(),
      range = [0, 1],
      round = false,
      unknown;

  function scale(x) {
    var y = unsquare(squared(x));
    return isNaN(y) ? unknown : round ? Math.round(y) : y;
  }

  scale.invert = function(y) {
    return squared.invert(square(y));
  };

  scale.domain = function(_) {
    return arguments.length ? (squared.domain(_), scale) : squared.domain();
  };

  scale.range = function(_) {
    return arguments.length ? (squared.range((range = Array.from(_, number$2)).map(square)), scale) : range.slice();
  };

  scale.rangeRound = function(_) {
    return scale.range(_).round(true);
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, scale) : round;
  };

  scale.clamp = function(_) {
    return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return radial(squared.domain(), range)
        .round(round)
        .clamp(squared.clamp())
        .unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

function quantile() {
  var domain = [],
      range = [],
      thresholds = [],
      unknown;

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = quantileSorted(domain, i / n);
    return scale;
  }

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : range[bisect(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (let d of _) if (d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return initRange.apply(scale, arguments);
}

function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1],
      unknown;

  function scale(x) {
    return x != null && x <= x ? range[bisect(domain, x, 0, n)] : unknown;
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : scale;
  };

  scale.thresholds = function() {
    return domain.slice();
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range)
        .unknown(unknown);
  };

  return initRange.apply(linearish(scale), arguments);
}

function threshold() {
  var domain = [0.5],
      range = [0, 1],
      unknown,
      n = 1;

  function scale(x) {
    return x != null && x <= x ? range[bisect(domain, x, 0, n)] : unknown;
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return initRange.apply(scale, arguments);
}

var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

var millisecond = newInterval(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return newInterval(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;

var second = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * durationSecond);
}, function(start, end) {
  return (end - start) / durationSecond;
}, function(date) {
  return date.getUTCSeconds();
});

var minute = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getMinutes();
});

var hour = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getHours();
});

var day = newInterval(
  date => date.setHours(0, 0, 0, 0),
  (date, step) => date.setDate(date.getDate() + step),
  (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay,
  date => date.getDate() - 1
);

function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}

var sunday = weekday(0);
var monday = weekday(1);
weekday(2);
weekday(3);
var thursday = weekday(4);
weekday(5);
weekday(6);

var month = newInterval(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

var year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

var utcMinute = newInterval(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getUTCMinutes();
});

var utcHour = newInterval(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getUTCHours();
});

var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay;
}, function(date) {
  return date.getUTCDate() - 1;
});

function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek;
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
utcWeekday(2);
utcWeekday(3);
var utcThursday = utcWeekday(4);
utcWeekday(5);
utcWeekday(6);

var utcMonth = newInterval(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

function ticker(year, month, week, day, hour, minute) {

  const tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function ticks(start, stop, count) {
    const reverse = stop < start;
    if (reverse) [start, stop] = [stop, start];
    const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
    const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
    return reverse ? ticks.reverse() : ticks;
  }

  function tickInterval(start, stop, count) {
    const target = Math.abs(stop - start) / count;
    const i = bisector(([,, step]) => step).right(tickIntervals, target);
    if (i === tickIntervals.length) return year.every(tickStep(start / durationYear, stop / durationYear, count));
    if (i === 0) return millisecond.every(Math.max(tickStep(start, stop, count), 1));
    const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
    return t.every(step);
  }

  return [ticks, tickInterval];
}

const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute);
const [timeTicks, timeTickInterval] = ticker(year, month, sunday, day, hour, minute);

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day$1;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day$1 = week.getUTCDay();
          week = day$1 > 4 || day$1 === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day$1 = week.getDay();
          week = day$1 > 4 || day$1 === 0 ? monday.ceil(week) : monday(week);
          week = day.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day$1 = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$1 + 5) % 7 : d.w + d.U * 7 - (day$1 + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + day.count(year(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(sunday.count(year(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(thursday.count(year(d), d) + (year(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(monday.count(year(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(utcYear(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(utcThursday.count(utcYear(d), d) + (utcYear(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(utcYear(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

var locale;
var timeFormat;
var utcFormat;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = formatLocale(definition);
  timeFormat = locale.format;
  utcFormat = locale.utcFormat;
  return locale;
}

function date$1(t) {
  return new Date(t);
}

function number$1(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
  var scale = continuous(),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(Array.from(_, number$1)) : domain().map(date$1);
  };

  scale.ticks = function(interval) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval) {
    var d = domain();
    if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
    return interval ? domain(nice(d, interval)) : scale;
  };

  scale.copy = function() {
    return copy$2(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
  };

  return scale;
}

function time$1() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, year, month, sunday, day, hour, minute, second, timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
}

function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
}

function transformer$1() {
  var x0 = 0,
      x1 = 1,
      t0,
      t1,
      k10,
      transform,
      interpolator = identity$9,
      clamp = false,
      unknown;

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function(_) {
    return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  function range(interpolate) {
    return function(_) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [interpolator(0), interpolator(1)];
    };
  }

  scale.range = range(interpolate);

  scale.rangeRound = range(interpolateRound);

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t) {
    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
    return scale;
  };
}

function copy$1(source, target) {
  return target
      .domain(source.domain())
      .interpolator(source.interpolator())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function sequential() {
  var scale = linearish(transformer$1()(identity$9));

  scale.copy = function() {
    return copy$1(scale, sequential());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialLog() {
  var scale = loggish(transformer$1()).domain([1, 10]);

  scale.copy = function() {
    return copy$1(scale, sequentialLog()).base(scale.base());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialSymlog() {
  var scale = symlogish(transformer$1());

  scale.copy = function() {
    return copy$1(scale, sequentialSymlog()).constant(scale.constant());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialPow() {
  var scale = powish(transformer$1());

  scale.copy = function() {
    return copy$1(scale, sequentialPow()).exponent(scale.exponent());
  };

  return initInterpolator.apply(scale, arguments);
}

function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}

function sequentialQuantile() {
  var domain = [],
      interpolator = identity$9;

  function scale(x) {
    if (x != null && !isNaN(x = +x)) return interpolator((bisect(domain, x, 1) - 1) / (domain.length - 1));
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (let d of _) if (d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(ascending);
    return scale;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.range = function() {
    return domain.map((d, i) => interpolator(i / (domain.length - 1)));
  };

  scale.quantiles = function(n) {
    return Array.from({length: n + 1}, (_, i) => quantile$1(domain, i / n));
  };

  scale.copy = function() {
    return sequentialQuantile(interpolator).domain(domain);
  };

  return initInterpolator.apply(scale, arguments);
}

function transformer() {
  var x0 = 0,
      x1 = 0.5,
      x2 = 1,
      s = 1,
      t0,
      t1,
      t2,
      k10,
      k21,
      interpolator = identity$9,
      transform,
      clamp = false,
      unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function(_) {
    return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [x0, x1, x2];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  function range(interpolate) {
    return function(_) {
      var r0, r1, r2;
      return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate, [r0, r1, r2]), scale) : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }

  scale.range = range(interpolate);

  scale.rangeRound = range(interpolateRound);

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t) {
    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
    return scale;
  };
}

function diverging() {
  var scale = linearish(transformer()(identity$9));

  scale.copy = function() {
    return copy$1(scale, diverging());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingLog() {
  var scale = loggish(transformer()).domain([0.1, 1, 10]);

  scale.copy = function() {
    return copy$1(scale, divergingLog()).base(scale.base());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingSymlog() {
  var scale = symlogish(transformer());

  scale.copy = function() {
    return copy$1(scale, divergingSymlog()).constant(scale.constant());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingPow() {
  var scale = powish(transformer());

  scale.copy = function() {
    return copy$1(scale, divergingPow()).exponent(scale.exponent());
  };

  return initInterpolator.apply(scale, arguments);
}

function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}

var d3Scales = /*#__PURE__*/Object.freeze({
  __proto__: null,
  scaleBand: band,
  scalePoint: point$2,
  scaleIdentity: identity$7,
  scaleLinear: linear,
  scaleLog: log,
  scaleSymlog: symlog,
  scaleOrdinal: ordinal,
  scaleImplicit: implicit,
  scalePow: pow,
  scaleSqrt: sqrt,
  scaleRadial: radial,
  scaleQuantile: quantile,
  scaleQuantize: quantize,
  scaleThreshold: threshold,
  scaleTime: time$1,
  scaleUtc: utcTime,
  scaleSequential: sequential,
  scaleSequentialLog: sequentialLog,
  scaleSequentialPow: sequentialPow,
  scaleSequentialSqrt: sequentialSqrt,
  scaleSequentialSymlog: sequentialSymlog,
  scaleSequentialQuantile: sequentialQuantile,
  scaleDiverging: diverging,
  scaleDivergingLog: divergingLog,
  scaleDivergingPow: divergingPow,
  scaleDivergingSqrt: divergingSqrt,
  scaleDivergingSymlog: divergingSymlog,
  tickFormat: tickFormat
});

function _toConsumableArray$4(arr) { return _arrayWithoutHoles$4(arr) || _iterableToArray$4(arr) || _unsupportedIterableToArray$6(arr) || _nonIterableSpread$4(); }

function _nonIterableSpread$4() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }

function _iterableToArray$4(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$4(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$6(arr); }

function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$k(Object(source), true).forEach(function (key) { _defineProperty$k(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$k(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function getValueByDataKey(obj, dataKey, defaultValue) {
  if (isNil_1(obj) || isNil_1(dataKey)) {
    return defaultValue;
  }

  if (isNumOrStr(dataKey)) {
    return get_1(obj, dataKey, defaultValue);
  }

  if (isFunction_1(dataKey)) {
    return dataKey(obj);
  }

  return defaultValue;
}
/**
 * Get domain of data by key
 * @param  {Array}   data      The data displayed in the chart
 * @param  {String}  key       The unique key of a group of data
 * @param  {String}  type      The type of axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array} Domain of data
 */

function getDomainOfDataByKey(data, key, type, filterNil) {
  var flattenData = flatMap_1(data, function (entry) {
    return getValueByDataKey(entry, key);
  });

  if (type === 'number') {
    var domain = flattenData.filter(function (entry) {
      return isNumber$1(entry) || parseFloat(entry);
    });
    return domain.length ? [min_1(domain), max_1(domain)] : [Infinity, -Infinity];
  }

  var validateData = filterNil ? flattenData.filter(function (entry) {
    return !isNil_1(entry);
  }) : flattenData; // 支持Date类型的x轴

  return validateData.map(function (entry) {
    return isNumOrStr(entry) || entry instanceof Date ? entry : '';
  });
}
var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate) {
  var _ticks$length;

  var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
  var axis = arguments.length > 3 ? arguments[3] : undefined;
  var index = -1;
  var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;

  if (len > 1) {
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
      var range = axis.range; // ticks are distributed in a circle

      for (var i = 0; i < len; i++) {
        var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
        var cur = unsortedTicks[i].coordinate;
        var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
        var sameDirectionCoord = void 0;

        if (mathSign(cur - before) !== mathSign(after - cur)) {
          var diffInterval = [];

          if (mathSign(after - cur) === mathSign(range[1] - range[0])) {
            sameDirectionCoord = after;
            var curInRange = cur + range[1] - range[0];
            diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
            diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
          } else {
            sameDirectionCoord = before;
            var afterInRange = after + range[1] - range[0];
            diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
            diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
          }

          var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];

          if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
            index = unsortedTicks[i].index;
            break;
          }
        } else {
          var min = Math.min(before, after);
          var max = Math.max(before, after);

          if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
            index = unsortedTicks[i].index;
            break;
          }
        }
      }
    } else {
      // ticks are distributed in a single direction
      for (var _i = 0; _i < len; _i++) {
        if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
          index = ticks[_i].index;
          break;
        }
      }
    }
  } else {
    index = 0;
  }

  return index;
};
/**
 * Get the main color of each graphic item
 * @param  {ReactElement} item A graphic item
 * @return {String}            Color
 */

var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
  var _ref = item,
      displayName = _ref.type.displayName; // TODO: check if displayName is valid.

  var _item$props = item.props,
      stroke = _item$props.stroke,
      fill = _item$props.fill;
  var result;

  switch (displayName) {
    case 'Line':
      result = stroke;
      break;

    case 'Area':
    case 'Radar':
      result = stroke && stroke !== 'none' ? stroke : fill;
      break;

    default:
      result = fill;
      break;
  }

  return result;
};
var getLegendProps = function getLegendProps(_ref2) {
  var children = _ref2.children,
      formattedGraphicalItems = _ref2.formattedGraphicalItems,
      legendWidth = _ref2.legendWidth,
      legendContent = _ref2.legendContent;
  var legendItem = findChildByType(children, Legend.displayName);

  if (!legendItem) {
    return null;
  }

  var legendData;

  if (legendItem.props && legendItem.props.payload) {
    legendData = legendItem.props && legendItem.props.payload;
  } else if (legendContent === 'children') {
    legendData = (formattedGraphicalItems || []).reduce(function (result, _ref3) {
      var item = _ref3.item,
          props = _ref3.props;
      var data = props.sectors || props.data || [];
      return result.concat(data.map(function (entry) {
        return {
          type: legendItem.props.iconType || item.props.legendType,
          value: entry.name,
          color: entry.fill,
          payload: entry
        };
      }));
    }, []);
  } else {
    legendData = (formattedGraphicalItems || []).map(function (_ref4) {
      var item = _ref4.item;
      var _item$props2 = item.props,
          dataKey = _item$props2.dataKey,
          name = _item$props2.name,
          legendType = _item$props2.legendType,
          hide = _item$props2.hide;
      return {
        inactive: hide,
        dataKey: dataKey,
        type: legendItem.props.iconType || legendType || 'square',
        color: getMainColorOfGraphicItem(item),
        value: name || dataKey,
        payload: item.props
      };
    });
  }

  return _objectSpread$j(_objectSpread$j(_objectSpread$j({}, legendItem.props), Legend.getWithHeight(legendItem, legendWidth)), {}, {
    payload: legendData,
    item: legendItem
  });
};
/**
 * Calculate the size of all groups for stacked bar graph
 * @param  {Object} stackGroups The items grouped by axisId and stackId
 * @return {Object} The size of all groups
 */

var getBarSizeList = function getBarSizeList(_ref5) {
  var globalSize = _ref5.barSize,
      _ref5$stackGroups = _ref5.stackGroups,
      stackGroups = _ref5$stackGroups === void 0 ? {} : _ref5$stackGroups;

  if (!stackGroups) {
    return {};
  }

  var result = {};
  var numericAxisIds = Object.keys(stackGroups);

  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
    var stackIds = Object.keys(sgs);

    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
      var _sgs$stackIds$j = sgs[stackIds[j]],
          items = _sgs$stackIds$j.items,
          cateAxisId = _sgs$stackIds$j.cateAxisId;
      var barItems = items.filter(function (item) {
        return getDisplayName(item.type).indexOf('Bar') >= 0;
      });

      if (barItems && barItems.length) {
        var selfSize = barItems[0].props.barSize;
        var cateId = barItems[0].props[cateAxisId];

        if (!result[cateId]) {
          result[cateId] = [];
        }

        result[cateId].push({
          item: barItems[0],
          stackList: barItems.slice(1),
          barSize: isNil_1(selfSize) ? globalSize : selfSize
        });
      }
    }
  }

  return result;
};
/**
 * Calculate the size of each bar and the gap between two bars
 * @param  {Number} bandSize  The size of each category
 * @param  {sizeList} sizeList  The size of all groups
 * @param  {maxBarSize} maxBarSize The maximum size of bar
 * @return {Number} The size of each bar and the gap between two bars
 */

var getBarPosition = function getBarPosition(_ref6) {
  var barGap = _ref6.barGap,
      barCategoryGap = _ref6.barCategoryGap,
      bandSize = _ref6.bandSize,
      _ref6$sizeList = _ref6.sizeList,
      sizeList = _ref6$sizeList === void 0 ? [] : _ref6$sizeList,
      maxBarSize = _ref6.maxBarSize;
  var len = sizeList.length;
  if (len < 1) return null;
  var realBarGap = getPercentValue(barGap, bandSize, 0, true);
  var result; // whether or not is barSize setted by user

  if (sizeList[0].barSize === +sizeList[0].barSize) {
    var useFull = false;
    var fullBarSize = bandSize / len;
    var sum = sizeList.reduce(function (res, entry) {
      return res + entry.barSize || 0;
    }, 0);
    sum += (len - 1) * realBarGap;

    if (sum >= bandSize) {
      sum -= (len - 1) * realBarGap;
      realBarGap = 0;
    }

    if (sum >= bandSize && fullBarSize > 0) {
      useFull = true;
      fullBarSize *= 0.9;
      sum = len * fullBarSize;
    }

    var offset = (bandSize - sum) / 2 >> 0;
    var prev = {
      offset: offset - realBarGap,
      size: 0
    };
    result = sizeList.reduce(function (res, entry) {
      var newRes = [].concat(_toConsumableArray$4(res), [{
        item: entry.item,
        position: {
          offset: prev.offset + prev.size + realBarGap,
          size: useFull ? fullBarSize : entry.barSize
        }
      }]);
      prev = newRes[newRes.length - 1].position;

      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function (item) {
          newRes.push({
            item: item,
            position: prev
          });
        });
      }

      return newRes;
    }, []);
  } else {
    var _offset = getPercentValue(barCategoryGap, bandSize, 0, true);

    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
      realBarGap = 0;
    }

    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;

    if (originalSize > 1) {
      originalSize >>= 0;
    }

    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
    result = sizeList.reduce(function (res, entry, i) {
      var newRes = [].concat(_toConsumableArray$4(res), [{
        item: entry.item,
        position: {
          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
          size: size
        }
      }]);

      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function (item) {
          newRes.push({
            item: item,
            position: newRes[newRes.length - 1].position
          });
        });
      }

      return newRes;
    }, []);
  }

  return result;
};
var appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
  var children = props.children,
      width = props.width,
      margin = props.margin;
  var legendWidth = width - (margin.left || 0) - (margin.right || 0); // const legendHeight = height - (margin.top || 0) - (margin.bottom || 0);

  var legendProps = getLegendProps({
    children: children,
    legendWidth: legendWidth
  });
  var newOffset = offset;

  if (legendProps) {
    var box = legendBox || {};
    var align = legendProps.align,
        verticalAlign = legendProps.verticalAlign,
        layout = legendProps.layout;

    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && isNumber$1(offset[align])) {
      newOffset = _objectSpread$j(_objectSpread$j({}, offset), {}, _defineProperty$k({}, align, newOffset[align] + (box.width || 0)));
    }

    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && isNumber$1(offset[verticalAlign])) {
      newOffset = _objectSpread$j(_objectSpread$j({}, offset), {}, _defineProperty$k({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
    }
  }

  return newOffset;
};
var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, axisType) {
  var children = item.props.children;
  var errorBars = findAllByType(children, 'ErrorBar').filter(function (errorBarChild) {
    var direction = errorBarChild.props.direction;
    return isNil_1(direction) || isNil_1(axisType) ? true : axisType.indexOf(direction) >= 0;
  });

  if (errorBars && errorBars.length) {
    var keys = errorBars.map(function (errorBarChild) {
      return errorBarChild.props.dataKey;
    });
    return data.reduce(function (result, entry) {
      var entryValue = getValueByDataKey(entry, dataKey, 0);
      var mainValue = isArray_1(entryValue) ? [min_1(entryValue), max_1(entryValue)] : [entryValue, entryValue];
      var errorDomain = keys.reduce(function (prevErrorArr, k) {
        var errorValue = getValueByDataKey(entry, k, 0);
        var lowerValue = mainValue[0] - Math.abs(isArray_1(errorValue) ? errorValue[0] : errorValue);
        var upperValue = mainValue[1] + Math.abs(isArray_1(errorValue) ? errorValue[1] : errorValue);
        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
      }, [Infinity, -Infinity]);
      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
    }, [Infinity, -Infinity]);
  }

  return null;
};
var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType) {
  var domains = items.map(function (item) {
    return getDomainOfErrorBars(data, item, dataKey, axisType);
  }).filter(function (entry) {
    return !isNil_1(entry);
  });

  if (domains && domains.length) {
    return domains.reduce(function (result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }

  return null;
};
/**
 * Get domain of data by the configuration of item element
 * @param  {Array}   data      The data displayed in the chart
 * @param  {Array}   items     The instances of item
 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array}        Domain
 */

var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
  var domains = items.map(function (item) {
    var dataKey = item.props.dataKey;

    if (type === 'number' && dataKey) {
      return getDomainOfErrorBars(data, item, dataKey) || getDomainOfDataByKey(data, dataKey, type, filterNil);
    }

    return getDomainOfDataByKey(data, dataKey, type, filterNil);
  });

  if (type === 'number') {
    // Calculate the domain of number axis
    return domains.reduce(function (result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }

  var tag = {}; // Get the union set of category axis

  return domains.reduce(function (result, entry) {
    for (var i = 0, len = entry.length; i < len; i++) {
      if (!tag[entry[i]]) {
        tag[entry[i]] = true;
        result.push(entry[i]);
      }
    }

    return result;
  }, []);
};
var isCategoricalAxis = function isCategoricalAxis(layout, axisType) {
  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
/**
 * Calculate the Coordinates of grid
 * @param  {Array} ticks The ticks in axis
 * @param {Number} min   The minimun value of axis
 * @param {Number} max   The maximun value of axis
 * @return {Array}       Coordinates
 */

var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
  var hasMin, hasMax;
  var values = ticks.map(function (entry) {
    if (entry.coordinate === min) {
      hasMin = true;
    }

    if (entry.coordinate === max) {
      hasMax = true;
    }

    return entry.coordinate;
  });

  if (!hasMin) {
    values.push(min);
  }

  if (!hasMax) {
    values.push(max);
  }

  return values;
};
/**
 * Get the ticks of an axis
 * @param  {Object}  axis The configuration of an axis
 * @param {Boolean} isGrid Whether or not are the ticks in grid
 * @param {Boolean} isAll Return the ticks of all the points or not
 * @return {Array}  Ticks
 */

var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
  if (!axis) return null;
  var scale = axis.scale;
  var duplicateDomain = axis.duplicateDomain,
      type = axis.type,
      range = axis.range;
  var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
  offset = axis.axisType === 'angleAxis' ? mathSign(range[0] - range[1]) * 2 * offset : offset; // The ticks setted by user should only affect the ticks adjacent to axis line

  if (isGrid && (axis.ticks || axis.niceTicks)) {
    return (axis.ticks || axis.niceTicks).map(function (entry) {
      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
      return {
        coordinate: scale(scaleContent) + offset,
        value: entry,
        offset: offset
      };
    });
  } // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"


  if (axis.isCategorical && axis.categoricalDomain) {
    return axis.categoricalDomain.map(function (entry, index) {
      return {
        coordinate: scale(entry) + offset,
        value: entry,
        index: index,
        offset: offset
      };
    });
  }

  if (scale.ticks && !isAll) {
    return scale.ticks(axis.tickCount).map(function (entry) {
      return {
        coordinate: scale(entry) + offset,
        value: entry,
        offset: offset
      };
    });
  } // When axis has duplicated text, serial numbers are used to generate scale


  return scale.domain().map(function (entry, index) {
    return {
      coordinate: scale(entry) + offset,
      value: duplicateDomain ? duplicateDomain[entry] : entry,
      index: index,
      offset: offset
    };
  });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} parentHandler  Handler function specified in parent component
 * @param  {Function} childHandler   Handler function specified in child component
 * @return {Function}                The combined handler
 */

var combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
  var customizedHandler;

  if (isFunction_1(childHandler)) {
    customizedHandler = childHandler;
  } else if (isFunction_1(parentHandler)) {
    customizedHandler = parentHandler;
  }

  if (isFunction_1(defaultHandler) || customizedHandler) {
    return function (arg1, arg2, arg3, arg4) {
      if (isFunction_1(defaultHandler)) {
        defaultHandler(arg1, arg2, arg3, arg4);
      }

      if (isFunction_1(customizedHandler)) {
        customizedHandler(arg1, arg2, arg3, arg4);
      }
    };
  }

  return null;
};
/**
 * Parse the scale function of axis
 * @param  {Object}   axis          The option of axis
 * @param  {String}   chartType     The displayName of chart
 * @param  {Boolean}  hasBar        if it has a bar
 * @return {Function}               The scale function
 */

var parseScale = function parseScale(axis, chartType, hasBar) {
  var scale = axis.scale,
      type = axis.type,
      layout = axis.layout,
      axisType = axis.axisType;

  if (scale === 'auto') {
    if (layout === 'radial' && axisType === 'radiusAxis') {
      return {
        scale: band(),
        realScaleType: 'band'
      };
    }

    if (layout === 'radial' && axisType === 'angleAxis') {
      return {
        scale: linear(),
        realScaleType: 'linear'
      };
    }

    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) {
      return {
        scale: point$2(),
        realScaleType: 'point'
      };
    }

    if (type === 'category') {
      return {
        scale: band(),
        realScaleType: 'band'
      };
    }

    return {
      scale: linear(),
      realScaleType: 'linear'
    };
  }

  if (isString_1(scale)) {
    var name = "scale".concat(upperFirst_1(scale));
    return {
      scale: (d3Scales[name] || point$2)(),
      realScaleType: d3Scales[name] ? name : 'point'
    };
  }

  return isFunction_1(scale) ? {
    scale: scale
  } : {
    scale: point$2(),
    realScaleType: 'point'
  };
};
var EPS = 1e-4;
var checkDomainOfScale = function checkDomainOfScale(scale) {
  var domain = scale.domain();

  if (!domain || domain.length <= 2) {
    return;
  }

  var len = domain.length;
  var range = scale.range();
  var min = Math.min(range[0], range[1]) - EPS;
  var max = Math.max(range[0], range[1]) + EPS;
  var first = scale(domain[0]);
  var last = scale(domain[len - 1]);

  if (first < min || first > max || last < min || last > max) {
    scale.domain([domain[0], domain[len - 1]]);
  }
};
/* eslint no-param-reassign: 0 */

var offsetSign = function offsetSign(series) {
  var n = series.length;

  if (n <= 0) {
    return;
  }

  for (var j = 0, m = series[0].length; j < m; ++j) {
    var positive = 0;
    var negative = 0;

    for (var i = 0; i < n; ++i) {
      var value = _isNaN(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
      /* eslint-disable prefer-destructuring */

      if (value >= 0) {
        series[i][j][0] = positive;
        series[i][j][1] = positive + value;
        positive = series[i][j][1];
      } else {
        series[i][j][0] = negative;
        series[i][j][1] = negative + value;
        negative = series[i][j][1];
      }
      /* eslint-enable prefer-destructuring */

    }
  }
};
/* eslint no-param-reassign: 0 */

var offsetPositive = function offsetPositive(series) {
  var n = series.length;

  if (n <= 0) {
    return;
  }

  for (var j = 0, m = series[0].length; j < m; ++j) {
    var positive = 0;

    for (var i = 0; i < n; ++i) {
      var value = _isNaN(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
      /* eslint-disable prefer-destructuring */

      if (value >= 0) {
        series[i][j][0] = positive;
        series[i][j][1] = positive + value;
        positive = series[i][j][1];
      } else {
        series[i][j][0] = 0;
        series[i][j][1] = 0;
      }
      /* eslint-enable prefer-destructuring */

    }
  }
};
var STACK_OFFSET_MAP = {
  sign: offsetSign,
  expand: stackOffsetExpand,
  none: stackOffsetNone,
  silhouette: stackOffsetSilhouette,
  wiggle: stackOffsetWiggle,
  positive: offsetPositive
};
var getStackedData = function getStackedData(data, stackItems, offsetType) {
  var dataKeys = stackItems.map(function (item) {
    return item.props.dataKey;
  });
  var stack = shapeStack().keys(dataKeys).value(function (d, key) {
    return +getValueByDataKey(d, key, 0);
  }).order(stackOrderNone).offset(STACK_OFFSET_MAP[offsetType]);
  return stack(data);
};
var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
  if (!data) {
    return null;
  } // reversing items to affect render order (for layering)


  var items = reverseStackOrder ? _items.reverse() : _items;
  var stackGroups = items.reduce(function (result, item) {
    var _item$props3 = item.props,
        stackId = _item$props3.stackId,
        hide = _item$props3.hide;

    if (hide) {
      return result;
    }

    var axisId = item.props[numericAxisId];
    var parentGroup = result[axisId] || {
      hasStack: false,
      stackGroups: {}
    };

    if (isNumOrStr(stackId)) {
      var childGroup = parentGroup.stackGroups[stackId] || {
        numericAxisId: numericAxisId,
        cateAxisId: cateAxisId,
        items: []
      };
      childGroup.items.push(item);
      parentGroup.hasStack = true;
      parentGroup.stackGroups[stackId] = childGroup;
    } else {
      parentGroup.stackGroups[uniqueId('_stackId_')] = {
        numericAxisId: numericAxisId,
        cateAxisId: cateAxisId,
        items: [item]
      };
    }

    return _objectSpread$j(_objectSpread$j({}, result), {}, _defineProperty$k({}, axisId, parentGroup));
  }, {});
  return Object.keys(stackGroups).reduce(function (result, axisId) {
    var group = stackGroups[axisId];

    if (group.hasStack) {
      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
        var g = group.stackGroups[stackId];
        return _objectSpread$j(_objectSpread$j({}, res), {}, _defineProperty$k({}, stackId, {
          numericAxisId: numericAxisId,
          cateAxisId: cateAxisId,
          items: g.items,
          stackedData: getStackedData(data, g.items, offsetType)
        }));
      }, {});
    }

    return _objectSpread$j(_objectSpread$j({}, result), {}, _defineProperty$k({}, axisId, group));
  }, {});
};
/**
 * get domain of ticks
 * @param  {Array} ticks Ticks of axis
 * @param  {String} type  The type of axis
 * @return {Array} domain
 */

var calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
  if (type === 'number') {
    return [min_1(ticks), max_1(ticks)];
  }

  return ticks;
};
/**
 * Configure the scale function of axis
 * @param {Object} scale The scale function
 * @param {Object} opts  The configuration of axis
 * @return {Object}      null
 */

var getTicksOfScale = function getTicksOfScale(scale, opts) {
  var realScaleType = opts.realScaleType,
      type = opts.type,
      tickCount = opts.tickCount,
      originalDomain = opts.originalDomain,
      allowDecimals = opts.allowDecimals;
  var scaleType = realScaleType || opts.scale;

  if (scaleType !== 'auto' && scaleType !== 'linear') {
    return null;
  }

  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
    // Calculate the ticks by the number of grid when the axis is a number axis
    var domain = scale.domain();

    if (!domain.length) {
      return null;
    }

    var tickValues = getNiceTickValues(domain, tickCount, allowDecimals);
    scale.domain(calculateDomainOfTicks(tickValues, type));
    return {
      niceTicks: tickValues
    };
  }

  if (tickCount && type === 'number') {
    var _domain = scale.domain();

    var _tickValues = getTickValuesFixedDomain(_domain, tickCount, allowDecimals);

    return {
      niceTicks: _tickValues
    };
  }

  return null;
};
var getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref7) {
  var axis = _ref7.axis,
      ticks = _ref7.ticks,
      bandSize = _ref7.bandSize,
      entry = _ref7.entry,
      index = _ref7.index,
      dataKey = _ref7.dataKey;

  if (axis.type === 'category') {
    // find coordinate of category axis by the value of category
    if (!axis.allowDuplicatedCategory && axis.dataKey && !isNil_1(entry[axis.dataKey])) {
      var matchedTick = findEntryInArray(ticks, 'value', entry[axis.dataKey]);

      if (matchedTick) {
        return matchedTick.coordinate + bandSize / 2;
      }
    }

    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
  }

  var value = getValueByDataKey(entry, !isNil_1(dataKey) ? dataKey : axis.dataKey);
  return !isNil_1(value) ? axis.scale(value) : null;
};
var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
  var stackId = item.props.stackId;

  if (isNumOrStr(stackId)) {
    var group = stackGroups[stackId];

    if (group && group.items.length) {
      var itemIndex = -1;

      for (var i = 0, len = group.items.length; i < len; i++) {
        if (group.items[i] === item) {
          itemIndex = i;
          break;
        }
      }

      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
    }
  }

  return null;
};

var getDomainOfSingle = function getDomainOfSingle(data) {
  return data.reduce(function (result, entry) {
    return [min_1(entry.concat([result[0]]).filter(isNumber$1)), max_1(entry.concat([result[1]]).filter(isNumber$1))];
  }, [Infinity, -Infinity]);
};

var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
  return Object.keys(stackGroups).reduce(function (result, stackId) {
    var group = stackGroups[stackId];
    var stackedData = group.stackedData;
    var domain = stackedData.reduce(function (res, entry) {
      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
    }, [Infinity, -Infinity]);
    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
  }, [Infinity, -Infinity]).map(function (result) {
    return result === Infinity || result === -Infinity ? 0 : result;
  });
};
var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
  if (isFunction_1(specifiedDomain)) {
    return specifiedDomain(dataDomain, allowDataOverflow);
  }

  if (!isArray_1(specifiedDomain)) {
    return dataDomain;
  }

  var domain = [];
  /* eslint-disable prefer-destructuring */

  if (isNumber$1(specifiedDomain[0])) {
    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
    domain[0] = dataDomain[0] - value;
  } else if (isFunction_1(specifiedDomain[0])) {
    domain[0] = specifiedDomain[0](dataDomain[0]);
  } else {
    domain[0] = dataDomain[0];
  }

  if (isNumber$1(specifiedDomain[1])) {
    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];

    domain[1] = dataDomain[1] + _value;
  } else if (isFunction_1(specifiedDomain[1])) {
    domain[1] = specifiedDomain[1](dataDomain[1]);
  } else {
    domain[1] = dataDomain[1];
  }
  /* eslint-enable prefer-destructuring */


  return domain;
};
/**
 * Calculate the size between two category
 * @param  {Object} axis  The options of axis
 * @param  {Array}  ticks The ticks of axis
 * @param  {Boolean} isBar if items in axis are bars
 * @return {Number} Size
 */

var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks, isBar) {
  if (axis && axis.scale && axis.scale.bandwidth) {
    var bandWidth = axis.scale.bandwidth();

    if (!isBar || bandWidth > 0) {
      return bandWidth;
    }
  }

  if (axis && ticks && ticks.length >= 2) {
    var orderedTicks = sortBy_1(ticks, function (o) {
      return o.coordinate;
    });

    var bandSize = Infinity;

    for (var i = 1, len = orderedTicks.length; i < len; i++) {
      var cur = orderedTicks[i];
      var prev = orderedTicks[i - 1];
      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
    }

    return bandSize === Infinity ? 0 : bandSize;
  }

  return isBar ? undefined : 0;
};
/**
 * parse the domain of a category axis when a domain is specified
 * @param   {Array}        specifiedDomain  The domain specified by users
 * @param   {Array}        calculatedDomain The domain calculated by dateKey
 * @param   {ReactElement} axisChild        The axis element
 * @returns {Array}        domains
 */

var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
  if (!specifiedDomain || !specifiedDomain.length) {
    return calculatedDomain;
  }

  if (isEqual_1(specifiedDomain, get_1(axisChild, 'type.defaultProps.domain'))) {
    return calculatedDomain;
  }

  return specifiedDomain;
};
var getTooltipItem = function getTooltipItem(graphicalItem, payload) {
  var _graphicalItem$props = graphicalItem.props,
      dataKey = _graphicalItem$props.dataKey,
      name = _graphicalItem$props.name,
      unit = _graphicalItem$props.unit,
      formatter = _graphicalItem$props.formatter,
      tooltipType = _graphicalItem$props.tooltipType,
      chartType = _graphicalItem$props.chartType;
  return _objectSpread$j(_objectSpread$j({}, filterProps(graphicalItem)), {}, {
    dataKey: dataKey,
    unit: unit,
    formatter: formatter,
    name: name || dataKey,
    color: getMainColorOfGraphicItem(graphicalItem),
    value: getValueByDataKey(payload, dataKey),
    type: tooltipType,
    payload: payload,
    chartType: chartType
  });
};

function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$j(Object(source), true).forEach(function (key) { _defineProperty$j(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$j(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var RADIAN = Math.PI / 180;
var radianToDegree = function radianToDegree(angleInRadian) {
  return angleInRadian * 180 / Math.PI;
};
var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
  return {
    x: cx + Math.cos(-RADIAN * angle) * radius,
    y: cy + Math.sin(-RADIAN * angle) * radius
  };
};
var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
  var x1 = point.x,
      y1 = point.y;
  var x2 = anotherPoint.x,
      y2 = anotherPoint.y;
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
  var x = _ref.x,
      y = _ref.y;
  var cx = _ref2.cx,
      cy = _ref2.cy;
  var radius = distanceBetweenPoints({
    x: x,
    y: y
  }, {
    x: cx,
    y: cy
  });

  if (radius <= 0) {
    return {
      radius: radius
    };
  }

  var cos = (x - cx) / radius;
  var angleInRadian = Math.acos(cos);

  if (y > cy) {
    angleInRadian = 2 * Math.PI - angleInRadian;
  }

  return {
    radius: radius,
    angle: radianToDegree(angleInRadian),
    angleInRadian: angleInRadian
  };
};
var formatAngleOfSector = function formatAngleOfSector(_ref3) {
  var startAngle = _ref3.startAngle,
      endAngle = _ref3.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min = Math.min(startCnt, endCnt);
  return {
    startAngle: startAngle - min * 360,
    endAngle: endAngle - min * 360
  };
};

var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
  var startAngle = _ref4.startAngle,
      endAngle = _ref4.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min = Math.min(startCnt, endCnt);
  return angle + min * 360;
};

var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
  var x = _ref5.x,
      y = _ref5.y;

  var _getAngleOfPoint = getAngleOfPoint({
    x: x,
    y: y
  }, sector),
      radius = _getAngleOfPoint.radius,
      angle = _getAngleOfPoint.angle;

  var innerRadius = sector.innerRadius,
      outerRadius = sector.outerRadius;

  if (radius < innerRadius || radius > outerRadius) {
    return false;
  }

  if (radius === 0) {
    return true;
  }

  var _formatAngleOfSector = formatAngleOfSector(sector),
      startAngle = _formatAngleOfSector.startAngle,
      endAngle = _formatAngleOfSector.endAngle;

  var formatAngle = angle;
  var inRange;

  if (startAngle <= endAngle) {
    while (formatAngle > endAngle) {
      formatAngle -= 360;
    }

    while (formatAngle < startAngle) {
      formatAngle += 360;
    }

    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
  } else {
    while (formatAngle > startAngle) {
      formatAngle -= 360;
    }

    while (formatAngle < endAngle) {
      formatAngle += 360;
    }

    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
  }

  if (inRange) {
    return _objectSpread$i(_objectSpread$i({}, sector), {}, {
      radius: radius,
      angle: reverseFormatAngleOfSetor(formatAngle, sector)
    });
  }

  return null;
};

function _toConsumableArray$3(arr) { return _arrayWithoutHoles$3(arr) || _iterableToArray$3(arr) || _unsupportedIterableToArray$5(arr) || _nonIterableSpread$3(); }

function _nonIterableSpread$3() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }

function _iterableToArray$3(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$3(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$5(arr); }

function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$i(Object(source), true).forEach(function (key) { _defineProperty$i(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$i(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var getLabel = function getLabel(props) {
  var value = props.value,
      formatter = props.formatter;
  var label = isNil_1(props.children) ? value : props.children;

  if (isFunction_1(formatter)) {
    return formatter(label);
  }

  return label;
};

var getDeltaAngle$1 = function getDeltaAngle(startAngle, endAngle) {
  var sign = mathSign(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign * deltaAngle;
};

var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
  var position = labelProps.position,
      viewBox = labelProps.viewBox,
      offset = labelProps.offset,
      className = labelProps.className;
  var _ref = viewBox,
      cx = _ref.cx,
      cy = _ref.cy,
      innerRadius = _ref.innerRadius,
      outerRadius = _ref.outerRadius,
      startAngle = _ref.startAngle,
      endAngle = _ref.endAngle,
      clockWise = _ref.clockWise;
  var radius = (innerRadius + outerRadius) / 2;
  var deltaAngle = getDeltaAngle$1(startAngle, endAngle);
  var sign = deltaAngle >= 0 ? 1 : -1;
  var labelAngle, direction;

  if (position === 'insideStart') {
    labelAngle = startAngle + sign * offset;
    direction = clockWise;
  } else if (position === 'insideEnd') {
    labelAngle = endAngle - sign * offset;
    direction = !clockWise;
  } else if (position === 'end') {
    labelAngle = endAngle + sign * offset;
    direction = clockWise;
  }

  direction = deltaAngle <= 0 ? direction : !direction;
  var startPoint = polarToCartesian(cx, cy, radius, labelAngle);
  var endPoint = polarToCartesian(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
  var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
  var id = isNil_1(labelProps.id) ? uniqueId('recharts-radial-line-') : labelProps.id;
  return /*#__PURE__*/React$2.createElement("text", _extends$i({}, attrs, {
    dominantBaseline: "central",
    className: classNames('recharts-radial-bar-label', className)
  }), /*#__PURE__*/React$2.createElement("defs", null, /*#__PURE__*/React$2.createElement("path", {
    id: id,
    d: path
  })), /*#__PURE__*/React$2.createElement("textPath", {
    xlinkHref: "#".concat(id)
  }, label));
};

var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
  var viewBox = props.viewBox,
      offset = props.offset,
      position = props.position;
  var _ref2 = viewBox,
      cx = _ref2.cx,
      cy = _ref2.cy,
      innerRadius = _ref2.innerRadius,
      outerRadius = _ref2.outerRadius,
      startAngle = _ref2.startAngle,
      endAngle = _ref2.endAngle;
  var midAngle = (startAngle + endAngle) / 2;

  if (position === 'outside') {
    var _polarToCartesian = polarToCartesian(cx, cy, outerRadius + offset, midAngle),
        _x = _polarToCartesian.x,
        _y = _polarToCartesian.y;

    return {
      x: _x,
      y: _y,
      textAnchor: _x >= cx ? 'start' : 'end',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'center') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'centerTop') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'start'
    };
  }

  if (position === 'centerBottom') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'end'
    };
  }

  var r = (innerRadius + outerRadius) / 2;

  var _polarToCartesian2 = polarToCartesian(cx, cy, r, midAngle),
      x = _polarToCartesian2.x,
      y = _polarToCartesian2.y;

  return {
    x: x,
    y: y,
    textAnchor: 'middle',
    verticalAnchor: 'middle'
  };
};

var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
  var viewBox = props.viewBox,
      parentViewBox = props.parentViewBox,
      offset = props.offset,
      position = props.position;
  var _ref3 = viewBox,
      x = _ref3.x,
      y = _ref3.y,
      width = _ref3.width,
      height = _ref3.height; // Define vertical offsets and position inverts based on the value being positive or negative

  var verticalSign = height >= 0 ? 1 : -1;
  var verticalOffset = verticalSign * offset;
  var verticalEnd = verticalSign > 0 ? 'end' : 'start';
  var verticalStart = verticalSign > 0 ? 'start' : 'end'; // Define horizontal offsets and position inverts based on the value being positive or negative

  var horizontalSign = width >= 0 ? 1 : -1;
  var horizontalOffset = horizontalSign * offset;
  var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
  var horizontalStart = horizontalSign > 0 ? 'start' : 'end';

  if (position === 'top') {
    var attrs = {
      x: x + width / 2,
      y: y - verticalSign * offset,
      textAnchor: 'middle',
      verticalAnchor: verticalEnd
    };
    return _objectSpread$h(_objectSpread$h({}, attrs), parentViewBox ? {
      height: Math.max(y - parentViewBox.y, 0),
      width: width
    } : {});
  }

  if (position === 'bottom') {
    var _attrs = {
      x: x + width / 2,
      y: y + height + verticalOffset,
      textAnchor: 'middle',
      verticalAnchor: verticalStart
    };
    return _objectSpread$h(_objectSpread$h({}, _attrs), parentViewBox ? {
      height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
      width: width
    } : {});
  }

  if (position === 'left') {
    var _attrs2 = {
      x: x - horizontalOffset,
      y: y + height / 2,
      textAnchor: horizontalEnd,
      verticalAnchor: 'middle'
    };
    return _objectSpread$h(_objectSpread$h({}, _attrs2), parentViewBox ? {
      width: Math.max(_attrs2.x - parentViewBox.x, 0),
      height: height
    } : {});
  }

  if (position === 'right') {
    var _attrs3 = {
      x: x + width + horizontalOffset,
      y: y + height / 2,
      textAnchor: horizontalStart,
      verticalAnchor: 'middle'
    };
    return _objectSpread$h(_objectSpread$h({}, _attrs3), parentViewBox ? {
      width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
      height: height
    } : {});
  }

  var sizeAttrs = parentViewBox ? {
    width: width,
    height: height
  } : {};

  if (position === 'insideLeft') {
    return _objectSpread$h({
      x: x + horizontalOffset,
      y: y + height / 2,
      textAnchor: horizontalStart,
      verticalAnchor: 'middle'
    }, sizeAttrs);
  }

  if (position === 'insideRight') {
    return _objectSpread$h({
      x: x + width - horizontalOffset,
      y: y + height / 2,
      textAnchor: horizontalEnd,
      verticalAnchor: 'middle'
    }, sizeAttrs);
  }

  if (position === 'insideTop') {
    return _objectSpread$h({
      x: x + width / 2,
      y: y + verticalOffset,
      textAnchor: 'middle',
      verticalAnchor: verticalStart
    }, sizeAttrs);
  }

  if (position === 'insideBottom') {
    return _objectSpread$h({
      x: x + width / 2,
      y: y + height - verticalOffset,
      textAnchor: 'middle',
      verticalAnchor: verticalEnd
    }, sizeAttrs);
  }

  if (position === 'insideTopLeft') {
    return _objectSpread$h({
      x: x + horizontalOffset,
      y: y + verticalOffset,
      textAnchor: horizontalStart,
      verticalAnchor: verticalStart
    }, sizeAttrs);
  }

  if (position === 'insideTopRight') {
    return _objectSpread$h({
      x: x + width - horizontalOffset,
      y: y + verticalOffset,
      textAnchor: horizontalEnd,
      verticalAnchor: verticalStart
    }, sizeAttrs);
  }

  if (position === 'insideBottomLeft') {
    return _objectSpread$h({
      x: x + horizontalOffset,
      y: y + height - verticalOffset,
      textAnchor: horizontalStart,
      verticalAnchor: verticalEnd
    }, sizeAttrs);
  }

  if (position === 'insideBottomRight') {
    return _objectSpread$h({
      x: x + width - horizontalOffset,
      y: y + height - verticalOffset,
      textAnchor: horizontalEnd,
      verticalAnchor: verticalEnd
    }, sizeAttrs);
  }

  if (isObject_1(position) && (isNumber$1(position.x) || isPercent(position.x)) && (isNumber$1(position.y) || isPercent(position.y))) {
    return _objectSpread$h({
      x: x + getPercentValue(position.x, width),
      y: y + getPercentValue(position.y, height),
      textAnchor: 'end',
      verticalAnchor: 'end'
    }, sizeAttrs);
  }

  return _objectSpread$h({
    x: x + width / 2,
    y: y + height / 2,
    textAnchor: 'middle',
    verticalAnchor: 'middle'
  }, sizeAttrs);
};

var isPolar = function isPolar(viewBox) {
  return isNumber$1(viewBox.cx);
};

function Label(props) {
  var viewBox = props.viewBox,
      position = props.position,
      value = props.value,
      children = props.children,
      content = props.content,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      textBreakAll = props.textBreakAll;

  if (!viewBox || isNil_1(value) && isNil_1(children) && ! /*#__PURE__*/isValidElement(content) && !isFunction_1(content)) {
    return null;
  }

  if ( /*#__PURE__*/isValidElement(content)) {
    return /*#__PURE__*/cloneElement(content, props);
  }

  var label;

  if (isFunction_1(content)) {
    label = /*#__PURE__*/createElement(content, props);

    if ( /*#__PURE__*/isValidElement(label)) {
      return label;
    }
  } else {
    label = getLabel(props);
  }

  var isPolarLabel = isPolar(viewBox);
  var attrs = filterProps(props, true);

  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
    return renderRadialLabel(props, label, attrs);
  }

  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
  return /*#__PURE__*/React$2.createElement(Text, _extends$i({
    className: classNames('recharts-label', className)
  }, attrs, positionAttrs, {
    breakAll: textBreakAll
  }), label);
}
Label.displayName = 'Label';
Label.defaultProps = {
  offset: 5
};

var parseViewBox = function parseViewBox(props) {
  var cx = props.cx,
      cy = props.cy,
      angle = props.angle,
      startAngle = props.startAngle,
      endAngle = props.endAngle,
      r = props.r,
      radius = props.radius,
      innerRadius = props.innerRadius,
      outerRadius = props.outerRadius,
      x = props.x,
      y = props.y,
      top = props.top,
      left = props.left,
      width = props.width,
      height = props.height,
      clockWise = props.clockWise,
      labelViewBox = props.labelViewBox;

  if (labelViewBox) {
    return labelViewBox;
  }

  if (isNumber$1(width) && isNumber$1(height)) {
    if (isNumber$1(x) && isNumber$1(y)) {
      return {
        x: x,
        y: y,
        width: width,
        height: height
      };
    }

    if (isNumber$1(top) && isNumber$1(left)) {
      return {
        x: top,
        y: left,
        width: width,
        height: height
      };
    }
  }

  if (isNumber$1(x) && isNumber$1(y)) {
    return {
      x: x,
      y: y,
      width: 0,
      height: 0
    };
  }

  if (isNumber$1(cx) && isNumber$1(cy)) {
    return {
      cx: cx,
      cy: cy,
      startAngle: startAngle || angle || 0,
      endAngle: endAngle || angle || 0,
      innerRadius: innerRadius || 0,
      outerRadius: outerRadius || radius || r || 0,
      clockWise: clockWise
    };
  }

  if (props.viewBox) {
    return props.viewBox;
  }

  return {};
};

var parseLabel = function parseLabel(label, viewBox) {
  if (!label) {
    return null;
  }

  if (label === true) {
    return /*#__PURE__*/React$2.createElement(Label, {
      key: "label-implicit",
      viewBox: viewBox
    });
  }

  if (isNumOrStr(label)) {
    return /*#__PURE__*/React$2.createElement(Label, {
      key: "label-implicit",
      viewBox: viewBox,
      value: label
    });
  }

  if ( /*#__PURE__*/isValidElement(label)) {
    if (label.type === Label) {
      return /*#__PURE__*/cloneElement(label, {
        key: 'label-implicit',
        viewBox: viewBox
      });
    }

    return /*#__PURE__*/React$2.createElement(Label, {
      key: "label-implicit",
      content: label,
      viewBox: viewBox
    });
  }

  if (isFunction_1(label)) {
    return /*#__PURE__*/React$2.createElement(Label, {
      key: "label-implicit",
      content: label,
      viewBox: viewBox
    });
  }

  if (isObject_1(label)) {
    return /*#__PURE__*/React$2.createElement(Label, _extends$i({
      viewBox: viewBox
    }, label, {
      key: "label-implicit"
    }));
  }

  return null;
};

var renderCallByParent$1 = function renderCallByParent(parentProps, viewBox) {
  var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) {
    return null;
  }

  var children = parentProps.children;
  var parentViewBox = parseViewBox(parentProps);
  var explicitChildren = findAllByType(children, Label.displayName).map(function (child, index) {
    return /*#__PURE__*/cloneElement(child, {
      viewBox: viewBox || parentViewBox,
      key: "label-".concat(index)
    });
  });

  if (!checkPropsLabel) {
    return explicitChildren;
  }

  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
  return [implicitLabel].concat(_toConsumableArray$3(explicitChildren));
};

Label.parseViewBox = parseViewBox;
Label.renderCallByParent = renderCallByParent$1;

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */

function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last;

function _toConsumableArray$2(arr) { return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$4(arr) || _nonIterableSpread$2(); }

function _nonIterableSpread$2() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _iterableToArray$2(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$2(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$4(arr); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$h(Object(source), true).forEach(function (key) { _defineProperty$h(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$h(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$6(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$6(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$6(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var defaultProps$1 = {
  valueAccessor: function valueAccessor(entry) {
    return isArray_1(entry.value) ? last_1(entry.value) : entry.value;
  }
};
function LabelList(props) {
  var data = props.data,
      valueAccessor = props.valueAccessor,
      dataKey = props.dataKey,
      clockWise = props.clockWise,
      id = props.id,
      textBreakAll = props.textBreakAll,
      others = _objectWithoutProperties$6(props, ["data", "valueAccessor", "dataKey", "clockWise", "id", "textBreakAll"]);

  if (!data || !data.length) {
    return null;
  }

  return /*#__PURE__*/React$2.createElement(Layer, {
    className: "recharts-label-list"
  }, data.map(function (entry, index) {
    var value = isNil_1(dataKey) ? valueAccessor(entry, index) : getValueByDataKey(entry && entry.payload, dataKey);
    var idProps = isNil_1(id) ? {} : {
      id: "".concat(id, "-").concat(index)
    };
    return /*#__PURE__*/React$2.createElement(Label, _extends$h({}, filterProps(entry, true), others, idProps, {
      parentViewBox: entry.parentViewBox,
      index: index,
      value: value,
      textBreakAll: textBreakAll,
      viewBox: Label.parseViewBox(isNil_1(clockWise) ? entry : _objectSpread$g(_objectSpread$g({}, entry), {}, {
        clockWise: clockWise
      })),
      key: "label-".concat(index) // eslint-disable-line react/no-array-index-key

    }));
  }));
}
LabelList.displayName = 'LabelList';

function parseLabelList(label, data) {
  if (!label) {
    return null;
  }

  if (label === true) {
    return /*#__PURE__*/React$2.createElement(LabelList, {
      key: "labelList-implicit",
      data: data
    });
  }

  if ( /*#__PURE__*/React$2.isValidElement(label) || isFunction_1(label)) {
    return /*#__PURE__*/React$2.createElement(LabelList, {
      key: "labelList-implicit",
      data: data,
      content: label
    });
  }

  if (isObject_1(label)) {
    return /*#__PURE__*/React$2.createElement(LabelList, _extends$h({
      data: data
    }, label, {
      key: "labelList-implicit"
    }));
  }

  return null;
}

function renderCallByParent(parentProps, data) {
  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
    return null;
  }

  var children = parentProps.children;
  var explicitChilren = findAllByType(children, LabelList.displayName).map(function (child, index) {
    return /*#__PURE__*/cloneElement(child, {
      data: data,
      key: "labelList-".concat(index)
    });
  });

  if (!ckeckPropsLabel) {
    return explicitChilren;
  }

  var implicitLabelList = parseLabelList(parentProps.label, data);
  return [implicitLabelList].concat(_toConsumableArray$2(explicitChilren));
}

LabelList.renderCallByParent = renderCallByParent;
LabelList.defaultProps = defaultProps$1;

function _typeof$h(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$h = function _typeof(obj) { return typeof obj; }; } else { _typeof$h = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$h(obj); }

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

function _classCallCheck$g(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$h(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$h(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$h(Constructor.prototype, protoProps); if (staticProps) _defineProperties$h(Constructor, staticProps); return Constructor; }

function _inherits$e(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$e(subClass, superClass); }

function _setPrototypeOf$e(o, p) { _setPrototypeOf$e = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$e(o, p); }

function _createSuper$d(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$d(); return function _createSuperInternal() { var Super = _getPrototypeOf$e(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$e(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$e(this, result); }; }

function _possibleConstructorReturn$e(self, call) { if (call && (_typeof$h(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$e(self); }

function _assertThisInitialized$e(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$d() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$e(o) { _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$e(o); }

var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
  var sign = mathSign(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
  return sign * deltaAngle;
};

var getTangentCircle = function getTangentCircle(_ref) {
  var cx = _ref.cx,
      cy = _ref.cy,
      radius = _ref.radius,
      angle = _ref.angle,
      sign = _ref.sign,
      isExternal = _ref.isExternal,
      cornerRadius = _ref.cornerRadius,
      cornerIsExternal = _ref.cornerIsExternal;
  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
  var theta = Math.asin(cornerRadius / centerRadius) / RADIAN;
  var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
  var center = polarToCartesian(cx, cy, centerRadius, centerAngle); // The coordinate of point which is tangent to the circle

  var circleTangency = polarToCartesian(cx, cy, radius, centerAngle); // The coordinate of point which is tangent to the radius line

  var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
  var lineTangency = polarToCartesian(cx, cy, centerRadius * Math.cos(theta * RADIAN), lineTangencyAngle);
  return {
    center: center,
    circleTangency: circleTangency,
    lineTangency: lineTangency,
    theta: theta
  };
};

var getSectorPath = function getSectorPath(_ref2) {
  var cx = _ref2.cx,
      cy = _ref2.cy,
      innerRadius = _ref2.innerRadius,
      outerRadius = _ref2.outerRadius,
      startAngle = _ref2.startAngle,
      endAngle = _ref2.endAngle;
  var angle = getDeltaAngle(startAngle, endAngle); // When the angle of sector equals to 360, star point and end point coincide

  var tempEndAngle = startAngle + angle;
  var outerStartPoint = polarToCartesian(cx, cy, outerRadius, startAngle);
  var outerEndPoint = polarToCartesian(cx, cy, outerRadius, tempEndAngle);
  var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");

  if (innerRadius > 0) {
    var innerStartPoint = polarToCartesian(cx, cy, innerRadius, startAngle);
    var innerEndPoint = polarToCartesian(cx, cy, innerRadius, tempEndAngle);
    path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
  } else {
    path += "L ".concat(cx, ",").concat(cy, " Z");
  }

  return path;
};

var getSectorWithCorner = function getSectorWithCorner(_ref3) {
  var cx = _ref3.cx,
      cy = _ref3.cy,
      innerRadius = _ref3.innerRadius,
      outerRadius = _ref3.outerRadius,
      cornerRadius = _ref3.cornerRadius,
      forceCornerRadius = _ref3.forceCornerRadius,
      cornerIsExternal = _ref3.cornerIsExternal,
      startAngle = _ref3.startAngle,
      endAngle = _ref3.endAngle;
  var sign = mathSign(endAngle - startAngle);

  var _getTangentCircle = getTangentCircle({
    cx: cx,
    cy: cy,
    radius: outerRadius,
    angle: startAngle,
    sign: sign,
    cornerRadius: cornerRadius,
    cornerIsExternal: cornerIsExternal
  }),
      soct = _getTangentCircle.circleTangency,
      solt = _getTangentCircle.lineTangency,
      sot = _getTangentCircle.theta;

  var _getTangentCircle2 = getTangentCircle({
    cx: cx,
    cy: cy,
    radius: outerRadius,
    angle: endAngle,
    sign: -sign,
    cornerRadius: cornerRadius,
    cornerIsExternal: cornerIsExternal
  }),
      eoct = _getTangentCircle2.circleTangency,
      eolt = _getTangentCircle2.lineTangency,
      eot = _getTangentCircle2.theta;

  var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;

  if (outerArcAngle < 0) {
    if (forceCornerRadius) {
      return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
    }

    return getSectorPath({
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle
    });
  }

  var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");

  if (innerRadius > 0) {
    var _getTangentCircle3 = getTangentCircle({
      cx: cx,
      cy: cy,
      radius: innerRadius,
      angle: startAngle,
      sign: sign,
      isExternal: true,
      cornerRadius: cornerRadius,
      cornerIsExternal: cornerIsExternal
    }),
        sict = _getTangentCircle3.circleTangency,
        silt = _getTangentCircle3.lineTangency,
        sit = _getTangentCircle3.theta;

    var _getTangentCircle4 = getTangentCircle({
      cx: cx,
      cy: cy,
      radius: innerRadius,
      angle: endAngle,
      sign: -sign,
      isExternal: true,
      cornerRadius: cornerRadius,
      cornerIsExternal: cornerIsExternal
    }),
        eict = _getTangentCircle4.circleTangency,
        eilt = _getTangentCircle4.lineTangency,
        eit = _getTangentCircle4.theta;

    var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;

    if (innerArcAngle < 0 && cornerRadius === 0) {
      return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
    }

    path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
  } else {
    path += "L".concat(cx, ",").concat(cy, "Z");
  }

  return path;
};

var Sector = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(Sector, _PureComponent);

  var _super = _createSuper$d(Sector);

  function Sector() {
    _classCallCheck$g(this, Sector);

    return _super.apply(this, arguments);
  }

  _createClass$h(Sector, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cx = _this$props.cx,
          cy = _this$props.cy,
          innerRadius = _this$props.innerRadius,
          outerRadius = _this$props.outerRadius,
          cornerRadius = _this$props.cornerRadius,
          forceCornerRadius = _this$props.forceCornerRadius,
          cornerIsExternal = _this$props.cornerIsExternal,
          startAngle = _this$props.startAngle,
          endAngle = _this$props.endAngle,
          className = _this$props.className;

      if (outerRadius < innerRadius || startAngle === endAngle) {
        return null;
      }

      var layerClass = classNames('recharts-sector', className);
      var deltaRadius = outerRadius - innerRadius;
      var cr = getPercentValue(cornerRadius, deltaRadius, 0, true);
      var path;

      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
        path = getSectorWithCorner({
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          cornerRadius: Math.min(cr, deltaRadius / 2),
          forceCornerRadius: forceCornerRadius,
          cornerIsExternal: cornerIsExternal,
          startAngle: startAngle,
          endAngle: endAngle
        });
      } else {
        path = getSectorPath({
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          startAngle: startAngle,
          endAngle: endAngle
        });
      }

      return /*#__PURE__*/React$2.createElement("path", _extends$g({}, filterProps(this.props, true), {
        className: layerClass,
        d: path
      }));
    }
  }]);

  return Sector;
}(PureComponent);
Sector.defaultProps = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: false,
  cornerIsExternal: false
};

function _typeof$g(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$g = function _typeof(obj) { return typeof obj; }; } else { _typeof$g = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$g(obj); }

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$g(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$g(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$f(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$g(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$g(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$g(Constructor.prototype, protoProps); if (staticProps) _defineProperties$g(Constructor, staticProps); return Constructor; }

function _inherits$d(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$d(subClass, superClass); }

function _setPrototypeOf$d(o, p) { _setPrototypeOf$d = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$d(o, p); }

function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf$d(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$d(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$d(this, result); }; }

function _possibleConstructorReturn$d(self, call) { if (call && (_typeof$g(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$d(self); }

function _assertThisInitialized$d(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$d(o) { _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$d(o); }
var CURVE_FACTORIES = {
  curveBasisClosed: curveBasisClosed,
  curveBasisOpen: curveBasisOpen,
  curveBasis: curveBasis,
  curveLinearClosed: curveLinearClosed,
  curveLinear: curveLinear,
  curveMonotoneX: monotoneX,
  curveMonotoneY: monotoneY,
  curveNatural: curveNatural,
  curveStep: curveStep,
  curveStepAfter: stepAfter,
  curveStepBefore: stepBefore
};

var defined = function defined(p) {
  return p.x === +p.x && p.y === +p.y;
};

var getX = function getX(p) {
  return p.x;
};

var getY = function getY(p) {
  return p.y;
};

var getCurveFactory = function getCurveFactory(type, layout) {
  if (isFunction_1(type)) {
    return type;
  }

  var name = "curve".concat(upperFirst_1(type));

  if (name === 'curveMonotone' && layout) {
    return CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
  }

  return CURVE_FACTORIES[name] || curveLinear;
};

var Curve = /*#__PURE__*/function (_PureComponent) {
  _inherits$d(Curve, _PureComponent);

  var _super = _createSuper$c(Curve);

  function Curve() {
    _classCallCheck$f(this, Curve);

    return _super.apply(this, arguments);
  }

  _createClass$g(Curve, [{
    key: "getPath",
    value:
    /**
     * Calculate the path of curve
     * @return {String} path
     */
    function getPath() {
      var _this$props = this.props,
          type = _this$props.type,
          points = _this$props.points,
          baseLine = _this$props.baseLine,
          layout = _this$props.layout,
          connectNulls = _this$props.connectNulls;
      var curveFactory = getCurveFactory(type, layout);
      var formatPoints = connectNulls ? points.filter(function (entry) {
        return defined(entry);
      }) : points;
      var lineFunction;

      if (isArray_1(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function (base) {
          return defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function (entry, index) {
          return _objectSpread$f(_objectSpread$f({}, entry), {}, {
            base: formatBaseLine[index]
          });
        });

        if (layout === 'vertical') {
          lineFunction = shapeArea().y(getY).x1(getX).x0(function (d) {
            return d.base.x;
          });
        } else {
          lineFunction = shapeArea().x(getX).y1(getY).y0(function (d) {
            return d.base.y;
          });
        }

        lineFunction.defined(defined).curve(curveFactory);
        return lineFunction(areaPoints);
      }

      if (layout === 'vertical' && isNumber$1(baseLine)) {
        lineFunction = shapeArea().y(getY).x1(getX).x0(baseLine);
      } else if (isNumber$1(baseLine)) {
        lineFunction = shapeArea().x(getX).y1(getY).y0(baseLine);
      } else {
        lineFunction = shapeLine().x(getX).y(getY);
      }

      lineFunction.defined(defined).curve(curveFactory);
      return lineFunction(formatPoints);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          points = _this$props2.points,
          path = _this$props2.path,
          pathRef = _this$props2.pathRef;

      if ((!points || !points.length) && !path) {
        return null;
      }

      var realPath = points && points.length ? this.getPath() : path;
      return /*#__PURE__*/React$2.createElement("path", _extends$f({}, filterProps(this.props), adaptEventHandlers(this.props), {
        className: classNames('recharts-curve', className),
        d: realPath,
        ref: pathRef
      }));
    }
  }]);

  return Curve;
}(PureComponent);
Curve.defaultProps = {
  type: 'linear',
  points: [],
  connectNulls: false
};

function _typeof$f(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$f = function _typeof(obj) { return typeof obj; }; } else { _typeof$f = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$f(obj); }

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

function _classCallCheck$e(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$f(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$f(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$f(Constructor.prototype, protoProps); if (staticProps) _defineProperties$f(Constructor, staticProps); return Constructor; }

function _inherits$c(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$c(subClass, superClass); }

function _setPrototypeOf$c(o, p) { _setPrototypeOf$c = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$c(o, p); }

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf$c(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$c(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$c(this, result); }; }

function _possibleConstructorReturn$c(self, call) { if (call && (_typeof$f(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$c(self); }

function _assertThisInitialized$c(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$c(o) { _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$c(o); }

var getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
  var ySign = height >= 0 ? 1 : -1;
  var xSign = width >= 0 ? 1 : -1;
  var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
  var path;

  if (maxRadius > 0 && radius instanceof Array) {
    var newRadius = [0, 0, 0, 0];

    for (var i = 0, len = 4; i < len; i++) {
      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
    }

    path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);

    if (newRadius[0] > 0) {
      path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
    }

    path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);

    if (newRadius[1] > 0) {
      path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
    }

    path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);

    if (newRadius[2] > 0) {
      path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
    }

    path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);

    if (newRadius[3] > 0) {
      path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
    }

    path += 'Z';
  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
    var _newRadius = Math.min(maxRadius, radius);

    path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
  } else {
    path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
  }

  return path;
};

var isInRectangle = function isInRectangle(point, rect) {
  if (!point || !rect) {
    return false;
  }

  var px = point.x,
      py = point.y;
  var x = rect.x,
      y = rect.y,
      width = rect.width,
      height = rect.height;

  if (Math.abs(width) > 0 && Math.abs(height) > 0) {
    var minX = Math.min(x, x + width);
    var maxX = Math.max(x, x + width);
    var minY = Math.min(y, y + height);
    var maxY = Math.max(y, y + height);
    return px >= minX && px <= maxX && py >= minY && py <= maxY;
  }

  return false;
};
var Rectangle = /*#__PURE__*/function (_PureComponent) {
  _inherits$c(Rectangle, _PureComponent);

  var _super = _createSuper$b(Rectangle);

  function Rectangle() {
    var _this;

    _classCallCheck$e(this, Rectangle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      totalLength: -1
    };
    _this.node = void 0;
    return _this;
  }

  _createClass$f(Rectangle, [{
    key: "componentDidMount",
    value:
    /* eslint-disable  react/no-did-mount-set-state */
    function componentDidMount() {
      if (this.node && this.node.getTotalLength) {
        try {
          var totalLength = this.node.getTotalLength();

          if (totalLength) {
            this.setState({
              totalLength: totalLength
            });
          }
        } catch (err) {// calculate total length error
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          width = _this$props.width,
          height = _this$props.height,
          radius = _this$props.radius,
          className = _this$props.className;
      var totalLength = this.state.totalLength;
      var _this$props2 = this.props,
          animationEasing = _this$props2.animationEasing,
          animationDuration = _this$props2.animationDuration,
          animationBegin = _this$props2.animationBegin,
          isAnimationActive = _this$props2.isAnimationActive,
          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;

      if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) {
        return null;
      }

      var layerClass = classNames('recharts-rectangle', className);

      if (!isUpdateAnimationActive) {
        return /*#__PURE__*/React$2.createElement("path", _extends$e({}, filterProps(this.props, true), {
          className: layerClass,
          d: getRectanglePath(x, y, width, height, radius)
        }));
      }

      return /*#__PURE__*/React$2.createElement(Animate, {
        canBegin: totalLength > 0,
        from: {
          width: width,
          height: height,
          x: x,
          y: y
        },
        to: {
          width: width,
          height: height,
          x: x,
          y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
      }, function (_ref) {
        var currWidth = _ref.width,
            currHeight = _ref.height,
            currX = _ref.x,
            currY = _ref.y;
        return /*#__PURE__*/React$2.createElement(Animate, {
          canBegin: totalLength > 0,
          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
          to: "".concat(totalLength, "px 0px"),
          attributeName: "strokeDasharray",
          begin: animationBegin,
          duration: animationDuration,
          isActive: isAnimationActive,
          easing: animationEasing
        }, /*#__PURE__*/React$2.createElement("path", _extends$e({}, filterProps(_this2.props, true), {
          className: layerClass,
          d: getRectanglePath(currX, currY, currWidth, currHeight, radius),
          ref: function ref(node) {
            _this2.node = node;
          }
        })));
      });
    }
  }]);

  return Rectangle;
}(PureComponent);
Rectangle.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: false,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};

function _typeof$e(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$e = function _typeof(obj) { return typeof obj; }; } else { _typeof$e = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$e(obj); }

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

function _classCallCheck$d(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$e(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$e(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$e(Constructor.prototype, protoProps); if (staticProps) _defineProperties$e(Constructor, staticProps); return Constructor; }

function _inherits$b(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$b(subClass, superClass); }

function _setPrototypeOf$b(o, p) { _setPrototypeOf$b = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$b(o, p); }

function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf$b(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$b(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$b(this, result); }; }

function _possibleConstructorReturn$b(self, call) { if (call && (_typeof$e(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$b(self); }

function _assertThisInitialized$b(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$b(o) { _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$b(o); }
var Dot = /*#__PURE__*/function (_PureComponent) {
  _inherits$b(Dot, _PureComponent);

  var _super = _createSuper$a(Dot);

  function Dot() {
    _classCallCheck$d(this, Dot);

    return _super.apply(this, arguments);
  }

  _createClass$e(Dot, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cx = _this$props.cx,
          cy = _this$props.cy,
          r = _this$props.r,
          className = _this$props.className;
      var layerClass = classNames('recharts-dot', className);

      if (cx === +cx && cy === +cy && r === +r) {
        return /*#__PURE__*/React$2.createElement("circle", _extends$d({}, filterProps(this.props), adaptEventHandlers(this.props), {
          className: layerClass,
          cx: cx,
          cy: cy,
          r: r
        }));
      }

      return null;
    }
  }]);

  return Dot;
}(PureComponent);

function _typeof$d(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$d = function _typeof(obj) { return typeof obj; }; } else { _typeof$d = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$d(obj); }

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$d(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$d(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$d(Constructor.prototype, protoProps); if (staticProps) _defineProperties$d(Constructor, staticProps); return Constructor; }

function _inherits$a(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$a(subClass, superClass); }

function _setPrototypeOf$a(o, p) { _setPrototypeOf$a = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$a(o, p); }

function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf$a(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$a(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$a(this, result); }; }

function _possibleConstructorReturn$a(self, call) { if (call && (_typeof$d(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$a(self); }

function _assertThisInitialized$a(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$a(o) { _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$a(o); }
var Cross = /*#__PURE__*/function (_PureComponent) {
  _inherits$a(Cross, _PureComponent);

  var _super = _createSuper$9(Cross);

  function Cross() {
    _classCallCheck$c(this, Cross);

    return _super.apply(this, arguments);
  }

  _createClass$d(Cross, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          width = _this$props.width,
          height = _this$props.height,
          top = _this$props.top,
          left = _this$props.left,
          className = _this$props.className;

      if (!isNumber$1(x) || !isNumber$1(y) || !isNumber$1(width) || !isNumber$1(height) || !isNumber$1(top) || !isNumber$1(left)) {
        return null;
      }

      return /*#__PURE__*/React$2.createElement("path", _extends$c({}, filterProps(this.props, true), {
        className: classNames('recharts-cross', className),
        d: Cross.getPath(x, y, width, height, top, left)
      }));
    }
  }], [{
    key: "getPath",
    value: function getPath(x, y, width, height, top, left) {
      return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
    }
  }]);

  return Cross;
}(PureComponent);
Cross.defaultProps = {
  x: 0,
  y: 0,
  top: 0,
  left: 0,
  width: 0,
  height: 0
};

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeCeil = Math.ceil,
    nativeMax$2 = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange$1(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax$2(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

var _baseRange = baseRange$1;

var toNumber$1 = toNumber_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite$2(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber$1(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite$2;

var baseRange = _baseRange,
    isIterateeCall$2 = _isIterateeCall,
    toFinite$1 = toFinite_1;

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange$1(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall$2(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite$1(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite$1(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite$1(step);
    return baseRange(start, end, step, fromRight);
  };
}

var _createRange = createRange$1;

var createRange = _createRange;

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

var range_1 = range;

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$f(Object(source), true).forEach(function (key) { _defineProperty$f(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
var generatePrefixStyle = function generatePrefixStyle(name, value) {
  if (!name) {
    return null;
  }

  var camelName = name.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  });
  var result = PREFIX_LIST.reduce(function (res, entry) {
    return _objectSpread$e(_objectSpread$e({}, res), {}, _defineProperty$f({}, entry + camelName, value));
  }, {});
  result[name] = value;
  return result;
};

function _typeof$c(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$c = function _typeof(obj) { return typeof obj; }; } else { _typeof$c = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$c(obj); }

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$e(Object(source), true).forEach(function (key) { _defineProperty$e(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$c(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$c(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$c(Constructor.prototype, protoProps); if (staticProps) _defineProperties$c(Constructor, staticProps); return Constructor; }

function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$9(subClass, superClass); }

function _setPrototypeOf$9(o, p) { _setPrototypeOf$9 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$9(o, p); }

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf$9(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$9(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$9(this, result); }; }

function _possibleConstructorReturn$9(self, call) { if (call && (_typeof$c(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$9(self); }

function _assertThisInitialized$9(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$9(o) { _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$9(o); }

var createScale = function createScale(_ref) {
  var data = _ref.data,
      startIndex = _ref.startIndex,
      endIndex = _ref.endIndex,
      x = _ref.x,
      width = _ref.width,
      travellerWidth = _ref.travellerWidth;

  if (!data || !data.length) {
    return {};
  }

  var len = data.length;
  var scale = point$2().domain(range_1(0, len)).range([x, x + width - travellerWidth]);
  var scaleValues = scale.domain().map(function (entry) {
    return scale(entry);
  });
  return {
    isTextActive: false,
    isSlideMoving: false,
    isTravellerMoving: false,
    startX: scale(startIndex),
    endX: scale(endIndex),
    scale: scale,
    scaleValues: scaleValues
  };
};

var isTouch = function isTouch(e) {
  return e.changedTouches && !!e.changedTouches.length;
};

var Brush = /*#__PURE__*/function (_PureComponent) {
  _inherits$9(Brush, _PureComponent);

  var _super = _createSuper$8(Brush);

  function Brush(props) {
    var _this;

    _classCallCheck$b(this, Brush);

    _this = _super.call(this, props);
    _this.leaveTimer = void 0;
    _this.travellerDragStartHandlers = void 0;

    _this.handleDrag = function (e) {
      if (_this.leaveTimer) {
        clearTimeout(_this.leaveTimer);
        _this.leaveTimer = null;
      }

      if (_this.state.isTravellerMoving) {
        _this.handleTravellerMove(e);
      } else if (_this.state.isSlideMoving) {
        _this.handleSlideDrag(e);
      }
    };

    _this.handleTouchMove = function (e) {
      if (e.changedTouches != null && e.changedTouches.length > 0) {
        _this.handleDrag(e.changedTouches[0]);
      }
    };

    _this.handleDragEnd = function () {
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: false
      });

      _this.detachDragEndListener();
    };

    _this.handleLeaveWrapper = function () {
      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
        _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
      }
    };

    _this.handleEnterSlideOrTraveller = function () {
      _this.setState({
        isTextActive: true
      });
    };

    _this.handleLeaveSlideOrTraveller = function () {
      _this.setState({
        isTextActive: false
      });
    };

    _this.handleSlideDragStart = function (e) {
      var event = isTouch(e) ? e.changedTouches[0] : e;

      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: true,
        slideMoveStartX: event.pageX
      });

      _this.attachDragEndListener();
    };

    _this.travellerDragStartHandlers = {
      startX: _this.handleTravellerDragStart.bind(_assertThisInitialized$9(_this), 'startX'),
      endX: _this.handleTravellerDragStart.bind(_assertThisInitialized$9(_this), 'endX')
    };
    _this.state = {};
    return _this;
  }

  _createClass$c(Brush, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer);
        this.leaveTimer = null;
      }

      this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function getIndex(_ref2) {
      var startX = _ref2.startX,
          endX = _ref2.endX;
      var scaleValues = this.state.scaleValues;
      var _this$props = this.props,
          gap = _this$props.gap,
          data = _this$props.data;
      var lastIndex = data.length - 1;
      var min = Math.min(startX, endX);
      var max = Math.max(startX, endX);
      var minIndex = Brush.getIndexInRange(scaleValues, min);
      var maxIndex = Brush.getIndexInRange(scaleValues, max);
      return {
        startIndex: minIndex - minIndex % gap,
        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
      };
    }
  }, {
    key: "getTextOfTick",
    value: function getTextOfTick(index) {
      var _this$props2 = this.props,
          data = _this$props2.data,
          tickFormatter = _this$props2.tickFormatter,
          dataKey = _this$props2.dataKey;
      var text = getValueByDataKey(data[index], dataKey, index);
      return isFunction_1(tickFormatter) ? tickFormatter(text, index) : text;
    }
  }, {
    key: "attachDragEndListener",
    value: function attachDragEndListener() {
      window.addEventListener('mouseup', this.handleDragEnd, true);
      window.addEventListener('touchend', this.handleDragEnd, true);
    }
  }, {
    key: "detachDragEndListener",
    value: function detachDragEndListener() {
      window.removeEventListener('mouseup', this.handleDragEnd, true);
      window.removeEventListener('touchend', this.handleDragEnd, true);
    }
  }, {
    key: "handleSlideDrag",
    value: function handleSlideDrag(e) {
      var _this$state = this.state,
          slideMoveStartX = _this$state.slideMoveStartX,
          startX = _this$state.startX,
          endX = _this$state.endX;
      var _this$props3 = this.props,
          x = _this$props3.x,
          width = _this$props3.width,
          travellerWidth = _this$props3.travellerWidth,
          startIndex = _this$props3.startIndex,
          endIndex = _this$props3.endIndex,
          onChange = _this$props3.onChange;
      var delta = e.pageX - slideMoveStartX;

      if (delta > 0) {
        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
      } else if (delta < 0) {
        delta = Math.max(delta, x - startX, x - endX);
      }

      var newIndex = this.getIndex({
        startX: startX + delta,
        endX: endX + delta
      });

      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
        onChange(newIndex);
      }

      this.setState({
        startX: startX + delta,
        endX: endX + delta,
        slideMoveStartX: e.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function handleTravellerDragStart(id, e) {
      var event = isTouch(e) ? e.changedTouches[0] : e;
      this.setState({
        isSlideMoving: false,
        isTravellerMoving: true,
        movingTravellerId: id,
        brushMoveStartX: event.pageX
      });
      this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function handleTravellerMove(e) {
      var _this$setState;

      var _this$state2 = this.state,
          brushMoveStartX = _this$state2.brushMoveStartX,
          movingTravellerId = _this$state2.movingTravellerId,
          endX = _this$state2.endX,
          startX = _this$state2.startX;
      var prevValue = this.state[movingTravellerId];
      var _this$props4 = this.props,
          x = _this$props4.x,
          width = _this$props4.width,
          travellerWidth = _this$props4.travellerWidth,
          onChange = _this$props4.onChange,
          gap = _this$props4.gap,
          data = _this$props4.data;
      var params = {
        startX: this.state.startX,
        endX: this.state.endX
      };
      var delta = e.pageX - brushMoveStartX;

      if (delta > 0) {
        delta = Math.min(delta, x + width - travellerWidth - prevValue);
      } else if (delta < 0) {
        delta = Math.max(delta, x - prevValue);
      }

      params[movingTravellerId] = prevValue + delta;
      var newIndex = this.getIndex(params);
      var startIndex = newIndex.startIndex,
          endIndex = newIndex.endIndex;

      var isFullGap = function isFullGap() {
        var lastIndex = data.length - 1;

        if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) {
          return true;
        }

        return false;
      };

      this.setState((_this$setState = {}, _defineProperty$e(_this$setState, movingTravellerId, prevValue + delta), _defineProperty$e(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function () {
        if (onChange) {
          if (isFullGap()) {
            onChange(newIndex);
          }
        }
      });
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var _this$props5 = this.props,
          x = _this$props5.x,
          y = _this$props5.y,
          width = _this$props5.width,
          height = _this$props5.height,
          fill = _this$props5.fill,
          stroke = _this$props5.stroke;
      return /*#__PURE__*/React$2.createElement("rect", {
        stroke: stroke,
        fill: fill,
        x: x,
        y: y,
        width: width,
        height: height
      });
    }
  }, {
    key: "renderPanorama",
    value: function renderPanorama() {
      var _this$props6 = this.props,
          x = _this$props6.x,
          y = _this$props6.y,
          width = _this$props6.width,
          height = _this$props6.height,
          data = _this$props6.data,
          children = _this$props6.children,
          padding = _this$props6.padding;
      var chartElement = Children.only(children);

      if (!chartElement) {
        return null;
      }

      return /*#__PURE__*/React$2.cloneElement(chartElement, {
        x: x,
        y: y,
        width: width,
        height: height,
        margin: padding,
        compact: true,
        data: data
      });
    }
  }, {
    key: "renderTravellerLayer",
    value: function renderTravellerLayer(travellerX, id) {
      var _this$props7 = this.props,
          y = _this$props7.y,
          travellerWidth = _this$props7.travellerWidth,
          height = _this$props7.height,
          traveller = _this$props7.traveller;
      var x = Math.max(travellerX, this.props.x);

      var travellerProps = _objectSpread$d(_objectSpread$d({}, filterProps(this.props)), {}, {
        x: x,
        y: y,
        width: travellerWidth,
        height: height
      });

      return /*#__PURE__*/React$2.createElement(Layer, {
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[id],
        onTouchStart: this.travellerDragStartHandlers[id],
        style: {
          cursor: 'col-resize'
        }
      }, Brush.renderTraveller(traveller, travellerProps));
    }
  }, {
    key: "renderSlide",
    value: function renderSlide(startX, endX) {
      var _this$props8 = this.props,
          y = _this$props8.y,
          height = _this$props8.height,
          stroke = _this$props8.stroke,
          travellerWidth = _this$props8.travellerWidth;
      var x = Math.min(startX, endX) + travellerWidth;
      var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
      return /*#__PURE__*/React$2.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: 'move'
        },
        stroke: "none",
        fill: stroke,
        fillOpacity: 0.2,
        x: x,
        y: y,
        width: width,
        height: height
      });
    }
  }, {
    key: "renderText",
    value: function renderText() {
      var _this$props9 = this.props,
          startIndex = _this$props9.startIndex,
          endIndex = _this$props9.endIndex,
          y = _this$props9.y,
          height = _this$props9.height,
          travellerWidth = _this$props9.travellerWidth,
          stroke = _this$props9.stroke;
      var _this$state3 = this.state,
          startX = _this$state3.startX,
          endX = _this$state3.endX;
      var offset = 5;
      var attrs = {
        pointerEvents: 'none',
        fill: stroke
      };
      return /*#__PURE__*/React$2.createElement(Layer, {
        className: "recharts-brush-texts"
      }, /*#__PURE__*/React$2.createElement(Text, _extends$b({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(startX, endX) - offset,
        y: y + height / 2
      }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/React$2.createElement(Text, _extends$b({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(startX, endX) + travellerWidth + offset,
        y: y + height / 2
      }, attrs), this.getTextOfTick(endIndex)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
          data = _this$props10.data,
          className = _this$props10.className,
          children = _this$props10.children,
          x = _this$props10.x,
          y = _this$props10.y,
          width = _this$props10.width,
          height = _this$props10.height,
          alwaysShowText = _this$props10.alwaysShowText;
      var _this$state4 = this.state,
          startX = _this$state4.startX,
          endX = _this$state4.endX,
          isTextActive = _this$state4.isTextActive,
          isSlideMoving = _this$state4.isSlideMoving,
          isTravellerMoving = _this$state4.isTravellerMoving;

      if (!data || !data.length || !isNumber$1(x) || !isNumber$1(y) || !isNumber$1(width) || !isNumber$1(height) || width <= 0 || height <= 0) {
        return null;
      }

      var layerClass = classNames('recharts-brush', className);
      var isPanoramic = React$2.Children.count(children) === 1;
      var style = generatePrefixStyle('userSelect', 'none');
      return /*#__PURE__*/React$2.createElement(Layer, {
        className: layerClass,
        onMouseMove: this.handleDrag,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: style
      }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function renderDefaultTraveller(props) {
      var x = props.x,
          y = props.y,
          width = props.width,
          height = props.height,
          stroke = props.stroke;
      var lineY = Math.floor(y + height / 2) - 1;
      return /*#__PURE__*/React$2.createElement(React$2.Fragment, null, /*#__PURE__*/React$2.createElement("rect", {
        x: x,
        y: y,
        width: width,
        height: height,
        fill: stroke,
        stroke: "none"
      }), /*#__PURE__*/React$2.createElement("line", {
        x1: x + 1,
        y1: lineY,
        x2: x + width - 1,
        y2: lineY,
        fill: "none",
        stroke: "#fff"
      }), /*#__PURE__*/React$2.createElement("line", {
        x1: x + 1,
        y1: lineY + 2,
        x2: x + width - 1,
        y2: lineY + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function renderTraveller(option, props) {
      var rectangle;

      if ( /*#__PURE__*/React$2.isValidElement(option)) {
        rectangle = /*#__PURE__*/React$2.cloneElement(option, props);
      } else if (isFunction_1(option)) {
        rectangle = option(props);
      } else {
        rectangle = Brush.renderDefaultTraveller(props);
      }

      return rectangle;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var data = nextProps.data,
          width = nextProps.width,
          x = nextProps.x,
          travellerWidth = nextProps.travellerWidth,
          updateId = nextProps.updateId,
          startIndex = nextProps.startIndex,
          endIndex = nextProps.endIndex;

      if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) {
        return _objectSpread$d({
          prevData: data,
          prevTravellerWidth: travellerWidth,
          prevUpdateId: updateId,
          prevX: x,
          prevWidth: width
        }, data && data.length ? createScale({
          data: data,
          width: width,
          x: x,
          travellerWidth: travellerWidth,
          startIndex: startIndex,
          endIndex: endIndex
        }) : {
          scale: null,
          scaleValues: null
        });
      }

      if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
        prevState.scale.range([x, x + width - travellerWidth]);
        var scaleValues = prevState.scale.domain().map(function (entry) {
          return prevState.scale(entry);
        });
        return {
          prevData: data,
          prevTravellerWidth: travellerWidth,
          prevUpdateId: updateId,
          prevX: x,
          prevWidth: width,
          startX: prevState.scale(nextProps.startIndex),
          endX: prevState.scale(nextProps.endIndex),
          scaleValues: scaleValues
        };
      }

      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function getIndexInRange(range, x) {
      var len = range.length;
      var start = 0;
      var end = len - 1;

      while (end - start > 1) {
        var middle = Math.floor((start + end) / 2);

        if (range[middle] > x) {
          end = middle;
        } else {
          start = middle;
        }
      }

      return x >= range[end] ? end : start;
    }
  }]);

  return Brush;
}(PureComponent);
Brush.displayName = 'Brush';
Brush.defaultProps = {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: '#fff',
  stroke: '#666',
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1000,
  alwaysShowText: false
};

var baseEach$1 = _baseEach;

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome$1(collection, predicate) {
  var result;

  baseEach$1(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

var _baseSome = baseSome$1;

var arraySome = _arraySome,
    baseIteratee$4 = _baseIteratee,
    baseSome = _baseSome,
    isArray$5 = isArray_1,
    isIterateeCall$1 = _isIterateeCall;

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray$5(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall$1(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee$4(predicate));
}

var some_1 = some;

var ifOverflowMatches = function ifOverflowMatches(props, value) {
  var alwaysShow = props.alwaysShow;
  var ifOverflow = props.ifOverflow;

  if (alwaysShow) {
    ifOverflow = 'extendDomain';
  }

  return ifOverflow === value;
};

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */

function arrayEvery$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

var _arrayEvery = arrayEvery$1;

var baseEach = _baseEach;

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery$1(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

var _baseEvery = baseEvery$1;

var arrayEvery = _arrayEvery,
    baseEvery = _baseEvery,
    baseIteratee$3 = _baseIteratee,
    isArray$4 = isArray_1,
    isIterateeCall = _isIterateeCall;

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray$4(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee$3(predicate));
}

var every_1 = every;

var defineProperty$1 = _defineProperty$p;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$1(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$1;

var baseAssignValue = _baseAssignValue,
    baseForOwn = _baseForOwn,
    baseIteratee$2 = _baseIteratee;

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee$2(iteratee);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

var mapValues_1 = mapValues;

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$b(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$b(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$b(Constructor.prototype, protoProps); if (staticProps) _defineProperties$b(Constructor, staticProps); return Constructor; }

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$d(Object(source), true).forEach(function (key) { _defineProperty$d(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/**
 * Calculate the scale function, position, width, height of axes
 * @param  {Object} props     Latest props
 * @param  {Object} axisMap   The configuration of axes
 * @param  {Object} offset    The offset of main part in the svg element
 * @param  {String} axisType  The type of axes, x-axis or y-axis
 * @param  {String} chartName The name of chart
 * @return {Object} Configuration
 */

var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
  var width = props.width,
      height = props.height,
      layout = props.layout,
      children = props.children;
  var ids = Object.keys(axisMap);
  var steps = {
    left: offset.left,
    leftMirror: offset.left,
    right: width - offset.right,
    rightMirror: width - offset.right,
    top: offset.top,
    topMirror: offset.top,
    bottom: height - offset.bottom,
    bottomMirror: height - offset.bottom
  };
  var hasBar = !!findChildByType(children, 'Bar');
  return ids.reduce(function (result, id) {
    var axis = axisMap[id];
    var orientation = axis.orientation,
        domain = axis.domain,
        _axis$padding = axis.padding,
        padding = _axis$padding === void 0 ? {} : _axis$padding,
        mirror = axis.mirror,
        reversed = axis.reversed;
    var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
    var calculatedPadding, range, x, y, needSpace;

    if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
      var diff = domain[1] - domain[0];
      var smallestDistanceBetweenValues = Infinity;
      var sortedValues = axis.categoricalDomain.sort();
      sortedValues.forEach(function (value, index) {
        if (index > 0) {
          smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
        }
      });
      var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
      var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;

      if (axis.padding === 'gap') {
        calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
      }

      if (axis.padding === 'no-gap') {
        var gap = getPercentValue(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
        var halfBand = smallestDistanceInPercent * rangeWidth / 2;
        calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
      }
    }

    if (axisType === 'xAxis') {
      range = [offset.left + (padding.left || 0) + (calculatedPadding || 0), offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)];
    } else if (axisType === 'yAxis') {
      range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0) + (calculatedPadding || 0), offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)];
    } else {
      range = axis.range;
    }

    if (reversed) {
      range = [range[1], range[0]];
    }

    var _parseScale = parseScale(axis, chartName, hasBar),
        scale = _parseScale.scale,
        realScaleType = _parseScale.realScaleType;

    scale.domain(domain).range(range);
    checkDomainOfScale(scale);
    var ticks = getTicksOfScale(scale, _objectSpread$c(_objectSpread$c({}, axis), {}, {
      realScaleType: realScaleType
    }));

    if (axisType === 'xAxis') {
      needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
      x = offset.left;
      y = steps[offsetKey] - needSpace * axis.height;
    } else if (axisType === 'yAxis') {
      needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
      x = steps[offsetKey] - needSpace * axis.width;
      y = offset.top;
    }

    var finalAxis = _objectSpread$c(_objectSpread$c(_objectSpread$c({}, axis), ticks), {}, {
      realScaleType: realScaleType,
      x: x,
      y: y,
      scale: scale,
      width: axisType === 'xAxis' ? offset.width : axis.width,
      height: axisType === 'yAxis' ? offset.height : axis.height
    });

    finalAxis.bandSize = getBandSizeOfAxis(finalAxis, ticks);

    if (!axis.hide && axisType === 'xAxis') {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
    } else if (!axis.hide) {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
    }

    return _objectSpread$c(_objectSpread$c({}, result), {}, _defineProperty$d({}, id, finalAxis));
  }, {});
};
var rectWithPoints = function rectWithPoints(_ref, _ref2) {
  var x1 = _ref.x,
      y1 = _ref.y;
  var x2 = _ref2.x,
      y2 = _ref2.y;
  return {
    x: Math.min(x1, x2),
    y: Math.min(y1, y2),
    width: Math.abs(x2 - x1),
    height: Math.abs(y2 - y1)
  };
};
/**
 * Compute the x, y, width, and height of a box from two reference points.
 * @param  {Object} coords     x1, x2, y1, and y2
 * @return {Object} object
 */

var rectWithCoords = function rectWithCoords(_ref3) {
  var x1 = _ref3.x1,
      y1 = _ref3.y1,
      x2 = _ref3.x2,
      y2 = _ref3.y2;
  return rectWithPoints({
    x: x1,
    y: y1
  }, {
    x: x2,
    y: y2
  });
};
var ScaleHelper = /*#__PURE__*/function () {
  function ScaleHelper(scale) {
    _classCallCheck$a(this, ScaleHelper);

    this.scale = void 0;
    this.scale = scale;
  }

  _createClass$b(ScaleHelper, [{
    key: "domain",
    get: function get() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function get() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function get() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function get() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function get() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function apply(value) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          bandAware = _ref4.bandAware,
          position = _ref4.position;

      if (value === undefined) {
        return undefined;
      }

      if (position) {
        switch (position) {
          case 'start':
            {
              return this.scale(value);
            }

          case 'middle':
            {
              var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(value) + offset;
            }

          case 'end':
            {
              var _offset = this.bandwidth ? this.bandwidth() : 0;

              return this.scale(value) + _offset;
            }

          default:
            {
              return this.scale(value);
            }
        }
      }

      if (bandAware) {
        var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;

        return this.scale(value) + _offset2;
      }

      return this.scale(value);
    }
  }, {
    key: "isInRange",
    value: function isInRange(value) {
      var range = this.range();
      var first = range[0];
      var last = range[range.length - 1];
      return first <= last ? value >= first && value <= last : value >= last && value <= first;
    }
  }], [{
    key: "create",
    value: function create(obj) {
      return new ScaleHelper(obj);
    }
  }]);

  return ScaleHelper;
}();
ScaleHelper.EPS = 1e-4;
var createLabeledScales = function createLabeledScales(options) {
  var scales = Object.keys(options).reduce(function (res, key) {
    return _objectSpread$c(_objectSpread$c({}, res), {}, _defineProperty$d({}, key, ScaleHelper.create(options[key])));
  }, {});
  return _objectSpread$c(_objectSpread$c({}, scales), {}, {
    apply: function apply(coord) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          bandAware = _ref5.bandAware,
          position = _ref5.position;

      return mapValues_1(coord, function (value, label) {
        return scales[label].apply(value, {
          bandAware: bandAware,
          position: position
        });
      });
    },
    isInRange: function isInRange(coord) {
      return every_1(coord, function (value, label) {
        return scales[label].isInRange(value);
      });
    }
  });
};

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$c(Object(source), true).forEach(function (key) { _defineProperty$c(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$2(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var renderLine = function renderLine(option, props) {
  var line;

  if ( /*#__PURE__*/React$2.isValidElement(option)) {
    line = /*#__PURE__*/React$2.cloneElement(option, props);
  } else if (isFunction_1(option)) {
    line = option(props);
  } else {
    line = /*#__PURE__*/React$2.createElement("line", _extends$a({}, props, {
      className: "recharts-reference-line-line"
    }));
  }

  return line;
}; // TODO: ScaleHelper


var getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, props) {
  var _props$viewBox = props.viewBox,
      x = _props$viewBox.x,
      y = _props$viewBox.y,
      width = _props$viewBox.width,
      height = _props$viewBox.height,
      position = props.position;

  if (isFixedY) {
    var yCoord = props.y,
        orientation = props.yAxis.orientation;
    var coord = scales.y.apply(yCoord, {
      position: position
    });

    if (ifOverflowMatches(props, 'discard') && !scales.y.isInRange(coord)) {
      return null;
    }

    var points = [{
      x: x + width,
      y: coord
    }, {
      x: x,
      y: coord
    }];
    return orientation === 'left' ? points.reverse() : points;
  }

  if (isFixedX) {
    var xCoord = props.x,
        _orientation = props.xAxis.orientation;

    var _coord = scales.x.apply(xCoord, {
      position: position
    });

    if (ifOverflowMatches(props, 'discard') && !scales.x.isInRange(_coord)) {
      return null;
    }

    var _points = [{
      x: _coord,
      y: y + height
    }, {
      x: _coord,
      y: y
    }];
    return _orientation === 'top' ? _points.reverse() : _points;
  }

  if (isSegment) {
    var segment = props.segment;

    var _points2 = segment.map(function (p) {
      return scales.apply(p, {
        position: position
      });
    });

    if (ifOverflowMatches(props, 'discard') && some_1(_points2, function (p) {
      return !scales.isInRange(p);
    })) {
      return null;
    }

    return _points2;
  }

  return null;
};

function ReferenceLine(props) {
  var fixedX = props.x,
      fixedY = props.y,
      segment = props.segment,
      xAxis = props.xAxis,
      yAxis = props.yAxis,
      shape = props.shape,
      className = props.className,
      alwaysShow = props.alwaysShow,
      clipPathId = props.clipPathId;
  warn(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale
  });
  var isX = isNumOrStr(fixedX);
  var isY = isNumOrStr(fixedY);
  var isSegment = segment && segment.length === 2;
  var endPoints = getEndPoints(scales, isX, isY, isSegment, props);

  if (!endPoints) {
    return null;
  }

  var _endPoints = _slicedToArray$2(endPoints, 2),
      _endPoints$ = _endPoints[0],
      x1 = _endPoints$.x,
      y1 = _endPoints$.y,
      _endPoints$2 = _endPoints[1],
      x2 = _endPoints$2.x,
      y2 = _endPoints$2.y;

  var clipPath = ifOverflowMatches(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;

  var lineProps = _objectSpread$b(_objectSpread$b({
    clipPath: clipPath
  }, filterProps(props, true)), {}, {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2
  });

  return /*#__PURE__*/React$2.createElement(Layer, {
    className: classNames('recharts-reference-line', className)
  }, renderLine(shape, lineProps), Label.renderCallByParent(props, rectWithCoords({
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2
  })));
}
ReferenceLine.displayName = 'ReferenceLine';
ReferenceLine.defaultProps = {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  fill: 'none',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1,
  position: 'middle'
};

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$b(Object(source), true).forEach(function (key) { _defineProperty$b(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getCoordinate = function getCoordinate(props) {
  var x = props.x,
      y = props.y,
      xAxis = props.xAxis,
      yAxis = props.yAxis;
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale
  });
  var result = scales.apply({
    x: x,
    y: y
  }, {
    bandAware: true
  });

  if (ifOverflowMatches(props, 'discard') && !scales.isInRange(result)) {
    return null;
  }

  return result;
};

function ReferenceDot(props) {
  var x = props.x,
      y = props.y,
      r = props.r,
      alwaysShow = props.alwaysShow,
      clipPathId = props.clipPathId;
  var isX = isNumOrStr(x);
  var isY = isNumOrStr(y);
  warn(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');

  if (!isX || !isY) {
    return null;
  }

  var coordinate = getCoordinate(props);

  if (!coordinate) {
    return null;
  }

  var cx = coordinate.x,
      cy = coordinate.y;
  var shape = props.shape,
      className = props.className;
  var clipPath = ifOverflowMatches(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;

  var dotProps = _objectSpread$a(_objectSpread$a({
    clipPath: clipPath
  }, filterProps(props, true)), {}, {
    cx: cx,
    cy: cy
  });

  return /*#__PURE__*/React$2.createElement(Layer, {
    className: classNames('recharts-reference-dot', className)
  }, ReferenceDot.renderDot(shape, dotProps), Label.renderCallByParent(props, {
    x: cx - r,
    y: cy - r,
    width: 2 * r,
    height: 2 * r
  }));
}
ReferenceDot.displayName = 'ReferenceDot';
ReferenceDot.defaultProps = {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#fff',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1
};

ReferenceDot.renderDot = function (option, props) {
  var dot;

  if ( /*#__PURE__*/React$2.isValidElement(option)) {
    dot = /*#__PURE__*/React$2.cloneElement(option, props);
  } else if (isFunction_1(option)) {
    dot = option(props);
  } else {
    dot = /*#__PURE__*/React$2.createElement(Dot, _extends$9({}, props, {
      cx: props.cx,
      cy: props.cy,
      className: "recharts-reference-dot-dot"
    }));
  }

  return dot;
};

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$a(Object(source), true).forEach(function (key) { _defineProperty$a(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
  var xValue1 = props.x1,
      xValue2 = props.x2,
      yValue1 = props.y1,
      yValue2 = props.y2,
      xAxis = props.xAxis,
      yAxis = props.yAxis;
  if (!xAxis || !yAxis) return null;
  var scales = createLabeledScales({
    x: xAxis.scale,
    y: yAxis.scale
  });
  var p1 = {
    x: hasX1 ? scales.x.apply(xValue1, {
      position: 'start'
    }) : scales.x.rangeMin,
    y: hasY1 ? scales.y.apply(yValue1, {
      position: 'start'
    }) : scales.y.rangeMin
  };
  var p2 = {
    x: hasX2 ? scales.x.apply(xValue2, {
      position: 'end'
    }) : scales.x.rangeMax,
    y: hasY2 ? scales.y.apply(yValue2, {
      position: 'end'
    }) : scales.y.rangeMax
  };

  if (ifOverflowMatches(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) {
    return null;
  }

  return rectWithPoints(p1, p2);
};

function ReferenceArea(props) {
  var x1 = props.x1,
      x2 = props.x2,
      y1 = props.y1,
      y2 = props.y2,
      className = props.className,
      alwaysShow = props.alwaysShow,
      clipPathId = props.clipPathId;
  warn(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var hasX1 = isNumOrStr(x1);
  var hasX2 = isNumOrStr(x2);
  var hasY1 = isNumOrStr(y1);
  var hasY2 = isNumOrStr(y2);
  var shape = props.shape;

  if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) {
    return null;
  }

  var rect = getRect(hasX1, hasX2, hasY1, hasY2, props);

  if (!rect && !shape) {
    return null;
  }

  var clipPath = ifOverflowMatches(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
  return /*#__PURE__*/React$2.createElement(Layer, {
    className: classNames('recharts-reference-area', className)
  }, ReferenceArea.renderRect(shape, _objectSpread$9(_objectSpread$9({
    clipPath: clipPath
  }, filterProps(props, true)), rect)), Label.renderCallByParent(props, rect));
}
ReferenceArea.displayName = 'ReferenceArea';
ReferenceArea.defaultProps = {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#ccc',
  fillOpacity: 0.5,
  stroke: 'none',
  strokeWidth: 1
};

ReferenceArea.renderRect = function (option, props) {
  var rect;

  if ( /*#__PURE__*/React$2.isValidElement(option)) {
    rect = /*#__PURE__*/React$2.cloneElement(option, props);
  } else if (isFunction_1(option)) {
    rect = option(props);
  } else {
    rect = /*#__PURE__*/React$2.createElement(Rectangle, _extends$8({}, props, {
      className: "recharts-reference-area-rect"
    }));
  }

  return rect;
};

function _typeof$b(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$b = function _typeof(obj) { return typeof obj; }; } else { _typeof$b = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$b(obj); }

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$9(Object(source), true).forEach(function (key) { _defineProperty$9(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$9(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$5(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$a(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$a(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$a(Constructor.prototype, protoProps); if (staticProps) _defineProperties$a(Constructor, staticProps); return Constructor; }

function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$8(subClass, superClass); }

function _setPrototypeOf$8(o, p) { _setPrototypeOf$8 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$8(o, p); }

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf$8(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$8(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$8(this, result); }; }

function _possibleConstructorReturn$8(self, call) { if (call && (_typeof$b(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$8(self); }

function _assertThisInitialized$8(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$8(o) { _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$8(o); }
var CartesianAxis = /*#__PURE__*/function (_Component) {
  _inherits$8(CartesianAxis, _Component);

  var _super = _createSuper$7(CartesianAxis);

  function CartesianAxis() {
    _classCallCheck$9(this, CartesianAxis);

    return _super.apply(this, arguments);
  }

  _createClass$a(CartesianAxis, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref) {
      var viewBox = _ref.viewBox,
          restProps = _objectWithoutProperties$5(_ref, ["viewBox"]);

      // props.viewBox is sometimes generated every time -
      // check that specially as object equality is likely to fail
      var _this$props = this.props,
          viewBoxOld = _this$props.viewBox,
          restPropsOld = _objectWithoutProperties$5(_this$props, ["viewBox"]);

      return !shallowEqual(viewBox, viewBoxOld) || !shallowEqual(restProps, restPropsOld);
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */

  }, {
    key: "getTickLineCoord",
    value: function getTickLineCoord(data) {
      var _this$props2 = this.props,
          x = _this$props2.x,
          y = _this$props2.y,
          width = _this$props2.width,
          height = _this$props2.height,
          orientation = _this$props2.orientation,
          tickSize = _this$props2.tickSize,
          mirror = _this$props2.mirror,
          tickMargin = _this$props2.tickMargin;
      var x1, x2, y1, y2, tx, ty;
      var sign = mirror ? -1 : 1;
      var finalTickSize = data.tickSize || tickSize;
      var tickCoord = isNumber$1(data.tickCoord) ? data.tickCoord : data.coordinate;

      switch (orientation) {
        case 'top':
          x1 = x2 = data.coordinate;
          y2 = y + +!mirror * height;
          y1 = y2 - sign * finalTickSize;
          ty = y1 - sign * tickMargin;
          tx = tickCoord;
          break;

        case 'left':
          y1 = y2 = data.coordinate;
          x2 = x + +!mirror * width;
          x1 = x2 - sign * finalTickSize;
          tx = x1 - sign * tickMargin;
          ty = tickCoord;
          break;

        case 'right':
          y1 = y2 = data.coordinate;
          x2 = x + +mirror * width;
          x1 = x2 + sign * finalTickSize;
          tx = x1 + sign * tickMargin;
          ty = tickCoord;
          break;

        default:
          x1 = x2 = data.coordinate;
          y2 = y + +mirror * height;
          y1 = y2 + sign * finalTickSize;
          ty = y1 + sign * tickMargin;
          tx = tickCoord;
          break;
      }

      return {
        line: {
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2
        },
        tick: {
          x: tx,
          y: ty
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor() {
      var _this$props3 = this.props,
          orientation = _this$props3.orientation,
          mirror = _this$props3.mirror;
      var textAnchor;

      switch (orientation) {
        case 'left':
          textAnchor = mirror ? 'start' : 'end';
          break;

        case 'right':
          textAnchor = mirror ? 'end' : 'start';
          break;

        default:
          textAnchor = 'middle';
          break;
      }

      return textAnchor;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function getTickVerticalAnchor() {
      var _this$props4 = this.props,
          orientation = _this$props4.orientation,
          mirror = _this$props4.mirror;
      var verticalAnchor = 'end';

      switch (orientation) {
        case 'left':
        case 'right':
          verticalAnchor = 'middle';
          break;

        case 'top':
          verticalAnchor = mirror ? 'start' : 'end';
          break;

        default:
          verticalAnchor = mirror ? 'end' : 'start';
          break;
      }

      return verticalAnchor;
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props5 = this.props,
          x = _this$props5.x,
          y = _this$props5.y,
          width = _this$props5.width,
          height = _this$props5.height,
          orientation = _this$props5.orientation,
          mirror = _this$props5.mirror,
          axisLine = _this$props5.axisLine;

      var props = _objectSpread$8(_objectSpread$8(_objectSpread$8({}, filterProps(this.props)), filterProps(axisLine)), {}, {
        fill: 'none'
      });

      if (orientation === 'top' || orientation === 'bottom') {
        var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
        props = _objectSpread$8(_objectSpread$8({}, props), {}, {
          x1: x,
          y1: y + needHeight * height,
          x2: x + width,
          y2: y + needHeight * height
        });
      } else {
        var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
        props = _objectSpread$8(_objectSpread$8({}, props), {}, {
          x1: x + needWidth * width,
          y1: y,
          x2: x + needWidth * width,
          y2: y + height
        });
      }

      return /*#__PURE__*/React$2.createElement("line", _extends$7({}, props, {
        className: classNames('recharts-cartesian-axis-line', get_1(axisLine, 'className'))
      }));
    }
  }, {
    key: "renderTicks",
    value:
    /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @return {ReactComponent} renderedTicks
     */
    function renderTicks(ticks) {
      var _this = this;

      var _this$props6 = this.props,
          tickLine = _this$props6.tickLine,
          stroke = _this$props6.stroke,
          tick = _this$props6.tick,
          tickFormatter = _this$props6.tickFormatter,
          unit = _this$props6.unit;
      var finalTicks = CartesianAxis.getTicks(_objectSpread$8(_objectSpread$8({}, this.props), {}, {
        ticks: ticks
      }));
      var textAnchor = this.getTickTextAnchor();
      var verticalAnchor = this.getTickVerticalAnchor();
      var axisProps = filterProps(this.props);
      var customTickProps = filterProps(tick);

      var tickLineProps = _objectSpread$8(_objectSpread$8({}, axisProps), {}, {
        fill: 'none'
      }, filterProps(tickLine));

      var items = finalTicks.map(function (entry, i) {
        var _this$getTickLineCoor = _this.getTickLineCoord(entry),
            lineCoord = _this$getTickLineCoor.line,
            tickCoord = _this$getTickLineCoor.tick;

        var tickProps = _objectSpread$8(_objectSpread$8(_objectSpread$8(_objectSpread$8({
          textAnchor: textAnchor,
          verticalAnchor: verticalAnchor
        }, axisProps), {}, {
          stroke: 'none',
          fill: stroke
        }, customTickProps), tickCoord), {}, {
          index: i,
          payload: entry,
          visibleTicksCount: finalTicks.length,
          tickFormatter: tickFormatter
        });

        return /*#__PURE__*/React$2.createElement(Layer, _extends$7({
          className: "recharts-cartesian-axis-tick",
          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key

        }, adaptEventsOfChild(_this.props, entry, i)), tickLine && /*#__PURE__*/React$2.createElement("line", _extends$7({}, tickLineProps, lineCoord, {
          className: classNames('recharts-cartesian-axis-tick-line', get_1(tickLine, 'className'))
        })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat(isFunction_1(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
      });
      return /*#__PURE__*/React$2.createElement("g", {
        className: "recharts-cartesian-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          axisLine = _this$props7.axisLine,
          width = _this$props7.width,
          height = _this$props7.height,
          ticksGenerator = _this$props7.ticksGenerator,
          className = _this$props7.className,
          hide = _this$props7.hide;

      if (hide) {
        return null;
      }

      var _this$props8 = this.props,
          ticks = _this$props8.ticks,
          noTicksProps = _objectWithoutProperties$5(_this$props8, ["ticks"]);

      var finalTicks = ticks;

      if (isFunction_1(ticksGenerator)) {
        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
      }

      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
        return null;
      }

      return /*#__PURE__*/React$2.createElement(Layer, {
        className: classNames('recharts-cartesian-axis', className)
      }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks), Label.renderCallByParent(this.props));
    }
  }], [{
    key: "getTicks",
    value: // todo Array<Tick>
    function getTicks(props) {
      var tick = props.tick,
          ticks = props.ticks,
          viewBox = props.viewBox,
          minTickGap = props.minTickGap,
          orientation = props.orientation,
          interval = props.interval,
          tickFormatter = props.tickFormatter,
          unit = props.unit;

      if (!ticks || !ticks.length || !tick) {
        return [];
      }

      if (isNumber$1(interval) || Global.isSsr) {
        return CartesianAxis.getNumberIntervalTicks(ticks, typeof interval === 'number' && isNumber$1(interval) ? interval : 0);
      }

      if (interval === 'preserveStartEnd') {
        return CartesianAxis.getTicksStart({
          ticks: ticks,
          tickFormatter: tickFormatter,
          viewBox: viewBox,
          orientation: orientation,
          minTickGap: minTickGap,
          unit: unit
        }, true);
      }

      if (interval === 'preserveStart') {
        return CartesianAxis.getTicksStart({
          ticks: ticks,
          tickFormatter: tickFormatter,
          viewBox: viewBox,
          orientation: orientation,
          minTickGap: minTickGap,
          unit: unit
        });
      }

      return CartesianAxis.getTicksEnd({
        ticks: ticks,
        tickFormatter: tickFormatter,
        viewBox: viewBox,
        orientation: orientation,
        minTickGap: minTickGap,
        unit: unit
      });
    }
  }, {
    key: "getNumberIntervalTicks",
    value: function getNumberIntervalTicks(ticks, interval) {
      return ticks.filter(function (entry, i) {
        return i % (interval + 1) === 0;
      });
    }
  }, {
    key: "getTicksStart",
    value: function getTicksStart(_ref2, preserveEnd) {
      var ticks = _ref2.ticks,
          tickFormatter = _ref2.tickFormatter,
          viewBox = _ref2.viewBox,
          orientation = _ref2.orientation,
          minTickGap = _ref2.minTickGap,
          unit = _ref2.unit;
      var x = viewBox.x,
          y = viewBox.y,
          width = viewBox.width,
          height = viewBox.height;
      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
      var result = (ticks || []).slice(); // we need add the width of 'unit' only when sizeKey === 'width'

      var unitSize = unit && sizeKey === 'width' ? getStringSize(unit)[sizeKey] : 0;
      var len = result.length;
      var sign = len >= 2 ? mathSign(result[1].coordinate - result[0].coordinate) : 1;
      var start, end;

      if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
      } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
      }

      if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailContent = isFunction_1(tickFormatter) ? tickFormatter(tail.value, len - 1) : tail.value;
        var tailSize = getStringSize(tailContent)[sizeKey] + unitSize;
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = _objectSpread$8(_objectSpread$8({}, tail), {}, {
          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;

        if (isTailShow) {
          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
          result[len - 1] = _objectSpread$8(_objectSpread$8({}, tail), {}, {
            isShow: true
          });
        }
      }

      var count = preserveEnd ? len - 1 : len;

      for (var i = 0; i < count; i++) {
        var entry = result[i];
        var content = isFunction_1(tickFormatter) ? tickFormatter(entry.value, i) : entry.value;
        var size = getStringSize(content)[sizeKey] + unitSize;

        if (i === 0) {
          var gap = sign * (entry.coordinate - sign * size / 2 - start);
          result[i] = entry = _objectSpread$8(_objectSpread$8({}, entry), {}, {
            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
          });
        } else {
          result[i] = entry = _objectSpread$8(_objectSpread$8({}, entry), {}, {
            tickCoord: entry.coordinate
          });
        }

        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;

        if (isShow) {
          start = entry.tickCoord + sign * (size / 2 + minTickGap);
          result[i] = _objectSpread$8(_objectSpread$8({}, entry), {}, {
            isShow: true
          });
        }
      }

      return result.filter(function (entry) {
        return entry.isShow;
      });
    }
  }, {
    key: "getTicksEnd",
    value: function getTicksEnd(_ref3) {
      var ticks = _ref3.ticks,
          tickFormatter = _ref3.tickFormatter,
          viewBox = _ref3.viewBox,
          orientation = _ref3.orientation,
          minTickGap = _ref3.minTickGap,
          unit = _ref3.unit;
      var x = viewBox.x,
          y = viewBox.y,
          width = viewBox.width,
          height = viewBox.height;
      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height'; // we need add the width of 'unit' only when sizeKey === 'width'

      var unitSize = unit && sizeKey === 'width' ? getStringSize(unit)[sizeKey] : 0;
      var result = (ticks || []).slice();
      var len = result.length;
      var sign = len >= 2 ? mathSign(result[1].coordinate - result[0].coordinate) : 1;
      var start, end;

      if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
      } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
      }

      for (var i = len - 1; i >= 0; i--) {
        var entry = result[i];
        var content = isFunction_1(tickFormatter) ? tickFormatter(entry.value, len - i - 1) : entry.value;
        var size = getStringSize(content)[sizeKey] + unitSize;

        if (i === len - 1) {
          var gap = sign * (entry.coordinate + sign * size / 2 - end);
          result[i] = entry = _objectSpread$8(_objectSpread$8({}, entry), {}, {
            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
          });
        } else {
          result[i] = entry = _objectSpread$8(_objectSpread$8({}, entry), {}, {
            tickCoord: entry.coordinate
          });
        }

        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;

        if (isShow) {
          end = entry.tickCoord - sign * (size / 2 + minTickGap);
          result[i] = _objectSpread$8(_objectSpread$8({}, entry), {}, {
            isShow: true
          });
        }
      }

      return result.filter(function (entry) {
        return entry.isShow;
      });
    }
  }, {
    key: "renderTickItem",
    value: function renderTickItem(option, props, value) {
      var tickItem;

      if ( /*#__PURE__*/React$2.isValidElement(option)) {
        tickItem = /*#__PURE__*/React$2.cloneElement(option, props);
      } else if (isFunction_1(option)) {
        tickItem = option(props);
      } else {
        tickItem = /*#__PURE__*/React$2.createElement(Text, _extends$7({}, props, {
          className: "recharts-cartesian-axis-tick-value"
        }), value);
      }

      return tickItem;
    }
  }]);

  return CartesianAxis;
}(Component);
CartesianAxis.displayName = 'CartesianAxis';
CartesianAxis.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: 'bottom',
  // The ticks
  ticks: [],
  stroke: '#666',
  tickLine: true,
  axisLine: true,
  tick: true,
  mirror: false,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: 'preserveEnd'
};

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$4(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ErrorBar(props) {
  var offset = props.offset,
      layout = props.layout,
      width = props.width,
      dataKey = props.dataKey,
      data = props.data,
      dataPointFormatter = props.dataPointFormatter,
      xAxis = props.xAxis,
      yAxis = props.yAxis,
      others = _objectWithoutProperties$4(props, ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"]);

  var svgProps = filterProps(others);
  var errorBars = data.map(function (entry, i) {
    var _dataPointFormatter = dataPointFormatter(entry, dataKey),
        x = _dataPointFormatter.x,
        y = _dataPointFormatter.y,
        value = _dataPointFormatter.value,
        errorVal = _dataPointFormatter.errorVal;

    if (!errorVal) {
      return null;
    }

    var lineCoordinates = [];
    var lowBound, highBound;

    if (Array.isArray(errorVal)) {
      var _errorVal = _slicedToArray$1(errorVal, 2);

      lowBound = _errorVal[0];
      highBound = _errorVal[1];
    } else {
      lowBound = highBound = errorVal;
    }

    if (layout === 'vertical') {
      // error bar for horizontal charts, the y is fixed, x is a range value
      var scale = xAxis.scale;
      var yMid = y + offset;
      var yMin = yMid + width;
      var yMax = yMid - width;
      var xMin = scale(value - lowBound);
      var xMax = scale(value + highBound); // the right line of |--|

      lineCoordinates.push({
        x1: xMax,
        y1: yMin,
        x2: xMax,
        y2: yMax
      }); // the middle line of |--|

      lineCoordinates.push({
        x1: xMin,
        y1: yMid,
        x2: xMax,
        y2: yMid
      }); // the left line of |--|

      lineCoordinates.push({
        x1: xMin,
        y1: yMin,
        x2: xMin,
        y2: yMax
      });
    } else if (layout === 'horizontal') {
      // error bar for horizontal charts, the x is fixed, y is a range value
      var _scale = yAxis.scale;
      var xMid = x + offset;

      var _xMin = xMid - width;

      var _xMax = xMid + width;

      var _yMin = _scale(value - lowBound);

      var _yMax = _scale(value + highBound); // the top line


      lineCoordinates.push({
        x1: _xMin,
        y1: _yMax,
        x2: _xMax,
        y2: _yMax
      }); // the middle line

      lineCoordinates.push({
        x1: xMid,
        y1: _yMin,
        x2: xMid,
        y2: _yMax
      }); // the bottom line

      lineCoordinates.push({
        x1: _xMin,
        y1: _yMin,
        x2: _xMax,
        y2: _yMin
      });
    }

    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React$2.createElement(Layer, _extends$6({
        className: "recharts-errorBar",
        key: "bar-".concat(i)
      }, svgProps), lineCoordinates.map(function (coordinates, index) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          React$2.createElement("line", _extends$6({}, coordinates, {
            key: "line-".concat(index)
          }))
        );
      }))
    );
  });
  return /*#__PURE__*/React$2.createElement(Layer, {
    className: "recharts-errorBars"
  }, errorBars);
}
ErrorBar.defaultProps = {
  stroke: 'black',
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: 'horizontal'
};
ErrorBar.displayName = 'ErrorBar';

function _typeof$a(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$a = function _typeof(obj) { return typeof obj; }; } else { _typeof$a = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$a(obj); }

function _objectWithoutProperties$3(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$3(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(Object(source), true).forEach(function (key) { _defineProperty$8(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1(arr); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$9(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$9(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$9(Constructor.prototype, protoProps); if (staticProps) _defineProperties$9(Constructor, staticProps); return Constructor; }

function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$7(subClass, superClass); }

function _setPrototypeOf$7(o, p) { _setPrototypeOf$7 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$7(o, p); }

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf$7(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$7(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$7(this, result); }; }

function _possibleConstructorReturn$7(self, call) { if (call && (_typeof$a(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$7(self); }

function _assertThisInitialized$7(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$7(o) { _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$7(o); }
var Line = /*#__PURE__*/function (_PureComponent) {
  _inherits$7(Line, _PureComponent);

  var _super = _createSuper$6(Line);

  function Line() {
    var _this;

    _classCallCheck$8(this, Line);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.mainCurve = void 0;
    _this.state = {
      isAnimationFinished: true,
      totalLength: 0
    };

    _this.getStrokeDasharray = function (length, totalLength, lines) {
      var lineLength = lines.reduce(function (pre, next) {
        return pre + next;
      });
      var count = Math.floor(length / lineLength);
      var remainLength = length % lineLength;
      var restLength = totalLength - length;
      var remainLines = [];

      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
        if (sum + lines[i] > remainLength) {
          remainLines = [].concat(_toConsumableArray$1(lines.slice(0, i)), [remainLength - sum]);
          break;
        }
      }

      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
      return [].concat(_toConsumableArray$1(Line.repeat(lines, count)), _toConsumableArray$1(remainLines), emptyLines).map(function (line) {
        return "".concat(line, "px");
      }).join(', ');
    };

    _this.id = uniqueId('recharts-line-');

    _this.pathRef = function (node) {
      _this.mainCurve = node;
    };

    _this.handleAnimationEnd = function () {
      _this.setState({
        isAnimationFinished: true
      });

      if (_this.props.onAnimationEnd) {
        _this.props.onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      _this.setState({
        isAnimationFinished: false
      });

      if (_this.props.onAnimationStart) {
        _this.props.onAnimationStart();
      }
    };

    return _this;
  }

  _createClass$9(Line, [{
    key: "componentDidMount",
    value:
    /* eslint-disable  react/no-did-mount-set-state */
    function componentDidMount() {
      if (!this.props.isAnimationActive) {
        return;
      }

      var totalLength = this.getTotalLength();
      this.setState({
        totalLength: totalLength
      });
    }
  }, {
    key: "getTotalLength",
    value: function getTotalLength() {
      var curveDom = this.mainCurve;

      try {
        return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
      } catch (err) {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar() {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _this$props = this.props,
          points = _this$props.points,
          xAxis = _this$props.xAxis,
          yAxis = _this$props.yAxis,
          layout = _this$props.layout,
          children = _this$props.children;
      var errorBarItems = findAllByType(children, ErrorBar.displayName);

      if (!errorBarItems) {
        return null;
      }

      function dataPointFormatter(dataPoint, dataKey) {
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: dataPoint.value,
          errorVal: getValueByDataKey(dataPoint.payload, dataKey)
        };
      }

      return errorBarItems.map(function (item, i) {
        return /*#__PURE__*/React$2.cloneElement(item, {
          // eslint-disable-next-line react/no-array-index-key
          key: "bar-".concat(i),
          data: points,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: layout,
          dataPointFormatter: dataPointFormatter
        });
      });
    }
  }, {
    key: "renderDots",
    value: function renderDots(needClip, clipPathId) {
      var isAnimationActive = this.props.isAnimationActive;

      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _this$props2 = this.props,
          dot = _this$props2.dot,
          points = _this$props2.points,
          dataKey = _this$props2.dataKey;
      var lineProps = filterProps(this.props);
      var customDotProps = filterProps(dot, true);
      var dots = points.map(function (entry, i) {
        var dotProps = _objectSpread$7(_objectSpread$7(_objectSpread$7({
          key: "dot-".concat(i),
          r: 3
        }, lineProps), customDotProps), {}, {
          value: entry.value,
          dataKey: dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i,
          payload: entry.payload
        });

        return Line.renderDotItem(dot, dotProps);
      });
      var dotsProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      };
      return /*#__PURE__*/React$2.createElement(Layer, _extends$5({
        className: "recharts-line-dots",
        key: "dots"
      }, dotsProps), dots);
    }
  }, {
    key: "renderCurveStatically",
    value: function renderCurveStatically(points, needClip, clipPathId, props) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _this$props3 = this.props,
          type = _this$props3.type,
          layout = _this$props3.layout,
          connectNulls = _this$props3.connectNulls;
          _this$props3.ref;
          var others = _objectWithoutProperties$3(_this$props3, ["type", "layout", "connectNulls", "ref"]);

      var curveProps = _objectSpread$7(_objectSpread$7(_objectSpread$7({}, filterProps(others, true)), {}, {
        fill: 'none',
        className: 'recharts-line-curve',
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
        points: points
      }, props), {}, {
        type: type,
        layout: layout,
        connectNulls: connectNulls
      });

      return /*#__PURE__*/React$2.createElement(Curve, _extends$5({}, curveProps, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function renderCurveWithAnimation(needClip, clipPathId) {
      var _this2 = this;

      var _this$props4 = this.props,
          points = _this$props4.points,
          strokeDasharray = _this$props4.strokeDasharray,
          isAnimationActive = _this$props4.isAnimationActive,
          animationBegin = _this$props4.animationBegin,
          animationDuration = _this$props4.animationDuration,
          animationEasing = _this$props4.animationEasing,
          animationId = _this$props4.animationId,
          animateNewValues = _this$props4.animateNewValues,
          width = _this$props4.width,
          height = _this$props4.height;
      var _this$state = this.state,
          prevPoints = _this$state.prevPoints,
          totalLength = _this$state.totalLength;
      return /*#__PURE__*/React$2.createElement(Animate, {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;

        if (prevPoints) {
          var prevPointsDiffFactor = prevPoints.length / points.length;
          var stepData = points.map(function (entry, index) {
            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);

            if (prevPoints[prevPointIndex]) {
              var prev = prevPoints[prevPointIndex];
              var interpolatorX = interpolateNumber$2(prev.x, entry.x);
              var interpolatorY = interpolateNumber$2(prev.y, entry.y);
              return _objectSpread$7(_objectSpread$7({}, entry), {}, {
                x: interpolatorX(t),
                y: interpolatorY(t)
              });
            } // magic number of faking previous x and y location


            if (animateNewValues) {
              var _interpolatorX = interpolateNumber$2(width * 2, entry.x);

              var _interpolatorY = interpolateNumber$2(height / 2, entry.y);

              return _objectSpread$7(_objectSpread$7({}, entry), {}, {
                x: _interpolatorX(t),
                y: _interpolatorY(t)
              });
            }

            return _objectSpread$7(_objectSpread$7({}, entry), {}, {
              x: entry.x,
              y: entry.y
            });
          });
          return _this2.renderCurveStatically(stepData, needClip, clipPathId);
        }

        var interpolator = interpolateNumber$2(0, totalLength);
        var curLength = interpolator(t);
        var currentStrokeDasharray;

        if (strokeDasharray) {
          var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function (num) {
            return parseFloat(num);
          });
          currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
        } else {
          currentStrokeDasharray = "".concat(curLength, "px ").concat(totalLength - curLength, "px");
        }

        return _this2.renderCurveStatically(points, needClip, clipPathId, {
          strokeDasharray: currentStrokeDasharray
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function renderCurve(needClip, clipPathId) {
      var _this$props5 = this.props,
          points = _this$props5.points,
          isAnimationActive = _this$props5.isAnimationActive;
      var _this$state2 = this.state,
          prevPoints = _this$state2.prevPoints,
          totalLength = _this$state2.totalLength;

      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !isEqual_1(prevPoints, points))) {
        return this.renderCurveWithAnimation(needClip, clipPathId);
      }

      return this.renderCurveStatically(points, needClip, clipPathId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          hide = _this$props6.hide,
          dot = _this$props6.dot,
          points = _this$props6.points,
          className = _this$props6.className,
          xAxis = _this$props6.xAxis,
          yAxis = _this$props6.yAxis,
          top = _this$props6.top,
          left = _this$props6.left,
          width = _this$props6.width,
          height = _this$props6.height,
          isAnimationActive = _this$props6.isAnimationActive,
          id = _this$props6.id;

      if (hide || !points || !points.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var hasSinglePoint = points.length === 1;
      var layerClass = classNames('recharts-line', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = isNil_1(id) ? this.id : id;
      return /*#__PURE__*/React$2.createElement(Layer, {
        className: layerClass
      }, needClip ? /*#__PURE__*/React$2.createElement("defs", null, /*#__PURE__*/React$2.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, /*#__PURE__*/React$2.createElement("rect", {
        x: left,
        y: top,
        width: width,
        height: height
      }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(), (hasSinglePoint || dot) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && LabelList.renderCallByParent(this.props, points));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curPoints: nextProps.points,
          prevPoints: prevState.curPoints
        };
      }

      if (nextProps.points !== prevState.curPoints) {
        return {
          curPoints: nextProps.points
        };
      }

      return null;
    }
  }, {
    key: "repeat",
    value: function repeat(lines, count) {
      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray$1(lines), [0]) : lines;
      var result = [];

      for (var i = 0; i < count; ++i) {
        result = [].concat(_toConsumableArray$1(result), _toConsumableArray$1(linesUnit));
      }

      return result;
    }
  }, {
    key: "renderDotItem",
    value: function renderDotItem(option, props) {
      var dotItem;

      if ( /*#__PURE__*/React$2.isValidElement(option)) {
        dotItem = /*#__PURE__*/React$2.cloneElement(option, props);
      } else if (isFunction_1(option)) {
        dotItem = option(props);
      } else {
        var className = classNames('recharts-line-dot', option ? option.className : '');
        dotItem = /*#__PURE__*/React$2.createElement(Dot, _extends$5({}, props, {
          className: className
        }));
      }

      return dotItem;
    }
  }]);

  return Line;
}(PureComponent);
Line.displayName = 'Line';
Line.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: false,
  activeDot: true,
  dot: true,
  legendType: 'line',
  stroke: '#3182bd',
  strokeWidth: 1,
  fill: '#fff',
  points: [],
  isAnimationActive: !Global.isSsr,
  animateNewValues: true,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
  hide: false
};

Line.getComposedData = function (_ref2) {
  var props = _ref2.props,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      xAxisTicks = _ref2.xAxisTicks,
      yAxisTicks = _ref2.yAxisTicks,
      dataKey = _ref2.dataKey,
      bandSize = _ref2.bandSize,
      displayedData = _ref2.displayedData,
      offset = _ref2.offset;
  var layout = props.layout;
  var points = displayedData.map(function (entry, index) {
    var value = getValueByDataKey(entry, dataKey);

    if (layout === 'horizontal') {
      return {
        x: getCateCoordinateOfLine({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize: bandSize,
          entry: entry,
          index: index
        }),
        y: isNil_1(value) ? null : yAxis.scale(value),
        value: value,
        payload: entry
      };
    }

    return {
      x: isNil_1(value) ? null : xAxis.scale(value),
      y: getCateCoordinateOfLine({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        entry: entry,
        index: index
      }),
      value: value,
      payload: entry
    };
  });
  return _objectSpread$7({
    points: points,
    layout: layout
  }, offset);
};

/**
 * @fileOverview X Axis
 */

/** Define of XAxis props */
var XAxis = function XAxis() {
  return null;
};
XAxis.displayName = 'XAxis';
XAxis.defaultProps = {
  allowDecimals: true,
  hide: false,
  orientation: 'bottom',
  width: 0,
  height: 30,
  mirror: false,
  xAxisId: 0,
  tickCount: 5,
  type: 'category',
  domain: [0, 'auto'],
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false,
  allowDuplicatedCategory: true
};

/**
 * @fileOverview Y Axis
 */
var YAxis = function YAxis() {
  return null;
};
YAxis.displayName = 'YAxis';
YAxis.defaultProps = {
  allowDuplicatedCategory: true,
  allowDecimals: true,
  hide: false,
  orientation: 'left',
  width: 60,
  height: 0,
  mirror: false,
  yAxisId: 0,
  tickCount: 5,
  type: 'number',
  domain: [0, 'auto'],
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false
};

var baseIteratee$1 = _baseIteratee,
    isArrayLike = isArrayLike_1,
    keys$1 = keys_1;

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind$1(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee$1(predicate);
      collection = keys$1(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

var _createFind = createFind$1;

var toFinite = toFinite_1;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger$1(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger$1;

var baseFindIndex = _baseFindIndex,
    baseIteratee = _baseIteratee,
    toInteger = toInteger_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex$1(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax$1(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate), index);
}

var findIndex_1 = findIndex$1;

var createFind = _createFind,
    findIndex = findIndex_1;

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find$1 = createFind(findIndex);

var find_1 = find$1;

var debounce$1 = debounce_1,
    isObject$3 = isObject_1;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  if (isObject$3(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce$1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var throttle_1 = throttle;

var baseGetTag = _baseGetTag,
    isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike$2(value) && baseGetTag(value) == boolTag);
}

var isBoolean_1 = isBoolean;

var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
  var lines = findAllByType(children, ReferenceLine.displayName);
  var dots = findAllByType(children, ReferenceDot.displayName);
  var elements = lines.concat(dots);
  var areas = findAllByType(children, ReferenceArea.displayName);
  var idKey = "".concat(axisType, "Id");
  var valueKey = axisType[0];
  var finalDomain = domain;

  if (elements.length) {
    finalDomain = elements.reduce(function (result, el) {
      if (el.props[idKey] === axisId && ifOverflowMatches(el.props, 'extendDomain') && isNumber$1(el.props[valueKey])) {
        var value = el.props[valueKey];
        return [Math.min(result[0], value), Math.max(result[1], value)];
      }

      return result;
    }, finalDomain);
  }

  if (areas.length) {
    var key1 = "".concat(valueKey, "1");
    var key2 = "".concat(valueKey, "2");
    finalDomain = areas.reduce(function (result, el) {
      if (el.props[idKey] === axisId && ifOverflowMatches(el.props, 'extendDomain') && isNumber$1(el.props[key1]) && isNumber$1(el.props[key2])) {
        var value1 = el.props[key1];
        var value2 = el.props[key2];
        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
      }

      return result;
    }, finalDomain);
  }

  if (specifiedTicks && specifiedTicks.length) {
    finalDomain = specifiedTicks.reduce(function (result, tick) {
      if (isNumber$1(tick)) {
        return [Math.min(result[0], tick), Math.max(result[1], tick)];
      }

      return result;
    }, finalDomain);
  }

  return finalDomain;
};

var eventemitter3 = {exports: {}};

(function (module) {

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
{
  module.exports = EventEmitter;
}
}(eventemitter3));

var EventEmitter = eventemitter3.exports;

var eventCenter = new EventEmitter();

if (eventCenter.setMaxListeners) {
  eventCenter.setMaxListeners(10);
}
var SYNC_EVENT = 'recharts.syncMouseEvents'; // eslint-disable-next-line no-redeclare

function _typeof$9(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$9 = function _typeof(obj) { return typeof obj; }; } else { _typeof$9 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$9(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$8(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$8(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$8(Constructor.prototype, protoProps); if (staticProps) _defineProperties$8(Constructor, staticProps); return Constructor; }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$6(subClass, superClass); }

function _setPrototypeOf$6(o, p) { _setPrototypeOf$6 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$6(o, p); }

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf$6(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$6(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$6(this, result); }; }

function _possibleConstructorReturn$6(self, call) { if (call && (_typeof$9(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$6(self); }

function _assertThisInitialized$6(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$6(o) { _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$6(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty$7(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ORIENT_MAP = {
  xAxis: ['bottom', 'top'],
  yAxis: ['left', 'right']
};
var originCoordinate = {
  x: 0,
  y: 0
}; // use legacy isFinite only if there is a problem (aka IE)
// eslint-disable-next-line no-restricted-globals

var isFinit = Number.isFinite ? Number.isFinite : isFinite;
var defer = // eslint-disable-next-line no-nested-ternary
typeof requestAnimationFrame === 'function' ? requestAnimationFrame : typeof setImmediate === 'function' ? setImmediate : setTimeout;
var deferClear = // eslint-disable-next-line no-nested-ternary
typeof cancelAnimationFrame === 'function' ? cancelAnimationFrame : typeof clearImmediate === 'function' ? clearImmediate : clearTimeout;

var calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
  if (layout === 'horizontal') {
    return rangeObj.x;
  }

  if (layout === 'vertical') {
    return rangeObj.y;
  }

  if (layout === 'centric') {
    return rangeObj.angle;
  }

  return rangeObj.radius;
};

var getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
  var entry = tooltipTicks.find(function (tick) {
    return tick && tick.index === activeIndex;
  });

  if (entry) {
    if (layout === 'horizontal') {
      return {
        x: entry.coordinate,
        y: rangeObj.y
      };
    }

    if (layout === 'vertical') {
      return {
        x: rangeObj.x,
        y: entry.coordinate
      };
    }

    if (layout === 'centric') {
      var _angle = entry.coordinate;
      var _radius = rangeObj.radius;
      return _objectSpread$6(_objectSpread$6(_objectSpread$6({}, rangeObj), polarToCartesian(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
        angle: _angle,
        radius: _radius
      });
    }

    var radius = entry.coordinate;
    var angle = rangeObj.angle;
    return _objectSpread$6(_objectSpread$6(_objectSpread$6({}, rangeObj), polarToCartesian(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
      angle: angle,
      radius: radius
    });
  }

  return originCoordinate;
};

var getDisplayedData = function getDisplayedData(data, _ref, item) {
  var graphicalItems = _ref.graphicalItems,
      dataStartIndex = _ref.dataStartIndex,
      dataEndIndex = _ref.dataEndIndex;
  var itemsData = (graphicalItems || []).reduce(function (result, child) {
    var itemData = child.props.data;

    if (itemData && itemData.length) {
      return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
    }

    return result;
  }, []);

  if (itemsData && itemsData.length > 0) {
    return itemsData;
  }

  if (item && item.props && item.props.data && item.props.data.length > 0) {
    return item.props.data;
  }

  if (data && data.length && isNumber$1(dataStartIndex) && isNumber$1(dataEndIndex)) {
    return data.slice(dataStartIndex, dataEndIndex + 1);
  }

  return [];
};
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */


var getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
  var graphicalItems = state.graphicalItems,
      tooltipAxis = state.tooltipAxis;
  var displayedData = getDisplayedData(chartData, state);

  if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
    return null;
  } // get data by activeIndex when the axis don't allow duplicated category


  return graphicalItems.reduce(function (result, child) {
    var hide = child.props.hide;

    if (hide) {
      return result;
    }

    var data = child.props.data;
    var payload;

    if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
      // graphic child has data props
      var entries = data === undefined ? displayedData : data;
      payload = findEntryInArray(entries, tooltipAxis.dataKey, activeLabel);
    } else {
      payload = data && data[activeIndex] || displayedData[activeIndex];
    }

    if (!payload) {
      return result;
    }

    return [].concat(_toConsumableArray(result), [getTooltipItem(child, payload)]);
  }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */


var getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
  var rangeData = rangeObj || {
    x: state.chartX,
    y: state.chartY
  };
  var pos = calculateTooltipPos(rangeData, layout);
  var ticks = state.orderedTooltipTicks,
      axis = state.tooltipAxis,
      tooltipTicks = state.tooltipTicks;
  var activeIndex = calculateActiveTickIndex(pos, ticks, tooltipTicks, axis);

  if (activeIndex >= 0 && tooltipTicks) {
    var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
    var activePayload = getTooltipContent(state, chartData, activeIndex, activeLabel);
    var activeCoordinate = getActiveCoordinate(layout, ticks, activeIndex, rangeData);
    return {
      activeTooltipIndex: activeIndex,
      activeLabel: activeLabel,
      activePayload: activePayload,
      activeCoordinate: activeCoordinate
    };
  }

  return null;
};
/**
 * Get the configuration of axis by the options of axis instance
 * @param  {Object} props         Latest props
 * @param {Array}  axes           The instance of axes
 * @param  {Array} graphicalItems The instances of item
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}      Configuration
 */


var getAxisMapByAxes = function getAxisMapByAxes(props, _ref2) {
  var axes = _ref2.axes,
      graphicalItems = _ref2.graphicalItems,
      axisType = _ref2.axisType,
      axisIdKey = _ref2.axisIdKey,
      stackGroups = _ref2.stackGroups,
      dataStartIndex = _ref2.dataStartIndex,
      dataEndIndex = _ref2.dataEndIndex;
  var layout = props.layout,
      children = props.children,
      stackOffset = props.stackOffset;
  var isCategorical = isCategoricalAxis(layout, axisType); // Eliminate duplicated axes

  var axisMap = axes.reduce(function (result, child) {
    var _child$props = child.props,
        type = _child$props.type,
        dataKey = _child$props.dataKey,
        allowDataOverflow = _child$props.allowDataOverflow,
        allowDuplicatedCategory = _child$props.allowDuplicatedCategory,
        scale = _child$props.scale,
        ticks = _child$props.ticks;
    var axisId = child.props[axisIdKey];
    var displayedData = getDisplayedData(props.data, {
      graphicalItems: graphicalItems.filter(function (item) {
        return item.props[axisIdKey] === axisId;
      }),
      dataStartIndex: dataStartIndex,
      dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;

    if (!result[axisId]) {
      var domain, duplicateDomain, categoricalDomain;

      if (dataKey) {
        // has dataKey in <Axis />
        domain = getDomainOfDataByKey(displayedData, dataKey, type);

        if (type === 'category' && isCategorical) {
          // the field type is category data and this axis is catrgorical axis
          var duplicate = hasDuplicate(domain);

          if (allowDuplicatedCategory && duplicate) {
            duplicateDomain = domain; // When category axis has duplicated text, serial numbers are used to generate scale

            domain = range_1(0, len);
          } else if (!allowDuplicatedCategory) {
            // remove duplicated category
            domain = parseDomainOfCategoryAxis(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
              return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
            }, []);
          }
        } else if (type === 'category') {
          // the field type is category data and this axis is numerical axis
          if (!allowDuplicatedCategory) {
            domain = parseDomainOfCategoryAxis(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
              return finalDomain.indexOf(entry) >= 0 || entry === '' || isNil_1(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
            }, []);
          } else {
            // eliminate undefined or null or empty string
            domain = domain.filter(function (entry) {
              return entry !== '' && !isNil_1(entry);
            });
          }
        } else if (type === 'number') {
          // the field type is numerical
          var errorBarsDomain = parseErrorBarsOfAxis(displayedData, graphicalItems.filter(function (item) {
            return item.props[axisIdKey] === axisId && !item.props.hide;
          }), dataKey, axisType);

          if (errorBarsDomain) {
            domain = errorBarsDomain;
          }
        }

        if (isCategorical && (type === 'number' || scale !== 'auto')) {
          categoricalDomain = getDomainOfDataByKey(displayedData, dataKey, 'category');
        }
      } else if (isCategorical) {
        // the axis is a categorical axis
        domain = range_1(0, len);
      } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
        // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
        domain = stackOffset === 'expand' ? [0, 1] : getDomainOfStackGroups(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
      } else {
        domain = getDomainOfItemsWithSameAxis(displayedData, graphicalItems.filter(function (item) {
          return item.props[axisIdKey] === axisId && !item.props.hide;
        }), type, true);
      }

      if (type === 'number') {
        // To detect wether there is any reference lines whose props alwaysShow is true
        domain = detectReferenceElementsDomain(children, domain, axisId, axisType, ticks);

        if (child.props.domain) {
          domain = parseSpecifiedDomain(child.props.domain, domain, allowDataOverflow);
        }
      } else if (type === 'category' && child.props.domain) {
        var axisDomain = child.props.domain;
        var isDomainValidate = domain.every(function (entry) {
          return axisDomain.indexOf(entry) >= 0;
        });

        if (isDomainValidate) {
          domain = axisDomain;
        }
      }

      return _objectSpread$6(_objectSpread$6({}, result), {}, _defineProperty$7({}, axisId, _objectSpread$6(_objectSpread$6({}, child.props), {}, {
        axisType: axisType,
        domain: domain,
        categoricalDomain: categoricalDomain,
        duplicateDomain: duplicateDomain,
        originalDomain: child.props.domain,
        isCategorical: isCategorical,
        layout: layout
      })));
    }

    return result;
  }, {});
  return axisMap;
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */


var getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
  var graphicalItems = _ref3.graphicalItems,
      Axis = _ref3.Axis,
      axisType = _ref3.axisType,
      axisIdKey = _ref3.axisIdKey,
      stackGroups = _ref3.stackGroups,
      dataStartIndex = _ref3.dataStartIndex,
      dataEndIndex = _ref3.dataEndIndex;
  var layout = props.layout,
      children = props.children;
  var displayedData = getDisplayedData(props.data, {
    graphicalItems: graphicalItems,
    dataStartIndex: dataStartIndex,
    dataEndIndex: dataEndIndex
  });
  var len = displayedData.length;
  var isCategorical = isCategoricalAxis(layout, axisType);
  var index = -1; // The default type of x-axis is category axis,
  // The default contents of x-axis is the serial numbers of data
  // The default type of y-axis is number axis
  // The default contents of y-axis is the domain of data

  var axisMap = graphicalItems.reduce(function (result, child) {
    var axisId = child.props[axisIdKey];

    if (!result[axisId]) {
      index++;
      var domain;

      if (isCategorical) {
        domain = range_1(0, len);
      } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
        domain = getDomainOfStackGroups(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
        domain = detectReferenceElementsDomain(children, domain, axisId, axisType);
      } else {
        domain = parseSpecifiedDomain(Axis.defaultProps.domain, getDomainOfItemsWithSameAxis(displayedData, graphicalItems.filter(function (item) {
          return item.props[axisIdKey] === axisId && !item.props.hide;
        }), 'number'), Axis.defaultProps.allowDataOverflow);
        domain = detectReferenceElementsDomain(children, domain, axisId, axisType);
      }

      return _objectSpread$6(_objectSpread$6({}, result), {}, _defineProperty$7({}, axisId, _objectSpread$6(_objectSpread$6({
        axisType: axisType
      }, Axis.defaultProps), {}, {
        hide: true,
        orientation: get_1(ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
        domain: domain,
        originalDomain: Axis.defaultProps.domain,
        isCategorical: isCategorical,
        layout: layout // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',

      })));
    }

    return result;
  }, {});
  return axisMap;
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */


var getAxisMap = function getAxisMap(props, _ref4) {
  var _ref4$axisType = _ref4.axisType,
      axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType,
      AxisComp = _ref4.AxisComp,
      graphicalItems = _ref4.graphicalItems,
      stackGroups = _ref4.stackGroups,
      dataStartIndex = _ref4.dataStartIndex,
      dataEndIndex = _ref4.dataEndIndex;
  var children = props.children;
  var axisIdKey = "".concat(axisType, "Id"); // Get all the instance of Axis

  var axes = findAllByType(children, AxisComp);
  var axisMap = {};

  if (axes && axes.length) {
    axisMap = getAxisMapByAxes(props, {
      axes: axes,
      graphicalItems: graphicalItems,
      axisType: axisType,
      axisIdKey: axisIdKey,
      stackGroups: stackGroups,
      dataStartIndex: dataStartIndex,
      dataEndIndex: dataEndIndex
    });
  } else if (graphicalItems && graphicalItems.length) {
    axisMap = getAxisMapByItems(props, {
      Axis: AxisComp,
      graphicalItems: graphicalItems,
      axisType: axisType,
      axisIdKey: axisIdKey,
      stackGroups: stackGroups,
      dataStartIndex: dataStartIndex,
      dataEndIndex: dataEndIndex
    });
  }

  return axisMap;
};

var tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
  var axis = getAnyElementOfObject(axisMap);
  var tooltipTicks = getTicksOfAxis(axis, false, true);
  return {
    tooltipTicks: tooltipTicks,
    orderedTooltipTicks: sortBy_1(tooltipTicks, function (o) {
      return o.coordinate;
    }),
    tooltipAxis: axis,
    tooltipAxisBandSize: getBandSizeOfAxis(axis, tooltipTicks)
  };
};
/**
 * Returns default, reset state for the categorical chart.
 * @param {Object} props Props object to use when creating the default state
 * @return {Object} Whole new state
 */


var createDefaultState = function createDefaultState(props) {
  var children = props.children,
      defaultShowTooltip = props.defaultShowTooltip;
  var brushItem = findChildByType(children, Brush.displayName);
  var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
  var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
  return {
    chartX: 0,
    chartY: 0,
    dataStartIndex: startIndex,
    dataEndIndex: endIndex,
    activeTooltipIndex: -1,
    isTooltipActive: !isNil_1(defaultShowTooltip) ? defaultShowTooltip : false
  };
};

var hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
  if (!graphicalItems || !graphicalItems.length) {
    return false;
  }

  return graphicalItems.some(function (item) {
    var name = getDisplayName(item && item.type);
    return name && name.indexOf('Bar') >= 0;
  });
};

var getAxisNameByLayout = function getAxisNameByLayout(layout) {
  if (layout === 'horizontal') {
    return {
      numericAxisName: 'yAxis',
      cateAxisName: 'xAxis'
    };
  }

  if (layout === 'vertical') {
    return {
      numericAxisName: 'xAxis',
      cateAxisName: 'yAxis'
    };
  }

  if (layout === 'centric') {
    return {
      numericAxisName: 'radiusAxis',
      cateAxisName: 'angleAxis'
    };
  }

  return {
    numericAxisName: 'angleAxis',
    cateAxisName: 'radiusAxis'
  };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} props          Latest props
 * graphicalItems The instances of item
 * xAxisMap       The configuration of x-axis
 * yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox          the boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */


var calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
  var props = _ref5.props,
      graphicalItems = _ref5.graphicalItems,
      _ref5$xAxisMap = _ref5.xAxisMap,
      xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap,
      _ref5$yAxisMap = _ref5.yAxisMap,
      yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
  var width = props.width,
      height = props.height,
      children = props.children;
  var margin = props.margin || {};
  var brushItem = findChildByType(children, Brush.displayName);
  var legendItem = findChildByType(children, Legend.displayName);
  var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
    var entry = yAxisMap[id];
    var orientation = entry.orientation;

    if (!entry.mirror && !entry.hide) {
      return _objectSpread$6(_objectSpread$6({}, result), {}, _defineProperty$7({}, orientation, result[orientation] + entry.width));
    }

    return result;
  }, {
    left: margin.left || 0,
    right: margin.right || 0
  });
  var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
    var entry = xAxisMap[id];
    var orientation = entry.orientation;

    if (!entry.mirror && !entry.hide) {
      return _objectSpread$6(_objectSpread$6({}, result), {}, _defineProperty$7({}, orientation, get_1(result, "".concat(orientation)) + entry.height));
    }

    return result;
  }, {
    top: margin.top || 0,
    bottom: margin.bottom || 0
  });

  var offset = _objectSpread$6(_objectSpread$6({}, offsetV), offsetH);

  var brushBottom = offset.bottom;

  if (brushItem) {
    offset.bottom += brushItem.props.height || Brush.defaultProps.height;
  }

  if (legendItem && prevLegendBBox) {
    offset = appendOffsetOfLegend(offset, graphicalItems, props, prevLegendBBox);
  }

  return _objectSpread$6(_objectSpread$6({
    brushBottom: brushBottom
  }, offset), {}, {
    width: width - offset.left - offset.right,
    height: height - offset.top - offset.bottom
  });
};

var generateCategoricalChart = function generateCategoricalChart(_ref6) {
  var _class, _temp;

  var chartName = _ref6.chartName,
      GraphicalChild = _ref6.GraphicalChild,
      _ref6$defaultTooltipE = _ref6.defaultTooltipEventType,
      defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE,
      _ref6$validateTooltip = _ref6.validateTooltipEventTypes,
      validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? ['axis'] : _ref6$validateTooltip,
      axisComponents = _ref6.axisComponents,
      legendContent = _ref6.legendContent,
      formatAxisMap = _ref6.formatAxisMap,
      defaultProps = _ref6.defaultProps;

  var getFormatItems = function getFormatItems(props, currentState) {
    var graphicalItems = currentState.graphicalItems,
        stackGroups = currentState.stackGroups,
        offset = currentState.offset,
        updateId = currentState.updateId,
        dataStartIndex = currentState.dataStartIndex,
        dataEndIndex = currentState.dataEndIndex;
    var barSize = props.barSize,
        layout = props.layout,
        barGap = props.barGap,
        barCategoryGap = props.barCategoryGap,
        globalMaxBarSize = props.maxBarSize;

    var _getAxisNameByLayout = getAxisNameByLayout(layout),
        numericAxisName = _getAxisNameByLayout.numericAxisName,
        cateAxisName = _getAxisNameByLayout.cateAxisName;

    var hasBar = hasGraphicalBarItem(graphicalItems);
    var sizeList = hasBar && getBarSizeList({
      barSize: barSize,
      stackGroups: stackGroups
    });
    var formattedItems = [];
    graphicalItems.forEach(function (item, index) {
      var displayedData = getDisplayedData(props.data, {
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
      }, item);
      var _item$props = item.props,
          dataKey = _item$props.dataKey,
          childMaxBarSize = _item$props.maxBarSize;
      var numericAxisId = item.props["".concat(numericAxisName, "Id")];
      var cateAxisId = item.props["".concat(cateAxisName, "Id")];
      var axisObj = axisComponents.reduce(function (result, entry) {
        var _objectSpread6;

        var axisMap = currentState["".concat(entry.axisType, "Map")];
        var id = item.props["".concat(entry.axisType, "Id")];
        var axis = axisMap && axisMap[id];
        return _objectSpread$6(_objectSpread$6({}, result), {}, (_objectSpread6 = {}, _defineProperty$7(_objectSpread6, entry.axisType, axis), _defineProperty$7(_objectSpread6, "".concat(entry.axisType, "Ticks"), getTicksOfAxis(axis)), _objectSpread6));
      }, {});
      var cateAxis = axisObj[cateAxisName];
      var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
      var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && getStackedDataOfItem(item, stackGroups[numericAxisId].stackGroups);
      var itemIsBar = getDisplayName(item.type).indexOf('Bar') >= 0;
      var bandSize = getBandSizeOfAxis(cateAxis, cateTicks);
      var barPosition = [];

      if (itemIsBar) {
        var _ref7, _getBandSizeOfAxis;

        // 如果是bar，计算bar的位置
        var maxBarSize = isNil_1(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
        var barBandSize = (_ref7 = (_getBandSizeOfAxis = getBandSizeOfAxis(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
        barPosition = getBarPosition({
          barGap: barGap,
          barCategoryGap: barCategoryGap,
          bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
          sizeList: sizeList[cateAxisId],
          maxBarSize: maxBarSize
        });

        if (barBandSize !== bandSize) {
          barPosition = barPosition.map(function (pos) {
            return _objectSpread$6(_objectSpread$6({}, pos), {}, {
              position: _objectSpread$6(_objectSpread$6({}, pos.position), {}, {
                offset: pos.position.offset - barBandSize / 2
              })
            });
          });
        }
      }

      var composedFn = item && item.type && item.type.getComposedData;

      if (composedFn) {
        var _objectSpread7;

        formattedItems.push({
          props: _objectSpread$6(_objectSpread$6({}, composedFn(_objectSpread$6(_objectSpread$6({}, axisObj), {}, {
            displayedData: displayedData,
            props: props,
            dataKey: dataKey,
            item: item,
            bandSize: bandSize,
            barPosition: barPosition,
            offset: offset,
            stackedData: stackedData,
            layout: layout,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          }))), {}, (_objectSpread7 = {
            key: item.key || "item-".concat(index)
          }, _defineProperty$7(_objectSpread7, numericAxisName, axisObj[numericAxisName]), _defineProperty$7(_objectSpread7, cateAxisName, axisObj[cateAxisName]), _defineProperty$7(_objectSpread7, "animationId", updateId), _objectSpread7)),
          childIndex: parseChildIndex(item, props.children),
          item: item
        });
      }
    });
    return formattedItems;
  };
  /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */


  var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
    var props = _ref8.props,
        dataStartIndex = _ref8.dataStartIndex,
        dataEndIndex = _ref8.dataEndIndex,
        updateId = _ref8.updateId;

    if (!validateWidthHeight({
      props: props
    })) {
      return null;
    }

    var children = props.children,
        layout = props.layout,
        stackOffset = props.stackOffset,
        data = props.data,
        reverseStackOrder = props.reverseStackOrder;

    var _getAxisNameByLayout2 = getAxisNameByLayout(layout),
        numericAxisName = _getAxisNameByLayout2.numericAxisName,
        cateAxisName = _getAxisNameByLayout2.cateAxisName;

    var graphicalItems = findAllByType(children, GraphicalChild);
    var stackGroups = getStackGroupsByAxisId(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
    var axisObj = axisComponents.reduce(function (result, entry) {
      var name = "".concat(entry.axisType, "Map");
      return _objectSpread$6(_objectSpread$6({}, result), {}, _defineProperty$7({}, name, getAxisMap(props, _objectSpread$6(_objectSpread$6({}, entry), {}, {
        graphicalItems: graphicalItems,
        stackGroups: entry.axisType === numericAxisName && stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
      }))));
    }, {});
    var offset = calculateOffset(_objectSpread$6(_objectSpread$6({}, axisObj), {}, {
      props: props,
      graphicalItems: graphicalItems
    }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
    Object.keys(axisObj).forEach(function (key) {
      axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
    });
    var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
    var ticksObj = tooltipTicksGenerator(cateAxisMap);
    var formattedGraphicalItems = getFormatItems(props, _objectSpread$6(_objectSpread$6({}, axisObj), {}, {
      dataStartIndex: dataStartIndex,
      dataEndIndex: dataEndIndex,
      updateId: updateId,
      graphicalItems: graphicalItems,
      stackGroups: stackGroups,
      offset: offset
    }));
    return _objectSpread$6(_objectSpread$6({
      formattedGraphicalItems: formattedGraphicalItems,
      graphicalItems: graphicalItems,
      offset: offset,
      stackGroups: stackGroups
    }, ticksObj), axisObj);
  };

  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inherits$6(CategoricalChartWrapper, _Component);

    var _super = _createSuper$5(CategoricalChartWrapper);

    // todo join specific chart propTypes
    function CategoricalChartWrapper(_props) {
      var _this;

      _classCallCheck$7(this, CategoricalChartWrapper);

      _this = _super.call(this, _props);
      _this.uniqueChartId = void 0;
      _this.clipPathId = void 0;
      _this.legendInstance = void 0;
      _this.deferId = void 0;
      _this.container = void 0;

      _this.clearDeferId = function () {
        if (!isNil_1(_this.deferId) && deferClear) {
          deferClear(_this.deferId);
        }

        _this.deferId = null;
      };

      _this.handleLegendBBoxUpdate = function (box) {
        if (box) {
          var _this$state = _this.state,
              dataStartIndex = _this$state.dataStartIndex,
              dataEndIndex = _this$state.dataEndIndex,
              updateId = _this$state.updateId;

          _this.setState(_objectSpread$6({
            legendBBox: box
          }, updateStateOfAxisMapsOffsetAndStackGroups({
            props: _this.props,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId
          }, _objectSpread$6(_objectSpread$6({}, _this.state), {}, {
            legendBBox: box
          }))));
        }
      };

      _this.handleReceiveSyncEvent = function (cId, chartId, data) {
        var syncId = _this.props.syncId;

        if (syncId === cId && chartId !== _this.uniqueChartId) {
          _this.clearDeferId();

          _this.deferId = defer && defer(_this.applySyncEvent.bind(_assertThisInitialized$6(_this), data));
        }
      };

      _this.handleBrushChange = function (_ref9) {
        var startIndex = _ref9.startIndex,
            endIndex = _ref9.endIndex;

        // Only trigger changes if the extents of the brush have actually changed
        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
          var updateId = _this.state.updateId;

          _this.setState(function () {
            return _objectSpread$6({
              dataStartIndex: startIndex,
              dataEndIndex: endIndex
            }, updateStateOfAxisMapsOffsetAndStackGroups({
              props: _this.props,
              dataStartIndex: startIndex,
              dataEndIndex: endIndex,
              updateId: updateId
            }, _this.state));
          });

          _this.triggerSyncEvent({
            dataStartIndex: startIndex,
            dataEndIndex: endIndex
          });
        }
      };

      _this.handleMouseEnter = function (e) {
        var onMouseEnter = _this.props.onMouseEnter;

        var mouse = _this.getMouseInfo(e);

        if (mouse) {
          var _nextState = _objectSpread$6(_objectSpread$6({}, mouse), {}, {
            isTooltipActive: true
          });

          _this.setState(_nextState);

          _this.triggerSyncEvent(_nextState);

          if (isFunction_1(onMouseEnter)) {
            onMouseEnter(_nextState, e);
          }
        }
      };

      _this.triggeredAfterMouseMove = function (e) {
        var onMouseMove = _this.props.onMouseMove;

        var mouse = _this.getMouseInfo(e);

        var nextState = mouse ? _objectSpread$6(_objectSpread$6({}, mouse), {}, {
          isTooltipActive: true
        }) : {
          isTooltipActive: false
        };

        _this.setState(nextState);

        _this.triggerSyncEvent(nextState);

        if (isFunction_1(onMouseMove)) {
          onMouseMove(nextState, e);
        }
      };

      _this.handleItemMouseEnter = function (el) {
        _this.setState(function () {
          return {
            isTooltipActive: true,
            activeItem: el,
            activePayload: el.tooltipPayload,
            activeCoordinate: el.tooltipPosition || {
              x: el.cx,
              y: el.cy
            }
          };
        });
      };

      _this.handleItemMouseLeave = function () {
        _this.setState(function () {
          return {
            isTooltipActive: false
          };
        });
      };

      _this.handleMouseMove = function (e) {
        if (e && isFunction_1(e.persist)) {
          e.persist();
        }

        _this.triggeredAfterMouseMove(e);
      };

      _this.handleMouseLeave = function (e) {
        var onMouseLeave = _this.props.onMouseLeave;
        var nextState = {
          isTooltipActive: false
        };

        _this.setState(nextState);

        _this.triggerSyncEvent(nextState);

        if (isFunction_1(onMouseLeave)) {
          onMouseLeave(nextState, e);
        }

        _this.cancelThrottledTriggerAfterMouseMove();
      };

      _this.handleOuterEvent = function (e) {
        var eventName = getReactEventByType(e);

        var event = get_1(_this.props, "".concat(eventName));

        if (eventName && isFunction_1(event)) {
          var mouse;

          if (/.*touch.*/i.test(eventName)) {
            mouse = _this.getMouseInfo(e.changedTouches[0]);
          } else {
            mouse = _this.getMouseInfo(e);
          }

          var handler = event;
          handler(mouse, e);
        }
      };

      _this.handleClick = function (e) {
        var onClick = _this.props.onClick;

        var mouse = _this.getMouseInfo(e);

        if (mouse) {
          var _nextState2 = _objectSpread$6(_objectSpread$6({}, mouse), {}, {
            isTooltipActive: true
          });

          _this.setState(_nextState2);

          _this.triggerSyncEvent(_nextState2);

          if (isFunction_1(onClick)) {
            onClick(_nextState2, e);
          }
        }
      };

      _this.handleMouseDown = function (e) {
        var onMouseDown = _this.props.onMouseDown;

        if (isFunction_1(onMouseDown)) {
          var _nextState3 = _this.getMouseInfo(e);

          onMouseDown(_nextState3, e);
        }
      };

      _this.handleMouseUp = function (e) {
        var onMouseUp = _this.props.onMouseUp;

        if (isFunction_1(onMouseUp)) {
          var _nextState4 = _this.getMouseInfo(e);

          onMouseUp(_nextState4, e);
        }
      };

      _this.handleTouchMove = function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseMove(e.changedTouches[0]);
        }
      };

      _this.handleTouchStart = function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseDown(e.changedTouches[0]);
        }
      };

      _this.handleTouchEnd = function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseUp(e.changedTouches[0]);
        }
      };

      _this.verticalCoordinatesGenerator = function (_ref10) {
        var xAxis = _ref10.xAxis,
            width = _ref10.width,
            height = _ref10.height,
            offset = _ref10.offset;
        return getCoordinatesOfGrid(CartesianAxis.getTicks(_objectSpread$6(_objectSpread$6(_objectSpread$6({}, CartesianAxis.defaultProps), xAxis), {}, {
          ticks: getTicksOfAxis(xAxis, true),
          viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
          }
        })), offset.left, offset.left + offset.width);
      };

      _this.horizontalCoordinatesGenerator = function (_ref11) {
        var yAxis = _ref11.yAxis,
            width = _ref11.width,
            height = _ref11.height,
            offset = _ref11.offset;
        return getCoordinatesOfGrid(CartesianAxis.getTicks(_objectSpread$6(_objectSpread$6(_objectSpread$6({}, CartesianAxis.defaultProps), yAxis), {}, {
          ticks: getTicksOfAxis(yAxis, true),
          viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
          }
        })), offset.top, offset.top + offset.height);
      };

      _this.axesTicksGenerator = function (axis) {
        return getTicksOfAxis(axis, true);
      };

      _this.renderCursor = function (element) {
        var _this$state2 = _this.state,
            isTooltipActive = _this$state2.isTooltipActive,
            activeCoordinate = _this$state2.activeCoordinate,
            activePayload = _this$state2.activePayload,
            offset = _this$state2.offset,
            activeTooltipIndex = _this$state2.activeTooltipIndex;

        var tooltipEventType = _this.getTooltipEventType();

        if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') {
          return null;
        }

        var layout = _this.props.layout;
        var restProps;
        var cursorComp = Curve;

        if (chartName === 'ScatterChart') {
          restProps = activeCoordinate;
          cursorComp = Cross;
        } else if (chartName === 'BarChart') {
          restProps = _this.getCursorRectangle();
          cursorComp = Rectangle;
        } else if (layout === 'radial') {
          var _this$getCursorPoints = _this.getCursorPoints(),
              cx = _this$getCursorPoints.cx,
              cy = _this$getCursorPoints.cy,
              radius = _this$getCursorPoints.radius,
              startAngle = _this$getCursorPoints.startAngle,
              endAngle = _this$getCursorPoints.endAngle;

          restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
          };
          cursorComp = Sector;
        } else {
          restProps = {
            points: _this.getCursorPoints()
          };
          cursorComp = Curve;
        }

        var key = element.key || '_recharts-cursor';

        var cursorProps = _objectSpread$6(_objectSpread$6(_objectSpread$6(_objectSpread$6({
          stroke: '#ccc',
          pointerEvents: 'none'
        }, offset), restProps), filterProps(element.props.cursor)), {}, {
          payload: activePayload,
          payloadIndex: activeTooltipIndex,
          key: key,
          className: 'recharts-tooltip-cursor'
        });

        return /*#__PURE__*/isValidElement(element.props.cursor) ? /*#__PURE__*/cloneElement(element.props.cursor, cursorProps) : /*#__PURE__*/createElement(cursorComp, cursorProps);
      };

      _this.renderPolarAxis = function (element, displayName, index) {
        var axisType = get_1(element, 'type.axisType');

        var axisMap = get_1(_this.state, "".concat(axisType, "Map"));

        var axisOption = axisMap[element.props["".concat(axisType, "Id")]];
        return /*#__PURE__*/cloneElement(element, _objectSpread$6(_objectSpread$6({}, axisOption), {}, {
          className: axisType,
          key: element.key || "".concat(displayName, "-").concat(index),
          ticks: getTicksOfAxis(axisOption, true)
        }));
      };

      _this.renderXAxis = function (element, displayName, index) {
        var xAxisMap = _this.state.xAxisMap;
        var axisObj = xAxisMap[element.props.xAxisId];
        return _this.renderAxis(axisObj, element, displayName, index);
      };

      _this.renderYAxis = function (element, displayName, index) {
        var yAxisMap = _this.state.yAxisMap;
        var axisObj = yAxisMap[element.props.yAxisId];
        return _this.renderAxis(axisObj, element, displayName, index);
      };

      _this.renderGrid = function (element) {
        var _this$state3 = _this.state,
            xAxisMap = _this$state3.xAxisMap,
            yAxisMap = _this$state3.yAxisMap,
            offset = _this$state3.offset;
        var _this$props = _this.props,
            width = _this$props.width,
            height = _this$props.height;
        var xAxis = getAnyElementOfObject(xAxisMap);

        var yAxisWithFiniteDomain = find_1(yAxisMap, function (axis) {
          return every_1(axis.domain, isFinit);
        });

        var yAxis = yAxisWithFiniteDomain || getAnyElementOfObject(yAxisMap);
        var props = element.props || {};
        return /*#__PURE__*/cloneElement(element, {
          key: element.key || 'grid',
          x: isNumber$1(props.x) ? props.x : offset.left,
          y: isNumber$1(props.y) ? props.y : offset.top,
          width: isNumber$1(props.width) ? props.width : offset.width,
          height: isNumber$1(props.height) ? props.height : offset.height,
          xAxis: xAxis,
          yAxis: yAxis,
          offset: offset,
          chartWidth: width,
          chartHeight: height,
          verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
          horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
        });
      };

      _this.renderPolarGrid = function (element) {
        var _element$props = element.props,
            radialLines = _element$props.radialLines,
            polarAngles = _element$props.polarAngles,
            polarRadius = _element$props.polarRadius;
        var _this$state4 = _this.state,
            radiusAxisMap = _this$state4.radiusAxisMap,
            angleAxisMap = _this$state4.angleAxisMap;
        var radiusAxis = getAnyElementOfObject(radiusAxisMap);
        var angleAxis = getAnyElementOfObject(angleAxisMap);
        var cx = angleAxis.cx,
            cy = angleAxis.cy,
            innerRadius = angleAxis.innerRadius,
            outerRadius = angleAxis.outerRadius;
        return /*#__PURE__*/cloneElement(element, {
          polarAngles: isArray_1(polarAngles) ? polarAngles : getTicksOfAxis(angleAxis, true).map(function (entry) {
            return entry.coordinate;
          }),
          polarRadius: isArray_1(polarRadius) ? polarRadius : getTicksOfAxis(radiusAxis, true).map(function (entry) {
            return entry.coordinate;
          }),
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          key: element.key || 'polar-grid',
          radialLines: radialLines
        });
      };

      _this.renderLegend = function () {
        var formattedGraphicalItems = _this.state.formattedGraphicalItems;
        var _this$props2 = _this.props,
            children = _this$props2.children,
            width = _this$props2.width,
            height = _this$props2.height;
        var margin = _this.props.margin || {};
        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
        var props = getLegendProps({
          children: children,
          formattedGraphicalItems: formattedGraphicalItems,
          legendWidth: legendWidth,
          legendContent: legendContent
        });

        if (!props) {
          return null;
        }

        var item = props.item,
            otherProps = _objectWithoutProperties$2(props, ["item"]);

        return /*#__PURE__*/cloneElement(item, _objectSpread$6(_objectSpread$6({}, otherProps), {}, {
          chartWidth: width,
          chartHeight: height,
          margin: margin,
          ref: function ref(legend) {
            _this.legendInstance = legend;
          },
          onBBoxUpdate: _this.handleLegendBBoxUpdate
        }));
      };

      _this.renderTooltip = function () {
        var children = _this.props.children;
        var tooltipItem = findChildByType(children, Tooltip.displayName);

        if (!tooltipItem) {
          return null;
        }

        var _this$state5 = _this.state,
            isTooltipActive = _this$state5.isTooltipActive,
            activeCoordinate = _this$state5.activeCoordinate,
            activePayload = _this$state5.activePayload,
            activeLabel = _this$state5.activeLabel,
            offset = _this$state5.offset;
        return /*#__PURE__*/cloneElement(tooltipItem, {
          viewBox: _objectSpread$6(_objectSpread$6({}, offset), {}, {
            x: offset.left,
            y: offset.top
          }),
          active: isTooltipActive,
          label: activeLabel,
          payload: isTooltipActive ? activePayload : [],
          coordinate: activeCoordinate
        });
      };

      _this.renderBrush = function (element) {
        var _this$props3 = _this.props,
            margin = _this$props3.margin,
            data = _this$props3.data;
        var _this$state6 = _this.state,
            offset = _this$state6.offset,
            dataStartIndex = _this$state6.dataStartIndex,
            dataEndIndex = _this$state6.dataEndIndex,
            updateId = _this$state6.updateId; // TODO: update brush when children update

        return /*#__PURE__*/cloneElement(element, {
          key: element.key || '_recharts-brush',
          onChange: combineEventHandlers(_this.handleBrushChange, null, element.props.onChange),
          data: data,
          x: isNumber$1(element.props.x) ? element.props.x : offset.left,
          y: isNumber$1(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
          width: isNumber$1(element.props.width) ? element.props.width : offset.width,
          startIndex: dataStartIndex,
          endIndex: dataEndIndex,
          updateId: "brush-".concat(updateId)
        });
      };

      _this.renderReferenceElement = function (element, displayName, index) {
        if (!element) {
          return null;
        }

        var _assertThisInitialize = _assertThisInitialized$6(_this),
            clipPathId = _assertThisInitialize.clipPathId;

        var _this$state7 = _this.state,
            xAxisMap = _this$state7.xAxisMap,
            yAxisMap = _this$state7.yAxisMap,
            offset = _this$state7.offset;
        var _element$props2 = element.props,
            xAxisId = _element$props2.xAxisId,
            yAxisId = _element$props2.yAxisId;
        return /*#__PURE__*/cloneElement(element, {
          key: element.key || "".concat(displayName, "-").concat(index),
          xAxis: xAxisMap[xAxisId],
          yAxis: yAxisMap[yAxisId],
          viewBox: {
            x: offset.left,
            y: offset.top,
            width: offset.width,
            height: offset.height
          },
          clipPathId: clipPathId
        });
      };

      _this.renderActivePoints = function (_ref12) {
        var item = _ref12.item,
            activePoint = _ref12.activePoint,
            basePoint = _ref12.basePoint,
            childIndex = _ref12.childIndex,
            isRange = _ref12.isRange;
        var result = [];
        var key = item.props.key;
        var _item$item$props = item.item.props,
            activeDot = _item$item$props.activeDot,
            dataKey = _item$item$props.dataKey;

        var dotProps = _objectSpread$6(_objectSpread$6({
          index: childIndex,
          dataKey: dataKey,
          cx: activePoint.x,
          cy: activePoint.y,
          r: 4,
          fill: getMainColorOfGraphicItem(item.item),
          strokeWidth: 2,
          stroke: '#fff',
          payload: activePoint.payload,
          value: activePoint.value,
          key: "".concat(key, "-activePoint-").concat(childIndex)
        }, filterProps(activeDot)), adaptEventHandlers(activeDot));

        result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));

        if (basePoint) {
          result.push(CategoricalChartWrapper.renderActiveDot(activeDot, _objectSpread$6(_objectSpread$6({}, dotProps), {}, {
            cx: basePoint.x,
            cy: basePoint.y,
            key: "".concat(key, "-basePoint-").concat(childIndex)
          })));
        } else if (isRange) {
          result.push(null);
        }

        return result;
      };

      _this.renderGraphicChild = function (element, displayName, index) {
        var item = _this.filterFormatItem(element, displayName, index);

        if (!item) {
          return null;
        }

        var tooltipEventType = _this.getTooltipEventType();

        var _this$state8 = _this.state,
            isTooltipActive = _this$state8.isTooltipActive,
            tooltipAxis = _this$state8.tooltipAxis,
            activeTooltipIndex = _this$state8.activeTooltipIndex,
            activeLabel = _this$state8.activeLabel;
        var children = _this.props.children;
        var tooltipItem = findChildByType(children, Tooltip.displayName);
        var _item$props2 = item.props,
            points = _item$props2.points,
            isRange = _item$props2.isRange,
            baseLine = _item$props2.baseLine;
        var _item$item$props2 = item.item.props,
            activeDot = _item$item$props2.activeDot,
            hide = _item$item$props2.hide;
        var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
        var itemEvents = {};

        if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') {
          itemEvents = {
            onClick: combineEventHandlers(_this.handleItemMouseEnter, null, element.props.onCLick)
          };
        } else if (tooltipEventType !== 'axis') {
          itemEvents = {
            onMouseLeave: combineEventHandlers(_this.handleItemMouseLeave, null, element.props.onMouseLeave),
            onMouseEnter: combineEventHandlers(_this.handleItemMouseEnter, null, element.props.onMouseEnter)
          };
        }

        var graphicalItem = /*#__PURE__*/cloneElement(element, _objectSpread$6(_objectSpread$6({}, item.props), itemEvents));

        function findWithPayload(entry) {
          // TODO needs to verify dataKey is Function
          return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
        }

        if (hasActive) {
          var activePoint, basePoint;

          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // number transform to string
            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
            activePoint = findEntryInArray(points, specifiedKey, activeLabel);
            basePoint = isRange && baseLine && findEntryInArray(baseLine, specifiedKey, activeLabel);
          } else {
            activePoint = points[activeTooltipIndex];
            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
          }

          if (!isNil_1(activePoint)) {
            return [graphicalItem].concat(_toConsumableArray(_this.renderActivePoints({
              item: item,
              activePoint: activePoint,
              basePoint: basePoint,
              childIndex: activeTooltipIndex,
              isRange: isRange
            })));
          }
        }

        if (isRange) {
          return [graphicalItem, null, null];
        }

        return [graphicalItem, null];
      };

      _this.renderCustomized = function (element, displayName, index) {
        return /*#__PURE__*/cloneElement(element, _objectSpread$6(_objectSpread$6({
          key: "recharts-customized-".concat(index)
        }, _this.props), _this.state));
      };

      _this.uniqueChartId = isNil_1(_props.id) ? uniqueId('recharts') : _props.id;
      _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");

      if (_props.throttleDelay) {
        _this.triggeredAfterMouseMove = throttle_1(_this.triggeredAfterMouseMove, _props.throttleDelay);
      }

      _this.state = {};
      return _this;
    }
    /* eslint-disable  react/no-did-mount-set-state */


    _createClass$8(CategoricalChartWrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!isNil_1(this.props.syncId)) {
          this.addListener();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        // add syncId
        if (isNil_1(prevProps.syncId) && !isNil_1(this.props.syncId)) {
          this.addListener();
        } // remove syncId


        if (!isNil_1(prevProps.syncId) && isNil_1(this.props.syncId)) {
          this.removeListener();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearDeferId();

        if (!isNil_1(this.props.syncId)) {
          this.removeListener();
        }

        this.cancelThrottledTriggerAfterMouseMove();
      }
    }, {
      key: "cancelThrottledTriggerAfterMouseMove",
      value: function cancelThrottledTriggerAfterMouseMove() {
        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
          this.triggeredAfterMouseMove.cancel();
        }
      }
    }, {
      key: "getTooltipEventType",
      value: function getTooltipEventType() {
        var tooltipItem = findChildByType(this.props.children, Tooltip.displayName);

        if (tooltipItem && isBoolean_1(tooltipItem.props.shared)) {
          var eventType = tooltipItem.props.shared ? 'axis' : 'item';
          return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
        }

        return defaultTooltipEventType;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {Object} event    The event object
       * @return {Object}          Mouse data
       */

    }, {
      key: "getMouseInfo",
      value: function getMouseInfo(event) {
        if (!this.container) {
          return null;
        }

        var containerOffset = getOffset(this.container);
        var e = calculateChartCoordinate(event, containerOffset);
        var rangeObj = this.inRange(e.chartX, e.chartY);

        if (!rangeObj) {
          return null;
        }

        var _this$state9 = this.state,
            xAxisMap = _this$state9.xAxisMap,
            yAxisMap = _this$state9.yAxisMap;
        var tooltipEventType = this.getTooltipEventType();

        if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
          var xScale = getAnyElementOfObject(xAxisMap).scale;
          var yScale = getAnyElementOfObject(yAxisMap).scale;
          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
          return _objectSpread$6(_objectSpread$6({}, e), {}, {
            xValue: xValue,
            yValue: yValue
          });
        }

        var toolTipData = getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);

        if (toolTipData) {
          return _objectSpread$6(_objectSpread$6({}, e), toolTipData);
        }

        return null;
      }
    }, {
      key: "getCursorRectangle",
      value: function getCursorRectangle() {
        var layout = this.props.layout;
        var _this$state10 = this.state,
            activeCoordinate = _this$state10.activeCoordinate,
            offset = _this$state10.offset,
            tooltipAxisBandSize = _this$state10.tooltipAxisBandSize;
        var halfSize = tooltipAxisBandSize / 2;
        return {
          stroke: 'none',
          fill: '#ccc',
          x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
          y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
          width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
          height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
        };
      }
    }, {
      key: "getCursorPoints",
      value: function getCursorPoints() {
        var layout = this.props.layout;
        var _this$state11 = this.state,
            activeCoordinate = _this$state11.activeCoordinate,
            offset = _this$state11.offset;
        var x1, y1, x2, y2;

        if (layout === 'horizontal') {
          x1 = activeCoordinate.x;
          x2 = x1;
          y1 = offset.top;
          y2 = offset.top + offset.height;
        } else if (layout === 'vertical') {
          y1 = activeCoordinate.y;
          y2 = y1;
          x1 = offset.left;
          x2 = offset.left + offset.width;
        } else if (!isNil_1(activeCoordinate.cx) || !isNil_1(activeCoordinate.cy)) {
          if (layout === 'centric') {
            var cx = activeCoordinate.cx,
                cy = activeCoordinate.cy,
                innerRadius = activeCoordinate.innerRadius,
                outerRadius = activeCoordinate.outerRadius,
                angle = activeCoordinate.angle;
            var innerPoint = polarToCartesian(cx, cy, innerRadius, angle);
            var outerPoint = polarToCartesian(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
          } else {
            var _cx = activeCoordinate.cx,
                _cy = activeCoordinate.cy,
                radius = activeCoordinate.radius,
                startAngle = activeCoordinate.startAngle,
                endAngle = activeCoordinate.endAngle;
            var startPoint = polarToCartesian(_cx, _cy, radius, startAngle);
            var endPoint = polarToCartesian(_cx, _cy, radius, endAngle);
            return {
              points: [startPoint, endPoint],
              cx: _cx,
              cy: _cy,
              radius: radius,
              startAngle: startAngle,
              endAngle: endAngle
            };
          }
        }

        return [{
          x: x1,
          y: y1
        }, {
          x: x2,
          y: y2
        }];
      }
    }, {
      key: "inRange",
      value: function inRange(x, y) {
        var layout = this.props.layout;

        if (layout === 'horizontal' || layout === 'vertical') {
          var offset = this.state.offset;
          var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
          return isInRange ? {
            x: x,
            y: y
          } : null;
        }

        var _this$state12 = this.state,
            angleAxisMap = _this$state12.angleAxisMap,
            radiusAxisMap = _this$state12.radiusAxisMap;

        if (angleAxisMap && radiusAxisMap) {
          var angleAxis = getAnyElementOfObject(angleAxisMap);
          return inRangeOfSector({
            x: x,
            y: y
          }, angleAxis);
        }

        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function parseEventsOfWrapper() {
        var children = this.props.children;
        var tooltipEventType = this.getTooltipEventType();
        var tooltipItem = findChildByType(children, Tooltip.displayName);
        var tooltipEvents = {};

        if (tooltipItem && tooltipEventType === 'axis') {
          if (tooltipItem.props.trigger === 'click') {
            tooltipEvents = {
              onClick: this.handleClick
            };
          } else {
            tooltipEvents = {
              onMouseEnter: this.handleMouseEnter,
              onMouseMove: this.handleMouseMove,
              onMouseLeave: this.handleMouseLeave,
              onTouchMove: this.handleTouchMove,
              onTouchStart: this.handleTouchStart,
              onTouchEnd: this.handleTouchEnd
            };
          }
        }

        var outerEvents = adaptEventHandlers(this.props, this.handleOuterEvent);
        return _objectSpread$6(_objectSpread$6({}, outerEvents), tooltipEvents);
      }
      /* eslint-disable  no-underscore-dangle */

    }, {
      key: "addListener",
      value: function addListener() {
        eventCenter.on(SYNC_EVENT, this.handleReceiveSyncEvent);

        if (eventCenter.setMaxListeners && eventCenter._maxListeners) {
          eventCenter.setMaxListeners(eventCenter._maxListeners + 1);
        }
      }
    }, {
      key: "removeListener",
      value: function removeListener() {
        eventCenter.removeListener(SYNC_EVENT, this.handleReceiveSyncEvent);

        if (eventCenter.setMaxListeners && eventCenter._maxListeners) {
          eventCenter.setMaxListeners(eventCenter._maxListeners - 1);
        }
      }
    }, {
      key: "triggerSyncEvent",
      value: function triggerSyncEvent(data) {
        var syncId = this.props.syncId;

        if (!isNil_1(syncId)) {
          eventCenter.emit(SYNC_EVENT, syncId, this.uniqueChartId, data);
        }
      }
    }, {
      key: "applySyncEvent",
      value: function applySyncEvent(data) {
        var _this$props4 = this.props,
            layout = _this$props4.layout,
            syncMethod = _this$props4.syncMethod;
        var updateId = this.state.updateId;
        var dataStartIndex = data.dataStartIndex,
            dataEndIndex = data.dataEndIndex;

        if (!isNil_1(data.dataStartIndex) || !isNil_1(data.dataEndIndex)) {
          this.setState(_objectSpread$6({
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          }, updateStateOfAxisMapsOffsetAndStackGroups({
            props: this.props,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId
          }, this.state)));
        } else if (!isNil_1(data.activeTooltipIndex)) {
          var chartX = data.chartX,
              chartY = data.chartY;
          var activeTooltipIndex = data.activeTooltipIndex;
          var _this$state13 = this.state,
              offset = _this$state13.offset,
              tooltipTicks = _this$state13.tooltipTicks;

          if (!offset) {
            return;
          }

          if (typeof syncMethod === 'function') {
            // Call a callback function. If there is an application specific algorithm
            activeTooltipIndex = syncMethod(tooltipTicks, data);
          } else if (syncMethod === 'value') {
            // Set activeTooltipIndex to the index with the same value as data.activeLabel
            // For loop instead of findIndex because the latter is very slow in some browsers
            activeTooltipIndex = -1; // in case we cannot find the element

            for (var i = 0; i < tooltipTicks.length; i++) {
              if (tooltipTicks[i].value === data.activeLabel) {
                activeTooltipIndex = i;
                break;
              }
            }
          }

          var viewBox = _objectSpread$6(_objectSpread$6({}, offset), {}, {
            x: offset.left,
            y: offset.top
          }); // When a categotical chart is combined with another chart, the value of chartX
          // and chartY may beyond the boundaries.


          var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
          var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
          var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
          var activePayload = getTooltipContent(this.state, this.props.data, activeTooltipIndex);
          var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
            x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
            y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
          } : originCoordinate;
          this.setState(_objectSpread$6(_objectSpread$6({}, data), {}, {
            activeLabel: activeLabel,
            activeCoordinate: activeCoordinate,
            activePayload: activePayload,
            activeTooltipIndex: activeTooltipIndex
          }));
        } else {
          this.setState(data);
        }
      }
    }, {
      key: "filterFormatItem",
      value: function filterFormatItem(item, displayName, childIndex) {
        var formattedGraphicalItems = this.state.formattedGraphicalItems;

        for (var i = 0, len = formattedGraphicalItems.length; i < len; i++) {
          var entry = formattedGraphicalItems[i];

          if (entry.item === item || entry.props.key === item.key || displayName === getDisplayName(entry.item.type) && childIndex === entry.childIndex) {
            return entry;
          }
        }

        return null;
      }
    }, {
      key: "renderAxis",
      value:
      /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */
      function renderAxis(axisOptions, element, displayName, index) {
        var _this$props5 = this.props,
            width = _this$props5.width,
            height = _this$props5.height;
        return /*#__PURE__*/React$2.createElement(CartesianAxis, _extends$4({}, axisOptions, {
          className: "recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType),
          key: element.key || "".concat(displayName, "-").concat(index),
          viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
          },
          ticksGenerator: this.axesTicksGenerator
        }));
      }
      /**
       * Draw grid
       * @param  {ReactElement} element the grid item
       * @return {ReactElement} The instance of grid
       */

    }, {
      key: "renderClipPath",
      value: function renderClipPath() {
        var clipPathId = this.clipPathId;
        var _this$state$offset = this.state.offset,
            left = _this$state$offset.left,
            top = _this$state$offset.top,
            height = _this$state$offset.height,
            width = _this$state$offset.width;
        return /*#__PURE__*/React$2.createElement("defs", null, /*#__PURE__*/React$2.createElement("clipPath", {
          id: clipPathId
        }, /*#__PURE__*/React$2.createElement("rect", {
          x: left,
          y: top,
          height: height,
          width: width
        })));
      }
    }, {
      key: "getXScales",
      value: function getXScales() {
        var xAxisMap = this.state.xAxisMap;
        return xAxisMap ? Object.entries(xAxisMap).reduce(function (res, _ref13) {
          var _ref14 = _slicedToArray(_ref13, 2),
              axisId = _ref14[0],
              axisProps = _ref14[1];

          return _objectSpread$6(_objectSpread$6({}, res), {}, _defineProperty$7({}, axisId, axisProps.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function getYScales() {
        var yAxisMap = this.state.yAxisMap;
        return yAxisMap ? Object.entries(yAxisMap).reduce(function (res, _ref15) {
          var _ref16 = _slicedToArray(_ref15, 2),
              axisId = _ref16[0],
              axisProps = _ref16[1];

          return _objectSpread$6(_objectSpread$6({}, res), {}, _defineProperty$7({}, axisId, axisProps.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function getXScaleByAxisId(axisId) {
        var _this$state$xAxisMap, _this$state$xAxisMap$;

        return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 ? void 0 : (_this$state$xAxisMap$ = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap$ === void 0 ? void 0 : _this$state$xAxisMap$.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function getYScaleByAxisId(axisId) {
        var _this$state$yAxisMap, _this$state$yAxisMap$;

        return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 ? void 0 : (_this$state$yAxisMap$ = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap$ === void 0 ? void 0 : _this$state$yAxisMap$.scale;
      }
    }, {
      key: "getItemByXY",
      value: function getItemByXY(chartXY) {
        var formattedGraphicalItems = this.state.formattedGraphicalItems;

        if (formattedGraphicalItems && formattedGraphicalItems.length) {
          for (var i = 0, len = formattedGraphicalItems.length; i < len; i++) {
            var graphicalItem = formattedGraphicalItems[i];
            var props = graphicalItem.props,
                item = graphicalItem.item;
            var itemDisplayName = getDisplayName(item.type);

            if (itemDisplayName === 'Bar') {
              var activeBarItem = (props.data || []).find(function (entry) {
                return isInRectangle(chartXY, entry);
              });

              if (activeBarItem) {
                return {
                  graphicalItem: graphicalItem,
                  payload: activeBarItem
                };
              }
            } else if (itemDisplayName === 'RadialBar') {
              var _activeBarItem = (props.data || []).find(function (entry) {
                return inRangeOfSector(chartXY, entry);
              });

              if (_activeBarItem) {
                return {
                  graphicalItem: graphicalItem,
                  payload: _activeBarItem
                };
              }
            }
          }
        }

        return null;
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        if (!validateWidthHeight(this)) {
          return null;
        }

        var _this$props6 = this.props,
            children = _this$props6.children,
            className = _this$props6.className,
            width = _this$props6.width,
            height = _this$props6.height,
            style = _this$props6.style,
            compact = _this$props6.compact,
            others = _objectWithoutProperties$2(_this$props6, ["children", "className", "width", "height", "style", "compact"]);

        var attrs = filterProps(others);
        var map = {
          CartesianGrid: {
            handler: this.renderGrid,
            once: true
          },
          ReferenceArea: {
            handler: this.renderReferenceElement
          },
          ReferenceLine: {
            handler: this.renderReferenceElement
          },
          ReferenceDot: {
            handler: this.renderReferenceElement
          },
          XAxis: {
            handler: this.renderXAxis
          },
          YAxis: {
            handler: this.renderYAxis
          },
          Brush: {
            handler: this.renderBrush,
            once: true
          },
          Bar: {
            handler: this.renderGraphicChild
          },
          Line: {
            handler: this.renderGraphicChild
          },
          Area: {
            handler: this.renderGraphicChild
          },
          Radar: {
            handler: this.renderGraphicChild
          },
          RadialBar: {
            handler: this.renderGraphicChild
          },
          Scatter: {
            handler: this.renderGraphicChild
          },
          Pie: {
            handler: this.renderGraphicChild
          },
          Funnel: {
            handler: this.renderGraphicChild
          },
          Tooltip: {
            handler: this.renderCursor,
            once: true
          },
          PolarGrid: {
            handler: this.renderPolarGrid,
            once: true
          },
          PolarAngleAxis: {
            handler: this.renderPolarAxis
          },
          PolarRadiusAxis: {
            handler: this.renderPolarAxis
          },
          Customized: {
            handler: this.renderCustomized
          }
        }; // The "compact" mode is mainly used as the panorama within Brush

        if (compact) {
          return /*#__PURE__*/React$2.createElement(Surface, _extends$4({}, attrs, {
            width: width,
            height: height
          }), this.renderClipPath(), renderByOrder(children, map));
        }

        var events = this.parseEventsOfWrapper();
        return /*#__PURE__*/React$2.createElement("div", _extends$4({
          className: classNames('recharts-wrapper', className),
          style: _objectSpread$6({
            position: 'relative',
            cursor: 'default',
            width: width,
            height: height
          }, style)
        }, events, {
          ref: function ref(node) {
            _this2.container = node;
          }
        }), /*#__PURE__*/React$2.createElement(Surface, _extends$4({}, attrs, {
          width: width,
          height: height
        }), this.renderClipPath(), renderByOrder(children, map)), this.renderLegend(), this.renderTooltip());
      }
    }]);

    return CategoricalChartWrapper;
  }(Component), _class.displayName = chartName, _class.defaultProps = _objectSpread$6({
    layout: 'horizontal',
    stackOffset: 'none',
    barCategoryGap: '10%',
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: false,
    syncMethod: 'index'
  }, defaultProps), _class.getDerivedStateFromProps = function (nextProps, prevState) {
    var data = nextProps.data,
        children = nextProps.children,
        width = nextProps.width,
        height = nextProps.height,
        layout = nextProps.layout,
        stackOffset = nextProps.stackOffset,
        margin = nextProps.margin;

    if (isNil_1(prevState.updateId)) {
      var defaultState = createDefaultState(nextProps);
      return _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defaultState), {}, {
        updateId: 0
      }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread$6(_objectSpread$6({
        props: nextProps
      }, defaultState), {}, {
        updateId: 0
      }), prevState)), {}, {
        prevData: data,
        prevWidth: width,
        prevHeight: height,
        prevLayout: layout,
        prevStackOffset: stackOffset,
        prevMargin: margin,
        prevChildren: children
      });
    }

    if (data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !shallowEqual(margin, prevState.prevMargin)) {
      var _defaultState = createDefaultState(nextProps); // Fixes https://github.com/recharts/recharts/issues/2143


      var keepFromPrevState = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: prevState.chartX,
        chartY: prevState.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: prevState.isTooltipActive
      };

      var updatesToState = _objectSpread$6(_objectSpread$6({}, getTooltipData(prevState, data, layout)), {}, {
        updateId: prevState.updateId + 1
      });

      var newState = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, _defaultState), keepFromPrevState), updatesToState);

      return _objectSpread$6(_objectSpread$6(_objectSpread$6({}, newState), updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread$6({
        props: nextProps
      }, newState), prevState)), {}, {
        prevData: data,
        prevWidth: width,
        prevHeight: height,
        prevLayout: layout,
        prevStackOffset: stackOffset,
        prevMargin: margin,
        prevChildren: children
      });
    }

    if (!isChildrenEqual(children, prevState.prevChildren)) {
      // update configuration in chilren
      var hasGlobalData = !isNil_1(data);
      var newUpdateId = hasGlobalData ? prevState.updateId : prevState.updateId + 1;
      return _objectSpread$6(_objectSpread$6({
        updateId: newUpdateId
      }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread$6(_objectSpread$6({
        props: nextProps
      }, prevState), {}, {
        updateId: newUpdateId
      }), prevState)), {}, {
        prevChildren: children
      });
    }

    return null;
  }, _class.renderActiveDot = function (option, props) {
    var dot;

    if ( /*#__PURE__*/isValidElement(option)) {
      dot = /*#__PURE__*/cloneElement(option, props);
    } else if (isFunction_1(option)) {
      dot = option(props);
    } else {
      dot = /*#__PURE__*/React$2.createElement(Dot, props);
    }

    return /*#__PURE__*/React$2.createElement(Layer, {
      className: "recharts-active-dot",
      key: props.key
    }, dot);
  }, _temp;
};

/**
 * @fileOverview Line Chart
 */
var LineChart = generateCategoricalChart({
  chartName: 'LineChart',
  GraphicalChild: Line,
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: XAxis
  }, {
    axisType: 'yAxis',
    AxisComp: YAxis
  }],
  formatAxisMap: formatAxisMap
});

var dayjs_min = {exports: {}};

(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},v="en",D={};D[v]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return v;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(v=i),i||!r&&v},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t);}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return O},m.isValid=function(){return !(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var v=this.$locale().weekStart||0,D=(y<v?y+7:y)-v;return $(r?m-D:m+(6-D),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,v=O.m(this,M);return v=(l={},l[c]=v/12,l[f]=v,l[h]=v/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?v:O.a(v)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[v],w.Ls=D,w.p={},w}));
}(dayjs_min));

var dayjs = dayjs_min.exports;

var utc$1 = {exports: {}};

(function (module, exports) {
!function(t,i){module.exports=i();}(commonjsGlobal,(function(){var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var o=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),o.call(this,t);};var r=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds();}else r.call(this);};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s),null===s))return this;var u=Math.abs(s)<=16?60*s:s,o=this;if(f)return o.$offset=u,o.$u=0===s,o;if(0!==s){var r=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();(o=this.local().add(u+r,t)).$offset=u,o.$x.$localOffset=r;}else o=this.utc();return o};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||this.$d.getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return !!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return "s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)};}}));
}(utc$1));

var utc = utc$1.exports;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$6 = function() {
    __assign$6 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$6.apply(this, arguments);
};

function _typeof$8(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$8 = function _typeof(obj) { return typeof obj; }; } else { _typeof$8 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$8(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike$1(value) {
  return _typeof$8(value) == 'object' && value !== null;
}

// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator

var SYMBOL_TO_STRING_TAG = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printLocation(location) {
  return printSourceLocation(location.source, getLocation(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace$1(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var subLineIndex = Math.floor(columnNum / 80);
    var subLineColumnNum = columnNum % 80;
    var subLines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), subLines[0]]].concat(subLines.slice(1, subLineIndex + 1).map(function (subLine) {
      return ['', subLine];
    }), [[' ', whitespace$1(subLineColumnNum - 1) + '^'], ['', subLines[subLineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace$1(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    _ref[0];
        var line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace$1(len) {
  return Array(len + 1).join(' ');
}

function leftPad(len, str) {
  return whitespace$1(len - str.length) + str;
}

function _typeof$7(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$7 = function _typeof(obj) { return typeof obj; }; } else { _typeof$7 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$7(obj); }

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty$6(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$7(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$7(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$7(Constructor.prototype, protoProps); if (staticProps) _defineProperties$7(Constructor, staticProps); return Constructor; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$5(subClass, superClass); }

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf$5(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$5(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$5(this, result); }; }

function _possibleConstructorReturn$5(self, call) { if (call && (_typeof$7(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$5(self); }

function _assertThisInitialized$5(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf$5(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf$5(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct$4()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf$5(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf$5(o, p) { _setPrototypeOf$5 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$5(o, p); }

function _getPrototypeOf$5(o) { _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$5(o); }
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

var GraphQLError = /*#__PURE__*/function (_Error) {
  _inherits$5(GraphQLError, _Error);

  var _super = _createSuper$4(GraphQLError);

  /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */
  function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
    var _nodeLocations, _nodeLocations2, _nodeLocations3;

    var _this;

    _classCallCheck$6(this, GraphQLError);

    _this = _super.call(this, message);
    _this.name = 'GraphQLError';
    _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.

    _this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined);
    var nodeLocations = [];

    for (var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++) {
      var _this$nodes;

      var _ref4 = _ref3[_i2];
      var loc = _ref4.loc;

      if (loc != null) {
        nodeLocations.push(loc);
      }
    }

    nodeLocations = undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.

    _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
    _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function (loc) {
      return loc.start;
    });
    _this.locations = positions && source ? positions.map(function (pos) {
      return getLocation(source, pos);
    }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function (loc) {
      return getLocation(loc.source, loc.start);
    });
    _this.path = path !== null && path !== void 0 ? path : undefined;
    var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;

    if (extensions == null && isObjectLike$1(originalExtensions)) {
      _this.extensions = _objectSpread$5({}, originalExtensions);
    } else {
      _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
    } // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
    // This ensures that the simplest possible GraphQL service adheres to the spec.


    Object.defineProperties(_assertThisInitialized$5(_this), {
      message: {
        enumerable: true
      },
      locations: {
        enumerable: _this.locations != null
      },
      path: {
        enumerable: _this.path != null
      },
      extensions: {
        enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
      },
      name: {
        enumerable: false
      },
      nodes: {
        enumerable: false
      },
      source: {
        enumerable: false
      },
      positions: {
        enumerable: false
      },
      originalError: {
        enumerable: false
      }
    }); // Include (non-enumerable) stack trace.

    if (originalError !== null && originalError !== void 0 && originalError.stack) {
      Object.defineProperty(_assertThisInitialized$5(_this), 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
      });
      return _possibleConstructorReturn$5(_this);
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')


    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized$5(_this), GraphQLError);
    } else {
      Object.defineProperty(_assertThisInitialized$5(_this), 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
      });
    }

    return _this;
  }

  _createClass$7(GraphQLError, [{
    key: "toString",
    value: function toString() {
      return printError(this);
    } // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet

  }, {
    key: SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Object';
    }
  }]);

  return GraphQLError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */


function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++) {
      var node = _error$nodes2[_i4];

      if (node.loc) {
        output += '\n\n' + printLocation(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++) {
      var location = _error$locations2[_i6];
      output += '\n\n' + printSourceLocation(error.source, location);
    }
  }

  return output;
}

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */

function invariant$1(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}

// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;

/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */

function defineInspect(classObject) {
  var fn = classObject.prototype.toJSON;
  typeof fn === 'function' || invariant$1(0);
  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

  if (nodejsCustomInspectSymbol) {
    classObject.prototype[nodejsCustomInspectSymbol] = fn;
  }
}

/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
var Location = /*#__PURE__*/function () {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  function Location(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  var _proto = Location.prototype;

  _proto.toJSON = function toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  };

  return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

var Token = /*#__PURE__*/function () {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  function Token(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
  }

  var _proto2 = Token.prototype;

  _proto2.toJSON = function toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  };

  return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Token);
/**
 * @internal
 */

function isNode(maybeNode) {
  return maybeNode != null && typeof maybeNode.kind === 'string';
}
/**
 * The list of all possible AST node types.
 */

/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

function _typeof$6(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$6 = function _typeof(obj) { return typeof obj; }; } else { _typeof$6 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$6(obj); }
var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof$6(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(nodejsCustomInspectSymbol)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}

function devAssert(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message);
  }
}

function _typeof$5(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */

// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
var instanceOf = process.env.NODE_ENV === 'production' ? // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
// eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  return value instanceof constructor;
} : // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  if (value instanceof constructor) {
    return true;
  }

  if (_typeof$5(value) === 'object' && value !== null) {
    var _value$constructor;

    var className = constructor.prototype[Symbol.toStringTag];
    var valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
    Symbol.toStringTag in value ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;

    if (className === valueClassName) {
      var stringifiedValue = inspect(value);
      throw new Error("Cannot use ".concat(className, " \"").concat(stringifiedValue, "\" from another module or realm.\n\nEnsure that there is only one instance of \"graphql\" in the node_modules\ndirectory. If different versions of \"graphql\" are the dependencies of other\nrelied on modules, use \"resolutions\" to ensure only one version is installed.\n\nhttps://yarnpkg.com/en/docs/selective-version-resolutions\n\nDuplicate \"graphql\" modules cannot be used at the same time since different\nversions may have different capabilities and behavior. The data from one\nversion used in the function from another could produce confusing and\nspurious results."));
    }
  }

  return false;
};

function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); return Constructor; }

/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
var Source = /*#__PURE__*/function () {
  function Source(body) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
    var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof body === 'string' || devAssert(0, "Body must be a string. Received: ".concat(inspect(body), "."));
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 || devAssert(0, 'line in locationOffset is 1-indexed and must be positive.');
    this.locationOffset.column > 0 || devAssert(0, 'column in locationOffset is 1-indexed and must be positive.');
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet


  _createClass$6(Source, [{
    key: SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Source';
    }
  }]);

  return Source;
}();
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

// eslint-disable-next-line no-redeclare
function isSource(source) {
  return instanceOf(source, Source);
}

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(rawString);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  var startLine = 0;

  while (startLine < lines.length && isBlank(lines[startLine])) {
    ++startLine;
  }

  var endLine = lines.length;

  while (endLine > startLine && isBlank(lines[endLine - 1])) {
    --endLine;
  } // Return a string of the lines joined with U+000A.


  return lines.slice(startLine, endLine).join('\n');
}

function isBlank(str) {
  for (var i = 0; i < str.length; ++i) {
    if (str[i] !== ' ' && str[i] !== '\t') {
      return false;
    }
  }

  return true;
}
/**
 * @internal
 */


function getBlockStringIndentation(value) {
  var _commonIndent;

  var isFirstLine = true;
  var isEmptyLine = true;
  var indent = 0;
  var commonIndent = null;

  for (var i = 0; i < value.length; ++i) {
    switch (value.charCodeAt(i)) {
      case 13:
        //  \r
        if (value.charCodeAt(i + 1) === 10) {
          ++i; // skip \r\n as one symbol
        }

      // falls through

      case 10:
        //  \n
        isFirstLine = false;
        isEmptyLine = true;
        indent = 0;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        ++indent;
        break;

      default:
        if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) {
          commonIndent = indent;
        }

        isEmptyLine = false;
    }
  }

  return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var hasTrailingSlash = value[value.length - 1] === '\\';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

var Lexer = /*#__PURE__*/function () {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  function Lexer(source) {
    var startOfFileToken = new Token(TokenKind.SOF, 0, 0, 0, 0, null);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */


  var _proto = Lexer.prototype;

  _proto.advance = function advance() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  ;

  _proto.lookahead = function lookahead() {
    var token = this.token;

    if (token.kind !== TokenKind.EOF) {
      do {
        var _token$next;

        // Note: next is only mutable during parsing, so we cast to allow this.
        token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
      } while (token.kind === TokenKind.COMMENT);
    }

    return token;
  };

  return Lexer;
}();
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return kind === TokenKind.BANG || kind === TokenKind.DOLLAR || kind === TokenKind.AMP || kind === TokenKind.PAREN_L || kind === TokenKind.PAREN_R || kind === TokenKind.SPREAD || kind === TokenKind.COLON || kind === TokenKind.EQUALS || kind === TokenKind.AT || kind === TokenKind.BRACKET_L || kind === TokenKind.BRACKET_R || kind === TokenKind.BRACE_L || kind === TokenKind.PIPE || kind === TokenKind.BRACE_R;
}

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = prev.end;

  while (pos < bodyLength) {
    var code = body.charCodeAt(pos);
    var _line = lexer.line;

    var _col = 1 + pos - lexer.lineStart; // SourceCharacter


    switch (code) {
      case 0xfeff: // <BOM>

      case 9: //   \t

      case 32: //  <space>

      case 44:
        //  ,
        ++pos;
        continue;

      case 10:
        //  \n
        ++pos;
        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 13:
        //  \r
        if (body.charCodeAt(pos + 1) === 10) {
          pos += 2;
        } else {
          ++pos;
        }

        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 33:
        //  !
        return new Token(TokenKind.BANG, pos, pos + 1, _line, _col, prev);

      case 35:
        //  #
        return readComment(source, pos, _line, _col, prev);

      case 36:
        //  $
        return new Token(TokenKind.DOLLAR, pos, pos + 1, _line, _col, prev);

      case 38:
        //  &
        return new Token(TokenKind.AMP, pos, pos + 1, _line, _col, prev);

      case 40:
        //  (
        return new Token(TokenKind.PAREN_L, pos, pos + 1, _line, _col, prev);

      case 41:
        //  )
        return new Token(TokenKind.PAREN_R, pos, pos + 1, _line, _col, prev);

      case 46:
        //  .
        if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
          return new Token(TokenKind.SPREAD, pos, pos + 3, _line, _col, prev);
        }

        break;

      case 58:
        //  :
        return new Token(TokenKind.COLON, pos, pos + 1, _line, _col, prev);

      case 61:
        //  =
        return new Token(TokenKind.EQUALS, pos, pos + 1, _line, _col, prev);

      case 64:
        //  @
        return new Token(TokenKind.AT, pos, pos + 1, _line, _col, prev);

      case 91:
        //  [
        return new Token(TokenKind.BRACKET_L, pos, pos + 1, _line, _col, prev);

      case 93:
        //  ]
        return new Token(TokenKind.BRACKET_R, pos, pos + 1, _line, _col, prev);

      case 123:
        // {
        return new Token(TokenKind.BRACE_L, pos, pos + 1, _line, _col, prev);

      case 124:
        // |
        return new Token(TokenKind.PIPE, pos, pos + 1, _line, _col, prev);

      case 125:
        // }
        return new Token(TokenKind.BRACE_R, pos, pos + 1, _line, _col, prev);

      case 34:
        //  "
        if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
          return readBlockString(source, pos, _line, _col, prev, lexer);
        }

        return readString(source, pos, _line, _col, prev);

      case 45: //  -

      case 48: //  0

      case 49: //  1

      case 50: //  2

      case 51: //  3

      case 52: //  4

      case 53: //  5

      case 54: //  6

      case 55: //  7

      case 56: //  8

      case 57:
        //  9
        return readNumber(source, pos, code, _line, _col, prev);

      case 65: //  A

      case 66: //  B

      case 67: //  C

      case 68: //  D

      case 69: //  E

      case 70: //  F

      case 71: //  G

      case 72: //  H

      case 73: //  I

      case 74: //  J

      case 75: //  K

      case 76: //  L

      case 77: //  M

      case 78: //  N

      case 79: //  O

      case 80: //  P

      case 81: //  Q

      case 82: //  R

      case 83: //  S

      case 84: //  T

      case 85: //  U

      case 86: //  V

      case 87: //  W

      case 88: //  X

      case 89: //  Y

      case 90: //  Z

      case 95: //  _

      case 97: //  a

      case 98: //  b

      case 99: //  c

      case 100: // d

      case 101: // e

      case 102: // f

      case 103: // g

      case 104: // h

      case 105: // i

      case 106: // j

      case 107: // k

      case 108: // l

      case 109: // m

      case 110: // n

      case 111: // o

      case 112: // p

      case 113: // q

      case 114: // r

      case 115: // s

      case 116: // t

      case 117: // u

      case 118: // v

      case 119: // w

      case 120: // x

      case 121: // y

      case 122:
        // z
        return readName(source, pos, _line, _col, prev);
    }

    throw syntaxError(source, pos, unexpectedCharacterMessage(code));
  }

  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;
  return new Token(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Token(TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw syntaxError(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart


  if (code === 46 || isNameStart(code)) {
    throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new Token(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new Token(TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw syntaxError(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw syntaxError(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new Token(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, dedentBlockStringValue(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new Token(TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z


function isNameStart(code) {
  return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse$2(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

var Parser = /*#__PURE__*/function () {
  function Parser(source, options) {
    var sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(TokenKind.NAME);
    return {
      kind: Kind.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: Kind.DOCUMENT,
      definitions: this.many(TokenKind.SOF, this.parseDefinition, TokenKind.EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(TokenKind.BRACE_L)) {
      return {
        kind: Kind.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(TokenKind.NAME)) {
      name = this.parseName();
    }

    return {
      kind: Kind.OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(TokenKind.PAREN_L, this.parseVariableDefinition, TokenKind.PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(TokenKind.DOLLAR);
    return {
      kind: Kind.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: Kind.SELECTION_SET,
      selections: this.many(TokenKind.BRACE_L, this.parseSelection, TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: Kind.FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(TokenKind.PAREN_L, item, TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return {
      kind: Kind.ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: Kind.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(TokenKind.NAME)) {
      return {
        kind: Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var _this$_options;

    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) {
      return {
        kind: Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case TokenKind.INT:
        this._lexer.advance();

        return {
          kind: Kind.INT,
          value: token.value,
          loc: this.loc(token)
        };

      case TokenKind.FLOAT:
        this._lexer.advance();

        return {
          kind: Kind.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case TokenKind.STRING:
      case TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case TokenKind.NAME:
        this._lexer.advance();

        switch (token.value) {
          case 'true':
            return {
              kind: Kind.BOOLEAN,
              value: true,
              loc: this.loc(token)
            };

          case 'false':
            return {
              kind: Kind.BOOLEAN,
              value: false,
              loc: this.loc(token)
            };

          case 'null':
            return {
              kind: Kind.NULL,
              loc: this.loc(token)
            };

          default:
            return {
              kind: Kind.ENUM,
              value: token.value,
              loc: this.loc(token)
            };
        }

      case TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: Kind.STRING,
      value: token.value,
      block: token.kind === TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: Kind.LIST,
      values: this.any(TokenKind.BRACKET_L, item, TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: Kind.OBJECT,
      fields: this.any(TokenKind.BRACE_L, item, TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return {
      kind: Kind.OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(TokenKind.AT);
    return {
      kind: Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(TokenKind.BRACKET_R);
      type = {
        kind: Kind.LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(TokenKind.BANG)) {
      return {
        kind: Kind.NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: Kind.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(TokenKind.STRING) || this.peek(TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(TokenKind.BRACE_L, this.parseOperationTypeDefinition, TokenKind.BRACE_R);
    return {
      kind: Kind.SCHEMA_DEFINITION,
      description: description,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: Kind.OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: Kind.OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var _this$_options2;

    if (!this.expectOptionalKeyword('implements')) {
      return [];
    }

    if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
      var types = []; // Optional leading ampersand

      this.expectOptionalToken(TokenKind.AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(TokenKind.AMP) || this.peek(TokenKind.NAME));

      return types;
    }

    return this.delimitedMany(TokenKind.AMP, this.parseNamedType);
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    var _this$_options3;

    // Legacy support for the SDL?
    if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek(TokenKind.BRACE_L) && this._lexer.lookahead().kind === TokenKind.BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(TokenKind.BRACE_L, this.parseFieldDefinition, TokenKind.BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(TokenKind.PAREN_L, this.parseInputValueDef, TokenKind.PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: Kind.INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: Kind.INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: Kind.UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    return this.expectOptionalToken(TokenKind.EQUALS) ? this.delimitedMany(TokenKind.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: Kind.ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(TokenKind.BRACE_L, this.parseEnumValueDefinition, TokenKind.BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(TokenKind.BRACE_L, this.parseInputValueDef, TokenKind.BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(TokenKind.BRACE_L, this.parseOperationTypeDefinition, TokenKind.BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.INTERFACE_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: Kind.DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    return this.delimitedMany(TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (DirectiveLocation[name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    var _this$_options4;

    if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) {
      return new Location(startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw syntaxError(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token), "."));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  ;

  _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  };

  return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  var value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */


function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? "\"".concat(kind, "\"") : kind;
}

/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

function visit$3(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error("Invalid AST Node: ".concat(inspect(node), "."));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _visitorKeys$node$kin;

      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */

function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}

/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return visit$3(ast, {
    leave: printDocASTReducer
  });
}
var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap$4('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap$4(' = ', defaultValue) + wrap$4(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    var prefix = wrap$4('', alias, ': ') + name;
    var argsLine = prefix + wrap$4('(', join(args, ', '), ')');

    if (argsLine.length > MAX_LINE_LENGTH) {
      argsLine = prefix + wrap$4('(\n', indent$1(join(args, '\n')), '\n)');
    }

    return join([argsLine, join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap$4(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap$4('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap$4('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap$4('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? printBlockString(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap$4('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: addDescription(function (_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  }),
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap$4('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap$4('(\n', indent$1(join(args, '\n')), '\n)') : wrap$4('(', join(args, ', '), ')')) + ': ' + type + wrap$4(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap$4('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        interfaces = _ref26.interfaces,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, wrap$4('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap$4('(\n', indent$1(join(args, '\n')), '\n)') : wrap$4('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap$4('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        interfaces = _ref35.interfaces,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, wrap$4('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray) {
  var _maybeArray$filter$jo;

  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function (x) {
    return x;
  }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return wrap$4('{\n', indent$1(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */


function wrap$4(start, maybeString) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}

function indent$1(str) {
  return wrap$4('  ', str.replace(/\n/g, '\n  '));
}

function isMultiline(str) {
  return str.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray != null && maybeArray.some(isMultiline);
}

var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize$1(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize$1(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return __assign$6(__assign$6({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize$1(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse$2(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
var gql$1 = gql;

const GET_BLOCKS = (timestamps) => {
  let queryString = 'query blocks {';
  queryString += timestamps.map((timestamp) => {
    return `t${timestamp}:blocks(first: 1, orderBy: timestamp, orderDirection: asc, where: { timestamp_gt: ${timestamp}, timestamp_lt: ${
      timestamp + 60 * 60 * 24 * 7
    } }) {
      number
    }`;
  });
  queryString += '}';
  return gql$1(queryString);
};

const PRICES_BY_BLOCK = (tokenAddress, blocks) => {
  let queryString = 'query blocks {';
  queryString += blocks.map(
    (block) => `
      t${block.timestamp}:token(id:"${tokenAddress}", block: { number: ${block.number} }) { 
        derivedETH
      }
    `,
  );
  queryString += ',';
  queryString += blocks.map(
    (block) => `
      b${block.timestamp}: bundle(id:"1", block: { number: ${block.number} }) { 
        ethPrice
      }
    `,
  );

  queryString += '}';
  return gql$1(queryString);
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$4 = function(d, b) {
    extendStatics$4 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics$4(d, b);
};

function __extends$4(d, b) {
    extendStatics$4(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$5 = function() {
    __assign$5 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$5.apply(this, arguments);
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$3 = function(d, b) {
    extendStatics$3 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics$3(d, b);
};

function __extends$3(d, b) {
    extendStatics$3(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var genericMessage = "Invariant Violation";
var _a$1 = Object.setPrototypeOf, setPrototypeOf = _a$1 === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a$1;
var InvariantError = /** @class */ (function (_super) {
    __extends$3(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
function wrapConsoleMethod(method) {
    return function () {
        return console[method].apply(console, arguments);
    };
}
(function (invariant) {
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var processStub = { env: {} };
if (typeof process === "object") {
    processStub = process;
}
else
    try {
        // Using Function to evaluate this assignment in global scope also escapes
        // the strict mode of the current module, thereby allowing the assignment.
        // Inspired by https://github.com/facebook/regenerator/pull/369.
        Function("stub", "process = stub")(processStub);
    }
    catch (atLeastWeTried) {
        // The assignment can fail if a Content Security Policy heavy-handedly
        // forbids Function usage. In those environments, developers should take
        // extra care to replace process.env.NODE_ENV in their production builds,
        // or define an appropriate global.process polyfill.
    }

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$4 = function() {
    __assign$4 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$4.apply(this, arguments);
};

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var fastJsonStableStringify = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};

var _a = Object.prototype, toString$6 = _a.toString, hasOwnProperty$3 = _a.hasOwnProperty;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal$2(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = toString$6.call(a);
    var bTag = toString$6.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (var k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty$3.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (var k = 0; k < keyCount; ++k) {
                var key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while (true) {
                var info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}

function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw process.env.NODE_ENV === "production" ? new InvariantError(17) : new InvariantError("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\"" +
            'is not supported. Use variables instead of inline arguments to ' +
            'overcome this limitation.');
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
function getStoreKeyName(fieldName, args, directives) {
    if (directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = fastJsonStableStringify(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            }
            else {
                completeFieldName += "@" + key;
            }
        });
    }
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
function isIdValue(idObject) {
    return idObject &&
        idObject.type === 'id' &&
        typeof idObject.generated === 'boolean';
}
function toIdValue(idConfig, generated) {
    if (generated === void 0) { generated = false; }
    return __assign$4({ type: 'id', generated: generated }, (typeof idConfig === 'string'
        ? { id: idConfig, typename: undefined }
        : idConfig));
}
function isJsonValue(jsonObject) {
    return (jsonObject != null &&
        typeof jsonObject === 'object' &&
        jsonObject.type === 'json');
}

function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function (directive) {
            directiveObj_1[directive.name.value] = argumentsObjectFromField(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function shouldInclude(selection, variables) {
    if (variables === void 0) { variables = {}; }
    return getInclusionDirectives(selection.directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            process.env.NODE_ENV === "production" ? invariant(evaledValue !== void 0, 13) : invariant(evaledValue !== void 0, "Invalid variable referenced in @" + directive.name.value + " directive.");
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(doc) {
    var names = [];
    visit$3(doc, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
function hasDirectives(names, doc) {
    return getDirectiveNames(doc).some(function (name) { return names.indexOf(name) > -1; });
}
function hasClientExports(document) {
    return (document &&
        hasDirectives(['client'], document) &&
        hasDirectives(['export'], document));
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function getInclusionDirectives(directives) {
    return directives ? directives.filter(isInclusionDirective).map(function (directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        process.env.NODE_ENV === "production" ? invariant(directiveArguments && directiveArguments.length === 1, 14) : invariant(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @" + directiveName + " directive.");
        var ifArgument = directiveArguments[0];
        process.env.NODE_ENV === "production" ? invariant(ifArgument.name && ifArgument.name.value === 'if', 15) : invariant(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @" + directiveName + " directive.");
        var ifValue = ifArgument.value;
        process.env.NODE_ENV === "production" ? invariant(ifValue &&
            (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16) : invariant(ifValue &&
            (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
        return { directive: directive, ifArgument: ifArgument };
    }) : [];
}

function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw process.env.NODE_ENV === "production" ? new InvariantError(11) : new InvariantError("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
        process.env.NODE_ENV === "production" ? invariant(fragments.length === 1, 12) : invariant(fragments.length === 1, "Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
        actualFragmentName = fragments[0].name.value;
    }
    var query = __assign$4(__assign$4({}, document), { definitions: __spreadArrays([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions) });
    return query;
}

function assign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) {
        if (typeof source === 'undefined' || source === null) {
            return;
        }
        Object.keys(source).forEach(function (key) {
            target[key] = source[key];
        });
    });
    return target;
}
function checkDocument(doc) {
    process.env.NODE_ENV === "production" ? invariant(doc && doc.kind === 'Document', 2) : invariant(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw process.env.NODE_ENV === "production" ? new InvariantError(3) : new InvariantError("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
        }
        return definition;
    });
    process.env.NODE_ENV === "production" ? invariant(operations.length <= 1, 4) : invariant(operations.length <= 1, "Ambiguous GraphQL document: contains " + operations.length + " operations");
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    process.env.NODE_ENV === "production" ? invariant(queryDef && queryDef.operation === 'query', 6) : invariant(queryDef && queryDef.operation === 'query', 'Must contain a query definition.');
    return queryDef;
}
function getFragmentDefinition(doc) {
    process.env.NODE_ENV === "production" ? invariant(doc.kind === 'Document', 7) : invariant(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    process.env.NODE_ENV === "production" ? invariant(doc.definitions.length <= 1, 8) : invariant(doc.definitions.length <= 1, 'Fragment must have exactly one definition.');
    var fragmentDef = doc.definitions[0];
    process.env.NODE_ENV === "production" ? invariant(fragmentDef.kind === 'FragmentDefinition', 9) : invariant(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.');
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw process.env.NODE_ENV === "production" ? new InvariantError(10) : new InvariantError('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.');
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getDefaultValues(definition) {
    if (definition &&
        definition.variableDefinitions &&
        definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions
            .filter(function (_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        })
            .map(function (_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            valueToObjectRepresentation(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return assign.apply(void 0, __spreadArrays([{}], defaultValues));
    }
    return {};
}

function filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function (elem, i) {
        if (test.call(this, elem, i, array)) {
            array[target++] = elem;
        }
    }, context);
    array.length = target;
    return array;
}

var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function (selection) {
        return selection.kind === 'FragmentSpread' &&
            isEmpty(fragments[selection.name.value], fragments);
    });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            return (dir.name && dir.name === directive.name.value) ||
                (dir.test && dir.test(directive));
        });
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = nullIfDocIsEmpty(visit$3(doc, {
        Variable: {
            enter: function (node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') {
                    variablesInUse[node.name.value] = true;
                }
            },
        },
        Field: {
            enter: function (node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function (directive) { return directive.remove; });
                    if (shouldRemoveField &&
                        node.directives &&
                        node.directives.some(getDirectiveMatcher(directives))) {
                        if (node.arguments) {
                            node.arguments.forEach(function (arg) {
                                if (arg.value.kind === 'Variable') {
                                    variablesToRemove.push({
                                        name: arg.value.name.value,
                                    });
                                }
                            });
                        }
                        if (node.selectionSet) {
                            getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value,
                                });
                            });
                        }
                        return null;
                    }
                }
            },
        },
        FragmentSpread: {
            enter: function (node) {
                fragmentSpreadsInUse[node.name.value] = true;
            },
        },
        Directive: {
            enter: function (node) {
                if (getDirectiveMatcher(directives)(node)) {
                    return null;
                }
            },
        },
    }));
    if (modifiedDoc &&
        filterInPlace(variablesToRemove, function (v) { return !variablesInUse[v.name]; }).length) {
        modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
    }
    if (modifiedDoc &&
        filterInPlace(fragmentSpreadsToRemove, function (fs) { return !fragmentSpreadsInUse[fs.name]; })
            .length) {
        modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
    }
    return modifiedDoc;
}
function addTypenameToDocument(doc) {
    return visit$3(checkDocument(doc), {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === 'OperationDefinition') {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return (isField(selection) &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                var field = parent;
                if (isField(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === 'export'; })) {
                    return;
                }
                return __assign$4(__assign$4({}, node), { selections: __spreadArrays(selections, [TYPENAME_FIELD]) });
            },
        },
    });
}
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                process.env.NODE_ENV === "production" || invariant.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === 'Variable' &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty(visit$3(doc, {
        OperationDefinition: {
            enter: function (node) {
                return __assign$4(__assign$4({}, node), { variableDefinitions: node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function (arg) {
                        if (argMatcher(arg)) {
                            argMatchCount_1 += 1;
                        }
                    });
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty(visit$3(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function (selection) {
        if ((isField(selection) || isInlineFragment(selection)) &&
            selection.selectionSet) {
            getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) { return allFragments.push(frag); });
        }
        else if (selection.kind === 'FragmentSpread') {
            allFragments.push(selection);
        }
    });
    return allFragments;
}
function buildQueryFromSelectionSet(document) {
    var definition = getMainDefinition(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = visit$3(document, {
        OperationDefinition: {
            enter: function (node) {
                return __assign$4(__assign$4({}, node), { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    checkDocument(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    if (modifiedDoc) {
        modifiedDoc = visit$3(modifiedDoc, {
            FragmentDefinition: {
                enter: function (node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
                            return isField(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) {
                            return null;
                        }
                    }
                },
            },
        });
    }
    return modifiedDoc;
}

var canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' &&
    navigator.product === 'ReactNative');

var toString$5 = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value, new Map());
}
function cloneDeepHelper(val, seen) {
    switch (toString$5.call(val)) {
        case "[object Array]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}

function getEnv() {
    if (typeof process !== 'undefined' && process.env.NODE_ENV) {
        return process.env.NODE_ENV;
    }
    return 'development';
}
function isEnv(env) {
    return getEnv() === env;
}
function isProduction() {
    return isEnv('production') === true;
}
function isDevelopment() {
    return isEnv('development') === true;
}
function isTest() {
    return isEnv('test') === true;
}

function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}

function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
function maybeDeepFreeze(obj) {
    if (isDevelopment() || isTest()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) {
            return deepFreeze(obj);
        }
    }
    return obj;
}

var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = shallowCopyForMerge(target, pastCopies);
        for (var i = 1; i < count; ++i) {
            target = mergeHelper(target, sources[i], pastCopies);
        }
    }
    return target;
}
function isObject$2(obj) {
    return obj !== null && typeof obj === 'object';
}
function mergeHelper(target, source, pastCopies) {
    if (isObject$2(source) && isObject$2(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) {
            target = shallowCopyForMerge(target, pastCopies);
        }
        Object.keys(source).forEach(function (sourceKey) {
            var sourceValue = source[sourceKey];
            if (hasOwnProperty$2.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) {
                    target[sourceKey] = mergeHelper(shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
                }
            }
            else {
                target[sourceKey] = sourceValue;
            }
        });
        return target;
    }
    return source;
}
function shallowCopyForMerge(value, pastCopies) {
    if (value !== null &&
        typeof value === 'object' &&
        pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) {
            value = value.slice(0);
        }
        else {
            value = __assign$4({ __proto__: Object.getPrototypeOf(value) }, value);
        }
        pastCopies.push(value);
    }
    return value;
}

function queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [op],
    };
    return out;
}
function fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType',
            },
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [frag],
    };
    return out;
}
function selectionSetFromObj(obj) {
    if (typeof obj === 'number' ||
        typeof obj === 'boolean' ||
        typeof obj === 'string' ||
        typeof obj === 'undefined' ||
        obj === null) {
        return null;
    }
    if (Array.isArray(obj)) {
        return selectionSetFromObj(obj[0]);
    }
    var selections = [];
    Object.keys(obj).forEach(function (key) {
        var nestedSelSet = selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key,
            },
            selectionSet: nestedSelSet || undefined,
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections,
    };
    return selectionSet;
}
var justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename',
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null,
                    },
                ],
            },
        },
    ],
};

var ApolloCache = (function () {
    function ApolloCache() {
    }
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: getFragmentQueryDocument(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables,
        });
    };
    ApolloCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: getFragmentQueryDocument(options.fragment, options.fragmentName),
        });
    };
    ApolloCache.prototype.writeData = function (_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: justTypenameQuery,
                });
            }
            catch (e) {
            }
            var __typename = (typenameResult && typenameResult.__typename) || '__ClientData';
            var dataToWrite = Object.assign({ __typename: __typename }, data);
            this.writeFragment({
                id: id,
                fragment: fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite,
            });
        }
        else {
            this.writeQuery({ query: queryFromPojo(data), data: data });
        }
    };
    return ApolloCache;
}());

// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var MISSING_VALUE = {};
var idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var makeSlotClass = function () { return /** @class */ (function () {
    function Slot() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    Slot.prototype.hasValue = function () {
        for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context_1 !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    };
    Slot.prototype.getValue = function () {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    };
    Slot.prototype.withValue = function (value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        var _a;
        var slots = (_a = {
                __proto__: null
            },
            _a[this.id] = value,
            _a);
        var parent = currentContext;
        currentContext = { parent: parent, slots: slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    };
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    Slot.bind = function (callback) {
        var context = currentContext;
        return function () {
            var saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    };
    // Immediately run a callback function without any captured context.
    Slot.noContext = function (callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            var saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    };
    return Slot;
}()); };
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var globalKey = "@wry/context:Slot";
var host = Array;
var Slot = host[globalKey] || function () {
    var Slot = makeSlotClass();
    try {
        Object.defineProperty(host, globalKey, {
            value: host[globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false,
        });
    }
    finally {
        return Slot;
    }
}();

Slot.bind; Slot.noContext;

function defaultDispose() { }
var Cache$2 = /** @class */ (function () {
    function Cache(max, dispose) {
        if (max === void 0) { max = Infinity; }
        if (dispose === void 0) { dispose = defaultDispose; }
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function (key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function (key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function (key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) {
                this.oldest = newer;
            }
        }
        return entry;
    };
    Cache.prototype.set = function (key, value) {
        var entry = this.getEntry(key);
        if (entry) {
            return entry.value = value;
        }
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = entry;
        }
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function () {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    };
    Cache.prototype.delete = function (key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) {
                this.newest = entry.older;
            }
            if (entry === this.oldest) {
                this.oldest = entry.newer;
            }
            if (entry.newer) {
                entry.newer.older = entry.older;
            }
            if (entry.older) {
                entry.older.newer = entry.newer;
            }
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}());

var parentEntrySlot = new Slot();

var reusableEmptyArray = [];
var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert$2(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    var len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
var Entry = /** @class */ (function () {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function () {
        assert$2(!this.recomputing, "already recomputing");
        if (!rememberParent(this) && maybeReportOrphan(this)) {
            // The recipient of the entry.reportOrphan callback decided to dispose
            // of this orphan entry by calling entry.dispose(), so we don't need to
            // (and should not) proceed with the recomputation.
            return void 0;
        }
        return mightBeDirty(this)
            ? reallyRecompute(this)
            : valueGet(this.value);
    };
    Entry.prototype.setDirty = function () {
        if (this.dirty)
            return;
        this.dirty = true;
        this.value.length = 0;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function () {
        var _this = this;
        forgetChildren(this).forEach(maybeReportOrphan);
        maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function (parent) {
            parent.setDirty();
            forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}());
function rememberParent(child) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry]);
    if (maybeSubscribe(entry)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach(maybeReportOrphan);
    return valueGet(entry.value);
}
function recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    }
    catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    child.parents.forEach(function (parent) { return reportDirtyChild(parent, child); });
}
function reportClean(child) {
    child.parents.forEach(function (parent) { return reportCleanChild(parent, child); });
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert$2(parent.childValues.has(child));
    assert$2(mightBeDirty(child));
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert$2(parent.childValues.has(child));
    assert$2(!mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function maybeReportOrphan(entry) {
    return entry.parents.size === 0 &&
        typeof entry.reportOrphan === "function" &&
        entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    var children = reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function (_value, child) {
            forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert$2(parent.dirtyChildren === null);
    return children;
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, entry.args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}

// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var KeyTrie = /** @class */ (function () {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
        }
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function (array) {
        var node = this;
        array.forEach(function (key) { return node = node.getChildTrie(key); });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function (key) {
        var map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child)
            map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}());
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var keyTrie = new KeyTrie(typeof WeakMap === "function");
function defaultMakeCacheKey() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return keyTrie.lookupArray(args);
}
var caches = new Set();
function wrap$3(originalFunction, options) {
    if (options === void 0) { options = Object.create(null); }
    var cache = new Cache$2(options.max || Math.pow(2, 16), function (entry) { return entry.dispose(); });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || defaultMakeCacheKey;
    function optimistic() {
        if (disposable && !parentEntrySlot.hasValue()) {
            // If there's no current parent computation, and this wrapped
            // function is disposable (meaning we don't care about entry.value,
            // just dependency tracking), then we can short-cut everything else
            // in this function, because entry.recompute() is going to recycle
            // the entry object without recomputing anything, anyway.
            return void 0;
        }
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) {
            entry.args = args;
        }
        else {
            entry = new Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) {
                entry.reportOrphan = function () { return cache.delete(key); };
            }
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(function (cache) { return cache.clean(); });
            caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function () {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) {
            child.setDirty();
        }
    };
    return optimistic;
}

var haveWarned = false;
function shouldWarn() {
    var answer = !haveWarned;
    if (!isTest()) {
        haveWarned = true;
    }
    return answer;
}
var HeuristicFragmentMatcher = (function () {
    function HeuristicFragmentMatcher() {
    }
    HeuristicFragmentMatcher.prototype.ensureReady = function () {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function () {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) {
            return isRootQuery;
        }
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            if (shouldWarn()) {
                process.env.NODE_ENV === "production" || invariant.warn("You're using fragments in your queries, but either don't have the addTypename:\n  true option set in Apollo Client, or you are trying to write a fragment to the store without the __typename.\n   Please turn on the addTypename option and include __typename when writing fragments so that Apollo Client\n   can accurately match fragments.");
                process.env.NODE_ENV === "production" || invariant.warn('Could not find __typename on Fragment ', typeCondition, obj);
                process.env.NODE_ENV === "production" || invariant.warn("DEPRECATION WARNING: using fragments without __typename is unsupported behavior " +
                    "and will be removed in future versions of Apollo client. You should fix this and set addTypename to true now.");
            }
            return 'heuristic';
        }
        if (__typename === typeCondition) {
            return true;
        }
        if (shouldWarn()) {
            process.env.NODE_ENV === "production" || invariant.error('You are using the simple (heuristic) fragment matcher, but your ' +
                'queries contain union or interface types. Apollo Client will not be ' +
                'able to accurately map fragments. To make this error go away, use ' +
                'the `IntrospectionFragmentMatcher` as described in the docs: ' +
                'https://www.apollographql.com/docs/react/advanced/fragments.html#fragment-matcher');
        }
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}());

var hasOwn$1 = Object.prototype.hasOwnProperty;
var DepTrackingCache = (function () {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) { data = Object.create(null); }
        this.data = data;
        this.depend = wrap$3(function (dataId) { return _this.data[dataId]; }, {
            disposable: true,
            makeCacheKey: function (dataId) {
                return dataId;
            },
        });
    }
    DepTrackingCache.prototype.toObject = function () {
        return this.data;
    };
    DepTrackingCache.prototype.get = function (dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function (dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function (dataId) {
        if (hasOwn$1.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function () {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function (newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function (dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function (dataId) {
                if (!hasOwn$1.call(newData, dataId)) {
                    _this.delete(dataId);
                }
            });
        }
        else {
            Object.keys(this.data).forEach(function (dataId) {
                _this.delete(dataId);
            });
        }
    };
    return DepTrackingCache;
}());
function defaultNormalizedCacheFactory(seed) {
    return new DepTrackingCache(seed);
}

var StoreReader = (function () {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new KeyTrie(canUseWeakMap) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = wrap$3(function (options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof DepTrackingCache) {
                    return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
                }
            }
        });
        this.executeSelectionSet = wrap$3(function (options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof DepTrackingCache) {
                    return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
                }
            }
        });
        this.executeSubSelectedArray = wrap$3(function (options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof DepTrackingCache) {
                    return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
                }
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function (options) {
        return this.diffQueryAgainstStore(__assign$5(__assign$5({}, options), { returnPartialData: false })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = getQueryDefinition(query);
        variables = assign({}, getDefaultValues(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: (config && config.cacheRedirects) || {},
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query',
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction,
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) {
            execResult.missing.forEach(function (info) {
                if (info.tolerable)
                    return;
                throw process.env.NODE_ENV === "production" ? new InvariantError(8) : new InvariantError("Can't find field " + info.fieldName + " on object " + JSON.stringify(info.object, null, 2) + ".");
            });
        }
        if (previousResult) {
            if (equal$2(previousResult, execResult.result)) {
                execResult.result = previousResult;
            }
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields,
        };
    };
    StoreReader.prototype.executeStoreQuery = function (_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? defaultFragmentMatcher : _b;
        var mainDefinition = getMainDefinition(query);
        var fragments = getFragmentDefinitions(query);
        var fragmentMap = createFragmentMap(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher,
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext,
        });
    };
    StoreReader.prototype.executeSelectionSet = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = { result: null };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = (object && object.__typename) ||
            (rootValue.id === 'ROOT_QUERY' && 'Query') ||
            void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function (selection) {
            var _a;
            if (!shouldInclude(selection, variables)) {
                return;
            }
            if (isField(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') {
                    objectsToMerge.push((_a = {},
                        _a[resultKeyNameFromField(selection)] = fieldResult,
                        _a));
                }
            }
            else {
                var fragment = void 0;
                if (isInlineFragment(selection)) {
                    fragment = selection;
                }
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) {
                        throw process.env.NODE_ENV === "production" ? new InvariantError(9) : new InvariantError("No fragment named " + selection.name.value);
                    }
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition ||
                    execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext,
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) {
                        fragmentExecResult = __assign$5(__assign$5({}, fragmentExecResult), { missing: fragmentExecResult.missing.map(function (info) {
                                return __assign$5(__assign$5({}, info), { tolerable: true });
                            }) });
                    }
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = mergeDeepArray(objectsToMerge);
        if (this.freezeResults && process.env.NODE_ENV !== 'production') {
            Object.freeze(finalResult.result);
        }
        return finalResult;
    };
    StoreReader.prototype.executeField = function (object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = argumentsObjectFromField(field, variables);
        var info = {
            resultKey: resultKeyNameFromField(field),
            directives: getDirectiveInfoFromField(field, variables),
        };
        var readStoreResult = readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) {
            return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
                field: field,
                array: readStoreResult.result,
                execContext: execContext,
            }));
        }
        if (!field.selectionSet) {
            assertSelectionSetForIdValue(field, readStoreResult.result);
            if (this.freezeResults && process.env.NODE_ENV !== 'production') {
                maybeDeepFreeze(readStoreResult);
            }
            return readStoreResult;
        }
        if (readStoreResult.result == null) {
            return readStoreResult;
        }
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext,
        }));
    };
    StoreReader.prototype.combineExecResults = function () {
        var execResults = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            execResults[_i] = arguments[_i];
        }
        var missing;
        execResults.forEach(function (execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing,
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    execContext: execContext,
                }));
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    rootValue: item,
                    execContext: execContext,
                }));
            }
            assertSelectionSetForIdValue(field, item);
            return item;
        });
        if (this.freezeResults && process.env.NODE_ENV !== 'production') {
            Object.freeze(array);
        }
        return { result: array, missing: missing };
    };
    return StoreReader;
}());
function assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && isIdValue(value)) {
        throw process.env.NODE_ENV === "production" ? new InvariantError(10) : new InvariantError("Missing selection set for object of type " + value.typename + " returned for query field " + field.name.value);
    }
}
function defaultFragmentMatcher() {
    return true;
}
function readStoreResolver(object, typename, fieldName, args, context, _a) {
    _a.resultKey; var directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) {
        storeKeyName = getStoreKeyName(storeKeyName, args, directives);
    }
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' &&
            context.cacheRedirects &&
            typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) {
                    fieldValue = resolver(object, args, {
                        getCacheKey: function (storeObj) {
                            var id = context.dataIdFromObject(storeObj);
                            return id && toIdValue({
                                id: id,
                                typename: storeObj.__typename,
                            });
                        },
                    });
                }
            }
        }
    }
    if (typeof fieldValue === 'undefined') {
        return {
            result: fieldValue,
            missing: [{
                    object: object,
                    fieldName: storeKeyName,
                    tolerable: false,
                }],
        };
    }
    if (isJsonValue(fieldValue)) {
        fieldValue = fieldValue.json;
    }
    return {
        result: fieldValue,
    };
}

var ObjectCache = (function () {
    function ObjectCache(data) {
        if (data === void 0) { data = Object.create(null); }
        this.data = data;
    }
    ObjectCache.prototype.toObject = function () {
        return this.data;
    };
    ObjectCache.prototype.get = function (dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function (dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function (dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function () {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function (newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}());

var WriteError = (function (_super) {
    __extends$4(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error));
function enhanceErrorWithDocument(error, document) {
    var enhancedError = new WriteError("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var StoreWriter = (function () {
    function StoreWriter() {
    }
    StoreWriter.prototype.writeQueryToStore = function (_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction,
        });
    };
    StoreWriter.prototype.writeResultToStore = function (_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = getOperationDefinition(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: assign({}, getDefaultValues(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: createFragmentMap(getFragmentDefinitions(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction,
                },
            });
        }
        catch (e) {
            throw enhanceErrorWithDocument(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function (_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function (selection) {
            var _a;
            if (!shouldInclude(selection, variables)) {
                return;
            }
            if (isField(selection)) {
                var resultFieldKey = resultKeyNameFromField(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') {
                    _this.writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context,
                    });
                }
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function (directive) { return directive.name && directive.name.value === 'defer'; });
                        isClient = selection.directives.some(function (directive) { return directive.name && directive.name.value === 'client'; });
                    }
                    if (!isDefered && !isClient && context.fragmentMatcherFunction) {
                        process.env.NODE_ENV === "production" || invariant.warn("Missing field " + resultFieldKey + " in " + JSON.stringify(result, null, 2).substring(0, 100));
                    }
                }
            }
            else {
                var fragment = void 0;
                if (isInlineFragment(selection)) {
                    fragment = selection;
                }
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    process.env.NODE_ENV === "production" ? invariant(fragment, 3) : invariant(fragment, "No fragment named " + selection.name.value + ".");
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = toIdValue({ id: id, typename: undefined });
                    var fakeContext = {
                        store: new ObjectCache((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {},
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    if (!isProduction() && match === 'heuristic') {
                        process.env.NODE_ENV === "production" || invariant.error('WARNING: heuristic fragment matching going on!');
                    }
                    matches = !!match;
                }
                if (matches) {
                    _this.writeSelectionSetToStore({
                        result: result,
                        selectionSet: fragment.selectionSet,
                        dataId: dataId,
                        context: context,
                    });
                }
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function (_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = storeKeyNameFromField(field, variables);
        if (!field.selectionSet || value === null) {
            storeValue =
                value != null && typeof value === 'object'
                    ?
                        { type: 'json', json: value }
                    :
                        value;
        }
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        }
        else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!isGeneratedId(valueDataId)) {
                valueDataId = '$' + valueDataId;
            }
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                process.env.NODE_ENV === "production" ? invariant(!semanticId || !isGeneratedId(semanticId), 4) : invariant(!semanticId || !isGeneratedId(semanticId), 'IDs returned by dataIdFromObject cannot begin with the "$" character.');
                if (semanticId ||
                    (typeof semanticId === 'number' && semanticId === 0)) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(valueDataId, field, context.processedData)) {
                this.writeSelectionSetToStore({
                    dataId: valueDataId,
                    result: value,
                    selectionSet: field.selectionSet,
                    context: context,
                });
            }
            var typename = value.__typename;
            storeValue = toIdValue({ id: valueDataId, typename: typename }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && isIdValue(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                process.env.NODE_ENV === "production" ? invariant(!generated || escapedId.generated || typenameChanged, 5) : invariant(!generated || escapedId.generated || typenameChanged, "Store error: the application attempted to write an object with no provided id but the store already contains an id of " + escapedId.id + " for this object. The selectionSet that was trying to be written is:\n" + JSON.stringify(field));
                process.env.NODE_ENV === "production" ? invariant(!hadTypename || hasTypename, 6) : invariant(!hadTypename || hasTypename, "Store error: the application attempted to write an object with no provided typename but the store already contains an object with typename of " + escapedId.typename + " for the object of id " + escapedId.id + ". The selectionSet that was trying to be written is:\n" + JSON.stringify(field));
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) {
                            store.delete(escapedId.id);
                        }
                    }
                    else {
                        mergeWithGenerated(escapedId.id, storeValue.id, store);
                    }
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !equal$2(storeValue, storeObject[storeFieldName])) {
            store.set(dataId, __assign$5(__assign$5({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
        }
    };
    StoreWriter.prototype.processArrayValue = function (value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function (item, index) {
            if (item === null) {
                return null;
            }
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) {
                return _this.processArrayValue(item, itemDataId, selectionSet, context);
            }
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) {
                _this.writeSelectionSetToStore({
                    dataId: itemDataId,
                    result: item,
                    selectionSet: selectionSet,
                    context: context,
                });
            }
            return toIdValue({ id: itemDataId, typename: item.__typename }, generated);
        });
    };
    return StoreWriter;
}());
function isGeneratedId(id) {
    return id[0] === '$';
}
function mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) {
        return false;
    }
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function (key) {
        var value = generated[key];
        var realValue = real[key];
        if (isIdValue(value) &&
            isGeneratedId(value.id) &&
            isIdValue(realValue) &&
            !equal$2(value, realValue) &&
            mergeWithGenerated(value.id, realValue.id, cache)) {
            madeChanges = true;
        }
    });
    cache.delete(generatedKey);
    var newRealValue = __assign$5(__assign$5({}, generated), real);
    if (equal$2(newRealValue, real)) {
        return madeChanges;
    }
    cache.set(realKey, newRealValue);
    return true;
}
function isDataProcessed(dataId, field, processedData) {
    if (!processedData) {
        return false;
    }
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) {
            return true;
        }
        else {
            processedData[dataId].push(field);
        }
    }
    else {
        processedData[dataId] = [field];
    }
    return false;
}

var defaultConfig = {
    fragmentMatcher: new HeuristicFragmentMatcher(),
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    freezeResults: false,
};
function defaultDataIdFromObject(result) {
    if (result.__typename) {
        if (result.id !== undefined) {
            return result.__typename + ":" + result.id;
        }
        if (result._id !== undefined) {
            return result.__typename + ":" + result._id;
        }
    }
    return null;
}
var hasOwn$1$1 = Object.prototype.hasOwnProperty;
var OptimisticCacheLayer = (function (_super) {
    __extends$4(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function () {
        return __assign$5(__assign$5({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function (dataId) {
        return hasOwn$1$1.call(this.data, dataId)
            ? this.data[dataId]
            : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}(ObjectCache));
var InMemoryCache = (function (_super) {
    __extends$4(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new KeyTrie(canUseWeakMap);
        _this.silenceBroadcast = false;
        _this.config = __assign$5(__assign$5({}, defaultConfig), config);
        if (_this.config.customResolvers) {
            process.env.NODE_ENV === "production" || invariant.warn('customResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating customResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.customResolvers;
        }
        if (_this.config.cacheResolvers) {
            process.env.NODE_ENV === "production" || invariant.warn('cacheResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating cacheResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.cacheResolvers;
        }
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching
            ? new DepTrackingCache()
            : new ObjectCache();
        _this.optimisticData = _this.data;
        _this.storeWriter = new StoreWriter();
        _this.storeReader = new StoreReader({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults,
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = wrap$3(function (c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function (c) {
                if (c.optimistic) {
                    return;
                }
                if (c.previousResult) {
                    return;
                }
                if (cache.data instanceof DepTrackingCache) {
                    return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
                }
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function (data) {
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function (options) {
        if (typeof options.rootId === 'string' &&
            typeof this.data.get(options.rootId) === 'undefined') {
            return null;
        }
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config,
        }) || null;
    };
    InMemoryCache.prototype.write = function (write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction,
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function (query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config,
        });
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        this.watches.add(watch);
        return function () {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function (query) {
        throw process.env.NODE_ENV === "production" ? new InvariantError(7) : new InvariantError("eviction is not implemented on InMemory Cache");
    };
    InMemoryCache.prototype.reset = function () {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while (layer instanceof OptimisticCacheLayer) {
            if (layer.optimisticId === idToRemove) {
                ++removedCount;
            }
            else {
                toReapply.push(layer);
            }
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while (toReapply.length > 0) {
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function (transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') {
            this.data = this.optimisticData = new OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        }
        try {
            transaction(this);
        }
        finally {
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function (transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = addTypenameToDocument(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function () {
        var _this = this;
        if (!this.silenceBroadcast) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c); });
        }
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function (c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic,
        }));
    };
    return InMemoryCache;
}(ApolloCache));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$2 = function(d, b) {
    extendStatics$2 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics$2(d, b);
};

function __extends$2(d, b) {
    extendStatics$2(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$3 = function() {
    __assign$3 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var Observable$4 = {};

Object.defineProperty(Observable$4, "__esModule", {
  value: true
});
Observable$4.Observable = void 0;

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable$3;
}

function isObservable(x) {
  return x instanceof Observable$3; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(observer, subscriber) {
    _classCallCheck$5(this, Subscription);

    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  _createClass$5(Subscription, [{
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this._state !== 'closed') {
        closeSubscription(this);
        cleanupSubscription(this);
      }
    }
  }, {
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver =
/*#__PURE__*/
function () {
  function SubscriptionObserver(subscription) {
    _classCallCheck$5(this, SubscriptionObserver);

    this._subscription = subscription;
  }

  _createClass$5(SubscriptionObserver, [{
    key: "next",
    value: function next(value) {
      onNotify(this._subscription, 'next', value);
    }
  }, {
    key: "error",
    value: function error(value) {
      onNotify(this._subscription, 'error', value);
    }
  }, {
    key: "complete",
    value: function complete() {
      onNotify(this._subscription, 'complete');
    }
  }, {
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable$3 =
/*#__PURE__*/
function () {
  function Observable(subscriber) {
    _classCallCheck$5(this, Observable);

    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  _createClass$5(Observable, [{
    key: "subscribe",
    value: function subscribe(observer) {
      if (typeof observer !== 'object' || observer === null) {
        observer = {
          next: observer,
          error: arguments[1],
          complete: arguments[2]
        };
      }

      return new Subscription(observer, this._subscriber);
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (typeof fn !== 'function') {
          reject(new TypeError(fn + ' is not a function'));
          return;
        }

        function done() {
          subscription.unsubscribe();
          resolve();
        }

        var subscription = _this.subscribe({
          next: function (value) {
            try {
              fn(value, done);
            } catch (e) {
              reject(e);
              subscription.unsubscribe();
            }
          },
          error: reject,
          complete: resolve
        });
      });
    }
  }, {
    key: "map",
    value: function map(fn) {
      var _this2 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this2.subscribe({
          next: function (value) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "filter",
    value: function filter(fn) {
      var _this3 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this3.subscribe({
          next: function (value) {
            try {
              if (!fn(value)) return;
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "reduce",
    value: function reduce(fn) {
      var _this4 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      var hasSeed = arguments.length > 1;
      var hasValue = false;
      var seed = arguments[1];
      var acc = seed;
      return new C(function (observer) {
        return _this4.subscribe({
          next: function (value) {
            var first = !hasValue;
            hasValue = true;

            if (!first || hasSeed) {
              try {
                acc = fn(acc, value);
              } catch (e) {
                return observer.error(e);
              }
            } else {
              acc = value;
            }
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
            observer.next(acc);
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "concat",
    value: function concat() {
      var _this5 = this;

      for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
      }

      var C = getSpecies(this);
      return new C(function (observer) {
        var subscription;
        var index = 0;

        function startNext(next) {
          subscription = next.subscribe({
            next: function (v) {
              observer.next(v);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              if (index === sources.length) {
                subscription = undefined;
                observer.complete();
              } else {
                startNext(C.from(sources[index++]));
              }
            }
          });
        }

        startNext(_this5);
        return function () {
          if (subscription) {
            subscription.unsubscribe();
            subscription = undefined;
          }
        };
      });
    }
  }, {
    key: "flatMap",
    value: function flatMap(fn) {
      var _this6 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        var subscriptions = [];

        var outer = _this6.subscribe({
          next: function (value) {
            if (fn) {
              try {
                value = fn(value);
              } catch (e) {
                return observer.error(e);
              }
            }

            var inner = C.from(value).subscribe({
              next: function (value) {
                observer.next(value);
              },
              error: function (e) {
                observer.error(e);
              },
              complete: function () {
                var i = subscriptions.indexOf(inner);
                if (i >= 0) subscriptions.splice(i, 1);
                completeIfDone();
              }
            });
            subscriptions.push(inner);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            completeIfDone();
          }
        });

        function completeIfDone() {
          if (outer.closed && subscriptions.length === 0) observer.complete();
        }

        return function () {
          subscriptions.forEach(function (s) {
            return s.unsubscribe();
          });
          outer.unsubscribe();
        };
      });
    }
  }, {
    key: SymbolObservable,
    value: function () {
      return this;
    }
  }], [{
    key: "from",
    value: function from(x) {
      var C = typeof this === 'function' ? this : Observable;
      if (x == null) throw new TypeError(x + ' is not an object');
      var method = getMethod(x, SymbolObservable);

      if (method) {
        var observable = method.call(x);
        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
        if (isObservable(observable) && observable.constructor === C) return observable;
        return new C(function (observer) {
          return observable.subscribe(observer);
        });
      }

      if (hasSymbol('iterator')) {
        method = getMethod(x, SymbolIterator);

        if (method) {
          return new C(function (observer) {
            enqueue(function () {
              if (observer.closed) return;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _item = _step.value;
                  observer.next(_item);
                  if (observer.closed) return;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              observer.complete();
            });
          });
        }
      }

      if (Array.isArray(x)) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var i = 0; i < x.length; ++i) {
              observer.next(x[i]);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }

      throw new TypeError(x + ' is not observable');
    }
  }, {
    key: "of",
    value: function of() {
      for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        items[_key2] = arguments[_key2];
      }

      var C = typeof this === 'function' ? this : Observable;
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < items.length; ++i) {
            observer.next(items[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }
  }, {
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

Observable$4.Observable = Observable$3;

if (hasSymbols()) {
  Object.defineProperty(Observable$3, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}

var zenObservable = Observable$4.Observable;

var Observable$1 = zenObservable;

var Observable$2 = Observable$1;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$1 = function(d, b) {
    extendStatics$1 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics$1(d, b);
};

function __extends$1(d, b) {
    extendStatics$1(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw process.env.NODE_ENV === "production" ? new InvariantError(2) : new InvariantError("illegal argument: " + key);
        }
    }
    return operation;
}
var LinkError = (function (_super) {
    __extends$1(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
function isTerminating(link) {
    return link.request.length <= 1;
}
function fromError(errorValue) {
    return new Observable$2(function (observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? getOperationName(transformedOperation.query)
                : '';
    }
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = __assign$2({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = __assign$2({}, context, next(context));
        }
        else {
            context = __assign$2({}, context, next);
        }
    };
    var getContext = function () { return (__assign$2({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function () { return getKey$1(operation); },
    });
    return operation;
}
function getKey$1(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([operationName, query, variables]);
}

function passthrough(op, forward) {
    return forward ? forward(op) : Observable$2.of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty$1() {
    return new ApolloLink(function () { return Observable$2.of(); });
}
function from$2(links) {
    if (links.length === 0)
        return empty$1();
    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) {
        return new ApolloLink(function (operation) {
            return test(operation)
                ? leftLink.request(operation) || Observable$2.of()
                : rightLink.request(operation) || Observable$2.of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return test(operation)
                ? leftLink.request(operation, forward) || Observable$2.of()
                : rightLink.request(operation, forward) || Observable$2.of();
        });
    }
}
var concat$3 = function (first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) {
        process.env.NODE_ENV === "production" || invariant.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
        return firstLink;
    }
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) {
        return new ApolloLink(function (operation) {
            return firstLink.request(operation, function (op) { return nextLink.request(op) || Observable$2.of(); }) || Observable$2.of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return (firstLink.request(operation, function (op) {
                return nextLink.request(op, forward) || Observable$2.of();
            }) || Observable$2.of());
        });
    }
};
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return concat$3(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw process.env.NODE_ENV === "production" ? new InvariantError(1) : new InvariantError('request is not implemented');
    };
    ApolloLink.empty = empty$1;
    ApolloLink.from = from$2;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}());
function execute(link, operation) {
    return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || Observable$2.of());
}

function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
}

/* global window */

var root$2;

if (typeof self !== 'undefined') {
  root$2 = self;
} else if (typeof window !== 'undefined') {
  root$2 = window;
} else if (typeof global !== 'undefined') {
  root$2 = global;
} else if (typeof module !== 'undefined') {
  root$2 = module;
} else {
  root$2 = Function('return this')();
}

var result = symbolObservablePonyfill(root$2);

var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}

var Observable = (function (_super) {
    __extends$2(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[result] = function () {
        return this;
    };
    Observable.prototype['@@observable'] = function () {
        return this;
    };
    return Observable;
}(Observable$2));

function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}

function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var message = '';
    if (isNonEmptyArray(err.graphQLErrors)) {
        err.graphQLErrors.forEach(function (graphQLError) {
            var errorMessage = graphQLError
                ? graphQLError.message
                : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
        });
    }
    if (err.networkError) {
        message += 'Network error: ' + err.networkError.message + '\n';
    }
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = (function (_super) {
    __extends$2(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) {
            _this.message = generateErrorMessage(_this);
        }
        else {
            _this.message = errorMessage;
        }
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

var FetchType;
(function (FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})(FetchType || (FetchType = {}));

var hasError = function (storeValue, policy) {
    if (policy === void 0) { policy = 'none'; }
    return storeValue && (storeValue.networkError ||
        (policy === 'none' && isNonEmptyArray(storeValue.graphQLErrors)));
};
var ObservableQuery = (function (_super) {
    __extends$2(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function (observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = getOperationDefinition(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var observer = {
                next: function (result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function () {
        var result = this.getCurrentResult();
        if (result.data === undefined) {
            result.data = {};
        }
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function () {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: NetworkStatus.error,
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' ||
            fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if (hasError(queryStoreValue, this.options.errorPolicy)) {
                return {
                    data: void 0,
                    loading: false,
                    networkStatus: networkStatus,
                    error: new ApolloError({
                        graphQLErrors: queryStoreValue.graphQLErrors,
                        networkError: queryStoreValue.networkError,
                    }),
                };
            }
            if (queryStoreValue.variables) {
                this.options.variables = __assign$3(__assign$3({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus,
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') {
                result.errors = queryStoreValue.graphQLErrors;
            }
        }
        else {
            var loading = isNetworkFetchPolicy ||
                (partial && fetchPolicy !== 'cache-only');
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? NetworkStatus.loading : NetworkStatus.ready,
            };
        }
        if (!partial) {
            this.updateLastResult(__assign$3(__assign$3({}, result), { stale: false }));
        }
        return __assign$3(__assign$3({}, result), { partial: partial });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot &&
            newResult &&
            snapshot.networkStatus === newResult.networkStatus &&
            snapshot.stale === newResult.stale &&
            equal$2(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function () {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function () {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') {
            return Promise.reject(process.env.NODE_ENV === "production" ? new InvariantError(1) : new InvariantError('cache-only fetchPolicy option should not be used together with query refetch.'));
        }
        if (fetchPolicy !== 'no-cache' &&
            fetchPolicy !== 'cache-and-network') {
            fetchPolicy = 'network-only';
        }
        if (!equal$2(this.variables, variables)) {
            this.variables = __assign$3(__assign$3({}, this.variables), variables);
        }
        if (!equal$2(this.options.variables, this.variables)) {
            this.options.variables = __assign$3(__assign$3({}, this.options.variables), this.variables);
        }
        return this.queryManager.fetchQuery(this.queryId, __assign$3(__assign$3({}, this.options), { fetchPolicy: fetchPolicy }), FetchType.refetch);
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        process.env.NODE_ENV === "production" ? invariant(fetchMoreOptions.updateQuery, 2) : invariant(fetchMoreOptions.updateQuery, 'updateQuery option is required. This function defines how to update the query data with the new results.');
        var combinedOptions = __assign$3(__assign$3({}, (fetchMoreOptions.query ? fetchMoreOptions : __assign$3(__assign$3(__assign$3({}, this.options), fetchMoreOptions), { variables: __assign$3(__assign$3({}, this.variables), fetchMoreOptions.variables) }))), { fetchPolicy: 'network-only' });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager
            .fetchQuery(qid, combinedOptions, FetchType.normal, this.queryId)
            .then(function (fetchMoreResult) {
            _this.updateQuery(function (previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables,
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function (error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                process.env.NODE_ENV === "production" || invariant.error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = __assign$3(__assign$3({}, this.options), opts);
        if (opts.pollInterval) {
            this.startPolling(opts.pollInterval);
        }
        else if (opts.pollInterval === 0) {
            this.stopPolling();
        }
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' ||
            oldFetchPolicy === 'standby' ||
            fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function (variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) { tryFetch = false; }
        if (fetchResults === void 0) { fetchResults = true; }
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && equal$2(variables, this.variables)) {
            return this.observers.size && fetchResults
                ? this.result()
                : Promise.resolve();
        }
        this.variables = this.options.variables = variables;
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = tryFunctionOrLogError(function () {
            return mapFn(previousResult, { variables: variables });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function () {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function (newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults
            ? newResult
            : cloneDeep(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function (observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) {
                subObserver.error = defaultSubscriptionObserverErrorCallback;
            }
        }
        catch (_a) { }
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult)
            observer.next(this.lastResult);
        if (observer.error && this.lastError)
            observer.error(this.lastError);
        if (first) {
            this.setUpQuery();
        }
        return function () {
            if (_this.observers.delete(observer) && !_this.observers.size) {
                _this.tearDownQuery();
            }
        };
    };
    ObservableQuery.prototype.setUpQuery = function () {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) {
            queryManager.addObservableQuery(queryId, this);
        }
        if (this.options.pollInterval) {
            assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function (error) {
            _this.updateLastResult(__assign$3(__assign$3({}, _this.lastResult), { errors: error.graphQLErrors, networkStatus: NetworkStatus.error, loading: false }));
            iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function (result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) {
                        queryManager.getLocalState().addExportedVariables(query_1, variables).then(function (variables) {
                            var previousVariables = _this.variables;
                            _this.variables = _this.options.variables = variables;
                            if (!result.loading &&
                                previousResult_1 &&
                                fetchPolicy_1 !== 'cache-only' &&
                                queryManager.transform(query_1).serverQuery &&
                                !equal$2(previousVariables, variables)) {
                                _this.refetch();
                            }
                            else {
                                iterateObserversSafely(_this.observers, 'next', result);
                            }
                        });
                    }
                    else {
                        iterateObserversSafely(_this.observers, 'next', result);
                    }
                }
            },
            error: onError,
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}(Observable));
function defaultSubscriptionObserverErrorCallback(error) {
    process.env.NODE_ENV === "production" || invariant.error('Unhandled error', error.message, error.stack);
}
function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
function assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    process.env.NODE_ENV === "production" ? invariant(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3) : invariant(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 'Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
}

var MutationStore = (function () {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function () {
        return this.store;
    };
    MutationStore.prototype.get = function (mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function (mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null,
        };
    };
    MutationStore.prototype.markMutationError = function (mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function (mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function () {
        this.store = {};
    };
    return MutationStore;
}());

var QueryStore = (function () {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function () {
        return this.store;
    };
    QueryStore.prototype.get = function (queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function (query) {
        var previousQuery = this.store[query.queryId];
        process.env.NODE_ENV === "production" ? invariant(!previousQuery ||
            previousQuery.document === query.document ||
            equal$2(previousQuery.document, query.document), 19) : invariant(!previousQuery ||
            previousQuery.document === query.document ||
            equal$2(previousQuery.document, query.document), 'Internal Error: may not update existing query string in store');
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables &&
            previousQuery &&
            previousQuery.networkStatus !== NetworkStatus.loading) {
            if (!equal$2(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) {
            networkStatus = NetworkStatus.setVariables;
        }
        else if (query.isPoll) {
            networkStatus = NetworkStatus.poll;
        }
        else if (query.isRefetch) {
            networkStatus = NetworkStatus.refetch;
        }
        else {
            networkStatus = NetworkStatus.loading;
        }
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) {
            graphQLErrors = previousQuery.graphQLErrors;
        }
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata,
        };
        if (typeof query.fetchMoreForQueryId === 'string' &&
            this.store[query.fetchMoreForQueryId]) {
            this.store[query.fetchMoreForQueryId].networkStatus =
                NetworkStatus.fetchMore;
        }
    };
    QueryStore.prototype.markQueryResult = function (queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = NetworkStatus.ready;
        if (typeof fetchMoreForQueryId === 'string' &&
            this.store[fetchMoreForQueryId]) {
            this.store[fetchMoreForQueryId].networkStatus = NetworkStatus.ready;
        }
    };
    QueryStore.prototype.markQueryError = function (queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = NetworkStatus.error;
        if (typeof fetchMoreForQueryId === 'string') {
            this.markQueryResultClient(fetchMoreForQueryId, true);
        }
    };
    QueryStore.prototype.markQueryResultClient = function (queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) {
                storeValue.networkStatus = NetworkStatus.ready;
            }
        }
    };
    QueryStore.prototype.stopQuery = function (queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function (observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function (queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) {
                _this.stopQuery(queryId);
            }
            else {
                _this.store[queryId].networkStatus = NetworkStatus.loading;
            }
        });
    };
    return QueryStore;
}());

function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

var LocalState = (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = mergeDeep(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = mergeDeep(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                if (document) {
                    return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return (__assign$3(__assign$3({}, remoteResult), { data: localResult.result })); })];
                }
                return [2, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function (document) {
        if (hasDirectives(['client'], document)) {
            if (this.resolvers) {
                return document;
            }
            process.env.NODE_ENV === "production" || invariant.warn('Found @client directives in a query but no ApolloClient resolvers ' +
                'were specified. This means ApolloClient local resolver handling ' +
                'has been disabled, and @client directives will be passed through ' +
                'to your link chain.');
        }
        return null;
    };
    LocalState.prototype.serverQuery = function (document) {
        return this.resolvers ? removeClientSetsFromDocument(document) : document;
    };
    LocalState.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var cache = this.cache;
        var newContext = __assign$3(__assign$3({}, context), { cache: cache, getCacheKey: function (obj) {
                if (cache.config) {
                    return cache.config.dataIdFromObject(obj);
                }
                else {
                    process.env.NODE_ENV === "production" ? invariant(false, 6) : invariant(false, 'To use context.getCacheKey, you need to use a cache that has ' +
                        'a configurable dataIdFromObject, like apollo-cache-inmemory.');
                }
            } });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (document) {
                    return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return (__assign$3(__assign$3({}, variables), data.exportedVariables)); })];
                }
                return [2, __assign$3({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        visit$3(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === 'always' &&
                                arg.value.kind === 'BooleanValue' &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return BREAK;
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: buildQueryFromSelectionSet(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return __awaiter(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return __generator(this, function (_b) {
                mainDefinition = getMainDefinition(document);
                fragments = getFragmentDefinitions(document);
                fragmentMap = createFragmentMap(fragments);
                definitionOperation = mainDefinition
                    .operation;
                defaultOperationType = definitionOperation
                    ? capitalizeFirstLetter(definitionOperation)
                    : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: __assign$3(__assign$3({}, context), { cache: cache,
                        client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                return [2, this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, rootValue, execContext) {
        return __awaiter(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return __generator(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return __awaiter(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return __generator(this, function (_a) {
                        if (!shouldInclude(selection, variables)) {
                            return [2];
                        }
                        if (isField(selection)) {
                            return [2, this.resolveField(selection, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') {
                                        resultsToMerge.push((_a = {},
                                            _a[resultKeyNameFromField(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if (isInlineFragment(selection)) {
                            fragment = selection;
                        }
                        else {
                            fragment = fragmentMap[selection.name.value];
                            process.env.NODE_ENV === "production" ? invariant(fragment, 7) : invariant(fragment, "No fragment named " + selection.name.value);
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2, this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2];
                    });
                }); };
                return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return mergeDeepArray(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, rootValue, execContext) {
        return __awaiter(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return __generator(this, function (_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = resultKeyNameFromField(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(resolve(rootValue, argumentsObjectFromField(field, variables), execContext.context, { field: field, fragmentMap: execContext.fragmentMap }));
                        }
                    }
                }
                return [2, resultPromise.then(function (result) {
                        if (result === void 0) { result = defaultResult; }
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === 'export' && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        if (!field.selectionSet) {
                            return result;
                        }
                        if (result == null) {
                            return result;
                        }
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, result, execContext);
                        }
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, item, execContext);
            }
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }
        }));
    };
    return LocalState;
}());

function multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new Observable(function (observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function (value) {
                observers.forEach(function (obs) { return obs.next && obs.next(value); });
            },
            error: function (error) {
                observers.forEach(function (obs) { return obs.error && obs.error(error); });
            },
            complete: function () {
                observers.forEach(function (obs) { return obs.complete && obs.complete(); });
            },
        });
        return function () {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function asyncMap(observable, mapFn) {
    return new Observable(function (observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function (value) {
                ++activeNextCount;
                new Promise(function (resolve) {
                    resolve(mapFn(value));
                }).then(function (result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function (e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function (e) {
                error && error.call(observer, e);
            },
            complete: function () {
                completed = true;
                if (!activeNextCount) {
                    complete && complete.call(observer);
                }
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}

var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var QueryManager = (function () {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function () { return undefined; } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new MutationStore();
        this.queryStore = new QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new (canUseWeakMap ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: store.getCache() });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function (reject) {
            reject(process.env.NODE_ENV === "production" ? new InvariantError(8) : new InvariantError('QueryManager stopped while query was in flight'));
        });
    };
    QueryManager.prototype.mutate = function (_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return __awaiter(this, void 0, void 0, function () {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        process.env.NODE_ENV === "production" ? invariant(mutation, 9) : invariant(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.');
                        process.env.NODE_ENV === "production" ? invariant(!fetchPolicy || fetchPolicy === 'no-cache', 10) : invariant(!fetchPolicy || fetchPolicy === 'no-cache', "Mutations only support a 'no-cache' fetchPolicy. If you don't want to disable the cache, remove your fetchPolicy setting to proceed with the default mutation behavior.");
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function () { return ({ document: mutation }); });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function () {
                            var ret = {};
                            if (updateQueriesByName) {
                                _this.queries.forEach(function (_a, queryId) {
                                    var observableQuery = _a.observableQuery;
                                    if (observableQuery) {
                                        var queryName = observableQuery.queryName;
                                        if (queryName &&
                                            hasOwnProperty$1.call(updateQueriesByName, queryName)) {
                                            ret[queryId] = {
                                                updater: updateQueriesByName[queryName],
                                                query: _this.queryStore.get(queryId),
                                            };
                                        }
                                    }
                                });
                            }
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse,
                        });
                        this.broadcastQueries();
                        self = this;
                        return [2, new Promise(function (resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, __assign$3(__assign$3({}, context), { optimisticResponse: optimisticResponse }), variables, false).subscribe({
                                    next: function (result) {
                                        if (graphQLResultHasError(result) && errorPolicy === 'none') {
                                            error = new ApolloError({
                                                graphQLErrors: result.errors,
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') {
                                            self.dataStore.markMutationResult({
                                                mutationId: mutationId,
                                                result: result,
                                                document: mutation,
                                                variables: variables,
                                                updateQueries: generateUpdateQueriesInfo(),
                                                update: updateWithProxyFn,
                                            });
                                        }
                                        storeResult = result;
                                    },
                                    error: function (err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse,
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function () { return ({ document: null }); });
                                        reject(new ApolloError({
                                            networkError: err,
                                        }));
                                    },
                                    complete: function () {
                                        if (error) {
                                            self.mutationStore.markMutationError(mutationId, error);
                                        }
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse,
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') {
                                            refetchQueries = refetchQueries(storeResult);
                                        }
                                        var refetchQueryPromises = [];
                                        if (isNonEmptyArray(refetchQueries)) {
                                            refetchQueries.forEach(function (refetchQuery) {
                                                if (typeof refetchQuery === 'string') {
                                                    self.queries.forEach(function (_a) {
                                                        var observableQuery = _a.observableQuery;
                                                        if (observableQuery &&
                                                            observableQuery.queryName === refetchQuery) {
                                                            refetchQueryPromises.push(observableQuery.refetch());
                                                        }
                                                    });
                                                }
                                                else {
                                                    var queryOptions = {
                                                        query: refetchQuery.query,
                                                        variables: refetchQuery.variables,
                                                        fetchPolicy: 'network-only',
                                                    };
                                                    if (refetchQuery.context) {
                                                        queryOptions.context = refetchQuery.context;
                                                    }
                                                    refetchQueryPromises.push(self.query(queryOptions));
                                                }
                                            });
                                        }
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function () {
                                            self.setQuery(mutationId, function () { return ({ document: null }); });
                                            if (errorPolicy === 'ignore' &&
                                                storeResult &&
                                                graphQLResultHasError(storeResult)) {
                                                delete storeResult.errors;
                                            }
                                            resolve(storeResult);
                                        });
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, fetchType, fetchMoreForQueryId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(query, variables, context)];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = __assign$3(__assign$3({}, options), { variables: variables });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false,
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if (hasDirectives(['live'], query))
                            shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache'
                            ? this.updateQueryWatch(queryId, query, options)
                            : undefined;
                        this.setQuery(queryId, function () { return ({
                            document: query,
                            lastRequestId: requestId,
                            invalidated: true,
                            cancel: cancel,
                        }); });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === FetchType.poll,
                            isRefetch: fetchType === FetchType.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId,
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId,
                            }).catch(function (error) {
                                if (isApolloError(error)) {
                                    throw error;
                                }
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new ApolloError({ networkError: error });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') {
                                return [2, networkResult];
                            }
                            networkResult.catch(function () { });
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) {
                            return [2, this.localState.runResolvers({
                                    document: query,
                                    remoteResult: { data: storeResult },
                                    context: context,
                                    variables: variables,
                                    onlyRunForcedResolvers: true,
                                }).then(function (result) {
                                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                    _this.broadcastQueries();
                                    return result;
                                })];
                        }
                        this.broadcastQueries();
                        return [2, { data: storeResult }];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function (queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') {
            this.setQuery(queryId, function () { return ({
                newData: { result: result.data, complete: true },
            }); });
        }
        else {
            this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
        }
    };
    QueryManager.prototype.queryListenerForObserver = function (queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) {
                try {
                    observer[method](argument);
                }
                catch (e) {
                    process.env.NODE_ENV === "production" || invariant.error(e);
                }
            }
            else if (method === 'error') {
                process.env.NODE_ENV === "production" || invariant.error(argument);
            }
        }
        return function (queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue)
                return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery
                ? observableQuery.options.fetchPolicy
                : options.fetchPolicy;
            if (fetchPolicy === 'standby')
                return;
            var loading = isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult &&
                lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData ||
                (!newData && queryStoreValue.previousVariables) ||
                (networkStatusChanged && options.notifyOnNetworkStatusChange) ||
                fetchPolicy === 'cache-only' ||
                fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) {
                return;
            }
            var hasGraphQLErrors = isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery
                && observableQuery.options.errorPolicy
                || options.errorPolicy
                || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) {
                return invoke('error', new ApolloError({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError,
                }));
            }
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') {
                        _this.setQuery(queryId, function () { return ({ newData: null }); });
                    }
                    data = newData.result;
                    isMissing = !newData.complete;
                }
                else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' &&
                        (lastError && lastError.graphQLErrors) !==
                            queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    }
                    else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables ||
                                queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true,
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData ||
                    fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale,
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) {
                    resultFromStore.errors = queryStoreValue.graphQLErrors;
                }
                invoke('next', resultFromStore);
            }
            catch (networkError) {
                invoke('error', new ApolloError({ networkError: networkError }));
            }
        };
    };
    QueryManager.prototype.transform = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = removeConnectionDirectiveFromDocument(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: hasClientExports(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: getDefaultValues(getOperationDefinition(transformed)),
            };
            var add = function (doc) {
                if (doc && !transformCache.has(doc)) {
                    transformCache.set(doc, cacheEntry_1);
                }
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return __assign$3(__assign$3({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options, shouldSubscribe) {
        if (shouldSubscribe === void 0) { shouldSubscribe = true; }
        process.env.NODE_ENV === "production" ? invariant(options.fetchPolicy !== 'standby', 11) : invariant(options.fetchPolicy !== 'standby', 'client.watchQuery cannot be called with fetchPolicy set to "standby"');
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var transformedOptions = __assign$3({}, options);
        return new ObservableQuery({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe,
        });
    };
    QueryManager.prototype.query = function (options) {
        var _this = this;
        process.env.NODE_ENV === "production" ? invariant(options.query, 12) : invariant(options.query, 'query option is required. You must specify your GraphQL document ' +
            'in the query option.');
        process.env.NODE_ENV === "production" ? invariant(options.query.kind === 'Document', 13) : invariant(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.');
        process.env.NODE_ENV === "production" ? invariant(!options.returnPartialData, 14) : invariant(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.');
        process.env.NODE_ENV === "production" ? invariant(!options.pollInterval, 15) : invariant(!options.pollInterval, 'pollInterval option only supported on watchQuery.');
        return new Promise(function (resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery
                .result()
                .then(resolve, reject)
                .then(function () {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function (queryId, listener) {
        this.setQuery(queryId, function (_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return { invalidated: false };
        });
    };
    QueryManager.prototype.updateQueryWatch = function (queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel)
            cancel();
        var previousResult = function () {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) {
                    previousResult = lastResult.data;
                }
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function (newData) {
                _this.setQuery(queryId, function () { return ({ invalidated: true, newData: newData }); });
            },
        });
    };
    QueryManager.prototype.addObservableQuery = function (queryId, observableQuery) {
        this.setQuery(queryId, function () { return ({ observableQuery: observableQuery }); });
    };
    QueryManager.prototype.removeObservableQuery = function (queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function () { return ({ observableQuery: null }); });
        if (cancel)
            cancel();
    };
    QueryManager.prototype.clearStore = function () {
        this.fetchQueryRejectFns.forEach(function (reject) {
            reject(process.env.NODE_ENV === "production" ? new InvariantError(16) : new InvariantError('Store reset while query was in flight (not completed in link chain)'));
        });
        var resetIds = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery)
                resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function () {
        var _this = this;
        return this.clearStore().then(function () {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' &&
                    (includeStandby || fetchPolicy !== 'standby')) {
                    observableQueryPromises.push(observableQuery.refetch());
                }
                _this.setQuery(queryId, function () { return ({ newData: null }); });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function (queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function (queryId, options, listener) {
        process.env.NODE_ENV === "production" || invariant.warn("The QueryManager.startQuery method has been deprecated");
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options)
            .catch(function () { return undefined; });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function (result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if (graphQLResultHasError(result)) {
                    throw new ApolloError({
                        graphQLErrors: result.errors,
                    });
                }
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new Observable(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return sub = observable.subscribe(observer); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function (x) { return x.unsubscribe(); });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function (observableQuery, optimistic) {
        if (optimistic === void 0) { optimistic = true; }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) {
            return { data: newData.result, partial: false };
        }
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') {
            return { data: undefined, partial: false };
        }
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic,
        }), result = _b.result, complete = _b.complete;
        return {
            data: (complete || returnPartialData) ? result : void 0,
            partial: !complete,
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function (queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            process.env.NODE_ENV === "production" ? invariant(foundObserveableQuery, 17) : invariant(foundObserveableQuery, "ObservableQuery with this id doesn't exist: " + queryIdOrObservable);
            observableQuery = foundObserveableQuery;
        }
        else {
            observableQuery = queryIdOrObservable;
        }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query,
        };
    };
    QueryManager.prototype.broadcastQueries = function () {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function (info, id) {
            if (info.invalidated) {
                info.listeners.forEach(function (listener) {
                    if (listener) {
                        listener(_this.queryStore.get(id), info.newData);
                    }
                });
            }
        });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) { deduplication = this.queryDeduplication; }
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: getOperationName(serverQuery) || void 0,
                context: this.prepareContext(__assign$3(__assign$3({}, context), { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = multiplex(execute(link, operation)));
                    var cleanup = function () {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size)
                            inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup,
                    });
                }
            }
            else {
                observable = multiplex(execute(link, operation));
            }
        }
        else {
            observable = Observable.of({ data: {} });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.fetchRequest = function (_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function (resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function () {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function (_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function (result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && isNonEmptyArray(result.errors)) {
                    return reject(new ApolloError({
                        graphQLErrors: result.errors,
                    }));
                }
                if (errorPolicy === 'all') {
                    errorsFromStore = result.errors;
                }
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') {
                    resultFromStore = result.data;
                }
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true,
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) {
                        resultFromStore = result_1;
                    }
                }
            }).subscribe({
                error: function (error) {
                    cleanup();
                    reject(error);
                },
                complete: function () {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: NetworkStatus.ready,
                        stale: false,
                    });
                },
            });
            _this.setQuery(queryId, function (_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function (queryId) {
        return (this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set(),
        });
    };
    QueryManager.prototype.setQuery = function (queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = __assign$3(__assign$3({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function (queryId, invalidated) {
        if (invalidated === void 0) { invalidated = true; }
        if (queryId) {
            this.setQuery(queryId, function () { return ({ invalidated: invalidated }); });
        }
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return __assign$3(__assign$3({}, newContext), { clientAwareness: this.clientAwareness });
    };
    QueryManager.prototype.checkInFlight = function (queryId) {
        var query = this.queryStore.get(queryId);
        return (query &&
            query.networkStatus !== NetworkStatus.ready &&
            query.networkStatus !== NetworkStatus.error);
    };
    QueryManager.prototype.startPollingQuery = function (options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        process.env.NODE_ENV === "production" ? invariant(pollInterval, 18) : invariant(pollInterval, 'Attempted to start a polling query without a polling interval.');
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) {
                this.pollingInfoByQueryId.set(queryId, (info = {}));
            }
            info.interval = pollInterval;
            info.options = __assign$3(__assign$3({}, options), { fetchPolicy: 'network-only' });
            var maybeFetch_1 = function () {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) {
                        poll_1();
                    }
                    else {
                        _this.fetchQuery(queryId, info.options, FetchType.poll).then(poll_1, poll_1);
                    }
                }
            };
            var poll_1 = function () {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) {
                this.addQueryListener(queryId, listener);
            }
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function (queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}());

var DataStore = (function () {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function () {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function (result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) { ignoreErrors = false; }
        var writeWithErrors = !graphQLResultHasError(result);
        if (ignoreErrors && graphQLResultHasError(result) && result.data) {
            writeWithErrors = true;
        }
        if (!fetchMoreForQueryId && writeWithErrors) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markSubscriptionResult = function (result, document, variables) {
        if (!graphQLResultHasError(result)) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_SUBSCRIPTION',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markMutationInit = function (mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') {
                optimistic_1 = mutation.optimisticResponse(mutation.variables);
            }
            else {
                optimistic_1 = mutation.optimisticResponse;
            }
            this.cache.recordOptimisticTransaction(function (c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: { data: optimistic_1 },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update,
                    });
                }
                finally {
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function (mutation) {
        var _this = this;
        if (!graphQLResultHasError(mutation.result)) {
            var cacheWrites_1 = [{
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables,
                }];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                Object.keys(updateQueries_1).forEach(function (id) {
                    var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                    var _b = _this.cache.diff({
                        query: query.document,
                        variables: query.variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (complete) {
                        var nextQueryResult = tryFunctionOrLogError(function () {
                            return updater(currentQueryResult, {
                                mutationResult: mutation.result,
                                queryName: getOperationName(query.document) || undefined,
                                queryVariables: query.variables,
                            });
                        });
                        if (nextQueryResult) {
                            cacheWrites_1.push({
                                result: nextQueryResult,
                                dataId: 'ROOT_QUERY',
                                query: query.document,
                                variables: query.variables,
                            });
                        }
                    }
                });
            }
            this.cache.performTransaction(function (c) {
                cacheWrites_1.forEach(function (write) { return c.write(write); });
                var update = mutation.update;
                if (update) {
                    tryFunctionOrLogError(function () { return update(c, mutation.result); });
                }
            });
        }
    };
    DataStore.prototype.markMutationComplete = function (_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) {
            this.cache.removeOptimistic(mutationId);
        }
    };
    DataStore.prototype.markUpdateQueryResult = function (document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document,
        });
    };
    DataStore.prototype.reset = function () {
        return this.cache.reset();
    };
    return DataStore;
}());

var version$1 = "2.6.10";

var hasSuggestedDevtools = false;
var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) {
            link = ApolloLink.empty();
        }
        if (!link || !cache) {
            throw process.env.NODE_ENV === "production" ? new InvariantError(4) : new InvariantError("In order to initialize Apollo Client, you must specify 'link' and 'cache' properties in the options object.\n" +
                "These options are part of the upgrade requirements when migrating from Apollo Client 1.x to Apollo Client 2.x.\n" +
                "For more information, please visit: https://www.apollographql.com/docs/tutorial/client.html#apollo-client-setup");
        }
        this.link = link;
        this.cache = cache;
        this.store = new DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = process.env.NODE_ENV !== 'production' &&
            typeof window !== 'undefined' &&
            !window.__APOLLO_CLIENT__;
        if (typeof connectToDevTools === 'undefined'
            ? defaultConnectToDevTools
            : connectToDevTools && typeof window !== 'undefined') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && process.env.NODE_ENV !== 'production') {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self) {
                if (typeof window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
                    if (window.navigator &&
                        window.navigator.userAgent &&
                        window.navigator.userAgent.indexOf('Chrome') > -1) {
                        console.debug('Download the Apollo DevTools ' +
                            'for a better development experience: ' +
                            'https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm');
                    }
                }
            }
        }
        this.version = version$1;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.queryStore.getStore(),
                            mutations: _this.queryManager.mutationStore.getStore(),
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            },
        });
    }
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = __assign$3(__assign$3({}, this.defaultOptions.watchQuery), options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = __assign$3(__assign$3({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = __assign$3(__assign$3({}, this.defaultOptions.query), options);
        }
        process.env.NODE_ENV === "production" ? invariant(options.fetchPolicy !== 'cache-and-network', 5) : invariant(options.fetchPolicy !== 'cache-and-network', 'The cache-and-network fetchPolicy does not work with client.query, because ' +
            'client.query can only return a single result. Please use client.watchQuery ' +
            'to receive multiple results from the cache and the network, or consider ' +
            'using a different fetchPolicy, such as cache-first or network-only.');
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = __assign$3(__assign$3({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = __assign$3(__assign$3({}, this.defaultOptions.mutate), options);
        }
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function (options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function (options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return execute(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function () {
        process.env.NODE_ENV === "production" || invariant.warn('Calling the initQueryManager method is no longer necessary, ' +
            'and it will be removed from ApolloClient in version 3.0.');
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore(); })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore(); })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}());

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var parseAndCheckHttpResponse = function (operations) { return function (response) {
    return (response
        .text()
        .then(function (bodyText) {
        try {
            return JSON.parse(bodyText);
        }
        catch (err) {
            var parseError = err;
            parseError.name = 'ServerParseError';
            parseError.response = response;
            parseError.statusCode = response.status;
            parseError.bodyText = bodyText;
            return Promise.reject(parseError);
        }
    })
        .then(function (result) {
        if (response.status >= 300) {
            throwServerError(response, result, "Response not successful: Received status code " + response.status);
        }
        if (!Array.isArray(result) &&
            !result.hasOwnProperty('data') &&
            !result.hasOwnProperty('errors')) {
            throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations)
                ? operations.map(function (op) { return op.operationName; })
                : operations.operationName) + "'.");
        }
        return result;
    }));
}; };
var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined')
            library = 'node-fetch';
        throw process.env.NODE_ENV === "production" ? new InvariantError(1) : new InvariantError("\nfetch is not found globally and no fetcher passed, to fix pass a fetch for\nyour environment like https://www.npmjs.com/package/" + library + ".\n\nFor example:\nimport fetch from '" + library + "';\nimport { createHttpLink } from 'apollo-link-http';\n\nconst link = createHttpLink({ uri: '/graphql', fetch: fetch });");
    }
};
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
var selectHttpOptionsAndBody = function (operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = __assign({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
    var http = fallbackConfig.http;
    configs.forEach(function (config) {
        options = __assign({}, options, config.options, { headers: __assign({}, options.headers, config.headers) });
        if (config.credentials)
            options.credentials = config.credentials;
        http = __assign({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = print(query);
    return {
        options: options,
        body: body,
    };
};
var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = process.env.NODE_ENV === "production" ? new InvariantError(2) : new InvariantError("Network request failed. " + label + " is not serializable: " + e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};

var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = __rest(linkOptions, ["uri", "fetch", "includeExtensions", "useGETForQueries"]);
    checkFetcher(fetcher);
    if (!fetcher) {
        fetcher = fetch;
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new ApolloLink(function (operation) {
        var chosenURI = selectURI(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = __assign$1({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        var _b = selectHttpOptionsAndBody(operation, fallbackHttpConfig, linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = createSignalIfSupported(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (options.method === 'GET') {
            var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return fromError(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = serializeFetchParameter(body, 'Payload');
            }
            catch (parseError) {
                return fromError(parseError);
            }
        }
        return new Observable$2(function (observer) {
            fetcher(chosenURI, options)
                .then(function (response) {
                operation.setContext({ response: response });
                return response;
            })
                .then(parseAndCheckHttpResponse(operation))
                .then(function (result) {
                observer.next(result);
                observer.complete();
                return result;
            })
                .catch(function (err) {
                if (err.name === 'AbortError')
                    return;
                if (err.result && err.result.errors && err.result.data) {
                    observer.next(err.result);
                }
                observer.error(err);
            });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};
function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = serializeFetchParameter(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = serializeFetchParameter(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
var HttpLink = (function (_super) {
    __extends(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, createHttpLink(opts).request) || this;
    }
    return HttpLink;
}(ApolloLink));

const client = new ApolloClient({
  link: new HttpLink({
    uri: `${SUBGRAPH_BASE_URL}/exchange`,
  }),
  cache: new InMemoryCache(),
  shouldBatch: true,
});

const blockClient = new ApolloClient({
  link: new HttpLink({
    uri: 'https://api.thegraph.com/subgraphs/name/dasconnor/avalanche-blocks',
  }),
  cache: new InMemoryCache(),
});

const GET_TOKEN_DAY_DATAS = gql$1`
  query tokenDayDatas($token: String!) {
    tokenDayDatas(first: 7, orderBy: date, orderDirection: desc, where: { token: $token }) {
      id
      date
      priceUSD
      token {
        symbol
      }
    }
  }
`;

const updateTokenWeeklyPriceChartData = createAction('token/updateTokenWeeklyPriceChartData');
const updateTokenPriceChartData = createAction('token/updateTokenPriceChartData');

function splitQuery(query, localClient, vars, list, skipCount = 100) {
    return __awaiter$a(this, void 0, void 0, function* () {
        let fetchedData = {};
        let allFound = false;
        let skip = 0;
        while (!allFound) {
            let end = list.length;
            if (skip + skipCount < list.length) {
                end = skip + skipCount;
            }
            const sliced = list.slice(skip, end);
            const result = yield localClient.query({
                query: query(...vars, sliced),
                fetchPolicy: 'cache-first',
            });
            fetchedData = Object.assign(Object.assign({}, fetchedData), result.data);
            if (Object.keys(result.data).length < skipCount || skip + skipCount > list.length) {
                allFound = true;
            }
            else {
                skip += skipCount;
            }
        }
        return fetchedData;
    });
}

dayjs.extend(utc);
function useAllTokenWeeklyPriceChartData() {
    return useSelector((state) => { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.ptoken) === null || _a === void 0 ? void 0 : _a.weekly) || {}; });
}
function useAllTokenPricesChartData() {
    return useSelector((state) => { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.ptoken) === null || _a === void 0 ? void 0 : _a.tokenPrices) || {}; });
}
function useTokenWeeklyChartData(tokenAddress) {
    const data1 = useAllTokenWeeklyPriceChartData();
    const chartData = data1 === null || data1 === void 0 ? void 0 : data1[tokenAddress];
    const dispatch = useDispatch();
    useEffect(() => {
        function checkForChartData() {
            return __awaiter$a(this, void 0, void 0, function* () {
                if (!chartData) {
                    const data = yield getTokenWeeklyChartData(tokenAddress);
                    dispatch(updateTokenWeeklyPriceChartData({ address: tokenAddress, chartData: data }));
                }
            });
        }
        checkForChartData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chartData, tokenAddress]);
    return chartData;
}
const getTokenWeeklyChartData = (tokenAddress) => __awaiter$a(void 0, void 0, void 0, function* () {
    var _a;
    let data = [];
    try {
        const result = yield client.query({
            query: GET_TOKEN_DAY_DATAS,
            variables: {
                token: tokenAddress,
            },
            fetchPolicy: 'cache-first',
        });
        data = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.tokenDayDatas;
    }
    catch (e) {
        console.log(e);
    }
    data = data.sort((a, b) => (parseInt(a.date) > parseInt(b.date) ? 1 : -1));
    return data;
});
function useTokenPriceData(tokenAddress, timeWindow, interval = 3600, type = 'ALL') {
    const data1 = useAllTokenPricesChartData();
    const chartData = data1 === null || data1 === void 0 ? void 0 : data1[tokenAddress];
    const dispatch = useDispatch();
    useEffect(() => {
        const currentTime = dayjs === null || dayjs === void 0 ? void 0 : dayjs.utc();
        // February 8th 2021 - Pangolin Factory is created
        const startTime = type === 'ALL'
            ? dayjs('2021-02-11').startOf('hour').unix()
            : currentTime
                .subtract(1, timeWindow)
                .startOf('hour')
                .unix();
        function fetch() {
            return __awaiter$a(this, void 0, void 0, function* () {
                const data = yield getIntervalTokenData(tokenAddress, startTime, undefined, interval);
                dispatch(updateTokenPriceChartData({ address: tokenAddress, chartData: data }));
            });
        }
        fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [interval, timeWindow, tokenAddress]);
    return chartData;
}
const getIntervalTokenData = (tokenAddress, startTime, to = dayjs.utc().unix(), interval = 3600 * 24) => __awaiter$a(void 0, void 0, void 0, function* () {
    var _b, _c;
    const utcEndTime = to;
    let time = startTime;
    // create an array of hour start times until we reach current hour
    // buffer by half hour to catch case where graph isnt synced to latest block
    const timestamps = [];
    while (time < utcEndTime) {
        timestamps.push(time);
        time += interval;
    }
    // backout if invalid timestamp format
    if (timestamps.length === 0) {
        return [];
    }
    // once you have all the timestamps, get the blocks for each timestamp in a bulk query
    let blocks;
    try {
        blocks = yield getBlocksFromTimestamps(timestamps, 100);
        // catch failing case
        if (!blocks || blocks.length === 0) {
            return [];
        }
        const result = yield splitQuery(PRICES_BY_BLOCK, client, [tokenAddress], blocks, 50);
        // format token ETH price results
        const values = [];
        for (const row in result) {
            const timestamp = row.split('t')[1];
            if (!timestamp)
                continue;
            const derivedETH = parseFloat((_b = result[`t${timestamp}`]) === null || _b === void 0 ? void 0 : _b.derivedETH);
            const ethPrice = parseFloat((_c = result[`b${timestamp}`]) === null || _c === void 0 ? void 0 : _c.ethPrice);
            const priceUSD = ethPrice * derivedETH;
            values.push({
                timestamp,
                derivedETH,
                ethPrice,
                priceUSD,
            });
        }
        const formattedHistory = [];
        // for each hour, construct the open and close price
        for (let i = 0; i < values.length - 1; i++) {
            formattedHistory.push({
                timestamp: values[i].timestamp,
                priceUSD: parseFloat(values === null || values === void 0 ? void 0 : values[i].priceUSD),
            });
        }
        return formattedHistory;
    }
    catch (e) {
        console.log(e);
        console.log('error fetching blocks');
        return [];
    }
});
function getBlocksFromTimestamps(timestamps, skipCount = 500) {
    return __awaiter$a(this, void 0, void 0, function* () {
        if ((timestamps === null || timestamps === void 0 ? void 0 : timestamps.length) === 0) {
            return [];
        }
        const fetchedData = yield splitQuery(GET_BLOCKS, blockClient, [], timestamps, skipCount);
        const blocks = [];
        if (fetchedData) {
            for (const t in fetchedData) {
                if (fetchedData[t].length > 0) {
                    blocks.push({
                        timestamp: t.split('t')[1],
                        number: fetchedData[t][0]['number'],
                    });
                }
            }
        }
        return blocks;
    });
}

var numeral = {exports: {}};

/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (module) {
(function (global, factory) {
    if (module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(commonjsGlobal, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));
}(numeral));

var Numeral = numeral.exports;

dayjs.extend(utc);
const toK = (num) => {
    return Numeral(num).format('0.[00]a');
};
// using a currency library here in case we want to add more in future
const priceFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
});
const toNiceDateYear = (date) => {
    return dayjs.utc(dayjs.unix(date)).format('MMMM DD, YYYY');
};
const formattedNum = (number, usd = false) => {
    if (isNaN(number) || number === '' || number === undefined) {
        return usd ? '$0' : 0;
    }
    const num = parseFloat(number);
    if (num > 500000000) {
        return (usd ? '$' : '') + toK(num.toFixed(0));
    }
    if (num === 0) {
        if (usd) {
            return '$0';
        }
        return 0;
    }
    if (num < 0.0001 && num > 0) {
        return usd ? '< $0.0001' : '< 0.0001';
    }
    if (num > 1000) {
        return usd
            ? '$' + Number(parseFloat(num).toFixed(0)).toLocaleString()
            : '' + Number(parseFloat(num).toFixed(0)).toLocaleString();
    }
    if (usd) {
        if (num < 0.1) {
            return '$' + Number(parseFloat(num).toFixed(4));
        }
        else {
            const usdString = priceFormatter.format(num);
            return '$' + usdString.slice(1, usdString.length);
        }
    }
    return Number(parseFloat(num).toFixed(5));
};

const WatchListRoot = styled(Box) `
  width: 100%;
  height: 100%;
  border-radius: 10px;
  padding: 20px;
  background-color: ${({ theme }) => theme.color2};
  display: flex;
  flex-direction: column;
`;
const DesktopWatchList = styled(Box) `
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.mediaWidth.upToSmall `
    display: none;
  `};
`;
const MobileWatchList = styled.div `
  display: none;
  ${({ theme }) => theme.mediaWidth.upToSmall `
  display: block;
`};
`;
const GridContainer = styled(Box) `
  display: grid;
  grid-template-columns: ${({ coinChartVisible }) => (!coinChartVisible ? `100%` : `minmax(auto, 50%) 50%`)};
  grid-gap: 8px;
  flex: 1;
  min-height: 263px;
  ${({ theme }) => theme.mediaWidth.upToSmall `
    grid-template-columns: none;
    grid-template-rows: max-content;
  `};
`;
styled(Box) `
  height: 1px;
  background-color: ${({ theme }) => theme.bg7};
  margin: 10px 0px 10px 0px;
  width: 100%;
`;
styled(Box) `
  max-height: 200px;
  overflow-y: auto;
`;
// WatchList Row Styles
const RowWrapper$1 = styled(Box) `
  padding: 0px 10px;
  display: grid;
  grid-template-columns: 100px minmax(auto, 1fr) max-content;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.text9};
  cursor: pointer;
  border-radius: 4px;
  background-color: ${({ theme, isSelected }) => (isSelected ? theme.color3 : theme.color2)};

  height: 64px;

  &:hover {
    background-color: ${({ theme }) => theme.color3};
  }
`;
const DeleteButton = styled.button `
  background-image: linear-gradient(to right, rgba(255, 0, 0, 0), ${({ theme }) => theme.bg6});
  background-color: transparent;
  border: 0px;
  color: ${({ theme }) => theme.text1};
  cursor: pointer;
  display: block;
  height: 64px;
  width: 100%;
  position: absolute;
`;
// Coin Chart Styles
const SelectedCoinInfo = styled(Box) `
  display: grid;
  grid-template-columns: max-content auto max-content;
  grid-gap: 8px;
  align-items: center;
`;
const TrackIcons = styled(Box) `
  display: grid;
  grid-template-columns: max-content max-content;
  grid-gap: 15px;
  align-items: center;
`;
const DurationBtns = styled(Box) `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Title = styled(Text$1) `
  font-size: 32px;
  font-weight: 500;
  color: ${({ theme }) => theme.text1};

  ${({ theme }) => theme.mediaWidth.upToSmall `
    font-size: 24px
  `};
`;

const CoinChart = ({ coin, visibleTradeButton, tradeLinkUrl, redirect }) => {
    const chainId = useChainId();
    const weekFrame = TIMEFRAME.find((value) => value.label === '1W');
    const { tokenUsdPrice } = useCoinGeckoTokenPrice(coin);
    const [timeWindow, setTimeWindow] = useState(weekFrame ||
        {});
    const tokenPrice = useUSDCPrice(coin);
    const usdcPrice = tokenUsdPrice || (tokenPrice === null || tokenPrice === void 0 ? void 0 : tokenPrice.toSignificant(4));
    const { onCurrencySelection } = useSwapActionHandlers(chainId);
    const onCurrencySelect = useCallback((currency) => {
        onCurrencySelection(Field.INPUT, currency);
    }, [onCurrencySelection]);
    const pangolinData = useTokenPriceData(((coin === null || coin === void 0 ? void 0 : coin.address) || '').toLowerCase(), timeWindow === null || timeWindow === void 0 ? void 0 : timeWindow.momentIdentifier, timeWindow === null || timeWindow === void 0 ? void 0 : timeWindow.interval, timeWindow === null || timeWindow === void 0 ? void 0 : timeWindow.label) || [];
    const coinGekoData = useCoinGeckoTokenPriceChart(coin, timeWindow === null || timeWindow === void 0 ? void 0 : timeWindow.days) || [];
    const token = unwrappedToken(coin, chainId);
    const priceChart = coinGekoData.length > 0 ? [...coinGekoData] : [...pangolinData];
    // add current price in chart
    if (priceChart.length > 0 && usdcPrice) {
        const timestampnow = Math.floor(Date.now() / 1000);
        priceChart.push({
            priceUSD: parseFloat(usdcPrice),
            timestamp: `${timestampnow}`,
        });
    }
    return (jsxs(Box, { children: [jsxs(SelectedCoinInfo, { children: [jsx(CurrencyLogo, { currency: token, size: 48 }, void 0), jsxs(Box, { children: [jsx(Text$1, Object.assign({ color: "text1", fontSize: "24px" }, { children: token.symbol }), void 0), jsxs(Text$1, Object.assign({ color: "green1", fontSize: "16px" }, { children: ["$", usdcPrice ? usdcPrice : '-'] }), void 0)] }, void 0), jsxs(TrackIcons, { children: [jsx(Button, Object.assign({ variant: "primary", backgroundColor: "primary", color: "black", width: '32px', height: '32px', padding: "0px", href: `${ANALYTICS_PAGE}/#/token/${coin === null || coin === void 0 ? void 0 : coin.address}`, target: "_blank", as: "a" }, { children: jsx(Link$3, { size: 12 }, void 0) }), void 0), visibleTradeButton &&
                                (redirect ? (jsx(Button, Object.assign({ variant: "plain", backgroundColor: "oceanBlue", color: "white", padding: "0px 10px", height: "32px", href: `/#${tradeLinkUrl}?inputCurrency=${coin === null || coin === void 0 ? void 0 : coin.address}`, target: "", as: "a" }, { children: "Trade" }), void 0)) : (jsx(Button, Object.assign({ variant: "plain", backgroundColor: "oceanBlue", color: "white", padding: "0px 10px", height: "32px", onClick: () => {
                                        onCurrencySelect(coin);
                                    } }, { children: "Trade" }), void 0)))] }, void 0)] }, void 0), jsx(ResponsiveContainer, Object.assign({ height: 150, width: '100%' }, { children: jsxs(LineChart, Object.assign({ data: priceChart }, { children: [jsx(Line, { type: "monotone", dataKey: "priceUSD", stroke: '#18C145', dot: false }, void 0), jsx(Tooltip, { cursor: true, formatter: (priceUSD) => {
                                return [`${formattedNum(priceUSD, true)}`, 'USD'];
                            }, labelFormatter: (_label, data) => {
                                var _a, _b;
                                return toNiceDateYear((_b = (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.timestamp);
                            }, labelStyle: { paddingTop: 4 }, wrapperStyle: { top: -70, left: -10, zIndex: 9999 } }, void 0)] }), void 0) }), void 0), jsx(DurationBtns, { children: TIMEFRAME.map((btn) => (jsx(Button, Object.assign({ variant: "plain", padding: "0px", width: "auto", color: timeWindow.label === btn.label ? 'mustardYellow' : 'text1', onClick: () => setTimeWindow(btn) }, { children: btn === null || btn === void 0 ? void 0 : btn.label }), btn === null || btn === void 0 ? void 0 : btn.label))) }, void 0)] }, void 0));
};

function filterTokens$1(tokens, search) {
    if (search.length === 0)
        return tokens;
    const searchingAddress = isAddress(search);
    if (searchingAddress) {
        return tokens.filter((token) => token.address === searchingAddress);
    }
    const lowerSearchParts = search
        .toLowerCase()
        .split(/\s+/)
        .filter((s) => s.length > 0);
    if (lowerSearchParts.length === 0) {
        return tokens;
    }
    const matchesSearch = (s) => {
        const sParts = s
            .toLowerCase()
            .split(/\s+/)
            .filter((value) => value.length > 0);
        return lowerSearchParts.every((p) => p.length === 0 || sParts.some((sp) => sp.startsWith(p) || sp.endsWith(p)));
    };
    return tokens.filter((token) => {
        const { symbol, name } = token;
        return (symbol && matchesSearch(symbol)) || (name && matchesSearch(name));
    });
}

// compare two token amounts with highest one coming first
function balanceComparator$1(balanceA, balanceB) {
    if (balanceA && balanceB) {
        return balanceA.greaterThan(balanceB) ? -1 : balanceA.equalTo(balanceB) ? 0 : 1;
    }
    else if (balanceA && balanceA.greaterThan('0')) {
        return -1;
    }
    else if (balanceB && balanceB.greaterThan('0')) {
        return 1;
    }
    return 0;
}
function getTokenComparator$1(balances) {
    return function sortTokens(tokenA, tokenB) {
        // -1 = a is first
        // 1 = b is first
        // sort by balances
        const balanceA = balances[tokenA.address];
        const balanceB = balances[tokenB.address];
        const balanceComp = balanceComparator$1(balanceA, balanceB);
        if (balanceComp !== 0)
            return balanceComp;
        if (tokenA.symbol && tokenB.symbol) {
            // sort by symbol
            return tokenA.symbol.toLowerCase() < tokenB.symbol.toLowerCase() ? -1 : 1;
        }
        else {
            return tokenA.symbol ? -1 : tokenB.symbol ? -1 : 0;
        }
    };
}
function useTokenComparator$1(inverted, firstTokens) {
    const balances = useAllTokenBalances();
    const comparator = useMemo(() => getTokenComparator$1(balances !== null && balances !== void 0 ? balances : {}), [balances]);
    return useMemo(() => {
        // if firstToken add firstToken in top of array
        if (firstTokens) {
            return (tokenA, tokenB) => {
                const firstTokenIndex = firstTokens.findIndex((t) => t.address === tokenA.address);
                const secondTokenIndex = firstTokens.findIndex((t) => t.address === tokenB.address);
                if (firstTokenIndex !== -1 || secondTokenIndex !== -1) {
                    return secondTokenIndex - firstTokenIndex;
                }
                return comparator(tokenA, tokenB) * (inverted ? -1 : 1);
            };
        }
        if (inverted) {
            return (tokenA, tokenB) => comparator(tokenA, tokenB) * -1;
        }
        else {
            return comparator;
        }
    }, [inverted, firstTokens, comparator]);
}

// modified from https://usehooks.com/usePrevious/
function usePrevious(value) {
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    const ref = useRef();
    // Store current value in ref
    useEffect(() => {
        ref.current = value;
    }, [value]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return ref.current;
}

const addCurrency = createAction('watchlists/addCurrency');
const removeCurrency = createAction('watchlists/removeCurrency');

styled(Box) `
  padding: 10px;
`;
const AddInputWrapper$1 = styled(Box) `
  display: grid;
  grid-gap: 10px;
`;
const PopoverContainer$1 = styled(Box) `
  z-index: 100;
  background: ${({ theme }) => theme.bg6};
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  color: ${({ theme }) => theme.text2};
  border-radius: 0.5rem;
  padding: 5px;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  text-align: left;
  height: 200px;
  position: absolute;
  min-width: 20.125rem;
  right: -6px;
  margin-top: 20px;
  &:after {
    content: '';
    position: absolute;
    top: -14px;
    left: 280px;
    border-style: solid;
    border-width: 0px 15px 15px;
    border-color: ${({ theme }) => theme.bg6} transparent;
    display: block;
    width: 0;
    z-index: 1;
  }
`;
const RowWrapper = styled.div `
  padding: 5px 5px;
  display: grid;
  grid-template-columns: 100px minmax(auto, calc(100% - 150px)) 50px;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.text9};
  border-radius: 4px;
  height: 45px;

  cursor: ${({ disabled }) => !disabled && 'pointer'};
  pointer-events: ${({ disabled }) => disabled && 'none'};

  &:hover {
    background-color: ${({ theme, disabled }) => !disabled && theme.bg3};
  }

  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;
const CurrencyList$1 = styled.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
  overflow-y: auto;
`;

const WatchlistCurrencyRow = ({ currency, onSelect, style }) => {
    const usdcPrice = useUSDCPrice(currency);
    const isSelected = useIsSelectedCurrency(currency === null || currency === void 0 ? void 0 : currency.address);
    const chainId = useChainId();
    const handleSelect = useCallback(() => {
        onSelect(currency === null || currency === void 0 ? void 0 : currency.address);
    }, [onSelect, currency]);
    const token = unwrappedToken(currency, chainId);
    return (jsxs(RowWrapper, Object.assign({ disabled: isSelected, style: style }, { children: [jsxs(Box, Object.assign({ display: "flex", alignItems: "center" }, { children: [jsx(CurrencyLogo, { size: 24, currency: token }, void 0), jsx(Text$1, Object.assign({ color: "text1", fontSize: 20, fontWeight: 500, marginLeft: '6px' }, { children: token === null || token === void 0 ? void 0 : token.symbol }), void 0)] }), void 0), jsx(Box, Object.assign({ ml: '10px', textAlign: "right" }, { children: jsxs(Text$1, Object.assign({ color: "text1", fontSize: 16, fontWeight: 500 }, { children: ["$", usdcPrice ? usdcPrice === null || usdcPrice === void 0 ? void 0 : usdcPrice.toSignificant(4, { groupSeparator: ',' }) : '-'] }), void 0) }), void 0), jsx(Box, Object.assign({ ml: '10px', textAlign: "right" }, { children: jsx(Button, Object.assign({ variant: "secondary", backgroundColor: "bg9", color: "text6", padding: '0px', onClick: handleSelect, height: "24px" }, { children: "Add" }), void 0) }), void 0)] }), void 0));
};

const currencyKey$1 = (currency, chainId) => {
    return currency instanceof Token$2 ? currency.address : currency === CAVAX[chainId] ? 'AVAX' : '';
};
const CurrencyPopover = ({ getRef = () => {
    /* */
}, coins, isOpen, onSelectCurrency, }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [invertSearchOrder] = useState(false);
    const chainId = useChainId();
    const inputRef = useRef(null);
    const lastOpen = usePrevious(isOpen);
    useEffect(() => {
        if (isOpen && !lastOpen) {
            setSearchQuery('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    useEffect(() => {
        if (isOpen && inputRef.current) {
            setTimeout(() => {
                var _a;
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 500);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    const isAddressSearch = isAddress(searchQuery);
    const searchToken = useToken(searchQuery);
    const tokenComparator = useTokenComparator$1(invertSearchOrder, [WAVAX[chainId]]);
    const filteredTokens = useMemo(() => {
        if (isAddressSearch)
            return searchToken ? [searchToken] : [];
        return filterTokens$1(Object.values(coins), searchQuery);
    }, [isAddressSearch, searchToken, coins, searchQuery]);
    const filteredSortedTokens = useMemo(() => {
        if (searchToken)
            return [searchToken];
        const sorted = filteredTokens.sort(tokenComparator);
        const symbolMatch = searchQuery
            .toLowerCase()
            .split(/\s+/)
            .filter((s) => s.length > 0);
        if (symbolMatch.length > 1)
            return sorted;
        return [
            ...(searchToken ? [searchToken] : []),
            // sort any exact symbol matches first
            ...sorted.filter((token) => { var _a; return ((_a = token.symbol) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === symbolMatch[0]; }),
            ...sorted.filter((token) => { var _a; return ((_a = token.symbol) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== symbolMatch[0]; }),
        ];
    }, [filteredTokens, searchQuery, searchToken, tokenComparator]);
    const currencies = filteredSortedTokens;
    const dispatch = useDispatch();
    const onCurrencySelection = useCallback((address) => {
        dispatch(addCurrency(address));
    }, [dispatch]);
    const Row = useCallback(({ data, index, style }) => {
        const currency = data === null || data === void 0 ? void 0 : data[index];
        return currency ? (jsx(WatchlistCurrencyRow, { style: style, currency: currency, onSelect: (address) => {
                onSelectCurrency(currency);
                onCurrencySelection(address);
            } }, index)) : null;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return (jsxs(PopoverContainer$1, Object.assign({ ref: (ref) => getRef(ref) }, { children: [jsx(Box, Object.assign({ padding: "0px 10px" }, { children: jsx(AddInputWrapper$1, { children: jsx(TextInput, { placeholder: "Search", onChange: (value) => {
                            setSearchQuery(value);
                        }, value: searchQuery, getRef: (ref) => (inputRef.current = ref) }, void 0) }, void 0) }), void 0), jsx(CurrencyList$1, { children: jsx(AutoSizer, Object.assign({ disableWidth: true }, { children: ({ height }) => (jsx(FixedSizeList, Object.assign({ height: height, width: "100%", itemCount: currencies.length, itemSize: 45, itemData: currencies, itemKey: (index, data) => currencyKey$1(data[index], chainId) }, { children: Row }), void 0)) }), void 0) }, void 0)] }), void 0));
};

const WatchlistRow = ({ coin, onClick, onRemove, isSelected }) => {
    var _a, _b, _c;
    const chainId = useChainId();
    const [showChart, setShowChart] = useState(false);
    const [showDeleteButton, setShowDeleteButton] = useState(false);
    const theme = useContext(Me);
    const { tokenUsdPrice } = useCoinGeckoTokenPrice(coin);
    const tokenPrice = useUSDCPrice(coin);
    const usdcPrice = tokenUsdPrice || (tokenPrice === null || tokenPrice === void 0 ? void 0 : tokenPrice.toSignificant(4));
    const coinGekoData = useCoinGeckoTokenPriceChart(coin) || [];
    const pangolinData = useTokenWeeklyChartData((_a = coin === null || coin === void 0 ? void 0 : coin.address) === null || _a === void 0 ? void 0 : _a.toLowerCase());
    const chartData = coinGekoData.length > 0 ? coinGekoData : pangolinData;
    const currentUSDPrice = ((_b = chartData === null || chartData === void 0 ? void 0 : chartData[(chartData || []).length - 1]) === null || _b === void 0 ? void 0 : _b.priceUSD) || 0;
    const previousUSDPrice = ((_c = chartData === null || chartData === void 0 ? void 0 : chartData[0]) === null || _c === void 0 ? void 0 : _c.priceUSD) || 0;
    const diffPercent = currentUSDPrice - previousUSDPrice < 0 ? -1 : 1;
    const decreaseValue = currentUSDPrice - previousUSDPrice;
    const perc = (decreaseValue / previousUSDPrice) * 100;
    const token = unwrappedToken(coin, chainId);
    const dispatch = useDispatch();
    const removeToken = () => {
        onRemove();
        dispatch(removeCurrency(coin === null || coin === void 0 ? void 0 : coin.address));
    };
    useEffect(() => {
        if (usdcPrice) {
            setTimeout(() => {
                // show chart only after price of token comes to display chart in visible space
                setShowChart(true);
            });
        }
    }, [usdcPrice, setShowChart]);
    return (jsxs(RowWrapper$1, Object.assign({ isSelected: isSelected, onMouseEnter: () => setShowDeleteButton(true), onMouseLeave: () => setShowDeleteButton(false) }, { children: [jsxs(Box, Object.assign({ display: "flex", alignItems: "center", height: '100%', onClick: onClick }, { children: [jsx(CurrencyLogo, { size: 24, currency: token, imageSize: 48 }, void 0), jsx(Text$1, Object.assign({ color: "text1", fontSize: 20, fontWeight: 500, marginLeft: '6px' }, { children: token.symbol }), void 0)] }), void 0), jsx(Box, Object.assign({ px: "7px", display: "flex", alignItems: "center", height: '100%', onClick: onClick }, { children: showChart && (jsx(ResponsiveContainer, Object.assign({ width: '99%' }, { children: jsx(LineChart, Object.assign({ data: chartData, margin: { top: 23 } }, { children: jsx(Line, { type: "monotone", dataKey: "priceUSD", stroke: diffPercent >= 0 ? theme.green1 : theme.red1, dot: false }, void 0) }), void 0) }), void 0)) }), void 0), jsxs(Box, Object.assign({ textAlign: "right", minWidth: 30, height: '100%' }, { children: [showDeleteButton && coin.address !== PNG[chainId].address && (jsx(Box, Object.assign({ zIndex: 2, position: "relative" }, { children: jsx(DeleteButton, Object.assign({ onClick: removeToken }, { children: jsx(X$1, { fontSize: 16, fontWeight: 600, style: { float: 'right' } }, void 0) }), void 0) }), void 0)), jsxs(Box, Object.assign({ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%", onClick: onClick }, { children: [jsx(Text$1, Object.assign({ color: "text1", fontSize: 14, fontWeight: 500 }, { children: usdcPrice ? `$${usdcPrice}` : '-' }), void 0), !isNaN(perc) && (jsxs(Text$1, Object.assign({ color: diffPercent > 0 ? 'green1' : 'red1', fontSize: '8px', fontWeight: 500 }, { children: [perc.toFixed(3), "%"] }), void 0))] }), void 0)] }), void 0)] }), void 0));
};

const WatchList = ({ coinChartVisible = true, visibleTradeButton = true, tradeLinkUrl, redirect = false, }) => {
    const { chainId = ChainId.AVALANCHE } = usePangolinWeb3();
    const [showMore, setShowMore] = useState(false);
    const allTokens = useAllTokens();
    const coins = Object.values(allTokens || {});
    const watchListCurrencies = useSelectedCurrencyLists();
    const theme = useContext(Me);
    const [selectedToken, setSelectedToken] = useState((watchListCurrencies === null || watchListCurrencies === void 0 ? void 0 : watchListCurrencies[0]) || {});
    const [open, toggle] = useToggle(false);
    const node = useRef();
    const popoverRef = useRef(null);
    const referenceElement = useRef(null);
    const currencies = useMemo(() => ((watchListCurrencies || []).length === 0 ? [PNG[chainId]] : watchListCurrencies), [chainId, watchListCurrencies]);
    useOnClickOutside(node, open ? toggle : undefined);
    const renderWatchlistRow = (coin) => {
        return (jsx(WatchlistRow, { coin: coin, onClick: () => setSelectedToken(coin), onRemove: () => setSelectedToken(PNG[chainId]), isSelected: (coin === null || coin === void 0 ? void 0 : coin.address) === (selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.address) }, coin.address));
    };
    const renderCoinChart = () => {
        return (jsx(Hidden, Object.assign({ upToSmall: true }, { children: jsx(CoinChart, { coin: selectedToken, visibleTradeButton: visibleTradeButton, tradeLinkUrl: tradeLinkUrl, redirect: redirect }, void 0) }), void 0));
    };
    return (jsxs(WatchListRoot, { children: [jsxs(Box, Object.assign({ display: "flex", alignItems: "center", justifyContent: "space-between" }, { children: [jsx(Title, { children: "Watchlist" }, void 0), jsxs(Box, Object.assign({ bgColor: theme.bg5, position: "relative", p: '5px', ref: node }, { children: [jsx(Box, Object.assign({ ref: referenceElement, onClick: toggle }, { children: jsx(Button, Object.assign({ variant: "primary", backgroundColor: "primary", color: "white", width: '32px', height: '32px', padding: "0px" }, { children: jsx(Plus$1, { size: 12, color: 'black' }, void 0) }), void 0) }), void 0), open && (jsx(CurrencyPopover, { getRef: (ref) => (popoverRef.current = ref), coins: coins, isOpen: open, onSelectCurrency: (currency) => {
                                    setSelectedToken(currency);
                                    toggle();
                                } }, void 0))] }), void 0)] }), void 0), jsxs(GridContainer, Object.assign({ coinChartVisible: coinChartVisible }, { children: [CHAINS[chainId].mainnet && coinChartVisible && renderCoinChart(), jsx(DesktopWatchList, { children: jsx(Scrollbars, { children: (currencies || []).map(renderWatchlistRow) }, void 0) }, void 0), jsxs(MobileWatchList, { children: [(currencies || []).slice(0, 3).map(renderWatchlistRow), showMore && (currencies || []).slice(3).map(renderWatchlistRow), currencies.length > 3 && jsx(ShowMore, { showMore: showMore, onToggle: () => setShowMore(!showMore) }, void 0)] }, void 0)] }), void 0)] }, void 0));
};

const protocols = ['http', 'https', 'mailto', 'tel'];

/**
 * @param {string} uri
 * @returns {string}
 */
function uriTransformer(uri) {
  const url = (uri || '').trim();
  const first = url.charAt(0);

  if (first === '#' || first === '/') {
    return url
  }

  const colon = url.indexOf(':');
  if (colon === -1) {
    return url
  }

  let index = -1;

  while (++index < protocols.length) {
    const protocol = protocols[index];

    if (
      colon === protocol.length &&
      url.slice(0, protocol.length).toLowerCase() === protocol
    ) {
      return url
    }
  }

  index = url.indexOf('?');
  if (index !== -1 && colon > index) {
    return url
  }

  index = url.indexOf('#');
  if (index !== -1 && colon > index) {
    return url
  }

  // eslint-disable-next-line no-script-url
  return 'javascript:void(0)'
}

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

var isBuffer$1 = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
};

/**
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {object & {type: string, position?: Position|undefined}} NodeLike
 */

/**
 * Stringify one point, a position (start and end points), or a node’s
 * positional information.
 *
 * @param {Node|NodeLike|Position|Point|null} [value]
 * @returns {string}
 */
function stringifyPosition(value) {
  // Nothing.
  if (!value || typeof value !== 'object') {
    return ''
  }

  // Node.
  if ('position' in value || 'type' in value) {
    return position(value.position)
  }

  // Position.
  if ('start' in value || 'end' in value) {
    return position(value)
  }

  // Point.
  if ('line' in value || 'column' in value) {
    return point$1(value)
  }

  // ?
  return ''
}

/**
 * @param {Point|undefined} point
 * @returns {string}
 */
function point$1(point) {
  return index(point && point.line) + ':' + index(point && point.column)
}

/**
 * @param {Position|undefined} pos
 * @returns {string}
 */
function position(pos) {
  return point$1(pos && pos.start) + '-' + point$1(pos && pos.end)
}

/**
 * @param {number|undefined} value
 * @returns {number}
 */
function index(value) {
  return value && typeof value === 'number' ? value : 1
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position|undefined}} NodeLike
 */

class VFileMessage$1 extends Error {
  /**
   * Constructor of a message for `reason` at `place` from `origin`.
   * When an error is passed in as `reason`, copies the `stack`.
   *
   * @param {string|Error} reason Reason for message (`string` or `Error`). Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place] Place at which the message occurred in a file (`Node`, `Position`, or `Point`, optional).
   * @param {string} [origin] Place in code the message originates from (`string`, optional).
   */
  constructor(reason, place, origin) {
    /** @type {[string|null, string|null]} */
    const parts = [null, null];
    /** @type {Position} */
    let position = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: {line: null, column: null},
      // @ts-expect-error: "
      end: {line: null, column: null}
    };

    super();

    if (typeof place === 'string') {
      origin = place;
      place = undefined;
    }

    if (typeof origin === 'string') {
      const index = origin.indexOf(':');

      if (index === -1) {
        parts[1] = origin;
      } else {
        parts[0] = origin.slice(0, index);
        parts[1] = origin.slice(index + 1);
      }
    }

    if (place) {
      // Node.
      if ('type' in place || 'position' in place) {
        if (place.position) {
          position = place.position;
        }
      }
      // Position.
      else if ('start' in place || 'end' in place) {
        position = place;
      }
      // Point.
      else if ('line' in place || 'column' in place) {
        position.start = place;
      }
    }

    // Fields from `Error`
    this.name = stringifyPosition(place) || '1:1';
    this.message = typeof reason === 'object' ? reason.message : reason;
    this.stack = typeof reason === 'object' ? reason.stack : '';

    /**
     * Reason for message.
     * @type {string}
     */
    this.reason = this.message;
    /**
     * If true, marks associated file as no longer processable.
     * @type {boolean?}
     */
    // eslint-disable-next-line no-unused-expressions
    this.fatal;
    /**
     * Starting line of error.
     * @type {number?}
     */
    this.line = position.start.line;
    /**
     * Starting column of error.
     * @type {number?}
     */
    this.column = position.start.column;
    /**
     * Namespace of warning.
     * @type {string?}
     */
    this.source = parts[0];
    /**
     * Category of message.
     * @type {string?}
     */
    this.ruleId = parts[1];
    /**
     * Full range information, when available.
     * Has start and end properties, both set to an object with line and column, set to number?.
     * @type {Position?}
     */
    this.position = position;

    // The following fields are “well known”.
    // Not standard.
    // Feel free to add other non-standard fields to your messages.

    /* eslint-disable no-unused-expressions */
    /**
     * You can use this to specify the source value that’s being reported, which
     * is deemed incorrect.
     * @type {string?}
     */
    this.actual;
    /**
     * You can use this to suggest values that should be used instead of
     * `actual`, one or more values that are deemed as acceptable.
     * @type {Array<string>?}
     */
    this.expected;
    /**
     * You may add a file property with a path of a file (used throughout the VFile ecosystem).
     * @type {string?}
     */
    this.file;
    /**
     * You may add a url property with a link to documentation for the message.
     * @type {string?}
     */
    this.url;
    /**
     * You may add a note property with a long form description of the message (supported by vfile-reporter).
     * @type {string?}
     */
    this.note;
    /* eslint-enable no-unused-expressions */
  }
}

VFileMessage$1.prototype.file = '';
VFileMessage$1.prototype.name = '';
VFileMessage$1.prototype.reason = '';
VFileMessage$1.prototype.message = '';
VFileMessage$1.prototype.stack = '';
VFileMessage$1.prototype.fatal = null;
VFileMessage$1.prototype.column = null;
VFileMessage$1.prototype.line = null;
VFileMessage$1.prototype.source = null;
VFileMessage$1.prototype.ruleId = null;
VFileMessage$1.prototype.position = null;

/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */

/**
 * @param {unknown} fileURLOrPath
 * @returns {fileURLOrPath is URL}
 */
// From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function isUrl$1(fileURLOrPath) {
  return (
    fileURLOrPath !== null &&
    typeof fileURLOrPath === 'object' &&
    // @ts-expect-error: indexable.
    fileURLOrPath.href &&
    // @ts-expect-error: indexable.
    fileURLOrPath.origin
  )
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {Record<string, unknown> & {type: string, position?: Position|undefined}} NodeLike
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('..').VFileData} VFileData
 * @typedef {import('..').VFileValue} VFileValue
 *
 * @typedef {'ascii'|'utf8'|'utf-8'|'utf16le'|'ucs2'|'ucs-2'|'base64'|'base64url'|'latin1'|'binary'|'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *   This is a copy of the typing from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {VFileValue|VFileOptions|VFile|URL} VFileCompatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 * @property {VFileValue} [value]
 * @property {string} [cwd]
 * @property {Array<string>} [history]
 * @property {string|URL} [path]
 * @property {string} [basename]
 * @property {string} [stem]
 * @property {string} [extname]
 * @property {string} [dirname]
 * @property {VFileData} [data]
 *
 * @typedef Map
 *   Raw source map, see:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 * @property {Array<string>} sources
 * @property {Array<string>} names
 * @property {string|undefined} [sourceRoot]
 * @property {Array<string>|undefined} [sourcesContent]
 * @property {string} mappings
 * @property {string} file
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} VFileOptions
 *   Configuration: a bunch of keys that will be shallow copied over to the new
 *   file.
 *
 * @typedef {Record<string, unknown>} VFileReporterSettings
 * @typedef {<T = VFileReporterSettings>(files: Array<VFile>, options: T) => string} VFileReporter
 */

// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
const order$1 = ['history', 'path', 'basename', 'stem', 'extname', 'dirname'];

class VFile$1 {
  /**
   * Create a new virtual file.
   *
   * If `options` is `string` or `Buffer`, treats it as `{value: options}`.
   * If `options` is a `VFile`, shallow copies its data over to the new file.
   * All other given fields are set on the newly created `VFile`.
   *
   * Path related properties are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * It’s not possible to set either `dirname` or `extname` without setting
   * either `history`, `path`, `basename`, or `stem` as well.
   *
   * @param {VFileCompatible} [value]
   */
  constructor(value) {
    /** @type {VFileOptions} */
    let options;

    if (!value) {
      options = {};
    } else if (typeof value === 'string' || isBuffer$1(value)) {
      // @ts-expect-error Looks like a buffer.
      options = {value};
    } else if (isUrl$1(value)) {
      options = {path: value};
    } else {
      // @ts-expect-error Looks like file or options.
      options = value;
    }

    /**
     * Place to store custom information.
     * It’s OK to store custom data directly on the file, moving it to `data`
     * gives a little more privacy.
     * @type {VFileData}
     */
    this.data = {};

    /**
     * List of messages associated with the file.
     * @type {Array<VFileMessage>}
     */
    this.messages = [];

    /**
     * List of file paths the file moved between.
     * @type {Array<string>}
     */
    this.history = [];

    /**
     * Base of `path`.
     * Defaults to `process.cwd()` (`/` in browsers).
     * @type {string}
     */
    this.cwd = proc.cwd();

    /* eslint-disable no-unused-expressions */
    /**
     * Raw value.
     * @type {VFileValue}
     */
    this.value;

    // The below are non-standard, they are “well-known”.
    // As in, used in several tools.

    /**
     * Whether a file was saved to disk.
     * This is used by vfile reporters.
     * @type {boolean}
     */
    this.stored;

    /**
     * Sometimes files have a non-string representation.
     * This can be stored in the `result` field.
     * One example is when turning markdown into React nodes.
     * This is used by unified to store non-string results.
     * @type {unknown}
     */
    this.result;

    /**
     * Sometimes files have a source map associated with them.
     * This can be stored in the `map` field.
     * This should be a `RawSourceMap` type from the `source-map` module.
     * @type {Map|undefined}
     */
    this.map;
    /* eslint-enable no-unused-expressions */

    // Set path related properties in the correct order.
    let index = -1;

    while (++index < order$1.length) {
      const prop = order$1[index];

      // Note: we specifically use `in` instead of `hasOwnProperty` to accept
      // `vfile`s too.
      if (prop in options && options[prop] !== undefined) {
        // @ts-expect-error: TS is confused by the different types for `history`.
        this[prop] = prop === 'history' ? [...options[prop]] : options[prop];
      }
    }

    /** @type {string} */
    let prop;

    // Set non-path related properties.
    for (prop in options) {
      // @ts-expect-error: fine to set other things.
      if (!order$1.includes(prop)) this[prop] = options[prop];
    }
  }

  /**
   * Access full path (`~/index.min.js`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1]
  }

  /**
   * Set full path (`~/index.min.js`).
   * Cannot be nullified.
   *
   * @param {string|URL} path
   */
  set path(path) {
    if (isUrl$1(path)) {
      path = fileURLToPath(path);
    }

    assertNonEmpty$1(path, 'path');

    if (this.path !== path) {
      this.history.push(path);
    }
  }

  /**
   * Access parent path (`~`).
   */
  get dirname() {
    return typeof this.path === 'string' ? path$2.dirname(this.path) : undefined
  }

  /**
   * Set parent path (`~`).
   * Cannot be set if there's no `path` yet.
   */
  set dirname(dirname) {
    assertPath$1(this.basename, 'dirname');
    this.path = path$2.join(dirname || '', this.basename);
  }

  /**
   * Access basename (including extname) (`index.min.js`).
   */
  get basename() {
    return typeof this.path === 'string' ? path$2.basename(this.path) : undefined
  }

  /**
   * Set basename (`index.min.js`).
   * Cannot contain path separators.
   * Cannot be nullified either (use `file.path = file.dirname` instead).
   */
  set basename(basename) {
    assertNonEmpty$1(basename, 'basename');
    assertPart$1(basename, 'basename');
    this.path = path$2.join(this.dirname || '', basename);
  }

  /**
   * Access extname (including dot) (`.js`).
   */
  get extname() {
    return typeof this.path === 'string' ? path$2.extname(this.path) : undefined
  }

  /**
   * Set extname (including dot) (`.js`).
   * Cannot be set if there's no `path` yet and cannot contain path separators.
   */
  set extname(extname) {
    assertPart$1(extname, 'extname');
    assertPath$1(this.dirname, 'extname');

    if (extname) {
      if (extname.charCodeAt(0) !== 46 /* `.` */) {
        throw new Error('`extname` must start with `.`')
      }

      if (extname.includes('.', 1)) {
        throw new Error('`extname` cannot contain multiple dots')
      }
    }

    this.path = path$2.join(this.dirname, this.stem + (extname || ''));
  }

  /**
   * Access stem (w/o extname) (`index.min`).
   */
  get stem() {
    return typeof this.path === 'string'
      ? path$2.basename(this.path, this.extname)
      : undefined
  }

  /**
   * Set stem (w/o extname) (`index.min`).
   * Cannot be nullified, and cannot contain path separators.
   */
  set stem(stem) {
    assertNonEmpty$1(stem, 'stem');
    assertPart$1(stem, 'stem');
    this.path = path$2.join(this.dirname || '', stem + (this.extname || ''));
  }

  /**
   * Serialize the file.
   *
   * @param {BufferEncoding} [encoding='utf8'] If `file.value` is a buffer, `encoding` is used to serialize buffers.
   * @returns {string}
   */
  toString(encoding) {
    return (this.value || '').toString(encoding)
  }

  /**
   * Create a message and associates it w/ the file.
   *
   * @param {string|Error} reason Reason for message (`string` or `Error`). Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place] Place at which the message occurred in a file (`Node`, `Position`, or `Point`, optional).
   * @param {string} [origin] Place in code the message originates from (`string`, optional).
   * @returns {VFileMessage}
   */
  message(reason, place, origin) {
    const message = new VFileMessage$1(reason, place, origin);

    if (this.path) {
      message.name = this.path + ':' + message.name;
      message.file = this.path;
    }

    message.fatal = false;

    this.messages.push(message);

    return message
  }

  /**
   * Info: create a message, associate it with the file, and mark the fatality
   * as `null`.
   * Calls `message()` internally.
   *
   * @param {string|Error} reason Reason for message (`string` or `Error`). Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place] Place at which the message occurred in a file (`Node`, `Position`, or `Point`, optional).
   * @param {string} [origin] Place in code the message originates from (`string`, optional).
   * @returns {VFileMessage}
   */
  info(reason, place, origin) {
    const message = this.message(reason, place, origin);

    message.fatal = null;

    return message
  }

  /**
   * Fail: create a message, associate it with the file, mark the fatality as
   * `true`.
   * Note: fatal errors mean a file is no longer processable.
   * Calls `message()` internally.
   *
   * @param {string|Error} reason Reason for message (`string` or `Error`). Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place] Place at which the message occurred in a file (`Node`, `Position`, or `Point`, optional).
   * @param {string} [origin] Place in code the message originates from (`string`, optional).
   * @returns {never}
   */
  fail(reason, place, origin) {
    const message = this.message(reason, place, origin);

    message.fatal = true;

    throw message
  }
}

/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string|undefined} part
 * @param {string} name
 * @returns {void}
 */
function assertPart$1(part, name) {
  if (part && part.includes(path$2.sep)) {
    throw new Error(
      '`' + name + '` cannot be a path: did not expect `' + path$2.sep + '`'
    )
  }
}

/**
 * Assert that `part` is not empty.
 *
 * @param {string|undefined} part
 * @param {string} name
 * @returns {asserts part is string}
 */
function assertNonEmpty$1(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty')
  }
}

/**
 * Assert `path` exists.
 *
 * @param {string|undefined} path
 * @param {string} name
 * @returns {asserts path is string}
 */
function assertPath$1(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too')
  }
}

/**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */
function bail(error) {
  if (error) {
    throw error
  }
}

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray$3 = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject$2 = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty$1 = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

var extend$1 = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty$1(target, name);
				copy = getProperty$1(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject$2(copy) || (copyIsArray = isArray$3(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray$3(src) ? src : [];
						} else {
							clone = src && isPlainObject$2(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};

function isPlainObject$1(value) {
	if (Object.prototype.toString.call(value) !== '[object Object]') {
		return false;
	}

	const prototype = Object.getPrototypeOf(value);
	return prototype === null || prototype === Object.prototype;
}

/**
 * @typedef {(error?: Error|null|undefined, ...output: Array<any>) => void} Callback
 * @typedef {(...input: Array<any>) => any} Middleware
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add `fn` (middleware) to the list.
 * @typedef {{run: Run, use: Use}} Pipeline
 *   Middleware.
 */

/**
 * Create new middleware.
 *
 * @returns {Pipeline}
 */
function trough() {
  /** @type {Array<Middleware>} */
  const fns = [];
  /** @type {Pipeline} */
  const pipeline = {run, use};

  return pipeline

  /** @type {Run} */
  function run(...values) {
    let middlewareIndex = -1;
    /** @type {Callback} */
    const callback = values.pop();

    if (typeof callback !== 'function') {
      throw new TypeError('Expected function as last argument, not ' + callback)
    }

    next(null, ...values);

    /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error|null|undefined} error
     * @param {Array<any>} output
     */
    function next(error, ...output) {
      const fn = fns[++middlewareIndex];
      let index = -1;

      if (error) {
        callback(error);
        return
      }

      // Copy non-nullish input into values.
      while (++index < values.length) {
        if (output[index] === null || output[index] === undefined) {
          output[index] = values[index];
        }
      }

      // Save the newly created `output` for the next call.
      values = output;

      // Next or done.
      if (fn) {
        wrap$2(fn, next)(...output);
      } else {
        callback(null, ...output);
      }
    }
  }

  /** @type {Use} */
  function use(middelware) {
    if (typeof middelware !== 'function') {
      throw new TypeError(
        'Expected `middelware` to be a function, not ' + middelware
      )
    }

    fns.push(middelware);
    return pipeline
  }
}

/**
 * Wrap `middleware`.
 * Can be sync or async; return a promise, receive a callback, or return new
 * values and errors.
 *
 * @param {Middleware} middleware
 * @param {Callback} callback
 */
function wrap$2(middleware, callback) {
  /** @type {boolean} */
  let called;

  return wrapped

  /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length;
    /** @type {any} */
    let result;

    if (fnExpectsCallback) {
      parameters.push(done);
    }

    try {
      result = middleware.apply(this, parameters);
    } catch (error) {
      const exception = /** @type {Error} */ (error);

      // Well, this is quite the pickle.
      // `middleware` received a callback and called it synchronously, but that
      // threw an error.
      // The only thing left to do is to throw the thing instead.
      if (fnExpectsCallback && called) {
        throw exception
      }

      return done(exception)
    }

    if (!fnExpectsCallback) {
      if (result instanceof Promise) {
        result.then(then, done);
      } else if (result instanceof Error) {
        done(result);
      } else {
        then(result);
      }
    }
  }

  /**
   * Call `callback`, only once.
   * @type {Callback}
   */
  function done(error, ...output) {
    if (!called) {
      called = true;
      callback(error, ...output);
    }
  }

  /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */
  function then(value) {
    done(null, value);
  }
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position|undefined}} NodeLike
 */

class VFileMessage extends Error {
  /**
   * Constructor of a message for `reason` at `place` from `origin`.
   * When an error is passed in as `reason`, copies the `stack`.
   *
   * @param {string|Error} reason Reason for message (`string` or `Error`). Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place] Place at which the message occurred in a file (`Node`, `Position`, or `Point`, optional).
   * @param {string} [origin] Place in code the message originates from (`string`, optional).
   */
  constructor(reason, place, origin) {
    /** @type {[string|null, string|null]} */
    const parts = [null, null];
    /** @type {Position} */
    let position = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: {line: null, column: null},
      // @ts-expect-error: "
      end: {line: null, column: null}
    };

    super();

    if (typeof place === 'string') {
      origin = place;
      place = undefined;
    }

    if (typeof origin === 'string') {
      const index = origin.indexOf(':');

      if (index === -1) {
        parts[1] = origin;
      } else {
        parts[0] = origin.slice(0, index);
        parts[1] = origin.slice(index + 1);
      }
    }

    if (place) {
      // Node.
      if ('type' in place || 'position' in place) {
        if (place.position) {
          position = place.position;
        }
      }
      // Position.
      else if ('start' in place || 'end' in place) {
        position = place;
      }
      // Point.
      else if ('line' in place || 'column' in place) {
        position.start = place;
      }
    }

    // Fields from `Error`
    this.name = stringifyPosition(place) || '1:1';
    this.message = typeof reason === 'object' ? reason.message : reason;
    this.stack = typeof reason === 'object' ? reason.stack : '';

    /**
     * Reason for message.
     * @type {string}
     */
    this.reason = this.message;
    /**
     * If true, marks associated file as no longer processable.
     * @type {boolean?}
     */
    // eslint-disable-next-line no-unused-expressions
    this.fatal;
    /**
     * Starting line of error.
     * @type {number?}
     */
    this.line = position.start.line;
    /**
     * Starting column of error.
     * @type {number?}
     */
    this.column = position.start.column;
    /**
     * Namespace of warning.
     * @type {string?}
     */
    this.source = parts[0];
    /**
     * Category of message.
     * @type {string?}
     */
    this.ruleId = parts[1];
    /**
     * Full range information, when available.
     * Has start and end properties, both set to an object with line and column, set to number?.
     * @type {Position?}
     */
    this.position = position;

    // The following fields are “well known”.
    // Not standard.
    // Feel free to add other non-standard fields to your messages.

    /* eslint-disable no-unused-expressions */
    /**
     * You can use this to specify the source value that’s being reported, which
     * is deemed incorrect.
     * @type {string?}
     */
    this.actual;
    /**
     * You can use this to suggest values that should be used instead of
     * `actual`, one or more values that are deemed as acceptable.
     * @type {Array<string>?}
     */
    this.expected;
    /**
     * You may add a file property with a path of a file (used throughout the VFile ecosystem).
     * @type {string?}
     */
    this.file;
    /**
     * You may add a url property with a link to documentation for the message.
     * @type {string?}
     */
    this.url;
    /**
     * You may add a note property with a long form description of the message (supported by vfile-reporter).
     * @type {string?}
     */
    this.note;
    /* eslint-enable no-unused-expressions */
  }
}

VFileMessage.prototype.file = '';
VFileMessage.prototype.name = '';
VFileMessage.prototype.reason = '';
VFileMessage.prototype.message = '';
VFileMessage.prototype.stack = '';
VFileMessage.prototype.fatal = null;
VFileMessage.prototype.column = null;
VFileMessage.prototype.line = null;
VFileMessage.prototype.source = null;
VFileMessage.prototype.ruleId = null;
VFileMessage.prototype.position = null;

/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */

/**
 * @param {unknown} fileURLOrPath
 * @returns {fileURLOrPath is URL}
 */
// From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function isUrl(fileURLOrPath) {
  return (
    fileURLOrPath !== null &&
    typeof fileURLOrPath === 'object' &&
    // @ts-expect-error: indexable.
    fileURLOrPath.href &&
    // @ts-expect-error: indexable.
    fileURLOrPath.origin
  )
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {Record<string, unknown> & {type: string, position?: Position|undefined}} NodeLike
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('..').VFileData} VFileData
 * @typedef {import('..').VFileValue} VFileValue
 *
 * @typedef {'ascii'|'utf8'|'utf-8'|'utf16le'|'ucs2'|'ucs-2'|'base64'|'base64url'|'latin1'|'binary'|'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *   This is a copy of the typing from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {VFileValue|VFileOptions|VFile|URL} VFileCompatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 * @property {VFileValue} [value]
 * @property {string} [cwd]
 * @property {Array<string>} [history]
 * @property {string|URL} [path]
 * @property {string} [basename]
 * @property {string} [stem]
 * @property {string} [extname]
 * @property {string} [dirname]
 * @property {VFileData} [data]
 *
 * @typedef Map
 *   Raw source map, see:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 * @property {Array<string>} sources
 * @property {Array<string>} names
 * @property {string|undefined} [sourceRoot]
 * @property {Array<string>|undefined} [sourcesContent]
 * @property {string} mappings
 * @property {string} file
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} VFileOptions
 *   Configuration: a bunch of keys that will be shallow copied over to the new
 *   file.
 *
 * @typedef {Record<string, unknown>} VFileReporterSettings
 * @typedef {<T = VFileReporterSettings>(files: Array<VFile>, options: T) => string} VFileReporter
 */

// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
const order = ['history', 'path', 'basename', 'stem', 'extname', 'dirname'];

class VFile {
  /**
   * Create a new virtual file.
   *
   * If `options` is `string` or `Buffer`, treats it as `{value: options}`.
   * If `options` is a `VFile`, shallow copies its data over to the new file.
   * All other given fields are set on the newly created `VFile`.
   *
   * Path related properties are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * It’s not possible to set either `dirname` or `extname` without setting
   * either `history`, `path`, `basename`, or `stem` as well.
   *
   * @param {VFileCompatible} [value]
   */
  constructor(value) {
    /** @type {VFileOptions} */
    let options;

    if (!value) {
      options = {};
    } else if (typeof value === 'string' || isBuffer$1(value)) {
      // @ts-expect-error Looks like a buffer.
      options = {value};
    } else if (isUrl(value)) {
      options = {path: value};
    } else {
      // @ts-expect-error Looks like file or options.
      options = value;
    }

    /**
     * Place to store custom information.
     * It’s OK to store custom data directly on the file, moving it to `data`
     * gives a little more privacy.
     * @type {VFileData}
     */
    this.data = {};

    /**
     * List of messages associated with the file.
     * @type {Array<VFileMessage>}
     */
    this.messages = [];

    /**
     * List of file paths the file moved between.
     * @type {Array<string>}
     */
    this.history = [];

    /**
     * Base of `path`.
     * Defaults to `process.cwd()` (`/` in browsers).
     * @type {string}
     */
    this.cwd = proc.cwd();

    /* eslint-disable no-unused-expressions */
    /**
     * Raw value.
     * @type {VFileValue}
     */
    this.value;

    // The below are non-standard, they are “well-known”.
    // As in, used in several tools.

    /**
     * Whether a file was saved to disk.
     * This is used by vfile reporters.
     * @type {boolean}
     */
    this.stored;

    /**
     * Sometimes files have a non-string representation.
     * This can be stored in the `result` field.
     * One example is when turning markdown into React nodes.
     * This is used by unified to store non-string results.
     * @type {unknown}
     */
    this.result;

    /**
     * Sometimes files have a source map associated with them.
     * This can be stored in the `map` field.
     * This should be a `RawSourceMap` type from the `source-map` module.
     * @type {Map|undefined}
     */
    this.map;
    /* eslint-enable no-unused-expressions */

    // Set path related properties in the correct order.
    let index = -1;

    while (++index < order.length) {
      const prop = order[index];

      // Note: we specifically use `in` instead of `hasOwnProperty` to accept
      // `vfile`s too.
      if (prop in options && options[prop] !== undefined) {
        // @ts-expect-error: TS is confused by the different types for `history`.
        this[prop] = prop === 'history' ? [...options[prop]] : options[prop];
      }
    }

    /** @type {string} */
    let prop;

    // Set non-path related properties.
    for (prop in options) {
      // @ts-expect-error: fine to set other things.
      if (!order.includes(prop)) this[prop] = options[prop];
    }
  }

  /**
   * Access full path (`~/index.min.js`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1]
  }

  /**
   * Set full path (`~/index.min.js`).
   * Cannot be nullified.
   *
   * @param {string|URL} path
   */
  set path(path) {
    if (isUrl(path)) {
      path = fileURLToPath(path);
    }

    assertNonEmpty(path, 'path');

    if (this.path !== path) {
      this.history.push(path);
    }
  }

  /**
   * Access parent path (`~`).
   */
  get dirname() {
    return typeof this.path === 'string' ? path$2.dirname(this.path) : undefined
  }

  /**
   * Set parent path (`~`).
   * Cannot be set if there's no `path` yet.
   */
  set dirname(dirname) {
    assertPath(this.basename, 'dirname');
    this.path = path$2.join(dirname || '', this.basename);
  }

  /**
   * Access basename (including extname) (`index.min.js`).
   */
  get basename() {
    return typeof this.path === 'string' ? path$2.basename(this.path) : undefined
  }

  /**
   * Set basename (`index.min.js`).
   * Cannot contain path separators.
   * Cannot be nullified either (use `file.path = file.dirname` instead).
   */
  set basename(basename) {
    assertNonEmpty(basename, 'basename');
    assertPart(basename, 'basename');
    this.path = path$2.join(this.dirname || '', basename);
  }

  /**
   * Access extname (including dot) (`.js`).
   */
  get extname() {
    return typeof this.path === 'string' ? path$2.extname(this.path) : undefined
  }

  /**
   * Set extname (including dot) (`.js`).
   * Cannot be set if there's no `path` yet and cannot contain path separators.
   */
  set extname(extname) {
    assertPart(extname, 'extname');
    assertPath(this.dirname, 'extname');

    if (extname) {
      if (extname.charCodeAt(0) !== 46 /* `.` */) {
        throw new Error('`extname` must start with `.`')
      }

      if (extname.includes('.', 1)) {
        throw new Error('`extname` cannot contain multiple dots')
      }
    }

    this.path = path$2.join(this.dirname, this.stem + (extname || ''));
  }

  /**
   * Access stem (w/o extname) (`index.min`).
   */
  get stem() {
    return typeof this.path === 'string'
      ? path$2.basename(this.path, this.extname)
      : undefined
  }

  /**
   * Set stem (w/o extname) (`index.min`).
   * Cannot be nullified, and cannot contain path separators.
   */
  set stem(stem) {
    assertNonEmpty(stem, 'stem');
    assertPart(stem, 'stem');
    this.path = path$2.join(this.dirname || '', stem + (this.extname || ''));
  }

  /**
   * Serialize the file.
   *
   * @param {BufferEncoding} [encoding='utf8'] If `file.value` is a buffer, `encoding` is used to serialize buffers.
   * @returns {string}
   */
  toString(encoding) {
    return (this.value || '').toString(encoding)
  }

  /**
   * Create a message and associates it w/ the file.
   *
   * @param {string|Error} reason Reason for message (`string` or `Error`). Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place] Place at which the message occurred in a file (`Node`, `Position`, or `Point`, optional).
   * @param {string} [origin] Place in code the message originates from (`string`, optional).
   * @returns {VFileMessage}
   */
  message(reason, place, origin) {
    const message = new VFileMessage(reason, place, origin);

    if (this.path) {
      message.name = this.path + ':' + message.name;
      message.file = this.path;
    }

    message.fatal = false;

    this.messages.push(message);

    return message
  }

  /**
   * Info: create a message, associate it with the file, and mark the fatality
   * as `null`.
   * Calls `message()` internally.
   *
   * @param {string|Error} reason Reason for message (`string` or `Error`). Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place] Place at which the message occurred in a file (`Node`, `Position`, or `Point`, optional).
   * @param {string} [origin] Place in code the message originates from (`string`, optional).
   * @returns {VFileMessage}
   */
  info(reason, place, origin) {
    const message = this.message(reason, place, origin);

    message.fatal = null;

    return message
  }

  /**
   * Fail: create a message, associate it with the file, mark the fatality as
   * `true`.
   * Note: fatal errors mean a file is no longer processable.
   * Calls `message()` internally.
   *
   * @param {string|Error} reason Reason for message (`string` or `Error`). Uses the stack and message of the error if given.
   * @param {Node|NodeLike|Position|Point} [place] Place at which the message occurred in a file (`Node`, `Position`, or `Point`, optional).
   * @param {string} [origin] Place in code the message originates from (`string`, optional).
   * @returns {never}
   */
  fail(reason, place, origin) {
    const message = this.message(reason, place, origin);

    message.fatal = true;

    throw message
  }
}

/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string|undefined} part
 * @param {string} name
 * @returns {void}
 */
function assertPart(part, name) {
  if (part && part.includes(path$2.sep)) {
    throw new Error(
      '`' + name + '` cannot be a path: did not expect `' + path$2.sep + '`'
    )
  }
}

/**
 * Assert that `part` is not empty.
 *
 * @param {string|undefined} part
 * @param {string} name
 * @returns {asserts part is string}
 */
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty')
  }
}

/**
 * Assert `path` exists.
 *
 * @param {string|undefined} path
 * @param {string} name
 * @returns {asserts path is string}
 */
function assertPath(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too')
  }
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */

// Expose a frozen processor.
const unified = base$d().freeze();

const own$9 = {}.hasOwnProperty;

// Function to create the first processor.
/**
 * @returns {Processor}
 */
function base$d() {
  const transformers = trough();
  /** @type {Processor['attachers']} */
  const attachers = [];
  /** @type {Record<string, unknown>} */
  let namespace = {};
  /** @type {boolean|undefined} */
  let frozen;
  let freezeIndex = -1;

  // Data management.
  // @ts-expect-error: overloads are handled.
  processor.data = data;
  processor.Parser = undefined;
  processor.Compiler = undefined;

  // Lock.
  processor.freeze = freeze;

  // Plugins.
  processor.attachers = attachers;
  // @ts-expect-error: overloads are handled.
  processor.use = use;

  // API.
  processor.parse = parse;
  processor.stringify = stringify;
  // @ts-expect-error: overloads are handled.
  processor.run = run;
  processor.runSync = runSync;
  // @ts-expect-error: overloads are handled.
  processor.process = process;
  processor.processSync = processSync;

  // Expose.
  return processor

  // Create a new processor based on the processor in the current scope.
  /** @type {Processor} */
  function processor() {
    const destination = base$d();
    let index = -1;

    while (++index < attachers.length) {
      destination.use(...attachers[index]);
    }

    destination.data(extend$1(true, {}, namespace));

    return destination
  }

  /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */
  function data(key, value) {
    if (typeof key === 'string') {
      // Set `key`.
      if (arguments.length === 2) {
        assertUnfrozen('data', frozen);
        namespace[key] = value;
        return processor
      }

      // Get `key`.
      return (own$9.call(namespace, key) && namespace[key]) || null
    }

    // Set space.
    if (key) {
      assertUnfrozen('data', frozen);
      namespace = key;
      return processor
    }

    // Get space.
    return namespace
  }

  /** @type {Processor['freeze']} */
  function freeze() {
    if (frozen) {
      return processor
    }

    while (++freezeIndex < attachers.length) {
      const [attacher, ...options] = attachers[freezeIndex];

      if (options[0] === false) {
        continue
      }

      if (options[0] === true) {
        options[0] = undefined;
      }

      /** @type {Transformer|void} */
      const transformer = attacher.call(processor, ...options);

      if (typeof transformer === 'function') {
        transformers.use(transformer);
      }
    }

    frozen = true;
    freezeIndex = Number.POSITIVE_INFINITY;

    return processor
  }

  /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */
  function use(value, ...options) {
    /** @type {Record<string, unknown>|undefined} */
    let settings;

    assertUnfrozen('use', frozen);

    if (value === null || value === undefined) ; else if (typeof value === 'function') {
      addPlugin(value, ...options);
    } else if (typeof value === 'object') {
      if (Array.isArray(value)) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new TypeError('Expected usable value, not `' + value + '`')
    }

    if (settings) {
      namespace.settings = Object.assign(namespace.settings || {}, settings);
    }

    return processor

    /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */
    function add(value) {
      if (typeof value === 'function') {
        addPlugin(value);
      } else if (typeof value === 'object') {
        if (Array.isArray(value)) {
          const [plugin, ...options] = value;
          addPlugin(plugin, ...options);
        } else {
          addPreset(value);
        }
      } else {
        throw new TypeError('Expected usable value, not `' + value + '`')
      }
    }

    /**
     * @param {Preset} result
     * @returns {void}
     */
    function addPreset(result) {
      addList(result.plugins);

      if (result.settings) {
        settings = Object.assign(settings || {}, result.settings);
      }
    }

    /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */
    function addList(plugins) {
      let index = -1;

      if (plugins === null || plugins === undefined) ; else if (Array.isArray(plugins)) {
        while (++index < plugins.length) {
          const thing = plugins[index];
          add(thing);
        }
      } else {
        throw new TypeError('Expected a list of plugins, not `' + plugins + '`')
      }
    }

    /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */
    function addPlugin(plugin, value) {
      let index = -1;
      /** @type {Processor['attachers'][number]|undefined} */
      let entry;

      while (++index < attachers.length) {
        if (attachers[index][0] === plugin) {
          entry = attachers[index];
          break
        }
      }

      if (entry) {
        if (isPlainObject$1(entry[1]) && isPlainObject$1(value)) {
          value = extend$1(true, entry[1], value);
        }

        entry[1] = value;
      } else {
        // @ts-expect-error: fine.
        attachers.push([...arguments]);
      }
    }
  }

  /** @type {Processor['parse']} */
  function parse(doc) {
    processor.freeze();
    const file = vfile(doc);
    const Parser = processor.Parser;
    assertParser('parse', Parser);

    if (newable(Parser, 'parse')) {
      // @ts-expect-error: `newable` checks this.
      return new Parser(String(file), file).parse()
    }

    // @ts-expect-error: `newable` checks this.
    return Parser(String(file), file) // eslint-disable-line new-cap
  }

  /** @type {Processor['stringify']} */
  function stringify(node, doc) {
    processor.freeze();
    const file = vfile(doc);
    const Compiler = processor.Compiler;
    assertCompiler('stringify', Compiler);
    assertNode(node);

    if (newable(Compiler, 'compile')) {
      // @ts-expect-error: `newable` checks this.
      return new Compiler(node, file).compile()
    }

    // @ts-expect-error: `newable` checks this.
    return Compiler(node, file) // eslint-disable-line new-cap
  }

  /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */
  function run(node, doc, callback) {
    assertNode(node);
    processor.freeze();

    if (!callback && typeof doc === 'function') {
      callback = doc;
      doc = undefined;
    }

    if (!callback) {
      return new Promise(executor)
    }

    executor(null, callback);

    /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */
    function executor(resolve, reject) {
      // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
      transformers.run(node, vfile(doc), done);

      /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */
      function done(error, tree, file) {
        tree = tree || node;
        if (error) {
          reject(error);
        } else if (resolve) {
          resolve(tree);
        } else {
          // @ts-expect-error: `callback` is defined if `resolve` is not.
          callback(null, tree, file);
        }
      }
    }
  }

  /** @type {Processor['runSync']} */
  function runSync(node, file) {
    /** @type {Node|undefined} */
    let result;
    /** @type {boolean|undefined} */
    let complete;

    processor.run(node, file, done);

    assertDone('runSync', 'run', complete);

    // @ts-expect-error: we either bailed on an error or have a tree.
    return result

    /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */
    function done(error, tree) {
      bail(error);
      result = tree;
      complete = true;
    }
  }

  /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */
  function process(doc, callback) {
    processor.freeze();
    assertParser('process', processor.Parser);
    assertCompiler('process', processor.Compiler);

    if (!callback) {
      return new Promise(executor)
    }

    executor(null, callback);

    /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */
    function executor(resolve, reject) {
      const file = vfile(doc);

      processor.run(processor.parse(file), file, (error, tree, file) => {
        if (error || !tree || !file) {
          done(error);
        } else {
          /** @type {unknown} */
          const result = processor.stringify(tree, file);

          if (result === undefined || result === null) ; else if (looksLikeAVFileValue(result)) {
            file.value = result;
          } else {
            file.result = result;
          }

          done(error, file);
        }
      });

      /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */
      function done(error, file) {
        if (error || !file) {
          reject(error);
        } else if (resolve) {
          resolve(file);
        } else {
          // @ts-expect-error: `callback` is defined if `resolve` is not.
          callback(null, file);
        }
      }
    }
  }

  /** @type {Processor['processSync']} */
  function processSync(doc) {
    /** @type {boolean|undefined} */
    let complete;

    processor.freeze();
    assertParser('processSync', processor.Parser);
    assertCompiler('processSync', processor.Compiler);

    const file = vfile(doc);

    processor.process(file, done);

    assertDone('processSync', 'process', complete);

    return file

    /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */
    function done(error) {
      complete = true;
      bail(error);
    }
  }
}

/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */
function newable(value, name) {
  return (
    typeof value === 'function' &&
    // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype &&
    // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    (keys(value.prototype) || name in value.prototype)
  )
}

/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */
function keys(value) {
  /** @type {string} */
  let key;

  for (key in value) {
    if (own$9.call(value, key)) {
      return true
    }
  }

  return false
}

/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */
function assertParser(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `Parser`')
  }
}

/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */
function assertCompiler(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `Compiler`')
  }
}

/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(
      'Cannot call `' +
        name +
        '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.'
    )
  }
}

/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */
function assertNode(node) {
  // `isPlainObj` unfortunately uses `any` instead of `unknown`.
  // type-coverage:ignore-next-line
  if (!isPlainObject$1(node) || typeof node.type !== 'string') {
    throw new TypeError('Expected node, got `' + node + '`')
    // Fine.
  }
}

/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error(
      '`' + name + '` finished async. Use `' + asyncName + '` instead'
    )
  }
}

/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */
function vfile(value) {
  return looksLikeAVFile(value) ? value : new VFile(value)
}

/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */
function looksLikeAVFile(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'message' in value &&
      'messages' in value
  )
}

/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */
function looksLikeAVFileValue(value) {
  return typeof value === 'string' || isBuffer$1(value)
}

/**
 * @typedef Options
 * @property {boolean} [includeImageAlt=true]
 */

/**
 * Get the text content of a node.
 * Prefer the node’s plain-text fields, otherwise serialize its children,
 * and if the given value is an array, serialize the nodes in it.
 *
 * @param {unknown} node
 * @param {Options} [options]
 * @returns {string}
 */
function toString$4(node, options) {
  var {includeImageAlt = true} = options || {};
  return one$1(node, includeImageAlt)
}

/**
 * @param {unknown} node
 * @param {boolean} includeImageAlt
 * @returns {string}
 */
function one$1(node, includeImageAlt) {
  return (
    (node &&
      typeof node === 'object' &&
      // @ts-ignore looks like a literal.
      (node.value ||
        // @ts-ignore looks like an image.
        (includeImageAlt ? node.alt : '') ||
        // @ts-ignore looks like a parent.
        ('children' in node && all$1(node.children, includeImageAlt)) ||
        (Array.isArray(node) && all$1(node, includeImageAlt)))) ||
    ''
  )
}

/**
 * @param {Array.<unknown>} values
 * @param {boolean} includeImageAlt
 * @returns {string}
 */
function all$1(values, includeImageAlt) {
  /** @type {Array.<string>} */
  var result = [];
  var index = -1;

  while (++index < values.length) {
    result[index] = one$1(values[index], includeImageAlt);
  }

  return result.join('')
}

/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 * @param {T[]} list
 * @param {number} start
 * @param {number} remove
 * @param {T[]} items
 * @returns {void}
 */
function splice(list, start, remove, items) {
  const end = list.length;
  let chunkStart = 0;
  /** @type {unknown[]} */

  let parameters; // Make start between zero and `end` (included).

  if (start < 0) {
    start = -start > end ? 0 : end + start;
  } else {
    start = start > end ? end : start;
  }

  remove = remove > 0 ? remove : 0; // No need to chunk the items if there’s only a couple (10k) items.

  if (items.length < 10000) {
    parameters = Array.from(items);
    parameters.unshift(start, remove) // @ts-expect-error Hush, it’s fine.
    ;[].splice.apply(list, parameters);
  } else {
    // Delete `remove` items starting from `start`
    if (remove) [].splice.apply(list, [start, remove]); // Insert the items in chunks to not cause stack overflows.

    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 10000);
      parameters.unshift(start, 0) // @ts-expect-error Hush, it’s fine.
      ;[].splice.apply(list, parameters);
      chunkStart += 10000;
      start += 10000;
    }
  }
}
/**
 * Append `items` (an array) at the end of `list` (another array).
 * When `list` was empty, returns `items` instead.
 *
 * This prevents a potentially expensive operation when `list` is empty,
 * and adds items in batches to prevent V8 from hanging.
 *
 * @template {unknown} T
 * @param {T[]} list
 * @param {T[]} items
 * @returns {T[]}
 */

function push(list, items) {
  if (list.length > 0) {
    splice(list, list.length, 0, items);
    return list
  }

  return items
}

/**
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */

const hasOwnProperty = {}.hasOwnProperty;

/**
 * Combine several syntax extensions into one.
 *
 * @param {Extension[]} extensions List of syntax extensions.
 * @returns {NormalizedExtension} A single combined extension.
 */
function combineExtensions(extensions) {
  /** @type {NormalizedExtension} */
  const all = {};
  let index = -1;

  while (++index < extensions.length) {
    syntaxExtension(all, extensions[index]);
  }

  return all
}

/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all Extension to merge into.
 * @param {Extension} extension Extension to merge.
 * @returns {void}
 */
function syntaxExtension(all, extension) {
  /** @type {string} */
  let hook;

  for (hook in extension) {
    const maybe = hasOwnProperty.call(all, hook) ? all[hook] : undefined;
    const left = maybe || (all[hook] = {});
    const right = extension[hook];
    /** @type {string} */
    let code;

    for (code in right) {
      if (!hasOwnProperty.call(left, code)) left[code] = [];
      const value = right[code];
      constructs(
        // @ts-expect-error Looks like a list.
        left[code],
        Array.isArray(value) ? value : value ? [value] : []
      );
    }
  }
}

/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {unknown[]} existing
 * @param {unknown[]} list
 * @returns {void}
 */
function constructs(existing, list) {
  let index = -1;
  /** @type {unknown[]} */
  const before = [];

  while (++index < list.length) {
(list[index].add === 'after' ? existing : before).push(list[index]);
  }

  splice(existing, 0, 0, before);
}

// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
const unicodePunctuationRegex =
  /[!-/:-@[-`{-~\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;

/**
 * @typedef {import('micromark-util-types').Code} Code
 */
/**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 */

const asciiAlpha = regexCheck(/[A-Za-z]/);
/**
 * Check whether the character code represents an ASCII digit (`0` through `9`).
 *
 * An **ASCII digit** is a character in the inclusive range U+0030 (`0`) to
 * U+0039 (`9`).
 */

const asciiDigit = regexCheck(/\d/);
/**
 * Check whether the character code represents an ASCII hex digit (`a` through
 * `f`, case insensitive, or `0` through `9`).
 *
 * An **ASCII hex digit** is an ASCII digit (see `asciiDigit`), ASCII upper hex
 * digit, or an ASCII lower hex digit.
 *
 * An **ASCII upper hex digit** is a character in the inclusive range U+0041
 * (`A`) to U+0046 (`F`).
 *
 * An **ASCII lower hex digit** is a character in the inclusive range U+0061
 * (`a`) to U+0066 (`f`).
 */

const asciiHexDigit = regexCheck(/[\dA-Fa-f]/);
/**
 * Check whether the character code represents an ASCII alphanumeric (`a`
 * through `z`, case insensitive, or `0` through `9`).
 *
 * An **ASCII alphanumeric** is an ASCII digit (see `asciiDigit`) or ASCII alpha
 * (see `asciiAlpha`).
 */

const asciiAlphanumeric = regexCheck(/[\dA-Za-z]/);
/**
 * Check whether the character code represents ASCII punctuation.
 *
 * An **ASCII punctuation** is a character in the inclusive ranges U+0021
 * EXCLAMATION MARK (`!`) to U+002F SLASH (`/`), U+003A COLON (`:`) to U+0040 AT
 * SIGN (`@`), U+005B LEFT SQUARE BRACKET (`[`) to U+0060 GRAVE ACCENT
 * (`` ` ``), or U+007B LEFT CURLY BRACE (`{`) to U+007E TILDE (`~`).
 */

const asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
/**
 * Check whether the character code represents an ASCII atext.
 *
 * atext is an ASCII alphanumeric (see `asciiAlphanumeric`), or a character in
 * the inclusive ranges U+0023 NUMBER SIGN (`#`) to U+0027 APOSTROPHE (`'`),
 * U+002A ASTERISK (`*`), U+002B PLUS SIGN (`+`), U+002D DASH (`-`), U+002F
 * SLASH (`/`), U+003D EQUALS TO (`=`), U+003F QUESTION MARK (`?`), U+005E
 * CARET (`^`) to U+0060 GRAVE ACCENT (`` ` ``), or U+007B LEFT CURLY BRACE
 * (`{`) to U+007E TILDE (`~`).
 *
 * See:
 * **\[RFC5322]**:
 * [Internet Message Format](https://tools.ietf.org/html/rfc5322).
 * P. Resnick.
 * IETF.
 */

const asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);
/**
 * Check whether a character code is an ASCII control character.
 *
 * An **ASCII control** is a character in the inclusive range U+0000 NULL (NUL)
 * to U+001F (US), or U+007F (DEL).
 *
 * @param {Code} code
 * @returns {code is number}
 */

function asciiControl(code) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127)
  )
}
/**
 * Check whether a character code is a markdown line ending (see
 * `markdownLineEnding`) or markdown space (see `markdownSpace`).
 *
 * @param {Code} code
 * @returns {code is number}
 */

function markdownLineEndingOrSpace(code) {
  return code !== null && (code < 0 || code === 32)
}
/**
 * Check whether a character code is a markdown line ending.
 *
 * A **markdown line ending** is the virtual characters M-0003 CARRIAGE RETURN
 * LINE FEED (CRLF), M-0004 LINE FEED (LF) and M-0005 CARRIAGE RETURN (CR).
 *
 * In micromark, the actual character U+000A LINE FEED (LF) and U+000D CARRIAGE
 * RETURN (CR) are replaced by these virtual characters depending on whether
 * they occurred together.
 *
 * @param {Code} code
 * @returns {code is number}
 */

function markdownLineEnding(code) {
  return code !== null && code < -2
}
/**
 * Check whether a character code is a markdown space.
 *
 * A **markdown space** is the concrete character U+0020 SPACE (SP) and the
 * virtual characters M-0001 VIRTUAL SPACE (VS) and M-0002 HORIZONTAL TAB (HT).
 *
 * In micromark, the actual character U+0009 CHARACTER TABULATION (HT) is
 * replaced by one M-0002 HORIZONTAL TAB (HT) and between 0 and 3 M-0001 VIRTUAL
 * SPACE (VS) characters, depending on the column at which the tab occurred.
 *
 * @param {Code} code
 * @returns {code is number}
 */

function markdownSpace(code) {
  return code === -2 || code === -1 || code === 32
}
/**
 * Check whether the character code represents Unicode whitespace.
 *
 * Note that this does handle micromark specific markdown whitespace characters.
 * See `markdownLineEndingOrSpace` to check that.
 *
 * A **Unicode whitespace** is a character in the Unicode `Zs` (Separator,
 * Space) category, or U+0009 CHARACTER TABULATION (HT), U+000A LINE FEED (LF),
 * U+000C (FF), or U+000D CARRIAGE RETURN (CR) (**\[UNICODE]**).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 */

const unicodeWhitespace = regexCheck(/\s/);
/**
 * Check whether the character code represents Unicode punctuation.
 *
 * A **Unicode punctuation** is a character in the Unicode `Pc` (Punctuation,
 * Connector), `Pd` (Punctuation, Dash), `Pe` (Punctuation, Close), `Pf`
 * (Punctuation, Final quote), `Pi` (Punctuation, Initial quote), `Po`
 * (Punctuation, Other), or `Ps` (Punctuation, Open) categories, or an ASCII
 * punctuation (see `asciiPunctuation`).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 */
// Size note: removing ASCII from the regex and using `asciiPunctuation` here
// In fact adds to the bundle size.

const unicodePunctuation = regexCheck(unicodePunctuationRegex);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => code is number}
 */

function regexCheck(regex) {
  return check
  /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code Character code
   * @returns {code is number} Whether the character code matches the bound regex
   */

  function check(code) {
    return code !== null && regex.test(String.fromCharCode(code))
  }
}

/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */
/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {string} type
 * @param {number} [max=Infinity]
 * @returns {State}
 */

function factorySpace(effects, ok, type, max) {
  const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
  let size = 0;
  return start
  /** @type {State} */

  function start(code) {
    if (markdownSpace(code)) {
      effects.enter(type);
      return prefix(code)
    }

    return ok(code)
  }
  /** @type {State} */

  function prefix(code) {
    if (markdownSpace(code) && size++ < limit) {
      effects.consume(code);
      return prefix
    }

    effects.exit(type);
    return ok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {InitialConstruct} */
const content$1 = {
  tokenize: initializeContent
};
/** @type {Initializer} */

function initializeContent(effects) {
  const contentStart = effects.attempt(
    this.parser.constructs.contentInitial,
    afterContentStartConstruct,
    paragraphInitial
  );
  /** @type {Token} */

  let previous;
  return contentStart
  /** @type {State} */

  function afterContentStartConstruct(code) {
    if (code === null) {
      effects.consume(code);
      return
    }

    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    return factorySpace(effects, contentStart, 'linePrefix')
  }
  /** @type {State} */

  function paragraphInitial(code) {
    effects.enter('paragraph');
    return lineStart(code)
  }
  /** @type {State} */

  function lineStart(code) {
    const token = effects.enter('chunkText', {
      contentType: 'text',
      previous
    });

    if (previous) {
      previous.next = token;
    }

    previous = token;
    return data(code)
  }
  /** @type {State} */

  function data(code) {
    if (code === null) {
      effects.exit('chunkText');
      effects.exit('paragraph');
      effects.consume(code);
      return
    }

    if (markdownLineEnding(code)) {
      effects.consume(code);
      effects.exit('chunkText');
      return lineStart
    } // Data.

    effects.consume(code);
    return data
  }
}

/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Point} Point
 */
/** @type {InitialConstruct} */

const document$2 = {
  tokenize: initializeDocument
};
/** @type {Construct} */

const containerConstruct = {
  tokenize: tokenizeContainer
};
/** @type {Initializer} */

function initializeDocument(effects) {
  const self = this;
  /** @type {StackItem[]} */

  const stack = [];
  let continued = 0;
  /** @type {TokenizeContext|undefined} */

  let childFlow;
  /** @type {Token|undefined} */

  let childToken;
  /** @type {number} */

  let lineStartOffset;
  return start
  /** @type {State} */

  function start(code) {
    // First we iterate through the open blocks, starting with the root
    // document, and descending through last children down to the last open
    // block.
    // Each block imposes a condition that the line must satisfy if the block is
    // to remain open.
    // For example, a block quote requires a `>` character.
    // A paragraph requires a non-blank line.
    // In this phase we may match all or just some of the open blocks.
    // But we cannot close unmatched blocks yet, because we may have a lazy
    // continuation line.
    if (continued < stack.length) {
      const item = stack[continued];
      self.containerState = item[1];
      return effects.attempt(
        item[0].continuation,
        documentContinue,
        checkNewContainers
      )(code)
    } // Done.

    return checkNewContainers(code)
  }
  /** @type {State} */

  function documentContinue(code) {
    continued++; // Note: this field is called `_closeFlow` but it also closes containers.
    // Perhaps a good idea to rename it but it’s already used in the wild by
    // extensions.

    if (self.containerState._closeFlow) {
      self.containerState._closeFlow = undefined;

      if (childFlow) {
        closeFlow();
      } // Note: this algorithm for moving events around is similar to the
      // algorithm when dealing with lazy lines in `writeToChild`.

      const indexBeforeExits = self.events.length;
      let indexBeforeFlow = indexBeforeExits;
      /** @type {Point|undefined} */

      let point; // Find the flow chunk.

      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          point = self.events[indexBeforeFlow][1].end;
          break
        }
      }

      exitContainers(continued); // Fix positions.

      let index = indexBeforeExits;

      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point);
        index++;
      } // Inject the exits earlier (they’re still also at the end).

      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      ); // Discard the duplicate exits.

      self.events.length = index;
      return checkNewContainers(code)
    }

    return start(code)
  }
  /** @type {State} */

  function checkNewContainers(code) {
    // Next, after consuming the continuation markers for existing blocks, we
    // look for new block starts (e.g. `>` for a block quote).
    // If we encounter a new block start, we close any blocks unmatched in
    // step 1 before creating the new block as a child of the last matched
    // block.
    if (continued === stack.length) {
      // No need to `check` whether there’s a container, of `exitContainers`
      // would be moot.
      // We can instead immediately `attempt` to parse one.
      if (!childFlow) {
        return documentContinued(code)
      } // If we have concrete content, such as block HTML or fenced code,
      // we can’t have containers “pierce” into them, so we can immediately
      // start.

      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code)
      } // If we do have flow, it could still be a blank line,
      // but we’d be interrupting it w/ a new container if there’s a current
      // construct.

      self.interrupt = Boolean(
        childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack
      );
    } // Check if there is a new container.

    self.containerState = {};
    return effects.check(
      containerConstruct,
      thereIsANewContainer,
      thereIsNoNewContainer
    )(code)
  }
  /** @type {State} */

  function thereIsANewContainer(code) {
    if (childFlow) closeFlow();
    exitContainers(continued);
    return documentContinued(code)
  }
  /** @type {State} */

  function thereIsNoNewContainer(code) {
    self.parser.lazy[self.now().line] = continued !== stack.length;
    lineStartOffset = self.now().offset;
    return flowStart(code)
  }
  /** @type {State} */

  function documentContinued(code) {
    // Try new containers.
    self.containerState = {};
    return effects.attempt(
      containerConstruct,
      containerContinue,
      flowStart
    )(code)
  }
  /** @type {State} */

  function containerContinue(code) {
    continued++;
    stack.push([self.currentConstruct, self.containerState]); // Try another.

    return documentContinued(code)
  }
  /** @type {State} */

  function flowStart(code) {
    if (code === null) {
      if (childFlow) closeFlow();
      exitContainers(0);
      effects.consume(code);
      return
    }

    childFlow = childFlow || self.parser.flow(self.now());
    effects.enter('chunkFlow', {
      contentType: 'flow',
      previous: childToken,
      _tokenizer: childFlow
    });
    return flowContinue(code)
  }
  /** @type {State} */

  function flowContinue(code) {
    if (code === null) {
      writeToChild(effects.exit('chunkFlow'), true);
      exitContainers(0);
      effects.consume(code);
      return
    }

    if (markdownLineEnding(code)) {
      effects.consume(code);
      writeToChild(effects.exit('chunkFlow')); // Get ready for the next line.

      continued = 0;
      self.interrupt = undefined;
      return start
    }

    effects.consume(code);
    return flowContinue
  }
  /**
   * @param {Token} token
   * @param {boolean} [eof]
   * @returns {void}
   */

  function writeToChild(token, eof) {
    const stream = self.sliceStream(token);
    if (eof) stream.push(null);
    token.previous = childToken;
    if (childToken) childToken.next = token;
    childToken = token;
    childFlow.defineSkip(token.start);
    childFlow.write(stream); // Alright, so we just added a lazy line:
    //
    // ```markdown
    // > a
    // b.
    //
    // Or:
    //
    // > ~~~c
    // d
    //
    // Or:
    //
    // > | e |
    // f
    // ```
    //
    // The construct in the second example (fenced code) does not accept lazy
    // lines, so it marked itself as done at the end of its first line, and
    // then the content construct parses `d`.
    // Most constructs in markdown match on the first line: if the first line
    // forms a construct, a non-lazy line can’t “unmake” it.
    //
    // The construct in the third example is potentially a GFM table, and
    // those are *weird*.
    // It *could* be a table, from the first line, if the following line
    // matches a condition.
    // In this case, that second line is lazy, which “unmakes” the first line
    // and turns the whole into one content block.
    //
    // We’ve now parsed the non-lazy and the lazy line, and can figure out
    // whether the lazy line started a new flow block.
    // If it did, we exit the current containers between the two flow blocks.

    if (self.parser.lazy[token.start.line]) {
      let index = childFlow.events.length;

      while (index--) {
        if (
          // The token starts before the line ending…
          childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
          (!childFlow.events[index][1].end || // …or ends after it.
            childFlow.events[index][1].end.offset > lineStartOffset)
        ) {
          // Exit: there’s still something open, which means it’s a lazy line
          // part of something.
          return
        }
      } // Note: this algorithm for moving events around is similar to the
      // algorithm when closing flow in `documentContinue`.

      const indexBeforeExits = self.events.length;
      let indexBeforeFlow = indexBeforeExits;
      /** @type {boolean|undefined} */

      let seen;
      /** @type {Point|undefined} */

      let point; // Find the previous chunk (the one before the lazy line).

      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          if (seen) {
            point = self.events[indexBeforeFlow][1].end;
            break
          }

          seen = true;
        }
      }

      exitContainers(continued); // Fix positions.

      index = indexBeforeExits;

      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point);
        index++;
      } // Inject the exits earlier (they’re still also at the end).

      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      ); // Discard the duplicate exits.

      self.events.length = index;
    }
  }
  /**
   * @param {number} size
   * @returns {void}
   */

  function exitContainers(size) {
    let index = stack.length; // Exit open containers.

    while (index-- > size) {
      const entry = stack[index];
      self.containerState = entry[1];
      entry[0].exit.call(self, effects);
    }

    stack.length = size;
  }

  function closeFlow() {
    childFlow.write([null]);
    childToken = undefined;
    childFlow = undefined;
    self.containerState._closeFlow = undefined;
  }
}
/** @type {Tokenizer} */

function tokenizeContainer(effects, ok, nok) {
  return factorySpace(
    effects,
    effects.attempt(this.parser.constructs.document, ok, nok),
    'linePrefix',
    this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4
  )
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * Classify whether a character code represents whitespace, punctuation, or
 * something else.
 *
 * Used for attention (emphasis, strong), whose sequences can open or close
 * based on the class of surrounding characters.
 *
 * Note that eof (`null`) is seen as whitespace.
 *
 * @param {Code} code
 * @returns {number|undefined}
 */
function classifyCharacter(code) {
  if (
    code === null ||
    markdownLineEndingOrSpace(code) ||
    unicodeWhitespace(code)
  ) {
    return 1
  }

  if (unicodePunctuation(code)) {
    return 2
  }
}

/**
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 */

/**
 * Call all `resolveAll`s.
 *
 * @param {{resolveAll?: Resolver}[]} constructs
 * @param {Event[]} events
 * @param {TokenizeContext} context
 * @returns {Event[]}
 */
function resolveAll(constructs, events, context) {
  /** @type {Resolver[]} */
  const called = [];
  let index = -1;

  while (++index < constructs.length) {
    const resolve = constructs[index].resolveAll;

    if (resolve && !called.includes(resolve)) {
      events = resolve(events, context);
      called.push(resolve);
    }
  }

  return events
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Point} Point
 */

/** @type {Construct} */
const attention = {
  name: 'attention',
  tokenize: tokenizeAttention,
  resolveAll: resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */

function resolveAllAttention(events, context) {
  let index = -1;
  /** @type {number} */

  let open;
  /** @type {Token} */

  let group;
  /** @type {Token} */

  let text;
  /** @type {Token} */

  let openingSequence;
  /** @type {Token} */

  let closingSequence;
  /** @type {number} */

  let use;
  /** @type {Event[]} */

  let nextEvents;
  /** @type {number} */

  let offset; // Walk through all events.
  //
  // Note: performance of this is fine on an mb of normal markdown, but it’s
  // a bottleneck for malicious stuff.

  while (++index < events.length) {
    // Find a token that can close.
    if (
      events[index][0] === 'enter' &&
      events[index][1].type === 'attentionSequence' &&
      events[index][1]._close
    ) {
      open = index; // Now walk back to find an opener.

      while (open--) {
        // Find a token that can open the closer.
        if (
          events[open][0] === 'exit' &&
          events[open][1].type === 'attentionSequence' &&
          events[open][1]._open && // If the markers are the same:
          context.sliceSerialize(events[open][1]).charCodeAt(0) ===
            context.sliceSerialize(events[index][1]).charCodeAt(0)
        ) {
          // If the opening can close or the closing can open,
          // and the close size *is not* a multiple of three,
          // but the sum of the opening and closing size *is* multiple of three,
          // then don’t match.
          if (
            (events[open][1]._close || events[index][1]._open) &&
            (events[index][1].end.offset - events[index][1].start.offset) % 3 &&
            !(
              (events[open][1].end.offset -
                events[open][1].start.offset +
                events[index][1].end.offset -
                events[index][1].start.offset) %
              3
            )
          ) {
            continue
          } // Number of markers to use from the sequence.

          use =
            events[open][1].end.offset - events[open][1].start.offset > 1 &&
            events[index][1].end.offset - events[index][1].start.offset > 1
              ? 2
              : 1;
          const start = Object.assign({}, events[open][1].end);
          const end = Object.assign({}, events[index][1].start);
          movePoint(start, -use);
          movePoint(end, use);
          openingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start,
            end: Object.assign({}, events[open][1].end)
          };
          closingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start: Object.assign({}, events[index][1].start),
            end
          };
          text = {
            type: use > 1 ? 'strongText' : 'emphasisText',
            start: Object.assign({}, events[open][1].end),
            end: Object.assign({}, events[index][1].start)
          };
          group = {
            type: use > 1 ? 'strong' : 'emphasis',
            start: Object.assign({}, openingSequence.start),
            end: Object.assign({}, closingSequence.end)
          };
          events[open][1].end = Object.assign({}, openingSequence.start);
          events[index][1].start = Object.assign({}, closingSequence.end);
          nextEvents = []; // If there are more markers in the opening, add them before.

          if (events[open][1].end.offset - events[open][1].start.offset) {
            nextEvents = push(nextEvents, [
              ['enter', events[open][1], context],
              ['exit', events[open][1], context]
            ]);
          } // Opening.

          nextEvents = push(nextEvents, [
            ['enter', group, context],
            ['enter', openingSequence, context],
            ['exit', openingSequence, context],
            ['enter', text, context]
          ]); // Between.

          nextEvents = push(
            nextEvents,
            resolveAll(
              context.parser.constructs.insideSpan.null,
              events.slice(open + 1, index),
              context
            )
          ); // Closing.

          nextEvents = push(nextEvents, [
            ['exit', text, context],
            ['enter', closingSequence, context],
            ['exit', closingSequence, context],
            ['exit', group, context]
          ]); // If there are more markers in the closing, add them after.

          if (events[index][1].end.offset - events[index][1].start.offset) {
            offset = 2;
            nextEvents = push(nextEvents, [
              ['enter', events[index][1], context],
              ['exit', events[index][1], context]
            ]);
          } else {
            offset = 0;
          }

          splice(events, open - 1, index - open + 3, nextEvents);
          index = open + nextEvents.length - offset - 2;
          break
        }
      }
    }
  } // Remove remaining sequences.

  index = -1;

  while (++index < events.length) {
    if (events[index][1].type === 'attentionSequence') {
      events[index][1].type = 'data';
    }
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeAttention(effects, ok) {
  const attentionMarkers = this.parser.constructs.attentionMarkers.null;
  const previous = this.previous;
  const before = classifyCharacter(previous);
  /** @type {NonNullable<Code>} */

  let marker;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('attentionSequence');
    marker = code;
    return sequence(code)
  }
  /** @type {State} */

  function sequence(code) {
    if (code === marker) {
      effects.consume(code);
      return sequence
    }

    const token = effects.exit('attentionSequence');
    const after = classifyCharacter(code);
    const open =
      !after || (after === 2 && before) || attentionMarkers.includes(code);
    const close =
      !before || (before === 2 && after) || attentionMarkers.includes(previous);
    token._open = Boolean(marker === 42 ? open : open && (before || !close));
    token._close = Boolean(marker === 42 ? close : close && (after || !open));
    return ok(code)
  }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */

function movePoint(point, offset) {
  point.column += offset;
  point.offset += offset;
  point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */
const autolink = {
  name: 'autolink',
  tokenize: tokenizeAutolink
};
/** @type {Tokenizer} */

function tokenizeAutolink(effects, ok, nok) {
  let size = 1;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('autolink');
    effects.enter('autolinkMarker');
    effects.consume(code);
    effects.exit('autolinkMarker');
    effects.enter('autolinkProtocol');
    return open
  }
  /** @type {State} */

  function open(code) {
    if (asciiAlpha(code)) {
      effects.consume(code);
      return schemeOrEmailAtext
    }

    return asciiAtext(code) ? emailAtext(code) : nok(code)
  }
  /** @type {State} */

  function schemeOrEmailAtext(code) {
    return code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)
      ? schemeInsideOrEmailAtext(code)
      : emailAtext(code)
  }
  /** @type {State} */

  function schemeInsideOrEmailAtext(code) {
    if (code === 58) {
      effects.consume(code);
      return urlInside
    }

    if (
      (code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) &&
      size++ < 32
    ) {
      effects.consume(code);
      return schemeInsideOrEmailAtext
    }

    return emailAtext(code)
  }
  /** @type {State} */

  function urlInside(code) {
    if (code === 62) {
      effects.exit('autolinkProtocol');
      return end(code)
    }

    if (code === null || code === 32 || code === 60 || asciiControl(code)) {
      return nok(code)
    }

    effects.consume(code);
    return urlInside
  }
  /** @type {State} */

  function emailAtext(code) {
    if (code === 64) {
      effects.consume(code);
      size = 0;
      return emailAtSignOrDot
    }

    if (asciiAtext(code)) {
      effects.consume(code);
      return emailAtext
    }

    return nok(code)
  }
  /** @type {State} */

  function emailAtSignOrDot(code) {
    return asciiAlphanumeric(code) ? emailLabel(code) : nok(code)
  }
  /** @type {State} */

  function emailLabel(code) {
    if (code === 46) {
      effects.consume(code);
      size = 0;
      return emailAtSignOrDot
    }

    if (code === 62) {
      // Exit, then change the type.
      effects.exit('autolinkProtocol').type = 'autolinkEmail';
      return end(code)
    }

    return emailValue(code)
  }
  /** @type {State} */

  function emailValue(code) {
    if ((code === 45 || asciiAlphanumeric(code)) && size++ < 63) {
      effects.consume(code);
      return code === 45 ? emailValue : emailLabel
    }

    return nok(code)
  }
  /** @type {State} */

  function end(code) {
    effects.enter('autolinkMarker');
    effects.consume(code);
    effects.exit('autolinkMarker');
    effects.exit('autolink');
    return ok
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */
const blankLine = {
  tokenize: tokenizeBlankLine,
  partial: true
};
/** @type {Tokenizer} */

function tokenizeBlankLine(effects, ok, nok) {
  return factorySpace(effects, afterWhitespace, 'linePrefix')
  /** @type {State} */

  function afterWhitespace(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */
const blockQuote = {
  name: 'blockQuote',
  tokenize: tokenizeBlockQuoteStart,
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit: exit$1
};
/** @type {Tokenizer} */

function tokenizeBlockQuoteStart(effects, ok, nok) {
  const self = this;
  return start
  /** @type {State} */

  function start(code) {
    if (code === 62) {
      const state = self.containerState;

      if (!state.open) {
        effects.enter('blockQuote', {
          _container: true
        });
        state.open = true;
      }

      effects.enter('blockQuotePrefix');
      effects.enter('blockQuoteMarker');
      effects.consume(code);
      effects.exit('blockQuoteMarker');
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    if (markdownSpace(code)) {
      effects.enter('blockQuotePrefixWhitespace');
      effects.consume(code);
      effects.exit('blockQuotePrefixWhitespace');
      effects.exit('blockQuotePrefix');
      return ok
    }

    effects.exit('blockQuotePrefix');
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeBlockQuoteContinuation(effects, ok, nok) {
  return factorySpace(
    effects,
    effects.attempt(blockQuote, ok, nok),
    'linePrefix',
    this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4
  )
}
/** @type {Exiter} */

function exit$1(effects) {
  effects.exit('blockQuote');
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */
const characterEscape = {
  name: 'characterEscape',
  tokenize: tokenizeCharacterEscape
};
/** @type {Tokenizer} */

function tokenizeCharacterEscape(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('characterEscape');
    effects.enter('escapeMarker');
    effects.consume(code);
    effects.exit('escapeMarker');
    return open
  }
  /** @type {State} */

  function open(code) {
    if (asciiPunctuation(code)) {
      effects.enter('characterEscapeValue');
      effects.consume(code);
      effects.exit('characterEscapeValue');
      effects.exit('characterEscape');
      return ok
    }

    return nok(code)
  }
}

/**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */
const characterEntities = {
  AEli: 'Æ',
  AElig: 'Æ',
  AM: '&',
  AMP: '&',
  Aacut: 'Á',
  Aacute: 'Á',
  Abreve: 'Ă',
  Acir: 'Â',
  Acirc: 'Â',
  Acy: 'А',
  Afr: '𝔄',
  Agrav: 'À',
  Agrave: 'À',
  Alpha: 'Α',
  Amacr: 'Ā',
  And: '⩓',
  Aogon: 'Ą',
  Aopf: '𝔸',
  ApplyFunction: '⁡',
  Arin: 'Å',
  Aring: 'Å',
  Ascr: '𝒜',
  Assign: '≔',
  Atild: 'Ã',
  Atilde: 'Ã',
  Aum: 'Ä',
  Auml: 'Ä',
  Backslash: '∖',
  Barv: '⫧',
  Barwed: '⌆',
  Bcy: 'Б',
  Because: '∵',
  Bernoullis: 'ℬ',
  Beta: 'Β',
  Bfr: '𝔅',
  Bopf: '𝔹',
  Breve: '˘',
  Bscr: 'ℬ',
  Bumpeq: '≎',
  CHcy: 'Ч',
  COP: '©',
  COPY: '©',
  Cacute: 'Ć',
  Cap: '⋒',
  CapitalDifferentialD: 'ⅅ',
  Cayleys: 'ℭ',
  Ccaron: 'Č',
  Ccedi: 'Ç',
  Ccedil: 'Ç',
  Ccirc: 'Ĉ',
  Cconint: '∰',
  Cdot: 'Ċ',
  Cedilla: '¸',
  CenterDot: '·',
  Cfr: 'ℭ',
  Chi: 'Χ',
  CircleDot: '⊙',
  CircleMinus: '⊖',
  CirclePlus: '⊕',
  CircleTimes: '⊗',
  ClockwiseContourIntegral: '∲',
  CloseCurlyDoubleQuote: '”',
  CloseCurlyQuote: '’',
  Colon: '∷',
  Colone: '⩴',
  Congruent: '≡',
  Conint: '∯',
  ContourIntegral: '∮',
  Copf: 'ℂ',
  Coproduct: '∐',
  CounterClockwiseContourIntegral: '∳',
  Cross: '⨯',
  Cscr: '𝒞',
  Cup: '⋓',
  CupCap: '≍',
  DD: 'ⅅ',
  DDotrahd: '⤑',
  DJcy: 'Ђ',
  DScy: 'Ѕ',
  DZcy: 'Џ',
  Dagger: '‡',
  Darr: '↡',
  Dashv: '⫤',
  Dcaron: 'Ď',
  Dcy: 'Д',
  Del: '∇',
  Delta: 'Δ',
  Dfr: '𝔇',
  DiacriticalAcute: '´',
  DiacriticalDot: '˙',
  DiacriticalDoubleAcute: '˝',
  DiacriticalGrave: '`',
  DiacriticalTilde: '˜',
  Diamond: '⋄',
  DifferentialD: 'ⅆ',
  Dopf: '𝔻',
  Dot: '¨',
  DotDot: '⃜',
  DotEqual: '≐',
  DoubleContourIntegral: '∯',
  DoubleDot: '¨',
  DoubleDownArrow: '⇓',
  DoubleLeftArrow: '⇐',
  DoubleLeftRightArrow: '⇔',
  DoubleLeftTee: '⫤',
  DoubleLongLeftArrow: '⟸',
  DoubleLongLeftRightArrow: '⟺',
  DoubleLongRightArrow: '⟹',
  DoubleRightArrow: '⇒',
  DoubleRightTee: '⊨',
  DoubleUpArrow: '⇑',
  DoubleUpDownArrow: '⇕',
  DoubleVerticalBar: '∥',
  DownArrow: '↓',
  DownArrowBar: '⤓',
  DownArrowUpArrow: '⇵',
  DownBreve: '̑',
  DownLeftRightVector: '⥐',
  DownLeftTeeVector: '⥞',
  DownLeftVector: '↽',
  DownLeftVectorBar: '⥖',
  DownRightTeeVector: '⥟',
  DownRightVector: '⇁',
  DownRightVectorBar: '⥗',
  DownTee: '⊤',
  DownTeeArrow: '↧',
  Downarrow: '⇓',
  Dscr: '𝒟',
  Dstrok: 'Đ',
  ENG: 'Ŋ',
  ET: 'Ð',
  ETH: 'Ð',
  Eacut: 'É',
  Eacute: 'É',
  Ecaron: 'Ě',
  Ecir: 'Ê',
  Ecirc: 'Ê',
  Ecy: 'Э',
  Edot: 'Ė',
  Efr: '𝔈',
  Egrav: 'È',
  Egrave: 'È',
  Element: '∈',
  Emacr: 'Ē',
  EmptySmallSquare: '◻',
  EmptyVerySmallSquare: '▫',
  Eogon: 'Ę',
  Eopf: '𝔼',
  Epsilon: 'Ε',
  Equal: '⩵',
  EqualTilde: '≂',
  Equilibrium: '⇌',
  Escr: 'ℰ',
  Esim: '⩳',
  Eta: 'Η',
  Eum: 'Ë',
  Euml: 'Ë',
  Exists: '∃',
  ExponentialE: 'ⅇ',
  Fcy: 'Ф',
  Ffr: '𝔉',
  FilledSmallSquare: '◼',
  FilledVerySmallSquare: '▪',
  Fopf: '𝔽',
  ForAll: '∀',
  Fouriertrf: 'ℱ',
  Fscr: 'ℱ',
  GJcy: 'Ѓ',
  G: '>',
  GT: '>',
  Gamma: 'Γ',
  Gammad: 'Ϝ',
  Gbreve: 'Ğ',
  Gcedil: 'Ģ',
  Gcirc: 'Ĝ',
  Gcy: 'Г',
  Gdot: 'Ġ',
  Gfr: '𝔊',
  Gg: '⋙',
  Gopf: '𝔾',
  GreaterEqual: '≥',
  GreaterEqualLess: '⋛',
  GreaterFullEqual: '≧',
  GreaterGreater: '⪢',
  GreaterLess: '≷',
  GreaterSlantEqual: '⩾',
  GreaterTilde: '≳',
  Gscr: '𝒢',
  Gt: '≫',
  HARDcy: 'Ъ',
  Hacek: 'ˇ',
  Hat: '^',
  Hcirc: 'Ĥ',
  Hfr: 'ℌ',
  HilbertSpace: 'ℋ',
  Hopf: 'ℍ',
  HorizontalLine: '─',
  Hscr: 'ℋ',
  Hstrok: 'Ħ',
  HumpDownHump: '≎',
  HumpEqual: '≏',
  IEcy: 'Е',
  IJlig: 'Ĳ',
  IOcy: 'Ё',
  Iacut: 'Í',
  Iacute: 'Í',
  Icir: 'Î',
  Icirc: 'Î',
  Icy: 'И',
  Idot: 'İ',
  Ifr: 'ℑ',
  Igrav: 'Ì',
  Igrave: 'Ì',
  Im: 'ℑ',
  Imacr: 'Ī',
  ImaginaryI: 'ⅈ',
  Implies: '⇒',
  Int: '∬',
  Integral: '∫',
  Intersection: '⋂',
  InvisibleComma: '⁣',
  InvisibleTimes: '⁢',
  Iogon: 'Į',
  Iopf: '𝕀',
  Iota: 'Ι',
  Iscr: 'ℐ',
  Itilde: 'Ĩ',
  Iukcy: 'І',
  Ium: 'Ï',
  Iuml: 'Ï',
  Jcirc: 'Ĵ',
  Jcy: 'Й',
  Jfr: '𝔍',
  Jopf: '𝕁',
  Jscr: '𝒥',
  Jsercy: 'Ј',
  Jukcy: 'Є',
  KHcy: 'Х',
  KJcy: 'Ќ',
  Kappa: 'Κ',
  Kcedil: 'Ķ',
  Kcy: 'К',
  Kfr: '𝔎',
  Kopf: '𝕂',
  Kscr: '𝒦',
  LJcy: 'Љ',
  L: '<',
  LT: '<',
  Lacute: 'Ĺ',
  Lambda: 'Λ',
  Lang: '⟪',
  Laplacetrf: 'ℒ',
  Larr: '↞',
  Lcaron: 'Ľ',
  Lcedil: 'Ļ',
  Lcy: 'Л',
  LeftAngleBracket: '⟨',
  LeftArrow: '←',
  LeftArrowBar: '⇤',
  LeftArrowRightArrow: '⇆',
  LeftCeiling: '⌈',
  LeftDoubleBracket: '⟦',
  LeftDownTeeVector: '⥡',
  LeftDownVector: '⇃',
  LeftDownVectorBar: '⥙',
  LeftFloor: '⌊',
  LeftRightArrow: '↔',
  LeftRightVector: '⥎',
  LeftTee: '⊣',
  LeftTeeArrow: '↤',
  LeftTeeVector: '⥚',
  LeftTriangle: '⊲',
  LeftTriangleBar: '⧏',
  LeftTriangleEqual: '⊴',
  LeftUpDownVector: '⥑',
  LeftUpTeeVector: '⥠',
  LeftUpVector: '↿',
  LeftUpVectorBar: '⥘',
  LeftVector: '↼',
  LeftVectorBar: '⥒',
  Leftarrow: '⇐',
  Leftrightarrow: '⇔',
  LessEqualGreater: '⋚',
  LessFullEqual: '≦',
  LessGreater: '≶',
  LessLess: '⪡',
  LessSlantEqual: '⩽',
  LessTilde: '≲',
  Lfr: '𝔏',
  Ll: '⋘',
  Lleftarrow: '⇚',
  Lmidot: 'Ŀ',
  LongLeftArrow: '⟵',
  LongLeftRightArrow: '⟷',
  LongRightArrow: '⟶',
  Longleftarrow: '⟸',
  Longleftrightarrow: '⟺',
  Longrightarrow: '⟹',
  Lopf: '𝕃',
  LowerLeftArrow: '↙',
  LowerRightArrow: '↘',
  Lscr: 'ℒ',
  Lsh: '↰',
  Lstrok: 'Ł',
  Lt: '≪',
  Map: '⤅',
  Mcy: 'М',
  MediumSpace: ' ',
  Mellintrf: 'ℳ',
  Mfr: '𝔐',
  MinusPlus: '∓',
  Mopf: '𝕄',
  Mscr: 'ℳ',
  Mu: 'Μ',
  NJcy: 'Њ',
  Nacute: 'Ń',
  Ncaron: 'Ň',
  Ncedil: 'Ņ',
  Ncy: 'Н',
  NegativeMediumSpace: '​',
  NegativeThickSpace: '​',
  NegativeThinSpace: '​',
  NegativeVeryThinSpace: '​',
  NestedGreaterGreater: '≫',
  NestedLessLess: '≪',
  NewLine: '\n',
  Nfr: '𝔑',
  NoBreak: '⁠',
  NonBreakingSpace: ' ',
  Nopf: 'ℕ',
  Not: '⫬',
  NotCongruent: '≢',
  NotCupCap: '≭',
  NotDoubleVerticalBar: '∦',
  NotElement: '∉',
  NotEqual: '≠',
  NotEqualTilde: '≂̸',
  NotExists: '∄',
  NotGreater: '≯',
  NotGreaterEqual: '≱',
  NotGreaterFullEqual: '≧̸',
  NotGreaterGreater: '≫̸',
  NotGreaterLess: '≹',
  NotGreaterSlantEqual: '⩾̸',
  NotGreaterTilde: '≵',
  NotHumpDownHump: '≎̸',
  NotHumpEqual: '≏̸',
  NotLeftTriangle: '⋪',
  NotLeftTriangleBar: '⧏̸',
  NotLeftTriangleEqual: '⋬',
  NotLess: '≮',
  NotLessEqual: '≰',
  NotLessGreater: '≸',
  NotLessLess: '≪̸',
  NotLessSlantEqual: '⩽̸',
  NotLessTilde: '≴',
  NotNestedGreaterGreater: '⪢̸',
  NotNestedLessLess: '⪡̸',
  NotPrecedes: '⊀',
  NotPrecedesEqual: '⪯̸',
  NotPrecedesSlantEqual: '⋠',
  NotReverseElement: '∌',
  NotRightTriangle: '⋫',
  NotRightTriangleBar: '⧐̸',
  NotRightTriangleEqual: '⋭',
  NotSquareSubset: '⊏̸',
  NotSquareSubsetEqual: '⋢',
  NotSquareSuperset: '⊐̸',
  NotSquareSupersetEqual: '⋣',
  NotSubset: '⊂⃒',
  NotSubsetEqual: '⊈',
  NotSucceeds: '⊁',
  NotSucceedsEqual: '⪰̸',
  NotSucceedsSlantEqual: '⋡',
  NotSucceedsTilde: '≿̸',
  NotSuperset: '⊃⃒',
  NotSupersetEqual: '⊉',
  NotTilde: '≁',
  NotTildeEqual: '≄',
  NotTildeFullEqual: '≇',
  NotTildeTilde: '≉',
  NotVerticalBar: '∤',
  Nscr: '𝒩',
  Ntild: 'Ñ',
  Ntilde: 'Ñ',
  Nu: 'Ν',
  OElig: 'Œ',
  Oacut: 'Ó',
  Oacute: 'Ó',
  Ocir: 'Ô',
  Ocirc: 'Ô',
  Ocy: 'О',
  Odblac: 'Ő',
  Ofr: '𝔒',
  Ograv: 'Ò',
  Ograve: 'Ò',
  Omacr: 'Ō',
  Omega: 'Ω',
  Omicron: 'Ο',
  Oopf: '𝕆',
  OpenCurlyDoubleQuote: '“',
  OpenCurlyQuote: '‘',
  Or: '⩔',
  Oscr: '𝒪',
  Oslas: 'Ø',
  Oslash: 'Ø',
  Otild: 'Õ',
  Otilde: 'Õ',
  Otimes: '⨷',
  Oum: 'Ö',
  Ouml: 'Ö',
  OverBar: '‾',
  OverBrace: '⏞',
  OverBracket: '⎴',
  OverParenthesis: '⏜',
  PartialD: '∂',
  Pcy: 'П',
  Pfr: '𝔓',
  Phi: 'Φ',
  Pi: 'Π',
  PlusMinus: '±',
  Poincareplane: 'ℌ',
  Popf: 'ℙ',
  Pr: '⪻',
  Precedes: '≺',
  PrecedesEqual: '⪯',
  PrecedesSlantEqual: '≼',
  PrecedesTilde: '≾',
  Prime: '″',
  Product: '∏',
  Proportion: '∷',
  Proportional: '∝',
  Pscr: '𝒫',
  Psi: 'Ψ',
  QUO: '"',
  QUOT: '"',
  Qfr: '𝔔',
  Qopf: 'ℚ',
  Qscr: '𝒬',
  RBarr: '⤐',
  RE: '®',
  REG: '®',
  Racute: 'Ŕ',
  Rang: '⟫',
  Rarr: '↠',
  Rarrtl: '⤖',
  Rcaron: 'Ř',
  Rcedil: 'Ŗ',
  Rcy: 'Р',
  Re: 'ℜ',
  ReverseElement: '∋',
  ReverseEquilibrium: '⇋',
  ReverseUpEquilibrium: '⥯',
  Rfr: 'ℜ',
  Rho: 'Ρ',
  RightAngleBracket: '⟩',
  RightArrow: '→',
  RightArrowBar: '⇥',
  RightArrowLeftArrow: '⇄',
  RightCeiling: '⌉',
  RightDoubleBracket: '⟧',
  RightDownTeeVector: '⥝',
  RightDownVector: '⇂',
  RightDownVectorBar: '⥕',
  RightFloor: '⌋',
  RightTee: '⊢',
  RightTeeArrow: '↦',
  RightTeeVector: '⥛',
  RightTriangle: '⊳',
  RightTriangleBar: '⧐',
  RightTriangleEqual: '⊵',
  RightUpDownVector: '⥏',
  RightUpTeeVector: '⥜',
  RightUpVector: '↾',
  RightUpVectorBar: '⥔',
  RightVector: '⇀',
  RightVectorBar: '⥓',
  Rightarrow: '⇒',
  Ropf: 'ℝ',
  RoundImplies: '⥰',
  Rrightarrow: '⇛',
  Rscr: 'ℛ',
  Rsh: '↱',
  RuleDelayed: '⧴',
  SHCHcy: 'Щ',
  SHcy: 'Ш',
  SOFTcy: 'Ь',
  Sacute: 'Ś',
  Sc: '⪼',
  Scaron: 'Š',
  Scedil: 'Ş',
  Scirc: 'Ŝ',
  Scy: 'С',
  Sfr: '𝔖',
  ShortDownArrow: '↓',
  ShortLeftArrow: '←',
  ShortRightArrow: '→',
  ShortUpArrow: '↑',
  Sigma: 'Σ',
  SmallCircle: '∘',
  Sopf: '𝕊',
  Sqrt: '√',
  Square: '□',
  SquareIntersection: '⊓',
  SquareSubset: '⊏',
  SquareSubsetEqual: '⊑',
  SquareSuperset: '⊐',
  SquareSupersetEqual: '⊒',
  SquareUnion: '⊔',
  Sscr: '𝒮',
  Star: '⋆',
  Sub: '⋐',
  Subset: '⋐',
  SubsetEqual: '⊆',
  Succeeds: '≻',
  SucceedsEqual: '⪰',
  SucceedsSlantEqual: '≽',
  SucceedsTilde: '≿',
  SuchThat: '∋',
  Sum: '∑',
  Sup: '⋑',
  Superset: '⊃',
  SupersetEqual: '⊇',
  Supset: '⋑',
  THOR: 'Þ',
  THORN: 'Þ',
  TRADE: '™',
  TSHcy: 'Ћ',
  TScy: 'Ц',
  Tab: '\t',
  Tau: 'Τ',
  Tcaron: 'Ť',
  Tcedil: 'Ţ',
  Tcy: 'Т',
  Tfr: '𝔗',
  Therefore: '∴',
  Theta: 'Θ',
  ThickSpace: '  ',
  ThinSpace: ' ',
  Tilde: '∼',
  TildeEqual: '≃',
  TildeFullEqual: '≅',
  TildeTilde: '≈',
  Topf: '𝕋',
  TripleDot: '⃛',
  Tscr: '𝒯',
  Tstrok: 'Ŧ',
  Uacut: 'Ú',
  Uacute: 'Ú',
  Uarr: '↟',
  Uarrocir: '⥉',
  Ubrcy: 'Ў',
  Ubreve: 'Ŭ',
  Ucir: 'Û',
  Ucirc: 'Û',
  Ucy: 'У',
  Udblac: 'Ű',
  Ufr: '𝔘',
  Ugrav: 'Ù',
  Ugrave: 'Ù',
  Umacr: 'Ū',
  UnderBar: '_',
  UnderBrace: '⏟',
  UnderBracket: '⎵',
  UnderParenthesis: '⏝',
  Union: '⋃',
  UnionPlus: '⊎',
  Uogon: 'Ų',
  Uopf: '𝕌',
  UpArrow: '↑',
  UpArrowBar: '⤒',
  UpArrowDownArrow: '⇅',
  UpDownArrow: '↕',
  UpEquilibrium: '⥮',
  UpTee: '⊥',
  UpTeeArrow: '↥',
  Uparrow: '⇑',
  Updownarrow: '⇕',
  UpperLeftArrow: '↖',
  UpperRightArrow: '↗',
  Upsi: 'ϒ',
  Upsilon: 'Υ',
  Uring: 'Ů',
  Uscr: '𝒰',
  Utilde: 'Ũ',
  Uum: 'Ü',
  Uuml: 'Ü',
  VDash: '⊫',
  Vbar: '⫫',
  Vcy: 'В',
  Vdash: '⊩',
  Vdashl: '⫦',
  Vee: '⋁',
  Verbar: '‖',
  Vert: '‖',
  VerticalBar: '∣',
  VerticalLine: '|',
  VerticalSeparator: '❘',
  VerticalTilde: '≀',
  VeryThinSpace: ' ',
  Vfr: '𝔙',
  Vopf: '𝕍',
  Vscr: '𝒱',
  Vvdash: '⊪',
  Wcirc: 'Ŵ',
  Wedge: '⋀',
  Wfr: '𝔚',
  Wopf: '𝕎',
  Wscr: '𝒲',
  Xfr: '𝔛',
  Xi: 'Ξ',
  Xopf: '𝕏',
  Xscr: '𝒳',
  YAcy: 'Я',
  YIcy: 'Ї',
  YUcy: 'Ю',
  Yacut: 'Ý',
  Yacute: 'Ý',
  Ycirc: 'Ŷ',
  Ycy: 'Ы',
  Yfr: '𝔜',
  Yopf: '𝕐',
  Yscr: '𝒴',
  Yuml: 'Ÿ',
  ZHcy: 'Ж',
  Zacute: 'Ź',
  Zcaron: 'Ž',
  Zcy: 'З',
  Zdot: 'Ż',
  ZeroWidthSpace: '​',
  Zeta: 'Ζ',
  Zfr: 'ℨ',
  Zopf: 'ℤ',
  Zscr: '𝒵',
  aacut: 'á',
  aacute: 'á',
  abreve: 'ă',
  ac: '∾',
  acE: '∾̳',
  acd: '∿',
  acir: 'â',
  acirc: 'â',
  acut: '´',
  acute: '´',
  acy: 'а',
  aeli: 'æ',
  aelig: 'æ',
  af: '⁡',
  afr: '𝔞',
  agrav: 'à',
  agrave: 'à',
  alefsym: 'ℵ',
  aleph: 'ℵ',
  alpha: 'α',
  amacr: 'ā',
  amalg: '⨿',
  am: '&',
  amp: '&',
  and: '∧',
  andand: '⩕',
  andd: '⩜',
  andslope: '⩘',
  andv: '⩚',
  ang: '∠',
  ange: '⦤',
  angle: '∠',
  angmsd: '∡',
  angmsdaa: '⦨',
  angmsdab: '⦩',
  angmsdac: '⦪',
  angmsdad: '⦫',
  angmsdae: '⦬',
  angmsdaf: '⦭',
  angmsdag: '⦮',
  angmsdah: '⦯',
  angrt: '∟',
  angrtvb: '⊾',
  angrtvbd: '⦝',
  angsph: '∢',
  angst: 'Å',
  angzarr: '⍼',
  aogon: 'ą',
  aopf: '𝕒',
  ap: '≈',
  apE: '⩰',
  apacir: '⩯',
  ape: '≊',
  apid: '≋',
  apos: "'",
  approx: '≈',
  approxeq: '≊',
  arin: 'å',
  aring: 'å',
  ascr: '𝒶',
  ast: '*',
  asymp: '≈',
  asympeq: '≍',
  atild: 'ã',
  atilde: 'ã',
  aum: 'ä',
  auml: 'ä',
  awconint: '∳',
  awint: '⨑',
  bNot: '⫭',
  backcong: '≌',
  backepsilon: '϶',
  backprime: '‵',
  backsim: '∽',
  backsimeq: '⋍',
  barvee: '⊽',
  barwed: '⌅',
  barwedge: '⌅',
  bbrk: '⎵',
  bbrktbrk: '⎶',
  bcong: '≌',
  bcy: 'б',
  bdquo: '„',
  becaus: '∵',
  because: '∵',
  bemptyv: '⦰',
  bepsi: '϶',
  bernou: 'ℬ',
  beta: 'β',
  beth: 'ℶ',
  between: '≬',
  bfr: '𝔟',
  bigcap: '⋂',
  bigcirc: '◯',
  bigcup: '⋃',
  bigodot: '⨀',
  bigoplus: '⨁',
  bigotimes: '⨂',
  bigsqcup: '⨆',
  bigstar: '★',
  bigtriangledown: '▽',
  bigtriangleup: '△',
  biguplus: '⨄',
  bigvee: '⋁',
  bigwedge: '⋀',
  bkarow: '⤍',
  blacklozenge: '⧫',
  blacksquare: '▪',
  blacktriangle: '▴',
  blacktriangledown: '▾',
  blacktriangleleft: '◂',
  blacktriangleright: '▸',
  blank: '␣',
  blk12: '▒',
  blk14: '░',
  blk34: '▓',
  block: '█',
  bne: '=⃥',
  bnequiv: '≡⃥',
  bnot: '⌐',
  bopf: '𝕓',
  bot: '⊥',
  bottom: '⊥',
  bowtie: '⋈',
  boxDL: '╗',
  boxDR: '╔',
  boxDl: '╖',
  boxDr: '╓',
  boxH: '═',
  boxHD: '╦',
  boxHU: '╩',
  boxHd: '╤',
  boxHu: '╧',
  boxUL: '╝',
  boxUR: '╚',
  boxUl: '╜',
  boxUr: '╙',
  boxV: '║',
  boxVH: '╬',
  boxVL: '╣',
  boxVR: '╠',
  boxVh: '╫',
  boxVl: '╢',
  boxVr: '╟',
  boxbox: '⧉',
  boxdL: '╕',
  boxdR: '╒',
  boxdl: '┐',
  boxdr: '┌',
  boxh: '─',
  boxhD: '╥',
  boxhU: '╨',
  boxhd: '┬',
  boxhu: '┴',
  boxminus: '⊟',
  boxplus: '⊞',
  boxtimes: '⊠',
  boxuL: '╛',
  boxuR: '╘',
  boxul: '┘',
  boxur: '└',
  boxv: '│',
  boxvH: '╪',
  boxvL: '╡',
  boxvR: '╞',
  boxvh: '┼',
  boxvl: '┤',
  boxvr: '├',
  bprime: '‵',
  breve: '˘',
  brvba: '¦',
  brvbar: '¦',
  bscr: '𝒷',
  bsemi: '⁏',
  bsim: '∽',
  bsime: '⋍',
  bsol: '\\',
  bsolb: '⧅',
  bsolhsub: '⟈',
  bull: '•',
  bullet: '•',
  bump: '≎',
  bumpE: '⪮',
  bumpe: '≏',
  bumpeq: '≏',
  cacute: 'ć',
  cap: '∩',
  capand: '⩄',
  capbrcup: '⩉',
  capcap: '⩋',
  capcup: '⩇',
  capdot: '⩀',
  caps: '∩︀',
  caret: '⁁',
  caron: 'ˇ',
  ccaps: '⩍',
  ccaron: 'č',
  ccedi: 'ç',
  ccedil: 'ç',
  ccirc: 'ĉ',
  ccups: '⩌',
  ccupssm: '⩐',
  cdot: 'ċ',
  cedi: '¸',
  cedil: '¸',
  cemptyv: '⦲',
  cen: '¢',
  cent: '¢',
  centerdot: '·',
  cfr: '𝔠',
  chcy: 'ч',
  check: '✓',
  checkmark: '✓',
  chi: 'χ',
  cir: '○',
  cirE: '⧃',
  circ: 'ˆ',
  circeq: '≗',
  circlearrowleft: '↺',
  circlearrowright: '↻',
  circledR: '®',
  circledS: 'Ⓢ',
  circledast: '⊛',
  circledcirc: '⊚',
  circleddash: '⊝',
  cire: '≗',
  cirfnint: '⨐',
  cirmid: '⫯',
  cirscir: '⧂',
  clubs: '♣',
  clubsuit: '♣',
  colon: ':',
  colone: '≔',
  coloneq: '≔',
  comma: ',',
  commat: '@',
  comp: '∁',
  compfn: '∘',
  complement: '∁',
  complexes: 'ℂ',
  cong: '≅',
  congdot: '⩭',
  conint: '∮',
  copf: '𝕔',
  coprod: '∐',
  cop: '©',
  copy: '©',
  copysr: '℗',
  crarr: '↵',
  cross: '✗',
  cscr: '𝒸',
  csub: '⫏',
  csube: '⫑',
  csup: '⫐',
  csupe: '⫒',
  ctdot: '⋯',
  cudarrl: '⤸',
  cudarrr: '⤵',
  cuepr: '⋞',
  cuesc: '⋟',
  cularr: '↶',
  cularrp: '⤽',
  cup: '∪',
  cupbrcap: '⩈',
  cupcap: '⩆',
  cupcup: '⩊',
  cupdot: '⊍',
  cupor: '⩅',
  cups: '∪︀',
  curarr: '↷',
  curarrm: '⤼',
  curlyeqprec: '⋞',
  curlyeqsucc: '⋟',
  curlyvee: '⋎',
  curlywedge: '⋏',
  curre: '¤',
  curren: '¤',
  curvearrowleft: '↶',
  curvearrowright: '↷',
  cuvee: '⋎',
  cuwed: '⋏',
  cwconint: '∲',
  cwint: '∱',
  cylcty: '⌭',
  dArr: '⇓',
  dHar: '⥥',
  dagger: '†',
  daleth: 'ℸ',
  darr: '↓',
  dash: '‐',
  dashv: '⊣',
  dbkarow: '⤏',
  dblac: '˝',
  dcaron: 'ď',
  dcy: 'д',
  dd: 'ⅆ',
  ddagger: '‡',
  ddarr: '⇊',
  ddotseq: '⩷',
  de: '°',
  deg: '°',
  delta: 'δ',
  demptyv: '⦱',
  dfisht: '⥿',
  dfr: '𝔡',
  dharl: '⇃',
  dharr: '⇂',
  diam: '⋄',
  diamond: '⋄',
  diamondsuit: '♦',
  diams: '♦',
  die: '¨',
  digamma: 'ϝ',
  disin: '⋲',
  div: '÷',
  divid: '÷',
  divide: '÷',
  divideontimes: '⋇',
  divonx: '⋇',
  djcy: 'ђ',
  dlcorn: '⌞',
  dlcrop: '⌍',
  dollar: '$',
  dopf: '𝕕',
  dot: '˙',
  doteq: '≐',
  doteqdot: '≑',
  dotminus: '∸',
  dotplus: '∔',
  dotsquare: '⊡',
  doublebarwedge: '⌆',
  downarrow: '↓',
  downdownarrows: '⇊',
  downharpoonleft: '⇃',
  downharpoonright: '⇂',
  drbkarow: '⤐',
  drcorn: '⌟',
  drcrop: '⌌',
  dscr: '𝒹',
  dscy: 'ѕ',
  dsol: '⧶',
  dstrok: 'đ',
  dtdot: '⋱',
  dtri: '▿',
  dtrif: '▾',
  duarr: '⇵',
  duhar: '⥯',
  dwangle: '⦦',
  dzcy: 'џ',
  dzigrarr: '⟿',
  eDDot: '⩷',
  eDot: '≑',
  eacut: 'é',
  eacute: 'é',
  easter: '⩮',
  ecaron: 'ě',
  ecir: 'ê',
  ecirc: 'ê',
  ecolon: '≕',
  ecy: 'э',
  edot: 'ė',
  ee: 'ⅇ',
  efDot: '≒',
  efr: '𝔢',
  eg: '⪚',
  egrav: 'è',
  egrave: 'è',
  egs: '⪖',
  egsdot: '⪘',
  el: '⪙',
  elinters: '⏧',
  ell: 'ℓ',
  els: '⪕',
  elsdot: '⪗',
  emacr: 'ē',
  empty: '∅',
  emptyset: '∅',
  emptyv: '∅',
  emsp13: ' ',
  emsp14: ' ',
  emsp: ' ',
  eng: 'ŋ',
  ensp: ' ',
  eogon: 'ę',
  eopf: '𝕖',
  epar: '⋕',
  eparsl: '⧣',
  eplus: '⩱',
  epsi: 'ε',
  epsilon: 'ε',
  epsiv: 'ϵ',
  eqcirc: '≖',
  eqcolon: '≕',
  eqsim: '≂',
  eqslantgtr: '⪖',
  eqslantless: '⪕',
  equals: '=',
  equest: '≟',
  equiv: '≡',
  equivDD: '⩸',
  eqvparsl: '⧥',
  erDot: '≓',
  erarr: '⥱',
  escr: 'ℯ',
  esdot: '≐',
  esim: '≂',
  eta: 'η',
  et: 'ð',
  eth: 'ð',
  eum: 'ë',
  euml: 'ë',
  euro: '€',
  excl: '!',
  exist: '∃',
  expectation: 'ℰ',
  exponentiale: 'ⅇ',
  fallingdotseq: '≒',
  fcy: 'ф',
  female: '♀',
  ffilig: 'ﬃ',
  fflig: 'ﬀ',
  ffllig: 'ﬄ',
  ffr: '𝔣',
  filig: 'ﬁ',
  fjlig: 'fj',
  flat: '♭',
  fllig: 'ﬂ',
  fltns: '▱',
  fnof: 'ƒ',
  fopf: '𝕗',
  forall: '∀',
  fork: '⋔',
  forkv: '⫙',
  fpartint: '⨍',
  frac1: '¼',
  frac12: '½',
  frac13: '⅓',
  frac14: '¼',
  frac15: '⅕',
  frac16: '⅙',
  frac18: '⅛',
  frac23: '⅔',
  frac25: '⅖',
  frac3: '¾',
  frac34: '¾',
  frac35: '⅗',
  frac38: '⅜',
  frac45: '⅘',
  frac56: '⅚',
  frac58: '⅝',
  frac78: '⅞',
  frasl: '⁄',
  frown: '⌢',
  fscr: '𝒻',
  gE: '≧',
  gEl: '⪌',
  gacute: 'ǵ',
  gamma: 'γ',
  gammad: 'ϝ',
  gap: '⪆',
  gbreve: 'ğ',
  gcirc: 'ĝ',
  gcy: 'г',
  gdot: 'ġ',
  ge: '≥',
  gel: '⋛',
  geq: '≥',
  geqq: '≧',
  geqslant: '⩾',
  ges: '⩾',
  gescc: '⪩',
  gesdot: '⪀',
  gesdoto: '⪂',
  gesdotol: '⪄',
  gesl: '⋛︀',
  gesles: '⪔',
  gfr: '𝔤',
  gg: '≫',
  ggg: '⋙',
  gimel: 'ℷ',
  gjcy: 'ѓ',
  gl: '≷',
  glE: '⪒',
  gla: '⪥',
  glj: '⪤',
  gnE: '≩',
  gnap: '⪊',
  gnapprox: '⪊',
  gne: '⪈',
  gneq: '⪈',
  gneqq: '≩',
  gnsim: '⋧',
  gopf: '𝕘',
  grave: '`',
  gscr: 'ℊ',
  gsim: '≳',
  gsime: '⪎',
  gsiml: '⪐',
  g: '>',
  gt: '>',
  gtcc: '⪧',
  gtcir: '⩺',
  gtdot: '⋗',
  gtlPar: '⦕',
  gtquest: '⩼',
  gtrapprox: '⪆',
  gtrarr: '⥸',
  gtrdot: '⋗',
  gtreqless: '⋛',
  gtreqqless: '⪌',
  gtrless: '≷',
  gtrsim: '≳',
  gvertneqq: '≩︀',
  gvnE: '≩︀',
  hArr: '⇔',
  hairsp: ' ',
  half: '½',
  hamilt: 'ℋ',
  hardcy: 'ъ',
  harr: '↔',
  harrcir: '⥈',
  harrw: '↭',
  hbar: 'ℏ',
  hcirc: 'ĥ',
  hearts: '♥',
  heartsuit: '♥',
  hellip: '…',
  hercon: '⊹',
  hfr: '𝔥',
  hksearow: '⤥',
  hkswarow: '⤦',
  hoarr: '⇿',
  homtht: '∻',
  hookleftarrow: '↩',
  hookrightarrow: '↪',
  hopf: '𝕙',
  horbar: '―',
  hscr: '𝒽',
  hslash: 'ℏ',
  hstrok: 'ħ',
  hybull: '⁃',
  hyphen: '‐',
  iacut: 'í',
  iacute: 'í',
  ic: '⁣',
  icir: 'î',
  icirc: 'î',
  icy: 'и',
  iecy: 'е',
  iexc: '¡',
  iexcl: '¡',
  iff: '⇔',
  ifr: '𝔦',
  igrav: 'ì',
  igrave: 'ì',
  ii: 'ⅈ',
  iiiint: '⨌',
  iiint: '∭',
  iinfin: '⧜',
  iiota: '℩',
  ijlig: 'ĳ',
  imacr: 'ī',
  image: 'ℑ',
  imagline: 'ℐ',
  imagpart: 'ℑ',
  imath: 'ı',
  imof: '⊷',
  imped: 'Ƶ',
  in: '∈',
  incare: '℅',
  infin: '∞',
  infintie: '⧝',
  inodot: 'ı',
  int: '∫',
  intcal: '⊺',
  integers: 'ℤ',
  intercal: '⊺',
  intlarhk: '⨗',
  intprod: '⨼',
  iocy: 'ё',
  iogon: 'į',
  iopf: '𝕚',
  iota: 'ι',
  iprod: '⨼',
  iques: '¿',
  iquest: '¿',
  iscr: '𝒾',
  isin: '∈',
  isinE: '⋹',
  isindot: '⋵',
  isins: '⋴',
  isinsv: '⋳',
  isinv: '∈',
  it: '⁢',
  itilde: 'ĩ',
  iukcy: 'і',
  ium: 'ï',
  iuml: 'ï',
  jcirc: 'ĵ',
  jcy: 'й',
  jfr: '𝔧',
  jmath: 'ȷ',
  jopf: '𝕛',
  jscr: '𝒿',
  jsercy: 'ј',
  jukcy: 'є',
  kappa: 'κ',
  kappav: 'ϰ',
  kcedil: 'ķ',
  kcy: 'к',
  kfr: '𝔨',
  kgreen: 'ĸ',
  khcy: 'х',
  kjcy: 'ќ',
  kopf: '𝕜',
  kscr: '𝓀',
  lAarr: '⇚',
  lArr: '⇐',
  lAtail: '⤛',
  lBarr: '⤎',
  lE: '≦',
  lEg: '⪋',
  lHar: '⥢',
  lacute: 'ĺ',
  laemptyv: '⦴',
  lagran: 'ℒ',
  lambda: 'λ',
  lang: '⟨',
  langd: '⦑',
  langle: '⟨',
  lap: '⪅',
  laqu: '«',
  laquo: '«',
  larr: '←',
  larrb: '⇤',
  larrbfs: '⤟',
  larrfs: '⤝',
  larrhk: '↩',
  larrlp: '↫',
  larrpl: '⤹',
  larrsim: '⥳',
  larrtl: '↢',
  lat: '⪫',
  latail: '⤙',
  late: '⪭',
  lates: '⪭︀',
  lbarr: '⤌',
  lbbrk: '❲',
  lbrace: '{',
  lbrack: '[',
  lbrke: '⦋',
  lbrksld: '⦏',
  lbrkslu: '⦍',
  lcaron: 'ľ',
  lcedil: 'ļ',
  lceil: '⌈',
  lcub: '{',
  lcy: 'л',
  ldca: '⤶',
  ldquo: '“',
  ldquor: '„',
  ldrdhar: '⥧',
  ldrushar: '⥋',
  ldsh: '↲',
  le: '≤',
  leftarrow: '←',
  leftarrowtail: '↢',
  leftharpoondown: '↽',
  leftharpoonup: '↼',
  leftleftarrows: '⇇',
  leftrightarrow: '↔',
  leftrightarrows: '⇆',
  leftrightharpoons: '⇋',
  leftrightsquigarrow: '↭',
  leftthreetimes: '⋋',
  leg: '⋚',
  leq: '≤',
  leqq: '≦',
  leqslant: '⩽',
  les: '⩽',
  lescc: '⪨',
  lesdot: '⩿',
  lesdoto: '⪁',
  lesdotor: '⪃',
  lesg: '⋚︀',
  lesges: '⪓',
  lessapprox: '⪅',
  lessdot: '⋖',
  lesseqgtr: '⋚',
  lesseqqgtr: '⪋',
  lessgtr: '≶',
  lesssim: '≲',
  lfisht: '⥼',
  lfloor: '⌊',
  lfr: '𝔩',
  lg: '≶',
  lgE: '⪑',
  lhard: '↽',
  lharu: '↼',
  lharul: '⥪',
  lhblk: '▄',
  ljcy: 'љ',
  ll: '≪',
  llarr: '⇇',
  llcorner: '⌞',
  llhard: '⥫',
  lltri: '◺',
  lmidot: 'ŀ',
  lmoust: '⎰',
  lmoustache: '⎰',
  lnE: '≨',
  lnap: '⪉',
  lnapprox: '⪉',
  lne: '⪇',
  lneq: '⪇',
  lneqq: '≨',
  lnsim: '⋦',
  loang: '⟬',
  loarr: '⇽',
  lobrk: '⟦',
  longleftarrow: '⟵',
  longleftrightarrow: '⟷',
  longmapsto: '⟼',
  longrightarrow: '⟶',
  looparrowleft: '↫',
  looparrowright: '↬',
  lopar: '⦅',
  lopf: '𝕝',
  loplus: '⨭',
  lotimes: '⨴',
  lowast: '∗',
  lowbar: '_',
  loz: '◊',
  lozenge: '◊',
  lozf: '⧫',
  lpar: '(',
  lparlt: '⦓',
  lrarr: '⇆',
  lrcorner: '⌟',
  lrhar: '⇋',
  lrhard: '⥭',
  lrm: '‎',
  lrtri: '⊿',
  lsaquo: '‹',
  lscr: '𝓁',
  lsh: '↰',
  lsim: '≲',
  lsime: '⪍',
  lsimg: '⪏',
  lsqb: '[',
  lsquo: '‘',
  lsquor: '‚',
  lstrok: 'ł',
  l: '<',
  lt: '<',
  ltcc: '⪦',
  ltcir: '⩹',
  ltdot: '⋖',
  lthree: '⋋',
  ltimes: '⋉',
  ltlarr: '⥶',
  ltquest: '⩻',
  ltrPar: '⦖',
  ltri: '◃',
  ltrie: '⊴',
  ltrif: '◂',
  lurdshar: '⥊',
  luruhar: '⥦',
  lvertneqq: '≨︀',
  lvnE: '≨︀',
  mDDot: '∺',
  mac: '¯',
  macr: '¯',
  male: '♂',
  malt: '✠',
  maltese: '✠',
  map: '↦',
  mapsto: '↦',
  mapstodown: '↧',
  mapstoleft: '↤',
  mapstoup: '↥',
  marker: '▮',
  mcomma: '⨩',
  mcy: 'м',
  mdash: '—',
  measuredangle: '∡',
  mfr: '𝔪',
  mho: '℧',
  micr: 'µ',
  micro: 'µ',
  mid: '∣',
  midast: '*',
  midcir: '⫰',
  middo: '·',
  middot: '·',
  minus: '−',
  minusb: '⊟',
  minusd: '∸',
  minusdu: '⨪',
  mlcp: '⫛',
  mldr: '…',
  mnplus: '∓',
  models: '⊧',
  mopf: '𝕞',
  mp: '∓',
  mscr: '𝓂',
  mstpos: '∾',
  mu: 'μ',
  multimap: '⊸',
  mumap: '⊸',
  nGg: '⋙̸',
  nGt: '≫⃒',
  nGtv: '≫̸',
  nLeftarrow: '⇍',
  nLeftrightarrow: '⇎',
  nLl: '⋘̸',
  nLt: '≪⃒',
  nLtv: '≪̸',
  nRightarrow: '⇏',
  nVDash: '⊯',
  nVdash: '⊮',
  nabla: '∇',
  nacute: 'ń',
  nang: '∠⃒',
  nap: '≉',
  napE: '⩰̸',
  napid: '≋̸',
  napos: 'ŉ',
  napprox: '≉',
  natur: '♮',
  natural: '♮',
  naturals: 'ℕ',
  nbs: ' ',
  nbsp: ' ',
  nbump: '≎̸',
  nbumpe: '≏̸',
  ncap: '⩃',
  ncaron: 'ň',
  ncedil: 'ņ',
  ncong: '≇',
  ncongdot: '⩭̸',
  ncup: '⩂',
  ncy: 'н',
  ndash: '–',
  ne: '≠',
  neArr: '⇗',
  nearhk: '⤤',
  nearr: '↗',
  nearrow: '↗',
  nedot: '≐̸',
  nequiv: '≢',
  nesear: '⤨',
  nesim: '≂̸',
  nexist: '∄',
  nexists: '∄',
  nfr: '𝔫',
  ngE: '≧̸',
  nge: '≱',
  ngeq: '≱',
  ngeqq: '≧̸',
  ngeqslant: '⩾̸',
  nges: '⩾̸',
  ngsim: '≵',
  ngt: '≯',
  ngtr: '≯',
  nhArr: '⇎',
  nharr: '↮',
  nhpar: '⫲',
  ni: '∋',
  nis: '⋼',
  nisd: '⋺',
  niv: '∋',
  njcy: 'њ',
  nlArr: '⇍',
  nlE: '≦̸',
  nlarr: '↚',
  nldr: '‥',
  nle: '≰',
  nleftarrow: '↚',
  nleftrightarrow: '↮',
  nleq: '≰',
  nleqq: '≦̸',
  nleqslant: '⩽̸',
  nles: '⩽̸',
  nless: '≮',
  nlsim: '≴',
  nlt: '≮',
  nltri: '⋪',
  nltrie: '⋬',
  nmid: '∤',
  nopf: '𝕟',
  no: '¬',
  not: '¬',
  notin: '∉',
  notinE: '⋹̸',
  notindot: '⋵̸',
  notinva: '∉',
  notinvb: '⋷',
  notinvc: '⋶',
  notni: '∌',
  notniva: '∌',
  notnivb: '⋾',
  notnivc: '⋽',
  npar: '∦',
  nparallel: '∦',
  nparsl: '⫽⃥',
  npart: '∂̸',
  npolint: '⨔',
  npr: '⊀',
  nprcue: '⋠',
  npre: '⪯̸',
  nprec: '⊀',
  npreceq: '⪯̸',
  nrArr: '⇏',
  nrarr: '↛',
  nrarrc: '⤳̸',
  nrarrw: '↝̸',
  nrightarrow: '↛',
  nrtri: '⋫',
  nrtrie: '⋭',
  nsc: '⊁',
  nsccue: '⋡',
  nsce: '⪰̸',
  nscr: '𝓃',
  nshortmid: '∤',
  nshortparallel: '∦',
  nsim: '≁',
  nsime: '≄',
  nsimeq: '≄',
  nsmid: '∤',
  nspar: '∦',
  nsqsube: '⋢',
  nsqsupe: '⋣',
  nsub: '⊄',
  nsubE: '⫅̸',
  nsube: '⊈',
  nsubset: '⊂⃒',
  nsubseteq: '⊈',
  nsubseteqq: '⫅̸',
  nsucc: '⊁',
  nsucceq: '⪰̸',
  nsup: '⊅',
  nsupE: '⫆̸',
  nsupe: '⊉',
  nsupset: '⊃⃒',
  nsupseteq: '⊉',
  nsupseteqq: '⫆̸',
  ntgl: '≹',
  ntild: 'ñ',
  ntilde: 'ñ',
  ntlg: '≸',
  ntriangleleft: '⋪',
  ntrianglelefteq: '⋬',
  ntriangleright: '⋫',
  ntrianglerighteq: '⋭',
  nu: 'ν',
  num: '#',
  numero: '№',
  numsp: ' ',
  nvDash: '⊭',
  nvHarr: '⤄',
  nvap: '≍⃒',
  nvdash: '⊬',
  nvge: '≥⃒',
  nvgt: '>⃒',
  nvinfin: '⧞',
  nvlArr: '⤂',
  nvle: '≤⃒',
  nvlt: '<⃒',
  nvltrie: '⊴⃒',
  nvrArr: '⤃',
  nvrtrie: '⊵⃒',
  nvsim: '∼⃒',
  nwArr: '⇖',
  nwarhk: '⤣',
  nwarr: '↖',
  nwarrow: '↖',
  nwnear: '⤧',
  oS: 'Ⓢ',
  oacut: 'ó',
  oacute: 'ó',
  oast: '⊛',
  ocir: 'ô',
  ocirc: 'ô',
  ocy: 'о',
  odash: '⊝',
  odblac: 'ő',
  odiv: '⨸',
  odot: '⊙',
  odsold: '⦼',
  oelig: 'œ',
  ofcir: '⦿',
  ofr: '𝔬',
  ogon: '˛',
  ograv: 'ò',
  ograve: 'ò',
  ogt: '⧁',
  ohbar: '⦵',
  ohm: 'Ω',
  oint: '∮',
  olarr: '↺',
  olcir: '⦾',
  olcross: '⦻',
  oline: '‾',
  olt: '⧀',
  omacr: 'ō',
  omega: 'ω',
  omicron: 'ο',
  omid: '⦶',
  ominus: '⊖',
  oopf: '𝕠',
  opar: '⦷',
  operp: '⦹',
  oplus: '⊕',
  or: '∨',
  orarr: '↻',
  ord: 'º',
  order: 'ℴ',
  orderof: 'ℴ',
  ordf: 'ª',
  ordm: 'º',
  origof: '⊶',
  oror: '⩖',
  orslope: '⩗',
  orv: '⩛',
  oscr: 'ℴ',
  oslas: 'ø',
  oslash: 'ø',
  osol: '⊘',
  otild: 'õ',
  otilde: 'õ',
  otimes: '⊗',
  otimesas: '⨶',
  oum: 'ö',
  ouml: 'ö',
  ovbar: '⌽',
  par: '¶',
  para: '¶',
  parallel: '∥',
  parsim: '⫳',
  parsl: '⫽',
  part: '∂',
  pcy: 'п',
  percnt: '%',
  period: '.',
  permil: '‰',
  perp: '⊥',
  pertenk: '‱',
  pfr: '𝔭',
  phi: 'φ',
  phiv: 'ϕ',
  phmmat: 'ℳ',
  phone: '☎',
  pi: 'π',
  pitchfork: '⋔',
  piv: 'ϖ',
  planck: 'ℏ',
  planckh: 'ℎ',
  plankv: 'ℏ',
  plus: '+',
  plusacir: '⨣',
  plusb: '⊞',
  pluscir: '⨢',
  plusdo: '∔',
  plusdu: '⨥',
  pluse: '⩲',
  plusm: '±',
  plusmn: '±',
  plussim: '⨦',
  plustwo: '⨧',
  pm: '±',
  pointint: '⨕',
  popf: '𝕡',
  poun: '£',
  pound: '£',
  pr: '≺',
  prE: '⪳',
  prap: '⪷',
  prcue: '≼',
  pre: '⪯',
  prec: '≺',
  precapprox: '⪷',
  preccurlyeq: '≼',
  preceq: '⪯',
  precnapprox: '⪹',
  precneqq: '⪵',
  precnsim: '⋨',
  precsim: '≾',
  prime: '′',
  primes: 'ℙ',
  prnE: '⪵',
  prnap: '⪹',
  prnsim: '⋨',
  prod: '∏',
  profalar: '⌮',
  profline: '⌒',
  profsurf: '⌓',
  prop: '∝',
  propto: '∝',
  prsim: '≾',
  prurel: '⊰',
  pscr: '𝓅',
  psi: 'ψ',
  puncsp: ' ',
  qfr: '𝔮',
  qint: '⨌',
  qopf: '𝕢',
  qprime: '⁗',
  qscr: '𝓆',
  quaternions: 'ℍ',
  quatint: '⨖',
  quest: '?',
  questeq: '≟',
  quo: '"',
  quot: '"',
  rAarr: '⇛',
  rArr: '⇒',
  rAtail: '⤜',
  rBarr: '⤏',
  rHar: '⥤',
  race: '∽̱',
  racute: 'ŕ',
  radic: '√',
  raemptyv: '⦳',
  rang: '⟩',
  rangd: '⦒',
  range: '⦥',
  rangle: '⟩',
  raqu: '»',
  raquo: '»',
  rarr: '→',
  rarrap: '⥵',
  rarrb: '⇥',
  rarrbfs: '⤠',
  rarrc: '⤳',
  rarrfs: '⤞',
  rarrhk: '↪',
  rarrlp: '↬',
  rarrpl: '⥅',
  rarrsim: '⥴',
  rarrtl: '↣',
  rarrw: '↝',
  ratail: '⤚',
  ratio: '∶',
  rationals: 'ℚ',
  rbarr: '⤍',
  rbbrk: '❳',
  rbrace: '}',
  rbrack: ']',
  rbrke: '⦌',
  rbrksld: '⦎',
  rbrkslu: '⦐',
  rcaron: 'ř',
  rcedil: 'ŗ',
  rceil: '⌉',
  rcub: '}',
  rcy: 'р',
  rdca: '⤷',
  rdldhar: '⥩',
  rdquo: '”',
  rdquor: '”',
  rdsh: '↳',
  real: 'ℜ',
  realine: 'ℛ',
  realpart: 'ℜ',
  reals: 'ℝ',
  rect: '▭',
  re: '®',
  reg: '®',
  rfisht: '⥽',
  rfloor: '⌋',
  rfr: '𝔯',
  rhard: '⇁',
  rharu: '⇀',
  rharul: '⥬',
  rho: 'ρ',
  rhov: 'ϱ',
  rightarrow: '→',
  rightarrowtail: '↣',
  rightharpoondown: '⇁',
  rightharpoonup: '⇀',
  rightleftarrows: '⇄',
  rightleftharpoons: '⇌',
  rightrightarrows: '⇉',
  rightsquigarrow: '↝',
  rightthreetimes: '⋌',
  ring: '˚',
  risingdotseq: '≓',
  rlarr: '⇄',
  rlhar: '⇌',
  rlm: '‏',
  rmoust: '⎱',
  rmoustache: '⎱',
  rnmid: '⫮',
  roang: '⟭',
  roarr: '⇾',
  robrk: '⟧',
  ropar: '⦆',
  ropf: '𝕣',
  roplus: '⨮',
  rotimes: '⨵',
  rpar: ')',
  rpargt: '⦔',
  rppolint: '⨒',
  rrarr: '⇉',
  rsaquo: '›',
  rscr: '𝓇',
  rsh: '↱',
  rsqb: ']',
  rsquo: '’',
  rsquor: '’',
  rthree: '⋌',
  rtimes: '⋊',
  rtri: '▹',
  rtrie: '⊵',
  rtrif: '▸',
  rtriltri: '⧎',
  ruluhar: '⥨',
  rx: '℞',
  sacute: 'ś',
  sbquo: '‚',
  sc: '≻',
  scE: '⪴',
  scap: '⪸',
  scaron: 'š',
  sccue: '≽',
  sce: '⪰',
  scedil: 'ş',
  scirc: 'ŝ',
  scnE: '⪶',
  scnap: '⪺',
  scnsim: '⋩',
  scpolint: '⨓',
  scsim: '≿',
  scy: 'с',
  sdot: '⋅',
  sdotb: '⊡',
  sdote: '⩦',
  seArr: '⇘',
  searhk: '⤥',
  searr: '↘',
  searrow: '↘',
  sec: '§',
  sect: '§',
  semi: ';',
  seswar: '⤩',
  setminus: '∖',
  setmn: '∖',
  sext: '✶',
  sfr: '𝔰',
  sfrown: '⌢',
  sharp: '♯',
  shchcy: 'щ',
  shcy: 'ш',
  shortmid: '∣',
  shortparallel: '∥',
  sh: '­',
  shy: '­',
  sigma: 'σ',
  sigmaf: 'ς',
  sigmav: 'ς',
  sim: '∼',
  simdot: '⩪',
  sime: '≃',
  simeq: '≃',
  simg: '⪞',
  simgE: '⪠',
  siml: '⪝',
  simlE: '⪟',
  simne: '≆',
  simplus: '⨤',
  simrarr: '⥲',
  slarr: '←',
  smallsetminus: '∖',
  smashp: '⨳',
  smeparsl: '⧤',
  smid: '∣',
  smile: '⌣',
  smt: '⪪',
  smte: '⪬',
  smtes: '⪬︀',
  softcy: 'ь',
  sol: '/',
  solb: '⧄',
  solbar: '⌿',
  sopf: '𝕤',
  spades: '♠',
  spadesuit: '♠',
  spar: '∥',
  sqcap: '⊓',
  sqcaps: '⊓︀',
  sqcup: '⊔',
  sqcups: '⊔︀',
  sqsub: '⊏',
  sqsube: '⊑',
  sqsubset: '⊏',
  sqsubseteq: '⊑',
  sqsup: '⊐',
  sqsupe: '⊒',
  sqsupset: '⊐',
  sqsupseteq: '⊒',
  squ: '□',
  square: '□',
  squarf: '▪',
  squf: '▪',
  srarr: '→',
  sscr: '𝓈',
  ssetmn: '∖',
  ssmile: '⌣',
  sstarf: '⋆',
  star: '☆',
  starf: '★',
  straightepsilon: 'ϵ',
  straightphi: 'ϕ',
  strns: '¯',
  sub: '⊂',
  subE: '⫅',
  subdot: '⪽',
  sube: '⊆',
  subedot: '⫃',
  submult: '⫁',
  subnE: '⫋',
  subne: '⊊',
  subplus: '⪿',
  subrarr: '⥹',
  subset: '⊂',
  subseteq: '⊆',
  subseteqq: '⫅',
  subsetneq: '⊊',
  subsetneqq: '⫋',
  subsim: '⫇',
  subsub: '⫕',
  subsup: '⫓',
  succ: '≻',
  succapprox: '⪸',
  succcurlyeq: '≽',
  succeq: '⪰',
  succnapprox: '⪺',
  succneqq: '⪶',
  succnsim: '⋩',
  succsim: '≿',
  sum: '∑',
  sung: '♪',
  sup: '⊃',
  sup1: '¹',
  sup2: '²',
  sup3: '³',
  supE: '⫆',
  supdot: '⪾',
  supdsub: '⫘',
  supe: '⊇',
  supedot: '⫄',
  suphsol: '⟉',
  suphsub: '⫗',
  suplarr: '⥻',
  supmult: '⫂',
  supnE: '⫌',
  supne: '⊋',
  supplus: '⫀',
  supset: '⊃',
  supseteq: '⊇',
  supseteqq: '⫆',
  supsetneq: '⊋',
  supsetneqq: '⫌',
  supsim: '⫈',
  supsub: '⫔',
  supsup: '⫖',
  swArr: '⇙',
  swarhk: '⤦',
  swarr: '↙',
  swarrow: '↙',
  swnwar: '⤪',
  szli: 'ß',
  szlig: 'ß',
  target: '⌖',
  tau: 'τ',
  tbrk: '⎴',
  tcaron: 'ť',
  tcedil: 'ţ',
  tcy: 'т',
  tdot: '⃛',
  telrec: '⌕',
  tfr: '𝔱',
  there4: '∴',
  therefore: '∴',
  theta: 'θ',
  thetasym: 'ϑ',
  thetav: 'ϑ',
  thickapprox: '≈',
  thicksim: '∼',
  thinsp: ' ',
  thkap: '≈',
  thksim: '∼',
  thor: 'þ',
  thorn: 'þ',
  tilde: '˜',
  time: '×',
  times: '×',
  timesb: '⊠',
  timesbar: '⨱',
  timesd: '⨰',
  tint: '∭',
  toea: '⤨',
  top: '⊤',
  topbot: '⌶',
  topcir: '⫱',
  topf: '𝕥',
  topfork: '⫚',
  tosa: '⤩',
  tprime: '‴',
  trade: '™',
  triangle: '▵',
  triangledown: '▿',
  triangleleft: '◃',
  trianglelefteq: '⊴',
  triangleq: '≜',
  triangleright: '▹',
  trianglerighteq: '⊵',
  tridot: '◬',
  trie: '≜',
  triminus: '⨺',
  triplus: '⨹',
  trisb: '⧍',
  tritime: '⨻',
  trpezium: '⏢',
  tscr: '𝓉',
  tscy: 'ц',
  tshcy: 'ћ',
  tstrok: 'ŧ',
  twixt: '≬',
  twoheadleftarrow: '↞',
  twoheadrightarrow: '↠',
  uArr: '⇑',
  uHar: '⥣',
  uacut: 'ú',
  uacute: 'ú',
  uarr: '↑',
  ubrcy: 'ў',
  ubreve: 'ŭ',
  ucir: 'û',
  ucirc: 'û',
  ucy: 'у',
  udarr: '⇅',
  udblac: 'ű',
  udhar: '⥮',
  ufisht: '⥾',
  ufr: '𝔲',
  ugrav: 'ù',
  ugrave: 'ù',
  uharl: '↿',
  uharr: '↾',
  uhblk: '▀',
  ulcorn: '⌜',
  ulcorner: '⌜',
  ulcrop: '⌏',
  ultri: '◸',
  umacr: 'ū',
  um: '¨',
  uml: '¨',
  uogon: 'ų',
  uopf: '𝕦',
  uparrow: '↑',
  updownarrow: '↕',
  upharpoonleft: '↿',
  upharpoonright: '↾',
  uplus: '⊎',
  upsi: 'υ',
  upsih: 'ϒ',
  upsilon: 'υ',
  upuparrows: '⇈',
  urcorn: '⌝',
  urcorner: '⌝',
  urcrop: '⌎',
  uring: 'ů',
  urtri: '◹',
  uscr: '𝓊',
  utdot: '⋰',
  utilde: 'ũ',
  utri: '▵',
  utrif: '▴',
  uuarr: '⇈',
  uum: 'ü',
  uuml: 'ü',
  uwangle: '⦧',
  vArr: '⇕',
  vBar: '⫨',
  vBarv: '⫩',
  vDash: '⊨',
  vangrt: '⦜',
  varepsilon: 'ϵ',
  varkappa: 'ϰ',
  varnothing: '∅',
  varphi: 'ϕ',
  varpi: 'ϖ',
  varpropto: '∝',
  varr: '↕',
  varrho: 'ϱ',
  varsigma: 'ς',
  varsubsetneq: '⊊︀',
  varsubsetneqq: '⫋︀',
  varsupsetneq: '⊋︀',
  varsupsetneqq: '⫌︀',
  vartheta: 'ϑ',
  vartriangleleft: '⊲',
  vartriangleright: '⊳',
  vcy: 'в',
  vdash: '⊢',
  vee: '∨',
  veebar: '⊻',
  veeeq: '≚',
  vellip: '⋮',
  verbar: '|',
  vert: '|',
  vfr: '𝔳',
  vltri: '⊲',
  vnsub: '⊂⃒',
  vnsup: '⊃⃒',
  vopf: '𝕧',
  vprop: '∝',
  vrtri: '⊳',
  vscr: '𝓋',
  vsubnE: '⫋︀',
  vsubne: '⊊︀',
  vsupnE: '⫌︀',
  vsupne: '⊋︀',
  vzigzag: '⦚',
  wcirc: 'ŵ',
  wedbar: '⩟',
  wedge: '∧',
  wedgeq: '≙',
  weierp: '℘',
  wfr: '𝔴',
  wopf: '𝕨',
  wp: '℘',
  wr: '≀',
  wreath: '≀',
  wscr: '𝓌',
  xcap: '⋂',
  xcirc: '◯',
  xcup: '⋃',
  xdtri: '▽',
  xfr: '𝔵',
  xhArr: '⟺',
  xharr: '⟷',
  xi: 'ξ',
  xlArr: '⟸',
  xlarr: '⟵',
  xmap: '⟼',
  xnis: '⋻',
  xodot: '⨀',
  xopf: '𝕩',
  xoplus: '⨁',
  xotime: '⨂',
  xrArr: '⟹',
  xrarr: '⟶',
  xscr: '𝓍',
  xsqcup: '⨆',
  xuplus: '⨄',
  xutri: '△',
  xvee: '⋁',
  xwedge: '⋀',
  yacut: 'ý',
  yacute: 'ý',
  yacy: 'я',
  ycirc: 'ŷ',
  ycy: 'ы',
  ye: '¥',
  yen: '¥',
  yfr: '𝔶',
  yicy: 'ї',
  yopf: '𝕪',
  yscr: '𝓎',
  yucy: 'ю',
  yum: 'ÿ',
  yuml: 'ÿ',
  zacute: 'ź',
  zcaron: 'ž',
  zcy: 'з',
  zdot: 'ż',
  zeetrf: 'ℨ',
  zeta: 'ζ',
  zfr: '𝔷',
  zhcy: 'ж',
  zigrarr: '⇝',
  zopf: '𝕫',
  zscr: '𝓏',
  zwj: '‍',
  zwnj: '‌'
};

const own$8 = {}.hasOwnProperty;

/**
 * Decode a single character reference (without the `&` or `;`).
 * You probably only need this when you’re building parsers yourself that follow
 * different rules compared to HTML.
 * This is optimized to be tiny in browsers.
 *
 * @param {string} value
 *   `notin` (named), `#123` (deci), `#x123` (hexa).
 * @returns {string|false}
 *   Decoded reference.
 */
function decodeNamedCharacterReference(value) {
  return own$8.call(characterEntities, value) ? characterEntities[value] : false
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */

/** @type {Construct} */
const characterReference = {
  name: 'characterReference',
  tokenize: tokenizeCharacterReference
};
/** @type {Tokenizer} */

function tokenizeCharacterReference(effects, ok, nok) {
  const self = this;
  let size = 0;
  /** @type {number} */

  let max;
  /** @type {(code: Code) => code is number} */

  let test;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('characterReference');
    effects.enter('characterReferenceMarker');
    effects.consume(code);
    effects.exit('characterReferenceMarker');
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 35) {
      effects.enter('characterReferenceMarkerNumeric');
      effects.consume(code);
      effects.exit('characterReferenceMarkerNumeric');
      return numeric
    }

    effects.enter('characterReferenceValue');
    max = 31;
    test = asciiAlphanumeric;
    return value(code)
  }
  /** @type {State} */

  function numeric(code) {
    if (code === 88 || code === 120) {
      effects.enter('characterReferenceMarkerHexadecimal');
      effects.consume(code);
      effects.exit('characterReferenceMarkerHexadecimal');
      effects.enter('characterReferenceValue');
      max = 6;
      test = asciiHexDigit;
      return value
    }

    effects.enter('characterReferenceValue');
    max = 7;
    test = asciiDigit;
    return value(code)
  }
  /** @type {State} */

  function value(code) {
    /** @type {Token} */
    let token;

    if (code === 59 && size) {
      token = effects.exit('characterReferenceValue');

      if (
        test === asciiAlphanumeric &&
        !decodeNamedCharacterReference(self.sliceSerialize(token))
      ) {
        return nok(code)
      }

      effects.enter('characterReferenceMarker');
      effects.consume(code);
      effects.exit('characterReferenceMarker');
      effects.exit('characterReference');
      return ok
    }

    if (test(code) && size++ < max) {
      effects.consume(code);
      return value
    }

    return nok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */

/** @type {Construct} */
const codeFenced = {
  name: 'codeFenced',
  tokenize: tokenizeCodeFenced,
  concrete: true
};
/** @type {Tokenizer} */

function tokenizeCodeFenced(effects, ok, nok) {
  const self = this;
  /** @type {Construct} */

  const closingFenceConstruct = {
    tokenize: tokenizeClosingFence,
    partial: true
  };
  /** @type {Construct} */

  const nonLazyLine = {
    tokenize: tokenizeNonLazyLine,
    partial: true
  };
  const tail = this.events[this.events.length - 1];
  const initialPrefix =
    tail && tail[1].type === 'linePrefix'
      ? tail[2].sliceSerialize(tail[1], true).length
      : 0;
  let sizeOpen = 0;
  /** @type {NonNullable<Code>} */

  let marker;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('codeFenced');
    effects.enter('codeFencedFence');
    effects.enter('codeFencedFenceSequence');
    marker = code;
    return sequenceOpen(code)
  }
  /** @type {State} */

  function sequenceOpen(code) {
    if (code === marker) {
      effects.consume(code);
      sizeOpen++;
      return sequenceOpen
    }

    effects.exit('codeFencedFenceSequence');
    return sizeOpen < 3
      ? nok(code)
      : factorySpace(effects, infoOpen, 'whitespace')(code)
  }
  /** @type {State} */

  function infoOpen(code) {
    if (code === null || markdownLineEnding(code)) {
      return openAfter(code)
    }

    effects.enter('codeFencedFenceInfo');
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return info(code)
  }
  /** @type {State} */

  function info(code) {
    if (code === null || markdownLineEndingOrSpace(code)) {
      effects.exit('chunkString');
      effects.exit('codeFencedFenceInfo');
      return factorySpace(effects, infoAfter, 'whitespace')(code)
    }

    if (code === 96 && code === marker) return nok(code)
    effects.consume(code);
    return info
  }
  /** @type {State} */

  function infoAfter(code) {
    if (code === null || markdownLineEnding(code)) {
      return openAfter(code)
    }

    effects.enter('codeFencedFenceMeta');
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return meta(code)
  }
  /** @type {State} */

  function meta(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('chunkString');
      effects.exit('codeFencedFenceMeta');
      return openAfter(code)
    }

    if (code === 96 && code === marker) return nok(code)
    effects.consume(code);
    return meta
  }
  /** @type {State} */

  function openAfter(code) {
    effects.exit('codeFencedFence');
    return self.interrupt ? ok(code) : contentStart(code)
  }
  /** @type {State} */

  function contentStart(code) {
    if (code === null) {
      return after(code)
    }

    if (markdownLineEnding(code)) {
      return effects.attempt(
        nonLazyLine,
        effects.attempt(
          closingFenceConstruct,
          after,
          initialPrefix
            ? factorySpace(
                effects,
                contentStart,
                'linePrefix',
                initialPrefix + 1
              )
            : contentStart
        ),
        after
      )(code)
    }

    effects.enter('codeFlowValue');
    return contentContinue(code)
  }
  /** @type {State} */

  function contentContinue(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFlowValue');
      return contentStart(code)
    }

    effects.consume(code);
    return contentContinue
  }
  /** @type {State} */

  function after(code) {
    effects.exit('codeFenced');
    return ok(code)
  }
  /** @type {Tokenizer} */

  function tokenizeNonLazyLine(effects, ok, nok) {
    const self = this;
    return start
    /** @type {State} */

    function start(code) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return lineStart
    }
    /** @type {State} */

    function lineStart(code) {
      return self.parser.lazy[self.now().line] ? nok(code) : ok(code)
    }
  }
  /** @type {Tokenizer} */

  function tokenizeClosingFence(effects, ok, nok) {
    let size = 0;
    return factorySpace(
      effects,
      closingSequenceStart,
      'linePrefix',
      this.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )
    /** @type {State} */

    function closingSequenceStart(code) {
      effects.enter('codeFencedFence');
      effects.enter('codeFencedFenceSequence');
      return closingSequence(code)
    }
    /** @type {State} */

    function closingSequence(code) {
      if (code === marker) {
        effects.consume(code);
        size++;
        return closingSequence
      }

      if (size < sizeOpen) return nok(code)
      effects.exit('codeFencedFenceSequence');
      return factorySpace(effects, closingSequenceEnd, 'whitespace')(code)
    }
    /** @type {State} */

    function closingSequenceEnd(code) {
      if (code === null || markdownLineEnding(code)) {
        effects.exit('codeFencedFence');
        return ok(code)
      }

      return nok(code)
    }
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */
const codeIndented = {
  name: 'codeIndented',
  tokenize: tokenizeCodeIndented
};
/** @type {Construct} */

const indentedContent = {
  tokenize: tokenizeIndentedContent,
  partial: true
};
/** @type {Tokenizer} */

function tokenizeCodeIndented(effects, ok, nok) {
  const self = this;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('codeIndented');
    return factorySpace(effects, afterStartPrefix, 'linePrefix', 4 + 1)(code)
  }
  /** @type {State} */

  function afterStartPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
      ? afterPrefix(code)
      : nok(code)
  }
  /** @type {State} */

  function afterPrefix(code) {
    if (code === null) {
      return after(code)
    }

    if (markdownLineEnding(code)) {
      return effects.attempt(indentedContent, afterPrefix, after)(code)
    }

    effects.enter('codeFlowValue');
    return content(code)
  }
  /** @type {State} */

  function content(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFlowValue');
      return afterPrefix(code)
    }

    effects.consume(code);
    return content
  }
  /** @type {State} */

  function after(code) {
    effects.exit('codeIndented');
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeIndentedContent(effects, ok, nok) {
  const self = this;
  return start
  /** @type {State} */

  function start(code) {
    // If this is a lazy line, it can’t be code.
    if (self.parser.lazy[self.now().line]) {
      return nok(code)
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return start
    }

    return factorySpace(effects, afterPrefix, 'linePrefix', 4 + 1)(code)
  }
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
      ? ok(code)
      : markdownLineEnding(code)
      ? start(code)
      : nok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */
const codeText = {
  name: 'codeText',
  tokenize: tokenizeCodeText,
  resolve: resolveCodeText,
  previous: previous$1
};
/** @type {Resolver} */

function resolveCodeText(events) {
  let tailExitIndex = events.length - 4;
  let headEnterIndex = 3;
  /** @type {number} */

  let index;
  /** @type {number|undefined} */

  let enter; // If we start and end with an EOL or a space.

  if (
    (events[headEnterIndex][1].type === 'lineEnding' ||
      events[headEnterIndex][1].type === 'space') &&
    (events[tailExitIndex][1].type === 'lineEnding' ||
      events[tailExitIndex][1].type === 'space')
  ) {
    index = headEnterIndex; // And we have data.

    while (++index < tailExitIndex) {
      if (events[index][1].type === 'codeTextData') {
        // Then we have padding.
        events[headEnterIndex][1].type = 'codeTextPadding';
        events[tailExitIndex][1].type = 'codeTextPadding';
        headEnterIndex += 2;
        tailExitIndex -= 2;
        break
      }
    }
  } // Merge adjacent spaces and data.

  index = headEnterIndex - 1;
  tailExitIndex++;

  while (++index <= tailExitIndex) {
    if (enter === undefined) {
      if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') {
        enter = index;
      }
    } else if (
      index === tailExitIndex ||
      events[index][1].type === 'lineEnding'
    ) {
      events[enter][1].type = 'codeTextData';

      if (index !== enter + 2) {
        events[enter][1].end = events[index - 1][1].end;
        events.splice(enter + 2, index - enter - 2);
        tailExitIndex -= index - enter - 2;
        index = enter + 2;
      }

      enter = undefined;
    }
  }

  return events
}
/** @type {Previous} */

function previous$1(code) {
  // If there is a previous code, there will always be a tail.
  return (
    code !== 96 ||
    this.events[this.events.length - 1][1].type === 'characterEscape'
  )
}
/** @type {Tokenizer} */

function tokenizeCodeText(effects, ok, nok) {
  let sizeOpen = 0;
  /** @type {number} */

  let size;
  /** @type {Token} */

  let token;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('codeText');
    effects.enter('codeTextSequence');
    return openingSequence(code)
  }
  /** @type {State} */

  function openingSequence(code) {
    if (code === 96) {
      effects.consume(code);
      sizeOpen++;
      return openingSequence
    }

    effects.exit('codeTextSequence');
    return gap(code)
  }
  /** @type {State} */

  function gap(code) {
    // EOF.
    if (code === null) {
      return nok(code)
    } // Closing fence?
    // Could also be data.

    if (code === 96) {
      token = effects.enter('codeTextSequence');
      size = 0;
      return closingSequence(code)
    } // Tabs don’t work, and virtual spaces don’t make sense.

    if (code === 32) {
      effects.enter('space');
      effects.consume(code);
      effects.exit('space');
      return gap
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return gap
    } // Data.

    effects.enter('codeTextData');
    return data(code)
  } // In code.

  /** @type {State} */

  function data(code) {
    if (
      code === null ||
      code === 32 ||
      code === 96 ||
      markdownLineEnding(code)
    ) {
      effects.exit('codeTextData');
      return gap(code)
    }

    effects.consume(code);
    return data
  } // Closing fence.

  /** @type {State} */

  function closingSequence(code) {
    // More.
    if (code === 96) {
      effects.consume(code);
      size++;
      return closingSequence
    } // Done!

    if (size === sizeOpen) {
      effects.exit('codeTextSequence');
      effects.exit('codeText');
      return ok(code)
    } // More or less accents: mark as data.

    token.type = 'codeTextData';
    return data(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 */

/**
 * Tokenize subcontent.
 *
 * @param {Event[]} events
 * @returns {boolean}
 */
function subtokenize(events) {
  /** @type {Record<string, number>} */
  const jumps = {};
  let index = -1;
  /** @type {Event} */

  let event;
  /** @type {number|undefined} */

  let lineIndex;
  /** @type {number} */

  let otherIndex;
  /** @type {Event} */

  let otherEvent;
  /** @type {Event[]} */

  let parameters;
  /** @type {Event[]} */

  let subevents;
  /** @type {boolean|undefined} */

  let more;

  while (++index < events.length) {
    while (index in jumps) {
      index = jumps[index];
    }

    event = events[index]; // Add a hook for the GFM tasklist extension, which needs to know if text
    // is in the first content of a list item.

    if (
      index &&
      event[1].type === 'chunkFlow' &&
      events[index - 1][1].type === 'listItemPrefix'
    ) {
      subevents = event[1]._tokenizer.events;
      otherIndex = 0;

      if (
        otherIndex < subevents.length &&
        subevents[otherIndex][1].type === 'lineEndingBlank'
      ) {
        otherIndex += 2;
      }

      if (
        otherIndex < subevents.length &&
        subevents[otherIndex][1].type === 'content'
      ) {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === 'content') {
            break
          }

          if (subevents[otherIndex][1].type === 'chunkText') {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true;
            otherIndex++;
          }
        }
      }
    } // Enter.

    if (event[0] === 'enter') {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent(events, index));
        index = jumps[index];
        more = true;
      }
    } // Exit.
    else if (event[1]._container) {
      otherIndex = index;
      lineIndex = undefined;

      while (otherIndex--) {
        otherEvent = events[otherIndex];

        if (
          otherEvent[1].type === 'lineEnding' ||
          otherEvent[1].type === 'lineEndingBlank'
        ) {
          if (otherEvent[0] === 'enter') {
            if (lineIndex) {
              events[lineIndex][1].type = 'lineEndingBlank';
            }

            otherEvent[1].type = 'lineEnding';
            lineIndex = otherIndex;
          }
        } else {
          break
        }
      }

      if (lineIndex) {
        // Fix position.
        event[1].end = Object.assign({}, events[lineIndex][1].start); // Switch container exit w/ line endings.

        parameters = events.slice(lineIndex, index);
        parameters.unshift(event);
        splice(events, lineIndex, index - lineIndex + 1, parameters);
      }
    }
  }

  return !more
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Event[]} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */

function subcontent(events, eventIndex) {
  const token = events[eventIndex][1];
  const context = events[eventIndex][2];
  let startPosition = eventIndex - 1;
  /** @type {number[]} */

  const startPositions = [];
  const tokenizer =
    token._tokenizer || context.parser[token.contentType](token.start);
  const childEvents = tokenizer.events;
  /** @type {[number, number][]} */

  const jumps = [];
  /** @type {Record<string, number>} */

  const gaps = {};
  /** @type {Chunk[]} */

  let stream;
  /** @type {Token|undefined} */

  let previous;
  let index = -1;
  /** @type {Token|undefined} */

  let current = token;
  let adjust = 0;
  let start = 0;
  const breaks = [start]; // Loop forward through the linked tokens to pass them in order to the
  // subtokenizer.

  while (current) {
    // Find the position of the event for this token.
    while (events[++startPosition][1] !== current) {
      // Empty.
    }

    startPositions.push(startPosition);

    if (!current._tokenizer) {
      stream = context.sliceStream(current);

      if (!current.next) {
        stream.push(null);
      }

      if (previous) {
        tokenizer.defineSkip(current.start);
      }

      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true;
      }

      tokenizer.write(stream);

      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = undefined;
      }
    } // Unravel the next token.

    previous = current;
    current = current.next;
  } // Now, loop back through all events (and linked tokens), to figure out which
  // parts belong where.

  current = token;

  while (++index < childEvents.length) {
    if (
      // Find a void token that includes a break.
      childEvents[index][0] === 'exit' &&
      childEvents[index - 1][0] === 'enter' &&
      childEvents[index][1].type === childEvents[index - 1][1].type &&
      childEvents[index][1].start.line !== childEvents[index][1].end.line
    ) {
      start = index + 1;
      breaks.push(start); // Help GC.

      current._tokenizer = undefined;
      current.previous = undefined;
      current = current.next;
    }
  } // Help GC.

  tokenizer.events = []; // If there’s one more token (which is the cases for lines that end in an
  // EOF), that’s perfect: the last point we found starts it.
  // If there isn’t then make sure any remaining content is added to it.

  if (current) {
    // Help GC.
    current._tokenizer = undefined;
    current.previous = undefined;
  } else {
    breaks.pop();
  } // Now splice the events from the subtokenizer into the current events,
  // moving back to front so that splice indices aren’t affected.

  index = breaks.length;

  while (index--) {
    const slice = childEvents.slice(breaks[index], breaks[index + 1]);
    const start = startPositions.pop();
    jumps.unshift([start, start + slice.length - 1]);
    splice(events, start, 2, slice);
  }

  index = -1;

  while (++index < jumps.length) {
    gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
    adjust += jumps[index][1] - jumps[index][0] - 1;
  }

  return gaps
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */

/**
 * No name because it must not be turned off.
 * @type {Construct}
 */
const content = {
  tokenize: tokenizeContent,
  resolve: resolveContent
};
/** @type {Construct} */

const continuationConstruct = {
  tokenize: tokenizeContinuation,
  partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */

function resolveContent(events) {
  subtokenize(events);
  return events
}
/** @type {Tokenizer} */

function tokenizeContent(effects, ok) {
  /** @type {Token} */
  let previous;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('content');
    previous = effects.enter('chunkContent', {
      contentType: 'content'
    });
    return data(code)
  }
  /** @type {State} */

  function data(code) {
    if (code === null) {
      return contentEnd(code)
    }

    if (markdownLineEnding(code)) {
      return effects.check(
        continuationConstruct,
        contentContinue,
        contentEnd
      )(code)
    } // Data.

    effects.consume(code);
    return data
  }
  /** @type {State} */

  function contentEnd(code) {
    effects.exit('chunkContent');
    effects.exit('content');
    return ok(code)
  }
  /** @type {State} */

  function contentContinue(code) {
    effects.consume(code);
    effects.exit('chunkContent');
    previous.next = effects.enter('chunkContent', {
      contentType: 'content',
      previous
    });
    previous = previous.next;
    return data
  }
}
/** @type {Tokenizer} */

function tokenizeContinuation(effects, ok, nok) {
  const self = this;
  return startLookahead
  /** @type {State} */

  function startLookahead(code) {
    effects.exit('chunkContent');
    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    return factorySpace(effects, prefixed, 'linePrefix')
  }
  /** @type {State} */

  function prefixed(code) {
    if (code === null || markdownLineEnding(code)) {
      return nok(code)
    }

    const tail = self.events[self.events.length - 1];

    if (
      !self.parser.constructs.disable.null.includes('codeIndented') &&
      tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
    ) {
      return ok(code)
    }

    return effects.interrupt(self.parser.constructs.flow, nok, ok)(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */

/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 * @param {string} literalType
 * @param {string} literalMarkerType
 * @param {string} rawType
 * @param {string} stringType
 * @param {number} [max=Infinity]
 * @returns {State}
 */
// eslint-disable-next-line max-params
function factoryDestination(
  effects,
  ok,
  nok,
  type,
  literalType,
  literalMarkerType,
  rawType,
  stringType,
  max
) {
  const limit = max || Number.POSITIVE_INFINITY;
  let balance = 0;
  return start
  /** @type {State} */

  function start(code) {
    if (code === 60) {
      effects.enter(type);
      effects.enter(literalType);
      effects.enter(literalMarkerType);
      effects.consume(code);
      effects.exit(literalMarkerType);
      return destinationEnclosedBefore
    }

    if (code === null || code === 41 || asciiControl(code)) {
      return nok(code)
    }

    effects.enter(type);
    effects.enter(rawType);
    effects.enter(stringType);
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return destinationRaw(code)
  }
  /** @type {State} */

  function destinationEnclosedBefore(code) {
    if (code === 62) {
      effects.enter(literalMarkerType);
      effects.consume(code);
      effects.exit(literalMarkerType);
      effects.exit(literalType);
      effects.exit(type);
      return ok
    }

    effects.enter(stringType);
    effects.enter('chunkString', {
      contentType: 'string'
    });
    return destinationEnclosed(code)
  }
  /** @type {State} */

  function destinationEnclosed(code) {
    if (code === 62) {
      effects.exit('chunkString');
      effects.exit(stringType);
      return destinationEnclosedBefore(code)
    }

    if (code === null || code === 60 || markdownLineEnding(code)) {
      return nok(code)
    }

    effects.consume(code);
    return code === 92 ? destinationEnclosedEscape : destinationEnclosed
  }
  /** @type {State} */

  function destinationEnclosedEscape(code) {
    if (code === 60 || code === 62 || code === 92) {
      effects.consume(code);
      return destinationEnclosed
    }

    return destinationEnclosed(code)
  }
  /** @type {State} */

  function destinationRaw(code) {
    if (code === 40) {
      if (++balance > limit) return nok(code)
      effects.consume(code);
      return destinationRaw
    }

    if (code === 41) {
      if (!balance--) {
        effects.exit('chunkString');
        effects.exit(stringType);
        effects.exit(rawType);
        effects.exit(type);
        return ok(code)
      }

      effects.consume(code);
      return destinationRaw
    }

    if (code === null || markdownLineEndingOrSpace(code)) {
      if (balance) return nok(code)
      effects.exit('chunkString');
      effects.exit(stringType);
      effects.exit(rawType);
      effects.exit(type);
      return ok(code)
    }

    if (asciiControl(code)) return nok(code)
    effects.consume(code);
    return code === 92 ? destinationRawEscape : destinationRaw
  }
  /** @type {State} */

  function destinationRawEscape(code) {
    if (code === 40 || code === 41 || code === 92) {
      effects.consume(code);
      return destinationRaw
    }

    return destinationRaw(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').State} State
 */

/**
 * @this {TokenizeContext}
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 * @param {string} markerType
 * @param {string} stringType
 * @returns {State}
 */
// eslint-disable-next-line max-params
function factoryLabel(effects, ok, nok, type, markerType, stringType) {
  const self = this;
  let size = 0;
  /** @type {boolean} */

  let data;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code);
    effects.exit(markerType);
    effects.enter(stringType);
    return atBreak
  }
  /** @type {State} */

  function atBreak(code) {
    if (
      code === null ||
      code === 91 ||
      (code === 93 && !data) ||
      /* To do: remove in the future once we’ve switched from
       * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
       * which doesn’t need this */

      /* Hidden footnotes hook */

      /* c8 ignore next 3 */
      (code === 94 &&
        !size &&
        '_hiddenFootnoteSupport' in self.parser.constructs) ||
      size > 999
    ) {
      return nok(code)
    }

    if (code === 93) {
      effects.exit(stringType);
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      effects.exit(type);
      return ok
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return atBreak
    }

    effects.enter('chunkString', {
      contentType: 'string'
    });
    return label(code)
  }
  /** @type {State} */

  function label(code) {
    if (
      code === null ||
      code === 91 ||
      code === 93 ||
      markdownLineEnding(code) ||
      size++ > 999
    ) {
      effects.exit('chunkString');
      return atBreak(code)
    }

    effects.consume(code);
    data = data || !markdownSpace(code);
    return code === 92 ? labelEscape : label
  }
  /** @type {State} */

  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code);
      size++;
      return label
    }

    return label(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * @param {Effects} effects
 * @param {State} ok
 * @param {State} nok
 * @param {string} type
 * @param {string} markerType
 * @param {string} stringType
 * @returns {State}
 */
// eslint-disable-next-line max-params
function factoryTitle(effects, ok, nok, type, markerType, stringType) {
  /** @type {NonNullable<Code>} */
  let marker;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code);
    effects.exit(markerType);
    marker = code === 40 ? 41 : code;
    return atFirstTitleBreak
  }
  /** @type {State} */

  function atFirstTitleBreak(code) {
    if (code === marker) {
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      effects.exit(type);
      return ok
    }

    effects.enter(stringType);
    return atTitleBreak(code)
  }
  /** @type {State} */

  function atTitleBreak(code) {
    if (code === marker) {
      effects.exit(stringType);
      return atFirstTitleBreak(marker)
    }

    if (code === null) {
      return nok(code)
    } // Note: blank lines can’t exist in content.

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return factorySpace(effects, atTitleBreak, 'linePrefix')
    }

    effects.enter('chunkString', {
      contentType: 'string'
    });
    return title(code)
  }
  /** @type {State} */

  function title(code) {
    if (code === marker || code === null || markdownLineEnding(code)) {
      effects.exit('chunkString');
      return atTitleBreak(code)
    }

    effects.consume(code);
    return code === 92 ? titleEscape : title
  }
  /** @type {State} */

  function titleEscape(code) {
    if (code === marker || code === 92) {
      effects.consume(code);
      return title
    }

    return title(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */

/**
 * @param {Effects} effects
 * @param {State} ok
 */
function factoryWhitespace(effects, ok) {
  /** @type {boolean} */
  let seen;
  return start
  /** @type {State} */

  function start(code) {
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      seen = true;
      return start
    }

    if (markdownSpace(code)) {
      return factorySpace(
        effects,
        start,
        seen ? 'linePrefix' : 'lineSuffix'
      )(code)
    }

    return ok(code)
  }
}

/**
 * Normalize an identifier (such as used in definitions).
 *
 * @param {string} value
 * @returns {string}
 */
function normalizeIdentifier(value) {
  return (
    value // Collapse Markdown whitespace.
      .replace(/[\t\n\r ]+/g, ' ') // Trim.
      .replace(/^ | $/g, '') // Some characters are considered “uppercase”, but if their lowercase
      // counterpart is uppercased will result in a different uppercase
      // character.
      // Hence, to get that form, we perform both lower- and uppercase.
      // Upper case makes sure keys will not interact with default prototypal
      // methods: no method is uppercase.
      .toLowerCase()
      .toUpperCase()
  )
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */
const definition = {
  name: 'definition',
  tokenize: tokenizeDefinition
};
/** @type {Construct} */

const titleConstruct = {
  tokenize: tokenizeTitle,
  partial: true
};
/** @type {Tokenizer} */

function tokenizeDefinition(effects, ok, nok) {
  const self = this;
  /** @type {string} */

  let identifier;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('definition');
    return factoryLabel.call(
      self,
      effects,
      labelAfter,
      nok,
      'definitionLabel',
      'definitionLabelMarker',
      'definitionLabelString'
    )(code)
  }
  /** @type {State} */

  function labelAfter(code) {
    identifier = normalizeIdentifier(
      self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1)
    );

    if (code === 58) {
      effects.enter('definitionMarker');
      effects.consume(code);
      effects.exit('definitionMarker'); // Note: blank lines can’t exist in content.

      return factoryWhitespace(
        effects,
        factoryDestination(
          effects,
          effects.attempt(
            titleConstruct,
            factorySpace(effects, after, 'whitespace'),
            factorySpace(effects, after, 'whitespace')
          ),
          nok,
          'definitionDestination',
          'definitionDestinationLiteral',
          'definitionDestinationLiteralMarker',
          'definitionDestinationRaw',
          'definitionDestinationString'
        )
      )
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('definition');

      if (!self.parser.defined.includes(identifier)) {
        self.parser.defined.push(identifier);
      }

      return ok(code)
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeTitle(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, before)(code)
      : nok(code)
  }
  /** @type {State} */

  function before(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(
        effects,
        factorySpace(effects, after, 'whitespace'),
        nok,
        'definitionTitle',
        'definitionTitleMarker',
        'definitionTitleString'
      )(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */
const hardBreakEscape = {
  name: 'hardBreakEscape',
  tokenize: tokenizeHardBreakEscape
};
/** @type {Tokenizer} */

function tokenizeHardBreakEscape(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('hardBreakEscape');
    effects.enter('escapeMarker');
    effects.consume(code);
    return open
  }
  /** @type {State} */

  function open(code) {
    if (markdownLineEnding(code)) {
      effects.exit('escapeMarker');
      effects.exit('hardBreakEscape');
      return ok(code)
    }

    return nok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */
const headingAtx = {
  name: 'headingAtx',
  tokenize: tokenizeHeadingAtx,
  resolve: resolveHeadingAtx
};
/** @type {Resolver} */

function resolveHeadingAtx(events, context) {
  let contentEnd = events.length - 2;
  let contentStart = 3;
  /** @type {Token} */

  let content;
  /** @type {Token} */

  let text; // Prefix whitespace, part of the opening.

  if (events[contentStart][1].type === 'whitespace') {
    contentStart += 2;
  } // Suffix whitespace, part of the closing.

  if (
    contentEnd - 2 > contentStart &&
    events[contentEnd][1].type === 'whitespace'
  ) {
    contentEnd -= 2;
  }

  if (
    events[contentEnd][1].type === 'atxHeadingSequence' &&
    (contentStart === contentEnd - 1 ||
      (contentEnd - 4 > contentStart &&
        events[contentEnd - 2][1].type === 'whitespace'))
  ) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
  }

  if (contentEnd > contentStart) {
    content = {
      type: 'atxHeadingText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end
    };
    text = {
      type: 'chunkText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end,
      // @ts-expect-error Constants are fine to assign.
      contentType: 'text'
    };
    splice(events, contentStart, contentEnd - contentStart + 1, [
      ['enter', content, context],
      ['enter', text, context],
      ['exit', text, context],
      ['exit', content, context]
    ]);
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeHeadingAtx(effects, ok, nok) {
  const self = this;
  let size = 0;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('atxHeading');
    effects.enter('atxHeadingSequence');
    return fenceOpenInside(code)
  }
  /** @type {State} */

  function fenceOpenInside(code) {
    if (code === 35 && size++ < 6) {
      effects.consume(code);
      return fenceOpenInside
    }

    if (code === null || markdownLineEndingOrSpace(code)) {
      effects.exit('atxHeadingSequence');
      return self.interrupt ? ok(code) : headingBreak(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function headingBreak(code) {
    if (code === 35) {
      effects.enter('atxHeadingSequence');
      return sequence(code)
    }

    if (code === null || markdownLineEnding(code)) {
      effects.exit('atxHeading');
      return ok(code)
    }

    if (markdownSpace(code)) {
      return factorySpace(effects, headingBreak, 'whitespace')(code)
    }

    effects.enter('atxHeadingText');
    return data(code)
  }
  /** @type {State} */

  function sequence(code) {
    if (code === 35) {
      effects.consume(code);
      return sequence
    }

    effects.exit('atxHeadingSequence');
    return headingBreak(code)
  }
  /** @type {State} */

  function data(code) {
    if (code === null || code === 35 || markdownLineEndingOrSpace(code)) {
      effects.exit('atxHeadingText');
      return headingBreak(code)
    }

    effects.consume(code);
    return data
  }
}

/**
 * List of lowercase HTML tag names which when parsing HTML (flow), result
 * in more relaxed rules (condition 6): because they are known blocks, the
 * HTML-like syntax doesn’t have to be strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.29/#html-blocks>.
 */
const htmlBlockNames = [
  'address',
  'article',
  'aside',
  'base',
  'basefont',
  'blockquote',
  'body',
  'caption',
  'center',
  'col',
  'colgroup',
  'dd',
  'details',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  'iframe',
  'legend',
  'li',
  'link',
  'main',
  'menu',
  'menuitem',
  'nav',
  'noframes',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'section',
  'source',
  'summary',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'track',
  'ul'
];

/**
 * List of lowercase HTML tag names which when parsing HTML (flow), result in
 * HTML that can include lines w/o exiting, until a closing tag also in this
 * list is found (condition 1).
 *
 * This module is copied from:
 * <https://spec.commonmark.org/0.29/#html-blocks>.
 *
 * Note that `textarea` is not available in `CommonMark@0.29` but has been
 * merged to the primary branch and is slated to be released in the next release
 * of CommonMark.
 */
const htmlRawNames = ['pre', 'script', 'style', 'textarea'];

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */
/** @type {Construct} */

const htmlFlow = {
  name: 'htmlFlow',
  tokenize: tokenizeHtmlFlow,
  resolveTo: resolveToHtmlFlow,
  concrete: true
};
/** @type {Construct} */

const nextBlankConstruct = {
  tokenize: tokenizeNextBlank,
  partial: true
};
/** @type {Resolver} */

function resolveToHtmlFlow(events) {
  let index = events.length;

  while (index--) {
    if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') {
      break
    }
  }

  if (index > 1 && events[index - 2][1].type === 'linePrefix') {
    // Add the prefix start to the HTML token.
    events[index][1].start = events[index - 2][1].start; // Add the prefix start to the HTML line token.

    events[index + 1][1].start = events[index - 2][1].start; // Remove the line prefix.

    events.splice(index - 2, 2);
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeHtmlFlow(effects, ok, nok) {
  const self = this;
  /** @type {number} */

  let kind;
  /** @type {boolean} */

  let startTag;
  /** @type {string} */

  let buffer;
  /** @type {number} */

  let index;
  /** @type {Code} */

  let marker;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('htmlFlow');
    effects.enter('htmlFlowData');
    effects.consume(code);
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 33) {
      effects.consume(code);
      return declarationStart
    }

    if (code === 47) {
      effects.consume(code);
      return tagCloseStart
    }

    if (code === 63) {
      effects.consume(code);
      kind = 3; // While we’re in an instruction instead of a declaration, we’re on a `?`
      // right now, so we do need to search for `>`, similar to declarations.

      return self.interrupt ? ok : continuationDeclarationInside
    }

    if (asciiAlpha(code)) {
      effects.consume(code);
      buffer = String.fromCharCode(code);
      startTag = true;
      return tagName
    }

    return nok(code)
  }
  /** @type {State} */

  function declarationStart(code) {
    if (code === 45) {
      effects.consume(code);
      kind = 2;
      return commentOpenInside
    }

    if (code === 91) {
      effects.consume(code);
      kind = 5;
      buffer = 'CDATA[';
      index = 0;
      return cdataOpenInside
    }

    if (asciiAlpha(code)) {
      effects.consume(code);
      kind = 4;
      return self.interrupt ? ok : continuationDeclarationInside
    }

    return nok(code)
  }
  /** @type {State} */

  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code);
      return self.interrupt ? ok : continuationDeclarationInside
    }

    return nok(code)
  }
  /** @type {State} */

  function cdataOpenInside(code) {
    if (code === buffer.charCodeAt(index++)) {
      effects.consume(code);
      return index === buffer.length
        ? self.interrupt
          ? ok
          : continuation
        : cdataOpenInside
    }

    return nok(code)
  }
  /** @type {State} */

  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      effects.consume(code);
      buffer = String.fromCharCode(code);
      return tagName
    }

    return nok(code)
  }
  /** @type {State} */

  function tagName(code) {
    if (
      code === null ||
      code === 47 ||
      code === 62 ||
      markdownLineEndingOrSpace(code)
    ) {
      if (
        code !== 47 &&
        startTag &&
        htmlRawNames.includes(buffer.toLowerCase())
      ) {
        kind = 1;
        return self.interrupt ? ok(code) : continuation(code)
      }

      if (htmlBlockNames.includes(buffer.toLowerCase())) {
        kind = 6;

        if (code === 47) {
          effects.consume(code);
          return basicSelfClosing
        }

        return self.interrupt ? ok(code) : continuation(code)
      }

      kind = 7; // Do not support complete HTML when interrupting

      return self.interrupt && !self.parser.lazy[self.now().line]
        ? nok(code)
        : startTag
        ? completeAttributeNameBefore(code)
        : completeClosingTagAfter(code)
    }

    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code);
      buffer += String.fromCharCode(code);
      return tagName
    }

    return nok(code)
  }
  /** @type {State} */

  function basicSelfClosing(code) {
    if (code === 62) {
      effects.consume(code);
      return self.interrupt ? ok : continuation
    }

    return nok(code)
  }
  /** @type {State} */

  function completeClosingTagAfter(code) {
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeClosingTagAfter
    }

    return completeEnd(code)
  }
  /** @type {State} */

  function completeAttributeNameBefore(code) {
    if (code === 47) {
      effects.consume(code);
      return completeEnd
    }

    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code);
      return completeAttributeName
    }

    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAttributeNameBefore
    }

    return completeEnd(code)
  }
  /** @type {State} */

  function completeAttributeName(code) {
    if (
      code === 45 ||
      code === 46 ||
      code === 58 ||
      code === 95 ||
      asciiAlphanumeric(code)
    ) {
      effects.consume(code);
      return completeAttributeName
    }

    return completeAttributeNameAfter(code)
  }
  /** @type {State} */

  function completeAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code);
      return completeAttributeValueBefore
    }

    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAttributeNameAfter
    }

    return completeAttributeNameBefore(code)
  }
  /** @type {State} */

  function completeAttributeValueBefore(code) {
    if (
      code === null ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }

    if (code === 34 || code === 39) {
      effects.consume(code);
      marker = code;
      return completeAttributeValueQuoted
    }

    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAttributeValueBefore
    }

    marker = null;
    return completeAttributeValueUnquoted(code)
  }
  /** @type {State} */

  function completeAttributeValueQuoted(code) {
    if (code === null || markdownLineEnding(code)) {
      return nok(code)
    }

    if (code === marker) {
      effects.consume(code);
      return completeAttributeValueQuotedAfter
    }

    effects.consume(code);
    return completeAttributeValueQuoted
  }
  /** @type {State} */

  function completeAttributeValueUnquoted(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96 ||
      markdownLineEndingOrSpace(code)
    ) {
      return completeAttributeNameAfter(code)
    }

    effects.consume(code);
    return completeAttributeValueUnquoted
  }
  /** @type {State} */

  function completeAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownSpace(code)) {
      return completeAttributeNameBefore(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function completeEnd(code) {
    if (code === 62) {
      effects.consume(code);
      return completeAfter
    }

    return nok(code)
  }
  /** @type {State} */

  function completeAfter(code) {
    if (markdownSpace(code)) {
      effects.consume(code);
      return completeAfter
    }

    return code === null || markdownLineEnding(code)
      ? continuation(code)
      : nok(code)
  }
  /** @type {State} */

  function continuation(code) {
    if (code === 45 && kind === 2) {
      effects.consume(code);
      return continuationCommentInside
    }

    if (code === 60 && kind === 1) {
      effects.consume(code);
      return continuationRawTagOpen
    }

    if (code === 62 && kind === 4) {
      effects.consume(code);
      return continuationClose
    }

    if (code === 63 && kind === 3) {
      effects.consume(code);
      return continuationDeclarationInside
    }

    if (code === 93 && kind === 5) {
      effects.consume(code);
      return continuationCharacterDataInside
    }

    if (markdownLineEnding(code) && (kind === 6 || kind === 7)) {
      return effects.check(
        nextBlankConstruct,
        continuationClose,
        continuationAtLineEnding
      )(code)
    }

    if (code === null || markdownLineEnding(code)) {
      return continuationAtLineEnding(code)
    }

    effects.consume(code);
    return continuation
  }
  /** @type {State} */

  function continuationAtLineEnding(code) {
    effects.exit('htmlFlowData');
    return htmlContinueStart(code)
  }
  /** @type {State} */

  function htmlContinueStart(code) {
    if (code === null) {
      return done(code)
    }

    if (markdownLineEnding(code)) {
      return effects.attempt(
        {
          tokenize: htmlLineEnd,
          partial: true
        },
        htmlContinueStart,
        done
      )(code)
    }

    effects.enter('htmlFlowData');
    return continuation(code)
  }
  /** @type {Tokenizer} */

  function htmlLineEnd(effects, ok, nok) {
    return start
    /** @type {State} */

    function start(code) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return lineStart
    }
    /** @type {State} */

    function lineStart(code) {
      return self.parser.lazy[self.now().line] ? nok(code) : ok(code)
    }
  }
  /** @type {State} */

  function continuationCommentInside(code) {
    if (code === 45) {
      effects.consume(code);
      return continuationDeclarationInside
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationRawTagOpen(code) {
    if (code === 47) {
      effects.consume(code);
      buffer = '';
      return continuationRawEndTag
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationRawEndTag(code) {
    if (code === 62 && htmlRawNames.includes(buffer.toLowerCase())) {
      effects.consume(code);
      return continuationClose
    }

    if (asciiAlpha(code) && buffer.length < 8) {
      effects.consume(code);
      buffer += String.fromCharCode(code);
      return continuationRawEndTag
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationCharacterDataInside(code) {
    if (code === 93) {
      effects.consume(code);
      return continuationDeclarationInside
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationDeclarationInside(code) {
    if (code === 62) {
      effects.consume(code);
      return continuationClose
    } // More dashes.

    if (code === 45 && kind === 2) {
      effects.consume(code);
      return continuationDeclarationInside
    }

    return continuation(code)
  }
  /** @type {State} */

  function continuationClose(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('htmlFlowData');
      return done(code)
    }

    effects.consume(code);
    return continuationClose
  }
  /** @type {State} */

  function done(code) {
    effects.exit('htmlFlow');
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeNextBlank(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.exit('htmlFlowData');
    effects.enter('lineEndingBlank');
    effects.consume(code);
    effects.exit('lineEndingBlank');
    return effects.attempt(blankLine, ok, nok)
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */

/** @type {Construct} */
const htmlText = {
  name: 'htmlText',
  tokenize: tokenizeHtmlText
};
/** @type {Tokenizer} */

function tokenizeHtmlText(effects, ok, nok) {
  const self = this;
  /** @type {NonNullable<Code>|undefined} */

  let marker;
  /** @type {string} */

  let buffer;
  /** @type {number} */

  let index;
  /** @type {State} */

  let returnState;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('htmlText');
    effects.enter('htmlTextData');
    effects.consume(code);
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 33) {
      effects.consume(code);
      return declarationOpen
    }

    if (code === 47) {
      effects.consume(code);
      return tagCloseStart
    }

    if (code === 63) {
      effects.consume(code);
      return instruction
    }

    if (asciiAlpha(code)) {
      effects.consume(code);
      return tagOpen
    }

    return nok(code)
  }
  /** @type {State} */

  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code);
      return commentOpen
    }

    if (code === 91) {
      effects.consume(code);
      buffer = 'CDATA[';
      index = 0;
      return cdataOpen
    }

    if (asciiAlpha(code)) {
      effects.consume(code);
      return declaration
    }

    return nok(code)
  }
  /** @type {State} */

  function commentOpen(code) {
    if (code === 45) {
      effects.consume(code);
      return commentStart
    }

    return nok(code)
  }
  /** @type {State} */

  function commentStart(code) {
    if (code === null || code === 62) {
      return nok(code)
    }

    if (code === 45) {
      effects.consume(code);
      return commentStartDash
    }

    return comment(code)
  }
  /** @type {State} */

  function commentStartDash(code) {
    if (code === null || code === 62) {
      return nok(code)
    }

    return comment(code)
  }
  /** @type {State} */

  function comment(code) {
    if (code === null) {
      return nok(code)
    }

    if (code === 45) {
      effects.consume(code);
      return commentClose
    }

    if (markdownLineEnding(code)) {
      returnState = comment;
      return atLineEnding(code)
    }

    effects.consume(code);
    return comment
  }
  /** @type {State} */

  function commentClose(code) {
    if (code === 45) {
      effects.consume(code);
      return end
    }

    return comment(code)
  }
  /** @type {State} */

  function cdataOpen(code) {
    if (code === buffer.charCodeAt(index++)) {
      effects.consume(code);
      return index === buffer.length ? cdata : cdataOpen
    }

    return nok(code)
  }
  /** @type {State} */

  function cdata(code) {
    if (code === null) {
      return nok(code)
    }

    if (code === 93) {
      effects.consume(code);
      return cdataClose
    }

    if (markdownLineEnding(code)) {
      returnState = cdata;
      return atLineEnding(code)
    }

    effects.consume(code);
    return cdata
  }
  /** @type {State} */

  function cdataClose(code) {
    if (code === 93) {
      effects.consume(code);
      return cdataEnd
    }

    return cdata(code)
  }
  /** @type {State} */

  function cdataEnd(code) {
    if (code === 62) {
      return end(code)
    }

    if (code === 93) {
      effects.consume(code);
      return cdataEnd
    }

    return cdata(code)
  }
  /** @type {State} */

  function declaration(code) {
    if (code === null || code === 62) {
      return end(code)
    }

    if (markdownLineEnding(code)) {
      returnState = declaration;
      return atLineEnding(code)
    }

    effects.consume(code);
    return declaration
  }
  /** @type {State} */

  function instruction(code) {
    if (code === null) {
      return nok(code)
    }

    if (code === 63) {
      effects.consume(code);
      return instructionClose
    }

    if (markdownLineEnding(code)) {
      returnState = instruction;
      return atLineEnding(code)
    }

    effects.consume(code);
    return instruction
  }
  /** @type {State} */

  function instructionClose(code) {
    return code === 62 ? end(code) : instruction(code)
  }
  /** @type {State} */

  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      effects.consume(code);
      return tagClose
    }

    return nok(code)
  }
  /** @type {State} */

  function tagClose(code) {
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return tagClose
    }

    return tagCloseBetween(code)
  }
  /** @type {State} */

  function tagCloseBetween(code) {
    if (markdownLineEnding(code)) {
      returnState = tagCloseBetween;
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code);
      return tagCloseBetween
    }

    return end(code)
  }
  /** @type {State} */

  function tagOpen(code) {
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code);
      return tagOpen
    }

    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function tagOpenBetween(code) {
    if (code === 47) {
      effects.consume(code);
      return end
    }

    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code);
      return tagOpenAttributeName
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenBetween;
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code);
      return tagOpenBetween
    }

    return end(code)
  }
  /** @type {State} */

  function tagOpenAttributeName(code) {
    if (
      code === 45 ||
      code === 46 ||
      code === 58 ||
      code === 95 ||
      asciiAlphanumeric(code)
    ) {
      effects.consume(code);
      return tagOpenAttributeName
    }

    return tagOpenAttributeNameAfter(code)
  }
  /** @type {State} */

  function tagOpenAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code);
      return tagOpenAttributeValueBefore
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeNameAfter;
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code);
      return tagOpenAttributeNameAfter
    }

    return tagOpenBetween(code)
  }
  /** @type {State} */

  function tagOpenAttributeValueBefore(code) {
    if (
      code === null ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }

    if (code === 34 || code === 39) {
      effects.consume(code);
      marker = code;
      return tagOpenAttributeValueQuoted
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueBefore;
      return atLineEnding(code)
    }

    if (markdownSpace(code)) {
      effects.consume(code);
      return tagOpenAttributeValueBefore
    }

    effects.consume(code);
    marker = undefined;
    return tagOpenAttributeValueUnquoted
  }
  /** @type {State} */

  function tagOpenAttributeValueQuoted(code) {
    if (code === marker) {
      effects.consume(code);
      return tagOpenAttributeValueQuotedAfter
    }

    if (code === null) {
      return nok(code)
    }

    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueQuoted;
      return atLineEnding(code)
    }

    effects.consume(code);
    return tagOpenAttributeValueQuoted
  }
  /** @type {State} */

  function tagOpenAttributeValueQuotedAfter(code) {
    if (code === 62 || code === 47 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function tagOpenAttributeValueUnquoted(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 60 ||
      code === 61 ||
      code === 96
    ) {
      return nok(code)
    }

    if (code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }

    effects.consume(code);
    return tagOpenAttributeValueUnquoted
  } // We can’t have blank lines in content, so no need to worry about empty
  // tokens.

  /** @type {State} */

  function atLineEnding(code) {
    effects.exit('htmlTextData');
    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    return factorySpace(
      effects,
      afterPrefix,
      'linePrefix',
      self.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )
  }
  /** @type {State} */

  function afterPrefix(code) {
    effects.enter('htmlTextData');
    return returnState(code)
  }
  /** @type {State} */

  function end(code) {
    if (code === 62) {
      effects.consume(code);
      effects.exit('htmlTextData');
      effects.exit('htmlText');
      return ok
    }

    return nok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */

/** @type {Construct} */
const labelEnd = {
  name: 'labelEnd',
  tokenize: tokenizeLabelEnd,
  resolveTo: resolveToLabelEnd,
  resolveAll: resolveAllLabelEnd
};
/** @type {Construct} */

const resourceConstruct = {
  tokenize: tokenizeResource
};
/** @type {Construct} */

const fullReferenceConstruct = {
  tokenize: tokenizeFullReference
};
/** @type {Construct} */

const collapsedReferenceConstruct = {
  tokenize: tokenizeCollapsedReference
};
/** @type {Resolver} */

function resolveAllLabelEnd(events) {
  let index = -1;
  /** @type {Token} */

  let token;

  while (++index < events.length) {
    token = events[index][1];

    if (
      token.type === 'labelImage' ||
      token.type === 'labelLink' ||
      token.type === 'labelEnd'
    ) {
      // Remove the marker.
      events.splice(index + 1, token.type === 'labelImage' ? 4 : 2);
      token.type = 'data';
      index++;
    }
  }

  return events
}
/** @type {Resolver} */

function resolveToLabelEnd(events, context) {
  let index = events.length;
  let offset = 0;
  /** @type {Token} */

  let token;
  /** @type {number|undefined} */

  let open;
  /** @type {number|undefined} */

  let close;
  /** @type {Event[]} */

  let media; // Find an opening.

  while (index--) {
    token = events[index][1];

    if (open) {
      // If we see another link, or inactive link label, we’ve been here before.
      if (
        token.type === 'link' ||
        (token.type === 'labelLink' && token._inactive)
      ) {
        break
      } // Mark other link openings as inactive, as we can’t have links in
      // links.

      if (events[index][0] === 'enter' && token.type === 'labelLink') {
        token._inactive = true;
      }
    } else if (close) {
      if (
        events[index][0] === 'enter' &&
        (token.type === 'labelImage' || token.type === 'labelLink') &&
        !token._balanced
      ) {
        open = index;

        if (token.type !== 'labelLink') {
          offset = 2;
          break
        }
      }
    } else if (token.type === 'labelEnd') {
      close = index;
    }
  }

  const group = {
    type: events[open][1].type === 'labelLink' ? 'link' : 'image',
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  };
  const label = {
    type: 'label',
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[close][1].end)
  };
  const text = {
    type: 'labelText',
    start: Object.assign({}, events[open + offset + 2][1].end),
    end: Object.assign({}, events[close - 2][1].start)
  };
  media = [
    ['enter', group, context],
    ['enter', label, context]
  ]; // Opening marker.

  media = push(media, events.slice(open + 1, open + offset + 3)); // Text open.

  media = push(media, [['enter', text, context]]); // Between.

  media = push(
    media,
    resolveAll(
      context.parser.constructs.insideSpan.null,
      events.slice(open + offset + 4, close - 3),
      context
    )
  ); // Text close, marker close, label close.

  media = push(media, [
    ['exit', text, context],
    events[close - 2],
    events[close - 1],
    ['exit', label, context]
  ]); // Reference, resource, or so.

  media = push(media, events.slice(close + 1)); // Media close.

  media = push(media, [['exit', group, context]]);
  splice(events, open, events.length, media);
  return events
}
/** @type {Tokenizer} */

function tokenizeLabelEnd(effects, ok, nok) {
  const self = this;
  let index = self.events.length;
  /** @type {Token} */

  let labelStart;
  /** @type {boolean} */

  let defined; // Find an opening.

  while (index--) {
    if (
      (self.events[index][1].type === 'labelImage' ||
        self.events[index][1].type === 'labelLink') &&
      !self.events[index][1]._balanced
    ) {
      labelStart = self.events[index][1];
      break
    }
  }

  return start
  /** @type {State} */

  function start(code) {
    if (!labelStart) {
      return nok(code)
    } // It’s a balanced bracket, but contains a link.

    if (labelStart._inactive) return balanced(code)
    defined = self.parser.defined.includes(
      normalizeIdentifier(
        self.sliceSerialize({
          start: labelStart.end,
          end: self.now()
        })
      )
    );
    effects.enter('labelEnd');
    effects.enter('labelMarker');
    effects.consume(code);
    effects.exit('labelMarker');
    effects.exit('labelEnd');
    return afterLabelEnd
  }
  /** @type {State} */

  function afterLabelEnd(code) {
    // Resource: `[asd](fgh)`.
    if (code === 40) {
      return effects.attempt(
        resourceConstruct,
        ok,
        defined ? ok : balanced
      )(code)
    } // Collapsed (`[asd][]`) or full (`[asd][fgh]`) reference?

    if (code === 91) {
      return effects.attempt(
        fullReferenceConstruct,
        ok,
        defined
          ? effects.attempt(collapsedReferenceConstruct, ok, balanced)
          : balanced
      )(code)
    } // Shortcut reference: `[asd]`?

    return defined ? ok(code) : balanced(code)
  }
  /** @type {State} */

  function balanced(code) {
    labelStart._balanced = true;
    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeResource(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('resource');
    effects.enter('resourceMarker');
    effects.consume(code);
    effects.exit('resourceMarker');
    return factoryWhitespace(effects, open)
  }
  /** @type {State} */

  function open(code) {
    if (code === 41) {
      return end(code)
    }

    return factoryDestination(
      effects,
      destinationAfter,
      nok,
      'resourceDestination',
      'resourceDestinationLiteral',
      'resourceDestinationLiteralMarker',
      'resourceDestinationRaw',
      'resourceDestinationString',
      32
    )(code)
  }
  /** @type {State} */

  function destinationAfter(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, between)(code)
      : end(code)
  }
  /** @type {State} */

  function between(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(
        effects,
        factoryWhitespace(effects, end),
        nok,
        'resourceTitle',
        'resourceTitleMarker',
        'resourceTitleString'
      )(code)
    }

    return end(code)
  }
  /** @type {State} */

  function end(code) {
    if (code === 41) {
      effects.enter('resourceMarker');
      effects.consume(code);
      effects.exit('resourceMarker');
      effects.exit('resource');
      return ok
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeFullReference(effects, ok, nok) {
  const self = this;
  return start
  /** @type {State} */

  function start(code) {
    return factoryLabel.call(
      self,
      effects,
      afterLabel,
      nok,
      'reference',
      'referenceMarker',
      'referenceString'
    )(code)
  }
  /** @type {State} */

  function afterLabel(code) {
    return self.parser.defined.includes(
      normalizeIdentifier(
        self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1)
      )
    )
      ? ok(code)
      : nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeCollapsedReference(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('reference');
    effects.enter('referenceMarker');
    effects.consume(code);
    effects.exit('referenceMarker');
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 93) {
      effects.enter('referenceMarker');
      effects.consume(code);
      effects.exit('referenceMarker');
      effects.exit('reference');
      return ok
    }

    return nok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */
/** @type {Construct} */

const labelStartImage = {
  name: 'labelStartImage',
  tokenize: tokenizeLabelStartImage,
  resolveAll: labelEnd.resolveAll
};
/** @type {Tokenizer} */

function tokenizeLabelStartImage(effects, ok, nok) {
  const self = this;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('labelImage');
    effects.enter('labelImageMarker');
    effects.consume(code);
    effects.exit('labelImageMarker');
    return open
  }
  /** @type {State} */

  function open(code) {
    if (code === 91) {
      effects.enter('labelMarker');
      effects.consume(code);
      effects.exit('labelMarker');
      effects.exit('labelImage');
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    /* To do: remove in the future once we’ve switched from
     * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
     * which doesn’t need this */

    /* Hidden footnotes hook */

    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs
      ? nok(code)
      : ok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */
/** @type {Construct} */

const labelStartLink = {
  name: 'labelStartLink',
  tokenize: tokenizeLabelStartLink,
  resolveAll: labelEnd.resolveAll
};
/** @type {Tokenizer} */

function tokenizeLabelStartLink(effects, ok, nok) {
  const self = this;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('labelLink');
    effects.enter('labelMarker');
    effects.consume(code);
    effects.exit('labelMarker');
    effects.exit('labelLink');
    return after
  }
  /** @type {State} */

  function after(code) {
    /* To do: remove in the future once we’ve switched from
     * `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
     * which doesn’t need this */

    /* Hidden footnotes hook. */

    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs
      ? nok(code)
      : ok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {Construct} */
const lineEnding = {
  name: 'lineEnding',
  tokenize: tokenizeLineEnding
};
/** @type {Tokenizer} */

function tokenizeLineEnding(effects, ok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    return factorySpace(effects, ok, 'linePrefix')
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */

/** @type {Construct} */
const thematicBreak$1 = {
  name: 'thematicBreak',
  tokenize: tokenizeThematicBreak
};
/** @type {Tokenizer} */

function tokenizeThematicBreak(effects, ok, nok) {
  let size = 0;
  /** @type {NonNullable<Code>} */

  let marker;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('thematicBreak');
    marker = code;
    return atBreak(code)
  }
  /** @type {State} */

  function atBreak(code) {
    if (code === marker) {
      effects.enter('thematicBreakSequence');
      return sequence(code)
    }

    if (markdownSpace(code)) {
      return factorySpace(effects, atBreak, 'whitespace')(code)
    }

    if (size < 3 || (code !== null && !markdownLineEnding(code))) {
      return nok(code)
    }

    effects.exit('thematicBreak');
    return ok(code)
  }
  /** @type {State} */

  function sequence(code) {
    if (code === marker) {
      effects.consume(code);
      size++;
      return sequence
    }

    effects.exit('thematicBreakSequence');
    return atBreak(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */
/** @type {Construct} */

const list$1 = {
  name: 'list',
  tokenize: tokenizeListStart,
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd
};
/** @type {Construct} */

const listItemPrefixWhitespaceConstruct = {
  tokenize: tokenizeListItemPrefixWhitespace,
  partial: true
};
/** @type {Construct} */

const indentConstruct = {
  tokenize: tokenizeIndent$1,
  partial: true
};
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeListStart(effects, ok, nok) {
  const self = this;
  const tail = self.events[self.events.length - 1];
  let initialSize =
    tail && tail[1].type === 'linePrefix'
      ? tail[2].sliceSerialize(tail[1], true).length
      : 0;
  let size = 0;
  return start
  /** @type {State} */

  function start(code) {
    const kind =
      self.containerState.type ||
      (code === 42 || code === 43 || code === 45
        ? 'listUnordered'
        : 'listOrdered');

    if (
      kind === 'listUnordered'
        ? !self.containerState.marker || code === self.containerState.marker
        : asciiDigit(code)
    ) {
      if (!self.containerState.type) {
        self.containerState.type = kind;
        effects.enter(kind, {
          _container: true
        });
      }

      if (kind === 'listUnordered') {
        effects.enter('listItemPrefix');
        return code === 42 || code === 45
          ? effects.check(thematicBreak$1, nok, atMarker)(code)
          : atMarker(code)
      }

      if (!self.interrupt || code === 49) {
        effects.enter('listItemPrefix');
        effects.enter('listItemValue');
        return inside(code)
      }
    }

    return nok(code)
  }
  /** @type {State} */

  function inside(code) {
    if (asciiDigit(code) && ++size < 10) {
      effects.consume(code);
      return inside
    }

    if (
      (!self.interrupt || size < 2) &&
      (self.containerState.marker
        ? code === self.containerState.marker
        : code === 41 || code === 46)
    ) {
      effects.exit('listItemValue');
      return atMarker(code)
    }

    return nok(code)
  }
  /**
   * @type {State}
   **/

  function atMarker(code) {
    effects.enter('listItemMarker');
    effects.consume(code);
    effects.exit('listItemMarker');
    self.containerState.marker = self.containerState.marker || code;
    return effects.check(
      blankLine, // Can’t be empty when interrupting.
      self.interrupt ? nok : onBlank,
      effects.attempt(
        listItemPrefixWhitespaceConstruct,
        endOfPrefix,
        otherPrefix
      )
    )
  }
  /** @type {State} */

  function onBlank(code) {
    self.containerState.initialBlankLine = true;
    initialSize++;
    return endOfPrefix(code)
  }
  /** @type {State} */

  function otherPrefix(code) {
    if (markdownSpace(code)) {
      effects.enter('listItemPrefixWhitespace');
      effects.consume(code);
      effects.exit('listItemPrefixWhitespace');
      return endOfPrefix
    }

    return nok(code)
  }
  /** @type {State} */

  function endOfPrefix(code) {
    self.containerState.size =
      initialSize +
      self.sliceSerialize(effects.exit('listItemPrefix'), true).length;
    return ok(code)
  }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeListContinuation(effects, ok, nok) {
  const self = this;
  self.containerState._closeFlow = undefined;
  return effects.check(blankLine, onBlank, notBlank)
  /** @type {State} */

  function onBlank(code) {
    self.containerState.furtherBlankLines =
      self.containerState.furtherBlankLines ||
      self.containerState.initialBlankLine; // We have a blank line.
    // Still, try to consume at most the items size.

    return factorySpace(
      effects,
      ok,
      'listItemIndent',
      self.containerState.size + 1
    )(code)
  }
  /** @type {State} */

  function notBlank(code) {
    if (self.containerState.furtherBlankLines || !markdownSpace(code)) {
      self.containerState.furtherBlankLines = undefined;
      self.containerState.initialBlankLine = undefined;
      return notInCurrentItem(code)
    }

    self.containerState.furtherBlankLines = undefined;
    self.containerState.initialBlankLine = undefined;
    return effects.attempt(indentConstruct, ok, notInCurrentItem)(code)
  }
  /** @type {State} */

  function notInCurrentItem(code) {
    // While we do continue, we signal that the flow should be closed.
    self.containerState._closeFlow = true; // As we’re closing flow, we’re no longer interrupting.

    self.interrupt = undefined;
    return factorySpace(
      effects,
      effects.attempt(list$1, ok, nok),
      'linePrefix',
      self.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )(code)
  }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeIndent$1(effects, ok, nok) {
  const self = this;
  return factorySpace(
    effects,
    afterPrefix,
    'listItemIndent',
    self.containerState.size + 1
  )
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return tail &&
      tail[1].type === 'listItemIndent' &&
      tail[2].sliceSerialize(tail[1], true).length === self.containerState.size
      ? ok(code)
      : nok(code)
  }
}
/**
 * @type {Exiter}
 * @this {TokenizeContextWithState}
 */

function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContextWithState}
 */

function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
  const self = this;
  return factorySpace(
    effects,
    afterPrefix,
    'listItemPrefixWhitespace',
    self.parser.constructs.disable.null.includes('codeIndented')
      ? undefined
      : 4 + 1
  )
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return !markdownSpace(code) &&
      tail &&
      tail[1].type === 'listItemPrefixWhitespace'
      ? ok(code)
      : nok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */

/** @type {Construct} */
const setextUnderline = {
  name: 'setextUnderline',
  tokenize: tokenizeSetextUnderline,
  resolveTo: resolveToSetextUnderline
};
/** @type {Resolver} */

function resolveToSetextUnderline(events, context) {
  let index = events.length;
  /** @type {number|undefined} */

  let content;
  /** @type {number|undefined} */

  let text;
  /** @type {number|undefined} */

  let definition; // Find the opening of the content.
  // It’ll always exist: we don’t tokenize if it isn’t there.

  while (index--) {
    if (events[index][0] === 'enter') {
      if (events[index][1].type === 'content') {
        content = index;
        break
      }

      if (events[index][1].type === 'paragraph') {
        text = index;
      }
    } // Exit
    else {
      if (events[index][1].type === 'content') {
        // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
      }

      if (!definition && events[index][1].type === 'definition') {
        definition = index;
      }
    }
  }

  const heading = {
    type: 'setextHeading',
    start: Object.assign({}, events[text][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  }; // Change the paragraph to setext heading text.

  events[text][1].type = 'setextHeadingText'; // If we have definitions in the content, we’ll keep on having content,
  // but we need move it.

  if (definition) {
    events.splice(text, 0, ['enter', heading, context]);
    events.splice(definition + 1, 0, ['exit', events[content][1], context]);
    events[content][1].end = Object.assign({}, events[definition][1].end);
  } else {
    events[content][1] = heading;
  } // Add the heading exit at the end.

  events.push(['exit', heading, context]);
  return events
}
/** @type {Tokenizer} */

function tokenizeSetextUnderline(effects, ok, nok) {
  const self = this;
  let index = self.events.length;
  /** @type {NonNullable<Code>} */

  let marker;
  /** @type {boolean} */

  let paragraph; // Find an opening.

  while (index--) {
    // Skip enter/exit of line ending, line prefix, and content.
    // We can now either have a definition or a paragraph.
    if (
      self.events[index][1].type !== 'lineEnding' &&
      self.events[index][1].type !== 'linePrefix' &&
      self.events[index][1].type !== 'content'
    ) {
      paragraph = self.events[index][1].type === 'paragraph';
      break
    }
  }

  return start
  /** @type {State} */

  function start(code) {
    if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
      effects.enter('setextHeadingLine');
      effects.enter('setextHeadingLineSequence');
      marker = code;
      return closingSequence(code)
    }

    return nok(code)
  }
  /** @type {State} */

  function closingSequence(code) {
    if (code === marker) {
      effects.consume(code);
      return closingSequence
    }

    effects.exit('setextHeadingLineSequence');
    return factorySpace(effects, closingSequenceEnd, 'lineSuffix')(code)
  }
  /** @type {State} */

  function closingSequenceEnd(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('setextHeadingLine');
      return ok(code)
    }

    return nok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 */

/** @type {InitialConstruct} */
const flow$1 = {
  tokenize: initializeFlow
};
/** @type {Initializer} */

function initializeFlow(effects) {
  const self = this;
  const initial = effects.attempt(
    // Try to parse a blank line.
    blankLine,
    atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(
      this.parser.constructs.flowInitial,
      afterConstruct,
      factorySpace(
        effects,
        effects.attempt(
          this.parser.constructs.flow,
          afterConstruct,
          effects.attempt(content, afterConstruct)
        ),
        'linePrefix'
      )
    )
  );
  return initial
  /** @type {State} */

  function atBlankEnding(code) {
    if (code === null) {
      effects.consume(code);
      return
    }

    effects.enter('lineEndingBlank');
    effects.consume(code);
    effects.exit('lineEndingBlank');
    self.currentConstruct = undefined;
    return initial
  }
  /** @type {State} */

  function afterConstruct(code) {
    if (code === null) {
      effects.consume(code);
      return
    }

    effects.enter('lineEnding');
    effects.consume(code);
    effects.exit('lineEnding');
    self.currentConstruct = undefined;
    return initial
  }
}

/**
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Code} Code
 */
const resolver = {
  resolveAll: createResolver()
};
const string$2 = initializeFactory('string');
const text$3 = initializeFactory('text');
/**
 * @param {'string'|'text'} field
 * @returns {InitialConstruct}
 */

function initializeFactory(field) {
  return {
    tokenize: initializeText,
    resolveAll: createResolver(
      field === 'text' ? resolveAllLineSuffixes : undefined
    )
  }
  /** @type {Initializer} */

  function initializeText(effects) {
    const self = this;
    const constructs = this.parser.constructs[field];
    const text = effects.attempt(constructs, start, notText);
    return start
    /** @type {State} */

    function start(code) {
      return atBreak(code) ? text(code) : notText(code)
    }
    /** @type {State} */

    function notText(code) {
      if (code === null) {
        effects.consume(code);
        return
      }

      effects.enter('data');
      effects.consume(code);
      return data
    }
    /** @type {State} */

    function data(code) {
      if (atBreak(code)) {
        effects.exit('data');
        return text(code)
      } // Data.

      effects.consume(code);
      return data
    }
    /**
     * @param {Code} code
     * @returns {boolean}
     */

    function atBreak(code) {
      if (code === null) {
        return true
      }

      const list = constructs[code];
      let index = -1;

      if (list) {
        while (++index < list.length) {
          const item = list[index];

          if (!item.previous || item.previous.call(self, self.previous)) {
            return true
          }
        }
      }

      return false
    }
  }
}
/**
 * @param {Resolver} [extraResolver]
 * @returns {Resolver}
 */

function createResolver(extraResolver) {
  return resolveAllText
  /** @type {Resolver} */

  function resolveAllText(events, context) {
    let index = -1;
    /** @type {number|undefined} */

    let enter; // A rather boring computation (to merge adjacent `data` events) which
    // improves mm performance by 29%.

    while (++index <= events.length) {
      if (enter === undefined) {
        if (events[index] && events[index][1].type === 'data') {
          enter = index;
          index++;
        }
      } else if (!events[index] || events[index][1].type !== 'data') {
        // Don’t do anything if there is one data token.
        if (index !== enter + 2) {
          events[enter][1].end = events[index - 1][1].end;
          events.splice(enter + 2, index - enter - 2);
          index = enter + 2;
        }

        enter = undefined;
      }
    }

    return extraResolver ? extraResolver(events, context) : events
  }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */

function resolveAllLineSuffixes(events, context) {
  let eventIndex = 0; // Skip first.

  while (++eventIndex <= events.length) {
    if (
      (eventIndex === events.length ||
        events[eventIndex][1].type === 'lineEnding') &&
      events[eventIndex - 1][1].type === 'data'
    ) {
      const data = events[eventIndex - 1][1];
      const chunks = context.sliceStream(data);
      let index = chunks.length;
      let bufferIndex = -1;
      let size = 0;
      /** @type {boolean|undefined} */

      let tabs;

      while (index--) {
        const chunk = chunks[index];

        if (typeof chunk === 'string') {
          bufferIndex = chunk.length;

          while (chunk.charCodeAt(bufferIndex - 1) === 32) {
            size++;
            bufferIndex--;
          }

          if (bufferIndex) break
          bufferIndex = -1;
        } // Number
        else if (chunk === -2) {
          tabs = true;
          size++;
        } else if (chunk === -1) ; else {
          // Replacement character, exit.
          index++;
          break
        }
      }

      if (size) {
        const token = {
          type:
            eventIndex === events.length || tabs || size < 2
              ? 'lineSuffix'
              : 'hardBreakTrailing',
          start: {
            line: data.end.line,
            column: data.end.column - size,
            offset: data.end.offset - size,
            _index: data.start._index + index,
            _bufferIndex: index
              ? bufferIndex
              : data.start._bufferIndex + bufferIndex
          },
          end: Object.assign({}, data.end)
        };
        data.end = Object.assign({}, token.start);

        if (data.start.offset === data.end.offset) {
          Object.assign(data, token);
        } else {
          events.splice(
            eventIndex,
            0,
            ['enter', token, context],
            ['exit', token, context]
          );
          eventIndex += 2;
        }
      }

      eventIndex++;
    }
  }

  return events
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 */

/**
 * Create a tokenizer.
 * Tokenizers deal with one type of data (e.g., containers, flow, text).
 * The parser is the object dealing with it all.
 * `initialize` works like other constructs, except that only its `tokenize`
 * function is used, in which case it doesn’t receive an `ok` or `nok`.
 * `from` can be given to set the point before the first character, although
 * when further lines are indented, they must be set with `defineSkip`.
 *
 * @param {ParseContext} parser
 * @param {InitialConstruct} initialize
 * @param {Omit<Point, '_index'|'_bufferIndex'>} [from]
 * @returns {TokenizeContext}
 */
function createTokenizer(parser, initialize, from) {
  /** @type {Point} */
  let point = Object.assign(
    from
      ? Object.assign({}, from)
      : {
          line: 1,
          column: 1,
          offset: 0
        },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  /** @type {Record<string, number>} */

  const columnStart = {};
  /** @type {Construct[]} */

  const resolveAllConstructs = [];
  /** @type {Chunk[]} */

  let chunks = [];
  /** @type {Token[]} */

  let stack = [];
  /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */

  const effects = {
    consume,
    enter,
    exit,
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  };
  /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */

  const context = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser,
    sliceStream,
    sliceSerialize,
    now,
    defineSkip,
    write
  };
  /**
   * The state function.
   *
   * @type {State|void}
   */

  let state = initialize.tokenize.call(context, effects);

  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize);
  }

  return context
  /** @type {TokenizeContext['write']} */

  function write(slice) {
    chunks = push(chunks, slice);
    main(); // Exit if we’re not done, resolve might change stuff.

    if (chunks[chunks.length - 1] !== null) {
      return []
    }

    addResult(initialize, 0); // Otherwise, resolve, and exit.

    context.events = resolveAll(resolveAllConstructs, context.events, context);
    return context.events
  } //
  // Tools.
  //

  /** @type {TokenizeContext['sliceSerialize']} */

  function sliceSerialize(token, expandTabs) {
    return serializeChunks(sliceStream(token), expandTabs)
  }
  /** @type {TokenizeContext['sliceStream']} */

  function sliceStream(token) {
    return sliceChunks(chunks, token)
  }
  /** @type {TokenizeContext['now']} */

  function now() {
    return Object.assign({}, point)
  }
  /** @type {TokenizeContext['defineSkip']} */

  function defineSkip(value) {
    columnStart[value.line] = value.column;
    accountForPotentialSkip();
  } //
  // State management.
  //

  /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */

  function main() {
    /** @type {number} */
    let chunkIndex;

    while (point._index < chunks.length) {
      const chunk = chunks[point._index]; // If we’re in a buffer chunk, loop through it.

      if (typeof chunk === 'string') {
        chunkIndex = point._index;

        if (point._bufferIndex < 0) {
          point._bufferIndex = 0;
        }

        while (
          point._index === chunkIndex &&
          point._bufferIndex < chunk.length
        ) {
          go(chunk.charCodeAt(point._bufferIndex));
        }
      } else {
        go(chunk);
      }
    }
  }
  /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */

  function go(code) {
    state = state(code);
  }
  /** @type {Effects['consume']} */

  function consume(code) {
    if (markdownLineEnding(code)) {
      point.line++;
      point.column = 1;
      point.offset += code === -3 ? 2 : 1;
      accountForPotentialSkip();
    } else if (code !== -1) {
      point.column++;
      point.offset++;
    } // Not in a string chunk.

    if (point._bufferIndex < 0) {
      point._index++;
    } else {
      point._bufferIndex++; // At end of string chunk.
      // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
      // strings.

      if (point._bufferIndex === chunks[point._index].length) {
        point._bufferIndex = -1;
        point._index++;
      }
    } // Expose the previous character.

    context.previous = code; // Mark as consumed.
  }
  /** @type {Effects['enter']} */

  function enter(type, fields) {
    /** @type {Token} */
    // @ts-expect-error Patch instead of assign required fields to help GC.
    const token = fields || {};
    token.type = type;
    token.start = now();
    context.events.push(['enter', token, context]);
    stack.push(token);
    return token
  }
  /** @type {Effects['exit']} */

  function exit(type) {
    const token = stack.pop();
    token.end = now();
    context.events.push(['exit', token, context]);
    return token
  }
  /**
   * Use results.
   *
   * @type {ReturnHandle}
   */

  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from);
  }
  /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */

  function onsuccessfulcheck(_, info) {
    info.restore();
  }
  /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {Record<string, unknown>} [fields]
   */

  function constructFactory(onreturn, fields) {
    return hook
    /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Construct|Construct[]|ConstructRecord} constructs
     * @param {State} returnState
     * @param {State} [bogusState]
     * @returns {State}
     */

    function hook(constructs, returnState, bogusState) {
      /** @type {Construct[]} */
      let listOfConstructs;
      /** @type {number} */

      let constructIndex;
      /** @type {Construct} */

      let currentConstruct;
      /** @type {Info} */

      let info;
      return Array.isArray(constructs)
        ? /* c8 ignore next 1 */
          handleListOfConstructs(constructs)
        : 'tokenize' in constructs // @ts-expect-error Looks like a construct.
        ? handleListOfConstructs([constructs])
        : handleMapOfConstructs(constructs)
      /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */

      function handleMapOfConstructs(map) {
        return start
        /** @type {State} */

        function start(code) {
          const def = code !== null && map[code];
          const all = code !== null && map.null;
          const list = [
            // To do: add more extension tests.

            /* c8 ignore next 2 */
            ...(Array.isArray(def) ? def : def ? [def] : []),
            ...(Array.isArray(all) ? all : all ? [all] : [])
          ];
          return handleListOfConstructs(list)(code)
        }
      }
      /**
       * Handle a list of construct.
       *
       * @param {Construct[]} list
       * @returns {State}
       */

      function handleListOfConstructs(list) {
        listOfConstructs = list;
        constructIndex = 0;

        if (list.length === 0) {
          return bogusState
        }

        return handleConstruct(list[constructIndex])
      }
      /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */

      function handleConstruct(construct) {
        return start
        /** @type {State} */

        function start(code) {
          // To do: not needed to store if there is no bogus state, probably?
          // Currently doesn’t work because `inspect` in document does a check
          // w/o a bogus, which doesn’t make sense. But it does seem to help perf
          // by not storing.
          info = store();
          currentConstruct = construct;

          if (!construct.partial) {
            context.currentConstruct = construct;
          }

          if (
            construct.name &&
            context.parser.constructs.disable.null.includes(construct.name)
          ) {
            return nok()
          }

          return construct.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            fields ? Object.assign(Object.create(context), fields) : context,
            effects,
            ok,
            nok
          )(code)
        }
      }
      /** @type {State} */

      function ok(code) {
        onreturn(currentConstruct, info);
        return returnState
      }
      /** @type {State} */

      function nok(code) {
        info.restore();

        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex])
        }

        return bogusState
      }
    }
  }
  /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */

  function addResult(construct, from) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct);
    }

    if (construct.resolve) {
      splice(
        context.events,
        from,
        context.events.length - from,
        construct.resolve(context.events.slice(from), context)
      );
    }

    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context);
    }
  }
  /**
   * Store state.
   *
   * @returns {Info}
   */

  function store() {
    const startPoint = now();
    const startPrevious = context.previous;
    const startCurrentConstruct = context.currentConstruct;
    const startEventsIndex = context.events.length;
    const startStack = Array.from(stack);
    return {
      restore,
      from: startEventsIndex
    }
    /**
     * Restore state.
     *
     * @returns {void}
     */

    function restore() {
      point = startPoint;
      context.previous = startPrevious;
      context.currentConstruct = startCurrentConstruct;
      context.events.length = startEventsIndex;
      stack = startStack;
      accountForPotentialSkip();
    }
  }
  /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */

  function accountForPotentialSkip() {
    if (point.line in columnStart && point.column < 2) {
      point.column = columnStart[point.line];
      point.offset += columnStart[point.line] - 1;
    }
  }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Chunk[]} chunks
 * @param {Pick<Token, 'start'|'end'>} token
 * @returns {Chunk[]}
 */

function sliceChunks(chunks, token) {
  const startIndex = token.start._index;
  const startBufferIndex = token.start._bufferIndex;
  const endIndex = token.end._index;
  const endBufferIndex = token.end._bufferIndex;
  /** @type {Chunk[]} */

  let view;

  if (startIndex === endIndex) {
    // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)];
  } else {
    view = chunks.slice(startIndex, endIndex);

    if (startBufferIndex > -1) {
      // @ts-expect-error `_bufferIndex` is used on string chunks.
      view[0] = view[0].slice(startBufferIndex);
    }

    if (endBufferIndex > 0) {
      // @ts-expect-error `_bufferIndex` is used on string chunks.
      view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
  }

  return view
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Chunk[]} chunks
 * @param {boolean} [expandTabs=false]
 * @returns {string}
 */

function serializeChunks(chunks, expandTabs) {
  let index = -1;
  /** @type {string[]} */

  const result = [];
  /** @type {boolean|undefined} */

  let atTab;

  while (++index < chunks.length) {
    const chunk = chunks[index];
    /** @type {string} */

    let value;

    if (typeof chunk === 'string') {
      value = chunk;
    } else
      switch (chunk) {
        case -5: {
          value = '\r';
          break
        }

        case -4: {
          value = '\n';
          break
        }

        case -3: {
          value = '\r' + '\n';
          break
        }

        case -2: {
          value = expandTabs ? ' ' : '\t';
          break
        }

        case -1: {
          if (!expandTabs && atTab) continue
          value = ' ';
          break
        }

        default: {
          // Currently only replacement character.
          value = String.fromCharCode(chunk);
        }
      }

    atTab = chunk === -2;
    result.push(value);
  }

  return result.join('')
}

/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */
/** @type {Extension['document']} */

const document$1 = {
  [42]: list$1,
  [43]: list$1,
  [45]: list$1,
  [48]: list$1,
  [49]: list$1,
  [50]: list$1,
  [51]: list$1,
  [52]: list$1,
  [53]: list$1,
  [54]: list$1,
  [55]: list$1,
  [56]: list$1,
  [57]: list$1,
  [62]: blockQuote
};
/** @type {Extension['contentInitial']} */

const contentInitial = {
  [91]: definition
};
/** @type {Extension['flowInitial']} */

const flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  [32]: codeIndented
};
/** @type {Extension['flow']} */

const flow = {
  [35]: headingAtx,
  [42]: thematicBreak$1,
  [45]: [setextUnderline, thematicBreak$1],
  [60]: htmlFlow,
  [61]: setextUnderline,
  [95]: thematicBreak$1,
  [96]: codeFenced,
  [126]: codeFenced
};
/** @type {Extension['string']} */

const string$1 = {
  [38]: characterReference,
  [92]: characterEscape
};
/** @type {Extension['text']} */

const text$2 = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  [33]: labelStartImage,
  [38]: characterReference,
  [42]: attention,
  [60]: [autolink, htmlText],
  [91]: labelStartLink,
  [92]: [hardBreakEscape, characterEscape],
  [93]: labelEnd,
  [95]: attention,
  [96]: codeText
};
/** @type {Extension['insideSpan']} */

const insideSpan = {
  null: [attention, resolver]
};
/** @type {Extension['attentionMarkers']} */

const attentionMarkers = {
  null: [42, 95]
};
/** @type {Extension['disable']} */

const disable = {
  null: []
};

var defaultConstructs = /*#__PURE__*/Object.freeze({
  __proto__: null,
  document: document$1,
  contentInitial: contentInitial,
  flowInitial: flowInitial,
  flow: flow,
  string: string$1,
  text: text$2,
  insideSpan: insideSpan,
  attentionMarkers: attentionMarkers,
  disable: disable
});

/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Create} Create
 */
/**
 * @param {ParseOptions} [options]
 * @returns {ParseContext}
 */

function parse$1(options = {}) {
  /** @type {FullNormalizedExtension} */
  // @ts-expect-error `defaultConstructs` is full, so the result will be too.
  const constructs = combineExtensions(
    // @ts-expect-error Same as above.
    [defaultConstructs].concat(options.extensions || [])
  );
  /** @type {ParseContext} */

  const parser = {
    defined: [],
    lazy: {},
    constructs,
    content: create(content$1),
    document: create(document$2),
    flow: create(flow$1),
    string: create(string$2),
    text: create(text$3)
  };
  return parser
  /**
   * @param {InitialConstruct} initial
   */

  function create(initial) {
    return creator
    /** @type {Create} */

    function creator(from) {
      return createTokenizer(parser, initial, from)
    }
  }
}

/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 */

/**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding} [encoding]
 * @param {boolean} [end=false]
 * @returns {Chunk[]}
 */
const search = /[\0\t\n\r]/g;
/**
 * @returns {Preprocessor}
 */

function preprocess() {
  let column = 1;
  let buffer = '';
  /** @type {boolean|undefined} */

  let start = true;
  /** @type {boolean|undefined} */

  let atCarriageReturn;
  return preprocessor
  /** @type {Preprocessor} */

  function preprocessor(value, encoding, end) {
    /** @type {Chunk[]} */
    const chunks = [];
    /** @type {RegExpMatchArray|null} */

    let match;
    /** @type {number} */

    let next;
    /** @type {number} */

    let startPosition;
    /** @type {number} */

    let endPosition;
    /** @type {Code} */

    let code; // @ts-expect-error `Buffer` does allow an encoding.

    value = buffer + value.toString(encoding);
    startPosition = 0;
    buffer = '';

    if (start) {
      if (value.charCodeAt(0) === 65279) {
        startPosition++;
      }

      start = undefined;
    }

    while (startPosition < value.length) {
      search.lastIndex = startPosition;
      match = search.exec(value);
      endPosition =
        match && match.index !== undefined ? match.index : value.length;
      code = value.charCodeAt(endPosition);

      if (!match) {
        buffer = value.slice(startPosition);
        break
      }

      if (code === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3);
        atCarriageReturn = undefined;
      } else {
        if (atCarriageReturn) {
          chunks.push(-5);
          atCarriageReturn = undefined;
        }

        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition));
          column += endPosition - startPosition;
        }

        switch (code) {
          case 0: {
            chunks.push(65533);
            column++;
            break
          }

          case 9: {
            next = Math.ceil(column / 4) * 4;
            chunks.push(-2);

            while (column++ < next) chunks.push(-1);

            break
          }

          case 10: {
            chunks.push(-4);
            column = 1;
            break
          }

          default: {
            atCarriageReturn = true;
            column = 1;
          }
        }
      }

      startPosition = endPosition + 1;
    }

    if (end) {
      if (atCarriageReturn) chunks.push(-5);
      if (buffer) chunks.push(buffer);
      chunks.push(null);
    }

    return chunks
  }
}

/**
 * @typedef {import('micromark-util-types').Event} Event
 */
/**
 * @param {Event[]} events
 * @returns {Event[]}
 */

function postprocess(events) {
  while (!subtokenize(events)) {
    // Empty
  }

  return events
}

/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 */
function decodeNumericCharacterReference(value, base) {
  const code = Number.parseInt(value, base);

  if (
    // C0 except for HT, LF, FF, CR, space
    code < 9 ||
    code === 11 ||
    (code > 13 && code < 32) || // Control character (DEL) of the basic block and C1 controls.
    (code > 126 && code < 160) || // Lone high surrogates and low surrogates.
    (code > 55295 && code < 57344) || // Noncharacters.
    (code > 64975 && code < 65008) ||
    (code & 65535) === 65535 ||
    (code & 65535) === 65534 || // Out of range
    code > 1114111
  ) {
    return '\uFFFD'
  }

  return String.fromCharCode(code)
}

const characterEscapeOrReference =
  /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
/**
 * Utility to decode markdown strings (which occur in places such as fenced
 * code info strings, destinations, labels, and titles).
 * The “string” content type allows character escapes and -references.
 * This decodes those.
 *
 * @param {string} value
 * @returns {string}
 */

function decodeString(value) {
  return value.replace(characterEscapeOrReference, decode$a)
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */

function decode$a($0, $1, $2) {
  if ($1) {
    // Escape.
    return $1
  } // Reference.

  const head = $2.charCodeAt(0);

  if (head === 35) {
    const head = $2.charCodeAt(1);
    const hex = head === 120 || head === 88;
    return decodeNumericCharacterReference($2.slice(hex ? 2 : 1), hex ? 16 : 10)
  }

  return decodeNamedCharacterReference($2) || $0
}

/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {Root|Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 *
 * @typedef {UnistParent & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */
const own$7 = {}.hasOwnProperty;
/**
 * @param value Markdown to parse (`string` or `Buffer`).
 * @param [encoding] Character encoding to understand `value` as when it’s a `Buffer` (`string`, default: `'utf8'`).
 * @param [options] Configuration
 */

const fromMarkdown =
  /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options) => Root) &
   *   ((value: Value, options?: Options) => Root)
   * )}
   */

  /**
   * @param {Value} value
   * @param {Encoding} [encoding]
   * @param {Options} [options]
   * @returns {Root}
   */
  function (value, encoding, options) {
    if (typeof encoding !== 'string') {
      options = encoding;
      encoding = undefined;
    }

    return compiler(options)(
      postprocess(
        parse$1(options).document().write(preprocess()(value, encoding, true))
      )
    )
  };
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options} [options]
 */

function compiler(options = {}) {
  /** @type {NormalizedExtension} */
  // @ts-expect-error: our base has all required fields, so the result will too.
  const config = configure(
    {
      transforms: [],
      canContainEols: [
        'emphasis',
        'fragment',
        'heading',
        'paragraph',
        'strong'
      ],
      enter: {
        autolink: opener(link),
        autolinkProtocol: onenterdata,
        autolinkEmail: onenterdata,
        atxHeading: opener(heading),
        blockQuote: opener(blockQuote),
        characterEscape: onenterdata,
        characterReference: onenterdata,
        codeFenced: opener(codeFlow),
        codeFencedFenceInfo: buffer,
        codeFencedFenceMeta: buffer,
        codeIndented: opener(codeFlow, buffer),
        codeText: opener(codeText, buffer),
        codeTextData: onenterdata,
        data: onenterdata,
        codeFlowValue: onenterdata,
        definition: opener(definition),
        definitionDestinationString: buffer,
        definitionLabelString: buffer,
        definitionTitleString: buffer,
        emphasis: opener(emphasis),
        hardBreakEscape: opener(hardBreak),
        hardBreakTrailing: opener(hardBreak),
        htmlFlow: opener(html, buffer),
        htmlFlowData: onenterdata,
        htmlText: opener(html, buffer),
        htmlTextData: onenterdata,
        image: opener(image),
        label: buffer,
        link: opener(link),
        listItem: opener(listItem),
        listItemValue: onenterlistitemvalue,
        listOrdered: opener(list, onenterlistordered),
        listUnordered: opener(list),
        paragraph: opener(paragraph),
        reference: onenterreference,
        referenceString: buffer,
        resourceDestinationString: buffer,
        resourceTitleString: buffer,
        setextHeading: opener(heading),
        strong: opener(strong),
        thematicBreak: opener(thematicBreak)
      },
      exit: {
        atxHeading: closer(),
        atxHeadingSequence: onexitatxheadingsequence,
        autolink: closer(),
        autolinkEmail: onexitautolinkemail,
        autolinkProtocol: onexitautolinkprotocol,
        blockQuote: closer(),
        characterEscapeValue: onexitdata,
        characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
        characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
        characterReferenceValue: onexitcharacterreferencevalue,
        codeFenced: closer(onexitcodefenced),
        codeFencedFence: onexitcodefencedfence,
        codeFencedFenceInfo: onexitcodefencedfenceinfo,
        codeFencedFenceMeta: onexitcodefencedfencemeta,
        codeFlowValue: onexitdata,
        codeIndented: closer(onexitcodeindented),
        codeText: closer(onexitcodetext),
        codeTextData: onexitdata,
        data: onexitdata,
        definition: closer(),
        definitionDestinationString: onexitdefinitiondestinationstring,
        definitionLabelString: onexitdefinitionlabelstring,
        definitionTitleString: onexitdefinitiontitlestring,
        emphasis: closer(),
        hardBreakEscape: closer(onexithardbreak),
        hardBreakTrailing: closer(onexithardbreak),
        htmlFlow: closer(onexithtmlflow),
        htmlFlowData: onexitdata,
        htmlText: closer(onexithtmltext),
        htmlTextData: onexitdata,
        image: closer(onexitimage),
        label: onexitlabel,
        labelText: onexitlabeltext,
        lineEnding: onexitlineending,
        link: closer(onexitlink),
        listItem: closer(),
        listOrdered: closer(),
        listUnordered: closer(),
        paragraph: closer(),
        referenceString: onexitreferencestring,
        resourceDestinationString: onexitresourcedestinationstring,
        resourceTitleString: onexitresourcetitlestring,
        resource: onexitresource,
        setextHeading: closer(onexitsetextheading),
        setextHeadingLineSequence: onexitsetextheadinglinesequence,
        setextHeadingText: onexitsetextheadingtext,
        strong: closer(),
        thematicBreak: closer()
      }
    },
    options.mdastExtensions || []
  );
  /** @type {CompileData} */

  const data = {};
  return compile
  /**
   * @param {Array<Event>} events
   * @returns {Root}
   */

  function compile(events) {
    /** @type {Root} */
    let tree = {
      type: 'root',
      children: []
    };
    /** @type {CompileContext['stack']} */

    const stack = [tree];
    /** @type {CompileContext['tokenStack']} */

    const tokenStack = [];
    /** @type {Array<number>} */

    const listStack = [];
    /** @type {Omit<CompileContext, 'sliceSerialize'>} */

    const context = {
      stack,
      tokenStack,
      config,
      enter,
      exit,
      buffer,
      resume,
      setData,
      getData
    };
    let index = -1;

    while (++index < events.length) {
      // We preprocess lists to add `listItem` tokens, and to infer whether
      // items the list itself are spread out.
      if (
        events[index][1].type === 'listOrdered' ||
        events[index][1].type === 'listUnordered'
      ) {
        if (events[index][0] === 'enter') {
          listStack.push(index);
        } else {
          const tail = listStack.pop();
          index = prepareList(events, tail, index);
        }
      }
    }

    index = -1;

    while (++index < events.length) {
      const handler = config[events[index][0]];

      if (own$7.call(handler, events[index][1].type)) {
        handler[events[index][1].type].call(
          Object.assign(
            {
              sliceSerialize: events[index][2].sliceSerialize
            },
            context
          ),
          events[index][1]
        );
      }
    }

    if (tokenStack.length > 0) {
      const tail = tokenStack[tokenStack.length - 1];
      const handler = tail[1] || defaultOnError;
      handler.call(context, undefined, tail[0]);
    } // Figure out `root` position.

    tree.position = {
      start: point(
        events.length > 0
          ? events[0][1].start
          : {
              line: 1,
              column: 1,
              offset: 0
            }
      ),
      end: point(
        events.length > 0
          ? events[events.length - 2][1].end
          : {
              line: 1,
              column: 1,
              offset: 0
            }
      )
    };
    index = -1;

    while (++index < config.transforms.length) {
      tree = config.transforms[index](tree) || tree;
    }

    return tree
  }
  /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */

  function prepareList(events, start, length) {
    let index = start - 1;
    let containerBalance = -1;
    let listSpread = false;
    /** @type {Token|undefined} */

    let listItem;
    /** @type {number|undefined} */

    let lineIndex;
    /** @type {number|undefined} */

    let firstBlankLineIndex;
    /** @type {boolean|undefined} */

    let atMarker;

    while (++index <= length) {
      const event = events[index];

      if (
        event[1].type === 'listUnordered' ||
        event[1].type === 'listOrdered' ||
        event[1].type === 'blockQuote'
      ) {
        if (event[0] === 'enter') {
          containerBalance++;
        } else {
          containerBalance--;
        }

        atMarker = undefined;
      } else if (event[1].type === 'lineEndingBlank') {
        if (event[0] === 'enter') {
          if (
            listItem &&
            !atMarker &&
            !containerBalance &&
            !firstBlankLineIndex
          ) {
            firstBlankLineIndex = index;
          }

          atMarker = undefined;
        }
      } else if (
        event[1].type === 'linePrefix' ||
        event[1].type === 'listItemValue' ||
        event[1].type === 'listItemMarker' ||
        event[1].type === 'listItemPrefix' ||
        event[1].type === 'listItemPrefixWhitespace'
      ) ; else {
        atMarker = undefined;
      }

      if (
        (!containerBalance &&
          event[0] === 'enter' &&
          event[1].type === 'listItemPrefix') ||
        (containerBalance === -1 &&
          event[0] === 'exit' &&
          (event[1].type === 'listUnordered' ||
            event[1].type === 'listOrdered'))
      ) {
        if (listItem) {
          let tailIndex = index;
          lineIndex = undefined;

          while (tailIndex--) {
            const tailEvent = events[tailIndex];

            if (
              tailEvent[1].type === 'lineEnding' ||
              tailEvent[1].type === 'lineEndingBlank'
            ) {
              if (tailEvent[0] === 'exit') continue

              if (lineIndex) {
                events[lineIndex][1].type = 'lineEndingBlank';
                listSpread = true;
              }

              tailEvent[1].type = 'lineEnding';
              lineIndex = tailIndex;
            } else if (
              tailEvent[1].type === 'linePrefix' ||
              tailEvent[1].type === 'blockQuotePrefix' ||
              tailEvent[1].type === 'blockQuotePrefixWhitespace' ||
              tailEvent[1].type === 'blockQuoteMarker' ||
              tailEvent[1].type === 'listItemIndent'
            ) ; else {
              break
            }
          }

          if (
            firstBlankLineIndex &&
            (!lineIndex || firstBlankLineIndex < lineIndex)
          ) {
            // @ts-expect-error Patched.
            listItem._spread = true;
          } // Fix position.

          listItem.end = Object.assign(
            {},
            lineIndex ? events[lineIndex][1].start : event[1].end
          );
          events.splice(lineIndex || index, 0, ['exit', listItem, event[2]]);
          index++;
          length++;
        } // Create a new list item.

        if (event[1].type === 'listItemPrefix') {
          listItem = {
            type: 'listItem',
            // @ts-expect-error Patched
            _spread: false,
            start: Object.assign({}, event[1].start)
          }; // @ts-expect-error: `listItem` is most definitely defined, TS...

          events.splice(index, 0, ['enter', listItem, event[2]]);
          index++;
          length++;
          firstBlankLineIndex = undefined;
          atMarker = true;
        }
      }
    } // @ts-expect-error Patched.

    events[start][1]._spread = listSpread;
    return length
  }
  /**
   * @type {CompileContext['setData']}
   * @param [value]
   */

  function setData(key, value) {
    data[key] = value;
  }
  /**
   * @type {CompileContext['getData']}
   * @template {string} K
   * @param {K} key
   * @returns {CompileData[K]}
   */

  function getData(key) {
    return data[key]
  }
  /**
   * @param {Point} d
   * @returns {Point}
   */

  function point(d) {
    return {
      line: d.line,
      column: d.column,
      offset: d.offset
    }
  }
  /**
   * @param {(token: Token) => Node} create
   * @param {Handle} [and]
   * @returns {Handle}
   */

  function opener(create, and) {
    return open
    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */

    function open(token) {
      enter.call(this, create(token), token);
      if (and) and.call(this, token);
    }
  }
  /** @type {CompileContext['buffer']} */

  function buffer() {
    this.stack.push({
      type: 'fragment',
      children: []
    });
  }
  /**
   * @type {CompileContext['enter']}
   * @template {Node} N
   * @this {CompileContext}
   * @param {N} node
   * @param {Token} token
   * @param {OnEnterError} [errorHandler]
   * @returns {N}
   */

  function enter(node, token, errorHandler) {
    const parent = this.stack[this.stack.length - 1];
    // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
    parent.children.push(node);
    this.stack.push(node);
    this.tokenStack.push([token, errorHandler]); // @ts-expect-error: `end` will be patched later.

    node.position = {
      start: point(token.start)
    };
    return node
  }
  /**
   * @param {Handle} [and]
   * @returns {Handle}
   */

  function closer(and) {
    return close
    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */

    function close(token) {
      if (and) and.call(this, token);
      exit.call(this, token);
    }
  }
  /**
   * @type {CompileContext['exit']}
   * @this {CompileContext}
   * @param {Token} token
   * @param {OnExitError} [onExitError]
   * @returns {Node}
   */

  function exit(token, onExitError) {
    const node = this.stack.pop();
    const open = this.tokenStack.pop();

    if (!open) {
      throw new Error(
        'Cannot close `' +
          token.type +
          '` (' +
          stringifyPosition({
            start: token.start,
            end: token.end
          }) +
          '): it’s not open'
      )
    } else if (open[0].type !== token.type) {
      if (onExitError) {
        onExitError.call(this, token, open[0]);
      } else {
        const handler = open[1] || defaultOnError;
        handler.call(this, token, open[0]);
      }
    }

    node.position.end = point(token.end);
    return node
  }
  /**
   * @this {CompileContext}
   * @returns {string}
   */

  function resume() {
    return toString$4(this.stack.pop())
  } //
  // Handlers.
  //

  /** @type {Handle} */

  function onenterlistordered() {
    setData('expectingFirstListItemValue', true);
  }
  /** @type {Handle} */

  function onenterlistitemvalue(token) {
    if (getData('expectingFirstListItemValue')) {
      const ancestor =
        /** @type {List} */
        this.stack[this.stack.length - 2];
      ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
      setData('expectingFirstListItemValue');
    }
  }
  /** @type {Handle} */

  function onexitcodefencedfenceinfo() {
    const data = this.resume();
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1];
    node.lang = data;
  }
  /** @type {Handle} */

  function onexitcodefencedfencemeta() {
    const data = this.resume();
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1];
    node.meta = data;
  }
  /** @type {Handle} */

  function onexitcodefencedfence() {
    // Exit if this is the closing fence.
    if (getData('flowCodeInside')) return
    this.buffer();
    setData('flowCodeInside', true);
  }
  /** @type {Handle} */

  function onexitcodefenced() {
    const data = this.resume();
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1];
    node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
    setData('flowCodeInside');
  }
  /** @type {Handle} */

  function onexitcodeindented() {
    const data = this.resume();
    const node =
      /** @type {Code} */
      this.stack[this.stack.length - 1];
    node.value = data.replace(/(\r?\n|\r)$/g, '');
  }
  /** @type {Handle} */

  function onexitdefinitionlabelstring(token) {
    // Discard label, use the source content instead.
    const label = this.resume();
    const node =
      /** @type {Definition} */
      this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase();
  }
  /** @type {Handle} */

  function onexitdefinitiontitlestring() {
    const data = this.resume();
    const node =
      /** @type {Definition} */
      this.stack[this.stack.length - 1];
    node.title = data;
  }
  /** @type {Handle} */

  function onexitdefinitiondestinationstring() {
    const data = this.resume();
    const node =
      /** @type {Definition} */
      this.stack[this.stack.length - 1];
    node.url = data;
  }
  /** @type {Handle} */

  function onexitatxheadingsequence(token) {
    const node =
      /** @type {Heading} */
      this.stack[this.stack.length - 1];

    if (!node.depth) {
      const depth = this.sliceSerialize(token).length;
      node.depth = depth;
    }
  }
  /** @type {Handle} */

  function onexitsetextheadingtext() {
    setData('setextHeadingSlurpLineEnding', true);
  }
  /** @type {Handle} */

  function onexitsetextheadinglinesequence(token) {
    const node =
      /** @type {Heading} */
      this.stack[this.stack.length - 1];
    node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
  }
  /** @type {Handle} */

  function onexitsetextheading() {
    setData('setextHeadingSlurpLineEnding');
  }
  /** @type {Handle} */

  function onenterdata(token) {
    const parent =
      /** @type {Parent} */
      this.stack[this.stack.length - 1];
    /** @type {Node} */

    let tail = parent.children[parent.children.length - 1];

    if (!tail || tail.type !== 'text') {
      // Add a new text node.
      tail = text(); // @ts-expect-error: we’ll add `end` later.

      tail.position = {
        start: point(token.start)
      }; // @ts-expect-error: Assume `parent` accepts `text`.

      parent.children.push(tail);
    }

    this.stack.push(tail);
  }
  /** @type {Handle} */

  function onexitdata(token) {
    const tail = this.stack.pop();
    tail.value += this.sliceSerialize(token);
    tail.position.end = point(token.end);
  }
  /** @type {Handle} */

  function onexitlineending(token) {
    const context = this.stack[this.stack.length - 1];

    // If we’re at a hard break, include the line ending in there.
    if (getData('atHardBreak')) {
      const tail = context.children[context.children.length - 1];
      tail.position.end = point(token.end);
      setData('atHardBreak');
      return
    }

    if (
      !getData('setextHeadingSlurpLineEnding') &&
      config.canContainEols.includes(context.type)
    ) {
      onenterdata.call(this, token);
      onexitdata.call(this, token);
    }
  }
  /** @type {Handle} */

  function onexithardbreak() {
    setData('atHardBreak', true);
  }
  /** @type {Handle} */

  function onexithtmlflow() {
    const data = this.resume();
    const node =
      /** @type {HTML} */
      this.stack[this.stack.length - 1];
    node.value = data;
  }
  /** @type {Handle} */

  function onexithtmltext() {
    const data = this.resume();
    const node =
      /** @type {HTML} */
      this.stack[this.stack.length - 1];
    node.value = data;
  }
  /** @type {Handle} */

  function onexitcodetext() {
    const data = this.resume();
    const node =
      /** @type {InlineCode} */
      this.stack[this.stack.length - 1];
    node.value = data;
  }
  /** @type {Handle} */

  function onexitlink() {
    const context =
      /** @type {Link & {identifier: string, label: string}} */
      this.stack[this.stack.length - 1]; // To do: clean.

    if (getData('inReference')) {
      context.type += 'Reference'; // @ts-expect-error: mutate.

      context.referenceType = getData('referenceType') || 'shortcut'; // @ts-expect-error: mutate.

      delete context.url;
      delete context.title;
    } else {
      // @ts-expect-error: mutate.
      delete context.identifier; // @ts-expect-error: mutate.

      delete context.label;
    }

    setData('referenceType');
  }
  /** @type {Handle} */

  function onexitimage() {
    const context =
      /** @type {Image & {identifier: string, label: string}} */
      this.stack[this.stack.length - 1]; // To do: clean.

    if (getData('inReference')) {
      context.type += 'Reference'; // @ts-expect-error: mutate.

      context.referenceType = getData('referenceType') || 'shortcut'; // @ts-expect-error: mutate.

      delete context.url;
      delete context.title;
    } else {
      // @ts-expect-error: mutate.
      delete context.identifier; // @ts-expect-error: mutate.

      delete context.label;
    }

    setData('referenceType');
  }
  /** @type {Handle} */

  function onexitlabeltext(token) {
    const ancestor =
      /** @type {(Link|Image) & {identifier: string, label: string}} */
      this.stack[this.stack.length - 2];
    const string = this.sliceSerialize(token);
    ancestor.label = decodeString(string);
    ancestor.identifier = normalizeIdentifier(string).toLowerCase();
  }
  /** @type {Handle} */

  function onexitlabel() {
    const fragment =
      /** @type {Fragment} */
      this.stack[this.stack.length - 1];
    const value = this.resume();
    const node =
      /** @type {(Link|Image) & {identifier: string, label: string}} */
      this.stack[this.stack.length - 1]; // Assume a reference.

    setData('inReference', true);

    if (node.type === 'link') {
      // @ts-expect-error: Assume static phrasing content.
      node.children = fragment.children;
    } else {
      node.alt = value;
    }
  }
  /** @type {Handle} */

  function onexitresourcedestinationstring() {
    const data = this.resume();
    const node =
      /** @type {Link|Image} */
      this.stack[this.stack.length - 1];
    node.url = data;
  }
  /** @type {Handle} */

  function onexitresourcetitlestring() {
    const data = this.resume();
    const node =
      /** @type {Link|Image} */
      this.stack[this.stack.length - 1];
    node.title = data;
  }
  /** @type {Handle} */

  function onexitresource() {
    setData('inReference');
  }
  /** @type {Handle} */

  function onenterreference() {
    setData('referenceType', 'collapsed');
  }
  /** @type {Handle} */

  function onexitreferencestring(token) {
    const label = this.resume();
    const node =
      /** @type {LinkReference|ImageReference} */
      this.stack[this.stack.length - 1];
    node.label = label;
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase();
    setData('referenceType', 'full');
  }
  /** @type {Handle} */

  function onexitcharacterreferencemarker(token) {
    setData('characterReferenceType', token.type);
  }
  /** @type {Handle} */

  function onexitcharacterreferencevalue(token) {
    const data = this.sliceSerialize(token);
    const type = getData('characterReferenceType');
    /** @type {string} */

    let value;

    if (type) {
      value = decodeNumericCharacterReference(
        data,
        type === 'characterReferenceMarkerNumeric' ? 10 : 16
      );
      setData('characterReferenceType');
    } else {
      // @ts-expect-error `decodeNamedCharacterReference` can return false for
      // invalid named character references, but everything we’ve tokenized is
      // valid.
      value = decodeNamedCharacterReference(data);
    }

    const tail = this.stack.pop();
    tail.value += value;
    tail.position.end = point(token.end);
  }
  /** @type {Handle} */

  function onexitautolinkprotocol(token) {
    onexitdata.call(this, token);
    const node =
      /** @type {Link} */
      this.stack[this.stack.length - 1];
    node.url = this.sliceSerialize(token);
  }
  /** @type {Handle} */

  function onexitautolinkemail(token) {
    onexitdata.call(this, token);
    const node =
      /** @type {Link} */
      this.stack[this.stack.length - 1];
    node.url = 'mailto:' + this.sliceSerialize(token);
  } //
  // Creaters.
  //

  /** @returns {Blockquote} */

  function blockQuote() {
    return {
      type: 'blockquote',
      children: []
    }
  }
  /** @returns {Code} */

  function codeFlow() {
    return {
      type: 'code',
      lang: null,
      meta: null,
      value: ''
    }
  }
  /** @returns {InlineCode} */

  function codeText() {
    return {
      type: 'inlineCode',
      value: ''
    }
  }
  /** @returns {Definition} */

  function definition() {
    return {
      type: 'definition',
      identifier: '',
      label: null,
      title: null,
      url: ''
    }
  }
  /** @returns {Emphasis} */

  function emphasis() {
    return {
      type: 'emphasis',
      children: []
    }
  }
  /** @returns {Heading} */

  function heading() {
    // @ts-expect-error `depth` will be set later.
    return {
      type: 'heading',
      depth: undefined,
      children: []
    }
  }
  /** @returns {Break} */

  function hardBreak() {
    return {
      type: 'break'
    }
  }
  /** @returns {HTML} */

  function html() {
    return {
      type: 'html',
      value: ''
    }
  }
  /** @returns {Image} */

  function image() {
    return {
      type: 'image',
      title: null,
      url: '',
      alt: null
    }
  }
  /** @returns {Link} */

  function link() {
    return {
      type: 'link',
      title: null,
      url: '',
      children: []
    }
  }
  /**
   * @param {Token} token
   * @returns {List}
   */

  function list(token) {
    return {
      type: 'list',
      ordered: token.type === 'listOrdered',
      start: null,
      // @ts-expect-error Patched.
      spread: token._spread,
      children: []
    }
  }
  /**
   * @param {Token} token
   * @returns {ListItem}
   */

  function listItem(token) {
    return {
      type: 'listItem',
      // @ts-expect-error Patched.
      spread: token._spread,
      checked: null,
      children: []
    }
  }
  /** @returns {Paragraph} */

  function paragraph() {
    return {
      type: 'paragraph',
      children: []
    }
  }
  /** @returns {Strong} */

  function strong() {
    return {
      type: 'strong',
      children: []
    }
  }
  /** @returns {Text} */

  function text() {
    return {
      type: 'text',
      value: ''
    }
  }
  /** @returns {ThematicBreak} */

  function thematicBreak() {
    return {
      type: 'thematicBreak'
    }
  }
}
/**
 * @param {Extension} combined
 * @param {Array<Extension|Array<Extension>>} extensions
 * @returns {Extension}
 */

function configure(combined, extensions) {
  let index = -1;

  while (++index < extensions.length) {
    const value = extensions[index];

    if (Array.isArray(value)) {
      configure(combined, value);
    } else {
      extension(combined, value);
    }
  }

  return combined
}
/**
 * @param {Extension} combined
 * @param {Extension} extension
 * @returns {void}
 */

function extension(combined, extension) {
  /** @type {string} */
  let key;

  for (key in extension) {
    if (own$7.call(extension, key)) {
      const list = key === 'canContainEols' || key === 'transforms';
      const maybe = own$7.call(combined, key) ? combined[key] : undefined;
      /* c8 ignore next */

      const left = maybe || (combined[key] = list ? [] : {});
      const right = extension[key];

      if (right) {
        if (list) {
          // @ts-expect-error: `left` is an array.
          combined[key] = [...left, ...right];
        } else {
          Object.assign(left, right);
        }
      }
    }
  }
}
/** @type {OnEnterError} */

function defaultOnError(left, right) {
  if (left) {
    throw new Error(
      'Cannot close `' +
        left.type +
        '` (' +
        stringifyPosition({
          start: left.start,
          end: left.end
        }) +
        '): a different token (`' +
        right.type +
        '`, ' +
        stringifyPosition({
          start: right.start,
          end: right.end
        }) +
        ') is open'
    )
  } else {
    throw new Error(
      'Cannot close document, a token (`' +
        right.type +
        '`, ' +
        stringifyPosition({
          start: right.start,
          end: right.end
        }) +
        ') is still open'
    )
  }
}

/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */

/** @type {import('unified').Plugin<[Options?] | void[], string, Root>} */
function remarkParse(options) {
  /** @type {import('unified').ParserFunction<Root>} */
  const parser = (doc) => {
    // Assume options.
    const settings = /** @type {Options} */ (this.data('settings'));

    return fromMarkdown(
      doc,
      Object.assign({}, settings, options, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data('micromarkExtensions') || [],
        mdastExtensions: this.data('fromMarkdownExtensions') || []
      })
    )
  };

  Object.assign(this, {Parser: parser});
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist').Literal} Literal
 * @typedef {Object.<string, unknown>} Props
 * @typedef {Array.<Node>|string} ChildrenOrValue
 *
 * @typedef {(<T extends string, P extends Record<string, unknown>, C extends Node[]>(type: T, props: P, children: C) => {type: T, children: C} & P)} BuildParentWithProps
 * @typedef {(<T extends string, P extends Record<string, unknown>>(type: T, props: P, value: string) => {type: T, value: string} & P)} BuildLiteralWithProps
 * @typedef {(<T extends string, P extends Record<string, unknown>>(type: T, props: P) => {type: T} & P)} BuildVoidWithProps
 * @typedef {(<T extends string, C extends Node[]>(type: T, children: C) => {type: T, children: C})} BuildParent
 * @typedef {(<T extends string>(type: T, value: string) => {type: T, value: string})} BuildLiteral
 * @typedef {(<T extends string>(type: T) => {type: T})} BuildVoid
 */

var u$1 = /**
 * @type {BuildVoid & BuildVoidWithProps & BuildLiteral & BuildLiteralWithProps & BuildParent & BuildParentWithProps}
 */ (
  /**
   * @param {string} type Type of node
   * @param {Props|ChildrenOrValue} [props] Additional properties for node (or `children` or `value`)
   * @param {ChildrenOrValue} [value] `children` or `value` of node
   * @returns {Node}
   */
  function (type, props, value) {
    /** @type {Node} */
    var node = {type: String(type)};

    if (
      (value === undefined || value === null) &&
      (typeof props === 'string' || Array.isArray(props))
    ) {
      value = props;
    } else {
      Object.assign(node, props);
    }

    if (Array.isArray(value)) {
      node.children = value;
    } else if (value !== undefined && value !== null) {
      node.value = String(value);
    }

    return node
  }
);

/**
 * @typedef {import('mdast').Root|import('mdast').Parent['children'][number]} MdastNode
 * @typedef {import('./index.js').H} H
 * @typedef {import('./index.js').Handler} Handler
 * @typedef {import('./index.js').Content} Content
 */

const own$6 = {}.hasOwnProperty;

/**
 * Transform an unknown node.
 * @type {Handler}
 * @param {MdastNode} node
 */
function unknown(h, node) {
  const data = node.data || {};

  if (
    'value' in node &&
    !(
      own$6.call(data, 'hName') ||
      own$6.call(data, 'hProperties') ||
      own$6.call(data, 'hChildren')
    )
  ) {
    return h.augment(node, u$1('text', node.value))
  }

  return h(node, 'div', all(h, node))
}

/**
 * @type {Handler}
 * @param {MdastNode} node
 */
function one(h, node, parent) {
  const type = node && node.type;
  /** @type {Handler} */
  let fn;

  // Fail on non-nodes.
  if (!type) {
    throw new Error('Expected node, got `' + node + '`')
  }

  if (own$6.call(h.handlers, type)) {
    fn = h.handlers[type];
  } else if (h.passThrough && h.passThrough.includes(type)) {
    fn = returnNode;
  } else {
    fn = h.unknownHandler;
  }

  return (typeof fn === 'function' ? fn : unknown)(h, node, parent)
}

/**
 * @type {Handler}
 * @param {MdastNode} node
 */
function returnNode(h, node) {
  // @ts-expect-error: Pass through custom node.
  return 'children' in node ? {...node, children: all(h, node)} : node
}

/**
 * @param {H} h
 * @param {MdastNode} parent
 */
function all(h, parent) {
  /** @type {Array<Content>} */
  const values = [];

  if ('children' in parent) {
    const nodes = parent.children;
    let index = -1;

    while (++index < nodes.length) {
      const result = one(h, nodes[index], parent);

      if (result) {
        if (index && nodes[index - 1].type === 'break') {
          if (!Array.isArray(result) && result.type === 'text') {
            result.value = result.value.replace(/^\s+/, '');
          }

          if (!Array.isArray(result) && result.type === 'element') {
            const head = result.children[0];

            if (head && head.type === 'text') {
              head.value = head.value.replace(/^\s+/, '');
            }
          }
        }

        if (Array.isArray(result)) {
          values.push(...result);
        } else {
          values.push(result);
        }
      }
    }
  }

  return values
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 *
 * @typedef {string} Type
 * @typedef {Object<string, unknown>} Props
 *
 * @typedef {null|undefined|Type|Props|TestFunctionAnything|Array.<Type|Props|TestFunctionAnything>} Test
 */

const convert =
  /**
   * @type {(
   *   (<T extends Node>(test: T['type']|Partial<T>|TestFunctionPredicate<T>) => AssertPredicate<T>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  (
    /**
     * Generate an assertion from a check.
     * @param {Test} [test]
     * When nullish, checks if `node` is a `Node`.
     * When `string`, works like passing `function (node) {return node.type === test}`.
     * When `function` checks if function passed the node is true.
     * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
     * When `array`, checks any one of the subtests pass.
     * @returns {AssertAnything}
     */
    function (test) {
      if (test === undefined || test === null) {
        return ok
      }

      if (typeof test === 'string') {
        return typeFactory(test)
      }

      if (typeof test === 'object') {
        return Array.isArray(test) ? anyFactory(test) : propsFactory(test)
      }

      if (typeof test === 'function') {
        return castFactory(test)
      }

      throw new Error('Expected function, string, or object as test')
    }
  );
/**
 * @param {Array.<Type|Props|TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */
function anyFactory(tests) {
  /** @type {Array.<AssertAnything>} */
  const checks = [];
  let index = -1;

  while (++index < tests.length) {
    checks[index] = convert(tests[index]);
  }

  return castFactory(any)

  /**
   * @this {unknown}
   * @param {unknown[]} parameters
   * @returns {boolean}
   */
  function any(...parameters) {
    let index = -1;

    while (++index < checks.length) {
      if (checks[index].call(this, ...parameters)) return true
    }

    return false
  }
}

/**
 * Utility to assert each property in `test` is represented in `node`, and each
 * values are strictly equal.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */
function propsFactory(check) {
  return castFactory(all)

  /**
   * @param {Node} node
   * @returns {boolean}
   */
  function all(node) {
    /** @type {string} */
    let key;

    for (key in check) {
      // @ts-expect-error: hush, it sure works as an index.
      if (node[key] !== check[key]) return false
    }

    return true
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 *
 * @param {Type} check
 * @returns {AssertAnything}
 */
function typeFactory(check) {
  return castFactory(type)

  /**
   * @param {Node} node
   */
  function type(node) {
    return node && node.type === check
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */
function castFactory(check) {
  return assertion

  /**
   * @this {unknown}
   * @param {Array.<unknown>} parameters
   * @returns {boolean}
   */
  function assertion(...parameters) {
    // @ts-expect-error: spreading is fine.
    return Boolean(check.call(this, ...parameters))
  }
}

// Utility to return true.
function ok() {
  return true
}

/**
 * @param {string} d
 * @returns {string}
 */
function color$3(d) {
  return '\u001B[33m' + d + '\u001B[39m'
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('./complex-types').Action} Action
 * @typedef {import('./complex-types').Index} Index
 * @typedef {import('./complex-types').ActionTuple} ActionTuple
 * @typedef {import('./complex-types').VisitorResult} VisitorResult
 * @typedef {import('./complex-types').Visitor} Visitor
 */

/**
 * Continue traversing as normal
 */
const CONTINUE$3 = true;
/**
 * Do not traverse this node’s children
 */
const SKIP$3 = 'skip';
/**
 * Stop traversing immediately
 */
const EXIT$3 = false;

/**
 * Visit children of tree which pass a test
 *
 * @param tree Abstract syntax tree to walk
 * @param test Test node, optional
 * @param visitor Function to run for each node
 * @param reverse Visit the tree in reverse order, defaults to false
 */
const visitParents$3 =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types').Visitor<Node>} visitor
     * @param {boolean} [reverse]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
      }

      const is = convert(test);
      const step = reverse ? -1 : 1;

      factory(tree, null, [])();

      /**
       * @param {Node} node
       * @param {number?} index
       * @param {Array.<Parent>} parents
       */
      function factory(node, index, parents) {
        /** @type {Object.<string, unknown>} */
        // @ts-expect-error: hush
        const value = typeof node === 'object' && node !== null ? node : {};
        /** @type {string|undefined} */
        let name;

        if (typeof value.type === 'string') {
          name =
            typeof value.tagName === 'string'
              ? value.tagName
              : typeof value.name === 'string'
              ? value.name
              : undefined;

          Object.defineProperty(visit, 'name', {
            value:
              'node (' +
              color$3(value.type + (name ? '<' + name + '>' : '')) +
              ')'
          });
        }

        return visit

        function visit() {
          /** @type {ActionTuple} */
          let result = [];
          /** @type {ActionTuple} */
          let subresult;
          /** @type {number} */
          let offset;
          /** @type {Array.<Parent>} */
          let grandparents;

          if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = toResult$3(visitor(node, parents));

            if (result[0] === EXIT$3) {
              return result
            }
          }

          // @ts-expect-error looks like a parent.
          if (node.children && result[0] !== SKIP$3) {
            // @ts-expect-error looks like a parent.
            offset = (reverse ? node.children.length : -1) + step;
            // @ts-expect-error looks like a parent.
            grandparents = parents.concat(node);

            // @ts-expect-error looks like a parent.
            while (offset > -1 && offset < node.children.length) {
              // @ts-expect-error looks like a parent.
              subresult = factory(node.children[offset], offset, grandparents)();

              if (subresult[0] === EXIT$3) {
                return subresult
              }

              offset =
                typeof subresult[1] === 'number' ? subresult[1] : offset + step;
            }
          }

          return result
        }
      }
    }
  );

/**
 * @param {VisitorResult} value
 * @returns {ActionTuple}
 */
function toResult$3(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE$3, value]
  }

  return [value]
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 * @typedef {import('./complex-types').Visitor} Visitor
 */

/**
 * Visit children of tree which pass a test
 *
 * @param tree Abstract syntax tree to walk
 * @param test Test, optional
 * @param visitor Function to run for each node
 * @param reverse Fisit the tree in reverse, defaults to false
 */
const visit$2 =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types').Visitor} visitor
     * @param {boolean} [reverse]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
      }

      visitParents$3(tree, test, overload, reverse);

      /**
       * @param {Node} node
       * @param {Array.<Parent>} parents
       */
      function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(
          node,
          parent ? parent.children.indexOf(node) : null,
          parent
        )
      }
    }
  );

/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {Record<string, unknown> & {type: string, position?: PositionLike|undefined}} NodeLike
 * @typedef {import('unist').Point} Point
 *
 * @typedef {Partial<Point>} PointLike
 *
 * @typedef PositionLike
 * @property {PointLike} [start]
 * @property {PointLike} [end]
 */

const pointStart = point('start');
const pointEnd = point('end');

/**
 * Get the positional info of `node`.
 *
 * @param {'start'|'end'} type
 */
function point(type) {
  return point

  /**
   * Get the positional info of `node`.
   *
   * @param {NodeLike|Node} [node]
   * @returns {Point}
   */
  function point(node) {
    const point = (node && node.position && node.position[type]) || {};

    return {
      line: point.line || null,
      column: point.column || null,
      offset: point.offset > -1 ? point.offset : null
    }
  }
}

/**
 * @typedef {Object} PointLike
 * @property {number} [line]
 * @property {number} [column]
 * @property {number} [offset]
 *
 * @typedef {Object} PositionLike
 * @property {PointLike} [start]
 * @property {PointLike} [end]
 *
 * @typedef {Object} NodeLike
 * @property {PositionLike} [position]
 */

/**
 * Check if `node` is *generated*.
 *
 * @param {NodeLike} [node]
 * @returns {boolean}
 */
function generated(node) {
  return (
    !node ||
    !node.position ||
    !node.position.start ||
    !node.position.start.line ||
    !node.position.start.column ||
    !node.position.end ||
    !node.position.end.line ||
    !node.position.end.column
  )
}

/**
 * @param {string} d
 * @returns {string}
 */
function color$2(d) {
  return '\u001B[33m' + d + '\u001B[39m'
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */

/**
 * Continue traversing as normal
 */
const CONTINUE$2 = true;
/**
 * Do not traverse this node’s children
 */
const SKIP$2 = 'skip';
/**
 * Stop traversing immediately
 */
const EXIT$2 = false;

const visitParents$2 =
  /**
   * @type {(
   *   (<T extends Node>(tree: Node, test: T['type']|Partial<T>|import('unist-util-is').TestFunctionPredicate<T>|Array.<T['type']|Partial<T>|import('unist-util-is').TestFunctionPredicate<T>>, visitor: Visitor<T>, reverse?: boolean) => void) &
   *   ((tree: Node, test: Test, visitor: Visitor<Node>, reverse?: boolean) => void) &
   *   ((tree: Node, visitor: Visitor<Node>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * Visit children of tree which pass a test
     *
     * @param {Node} tree Abstract syntax tree to walk
     * @param {Test} test test Test node
     * @param {Visitor<Node>} visitor Function to run for each node
     * @param {boolean} [reverse] Fisit the tree in reverse, defaults to false
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-ignore no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
      }

      var is = convert(test);
      var step = reverse ? -1 : 1;

      factory(tree, null, [])();

      /**
       * @param {Node} node
       * @param {number?} index
       * @param {Array.<Parent>} parents
       */
      function factory(node, index, parents) {
        /** @type {Object.<string, unknown>} */
        var value = typeof node === 'object' && node !== null ? node : {};
        /** @type {string} */
        var name;

        if (typeof value.type === 'string') {
          name =
            typeof value.tagName === 'string'
              ? value.tagName
              : typeof value.name === 'string'
              ? value.name
              : undefined;

          Object.defineProperty(visit, 'name', {
            value:
              'node (' +
              color$2(value.type + (name ? '<' + name + '>' : '')) +
              ')'
          });
        }

        return visit

        function visit() {
          /** @type {ActionTuple} */
          var result = [];
          /** @type {ActionTuple} */
          var subresult;
          /** @type {number} */
          var offset;
          /** @type {Array.<Parent>} */
          var grandparents;

          if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = toResult$2(visitor(node, parents));

            if (result[0] === EXIT$2) {
              return result
            }
          }

          if (node.children && result[0] !== SKIP$2) {
            // @ts-ignore looks like a parent.
            offset = (reverse ? node.children.length : -1) + step;
            // @ts-ignore looks like a parent.
            grandparents = parents.concat(node);

            // @ts-ignore looks like a parent.
            while (offset > -1 && offset < node.children.length) {
              subresult = factory(node.children[offset], offset, grandparents)();

              if (subresult[0] === EXIT$2) {
                return subresult
              }

              offset =
                typeof subresult[1] === 'number' ? subresult[1] : offset + step;
            }
          }

          return result
        }
      }
    }
  );

/**
 * @param {VisitorResult} value
 * @returns {ActionTuple}
 */
function toResult$2(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE$2, value]
  }

  return [value]
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */

const visit$1 =
  /**
   * @type {(
   *   (<T extends Node>(tree: Node, test: T['type']|Partial<T>|import('unist-util-is').TestFunctionPredicate<T>|Array.<T['type']|Partial<T>|import('unist-util-is').TestFunctionPredicate<T>>, visitor: Visitor<T>, reverse?: boolean) => void) &
   *   ((tree: Node, test: Test, visitor: Visitor<Node>, reverse?: boolean) => void) &
   *   ((tree: Node, visitor: Visitor<Node>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * Visit children of tree which pass a test
     *
     * @param {Node} tree Abstract syntax tree to walk
     * @param {Test} test test Test node
     * @param {Visitor<Node>} visitor Function to run for each node
     * @param {boolean} [reverse] Fisit the tree in reverse, defaults to false
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
      }

      visitParents$2(tree, test, overload, reverse);

      /**
       * @param {Node} node
       * @param {Array.<Parent>} parents
       */
      function overload(node, parents) {
        var parent = parents[parents.length - 1];
        return visitor(
          node,
          parent ? parent.children.indexOf(node) : null,
          parent
        )
      }
    }
  );

/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('unist-util-visit').Visitor<Definition>} DefinitionVisitor
 */

const own$5 = {}.hasOwnProperty;

/**
 *
 * @param {Node} node
 */
function definitions$2(node) {
  /** @type {Object.<string, Definition>} */
  const cache = Object.create(null);

  if (!node || !node.type) {
    throw new Error('mdast-util-definitions expected node')
  }

  visit$1(node, 'definition', ondefinition);

  return getDefinition

  /** @type {DefinitionVisitor} */
  function ondefinition(definition) {
    const id = clean(definition.identifier);
    if (id && !own$5.call(cache, id)) {
      cache[id] = definition;
    }
  }

  /**
   * Get a node from the bound definition-cache.
   *
   * @param {string} identifier
   * @returns {Definition|null}
   */
  function getDefinition(identifier) {
    const id = clean(identifier);
    return id && own$5.call(cache, id) ? cache[id] : null
  }
}

/**
 * @param {string} [value]
 * @returns {string}
 */
function clean(value) {
  return String(value || '').toUpperCase()
}

const characterReferences = {'"': 'quot', '&': 'amp', '<': 'lt', '>': 'gt'};

/**
 * Encode only the dangerous HTML characters.
 *
 * This ensures that certain characters which have special meaning in HTML are
 * dealt with.
 * Technically, we can skip `>` and `"` in many cases, but CM includes them.
 *
 * @param {string} value
 * @returns {string}
 */
function encode$b(value) {
  return value.replace(/["&<>]/g, replace)

  /**
   * @param {string} value
   * @returns {string}
   */
  function replace(value) {
    // @ts-expect-error Hush, it’s fine.
    return '&' + characterReferences[value] + ';'
  }
}

/**
 * Make a value safe for injection as a URL.
 *
 * This encodes unsafe characters with percent-encoding and skips already
 * encoded sequences (see `normalizeUri` below).
 * Further unsafe characters are encoded as character references (see
 * `micromark-util-encode`).
 *
 * Then, a regex of allowed protocols can be given, in which case the URL is
 * sanitized.
 * For example, `/^(https?|ircs?|mailto|xmpp)$/i` can be used for `a[href]`,
 * or `/^https?$/i` for `img[src]`.
 * If the URL includes an unknown protocol (one not matched by `protocol`, such
 * as a dangerous example, `javascript:`), the value is ignored.
 *
 * @param {string|undefined} url
 * @param {RegExp} [protocol]
 * @returns {string}
 */
function sanitizeUri(url, protocol) {
  const value = encode$b(normalizeUri(url || ''));

  if (!protocol) {
    return value
  }

  const colon = value.indexOf(':');
  const questionMark = value.indexOf('?');
  const numberSign = value.indexOf('#');
  const slash = value.indexOf('/');

  if (
    // If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    (slash > -1 && colon > slash) ||
    (questionMark > -1 && colon > questionMark) ||
    (numberSign > -1 && colon > numberSign) || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))
  ) {
    return value
  }

  return ''
}
/**
 * Normalize a URL (such as used in definitions).
 *
 * Encode unsafe characters with percent-encoding, skipping already encoded
 * sequences.
 *
 * @param {string} value
 * @returns {string}
 */

function normalizeUri(value) {
  /** @type {string[]} */
  const result = [];
  let index = -1;
  let start = 0;
  let skip = 0;

  while (++index < value.length) {
    const code = value.charCodeAt(index);
    /** @type {string} */

    let replace = ''; // A correct percent encoded value.

    if (
      code === 37 &&
      asciiAlphanumeric(value.charCodeAt(index + 1)) &&
      asciiAlphanumeric(value.charCodeAt(index + 2))
    ) {
      skip = 2;
    } // ASCII.
    else if (code < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) {
        replace = String.fromCharCode(code);
      }
    } // Astral.
    else if (code > 55295 && code < 57344) {
      const next = value.charCodeAt(index + 1); // A correct surrogate pair.

      if (code < 56320 && next > 56319 && next < 57344) {
        replace = String.fromCharCode(code, next);
        skip = 1;
      } // Lone surrogate.
      else {
        replace = '\uFFFD';
      }
    } // Unicode.
    else {
      replace = String.fromCharCode(code);
    }

    if (replace) {
      result.push(value.slice(start, index), encodeURIComponent(replace));
      start = index + skip + 1;
      replace = '';
    }

    if (skip) {
      index += skip;
      skip = 0;
    }
  }

  return result.join('') + value.slice(start)
}

/**
 * @typedef {import('./index.js').Content} Content
 */

/**
 * Wrap `nodes` with line feeds between each entry.
 * Optionally adds line feeds at the start and end.
 *
 * @param {Array<Content>} nodes
 * @param {boolean} [loose=false]
 * @returns {Array<Content>}
 */
function wrap$1(nodes, loose) {
  /** @type {Array<Content>} */
  const result = [];
  let index = -1;

  if (loose) {
    result.push(u$1('text', '\n'));
  }

  while (++index < nodes.length) {
    if (index) result.push(u$1('text', '\n'));
    result.push(nodes[index]);
  }

  if (loose && nodes.length > 0) {
    result.push(u$1('text', '\n'));
  }

  return result
}

/**
 * @typedef {import('mdast').BlockContent} BlockContent
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('./index.js').H} H
 */

/**
 * @param {H} h
 */
function footer(h) {
  let index = -1;
  /** @type {Array<ElementContent>} */
  const listItems = [];

  while (++index < h.footnoteOrder.length) {
    const def = h.footnoteById[h.footnoteOrder[index].toUpperCase()];

    if (!def) {
      continue
    }

    const content = all(h, def);
    const id = String(def.identifier);
    const safeId = sanitizeUri(id.toLowerCase());
    let referenceIndex = 0;
    /** @type {Array<ElementContent>} */
    const backReferences = [];

    while (++referenceIndex <= h.footnoteCounts[id]) {
      /** @type {Element} */
      const backReference = {
        type: 'element',
        tagName: 'a',
        properties: {
          href:
            '#' +
            h.clobberPrefix +
            'fnref-' +
            safeId +
            (referenceIndex > 1 ? '-' + referenceIndex : ''),
          dataFootnoteBackref: true,
          className: ['data-footnote-backref'],
          ariaLabel: h.footnoteBackLabel
        },
        children: [{type: 'text', value: '↩'}]
      };

      if (referenceIndex > 1) {
        backReference.children.push({
          type: 'element',
          tagName: 'sup',
          children: [{type: 'text', value: String(referenceIndex)}]
        });
      }

      if (backReferences.length > 0) {
        backReferences.push({type: 'text', value: ' '});
      }

      backReferences.push(backReference);
    }

    const tail = content[content.length - 1];

    if (tail && tail.type === 'element' && tail.tagName === 'p') {
      const tailTail = tail.children[tail.children.length - 1];
      if (tailTail && tailTail.type === 'text') {
        tailTail.value += ' ';
      } else {
        tail.children.push({type: 'text', value: ' '});
      }

      tail.children.push(...backReferences);
    } else {
      content.push(...backReferences);
    }

    /** @type {Element} */
    const listItem = {
      type: 'element',
      tagName: 'li',
      properties: {id: h.clobberPrefix + 'fn-' + safeId},
      children: wrap$1(content, true)
    };

    if (def.position) {
      listItem.position = def.position;
    }

    listItems.push(listItem);
  }

  if (listItems.length === 0) {
    return null
  }

  return {
    type: 'element',
    tagName: 'section',
    properties: {dataFootnotes: true, className: ['footnotes']},
    children: [
      {
        type: 'element',
        tagName: 'h2',
        properties: {id: 'footnote-label', className: ['sr-only']},
        children: [u$1('text', h.footnoteLabel)]
      },
      {type: 'text', value: '\n'},
      {
        type: 'element',
        tagName: 'ol',
        properties: {},
        children: wrap$1(listItems, true)
      },
      {type: 'text', value: '\n'}
    ]
  }
}

/**
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {Blockquote} node
 */
function blockquote(h, node) {
  return h(node, 'blockquote', wrap$1(all(h, node), true))
}

/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {Break} node
 * @returns {Array<Element|Text>}
 */
function hardBreak(h, node) {
  return [h(node, 'br'), u$1('text', '\n')]
}

/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {Code} node
 */
function code$4(h, node) {
  const value = node.value ? node.value + '\n' : '';
  // To do: next major, use `node.lang` w/o regex, the splitting’s been going
  // on for years in remark now.
  const lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/);
  /** @type {Properties} */
  const props = {};

  if (lang) {
    props.className = ['language-' + lang];
  }

  const code = h(node, 'code', props, [u$1('text', value)]);

  if (node.meta) {
    code.data = {meta: node.meta};
  }

  return h(node.position, 'pre', [code])
}

/**
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {Delete} node
 */
function strikethrough(h, node) {
  return h(node, 'del', all(h, node))
}

/**
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {Emphasis} node
 */
function emphasis(h, node) {
  return h(node, 'em', all(h, node))
}

/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {FootnoteReference} node
 */
function footnoteReference(h, node) {
  const id = String(node.identifier);
  const safeId = sanitizeUri(id.toLowerCase());
  const index = h.footnoteOrder.indexOf(id);
  /** @type {number} */
  let counter;

  if (index === -1) {
    h.footnoteOrder.push(id);
    h.footnoteCounts[id] = 1;
    counter = h.footnoteOrder.length;
  } else {
    h.footnoteCounts[id]++;
    counter = index + 1;
  }

  const reuseCounter = h.footnoteCounts[id];

  return h(node, 'sup', [
    h(
      node.position,
      'a',
      {
        href: '#' + h.clobberPrefix + 'fn-' + safeId,
        id:
          h.clobberPrefix +
          'fnref-' +
          safeId +
          (reuseCounter > 1 ? '-' + reuseCounter : ''),
        dataFootnoteRef: true,
        ariaDescribedBy: 'footnote-label'
      },
      [u$1('text', String(counter))]
    )
  ])
}

/**
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../index.js').Handler} Handler
 *
 * @todo
 *   `footnote` (or “inline note”) are a pandoc footnotes feature (`^[a note]`)
 *   that does not exist in GFM.
 *   We still have support for it, so that things remain working with
 *   `micromark-extension-footnote` and `mdast-util-footnote`, but in the future
 *   we might be able to remove it?
 */

/**
 * @type {Handler}
 * @param {Footnote} node
 */
function footnote(h, node) {
  const footnoteById = h.footnoteById;
  let no = 1;

  while (no in footnoteById) no++;

  const identifier = String(no);

  footnoteById[identifier] = {
    type: 'footnoteDefinition',
    identifier,
    children: [{type: 'paragraph', children: node.children}],
    position: node.position
  };

  return footnoteReference(h, {
    type: 'footnoteReference',
    identifier,
    position: node.position
  })
}

/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {Heading} node
 */
function heading(h, node) {
  return h(node, 'h' + node.depth, all(h, node))
}

/**
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * Return either a `raw` node in dangerous mode, otherwise nothing.
 *
 * @type {Handler}
 * @param {HTML} node
 */
function html$2(h, node) {
  return h.dangerous ? h.augment(node, u$1('raw', node.value)) : null
}

var encodeCache = {};


// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function getEncodeCache(exclude) {
  var i, ch, cache = encodeCache[exclude];
  if (cache) { return cache; }

  cache = encodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);

    if (/^[0-9a-z]$/i.test(ch)) {
      // always allow unencoded alphanumeric characters
      cache.push(ch);
    } else {
      cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
  }

  for (i = 0; i < exclude.length; i++) {
    cache[exclude.charCodeAt(i)] = exclude[i];
  }

  return cache;
}


// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function encode$a(string, exclude, keepEscaped) {
  var i, l, code, nextCode, cache,
      result = '';

  if (typeof exclude !== 'string') {
    // encode(string, keepEscaped)
    keepEscaped  = exclude;
    exclude = encode$a.defaultChars;
  }

  if (typeof keepEscaped === 'undefined') {
    keepEscaped = true;
  }

  cache = getEncodeCache(exclude);

  for (i = 0, l = string.length; i < l; i++) {
    code = string.charCodeAt(i);

    if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
      if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
        result += string.slice(i, i + 3);
        i += 2;
        continue;
      }
    }

    if (code < 128) {
      result += cache[code];
      continue;
    }

    if (code >= 0xD800 && code <= 0xDFFF) {
      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
        nextCode = string.charCodeAt(i + 1);
        if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
          result += encodeURIComponent(string[i] + string[i + 1]);
          i++;
          continue;
        }
      }
      result += '%EF%BF%BD';
      continue;
    }

    result += encodeURIComponent(string[i]);
  }

  return result;
}

encode$a.defaultChars   = ";/?:@&=+$,-_.!~*'()#";
encode$a.componentChars = "-_.!~*'()";


var encode_1$3 = encode$a;

/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('./index.js').Handler} Handler
 * @typedef {import('./index.js').Content} Content
 */

/**
 * Return the content of a reference without definition as plain text.
 *
 * @type {Handler}
 * @param {ImageReference|LinkReference} node
 * @returns {Content|Array<Content>}
 */
function revert(h, node) {
  const subtype = node.referenceType;
  let suffix = ']';

  if (subtype === 'collapsed') {
    suffix += '[]';
  } else if (subtype === 'full') {
    suffix += '[' + (node.label || node.identifier) + ']';
  }

  if (node.type === 'imageReference') {
    return u$1('text', '![' + node.alt + suffix)
  }

  const contents = all(h, node);
  const head = contents[0];

  if (head && head.type === 'text') {
    head.value = '[' + head.value;
  } else {
    contents.unshift(u$1('text', '['));
  }

  const tail = contents[contents.length - 1];

  if (tail && tail.type === 'text') {
    tail.value += suffix;
  } else {
    contents.push(u$1('text', suffix));
  }

  return contents
}

/**
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {ImageReference} node
 */
function imageReference(h, node) {
  const def = h.definition(node.identifier);

  if (!def) {
    return revert(h, node)
  }

  /** @type {Properties} */
  const props = {src: encode_1$3(def.url || ''), alt: node.alt};

  if (def.title !== null && def.title !== undefined) {
    props.title = def.title;
  }

  return h(node, 'img', props)
}

/**
 * @typedef {import('mdast').Image} Image
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {Image} node
 */
function image(h, node) {
  /** @type {Properties} */
  const props = {src: encode_1$3(node.url), alt: node.alt};

  if (node.title !== null && node.title !== undefined) {
    props.title = node.title;
  }

  return h(node, 'img', props)
}

/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {InlineCode} node
 */
function inlineCode$1(h, node) {
  return h(node, 'code', [u$1('text', node.value.replace(/\r?\n|\r/g, ' '))])
}

/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {LinkReference} node
 */
function linkReference(h, node) {
  const def = h.definition(node.identifier);

  if (!def) {
    return revert(h, node)
  }

  /** @type {Properties} */
  const props = {href: encode_1$3(def.url || '')};

  if (def.title !== null && def.title !== undefined) {
    props.title = def.title;
  }

  return h(node, 'a', props, all(h, node))
}

/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {Link} node
 */
function link(h, node) {
  /** @type {Properties} */
  const props = {href: encode_1$3(node.url)};

  if (node.title !== null && node.title !== undefined) {
    props.title = node.title;
  }

  return h(node, 'a', props, all(h, node))
}

/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').List} List
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 * @typedef {import('../index.js').Content} Content
 */

/**
 * @type {Handler}
 * @param {ListItem} node
 * @param {List} parent
 */
function listItem$1(h, node, parent) {
  const result = all(h, node);
  const loose = parent ? listLoose(parent) : listItemLoose(node);
  /** @type {Properties} */
  const props = {};
  /** @type {Array<Content>} */
  const wrapped = [];

  if (typeof node.checked === 'boolean') {
    /** @type {Element} */
    let paragraph;

    if (
      result[0] &&
      result[0].type === 'element' &&
      result[0].tagName === 'p'
    ) {
      paragraph = result[0];
    } else {
      paragraph = h(null, 'p', []);
      result.unshift(paragraph);
    }

    if (paragraph.children.length > 0) {
      paragraph.children.unshift(u$1('text', ' '));
    }

    paragraph.children.unshift(
      h(null, 'input', {
        type: 'checkbox',
        checked: node.checked,
        disabled: true
      })
    );

    // According to github-markdown-css, this class hides bullet.
    // See: <https://github.com/sindresorhus/github-markdown-css>.
    props.className = ['task-list-item'];
  }

  let index = -1;

  while (++index < result.length) {
    const child = result[index];

    // Add eols before nodes, except if this is a loose, first paragraph.
    if (
      loose ||
      index !== 0 ||
      child.type !== 'element' ||
      child.tagName !== 'p'
    ) {
      wrapped.push(u$1('text', '\n'));
    }

    if (child.type === 'element' && child.tagName === 'p' && !loose) {
      wrapped.push(...child.children);
    } else {
      wrapped.push(child);
    }
  }

  const tail = result[result.length - 1];

  // Add a final eol.
  if (tail && (loose || !('tagName' in tail) || tail.tagName !== 'p')) {
    wrapped.push(u$1('text', '\n'));
  }

  return h(node, 'li', props, wrapped)
}

/**
 * @param {List} node
 * @return {Boolean}
 */
function listLoose(node) {
  let loose = node.spread;
  const children = node.children;
  let index = -1;

  while (!loose && ++index < children.length) {
    loose = listItemLoose(children[index]);
  }

  return Boolean(loose)
}

/**
 * @param {ListItem} node
 * @return {Boolean}
 */
function listItemLoose(node) {
  const spread = node.spread;

  return spread === undefined || spread === null
    ? node.children.length > 1
    : spread
}

/**
 * @typedef {import('mdast').List} List
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {List} node
 * @returns {Element}
 */
function list(h, node) {
  /** @type {Properties} */
  const props = {};
  const name = node.ordered ? 'ol' : 'ul';
  const items = all(h, node);
  let index = -1;

  if (typeof node.start === 'number' && node.start !== 1) {
    props.start = node.start;
  }

  // Like GitHub, add a class for custom styling.
  while (++index < items.length) {
    const item = items[index];

    if (
      item.type === 'element' &&
      item.tagName === 'li' &&
      item.properties &&
      Array.isArray(item.properties.className) &&
      item.properties.className.includes('task-list-item')
    ) {
      props.className = ['contains-task-list'];
      break
    }
  }

  return h(node, name, props, wrap$1(items, true))
}

/**
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {Paragraph} node
 */
function paragraph(h, node) {
  return h(node, 'p', all(h, node))
}

/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {Root} node
 */
function root$1(h, node) {
  // @ts-expect-error `root`s are also fine.
  return h.augment(node, u$1('root', wrap$1(all(h, node))))
}

/**
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {Strong} node
 */
function strong(h, node) {
  return h(node, 'strong', all(h, node))
}

/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 * @typedef {import('../index.js').Content} Content
 */

/**
 * @type {Handler}
 * @param {Table} node
 */
function table(h, node) {
  const rows = node.children;
  let index = -1;
  const align = node.align || [];
  /** @type {Array<Element>} */
  const result = [];

  while (++index < rows.length) {
    const row = rows[index].children;
    const name = index === 0 ? 'th' : 'td';
    /** @type {Array<Content>} */
    const out = [];
    let cellIndex = -1;
    const length = node.align ? align.length : row.length;

    while (++cellIndex < length) {
      const cell = row[cellIndex];
      out.push(
        h(cell, name, {align: align[cellIndex]}, cell ? all(h, cell) : [])
      );
    }

    result[index] = h(rows[index], 'tr', wrap$1(out, true));
  }

  return h(
    node,
    'table',
    wrap$1(
      [h(result[0].position, 'thead', wrap$1([result[0]], true))].concat(
        result[1]
          ? h(
              {
                start: pointStart(result[1]),
                end: pointEnd(result[result.length - 1])
              },
              'tbody',
              wrap$1(result.slice(1), true)
            )
          : []
      ),
      true
    )
  )
}

/**
 * @typedef {import('mdast').Text} Text
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {Text} node
 */
function text$1(h, node) {
  return h.augment(
    node,
    u$1('text', String(node.value).replace(/[ \t]*(\r?\n|\r)[ \t]*/g, '$1'))
  )
}

/**
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('hast').Element} Element
 * @typedef {import('../index.js').Handler} Handler
 */

/**
 * @type {Handler}
 * @param {ThematicBreak} [node]
 * @returns {Element}
 */
function thematicBreak(h, node) {
  return h(node, 'hr')
}

const handlers = {
  blockquote,
  break: hardBreak,
  code: code$4,
  delete: strikethrough,
  emphasis,
  footnoteReference,
  footnote,
  heading,
  html: html$2,
  imageReference,
  image,
  inlineCode: inlineCode$1,
  linkReference,
  link,
  listItem: listItem$1,
  list,
  paragraph,
  root: root$1,
  strong,
  table,
  text: text$1,
  thematicBreak,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
};

// Return nothing for nodes that are ignored.
function ignore() {
  return null
}

/**
 * @typedef {import('mdast').Root|import('mdast').Parent['children'][number]} MdastNode
 * @typedef {import('hast').Root|import('hast').Parent['children'][number]} HastNode
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').ElementContent} Content
 * @typedef {import('unist-util-position').PositionLike} PositionLike
 *
 * @typedef EmbeddedHastFields
 * @property {string} [hName] Defines the tag name of an element
 * @property {Properties} [hProperties] Defines the properties of an element
 * @property {Array<Content>} [hChildren] Defines the (hast) children of an element
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} Data unist data with embedded hast fields
 *
 * @typedef {MdastNode & {data?: Data}} NodeWithData unist node with embedded hast data
 *
 * @callback Handler
 * @param {H} h Handle context
 * @param {any} node mdast node to handle
 * @param {Parent|null} parent Parent of `node`
 * @returns {Content|Array<Content>|null|undefined} hast node
 *
 * @callback HFunctionProps
 * @param {MdastNode|PositionLike|null|undefined} node mdast node or unist position
 * @param {string} tagName HTML tag name
 * @param {Properties} props Properties
 * @param {Array<Content>?} [children] hast content
 * @returns {Element}
 *
 * @callback HFunctionNoProps
 * @param {MdastNode|PositionLike|null|undefined} node mdast node or unist position
 * @param {string} tagName HTML tag name
 * @param {Array<Content>?} [children] hast content
 * @returns {Element}
 *
 * @typedef HFields
 * @property {boolean} dangerous Whether HTML is allowed
 * @property {string} clobberPrefix Prefix to use to prevent DOM clobbering
 * @property {string} footnoteLabel Label to use to introduce the footnote section
 * @property {string} footnoteBackLabel Label to use to go back to a footnote call from the footnote section
 * @property {(identifier: string) => Definition|null} definition Definition cache
 * @property {Record<string, FootnoteDefinition>} footnoteById Footnote cache
 * @property {Array<string>} footnoteOrder Order in which footnotes occur
 * @property {Record<string, number>} footnoteCounts Counts the same footnote was used
 * @property {Handlers} handlers Applied handlers
 * @property {Handler} unknownHandler Handler for any none not in `passThrough` or otherwise handled
 * @property {(left: NodeWithData|PositionLike|null|undefined, right: Content) => Content} augment Like `h` but lower-level and usable on non-elements.
 * @property {Array<string>} passThrough List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 * @property {boolean} [allowDangerousHtml=false]
 *   Whether to allow `html` nodes and inject them as `raw` HTML
 * @property {string} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute to prevent it from *clobbering*.
 *   attributes.
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id=x></p>
 *   <script>alert(x)</script>
 *   ```
 *
 *   Elements by their ID are made available in browsers on the `window` object.
 *   Using a prefix prevents this from being a problem.
 * @property {string} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section.
 *   Affects screen reader users.
 *   Change it if you’re authoring in a different language.
 * @property {string} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call.
 *   Affects screen reader users.
 *   Change it if you’re authoring in a different language.
 * @property {Handlers} [handlers]
 *   Object mapping mdast nodes to functions handling them
 * @property {Array<string>} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast
 * @property {Handler} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Map of node types to handlers
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} H
 *   Handle context
 */

const own$4 = {}.hasOwnProperty;

/**
 * Factory to transform.
 * @param {MdastNode} tree mdast node
 * @param {Options} [options] Configuration
 * @returns {H} `h` function
 */
function factory(tree, options) {
  const settings = options || {};
  const dangerous = settings.allowDangerousHtml || false;
  /** @type {Record<string, FootnoteDefinition>} */
  const footnoteById = {};

  h.dangerous = dangerous;
  h.clobberPrefix =
    settings.clobberPrefix === undefined || settings.clobberPrefix === null
      ? 'user-content-'
      : settings.clobberPrefix;
  h.footnoteLabel = settings.footnoteLabel || 'Footnotes';
  h.footnoteBackLabel = settings.footnoteBackLabel || 'Back to content';
  h.definition = definitions$2(tree);
  h.footnoteById = footnoteById;
  /** @type {Array<string>} */
  h.footnoteOrder = [];
  /** @type {Record<string, number>} */
  h.footnoteCounts = {};
  h.augment = augment;
  h.handlers = {...handlers, ...settings.handlers};
  h.unknownHandler = settings.unknownHandler;
  h.passThrough = settings.passThrough;

  visit$2(tree, 'footnoteDefinition', (definition) => {
    const id = String(definition.identifier).toUpperCase();

    // Mimick CM behavior of link definitions.
    // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
    if (!own$4.call(footnoteById, id)) {
      footnoteById[id] = definition;
    }
  });

  // @ts-expect-error Hush, it’s fine!
  return h

  /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   * @param {(NodeWithData|PositionLike)?} left
   * @param {Content} right
   * @returns {Content}
   */
  function augment(left, right) {
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (left && 'data' in left && left.data) {
      /** @type {Data} */
      const data = left.data;

      if (data.hName) {
        if (right.type !== 'element') {
          right = {
            type: 'element',
            tagName: '',
            properties: {},
            children: []
          };
        }

        right.tagName = data.hName;
      }

      if (right.type === 'element' && data.hProperties) {
        right.properties = {...right.properties, ...data.hProperties};
      }

      if ('children' in right && right.children && data.hChildren) {
        right.children = data.hChildren;
      }
    }

    if (left) {
      const ctx = 'type' in left ? left : {position: left};

      if (!generated(ctx)) {
        right.position = {start: pointStart(ctx), end: pointEnd(ctx)};
      }
    }

    return right
  }

  /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */
  function h(node, tagName, props, children) {
    if (Array.isArray(props)) {
      children = props;
      props = {};
    }

    // @ts-expect-error augmenting an element yields an element.
    return augment(node, {
      type: 'element',
      tagName,
      properties: props || {},
      children: children || []
    })
  }
}

/**
 * Transform `tree` (an mdast node) to a hast node.
 *
 * @param {MdastNode} tree mdast node
 * @param {Options} [options] Configuration
 * @returns {HastNode|null|undefined} hast node
 */
function toHast(tree, options) {
  const h = factory(tree, options);
  const node = one(h, tree, null);
  const foot = footer(h);

  if (foot) {
    // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push(u$1('text', '\n'), foot);
  }

  return Array.isArray(node) ? {type: 'root', children: node} : node
}

/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */

// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(

/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */
const remarkRehype =
  /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */
  (
    function (destination, options) {
      return destination && 'run' in destination
        ? bridge(destination, options)
        : mutate(destination || options)
    }
  );

var remarkRehype$1 = remarkRehype;

/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */
function bridge(destination, options) {
  return (node, file, next) => {
    destination.run(toHast(node, options), file, (error) => {
      next(error);
    });
  }
}

/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */
function mutate(options) {
  // @ts-expect-error: assume a corresponding node is returned by `toHast`.
  return (node) => toHast(node, options)
}

/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */

class Schema {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(property, normal, space) {
    this.property = property;
    this.normal = normal;
    if (space) {
      this.space = space;
    }
  }
}

/** @type {Properties} */
Schema.prototype.property = {};
/** @type {Normal} */
Schema.prototype.normal = {};
/** @type {string|null} */
Schema.prototype.space = null;

/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */

/**
 * @param {Schema[]} definitions
 * @param {string} [space]
 * @returns {Schema}
 */
function merge$1(definitions, space) {
  /** @type {Properties} */
  const property = {};
  /** @type {Normal} */
  const normal = {};
  let index = -1;

  while (++index < definitions.length) {
    Object.assign(property, definitions[index].property);
    Object.assign(normal, definitions[index].normal);
  }

  return new Schema(property, normal, space)
}

/**
 * @param {string} value
 * @returns {string}
 */
function normalize(value) {
  return value.toLowerCase()
}

class Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(property, attribute) {
    /** @type {string} */
    this.property = property;
    /** @type {string} */
    this.attribute = attribute;
  }
}

/** @type {string|null} */
Info.prototype.space = null;
Info.prototype.boolean = false;
Info.prototype.booleanish = false;
Info.prototype.overloadedBoolean = false;
Info.prototype.number = false;
Info.prototype.commaSeparated = false;
Info.prototype.spaceSeparated = false;
Info.prototype.commaOrSpaceSeparated = false;
Info.prototype.mustUseProperty = false;
Info.prototype.defined = false;

let powers = 0;

const boolean = increment();
const booleanish = increment();
const overloadedBoolean = increment();
const number = increment();
const spaceSeparated = increment();
const commaSeparated = increment();
const commaOrSpaceSeparated = increment();

function increment() {
  return 2 ** ++powers
}

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  boolean: boolean,
  booleanish: booleanish,
  overloadedBoolean: overloadedBoolean,
  number: number,
  spaceSeparated: spaceSeparated,
  commaSeparated: commaSeparated,
  commaOrSpaceSeparated: commaOrSpaceSeparated
});

/** @type {Array<keyof types>} */
// @ts-expect-error: hush.
const checks = Object.keys(types);

class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(property, attribute, mask, space) {
    let index = -1;

    super(property, attribute);

    mark(this, 'space', space);

    if (typeof mask === 'number') {
      while (++index < checks.length) {
        const check = checks[index];
        mark(this, checks[index], (mask & types[check]) === types[check]);
      }
    }
  }
}

DefinedInfo.prototype.defined = true;

/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */
function mark(values, key, value) {
  if (value) {
    // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
  }
}

/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */

const own$3 = {}.hasOwnProperty;

/**
 * @param {Definition} definition
 * @returns {Schema}
 */
function create$1(definition) {
  /** @type {Properties} */
  const property = {};
  /** @type {Normal} */
  const normal = {};
  /** @type {string} */
  let prop;

  for (prop in definition.properties) {
    if (own$3.call(definition.properties, prop)) {
      const value = definition.properties[prop];
      const info = new DefinedInfo(
        prop,
        definition.transform(definition.attributes || {}, prop),
        value,
        definition.space
      );

      if (
        definition.mustUseProperty &&
        definition.mustUseProperty.includes(prop)
      ) {
        info.mustUseProperty = true;
      }

      property[prop] = info;

      normal[normalize(prop)] = prop;
      normal[normalize(info.attribute)] = prop;
    }
  }

  return new Schema(property, normal, definition.space)
}

const xlink = create$1({
  space: 'xlink',
  transform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase()
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
});

const xml = create$1({
  space: 'xml',
  transform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase()
  },
  properties: {xmlLang: null, xmlBase: null, xmlSpace: null}
});

/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}

/**
 * @param {Record<string, string>} attributes
 * @param {string} property
 * @returns {string}
 */
function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}

const xmlns = create$1({
  space: 'xmlns',
  attributes: {xmlnsxlink: 'xmlns:xlink'},
  transform: caseInsensitiveTransform,
  properties: {xmlns: null, xmlnsXLink: null}
});

const aria = create$1({
  transform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  }
});

const html$1 = create$1({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    capture: boolean,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: boolean, // Lists. Use CSS to reduce space between items instead
    declare: boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: number, // `<img>` and `<object>`
    leftMargin: number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: number, // `<body>`
    marginWidth: number, // `<body>`
    noResize: boolean, // `<frame>`
    noHref: boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  }
});

const svg$1 = create$1({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: caseSensitiveTransform,
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
});

/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */

const valid = /^data[-\w.:]+$/i;
const dash = /-[a-z]/g;
const cap = /[A-Z]/g;

/**
 * @param {Schema} schema
 * @param {string} value
 * @returns {Info}
 */
function find(schema, value) {
  const normal = normalize(value);
  let prop = value;
  let Type = Info;

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === 'data' && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      const rest = value.slice(5).replace(dash, camelcase);
      prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
    } else {
      // Turn it into an attribute.
      const rest = value.slice(4);

      if (!dash.test(rest)) {
        let dashes = rest.replace(cap, kebab);

        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes;
        }

        value = 'data' + dashes;
      }
    }

    Type = DefinedInfo;
  }

  return new Type(prop, value)
}

/**
 * @param {string} $0
 * @returns {string}
 */
function kebab($0) {
  return '-' + $0.toLowerCase()
}

/**
 * @param {string} $0
 * @returns {string}
 */
function camelcase($0) {
  return $0.charAt(1).toUpperCase()
}

const hastToReact = {
  classId: 'classID',
  dataType: 'datatype',
  itemId: 'itemID',
  strokeDashArray: 'strokeDasharray',
  strokeDashOffset: 'strokeDashoffset',
  strokeLineCap: 'strokeLinecap',
  strokeLineJoin: 'strokeLinejoin',
  strokeMiterLimit: 'strokeMiterlimit',
  typeOf: 'typeof',
  xLinkActuate: 'xlinkActuate',
  xLinkArcRole: 'xlinkArcrole',
  xLinkHref: 'xlinkHref',
  xLinkRole: 'xlinkRole',
  xLinkShow: 'xlinkShow',
  xLinkTitle: 'xlinkTitle',
  xLinkType: 'xlinkType',
  xmlnsXLink: 'xmlnsXlink'
};

/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */
const html = merge$1([xml, xlink, xmlns, aria, html$1], 'html');
const svg = merge$1([xml, xlink, xmlns, aria, svg$1], 'svg');

/**
 * @param {string} d
 * @returns {string}
 */
function color$1(d) {
  return '\u001B[33m' + d + '\u001B[39m'
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('./complex-types').Action} Action
 * @typedef {import('./complex-types').Index} Index
 * @typedef {import('./complex-types').ActionTuple} ActionTuple
 * @typedef {import('./complex-types').VisitorResult} VisitorResult
 * @typedef {import('./complex-types').Visitor} Visitor
 */

/**
 * Continue traversing as normal
 */
const CONTINUE$1 = true;
/**
 * Do not traverse this node’s children
 */
const SKIP$1 = 'skip';
/**
 * Stop traversing immediately
 */
const EXIT$1 = false;

/**
 * Visit children of tree which pass a test
 *
 * @param tree Abstract syntax tree to walk
 * @param test Test node, optional
 * @param visitor Function to run for each node
 * @param reverse Visit the tree in reverse order, defaults to false
 */
const visitParents$1 =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types').Visitor<Node>} visitor
     * @param {boolean} [reverse]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
      }

      const is = convert(test);
      const step = reverse ? -1 : 1;

      factory(tree, null, [])();

      /**
       * @param {Node} node
       * @param {number?} index
       * @param {Array.<Parent>} parents
       */
      function factory(node, index, parents) {
        /** @type {Object.<string, unknown>} */
        // @ts-expect-error: hush
        const value = typeof node === 'object' && node !== null ? node : {};
        /** @type {string|undefined} */
        let name;

        if (typeof value.type === 'string') {
          name =
            typeof value.tagName === 'string'
              ? value.tagName
              : typeof value.name === 'string'
              ? value.name
              : undefined;

          Object.defineProperty(visit, 'name', {
            value:
              'node (' +
              color$1(value.type + (name ? '<' + name + '>' : '')) +
              ')'
          });
        }

        return visit

        function visit() {
          /** @type {ActionTuple} */
          let result = [];
          /** @type {ActionTuple} */
          let subresult;
          /** @type {number} */
          let offset;
          /** @type {Array.<Parent>} */
          let grandparents;

          if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = toResult$1(visitor(node, parents));

            if (result[0] === EXIT$1) {
              return result
            }
          }

          // @ts-expect-error looks like a parent.
          if (node.children && result[0] !== SKIP$1) {
            // @ts-expect-error looks like a parent.
            offset = (reverse ? node.children.length : -1) + step;
            // @ts-expect-error looks like a parent.
            grandparents = parents.concat(node);

            // @ts-expect-error looks like a parent.
            while (offset > -1 && offset < node.children.length) {
              // @ts-expect-error looks like a parent.
              subresult = factory(node.children[offset], offset, grandparents)();

              if (subresult[0] === EXIT$1) {
                return subresult
              }

              offset =
                typeof subresult[1] === 'number' ? subresult[1] : offset + step;
            }
          }

          return result
        }
      }
    }
  );

/**
 * @param {VisitorResult} value
 * @returns {ActionTuple}
 */
function toResult$1(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE$1, value]
  }

  return [value]
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 * @typedef {import('./complex-types').Visitor} Visitor
 */

/**
 * Visit children of tree which pass a test
 *
 * @param tree Abstract syntax tree to walk
 * @param test Test, optional
 * @param visitor Function to run for each node
 * @param reverse Fisit the tree in reverse, defaults to false
 */
const visit =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: import('./complex-types').BuildVisitor<Tree, Check>, reverse?: boolean) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: import('./complex-types').BuildVisitor<Tree>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {import('./complex-types').Visitor} visitor
     * @param {boolean} [reverse]
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
      }

      visitParents$1(tree, test, overload, reverse);

      /**
       * @param {Node} node
       * @param {Array.<Parent>} parents
       */
      function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(
          node,
          parent ? parent.children.indexOf(node) : null,
          parent
        )
      }
    }
  );

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Element} Element
 *
 * @callback AllowElement
 * @param {Element} element
 * @param {number} index
 * @param {Element|Root} parent
 * @returns {boolean|undefined}
 *
 * @typedef Options
 * @property {Array<string>} [allowedElements]
 * @property {Array<string>} [disallowedElements=[]]
 * @property {AllowElement} [allowElement]
 * @property {boolean} [unwrapDisallowed=false]
 */

/**
 * @type {import('unified').Plugin<[Options], Root>}
 */
function rehypeFilter(options) {
  if (options.allowedElements && options.disallowedElements) {
    throw new TypeError(
      'Only one of `allowedElements` and `disallowedElements` should be defined'
    )
  }

  if (
    options.allowedElements ||
    options.disallowedElements ||
    options.allowElement
  ) {
    return (tree) => {
      visit(tree, 'element', (node, index, parent_) => {
        const parent = /** @type {Element|Root} */ (parent_);
        /** @type {boolean|undefined} */
        let remove;

        if (options.allowedElements) {
          remove = !options.allowedElements.includes(node.tagName);
        } else if (options.disallowedElements) {
          remove = options.disallowedElements.includes(node.tagName);
        }

        if (!remove && options.allowElement && typeof index === 'number') {
          remove = !options.allowElement(node, index, parent);
        }

        if (remove && typeof index === 'number') {
          if (options.unwrapDisallowed && node.children) {
            parent.children.splice(index, 1, ...node.children);
          } else {
            parent.children.splice(index, 1);
          }

          return index
        }

        return undefined
      });
    }
  }
}

var reactIs = {exports: {}};

var reactIs_production_min = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=g;reactIs_production_min.Element=b;reactIs_production_min.ForwardRef=l;reactIs_production_min.Fragment=d;reactIs_production_min.Lazy=q;reactIs_production_min.Memo=p;reactIs_production_min.Portal=c;reactIs_production_min.Profiler=f;reactIs_production_min.StrictMode=e;reactIs_production_min.Suspense=m;
reactIs_production_min.SuspenseList=n;reactIs_production_min.isAsyncMode=function(){return !1};reactIs_production_min.isConcurrentMode=function(){return !1};reactIs_production_min.isContextConsumer=function(a){return v(a)===h};reactIs_production_min.isContextProvider=function(a){return v(a)===g};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min.isForwardRef=function(a){return v(a)===l};reactIs_production_min.isFragment=function(a){return v(a)===d};reactIs_production_min.isLazy=function(a){return v(a)===q};reactIs_production_min.isMemo=function(a){return v(a)===p};
reactIs_production_min.isPortal=function(a){return v(a)===c};reactIs_production_min.isProfiler=function(a){return v(a)===f};reactIs_production_min.isStrictMode=function(a){return v(a)===e};reactIs_production_min.isSuspense=function(a){return v(a)===m};reactIs_production_min.isSuspenseList=function(a){return v(a)===n};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};reactIs_production_min.typeOf=v;

var reactIs_development = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

// -----------------------------------------------------------------------------

var enableScopeAPI = false; // Experimental Create Event Handle API.
var enableCacheElement = false;
var enableTransitionTracing = false; // No known bugs, but needs performance testing

var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
// stuff. Intended to enable React core members to more easily debug scheduling
// issues in DEV builds.

var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

// ATTENTION

var REACT_ELEMENT_TYPE =  Symbol.for('react.element');
var REACT_PORTAL_TYPE =  Symbol.for('react.portal');
var REACT_FRAGMENT_TYPE =  Symbol.for('react.fragment');
var REACT_STRICT_MODE_TYPE =  Symbol.for('react.strict_mode');
var REACT_PROFILER_TYPE =  Symbol.for('react.profiler');
var REACT_PROVIDER_TYPE =  Symbol.for('react.provider');
var REACT_CONTEXT_TYPE =  Symbol.for('react.context');
var REACT_SERVER_CONTEXT_TYPE =  Symbol.for('react.server_context');
var REACT_FORWARD_REF_TYPE =  Symbol.for('react.forward_ref');
var REACT_SUSPENSE_TYPE =  Symbol.for('react.suspense');
var REACT_SUSPENSE_LIST_TYPE =  Symbol.for('react.suspense_list');
var REACT_MEMO_TYPE =  Symbol.for('react.memo');
var REACT_LAZY_TYPE =  Symbol.for('react.lazy');
var REACT_OFFSCREEN_TYPE =  Symbol.for('react.offscreen');

var REACT_MODULE_REFERENCE;

{
  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
}

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
    // types supported by any Flight configuration anywhere since
    // we don't know which Flight build this will end up being used
    // with.
    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_SERVER_CONTEXT_TYPE:
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}
function isSuspenseList(object) {
  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
}

reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.SuspenseList = SuspenseList;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isSuspenseList = isSuspenseList;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

var ReactIs = reactIs.exports;

/**
 * @param {unknown} thing
 * @returns {boolean}
 */
function whitespace(thing) {
  /** @type {string} */
  var value =
    // @ts-ignore looks like a node.
    thing && typeof thing === 'object' && thing.type === 'text'
      ? // @ts-ignore looks like a text.
        thing.value || ''
      : thing;

  // HTML whitespace expression.
  // See <https://html.spec.whatwg.org/#space-character>.
  return typeof value === 'string' && value.replace(/[ \t\n\f\r]/g, '') === ''
}

/**
 * Parse space separated tokens to an array of strings.
 *
 * @param {string} value Space separated tokens
 * @returns {Array.<string>} Tokens
 */

/**
 * Serialize an array of strings as space separated tokens.
 *
 * @param {Array.<string|number>} values Tokens
 * @returns {string} Space separated tokens
 */
function stringify$1(values) {
  return values.join(' ').trim()
}

/**
 * @typedef {Object} StringifyOptions
 * @property {boolean} [padLeft=true] Whether to pad a space before a token (`boolean`, default: `true`).
 * @property {boolean} [padRight=false] Whether to pad a space after a token (`boolean`, default: `false`).
 */

/**
 * Serialize an array of strings to comma separated tokens.
 *
 * @param {Array.<string|number>} values
 * @param {StringifyOptions} [options]
 * @returns {string}
 */
function stringify(values, options) {
  var settings = options || {};

  // Ensure the last empty entry is seen.
  if (values[values.length - 1] === '') {
    values = values.concat('');
  }

  return values
    .join(
      (settings.padRight ? ' ' : '') +
        ',' +
        (settings.padLeft === false ? '' : ' ')
    )
    .trim()
}

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
var inlineStyleParser = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) ; else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim$1(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim$1(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim$1(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}

var parse = inlineStyleParser;

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

var styleToObject = StyleToObject;

/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */

const own$2 = {}.hasOwnProperty;

// The table-related elements that must not contain whitespace text according
// to React.
const tableElements = new Set(['table', 'thead', 'tbody', 'tfoot', 'tr']);

/**
 * @param {Context} context
 * @param {Element|Root} node
 */
function childrenToReact(context, node) {
  /** @type {Array<ReactNode>} */
  const children = [];
  let childIndex = -1;
  /** @type {Comment|Doctype|Element|Raw|Text} */
  let child;

  while (++childIndex < node.children.length) {
    child = node.children[childIndex];

    if (child.type === 'element') {
      children.push(toReact(context, child, childIndex, node));
    } else if (child.type === 'text') {
      // Currently, a warning is triggered by react for *any* white space in
      // tables.
      // So we drop it.
      // See: <https://github.com/facebook/react/pull/7081>.
      // See: <https://github.com/facebook/react/pull/7515>.
      // See: <https://github.com/remarkjs/remark-react/issues/64>.
      // See: <https://github.com/remarkjs/react-markdown/issues/576>.
      if (
        node.type !== 'element' ||
        !tableElements.has(node.tagName) ||
        !whitespace(child)
      ) {
        children.push(child.value);
      }
    } else if (child.type === 'raw' && !context.options.skipHtml) {
      // Default behavior is to show (encoded) HTML.
      children.push(child.value);
    }
  }

  return children
}

/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */
function toReact(context, node, index, parent) {
  const options = context.options;
  const parentSchema = context.schema;
  /** @type {ReactMarkdownNames} */
  // @ts-expect-error assume a known HTML/SVG element.
  const name = node.tagName;
  /** @type {Record<string, unknown>} */
  const properties = {};
  let schema = parentSchema;
  /** @type {string} */
  let property;

  if (parentSchema.space === 'html' && name === 'svg') {
    schema = svg;
    context.schema = schema;
  }

  if (node.properties) {
    for (property in node.properties) {
      if (own$2.call(node.properties, property)) {
        addProperty(properties, property, node.properties[property], context);
      }
    }
  }

  if (name === 'ol' || name === 'ul') {
    context.listDepth++;
  }

  const children = childrenToReact(context, node);

  if (name === 'ol' || name === 'ul') {
    context.listDepth--;
  }

  // Restore parent schema.
  context.schema = parentSchema;

  // Nodes created by plugins do not have positional info, in which case we use
  // an object that matches the position interface.
  const position = node.position || {
    start: {line: null, column: null, offset: null},
    end: {line: null, column: null, offset: null}
  };
  const component =
    options.components && own$2.call(options.components, name)
      ? options.components[name]
      : name;
  const basic = typeof component === 'string' || component === React$2.Fragment;

  if (!ReactIs.isValidElementType(component)) {
    throw new TypeError(
      `Component for name \`${name}\` not defined or is not renderable`
    )
  }

  properties.key = [
    name,
    position.start.line,
    position.start.column,
    index
  ].join('-');

  if (name === 'a' && options.linkTarget) {
    properties.target =
      typeof options.linkTarget === 'function'
        ? options.linkTarget(
            String(properties.href || ''),
            node.children,
            typeof properties.title === 'string' ? properties.title : null
          )
        : options.linkTarget;
  }

  if (name === 'a' && options.transformLinkUri) {
    properties.href = options.transformLinkUri(
      String(properties.href || ''),
      node.children,
      typeof properties.title === 'string' ? properties.title : null
    );
  }

  if (
    !basic &&
    name === 'code' &&
    parent.type === 'element' &&
    parent.tagName !== 'pre'
  ) {
    properties.inline = true;
  }

  if (
    !basic &&
    (name === 'h1' ||
      name === 'h2' ||
      name === 'h3' ||
      name === 'h4' ||
      name === 'h5' ||
      name === 'h6')
  ) {
    properties.level = Number.parseInt(name.charAt(1), 10);
  }

  if (name === 'img' && options.transformImageUri) {
    properties.src = options.transformImageUri(
      String(properties.src || ''),
      String(properties.alt || ''),
      typeof properties.title === 'string' ? properties.title : null
    );
  }

  if (!basic && name === 'li' && parent.type === 'element') {
    const input = getInputElement(node);
    properties.checked =
      input && input.properties ? Boolean(input.properties.checked) : null;
    properties.index = getElementsBeforeCount(parent, node);
    properties.ordered = parent.tagName === 'ol';
  }

  if (!basic && (name === 'ol' || name === 'ul')) {
    properties.ordered = name === 'ol';
    properties.depth = context.listDepth;
  }

  if (name === 'td' || name === 'th') {
    if (properties.align) {
      if (!properties.style) properties.style = {};
      // @ts-expect-error assume `style` is an object
      properties.style.textAlign = properties.align;
      delete properties.align;
    }

    if (!basic) {
      properties.isHeader = name === 'th';
    }
  }

  if (!basic && name === 'tr' && parent.type === 'element') {
    properties.isHeader = Boolean(parent.tagName === 'thead');
  }

  // If `sourcePos` is given, pass source information (line/column info from markdown source).
  if (options.sourcePos) {
    properties['data-sourcepos'] = flattenPosition(position);
  }

  if (!basic && options.rawSourcePos) {
    properties.sourcePosition = node.position;
  }

  // If `includeElementIndex` is given, pass node index info to components.
  if (!basic && options.includeElementIndex) {
    properties.index = getElementsBeforeCount(parent, node);
    properties.siblingCount = getElementsBeforeCount(parent);
  }

  if (!basic) {
    properties.node = node;
  }

  // Ensure no React warnings are emitted for void elements w/ children.
  return children.length > 0
    ? React$2.createElement(component, properties, children)
    : React$2.createElement(component, properties)
}

/**
 * @param {Element|Root} node
 * @returns {Element?}
 */
function getInputElement(node) {
  let index = -1;

  while (++index < node.children.length) {
    const child = node.children[index];

    if (child.type === 'element' && child.tagName === 'input') {
      return child
    }
  }

  return null
}

/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */
function getElementsBeforeCount(parent, node) {
  let index = -1;
  let count = 0;

  while (++index < parent.children.length) {
    if (parent.children[index] === node) break
    if (parent.children[index].type === 'element') count++;
  }

  return count
}

/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */
function addProperty(props, prop, value, ctx) {
  const info = find(ctx.schema, prop);
  let result = value;

  // Ignore nullish and `NaN` values.
  // eslint-disable-next-line no-self-compare
  if (result === null || result === undefined || result !== result) {
    return
  }

  // Accept `array`.
  // Most props are space-separated.
  if (Array.isArray(result)) {
    result = info.commaSeparated ? stringify(result) : stringify$1(result);
  }

  if (info.property === 'style' && typeof result === 'string') {
    result = parseStyle(result);
  }

  if (info.space && info.property) {
    props[
      own$2.call(hastToReact, info.property)
        ? hastToReact[info.property]
        : info.property
    ] = result;
  } else if (info.attribute) {
    props[info.attribute] = result;
  }
}

/**
 * @param {string} value
 * @returns {Record<string, string>}
 */
function parseStyle(value) {
  /** @type {Record<string, string>} */
  const result = {};

  try {
    styleToObject(value, iterator);
  } catch {
    // Silent.
  }

  return result

  /**
   * @param {string} name
   * @param {string} v
   */
  function iterator(name, v) {
    const k = name.slice(0, 4) === '-ms-' ? `ms-${name.slice(4)}` : name;
    result[k.replace(/-([a-z])/g, styleReplacer)] = v;
  }
}

/**
 * @param {unknown} _
 * @param {string} $1
 */
function styleReplacer(_, $1) {
  return $1.toUpperCase()
}

/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */
function flattenPosition(pos) {
  return [
    pos.start.line,
    ':',
    pos.start.column,
    '-',
    pos.end.line,
    ':',
    pos.end.column
  ]
    .map((d) => String(d))
    .join('')
}

/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */

const own$1 = {}.hasOwnProperty;
const changelog =
  'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';

/** @type {Record<string, Deprecation>} */
const deprecated = {
  plugins: {to: 'plugins', id: 'change-plugins-to-remarkplugins'},
  renderers: {to: 'components', id: 'change-renderers-to-components'},
  astPlugins: {id: 'remove-buggy-html-in-markdown-parser'},
  allowDangerousHtml: {id: 'remove-buggy-html-in-markdown-parser'},
  escapeHtml: {id: 'remove-buggy-html-in-markdown-parser'},
  source: {to: 'children', id: 'change-source-to-children'},
  allowNode: {
    to: 'allowElement',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  allowedTypes: {
    to: 'allowedElements',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  disallowedTypes: {
    to: 'disallowedElements',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  includeNodeIndex: {
    to: 'includeElementIndex',
    id: 'change-includenodeindex-to-includeelementindex'
  }
};

/**
 * React component to render markdown.
 *
 * @param {ReactMarkdownOptions} options
 * @returns {ReactElement}
 */
function ReactMarkdown(options) {
  for (const key in deprecated) {
    if (own$1.call(deprecated, key) && own$1.call(options, key)) {
      const deprecation = deprecated[key];
      console.warn(
        `[react-markdown] Warning: please ${
          deprecation.to ? `use \`${deprecation.to}\` instead of` : 'remove'
        } \`${key}\` (see <${changelog}#${deprecation.id}> for more info)`
      );
      delete deprecated[key];
    }
  }

  const processor = unified()
    .use(remarkParse)
    .use(options.remarkPlugins || [])
    .use(remarkRehype$1, {
      ...options.remarkRehypeOptions,
      allowDangerousHtml: true
    })
    .use(options.rehypePlugins || [])
    .use(rehypeFilter, options);

  const file = new VFile$1();

  if (typeof options.children === 'string') {
    file.value = options.children;
  } else if (options.children !== undefined && options.children !== null) {
    console.warn(
      `[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`
    );
  }

  const hastNode = processor.runSync(processor.parse(file), file);

  if (hastNode.type !== 'root') {
    throw new TypeError('Expected a `root` node')
  }

  /** @type {ReactElement} */
  let result = React$2.createElement(
    React$2.Fragment,
    {},
    childrenToReact({options, schema: html, listDepth: 0}, hastNode)
  );

  if (options.className) {
    result = React$2.createElement('div', {className: options.className}, result);
  }

  return result
}

ReactMarkdown.defaultProps = {transformLinkUri: uriTransformer};

ReactMarkdown.propTypes = {
  // Core options:
  children: PropTypes$2.string,
  // Layout options:
  className: PropTypes$2.string,
  // Filter options:
  allowElement: PropTypes$2.func,
  allowedElements: PropTypes$2.arrayOf(PropTypes$2.string),
  disallowedElements: PropTypes$2.arrayOf(PropTypes$2.string),
  unwrapDisallowed: PropTypes$2.bool,
  // Plugin options:
  remarkPlugins: PropTypes$2.arrayOf(
    PropTypes$2.oneOfType([
      PropTypes$2.object,
      PropTypes$2.func,
      PropTypes$2.arrayOf(
        PropTypes$2.oneOfType([
          PropTypes$2.bool,
          PropTypes$2.string,
          PropTypes$2.object,
          PropTypes$2.func,
          PropTypes$2.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            PropTypes$2.any
          )
        ])
      )
    ])
  ),
  rehypePlugins: PropTypes$2.arrayOf(
    PropTypes$2.oneOfType([
      PropTypes$2.object,
      PropTypes$2.func,
      PropTypes$2.arrayOf(
        PropTypes$2.oneOfType([
          PropTypes$2.bool,
          PropTypes$2.string,
          PropTypes$2.object,
          PropTypes$2.func,
          PropTypes$2.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            PropTypes$2.any
          )
        ])
      )
    ])
  ),
  // Transform options:
  sourcePos: PropTypes$2.bool,
  rawSourcePos: PropTypes$2.bool,
  skipHtml: PropTypes$2.bool,
  includeElementIndex: PropTypes$2.bool,
  transformLinkUri: PropTypes$2.oneOfType([PropTypes$2.func, PropTypes$2.bool]),
  linkTarget: PropTypes$2.oneOfType([PropTypes$2.func, PropTypes$2.string]),
  transformImageUri: PropTypes$2.func,
  components: PropTypes$2.object
};

var lib = {};

var slider = {};

var innerSlider = {};

var initialState$8 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
var _default = initialState;
exports["default"] = _default;
}(initialState$8));

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce;

var innerSliderUtils = {};

Object.defineProperty(innerSliderUtils, "__esModule", {
  value: true
});
innerSliderUtils.clamp = clamp;
innerSliderUtils.canUseDOM = innerSliderUtils.slidesOnLeft = innerSliderUtils.slidesOnRight = innerSliderUtils.siblingDirection = innerSliderUtils.getTotalSlides = innerSliderUtils.getPostClones = innerSliderUtils.getPreClones = innerSliderUtils.getTrackLeft = innerSliderUtils.getTrackAnimateCSS = innerSliderUtils.getTrackCSS = innerSliderUtils.checkSpecKeys = innerSliderUtils.getSlideCount = innerSliderUtils.checkNavigable = innerSliderUtils.getNavigableIndexes = innerSliderUtils.swipeEnd = innerSliderUtils.swipeMove = innerSliderUtils.swipeStart = innerSliderUtils.keyHandler = innerSliderUtils.changeSlide = innerSliderUtils.slideHandler = innerSliderUtils.initializedState = innerSliderUtils.extractObject = innerSliderUtils.canGoNext = innerSliderUtils.getSwipeDirection = innerSliderUtils.getHeight = innerSliderUtils.getWidth = innerSliderUtils.lazySlidesOnRight = innerSliderUtils.lazySlidesOnLeft = innerSliderUtils.lazyEndIndex = innerSliderUtils.lazyStartIndex = innerSliderUtils.getRequiredLazySlides = innerSliderUtils.getOnDemandLazySlides = innerSliderUtils.safePreventDefault = void 0;

var _react$4 = _interopRequireDefault$4(React$2);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty$5(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function clamp(number, lowerBound, upperBound) {
  return Math.max(lowerBound, Math.min(number, upperBound));
}

var safePreventDefault = function safePreventDefault(event) {
  var passiveEvents = ["onTouchStart", "onTouchMove", "onWheel"];

  if (!passiveEvents.includes(event._reactName)) {
    event.preventDefault();
  }
};

innerSliderUtils.safePreventDefault = safePreventDefault;

var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
}; // return list of slides that need to be present


innerSliderUtils.getOnDemandLazySlides = getOnDemandLazySlides;

var getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }

  return requiredSlides;
}; // startIndex that needs to be present


innerSliderUtils.getRequiredLazySlides = getRequiredLazySlides;

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};

innerSliderUtils.lazyStartIndex = lazyStartIndex;

var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};

innerSliderUtils.lazyEndIndex = lazyEndIndex;

var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};

innerSliderUtils.lazySlidesOnLeft = lazySlidesOnLeft;

var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
}; // get width of an element


innerSliderUtils.lazySlidesOnRight = lazySlidesOnRight;

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};

innerSliderUtils.getWidth = getWidth;

var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};

innerSliderUtils.getHeight = getHeight;

var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
}; // whether or not we can go next


innerSliderUtils.getSwipeDirection = getSwipeDirection;

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
}; // given an object and a list of keys, return new object with given keys


innerSliderUtils.canGoNext = canGoNext;

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
}; // get initialized state


innerSliderUtils.extractObject = extractObject;

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react$4["default"].Children.count(spec.children);

  var listNode = spec.listRef;
  var listWidth = Math.ceil(getWidth(listNode));
  var trackNode = spec.trackRef && spec.trackRef.node;
  var trackWidth = Math.ceil(getWidth(trackNode));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = listNode && getHeight(listNode.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides(_objectSpread$4(_objectSpread$4({}, spec), {}, {
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }));
  lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

innerSliderUtils.initializedState = initializedState;

var slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  var lazyLoadedList = spec.lazyLoadedList;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};
  var targetSlide = infinite ? index : clamp(index, 0, slideCount - 1);

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList = lazyLoadedList.concat(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList,
      targetSlide: animationSlide
    };
    nextState = {
      animating: false,
      targetSlide: animationSlide
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    if (!infinite && animationSlide + slidesToShow >= slideCount) {
      finalSlide = slideCount - slidesToShow;
    }

    animationLeft = getTrackLeft(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    if (lazyLoad) {
      lazyLoadedList = lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread$4(_objectSpread$4({}, spec), {}, {
        currentSlide: animationSlide
      })));
    }

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList,
        targetSlide: targetSlide
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
          left: finalLeft
        })),
        swipeLeft: null,
        targetSlide: targetSlide
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
};

innerSliderUtils.slideHandler = slideHandler;

var changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      previousTargetSlide = spec.targetSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide - slidesToScroll;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }

    if (!infinite) {
      targetSlide = previousTargetSlide + slidesToScroll;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;

    if (infinite) {
      var direction = siblingDirection(_objectSpread$4(_objectSpread$4({}, spec), {}, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
  }

  return targetSlide;
};

innerSliderUtils.changeSlide = changeSlide;

var keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

innerSliderUtils.keyHandler = keyHandler;

var swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && safePreventDefault(e);
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};

innerSliderUtils.swipeStart = swipeStart;

var swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return safePreventDefault(e);
  if (vertical && swipeToSlide && verticalSwiping) safePreventDefault(e);
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread$4(_objectSpread$4({}, state), {}, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    safePreventDefault(e);
  }

  return state;
};

innerSliderUtils.swipeMove = swipeMove;

var swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe,
      targetSlide = spec.targetSlide,
      currentSlide = spec.currentSlide,
      infinite = spec.infinite;

  if (!dragging) {
    if (swipe) safePreventDefault(e);
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    safePreventDefault(e);

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;
    var activeSlide = infinite ? currentSlide : targetSlide;

    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = activeSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;

      case "right":
      case "down":
        newSlide = activeSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;

      default:
        slideCount = activeSlide;
    }

    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_objectSpread$4(_objectSpread$4({}, spec), {}, {
      left: currentLeft
    }));
  }

  return state;
};

innerSliderUtils.swipeEnd = swipeEnd;

var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};

innerSliderUtils.getNavigableIndexes = getNavigableIndexes;

var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};

innerSliderUtils.checkNavigable = checkNavigable;

var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

innerSliderUtils.getSlideCount = getSlideCount;

var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

innerSliderUtils.checkSpecKeys = checkSpecKeys;

var getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _objectSpread$4(_objectSpread$4({}, style), {}, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};

innerSliderUtils.getTrackCSS = getTrackCSS;

var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

innerSliderUtils.getTrackAnimateCSS = getTrackAnimateCSS;

var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef && trackRef.node;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

innerSliderUtils.getTrackLeft = getTrackLeft;

var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

innerSliderUtils.getPreClones = getPreClones;

var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};

innerSliderUtils.getPostClones = getPostClones;

var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};

innerSliderUtils.getTotalSlides = getTotalSlides;

var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }

    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }

    return "left";
  }
};

innerSliderUtils.siblingDirection = siblingDirection;

var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};

innerSliderUtils.slidesOnRight = slidesOnRight;

var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
};

innerSliderUtils.slidesOnLeft = slidesOnLeft;

var canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

innerSliderUtils.canUseDOM = canUseDOM;

var track$1 = {};

Object.defineProperty(track$1, "__esModule", {
  value: true
});
track$1.Track = void 0;

var _react$3 = _interopRequireDefault$3(React$2);

var _classnames$3 = _interopRequireDefault$3(classnames.exports);

var _innerSliderUtils$3 = innerSliderUtils;

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); return Constructor; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$4(subClass, superClass); }

function _setPrototypeOf$4(o, p) { _setPrototypeOf$4 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$4(o, p); }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf$4(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$4(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$4(this, result); }; }

function _possibleConstructorReturn$4(self, call) { if (call && (_typeof$4(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$4(self); }

function _assertThisInitialized$4(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$4(o) { _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$4(o); }

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var focusedSlide;

  if (spec.targetSlide < 0) {
    focusedSlide = spec.targetSlide + spec.slideCount;
  } else if (spec.targetSlide >= spec.slideCount) {
    focusedSlide = spec.targetSlide - spec.slideCount;
  } else {
    focusedSlide = spec.targetSlide;
  }

  var slickCurrent = index === focusedSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";

    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;

    if (spec.useCSS) {
      style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  var childrenCount = _react$3["default"].Children.count(spec.children);

  var startIndex = (0, _innerSliderUtils$3.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils$3.lazyEndIndex)(spec);

  _react$3["default"].Children.forEach(spec.children, function (elem, index) {
    var child;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    }; // in case of lazyLoad, whether or not we want to fetch the slide

    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = /*#__PURE__*/_react$3["default"].createElement("div", null);
    }

    var childStyle = getSlideStyle(_objectSpread$3(_objectSpread$3({}, spec), {}, {
      index: index
    }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_objectSpread$3(_objectSpread$3({}, spec), {}, {
      index: index
    })); // push a cloned element of the desired slide

    slides.push( /*#__PURE__*/_react$3["default"].cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames$3["default"])(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _objectSpread$3(_objectSpread$3({
        outline: "none"
      }, child.props.style || {}), childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);

        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    })); // if slide needs to be precloned or postcloned

    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;

      if (preCloneNo <= (0, _innerSliderUtils$3.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;

        if (key >= startIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread$3(_objectSpread$3({}, spec), {}, {
          index: key
        }));
        preCloneSlides.push( /*#__PURE__*/_react$3["default"].cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames$3["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread$3(_objectSpread$3({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;

        if (key < endIndex) {
          child = elem;
        }

        slideClasses = getSlideClasses(_objectSpread$3(_objectSpread$3({}, spec), {}, {
          index: key
        }));
        postCloneSlides.push( /*#__PURE__*/_react$3["default"].cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames$3["default"])(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _objectSpread$3(_objectSpread$3({}, child.props.style || {}), childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);

            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$4(Track, _React$PureComponent);

  var _super = _createSuper$3(Track);

  function Track() {
    var _this;

    _classCallCheck$4(this, Track);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$4(_assertThisInitialized$4(_this), "node", null);

    _defineProperty$4(_assertThisInitialized$4(_this), "handleRef", function (ref) {
      _this.node = ref;
    });

    return _this;
  }

  _createClass$4(Track, [{
    key: "render",
    value: function render() {
      var slides = renderSlides(this.props);
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave;
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      return /*#__PURE__*/_react$3["default"].createElement("div", _extends$3({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents), slides);
    }
  }]);

  return Track;
}(_react$3["default"].PureComponent);

track$1.Track = Track;

var dots = {};

Object.defineProperty(dots, "__esModule", {
  value: true
});
dots.Dots = void 0;

var _react$2 = _interopRequireDefault$2(React$2);

var _classnames$2 = _interopRequireDefault$2(classnames.exports);

var _innerSliderUtils$2 = innerSliderUtils;

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$3(subClass, superClass); }

function _setPrototypeOf$3(o, p) { _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$3(o, p); }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf$3(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$3(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$3(this, result); }; }

function _possibleConstructorReturn$3(self, call) { if (call && (_typeof$3(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$3(self); }

function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$3(o) { _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$3(o); }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$3(Dots, _React$PureComponent);

  var _super = _createSuper$2(Dots);

  function Dots() {
    _classCallCheck$3(this, Dots);

    return _super.apply(this, arguments);
  }

  _createClass$3(Dots, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      // In Autoplay the focus stays on clicked button even after transition
      // to next slide. That only goes away by click somewhere outside
      e.preventDefault();
      this.props.clickHandler(options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseOver = _this$props.onMouseOver,
          onMouseLeave = _this$props.onMouseLeave,
          infinite = _this$props.infinite,
          slidesToScroll = _this$props.slidesToScroll,
          slidesToShow = _this$props.slidesToShow,
          slideCount = _this$props.slideCount,
          currentSlide = _this$props.currentSlide;
      var dotCount = getDotCount({
        slideCount: slideCount,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        infinite: infinite
      });
      var mouseEvents = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave
      };
      var dots = [];

      for (var i = 0; i < dotCount; i++) {
        var _rightBound = (i + 1) * slidesToScroll - 1;

        var rightBound = infinite ? _rightBound : (0, _innerSliderUtils$2.clamp)(_rightBound, 0, slideCount - 1);

        var _leftBound = rightBound - (slidesToScroll - 1);

        var leftBound = infinite ? _leftBound : (0, _innerSliderUtils$2.clamp)(_leftBound, 0, slideCount - 1);
        var className = (0, _classnames$2["default"])({
          "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
        });
        var dotOptions = {
          message: "dots",
          index: i,
          slidesToScroll: slidesToScroll,
          currentSlide: currentSlide
        };
        var onClick = this.clickHandler.bind(this, dotOptions);
        dots = dots.concat( /*#__PURE__*/_react$2["default"].createElement("li", {
          key: i,
          className: className
        }, /*#__PURE__*/_react$2["default"].cloneElement(this.props.customPaging(i), {
          onClick: onClick
        })));
      }

      return /*#__PURE__*/_react$2["default"].cloneElement(this.props.appendDots(dots), _objectSpread$2({
        className: this.props.dotsClass
      }, mouseEvents));
    }
  }]);

  return Dots;
}(_react$2["default"].PureComponent);

dots.Dots = Dots;

var arrows = {};

Object.defineProperty(arrows, "__esModule", {
  value: true
});
arrows.NextArrow = arrows.PrevArrow = void 0;

var _react$1 = _interopRequireDefault$1(React$2);

var _classnames$1 = _interopRequireDefault$1(classnames.exports);

var _innerSliderUtils$1 = innerSliderUtils;

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$2(subClass, superClass); }

function _setPrototypeOf$2(o, p) { _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$2(o, p); }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }

function _possibleConstructorReturn$2(self, call) { if (call && (_typeof$2(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$2(self); }

function _assertThisInitialized$2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$2(o) { _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$2(o); }

var PrevArrow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits$2(PrevArrow, _React$PureComponent);

  var _super = _createSuper$1(PrevArrow);

  function PrevArrow() {
    _classCallCheck$2(this, PrevArrow);

    return _super.apply(this, arguments);
  }

  _createClass$2(PrevArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var prevClasses = {
        "slick-arrow": true,
        "slick-prev": true
      };
      var prevHandler = this.clickHandler.bind(this, {
        message: "previous"
      });

      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
        prevClasses["slick-disabled"] = true;
        prevHandler = null;
      }

      var prevArrowProps = {
        key: "0",
        "data-role": "none",
        className: (0, _classnames$1["default"])(prevClasses),
        style: {
          display: "block"
        },
        onClick: prevHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var prevArrow;

      if (this.props.prevArrow) {
        prevArrow = /*#__PURE__*/_react$1["default"].cloneElement(this.props.prevArrow, _objectSpread$1(_objectSpread$1({}, prevArrowProps), customProps));
      } else {
        prevArrow = /*#__PURE__*/_react$1["default"].createElement("button", _extends$2({
          key: "0",
          type: "button"
        }, prevArrowProps), " ", "Previous");
      }

      return prevArrow;
    }
  }]);

  return PrevArrow;
}(_react$1["default"].PureComponent);

arrows.PrevArrow = PrevArrow;

var NextArrow = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits$2(NextArrow, _React$PureComponent2);

  var _super2 = _createSuper$1(NextArrow);

  function NextArrow() {
    _classCallCheck$2(this, NextArrow);

    return _super2.apply(this, arguments);
  }

  _createClass$2(NextArrow, [{
    key: "clickHandler",
    value: function clickHandler(options, e) {
      if (e) {
        e.preventDefault();
      }

      this.props.clickHandler(options, e);
    }
  }, {
    key: "render",
    value: function render() {
      var nextClasses = {
        "slick-arrow": true,
        "slick-next": true
      };
      var nextHandler = this.clickHandler.bind(this, {
        message: "next"
      });

      if (!(0, _innerSliderUtils$1.canGoNext)(this.props)) {
        nextClasses["slick-disabled"] = true;
        nextHandler = null;
      }

      var nextArrowProps = {
        key: "1",
        "data-role": "none",
        className: (0, _classnames$1["default"])(nextClasses),
        style: {
          display: "block"
        },
        onClick: nextHandler
      };
      var customProps = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      };
      var nextArrow;

      if (this.props.nextArrow) {
        nextArrow = /*#__PURE__*/_react$1["default"].cloneElement(this.props.nextArrow, _objectSpread$1(_objectSpread$1({}, nextArrowProps), customProps));
      } else {
        nextArrow = /*#__PURE__*/_react$1["default"].createElement("button", _extends$2({
          key: "1",
          type: "button"
        }, nextArrowProps), " ", "Next");
      }

      return nextArrow;
    }
  }]);

  return NextArrow;
}(_react$1["default"].PureComponent);

arrows.NextArrow = NextArrow;

Object.defineProperty(innerSlider, "__esModule", {
  value: true
});
innerSlider.InnerSlider = void 0;

var _react = _interopRequireDefault(React$2);

var _initialState = _interopRequireDefault(initialState$8);

var _lodash = _interopRequireDefault(lodash_debounce);

var _classnames = _interopRequireDefault(classnames.exports);

var _innerSliderUtils = innerSliderUtils;

var _track = track$1;

var _dots = dots;

var _arrows = arrows;

var _resizeObserverPolyfill = _interopRequireDefault(require$$8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf$1(subClass, superClass); }

function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }

function _possibleConstructorReturn$1(self, call) { if (call && (_typeof$1(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized$1(self); }

function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InnerSlider = /*#__PURE__*/function (_React$Component) {
  _inherits$1(InnerSlider, _React$Component);

  var _super = _createSuper(InnerSlider);

  function InnerSlider(props) {
    var _this;

    _classCallCheck$1(this, InnerSlider);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized$1(_this), "listRefHandler", function (ref) {
      return _this.list = ref;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "trackRefHandler", function (ref) {
      return _this.track = ref;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "adaptHeight", function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));

        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidMount", function () {
      _this.props.onInit && _this.props.onInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }

      var spec = _objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props);

      _this.updateState(spec, true, function () {
        _this.adaptHeight();

        _this.props.autoplay && _this.autoPlay("update");
      });

      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }

      _this.ro = new _resizeObserverPolyfill["default"](function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation


          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });

      _this.ro.observe(_this.list);

      document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });

      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentWillUnmount", function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }

      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }

      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });

        _this.callbackTimers = [];
      }

      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }

      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      _this.ro.disconnect();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidUpdate", function (prevProps) {
      _this.checkImagesLoad();

      _this.props.onReInit && _this.props.onReInit();

      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread(_objectSpread({}, _this.props), _this.state));

        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });

          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      } // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }


      _this.adaptHeight();

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      var setTrackStyle = _this.didPropsChange(prevProps);

      setTrackStyle && _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react["default"].Children.count(_this.props.children)) {
          _this.changeSlide({
            message: "index",
            index: _react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }

        if (_this.props.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onWindowResized", function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash["default"])(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);

      _this.debouncedResize();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "resizeWindow", function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var isTrackMounted = Boolean(_this.track && _this.track.node); // prevent warning: setting state on unmounted component (server side rendering)

      if (!isTrackMounted) return;

      var spec = _objectSpread(_objectSpread({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props), _this.state);

      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      }); // animating state should be cleared while resizing, otherwise autoplay stops working


      _this.setState({
        animating: false
      });

      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "updateState", function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _objectSpread(_objectSpread(_objectSpread({}, spec), updatedState), {}, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _objectSpread(_objectSpread({}, spec), {}, {
        left: targetLeft
      });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);

      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }

      _this.setState(updatedState, callback);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "ssrInit", function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
          slideCount: _this.props.children.length
        }));

        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });

        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }

        for (var _i = 0; _i < postClones; _i++) {
          _trackWidth += childrenWidths[_i];
        }

        for (var _i2 = 0; _i2 < _this.state.currentSlide; _i2++) {
          _trackLeft += childrenWidths[_i2];
        }

        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };

        if (_this.props.centerMode) {
          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
        }

        return {
          trackStyle: _trackStyle
        };
      }

      var childrenCount = _react["default"].Children.count(_this.props.children);

      var spec = _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        slideCount: childrenCount
      });

      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;

      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }

      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      return {
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "checkImagesLoad", function () {
      var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();

              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "progressiveLazyLoad", function () {
      var slidesToLoad = [];

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });

        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "slideHandler", function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange; // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread(_objectSpread(_objectSpread({
        index: index
      }, _this.props), _this.state), {}, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);

      if (!_this.props.waitForAnimate && _this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
        afterChange && afterChange(currentSlide);
        delete _this.animationEndCallback;
      }

      _this.setState(state, function () {
        // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
        if (asNavFor && _this.asNavForIndex !== index) {
          _this.asNavForIndex = index;
          asNavFor.innerSlider.slideHandler(index);
        }

        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties$1(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({
                animating: animating
              });
            }, 10));

            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "changeSlide", function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }

      _this.props.autoplay && _this.autoPlay("update");

      if (_this.props.focusOnSelect) {
        var nodes = _this.list.querySelectorAll(".slick-current");

        nodes[0] && nodes[0].focus();
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "clickHandler", function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      _this.clickable = true;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "keyHandler", function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({
        message: dir
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "selectHandler", function (options) {
      _this.changeSlide(options);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "disableBodyScroll", function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };

      window.ontouchmove = preventDefault;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "enableBodyScroll", function () {
      window.ontouchmove = null;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "swipeStart", function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }

      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "swipeMove", function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;

      if (state["swiping"]) {
        _this.clickable = false;
      }

      _this.setState(state);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "swipeEnd", function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];

      _this.setState(state);

      if (triggerSlideHandler === undefined) return;

      _this.slideHandler(triggerSlideHandler);

      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "touchEnd", function (e) {
      _this.swipeEnd(e);

      _this.clickable = true;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "slickPrev", function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "previous"
        });
      }, 0));
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "slickNext", function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "next"
        });
      }, 0));
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return "";

      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "play", function () {
      var nextIndex;

      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_objectSpread(_objectSpread({}, _this.props), _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "autoPlay", function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }

      var autoplaying = _this.state.autoplaying;

      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }

      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);

      _this.setState({
        autoplaying: "playing"
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "pause", function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }

      var autoplaying = _this.state.autoplaying;

      if (pauseType === "paused") {
        _this.setState({
          autoplaying: "paused"
        });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({
            autoplaying: "focused"
          });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({
            autoplaying: "hovered"
          });
        }
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onDotsOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onDotsLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onTrackOver", function () {
      return _this.props.autoplay && _this.pause("hovered");
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onTrackLeave", function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onSlideFocus", function () {
      return _this.props.autoplay && _this.pause("focused");
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onSlideBlur", function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "render", function () {
      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });

      var spec = _objectSpread(_objectSpread({}, _this.props), _this.state);

      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]);
      var pauseOnHover = _this.props.pauseOnHover;
      trackProps = _objectSpread(_objectSpread({}, trackProps), {}, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
      });
      var dots;

      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
        dotProps = _objectSpread(_objectSpread({}, dotProps), {}, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = /*#__PURE__*/_react["default"].createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = /*#__PURE__*/_react["default"].createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = /*#__PURE__*/_react["default"].createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _objectSpread(_objectSpread({}, verticalHeightStyle), centerPaddingStyle);

      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.touchEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };
      var innerSliderProps = {
        className: className,
        dir: "ltr",
        style: _this.props.style
      };

      if (_this.props.unslick) {
        listProps = {
          className: "slick-list"
        };
        innerSliderProps = {
          className: className
        };
      }

      return /*#__PURE__*/_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/_react["default"].createElement("div", _extends$1({
        ref: _this.listRefHandler
      }, listProps), /*#__PURE__*/_react["default"].createElement(_track.Track, _extends$1({
        ref: _this.trackRefHandler
      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
    });

    _this.list = null;
    _this.track = null;
    _this.state = _objectSpread(_objectSpread({}, _initialState["default"]), {}, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react["default"].Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;

    var ssrState = _this.ssrInit();

    _this.state = _objectSpread(_objectSpread({}, _this.state), ssrState);
    return _this;
  }

  _createClass$1(InnerSlider, [{
    key: "didPropsChange",
    value: function didPropsChange(prevProps) {
      var setTrackStyle = false;

      for (var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++) {
        var key = _Object$keys[_i3];

        if (!prevProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof$1(prevProps[key]) === "object" || typeof prevProps[key] === "function") {
          continue;
        }

        if (prevProps[key] !== this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      return setTrackStyle || _react["default"].Children.count(this.props.children) !== _react["default"].Children.count(prevProps.children);
    }
  }]);

  return InnerSlider;
}(_react["default"].Component);

innerSlider.InnerSlider = InnerSlider;

var camel2hyphen$1 = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

var camel2hyphen_1 = camel2hyphen$1;

var camel2hyphen = camel2hyphen_1;

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and ';
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', ';
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

var json2mq_1 = json2mq;

var defaultProps = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(React$2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return /*#__PURE__*/_react["default"].createElement("ul", {
      style: {
        display: "block"
      }
    }, dots);
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return /*#__PURE__*/_react["default"].createElement("button", null, i + 1);
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
var _default = defaultProps;
exports["default"] = _default;
}(defaultProps));

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */

function QueryHandler$1(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler$1.prototype = {

    constructor : QueryHandler$1,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

var QueryHandler_1 = QueryHandler$1;

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */

function each$2(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray$2(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction$2(target) {
    return typeof target === 'function';
}

var Util$1 = {
    isFunction : isFunction$2,
    isArray : isArray$2,
    each : each$2
};

var QueryHandler = QueryHandler_1;
var each$1 = Util$1.each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery$1(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery$1.prototype = {

    constuctor : MediaQuery$1,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each$1(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each$1(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each$1(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

var MediaQuery_1 = MediaQuery$1;

var MediaQuery = MediaQuery_1;
var Util = Util$1;
var each = Util.each;
var isFunction$1 = Util.isFunction;
var isArray$1 = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch$1 () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch$1.prototype = {

    constructor : MediaQueryDispatch$1,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction$1(options)) {
            options = { match : options };
        }
        if(!isArray$1(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction$1(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

var MediaQueryDispatch_1 = MediaQueryDispatch$1;

var MediaQueryDispatch = MediaQueryDispatch_1;
var src$7 = new MediaQueryDispatch();

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(React$2);

var _innerSlider = innerSlider;

var _json2mq = _interopRequireDefault(json2mq_1);

var _defaultProps = _interopRequireDefault(defaultProps);

var _innerSliderUtils = innerSliderUtils;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && src$7;

var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider(props) {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
      return _this.innerSlider = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
      return _this.innerSlider.slickPrev();
    });

    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
      return _this.innerSlider.slickNext();
    });

    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    });

    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
      return _this.innerSlider.pause("paused");
    });

    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
      return _this.innerSlider.autoPlay("play");
    });

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  _createClass(Slider, [{
    key: "media",
    value: function media(query, handler) {
      // javascript handler for  css media query
      enquire.register(query, handler);

      this._responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    } // handles responsive breakpoints

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // performance monitoring
      //if (process.env.NODE_ENV !== 'production') {
      //const { whyDidYouUpdate } = require('why-did-you-update')
      //whyDidYouUpdate(React)
      //}
      if (this.props.responsive) {
        var breakpoints = this.props.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var bQuery;

          if (index === 0) {
            bQuery = (0, _json2mq["default"])({
              minWidth: 0,
              maxWidth: breakpoint
            });
          } else {
            bQuery = (0, _json2mq["default"])({
              minWidth: breakpoints[index - 1] + 1,
              maxWidth: breakpoint
            });
          } // when not using server side rendering


          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
            _this2.setState({
              breakpoint: breakpoint
            });
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = (0, _json2mq["default"])({
          minWidth: breakpoints.slice(-1)[0]
        });
        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
          _this2.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._responsiveMediaHandlers.forEach(function (obj) {
        enquire.unregister(obj.query, obj.handler);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var settings;
      var newProps;

      if (this.state.breakpoint) {
        newProps = this.props.responsive.filter(function (resp) {
          return resp.breakpoint === _this3.state.breakpoint;
        });
        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread(_objectSpread(_objectSpread({}, _defaultProps["default"]), this.props), newProps[0].settings);
      } else {
        settings = _objectSpread(_objectSpread({}, _defaultProps["default"]), this.props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && process.env.NODE_ENV !== "production") {
          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
        }

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && process.env.NODE_ENV !== "production") {
          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
        }

        if (settings.slidesToScroll > 1 && process.env.NODE_ENV !== "production") {
          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
        }

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // makes sure that children is an array, even when there is only 1 child


      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
      // children may also contain string filled with spaces (in certain cases where we use jsx strings)


      children = children.filter(function (child) {
        if (typeof child === "string") {
          return !!child.trim();
        }

        return !!child;
      }); // rows and slidesPerRow logic is handled here

      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      var newChildren = [];
      var currentWidth = null;

      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
        var newSlide = [];

        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
          var row = [];

          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
            if (settings.variableWidth && children[k].props.style) {
              currentWidth = children[k].props.style.width;
            }

            if (k >= children.length) break;
            row.push( /*#__PURE__*/_react["default"].cloneElement(children[k], {
              key: 100 * i + 10 * j + k,
              tabIndex: -1,
              style: {
                width: "".concat(100 / settings.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          }

          newSlide.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: 10 * i + j
          }, row));
        }

        if (settings.variableWidth) {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i,
            style: {
              width: currentWidth
            }
          }, newSlide));
        } else {
          newChildren.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: i
          }, newSlide));
        }
      }

      if (settings === "unslick") {
        var className = "regular slider " + (this.props.className || "");
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: className
        }, children);
      } else if (newChildren.length <= settings.slidesToShow) {
        settings.unslick = true;
      }

      return /*#__PURE__*/_react["default"].createElement(_innerSlider.InnerSlider, _extends({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, settings), newChildren);
    }
  }]);

  return Slider;
}(_react["default"].Component);

exports["default"] = Slider;
}(slider));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slider = _interopRequireDefault(slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _slider["default"];
exports["default"] = _default;
}(lib));

var Slider = /*@__PURE__*/getDefaultExportFromCjs(lib);

/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Code} Code
 */
const www = {
  tokenize: tokenizeWww,
  partial: true
};
const domain = {
  tokenize: tokenizeDomain,
  partial: true
};
const path = {
  tokenize: tokenizePath,
  partial: true
};
const punctuation = {
  tokenize: tokenizePunctuation,
  partial: true
};
const namedCharacterReference = {
  tokenize: tokenizeNamedCharacterReference,
  partial: true
};
const wwwAutolink = {
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
};
const httpAutolink = {
  tokenize: tokenizeHttpAutolink,
  previous: previousHttp
};
const emailAutolink = {
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
};
/** @type {ConstructRecord} */

const text = {};
/** @type {Extension} */

const gfmAutolinkLiteral = {
  text
};
let code$3 = 48; // Add alphanumerics.

while (code$3 < 123) {
  text[code$3] = emailAutolink;
  code$3++;
  if (code$3 === 58) code$3 = 65;
  else if (code$3 === 91) code$3 = 97;
}

text[43] = emailAutolink;
text[45] = emailAutolink;
text[46] = emailAutolink;
text[95] = emailAutolink;
text[72] = [emailAutolink, httpAutolink];
text[104] = [emailAutolink, httpAutolink];
text[87] = [emailAutolink, wwwAutolink];
text[119] = [emailAutolink, wwwAutolink];
/** @type {Tokenizer} */

function tokenizeEmailAutolink(effects, ok, nok) {
  const self = this;
  /** @type {boolean} */

  let hasDot;
  /** @type {boolean|undefined} */

  let hasDigitInLastSegment;
  return start
  /** @type {State} */

  function start(code) {
    if (
      !gfmAtext(code) ||
      !previousEmail(self.previous) ||
      previousUnbalanced(self.events)
    ) {
      return nok(code)
    }

    effects.enter('literalAutolink');
    effects.enter('literalAutolinkEmail');
    return atext(code)
  }
  /** @type {State} */

  function atext(code) {
    if (gfmAtext(code)) {
      effects.consume(code);
      return atext
    }

    if (code === 64) {
      effects.consume(code);
      return label
    }

    return nok(code)
  }
  /** @type {State} */

  function label(code) {
    if (code === 46) {
      return effects.check(punctuation, done, dotContinuation)(code)
    }

    if (code === 45 || code === 95) {
      return effects.check(punctuation, nok, dashOrUnderscoreContinuation)(code)
    }

    if (asciiAlphanumeric(code)) {
      if (!hasDigitInLastSegment && asciiDigit(code)) {
        hasDigitInLastSegment = true;
      }

      effects.consume(code);
      return label
    }

    return done(code)
  }
  /** @type {State} */

  function dotContinuation(code) {
    effects.consume(code);
    hasDot = true;
    hasDigitInLastSegment = undefined;
    return label
  }
  /** @type {State} */

  function dashOrUnderscoreContinuation(code) {
    effects.consume(code);
    return afterDashOrUnderscore
  }
  /** @type {State} */

  function afterDashOrUnderscore(code) {
    if (code === 46) {
      return effects.check(punctuation, nok, dotContinuation)(code)
    }

    return label(code)
  }
  /** @type {State} */

  function done(code) {
    if (hasDot && !hasDigitInLastSegment) {
      effects.exit('literalAutolinkEmail');
      effects.exit('literalAutolink');
      return ok(code)
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeWwwAutolink(effects, ok, nok) {
  const self = this;
  return start
  /** @type {State} */

  function start(code) {
    if (
      (code !== 87 && code !== 119) ||
      !previousWww(self.previous) ||
      previousUnbalanced(self.events)
    ) {
      return nok(code)
    }

    effects.enter('literalAutolink');
    effects.enter('literalAutolinkWww'); // For `www.` we check instead of attempt, because when it matches, GH
    // treats it as part of a domain (yes, it says a valid domain must come
    // after `www.`, but that’s not how it’s implemented by them).

    return effects.check(
      www,
      effects.attempt(domain, effects.attempt(path, done), nok),
      nok
    )(code)
  }
  /** @type {State} */

  function done(code) {
    effects.exit('literalAutolinkWww');
    effects.exit('literalAutolink');
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeHttpAutolink(effects, ok, nok) {
  const self = this;
  return start
  /** @type {State} */

  function start(code) {
    if (
      (code !== 72 && code !== 104) ||
      !previousHttp(self.previous) ||
      previousUnbalanced(self.events)
    ) {
      return nok(code)
    }

    effects.enter('literalAutolink');
    effects.enter('literalAutolinkHttp');
    effects.consume(code);
    return t1
  }
  /** @type {State} */

  function t1(code) {
    if (code === 84 || code === 116) {
      effects.consume(code);
      return t2
    }

    return nok(code)
  }
  /** @type {State} */

  function t2(code) {
    if (code === 84 || code === 116) {
      effects.consume(code);
      return p
    }

    return nok(code)
  }
  /** @type {State} */

  function p(code) {
    if (code === 80 || code === 112) {
      effects.consume(code);
      return s
    }

    return nok(code)
  }
  /** @type {State} */

  function s(code) {
    if (code === 83 || code === 115) {
      effects.consume(code);
      return colon
    }

    return colon(code)
  }
  /** @type {State} */

  function colon(code) {
    if (code === 58) {
      effects.consume(code);
      return slash1
    }

    return nok(code)
  }
  /** @type {State} */

  function slash1(code) {
    if (code === 47) {
      effects.consume(code);
      return slash2
    }

    return nok(code)
  }
  /** @type {State} */

  function slash2(code) {
    if (code === 47) {
      effects.consume(code);
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    return code === null ||
      asciiControl(code) ||
      unicodeWhitespace(code) ||
      unicodePunctuation(code)
      ? nok(code)
      : effects.attempt(domain, effects.attempt(path, done), nok)(code)
  }
  /** @type {State} */

  function done(code) {
    effects.exit('literalAutolinkHttp');
    effects.exit('literalAutolink');
    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeWww(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.consume(code);
    return w2
  }
  /** @type {State} */

  function w2(code) {
    if (code === 87 || code === 119) {
      effects.consume(code);
      return w3
    }

    return nok(code)
  }
  /** @type {State} */

  function w3(code) {
    if (code === 87 || code === 119) {
      effects.consume(code);
      return dot
    }

    return nok(code)
  }
  /** @type {State} */

  function dot(code) {
    if (code === 46) {
      effects.consume(code);
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    return code === null || markdownLineEnding(code) ? nok(code) : ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeDomain(effects, ok, nok) {
  /** @type {boolean|undefined} */
  let hasUnderscoreInLastSegment;
  /** @type {boolean|undefined} */

  let hasUnderscoreInLastLastSegment;
  return domain
  /** @type {State} */

  function domain(code) {
    if (code === 38) {
      return effects.check(
        namedCharacterReference,
        done,
        punctuationContinuation
      )(code)
    }

    if (code === 46 || code === 95) {
      return effects.check(punctuation, done, punctuationContinuation)(code)
    } // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
    // occur, which sounds like ASCII only, but they also support `www.點看.com`,
    // so that’s Unicode.
    // Instead of some new production for Unicode alphanumerics, markdown
    // already has that for Unicode punctuation and whitespace, so use those.

    if (
      code === null ||
      asciiControl(code) ||
      unicodeWhitespace(code) ||
      (code !== 45 && unicodePunctuation(code))
    ) {
      return done(code)
    }

    effects.consume(code);
    return domain
  }
  /** @type {State} */

  function punctuationContinuation(code) {
    if (code === 46) {
      hasUnderscoreInLastLastSegment = hasUnderscoreInLastSegment;
      hasUnderscoreInLastSegment = undefined;
      effects.consume(code);
      return domain
    }

    if (code === 95) hasUnderscoreInLastSegment = true;
    effects.consume(code);
    return domain
  }
  /** @type {State} */

  function done(code) {
    if (!hasUnderscoreInLastLastSegment && !hasUnderscoreInLastSegment) {
      return ok(code)
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizePath(effects, ok) {
  let balance = 0;
  return inPath
  /** @type {State} */

  function inPath(code) {
    if (code === 38) {
      return effects.check(
        namedCharacterReference,
        ok,
        continuedPunctuation
      )(code)
    }

    if (code === 40) {
      balance++;
    }

    if (code === 41) {
      return effects.check(
        punctuation,
        parenAtPathEnd,
        continuedPunctuation
      )(code)
    }

    if (pathEnd(code)) {
      return ok(code)
    }

    if (trailingPunctuation(code)) {
      return effects.check(punctuation, ok, continuedPunctuation)(code)
    }

    effects.consume(code);
    return inPath
  }
  /** @type {State} */

  function continuedPunctuation(code) {
    effects.consume(code);
    return inPath
  }
  /** @type {State} */

  function parenAtPathEnd(code) {
    balance--;
    return balance < 0 ? ok(code) : continuedPunctuation(code)
  }
}
/** @type {Tokenizer} */

function tokenizeNamedCharacterReference(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.consume(code);
    return inside
  }
  /** @type {State} */

  function inside(code) {
    if (asciiAlpha(code)) {
      effects.consume(code);
      return inside
    }

    if (code === 59) {
      effects.consume(code);
      return after
    }

    return nok(code)
  }
  /** @type {State} */

  function after(code) {
    // If the named character reference is followed by the end of the path, it’s
    // not continued punctuation.
    return pathEnd(code) ? ok(code) : nok(code)
  }
}
/** @type {Tokenizer} */

function tokenizePunctuation(effects, ok, nok) {
  return start
  /** @type {State} */

  function start(code) {
    effects.consume(code);
    return after
  }
  /** @type {State} */

  function after(code) {
    // Check the next.
    if (trailingPunctuation(code)) {
      effects.consume(code);
      return after
    } // If the punctuation marker is followed by the end of the path, it’s not
    // continued punctuation.

    return pathEnd(code) ? ok(code) : nok(code)
  }
}
/**
 * @param {Code} code
 * @returns {boolean}
 */

function trailingPunctuation(code) {
  return (
    code === 33 ||
    code === 34 ||
    code === 39 ||
    code === 41 ||
    code === 42 ||
    code === 44 ||
    code === 46 ||
    code === 58 ||
    code === 59 ||
    code === 60 ||
    code === 63 ||
    code === 95 ||
    code === 126
  )
}
/**
 * @param {Code} code
 * @returns {boolean}
 */

function pathEnd(code) {
  return code === null || code === 60 || markdownLineEndingOrSpace(code)
}
/**
 * @param {Code} code
 * @returns {boolean}
 */

function gfmAtext(code) {
  return (
    code === 43 ||
    code === 45 ||
    code === 46 ||
    code === 95 ||
    asciiAlphanumeric(code)
  )
}
/** @type {Previous} */

function previousWww(code) {
  return (
    code === null ||
    code === 40 ||
    code === 42 ||
    code === 95 ||
    code === 126 ||
    markdownLineEndingOrSpace(code)
  )
}
/** @type {Previous} */

function previousHttp(code) {
  return code === null || !asciiAlpha(code)
}
/** @type {Previous} */

function previousEmail(code) {
  return code !== 47 && previousHttp(code)
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */

function previousUnbalanced(events) {
  let index = events.length;
  let result = false;

  while (index--) {
    const token = events[index][1];

    if (
      (token.type === 'labelLink' || token.type === 'labelImage') &&
      !token._balanced
    ) {
      result = true;
      break
    } // @ts-expect-error If we’ve seen this token, and it was marked as not
    // having any unbalanced bracket before it, we can exit.

    if (token._gfmAutolinkLiteralWalkedInto) {
      result = false;
      break
    }
  }

  if (events.length > 0 && !result) {
    // @ts-expect-error Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
  }

  return result
}

/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Event} Event
 */
const indent = {
  tokenize: tokenizeIndent,
  partial: true
};
/**
 * @returns {Extension}
 */

function gfmFootnote() {
  /** @type {Extension} */
  return {
    document: {
      [91]: {
        tokenize: tokenizeDefinitionStart,
        continuation: {
          tokenize: tokenizeDefinitionContinuation
        },
        exit: gfmFootnoteDefinitionEnd
      }
    },
    text: {
      [91]: {
        tokenize: tokenizeGfmFootnoteCall
      },
      [93]: {
        add: 'after',
        tokenize: tokenizePotentialGfmFootnoteCall,
        resolveTo: resolveToPotentialGfmFootnoteCall
      }
    }
  }
}
/** @type {Tokenizer} */

function tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
  const self = this;
  let index = self.events.length;
  /** @type {Array<string>} */
  // @ts-expect-error It’s fine!

  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
  /** @type {Token} */

  let labelStart; // Find an opening.

  while (index--) {
    const token = self.events[index][1];

    if (token.type === 'labelImage') {
      labelStart = token;
      break
    } // Exit if we’ve walked far enough.

    if (
      token.type === 'gfmFootnoteCall' ||
      token.type === 'labelLink' ||
      token.type === 'label' ||
      token.type === 'image' ||
      token.type === 'link'
    ) {
      break
    }
  }

  return start
  /** @type {State} */

  function start(code) {
    if (!labelStart || !labelStart._balanced) {
      return nok(code)
    }

    const id = normalizeIdentifier(
      self.sliceSerialize({
        start: labelStart.end,
        end: self.now()
      })
    );

    if (id.charCodeAt(0) !== 94 || !defined.includes(id.slice(1))) {
      return nok(code)
    }

    effects.enter('gfmFootnoteCallLabelMarker');
    effects.consume(code);
    effects.exit('gfmFootnoteCallLabelMarker');
    return ok(code)
  }
}
/** @type {Resolver} */

function resolveToPotentialGfmFootnoteCall(events, context) {
  let index = events.length;

  while (index--) {
    if (
      events[index][1].type === 'labelImage' &&
      events[index][0] === 'enter'
    ) {
      events[index][1];
      break
    }
  }

  // Change the `labelImageMarker` to a `data`.
  events[index + 1][1].type = 'data';
  events[index + 3][1].type = 'gfmFootnoteCallLabelMarker'; // The whole (without `!`):

  const call = {
    type: 'gfmFootnoteCall',
    start: Object.assign({}, events[index + 3][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  }; // The `^` marker

  const marker = {
    type: 'gfmFootnoteCallMarker',
    start: Object.assign({}, events[index + 3][1].end),
    end: Object.assign({}, events[index + 3][1].end)
  }; // Increment the end 1 character.

  marker.end.column++;
  marker.end.offset++;
  marker.end._bufferIndex++;
  const string = {
    type: 'gfmFootnoteCallString',
    start: Object.assign({}, marker.end),
    end: Object.assign({}, events[events.length - 1][1].start)
  };
  const chunk = {
    type: 'chunkString',
    contentType: 'string',
    start: Object.assign({}, string.start),
    end: Object.assign({}, string.end)
  };
  /** @type {Array<Event>} */

  const replacement = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    events[index + 1],
    events[index + 2],
    ['enter', call, context], // The `[`
    events[index + 3],
    events[index + 4], // The `^`.
    ['enter', marker, context],
    ['exit', marker, context], // Everything in between.
    ['enter', string, context],
    ['enter', chunk, context],
    ['exit', chunk, context],
    ['exit', string, context], // The ending (`]`, properly parsed and labelled).
    events[events.length - 2],
    events[events.length - 1],
    ['exit', call, context]
  ];
  events.splice(index, events.length - index + 1, ...replacement);
  return events
}
/** @type {Tokenizer} */

function tokenizeGfmFootnoteCall(effects, ok, nok) {
  const self = this;
  /** @type {Array<string>} */
  // @ts-expect-error It’s fine!

  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
  let size = 0;
  /** @type {boolean} */

  let data;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('gfmFootnoteCall');
    effects.enter('gfmFootnoteCallLabelMarker');
    effects.consume(code);
    effects.exit('gfmFootnoteCallLabelMarker');
    return callStart
  }
  /** @type {State} */

  function callStart(code) {
    if (code !== 94) return nok(code)
    effects.enter('gfmFootnoteCallMarker');
    effects.consume(code);
    effects.exit('gfmFootnoteCallMarker');
    effects.enter('gfmFootnoteCallString');
    effects.enter('chunkString').contentType = 'string';
    return callData
  }
  /** @type {State} */

  function callData(code) {
    /** @type {Token} */
    let token;

    if (code === null || code === 91 || size++ > 999) {
      return nok(code)
    }

    if (code === 93) {
      if (!data) {
        return nok(code)
      }

      effects.exit('chunkString');
      token = effects.exit('gfmFootnoteCallString');
      return defined.includes(normalizeIdentifier(self.sliceSerialize(token)))
        ? end(code)
        : nok(code)
    }

    effects.consume(code);

    if (!markdownLineEndingOrSpace(code)) {
      data = true;
    }

    return code === 92 ? callEscape : callData
  }
  /** @type {State} */

  function callEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code);
      size++;
      return callData
    }

    return callData(code)
  }
  /** @type {State} */

  function end(code) {
    effects.enter('gfmFootnoteCallLabelMarker');
    effects.consume(code);
    effects.exit('gfmFootnoteCallLabelMarker');
    effects.exit('gfmFootnoteCall');
    return ok
  }
}
/** @type {Tokenizer} */

function tokenizeDefinitionStart(effects, ok, nok) {
  const self = this;
  /** @type {Array<string>} */
  // @ts-expect-error It’s fine!

  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
  /** @type {string} */

  let identifier;
  let size = 0;
  /** @type {boolean|undefined} */

  let data;
  return start
  /** @type {State} */

  function start(code) {
    effects.enter('gfmFootnoteDefinition')._container = true;
    effects.enter('gfmFootnoteDefinitionLabel');
    effects.enter('gfmFootnoteDefinitionLabelMarker');
    effects.consume(code);
    effects.exit('gfmFootnoteDefinitionLabelMarker');
    return labelStart
  }
  /** @type {State} */

  function labelStart(code) {
    if (code === 94) {
      effects.enter('gfmFootnoteDefinitionMarker');
      effects.consume(code);
      effects.exit('gfmFootnoteDefinitionMarker');
      effects.enter('gfmFootnoteDefinitionLabelString');
      return atBreak
    }

    return nok(code)
  }
  /** @type {State} */

  function atBreak(code) {
    /** @type {Token} */
    let token;

    if (code === null || code === 91 || size > 999) {
      return nok(code)
    }

    if (code === 93) {
      if (!data) {
        return nok(code)
      }

      token = effects.exit('gfmFootnoteDefinitionLabelString');
      identifier = normalizeIdentifier(self.sliceSerialize(token));
      effects.enter('gfmFootnoteDefinitionLabelMarker');
      effects.consume(code);
      effects.exit('gfmFootnoteDefinitionLabelMarker');
      effects.exit('gfmFootnoteDefinitionLabel');
      return labelAfter
    }

    if (markdownLineEnding(code)) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      size++;
      return atBreak
    }

    effects.enter('chunkString').contentType = 'string';
    return label(code)
  }
  /** @type {State} */

  function label(code) {
    if (
      code === null ||
      markdownLineEnding(code) ||
      code === 91 ||
      code === 93 ||
      size > 999
    ) {
      effects.exit('chunkString');
      return atBreak(code)
    }

    if (!markdownLineEndingOrSpace(code)) {
      data = true;
    }

    size++;
    effects.consume(code);
    return code === 92 ? labelEscape : label
  }
  /** @type {State} */

  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code);
      size++;
      return label
    }

    return label(code)
  }
  /** @type {State} */

  function labelAfter(code) {
    if (code === 58) {
      effects.enter('definitionMarker');
      effects.consume(code);
      effects.exit('definitionMarker'); // Any whitespace after the marker is eaten, forming indented code
      // is not possible.
      // No space is also fine, just like a block quote marker.

      return factorySpace(effects, done, 'gfmFootnoteDefinitionWhitespace')
    }

    return nok(code)
  }
  /** @type {State} */

  function done(code) {
    if (!defined.includes(identifier)) {
      defined.push(identifier);
    }

    return ok(code)
  }
}
/** @type {Tokenizer} */

function tokenizeDefinitionContinuation(effects, ok, nok) {
  // Either a blank line, which is okay, or an indented thing.
  return effects.check(blankLine, ok, effects.attempt(indent, ok, nok))
}
/** @type {Exiter} */

function gfmFootnoteDefinitionEnd(effects) {
  effects.exit('gfmFootnoteDefinition');
}
/** @type {Tokenizer} */

function tokenizeIndent(effects, ok, nok) {
  const self = this;
  return factorySpace(
    effects,
    afterPrefix,
    'gfmFootnoteDefinitionIndent',
    4 + 1
  )
  /** @type {State} */

  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1];
    return tail &&
      tail[1].type === 'gfmFootnoteDefinitionIndent' &&
      tail[2].sliceSerialize(tail[1], true).length === 4
      ? ok(code)
      : nok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').Event} Event
 */

/**
 * @param {Options} [options]
 * @returns {Extension}
 */
function gfmStrikethrough(options = {}) {
  let single = options.singleTilde;
  const tokenizer = {
    tokenize: tokenizeStrikethrough,
    resolveAll: resolveAllStrikethrough
  };

  if (single === null || single === undefined) {
    single = true;
  }

  return {
    text: {
      [126]: tokenizer
    },
    insideSpan: {
      null: [tokenizer]
    },
    attentionMarkers: {
      null: [126]
    }
  }
  /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */

  function resolveAllStrikethrough(events, context) {
    let index = -1; // Walk through all events.

    while (++index < events.length) {
      // Find a token that can close.
      if (
        events[index][0] === 'enter' &&
        events[index][1].type === 'strikethroughSequenceTemporary' &&
        events[index][1]._close
      ) {
        let open = index; // Now walk back to find an opener.

        while (open--) {
          // Find a token that can open the closer.
          if (
            events[open][0] === 'exit' &&
            events[open][1].type === 'strikethroughSequenceTemporary' &&
            events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset ===
              events[open][1].end.offset - events[open][1].start.offset
          ) {
            events[index][1].type = 'strikethroughSequence';
            events[open][1].type = 'strikethroughSequence';
            const strikethrough = {
              type: 'strikethrough',
              start: Object.assign({}, events[open][1].start),
              end: Object.assign({}, events[index][1].end)
            };
            const text = {
              type: 'strikethroughText',
              start: Object.assign({}, events[open][1].end),
              end: Object.assign({}, events[index][1].start)
            }; // Opening.

            const nextEvents = [
              ['enter', strikethrough, context],
              ['enter', events[open][1], context],
              ['exit', events[open][1], context],
              ['enter', text, context]
            ]; // Between.

            splice(
              nextEvents,
              nextEvents.length,
              0,
              resolveAll(
                context.parser.constructs.insideSpan.null,
                events.slice(open + 1, index),
                context
              )
            ); // Closing.

            splice(nextEvents, nextEvents.length, 0, [
              ['exit', text, context],
              ['enter', events[index][1], context],
              ['exit', events[index][1], context],
              ['exit', strikethrough, context]
            ]);
            splice(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - 2;
            break
          }
        }
      }
    }

    index = -1;

    while (++index < events.length) {
      if (events[index][1].type === 'strikethroughSequenceTemporary') {
        events[index][1].type = 'data';
      }
    }

    return events
  }
  /** @type {Tokenizer} */

  function tokenizeStrikethrough(effects, ok, nok) {
    const previous = this.previous;
    const events = this.events;
    let size = 0;
    return start
    /** @type {State} */

    function start(code) {
      if (
        previous === 126 &&
        events[events.length - 1][1].type !== 'characterEscape'
      ) {
        return nok(code)
      }

      effects.enter('strikethroughSequenceTemporary');
      return more(code)
    }
    /** @type {State} */

    function more(code) {
      const before = classifyCharacter(previous);

      if (code === 126) {
        // If this is the third marker, exit.
        if (size > 1) return nok(code)
        effects.consume(code);
        size++;
        return more
      }

      if (size < 2 && !single) return nok(code)
      const token = effects.exit('strikethroughSequenceTemporary');
      const after = classifyCharacter(code);
      token._open = !after || (after === 2 && Boolean(before));
      token._close = !before || (before === 2 && Boolean(after));
      return ok(code)
    }
  }
}

/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 */

/** @type {Extension} */
const gfmTable = {
  flow: {
    null: {
      tokenize: tokenizeTable,
      resolve: resolveTable
    }
  }
};
const nextPrefixedOrBlank = {
  tokenize: tokenizeNextPrefixedOrBlank,
  partial: true
};
/** @type {Resolver} */

function resolveTable(events, context) {
  let index = -1;
  /** @type {boolean|undefined} */

  let inHead;
  /** @type {boolean|undefined} */

  let inDelimiterRow;
  /** @type {boolean|undefined} */

  let inRow;
  /** @type {number|undefined} */

  let contentStart;
  /** @type {number|undefined} */

  let contentEnd;
  /** @type {number|undefined} */

  let cellStart;
  /** @type {boolean|undefined} */

  let seenCellInRow;

  while (++index < events.length) {
    const token = events[index][1];

    if (inRow) {
      if (token.type === 'temporaryTableCellContent') {
        contentStart = contentStart || index;
        contentEnd = index;
      }

      if (
        // Combine separate content parts into one.
        (token.type === 'tableCellDivider' || token.type === 'tableRow') &&
        contentEnd
      ) {
        const content = {
          type: 'tableContent',
          start: events[contentStart][1].start,
          end: events[contentEnd][1].end
        };
        /** @type {Token} */

        const text = {
          type: 'chunkText',
          start: content.start,
          end: content.end,
          // @ts-expect-error It’s fine.
          contentType: 'text'
        };
        events.splice(
          contentStart,
          contentEnd - contentStart + 1,
          ['enter', content, context],
          ['enter', text, context],
          ['exit', text, context],
          ['exit', content, context]
        );
        index -= contentEnd - contentStart - 3;
        contentStart = undefined;
        contentEnd = undefined;
      }
    }

    if (
      events[index][0] === 'exit' &&
      cellStart !== undefined &&
      cellStart + (seenCellInRow ? 0 : 1) < index &&
      (token.type === 'tableCellDivider' ||
        (token.type === 'tableRow' &&
          (cellStart + 3 < index ||
            events[cellStart][1].type !== 'whitespace')))
    ) {
      const cell = {
        type: inDelimiterRow
          ? 'tableDelimiter'
          : inHead
          ? 'tableHeader'
          : 'tableData',
        start: events[cellStart][1].start,
        end: events[index][1].end
      };
      events.splice(index + (token.type === 'tableCellDivider' ? 1 : 0), 0, [
        'exit',
        cell,
        context
      ]);
      events.splice(cellStart, 0, ['enter', cell, context]);
      index += 2;
      cellStart = index + 1;
      seenCellInRow = true;
    }

    if (token.type === 'tableRow') {
      inRow = events[index][0] === 'enter';

      if (inRow) {
        cellStart = index + 1;
        seenCellInRow = false;
      }
    }

    if (token.type === 'tableDelimiterRow') {
      inDelimiterRow = events[index][0] === 'enter';

      if (inDelimiterRow) {
        cellStart = index + 1;
        seenCellInRow = false;
      }
    }

    if (token.type === 'tableHead') {
      inHead = events[index][0] === 'enter';
    }
  }

  return events
}
/** @type {Tokenizer} */

function tokenizeTable(effects, ok, nok) {
  const self = this;
  /** @type {Array<Align>} */

  const align = [];
  let tableHeaderCount = 0;
  /** @type {boolean|undefined} */

  let seenDelimiter;
  /** @type {boolean|undefined} */

  let hasDash;
  return start
  /** @type {State} */

  function start(code) {
    // @ts-expect-error Custom.
    effects.enter('table')._align = align;
    effects.enter('tableHead');
    effects.enter('tableRow'); // If we start with a pipe, we open a cell marker.

    if (code === 124) {
      return cellDividerHead(code)
    }

    tableHeaderCount++;
    effects.enter('temporaryTableCellContent'); // Can’t be space or eols at the start of a construct, so we’re in a cell.

    return inCellContentHead(code)
  }
  /** @type {State} */

  function cellDividerHead(code) {
    effects.enter('tableCellDivider');
    effects.consume(code);
    effects.exit('tableCellDivider');
    seenDelimiter = true;
    return cellBreakHead
  }
  /** @type {State} */

  function cellBreakHead(code) {
    if (code === null || markdownLineEnding(code)) {
      return atRowEndHead(code)
    }

    if (markdownSpace(code)) {
      effects.enter('whitespace');
      effects.consume(code);
      return inWhitespaceHead
    }

    if (seenDelimiter) {
      seenDelimiter = undefined;
      tableHeaderCount++;
    }

    if (code === 124) {
      return cellDividerHead(code)
    } // Anything else is cell content.

    effects.enter('temporaryTableCellContent');
    return inCellContentHead(code)
  }
  /** @type {State} */

  function inWhitespaceHead(code) {
    if (markdownSpace(code)) {
      effects.consume(code);
      return inWhitespaceHead
    }

    effects.exit('whitespace');
    return cellBreakHead(code)
  }
  /** @type {State} */

  function inCellContentHead(code) {
    // EOF, whitespace, pipe
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit('temporaryTableCellContent');
      return cellBreakHead(code)
    }

    effects.consume(code);
    return code === 92 ? inCellContentEscapeHead : inCellContentHead
  }
  /** @type {State} */

  function inCellContentEscapeHead(code) {
    if (code === 92 || code === 124) {
      effects.consume(code);
      return inCellContentHead
    } // Anything else.

    return inCellContentHead(code)
  }
  /** @type {State} */

  function atRowEndHead(code) {
    if (code === null) {
      return nok(code)
    }

    effects.exit('tableRow');
    effects.exit('tableHead');
    const originalInterrupt = self.interrupt;
    self.interrupt = true;
    return effects.attempt(
      {
        tokenize: tokenizeRowEnd,
        partial: true
      },
      function (code) {
        self.interrupt = originalInterrupt;
        effects.enter('tableDelimiterRow');
        return atDelimiterRowBreak(code)
      },
      function (code) {
        self.interrupt = originalInterrupt;
        return nok(code)
      }
    )(code)
  }
  /** @type {State} */

  function atDelimiterRowBreak(code) {
    if (code === null || markdownLineEnding(code)) {
      return rowEndDelimiter(code)
    }

    if (markdownSpace(code)) {
      effects.enter('whitespace');
      effects.consume(code);
      return inWhitespaceDelimiter
    }

    if (code === 45) {
      effects.enter('tableDelimiterFiller');
      effects.consume(code);
      hasDash = true;
      align.push('none');
      return inFillerDelimiter
    }

    if (code === 58) {
      effects.enter('tableDelimiterAlignment');
      effects.consume(code);
      effects.exit('tableDelimiterAlignment');
      align.push('left');
      return afterLeftAlignment
    } // If we start with a pipe, we open a cell marker.

    if (code === 124) {
      effects.enter('tableCellDivider');
      effects.consume(code);
      effects.exit('tableCellDivider');
      return atDelimiterRowBreak
    }

    return nok(code)
  }
  /** @type {State} */

  function inWhitespaceDelimiter(code) {
    if (markdownSpace(code)) {
      effects.consume(code);
      return inWhitespaceDelimiter
    }

    effects.exit('whitespace');
    return atDelimiterRowBreak(code)
  }
  /** @type {State} */

  function inFillerDelimiter(code) {
    if (code === 45) {
      effects.consume(code);
      return inFillerDelimiter
    }

    effects.exit('tableDelimiterFiller');

    if (code === 58) {
      effects.enter('tableDelimiterAlignment');
      effects.consume(code);
      effects.exit('tableDelimiterAlignment');
      align[align.length - 1] =
        align[align.length - 1] === 'left' ? 'center' : 'right';
      return afterRightAlignment
    }

    return atDelimiterRowBreak(code)
  }
  /** @type {State} */

  function afterLeftAlignment(code) {
    if (code === 45) {
      effects.enter('tableDelimiterFiller');
      effects.consume(code);
      hasDash = true;
      return inFillerDelimiter
    } // Anything else is not ok.

    return nok(code)
  }
  /** @type {State} */

  function afterRightAlignment(code) {
    if (code === null || markdownLineEnding(code)) {
      return rowEndDelimiter(code)
    }

    if (markdownSpace(code)) {
      effects.enter('whitespace');
      effects.consume(code);
      return inWhitespaceDelimiter
    } // `|`

    if (code === 124) {
      effects.enter('tableCellDivider');
      effects.consume(code);
      effects.exit('tableCellDivider');
      return atDelimiterRowBreak
    }

    return nok(code)
  }
  /** @type {State} */

  function rowEndDelimiter(code) {
    effects.exit('tableDelimiterRow'); // Exit if there was no dash at all, or if the header cell count is not the
    // delimiter cell count.

    if (!hasDash || tableHeaderCount !== align.length) {
      return nok(code)
    }

    if (code === null) {
      return tableClose(code)
    }

    return effects.check(
      nextPrefixedOrBlank,
      tableClose,
      effects.attempt(
        {
          tokenize: tokenizeRowEnd,
          partial: true
        },
        factorySpace(effects, bodyStart, 'linePrefix', 4),
        tableClose
      )
    )(code)
  }
  /** @type {State} */

  function tableClose(code) {
    effects.exit('table');
    return ok(code)
  }
  /** @type {State} */

  function bodyStart(code) {
    effects.enter('tableBody');
    return rowStartBody(code)
  }
  /** @type {State} */

  function rowStartBody(code) {
    effects.enter('tableRow'); // If we start with a pipe, we open a cell marker.

    if (code === 124) {
      return cellDividerBody(code)
    }

    effects.enter('temporaryTableCellContent'); // Can’t be space or eols at the start of a construct, so we’re in a cell.

    return inCellContentBody(code)
  }
  /** @type {State} */

  function cellDividerBody(code) {
    effects.enter('tableCellDivider');
    effects.consume(code);
    effects.exit('tableCellDivider');
    return cellBreakBody
  }
  /** @type {State} */

  function cellBreakBody(code) {
    if (code === null || markdownLineEnding(code)) {
      return atRowEndBody(code)
    }

    if (markdownSpace(code)) {
      effects.enter('whitespace');
      effects.consume(code);
      return inWhitespaceBody
    } // `|`

    if (code === 124) {
      return cellDividerBody(code)
    } // Anything else is cell content.

    effects.enter('temporaryTableCellContent');
    return inCellContentBody(code)
  }
  /** @type {State} */

  function inWhitespaceBody(code) {
    if (markdownSpace(code)) {
      effects.consume(code);
      return inWhitespaceBody
    }

    effects.exit('whitespace');
    return cellBreakBody(code)
  }
  /** @type {State} */

  function inCellContentBody(code) {
    // EOF, whitespace, pipe
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit('temporaryTableCellContent');
      return cellBreakBody(code)
    }

    effects.consume(code);
    return code === 92 ? inCellContentEscapeBody : inCellContentBody
  }
  /** @type {State} */

  function inCellContentEscapeBody(code) {
    if (code === 92 || code === 124) {
      effects.consume(code);
      return inCellContentBody
    } // Anything else.

    return inCellContentBody(code)
  }
  /** @type {State} */

  function atRowEndBody(code) {
    effects.exit('tableRow');

    if (code === null) {
      return tableBodyClose(code)
    }

    return effects.check(
      nextPrefixedOrBlank,
      tableBodyClose,
      effects.attempt(
        {
          tokenize: tokenizeRowEnd,
          partial: true
        },
        factorySpace(effects, rowStartBody, 'linePrefix', 4),
        tableBodyClose
      )
    )(code)
  }
  /** @type {State} */

  function tableBodyClose(code) {
    effects.exit('tableBody');
    return tableClose(code)
  }
  /** @type {Tokenizer} */

  function tokenizeRowEnd(effects, ok, nok) {
    return start
    /** @type {State} */

    function start(code) {
      effects.enter('lineEnding');
      effects.consume(code);
      effects.exit('lineEnding');
      return factorySpace(effects, prefixed, 'linePrefix')
    }
    /** @type {State} */

    function prefixed(code) {
      // Blank or interrupting line.
      if (
        self.parser.lazy[self.now().line] ||
        code === null ||
        markdownLineEnding(code)
      ) {
        return nok(code)
      }

      const tail = self.events[self.events.length - 1]; // Indented code can interrupt delimiter and body rows.

      if (
        !self.parser.constructs.disable.null.includes('codeIndented') &&
        tail &&
        tail[1].type === 'linePrefix' &&
        tail[2].sliceSerialize(tail[1], true).length >= 4
      ) {
        return nok(code)
      }

      self._gfmTableDynamicInterruptHack = true;
      return effects.check(
        self.parser.constructs.flow,
        function (code) {
          self._gfmTableDynamicInterruptHack = false;
          return nok(code)
        },
        function (code) {
          self._gfmTableDynamicInterruptHack = false;
          return ok(code)
        }
      )(code)
    }
  }
}
/** @type {Tokenizer} */

function tokenizeNextPrefixedOrBlank(effects, ok, nok) {
  let size = 0;
  return start
  /** @type {State} */

  function start(code) {
    // This is a check, so we don’t care about tokens, but we open a bogus one
    // so we’re valid.
    effects.enter('check'); // EOL.

    effects.consume(code);
    return whitespace
  }
  /** @type {State} */

  function whitespace(code) {
    if (code === -1 || code === 32) {
      effects.consume(code);
      size++;
      return size === 4 ? ok : whitespace
    } // EOF or whitespace

    if (code === null || markdownLineEndingOrSpace(code)) {
      return ok(code)
    } // Anything else.

    return nok(code)
  }
}

/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Code} Code
 */
const tasklistCheck = {
  tokenize: tokenizeTasklistCheck
};
const gfmTaskListItem = {
  text: {
    [91]: tasklistCheck
  }
};
/** @type {Tokenizer} */

function tokenizeTasklistCheck(effects, ok, nok) {
  const self = this;
  return open
  /** @type {State} */

  function open(code) {
    if (
      // Exit if there’s stuff before.
      self.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !self._gfmTasklistFirstContentOfListItem
    ) {
      return nok(code)
    }

    effects.enter('taskListCheck');
    effects.enter('taskListCheckMarker');
    effects.consume(code);
    effects.exit('taskListCheckMarker');
    return inside
  }
  /** @type {State} */

  function inside(code) {
    // To match how GH works in comments, use `markdownSpace` (`[ \t]`) instead
    // of `markdownLineEndingOrSpace` (`[ \t\r\n]`).
    if (markdownLineEndingOrSpace(code)) {
      effects.enter('taskListCheckValueUnchecked');
      effects.consume(code);
      effects.exit('taskListCheckValueUnchecked');
      return close
    }

    if (code === 88 || code === 120) {
      effects.enter('taskListCheckValueChecked');
      effects.consume(code);
      effects.exit('taskListCheckValueChecked');
      return close
    }

    return nok(code)
  }
  /** @type {State} */

  function close(code) {
    if (code === 93) {
      effects.enter('taskListCheckMarker');
      effects.consume(code);
      effects.exit('taskListCheckMarker');
      effects.exit('taskListCheck');
      return effects.check(
        {
          tokenize: spaceThenNonSpace
        },
        ok,
        nok
      )
    }

    return nok(code)
  }
}
/** @type {Tokenizer} */

function spaceThenNonSpace(effects, ok, nok) {
  const self = this;
  return factorySpace(effects, after, 'whitespace')
  /** @type {State} */

  function after(code) {
    const tail = self.events[self.events.length - 1];
    return (
      // We either found spaces…
      ((tail && tail[1].type === 'whitespace') || // …or it was followed by a line ending, in which case, there has to be
        // non-whitespace after that line ending, because otherwise we’d get an
        // EOF as the content is closed with blank lines.
        markdownLineEnding(code)) &&
        code !== null
        ? ok(code)
        : nok(code)
    )
  }
}

/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 */

/**
 * Support GFM or markdown on github.com.
 *
 * @param {Options} [options]
 * @returns {Extension}
 */
function gfm(options) {
  return combineExtensions([
    gfmAutolinkLiteral,
    gfmFootnote(),
    gfmStrikethrough(options),
    gfmTable,
    gfmTaskListItem
  ])
}

/**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */
function ccount(value, character) {
  const source = String(value);

  if (typeof character !== 'string') {
    throw new TypeError('Expected character')
  }

  let count = 0;
  let index = source.indexOf(character);

  while (index !== -1) {
    count++;
    index = source.indexOf(character, index + character.length);
  }

  return count
}

function escapeStringRegexp(string) {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string
		.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
		.replace(/-/g, '\\x2d');
}

/**
 * @param {string} d
 * @returns {string}
 */
function color(d) {
  return '\u001B[33m' + d + '\u001B[39m'
}

/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */

/**
 * Continue traversing as normal
 */
const CONTINUE = true;
/**
 * Do not traverse this node’s children
 */
const SKIP = 'skip';
/**
 * Stop traversing immediately
 */
const EXIT = false;

const visitParents =
  /**
   * @type {(
   *   (<T extends Node>(tree: Node, test: T['type']|Partial<T>|import('unist-util-is').TestFunctionPredicate<T>|Array.<T['type']|Partial<T>|import('unist-util-is').TestFunctionPredicate<T>>, visitor: Visitor<T>, reverse?: boolean) => void) &
   *   ((tree: Node, test: Test, visitor: Visitor<Node>, reverse?: boolean) => void) &
   *   ((tree: Node, visitor: Visitor<Node>, reverse?: boolean) => void)
   * )}
   */
  (
    /**
     * Visit children of tree which pass a test
     *
     * @param {Node} tree Abstract syntax tree to walk
     * @param {Test} test test Test node
     * @param {Visitor<Node>} visitor Function to run for each node
     * @param {boolean} [reverse] Fisit the tree in reverse, defaults to false
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-ignore no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
      }

      var is = convert(test);
      var step = reverse ? -1 : 1;

      factory(tree, null, [])();

      /**
       * @param {Node} node
       * @param {number?} index
       * @param {Array.<Parent>} parents
       */
      function factory(node, index, parents) {
        /** @type {Object.<string, unknown>} */
        var value = typeof node === 'object' && node !== null ? node : {};
        /** @type {string} */
        var name;

        if (typeof value.type === 'string') {
          name =
            typeof value.tagName === 'string'
              ? value.tagName
              : typeof value.name === 'string'
              ? value.name
              : undefined;

          Object.defineProperty(visit, 'name', {
            value:
              'node (' +
              color(value.type + (name ? '<' + name + '>' : '')) +
              ')'
          });
        }

        return visit

        function visit() {
          /** @type {ActionTuple} */
          var result = [];
          /** @type {ActionTuple} */
          var subresult;
          /** @type {number} */
          var offset;
          /** @type {Array.<Parent>} */
          var grandparents;

          if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = toResult(visitor(node, parents));

            if (result[0] === EXIT) {
              return result
            }
          }

          if (node.children && result[0] !== SKIP) {
            // @ts-ignore looks like a parent.
            offset = (reverse ? node.children.length : -1) + step;
            // @ts-ignore looks like a parent.
            grandparents = parents.concat(node);

            // @ts-ignore looks like a parent.
            while (offset > -1 && offset < node.children.length) {
              subresult = factory(node.children[offset], offset, grandparents)();

              if (subresult[0] === EXIT) {
                return subresult
              }

              offset =
                typeof subresult[1] === 'number' ? subresult[1] : offset + step;
            }
          }

          return result
        }
      }
    }
  );

/**
 * @param {VisitorResult} value
 * @returns {ActionTuple}
 */
function toResult(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return [value]
}

/**
 * @typedef Options Configuration.
 * @property {Test} [ignore] `unist-util-is` test used to assert parents
 *
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Text} Text
 * @typedef {Content|Root} Node
 * @typedef {Extract<Node, import('mdast').Parent>} Parent
 *
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 *
 * @typedef RegExpMatchObject
 * @property {number} index
 * @property {string} input
 *
 * @typedef {string|RegExp} Find
 * @typedef {string|ReplaceFunction} Replace
 *
 * @typedef {[Find, Replace]} FindAndReplaceTuple
 * @typedef {Object.<string, Replace>} FindAndReplaceSchema
 * @typedef {Array.<FindAndReplaceTuple>} FindAndReplaceList
 *
 * @typedef {[RegExp, ReplaceFunction]} Pair
 * @typedef {Array.<Pair>} Pairs
 */

const own = {}.hasOwnProperty;

/**
 * @param tree mdast tree
 * @param find Value to find and remove. When `string`, escaped and made into a global `RegExp`
 * @param [replace] Value to insert.
 *   * When `string`, turned into a Text node.
 *   * When `Function`, called with the results of calling `RegExp.exec` as
 *     arguments, in which case it can return a single or a list of `Node`,
 *     a `string` (which is wrapped in a `Text` node), or `false` to not replace
 * @param [options] Configuration.
 */
const findAndReplace =
  /**
   * @type {(
   *   ((tree: Node, find: Find, replace?: Replace, options?: Options) => Node) &
   *   ((tree: Node, schema: FindAndReplaceSchema|FindAndReplaceList, options?: Options) => Node)
   * )}
   **/
  (
    /**
     * @param {Node} tree
     * @param {Find|FindAndReplaceSchema|FindAndReplaceList} find
     * @param {Replace|Options} [replace]
     * @param {Options} [options]
     */
    function (tree, find, replace, options) {
      /** @type {Options|undefined} */
      let settings;
      /** @type {FindAndReplaceSchema|FindAndReplaceList} */
      let schema;

      if (typeof find === 'string' || find instanceof RegExp) {
        // @ts-expect-error don’t expect options twice.
        schema = [[find, replace]];
        settings = options;
      } else {
        schema = find;
        // @ts-expect-error don’t expect replace twice.
        settings = replace;
      }

      if (!settings) {
        settings = {};
      }

      const ignored = convert(settings.ignore || []);
      const pairs = toPairs(schema);
      let pairIndex = -1;

      while (++pairIndex < pairs.length) {
        visitParents(tree, 'text', visitor);
      }

      return tree

      /** @type {import('unist-util-visit-parents').Visitor<Text>} */
      function visitor(node, parents) {
        let index = -1;
        /** @type {Parent|undefined} */
        let grandparent;

        while (++index < parents.length) {
          const parent = /** @type {Parent} */ (parents[index]);

          if (
            ignored(
              parent,
              // @ts-expect-error mdast vs. unist parent.
              grandparent ? grandparent.children.indexOf(parent) : undefined,
              grandparent
            )
          ) {
            return
          }

          grandparent = parent;
        }

        if (grandparent) {
          return handler(node, grandparent)
        }
      }

      /**
       * @param {Text} node
       * @param {Parent} parent
       * @returns {VisitorResult}
       */
      function handler(node, parent) {
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        // @ts-expect-error: TS is wrong, some of these children can be text.
        let index = parent.children.indexOf(node);
        /** @type {Array.<PhrasingContent>} */
        let nodes = [];
        /** @type {number|undefined} */
        let position;

        find.lastIndex = 0;

        let match = find.exec(node.value);

        while (match) {
          position = match.index;
          // @ts-expect-error this is perfectly fine, typescript.
          let value = replace(...match, {
            index: match.index,
            input: match.input
          });

          if (typeof value === 'string') {
            value = value.length > 0 ? {type: 'text', value} : undefined;
          }

          if (value !== false) {
            if (start !== position) {
              nodes.push({
                type: 'text',
                value: node.value.slice(start, position)
              });
            }

            if (Array.isArray(value)) {
              nodes.push(...value);
            } else if (value) {
              nodes.push(value);
            }

            start = position + match[0].length;
          }

          if (!find.global) {
            break
          }

          match = find.exec(node.value);
        }

        if (position === undefined) {
          nodes = [node];
          index--;
        } else {
          if (start < node.value.length) {
            nodes.push({type: 'text', value: node.value.slice(start)});
          }

          parent.children.splice(index, 1, ...nodes);
        }

        return index + nodes.length + 1
      }
    }
  );

/**
 * @param {FindAndReplaceSchema|FindAndReplaceList} schema
 * @returns {Pairs}
 */
function toPairs(schema) {
  /** @type {Pairs} */
  const result = [];

  if (typeof schema !== 'object') {
    throw new TypeError('Expected array or object as schema')
  }

  if (Array.isArray(schema)) {
    let index = -1;

    while (++index < schema.length) {
      result.push([
        toExpression(schema[index][0]),
        toFunction(schema[index][1])
      ]);
    }
  } else {
    /** @type {string} */
    let key;

    for (key in schema) {
      if (own.call(schema, key)) {
        result.push([toExpression(key), toFunction(schema[key])]);
      }
    }
  }

  return result
}

/**
 * @param {Find} find
 * @returns {RegExp}
 */
function toExpression(find) {
  return typeof find === 'string' ? new RegExp(escapeStringRegexp(find), 'g') : find
}

/**
 * @param {Replace} replace
 * @returns {ReplaceFunction}
 */
function toFunction(replace) {
  return typeof replace === 'function' ? replace : () => replace
}

/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown/lib/types.js').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 * @typedef {import('mdast-util-find-and-replace').PhrasingContent} PhrasingContent
 */

const inConstruct = 'phrasing';
const notInConstruct = ['autolink', 'link', 'image', 'label'];

/** @type {FromMarkdownExtension} */
const gfmAutolinkLiteralFromMarkdown = {
  transforms: [transformGfmAutolinkLiterals],
  enter: {
    literalAutolink: enterLiteralAutolink,
    literalAutolinkEmail: enterLiteralAutolinkValue,
    literalAutolinkHttp: enterLiteralAutolinkValue,
    literalAutolinkWww: enterLiteralAutolinkValue
  },
  exit: {
    literalAutolink: exitLiteralAutolink,
    literalAutolinkEmail: exitLiteralAutolinkEmail,
    literalAutolinkHttp: exitLiteralAutolinkHttp,
    literalAutolinkWww: exitLiteralAutolinkWww
  }
};

/** @type {ToMarkdownExtension} */
const gfmAutolinkLiteralToMarkdown = {
  unsafe: [
    {
      character: '@',
      before: '[+\\-.\\w]',
      after: '[\\-.\\w]',
      inConstruct,
      notInConstruct
    },
    {
      character: '.',
      before: '[Ww]',
      after: '[\\-.\\w]',
      inConstruct,
      notInConstruct
    },
    {character: ':', before: '[ps]', after: '\\/', inConstruct, notInConstruct}
  ]
};

/** @type {FromMarkdownHandle} */
function enterLiteralAutolink(token) {
  this.enter({type: 'link', title: null, url: '', children: []}, token);
}

/** @type {FromMarkdownHandle} */
function enterLiteralAutolinkValue(token) {
  this.config.enter.autolinkProtocol.call(this, token);
}

/** @type {FromMarkdownHandle} */
function exitLiteralAutolinkHttp(token) {
  this.config.exit.autolinkProtocol.call(this, token);
}

/** @type {FromMarkdownHandle} */
function exitLiteralAutolinkWww(token) {
  this.config.exit.data.call(this, token);
  const node = /** @type {Link} */ (this.stack[this.stack.length - 1]);
  node.url = 'http://' + this.sliceSerialize(token);
}

/** @type {FromMarkdownHandle} */
function exitLiteralAutolinkEmail(token) {
  this.config.exit.autolinkEmail.call(this, token);
}

/** @type {FromMarkdownHandle} */
function exitLiteralAutolink(token) {
  this.exit(token);
}

/** @type {FromMarkdownTransform} */
function transformGfmAutolinkLiterals(tree) {
  findAndReplace(
    tree,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, findUrl],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, findEmail]
    ],
    {ignore: ['link', 'linkReference']}
  );
}

/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 */
// eslint-disable-next-line max-params
function findUrl(_, protocol, domain, path, match) {
  let prefix = '';

  // Not an expected previous character.
  if (!previous(match)) {
    return false
  }

  // Treat `www` as part of the domain.
  if (/^w/i.test(protocol)) {
    domain = protocol + domain;
    protocol = '';
    prefix = 'http://';
  }

  if (!isCorrectDomain(domain)) {
    return false
  }

  const parts = splitUrl(domain + path);

  if (!parts[0]) return false

  /** @type {PhrasingContent} */
  const result = {
    type: 'link',
    title: null,
    url: prefix + protocol + parts[0],
    children: [{type: 'text', value: protocol + parts[0]}]
  };

  if (parts[1]) {
    return [result, {type: 'text', value: parts[1]}]
  }

  return result
}

/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 */
function findEmail(_, atext, label, match) {
  if (
    // Not an expected previous character.
    !previous(match, true) ||
    // Label ends in not allowed character.
    /[_-\d]$/.test(label)
  ) {
    return false
  }

  return {
    type: 'link',
    title: null,
    url: 'mailto:' + atext + '@' + label,
    children: [{type: 'text', value: atext + '@' + label}]
  }
}

/**
 * @param {string} domain
 * @returns {boolean}
 */
function isCorrectDomain(domain) {
  const parts = domain.split('.');

  if (
    parts.length < 2 ||
    (parts[parts.length - 1] &&
      (/_/.test(parts[parts.length - 1]) ||
        !/[a-zA-Z\d]/.test(parts[parts.length - 1]))) ||
    (parts[parts.length - 2] &&
      (/_/.test(parts[parts.length - 2]) ||
        !/[a-zA-Z\d]/.test(parts[parts.length - 2])))
  ) {
    return false
  }

  return true
}

/**
 * @param {string} url
 * @returns {[string, string|undefined]}
 */
function splitUrl(url) {
  const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
  /** @type {number} */
  let closingParenIndex;
  /** @type {number} */
  let openingParens;
  /** @type {number} */
  let closingParens;
  /** @type {string|undefined} */
  let trail;

  if (trailExec) {
    url = url.slice(0, trailExec.index);
    trail = trailExec[0];
    closingParenIndex = trail.indexOf(')');
    openingParens = ccount(url, '(');
    closingParens = ccount(url, ')');

    while (closingParenIndex !== -1 && openingParens > closingParens) {
      url += trail.slice(0, closingParenIndex + 1);
      trail = trail.slice(closingParenIndex + 1);
      closingParenIndex = trail.indexOf(')');
      closingParens++;
    }
  }

  return [url, trail]
}

/**
 * @param {RegExpMatchObject} match
 * @param {boolean} [email=false]
 * @returns {boolean}
 */
function previous(match, email) {
  const code = match.input.charCodeAt(match.index - 1);

  return (
    (match.index === 0 ||
      unicodeWhitespace(code) ||
      unicodePunctuation(code)) &&
    (!email || code !== 47)
  )
}

/**
 * @typedef {import('mdast').Association} Association
 */

/**
 * The `label` of an association is the string value: character escapes and
 * references work, and casing is intact.
 * The `identifier` is used to match one association to another: controversially,
 * character escapes and references don’t work in this matching: `&copy;` does
 * not match `©`, and `\+` does not match `+`.
 * But casing is ignored (and whitespace) is trimmed and collapsed: ` A\nb`
 * matches `a b`.
 * So, we do prefer the label when figuring out how we’re going to serialize:
 * it has whitespace, casing, and we can ignore most useless character escapes
 * and all character references.
 *
 * @param {Association} node
 * @returns {string}
 */
function association(node) {
  if (node.label || !node.identifier) {
    return node.label || ''
  }

  return decodeString(node.identifier)
}

/**
 * @typedef {import('unist').Point} Point
 * @typedef {import('../types.js').TrackFields} TrackFields
 */

/**
 * Functions to track output positions.
 * This info isn’t used yet but suchs functionality allows line wrapping,
 * and theoretically source maps (though, is there practical use in that?).
 *
 * @param {TrackFields} options_
 */
function track(options_) {
  // Defaults are used to prevent crashes when older utilities somehow activate
  // this code.
  /* c8 ignore next 5 */
  const options = options_ || {};
  const now = options.now || {};
  let lineShift = options.lineShift || 0;
  let line = now.line || 1;
  let column = now.column || 1;

  return {move, current, shift}

  /**
   * Get the current tracked info.
   *
   * @returns {{now: Point, lineShift: number}}
   */
  function current() {
    return {now: {line, column}, lineShift}
  }

  /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @param {number} value
   */
  function shift(value) {
    lineShift += value;
  }

  /**
   * Move past a string.
   *
   * @param {string} value
   * @returns {string}
   */
  function move(value = '') {
    const chunks = value.split(/\r?\n|\r/g);
    const tail = chunks[chunks.length - 1];
    line += chunks.length - 1;
    column =
      chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
    return value
  }
}

/**
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').Join} Join
 * @typedef {import('../types.js').Context} Context
 * @typedef {import('../types.js').TrackFields} TrackFields
 */

/**
 * @param {Parent} parent
 * @param {Context} context
 * @param {TrackFields} safeOptions
 * @returns {string}
 */
function containerFlow(parent, context, safeOptions) {
  const indexStack = context.indexStack;
  const children = parent.children || [];
  const tracker = track(safeOptions);
  /** @type {Array<string>} */
  const results = [];
  let index = -1;

  indexStack.push(-1);

  while (++index < children.length) {
    const child = children[index];

    indexStack[indexStack.length - 1] = index;

    results.push(
      tracker.move(
        context.handle(child, parent, context, {
          before: '\n',
          after: '\n',
          ...tracker.current()
        })
      )
    );

    if (child.type !== 'list') {
      context.bulletLastUsed = undefined;
    }

    if (index < children.length - 1) {
      results.push(tracker.move(between(child, children[index + 1])));
    }
  }

  indexStack.pop();

  return results.join('')

  /**
   * @param {Node} left
   * @param {Node} right
   * @returns {string}
   */
  function between(left, right) {
    let index = context.join.length;

    while (index--) {
      const result = context.join[index](left, right, parent, context);

      if (result === true || result === 1) {
        break
      }

      if (typeof result === 'number') {
        return '\n'.repeat(1 + result)
      }

      if (result === false) {
        return '\n\n<!---->\n\n'
      }
    }

    return '\n\n'
  }
}

/**
 * @callback Map
 * @param {string} value
 * @param {number} line
 * @param {boolean} blank
 * @returns {string}
 */

const eol = /\r?\n|\r/g;

/**
 * @param {string} value
 * @param {Map} map
 * @returns {string}
 */
function indentLines(value, map) {
  /** @type {Array<string>} */
  const result = [];
  let start = 0;
  let line = 0;
  /** @type {RegExpExecArray|null} */
  let match;

  while ((match = eol.exec(value))) {
    one(value.slice(start, match.index));
    result.push(match[0]);
    start = match.index + match[0].length;
    line++;
  }

  one(value.slice(start));

  return result.join('')

  /**
   * @param {string} value
   */
  function one(value) {
    result.push(map(value, line, !value));
  }
}

/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 */

/**
 * @param {Unsafe} pattern
 * @returns {RegExp}
 */
function patternCompile(pattern) {
  if (!pattern._compiled) {
    const before =
      (pattern.atBreak ? '[\\r\\n][\\t ]*' : '') +
      (pattern.before ? '(?:' + pattern.before + ')' : '');

    pattern._compiled = new RegExp(
      (before ? '(' + before + ')' : '') +
        (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? '\\' : '') +
        pattern.character +
        (pattern.after ? '(?:' + pattern.after + ')' : ''),
      'g'
    );
  }

  return pattern._compiled
}

/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 */

/**
 * @param {Array<string>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */
function patternInScope(stack, pattern) {
  return (
    listInScope(stack, pattern.inConstruct, true) &&
    !listInScope(stack, pattern.notInConstruct, false)
  )
}

/**
 * @param {Array<string>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */
function listInScope(stack, list, none) {
  if (!list) {
    return none
  }

  if (typeof list === 'string') {
    list = [list];
  }

  let index = -1;

  while (++index < list.length) {
    if (stack.includes(list[index])) {
      return true
    }
  }

  return false
}

/**
 * @typedef {import('../types.js').Context} Context
 * @typedef {import('../types.js').SafeOptions} SafeOptions
 */

/**
 * @param {Context} context
 * @param {string|null|undefined} input
 * @param {SafeOptions & {encode?: Array<string>}} config
 * @returns {string}
 */
function safe(context, input, config) {
  const value = (config.before || '') + (input || '') + (config.after || '');
  /** @type {Array<number>} */
  const positions = [];
  /** @type {Array<string>} */
  const result = [];
  /** @type {Record<number, {before: boolean, after: boolean}>} */
  const infos = {};
  let index = -1;

  while (++index < context.unsafe.length) {
    const pattern = context.unsafe[index];

    if (!patternInScope(context.stack, pattern)) {
      continue
    }

    const expression = patternCompile(pattern);
    /** @type {RegExpExecArray|null} */
    let match;

    while ((match = expression.exec(value))) {
      const before = 'before' in pattern || Boolean(pattern.atBreak);
      const after = 'after' in pattern;
      const position = match.index + (before ? match[1].length : 0);

      if (positions.includes(position)) {
        if (infos[position].before && !before) {
          infos[position].before = false;
        }

        if (infos[position].after && !after) {
          infos[position].after = false;
        }
      } else {
        positions.push(position);
        infos[position] = {before, after};
      }
    }
  }

  positions.sort(numerical);

  let start = config.before ? config.before.length : 0;
  const end = value.length - (config.after ? config.after.length : 0);
  index = -1;

  while (++index < positions.length) {
    const position = positions[index];

    // Character before or after matched:
    if (position < start || position >= end) {
      continue
    }

    // If this character is supposed to be escaped because it has a condition on
    // the next character, and the next character is definitly being escaped,
    // then skip this escape.
    if (
      (position + 1 < end &&
        positions[index + 1] === position + 1 &&
        infos[position].after &&
        !infos[position + 1].before &&
        !infos[position + 1].after) ||
      (positions[index - 1] === position - 1 &&
        infos[position].before &&
        !infos[position - 1].before &&
        !infos[position - 1].after)
    ) {
      continue
    }

    if (start !== position) {
      // If we have to use a character reference, an ampersand would be more
      // correct, but as backslashes only care about punctuation, either will
      // do the trick
      result.push(escapeBackslashes(value.slice(start, position), '\\'));
    }

    start = position;

    if (
      /[!-/:-@[-`{-~]/.test(value.charAt(position)) &&
      (!config.encode || !config.encode.includes(value.charAt(position)))
    ) {
      // Character escape.
      result.push('\\');
    } else {
      // Character reference.
      result.push(
        '&#x' + value.charCodeAt(position).toString(16).toUpperCase() + ';'
      );
      start++;
    }
  }

  result.push(escapeBackslashes(value.slice(start, end), config.after));

  return result.join('')
}

/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */
function numerical(a, b) {
  return a - b
}

/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */
function escapeBackslashes(value, after) {
  const expression = /\\(?=[!-/:-@[-`{-~])/g;
  /** @type {Array<number>} */
  const positions = [];
  /** @type {Array<string>} */
  const results = [];
  const whole = value + after;
  let index = -1;
  let start = 0;
  /** @type {RegExpExecArray|null} */
  let match;

  while ((match = expression.exec(whole))) {
    positions.push(match.index);
  }

  while (++index < positions.length) {
    if (start !== positions[index]) {
      results.push(value.slice(start, positions[index]));
    }

    results.push('\\');
    start = positions[index];
  }

  results.push(value.slice(start));

  return results.join('')
}

/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 */

/**
 * @returns {FromMarkdownExtension}
 */
function gfmFootnoteFromMarkdown() {
  return {
    enter: {
      gfmFootnoteDefinition: enterFootnoteDefinition,
      gfmFootnoteDefinitionLabelString: enterFootnoteDefinitionLabelString,
      gfmFootnoteCall: enterFootnoteCall,
      gfmFootnoteCallString: enterFootnoteCallString
    },
    exit: {
      gfmFootnoteDefinition: exitFootnoteDefinition,
      gfmFootnoteDefinitionLabelString: exitFootnoteDefinitionLabelString,
      gfmFootnoteCall: exitFootnoteCall,
      gfmFootnoteCallString: exitFootnoteCallString
    }
  }

  /** @type {FromMarkdownHandle} */
  function enterFootnoteDefinition(token) {
    this.enter(
      {type: 'footnoteDefinition', identifier: '', label: '', children: []},
      token
    );
  }

  /** @type {FromMarkdownHandle} */
  function enterFootnoteDefinitionLabelString() {
    this.buffer();
  }

  /** @type {FromMarkdownHandle} */
  function exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ (
      this.stack[this.stack.length - 1]
    );
    node.label = label;
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase();
  }

  /** @type {FromMarkdownHandle} */
  function exitFootnoteDefinition(token) {
    this.exit(token);
  }

  /** @type {FromMarkdownHandle} */
  function enterFootnoteCall(token) {
    this.enter({type: 'footnoteReference', identifier: '', label: ''}, token);
  }

  /** @type {FromMarkdownHandle} */
  function enterFootnoteCallString() {
    this.buffer();
  }

  /** @type {FromMarkdownHandle} */
  function exitFootnoteCallString(token) {
    const label = this.resume();
    const node = /** @type {FootnoteDefinition} */ (
      this.stack[this.stack.length - 1]
    );
    node.label = label;
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase();
  }

  /** @type {FromMarkdownHandle} */
  function exitFootnoteCall(token) {
    this.exit(token);
  }
}

/**
 * @returns {ToMarkdownExtension}
 */
function gfmFootnoteToMarkdown() {
  footnoteReference.peek = footnoteReferencePeek;

  return {
    // This is on by default already.
    unsafe: [{character: '[', inConstruct: ['phrasing', 'label', 'reference']}],
    handlers: {footnoteDefinition, footnoteReference}
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {FootnoteReference} node
   */
  function footnoteReference(node, _, context, safeOptions) {
    const tracker = track(safeOptions);
    let value = tracker.move('[^');
    const exit = context.enter('footnoteReference');
    const subexit = context.enter('reference');
    value += tracker.move(
      safe(context, association(node), {
        ...tracker.current(),
        before: value,
        after: ']'
      })
    );
    subexit();
    exit();
    value += tracker.move(']');
    return value
  }

  /** @type {ToMarkdownHandle} */
  function footnoteReferencePeek() {
    return '['
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {FootnoteDefinition} node
   */
  function footnoteDefinition(node, _, context, safeOptions) {
    const tracker = track(safeOptions);
    let value = tracker.move('[^');
    const exit = context.enter('footnoteDefinition');
    const subexit = context.enter('label');
    value += tracker.move(
      safe(context, association(node), {
        ...tracker.current(),
        before: value,
        after: ']'
      })
    );
    subexit();
    value += tracker.move(
      ']:' + (node.children && node.children.length > 0 ? ' ' : '')
    );
    tracker.shift(4);
    value += tracker.move(
      indentLines(containerFlow(node, context, tracker.current()), map)
    );
    exit();

    return value

    /** @type {Map} */
    function map(line, index, blank) {
      if (index) {
        return (blank ? '' : '    ') + line
      }

      return line
    }
  }
}

/**
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').SafeOptions} SafeOptions
 * @typedef {import('../types.js').Context} Context
 */

/**
 * @param {Parent} parent
 * @param {Context} context
 * @param {SafeOptions} safeOptions
 * @returns {string}
 */
function containerPhrasing(parent, context, safeOptions) {
  const indexStack = context.indexStack;
  const children = parent.children || [];
  /** @type {Array<string>} */
  const results = [];
  let index = -1;
  let before = safeOptions.before;

  indexStack.push(-1);
  let tracker = track(safeOptions);

  while (++index < children.length) {
    const child = children[index];
    /** @type {string} */
    let after;

    indexStack[indexStack.length - 1] = index;

    if (index + 1 < children.length) {
      // @ts-expect-error: hush, it’s actually a `zwitch`.
      let handle = context.handle.handlers[children[index + 1].type];
      if (handle && handle.peek) handle = handle.peek;
      after = handle
        ? handle(children[index + 1], parent, context, {
            before: '',
            after: '',
            ...tracker.current()
          }).charAt(0)
        : '';
    } else {
      after = safeOptions.after;
    }

    // In some cases, html (text) can be found in phrasing right after an eol.
    // When we’d serialize that, in most cases that would be seen as html
    // (flow).
    // As we can’t escape or so to prevent it from happening, we take a somewhat
    // reasonable approach: replace that eol with a space.
    // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
    if (
      results.length > 0 &&
      (before === '\r' || before === '\n') &&
      child.type === 'html'
    ) {
      results[results.length - 1] = results[results.length - 1].replace(
        /(\r?\n|\r)$/,
        ' '
      );
      before = ' ';

      // To do: does this work to reset tracker?
      tracker = track(safeOptions);
      tracker.move(results.join(''));
    }

    results.push(
      tracker.move(
        context.handle(child, parent, context, {
          ...tracker.current(),
          before,
          after
        })
      )
    );

    before = results[results.length - 1].slice(-1);
  }

  indexStack.pop();

  return results.join('')
}

/**
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */

/** @type {FromMarkdownExtension} */
const gfmStrikethroughFromMarkdown = {
  canContainEols: ['delete'],
  enter: {strikethrough: enterStrikethrough},
  exit: {strikethrough: exitStrikethrough}
};

/** @type {ToMarkdownExtension} */
const gfmStrikethroughToMarkdown = {
  unsafe: [{character: '~', inConstruct: 'phrasing'}],
  handlers: {delete: handleDelete}
};

handleDelete.peek = peekDelete;

/** @type {FromMarkdownHandle} */
function enterStrikethrough(token) {
  this.enter({type: 'delete', children: []}, token);
}

/** @type {FromMarkdownHandle} */
function exitStrikethrough(token) {
  this.exit(token);
}

/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */
function handleDelete(node, _, context, safeOptions) {
  const tracker = track(safeOptions);
  const exit = context.enter('emphasis');
  let value = tracker.move('~~');
  value += containerPhrasing(node, context, {
    ...tracker.current(),
    before: value,
    after: '~'
  });
  value += tracker.move('~~');
  exit();
  return value
}

/** @type {ToMarkdownHandle} */
function peekDelete() {
  return '~'
}

/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../types.js').Handle} Handle
 */

inlineCode.peek = inlineCodePeek;

/**
 * @type {Handle}
 * @param {InlineCode} node
 */
function inlineCode(node, _, context) {
  let value = node.value || '';
  let sequence = '`';
  let index = -1;

  // If there is a single grave accent on its own in the code, use a fence of
  // two.
  // If there are two in a row, use one.
  while (new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value)) {
    sequence += '`';
  }

  // If this is not just spaces or eols (tabs don’t count), and either the
  // first or last character are a space, eol, or tick, then pad with spaces.
  if (
    /[^ \r\n]/.test(value) &&
    ((/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value)) || /^`|`$/.test(value))
  ) {
    value = ' ' + value + ' ';
  }

  // We have a potential problem: certain characters after eols could result in
  // blocks being seen.
  // For example, if someone injected the string `'\n# b'`, then that would
  // result in an ATX heading.
  // We can’t escape characters in `inlineCode`, but because eols are
  // transformed to spaces when going from markdown to HTML anyway, we can swap
  // them out.
  while (++index < context.unsafe.length) {
    const pattern = context.unsafe[index];
    const expression = patternCompile(pattern);
    /** @type {RegExpExecArray|null} */
    let match;

    // Only look for `atBreak`s.
    // Btw: note that `atBreak` patterns will always start the regex at LF or
    // CR.
    if (!pattern.atBreak) continue

    while ((match = expression.exec(value))) {
      let position = match.index;

      // Support CRLF (patterns only look for one of the characters).
      if (
        value.charCodeAt(position) === 10 /* `\n` */ &&
        value.charCodeAt(position - 1) === 13 /* `\r` */
      ) {
        position--;
      }

      value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
    }
  }

  return sequence + value + sequence
}

/**
 * @type {Handle}
 */
function inlineCodePeek() {
  return '`'
}

/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|Array<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */

/**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */

/**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {Array<Array<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */
function markdownTable(table, options = {}) {
  const align = (options.align || []).concat();
  const stringLength = options.stringLength || defaultStringLength;
  /** @type {Array<number>} Character codes as symbols for alignment per column. */
  const alignments = [];
  /** @type {Array<Array<string>>} Cells per row. */
  const cellMatrix = [];
  /** @type {Array<Array<number>>} Sizes of each cell per row. */
  const sizeMatrix = [];
  /** @type {Array<number>} */
  const longestCellByColumn = [];
  let mostCellsPerRow = 0;
  let rowIndex = -1;

  // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
  // do superfluous work when aligning, so optimize for aligning.
  while (++rowIndex < table.length) {
    /** @type {Array<string>} */
    const row = [];
    /** @type {Array<number>} */
    const sizes = [];
    let columnIndex = -1;

    if (table[rowIndex].length > mostCellsPerRow) {
      mostCellsPerRow = table[rowIndex].length;
    }

    while (++columnIndex < table[rowIndex].length) {
      const cell = serialize(table[rowIndex][columnIndex]);

      if (options.alignDelimiters !== false) {
        const size = stringLength(cell);
        sizes[columnIndex] = size;

        if (
          longestCellByColumn[columnIndex] === undefined ||
          size > longestCellByColumn[columnIndex]
        ) {
          longestCellByColumn[columnIndex] = size;
        }
      }

      row.push(cell);
    }

    cellMatrix[rowIndex] = row;
    sizeMatrix[rowIndex] = sizes;
  }

  // Figure out which alignments to use.
  let columnIndex = -1;

  if (typeof align === 'object' && 'length' in align) {
    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = toAlignment(align[columnIndex]);
    }
  } else {
    const code = toAlignment(align);

    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = code;
    }
  }

  // Inject the alignment row.
  columnIndex = -1;
  /** @type {Array<string>} */
  const row = [];
  /** @type {Array<number>} */
  const sizes = [];

  while (++columnIndex < mostCellsPerRow) {
    const code = alignments[columnIndex];
    let before = '';
    let after = '';

    if (code === 99 /* `c` */) {
      before = ':';
      after = ':';
    } else if (code === 108 /* `l` */) {
      before = ':';
    } else if (code === 114 /* `r` */) {
      after = ':';
    }

    // There *must* be at least one hyphen-minus in each alignment cell.
    let size =
      options.alignDelimiters === false
        ? 1
        : Math.max(
            1,
            longestCellByColumn[columnIndex] - before.length - after.length
          );

    const cell = before + '-'.repeat(size) + after;

    if (options.alignDelimiters !== false) {
      size = before.length + size + after.length;

      if (size > longestCellByColumn[columnIndex]) {
        longestCellByColumn[columnIndex] = size;
      }

      sizes[columnIndex] = size;
    }

    row[columnIndex] = cell;
  }

  // Inject the alignment row.
  cellMatrix.splice(1, 0, row);
  sizeMatrix.splice(1, 0, sizes);

  rowIndex = -1;
  /** @type {Array<string>} */
  const lines = [];

  while (++rowIndex < cellMatrix.length) {
    const row = cellMatrix[rowIndex];
    const sizes = sizeMatrix[rowIndex];
    columnIndex = -1;
    /** @type {Array<string>} */
    const line = [];

    while (++columnIndex < mostCellsPerRow) {
      const cell = row[columnIndex] || '';
      let before = '';
      let after = '';

      if (options.alignDelimiters !== false) {
        const size =
          longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
        const code = alignments[columnIndex];

        if (code === 114 /* `r` */) {
          before = ' '.repeat(size);
        } else if (code === 99 /* `c` */) {
          if (size % 2) {
            before = ' '.repeat(size / 2 + 0.5);
            after = ' '.repeat(size / 2 - 0.5);
          } else {
            before = ' '.repeat(size / 2);
            after = before;
          }
        } else {
          after = ' '.repeat(size);
        }
      }

      if (options.delimiterStart !== false && !columnIndex) {
        line.push('|');
      }

      if (
        options.padding !== false &&
        // Don’t add the opening space if we’re not aligning and the cell is
        // empty: there will be a closing space.
        !(options.alignDelimiters === false && cell === '') &&
        (options.delimiterStart !== false || columnIndex)
      ) {
        line.push(' ');
      }

      if (options.alignDelimiters !== false) {
        line.push(before);
      }

      line.push(cell);

      if (options.alignDelimiters !== false) {
        line.push(after);
      }

      if (options.padding !== false) {
        line.push(' ');
      }

      if (
        options.delimiterEnd !== false ||
        columnIndex !== mostCellsPerRow - 1
      ) {
        line.push('|');
      }
    }

    lines.push(
      options.delimiterEnd === false
        ? line.join('').replace(/ +$/, '')
        : line.join('')
    );
  }

  return lines.join('\n')
}

/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */
function serialize(value) {
  return value === null || value === undefined ? '' : String(value)
}

/**
 * @param {string} value
 * @returns {number}
 */
function defaultStringLength(value) {
  return value.length
}

/**
 * @param {string|null|undefined} value
 * @returns {number}
 */
function toAlignment(value) {
  const code = typeof value === 'string' ? value.codePointAt(0) : 0;

  return code === 67 /* `C` */ || code === 99 /* `c` */
    ? 99 /* `c` */
    : code === 76 /* `L` */ || code === 108 /* `l` */
    ? 108 /* `l` */
    : code === 82 /* `R` */ || code === 114 /* `r` */
    ? 114 /* `r` */
    : 0
}

/**
 * @typedef {import('mdast').AlignType} AlignType
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('markdown-table').MarkdownTableOptions} MarkdownTableOptions
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Context} ToMarkdownContext
 * @typedef {import('mdast-util-to-markdown').SafeOptions} SafeOptions
 *
 * @typedef Options
 * @property {boolean} [tableCellPadding=true]
 * @property {boolean} [tablePipeAlign=true]
 * @property {MarkdownTableOptions['stringLength']} [stringLength]
 */

/** @type {FromMarkdownExtension} */
const gfmTableFromMarkdown = {
  enter: {
    table: enterTable,
    tableData: enterCell,
    tableHeader: enterCell,
    tableRow: enterRow
  },
  exit: {
    codeText: exitCodeText,
    table: exitTable,
    tableData: exit,
    tableHeader: exit,
    tableRow: exit
  }
};

/** @type {FromMarkdownHandle} */
function enterTable(token) {
  /** @type {Array<'left'|'right'|'center'|'none'>} */
  // @ts-expect-error: `align` is custom.
  const align = token._align;
  this.enter(
    {
      type: 'table',
      align: align.map((d) => (d === 'none' ? null : d)),
      children: []
    },
    token
  );
  this.setData('inTable', true);
}

/** @type {FromMarkdownHandle} */
function exitTable(token) {
  this.exit(token);
  this.setData('inTable');
}

/** @type {FromMarkdownHandle} */
function enterRow(token) {
  this.enter({type: 'tableRow', children: []}, token);
}

/** @type {FromMarkdownHandle} */
function exit(token) {
  this.exit(token);
}

/** @type {FromMarkdownHandle} */
function enterCell(token) {
  this.enter({type: 'tableCell', children: []}, token);
}

// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/** @type {FromMarkdownHandle} */
function exitCodeText(token) {
  let value = this.resume();

  if (this.getData('inTable')) {
    value = value.replace(/\\([\\|])/g, replace);
  }

  const node = /** @type {InlineCode} */ (this.stack[this.stack.length - 1]);
  node.value = value;
  this.exit(token);
}

/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */
function replace($0, $1) {
  // Pipes work, backslashes don’t (but can’t escape pipes).
  return $1 === '|' ? $1 : $0
}

/**
 * @param {Options} [options]
 * @returns {ToMarkdownExtension}
 */
function gfmTableToMarkdown(options) {
  const settings = options || {};
  const padding = settings.tableCellPadding;
  const alignDelimiters = settings.tablePipeAlign;
  const stringLength = settings.stringLength;
  const around = padding ? ' ' : '|';

  return {
    unsafe: [
      {character: '\r', inConstruct: 'tableCell'},
      {character: '\n', inConstruct: 'tableCell'},
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      {atBreak: true, character: '|', after: '[\t :-]'},
      // A pipe in a cell must be encoded.
      {character: '|', inConstruct: 'tableCell'},
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      {atBreak: true, character: ':', after: '-'},
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      {atBreak: true, character: '-', after: '[:|-]'}
    ],
    handlers: {
      table: handleTable,
      tableRow: handleTableRow,
      tableCell: handleTableCell,
      inlineCode: inlineCodeWithTable
    }
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */
  function handleTable(node, _, context, safeOptions) {
    return serializeData(
      handleTableAsData(node, context, safeOptions),
      // @ts-expect-error: fixed in `markdown-table@3.0.1`.
      node.align
    )
  }

  /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */
  function handleTableRow(node, _, context, safeOptions) {
    const row = handleTableRowAsData(node, context, safeOptions);
    // `markdown-table` will always add an align row
    const value = serializeData([row]);
    return value.slice(0, value.indexOf('\n'))
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */
  function handleTableCell(node, _, context, safeOptions) {
    const exit = context.enter('tableCell');
    const subexit = context.enter('phrasing');
    const value = containerPhrasing(node, context, {
      ...safeOptions,
      before: around,
      after: around
    });
    subexit();
    exit();
    return value
  }

  /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string>} [align]
   */
  function serializeData(matrix, align) {
    return markdownTable(matrix, {
      align,
      alignDelimiters,
      padding,
      stringLength
    })
  }

  /**
   * @param {Table} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */
  function handleTableAsData(node, context, safeOptions) {
    const children = node.children;
    let index = -1;
    /** @type {Array<Array<string>>} */
    const result = [];
    const subexit = context.enter('table');

    while (++index < children.length) {
      result[index] = handleTableRowAsData(
        children[index],
        context,
        safeOptions
      );
    }

    subexit();

    return result
  }

  /**
   * @param {TableRow} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */
  function handleTableRowAsData(node, context, safeOptions) {
    const children = node.children;
    let index = -1;
    /** @type {Array<string>} */
    const result = [];
    const subexit = context.enter('tableRow');

    while (++index < children.length) {
      // Note: the positional info as used here is incorrect.
      // Making it correct would be impossible due to aligning cells?
      // And it would need copy/pasting `markdown-table` into this project.
      result[index] = handleTableCell(
        children[index],
        node,
        context,
        safeOptions
      );
    }

    subexit();

    return result
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */
  function inlineCodeWithTable(node, parent, context) {
    let value = inlineCode(node, parent, context);

    if (context.stack.includes('tableCell')) {
      value = value.replace(/\|/g, '\\$&');
    }

    return value
  }
}

/**
 * @typedef {import('../types.js').Context} Context
 * @typedef {import('../types.js').Options} Options
 */

/**
 * @param {Context} context
 * @returns {Exclude<Options['bullet'], undefined>}
 */
function checkBullet(context) {
  const marker = context.options.bullet || '*';

  if (marker !== '*' && marker !== '+' && marker !== '-') {
    throw new Error(
      'Cannot serialize items with `' +
        marker +
        '` for `options.bullet`, expected `*`, `+`, or `-`'
    )
  }

  return marker
}

/**
 * @typedef {import('../types.js').Context} Context
 * @typedef {import('../types.js').Options} Options
 */

/**
 * @param {Context} context
 * @returns {Exclude<Options['listItemIndent'], undefined>}
 */
function checkListItemIndent(context) {
  const style = context.options.listItemIndent || 'tab';

  // To do: remove in a major.
  // @ts-expect-error: deprecated.
  if (style === 1 || style === '1') {
    return 'one'
  }

  if (style !== 'tab' && style !== 'one' && style !== 'mixed') {
    throw new Error(
      'Cannot serialize items with `' +
        style +
        '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`'
    )
  }

  return style
}

/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').List} List
 * @typedef {import('../util/indent-lines.js').Map} Map
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').Handle} Handle
 */

/**
 * @type {Handle}
 * @param {ListItem} node
 */
function listItem(node, parent, context, safeOptions) {
  const listItemIndent = checkListItemIndent(context);
  let bullet = context.bulletCurrent || checkBullet(context);

  // Add the marker value for ordered lists.
  if (parent && parent.type === 'list' && parent.ordered) {
    bullet =
      (typeof parent.start === 'number' && parent.start > -1
        ? parent.start
        : 1) +
      (context.options.incrementListMarker === false
        ? 0
        : parent.children.indexOf(node)) +
      bullet;
  }

  let size = bullet.length + 1;

  if (
    listItemIndent === 'tab' ||
    (listItemIndent === 'mixed' &&
      ((parent && parent.type === 'list' && parent.spread) || node.spread))
  ) {
    size = Math.ceil(size / 4) * 4;
  }

  const tracker = track(safeOptions);
  tracker.move(bullet + ' '.repeat(size - bullet.length));
  tracker.shift(size);
  const exit = context.enter('listItem');
  const value = indentLines(
    containerFlow(node, context, tracker.current()),
    map
  );
  exit();

  return value

  /** @type {Map} */
  function map(line, index, blank) {
    if (index) {
      return (blank ? '' : ' '.repeat(size)) + line
    }

    return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line
  }
}

/**
 * @typedef {Extract<import('mdast').Root|import('mdast').Content, import('unist').Parent>} Parent
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').BlockContent} BlockContent
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */

/** @type {FromMarkdownExtension} */
const gfmTaskListItemFromMarkdown = {
  exit: {
    taskListCheckValueChecked: exitCheck,
    taskListCheckValueUnchecked: exitCheck,
    paragraph: exitParagraphWithTaskListItem
  }
};

/** @type {ToMarkdownExtension} */
const gfmTaskListItemToMarkdown = {
  unsafe: [{atBreak: true, character: '-', after: '[:|-]'}],
  handlers: {listItem: listItemWithTaskListItem}
};

/** @type {FromMarkdownHandle} */
function exitCheck(token) {
  const node = /** @type {ListItem} */ (this.stack[this.stack.length - 2]);
  // We’re always in a paragraph, in a list item.
  node.checked = token.type === 'taskListCheckValueChecked';
}

/** @type {FromMarkdownHandle} */
function exitParagraphWithTaskListItem(token) {
  const parent = /** @type {Parent} */ (this.stack[this.stack.length - 2]);
  const node = /** @type {Paragraph} */ (this.stack[this.stack.length - 1]);
  const siblings = parent.children;
  const head = node.children[0];
  let index = -1;
  /** @type {Paragraph|undefined} */
  let firstParaghraph;

  if (
    parent &&
    parent.type === 'listItem' &&
    typeof parent.checked === 'boolean' &&
    head &&
    head.type === 'text'
  ) {
    while (++index < siblings.length) {
      const sibling = siblings[index];
      if (sibling.type === 'paragraph') {
        firstParaghraph = sibling;
        break
      }
    }

    if (firstParaghraph === node) {
      // Must start with a space or a tab.
      head.value = head.value.slice(1);

      if (head.value.length === 0) {
        node.children.shift();
      } else if (
        node.position &&
        head.position &&
        typeof head.position.start.offset === 'number'
      ) {
        head.position.start.column++;
        head.position.start.offset++;
        node.position.start = Object.assign({}, head.position.start);
      }
    }
  }

  this.exit(token);
}

/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */
function listItemWithTaskListItem(node, parent, context, safeOptions) {
  const head = node.children[0];
  const checkable =
    typeof node.checked === 'boolean' && head && head.type === 'paragraph';
  const checkbox = '[' + (node.checked ? 'x' : ' ') + '] ';
  const tracker = track(safeOptions);

  if (checkable) {
    tracker.move(checkbox);
  }

  let value = listItem(node, parent, context, {
    ...safeOptions,
    ...tracker.current()
  });

  if (checkable) {
    value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
  }

  return value

  /**
   * @param {string} $0
   * @returns {string}
   */
  function check($0) {
    return $0 + checkbox
  }
}

/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-gfm-table').Options} Options
 */

/**
 * @returns {Array<FromMarkdownExtension>}
 */
function gfmFromMarkdown() {
  return [
    gfmAutolinkLiteralFromMarkdown,
    gfmFootnoteFromMarkdown(),
    gfmStrikethroughFromMarkdown,
    gfmTableFromMarkdown,
    gfmTaskListItemFromMarkdown
  ]
}

/**
 * @param {Options} [options]
 * @returns {ToMarkdownExtension}
 */
function gfmToMarkdown(options) {
  return {
    extensions: [
      gfmAutolinkLiteralToMarkdown,
      gfmFootnoteToMarkdown(),
      gfmStrikethroughToMarkdown,
      gfmTableToMarkdown(options),
      gfmTaskListItemToMarkdown
    ]
  }
}

/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('micromark-extension-gfm').Options & import('mdast-util-gfm').Options} Options
 */

/**
 * Plugin to support GFM (autolink literals, footnotes, strikethrough, tables, tasklists).
 *
 * @type {import('unified').Plugin<[Options?]|void[], Root>}
 */
function remarkGfm(options = {}) {
  const data = this.data();

  add('micromarkExtensions', gfm(options));
  add('fromMarkdownExtensions', gfmFromMarkdown());
  add('toMarkdownExtensions', gfmToMarkdown(options));

  /**
   * @param {string} field
   * @param {unknown} value
   */
  function add(field, value) {
    const list = /** @type {unknown[]} */ (
      // Other extensions
      /* c8 ignore next 2 */
      data[field] ? data[field] : (data[field] = [])
    );

    list.push(value);
  }
}

var Earth = "data:image/png;base64,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";

var axios$2 = {exports: {}};

var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var bind$1 = bind$2;

// utils is a library of generic helper functions non-specific to axios

var toString$3 = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString$3.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return toString$3.call(val) === '[object FormData]';
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString$3.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString$3.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString$3.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString$3.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString$3.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return toString$3.call(val) === '[object URLSearchParams]';
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$f = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

var utils$e = utils$f;

function encode$9(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$3 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$e.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$e.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$e.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$e.forEach(val, function parseValue(v) {
        if (utils$e.isDate(v)) {
          v = v.toISOString();
        } else if (utils$e.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode$9(key) + '=' + encode$9(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$d = utils$f;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$d.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$c = utils$f;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$c.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError$3 = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};

var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var enhanceError$2 = enhanceError$3;

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError$3 = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError$2(error, config, code, request, response);
};

var createError$2 = createError$3;

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle$2 = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError$2(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

var utils$b = utils$f;

var cookies$1 = (
  utils$b.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils$b.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils$b.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils$b.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

var isAbsoluteURL = isAbsoluteURL$1;
var combineURLs = combineURLs$1;

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath$2 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

var utils$a = utils$f;

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils$a.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$a.trim(line.substr(0, i)).toLowerCase();
    val = utils$a.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var utils$9 = utils$f;

var isURLSameOrigin$1 = (
  utils$9.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils$9.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel$4(message) {
  this.message = message;
}

Cancel$4.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel$4.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel$4;

var utils$8 = utils$f;
var settle$1 = settle$2;
var cookies = cookies$1;
var buildURL$2 = buildURL$3;
var buildFullPath$1 = buildFullPath$2;
var parseHeaders = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError$1 = createError$3;
var transitionalDefaults$2 = transitional;
var Cancel$3 = Cancel_1;

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils$8.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath$1(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL$2(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle$1(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError$1('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError$1('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults$2;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError$1(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils$8.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$8.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils$8.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel$3('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

var followRedirects = {exports: {}};

var debug$1;

var debug_1 = function () {
  if (!debug$1) {
    try {
      /* eslint global-require: off */
      debug$1 = require("debug")("follow-redirects");
    }
    catch (error) { /* */ }
    if (typeof debug$1 !== "function") {
      debug$1 = function () { /* */ };
    }
  }
  debug$1.apply(null, arguments);
};

var url$1 = require$$0$1;
var URL$2 = url$1.URL;
var http$1 = require$$1;
var https$1 = require$$2;
var Writable = require$$3.Writable;
var assert$1 = require$$4;
var debug = debug_1;

// Create handlers that pass events from native requests
var events = ["abort", "aborted", "connect", "error", "socket", "timeout"];
var eventHandlers = Object.create(null);
events.forEach(function (event) {
  eventHandlers[event] = function (arg1, arg2, arg3) {
    this._redirectable.emit(event, arg1, arg2, arg3);
  };
});

// Error types with codes
var RedirectionError = createErrorType(
  "ERR_FR_REDIRECTION_FAILURE",
  "Redirected request failed"
);
var TooManyRedirectsError = createErrorType(
  "ERR_FR_TOO_MANY_REDIRECTS",
  "Maximum number of redirects exceeded"
);
var MaxBodyLengthExceededError = createErrorType(
  "ERR_FR_MAX_BODY_LENGTH_EXCEEDED",
  "Request body larger than maxBodyLength limit"
);
var WriteAfterEndError = createErrorType(
  "ERR_STREAM_WRITE_AFTER_END",
  "write after end"
);

// An HTTP(S) request that can be redirected
function RedirectableRequest(options, responseCallback) {
  // Initialize the request
  Writable.call(this);
  this._sanitizeOptions(options);
  this._options = options;
  this._ended = false;
  this._ending = false;
  this._redirectCount = 0;
  this._redirects = [];
  this._requestBodyLength = 0;
  this._requestBodyBuffers = [];

  // Attach a callback if passed
  if (responseCallback) {
    this.on("response", responseCallback);
  }

  // React to responses of native requests
  var self = this;
  this._onNativeResponse = function (response) {
    self._processResponse(response);
  };

  // Perform the first request
  this._performRequest();
}
RedirectableRequest.prototype = Object.create(Writable.prototype);

RedirectableRequest.prototype.abort = function () {
  abortRequest(this._currentRequest);
  this.emit("abort");
};

// Writes buffered data to the current native request
RedirectableRequest.prototype.write = function (data, encoding, callback) {
  // Writing is not allowed if end has been called
  if (this._ending) {
    throw new WriteAfterEndError();
  }

  // Validate input and shift parameters if necessary
  if (!(typeof data === "string" || typeof data === "object" && ("length" in data))) {
    throw new TypeError("data should be a string, Buffer or Uint8Array");
  }
  if (typeof encoding === "function") {
    callback = encoding;
    encoding = null;
  }

  // Ignore empty buffers, since writing them doesn't invoke the callback
  // https://github.com/nodejs/node/issues/22066
  if (data.length === 0) {
    if (callback) {
      callback();
    }
    return;
  }
  // Only write when we don't exceed the maximum body length
  if (this._requestBodyLength + data.length <= this._options.maxBodyLength) {
    this._requestBodyLength += data.length;
    this._requestBodyBuffers.push({ data: data, encoding: encoding });
    this._currentRequest.write(data, encoding, callback);
  }
  // Error when we exceed the maximum body length
  else {
    this.emit("error", new MaxBodyLengthExceededError());
    this.abort();
  }
};

// Ends the current native request
RedirectableRequest.prototype.end = function (data, encoding, callback) {
  // Shift parameters if necessary
  if (typeof data === "function") {
    callback = data;
    data = encoding = null;
  }
  else if (typeof encoding === "function") {
    callback = encoding;
    encoding = null;
  }

  // Write data if needed and end
  if (!data) {
    this._ended = this._ending = true;
    this._currentRequest.end(null, null, callback);
  }
  else {
    var self = this;
    var currentRequest = this._currentRequest;
    this.write(data, encoding, function () {
      self._ended = true;
      currentRequest.end(null, null, callback);
    });
    this._ending = true;
  }
};

// Sets a header value on the current native request
RedirectableRequest.prototype.setHeader = function (name, value) {
  this._options.headers[name] = value;
  this._currentRequest.setHeader(name, value);
};

// Clears a header value on the current native request
RedirectableRequest.prototype.removeHeader = function (name) {
  delete this._options.headers[name];
  this._currentRequest.removeHeader(name);
};

// Global timeout for all underlying requests
RedirectableRequest.prototype.setTimeout = function (msecs, callback) {
  var self = this;

  // Destroys the socket on timeout
  function destroyOnTimeout(socket) {
    socket.setTimeout(msecs);
    socket.removeListener("timeout", socket.destroy);
    socket.addListener("timeout", socket.destroy);
  }

  // Sets up a timer to trigger a timeout event
  function startTimer(socket) {
    if (self._timeout) {
      clearTimeout(self._timeout);
    }
    self._timeout = setTimeout(function () {
      self.emit("timeout");
      clearTimer();
    }, msecs);
    destroyOnTimeout(socket);
  }

  // Stops a timeout from triggering
  function clearTimer() {
    // Clear the timeout
    if (self._timeout) {
      clearTimeout(self._timeout);
      self._timeout = null;
    }

    // Clean up all attached listeners
    self.removeListener("abort", clearTimer);
    self.removeListener("error", clearTimer);
    self.removeListener("response", clearTimer);
    if (callback) {
      self.removeListener("timeout", callback);
    }
    if (!self.socket) {
      self._currentRequest.removeListener("socket", startTimer);
    }
  }

  // Attach callback if passed
  if (callback) {
    this.on("timeout", callback);
  }

  // Start the timer if or when the socket is opened
  if (this.socket) {
    startTimer(this.socket);
  }
  else {
    this._currentRequest.once("socket", startTimer);
  }

  // Clean up on events
  this.on("socket", destroyOnTimeout);
  this.on("abort", clearTimer);
  this.on("error", clearTimer);
  this.on("response", clearTimer);

  return this;
};

// Proxy all other public ClientRequest methods
[
  "flushHeaders", "getHeader",
  "setNoDelay", "setSocketKeepAlive",
].forEach(function (method) {
  RedirectableRequest.prototype[method] = function (a, b) {
    return this._currentRequest[method](a, b);
  };
});

// Proxy all public ClientRequest properties
["aborted", "connection", "socket"].forEach(function (property) {
  Object.defineProperty(RedirectableRequest.prototype, property, {
    get: function () { return this._currentRequest[property]; },
  });
});

RedirectableRequest.prototype._sanitizeOptions = function (options) {
  // Ensure headers are always present
  if (!options.headers) {
    options.headers = {};
  }

  // Since http.request treats host as an alias of hostname,
  // but the url module interprets host as hostname plus port,
  // eliminate the host property to avoid confusion.
  if (options.host) {
    // Use hostname if set, because it has precedence
    if (!options.hostname) {
      options.hostname = options.host;
    }
    delete options.host;
  }

  // Complete the URL object when necessary
  if (!options.pathname && options.path) {
    var searchPos = options.path.indexOf("?");
    if (searchPos < 0) {
      options.pathname = options.path;
    }
    else {
      options.pathname = options.path.substring(0, searchPos);
      options.search = options.path.substring(searchPos);
    }
  }
};


// Executes the next native request (initial or redirect)
RedirectableRequest.prototype._performRequest = function () {
  // Load the native protocol
  var protocol = this._options.protocol;
  var nativeProtocol = this._options.nativeProtocols[protocol];
  if (!nativeProtocol) {
    this.emit("error", new TypeError("Unsupported protocol " + protocol));
    return;
  }

  // If specified, use the agent corresponding to the protocol
  // (HTTP and HTTPS use different types of agents)
  if (this._options.agents) {
    var scheme = protocol.slice(0, -1);
    this._options.agent = this._options.agents[scheme];
  }

  // Create the native request
  var request = this._currentRequest =
        nativeProtocol.request(this._options, this._onNativeResponse);
  this._currentUrl = url$1.format(this._options);

  // Set up event handlers
  request._redirectable = this;
  for (var e = 0; e < events.length; e++) {
    request.on(events[e], eventHandlers[events[e]]);
  }

  // End a redirected request
  // (The first request must be ended explicitly with RedirectableRequest#end)
  if (this._isRedirect) {
    // Write the request entity and end.
    var i = 0;
    var self = this;
    var buffers = this._requestBodyBuffers;
    (function writeNext(error) {
      // Only write if this request has not been redirected yet
      /* istanbul ignore else */
      if (request === self._currentRequest) {
        // Report any write errors
        /* istanbul ignore if */
        if (error) {
          self.emit("error", error);
        }
        // Write the next buffer if there are still left
        else if (i < buffers.length) {
          var buffer = buffers[i++];
          /* istanbul ignore else */
          if (!request.finished) {
            request.write(buffer.data, buffer.encoding, writeNext);
          }
        }
        // End the request if `end` has been called on us
        else if (self._ended) {
          request.end();
        }
      }
    }());
  }
};

// Processes a response from the current native request
RedirectableRequest.prototype._processResponse = function (response) {
  // Store the redirected response
  var statusCode = response.statusCode;
  if (this._options.trackRedirects) {
    this._redirects.push({
      url: this._currentUrl,
      headers: response.headers,
      statusCode: statusCode,
    });
  }

  // RFC7231§6.4: The 3xx (Redirection) class of status code indicates
  // that further action needs to be taken by the user agent in order to
  // fulfill the request. If a Location header field is provided,
  // the user agent MAY automatically redirect its request to the URI
  // referenced by the Location field value,
  // even if the specific status code is not understood.

  // If the response is not a redirect; return it as-is
  var location = response.headers.location;
  if (!location || this._options.followRedirects === false ||
      statusCode < 300 || statusCode >= 400) {
    response.responseUrl = this._currentUrl;
    response.redirects = this._redirects;
    this.emit("response", response);

    // Clean up
    this._requestBodyBuffers = [];
    return;
  }

  // The response is a redirect, so abort the current request
  abortRequest(this._currentRequest);
  // Discard the remainder of the response to avoid waiting for data
  response.destroy();

  // RFC7231§6.4: A client SHOULD detect and intervene
  // in cyclical redirections (i.e., "infinite" redirection loops).
  if (++this._redirectCount > this._options.maxRedirects) {
    this.emit("error", new TooManyRedirectsError());
    return;
  }

  // Store the request headers if applicable
  var requestHeaders;
  var beforeRedirect = this._options.beforeRedirect;
  if (beforeRedirect) {
    requestHeaders = Object.assign({
      // The Host header was set by nativeProtocol.request
      Host: response.req.getHeader("host"),
    }, this._options.headers);
  }

  // RFC7231§6.4: Automatic redirection needs to done with
  // care for methods not known to be safe, […]
  // RFC7231§6.4.2–3: For historical reasons, a user agent MAY change
  // the request method from POST to GET for the subsequent request.
  var method = this._options.method;
  if ((statusCode === 301 || statusCode === 302) && this._options.method === "POST" ||
      // RFC7231§6.4.4: The 303 (See Other) status code indicates that
      // the server is redirecting the user agent to a different resource […]
      // A user agent can perform a retrieval request targeting that URI
      // (a GET or HEAD request if using HTTP) […]
      (statusCode === 303) && !/^(?:GET|HEAD)$/.test(this._options.method)) {
    this._options.method = "GET";
    // Drop a possible entity and headers related to it
    this._requestBodyBuffers = [];
    removeMatchingHeaders(/^content-/i, this._options.headers);
  }

  // Drop the Host header, as the redirect might lead to a different host
  var currentHostHeader = removeMatchingHeaders(/^host$/i, this._options.headers);

  // If the redirect is relative, carry over the host of the last request
  var currentUrlParts = url$1.parse(this._currentUrl);
  var currentHost = currentHostHeader || currentUrlParts.host;
  var currentUrl = /^\w+:/.test(location) ? this._currentUrl :
    url$1.format(Object.assign(currentUrlParts, { host: currentHost }));

  // Determine the URL of the redirection
  var redirectUrl;
  try {
    redirectUrl = url$1.resolve(currentUrl, location);
  }
  catch (cause) {
    this.emit("error", new RedirectionError(cause));
    return;
  }

  // Create the redirected request
  debug("redirecting to", redirectUrl);
  this._isRedirect = true;
  var redirectUrlParts = url$1.parse(redirectUrl);
  Object.assign(this._options, redirectUrlParts);

  // Drop confidential headers when redirecting to a less secure protocol
  // or to a different domain that is not a superdomain
  if (redirectUrlParts.protocol !== currentUrlParts.protocol &&
     redirectUrlParts.protocol !== "https:" ||
     redirectUrlParts.host !== currentHost &&
     !isSubdomain(redirectUrlParts.host, currentHost)) {
    removeMatchingHeaders(/^(?:authorization|cookie)$/i, this._options.headers);
  }

  // Evaluate the beforeRedirect callback
  if (typeof beforeRedirect === "function") {
    var responseDetails = {
      headers: response.headers,
      statusCode: statusCode,
    };
    var requestDetails = {
      url: currentUrl,
      method: method,
      headers: requestHeaders,
    };
    try {
      beforeRedirect(this._options, responseDetails, requestDetails);
    }
    catch (err) {
      this.emit("error", err);
      return;
    }
    this._sanitizeOptions(this._options);
  }

  // Perform the redirected request
  try {
    this._performRequest();
  }
  catch (cause) {
    this.emit("error", new RedirectionError(cause));
  }
};

// Wraps the key/value object of protocols with redirect functionality
function wrap(protocols) {
  // Default settings
  var exports = {
    maxRedirects: 21,
    maxBodyLength: 10 * 1024 * 1024,
  };

  // Wrap each protocol
  var nativeProtocols = {};
  Object.keys(protocols).forEach(function (scheme) {
    var protocol = scheme + ":";
    var nativeProtocol = nativeProtocols[protocol] = protocols[scheme];
    var wrappedProtocol = exports[scheme] = Object.create(nativeProtocol);

    // Executes a request, following redirects
    function request(input, options, callback) {
      // Parse parameters
      if (typeof input === "string") {
        var urlStr = input;
        try {
          input = urlToOptions(new URL$2(urlStr));
        }
        catch (err) {
          /* istanbul ignore next */
          input = url$1.parse(urlStr);
        }
      }
      else if (URL$2 && (input instanceof URL$2)) {
        input = urlToOptions(input);
      }
      else {
        callback = options;
        options = input;
        input = { protocol: protocol };
      }
      if (typeof options === "function") {
        callback = options;
        options = null;
      }

      // Set defaults
      options = Object.assign({
        maxRedirects: exports.maxRedirects,
        maxBodyLength: exports.maxBodyLength,
      }, input, options);
      options.nativeProtocols = nativeProtocols;

      assert$1.equal(options.protocol, protocol, "protocol mismatch");
      debug("options", options);
      return new RedirectableRequest(options, callback);
    }

    // Executes a GET request, following redirects
    function get(input, options, callback) {
      var wrappedRequest = wrappedProtocol.request(input, options, callback);
      wrappedRequest.end();
      return wrappedRequest;
    }

    // Expose the properties on the wrapped protocol
    Object.defineProperties(wrappedProtocol, {
      request: { value: request, configurable: true, enumerable: true, writable: true },
      get: { value: get, configurable: true, enumerable: true, writable: true },
    });
  });
  return exports;
}

/* istanbul ignore next */
function noop$1() { /* empty */ }

// from https://github.com/nodejs/node/blob/master/lib/internal/url.js
function urlToOptions(urlObject) {
  var options = {
    protocol: urlObject.protocol,
    hostname: urlObject.hostname.startsWith("[") ?
      /* istanbul ignore next */
      urlObject.hostname.slice(1, -1) :
      urlObject.hostname,
    hash: urlObject.hash,
    search: urlObject.search,
    pathname: urlObject.pathname,
    path: urlObject.pathname + urlObject.search,
    href: urlObject.href,
  };
  if (urlObject.port !== "") {
    options.port = Number(urlObject.port);
  }
  return options;
}

function removeMatchingHeaders(regex, headers) {
  var lastValue;
  for (var header in headers) {
    if (regex.test(header)) {
      lastValue = headers[header];
      delete headers[header];
    }
  }
  return (lastValue === null || typeof lastValue === "undefined") ?
    undefined : String(lastValue).trim();
}

function createErrorType(code, defaultMessage) {
  function CustomError(cause) {
    Error.captureStackTrace(this, this.constructor);
    if (!cause) {
      this.message = defaultMessage;
    }
    else {
      this.message = defaultMessage + ": " + cause.message;
      this.cause = cause;
    }
  }
  CustomError.prototype = new Error();
  CustomError.prototype.constructor = CustomError;
  CustomError.prototype.name = "Error [" + code + "]";
  CustomError.prototype.code = code;
  return CustomError;
}

function abortRequest(request) {
  for (var e = 0; e < events.length; e++) {
    request.removeListener(events[e], eventHandlers[events[e]]);
  }
  request.on("error", noop$1);
  request.abort();
}

function isSubdomain(subdomain, domain) {
  const dot = subdomain.length - domain.length - 1;
  return dot > 0 && subdomain[dot] === "." && subdomain.endsWith(domain);
}

// Exports
followRedirects.exports = wrap({ http: http$1, https: https$1 });
followRedirects.exports.wrap = wrap;

var data$1 = {
  "version": "0.26.1"
};

var utils$7 = utils$f;
var settle = settle$2;
var buildFullPath = buildFullPath$2;
var buildURL$1 = buildURL$3;
var http = require$$1;
var https = require$$2;
var httpFollow = followRedirects.exports.http;
var httpsFollow = followRedirects.exports.https;
var url = require$$0$1;
var zlib = require$$8$1;
var VERSION$1 = data$1.version;
var createError = createError$3;
var enhanceError$1 = enhanceError$3;
var transitionalDefaults$1 = transitional;
var Cancel$2 = Cancel_1;

var isHttps = /https:?/;

/**
 *
 * @param {http.ClientRequestArgs} options
 * @param {AxiosProxyConfig} proxy
 * @param {string} location
 */
function setProxy(options, proxy, location) {
  options.hostname = proxy.host;
  options.host = proxy.host;
  options.port = proxy.port;
  options.path = location;

  // Basic proxy authorization
  if (proxy.auth) {
    var base64 = Buffer.from(proxy.auth.username + ':' + proxy.auth.password, 'utf8').toString('base64');
    options.headers['Proxy-Authorization'] = 'Basic ' + base64;
  }

  // If a proxy is used, any redirects must also pass through the proxy
  options.beforeRedirect = function beforeRedirect(redirection) {
    redirection.headers.host = redirection.host;
    setProxy(redirection, proxy, redirection.href);
  };
}

/*eslint consistent-return:0*/
var http_1 = function httpAdapter(config) {
  return new Promise(function dispatchHttpRequest(resolvePromise, rejectPromise) {
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }
    var resolve = function resolve(value) {
      done();
      resolvePromise(value);
    };
    var rejected = false;
    var reject = function reject(value) {
      done();
      rejected = true;
      rejectPromise(value);
    };
    var data = config.data;
    var headers = config.headers;
    var headerNames = {};

    Object.keys(headers).forEach(function storeLowerName(name) {
      headerNames[name.toLowerCase()] = name;
    });

    // Set User-Agent (required by some servers)
    // See https://github.com/axios/axios/issues/69
    if ('user-agent' in headerNames) {
      // User-Agent is specified; handle case where no UA header is desired
      if (!headers[headerNames['user-agent']]) {
        delete headers[headerNames['user-agent']];
      }
      // Otherwise, use specified value
    } else {
      // Only set header if it hasn't been set in config
      headers['User-Agent'] = 'axios/' + VERSION$1;
    }

    if (data && !utils$7.isStream(data)) {
      if (Buffer.isBuffer(data)) ; else if (utils$7.isArrayBuffer(data)) {
        data = Buffer.from(new Uint8Array(data));
      } else if (utils$7.isString(data)) {
        data = Buffer.from(data, 'utf-8');
      } else {
        return reject(createError(
          'Data after transformation must be a string, an ArrayBuffer, a Buffer, or a Stream',
          config
        ));
      }

      if (config.maxBodyLength > -1 && data.length > config.maxBodyLength) {
        return reject(createError('Request body larger than maxBodyLength limit', config));
      }

      // Add Content-Length header if data exists
      if (!headerNames['content-length']) {
        headers['Content-Length'] = data.length;
      }
    }

    // HTTP basic authentication
    var auth = undefined;
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      auth = username + ':' + password;
    }

    // Parse url
    var fullPath = buildFullPath(config.baseURL, config.url);
    var parsed = url.parse(fullPath);
    var protocol = parsed.protocol || 'http:';

    if (!auth && parsed.auth) {
      var urlAuth = parsed.auth.split(':');
      var urlUsername = urlAuth[0] || '';
      var urlPassword = urlAuth[1] || '';
      auth = urlUsername + ':' + urlPassword;
    }

    if (auth && headerNames.authorization) {
      delete headers[headerNames.authorization];
    }

    var isHttpsRequest = isHttps.test(protocol);
    var agent = isHttpsRequest ? config.httpsAgent : config.httpAgent;

    try {
      buildURL$1(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, '');
    } catch (err) {
      var customErr = new Error(err.message);
      customErr.config = config;
      customErr.url = config.url;
      customErr.exists = true;
      reject(customErr);
    }

    var options = {
      path: buildURL$1(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, ''),
      method: config.method.toUpperCase(),
      headers: headers,
      agent: agent,
      agents: { http: config.httpAgent, https: config.httpsAgent },
      auth: auth
    };

    if (config.socketPath) {
      options.socketPath = config.socketPath;
    } else {
      options.hostname = parsed.hostname;
      options.port = parsed.port;
    }

    var proxy = config.proxy;
    if (!proxy && proxy !== false) {
      var proxyEnv = protocol.slice(0, -1) + '_proxy';
      var proxyUrl = process.env[proxyEnv] || process.env[proxyEnv.toUpperCase()];
      if (proxyUrl) {
        var parsedProxyUrl = url.parse(proxyUrl);
        var noProxyEnv = process.env.no_proxy || process.env.NO_PROXY;
        var shouldProxy = true;

        if (noProxyEnv) {
          var noProxy = noProxyEnv.split(',').map(function trim(s) {
            return s.trim();
          });

          shouldProxy = !noProxy.some(function proxyMatch(proxyElement) {
            if (!proxyElement) {
              return false;
            }
            if (proxyElement === '*') {
              return true;
            }
            if (proxyElement[0] === '.' &&
                parsed.hostname.substr(parsed.hostname.length - proxyElement.length) === proxyElement) {
              return true;
            }

            return parsed.hostname === proxyElement;
          });
        }

        if (shouldProxy) {
          proxy = {
            host: parsedProxyUrl.hostname,
            port: parsedProxyUrl.port,
            protocol: parsedProxyUrl.protocol
          };

          if (parsedProxyUrl.auth) {
            var proxyUrlAuth = parsedProxyUrl.auth.split(':');
            proxy.auth = {
              username: proxyUrlAuth[0],
              password: proxyUrlAuth[1]
            };
          }
        }
      }
    }

    if (proxy) {
      options.headers.host = parsed.hostname + (parsed.port ? ':' + parsed.port : '');
      setProxy(options, proxy, protocol + '//' + parsed.hostname + (parsed.port ? ':' + parsed.port : '') + options.path);
    }

    var transport;
    var isHttpsProxy = isHttpsRequest && (proxy ? isHttps.test(proxy.protocol) : true);
    if (config.transport) {
      transport = config.transport;
    } else if (config.maxRedirects === 0) {
      transport = isHttpsProxy ? https : http;
    } else {
      if (config.maxRedirects) {
        options.maxRedirects = config.maxRedirects;
      }
      transport = isHttpsProxy ? httpsFollow : httpFollow;
    }

    if (config.maxBodyLength > -1) {
      options.maxBodyLength = config.maxBodyLength;
    }

    if (config.insecureHTTPParser) {
      options.insecureHTTPParser = config.insecureHTTPParser;
    }

    // Create the request
    var req = transport.request(options, function handleResponse(res) {
      if (req.aborted) return;

      // uncompress the response body transparently if required
      var stream = res;

      // return the last request in case of redirects
      var lastRequest = res.req || req;


      // if no content, is HEAD request or decompress disabled we should not decompress
      if (res.statusCode !== 204 && lastRequest.method !== 'HEAD' && config.decompress !== false) {
        switch (res.headers['content-encoding']) {
        /*eslint default-case:0*/
        case 'gzip':
        case 'compress':
        case 'deflate':
        // add the unzipper to the body stream processing pipeline
          stream = stream.pipe(zlib.createUnzip());

          // remove the content-encoding in order to not confuse downstream operations
          delete res.headers['content-encoding'];
          break;
        }
      }

      var response = {
        status: res.statusCode,
        statusText: res.statusMessage,
        headers: res.headers,
        config: config,
        request: lastRequest
      };

      if (config.responseType === 'stream') {
        response.data = stream;
        settle(resolve, reject, response);
      } else {
        var responseBuffer = [];
        var totalResponseBytes = 0;
        stream.on('data', function handleStreamData(chunk) {
          responseBuffer.push(chunk);
          totalResponseBytes += chunk.length;

          // make sure the content length is not over the maxContentLength if specified
          if (config.maxContentLength > -1 && totalResponseBytes > config.maxContentLength) {
            // stream.destoy() emit aborted event before calling reject() on Node.js v16
            rejected = true;
            stream.destroy();
            reject(createError('maxContentLength size of ' + config.maxContentLength + ' exceeded',
              config, null, lastRequest));
          }
        });

        stream.on('aborted', function handlerStreamAborted() {
          if (rejected) {
            return;
          }
          stream.destroy();
          reject(createError('error request aborted', config, 'ERR_REQUEST_ABORTED', lastRequest));
        });

        stream.on('error', function handleStreamError(err) {
          if (req.aborted) return;
          reject(enhanceError$1(err, config, null, lastRequest));
        });

        stream.on('end', function handleStreamEnd() {
          try {
            var responseData = responseBuffer.length === 1 ? responseBuffer[0] : Buffer.concat(responseBuffer);
            if (config.responseType !== 'arraybuffer') {
              responseData = responseData.toString(config.responseEncoding);
              if (!config.responseEncoding || config.responseEncoding === 'utf8') {
                responseData = utils$7.stripBOM(responseData);
              }
            }
            response.data = responseData;
          } catch (err) {
            reject(enhanceError$1(err, config, err.code, response.request, response));
          }
          settle(resolve, reject, response);
        });
      }
    });

    // Handle errors
    req.on('error', function handleRequestError(err) {
      if (req.aborted && err.code !== 'ERR_FR_TOO_MANY_REDIRECTS') return;
      reject(enhanceError$1(err, config, null, req));
    });

    // set tcp keep alive to prevent drop connection by peer
    req.on('socket', function handleRequestSocket(socket) {
      // default interval of sending ack packet is 1 minute
      socket.setKeepAlive(true, 1000 * 60);
    });

    // Handle request timeout
    if (config.timeout) {
      // This is forcing a int timeout to avoid problems if the `req` interface doesn't handle other types.
      var timeout = parseInt(config.timeout, 10);

      if (isNaN(timeout)) {
        reject(createError(
          'error trying to parse `config.timeout` to int',
          config,
          'ERR_PARSE_TIMEOUT',
          req
        ));

        return;
      }

      // Sometime, the response will be very slow, and does not respond, the connect event will be block by event loop system.
      // And timer callback will be fired, and abort() will be invoked before connection, then get "socket hang up" and code ECONNRESET.
      // At this time, if we have a large number of request, nodejs will hang up some socket on background. and the number will up and up.
      // And then these socket which be hang up will devoring CPU little by little.
      // ClientRequest.setTimeout will be fired on the specify milliseconds, and can make sure that abort() will be fired after connect.
      req.setTimeout(timeout, function handleRequestTimeout() {
        req.abort();
        var timeoutErrorMessage = '';
        if (config.timeoutErrorMessage) {
          timeoutErrorMessage = config.timeoutErrorMessage;
        } else {
          timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
        }
        var transitional = config.transitional || transitionalDefaults$1;
        reject(createError(
          timeoutErrorMessage,
          config,
          transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
          req
        ));
      });
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (req.aborted) return;

        req.abort();
        reject(!cancel || (cancel && cancel.type) ? new Cancel$2('canceled') : cancel);
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }


    // Send the request
    if (utils$7.isStream(data)) {
      data.on('error', function handleStreamError(err) {
        reject(enhanceError$1(err, config, null, req));
      }).pipe(req);
    } else {
      req.end(data);
    }
  });
};

var utils$6 = utils$f;
var normalizeHeaderName = normalizeHeaderName$1;
var enhanceError = enhanceError$3;
var transitionalDefaults = transitional;

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = http_1;
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$6.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$6.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$3 = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$6.isFormData(data) ||
      utils$6.isArrayBuffer(data) ||
      utils$6.isBuffer(data) ||
      utils$6.isStream(data) ||
      utils$6.isFile(data) ||
      utils$6.isBlob(data)
    ) {
      return data;
    }
    if (utils$6.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$6.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$6.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils$6.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils$6.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});

utils$6.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$3;

var utils$5 = utils$f;
var defaults$2 = defaults_1;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$2;
  /*eslint no-param-reassign:0*/
  utils$5.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var utils$4 = utils$f;
var transformData = transformData$1;
var isCancel = isCancel$1;
var defaults$1 = defaults_1;
var Cancel$1 = Cancel_1;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel$1('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$4.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$4.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

var utils$3 = utils$f;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source)) {
      return utils$3.merge(target, source);
    } else if (utils$3.isPlainObject(source)) {
      return utils$3.merge({}, source);
    } else if (utils$3.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils$3.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};

var VERSION = data$1.version;

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator$1 = {
  assertOptions: assertOptions,
  validators: validators$1
};

var utils$2 = utils$f;
var buildURL = buildURL$3;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$2.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$2.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios$1;

var Cancel = Cancel_1;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

var utils$1 = utils$f;

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return utils$1.isObject(payload) && (payload.isAxiosError === true);
};

var utils = utils$f;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios;

// Expose Cancel & CancelToken
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data$1.version;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;

// Expose isAxiosError
axios$1.isAxiosError = isAxiosError;

axios$2.exports = axios$1;

// Allow use of default import syntax in TypeScript
axios$2.exports.default = axios$1;

var axios = axios$2.exports;

// Get News in Pangolin Strapi api
function useGetNews() {
    const query = lib$3.stringify({
        sort: ['-date_created'],
        limit: 10,
    }, {
        encodeValuesOnly: true,
    });
    return useQuery('getNews', () => __awaiter$a(this, void 0, void 0, function* () {
        var _a;
        const response = yield axios.get(`${DIRECTUS_URL_NEWS}${query}`, {
            timeout: 1000,
        });
        const data = response.data;
        const news = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.map((element) => {
            return {
                id: element === null || element === void 0 ? void 0 : element.id,
                title: element === null || element === void 0 ? void 0 : element.title,
                content: element === null || element === void 0 ? void 0 : element.content,
                createdAt: new Date(element === null || element === void 0 ? void 0 : element.date_created),
                updatedAt: !(element === null || element === void 0 ? void 0 : element.date_updated) ? null : new Date(element === null || element === void 0 ? void 0 : element.date_updated),
            };
        });
        return news;
    }));
}

// news section
const NewsSection = styled(Box) `
  background-color: ${({ theme }) => theme.bg2};
  background-image: url(${(props) => props.img});
  background-repeat: no-repeat;
  background-position: bottom right;
  height: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  & .slick-slider {
    height: 100%;
    padding: 0px;

    .slick-dots {
      bottom: 0px;
      li button:before {
        color: ${({ theme }) => theme.text1};
      }
      li.slick-active button:before {
        color: ${({ theme }) => theme.text1};
      }
    }
  }

  & .slick-slide {
    height: auto;

    & div {
      height: 100%;
    }
  }

  & .slick-list {
    height: 100%;
    overflow: hidden;
  }

  & .slick-track {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    height: 100%;
  }

  ${({ theme }) => theme.mediaWidth.upToSmall `
    height: 600px;
  `};
`;
const NewsTitle = styled(Box) `
  align-self: start;
  font-weight: bold;
  font-size: 32px;
  line-height: 48px;
  padding: 20px;
  background: linear-gradient(0deg, #ffc800, #ffc800);
  border-radius: 5px 0px 5px 0px;
`;
const NewsContent = styled(Box) `
  color: ${({ theme }) => theme.text7};
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  height: 90% !important;
  padding: 0px 20px;
  & a {
    color: ${({ theme }) => theme.text7};
  }
`;
const NewsDate = styled(Box) `
  font-size: 10px;
  line-height: 15px;
  display: flex;
  align-items: center;
  color: #929292;
  margin-bottom: 15px;
  height: 10% !important;
  padding: 0px 10px;
`;
const SlickNext = styled(Box) `
  background: ${({ theme }) => theme.primary};
  width: 32px;
  height: 32px;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
  z-index: 9999;
`;
const TitleWrapper = styled(Box) `
  display: flex;
  justify-content: space-between;
`;
const ArrowWrapper = styled(Box) `
  display: flex;
  gap: 10px;
  padding: 20px;
`;

const NewsFeedSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 10000,
};
const NewsWidget = ({ boxHeight = '400px' }) => {
    const theme = useContext(Me);
    const sliderRef = useRef(null);
    const handleNewsNext = () => {
        var _a;
        (_a = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickNext();
    };
    const handleNewsBack = () => {
        var _a;
        (_a = sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickPrev();
    };
    const { data: news, isLoading } = useGetNews();
    return (jsxs(NewsSection, Object.assign({ img: Earth }, { children: [jsxs(TitleWrapper, { children: [jsx(NewsTitle, { children: "News" }, void 0), jsxs(ArrowWrapper, { children: [jsx(SlickNext, Object.assign({ onClick: handleNewsBack, style: { right: 60 } }, { children: jsx(ArrowLeft$1, { size: 20, style: { minWidth: 24 } }, void 0) }), void 0), jsx(SlickNext, Object.assign({ onClick: handleNewsNext }, { children: jsx(ArrowRight$1, { size: 20, style: { minWidth: 24 } }, void 0) }), void 0)] }, void 0)] }, void 0), jsx("div", Object.assign({ style: { height: '100%' } }, { children: !isLoading ? (jsx(Slider, Object.assign({ ref: sliderRef }, NewsFeedSettings, { children: news &&
                        news.map((element) => {
                            var _a, _b;
                            return (jsxs("div", { children: [jsx(NewsContent, { children: jsx(Scrollbars, Object.assign({ style: { minHeight: boxHeight, padding: '0px 10px' }, 
                                            // eslint-disable-next-line react/prop-types
                                            renderView: (props) => jsx("div", Object.assign({}, props, { style: Object.assign(Object.assign({}, props.style), { overflowX: 'hidden' }) }), void 0), renderThumbVertical: (props) => (jsx("div", Object.assign({}, props, { style: Object.assign(Object.assign({}, props.style), { backgroundColor: theme.text1, opacity: 0.2, cursor: 'pointer', borderRadius: '3px' }) }), void 0)) }, { children: jsx(ReactMarkdown, Object.assign({ remarkPlugins: [remarkGfm], linkTarget: '_blank', components: {
                                                    /* eslint-disable react/prop-types */
                                                    a: (_a) => {
                                                        var { children } = _a, props = __rest$1(_a, ["children"]);
                                                        const linkProps = props;
                                                        if (props.target === '_blank') {
                                                            linkProps['rel'] = 'noopener noreferrer';
                                                        }
                                                        return jsx("a", Object.assign({}, linkProps, { children: children }), void 0);
                                                    },
                                                } }, { children: element.content }), void 0) }), void 0) }, void 0), jsxs(NewsDate, { children: [(element === null || element === void 0 ? void 0 : element.updatedAt)
                                                ? (_a = element === null || element === void 0 ? void 0 : element.updatedAt) === null || _a === void 0 ? void 0 : _a.toLocaleTimeString()
                                                : element === null || element === void 0 ? void 0 : element.createdAt.toLocaleTimeString(), ", ", element.updatedAt ? (_b = element === null || element === void 0 ? void 0 : element.updatedAt) === null || _b === void 0 ? void 0 : _b.toDateString() : element === null || element === void 0 ? void 0 : element.createdAt.toDateString()] }, void 0)] }, element.id));
                        }) }), void 0)) : (jsx(Box, Object.assign({ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }, { children: jsx(Loader, { size: 100 }, void 0) }), void 0)) }), void 0)] }), void 0));
};

const Frame$1 = styled(Box) `
  width: 40vw;
  background-color: ${({ theme }) => theme.bg2};
  padding: 30px;
  display: grid;
  position: relative;
  grid-template-areas:"text buttons"
                      "chains chains";
  grid-template-columns: grid-template-columns: repeat(2, 50%);

  ${({ theme }) => theme.mediaWidth.upToMedium `
    width: 60vw;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall `
    width: 100vw;
  `};

`;
const ButtonFrame = styled(Box) `
  grid-area: buttons;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
`;
const CloseButton$1 = styled(CloseIcon$1) `
  color: ${({ theme }) => theme.text1};
  position: absolute;
  right: 3px;
  top: 3px;
`;
const ChainsList = styled(Box) `
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 20px;
`;
const ChainButton = styled.button `
  background-color: ${({ theme }) => theme.bg8};
  display: flex;
  align-items: center;
  border: 0px;
  border-radius: 5px;
  cursor: pointer;
  padding: 10px;
  height: 48px;
  font-weight: 500;

  :hover {
    opacity: 0.5;
  }
`;
const Logo = styled.img `
  border-radius: 20px;
  height: 28px;
  width: 28px;
  margin-right: 10px;
`;

var NETWORK_TYPE;
(function (NETWORK_TYPE) {
    NETWORK_TYPE["MAINNET"] = "Mainnet";
    NETWORK_TYPE["TESTNET"] = "Testnet";
})(NETWORK_TYPE || (NETWORK_TYPE = {}));
const NetworkSelection = (props) => {
    const { open, closeModal } = props;
    const [mainnet, setMainnet] = useState(true);
    const [chainListHeight, setChainListHeight] = useState(48);
    const { ethereum } = window;
    const isMetaMask = ethereum && ethereum.isMetaMask;
    const chains = ALL_CHAINS.filter((chain) => chain.pangolin_is_live && chain.mainnet === mainnet);
    useEffect(() => {
        if (chains.length / 2 <= 1)
            setChainListHeight(48);
        else if (chains.length / 2 <= 2)
            setChainListHeight(116);
        else
            setChainListHeight(184);
    }, [mainnet]);
    const changeChain = (chain) => __awaiter$a(void 0, void 0, void 0, function* () {
        if (isMetaMask && ethereum) {
            try {
                yield ethereum.request({
                    method: 'wallet_switchEthereumChain',
                    params: [{ chainId: `0x${chain.chain_id.toString(16)}` }],
                });
                window.location.reload();
            }
            catch (error) {
                // This error code indicates that the chain has not been added to MetaMask.
                const metamask = error;
                if (metamask.code === 4902) {
                    yield ethereum.request({
                        method: 'wallet_addEthereumChain',
                        params: [
                            {
                                chainName: chain.name,
                                chainId: `0x${chain.chain_id.toString(16)}`,
                                //nativeCurrency: chain.nativeCurrency,
                                rpcUrls: [chain.rpc_uri],
                                blockExplorerUrls: chain.blockExplorerUrls,
                                iconUrls: chain.logo,
                                nativeCurrency: chain.nativeCurrency,
                            },
                        ],
                    });
                }
            }
        }
    });
    return (jsx(Modal, Object.assign({ isOpen: open, onDismiss: closeModal }, { children: jsxs(Frame$1, { children: [jsx(CloseButton$1, { onClick: closeModal }, void 0), jsx(Text$1, Object.assign({ color: "text1", fontSize: "24px", marginBottom: 20, style: { gridArea: 'text' } }, { children: "Select Chain" }), void 0), jsx(ButtonFrame, { children: jsx(ToggleButtons, { options: [NETWORK_TYPE.MAINNET, NETWORK_TYPE.TESTNET], value: mainnet === true ? NETWORK_TYPE.MAINNET : NETWORK_TYPE.TESTNET, onChange: (value) => {
                            setMainnet(value === NETWORK_TYPE.MAINNET);
                        } }, void 0) }, void 0), jsx(Box, Object.assign({ height: chainListHeight, style: { gridArea: 'chains' } }, { children: jsx(lib$2.Scrollbars, { children: jsx(ChainsList, { children: chains.map((chain, index) => (jsxs(ChainButton, Object.assign({ onClick: () => changeChain(chain) }, { children: [jsx(Logo, { src: chain.logo }, void 0), jsx(Text$1, Object.assign({ color: "text1" }, { children: chain.name }), void 0)] }), index))) }, void 0) }, void 0) }), void 0)] }, void 0) }), void 0));
};

var main = {};

var uaParser_min = {exports: {}};

/* UAParser.js v0.7.31
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */

(function (module, exports) {
(function(window,undefined$1){var LIBVERSION="0.7.31",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=255;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i]);}else {mergedRegexes[i]=regexes[i];}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i];}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined$1},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY).replace(/\s\s*$/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match);}else {this[q[0]]=q[1];}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined$1;}else {this[q[0]]=match?match.replace(q[1],q[2]):undefined$1;}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined$1;}}else {this[q]=match?match:undefined$1;}}}}i+=2;}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined$1:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined$1:i}}return str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,/(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,/(ba?idubrowser)[\/ ]?([\w\.]+)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/\bqbcore\/([\w\.]+)/i],[VERSION,[NAME,"WeChat(Win) Desktop"]],[/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/yabrowser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI "+BROWSER]],[/fxios\/([-\w\.]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihu|(qi?ho?o?|360)browser/i],[[NAME,"360 "+BROWSER]],[/(oculus|samsung|sailfish)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 "+BROWSER],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i],[NAME,VERSION],[/(metasr)[\/ ]?([\w\.]+)/i,/(lbbrowser)/i],[NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(chromium|instagram)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/\((ip(?:hone|od)[\w ]*);/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+)(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[12]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/(quest( 2)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows) nt 6\.2; (arm)/i,/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,/(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,strMapper,windowsVersionMap]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+ ([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined$1;}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _ua=ua||(typeof window!==UNDEF_TYPE&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var _rgxmap=extensions?extend(regexes,extensions):regexes;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined$1;_browser[VERSION]=undefined$1;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser.major=majorize(_browser.version);return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined$1;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined$1;_device[MODEL]=undefined$1;_device[TYPE]=undefined$1;rgxMapper.call(_device,_ua,_rgxmap.device);return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined$1;_engine[VERSION]=undefined$1;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined$1;_os[VERSION]=undefined$1;rgxMapper.call(_os,_ua,_rgxmap.os);return _os};this.getResult=function(){return {ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);{if(module.exports){exports=module.exports=UAParser;}exports.UAParser=UAParser;}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop];}};}})(typeof window==="object"?window:commonjsGlobal);
}(uaParser_min, uaParser_min.exports));

Object.defineProperty(main, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = React$2;
var React__default = _interopDefault(React);

var UAParser = uaParser_min.exports;

var UA = new UAParser();
var browser = UA.getBrowser();
UA.getCPU();
var device = UA.getDevice();
var engine = UA.getEngine();
var os = UA.getOS();
var ua = UA.getUA();

var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: 'IE',
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};
var checkType = function checkType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    default:
      return initialData;
  }
};
var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

var type$3 = checkType(device.type);

function deviceDetect() {
  var isBrowser = type$3.isBrowser,
      isMobile = type$3.isMobile,
      isTablet = type$3.isTablet,
      isSmartTV = type$3.isSmartTV,
      isConsole = type$3.isConsole,
      isWearable = type$3.isWearable;

  if (isBrowser) {
    return broPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return stvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type$3, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type$3, device, os, ua);
  }

  if (isWearable) {
    return wearPayload(isWearable, engine, os, ua);
  }
}

var isMobileType = function isMobileType() {
  return device.type === DeviceTypes.Mobile;
};

var isTabletType = function isTabletType() {
  return device.type === DeviceTypes.Tablet;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (device.type) {
    case DeviceTypes.Mobile:
    case DeviceTypes.Tablet:
      return true;

    default:
      return false;
  }
};

var isEdgeChromiumType = function isEdgeChromiumType() {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};

var isSmartTVType = function isSmartTVType() {
  return device.type === DeviceTypes.SmartTv;
};

var isBrowserType = function isBrowserType() {
  return device.type === DeviceTypes.Browser;
};

var isWearableType = function isWearableType() {
  return device.type === DeviceTypes.Wearable;
};

var isConsoleType = function isConsoleType() {
  return device.type === DeviceTypes.Console;
};

var isAndroidType = function isAndroidType() {
  return os.name === OsTypes.Android;
};

var isWindowsType = function isWindowsType() {
  return os.name === OsTypes.Windows;
};

var isMacOsType = function isMacOsType() {
  return os.name === OsTypes.MAC_OS;
};

var isWinPhoneType = function isWinPhoneType() {
  return os.name === OsTypes.WindowsPhone;
};

var isIOSType = function isIOSType() {
  return os.name === OsTypes.IOS;
};

var isChromeType = function isChromeType() {
  return browser.name === BrowserTypes.Chrome;
};

var isFirefoxType = function isFirefoxType() {
  return browser.name === BrowserTypes.Firefox;
};

var isChromiumType = function isChromiumType() {
  return browser.name === BrowserTypes.Chromium;
};

var isEdgeType = function isEdgeType() {
  return browser.name === BrowserTypes.Edge;
};

var isYandexType = function isYandexType() {
  return browser.name === BrowserTypes.Yandex;
};

var isSafariType = function isSafariType() {
  return browser.name === BrowserTypes.Safari || browser.name === BrowserTypes.MobileSafari;
};

var isMobileSafariType = function isMobileSafariType() {
  return browser.name === BrowserTypes.MobileSafari;
};

var isOperaType = function isOperaType() {
  return browser.name === BrowserTypes.Opera;
};

var isIEType = function isIEType() {
  return browser.name === BrowserTypes.InternetExplorer || browser.name === BrowserTypes.Ie;
};

var isMIUIType = function isMIUIType() {
  return browser.name === BrowserTypes.MIUI;
};

var isSamsungBrowserType = function isSamsungBrowserType() {
  return browser.name === BrowserTypes.SamsungBrowser;
};

var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};

var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};

var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};

var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};

var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return setDefaults(browser.version);
};

var getBrowserVersion = function getBrowserVersion() {
  return setDefaults(browser.major);
};

var getOsVersion = function getOsVersion() {
  return setDefaults(os.version);
};

var getOsName = function getOsName() {
  return setDefaults(os.name);
};

var getBrowserName = function getBrowserName() {
  return setDefaults(browser.name);
};

var getMobileVendor = function getMobileVendor() {
  return setDefaults(device.vendor);
};

var getMobileModel = function getMobileModel() {
  return setDefaults(device.model);
};

var getEngineName = function getEngineName() {
  return setDefaults(engine.name);
};

var getEngineVersion = function getEngineVersion() {
  return setDefaults(engine.version);
};

var getUseragent = function getUseragent() {
  return setDefaults(ua);
};

var getDeviceType = function getDeviceType() {
  return setDefaults(device.type, 'browser');
};

var isSmartTV = isSmartTVType();
var isConsole = isConsoleType();
var isWearable = isWearableType();
var isMobileSafari = isMobileSafariType() || getIPad13();
var isChromium = isChromiumType();
var isMobile = isMobileAndTabletType() || getIPad13();
var isMobileOnly = isMobileType();
var isTablet = isTabletType() || getIPad13();
var isBrowser = isBrowserType();
var isDesktop = isBrowserType();
var isAndroid = isAndroidType();
var isWinPhone = isWinPhoneType();
var isIOS = isIOSType() || getIPad13();
var isChrome = isChromeType();
var isFirefox = isFirefoxType();
var isSafari = isSafariType();
var isOpera = isOperaType();
var isIE = isIEType();
var osVersion = getOsVersion();
var osName = getOsName();
var fullBrowserVersion = getBrowserFullVersion();
var browserVersion = getBrowserVersion();
var browserName = getBrowserName();
var mobileVendor = getMobileVendor();
var mobileModel = getMobileModel();
var engineName = getEngineName();
var engineVersion = getEngineVersion();
var getUA = getUseragent();
var isEdge = isEdgeType() || isEdgeChromiumType();
var isYandex = isYandexType();
var deviceType = getDeviceType();
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType();
var isLegacyEdge = isEdgeType() && !isEdgeChromiumType();
var isWindows = isWindowsType();
var isMacOs = isMacOsType();
var isMIUI = isMIUIType();
var isSamsungBrowser = isSamsungBrowserType();

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", _extends({
    className: viewClassName,
    style: style
  }, props), children) : null;
};

function withOrientationChange(WrappedComponent) {
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this.isEventListenerAdded = false;
        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
        _this.state = {
          isLandscape: false,
          isPortrait: false
        };
        return _this;
      }

      _createClass(_class, [{
        key: "handleOrientationChange",
        value: function handleOrientationChange() {
          if (!this.isEventListenerAdded) {
            this.isEventListenerAdded = true;
          }

          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: orientation === 0,
            isLandscape: orientation === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function onOrientationChange() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function onPageLoad() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
            if (!this.isEventListenerAdded) {
              this.handleOrientationChange();
              window.addEventListener("load", this.onPageLoad, false);
            } else {
              window.removeEventListener("load", this.onPageLoad, false);
            }

            window.addEventListener("resize", this.onOrientationChange, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onOrientationChange, false);
        }
      }, {
        key: "render",
        value: function render() {
          return React__default.createElement(WrappedComponent, _extends({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]);

      return _class;
    }(React__default.Component)
  );
}

main.AndroidView = AndroidView;
main.BrowserTypes = BrowserTypes;
main.BrowserView = BrowserView;
main.ConsoleView = ConsoleView;
main.CustomView = CustomView;
main.IEView = IEView;
main.IOSView = IOSView;
main.MobileOnlyView = MobileOnlyView;
main.MobileView = MobileView;
main.OsTypes = OsTypes;
main.SmartTVView = SmartTVView;
main.TabletView = TabletView;
main.WearableView = WearableView;
main.WinPhoneView = WinPhoneView;
main.browserName = browserName;
main.browserVersion = browserVersion;
main.deviceDetect = deviceDetect;
main.deviceType = deviceType;
main.engineName = engineName;
main.engineVersion = engineVersion;
main.fullBrowserVersion = fullBrowserVersion;
main.getUA = getUA;
main.isAndroid = isAndroid;
main.isBrowser = isBrowser;
main.isChrome = isChrome;
main.isChromium = isChromium;
main.isConsole = isConsole;
main.isDesktop = isDesktop;
main.isEdge = isEdge;
main.isEdgeChromium = isEdgeChromium;
main.isElectron = isElectron;
main.isFirefox = isFirefox;
main.isIE = isIE;
main.isIOS = isIOS;
main.isIOS13 = isIOS13;
main.isIPad13 = isIPad13;
main.isIPhone13 = isIPhone13;
main.isIPod13 = isIPod13;
main.isLegacyEdge = isLegacyEdge;
main.isMIUI = isMIUI;
main.isMacOs = isMacOs;
var isMobile_1 = main.isMobile = isMobile;
main.isMobileOnly = isMobileOnly;
main.isMobileSafari = isMobileSafari;
main.isOpera = isOpera;
main.isSafari = isSafari;
main.isSamsungBrowser = isSamsungBrowser;
main.isSmartTV = isSmartTV;
main.isTablet = isTablet;
main.isWearable = isWearable;
main.isWinPhone = isWinPhone;
main.isWindows = isWindows;
main.isYandex = isYandex;
main.mobileModel = mobileModel;
main.mobileVendor = mobileVendor;
main.osName = osName;
main.osVersion = osVersion;
main.withOrientationChange = withOrientationChange;

var MetamaskIcon = "data:image/png;base64,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";

var RabbyIcon = "data:image/svg+xml,%3Csvg%20width%3D%22320%22%20height%3D%22320%22%20viewBox%3D%220%200%20320%20320%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M310.142%20178.941C322.057%20152.322%20263.149%2077.9513%20206.872%2046.9671C171.399%2022.9641%20134.435%2026.2617%20126.949%2036.8008C110.52%2059.93%20181.351%2079.5284%20228.721%20102.398C218.538%20106.821%20208.943%20114.758%20203.3%20124.908C185.64%20105.627%20146.878%2089.0245%20101.396%20102.398C70.7464%20111.411%2045.2741%20132.658%2035.4293%20164.749C33.0371%20163.686%2030.3886%20163.095%2027.6021%20163.095C16.9467%20163.095%208.3087%20171.733%208.3087%20182.389C8.3087%20193.044%2016.9467%20201.682%2027.6021%20201.682C29.5772%20201.682%2035.7526%20200.357%2035.7526%20200.357L134.435%20201.073C94.97%20263.68%2063.7812%20272.832%2063.7812%20283.679C63.7812%20294.525%2093.6234%20291.586%20104.828%20287.543C158.468%20268.189%20216.08%20207.869%20225.966%20190.505C267.482%20195.685%20302.372%20196.298%20310.142%20178.941Z%22%20fill%3D%22url%28%23paint0_linear%29%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M228.717%20102.401C228.72%20102.403%20228.722%20102.404%20228.725%20102.405C230.92%20101.54%20230.565%2098.297%20229.962%2095.7505C228.577%2089.8972%20204.667%2066.2872%20182.215%2055.7122C151.62%2041.3023%20129.091%2042.0452%20125.763%2048.6868C131.995%2061.4595%20160.886%2073.4515%20191.061%2085.9761C203.934%2091.3196%20217.041%2096.7599%20228.722%20102.399C228.72%20102.4%20228.719%20102.401%20228.717%20102.401Z%22%20fill%3D%22url%28%23paint1_linear%29%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M189.892%20230.954C183.705%20228.59%20176.716%20226.42%20168.77%20224.452C177.242%20209.292%20179.02%20186.849%20171.019%20172.659C159.789%20152.745%20145.693%20142.146%20112.937%20142.146C94.9207%20142.146%2046.4136%20148.214%2045.5525%20188.707C45.4621%20192.956%2045.5502%20196.849%2045.8578%20200.43L134.435%20201.072C122.494%20220.016%20111.31%20234.066%20101.519%20244.75C113.275%20247.762%20122.976%20250.291%20131.883%20252.613C140.334%20254.816%20148.069%20256.832%20156.165%20258.898C168.378%20250%20179.86%20240.298%20189.892%20230.954Z%22%20fill%3D%22url%28%23paint2_linear%29%22%2F%3E%3Cpath%20d%3D%22M34.2473%20196.269C37.8658%20227.03%2055.3476%20239.085%2091.0698%20242.652C126.792%20246.22%20147.283%20243.826%20174.563%20246.308C197.347%20248.381%20217.691%20259.992%20225.238%20255.98C232.03%20252.369%20228.23%20239.323%20219.142%20230.953C207.361%20220.103%20191.056%20212.56%20162.366%20209.883C168.084%20194.228%20166.482%20172.279%20157.602%20160.337C144.763%20143.07%20121.064%20135.263%2091.0699%20138.674C59.733%20142.238%2029.7062%20157.666%2034.2473%20196.269Z%22%20fill%3D%22url%28%23paint3_linear%29%22%2F%3E%3Cdefs%3E%3ClinearGradient%20id%3D%22paint0_linear%22%20x1%3D%2297.8271%22%20y1%3D%22155.368%22%20x2%3D%22307.576%22%20y2%3D%22214.849%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20stop-color%3D%22%238797FF%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23AAA8FF%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22paint1_linear%22%20x1%3D%22272.257%22%20y1%3D%22151.38%22%20x2%3D%22120.914%22%20y2%3D%22-0.332927%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20stop-color%3D%22%233B22A0%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%235156D8%22%20stop-opacity%3D%220%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22paint2_linear%22%20x1%3D%22194.103%22%20y1%3D%22236.239%22%20x2%3D%2248.7216%22%20y2%3D%22152.655%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20stop-color%3D%22%233B1E8F%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%236A6FFB%22%20stop-opacity%3D%220%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22paint3_linear%22%20x1%3D%22110.349%22%20y1%3D%22153.803%22%20x2%3D%22208.616%22%20y2%3D%22278.661%22%20gradientUnits%3D%22userSpaceOnUse%22%3E%3Cstop%20stop-color%3D%22%238898FF%22%2F%3E%3Cstop%20offset%3D%220.983895%22%20stop-color%3D%22%235F47F1%22%2F%3E%3C%2FlinearGradient%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";

var XDefiIcon = "data:image/png;base64,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";

const InfoCard = styled.button `
  background-color: ${({ theme, active }) => (active ? theme.bg3 : theme.bg2)};
  padding: 1rem;
  outline: none;
  border: 1px solid;
  border-radius: 12px;
  width: 100% !important;
  &:focus {
    box-shadow: 0 0 0 1px ${({ theme }) => theme.primary1};
  }
  border-color: ${({ theme, active }) => (active ? 'transparent' : theme.bg3)};
`;
const OptionCard = styled(InfoCard) `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 2rem;
  padding: 1rem;
`;
const OptionCardLeft = styled.div `
  ${({ theme }) => theme.flexColumnNoWrap};
  justify-content: center;
  height: 100%;
`;
const OptionCardClickable = styled(OptionCard) `
  margin-top: 0;
  &:hover {
    cursor: ${({ clickable }) => (clickable ? 'pointer' : '')};
    border: ${({ clickable, theme }) => (clickable ? `1px solid ${theme.primary}` : ``)};
  }
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
`;
const GreenCircle = styled.div `
  ${({ theme }) => theme.flexRowNoWrap}
  justify-content: center;
  align-items: center;

  &:first-child {
    height: 8px;
    width: 8px;
    margin-right: 8px;
    background-color: ${({ theme }) => theme.green1};
    border-radius: 50%;
  }
`;
const CircleWrapper = styled.div `
  color: ${({ theme }) => theme.green1};
  display: flex;
  justify-content: center;
  align-items: center;
`;
const HeaderText = styled.div `
  ${({ theme }) => theme.flexRowNoWrap};
  color: ${(props) => (props.color === 'blue' ? ({ theme }) => theme.primary1 : ({ theme }) => theme.text1)};
  font-size: 1rem;
  font-weight: 500;
`;
const SubHeader = styled.div `
  color: ${({ theme }) => theme.text1};
  margin-top: 10px;
  font-size: 12px;
`;
const IconWrapper = styled.div `
  ${({ theme }) => theme.flexColumnNoWrap};
  align-items: center;
  justify-content: center;
  & > img,
  span {
    height: ${({ size }) => (size ? size + 'px' : '24px')};
    width: ${({ size }) => (size ? size + 'px' : '24px')};
  }
  ${({ theme }) => theme.mediaWidth.upToMedium `
    align-items: flex-end;
  `};
`;

function Option({ link = null, clickable = true, size, onClick = null, color, header, subheader = null, icon, active = false, id, }) {
    const content = (jsxs(OptionCardClickable, Object.assign({ id: id, onClick: onClick, clickable: clickable && !active, active: active }, { children: [jsxs(OptionCardLeft, { children: [jsxs(HeaderText, Object.assign({ color: color }, { children: [active ? (jsx(CircleWrapper, { children: jsx(GreenCircle, { children: jsx("div", {}, void 0) }, void 0) }, void 0)) : (''), header] }), void 0), subheader && jsx(SubHeader, { children: subheader }, void 0)] }, void 0), jsx(IconWrapper, Object.assign({ size: size }, { children: jsx("img", { src: icon, alt: 'Icon' }, void 0) }), void 0)] }), void 0));
    if (link) {
        return jsx(ExternalLink, Object.assign({ href: link }, { children: content }), void 0);
    }
    return content;
}

const rotate = We `
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const StyledSVG = styled.svg `
  animation: 2s ${rotate} linear infinite;
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  path {
    stroke: ${({ stroke, theme }) => stroke !== null && stroke !== void 0 ? stroke : theme.primary1};
  }
`;

/**
 * Takes in custom size and stroke for circle color, default to primary color as fill,
 * need ...rest for layered styles on top
 */
function CircleLoader(_a) {
    var { size = '16px', stroke } = _a, rest = __rest$1(_a, ["size", "stroke"]);
    return (jsx(StyledSVG, Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", size: size, stroke: stroke }, rest, { children: jsx("path", { d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.27455 20.9097 6.80375 19.1414 5", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, void 0) }), void 0));
}

const PendingSection = styled.div `
  ${({ theme }) => theme.flexColumnNoWrap};
  align-items: center;
  justify-content: center;
  width: 100%;
  & > * {
    width: 100%;
  }
`;
const StyledLoader = styled(CircleLoader) `
  margin-right: 1rem;
`;
const LoadingMessage = styled.div `
  ${({ theme }) => theme.flexRowNoWrap};
  align-items: center;
  justify-content: flex-start;
  border-radius: 12px;
  margin-bottom: 20px;
  color: ${({ theme, error }) => (error ? theme.red1 : 'inherit')};
  border: 1px solid ${({ theme, error }) => (error ? theme.red1 : theme.text4)};

  & > * {
    padding: 1rem;
  }
`;
const ErrorGroup = styled.div `
  ${({ theme }) => theme.flexRowNoWrap};
  align-items: center;
  justify-content: flex-start;
`;
const ErrorButton = styled.div `
  border-radius: 8px;
  font-size: 12px;
  color: ${({ theme }) => theme.text1};
  background-color: ${({ theme }) => theme.bg4};
  margin-left: 1rem;
  padding: 0.5rem;
  font-weight: 600;
  user-select: none;

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => curriedDarken(0.1, theme.text4)};
  }
`;
const LoadingWrapper = styled.div `
  ${({ theme }) => theme.flexRowNoWrap};
  align-items: center;
  justify-content: center;
`;

function PendingView({ option, connector, error = false, setPendingError, tryActivation, }) {
    return (jsxs(PendingSection, { children: [jsx(LoadingMessage, Object.assign({ error: error }, { children: jsx(LoadingWrapper, { children: error ? (jsxs(ErrorGroup, { children: [jsx("div", { children: "Error connecting." }, void 0), jsx(ErrorButton, Object.assign({ onClick: () => {
                                    setPendingError(false);
                                    connector && option && tryActivation(connector, option);
                                } }, { children: "Try Again" }), void 0)] }, void 0)) : (jsxs(Fragment$1, { children: [jsx(StyledLoader, {}, void 0), "Initializing..."] }, void 0)) }, void 0) }), void 0), option && (jsx(Option, { id: `connect-${option.name}`, clickable: false, color: option.color, header: option.name, subheader: option.description, icon: require('src/assets/images/' + option.iconName) }, option.name))] }, void 0));
}

const CloseButton = styled(CloseIcon$1) `
  color: ${({ theme }) => theme.text1};
  position: relative;
  right: -3px;
  top: 3px;
`;
const Wrapper = styled.div `
  ${({ theme }) => theme.flexColumnNoWrap}
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 422px;
  border-radius: 10px;
  background-color: ${({ theme, background }) => (background ? background : theme.bg2)};
  ${({ theme }) => theme.mediaWidth.upToMedium `max-width: 100%`};
`;
const ModalWrapper = styled(Box) `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0rem 2rem;
  ${({ theme }) => theme.mediaWidth.upToMedium `padding: 0rem 1rem`};
`;
const HeaderRow = styled.div `
  ${({ theme }) => theme.flexRowNoWrap};
  padding: 1rem 0rem;
  font-weight: 500;
  color: ${({ theme }) => theme.color4};
`;
const ContentWrapper = styled.div `
  padding: 0 2rem 2rem 2rem;
  ${({ theme }) => theme.mediaWidth.upToMedium `padding: 0 1rem 1rem 1rem`};
`;
const UpperSection = styled.div `
  position: relative;

  h5 {
    margin: 0;
    margin-bottom: 0.5rem;
    font-size: 1rem;
    font-weight: 400;
  }

  h5:last-child {
    margin-bottom: 0px;
  }

  h4 {
    margin-top: 0;
    font-weight: 500;
  }
`;
const Blurb = styled.div `
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
  ${({ theme }) => theme.mediaWidth.upToMedium `
    margin: 1rem;
    font-size: 12px;
  `};
`;
const OptionGrid = styled.div `
  display: grid;
  grid-gap: 10px;
  ${({ theme }) => theme.mediaWidth.upToMedium `
    grid-template-columns: 1fr;
    grid-gap: 10px;
  `};
`;
const HoverText = styled.div `
  :hover {
    cursor: pointer;
  }
`;

const WALLET_TUTORIAL = `${LANDING_PAGE}/tutorials/getting-started/#set-up-metamask`;
var CHAIN_TYPE;
(function (CHAIN_TYPE) {
    CHAIN_TYPE["EVM_CHAINS"] = "EVM CHAINS";
    CHAIN_TYPE["NON_EVM_CHAINS"] = "NON-EVM CHAINS";
})(CHAIN_TYPE || (CHAIN_TYPE = {}));
const WALLET_VIEWS = {
    OPTIONS: 'options',
    OPTIONS_SECONDARY: 'options_secondary',
    ACCOUNT: 'account',
    PENDING: 'pending',
};
const WalletModal = ({ open, closeModal, background, shouldShowBackButton, onWalletConnect, onClickBack, }) => {
    var _a;
    // important that these are destructed from the account-specific web3-react context
    const { connector, activate, error: web3Error } = useWeb3React();
    const [walletType, setWalletType] = useState(CHAIN_TYPE.EVM_CHAINS);
    const [walletView, setWalletView] = useState('');
    const [pendingWallet, setPendingWallet] = useState();
    const [selectedOption, setSelectedOption] = useState();
    const [pendingError, setPendingError] = useState();
    const [triedSafe, setTriedSafe] = useState(!IS_IN_IFRAME);
    const walletModalOpen = open;
    const walletOptions = walletType === CHAIN_TYPE.EVM_CHAINS ? EVM_SUPPORTED_WALLETS : [];
    function addAvalancheNetwork() {
        injected.getProvider().then((provider) => {
            provider === null || provider === void 0 ? void 0 : provider.request({
                method: 'wallet_addEthereumChain',
                params: [AVALANCHE_CHAIN_PARAMS],
            }).then(() => {
                onWalletConnect();
            }).catch((error) => {
                console.log(error);
            });
        });
    }
    // always reset to account view
    useEffect(() => {
        if (walletModalOpen) {
            setPendingError(false);
            setWalletView('');
        }
    }, [walletModalOpen]);
    const isMetamask = window.ethereum && window.ethereum.isMetaMask;
    const isRabby = window.ethereum && window.ethereum.isRabby;
    const isCbWalletDappBrowser = (_a = window === null || window === void 0 ? void 0 : window.ethereum) === null || _a === void 0 ? void 0 : _a.isCoinbaseWallet;
    const isWalletlink = !!(window === null || window === void 0 ? void 0 : window.WalletLinkProvider) || !!(window === null || window === void 0 ? void 0 : window.walletLinkExtension);
    const isCbWallet = isCbWalletDappBrowser || isWalletlink;
    const tryActivation = (activationConnector, option) => __awaiter$a(void 0, void 0, void 0, function* () {
        var _b, _c;
        const name = Object.keys(walletOptions).find((key) => walletOptions[key].connector === activationConnector);
        // log selected wallet
        // eslint-disable-next-line import/no-named-as-default-member
        ReactGA.event({
            category: 'Wallet',
            action: 'Change Wallet',
            label: name,
        });
        setPendingWallet(connector); // set wallet for pending view
        setSelectedOption(option);
        setWalletView(WALLET_VIEWS.PENDING);
        // if the connector is walletconnect and the user has already tried to connect, manually reset the connector
        if (activationConnector instanceof WalletConnectConnector && ((_c = (_b = activationConnector.walletConnectProvider) === null || _b === void 0 ? void 0 : _b.wc) === null || _c === void 0 ? void 0 : _c.uri)) {
            activationConnector.walletConnectProvider = undefined;
        }
        if (!triedSafe && activationConnector instanceof SafeAppConnector) {
            activationConnector.isSafeApp().then((loadedInSafe) => {
                if (loadedInSafe) {
                    activate(activationConnector, undefined, true)
                        .then(() => {
                        onWalletConnect();
                    })
                        .catch(() => {
                        setTriedSafe(true);
                    });
                }
                setTriedSafe(true);
            });
        }
        else if (activationConnector) {
            activate(activationConnector, undefined, true)
                .then(() => {
                if (isCbWallet) {
                    addAvalancheNetwork();
                }
                else {
                    onWalletConnect();
                }
            })
                .catch((error) => {
                if (error instanceof UnsupportedChainIdError) {
                    activate(activationConnector); // a little janky...can't use setError because the connector isn't set
                }
                else {
                    setPendingError(true);
                }
            });
        }
    });
    function getActiveOption() {
        if (connector === injected) {
            if (isRabby) {
                return EVM_SUPPORTED_WALLETS.RABBY;
            }
            else if (isMetamask) {
                return EVM_SUPPORTED_WALLETS.METAMASK;
            }
            return EVM_SUPPORTED_WALLETS.INJECTED;
        }
        const name = Object.keys(walletOptions).find((key) => walletOptions[key].connector === connector);
        if (name) {
            return walletOptions[name];
        }
        return undefined;
    }
    //get wallets user can switch too, depending on device/browser
    function getOptions() {
        const isXDEFI = window.ethereum && window.ethereum.isXDEFI;
        const activeOption = getActiveOption();
        return Object.keys(walletOptions).map((key) => {
            const option = walletOptions[key];
            // check for mobile options
            if (isMobile_1) {
                if (!window.web3 && !window.ethereum && option.mobile) {
                    return (jsx(Option, { onClick: () => {
                            option.connector !== connector && !option.href && tryActivation(option.connector, option);
                        }, id: `connect-${key}`, active: activeOption && option.name === activeOption.name, color: option.color, link: option.href, header: option.name, subheader: null, icon: require('src/assets/images/' + option.iconName) }, key));
                }
                return null;
            }
            // overwrite injected when needed
            if (option.connector === injected) {
                if (option.name === 'Rabby Wallet') {
                    if (!isRabby) {
                        return (jsx(Option, { id: `connect-${key}`, color: '#7a7cff', header: 'Install Rabby Wallet', subheader: null, link: 'https://rabby.io/', icon: RabbyIcon }, key));
                    }
                }
                // don't show injected if there's no injected provider
                if (!(window.web3 || window.ethereum)) {
                    if (option.name === 'MetaMask') {
                        return (jsx(Option, { id: `connect-${key}`, color: '#E8831D', header: 'Install Metamask', subheader: null, link: 'https://metamask.io/', icon: MetamaskIcon }, key));
                    }
                    else {
                        return null; //dont want to return install twice
                    }
                }
                // don't return metamask if injected provider isn't metamask
                else if (option.name === 'MetaMask' && !isMetamask) {
                    return null;
                }
                // likewise for generic
                else if (option.name === 'Injected' && isMetamask) {
                    return null;
                }
            }
            // overwrite injected when needed
            else if (option.connector === xDefi) {
                // don't show injected if there's no injected provider
                if (!(window.xfi && window.xfi.ethereum && window.xfi.ethereum.isXDEFI)) {
                    if (option.name === 'XDEFI Wallet') {
                        return (jsx(Option, { id: `connect-${key}`, color: '#315CF5', header: 'Install XDEFI Wallet', subheader: null, link: 'https://www.xdefi.io/', icon: XDefiIcon }, key));
                    }
                    else {
                        return null; //dont want to return install twice
                    }
                }
                // likewise for generic
                else if (option.name === 'Injected' && (isMetamask || isXDEFI)) {
                    return null;
                }
            }
            // Not show Gnosis Safe option without Gnosis Interface
            if (option.connector === gnosisSafe && !IS_IN_IFRAME) {
                return null;
            }
            // return rest of options
            return (!isMobile_1 &&
                !option.mobileOnly && (jsx(Option, { id: `connect-${key}`, onClick: () => {
                    option.connector !== connector && !option.href && tryActivation(option.connector, option);
                }, active: activeOption && option.name === activeOption.name, color: option.color, link: option.href, header: option.name, subheader: null, icon: require('src/assets/images/' + option.iconName) }, key)));
        });
    }
    const renderHeader = () => {
        if (web3Error) {
            return (jsx(HeaderRow, { children: web3Error instanceof UnsupportedChainIdError ? 'Wrong Network' : 'Error connecting' }, void 0));
        }
        else if (walletView === WALLET_VIEWS.PENDING || shouldShowBackButton) {
            return (jsx(HeaderRow, { children: jsx(HoverText, Object.assign({ onClick: () => {
                        if (onClickBack && shouldShowBackButton) {
                            onClickBack();
                        }
                        else {
                            setPendingError(false);
                            setWalletView('');
                        }
                    } }, { children: "Back" }), void 0) }, void 0));
        }
        else {
            return (jsx(HeaderRow, { children: jsx(HoverText, { children: "Connect to a wallet" }, void 0) }, void 0));
        }
    };
    const renderContent = () => {
        const isXDEFI = window.xfi && window.xfi.ethereum && window.xfi.ethereum.isXDEFI;
        const isMetamaskOrCbWallet = isMetamask || isCbWallet || isXDEFI;
        if (web3Error) {
            return (jsx(ContentWrapper, { children: web3Error instanceof UnsupportedChainIdError ? (jsxs(Fragment$1, { children: [jsx("h5", { children: "Please connect to the appropriate Avalanche network." }, void 0), isMetamaskOrCbWallet && (jsx(Button, Object.assign({ variant: "primary", onClick: addAvalancheNetwork }, { children: "Switch to Avalanche Chain" }), void 0))] }, void 0)) : ('Error connecting. Try refreshing the page.') }, void 0));
        }
        else {
            return (jsxs(ContentWrapper, { children: [walletView === WALLET_VIEWS.PENDING ? (jsx(PendingView, { option: selectedOption, connector: pendingWallet, error: pendingError, setPendingError: setPendingError, tryActivation: tryActivation }, void 0)) : (jsxs(Fragment$1, { children: [jsx(Box, Object.assign({ mt: "5px", width: "100%", mb: "5px" }, { children: jsx(ToggleButtons, { options: [CHAIN_TYPE.EVM_CHAINS, CHAIN_TYPE.NON_EVM_CHAINS], value: walletType, onChange: (value) => {
                                        setWalletType(value);
                                    } }, void 0) }), void 0), jsx(OptionGrid, { children: getOptions() }, void 0)] }, void 0)), walletView !== WALLET_VIEWS.PENDING && (jsxs(Blurb, { children: [jsx("span", { children: "New to Avalanche? \u00A0" }, void 0), ' ', jsx(ExternalLink, Object.assign({ href: WALLET_TUTORIAL }, { children: "Learn more about setting up a wallet" }), void 0)] }, void 0))] }, void 0));
        }
    };
    function getModalContent() {
        return (jsxs(UpperSection, { children: [jsxs(ModalWrapper, { children: [renderHeader(), jsx(CloseButton, { onClick: closeModal }, void 0)] }, void 0), renderContent()] }, void 0));
    }
    return (jsx(Modal, Object.assign({ isOpen: walletModalOpen, onDismiss: () => {
            closeModal();
        } }, { children: jsx(Wrapper, Object.assign({ background: background }, { children: getModalContent() }), void 0) }), void 0));
};

const openApi = axios.create({
    baseURL: OPEN_API_DEBANK,
    timeout: 2000,
});
// Get the USD balance of address of all chains (supported by Debank)
function useGetChainsBalances() {
    const { account } = usePangolinWeb3();
    const query = lib$3.stringify({
        id: account,
    }, {
        encodeValuesOnly: true,
    });
    return useQuery('getChainsBalances', () => __awaiter$a(this, void 0, void 0, function* () {
        var _a;
        if (account) {
            const response = yield openApi.get(`/total_balance?${query}`);
            const data = response.data;
            const chainbalances = {
                total: data === null || data === void 0 ? void 0 : data.total_usd_value,
                chains: [],
            };
            (_a = data === null || data === void 0 ? void 0 : data.chain_list) === null || _a === void 0 ? void 0 : _a.forEach((chain) => {
                const _chain = ALL_CHAINS.filter((value) => value.chain_id === (chain === null || chain === void 0 ? void 0 : chain.community_id))[0];
                if (_chain) {
                    chainbalances.chains.push({
                        chainID: chain === null || chain === void 0 ? void 0 : chain.community_id,
                        balance: chain === null || chain === void 0 ? void 0 : chain.usd_value,
                    });
                }
            });
            return chainbalances;
        }
        return null;
    }), { refetchOnWindowFocus: false });
}

const PortifolioRoot = styled(Box) `
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;

  padding: 20px;

  border-radius: 10px;
  background-color: ${({ theme }) => theme.color2};
`;
const PortfolioHeader = styled(Box) `
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 5px;
`;
const PortifolioFooter = styled(PortfolioHeader) `
  background-color: ${({ theme }) => theme.bg6};
  color: ${({ theme }) => theme.text13};
  border-radius: 4px;

  justify-content: center;
  align-items: center;

  padding: 5px;
`;
const HideButton = styled.button `
  background-color: ${({ theme }) => theme.bg6};
  color: ${({ theme }) => theme.text15};

  min-width: 20px;
  min-height: 20px;

  font-size: 12px;
  border-radius: 5px;
  border: 0px;
  padding: 5px;

  display: flex;
  align-items: center;

  cursor: pointer;

  :hover,
  :focus {
    opacity: 0.8;
  }

  align-self: flex-start;

  ${({ theme }) => theme.mediaWidth.upToMedium `
    #portfolio-text {
      display: none;
    }
  `}
`;
const ChainCard = styled(Box) `
  padding: 10px;
  background-color: ${({ theme }) => theme.bg6};
  border-radius: 4px;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;

  font-weight: 500;
  width: 100%;
`;
const Frame = styled(Box) `
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
`;

const Portfolio = () => {
    const theme = useContext(Me);
    const { account } = usePangolinWeb3();
    const { data: balance, isRefetching, isLoading } = useGetChainsBalances();
    const [availableBalances, setAvailableBalances] = useState([]);
    const [showBalances, setShowBalances] = useState(true);
    const [size, setSize] = useState(25);
    useEffect(() => {
        if (balance) {
            const _availableBalances = balance.chains
                .filter((chain) => chain.balance > 0.01)
                .sort((a, b) => b.balance - a.balance);
            setAvailableBalances(_availableBalances);
            if (_availableBalances.length === 0) {
                setSize(25);
            }
            else if (_availableBalances.length <= 4) {
                setSize(95);
            }
            else {
                setSize(200);
            }
        }
    }, [balance]);
    const renderChain = (_chain, key) => {
        const chain = ALL_CHAINS.filter((value) => value.chain_id === _chain.chainID)[0];
        const balance = _chain.balance.toLocaleString(undefined, { maximumFractionDigits: 2 });
        return (jsxs(ChainCard, { children: [jsx("img", { width: '55px', height: "55px", src: chain === null || chain === void 0 ? void 0 : chain.logo, alt: 'Chain logo' }, void 0), jsxs(Box, Object.assign({ height: "100%", display: "flex", justifyContent: "center", flexDirection: "column" }, { children: [jsx(Text$1, Object.assign({ fontSize: 14, color: "text1" }, { children: chain.name }), void 0), showBalances ? (jsxs(Text$1, Object.assign({ fontSize: 14, color: "text13" }, { children: ["$", balance] }), void 0)) : (jsx(Box, Object.assign({ display: "flex", flexDirection: "row" }, { children: [...Array(4)].map((_value, key) => (jsx(Lock$1, { color: theme.text13, size: 18 }, key))) }), void 0))] }), void 0)] }, key));
    };
    const renderTotalBalance = () => {
        if (showBalances) {
            return (jsxs(Text$1, Object.assign({ fontSize: 18, color: "text1", fontWeight: 600 }, { children: ["$", balance ? balance.total.toLocaleString(undefined, { maximumFractionDigits: 2 }) : 0] }), void 0));
        }
        return jsx(Lock$1, { color: theme.text1, size: 18 }, void 0);
    };
    return (jsxs(PortifolioRoot, { children: [jsxs(PortfolioHeader, { children: [jsx(Text$1, Object.assign({ fontSize: ['16px', '16px', '24px'], color: "text1", fontWeight: 600, style: { flexGrow: 1 } }, { children: "Portfolio Value in All Chains" }), void 0), jsx(HideButton, Object.assign({ onClick: () => setShowBalances(!showBalances) }, { children: showBalances ? (jsxs(Fragment$1, { children: [jsx(EyeOff$1, { size: 12, id: "portfolio-icon" }, void 0), jsx(Text$1, Object.assign({ fontSize: ['8px', '10px', '12px'], id: "portfolio-text", style: { marginLeft: '5px' } }, { children: "Hide Your Balance" }), void 0)] }, void 0)) : (jsxs(Fragment$1, { children: [jsx(Eye$1, { size: 12, id: "portfolio-icon" }, void 0), jsx(Text$1, Object.assign({ fontSize: 12, id: "portfolio-text", style: { marginLeft: '5px' } }, { children: "Show Your Balance" }), void 0)] }, void 0)) }), void 0)] }, void 0), !account ? (jsx(Box, { children: jsx(Text$1, Object.assign({ fontSize: 20, color: "text1", textAlign: "center" }, { children: "Connect a wallet to see your portifolio" }), void 0) }, void 0)) : isRefetching || isLoading || !balance ? (jsx(Loader, { size: 100 }, void 0)) : (jsxs(Box, Object.assign({ width: "100%" }, { children: [jsxs(Box, Object.assign({ padding: 10, borderRadius: 4, display: "flex", marginBottom: 15, alignItems: "center", bgColor: "bg6", flexWrap: "wrap" }, { children: [jsx(Text$1, Object.assign({ fontSize: 18, color: "text1", style: { flexGrow: 1, minWidth: '200px' } }, { children: "Total Amount Invested" }), void 0), renderTotalBalance()] }), void 0), jsx(Box, Object.assign({ height: size, width: "100%" }, { children: availableBalances.length > 0 ? (jsx(Scrollbars, Object.assign({ style: { width: '100%', height: '100%', display: 'flex', flexDirection: 'row' } }, { children: jsx(Frame, { children: availableBalances.map((chain, key) => renderChain(chain, key)) }, void 0) }), void 0)) : (jsx(Text$1, Object.assign({ fontSize: 18, color: "text1", textAlign: "center" }, { children: "Not found balances" }), void 0)) }), void 0)] }), void 0)), jsxs(PortifolioFooter, { children: [jsx(Info$2, { size: 12 }, void 0), jsx(Text$1, Object.assign({ fontSize: 12, textAlign: "center" }, { children: "Includes coins, pools and other holdings in your current wallet" }), void 0)] }, void 0)] }, void 0));
};

const DrawerRoot = styled.div `
  overflow: hidden;
  position: absolute;
  z-index: 99;
  transition: all 350ms ease;
  background-color: ${({ theme, backgroundColor }) => (backgroundColor ? theme[backgroundColor] : theme.bg2)};
  transform: ${({ isOpen }) => (!isOpen ? 'translate(100%, 0px)' : 'translate(0px, 0px)')};
  width: 100%;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 10px;
  height: 100%;

  /* ${({ theme, isOpen }) => theme.mediaWidth.upToSmall `
    display: ${isOpen ? 'none' : 'flex'};
    width: 100%;
    height: 100%
  `}; */
`;
const DrawerContent = styled.div `
  flex: 1;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;
const CloseIcon = styled(X$1) `
  cursor: pointer;
`;

function Drawer({ isOpen, onClose, children, title, backgroundColor }) {
    const theme = useContext(Me);
    return (jsxs(DrawerRoot, Object.assign({ isOpen: isOpen, backgroundColor: backgroundColor }, { children: [title && (jsx(Box, Object.assign({ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px" }, { children: jsx(Text$1, Object.assign({ color: "text1", fontSize: 24 }, { children: title }), void 0) }), void 0)), jsx(Box, Object.assign({ position: "absolute", right: 10, top: 10 }, { children: jsx(CloseIcon, { onClick: onClose, color: theme.text4 }, void 0) }), void 0), jsx(DrawerContent, { children: children }, void 0)] }), void 0));
}

function filterTokens(tokens, search) {
    if (search.length === 0)
        return tokens;
    const searchingAddress = isAddress(search);
    if (searchingAddress) {
        return tokens.filter((token) => token.address === searchingAddress);
    }
    const lowerSearchParts = search
        .toLowerCase()
        .split(/\s+/)
        .filter((s) => s.length > 0);
    if (lowerSearchParts.length === 0) {
        return tokens;
    }
    const matchesSearch = (s) => {
        const sParts = s
            .toLowerCase()
            .split(/\s+/)
            .filter((s) => s.length > 0);
        return lowerSearchParts.every((p) => p.length === 0 || sParts.some((sp) => sp.startsWith(p) || sp.endsWith(p)));
    };
    return tokens.filter((token) => {
        const { symbol, name } = token;
        return (symbol && matchesSearch(symbol)) || (name && matchesSearch(name));
    });
}

// compare two token amounts with highest one coming first
function balanceComparator(balanceA, balanceB) {
    if (balanceA && balanceB) {
        return balanceA.greaterThan(balanceB) ? -1 : balanceA.equalTo(balanceB) ? 0 : 1;
    }
    else if (balanceA && balanceA.greaterThan('0')) {
        return -1;
    }
    else if (balanceB && balanceB.greaterThan('0')) {
        return 1;
    }
    return 0;
}
function getTokenComparator(balances) {
    return function sortTokens(tokenA, tokenB) {
        // -1 = a is first
        // 1 = b is first
        // sort by balances
        const balanceA = balances[tokenA.address];
        const balanceB = balances[tokenB.address];
        const balanceComp = balanceComparator(balanceA, balanceB);
        if (balanceComp !== 0)
            return balanceComp;
        if (tokenA.symbol && tokenB.symbol) {
            // sort by symbol
            return tokenA.symbol.toLowerCase() < tokenB.symbol.toLowerCase() ? -1 : 1;
        }
        else {
            return tokenA.symbol ? -1 : tokenB.symbol ? -1 : 0;
        }
    };
}
function useTokenComparator(inverted) {
    const balances = useAllTokenBalances();
    const comparator = useMemo(() => getTokenComparator(balances !== null && balances !== void 0 ? balances : {}), [balances]);
    return useMemo(() => {
        if (inverted) {
            return (tokenA, tokenB) => comparator(tokenA, tokenB) * -1;
        }
        else {
            return comparator;
        }
    }, [inverted, comparator]);
}

var $schema$2 = "http://json-schema.org/draft-07/schema#";
var $id$2 = "https://uniswap.org/tokenlist.schema.json";
var title$1 = "Uniswap Token List";
var description$1 = "Schema for lists of tokens compatible with the Uniswap Interface";
var definitions$1 = {
	Version: {
		type: "object",
		description: "The version of the list, used in change detection",
		examples: [
			{
				major: 1,
				minor: 0,
				patch: 0
			}
		],
		additionalProperties: false,
		properties: {
			major: {
				type: "integer",
				description: "The major version of the list. Must be incremented when tokens are removed from the list or token addresses are changed.",
				minimum: 0,
				examples: [
					1,
					2
				]
			},
			minor: {
				type: "integer",
				description: "The minor version of the list. Must be incremented when tokens are added to the list.",
				minimum: 0,
				examples: [
					0,
					1
				]
			},
			patch: {
				type: "integer",
				description: "The patch version of the list. Must be incremented for any changes to the list.",
				minimum: 0,
				examples: [
					0,
					1
				]
			}
		},
		required: [
			"major",
			"minor",
			"patch"
		]
	},
	TagIdentifier: {
		type: "string",
		description: "The unique identifier of a tag",
		minLength: 1,
		maxLength: 10,
		pattern: "^[\\w]+$",
		examples: [
			"compound",
			"stablecoin"
		]
	},
	ExtensionIdentifier: {
		type: "string",
		description: "The name of a token extension property",
		minLength: 1,
		maxLength: 30,
		pattern: "^[\\w]+$",
		examples: [
			"color",
			"is_fee_on_transfer",
			"aliases"
		]
	},
	ExtensionValue: {
		anyOf: [
			{
				type: "string",
				minLength: 1,
				maxLength: 42,
				examples: [
					"#00000"
				]
			},
			{
				type: "boolean",
				examples: [
					true
				]
			},
			{
				type: "number",
				examples: [
					15
				]
			},
			{
				type: "null"
			}
		]
	},
	TagDefinition: {
		type: "object",
		description: "Definition of a tag that can be associated with a token via its identifier",
		additionalProperties: false,
		properties: {
			name: {
				type: "string",
				description: "The name of the tag",
				pattern: "^[ \\w]+$",
				minLength: 1,
				maxLength: 20
			},
			description: {
				type: "string",
				description: "A user-friendly description of the tag",
				pattern: "^[ \\w\\.,:]+$",
				minLength: 1,
				maxLength: 200
			}
		},
		required: [
			"name",
			"description"
		],
		examples: [
			{
				name: "Stablecoin",
				description: "A token with value pegged to another asset"
			}
		]
	},
	TokenInfo: {
		type: "object",
		description: "Metadata for a single token in a token list",
		additionalProperties: false,
		properties: {
			chainId: {
				type: "integer",
				description: "The chain ID of the Ethereum network where this token is deployed",
				minimum: 1,
				examples: [
					1,
					42
				]
			},
			address: {
				type: "string",
				description: "The checksummed address of the token on the specified chain ID",
				pattern: "^0x[a-fA-F0-9]{40}$",
				examples: [
					"0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
				]
			},
			decimals: {
				type: "integer",
				description: "The number of decimals for the token balance",
				minimum: 0,
				maximum: 255,
				examples: [
					18
				]
			},
			name: {
				type: "string",
				description: "The name of the token",
				minLength: 1,
				maxLength: 40,
				pattern: "^[ \\w.'+\\-%\\/À-ÖØ-öø-ÿ:]+$",
				examples: [
					"USD Coin"
				]
			},
			symbol: {
				type: "string",
				description: "The symbol for the token; must be alphanumeric",
				pattern: "^[a-zA-Z0-9+\\-%\\/\\$\\.]+$",
				minLength: 1,
				maxLength: 20,
				examples: [
					"USDC"
				]
			},
			logoURI: {
				type: "string",
				description: "A URI to the token logo asset; if not set, interface will attempt to find a logo based on the token address; suggest SVG or PNG of size 64x64",
				format: "uri",
				examples: [
					"ipfs://QmXfzKRvjZz3u5JRgC4v5mGVbm9ahrUiB4DgzHBsnWbTMM"
				]
			},
			tags: {
				type: "array",
				description: "An array of tag identifiers associated with the token; tags are defined at the list level",
				items: {
					$ref: "#/definitions/TagIdentifier"
				},
				maxItems: 10,
				examples: [
					"stablecoin",
					"compound"
				]
			},
			extensions: {
				type: "object",
				description: "An object containing any arbitrary or vendor-specific token metadata",
				propertyNames: {
					$ref: "#/definitions/ExtensionIdentifier"
				},
				additionalProperties: {
					$ref: "#/definitions/ExtensionValue"
				},
				maxProperties: 10,
				examples: [
					{
						color: "#000000",
						is_verified_by_me: true
					}
				]
			}
		},
		required: [
			"chainId",
			"address",
			"decimals",
			"name",
			"symbol"
		]
	}
};
var type$2 = "object";
var additionalProperties$1 = false;
var properties$3 = {
	name: {
		type: "string",
		description: "The name of the token list",
		minLength: 1,
		maxLength: 20,
		pattern: "^[\\w ]+$",
		examples: [
			"My Token List"
		]
	},
	timestamp: {
		type: "string",
		format: "date-time",
		description: "The timestamp of this list version; i.e. when this immutable version of the list was created"
	},
	version: {
		$ref: "#/definitions/Version"
	},
	tokens: {
		type: "array",
		description: "The list of tokens included in the list",
		items: {
			$ref: "#/definitions/TokenInfo"
		},
		minItems: 1,
		maxItems: 10000
	},
	keywords: {
		type: "array",
		description: "Keywords associated with the contents of the list; may be used in list discoverability",
		items: {
			type: "string",
			description: "A keyword to describe the contents of the list",
			minLength: 1,
			maxLength: 20,
			pattern: "^[\\w ]+$",
			examples: [
				"compound",
				"lending",
				"personal tokens"
			]
		},
		maxItems: 20,
		uniqueItems: true
	},
	tags: {
		type: "object",
		description: "A mapping of tag identifiers to their name and description",
		propertyNames: {
			$ref: "#/definitions/TagIdentifier"
		},
		additionalProperties: {
			$ref: "#/definitions/TagDefinition"
		},
		maxProperties: 20,
		examples: [
			{
				stablecoin: {
					name: "Stablecoin",
					description: "A token with value pegged to another asset"
				}
			}
		]
	},
	logoURI: {
		type: "string",
		description: "A URI for the logo of the token list; prefer SVG or PNG of size 256x256",
		format: "uri",
		examples: [
			"ipfs://QmXfzKRvjZz3u5JRgC4v5mGVbm9ahrUiB4DgzHBsnWbTMM"
		]
	}
};
var required$2 = [
	"name",
	"timestamp",
	"version",
	"tokens"
];
var schema = {
	$schema: $schema$2,
	$id: $id$2,
	title: title$1,
	description: description$1,
	definitions: definitions$1,
	type: type$2,
	additionalProperties: additionalProperties$1,
	properties: properties$3,
	required: required$2
};

var uri_all = {exports: {}};

/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */

(function (module, exports) {
(function (global, factory) {
	factory(exports) ;
}(commonjsGlobal, (function (exports) {
function merge() {
    for (var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++) {
        sets[_key] = arguments[_key];
    }

    if (sets.length > 1) {
        sets[0] = sets[0].slice(0, -1);
        var xl = sets.length - 1;
        for (var x = 1; x < xl; ++x) {
            sets[x] = sets[x].slice(1, -1);
        }
        sets[xl] = sets[xl].slice(1);
        return sets.join('');
    } else {
        return sets[0];
    }
}
function subexp(str) {
    return "(?:" + str + ")";
}
function typeOf(o) {
    return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
}
function toUpperCase(str) {
    return str.toUpperCase();
}
function toArray(obj) {
    return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [obj] : Array.prototype.slice.call(obj) : [];
}
function assign(target, source) {
    var obj = target;
    if (source) {
        for (var key in source) {
            obj[key] = source[key];
        }
    }
    return obj;
}

function buildExps(isIRI) {
    var ALPHA$$ = "[A-Za-z]",
        DIGIT$$ = "[0-9]",
        HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"),
        PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)),
        //expanded
    GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]",
        SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]",
        RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$),
        UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]",
        //subset, excludes bidi control characters
    IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]",
        //subset
    UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$);
        subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*");
        subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*");
        var DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$),
        //relaxed parsing rules
    IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$),
        H16$ = subexp(HEXDIG$$ + "{1,4}"),
        LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$),
        IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$),
        //                           6( h16 ":" ) ls32
    IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$),
        //                      "::" 5( h16 ":" ) ls32
    IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$),
        //[               h16 ] "::" 4( h16 ":" ) ls32
    IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$),
        //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
    IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$),
        //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
    IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$),
        //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
    IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$),
        //[ *4( h16 ":" ) h16 ] "::"              ls32
    IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$),
        //[ *5( h16 ":" ) h16 ] "::"              h16
    IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"),
        //[ *6( h16 ":" ) h16 ] "::"
    IPV6ADDRESS$ = subexp([IPV6ADDRESS1$, IPV6ADDRESS2$, IPV6ADDRESS3$, IPV6ADDRESS4$, IPV6ADDRESS5$, IPV6ADDRESS6$, IPV6ADDRESS7$, IPV6ADDRESS8$, IPV6ADDRESS9$].join("|")),
        ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+");
        //RFC 6874, with relaxed parsing rules
    subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+");
        //RFC 6874
    subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*");
        var PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]"));
        subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+");
        subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*");
    return {
        NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
        NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
        NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
        ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        UNRESERVED: new RegExp(UNRESERVED$$, "g"),
        OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
        PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
        IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
        IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
    };
}
var URI_PROTOCOL = buildExps(false);

var IRI_PROTOCOL = buildExps(true);

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();













var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/** Highest positive signed 32-bit float value */

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

/** Bootstring parameters */
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'

/** Regular expressions */
var regexPunycode = /^xn--/;
var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

/** Error messages */
var errors = {
	'overflow': 'Overflow: input needs wider integers to process',
	'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
	'invalid-input': 'Invalid input'
};

/** Convenience shortcuts */
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/*--------------------------------------------------------------------------*/

/**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */
function error$1(type) {
	throw new RangeError(errors[type]);
}

/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */
function map(array, fn) {
	var result = [];
	var length = array.length;
	while (length--) {
		result[length] = fn(array[length]);
	}
	return result;
}

/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */
function mapDomain(string, fn) {
	var parts = string.split('@');
	var result = '';
	if (parts.length > 1) {
		// In email addresses, only the domain name should be punycoded. Leave
		// the local part (i.e. everything up to `@`) intact.
		result = parts[0] + '@';
		string = parts[1];
	}
	// Avoid `split(regex)` for IE8 compatibility. See #17.
	string = string.replace(regexSeparators, '\x2E');
	var labels = string.split('.');
	var encoded = map(labels, fn).join('.');
	return result + encoded;
}

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */
function ucs2decode(string) {
	var output = [];
	var counter = 0;
	var length = string.length;
	while (counter < length) {
		var value = string.charCodeAt(counter++);
		if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
			// It's a high surrogate, and there is a next character.
			var extra = string.charCodeAt(counter++);
			if ((extra & 0xFC00) == 0xDC00) {
				// Low surrogate.
				output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
			} else {
				// It's an unmatched surrogate; only append this code unit, in case the
				// next code unit is the high surrogate of a surrogate pair.
				output.push(value);
				counter--;
			}
		} else {
			output.push(value);
		}
	}
	return output;
}

/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */
var ucs2encode = function ucs2encode(array) {
	return String.fromCodePoint.apply(String, toConsumableArray(array));
};

/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */
var basicToDigit = function basicToDigit(codePoint) {
	if (codePoint - 0x30 < 0x0A) {
		return codePoint - 0x16;
	}
	if (codePoint - 0x41 < 0x1A) {
		return codePoint - 0x41;
	}
	if (codePoint - 0x61 < 0x1A) {
		return codePoint - 0x61;
	}
	return base;
};

/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */
var digitToBasic = function digitToBasic(digit, flag) {
	//  0..25 map to ASCII a..z or A..Z
	// 26..35 map to ASCII 0..9
	return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */
var adapt = function adapt(delta, numPoints, firstTime) {
	var k = 0;
	delta = firstTime ? floor(delta / damp) : delta >> 1;
	delta += floor(delta / numPoints);
	for (; /* no initialization */delta > baseMinusTMin * tMax >> 1; k += base) {
		delta = floor(delta / baseMinusTMin);
	}
	return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */
var decode = function decode(input) {
	// Don't use UCS-2.
	var output = [];
	var inputLength = input.length;
	var i = 0;
	var n = initialN;
	var bias = initialBias;

	// Handle the basic code points: let `basic` be the number of input code
	// points before the last delimiter, or `0` if there is none, then copy
	// the first basic code points to the output.

	var basic = input.lastIndexOf(delimiter);
	if (basic < 0) {
		basic = 0;
	}

	for (var j = 0; j < basic; ++j) {
		// if it's not a basic code point
		if (input.charCodeAt(j) >= 0x80) {
			error$1('not-basic');
		}
		output.push(input.charCodeAt(j));
	}

	// Main decoding loop: start just after the last delimiter if any basic code
	// points were copied; start at the beginning otherwise.

	for (var index = basic > 0 ? basic + 1 : 0; index < inputLength;) /* no final expression */{

		// `index` is the index of the next character to be consumed.
		// Decode a generalized variable-length integer into `delta`,
		// which gets added to `i`. The overflow checking is easier
		// if we increase `i` as we go, then subtract off its starting
		// value at the end to obtain `delta`.
		var oldi = i;
		for (var w = 1, k = base;; /* no condition */k += base) {

			if (index >= inputLength) {
				error$1('invalid-input');
			}

			var digit = basicToDigit(input.charCodeAt(index++));

			if (digit >= base || digit > floor((maxInt - i) / w)) {
				error$1('overflow');
			}

			i += digit * w;
			var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

			if (digit < t) {
				break;
			}

			var baseMinusT = base - t;
			if (w > floor(maxInt / baseMinusT)) {
				error$1('overflow');
			}

			w *= baseMinusT;
		}

		var out = output.length + 1;
		bias = adapt(i - oldi, out, oldi == 0);

		// `i` was supposed to wrap around from `out` to `0`,
		// incrementing `n` each time, so we'll fix that now:
		if (floor(i / out) > maxInt - n) {
			error$1('overflow');
		}

		n += floor(i / out);
		i %= out;

		// Insert `n` at position `i` of the output.
		output.splice(i++, 0, n);
	}

	return String.fromCodePoint.apply(String, output);
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */
var encode = function encode(input) {
	var output = [];

	// Convert the input in UCS-2 to an array of Unicode code points.
	input = ucs2decode(input);

	// Cache the length.
	var inputLength = input.length;

	// Initialize the state.
	var n = initialN;
	var delta = 0;
	var bias = initialBias;

	// Handle the basic code points.
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _currentValue2 = _step.value;

			if (_currentValue2 < 0x80) {
				output.push(stringFromCharCode(_currentValue2));
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	var basicLength = output.length;
	var handledCPCount = basicLength;

	// `handledCPCount` is the number of code points that have been handled;
	// `basicLength` is the number of basic code points.

	// Finish the basic string with a delimiter unless it's empty.
	if (basicLength) {
		output.push(delimiter);
	}

	// Main encoding loop:
	while (handledCPCount < inputLength) {

		// All non-basic code points < n have been handled already. Find the next
		// larger one:
		var m = maxInt;
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;

		try {
			for (var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var currentValue = _step2.value;

				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow.
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}

		var handledCPCountPlusOne = handledCPCount + 1;
		if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
			error$1('overflow');
		}

		delta += (m - n) * handledCPCountPlusOne;
		n = m;

		var _iteratorNormalCompletion3 = true;
		var _didIteratorError3 = false;
		var _iteratorError3 = undefined;

		try {
			for (var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
				var _currentValue = _step3.value;

				if (_currentValue < n && ++delta > maxInt) {
					error$1('overflow');
				}
				if (_currentValue == n) {
					// Represent delta as a generalized variable-length integer.
					var q = delta;
					for (var k = base;; /* no condition */k += base) {
						var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
						if (q < t) {
							break;
						}
						var qMinusT = q - t;
						var baseMinusT = base - t;
						output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}
		} catch (err) {
			_didIteratorError3 = true;
			_iteratorError3 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion3 && _iterator3.return) {
					_iterator3.return();
				}
			} finally {
				if (_didIteratorError3) {
					throw _iteratorError3;
				}
			}
		}

		++delta;
		++n;
	}
	return output.join('');
};

/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */
var toUnicode = function toUnicode(input) {
	return mapDomain(input, function (string) {
		return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
	});
};

/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */
var toASCII = function toASCII(input) {
	return mapDomain(input, function (string) {
		return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
	});
};

/*--------------------------------------------------------------------------*/

/** Define the public API */
var punycode = {
	/**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */
	'version': '2.1.0',
	/**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */
	'ucs2': {
		'decode': ucs2decode,
		'encode': ucs2encode
	},
	'decode': decode,
	'encode': encode,
	'toASCII': toASCII,
	'toUnicode': toUnicode
};

/**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */
/**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */
var SCHEMES = {};
function pctEncChar(chr) {
    var c = chr.charCodeAt(0);
    var e = void 0;
    if (c < 16) e = "%0" + c.toString(16).toUpperCase();else if (c < 128) e = "%" + c.toString(16).toUpperCase();else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
    return e;
}
function pctDecChars(str) {
    var newStr = "";
    var i = 0;
    var il = str.length;
    while (i < il) {
        var c = parseInt(str.substr(i + 1, 2), 16);
        if (c < 128) {
            newStr += String.fromCharCode(c);
            i += 3;
        } else if (c >= 194 && c < 224) {
            if (il - i >= 6) {
                var c2 = parseInt(str.substr(i + 4, 2), 16);
                newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
            } else {
                newStr += str.substr(i, 6);
            }
            i += 6;
        } else if (c >= 224) {
            if (il - i >= 9) {
                var _c = parseInt(str.substr(i + 4, 2), 16);
                var c3 = parseInt(str.substr(i + 7, 2), 16);
                newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
            } else {
                newStr += str.substr(i, 9);
            }
            i += 9;
        } else {
            newStr += str.substr(i, 3);
            i += 3;
        }
    }
    return newStr;
}
function _normalizeComponentEncoding(components, protocol) {
    function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(protocol.UNRESERVED) ? str : decStr;
    }
    if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
    if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    return components;
}

function _stripLeadingZeros(str) {
    return str.replace(/^0*(.*)/, "$1") || "0";
}
function _normalizeIPv4(host, protocol) {
    var matches = host.match(protocol.IPV4ADDRESS) || [];

    var _matches = slicedToArray(matches, 2),
        address = _matches[1];

    if (address) {
        return address.split(".").map(_stripLeadingZeros).join(".");
    } else {
        return host;
    }
}
function _normalizeIPv6(host, protocol) {
    var matches = host.match(protocol.IPV6ADDRESS) || [];

    var _matches2 = slicedToArray(matches, 3),
        address = _matches2[1],
        zone = _matches2[2];

    if (address) {
        var _address$toLowerCase$ = address.toLowerCase().split('::').reverse(),
            _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2),
            last = _address$toLowerCase$2[0],
            first = _address$toLowerCase$2[1];

        var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
        var lastFields = last.split(":").map(_stripLeadingZeros);
        var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
        var fieldCount = isLastFieldIPv4Address ? 7 : 8;
        var lastFieldsStart = lastFields.length - fieldCount;
        var fields = Array(fieldCount);
        for (var x = 0; x < fieldCount; ++x) {
            fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || '';
        }
        if (isLastFieldIPv4Address) {
            fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
        }
        var allZeroFields = fields.reduce(function (acc, field, index) {
            if (!field || field === "0") {
                var lastLongest = acc[acc.length - 1];
                if (lastLongest && lastLongest.index + lastLongest.length === index) {
                    lastLongest.length++;
                } else {
                    acc.push({ index: index, length: 1 });
                }
            }
            return acc;
        }, []);
        var longestZeroFields = allZeroFields.sort(function (a, b) {
            return b.length - a.length;
        })[0];
        var newHost = void 0;
        if (longestZeroFields && longestZeroFields.length > 1) {
            var newFirst = fields.slice(0, longestZeroFields.index);
            var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
            newHost = newFirst.join(":") + "::" + newLast.join(":");
        } else {
            newHost = fields.join(":");
        }
        if (zone) {
            newHost += "%" + zone;
        }
        return newHost;
    } else {
        return host;
    }
}
var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
function parse(uriString) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var components = {};
    var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
    if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
    var matches = uriString.match(URI_PARSE);
    if (matches) {
        if (NO_MATCH_IS_UNDEFINED) {
            //store each component
            components.scheme = matches[1];
            components.userinfo = matches[3];
            components.host = matches[4];
            components.port = parseInt(matches[5], 10);
            components.path = matches[6] || "";
            components.query = matches[7];
            components.fragment = matches[8];
            //fix port number
            if (isNaN(components.port)) {
                components.port = matches[5];
            }
        } else {
            //IE FIX for improper RegExp matching
            //store each component
            components.scheme = matches[1] || undefined;
            components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
            components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
            components.port = parseInt(matches[5], 10);
            components.path = matches[6] || "";
            components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
            components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
            //fix port number
            if (isNaN(components.port)) {
                components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
        }
        if (components.host) {
            //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
        }
        //determine reference type
        if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) {
            components.reference = "same-document";
        } else if (components.scheme === undefined) {
            components.reference = "relative";
        } else if (components.fragment === undefined) {
            components.reference = "absolute";
        } else {
            components.reference = "uri";
        }
        //check for reference errors
        if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) {
            components.error = components.error || "URI is not a " + options.reference + " reference.";
        }
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //check if scheme can't handle IRIs
        if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
            //if host component is a domain name
            if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) {
                //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
            }
            //convert IRI -> URI
            _normalizeComponentEncoding(components, URI_PROTOCOL);
        } else {
            //normalize encodings
            _normalizeComponentEncoding(components, protocol);
        }
        //perform scheme specific parsing
        if (schemeHandler && schemeHandler.parse) {
            schemeHandler.parse(components, options);
        }
    } else {
        components.error = components.error || "URI can not be parsed.";
    }
    return components;
}

function _recomposeAuthority(components, options) {
    var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
    var uriTokens = [];
    if (components.userinfo !== undefined) {
        uriTokens.push(components.userinfo);
        uriTokens.push("@");
    }
    if (components.host !== undefined) {
        //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function (_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
    }
    if (typeof components.port === "number" || typeof components.port === "string") {
        uriTokens.push(":");
        uriTokens.push(String(components.port));
    }
    return uriTokens.length ? uriTokens.join("") : undefined;
}

var RDS1 = /^\.\.?\//;
var RDS2 = /^\/\.(\/|$)/;
var RDS3 = /^\/\.\.(\/|$)/;
var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
function removeDotSegments(input) {
    var output = [];
    while (input.length) {
        if (input.match(RDS1)) {
            input = input.replace(RDS1, "");
        } else if (input.match(RDS2)) {
            input = input.replace(RDS2, "/");
        } else if (input.match(RDS3)) {
            input = input.replace(RDS3, "/");
            output.pop();
        } else if (input === "." || input === "..") {
            input = "";
        } else {
            var im = input.match(RDS5);
            if (im) {
                var s = im[0];
                input = input.slice(s.length);
                output.push(s);
            } else {
                throw new Error("Unexpected dot segment condition");
            }
        }
    }
    return output.join("");
}

function serialize(components) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
    var uriTokens = [];
    //find scheme handler
    var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
    //perform scheme specific serialization
    if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
    if (components.host) {
        //if host component is an IPv6 address
        if (protocol.IPV6ADDRESS.test(components.host)) ;
        //TODO: normalize IPv6 address as per RFC 5952

        //if host component is a domain name
        else if (options.domainHost || schemeHandler && schemeHandler.domainHost) {
                //convert IDN via punycode
                try {
                    components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                }
            }
    }
    //normalize encoding
    _normalizeComponentEncoding(components, protocol);
    if (options.reference !== "suffix" && components.scheme) {
        uriTokens.push(components.scheme);
        uriTokens.push(":");
    }
    var authority = _recomposeAuthority(components, options);
    if (authority !== undefined) {
        if (options.reference !== "suffix") {
            uriTokens.push("//");
        }
        uriTokens.push(authority);
        if (components.path && components.path.charAt(0) !== "/") {
            uriTokens.push("/");
        }
    }
    if (components.path !== undefined) {
        var s = components.path;
        if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) {
            s = removeDotSegments(s);
        }
        if (authority === undefined) {
            s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
        }
        uriTokens.push(s);
    }
    if (components.query !== undefined) {
        uriTokens.push("?");
        uriTokens.push(components.query);
    }
    if (components.fragment !== undefined) {
        uriTokens.push("#");
        uriTokens.push(components.fragment);
    }
    return uriTokens.join(""); //merge tokens into a string
}

function resolveComponents(base, relative) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var skipNormalization = arguments[3];

    var target = {};
    if (!skipNormalization) {
        base = parse(serialize(base, options), options); //normalize base components
        relative = parse(serialize(relative, options), options); //normalize relative components
    }
    options = options || {};
    if (!options.tolerant && relative.scheme) {
        target.scheme = relative.scheme;
        //target.authority = relative.authority;
        target.userinfo = relative.userinfo;
        target.host = relative.host;
        target.port = relative.port;
        target.path = removeDotSegments(relative.path || "");
        target.query = relative.query;
    } else {
        if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (!relative.path) {
                target.path = base.path;
                if (relative.query !== undefined) {
                    target.query = relative.query;
                } else {
                    target.query = base.query;
                }
            } else {
                if (relative.path.charAt(0) === "/") {
                    target.path = removeDotSegments(relative.path);
                } else {
                    if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) {
                        target.path = "/" + relative.path;
                    } else if (!base.path) {
                        target.path = relative.path;
                    } else {
                        target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                    }
                    target.path = removeDotSegments(target.path);
                }
                target.query = relative.query;
            }
            //target.authority = base.authority;
            target.userinfo = base.userinfo;
            target.host = base.host;
            target.port = base.port;
        }
        target.scheme = base.scheme;
    }
    target.fragment = relative.fragment;
    return target;
}

function resolve(baseURI, relativeURI, options) {
    var schemelessOptions = assign({ scheme: 'null' }, options);
    return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
}

function normalize(uri, options) {
    if (typeof uri === "string") {
        uri = serialize(parse(uri, options), options);
    } else if (typeOf(uri) === "object") {
        uri = parse(serialize(uri, options), options);
    }
    return uri;
}

function equal(uriA, uriB, options) {
    if (typeof uriA === "string") {
        uriA = serialize(parse(uriA, options), options);
    } else if (typeOf(uriA) === "object") {
        uriA = serialize(uriA, options);
    }
    if (typeof uriB === "string") {
        uriB = serialize(parse(uriB, options), options);
    } else if (typeOf(uriB) === "object") {
        uriB = serialize(uriB, options);
    }
    return uriA === uriB;
}

function escapeComponent(str, options) {
    return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
}

function unescapeComponent(str, options) {
    return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
}

var handler = {
    scheme: "http",
    domainHost: true,
    parse: function parse(components, options) {
        //report missing host
        if (!components.host) {
            components.error = components.error || "HTTP URIs must have a host.";
        }
        return components;
    },
    serialize: function serialize(components, options) {
        var secure = String(components.scheme).toLowerCase() === "https";
        //normalize the default port
        if (components.port === (secure ? 443 : 80) || components.port === "") {
            components.port = undefined;
        }
        //normalize the empty path
        if (!components.path) {
            components.path = "/";
        }
        //NOTE: We do not parse query strings for HTTP URIs
        //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
        //and not the HTTP spec.
        return components;
    }
};

var handler$1 = {
    scheme: "https",
    domainHost: handler.domainHost,
    parse: handler.parse,
    serialize: handler.serialize
};

function isSecure(wsComponents) {
    return typeof wsComponents.secure === 'boolean' ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
}
//RFC 6455
var handler$2 = {
    scheme: "ws",
    domainHost: true,
    parse: function parse(components, options) {
        var wsComponents = components;
        //indicate if the secure flag is set
        wsComponents.secure = isSecure(wsComponents);
        //construct resouce name
        wsComponents.resourceName = (wsComponents.path || '/') + (wsComponents.query ? '?' + wsComponents.query : '');
        wsComponents.path = undefined;
        wsComponents.query = undefined;
        return wsComponents;
    },
    serialize: function serialize(wsComponents, options) {
        //normalize the default port
        if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") {
            wsComponents.port = undefined;
        }
        //ensure scheme matches secure flag
        if (typeof wsComponents.secure === 'boolean') {
            wsComponents.scheme = wsComponents.secure ? 'wss' : 'ws';
            wsComponents.secure = undefined;
        }
        //reconstruct path from resource name
        if (wsComponents.resourceName) {
            var _wsComponents$resourc = wsComponents.resourceName.split('?'),
                _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2),
                path = _wsComponents$resourc2[0],
                query = _wsComponents$resourc2[1];

            wsComponents.path = path && path !== '/' ? path : undefined;
            wsComponents.query = query;
            wsComponents.resourceName = undefined;
        }
        //forbid fragment component
        wsComponents.fragment = undefined;
        return wsComponents;
    }
};

var handler$3 = {
    scheme: "wss",
    domainHost: handler$2.domainHost,
    parse: handler$2.parse,
    serialize: handler$2.serialize
};

var O = {};
//RFC 3986
var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + ("\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" ) + "]";
var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
//RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
//const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
//const WSP$$ = "[\\x20\\x09]";
//const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
//const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
//const VCHAR$$ = "[\\x21-\\x7E]";
//const WSP$$ = "[\\x20\\x09]";
//const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
//const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
//const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
//const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
var VCHAR$$ = merge(QTEXT$$, "[\\\"\\\\]");
var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
var UNRESERVED = new RegExp(UNRESERVED$$, "g");
var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
var NOT_HFVALUE = NOT_HFNAME;
function decodeUnreserved(str) {
    var decStr = pctDecChars(str);
    return !decStr.match(UNRESERVED) ? str : decStr;
}
var handler$4 = {
    scheme: "mailto",
    parse: function parse$$1(components, options) {
        var mailtoComponents = components;
        var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
        mailtoComponents.path = undefined;
        if (mailtoComponents.query) {
            var unknownHeaders = false;
            var headers = {};
            var hfields = mailtoComponents.query.split("&");
            for (var x = 0, xl = hfields.length; x < xl; ++x) {
                var hfield = hfields[x].split("=");
                switch (hfield[0]) {
                    case "to":
                        var toAddrs = hfield[1].split(",");
                        for (var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x) {
                            to.push(toAddrs[_x]);
                        }
                        break;
                    case "subject":
                        mailtoComponents.subject = unescapeComponent(hfield[1], options);
                        break;
                    case "body":
                        mailtoComponents.body = unescapeComponent(hfield[1], options);
                        break;
                    default:
                        unknownHeaders = true;
                        headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                        break;
                }
            }
            if (unknownHeaders) mailtoComponents.headers = headers;
        }
        mailtoComponents.query = undefined;
        for (var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2) {
            var addr = to[_x2].split("@");
            addr[0] = unescapeComponent(addr[0]);
            if (!options.unicodeSupport) {
                //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
            } else {
                addr[1] = unescapeComponent(addr[1], options).toLowerCase();
            }
            to[_x2] = addr.join("@");
        }
        return mailtoComponents;
    },
    serialize: function serialize$$1(mailtoComponents, options) {
        var components = mailtoComponents;
        var to = toArray(mailtoComponents.to);
        if (to) {
            for (var x = 0, xl = to.length; x < xl; ++x) {
                var toAddr = String(to[x]);
                var atIdx = toAddr.lastIndexOf("@");
                var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                var domain = toAddr.slice(atIdx + 1);
                //convert IDN via punycode
                try {
                    domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                } catch (e) {
                    components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                }
                to[x] = localPart + "@" + domain;
            }
            components.path = to.join(",");
        }
        var headers = mailtoComponents.headers = mailtoComponents.headers || {};
        if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
        if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
        var fields = [];
        for (var name in headers) {
            if (headers[name] !== O[name]) {
                fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            }
        }
        if (fields.length) {
            components.query = fields.join("&");
        }
        return components;
    }
};

var URN_PARSE = /^([^\:]+)\:(.*)/;
//RFC 2141
var handler$5 = {
    scheme: "urn",
    parse: function parse$$1(components, options) {
        var matches = components.path && components.path.match(URN_PARSE);
        var urnComponents = components;
        if (matches) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = matches[1].toLowerCase();
            var nss = matches[2];
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            urnComponents.nid = nid;
            urnComponents.nss = nss;
            urnComponents.path = undefined;
            if (schemeHandler) {
                urnComponents = schemeHandler.parse(urnComponents, options);
            }
        } else {
            urnComponents.error = urnComponents.error || "URN can not be parsed.";
        }
        return urnComponents;
    },
    serialize: function serialize$$1(urnComponents, options) {
        var scheme = options.scheme || urnComponents.scheme || "urn";
        var nid = urnComponents.nid;
        var urnScheme = scheme + ":" + (options.nid || nid);
        var schemeHandler = SCHEMES[urnScheme];
        if (schemeHandler) {
            urnComponents = schemeHandler.serialize(urnComponents, options);
        }
        var uriComponents = urnComponents;
        var nss = urnComponents.nss;
        uriComponents.path = (nid || options.nid) + ":" + nss;
        return uriComponents;
    }
};

var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
//RFC 4122
var handler$6 = {
    scheme: "urn:uuid",
    parse: function parse(urnComponents, options) {
        var uuidComponents = urnComponents;
        uuidComponents.uuid = uuidComponents.nss;
        uuidComponents.nss = undefined;
        if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) {
            uuidComponents.error = uuidComponents.error || "UUID is not valid.";
        }
        return uuidComponents;
    },
    serialize: function serialize(uuidComponents, options) {
        var urnComponents = uuidComponents;
        //normalize UUID
        urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
        return urnComponents;
    }
};

SCHEMES[handler.scheme] = handler;
SCHEMES[handler$1.scheme] = handler$1;
SCHEMES[handler$2.scheme] = handler$2;
SCHEMES[handler$3.scheme] = handler$3;
SCHEMES[handler$4.scheme] = handler$4;
SCHEMES[handler$5.scheme] = handler$5;
SCHEMES[handler$6.scheme] = handler$6;

exports.SCHEMES = SCHEMES;
exports.pctEncChar = pctEncChar;
exports.pctDecChars = pctDecChars;
exports.parse = parse;
exports.removeDotSegments = removeDotSegments;
exports.serialize = serialize;
exports.resolveComponents = resolveComponents;
exports.resolve = resolve;
exports.normalize = normalize;
exports.equal = equal;
exports.escapeComponent = escapeComponent;
exports.unescapeComponent = unescapeComponent;

Object.defineProperty(exports, '__esModule', { value: true });

})));

}(uri_all, uri_all.exports));

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
var ucs2length$1 = function ucs2length(str) {
  var length = 0
    , len = str.length
    , pos = 0
    , value;
  while (pos < len) {
    length++;
    value = str.charCodeAt(pos++);
    if (value >= 0xD800 && value <= 0xDBFF && pos < len) {
      // high surrogate, and there is a next character
      value = str.charCodeAt(pos);
      if ((value & 0xFC00) == 0xDC00) pos++; // low surrogate
    }
  }
  return length;
};

var util$8 = {
  copy: copy,
  checkDataType: checkDataType,
  checkDataTypes: checkDataTypes,
  coerceToTypes: coerceToTypes,
  toHash: toHash$1,
  getProperty: getProperty,
  escapeQuotes: escapeQuotes,
  equal: fastDeepEqual,
  ucs2length: ucs2length$1,
  varOccurences: varOccurences,
  varReplace: varReplace,
  schemaHasRules: schemaHasRules,
  schemaHasRulesExcept: schemaHasRulesExcept,
  schemaUnknownRules: schemaUnknownRules,
  toQuotedString: toQuotedString,
  getPathExpr: getPathExpr,
  getPath: getPath,
  getData: getData,
  unescapeFragment: unescapeFragment,
  unescapeJsonPointer: unescapeJsonPointer,
  escapeFragment: escapeFragment,
  escapeJsonPointer: escapeJsonPointer
};


function copy(o, to) {
  to = to || {};
  for (var key in o) to[key] = o[key];
  return to;
}


function checkDataType(dataType, data, strictNumbers, negate) {
  var EQUAL = negate ? ' !== ' : ' === '
    , AND = negate ? ' || ' : ' && '
    , OK = negate ? '!' : ''
    , NOT = negate ? '' : '!';
  switch (dataType) {
    case 'null': return data + EQUAL + 'null';
    case 'array': return OK + 'Array.isArray(' + data + ')';
    case 'object': return '(' + OK + data + AND +
                          'typeof ' + data + EQUAL + '"object"' + AND +
                          NOT + 'Array.isArray(' + data + '))';
    case 'integer': return '(typeof ' + data + EQUAL + '"number"' + AND +
                           NOT + '(' + data + ' % 1)' +
                           AND + data + EQUAL + data +
                           (strictNumbers ? (AND + OK + 'isFinite(' + data + ')') : '') + ')';
    case 'number': return '(typeof ' + data + EQUAL + '"' + dataType + '"' +
                          (strictNumbers ? (AND + OK + 'isFinite(' + data + ')') : '') + ')';
    default: return 'typeof ' + data + EQUAL + '"' + dataType + '"';
  }
}


function checkDataTypes(dataTypes, data, strictNumbers) {
  switch (dataTypes.length) {
    case 1: return checkDataType(dataTypes[0], data, strictNumbers, true);
    default:
      var code = '';
      var types = toHash$1(dataTypes);
      if (types.array && types.object) {
        code = types.null ? '(': '(!' + data + ' || ';
        code += 'typeof ' + data + ' !== "object")';
        delete types.null;
        delete types.array;
        delete types.object;
      }
      if (types.number) delete types.integer;
      for (var t in types)
        code += (code ? ' && ' : '' ) + checkDataType(t, data, strictNumbers, true);

      return code;
  }
}


var COERCE_TO_TYPES = toHash$1([ 'string', 'number', 'integer', 'boolean', 'null' ]);
function coerceToTypes(optionCoerceTypes, dataTypes) {
  if (Array.isArray(dataTypes)) {
    var types = [];
    for (var i=0; i<dataTypes.length; i++) {
      var t = dataTypes[i];
      if (COERCE_TO_TYPES[t]) types[types.length] = t;
      else if (optionCoerceTypes === 'array' && t === 'array') types[types.length] = t;
    }
    if (types.length) return types;
  } else if (COERCE_TO_TYPES[dataTypes]) {
    return [dataTypes];
  } else if (optionCoerceTypes === 'array' && dataTypes === 'array') {
    return ['array'];
  }
}


function toHash$1(arr) {
  var hash = {};
  for (var i=0; i<arr.length; i++) hash[arr[i]] = true;
  return hash;
}


var IDENTIFIER$1 = /^[a-z$_][a-z$_0-9]*$/i;
var SINGLE_QUOTE = /'|\\/g;
function getProperty(key) {
  return typeof key == 'number'
          ? '[' + key + ']'
          : IDENTIFIER$1.test(key)
            ? '.' + key
            : "['" + escapeQuotes(key) + "']";
}


function escapeQuotes(str) {
  return str.replace(SINGLE_QUOTE, '\\$&')
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/\f/g, '\\f')
            .replace(/\t/g, '\\t');
}


function varOccurences(str, dataVar) {
  dataVar += '[^0-9]';
  var matches = str.match(new RegExp(dataVar, 'g'));
  return matches ? matches.length : 0;
}


function varReplace(str, dataVar, expr) {
  dataVar += '([^0-9])';
  expr = expr.replace(/\$/g, '$$$$');
  return str.replace(new RegExp(dataVar, 'g'), expr + '$1');
}


function schemaHasRules(schema, rules) {
  if (typeof schema == 'boolean') return !schema;
  for (var key in schema) if (rules[key]) return true;
}


function schemaHasRulesExcept(schema, rules, exceptKeyword) {
  if (typeof schema == 'boolean') return !schema && exceptKeyword != 'not';
  for (var key in schema) if (key != exceptKeyword && rules[key]) return true;
}


function schemaUnknownRules(schema, rules) {
  if (typeof schema == 'boolean') return;
  for (var key in schema) if (!rules[key]) return key;
}


function toQuotedString(str) {
  return '\'' + escapeQuotes(str) + '\'';
}


function getPathExpr(currentPath, expr, jsonPointers, isNumber) {
  var path = jsonPointers // false by default
              ? '\'/\' + ' + expr + (isNumber ? '' : '.replace(/~/g, \'~0\').replace(/\\//g, \'~1\')')
              : (isNumber ? '\'[\' + ' + expr + ' + \']\'' : '\'[\\\'\' + ' + expr + ' + \'\\\']\'');
  return joinPaths(currentPath, path);
}


function getPath(currentPath, prop, jsonPointers) {
  var path = jsonPointers // false by default
              ? toQuotedString('/' + escapeJsonPointer(prop))
              : toQuotedString(getProperty(prop));
  return joinPaths(currentPath, path);
}


var JSON_POINTER$1 = /^\/(?:[^~]|~0|~1)*$/;
var RELATIVE_JSON_POINTER$1 = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function getData($data, lvl, paths) {
  var up, jsonPointer, data, matches;
  if ($data === '') return 'rootData';
  if ($data[0] == '/') {
    if (!JSON_POINTER$1.test($data)) throw new Error('Invalid JSON-pointer: ' + $data);
    jsonPointer = $data;
    data = 'rootData';
  } else {
    matches = $data.match(RELATIVE_JSON_POINTER$1);
    if (!matches) throw new Error('Invalid JSON-pointer: ' + $data);
    up = +matches[1];
    jsonPointer = matches[2];
    if (jsonPointer == '#') {
      if (up >= lvl) throw new Error('Cannot access property/index ' + up + ' levels up, current level is ' + lvl);
      return paths[lvl - up];
    }

    if (up > lvl) throw new Error('Cannot access data ' + up + ' levels up, current level is ' + lvl);
    data = 'data' + ((lvl - up) || '');
    if (!jsonPointer) return data;
  }

  var expr = data;
  var segments = jsonPointer.split('/');
  for (var i=0; i<segments.length; i++) {
    var segment = segments[i];
    if (segment) {
      data += getProperty(unescapeJsonPointer(segment));
      expr += ' && ' + data;
    }
  }
  return expr;
}


function joinPaths (a, b) {
  if (a == '""') return b;
  return (a + ' + ' + b).replace(/([^\\])' \+ '/g, '$1');
}


function unescapeFragment(str) {
  return unescapeJsonPointer(decodeURIComponent(str));
}


function escapeFragment(str) {
  return encodeURIComponent(escapeJsonPointer(str));
}


function escapeJsonPointer(str) {
  return str.replace(/~/g, '~0').replace(/\//g, '~1');
}


function unescapeJsonPointer(str) {
  return str.replace(/~1/g, '/').replace(/~0/g, '~');
}

var util$7 = util$8;

var schema_obj = SchemaObject$2;

function SchemaObject$2(obj) {
  util$7.copy(obj, this);
}

var jsonSchemaTraverse = {exports: {}};

var traverse$1 = jsonSchemaTraverse.exports = function (schema, opts, cb) {
  // Legacy support for v0.3.1 and earlier.
  if (typeof opts == 'function') {
    cb = opts;
    opts = {};
  }

  cb = opts.cb || cb;
  var pre = (typeof cb == 'function') ? cb : cb.pre || function() {};
  var post = cb.post || function() {};

  _traverse(opts, pre, post, schema, '', schema);
};


traverse$1.keywords = {
  additionalItems: true,
  items: true,
  contains: true,
  additionalProperties: true,
  propertyNames: true,
  not: true
};

traverse$1.arrayKeywords = {
  items: true,
  allOf: true,
  anyOf: true,
  oneOf: true
};

traverse$1.propsKeywords = {
  definitions: true,
  properties: true,
  patternProperties: true,
  dependencies: true
};

traverse$1.skipKeywords = {
  default: true,
  enum: true,
  const: true,
  required: true,
  maximum: true,
  minimum: true,
  exclusiveMaximum: true,
  exclusiveMinimum: true,
  multipleOf: true,
  maxLength: true,
  minLength: true,
  pattern: true,
  format: true,
  maxItems: true,
  minItems: true,
  uniqueItems: true,
  maxProperties: true,
  minProperties: true
};


function _traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
  if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
    pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    for (var key in schema) {
      var sch = schema[key];
      if (Array.isArray(sch)) {
        if (key in traverse$1.arrayKeywords) {
          for (var i=0; i<sch.length; i++)
            _traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
        }
      } else if (key in traverse$1.propsKeywords) {
        if (sch && typeof sch == 'object') {
          for (var prop in sch)
            _traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
        }
      } else if (key in traverse$1.keywords || (opts.allKeys && !(key in traverse$1.skipKeywords))) {
        _traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
      }
    }
    post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
  }
}


function escapeJsonPtr(str) {
  return str.replace(/~/g, '~0').replace(/\//g, '~1');
}

var URI$1 = uri_all.exports
  , equal$1 = fastDeepEqual
  , util$6 = util$8
  , SchemaObject$1 = schema_obj
  , traverse = jsonSchemaTraverse.exports;

var resolve_1 = resolve$3;

resolve$3.normalizeId = normalizeId;
resolve$3.fullPath = getFullPath;
resolve$3.url = resolveUrl;
resolve$3.ids = resolveIds;
resolve$3.inlineRef = inlineRef;
resolve$3.schema = resolveSchema;

/**
 * [resolve and compile the references ($ref)]
 * @this   Ajv
 * @param  {Function} compile reference to schema compilation funciton (localCompile)
 * @param  {Object} root object with information about the root schema for the current schema
 * @param  {String} ref reference to resolve
 * @return {Object|Function} schema object (if the schema can be inlined) or validation function
 */
function resolve$3(compile, root, ref) {
  /* jshint validthis: true */
  var refVal = this._refs[ref];
  if (typeof refVal == 'string') {
    if (this._refs[refVal]) refVal = this._refs[refVal];
    else return resolve$3.call(this, compile, root, refVal);
  }

  refVal = refVal || this._schemas[ref];
  if (refVal instanceof SchemaObject$1) {
    return inlineRef(refVal.schema, this._opts.inlineRefs)
            ? refVal.schema
            : refVal.validate || this._compile(refVal);
  }

  var res = resolveSchema.call(this, root, ref);
  var schema, v, baseId;
  if (res) {
    schema = res.schema;
    root = res.root;
    baseId = res.baseId;
  }

  if (schema instanceof SchemaObject$1) {
    v = schema.validate || compile.call(this, schema.schema, root, undefined, baseId);
  } else if (schema !== undefined) {
    v = inlineRef(schema, this._opts.inlineRefs)
        ? schema
        : compile.call(this, schema, root, undefined, baseId);
  }

  return v;
}


/**
 * Resolve schema, its root and baseId
 * @this Ajv
 * @param  {Object} root root object with properties schema, refVal, refs
 * @param  {String} ref  reference to resolve
 * @return {Object} object with properties schema, root, baseId
 */
function resolveSchema(root, ref) {
  /* jshint validthis: true */
  var p = URI$1.parse(ref)
    , refPath = _getFullPath(p)
    , baseId = getFullPath(this._getId(root.schema));
  if (Object.keys(root.schema).length === 0 || refPath !== baseId) {
    var id = normalizeId(refPath);
    var refVal = this._refs[id];
    if (typeof refVal == 'string') {
      return resolveRecursive.call(this, root, refVal, p);
    } else if (refVal instanceof SchemaObject$1) {
      if (!refVal.validate) this._compile(refVal);
      root = refVal;
    } else {
      refVal = this._schemas[id];
      if (refVal instanceof SchemaObject$1) {
        if (!refVal.validate) this._compile(refVal);
        if (id == normalizeId(ref))
          return { schema: refVal, root: root, baseId: baseId };
        root = refVal;
      } else {
        return;
      }
    }
    if (!root.schema) return;
    baseId = getFullPath(this._getId(root.schema));
  }
  return getJsonPointer.call(this, p, baseId, root.schema, root);
}


/* @this Ajv */
function resolveRecursive(root, ref, parsedRef) {
  /* jshint validthis: true */
  var res = resolveSchema.call(this, root, ref);
  if (res) {
    var schema = res.schema;
    var baseId = res.baseId;
    root = res.root;
    var id = this._getId(schema);
    if (id) baseId = resolveUrl(baseId, id);
    return getJsonPointer.call(this, parsedRef, baseId, schema, root);
  }
}


var PREVENT_SCOPE_CHANGE = util$6.toHash(['properties', 'patternProperties', 'enum', 'dependencies', 'definitions']);
/* @this Ajv */
function getJsonPointer(parsedRef, baseId, schema, root) {
  /* jshint validthis: true */
  parsedRef.fragment = parsedRef.fragment || '';
  if (parsedRef.fragment.slice(0,1) != '/') return;
  var parts = parsedRef.fragment.split('/');

  for (var i = 1; i < parts.length; i++) {
    var part = parts[i];
    if (part) {
      part = util$6.unescapeFragment(part);
      schema = schema[part];
      if (schema === undefined) break;
      var id;
      if (!PREVENT_SCOPE_CHANGE[part]) {
        id = this._getId(schema);
        if (id) baseId = resolveUrl(baseId, id);
        if (schema.$ref) {
          var $ref = resolveUrl(baseId, schema.$ref);
          var res = resolveSchema.call(this, root, $ref);
          if (res) {
            schema = res.schema;
            root = res.root;
            baseId = res.baseId;
          }
        }
      }
    }
  }
  if (schema !== undefined && schema !== root.schema)
    return { schema: schema, root: root, baseId: baseId };
}


var SIMPLE_INLINED = util$6.toHash([
  'type', 'format', 'pattern',
  'maxLength', 'minLength',
  'maxProperties', 'minProperties',
  'maxItems', 'minItems',
  'maximum', 'minimum',
  'uniqueItems', 'multipleOf',
  'required', 'enum'
]);
function inlineRef(schema, limit) {
  if (limit === false) return false;
  if (limit === undefined || limit === true) return checkNoRef(schema);
  else if (limit) return countKeys(schema) <= limit;
}


function checkNoRef(schema) {
  var item;
  if (Array.isArray(schema)) {
    for (var i=0; i<schema.length; i++) {
      item = schema[i];
      if (typeof item == 'object' && !checkNoRef(item)) return false;
    }
  } else {
    for (var key in schema) {
      if (key == '$ref') return false;
      item = schema[key];
      if (typeof item == 'object' && !checkNoRef(item)) return false;
    }
  }
  return true;
}


function countKeys(schema) {
  var count = 0, item;
  if (Array.isArray(schema)) {
    for (var i=0; i<schema.length; i++) {
      item = schema[i];
      if (typeof item == 'object') count += countKeys(item);
      if (count == Infinity) return Infinity;
    }
  } else {
    for (var key in schema) {
      if (key == '$ref') return Infinity;
      if (SIMPLE_INLINED[key]) {
        count++;
      } else {
        item = schema[key];
        if (typeof item == 'object') count += countKeys(item) + 1;
        if (count == Infinity) return Infinity;
      }
    }
  }
  return count;
}


function getFullPath(id, normalize) {
  if (normalize !== false) id = normalizeId(id);
  var p = URI$1.parse(id);
  return _getFullPath(p);
}


function _getFullPath(p) {
  return URI$1.serialize(p).split('#')[0] + '#';
}


var TRAILING_SLASH_HASH = /#\/?$/;
function normalizeId(id) {
  return id ? id.replace(TRAILING_SLASH_HASH, '') : '';
}


function resolveUrl(baseId, id) {
  id = normalizeId(id);
  return URI$1.resolve(baseId, id);
}


/* @this Ajv */
function resolveIds(schema) {
  var schemaId = normalizeId(this._getId(schema));
  var baseIds = {'': schemaId};
  var fullPaths = {'': getFullPath(schemaId, false)};
  var localRefs = {};
  var self = this;

  traverse(schema, {allKeys: true}, function(sch, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (jsonPtr === '') return;
    var id = self._getId(sch);
    var baseId = baseIds[parentJsonPtr];
    var fullPath = fullPaths[parentJsonPtr] + '/' + parentKeyword;
    if (keyIndex !== undefined)
      fullPath += '/' + (typeof keyIndex == 'number' ? keyIndex : util$6.escapeFragment(keyIndex));

    if (typeof id == 'string') {
      id = baseId = normalizeId(baseId ? URI$1.resolve(baseId, id) : id);

      var refVal = self._refs[id];
      if (typeof refVal == 'string') refVal = self._refs[refVal];
      if (refVal && refVal.schema) {
        if (!equal$1(sch, refVal.schema))
          throw new Error('id "' + id + '" resolves to more than one schema');
      } else if (id != normalizeId(fullPath)) {
        if (id[0] == '#') {
          if (localRefs[id] && !equal$1(sch, localRefs[id]))
            throw new Error('id "' + id + '" resolves to more than one schema');
          localRefs[id] = sch;
        } else {
          self._refs[id] = fullPath;
        }
      }
    }
    baseIds[jsonPtr] = baseId;
    fullPaths[jsonPtr] = fullPath;
  });

  return localRefs;
}

var resolve$2 = resolve_1;

var error_classes = {
  Validation: errorSubclass(ValidationError$1),
  MissingRef: errorSubclass(MissingRefError$1)
};


function ValidationError$1(errors) {
  this.message = 'validation failed';
  this.errors = errors;
  this.ajv = this.validation = true;
}


MissingRefError$1.message = function (baseId, ref) {
  return 'can\'t resolve reference ' + ref + ' from id ' + baseId;
};


function MissingRefError$1(baseId, ref, message) {
  this.message = message || MissingRefError$1.message(baseId, ref);
  this.missingRef = resolve$2.url(baseId, ref);
  this.missingSchema = resolve$2.normalizeId(resolve$2.fullPath(this.missingRef));
}


function errorSubclass(Subclass) {
  Subclass.prototype = Object.create(Error.prototype);
  Subclass.prototype.constructor = Subclass;
  return Subclass;
}

var validate$2 = function generate_validate(it, $keyword, $ruleType) {
  var out = '';
  var $async = it.schema.$async === true,
    $refKeywords = it.util.schemaHasRulesExcept(it.schema, it.RULES.all, '$ref'),
    $id = it.self._getId(it.schema);
  if (it.opts.strictKeywords) {
    var $unknownKwd = it.util.schemaUnknownRules(it.schema, it.RULES.keywords);
    if ($unknownKwd) {
      var $keywordsMsg = 'unknown keyword: ' + $unknownKwd;
      if (it.opts.strictKeywords === 'log') it.logger.warn($keywordsMsg);
      else throw new Error($keywordsMsg);
    }
  }
  if (it.isTop) {
    out += ' var validate = ';
    if ($async) {
      it.async = true;
      out += 'async ';
    }
    out += 'function(data, dataPath, parentData, parentDataProperty, rootData) { \'use strict\'; ';
    if ($id && (it.opts.sourceCode || it.opts.processCode)) {
      out += ' ' + ('/\*# sourceURL=' + $id + ' */') + ' ';
    }
  }
  if (typeof it.schema == 'boolean' || !($refKeywords || it.schema.$ref)) {
    var $keyword = 'false schema';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    if (it.schema === false) {
      if (it.isTop) {
        $breakOnError = true;
      } else {
        out += ' var ' + ($valid) + ' = false; ';
      }
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = ''; /* istanbul ignore else */
      if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || 'false schema') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
        if (it.opts.messages !== false) {
          out += ' , message: \'boolean schema is false\' ';
        }
        if (it.opts.verbose) {
          out += ' , schema: false , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
        }
        out += ' } ';
      } else {
        out += ' {} ';
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */
        if (it.async) {
          out += ' throw new ValidationError([' + (__err) + ']); ';
        } else {
          out += ' validate.errors = [' + (__err) + ']; return false; ';
        }
      } else {
        out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
      }
    } else {
      if (it.isTop) {
        if ($async) {
          out += ' return data; ';
        } else {
          out += ' validate.errors = null; return true; ';
        }
      } else {
        out += ' var ' + ($valid) + ' = true; ';
      }
    }
    if (it.isTop) {
      out += ' }; return validate; ';
    }
    return out;
  }
  if (it.isTop) {
    var $top = it.isTop,
      $lvl = it.level = 0,
      $dataLvl = it.dataLevel = 0,
      $data = 'data';
    it.rootId = it.resolve.fullPath(it.self._getId(it.root.schema));
    it.baseId = it.baseId || it.rootId;
    delete it.isTop;
    it.dataPathArr = [""];
    if (it.schema.default !== undefined && it.opts.useDefaults && it.opts.strictDefaults) {
      var $defaultMsg = 'default is ignored in the schema root';
      if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
      else throw new Error($defaultMsg);
    }
    out += ' var vErrors = null; ';
    out += ' var errors = 0;     ';
    out += ' if (rootData === undefined) rootData = data; ';
  } else {
    var $lvl = it.level,
      $dataLvl = it.dataLevel,
      $data = 'data' + ($dataLvl || '');
    if ($id) it.baseId = it.resolve.url(it.baseId, $id);
    if ($async && !it.async) throw new Error('async schema in sync schema');
    out += ' var errs_' + ($lvl) + ' = errors;';
  }
  var $valid = 'valid' + $lvl,
    $breakOnError = !it.opts.allErrors,
    $closingBraces1 = '',
    $closingBraces2 = '';
  var $errorKeyword;
  var $typeSchema = it.schema.type,
    $typeIsArray = Array.isArray($typeSchema);
  if ($typeSchema && it.opts.nullable && it.schema.nullable === true) {
    if ($typeIsArray) {
      if ($typeSchema.indexOf('null') == -1) $typeSchema = $typeSchema.concat('null');
    } else if ($typeSchema != 'null') {
      $typeSchema = [$typeSchema, 'null'];
      $typeIsArray = true;
    }
  }
  if ($typeIsArray && $typeSchema.length == 1) {
    $typeSchema = $typeSchema[0];
    $typeIsArray = false;
  }
  if (it.schema.$ref && $refKeywords) {
    if (it.opts.extendRefs == 'fail') {
      throw new Error('$ref: validation keywords used in schema at path "' + it.errSchemaPath + '" (see option extendRefs)');
    } else if (it.opts.extendRefs !== true) {
      $refKeywords = false;
      it.logger.warn('$ref: keywords ignored in schema at path "' + it.errSchemaPath + '"');
    }
  }
  if (it.schema.$comment && it.opts.$comment) {
    out += ' ' + (it.RULES.all.$comment.code(it, '$comment'));
  }
  if ($typeSchema) {
    if (it.opts.coerceTypes) {
      var $coerceToTypes = it.util.coerceToTypes(it.opts.coerceTypes, $typeSchema);
    }
    var $rulesGroup = it.RULES.types[$typeSchema];
    if ($coerceToTypes || $typeIsArray || $rulesGroup === true || ($rulesGroup && !$shouldUseGroup($rulesGroup))) {
      var $schemaPath = it.schemaPath + '.type',
        $errSchemaPath = it.errSchemaPath + '/type';
      var $schemaPath = it.schemaPath + '.type',
        $errSchemaPath = it.errSchemaPath + '/type',
        $method = $typeIsArray ? 'checkDataTypes' : 'checkDataType';
      out += ' if (' + (it.util[$method]($typeSchema, $data, it.opts.strictNumbers, true)) + ') { ';
      if ($coerceToTypes) {
        var $dataType = 'dataType' + $lvl,
          $coerced = 'coerced' + $lvl;
        out += ' var ' + ($dataType) + ' = typeof ' + ($data) + '; var ' + ($coerced) + ' = undefined; ';
        if (it.opts.coerceTypes == 'array') {
          out += ' if (' + ($dataType) + ' == \'object\' && Array.isArray(' + ($data) + ') && ' + ($data) + '.length == 1) { ' + ($data) + ' = ' + ($data) + '[0]; ' + ($dataType) + ' = typeof ' + ($data) + '; if (' + (it.util.checkDataType(it.schema.type, $data, it.opts.strictNumbers)) + ') ' + ($coerced) + ' = ' + ($data) + '; } ';
        }
        out += ' if (' + ($coerced) + ' !== undefined) ; ';
        var arr1 = $coerceToTypes;
        if (arr1) {
          var $type, $i = -1,
            l1 = arr1.length - 1;
          while ($i < l1) {
            $type = arr1[$i += 1];
            if ($type == 'string') {
              out += ' else if (' + ($dataType) + ' == \'number\' || ' + ($dataType) + ' == \'boolean\') ' + ($coerced) + ' = \'\' + ' + ($data) + '; else if (' + ($data) + ' === null) ' + ($coerced) + ' = \'\'; ';
            } else if ($type == 'number' || $type == 'integer') {
              out += ' else if (' + ($dataType) + ' == \'boolean\' || ' + ($data) + ' === null || (' + ($dataType) + ' == \'string\' && ' + ($data) + ' && ' + ($data) + ' == +' + ($data) + ' ';
              if ($type == 'integer') {
                out += ' && !(' + ($data) + ' % 1)';
              }
              out += ')) ' + ($coerced) + ' = +' + ($data) + '; ';
            } else if ($type == 'boolean') {
              out += ' else if (' + ($data) + ' === \'false\' || ' + ($data) + ' === 0 || ' + ($data) + ' === null) ' + ($coerced) + ' = false; else if (' + ($data) + ' === \'true\' || ' + ($data) + ' === 1) ' + ($coerced) + ' = true; ';
            } else if ($type == 'null') {
              out += ' else if (' + ($data) + ' === \'\' || ' + ($data) + ' === 0 || ' + ($data) + ' === false) ' + ($coerced) + ' = null; ';
            } else if (it.opts.coerceTypes == 'array' && $type == 'array') {
              out += ' else if (' + ($dataType) + ' == \'string\' || ' + ($dataType) + ' == \'number\' || ' + ($dataType) + ' == \'boolean\' || ' + ($data) + ' == null) ' + ($coerced) + ' = [' + ($data) + ']; ';
            }
          }
        }
        out += ' else {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { type: \'';
          if ($typeIsArray) {
            out += '' + ($typeSchema.join(","));
          } else {
            out += '' + ($typeSchema);
          }
          out += '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'should be ';
            if ($typeIsArray) {
              out += '' + ($typeSchema.join(","));
            } else {
              out += '' + ($typeSchema);
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        out += ' } if (' + ($coerced) + ' !== undefined) {  ';
        var $parentData = $dataLvl ? 'data' + (($dataLvl - 1) || '') : 'parentData',
          $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
        out += ' ' + ($data) + ' = ' + ($coerced) + '; ';
        if (!$dataLvl) {
          out += 'if (' + ($parentData) + ' !== undefined)';
        }
        out += ' ' + ($parentData) + '[' + ($parentDataProperty) + '] = ' + ($coerced) + '; } ';
      } else {
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { type: \'';
          if ($typeIsArray) {
            out += '' + ($typeSchema.join(","));
          } else {
            out += '' + ($typeSchema);
          }
          out += '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'should be ';
            if ($typeIsArray) {
              out += '' + ($typeSchema.join(","));
            } else {
              out += '' + ($typeSchema);
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
      }
      out += ' } ';
    }
  }
  if (it.schema.$ref && !$refKeywords) {
    out += ' ' + (it.RULES.all.$ref.code(it, '$ref')) + ' ';
    if ($breakOnError) {
      out += ' } if (errors === ';
      if ($top) {
        out += '0';
      } else {
        out += 'errs_' + ($lvl);
      }
      out += ') { ';
      $closingBraces2 += '}';
    }
  } else {
    var arr2 = it.RULES;
    if (arr2) {
      var $rulesGroup, i2 = -1,
        l2 = arr2.length - 1;
      while (i2 < l2) {
        $rulesGroup = arr2[i2 += 1];
        if ($shouldUseGroup($rulesGroup)) {
          if ($rulesGroup.type) {
            out += ' if (' + (it.util.checkDataType($rulesGroup.type, $data, it.opts.strictNumbers)) + ') { ';
          }
          if (it.opts.useDefaults) {
            if ($rulesGroup.type == 'object' && it.schema.properties) {
              var $schema = it.schema.properties,
                $schemaKeys = Object.keys($schema);
              var arr3 = $schemaKeys;
              if (arr3) {
                var $propertyKey, i3 = -1,
                  l3 = arr3.length - 1;
                while (i3 < l3) {
                  $propertyKey = arr3[i3 += 1];
                  var $sch = $schema[$propertyKey];
                  if ($sch.default !== undefined) {
                    var $passData = $data + it.util.getProperty($propertyKey);
                    if (it.compositeRule) {
                      if (it.opts.strictDefaults) {
                        var $defaultMsg = 'default is ignored for: ' + $passData;
                        if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
                        else throw new Error($defaultMsg);
                      }
                    } else {
                      out += ' if (' + ($passData) + ' === undefined ';
                      if (it.opts.useDefaults == 'empty') {
                        out += ' || ' + ($passData) + ' === null || ' + ($passData) + ' === \'\' ';
                      }
                      out += ' ) ' + ($passData) + ' = ';
                      if (it.opts.useDefaults == 'shared') {
                        out += ' ' + (it.useDefault($sch.default)) + ' ';
                      } else {
                        out += ' ' + (JSON.stringify($sch.default)) + ' ';
                      }
                      out += '; ';
                    }
                  }
                }
              }
            } else if ($rulesGroup.type == 'array' && Array.isArray(it.schema.items)) {
              var arr4 = it.schema.items;
              if (arr4) {
                var $sch, $i = -1,
                  l4 = arr4.length - 1;
                while ($i < l4) {
                  $sch = arr4[$i += 1];
                  if ($sch.default !== undefined) {
                    var $passData = $data + '[' + $i + ']';
                    if (it.compositeRule) {
                      if (it.opts.strictDefaults) {
                        var $defaultMsg = 'default is ignored for: ' + $passData;
                        if (it.opts.strictDefaults === 'log') it.logger.warn($defaultMsg);
                        else throw new Error($defaultMsg);
                      }
                    } else {
                      out += ' if (' + ($passData) + ' === undefined ';
                      if (it.opts.useDefaults == 'empty') {
                        out += ' || ' + ($passData) + ' === null || ' + ($passData) + ' === \'\' ';
                      }
                      out += ' ) ' + ($passData) + ' = ';
                      if (it.opts.useDefaults == 'shared') {
                        out += ' ' + (it.useDefault($sch.default)) + ' ';
                      } else {
                        out += ' ' + (JSON.stringify($sch.default)) + ' ';
                      }
                      out += '; ';
                    }
                  }
                }
              }
            }
          }
          var arr5 = $rulesGroup.rules;
          if (arr5) {
            var $rule, i5 = -1,
              l5 = arr5.length - 1;
            while (i5 < l5) {
              $rule = arr5[i5 += 1];
              if ($shouldUseRule($rule)) {
                var $code = $rule.code(it, $rule.keyword, $rulesGroup.type);
                if ($code) {
                  out += ' ' + ($code) + ' ';
                  if ($breakOnError) {
                    $closingBraces1 += '}';
                  }
                }
              }
            }
          }
          if ($breakOnError) {
            out += ' ' + ($closingBraces1) + ' ';
            $closingBraces1 = '';
          }
          if ($rulesGroup.type) {
            out += ' } ';
            if ($typeSchema && $typeSchema === $rulesGroup.type && !$coerceToTypes) {
              out += ' else { ';
              var $schemaPath = it.schemaPath + '.type',
                $errSchemaPath = it.errSchemaPath + '/type';
              var $$outStack = $$outStack || [];
              $$outStack.push(out);
              out = ''; /* istanbul ignore else */
              if (it.createErrors !== false) {
                out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { type: \'';
                if ($typeIsArray) {
                  out += '' + ($typeSchema.join(","));
                } else {
                  out += '' + ($typeSchema);
                }
                out += '\' } ';
                if (it.opts.messages !== false) {
                  out += ' , message: \'should be ';
                  if ($typeIsArray) {
                    out += '' + ($typeSchema.join(","));
                  } else {
                    out += '' + ($typeSchema);
                  }
                  out += '\' ';
                }
                if (it.opts.verbose) {
                  out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
                }
                out += ' } ';
              } else {
                out += ' {} ';
              }
              var __err = out;
              out = $$outStack.pop();
              if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */
                if (it.async) {
                  out += ' throw new ValidationError([' + (__err) + ']); ';
                } else {
                  out += ' validate.errors = [' + (__err) + ']; return false; ';
                }
              } else {
                out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
              }
              out += ' } ';
            }
          }
          if ($breakOnError) {
            out += ' if (errors === ';
            if ($top) {
              out += '0';
            } else {
              out += 'errs_' + ($lvl);
            }
            out += ') { ';
            $closingBraces2 += '}';
          }
        }
      }
    }
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces2) + ' ';
  }
  if ($top) {
    if ($async) {
      out += ' if (errors === 0) return data;           ';
      out += ' else throw new ValidationError(vErrors); ';
    } else {
      out += ' validate.errors = vErrors; ';
      out += ' return errors === 0;       ';
    }
    out += ' }; return validate;';
  } else {
    out += ' var ' + ($valid) + ' = errors === errs_' + ($lvl) + ';';
  }

  function $shouldUseGroup($rulesGroup) {
    var rules = $rulesGroup.rules;
    for (var i = 0; i < rules.length; i++)
      if ($shouldUseRule(rules[i])) return true;
  }

  function $shouldUseRule($rule) {
    return it.schema[$rule.keyword] !== undefined || ($rule.implements && $ruleImplementsSomeKeyword($rule));
  }

  function $ruleImplementsSomeKeyword($rule) {
    var impl = $rule.implements;
    for (var i = 0; i < impl.length; i++)
      if (it.schema[impl[i]] !== undefined) return true;
  }
  return out;
};

var resolve$1 = resolve_1
  , util$5 = util$8
  , errorClasses$1 = error_classes
  , stableStringify$1 = fastJsonStableStringify;

var validateGenerator = validate$2;

/**
 * Functions below are used inside compiled validations function
 */

var ucs2length = util$5.ucs2length;
var equal = fastDeepEqual;

// this error is thrown by async schemas to return validation errors via exception
var ValidationError = errorClasses$1.Validation;

var compile_1 = compile$1;


/**
 * Compiles schema to validation function
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Object} root object with information about the root schema for this schema
 * @param  {Object} localRefs the hash of local references inside the schema (created by resolve.id), used for inline resolution
 * @param  {String} baseId base ID for IDs in the schema
 * @return {Function} validation function
 */
function compile$1(schema, root, localRefs, baseId) {
  /* jshint validthis: true, evil: true */
  /* eslint no-shadow: 0 */
  var self = this
    , opts = this._opts
    , refVal = [ undefined ]
    , refs = {}
    , patterns = []
    , patternsHash = {}
    , defaults = []
    , defaultsHash = {}
    , customRules = [];

  root = root || { schema: schema, refVal: refVal, refs: refs };

  var c = checkCompiling.call(this, schema, root, baseId);
  var compilation = this._compilations[c.index];
  if (c.compiling) return (compilation.callValidate = callValidate);

  var formats = this._formats;
  var RULES = this.RULES;

  try {
    var v = localCompile(schema, root, localRefs, baseId);
    compilation.validate = v;
    var cv = compilation.callValidate;
    if (cv) {
      cv.schema = v.schema;
      cv.errors = null;
      cv.refs = v.refs;
      cv.refVal = v.refVal;
      cv.root = v.root;
      cv.$async = v.$async;
      if (opts.sourceCode) cv.source = v.source;
    }
    return v;
  } finally {
    endCompiling.call(this, schema, root, baseId);
  }

  /* @this   {*} - custom context, see passContext option */
  function callValidate() {
    /* jshint validthis: true */
    var validate = compilation.validate;
    var result = validate.apply(this, arguments);
    callValidate.errors = validate.errors;
    return result;
  }

  function localCompile(_schema, _root, localRefs, baseId) {
    var isRoot = !_root || (_root && _root.schema == _schema);
    if (_root.schema != root.schema)
      return compile$1.call(self, _schema, _root, localRefs, baseId);

    var $async = _schema.$async === true;

    var sourceCode = validateGenerator({
      isTop: true,
      schema: _schema,
      isRoot: isRoot,
      baseId: baseId,
      root: _root,
      schemaPath: '',
      errSchemaPath: '#',
      errorPath: '""',
      MissingRefError: errorClasses$1.MissingRef,
      RULES: RULES,
      validate: validateGenerator,
      util: util$5,
      resolve: resolve$1,
      resolveRef: resolveRef,
      usePattern: usePattern,
      useDefault: useDefault,
      useCustomRule: useCustomRule,
      opts: opts,
      formats: formats,
      logger: self.logger,
      self: self
    });

    sourceCode = vars(refVal, refValCode) + vars(patterns, patternCode)
                   + vars(defaults, defaultCode) + vars(customRules, customRuleCode$1)
                   + sourceCode;

    if (opts.processCode) sourceCode = opts.processCode(sourceCode, _schema);
    // console.log('\n\n\n *** \n', JSON.stringify(sourceCode));
    var validate;
    try {
      var makeValidate = new Function(
        'self',
        'RULES',
        'formats',
        'root',
        'refVal',
        'defaults',
        'customRules',
        'equal',
        'ucs2length',
        'ValidationError',
        sourceCode
      );

      validate = makeValidate(
        self,
        RULES,
        formats,
        root,
        refVal,
        defaults,
        customRules,
        equal,
        ucs2length,
        ValidationError
      );

      refVal[0] = validate;
    } catch(e) {
      self.logger.error('Error compiling schema, function code:', sourceCode);
      throw e;
    }

    validate.schema = _schema;
    validate.errors = null;
    validate.refs = refs;
    validate.refVal = refVal;
    validate.root = isRoot ? validate : _root;
    if ($async) validate.$async = true;
    if (opts.sourceCode === true) {
      validate.source = {
        code: sourceCode,
        patterns: patterns,
        defaults: defaults
      };
    }

    return validate;
  }

  function resolveRef(baseId, ref, isRoot) {
    ref = resolve$1.url(baseId, ref);
    var refIndex = refs[ref];
    var _refVal, refCode;
    if (refIndex !== undefined) {
      _refVal = refVal[refIndex];
      refCode = 'refVal[' + refIndex + ']';
      return resolvedRef(_refVal, refCode);
    }
    if (!isRoot && root.refs) {
      var rootRefId = root.refs[ref];
      if (rootRefId !== undefined) {
        _refVal = root.refVal[rootRefId];
        refCode = addLocalRef(ref, _refVal);
        return resolvedRef(_refVal, refCode);
      }
    }

    refCode = addLocalRef(ref);
    var v = resolve$1.call(self, localCompile, root, ref);
    if (v === undefined) {
      var localSchema = localRefs && localRefs[ref];
      if (localSchema) {
        v = resolve$1.inlineRef(localSchema, opts.inlineRefs)
            ? localSchema
            : compile$1.call(self, localSchema, root, localRefs, baseId);
      }
    }

    if (v === undefined) {
      removeLocalRef(ref);
    } else {
      replaceLocalRef(ref, v);
      return resolvedRef(v, refCode);
    }
  }

  function addLocalRef(ref, v) {
    var refId = refVal.length;
    refVal[refId] = v;
    refs[ref] = refId;
    return 'refVal' + refId;
  }

  function removeLocalRef(ref) {
    delete refs[ref];
  }

  function replaceLocalRef(ref, v) {
    var refId = refs[ref];
    refVal[refId] = v;
  }

  function resolvedRef(refVal, code) {
    return typeof refVal == 'object' || typeof refVal == 'boolean'
            ? { code: code, schema: refVal, inline: true }
            : { code: code, $async: refVal && !!refVal.$async };
  }

  function usePattern(regexStr) {
    var index = patternsHash[regexStr];
    if (index === undefined) {
      index = patternsHash[regexStr] = patterns.length;
      patterns[index] = regexStr;
    }
    return 'pattern' + index;
  }

  function useDefault(value) {
    switch (typeof value) {
      case 'boolean':
      case 'number':
        return '' + value;
      case 'string':
        return util$5.toQuotedString(value);
      case 'object':
        if (value === null) return 'null';
        var valueStr = stableStringify$1(value);
        var index = defaultsHash[valueStr];
        if (index === undefined) {
          index = defaultsHash[valueStr] = defaults.length;
          defaults[index] = value;
        }
        return 'default' + index;
    }
  }

  function useCustomRule(rule, schema, parentSchema, it) {
    if (self._opts.validateSchema !== false) {
      var deps = rule.definition.dependencies;
      if (deps && !deps.every(function(keyword) {
        return Object.prototype.hasOwnProperty.call(parentSchema, keyword);
      }))
        throw new Error('parent schema must have all required keywords: ' + deps.join(','));

      var validateSchema = rule.definition.validateSchema;
      if (validateSchema) {
        var valid = validateSchema(schema);
        if (!valid) {
          var message = 'keyword schema is invalid: ' + self.errorsText(validateSchema.errors);
          if (self._opts.validateSchema == 'log') self.logger.error(message);
          else throw new Error(message);
        }
      }
    }

    var compile = rule.definition.compile
      , inline = rule.definition.inline
      , macro = rule.definition.macro;

    var validate;
    if (compile) {
      validate = compile.call(self, schema, parentSchema, it);
    } else if (macro) {
      validate = macro.call(self, schema, parentSchema, it);
      if (opts.validateSchema !== false) self.validateSchema(validate, true);
    } else if (inline) {
      validate = inline.call(self, it, rule.keyword, schema, parentSchema);
    } else {
      validate = rule.definition.validate;
      if (!validate) return;
    }

    if (validate === undefined)
      throw new Error('custom keyword "' + rule.keyword + '"failed to compile');

    var index = customRules.length;
    customRules[index] = validate;

    return {
      code: 'customRule' + index,
      validate: validate
    };
  }
}


/**
 * Checks if the schema is currently compiled
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Object} object with properties "index" (compilation index) and "compiling" (boolean)
 */
function checkCompiling(schema, root, baseId) {
  /* jshint validthis: true */
  var index = compIndex.call(this, schema, root, baseId);
  if (index >= 0) return { index: index, compiling: true };
  index = this._compilations.length;
  this._compilations[index] = {
    schema: schema,
    root: root,
    baseId: baseId
  };
  return { index: index, compiling: false };
}


/**
 * Removes the schema from the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 */
function endCompiling(schema, root, baseId) {
  /* jshint validthis: true */
  var i = compIndex.call(this, schema, root, baseId);
  if (i >= 0) this._compilations.splice(i, 1);
}


/**
 * Index of schema compilation in the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Integer} compilation index
 */
function compIndex(schema, root, baseId) {
  /* jshint validthis: true */
  for (var i=0; i<this._compilations.length; i++) {
    var c = this._compilations[i];
    if (c.schema == schema && c.root == root && c.baseId == baseId) return i;
  }
  return -1;
}


function patternCode(i, patterns) {
  return 'var pattern' + i + ' = new RegExp(' + util$5.toQuotedString(patterns[i]) + ');';
}


function defaultCode(i) {
  return 'var default' + i + ' = defaults[' + i + '];';
}


function refValCode(i, refVal) {
  return refVal[i] === undefined ? '' : 'var refVal' + i + ' = refVal[' + i + '];';
}


function customRuleCode$1(i) {
  return 'var customRule' + i + ' = customRules[' + i + '];';
}


function vars(arr, statement) {
  if (!arr.length) return '';
  var code = '';
  for (var i=0; i<arr.length; i++)
    code += statement(i, arr);
  return code;
}

var cache = {exports: {}};

var Cache$1 = cache.exports = function Cache() {
  this._cache = {};
};


Cache$1.prototype.put = function Cache_put(key, value) {
  this._cache[key] = value;
};


Cache$1.prototype.get = function Cache_get(key) {
  return this._cache[key];
};


Cache$1.prototype.del = function Cache_del(key) {
  delete this._cache[key];
};


Cache$1.prototype.clear = function Cache_clear() {
  this._cache = {};
};

var util$4 = util$8;

var DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
var DAYS = [0,31,28,31,30,31,30,31,31,30,31,30,31];
var TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
var HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
var URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
var URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
// uri-template: https://tools.ietf.org/html/rfc6570
var URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
// For the source: https://gist.github.com/dperini/729294
// For test cases: https://mathiasbynens.be/demo/url-regex
// @todo Delete current URL in favour of the commented out URL rule when this issue is fixed https://github.com/eslint/eslint/issues/7983.
// var URL = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu;
var URL$1 = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i;
var UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
var JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
var JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
var RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;


var formats_1 = formats$1;

function formats$1(mode) {
  mode = mode == 'full' ? 'full' : 'fast';
  return util$4.copy(formats$1[mode]);
}


formats$1.fast = {
  // date: http://tools.ietf.org/html/rfc3339#section-5.6
  date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
  // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
  time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
  'date-time': /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
  // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
  uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
  'uri-reference': /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
  'uri-template': URITEMPLATE,
  url: URL$1,
  // email (sources from jsen validator):
  // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
  // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'willful violation')
  email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
  hostname: HOSTNAME,
  // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
  ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
  // optimized http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
  ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
  regex: regex,
  // uuid: http://tools.ietf.org/html/rfc4122
  uuid: UUID,
  // JSON-pointer: https://tools.ietf.org/html/rfc6901
  // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
  'json-pointer': JSON_POINTER,
  'json-pointer-uri-fragment': JSON_POINTER_URI_FRAGMENT,
  // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
  'relative-json-pointer': RELATIVE_JSON_POINTER
};


formats$1.full = {
  date: date,
  time: time,
  'date-time': date_time,
  uri: uri,
  'uri-reference': URIREF,
  'uri-template': URITEMPLATE,
  url: URL$1,
  email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
  hostname: HOSTNAME,
  ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
  ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
  regex: regex,
  uuid: UUID,
  'json-pointer': JSON_POINTER,
  'json-pointer-uri-fragment': JSON_POINTER_URI_FRAGMENT,
  'relative-json-pointer': RELATIVE_JSON_POINTER
};


function isLeapYear(year) {
  // https://tools.ietf.org/html/rfc3339#appendix-C
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}


function date(str) {
  // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
  var matches = str.match(DATE);
  if (!matches) return false;

  var year = +matches[1];
  var month = +matches[2];
  var day = +matches[3];

  return month >= 1 && month <= 12 && day >= 1 &&
          day <= (month == 2 && isLeapYear(year) ? 29 : DAYS[month]);
}


function time(str, full) {
  var matches = str.match(TIME);
  if (!matches) return false;

  var hour = matches[1];
  var minute = matches[2];
  var second = matches[3];
  var timeZone = matches[5];
  return ((hour <= 23 && minute <= 59 && second <= 59) ||
          (hour == 23 && minute == 59 && second == 60)) &&
         (!full || timeZone);
}


var DATE_TIME_SEPARATOR = /t|\s/i;
function date_time(str) {
  // http://tools.ietf.org/html/rfc3339#section-5.6
  var dateTime = str.split(DATE_TIME_SEPARATOR);
  return dateTime.length == 2 && date(dateTime[0]) && time(dateTime[1], true);
}


var NOT_URI_FRAGMENT = /\/|:/;
function uri(str) {
  // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
  return NOT_URI_FRAGMENT.test(str) && URI.test(str);
}


var Z_ANCHOR = /[^\\]\\Z/;
function regex(str) {
  if (Z_ANCHOR.test(str)) return false;
  try {
    new RegExp(str);
    return true;
  } catch(e) {
    return false;
  }
}

var ref = function generate_ref(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $async, $refCode;
  if ($schema == '#' || $schema == '#/') {
    if (it.isRoot) {
      $async = it.async;
      $refCode = 'validate';
    } else {
      $async = it.root.schema.$async === true;
      $refCode = 'root.refVal[0]';
    }
  } else {
    var $refVal = it.resolveRef(it.baseId, $schema, it.isRoot);
    if ($refVal === undefined) {
      var $message = it.MissingRefError.message(it.baseId, $schema);
      if (it.opts.missingRefs == 'fail') {
        it.logger.error($message);
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('$ref') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { ref: \'' + (it.util.escapeQuotes($schema)) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'can\\\'t resolve reference ' + (it.util.escapeQuotes($schema)) + '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: ' + (it.util.toQuotedString($schema)) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        if ($breakOnError) {
          out += ' if (false) { ';
        }
      } else if (it.opts.missingRefs == 'ignore') {
        it.logger.warn($message);
        if ($breakOnError) {
          out += ' if (true) { ';
        }
      } else {
        throw new it.MissingRefError(it.baseId, $schema, $message);
      }
    } else if ($refVal.inline) {
      var $it = it.util.copy(it);
      $it.level++;
      var $nextValid = 'valid' + $it.level;
      $it.schema = $refVal.schema;
      $it.schemaPath = '';
      $it.errSchemaPath = $schema;
      var $code = it.validate($it).replace(/validate\.schema/g, $refVal.code);
      out += ' ' + ($code) + ' ';
      if ($breakOnError) {
        out += ' if (' + ($nextValid) + ') { ';
      }
    } else {
      $async = $refVal.$async === true || (it.async && $refVal.$async !== false);
      $refCode = $refVal.code;
    }
  }
  if ($refCode) {
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = '';
    if (it.opts.passContext) {
      out += ' ' + ($refCode) + '.call(this, ';
    } else {
      out += ' ' + ($refCode) + '( ';
    }
    out += ' ' + ($data) + ', (dataPath || \'\')';
    if (it.errorPath != '""') {
      out += ' + ' + (it.errorPath);
    }
    var $parentData = $dataLvl ? 'data' + (($dataLvl - 1) || '') : 'parentData',
      $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
    out += ' , ' + ($parentData) + ' , ' + ($parentDataProperty) + ', rootData)  ';
    var __callValidate = out;
    out = $$outStack.pop();
    if ($async) {
      if (!it.async) throw new Error('async schema referenced by sync schema');
      if ($breakOnError) {
        out += ' var ' + ($valid) + '; ';
      }
      out += ' try { await ' + (__callValidate) + '; ';
      if ($breakOnError) {
        out += ' ' + ($valid) + ' = true; ';
      }
      out += ' } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ';
      if ($breakOnError) {
        out += ' ' + ($valid) + ' = false; ';
      }
      out += ' } ';
      if ($breakOnError) {
        out += ' if (' + ($valid) + ') { ';
      }
    } else {
      out += ' if (!' + (__callValidate) + ') { if (vErrors === null) vErrors = ' + ($refCode) + '.errors; else vErrors = vErrors.concat(' + ($refCode) + '.errors); errors = vErrors.length; } ';
      if ($breakOnError) {
        out += ' else { ';
      }
    }
  }
  return out;
};

var allOf = function generate_allOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $currentBaseId = $it.baseId,
    $allSchemasEmpty = true;
  var arr1 = $schema;
  if (arr1) {
    var $sch, $i = -1,
      l1 = arr1.length - 1;
    while ($i < l1) {
      $sch = arr1[$i += 1];
      if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
        $allSchemasEmpty = false;
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + '[' + $i + ']';
        $it.errSchemaPath = $errSchemaPath + '/' + $i;
        out += '  ' + (it.validate($it)) + ' ';
        $it.baseId = $currentBaseId;
        if ($breakOnError) {
          out += ' if (' + ($nextValid) + ') { ';
          $closingBraces += '}';
        }
      }
    }
  }
  if ($breakOnError) {
    if ($allSchemasEmpty) {
      out += ' if (true) { ';
    } else {
      out += ' ' + ($closingBraces.slice(0, -1)) + ' ';
    }
  }
  return out;
};

var anyOf = function generate_anyOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $noEmptySchema = $schema.every(function($sch) {
    return (it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all));
  });
  if ($noEmptySchema) {
    var $currentBaseId = $it.baseId;
    out += ' var ' + ($errs) + ' = errors; var ' + ($valid) + ' = false;  ';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var arr1 = $schema;
    if (arr1) {
      var $sch, $i = -1,
        l1 = arr1.length - 1;
      while ($i < l1) {
        $sch = arr1[$i += 1];
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + '[' + $i + ']';
        $it.errSchemaPath = $errSchemaPath + '/' + $i;
        out += '  ' + (it.validate($it)) + ' ';
        $it.baseId = $currentBaseId;
        out += ' ' + ($valid) + ' = ' + ($valid) + ' || ' + ($nextValid) + '; if (!' + ($valid) + ') { ';
        $closingBraces += '}';
      }
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' ' + ($closingBraces) + ' if (!' + ($valid) + ') {   var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('anyOf') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should match some schema in anyOf\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError(vErrors); ';
      } else {
        out += ' validate.errors = vErrors; return false; ';
      }
    }
    out += ' } else {  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; } ';
    if (it.opts.allErrors) {
      out += ' } ';
    }
  } else {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  }
  return out;
};

var comment = function generate_comment(it, $keyword, $ruleType) {
  var out = ' ';
  var $schema = it.schema[$keyword];
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  !it.opts.allErrors;
  var $comment = it.util.toQuotedString($schema);
  if (it.opts.$comment === true) {
    out += ' console.log(' + ($comment) + ');';
  } else if (typeof it.opts.$comment == 'function') {
    out += ' self._opts.$comment(' + ($comment) + ', ' + (it.util.toQuotedString($errSchemaPath)) + ', validate.root.schema);';
  }
  return out;
};

var _const = function generate_const(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
  }
  if (!$isData) {
    out += ' var schema' + ($lvl) + ' = validate.schema' + ($schemaPath) + ';';
  }
  out += 'var ' + ($valid) + ' = equal(' + ($data) + ', schema' + ($lvl) + '); if (!' + ($valid) + ') {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('const') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { allowedValue: schema' + ($lvl) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be equal to constant\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' }';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
};

var contains = function generate_contains(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $idx = 'i' + $lvl,
    $dataNxt = $it.dataLevel = it.dataLevel + 1,
    $nextData = 'data' + $dataNxt,
    $currentBaseId = it.baseId,
    $nonEmptySchema = (it.opts.strictKeywords ? (typeof $schema == 'object' && Object.keys($schema).length > 0) || $schema === false : it.util.schemaHasRules($schema, it.RULES.all));
  out += 'var ' + ($errs) + ' = errors;var ' + ($valid) + ';';
  if ($nonEmptySchema) {
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += ' var ' + ($nextValid) + ' = false; for (var ' + ($idx) + ' = 0; ' + ($idx) + ' < ' + ($data) + '.length; ' + ($idx) + '++) { ';
    $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
    var $passData = $data + '[' + $idx + ']';
    $it.dataPathArr[$dataNxt] = $idx;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
    } else {
      out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
    }
    out += ' if (' + ($nextValid) + ') break; }  ';
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' ' + ($closingBraces) + ' if (!' + ($nextValid) + ') {';
  } else {
    out += ' if (' + ($data) + '.length == 0) {';
  }
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('contains') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should contain a valid item\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' } else { ';
  if ($nonEmptySchema) {
    out += '  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; } ';
  }
  if (it.opts.allErrors) {
    out += ' } ';
  }
  return out;
};

var dependencies = function generate_dependencies(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $schemaDeps = {},
    $propertyDeps = {},
    $ownProperties = it.opts.ownProperties;
  for ($property in $schema) {
    if ($property == '__proto__') continue;
    var $sch = $schema[$property];
    var $deps = Array.isArray($sch) ? $propertyDeps : $schemaDeps;
    $deps[$property] = $sch;
  }
  out += 'var ' + ($errs) + ' = errors;';
  var $currentErrorPath = it.errorPath;
  out += 'var missing' + ($lvl) + ';';
  for (var $property in $propertyDeps) {
    $deps = $propertyDeps[$property];
    if ($deps.length) {
      out += ' if ( ' + ($data) + (it.util.getProperty($property)) + ' !== undefined ';
      if ($ownProperties) {
        out += ' && Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($property)) + '\') ';
      }
      if ($breakOnError) {
        out += ' && ( ';
        var arr1 = $deps;
        if (arr1) {
          var $propertyKey, $i = -1,
            l1 = arr1.length - 1;
          while ($i < l1) {
            $propertyKey = arr1[$i += 1];
            if ($i) {
              out += ' || ';
            }
            var $prop = it.util.getProperty($propertyKey),
              $useData = $data + $prop;
            out += ' ( ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') && (missing' + ($lvl) + ' = ' + (it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop)) + ') ) ';
          }
        }
        out += ')) {  ';
        var $propertyPath = 'missing' + $lvl,
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
        }
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('dependencies') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { property: \'' + (it.util.escapeQuotes($property)) + '\', missingProperty: \'' + ($missingProperty) + '\', depsCount: ' + ($deps.length) + ', deps: \'' + (it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", "))) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'should have ';
            if ($deps.length == 1) {
              out += 'property ' + (it.util.escapeQuotes($deps[0]));
            } else {
              out += 'properties ' + (it.util.escapeQuotes($deps.join(", ")));
            }
            out += ' when property ' + (it.util.escapeQuotes($property)) + ' is present\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
      } else {
        out += ' ) { ';
        var arr2 = $deps;
        if (arr2) {
          var $propertyKey, i2 = -1,
            l2 = arr2.length - 1;
          while (i2 < l2) {
            $propertyKey = arr2[i2 += 1];
            var $prop = it.util.getProperty($propertyKey),
              $missingProperty = it.util.escapeQuotes($propertyKey),
              $useData = $data + $prop;
            if (it.opts._errorDataPathProperty) {
              it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
            }
            out += ' if ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') {  var err =   '; /* istanbul ignore else */
            if (it.createErrors !== false) {
              out += ' { keyword: \'' + ('dependencies') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { property: \'' + (it.util.escapeQuotes($property)) + '\', missingProperty: \'' + ($missingProperty) + '\', depsCount: ' + ($deps.length) + ', deps: \'' + (it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", "))) + '\' } ';
              if (it.opts.messages !== false) {
                out += ' , message: \'should have ';
                if ($deps.length == 1) {
                  out += 'property ' + (it.util.escapeQuotes($deps[0]));
                } else {
                  out += 'properties ' + (it.util.escapeQuotes($deps.join(", ")));
                }
                out += ' when property ' + (it.util.escapeQuotes($property)) + ' is present\' ';
              }
              if (it.opts.verbose) {
                out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
              }
              out += ' } ';
            } else {
              out += ' {} ';
            }
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
          }
        }
      }
      out += ' }   ';
      if ($breakOnError) {
        $closingBraces += '}';
        out += ' else { ';
      }
    }
  }
  it.errorPath = $currentErrorPath;
  var $currentBaseId = $it.baseId;
  for (var $property in $schemaDeps) {
    var $sch = $schemaDeps[$property];
    if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
      out += ' ' + ($nextValid) + ' = true; if ( ' + ($data) + (it.util.getProperty($property)) + ' !== undefined ';
      if ($ownProperties) {
        out += ' && Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($property)) + '\') ';
      }
      out += ') { ';
      $it.schema = $sch;
      $it.schemaPath = $schemaPath + it.util.getProperty($property);
      $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($property);
      out += '  ' + (it.validate($it)) + ' ';
      $it.baseId = $currentBaseId;
      out += ' }  ';
      if ($breakOnError) {
        out += ' if (' + ($nextValid) + ') { ';
        $closingBraces += '}';
      }
    }
  }
  if ($breakOnError) {
    out += '   ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  return out;
};

var _enum = function generate_enum(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
  }
  var $i = 'i' + $lvl,
    $vSchema = 'schema' + $lvl;
  if (!$isData) {
    out += ' var ' + ($vSchema) + ' = validate.schema' + ($schemaPath) + ';';
  }
  out += 'var ' + ($valid) + ';';
  if ($isData) {
    out += ' if (schema' + ($lvl) + ' === undefined) ' + ($valid) + ' = true; else if (!Array.isArray(schema' + ($lvl) + ')) ' + ($valid) + ' = false; else {';
  }
  out += '' + ($valid) + ' = false;for (var ' + ($i) + '=0; ' + ($i) + '<' + ($vSchema) + '.length; ' + ($i) + '++) if (equal(' + ($data) + ', ' + ($vSchema) + '[' + ($i) + '])) { ' + ($valid) + ' = true; break; }';
  if ($isData) {
    out += '  }  ';
  }
  out += ' if (!' + ($valid) + ') {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('enum') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { allowedValues: schema' + ($lvl) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be equal to one of the allowed values\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' }';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
};

var format = function generate_format(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  if (it.opts.format === false) {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
    return out;
  }
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $unknownFormats = it.opts.unknownFormats,
    $allowUnknown = Array.isArray($unknownFormats);
  if ($isData) {
    var $format = 'format' + $lvl,
      $isObject = 'isObject' + $lvl,
      $formatType = 'formatType' + $lvl;
    out += ' var ' + ($format) + ' = formats[' + ($schemaValue) + ']; var ' + ($isObject) + ' = typeof ' + ($format) + ' == \'object\' && !(' + ($format) + ' instanceof RegExp) && ' + ($format) + '.validate; var ' + ($formatType) + ' = ' + ($isObject) + ' && ' + ($format) + '.type || \'string\'; if (' + ($isObject) + ') { ';
    if (it.async) {
      out += ' var async' + ($lvl) + ' = ' + ($format) + '.async; ';
    }
    out += ' ' + ($format) + ' = ' + ($format) + '.validate; } if (  ';
    if ($isData) {
      out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'string\') || ';
    }
    out += ' (';
    if ($unknownFormats != 'ignore') {
      out += ' (' + ($schemaValue) + ' && !' + ($format) + ' ';
      if ($allowUnknown) {
        out += ' && self._opts.unknownFormats.indexOf(' + ($schemaValue) + ') == -1 ';
      }
      out += ') || ';
    }
    out += ' (' + ($format) + ' && ' + ($formatType) + ' == \'' + ($ruleType) + '\' && !(typeof ' + ($format) + ' == \'function\' ? ';
    if (it.async) {
      out += ' (async' + ($lvl) + ' ? await ' + ($format) + '(' + ($data) + ') : ' + ($format) + '(' + ($data) + ')) ';
    } else {
      out += ' ' + ($format) + '(' + ($data) + ') ';
    }
    out += ' : ' + ($format) + '.test(' + ($data) + '))))) {';
  } else {
    var $format = it.formats[$schema];
    if (!$format) {
      if ($unknownFormats == 'ignore') {
        it.logger.warn('unknown format "' + $schema + '" ignored in schema at path "' + it.errSchemaPath + '"');
        if ($breakOnError) {
          out += ' if (true) { ';
        }
        return out;
      } else if ($allowUnknown && $unknownFormats.indexOf($schema) >= 0) {
        if ($breakOnError) {
          out += ' if (true) { ';
        }
        return out;
      } else {
        throw new Error('unknown format "' + $schema + '" is used in schema at path "' + it.errSchemaPath + '"');
      }
    }
    var $isObject = typeof $format == 'object' && !($format instanceof RegExp) && $format.validate;
    var $formatType = $isObject && $format.type || 'string';
    if ($isObject) {
      var $async = $format.async === true;
      $format = $format.validate;
    }
    if ($formatType != $ruleType) {
      if ($breakOnError) {
        out += ' if (true) { ';
      }
      return out;
    }
    if ($async) {
      if (!it.async) throw new Error('async format in sync schema');
      var $formatRef = 'formats' + it.util.getProperty($schema) + '.validate';
      out += ' if (!(await ' + ($formatRef) + '(' + ($data) + '))) { ';
    } else {
      out += ' if (! ';
      var $formatRef = 'formats' + it.util.getProperty($schema);
      if ($isObject) $formatRef += '.validate';
      if (typeof $format == 'function') {
        out += ' ' + ($formatRef) + '(' + ($data) + ') ';
      } else {
        out += ' ' + ($formatRef) + '.test(' + ($data) + ') ';
      }
      out += ') { ';
    }
  }
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('format') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { format:  ';
    if ($isData) {
      out += '' + ($schemaValue);
    } else {
      out += '' + (it.util.toQuotedString($schema));
    }
    out += '  } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should match format "';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + (it.util.escapeQuotes($schema));
      }
      out += '"\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + (it.util.toQuotedString($schema));
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' } ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
};

var _if = function generate_if(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $thenSch = it.schema['then'],
    $elseSch = it.schema['else'],
    $thenPresent = $thenSch !== undefined && (it.opts.strictKeywords ? (typeof $thenSch == 'object' && Object.keys($thenSch).length > 0) || $thenSch === false : it.util.schemaHasRules($thenSch, it.RULES.all)),
    $elsePresent = $elseSch !== undefined && (it.opts.strictKeywords ? (typeof $elseSch == 'object' && Object.keys($elseSch).length > 0) || $elseSch === false : it.util.schemaHasRules($elseSch, it.RULES.all)),
    $currentBaseId = $it.baseId;
  if ($thenPresent || $elsePresent) {
    var $ifClause;
    $it.createErrors = false;
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += ' var ' + ($errs) + ' = errors; var ' + ($valid) + ' = true;  ';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    out += '  ' + (it.validate($it)) + ' ';
    $it.baseId = $currentBaseId;
    $it.createErrors = true;
    out += '  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; }  ';
    it.compositeRule = $it.compositeRule = $wasComposite;
    if ($thenPresent) {
      out += ' if (' + ($nextValid) + ') {  ';
      $it.schema = it.schema['then'];
      $it.schemaPath = it.schemaPath + '.then';
      $it.errSchemaPath = it.errSchemaPath + '/then';
      out += '  ' + (it.validate($it)) + ' ';
      $it.baseId = $currentBaseId;
      out += ' ' + ($valid) + ' = ' + ($nextValid) + '; ';
      if ($thenPresent && $elsePresent) {
        $ifClause = 'ifClause' + $lvl;
        out += ' var ' + ($ifClause) + ' = \'then\'; ';
      } else {
        $ifClause = '\'then\'';
      }
      out += ' } ';
      if ($elsePresent) {
        out += ' else { ';
      }
    } else {
      out += ' if (!' + ($nextValid) + ') { ';
    }
    if ($elsePresent) {
      $it.schema = it.schema['else'];
      $it.schemaPath = it.schemaPath + '.else';
      $it.errSchemaPath = it.errSchemaPath + '/else';
      out += '  ' + (it.validate($it)) + ' ';
      $it.baseId = $currentBaseId;
      out += ' ' + ($valid) + ' = ' + ($nextValid) + '; ';
      if ($thenPresent && $elsePresent) {
        $ifClause = 'ifClause' + $lvl;
        out += ' var ' + ($ifClause) + ' = \'else\'; ';
      } else {
        $ifClause = '\'else\'';
      }
      out += ' } ';
    }
    out += ' if (!' + ($valid) + ') {   var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('if') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { failingKeyword: ' + ($ifClause) + ' } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should match "\' + ' + ($ifClause) + ' + \'" schema\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError(vErrors); ';
      } else {
        out += ' validate.errors = vErrors; return false; ';
      }
    }
    out += ' }   ';
    if ($breakOnError) {
      out += ' else { ';
    }
  } else {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  }
  return out;
};

var items = function generate_items(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $idx = 'i' + $lvl,
    $dataNxt = $it.dataLevel = it.dataLevel + 1,
    $nextData = 'data' + $dataNxt,
    $currentBaseId = it.baseId;
  out += 'var ' + ($errs) + ' = errors;var ' + ($valid) + ';';
  if (Array.isArray($schema)) {
    var $additionalItems = it.schema.additionalItems;
    if ($additionalItems === false) {
      out += ' ' + ($valid) + ' = ' + ($data) + '.length <= ' + ($schema.length) + '; ';
      var $currErrSchemaPath = $errSchemaPath;
      $errSchemaPath = it.errSchemaPath + '/additionalItems';
      out += '  if (!' + ($valid) + ') {   ';
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = ''; /* istanbul ignore else */
      if (it.createErrors !== false) {
        out += ' { keyword: \'' + ('additionalItems') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schema.length) + ' } ';
        if (it.opts.messages !== false) {
          out += ' , message: \'should NOT have more than ' + ($schema.length) + ' items\' ';
        }
        if (it.opts.verbose) {
          out += ' , schema: false , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
        }
        out += ' } ';
      } else {
        out += ' {} ';
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */
        if (it.async) {
          out += ' throw new ValidationError([' + (__err) + ']); ';
        } else {
          out += ' validate.errors = [' + (__err) + ']; return false; ';
        }
      } else {
        out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
      }
      out += ' } ';
      $errSchemaPath = $currErrSchemaPath;
      if ($breakOnError) {
        $closingBraces += '}';
        out += ' else { ';
      }
    }
    var arr1 = $schema;
    if (arr1) {
      var $sch, $i = -1,
        l1 = arr1.length - 1;
      while ($i < l1) {
        $sch = arr1[$i += 1];
        if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
          out += ' ' + ($nextValid) + ' = true; if (' + ($data) + '.length > ' + ($i) + ') { ';
          var $passData = $data + '[' + $i + ']';
          $it.schema = $sch;
          $it.schemaPath = $schemaPath + '[' + $i + ']';
          $it.errSchemaPath = $errSchemaPath + '/' + $i;
          $it.errorPath = it.util.getPathExpr(it.errorPath, $i, it.opts.jsonPointers, true);
          $it.dataPathArr[$dataNxt] = $i;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          out += ' }  ';
          if ($breakOnError) {
            out += ' if (' + ($nextValid) + ') { ';
            $closingBraces += '}';
          }
        }
      }
    }
    if (typeof $additionalItems == 'object' && (it.opts.strictKeywords ? (typeof $additionalItems == 'object' && Object.keys($additionalItems).length > 0) || $additionalItems === false : it.util.schemaHasRules($additionalItems, it.RULES.all))) {
      $it.schema = $additionalItems;
      $it.schemaPath = it.schemaPath + '.additionalItems';
      $it.errSchemaPath = it.errSchemaPath + '/additionalItems';
      out += ' ' + ($nextValid) + ' = true; if (' + ($data) + '.length > ' + ($schema.length) + ') {  for (var ' + ($idx) + ' = ' + ($schema.length) + '; ' + ($idx) + ' < ' + ($data) + '.length; ' + ($idx) + '++) { ';
      $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
      var $passData = $data + '[' + $idx + ']';
      $it.dataPathArr[$dataNxt] = $idx;
      var $code = it.validate($it);
      $it.baseId = $currentBaseId;
      if (it.util.varOccurences($code, $nextData) < 2) {
        out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
      } else {
        out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
      }
      if ($breakOnError) {
        out += ' if (!' + ($nextValid) + ') break; ';
      }
      out += ' } }  ';
      if ($breakOnError) {
        out += ' if (' + ($nextValid) + ') { ';
        $closingBraces += '}';
      }
    }
  } else if ((it.opts.strictKeywords ? (typeof $schema == 'object' && Object.keys($schema).length > 0) || $schema === false : it.util.schemaHasRules($schema, it.RULES.all))) {
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += '  for (var ' + ($idx) + ' = ' + (0) + '; ' + ($idx) + ' < ' + ($data) + '.length; ' + ($idx) + '++) { ';
    $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
    var $passData = $data + '[' + $idx + ']';
    $it.dataPathArr[$dataNxt] = $idx;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
    } else {
      out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
    }
    if ($breakOnError) {
      out += ' if (!' + ($nextValid) + ') break; ';
    }
    out += ' }';
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  return out;
};

var _limit = function generate__limit(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $isMax = $keyword == 'maximum',
    $exclusiveKeyword = $isMax ? 'exclusiveMaximum' : 'exclusiveMinimum',
    $schemaExcl = it.schema[$exclusiveKeyword],
    $isDataExcl = it.opts.$data && $schemaExcl && $schemaExcl.$data,
    $op = $isMax ? '<' : '>',
    $notOp = $isMax ? '>' : '<',
    $errorKeyword = undefined;
  if (!($isData || typeof $schema == 'number' || $schema === undefined)) {
    throw new Error($keyword + ' must be number');
  }
  if (!($isDataExcl || $schemaExcl === undefined || typeof $schemaExcl == 'number' || typeof $schemaExcl == 'boolean')) {
    throw new Error($exclusiveKeyword + ' must be number or boolean');
  }
  if ($isDataExcl) {
    var $schemaValueExcl = it.util.getData($schemaExcl.$data, $dataLvl, it.dataPathArr),
      $exclusive = 'exclusive' + $lvl,
      $exclType = 'exclType' + $lvl,
      $exclIsNumber = 'exclIsNumber' + $lvl,
      $opExpr = 'op' + $lvl,
      $opStr = '\' + ' + $opExpr + ' + \'';
    out += ' var schemaExcl' + ($lvl) + ' = ' + ($schemaValueExcl) + '; ';
    $schemaValueExcl = 'schemaExcl' + $lvl;
    out += ' var ' + ($exclusive) + '; var ' + ($exclType) + ' = typeof ' + ($schemaValueExcl) + '; if (' + ($exclType) + ' != \'boolean\' && ' + ($exclType) + ' != \'undefined\' && ' + ($exclType) + ' != \'number\') { ';
    var $errorKeyword = $exclusiveKeyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ($errorKeyword || '_exclusiveLimit') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'' + ($exclusiveKeyword) + ' should be boolean\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    out += ' } else if ( ';
    if ($isData) {
      out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
    }
    out += ' ' + ($exclType) + ' == \'number\' ? ( (' + ($exclusive) + ' = ' + ($schemaValue) + ' === undefined || ' + ($schemaValueExcl) + ' ' + ($op) + '= ' + ($schemaValue) + ') ? ' + ($data) + ' ' + ($notOp) + '= ' + ($schemaValueExcl) + ' : ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' ) : ( (' + ($exclusive) + ' = ' + ($schemaValueExcl) + ' === true) ? ' + ($data) + ' ' + ($notOp) + '= ' + ($schemaValue) + ' : ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' ) || ' + ($data) + ' !== ' + ($data) + ') { var op' + ($lvl) + ' = ' + ($exclusive) + ' ? \'' + ($op) + '\' : \'' + ($op) + '=\'; ';
    if ($schema === undefined) {
      $errorKeyword = $exclusiveKeyword;
      $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
      $schemaValue = $schemaValueExcl;
      $isData = $isDataExcl;
    }
  } else {
    var $exclIsNumber = typeof $schemaExcl == 'number',
      $opStr = $op;
    if ($exclIsNumber && $isData) {
      var $opExpr = '\'' + $opStr + '\'';
      out += ' if ( ';
      if ($isData) {
        out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
      }
      out += ' ( ' + ($schemaValue) + ' === undefined || ' + ($schemaExcl) + ' ' + ($op) + '= ' + ($schemaValue) + ' ? ' + ($data) + ' ' + ($notOp) + '= ' + ($schemaExcl) + ' : ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' ) || ' + ($data) + ' !== ' + ($data) + ') { ';
    } else {
      if ($exclIsNumber && $schema === undefined) {
        $exclusive = true;
        $errorKeyword = $exclusiveKeyword;
        $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
        $schemaValue = $schemaExcl;
        $notOp += '=';
      } else {
        if ($exclIsNumber) $schemaValue = Math[$isMax ? 'min' : 'max']($schemaExcl, $schema);
        if ($schemaExcl === ($exclIsNumber ? $schemaValue : true)) {
          $exclusive = true;
          $errorKeyword = $exclusiveKeyword;
          $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
          $notOp += '=';
        } else {
          $exclusive = false;
          $opStr += '=';
        }
      }
      var $opExpr = '\'' + $opStr + '\'';
      out += ' if ( ';
      if ($isData) {
        out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
      }
      out += ' ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' || ' + ($data) + ' !== ' + ($data) + ') { ';
    }
  }
  $errorKeyword = $errorKeyword || $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limit') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { comparison: ' + ($opExpr) + ', limit: ' + ($schemaValue) + ', exclusive: ' + ($exclusive) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be ' + ($opStr) + ' ';
      if ($isData) {
        out += '\' + ' + ($schemaValue);
      } else {
        out += '' + ($schemaValue) + '\'';
      }
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' } ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
};

var _limitItems = function generate__limitItems(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!($isData || typeof $schema == 'number')) {
    throw new Error($keyword + ' must be number');
  }
  var $op = $keyword == 'maxItems' ? '>' : '<';
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
  }
  out += ' ' + ($data) + '.length ' + ($op) + ' ' + ($schemaValue) + ') { ';
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limitItems') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should NOT have ';
      if ($keyword == 'maxItems') {
        out += 'more';
      } else {
        out += 'fewer';
      }
      out += ' than ';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + ($schema);
      }
      out += ' items\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
};

var _limitLength = function generate__limitLength(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!($isData || typeof $schema == 'number')) {
    throw new Error($keyword + ' must be number');
  }
  var $op = $keyword == 'maxLength' ? '>' : '<';
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
  }
  if (it.opts.unicode === false) {
    out += ' ' + ($data) + '.length ';
  } else {
    out += ' ucs2length(' + ($data) + ') ';
  }
  out += ' ' + ($op) + ' ' + ($schemaValue) + ') { ';
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limitLength') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should NOT be ';
      if ($keyword == 'maxLength') {
        out += 'longer';
      } else {
        out += 'shorter';
      }
      out += ' than ';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + ($schema);
      }
      out += ' characters\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
};

var _limitProperties = function generate__limitProperties(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!($isData || typeof $schema == 'number')) {
    throw new Error($keyword + ' must be number');
  }
  var $op = $keyword == 'maxProperties' ? '>' : '<';
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
  }
  out += ' Object.keys(' + ($data) + ').length ' + ($op) + ' ' + ($schemaValue) + ') { ';
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limitProperties') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should NOT have ';
      if ($keyword == 'maxProperties') {
        out += 'more';
      } else {
        out += 'fewer';
      }
      out += ' than ';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + ($schema);
      }
      out += ' properties\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
};

var multipleOf = function generate_multipleOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!($isData || typeof $schema == 'number')) {
    throw new Error($keyword + ' must be number');
  }
  out += 'var division' + ($lvl) + ';if (';
  if ($isData) {
    out += ' ' + ($schemaValue) + ' !== undefined && ( typeof ' + ($schemaValue) + ' != \'number\' || ';
  }
  out += ' (division' + ($lvl) + ' = ' + ($data) + ' / ' + ($schemaValue) + ', ';
  if (it.opts.multipleOfPrecision) {
    out += ' Math.abs(Math.round(division' + ($lvl) + ') - division' + ($lvl) + ') > 1e-' + (it.opts.multipleOfPrecision) + ' ';
  } else {
    out += ' division' + ($lvl) + ' !== parseInt(division' + ($lvl) + ') ';
  }
  out += ' ) ';
  if ($isData) {
    out += '  )  ';
  }
  out += ' ) {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('multipleOf') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { multipleOf: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be multiple of ';
      if ($isData) {
        out += '\' + ' + ($schemaValue);
      } else {
        out += '' + ($schemaValue) + '\'';
      }
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
};

var not = function generate_not(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  if ((it.opts.strictKeywords ? (typeof $schema == 'object' && Object.keys($schema).length > 0) || $schema === false : it.util.schemaHasRules($schema, it.RULES.all))) {
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += ' var ' + ($errs) + ' = errors;  ';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    $it.createErrors = false;
    var $allErrorsOption;
    if ($it.opts.allErrors) {
      $allErrorsOption = $it.opts.allErrors;
      $it.opts.allErrors = false;
    }
    out += ' ' + (it.validate($it)) + ' ';
    $it.createErrors = true;
    if ($allErrorsOption) $it.opts.allErrors = $allErrorsOption;
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' if (' + ($nextValid) + ') {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('not') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should NOT be valid\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    out += ' } else {  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; } ';
    if (it.opts.allErrors) {
      out += ' } ';
    }
  } else {
    out += '  var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('not') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should NOT be valid\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if ($breakOnError) {
      out += ' if (false) { ';
    }
  }
  return out;
};

var oneOf = function generate_oneOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $currentBaseId = $it.baseId,
    $prevValid = 'prevValid' + $lvl,
    $passingSchemas = 'passingSchemas' + $lvl;
  out += 'var ' + ($errs) + ' = errors , ' + ($prevValid) + ' = false , ' + ($valid) + ' = false , ' + ($passingSchemas) + ' = null; ';
  var $wasComposite = it.compositeRule;
  it.compositeRule = $it.compositeRule = true;
  var arr1 = $schema;
  if (arr1) {
    var $sch, $i = -1,
      l1 = arr1.length - 1;
    while ($i < l1) {
      $sch = arr1[$i += 1];
      if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + '[' + $i + ']';
        $it.errSchemaPath = $errSchemaPath + '/' + $i;
        out += '  ' + (it.validate($it)) + ' ';
        $it.baseId = $currentBaseId;
      } else {
        out += ' var ' + ($nextValid) + ' = true; ';
      }
      if ($i) {
        out += ' if (' + ($nextValid) + ' && ' + ($prevValid) + ') { ' + ($valid) + ' = false; ' + ($passingSchemas) + ' = [' + ($passingSchemas) + ', ' + ($i) + ']; } else { ';
        $closingBraces += '}';
      }
      out += ' if (' + ($nextValid) + ') { ' + ($valid) + ' = ' + ($prevValid) + ' = true; ' + ($passingSchemas) + ' = ' + ($i) + '; }';
    }
  }
  it.compositeRule = $it.compositeRule = $wasComposite;
  out += '' + ($closingBraces) + 'if (!' + ($valid) + ') {   var err =   '; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('oneOf') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { passingSchemas: ' + ($passingSchemas) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should match exactly one schema in oneOf\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError(vErrors); ';
    } else {
      out += ' validate.errors = vErrors; return false; ';
    }
  }
  out += '} else {  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; }';
  if (it.opts.allErrors) {
    out += ' } ';
  }
  return out;
};

var pattern = function generate_pattern(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $regexp = $isData ? '(new RegExp(' + $schemaValue + '))' : it.usePattern($schema);
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'string\') || ';
  }
  out += ' !' + ($regexp) + '.test(' + ($data) + ') ) {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('pattern') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { pattern:  ';
    if ($isData) {
      out += '' + ($schemaValue);
    } else {
      out += '' + (it.util.toQuotedString($schema));
    }
    out += '  } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should match pattern "';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + (it.util.escapeQuotes($schema));
      }
      out += '"\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + (it.util.toQuotedString($schema));
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) {
    /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
};

var properties$2 = function generate_properties(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $key = 'key' + $lvl,
    $idx = 'idx' + $lvl,
    $dataNxt = $it.dataLevel = it.dataLevel + 1,
    $nextData = 'data' + $dataNxt,
    $dataProperties = 'dataProperties' + $lvl;
  var $schemaKeys = Object.keys($schema || {}).filter(notProto),
    $pProperties = it.schema.patternProperties || {},
    $pPropertyKeys = Object.keys($pProperties).filter(notProto),
    $aProperties = it.schema.additionalProperties,
    $someProperties = $schemaKeys.length || $pPropertyKeys.length,
    $noAdditional = $aProperties === false,
    $additionalIsSchema = typeof $aProperties == 'object' && Object.keys($aProperties).length,
    $removeAdditional = it.opts.removeAdditional,
    $checkAdditional = $noAdditional || $additionalIsSchema || $removeAdditional,
    $ownProperties = it.opts.ownProperties,
    $currentBaseId = it.baseId;
  var $required = it.schema.required;
  if ($required && !(it.opts.$data && $required.$data) && $required.length < it.opts.loopRequired) {
    var $requiredHash = it.util.toHash($required);
  }

  function notProto(p) {
    return p !== '__proto__';
  }
  out += 'var ' + ($errs) + ' = errors;var ' + ($nextValid) + ' = true;';
  if ($ownProperties) {
    out += ' var ' + ($dataProperties) + ' = undefined;';
  }
  if ($checkAdditional) {
    if ($ownProperties) {
      out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
    } else {
      out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
    }
    if ($someProperties) {
      out += ' var isAdditional' + ($lvl) + ' = !(false ';
      if ($schemaKeys.length) {
        if ($schemaKeys.length > 8) {
          out += ' || validate.schema' + ($schemaPath) + '.hasOwnProperty(' + ($key) + ') ';
        } else {
          var arr1 = $schemaKeys;
          if (arr1) {
            var $propertyKey, i1 = -1,
              l1 = arr1.length - 1;
            while (i1 < l1) {
              $propertyKey = arr1[i1 += 1];
              out += ' || ' + ($key) + ' == ' + (it.util.toQuotedString($propertyKey)) + ' ';
            }
          }
        }
      }
      if ($pPropertyKeys.length) {
        var arr2 = $pPropertyKeys;
        if (arr2) {
          var $pProperty, $i = -1,
            l2 = arr2.length - 1;
          while ($i < l2) {
            $pProperty = arr2[$i += 1];
            out += ' || ' + (it.usePattern($pProperty)) + '.test(' + ($key) + ') ';
          }
        }
      }
      out += ' ); if (isAdditional' + ($lvl) + ') { ';
    }
    if ($removeAdditional == 'all') {
      out += ' delete ' + ($data) + '[' + ($key) + ']; ';
    } else {
      var $currentErrorPath = it.errorPath;
      var $additionalProperty = '\' + ' + $key + ' + \'';
      if (it.opts._errorDataPathProperty) {
        it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
      }
      if ($noAdditional) {
        if ($removeAdditional) {
          out += ' delete ' + ($data) + '[' + ($key) + ']; ';
        } else {
          out += ' ' + ($nextValid) + ' = false; ';
          var $currErrSchemaPath = $errSchemaPath;
          $errSchemaPath = it.errSchemaPath + '/additionalProperties';
          var $$outStack = $$outStack || [];
          $$outStack.push(out);
          out = ''; /* istanbul ignore else */
          if (it.createErrors !== false) {
            out += ' { keyword: \'' + ('additionalProperties') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { additionalProperty: \'' + ($additionalProperty) + '\' } ';
            if (it.opts.messages !== false) {
              out += ' , message: \'';
              if (it.opts._errorDataPathProperty) {
                out += 'is an invalid additional property';
              } else {
                out += 'should NOT have additional properties';
              }
              out += '\' ';
            }
            if (it.opts.verbose) {
              out += ' , schema: false , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
            }
            out += ' } ';
          } else {
            out += ' {} ';
          }
          var __err = out;
          out = $$outStack.pop();
          if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */
            if (it.async) {
              out += ' throw new ValidationError([' + (__err) + ']); ';
            } else {
              out += ' validate.errors = [' + (__err) + ']; return false; ';
            }
          } else {
            out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
          }
          $errSchemaPath = $currErrSchemaPath;
          if ($breakOnError) {
            out += ' break; ';
          }
        }
      } else if ($additionalIsSchema) {
        if ($removeAdditional == 'failing') {
          out += ' var ' + ($errs) + ' = errors;  ';
          var $wasComposite = it.compositeRule;
          it.compositeRule = $it.compositeRule = true;
          $it.schema = $aProperties;
          $it.schemaPath = it.schemaPath + '.additionalProperties';
          $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
          $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + '[' + $key + ']';
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          out += ' if (!' + ($nextValid) + ') { errors = ' + ($errs) + '; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete ' + ($data) + '[' + ($key) + ']; }  ';
          it.compositeRule = $it.compositeRule = $wasComposite;
        } else {
          $it.schema = $aProperties;
          $it.schemaPath = it.schemaPath + '.additionalProperties';
          $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
          $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + '[' + $key + ']';
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          if ($breakOnError) {
            out += ' if (!' + ($nextValid) + ') break; ';
          }
        }
      }
      it.errorPath = $currentErrorPath;
    }
    if ($someProperties) {
      out += ' } ';
    }
    out += ' }  ';
    if ($breakOnError) {
      out += ' if (' + ($nextValid) + ') { ';
      $closingBraces += '}';
    }
  }
  var $useDefaults = it.opts.useDefaults && !it.compositeRule;
  if ($schemaKeys.length) {
    var arr3 = $schemaKeys;
    if (arr3) {
      var $propertyKey, i3 = -1,
        l3 = arr3.length - 1;
      while (i3 < l3) {
        $propertyKey = arr3[i3 += 1];
        var $sch = $schema[$propertyKey];
        if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
          var $prop = it.util.getProperty($propertyKey),
            $passData = $data + $prop,
            $hasDefault = $useDefaults && $sch.default !== undefined;
          $it.schema = $sch;
          $it.schemaPath = $schemaPath + $prop;
          $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($propertyKey);
          $it.errorPath = it.util.getPath(it.errorPath, $propertyKey, it.opts.jsonPointers);
          $it.dataPathArr[$dataNxt] = it.util.toQuotedString($propertyKey);
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            $code = it.util.varReplace($code, $nextData, $passData);
            var $useData = $passData;
          } else {
            var $useData = $nextData;
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ';
          }
          if ($hasDefault) {
            out += ' ' + ($code) + ' ';
          } else {
            if ($requiredHash && $requiredHash[$propertyKey]) {
              out += ' if ( ' + ($useData) + ' === undefined ';
              if ($ownProperties) {
                out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
              }
              out += ') { ' + ($nextValid) + ' = false; ';
              var $currentErrorPath = it.errorPath,
                $currErrSchemaPath = $errSchemaPath,
                $missingProperty = it.util.escapeQuotes($propertyKey);
              if (it.opts._errorDataPathProperty) {
                it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
              }
              $errSchemaPath = it.errSchemaPath + '/required';
              var $$outStack = $$outStack || [];
              $$outStack.push(out);
              out = ''; /* istanbul ignore else */
              if (it.createErrors !== false) {
                out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
                if (it.opts.messages !== false) {
                  out += ' , message: \'';
                  if (it.opts._errorDataPathProperty) {
                    out += 'is a required property';
                  } else {
                    out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
                  }
                  out += '\' ';
                }
                if (it.opts.verbose) {
                  out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
                }
                out += ' } ';
              } else {
                out += ' {} ';
              }
              var __err = out;
              out = $$outStack.pop();
              if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */
                if (it.async) {
                  out += ' throw new ValidationError([' + (__err) + ']); ';
                } else {
                  out += ' validate.errors = [' + (__err) + ']; return false; ';
                }
              } else {
                out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
              }
              $errSchemaPath = $currErrSchemaPath;
              it.errorPath = $currentErrorPath;
              out += ' } else { ';
            } else {
              if ($breakOnError) {
                out += ' if ( ' + ($useData) + ' === undefined ';
                if ($ownProperties) {
                  out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
                }
                out += ') { ' + ($nextValid) + ' = true; } else { ';
              } else {
                out += ' if (' + ($useData) + ' !== undefined ';
                if ($ownProperties) {
                  out += ' &&   Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
                }
                out += ' ) { ';
              }
            }
            out += ' ' + ($code) + ' } ';
          }
        }
        if ($breakOnError) {
          out += ' if (' + ($nextValid) + ') { ';
          $closingBraces += '}';
        }
      }
    }
  }
  if ($pPropertyKeys.length) {
    var arr4 = $pPropertyKeys;
    if (arr4) {
      var $pProperty, i4 = -1,
        l4 = arr4.length - 1;
      while (i4 < l4) {
        $pProperty = arr4[i4 += 1];
        var $sch = $pProperties[$pProperty];
        if ((it.opts.strictKeywords ? (typeof $sch == 'object' && Object.keys($sch).length > 0) || $sch === false : it.util.schemaHasRules($sch, it.RULES.all))) {
          $it.schema = $sch;
          $it.schemaPath = it.schemaPath + '.patternProperties' + it.util.getProperty($pProperty);
          $it.errSchemaPath = it.errSchemaPath + '/patternProperties/' + it.util.escapeFragment($pProperty);
          if ($ownProperties) {
            out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
          } else {
            out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
          }
          out += ' if (' + (it.usePattern($pProperty)) + '.test(' + ($key) + ')) { ';
          $it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + '[' + $key + ']';
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          if ($breakOnError) {
            out += ' if (!' + ($nextValid) + ') break; ';
          }
          out += ' } ';
          if ($breakOnError) {
            out += ' else ' + ($nextValid) + ' = true; ';
          }
          out += ' }  ';
          if ($breakOnError) {
            out += ' if (' + ($nextValid) + ') { ';
            $closingBraces += '}';
          }
        }
      }
    }
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  return out;
};

var propertyNames = function generate_propertyNames(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  out += 'var ' + ($errs) + ' = errors;';
  if ((it.opts.strictKeywords ? (typeof $schema == 'object' && Object.keys($schema).length > 0) || $schema === false : it.util.schemaHasRules($schema, it.RULES.all))) {
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    var $key = 'key' + $lvl,
      $idx = 'idx' + $lvl,
      $i = 'i' + $lvl,
      $invalidName = '\' + ' + $key + ' + \'',
      $dataNxt = $it.dataLevel = it.dataLevel + 1,
      $nextData = 'data' + $dataNxt,
      $dataProperties = 'dataProperties' + $lvl,
      $ownProperties = it.opts.ownProperties,
      $currentBaseId = it.baseId;
    if ($ownProperties) {
      out += ' var ' + ($dataProperties) + ' = undefined; ';
    }
    if ($ownProperties) {
      out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
    } else {
      out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
    }
    out += ' var startErrs' + ($lvl) + ' = errors; ';
    var $passData = $key;
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
    } else {
      out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' if (!' + ($nextValid) + ') { for (var ' + ($i) + '=startErrs' + ($lvl) + '; ' + ($i) + '<errors; ' + ($i) + '++) { vErrors[' + ($i) + '].propertyName = ' + ($key) + '; }   var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('propertyNames') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { propertyName: \'' + ($invalidName) + '\' } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'property name \\\'' + ($invalidName) + '\\\' is invalid\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError(vErrors); ';
      } else {
        out += ' validate.errors = vErrors; return false; ';
      }
    }
    if ($breakOnError) {
      out += ' break; ';
    }
    out += ' } }';
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  return out;
};

var required$1 = function generate_required(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
  }
  var $vSchema = 'schema' + $lvl;
  if (!$isData) {
    if ($schema.length < it.opts.loopRequired && it.schema.properties && Object.keys(it.schema.properties).length) {
      var $required = [];
      var arr1 = $schema;
      if (arr1) {
        var $property, i1 = -1,
          l1 = arr1.length - 1;
        while (i1 < l1) {
          $property = arr1[i1 += 1];
          var $propertySch = it.schema.properties[$property];
          if (!($propertySch && (it.opts.strictKeywords ? (typeof $propertySch == 'object' && Object.keys($propertySch).length > 0) || $propertySch === false : it.util.schemaHasRules($propertySch, it.RULES.all)))) {
            $required[$required.length] = $property;
          }
        }
      }
    } else {
      var $required = $schema;
    }
  }
  if ($isData || $required.length) {
    var $currentErrorPath = it.errorPath,
      $loopRequired = $isData || $required.length >= it.opts.loopRequired,
      $ownProperties = it.opts.ownProperties;
    if ($breakOnError) {
      out += ' var missing' + ($lvl) + '; ';
      if ($loopRequired) {
        if (!$isData) {
          out += ' var ' + ($vSchema) + ' = validate.schema' + ($schemaPath) + '; ';
        }
        var $i = 'i' + $lvl,
          $propertyPath = 'schema' + $lvl + '[' + $i + ']',
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
        }
        out += ' var ' + ($valid) + ' = true; ';
        if ($isData) {
          out += ' if (schema' + ($lvl) + ' === undefined) ' + ($valid) + ' = true; else if (!Array.isArray(schema' + ($lvl) + ')) ' + ($valid) + ' = false; else {';
        }
        out += ' for (var ' + ($i) + ' = 0; ' + ($i) + ' < ' + ($vSchema) + '.length; ' + ($i) + '++) { ' + ($valid) + ' = ' + ($data) + '[' + ($vSchema) + '[' + ($i) + ']] !== undefined ';
        if ($ownProperties) {
          out += ' &&   Object.prototype.hasOwnProperty.call(' + ($data) + ', ' + ($vSchema) + '[' + ($i) + ']) ';
        }
        out += '; if (!' + ($valid) + ') break; } ';
        if ($isData) {
          out += '  }  ';
        }
        out += '  if (!' + ($valid) + ') {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'';
            if (it.opts._errorDataPathProperty) {
              out += 'is a required property';
            } else {
              out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        out += ' } else { ';
      } else {
        out += ' if ( ';
        var arr2 = $required;
        if (arr2) {
          var $propertyKey, $i = -1,
            l2 = arr2.length - 1;
          while ($i < l2) {
            $propertyKey = arr2[$i += 1];
            if ($i) {
              out += ' || ';
            }
            var $prop = it.util.getProperty($propertyKey),
              $useData = $data + $prop;
            out += ' ( ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') && (missing' + ($lvl) + ' = ' + (it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop)) + ') ) ';
          }
        }
        out += ') {  ';
        var $propertyPath = 'missing' + $lvl,
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
        }
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'';
            if (it.opts._errorDataPathProperty) {
              out += 'is a required property';
            } else {
              out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
          /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        out += ' } else { ';
      }
    } else {
      if ($loopRequired) {
        if (!$isData) {
          out += ' var ' + ($vSchema) + ' = validate.schema' + ($schemaPath) + '; ';
        }
        var $i = 'i' + $lvl,
          $propertyPath = 'schema' + $lvl + '[' + $i + ']',
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
        }
        if ($isData) {
          out += ' if (' + ($vSchema) + ' && !Array.isArray(' + ($vSchema) + ')) {  var err =   '; /* istanbul ignore else */
          if (it.createErrors !== false) {
            out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
            if (it.opts.messages !== false) {
              out += ' , message: \'';
              if (it.opts._errorDataPathProperty) {
                out += 'is a required property';
              } else {
                out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
              }
              out += '\' ';
            }
            if (it.opts.verbose) {
              out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
            }
            out += ' } ';
          } else {
            out += ' {} ';
          }
          out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (' + ($vSchema) + ' !== undefined) { ';
        }
        out += ' for (var ' + ($i) + ' = 0; ' + ($i) + ' < ' + ($vSchema) + '.length; ' + ($i) + '++) { if (' + ($data) + '[' + ($vSchema) + '[' + ($i) + ']] === undefined ';
        if ($ownProperties) {
          out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', ' + ($vSchema) + '[' + ($i) + ']) ';
        }
        out += ') {  var err =   '; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'';
            if (it.opts._errorDataPathProperty) {
              out += 'is a required property';
            } else {
              out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ';
        if ($isData) {
          out += '  }  ';
        }
      } else {
        var arr3 = $required;
        if (arr3) {
          var $propertyKey, i3 = -1,
            l3 = arr3.length - 1;
          while (i3 < l3) {
            $propertyKey = arr3[i3 += 1];
            var $prop = it.util.getProperty($propertyKey),
              $missingProperty = it.util.escapeQuotes($propertyKey),
              $useData = $data + $prop;
            if (it.opts._errorDataPathProperty) {
              it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
            }
            out += ' if ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') {  var err =   '; /* istanbul ignore else */
            if (it.createErrors !== false) {
              out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
              if (it.opts.messages !== false) {
                out += ' , message: \'';
                if (it.opts._errorDataPathProperty) {
                  out += 'is a required property';
                } else {
                  out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
                }
                out += '\' ';
              }
              if (it.opts.verbose) {
                out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
              }
              out += ' } ';
            } else {
              out += ' {} ';
            }
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
          }
        }
      }
    }
    it.errorPath = $currentErrorPath;
  } else if ($breakOnError) {
    out += ' if (true) {';
  }
  return out;
};

var uniqueItems = function generate_uniqueItems(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (($schema || $isData) && it.opts.uniqueItems !== false) {
    if ($isData) {
      out += ' var ' + ($valid) + '; if (' + ($schemaValue) + ' === false || ' + ($schemaValue) + ' === undefined) ' + ($valid) + ' = true; else if (typeof ' + ($schemaValue) + ' != \'boolean\') ' + ($valid) + ' = false; else { ';
    }
    out += ' var i = ' + ($data) + '.length , ' + ($valid) + ' = true , j; if (i > 1) { ';
    var $itemType = it.schema.items && it.schema.items.type,
      $typeIsArray = Array.isArray($itemType);
    if (!$itemType || $itemType == 'object' || $itemType == 'array' || ($typeIsArray && ($itemType.indexOf('object') >= 0 || $itemType.indexOf('array') >= 0))) {
      out += ' outer: for (;i--;) { for (j = i; j--;) { if (equal(' + ($data) + '[i], ' + ($data) + '[j])) { ' + ($valid) + ' = false; break outer; } } } ';
    } else {
      out += ' var itemIndices = {}, item; for (;i--;) { var item = ' + ($data) + '[i]; ';
      var $method = 'checkDataType' + ($typeIsArray ? 's' : '');
      out += ' if (' + (it.util[$method]($itemType, 'item', it.opts.strictNumbers, true)) + ') continue; ';
      if ($typeIsArray) {
        out += ' if (typeof item == \'string\') item = \'"\' + item; ';
      }
      out += ' if (typeof itemIndices[item] == \'number\') { ' + ($valid) + ' = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ';
    }
    out += ' } ';
    if ($isData) {
      out += '  }  ';
    }
    out += ' if (!' + ($valid) + ') {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('uniqueItems') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { i: i, j: j } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should NOT have duplicate items (items ## \' + j + \' and \' + i + \' are identical)\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema:  ';
        if ($isData) {
          out += 'validate.schema' + ($schemaPath);
        } else {
          out += '' + ($schema);
        }
        out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    out += ' } ';
    if ($breakOnError) {
      out += ' else { ';
    }
  } else {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  }
  return out;
};

//all requires must be explicit because browserify won't work with dynamic requires
var dotjs = {
  '$ref': ref,
  allOf: allOf,
  anyOf: anyOf,
  '$comment': comment,
  const: _const,
  contains: contains,
  dependencies: dependencies,
  'enum': _enum,
  format: format,
  'if': _if,
  items: items,
  maximum: _limit,
  minimum: _limit,
  maxItems: _limitItems,
  minItems: _limitItems,
  maxLength: _limitLength,
  minLength: _limitLength,
  maxProperties: _limitProperties,
  minProperties: _limitProperties,
  multipleOf: multipleOf,
  not: not,
  oneOf: oneOf,
  pattern: pattern,
  properties: properties$2,
  propertyNames: propertyNames,
  required: required$1,
  uniqueItems: uniqueItems,
  validate: validate$2
};

var ruleModules = dotjs
  , toHash = util$8.toHash;

var rules$1 = function rules() {
  var RULES = [
    { type: 'number',
      rules: [ { 'maximum': ['exclusiveMaximum'] },
               { 'minimum': ['exclusiveMinimum'] }, 'multipleOf', 'format'] },
    { type: 'string',
      rules: [ 'maxLength', 'minLength', 'pattern', 'format' ] },
    { type: 'array',
      rules: [ 'maxItems', 'minItems', 'items', 'contains', 'uniqueItems' ] },
    { type: 'object',
      rules: [ 'maxProperties', 'minProperties', 'required', 'dependencies', 'propertyNames',
               { 'properties': ['additionalProperties', 'patternProperties'] } ] },
    { rules: [ '$ref', 'const', 'enum', 'not', 'anyOf', 'oneOf', 'allOf', 'if' ] }
  ];

  var ALL = [ 'type', '$comment' ];
  var KEYWORDS = [
    '$schema', '$id', 'id', '$data', '$async', 'title',
    'description', 'default', 'definitions',
    'examples', 'readOnly', 'writeOnly',
    'contentMediaType', 'contentEncoding',
    'additionalItems', 'then', 'else'
  ];
  var TYPES = [ 'number', 'integer', 'string', 'array', 'object', 'boolean', 'null' ];
  RULES.all = toHash(ALL);
  RULES.types = toHash(TYPES);

  RULES.forEach(function (group) {
    group.rules = group.rules.map(function (keyword) {
      var implKeywords;
      if (typeof keyword == 'object') {
        var key = Object.keys(keyword)[0];
        implKeywords = keyword[key];
        keyword = key;
        implKeywords.forEach(function (k) {
          ALL.push(k);
          RULES.all[k] = true;
        });
      }
      ALL.push(keyword);
      var rule = RULES.all[keyword] = {
        keyword: keyword,
        code: ruleModules[keyword],
        implements: implKeywords
      };
      return rule;
    });

    RULES.all.$comment = {
      keyword: '$comment',
      code: ruleModules.$comment
    };

    if (group.type) RULES.types[group.type] = group;
  });

  RULES.keywords = toHash(ALL.concat(KEYWORDS));
  RULES.custom = {};

  return RULES;
};

var KEYWORDS = [
  'multipleOf',
  'maximum',
  'exclusiveMaximum',
  'minimum',
  'exclusiveMinimum',
  'maxLength',
  'minLength',
  'pattern',
  'additionalItems',
  'maxItems',
  'minItems',
  'uniqueItems',
  'maxProperties',
  'minProperties',
  'required',
  'additionalProperties',
  'enum',
  'format',
  'const'
];

var data = function (metaSchema, keywordsJsonPointers) {
  for (var i=0; i<keywordsJsonPointers.length; i++) {
    metaSchema = JSON.parse(JSON.stringify(metaSchema));
    var segments = keywordsJsonPointers[i].split('/');
    var keywords = metaSchema;
    var j;
    for (j=1; j<segments.length; j++)
      keywords = keywords[segments[j]];

    for (j=0; j<KEYWORDS.length; j++) {
      var key = KEYWORDS[j];
      var schema = keywords[key];
      if (schema) {
        keywords[key] = {
          anyOf: [
            schema,
            { $ref: 'https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#' }
          ]
        };
      }
    }
  }

  return metaSchema;
};

var MissingRefError = error_classes.MissingRef;

var async = compileAsync;


/**
 * Creates validating function for passed schema with asynchronous loading of missing schemas.
 * `loadSchema` option should be a function that accepts schema uri and returns promise that resolves with the schema.
 * @this  Ajv
 * @param {Object}   schema schema object
 * @param {Boolean}  meta optional true to compile meta-schema; this parameter can be skipped
 * @param {Function} callback an optional node-style callback, it is called with 2 parameters: error (or null) and validating function.
 * @return {Promise} promise that resolves with a validating function.
 */
function compileAsync(schema, meta, callback) {
  /* eslint no-shadow: 0 */
  /* global Promise */
  /* jshint validthis: true */
  var self = this;
  if (typeof this._opts.loadSchema != 'function')
    throw new Error('options.loadSchema should be a function');

  if (typeof meta == 'function') {
    callback = meta;
    meta = undefined;
  }

  var p = loadMetaSchemaOf(schema).then(function () {
    var schemaObj = self._addSchema(schema, undefined, meta);
    return schemaObj.validate || _compileAsync(schemaObj);
  });

  if (callback) {
    p.then(
      function(v) { callback(null, v); },
      callback
    );
  }

  return p;


  function loadMetaSchemaOf(sch) {
    var $schema = sch.$schema;
    return $schema && !self.getSchema($schema)
            ? compileAsync.call(self, { $ref: $schema }, true)
            : Promise.resolve();
  }


  function _compileAsync(schemaObj) {
    try { return self._compile(schemaObj); }
    catch(e) {
      if (e instanceof MissingRefError) return loadMissingSchema(e);
      throw e;
    }


    function loadMissingSchema(e) {
      var ref = e.missingSchema;
      if (added(ref)) throw new Error('Schema ' + ref + ' is loaded but ' + e.missingRef + ' cannot be resolved');

      var schemaPromise = self._loadingSchemas[ref];
      if (!schemaPromise) {
        schemaPromise = self._loadingSchemas[ref] = self._opts.loadSchema(ref);
        schemaPromise.then(removePromise, removePromise);
      }

      return schemaPromise.then(function (sch) {
        if (!added(ref)) {
          return loadMetaSchemaOf(sch).then(function () {
            if (!added(ref)) self.addSchema(sch, ref, undefined, meta);
          });
        }
      }).then(function() {
        return _compileAsync(schemaObj);
      });

      function removePromise() {
        delete self._loadingSchemas[ref];
      }

      function added(ref) {
        return self._refs[ref] || self._schemas[ref];
      }
    }
  }
}

var custom = function generate_custom(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $rule = this,
    $definition = 'definition' + $lvl,
    $rDef = $rule.definition,
    $closingBraces = '';
  var $compile, $inline, $macro, $ruleValidate, $validateCode;
  if ($isData && $rDef.$data) {
    $validateCode = 'keywordValidate' + $lvl;
    var $validateSchema = $rDef.validateSchema;
    out += ' var ' + ($definition) + ' = RULES.custom[\'' + ($keyword) + '\'].definition; var ' + ($validateCode) + ' = ' + ($definition) + '.validate;';
  } else {
    $ruleValidate = it.useCustomRule($rule, $schema, it.schema, it);
    if (!$ruleValidate) return;
    $schemaValue = 'validate.schema' + $schemaPath;
    $validateCode = $ruleValidate.code;
    $compile = $rDef.compile;
    $inline = $rDef.inline;
    $macro = $rDef.macro;
  }
  var $ruleErrs = $validateCode + '.errors',
    $i = 'i' + $lvl,
    $ruleErr = 'ruleErr' + $lvl,
    $asyncKeyword = $rDef.async;
  if ($asyncKeyword && !it.async) throw new Error('async keyword in sync schema');
  if (!($inline || $macro)) {
    out += '' + ($ruleErrs) + ' = null;';
  }
  out += 'var ' + ($errs) + ' = errors;var ' + ($valid) + ';';
  if ($isData && $rDef.$data) {
    $closingBraces += '}';
    out += ' if (' + ($schemaValue) + ' === undefined) { ' + ($valid) + ' = true; } else { ';
    if ($validateSchema) {
      $closingBraces += '}';
      out += ' ' + ($valid) + ' = ' + ($definition) + '.validateSchema(' + ($schemaValue) + '); if (' + ($valid) + ') { ';
    }
  }
  if ($inline) {
    if ($rDef.statements) {
      out += ' ' + ($ruleValidate.validate) + ' ';
    } else {
      out += ' ' + ($valid) + ' = ' + ($ruleValidate.validate) + '; ';
    }
  } else if ($macro) {
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    $it.schema = $ruleValidate.validate;
    $it.schemaPath = '';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var $code = it.validate($it).replace(/validate\.schema/g, $validateCode);
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' ' + ($code);
  } else {
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = '';
    out += '  ' + ($validateCode) + '.call( ';
    if (it.opts.passContext) {
      out += 'this';
    } else {
      out += 'self';
    }
    if ($compile || $rDef.schema === false) {
      out += ' , ' + ($data) + ' ';
    } else {
      out += ' , ' + ($schemaValue) + ' , ' + ($data) + ' , validate.schema' + (it.schemaPath) + ' ';
    }
    out += ' , (dataPath || \'\')';
    if (it.errorPath != '""') {
      out += ' + ' + (it.errorPath);
    }
    var $parentData = $dataLvl ? 'data' + (($dataLvl - 1) || '') : 'parentData',
      $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
    out += ' , ' + ($parentData) + ' , ' + ($parentDataProperty) + ' , rootData )  ';
    var def_callRuleValidate = out;
    out = $$outStack.pop();
    if ($rDef.errors === false) {
      out += ' ' + ($valid) + ' = ';
      if ($asyncKeyword) {
        out += 'await ';
      }
      out += '' + (def_callRuleValidate) + '; ';
    } else {
      if ($asyncKeyword) {
        $ruleErrs = 'customErrors' + $lvl;
        out += ' var ' + ($ruleErrs) + ' = null; try { ' + ($valid) + ' = await ' + (def_callRuleValidate) + '; } catch (e) { ' + ($valid) + ' = false; if (e instanceof ValidationError) ' + ($ruleErrs) + ' = e.errors; else throw e; } ';
      } else {
        out += ' ' + ($ruleErrs) + ' = null; ' + ($valid) + ' = ' + (def_callRuleValidate) + '; ';
      }
    }
  }
  if ($rDef.modifying) {
    out += ' if (' + ($parentData) + ') ' + ($data) + ' = ' + ($parentData) + '[' + ($parentDataProperty) + '];';
  }
  out += '' + ($closingBraces);
  if ($rDef.valid) {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  } else {
    out += ' if ( ';
    if ($rDef.valid === undefined) {
      out += ' !';
      if ($macro) {
        out += '' + ($nextValid);
      } else {
        out += '' + ($valid);
      }
    } else {
      out += ' ' + (!$rDef.valid) + ' ';
    }
    out += ') { ';
    $errorKeyword = $rule.keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = '';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { keyword: \'' + ($rule.keyword) + '\' } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should pass "' + ($rule.keyword) + '" keyword validation\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
      /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    var def_customError = out;
    out = $$outStack.pop();
    if ($inline) {
      if ($rDef.errors) {
        if ($rDef.errors != 'full') {
          out += '  for (var ' + ($i) + '=' + ($errs) + '; ' + ($i) + '<errors; ' + ($i) + '++) { var ' + ($ruleErr) + ' = vErrors[' + ($i) + ']; if (' + ($ruleErr) + '.dataPath === undefined) ' + ($ruleErr) + '.dataPath = (dataPath || \'\') + ' + (it.errorPath) + '; if (' + ($ruleErr) + '.schemaPath === undefined) { ' + ($ruleErr) + '.schemaPath = "' + ($errSchemaPath) + '"; } ';
          if (it.opts.verbose) {
            out += ' ' + ($ruleErr) + '.schema = ' + ($schemaValue) + '; ' + ($ruleErr) + '.data = ' + ($data) + '; ';
          }
          out += ' } ';
        }
      } else {
        if ($rDef.errors === false) {
          out += ' ' + (def_customError) + ' ';
        } else {
          out += ' if (' + ($errs) + ' == errors) { ' + (def_customError) + ' } else {  for (var ' + ($i) + '=' + ($errs) + '; ' + ($i) + '<errors; ' + ($i) + '++) { var ' + ($ruleErr) + ' = vErrors[' + ($i) + ']; if (' + ($ruleErr) + '.dataPath === undefined) ' + ($ruleErr) + '.dataPath = (dataPath || \'\') + ' + (it.errorPath) + '; if (' + ($ruleErr) + '.schemaPath === undefined) { ' + ($ruleErr) + '.schemaPath = "' + ($errSchemaPath) + '"; } ';
          if (it.opts.verbose) {
            out += ' ' + ($ruleErr) + '.schema = ' + ($schemaValue) + '; ' + ($ruleErr) + '.data = ' + ($data) + '; ';
          }
          out += ' } } ';
        }
      }
    } else if ($macro) {
      out += '   var err =   '; /* istanbul ignore else */
      if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { keyword: \'' + ($rule.keyword) + '\' } ';
        if (it.opts.messages !== false) {
          out += ' , message: \'should pass "' + ($rule.keyword) + '" keyword validation\' ';
        }
        if (it.opts.verbose) {
          out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
        }
        out += ' } ';
      } else {
        out += ' {} ';
      }
      out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
      if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */
        if (it.async) {
          out += ' throw new ValidationError(vErrors); ';
        } else {
          out += ' validate.errors = vErrors; return false; ';
        }
      }
    } else {
      if ($rDef.errors === false) {
        out += ' ' + (def_customError) + ' ';
      } else {
        out += ' if (Array.isArray(' + ($ruleErrs) + ')) { if (vErrors === null) vErrors = ' + ($ruleErrs) + '; else vErrors = vErrors.concat(' + ($ruleErrs) + '); errors = vErrors.length;  for (var ' + ($i) + '=' + ($errs) + '; ' + ($i) + '<errors; ' + ($i) + '++) { var ' + ($ruleErr) + ' = vErrors[' + ($i) + ']; if (' + ($ruleErr) + '.dataPath === undefined) ' + ($ruleErr) + '.dataPath = (dataPath || \'\') + ' + (it.errorPath) + ';  ' + ($ruleErr) + '.schemaPath = "' + ($errSchemaPath) + '";  ';
        if (it.opts.verbose) {
          out += ' ' + ($ruleErr) + '.schema = ' + ($schemaValue) + '; ' + ($ruleErr) + '.data = ' + ($data) + '; ';
        }
        out += ' } } else { ' + (def_customError) + ' } ';
      }
    }
    out += ' } ';
    if ($breakOnError) {
      out += ' else { ';
    }
  }
  return out;
};

var $schema$1 = "http://json-schema.org/draft-07/schema#";
var $id$1 = "http://json-schema.org/draft-07/schema#";
var title = "Core schema meta-schema";
var definitions = {
	schemaArray: {
		type: "array",
		minItems: 1,
		items: {
			$ref: "#"
		}
	},
	nonNegativeInteger: {
		type: "integer",
		minimum: 0
	},
	nonNegativeIntegerDefault0: {
		allOf: [
			{
				$ref: "#/definitions/nonNegativeInteger"
			},
			{
				"default": 0
			}
		]
	},
	simpleTypes: {
		"enum": [
			"array",
			"boolean",
			"integer",
			"null",
			"number",
			"object",
			"string"
		]
	},
	stringArray: {
		type: "array",
		items: {
			type: "string"
		},
		uniqueItems: true,
		"default": [
		]
	}
};
var type$1 = [
	"object",
	"boolean"
];
var properties$1 = {
	$id: {
		type: "string",
		format: "uri-reference"
	},
	$schema: {
		type: "string",
		format: "uri"
	},
	$ref: {
		type: "string",
		format: "uri-reference"
	},
	$comment: {
		type: "string"
	},
	title: {
		type: "string"
	},
	description: {
		type: "string"
	},
	"default": true,
	readOnly: {
		type: "boolean",
		"default": false
	},
	examples: {
		type: "array",
		items: true
	},
	multipleOf: {
		type: "number",
		exclusiveMinimum: 0
	},
	maximum: {
		type: "number"
	},
	exclusiveMaximum: {
		type: "number"
	},
	minimum: {
		type: "number"
	},
	exclusiveMinimum: {
		type: "number"
	},
	maxLength: {
		$ref: "#/definitions/nonNegativeInteger"
	},
	minLength: {
		$ref: "#/definitions/nonNegativeIntegerDefault0"
	},
	pattern: {
		type: "string",
		format: "regex"
	},
	additionalItems: {
		$ref: "#"
	},
	items: {
		anyOf: [
			{
				$ref: "#"
			},
			{
				$ref: "#/definitions/schemaArray"
			}
		],
		"default": true
	},
	maxItems: {
		$ref: "#/definitions/nonNegativeInteger"
	},
	minItems: {
		$ref: "#/definitions/nonNegativeIntegerDefault0"
	},
	uniqueItems: {
		type: "boolean",
		"default": false
	},
	contains: {
		$ref: "#"
	},
	maxProperties: {
		$ref: "#/definitions/nonNegativeInteger"
	},
	minProperties: {
		$ref: "#/definitions/nonNegativeIntegerDefault0"
	},
	required: {
		$ref: "#/definitions/stringArray"
	},
	additionalProperties: {
		$ref: "#"
	},
	definitions: {
		type: "object",
		additionalProperties: {
			$ref: "#"
		},
		"default": {
		}
	},
	properties: {
		type: "object",
		additionalProperties: {
			$ref: "#"
		},
		"default": {
		}
	},
	patternProperties: {
		type: "object",
		additionalProperties: {
			$ref: "#"
		},
		propertyNames: {
			format: "regex"
		},
		"default": {
		}
	},
	dependencies: {
		type: "object",
		additionalProperties: {
			anyOf: [
				{
					$ref: "#"
				},
				{
					$ref: "#/definitions/stringArray"
				}
			]
		}
	},
	propertyNames: {
		$ref: "#"
	},
	"const": true,
	"enum": {
		type: "array",
		items: true,
		minItems: 1,
		uniqueItems: true
	},
	type: {
		anyOf: [
			{
				$ref: "#/definitions/simpleTypes"
			},
			{
				type: "array",
				items: {
					$ref: "#/definitions/simpleTypes"
				},
				minItems: 1,
				uniqueItems: true
			}
		]
	},
	format: {
		type: "string"
	},
	contentMediaType: {
		type: "string"
	},
	contentEncoding: {
		type: "string"
	},
	"if": {
		$ref: "#"
	},
	then: {
		$ref: "#"
	},
	"else": {
		$ref: "#"
	},
	allOf: {
		$ref: "#/definitions/schemaArray"
	},
	anyOf: {
		$ref: "#/definitions/schemaArray"
	},
	oneOf: {
		$ref: "#/definitions/schemaArray"
	},
	not: {
		$ref: "#"
	}
};
var require$$13 = {
	$schema: $schema$1,
	$id: $id$1,
	title: title,
	definitions: definitions,
	type: type$1,
	properties: properties$1,
	"default": true
};

var metaSchema = require$$13;

var definition_schema = {
  $id: 'https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js',
  definitions: {
    simpleTypes: metaSchema.definitions.simpleTypes
  },
  type: 'object',
  dependencies: {
    schema: ['validate'],
    $data: ['validate'],
    statements: ['inline'],
    valid: {not: {required: ['macro']}}
  },
  properties: {
    type: metaSchema.properties.type,
    schema: {type: 'boolean'},
    statements: {type: 'boolean'},
    dependencies: {
      type: 'array',
      items: {type: 'string'}
    },
    metaSchema: {type: 'object'},
    modifying: {type: 'boolean'},
    valid: {type: 'boolean'},
    $data: {type: 'boolean'},
    async: {type: 'boolean'},
    errors: {
      anyOf: [
        {type: 'boolean'},
        {const: 'full'}
      ]
    }
  }
};

var IDENTIFIER = /^[a-z_$][a-z0-9_$-]*$/i;
var customRuleCode = custom;
var definitionSchema = definition_schema;

var keyword = {
  add: addKeyword,
  get: getKeyword,
  remove: removeKeyword,
  validate: validateKeyword
};


/**
 * Define custom keyword
 * @this  Ajv
 * @param {String} keyword custom keyword, should be unique (including different from all standard, custom and macro keywords).
 * @param {Object} definition keyword definition object with properties `type` (type(s) which the keyword applies to), `validate` or `compile`.
 * @return {Ajv} this for method chaining
 */
function addKeyword(keyword, definition) {
  /* jshint validthis: true */
  /* eslint no-shadow: 0 */
  var RULES = this.RULES;
  if (RULES.keywords[keyword])
    throw new Error('Keyword ' + keyword + ' is already defined');

  if (!IDENTIFIER.test(keyword))
    throw new Error('Keyword ' + keyword + ' is not a valid identifier');

  if (definition) {
    this.validateKeyword(definition, true);

    var dataType = definition.type;
    if (Array.isArray(dataType)) {
      for (var i=0; i<dataType.length; i++)
        _addRule(keyword, dataType[i], definition);
    } else {
      _addRule(keyword, dataType, definition);
    }

    var metaSchema = definition.metaSchema;
    if (metaSchema) {
      if (definition.$data && this._opts.$data) {
        metaSchema = {
          anyOf: [
            metaSchema,
            { '$ref': 'https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#' }
          ]
        };
      }
      definition.validateSchema = this.compile(metaSchema, true);
    }
  }

  RULES.keywords[keyword] = RULES.all[keyword] = true;


  function _addRule(keyword, dataType, definition) {
    var ruleGroup;
    for (var i=0; i<RULES.length; i++) {
      var rg = RULES[i];
      if (rg.type == dataType) {
        ruleGroup = rg;
        break;
      }
    }

    if (!ruleGroup) {
      ruleGroup = { type: dataType, rules: [] };
      RULES.push(ruleGroup);
    }

    var rule = {
      keyword: keyword,
      definition: definition,
      custom: true,
      code: customRuleCode,
      implements: definition.implements
    };
    ruleGroup.rules.push(rule);
    RULES.custom[keyword] = rule;
  }

  return this;
}


/**
 * Get keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Object|Boolean} custom keyword definition, `true` if it is a predefined keyword, `false` otherwise.
 */
function getKeyword(keyword) {
  /* jshint validthis: true */
  var rule = this.RULES.custom[keyword];
  return rule ? rule.definition : this.RULES.keywords[keyword] || false;
}


/**
 * Remove keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Ajv} this for method chaining
 */
function removeKeyword(keyword) {
  /* jshint validthis: true */
  var RULES = this.RULES;
  delete RULES.keywords[keyword];
  delete RULES.all[keyword];
  delete RULES.custom[keyword];
  for (var i=0; i<RULES.length; i++) {
    var rules = RULES[i].rules;
    for (var j=0; j<rules.length; j++) {
      if (rules[j].keyword == keyword) {
        rules.splice(j, 1);
        break;
      }
    }
  }
  return this;
}


/**
 * Validate keyword definition
 * @this  Ajv
 * @param {Object} definition keyword definition object.
 * @param {Boolean} throwError true to throw exception if definition is invalid
 * @return {boolean} validation result
 */
function validateKeyword(definition, throwError) {
  validateKeyword.errors = null;
  var v = this._validateKeyword = this._validateKeyword
                                  || this.compile(definitionSchema, true);

  if (v(definition)) return true;
  validateKeyword.errors = v.errors;
  if (throwError)
    throw new Error('custom keyword definition is invalid: '  + this.errorsText(v.errors));
  else
    return false;
}

var $schema = "http://json-schema.org/draft-07/schema#";
var $id = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#";
var description = "Meta-schema for $data reference (JSON Schema extension proposal)";
var type = "object";
var required = [
	"$data"
];
var properties = {
	$data: {
		type: "string",
		anyOf: [
			{
				format: "relative-json-pointer"
			},
			{
				format: "json-pointer"
			}
		]
	}
};
var additionalProperties = false;
var require$$12 = {
	$schema: $schema,
	$id: $id,
	description: description,
	type: type,
	required: required,
	properties: properties,
	additionalProperties: additionalProperties
};

var compileSchema = compile_1
  , resolve = resolve_1
  , Cache = cache.exports
  , SchemaObject = schema_obj
  , stableStringify = fastJsonStableStringify
  , formats = formats_1
  , rules = rules$1
  , $dataMetaSchema = data
  , util$3 = util$8;

var ajv = Ajv;

Ajv.prototype.validate = validate$1;
Ajv.prototype.compile = compile;
Ajv.prototype.addSchema = addSchema;
Ajv.prototype.addMetaSchema = addMetaSchema;
Ajv.prototype.validateSchema = validateSchema;
Ajv.prototype.getSchema = getSchema;
Ajv.prototype.removeSchema = removeSchema;
Ajv.prototype.addFormat = addFormat;
Ajv.prototype.errorsText = errorsText;

Ajv.prototype._addSchema = _addSchema;
Ajv.prototype._compile = _compile;

Ajv.prototype.compileAsync = async;
var customKeyword = keyword;
Ajv.prototype.addKeyword = customKeyword.add;
Ajv.prototype.getKeyword = customKeyword.get;
Ajv.prototype.removeKeyword = customKeyword.remove;
Ajv.prototype.validateKeyword = customKeyword.validate;

var errorClasses = error_classes;
Ajv.ValidationError = errorClasses.Validation;
Ajv.MissingRefError = errorClasses.MissingRef;
Ajv.$dataMetaSchema = $dataMetaSchema;

var META_SCHEMA_ID = 'http://json-schema.org/draft-07/schema';

var META_IGNORE_OPTIONS = [ 'removeAdditional', 'useDefaults', 'coerceTypes', 'strictDefaults' ];
var META_SUPPORT_DATA = ['/properties'];

/**
 * Creates validator instance.
 * Usage: `Ajv(opts)`
 * @param {Object} opts optional options
 * @return {Object} ajv instance
 */
function Ajv(opts) {
  if (!(this instanceof Ajv)) return new Ajv(opts);
  opts = this._opts = util$3.copy(opts) || {};
  setLogger(this);
  this._schemas = {};
  this._refs = {};
  this._fragments = {};
  this._formats = formats(opts.format);

  this._cache = opts.cache || new Cache;
  this._loadingSchemas = {};
  this._compilations = [];
  this.RULES = rules();
  this._getId = chooseGetId(opts);

  opts.loopRequired = opts.loopRequired || Infinity;
  if (opts.errorDataPath == 'property') opts._errorDataPathProperty = true;
  if (opts.serialize === undefined) opts.serialize = stableStringify;
  this._metaOpts = getMetaSchemaOptions(this);

  if (opts.formats) addInitialFormats(this);
  if (opts.keywords) addInitialKeywords(this);
  addDefaultMetaSchema(this);
  if (typeof opts.meta == 'object') this.addMetaSchema(opts.meta);
  if (opts.nullable) this.addKeyword('nullable', {metaSchema: {type: 'boolean'}});
  addInitialSchemas(this);
}



/**
 * Validate data using schema
 * Schema will be compiled and cached (using serialized JSON as key. [fast-json-stable-stringify](https://github.com/epoberezkin/fast-json-stable-stringify) is used to serialize.
 * @this   Ajv
 * @param  {String|Object} schemaKeyRef key, ref or schema object
 * @param  {Any} data to be validated
 * @return {Boolean} validation result. Errors from the last validation will be available in `ajv.errors` (and also in compiled schema: `schema.errors`).
 */
function validate$1(schemaKeyRef, data) {
  var v;
  if (typeof schemaKeyRef == 'string') {
    v = this.getSchema(schemaKeyRef);
    if (!v) throw new Error('no schema with key or ref "' + schemaKeyRef + '"');
  } else {
    var schemaObj = this._addSchema(schemaKeyRef);
    v = schemaObj.validate || this._compile(schemaObj);
  }

  var valid = v(data);
  if (v.$async !== true) this.errors = v.errors;
  return valid;
}


/**
 * Create validating function for passed schema.
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Boolean} _meta true if schema is a meta-schema. Used internally to compile meta schemas of custom keywords.
 * @return {Function} validating function
 */
function compile(schema, _meta) {
  var schemaObj = this._addSchema(schema, undefined, _meta);
  return schemaObj.validate || this._compile(schemaObj);
}


/**
 * Adds schema to the instance.
 * @this   Ajv
 * @param {Object|Array} schema schema or array of schemas. If array is passed, `key` and other parameters will be ignored.
 * @param {String} key Optional schema key. Can be passed to `validate` method instead of schema object or id/ref. One schema per instance can have empty `id` and `key`.
 * @param {Boolean} _skipValidation true to skip schema validation. Used internally, option validateSchema should be used instead.
 * @param {Boolean} _meta true if schema is a meta-schema. Used internally, addMetaSchema should be used instead.
 * @return {Ajv} this for method chaining
 */
function addSchema(schema, key, _skipValidation, _meta) {
  if (Array.isArray(schema)){
    for (var i=0; i<schema.length; i++) this.addSchema(schema[i], undefined, _skipValidation, _meta);
    return this;
  }
  var id = this._getId(schema);
  if (id !== undefined && typeof id != 'string')
    throw new Error('schema id must be string');
  key = resolve.normalizeId(key || id);
  checkUnique(this, key);
  this._schemas[key] = this._addSchema(schema, _skipValidation, _meta, true);
  return this;
}


/**
 * Add schema that will be used to validate other schemas
 * options in META_IGNORE_OPTIONS are alway set to false
 * @this   Ajv
 * @param {Object} schema schema object
 * @param {String} key optional schema key
 * @param {Boolean} skipValidation true to skip schema validation, can be used to override validateSchema option for meta-schema
 * @return {Ajv} this for method chaining
 */
function addMetaSchema(schema, key, skipValidation) {
  this.addSchema(schema, key, skipValidation, true);
  return this;
}


/**
 * Validate schema
 * @this   Ajv
 * @param {Object} schema schema to validate
 * @param {Boolean} throwOrLogError pass true to throw (or log) an error if invalid
 * @return {Boolean} true if schema is valid
 */
function validateSchema(schema, throwOrLogError) {
  var $schema = schema.$schema;
  if ($schema !== undefined && typeof $schema != 'string')
    throw new Error('$schema must be a string');
  $schema = $schema || this._opts.defaultMeta || defaultMeta(this);
  if (!$schema) {
    this.logger.warn('meta-schema not available');
    this.errors = null;
    return true;
  }
  var valid = this.validate($schema, schema);
  if (!valid && throwOrLogError) {
    var message = 'schema is invalid: ' + this.errorsText();
    if (this._opts.validateSchema == 'log') this.logger.error(message);
    else throw new Error(message);
  }
  return valid;
}


function defaultMeta(self) {
  var meta = self._opts.meta;
  self._opts.defaultMeta = typeof meta == 'object'
                            ? self._getId(meta) || meta
                            : self.getSchema(META_SCHEMA_ID)
                              ? META_SCHEMA_ID
                              : undefined;
  return self._opts.defaultMeta;
}


/**
 * Get compiled schema from the instance by `key` or `ref`.
 * @this   Ajv
 * @param  {String} keyRef `key` that was passed to `addSchema` or full schema reference (`schema.id` or resolved id).
 * @return {Function} schema validating function (with property `schema`).
 */
function getSchema(keyRef) {
  var schemaObj = _getSchemaObj(this, keyRef);
  switch (typeof schemaObj) {
    case 'object': return schemaObj.validate || this._compile(schemaObj);
    case 'string': return this.getSchema(schemaObj);
    case 'undefined': return _getSchemaFragment(this, keyRef);
  }
}


function _getSchemaFragment(self, ref) {
  var res = resolve.schema.call(self, { schema: {} }, ref);
  if (res) {
    var schema = res.schema
      , root = res.root
      , baseId = res.baseId;
    var v = compileSchema.call(self, schema, root, undefined, baseId);
    self._fragments[ref] = new SchemaObject({
      ref: ref,
      fragment: true,
      schema: schema,
      root: root,
      baseId: baseId,
      validate: v
    });
    return v;
  }
}


function _getSchemaObj(self, keyRef) {
  keyRef = resolve.normalizeId(keyRef);
  return self._schemas[keyRef] || self._refs[keyRef] || self._fragments[keyRef];
}


/**
 * Remove cached schema(s).
 * If no parameter is passed all schemas but meta-schemas are removed.
 * If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
 * Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
 * @this   Ajv
 * @param  {String|Object|RegExp} schemaKeyRef key, ref, pattern to match key/ref or schema object
 * @return {Ajv} this for method chaining
 */
function removeSchema(schemaKeyRef) {
  if (schemaKeyRef instanceof RegExp) {
    _removeAllSchemas(this, this._schemas, schemaKeyRef);
    _removeAllSchemas(this, this._refs, schemaKeyRef);
    return this;
  }
  switch (typeof schemaKeyRef) {
    case 'undefined':
      _removeAllSchemas(this, this._schemas);
      _removeAllSchemas(this, this._refs);
      this._cache.clear();
      return this;
    case 'string':
      var schemaObj = _getSchemaObj(this, schemaKeyRef);
      if (schemaObj) this._cache.del(schemaObj.cacheKey);
      delete this._schemas[schemaKeyRef];
      delete this._refs[schemaKeyRef];
      return this;
    case 'object':
      var serialize = this._opts.serialize;
      var cacheKey = serialize ? serialize(schemaKeyRef) : schemaKeyRef;
      this._cache.del(cacheKey);
      var id = this._getId(schemaKeyRef);
      if (id) {
        id = resolve.normalizeId(id);
        delete this._schemas[id];
        delete this._refs[id];
      }
  }
  return this;
}


function _removeAllSchemas(self, schemas, regex) {
  for (var keyRef in schemas) {
    var schemaObj = schemas[keyRef];
    if (!schemaObj.meta && (!regex || regex.test(keyRef))) {
      self._cache.del(schemaObj.cacheKey);
      delete schemas[keyRef];
    }
  }
}


/* @this   Ajv */
function _addSchema(schema, skipValidation, meta, shouldAddSchema) {
  if (typeof schema != 'object' && typeof schema != 'boolean')
    throw new Error('schema should be object or boolean');
  var serialize = this._opts.serialize;
  var cacheKey = serialize ? serialize(schema) : schema;
  var cached = this._cache.get(cacheKey);
  if (cached) return cached;

  shouldAddSchema = shouldAddSchema || this._opts.addUsedSchema !== false;

  var id = resolve.normalizeId(this._getId(schema));
  if (id && shouldAddSchema) checkUnique(this, id);

  var willValidate = this._opts.validateSchema !== false && !skipValidation;
  var recursiveMeta;
  if (willValidate && !(recursiveMeta = id && id == resolve.normalizeId(schema.$schema)))
    this.validateSchema(schema, true);

  var localRefs = resolve.ids.call(this, schema);

  var schemaObj = new SchemaObject({
    id: id,
    schema: schema,
    localRefs: localRefs,
    cacheKey: cacheKey,
    meta: meta
  });

  if (id[0] != '#' && shouldAddSchema) this._refs[id] = schemaObj;
  this._cache.put(cacheKey, schemaObj);

  if (willValidate && recursiveMeta) this.validateSchema(schema, true);

  return schemaObj;
}


/* @this   Ajv */
function _compile(schemaObj, root) {
  if (schemaObj.compiling) {
    schemaObj.validate = callValidate;
    callValidate.schema = schemaObj.schema;
    callValidate.errors = null;
    callValidate.root = root ? root : callValidate;
    if (schemaObj.schema.$async === true)
      callValidate.$async = true;
    return callValidate;
  }
  schemaObj.compiling = true;

  var currentOpts;
  if (schemaObj.meta) {
    currentOpts = this._opts;
    this._opts = this._metaOpts;
  }

  var v;
  try { v = compileSchema.call(this, schemaObj.schema, root, schemaObj.localRefs); }
  catch(e) {
    delete schemaObj.validate;
    throw e;
  }
  finally {
    schemaObj.compiling = false;
    if (schemaObj.meta) this._opts = currentOpts;
  }

  schemaObj.validate = v;
  schemaObj.refs = v.refs;
  schemaObj.refVal = v.refVal;
  schemaObj.root = v.root;
  return v;


  /* @this   {*} - custom context, see passContext option */
  function callValidate() {
    /* jshint validthis: true */
    var _validate = schemaObj.validate;
    var result = _validate.apply(this, arguments);
    callValidate.errors = _validate.errors;
    return result;
  }
}


function chooseGetId(opts) {
  switch (opts.schemaId) {
    case 'auto': return _get$IdOrId;
    case 'id': return _getId;
    default: return _get$Id;
  }
}

/* @this   Ajv */
function _getId(schema) {
  if (schema.$id) this.logger.warn('schema $id ignored', schema.$id);
  return schema.id;
}

/* @this   Ajv */
function _get$Id(schema) {
  if (schema.id) this.logger.warn('schema id ignored', schema.id);
  return schema.$id;
}


function _get$IdOrId(schema) {
  if (schema.$id && schema.id && schema.$id != schema.id)
    throw new Error('schema $id is different from id');
  return schema.$id || schema.id;
}


/**
 * Convert array of error message objects to string
 * @this   Ajv
 * @param  {Array<Object>} errors optional array of validation errors, if not passed errors from the instance are used.
 * @param  {Object} options optional options with properties `separator` and `dataVar`.
 * @return {String} human readable string with all errors descriptions
 */
function errorsText(errors, options) {
  errors = errors || this.errors;
  if (!errors) return 'No errors';
  options = options || {};
  var separator = options.separator === undefined ? ', ' : options.separator;
  var dataVar = options.dataVar === undefined ? 'data' : options.dataVar;

  var text = '';
  for (var i=0; i<errors.length; i++) {
    var e = errors[i];
    if (e) text += dataVar + e.dataPath + ' ' + e.message + separator;
  }
  return text.slice(0, -separator.length);
}


/**
 * Add custom format
 * @this   Ajv
 * @param {String} name format name
 * @param {String|RegExp|Function} format string is converted to RegExp; function should return boolean (true when valid)
 * @return {Ajv} this for method chaining
 */
function addFormat(name, format) {
  if (typeof format == 'string') format = new RegExp(format);
  this._formats[name] = format;
  return this;
}


function addDefaultMetaSchema(self) {
  var $dataSchema;
  if (self._opts.$data) {
    $dataSchema = require$$12;
    self.addMetaSchema($dataSchema, $dataSchema.$id, true);
  }
  if (self._opts.meta === false) return;
  var metaSchema = require$$13;
  if (self._opts.$data) metaSchema = $dataMetaSchema(metaSchema, META_SUPPORT_DATA);
  self.addMetaSchema(metaSchema, META_SCHEMA_ID, true);
  self._refs['http://json-schema.org/schema'] = META_SCHEMA_ID;
}


function addInitialSchemas(self) {
  var optsSchemas = self._opts.schemas;
  if (!optsSchemas) return;
  if (Array.isArray(optsSchemas)) self.addSchema(optsSchemas);
  else for (var key in optsSchemas) self.addSchema(optsSchemas[key], key);
}


function addInitialFormats(self) {
  for (var name in self._opts.formats) {
    var format = self._opts.formats[name];
    self.addFormat(name, format);
  }
}


function addInitialKeywords(self) {
  for (var name in self._opts.keywords) {
    var keyword = self._opts.keywords[name];
    self.addKeyword(name, keyword);
  }
}


function checkUnique(self, id) {
  if (self._schemas[id] || self._refs[id])
    throw new Error('schema with key or id "' + id + '" already exists');
}


function getMetaSchemaOptions(self) {
  var metaOpts = util$3.copy(self._opts);
  for (var i=0; i<META_IGNORE_OPTIONS.length; i++)
    delete metaOpts[META_IGNORE_OPTIONS[i]];
  return metaOpts;
}


function setLogger(self) {
  var logger = self._opts.logger;
  if (logger === false) {
    self.logger = {log: noop, warn: noop, error: noop};
  } else {
    if (logger === undefined) logger = console;
    if (!(typeof logger == 'object' && logger.log && logger.warn && logger.error))
      throw new Error('logger must implement log, warn and error methods');
    self.logger = logger;
  }
}


function noop() {}

var src$6 = {exports: {}};

// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function base$c (ALPHABET) {
  if (ALPHABET.length >= 255) { throw new TypeError('Alphabet too long') }
  var BASE_MAP = new Uint8Array(256);
  for (var j = 0; j < BASE_MAP.length; j++) {
    BASE_MAP[j] = 255;
  }
  for (var i = 0; i < ALPHABET.length; i++) {
    var x = ALPHABET.charAt(i);
    var xc = x.charCodeAt(0);
    if (BASE_MAP[xc] !== 255) { throw new TypeError(x + ' is ambiguous') }
    BASE_MAP[xc] = i;
  }
  var BASE = ALPHABET.length;
  var LEADER = ALPHABET.charAt(0);
  var FACTOR = Math.log(BASE) / Math.log(256); // log(BASE) / log(256), rounded up
  var iFACTOR = Math.log(256) / Math.log(BASE); // log(256) / log(BASE), rounded up
  function encode (source) {
    if (source instanceof Uint8Array) ; else if (ArrayBuffer.isView(source)) {
      source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
    } else if (Array.isArray(source)) {
      source = Uint8Array.from(source);
    }
    if (!(source instanceof Uint8Array)) { throw new TypeError('Expected Uint8Array') }
    if (source.length === 0) { return '' }
        // Skip & count leading zeroes.
    var zeroes = 0;
    var length = 0;
    var pbegin = 0;
    var pend = source.length;
    while (pbegin !== pend && source[pbegin] === 0) {
      pbegin++;
      zeroes++;
    }
        // Allocate enough space in big-endian base58 representation.
    var size = ((pend - pbegin) * iFACTOR + 1) >>> 0;
    var b58 = new Uint8Array(size);
        // Process the bytes.
    while (pbegin !== pend) {
      var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
      var i = 0;
      for (var it1 = size - 1; (carry !== 0 || i < length) && (it1 !== -1); it1--, i++) {
        carry += (256 * b58[it1]) >>> 0;
        b58[it1] = (carry % BASE) >>> 0;
        carry = (carry / BASE) >>> 0;
      }
      if (carry !== 0) { throw new Error('Non-zero carry') }
      length = i;
      pbegin++;
    }
        // Skip leading zeroes in base58 result.
    var it2 = size - length;
    while (it2 !== size && b58[it2] === 0) {
      it2++;
    }
        // Translate the result into a string.
    var str = LEADER.repeat(zeroes);
    for (; it2 < size; ++it2) { str += ALPHABET.charAt(b58[it2]); }
    return str
  }
  function decodeUnsafe (source) {
    if (typeof source !== 'string') { throw new TypeError('Expected String') }
    if (source.length === 0) { return new Uint8Array() }
    var psz = 0;
        // Skip leading spaces.
    if (source[psz] === ' ') { return }
        // Skip and count leading '1's.
    var zeroes = 0;
    var length = 0;
    while (source[psz] === LEADER) {
      zeroes++;
      psz++;
    }
        // Allocate enough space in big-endian base256 representation.
    var size = (((source.length - psz) * FACTOR) + 1) >>> 0; // log(58) / log(256), rounded up.
    var b256 = new Uint8Array(size);
        // Process the characters.
    while (source[psz]) {
            // Decode character
      var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
      if (carry === 255) { return }
      var i = 0;
      for (var it3 = size - 1; (carry !== 0 || i < length) && (it3 !== -1); it3--, i++) {
        carry += (BASE * b256[it3]) >>> 0;
        b256[it3] = (carry % 256) >>> 0;
        carry = (carry / 256) >>> 0;
      }
      if (carry !== 0) { throw new Error('Non-zero carry') }
      length = i;
      psz++;
    }
        // Skip trailing spaces.
    if (source[psz] === ' ') { return }
        // Skip leading zeroes in b256.
    var it4 = size - length;
    while (it4 !== size && b256[it4] === 0) {
      it4++;
    }
    var vch = new Uint8Array(zeroes + (size - it4));
    var j = zeroes;
    while (it4 !== size) {
      vch[j++] = b256[it4++];
    }
    return vch
  }
  function decode (string) {
    var buffer = decodeUnsafe(string);
    if (buffer) { return buffer }
    throw new Error('Non-base' + BASE + ' character')
  }
  return {
    encode: encode,
    decodeUnsafe: decodeUnsafe,
    decode: decode
  }
}
var src$5 = base$c;

const textDecoder$1 = new TextDecoder();
/**
 * @param {ArrayBufferView|ArrayBuffer} bytes
 * @returns {string}
 */
const decodeText$1 = (bytes) => textDecoder$1.decode(bytes);

const textEncoder$1 = new TextEncoder();
/**
 * @param {string} text
 * @returns {Uint8Array}
 */
const encodeText$2 = (text) => textEncoder$1.encode(text);

/**
 * Returns a new Uint8Array created by concatenating the passed Arrays
 *
 * @param {Array<ArrayLike<number>>} arrs
 * @param {number} length
 * @returns {Uint8Array}
 */
function concat$2 (arrs, length) {
  const output = new Uint8Array(length);
  let offset = 0;

  for (const arr of arrs) {
    output.set(arr, offset);
    offset += arr.length;
  }

  return output
}

var util$2 = { decodeText: decodeText$1, encodeText: encodeText$2, concat: concat$2 };

const { encodeText: encodeText$1 } = util$2;

/** @typedef {import('./types').CodecFactory} CodecFactory */
/** @typedef {import("./types").BaseName} BaseName */
/** @typedef {import("./types").BaseCode} BaseCode */

/**
 * Class to encode/decode in the supported Bases
 *
 */
class Base$1 {
  /**
   * @param {BaseName} name
   * @param {BaseCode} code
   * @param {CodecFactory} factory
   * @param {string} alphabet
   */
  constructor (name, code, factory, alphabet) {
    this.name = name;
    this.code = code;
    this.codeBuf = encodeText$1(this.code);
    this.alphabet = alphabet;
    this.codec = factory(alphabet);
  }

  /**
   * @param {Uint8Array} buf
   * @returns {string}
   */
  encode (buf) {
    return this.codec.encode(buf)
  }

  /**
   * @param {string} string
   * @returns {Uint8Array}
   */
  decode (string) {
    for (const char of string) {
      if (this.alphabet && this.alphabet.indexOf(char) < 0) {
        throw new Error(`invalid character '${char}' in '${string}'`)
      }
    }
    return this.codec.decode(string)
  }
}

var base$b = Base$1;

/** @typedef {import('./types').CodecFactory} CodecFactory */

/**
 * @param {string} string
 * @param {string} alphabet
 * @param {number} bitsPerChar
 * @returns {Uint8Array}
 */
const decode$9 = (string, alphabet, bitsPerChar) => {
  // Build the character lookup table:
  /** @type {Record<string, number>} */
  const codes = {};
  for (let i = 0; i < alphabet.length; ++i) {
    codes[alphabet[i]] = i;
  }

  // Count the padding bytes:
  let end = string.length;
  while (string[end - 1] === '=') {
    --end;
  }

  // Allocate the output:
  const out = new Uint8Array((end * bitsPerChar / 8) | 0);

  // Parse the data:
  let bits = 0; // Number of bits currently in the buffer
  let buffer = 0; // Bits waiting to be written out, MSB first
  let written = 0; // Next byte to write
  for (let i = 0; i < end; ++i) {
    // Read one character from the string:
    const value = codes[string[i]];
    if (value === undefined) {
      throw new SyntaxError('Invalid character ' + string[i])
    }

    // Append the bits to the buffer:
    buffer = (buffer << bitsPerChar) | value;
    bits += bitsPerChar;

    // Write out some bits if the buffer has a byte's worth:
    if (bits >= 8) {
      bits -= 8;
      out[written++] = 0xff & (buffer >> bits);
    }
  }

  // Verify that we have received just enough bits:
  if (bits >= bitsPerChar || 0xff & (buffer << (8 - bits))) {
    throw new SyntaxError('Unexpected end of data')
  }

  return out
};

/**
 * @param {Uint8Array} data
 * @param {string} alphabet
 * @param {number} bitsPerChar
 * @returns {string}
 */
const encode$8 = (data, alphabet, bitsPerChar) => {
  const pad = alphabet[alphabet.length - 1] === '=';
  const mask = (1 << bitsPerChar) - 1;
  let out = '';

  let bits = 0; // Number of bits currently in the buffer
  let buffer = 0; // Bits waiting to be written out, MSB first
  for (let i = 0; i < data.length; ++i) {
    // Slurp data into the buffer:
    buffer = (buffer << 8) | data[i];
    bits += 8;

    // Write out as much as we can:
    while (bits > bitsPerChar) {
      bits -= bitsPerChar;
      out += alphabet[mask & (buffer >> bits)];
    }
  }

  // Partial character:
  if (bits) {
    out += alphabet[mask & (buffer << (bitsPerChar - bits))];
  }

  // Add padding characters until we hit a byte boundary:
  if (pad) {
    while ((out.length * bitsPerChar) & 7) {
      out += '=';
    }
  }

  return out
};

/**
 * RFC4648 Factory
 *
 * @param {number} bitsPerChar
 * @returns {CodecFactory}
 */
const rfc4648$2 = (bitsPerChar) => (alphabet) => {
  return {
    /**
     * @param {Uint8Array} input
     * @returns {string}
     */
    encode (input) {
      return encode$8(input, alphabet, bitsPerChar)
    },
    /**
     * @param {string} input
     * @returns {Uint8Array}
     */
    decode (input) {
      return decode$9(input, alphabet, bitsPerChar)
    }
  }
};

var rfc4648_1 = { rfc4648: rfc4648$2 };

const baseX$3 = src$5;
const Base = base$b;
const { rfc4648: rfc4648$1 } = rfc4648_1;
const { decodeText, encodeText } = util$2;

/** @typedef {import('./types').CodecFactory} CodecFactory */
/** @typedef {import('./types').Codec} Codec */
/** @typedef {import('./types').BaseName} BaseName */
/** @typedef {import('./types').BaseCode} BaseCode */

/** @type {CodecFactory} */
const identity$6 = () => {
  return {
    encode: decodeText,
    decode: encodeText
  }
};

/**
 *
 * name, code, implementation, alphabet
 *
 * @type {Array<[BaseName, BaseCode, CodecFactory, string]>}
 */
const constants$1 = [
  ['identity', '\x00', identity$6, ''],
  ['base2', '0', rfc4648$1(1), '01'],
  ['base8', '7', rfc4648$1(3), '01234567'],
  ['base10', '9', baseX$3, '0123456789'],
  ['base16', 'f', rfc4648$1(4), '0123456789abcdef'],
  ['base16upper', 'F', rfc4648$1(4), '0123456789ABCDEF'],
  ['base32hex', 'v', rfc4648$1(5), '0123456789abcdefghijklmnopqrstuv'],
  ['base32hexupper', 'V', rfc4648$1(5), '0123456789ABCDEFGHIJKLMNOPQRSTUV'],
  ['base32hexpad', 't', rfc4648$1(5), '0123456789abcdefghijklmnopqrstuv='],
  ['base32hexpadupper', 'T', rfc4648$1(5), '0123456789ABCDEFGHIJKLMNOPQRSTUV='],
  ['base32', 'b', rfc4648$1(5), 'abcdefghijklmnopqrstuvwxyz234567'],
  ['base32upper', 'B', rfc4648$1(5), 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'],
  ['base32pad', 'c', rfc4648$1(5), 'abcdefghijklmnopqrstuvwxyz234567='],
  ['base32padupper', 'C', rfc4648$1(5), 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567='],
  ['base32z', 'h', rfc4648$1(5), 'ybndrfg8ejkmcpqxot1uwisza345h769'],
  ['base36', 'k', baseX$3, '0123456789abcdefghijklmnopqrstuvwxyz'],
  ['base36upper', 'K', baseX$3, '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'],
  ['base58btc', 'z', baseX$3, '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'],
  ['base58flickr', 'Z', baseX$3, '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'],
  ['base64', 'm', rfc4648$1(6), 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'],
  ['base64pad', 'M', rfc4648$1(6), 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='],
  ['base64url', 'u', rfc4648$1(6), 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'],
  ['base64urlpad', 'U', rfc4648$1(6), 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=']
];

/** @type {Record<BaseName,Base>} */
const names$2 = constants$1.reduce((prev, tupple) => {
  prev[tupple[0]] = new Base(tupple[0], tupple[1], tupple[2], tupple[3]);
  return prev
}, /** @type {Record<BaseName,Base>} */({}));

/** @type {Record<BaseCode,Base>} */
const codes$1 = constants$1.reduce((prev, tupple) => {
  prev[tupple[1]] = names$2[tupple[0]];
  return prev
}, /** @type {Record<BaseCode,Base>} */({}));

var constants_1 = {
  names: names$2,
  codes: codes$1
};

/**
 * Implementation of the [multibase](https://github.com/multiformats/multibase) specification.
 *
 */

(function (module, exports) {

const constants = constants_1;
const { encodeText, decodeText, concat } = util$2;

/** @typedef {import('./base')} Base */
/** @typedef {import("./types").BaseNameOrCode} BaseNameOrCode */
/** @typedef {import("./types").BaseCode} BaseCode */
/** @typedef {import("./types").BaseName} BaseName */

/**
 * Create a new Uint8Array with the multibase varint+code.
 *
 * @param {BaseNameOrCode} nameOrCode - The multibase name or code number.
 * @param {Uint8Array} buf - The data to be prefixed with multibase.
 * @returns {Uint8Array}
 * @throws {Error} Will throw if the encoding is not supported
 */
function multibase (nameOrCode, buf) {
  if (!buf) {
    throw new Error('requires an encoded Uint8Array')
  }
  const { name, codeBuf } = encoding(nameOrCode);
  validEncode(name, buf);

  return concat([codeBuf, buf], codeBuf.length + buf.length)
}

/**
 * Encode data with the specified base and add the multibase prefix.
 *
 * @param {BaseNameOrCode} nameOrCode - The multibase name or code number.
 * @param {Uint8Array} buf - The data to be encoded.
 * @returns {Uint8Array}
 * @throws {Error} Will throw if the encoding is not supported
 *
 */
function encode (nameOrCode, buf) {
  const enc = encoding(nameOrCode);
  const data = encodeText(enc.encode(buf));

  return concat([enc.codeBuf, data], enc.codeBuf.length + data.length)
}

/**
 * Takes a Uint8Array or string encoded with multibase header, decodes it and
 * returns the decoded buffer
 *
 * @param {Uint8Array|string} data
 * @returns {Uint8Array}
 * @throws {Error} Will throw if the encoding is not supported
 *
 */
function decode (data) {
  if (data instanceof Uint8Array) {
    data = decodeText(data);
  }
  const prefix = data[0];

  // Make all encodings case-insensitive except the ones that include upper and lower chars in the alphabet
  if (['f', 'F', 'v', 'V', 't', 'T', 'b', 'B', 'c', 'C', 'h', 'k', 'K'].includes(prefix)) {
    data = data.toLowerCase();
  }
  const enc = encoding(/** @type {BaseCode} */(data[0]));
  return enc.decode(data.substring(1))
}

/**
 * Is the given data multibase encoded?
 *
 * @param {Uint8Array|string} data
 */
function isEncoded (data) {
  if (data instanceof Uint8Array) {
    data = decodeText(data);
  }

  // Ensure bufOrString is a string
  if (Object.prototype.toString.call(data) !== '[object String]') {
    return false
  }

  try {
    const enc = encoding(/** @type {BaseCode} */(data[0]));
    return enc.name
  } catch (err) {
    return false
  }
}

/**
 * Validate encoded data
 *
 * @param {BaseNameOrCode} name
 * @param {Uint8Array} buf
 * @returns {void}
 * @throws {Error} Will throw if the encoding is not supported
 */
function validEncode (name, buf) {
  const enc = encoding(name);
  enc.decode(decodeText(buf));
}

/**
 * Get the encoding by name or code
 *
 * @param {BaseNameOrCode} nameOrCode
 * @returns {Base}
 * @throws {Error} Will throw if the encoding is not supported
 */
function encoding (nameOrCode) {
  if (Object.prototype.hasOwnProperty.call(constants.names, /** @type {BaseName} */(nameOrCode))) {
    return constants.names[/** @type {BaseName} */(nameOrCode)]
  } else if (Object.prototype.hasOwnProperty.call(constants.codes, /** @type {BaseCode} */(nameOrCode))) {
    return constants.codes[/** @type {BaseCode} */(nameOrCode)]
  } else {
    throw new Error(`Unsupported encoding: ${nameOrCode}`)
  }
}

/**
 * Get encoding from data
 *
 * @param {string|Uint8Array} data
 * @returns {Base}
 * @throws {Error} Will throw if the encoding is not supported
 */
function encodingFromData (data) {
  if (data instanceof Uint8Array) {
    data = decodeText(data);
  }

  return encoding(/** @type {BaseCode} */(data[0]))
}

exports = module.exports = multibase;
exports.encode = encode;
exports.decode = decode;
exports.isEncoded = isEncoded;
exports.encoding = encoding;
exports.encodingFromData = encodingFromData;
const names = Object.freeze(constants.names);
const codes = Object.freeze(constants.codes);
exports.names = names;
exports.codes = codes;
}(src$6, src$6.exports));

var encode_1$2 = encode$7;

var MSB$4 = 0x80
  , REST$4 = 0x7F
  , MSBALL$2 = ~REST$4
  , INT$2 = Math.pow(2, 31);

function encode$7(num, out, offset) {
  out = out || [];
  offset = offset || 0;
  var oldOffset = offset;

  while(num >= INT$2) {
    out[offset++] = (num & 0xFF) | MSB$4;
    num /= 128;
  }
  while(num & MSBALL$2) {
    out[offset++] = (num & 0xFF) | MSB$4;
    num >>>= 7;
  }
  out[offset] = num | 0;
  
  encode$7.bytes = offset - oldOffset + 1;
  
  return out
}

var decode$8 = read$2;

var MSB$3 = 0x80
  , REST$3 = 0x7F;

function read$2(buf, offset) {
  var res    = 0
    , offset = offset || 0
    , shift  = 0
    , counter = offset
    , b
    , l = buf.length;

  do {
    if (counter >= l) {
      read$2.bytes = 0;
      throw new RangeError('Could not decode varint')
    }
    b = buf[counter++];
    res += shift < 28
      ? (b & REST$3) << shift
      : (b & REST$3) * Math.pow(2, shift);
    shift += 7;
  } while (b >= MSB$3)

  read$2.bytes = counter - offset;

  return res
}

var N1$2 = Math.pow(2,  7);
var N2$2 = Math.pow(2, 14);
var N3$2 = Math.pow(2, 21);
var N4$2 = Math.pow(2, 28);
var N5$2 = Math.pow(2, 35);
var N6$2 = Math.pow(2, 42);
var N7$2 = Math.pow(2, 49);
var N8$2 = Math.pow(2, 56);
var N9$2 = Math.pow(2, 63);

var length$2 = function (value) {
  return (
    value < N1$2 ? 1
  : value < N2$2 ? 2
  : value < N3$2 ? 3
  : value < N4$2 ? 4
  : value < N5$2 ? 5
  : value < N6$2 ? 6
  : value < N7$2 ? 7
  : value < N8$2 ? 8
  : value < N9$2 ? 9
  :              10
  )
};

var varint$a = {
    encode: encode_1$2
  , decode: decode$8
  , encodingLength: length$2
};

/* eslint quote-props: off */

/**
 * Names for all available hashes
 *
 * @typedef { "identity" | "sha1" | "sha2-256" | "sha2-512" | "sha3-512" | "sha3-384" | "sha3-256" | "sha3-224" | "shake-128" | "shake-256" | "keccak-224" | "keccak-256" | "keccak-384" | "keccak-512" | "blake3" | "murmur3-128" | "murmur3-32" | "dbl-sha2-256" | "md4" | "md5" | "bmt" | "sha2-256-trunc254-padded" | "ripemd-128" | "ripemd-160" | "ripemd-256" | "ripemd-320" | "x11" | "kangarootwelve" | "sm3-256" | "blake2b-8" | "blake2b-16" | "blake2b-24" | "blake2b-32" | "blake2b-40" | "blake2b-48" | "blake2b-56" | "blake2b-64" | "blake2b-72" | "blake2b-80" | "blake2b-88" | "blake2b-96" | "blake2b-104" | "blake2b-112" | "blake2b-120" | "blake2b-128" | "blake2b-136" | "blake2b-144" | "blake2b-152" | "blake2b-160" | "blake2b-168" | "blake2b-176" | "blake2b-184" | "blake2b-192" | "blake2b-200" | "blake2b-208" | "blake2b-216" | "blake2b-224" | "blake2b-232" | "blake2b-240" | "blake2b-248" | "blake2b-256" | "blake2b-264" | "blake2b-272" | "blake2b-280" | "blake2b-288" | "blake2b-296" | "blake2b-304" | "blake2b-312" | "blake2b-320" | "blake2b-328" | "blake2b-336" | "blake2b-344" | "blake2b-352" | "blake2b-360" | "blake2b-368" | "blake2b-376" | "blake2b-384" | "blake2b-392" | "blake2b-400" | "blake2b-408" | "blake2b-416" | "blake2b-424" | "blake2b-432" | "blake2b-440" | "blake2b-448" | "blake2b-456" | "blake2b-464" | "blake2b-472" | "blake2b-480" | "blake2b-488" | "blake2b-496" | "blake2b-504" | "blake2b-512" | "blake2s-8" | "blake2s-16" | "blake2s-24" | "blake2s-32" | "blake2s-40" | "blake2s-48" | "blake2s-56" | "blake2s-64" | "blake2s-72" | "blake2s-80" | "blake2s-88" | "blake2s-96" | "blake2s-104" | "blake2s-112" | "blake2s-120" | "blake2s-128" | "blake2s-136" | "blake2s-144" | "blake2s-152" | "blake2s-160" | "blake2s-168" | "blake2s-176" | "blake2s-184" | "blake2s-192" | "blake2s-200" | "blake2s-208" | "blake2s-216" | "blake2s-224" | "blake2s-232" | "blake2s-240" | "blake2s-248" | "blake2s-256" | "skein256-8" | "skein256-16" | "skein256-24" | "skein256-32" | "skein256-40" | "skein256-48" | "skein256-56" | "skein256-64" | "skein256-72" | "skein256-80" | "skein256-88" | "skein256-96" | "skein256-104" | "skein256-112" | "skein256-120" | "skein256-128" | "skein256-136" | "skein256-144" | "skein256-152" | "skein256-160" | "skein256-168" | "skein256-176" | "skein256-184" | "skein256-192" | "skein256-200" | "skein256-208" | "skein256-216" | "skein256-224" | "skein256-232" | "skein256-240" | "skein256-248" | "skein256-256" | "skein512-8" | "skein512-16" | "skein512-24" | "skein512-32" | "skein512-40" | "skein512-48" | "skein512-56" | "skein512-64" | "skein512-72" | "skein512-80" | "skein512-88" | "skein512-96" | "skein512-104" | "skein512-112" | "skein512-120" | "skein512-128" | "skein512-136" | "skein512-144" | "skein512-152" | "skein512-160" | "skein512-168" | "skein512-176" | "skein512-184" | "skein512-192" | "skein512-200" | "skein512-208" | "skein512-216" | "skein512-224" | "skein512-232" | "skein512-240" | "skein512-248" | "skein512-256" | "skein512-264" | "skein512-272" | "skein512-280" | "skein512-288" | "skein512-296" | "skein512-304" | "skein512-312" | "skein512-320" | "skein512-328" | "skein512-336" | "skein512-344" | "skein512-352" | "skein512-360" | "skein512-368" | "skein512-376" | "skein512-384" | "skein512-392" | "skein512-400" | "skein512-408" | "skein512-416" | "skein512-424" | "skein512-432" | "skein512-440" | "skein512-448" | "skein512-456" | "skein512-464" | "skein512-472" | "skein512-480" | "skein512-488" | "skein512-496" | "skein512-504" | "skein512-512" | "skein1024-8" | "skein1024-16" | "skein1024-24" | "skein1024-32" | "skein1024-40" | "skein1024-48" | "skein1024-56" | "skein1024-64" | "skein1024-72" | "skein1024-80" | "skein1024-88" | "skein1024-96" | "skein1024-104" | "skein1024-112" | "skein1024-120" | "skein1024-128" | "skein1024-136" | "skein1024-144" | "skein1024-152" | "skein1024-160" | "skein1024-168" | "skein1024-176" | "skein1024-184" | "skein1024-192" | "skein1024-200" | "skein1024-208" | "skein1024-216" | "skein1024-224" | "skein1024-232" | "skein1024-240" | "skein1024-248" | "skein1024-256" | "skein1024-264" | "skein1024-272" | "skein1024-280" | "skein1024-288" | "skein1024-296" | "skein1024-304" | "skein1024-312" | "skein1024-320" | "skein1024-328" | "skein1024-336" | "skein1024-344" | "skein1024-352" | "skein1024-360" | "skein1024-368" | "skein1024-376" | "skein1024-384" | "skein1024-392" | "skein1024-400" | "skein1024-408" | "skein1024-416" | "skein1024-424" | "skein1024-432" | "skein1024-440" | "skein1024-448" | "skein1024-456" | "skein1024-464" | "skein1024-472" | "skein1024-480" | "skein1024-488" | "skein1024-496" | "skein1024-504" | "skein1024-512" | "skein1024-520" | "skein1024-528" | "skein1024-536" | "skein1024-544" | "skein1024-552" | "skein1024-560" | "skein1024-568" | "skein1024-576" | "skein1024-584" | "skein1024-592" | "skein1024-600" | "skein1024-608" | "skein1024-616" | "skein1024-624" | "skein1024-632" | "skein1024-640" | "skein1024-648" | "skein1024-656" | "skein1024-664" | "skein1024-672" | "skein1024-680" | "skein1024-688" | "skein1024-696" | "skein1024-704" | "skein1024-712" | "skein1024-720" | "skein1024-728" | "skein1024-736" | "skein1024-744" | "skein1024-752" | "skein1024-760" | "skein1024-768" | "skein1024-776" | "skein1024-784" | "skein1024-792" | "skein1024-800" | "skein1024-808" | "skein1024-816" | "skein1024-824" | "skein1024-832" | "skein1024-840" | "skein1024-848" | "skein1024-856" | "skein1024-864" | "skein1024-872" | "skein1024-880" | "skein1024-888" | "skein1024-896" | "skein1024-904" | "skein1024-912" | "skein1024-920" | "skein1024-928" | "skein1024-936" | "skein1024-944" | "skein1024-952" | "skein1024-960" | "skein1024-968" | "skein1024-976" | "skein1024-984" | "skein1024-992" | "skein1024-1000" | "skein1024-1008" | "skein1024-1016" | "skein1024-1024" | "poseidon-bls12_381-a2-fc1" | "poseidon-bls12_381-a2-fc1-sc" } HashName
 */
/**
 * Codes for all available hashes
 *
 * @typedef { 0x00 | 0x11 | 0x12 | 0x13 | 0x14 | 0x15 | 0x16 | 0x17 | 0x18 | 0x19 | 0x1a | 0x1b | 0x1c | 0x1d | 0x1e | 0x22 | 0x23 | 0x56 | 0xd4 | 0xd5 | 0xd6 | 0x1012 | 0x1052 | 0x1053 | 0x1054 | 0x1055 | 0x1100 | 0x1d01 | 0x534d | 0xb201 | 0xb202 | 0xb203 | 0xb204 | 0xb205 | 0xb206 | 0xb207 | 0xb208 | 0xb209 | 0xb20a | 0xb20b | 0xb20c | 0xb20d | 0xb20e | 0xb20f | 0xb210 | 0xb211 | 0xb212 | 0xb213 | 0xb214 | 0xb215 | 0xb216 | 0xb217 | 0xb218 | 0xb219 | 0xb21a | 0xb21b | 0xb21c | 0xb21d | 0xb21e | 0xb21f | 0xb220 | 0xb221 | 0xb222 | 0xb223 | 0xb224 | 0xb225 | 0xb226 | 0xb227 | 0xb228 | 0xb229 | 0xb22a | 0xb22b | 0xb22c | 0xb22d | 0xb22e | 0xb22f | 0xb230 | 0xb231 | 0xb232 | 0xb233 | 0xb234 | 0xb235 | 0xb236 | 0xb237 | 0xb238 | 0xb239 | 0xb23a | 0xb23b | 0xb23c | 0xb23d | 0xb23e | 0xb23f | 0xb240 | 0xb241 | 0xb242 | 0xb243 | 0xb244 | 0xb245 | 0xb246 | 0xb247 | 0xb248 | 0xb249 | 0xb24a | 0xb24b | 0xb24c | 0xb24d | 0xb24e | 0xb24f | 0xb250 | 0xb251 | 0xb252 | 0xb253 | 0xb254 | 0xb255 | 0xb256 | 0xb257 | 0xb258 | 0xb259 | 0xb25a | 0xb25b | 0xb25c | 0xb25d | 0xb25e | 0xb25f | 0xb260 | 0xb301 | 0xb302 | 0xb303 | 0xb304 | 0xb305 | 0xb306 | 0xb307 | 0xb308 | 0xb309 | 0xb30a | 0xb30b | 0xb30c | 0xb30d | 0xb30e | 0xb30f | 0xb310 | 0xb311 | 0xb312 | 0xb313 | 0xb314 | 0xb315 | 0xb316 | 0xb317 | 0xb318 | 0xb319 | 0xb31a | 0xb31b | 0xb31c | 0xb31d | 0xb31e | 0xb31f | 0xb320 | 0xb321 | 0xb322 | 0xb323 | 0xb324 | 0xb325 | 0xb326 | 0xb327 | 0xb328 | 0xb329 | 0xb32a | 0xb32b | 0xb32c | 0xb32d | 0xb32e | 0xb32f | 0xb330 | 0xb331 | 0xb332 | 0xb333 | 0xb334 | 0xb335 | 0xb336 | 0xb337 | 0xb338 | 0xb339 | 0xb33a | 0xb33b | 0xb33c | 0xb33d | 0xb33e | 0xb33f | 0xb340 | 0xb341 | 0xb342 | 0xb343 | 0xb344 | 0xb345 | 0xb346 | 0xb347 | 0xb348 | 0xb349 | 0xb34a | 0xb34b | 0xb34c | 0xb34d | 0xb34e | 0xb34f | 0xb350 | 0xb351 | 0xb352 | 0xb353 | 0xb354 | 0xb355 | 0xb356 | 0xb357 | 0xb358 | 0xb359 | 0xb35a | 0xb35b | 0xb35c | 0xb35d | 0xb35e | 0xb35f | 0xb360 | 0xb361 | 0xb362 | 0xb363 | 0xb364 | 0xb365 | 0xb366 | 0xb367 | 0xb368 | 0xb369 | 0xb36a | 0xb36b | 0xb36c | 0xb36d | 0xb36e | 0xb36f | 0xb370 | 0xb371 | 0xb372 | 0xb373 | 0xb374 | 0xb375 | 0xb376 | 0xb377 | 0xb378 | 0xb379 | 0xb37a | 0xb37b | 0xb37c | 0xb37d | 0xb37e | 0xb37f | 0xb380 | 0xb381 | 0xb382 | 0xb383 | 0xb384 | 0xb385 | 0xb386 | 0xb387 | 0xb388 | 0xb389 | 0xb38a | 0xb38b | 0xb38c | 0xb38d | 0xb38e | 0xb38f | 0xb390 | 0xb391 | 0xb392 | 0xb393 | 0xb394 | 0xb395 | 0xb396 | 0xb397 | 0xb398 | 0xb399 | 0xb39a | 0xb39b | 0xb39c | 0xb39d | 0xb39e | 0xb39f | 0xb3a0 | 0xb3a1 | 0xb3a2 | 0xb3a3 | 0xb3a4 | 0xb3a5 | 0xb3a6 | 0xb3a7 | 0xb3a8 | 0xb3a9 | 0xb3aa | 0xb3ab | 0xb3ac | 0xb3ad | 0xb3ae | 0xb3af | 0xb3b0 | 0xb3b1 | 0xb3b2 | 0xb3b3 | 0xb3b4 | 0xb3b5 | 0xb3b6 | 0xb3b7 | 0xb3b8 | 0xb3b9 | 0xb3ba | 0xb3bb | 0xb3bc | 0xb3bd | 0xb3be | 0xb3bf | 0xb3c0 | 0xb3c1 | 0xb3c2 | 0xb3c3 | 0xb3c4 | 0xb3c5 | 0xb3c6 | 0xb3c7 | 0xb3c8 | 0xb3c9 | 0xb3ca | 0xb3cb | 0xb3cc | 0xb3cd | 0xb3ce | 0xb3cf | 0xb3d0 | 0xb3d1 | 0xb3d2 | 0xb3d3 | 0xb3d4 | 0xb3d5 | 0xb3d6 | 0xb3d7 | 0xb3d8 | 0xb3d9 | 0xb3da | 0xb3db | 0xb3dc | 0xb3dd | 0xb3de | 0xb3df | 0xb3e0 | 0xb401 | 0xb402 } HashCode
 */

/**
 * @type { Record<HashName,HashCode> }
 */
const names$1 = Object.freeze({
  'identity': 0x00,
  'sha1': 0x11,
  'sha2-256': 0x12,
  'sha2-512': 0x13,
  'sha3-512': 0x14,
  'sha3-384': 0x15,
  'sha3-256': 0x16,
  'sha3-224': 0x17,
  'shake-128': 0x18,
  'shake-256': 0x19,
  'keccak-224': 0x1a,
  'keccak-256': 0x1b,
  'keccak-384': 0x1c,
  'keccak-512': 0x1d,
  'blake3': 0x1e,
  'murmur3-128': 0x22,
  'murmur3-32': 0x23,
  'dbl-sha2-256': 0x56,
  'md4': 0xd4,
  'md5': 0xd5,
  'bmt': 0xd6,
  'sha2-256-trunc254-padded': 0x1012,
  'ripemd-128': 0x1052,
  'ripemd-160': 0x1053,
  'ripemd-256': 0x1054,
  'ripemd-320': 0x1055,
  'x11': 0x1100,
  'kangarootwelve': 0x1d01,
  'sm3-256': 0x534d,
  'blake2b-8': 0xb201,
  'blake2b-16': 0xb202,
  'blake2b-24': 0xb203,
  'blake2b-32': 0xb204,
  'blake2b-40': 0xb205,
  'blake2b-48': 0xb206,
  'blake2b-56': 0xb207,
  'blake2b-64': 0xb208,
  'blake2b-72': 0xb209,
  'blake2b-80': 0xb20a,
  'blake2b-88': 0xb20b,
  'blake2b-96': 0xb20c,
  'blake2b-104': 0xb20d,
  'blake2b-112': 0xb20e,
  'blake2b-120': 0xb20f,
  'blake2b-128': 0xb210,
  'blake2b-136': 0xb211,
  'blake2b-144': 0xb212,
  'blake2b-152': 0xb213,
  'blake2b-160': 0xb214,
  'blake2b-168': 0xb215,
  'blake2b-176': 0xb216,
  'blake2b-184': 0xb217,
  'blake2b-192': 0xb218,
  'blake2b-200': 0xb219,
  'blake2b-208': 0xb21a,
  'blake2b-216': 0xb21b,
  'blake2b-224': 0xb21c,
  'blake2b-232': 0xb21d,
  'blake2b-240': 0xb21e,
  'blake2b-248': 0xb21f,
  'blake2b-256': 0xb220,
  'blake2b-264': 0xb221,
  'blake2b-272': 0xb222,
  'blake2b-280': 0xb223,
  'blake2b-288': 0xb224,
  'blake2b-296': 0xb225,
  'blake2b-304': 0xb226,
  'blake2b-312': 0xb227,
  'blake2b-320': 0xb228,
  'blake2b-328': 0xb229,
  'blake2b-336': 0xb22a,
  'blake2b-344': 0xb22b,
  'blake2b-352': 0xb22c,
  'blake2b-360': 0xb22d,
  'blake2b-368': 0xb22e,
  'blake2b-376': 0xb22f,
  'blake2b-384': 0xb230,
  'blake2b-392': 0xb231,
  'blake2b-400': 0xb232,
  'blake2b-408': 0xb233,
  'blake2b-416': 0xb234,
  'blake2b-424': 0xb235,
  'blake2b-432': 0xb236,
  'blake2b-440': 0xb237,
  'blake2b-448': 0xb238,
  'blake2b-456': 0xb239,
  'blake2b-464': 0xb23a,
  'blake2b-472': 0xb23b,
  'blake2b-480': 0xb23c,
  'blake2b-488': 0xb23d,
  'blake2b-496': 0xb23e,
  'blake2b-504': 0xb23f,
  'blake2b-512': 0xb240,
  'blake2s-8': 0xb241,
  'blake2s-16': 0xb242,
  'blake2s-24': 0xb243,
  'blake2s-32': 0xb244,
  'blake2s-40': 0xb245,
  'blake2s-48': 0xb246,
  'blake2s-56': 0xb247,
  'blake2s-64': 0xb248,
  'blake2s-72': 0xb249,
  'blake2s-80': 0xb24a,
  'blake2s-88': 0xb24b,
  'blake2s-96': 0xb24c,
  'blake2s-104': 0xb24d,
  'blake2s-112': 0xb24e,
  'blake2s-120': 0xb24f,
  'blake2s-128': 0xb250,
  'blake2s-136': 0xb251,
  'blake2s-144': 0xb252,
  'blake2s-152': 0xb253,
  'blake2s-160': 0xb254,
  'blake2s-168': 0xb255,
  'blake2s-176': 0xb256,
  'blake2s-184': 0xb257,
  'blake2s-192': 0xb258,
  'blake2s-200': 0xb259,
  'blake2s-208': 0xb25a,
  'blake2s-216': 0xb25b,
  'blake2s-224': 0xb25c,
  'blake2s-232': 0xb25d,
  'blake2s-240': 0xb25e,
  'blake2s-248': 0xb25f,
  'blake2s-256': 0xb260,
  'skein256-8': 0xb301,
  'skein256-16': 0xb302,
  'skein256-24': 0xb303,
  'skein256-32': 0xb304,
  'skein256-40': 0xb305,
  'skein256-48': 0xb306,
  'skein256-56': 0xb307,
  'skein256-64': 0xb308,
  'skein256-72': 0xb309,
  'skein256-80': 0xb30a,
  'skein256-88': 0xb30b,
  'skein256-96': 0xb30c,
  'skein256-104': 0xb30d,
  'skein256-112': 0xb30e,
  'skein256-120': 0xb30f,
  'skein256-128': 0xb310,
  'skein256-136': 0xb311,
  'skein256-144': 0xb312,
  'skein256-152': 0xb313,
  'skein256-160': 0xb314,
  'skein256-168': 0xb315,
  'skein256-176': 0xb316,
  'skein256-184': 0xb317,
  'skein256-192': 0xb318,
  'skein256-200': 0xb319,
  'skein256-208': 0xb31a,
  'skein256-216': 0xb31b,
  'skein256-224': 0xb31c,
  'skein256-232': 0xb31d,
  'skein256-240': 0xb31e,
  'skein256-248': 0xb31f,
  'skein256-256': 0xb320,
  'skein512-8': 0xb321,
  'skein512-16': 0xb322,
  'skein512-24': 0xb323,
  'skein512-32': 0xb324,
  'skein512-40': 0xb325,
  'skein512-48': 0xb326,
  'skein512-56': 0xb327,
  'skein512-64': 0xb328,
  'skein512-72': 0xb329,
  'skein512-80': 0xb32a,
  'skein512-88': 0xb32b,
  'skein512-96': 0xb32c,
  'skein512-104': 0xb32d,
  'skein512-112': 0xb32e,
  'skein512-120': 0xb32f,
  'skein512-128': 0xb330,
  'skein512-136': 0xb331,
  'skein512-144': 0xb332,
  'skein512-152': 0xb333,
  'skein512-160': 0xb334,
  'skein512-168': 0xb335,
  'skein512-176': 0xb336,
  'skein512-184': 0xb337,
  'skein512-192': 0xb338,
  'skein512-200': 0xb339,
  'skein512-208': 0xb33a,
  'skein512-216': 0xb33b,
  'skein512-224': 0xb33c,
  'skein512-232': 0xb33d,
  'skein512-240': 0xb33e,
  'skein512-248': 0xb33f,
  'skein512-256': 0xb340,
  'skein512-264': 0xb341,
  'skein512-272': 0xb342,
  'skein512-280': 0xb343,
  'skein512-288': 0xb344,
  'skein512-296': 0xb345,
  'skein512-304': 0xb346,
  'skein512-312': 0xb347,
  'skein512-320': 0xb348,
  'skein512-328': 0xb349,
  'skein512-336': 0xb34a,
  'skein512-344': 0xb34b,
  'skein512-352': 0xb34c,
  'skein512-360': 0xb34d,
  'skein512-368': 0xb34e,
  'skein512-376': 0xb34f,
  'skein512-384': 0xb350,
  'skein512-392': 0xb351,
  'skein512-400': 0xb352,
  'skein512-408': 0xb353,
  'skein512-416': 0xb354,
  'skein512-424': 0xb355,
  'skein512-432': 0xb356,
  'skein512-440': 0xb357,
  'skein512-448': 0xb358,
  'skein512-456': 0xb359,
  'skein512-464': 0xb35a,
  'skein512-472': 0xb35b,
  'skein512-480': 0xb35c,
  'skein512-488': 0xb35d,
  'skein512-496': 0xb35e,
  'skein512-504': 0xb35f,
  'skein512-512': 0xb360,
  'skein1024-8': 0xb361,
  'skein1024-16': 0xb362,
  'skein1024-24': 0xb363,
  'skein1024-32': 0xb364,
  'skein1024-40': 0xb365,
  'skein1024-48': 0xb366,
  'skein1024-56': 0xb367,
  'skein1024-64': 0xb368,
  'skein1024-72': 0xb369,
  'skein1024-80': 0xb36a,
  'skein1024-88': 0xb36b,
  'skein1024-96': 0xb36c,
  'skein1024-104': 0xb36d,
  'skein1024-112': 0xb36e,
  'skein1024-120': 0xb36f,
  'skein1024-128': 0xb370,
  'skein1024-136': 0xb371,
  'skein1024-144': 0xb372,
  'skein1024-152': 0xb373,
  'skein1024-160': 0xb374,
  'skein1024-168': 0xb375,
  'skein1024-176': 0xb376,
  'skein1024-184': 0xb377,
  'skein1024-192': 0xb378,
  'skein1024-200': 0xb379,
  'skein1024-208': 0xb37a,
  'skein1024-216': 0xb37b,
  'skein1024-224': 0xb37c,
  'skein1024-232': 0xb37d,
  'skein1024-240': 0xb37e,
  'skein1024-248': 0xb37f,
  'skein1024-256': 0xb380,
  'skein1024-264': 0xb381,
  'skein1024-272': 0xb382,
  'skein1024-280': 0xb383,
  'skein1024-288': 0xb384,
  'skein1024-296': 0xb385,
  'skein1024-304': 0xb386,
  'skein1024-312': 0xb387,
  'skein1024-320': 0xb388,
  'skein1024-328': 0xb389,
  'skein1024-336': 0xb38a,
  'skein1024-344': 0xb38b,
  'skein1024-352': 0xb38c,
  'skein1024-360': 0xb38d,
  'skein1024-368': 0xb38e,
  'skein1024-376': 0xb38f,
  'skein1024-384': 0xb390,
  'skein1024-392': 0xb391,
  'skein1024-400': 0xb392,
  'skein1024-408': 0xb393,
  'skein1024-416': 0xb394,
  'skein1024-424': 0xb395,
  'skein1024-432': 0xb396,
  'skein1024-440': 0xb397,
  'skein1024-448': 0xb398,
  'skein1024-456': 0xb399,
  'skein1024-464': 0xb39a,
  'skein1024-472': 0xb39b,
  'skein1024-480': 0xb39c,
  'skein1024-488': 0xb39d,
  'skein1024-496': 0xb39e,
  'skein1024-504': 0xb39f,
  'skein1024-512': 0xb3a0,
  'skein1024-520': 0xb3a1,
  'skein1024-528': 0xb3a2,
  'skein1024-536': 0xb3a3,
  'skein1024-544': 0xb3a4,
  'skein1024-552': 0xb3a5,
  'skein1024-560': 0xb3a6,
  'skein1024-568': 0xb3a7,
  'skein1024-576': 0xb3a8,
  'skein1024-584': 0xb3a9,
  'skein1024-592': 0xb3aa,
  'skein1024-600': 0xb3ab,
  'skein1024-608': 0xb3ac,
  'skein1024-616': 0xb3ad,
  'skein1024-624': 0xb3ae,
  'skein1024-632': 0xb3af,
  'skein1024-640': 0xb3b0,
  'skein1024-648': 0xb3b1,
  'skein1024-656': 0xb3b2,
  'skein1024-664': 0xb3b3,
  'skein1024-672': 0xb3b4,
  'skein1024-680': 0xb3b5,
  'skein1024-688': 0xb3b6,
  'skein1024-696': 0xb3b7,
  'skein1024-704': 0xb3b8,
  'skein1024-712': 0xb3b9,
  'skein1024-720': 0xb3ba,
  'skein1024-728': 0xb3bb,
  'skein1024-736': 0xb3bc,
  'skein1024-744': 0xb3bd,
  'skein1024-752': 0xb3be,
  'skein1024-760': 0xb3bf,
  'skein1024-768': 0xb3c0,
  'skein1024-776': 0xb3c1,
  'skein1024-784': 0xb3c2,
  'skein1024-792': 0xb3c3,
  'skein1024-800': 0xb3c4,
  'skein1024-808': 0xb3c5,
  'skein1024-816': 0xb3c6,
  'skein1024-824': 0xb3c7,
  'skein1024-832': 0xb3c8,
  'skein1024-840': 0xb3c9,
  'skein1024-848': 0xb3ca,
  'skein1024-856': 0xb3cb,
  'skein1024-864': 0xb3cc,
  'skein1024-872': 0xb3cd,
  'skein1024-880': 0xb3ce,
  'skein1024-888': 0xb3cf,
  'skein1024-896': 0xb3d0,
  'skein1024-904': 0xb3d1,
  'skein1024-912': 0xb3d2,
  'skein1024-920': 0xb3d3,
  'skein1024-928': 0xb3d4,
  'skein1024-936': 0xb3d5,
  'skein1024-944': 0xb3d6,
  'skein1024-952': 0xb3d7,
  'skein1024-960': 0xb3d8,
  'skein1024-968': 0xb3d9,
  'skein1024-976': 0xb3da,
  'skein1024-984': 0xb3db,
  'skein1024-992': 0xb3dc,
  'skein1024-1000': 0xb3dd,
  'skein1024-1008': 0xb3de,
  'skein1024-1016': 0xb3df,
  'skein1024-1024': 0xb3e0,
  'poseidon-bls12_381-a2-fc1': 0xb401,
  'poseidon-bls12_381-a2-fc1-sc': 0xb402
});

var constants = { names: names$1 };

var toString$2 = {};

var basics$1 = {};

var identity$5 = {};

var base$a = {};

function base$9(ALPHABET, name) {
  if (ALPHABET.length >= 255) {
    throw new TypeError('Alphabet too long');
  }
  var BASE_MAP = new Uint8Array(256);
  for (var j = 0; j < BASE_MAP.length; j++) {
    BASE_MAP[j] = 255;
  }
  for (var i = 0; i < ALPHABET.length; i++) {
    var x = ALPHABET.charAt(i);
    var xc = x.charCodeAt(0);
    if (BASE_MAP[xc] !== 255) {
      throw new TypeError(x + ' is ambiguous');
    }
    BASE_MAP[xc] = i;
  }
  var BASE = ALPHABET.length;
  var LEADER = ALPHABET.charAt(0);
  var FACTOR = Math.log(BASE) / Math.log(256);
  var iFACTOR = Math.log(256) / Math.log(BASE);
  function encode(source) {
    if (source instanceof Uint8Array);
    else if (ArrayBuffer.isView(source)) {
      source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
    } else if (Array.isArray(source)) {
      source = Uint8Array.from(source);
    }
    if (!(source instanceof Uint8Array)) {
      throw new TypeError('Expected Uint8Array');
    }
    if (source.length === 0) {
      return '';
    }
    var zeroes = 0;
    var length = 0;
    var pbegin = 0;
    var pend = source.length;
    while (pbegin !== pend && source[pbegin] === 0) {
      pbegin++;
      zeroes++;
    }
    var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
    var b58 = new Uint8Array(size);
    while (pbegin !== pend) {
      var carry = source[pbegin];
      var i = 0;
      for (var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++) {
        carry += 256 * b58[it1] >>> 0;
        b58[it1] = carry % BASE >>> 0;
        carry = carry / BASE >>> 0;
      }
      if (carry !== 0) {
        throw new Error('Non-zero carry');
      }
      length = i;
      pbegin++;
    }
    var it2 = size - length;
    while (it2 !== size && b58[it2] === 0) {
      it2++;
    }
    var str = LEADER.repeat(zeroes);
    for (; it2 < size; ++it2) {
      str += ALPHABET.charAt(b58[it2]);
    }
    return str;
  }
  function decodeUnsafe(source) {
    if (typeof source !== 'string') {
      throw new TypeError('Expected String');
    }
    if (source.length === 0) {
      return new Uint8Array();
    }
    var psz = 0;
    if (source[psz] === ' ') {
      return;
    }
    var zeroes = 0;
    var length = 0;
    while (source[psz] === LEADER) {
      zeroes++;
      psz++;
    }
    var size = (source.length - psz) * FACTOR + 1 >>> 0;
    var b256 = new Uint8Array(size);
    while (source[psz]) {
      var carry = BASE_MAP[source.charCodeAt(psz)];
      if (carry === 255) {
        return;
      }
      var i = 0;
      for (var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++) {
        carry += BASE * b256[it3] >>> 0;
        b256[it3] = carry % 256 >>> 0;
        carry = carry / 256 >>> 0;
      }
      if (carry !== 0) {
        throw new Error('Non-zero carry');
      }
      length = i;
      psz++;
    }
    if (source[psz] === ' ') {
      return;
    }
    var it4 = size - length;
    while (it4 !== size && b256[it4] === 0) {
      it4++;
    }
    var vch = new Uint8Array(zeroes + (size - it4));
    var j = zeroes;
    while (it4 !== size) {
      vch[j++] = b256[it4++];
    }
    return vch;
  }
  function decode(string) {
    var buffer = decodeUnsafe(string);
    if (buffer) {
      return buffer;
    }
    throw new Error(`Non-${ name } character`);
  }
  return {
    encode: encode,
    decodeUnsafe: decodeUnsafe,
    decode: decode
  };
}
var src$4 = base$9;
var _brrp__multiformats_scope_baseX = src$4;

var baseX$2 = _brrp__multiformats_scope_baseX;

var bytes$9 = {};

Object.defineProperty(bytes$9, '__esModule', { value: true });

const empty = new Uint8Array(0);
const toHex = d => d.reduce((hex, byte) => hex + byte.toString(16).padStart(2, '0'), '');
const fromHex = hex => {
  const hexes = hex.match(/../g);
  return hexes ? new Uint8Array(hexes.map(b => parseInt(b, 16))) : empty;
};
const equals$3 = (aa, bb) => {
  if (aa === bb)
    return true;
  if (aa.byteLength !== bb.byteLength) {
    return false;
  }
  for (let ii = 0; ii < aa.byteLength; ii++) {
    if (aa[ii] !== bb[ii]) {
      return false;
    }
  }
  return true;
};
const coerce = o => {
  if (o instanceof Uint8Array && o.constructor.name === 'Uint8Array')
    return o;
  if (o instanceof ArrayBuffer)
    return new Uint8Array(o);
  if (ArrayBuffer.isView(o)) {
    return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
  }
  throw new Error('Unknown type, must be binary type');
};
const isBinary = o => o instanceof ArrayBuffer || ArrayBuffer.isView(o);
const fromString$2 = str => new TextEncoder().encode(str);
const toString$1 = b => new TextDecoder().decode(b);

bytes$9.coerce = coerce;
bytes$9.empty = empty;
bytes$9.equals = equals$3;
bytes$9.fromHex = fromHex;
bytes$9.fromString = fromString$2;
bytes$9.isBinary = isBinary;
bytes$9.toHex = toHex;
bytes$9.toString = toString$1;

Object.defineProperty(base$a, '__esModule', { value: true });

var baseX$1 = baseX$2;
var bytes$8 = bytes$9;

class Encoder {
  constructor(name, prefix, baseEncode) {
    this.name = name;
    this.prefix = prefix;
    this.baseEncode = baseEncode;
  }
  encode(bytes) {
    if (bytes instanceof Uint8Array) {
      return `${ this.prefix }${ this.baseEncode(bytes) }`;
    } else {
      throw Error('Unknown type, must be binary type');
    }
  }
}
class Decoder {
  constructor(name, prefix, baseDecode) {
    this.name = name;
    this.prefix = prefix;
    this.baseDecode = baseDecode;
  }
  decode(text) {
    if (typeof text === 'string') {
      switch (text[0]) {
      case this.prefix: {
          return this.baseDecode(text.slice(1));
        }
      default: {
          throw Error(`Unable to decode multibase string ${ JSON.stringify(text) }, ${ this.name } decoder only supports inputs prefixed with ${ this.prefix }`);
        }
      }
    } else {
      throw Error('Can only multibase decode strings');
    }
  }
  or(decoder) {
    return or(this, decoder);
  }
}
class ComposedDecoder {
  constructor(decoders) {
    this.decoders = decoders;
  }
  or(decoder) {
    return or(this, decoder);
  }
  decode(input) {
    const prefix = input[0];
    const decoder = this.decoders[prefix];
    if (decoder) {
      return decoder.decode(input);
    } else {
      throw RangeError(`Unable to decode multibase string ${ JSON.stringify(input) }, only inputs prefixed with ${ Object.keys(this.decoders) } are supported`);
    }
  }
}
const or = (left, right) => new ComposedDecoder({
  ...left.decoders || { [left.prefix]: left },
  ...right.decoders || { [right.prefix]: right }
});
class Codec {
  constructor(name, prefix, baseEncode, baseDecode) {
    this.name = name;
    this.prefix = prefix;
    this.baseEncode = baseEncode;
    this.baseDecode = baseDecode;
    this.encoder = new Encoder(name, prefix, baseEncode);
    this.decoder = new Decoder(name, prefix, baseDecode);
  }
  encode(input) {
    return this.encoder.encode(input);
  }
  decode(input) {
    return this.decoder.decode(input);
  }
}
const from$1 = ({name, prefix, encode, decode}) => new Codec(name, prefix, encode, decode);
const baseX = ({prefix, name, alphabet}) => {
  const {encode, decode} = baseX$1(alphabet, name);
  return from$1({
    prefix,
    name,
    encode,
    decode: text => bytes$8.coerce(decode(text))
  });
};
const decode$7 = (string, alphabet, bitsPerChar, name) => {
  const codes = {};
  for (let i = 0; i < alphabet.length; ++i) {
    codes[alphabet[i]] = i;
  }
  let end = string.length;
  while (string[end - 1] === '=') {
    --end;
  }
  const out = new Uint8Array(end * bitsPerChar / 8 | 0);
  let bits = 0;
  let buffer = 0;
  let written = 0;
  for (let i = 0; i < end; ++i) {
    const value = codes[string[i]];
    if (value === undefined) {
      throw new SyntaxError(`Non-${ name } character`);
    }
    buffer = buffer << bitsPerChar | value;
    bits += bitsPerChar;
    if (bits >= 8) {
      bits -= 8;
      out[written++] = 255 & buffer >> bits;
    }
  }
  if (bits >= bitsPerChar || 255 & buffer << 8 - bits) {
    throw new SyntaxError('Unexpected end of data');
  }
  return out;
};
const encode$6 = (data, alphabet, bitsPerChar) => {
  const pad = alphabet[alphabet.length - 1] === '=';
  const mask = (1 << bitsPerChar) - 1;
  let out = '';
  let bits = 0;
  let buffer = 0;
  for (let i = 0; i < data.length; ++i) {
    buffer = buffer << 8 | data[i];
    bits += 8;
    while (bits > bitsPerChar) {
      bits -= bitsPerChar;
      out += alphabet[mask & buffer >> bits];
    }
  }
  if (bits) {
    out += alphabet[mask & buffer << bitsPerChar - bits];
  }
  if (pad) {
    while (out.length * bitsPerChar & 7) {
      out += '=';
    }
  }
  return out;
};
const rfc4648 = ({name, prefix, bitsPerChar, alphabet}) => {
  return from$1({
    prefix,
    name,
    encode(input) {
      return encode$6(input, alphabet, bitsPerChar);
    },
    decode(input) {
      return decode$7(input, alphabet, bitsPerChar, name);
    }
  });
};

base$a.Codec = Codec;
base$a.baseX = baseX;
base$a.from = from$1;
base$a.or = or;
base$a.rfc4648 = rfc4648;

Object.defineProperty(identity$5, '__esModule', { value: true });

var base$8 = base$a;
var bytes$7 = bytes$9;

const identity$4 = base$8.from({
  prefix: '\0',
  name: 'identity',
  encode: buf => bytes$7.toString(buf),
  decode: str => bytes$7.fromString(str)
});

identity$5.identity = identity$4;

var base2$2 = {};

Object.defineProperty(base2$2, '__esModule', { value: true });

var base$7 = base$a;

const base2$1 = base$7.rfc4648({
  prefix: '0',
  name: 'base2',
  alphabet: '01',
  bitsPerChar: 1
});

base2$2.base2 = base2$1;

var base8$2 = {};

Object.defineProperty(base8$2, '__esModule', { value: true });

var base$6 = base$a;

const base8$1 = base$6.rfc4648({
  prefix: '7',
  name: 'base8',
  alphabet: '01234567',
  bitsPerChar: 3
});

base8$2.base8 = base8$1;

var base10$2 = {};

Object.defineProperty(base10$2, '__esModule', { value: true });

var base$5 = base$a;

const base10$1 = base$5.baseX({
  prefix: '9',
  name: 'base10',
  alphabet: '0123456789'
});

base10$2.base10 = base10$1;

var base16$2 = {};

Object.defineProperty(base16$2, '__esModule', { value: true });

var base$4 = base$a;

const base16$1 = base$4.rfc4648({
  prefix: 'f',
  name: 'base16',
  alphabet: '0123456789abcdef',
  bitsPerChar: 4
});
const base16upper = base$4.rfc4648({
  prefix: 'F',
  name: 'base16upper',
  alphabet: '0123456789ABCDEF',
  bitsPerChar: 4
});

base16$2.base16 = base16$1;
base16$2.base16upper = base16upper;

var base32$3 = {};

Object.defineProperty(base32$3, '__esModule', { value: true });

var base$3 = base$a;

const base32$2 = base$3.rfc4648({
  prefix: 'b',
  name: 'base32',
  alphabet: 'abcdefghijklmnopqrstuvwxyz234567',
  bitsPerChar: 5
});
const base32upper = base$3.rfc4648({
  prefix: 'B',
  name: 'base32upper',
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567',
  bitsPerChar: 5
});
const base32pad = base$3.rfc4648({
  prefix: 'c',
  name: 'base32pad',
  alphabet: 'abcdefghijklmnopqrstuvwxyz234567=',
  bitsPerChar: 5
});
const base32padupper = base$3.rfc4648({
  prefix: 'C',
  name: 'base32padupper',
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=',
  bitsPerChar: 5
});
const base32hex = base$3.rfc4648({
  prefix: 'v',
  name: 'base32hex',
  alphabet: '0123456789abcdefghijklmnopqrstuv',
  bitsPerChar: 5
});
const base32hexupper = base$3.rfc4648({
  prefix: 'V',
  name: 'base32hexupper',
  alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV',
  bitsPerChar: 5
});
const base32hexpad = base$3.rfc4648({
  prefix: 't',
  name: 'base32hexpad',
  alphabet: '0123456789abcdefghijklmnopqrstuv=',
  bitsPerChar: 5
});
const base32hexpadupper = base$3.rfc4648({
  prefix: 'T',
  name: 'base32hexpadupper',
  alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV=',
  bitsPerChar: 5
});
const base32z = base$3.rfc4648({
  prefix: 'h',
  name: 'base32z',
  alphabet: 'ybndrfg8ejkmcpqxot1uwisza345h769',
  bitsPerChar: 5
});

base32$3.base32 = base32$2;
base32$3.base32hex = base32hex;
base32$3.base32hexpad = base32hexpad;
base32$3.base32hexpadupper = base32hexpadupper;
base32$3.base32hexupper = base32hexupper;
base32$3.base32pad = base32pad;
base32$3.base32padupper = base32padupper;
base32$3.base32upper = base32upper;
base32$3.base32z = base32z;

var base36$2 = {};

Object.defineProperty(base36$2, '__esModule', { value: true });

var base$2 = base$a;

const base36$1 = base$2.baseX({
  prefix: 'k',
  name: 'base36',
  alphabet: '0123456789abcdefghijklmnopqrstuvwxyz'
});
const base36upper = base$2.baseX({
  prefix: 'K',
  name: 'base36upper',
  alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
});

base36$2.base36 = base36$1;
base36$2.base36upper = base36upper;

var base58$2 = {};

Object.defineProperty(base58$2, '__esModule', { value: true });

var base$1 = base$a;

const base58btc = base$1.baseX({
  name: 'base58btc',
  prefix: 'z',
  alphabet: '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
});
const base58flickr = base$1.baseX({
  name: 'base58flickr',
  prefix: 'Z',
  alphabet: '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'
});

base58$2.base58btc = base58btc;
base58$2.base58flickr = base58flickr;

var base64$2 = {};

Object.defineProperty(base64$2, '__esModule', { value: true });

var base = base$a;

const base64$1 = base.rfc4648({
  prefix: 'm',
  name: 'base64',
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
  bitsPerChar: 6
});
const base64pad = base.rfc4648({
  prefix: 'M',
  name: 'base64pad',
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
  bitsPerChar: 6
});
const base64url = base.rfc4648({
  prefix: 'u',
  name: 'base64url',
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
  bitsPerChar: 6
});
const base64urlpad = base.rfc4648({
  prefix: 'U',
  name: 'base64urlpad',
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=',
  bitsPerChar: 6
});

base64$2.base64 = base64$1;
base64$2.base64pad = base64pad;
base64$2.base64url = base64url;
base64$2.base64urlpad = base64urlpad;

var sha2$1 = {};

var hasher$3 = {};

var digest$5 = {};

var varint$9 = {};

var encode_1$1 = encode$5;
var MSB$2 = 128, REST$2 = 127, MSBALL$1 = ~REST$2, INT$1 = Math.pow(2, 31);
function encode$5(num, out, offset) {
  out = out || [];
  offset = offset || 0;
  var oldOffset = offset;
  while (num >= INT$1) {
    out[offset++] = num & 255 | MSB$2;
    num /= 128;
  }
  while (num & MSBALL$1) {
    out[offset++] = num & 255 | MSB$2;
    num >>>= 7;
  }
  out[offset] = num | 0;
  encode$5.bytes = offset - oldOffset + 1;
  return out;
}
var decode$6 = read$1;
var MSB$1$1 = 128, REST$1$1 = 127;
function read$1(buf, offset) {
  var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
  do {
    if (counter >= l) {
      read$1.bytes = 0;
      throw new RangeError('Could not decode varint');
    }
    b = buf[counter++];
    res += shift < 28 ? (b & REST$1$1) << shift : (b & REST$1$1) * Math.pow(2, shift);
    shift += 7;
  } while (b >= MSB$1$1);
  read$1.bytes = counter - offset;
  return res;
}
var N1$1 = Math.pow(2, 7);
var N2$1 = Math.pow(2, 14);
var N3$1 = Math.pow(2, 21);
var N4$1 = Math.pow(2, 28);
var N5$1 = Math.pow(2, 35);
var N6$1 = Math.pow(2, 42);
var N7$1 = Math.pow(2, 49);
var N8$1 = Math.pow(2, 56);
var N9$1 = Math.pow(2, 63);
var length$1 = function (value) {
  return value < N1$1 ? 1 : value < N2$1 ? 2 : value < N3$1 ? 3 : value < N4$1 ? 4 : value < N5$1 ? 5 : value < N6$1 ? 6 : value < N7$1 ? 7 : value < N8$1 ? 8 : value < N9$1 ? 9 : 10;
};
var varint$8 = {
  encode: encode_1$1,
  decode: decode$6,
  encodingLength: length$1
};
var _brrp_varint = varint$8;
var varint$1$2 = _brrp_varint;

var varint_1 = varint$1$2;

Object.defineProperty(varint$9, '__esModule', { value: true });

var varint$1$1 = varint_1;

const decode$5 = data => {
  const code = varint$1$1.decode(data);
  return [
    code,
    varint$1$1.decode.bytes
  ];
};
const encodeTo = (int, target, offset = 0) => {
  varint$1$1.encode(int, target, offset);
  return target;
};
const encodingLength = int => {
  return varint$1$1.encodingLength(int);
};

varint$9.decode = decode$5;
varint$9.encodeTo = encodeTo;
varint$9.encodingLength = encodingLength;

Object.defineProperty(digest$5, '__esModule', { value: true });

var bytes$6 = bytes$9;
var varint$7 = varint$9;

const create = (code, digest) => {
  const size = digest.byteLength;
  const sizeOffset = varint$7.encodingLength(code);
  const digestOffset = sizeOffset + varint$7.encodingLength(size);
  const bytes = new Uint8Array(digestOffset + size);
  varint$7.encodeTo(code, bytes, 0);
  varint$7.encodeTo(size, bytes, sizeOffset);
  bytes.set(digest, digestOffset);
  return new Digest(code, size, digest, bytes);
};
const decode$4 = multihash => {
  const bytes$1 = bytes$6.coerce(multihash);
  const [code, sizeOffset] = varint$7.decode(bytes$1);
  const [size, digestOffset] = varint$7.decode(bytes$1.subarray(sizeOffset));
  const digest = bytes$1.subarray(sizeOffset + digestOffset);
  if (digest.byteLength !== size) {
    throw new Error('Incorrect length');
  }
  return new Digest(code, size, digest, bytes$1);
};
const equals$2 = (a, b) => {
  if (a === b) {
    return true;
  } else {
    return a.code === b.code && a.size === b.size && bytes$6.equals(a.bytes, b.bytes);
  }
};
class Digest {
  constructor(code, size, digest, bytes) {
    this.code = code;
    this.size = size;
    this.digest = digest;
    this.bytes = bytes;
  }
}

digest$5.Digest = Digest;
digest$5.create = create;
digest$5.decode = decode$4;
digest$5.equals = equals$2;

Object.defineProperty(hasher$3, '__esModule', { value: true });

var digest$4 = digest$5;

const from = ({name, code, encode}) => new Hasher(name, code, encode);
class Hasher {
  constructor(name, code, encode) {
    this.name = name;
    this.code = code;
    this.encode = encode;
  }
  digest(input) {
    if (input instanceof Uint8Array) {
      const result = this.encode(input);
      return result instanceof Uint8Array ? digest$4.create(this.code, result) : result.then(digest$1 => digest$4.create(this.code, digest$1));
    } else {
      throw Error('Unknown type, must be binary type');
    }
  }
}

hasher$3.Hasher = Hasher;
hasher$3.from = from;

Object.defineProperty(sha2$1, '__esModule', { value: true });

var crypto = require$$0$2;
var hasher$2 = hasher$3;
var bytes$5 = bytes$9;

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var crypto__default = /*#__PURE__*/_interopDefaultLegacy(crypto);

const sha256 = hasher$2.from({
  name: 'sha2-256',
  code: 18,
  encode: input => bytes$5.coerce(crypto__default["default"].createHash('sha256').update(input).digest())
});
const sha512 = hasher$2.from({
  name: 'sha2-512',
  code: 19,
  encode: input => bytes$5.coerce(crypto__default["default"].createHash('sha512').update(input).digest())
});

sha2$1.sha256 = sha256;
sha2$1.sha512 = sha512;

var identity$3 = {};

Object.defineProperty(identity$3, '__esModule', { value: true });

var bytes$4 = bytes$9;
var digest$1$1 = digest$5;

const code$2 = 0;
const name$2 = 'identity';
const encode$4 = bytes$4.coerce;
const digest$3 = input => digest$1$1.create(code$2, encode$4(input));
const identity$2 = {
  code: code$2,
  name: name$2,
  encode: encode$4,
  digest: digest$3
};

identity$3.identity = identity$2;

var raw$1 = {};

Object.defineProperty(raw$1, '__esModule', { value: true });

var bytes$3 = bytes$9;

const name$1 = 'raw';
const code$1 = 85;
const encode$3 = node => bytes$3.coerce(node);
const decode$3 = data => bytes$3.coerce(data);

raw$1.code = code$1;
raw$1.decode = decode$3;
raw$1.encode = encode$3;
raw$1.name = name$1;

var json$1 = {};

Object.defineProperty(json$1, '__esModule', { value: true });

const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();
const name = 'json';
const code = 512;
const encode$2 = node => textEncoder.encode(JSON.stringify(node));
const decode$2 = data => JSON.parse(textDecoder.decode(data));

json$1.code = code;
json$1.decode = decode$2;
json$1.encode = encode$2;
json$1.name = name;

var src$3 = {};

var cid$2 = {};

Object.defineProperty(cid$2, '__esModule', { value: true });

var varint$6 = varint$9;
var digest$2 = digest$5;
var base58$1 = base58$2;
var base32$1 = base32$3;
var bytes$2 = bytes$9;

class CID$1 {
  constructor(version, code, multihash, bytes) {
    this.code = code;
    this.version = version;
    this.multihash = multihash;
    this.bytes = bytes;
    this.byteOffset = bytes.byteOffset;
    this.byteLength = bytes.byteLength;
    this.asCID = this;
    this._baseCache = new Map();
    Object.defineProperties(this, {
      byteOffset: hidden,
      byteLength: hidden,
      code: readonly,
      version: readonly,
      multihash: readonly,
      bytes: readonly,
      _baseCache: hidden,
      asCID: hidden
    });
  }
  toV0() {
    switch (this.version) {
    case 0: {
        return this;
      }
    default: {
        const {code, multihash} = this;
        if (code !== DAG_PB_CODE) {
          throw new Error('Cannot convert a non dag-pb CID to CIDv0');
        }
        if (multihash.code !== SHA_256_CODE) {
          throw new Error('Cannot convert non sha2-256 multihash CID to CIDv0');
        }
        return CID$1.createV0(multihash);
      }
    }
  }
  toV1() {
    switch (this.version) {
    case 0: {
        const {code, digest: digest$1} = this.multihash;
        const multihash = digest$2.create(code, digest$1);
        return CID$1.createV1(this.code, multihash);
      }
    case 1: {
        return this;
      }
    default: {
        throw Error(`Can not convert CID version ${ this.version } to version 0. This is a bug please report`);
      }
    }
  }
  equals(other) {
    return other && this.code === other.code && this.version === other.version && digest$2.equals(this.multihash, other.multihash);
  }
  toString(base) {
    const {bytes, version, _baseCache} = this;
    switch (version) {
    case 0:
      return toStringV0(bytes, _baseCache, base || base58$1.base58btc.encoder);
    default:
      return toStringV1(bytes, _baseCache, base || base32$1.base32.encoder);
    }
  }
  toJSON() {
    return {
      code: this.code,
      version: this.version,
      hash: this.multihash.bytes
    };
  }
  get [Symbol.toStringTag]() {
    return 'CID';
  }
  [Symbol.for('nodejs.util.inspect.custom')]() {
    return 'CID(' + this.toString() + ')';
  }
  static isCID(value) {
    deprecate(/^0\.0/, IS_CID_DEPRECATION);
    return !!(value && (value[cidSymbol] || value.asCID === value));
  }
  get toBaseEncodedString() {
    throw new Error('Deprecated, use .toString()');
  }
  get codec() {
    throw new Error('"codec" property is deprecated, use integer "code" property instead');
  }
  get buffer() {
    throw new Error('Deprecated .buffer property, use .bytes to get Uint8Array instead');
  }
  get multibaseName() {
    throw new Error('"multibaseName" property is deprecated');
  }
  get prefix() {
    throw new Error('"prefix" property is deprecated');
  }
  static asCID(value) {
    if (value instanceof CID$1) {
      return value;
    } else if (value != null && value.asCID === value) {
      const {version, code, multihash, bytes} = value;
      return new CID$1(version, code, multihash, bytes || encodeCID(version, code, multihash.bytes));
    } else if (value != null && value[cidSymbol] === true) {
      const {version, multihash, code} = value;
      const digest$1 = digest$2.decode(multihash);
      return CID$1.create(version, code, digest$1);
    } else {
      return null;
    }
  }
  static create(version, code, digest) {
    if (typeof code !== 'number') {
      throw new Error('String codecs are no longer supported');
    }
    switch (version) {
    case 0: {
        if (code !== DAG_PB_CODE) {
          throw new Error(`Version 0 CID must use dag-pb (code: ${ DAG_PB_CODE }) block encoding`);
        } else {
          return new CID$1(version, code, digest, digest.bytes);
        }
      }
    case 1: {
        const bytes = encodeCID(version, code, digest.bytes);
        return new CID$1(version, code, digest, bytes);
      }
    default: {
        throw new Error('Invalid version');
      }
    }
  }
  static createV0(digest) {
    return CID$1.create(0, DAG_PB_CODE, digest);
  }
  static createV1(code, digest) {
    return CID$1.create(1, code, digest);
  }
  static decode(bytes) {
    const [cid, remainder] = CID$1.decodeFirst(bytes);
    if (remainder.length) {
      throw new Error('Incorrect length');
    }
    return cid;
  }
  static decodeFirst(bytes$1) {
    const specs = CID$1.inspectBytes(bytes$1);
    const prefixSize = specs.size - specs.multihashSize;
    const multihashBytes = bytes$2.coerce(bytes$1.subarray(prefixSize, prefixSize + specs.multihashSize));
    if (multihashBytes.byteLength !== specs.multihashSize) {
      throw new Error('Incorrect length');
    }
    const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
    const digest$1 = new digest$2.Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
    const cid = specs.version === 0 ? CID$1.createV0(digest$1) : CID$1.createV1(specs.codec, digest$1);
    return [
      cid,
      bytes$1.subarray(specs.size)
    ];
  }
  static inspectBytes(initialBytes) {
    let offset = 0;
    const next = () => {
      const [i, length] = varint$6.decode(initialBytes.subarray(offset));
      offset += length;
      return i;
    };
    let version = next();
    let codec = DAG_PB_CODE;
    if (version === 18) {
      version = 0;
      offset = 0;
    } else if (version === 1) {
      codec = next();
    }
    if (version !== 0 && version !== 1) {
      throw new RangeError(`Invalid CID version ${ version }`);
    }
    const prefixSize = offset;
    const multihashCode = next();
    const digestSize = next();
    const size = offset + digestSize;
    const multihashSize = size - prefixSize;
    return {
      version,
      codec,
      multihashCode,
      digestSize,
      multihashSize,
      size
    };
  }
  static parse(source, base) {
    const [prefix, bytes] = parseCIDtoBytes(source, base);
    const cid = CID$1.decode(bytes);
    cid._baseCache.set(prefix, source);
    return cid;
  }
}
const parseCIDtoBytes = (source, base) => {
  switch (source[0]) {
  case 'Q': {
      const decoder = base || base58$1.base58btc;
      return [
        base58$1.base58btc.prefix,
        decoder.decode(`${ base58$1.base58btc.prefix }${ source }`)
      ];
    }
  case base58$1.base58btc.prefix: {
      const decoder = base || base58$1.base58btc;
      return [
        base58$1.base58btc.prefix,
        decoder.decode(source)
      ];
    }
  case base32$1.base32.prefix: {
      const decoder = base || base32$1.base32;
      return [
        base32$1.base32.prefix,
        decoder.decode(source)
      ];
    }
  default: {
      if (base == null) {
        throw Error('To parse non base32 or base58btc encoded CID multibase decoder must be provided');
      }
      return [
        source[0],
        base.decode(source)
      ];
    }
  }
};
const toStringV0 = (bytes, cache, base) => {
  const {prefix} = base;
  if (prefix !== base58$1.base58btc.prefix) {
    throw Error(`Cannot string encode V0 in ${ base.name } encoding`);
  }
  const cid = cache.get(prefix);
  if (cid == null) {
    const cid = base.encode(bytes).slice(1);
    cache.set(prefix, cid);
    return cid;
  } else {
    return cid;
  }
};
const toStringV1 = (bytes, cache, base) => {
  const {prefix} = base;
  const cid = cache.get(prefix);
  if (cid == null) {
    const cid = base.encode(bytes);
    cache.set(prefix, cid);
    return cid;
  } else {
    return cid;
  }
};
const DAG_PB_CODE = 112;
const SHA_256_CODE = 18;
const encodeCID = (version, code, multihash) => {
  const codeOffset = varint$6.encodingLength(version);
  const hashOffset = codeOffset + varint$6.encodingLength(code);
  const bytes = new Uint8Array(hashOffset + multihash.byteLength);
  varint$6.encodeTo(version, bytes, 0);
  varint$6.encodeTo(code, bytes, codeOffset);
  bytes.set(multihash, hashOffset);
  return bytes;
};
const cidSymbol = Symbol.for('@ipld/js-cid/CID');
const readonly = {
  writable: false,
  configurable: false,
  enumerable: true
};
const hidden = {
  writable: false,
  enumerable: false,
  configurable: false
};
const version = '0.0.0-dev';
const deprecate = (range, message) => {
  if (range.test(version)) {
    console.warn(message);
  } else {
    throw new Error(message);
  }
};
const IS_CID_DEPRECATION = `CID.isCID(v) is deprecated and will be removed in the next major release.
Following code pattern:

if (CID.isCID(value)) {
  doSomethingWithCID(value)
}

Is replaced with:

const cid = CID.asCID(value)
if (cid) {
  // Make sure to use cid instead of value
  doSomethingWithCID(cid)
}
`;

cid$2.CID = CID$1;

Object.defineProperty(src$3, '__esModule', { value: true });

var cid$1 = cid$2;
var varint$5 = varint$9;
var bytes$1 = bytes$9;
var hasher$1 = hasher$3;
var digest$1 = digest$5;



src$3.CID = cid$1.CID;
src$3.varint = varint$5;
src$3.bytes = bytes$1;
src$3.hasher = hasher$1;
src$3.digest = digest$1;

Object.defineProperty(basics$1, '__esModule', { value: true });

var identity = identity$5;
var base2 = base2$2;
var base8 = base8$2;
var base10 = base10$2;
var base16 = base16$2;
var base32 = base32$3;
var base36 = base36$2;
var base58 = base58$2;
var base64 = base64$2;
var sha2 = sha2$1;
var identity$1 = identity$3;
var raw = raw$1;
var json = json$1;

var cid = cid$2;
var hasher = hasher$3;
var digest = digest$5;
var varint$4 = varint$9;
var bytes = bytes$9;

const bases$3 = {
  ...identity,
  ...base2,
  ...base8,
  ...base10,
  ...base16,
  ...base32,
  ...base36,
  ...base58,
  ...base64
};
const hashes = {
  ...sha2,
  ...identity$1
};
const codecs$1 = {
  raw,
  json
};

basics$1.CID = cid.CID;
basics$1.hasher = hasher;
basics$1.digest = digest;
basics$1.varint = varint$4;
basics$1.bytes = bytes;
basics$1.bases = bases$3;
basics$1.codecs = codecs$1;
basics$1.hashes = hashes;

var basics = basics$1;

function createCodec(name, prefix, encode, decode) {
  return {
    name,
    prefix,
    encoder: {
      name,
      prefix,
      encode
    },
    decoder: { decode }
  };
}
const string = createCodec('utf8', 'u', buf => {
  const decoder = new TextDecoder('utf8');
  return 'u' + decoder.decode(buf);
}, str => {
  const encoder = new TextEncoder();
  return encoder.encode(str.substring(1));
});
const ascii = createCodec('ascii', 'a', buf => {
  let string = 'a';
  for (let i = 0; i < buf.length; i++) {
    string += String.fromCharCode(buf[i]);
  }
  return string;
}, str => {
  str = str.substring(1);
  const buf = new Uint8Array(str.length);
  for (let i = 0; i < str.length; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
});
const BASES = {
  utf8: string,
  'utf-8': string,
  hex: basics.bases.base16,
  latin1: ascii,
  ascii: ascii,
  binary: ascii,
  ...basics.bases
};

var bases$2 = BASES;

Object.defineProperty(toString$2, '__esModule', { value: true });

var bases$1 = bases$2;

function toString(array, encoding = 'utf8') {
  const base = bases$1[encoding];
  if (!base) {
    throw new Error(`Unsupported encoding "${ encoding }"`);
  }
  return base.encoder.encode(array).substring(1);
}

toString$2.toString = toString;

var fromString$1 = {};

Object.defineProperty(fromString$1, '__esModule', { value: true });

var bases = bases$2;

function fromString(string, encoding = 'utf8') {
  const base = bases[encoding];
  if (!base) {
    throw new Error(`Unsupported encoding "${ encoding }"`);
  }
  return base.decoder.decode(`${ base.prefix }${ string }`);
}

fromString$1.fromString = fromString;

var concat$1 = {};

Object.defineProperty(concat$1, '__esModule', { value: true });

function concat(arrays, length) {
  if (!length) {
    length = arrays.reduce((acc, curr) => acc + curr.length, 0);
  }
  const output = new Uint8Array(length);
  let offset = 0;
  for (const arr of arrays) {
    output.set(arr, offset);
    offset += arr.length;
  }
  return output;
}

concat$1.concat = concat;

/**
 * Multihash implementation in JavaScript.
 */

const multibase$1 = src$6.exports;
const varint$3 = varint$a;
const { names } = constants;
const { toString: uint8ArrayToString$2 } = toString$2;
const { fromString: uint8ArrayFromString$1 } = fromString$1;
const { concat: uint8ArrayConcat$2 } = concat$1;

const codes = /** @type {import('./types').CodeNameMap} */({});

// eslint-disable-next-line guard-for-in
for (const key in names) {
  const name = /** @type {HashName} */(key);
  codes[names[name]] = name;
}
Object.freeze(codes);

/**
 * Convert the given multihash to a hex encoded string.
 *
 * @param {Uint8Array} hash
 * @returns {string}
 */
function toHexString (hash) {
  if (!(hash instanceof Uint8Array)) {
    throw new Error('must be passed a Uint8Array')
  }

  return uint8ArrayToString$2(hash, 'base16')
}

/**
 * Convert the given hex encoded string to a multihash.
 *
 * @param {string} hash
 * @returns {Uint8Array}
 */
function fromHexString (hash) {
  return uint8ArrayFromString$1(hash, 'base16')
}

/**
 * Convert the given multihash to a base58 encoded string.
 *
 * @param {Uint8Array} hash
 * @returns {string}
 */
function toB58String (hash) {
  if (!(hash instanceof Uint8Array)) {
    throw new Error('must be passed a Uint8Array')
  }

  return uint8ArrayToString$2(multibase$1.encode('base58btc', hash)).slice(1)
}

/**
 * Convert the given base58 encoded string to a multihash.
 *
 * @param {string|Uint8Array} hash
 * @returns {Uint8Array}
 */
function fromB58String (hash) {
  const encoded = hash instanceof Uint8Array
    ? uint8ArrayToString$2(hash)
    : hash;

  return multibase$1.decode('z' + encoded)
}

/**
 * Decode a hash from the given multihash.
 *
 * @param {Uint8Array} bytes
 * @returns {{code: HashCode, name: HashName, length: number, digest: Uint8Array}} result
 */
function decode$1 (bytes) {
  if (!(bytes instanceof Uint8Array)) {
    throw new Error('multihash must be a Uint8Array')
  }

  if (bytes.length < 2) {
    throw new Error('multihash too short. must be > 2 bytes.')
  }

  const code = /** @type {HashCode} */(varint$3.decode(bytes));
  if (!isValidCode(code)) {
    throw new Error(`multihash unknown function code: 0x${code.toString(16)}`)
  }
  bytes = bytes.slice(varint$3.decode.bytes);

  const len = varint$3.decode(bytes);
  if (len < 0) {
    throw new Error(`multihash invalid length: ${len}`)
  }
  bytes = bytes.slice(varint$3.decode.bytes);

  if (bytes.length !== len) {
    throw new Error(`multihash length inconsistent: 0x${uint8ArrayToString$2(bytes, 'base16')}`)
  }

  return {
    code,
    name: codes[code],
    length: len,
    digest: bytes
  }
}

/**
 * Encode a hash digest along with the specified function code.
 *
 * > **Note:** the length is derived from the length of the digest itself.
 *
 * @param {Uint8Array} digest
 * @param {HashName | HashCode} code
 * @param {number} [length]
 * @returns {Uint8Array}
 */
function encode$1 (digest, code, length) {
  if (!digest || code === undefined) {
    throw new Error('multihash encode requires at least two args: digest, code')
  }

  // ensure it's a hashfunction code.
  const hashfn = coerceCode(code);

  if (!(digest instanceof Uint8Array)) {
    throw new Error('digest should be a Uint8Array')
  }

  if (length == null) {
    length = digest.length;
  }

  if (length && digest.length !== length) {
    throw new Error('digest length should be equal to specified length.')
  }

  const hash = varint$3.encode(hashfn);
  const len = varint$3.encode(length);
  return uint8ArrayConcat$2([hash, len, digest], hash.length + len.length + digest.length)
}

/**
 * Converts a hash function name into the matching code.
 * If passed a number it will return the number if it's a valid code.
 *
 * @param {HashName | number} name
 * @returns {number}
 */
function coerceCode (name) {
  let code = name;

  if (typeof name === 'string') {
    if (names[name] === undefined) {
      throw new Error(`Unrecognized hash function named: ${name}`)
    }
    code = names[name];
  }

  if (typeof code !== 'number') {
    throw new Error(`Hash function code should be a number. Got: ${code}`)
  }

  // @ts-ignore
  if (codes[code] === undefined && !isAppCode(code)) {
    throw new Error(`Unrecognized function code: ${code}`)
  }

  return code
}

/**
 * Checks if a code is part of the app range
 *
 * @param {number} code
 * @returns {boolean}
 */
function isAppCode (code) {
  return code > 0 && code < 0x10
}

/**
 * Checks whether a multihash code is valid.
 *
 * @param {HashCode} code
 * @returns {boolean}
 */
function isValidCode (code) {
  if (isAppCode(code)) {
    return true
  }

  if (codes[code]) {
    return true
  }

  return false
}

/**
 * Check if the given buffer is a valid multihash. Throws an error if it is not valid.
 *
 * @param {Uint8Array} multihash
 * @returns {void}
 * @throws {Error}
 */
function validate (multihash) {
  decode$1(multihash); // throws if bad.
}

/**
 * Returns a prefix from a valid multihash. Throws an error if it is not valid.
 *
 * @param {Uint8Array} multihash
 * @returns {Uint8Array}
 * @throws {Error}
 */
function prefix (multihash) {
  validate(multihash);

  return multihash.subarray(0, 2)
}

var src$2 = {
  names,
  codes,
  toHexString,
  fromHexString,
  toB58String,
  fromB58String,
  decode: decode$1,
  encode: encode$1,
  coerceCode,
  isAppCode,
  validate,
  prefix,
  isValidCode
};

var encode_1 = encode;

var MSB$1 = 0x80
  , REST$1 = 0x7F
  , MSBALL = ~REST$1
  , INT = Math.pow(2, 31);

function encode(num, out, offset) {
  if (Number.MAX_SAFE_INTEGER && num > Number.MAX_SAFE_INTEGER) {
    encode.bytes = 0;
    throw new RangeError('Could not encode varint')
  }
  out = out || [];
  offset = offset || 0;
  var oldOffset = offset;

  while(num >= INT) {
    out[offset++] = (num & 0xFF) | MSB$1;
    num /= 128;
  }
  while(num & MSBALL) {
    out[offset++] = (num & 0xFF) | MSB$1;
    num >>>= 7;
  }
  out[offset] = num | 0;
  
  encode.bytes = offset - oldOffset + 1;
  
  return out
}

var decode = read;

var MSB = 0x80
  , REST = 0x7F;

function read(buf, offset) {
  var res    = 0
    , offset = offset || 0
    , shift  = 0
    , counter = offset
    , b
    , l = buf.length;

  do {
    if (counter >= l || shift > 49) {
      read.bytes = 0;
      throw new RangeError('Could not decode varint')
    }
    b = buf[counter++];
    res += shift < 28
      ? (b & REST) << shift
      : (b & REST) * Math.pow(2, shift);
    shift += 7;
  } while (b >= MSB)

  read.bytes = counter - offset;

  return res
}

var N1 = Math.pow(2,  7);
var N2 = Math.pow(2, 14);
var N3 = Math.pow(2, 21);
var N4 = Math.pow(2, 28);
var N5 = Math.pow(2, 35);
var N6 = Math.pow(2, 42);
var N7 = Math.pow(2, 49);
var N8 = Math.pow(2, 56);
var N9 = Math.pow(2, 63);

var length = function (value) {
  return (
    value < N1 ? 1
  : value < N2 ? 2
  : value < N3 ? 3
  : value < N4 ? 4
  : value < N5 ? 5
  : value < N6 ? 6
  : value < N7 ? 7
  : value < N8 ? 8
  : value < N9 ? 9
  :              10
  )
};

var varint$2 = {
    encode: encode_1
  , decode: decode
  , encodingLength: length
};

const varint$1 = varint$2;
const { toString: uint8ArrayToString$1 } = toString$2;
const { fromString: uint8ArrayFromString } = fromString$1;

var util$1 = {
  numberToUint8Array,
  uint8ArrayToNumber,
  varintUint8ArrayEncode,
  varintEncode: varintEncode$1
};

/**
 * @param {Uint8Array} buf
 */
function uint8ArrayToNumber (buf) {
  return parseInt(uint8ArrayToString$1(buf, 'base16'), 16)
}

/**
 * @param {number} num
 */
function numberToUint8Array (num) {
  let hexString = num.toString(16);
  if (hexString.length % 2 === 1) {
    hexString = '0' + hexString;
  }
  return uint8ArrayFromString(hexString, 'base16')
}

/**
 * @param {Uint8Array} input
 */
function varintUint8ArrayEncode (input) {
  return Uint8Array.from(varint$1.encode(uint8ArrayToNumber(input)))
}

/**
 * @param {number} num
 */
function varintEncode$1 (num) {
  return Uint8Array.from(varint$1.encode(num))
}

/**
 * @type {import('./generated-types').NameCodeMap}
 */
const baseTable$1 = Object.freeze({
  'identity': 0x00,
  'cidv1': 0x01,
  'cidv2': 0x02,
  'cidv3': 0x03,
  'ip4': 0x04,
  'tcp': 0x06,
  'sha1': 0x11,
  'sha2-256': 0x12,
  'sha2-512': 0x13,
  'sha3-512': 0x14,
  'sha3-384': 0x15,
  'sha3-256': 0x16,
  'sha3-224': 0x17,
  'shake-128': 0x18,
  'shake-256': 0x19,
  'keccak-224': 0x1a,
  'keccak-256': 0x1b,
  'keccak-384': 0x1c,
  'keccak-512': 0x1d,
  'blake3': 0x1e,
  'dccp': 0x21,
  'murmur3-128': 0x22,
  'murmur3-32': 0x23,
  'ip6': 0x29,
  'ip6zone': 0x2a,
  'path': 0x2f,
  'multicodec': 0x30,
  'multihash': 0x31,
  'multiaddr': 0x32,
  'multibase': 0x33,
  'dns': 0x35,
  'dns4': 0x36,
  'dns6': 0x37,
  'dnsaddr': 0x38,
  'protobuf': 0x50,
  'cbor': 0x51,
  'raw': 0x55,
  'dbl-sha2-256': 0x56,
  'rlp': 0x60,
  'bencode': 0x63,
  'dag-pb': 0x70,
  'dag-cbor': 0x71,
  'libp2p-key': 0x72,
  'git-raw': 0x78,
  'torrent-info': 0x7b,
  'torrent-file': 0x7c,
  'leofcoin-block': 0x81,
  'leofcoin-tx': 0x82,
  'leofcoin-pr': 0x83,
  'sctp': 0x84,
  'dag-jose': 0x85,
  'dag-cose': 0x86,
  'eth-block': 0x90,
  'eth-block-list': 0x91,
  'eth-tx-trie': 0x92,
  'eth-tx': 0x93,
  'eth-tx-receipt-trie': 0x94,
  'eth-tx-receipt': 0x95,
  'eth-state-trie': 0x96,
  'eth-account-snapshot': 0x97,
  'eth-storage-trie': 0x98,
  'eth-receipt-log-trie': 0x99,
  'eth-reciept-log': 0x9a,
  'bitcoin-block': 0xb0,
  'bitcoin-tx': 0xb1,
  'bitcoin-witness-commitment': 0xb2,
  'zcash-block': 0xc0,
  'zcash-tx': 0xc1,
  'caip-50': 0xca,
  'streamid': 0xce,
  'stellar-block': 0xd0,
  'stellar-tx': 0xd1,
  'md4': 0xd4,
  'md5': 0xd5,
  'bmt': 0xd6,
  'decred-block': 0xe0,
  'decred-tx': 0xe1,
  'ipld-ns': 0xe2,
  'ipfs-ns': 0xe3,
  'swarm-ns': 0xe4,
  'ipns-ns': 0xe5,
  'zeronet': 0xe6,
  'secp256k1-pub': 0xe7,
  'bls12_381-g1-pub': 0xea,
  'bls12_381-g2-pub': 0xeb,
  'x25519-pub': 0xec,
  'ed25519-pub': 0xed,
  'bls12_381-g1g2-pub': 0xee,
  'dash-block': 0xf0,
  'dash-tx': 0xf1,
  'swarm-manifest': 0xfa,
  'swarm-feed': 0xfb,
  'udp': 0x0111,
  'p2p-webrtc-star': 0x0113,
  'p2p-webrtc-direct': 0x0114,
  'p2p-stardust': 0x0115,
  'p2p-circuit': 0x0122,
  'dag-json': 0x0129,
  'udt': 0x012d,
  'utp': 0x012e,
  'unix': 0x0190,
  'thread': 0x0196,
  'p2p': 0x01a5,
  'ipfs': 0x01a5,
  'https': 0x01bb,
  'onion': 0x01bc,
  'onion3': 0x01bd,
  'garlic64': 0x01be,
  'garlic32': 0x01bf,
  'tls': 0x01c0,
  'noise': 0x01c6,
  'quic': 0x01cc,
  'ws': 0x01dd,
  'wss': 0x01de,
  'p2p-websocket-star': 0x01df,
  'http': 0x01e0,
  'swhid-1-snp': 0x01f0,
  'json': 0x0200,
  'messagepack': 0x0201,
  'libp2p-peer-record': 0x0301,
  'libp2p-relay-rsvp': 0x0302,
  'car-index-sorted': 0x0400,
  'sha2-256-trunc254-padded': 0x1012,
  'ripemd-128': 0x1052,
  'ripemd-160': 0x1053,
  'ripemd-256': 0x1054,
  'ripemd-320': 0x1055,
  'x11': 0x1100,
  'p256-pub': 0x1200,
  'p384-pub': 0x1201,
  'p521-pub': 0x1202,
  'ed448-pub': 0x1203,
  'x448-pub': 0x1204,
  'ed25519-priv': 0x1300,
  'secp256k1-priv': 0x1301,
  'x25519-priv': 0x1302,
  'kangarootwelve': 0x1d01,
  'sm3-256': 0x534d,
  'blake2b-8': 0xb201,
  'blake2b-16': 0xb202,
  'blake2b-24': 0xb203,
  'blake2b-32': 0xb204,
  'blake2b-40': 0xb205,
  'blake2b-48': 0xb206,
  'blake2b-56': 0xb207,
  'blake2b-64': 0xb208,
  'blake2b-72': 0xb209,
  'blake2b-80': 0xb20a,
  'blake2b-88': 0xb20b,
  'blake2b-96': 0xb20c,
  'blake2b-104': 0xb20d,
  'blake2b-112': 0xb20e,
  'blake2b-120': 0xb20f,
  'blake2b-128': 0xb210,
  'blake2b-136': 0xb211,
  'blake2b-144': 0xb212,
  'blake2b-152': 0xb213,
  'blake2b-160': 0xb214,
  'blake2b-168': 0xb215,
  'blake2b-176': 0xb216,
  'blake2b-184': 0xb217,
  'blake2b-192': 0xb218,
  'blake2b-200': 0xb219,
  'blake2b-208': 0xb21a,
  'blake2b-216': 0xb21b,
  'blake2b-224': 0xb21c,
  'blake2b-232': 0xb21d,
  'blake2b-240': 0xb21e,
  'blake2b-248': 0xb21f,
  'blake2b-256': 0xb220,
  'blake2b-264': 0xb221,
  'blake2b-272': 0xb222,
  'blake2b-280': 0xb223,
  'blake2b-288': 0xb224,
  'blake2b-296': 0xb225,
  'blake2b-304': 0xb226,
  'blake2b-312': 0xb227,
  'blake2b-320': 0xb228,
  'blake2b-328': 0xb229,
  'blake2b-336': 0xb22a,
  'blake2b-344': 0xb22b,
  'blake2b-352': 0xb22c,
  'blake2b-360': 0xb22d,
  'blake2b-368': 0xb22e,
  'blake2b-376': 0xb22f,
  'blake2b-384': 0xb230,
  'blake2b-392': 0xb231,
  'blake2b-400': 0xb232,
  'blake2b-408': 0xb233,
  'blake2b-416': 0xb234,
  'blake2b-424': 0xb235,
  'blake2b-432': 0xb236,
  'blake2b-440': 0xb237,
  'blake2b-448': 0xb238,
  'blake2b-456': 0xb239,
  'blake2b-464': 0xb23a,
  'blake2b-472': 0xb23b,
  'blake2b-480': 0xb23c,
  'blake2b-488': 0xb23d,
  'blake2b-496': 0xb23e,
  'blake2b-504': 0xb23f,
  'blake2b-512': 0xb240,
  'blake2s-8': 0xb241,
  'blake2s-16': 0xb242,
  'blake2s-24': 0xb243,
  'blake2s-32': 0xb244,
  'blake2s-40': 0xb245,
  'blake2s-48': 0xb246,
  'blake2s-56': 0xb247,
  'blake2s-64': 0xb248,
  'blake2s-72': 0xb249,
  'blake2s-80': 0xb24a,
  'blake2s-88': 0xb24b,
  'blake2s-96': 0xb24c,
  'blake2s-104': 0xb24d,
  'blake2s-112': 0xb24e,
  'blake2s-120': 0xb24f,
  'blake2s-128': 0xb250,
  'blake2s-136': 0xb251,
  'blake2s-144': 0xb252,
  'blake2s-152': 0xb253,
  'blake2s-160': 0xb254,
  'blake2s-168': 0xb255,
  'blake2s-176': 0xb256,
  'blake2s-184': 0xb257,
  'blake2s-192': 0xb258,
  'blake2s-200': 0xb259,
  'blake2s-208': 0xb25a,
  'blake2s-216': 0xb25b,
  'blake2s-224': 0xb25c,
  'blake2s-232': 0xb25d,
  'blake2s-240': 0xb25e,
  'blake2s-248': 0xb25f,
  'blake2s-256': 0xb260,
  'skein256-8': 0xb301,
  'skein256-16': 0xb302,
  'skein256-24': 0xb303,
  'skein256-32': 0xb304,
  'skein256-40': 0xb305,
  'skein256-48': 0xb306,
  'skein256-56': 0xb307,
  'skein256-64': 0xb308,
  'skein256-72': 0xb309,
  'skein256-80': 0xb30a,
  'skein256-88': 0xb30b,
  'skein256-96': 0xb30c,
  'skein256-104': 0xb30d,
  'skein256-112': 0xb30e,
  'skein256-120': 0xb30f,
  'skein256-128': 0xb310,
  'skein256-136': 0xb311,
  'skein256-144': 0xb312,
  'skein256-152': 0xb313,
  'skein256-160': 0xb314,
  'skein256-168': 0xb315,
  'skein256-176': 0xb316,
  'skein256-184': 0xb317,
  'skein256-192': 0xb318,
  'skein256-200': 0xb319,
  'skein256-208': 0xb31a,
  'skein256-216': 0xb31b,
  'skein256-224': 0xb31c,
  'skein256-232': 0xb31d,
  'skein256-240': 0xb31e,
  'skein256-248': 0xb31f,
  'skein256-256': 0xb320,
  'skein512-8': 0xb321,
  'skein512-16': 0xb322,
  'skein512-24': 0xb323,
  'skein512-32': 0xb324,
  'skein512-40': 0xb325,
  'skein512-48': 0xb326,
  'skein512-56': 0xb327,
  'skein512-64': 0xb328,
  'skein512-72': 0xb329,
  'skein512-80': 0xb32a,
  'skein512-88': 0xb32b,
  'skein512-96': 0xb32c,
  'skein512-104': 0xb32d,
  'skein512-112': 0xb32e,
  'skein512-120': 0xb32f,
  'skein512-128': 0xb330,
  'skein512-136': 0xb331,
  'skein512-144': 0xb332,
  'skein512-152': 0xb333,
  'skein512-160': 0xb334,
  'skein512-168': 0xb335,
  'skein512-176': 0xb336,
  'skein512-184': 0xb337,
  'skein512-192': 0xb338,
  'skein512-200': 0xb339,
  'skein512-208': 0xb33a,
  'skein512-216': 0xb33b,
  'skein512-224': 0xb33c,
  'skein512-232': 0xb33d,
  'skein512-240': 0xb33e,
  'skein512-248': 0xb33f,
  'skein512-256': 0xb340,
  'skein512-264': 0xb341,
  'skein512-272': 0xb342,
  'skein512-280': 0xb343,
  'skein512-288': 0xb344,
  'skein512-296': 0xb345,
  'skein512-304': 0xb346,
  'skein512-312': 0xb347,
  'skein512-320': 0xb348,
  'skein512-328': 0xb349,
  'skein512-336': 0xb34a,
  'skein512-344': 0xb34b,
  'skein512-352': 0xb34c,
  'skein512-360': 0xb34d,
  'skein512-368': 0xb34e,
  'skein512-376': 0xb34f,
  'skein512-384': 0xb350,
  'skein512-392': 0xb351,
  'skein512-400': 0xb352,
  'skein512-408': 0xb353,
  'skein512-416': 0xb354,
  'skein512-424': 0xb355,
  'skein512-432': 0xb356,
  'skein512-440': 0xb357,
  'skein512-448': 0xb358,
  'skein512-456': 0xb359,
  'skein512-464': 0xb35a,
  'skein512-472': 0xb35b,
  'skein512-480': 0xb35c,
  'skein512-488': 0xb35d,
  'skein512-496': 0xb35e,
  'skein512-504': 0xb35f,
  'skein512-512': 0xb360,
  'skein1024-8': 0xb361,
  'skein1024-16': 0xb362,
  'skein1024-24': 0xb363,
  'skein1024-32': 0xb364,
  'skein1024-40': 0xb365,
  'skein1024-48': 0xb366,
  'skein1024-56': 0xb367,
  'skein1024-64': 0xb368,
  'skein1024-72': 0xb369,
  'skein1024-80': 0xb36a,
  'skein1024-88': 0xb36b,
  'skein1024-96': 0xb36c,
  'skein1024-104': 0xb36d,
  'skein1024-112': 0xb36e,
  'skein1024-120': 0xb36f,
  'skein1024-128': 0xb370,
  'skein1024-136': 0xb371,
  'skein1024-144': 0xb372,
  'skein1024-152': 0xb373,
  'skein1024-160': 0xb374,
  'skein1024-168': 0xb375,
  'skein1024-176': 0xb376,
  'skein1024-184': 0xb377,
  'skein1024-192': 0xb378,
  'skein1024-200': 0xb379,
  'skein1024-208': 0xb37a,
  'skein1024-216': 0xb37b,
  'skein1024-224': 0xb37c,
  'skein1024-232': 0xb37d,
  'skein1024-240': 0xb37e,
  'skein1024-248': 0xb37f,
  'skein1024-256': 0xb380,
  'skein1024-264': 0xb381,
  'skein1024-272': 0xb382,
  'skein1024-280': 0xb383,
  'skein1024-288': 0xb384,
  'skein1024-296': 0xb385,
  'skein1024-304': 0xb386,
  'skein1024-312': 0xb387,
  'skein1024-320': 0xb388,
  'skein1024-328': 0xb389,
  'skein1024-336': 0xb38a,
  'skein1024-344': 0xb38b,
  'skein1024-352': 0xb38c,
  'skein1024-360': 0xb38d,
  'skein1024-368': 0xb38e,
  'skein1024-376': 0xb38f,
  'skein1024-384': 0xb390,
  'skein1024-392': 0xb391,
  'skein1024-400': 0xb392,
  'skein1024-408': 0xb393,
  'skein1024-416': 0xb394,
  'skein1024-424': 0xb395,
  'skein1024-432': 0xb396,
  'skein1024-440': 0xb397,
  'skein1024-448': 0xb398,
  'skein1024-456': 0xb399,
  'skein1024-464': 0xb39a,
  'skein1024-472': 0xb39b,
  'skein1024-480': 0xb39c,
  'skein1024-488': 0xb39d,
  'skein1024-496': 0xb39e,
  'skein1024-504': 0xb39f,
  'skein1024-512': 0xb3a0,
  'skein1024-520': 0xb3a1,
  'skein1024-528': 0xb3a2,
  'skein1024-536': 0xb3a3,
  'skein1024-544': 0xb3a4,
  'skein1024-552': 0xb3a5,
  'skein1024-560': 0xb3a6,
  'skein1024-568': 0xb3a7,
  'skein1024-576': 0xb3a8,
  'skein1024-584': 0xb3a9,
  'skein1024-592': 0xb3aa,
  'skein1024-600': 0xb3ab,
  'skein1024-608': 0xb3ac,
  'skein1024-616': 0xb3ad,
  'skein1024-624': 0xb3ae,
  'skein1024-632': 0xb3af,
  'skein1024-640': 0xb3b0,
  'skein1024-648': 0xb3b1,
  'skein1024-656': 0xb3b2,
  'skein1024-664': 0xb3b3,
  'skein1024-672': 0xb3b4,
  'skein1024-680': 0xb3b5,
  'skein1024-688': 0xb3b6,
  'skein1024-696': 0xb3b7,
  'skein1024-704': 0xb3b8,
  'skein1024-712': 0xb3b9,
  'skein1024-720': 0xb3ba,
  'skein1024-728': 0xb3bb,
  'skein1024-736': 0xb3bc,
  'skein1024-744': 0xb3bd,
  'skein1024-752': 0xb3be,
  'skein1024-760': 0xb3bf,
  'skein1024-768': 0xb3c0,
  'skein1024-776': 0xb3c1,
  'skein1024-784': 0xb3c2,
  'skein1024-792': 0xb3c3,
  'skein1024-800': 0xb3c4,
  'skein1024-808': 0xb3c5,
  'skein1024-816': 0xb3c6,
  'skein1024-824': 0xb3c7,
  'skein1024-832': 0xb3c8,
  'skein1024-840': 0xb3c9,
  'skein1024-848': 0xb3ca,
  'skein1024-856': 0xb3cb,
  'skein1024-864': 0xb3cc,
  'skein1024-872': 0xb3cd,
  'skein1024-880': 0xb3ce,
  'skein1024-888': 0xb3cf,
  'skein1024-896': 0xb3d0,
  'skein1024-904': 0xb3d1,
  'skein1024-912': 0xb3d2,
  'skein1024-920': 0xb3d3,
  'skein1024-928': 0xb3d4,
  'skein1024-936': 0xb3d5,
  'skein1024-944': 0xb3d6,
  'skein1024-952': 0xb3d7,
  'skein1024-960': 0xb3d8,
  'skein1024-968': 0xb3d9,
  'skein1024-976': 0xb3da,
  'skein1024-984': 0xb3db,
  'skein1024-992': 0xb3dc,
  'skein1024-1000': 0xb3dd,
  'skein1024-1008': 0xb3de,
  'skein1024-1016': 0xb3df,
  'skein1024-1024': 0xb3e0,
  'poseidon-bls12_381-a2-fc1': 0xb401,
  'poseidon-bls12_381-a2-fc1-sc': 0xb402,
  'zeroxcert-imprint-256': 0xce11,
  'fil-commitment-unsealed': 0xf101,
  'fil-commitment-sealed': 0xf102,
  'holochain-adr-v0': 0x807124,
  'holochain-adr-v1': 0x817124,
  'holochain-key-v0': 0x947124,
  'holochain-key-v1': 0x957124,
  'holochain-sig-v0': 0xa27124,
  'holochain-sig-v1': 0xa37124,
  'skynet-ns': 0xb19910,
  'arweave-ns': 0xb29910
});

var generatedTable = { baseTable: baseTable$1 };

/** @typedef {import('./generated-types').ConstantCodeMap} ConstantCodeMap */
/** @typedef {import('./generated-types').NameUint8ArrayMap} NameUint8ArrayMap */
/** @typedef {import('./generated-types').CodeNameMap} CodeNameMap */
/** @typedef {import('./generated-types').CodecName} CodecName */
/** @typedef {import('./generated-types').CodecConstant} CodecConstant */

const { baseTable } = generatedTable;
const varintEncode = util$1.varintEncode;

const nameToVarint$1 = /** @type {NameUint8ArrayMap} */ ({});
const constantToCode$1 = /** @type {ConstantCodeMap} */({});
const codeToName$1 = /** @type {CodeNameMap} */({});

// eslint-disable-next-line guard-for-in
for (const name in baseTable) {
  const codecName = /** @type {CodecName} */(name);
  const code = baseTable[codecName];
  nameToVarint$1[codecName] = varintEncode(code);

  const constant = /** @type {CodecConstant} */(codecName.toUpperCase().replace(/-/g, '_'));
  constantToCode$1[constant] = code;

  if (!codeToName$1[code]) {
    codeToName$1[code] = codecName;
  }
}

Object.freeze(nameToVarint$1);
Object.freeze(constantToCode$1);
Object.freeze(codeToName$1);
const nameToCode$1 = Object.freeze(baseTable);
var maps = {
  nameToVarint: nameToVarint$1,
  constantToCode: constantToCode$1,
  nameToCode: nameToCode$1,
  codeToName: codeToName$1
};

/**
 * Implementation of the multicodec specification.
 *
 * @module multicodec
 * @example
 * const multicodec = require('multicodec')
 *
 * const prefixedProtobuf = multicodec.addPrefix('protobuf', protobufBuffer)
 * // prefixedProtobuf 0x50...
 *
 */

/** @typedef {import('./generated-types').CodecName} CodecName */
/** @typedef {import('./generated-types').CodecCode} CodecCode */

const varint = varint$2;
const { concat: uint8ArrayConcat$1 } = concat$1;
const util = util$1;
const { nameToVarint, constantToCode, nameToCode, codeToName } = maps;

/**
 * Prefix a buffer with a multicodec-packed.
 *
 * @param {CodecName|Uint8Array} multicodecStrOrCode
 * @param {Uint8Array} data
 * @returns {Uint8Array}
 */
function addPrefix (multicodecStrOrCode, data) {
  let prefix;

  if (multicodecStrOrCode instanceof Uint8Array) {
    prefix = util.varintUint8ArrayEncode(multicodecStrOrCode);
  } else {
    if (nameToVarint[multicodecStrOrCode]) {
      prefix = nameToVarint[multicodecStrOrCode];
    } else {
      throw new Error('multicodec not recognized')
    }
  }

  return uint8ArrayConcat$1([prefix, data], prefix.length + data.length)
}

/**
 * Decapsulate the multicodec-packed prefix from the data.
 *
 * @param {Uint8Array} data
 * @returns {Uint8Array}
 */
function rmPrefix (data) {
  varint.decode(/** @type {Buffer} */(data));
  return data.slice(varint.decode.bytes)
}

/**
 * Get the codec name of the prefixed data.
 *
 * @param {Uint8Array} prefixedData
 * @returns {CodecName}
 */
function getNameFromData (prefixedData) {
  const code = /** @type {CodecCode} */(varint.decode(/** @type {Buffer} */(prefixedData)));
  const name = codeToName[code];
  if (name === undefined) {
    throw new Error(`Code "${code}" not found`)
  }
  return name
}

/**
 * Get the codec name from a code.
 *
 * @param {CodecCode} codec
 * @returns {CodecName}
 */
function getNameFromCode (codec) {
  return codeToName[codec]
}

/**
 * Get the code of the codec
 *
 * @param {CodecName} name
 * @returns {CodecCode}
 */
function getCodeFromName (name) {
  const code = nameToCode[name];
  if (code === undefined) {
    throw new Error(`Codec "${name}" not found`)
  }
  return code
}

/**
 * Get the code of the prefixed data.
 *
 * @param {Uint8Array} prefixedData
 * @returns {CodecCode}
 */
function getCodeFromData (prefixedData) {
  return /** @type {CodecCode} */(varint.decode(/** @type {Buffer} */(prefixedData)))
}

/**
 * Get the code as varint of a codec name.
 *
 * @param {CodecName} name
 * @returns {Uint8Array}
 */
function getVarintFromName (name) {
  const code = nameToVarint[name];
  if (code === undefined) {
    throw new Error(`Codec "${name}" not found`)
  }
  return code
}

/**
 * Get the varint of a code.
 *
 * @param {CodecCode} code
 * @returns {Uint8Array}
 */
function getVarintFromCode (code) {
  return util.varintEncode(code)
}

/**
 * Get the codec name of the prefixed data.
 *
 * @deprecated use getNameFromData instead.
 * @param {Uint8Array} prefixedData
 * @returns {CodecName}
 */
function getCodec (prefixedData) {
  return getNameFromData(prefixedData)
}

/**
 * Get the codec name from a code.
 *
 * @deprecated use getNameFromCode instead.
 * @param {CodecCode} codec
 * @returns {CodecName}
 */
function getName (codec) {
  return getNameFromCode(codec)
}

/**
 * Get the code of the codec
 *
 * @deprecated use getCodeFromName instead.
 * @param {CodecName} name
 * @returns {CodecCode}
 */
function getNumber (name) {
  return getCodeFromName(name)
}

/**
 * Get the code of the prefixed data.
 *
 * @deprecated use getCodeFromData instead.
 * @param {Uint8Array} prefixedData
 * @returns {CodecCode}
 */
function getCode (prefixedData) {
  return getCodeFromData(prefixedData)
}

/**
 * Get the code as varint of a codec name.
 *
 * @deprecated use getVarintFromName instead.
 * @param {CodecName} name
 * @returns {Uint8Array}
 */
function getCodeVarint (name) {
  return getVarintFromName(name)
}

/**
 * Get the varint of a code.
 *
 * @deprecated use getVarintFromCode instead.
 * @param {CodecCode} code
 * @returns {Array.<number>}
 */
function getVarint (code) {
  return Array.from(getVarintFromCode(code))
}

var src$1 = {
  addPrefix,
  rmPrefix,
  getNameFromData,
  getNameFromCode,
  getCodeFromName,
  getCodeFromData,
  getVarintFromName,
  getVarintFromCode,
  // Deprecated
  getCodec,
  getName,
  getNumber,
  getCode,
  getCodeVarint,
  getVarint,
  // Make the constants top-level constants
  ...constantToCode,
  // Export the maps
  nameToVarint,
  nameToCode,
  codeToName
};

const mh$1 = src$2;

const CIDUtil$1 = {
  /**
   * Test if the given input is a valid CID object.
   * Returns an error message if it is not.
   * Returns undefined if it is a valid CID.
   *
   * @param {any} other
   * @returns {string|undefined}
   */
  checkCIDComponents: function (other) {
    if (other == null) {
      return 'null values are not valid CIDs'
    }

    if (!(other.version === 0 || other.version === 1)) {
      return 'Invalid version, must be a number equal to 1 or 0'
    }

    if (typeof other.codec !== 'string') {
      return 'codec must be string'
    }

    if (other.version === 0) {
      if (other.codec !== 'dag-pb') {
        return "codec must be 'dag-pb' for CIDv0"
      }
      if (other.multibaseName !== 'base58btc') {
        return "multibaseName must be 'base58btc' for CIDv0"
      }
    }

    if (!(other.multihash instanceof Uint8Array)) {
      return 'multihash must be a Uint8Array'
    }

    try {
      mh$1.validate(other.multihash);
    } catch (err) {
      let errorMsg = err.message;
      if (!errorMsg) { // Just in case mh.validate() throws an error with empty error message
        errorMsg = 'Multihash validation failed';
      }
      return errorMsg
    }
  }
};

var cidUtil = CIDUtil$1;

var equals$1 = {};

Object.defineProperty(equals$1, '__esModule', { value: true });

function equals(a, b) {
  if (a === b) {
    return true;
  }
  if (a.byteLength !== b.byteLength) {
    return false;
  }
  for (let i = 0; i < a.byteLength; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}

equals$1.equals = equals;

const mh = src$2;
const multibase = src$6.exports;
const multicodec = src$1;
const CIDUtil = cidUtil;
const { concat: uint8ArrayConcat } = concat$1;
const { toString: uint8ArrayToString } = toString$2;
const { equals: uint8ArrayEquals } = equals$1;

const codecs = multicodec.nameToCode;
const codecInts = /** @type {CodecName[]} */(Object.keys(codecs)).reduce((p, name) => {
  p[codecs[name]] = name;
  return p
}, /** @type {Record<CodecCode, CodecName>} */({}));

const symbol = Symbol.for('@ipld/js-cid/CID');

/**
 * @typedef {Object} SerializedCID
 * @property {string} codec
 * @property {number} version
 * @property {Uint8Array} hash
 */
/**
 * @typedef {0|1} CIDVersion
 * @typedef {import('multibase').BaseNameOrCode} BaseNameOrCode
 * @typedef {import('multicodec').CodecName} CodecName
 * @typedef {import('multicodec').CodecCode} CodecCode
 */

/**
 * Class representing a CID `<mbase><version><mcodec><mhash>`
 * , as defined in [ipld/cid](https://github.com/multiformats/cid).
 *
 * @class CID
 */
class CID {
  /**
   * Create a new CID.
   *
   * The algorithm for argument input is roughly:
   * ```
   * if (cid)
   *   -> create a copy
   * else if (str)
   *   if (1st char is on multibase table) -> CID String
   *   else -> bs58 encoded multihash
   * else if (Uint8Array)
   *   if (1st byte is 0 or 1) -> CID
   *   else -> multihash
   * else if (Number)
   *   -> construct CID by parts
   * ```
   *
   * @param {CIDVersion | string | Uint8Array | CID} version
   * @param {string|number} [codec]
   * @param {Uint8Array} [multihash]
   * @param {string} [multibaseName]
   *
   * @example
   * new CID(<version>, <codec>, <multihash>, <multibaseName>)
   * new CID(<cidStr>)
   * new CID(<cid.bytes>)
   * new CID(<multihash>)
   * new CID(<bs58 encoded multihash>)
   * new CID(<cid>)
   */
  constructor (version, codec, multihash, multibaseName) {
    // We have below three blank field accessors only because
    // otherwise TS will not pick them up if done after assignemnts

    /**
     * The version of the CID.
     *
     * @type {CIDVersion}
     */
    // eslint-disable-next-line no-unused-expressions
    this.version;

    /**
     * The codec of the CID.
     *
     * @deprecated
     * @type {CodecName}
     */
    // eslint-disable-next-line no-unused-expressions
    this.codec;

    /**
     * The multihash of the CID.
     *
     * @type {Uint8Array}
     */
    // eslint-disable-next-line no-unused-expressions
    this.multihash;

    Object.defineProperty(this, symbol, { value: true });
    if (CID.isCID(version)) {
      // version is an exising CID instance
      const cid = /** @type {CID} */(version);
      this.version = cid.version;
      this.codec = cid.codec;
      this.multihash = cid.multihash;
      // Default guard for when a CID < 0.7 is passed with no multibaseName
      // @ts-ignore
      this.multibaseName = cid.multibaseName || (cid.version === 0 ? 'base58btc' : 'base32');
      return
    }

    if (typeof version === 'string') {
      // e.g. 'base32' or false
      const baseName = multibase.isEncoded(version);
      if (baseName) {
        // version is a CID String encoded with multibase, so v1
        const cid = multibase.decode(version);
        this.version = /** @type {CIDVersion} */(parseInt(cid[0].toString(), 16));
        this.codec = multicodec.getCodec(cid.slice(1));
        this.multihash = multicodec.rmPrefix(cid.slice(1));
        this.multibaseName = baseName;
      } else {
        // version is a base58btc string multihash, so v0
        this.version = 0;
        this.codec = 'dag-pb';
        this.multihash = mh.fromB58String(version);
        this.multibaseName = 'base58btc';
      }
      CID.validateCID(this);
      Object.defineProperty(this, 'string', { value: version });
      return
    }

    if (version instanceof Uint8Array) {
      const v = parseInt(version[0].toString(), 16);
      if (v === 1) {
        // version is a CID Uint8Array
        const cid = version;
        this.version = v;
        this.codec = multicodec.getCodec(cid.slice(1));
        this.multihash = multicodec.rmPrefix(cid.slice(1));
        this.multibaseName = 'base32';
      } else {
        // version is a raw multihash Uint8Array, so v0
        this.version = 0;
        this.codec = 'dag-pb';
        this.multihash = version;
        this.multibaseName = 'base58btc';
      }
      CID.validateCID(this);
      return
    }

    // otherwise, assemble the CID from the parameters

    this.version = version;

    if (typeof codec === 'number') {
      // @ts-ignore
      codec = codecInts[codec];
    }

    this.codec = /** @type {CodecName} */ (codec);

    this.multihash = /** @type {Uint8Array} */ (multihash);

    /**
     * Multibase name as string.
     *
     * @deprecated
     * @type {string}
     */
    this.multibaseName = multibaseName || (version === 0 ? 'base58btc' : 'base32');

    CID.validateCID(this);
  }

  /**
   * The CID as a `Uint8Array`
   *
   * @returns {Uint8Array}
   *
   */
  get bytes () {
    // @ts-ignore
    let bytes = this._bytes;

    if (!bytes) {
      if (this.version === 0) {
        bytes = this.multihash;
      } else if (this.version === 1) {
        const codec = multicodec.getCodeVarint(this.codec);
        bytes = uint8ArrayConcat([
          [1], codec, this.multihash
        ], 1 + codec.byteLength + this.multihash.byteLength);
      } else {
        throw new Error('unsupported version')
      }

      // Cache this Uint8Array so it doesn't have to be recreated
      Object.defineProperty(this, '_bytes', { value: bytes });
    }

    return bytes
  }

  /**
   * The prefix of the CID.
   *
   * @returns {Uint8Array}
   */
  get prefix () {
    const codec = multicodec.getCodeVarint(this.codec);
    const multihash = mh.prefix(this.multihash);
    const prefix = uint8ArrayConcat([
      [this.version], codec, multihash
    ], 1 + codec.byteLength + multihash.byteLength);

    return prefix
  }

  /**
   * The codec of the CID in its number form.
   *
   * @returns {CodecCode}
   */
  get code () {
    return codecs[this.codec]
  }

  /**
   * Convert to a CID of version `0`.
   *
   * @returns {CID}
   */
  toV0 () {
    if (this.codec !== 'dag-pb') {
      throw new Error('Cannot convert a non dag-pb CID to CIDv0')
    }

    const { name, length } = mh.decode(this.multihash);

    if (name !== 'sha2-256') {
      throw new Error('Cannot convert non sha2-256 multihash CID to CIDv0')
    }

    if (length !== 32) {
      throw new Error('Cannot convert non 32 byte multihash CID to CIDv0')
    }

    return new CID(0, this.codec, this.multihash)
  }

  /**
   * Convert to a CID of version `1`.
   *
   * @returns {CID}
   */
  toV1 () {
    return new CID(1, this.codec, this.multihash, this.multibaseName)
  }

  /**
   * Encode the CID into a string.
   *
   * @param {BaseNameOrCode} [base=this.multibaseName] - Base encoding to use.
   * @returns {string}
   */
  toBaseEncodedString (base = this.multibaseName) {
    // @ts-ignore non enumerable cache property
    if (this.string && this.string.length !== 0 && base === this.multibaseName) {
      // @ts-ignore non enumerable cache property
      return this.string
    }
    let str;
    if (this.version === 0) {
      if (base !== 'base58btc') {
        throw new Error('not supported with CIDv0, to support different bases, please migrate the instance do CIDv1, you can do that through cid.toV1()')
      }
      str = mh.toB58String(this.multihash);
    } else if (this.version === 1) {
      str = uint8ArrayToString(multibase.encode(base, this.bytes));
    } else {
      throw new Error('unsupported version')
    }
    if (base === this.multibaseName) {
      // cache the string value
      Object.defineProperty(this, 'string', { value: str });
    }
    return str
  }

  /**
   * CID(QmdfTbBqBPQ7VNxZEYEj14VmRuZBkqFbiwReogJgS1zR1n)
   *
   * @returns {string}
   */
  [Symbol.for('nodejs.util.inspect.custom')] () {
    return 'CID(' + this.toString() + ')'
  }

  /**
   * Encode the CID into a string.
   *
   * @param {BaseNameOrCode} [base=this.multibaseName] - Base encoding to use.
   * @returns {string}
   */
  toString (base) {
    return this.toBaseEncodedString(base)
  }

  /**
   * Serialize to a plain object.
   *
   * @returns {SerializedCID}
   */
  toJSON () {
    return {
      codec: this.codec,
      version: this.version,
      hash: this.multihash
    }
  }

  /**
   * Compare equality with another CID.
   *
   * @param {CID} other
   * @returns {boolean}
   */
  equals (other) {
    return this.codec === other.codec &&
      this.version === other.version &&
      uint8ArrayEquals(this.multihash, other.multihash)
  }

  /**
   * Test if the given input is a valid CID object.
   * Throws if it is not.
   *
   * @param {any} other - The other CID.
   * @returns {void}
   */
  static validateCID (other) {
    const errorMsg = CIDUtil.checkCIDComponents(other);
    if (errorMsg) {
      throw new Error(errorMsg)
    }
  }

  /**
   * Check if object is a CID instance
   *
   * @param {any} value
   * @returns {value is CID}
   */
  static isCID (value) {
    return value instanceof CID || Boolean(value && value[symbol])
  }
}

CID.codecs = codecs;

var src = CID;

function hexToUint8Array(hex) {
    hex = hex.startsWith('0x') ? hex.substr(2) : hex;
    if (hex.length % 2 !== 0)
        throw new Error('hex must have length that is multiple of 2');
    const arr = new Uint8Array(hex.length / 2);
    for (let i = 0; i < arr.length; i++) {
        arr[i] = parseInt(hex.substr(i * 2, 2), 16);
    }
    return arr;
}
const UTF_8_DECODER = new TextDecoder();
/**
 * Returns the URI representation of the content hash for supported codecs
 * @param contenthash to decode
 */
function contenthashToUri(contenthash) {
    const buff = hexToUint8Array(contenthash);
    const codec = src$1.getCodec(buff); // the typing is wrong for @types/multicodec
    switch (codec) {
        case 'ipfs-ns': {
            const data = src$1.rmPrefix(buff);
            const cid = new src(data);
            return `ipfs://${src$2.toB58String(cid.multihash)}`;
        }
        case 'ipns-ns': {
            const data = src$1.rmPrefix(buff);
            const cid = new src(data);
            const multihash = src$2.decode(cid.multihash);
            if (multihash.name === 'identity') {
                return `ipns://${UTF_8_DECODER.decode(multihash.digest).trim()}`;
            }
            else {
                return `ipns://${src$2.toB58String(cid.multihash)}`;
            }
        }
        default:
            throw new Error(`Unrecognized codec: ${codec}`);
    }
}

const ENS_NAME_REGEX = /^(([a-zA-Z0-9]+\.)+)eth(\/.*)?$/;
function parseENSAddress(ensAddress) {
    const match = ensAddress.match(ENS_NAME_REGEX);
    if (!match)
        return undefined;
    return { ensName: `${match[1].toLowerCase()}eth`, ensPath: match[3] };
}

/**
 * Given a URI that may be ipfs, ipns, http, or https protocol, return the fetch-able http(s) URLs for the same content
 * @param uri to convert to fetch-able http url
 */
function uriToHttp(uri) {
    var _a, _b;
    const protocol = uri.split(':')[0].toLowerCase();
    switch (protocol) {
        case 'https':
            return [uri];
        case 'http':
            return ['https' + uri.substr(4), uri];
        case 'ipfs':
            const hash = (_a = uri.match(/^ipfs:(\/\/)?(.*)$/i)) === null || _a === void 0 ? void 0 : _a[2];
            return [`https://cloudflare-ipfs.com/ipfs/${hash}/`, `https://ipfs.io/ipfs/${hash}/`];
        case 'ipns':
            const name = (_b = uri.match(/^ipns:(\/\/)?(.*)$/i)) === null || _b === void 0 ? void 0 : _b[2];
            return [`https://cloudflare-ipfs.com/ipns/${name}/`, `https://ipfs.io/ipns/${name}/`];
        default:
            return [];
    }
}

const tokenListValidator = new ajv({ allErrors: true }).compile(schema);
/**
 * Contains the logic for resolving a list URL to a validated token list
 * @param listUrl list url
 * @param resolveENSContentHash resolves an ens name to a contenthash
 */
function getTokenList(listUrl, resolveENSContentHash) {
    var _a, _b, _c;
    return __awaiter$a(this, void 0, void 0, function* () {
        const parsedENS = parseENSAddress(listUrl);
        let urls;
        if (parsedENS) {
            let contentHashUri;
            try {
                contentHashUri = yield resolveENSContentHash(parsedENS.ensName);
            }
            catch (error) {
                console.debug(`Failed to resolve ENS name: ${parsedENS.ensName}`, error);
                throw new Error(`Failed to resolve ENS name: ${parsedENS.ensName}`);
            }
            let translatedUri;
            try {
                translatedUri = contenthashToUri(contentHashUri);
            }
            catch (error) {
                console.debug('Failed to translate contenthash to URI', contentHashUri);
                throw new Error(`Failed to translate contenthash to URI: ${contentHashUri}`);
            }
            urls = uriToHttp(`${translatedUri}${(_a = parsedENS.ensPath) !== null && _a !== void 0 ? _a : ''}`);
        }
        else {
            urls = uriToHttp(listUrl);
        }
        for (let i = 0; i < urls.length; i++) {
            const url = urls[i];
            const isLast = i === urls.length - 1;
            let response;
            try {
                response = yield fetch(url);
            }
            catch (error) {
                console.debug('Failed to fetch list', listUrl, error);
                if (isLast)
                    throw new Error(`Failed to download list ${listUrl}`);
                continue;
            }
            if (!response.ok) {
                if (isLast)
                    throw new Error(`Failed to download list ${listUrl}`);
                continue;
            }
            const json = yield response.json();
            if (!tokenListValidator(json)) {
                const validationErrors = (_c = (_b = tokenListValidator.errors) === null || _b === void 0 ? void 0 : _b.reduce((memo, error) => {
                    var _a;
                    const add = `${error.dataPath} ${(_a = error.message) !== null && _a !== void 0 ? _a : ''}`;
                    return memo.length > 0 ? `${memo}; ${add}` : `${add}`;
                }, '')) !== null && _c !== void 0 ? _c : 'unknown error';
                throw new Error(`Token list failed validation: ${validationErrors}`);
            }
            return json;
        }
        throw new Error('Unrecognized list URL protocol.');
    });
}

const fetchTokenList = {
    pending: createAction('plists/fetchTokenList/pending'),
    fulfilled: createAction('plists/fetchTokenList/fulfilled'),
    rejected: createAction('plists/fetchTokenList/rejected'),
};
const acceptListUpdate = createAction('plists/acceptListUpdate');
const addList = createAction('plists/addList');
const removeList = createAction('plists/removeList');
const selectList = createAction('plists/selectList');
createAction('plists/rejectVersionUpdate');

function useFetchListCallback() {
    const dispatch = useDispatch();
    const ensResolver = useCallback(() => {
        throw new Error('Could not construct mainnet ENS resolver');
    }, []);
    return useCallback((listUrl) => __awaiter$a(this, void 0, void 0, function* () {
        const requestId = nanoid();
        dispatch(fetchTokenList.pending({ requestId, url: listUrl }));
        return getTokenList(listUrl, ensResolver)
            .then((tokenList) => {
            dispatch(fetchTokenList.fulfilled({ url: listUrl, tokenList, requestId }));
            return tokenList;
        })
            .catch((error) => {
            console.debug(`Failed to get list at url ${listUrl}`, error);
            dispatch(fetchTokenList.rejected({ url: listUrl, requestId, errorMessage: error.message }));
            throw error;
        });
    }), [dispatch, ensResolver]);
}

function listVersionLabel(version) {
    return `v${version.major}.${version.minor}.${version.patch}`;
}

function TokenListOrigin({ listUrl }) {
    const ensName = useMemo(() => { var _a; return (_a = parseENSAddress(listUrl)) === null || _a === void 0 ? void 0 : _a.ensName; }, [listUrl]);
    const host = useMemo(() => {
        if (ensName)
            return undefined;
        const lowerListUrl = listUrl.toLowerCase();
        if (lowerListUrl.startsWith('ipfs://') || lowerListUrl.startsWith('ipns://')) {
            return listUrl;
        }
        try {
            const url = new URL(listUrl);
            return url.host;
        }
        catch (error) {
            return undefined;
        }
    }, [listUrl, ensName]);
    return jsx(Fragment$1, { children: ensName !== null && ensName !== void 0 ? ensName : host }, void 0);
}

styled(Box) `
  padding: 10px;
`;
const List = styled(Box) `
  padding: 10px;
`;
const AddInputWrapper = styled(Box) `
  display: grid;
  grid-template-columns: auto 100px;
  grid-gap: 10px;
`;
const RowRoot = styled(Box) `
  display: grid;
  grid-template-columns: max-content auto max-content max-content;
  grid-gap: 10px;
  padding: 15px 0px;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);

  &:last-child {
    border-bottom: 0px solid;
  }
`;
const ListLogo$1 = styled.img `
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
`;
const DownArrow = styled.div `
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.text5};
  color: ${({ theme }) => theme.text1};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const PopoverContainer = styled.div `
  z-index: 100;
  background: ${({ theme }) => theme.bg2};
  border: 1px solid ${({ theme }) => theme.bg3};
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
    0px 24px 32px rgba(0, 0, 0, 0.01);
  color: ${({ theme }) => theme.text2};
  border-radius: 0.5rem;
  padding: 5px;
  display: grid;
  grid-template-rows: 1fr;
  grid-gap: 8px;
  font-size: 1rem;
  text-align: left;
  position: absolute;
`;
const Separator = styled.div `
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.bg3};
`;
const ViewLink = styled(Text$1) `
  text-decoration: none;
  cursor: pointer;
  pointer-events: ${({ disabled }) => disabled && 'none'};
`;

const TokenListRow = ({ listUrl }) => {
    const lists = useSelector((state) => state.plists.byUrl);
    const { current: list } = lists[listUrl];
    const dispatch = useDispatch();
    const selectedListUrl = useSelectedListUrl();
    const isSelected = (selectedListUrl || []).includes(listUrl);
    const [open, setOpen] = useState(false);
    const node = useRef();
    const handleClose = useCallback(() => {
        setOpen(false);
    }, [setOpen]);
    useOnClickOutside(node, open ? handleClose : undefined);
    const selectThisList = useCallback(() => {
        // eslint-disable-next-line import/no-named-as-default-member
        ReactGA.event({
            category: 'Lists',
            action: 'Select List',
            label: listUrl,
        });
        dispatch(selectList({ url: listUrl, shouldSelect: !isSelected }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, isSelected, listUrl]);
    const handleRemoveList = useCallback(() => {
        // eslint-disable-next-line import/no-named-as-default-member
        ReactGA.event({
            category: 'Lists',
            action: 'Start Remove List',
            label: listUrl,
        });
        const answer = window.prompt('Please confirm you would like to remove this list by typing "remove"');
        if ((answer === null || answer === void 0 ? void 0 : answer.toLocaleLowerCase()) === 'remove') {
            // eslint-disable-next-line import/no-named-as-default-member
            ReactGA.event({
                category: 'Lists',
                action: 'Confirm Remove List',
                label: listUrl,
            });
            dispatch(removeList(listUrl));
        }
    }, [dispatch, listUrl]);
    if (!list)
        return null;
    return (jsxs(RowRoot, { children: [(list === null || list === void 0 ? void 0 : list.logoURI) ? jsx(ListLogo$1, { size: 24, src: list === null || list === void 0 ? void 0 : list.logoURI }, void 0) : jsx(ListLogo$1, { as: "div", size: 24 }, void 0), jsxs(Box, { children: [jsx(Text$1, Object.assign({ fontSize: 16, color: "text1", style: { overflow: 'hidden', textOverflow: 'ellipsis' } }, { children: list === null || list === void 0 ? void 0 : list.name }), void 0), jsx(Text$1, Object.assign({ fontSize: 12, color: "text3", style: { overflow: 'hidden', textOverflow: 'ellipsis' }, title: listUrl }, { children: jsx(TokenListOrigin, { listUrl: listUrl }, void 0) }), void 0)] }, void 0), jsxs(Box, Object.assign({ ref: node }, { children: [jsx(DownArrow, Object.assign({ onClick: () => setOpen(!open) }, { children: jsx(ChevronDown$1, {}, void 0) }), void 0), open && (jsxs(PopoverContainer, { children: [jsx("div", { children: list && listVersionLabel(list.version) }, void 0), jsx(Separator, {}, void 0), jsx(ViewLink, Object.assign({ fontSize: 13, as: "a", color: "text1", href: `https://tokenlists.org/token-list?url=${listUrl}`, target: "_blank" }, { children: "View list" }), void 0), jsx(ViewLink, Object.assign({ fontSize: 13, color: "text1", onClick: handleRemoveList, disabled: Object.keys(lists).length === 1 }, { children: "Remove list" }), void 0)] }, void 0))] }), void 0), jsx(Switch, { checked: isSelected, onChange: () => selectThisList() }, void 0)] }, void 0));
};

const TokenListDrawer = ({ isOpen, onClose }) => {
    var _a;
    const [listUrlInput, setListUrlInput] = useState('');
    const dispatch = useDispatch();
    const lists = useSelector((state) => state.plists.byUrl);
    const adding = Boolean((_a = lists[listUrlInput]) === null || _a === void 0 ? void 0 : _a.loadingRequestId);
    const [addError, setAddError] = useState(null);
    const fetchList = useFetchListCallback();
    const handleAddList = useCallback(() => {
        if (adding)
            return;
        setAddError(null);
        fetchList(listUrlInput)
            .then(() => {
            setListUrlInput('');
            // eslint-disable-next-line import/no-named-as-default-member
            ReactGA.event({
                category: 'Lists',
                action: 'Add List',
                label: listUrlInput,
            });
        })
            .catch((error) => {
            // eslint-disable-next-line import/no-named-as-default-member
            ReactGA.event({
                category: 'Lists',
                action: 'Add List Failed',
                label: listUrlInput,
            });
            setAddError(error.message);
            dispatch(removeList(listUrlInput));
        });
    }, [adding, dispatch, fetchList, listUrlInput]);
    const validUrl = useMemo(() => {
        return uriToHttp(listUrlInput).length > 0 || Boolean(parseENSAddress(listUrlInput));
    }, [listUrlInput]);
    const handleEnterKey = useCallback((e) => {
        if (validUrl && e.key === 'Enter') {
            handleAddList();
        }
    }, [handleAddList, validUrl]);
    const sortedLists = useMemo(() => {
        const listUrls = Object.keys(lists);
        return listUrls
            .filter((listUrl) => {
            return Boolean(lists[listUrl].current);
        })
            .sort((u1, u2) => {
            const { current: l1 } = lists[u1];
            const { current: l2 } = lists[u2];
            if (l1 && l2) {
                return l1.name.toLowerCase() < l2.name.toLowerCase()
                    ? -1
                    : l1.name.toLowerCase() === l2.name.toLowerCase()
                        ? 0
                        : 1;
            }
            if (l1)
                return -1;
            if (l2)
                return 1;
            return 0;
        });
    }, [lists]);
    return (jsxs(Drawer, Object.assign({ title: "Manage Lists", isOpen: isOpen, onClose: onClose }, { children: [jsxs(Box, Object.assign({ padding: "0px 10px" }, { children: [jsxs(AddInputWrapper, { children: [jsx(TextInput, { placeholder: "https:// or ipfs://", onChange: (value) => {
                                    setListUrlInput(value);
                                    setAddError(null);
                                }, onKeyDown: handleEnterKey, value: listUrlInput }, void 0), jsx(Button, Object.assign({ variant: "primary", padding: '0px', isDisabled: !validUrl, onClick: handleAddList, height: "50px" }, { children: "Add" }), void 0)] }, void 0), addError ? (jsx(Text$1, Object.assign({ title: addError, color: "red2", fontSize: 12 }, { children: addError }), void 0)) : null] }), void 0), jsx(Scrollbars, { children: jsx(List, { children: sortedLists.map((url) => (jsx(TokenListRow, { listUrl: url }, url))) }, void 0) }, void 0)] }), void 0));
};

const CurrencyList = styled.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
`;
const CurrencyRowRoot = styled.div `
  min-height: 56px;
  font-size: 16px;
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  pointer-events: ${({ disabled }) => disabled && 'none'};
  display: grid;
  grid-template-columns: auto minmax(auto, 1fr) minmax(0, 72px);
  grid-gap: 16px;
  align-items: center;
  padding: 10px;

  &:hover {
    background-color: ${({ theme, disabled }) => !disabled && theme.bg3};
  }

  opacity: ${({ disabled, selected }) => (disabled || selected ? 0.5 : 1)};
`;
const Balance = styled(Text$1) `
  justify-self: flex-end;
  white-space: nowrap;
`;
const ManageList = styled.div `
  background-color: ${({ theme }) => theme.bg1};
  padding: 10px;
  cursor: pointer;
`;
const ListLogo = styled.img `
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  margin-right: 10px;
`;

const CurrencyRow = (props) => {
    const { currency, style, onSelect, isSelected, otherSelected } = props;
    const { account } = usePangolinWeb3();
    const chainId = useChainId();
    const balance = useCurrencyBalance(chainId, account !== null && account !== void 0 ? account : undefined, currency);
    const handleSelect = useCallback(() => {
        onSelect(currency);
    }, [onSelect, currency]);
    return (jsxs(CurrencyRowRoot, Object.assign({ style: style, onClick: handleSelect, disabled: isSelected, selected: otherSelected }, { children: [jsx(CurrencyLogo, { currency: currency, size: 24, imageSize: 48 }, void 0), jsx(Text$1, Object.assign({ color: "text1", fontSize: 14, title: currency === null || currency === void 0 ? void 0 : currency.name }, { children: currency === null || currency === void 0 ? void 0 : currency.symbol }), void 0), jsx(Balance, Object.assign({ color: "text1", fontSize: 14 }, { children: balance ? balance.toSignificant(4) : account ? jsx(LoaderIcon, {}, void 0) : null }), void 0)] }), void 0));
};

const currencyKey = (currency, chainId) => {
    return currency instanceof Token$2 ? currency.address : currency === CAVAX[chainId] ? 'AVAX' : '';
};
const SelectTokenDrawer = (props) => {
    var _a, _b, _c;
    const { isOpen, onClose, onCurrencySelect, otherSelectedCurrency, selectedCurrency } = props;
    const [searchQuery, setSearchQuery] = useState('');
    const [isTokenListOpen, setIsTokenListOpen] = useState(false);
    const [invertSearchOrder] = useState(false);
    const inputRef = useRef(null);
    const lastOpen = usePrevious(isOpen);
    useEffect(() => {
        if (isOpen && !lastOpen) {
            setSearchQuery('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    useEffect(() => {
        if (isOpen && inputRef.current) {
            setTimeout(() => {
                var _a;
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 500);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    const allTokens = useAllTokens();
    const selectedListInfo = useSelectedListInfo();
    const chainId = useChainId();
    const isAddressSearch = isAddress(searchQuery);
    const searchToken = useToken(searchQuery);
    const tokenComparator = useTokenComparator(invertSearchOrder);
    const filteredTokens = useMemo(() => {
        if (isAddressSearch)
            return searchToken ? [searchToken] : [];
        const tokens = Object.values(allTokens);
        tokens.unshift(CAVAX[chainId]);
        return filterTokens(tokens, searchQuery);
    }, [isAddressSearch, searchToken, allTokens, searchQuery]);
    const filteredSortedTokens = useMemo(() => {
        if (searchToken)
            return [searchToken];
        const sorted = filteredTokens.sort(tokenComparator);
        const symbolMatch = searchQuery
            .toLowerCase()
            .split(/\s+/)
            .filter((s) => s.length > 0);
        if (symbolMatch.length > 1)
            return sorted;
        return [
            ...(searchToken ? [searchToken] : []),
            // sort any exact symbol matches first
            ...sorted.filter((token) => { var _a; return ((_a = token.symbol) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === symbolMatch[0]; }),
            ...sorted.filter((token) => { var _a; return ((_a = token.symbol) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== symbolMatch[0]; }),
        ];
    }, [filteredTokens, searchQuery, searchToken, tokenComparator]);
    const currencies = useMemo(() => {
        if (searchQuery === '') {
            // remove Currency from array and add in first position
            const _tokens = filteredSortedTokens.filter((token) => token !== CAVAX[chainId]);
            return [CAVAX[chainId], ..._tokens];
        }
        return filteredSortedTokens;
    }, [filteredSortedTokens, chainId]);
    //const currencies = useMemo(() => [Currency.CAVAX, ...filteredSortedTokens], [filteredSortedTokens]);
    const onSelect = useCallback((currency) => {
        onCurrencySelect(currency);
        onClose();
    }, [onCurrencySelect, onClose]);
    const Row = useCallback(({ data, index, style }) => {
        const currency = data === null || data === void 0 ? void 0 : data[index];
        const isSelected = Boolean(selectedCurrency && currencyEquals(selectedCurrency, currency));
        const otherSelected = Boolean(otherSelectedCurrency && currencyEquals(otherSelectedCurrency, currency));
        return currency ? (jsx(CurrencyRow, { style: style, currency: currency, isSelected: isSelected, onSelect: onSelect, otherSelected: otherSelected }, void 0)) : null;
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedCurrency, otherSelectedCurrency, onCurrencySelect, onClose]);
    return (jsxs(Drawer, Object.assign({ title: "Select a token", isOpen: isOpen, onClose: onClose }, { children: [jsx(Box, Object.assign({ padding: "0px 10px" }, { children: jsx(TextInput, { placeholder: "Search", onChange: (value) => {
                        setSearchQuery(value);
                    }, value: searchQuery, getRef: (ref) => (inputRef.current = ref) }, void 0) }), void 0), jsx(CurrencyList, { children: jsx(AutoSizer, Object.assign({ disableWidth: true }, { children: ({ height }) => (jsx(FixedSizeList, Object.assign({ height: height, width: "100%", itemCount: currencies.length, itemSize: 56, itemData: currencies, itemKey: (index, data) => currencyKey(data[index], chainId) }, { children: Row }), void 0)) }), void 0) }, void 0), jsx(ManageList, Object.assign({ onClick: () => setIsTokenListOpen(true) }, { children: selectedListInfo.multipleSelected ? (jsxs(Box, Object.assign({ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }, { children: [jsxs(Text$1, Object.assign({ fontSize: 14, color: "text1" }, { children: [selectedListInfo.selectedCount, " lists selected"] }), void 0), jsx(Text$1, Object.assign({ fontSize: 12, color: "text1" }, { children: "Change" }), void 0)] }), void 0)) : (jsxs(Box, Object.assign({ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }, { children: [jsxs(Box, Object.assign({ display: "flex", alignItems: "center", width: "100%" }, { children: [jsx(ListLogo, { size: 24, src: (_a = selectedListInfo === null || selectedListInfo === void 0 ? void 0 : selectedListInfo.current) === null || _a === void 0 ? void 0 : _a.logoURI, alt: `${(_b = selectedListInfo === null || selectedListInfo === void 0 ? void 0 : selectedListInfo.current) === null || _b === void 0 ? void 0 : _b.name} list logo` }, void 0), jsx(Text$1, Object.assign({ fontSize: 14, color: "text1" }, { children: (_c = selectedListInfo === null || selectedListInfo === void 0 ? void 0 : selectedListInfo.current) === null || _c === void 0 ? void 0 : _c.name }), void 0)] }), void 0), jsx(Text$1, Object.assign({ fontSize: 12, color: "text1" }, { children: "Change" }), void 0)] }), void 0)) }), void 0), jsx(TokenListDrawer, { isOpen: isTokenListOpen, onClose: () => setIsTokenListOpen(false) }, void 0)] }), void 0));
};
var SelectTokenDrawer$1 = memo(SelectTokenDrawer, (prevProps, nextProps) => {
    const isEqual = prevProps.isOpen === nextProps.isOpen &&
        prevProps.onClose === nextProps.onClose &&
        prevProps.onCurrencySelect === nextProps.onCurrencySelect &&
        (!!prevProps.selectedCurrency && !!nextProps.selectedCurrency
            ? prevProps.selectedCurrency.symbol === nextProps.selectedCurrency.symbol
            : true) &&
        (!!prevProps.otherSelectedCurrency && !!nextProps.otherSelectedCurrency
            ? prevProps.otherSelectedCurrency.symbol === nextProps.otherSelectedCurrency.symbol
            : true);
    return isEqual;
});

const initialState$7 = {
    blockNumber: {},
    popupList: [],
    openModal: null,
};
var papplication = createReducer(initialState$7, (builder) => builder
    .addCase(updateBlockNumber, (state, action) => {
    const { chainId, blockNumber } = action.payload;
    if (typeof state.blockNumber[chainId] !== 'number') {
        state.blockNumber[chainId] = blockNumber;
    }
    else {
        state.blockNumber[chainId] = Math.max(blockNumber, state.blockNumber[chainId]);
    }
})
    .addCase(setOpenModal, (state, action) => {
    state.openModal = action.payload;
})
    .addCase(addPopup, (state, { payload: { content, key, removeAfterMs = 15000 } }) => {
    state.popupList = (key ? state.popupList.filter((popup) => popup.key !== key) : state.popupList).concat([
        {
            key: key || nanoid(),
            show: true,
            content,
            removeAfterMs,
        },
    ]);
})
    .addCase(removePopup, (state, { payload: { key } }) => {
    state.popupList.forEach((p) => {
        if (p.key === key) {
            p.show = false;
        }
    });
}));

var VersionUpgrade;

(function (VersionUpgrade) {
  VersionUpgrade[VersionUpgrade["NONE"] = 0] = "NONE";
  VersionUpgrade[VersionUpgrade["PATCH"] = 1] = "PATCH";
  VersionUpgrade[VersionUpgrade["MINOR"] = 2] = "MINOR";
  VersionUpgrade[VersionUpgrade["MAJOR"] = 3] = "MAJOR";
})(VersionUpgrade || (VersionUpgrade = {}));
/**
 * Return the upgrade type from the base version to the update version.
 * Note that downgrades and equivalent versions are both treated as `NONE`.
 * @param base base list
 * @param update update to the list
 */


function getVersionUpgrade(base, update) {
  if (update.major > base.major) {
    return VersionUpgrade.MAJOR;
  }

  if (update.major < base.major) {
    return VersionUpgrade.NONE;
  }

  if (update.minor > base.minor) {
    return VersionUpgrade.MINOR;
  }

  if (update.minor < base.minor) {
    return VersionUpgrade.NONE;
  }

  return update.patch > base.patch ? VersionUpgrade.PATCH : VersionUpgrade.NONE;
}

/**
 * compares two token info key values
 * this subset of full deep equal functionality does not work on objects or object arrays
 * @param a comparison item a
 * @param b comparison item b
 */
function compareTokenInfoProperty(a, b) {
  if (a === b) return true;
  if (typeof a !== typeof b) return false;

  if (Array.isArray(a) && Array.isArray(b)) {
    return a.every(function (el, i) {
      return b[i] === el;
    });
  }

  return false;
}
/**
 * Computes the diff of a token list where the first argument is the base and the second argument is the updated list.
 * @param base base list
 * @param update updated list
 */


function diffTokenLists(base, update) {
  var indexedBase = base.reduce(function (memo, tokenInfo) {
    if (!memo[tokenInfo.chainId]) memo[tokenInfo.chainId] = {};
    memo[tokenInfo.chainId][tokenInfo.address] = tokenInfo;
    return memo;
  }, {});
  var newListUpdates = update.reduce(function (memo, tokenInfo) {
    var _indexedBase$tokenInf;

    var baseToken = (_indexedBase$tokenInf = indexedBase[tokenInfo.chainId]) == null ? void 0 : _indexedBase$tokenInf[tokenInfo.address];

    if (!baseToken) {
      memo.added.push(tokenInfo);
    } else {
      var changes = Object.keys(tokenInfo).filter(function (s) {
        return s !== 'address' && s !== 'chainId';
      }).filter(function (s) {
        return !compareTokenInfoProperty(tokenInfo[s], baseToken[s]);
      });

      if (changes.length > 0) {
        if (!memo.changed[tokenInfo.chainId]) {
          memo.changed[tokenInfo.chainId] = {};
        }

        memo.changed[tokenInfo.chainId][tokenInfo.address] = changes;
      }
    }

    if (!memo.index[tokenInfo.chainId]) {
      var _memo$index$tokenInfo;

      memo.index[tokenInfo.chainId] = (_memo$index$tokenInfo = {}, _memo$index$tokenInfo[tokenInfo.address] = true, _memo$index$tokenInfo);
    } else {
      memo.index[tokenInfo.chainId][tokenInfo.address] = true;
    }

    return memo;
  }, {
    added: [],
    changed: {},
    index: {}
  });
  var removed = base.reduce(function (list, curr) {
    if (!newListUpdates.index[curr.chainId] || !newListUpdates.index[curr.chainId][curr.address]) {
      list.push(curr);
    }

    return list;
  }, []);
  return {
    added: newListUpdates.added,
    changed: newListUpdates.changed,
    removed: removed
  };
}

/**
 * Returns the minimum version bump for the given list
 * @param baseList the base list of tokens
 * @param updatedList the updated list of tokens
 */

function minVersionBump(baseList, updatedList) {
  var diff = diffTokenLists(baseList, updatedList);
  if (diff.removed.length > 0) return VersionUpgrade.MAJOR;
  if (diff.added.length > 0) return VersionUpgrade.MINOR;
  if (Object.keys(diff.changed).length > 0) return VersionUpgrade.PATCH;
  return VersionUpgrade.NONE;
}

// fired once when the app reloads but before the app renders
// allows any updates to be applied to store data loaded from localStorage
const updateVersion = createAction('pglobal/updateVersion');

const NEW_LIST_STATE = {
    error: null,
    current: null,
    loadingRequestId: null,
    pendingUpdate: null,
};
const initialState$6 = {
    lastInitializedDefaultListOfLists: DEFAULT_TOKEN_LISTS,
    byUrl: Object.assign({}, DEFAULT_TOKEN_LISTS.reduce((memo, listUrl) => {
        memo[listUrl] = NEW_LIST_STATE;
        return memo;
    }, {})),
    selectedListUrl: DEFAULT_TOKEN_LISTS_SELECTED,
};
var plists = createReducer(initialState$6, (builder) => builder
    .addCase(fetchTokenList.pending, (state, { payload: { requestId, url } }) => {
    state.byUrl[url] = Object.assign(Object.assign({ 
        // eslint-disable-next-line  @typescript-eslint/ban-ts-comment
        // @ts-ignore
        current: null, 
        // eslint-disable-next-line  @typescript-eslint/ban-ts-comment
        // @ts-ignore
        pendingUpdate: null }, state.byUrl[url]), { loadingRequestId: requestId, error: null });
})
    .addCase(fetchTokenList.fulfilled, (state, { payload: { requestId, tokenList, url } }) => {
    var _a, _b;
    const current = (_a = state.byUrl[url]) === null || _a === void 0 ? void 0 : _a.current;
    const loadingRequestId = (_b = state.byUrl[url]) === null || _b === void 0 ? void 0 : _b.loadingRequestId;
    // no-op if update does nothing
    if (current) {
        const upgradeType = getVersionUpgrade(current.version, tokenList.version);
        if (upgradeType === VersionUpgrade.NONE)
            return;
        if (loadingRequestId === null || loadingRequestId === requestId) {
            state.byUrl[url] = Object.assign(Object.assign({}, state.byUrl[url]), { loadingRequestId: null, error: null, current: current, pendingUpdate: tokenList });
        }
    }
    else {
        state.byUrl[url] = Object.assign(Object.assign({}, state.byUrl[url]), { loadingRequestId: null, error: null, current: tokenList, pendingUpdate: null });
    }
})
    .addCase(fetchTokenList.rejected, (state, { payload: { url, requestId, errorMessage } }) => {
    var _a;
    if (((_a = state.byUrl[url]) === null || _a === void 0 ? void 0 : _a.loadingRequestId) !== requestId) {
        // no-op since it's not the latest request
        return;
    }
    state.byUrl[url] = Object.assign(Object.assign({}, state.byUrl[url]), { loadingRequestId: null, error: errorMessage, current: null, pendingUpdate: null });
})
    .addCase(selectList, (state, { payload: { url, shouldSelect } }) => {
    const existingSelectedListUrl = [].concat(state.selectedListUrl || []);
    if (shouldSelect) {
        // if user want to select the list, then just push it into selected array
        existingSelectedListUrl.push(url);
        state.selectedListUrl = existingSelectedListUrl;
    }
    else {
        const index = existingSelectedListUrl.indexOf(url);
        if (index !== -1) {
            if ((existingSelectedListUrl === null || existingSelectedListUrl === void 0 ? void 0 : existingSelectedListUrl.length) === 1) {
                // if user want to deselect the list and if there is only one item in the list
                state.selectedListUrl = DEFAULT_TOKEN_LISTS_SELECTED;
            }
            else {
                existingSelectedListUrl.splice(index, 1);
                state.selectedListUrl = existingSelectedListUrl;
            }
        }
    }
    // automatically adds list
    if (!state.byUrl[url]) {
        state.byUrl[url] = NEW_LIST_STATE;
    }
})
    .addCase(addList, (state, { payload: url }) => {
    if (!state.byUrl[url]) {
        state.byUrl[url] = NEW_LIST_STATE;
    }
})
    .addCase(removeList, (state, { payload: url }) => {
    if (state.byUrl[url]) {
        delete state.byUrl[url];
    }
    const existingList = [].concat(state.selectedListUrl || []);
    const index = existingList.indexOf(url);
    if (index !== -1) {
        if ((existingList === null || existingList === void 0 ? void 0 : existingList.length) === 1) {
            // if user want to remove the list and if there is only one item in the selected list
            state.selectedListUrl = DEFAULT_TOKEN_LISTS_SELECTED;
        }
        else {
            existingList.splice(index, 1);
            state.selectedListUrl = existingList;
        }
    }
})
    .addCase(acceptListUpdate, (state, { payload: url }) => {
    var _a;
    if (!((_a = state.byUrl[url]) === null || _a === void 0 ? void 0 : _a.pendingUpdate)) {
        throw new Error('accept list update called without pending update');
    }
    state.byUrl[url] = Object.assign(Object.assign({}, state.byUrl[url]), { pendingUpdate: null, current: state.byUrl[url].pendingUpdate });
})
    .addCase(updateVersion, (state) => {
    // state loaded from localStorage, but new lists have never been initialized
    if (!state.lastInitializedDefaultListOfLists) {
        state.byUrl = initialState$6.byUrl;
        state.selectedListUrl = DEFAULT_TOKEN_LISTS_SELECTED;
    }
    else if (state.lastInitializedDefaultListOfLists) {
        const lastInitializedSet = state.lastInitializedDefaultListOfLists.reduce((s, l) => s.add(l), new Set());
        const newListOfListsSet = DEFAULT_TOKEN_LISTS.reduce((s, l) => s.add(l), new Set());
        // Detected addition of default token lists
        DEFAULT_TOKEN_LISTS.forEach((listUrl) => {
            if (!lastInitializedSet.has(listUrl)) {
                state.byUrl[listUrl] = NEW_LIST_STATE;
                if (DEFAULT_TOKEN_LISTS_SELECTED.includes(listUrl)) {
                    if (!state.selectedListUrl || !state.selectedListUrl.includes(listUrl)) {
                        state.selectedListUrl = (state.selectedListUrl || []).concat([listUrl]);
                    }
                }
            }
        });
        // Detected removal of default token lists
        state.lastInitializedDefaultListOfLists.forEach((listUrl) => {
            if (!newListOfListsSet.has(listUrl)) {
                delete state.byUrl[listUrl];
                if (!!state.selectedListUrl && state.selectedListUrl.includes(listUrl)) {
                    state.selectedListUrl = state.selectedListUrl.filter((url) => url !== listUrl);
                    if (state.selectedListUrl.length === 0) {
                        state.selectedListUrl = DEFAULT_TOKEN_LISTS_SELECTED;
                    }
                }
            }
        });
    }
    state.lastInitializedDefaultListOfLists = DEFAULT_TOKEN_LISTS;
    if (!state.selectedListUrl) {
        state.selectedListUrl = DEFAULT_TOKEN_LISTS_SELECTED;
        DEFAULT_TOKEN_LISTS.forEach((listUrl) => {
            if (!state.byUrl[listUrl]) {
                state.byUrl[listUrl] = NEW_LIST_STATE;
            }
        });
    }
}));

const initialState$5 = {
    callResults: {},
};
var pmulticall = createReducer(initialState$5, (builder) => builder
    .addCase(addMulticallListeners, (state, { payload: { calls, chainId, options: { blocksPerFetch = 1 } = {} } }) => {
    var _a;
    const listeners = state.callListeners
        ? state.callListeners
        : (state.callListeners = {});
    listeners[chainId] = (_a = listeners[chainId]) !== null && _a !== void 0 ? _a : {};
    calls.forEach((call) => {
        var _a, _b;
        const callKey = toCallKey(call);
        listeners[chainId][callKey] = (_a = listeners[chainId][callKey]) !== null && _a !== void 0 ? _a : {};
        listeners[chainId][callKey][blocksPerFetch] = ((_b = listeners[chainId][callKey][blocksPerFetch]) !== null && _b !== void 0 ? _b : 0) + 1;
    });
})
    .addCase(removeMulticallListeners, (state, { payload: { chainId, calls, options: { blocksPerFetch = 1 } = {} } }) => {
    const listeners = state.callListeners
        ? state.callListeners
        : (state.callListeners = {});
    if (!listeners[chainId])
        return;
    calls.forEach((call) => {
        const callKey = toCallKey(call);
        if (!listeners[chainId][callKey])
            return;
        if (!listeners[chainId][callKey][blocksPerFetch])
            return;
        if (listeners[chainId][callKey][blocksPerFetch] === 1) {
            delete listeners[chainId][callKey][blocksPerFetch];
        }
        else {
            listeners[chainId][callKey][blocksPerFetch]--;
        }
    });
})
    .addCase(fetchingMulticallResults, (state, { payload: { chainId, fetchingBlockNumber, calls } }) => {
    var _a;
    state.callResults[chainId] = (_a = state.callResults[chainId]) !== null && _a !== void 0 ? _a : {};
    calls.forEach((call) => {
        var _a;
        const callKey = toCallKey(call);
        const current = state.callResults[chainId][callKey];
        if (!current) {
            state.callResults[chainId][callKey] = {
                fetchingBlockNumber,
            };
        }
        else {
            if (((_a = current.fetchingBlockNumber) !== null && _a !== void 0 ? _a : 0) >= fetchingBlockNumber)
                return;
            state.callResults[chainId][callKey].fetchingBlockNumber = fetchingBlockNumber;
        }
    });
})
    .addCase(errorFetchingMulticallResults, (state, { payload: { fetchingBlockNumber, chainId, calls } }) => {
    var _a;
    state.callResults[chainId] = (_a = state.callResults[chainId]) !== null && _a !== void 0 ? _a : {};
    calls.forEach((call) => {
        const callKey = toCallKey(call);
        const current = state.callResults[chainId][callKey];
        if (!current)
            return; // only should be dispatched if we are already fetching
        if (current.fetchingBlockNumber === fetchingBlockNumber) {
            delete current.fetchingBlockNumber;
            current.data = null;
            current.blockNumber = fetchingBlockNumber;
        }
    });
})
    .addCase(updateMulticallResults, (state, { payload: { chainId, results, blockNumber } }) => {
    var _a;
    state.callResults[chainId] = (_a = state.callResults[chainId]) !== null && _a !== void 0 ? _a : {};
    Object.keys(results).forEach((callKey) => {
        var _a;
        const current = state.callResults[chainId][callKey];
        if (((_a = current === null || current === void 0 ? void 0 : current.blockNumber) !== null && _a !== void 0 ? _a : 0) > blockNumber)
            return;
        state.callResults[chainId][callKey] = {
            data: results[callKey],
            blockNumber,
        };
    });
}));

const initialState$4 = {
    independentField: Field.INPUT,
    typedValue: '',
    [Field.INPUT]: {
        currencyId: '',
    },
    [Field.OUTPUT]: {
        currencyId: '',
    },
    recipient: null,
};
var pswap = createReducer(initialState$4, (builder) => builder
    .addCase(replaceSwapState, (state, { payload: { typedValue, recipient, field, inputCurrencyId, outputCurrencyId } }) => {
    return {
        [Field.INPUT]: {
            currencyId: inputCurrencyId,
        },
        [Field.OUTPUT]: {
            currencyId: outputCurrencyId,
        },
        independentField: field,
        typedValue: typedValue,
        recipient,
    };
})
    .addCase(selectCurrency, (state, { payload: { currencyId, field } }) => {
    const otherField = field === Field.INPUT ? Field.OUTPUT : Field.INPUT;
    if (currencyId === state[otherField].currencyId) {
        // the case where we have to swap the order
        return Object.assign(Object.assign({}, state), { independentField: state.independentField === Field.INPUT ? Field.OUTPUT : Field.INPUT, [field]: { currencyId: currencyId }, [otherField]: { currencyId: state[field].currencyId } });
    }
    else {
        // the normal case
        return Object.assign(Object.assign({}, state), { [field]: { currencyId: currencyId } });
    }
})
    .addCase(switchCurrencies, (state) => {
    return Object.assign(Object.assign({}, state), { independentField: state.independentField === Field.INPUT ? Field.OUTPUT : Field.INPUT, [Field.INPUT]: { currencyId: state[Field.OUTPUT].currencyId }, [Field.OUTPUT]: { currencyId: state[Field.INPUT].currencyId } });
})
    .addCase(typeInput, (state, { payload: { field, typedValue } }) => {
    return Object.assign(Object.assign({}, state), { independentField: field, typedValue });
})
    .addCase(setRecipient, (state, { payload: { recipient } }) => {
    state.recipient = recipient;
}));

const initialState$3 = {
    weekly: {},
    tokenPrices: {},
};
var ptoken = createReducer(initialState$3, (builder) => builder
    .addCase(updateTokenWeeklyPriceChartData, (state, { payload: { address, chartData } }) => {
    const container = {};
    container[address] = chartData;
    const existingChartData = Object.assign(Object.assign({}, (state.weekly || {})), container);
    state.weekly = existingChartData;
})
    .addCase(updateTokenPriceChartData, (state, { payload: { address, chartData } }) => {
    const container = {};
    container[address] = chartData;
    const existingChartData = Object.assign(Object.assign({}, (state.tokenPrices || {})), container);
    state.tokenPrices = existingChartData;
}));

const now = () => new Date().getTime();
const initialState$2 = {};
var ptransactions = createReducer(initialState$2, (builder) => builder
    .addCase(addTransaction, (transactions, { payload: { chainId, from, hash, approval, summary, claim } }) => {
    var _a, _b;
    if ((_a = transactions[chainId]) === null || _a === void 0 ? void 0 : _a[hash]) {
        throw Error('Attempted to add existing transaction.');
    }
    const txs = (_b = transactions[chainId]) !== null && _b !== void 0 ? _b : {};
    txs[hash] = { hash, approval, summary, claim, from, addedTime: now() };
    transactions[chainId] = txs;
})
    .addCase(clearAllTransactions, (transactions, { payload: { chainId } }) => {
    if (!transactions[chainId])
        return;
    transactions[chainId] = {};
})
    .addCase(checkedTransaction, (transactions, { payload: { chainId, hash, blockNumber } }) => {
    var _a;
    const tx = (_a = transactions[chainId]) === null || _a === void 0 ? void 0 : _a[hash];
    if (!tx) {
        return;
    }
    if (!tx.lastCheckedBlockNumber) {
        tx.lastCheckedBlockNumber = blockNumber;
    }
    else {
        tx.lastCheckedBlockNumber = Math.max(blockNumber, tx.lastCheckedBlockNumber);
    }
})
    .addCase(finalizeTransaction, (transactions, { payload: { hash, chainId, receipt } }) => {
    var _a;
    const tx = (_a = transactions[chainId]) === null || _a === void 0 ? void 0 : _a[hash];
    if (!tx) {
        return;
    }
    tx.receipt = receipt;
    tx.confirmedTime = now();
}));

const currentTimestamp = () => new Date().getTime();
const initialState$1 = {
    userSlippageTolerance: INITIAL_ALLOWED_SLIPPAGE,
    tokens: {},
    timestamp: currentTimestamp(),
    userExpertMode: false,
    userDeadline: DEFAULT_DEADLINE_FROM_NOW,
};
var puser = createReducer(initialState$1, (builder) => builder
    .addCase(updateUserSlippageTolerance, (state, action) => {
    state.userSlippageTolerance = action.payload.userSlippageTolerance;
    state.timestamp = currentTimestamp();
})
    .addCase(updateUserExpertMode, (state, action) => {
    state.userExpertMode = action.payload.userExpertMode;
    state.timestamp = currentTimestamp();
})
    .addCase(updateUserDeadline, (state, action) => {
    state.userDeadline = action.payload.userDeadline;
    state.timestamp = currentTimestamp();
})
    .addCase(addSerializedToken, (state, { payload: { serializedToken } }) => {
    state.tokens[serializedToken.chainId] = state.tokens[serializedToken.chainId] || {};
    state.tokens[serializedToken.chainId][serializedToken.address] = serializedToken;
    state.timestamp = currentTimestamp();
})
    .addCase(removeSerializedToken, (state, { payload: { address, chainId } }) => {
    state.tokens[chainId] = state.tokens[chainId] || {};
    delete state.tokens[chainId][address];
    state.timestamp = currentTimestamp();
}));

const initialState = {
    currencies: [],
};
var pwatchlists = createReducer(initialState, (builder) => builder
    .addCase(addCurrency, (state, { payload: address }) => {
    const existingSelectedListUrl = [].concat(state.currencies || []);
    existingSelectedListUrl.push(address);
    state.currencies = existingSelectedListUrl;
})
    .addCase(removeCurrency, (state, { payload: address }) => {
    const existingList = [].concat(state.currencies || []);
    const index = existingList.indexOf(address);
    if (index !== -1) {
        if ((existingList === null || existingList === void 0 ? void 0 : existingList.length) === 1) {
            // if user want to remove the list and if there is only one item in the selected list
            state.currencies = [];
        }
        else {
            existingList.splice(index, 1);
            state.currencies = existingList;
        }
    }
}));

const PANGOLIN_PERSISTED_KEYS = [
    'puser',
    'plists',
    'ptransactions',
    'pwatchlists',
    'ptoken',
    ...GELATO_PERSISTED_KEYS,
];
const pangolinReducers = Object.assign({ papplication,
    ptransactions,
    pswap,
    plists,
    pmulticall,
    puser,
    pwatchlists,
    ptoken }, gelatoReducers);
configureStore({
    reducer: pangolinReducers,
    middleware: [...getDefaultMiddleware({ thunk: false }), save({ states: PANGOLIN_PERSISTED_KEYS })],
    preloadedState: load({ states: PANGOLIN_PERSISTED_KEYS }),
});

// modified from https://usehooks.com/useDebounce/
function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        // Update debounced value after delay
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
}

const VISIBILITY_STATE_SUPPORTED = 'visibilityState' in document;
function isWindowVisible() {
    return !VISIBILITY_STATE_SUPPORTED || document.visibilityState !== 'hidden';
}
/**
 * Returns whether the window is currently visible to the user.
 */
function useIsWindowVisible() {
    const [focused, setFocused] = useState(isWindowVisible());
    const listener = useCallback(() => {
        setFocused(isWindowVisible());
    }, [setFocused]);
    useEffect(() => {
        if (!VISIBILITY_STATE_SUPPORTED)
            return undefined;
        document.addEventListener('visibilitychange', listener);
        return () => {
            document.removeEventListener('visibilitychange', listener);
        };
    }, [listener]);
    return focused;
}

function Updater$3() {
    const { library, chainId } = usePangolinWeb3();
    const dispatch = useDispatch();
    const windowVisible = useIsWindowVisible();
    const [state, setState] = useState({
        chainId,
        blockNumber: null,
    });
    const blockNumberCallback = useCallback((blockNumber) => {
        setState((state) => {
            if (chainId === state.chainId) {
                if (typeof state.blockNumber !== 'number')
                    return { chainId, blockNumber };
                return { chainId, blockNumber: Math.max(blockNumber, state.blockNumber) };
            }
            return state;
        });
    }, [chainId, setState]);
    // attach/detach listeners
    useEffect(() => {
        if (!library || !chainId || !windowVisible)
            return undefined;
        setState({ chainId, blockNumber: null });
        library
            .getBlockNumber()
            .then(blockNumberCallback)
            .catch((error) => console.error(`Failed to get block number for chainId: ${chainId}`, error));
        library.on('block', blockNumberCallback);
        return () => {
            library.removeListener('block', blockNumberCallback);
        };
    }, [dispatch, chainId, library, blockNumberCallback, windowVisible]);
    const debouncedState = useDebounce(state, 100);
    useEffect(() => {
        if (!debouncedState.chainId || !debouncedState.blockNumber || !windowVisible)
            return;
        dispatch(updateBlockNumber({ chainId: debouncedState.chainId, blockNumber: debouncedState.blockNumber }));
    }, [windowVisible, dispatch, debouncedState.blockNumber, debouncedState.chainId]);
    return null;
}

function useInterval(callback, delay, leading = true) {
    const savedCallback = useRef();
    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    useEffect(() => {
        function tick() {
            const current = savedCallback.current;
            current && current();
        }
        if (delay !== null) {
            if (leading)
                tick();
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
        return undefined;
    }, [delay, leading]);
}

function Updater$2() {
    const { library } = usePangolinWeb3();
    const dispatch = useDispatch();
    const lists = useSelector((state) => state.plists.byUrl);
    const isWindowVisible = useIsWindowVisible();
    const fetchList = useFetchListCallback();
    const fetchAllListsCallback = useCallback(() => {
        if (!isWindowVisible)
            return;
        Object.keys(lists).forEach((url) => fetchList(url).catch((error) => console.debug('interval list fetching error', error)));
    }, [fetchList, isWindowVisible, lists]);
    // fetch all lists every 10 minutes, but only after we initialize library
    useInterval(fetchAllListsCallback, library ? 1000 * 60 * 10 : null);
    // whenever a list is not loaded and not loading, try again to load it
    useEffect(() => {
        Object.keys(lists).forEach((listUrl) => {
            const list = lists[listUrl];
            if (!list.current && !list.loadingRequestId && !list.error) {
                fetchList(listUrl).catch((error) => console.debug('list added fetching error', error));
            }
        });
    }, [dispatch, fetchList, library, lists]);
    // automatically update lists if versions are minor/patch
    useEffect(() => {
        Object.keys(lists).forEach((listUrl) => {
            const list = lists[listUrl];
            if (list.current && list.pendingUpdate) {
                const bump = getVersionUpgrade(list.current.version, list.pendingUpdate.version);
                const isDefaultList = DEFAULT_TOKEN_LISTS.includes(listUrl);
                switch (bump) {
                    case VersionUpgrade.NONE:
                        throw new Error('unexpected no version bump');
                    case VersionUpgrade.PATCH:
                    case VersionUpgrade.MINOR:
                        const min = minVersionBump(list.current.tokens, list.pendingUpdate.tokens);
                        // automatically update minor/patch as long as bump matches the min update
                        if (bump >= min) {
                            if (isDefaultList) {
                                //if its pangolin hosted token list then we will autoupdate it
                                // eslint-disable-next-line import/no-named-as-default-member
                                ReactGA.event({
                                    category: 'Lists',
                                    action: 'Update List from Popup',
                                    label: listUrl,
                                });
                                dispatch(acceptListUpdate(listUrl));
                            }
                        }
                        else {
                            console.error(`List at url ${listUrl} could not automatically update because the version bump was only PATCH/MINOR while the update had breaking changes and should have been MAJOR`);
                        }
                        break;
                    case VersionUpgrade.MAJOR:
                        if (isDefaultList) {
                            // if its pangolin hosted token list then we will autoupdate it
                            // eslint-disable-next-line import/no-named-as-default-member
                            ReactGA.event({
                                category: 'Lists',
                                action: 'Update List from Popup',
                                label: listUrl,
                            });
                            dispatch(acceptListUpdate(listUrl));
                        }
                }
            }
        });
    }, [dispatch, lists]);
    return null;
}

// chunks array into chunks of maximum size
// evenly distributes items among the chunks
function chunkArray(items, maxChunkSize) {
    if (maxChunkSize < 1)
        throw new Error('maxChunkSize must be gte 1');
    if (items.length <= maxChunkSize)
        return [items];
    const numChunks = Math.ceil(items.length / maxChunkSize);
    const chunkSize = Math.ceil(items.length / numChunks);
    return [...Array(numChunks).keys()].map((ix) => items.slice(ix * chunkSize, ix * chunkSize + chunkSize));
}

function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
function waitRandom(min, max) {
    return wait(min + Math.round(Math.random() * Math.max(0, max - min)));
}
/**
 * This error is thrown if the function is cancelled before completing
 */
class CancelledError extends Error {
    constructor() {
        super('Cancelled');
    }
}
/**
 * Throw this error if the function should retry
 */
class RetryableError extends Error {
}
/**
 * Retries the function that returns the promise until the promise successfully resolves up to n retries
 * @param fn function to retry
 * @param n how many times to retry
 * @param minWait min wait between retries in ms
 * @param maxWait max wait between retries in ms
 */
function retry(fn, { n, minWait, maxWait }) {
    let completed = false;
    let rejectCancelled;
    const promise = new Promise((resolve, reject) => __awaiter$a(this, void 0, void 0, function* () {
        rejectCancelled = reject;
        while (true) {
            let result;
            try {
                result = yield fn();
                if (!completed) {
                    resolve(result);
                    completed = true;
                }
                break;
            }
            catch (error) {
                if (completed) {
                    break;
                }
                if (n <= 0 || !(error instanceof RetryableError)) {
                    reject(error);
                    completed = true;
                    break;
                }
                n--;
            }
            yield waitRandom(minWait, maxWait);
        }
    }));
    return {
        promise,
        cancel: () => {
            if (completed)
                return;
            completed = true;
            rejectCancelled(new CancelledError());
        },
    };
}

// chunk calls so we do not exceed the gas limit
const CALL_CHUNK_SIZE = 500;
/**
 * Fetches a chunk of calls, enforcing a minimum block number constraint
 * @param multicallContract multicall contract to fetch against
 * @param chunk chunk of calls to make
 * @param minBlockNumber minimum block number of the result set
 */
function fetchChunk(multicallContract, chunk, minBlockNumber) {
    return __awaiter$a(this, void 0, void 0, function* () {
        console.debug('Fetching chunk', multicallContract, chunk, minBlockNumber);
        let resultsBlockNumber, returnData;
        try {
            [resultsBlockNumber, returnData] = yield multicallContract.aggregate(chunk.map((obj) => [obj.address, obj.callData]));
        }
        catch (error) {
            console.debug('Failed to fetch chunk inside retry', error);
            throw error;
        }
        if (resultsBlockNumber.toNumber() < minBlockNumber) {
            throw new RetryableError('Fetched for old block number');
        }
        return { results: returnData, blockNumber: resultsBlockNumber.toNumber() };
    });
}
/**
 * From the current all listeners state, return each call key mapped to the
 * minimum number of blocks per fetch. This is how often each key must be fetched.
 * @param allListeners the all listeners state
 * @param chainId the current chain id
 */
function activeListeningKeys(allListeners, chainId) {
    if (!allListeners || !chainId)
        return {};
    const listeners = allListeners[chainId];
    if (!listeners)
        return {};
    return Object.keys(listeners).reduce((memo, callKey) => {
        const keyListeners = listeners[callKey];
        memo[callKey] = Object.keys(keyListeners)
            .filter((key) => {
            const blocksPerFetch = parseInt(key);
            if (blocksPerFetch <= 0)
                return false;
            return keyListeners[blocksPerFetch] > 0;
        })
            .reduce((previousMin, current) => {
            return Math.min(previousMin, parseInt(current));
        }, Infinity);
        return memo;
    }, {});
}
/**
 * Return the keys that need to be refetched
 * @param callResults current call result state
 * @param listeningKeys each call key mapped to how old the data can be in blocks
 * @param chainId the current chain id
 * @param latestBlockNumber the latest block number
 */
function outdatedListeningKeys(callResults, listeningKeys, chainId, latestBlockNumber) {
    if (!chainId || !latestBlockNumber)
        return [];
    const results = callResults[chainId];
    // no results at all, load everything
    if (!results)
        return Object.keys(listeningKeys);
    return Object.keys(listeningKeys).filter((callKey) => {
        const blocksPerFetch = listeningKeys[callKey];
        const data = callResults[chainId][callKey];
        // no data, must fetch
        if (!data)
            return true;
        const minDataBlockNumber = latestBlockNumber - (blocksPerFetch - 1);
        // already fetching it for a recent enough block, don't refetch it
        if (data.fetchingBlockNumber && data.fetchingBlockNumber >= minDataBlockNumber)
            return false;
        // if data is older than minDataBlockNumber, fetch it
        return !data.blockNumber || data.blockNumber < minDataBlockNumber;
    });
}
function Updater$1() {
    const dispatch = useDispatch();
    const state = useSelector((state) => state.pmulticall);
    // wait for listeners to settle before triggering updates
    const debouncedListeners = useDebounce(state.callListeners, 100);
    const latestBlockNumber = useBlockNumber();
    const { chainId } = usePangolinWeb3();
    const multicallContract = useMulticallContract();
    const cancellations = useRef();
    const listeningKeys = useMemo(() => {
        return activeListeningKeys(debouncedListeners, chainId);
    }, [debouncedListeners, chainId]);
    const unserializedOutdatedCallKeys = useMemo(() => {
        return outdatedListeningKeys(state.callResults, listeningKeys, chainId, latestBlockNumber);
    }, [chainId, state.callResults, listeningKeys, latestBlockNumber]);
    const serializedOutdatedCallKeys = useMemo(() => JSON.stringify(unserializedOutdatedCallKeys.sort()), [unserializedOutdatedCallKeys]);
    useEffect(() => {
        var _a, _b, _c;
        if (!latestBlockNumber || !chainId || !multicallContract)
            return;
        const outdatedCallKeys = JSON.parse(serializedOutdatedCallKeys);
        if (outdatedCallKeys.length === 0)
            return;
        const calls = outdatedCallKeys.map((key) => parseCallKey(key));
        const chunkedCalls = chunkArray(calls, CALL_CHUNK_SIZE);
        if (((_a = cancellations.current) === null || _a === void 0 ? void 0 : _a.blockNumber) !== latestBlockNumber) {
            (_c = (_b = cancellations.current) === null || _b === void 0 ? void 0 : _b.cancellations) === null || _c === void 0 ? void 0 : _c.forEach((c) => c());
        }
        dispatch(fetchingMulticallResults({
            calls,
            chainId,
            fetchingBlockNumber: latestBlockNumber,
        }));
        cancellations.current = {
            blockNumber: latestBlockNumber,
            cancellations: chunkedCalls.map((chunk, index) => {
                const { cancel, promise } = retry(() => fetchChunk(multicallContract, chunk, latestBlockNumber), {
                    n: Infinity,
                    minWait: 2500,
                    maxWait: 3500,
                });
                promise
                    .then(({ results: returnData, blockNumber: fetchBlockNumber }) => {
                    cancellations.current = { cancellations: [], blockNumber: latestBlockNumber };
                    // accumulates the length of all previous indices
                    const firstCallKeyIndex = chunkedCalls
                        .slice(0, index)
                        .reduce((memo, curr) => memo + curr.length, 0);
                    const lastCallKeyIndex = firstCallKeyIndex + returnData.length;
                    dispatch(updateMulticallResults({
                        chainId,
                        results: outdatedCallKeys
                            .slice(firstCallKeyIndex, lastCallKeyIndex)
                            .reduce((memo, callKey, i) => {
                            var _a;
                            memo[callKey] = (_a = returnData[i]) !== null && _a !== void 0 ? _a : null;
                            return memo;
                        }, {}),
                        blockNumber: fetchBlockNumber,
                    }));
                })
                    .catch((error) => {
                    if (error instanceof CancelledError) {
                        console.debug('Cancelled fetch for blockNumber', latestBlockNumber);
                        return;
                    }
                    console.error('Failed to fetch multicall chunk', chunk, chainId, error);
                    dispatch(errorFetchingMulticallResults({
                        calls: chunk,
                        chainId,
                        fetchingBlockNumber: latestBlockNumber,
                    }));
                });
                return cancel;
            }),
        };
    }, [chainId, multicallContract, dispatch, serializedOutdatedCallKeys, latestBlockNumber]);
    return null;
}

function shouldCheck(lastBlockNumber, tx) {
    if (tx.receipt)
        return false;
    if (!tx.lastCheckedBlockNumber)
        return true;
    const blocksSinceCheck = lastBlockNumber - tx.lastCheckedBlockNumber;
    if (blocksSinceCheck < 1)
        return false;
    const minutesPending = (new Date().getTime() - tx.addedTime) / 1000 / 60;
    if (minutesPending > 60) {
        // every 10 blocks if pending for longer than an hour
        return blocksSinceCheck > 9;
    }
    else if (minutesPending > 5) {
        // every 3 blocks if pending more than 5 minutes
        return blocksSinceCheck > 2;
    }
    else {
        // otherwise every block
        return true;
    }
}
function Updater() {
    var _a;
    const { chainId, library } = usePangolinWeb3();
    const lastBlockNumber = useBlockNumber();
    const dispatch = useDispatch();
    const state = useSelector((state) => state.ptransactions);
    const transactions = chainId ? (_a = state[chainId]) !== null && _a !== void 0 ? _a : {} : {}; // eslint-disable-line react-hooks/exhaustive-deps
    // show popup on confirm
    const addPopup = useAddPopup();
    useEffect(() => {
        if (!chainId || !library || !lastBlockNumber)
            return;
        Object.keys(transactions)
            .filter((hash) => shouldCheck(lastBlockNumber, transactions[hash]))
            .forEach((hash) => {
            library
                .getTransactionReceipt(hash)
                .then((receipt) => {
                var _a;
                if (receipt) {
                    dispatch(finalizeTransaction({
                        chainId,
                        hash,
                        receipt: {
                            blockHash: receipt.blockHash,
                            blockNumber: receipt.blockNumber,
                            contractAddress: receipt.contractAddress,
                            from: receipt.from,
                            status: receipt.status,
                            to: receipt.to,
                            transactionHash: receipt.transactionHash,
                            transactionIndex: receipt.transactionIndex,
                        },
                    }));
                    addPopup({
                        txn: {
                            hash,
                            success: receipt.status === 1,
                            summary: (_a = transactions[hash]) === null || _a === void 0 ? void 0 : _a.summary,
                        },
                    }, hash);
                }
                else {
                    dispatch(checkedTransaction({ chainId, hash, blockNumber: lastBlockNumber }));
                }
            })
                .catch((error) => {
                console.error(`failed to check transaction hash: ${hash}`, error);
            });
        });
    }, [chainId, library, transactions, lastBlockNumber, dispatch, addPopup]);
    return null;
}

const queryClient = new QueryClient();
function PangolinProvider({ chainId, library, children, account, theme, }) {
    return (jsxs(PangolinWeb3Provider, Object.assign({ chainId: chainId, library: library, account: account }, { children: [jsx(Updater$2, {}, void 0), jsx(Updater$3, {}, void 0), jsx(Updater$1, {}, void 0), jsx(Updater, {}, void 0), jsx(ThemeProvider, Object.assign({ theme: theme }, { children: jsx(QueryClientProvider, Object.assign({ client: queryClient }, { children: jsx(GelatoProvider, Object.assign({ library: library, chainId: chainId, account: account !== null && account !== void 0 ? account : undefined, useDefaultTheme: false, handler: 'pangolin' }, { children: children }), void 0) }), void 0) }), void 0)] }), void 0));
}

export { ALLOWED_PRICE_IMPACT_HIGH, ALLOWED_PRICE_IMPACT_LOW, ALLOWED_PRICE_IMPACT_MEDIUM, ANALYTICS_PAGE, AVALANCHE_CHAIN_PARAMS, BASES_TO_CHECK_TRADES_AGAINST, BIPS_BASE, BLOCKED_PRICE_IMPACT_NON_EXPERT, Box, Button, COINGEKO_BASE_URL, CUSTOM_BASES, Checkbox, CheckboxGroup, CurrencyInput, CurrencyLogo, DAIe, DEFAULT_DEADLINE_FROM_NOW, DIRECTUS_URL_NEWS, DoubleCurrencyLogo, Drawer, EVM_SUPPORTED_WALLETS, INITIAL_ALLOWED_SLIPPAGE, IS_IN_IFRAME, LANDING_PAGE, Loader, Logo$1 as Logo, MIN_ETH, Modal, NATIVE, NETWORK_CHAIN_ID, NetworkContextName, NetworkSelection, NewsWidget, NumberOptions, ONE_BIPS, OPEN_API_DEBANK, PANGOLIN_PERSISTED_KEYS, PANGOLIN_TOKENS_REPO_RAW_BASE_URL, PNG$1 as PNG, PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN, PangolinProvider, Portfolio as Portifolio, ROUTER_ADDRESS, RadioButton, RadioButtonGroup, SUBGRAPH_BASE_URL, SWAP_DEFAULT_CURRENCY, SelectTokenDrawer$1 as SelectTokenDrawer, ShowMore, Step$1 as Step, Steps, SwapWidget, Switch, TIMEFRAME, TRUSTED_TOKEN_ADDRESSES, Text$1 as Text, TextInput, ToggleButtons, USDC, USDCe, USDT, USDTe, UST, WalletModal, WatchList, ZERO_ADDRESS, axlUST, getNetworkLibrary, gnosisSafe, injected, network, pangolinReducers, useAllTokens, useDerivedSwapInfo, useGelatoLimitOrderDetail, useGelatoLimitOrderList, usePair, useSwapActionHandlers, useUSDCPrice, walletconnect, walletlink, wrappedCurrency, xDefi };
//# sourceMappingURL=index.js.map
